
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref25d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref25d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("5UUfm", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $44edd02a6be448cd$export$5f828d93ff035aa8, (v) => $44edd02a6be448cd$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $44edd02a6be448cd$export$cd94982b18c6332c, (v) => $44edd02a6be448cd$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $44edd02a6be448cd$export$1d518568e4f529b0, (v) => $44edd02a6be448cd$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $44edd02a6be448cd$export$5285b6d41c912b41, (v) => $44edd02a6be448cd$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $44edd02a6be448cd$export$2fb37efbf6ae0c0e, (v) => $44edd02a6be448cd$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $44edd02a6be448cd$export$ab85ecd77ce6a5cd, (v) => $44edd02a6be448cd$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $44edd02a6be448cd$export$da39cf97e1eb7c91, (v) => $44edd02a6be448cd$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $44edd02a6be448cd$export$52a9039d7177394f, (v) => $44edd02a6be448cd$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $44edd02a6be448cd$export$f7201db400317331, (v) => $44edd02a6be448cd$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $44edd02a6be448cd$export$448fa22aedc9dbca, (v) => $44edd02a6be448cd$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $44edd02a6be448cd$export$b80c7ba289c8fa56, (v) => $44edd02a6be448cd$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $44edd02a6be448cd$export$26e5786e8ac8e530, (v) => $44edd02a6be448cd$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $44edd02a6be448cd$export$bdd223f16383713e, (v) => $44edd02a6be448cd$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $44edd02a6be448cd$export$20533d26f07f1ee0, (v) => $44edd02a6be448cd$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $44edd02a6be448cd$export$2f64596b8cbf08b4, (v) => $44edd02a6be448cd$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $44edd02a6be448cd$export$2ce6d8d0e8b04e1a, (v) => $44edd02a6be448cd$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $44edd02a6be448cd$export$12ada9414fbc594c, (v) => $44edd02a6be448cd$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $44edd02a6be448cd$export$f5e7e39d57cd9700, (v) => $44edd02a6be448cd$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $44edd02a6be448cd$export$36b6d6ef312eab39, (v) => $44edd02a6be448cd$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $44edd02a6be448cd$export$58a258485f1e49f6, (v) => $44edd02a6be448cd$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $44edd02a6be448cd$export$dedd8dc3dc62b370, (v) => $44edd02a6be448cd$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $44edd02a6be448cd$export$971862a2fcb1bb40, (v) => $44edd02a6be448cd$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $44edd02a6be448cd$export$c6ff6a88acbeaf40, (v) => $44edd02a6be448cd$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $44edd02a6be448cd$export$fdc27893e98845cc, (v) => $44edd02a6be448cd$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $44edd02a6be448cd$export$6671fb9a1323bed, (v) => $44edd02a6be448cd$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $44edd02a6be448cd$export$d74daf141a551db, (v) => $44edd02a6be448cd$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $44edd02a6be448cd$export$45df7cae684751af, (v) => $44edd02a6be448cd$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $44edd02a6be448cd$export$1db683ad541682f6, (v) => $44edd02a6be448cd$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $44edd02a6be448cd$export$6f65485f87568e37, (v) => $44edd02a6be448cd$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $44edd02a6be448cd$export$91a8e56769aeb334, (v) => $44edd02a6be448cd$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $44edd02a6be448cd$export$2d4117e99c2179e4, (v) => $44edd02a6be448cd$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $44edd02a6be448cd$export$512823e338ddb1b7, (v) => $44edd02a6be448cd$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $44edd02a6be448cd$export$9d0e0c0c4a8d30f3, (v) => $44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $44edd02a6be448cd$export$b9d55ff329113abd, (v) => $44edd02a6be448cd$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $44edd02a6be448cd$export$7efb24e2fddf99b9, (v) => $44edd02a6be448cd$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $44edd02a6be448cd$export$bb1abf2ce84fc7e8, (v) => $44edd02a6be448cd$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $44edd02a6be448cd$export$2f7171e78e524d5e, (v) => $44edd02a6be448cd$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $44edd02a6be448cd$export$e1d879b482f37d98, (v) => $44edd02a6be448cd$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $44edd02a6be448cd$export$1a988e7317c65621, (v) => $44edd02a6be448cd$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
'use strict';

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));

var $eFSIF = parcelRequire("eFSIF");
var $44edd02a6be448cd$var$algoKeys = Object.keys($eFSIF);
var $44edd02a6be448cd$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;

var $eyeBm = parcelRequire("eyeBm");
$44edd02a6be448cd$export$26e5786e8ac8e530 = $eyeBm.Cipher;
$44edd02a6be448cd$export$bdd223f16383713e = $eyeBm.createCipher;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $eyeBm.Cipheriv;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $eyeBm.createCipheriv;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $eyeBm.Decipher;
$44edd02a6be448cd$export$12ada9414fbc594c = $eyeBm.createDecipher;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $eyeBm.Decipheriv;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $eyeBm.createDecipheriv;
$44edd02a6be448cd$export$58a258485f1e49f6 = $eyeBm.getCiphers;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $eyeBm.listCiphers;

var $5NszM = parcelRequire("5NszM");
$44edd02a6be448cd$export$971862a2fcb1bb40 = $5NszM.DiffieHellmanGroup;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $5NszM.createDiffieHellmanGroup;
$44edd02a6be448cd$export$fdc27893e98845cc = $5NszM.getDiffieHellman;
$44edd02a6be448cd$export$6671fb9a1323bed = $5NszM.createDiffieHellman;
$44edd02a6be448cd$export$d74daf141a551db = $5NszM.DiffieHellman;

var $4zMFU = parcelRequire("4zMFU");
$44edd02a6be448cd$export$45df7cae684751af = $4zMFU.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $4zMFU.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $4zMFU.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $4zMFU.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));

var $fMM6j = parcelRequire("fMM6j");
$44edd02a6be448cd$export$512823e338ddb1b7 = $fMM6j.publicEncrypt;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $fMM6j.privateEncrypt;
$44edd02a6be448cd$export$b9d55ff329113abd = $fMM6j.publicDecrypt;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $fMM6j.privateDecrypt;

var $c34vB = parcelRequire("c34vB");
$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $c34vB.randomFill;
$44edd02a6be448cd$export$2f7171e78e524d5e = $c34vB.randomFillSync;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRegister("1R2J7", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, 'digest');
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $loYLU();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("loYLU", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("eLdEM", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $abf00c68ae11d39d$require$Transform = $ioRHp.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $abf00c68ae11d39d$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $abf00c68ae11d39d$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($abf00c68ae11d39d$require$Buffer.prototype instanceof Uint8Array || $abf00c68ae11d39d$require$Buffer.TYPED_ARRAY_SUPPORT);
function $abf00c68ae11d39d$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $abf00c68ae11d39d$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($abf00c68ae11d39d$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $abf00c68ae11d39d$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $abf00c68ae11d39d$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($abf00c68ae11d39d$var$useUint8Array && data instanceof Uint8Array) return $abf00c68ae11d39d$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($abf00c68ae11d39d$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $abf00c68ae11d39d$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $abf00c68ae11d39d$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("aBufs"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("6XbcT"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("fFuzr"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("k3Gr9"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("6G2fH"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("hzqCm"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("coyuH"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("aBufs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $7b84d2ca8f0d8afd$var$Readable;
/*<replacement>*/ var $7b84d2ca8f0d8afd$var$Duplex;
/*</replacement>*/ $7b84d2ca8f0d8afd$var$Readable.ReadableState = $7b84d2ca8f0d8afd$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $7b84d2ca8f0d8afd$require$EE = $7etJZ.EventEmitter;
var $7b84d2ca8f0d8afd$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $7b84d2ca8f0d8afd$require$Buffer = $6ZWSX.Buffer;
var $7b84d2ca8f0d8afd$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk) {
    return $7b84d2ca8f0d8afd$require$Buffer.from(chunk);
}
function $7b84d2ca8f0d8afd$var$_isUint8Array(obj) {
    return $7b84d2ca8f0d8afd$require$Buffer.isBuffer(obj) || obj instanceof $7b84d2ca8f0d8afd$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $7b84d2ca8f0d8afd$var$debug;
if ($kjyEk && $kjyEk.debuglog) $7b84d2ca8f0d8afd$var$debug = $kjyEk.debuglog('stream');
else $7b84d2ca8f0d8afd$var$debug = function debug() {};

var $6aKSQ = parcelRequire("6aKSQ");

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $7b84d2ca8f0d8afd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $7b84d2ca8f0d8afd$require$_require$codes = $967Aq.codes;
var $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE = $7b84d2ca8f0d8afd$require$_require$codes.ERR_INVALID_ARG_TYPE, $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED = $7b84d2ca8f0d8afd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $7b84d2ca8f0d8afd$var$StringDecoder;
var $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator;
var $7b84d2ca8f0d8afd$var$from;

(parcelRequire("dlqwk"))($7b84d2ca8f0d8afd$var$Readable, $jJj7p);
var $7b84d2ca8f0d8afd$var$errorOrDestroy = $fnDgj.errorOrDestroy;
var $7b84d2ca8f0d8afd$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $7b84d2ca8f0d8afd$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $7b84d2ca8f0d8afd$var$ReadableState(options, stream, isDuplex) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $7b84d2ca8f0d8afd$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $7b84d2ca8f0d8afd$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6aKSQ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $7b84d2ca8f0d8afd$var$Readable(options) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    if (!(this instanceof $7b84d2ca8f0d8afd$var$Readable)) return new $7b84d2ca8f0d8afd$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $7b84d2ca8f0d8afd$var$Duplex;
    this._readableState = new $7b84d2ca8f0d8afd$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jJj7p.call(this);
}
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$7b84d2ca8f0d8afd$var$Readable.prototype.destroy = $fnDgj.destroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._undestroy = $fnDgj.undestroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$7b84d2ca8f0d8afd$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $7b84d2ca8f0d8afd$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$7b84d2ca8f0d8afd$var$Readable.prototype.unshift = function(chunk) {
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, null, true, false);
};
function $7b84d2ca8f0d8afd$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $7b84d2ca8f0d8afd$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $7b84d2ca8f0d8afd$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk);
        if (er) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $7b84d2ca8f0d8afd$require$Buffer.prototype) chunk = $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
                    else $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
                } else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $7b84d2ca8f0d8afd$var$emitReadable(stream);
    }
    $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
}
function $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk) {
    var er;
    if (!$7b84d2ca8f0d8afd$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$7b84d2ca8f0d8afd$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$7b84d2ca8f0d8afd$var$Readable.prototype.setEncoding = function(enc) {
    if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $7b84d2ca8f0d8afd$var$MAX_HWM = 0x40000000;
function $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n) {
    if (n >= $7b84d2ca8f0d8afd$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $7b84d2ca8f0d8afd$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$7b84d2ca8f0d8afd$var$Readable.prototype.read = function(n) {
    $7b84d2ca8f0d8afd$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $7b84d2ca8f0d8afd$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
        else $7b84d2ca8f0d8afd$var$emitReadable(this);
        return null;
    }
    n = $7b84d2ca8f0d8afd$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $7b84d2ca8f0d8afd$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $7b84d2ca8f0d8afd$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $7b84d2ca8f0d8afd$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $7b84d2ca8f0d8afd$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $7b84d2ca8f0d8afd$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $7b84d2ca8f0d8afd$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $7b84d2ca8f0d8afd$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $7b84d2ca8f0d8afd$var$onEofChunk(stream, state) {
    $7b84d2ca8f0d8afd$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $7b84d2ca8f0d8afd$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $7b84d2ca8f0d8afd$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $7b84d2ca8f0d8afd$var$emitReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $7b84d2ca8f0d8afd$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$emitReadable_, stream);
    }
}
function $7b84d2ca8f0d8afd$var$emitReadable_(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $7b84d2ca8f0d8afd$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$maybeReadMore_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $7b84d2ca8f0d8afd$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$7b84d2ca8f0d8afd$var$Readable.prototype._read = function(n) {
    $7b84d2ca8f0d8afd$var$errorOrDestroy(this, new $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$7b84d2ca8f0d8afd$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $7b84d2ca8f0d8afd$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $7b84d2ca8f0d8afd$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $7b84d2ca8f0d8afd$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $7b84d2ca8f0d8afd$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $7b84d2ca8f0d8afd$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $7b84d2ca8f0d8afd$var$debug('ondata');
        var ret = dest.write(chunk);
        $7b84d2ca8f0d8afd$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $7b84d2ca8f0d8afd$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $7b84d2ca8f0d8afd$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($7b84d2ca8f0d8afd$var$EElistenerCount(dest, 'error') === 0) $7b84d2ca8f0d8afd$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $7b84d2ca8f0d8afd$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $7b84d2ca8f0d8afd$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $7b84d2ca8f0d8afd$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $7b84d2ca8f0d8afd$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $7b84d2ca8f0d8afd$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $7b84d2ca8f0d8afd$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $7b84d2ca8f0d8afd$var$flow(src);
        }
    };
}
$7b84d2ca8f0d8afd$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$7b84d2ca8f0d8afd$var$Readable.prototype.on = function(ev, fn) {
    var res = $jJj7p.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $7b84d2ca8f0d8afd$var$debug('on readable', state.length, state.reading);
            if (state.length) $7b84d2ca8f0d8afd$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($7b84d2ca8f0d8afd$var$nReadingNextTick, this);
        }
    }
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.addListener = $7b84d2ca8f0d8afd$var$Readable.prototype.on;
$7b84d2ca8f0d8afd$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jJj7p.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jJj7p.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
function $7b84d2ca8f0d8afd$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $7b84d2ca8f0d8afd$var$nReadingNextTick(self1) {
    $7b84d2ca8f0d8afd$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$7b84d2ca8f0d8afd$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $7b84d2ca8f0d8afd$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $7b84d2ca8f0d8afd$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$resume_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$resume_(stream, state) {
    $7b84d2ca8f0d8afd$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $7b84d2ca8f0d8afd$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$7b84d2ca8f0d8afd$var$Readable.prototype.pause = function() {
    $7b84d2ca8f0d8afd$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $7b84d2ca8f0d8afd$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $7b84d2ca8f0d8afd$var$flow(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$7b84d2ca8f0d8afd$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $7b84d2ca8f0d8afd$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $7b84d2ca8f0d8afd$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $7b84d2ca8f0d8afd$var$kProxyEvents.length; n++)stream.on($7b84d2ca8f0d8afd$var$kProxyEvents[n], this.emit.bind(this, $7b84d2ca8f0d8afd$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $7b84d2ca8f0d8afd$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $7b84d2ca8f0d8afd$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator === undefined) $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator = (parcelRequire("3etzH"));
    return $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$7b84d2ca8f0d8afd$var$Readable._fromList = $7b84d2ca8f0d8afd$var$fromList;
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $7b84d2ca8f0d8afd$var$endReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$endReadableNT, state, stream);
    }
}
function $7b84d2ca8f0d8afd$var$endReadableNT(state, stream) {
    $7b84d2ca8f0d8afd$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $7b84d2ca8f0d8afd$var$Readable.from = function(iterable, opts) {
    if ($7b84d2ca8f0d8afd$var$from === undefined) $7b84d2ca8f0d8afd$var$from = (parcelRequire("gN4Jr"));
    return $7b84d2ca8f0d8afd$var$from($7b84d2ca8f0d8afd$var$Readable, iterable, opts);
};
function $7b84d2ca8f0d8afd$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jJj7p", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("6aKSQ", function(module, exports) {
'use strict';
function $47e80b5d1f4ca857$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $47e80b5d1f4ca857$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $47e80b5d1f4ca857$var$ownKeys(Object(source), !0).forEach(function(key) {
            $47e80b5d1f4ca857$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $47e80b5d1f4ca857$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $47e80b5d1f4ca857$var$_defineProperty(obj, key, value) {
    key = $47e80b5d1f4ca857$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47e80b5d1f4ca857$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $47e80b5d1f4ca857$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $47e80b5d1f4ca857$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $47e80b5d1f4ca857$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $47e80b5d1f4ca857$var$_toPropertyKey(arg) {
    var key = $47e80b5d1f4ca857$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $47e80b5d1f4ca857$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $47e80b5d1f4ca857$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $47e80b5d1f4ca857$var$inspect = $kjyEk.inspect;
var $47e80b5d1f4ca857$var$custom = $47e80b5d1f4ca857$var$inspect && $47e80b5d1f4ca857$var$inspect.custom || 'inspect';
function $47e80b5d1f4ca857$var$copyBuffer(src, target, offset) {
    $47e80b5d1f4ca857$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $47e80b5d1f4ca857$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $47e80b5d1f4ca857$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $47e80b5d1f4ca857$var$Buffer.alloc(0);
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $47e80b5d1f4ca857$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $47e80b5d1f4ca857$var$custom,
            value: function value(_, options) {
                return $47e80b5d1f4ca857$var$inspect(this, $47e80b5d1f4ca857$var$_objectSpread($47e80b5d1f4ca857$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fnDgj", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $b32775a19d7a76d1$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
    });
    return this;
}
function $b32775a19d7a76d1$var$emitErrorAndCloseNT(self, err) {
    $b32775a19d7a76d1$var$emitErrorNT(self, err);
    $b32775a19d7a76d1$var$emitCloseNT(self);
}
function $b32775a19d7a76d1$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $b32775a19d7a76d1$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b32775a19d7a76d1$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $b32775a19d7a76d1$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $b32775a19d7a76d1$var$destroy,
    undestroy: $b32775a19d7a76d1$var$undestroy,
    errorOrDestroy: $b32775a19d7a76d1$var$errorOrDestroy
};

});

parcelRegister("5yyyA", function(module, exports) {
'use strict';

var $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("967Aq")).codes.ERR_INVALID_OPT_VALUE;
function $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $40baeeffbb52bbd0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $40baeeffbb52bbd0$var$getHighWaterMark
};

});
parcelRegister("967Aq", function(module, exports) {

$parcel$export(module.exports, "codes", () => $69fa8f23fe6fc7e7$export$e45cb6485273080e, (v) => $69fa8f23fe6fc7e7$export$e45cb6485273080e = v);
var $69fa8f23fe6fc7e7$export$e45cb6485273080e;
'use strict';
function $69fa8f23fe6fc7e7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $69fa8f23fe6fc7e7$var$codes = {};
function $69fa8f23fe6fc7e7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $69fa8f23fe6fc7e7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $69fa8f23fe6fc7e7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $69fa8f23fe6fc7e7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $69fa8f23fe6fc7e7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $69fa8f23fe6fc7e7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $69fa8f23fe6fc7e7$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$69fa8f23fe6fc7e7$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $69fa8f23fe6fc7e7$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($69fa8f23fe6fc7e7$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, 'type'));
    else {
        var type = $69fa8f23fe6fc7e7$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$69fa8f23fe6fc7e7$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$69fa8f23fe6fc7e7$export$e45cb6485273080e = $69fa8f23fe6fc7e7$var$codes;

});


parcelRegister("fFuzr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
/*<replacement>*/ var $b682660ac74fe757$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $b682660ac74fe757$var$Duplex;

var $aBufs = parcelRequire("aBufs");

var $6XbcT = parcelRequire("6XbcT");

(parcelRequire("dlqwk"))($b682660ac74fe757$var$Duplex, $aBufs);
// Allow the keys array to be GC'ed.
var $b682660ac74fe757$var$keys = $b682660ac74fe757$var$objectKeys($6XbcT.prototype);
for(var $b682660ac74fe757$var$v = 0; $b682660ac74fe757$var$v < $b682660ac74fe757$var$keys.length; $b682660ac74fe757$var$v++){
    var $b682660ac74fe757$var$method = $b682660ac74fe757$var$keys[$b682660ac74fe757$var$v];
    if (!$b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method]) $b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method] = $6XbcT.prototype[$b682660ac74fe757$var$method];
}
function $b682660ac74fe757$var$Duplex(options) {
    if (!(this instanceof $b682660ac74fe757$var$Duplex)) return new $b682660ac74fe757$var$Duplex(options);
    $aBufs.call(this, options);
    $6XbcT.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $b682660ac74fe757$var$onend);
        }
    }
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $b682660ac74fe757$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($b682660ac74fe757$var$onEndNT, this);
}
function $b682660ac74fe757$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("6XbcT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $5100f23d2ab8fadd$var$Writable;
/* <replacement> */ function $5100f23d2ab8fadd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5100f23d2ab8fadd$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5100f23d2ab8fadd$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5100f23d2ab8fadd$var$Duplex;
/*</replacement>*/ $5100f23d2ab8fadd$var$Writable.WritableState = $5100f23d2ab8fadd$var$WritableState;

/*<replacement>*/ var $5100f23d2ab8fadd$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $5100f23d2ab8fadd$require$Buffer = $6ZWSX.Buffer;
var $5100f23d2ab8fadd$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk) {
    return $5100f23d2ab8fadd$require$Buffer.from(chunk);
}
function $5100f23d2ab8fadd$var$_isUint8Array(obj) {
    return $5100f23d2ab8fadd$require$Buffer.isBuffer(obj) || obj instanceof $5100f23d2ab8fadd$var$OurUint8Array;
}

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $5100f23d2ab8fadd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $5100f23d2ab8fadd$require$_require$codes = $967Aq.codes;
var $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE = $5100f23d2ab8fadd$require$_require$codes.ERR_INVALID_ARG_TYPE, $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED = $5100f23d2ab8fadd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK = $5100f23d2ab8fadd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_DESTROYED, $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_NULL_VALUES, $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING = $5100f23d2ab8fadd$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5100f23d2ab8fadd$var$errorOrDestroy = $fnDgj.errorOrDestroy;

(parcelRequire("dlqwk"))($5100f23d2ab8fadd$var$Writable, $jJj7p);
function $5100f23d2ab8fadd$var$nop() {}

function $5100f23d2ab8fadd$var$WritableState(options, stream, isDuplex) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $5100f23d2ab8fadd$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5100f23d2ab8fadd$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5100f23d2ab8fadd$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(this);
}
$5100f23d2ab8fadd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5100f23d2ab8fadd$var$WritableState.prototype, 'buffer', {
            get: $5100f23d2ab8fadd$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5100f23d2ab8fadd$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $5100f23d2ab8fadd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5100f23d2ab8fadd$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5100f23d2ab8fadd$var$realHasInstance.call(this, object)) return true;
            if (this !== $5100f23d2ab8fadd$var$Writable) return false;
            return object && object._writableState instanceof $5100f23d2ab8fadd$var$WritableState;
        }
    });
} else $5100f23d2ab8fadd$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5100f23d2ab8fadd$var$Writable(options) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5100f23d2ab8fadd$var$Duplex;
    if (!isDuplex && !$5100f23d2ab8fadd$var$realHasInstance.call($5100f23d2ab8fadd$var$Writable, this)) return new $5100f23d2ab8fadd$var$Writable(options);
    this._writableState = new $5100f23d2ab8fadd$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jJj7p.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5100f23d2ab8fadd$var$Writable.prototype.pipe = function() {
    $5100f23d2ab8fadd$var$errorOrDestroy(this, new $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE());
};
function $5100f23d2ab8fadd$var$writeAfterEnd(stream, cb) {
    var er = new $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5100f23d2ab8fadd$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$5100f23d2ab8fadd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5100f23d2ab8fadd$var$_isUint8Array(chunk);
    if (isBuf && !$5100f23d2ab8fadd$require$Buffer.isBuffer(chunk)) chunk = $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $5100f23d2ab8fadd$var$nop;
    if (state.ending) $5100f23d2ab8fadd$var$writeAfterEnd(this, cb);
    else if (isBuf || $5100f23d2ab8fadd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5100f23d2ab8fadd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5100f23d2ab8fadd$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5100f23d2ab8fadd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(this, state);
    }
};
$5100f23d2ab8fadd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $5100f23d2ab8fadd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5100f23d2ab8fadd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5100f23d2ab8fadd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($5100f23d2ab8fadd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    }
}
function $5100f23d2ab8fadd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5100f23d2ab8fadd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK();
    $5100f23d2ab8fadd$var$onwriteStateUpdate(state);
    if (er) $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5100f23d2ab8fadd$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($5100f23d2ab8fadd$var$afterWrite, stream, state, finished, cb);
        else $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb);
    }
}
function $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5100f23d2ab8fadd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5100f23d2ab8fadd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $5100f23d2ab8fadd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5100f23d2ab8fadd$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5100f23d2ab8fadd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$5100f23d2ab8fadd$var$Writable.prototype._writev = null;
$5100f23d2ab8fadd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5100f23d2ab8fadd$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5100f23d2ab8fadd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5100f23d2ab8fadd$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5100f23d2ab8fadd$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    });
}
function $5100f23d2ab8fadd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($5100f23d2ab8fadd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $5100f23d2ab8fadd$var$finishMaybe(stream, state) {
    var need = $5100f23d2ab8fadd$var$needFinish(state);
    if (need) {
        $5100f23d2ab8fadd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5100f23d2ab8fadd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5100f23d2ab8fadd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5100f23d2ab8fadd$var$Writable.prototype.destroy = $fnDgj.destroy;
$5100f23d2ab8fadd$var$Writable.prototype._undestroy = $fnDgj.undestroy;
$5100f23d2ab8fadd$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config('throwDeprecation')) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("3etzH", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
var $25a99ede456543b7$var$_Object$setPrototypeO;
function $25a99ede456543b7$var$_defineProperty(obj, key, value) {
    key = $25a99ede456543b7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25a99ede456543b7$var$_toPropertyKey(arg) {
    var key = $25a99ede456543b7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $25a99ede456543b7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $hzqCm = parcelRequire("hzqCm");
var $25a99ede456543b7$var$kLastResolve = Symbol('lastResolve');
var $25a99ede456543b7$var$kLastReject = Symbol('lastReject');
var $25a99ede456543b7$var$kError = Symbol('error');
var $25a99ede456543b7$var$kEnded = Symbol('ended');
var $25a99ede456543b7$var$kLastPromise = Symbol('lastPromise');
var $25a99ede456543b7$var$kHandlePromise = Symbol('handlePromise');
var $25a99ede456543b7$var$kStream = Symbol('stream');
function $25a99ede456543b7$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $25a99ede456543b7$var$readAndResolve(iter) {
    var resolve = iter[$25a99ede456543b7$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$25a99ede456543b7$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$25a99ede456543b7$var$kLastPromise] = null;
            iter[$25a99ede456543b7$var$kLastResolve] = null;
            iter[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(data, false));
        }
    }
}
function $25a99ede456543b7$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($25a99ede456543b7$var$readAndResolve, iter);
}
function $25a99ede456543b7$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$25a99ede456543b7$var$kEnded]) {
                resolve($25a99ede456543b7$var$createIterResult(undefined, true));
                return;
            }
            iter[$25a99ede456543b7$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $25a99ede456543b7$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($25a99ede456543b7$var$_Object$setPrototypeO = {
    get stream () {
        return this[$25a99ede456543b7$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$25a99ede456543b7$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$25a99ede456543b7$var$kEnded]) return Promise.resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        if (this[$25a99ede456543b7$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$25a99ede456543b7$var$kError]) reject(_this[$25a99ede456543b7$var$kError]);
                else resolve($25a99ede456543b7$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$25a99ede456543b7$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($25a99ede456543b7$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$25a99ede456543b7$var$kStream].read();
            if (data !== null) return Promise.resolve($25a99ede456543b7$var$createIterResult(data, false));
            promise = new Promise(this[$25a99ede456543b7$var$kHandlePromise]);
        }
        this[$25a99ede456543b7$var$kLastPromise] = promise;
        return promise;
    }
}, $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$25a99ede456543b7$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        });
    });
}), $25a99ede456543b7$var$_Object$setPrototypeO), $25a99ede456543b7$var$AsyncIteratorPrototype);
var $25a99ede456543b7$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kStream, {
        value: stream,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastResolve, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastReject, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kError, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$25a99ede456543b7$var$kStream].read();
            if (data) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                resolve($25a99ede456543b7$var$createIterResult(data, false));
            } else {
                iterator[$25a99ede456543b7$var$kLastResolve] = resolve;
                iterator[$25a99ede456543b7$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$25a99ede456543b7$var$kLastPromise] = null;
    $hzqCm(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$25a99ede456543b7$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                reject(err);
            }
            iterator[$25a99ede456543b7$var$kError] = err;
            return;
        }
        var resolve = iterator[$25a99ede456543b7$var$kLastResolve];
        if (resolve !== null) {
            iterator[$25a99ede456543b7$var$kLastPromise] = null;
            iterator[$25a99ede456543b7$var$kLastResolve] = null;
            iterator[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        }
        iterator[$25a99ede456543b7$var$kEnded] = true;
    });
    stream.on('readable', $25a99ede456543b7$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $25a99ede456543b7$var$createReadableStreamAsyncIterator;

});
parcelRegister("hzqCm", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("967Aq")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $ccaa5a4968d6bb28$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $ccaa5a4968d6bb28$var$noop() {}
function $ccaa5a4968d6bb28$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $ccaa5a4968d6bb28$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $ccaa5a4968d6bb28$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $ccaa5a4968d6bb28$var$once(callback || $ccaa5a4968d6bb28$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($ccaa5a4968d6bb28$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $ccaa5a4968d6bb28$var$eos;

});


parcelRegister("gN4Jr", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("k3Gr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $e9a50192eb9e2af9$var$Transform;

var $967Aq = parcelRequire("967Aq");
var $e9a50192eb9e2af9$require$_require$codes = $967Aq.codes;
var $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED = $e9a50192eb9e2af9$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK = $e9a50192eb9e2af9$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $fFuzr = parcelRequire("fFuzr");

(parcelRequire("dlqwk"))($e9a50192eb9e2af9$var$Transform, $fFuzr);
function $e9a50192eb9e2af9$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e9a50192eb9e2af9$var$Transform(options) {
    if (!(this instanceof $e9a50192eb9e2af9$var$Transform)) return new $e9a50192eb9e2af9$var$Transform(options);
    $fFuzr.call(this, options);
    this._transformState = {
        afterTransform: $e9a50192eb9e2af9$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $e9a50192eb9e2af9$var$prefinish);
}
function $e9a50192eb9e2af9$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $e9a50192eb9e2af9$var$done(_this, er, data);
    });
    else $e9a50192eb9e2af9$var$done(this, null, null);
}
$e9a50192eb9e2af9$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $fFuzr.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e9a50192eb9e2af9$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$e9a50192eb9e2af9$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e9a50192eb9e2af9$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e9a50192eb9e2af9$var$Transform.prototype._destroy = function(err, cb) {
    $fFuzr.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e9a50192eb9e2af9$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6G2fH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $4dc8698e5416b71e$var$PassThrough;

var $k3Gr9 = parcelRequire("k3Gr9");

(parcelRequire("dlqwk"))($4dc8698e5416b71e$var$PassThrough, $k3Gr9);
function $4dc8698e5416b71e$var$PassThrough(options) {
    if (!(this instanceof $4dc8698e5416b71e$var$PassThrough)) return new $4dc8698e5416b71e$var$PassThrough(options);
    $k3Gr9.call(this, options);
}
$4dc8698e5416b71e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("coyuH", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $90627bba44315748$var$eos;
function $90627bba44315748$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $967Aq = parcelRequire("967Aq");
var $90627bba44315748$require$_require$codes = $967Aq.codes;
var $90627bba44315748$var$ERR_MISSING_ARGS = $90627bba44315748$require$_require$codes.ERR_MISSING_ARGS, $90627bba44315748$var$ERR_STREAM_DESTROYED = $90627bba44315748$require$_require$codes.ERR_STREAM_DESTROYED;
function $90627bba44315748$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $90627bba44315748$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $90627bba44315748$var$destroyer(stream, reading, writing, callback) {
    callback = $90627bba44315748$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($90627bba44315748$var$eos === undefined) $90627bba44315748$var$eos = (parcelRequire("hzqCm"));
    $90627bba44315748$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($90627bba44315748$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $90627bba44315748$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $90627bba44315748$var$call(fn) {
    fn();
}
function $90627bba44315748$var$pipe(from, to) {
    return from.pipe(to);
}
function $90627bba44315748$var$popCallback(streams) {
    if (!streams.length) return $90627bba44315748$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $90627bba44315748$var$noop;
    return streams.pop();
}
function $90627bba44315748$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $90627bba44315748$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $90627bba44315748$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $90627bba44315748$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($90627bba44315748$var$call);
            if (reading) return;
            destroys.forEach($90627bba44315748$var$call);
            callback(error);
        });
    });
    return streams.reduce($90627bba44315748$var$pipe);
}
module.exports = $90627bba44315748$var$pipeline;

});




parcelRegister("a8qBR", function(module, exports) {
'use strict';

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $8amZM = parcelRequire("8amZM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $8amZM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $8amZM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});
parcelRegister("8amZM", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $5f21184fa2855fc7$require$Buffer = $1U9GM.Buffer;

var $lTKyd = parcelRequire("lTKyd");

var $b6RFW = parcelRequire("b6RFW");
var $5f21184fa2855fc7$require$Transform = $b6RFW.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $5f21184fa2855fc7$var$HashBase(blockSize) {
    $5f21184fa2855fc7$require$Transform.call(this);
    this._block = $5f21184fa2855fc7$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($5f21184fa2855fc7$var$HashBase, $5f21184fa2855fc7$require$Transform);
$5f21184fa2855fc7$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$5f21184fa2855fc7$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$5f21184fa2855fc7$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $lTKyd(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$5f21184fa2855fc7$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$5f21184fa2855fc7$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$5f21184fa2855fc7$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $5f21184fa2855fc7$var$HashBase;

});
parcelRegister("lTKyd", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ff12d80b875587b3$require$Buffer = $1U9GM.Buffer;

var $5KQLs = parcelRequire("5KQLs");
var $ff12d80b875587b3$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $ff12d80b875587b3$var$useArrayBuffer = $ff12d80b875587b3$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $ff12d80b875587b3$var$isView = $ff12d80b875587b3$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $ff12d80b875587b3$require$Buffer.isBuffer(thing) || $ff12d80b875587b3$var$useUint8Array && thing instanceof Uint8Array || $ff12d80b875587b3$var$isView && $ff12d80b875587b3$var$isView(thing)) return $5KQLs(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("5KQLs", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $430a2d85d7cad11c$require$Buffer = $1U9GM.Buffer;

var $5RgoW = parcelRequire("5RgoW");

var $aErU4 = parcelRequire("aErU4");
var $430a2d85d7cad11c$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $aErU4(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $430a2d85d7cad11c$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $430a2d85d7cad11c$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $430a2d85d7cad11c$var$useFromArrayBuffer = $430a2d85d7cad11c$var$useArrayBuffer && ($430a2d85d7cad11c$require$Buffer.prototype instanceof Uint8Array || $430a2d85d7cad11c$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($430a2d85d7cad11c$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $430a2d85d7cad11c$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $430a2d85d7cad11c$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($430a2d85d7cad11c$var$useArrayBuffer && $430a2d85d7cad11c$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $430a2d85d7cad11c$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($430a2d85d7cad11c$var$useFromArrayBuffer) {
            var res = $430a2d85d7cad11c$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $430a2d85d7cad11c$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($430a2d85d7cad11c$var$useUint8Array && data instanceof Uint8Array) return $430a2d85d7cad11c$require$Buffer.from(data);
    var isArr = $5RgoW(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $430a2d85d7cad11c$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $430a2d85d7cad11c$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("5RgoW", function(module, exports) {
var $443e9fef32a42cac$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $443e9fef32a42cac$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("aErU4", function(module, exports) {
'use strict';

var $eEkyn = parcelRequire("eEkyn");

var $eW390 = parcelRequire("eW390");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $7c1348d7c62af12b$var$$typedArrayBuffer = $eW390('TypedArray.prototype.buffer', true);

var $hN833 = parcelRequire("hN833");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $7c1348d7c62af12b$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$hN833(x)) throw new $eEkyn('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("eEkyn", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("eW390", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $jyxCz = parcelRequire("jyxCz");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $adf8ebd7229df60a$var$$indexOf = $jyxCz([
    $1zENl('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $1zENl(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $adf8ebd7229df60a$var$$indexOf(name, '.prototype.') > -1) return $jyxCz(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
'use strict';
var $1258b452ecf218a1$var$undefined1;

var $90JBs = parcelRequire("90JBs");

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");

var $bdePV = parcelRequire("bdePV");

var $dK8VM = parcelRequire("dK8VM");

var $7F9c3 = parcelRequire("7F9c3");

var $4l7TM = parcelRequire("4l7TM");

var $brYbP = parcelRequire("brYbP");

var $1rWQg = parcelRequire("1rWQg");

var $4J7z9 = parcelRequire("4J7z9");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $dYOee = parcelRequire("dYOee");

var $jAy3M = parcelRequire("jAy3M");
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $dYOee ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $dYOee(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $3ERI6 = parcelRequire("3ERI6");

var $eim86 = parcelRequire("eim86");

var $TxOUG = parcelRequire("TxOUG");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' || !$3ERI6 ? undefined : $3ERI6(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $5A49f,
    '%eval%': eval,
    '%EvalError%': $hDtVy,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6($3ERI6([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $90JBs,
    '%Object.getOwnPropertyDescriptor%': $dYOee,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $9RC8m,
    '%ReferenceError%': $2BaZq,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $5Ox6r,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $eEkyn,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $hFSMY,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9pzbV,
    '%Function.prototype.apply%': $xMvSJ,
    '%Object.defineProperty%': $jAy3M,
    '%Object.getPrototypeOf%': $eim86,
    '%Math.abs%': $bdePV,
    '%Math.floor%': $dK8VM,
    '%Math.max%': $7F9c3,
    '%Math.min%': $4l7TM,
    '%Math.pow%': $brYbP,
    '%Math.round%': $1rWQg,
    '%Math.sign%': $4J7z9,
    '%Reflect.getPrototypeOf%': $TxOUG
};
if ($3ERI6) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $3ERI6($3ERI6(e));
    $1258b452ecf218a1$var$INTRINSICS['%Error.prototype%'] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3ERI6) value = $3ERI6(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call($9pzbV, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call($xMvSJ, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call($9pzbV, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call($9pzbV, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call($9pzbV, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eEkyn('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eEkyn('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $5Ox6r('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($dYOee && i + 1 >= parts.length) {
                var desc = $dYOee(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("90JBs", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("5A49f", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("hFSMY", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("bdePV", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("dK8VM", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("7F9c3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4l7TM", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("brYbP", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("1rWQg", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("4J7z9", function(module, exports) {
'use strict';

var $4oiz9 = parcelRequire("4oiz9");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($4oiz9(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("4oiz9", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("dYOee", function(module, exports) {
'use strict';

var $d4L75 = parcelRequire("d4L75");
var $a2d7d74e83f6c3ed$require$$gOPD = $d4L75;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$require$$gOPD;

});
parcelRegister("d4L75", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("jAy3M", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = Object.defineProperty || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("3ERI6", function(module, exports) {
'use strict';

var $TxOUG = parcelRequire("TxOUG");

var $eim86 = parcelRequire("eim86");

var $7kfw3 = parcelRequire("7kfw3");
/** @type {import('.')} */ module.exports = $TxOUG ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $TxOUG(O);
} : $eim86 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eim86(O);
} : $7kfw3 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7kfw3(O);
} : null;

});
parcelRegister("TxOUG", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("eim86", function(module, exports) {
'use strict';

var $90JBs = parcelRequire("90JBs");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $90JBs.getPrototypeOf || null;

});

parcelRegister("7kfw3", function(module, exports) {
'use strict';

var $jyxCz = parcelRequire("jyxCz");

var $dYOee = parcelRequire("dYOee");
var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $dYOee && $dYOee(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $jyxCz([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;

});
parcelRegister("jyxCz", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $eEkyn = parcelRequire("eEkyn");

var $9pzbV = parcelRequire("9pzbV");

var $3YvJT = parcelRequire("3YvJT");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eEkyn('a function is required');
    return $3YvJT($gvair, $9pzbV, args);
};

});
parcelRegister("gvair", function(module, exports) {
'use strict';

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9pzbV", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("3YvJT", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");

var $8qWPV = parcelRequire("8qWPV");
/** @type {import('./actualApply')} */ module.exports = $8qWPV || $gvair.call($9pzbV, $xMvSJ);

});
parcelRegister("xMvSJ", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("8qWPV", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("4c4Ky", function(module, exports) {
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});



parcelRegister("hN833", function(module, exports) {
'use strict';

var $gJrpv = parcelRequire("gJrpv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});
parcelRegister("gJrpv", function(module, exports) {
'use strict';

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $eW390 = parcelRequire("eW390");

var $dYOee = parcelRequire("dYOee");

var $3ERI6 = parcelRequire("3ERI6");
var $c2e61c703a2c9ae0$var$$toString = $eW390('Object.prototype.toString');

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $eW390('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c2e61c703a2c9ae0$var$$indexOf = $eW390('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $3ERI6) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $3ERI6) {
        var proto = $3ERI6(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $3ERI6(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $c2e61c703a2c9ae0$var$cache['$' + typedArray] = $cOB0F(descriptor.get);
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $c2e61c703a2c9ae0$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $cOB0F(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        /** @type {string} */ var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
'use strict';

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $c21e1d005400ef2a$var$isArray(x) {
    return $c21e1d005400ef2a$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$isArray(list)) $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("63RD0", function(module, exports) {
'use strict';
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = '[object Object]';
var $469c9f4bd3a650de$var$fnClass = '[object Function]';
var $469c9f4bd3a650de$var$genClass = '[object GeneratorFunction]';
var $469c9f4bd3a650de$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = '[object HTML document.all class]';
var $469c9f4bd3a650de$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
'use strict';

var $epJrh = parcelRequire("epJrh");
var $63bfbecf41903c8f$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $epJrh.length; i++)if (typeof $63bfbecf41903c8f$var$g[$epJrh[i]] === 'function') // @ts-expect-error
    out[out.length] = $epJrh[i];
    return out;
};

});
parcelRegister("epJrh", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("cOB0F", function(module, exports) {
'use strict';

var $BPe9e = parcelRequire("BPe9e");

var $jAy3M = parcelRequire("jAy3M");

var $jyxCz = parcelRequire("jyxCz");

var $1uOip = parcelRequire("1uOip");
module.exports = function callBind(originalFunction) {
    var func = $jyxCz(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $BPe9e(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($jAy3M) $jAy3M(module.exports, 'apply', {
    value: $1uOip
});
else module.exports.apply = $1uOip;

});
parcelRegister("BPe9e", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $eEkyn('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $dYOee) {
        var desc = $dYOee(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $eEkyn('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $eEkyn('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $eEkyn('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $eEkyn('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $eEkyn('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $eEkyn('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("i16wS", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});


parcelRegister("1uOip", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $3YvJT = parcelRequire("3YvJT");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $3YvJT($gvair, $xMvSJ, arguments);
};

});


parcelRegister("3KyxH", function(module, exports) {
'use strict';

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});






parcelRegister("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

});
parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $9845726cca5dc7eb$var$Readable;

var $767Wy = parcelRequire("767Wy");
/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $9845726cca5dc7eb$require$Buffer = $h3oXE.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$util = Object.create((parcelRequire("dH2Jp")));

$9845726cca5dc7eb$var$util.inherits = (parcelRequire("dlqwk"));

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug = void 0;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog('stream');
else $9845726cca5dc7eb$var$debug = function() {};

var $185iR = parcelRequire("185iR");

var $fMCbt = parcelRequire("fMCbt");
var $9845726cca5dc7eb$var$StringDecoder;
$9845726cca5dc7eb$var$util.inherits($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($767Wy(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $185iR();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $9845726cca5dc7eb$var$needMoreData(state);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $9845726cca5dc7eb$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
    this._readableState.decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $9845726cca5dc7eb$var$MAX_HWM = 0x800000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $9845726cca5dc7eb$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $9845726cca5dc7eb$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $bUlqC.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
        else $9845726cca5dc7eb$var$emitReadable_(stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    $9845726cca5dc7eb$var$debug('emit readable');
    stream.emit('readable');
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $9845726cca5dc7eb$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $bUlqC.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $bUlqC.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
            else if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('resume');
        state.flowing = true;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    if (!state.reading) {
        $9845726cca5dc7eb$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $9845726cca5dc7eb$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $9845726cca5dc7eb$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $9845726cca5dc7eb$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $9845726cca5dc7eb$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $9845726cca5dc7eb$var$copyFromBufferString(n, list) : $9845726cca5dc7eb$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBuffer(n, list) {
    var ret = $9845726cca5dc7eb$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bUlqC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = {
    nextTick: $8ab58be9444f732a$var$nextTick
};
function $8ab58be9444f732a$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $hPtJY.nextTick(fn);
        case 2:
            return $hPtJY.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $hPtJY.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $hPtJY.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $hPtJY.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("767Wy", function(module, exports) {
var $52af415c3a3d4253$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("h3oXE", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $c6a6143e40fe9703$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $c6a6143e40fe9703$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($c6a6143e40fe9703$var$Buffer.from && $c6a6143e40fe9703$var$Buffer.alloc && $c6a6143e40fe9703$var$Buffer.allocUnsafe && $c6a6143e40fe9703$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $c6a6143e40fe9703$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $c6a6143e40fe9703$var$SafeBuffer;
}
function $c6a6143e40fe9703$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$c6a6143e40fe9703$var$copyProps($c6a6143e40fe9703$var$Buffer, $c6a6143e40fe9703$var$SafeBuffer);
$c6a6143e40fe9703$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
};
$c6a6143e40fe9703$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $c6a6143e40fe9703$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $c6a6143e40fe9703$var$Buffer(size);
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});

parcelRegister("dH2Jp", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $9f8168ed52eee242$export$43bee75e5e14138e, (v) => $9f8168ed52eee242$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $9f8168ed52eee242$export$f9ce7b637dfbe238, (v) => $9f8168ed52eee242$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $9f8168ed52eee242$export$630801d484da15df, (v) => $9f8168ed52eee242$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $9f8168ed52eee242$export$bedb7023a7733221, (v) => $9f8168ed52eee242$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $9f8168ed52eee242$export$7e4aa119212bc614, (v) => $9f8168ed52eee242$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $9f8168ed52eee242$export$844ec244b1367d54, (v) => $9f8168ed52eee242$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $9f8168ed52eee242$export$a244864fd9645c7f, (v) => $9f8168ed52eee242$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $9f8168ed52eee242$export$fce6876652108ab, (v) => $9f8168ed52eee242$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $9f8168ed52eee242$export$49841c62b9eff15, (v) => $9f8168ed52eee242$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $9f8168ed52eee242$export$a6cdc56e425d0d0a, (v) => $9f8168ed52eee242$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $9f8168ed52eee242$export$871608497c498473, (v) => $9f8168ed52eee242$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $9f8168ed52eee242$export$e6127cc7fe7395c3, (v) => $9f8168ed52eee242$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $9f8168ed52eee242$export$f6e2535fb5126e54, (v) => $9f8168ed52eee242$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $9f8168ed52eee242$export$c3825b437cbdea5c, (v) => $9f8168ed52eee242$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $9f8168ed52eee242$export$a7884ebc965f8f54, (v) => $9f8168ed52eee242$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $9f8168ed52eee242$export$43bee75e5e14138e;
var $9f8168ed52eee242$export$f9ce7b637dfbe238;
var $9f8168ed52eee242$export$630801d484da15df;
var $9f8168ed52eee242$export$bedb7023a7733221;
var $9f8168ed52eee242$export$7e4aa119212bc614;
var $9f8168ed52eee242$export$844ec244b1367d54;
var $9f8168ed52eee242$export$a244864fd9645c7f;
var $9f8168ed52eee242$export$fce6876652108ab;
var $9f8168ed52eee242$export$49841c62b9eff15;
var $9f8168ed52eee242$export$a6cdc56e425d0d0a;
var $9f8168ed52eee242$export$871608497c498473;
var $9f8168ed52eee242$export$e6127cc7fe7395c3;
var $9f8168ed52eee242$export$f6e2535fb5126e54;
var $9f8168ed52eee242$export$c3825b437cbdea5c;
var $9f8168ed52eee242$export$a7884ebc965f8f54;
function $9f8168ed52eee242$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $9f8168ed52eee242$var$objectToString(arg) === '[object Array]';
}
$9f8168ed52eee242$export$43bee75e5e14138e = $9f8168ed52eee242$var$isArray;
function $9f8168ed52eee242$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$9f8168ed52eee242$export$f9ce7b637dfbe238 = $9f8168ed52eee242$var$isBoolean;
function $9f8168ed52eee242$var$isNull(arg) {
    return arg === null;
}
$9f8168ed52eee242$export$630801d484da15df = $9f8168ed52eee242$var$isNull;
function $9f8168ed52eee242$var$isNullOrUndefined(arg) {
    return arg == null;
}
$9f8168ed52eee242$export$bedb7023a7733221 = $9f8168ed52eee242$var$isNullOrUndefined;
function $9f8168ed52eee242$var$isNumber(arg) {
    return typeof arg === 'number';
}
$9f8168ed52eee242$export$7e4aa119212bc614 = $9f8168ed52eee242$var$isNumber;
function $9f8168ed52eee242$var$isString(arg) {
    return typeof arg === 'string';
}
$9f8168ed52eee242$export$844ec244b1367d54 = $9f8168ed52eee242$var$isString;
function $9f8168ed52eee242$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$9f8168ed52eee242$export$a244864fd9645c7f = $9f8168ed52eee242$var$isSymbol;
function $9f8168ed52eee242$var$isUndefined(arg) {
    return arg === void 0;
}
$9f8168ed52eee242$export$fce6876652108ab = $9f8168ed52eee242$var$isUndefined;
function $9f8168ed52eee242$var$isRegExp(re) {
    return $9f8168ed52eee242$var$objectToString(re) === '[object RegExp]';
}
$9f8168ed52eee242$export$49841c62b9eff15 = $9f8168ed52eee242$var$isRegExp;
function $9f8168ed52eee242$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$9f8168ed52eee242$export$a6cdc56e425d0d0a = $9f8168ed52eee242$var$isObject;
function $9f8168ed52eee242$var$isDate(d) {
    return $9f8168ed52eee242$var$objectToString(d) === '[object Date]';
}
$9f8168ed52eee242$export$871608497c498473 = $9f8168ed52eee242$var$isDate;
function $9f8168ed52eee242$var$isError(e) {
    return $9f8168ed52eee242$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$9f8168ed52eee242$export$e6127cc7fe7395c3 = $9f8168ed52eee242$var$isError;
function $9f8168ed52eee242$var$isFunction(arg) {
    return typeof arg === 'function';
}
$9f8168ed52eee242$export$f6e2535fb5126e54 = $9f8168ed52eee242$var$isFunction;
function $9f8168ed52eee242$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$9f8168ed52eee242$export$c3825b437cbdea5c = $9f8168ed52eee242$var$isPrimitive;

$9f8168ed52eee242$export$a7884ebc965f8f54 = (parcelRequire("6ZWSX")).Buffer.isBuffer;
function $9f8168ed52eee242$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("185iR", function(module, exports) {
'use strict';
function $0d2aa6ea56b3e1e2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $h3oXE = parcelRequire("h3oXE");
var $0d2aa6ea56b3e1e2$require$Buffer = $h3oXE.Buffer;

var $kjyEk = parcelRequire("kjyEk");
function $0d2aa6ea56b3e1e2$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $0d2aa6ea56b3e1e2$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $0d2aa6ea56b3e1e2$require$Buffer.alloc(0);
        var ret = $0d2aa6ea56b3e1e2$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $0d2aa6ea56b3e1e2$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($kjyEk && $kjyEk.inspect && $kjyEk.inspect.custom) module.exports.prototype[$kjyEk.inspect.custom] = function() {
    var obj = $kjyEk.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("fMCbt", function(module, exports) {
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy
};

});

parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ /*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

/*<replacement>*/ var $076d08b0309449dc$var$util = Object.create((parcelRequire("dH2Jp")));

$076d08b0309449dc$var$util.inherits = (parcelRequire("dlqwk"));

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");
$076d08b0309449dc$var$util.inherits($076d08b0309449dc$var$Duplex, $d4xg3);
// avoid scope creep, the keys array can then be collected
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $076d08b0309449dc$var$onend);
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $bUlqC.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$076d08b0309449dc$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $bUlqC.nextTick(cb, err);
};

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$asyncWrite = (0, $bUlqC.nextTick);
/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$util = Object.create((parcelRequire("dH2Jp")));

$2bdf55c2c4f390d3$var$util.inherits = (parcelRequire("dlqwk"));

/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $2bdf55c2c4f390d3$require$Buffer = $h3oXE.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");
$2bdf55c2c4f390d3$var$util.inherits($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, 'buffer', {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this) && !(this instanceof $2bdf55c2c4f390d3$var$Duplex)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $bUlqC.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $bUlqC.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ended) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $bUlqC.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $bUlqC.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $2bdf55c2c4f390d3$var$asyncWrite($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
};
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $bUlqC.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $bUlqC.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("imDDS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $d5e9082788fdd47b$export$63a7aa211a91ed69, (v) => $d5e9082788fdd47b$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d5e9082788fdd47b$export$63a7aa211a91ed69;
'use strict';

var $h3oXE = parcelRequire("h3oXE");
var $d5e9082788fdd47b$require$Buffer = $h3oXE.Buffer;
/*</replacement>*/ var $d5e9082788fdd47b$var$isEncoding = $d5e9082788fdd47b$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $d5e9082788fdd47b$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d5e9082788fdd47b$var$normalizeEncoding(enc) {
    var nenc = $d5e9082788fdd47b$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($d5e9082788fdd47b$require$Buffer.isEncoding === $d5e9082788fdd47b$var$isEncoding || !$d5e9082788fdd47b$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$d5e9082788fdd47b$export$63a7aa211a91ed69 = $d5e9082788fdd47b$var$StringDecoder;
function $d5e9082788fdd47b$var$StringDecoder(encoding) {
    this.encoding = $d5e9082788fdd47b$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $d5e9082788fdd47b$var$utf16Text;
            this.end = $d5e9082788fdd47b$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $d5e9082788fdd47b$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $d5e9082788fdd47b$var$base64Text;
            this.end = $d5e9082788fdd47b$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d5e9082788fdd47b$var$simpleWrite;
            this.end = $d5e9082788fdd47b$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d5e9082788fdd47b$require$Buffer.allocUnsafe(nb);
}
$d5e9082788fdd47b$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$d5e9082788fdd47b$var$StringDecoder.prototype.end = $d5e9082788fdd47b$var$utf8End;
// Returns only complete characters in a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.text = $d5e9082788fdd47b$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d5e9082788fdd47b$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d5e9082788fdd47b$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d5e9082788fdd47b$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d5e9082788fdd47b$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d5e9082788fdd47b$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d5e9082788fdd47b$var$utf8Text(buf, i) {
    var total = $d5e9082788fdd47b$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d5e9082788fdd47b$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d5e9082788fdd47b$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d5e9082788fdd47b$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $d5e9082788fdd47b$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $d5e9082788fdd47b$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d5e9082788fdd47b$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d5e9082788fdd47b$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $8180203f7f0d3074$var$Transform;

var $DwJuQ = parcelRequire("DwJuQ");

/*<replacement>*/ var $8180203f7f0d3074$var$util = Object.create((parcelRequire("dH2Jp")));

$8180203f7f0d3074$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $8180203f7f0d3074$var$util.inherits($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

/*<replacement>*/ var $34c74be520d619f2$var$util = Object.create((parcelRequire("dH2Jp")));

$34c74be520d619f2$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $34c74be520d619f2$var$util.inherits($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("5Z1sR", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("dECyV"));

module.exports.sha1 = (parcelRequire("dVcFO"));

module.exports.sha224 = (parcelRequire("3wNjm"));

module.exports.sha256 = (parcelRequire("3BFQx"));

module.exports.sha384 = (parcelRequire("5qHaZ"));

module.exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + w[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;

var $5KQLs = parcelRequire("5KQLs");
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $5KQLs(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRegister("dVcFO", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $a22a6de6a357c37a$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + w[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W; // new Array(64)
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W; // new Array(64)
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $2a05499bef58a0cf$var$gamma1(w[i - 2]) + w[i - 7] + $2a05499bef58a0cf$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + w[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");

var $5KQLs = parcelRequire("5KQLs");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $5KQLs(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});


parcelRegister("1iL1D", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, 'digest');
    if (typeof key === 'string') key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $0f2bf322914b61b2$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, 'digest');
    if (typeof key === 'string') key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("eFSIF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6swAi"));

});
parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;
'use strict';

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});
parcelRegister("5dQ72", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $3cd697166017b735$var$checks = [];
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, 'Password');
    salt = $kiaDM(salt, $6YaY3, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
'use strict';
var $5410f37dea3a95ee$var$$isFinite = isFinite;
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$5410f37dea3a95ee$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split('.')[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $5130da986dd86f24$var$defaultEncoding = 'utf-8';
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {
'use strict';

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $16722fe28cdbf3c2$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $16722fe28cdbf3c2$var$rmd160Func(data) {
    return new $a8qBR().update(data).digest();
}
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $16722fe28cdbf3c2$var$rmd160Func;
    if (alg === 'md5') return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, 'Password');
    salt = $kiaDM(salt, $6YaY3, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $16722fe28cdbf3c2$var$mapping[lowerDigest] || lowerDigest;
    var size = $16722fe28cdbf3c2$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $16722fe28cdbf3c2$var$Hmac(mappedDigest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("kiaDM", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;

var $5KQLs = parcelRequire("5KQLs");
var $ec5dbe1d2de061b3$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $ec5dbe1d2de061b3$var$useArrayBuffer = $ec5dbe1d2de061b3$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $ec5dbe1d2de061b3$var$isView = $ec5dbe1d2de061b3$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $ec5dbe1d2de061b3$require$Buffer.isBuffer(thing) || $ec5dbe1d2de061b3$var$useUint8Array && thing instanceof Uint8Array || $ec5dbe1d2de061b3$var$isView && $ec5dbe1d2de061b3$var$isView(thing)) return $5KQLs(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("eyeBm", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $a97f913e2ff95e3b$export$bdd223f16383713e, (v) => $a97f913e2ff95e3b$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $a97f913e2ff95e3b$export$26e5786e8ac8e530, (v) => $a97f913e2ff95e3b$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $a97f913e2ff95e3b$export$2f64596b8cbf08b4, (v) => $a97f913e2ff95e3b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $a97f913e2ff95e3b$export$20533d26f07f1ee0, (v) => $a97f913e2ff95e3b$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $a97f913e2ff95e3b$export$12ada9414fbc594c, (v) => $a97f913e2ff95e3b$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a, (v) => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $a97f913e2ff95e3b$export$36b6d6ef312eab39, (v) => $a97f913e2ff95e3b$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $a97f913e2ff95e3b$export$f5e7e39d57cd9700, (v) => $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $a97f913e2ff95e3b$export$dedd8dc3dc62b370, (v) => $a97f913e2ff95e3b$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $a97f913e2ff95e3b$export$58a258485f1e49f6, (v) => $a97f913e2ff95e3b$export$58a258485f1e49f6 = v);
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;

var $ljOtR = parcelRequire("ljOtR");

var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");

var $xsYYh = parcelRequire("xsYYh");

var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($xsYYh).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;

});
parcelRegister("ljOtR", function(module, exports) {

var $26nOC = parcelRequire("26nOC");

var $8SeDJ = parcelRequire("8SeDJ");

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    'des-ede3-cbc': $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    'des-ede3': $8SeDJ.EDE,
    'des-ede-cbc': $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    'des-ede': $8SeDJ.EDE,
    'des-cbc': $8SeDJ.CBC.instantiate($8SeDJ.DES),
    'des-ecb': $8SeDJ.DES
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes['des-cbc'];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes['des-ede3-cbc'];
module.exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};

});
parcelRegister("8SeDJ", function(module, exports) {

$parcel$export(module.exports, "DES", () => $675eb908dbde2e68$export$cc8859615686b300, (v) => $675eb908dbde2e68$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $675eb908dbde2e68$export$8ad3f227af08fcc5, (v) => $675eb908dbde2e68$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $675eb908dbde2e68$export$947646e34766044f, (v) => $675eb908dbde2e68$export$947646e34766044f = v);
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
'use strict';

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));

});
parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
'use strict';
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("enfpo", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("dB8Kv", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $dB8Kv.create({
            type: 'encrypt',
            key: k1
        }),
        $dB8Kv.create({
            type: 'decrypt',
            key: k2
        }),
        $dB8Kv.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: 'decrypt',
            key: k3
        }),
        $dB8Kv.create({
            type: 'encrypt',
            key: k2
        }),
        $dB8Kv.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});



parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $hzsAp(config.module, password, iv);
    else if (config.type === 'auth') return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});

parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $hzsAp(config.module, password, iv, true);
    else if (config.type === 'auth') return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});


parcelRegister("xsYYh", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("5NszM", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $4387b1fafb8a1868$export$971862a2fcb1bb40, (v) => $4387b1fafb8a1868$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $4387b1fafb8a1868$export$c6ff6a88acbeaf40, (v) => $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $4387b1fafb8a1868$export$fdc27893e98845cc, (v) => $4387b1fafb8a1868$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $4387b1fafb8a1868$export$6671fb9a1323bed, (v) => $4387b1fafb8a1868$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $4387b1fafb8a1868$export$d74daf141a551db, (v) => $4387b1fafb8a1868$export$d74daf141a551db = v);
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;

var $aV75E = parcelRequire("aV75E");

var $kGErQ = parcelRequire("kGErQ");

var $bLCm8 = parcelRequire("bLCm8");
function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].prime, 'hex');
    var gen = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].gen, 'hex');
    return new $bLCm8(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $bLCm8($aV75E(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $bLCm8(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;

});
parcelRegister("aV75E", function(module, exports) {

var $hkN9y = parcelRequire("hkN9y");
module.exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);

var $g2bJL = parcelRequire("g2bJL");
var $7f34ba2fa9025258$var$millerRabin = new $g2bJL();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("5vmVB", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("g2bJL", function(module, exports) {

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
module.exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("7Zvov", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("kGErQ", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("bLCm8", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $g2bJL = parcelRequire("g2bJL");
var $8911d62d5514749e$var$millerRabin = new $g2bJL();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);

var $aV75E = parcelRequire("aV75E");

var $hkN9y = parcelRequire("hkN9y");
module.exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$aV75E.simpleSieve || !$aV75E.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("4zMFU", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $b6RFW = parcelRequire("b6RFW");

var $dlqwk = parcelRequire("dlqwk");

var $6E9kG = parcelRequire("6E9kG");

var $fQdau = parcelRequire("fQdau");

var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, 'hex');
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $b6RFW.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $6E9kG(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $b6RFW.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $3550302076d9e62e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $fQdau(sigBuffer, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
module.exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};

});
parcelRegister("6E9kG", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
var $4d6db7c28d99f640$var$RSA_PKCS1_PADDING = 1;
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $4d6db7c28d99f640$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $aYksR[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $4d6db7c28d99f640$var$sign;
module.exports.getKey = $4d6db7c28d99f640$var$getKey;
module.exports.makeKey = $4d6db7c28d99f640$var$makeKey;

});
parcelRegister("3Sg1O", function(module, exports) {
'use strict';

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");

var $1U9GM = parcelRequire("1U9GM");
var $2d22d91c93a13ae5$require$Buffer = $1U9GM.Buffer;
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, 'be', len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});
parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("1zUcV", function(module, exports) {
'use strict';
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});
parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("gEVtY", function(module, exports) {
'use strict';
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $c20cf89948514165$var$utils.toArray(bytes, 'hex') : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, 'hex', 'le');
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("jX0xT", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lC4vN", function(module, exports) {
'use strict';
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("cP1GP", function(module, exports) {
'use strict';
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, 'short', conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, 'mont', conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, 'edwards', conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
'use strict';
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $cP1GP.short(options);
    else if (options.type === 'edwards') this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), 'Invalid curve');
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$b0f2b206068f1378$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$b0f2b206068f1378$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$b0f2b206068f1378$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$b0f2b206068f1378$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
'use strict';

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
'use strict';

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
'use strict';

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $btcbI.toHex32(this.h.slice(0, 7), 'big');
    else return $btcbI.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("a9EzX", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};

});


parcelRegister("7j4cV", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h.slice(0, 12), 'big');
    else return $btcbI.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("lMBCM", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'little');
    else return $btcbI.split32(this.h, 'little');
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), 'Unknown curve ' + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($jX0xT.isBN(msg) || typeof msg === 'number') {
        msg = new $jX0xT(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $jX0xT(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $jX0xT(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$jX0xT.isBN(msg)) {
        $17ac898fe5b06379$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $17ac898fe5b06379$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$17ac898fe5b06379$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $17ac898fe5b06379$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $17ac898fe5b06379$var$assert(new $jX0xT(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("kKonu", function(module, exports) {
'use strict';

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $lC4vN.toArray(options.pers, options.persEnc || 'hex');
    $koC21(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $fe42f8d68750188b$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $fe42f8d68750188b$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("i46nc", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
'use strict';

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, 'KeyPair is public only');
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $5ca7e26f93e1a560$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});



parcelRegister("aNeDF", function(module, exports) {
'use strict';

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");
var $7db9d5f82e4113aa$require$pbkdf2Sync = $lORrZ.pbkdf2Sync;

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $7db9d5f82e4113aa$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $fC6a8.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $fC6a8.EncryptedPrivateKey.decode(data, 'der');
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $fC6a8.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $fC6a8.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $fC6a8.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $fC6a8.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $fC6a8.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
module.exports = $7db9d5f82e4113aa$var$parseKeys;

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
'use strict';

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define('DSAparam', function() {
    this['int']();
});
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("10gXo", function(module, exports) {
var $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});
parcelRegister("9qVGS", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8fBln", function(module, exports) {

var $10gXo = parcelRequire("10gXo");

var $dlqwk = parcelRequire("dlqwk");
var $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("aeJDW")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $dlqwk(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($10gXo.decoders[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($10gXo.encoders[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("aeJDW", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("5JhaY", function(module, exports) {
var $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;

var $dlqwk = parcelRequire("dlqwk");

var $5JhaY = parcelRequire("5JhaY");
var $2397844df508f52e$require$Reporter = $5JhaY.Reporter;

var $6ZWSX = parcelRequire("6ZWSX");
var $2397844df508f52e$require$Buffer = $6ZWSX.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $2397844df508f52e$var$EncoderBuffer)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $2397844df508f52e$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("h4y6g", function(module, exports) {

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$Reporter = $5JhaY.Reporter;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$EncoderBuffer = $5JhaY.EncoderBuffer;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$DecoderBuffer = $5JhaY.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
var $c6dd42f3395d566f$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $c6dd42f3395d566f$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
var $c6dd42f3395d566f$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $c6dd42f3395d566f$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
var $c6dd42f3395d566f$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, 'Root node can have only one child');
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    var state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $koC21(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $koC21(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("3TcQc", function(module, exports) {
var $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});
parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;

var $3TcQc = parcelRequire("3TcQc");
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$138ac3909863432c$export$f18596ef8d632e49 = $3TcQc._reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$138ac3909863432c$export$f17df38a421ab9e3 = $3TcQc._reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("89TTw", function(module, exports) {
var $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $10gXo = parcelRequire("10gXo");
var $b28be291c8d179e1$var$base = $10gXo.base;
var $b28be291c8d179e1$var$bignum = $10gXo.bignum;
// Import DER constants
var $b28be291c8d179e1$var$der = $10gXo.constants.der;
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $b28be291c8d179e1$var$base.DecoderBuffer)) data = new $b28be291c8d179e1$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $b28be291c8d179e1$var$base.Node.call(this, 'der', parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $b28be291c8d179e1$var$base.Node);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $b28be291c8d179e1$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $b28be291c8d179e1$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $b28be291c8d179e1$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $6ef8062b6cdbe0f4$require$Buffer = $6ZWSX.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = 'pem';
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $6ef8062b6cdbe0f4$require$Buffer(base64, 'base64');
    return $fkoHA.prototype.decode.call(this, input, options);
};

});


parcelRegister("ljw8S", function(module, exports) {
var $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $1ae2666fc718ae87$require$Buffer = $6ZWSX.Buffer;

var $10gXo = parcelRequire("10gXo");
var $1ae2666fc718ae87$var$base = $10gXo.base;
// Import DER constants
var $1ae2666fc718ae87$var$der = $10gXo.constants.der;
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $1ae2666fc718ae87$var$base.Node.call(this, 'der', parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $1ae2666fc718ae87$var$base.Node);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $1ae2666fc718ae87$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $1ae2666fc718ae87$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $1ae2666fc718ae87$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $1ae2666fc718ae87$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $1ae2666fc718ae87$var$two(date.getFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $1ae2666fc718ae87$var$two(date.getFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $1ae2666fc718ae87$require$Buffer(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $1ae2666fc718ae87$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $1ae2666fc718ae87$require$Buffer(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($1ae2666fc718ae87$var$der.tagByName.hasOwnProperty(tag)) res = $1ae2666fc718ae87$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $1ae2666fc718ae87$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("bPffB", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = 'pem';
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $2j6ve.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define('RelativeDistinguishedName', function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define('RDNSequence', function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define('Name', function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($877bcccea3fc6be5$var$Time), this.key('notAfter').use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('issuer').use($877bcccea3fc6be5$var$Name), this.key('validity').use($877bcccea3fc6be5$var$Validity), this.key('subject').use($877bcccea3fc6be5$var$Name), this.key('subjectPublicKeyInfo').use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($877bcccea3fc6be5$var$TBSCertificate), this.key('signatureAlgorithm').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});


parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("3ILSx", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], 'hex');
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("aYksR", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("fQdau", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $aYksR[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $b885ed4272d45f84$var$verify;

});


parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("jqmf0", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("fMM6j", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $b7e0a6843ffae451$export$512823e338ddb1b7, (v) => $b7e0a6843ffae451$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $b7e0a6843ffae451$export$7efb24e2fddf99b9, (v) => $b7e0a6843ffae451$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3, (v) => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $b7e0a6843ffae451$export$b9d55ff329113abd, (v) => $b7e0a6843ffae451$export$b9d55ff329113abd = v);
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7('sha1').update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6rDPA", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7('sha1').update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("c34vB", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $8c5943302864e9a5$export$bb1abf2ce84fc7e8, (v) => $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $8c5943302864e9a5$export$2f7171e78e524d5e, (v) => $8c5943302864e9a5$export$2f7171e78e524d5e = v);
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}

});


parcelRegister("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = ' ' + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRegister("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== 'undefined';
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== 'undefined';
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === 'Uint8Array';
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === 'Uint16Array';
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === 'Uint32Array';
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === 'Int8Array';
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === 'Int16Array';
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === 'Int32Array';
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === 'Float32Array';
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === 'Float64Array';
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map]';
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== 'undefined' && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set]';
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== 'undefined' && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakMap]';
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakSet]';
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object DataView]';
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === 'undefined') $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("f4HGZ", function(module, exports) {
'use strict';

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $eW390 = parcelRequire("eW390");
var $af991f1d6c80f097$var$$toString = $eW390('Object.prototype.toString');
/** @type {import('.')} */ var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== '[object Array]' && 'callee' in value && $af991f1d6c80f097$var$$toString(value.callee) === '[object Function]';
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});

parcelRegister("5WnCa", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $2xf7f = parcelRequire("2xf7f");
var $4534afe844d627e4$var$isFnRegex = $2xf7f(/^\s*(?:function)?\*/);

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $3ERI6 = parcelRequire("3ERI6");
var $4534afe844d627e4$var$toStr = $eW390('Object.prototype.toString');
var $4534afe844d627e4$var$fnToStr = $eW390('Function.prototype.toString');

var $1xINW = parcelRequire("1xINW");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($4534afe844d627e4$var$isFnRegex($4534afe844d627e4$var$fnToStr(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$3ERI6) return false;
    var GeneratorFunction = $1xINW();
    return GeneratorFunction && $3ERI6(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("2xf7f", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $l37Ky = parcelRequire("l37Ky");
var $1d8a638ce4bfc95c$var$$exec = $eW390('RegExp.prototype.exec');

var $eEkyn = parcelRequire("eEkyn");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$l37Ky(regex)) throw new $eEkyn('`regex` must be a RegExp');
    return function test(s) {
        return $1d8a638ce4bfc95c$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("l37Ky", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $f52fe3bd41a86f17$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $4c4Ky = parcelRequire("4c4Ky");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ var $f52fe3bd41a86f17$var$fn;
if ($f52fe3bd41a86f17$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $f52fe3bd41a86f17$var$$exec = $eW390('RegExp.prototype.exec');
    /** @type {object} */ var $f52fe3bd41a86f17$var$isRegexMarker = {};
    var $f52fe3bd41a86f17$var$throwRegexMarker = function() {
        throw $f52fe3bd41a86f17$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $f52fe3bd41a86f17$var$badStringifier = {
        toString: $f52fe3bd41a86f17$var$throwRegexMarker,
        valueOf: $f52fe3bd41a86f17$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $f52fe3bd41a86f17$var$badStringifier[Symbol.toPrimitive] = $f52fe3bd41a86f17$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $f52fe3bd41a86f17$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $dYOee(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $4c4Ky(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $f52fe3bd41a86f17$var$$exec(value, /** @type {unknown} */ $f52fe3bd41a86f17$var$badStringifier);
        } catch (e) {
            return e === $f52fe3bd41a86f17$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $f52fe3bd41a86f17$var$$toString = $eW390('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $f52fe3bd41a86f17$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $f52fe3bd41a86f17$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $f52fe3bd41a86f17$var$$toString(value) === $f52fe3bd41a86f17$var$regexClass;
    };
}
module.exports = $f52fe3bd41a86f17$var$fn;

});


parcelRegister("1xINW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8c988d2af4ba1e07$export$2e2bcd8739ae039);

var $aN8bA = parcelRequire("aN8bA");
var /** @type {import('./index.d.mts').default} */ $8c988d2af4ba1e07$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aN8bA)));

});
parcelRegister("aN8bA", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $7db4d48993eb4086$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$7db4d48993eb4086$var$cached;

});




parcelRegister("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});


parcelRegister("9EePZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("fUPCt")), module.exports);

$7WQrb.__exportStar((parcelRequire("3NXE9")), module.exports);

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $5c96a02c592fcff1$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5c96a02c592fcff1$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("fUPCt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $b964208cf0e7f449$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $b964208cf0e7f449$var$delay;

});

parcelRegister("3NXE9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $2MWZl = parcelRequire("2MWZl");
function $2c543746c4e25c3a$var$toMiliseconds(seconds) {
    return seconds * $2MWZl.ONE_THOUSAND;
}
module.exports.toMiliseconds = $2c543746c4e25c3a$var$toMiliseconds;
function $2c543746c4e25c3a$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $2MWZl.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $2c543746c4e25c3a$var$fromMiliseconds;

});
parcelRegister("2MWZl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("lfr75")), module.exports);

$7WQrb.__exportStar((parcelRequire("1qmVT")), module.exports);

});
parcelRegister("lfr75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("1qmVT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("iD73S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $d90158c308dd266b$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $d90158c308dd266b$var$Watch;
module.exports.default = $d90158c308dd266b$var$Watch;

});

parcelRegister("dTXLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("b5rRE")), module.exports);

});
parcelRegister("b5rRE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $8125c6986ecca435$var$IWatch {
}
module.exports.IWatch = $8125c6986ecca435$var$IWatch;

});


parcelRegister("ljFVp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $f84be4b966947ef2$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $f84be4b966947ef2$var$getBrowerCrypto;
function $f84be4b966947ef2$var$getSubtleCrypto() {
    const browserCrypto = $f84be4b966947ef2$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $f84be4b966947ef2$var$getSubtleCrypto;
function $f84be4b966947ef2$var$isBrowserCryptoAvailable() {
    return !!$f84be4b966947ef2$var$getBrowerCrypto() && !!$f84be4b966947ef2$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $f84be4b966947ef2$var$isBrowserCryptoAvailable;

});

parcelRegister("5vmD7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $402166cfd1e26574$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $402166cfd1e26574$var$isReactNative;
function $402166cfd1e26574$var$isNode() {
    return false;
}
module.exports.isNode = $402166cfd1e26574$var$isNode;
function $402166cfd1e26574$var$isBrowser() {
    return !$402166cfd1e26574$var$isReactNative() && !$402166cfd1e26574$var$isNode();
}
module.exports.isBrowser = $402166cfd1e26574$var$isBrowser;

});

parcelRegister("fvaAM", function(module, exports) {
'use strict';
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});

parcelRegister("6cqMT", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("fLVpN", function(module, exports) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var globalObject = getGlobal();
module.exports = exports = globalObject.fetch;
// Needed for TypeScript and Webpack.
if (globalObject.fetch) exports.default = globalObject.fetch.bind(globalObject);
exports.Headers = globalObject.Headers;
exports.Request = globalObject.Request;
exports.Response = globalObject.Response;

});

parcelRegister("cgCz9", function(module, exports) {



































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")), (parcelRequire("dOqqi")), (parcelRequire("dkHeo")), (parcelRequire("33Dov")), (parcelRequire("4Gs7i")), (parcelRequire("3v7ey")), (parcelRequire("9xtq3")), (parcelRequire("dCBbD")), (parcelRequire("ch0KT")), (parcelRequire("QV0jx")), (parcelRequire("9jPYZ")), (parcelRequire("1z9jS")), (parcelRequire("k6BGg")), (parcelRequire("6gSsW")), (parcelRequire("4QIA3")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")), (parcelRequire("jl5kK")), (parcelRequire("5F0ko")), (parcelRequire("lxABR")), (parcelRequire("2Qhlr")), (parcelRequire("dITey")), (parcelRequire("cVYKW")), (parcelRequire("2MnMp")), (parcelRequire("5n9UW")), (parcelRequire("2X3cT")), (parcelRequire("fXAPg")), (parcelRequire("6AdsH")), (parcelRequire("52GAb")), (parcelRequire("fWyuT")), (parcelRequire("8A2QT")), (parcelRequire("4lLjY")), (parcelRequire("iHWrV")), (parcelRequire("en8DC")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("3OBZa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("kjyEk"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("jN34i", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("dOqqi", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("dkHeo", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join('');
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join('');
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("33Dov", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("4Gs7i", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
            _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

});

parcelRegister("3v7ey", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("9xtq3", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("dCBbD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("ch0KT", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("dCBbD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("QV0jx", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("9jPYZ", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")), (parcelRequire("QV0jx")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("1z9jS", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("k6BGg", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("6gSsW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == 'string') key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("4QIA3", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("dCBbD")), (parcelRequire("6gSsW")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("8fUCE", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("9xtq3")), (parcelRequire("6gSsW")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("lgRCb", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("8fUCE")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == 'string') return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == 'string') return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("jl5kK", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("5F0ko", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("lxABR", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("2Qhlr", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("dITey", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("cVYKW", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("2MnMp", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("5n9UW", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("2X3cT", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("fXAPg", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("6AdsH", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("52GAb", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("fWyuT", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("8A2QT", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("4lLjY", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("iHWrV", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});

parcelRegister("en8DC", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        //Origin pbox and sbox, derived from PI
        const ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        const ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            let a = x >> 24 & 0xFF;
            let b = x >> 16 & 0xFF;
            let c = x >> 8 & 0xFF;
            let d = x & 0xFF;
            let y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(let Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(let Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            let keyIndex = 0;
            for(let index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            let Data1 = 0;
            let Data2 = 0;
            let res = 0;
            for(let i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(let i = 0; i < 4; i++)for(let j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i][j] = Data1;
                ctx.sbox[i][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

});


/**
 * General docs
 * @module public
 */ /* eslint-disable prefer-arrow/prefer-arrow-functions */ /**
 * A helper function to improve typings of object keys
 *
 * @param obj Object
 */ function $46daaaa2fa498f63$export$ed97f33186d4b816(obj) {
    return Object.keys(obj);
}


var $247a3319916bcc85$export$57465cba173e479e;
(function(ExposedPromiseStatus) {
    ExposedPromiseStatus["PENDING"] = "pending";
    ExposedPromiseStatus["RESOLVED"] = "resolved";
    ExposedPromiseStatus["REJECTED"] = "rejected";
})($247a3319916bcc85$export$57465cba173e479e || ($247a3319916bcc85$export$57465cba173e479e = {}));
const $247a3319916bcc85$var$notInitialized = ()=>{
    throw new Error('ExposedPromise not initialized yet.');
};
class $247a3319916bcc85$export$babe85162c870d79 {
    _promise;
    _resolve = $247a3319916bcc85$var$notInitialized;
    _reject = $247a3319916bcc85$var$notInitialized;
    _status = $247a3319916bcc85$export$57465cba173e479e.PENDING;
    _promiseResult;
    _promiseError;
    get promise() {
        return this._promise;
    }
    get resolve() {
        return this._resolve;
    }
    get reject() {
        return this._reject;
    }
    get status() {
        return this._status;
    }
    get promiseResult() {
        return this._promiseResult;
    }
    get promiseError() {
        return this._promiseError;
    }
    constructor(){
        this._promise = new Promise((innerResolve, innerReject)=>{
            this._resolve = (value)=>{
                if (this.isSettled()) return;
                this._promiseResult = value;
                innerResolve(value);
                this._status = $247a3319916bcc85$export$57465cba173e479e.RESOLVED;
                return;
            };
            this._reject = (reason)=>{
                if (this.isSettled()) return;
                this._promiseError = reason;
                innerReject(reason);
                this._status = $247a3319916bcc85$export$57465cba173e479e.REJECTED;
                return;
            };
        });
    }
    static resolve(value) {
        const promise = new $247a3319916bcc85$export$babe85162c870d79();
        promise.resolve(value);
        return promise;
    }
    static reject(reason) {
        const promise = new $247a3319916bcc85$export$babe85162c870d79();
        promise.reject(reason);
        return promise;
    }
    isPending() {
        return this.status === $247a3319916bcc85$export$57465cba173e479e.PENDING;
    }
    isResolved() {
        return this.status === $247a3319916bcc85$export$57465cba173e479e.RESOLVED;
    }
    isRejected() {
        return this.status === $247a3319916bcc85$export$57465cba173e479e.REJECTED;
    }
    isSettled() {
        return this.isResolved() || this.isRejected();
    }
}


var $510ad3657d73a9d2$exports = {};
"use strict";
Object.defineProperty($510ad3657d73a9d2$exports, "__esModule", {
    value: true
});
$510ad3657d73a9d2$exports.sha224 = $510ad3657d73a9d2$exports.sha256 = $510ad3657d73a9d2$exports.SHA256 = void 0;
var $dd17a2ee919821c7$exports = {};
"use strict";
Object.defineProperty($dd17a2ee919821c7$exports, "__esModule", {
    value: true
});
$dd17a2ee919821c7$exports.HashMD = $dd17a2ee919821c7$exports.Maj = $dd17a2ee919821c7$exports.Chi = void 0;
$dd17a2ee919821c7$exports.setBigUint64 = $dd17a2ee919821c7$var$setBigUint64;
var $a0ae23f5901291b4$exports = {};
"use strict";
/**
 * Assertion helpers
 * @module
 */ Object.defineProperty($a0ae23f5901291b4$exports, "__esModule", {
    value: true
});
$a0ae23f5901291b4$exports.anumber = $a0ae23f5901291b4$var$anumber;
$a0ae23f5901291b4$exports.abytes = $a0ae23f5901291b4$var$abytes;
$a0ae23f5901291b4$exports.ahash = $a0ae23f5901291b4$var$ahash;
$a0ae23f5901291b4$exports.aexists = $a0ae23f5901291b4$var$aexists;
$a0ae23f5901291b4$exports.aoutput = $a0ae23f5901291b4$var$aoutput;
function $a0ae23f5901291b4$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
// copied from utils
function $a0ae23f5901291b4$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $a0ae23f5901291b4$var$abytes(b, ...lengths) {
    if (!$a0ae23f5901291b4$var$isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
function $a0ae23f5901291b4$var$ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.wrapConstructor');
    $a0ae23f5901291b4$var$anumber(h.outputLen);
    $a0ae23f5901291b4$var$anumber(h.blockLen);
}
function $a0ae23f5901291b4$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $a0ae23f5901291b4$var$aoutput(out, instance) {
    $a0ae23f5901291b4$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}


var $29ee4d3171d9809b$exports = {};
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($29ee4d3171d9809b$exports, "__esModule", {
    value: true
});
$29ee4d3171d9809b$exports.Hash = $29ee4d3171d9809b$exports.nextTick = $29ee4d3171d9809b$exports.byteSwapIfBE = $29ee4d3171d9809b$exports.byteSwap = $29ee4d3171d9809b$exports.isLE = $29ee4d3171d9809b$exports.rotl = $29ee4d3171d9809b$exports.rotr = $29ee4d3171d9809b$exports.createView = $29ee4d3171d9809b$exports.u32 = $29ee4d3171d9809b$exports.u8 = void 0;
$29ee4d3171d9809b$exports.isBytes = $29ee4d3171d9809b$var$isBytes;
$29ee4d3171d9809b$exports.byteSwap32 = $29ee4d3171d9809b$var$byteSwap32;
$29ee4d3171d9809b$exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
$29ee4d3171d9809b$exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
$29ee4d3171d9809b$exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
$29ee4d3171d9809b$exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
$29ee4d3171d9809b$exports.toBytes = $29ee4d3171d9809b$var$toBytes;
$29ee4d3171d9809b$exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
$29ee4d3171d9809b$exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
$29ee4d3171d9809b$exports.wrapConstructor = $29ee4d3171d9809b$var$wrapConstructor;
$29ee4d3171d9809b$exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$wrapConstructorWithOpts;
$29ee4d3171d9809b$exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts;
$29ee4d3171d9809b$exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;
var $a20ad0ecd1be3cb3$exports = {};
"use strict";
Object.defineProperty($a20ad0ecd1be3cb3$exports, "__esModule", {
    value: true
});
$a20ad0ecd1be3cb3$exports.crypto = void 0;
$a20ad0ecd1be3cb3$exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;



// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $29ee4d3171d9809b$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
// Cast array to different type
const $29ee4d3171d9809b$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
$29ee4d3171d9809b$exports.u8 = $29ee4d3171d9809b$var$u8;
const $29ee4d3171d9809b$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
$29ee4d3171d9809b$exports.u32 = $29ee4d3171d9809b$var$u32;
// Cast array to view
const $29ee4d3171d9809b$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
$29ee4d3171d9809b$exports.createView = $29ee4d3171d9809b$var$createView;
/** The rotate right (circular right shift) operation for uint32 */ const $29ee4d3171d9809b$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
$29ee4d3171d9809b$exports.rotr = $29ee4d3171d9809b$var$rotr;
/** The rotate left (circular left shift) operation for uint32 */ const $29ee4d3171d9809b$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
$29ee4d3171d9809b$exports.rotl = $29ee4d3171d9809b$var$rotl;
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ $29ee4d3171d9809b$exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
// The byte swap operation for uint32
const $29ee4d3171d9809b$var$byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
$29ee4d3171d9809b$exports.byteSwap = $29ee4d3171d9809b$var$byteSwap;
/** Conditionally byte swap if on a big-endian platform */ $29ee4d3171d9809b$exports.byteSwapIfBE = $29ee4d3171d9809b$exports.isLE ? (n)=>n : (n)=>(0, $29ee4d3171d9809b$exports.byteSwap)(n);
/** In place byte swap for Uint32Array */ function $29ee4d3171d9809b$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = (0, $29ee4d3171d9809b$exports.byteSwap)(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $29ee4d3171d9809b$var$bytesToHex(bytes) {
    (0, $a0ae23f5901291b4$exports.abytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $29ee4d3171d9809b$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $29ee4d3171d9809b$var$asciiToBase16(ch) {
    if (ch >= $29ee4d3171d9809b$var$asciis._0 && ch <= $29ee4d3171d9809b$var$asciis._9) return ch - $29ee4d3171d9809b$var$asciis._0; // '2' => 50-48
    if (ch >= $29ee4d3171d9809b$var$asciis.A && ch <= $29ee4d3171d9809b$var$asciis.F) return ch - ($29ee4d3171d9809b$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $29ee4d3171d9809b$var$asciis.a && ch <= $29ee4d3171d9809b$var$asciis.f) return ch - ($29ee4d3171d9809b$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $29ee4d3171d9809b$var$nextTick = async ()=>{};
$29ee4d3171d9809b$exports.nextTick = $29ee4d3171d9809b$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, $29ee4d3171d9809b$exports.nextTick)();
        ts += diff;
    }
}
/**
 * Convert JS string to byte array.
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('utf8ToBytes expected string, got ' + typeof str);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === 'string') data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    (0, $a0ae23f5901291b4$exports.abytes)(data);
    return data;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $a0ae23f5901291b4$exports.abytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
// For runtime check if class implements interface
class $29ee4d3171d9809b$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
$29ee4d3171d9809b$exports.Hash = $29ee4d3171d9809b$var$Hash;
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('Options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $29ee4d3171d9809b$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $29ee4d3171d9809b$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($a20ad0ecd1be3cb3$exports.crypto && typeof $a20ad0ecd1be3cb3$exports.crypto.getRandomValues === 'function') return $a20ad0ecd1be3cb3$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ($a20ad0ecd1be3cb3$exports.crypto && typeof $a20ad0ecd1be3cb3$exports.crypto.randomBytes === 'function') return $a20ad0ecd1be3cb3$exports.crypto.randomBytes(bytesLength);
    throw new Error('crypto.getRandomValues must be defined');
}


/**
 * Merkle-Damgard hash utils.
 * @module
 */ /**
 * Polyfill for Safari 14
 */ function $dd17a2ee919821c7$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/**
 * Choice: a ? b : c
 */ const $dd17a2ee919821c7$var$Chi = (a, b, c)=>a & b ^ ~a & c;
$dd17a2ee919821c7$exports.Chi = $dd17a2ee919821c7$var$Chi;
/**
 * Majority function, true if any two inputs is true
 */ const $dd17a2ee919821c7$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
$dd17a2ee919821c7$exports.Maj = $dd17a2ee919821c7$var$Maj;
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class $dd17a2ee919821c7$var$HashMD extends $29ee4d3171d9809b$exports.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $29ee4d3171d9809b$exports.createView)(this.buffer);
    }
    update(data) {
        (0, $a0ae23f5901291b4$exports.aexists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $29ee4d3171d9809b$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $29ee4d3171d9809b$exports.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $a0ae23f5901291b4$exports.aexists)(this);
        (0, $a0ae23f5901291b4$exports.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $dd17a2ee919821c7$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $29ee4d3171d9809b$exports.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
$dd17a2ee919821c7$exports.HashMD = $dd17a2ee919821c7$var$HashMD;



/**
 * SHA2-256 a.k.a. sha256. In JS, it is the fastest hash, even faster than Blake3.
 *
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 *
 * Check out [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */ /** Round constants: first 32 bits of fractional parts of the cube roots of the first 64 primes 2..311). */ // prettier-ignore
const $510ad3657d73a9d2$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Initial state: first 32 bits of fractional parts of the square roots of the first 8 primes 2..19. */ // prettier-ignore
const $510ad3657d73a9d2$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/**
 * Temporary buffer, not used to store anything between runs.
 * Named this way because it matches specification.
 */ const $510ad3657d73a9d2$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $510ad3657d73a9d2$var$SHA256 extends $dd17a2ee919821c7$exports.HashMD {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $510ad3657d73a9d2$var$SHA256_IV[0] | 0;
        this.B = $510ad3657d73a9d2$var$SHA256_IV[1] | 0;
        this.C = $510ad3657d73a9d2$var$SHA256_IV[2] | 0;
        this.D = $510ad3657d73a9d2$var$SHA256_IV[3] | 0;
        this.E = $510ad3657d73a9d2$var$SHA256_IV[4] | 0;
        this.F = $510ad3657d73a9d2$var$SHA256_IV[5] | 0;
        this.G = $510ad3657d73a9d2$var$SHA256_IV[6] | 0;
        this.H = $510ad3657d73a9d2$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$510ad3657d73a9d2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $510ad3657d73a9d2$var$SHA256_W[i - 15];
            const W2 = $510ad3657d73a9d2$var$SHA256_W[i - 2];
            const s0 = (0, $29ee4d3171d9809b$exports.rotr)(W15, 7) ^ (0, $29ee4d3171d9809b$exports.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $29ee4d3171d9809b$exports.rotr)(W2, 17) ^ (0, $29ee4d3171d9809b$exports.rotr)(W2, 19) ^ W2 >>> 10;
            $510ad3657d73a9d2$var$SHA256_W[i] = s1 + $510ad3657d73a9d2$var$SHA256_W[i - 7] + s0 + $510ad3657d73a9d2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $29ee4d3171d9809b$exports.rotr)(E, 6) ^ (0, $29ee4d3171d9809b$exports.rotr)(E, 11) ^ (0, $29ee4d3171d9809b$exports.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $dd17a2ee919821c7$exports.Chi)(E, F, G) + $510ad3657d73a9d2$var$SHA256_K[i] + $510ad3657d73a9d2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $29ee4d3171d9809b$exports.rotr)(A, 2) ^ (0, $29ee4d3171d9809b$exports.rotr)(A, 13) ^ (0, $29ee4d3171d9809b$exports.rotr)(A, 22);
            const T2 = sigma0 + (0, $dd17a2ee919821c7$exports.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $510ad3657d73a9d2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
$510ad3657d73a9d2$exports.SHA256 = $510ad3657d73a9d2$var$SHA256;
/**
 * Constants taken from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf.
 */ class $510ad3657d73a9d2$var$SHA224 extends $510ad3657d73a9d2$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/** SHA2-256 hash function */ $510ad3657d73a9d2$exports.sha256 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA256());
/** SHA2-224 hash function */ $510ad3657d73a9d2$exports.sha224 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA224());


// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $19db9dcb179ed38a$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    const BASE_MAP = new Uint8Array(256);
    for(let j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(let i = 0; i < ALPHABET.length; i++){
        const x = ALPHABET.charAt(i);
        const xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    const BASE = ALPHABET.length;
    const LEADER = ALPHABET.charAt(0);
    const FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    const iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        // eslint-disable-next-line no-empty
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        let zeroes = 0;
        let length = 0;
        let pbegin = 0;
        const pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        const size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        const b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            let carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            let i = 0;
            for(let it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        let it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        let str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        let psz = 0;
        // Skip and count leading '1's.
        let zeroes = 0;
        let length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        const size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        const b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Find code of next character
            const charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            let carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            let i = 0;
            for(let it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        let it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        const vch = new Uint8Array(zeroes + (size - it4));
        let j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        const buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $19db9dcb179ed38a$export$2e2bcd8739ae039 = $19db9dcb179ed38a$var$base;


var $506427b07233fe62$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
var $506427b07233fe62$export$2e2bcd8739ae039 = (0, $19db9dcb179ed38a$export$2e2bcd8739ae039)($506427b07233fe62$var$ALPHABET);


'use strict';
function $1699e8e99ca29c86$export$2e2bcd8739ae039(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var payloadU8 = Uint8Array.from(payload);
        var checksum = checksumFn(payloadU8);
        var length = payloadU8.length + 4;
        var both = new Uint8Array(length);
        both.set(payloadU8, 0);
        both.set(checksum.subarray(0, 4), payloadU8.length);
        return (0, $506427b07233fe62$export$2e2bcd8739ae039).encode(both);
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        // eslint-disable-next-line
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(str) {
        var buffer = (0, $506427b07233fe62$export$2e2bcd8739ae039).decodeUnsafe(str);
        if (buffer == null) return;
        return decodeRaw(buffer);
    }
    function decode(str) {
        var buffer = (0, $506427b07233fe62$export$2e2bcd8739ae039).decode(str);
        var payload = decodeRaw(buffer);
        if (payload == null) throw new Error('Invalid checksum');
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
}


'use strict';
// SHA256(SHA256(buffer))
function $7e3a089a80d0b268$var$sha256x2(buffer) {
    return (0, $510ad3657d73a9d2$exports.sha256)((0, $510ad3657d73a9d2$exports.sha256)(buffer));
}
var $7e3a089a80d0b268$export$2e2bcd8739ae039 = (0, $1699e8e99ca29c86$export$2e2bcd8739ae039)($7e3a089a80d0b268$var$sha256x2);


// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
/**
 * Package nacl implements NaCl (Networking and Cryptography library) cryptography.
 */ // Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
// Copyright (C) 2024 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
const $470144fd408ed875$var$QUOTA = 65536;
class $470144fd408ed875$export$801f58a6448614ff {
    isAvailable = false;
    isInstantiated = false;
    constructor(){
        if (typeof crypto !== "undefined" && 'getRandomValues' in crypto) {
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $470144fd408ed875$var$QUOTA)crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $470144fd408ed875$var$QUOTA)));
        return out;
    }
}


// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
/**
 * Package binary provides functions for encoding and decoding numbers in byte arrays.
 */ // Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
/**
 * Package int provides helper functions for integerss.
 */ /** 32-bit integer multiplication.  */ const $51a3ca76628cc201$export$6e3a27864ab166fe = Math.imul;
function $51a3ca76628cc201$export$e16d8520af44a096(a, b) {
    return a + b | 0;
}
function $51a3ca76628cc201$export$f93b5905241a7cca(a, b) {
    return a - b | 0;
}
function $51a3ca76628cc201$export$ac5e39599698b562(x, n) {
    return x << n | x >>> 32 - n;
}
function $51a3ca76628cc201$export$466993d7d0d272aa(x, n) {
    return x << 32 - n | x >>> n;
}
const $51a3ca76628cc201$export$a287f47fed4544b8 = Number.isInteger;
const $51a3ca76628cc201$export$18510406f204a1b9 = Number.MAX_SAFE_INTEGER;
const $51a3ca76628cc201$export$77eb246723dd35ec = Number.isSafeInteger;


function $ddd89ca0ca71c6d3$export$a8d21fa09cac49e1(array, offset = 0) {
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
function $ddd89ca0ca71c6d3$export$ee84bedcd5802342(array, offset = 0) {
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
function $ddd89ca0ca71c6d3$export$2169276b99e5d684(array, offset = 0) {
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
function $ddd89ca0ca71c6d3$export$1a536f28abc8e70e(array, offset = 0) {
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
function $ddd89ca0ca71c6d3$export$68b8226ef83a2851(value, out = new Uint8Array(2), offset = 0) {
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
const $ddd89ca0ca71c6d3$export$df8c96684246161b = $ddd89ca0ca71c6d3$export$68b8226ef83a2851;
function $ddd89ca0ca71c6d3$export$1c1f6805bca8d2ca(value, out = new Uint8Array(2), offset = 0) {
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
const $ddd89ca0ca71c6d3$export$681db36914397e9d = $ddd89ca0ca71c6d3$export$1c1f6805bca8d2ca;
function $ddd89ca0ca71c6d3$export$89308d455f98d9(array, offset = 0) {
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
function $ddd89ca0ca71c6d3$export$affba09000bbdbfe(array, offset = 0) {
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
function $ddd89ca0ca71c6d3$export$41469b9fa4aaddde(array, offset = 0) {
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
function $ddd89ca0ca71c6d3$export$776ff71a86505abc(array, offset = 0) {
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
function $ddd89ca0ca71c6d3$export$4c09557cfb04670a(value, out = new Uint8Array(4), offset = 0) {
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
const $ddd89ca0ca71c6d3$export$e07d8a7f46eba301 = $ddd89ca0ca71c6d3$export$4c09557cfb04670a;
function $ddd89ca0ca71c6d3$export$2208c283270dd3a7(value, out = new Uint8Array(4), offset = 0) {
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
const $ddd89ca0ca71c6d3$export$71378937866c100a = $ddd89ca0ca71c6d3$export$2208c283270dd3a7;
function $ddd89ca0ca71c6d3$export$c82cff9554d15ce9(array, offset = 0) {
    const hi = $ddd89ca0ca71c6d3$export$89308d455f98d9(array, offset);
    const lo = $ddd89ca0ca71c6d3$export$89308d455f98d9(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
function $ddd89ca0ca71c6d3$export$8f11d79918d39530(array, offset = 0) {
    const hi = $ddd89ca0ca71c6d3$export$affba09000bbdbfe(array, offset);
    const lo = $ddd89ca0ca71c6d3$export$affba09000bbdbfe(array, offset + 4);
    return hi * 0x100000000 + lo;
}
function $ddd89ca0ca71c6d3$export$e9d44ca12492b789(array, offset = 0) {
    const lo = $ddd89ca0ca71c6d3$export$41469b9fa4aaddde(array, offset);
    const hi = $ddd89ca0ca71c6d3$export$41469b9fa4aaddde(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
function $ddd89ca0ca71c6d3$export$9a6c8a33602659a1(array, offset = 0) {
    const lo = $ddd89ca0ca71c6d3$export$776ff71a86505abc(array, offset);
    const hi = $ddd89ca0ca71c6d3$export$776ff71a86505abc(array, offset + 4);
    return hi * 0x100000000 + lo;
}
function $ddd89ca0ca71c6d3$export$aafa4256b178b12b(value, out = new Uint8Array(8), offset = 0) {
    $ddd89ca0ca71c6d3$export$4c09557cfb04670a(value / 0x100000000 >>> 0, out, offset);
    $ddd89ca0ca71c6d3$export$4c09557cfb04670a(value >>> 0, out, offset + 4);
    return out;
}
const $ddd89ca0ca71c6d3$export$a6ae475a7fcaa5e6 = $ddd89ca0ca71c6d3$export$aafa4256b178b12b;
function $ddd89ca0ca71c6d3$export$2610941fdadecd7c(value, out = new Uint8Array(8), offset = 0) {
    $ddd89ca0ca71c6d3$export$2208c283270dd3a7(value >>> 0, out, offset);
    $ddd89ca0ca71c6d3$export$2208c283270dd3a7(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
const $ddd89ca0ca71c6d3$export$23588794483f9460 = $ddd89ca0ca71c6d3$export$2610941fdadecd7c;
function $ddd89ca0ca71c6d3$export$bcbfc64893b65bf7(bitLength, array, offset = 0) {
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    let result = 0;
    let mul = 1;
    for(let i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
function $ddd89ca0ca71c6d3$export$632e43c0ae926603(bitLength, array, offset = 0) {
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    let result = 0;
    let mul = 1;
    for(let i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
function $ddd89ca0ca71c6d3$export$fd23e4d3d5826c82(bitLength, value, out = new Uint8Array(bitLength / 8), offset = 0) {
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!(0, $51a3ca76628cc201$export$77eb246723dd35ec)(value)) throw new Error("writeUintBE value must be an integer");
    let div = 1;
    for(let i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
function $ddd89ca0ca71c6d3$export$dd8f0100381f94a1(bitLength, value, out = new Uint8Array(bitLength / 8), offset = 0) {
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!(0, $51a3ca76628cc201$export$77eb246723dd35ec)(value)) throw new Error("writeUintLE value must be an integer");
    let div = 1;
    for(let i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
function $ddd89ca0ca71c6d3$export$a4b3f3cebb1e69fb(array, offset = 0) {
    const view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
function $ddd89ca0ca71c6d3$export$48d82bfe19c9f7d6(array, offset = 0) {
    const view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
function $ddd89ca0ca71c6d3$export$f6466632c349db39(array, offset = 0) {
    const view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
function $ddd89ca0ca71c6d3$export$5a9a145e1c1ec60d(array, offset = 0) {
    const view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
function $ddd89ca0ca71c6d3$export$913808077b318b21(value, out = new Uint8Array(4), offset = 0) {
    const view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
function $ddd89ca0ca71c6d3$export$34871e0169327cf4(value, out = new Uint8Array(4), offset = 0) {
    const view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
function $ddd89ca0ca71c6d3$export$9f73ed375c8d51d1(value, out = new Uint8Array(8), offset = 0) {
    const view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
function $ddd89ca0ca71c6d3$export$add31e9372359633(value, out = new Uint8Array(8), offset = 0) {
    const view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}


// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $276678191c4bdb56$export$46890c41d2ad591f(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(let i = 0; i < array.length; i++)array[i] = 0;
    return array;
}


const $73945d82524e104e$export$d01a91097f387409 = new (0, $470144fd408ed875$export$801f58a6448614ff)();
function $73945d82524e104e$export$5f828d93ff035aa8(length, prng = $73945d82524e104e$export$d01a91097f387409) {
    return prng.randomBytes(length);
}
function $73945d82524e104e$export$767c0c90c20fa51d(prng = $73945d82524e104e$export$d01a91097f387409) {
    // Generate 4-byte random buffer.
    const buf = $73945d82524e104e$export$5f828d93ff035aa8(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $ddd89ca0ca71c6d3$export$776ff71a86505abc)(buf);
    // Clean the buffer.
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(buf);
    return result;
}
/** 62 alphanumeric characters for default charset of randomString() */ const $73945d82524e104e$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
function $73945d82524e104e$export$7fa8378418b4411e(length, charset = $73945d82524e104e$var$ALPHANUMERIC, prng = $73945d82524e104e$export$d01a91097f387409) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = '';
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $73945d82524e104e$export$5f828d93ff035aa8(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(buf);
    }
    return out;
}
function $73945d82524e104e$export$52247520cdfa29c9(bits, charset = $73945d82524e104e$var$ALPHANUMERIC, prng = $73945d82524e104e$export$d01a91097f387409) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $73945d82524e104e$export$7fa8378418b4411e(length, charset, prng);
}



const $569072827d3d60aa$export$84fc0a248cc54343 = 32;
const $569072827d3d60aa$export$f2bd165db7344603 = 32;
const $569072827d3d60aa$export$8c9eeea810e9635e = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $569072827d3d60aa$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $569072827d3d60aa$var$_9 = new Uint8Array(32);
$569072827d3d60aa$var$_9[0] = 9;
const $569072827d3d60aa$var$_121665 = $569072827d3d60aa$var$gf([
    0xdb41,
    1
]);
function $569072827d3d60aa$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $569072827d3d60aa$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $569072827d3d60aa$var$pack25519(o, n) {
    const m = $569072827d3d60aa$var$gf();
    const t = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $569072827d3d60aa$var$car25519(t);
    $569072827d3d60aa$var$car25519(t);
    $569072827d3d60aa$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $569072827d3d60aa$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $569072827d3d60aa$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $569072827d3d60aa$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $569072827d3d60aa$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $569072827d3d60aa$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $569072827d3d60aa$var$square(o, a) {
    $569072827d3d60aa$var$mul(o, a, a);
}
function $569072827d3d60aa$var$inv25519(o, inp) {
    const c = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $569072827d3d60aa$var$square(c, c);
        if (i !== 2 && i !== 4) $569072827d3d60aa$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $569072827d3d60aa$export$444f0a6e47fe8a1f(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $569072827d3d60aa$var$gf(), b = $569072827d3d60aa$var$gf(), c = $569072827d3d60aa$var$gf(), d = $569072827d3d60aa$var$gf(), e = $569072827d3d60aa$var$gf(), f = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $569072827d3d60aa$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $569072827d3d60aa$var$sel25519(a, b, r);
        $569072827d3d60aa$var$sel25519(c, d, r);
        $569072827d3d60aa$var$add(e, a, c);
        $569072827d3d60aa$var$sub(a, a, c);
        $569072827d3d60aa$var$add(c, b, d);
        $569072827d3d60aa$var$sub(b, b, d);
        $569072827d3d60aa$var$square(d, e);
        $569072827d3d60aa$var$square(f, a);
        $569072827d3d60aa$var$mul(a, c, a);
        $569072827d3d60aa$var$mul(c, b, e);
        $569072827d3d60aa$var$add(e, a, c);
        $569072827d3d60aa$var$sub(a, a, c);
        $569072827d3d60aa$var$square(b, a);
        $569072827d3d60aa$var$sub(c, d, f);
        $569072827d3d60aa$var$mul(a, c, $569072827d3d60aa$var$_121665);
        $569072827d3d60aa$var$add(a, a, d);
        $569072827d3d60aa$var$mul(c, c, a);
        $569072827d3d60aa$var$mul(a, d, f);
        $569072827d3d60aa$var$mul(d, b, x);
        $569072827d3d60aa$var$square(b, e);
        $569072827d3d60aa$var$sel25519(a, b, r);
        $569072827d3d60aa$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $569072827d3d60aa$var$inv25519(x32, x32);
    $569072827d3d60aa$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $569072827d3d60aa$var$pack25519(q, x16);
    return q;
}
function $569072827d3d60aa$export$83da7ff789d91f8(n) {
    return $569072827d3d60aa$export$444f0a6e47fe8a1f(n, $569072827d3d60aa$var$_9);
}
function $569072827d3d60aa$export$b260aa5f705622f1(seed) {
    if (seed.length !== $569072827d3d60aa$export$f2bd165db7344603) throw new Error(`x25519: seed must be ${$569072827d3d60aa$export$f2bd165db7344603} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $569072827d3d60aa$export$83da7ff789d91f8(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
function $569072827d3d60aa$export$a949d36eab55b41f(prng) {
    const seed = (0, $73945d82524e104e$export$5f828d93ff035aa8)(32, prng);
    const result = $569072827d3d60aa$export$b260aa5f705622f1(seed);
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(seed);
    return result;
}
function $569072827d3d60aa$export$433046d8e52fa655(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== $569072827d3d60aa$export$84fc0a248cc54343) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== $569072827d3d60aa$export$84fc0a248cc54343) throw new Error("X25519: incorrect public key length");
    const result = $569072827d3d60aa$export$444f0a6e47fe8a1f(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}


// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
/**
 * Package xsalsa20 implements XSalsa20 stream cipher.
 */ 
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
/**
 * Package salsa20 implements Salsa20 stream cipher.
 */ 

// Number of Salsa20 rounds (Salsa20/20).
const $e5d66c94963f98c0$var$ROUNDS = 20;
/**
 * Applies the Salsa20 core function to 16-byte input,
 * 32-byte key key, and puts the result into 64-byte array out.
 */ function $e5d66c94963f98c0$var$core(out, input, key) {
    let j0 = 0x61707865; // "expa"
    let j1 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    let j2 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    let j3 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    let j4 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    let j5 = 0x3320646E; // "nd 3"
    let j6 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    let j7 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    let j8 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    let j9 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    let j10 = 0x79622D32; // "2-by"
    let j11 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    let j12 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    let j13 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    let j14 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    let j15 = 0x6B206574; // "te k"
    let x0 = j0;
    let x1 = j1;
    let x2 = j2;
    let x3 = j3;
    let x4 = j4;
    let x5 = j5;
    let x6 = j6;
    let x7 = j7;
    let x8 = j8;
    let x9 = j9;
    let x10 = j10;
    let x11 = j11;
    let x12 = j12;
    let x13 = j13;
    let x14 = j14;
    let x15 = j15;
    let u;
    for(let i = 0; i < $e5d66c94963f98c0$var$ROUNDS; i += 2){
        u = x0 + x12 | 0;
        x4 ^= u << 7 | u >>> 25;
        u = x4 + x0 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x4 | 0;
        x12 ^= u << 13 | u >>> 19;
        u = x12 + x8 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x1 | 0;
        x9 ^= u << 7 | u >>> 25;
        u = x9 + x5 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x9 | 0;
        x1 ^= u << 13 | u >>> 19;
        u = x1 + x13 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x6 | 0;
        x14 ^= u << 7 | u >>> 25;
        u = x14 + x10 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x14 | 0;
        x6 ^= u << 13 | u >>> 19;
        u = x6 + x2 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x11 | 0;
        x3 ^= u << 7 | u >>> 25;
        u = x3 + x15 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x3 | 0;
        x11 ^= u << 13 | u >>> 19;
        u = x11 + x7 | 0;
        x15 ^= u << 18 | u >>> 14;
        u = x0 + x3 | 0;
        x1 ^= u << 7 | u >>> 25;
        u = x1 + x0 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x1 | 0;
        x3 ^= u << 13 | u >>> 19;
        u = x3 + x2 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x4 | 0;
        x6 ^= u << 7 | u >>> 25;
        u = x6 + x5 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x6 | 0;
        x4 ^= u << 13 | u >>> 19;
        u = x4 + x7 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x9 | 0;
        x11 ^= u << 7 | u >>> 25;
        u = x11 + x10 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x11 | 0;
        x9 ^= u << 13 | u >>> 19;
        u = x9 + x8 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x14 | 0;
        x12 ^= u << 7 | u >>> 25;
        u = x12 + x15 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x12 | 0;
        x14 ^= u << 13 | u >>> 19;
        u = x14 + x13 | 0;
        x15 ^= u << 18 | u >>> 14;
    }
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x0 + j0 | 0, out, 0);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x1 + j1 | 0, out, 4);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x2 + j2 | 0, out, 8);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x3 + j3 | 0, out, 12);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x4 + j4 | 0, out, 16);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x5 + j5 | 0, out, 20);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x6 + j6 | 0, out, 24);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x7 + j7 | 0, out, 28);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x8 + j8 | 0, out, 32);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x9 + j9 | 0, out, 36);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x10 + j10 | 0, out, 40);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x11 + j11 | 0, out, 44);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x12 + j12 | 0, out, 48);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x13 + j13 | 0, out, 52);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x14 + j14 | 0, out, 56);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x15 + j15 | 0, out, 60);
}
function $e5d66c94963f98c0$export$cbd89e41b50010bd(key, nonce, src, dst, nonceInplaceCounterLength = 0) {
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("Salsa20: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("Salsa20: destination is shorter than source");
    let nc;
    let counterStart;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8) throw new Error("Salsa20 nonce must be 8 bytes");
        nc = new Uint8Array(16);
        // First bytes of nc are nonce, set it.
        nc.set(nonce);
        // Last bytes are counter.
        counterStart = nonce.length;
    } else {
        if (nonce.length !== 16) throw new Error("Salsa20 nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterStart = 16 - nonceInplaceCounterLength;
    }
    // Allocate temporary space for Salsa20 block.
    const block = new Uint8Array(64);
    for(let i = 0; i < src.length; i += 64){
        // Generate a block.
        $e5d66c94963f98c0$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(let j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $e5d66c94963f98c0$var$incrementCounter(nc, counterStart, nc.length - counterStart);
    }
    // Cleanup temporary space.
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(nc);
    return dst;
}
function $e5d66c94963f98c0$export$4938110305e6185f(key, nonce, dst, nonceInplaceCounterLength = 0) {
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(dst);
    return $e5d66c94963f98c0$export$cbd89e41b50010bd(key, nonce, dst, dst, nonceInplaceCounterLength);
}
function $e5d66c94963f98c0$var$incrementCounter(counter, pos, len) {
    let carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("Salsa20: counter overflow");
}



function $5daa362adb88524b$export$cbd89e41b50010bd(key, nonce, src, dst, nonceInplaceCounterLength = 0) {
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 24) throw new Error("XSalsa20 nonce must be 24 bytes");
    } else {
        if (nonce.length !== 32) throw new Error("XSalsa20 nonce with counter must be 32 bytes");
    }
    // Use HSalsa one-way function to transform first 16 bytes of
    // 24-byte extended nonce and key into a new key for Salsa
    // stream -- "subkey".
    const subkey = $5daa362adb88524b$export$d56d9ded526eca1b(key, nonce.subarray(0, 16), new Uint8Array(32));
    // Use last 8 bytes of 24-byte extended nonce as an actual nonce,
    // and a subkey derived in the previous step as key to encrypt.
    //
    // If nonceInplaceCounterLength > 0, we'll still pass the correct
    // nonce || counter, as we don't limit the end of nonce subarray.
    const result = (0, $e5d66c94963f98c0$export$cbd89e41b50010bd)(subkey, nonce.subarray(16), src, dst, nonceInplaceCounterLength);
    // Clean subkey.
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(subkey);
    return result;
}
function $5daa362adb88524b$export$4938110305e6185f(key, nonce, dst, nonceInplaceCounterLength = 0) {
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(dst);
    return $5daa362adb88524b$export$cbd89e41b50010bd(key, nonce, dst, dst, nonceInplaceCounterLength);
}
// Number of Salsa20 rounds (Salsa20/20).
const $5daa362adb88524b$var$ROUNDS = 20;
function $5daa362adb88524b$export$d56d9ded526eca1b(key, src, dst) {
    let x0 = 0x61707865; // "expa"
    let x1 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    let x2 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    let x3 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    let x4 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    let x5 = 0x3320646E; // "nd 3"
    let x6 = src[3] << 24 | src[2] << 16 | src[1] << 8 | src[0];
    let x7 = src[7] << 24 | src[6] << 16 | src[5] << 8 | src[4];
    let x8 = src[11] << 24 | src[10] << 16 | src[9] << 8 | src[8];
    let x9 = src[15] << 24 | src[14] << 16 | src[13] << 8 | src[12];
    let x10 = 0x79622D32; // "2-by"
    let x11 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    let x12 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    let x13 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    let x14 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    let x15 = 0x6B206574; // "te k"
    let u;
    for(let i = 0; i < $5daa362adb88524b$var$ROUNDS; i += 2){
        u = x0 + x12 | 0;
        x4 ^= u << 7 | u >>> 25;
        u = x4 + x0 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x4 | 0;
        x12 ^= u << 13 | u >>> 19;
        u = x12 + x8 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x1 | 0;
        x9 ^= u << 7 | u >>> 25;
        u = x9 + x5 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x9 | 0;
        x1 ^= u << 13 | u >>> 19;
        u = x1 + x13 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x6 | 0;
        x14 ^= u << 7 | u >>> 25;
        u = x14 + x10 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x14 | 0;
        x6 ^= u << 13 | u >>> 19;
        u = x6 + x2 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x11 | 0;
        x3 ^= u << 7 | u >>> 25;
        u = x3 + x15 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x3 | 0;
        x11 ^= u << 13 | u >>> 19;
        u = x11 + x7 | 0;
        x15 ^= u << 18 | u >>> 14;
        u = x0 + x3 | 0;
        x1 ^= u << 7 | u >>> 25;
        u = x1 + x0 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x1 | 0;
        x3 ^= u << 13 | u >>> 19;
        u = x3 + x2 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x4 | 0;
        x6 ^= u << 7 | u >>> 25;
        u = x6 + x5 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x6 | 0;
        x4 ^= u << 13 | u >>> 19;
        u = x4 + x7 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x9 | 0;
        x11 ^= u << 7 | u >>> 25;
        u = x11 + x10 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x11 | 0;
        x9 ^= u << 13 | u >>> 19;
        u = x9 + x8 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x14 | 0;
        x12 ^= u << 7 | u >>> 25;
        u = x12 + x15 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x12 | 0;
        x14 ^= u << 13 | u >>> 19;
        u = x14 + x13 | 0;
        x15 ^= u << 18 | u >>> 14;
    }
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x0, dst, 0);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x5, dst, 4);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x10, dst, 8);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x15, dst, 12);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x6, dst, 16);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x7, dst, 20);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x8, dst, 24);
    (0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(x9, dst, 28);
    return dst;
}


// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
/**
 * Package poly1305 implements Poly1305 one-time message authentication algorithm.
 */ // Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $0806512cf7f87b87$export$2e6c959c16ff56b8(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
function $0806512cf7f87b87$export$2d9f5260eb7bfc8b(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
function $0806512cf7f87b87$export$398604a469f7de9a(a, b) {
    if (a.length !== b.length) return 0;
    let result = 0;
    for(let i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
function $0806512cf7f87b87$export$411ce8e5a71e3069(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $0806512cf7f87b87$export$398604a469f7de9a(a, b) !== 0;
}



const $bc2eb21e5dd3f530$export$d7bd469488748c5f = 16;
class $bc2eb21e5dd3f530$export$c048faf97da45308 {
    digestLength = $bc2eb21e5dd3f530$export$d7bd469488748c5f;
    _buffer = new Uint8Array(16);
    _r = new Uint16Array(10);
    _h = new Uint16Array(10);
    _pad = new Uint16Array(8);
    _leftover = 0;
    _fin = 0;
    _finished = false;
    constructor(key){
        let t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        let t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        let t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        let t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        let t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        let t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        let t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        let t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    _blocks(m, mpos, bytes) {
        let hibit = this._fin ? 0 : 2048;
        let h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        let r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            let t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            let t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            let t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            let t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            let t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            let t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            let t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            let t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            let c = 0;
            let d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            let d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            let d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            let d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            let d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            let d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            let d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            let d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            let d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            let d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    }
    finish(mac, macpos = 0) {
        const g = new Uint16Array(10);
        let c;
        let mask;
        let f;
        let i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    }
    update(m) {
        let mpos = 0;
        let bytes = m.length;
        let want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(let i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(let i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    }
    digest() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        let mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    }
    clean() {
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._buffer);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._r);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._h);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    }
}
function $bc2eb21e5dd3f530$export$795e603cdbc02162(key, data) {
    const h = new $bc2eb21e5dd3f530$export$c048faf97da45308(key);
    h.update(data);
    const digest = h.digest();
    h.clean();
    return digest;
}
function $bc2eb21e5dd3f530$export$411ce8e5a71e3069(a, b) {
    if (a.length !== $bc2eb21e5dd3f530$export$d7bd469488748c5f || b.length !== $bc2eb21e5dd3f530$export$d7bd469488748c5f) return false;
    return (0, $0806512cf7f87b87$export$411ce8e5a71e3069)(a, b);
}




function $fb057964aa786cfd$export$73678ee8284bdb61(key, nonce, data) {
    if (nonce.length !== 24) throw new Error("secretBox nonce must be 24 bytes");
    const firstBlock = new Uint8Array(64);
    // Allocate place for nonce and counter.
    const nonceCounter = new Uint8Array(32);
    // Set first bytes to nonce. Last 8 bytes will be counter.
    nonceCounter.set(nonce);
    // Generate first block of XSalsa20 stream, of which
    // first 32 bytes will be authentication key, and the rest
    // will be used for encryption.
    (0, $5daa362adb88524b$export$4938110305e6185f)(key, nonceCounter, firstBlock, 8);
    // Allocate result, which will contain 16-byte authenticator
    // concatenated with ciphertext.
    const result = new Uint8Array(16 + data.length);
    // Encrypt first 32 bytes of data with last 32 bytes of generated stream.
    for(let i = 0; i < 32 && i < data.length; i++)result[16 + i] = data[i] ^ firstBlock[32 + i];
    // Encrypt the rest of data.
    if (data.length > 32) (0, $5daa362adb88524b$export$cbd89e41b50010bd)(key, nonceCounter, data.subarray(32), result.subarray(48), 8);
    // Calculate Poly1305 authenticator of encrypted data using
    // authentication key in the first block of XSalsa20 stream.
    const auth = (0, $bc2eb21e5dd3f530$export$795e603cdbc02162)(firstBlock.subarray(0, 32), result.subarray(16));
    // Copy authenticator to the beginning of result.
    for(let i = 0; i < auth.length; i++)result[i] = auth[i];
    // Clean auth.
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(auth);
    // Clean first block.
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(firstBlock);
    // Clean nonceCounter.
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(nonceCounter);
    return result;
}
function $fb057964aa786cfd$export$2c221cd9fce4f342(key, nonce, box) {
    if (nonce.length !== 24) throw new Error("secretBox nonce must be 24 bytes");
    if (box.length < 16) throw new Error("secretBox data must be at least 16 bytes");
    const firstBlock = new Uint8Array(64);
    // Allocate place for nonce and counter.
    const nonceCounter = new Uint8Array(32);
    // Set first bytes to nonce. Last 8 bytes will be counter.
    nonceCounter.set(nonce);
    // Generate first block of XSalsa20 stream, of which
    // first 32 bytes will be authentication key, and the rest
    // will be used for encryption.
    (0, $5daa362adb88524b$export$4938110305e6185f)(key, nonceCounter, firstBlock, 8);
    // Calculate Poly1305 authenticator of encrypted data using
    // authentication key in the first block of XSalsa20 stream.
    const auth = (0, $bc2eb21e5dd3f530$export$795e603cdbc02162)(firstBlock.subarray(0, 32), box.subarray(16));
    // Check authenticator.
    if (!(0, $bc2eb21e5dd3f530$export$411ce8e5a71e3069)(auth, box.subarray(0, 16))) // Authenticator is incorrect: ciphertext or authenticator
    // was corrupted, maybe maliciously.
    return null;
    // Authenticator verifies, so we can decrypt ciphertext.
    const ciphertext = box.subarray(16);
    // Allocate result array.
    const result = new Uint8Array(ciphertext.length);
    // Decrypt first 32 bytes of box with last 32 bytes of generated stream.
    for(let i = 0; i < 32 && i < ciphertext.length; i++)result[i] = ciphertext[i] ^ firstBlock[32 + i];
    // Decrypt the rest of data.
    if (ciphertext.length > 32) (0, $5daa362adb88524b$export$cbd89e41b50010bd)(key, nonceCounter, ciphertext.subarray(32), result.subarray(32), 8);
    // Clean auth.
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(auth);
    // Clean first block.
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(firstBlock);
    // Clean nonceCounter.
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(nonceCounter);
    return result;
}
function $fb057964aa786cfd$export$3a7728e868aa3ebd(prng) {
    return (0, $73945d82524e104e$export$5f828d93ff035aa8)(32, prng);
}



const $8e5ffcb91c156513$var$zeros16 = new Uint8Array(16);
function $8e5ffcb91c156513$export$98370c91f25cb8a0(theirPublicKey, mySecretKey) {
    // Compute scalar multiplication result.
    const key = (0, $569072827d3d60aa$export$444f0a6e47fe8a1f)(mySecretKey, theirPublicKey);
    // Hash key with HSalsa function.
    (0, $5daa362adb88524b$export$d56d9ded526eca1b)(key, $8e5ffcb91c156513$var$zeros16, key);
    return key;
}
function $8e5ffcb91c156513$export$827f4ee28efc37(theirPublicKey, mySecretKey, nonce, data) {
    const sharedKey = $8e5ffcb91c156513$export$98370c91f25cb8a0(theirPublicKey, mySecretKey);
    const result = (0, $fb057964aa786cfd$export$73678ee8284bdb61)(sharedKey, nonce, data);
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(sharedKey);
    return result;
}
function $8e5ffcb91c156513$export$ada26e8482d44de1(theirPublicKey, mySecretKey, nonce, data) {
    const sharedKey = $8e5ffcb91c156513$export$98370c91f25cb8a0(theirPublicKey, mySecretKey);
    const result = (0, $fb057964aa786cfd$export$2c221cd9fce4f342)(sharedKey, nonce, data);
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(sharedKey);
    return result;
}






// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
/**
 * Package utf8 implements UTF-8 encoding and decoding.
 */ const $9a00e3fafffa883b$var$INVALID_UTF16 = "utf8: invalid string";
const $9a00e3fafffa883b$var$INVALID_UTF8 = "utf8: invalid source encoding";
function $9a00e3fafffa883b$export$c564cdbbe6da493(s) {
    // Calculate result length and allocate output array.
    // encodedLength() validates string and throws errors,
    // so we don't need repeat validation here.
    const arr = new Uint8Array($9a00e3fafffa883b$export$721e9895fd4c3020(s));
    let pos = 0;
    for(let i = 0; i < s.length; i++){
        let c = s.charCodeAt(i);
        if (c >= 0xd800 && c <= 0xdbff) c = (c - 0xd800 << 10) + (s.charCodeAt(++i) - 0xdc00) + 0x10000;
        if (c < 0x80) arr[pos++] = c;
        else if (c < 0x800) {
            arr[pos++] = 0xc0 | c >> 6;
            arr[pos++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            arr[pos++] = 0xe0 | c >> 12;
            arr[pos++] = 0x80 | c >> 6 & 0x3f;
            arr[pos++] = 0x80 | c & 0x3f;
        } else {
            arr[pos++] = 0xf0 | c >> 18;
            arr[pos++] = 0x80 | c >> 12 & 0x3f;
            arr[pos++] = 0x80 | c >> 6 & 0x3f;
            arr[pos++] = 0x80 | c & 0x3f;
        }
    }
    return arr;
}
function $9a00e3fafffa883b$export$721e9895fd4c3020(s) {
    let result = 0;
    for(let i = 0; i < s.length; i++){
        let c = s.charCodeAt(i);
        if (c >= 0xd800 && c <= 0xdbff) {
            // surrogate pair
            if (i === s.length - 1) throw new Error($9a00e3fafffa883b$var$INVALID_UTF16);
            i++;
            const c2 = s.charCodeAt(i);
            if (c2 < 0xdc00 || c2 > 0xdfff) throw new Error($9a00e3fafffa883b$var$INVALID_UTF16);
            c = (c - 0xd800 << 10) + (c2 - 0xdc00) + 0x10000;
        }
        if (c < 0x80) result += 1;
        else if (c < 0x800) result += 2;
        else if (c < 0x10000) result += 3;
        else result += 4;
    }
    return result;
}
function $9a00e3fafffa883b$export$2f872c0f2117be69(arr) {
    const chars = [];
    for(let i = 0; i < arr.length; i++){
        let b = arr[i];
        if (b & 0x80) {
            let min;
            if (b < 0xe0) {
                // Need 1 more byte.
                if (i >= arr.length) throw new Error($9a00e3fafffa883b$var$INVALID_UTF8);
                const n1 = arr[++i];
                if ((n1 & 0xc0) !== 0x80) throw new Error($9a00e3fafffa883b$var$INVALID_UTF8);
                b = (b & 0x1f) << 6 | n1 & 0x3f;
                min = 0x80;
            } else if (b < 0xf0) {
                // Need 2 more bytes.
                if (i >= arr.length - 1) throw new Error($9a00e3fafffa883b$var$INVALID_UTF8);
                const n1 = arr[++i];
                const n2 = arr[++i];
                if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80) throw new Error($9a00e3fafffa883b$var$INVALID_UTF8);
                b = (b & 0x0f) << 12 | (n1 & 0x3f) << 6 | n2 & 0x3f;
                min = 0x800;
            } else if (b < 0xf8) {
                // Need 3 more bytes.
                if (i >= arr.length - 2) throw new Error($9a00e3fafffa883b$var$INVALID_UTF8);
                const n1 = arr[++i];
                const n2 = arr[++i];
                const n3 = arr[++i];
                if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80 || (n3 & 0xc0) !== 0x80) throw new Error($9a00e3fafffa883b$var$INVALID_UTF8);
                b = (b & 0x0f) << 18 | (n1 & 0x3f) << 12 | (n2 & 0x3f) << 6 | n3 & 0x3f;
                min = 0x10000;
            } else throw new Error($9a00e3fafffa883b$var$INVALID_UTF8);
            if (b < min || b >= 0xd800 && b <= 0xdfff) throw new Error($9a00e3fafffa883b$var$INVALID_UTF8);
            if (b >= 0x10000) {
                // Surrogate pair.
                if (b > 0x10ffff) throw new Error($9a00e3fafffa883b$var$INVALID_UTF8);
                b -= 0x10000;
                chars.push(String.fromCharCode(0xd800 | b >> 10));
                b = 0xdc00 | b & 0x3ff;
            }
        }
        chars.push(String.fromCharCode(b));
    }
    return chars.join("");
}


// Copyright (C) 2017 Dmitry Chestnykh
// MIT License. See LICENSE file for details.


const $b245bb78b1cc020b$export$b2e3d6d444266a5c = 128;
const $b245bb78b1cc020b$export$d7bd469488748c5f = 64;
const $b245bb78b1cc020b$export$ff7f6eaed58f6467 = 64;
const $b245bb78b1cc020b$export$85cd107033603d6 = 16;
const $b245bb78b1cc020b$export$2ddcd3a55c33bcaa = 16;
const $b245bb78b1cc020b$export$8b38ac26a6a6838f = Math.pow(2, 32) - 1;
const $b245bb78b1cc020b$export$19d92e43dc222637 = 255;
const $b245bb78b1cc020b$export$eb4bda5116506bd2 = 255; // not a typo
const $b245bb78b1cc020b$var$IV = new Uint32Array([
    // low bits // high bits
    0xf3bcc908,
    0x6a09e667,
    0x84caa73b,
    0xbb67ae85,
    0xfe94f82b,
    0x3c6ef372,
    0x5f1d36f1,
    0xa54ff53a,
    0xade682d1,
    0x510e527f,
    0x2b3e6c1f,
    0x9b05688c,
    0xfb41bd6b,
    0x1f83d9ab,
    0x137e2179,
    0x5be0cd19
]);
// Note: sigma values are doubled since we store
// 64-bit ints as two 32-bit ints in arrays.
const $b245bb78b1cc020b$var$SIGMA = [
    [
        0,
        2,
        4,
        6,
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30
    ],
    [
        28,
        20,
        8,
        16,
        18,
        30,
        26,
        12,
        2,
        24,
        0,
        4,
        22,
        14,
        10,
        6
    ],
    [
        22,
        16,
        24,
        0,
        10,
        4,
        30,
        26,
        20,
        28,
        6,
        12,
        14,
        2,
        18,
        8
    ],
    [
        14,
        18,
        6,
        2,
        26,
        24,
        22,
        28,
        4,
        12,
        10,
        20,
        8,
        0,
        30,
        16
    ],
    [
        18,
        0,
        10,
        14,
        4,
        8,
        20,
        30,
        28,
        2,
        22,
        24,
        12,
        16,
        6,
        26
    ],
    [
        4,
        24,
        12,
        20,
        0,
        22,
        16,
        6,
        8,
        26,
        14,
        10,
        30,
        28,
        2,
        18
    ],
    [
        24,
        10,
        2,
        30,
        28,
        26,
        8,
        20,
        0,
        14,
        12,
        6,
        18,
        4,
        16,
        22
    ],
    [
        26,
        22,
        14,
        28,
        24,
        2,
        6,
        18,
        10,
        0,
        30,
        8,
        16,
        12,
        4,
        20
    ],
    [
        12,
        30,
        28,
        18,
        22,
        6,
        0,
        16,
        24,
        4,
        26,
        14,
        2,
        8,
        20,
        10
    ],
    [
        20,
        4,
        16,
        8,
        14,
        12,
        2,
        10,
        30,
        22,
        18,
        28,
        6,
        24,
        26,
        0
    ],
    [
        0,
        2,
        4,
        6,
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30
    ],
    [
        28,
        20,
        8,
        16,
        18,
        30,
        26,
        12,
        2,
        24,
        0,
        4,
        22,
        14,
        10,
        6
    ]
];
class $b245bb78b1cc020b$export$5ad32252b3508605 {
    digestLength;
    blockSize = $b245bb78b1cc020b$export$b2e3d6d444266a5c;
    // Note: Int32Arrays for state and message are used for performance reasons.
    _state = new Int32Array($b245bb78b1cc020b$var$IV);
    _buffer = new Uint8Array($b245bb78b1cc020b$export$b2e3d6d444266a5c);
    _bufferLength = 0;
    _ctr = new Uint32Array(4);
    _flag = new Uint32Array(4);
    _lastNode = false;
    _finished = false;
    _vtmp = new Uint32Array(32);
    _mtmp = new Uint32Array(32);
    _paddedKey;
    _initialState;
    constructor(digestLength = 64, config){
        this.digestLength = digestLength;
        // Validate digest length.
        if (digestLength < 1 || digestLength > $b245bb78b1cc020b$export$d7bd469488748c5f) throw new Error("blake2b: wrong digest length");
        // Validate config, if present.
        if (config) this.validateConfig(config);
        // Get key length from config.
        let keyLength = 0;
        if (config && config.key) keyLength = config.key.length;
        // Get tree fanout and maxDepth from config.
        let fanout = 1;
        let maxDepth = 1;
        if (config && config.tree) {
            fanout = config.tree.fanout;
            maxDepth = config.tree.maxDepth;
        }
        // Xor common parameters into state.
        this._state[0] ^= digestLength | keyLength << 8 | fanout << 16 | maxDepth << 24;
        // Xor tree parameters into state.
        if (config && config.tree) {
            this._state[1] ^= config.tree.leafSize;
            this._state[2] ^= config.tree.nodeOffsetLowBits;
            this._state[3] ^= config.tree.nodeOffsetHighBits;
            this._state[4] ^= config.tree.nodeDepth | config.tree.innerDigestLength << 8;
            this._lastNode = config.tree.lastNode;
        }
        // Xor salt into state.
        if (config && config.salt) {
            this._state[8] ^= (0, $ddd89ca0ca71c6d3$export$776ff71a86505abc)(config.salt, 0);
            this._state[9] ^= (0, $ddd89ca0ca71c6d3$export$776ff71a86505abc)(config.salt, 4);
            this._state[10] ^= (0, $ddd89ca0ca71c6d3$export$776ff71a86505abc)(config.salt, 8);
            this._state[11] ^= (0, $ddd89ca0ca71c6d3$export$776ff71a86505abc)(config.salt, 12);
        }
        // Xor personalization into state.
        if (config && config.personalization) {
            this._state[12] ^= (0, $ddd89ca0ca71c6d3$export$776ff71a86505abc)(config.personalization, 0);
            this._state[13] ^= (0, $ddd89ca0ca71c6d3$export$776ff71a86505abc)(config.personalization, 4);
            this._state[14] ^= (0, $ddd89ca0ca71c6d3$export$776ff71a86505abc)(config.personalization, 8);
            this._state[15] ^= (0, $ddd89ca0ca71c6d3$export$776ff71a86505abc)(config.personalization, 12);
        }
        // Save a copy of initialized state for reset.
        this._initialState = new Uint32Array(this._state);
        // Process key.
        if (config && config.key && keyLength > 0) {
            this._paddedKey = new Uint8Array($b245bb78b1cc020b$export$b2e3d6d444266a5c);
            this._paddedKey.set(config.key);
            // Put padded key into buffer.
            this._buffer.set(this._paddedKey);
            this._bufferLength = $b245bb78b1cc020b$export$b2e3d6d444266a5c;
        }
    }
    reset() {
        // Restore initial state.
        this._state.set(this._initialState);
        if (this._paddedKey) {
            // Put padded key into buffer.
            this._buffer.set(this._paddedKey);
            this._bufferLength = $b245bb78b1cc020b$export$b2e3d6d444266a5c;
        } else this._bufferLength = 0;
        // Clear counters and flags.
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._ctr);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._flag);
        this._finished = false;
        return this;
    }
    validateConfig(config) {
        if (config.key && config.key.length > $b245bb78b1cc020b$export$ff7f6eaed58f6467) throw new Error("blake2b: wrong key length");
        if (config.salt && config.salt.length !== $b245bb78b1cc020b$export$2ddcd3a55c33bcaa) throw new Error("blake2b: wrong salt length");
        if (config.personalization && config.personalization.length !== $b245bb78b1cc020b$export$85cd107033603d6) throw new Error("blake2b: wrong personalization length");
        if (config.tree) {
            if (config.tree.fanout < 0 || config.tree.fanout > $b245bb78b1cc020b$export$19d92e43dc222637) throw new Error("blake2b: wrong tree fanout");
            if (config.tree.maxDepth < 0 || config.tree.maxDepth > $b245bb78b1cc020b$export$eb4bda5116506bd2) throw new Error("blake2b: wrong tree depth");
            if (config.tree.leafSize < 0 || config.tree.leafSize > $b245bb78b1cc020b$export$8b38ac26a6a6838f) throw new Error("blake2b: wrong leaf size");
            if (config.tree.innerDigestLength < 0 || config.tree.innerDigestLength > $b245bb78b1cc020b$export$d7bd469488748c5f) throw new Error("blake2b: wrong tree inner digest length");
        }
    }
    update(data, dataLength = data.length) {
        if (this._finished) throw new Error("blake2b: can't update because hash was finished.");
        const left = $b245bb78b1cc020b$export$b2e3d6d444266a5c - this._bufferLength;
        let dataPos = 0;
        if (dataLength === 0) return this;
        // Finish buffer.
        if (dataLength > left) {
            for(let i = 0; i < left; i++)this._buffer[this._bufferLength + i] = data[dataPos + i];
            this._processBlock($b245bb78b1cc020b$export$b2e3d6d444266a5c);
            dataPos += left;
            dataLength -= left;
            this._bufferLength = 0;
        }
        // Process data blocks.
        while(dataLength > $b245bb78b1cc020b$export$b2e3d6d444266a5c){
            for(let i = 0; i < $b245bb78b1cc020b$export$b2e3d6d444266a5c; i++)this._buffer[i] = data[dataPos + i];
            this._processBlock($b245bb78b1cc020b$export$b2e3d6d444266a5c);
            dataPos += $b245bb78b1cc020b$export$b2e3d6d444266a5c;
            dataLength -= $b245bb78b1cc020b$export$b2e3d6d444266a5c;
            this._bufferLength = 0;
        }
        // Copy leftovers to buffer.
        for(let i = 0; i < dataLength; i++)this._buffer[this._bufferLength + i] = data[dataPos + i];
        this._bufferLength += dataLength;
        return this;
    }
    finish(out) {
        if (!this._finished) {
            for(let i = this._bufferLength; i < $b245bb78b1cc020b$export$b2e3d6d444266a5c; i++)this._buffer[i] = 0;
            // Set last block flag.
            this._flag[0] = 0xffffffff;
            this._flag[1] = 0xffffffff;
            // Set last node flag if last node in tree.
            if (this._lastNode) {
                this._flag[2] = 0xffffffff;
                this._flag[3] = 0xffffffff;
            }
            this._processBlock(this._bufferLength);
            this._finished = true;
        }
        // Reuse buffer as temporary space for digest.
        const tmp = this._buffer.subarray(0, 64);
        for(let i = 0; i < 16; i++)(0, $ddd89ca0ca71c6d3$export$2208c283270dd3a7)(this._state[i], tmp, i * 4);
        out.set(tmp.subarray(0, out.length));
        return this;
    }
    digest() {
        const out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    }
    clean() {
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._vtmp);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._mtmp);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._state);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._buffer);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._initialState);
        if (this._paddedKey) (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._paddedKey);
        this._bufferLength = 0;
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._ctr);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._flag);
        this._lastNode = false;
        this._finished = false;
    }
    saveState() {
        if (this._finished) throw new Error("blake2b: cannot save finished state");
        return {
            state: new Uint32Array(this._state),
            buffer: new Uint8Array(this._buffer),
            bufferLength: this._bufferLength,
            ctr: new Uint32Array(this._ctr),
            flag: new Uint32Array(this._flag),
            lastNode: this._lastNode,
            paddedKey: this._paddedKey ? new Uint8Array(this._paddedKey) : undefined,
            initialState: new Uint32Array(this._initialState)
        };
    }
    restoreState(savedState) {
        this._state.set(savedState.state);
        this._buffer.set(savedState.buffer);
        this._bufferLength = savedState.bufferLength;
        this._ctr.set(savedState.ctr);
        this._flag.set(savedState.flag);
        this._lastNode = savedState.lastNode;
        if (this._paddedKey) (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._paddedKey);
        this._paddedKey = savedState.paddedKey ? new Uint8Array(savedState.paddedKey) : undefined;
        this._initialState.set(savedState.initialState);
        return this;
    }
    cleanSavedState(savedState) {
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(savedState.state);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(savedState.buffer);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(savedState.initialState);
        if (savedState.paddedKey) (0, $276678191c4bdb56$export$46890c41d2ad591f)(savedState.paddedKey);
        savedState.bufferLength = 0;
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(savedState.ctr);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(savedState.flag);
        savedState.lastNode = false;
    }
    _G(v, al, bl, cl, dl, ah, bh, ch, dh, ml0, mh0, ml1, mh1) {
        let vla = v[al], vha = v[ah], vlb = v[bl], vhb = v[bh], vlc = v[cl], vhc = v[ch], vld = v[dl], vhd = v[dh];
        // 64-bit: va += vb
        let w = vla & 0xffff, x = vla >>> 16, y = vha & 0xffff, z = vha >>> 16;
        w += vlb & 0xffff;
        x += vlb >>> 16;
        y += vhb & 0xffff;
        z += vhb >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: va += m[sigma[r][2 * i + 0]]
        w = vla & 0xffff;
        x = vla >>> 16;
        y = vha & 0xffff;
        z = vha >>> 16;
        w += ml0 & 0xffff;
        x += ml0 >>> 16;
        y += mh0 & 0xffff;
        z += mh0 >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: vd ^= va
        vld ^= vla;
        vhd ^= vha;
        // 64-bit: rot(vd, 32)
        w = vhd;
        vhd = vld;
        vld = w;
        // 64-bit: vc += vd
        w = vlc & 0xffff;
        x = vlc >>> 16;
        y = vhc & 0xffff;
        z = vhc >>> 16;
        w += vld & 0xffff;
        x += vld >>> 16;
        y += vhd & 0xffff;
        z += vhd >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vhc = y & 0xffff | z << 16;
        vlc = w & 0xffff | x << 16;
        // 64-bit: vb ^= vc
        vlb ^= vlc;
        vhb ^= vhc;
        // 64-bit: rot(vb, 24)
        w = vlb << 8 | vhb >>> 24;
        vlb = vhb << 8 | vlb >>> 24;
        vhb = w;
        // 64-bit: va += vb
        w = vla & 0xffff;
        x = vla >>> 16;
        y = vha & 0xffff;
        z = vha >>> 16;
        w += vlb & 0xffff;
        x += vlb >>> 16;
        y += vhb & 0xffff;
        z += vhb >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: va += m[sigma[r][2 * i + 1]
        w = vla & 0xffff;
        x = vla >>> 16;
        y = vha & 0xffff;
        z = vha >>> 16;
        w += ml1 & 0xffff;
        x += ml1 >>> 16;
        y += mh1 & 0xffff;
        z += mh1 >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: vd ^= va
        vld ^= vla;
        vhd ^= vha;
        // 64-bit: rot(vd, 16)
        w = vld << 16 | vhd >>> 16;
        vld = vhd << 16 | vld >>> 16;
        vhd = w;
        // 64-bit: vc += vd
        w = vlc & 0xffff;
        x = vlc >>> 16;
        y = vhc & 0xffff;
        z = vhc >>> 16;
        w += vld & 0xffff;
        x += vld >>> 16;
        y += vhd & 0xffff;
        z += vhd >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vhc = y & 0xffff | z << 16;
        vlc = w & 0xffff | x << 16;
        // 64-bit: vb ^= vc
        vlb ^= vlc;
        vhb ^= vhc;
        // 64-bit: rot(vb, 63)
        w = vhb << 1 | vlb >>> 31;
        vlb = vlb << 1 | vhb >>> 31;
        vhb = w;
        v[al] = vla;
        v[ah] = vha;
        v[bl] = vlb;
        v[bh] = vhb;
        v[cl] = vlc;
        v[ch] = vhc;
        v[dl] = vld;
        v[dh] = vhd;
    }
    _incrementCounter(n) {
        for(let i = 0; i < 3; i++){
            let a = this._ctr[i] + n;
            this._ctr[i] = a >>> 0;
            if (this._ctr[i] === a) return;
            n = 1;
        }
    }
    _processBlock(length) {
        this._incrementCounter(length);
        let v = this._vtmp;
        v.set(this._state);
        v.set($b245bb78b1cc020b$var$IV, 16);
        v[24] ^= this._ctr[0];
        v[25] ^= this._ctr[1];
        v[26] ^= this._ctr[2];
        v[27] ^= this._ctr[3];
        v[28] ^= this._flag[0];
        v[29] ^= this._flag[1];
        v[30] ^= this._flag[2];
        v[31] ^= this._flag[3];
        let m = this._mtmp;
        for(let i = 0; i < 32; i++)m[i] = (0, $ddd89ca0ca71c6d3$export$776ff71a86505abc)(this._buffer, i * 4);
        for(let r = 0; r < 12; r++){
            this._G(v, 0, 8, 16, 24, 1, 9, 17, 25, m[$b245bb78b1cc020b$var$SIGMA[r][0]], m[$b245bb78b1cc020b$var$SIGMA[r][0] + 1], m[$b245bb78b1cc020b$var$SIGMA[r][1]], m[$b245bb78b1cc020b$var$SIGMA[r][1] + 1]);
            this._G(v, 2, 10, 18, 26, 3, 11, 19, 27, m[$b245bb78b1cc020b$var$SIGMA[r][2]], m[$b245bb78b1cc020b$var$SIGMA[r][2] + 1], m[$b245bb78b1cc020b$var$SIGMA[r][3]], m[$b245bb78b1cc020b$var$SIGMA[r][3] + 1]);
            this._G(v, 4, 12, 20, 28, 5, 13, 21, 29, m[$b245bb78b1cc020b$var$SIGMA[r][4]], m[$b245bb78b1cc020b$var$SIGMA[r][4] + 1], m[$b245bb78b1cc020b$var$SIGMA[r][5]], m[$b245bb78b1cc020b$var$SIGMA[r][5] + 1]);
            this._G(v, 6, 14, 22, 30, 7, 15, 23, 31, m[$b245bb78b1cc020b$var$SIGMA[r][6]], m[$b245bb78b1cc020b$var$SIGMA[r][6] + 1], m[$b245bb78b1cc020b$var$SIGMA[r][7]], m[$b245bb78b1cc020b$var$SIGMA[r][7] + 1]);
            this._G(v, 0, 10, 20, 30, 1, 11, 21, 31, m[$b245bb78b1cc020b$var$SIGMA[r][8]], m[$b245bb78b1cc020b$var$SIGMA[r][8] + 1], m[$b245bb78b1cc020b$var$SIGMA[r][9]], m[$b245bb78b1cc020b$var$SIGMA[r][9] + 1]);
            this._G(v, 2, 12, 22, 24, 3, 13, 23, 25, m[$b245bb78b1cc020b$var$SIGMA[r][10]], m[$b245bb78b1cc020b$var$SIGMA[r][10] + 1], m[$b245bb78b1cc020b$var$SIGMA[r][11]], m[$b245bb78b1cc020b$var$SIGMA[r][11] + 1]);
            this._G(v, 4, 14, 16, 26, 5, 15, 17, 27, m[$b245bb78b1cc020b$var$SIGMA[r][12]], m[$b245bb78b1cc020b$var$SIGMA[r][12] + 1], m[$b245bb78b1cc020b$var$SIGMA[r][13]], m[$b245bb78b1cc020b$var$SIGMA[r][13] + 1]);
            this._G(v, 6, 8, 18, 28, 7, 9, 19, 29, m[$b245bb78b1cc020b$var$SIGMA[r][14]], m[$b245bb78b1cc020b$var$SIGMA[r][14] + 1], m[$b245bb78b1cc020b$var$SIGMA[r][15]], m[$b245bb78b1cc020b$var$SIGMA[r][15] + 1]);
        }
        for(let i = 0; i < 16; i++)this._state[i] ^= v[i] ^ v[i + 16];
    }
}
function $b245bb78b1cc020b$export$d6af199866bfb566(data, digestLength = $b245bb78b1cc020b$export$d7bd469488748c5f, config) {
    const h = new $b245bb78b1cc020b$export$5ad32252b3508605(digestLength, config);
    h.update(data);
    const digest = h.digest();
    h.clean();
    return digest;
}


// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.


const $2cc6b12a8ccb780d$export$d7bd469488748c5f = 64;
const $2cc6b12a8ccb780d$export$b2e3d6d444266a5c = 128;
class $2cc6b12a8ccb780d$export$d655fdb8a1cad5df {
    /** Length of hash output */ digestLength = $2cc6b12a8ccb780d$export$d7bd469488748c5f;
    /** Block size */ blockSize = $2cc6b12a8ccb780d$export$b2e3d6d444266a5c;
    // Note: Int32Array is used instead of Uint32Array for performance reasons.
    _stateHi = new Int32Array(8);
    _stateLo = new Int32Array(8);
    _tempHi = new Int32Array(16);
    _tempLo = new Int32Array(16);
    _buffer = new Uint8Array(256);
    _bufferLength = 0;
    _bytesHashed = 0;
    _finished = false;
    constructor(){
        this.reset();
    }
    _initState() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    }
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ reset() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    }
    /**
     * Cleans internal buffers and resets hash state.
     */ clean() {
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._buffer);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._tempHi);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._tempLo);
        this.reset();
    }
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ update(data, dataLength = data.length) {
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        let dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < $2cc6b12a8ccb780d$export$b2e3d6d444266a5c && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    }
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ finish(out) {
        if (!this._finished) {
            const bytesHashed = this._bytesHashed;
            const left = this._bufferLength;
            const bitLenHi = bytesHashed / 0x20000000 | 0;
            const bitLenLo = bytesHashed << 3;
            const padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(let i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            (0, $ddd89ca0ca71c6d3$export$4c09557cfb04670a)(bitLenHi, this._buffer, padLength - 8);
            (0, $ddd89ca0ca71c6d3$export$4c09557cfb04670a)(bitLenLo, this._buffer, padLength - 4);
            $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(let i = 0; i < this.digestLength / 8; i++){
            (0, $ddd89ca0ca71c6d3$export$4c09557cfb04670a)(this._stateHi[i], out, i * 8);
            (0, $ddd89ca0ca71c6d3$export$4c09557cfb04670a)(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    }
    /**
     * Returns the final hash digest.
     */ digest() {
        const out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    }
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ saveState() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    }
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ restoreState(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    }
    /**
     * Cleans state returned by saveState().
     */ cleanSavedState(savedState) {
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(savedState.stateHi);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(savedState.stateLo);
        if (savedState.buffer) (0, $276678191c4bdb56$export$46890c41d2ad591f)(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    }
}
// Constants
const $2cc6b12a8ccb780d$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $2cc6b12a8ccb780d$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    let ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    let h, l;
    let th, tl;
    let a, b, c, d;
    while(len >= 128){
        for(let i = 0; i < 16; i++){
            const j = 8 * i + pos;
            wh[i] = (0, $ddd89ca0ca71c6d3$export$affba09000bbdbfe)(m, j);
            wl[i] = (0, $ddd89ca0ca71c6d3$export$affba09000bbdbfe)(m, j + 4);
        }
        for(let i = 0; i < 80; i++){
            let bh0 = ah0;
            let bh1 = ah1;
            let bh2 = ah2;
            let bh3 = ah3;
            let bh4 = ah4;
            let bh5 = ah5;
            let bh6 = ah6;
            let bh7 = ah7;
            let bl0 = al0;
            let bl1 = al1;
            let bl2 = al2;
            let bl3 = al3;
            let bl4 = al4;
            let bl5 = al5;
            let bl6 = al6;
            let bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $2cc6b12a8ccb780d$var$K[i * 2];
            l = $2cc6b12a8ccb780d$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(let j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $2cc6b12a8ccb780d$export$d6af199866bfb566(data) {
    const h = new $2cc6b12a8ccb780d$export$d655fdb8a1cad5df();
    h.update(data);
    const digest = h.digest();
    h.clean();
    return digest;
}



const $a1d7ebd43ba0a83c$export$9fb7407f597ec460 = 64;
const $a1d7ebd43ba0a83c$export$84fc0a248cc54343 = 32;
const $a1d7ebd43ba0a83c$export$f2bd165db7344603 = 64;
const $a1d7ebd43ba0a83c$export$12cdc9e159d33298 = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $a1d7ebd43ba0a83c$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $a1d7ebd43ba0a83c$var$_9 = new Uint8Array(32);
$a1d7ebd43ba0a83c$var$_9[0] = 9;
const $a1d7ebd43ba0a83c$var$gf0 = $a1d7ebd43ba0a83c$var$gf();
const $a1d7ebd43ba0a83c$var$gf1 = $a1d7ebd43ba0a83c$var$gf([
    1
]);
const $a1d7ebd43ba0a83c$var$D = $a1d7ebd43ba0a83c$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $a1d7ebd43ba0a83c$var$D2 = $a1d7ebd43ba0a83c$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $a1d7ebd43ba0a83c$var$X = $a1d7ebd43ba0a83c$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $a1d7ebd43ba0a83c$var$Y = $a1d7ebd43ba0a83c$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $a1d7ebd43ba0a83c$var$I = $a1d7ebd43ba0a83c$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $a1d7ebd43ba0a83c$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $a1d7ebd43ba0a83c$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $a1d7ebd43ba0a83c$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $a1d7ebd43ba0a83c$var$pack25519(o, n) {
    const m = $a1d7ebd43ba0a83c$var$gf();
    const t = $a1d7ebd43ba0a83c$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $a1d7ebd43ba0a83c$var$car25519(t);
    $a1d7ebd43ba0a83c$var$car25519(t);
    $a1d7ebd43ba0a83c$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $a1d7ebd43ba0a83c$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $a1d7ebd43ba0a83c$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $a1d7ebd43ba0a83c$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(c, a);
    $a1d7ebd43ba0a83c$var$pack25519(d, b);
    return $a1d7ebd43ba0a83c$var$verify32(c, d);
}
function $a1d7ebd43ba0a83c$var$par25519(a) {
    const d = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(d, a);
    return d[0] & 1;
}
function $a1d7ebd43ba0a83c$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $a1d7ebd43ba0a83c$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $a1d7ebd43ba0a83c$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $a1d7ebd43ba0a83c$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $a1d7ebd43ba0a83c$var$square(o, a) {
    $a1d7ebd43ba0a83c$var$mul(o, a, a);
}
function $a1d7ebd43ba0a83c$var$inv25519(o, i) {
    const c = $a1d7ebd43ba0a83c$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $a1d7ebd43ba0a83c$var$square(c, c);
        if (a !== 2 && a !== 4) $a1d7ebd43ba0a83c$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $a1d7ebd43ba0a83c$var$pow2523(o, i) {
    const c = $a1d7ebd43ba0a83c$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $a1d7ebd43ba0a83c$var$square(c, c);
        if (a !== 1) $a1d7ebd43ba0a83c$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $a1d7ebd43ba0a83c$var$edadd(p, q) {
    const a = $a1d7ebd43ba0a83c$var$gf(), b = $a1d7ebd43ba0a83c$var$gf(), c = $a1d7ebd43ba0a83c$var$gf(), d = $a1d7ebd43ba0a83c$var$gf(), e = $a1d7ebd43ba0a83c$var$gf(), f = $a1d7ebd43ba0a83c$var$gf(), g = $a1d7ebd43ba0a83c$var$gf(), h = $a1d7ebd43ba0a83c$var$gf(), t = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$sub(a, p[1], p[0]);
    $a1d7ebd43ba0a83c$var$sub(t, q[1], q[0]);
    $a1d7ebd43ba0a83c$var$mul(a, a, t);
    $a1d7ebd43ba0a83c$var$add(b, p[0], p[1]);
    $a1d7ebd43ba0a83c$var$add(t, q[0], q[1]);
    $a1d7ebd43ba0a83c$var$mul(b, b, t);
    $a1d7ebd43ba0a83c$var$mul(c, p[3], q[3]);
    $a1d7ebd43ba0a83c$var$mul(c, c, $a1d7ebd43ba0a83c$var$D2);
    $a1d7ebd43ba0a83c$var$mul(d, p[2], q[2]);
    $a1d7ebd43ba0a83c$var$add(d, d, d);
    $a1d7ebd43ba0a83c$var$sub(e, b, a);
    $a1d7ebd43ba0a83c$var$sub(f, d, c);
    $a1d7ebd43ba0a83c$var$add(g, d, c);
    $a1d7ebd43ba0a83c$var$add(h, b, a);
    $a1d7ebd43ba0a83c$var$mul(p[0], e, f);
    $a1d7ebd43ba0a83c$var$mul(p[1], h, g);
    $a1d7ebd43ba0a83c$var$mul(p[2], g, f);
    $a1d7ebd43ba0a83c$var$mul(p[3], e, h);
}
function $a1d7ebd43ba0a83c$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$a1d7ebd43ba0a83c$var$sel25519(p[i], q[i], b);
}
function $a1d7ebd43ba0a83c$var$pack(r, p) {
    const tx = $a1d7ebd43ba0a83c$var$gf(), ty = $a1d7ebd43ba0a83c$var$gf(), zi = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$inv25519(zi, p[2]);
    $a1d7ebd43ba0a83c$var$mul(tx, p[0], zi);
    $a1d7ebd43ba0a83c$var$mul(ty, p[1], zi);
    $a1d7ebd43ba0a83c$var$pack25519(r, ty);
    r[31] ^= $a1d7ebd43ba0a83c$var$par25519(tx) << 7;
}
function $a1d7ebd43ba0a83c$var$scalarmult(p, q, s) {
    $a1d7ebd43ba0a83c$var$set25519(p[0], $a1d7ebd43ba0a83c$var$gf0);
    $a1d7ebd43ba0a83c$var$set25519(p[1], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$set25519(p[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$set25519(p[3], $a1d7ebd43ba0a83c$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $a1d7ebd43ba0a83c$var$cswap(p, q, b);
        $a1d7ebd43ba0a83c$var$edadd(q, p);
        $a1d7ebd43ba0a83c$var$edadd(p, p);
        $a1d7ebd43ba0a83c$var$cswap(p, q, b);
    }
}
function $a1d7ebd43ba0a83c$var$scalarbase(p, s) {
    const q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    $a1d7ebd43ba0a83c$var$set25519(q[0], $a1d7ebd43ba0a83c$var$X);
    $a1d7ebd43ba0a83c$var$set25519(q[1], $a1d7ebd43ba0a83c$var$Y);
    $a1d7ebd43ba0a83c$var$set25519(q[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$mul(q[3], $a1d7ebd43ba0a83c$var$X, $a1d7ebd43ba0a83c$var$Y);
    $a1d7ebd43ba0a83c$var$scalarmult(p, q, s);
}
function $a1d7ebd43ba0a83c$export$b260aa5f705622f1(seed) {
    if (seed.length !== $a1d7ebd43ba0a83c$export$12cdc9e159d33298) throw new Error(`ed25519: seed must be ${$a1d7ebd43ba0a83c$export$12cdc9e159d33298} bytes`);
    const d = (0, $2cc6b12a8ccb780d$export$d6af199866bfb566)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    $a1d7ebd43ba0a83c$var$scalarbase(p, d);
    $a1d7ebd43ba0a83c$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
function $a1d7ebd43ba0a83c$export$a949d36eab55b41f(prng) {
    const seed = (0, $73945d82524e104e$export$5f828d93ff035aa8)(32, prng);
    const result = $a1d7ebd43ba0a83c$export$b260aa5f705622f1(seed);
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(seed);
    return result;
}
function $a1d7ebd43ba0a83c$export$27efc0dca08886c3(secretKey) {
    if (secretKey.length !== $a1d7ebd43ba0a83c$export$f2bd165db7344603) throw new Error(`ed25519: secret key must be ${$a1d7ebd43ba0a83c$export$f2bd165db7344603} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
const $a1d7ebd43ba0a83c$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $a1d7ebd43ba0a83c$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $a1d7ebd43ba0a83c$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $a1d7ebd43ba0a83c$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $a1d7ebd43ba0a83c$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $a1d7ebd43ba0a83c$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $a1d7ebd43ba0a83c$var$modL(r, x);
}
function $a1d7ebd43ba0a83c$export$c5552dfdbc7cec71(secretKey, message) {
    if (secretKey.length !== $a1d7ebd43ba0a83c$export$f2bd165db7344603) throw new Error(`ed25519: secret key must be ${$a1d7ebd43ba0a83c$export$f2bd165db7344603} bytes`);
    const x = new Float64Array(64);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    const d = (0, $2cc6b12a8ccb780d$export$d6af199866bfb566)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new (0, $2cc6b12a8ccb780d$export$d655fdb8a1cad5df)();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $a1d7ebd43ba0a83c$var$reduce(r);
    $a1d7ebd43ba0a83c$var$scalarbase(p, r);
    $a1d7ebd43ba0a83c$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $a1d7ebd43ba0a83c$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $a1d7ebd43ba0a83c$var$modL(signature.subarray(32), x);
    return signature;
}
function $a1d7ebd43ba0a83c$var$unpackneg(r, p) {
    const t = $a1d7ebd43ba0a83c$var$gf(), chk = $a1d7ebd43ba0a83c$var$gf(), num = $a1d7ebd43ba0a83c$var$gf(), den = $a1d7ebd43ba0a83c$var$gf(), den2 = $a1d7ebd43ba0a83c$var$gf(), den4 = $a1d7ebd43ba0a83c$var$gf(), den6 = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$set25519(r[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$unpack25519(r[1], p);
    $a1d7ebd43ba0a83c$var$square(num, r[1]);
    $a1d7ebd43ba0a83c$var$mul(den, num, $a1d7ebd43ba0a83c$var$D);
    $a1d7ebd43ba0a83c$var$sub(num, num, r[2]);
    $a1d7ebd43ba0a83c$var$add(den, r[2], den);
    $a1d7ebd43ba0a83c$var$square(den2, den);
    $a1d7ebd43ba0a83c$var$square(den4, den2);
    $a1d7ebd43ba0a83c$var$mul(den6, den4, den2);
    $a1d7ebd43ba0a83c$var$mul(t, den6, num);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$pow2523(t, t);
    $a1d7ebd43ba0a83c$var$mul(t, t, num);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$mul(r[0], t, den);
    $a1d7ebd43ba0a83c$var$square(chk, r[0]);
    $a1d7ebd43ba0a83c$var$mul(chk, chk, den);
    if ($a1d7ebd43ba0a83c$var$neq25519(chk, num)) $a1d7ebd43ba0a83c$var$mul(r[0], r[0], $a1d7ebd43ba0a83c$var$I);
    $a1d7ebd43ba0a83c$var$square(chk, r[0]);
    $a1d7ebd43ba0a83c$var$mul(chk, chk, den);
    if ($a1d7ebd43ba0a83c$var$neq25519(chk, num)) return -1;
    if ($a1d7ebd43ba0a83c$var$par25519(r[0]) === p[31] >> 7) $a1d7ebd43ba0a83c$var$sub(r[0], $a1d7ebd43ba0a83c$var$gf0, r[0]);
    $a1d7ebd43ba0a83c$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $a1d7ebd43ba0a83c$export$532244b5b8b0b4b6(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    const q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    if (signature.length !== $a1d7ebd43ba0a83c$export$9fb7407f597ec460) throw new Error(`ed25519: signature must be ${$a1d7ebd43ba0a83c$export$9fb7407f597ec460} bytes`);
    if ($a1d7ebd43ba0a83c$var$unpackneg(q, publicKey)) return false;
    const hs = new (0, $2cc6b12a8ccb780d$export$d655fdb8a1cad5df)();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $a1d7ebd43ba0a83c$var$reduce(h);
    $a1d7ebd43ba0a83c$var$scalarmult(p, q, h);
    $a1d7ebd43ba0a83c$var$scalarbase(q, signature.subarray(32));
    $a1d7ebd43ba0a83c$var$edadd(p, q);
    $a1d7ebd43ba0a83c$var$pack(t, p);
    if ($a1d7ebd43ba0a83c$var$verify32(signature, t)) return false;
    return true;
}
function $a1d7ebd43ba0a83c$export$4cf9eeb5c9f6edbd(publicKey) {
    let q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    if ($a1d7ebd43ba0a83c$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $a1d7ebd43ba0a83c$var$gf();
    let b = $a1d7ebd43ba0a83c$var$gf();
    let y = q[1];
    $a1d7ebd43ba0a83c$var$add(a, $a1d7ebd43ba0a83c$var$gf1, y);
    $a1d7ebd43ba0a83c$var$sub(b, $a1d7ebd43ba0a83c$var$gf1, y);
    $a1d7ebd43ba0a83c$var$inv25519(b, b);
    $a1d7ebd43ba0a83c$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(z, a);
    return z;
}
function $a1d7ebd43ba0a83c$export$72e55b4de13bdf7c(secretKey) {
    const d = (0, $2cc6b12a8ccb780d$export$d6af199866bfb566)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $276678191c4bdb56$export$46890c41d2ad591f)(d);
    return o;
}


// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
/**
 * Package bytes provides functions for dealing with byte arrays.
 */ /**
 * Concatenates byte arrays.
 */ function $58cdd2550bf9536a$export$ee1b3e54f0441b22(...arrays) {
    // Calculate sum of lengths of all arrays.
    let totalLength = 0;
    for(let i = 0; i < arrays.length; i++)totalLength += arrays[i].length;
    // Allocate new array of calculated length.
    const result = new Uint8Array(totalLength);
    // Copy all arrays into result.
    let offset = 0;
    for(let i = 0; i < arrays.length; i++){
        const arg = arrays[i];
        result.set(arg, offset);
        offset += arg.length;
    }
    return result;
}



var $6ZWSX = parcelRequire("6ZWSX");
var $efd1a952be4e6fd9$require$Buffer = $6ZWSX.Buffer;
const $efd1a952be4e6fd9$export$5a119edad5f33470 = 24; // crypto_secretbox_NONCEBYTES
const $efd1a952be4e6fd9$export$a5d0660c4a35a096 = 16; // crypto_secretbox_MACBYTES
const $efd1a952be4e6fd9$var$POE_CHALLENGE_BYTES_LENGTH = 20;
const $efd1a952be4e6fd9$var$POE_CHALLENGE_PREFIX = 110;
function $efd1a952be4e6fd9$export$7ea66e3774a60b67(value) {
    return $efd1a952be4e6fd9$require$Buffer.from(value).toString('hex');
}
async function $efd1a952be4e6fd9$export$c3338cbceb8bf393(key) {
    if (typeof key === 'string') return $efd1a952be4e6fd9$export$7ea66e3774a60b67((0, $b245bb78b1cc020b$export$d6af199866bfb566)((0, $9a00e3fafffa883b$export$c564cdbbe6da493)(key), 32));
    return $efd1a952be4e6fd9$export$7ea66e3774a60b67((0, $b245bb78b1cc020b$export$d6af199866bfb566)(key, 32));
}
async function $efd1a952be4e6fd9$export$f73c212cf4258056(seed) {
    return (0, $a1d7ebd43ba0a83c$export$b260aa5f705622f1)((0, $b245bb78b1cc020b$export$d6af199866bfb566)((0, $9a00e3fafffa883b$export$c564cdbbe6da493)(seed), 32));
}
async function $efd1a952be4e6fd9$export$e46cb313f94b0706(message, sharedKey) {
    const nonce = $efd1a952be4e6fd9$require$Buffer.from((0, $73945d82524e104e$export$5f828d93ff035aa8)($efd1a952be4e6fd9$export$5a119edad5f33470));
    const combinedPayload = $efd1a952be4e6fd9$require$Buffer.concat([
        nonce,
        $efd1a952be4e6fd9$require$Buffer.from((0, $fb057964aa786cfd$export$73678ee8284bdb61)(sharedKey, nonce, $efd1a952be4e6fd9$require$Buffer.from(message, 'utf8')))
    ]);
    return $efd1a952be4e6fd9$export$7ea66e3774a60b67(combinedPayload);
}
async function $efd1a952be4e6fd9$export$b8de54a33cec1158(payload, sharedKey) {
    const nonce = payload.slice(0, $efd1a952be4e6fd9$export$5a119edad5f33470);
    const ciphertext = payload.slice($efd1a952be4e6fd9$export$5a119edad5f33470);
    const openBox = (0, $fb057964aa786cfd$export$2c221cd9fce4f342)(sharedKey, nonce, ciphertext);
    if (!openBox) throw new Error('Decryption failed');
    return $efd1a952be4e6fd9$require$Buffer.from(openBox).toString('utf8');
}
async function $efd1a952be4e6fd9$export$fcde1af43ae5282f(payload, otherPublicKey) {
    const kxOtherPublicKey = (0, $a1d7ebd43ba0a83c$export$4cf9eeb5c9f6edbd)($efd1a952be4e6fd9$require$Buffer.from(otherPublicKey)); // Secret bytes to scalar bytes
    const keypair = (0, $569072827d3d60aa$export$a949d36eab55b41f)();
    const state = new (0, $b245bb78b1cc020b$export$5ad32252b3508605)(24);
    const nonce = state.update(keypair.publicKey, 32).update(kxOtherPublicKey, 32).digest();
    const bytesPayload = typeof payload === 'string' ? (0, $9a00e3fafffa883b$export$c564cdbbe6da493)(payload) : payload;
    const encryptedMessage = (0, $8e5ffcb91c156513$export$827f4ee28efc37)(kxOtherPublicKey, keypair.secretKey, nonce, bytesPayload);
    return $efd1a952be4e6fd9$export$7ea66e3774a60b67((0, $58cdd2550bf9536a$export$ee1b3e54f0441b22)(keypair.publicKey, encryptedMessage));
}
async function $efd1a952be4e6fd9$export$26920d2a32821f84(encryptedPayload, publicKey, privateKey) {
    const kxSelfPrivateKey = (0, $a1d7ebd43ba0a83c$export$72e55b4de13bdf7c)($efd1a952be4e6fd9$require$Buffer.from(privateKey)); // Secret bytes to scalar bytes
    const kxSelfPublicKey = (0, $a1d7ebd43ba0a83c$export$4cf9eeb5c9f6edbd)($efd1a952be4e6fd9$require$Buffer.from(publicKey)); // Secret bytes to scalar bytes
    const bytesPayload = typeof encryptedPayload === 'string' ? (0, $9a00e3fafffa883b$export$c564cdbbe6da493)(encryptedPayload) : encryptedPayload;
    const epk = bytesPayload.slice(0, 32);
    const ciphertext = bytesPayload.slice(32);
    const state = new (0, $b245bb78b1cc020b$export$5ad32252b3508605)(24);
    const nonce = state.update(epk, 32).update(kxSelfPublicKey, 32).digest();
    const decryptedMessage2 = (0, $8e5ffcb91c156513$export$ada26e8482d44de1)(epk, kxSelfPrivateKey, nonce, ciphertext);
    if (!decryptedMessage2) throw new Error('Decryption failed');
    return $efd1a952be4e6fd9$require$Buffer.from(decryptedMessage2).toString();
}
async function $efd1a952be4e6fd9$export$a28ea21350b9dd16(publicKey) {
    const prefixes = {
        // tz1...
        edpk: {
            length: 54,
            prefix: $efd1a952be4e6fd9$require$Buffer.from(new Uint8Array([
                6,
                161,
                159
            ]))
        },
        // tz2...
        sppk: {
            length: 55,
            prefix: $efd1a952be4e6fd9$require$Buffer.from(new Uint8Array([
                6,
                161,
                161
            ]))
        },
        // tz3...
        p2pk: {
            length: 55,
            prefix: $efd1a952be4e6fd9$require$Buffer.from(new Uint8Array([
                6,
                161,
                164
            ]))
        },
        // tz4...
        BLpk: {
            length: 55,
            prefix: $efd1a952be4e6fd9$require$Buffer.from(new Uint8Array([
                6,
                161,
                166
            ]))
        }
    };
    let prefix;
    let plainPublicKey;
    if (publicKey.length === 64) {
        prefix = prefixes.edpk.prefix;
        plainPublicKey = publicKey;
    } else {
        const entries = Object.entries(prefixes);
        for(let index = 0; index < entries.length; index++){
            const [key, value] = entries[index];
            if (publicKey.startsWith(key) && publicKey.length === value.length) {
                prefix = value.prefix;
                const decoded = (0, $7e3a089a80d0b268$export$2e2bcd8739ae039).decode(publicKey);
                plainPublicKey = $efd1a952be4e6fd9$require$Buffer.from(decoded.slice(key.length, decoded.length)).toString('hex');
                break;
            }
        }
    }
    if (!prefix || !plainPublicKey) throw new Error(`invalid publicKey: ${publicKey}`);
    const payload = (0, $b245bb78b1cc020b$export$d6af199866bfb566)($efd1a952be4e6fd9$require$Buffer.from(plainPublicKey, 'hex'), 20);
    return (0, $7e3a089a80d0b268$export$2e2bcd8739ae039).encode($efd1a952be4e6fd9$require$Buffer.concat([
        prefix,
        $efd1a952be4e6fd9$require$Buffer.from(payload)
    ]));
}
function $efd1a952be4e6fd9$export$49a0f573bf6332f8(publicKey) {
    if (publicKey.length !== 64) return publicKey;
    const payload = $efd1a952be4e6fd9$require$Buffer.from(publicKey, 'hex');
    return (0, $7e3a089a80d0b268$export$2e2bcd8739ae039).encode($efd1a952be4e6fd9$require$Buffer.concat([
        new Uint8Array([
            13,
            15,
            37,
            217
        ]),
        $efd1a952be4e6fd9$require$Buffer.from(payload)
    ]));
}
function $efd1a952be4e6fd9$export$1a3a10450432dc35(recipientHash, relayServer) {
    return `@${recipientHash}:${relayServer}`;
}
const $efd1a952be4e6fd9$var$toBuffer = async (message)=>{
    if (message.length % 2 !== 0) return (0, $9a00e3fafffa883b$export$c564cdbbe6da493)(message);
    let adjustedMessage = message;
    if (message.startsWith('0x')) adjustedMessage = message.slice(2);
    const buffer = $efd1a952be4e6fd9$require$Buffer.from(adjustedMessage, 'hex');
    if (buffer.length === adjustedMessage.length / 2) return buffer;
    return (0, $9a00e3fafffa883b$export$c564cdbbe6da493)(message);
};
const $efd1a952be4e6fd9$var$coinlibhash = async (message, size = 32)=>{
    return (0, $b245bb78b1cc020b$export$d6af199866bfb566)(message, size);
};
const $efd1a952be4e6fd9$export$1d9a7a8a40780de = async (message, keypair)=>{
    const bufferMessage = await $efd1a952be4e6fd9$var$toBuffer(message);
    const edsigPrefix = new Uint8Array([
        9,
        245,
        205,
        134,
        18
    ]);
    const hash = await $efd1a952be4e6fd9$var$coinlibhash(bufferMessage);
    const rawSignature = (0, $a1d7ebd43ba0a83c$export$c5552dfdbc7cec71)(keypair.secretKey, hash);
    const signature = (0, $7e3a089a80d0b268$export$2e2bcd8739ae039).encode($efd1a952be4e6fd9$require$Buffer.concat([
        $efd1a952be4e6fd9$require$Buffer.from(edsigPrefix),
        $efd1a952be4e6fd9$require$Buffer.from(rawSignature)
    ]));
    return signature;
};
const $efd1a952be4e6fd9$export$1987372119294ebb = (address)=>{
    const prefixes = [
        'tz1',
        'tz2',
        'tz3',
        'tz4',
        'KT1',
        'txr1',
        'sr1'
    ];
    if (!prefixes.some((p)=>address.toLowerCase().startsWith(p.toLowerCase()))) return false;
    try {
        (0, $7e3a089a80d0b268$export$2e2bcd8739ae039).decode(address);
    } catch (error) {
        return false;
    }
    return true;
};
function $efd1a952be4e6fd9$export$4f2b7340e265d47b(payload) {
    const poeBlake2b = new (0, $b245bb78b1cc020b$export$5ad32252b3508605)($efd1a952be4e6fd9$var$POE_CHALLENGE_BYTES_LENGTH);
    return (0, $7e3a089a80d0b268$export$2e2bcd8739ae039).encode($efd1a952be4e6fd9$require$Buffer.concat([
        new Uint8Array([
            $efd1a952be4e6fd9$var$POE_CHALLENGE_PREFIX
        ]),
        $efd1a952be4e6fd9$require$Buffer.from(poeBlake2b.update($efd1a952be4e6fd9$require$Buffer.from(payload)).digest())
    ]));
}
function $efd1a952be4e6fd9$export$212c5439ed082413(publicKey) {
    if (!publicKey) return false;
    return publicKey.startsWith('edpk') || publicKey.startsWith('sppk') || publicKey.startsWith('p2pk') || publicKey.startsWith('BLpk');
} /* eslint-enable prefer-arrow/prefer-arrow-functions */ 


/* eslint-disable prefer-arrow/prefer-arrow-functions */ 

var $6ZWSX = parcelRequire("6ZWSX");
var $788668db41590f82$require$Buffer = $6ZWSX.Buffer;
async function $788668db41590f82$export$2dbe1b699c206fb() {
    const buf = (0, $73945d82524e104e$export$5f828d93ff035aa8)(16);
    return [
        buf.slice(0, 4),
        buf.slice(4, 6),
        buf.slice(6, 8),
        buf.slice(8, 10),
        buf.slice(10, 16)
    ].map(function(subbuf) {
        return $788668db41590f82$require$Buffer.from(subbuf).toString('hex');
    }).join('-');
} /* eslint-enable prefer-arrow/prefer-arrow-functions */ 


const $15a40981d98388e5$export$f3c76c19efc1480d = 'KT1';
const $15a40981d98388e5$export$5a119edad5f33470 = 24; // crypto_secretbox_NONCEBYTES
const $15a40981d98388e5$export$a5d0660c4a35a096 = 16; // crypto_secretbox_MACBYTES


var $8d4b62279108a12b$export$d26bbbc5c9ff3ce8;
(function(BeaconMessageType) {
    BeaconMessageType["BlockchainRequest"] = "blockchain_request";
    BeaconMessageType["PermissionRequest"] = "permission_request";
    BeaconMessageType["SignPayloadRequest"] = "sign_payload_request";
    // EncryptPayloadRequest = 'encrypt_payload_request',
    BeaconMessageType["OperationRequest"] = "operation_request";
    BeaconMessageType["BroadcastRequest"] = "broadcast_request";
    BeaconMessageType["ChangeAccountRequest"] = "change_account_request";
    BeaconMessageType["BlockchainResponse"] = "blockchain_response";
    BeaconMessageType["PermissionResponse"] = "permission_response";
    BeaconMessageType["SignPayloadResponse"] = "sign_payload_response";
    // EncryptPayloadResponse = 'encrypt_payload_response',
    BeaconMessageType["ProofOfEventChallengeRequest"] = "proof_of_event_challenge_request";
    BeaconMessageType["ProofOfEventChallengeResponse"] = "proof_of_event_challenge_response";
    BeaconMessageType["SimulatedProofOfEventChallengeRequest"] = "simulated_proof_of_event_challenge_request";
    BeaconMessageType["SimulatedProofOfEventChallengeResponse"] = "simulated_proof_of_event_challenge_response";
    BeaconMessageType["OperationResponse"] = "operation_response";
    BeaconMessageType["BroadcastResponse"] = "broadcast_response";
    BeaconMessageType["Acknowledge"] = "acknowledge";
    BeaconMessageType["Disconnect"] = "disconnect";
    BeaconMessageType["Error"] = "error";
})($8d4b62279108a12b$export$d26bbbc5c9ff3ce8 || ($8d4b62279108a12b$export$d26bbbc5c9ff3ce8 = {}));


var $23ff6a3db924eefa$export$daafb2ca9aa4674b;
(function(PermissionScope) {
    PermissionScope["SIGN"] = "sign";
    PermissionScope["OPERATION_REQUEST"] = "operation_request";
    PermissionScope["ENCRYPT"] = "encrypt";
    PermissionScope["NOTIFICATION"] = "notification";
    PermissionScope["THRESHOLD"] = "threshold"; // Allows the DApp to sign transactions below a certain threshold. This is currently not fully defined and unused
})($23ff6a3db924eefa$export$daafb2ca9aa4674b || ($23ff6a3db924eefa$export$daafb2ca9aa4674b = {}));


var $3ebc4504403abbff$export$4a868a35d3b57055;
(function(NetworkType) {
    NetworkType["MAINNET"] = "mainnet";
    NetworkType["GHOSTNET"] = "ghostnet";
    NetworkType["WEEKLYNET"] = "weeklynet";
    NetworkType["DAILYNET"] = "dailynet";
    NetworkType["DELPHINET"] = "delphinet";
    NetworkType["EDONET"] = "edonet";
    NetworkType["FLORENCENET"] = "florencenet";
    NetworkType["GRANADANET"] = "granadanet";
    NetworkType["HANGZHOUNET"] = "hangzhounet";
    NetworkType["ITHACANET"] = "ithacanet";
    NetworkType["JAKARTANET"] = "jakartanet";
    NetworkType["KATHMANDUNET"] = "kathmandunet";
    NetworkType["LIMANET"] = "limanet";
    NetworkType["MUMBAINET"] = "mumbainet";
    NetworkType["NAIROBINET"] = "nairobinet";
    NetworkType["OXFORDNET"] = "oxfordnet";
    NetworkType["PARISNET"] = "parisnet";
    NetworkType["QUEBECNET"] = "quebecnet";
    NetworkType["RIONET"] = "rionet";
    NetworkType["SEOULNET"] = "seoulnet";
    NetworkType["SHADOWNET"] = "shadownet";
    NetworkType["CUSTOM"] = "custom";
})($3ebc4504403abbff$export$4a868a35d3b57055 || ($3ebc4504403abbff$export$4a868a35d3b57055 = {}));


/**
 * @publicapi
 * @category Tezos
 */ var $86e9f2fe85a1f972$export$fb65464a4e1f1493;
(function(TezosOperationType) {
    TezosOperationType["ACTIVATE_ACCOUNT"] = "activate_account";
    TezosOperationType["ATTESTATION"] = "attestation";
    TezosOperationType["ATTESTATIONS_AGGREGATE"] = "attestations_aggregate";
    TezosOperationType["ATTESTATION_WITH_DAL"] = "attestation_with_dal";
    TezosOperationType["BALLOT"] = "ballot";
    TezosOperationType["DAL_PUBLISH_COMMITMENT"] = "dal_publish_commitment";
    TezosOperationType["DELEGATION"] = "delegation";
    TezosOperationType["DRAIN_DELEGATE"] = "drain_delegate";
    TezosOperationType["DOUBLE_ATTESTATION_EVIDENCE"] = "double_attestation_evidence";
    TezosOperationType["DOUBLE_BAKING_EVIDENCE"] = "double_baking_evidence";
    TezosOperationType["DOUBLE_ENDORSEMENT_EVIDENCE"] = "double_endorsement_evidence";
    TezosOperationType["DOUBLE_PREATTESTATION_EVIDENCE"] = "double_preattestation_evidence";
    TezosOperationType["DOUBLE_PREENDORSEMENT_EVIDENCE"] = "double_preendorsement_evidence";
    TezosOperationType["ENDORSEMENT"] = "endorsement";
    TezosOperationType["ENDORSEMENT_WITH_DAL"] = "endorsement_with_dal";
    TezosOperationType["EVENT"] = "event";
    TezosOperationType["FAILING_NOOP"] = "failing_noop";
    TezosOperationType["INCREASE_PAID_STORAGE"] = "increase_paid_storage";
    TezosOperationType["ORIGINATION"] = "origination";
    TezosOperationType["PREATTESTATION"] = "preattestation";
    TezosOperationType["PREATTESTATIONS_AGGREGATE"] = "preattestations_aggregate";
    TezosOperationType["PREENDORSEMENT"] = "preendorsement";
    TezosOperationType["PROPOSALS"] = "proposals";
    TezosOperationType["REGISTER_GLOBAL_CONSTANT"] = "register_global_constant";
    TezosOperationType["REVEAL"] = "reveal";
    TezosOperationType["SEED_NONCE_REVELATION"] = "seed_nonce_revelation";
    TezosOperationType["SET_DEPOSITS_LIMIT"] = "set_deposits_limit";
    TezosOperationType["SMART_ROLLUP_ADD_MESSAGES"] = "smart_rollup_add_messages";
    TezosOperationType["SMART_ROLLUP_CEMENT"] = "smart_rollup_cement";
    TezosOperationType["SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE"] = "smart_rollup_execute_outbox_message";
    TezosOperationType["SMART_ROLLUP_ORIGINATE"] = "smart_rollup_originate";
    TezosOperationType["SMART_ROLLUP_PUBLISH"] = "smart_rollup_publish";
    TezosOperationType["SMART_ROLLUP_RECOVER_BOND"] = "smart_rollup_recover_bond";
    TezosOperationType["SMART_ROLLUP_REFUTE"] = "smart_rollup_refute";
    TezosOperationType["SMART_ROLLUP_TIMEOUT"] = "smart_rollup_timeout";
    TezosOperationType["TICKET_UPDATES"] = "ticket_updates";
    TezosOperationType["TRANSACTION"] = "transaction";
    TezosOperationType["TRANSFER_TICKET"] = "transfer_ticket";
    TezosOperationType["UPDATE_CONSENSUS_KEY"] = "update_consensus_key";
    TezosOperationType["UPDATE_COMPANION_KEY"] = "update_companion_key";
    TezosOperationType["VDF_REVELATION"] = "vdf_revelation";
    TezosOperationType["DOUBLE_CONSENSUS_OPERATION_EVIDENCE"] = "double_consensus_operation_evidence";
    TezosOperationType["DAL_ENTRAPMENT_EVIDENCE"] = "dal_entrapment_evidence";
})($86e9f2fe85a1f972$export$fb65464a4e1f1493 || ($86e9f2fe85a1f972$export$fb65464a4e1f1493 = {}));


/**
 * @internalapi
 */ var $6a40437df5c178f8$export$bb47f81d5b009d7f;
(function(Origin) {
    Origin["WEBSITE"] = "website";
    Origin["EXTENSION"] = "extension";
    Origin["P2P"] = "p2p";
    Origin["WALLETCONNECT"] = "walletconnect";
})($6a40437df5c178f8$export$bb47f81d5b009d7f || ($6a40437df5c178f8$export$bb47f81d5b009d7f = {}));


/**
 * @internalapi
 */ var $4da46fae6de1b2e1$export$df51877e5681a4ab;
(function(ExtensionMessageTarget) {
    ExtensionMessageTarget["BACKGROUND"] = "toBackground";
    ExtensionMessageTarget["PAGE"] = "toPage";
    ExtensionMessageTarget["EXTENSION"] = "toExtension";
})($4da46fae6de1b2e1$export$df51877e5681a4ab || ($4da46fae6de1b2e1$export$df51877e5681a4ab = {}));


var $3402b71e229a176a$export$de39e3c3d623b630;
(function(BeaconErrorType) {
    /**
     * {@link BroadcastBeaconError}
     *
     * Will be returned if the user chooses that the transaction is broadcast but there is an error (eg. node not available).
     *
     * Returned by: Broadcast | Operation Request
     */ BeaconErrorType["BROADCAST_ERROR"] = "BROADCAST_ERROR";
    /**
     * {@link NetworkNotSupportedBeaconError}
     *
     * Will be returned if the selected network is not supported by the wallet / extension.
     *
     * Returned by: Permission
     */ BeaconErrorType["NETWORK_NOT_SUPPORTED"] = "NETWORK_NOT_SUPPORTED";
    /**
     * {@link NoAddressBeaconError}
     *
     * Will be returned if there is no address present for the protocol / network requested.
     *
     * Returned by: Permission
     */ BeaconErrorType["NO_ADDRESS_ERROR"] = "NO_ADDRESS_ERROR";
    /**
     * {@link NoPrivateKeyBeaconError}
     *
     * Will be returned if the private key matching the sourceAddress could not be found.
     *
     * Returned by: Sign
     */ BeaconErrorType["NO_PRIVATE_KEY_FOUND_ERROR"] = "NO_PRIVATE_KEY_FOUND_ERROR";
    /**
     * {@link NotGrantedBeaconError}
     *
     * Will be returned if the signature was blocked // (Not needed?) Permission: Will be returned if the permissions requested by the App were not granted.
     *
     * Returned by: Sign
     */ BeaconErrorType["NOT_GRANTED_ERROR"] = "NOT_GRANTED_ERROR";
    /**
     * {@link ParametersInvalidBeaconError}
     *
     * Will be returned if any of the parameters are invalid.
     *
     * Returned by: Operation Request
     */ BeaconErrorType["PARAMETERS_INVALID_ERROR"] = "PARAMETERS_INVALID_ERROR";
    /**
     * {@link TooManyOperationsBeaconError}
     *
     * Will be returned if too many operations were in the request and they were not able to fit into a single operation group.
     *
     * Returned by: Operation Request
     */ BeaconErrorType["TOO_MANY_OPERATIONS"] = "TOO_MANY_OPERATIONS";
    /**
     * {@link TransactionInvalidBeaconError}
     *
     * Will be returned if the transaction is not parsable or is rejected by the node.
     *
     * Returned by: Broadcast
     */ BeaconErrorType["TRANSACTION_INVALID_ERROR"] = "TRANSACTION_INVALID_ERROR";
    /**
     * {@link SignatureTypeNotSupportedBeaconError}
     *
     * Will be returned if the signing type is not supported.
     *
     * Returned by: Sign
     */ BeaconErrorType["SIGNATURE_TYPE_NOT_SUPPORTED"] = "SIGNATURE_TYPE_NOT_SUPPORTED";
    // TODO: ENCRYPTION
    // /**
    //  * {@link EncryptionTypeNotSupportedBeaconError}
    //  *
    //  * Will be returned if the encryption type is not supported.
    //  *
    //  * Returned by: Encrypt
    //  */
    // ENCRYPTION_TYPE_NOT_SUPPORTED = 'ENCRYPTION_TYPE_NOT_SUPPORTED',
    /**
     * {@link AbortedBeaconError}
     *
     * Will be returned if the request was aborted by the user or the wallet.
     *
     * Returned by: Permission | Operation Request | Sign Request | Broadcast
     */ BeaconErrorType["ABORTED_ERROR"] = "ABORTED_ERROR";
    /**
     * {@link UnknownBeaconError}
     *
     * Used as a wildcard if an unexpected error occured.
     *
     * Returned by: Permission | Operation Request | Sign Request | Broadcast
     */ BeaconErrorType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})($3402b71e229a176a$export$de39e3c3d623b630 || ($3402b71e229a176a$export$de39e3c3d623b630 = {}));


var $6526b1c1da97cb73$export$da8d660a2cd6a8c0;
(function(TransportStatus) {
    TransportStatus["NOT_CONNECTED"] = "NOT_CONNECTED";
    TransportStatus["CONNECTING"] = "CONNECTING";
    TransportStatus["CONNECTED"] = "CONNECTED";
    TransportStatus["SECONDARY_TAB_CONNECTED"] = "SECONDARY_TAB_CONNECTED";
})($6526b1c1da97cb73$export$da8d660a2cd6a8c0 || ($6526b1c1da97cb73$export$da8d660a2cd6a8c0 = {}));


/**
 * @internalapi
 */ var $809a8ab02b228419$export$6d07abd9f0bba447;
(function(TransportType) {
    TransportType["CHROME_MESSAGE"] = "chrome_message";
    TransportType["WALLETCONNECT"] = "walletconnect";
    TransportType["POST_MESSAGE"] = "post_message";
    TransportType["LEDGER"] = "ledger";
    TransportType["P2P"] = "p2p";
})($809a8ab02b228419$export$6d07abd9f0bba447 || ($809a8ab02b228419$export$6d07abd9f0bba447 = {}));


/**
 * @internalapi
 *
 * The storage used in the SDK
 */ class $78be7a0343b19772$export$bf2a15d34f3c441c {
    /**
     * Returns a promise that resolves to true if the storage option is available on this platform.
     */ static isSupported() {
        return Promise.resolve(false);
    }
}


/**
 * @internalapi
 */ var $8d1a6d1de5294bad$export$2fdc5139b636713c;
(function(StorageKey) {
    StorageKey["TRANSPORT_P2P_PEERS_DAPP"] = "beacon:communication-peers-dapp";
    StorageKey["TRANSPORT_P2P_PEERS_WALLET"] = "beacon:communication-peers-wallet";
    StorageKey["TRANSPORT_POSTMESSAGE_PEERS_DAPP"] = "beacon:postmessage-peers-dapp";
    StorageKey["TRANSPORT_POSTMESSAGE_PEERS_WALLET"] = "beacon:postmessage-peers-wallet";
    StorageKey["TRANSPORT_WALLETCONNECT_PEERS_DAPP"] = "beacon:walletconnect-peers-dapp";
    StorageKey["LAST_SELECTED_WALLET"] = "beacon:last-selected-wallet";
    StorageKey["ACCOUNTS"] = "beacon:accounts";
    StorageKey["ACTIVE_ACCOUNT"] = "beacon:active-account";
    StorageKey["PUSH_TOKENS"] = "beacon:push-tokens";
    StorageKey["BEACON_SDK_SECRET_SEED"] = "beacon:sdk-secret-seed";
    StorageKey["BEACON_LAST_ERROR"] = "beacon:beacon-last-error";
    StorageKey["APP_METADATA_LIST"] = "beacon:app-metadata-list";
    StorageKey["PERMISSION_LIST"] = "beacon:permissions";
    StorageKey["ONGOING_PROOF_OF_EVENT_CHALLENGES"] = "beacon:ongoing-proof-of-event-challenges";
    StorageKey["BEACON_SDK_VERSION"] = "beacon:sdk_version";
    StorageKey["MATRIX_PRESERVED_STATE"] = "beacon:sdk-matrix-preserved-state";
    StorageKey["MATRIX_PEER_ROOM_IDS"] = "beacon:matrix-peer-rooms";
    StorageKey["MATRIX_SELECTED_NODE"] = "beacon:matrix-selected-node";
    StorageKey["MULTI_NODE_SETUP_DONE"] = "beacon:multi-node-setup";
    StorageKey["USER_ID"] = "beacon:user-id";
    StorageKey["ENABLE_METRICS"] = "beacon:enable_metrics";
    StorageKey["WC_INIT_ERROR"] = "beacon:wc-init-error";
    StorageKey["WC_2_CORE_PAIRING"] = "wc@2:core:0.3:pairing";
    StorageKey["WC_2_CLIENT_SESSION"] = "wc@2:client:0.3:session";
    StorageKey["WC_2_CORE_KEYCHAIN"] = "wc@2:core:0.3:keychain";
    StorageKey["WC_2_CORE_MESSAGES"] = "wc@2:core:0.3:messages";
    StorageKey["WC_2_CLIENT_PROPOSAL"] = "wc@2:client:0.3:proposal";
    StorageKey["WC_2_CORE_SUBSCRIPTION"] = "wc@2:core:0.3:subscription";
    StorageKey["WC_2_CORE_HISTORY"] = "wc@2:core:0.3:history";
    StorageKey["WC_2_CORE_EXPIRER"] = "wc@2:core:0.3:expirer";
})($8d1a6d1de5294bad$export$2fdc5139b636713c || ($8d1a6d1de5294bad$export$2fdc5139b636713c = {}));



const $4b201e2d090578e5$export$7e292eecf5a8f340 = {
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_P2P_PEERS_DAPP]: [],
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_P2P_PEERS_WALLET]: [],
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_POSTMESSAGE_PEERS_DAPP]: [],
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_POSTMESSAGE_PEERS_WALLET]: [],
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_WALLETCONNECT_PEERS_DAPP]: [],
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).LAST_SELECTED_WALLET]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ACCOUNTS]: [],
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ACTIVE_ACCOUNT]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).PUSH_TOKENS]: [],
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).BEACON_SDK_SECRET_SEED]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).BEACON_LAST_ERROR]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).APP_METADATA_LIST]: [],
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).PERMISSION_LIST]: [],
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ONGOING_PROOF_OF_EVENT_CHALLENGES]: [],
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).BEACON_SDK_VERSION]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PRESERVED_STATE]: {},
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PEER_ROOM_IDS]: {},
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_SELECTED_NODE]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MULTI_NODE_SETUP_DONE]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CLIENT_SESSION]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).USER_ID]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ENABLE_METRICS]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_INIT_ERROR]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_PAIRING]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_KEYCHAIN]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_MESSAGES]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CLIENT_PROPOSAL]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_SUBSCRIPTION]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_HISTORY]: undefined,
    [(0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_EXPIRER]: undefined
};


/**
 * @internalapi
 */ class $7625031e92f13c50$export$5105399ce7c287dd {
    type = 'p2p-pairing-request';
    relayServer;
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(id, name, publicKey, version, relayServer, icon, appUrl){
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.appUrl = appUrl;
        this.publicKey = publicKey;
        this.version = version;
        this.relayServer = relayServer;
    }
}
class $7625031e92f13c50$export$4ed13e9517258bfc extends $7625031e92f13c50$export$5105399ce7c287dd {
    senderId;
    constructor(id, name, publicKey, version, relayServer, senderId, icon, appUrl){
        super(id, name, publicKey, version, relayServer, icon, appUrl);
        this.senderId = senderId;
    }
}


var $1135dc71db7da99c$export$ecff5c1a4386a2e0;
(function(SigningType) {
    SigningType["RAW"] = "raw";
    SigningType["OPERATION"] = "operation";
    SigningType["MICHELINE"] = "micheline"; // "05" prefix
})($1135dc71db7da99c$export$ecff5c1a4386a2e0 || ($1135dc71db7da99c$export$ecff5c1a4386a2e0 = {}));


/**
 * @internalapi
 */ class $72fa78d0a3e4e700$export$8d55e7f86bba45ec {
    type = 'p2p-pairing-request';
    relayServer;
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(id, name, publicKey, version, relayServer, icon, appUrl){
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.appUrl = appUrl;
        this.publicKey = publicKey;
        this.version = version;
        this.relayServer = relayServer;
    }
}
class $72fa78d0a3e4e700$export$92eab244074118c1 extends $72fa78d0a3e4e700$export$8d55e7f86bba45ec {
    senderId;
    constructor(id, name, publicKey, version, relayServer, senderId, icon, appUrl){
        super(id, name, publicKey, version, relayServer, icon, appUrl);
        this.senderId = senderId;
    }
} // TODO: Rename to "WalletPeerInfo"?


/**
 * @internalapi
 */ class $ce56bdceace47856$export$556bd87f142daf0c {
    type = 'postmessage-pairing-request';
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(id, name, publicKey, version, icon, appUrl){
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.appUrl = appUrl;
        this.publicKey = publicKey;
        this.version = version;
    }
}
class $ce56bdceace47856$export$fc9232e2a449c314 extends $ce56bdceace47856$export$556bd87f142daf0c {
    senderId;
    constructor(id, name, publicKey, version, senderId, icon, appUrl){
        super(id, name, publicKey, version, icon, appUrl);
        this.senderId = senderId;
    }
}


/**
 * @internalapi
 */ class $e10c8d28a45e9074$export$c5b08edfd1e23535 {
    type = 'walletconnect-pairing-response';
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(id, name, publicKey, version, icon, appUrl){
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.appUrl = appUrl;
        this.publicKey = publicKey;
        this.version = version;
    }
}
class $e10c8d28a45e9074$export$5edcb89f336f8361 extends $e10c8d28a45e9074$export$c5b08edfd1e23535 {
    senderId;
    extensionId;
    constructor(id, name, publicKey, version, senderId, extensionId, icon, appUrl){
        super(id, name, publicKey, version, icon, appUrl);
        this.senderId = senderId;
        this.extensionId = extensionId;
    }
} // TODO: Rename to "WalletPeerInfo"?


/**
 * @internalapi
 */ class $40e5f66fcc7157a8$export$e0a3dfb7d198c438 {
    type = 'walletconnect-pairing-request';
    uri;
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(id, name, publicKey, version, uri, icon, appUrl){
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.appUrl = appUrl;
        this.publicKey = publicKey;
        this.version = version;
        this.uri = uri;
    }
}
class $40e5f66fcc7157a8$export$6e43c36514596f83 extends $40e5f66fcc7157a8$export$e0a3dfb7d198c438 {
    senderId;
    constructor(id, name, publicKey, version, senderId, uri, icon, appUrl){
        super(id, name, publicKey, version, uri, icon, appUrl);
        this.senderId = senderId;
    }
}


/**
 * @internalapi
 */ class $1ff34411b45f2011$export$765ddbee55ef88ad {
    type = 'postmessage-pairing-response';
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(id, name, publicKey, version, icon, appUrl){
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.appUrl = appUrl;
        this.publicKey = publicKey;
        this.version = version;
    }
}
class $1ff34411b45f2011$export$cc40ce077fc2de8a extends $1ff34411b45f2011$export$765ddbee55ef88ad {
    senderId;
    extensionId;
    constructor(id, name, publicKey, version, senderId, extensionId, icon, appUrl){
        super(id, name, publicKey, version, icon, appUrl);
        this.senderId = senderId;
        this.extensionId = extensionId;
    }
} // TODO: Rename to "WalletPeerInfo"?


var $92037e38839d1f95$export$e9cc541a1d84538e;
(function(ColorMode) {
    ColorMode["LIGHT"] = "light";
    ColorMode["DARK"] = "dark";
})($92037e38839d1f95$export$e9cc541a1d84538e || ($92037e38839d1f95$export$e9cc541a1d84538e = {}));









/**
 * Geographic region where a beacon node is located. This list can be changed in the future to be more specific, but for now it should cover most general areas.
 */ var $15656c470911b69d$export$b63330adaddce5a3;
(function(Regions) {
    Regions["EUROPE_EAST"] = "europe-east";
    Regions["EUROPE_WEST"] = "europe-west";
    Regions["NORTH_AMERICA_EAST"] = "north-america-east";
    Regions["NORTH_AMERICA_WEST"] = "north-america-west";
    Regions["CENTRAL_AMERICA"] = "central-america";
    Regions["SOUTH_AMERICA"] = "south-america";
    Regions["ASIA_EAST"] = "asia-east";
    Regions["ASIA_WEST"] = "asia-west";
    Regions["AFRICA"] = "africa";
    Regions["AUSTRALIA"] = "australia";
})($15656c470911b69d$export$b63330adaddce5a3 || ($15656c470911b69d$export$b63330adaddce5a3 = {}));






const $217f751cff903b1b$export$31499a9cd224b78c = '4.6.2';
const $217f751cff903b1b$export$2220237b3fa2434a = '3';
const $217f751cff903b1b$export$868c67dc8134ff07 = 'https://beacon-notification-oracle.dev.gke.papers.tech';
const $217f751cff903b1b$export$b27b0287c31e45de = 'https://beacon-backend.prod.gke.papers.tech';


const $3d44e06f3373abda$var$cbs = [
    (_)=>undefined
];
/**
 * A mock for postmessage if run in node.js environment
 */ let $3d44e06f3373abda$export$32684078d75a1df3 = {
    postMessage: (message, _target)=>{
        console.log('GOT MOCK POST MESSAGE', message);
        $3d44e06f3373abda$var$cbs.forEach((callbackElement)=>{
            callbackElement({
                data: message
            });
        });
    },
    addEventListener: (_name, eventCallback)=>{
        $3d44e06f3373abda$var$cbs.push(eventCallback);
    },
    removeEventListener: (_name, eventCallback)=>{
        $3d44e06f3373abda$var$cbs.splice($3d44e06f3373abda$var$cbs.indexOf((element)=>element === eventCallback), 1);
    },
    location: {
        origin: '*'
    }
};
try {
    if (typeof window !== 'undefined') // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $3d44e06f3373abda$export$32684078d75a1df3 = window;
} catch (windowError) {
    console.log(`not defined: ${windowError}`);
}
const $3d44e06f3373abda$export$f64691c0cd63df73 = ()=>{
    $3d44e06f3373abda$var$cbs.length = 0;
};


class $315f4d02ac215f87$export$35b2cd6a82ca9744 {
    track(_trigger, _section, _label, _data) {
    // console.log('##### TRACK', trigger, section, label, data)
    // noop
    }
}


class $71f80b0c8b14c62f$export$2ad4faf1649ff611 {
    /**
     * The name of the client
     */ name;
    /**
     * The URL of the dApp Icon. This can be used to display the icon of the dApp on in the wallet
     */ iconUrl;
    /**
     * The URL of the dApp.
     */ appUrl;
    /** The beaconId is a public key that is used to identify one specific application (dapp or wallet).
     * This is used inside a message to specify the sender, for example.
     */ _beaconId = new (0, $247a3319916bcc85$export$babe85162c870d79)();
    get beaconId() {
        return this._beaconId.promise;
    }
    storage;
    analytics;
    /**
     * The local keypair that is used for the communication encryption
     */ _keyPair = new (0, $247a3319916bcc85$export$babe85162c870d79)();
    get keyPair() {
        return this._keyPair.promise;
    }
    constructor(config){
        if (!config.name) throw new Error('Name not set');
        if (!config.storage) throw new Error('Storage not set');
        this.name = config.name;
        this.iconUrl = config.iconUrl;
        this.appUrl = config.appUrl ?? (0, $3d44e06f3373abda$export$32684078d75a1df3).location.origin;
        this.storage = config.storage;
        this.analytics = config.analytics ?? new (0, $315f4d02ac215f87$export$35b2cd6a82ca9744)();
        // TODO: This is a temporary "workaround" to prevent users from creating multiple Client instances
        if ((0, $3d44e06f3373abda$export$32684078d75a1df3).beaconCreatedClientInstance) console.error('[BEACON] It looks like you created multiple Beacon SDK Client instances. This can lead to problems. Only create one instance and re-use it everywhere.');
        else (0, $3d44e06f3373abda$export$32684078d75a1df3).beaconCreatedClientInstance = true;
        this.initSDK().catch(console.error);
    }
    /**
     * This resets the SDK. After using this method, this instance is no longer usable. You will have to instanciate a new client.
     */ async destroy() {
        await this.removeBeaconEntriesFromStorage();
        (0, $3d44e06f3373abda$export$32684078d75a1df3).beaconCreatedClientInstance = false;
    }
    /**
     * This method initializes the SDK by setting some values in the storage and generating a keypair.
     */ async initSDK() {
        this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).BEACON_SDK_VERSION, (0, $217f751cff903b1b$export$31499a9cd224b78c)).catch(console.error);
        this.loadOrCreateBeaconSecret().catch(console.error);
        return this.keyPair.then((keyPair)=>{
            this._beaconId.resolve((0, $efd1a952be4e6fd9$export$7ea66e3774a60b67)(keyPair.publicKey));
        });
    }
    /**
     * Removes all beacon values from the storage.
     */ async removeBeaconEntriesFromStorage() {
        const allKeys = Object.values((0, $8d1a6d1de5294bad$export$2fdc5139b636713c));
        await Promise.all(allKeys.map((key)=>this.storage.delete(key)));
    }
    /**
     * This method tries to load the seed from storage, if it doesn't exist, a new one will be created and persisted.
     */ async loadOrCreateBeaconSecret() {
        const storageValue = await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).BEACON_SDK_SECRET_SEED);
        if (storageValue && typeof storageValue === 'string') this._keyPair.resolve(await (0, $efd1a952be4e6fd9$export$f73c212cf4258056)(storageValue));
        else {
            const key = await (0, $788668db41590f82$export$2dbe1b699c206fb)();
            await this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).BEACON_SDK_SECRET_SEED, key);
            this._keyPair.resolve(await (0, $efd1a952be4e6fd9$export$f73c212cf4258056)(key));
        }
    }
}



/* eslint-disable prefer-arrow/prefer-arrow-functions */ function $12abb68163582f3c$var$fixArrayType(array) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return array;
}
class $12abb68163582f3c$export$93525d6e221593cb {
    storage;
    storageKey;
    constructor(storage, storageKey){
        this.storage = storage;
        this.storageKey = storageKey;
    }
    async getAll() {
        return await this.storage.get(this.storageKey) ?? [];
    }
    async getOne(predicate) {
        const entities = await this.storage.get(this.storageKey);
        return $12abb68163582f3c$var$fixArrayType(entities).find(predicate);
    }
    async addOne(element, predicate, overwrite = true) {
        const entities = await this.storage.get(this.storageKey);
        if (!$12abb68163582f3c$var$fixArrayType(entities).some(predicate)) $12abb68163582f3c$var$fixArrayType(entities).push(element);
        else if (overwrite) {
            for(let i = 0; i < entities.length; i++)if (predicate($12abb68163582f3c$var$fixArrayType(entities)[i])) entities[i] = element;
        }
        return this.storage.set(this.storageKey, entities);
    }
    async remove(predicate) {
        const entities = await this.storage.get(this.storageKey);
        const filteredEntities = $12abb68163582f3c$var$fixArrayType(entities).filter((entity)=>!predicate(entity));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.storage.set(this.storageKey, filteredEntities);
    }
    async removeAll() {
        return this.storage.delete(this.storageKey);
    }
}







var $6ZWSX = parcelRequire("6ZWSX");
var $707e3c5710107d55$require$Buffer = $6ZWSX.Buffer;
const $707e3c5710107d55$export$f481d8b6bb80ca4a = async (address, network)=>{
    const data = [
        address,
        network.type
    ];
    if (network.name) data.push(`name:${network.name}`);
    if (network.rpcUrl) data.push(`rpc:${network.rpcUrl}`);
    const buffer = $707e3c5710107d55$require$Buffer.from((0, $b245bb78b1cc020b$export$d6af199866bfb566)((0, $9a00e3fafffa883b$export$c564cdbbe6da493)(data.join('-')), 10));
    return (0, $7e3a089a80d0b268$export$2e2bcd8739ae039).encode(buffer);
};


class $df75aef2bdc898cd$export$cd1abfdb09fcea85 {
    /**
     * Check if permissions were given for a certain message type.
     *
     * PermissionRequest and BroadcastRequest will always return true.
     *
     * @param message Beacon Message
     */ static async hasPermission(message, getOne, getAll) {
        switch(message.type){
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest:
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BroadcastRequest:
                return true;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).OperationRequest:
                {
                    const accountIdentifier = await (0, $707e3c5710107d55$export$f481d8b6bb80ca4a)(message.sourceAddress, message.network);
                    const permission = await getOne(accountIdentifier);
                    if (!permission) return false;
                    return permission.scopes.includes((0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).OPERATION_REQUEST);
                }
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SignPayloadRequest:
                {
                    const permissions = await getAll();
                    const filteredPermissions = permissions.filter((permission)=>permission.address === message.sourceAddress);
                    if (filteredPermissions.length === 0) return false;
                    return filteredPermissions.some((permission)=>permission.scopes.includes((0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).SIGN));
                }
            default:
                throw new Error('Message not handled');
        }
    }
}


class $d2313a5952bccbbc$export$a1e1c1cb52ebd7df {
    storageManager;
    constructor(storage){
        this.storageManager = new (0, $12abb68163582f3c$export$93525d6e221593cb)(storage, (0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ACCOUNTS);
    }
    async getAccounts() {
        return await this.storageManager.getAll() ?? [];
    }
    async getAccount(accountIdentifier) {
        return this.storageManager.getOne((account)=>account.accountIdentifier === accountIdentifier);
    }
    async addAccount(accountInfo) {
        return this.storageManager.addOne(accountInfo, (account)=>account.accountIdentifier === accountInfo.accountIdentifier);
    }
    async updateAccount(accountIdentifier, accountInfo) {
        const account = await this.getAccount(accountIdentifier);
        if (!account) return undefined;
        const newAccount = {
            ...account,
            ...accountInfo
        };
        await this.storageManager.addOne(newAccount, (account)=>account.accountIdentifier === accountIdentifier, true);
        return newAccount;
    }
    async removeAccount(accountIdentifier) {
        return this.storageManager.remove((account)=>account.accountIdentifier === accountIdentifier);
    }
    async removeAccounts(accountIdentifiers) {
        return this.storageManager.remove((account)=>accountIdentifiers.includes(account.accountIdentifier));
    }
    async removeAllAccounts() {
        return this.storageManager.removeAll();
    }
    async hasPermission(message) {
        return (0, $df75aef2bdc898cd$export$cd1abfdb09fcea85).hasPermission(message, this.getAccount.bind(this), this.getAccounts.bind(this));
    }
}





var $6ZWSX = parcelRequire("6ZWSX");
var $1c5c036caa7dc2d6$require$Buffer = $6ZWSX.Buffer;
const $1c5c036caa7dc2d6$var$isHex = (str)=>/^[A-F0-9]+$/i.test(str);
const $1c5c036caa7dc2d6$export$c00969587a4639cc = async (publicKey)=>{
    if (!$1c5c036caa7dc2d6$var$isHex(publicKey)) console.error('PublicKey needs to be in hex format!');
    const buffer = $1c5c036caa7dc2d6$require$Buffer.from((0, $b245bb78b1cc020b$export$d6af199866bfb566)($1c5c036caa7dc2d6$require$Buffer.from(publicKey, 'hex'), 5));
    return (0, $7e3a089a80d0b268$export$2e2bcd8739ae039).encode(buffer);
};



// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $cc2a2f18e399f759$var$debug = (0, $3d44e06f3373abda$export$32684078d75a1df3).beaconSdkDebugEnabled ? true : false;
if ($cc2a2f18e399f759$var$debug) // eslint-disable-next-line no-console
console.log('[BEACON]: Debug mode is ON (turned on either by the developer or a browser extension)');
const $cc2a2f18e399f759$export$be0ab11739306586 = (enabled)=>{
    $cc2a2f18e399f759$var$debug = enabled;
};
const $cc2a2f18e399f759$export$3606df0bc1582bc6 = ()=>$cc2a2f18e399f759$var$debug;


class $0b40dc7ca94909f1$export$62d4b28acaf09e3 {
    constructor(){}
    debug(name, method, ...args) {
        this._log('debug', name, method, args);
    }
    log(name, method, ...args) {
        this._log('log', name, method, args);
    }
    warn(name, method, ...args) {
        this._log('warn', name, method, args);
    }
    error(name, method, ...args) {
        this._log('error', name, method, args);
    }
    time(start, label) {
        start ? console.time(label) : console.timeEnd(label);
    }
    timeLog(name, method, ...args) {
        this._log('timeLog', name, method, args);
    }
    _log(type, name, method, args = []) {
        if (!(0, $cc2a2f18e399f759$export$3606df0bc1582bc6)()) return;
        let groupText = `[BEACON] ${new Date().toISOString()} [${name}](${method})`;
        let data = args;
        if (args[0] && typeof args[0] === 'string') {
            groupText += ` ${args[0]}`;
            data = args.slice(1);
        }
        switch(type){
            case 'error':
                console.group(groupText);
                console.error(...data);
                break;
            case 'warn':
                console.group(groupText);
                console.warn(...data);
                break;
            case 'debug':
                console.groupCollapsed(groupText);
                console.debug(...data);
                break;
            case 'timeLog':
                console.group(groupText);
                console.timeLog(...data);
                break;
            default:
                console.group(groupText);
                console.log(...data);
        }
        console.groupEnd();
    // echo.group(echo.asWarning(`[BEACON] ${message}`))
    // echo.log(echo.asWarning(`[${this.name}]`), echo.asAlert(`(${method})`), ...args)
    // echo.groupEnd()
    }
}
class $0b40dc7ca94909f1$export$efa9a398d6368992 {
    name;
    constructor(service){
        this.name = service;
    }
    debug(method, ...args) {
        $0b40dc7ca94909f1$var$logger.debug(this.name, method, args);
    }
    log(method, ...args) {
        $0b40dc7ca94909f1$var$logger.log(this.name, method, args);
    }
    warn(method, ...args) {
        $0b40dc7ca94909f1$var$logger.warn(this.name, method, args);
    }
    error(method, ...args) {
        $0b40dc7ca94909f1$var$logger.error(this.name, method, args);
    }
    time(start, label) {
        $0b40dc7ca94909f1$var$logger.time(start, label);
    }
    timeLog(method, ...args) {
        $0b40dc7ca94909f1$var$logger.timeLog(method, args);
    }
}
const $0b40dc7ca94909f1$var$loggerWrapper = new $0b40dc7ca94909f1$export$efa9a398d6368992('');
let $0b40dc7ca94909f1$var$logger = new $0b40dc7ca94909f1$export$62d4b28acaf09e3();
const $0b40dc7ca94909f1$export$3abbd92f765bee58 = (newLogger)=>{
    $0b40dc7ca94909f1$var$logger = newLogger;
};
const $0b40dc7ca94909f1$export$2b1d391cd05230fd = ()=>$0b40dc7ca94909f1$var$loggerWrapper;




var $6ZWSX = parcelRequire("6ZWSX");
var $33b837e22eef79cd$require$Buffer = $6ZWSX.Buffer;
class $33b837e22eef79cd$export$ef852775387a0be7 {
    /**
     * Serialize and bs58check encode an object
     *
     * @param message JSON object to serialize
     */ async serialize(message) {
        const str = JSON.stringify(message);
        return (0, $7e3a089a80d0b268$export$2e2bcd8739ae039).encode($33b837e22eef79cd$require$Buffer.from(str));
    }
    /**
     * Deserialize a bs58check encoded string
     *
     * @param encoded String to be deserialized
     */ async deserialize(encoded) {
        if (typeof encoded !== 'string') throw new Error('Encoded payload needs to be a string');
        const decodedBytes = (0, $7e3a089a80d0b268$export$2e2bcd8739ae039).decode(encoded);
        const jsonString = $33b837e22eef79cd$require$Buffer.from(decodedBytes).toString('utf8');
        return JSON.parse(jsonString);
    }
}


const $a9ae2c45e15f00d9$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('Client');
class $a9ae2c45e15f00d9$export$1f2bb630327ac4b6 extends (0, $71f80b0c8b14c62f$export$2ad4faf1649ff611) {
    accountManager;
    handleResponse;
    /**
     * How many requests can be sent after another
     */ rateLimit = 2;
    /**
     * The time window in seconds in which the "rateLimit" is checked
     */ rateLimitWindowInSeconds = 5;
    /**
     * Stores the times when requests have been made to determine if the rate limit has been reached
     */ requestCounter = [];
    matrixNodes;
    transportListeners = new Map();
    _transport = new (0, $247a3319916bcc85$export$babe85162c870d79)();
    get transport() {
        return this._transport.promise;
    }
    /**
     * Returns the connection status of the Client
     */ get connectionStatus() {
        return this._transport.promiseResult?.connectionStatus ?? (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).NOT_CONNECTED;
    }
    /**
     * Returns whether or not the transaport is ready
     */ get ready() {
        return this.transport.then(()=>undefined);
    }
    constructor(config){
        super(config);
        this.accountManager = new (0, $d2313a5952bccbbc$export$a1e1c1cb52ebd7df)(config.storage);
        this.matrixNodes = config.matrixNodes ?? {};
        this.handleResponse = (message, connectionInfo)=>{
            throw new Error(`not overwritten${JSON.stringify(message)} - ${JSON.stringify(connectionInfo)}`);
        };
    }
    async cleanup() {
        if (!this.transportListeners.size) return;
        if (this._transport.isResolved()) {
            const transport = await this.transport;
            await Promise.all(Array.from(this.transportListeners.values()).map((listener)=>transport.removeListener(listener)));
            this.transportListeners.clear();
        }
    }
    /**
     * Return all locally known accounts
     */ async getAccounts() {
        return this.accountManager.getAccounts();
    }
    /**
     * Return the account by ID
     * @param accountIdentifier The ID of an account
     */ async getAccount(accountIdentifier) {
        return this.accountManager.getAccount(accountIdentifier);
    }
    /**
     * Remove the account by ID
     * @param accountIdentifier The ID of an account
     */ async removeAccount(accountIdentifier) {
        return this.accountManager.removeAccount(accountIdentifier);
    }
    /**
     * Remove all locally stored accounts
     */ async removeAllAccounts() {
        return this.accountManager.removeAllAccounts();
    }
    /**
     * Add a new request (current timestamp) to the pending requests, remove old ones and check if we are above the limit
     */ async addRequestAndCheckIfRateLimited() {
        const now = new Date().getTime();
        this.requestCounter = this.requestCounter.filter((date)=>date + this.rateLimitWindowInSeconds * 1000 > now);
        this.requestCounter.push(now);
        return this.requestCounter.length > this.rateLimit;
    }
    /**
     * This method initializes the client. It will check if the connection should be established to a
     * browser extension or if the P2P transport should be used.
     *
     * @param transport A transport that can be provided by the user
     */ async init(transport) {
        if (this._transport.isResolved()) return (await this.transport).type;
        await this.setTransport(transport); // Let users define their own transport
        return transport.type;
    }
    /**
     * Returns the metadata of this DApp
     */ async getOwnAppMetadata() {
        return {
            senderId: await (0, $1c5c036caa7dc2d6$export$c00969587a4639cc)(await this.beaconId),
            name: this.name,
            icon: this.iconUrl
        };
    }
    /**
     * Return all known peers
     */ async getPeers() {
        return (await this.transport).getPeers();
    }
    /**
     * Add a new peer to the known peers
     * @param peer The new peer to add
     */ async addPeer(peer) {
        return (await this.transport).addPeer(peer);
    }
    async destroy() {
        if (this._transport.isResolved()) {
            const transport = await this.transport;
            await this.cleanup();
            await transport.disconnect();
            if (transport.type === (0, $809a8ab02b228419$export$6d07abd9f0bba447).WALLETCONNECT) await transport.doClientCleanup(); // any because I cannot import the type definition
        }
        await super.destroy();
    }
    /**
     * A "setter" for when the transport needs to be changed.
     */ async setTransport(transport) {
        if (transport) {
            if (this._transport.isSettled()) // If the promise has already been resolved we need to create a new one.
            this._transport = (0, $247a3319916bcc85$export$babe85162c870d79).resolve(transport);
            else this._transport.resolve(transport);
        } else if (this._transport.isSettled()) // If the promise has already been resolved we need to create a new one.
        this._transport = new (0, $247a3319916bcc85$export$babe85162c870d79)();
    }
    async addListener(transport) {
        // in beacon we subscribe to the transport on client init only
        // unsubscribing from the transport is only beneficial when running
        // a single page dApp.
        // However, while running a multiple tabs setup, if one of the dApps disconnects
        // the others wont't recover until after a page refresh
        if (this.transportListeners.has(transport.type)) await transport.removeListener(this.transportListeners.get(transport.type));
        const subscription = async (message, connectionInfo)=>{
            if (typeof message === 'string') {
                const deserializedMessage = await new (0, $33b837e22eef79cd$export$ef852775387a0be7)().deserialize(message);
                this.handleResponse(deserializedMessage, connectionInfo);
            }
        };
        this.transportListeners.set(transport.type, subscription);
        transport.addListener(subscription).catch((error)=>$a9ae2c45e15f00d9$var$logger.error('addListener', error));
    }
    async sendDisconnectToPeer(peer, transport) {
        const request = {
            id: await (0, $788668db41590f82$export$2dbe1b699c206fb)(),
            version: peer.version,
            senderId: await (0, $1c5c036caa7dc2d6$export$c00969587a4639cc)(await this.beaconId),
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Disconnect
        };
        const payload = await new (0, $33b837e22eef79cd$export$ef852775387a0be7)().serialize(request);
        const selectedTransport = transport ?? await this.transport;
        await selectedTransport.send(payload, peer);
    }
}


/**
 * @category Error
 */ class $7cd1853b2e4f31d9$export$284df2229217effd {
    name = 'BeaconError';
    message;
    title = 'Error';
    description;
    get fullDescription() {
        return {
            description: this.description
        };
    }
    constructor(errorType, message){
        this.message = `[${errorType}]:${message}`;
        this.description = message;
    }
}




class $a8f2b12327887c60$export$83044806d984e5c6 extends (0, $7cd1853b2e4f31d9$export$284df2229217effd) {
    name = 'BroadcastBeaconError';
    title = 'Broadcast Error';
    constructor(){
        super((0, $3402b71e229a176a$export$de39e3c3d623b630).BROADCAST_ERROR, 'The transaction could not be broadcast to the network. Please try again.');
    }
}




class $c12a9d2619de09b6$export$4dfb289da8bd09fd extends (0, $7cd1853b2e4f31d9$export$284df2229217effd) {
    name = 'NetworkNotSupportedBeaconError';
    title = 'Network Error';
    constructor(){
        super((0, $3402b71e229a176a$export$de39e3c3d623b630).NETWORK_NOT_SUPPORTED, 'The wallet does not support this network. Please select another one.');
    }
}




class $2d4716f275c51aca$export$9e81db5657a1f0a6 extends (0, $7cd1853b2e4f31d9$export$284df2229217effd) {
    name = 'NoAddressBeaconError';
    title = 'No Address';
    constructor(){
        super((0, $3402b71e229a176a$export$de39e3c3d623b630).NO_ADDRESS_ERROR, 'The wallet does not have an account set up. Please make sure to set up your wallet and try again.');
    }
}




class $d5ff984206213c6d$export$359c57fe9d5eb841 extends (0, $7cd1853b2e4f31d9$export$284df2229217effd) {
    name = 'NoPrivateKeyBeaconError';
    title = 'Account Not Found';
    constructor(){
        super((0, $3402b71e229a176a$export$de39e3c3d623b630).NO_PRIVATE_KEY_FOUND_ERROR, 'The account you are trying to interact with is not available. Please make sure to add the account to your wallet and try again.');
    }
}




class $2c896c9265630313$export$8e600e66f4af7f7d extends (0, $7cd1853b2e4f31d9$export$284df2229217effd) {
    name = 'NotGrantedBeaconError';
    title = 'Permission Not Granted';
    constructor(){
        super((0, $3402b71e229a176a$export$de39e3c3d623b630).NOT_GRANTED_ERROR, 'You do not have the necessary permissions to perform this action. Please initiate another permission request and give the necessary permissions.');
    }
}




class $771922e0933cb721$export$22b8fd83da8b102c extends (0, $7cd1853b2e4f31d9$export$284df2229217effd) {
    name = 'ParametersInvalidBeaconError';
    title = 'Parameters Invalid';
    constructor(){
        super((0, $3402b71e229a176a$export$de39e3c3d623b630).PARAMETERS_INVALID_ERROR, 'Some of the parameters you provided are invalid and the request could not be completed. Please check your inputs and try again.');
    }
}




class $bb6c701f563f39e3$export$6e17886767f6e528 extends (0, $7cd1853b2e4f31d9$export$284df2229217effd) {
    name = 'TooManyOperationsBeaconError';
    title = 'Too Many Operations';
    constructor(){
        super((0, $3402b71e229a176a$export$de39e3c3d623b630).TOO_MANY_OPERATIONS, 'The request contains too many transactions. Please include fewer operations and try again.');
    }
}




class $f1dd0b3b3b4e4035$export$123f0c5aa60e29ed extends (0, $7cd1853b2e4f31d9$export$284df2229217effd) {
    data;
    name = 'TransactionInvalidBeaconError';
    title = 'Transaction Invalid';
    get fullDescription() {
        return {
            description: this.description,
            data: JSON.stringify(this.data, undefined, 2)
        };
    }
    constructor(data){
        super((0, $3402b71e229a176a$export$de39e3c3d623b630).TRANSACTION_INVALID_ERROR, `The transaction is invalid and the node did not accept it.`);
        this.data = data;
        this.data = data;
    }
}




class $4e2584c02ef3f2b6$export$c9a8ac1e67341255 extends (0, $7cd1853b2e4f31d9$export$284df2229217effd) {
    name = 'UnknownBeaconError';
    title = 'Error';
    constructor(){
        super((0, $3402b71e229a176a$export$de39e3c3d623b630).UNKNOWN_ERROR, 'An unknown error occured. Please try again or report it to a developer.');
    }
}




const $58c6d5fc9cc0fe50$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('Transport');
class $58c6d5fc9cc0fe50$export$86495b081fef8e52 {
    /**
     * The type of the transport
     */ type = (0, $809a8ab02b228419$export$6d07abd9f0bba447).POST_MESSAGE;
    /**
     * The name of the app
     */ name;
    /**
     * The status of the transport
     */ _isConnected = (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).NOT_CONNECTED;
    peerManager;
    /**
     * The client handling the encryption/decryption of messages
     */ client;
    /**
     * The listener that will be invoked when a new peer is connected
     */ newPeerListener;
    setEventHandler(event, fun) {
        this.client.eventHandlers.set(event, fun);
    }
    /**
     * The listeners that will be notified when new messages are coming in
     */ listeners = [];
    /**
     * Return the status of the connection
     */ get connectionStatus() {
        return this._isConnected;
    }
    constructor(name, client, peerManager){
        this.name = name;
        this.client = client;
        this.peerManager = peerManager;
    }
    /**
     * Returns a promise that resolves to true if the transport is available, false if it is not
     */ static async isAvailable() {
        return Promise.resolve(false);
    }
    /**
     * Connect the transport
     */ async connect() {
        $58c6d5fc9cc0fe50$var$logger.log('connect');
        this._isConnected = (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).CONNECTED;
        return;
    }
    /**
     * Disconnect the transport
     */ async disconnect() {
        $58c6d5fc9cc0fe50$var$logger.log('disconnect');
        this._isConnected = (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).NOT_CONNECTED;
        return;
    }
    /**
     * Send a message through the transport
     *
     * @param message The message to send
     * @param recipient The recipient of the message
     */ async send(message, peer) {
        if (peer) return this.client.sendMessage(message, peer);
        else {
            const knownPeers = await this.getPeers();
            // A broadcast request has to be sent everywhere.
            const promises = knownPeers.map((peerEl)=>this.client.sendMessage(message, peerEl));
            return (await Promise.all(promises))[0];
        }
    }
    /**
     * Add a listener to be called when a new message is received
     *
     * @param listener The listener that will be registered
     */ async addListener(listener) {
        $58c6d5fc9cc0fe50$var$logger.debug('addListener');
        this.listeners.push(listener);
        return;
    }
    /**
     * Remove a listener
     *
     * @param listener
     */ async removeListener(listener) {
        $58c6d5fc9cc0fe50$var$logger.log('removeListener');
        this.listeners = this.listeners.filter((element)=>element !== listener);
        return;
    }
    async getPeers() {
        return this.peerManager.getPeers(); // TODO: Fix type
    }
    async addPeer(newPeer, _sendPairingResponse = true) {
        $58c6d5fc9cc0fe50$var$logger.log('addPeer', 'adding peer', newPeer);
        await this.peerManager.addPeer(newPeer); // TODO: Fix type
        await this.listen(newPeer.publicKey);
    }
    async removePeer(peerToBeRemoved) {
        $58c6d5fc9cc0fe50$var$logger.log('removePeer', 'removing peer', peerToBeRemoved);
        await this.peerManager.removePeer(peerToBeRemoved.publicKey);
        if (this.client) await this.client.unsubscribeFromEncryptedMessage(peerToBeRemoved.publicKey);
    }
    async removeAllPeers() {
        $58c6d5fc9cc0fe50$var$logger.log('removeAllPeers');
        await this.peerManager.removeAllPeers();
        if (this.client) await this.client.unsubscribeFromEncryptedMessages();
    }
    /**
     * Notify the listeners when a new message comes in
     *
     * @param message Message
     * @param connectionInfo Context info about the connection
     */ async notifyListeners(message, connectionInfo) {
        if (this.listeners.length === 0) $58c6d5fc9cc0fe50$var$logger.warn('notifyListeners', '0 listeners notified!', this);
        else $58c6d5fc9cc0fe50$var$logger.log('notifyListeners', `Notifying ${this.listeners.length} listeners`, this);
        this.listeners.forEach((listener)=>{
            listener(message, connectionInfo);
        });
        return;
    }
}



class $12d71ead7a4bed26$export$842b4516e1b4dcd5 {
    static async isSupported() {
        return typeof window !== 'undefined' && typeof chrome !== 'undefined' && Boolean(chrome) && Boolean(chrome.runtime) && Boolean(chrome.runtime.id);
    }
    async get(key) {
        return new Promise((resolve)=>{
            chrome.storage.local.get(null, (storageContent)=>{
                if (storageContent[key]) resolve(storageContent[key]);
                else if (typeof (0, $4b201e2d090578e5$export$7e292eecf5a8f340)[key] === 'object') resolve(JSON.parse(JSON.stringify((0, $4b201e2d090578e5$export$7e292eecf5a8f340)[key])));
                else resolve((0, $4b201e2d090578e5$export$7e292eecf5a8f340)[key]);
            });
        });
    }
    async set(key, value) {
        return new Promise((resolve)=>{
            chrome.storage.local.set({
                [key]: value
            }, ()=>{
                resolve();
            });
        });
    }
    async delete(key) {
        return new Promise((resolve)=>{
            chrome.storage.local.set({
                [key]: undefined
            }, ()=>{
                resolve();
            });
        });
    }
    async subscribeToStorageChanged(_callback) {
    // TODO
    }
    getPrefixedKey(key) {
        return key;
    }
}



class $59e826bfd354e77a$export$19fffca37ef3e106 extends (0, $78be7a0343b19772$export$bf2a15d34f3c441c) {
    prefix;
    constructor(prefix){
        super();
        this.prefix = prefix;
    }
    static async isSupported() {
        return Promise.resolve(Boolean(typeof window !== 'undefined') && Boolean(window.localStorage));
    }
    async get(key) {
        const value = localStorage.getItem(this.getPrefixedKey(key));
        if (!value) {
            if (typeof (0, $4b201e2d090578e5$export$7e292eecf5a8f340)[key] === 'object') return JSON.parse(JSON.stringify((0, $4b201e2d090578e5$export$7e292eecf5a8f340)[key]));
            else return (0, $4b201e2d090578e5$export$7e292eecf5a8f340)[key];
        } else try {
            return JSON.parse(value);
        } catch (jsonParseError) {
            return value; // TODO: Validate storage
        }
    }
    async set(key, value) {
        if (typeof value === 'string') return localStorage.setItem(this.getPrefixedKey(key), value);
        else return localStorage.setItem(this.getPrefixedKey(key), JSON.stringify(value));
    }
    async delete(key) {
        return Promise.resolve(localStorage.removeItem(this.getPrefixedKey(key)));
    }
    async subscribeToStorageChanged(callback) {
        window.addEventListener('storage', (event)=>{
            if (!event.key) callback({
                eventType: 'storageCleared',
                key: null,
                oldValue: null,
                newValue: null
            });
            else callback({
                eventType: 'entryModified',
                key: this.getPrefixedKey(event.key),
                oldValue: event.oldValue,
                newValue: event.newValue
            });
        }, false);
    }
    getPrefixedKey(key) {
        return this.prefix ? `${this.prefix}-${key}` : key;
    }
}





const $e4d006f43cc3035e$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('STORAGE');
const $e4d006f43cc3035e$export$fbd9b57a66480737 = async ()=>{
    if (await (0, $12d71ead7a4bed26$export$842b4516e1b4dcd5).isSupported()) {
        $e4d006f43cc3035e$var$logger.log('getStorage', 'USING CHROME STORAGE');
        return new (0, $12d71ead7a4bed26$export$842b4516e1b4dcd5)();
    } else if (await (0, $59e826bfd354e77a$export$19fffca37ef3e106).isSupported()) {
        $e4d006f43cc3035e$var$logger.log('getStorage', 'USING LOCAL STORAGE');
        return new (0, $59e826bfd354e77a$export$19fffca37ef3e106)();
    } else throw new Error('no storage type supported');
};







class $8f0d28279074bcb8$export$50a53e4bf19e8f0f {
    storageManager;
    constructor(storage){
        this.storageManager = new (0, $12abb68163582f3c$export$93525d6e221593cb)(storage, (0, $8d1a6d1de5294bad$export$2fdc5139b636713c).APP_METADATA_LIST);
    }
    async getAppMetadataList() {
        return await this.storageManager.getAll() ?? [];
    }
    async getAppMetadata(senderId) {
        return this.storageManager.getOne((appMetadata)=>appMetadata.senderId === senderId);
    }
    async addAppMetadata(appMetadata) {
        return this.storageManager.addOne(appMetadata, (appMetadataElement)=>appMetadataElement.senderId === appMetadata.senderId);
    }
    async removeAppMetadata(senderId) {
        return this.storageManager.remove((appMetadata)=>appMetadata.senderId === senderId);
    }
    async removeAppMetadatas(senderIds) {
        return this.storageManager.remove((appMetadata)=>senderIds.includes(appMetadata.senderId));
    }
    async removeAllAppMetadata() {
        return this.storageManager.removeAll();
    }
}





class $6fdebab29f931b92$export$46a505c858cc753 {
    storageManager;
    constructor(storage){
        this.storageManager = new (0, $12abb68163582f3c$export$93525d6e221593cb)(storage, (0, $8d1a6d1de5294bad$export$2fdc5139b636713c).PERMISSION_LIST);
    }
    async getPermissions() {
        return await this.storageManager.getAll() ?? [];
    }
    async getPermission(accountIdentifier) {
        return this.storageManager.getOne((permission)=>permission.accountIdentifier === accountIdentifier);
    }
    async addPermission(permissionInfo) {
        return this.storageManager.addOne(permissionInfo, (permission)=>permission.accountIdentifier === permissionInfo.accountIdentifier && permission.senderId === permissionInfo.senderId);
    }
    async removePermission(accountIdentifier, senderId) {
        return this.storageManager.remove((permission)=>permission.accountIdentifier === accountIdentifier && permission.senderId === senderId);
    }
    async removePermissions(accountIdentifiers) {
        return this.storageManager.remove((permission)=>accountIdentifiers.includes(permission.accountIdentifier));
    }
    async removeAllPermissions() {
        return this.storageManager.removeAll();
    }
    async hasPermission(message) {
        return (0, $df75aef2bdc898cd$export$cd1abfdb09fcea85).hasPermission(message, this.getPermission.bind(this), this.getPermissions.bind(this));
    }
}






class $6bd82097f645d3eb$export$4e7a6be3179f008e extends (0, $7cd1853b2e4f31d9$export$284df2229217effd) {
    name = 'UnknownBeaconError';
    title = 'Aborted';
    constructor(){
        super((0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR, 'The action was aborted by the user.');
    }
}




class $3514bc91c0d3d509$export$a1f30c6c22927bc5 {
    storageManager;
    constructor(storage, key){
        this.storageManager = new (0, $12abb68163582f3c$export$93525d6e221593cb)(storage, key);
    }
    async hasPeer(publicKey) {
        return await this.getPeer(publicKey) ? true : false;
    }
    async getPeers() {
        return await this.storageManager.getAll() ?? [];
    }
    async getPeer(publicKey) {
        return this.storageManager.getOne((peer)=>peer.publicKey === publicKey);
    }
    async addPeer(peerInfo) {
        return this.storageManager.addOne(peerInfo, (peer)=>peer.publicKey === peerInfo.publicKey);
    }
    async removePeer(publicKey) {
        return this.storageManager.remove((peer)=>peer.publicKey === publicKey);
    }
    async removePeers(publicKeys) {
        return this.storageManager.remove((peer)=>publicKeys.includes(peer.publicKey));
    }
    async removeAllPeers() {
        return this.storageManager.removeAll();
    }
}






// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
/**
 * Package x25519-session implements libsodium compatible session keys generation based on X25519 key agreement.
 */ 

// Copyright (C) 2020 Dmitry Chestnykh
// MIT License. See LICENSE file for details.




const $6a1bb68479f405be$export$b450c7d57523b59e = (0, $569072827d3d60aa$export$84fc0a248cc54343);
const $6a1bb68479f405be$export$6c11d9fa84add682 = (0, $569072827d3d60aa$export$84fc0a248cc54343);
const $6a1bb68479f405be$export$6df05fba8f98cca6 = (0, $569072827d3d60aa$export$f2bd165db7344603);
const $6a1bb68479f405be$export$1de0867f115ad93a = (0, $569072827d3d60aa$export$f2bd165db7344603);
class $6a1bb68479f405be$export$8b3592934d44d23a {
    offerMessageLength = $6a1bb68479f405be$export$b450c7d57523b59e;
    acceptMessageLength = $6a1bb68479f405be$export$6c11d9fa84add682;
    sharedKeyLength = (0, $569072827d3d60aa$export$8c9eeea810e9635e);
    savedStateLength = $6a1bb68479f405be$export$6df05fba8f98cca6;
    _seed;
    _keyPair;
    _sharedKey;
    _sessionKeys;
    constructor(secretSeed, prng){
        this._seed = secretSeed || (0, $73945d82524e104e$export$5f828d93ff035aa8)((0, $569072827d3d60aa$export$f2bd165db7344603), prng);
    }
    saveState() {
        return new Uint8Array(this._seed);
    }
    restoreState(savedState) {
        this._seed = new Uint8Array(savedState);
        return this;
    }
    clean() {
        if (this._seed) (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._seed);
        if (this._keyPair) {
            (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._keyPair.secretKey);
            (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._keyPair.publicKey);
        }
        if (this._sharedKey) (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._sharedKey);
        if (this._sessionKeys) {
            (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._sessionKeys.receive);
            (0, $276678191c4bdb56$export$46890c41d2ad591f)(this._sessionKeys.send);
        }
    }
    offer() {
        this._keyPair = (0, $569072827d3d60aa$export$b260aa5f705622f1)(this._seed);
        return new Uint8Array(this._keyPair.publicKey);
    }
    accept(offerMsg) {
        if (this._keyPair) throw new Error("X25519Session: accept shouldn't be called by offering party");
        if (offerMsg.length !== this.offerMessageLength) throw new Error("X25519Session: incorrect offer message length");
        if (this._sharedKey) throw new Error("X25519Session: accept was already called");
        const keyPair = (0, $569072827d3d60aa$export$b260aa5f705622f1)(this._seed);
        this._sharedKey = (0, $569072827d3d60aa$export$433046d8e52fa655)(keyPair.secretKey, offerMsg);
        this._sessionKeys = (0, $4ae79cb46d23e1f3$export$c0efc6493fb8743b)(this._sharedKey, keyPair.publicKey, offerMsg);
        (0, $276678191c4bdb56$export$46890c41d2ad591f)(keyPair.secretKey);
        return keyPair.publicKey;
    }
    finish(acceptMsg) {
        if (acceptMsg.length !== this.acceptMessageLength) throw new Error("X25519Session: incorrect accept message length");
        if (!this._keyPair) throw new Error("X25519Session: no offer state");
        if (this._sharedKey) throw new Error("X25519Session: finish was already called");
        this._sharedKey = (0, $569072827d3d60aa$export$433046d8e52fa655)(this._keyPair.secretKey, acceptMsg);
        this._sessionKeys = (0, $4ae79cb46d23e1f3$export$6590f8f7eb5e071f)(this._sharedKey, this._keyPair.publicKey, acceptMsg);
        return this;
    }
    getSharedKey() {
        if (!this._sharedKey) throw new Error("X25519Session: no shared key established");
        return new Uint8Array(this._sharedKey);
    }
    getSessionKeys() {
        if (!this._sessionKeys) throw new Error("X25519Session: no shared key established");
        return {
            receive: new Uint8Array(this._sessionKeys.receive),
            send: new Uint8Array(this._sessionKeys.send)
        };
    }
}


const $4ae79cb46d23e1f3$var$SESSION_KEY_LENGTH = 32;
function $4ae79cb46d23e1f3$export$6590f8f7eb5e071f(sharedKey, myPublicKey, theirPublicKey, hash = (0, $b245bb78b1cc020b$export$5ad32252b3508605)) {
    const state = new hash();
    if (state.digestLength !== $4ae79cb46d23e1f3$var$SESSION_KEY_LENGTH * 2) throw new Error("X25519: incorrect digest length");
    const h = state.update(sharedKey).update(theirPublicKey).update(myPublicKey).digest();
    return {
        send: h.subarray(0, $4ae79cb46d23e1f3$var$SESSION_KEY_LENGTH),
        receive: h.subarray($4ae79cb46d23e1f3$var$SESSION_KEY_LENGTH)
    };
}
function $4ae79cb46d23e1f3$export$c0efc6493fb8743b(sharedKey, myPublicKey, theirPublicKey, hash = (0, $b245bb78b1cc020b$export$5ad32252b3508605)) {
    const state = new hash();
    if (state.digestLength !== $4ae79cb46d23e1f3$var$SESSION_KEY_LENGTH * 2) throw new Error("X25519: incorrect digest length");
    const h = state.update(sharedKey).update(myPublicKey).update(theirPublicKey).digest();
    return {
        receive: h.subarray(0, $4ae79cb46d23e1f3$var$SESSION_KEY_LENGTH),
        send: h.subarray($4ae79cb46d23e1f3$var$SESSION_KEY_LENGTH)
    };
}
function $4ae79cb46d23e1f3$export$6de1e09a61521efd(myKeyPair, theirPublicKey, hash = (0, $b245bb78b1cc020b$export$5ad32252b3508605)) {
    const sk = (0, $569072827d3d60aa$export$433046d8e52fa655)(myKeyPair.secretKey, theirPublicKey);
    return $4ae79cb46d23e1f3$export$6590f8f7eb5e071f(sk, myKeyPair.publicKey, theirPublicKey, hash);
}
function $4ae79cb46d23e1f3$export$aeb791607e45ce87(myKeyPair, theirPublicKey, hash = (0, $b245bb78b1cc020b$export$5ad32252b3508605)) {
    const sk = (0, $569072827d3d60aa$export$433046d8e52fa655)(myKeyPair.secretKey, theirPublicKey);
    return $4ae79cb46d23e1f3$export$c0efc6493fb8743b(sk, myKeyPair.publicKey, theirPublicKey, hash);
}



var $6ZWSX = parcelRequire("6ZWSX");
var $a78bfde4d24b2c3a$require$Buffer = $6ZWSX.Buffer;
class $a78bfde4d24b2c3a$export$ff98bc0bfc6c5f28 {
    keyPair;
    constructor(keyPair){
        this.keyPair = keyPair;
    }
    eventHandlers = new Map();
    // todo move OS
    isMobileOS = ()=>/(Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet|Windows Phone|SymbianOS|Kindle)/i.test(navigator.userAgent);
    /**
     * Get the public key
     */ async getPublicKey() {
        return (0, $efd1a952be4e6fd9$export$7ea66e3774a60b67)(this.keyPair?.publicKey);
    }
    /**
     * get the public key hash
     */ async getPublicKeyHash() {
        return (0, $efd1a952be4e6fd9$export$c3338cbceb8bf393)(this.keyPair.publicKey);
    }
    /**
     * Create a cryptobox server
     *
     * @param otherPublicKey
     * @param selfKeypair
     */ async createCryptoBoxServer(otherPublicKey, selfKeypair) {
        return (0, $4ae79cb46d23e1f3$export$6de1e09a61521efd)({
            publicKey: (0, $a1d7ebd43ba0a83c$export$4cf9eeb5c9f6edbd)(selfKeypair.publicKey),
            secretKey: (0, $a1d7ebd43ba0a83c$export$72e55b4de13bdf7c)(selfKeypair.secretKey)
        }, (0, $a1d7ebd43ba0a83c$export$4cf9eeb5c9f6edbd)($a78bfde4d24b2c3a$require$Buffer.from(otherPublicKey, 'hex')));
    }
    /**
     * Create a cryptobox client
     *
     * @param otherPublicKey
     * @param selfKeypair
     */ async createCryptoBoxClient(otherPublicKey, selfKeypair) {
        return (0, $4ae79cb46d23e1f3$export$aeb791607e45ce87)({
            publicKey: (0, $a1d7ebd43ba0a83c$export$4cf9eeb5c9f6edbd)(selfKeypair.publicKey),
            secretKey: (0, $a1d7ebd43ba0a83c$export$72e55b4de13bdf7c)(selfKeypair.secretKey)
        }, (0, $a1d7ebd43ba0a83c$export$4cf9eeb5c9f6edbd)($a78bfde4d24b2c3a$require$Buffer.from(otherPublicKey, 'hex')));
    }
    /**
     * Encrypt a message for a specific publicKey (receiver, asymmetric)
     *
     * @param recipientPublicKey
     * @param message
     */ async encryptMessageAsymmetric(recipientPublicKey, message) {
        return (0, $efd1a952be4e6fd9$export$fcde1af43ae5282f)(message, $a78bfde4d24b2c3a$require$Buffer.from(recipientPublicKey, 'hex'));
    }
}




var $6ZWSX = parcelRequire("6ZWSX");
var $cff0a1e4c122e64c$require$Buffer = $6ZWSX.Buffer;
class $cff0a1e4c122e64c$export$b4ec959cd561194a extends (0, $a78bfde4d24b2c3a$export$ff98bc0bfc6c5f28) {
    name;
    constructor(name, keyPair){
        super(keyPair);
        this.name = name;
        this.init().catch(console.error);
    }
    /**
     * start the client and make sure all dependencies are ready
     */ async start() {
        await Promise.resolve();
    }
    /**
     * Get the pairing request information. This will be shared with the peer during the connection setup
     */ async getPairingRequestInfo() {
        return new (0, $ce56bdceace47856$export$556bd87f142daf0c)(await (0, $788668db41590f82$export$2dbe1b699c206fb)(), this.name, await this.getPublicKey(), (0, $217f751cff903b1b$export$2220237b3fa2434a));
    }
    /**
     * Get the pairing response information. This will be shared with the peer during the connection setup
     */ async getPairingResponseInfo(request) {
        return new (0, $1ff34411b45f2011$export$765ddbee55ef88ad)(request.id, this.name, await this.getPublicKey(), request.version);
    }
    /**
     * Unsubscribe from encrypted messages from a specific peer
     *
     * @param senderPublicKey
     */ async unsubscribeFromEncryptedMessage(senderPublicKey) {
        const listener = this.activeListeners.get(senderPublicKey);
        if (!listener) return;
        this.activeListeners.delete(senderPublicKey);
    }
    /**
     * Unsubscribe from all encrypted messages
     */ async unsubscribeFromEncryptedMessages() {
        this.activeListeners.clear();
    }
    /**
     * Decrypt a message from a specific peer
     *
     * @param senderPublicKey
     * @param payload
     */ async decryptMessage(senderPublicKey, payload) {
        const sharedKey = await this.createCryptoBoxServer(senderPublicKey, this.keyPair);
        const hexPayload = $cff0a1e4c122e64c$require$Buffer.from(payload, 'hex');
        if (hexPayload.length >= (0, $15a40981d98388e5$export$5a119edad5f33470) + (0, $15a40981d98388e5$export$a5d0660c4a35a096)) try {
            return await (0, $efd1a952be4e6fd9$export$b8de54a33cec1158)(hexPayload, sharedKey.receive);
        } catch (decryptionError) {
        /* NO-OP. We try to decode every message, but some might not be addressed to us. */ }
        throw new Error('Could not decrypt message');
    }
    /**
     * Encrypt a message for a specific publicKey (receiver)
     *
     * @param recipientPublicKey
     * @param message
     */ async encryptMessage(recipientPublicKey, message) {
        const sharedKey = await this.createCryptoBoxClient(recipientPublicKey, this.keyPair);
        return (0, $efd1a952be4e6fd9$export$e46cb313f94b0706)(message, sharedKey.send);
    }
}





class $057c875aca7f70a9$export$3fbf9393208a93de extends (0, $7cd1853b2e4f31d9$export$284df2229217effd) {
    name = 'SignatureTypeNotSupportedBeaconError';
    title = 'Signature Type Not Supported';
    constructor(){
        super((0, $3402b71e229a176a$export$de39e3c3d623b630).SIGNATURE_TYPE_NOT_SUPPORTED, 'The wallet is not able to sign payloads of this type.');
    }
}









const $15e359ec5ec6b30e$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('IndexedDBStorage');
class $15e359ec5ec6b30e$export$685d695cbf574ee8 extends (0, $78be7a0343b19772$export$bf2a15d34f3c441c) {
    dbName;
    storeNames;
    db = null;
    isSupported = true;
    /**
     * @param dbName Name of the database.
     * @param storeNames An array of object store names to create in the database.
     *                   The first store in the array will be used as the default if none is specified.
     */ constructor(dbName = 'WALLET_CONNECT_V2_INDEXED_DB', storeNames = [
        'keyvaluestorage'
    ]){
        super();
        this.dbName = dbName;
        this.storeNames = storeNames;
        this.initDB().then((db)=>this.db = db).catch((err)=>$15e359ec5ec6b30e$var$logger.error(err.message));
    }
    isIndexedDBSupported() {
        if (typeof window !== 'undefined' && 'indexedDB' in window) {
            $15e359ec5ec6b30e$var$logger.log('isIndexedDBSupported', 'IndexedDB is supported in this browser.');
            return true;
        } else {
            $15e359ec5ec6b30e$var$logger.error('isIndexedDBSupported', 'IndexedDB is not supported in this browser.');
            return false;
        }
    }
    async initDB() {
        return new Promise((resolve, reject)=>{
            this.isSupported = this.isIndexedDBSupported();
            if (!this.isSupported) {
                reject('IndexedDB is not supported.');
                return;
            }
            const openRequest = indexedDB.open(this.dbName);
            openRequest.onupgradeneeded = ()=>{
                const db = openRequest.result;
                // Create all required object stores
                this.storeNames.forEach((storeName)=>{
                    if (!db.objectStoreNames.contains(storeName)) db.createObjectStore(storeName);
                });
            };
            openRequest.onsuccess = (event)=>{
                const db = event.target.result;
                // Check if all stores exist – if not, perform an upgrade.
                const missingStores = this.storeNames.filter((storeName)=>!db.objectStoreNames.contains(storeName));
                if (missingStores.length > 0) {
                    db.close();
                    const newVersion = db.version + 1;
                    const upgradeRequest = indexedDB.open(this.dbName, newVersion);
                    upgradeRequest.onupgradeneeded = ()=>{
                        const upgradedDB = upgradeRequest.result;
                        missingStores.forEach((storeName)=>{
                            if (!upgradedDB.objectStoreNames.contains(storeName)) upgradedDB.createObjectStore(storeName);
                        });
                    };
                    upgradeRequest.onsuccess = (event)=>{
                        this.db = event.target.result;
                        resolve(this.db);
                    };
                    upgradeRequest.onerror = (event)=>reject(event.target.error);
                } else {
                    this.db = db;
                    resolve(db);
                }
            };
            openRequest.onerror = (event)=>reject(event.target.error);
        });
    }
    /**
     * Performs a transaction on the given object store.
     * @param mode Transaction mode.
     * @param storeName The name of the object store.
     * @param operation The operation to perform with the object store.
     */ async transaction(mode, storeName, operation) {
        return new Promise((resolve, reject)=>{
            if (!this.isSupported) {
                reject('IndexedDB is not supported.');
                return;
            }
            if (!this.db?.objectStoreNames.contains(storeName)) {
                reject(`${storeName} not found. error: ${new Error().stack}`);
                return;
            }
            const transaction = this.db.transaction(storeName, mode);
            const objectStore = transaction.objectStore(storeName);
            operation(objectStore).then(resolve).catch(reject);
        });
    }
    get(key, storeName = this.storeNames[0]) {
        return this.transaction('readonly', storeName, (store)=>new Promise((resolve, reject)=>{
                const getRequest = store.get(key);
                getRequest.onsuccess = ()=>resolve(getRequest.result);
                getRequest.onerror = ()=>reject(getRequest.error);
            }));
    }
    set(key, value, storeName = this.storeNames[0]) {
        return this.transaction('readwrite', storeName, (store)=>new Promise((resolve, reject)=>{
                const putRequest = store.put(value, key);
                putRequest.onsuccess = ()=>resolve();
                putRequest.onerror = ()=>reject(putRequest.error);
            }));
    }
    delete(key, storeName = this.storeNames[0]) {
        return this.transaction('readwrite', storeName, (store)=>new Promise((resolve, reject)=>{
                const deleteRequest = store.delete(key);
                deleteRequest.onsuccess = ()=>resolve();
                deleteRequest.onerror = ()=>reject(deleteRequest.error);
            }));
    }
    /**
     * Retrieves all values from the specified object store.
     */ getAll(storeName) {
        return this.transaction('readonly', storeName || this.storeNames[0], (store)=>new Promise((resolve, reject)=>{
                const getAllRequest = store.getAll();
                getAllRequest.onsuccess = ()=>resolve(getAllRequest.result);
                getAllRequest.onerror = ()=>reject(getAllRequest.error);
            }));
    }
    /**
     * Retrieves all keys from the specified object store.
     */ getAllKeys(storeName) {
        return this.transaction('readonly', storeName || this.storeNames[0], (store)=>new Promise((resolve, reject)=>{
                const getAllKeysRequest = store.getAllKeys();
                getAllKeysRequest.onsuccess = ()=>resolve(getAllKeysRequest.result);
                getAllKeysRequest.onerror = ()=>reject(getAllKeysRequest.error);
            }));
    }
    /**
     * Clears all entries from the specified object store.
     */ clearStore(storeName) {
        return this.transaction('readwrite', storeName || this.storeNames[0], (store)=>new Promise((resolve, reject)=>{
                const clearRequest = store.clear();
                clearRequest.onsuccess = ()=>resolve();
                clearRequest.onerror = ()=>reject(clearRequest.error);
            }));
    }
    getPrefixedKey(key) {
        $15e359ec5ec6b30e$var$logger.debug('getPrefixedKey', key);
        throw new Error('Method not implemented.');
    }
    subscribeToStorageChanged(callback) {
        $15e359ec5ec6b30e$var$logger.debug('subscribeToStorageEvent', callback);
        throw new Error('Method not implemented.');
    }
    /**
     * Copies all key/value pairs from the source store into a target store.
     * @param targetDBName Name of the target database.
     * @param targetStoreName Name of the target object store.
     * @param skipKeys Keys to skip.
     * @param sourceStoreName (Optional) Source store name – defaults to the default store.
     */ async fillStore(targetDBName, targetStoreName, skipKeys = [], sourceStoreName = this.storeNames[0]) {
        if (!this.isSupported) {
            $15e359ec5ec6b30e$var$logger.error('fillStore', 'IndexedDB not supported.');
            return;
        }
        const targetDBRequest = indexedDB.open(targetDBName);
        targetDBRequest.onerror = (event)=>{
            throw new Error(`Failed to open target database: ${event.target.error}`);
        };
        const targetDB = await new Promise((resolve, reject)=>{
            targetDBRequest.onsuccess = (event)=>resolve(event.target.result);
            targetDBRequest.onerror = (event)=>reject(event.target.error);
        });
        // Copy items from the source store to the target store, skipping any specified keys.
        await this.transaction('readonly', sourceStoreName, async (sourceStore)=>{
            const getAllRequest = sourceStore.getAll();
            const getAllKeysRequest = sourceStore.getAllKeys();
            getAllRequest.onsuccess = async ()=>{
                getAllKeysRequest.onsuccess = async ()=>{
                    const items = getAllRequest.result;
                    const keys = getAllKeysRequest.result;
                    if (!targetDB.objectStoreNames.contains(targetStoreName)) {
                        $15e359ec5ec6b30e$var$logger.error(`${targetStoreName} not found. ${new Error().stack}`);
                        return;
                    }
                    const targetTransaction = targetDB.transaction(targetStoreName, 'readwrite');
                    const targetStore = targetTransaction.objectStore(targetStoreName);
                    keys.filter((key)=>!skipKeys.includes(key.toString())).forEach((key, index)=>{
                        targetStore.put(items[index], key);
                    });
                    targetTransaction.onerror = (event)=>{
                        $15e359ec5ec6b30e$var$logger.error('Transaction error: ', event.target.error);
                    };
                };
            };
            getAllKeysRequest.onerror = ()=>{
                $15e359ec5ec6b30e$var$logger.error('Failed to getAllKeys from source:', getAllKeysRequest.error);
            };
            getAllRequest.onerror = ()=>{
                $15e359ec5ec6b30e$var$logger.error('Failed to getAll from source:', getAllRequest.error);
            };
        });
    }
}


class $1fb6b7142554ff86$export$3095297bb9e84116 {
    localStorage = new (0, $59e826bfd354e77a$export$19fffca37ef3e106)();
    indexedDB = new (0, $15e359ec5ec6b30e$export$685d695cbf574ee8)();
    channel = new BroadcastChannel('WALLET_CONNECT_V2_INDEXED_DB');
    onMessageHandler;
    onErrorHandler;
    constructor(){
        this.channel.onmessage = this.onMessage.bind(this);
        this.channel.onmessageerror = this.onError.bind(this);
    }
    onMessage(message) {
        this.onMessageHandler && this.onMessageHandler(message.data.type);
    }
    onError({ data: data }) {
        this.onErrorHandler && this.onErrorHandler(data);
    }
    notify(type) {
        this.channel?.postMessage({
            type: type
        });
    }
    async hasPairings() {
        const pairings = await this.indexedDB.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_PAIRING) ?? '[]';
        if (pairings.length) return true;
        if (await (0, $59e826bfd354e77a$export$19fffca37ef3e106).isSupported()) return (await this.localStorage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_PAIRING) ?? '[]') !== '[]';
        return false;
    }
    async hasSessions() {
        const sessions = await this.indexedDB.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CLIENT_SESSION) ?? '[]';
        if (sessions.length) return true;
        if (await (0, $59e826bfd354e77a$export$19fffca37ef3e106).isSupported()) return (await this.localStorage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CLIENT_SESSION) ?? '[]') !== '[]';
        return false;
    }
    backup() {
        this.indexedDB.fillStore('beacon', 'bug_report', [
            (0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_KEYCHAIN
        ]).catch((error)=>console.error(error.message));
    }
    async resetState() {
        await this.indexedDB.clearStore();
        if (await (0, $59e826bfd354e77a$export$19fffca37ef3e106).isSupported()) await Promise.all([
            this.localStorage.delete((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CLIENT_SESSION),
            this.localStorage.delete((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_PAIRING),
            this.localStorage.delete((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_KEYCHAIN),
            this.localStorage.delete((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_MESSAGES),
            this.localStorage.delete((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CLIENT_PROPOSAL),
            this.localStorage.delete((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_SUBSCRIPTION),
            this.localStorage.delete((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_HISTORY),
            this.localStorage.delete((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_2_CORE_EXPIRER)
        ]);
    }
}




class $742007c4a02b555f$export$8683b41bf72c2f8a {
    storage;
    constructor(storage){
        this.storage = storage;
    }
    validateNumber(param) {
        return typeof param === 'number' && !isNaN(param);
    }
    validateText(param) {
        return typeof param === 'string';
    }
    validateBoolean(param) {
        return typeof param === 'boolean';
    }
    validateArray(param) {
        return Array.isArray(param);
    }
    objHasProperty(obj, path) {
        if (!obj) return false; // Return false if the object is null or undefined
        const properties = path.split('.'); // Split the path into individual properties
        let current = obj;
        for (const property of properties){
            // If the property doesn't exist, return false
            if (!current.hasOwnProperty(property)) return false;
            // Move to the next level in the path
            current = current[property];
        }
        return true;
    }
    innerValidate(value, type, prop) {
        if (!value) return true;
        switch(type){
            case 'num':
                return this.validateNumber(value);
            case 'str':
                return this.validateText(value);
            case 'bol':
                return this.validateBoolean(value);
            case 'obj':
                return this.objHasProperty(value, prop);
            case 'arr':
                return this.validateArray(value);
            default:
                return false;
        }
    }
    async validate() {
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).BEACON_SDK_VERSION), 'str')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_SELECTED_NODE), 'str')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MULTI_NODE_SETUP_DONE), 'bol')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_P2P_PEERS_DAPP), 'arr')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_P2P_PEERS_WALLET), 'arr')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_POSTMESSAGE_PEERS_DAPP), 'arr')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_POSTMESSAGE_PEERS_WALLET), 'arr')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_WALLETCONNECT_PEERS_DAPP), 'arr')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ACCOUNTS), 'arr')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).APP_METADATA_LIST), 'arr')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).PERMISSION_LIST), 'arr')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ACTIVE_ACCOUNT), 'str')) return false;
        if (!this.innerValidate(await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).LAST_SELECTED_WALLET), 'obj', 'key')) return false;
        return true;
    }
}


var $f49c866e7a54e899$exports = {};
"use strict";
var $f8ad086be43ac0c3$exports = {};
"use strict";
Object.defineProperty($f8ad086be43ac0c3$exports, "__esModule", {
    value: true
});
Object.defineProperty($f8ad086be43ac0c3$exports, "BroadcastChannel", {
    enumerable: true,
    get: function get() {
        return $e8feac5a717f1397$exports.BroadcastChannel;
    }
});
Object.defineProperty($f8ad086be43ac0c3$exports, "OPEN_BROADCAST_CHANNELS", {
    enumerable: true,
    get: function get() {
        return $e8feac5a717f1397$exports.OPEN_BROADCAST_CHANNELS;
    }
});
Object.defineProperty($f8ad086be43ac0c3$exports, "beLeader", {
    enumerable: true,
    get: function get() {
        return $308f7d71d2b865d3$exports.beLeader;
    }
});
Object.defineProperty($f8ad086be43ac0c3$exports, "clearNodeFolder", {
    enumerable: true,
    get: function get() {
        return $e8feac5a717f1397$exports.clearNodeFolder;
    }
});
Object.defineProperty($f8ad086be43ac0c3$exports, "createLeaderElection", {
    enumerable: true,
    get: function get() {
        return $471cc0014c6ed83d$exports.createLeaderElection;
    }
});
Object.defineProperty($f8ad086be43ac0c3$exports, "enforceOptions", {
    enumerable: true,
    get: function get() {
        return $e8feac5a717f1397$exports.enforceOptions;
    }
});
var $e8feac5a717f1397$exports = {};
"use strict";
Object.defineProperty($e8feac5a717f1397$exports, "__esModule", {
    value: true
});
$e8feac5a717f1397$exports.OPEN_BROADCAST_CHANNELS = $e8feac5a717f1397$exports.BroadcastChannel = void 0;
$e8feac5a717f1397$exports.clearNodeFolder = $e8feac5a717f1397$var$clearNodeFolder;
$e8feac5a717f1397$exports.enforceOptions = $e8feac5a717f1397$var$enforceOptions;
var $563fa712cae12588$exports = {};
"use strict";
Object.defineProperty($563fa712cae12588$exports, "__esModule", {
    value: true
});
$563fa712cae12588$exports.PROMISE_RESOLVED_VOID = $563fa712cae12588$exports.PROMISE_RESOLVED_TRUE = $563fa712cae12588$exports.PROMISE_RESOLVED_FALSE = void 0;
$563fa712cae12588$exports.isPromise = $563fa712cae12588$var$isPromise;
$563fa712cae12588$exports.microSeconds = $563fa712cae12588$var$microSeconds;
$563fa712cae12588$exports.randomInt = $563fa712cae12588$var$randomInt;
$563fa712cae12588$exports.randomToken = $563fa712cae12588$var$randomToken;
$563fa712cae12588$exports.sleep = $563fa712cae12588$var$sleep;
$563fa712cae12588$exports.supportsWebLockAPI = $563fa712cae12588$var$supportsWebLockAPI;
/**
 * returns true if the given object is a promise
 */ function $563fa712cae12588$var$isPromise(obj) {
    return obj && typeof obj.then === 'function';
}
var $563fa712cae12588$var$PROMISE_RESOLVED_FALSE = $563fa712cae12588$exports.PROMISE_RESOLVED_FALSE = Promise.resolve(false);
var $563fa712cae12588$var$PROMISE_RESOLVED_TRUE = $563fa712cae12588$exports.PROMISE_RESOLVED_TRUE = Promise.resolve(true);
var $563fa712cae12588$var$PROMISE_RESOLVED_VOID = $563fa712cae12588$exports.PROMISE_RESOLVED_VOID = Promise.resolve();
function $563fa712cae12588$var$sleep(time, resolveWith) {
    if (!time) time = 0;
    return new Promise(function(res) {
        return setTimeout(function() {
            return res(resolveWith);
        }, time);
    });
}
function $563fa712cae12588$var$randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
/**
 * https://stackoverflow.com/a/8084248
 */ function $563fa712cae12588$var$randomToken() {
    return Math.random().toString(36).substring(2);
}
var $563fa712cae12588$var$lastMs = 0;
/**
 * Returns the current unix time in micro-seconds,
 * WARNING: This is a pseudo-function
 * Performance.now is not reliable in webworkers, so we just make sure to never return the same time.
 * This is enough in browsers, and this function will not be used in nodejs.
 * The main reason for this hack is to ensure that BroadcastChannel behaves equal to production when it is used in fast-running unit tests.
 */ function $563fa712cae12588$var$microSeconds() {
    var ret = Date.now() * 1000; // milliseconds to microseconds
    if (ret <= $563fa712cae12588$var$lastMs) ret = $563fa712cae12588$var$lastMs + 1;
    $563fa712cae12588$var$lastMs = ret;
    return ret;
}
/**
 * Check if WebLock API is supported.
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Locks_API
 */ function $563fa712cae12588$var$supportsWebLockAPI() {
    if (typeof navigator !== 'undefined' && typeof navigator.locks !== 'undefined' && typeof navigator.locks.request === 'function') return true;
    else return false;
}


var $c3d707e829498aa1$exports = {};
"use strict";
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


Object.defineProperty($c3d707e829498aa1$exports, "__esModule", {
    value: true
});
$c3d707e829498aa1$exports.chooseMethod = $c3d707e829498aa1$var$chooseMethod;
var $3df1a9752b813d95$exports = {};
"use strict";
Object.defineProperty($3df1a9752b813d95$exports, "__esModule", {
    value: true
});
$3df1a9752b813d95$exports.NativeMethod = void 0;
$3df1a9752b813d95$exports.averageResponseTime = $3df1a9752b813d95$var$averageResponseTime;
$3df1a9752b813d95$exports.canBeUsed = $3df1a9752b813d95$var$canBeUsed;
$3df1a9752b813d95$exports.close = $3df1a9752b813d95$var$close;
$3df1a9752b813d95$exports.create = $3df1a9752b813d95$var$create;
$3df1a9752b813d95$exports.microSeconds = void 0;
$3df1a9752b813d95$exports.onMessage = $3df1a9752b813d95$var$onMessage;
$3df1a9752b813d95$exports.postMessage = $3df1a9752b813d95$var$postMessage;
$3df1a9752b813d95$exports.type = void 0;

var $3df1a9752b813d95$var$microSeconds = $3df1a9752b813d95$exports.microSeconds = $563fa712cae12588$exports.microSeconds;
var $3df1a9752b813d95$var$type = $3df1a9752b813d95$exports.type = 'native';
function $3df1a9752b813d95$var$create(channelName) {
    var state = {
        time: (0, $563fa712cae12588$exports.microSeconds)(),
        messagesCallback: null,
        bc: new BroadcastChannel(channelName),
        subFns: [] // subscriberFunctions
    };
    state.bc.onmessage = function(msgEvent) {
        if (state.messagesCallback) state.messagesCallback(msgEvent.data);
    };
    return state;
}
function $3df1a9752b813d95$var$close(channelState) {
    channelState.bc.close();
    channelState.subFns = [];
}
function $3df1a9752b813d95$var$postMessage(channelState, messageJson) {
    try {
        channelState.bc.postMessage(messageJson, false);
        return $563fa712cae12588$exports.PROMISE_RESOLVED_VOID;
    } catch (err) {
        return Promise.reject(err);
    }
}
function $3df1a9752b813d95$var$onMessage(channelState, fn) {
    channelState.messagesCallback = fn;
}
function $3df1a9752b813d95$var$canBeUsed() {
    // Deno runtime
    // eslint-disable-next-line
    if (typeof globalThis !== 'undefined' && globalThis.Deno && globalThis.Deno.args) return true;
    // Browser runtime
    if ((typeof window !== 'undefined' || typeof self !== 'undefined') && typeof BroadcastChannel === 'function') {
        if (BroadcastChannel._pubkey) throw new Error('BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill');
        return true;
    } else return false;
}
function $3df1a9752b813d95$var$averageResponseTime() {
    return 150;
}
var $3df1a9752b813d95$var$NativeMethod = $3df1a9752b813d95$exports.NativeMethod = {
    create: $3df1a9752b813d95$var$create,
    close: $3df1a9752b813d95$var$close,
    onMessage: $3df1a9752b813d95$var$onMessage,
    postMessage: $3df1a9752b813d95$var$postMessage,
    canBeUsed: $3df1a9752b813d95$var$canBeUsed,
    type: $3df1a9752b813d95$var$type,
    averageResponseTime: $3df1a9752b813d95$var$averageResponseTime,
    microSeconds: $3df1a9752b813d95$var$microSeconds
};


var $0f6be1fd56024fa6$exports = {};
"use strict";
Object.defineProperty($0f6be1fd56024fa6$exports, "__esModule", {
    value: true
});
$0f6be1fd56024fa6$exports.TRANSACTION_SETTINGS = $0f6be1fd56024fa6$exports.IndexedDBMethod = void 0;
$0f6be1fd56024fa6$exports.averageResponseTime = $0f6be1fd56024fa6$var$averageResponseTime;
$0f6be1fd56024fa6$exports.canBeUsed = $0f6be1fd56024fa6$var$canBeUsed;
$0f6be1fd56024fa6$exports.cleanOldMessages = $0f6be1fd56024fa6$var$cleanOldMessages;
$0f6be1fd56024fa6$exports.close = $0f6be1fd56024fa6$var$close;
$0f6be1fd56024fa6$exports.commitIndexedDBTransaction = $0f6be1fd56024fa6$var$commitIndexedDBTransaction;
$0f6be1fd56024fa6$exports.create = $0f6be1fd56024fa6$var$create;
$0f6be1fd56024fa6$exports.createDatabase = $0f6be1fd56024fa6$var$createDatabase;
$0f6be1fd56024fa6$exports.getAllMessages = $0f6be1fd56024fa6$var$getAllMessages;
$0f6be1fd56024fa6$exports.getIdb = $0f6be1fd56024fa6$var$getIdb;
$0f6be1fd56024fa6$exports.getMessagesHigherThan = $0f6be1fd56024fa6$var$getMessagesHigherThan;
$0f6be1fd56024fa6$exports.getOldMessages = $0f6be1fd56024fa6$var$getOldMessages;
$0f6be1fd56024fa6$exports.microSeconds = void 0;
$0f6be1fd56024fa6$exports.onMessage = $0f6be1fd56024fa6$var$onMessage;
$0f6be1fd56024fa6$exports.postMessage = $0f6be1fd56024fa6$var$postMessage;
$0f6be1fd56024fa6$exports.removeMessagesById = $0f6be1fd56024fa6$var$removeMessagesById;
$0f6be1fd56024fa6$exports.type = void 0;
$0f6be1fd56024fa6$exports.writeMessage = $0f6be1fd56024fa6$var$writeMessage;

/**
 * this is a set which automatically forgets
 * a given entry when a new entry is set and the ttl
 * of the old one is over
 */ class $1d61605cf6096f42$export$95f11f715943104f {
    ttl;
    map = new Map();
    /**
     * Creating calls to setTimeout() is expensive,
     * so we only do that if there is not timeout already open.
     */ _to = false;
    constructor(ttl){
        this.ttl = ttl;
    }
    has(value) {
        const valueTime = this.map.get(value);
        if (typeof valueTime === 'undefined') return false;
        if (valueTime < $1d61605cf6096f42$export$461939dd4422153() - this.ttl) {
            this.map.delete(value);
            return false;
        }
        return true;
    }
    add(value) {
        this.map.delete(value);
        this.map.set(value, $1d61605cf6096f42$export$461939dd4422153());
        /**
         * When a new value is added,
         * start the cleanup at the next tick
         * to not block the cpu for more important stuff
         * that might happen.
         */ if (!this._to) {
            this._to = true;
            setTimeout(()=>{
                this._to = false;
                $1d61605cf6096f42$export$bb2da5c3b0945a45(this);
            }, 0);
        }
    }
    clear() {
        this.map.clear();
    }
}
function $1d61605cf6096f42$export$bb2da5c3b0945a45(obliviousSet) {
    const olderThen = $1d61605cf6096f42$export$461939dd4422153() - obliviousSet.ttl;
    const iterator = obliviousSet.map[Symbol.iterator]();
    /**
     * Because we can assume the new values are added at the bottom,
     * we start from the top and stop as soon as we reach a non-too-old value.
     */ while(true){
        const next = iterator.next().value;
        if (!next) break; // no more elements
        const value = next[0];
        const time = next[1];
        if (time < olderThen) obliviousSet.map.delete(value);
        else break;
    }
}
function $1d61605cf6096f42$export$461939dd4422153() {
    return Date.now();
}


var $2ad219db58a3df18$exports = {};
"use strict";
Object.defineProperty($2ad219db58a3df18$exports, "__esModule", {
    value: true
});
$2ad219db58a3df18$exports.fillOptionsWithDefaults = $2ad219db58a3df18$var$fillOptionsWithDefaults;
function $2ad219db58a3df18$var$fillOptionsWithDefaults() {
    var originalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = JSON.parse(JSON.stringify(originalOptions));
    // main
    if (typeof options.webWorkerSupport === 'undefined') options.webWorkerSupport = true;
    // indexed-db
    if (!options.idb) options.idb = {};
    //  after this time the messages get deleted
    if (!options.idb.ttl) options.idb.ttl = 45000;
    if (!options.idb.fallbackInterval) options.idb.fallbackInterval = 150;
    //  handles abrupt db onclose events.
    if (originalOptions.idb && typeof originalOptions.idb.onclose === 'function') options.idb.onclose = originalOptions.idb.onclose;
    // localstorage
    if (!options.localstorage) options.localstorage = {};
    if (!options.localstorage.removeTimeout) options.localstorage.removeTimeout = 60000;
    // custom methods
    if (originalOptions.methods) options.methods = originalOptions.methods;
    // node
    if (!options.node) options.node = {};
    if (!options.node.ttl) options.node.ttl = 120000; // 2 minutes;
    /**
   * On linux use 'ulimit -Hn' to get the limit of open files.
   * On ubuntu this was 4096 for me, so we use half of that as maxParallelWrites default.
   */ if (!options.node.maxParallelWrites) options.node.maxParallelWrites = 2048;
    if (typeof options.node.useFastPath === 'undefined') options.node.useFastPath = true;
    return options;
}


/**
 * this method uses indexeddb to store the messages
 * There is currently no observerAPI for idb
 * @link https://github.com/w3c/IndexedDB/issues/51
 * 
 * When working on this, ensure to use these performance optimizations:
 * @link https://rxdb.info/slow-indexeddb.html
 */ var $0f6be1fd56024fa6$var$microSeconds = $0f6be1fd56024fa6$exports.microSeconds = $563fa712cae12588$exports.microSeconds;
var $0f6be1fd56024fa6$var$DB_PREFIX = 'pubkey.broadcast-channel-0-';
var $0f6be1fd56024fa6$var$OBJECT_STORE_ID = 'messages';
/**
 * Use relaxed durability for faster performance on all transactions.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */ var $0f6be1fd56024fa6$var$TRANSACTION_SETTINGS = $0f6be1fd56024fa6$exports.TRANSACTION_SETTINGS = {
    durability: 'relaxed'
};
var $0f6be1fd56024fa6$var$type = $0f6be1fd56024fa6$exports.type = 'idb';
function $0f6be1fd56024fa6$var$getIdb() {
    if (typeof indexedDB !== 'undefined') return indexedDB;
    if (typeof window !== 'undefined') {
        if (typeof window.mozIndexedDB !== 'undefined') return window.mozIndexedDB;
        if (typeof window.webkitIndexedDB !== 'undefined') return window.webkitIndexedDB;
        if (typeof window.msIndexedDB !== 'undefined') return window.msIndexedDB;
    }
    return false;
}
/**
 * If possible, we should explicitly commit IndexedDB transactions
 * for better performance.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */ function $0f6be1fd56024fa6$var$commitIndexedDBTransaction(tx) {
    if (tx.commit) tx.commit();
}
function $0f6be1fd56024fa6$var$createDatabase(channelName) {
    var IndexedDB = $0f6be1fd56024fa6$var$getIdb();
    // create table
    var dbName = $0f6be1fd56024fa6$var$DB_PREFIX + channelName;
    /**
   * All IndexedDB databases are opened without version
   * because it is a bit faster, especially on firefox
   * @link http://nparashuram.com/IndexedDB/perf/#Open%20Database%20with%20version
   */ var openRequest = IndexedDB.open(dbName);
    openRequest.onupgradeneeded = function(ev) {
        var db = ev.target.result;
        db.createObjectStore($0f6be1fd56024fa6$var$OBJECT_STORE_ID, {
            keyPath: 'id',
            autoIncrement: true
        });
    };
    return new Promise(function(res, rej) {
        openRequest.onerror = function(ev) {
            return rej(ev);
        };
        openRequest.onsuccess = function() {
            res(openRequest.result);
        };
    });
}
/**
 * writes the new message to the database
 * so other readers can find it
 */ function $0f6be1fd56024fa6$var$writeMessage(db, readerUuid, messageJson) {
    var time = Date.now();
    var writeObject = {
        uuid: readerUuid,
        time: time,
        data: messageJson
    };
    var tx = db.transaction([
        $0f6be1fd56024fa6$var$OBJECT_STORE_ID
    ], 'readwrite', $0f6be1fd56024fa6$var$TRANSACTION_SETTINGS);
    return new Promise(function(res, rej) {
        tx.oncomplete = function() {
            return res();
        };
        tx.onerror = function(ev) {
            return rej(ev);
        };
        var objectStore = tx.objectStore($0f6be1fd56024fa6$var$OBJECT_STORE_ID);
        objectStore.add(writeObject);
        $0f6be1fd56024fa6$var$commitIndexedDBTransaction(tx);
    });
}
function $0f6be1fd56024fa6$var$getAllMessages(db) {
    var tx = db.transaction($0f6be1fd56024fa6$var$OBJECT_STORE_ID, 'readonly', $0f6be1fd56024fa6$var$TRANSACTION_SETTINGS);
    var objectStore = tx.objectStore($0f6be1fd56024fa6$var$OBJECT_STORE_ID);
    var ret = [];
    return new Promise(function(res) {
        objectStore.openCursor().onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                ret.push(cursor.value);
                //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
                cursor["continue"]();
            } else {
                $0f6be1fd56024fa6$var$commitIndexedDBTransaction(tx);
                res(ret);
            }
        };
    });
}
function $0f6be1fd56024fa6$var$getMessagesHigherThan(db, lastCursorId) {
    var tx = db.transaction($0f6be1fd56024fa6$var$OBJECT_STORE_ID, 'readonly', $0f6be1fd56024fa6$var$TRANSACTION_SETTINGS);
    var objectStore = tx.objectStore($0f6be1fd56024fa6$var$OBJECT_STORE_ID);
    var ret = [];
    var keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
    /**
   * Optimization shortcut,
   * if getAll() can be used, do not use a cursor.
   * @link https://rxdb.info/slow-indexeddb.html
   */ if (objectStore.getAll) {
        var getAllRequest = objectStore.getAll(keyRangeValue);
        return new Promise(function(res, rej) {
            getAllRequest.onerror = function(err) {
                return rej(err);
            };
            getAllRequest.onsuccess = function(e) {
                res(e.target.result);
            };
        });
    }
    function openCursor() {
        // Occasionally Safari will fail on IDBKeyRange.bound, this
        // catches that error, having it open the cursor to the first
        // item. When it gets data it will advance to the desired key.
        try {
            keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
            return objectStore.openCursor(keyRangeValue);
        } catch (e) {
            return objectStore.openCursor();
        }
    }
    return new Promise(function(res, rej) {
        var openCursorRequest = openCursor();
        openCursorRequest.onerror = function(err) {
            return rej(err);
        };
        openCursorRequest.onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                if (cursor.value.id < lastCursorId + 1) cursor["continue"](lastCursorId + 1);
                else {
                    ret.push(cursor.value);
                    cursor["continue"]();
                }
            } else {
                $0f6be1fd56024fa6$var$commitIndexedDBTransaction(tx);
                res(ret);
            }
        };
    });
}
function $0f6be1fd56024fa6$var$removeMessagesById(channelState, ids) {
    if (channelState.closed) return Promise.resolve([]);
    var tx = channelState.db.transaction($0f6be1fd56024fa6$var$OBJECT_STORE_ID, 'readwrite', $0f6be1fd56024fa6$var$TRANSACTION_SETTINGS);
    var objectStore = tx.objectStore($0f6be1fd56024fa6$var$OBJECT_STORE_ID);
    return Promise.all(ids.map(function(id) {
        var deleteRequest = objectStore["delete"](id);
        return new Promise(function(res) {
            deleteRequest.onsuccess = function() {
                return res();
            };
        });
    }));
}
function $0f6be1fd56024fa6$var$getOldMessages(db, ttl) {
    var olderThen = Date.now() - ttl;
    var tx = db.transaction($0f6be1fd56024fa6$var$OBJECT_STORE_ID, 'readonly', $0f6be1fd56024fa6$var$TRANSACTION_SETTINGS);
    var objectStore = tx.objectStore($0f6be1fd56024fa6$var$OBJECT_STORE_ID);
    var ret = [];
    return new Promise(function(res) {
        objectStore.openCursor().onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                var msgObk = cursor.value;
                if (msgObk.time < olderThen) {
                    ret.push(msgObk);
                    //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
                    cursor["continue"]();
                } else {
                    // no more old messages,
                    $0f6be1fd56024fa6$var$commitIndexedDBTransaction(tx);
                    res(ret);
                }
            } else res(ret);
        };
    });
}
function $0f6be1fd56024fa6$var$cleanOldMessages(channelState) {
    return $0f6be1fd56024fa6$var$getOldMessages(channelState.db, channelState.options.idb.ttl).then(function(tooOld) {
        return $0f6be1fd56024fa6$var$removeMessagesById(channelState, tooOld.map(function(msg) {
            return msg.id;
        }));
    });
}
function $0f6be1fd56024fa6$var$create(channelName, options) {
    options = (0, $2ad219db58a3df18$exports.fillOptionsWithDefaults)(options);
    return $0f6be1fd56024fa6$var$createDatabase(channelName).then(function(db) {
        var state = {
            closed: false,
            lastCursorId: 0,
            channelName: channelName,
            options: options,
            uuid: (0, $563fa712cae12588$exports.randomToken)(),
            /**
       * emittedMessagesIds
       * contains all messages that have been emitted before
       * @type {ObliviousSet}
       */ eMIs: new $1d61605cf6096f42$export$95f11f715943104f(options.idb.ttl * 2),
            // ensures we do not read messages in parallel
            writeBlockPromise: $563fa712cae12588$exports.PROMISE_RESOLVED_VOID,
            messagesCallback: null,
            readQueuePromises: [],
            db: db
        };
        /**
     * Handle abrupt closes that do not originate from db.close().
     * This could happen, for example, if the underlying storage is
     * removed or if the user clears the database in the browser's
     * history preferences.
     */ db.onclose = function() {
            state.closed = true;
            if (options.idb.onclose) options.idb.onclose();
        };
        /**
     * if service-workers are used,
     * we have no 'storage'-event if they post a message,
     * therefore we also have to set an interval
     */ $0f6be1fd56024fa6$var$_readLoop(state);
        return state;
    });
}
function $0f6be1fd56024fa6$var$_readLoop(state) {
    if (state.closed) return;
    $0f6be1fd56024fa6$var$readNewMessages(state).then(function() {
        return (0, $563fa712cae12588$exports.sleep)(state.options.idb.fallbackInterval);
    }).then(function() {
        return $0f6be1fd56024fa6$var$_readLoop(state);
    });
}
function $0f6be1fd56024fa6$var$_filterMessage(msgObj, state) {
    if (msgObj.uuid === state.uuid) return false; // send by own
    if (state.eMIs.has(msgObj.id)) return false; // already emitted
    if (msgObj.data.time < state.messagesCallbackTime) return false; // older then onMessageCallback
    return true;
}
/**
 * reads all new messages from the database and emits them
 */ function $0f6be1fd56024fa6$var$readNewMessages(state) {
    // channel already closed
    if (state.closed) return $563fa712cae12588$exports.PROMISE_RESOLVED_VOID;
    // if no one is listening, we do not need to scan for new messages
    if (!state.messagesCallback) return $563fa712cae12588$exports.PROMISE_RESOLVED_VOID;
    return $0f6be1fd56024fa6$var$getMessagesHigherThan(state.db, state.lastCursorId).then(function(newerMessages) {
        var useMessages = newerMessages/**
     * there is a bug in iOS where the msgObj can be undefined sometimes
     * so we filter them out
     * @link https://github.com/pubkey/broadcast-channel/issues/19
     */ .filter(function(msgObj) {
            return !!msgObj;
        }).map(function(msgObj) {
            if (msgObj.id > state.lastCursorId) state.lastCursorId = msgObj.id;
            return msgObj;
        }).filter(function(msgObj) {
            return $0f6be1fd56024fa6$var$_filterMessage(msgObj, state);
        }).sort(function(msgObjA, msgObjB) {
            return msgObjA.time - msgObjB.time;
        }); // sort by time
        useMessages.forEach(function(msgObj) {
            if (state.messagesCallback) {
                state.eMIs.add(msgObj.id);
                state.messagesCallback(msgObj.data);
            }
        });
        return $563fa712cae12588$exports.PROMISE_RESOLVED_VOID;
    });
}
function $0f6be1fd56024fa6$var$close(channelState) {
    channelState.closed = true;
    channelState.db.close();
}
function $0f6be1fd56024fa6$var$postMessage(channelState, messageJson) {
    channelState.writeBlockPromise = channelState.writeBlockPromise.then(function() {
        return $0f6be1fd56024fa6$var$writeMessage(channelState.db, channelState.uuid, messageJson);
    }).then(function() {
        if ((0, $563fa712cae12588$exports.randomInt)(0, 10) === 0) /* await (do not await) */ $0f6be1fd56024fa6$var$cleanOldMessages(channelState);
    });
    return channelState.writeBlockPromise;
}
function $0f6be1fd56024fa6$var$onMessage(channelState, fn, time) {
    channelState.messagesCallbackTime = time;
    channelState.messagesCallback = fn;
    $0f6be1fd56024fa6$var$readNewMessages(channelState);
}
function $0f6be1fd56024fa6$var$canBeUsed() {
    return !!$0f6be1fd56024fa6$var$getIdb();
}
function $0f6be1fd56024fa6$var$averageResponseTime(options) {
    return options.idb.fallbackInterval * 2;
}
var $0f6be1fd56024fa6$var$IndexedDBMethod = $0f6be1fd56024fa6$exports.IndexedDBMethod = {
    create: $0f6be1fd56024fa6$var$create,
    close: $0f6be1fd56024fa6$var$close,
    onMessage: $0f6be1fd56024fa6$var$onMessage,
    postMessage: $0f6be1fd56024fa6$var$postMessage,
    canBeUsed: $0f6be1fd56024fa6$var$canBeUsed,
    type: $0f6be1fd56024fa6$var$type,
    averageResponseTime: $0f6be1fd56024fa6$var$averageResponseTime,
    microSeconds: $0f6be1fd56024fa6$var$microSeconds
};


var $e0ecdb59d513ce6b$exports = {};
"use strict";
Object.defineProperty($e0ecdb59d513ce6b$exports, "__esModule", {
    value: true
});
$e0ecdb59d513ce6b$exports.LocalstorageMethod = void 0;
$e0ecdb59d513ce6b$exports.addStorageEventListener = $e0ecdb59d513ce6b$var$addStorageEventListener;
$e0ecdb59d513ce6b$exports.averageResponseTime = $e0ecdb59d513ce6b$var$averageResponseTime;
$e0ecdb59d513ce6b$exports.canBeUsed = $e0ecdb59d513ce6b$var$canBeUsed;
$e0ecdb59d513ce6b$exports.close = $e0ecdb59d513ce6b$var$close;
$e0ecdb59d513ce6b$exports.create = $e0ecdb59d513ce6b$var$create;
$e0ecdb59d513ce6b$exports.getLocalStorage = $e0ecdb59d513ce6b$var$getLocalStorage;
$e0ecdb59d513ce6b$exports.microSeconds = void 0;
$e0ecdb59d513ce6b$exports.onMessage = $e0ecdb59d513ce6b$var$onMessage;
$e0ecdb59d513ce6b$exports.postMessage = $e0ecdb59d513ce6b$var$postMessage;
$e0ecdb59d513ce6b$exports.removeStorageEventListener = $e0ecdb59d513ce6b$var$removeStorageEventListener;
$e0ecdb59d513ce6b$exports.storageKey = $e0ecdb59d513ce6b$var$storageKey;
$e0ecdb59d513ce6b$exports.type = void 0;



/**
 * A localStorage-only method which uses localstorage and its 'storage'-event
 * This does not work inside webworkers because they have no access to localstorage
 * This is basically implemented to support IE9 or your grandmother's toaster.
 * @link https://caniuse.com/#feat=namevalue-storage
 * @link https://caniuse.com/#feat=indexeddb
 */ var $e0ecdb59d513ce6b$var$microSeconds = $e0ecdb59d513ce6b$exports.microSeconds = $563fa712cae12588$exports.microSeconds;
var $e0ecdb59d513ce6b$var$KEY_PREFIX = 'pubkey.broadcastChannel-';
var $e0ecdb59d513ce6b$var$type = $e0ecdb59d513ce6b$exports.type = 'localstorage';
/**
 * copied from crosstab
 * @link https://github.com/tejacques/crosstab/blob/master/src/crosstab.js#L32
 */ function $e0ecdb59d513ce6b$var$getLocalStorage() {
    var localStorage;
    if (typeof window === 'undefined') return null;
    try {
        localStorage = window.localStorage;
        localStorage = window['ie8-eventlistener/storage'] || window.localStorage;
    } catch (e) {
    // New versions of Firefox throw a Security exception
    // if cookies are disabled. See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1028153
    }
    return localStorage;
}
function $e0ecdb59d513ce6b$var$storageKey(channelName) {
    return $e0ecdb59d513ce6b$var$KEY_PREFIX + channelName;
}
/**
* writes the new message to the storage
* and fires the storage-event so other readers can find it
*/ function $e0ecdb59d513ce6b$var$postMessage(channelState, messageJson) {
    return new Promise(function(res) {
        (0, $563fa712cae12588$exports.sleep)().then(function() {
            var key = $e0ecdb59d513ce6b$var$storageKey(channelState.channelName);
            var writeObj = {
                token: (0, $563fa712cae12588$exports.randomToken)(),
                time: Date.now(),
                data: messageJson,
                uuid: channelState.uuid
            };
            var value = JSON.stringify(writeObj);
            $e0ecdb59d513ce6b$var$getLocalStorage().setItem(key, value);
            /**
       * StorageEvent does not fire the 'storage' event
       * in the window that changes the state of the local storage.
       * So we fire it manually
       */ var ev = document.createEvent('Event');
            ev.initEvent('storage', true, true);
            ev.key = key;
            ev.newValue = value;
            window.dispatchEvent(ev);
            res();
        });
    });
}
function $e0ecdb59d513ce6b$var$addStorageEventListener(channelName, fn) {
    var key = $e0ecdb59d513ce6b$var$storageKey(channelName);
    var listener = function listener(ev) {
        if (ev.key === key) fn(JSON.parse(ev.newValue));
    };
    window.addEventListener('storage', listener);
    return listener;
}
function $e0ecdb59d513ce6b$var$removeStorageEventListener(listener) {
    window.removeEventListener('storage', listener);
}
function $e0ecdb59d513ce6b$var$create(channelName, options) {
    options = (0, $2ad219db58a3df18$exports.fillOptionsWithDefaults)(options);
    if (!$e0ecdb59d513ce6b$var$canBeUsed()) throw new Error('BroadcastChannel: localstorage cannot be used');
    var uuid = (0, $563fa712cae12588$exports.randomToken)();
    /**
   * eMIs
   * contains all messages that have been emitted before
   * @type {ObliviousSet}
   */ var eMIs = new $1d61605cf6096f42$export$95f11f715943104f(options.localstorage.removeTimeout);
    var state = {
        channelName: channelName,
        uuid: uuid,
        eMIs: eMIs // emittedMessagesIds
    };
    state.listener = $e0ecdb59d513ce6b$var$addStorageEventListener(channelName, function(msgObj) {
        if (!state.messagesCallback) return; // no listener
        if (msgObj.uuid === uuid) return; // own message
        if (!msgObj.token || eMIs.has(msgObj.token)) return; // already emitted
        if (msgObj.data.time && msgObj.data.time < state.messagesCallbackTime) return; // too old
        eMIs.add(msgObj.token);
        state.messagesCallback(msgObj.data);
    });
    return state;
}
function $e0ecdb59d513ce6b$var$close(channelState) {
    $e0ecdb59d513ce6b$var$removeStorageEventListener(channelState.listener);
}
function $e0ecdb59d513ce6b$var$onMessage(channelState, fn, time) {
    channelState.messagesCallbackTime = time;
    channelState.messagesCallback = fn;
}
function $e0ecdb59d513ce6b$var$canBeUsed() {
    var ls = $e0ecdb59d513ce6b$var$getLocalStorage();
    if (!ls) return false;
    try {
        var key = '__broadcastchannel_check';
        ls.setItem(key, 'works');
        ls.removeItem(key);
    } catch (e) {
        // Safari 10 in private mode will not allow write access to local
        // storage and fail with a QuotaExceededError. See
        // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API#Private_Browsing_Incognito_modes
        return false;
    }
    return true;
}
function $e0ecdb59d513ce6b$var$averageResponseTime() {
    var defaultTime = 120;
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('safari') && !userAgent.includes('chrome')) // safari is much slower so this time is higher
    return defaultTime * 2;
    return defaultTime;
}
var $e0ecdb59d513ce6b$var$LocalstorageMethod = $e0ecdb59d513ce6b$exports.LocalstorageMethod = {
    create: $e0ecdb59d513ce6b$var$create,
    close: $e0ecdb59d513ce6b$var$close,
    onMessage: $e0ecdb59d513ce6b$var$onMessage,
    postMessage: $e0ecdb59d513ce6b$var$postMessage,
    canBeUsed: $e0ecdb59d513ce6b$var$canBeUsed,
    type: $e0ecdb59d513ce6b$var$type,
    averageResponseTime: $e0ecdb59d513ce6b$var$averageResponseTime,
    microSeconds: $e0ecdb59d513ce6b$var$microSeconds
};


var $8220a28f1be74215$exports = {};
"use strict";
Object.defineProperty($8220a28f1be74215$exports, "__esModule", {
    value: true
});
$8220a28f1be74215$exports.SimulateMethod = $8220a28f1be74215$exports.SIMULATE_DELAY_TIME = void 0;
$8220a28f1be74215$exports.averageResponseTime = $8220a28f1be74215$var$averageResponseTime;
$8220a28f1be74215$exports.canBeUsed = $8220a28f1be74215$var$canBeUsed;
$8220a28f1be74215$exports.close = $8220a28f1be74215$var$close;
$8220a28f1be74215$exports.create = $8220a28f1be74215$var$create;
$8220a28f1be74215$exports.microSeconds = void 0;
$8220a28f1be74215$exports.onMessage = $8220a28f1be74215$var$onMessage;
$8220a28f1be74215$exports.postMessage = $8220a28f1be74215$var$postMessage;
$8220a28f1be74215$exports.type = void 0;

var $8220a28f1be74215$var$microSeconds = $8220a28f1be74215$exports.microSeconds = $563fa712cae12588$exports.microSeconds;
var $8220a28f1be74215$var$type = $8220a28f1be74215$exports.type = 'simulate';
var $8220a28f1be74215$var$SIMULATE_CHANNELS = new Set();
function $8220a28f1be74215$var$create(channelName) {
    var state = {
        time: $8220a28f1be74215$var$microSeconds(),
        name: channelName,
        messagesCallback: null
    };
    $8220a28f1be74215$var$SIMULATE_CHANNELS.add(state);
    return state;
}
function $8220a28f1be74215$var$close(channelState) {
    $8220a28f1be74215$var$SIMULATE_CHANNELS["delete"](channelState);
}
var $8220a28f1be74215$var$SIMULATE_DELAY_TIME = $8220a28f1be74215$exports.SIMULATE_DELAY_TIME = 5;
function $8220a28f1be74215$var$postMessage(channelState, messageJson) {
    return new Promise(function(res) {
        return setTimeout(function() {
            var channelArray = Array.from($8220a28f1be74215$var$SIMULATE_CHANNELS);
            channelArray.forEach(function(channel) {
                if (channel.name === channelState.name && // has same name
                channel !== channelState && // not own channel
                !!channel.messagesCallback && // has subscribers
                channel.time < messageJson.time // channel not created after postMessage() call
                ) channel.messagesCallback(messageJson);
            });
            res();
        }, $8220a28f1be74215$var$SIMULATE_DELAY_TIME);
    });
}
function $8220a28f1be74215$var$onMessage(channelState, fn) {
    channelState.messagesCallback = fn;
}
function $8220a28f1be74215$var$canBeUsed() {
    return true;
}
function $8220a28f1be74215$var$averageResponseTime() {
    return $8220a28f1be74215$var$SIMULATE_DELAY_TIME;
}
var $8220a28f1be74215$var$SimulateMethod = $8220a28f1be74215$exports.SimulateMethod = {
    create: $8220a28f1be74215$var$create,
    close: $8220a28f1be74215$var$close,
    onMessage: $8220a28f1be74215$var$onMessage,
    postMessage: $8220a28f1be74215$var$postMessage,
    canBeUsed: $8220a28f1be74215$var$canBeUsed,
    type: $8220a28f1be74215$var$type,
    averageResponseTime: $8220a28f1be74215$var$averageResponseTime,
    microSeconds: $8220a28f1be74215$var$microSeconds
};


function $c3d707e829498aa1$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($c3d707e829498aa1$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != $2ef66ab8c52ac1c0$exports(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t2 in e)"default" !== _t2 && ({}).hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]);
        return f;
    })(e, t);
}
// the line below will be removed from es5/browser builds
// order is important
var $c3d707e829498aa1$var$METHODS = [
    $3df1a9752b813d95$exports.NativeMethod,
    // fastest
    $0f6be1fd56024fa6$exports.IndexedDBMethod,
    $e0ecdb59d513ce6b$exports.LocalstorageMethod
];
function $c3d707e829498aa1$var$chooseMethod(options) {
    var chooseMethods = [].concat(options.methods, $c3d707e829498aa1$var$METHODS).filter(Boolean);
    // the line below will be removed from es5/browser builds
    // directly chosen
    if (options.type) {
        if (options.type === 'simulate') // only use simulate-method if directly chosen
        return $8220a28f1be74215$exports.SimulateMethod;
        var ret = chooseMethods.find(function(m) {
            return m.type === options.type;
        });
        if (!ret) throw new Error('method-type ' + options.type + ' not found');
        else return ret;
    }
    /**
   * if no webworker support is needed,
   * remove idb from the list so that localstorage will be chosen
   */ if (!options.webWorkerSupport) chooseMethods = chooseMethods.filter(function(m) {
        return m.type !== 'idb';
    });
    var useMethod = chooseMethods.find(function(method) {
        return method.canBeUsed();
    });
    if (!useMethod) throw new Error("No usable method found in " + JSON.stringify($c3d707e829498aa1$var$METHODS.map(function(m) {
        return m.type;
    })));
    else return useMethod;
}



/**
 * Contains all open channels,
 * used in tests to ensure everything is closed.
 */ var $e8feac5a717f1397$var$OPEN_BROADCAST_CHANNELS = $e8feac5a717f1397$exports.OPEN_BROADCAST_CHANNELS = new Set();
var $e8feac5a717f1397$var$lastId = 0;
var $e8feac5a717f1397$var$BroadcastChannel = $e8feac5a717f1397$exports.BroadcastChannel = function BroadcastChannel(name, options) {
    // identifier of the channel to debug stuff
    this.id = $e8feac5a717f1397$var$lastId++;
    $e8feac5a717f1397$var$OPEN_BROADCAST_CHANNELS.add(this);
    this.name = name;
    if ($e8feac5a717f1397$var$ENFORCED_OPTIONS) options = $e8feac5a717f1397$var$ENFORCED_OPTIONS;
    this.options = (0, $2ad219db58a3df18$exports.fillOptionsWithDefaults)(options);
    this.method = (0, $c3d707e829498aa1$exports.chooseMethod)(this.options);
    // isListening
    this._iL = false;
    /**
   * _onMessageListener
   * setting onmessage twice,
   * will overwrite the first listener
   */ this._onML = null;
    /**
   * _addEventListeners
   */ this._addEL = {
        message: [],
        internal: []
    };
    /**
   * Unsent message promises
   * where the sending is still in progress
   * @type {Set<Promise>}
   */ this._uMP = new Set();
    /**
   * _beforeClose
   * array of promises that will be awaited
   * before the channel is closed
   */ this._befC = [];
    /**
   * _preparePromise
   */ this._prepP = null;
    $e8feac5a717f1397$var$_prepareChannel(this);
};
// STATICS
/**
 * used to identify if someone overwrites
 * window.BroadcastChannel with this
 * See methods/native.js
 */ $e8feac5a717f1397$var$BroadcastChannel._pubkey = true;
/**
 * clears the tmp-folder if is node
 * @return {Promise<boolean>} true if has run, false if not node
 */ function $e8feac5a717f1397$var$clearNodeFolder(options) {
    options = (0, $2ad219db58a3df18$exports.fillOptionsWithDefaults)(options);
    var method = (0, $c3d707e829498aa1$exports.chooseMethod)(options);
    if (method.type === 'node') return method.clearNodeFolder().then(function() {
        return true;
    });
    else return $563fa712cae12588$exports.PROMISE_RESOLVED_FALSE;
}
/**
 * if set, this method is enforced,
 * no mather what the options are
 */ var $e8feac5a717f1397$var$ENFORCED_OPTIONS;
function $e8feac5a717f1397$var$enforceOptions(options) {
    $e8feac5a717f1397$var$ENFORCED_OPTIONS = options;
}
// PROTOTYPE
$e8feac5a717f1397$var$BroadcastChannel.prototype = {
    postMessage: function postMessage(msg) {
        if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + /**
       * In the past when this error appeared, it was really hard to debug.
       * So now we log the msg together with the error so it at least
       * gives some clue about where in your application this happens.
       */ JSON.stringify(msg));
        return $e8feac5a717f1397$var$_post(this, 'message', msg);
    },
    postInternal: function postInternal(msg) {
        return $e8feac5a717f1397$var$_post(this, 'internal', msg);
    },
    set onmessage (fn){
        var time = this.method.microSeconds();
        var listenObj = {
            time: time,
            fn: fn
        };
        $e8feac5a717f1397$var$_removeListenerObject(this, 'message', this._onML);
        if (fn && typeof fn === 'function') {
            this._onML = listenObj;
            $e8feac5a717f1397$var$_addListenerObject(this, 'message', listenObj);
        } else this._onML = null;
    },
    addEventListener: function addEventListener(type, fn1) {
        var time = this.method.microSeconds();
        var listenObj = {
            time: time,
            fn: fn1
        };
        $e8feac5a717f1397$var$_addListenerObject(this, type, listenObj);
    },
    removeEventListener: function removeEventListener(type, fn1) {
        var obj = this._addEL[type].find(function(obj) {
            return obj.fn === fn1;
        });
        $e8feac5a717f1397$var$_removeListenerObject(this, type, obj);
    },
    close: function close() {
        var _this = this;
        if (this.closed) return;
        $e8feac5a717f1397$var$OPEN_BROADCAST_CHANNELS["delete"](this);
        this.closed = true;
        var awaitPrepare = this._prepP ? this._prepP : $563fa712cae12588$exports.PROMISE_RESOLVED_VOID;
        this._onML = null;
        this._addEL.message = [];
        return awaitPrepare// wait until all current sending are processed
        .then(function() {
            return Promise.all(Array.from(_this._uMP));
        })// run before-close hooks
        .then(function() {
            return Promise.all(_this._befC.map(function(fn1) {
                return fn1();
            }));
        })// close the channel
        .then(function() {
            return _this.method.close(_this._state);
        });
    },
    get type () {
        return this.method.type;
    },
    get isClosed () {
        return this.closed;
    }
};
/**
 * Post a message over the channel
 * @returns {Promise} that resolved when the message sending is done
 */ function $e8feac5a717f1397$var$_post(broadcastChannel, type, msg) {
    var time = broadcastChannel.method.microSeconds();
    var msgObj = {
        time: time,
        type: type,
        data: msg
    };
    var awaitPrepare = broadcastChannel._prepP ? broadcastChannel._prepP : $563fa712cae12588$exports.PROMISE_RESOLVED_VOID;
    return awaitPrepare.then(function() {
        var sendPromise = broadcastChannel.method.postMessage(broadcastChannel._state, msgObj);
        // add/remove to unsent messages list
        broadcastChannel._uMP.add(sendPromise);
        sendPromise["catch"]().then(function() {
            return broadcastChannel._uMP["delete"](sendPromise);
        });
        return sendPromise;
    });
}
function $e8feac5a717f1397$var$_prepareChannel(channel) {
    var maybePromise = channel.method.create(channel.name, channel.options);
    if ((0, $563fa712cae12588$exports.isPromise)(maybePromise)) {
        channel._prepP = maybePromise;
        maybePromise.then(function(s) {
            // used in tests to simulate slow runtime
            /*if (channel.options.prepareDelay) {
           await new Promise(res => setTimeout(res, this.options.prepareDelay));
      }*/ channel._state = s;
        });
    } else channel._state = maybePromise;
}
function $e8feac5a717f1397$var$_hasMessageListeners(channel) {
    if (channel._addEL.message.length > 0) return true;
    if (channel._addEL.internal.length > 0) return true;
    return false;
}
function $e8feac5a717f1397$var$_addListenerObject(channel, type, obj) {
    channel._addEL[type].push(obj);
    $e8feac5a717f1397$var$_startListening(channel);
}
function $e8feac5a717f1397$var$_removeListenerObject(channel, type, obj) {
    channel._addEL[type] = channel._addEL[type].filter(function(o) {
        return o !== obj;
    });
    $e8feac5a717f1397$var$_stopListening(channel);
}
function $e8feac5a717f1397$var$_startListening(channel) {
    if (!channel._iL && $e8feac5a717f1397$var$_hasMessageListeners(channel)) {
        // someone is listening, start subscribing
        var listenerFn = function listenerFn(msgObj) {
            channel._addEL[msgObj.type].forEach(function(listenerObject) {
                if (msgObj.time >= listenerObject.time) listenerObject.fn(msgObj.data);
            });
        };
        var time = channel.method.microSeconds();
        if (channel._prepP) channel._prepP.then(function() {
            channel._iL = true;
            channel.method.onMessage(channel._state, listenerFn, time);
        });
        else {
            channel._iL = true;
            channel.method.onMessage(channel._state, listenerFn, time);
        }
    }
}
function $e8feac5a717f1397$var$_stopListening(channel) {
    if (channel._iL && !$e8feac5a717f1397$var$_hasMessageListeners(channel)) {
        // no one is listening, stop subscribing
        channel._iL = false;
        var time = channel.method.microSeconds();
        channel.method.onMessage(channel._state, null, time);
    }
}


var $471cc0014c6ed83d$exports = {};
"use strict";
Object.defineProperty($471cc0014c6ed83d$exports, "__esModule", {
    value: true
});
$471cc0014c6ed83d$exports.createLeaderElection = $471cc0014c6ed83d$var$createLeaderElection;

var $308f7d71d2b865d3$exports = {};
"use strict";
Object.defineProperty($308f7d71d2b865d3$exports, "__esModule", {
    value: true
});
$308f7d71d2b865d3$exports.beLeader = $308f7d71d2b865d3$var$beLeader;
$308f7d71d2b865d3$exports.sendLeaderMessage = $308f7d71d2b865d3$var$sendLeaderMessage;
/* global WorkerGlobalScope */ function $ab1aa3b05ae2e96f$export$ae93c1693bb96e6(fn) {
    if (typeof WorkerGlobalScope === 'function' && self instanceof WorkerGlobalScope) {
        /**
     * Because killing a worker does directly stop the excution
     * of the code, our only chance is to overwrite the close function
     * which could work some times.
     * @link https://stackoverflow.com/q/72903255/3443137
     */ var oldClose = self.close.bind(self);
        self.close = function() {
            fn();
            return oldClose();
        };
    } else {
        /**
     * if we are on react-native, there is no window.addEventListener
     * @link https://github.com/pubkey/unload/issues/6
     */ if (typeof window.addEventListener !== 'function') return;
        /**
     * for normal browser-windows, we use the beforeunload-event
     */ window.addEventListener('beforeunload', function() {
            fn();
        }, true);
        /**
     * for iframes, we have to use the unload-event
     * @link https://stackoverflow.com/q/47533670/3443137
     */ window.addEventListener('unload', function() {
            fn();
        }, true);
    }
/**
   * TODO add fallback for safari-mobile
   * @link https://stackoverflow.com/a/26193516/3443137
   */ }



var $hPtJY = parcelRequire("hPtJY");
function $b5fc66e6f9b92e36$export$2fed3c3ffa8e7fdf(fn) {
    $hPtJY.on('exit', function() {
        return fn();
    });
    /**
   * on the following events,
   * the process will not end if there are
   * event-handlers attached,
   * therefore we have to call process.exit()
   */ $hPtJY.on('beforeExit', function() {
        return fn().then(function() {
            return $hPtJY.exit();
        });
    });
    // catches ctrl+c event
    $hPtJY.on('SIGINT', function() {
        return fn().then(function() {
            return $hPtJY.exit();
        });
    });
    // catches uncaught exceptions
    $hPtJY.on('uncaughtException', function(err) {
        return fn().then(function() {
            console.trace(err);
            $hPtJY.exit(101);
        });
    });
}


/**
 * Use the code directly to prevent import problems
 * with the detect-node package.
 * @link https://github.com/iliakan/detect-node/blob/master/index.js
 */ var $82074927497c80e3$var$isNode = Object.prototype.toString.call(0) === '[object process]';
var $82074927497c80e3$var$USE_METHOD = $82074927497c80e3$var$isNode ? (0, $b5fc66e6f9b92e36$export$2fed3c3ffa8e7fdf) : (0, $ab1aa3b05ae2e96f$export$ae93c1693bb96e6);
var $82074927497c80e3$var$LISTENERS = new Set();
var $82074927497c80e3$var$startedListening = false;
function $82074927497c80e3$var$startListening() {
    if ($82074927497c80e3$var$startedListening) return;
    $82074927497c80e3$var$startedListening = true;
    $82074927497c80e3$var$USE_METHOD($82074927497c80e3$export$62f8a3b655d92f84);
}
function $82074927497c80e3$export$e16d8520af44a096(fn) {
    $82074927497c80e3$var$startListening();
    if (typeof fn !== 'function') throw new Error('Listener is no function');
    $82074927497c80e3$var$LISTENERS.add(fn);
    var addReturn = {
        remove: function remove() {
            return $82074927497c80e3$var$LISTENERS["delete"](fn);
        },
        run: function run() {
            $82074927497c80e3$var$LISTENERS["delete"](fn);
            return fn();
        }
    };
    return addReturn;
}
function $82074927497c80e3$export$62f8a3b655d92f84() {
    var promises = [];
    $82074927497c80e3$var$LISTENERS.forEach(function(fn) {
        promises.push(fn());
        $82074927497c80e3$var$LISTENERS["delete"](fn);
    });
    return Promise.all(promises);
}
function $82074927497c80e3$export$1cfc7aad5cb1833b() {
    $82074927497c80e3$var$LISTENERS.clear();
}
function $82074927497c80e3$export$31b21d0167753bb4() {
    return $82074927497c80e3$var$LISTENERS.size;
}


/**
 * sends and internal message over the broadcast-channel
 */ function $308f7d71d2b865d3$var$sendLeaderMessage(leaderElector, action) {
    var msgJson = {
        context: 'leader',
        action: action,
        token: leaderElector.token
    };
    return leaderElector.broadcastChannel.postInternal(msgJson);
}
function $308f7d71d2b865d3$var$beLeader(leaderElector) {
    leaderElector.isLeader = true;
    leaderElector._hasLeader = true;
    var unloadFn = (0, $82074927497c80e3$export$e16d8520af44a096)(function() {
        return leaderElector.die();
    });
    leaderElector._unl.push(unloadFn);
    var isLeaderListener = function isLeaderListener(msg) {
        if (msg.context === 'leader' && msg.action === 'apply') $308f7d71d2b865d3$var$sendLeaderMessage(leaderElector, 'tell');
        if (msg.context === 'leader' && msg.action === 'tell' && !leaderElector._dpLC) {
            /**
       * another instance is also leader!
       * This can happen on rare events
       * like when the CPU is at 100% for long time
       * or the tabs are open very long and the browser throttles them.
       * @link https://github.com/pubkey/broadcast-channel/issues/414
       * @link https://github.com/pubkey/broadcast-channel/issues/385
       */ leaderElector._dpLC = true;
            leaderElector._dpL(); // message the lib user so the app can handle the problem
            $308f7d71d2b865d3$var$sendLeaderMessage(leaderElector, 'tell'); // ensure other leader also knows the problem
        }
    };
    leaderElector.broadcastChannel.addEventListener('internal', isLeaderListener);
    leaderElector._lstns.push(isLeaderListener);
    return $308f7d71d2b865d3$var$sendLeaderMessage(leaderElector, 'tell');
}


var $939b927ba32124df$exports = {};
"use strict";
Object.defineProperty($939b927ba32124df$exports, "__esModule", {
    value: true
});
$939b927ba32124df$exports.LeaderElectionWebLock = void 0;


/**
 * A faster version of the leader elector that uses the WebLock API
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Locks_API
 */ var $939b927ba32124df$var$LeaderElectionWebLock = $939b927ba32124df$exports.LeaderElectionWebLock = function LeaderElectionWebLock(broadcastChannel, options) {
    var _this = this;
    this.broadcastChannel = broadcastChannel;
    broadcastChannel._befC.push(function() {
        return _this.die();
    });
    this._options = options;
    this.isLeader = false;
    this.isDead = false;
    this.token = (0, $563fa712cae12588$exports.randomToken)();
    this._lstns = [];
    this._unl = [];
    this._dpL = function() {}; // onduplicate listener
    this._dpLC = false; // true when onduplicate called
    this._wKMC = {}; // stuff for cleanup
    // lock name
    this.lN = 'pubkey-bc||' + broadcastChannel.method.type + '||' + broadcastChannel.name;
};
$939b927ba32124df$var$LeaderElectionWebLock.prototype = {
    hasLeader: function hasLeader() {
        var _this2 = this;
        return navigator.locks.query().then(function(locks) {
            var relevantLocks = locks.held ? locks.held.filter(function(lock) {
                return lock.name === _this2.lN;
            }) : [];
            if (relevantLocks && relevantLocks.length > 0) return true;
            else return false;
        });
    },
    awaitLeadership: function awaitLeadership() {
        var _this3 = this;
        if (!this._wLMP) {
            this._wKMC.c = new AbortController();
            var returnPromise = new Promise(function(res, rej) {
                _this3._wKMC.res = res;
                _this3._wKMC.rej = rej;
            });
            this._wLMP = new Promise(function(res, reject) {
                navigator.locks.request(_this3.lN, {
                    signal: _this3._wKMC.c.signal
                }, function() {
                    // if the lock resolved, we can drop the abort controller
                    _this3._wKMC.c = undefined;
                    (0, $308f7d71d2b865d3$exports.beLeader)(_this3);
                    res();
                    return returnPromise;
                })["catch"](function(err) {
                    if (_this3._wKMC.rej) _this3._wKMC.rej(err);
                    reject(err);
                });
            });
        }
        return this._wLMP;
    },
    set onduplicate (_fn){
    // Do nothing because there are no duplicates in the WebLock version
    },
    die: function die() {
        var _this4 = this;
        this._lstns.forEach(function(listener) {
            return _this4.broadcastChannel.removeEventListener('internal', listener);
        });
        this._lstns = [];
        this._unl.forEach(function(uFn) {
            return uFn.remove();
        });
        this._unl = [];
        if (this.isLeader) this.isLeader = false;
        this.isDead = true;
        if (this._wKMC.res) this._wKMC.res();
        if (this._wKMC.c) this._wKMC.c.abort('LeaderElectionWebLock.die() called');
        return (0, $308f7d71d2b865d3$exports.sendLeaderMessage)(this, 'death');
    }
};


var $471cc0014c6ed83d$var$LeaderElection = function LeaderElection(broadcastChannel, options) {
    var _this = this;
    this.broadcastChannel = broadcastChannel;
    this._options = options;
    this.isLeader = false;
    this._hasLeader = false;
    this.isDead = false;
    this.token = (0, $563fa712cae12588$exports.randomToken)();
    /**
   * Apply Queue,
   * used to ensure we do not run applyOnce()
   * in parallel.
   */ this._aplQ = $563fa712cae12588$exports.PROMISE_RESOLVED_VOID;
    // amount of unfinished applyOnce() calls
    this._aplQC = 0;
    // things to clean up
    this._unl = []; // _unloads
    this._lstns = []; // _listeners
    this._dpL = function() {}; // onduplicate listener
    this._dpLC = false; // true when onduplicate called
    /**
   * Even when the own instance is not applying,
   * we still listen to messages to ensure the hasLeader flag
   * is set correctly.
   */ var hasLeaderListener = function hasLeaderListener(msg) {
        if (msg.context === 'leader') {
            if (msg.action === 'death') _this._hasLeader = false;
            if (msg.action === 'tell') _this._hasLeader = true;
        }
    };
    this.broadcastChannel.addEventListener('internal', hasLeaderListener);
    this._lstns.push(hasLeaderListener);
};
$471cc0014c6ed83d$var$LeaderElection.prototype = {
    hasLeader: function hasLeader() {
        return Promise.resolve(this._hasLeader);
    },
    /**
   * Returns true if the instance is leader,
   * false if not.
   * @async
   */ applyOnce: function applyOnce(// true if the applyOnce() call came from the fallbackInterval cycle
    isFromFallbackInterval) {
        var _this2 = this;
        if (this.isLeader) return (0, $563fa712cae12588$exports.sleep)(0, true);
        if (this.isDead) return (0, $563fa712cae12588$exports.sleep)(0, false);
        /**
     * Already applying more than once,
     * -> wait for the apply queue to be finished.
     */ if (this._aplQC > 1) return this._aplQ;
        /**
     * Add a new apply-run
     */ var applyRun = function applyRun() {
            /**
       * Optimization shortcuts.
       * Directly return if a previous run
       * has already elected a leader.
       */ if (_this2.isLeader) return $563fa712cae12588$exports.PROMISE_RESOLVED_TRUE;
            var stopCriteria = false;
            var stopCriteriaPromiseResolve;
            /**
       * Resolves when a stop criteria is reached.
       * Uses as a performance shortcut so we do not
       * have to await the responseTime when it is already clear
       * that the election failed.
       */ var stopCriteriaPromise = new Promise(function(res) {
                stopCriteriaPromiseResolve = function stopCriteriaPromiseResolve() {
                    stopCriteria = true;
                    res();
                };
            });
            var handleMessage = function handleMessage(msg) {
                if (msg.context === 'leader' && msg.token != _this2.token) {
                    if (msg.action === 'apply') // other is applying
                    {
                        if (msg.token > _this2.token) /**
               * other has higher token
               * -> stop applying and let other become leader.
               */ stopCriteriaPromiseResolve();
                    }
                    if (msg.action === 'tell') {
                        // other is already leader
                        stopCriteriaPromiseResolve();
                        _this2._hasLeader = true;
                    }
                }
            };
            _this2.broadcastChannel.addEventListener('internal', handleMessage);
            /**
       * If the applyOnce() call came from the fallbackInterval,
       * we can assume that the election runs in the background and
       * not critical process is waiting for it.
       * When this is true, we give the other instances
       * more time to answer to messages in the election cycle.
       * This makes it less likely to elect duplicate leaders.
       * But also it takes longer which is not a problem because we anyway
       * run in the background.
       */ var waitForAnswerTime = isFromFallbackInterval ? _this2._options.responseTime * 4 : _this2._options.responseTime;
            return (0, $308f7d71d2b865d3$exports.sendLeaderMessage)(_this2, 'apply') // send out that this one is applying
            .then(function() {
                return Promise.race([
                    (0, $563fa712cae12588$exports.sleep)(waitForAnswerTime),
                    stopCriteriaPromise.then(function() {
                        return Promise.reject(new Error());
                    })
                ]);
            })// send again in case another instance was just created
            .then(function() {
                return (0, $308f7d71d2b865d3$exports.sendLeaderMessage)(_this2, 'apply');
            })// let others time to respond
            .then(function() {
                return Promise.race([
                    (0, $563fa712cae12588$exports.sleep)(waitForAnswerTime),
                    stopCriteriaPromise.then(function() {
                        return Promise.reject(new Error());
                    })
                ]);
            })["catch"](function() {}).then(function() {
                _this2.broadcastChannel.removeEventListener('internal', handleMessage);
                if (!stopCriteria) // no stop criteria -> own is leader
                return (0, $308f7d71d2b865d3$exports.beLeader)(_this2).then(function() {
                    return true;
                });
                else // other is leader
                return false;
            });
        };
        this._aplQC = this._aplQC + 1;
        this._aplQ = this._aplQ.then(function() {
            return applyRun();
        }).then(function() {
            _this2._aplQC = _this2._aplQC - 1;
        });
        return this._aplQ.then(function() {
            return _this2.isLeader;
        });
    },
    awaitLeadership: function awaitLeadership() {
        if (/* _awaitLeadershipPromise */ !this._aLP) this._aLP = $471cc0014c6ed83d$var$_awaitLeadershipOnce(this);
        return this._aLP;
    },
    set onduplicate (fn){
        this._dpL = fn;
    },
    die: function die() {
        var _this3 = this;
        this._lstns.forEach(function(listener) {
            return _this3.broadcastChannel.removeEventListener('internal', listener);
        });
        this._lstns = [];
        this._unl.forEach(function(uFn) {
            return uFn.remove();
        });
        this._unl = [];
        if (this.isLeader) {
            this._hasLeader = false;
            this.isLeader = false;
        }
        this.isDead = true;
        return (0, $308f7d71d2b865d3$exports.sendLeaderMessage)(this, 'death');
    }
};
/**
 * @param leaderElector {LeaderElector}
 */ function $471cc0014c6ed83d$var$_awaitLeadershipOnce(leaderElector) {
    if (leaderElector.isLeader) return $563fa712cae12588$exports.PROMISE_RESOLVED_VOID;
    return new Promise(function(res) {
        var resolved = false;
        function finish() {
            if (resolved) return;
            resolved = true;
            leaderElector.broadcastChannel.removeEventListener('internal', whenDeathListener);
            res(true);
        }
        // try once now
        leaderElector.applyOnce().then(function() {
            if (leaderElector.isLeader) finish();
        });
        /**
     * Try on fallbackInterval
     * @recursive
     */ var _tryOnFallBack = function tryOnFallBack() {
            return (0, $563fa712cae12588$exports.sleep)(leaderElector._options.fallbackInterval).then(function() {
                if (leaderElector.isDead || resolved) return;
                if (leaderElector.isLeader) finish();
                else return leaderElector.applyOnce(true).then(function() {
                    if (leaderElector.isLeader) finish();
                    else _tryOnFallBack();
                });
            });
        };
        _tryOnFallBack();
        // try when other leader dies
        var whenDeathListener = function whenDeathListener(msg) {
            if (msg.context === 'leader' && msg.action === 'death') {
                leaderElector._hasLeader = false;
                leaderElector.applyOnce().then(function() {
                    if (leaderElector.isLeader) finish();
                });
            }
        };
        leaderElector.broadcastChannel.addEventListener('internal', whenDeathListener);
        leaderElector._lstns.push(whenDeathListener);
    });
}
function $471cc0014c6ed83d$var$fillOptionsWithDefaults(options, channel) {
    if (!options) options = {};
    options = JSON.parse(JSON.stringify(options));
    if (!options.fallbackInterval) options.fallbackInterval = 3000;
    if (!options.responseTime) options.responseTime = channel.method.averageResponseTime(channel.options);
    return options;
}
function $471cc0014c6ed83d$var$createLeaderElection(channel, options) {
    if (channel._leaderElector) throw new Error('BroadcastChannel already has a leader-elector');
    options = $471cc0014c6ed83d$var$fillOptionsWithDefaults(options, channel);
    var elector = (0, $563fa712cae12588$exports.supportsWebLockAPI)() ? new $939b927ba32124df$exports.LeaderElectionWebLock(channel, options) : new $471cc0014c6ed83d$var$LeaderElection(channel, options);
    channel._befC.push(function() {
        return elector.die();
    });
    channel._leaderElector = elector;
    return elector;
}





/**
 * because babel can only export on default-attribute,
 * we use this for the non-module-build
 * this ensures that users do not have to use
 * var BroadcastChannel = require('broadcast-channel').default;
 * but
 * var BroadcastChannel = require('broadcast-channel');
 */ $f49c866e7a54e899$exports = {
    BroadcastChannel: $f8ad086be43ac0c3$exports.BroadcastChannel,
    createLeaderElection: $f8ad086be43ac0c3$exports.createLeaderElection,
    clearNodeFolder: $f8ad086be43ac0c3$exports.clearNodeFolder,
    enforceOptions: $f8ad086be43ac0c3$exports.enforceOptions,
    beLeader: $f8ad086be43ac0c3$exports.beLeader
};


class $ee79f0831fdf2471$export$8cb546401f8ec14b {
    channel;
    elector;
    eventListeners = [
        ()=>this.onBeforeUnloadHandler(),
        (message)=>this.onMessageHandler(message)
    ];
    onBCMessageHandler;
    onElectedLeaderHandler;
    // Auxiliary variable needed for handling beforeUnload.
    // Closing a tab causes the elector to be killed immediately
    wasLeader = false;
    initialized = false;
    constructor(name, onBCMessageHandler, onElectedLeaderHandler){
        this.onBCMessageHandler = onBCMessageHandler;
        this.onElectedLeaderHandler = onElectedLeaderHandler;
        this.channel = new (0, $f49c866e7a54e899$exports.BroadcastChannel)(name);
        this.elector = (0, $f49c866e7a54e899$exports.createLeaderElection)(this.channel);
    }
    async init() {
        if (this.initialized) return;
        const hasLeader = await this.elector.hasLeader();
        if (!hasLeader) {
            await this.elector.awaitLeadership();
            this.wasLeader = this.isLeader();
        }
        this.channel.onmessage = this.eventListeners[1];
        window?.addEventListener('beforeunload', this.eventListeners[0]);
        this.initialized = true;
    }
    async onBeforeUnloadHandler() {
        if (this.wasLeader) {
            await this.elector.die();
            this.postMessage({
                type: 'LEADER_DEAD'
            });
        }
        window?.removeEventListener('beforeunload', this.eventListeners[0]);
        this.channel.removeEventListener('message', this.eventListeners[1]);
    }
    async onMessageHandler(message) {
        if (message.type === 'LEADER_DEAD') {
            await this.elector.awaitLeadership();
            this.wasLeader = this.isLeader();
            if (this.isLeader()) this.onElectedLeaderHandler();
            return;
        }
        this.onBCMessageHandler(message);
    }
    isLeader() {
        return this.elector.isLeader;
    }
    async getLeadership() {
        return this.elector.awaitLeadership();
    }
    async hasLeader() {
        return this.elector.hasLeader();
    }
    postMessage(message) {
        this.channel.postMessage(message);
    }
}


// src/errors/index.ts




/* eslint-disable prefer-arrow/prefer-arrow-functions */ /**
 * A helper function to make sure if/elses and switch/cases are exhaustive
 *
 * @param empty The data that has to be empty
 */ function $8fe60c2ecf8f9e85$export$cbadc5a7223772a8(empty) {
    return empty;
} /* eslint-enable prefer-arrow/prefer-arrow-functions */ 











const $3797c71f856a2ed6$var$getError = (errorType, errorData)=>{
    switch(errorType){
        case (0, $3402b71e229a176a$export$de39e3c3d623b630).BROADCAST_ERROR:
            return new (0, $a8f2b12327887c60$export$83044806d984e5c6)();
        case (0, $3402b71e229a176a$export$de39e3c3d623b630).NETWORK_NOT_SUPPORTED:
            return new (0, $c12a9d2619de09b6$export$4dfb289da8bd09fd)();
        case (0, $3402b71e229a176a$export$de39e3c3d623b630).NO_ADDRESS_ERROR:
            return new (0, $2d4716f275c51aca$export$9e81db5657a1f0a6)();
        case (0, $3402b71e229a176a$export$de39e3c3d623b630).NO_PRIVATE_KEY_FOUND_ERROR:
            return new (0, $d5ff984206213c6d$export$359c57fe9d5eb841)();
        case (0, $3402b71e229a176a$export$de39e3c3d623b630).NOT_GRANTED_ERROR:
            return new (0, $2c896c9265630313$export$8e600e66f4af7f7d)();
        case (0, $3402b71e229a176a$export$de39e3c3d623b630).PARAMETERS_INVALID_ERROR:
            return new (0, $771922e0933cb721$export$22b8fd83da8b102c)();
        case (0, $3402b71e229a176a$export$de39e3c3d623b630).TOO_MANY_OPERATIONS:
            return new (0, $bb6c701f563f39e3$export$6e17886767f6e528)();
        case (0, $3402b71e229a176a$export$de39e3c3d623b630).TRANSACTION_INVALID_ERROR:
            return new (0, $f1dd0b3b3b4e4035$export$123f0c5aa60e29ed)(errorData);
        case (0, $3402b71e229a176a$export$de39e3c3d623b630).SIGNATURE_TYPE_NOT_SUPPORTED:
            return new (0, $057c875aca7f70a9$export$3fbf9393208a93de)();
        // case BeaconErrorType.ENCRYPTION_TYPE_NOT_SUPPORTED:
        //   return new EncryptionTypeNotSupportedBeaconError()
        case (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR:
            return new (0, $6bd82097f645d3eb$export$4e7a6be3179f008e)();
        case (0, $3402b71e229a176a$export$de39e3c3d623b630).UNKNOWN_ERROR:
            return new (0, $4e2584c02ef3f2b6$export$c9a8ac1e67341255)();
        default:
            (0, $8fe60c2ecf8f9e85$export$cbadc5a7223772a8)(errorType);
    }
};
var $3797c71f856a2ed6$export$2e2bcd8739ae039 = $3797c71f856a2ed6$var$getError;





'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    const msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;



var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(msg, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039);
const $e52be20a9fc15e96$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $c319b2c832c2914a$export$2e2bcd8739ae039).global);
const { ReadableStream: $e52be20a9fc15e96$var$ReadableStream, TextEncoder: $e52be20a9fc15e96$var$TextEncoder } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global;
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    env = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $e52be20a9fc15e96$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction($e52be20a9fc15e96$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $e52be20a9fc15e96$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $e52be20a9fc15e96$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            body: new $e52be20a9fc15e96$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 * 
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: {
        get: $e52be20a9fc15e96$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 * 
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 * 
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 * 
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.13.1";



'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);







var $09f5ffaf4310da0b$export$c26fd134b68e2d9c;
(function(MatrixMessageType) {
    MatrixMessageType["TEXT"] = "m.text";
})($09f5ffaf4310da0b$export$c26fd134b68e2d9c || ($09f5ffaf4310da0b$export$c26fd134b68e2d9c = {}));
class $09f5ffaf4310da0b$export$68b87d833ed5234a {
    type;
    sender;
    content;
    timestamp;
    /**
     * Construct a message from a message event
     *
     * @param event
     */ static from(event) {
        if ((0, $55e984d9e36a0569$export$a7eb12561d44ed31)(event)) return new $09f5ffaf4310da0b$export$68b87d833ed5234a(event.content.msgtype, event.sender, event.content.body, event.origin_server_ts);
        // for now only text messages are supported
        return undefined;
    }
    constructor(type, sender, content, timestamp){
        this.type = type;
        this.sender = sender;
        this.content = content;
        this.timestamp = timestamp;
    }
}


const $55e984d9e36a0569$export$6b0e342bdff619f1 = (event)=>event.type === 'm.room.create' && event.content instanceof Object && 'creator' in event.content;
const $55e984d9e36a0569$export$ddaea47dabb12363 = (event)=>event.type === 'm.room.member' && event.content instanceof Object && 'membership' in event.content && // eslint-disable-next-line dot-notation
    event.content['membership'] === 'join';
const $55e984d9e36a0569$export$ea0920faf73b687d = (event)=>event.type === 'm.room.message';
const $55e984d9e36a0569$export$a7eb12561d44ed31 = (event)=>$55e984d9e36a0569$export$ea0920faf73b687d(event) && event.content instanceof Object && 'msgtype' in event.content && // eslint-disable-next-line dot-notation
    event.content['msgtype'] === (0, $09f5ffaf4310da0b$export$c26fd134b68e2d9c).TEXT;



var $8dace66d39510bd5$export$b4e5f39a63cad558;
(function(MatrixRoomStatus) {
    MatrixRoomStatus[MatrixRoomStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MatrixRoomStatus[MatrixRoomStatus["JOINED"] = 1] = "JOINED";
    MatrixRoomStatus[MatrixRoomStatus["INVITED"] = 2] = "INVITED";
    MatrixRoomStatus[MatrixRoomStatus["LEFT"] = 3] = "LEFT";
})($8dace66d39510bd5$export$b4e5f39a63cad558 || ($8dace66d39510bd5$export$b4e5f39a63cad558 = {}));
class $8dace66d39510bd5$export$d922b96e102f0ccd {
    id;
    status;
    members;
    messages;
    /**
     * Reconstruct rooms from a sync response
     *
     * @param roomSync
     */ static fromSync(roomSync) {
        if (!roomSync) return [];
        function create(rooms, creator) {
            return Object.entries(rooms).map(([id, room])=>creator(id, room));
        }
        return [
            ...create(roomSync.join ?? {}, $8dace66d39510bd5$export$d922b96e102f0ccd.fromJoined),
            ...create(roomSync.invite ?? {}, $8dace66d39510bd5$export$d922b96e102f0ccd.fromInvited),
            ...create(roomSync.leave ?? {}, $8dace66d39510bd5$export$d922b96e102f0ccd.fromLeft)
        ];
    }
    /**
     * Reconstruct a room from an ID or object
     *
     * @param roomOrId
     * @param status
     */ static from(roomOrId, status) {
        return typeof roomOrId === 'string' ? new $8dace66d39510bd5$export$d922b96e102f0ccd(roomOrId, status || $8dace66d39510bd5$export$b4e5f39a63cad558.UNKNOWN) : status !== undefined ? new $8dace66d39510bd5$export$d922b96e102f0ccd(roomOrId.id, status, roomOrId.members, roomOrId.messages) : roomOrId;
    }
    /**
     * Merge new and old state and remove duplicates
     *
     * @param newState
     * @param previousState
     */ static merge(newState, previousState) {
        if (!previousState || previousState.id !== newState.id) return $8dace66d39510bd5$export$d922b96e102f0ccd.from(newState);
        return new $8dace66d39510bd5$export$d922b96e102f0ccd(newState.id, newState.status, [
            ...previousState.members,
            ...newState.members
        ].filter((member, index, array)=>array.indexOf(member) === index), [
            ...previousState.messages,
            ...newState.messages
        ]);
    }
    /**
     * Create a room from a join
     *
     * @param id
     * @param joined
     */ static fromJoined(id, joined) {
        const events = [
            ...joined.state.events,
            ...joined.timeline.events
        ];
        const members = $8dace66d39510bd5$export$d922b96e102f0ccd.getMembersFromEvents(events);
        const messages = $8dace66d39510bd5$export$d922b96e102f0ccd.getMessagesFromEvents(events);
        return new $8dace66d39510bd5$export$d922b96e102f0ccd(id, $8dace66d39510bd5$export$b4e5f39a63cad558.JOINED, members, messages);
    }
    /**
     * Create a room from an invite
     *
     * @param id
     * @param invited
     */ static fromInvited(id, invited) {
        const members = $8dace66d39510bd5$export$d922b96e102f0ccd.getMembersFromEvents(invited.invite_state.events);
        return new $8dace66d39510bd5$export$d922b96e102f0ccd(id, $8dace66d39510bd5$export$b4e5f39a63cad558.INVITED, members);
    }
    /**
     * Create a room from a leave
     *
     * @param id
     * @param left
     */ static fromLeft(id, left) {
        const events = [
            ...left.state.events,
            ...left.timeline.events
        ];
        const members = $8dace66d39510bd5$export$d922b96e102f0ccd.getMembersFromEvents(events);
        const messages = $8dace66d39510bd5$export$d922b96e102f0ccd.getMessagesFromEvents(events);
        return new $8dace66d39510bd5$export$d922b96e102f0ccd(id, $8dace66d39510bd5$export$b4e5f39a63cad558.LEFT, members, messages);
    }
    /**
     * Extract members from an event
     *
     * @param events
     */ static getMembersFromEvents(events) {
        return $8dace66d39510bd5$export$d922b96e102f0ccd.getUniqueEvents(events.filter((event)=>(0, $55e984d9e36a0569$export$6b0e342bdff619f1)(event) || (0, $55e984d9e36a0569$export$ddaea47dabb12363)(event))).map((event)=>event.sender).filter((member, index, array)=>array.indexOf(member) === index);
    }
    /**
     * Extract messages from an event
     *
     * @param events
     */ static getMessagesFromEvents(events) {
        return $8dace66d39510bd5$export$d922b96e102f0ccd.getUniqueEvents(events.filter((0, $55e984d9e36a0569$export$ea0920faf73b687d))).map((event)=>(0, $09f5ffaf4310da0b$export$68b87d833ed5234a).from(event)).filter(Boolean);
    }
    /**
     * Get unique events and remove duplicates
     *
     * @param events
     */ static getUniqueEvents(events) {
        const eventIds = {};
        const uniqueEvents = [];
        events.forEach((event, index)=>{
            const eventId = event.event_id;
            if (eventId === undefined || !(eventId in eventIds)) {
                if (eventId !== undefined) eventIds[eventId] = index;
                uniqueEvents.push(event);
            }
        });
        return uniqueEvents;
    }
    constructor(id, status = $8dace66d39510bd5$export$b4e5f39a63cad558.UNKNOWN, members = [], messages = []){
        this.id = id;
        this.status = status;
        this.members = members;
        this.messages = messages;
    }
}



const $470ddc63d6add73a$var$PRESERVED_FIELDS = [
    'syncToken',
    'rooms'
];
class $470ddc63d6add73a$export$9a21c1400948bb23 {
    storage;
    /**
     * The state of the matrix client
     */ state = {
        isRunning: false,
        userId: undefined,
        deviceId: undefined,
        txnNo: 0,
        accessToken: undefined,
        syncToken: undefined,
        pollingTimeout: undefined,
        pollingRetries: 0,
        rooms: {}
    };
    /**
     * Listeners that will be called when the state changes
     */ onStateChangedListeners = new Map();
    /**
     * A promise that resolves once the client is ready
     */ waitReadyPromise;
    constructor(storage){
        this.storage = storage;
        this.waitReadyPromise = new Promise(async (resolve, reject)=>{
            try {
                await this.initFromStorage();
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
     * Get an item from the state
     *
     * @param key
     */ get(key) {
        return this.state[key];
    }
    /**
     * Get the room from an ID or room instance
     *
     * @param roomOrId
     */ getRoom(roomOrId) {
        const room = (0, $8dace66d39510bd5$export$d922b96e102f0ccd).from(roomOrId, (0, $8dace66d39510bd5$export$b4e5f39a63cad558).UNKNOWN);
        return this.state.rooms[room.id] || room;
    }
    /**
     * Update the state with a partial state
     *
     * @param stateUpdate
     */ async update(stateUpdate) {
        await this.waitReady();
        const oldState = Object.assign({}, this.state);
        this.setState(stateUpdate);
        this.updateStorage(stateUpdate);
        this.notifyListeners(oldState, this.state, stateUpdate);
    }
    /**
     * Register listeners that are called once the state has changed
     *
     * @param listener
     * @param subscribed
     */ onStateChanged(listener, ...subscribed) {
        if (subscribed.length > 0) subscribed.forEach((key)=>{
            this.onStateChangedListeners.set(key, listener);
        });
        else this.onStateChangedListeners.set('all', listener);
    }
    /**
     * A promise that resolves once the client is ready
     */ async waitReady() {
        return this.waitReadyPromise;
    }
    /**
     * Read state from storage
     */ async initFromStorage() {
        const preserved = await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PRESERVED_STATE);
        this.setState(preserved);
    }
    /**
     * Prepare data before persisting it in storage
     *
     * @param toStore
     */ prepareData(toStore) {
        const requiresPreparation = [
            'rooms'
        ];
        const toStoreCopy = requiresPreparation.some((key)=>toStore[key] !== undefined) ? JSON.parse(JSON.stringify(toStore)) : toStore;
        // there is no need for saving messages in a persistent storage
        Object.values(toStoreCopy.rooms || {}).forEach((room)=>{
            room.messages = [];
        });
        return toStoreCopy;
    }
    /**
     * Persist state in storage
     *
     * @param stateUpdate
     */ updateStorage(stateUpdate) {
        const updatedCachedFields = Object.entries(stateUpdate).filter(([key, value])=>$470ddc63d6add73a$var$PRESERVED_FIELDS.includes(key) && Boolean(value));
        if (updatedCachedFields.length > 0) {
            const filteredState = {};
            $470ddc63d6add73a$var$PRESERVED_FIELDS.forEach((key)=>{
                filteredState[key] = this.state[key];
            });
            this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PRESERVED_STATE, this.prepareData(filteredState));
        }
    }
    /**
     * Set the state
     *
     * @param partialState
     */ setState(partialState) {
        this.state = {
            isRunning: partialState.isRunning || this.state.isRunning,
            userId: partialState.userId || this.state.userId,
            deviceId: partialState.deviceId || this.state.deviceId,
            txnNo: partialState.txnNo || this.state.txnNo,
            accessToken: partialState.accessToken || this.state.accessToken,
            syncToken: partialState.syncToken || this.state.syncToken,
            pollingTimeout: partialState.pollingTimeout || this.state.pollingTimeout,
            pollingRetries: partialState.pollingRetries || this.state.pollingRetries,
            rooms: this.mergeRooms(this.state.rooms, partialState.rooms)
        };
    }
    /**
     * Merge room records and eliminate duplicates
     *
     * @param oldRooms
     * @param _newRooms
     */ mergeRooms(oldRooms, _newRooms) {
        if (!_newRooms) return oldRooms;
        const newRooms = Array.isArray(_newRooms) ? _newRooms : Object.values(_newRooms);
        const merged = Object.assign({}, oldRooms);
        newRooms.forEach((newRoom)=>{
            merged[newRoom.id] = (0, $8dace66d39510bd5$export$d922b96e102f0ccd).merge(newRoom, oldRooms[newRoom.id]);
        });
        return merged;
    }
    /**
     * Notify listeners of state changes
     *
     * @param oldState
     * @param newState
     * @param stateChange
     */ notifyListeners(oldState, newState, stateChange) {
        const listenForAll = this.onStateChangedListeners.get('all');
        if (listenForAll) listenForAll(oldState, newState, stateChange);
        (0, $46daaaa2fa498f63$export$ed97f33186d4b816)(stateChange).filter((key)=>stateChange[key] !== undefined).forEach((key)=>{
            const listener = this.onStateChangedListeners.get(key);
            if (listener) listener(oldState, newState, stateChange);
        });
    }
}





const $2fee41f088fd540b$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('MatrixHttpClient');
const $2fee41f088fd540b$var$CLIENT_API_R0 = '/_matrix/client/r0';
class $2fee41f088fd540b$export$273939202d569499 {
    baseUrl;
    cancelTokenSource;
    constructor(baseUrl){
        this.baseUrl = baseUrl;
        this.cancelTokenSource = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).CancelToken.source();
    }
    /**
     * Get data from the synapse node
     *
     * @param endpoint
     * @param options
     */ async get(endpoint, params, options) {
        return this.send('GET', endpoint, options, params);
    }
    /**
     * Post data to the synapse node
     *
     * @param endpoint
     * @param body
     * @param options
     * @param params
     */ async post(endpoint, body, options, params) {
        return this.send('POST', endpoint, options, params, body);
    }
    /**
     * Put data to the synapse node
     *
     * @param endpoint
     * @param body
     * @param options
     * @param params
     */ async put(endpoint, body, options, params) {
        return this.send('PUT', endpoint, options, params, body);
    }
    async cancelAllRequests() {
        return this.cancelTokenSource.cancel('Manually cancelled');
    }
    /**
     * Send a request to the synapse node
     *
     * @param method
     * @param endpoint
     * @param config
     * @param requestParams
     * @param data
     */ async send(method, endpoint, config, requestParams, data) {
        const headers = config ? this.getHeaders(config) : undefined;
        const params = requestParams ? this.getParams(requestParams) : undefined;
        let response;
        try {
            response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).request({
                method: method,
                url: endpoint,
                baseURL: this.apiUrl($2fee41f088fd540b$var$CLIENT_API_R0),
                headers: headers,
                data: data,
                params: params,
                cancelToken: this.cancelTokenSource.token
            });
        } catch (error) {
            const axiosError = error;
            $2fee41f088fd540b$var$logger.error('send', axiosError.code, axiosError.message, axiosError.response.data);
            throw error.response.data;
        }
        return response.data;
    }
    /**
     * Get the headers based on the options object
     *
     * @param options
     */ getHeaders(options) {
        const headers = {};
        const entries = [];
        if (options.accessToken) entries.push([
            'Authorization',
            `Bearer ${options.accessToken}`
        ]);
        if (entries.length === 0) return undefined;
        for (const [key, value] of entries)headers[key] = value;
        return headers;
    }
    /**
     * Get parameters
     *
     * @param _params
     */ getParams(_params) {
        if (!_params) return undefined;
        const params = Object.assign(_params, {});
        (0, $46daaaa2fa498f63$export$ed97f33186d4b816)(params).forEach((key)=>params[key] === undefined && delete params[key]);
        return params;
    }
    /**
     * Construct API URL
     */ apiUrl(...parts) {
        const apiBase = this.baseUrl.endsWith('/') ? this.baseUrl.substr(0, this.baseUrl.length - 1) : this.baseUrl;
        const apiParts = parts.map((path)=>path.startsWith('/') ? path.substr(1) : path);
        return [
            apiBase,
            ...apiParts
        ].join('/');
    }
}




class $03e19e8e698c90aa$export$89cb96db43796b5b {
    httpClient;
    constructor(httpClient){
        this.httpClient = httpClient;
    }
    /**
     * Create a room
     *
     * @param accessToken
     * @param config
     */ async createRoom(accessToken, config = {}) {
        return this.httpClient.post('/createRoom', config, {
            accessToken: accessToken
        });
    }
    /**
     * Invite a user to a room
     *
     * @param accessToken
     * @param user
     * @param room
     */ async inviteToRoom(accessToken, user, room) {
        if (room.status !== (0, $8dace66d39510bd5$export$b4e5f39a63cad558).JOINED && room.status !== (0, $8dace66d39510bd5$export$b4e5f39a63cad558).UNKNOWN) return Promise.reject(`User is not a member of room ${room.id}.`);
        return this.httpClient.post(`/rooms/${encodeURIComponent(room.id)}/invite`, {
            user_id: user
        }, {
            accessToken: accessToken
        });
    }
    /**
     * Join a specific room
     *
     * @param accessToken
     * @param room
     */ async joinRoom(accessToken, room) {
        if (room.status === (0, $8dace66d39510bd5$export$b4e5f39a63cad558).JOINED) return Promise.resolve({
            room_id: room.id
        });
        return this.httpClient.post(`/rooms/${encodeURIComponent(room.id)}/join`, {}, {
            accessToken: accessToken
        });
    }
    /**
     * Get all joined rooms
     *
     * @param accessToken
     */ async getJoinedRooms(accessToken) {
        return this.httpClient.get(`/joined_rooms`, undefined, {
            accessToken: accessToken
        });
    }
}


class $3ca3ae28b9b74073$export$ca01f25571183c1b {
    httpClient;
    constructor(httpClient){
        this.httpClient = httpClient;
    }
    /**
     * Log in to the matrix node with username and password
     *
     * @param user
     * @param password
     * @param deviceId
     */ async login(user, password, deviceId) {
        return this.httpClient.post('/login', {
            type: 'm.login.password',
            identifier: {
                type: 'm.id.user',
                user: user
            },
            password: password,
            device_id: deviceId
        });
    }
}


/**
 * A service to help with matrix event management
 */ class $ee7a66c744e574e7$export$146add376a6d53e5 {
    httpClient;
    cachedPromises = new Map();
    constructor(httpClient){
        this.httpClient = httpClient;
    }
    /**
     * Get the latest state from the matrix node
     *
     * @param accessToken
     * @param options
     */ async sync(accessToken, options) {
        return this.withCache('sync', ()=>this.httpClient.get('/sync', {
                timeout: options ? options.pollingTimeout : undefined,
                since: options ? options.syncToken : undefined
            }, {
                accessToken: accessToken
            }));
    }
    /**
     * Send a message to a room
     *
     * @param accessToken
     * @param room
     * @param content
     * @param txnId
     */ async sendMessage(accessToken, roomId, content, txnId) {
        return new Promise((resolve, reject)=>this.scheduleEvent({
                accessToken: accessToken,
                roomId: roomId,
                type: 'm.room.message',
                content: content,
                txnId: txnId,
                onSuccess: resolve,
                onError: reject
            }));
    }
    /**
     * Schedules an event to be sent to the node
     *
     * @param event
     */ scheduleEvent(event) {
        // TODO: actual scheduling
        this.sendEvent(event);
    }
    /**
     * Send an event to the matrix node
     *
     * @param scheduledEvent
     */ async sendEvent(scheduledEvent) {
        const { roomId: roomId, type: type, txnId: txnId, content: content, accessToken: accessToken } = scheduledEvent;
        try {
            const response = await this.httpClient.put(`/rooms/${encodeURIComponent(roomId)}/send/${type}/${encodeURIComponent(txnId)}`, content, {
                accessToken: accessToken
            });
            scheduledEvent.onSuccess(response);
        } catch (error) {
            scheduledEvent.onError(error);
        }
    }
    /**
     * Check the cache when interacting with the Matrix node, if there is an already ongoing call for the specified key, return its promise instead of duplicating the call.
     *
     * @param key
     * @param promiseProvider
     */ withCache(key, promiseProvider) {
        let promise = this.cachedPromises.get(key);
        if (!promise) {
            promise = promiseProvider().finally(()=>{
                this.cachedPromises.delete(key);
            });
            this.cachedPromises.set(key, promise);
        }
        return promise;
    }
}


// https://gist.github.com/mudge/5830382?permalink_comment_id=2658721#gistcomment-2658721
class $5e5d8ae10c9276da$export$4fae95256245c8c0 {
    events = {};
    on(event, listener) {
        if (typeof this.events[event] !== 'object') this.events[event] = [];
        this.events[event].push(listener);
        return ()=>this.removeListener(event, listener);
    }
    removeListener(event, listener) {
        if (typeof this.events[event] !== 'object') return;
        if (!listener) {
            this.events[event] = [];
            return;
        }
        const idx = this.events[event].indexOf(listener);
        if (idx > -1) this.events[event].splice(idx, 1);
    }
    removeAllListeners() {
        Object.keys(this.events).forEach((event)=>this.events[event].splice(0, this.events[event].length));
    }
    emit(event, ...args) {
        if (typeof this.events[event] !== 'object') return;
        [
            ...this.events[event]
        ].forEach((listener)=>listener.apply(this, args));
    }
    once(event, listener) {
        const remove = this.on(event, (...args)=>{
            remove();
            listener.apply(this, args);
        });
        return remove;
    }
}




var $cc429ecfdcdbd180$export$c8fbc395306a808d;
(function(MatrixClientEventType) {
    MatrixClientEventType["INVITE"] = "invite";
    MatrixClientEventType["MESSAGE"] = "message";
})($cc429ecfdcdbd180$export$c8fbc395306a808d || ($cc429ecfdcdbd180$export$c8fbc395306a808d = {}));


class $2e178ecbfba5dd20$export$f1ea207215937af2 extends (0, $5e5d8ae10c9276da$export$4fae95256245c8c0) {
    eventEmitProviders = new Map([
        [
            (0, $cc429ecfdcdbd180$export$c8fbc395306a808d).INVITE,
            ()=>[
                    this.isInvite,
                    this.emitInvite.bind(this)
                ]
        ],
        [
            (0, $cc429ecfdcdbd180$export$c8fbc395306a808d).MESSAGE,
            ()=>[
                    this.isMessage,
                    this.emitMessage.bind(this)
                ]
        ]
    ]);
    /**
     * This method is called every time the state is changed
     *
     * @param _oldState
     * @param _newState
     * @param stateChange
     */ onStateChanged(_oldState, _newState, stateChange) {
        for (const event of (0, $46daaaa2fa498f63$export$ed97f33186d4b816)((0, $cc429ecfdcdbd180$export$c8fbc395306a808d)))this.emitIfEvent((0, $cc429ecfdcdbd180$export$c8fbc395306a808d)[event], stateChange);
    }
    /**
     * Emit the message if we have listeners registered for that type
     *
     * @param eventType
     * @param object
     */ emitIfEvent(eventType, object) {
        const provider = this.eventEmitProviders.get(eventType);
        if (provider) {
            const [predicate, emitter] = provider();
            if (predicate(object)) emitter(eventType, object);
        }
    }
    /**
     * Emit a client event
     *
     * @param eventType
     * @param content
     */ emitClientEvent(eventType, content, timestamp) {
        this.emit(eventType, {
            type: eventType,
            content: content,
            timestamp: timestamp
        });
    }
    /**
     * Check if event is an invite
     *
     * @param stateChange
     */ isInvite(stateChange) {
        return stateChange.rooms ? stateChange.rooms.some((room)=>room.status === (0, $8dace66d39510bd5$export$b4e5f39a63cad558).INVITED) : false;
    }
    /**
     * Emit an invite
     *
     * @param eventType
     * @param stateChange
     */ emitInvite(eventType, stateChange) {
        stateChange.rooms.filter((room)=>room.status === (0, $8dace66d39510bd5$export$b4e5f39a63cad558).INVITED).map((room)=>[
                room.id,
                room.members
            ]).forEach(([id, members])=>{
            this.emitClientEvent(eventType, {
                roomId: id,
                members: members
            });
        });
    }
    /**
     * Check if event is a message
     *
     * @param stateChange
     */ isMessage(stateChange) {
        return stateChange.rooms ? stateChange.rooms.some((room)=>room.messages.length > 0) : false;
    }
    /**
     * Emit an event to all rooms
     *
     * @param eventType
     * @param stateChange
     */ emitMessage(eventType, stateChange) {
        stateChange.rooms.filter((room)=>room.messages.length > 0).map((room)=>room.messages.map((message)=>[
                    room.id,
                    message,
                    message.timestamp
                ])).reduce((flatten, toFlatten)=>flatten.concat(toFlatten), []).forEach(([roomId, message, timestamp])=>{
            this.emitClientEvent(eventType, {
                roomId: roomId,
                message: message
            }, timestamp);
        });
    }
}


const $693c21b3f83e50f2$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('MatrixClient');
const $693c21b3f83e50f2$var$IMMEDIATE_POLLING_RETRIES = 3;
const $693c21b3f83e50f2$var$RETRY_INTERVAL = 5000;
class $693c21b3f83e50f2$export$444737bbc67d9d5b {
    store;
    eventEmitter;
    userService;
    roomService;
    eventService;
    httpClient;
    isActive = true;
    _isReady = new (0, $247a3319916bcc85$export$babe85162c870d79)();
    constructor(store, eventEmitter, userService, roomService, eventService, httpClient){
        this.store = store;
        this.eventEmitter = eventEmitter;
        this.userService = userService;
        this.roomService = roomService;
        this.eventService = eventService;
        this.httpClient = httpClient;
        this.store.onStateChanged((oldState, newState, stateChange)=>{
            this.eventEmitter.onStateChanged(oldState, newState, stateChange);
        }, 'rooms');
    }
    /**
     * Create a matrix client based on the options provided
     *
     * @param config
     */ static create(config) {
        const store = new (0, $470ddc63d6add73a$export$9a21c1400948bb23)(config.storage);
        const eventEmitter = new (0, $2e178ecbfba5dd20$export$f1ea207215937af2)();
        const httpClient = new (0, $2fee41f088fd540b$export$273939202d569499)(config.baseUrl);
        const accountService = new (0, $3ca3ae28b9b74073$export$ca01f25571183c1b)(httpClient);
        const roomService = new (0, $03e19e8e698c90aa$export$89cb96db43796b5b)(httpClient);
        const eventService = new (0, $ee7a66c744e574e7$export$146add376a6d53e5)(httpClient);
        return new $693c21b3f83e50f2$export$444737bbc67d9d5b(store, eventEmitter, accountService, roomService, eventService, httpClient);
    }
    /**
     * Return all the rooms we are currently part of
     */ get joinedRooms() {
        return new Promise(async (resolve)=>{
            await this.isConnected();
            resolve(Object.values(this.store.get('rooms')).filter((room)=>room.status === (0, $8dace66d39510bd5$export$b4e5f39a63cad558).JOINED));
        });
    }
    /**
     * Return all the rooms to which we have received invitations
     */ get invitedRooms() {
        return new Promise(async (resolve)=>{
            await this.isConnected();
            resolve(Object.values(this.store.get('rooms')).filter((room)=>room.status === (0, $8dace66d39510bd5$export$b4e5f39a63cad558).INVITED));
        });
    }
    /**
     * Return all the rooms that we left
     */ get leftRooms() {
        return new Promise(async (resolve)=>{
            await this.isConnected();
            resolve(Object.values(this.store.get('rooms')).filter((room)=>room.status === (0, $8dace66d39510bd5$export$b4e5f39a63cad558).LEFT));
        });
    }
    /**
     * Initiate the connection to the matrix node and log in
     *
     * @param user
     */ async start(user) {
        const response = await this.userService.login(user.id, user.password, user.deviceId);
        await this.store.update({
            accessToken: response.access_token
        });
        const initialPollingResult = new Promise(async (resolve, reject)=>{
            await this.poll(0, async (pollingResponse)=>{
                if (!this.store.get('isRunning')) resolve();
                await this.store.update({
                    isRunning: true,
                    syncToken: pollingResponse.next_batch,
                    pollingTimeout: 30000,
                    pollingRetries: 0,
                    rooms: (0, $8dace66d39510bd5$export$d922b96e102f0ccd).fromSync(pollingResponse.rooms)
                });
            }, async (error)=>{
                if (!this.store.get('isRunning')) reject(error);
                await this.store.update({
                    isRunning: false,
                    pollingRetries: this.store.get('pollingRetries') + 1
                });
            });
        });
        initialPollingResult.then(()=>{
            this._isReady.resolve();
        }).catch(console.error);
        return initialPollingResult;
    }
    async isConnected() {
        return this._isReady.promise;
    }
    /**
     * Stop all running requests
     */ async stop() {
        $693c21b3f83e50f2$var$logger.log(`MATRIX CLIENT STOPPED`);
        this.isActive = false;
        this._isReady = new (0, $247a3319916bcc85$export$babe85162c870d79)();
        return this.httpClient.cancelAllRequests();
    }
    /**
     * Subscribe to new matrix events
     *
     * @param event
     * @param listener
     */ subscribe(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    /**
     * Unsubscribe from matrix events
     *
     * @param event
     * @param listener
     */ unsubscribe(event, listener) {
        if (listener) this.eventEmitter.removeListener(event, listener);
    }
    /**
     * Unsubscribe from all matrix events of this type
     *
     * @param event
     * @param listener
     */ unsubscribeAll(event) {
        this.eventEmitter.removeListener(event);
    }
    async getRoomById(id) {
        await this.isConnected();
        return this.store.getRoom(id);
    }
    /**
     * Create a private room with the supplied members
     *
     * @param members Members that will be in the room
     */ async createTrustedPrivateRoom(...members) {
        await this.isConnected();
        return this.requiresAuthorization('createRoom', async (accessToken)=>{
            const response = await this.roomService.createRoom(accessToken, {
                room_version: '5',
                invite: members,
                preset: 'public_chat',
                is_direct: true
            });
            return response.room_id;
        });
    }
    /**
     * Invite user to rooms
     *
     * @param user The user to be invited
     * @param roomsOrIds The rooms the user will be invited to
     */ async inviteToRooms(user, ...roomsOrIds) {
        await this.isConnected();
        await this.requiresAuthorization('invite', (accessToken)=>Promise.all(roomsOrIds.map((roomOrId)=>{
                const room = this.store.getRoom(roomOrId);
                this.roomService.inviteToRoom(accessToken, user, room).catch((error)=>$693c21b3f83e50f2$var$logger.warn('inviteToRooms', error));
            })));
    }
    /**
     * Join rooms
     *
     * @param roomsOrIds
     */ async joinRooms(...roomsOrIds) {
        await this.isConnected();
        await this.requiresAuthorization('join', (accessToken)=>Promise.all(roomsOrIds.map((roomOrId)=>{
                const room = this.store.getRoom(roomOrId);
                return this.roomService.joinRoom(accessToken, room);
            })));
    }
    /**
     * Send a text message
     *
     * @param roomOrId
     * @param message
     */ async sendTextMessage(roomId, message) {
        await this.isConnected();
        await this.requiresAuthorization('send', async (accessToken)=>{
            const txnId = await this.createTxnId();
            return this.eventService.sendMessage(accessToken, roomId, {
                msgtype: 'm.text',
                body: message
            }, txnId);
        });
    }
    /**
     * Poll the server to get the latest data and get notified of changes
     *
     * @param interval
     * @param onSyncSuccess
     * @param onSyncError
     */ async poll(interval, onSyncSuccess, onSyncError) {
        const store = this.store;
        const sync = this.sync.bind(this);
        const pollSync = async (resolve, reject)=>{
            let syncingRetries = 0;
            try {
                const response = await sync();
                onSyncSuccess(response);
            } catch (error) {
                onSyncError(error);
                syncingRetries = store.get('pollingRetries');
                // console.warn('Could not sync:', error)
                if (this.isActive) $693c21b3f83e50f2$var$logger.log(`Retry syncing... ${syncingRetries} retries so far`);
            } finally{
                if (this.isActive) setTimeout(async ()=>{
                    await pollSync(resolve, reject);
                }, syncingRetries > $693c21b3f83e50f2$var$IMMEDIATE_POLLING_RETRIES ? $693c21b3f83e50f2$var$RETRY_INTERVAL + interval : interval);
                else reject(new Error(`Syncing stopped manually.`));
            }
        };
        return new Promise(pollSync);
    }
    /**
     * Get state from server
     */ async sync() {
        return this.requiresAuthorization('sync', async (accessToken)=>this.eventService.sync(accessToken, {
                pollingTimeout: this.store.get('pollingTimeout'),
                syncToken: this.store.get('syncToken')
            }));
    }
    /**
     * A helper method that makes sure an access token is provided
     *
     * @param name
     * @param action
     */ async requiresAuthorization(name, action) {
        const storedToken = this.store.get('accessToken');
        if (!storedToken) return Promise.reject(`${name} requires authorization but no access token has been provided.`);
        return action(storedToken);
    }
    /**
     * Create a transaction ID
     */ async createTxnId() {
        const timestamp = new Date().getTime();
        const counter = this.store.get('txnNo');
        await this.store.update({
            txnNo: counter + 1
        });
        return `m${timestamp}.${counter}`;
    }
}









var $6ZWSX = parcelRequire("6ZWSX");
var $c82337330ed46a8a$require$Buffer = $6ZWSX.Buffer;
const $c82337330ed46a8a$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('P2PCommunicationClient');
const $c82337330ed46a8a$var$RESPONSE_WAIT_TIME_MS = 60000; // total wait time for all the probes
const $c82337330ed46a8a$var$REGIONS_AND_SERVERS = {
    [(0, $15656c470911b69d$export$b63330adaddce5a3).EUROPE_WEST]: [
        'beacon-node-1.diamond.papers.tech',
        'beacon-node-1.sky.papers.tech',
        'beacon-node-2.sky.papers.tech',
        'beacon-node-1.hope.papers.tech',
        'beacon-node-1.hope-2.papers.tech',
        'beacon-node-1.hope-3.papers.tech',
        'beacon-node-1.hope-4.papers.tech',
        'beacon-node-1.hope-5.papers.tech'
    ],
    [(0, $15656c470911b69d$export$b63330adaddce5a3).NORTH_AMERICA_EAST]: [
        'beacon-node-1.beacon-server-1.papers.tech'
    ],
    [(0, $15656c470911b69d$export$b63330adaddce5a3).NORTH_AMERICA_WEST]: [
        'beacon-node-1.beacon-server-2.papers.tech'
    ],
    [(0, $15656c470911b69d$export$b63330adaddce5a3).ASIA_EAST]: [
        'beacon-node-1.beacon-server-3.papers.tech'
    ],
    [(0, $15656c470911b69d$export$b63330adaddce5a3).AUSTRALIA]: [
        'beacon-node-1.beacon-server-4.papers.tech'
    ]
};
const $c82337330ed46a8a$var$sleep = (time)=>{
    return new Promise((resolve)=>setTimeout(resolve, time));
};
class $c82337330ed46a8a$export$3ad3037eaf13a9fc extends (0, $a78bfde4d24b2c3a$export$ff98bc0bfc6c5f28) {
    name;
    replicationCount;
    storage;
    iconUrl;
    appUrl;
    client = new (0, $247a3319916bcc85$export$babe85162c870d79)();
    initialEvent;
    initialListener;
    selectedRegion;
    ENABLED_RELAY_SERVERS;
    relayServer;
    activeListeners = new Map();
    ignoredRooms = [];
    loginCounter = 0;
    constructor(name, keyPair, replicationCount, storage, matrixNodes, iconUrl, appUrl){
        super(keyPair);
        this.name = name;
        this.replicationCount = replicationCount;
        this.storage = storage;
        this.iconUrl = iconUrl;
        this.appUrl = appUrl;
        $c82337330ed46a8a$var$logger.log('constructor', 'P2PCommunicationClient created');
        this.ENABLED_RELAY_SERVERS = $c82337330ed46a8a$var$REGIONS_AND_SERVERS;
        if (matrixNodes) this.ENABLED_RELAY_SERVERS = {
            ...$c82337330ed46a8a$var$REGIONS_AND_SERVERS,
            ...matrixNodes
        };
    }
    async getPairingRequestInfo() {
        const info = new (0, $7625031e92f13c50$export$5105399ce7c287dd)(await (0, $788668db41590f82$export$2dbe1b699c206fb)(), this.name, await this.getPublicKey(), (0, $217f751cff903b1b$export$2220237b3fa2434a), (await this.getRelayServer()).server);
        if (this.iconUrl) info.icon = this.iconUrl;
        if (this.appUrl) info.appUrl = this.appUrl;
        return info;
    }
    async getPairingResponseInfo(request) {
        const info = new (0, $72fa78d0a3e4e700$export$8d55e7f86bba45ec)(request.id, this.name, await this.getPublicKey(), request.version, (await this.getRelayServer()).server);
        if (this.iconUrl) info.icon = this.iconUrl;
        if (this.appUrl) info.appUrl = this.appUrl;
        return info;
    }
    /**
     * To get the fastest region, we can't simply do one request, because sometimes,
     * DNS and SSL handshakes make "faster" connections slower. So we need to do 2 requests
     * and check which request was the fastest after 1s.
     */ async findBestRegionAndGetServer() {
        if (this.selectedRegion) return this.relayServer?.promiseResult;
        const probes = Object.entries(this.ENABLED_RELAY_SERVERS).flatMap(([region, servers])=>servers.map((server)=>({
                    server: server,
                    region: region
                }))).sort(()=>Math.random() - 0.5);
        const results = [];
        const probePromises = probes.map(({ server: server, region: region })=>(async ()=>{
                const start = Date.now();
                try {
                    const info = await this.getBeaconInfo(server);
                    results.push({
                        server: server,
                        region: region,
                        time: Date.now() - start,
                        timestamp: info.timestamp
                    });
                } catch (err) {
                    $c82337330ed46a8a$var$logger.warn(`probe for ${server} failed:`, err);
                // swallow the error so Promise.all never rejects
                }
            })());
        // 3) Wait until either:
        //    • all probes settle (fast regions), or
        //    • we hit our global timeout
        await Promise.race([
            Promise.all(probePromises),
            $c82337330ed46a8a$var$sleep($c82337330ed46a8a$var$RESPONSE_WAIT_TIME_MS)
        ]);
        // 4) If nobody replied, bail out
        if (results.length === 0) throw new Error('No server responded.');
        // 5) Pick the lowest-latency reply
        const best = results.reduce((a, b)=>b.time < a.time ? b : a);
        this.selectedRegion = best.region;
        return {
            server: best.server,
            timestamp: best.timestamp
        };
    }
    async getRelayServer() {
        if (this.relayServer) {
            const relayServer = await this.relayServer.promise;
            // We make sure the locally cached timestamp is not older than 1 minute, if it is, we refresh it
            if (Date.now() - relayServer.localTimestamp < 60000) return {
                server: relayServer.server,
                timestamp: relayServer.timestamp
            };
            const info = await this.getBeaconInfo(relayServer.server);
            this.relayServer.resolve({
                server: relayServer.server,
                timestamp: info.timestamp,
                localTimestamp: new Date().getTime()
            });
            return {
                server: relayServer.server,
                timestamp: info.timestamp
            };
        } else this.relayServer = new (0, $247a3319916bcc85$export$babe85162c870d79)();
        const node = await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_SELECTED_NODE);
        if (node && node.length > 0) {
            const info = await this.getBeaconInfo(node);
            this.relayServer.resolve({
                server: node,
                timestamp: info.timestamp,
                localTimestamp: new Date().getTime()
            });
            return {
                server: node,
                timestamp: info.timestamp
            };
        }
        const server = await this.findBestRegionAndGetServer();
        if (!server) throw new Error(`No servers found`);
        this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_SELECTED_NODE, server.server).catch((error)=>$c82337330ed46a8a$var$logger.log(error));
        this.relayServer.resolve({
            server: server.server,
            timestamp: server.timestamp,
            localTimestamp: new Date().getTime()
        });
        return {
            server: server.server,
            timestamp: server.timestamp
        };
    }
    async getBeaconInfo(server) {
        return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`https://${server}/_synapse/client/beacon/info`).then((res)=>({
                region: res.data.region,
                known_servers: res.data.known_servers,
                timestamp: Math.floor(res.data.timestamp)
            }));
    }
    async tryJoinRooms(roomId, retry = 1) {
        try {
            await (await this.client.promise).joinRooms(roomId);
        } catch (error) {
            if (retry <= 10 && error.errcode === 'M_FORBIDDEN') {
                // If we join the room too fast after receiving the invite, the server can accidentally reject our join. This seems to be a problem only when using a federated multi-node setup. Usually waiting for a couple milliseconds solves the issue, but to handle lag, we will keep retrying for 2 seconds.
                $c82337330ed46a8a$var$logger.log(`Retrying to join...`, error);
                setTimeout(async ()=>{
                    await this.tryJoinRooms(roomId, retry + 1);
                }, 200);
            } else $c82337330ed46a8a$var$logger.log(`Failed to join after ${retry} tries.`, error);
        }
    }
    async start() {
        $c82337330ed46a8a$var$logger.log('start', 'starting client');
        $c82337330ed46a8a$var$logger.log('start', `connecting to server`);
        const relayServer = await this.getRelayServer();
        const client = (0, $693c21b3f83e50f2$export$444737bbc67d9d5b).create({
            baseUrl: `https://${relayServer.server}`,
            storage: this.storage
        });
        this.initialListener = async (event)=>{
            if (this.initialEvent && this.initialEvent.timestamp && event && event.timestamp) {
                if (this.initialEvent.timestamp < event.timestamp) this.initialEvent = event;
            } else this.initialEvent = event;
        };
        client.subscribe((0, $cc429ecfdcdbd180$export$c8fbc395306a808d).MESSAGE, this.initialListener);
        client.subscribe((0, $cc429ecfdcdbd180$export$c8fbc395306a808d).INVITE, async (event)=>{
            let member;
            if (event.content.members.length === 1) // If there is only one member we know it's a new room
            // TODO: Use the "sender" of the event instead
            member = event.content.members[0];
            await this.tryJoinRooms(event.content.roomId);
            if (member) {
                await this.updateRelayServer(member);
                await this.updatePeerRoom(member, event.content.roomId);
            }
        });
        if (!relayServer.timestamp) throw new Error('No timestamp received from relay server');
        const time = Math.floor(relayServer.timestamp);
        const loginString = `login:${Math.floor(time / 300)}`;
        $c82337330ed46a8a$var$logger.log('start', `login ${loginString}, ${await this.getPublicKeyHash()} on ${relayServer.server}`);
        const loginRawDigest = (0, $b245bb78b1cc020b$export$d6af199866bfb566)((0, $9a00e3fafffa883b$export$c564cdbbe6da493)(loginString), 32);
        const secretKey = this.keyPair.secretKey ?? this.keyPair.privateKey;
        const rawSignature = (0, $a1d7ebd43ba0a83c$export$c5552dfdbc7cec71)(secretKey, loginRawDigest);
        try {
            await client.start({
                id: await this.getPublicKeyHash(),
                password: `ed:${(0, $efd1a952be4e6fd9$export$7ea66e3774a60b67)(rawSignature)}:${await this.getPublicKey()}`,
                deviceId: (0, $efd1a952be4e6fd9$export$7ea66e3774a60b67)(this.keyPair.publicKey)
            });
        } catch (error) {
            $c82337330ed46a8a$var$logger.error('start', 'Could not log in, retrying', error);
            if (error.errcode === 'M_USER_DEACTIVATED') {
                await this.generateNewKeyPair();
                await this.reset();
                throw new Error('The account is deactivated.');
            }
            await this.reset(); // If we can't log in, let's reset
            if (!this.selectedRegion) throw new Error('No region selected.');
            if (this.loginCounter <= (this.ENABLED_RELAY_SERVERS[this.selectedRegion] ?? []).length) {
                this.loginCounter++;
                this.start();
                return;
            } else {
                $c82337330ed46a8a$var$logger.error('start', 'Tried to log in to every known beacon node, but no login was successful.');
                throw new Error('Could not connect to any beacon nodes. Try again later.');
            }
        }
        $c82337330ed46a8a$var$logger.log('start', 'login successful, client is ready');
        this.client.resolve(client);
    }
    async stop() {
        $c82337330ed46a8a$var$logger.log('stop', 'stopping client');
        if (this.client.isResolved()) await (await this.client.promise).stop().catch((error)=>$c82337330ed46a8a$var$logger.error(error));
        await this.reset();
    }
    async reset() {
        $c82337330ed46a8a$var$logger.log('reset', 'resetting connection');
        await this.storage.delete((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PEER_ROOM_IDS).catch((error)=>$c82337330ed46a8a$var$logger.log(error));
        await this.storage.delete((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PRESERVED_STATE).catch((error)=>$c82337330ed46a8a$var$logger.log(error));
        await this.storage.delete((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_SELECTED_NODE).catch((error)=>$c82337330ed46a8a$var$logger.log(error));
        // Instead of resetting everything, maybe we should make sure a new instance is created?
        this.relayServer = undefined;
        this.client = new (0, $247a3319916bcc85$export$babe85162c870d79)();
        this.initialEvent = undefined;
        this.initialListener = undefined;
    }
    async listenForEncryptedMessage(senderPublicKey, messageCallback) {
        if (this.activeListeners.has(senderPublicKey)) return;
        $c82337330ed46a8a$var$logger.log('listenForEncryptedMessage', `start listening for encrypted messages from publicKey ${senderPublicKey}`);
        const sharedKey = await this.createCryptoBoxServer(senderPublicKey, this.keyPair);
        const callbackFunction = async (event)=>{
            if (this.isTextMessage(event.content) && await this.isSender(event, senderPublicKey)) {
                let payload;
                await this.updateRelayServer(event.content.message.sender);
                await this.updatePeerRoom(event.content.message.sender, event.content.roomId);
                try {
                    payload = $c82337330ed46a8a$require$Buffer.from(event.content.message.content, 'hex');
                // content can be non-hex if it's a connection open request
                } catch  {
                /* */ }
                if (payload && payload.length >= (0, $15a40981d98388e5$export$5a119edad5f33470) + (0, $15a40981d98388e5$export$a5d0660c4a35a096)) try {
                    const decryptedMessage = await (0, $efd1a952be4e6fd9$export$b8de54a33cec1158)(payload, sharedKey.receive);
                    $c82337330ed46a8a$var$logger.log('listenForEncryptedMessage', `received a message from ${senderPublicKey}`, decryptedMessage);
                    // logger.log(
                    //   'listenForEncryptedMessage',
                    //   'encrypted message received',
                    //   decryptedMessage,
                    //   await new Serializer().deserialize(decryptedMessage)
                    // )
                    // console.log('calculated sender ID', await getSenderId(senderPublicKey))
                    // TODO: Add check for correct decryption key / sender ID
                    messageCallback(decryptedMessage);
                } catch (decryptionError) {
                /* NO-OP. We try to decode every message, but some might not be addressed to us. */ }
            }
        };
        this.activeListeners.set(senderPublicKey, callbackFunction);
        (await this.client.promise).subscribe((0, $cc429ecfdcdbd180$export$c8fbc395306a808d).MESSAGE, callbackFunction);
        const lastEvent = this.initialEvent;
        if (lastEvent && lastEvent.timestamp && new Date().getTime() - lastEvent.timestamp < 300000) {
            $c82337330ed46a8a$var$logger.log('listenForEncryptedMessage', 'Handling previous event');
            await callbackFunction(lastEvent);
        } else $c82337330ed46a8a$var$logger.log('listenForEncryptedMessage', 'No previous event found');
        const initialListener = this.initialListener;
        if (initialListener) (await this.client.promise).unsubscribe((0, $cc429ecfdcdbd180$export$c8fbc395306a808d).MESSAGE, initialListener);
        this.initialListener = undefined;
        this.initialEvent = undefined;
    }
    async unsubscribeFromEncryptedMessage(senderPublicKey) {
        const listener = this.activeListeners.get(senderPublicKey);
        if (!listener) return;
        (await this.client.promise).unsubscribe((0, $cc429ecfdcdbd180$export$c8fbc395306a808d).MESSAGE, listener);
        this.activeListeners.delete(senderPublicKey);
    }
    async unsubscribeFromEncryptedMessages() {
        (await this.client.promise).unsubscribeAll((0, $cc429ecfdcdbd180$export$c8fbc395306a808d).MESSAGE);
        this.activeListeners.clear();
    }
    async sendMessage(message, peer) {
        const sharedKey = await this.createCryptoBoxClient(peer.publicKey, this.keyPair);
        const recipientHash = await (0, $efd1a952be4e6fd9$export$c3338cbceb8bf393)($c82337330ed46a8a$require$Buffer.from(peer.publicKey, 'hex'));
        const recipient = (0, $efd1a952be4e6fd9$export$1a3a10450432dc35)(recipientHash, peer.relayServer);
        const roomId = await this.getRelevantRoom(recipient);
        // Before we send the message, we have to wait for the join to be accepted.
        // await this.waitForJoin(roomId) // TODO: This can probably be removed because we are now waiting inside the get room method
        const encryptedMessage = await (0, $efd1a952be4e6fd9$export$e46cb313f94b0706)(message, sharedKey.send);
        $c82337330ed46a8a$var$logger.log('sendMessage', 'sending encrypted message', peer.publicKey, roomId, message);
        (await this.client.promise).sendTextMessage(roomId, encryptedMessage).catch(async (error)=>{
            if (error.errcode === 'M_FORBIDDEN') {
                // Room doesn't exist
                $c82337330ed46a8a$var$logger.log(`sendMessage`, `M_FORBIDDEN`, roomId, error);
                await this.deleteRoomIdFromRooms(roomId);
                const newRoomId = await this.getRelevantRoom(recipient);
                $c82337330ed46a8a$var$logger.log(`sendMessage`, `Old room deleted, new room created`, newRoomId);
                (await this.client.promise).sendTextMessage(newRoomId, encryptedMessage).catch(async (error2)=>{
                    $c82337330ed46a8a$var$logger.log(`sendMessage`, `inner error`, newRoomId, error2);
                });
            } else $c82337330ed46a8a$var$logger.log(`sendMessage`, `unexpected error`, error);
        });
    }
    async updatePeerRoom(sender, roomId) {
        $c82337330ed46a8a$var$logger.log(`updatePeerRoom`, sender, roomId);
        // Sender is in the format "@pubkeyhash:relayserver.tld"
        const split = sender.split(':');
        if (split.length < 2 || !split[0].startsWith('@')) throw new Error('Invalid sender');
        const roomIds = await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PEER_ROOM_IDS);
        const room = roomIds[sender];
        if (room === roomId) $c82337330ed46a8a$var$logger.debug(`updatePeerRoom`, `rooms are the same, not updating`);
        $c82337330ed46a8a$var$logger.debug(`updatePeerRoom`, `current room`, room, 'new room', roomId);
        if (room && room[1]) {
            // If we have a room already, let's ignore it. We need to do this, otherwise it will be loaded from the matrix cache.
            $c82337330ed46a8a$var$logger.log(`updatePeerRoom`, `adding room "${room[1]}" to ignored array`);
            this.ignoredRooms.push(room[1]);
        }
        roomIds[sender] = roomId;
        await this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PEER_ROOM_IDS, roomIds);
    // TODO: We also need to delete the room from the sync state
    // If we need to delete a room, we can assume the local state is not up to date anymore, so we can reset the state
    }
    async deleteRoomIdFromRooms(roomId) {
        const roomIds = await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PEER_ROOM_IDS);
        const newRoomIds = Object.entries(roomIds).filter((entry)=>entry[1] !== roomId).reduce((pv, cv)=>({
                ...pv,
                [cv[0]]: cv[1]
            }), {});
        await this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PEER_ROOM_IDS, newRoomIds);
        // TODO: We also need to delete the room from the sync state
        // If we need to delete a room, we can assume the local state is not up to date anymore, so we can reset the state
        this.ignoredRooms.push(roomId);
    }
    async listenForChannelOpening(messageCallback) {
        $c82337330ed46a8a$var$logger.debug(`listenForChannelOpening`);
        (await this.client.promise).subscribe((0, $cc429ecfdcdbd180$export$c8fbc395306a808d).MESSAGE, async (event)=>{
            if (this.isTextMessage(event.content) && await this.isChannelOpenMessage(event.content)) {
                $c82337330ed46a8a$var$logger.log(`listenForChannelOpening`, `channel opening received, trying to decrypt`, JSON.stringify(event));
                await this.updateRelayServer(event.content.message.sender);
                await this.updatePeerRoom(event.content.message.sender, event.content.roomId);
                const splits = event.content.message.content.split(':');
                const payload = $c82337330ed46a8a$require$Buffer.from(splits[splits.length - 1], 'hex');
                if (payload.length >= (0, $15a40981d98388e5$export$5a119edad5f33470) + (0, $15a40981d98388e5$export$a5d0660c4a35a096)) try {
                    const pairingResponse = JSON.parse(await (0, $efd1a952be4e6fd9$export$26920d2a32821f84)(payload, this.keyPair.publicKey, this.keyPair.secretKey));
                    $c82337330ed46a8a$var$logger.log(`listenForChannelOpening`, `channel opening received and decrypted`, JSON.stringify(pairingResponse));
                    messageCallback({
                        ...pairingResponse,
                        senderId: await (0, $1c5c036caa7dc2d6$export$c00969587a4639cc)(pairingResponse.publicKey)
                    });
                } catch (decryptionError) {
                /* NO-OP. We try to decode every message, but some might not be addressed to us. */ }
            }
        });
    }
    async waitForJoin(roomId, retry = 0) {
        // Rooms are updated as new events come in. `client.getRoomById` only accesses memory, it does not do any network requests.
        // TODO: Improve to listen to "JOIN" event
        const room = await (await this.client.promise).getRoomById(roomId);
        $c82337330ed46a8a$var$logger.log(`waitForJoin`, `Currently ${room.members.length} members, we need at least 2`);
        if (room.members.length >= 2) return;
        else {
            if (retry <= 200) {
                // On mobile, due to app switching, we potentially have to wait for a long time
                $c82337330ed46a8a$var$logger.log(`Waiting for join... Try: ${retry}`);
                return new Promise((resolve)=>{
                    setTimeout(()=>{
                        resolve(this.waitForJoin(roomId, retry + 1));
                    }, 100 * (retry > 50 ? 10 : 1)); // After the initial 5 seconds, retry only once per second
                });
            } else throw new Error(`No one joined after ${retry} tries.`);
        }
    }
    async sendPairingResponse(pairingRequest) {
        $c82337330ed46a8a$var$logger.log(`sendPairingResponse`);
        const recipientHash = await (0, $efd1a952be4e6fd9$export$c3338cbceb8bf393)($c82337330ed46a8a$require$Buffer.from(pairingRequest.publicKey, 'hex'));
        const recipient = (0, $efd1a952be4e6fd9$export$1a3a10450432dc35)(recipientHash, pairingRequest.relayServer);
        // We force room creation here because if we "re-pair", we need to make sure that we don't send it to an old room.
        const roomId = await (await this.client.promise).createTrustedPrivateRoom(recipient);
        $c82337330ed46a8a$var$logger.debug(`sendPairingResponse`, `Connecting to room "${roomId}"`);
        await this.updatePeerRoom(recipient, roomId);
        // Before we send the message, we have to wait for the join to be accepted.
        await this.waitForJoin(roomId); // TODO: This can probably be removed because we are now waiting inside the get room method
        $c82337330ed46a8a$var$logger.debug(`sendPairingResponse`, `Successfully joined room.`);
        // TODO: remove v1 backwards-compatibility
        const message = typeof pairingRequest.version === 'undefined' ? await this.getPublicKey() // v1
         : JSON.stringify(await this.getPairingResponseInfo(pairingRequest)); // v2
        $c82337330ed46a8a$var$logger.debug(`sendPairingResponse`, `Sending pairing response`, message);
        const encryptedMessage = await this.encryptMessageAsymmetric(pairingRequest.publicKey, message);
        const msg = [
            '@channel-open',
            recipient,
            encryptedMessage
        ].join(':');
        (await this.client.promise).sendTextMessage(roomId, msg).catch(async (error)=>{
            if (error.errcode === 'M_FORBIDDEN') {
                // Room doesn't exist
                $c82337330ed46a8a$var$logger.log(`sendPairingResponse`, `M_FORBIDDEN`, roomId, error);
                await this.deleteRoomIdFromRooms(roomId);
                const newRoomId = await this.getRelevantRoom(recipient);
                $c82337330ed46a8a$var$logger.log(`sendPairingResponse`, `Old room deleted, new room created`, newRoomId);
                (await this.client.promise).sendTextMessage(newRoomId, msg).catch(async (error2)=>{
                    $c82337330ed46a8a$var$logger.log(`sendPairingResponse`, `inner error`, newRoomId, error2);
                });
            } else $c82337330ed46a8a$var$logger.log(`sendPairingResponse`, `unexpected error`, error);
        });
    }
    isTextMessage(content) {
        return content.message.type === (0, $09f5ffaf4310da0b$export$c26fd134b68e2d9c).TEXT;
    }
    async updateRelayServer(sender) {
        $c82337330ed46a8a$var$logger.log(`updateRelayServer`, sender);
        // Sender is in the format "@pubkeyhash:relayserver.tld"
        const split = sender.split(':');
        if (split.length < 2 || !split[0].startsWith('@')) throw new Error('Invalid sender');
        const senderHash = split.shift();
        const relayServer = split.join(':');
        const manager = localStorage.getItem('beacon:communication-peers-dapp') ? new (0, $3514bc91c0d3d509$export$a1f30c6c22927bc5)(this.storage, (0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_P2P_PEERS_DAPP) : new (0, $3514bc91c0d3d509$export$a1f30c6c22927bc5)(this.storage, (0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_P2P_PEERS_WALLET);
        const peers = await manager.getPeers();
        const promiseArray = peers.map(async (peer)=>{
            const hash = `@${await (0, $efd1a952be4e6fd9$export$c3338cbceb8bf393)($c82337330ed46a8a$require$Buffer.from(peer.publicKey, 'hex'))}`;
            if (hash === senderHash) {
                if (peer.relayServer !== relayServer) {
                    peer.relayServer = relayServer;
                    await manager.addPeer(peer);
                }
            }
        });
        await Promise.all(promiseArray);
    }
    async isChannelOpenMessage(content) {
        return content.message.content.startsWith(`@channel-open:@${await (0, $efd1a952be4e6fd9$export$c3338cbceb8bf393)($c82337330ed46a8a$require$Buffer.from(await this.getPublicKey(), 'hex'))}`);
    }
    async isSender(event, senderPublicKey) {
        return event.content.message.sender.startsWith(`@${await (0, $efd1a952be4e6fd9$export$c3338cbceb8bf393)($c82337330ed46a8a$require$Buffer.from(senderPublicKey, 'hex'))}`);
    }
    async generateNewKeyPair() {
        const newSeed = await (0, $788668db41590f82$export$2dbe1b699c206fb)();
        console.warn(`The current user ID has been deactivated. Generating new ID: ${newSeed}`);
        this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).BEACON_SDK_SECRET_SEED, newSeed);
        this.keyPair = await (0, $efd1a952be4e6fd9$export$f73c212cf4258056)(newSeed);
    }
    async getRelevantRoom(recipient) {
        const roomIds = await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PEER_ROOM_IDS);
        let roomId = roomIds[recipient];
        if (!roomId) {
            $c82337330ed46a8a$var$logger.log(`getRelevantRoom`, `No room found for peer ${recipient}, checking joined ones.`);
            const room = await this.getRelevantJoinedRoom(recipient);
            roomId = room.id;
            roomIds[recipient] = room.id;
            await this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).MATRIX_PEER_ROOM_IDS, roomIds);
        }
        $c82337330ed46a8a$var$logger.log(`getRelevantRoom`, `Using room ${roomId}`);
        return roomId;
    }
    async getRelevantJoinedRoom(recipient) {
        const joinedRooms = await (await this.client.promise).joinedRooms;
        $c82337330ed46a8a$var$logger.log('checking joined rooms', joinedRooms, recipient);
        const relevantRooms = joinedRooms.filter((roomElement)=>!this.ignoredRooms.some((id)=>roomElement.id === id)).filter((roomElement)=>roomElement.members.some((member)=>member === recipient));
        let room;
        // We always create a new room if one has been ignored. This is because if we ignore one, we know the server state changed.
        // So we cannot trust the current sync state. This can be removed once we have a method to properly clear and refresh the sync state.
        if (relevantRooms.length === 0 || this.ignoredRooms.length > 0) {
            $c82337330ed46a8a$var$logger.log(`getRelevantJoinedRoom`, `no relevant rooms found, creating new one`);
            const roomId = await (await this.client.promise).createTrustedPrivateRoom(recipient);
            room = await (await this.client.promise).getRoomById(roomId);
            $c82337330ed46a8a$var$logger.log(`getRelevantJoinedRoom`, `waiting for other party to join room: ${room.id}`);
            await this.waitForJoin(roomId);
            $c82337330ed46a8a$var$logger.log(`getRelevantJoinedRoom`, `new room created and peer invited: ${room.id}`);
        } else {
            room = relevantRooms[0];
            $c82337330ed46a8a$var$logger.log(`getRelevantJoinedRoom`, `channel already open, reusing room ${room.id}`);
        }
        return room;
    }
}





const $3d81b3dc1d4c3571$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('P2PTransport');
class $3d81b3dc1d4c3571$export$f05ea4a0ac7b2e6c extends (0, $58c6d5fc9cc0fe50$export$86495b081fef8e52) {
    type = (0, $809a8ab02b228419$export$6d07abd9f0bba447).P2P;
    constructor(name, keyPair, storage, matrixNodes, storageKey, iconUrl, appUrl){
        super(name, new (0, $c82337330ed46a8a$export$3ad3037eaf13a9fc)(name, keyPair, 1, storage, matrixNodes, iconUrl, appUrl), new (0, $3514bc91c0d3d509$export$a1f30c6c22927bc5)(storage, storageKey));
    }
    static async isAvailable() {
        return Promise.resolve(true);
    }
    async connect() {
        if (this._isConnected !== (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).NOT_CONNECTED) return;
        $3d81b3dc1d4c3571$var$logger.log('connect');
        this._isConnected = (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).CONNECTING;
        await this.client.start();
        const knownPeers = await this.getPeers();
        if (knownPeers.length > 0) {
            $3d81b3dc1d4c3571$var$logger.log('connect', `connecting to ${knownPeers.length} peers`);
            const connectionPromises = knownPeers.map(async (peer)=>this.listen(peer.publicKey));
            Promise.all(connectionPromises).catch((error)=>$3d81b3dc1d4c3571$var$logger.error('connect', error));
        }
        await this.startOpenChannelListener();
        return super.connect();
    }
    async disconnect() {
        await this.client.stop();
        return super.disconnect();
    }
    async startOpenChannelListener() {
    //
    }
    async getPairingRequestInfo() {
        return this.client.getPairingRequestInfo();
    }
    async listen(publicKey) {
        await this.client.listenForEncryptedMessage(publicKey, (message)=>{
            const connectionContext = {
                origin: (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).P2P,
                id: publicKey
            };
            this.notifyListeners(message, connectionContext).catch((error)=>{
                throw error;
            });
        }).catch((error)=>{
            throw error;
        });
    }
}










var $6ZWSX = parcelRequire("6ZWSX");
var $7c78f9fe621a051f$require$Buffer = $6ZWSX.Buffer;
class $7c78f9fe621a051f$export$a1230dadebb829d7 extends (0, $cff0a1e4c122e64c$export$b4ec959cd561194a) {
    activeListeners = new Map();
    async init() {
        this.subscribeToMessages().catch(console.error);
    }
    async listenForEncryptedMessage(senderPublicKey, messageCallback) {
        if (this.activeListeners.has(senderPublicKey)) return;
        const callbackFunction = async (message, context)=>{
            try {
                const decryptedMessage = await this.decryptMessage(senderPublicKey, message.encryptedPayload);
                // console.log('calculated sender ID', await getSenderId(senderPublicKey))
                // TODO: Add check for correct decryption key / sender ID
                messageCallback(decryptedMessage, context);
            } catch (decryptionError) {
            /* NO-OP. We try to decode every message, but some might not be addressed to us. */ }
        };
        this.activeListeners.set(senderPublicKey, callbackFunction);
    }
    async sendMessage(message, peer) {
        const payload = await this.encryptMessage(peer.publicKey, message);
        const targetId = peer?.extensionId;
        // if no targetId, we remove peer
        const msg = {
            target: (0, $4da46fae6de1b2e1$export$df51877e5681a4ab).EXTENSION,
            encryptedPayload: payload,
            targetId: targetId
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $3d44e06f3373abda$export$32684078d75a1df3).postMessage(msg, (0, $3d44e06f3373abda$export$32684078d75a1df3).location.origin);
    }
    async listenForChannelOpening(messageCallback) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const fn = async (event)=>{
            if (event.source !== (0, $3d44e06f3373abda$export$32684078d75a1df3) || event.origin !== (0, $3d44e06f3373abda$export$32684078d75a1df3).location.origin) // TODO: Add to error handler: console.debug('[Beacon]: Event received from untrusted origin')
            return;
            const data = event?.data?.message;
            if (data && data.target === (0, $4da46fae6de1b2e1$export$df51877e5681a4ab).PAGE && await this.isChannelOpenMessage(data)) {
                const payload = $7c78f9fe621a051f$require$Buffer.from(data.payload, 'hex');
                if (payload.length >= (0, $15a40981d98388e5$export$5a119edad5f33470) + (0, $15a40981d98388e5$export$a5d0660c4a35a096)) try {
                    const pairingResponse = JSON.parse(await (0, $efd1a952be4e6fd9$export$26920d2a32821f84)(payload, this.keyPair.publicKey, this.keyPair.secretKey));
                    messageCallback(new (0, $1ff34411b45f2011$export$cc40ce077fc2de8a)(pairingResponse.id, pairingResponse.name, pairingResponse.publicKey, pairingResponse.version, await (0, $1c5c036caa7dc2d6$export$c00969587a4639cc)(pairingResponse.publicKey), event?.data?.sender.id));
                } catch (decryptionError) {
                /* NO-OP. We try to decode every message, but some might not be addressed to us. */ }
            }
        };
        (0, $3d44e06f3373abda$export$32684078d75a1df3).addEventListener('message', fn);
    }
    async sendPairingRequest(id) {
        const message = {
            target: (0, $4da46fae6de1b2e1$export$df51877e5681a4ab).EXTENSION,
            payload: await new (0, $33b837e22eef79cd$export$ef852775387a0be7)().serialize(await this.getPairingRequestInfo()),
            targetId: id
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $3d44e06f3373abda$export$32684078d75a1df3).postMessage(message, (0, $3d44e06f3373abda$export$32684078d75a1df3).location.origin);
    }
    async isChannelOpenMessage(message) {
        return typeof message === 'object' && message.hasOwnProperty('payload');
    }
    async subscribeToMessages() {
        (0, $3d44e06f3373abda$export$32684078d75a1df3).addEventListener('message', (message)=>{
            if (message.source !== (0, $3d44e06f3373abda$export$32684078d75a1df3) || message.origin !== (0, $3d44e06f3373abda$export$32684078d75a1df3).location.origin) // TODO: Add to error handler: console.debug('[Beacon]: Event received from untrusted origin')
            return;
            if (typeof message === 'object' && message) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const data = message.data;
                if (data.message && data.message.target === (0, $4da46fae6de1b2e1$export$df51877e5681a4ab).PAGE) this.activeListeners.forEach((listener)=>{
                    listener(data.message, {
                        origin: (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).EXTENSION,
                        id: data.sender.id || ''
                    });
                });
            }
        });
    }
}


const $6c4533a0ab3f42b7$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('PostMessageTransport');
let $6c4533a0ab3f42b7$var$listeningForExtensions = false;
let $6c4533a0ab3f42b7$var$extensionsPromise;
let $6c4533a0ab3f42b7$var$extensions;
const $6c4533a0ab3f42b7$var$addExtension = (extension)=>{
    if (!$6c4533a0ab3f42b7$var$extensions) $6c4533a0ab3f42b7$var$extensions = [];
    if (!$6c4533a0ab3f42b7$var$extensions.some((ext)=>ext.id === extension.id)) {
        $6c4533a0ab3f42b7$var$extensions.push(extension);
        (0, $3d44e06f3373abda$export$32684078d75a1df3).postMessage('extensionsUpdated', (0, $3d44e06f3373abda$export$32684078d75a1df3).location.origin);
    }
};
class $6c4533a0ab3f42b7$export$9a11a09f0f7983f7 extends (0, $58c6d5fc9cc0fe50$export$86495b081fef8e52) {
    type = (0, $809a8ab02b228419$export$6d07abd9f0bba447).POST_MESSAGE;
    constructor(name, keyPair, storage, storageKey){
        super(name, new (0, $7c78f9fe621a051f$export$a1230dadebb829d7)(name, keyPair), new (0, $3514bc91c0d3d509$export$a1f30c6c22927bc5)(storage, storageKey));
    }
    static async isAvailable() {
        return new Promise((resolve)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const fn = (event)=>{
                const data = event.data;
                if (data && data.payload === 'pong') {
                    resolve(true);
                    (0, $3d44e06f3373abda$export$32684078d75a1df3).removeEventListener('message', fn);
                }
            };
            (0, $3d44e06f3373abda$export$32684078d75a1df3).addEventListener('message', fn);
            const message = {
                target: (0, $4da46fae6de1b2e1$export$df51877e5681a4ab).EXTENSION,
                payload: 'ping'
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $3d44e06f3373abda$export$32684078d75a1df3).postMessage(message, (0, $3d44e06f3373abda$export$32684078d75a1df3).location.origin);
        });
    }
    static async getAvailableExtensions() {
        if ($6c4533a0ab3f42b7$var$extensionsPromise) return $6c4533a0ab3f42b7$var$extensionsPromise;
        if ($6c4533a0ab3f42b7$var$extensions) return $6c4533a0ab3f42b7$var$extensions;
        $6c4533a0ab3f42b7$var$extensions = [];
        $6c4533a0ab3f42b7$var$extensionsPromise = new Promise((resolve)=>{
            $6c4533a0ab3f42b7$export$9a11a09f0f7983f7.listenForExtensions();
            setTimeout(()=>{
                resolve($6c4533a0ab3f42b7$var$extensions ?? []);
            }, 1000);
        }).finally(()=>{
            $6c4533a0ab3f42b7$var$extensionsPromise = undefined;
        });
        return $6c4533a0ab3f42b7$var$extensionsPromise;
    }
    static listenForExtensions() {
        if ($6c4533a0ab3f42b7$var$listeningForExtensions) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const fn = (event)=>{
            if (event.source !== (0, $3d44e06f3373abda$export$32684078d75a1df3) || event.origin !== (0, $3d44e06f3373abda$export$32684078d75a1df3).location.origin) // TODO: Add to error handler: console.debug('[Beacon]: Event received from untrusted origin')
            return;
            const data = event.data;
            const sender = data.sender;
            if (data && data.payload === 'pong' && sender) {
                $6c4533a0ab3f42b7$var$logger.log('getAvailableExtensions', `extension "${sender.name}" is available`, sender);
                $6c4533a0ab3f42b7$var$addExtension(sender);
            }
        };
        (0, $3d44e06f3373abda$export$32684078d75a1df3).addEventListener('message', fn);
        const message = {
            target: (0, $4da46fae6de1b2e1$export$df51877e5681a4ab).EXTENSION,
            payload: 'ping'
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $3d44e06f3373abda$export$32684078d75a1df3).postMessage(message, (0, $3d44e06f3373abda$export$32684078d75a1df3).location.origin);
        $6c4533a0ab3f42b7$var$listeningForExtensions = true;
    }
    async connect() {
        $6c4533a0ab3f42b7$var$logger.log('connect');
        if (this._isConnected !== (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).NOT_CONNECTED) return;
        this._isConnected = (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).CONNECTING;
        const knownPeers = await this.getPeers();
        if (knownPeers.length > 0) {
            $6c4533a0ab3f42b7$var$logger.log('connect', `connecting to ${knownPeers.length} peers`);
            const connectionPromises = knownPeers.map(async (peer)=>this.listen(peer.publicKey));
            Promise.all(connectionPromises).catch((error)=>$6c4533a0ab3f42b7$var$logger.error('connect', error));
        }
        await this.startOpenChannelListener();
        await super.connect();
    }
    async startOpenChannelListener() {
    //
    }
    async getPairingRequestInfo() {
        return this.client.getPairingRequestInfo();
    }
    async listen(publicKey) {
        $6c4533a0ab3f42b7$var$logger.log('listen', publicKey);
        await this.client.listenForEncryptedMessage(publicKey, (message, context)=>{
            const connectionContext = {
                origin: (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).EXTENSION,
                id: context.id
            };
            this.notifyListeners(message, connectionContext).catch((error)=>{
                throw error;
            });
        }).catch((error)=>{
            throw error;
        });
    }
}
// Start loading wallets async so they will be ready when the modal is opened
$6c4533a0ab3f42b7$export$9a11a09f0f7983f7.getAvailableExtensions();








var $cf61b77dbdb95489$require$Buffer = (parcelRequire("6ZWSX")).Buffer;
function $cf61b77dbdb95489$var$e(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var n = 0, r = Array(t); n < t; n++)r[n] = e[n];
    return r;
}
function $cf61b77dbdb95489$var$t(e, t, n, r, i, o, a) {
    try {
        var l = e[o](a), s = l.value;
    } catch (e) {
        return void n(e);
    }
    l.done ? t(s) : Promise.resolve(s).then(r, i);
}
function $cf61b77dbdb95489$var$n(e) {
    return function() {
        var n = this, r = arguments;
        return new Promise(function(i, o) {
            var a = e.apply(n, r);
            function l(e) {
                $cf61b77dbdb95489$var$t(a, i, o, l, s, "next", e);
            }
            function s(e) {
                $cf61b77dbdb95489$var$t(a, i, o, l, s, "throw", e);
            }
            l(void 0);
        });
    };
}
function $cf61b77dbdb95489$var$r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $cf61b77dbdb95489$var$i(e, t, n) {
    return t && function(e, t) {
        for(var n = 0; n < t.length; n++){
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, $cf61b77dbdb95489$var$h(r.key), r);
        }
    }(e.prototype, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $cf61b77dbdb95489$var$o(e, t) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!n) {
        if (Array.isArray(e) || (n = $cf61b77dbdb95489$var$p(e)) || t) {
            n && (e = n);
            var r = 0, i = function() {};
            return {
                s: i,
                n: function() {
                    return r >= e.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: e[r++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: i
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, l = !1;
    return {
        s: function() {
            n = n.call(e);
        },
        n: function() {
            var e = n.next();
            return a = e.done, e;
        },
        e: function(e) {
            l = !0, o = e;
        },
        f: function() {
            try {
                a || null == n.return || n.return();
            } finally{
                if (l) throw o;
            }
        }
    };
}
function $cf61b77dbdb95489$var$a(e, t, n) {
    return (t = $cf61b77dbdb95489$var$h(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $cf61b77dbdb95489$var$l(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function $cf61b77dbdb95489$var$s(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $cf61b77dbdb95489$var$l(Object(n), !0).forEach(function(t) {
            $cf61b77dbdb95489$var$a(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $cf61b77dbdb95489$var$l(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
function $cf61b77dbdb95489$var$u() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, n = "function" == typeof Symbol ? Symbol : {}, r = n.iterator || "@@iterator", i = n.toStringTag || "@@toStringTag";
    function o(n, r, i, o) {
        var s = r && r.prototype instanceof l ? r : l, u = Object.create(s.prototype);
        return $cf61b77dbdb95489$var$c(u, "_invoke", function(n, r, i) {
            var o, l, s, u = 0, c = i || [], d = !1, f = {
                p: 0,
                n: 0,
                v: e,
                a: h,
                f: h.bind(e, 4),
                d: function(t, n) {
                    return o = t, l = 0, s = e, f.n = n, a;
                }
            };
            function h(n, r) {
                for(l = n, s = r, t = 0; !d && u && !i && t < c.length; t++){
                    var i, o = c[t], h = f.p, p = o[2];
                    n > 3 ? (i = p === r) && (s = o[(l = o[4]) ? 5 : (l = 3, 3)], o[4] = o[5] = e) : o[0] <= h && ((i = n < 2 && h < o[1]) ? (l = 0, f.v = r, f.n = o[1]) : h < p && (i = n < 3 || o[0] > r || r > p) && (o[4] = n, o[5] = r, f.n = p, l = 0));
                }
                if (i || n > 1) return a;
                throw d = !0, r;
            }
            return function(i, c, p) {
                if (u > 1) throw TypeError("Generator is already running");
                for(d && 1 === c && h(c, p), l = c, s = p; (t = l < 2 ? e : s) || !d;){
                    o || (l ? l < 3 ? (l > 1 && (f.n = -1), h(l, s)) : f.n = s : f.v = s);
                    try {
                        if (u = 2, o) {
                            if (l || (i = "next"), t = o[i]) {
                                if (!(t = t.call(o, s))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                s = t.value, l < 2 && (l = 0);
                            } else 1 === l && (t = o.return) && t.call(o), l < 2 && (s = TypeError("The iterator does not provide a '" + i + "' method"), l = 1);
                            o = e;
                        } else if ((t = (d = f.n < 0) ? s : n.call(r, f)) !== a) break;
                    } catch (t) {
                        o = e, l = 1, s = t;
                    } finally{
                        u = 1;
                    }
                }
                return {
                    value: t,
                    done: d
                };
            };
        }(n, i, o), !0), u;
    }
    var a = {};
    function l() {}
    function s() {}
    function d() {}
    t = Object.getPrototypeOf;
    var f = [][r] ? t(t([][r]())) : ($cf61b77dbdb95489$var$c(t = {}, r, function() {
        return this;
    }), t), h = d.prototype = l.prototype = Object.create(f);
    function p(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, d) : (e.__proto__ = d, $cf61b77dbdb95489$var$c(e, i, "GeneratorFunction")), e.prototype = Object.create(h), e;
    }
    return s.prototype = d, $cf61b77dbdb95489$var$c(h, "constructor", d), $cf61b77dbdb95489$var$c(d, "constructor", s), s.displayName = "GeneratorFunction", $cf61b77dbdb95489$var$c(d, i, "GeneratorFunction"), $cf61b77dbdb95489$var$c(h), $cf61b77dbdb95489$var$c(h, i, "Generator"), $cf61b77dbdb95489$var$c(h, r, function() {
        return this;
    }), $cf61b77dbdb95489$var$c(h, "toString", function() {
        return "[object Generator]";
    }), ($cf61b77dbdb95489$var$u = function() {
        return {
            w: o,
            m: p
        };
    })();
}
function $cf61b77dbdb95489$var$c(e, t, n, r) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    $cf61b77dbdb95489$var$c = function(e, t, n, r) {
        function o(t, n) {
            $cf61b77dbdb95489$var$c(e, t, function(e) {
                return this._invoke(t, n, e);
            });
        }
        t ? i ? i(e, t, {
            value: n,
            enumerable: !r,
            configurable: !r,
            writable: !r
        }) : e[t] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, $cf61b77dbdb95489$var$c(e, t, n, r);
}
function $cf61b77dbdb95489$var$d(e, t) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
            var r, i, o, a, l = [], s = !0, u = !1;
            try {
                if (o = (n = n.call(e)).next, 0 === t) {
                    if (Object(n) !== n) return;
                    s = !1;
                } else for(; !(s = (r = o.call(n)).done) && (l.push(r.value), l.length !== t); s = !0);
            } catch (e) {
                u = !0, i = e;
            } finally{
                try {
                    if (!s && null != n.return && (a = n.return(), Object(a) !== a)) return;
                } finally{
                    if (u) throw i;
                }
            }
            return l;
        }
    }(e, t) || $cf61b77dbdb95489$var$p(e, t) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $cf61b77dbdb95489$var$f(t) {
    return function(t) {
        if (Array.isArray(t)) return $cf61b77dbdb95489$var$e(t);
    }(t) || function(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(t) || $cf61b77dbdb95489$var$p(t) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $cf61b77dbdb95489$var$h(e) {
    var t = function(e, t) {
        if ("object" != typeof e || !e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
            var r = n.call(e, t);
            if ("object" != typeof r) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
    }(e, "string");
    return "symbol" == typeof t ? t : t + "";
}
function $cf61b77dbdb95489$var$p(t, n) {
    if (t) {
        if ("string" == typeof t) return $cf61b77dbdb95489$var$e(t, n);
        var r = ({}).toString.call(t).slice(8, -1);
        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? $cf61b77dbdb95489$var$e(t, n) : void 0;
    }
}
function $cf61b77dbdb95489$var$m(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $cf61b77dbdb95489$var$g(e) {
    if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
    var t = e.default;
    if ("function" == typeof t) {
        var n = function e() {
            var n = !1;
            try {
                n = this instanceof e;
            } catch  {}
            return n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
        };
        n.prototype = t.prototype;
    } else n = {};
    return Object.defineProperty(n, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(t) {
        var r = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(n, t, r.get ? r : {
            enumerable: !0,
            get: function() {
                return e[t];
            }
        });
    }), n;
}
var $cf61b77dbdb95489$var$b, $cf61b77dbdb95489$var$y = {
    exports: {}
}, $cf61b77dbdb95489$var$v = {}, $cf61b77dbdb95489$var$I = {
    exports: {}
}, $cf61b77dbdb95489$var$M = {};
var $cf61b77dbdb95489$var$E, $cf61b77dbdb95489$var$x, $cf61b77dbdb95489$var$S = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $cf61b77dbdb95489$var$w() {
    var e;
    return $cf61b77dbdb95489$var$x || ($cf61b77dbdb95489$var$x = 1, $cf61b77dbdb95489$var$I.exports = ($cf61b77dbdb95489$var$b || ($cf61b77dbdb95489$var$b = 1, function(e) {
        function t(e, t) {
            var n = e.length;
            e.push(t);
            e: for(; 0 < n;){
                var r = n - 1 >>> 1, o = e[r];
                if (!(0 < i(o, t))) break e;
                e[r] = t, e[n] = o, n = r;
            }
        }
        function n(e) {
            return 0 === e.length ? null : e[0];
        }
        function r(e) {
            if (0 === e.length) return null;
            var t = e[0], n = e.pop();
            if (n !== t) {
                e[0] = n;
                e: for(var r = 0, o = e.length, a = o >>> 1; r < a;){
                    var l = 2 * (r + 1) - 1, s = e[l], u = l + 1, c = e[u];
                    if (0 > i(s, n)) u < o && 0 > i(c, s) ? (e[r] = c, e[u] = n, r = u) : (e[r] = s, e[l] = n, r = l);
                    else {
                        if (!(u < o && 0 > i(c, n))) break e;
                        e[r] = c, e[u] = n, r = u;
                    }
                }
            }
            return t;
        }
        function i(e, t) {
            var n = e.sortIndex - t.sortIndex;
            return 0 !== n ? n : e.id - t.id;
        }
        if (e.unstable_now = void 0, "object" == typeof performance && "function" == typeof performance.now) {
            var o = performance;
            e.unstable_now = function() {
                return o.now();
            };
        } else {
            var a = Date, l = a.now();
            e.unstable_now = function() {
                return a.now() - l;
            };
        }
        var s = [], u = [], c = 1, d = null, f = 3, h = !1, p = !1, m = !1, g = !1, b = "function" == typeof setTimeout ? setTimeout : null, y = "function" == typeof clearTimeout ? clearTimeout : null, v = "undefined" != typeof setImmediate ? setImmediate : null;
        function I(e) {
            for(var i = n(u); null !== i;){
                if (null === i.callback) r(u);
                else {
                    if (!(i.startTime <= e)) break;
                    r(u), i.sortIndex = i.expirationTime, t(s, i);
                }
                i = n(u);
            }
        }
        function M(e) {
            if (m = !1, I(e), !p) {
                if (null !== n(s)) p = !0, x || (x = !0, E());
                else {
                    var t = n(u);
                    null !== t && C(M, t.startTime - e);
                }
            }
        }
        var E, x = !1, S = -1, w = 5, k = -1;
        function N() {
            return !(!g && e.unstable_now() - k < w);
        }
        function U() {
            if (g = !1, x) {
                var t = e.unstable_now();
                k = t;
                var i = !0;
                try {
                    e: {
                        p = !1, m && (m = !1, y(S), S = -1), h = !0;
                        var o = f;
                        try {
                            t: {
                                for(I(t), d = n(s); null !== d && !(d.expirationTime > t && N());){
                                    var a = d.callback;
                                    if ("function" == typeof a) {
                                        d.callback = null, f = d.priorityLevel;
                                        var l = a(d.expirationTime <= t);
                                        if (t = e.unstable_now(), "function" == typeof l) {
                                            d.callback = l, I(t), i = !0;
                                            break t;
                                        }
                                        d === n(s) && r(s), I(t);
                                    } else r(s);
                                    d = n(s);
                                }
                                if (null !== d) i = !0;
                                else {
                                    var c = n(u);
                                    null !== c && C(M, c.startTime - t), i = !1;
                                }
                            }
                            break e;
                        } finally{
                            d = null, f = o, h = !1;
                        }
                        i = void 0;
                    }
                } finally{
                    i ? E() : x = !1;
                }
            }
        }
        if ("function" == typeof v) E = function() {
            v(U);
        };
        else if ("undefined" != typeof MessageChannel) {
            var R = new MessageChannel, L = R.port2;
            R.port1.onmessage = U, E = function() {
                L.postMessage(null);
            };
        } else E = function() {
            b(U, 0);
        };
        function C(t, n) {
            S = b(function() {
                t(e.unstable_now());
            }, n);
        }
        e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(e) {
            e.callback = null;
        }, e.unstable_forceFrameRate = function(e) {
            0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : w = 0 < e ? Math.floor(1e3 / e) : 5;
        }, e.unstable_getCurrentPriorityLevel = function() {
            return f;
        }, e.unstable_next = function(e) {
            switch(f){
                case 1:
                case 2:
                case 3:
                    var t = 3;
                    break;
                default:
                    t = f;
            }
            var n = f;
            f = t;
            try {
                return e();
            } finally{
                f = n;
            }
        }, e.unstable_requestPaint = function() {
            g = !0;
        }, e.unstable_runWithPriority = function(e, t) {
            switch(e){
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                default:
                    e = 3;
            }
            var n = f;
            f = e;
            try {
                return t();
            } finally{
                f = n;
            }
        }, e.unstable_scheduleCallback = function(r, i, o) {
            var a = e.unstable_now();
            switch(o = "object" == typeof o && null !== o && "number" == typeof (o = o.delay) && 0 < o ? a + o : a, r){
                case 1:
                    var l = -1;
                    break;
                case 2:
                    l = 250;
                    break;
                case 5:
                    l = 1073741823;
                    break;
                case 4:
                    l = 1e4;
                    break;
                default:
                    l = 5e3;
            }
            return r = {
                id: c++,
                callback: i,
                priorityLevel: r,
                startTime: o,
                expirationTime: l = o + l,
                sortIndex: -1
            }, o > a ? (r.sortIndex = o, t(u, r), null === n(s) && r === n(u) && (m ? (y(S), S = -1) : m = !0, C(M, o - a))) : (r.sortIndex = l, t(s, r), p || h || (p = !0, x || (x = !0, E()))), r;
        }, e.unstable_shouldYield = N, e.unstable_wrapCallback = function(e) {
            var t = f;
            return function() {
                var n = f;
                f = t;
                try {
                    return e.apply(this, arguments);
                } finally{
                    f = n;
                }
            };
        };
    }($cf61b77dbdb95489$var$M)), $cf61b77dbdb95489$var$M)), $cf61b77dbdb95489$var$I.exports;
}
var $cf61b77dbdb95489$var$k, $cf61b77dbdb95489$var$N = {
    exports: {}
}, $cf61b77dbdb95489$var$U = {};
function $cf61b77dbdb95489$var$R() {
    if ($cf61b77dbdb95489$var$k) return $cf61b77dbdb95489$var$U;
    $cf61b77dbdb95489$var$k = 1;
    var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), d = Symbol.iterator;
    var f = {
        isMounted: function() {
            return !1;
        },
        enqueueForceUpdate: function() {},
        enqueueReplaceState: function() {},
        enqueueSetState: function() {}
    }, h = Object.assign, p = {};
    function m(e, t, n) {
        this.props = e, this.context = t, this.refs = p, this.updater = n || f;
    }
    function g() {}
    function b(e, t, n) {
        this.props = e, this.context = t, this.refs = p, this.updater = n || f;
    }
    m.prototype.isReactComponent = {}, m.prototype.setState = function(e, t) {
        if ("object" != typeof e && "function" != typeof e && null != e) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, e, t, "setState");
    }, m.prototype.forceUpdate = function(e) {
        this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    }, g.prototype = m.prototype;
    var y = b.prototype = new g;
    y.constructor = b, h(y, m.prototype), y.isPureReactComponent = !0;
    var v = Array.isArray, I = {
        H: null,
        A: null,
        T: null,
        S: null,
        V: null
    }, M = Object.prototype.hasOwnProperty;
    function E(t, n, r, i, o, a) {
        return r = a.ref, {
            $$typeof: e,
            type: t,
            key: n,
            ref: void 0 !== r ? r : null,
            props: a
        };
    }
    function x(t) {
        return "object" == typeof t && null !== t && t.$$typeof === e;
    }
    var S = /\/+/g;
    function w(e, t) {
        return "object" == typeof e && null !== e && null != e.key ? function(e) {
            var t = {
                "=": "=0",
                ":": "=2"
            };
            return "$" + e.replace(/[=:]/g, function(e) {
                return t[e];
            });
        }("" + e.key) : t.toString(36);
    }
    function N() {}
    function R(n, r, i, o, a) {
        var l = typeof n;
        "undefined" !== l && "boolean" !== l || (n = null);
        var s, u, f = !1;
        if (null === n) f = !0;
        else switch(l){
            case "bigint":
            case "string":
            case "number":
                f = !0;
                break;
            case "object":
                switch(n.$$typeof){
                    case e:
                    case t:
                        f = !0;
                        break;
                    case c:
                        return R((f = n._init)(n._payload), r, i, o, a);
                }
        }
        if (f) return a = a(n), f = "" === o ? "." + w(n, 0) : o, v(a) ? (i = "", null != f && (i = f.replace(S, "$&/") + "/"), R(a, r, i, "", function(e) {
            return e;
        })) : null != a && (x(a) && (s = a, u = i + (null == a.key || n && n.key === a.key ? "" : ("" + a.key).replace(S, "$&/") + "/") + f, a = E(s.type, u, void 0, 0, 0, s.props)), r.push(a)), 1;
        f = 0;
        var h, p = "" === o ? "." : o + ":";
        if (v(n)) for(var m = 0; m < n.length; m++)f += R(o = n[m], r, i, l = p + w(o, m), a);
        else if ("function" == typeof (m = null === (h = n) || "object" != typeof h ? null : "function" == typeof (h = d && h[d] || h["@@iterator"]) ? h : null)) for(n = m.call(n), m = 0; !(o = n.next()).done;)f += R(o = o.value, r, i, l = p + w(o, m++), a);
        else if ("object" === l) {
            if ("function" == typeof n.then) return R(function(e) {
                switch(e.status){
                    case "fulfilled":
                        return e.value;
                    case "rejected":
                        throw e.reason;
                    default:
                        switch("string" == typeof e.status ? e.then(N, N) : (e.status = "pending", e.then(function(t) {
                            "pending" === e.status && (e.status = "fulfilled", e.value = t);
                        }, function(t) {
                            "pending" === e.status && (e.status = "rejected", e.reason = t);
                        })), e.status){
                            case "fulfilled":
                                return e.value;
                            case "rejected":
                                throw e.reason;
                        }
                }
                throw e;
            }(n), r, i, o, a);
            throw r = String(n), Error("Objects are not valid as a React child (found: " + ("[object Object]" === r ? "object with keys {" + Object.keys(n).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
        }
        return f;
    }
    function L(e, t, n) {
        if (null == e) return e;
        var r = [], i = 0;
        return R(e, r, "", "", function(e) {
            return t.call(n, e, i++);
        }), r;
    }
    function C(e) {
        if (-1 === e._status) {
            var t = e._result;
            (t = t()).then(function(t) {
                0 !== e._status && -1 !== e._status || (e._status = 1, e._result = t);
            }, function(t) {
                0 !== e._status && -1 !== e._status || (e._status = 2, e._result = t);
            }), -1 === e._status && (e._status = 0, e._result = t);
        }
        if (1 === e._status) return e._result.default;
        throw e._result;
    }
    var z = "function" == typeof reportError ? reportError : function(e) {
        if ("object" == typeof window && "function" == typeof window.ErrorEvent) {
            var t = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" == typeof e && null !== e && "string" == typeof e.message ? String(e.message) : String(e),
                error: e
            });
            if (!window.dispatchEvent(t)) return;
        }
        console.error(e);
    };
    function T() {}
    return $cf61b77dbdb95489$var$U.Children = {
        map: L,
        forEach: function(e, t, n) {
            L(e, function() {
                t.apply(this, arguments);
            }, n);
        },
        count: function(e) {
            var t = 0;
            return L(e, function() {
                t++;
            }), t;
        },
        toArray: function(e) {
            return L(e, function(e) {
                return e;
            }) || [];
        },
        only: function(e) {
            if (!x(e)) throw Error("React.Children.only expected to receive a single React element child.");
            return e;
        }
    }, $cf61b77dbdb95489$var$U.Component = m, $cf61b77dbdb95489$var$U.Fragment = n, $cf61b77dbdb95489$var$U.Profiler = i, $cf61b77dbdb95489$var$U.PureComponent = b, $cf61b77dbdb95489$var$U.StrictMode = r, $cf61b77dbdb95489$var$U.Suspense = s, $cf61b77dbdb95489$var$U.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = I, $cf61b77dbdb95489$var$U.__COMPILER_RUNTIME = {
        __proto__: null,
        c: function(e) {
            return I.H.useMemoCache(e);
        }
    }, $cf61b77dbdb95489$var$U.cache = function(e) {
        return function() {
            return e.apply(null, arguments);
        };
    }, $cf61b77dbdb95489$var$U.cloneElement = function(e, t, n) {
        if (null == e) throw Error("The argument must be a React element, but you passed " + e + ".");
        var r = h({}, e.props), i = e.key;
        if (null != t) for(o in t.ref, void 0 !== t.key && (i = "" + t.key), t)!M.call(t, o) || "key" === o || "__self" === o || "__source" === o || "ref" === o && void 0 === t.ref || (r[o] = t[o]);
        var o = arguments.length - 2;
        if (1 === o) r.children = n;
        else if (1 < o) {
            for(var a = Array(o), l = 0; l < o; l++)a[l] = arguments[l + 2];
            r.children = a;
        }
        return E(e.type, i, void 0, 0, 0, r);
    }, $cf61b77dbdb95489$var$U.createContext = function(e) {
        return (e = {
            $$typeof: a,
            _currentValue: e,
            _currentValue2: e,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        }).Provider = e, e.Consumer = {
            $$typeof: o,
            _context: e
        }, e;
    }, $cf61b77dbdb95489$var$U.createElement = function(e, t, n) {
        var r, i = {}, o = null;
        if (null != t) for(r in void 0 !== t.key && (o = "" + t.key), t)M.call(t, r) && "key" !== r && "__self" !== r && "__source" !== r && (i[r] = t[r]);
        var a = arguments.length - 2;
        if (1 === a) i.children = n;
        else if (1 < a) {
            for(var l = Array(a), s = 0; s < a; s++)l[s] = arguments[s + 2];
            i.children = l;
        }
        if (e && e.defaultProps) for(r in a = e.defaultProps)void 0 === i[r] && (i[r] = a[r]);
        return E(e, o, void 0, 0, 0, i);
    }, $cf61b77dbdb95489$var$U.createRef = function() {
        return {
            current: null
        };
    }, $cf61b77dbdb95489$var$U.forwardRef = function(e) {
        return {
            $$typeof: l,
            render: e
        };
    }, $cf61b77dbdb95489$var$U.isValidElement = x, $cf61b77dbdb95489$var$U.lazy = function(e) {
        return {
            $$typeof: c,
            _payload: {
                _status: -1,
                _result: e
            },
            _init: C
        };
    }, $cf61b77dbdb95489$var$U.memo = function(e, t) {
        return {
            $$typeof: u,
            type: e,
            compare: void 0 === t ? null : t
        };
    }, $cf61b77dbdb95489$var$U.startTransition = function(e) {
        var t = I.T, n = {};
        I.T = n;
        try {
            var r = e(), i = I.S;
            null !== i && i(n, r), "object" == typeof r && null !== r && "function" == typeof r.then && r.then(T, z);
        } catch (e) {
            z(e);
        } finally{
            I.T = t;
        }
    }, $cf61b77dbdb95489$var$U.unstable_useCacheRefresh = function() {
        return I.H.useCacheRefresh();
    }, $cf61b77dbdb95489$var$U.use = function(e) {
        return I.H.use(e);
    }, $cf61b77dbdb95489$var$U.useActionState = function(e, t, n) {
        return I.H.useActionState(e, t, n);
    }, $cf61b77dbdb95489$var$U.useCallback = function(e, t) {
        return I.H.useCallback(e, t);
    }, $cf61b77dbdb95489$var$U.useContext = function(e) {
        return I.H.useContext(e);
    }, $cf61b77dbdb95489$var$U.useDebugValue = function() {}, $cf61b77dbdb95489$var$U.useDeferredValue = function(e, t) {
        return I.H.useDeferredValue(e, t);
    }, $cf61b77dbdb95489$var$U.useEffect = function(e, t, n) {
        var r = I.H;
        if ("function" == typeof n) throw Error("useEffect CRUD overload is not enabled in this build of React.");
        return r.useEffect(e, t);
    }, $cf61b77dbdb95489$var$U.useId = function() {
        return I.H.useId();
    }, $cf61b77dbdb95489$var$U.useImperativeHandle = function(e, t, n) {
        return I.H.useImperativeHandle(e, t, n);
    }, $cf61b77dbdb95489$var$U.useInsertionEffect = function(e, t) {
        return I.H.useInsertionEffect(e, t);
    }, $cf61b77dbdb95489$var$U.useLayoutEffect = function(e, t) {
        return I.H.useLayoutEffect(e, t);
    }, $cf61b77dbdb95489$var$U.useMemo = function(e, t) {
        return I.H.useMemo(e, t);
    }, $cf61b77dbdb95489$var$U.useOptimistic = function(e, t) {
        return I.H.useOptimistic(e, t);
    }, $cf61b77dbdb95489$var$U.useReducer = function(e, t, n) {
        return I.H.useReducer(e, t, n);
    }, $cf61b77dbdb95489$var$U.useRef = function(e) {
        return I.H.useRef(e);
    }, $cf61b77dbdb95489$var$U.useState = function(e) {
        return I.H.useState(e);
    }, $cf61b77dbdb95489$var$U.useSyncExternalStore = function(e, t, n) {
        return I.H.useSyncExternalStore(e, t, n);
    }, $cf61b77dbdb95489$var$U.useTransition = function() {
        return I.H.useTransition();
    }, $cf61b77dbdb95489$var$U.version = "19.1.0", $cf61b77dbdb95489$var$U;
}
var $cf61b77dbdb95489$var$L, $cf61b77dbdb95489$var$C, $cf61b77dbdb95489$var$z = {
    exports: {}
};
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $cf61b77dbdb95489$var$T() {
    var e, t;
    return $cf61b77dbdb95489$var$L || ($cf61b77dbdb95489$var$L = 1, e = $cf61b77dbdb95489$var$z, t = $cf61b77dbdb95489$var$z.exports, false), $cf61b77dbdb95489$var$z.exports;
}
function $cf61b77dbdb95489$var$D() {
    return $cf61b77dbdb95489$var$C || ($cf61b77dbdb95489$var$C = 1, $cf61b77dbdb95489$var$N.exports = $cf61b77dbdb95489$var$R()), $cf61b77dbdb95489$var$N.exports;
}
var $cf61b77dbdb95489$var$F, $cf61b77dbdb95489$var$V = {
    exports: {}
}, $cf61b77dbdb95489$var$A = {};
function $cf61b77dbdb95489$var$j() {
    if ($cf61b77dbdb95489$var$F) return $cf61b77dbdb95489$var$A;
    $cf61b77dbdb95489$var$F = 1;
    var e = $cf61b77dbdb95489$var$D();
    function t(e) {
        var t = "https://react.dev/errors/" + e;
        if (1 < arguments.length) {
            t += "?args[]=" + encodeURIComponent(arguments[1]);
            for(var n = 2; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
        }
        return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    function n() {}
    var r = {
        d: {
            f: n,
            r: function() {
                throw Error(t(522));
            },
            D: n,
            C: n,
            L: n,
            m: n,
            X: n,
            S: n,
            M: n
        },
        p: 0,
        findDOMNode: null
    }, i = Symbol.for("react.portal");
    var o = e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    function a(e, t) {
        return "font" === e ? "" : "string" == typeof t ? "use-credentials" === t ? t : "" : void 0;
    }
    return $cf61b77dbdb95489$var$A.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r, $cf61b77dbdb95489$var$A.createPortal = function(e, n) {
        var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
        if (!n || 1 !== n.nodeType && 9 !== n.nodeType && 11 !== n.nodeType) throw Error(t(299));
        return function(e, t, n) {
            var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
            return {
                $$typeof: i,
                key: null == r ? null : "" + r,
                children: e,
                containerInfo: t,
                implementation: n
            };
        }(e, n, null, r);
    }, $cf61b77dbdb95489$var$A.flushSync = function(e) {
        var t = o.T, n = r.p;
        try {
            if (o.T = null, r.p = 2, e) return e();
        } finally{
            o.T = t, r.p = n, r.d.f();
        }
    }, $cf61b77dbdb95489$var$A.preconnect = function(e, t) {
        "string" == typeof e && (t ? t = "string" == typeof (t = t.crossOrigin) ? "use-credentials" === t ? t : "" : void 0 : t = null, r.d.C(e, t));
    }, $cf61b77dbdb95489$var$A.prefetchDNS = function(e) {
        "string" == typeof e && r.d.D(e);
    }, $cf61b77dbdb95489$var$A.preinit = function(e, t) {
        if ("string" == typeof e && t && "string" == typeof t.as) {
            var n = t.as, i = a(n, t.crossOrigin), o = "string" == typeof t.integrity ? t.integrity : void 0, l = "string" == typeof t.fetchPriority ? t.fetchPriority : void 0;
            "style" === n ? r.d.S(e, "string" == typeof t.precedence ? t.precedence : void 0, {
                crossOrigin: i,
                integrity: o,
                fetchPriority: l
            }) : "script" === n && r.d.X(e, {
                crossOrigin: i,
                integrity: o,
                fetchPriority: l,
                nonce: "string" == typeof t.nonce ? t.nonce : void 0
            });
        }
    }, $cf61b77dbdb95489$var$A.preinitModule = function(e, t) {
        if ("string" == typeof e) {
            if ("object" == typeof t && null !== t) {
                if (null == t.as || "script" === t.as) {
                    var n = a(t.as, t.crossOrigin);
                    r.d.M(e, {
                        crossOrigin: n,
                        integrity: "string" == typeof t.integrity ? t.integrity : void 0,
                        nonce: "string" == typeof t.nonce ? t.nonce : void 0
                    });
                }
            } else null == t && r.d.M(e);
        }
    }, $cf61b77dbdb95489$var$A.preload = function(e, t) {
        if ("string" == typeof e && "object" == typeof t && null !== t && "string" == typeof t.as) {
            var n = t.as, i = a(n, t.crossOrigin);
            r.d.L(e, n, {
                crossOrigin: i,
                integrity: "string" == typeof t.integrity ? t.integrity : void 0,
                nonce: "string" == typeof t.nonce ? t.nonce : void 0,
                type: "string" == typeof t.type ? t.type : void 0,
                fetchPriority: "string" == typeof t.fetchPriority ? t.fetchPriority : void 0,
                referrerPolicy: "string" == typeof t.referrerPolicy ? t.referrerPolicy : void 0,
                imageSrcSet: "string" == typeof t.imageSrcSet ? t.imageSrcSet : void 0,
                imageSizes: "string" == typeof t.imageSizes ? t.imageSizes : void 0,
                media: "string" == typeof t.media ? t.media : void 0
            });
        }
    }, $cf61b77dbdb95489$var$A.preloadModule = function(e, t) {
        if ("string" == typeof e) {
            if (t) {
                var n = a(t.as, t.crossOrigin);
                r.d.m(e, {
                    as: "string" == typeof t.as && "script" !== t.as ? t.as : void 0,
                    crossOrigin: n,
                    integrity: "string" == typeof t.integrity ? t.integrity : void 0
                });
            } else r.d.m(e);
        }
    }, $cf61b77dbdb95489$var$A.requestFormReset = function(e) {
        r.d.r(e);
    }, $cf61b77dbdb95489$var$A.unstable_batchedUpdates = function(e, t) {
        return e(t);
    }, $cf61b77dbdb95489$var$A.useFormState = function(e, t, n) {
        return o.H.useFormState(e, t, n);
    }, $cf61b77dbdb95489$var$A.useFormStatus = function() {
        return o.H.useHostTransitionStatus();
    }, $cf61b77dbdb95489$var$A.version = "19.1.0", $cf61b77dbdb95489$var$A;
}
var $cf61b77dbdb95489$var$O, $cf61b77dbdb95489$var$Q, $cf61b77dbdb95489$var$q, $cf61b77dbdb95489$var$W = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $cf61b77dbdb95489$var$G() {
    return $cf61b77dbdb95489$var$O || ($cf61b77dbdb95489$var$O = 1), $cf61b77dbdb95489$var$W;
}
function $cf61b77dbdb95489$var$B() {
    if ($cf61b77dbdb95489$var$Q) return $cf61b77dbdb95489$var$V.exports;
    return $cf61b77dbdb95489$var$Q = 1, !function e() {
        if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
            __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
        } catch (e) {
            console.error(e);
        }
    }(), $cf61b77dbdb95489$var$V.exports = $cf61b77dbdb95489$var$j(), $cf61b77dbdb95489$var$V.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $cf61b77dbdb95489$var$K() {
    if ($cf61b77dbdb95489$var$q) return $cf61b77dbdb95489$var$v;
    $cf61b77dbdb95489$var$q = 1;
    var e = $cf61b77dbdb95489$var$w(), t = $cf61b77dbdb95489$var$D(), n = $cf61b77dbdb95489$var$B();
    function r(e) {
        var t = "https://react.dev/errors/" + e;
        if (1 < arguments.length) {
            t += "?args[]=" + encodeURIComponent(arguments[1]);
            for(var n = 2; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
        }
        return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    function i(e) {
        return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType);
    }
    function o(e) {
        var t = e, n = e;
        if (e.alternate) for(; t.return;)t = t.return;
        else {
            e = t;
            do !!(4098 & (t = e).flags) && (n = t.return), e = t.return;
            while (e);
        }
        return 3 === t.tag ? n : null;
    }
    function a(e) {
        if (13 === e.tag) {
            var t = e.memoizedState;
            if (null === t && null !== (e = e.alternate) && (t = e.memoizedState), null !== t) return t.dehydrated;
        }
        return null;
    }
    function l(e) {
        if (o(e) !== e) throw Error(r(188));
    }
    function s(e) {
        var t = e.tag;
        if (5 === t || 26 === t || 27 === t || 6 === t) return e;
        for(e = e.child; null !== e;){
            if (null !== (t = s(e))) return t;
            e = e.sibling;
        }
        return null;
    }
    var u = Object.assign, c = Symbol.for("react.element"), d = Symbol.for("react.transitional.element"), f = Symbol.for("react.portal"), h = Symbol.for("react.fragment"), p = Symbol.for("react.strict_mode"), m = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), b = Symbol.for("react.consumer"), y = Symbol.for("react.context"), I = Symbol.for("react.forward_ref"), M = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), k = Symbol.for("react.activity"), N = Symbol.for("react.memo_cache_sentinel"), U = Symbol.iterator;
    function R(e) {
        return null === e || "object" != typeof e ? null : "function" == typeof (e = U && e[U] || e["@@iterator"]) ? e : null;
    }
    var L = Symbol.for("react.client.reference");
    function C(e) {
        if (null == e) return null;
        if ("function" == typeof e) return e.$$typeof === L ? null : e.displayName || e.name || null;
        if ("string" == typeof e) return e;
        switch(e){
            case h:
                return "Fragment";
            case m:
                return "Profiler";
            case p:
                return "StrictMode";
            case M:
                return "Suspense";
            case E:
                return "SuspenseList";
            case k:
                return "Activity";
        }
        if ("object" == typeof e) switch(e.$$typeof){
            case f:
                return "Portal";
            case y:
                return (e.displayName || "Context") + ".Provider";
            case b:
                return (e._context.displayName || "Context") + ".Consumer";
            case I:
                var t = e.render;
                return (e = e.displayName) || (e = "" !== (e = t.displayName || t.name || "") ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
            case x:
                return null !== (t = e.displayName || null) ? t : C(e.type) || "Memo";
            case S:
                t = e._payload, e = e._init;
                try {
                    return C(e(t));
                } catch (e) {}
        }
        return null;
    }
    var z = Array.isArray, T = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, F = n.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, V = {
        pending: !1,
        data: null,
        method: null,
        action: null
    }, A = [], j = -1;
    function O(e) {
        return {
            current: e
        };
    }
    function Q(e) {
        0 > j || (e.current = A[j], A[j] = null, j--);
    }
    function W(e, t) {
        j++, A[j] = e.current, e.current = t;
    }
    var G = O(null), K = O(null), Y = O(null), Z = O(null);
    function X(e, t) {
        switch(W(Y, t), W(K, e), W(G, null), t.nodeType){
            case 9:
            case 11:
                e = (e = t.documentElement) && (e = e.namespaceURI) ? ld(e) : 0;
                break;
            default:
                if (e = t.tagName, t = t.namespaceURI) e = sd(t = ld(t), e);
                else switch(e){
                    case "svg":
                        e = 1;
                        break;
                    case "math":
                        e = 2;
                        break;
                    default:
                        e = 0;
                }
        }
        Q(G), W(G, e);
    }
    function P() {
        Q(G), Q(K), Q(Y);
    }
    function J(e) {
        null !== e.memoizedState && W(Z, e);
        var t = G.current, n = sd(t, e.type);
        t !== n && (W(K, e), W(G, n));
    }
    function H(e) {
        K.current === e && (Q(G), Q(K)), Z.current === e && (Q(Z), Hd._currentValue = V);
    }
    var _ = Object.prototype.hasOwnProperty, $ = e.unstable_scheduleCallback, ee = e.unstable_cancelCallback, te = e.unstable_shouldYield, ne = e.unstable_requestPaint, re = e.unstable_now, ie = e.unstable_getCurrentPriorityLevel, oe = e.unstable_ImmediatePriority, ae = e.unstable_UserBlockingPriority, le = e.unstable_NormalPriority, se = e.unstable_LowPriority, ue = e.unstable_IdlePriority, ce = e.log, de = e.unstable_setDisableYieldValue, fe = null, he = null;
    function pe(e) {
        if ("function" == typeof ce && de(e), he && "function" == typeof he.setStrictMode) try {
            he.setStrictMode(fe, e);
        } catch (e) {}
    }
    var me = Math.clz32 ? Math.clz32 : function(e) {
        return e >>>= 0, 0 === e ? 32 : 31 - (ge(e) / be | 0) | 0;
    }, ge = Math.log, be = Math.LN2;
    var ye = 256, ve = 4194304;
    function Ie(e) {
        var t = 42 & e;
        if (0 !== t) return t;
        switch(e & -e){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
                return 64;
            case 128:
                return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return 4194048 & e;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return 62914560 & e;
            case 67108864:
                return 67108864;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 0;
            default:
                return e;
        }
    }
    function Me(e, t, n) {
        var r = e.pendingLanes;
        if (0 === r) return 0;
        var i = 0, o = e.suspendedLanes, a = e.pingedLanes;
        e = e.warmLanes;
        var l = 134217727 & r;
        return 0 !== l ? 0 !== (r = l & ~o) ? i = Ie(r) : 0 !== (a &= l) ? i = Ie(a) : n || 0 !== (n = l & ~e) && (i = Ie(n)) : 0 !== (l = r & ~o) ? i = Ie(l) : 0 !== a ? i = Ie(a) : n || 0 !== (n = r & ~e) && (i = Ie(n)), 0 === i ? 0 : 0 !== t && t !== i && 0 === (t & o) && ((o = i & -i) >= (n = t & -t) || 32 === o && 4194048 & n) ? t : i;
    }
    function Ee(e, t) {
        return 0 === (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t);
    }
    function xe(e, t) {
        switch(e){
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
                return t + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return t + 5e3;
            default:
                return -1;
        }
    }
    function Se() {
        var e = ye;
        return !(4194048 & (ye <<= 1)) && (ye = 256), e;
    }
    function we() {
        var e = ve;
        return !(62914560 & (ve <<= 1)) && (ve = 4194304), e;
    }
    function ke(e) {
        for(var t = [], n = 0; 31 > n; n++)t.push(e);
        return t;
    }
    function Ne(e, t) {
        e.pendingLanes |= t, 268435456 !== t && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
    }
    function Ue(e, t, n) {
        e.pendingLanes |= t, e.suspendedLanes &= ~t;
        var r = 31 - me(t);
        e.entangledLanes |= t, e.entanglements[r] = 1073741824 | e.entanglements[r] | 4194090 & n;
    }
    function Re(e, t) {
        var n = e.entangledLanes |= t;
        for(e = e.entanglements; n;){
            var r = 31 - me(n), i = 1 << r;
            i & t | e[r] & t && (e[r] |= t), n &= ~i;
        }
    }
    function Le(e) {
        switch(e){
            case 2:
                e = 1;
                break;
            case 8:
                e = 4;
                break;
            case 32:
                e = 16;
                break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                e = 128;
                break;
            case 268435456:
                e = 134217728;
                break;
            default:
                e = 0;
        }
        return e;
    }
    function Ce(e) {
        return 2 < (e &= -e) ? 8 < e ? 134217727 & e ? 32 : 268435456 : 8 : 2;
    }
    function ze() {
        var e = F.p;
        return 0 !== e ? e : void 0 === (e = window.event) ? 32 : hf(e.type);
    }
    var Te = Math.random().toString(36).slice(2), De = "__reactFiber$" + Te, Fe = "__reactProps$" + Te, Ve = "__reactContainer$" + Te, Ae = "__reactEvents$" + Te, je = "__reactListeners$" + Te, Oe = "__reactHandles$" + Te, Qe = "__reactResources$" + Te, qe = "__reactMarker$" + Te;
    function We(e) {
        delete e[De], delete e[Fe], delete e[Ae], delete e[je], delete e[Oe];
    }
    function Ge(e) {
        var t = e[De];
        if (t) return t;
        for(var n = e.parentNode; n;){
            if (t = n[Ve] || n[De]) {
                if (n = t.alternate, null !== t.child || null !== n && null !== n.child) for(e = Ed(e); null !== e;){
                    if (n = e[De]) return n;
                    e = Ed(e);
                }
                return t;
            }
            n = (e = n).parentNode;
        }
        return null;
    }
    function Be(e) {
        if (e = e[De] || e[Ve]) {
            var t = e.tag;
            if (5 === t || 6 === t || 13 === t || 26 === t || 27 === t || 3 === t) return e;
        }
        return null;
    }
    function Ke(e) {
        var t = e.tag;
        if (5 === t || 26 === t || 27 === t || 6 === t) return e.stateNode;
        throw Error(r(33));
    }
    function Ye(e) {
        var t = e[Qe];
        return t || (t = e[Qe] = {
            hoistableStyles: new Map,
            hoistableScripts: new Map
        }), t;
    }
    function Ze(e) {
        e[qe] = !0;
    }
    var Xe = new Set, Pe = {};
    function Je(e, t) {
        He(e, t), He(e + "Capture", t);
    }
    function He(e, t) {
        for(Pe[e] = t, e = 0; e < t.length; e++)Xe.add(t[e]);
    }
    var _e, $e, et = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), tt = {}, nt = {};
    function rt(e, t, n) {
        if (i = t, _.call(nt, i) || !_.call(tt, i) && (et.test(i) ? nt[i] = !0 : (tt[i] = !0, 0))) {
            if (null === n) e.removeAttribute(t);
            else {
                switch(typeof n){
                    case "undefined":
                    case "function":
                    case "symbol":
                        return void e.removeAttribute(t);
                    case "boolean":
                        var r = t.toLowerCase().slice(0, 5);
                        if ("data-" !== r && "aria-" !== r) return void e.removeAttribute(t);
                }
                e.setAttribute(t, "" + n);
            }
        }
        var i;
    }
    function it(e, t, n) {
        if (null === n) e.removeAttribute(t);
        else {
            switch(typeof n){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    return void e.removeAttribute(t);
            }
            e.setAttribute(t, "" + n);
        }
    }
    function ot(e, t, n, r) {
        if (null === r) e.removeAttribute(n);
        else {
            switch(typeof r){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    return void e.removeAttribute(n);
            }
            e.setAttributeNS(t, n, "" + r);
        }
    }
    function at(e) {
        if (void 0 === _e) try {
            throw Error();
        } catch (e) {
            var t = e.stack.trim().match(/\n( *(at )?)/);
            _e = t && t[1] || "", $e = -1 < e.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
        return "\n" + _e + e + $e;
    }
    var lt = !1;
    function st(e, t) {
        if (!e || lt) return "";
        lt = !0;
        var n = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            var r = {
                DetermineComponentFrameRoot: function() {
                    try {
                        if (t) {
                            var n = function() {
                                throw Error();
                            };
                            if (Object.defineProperty(n.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            }), "object" == typeof Reflect && Reflect.construct) {
                                try {
                                    Reflect.construct(n, []);
                                } catch (e) {
                                    var r = e;
                                }
                                Reflect.construct(e, [], n);
                            } else {
                                try {
                                    n.call();
                                } catch (e) {
                                    r = e;
                                }
                                e.call(n.prototype);
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (e) {
                                r = e;
                            }
                            (n = e()) && "function" == typeof n.catch && n.catch(function() {});
                        }
                    } catch (e) {
                        if (e && r && "string" == typeof e.stack) return [
                            e.stack,
                            r.stack
                        ];
                    }
                    return [
                        null,
                        null
                    ];
                }
            };
            r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
            var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, "name");
            i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot"
            });
            var o = r.DetermineComponentFrameRoot(), a = o[0], l = o[1];
            if (a && l) {
                var s = a.split("\n"), u = l.split("\n");
                for(i = r = 0; r < s.length && !s[r].includes("DetermineComponentFrameRoot");)r++;
                for(; i < u.length && !u[i].includes("DetermineComponentFrameRoot");)i++;
                if (r === s.length || i === u.length) for(r = s.length - 1, i = u.length - 1; 1 <= r && 0 <= i && s[r] !== u[i];)i--;
                for(; 1 <= r && 0 <= i; r--, i--)if (s[r] !== u[i]) {
                    if (1 !== r || 1 !== i) do if (r--, 0 > --i || s[r] !== u[i]) {
                        var c = "\n" + s[r].replace(" at new ", " at ");
                        return e.displayName && c.includes("<anonymous>") && (c = c.replace("<anonymous>", e.displayName)), c;
                    }
                    while (1 <= r && 0 <= i);
                    break;
                }
            }
        } finally{
            lt = !1, Error.prepareStackTrace = n;
        }
        return (n = e ? e.displayName || e.name : "") ? at(n) : "";
    }
    function ut(e) {
        switch(e.tag){
            case 26:
            case 27:
            case 5:
                return at(e.type);
            case 16:
                return at("Lazy");
            case 13:
                return at("Suspense");
            case 19:
                return at("SuspenseList");
            case 0:
            case 15:
                return st(e.type, !1);
            case 11:
                return st(e.type.render, !1);
            case 1:
                return st(e.type, !0);
            case 31:
                return at("Activity");
            default:
                return "";
        }
    }
    function ct(e) {
        try {
            var t = "";
            do t += ut(e), e = e.return;
            while (e);
            return t;
        } catch (e) {
            return "\nError generating stack: " + e.message + "\n" + e.stack;
        }
    }
    function dt(e) {
        switch(typeof e){
            case "bigint":
            case "boolean":
            case "number":
            case "string":
            case "undefined":
            case "object":
                return e;
            default:
                return "";
        }
    }
    function ft(e) {
        var t = e.type;
        return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === t || "radio" === t);
    }
    function ht(e) {
        e._valueTracker || (e._valueTracker = function(e) {
            var t = ft(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), r = "" + e[t];
            if (!e.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
                var i = n.get, o = n.set;
                return Object.defineProperty(e, t, {
                    configurable: !0,
                    get: function() {
                        return i.call(this);
                    },
                    set: function(e) {
                        r = "" + e, o.call(this, e);
                    }
                }), Object.defineProperty(e, t, {
                    enumerable: n.enumerable
                }), {
                    getValue: function() {
                        return r;
                    },
                    setValue: function(e) {
                        r = "" + e;
                    },
                    stopTracking: function() {
                        e._valueTracker = null, delete e[t];
                    }
                };
            }
        }(e));
    }
    function pt(e) {
        if (!e) return !1;
        var t = e._valueTracker;
        if (!t) return !0;
        var n = t.getValue(), r = "";
        return e && (r = ft(e) ? e.checked ? "true" : "false" : e.value), (e = r) !== n && (t.setValue(e), !0);
    }
    function mt(e) {
        if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;
        try {
            return e.activeElement || e.body;
        } catch (t) {
            return e.body;
        }
    }
    var gt = /[\n"\\]/g;
    function bt(e) {
        return e.replace(gt, function(e) {
            return "\\" + e.charCodeAt(0).toString(16) + " ";
        });
    }
    function yt(e, t, n, r, i, o, a, l) {
        e.name = "", null != a && "function" != typeof a && "symbol" != typeof a && "boolean" != typeof a ? e.type = a : e.removeAttribute("type"), null != t ? "number" === a ? (0 === t && "" === e.value || e.value != t) && (e.value = "" + dt(t)) : e.value !== "" + dt(t) && (e.value = "" + dt(t)) : "submit" !== a && "reset" !== a || e.removeAttribute("value"), null != t ? It(e, a, dt(t)) : null != n ? It(e, a, dt(n)) : null != r && e.removeAttribute("value"), null == i && null != o && (e.defaultChecked = !!o), null != i && (e.checked = i && "function" != typeof i && "symbol" != typeof i), null != l && "function" != typeof l && "symbol" != typeof l && "boolean" != typeof l ? e.name = "" + dt(l) : e.removeAttribute("name");
    }
    function vt(e, t, n, r, i, o, a, l) {
        if (null != o && "function" != typeof o && "symbol" != typeof o && "boolean" != typeof o && (e.type = o), null != t || null != n) {
            if (("submit" === o || "reset" === o) && null == t) return;
            n = null != n ? "" + dt(n) : "", t = null != t ? "" + dt(t) : n, l || t === e.value || (e.value = t), e.defaultValue = t;
        }
        r = "function" != typeof (r = null != r ? r : i) && "symbol" != typeof r && !!r, e.checked = l ? e.checked : !!r, e.defaultChecked = !!r, null != a && "function" != typeof a && "symbol" != typeof a && "boolean" != typeof a && (e.name = a);
    }
    function It(e, t, n) {
        "number" === t && mt(e.ownerDocument) === e || e.defaultValue === "" + n || (e.defaultValue = "" + n);
    }
    function Mt(e, t, n, r) {
        if (e = e.options, t) {
            t = {};
            for(var i = 0; i < n.length; i++)t["$" + n[i]] = !0;
            for(n = 0; n < e.length; n++)i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
        } else {
            for(n = "" + dt(n), t = null, i = 0; i < e.length; i++){
                if (e[i].value === n) return e[i].selected = !0, void (r && (e[i].defaultSelected = !0));
                null !== t || e[i].disabled || (t = e[i]);
            }
            null !== t && (t.selected = !0);
        }
    }
    function Et(e, t, n) {
        null == t || ((t = "" + dt(t)) !== e.value && (e.value = t), null != n) ? e.defaultValue = null != n ? "" + dt(n) : "" : e.defaultValue !== t && (e.defaultValue = t);
    }
    function xt(e, t, n, i) {
        if (null == t) {
            if (null != i) {
                if (null != n) throw Error(r(92));
                if (z(i)) {
                    if (1 < i.length) throw Error(r(93));
                    i = i[0];
                }
                n = i;
            }
            null == n && (n = ""), t = n;
        }
        n = dt(t), e.defaultValue = n, (i = e.textContent) === n && "" !== i && null !== i && (e.value = i);
    }
    function St(e, t) {
        if (t) {
            var n = e.firstChild;
            if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
        }
        e.textContent = t;
    }
    var wt = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
    function kt(e, t, n) {
        var r = 0 === t.indexOf("--");
        null == n || "boolean" == typeof n || "" === n ? r ? e.setProperty(t, "") : "float" === t ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, n) : "number" != typeof n || 0 === n || wt.has(t) ? "float" === t ? e.cssFloat = n : e[t] = ("" + n).trim() : e[t] = n + "px";
    }
    function Nt(e, t, n) {
        if (null != t && "object" != typeof t) throw Error(r(62));
        if (e = e.style, null != n) {
            for(var i in n)!n.hasOwnProperty(i) || null != t && t.hasOwnProperty(i) || (0 === i.indexOf("--") ? e.setProperty(i, "") : "float" === i ? e.cssFloat = "" : e[i] = "");
            for(var o in t)i = t[o], t.hasOwnProperty(o) && n[o] !== i && kt(e, o, i);
        } else for(var a in t)t.hasOwnProperty(a) && kt(e, a, t[a]);
    }
    function Ut(e) {
        if (-1 === e.indexOf("-")) return !1;
        switch(e){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return !1;
            default:
                return !0;
        }
    }
    var Rt = new Map([
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ],
        [
            "crossOrigin",
            "crossorigin"
        ],
        [
            "accentHeight",
            "accent-height"
        ],
        [
            "alignmentBaseline",
            "alignment-baseline"
        ],
        [
            "arabicForm",
            "arabic-form"
        ],
        [
            "baselineShift",
            "baseline-shift"
        ],
        [
            "capHeight",
            "cap-height"
        ],
        [
            "clipPath",
            "clip-path"
        ],
        [
            "clipRule",
            "clip-rule"
        ],
        [
            "colorInterpolation",
            "color-interpolation"
        ],
        [
            "colorInterpolationFilters",
            "color-interpolation-filters"
        ],
        [
            "colorProfile",
            "color-profile"
        ],
        [
            "colorRendering",
            "color-rendering"
        ],
        [
            "dominantBaseline",
            "dominant-baseline"
        ],
        [
            "enableBackground",
            "enable-background"
        ],
        [
            "fillOpacity",
            "fill-opacity"
        ],
        [
            "fillRule",
            "fill-rule"
        ],
        [
            "floodColor",
            "flood-color"
        ],
        [
            "floodOpacity",
            "flood-opacity"
        ],
        [
            "fontFamily",
            "font-family"
        ],
        [
            "fontSize",
            "font-size"
        ],
        [
            "fontSizeAdjust",
            "font-size-adjust"
        ],
        [
            "fontStretch",
            "font-stretch"
        ],
        [
            "fontStyle",
            "font-style"
        ],
        [
            "fontVariant",
            "font-variant"
        ],
        [
            "fontWeight",
            "font-weight"
        ],
        [
            "glyphName",
            "glyph-name"
        ],
        [
            "glyphOrientationHorizontal",
            "glyph-orientation-horizontal"
        ],
        [
            "glyphOrientationVertical",
            "glyph-orientation-vertical"
        ],
        [
            "horizAdvX",
            "horiz-adv-x"
        ],
        [
            "horizOriginX",
            "horiz-origin-x"
        ],
        [
            "imageRendering",
            "image-rendering"
        ],
        [
            "letterSpacing",
            "letter-spacing"
        ],
        [
            "lightingColor",
            "lighting-color"
        ],
        [
            "markerEnd",
            "marker-end"
        ],
        [
            "markerMid",
            "marker-mid"
        ],
        [
            "markerStart",
            "marker-start"
        ],
        [
            "overlinePosition",
            "overline-position"
        ],
        [
            "overlineThickness",
            "overline-thickness"
        ],
        [
            "paintOrder",
            "paint-order"
        ],
        [
            "panose-1",
            "panose-1"
        ],
        [
            "pointerEvents",
            "pointer-events"
        ],
        [
            "renderingIntent",
            "rendering-intent"
        ],
        [
            "shapeRendering",
            "shape-rendering"
        ],
        [
            "stopColor",
            "stop-color"
        ],
        [
            "stopOpacity",
            "stop-opacity"
        ],
        [
            "strikethroughPosition",
            "strikethrough-position"
        ],
        [
            "strikethroughThickness",
            "strikethrough-thickness"
        ],
        [
            "strokeDasharray",
            "stroke-dasharray"
        ],
        [
            "strokeDashoffset",
            "stroke-dashoffset"
        ],
        [
            "strokeLinecap",
            "stroke-linecap"
        ],
        [
            "strokeLinejoin",
            "stroke-linejoin"
        ],
        [
            "strokeMiterlimit",
            "stroke-miterlimit"
        ],
        [
            "strokeOpacity",
            "stroke-opacity"
        ],
        [
            "strokeWidth",
            "stroke-width"
        ],
        [
            "textAnchor",
            "text-anchor"
        ],
        [
            "textDecoration",
            "text-decoration"
        ],
        [
            "textRendering",
            "text-rendering"
        ],
        [
            "transformOrigin",
            "transform-origin"
        ],
        [
            "underlinePosition",
            "underline-position"
        ],
        [
            "underlineThickness",
            "underline-thickness"
        ],
        [
            "unicodeBidi",
            "unicode-bidi"
        ],
        [
            "unicodeRange",
            "unicode-range"
        ],
        [
            "unitsPerEm",
            "units-per-em"
        ],
        [
            "vAlphabetic",
            "v-alphabetic"
        ],
        [
            "vHanging",
            "v-hanging"
        ],
        [
            "vIdeographic",
            "v-ideographic"
        ],
        [
            "vMathematical",
            "v-mathematical"
        ],
        [
            "vectorEffect",
            "vector-effect"
        ],
        [
            "vertAdvY",
            "vert-adv-y"
        ],
        [
            "vertOriginX",
            "vert-origin-x"
        ],
        [
            "vertOriginY",
            "vert-origin-y"
        ],
        [
            "wordSpacing",
            "word-spacing"
        ],
        [
            "writingMode",
            "writing-mode"
        ],
        [
            "xmlnsXlink",
            "xmlns:xlink"
        ],
        [
            "xHeight",
            "x-height"
        ]
    ]), Lt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
    function Ct(e) {
        return Lt.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
    }
    var zt = null;
    function Tt(e) {
        return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
    }
    var Dt = null, Ft = null;
    function Vt(e) {
        var t = Be(e);
        if (t && (e = t.stateNode)) {
            var n = e[Fe] || null;
            e: switch(e = t.stateNode, t.type){
                case "input":
                    if (yt(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, "radio" === n.type && null != t) {
                        for(n = e; n.parentNode;)n = n.parentNode;
                        for(n = n.querySelectorAll('input[name="' + bt("" + t) + '"][type="radio"]'), t = 0; t < n.length; t++){
                            var i = n[t];
                            if (i !== e && i.form === e.form) {
                                var o = i[Fe] || null;
                                if (!o) throw Error(r(90));
                                yt(i, o.value, o.defaultValue, o.defaultValue, o.checked, o.defaultChecked, o.type, o.name);
                            }
                        }
                        for(t = 0; t < n.length; t++)(i = n[t]).form === e.form && pt(i);
                    }
                    break e;
                case "textarea":
                    Et(e, n.value, n.defaultValue);
                    break e;
                case "select":
                    null != (t = n.value) && Mt(e, !!n.multiple, t, !1);
            }
        }
    }
    var At = !1;
    function jt(e, t, n) {
        if (At) return e(t, n);
        At = !0;
        try {
            return e(t);
        } finally{
            if (At = !1, (null !== Dt || null !== Ft) && (Bu(), Dt && (t = Dt, e = Ft, Ft = Dt = null, Vt(t), e))) for(t = 0; t < e.length; t++)Vt(e[t]);
        }
    }
    function Ot(e, t) {
        var n = e.stateNode;
        if (null === n) return null;
        var i = n[Fe] || null;
        if (null === i) return null;
        n = i[t];
        e: switch(t){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                (i = !i.disabled) || (i = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !i;
                break e;
            default:
                e = !1;
        }
        if (e) return null;
        if (n && "function" != typeof n) throw Error(r(231, t, typeof n));
        return n;
    }
    var Qt = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), qt = !1;
    if (Qt) try {
        var Wt = {};
        Object.defineProperty(Wt, "passive", {
            get: function() {
                qt = !0;
            }
        }), window.addEventListener("test", Wt, Wt), window.removeEventListener("test", Wt, Wt);
    } catch (e) {
        qt = !1;
    }
    var Gt = null, Bt = null, Kt = null;
    function Yt() {
        if (Kt) return Kt;
        var e, t, n = Bt, r = n.length, i = "value" in Gt ? Gt.value : Gt.textContent, o = i.length;
        for(e = 0; e < r && n[e] === i[e]; e++);
        var a = r - e;
        for(t = 1; t <= a && n[r - t] === i[o - t]; t++);
        return Kt = i.slice(e, 1 < t ? 1 - t : void 0);
    }
    function Zt(e) {
        var t = e.keyCode;
        return "charCode" in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : e = t, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
    }
    function Xt() {
        return !0;
    }
    function Pt() {
        return !1;
    }
    function Jt(e) {
        function t(t, n, r, i, o) {
            for(var a in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = o, this.currentTarget = null, e)e.hasOwnProperty(a) && (t = e[a], this[a] = t ? t(i) : i[a]);
            return this.isDefaultPrevented = (null != i.defaultPrevented ? i.defaultPrevented : !1 === i.returnValue) ? Xt : Pt, this.isPropagationStopped = Pt, this;
        }
        return u(t.prototype, {
            preventDefault: function() {
                this.defaultPrevented = !0;
                var e = this.nativeEvent;
                e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), this.isDefaultPrevented = Xt);
            },
            stopPropagation: function() {
                var e = this.nativeEvent;
                e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), this.isPropagationStopped = Xt);
            },
            persist: function() {},
            isPersistent: Xt
        }), t;
    }
    var Ht, _t, $t, en = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(e) {
            return e.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    }, tn = Jt(en), nn = u({}, en, {
        view: 0,
        detail: 0
    }), rn = Jt(nn), on = u({}, nn, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: gn,
        button: 0,
        buttons: 0,
        relatedTarget: function(e) {
            return void 0 === e.relatedTarget ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
        },
        movementX: function(e) {
            return "movementX" in e ? e.movementX : (e !== $t && ($t && "mousemove" === e.type ? (Ht = e.screenX - $t.screenX, _t = e.screenY - $t.screenY) : _t = Ht = 0, $t = e), Ht);
        },
        movementY: function(e) {
            return "movementY" in e ? e.movementY : _t;
        }
    }), an = Jt(on), ln = Jt(u({}, on, {
        dataTransfer: 0
    })), sn = Jt(u({}, nn, {
        relatedTarget: 0
    })), un = Jt(u({}, en, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    })), cn = Jt(u({}, en, {
        clipboardData: function(e) {
            return "clipboardData" in e ? e.clipboardData : window.clipboardData;
        }
    })), dn = Jt(u({}, en, {
        data: 0
    })), fn = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    }, hn = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
    }, pn = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    };
    function mn(e) {
        var t = this.nativeEvent;
        return t.getModifierState ? t.getModifierState(e) : !!(e = pn[e]) && !!t[e];
    }
    function gn() {
        return mn;
    }
    var bn = u({}, nn, {
        key: function(e) {
            if (e.key) {
                var t = fn[e.key] || e.key;
                if ("Unidentified" !== t) return t;
            }
            return "keypress" === e.type ? 13 === (e = Zt(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? hn[e.keyCode] || "Unidentified" : "";
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: gn,
        charCode: function(e) {
            return "keypress" === e.type ? Zt(e) : 0;
        },
        keyCode: function(e) {
            return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
        },
        which: function(e) {
            return "keypress" === e.type ? Zt(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
        }
    }), yn = Jt(bn), vn = Jt(u({}, on, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    })), In = Jt(u({}, nn, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: gn
    })), Mn = Jt(u({}, en, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    })), En = Jt(u({}, on, {
        deltaX: function(e) {
            return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
        },
        deltaY: function(e) {
            return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
    })), xn = Jt(u({}, en, {
        newState: 0,
        oldState: 0
    })), Sn = [
        9,
        13,
        27,
        32
    ], wn = Qt && "CompositionEvent" in window, kn = null;
    Qt && "documentMode" in document && (kn = document.documentMode);
    var Nn = Qt && "TextEvent" in window && !kn, Un = Qt && (!wn || kn && 8 < kn && 11 >= kn), Rn = String.fromCharCode(32), Ln = !1;
    function Cn(e, t) {
        switch(e){
            case "keyup":
                return -1 !== Sn.indexOf(t.keyCode);
            case "keydown":
                return 229 !== t.keyCode;
            case "keypress":
            case "mousedown":
            case "focusout":
                return !0;
            default:
                return !1;
        }
    }
    function zn(e) {
        return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
    }
    var Tn = !1;
    var Dn = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
    };
    function Fn(e) {
        var t = e && e.nodeName && e.nodeName.toLowerCase();
        return "input" === t ? !!Dn[e.type] : "textarea" === t;
    }
    function Vn(e, t, n, r) {
        Dt ? Ft ? Ft.push(r) : Ft = [
            r
        ] : Dt = r, 0 < (t = Zc(t, "onChange")).length && (n = new tn("onChange", "change", null, n, r), e.push({
            event: n,
            listeners: t
        }));
    }
    var An = null, jn = null;
    function On(e) {
        Oc(e, 0);
    }
    function Qn(e) {
        if (pt(Ke(e))) return e;
    }
    function qn(e, t) {
        if ("change" === e) return t;
    }
    var Wn = !1;
    if (Qt) {
        var Gn;
        if (Qt) {
            var Bn = "oninput" in document;
            if (!Bn) {
                var Kn = document.createElement("div");
                Kn.setAttribute("oninput", "return;"), Bn = "function" == typeof Kn.oninput;
            }
            Gn = Bn;
        } else Gn = !1;
        Wn = Gn && (!document.documentMode || 9 < document.documentMode);
    }
    function Yn() {
        An && (An.detachEvent("onpropertychange", Zn), jn = An = null);
    }
    function Zn(e) {
        if ("value" === e.propertyName && Qn(jn)) {
            var t = [];
            Vn(t, jn, e, Tt(e)), jt(On, t);
        }
    }
    function Xn(e, t, n) {
        "focusin" === e ? (Yn(), jn = n, (An = t).attachEvent("onpropertychange", Zn)) : "focusout" === e && Yn();
    }
    function Pn(e) {
        if ("selectionchange" === e || "keyup" === e || "keydown" === e) return Qn(jn);
    }
    function Jn(e, t) {
        if ("click" === e) return Qn(t);
    }
    function Hn(e, t) {
        if ("input" === e || "change" === e) return Qn(t);
    }
    var _n = "function" == typeof Object.is ? Object.is : function(e, t) {
        return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
    };
    function $n(e, t) {
        if (_n(e, t)) return !0;
        if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
        var n = Object.keys(e), r = Object.keys(t);
        if (n.length !== r.length) return !1;
        for(r = 0; r < n.length; r++){
            var i = n[r];
            if (!_.call(t, i) || !_n(e[i], t[i])) return !1;
        }
        return !0;
    }
    function er(e) {
        for(; e && e.firstChild;)e = e.firstChild;
        return e;
    }
    function tr(e, t) {
        var n, r = er(e);
        for(e = 0; r;){
            if (3 === r.nodeType) {
                if (n = e + r.textContent.length, e <= t && n >= t) return {
                    node: r,
                    offset: t - e
                };
                e = n;
            }
            e: {
                for(; r;){
                    if (r.nextSibling) {
                        r = r.nextSibling;
                        break e;
                    }
                    r = r.parentNode;
                }
                r = void 0;
            }
            r = er(r);
        }
    }
    function nr(e, t) {
        return !(!e || !t) && (e === t || (!e || 3 !== e.nodeType) && (t && 3 === t.nodeType ? nr(e, t.parentNode) : "contains" in e ? e.contains(t) : !!e.compareDocumentPosition && !!(16 & e.compareDocumentPosition(t))));
    }
    function rr(e) {
        for(var t = mt((e = null != e && null != e.ownerDocument && null != e.ownerDocument.defaultView ? e.ownerDocument.defaultView : window).document); t instanceof e.HTMLIFrameElement;){
            try {
                var n = "string" == typeof t.contentWindow.location.href;
            } catch (e) {
                n = !1;
            }
            if (!n) break;
            t = mt((e = t.contentWindow).document);
        }
        return t;
    }
    function ir(e) {
        var t = e && e.nodeName && e.nodeName.toLowerCase();
        return t && ("input" === t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === t || "true" === e.contentEditable);
    }
    var or = Qt && "documentMode" in document && 11 >= document.documentMode, ar = null, lr = null, sr = null, ur = !1;
    function cr(e, t, n) {
        var r = n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument;
        ur || null == ar || ar !== mt(r) || ("selectionStart" in (r = ar) && ir(r) ? r = {
            start: r.selectionStart,
            end: r.selectionEnd
        } : r = {
            anchorNode: (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection()).anchorNode,
            anchorOffset: r.anchorOffset,
            focusNode: r.focusNode,
            focusOffset: r.focusOffset
        }, sr && $n(sr, r) || (sr = r, 0 < (r = Zc(lr, "onSelect")).length && (t = new tn("onSelect", "select", null, t, n), e.push({
            event: t,
            listeners: r
        }), t.target = ar)));
    }
    function dr(e, t) {
        var n = {};
        return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
    }
    var fr = {
        animationend: dr("Animation", "AnimationEnd"),
        animationiteration: dr("Animation", "AnimationIteration"),
        animationstart: dr("Animation", "AnimationStart"),
        transitionrun: dr("Transition", "TransitionRun"),
        transitionstart: dr("Transition", "TransitionStart"),
        transitioncancel: dr("Transition", "TransitionCancel"),
        transitionend: dr("Transition", "TransitionEnd")
    }, hr = {}, pr = {};
    function mr(e) {
        if (hr[e]) return hr[e];
        if (!fr[e]) return e;
        var t, n = fr[e];
        for(t in n)if (n.hasOwnProperty(t) && t in pr) return hr[e] = n[t];
        return e;
    }
    Qt && (pr = document.createElement("div").style, "AnimationEvent" in window || (delete fr.animationend.animation, delete fr.animationiteration.animation, delete fr.animationstart.animation), "TransitionEvent" in window || delete fr.transitionend.transition);
    var gr = mr("animationend"), br = mr("animationiteration"), yr = mr("animationstart"), vr = mr("transitionrun"), Ir = mr("transitionstart"), Mr = mr("transitioncancel"), Er = mr("transitionend"), xr = new Map, Sr = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    function wr(e, t) {
        xr.set(e, t), Je(t, [
            e
        ]);
    }
    Sr.push("scrollEnd");
    var kr = new WeakMap;
    function Nr(e, t) {
        if ("object" == typeof e && null !== e) {
            var n = kr.get(e);
            return void 0 !== n ? n : (t = {
                value: e,
                source: t,
                stack: ct(t)
            }, kr.set(e, t), t);
        }
        return {
            value: e,
            source: t,
            stack: ct(t)
        };
    }
    var Ur = [], Rr = 0, Lr = 0;
    function Cr() {
        for(var e = Rr, t = Lr = Rr = 0; t < e;){
            var n = Ur[t];
            Ur[t++] = null;
            var r = Ur[t];
            Ur[t++] = null;
            var i = Ur[t];
            Ur[t++] = null;
            var o = Ur[t];
            if (Ur[t++] = null, null !== r && null !== i) {
                var a = r.pending;
                null === a ? i.next = i : (i.next = a.next, a.next = i), r.pending = i;
            }
            0 !== o && Fr(n, i, o);
        }
    }
    function zr(e, t, n, r) {
        Ur[Rr++] = e, Ur[Rr++] = t, Ur[Rr++] = n, Ur[Rr++] = r, Lr |= r, e.lanes |= r, null !== (e = e.alternate) && (e.lanes |= r);
    }
    function Tr(e, t, n, r) {
        return zr(e, t, n, r), Vr(e);
    }
    function Dr(e, t) {
        return zr(e, null, null, t), Vr(e);
    }
    function Fr(e, t, n) {
        e.lanes |= n;
        var r = e.alternate;
        null !== r && (r.lanes |= n);
        for(var i = !1, o = e.return; null !== o;)o.childLanes |= n, null !== (r = o.alternate) && (r.childLanes |= n), 22 === o.tag && (null === (e = o.stateNode) || 1 & e._visibility || (i = !0)), e = o, o = o.return;
        return 3 === e.tag ? (o = e.stateNode, i && null !== t && (i = 31 - me(n), null === (r = (e = o.hiddenUpdates)[i]) ? e[i] = [
            t
        ] : r.push(t), t.lane = 536870912 | n), o) : null;
    }
    function Vr(e) {
        if (50 < Fu) throw Fu = 0, Vu = null, Error(r(185));
        for(var t = e.return; null !== t;)t = (e = t).return;
        return 3 === e.tag ? e.stateNode : null;
    }
    var Ar = {};
    function jr(e, t, n, r) {
        this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
    }
    function Or(e, t, n, r) {
        return new jr(e, t, n, r);
    }
    function Qr(e) {
        return !(!(e = e.prototype) || !e.isReactComponent);
    }
    function qr(e, t) {
        var n = e.alternate;
        return null === n ? ((n = Or(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = 65011712 & e.flags, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = null === t ? null : {
            lanes: t.lanes,
            firstContext: t.firstContext
        }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
    }
    function Wr(e, t) {
        e.flags &= 65011714;
        var n = e.alternate;
        return null === n ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = null === t ? null : {
            lanes: t.lanes,
            firstContext: t.firstContext
        }), e;
    }
    function Gr(e, t, n, i, o, a) {
        var l = 0;
        if (i = e, "function" == typeof e) Qr(e) && (l = 1);
        else if ("string" == typeof e) l = function(e, t, n) {
            if (1 === n || null != t.itemProp) return !1;
            switch(e){
                case "meta":
                case "title":
                    return !0;
                case "style":
                    if ("string" != typeof t.precedence || "string" != typeof t.href || "" === t.href) break;
                    return !0;
                case "link":
                    if ("string" != typeof t.rel || "string" != typeof t.href || "" === t.href || t.onLoad || t.onError) break;
                    return "stylesheet" !== t.rel || (e = t.disabled, "string" == typeof t.precedence && null == e);
                case "script":
                    if (t.async && "function" != typeof t.async && "symbol" != typeof t.async && !t.onLoad && !t.onError && t.src && "string" == typeof t.src) return !0;
            }
            return !1;
        }(e, n, G.current) ? 26 : "html" === e || "head" === e || "body" === e ? 27 : 5;
        else e: switch(e){
            case k:
                return (e = Or(31, n, t, o)).elementType = k, e.lanes = a, e;
            case h:
                return Br(n.children, o, a, t);
            case p:
                l = 8, o |= 24;
                break;
            case m:
                return (e = Or(12, n, t, 2 | o)).elementType = m, e.lanes = a, e;
            case M:
                return (e = Or(13, n, t, o)).elementType = M, e.lanes = a, e;
            case E:
                return (e = Or(19, n, t, o)).elementType = E, e.lanes = a, e;
            default:
                if ("object" == typeof e && null !== e) switch(e.$$typeof){
                    case g:
                    case y:
                        l = 10;
                        break e;
                    case b:
                        l = 9;
                        break e;
                    case I:
                        l = 11;
                        break e;
                    case x:
                        l = 14;
                        break e;
                    case S:
                        l = 16, i = null;
                        break e;
                }
                l = 29, n = Error(r(130, null === e ? "null" : typeof e, "")), i = null;
        }
        return (t = Or(l, n, t, o)).elementType = e, t.type = i, t.lanes = a, t;
    }
    function Br(e, t, n, r) {
        return (e = Or(7, e, r, t)).lanes = n, e;
    }
    function Kr(e, t, n) {
        return (e = Or(6, e, null, t)).lanes = n, e;
    }
    function Yr(e, t, n) {
        return (t = Or(4, null !== e.children ? e.children : [], e.key, t)).lanes = n, t.stateNode = {
            containerInfo: e.containerInfo,
            pendingChildren: null,
            implementation: e.implementation
        }, t;
    }
    var Zr = [], Xr = 0, Pr = null, Jr = 0, Hr = [], _r = 0, $r = null, ei = 1, ti = "";
    function ni(e, t) {
        Zr[Xr++] = Jr, Zr[Xr++] = Pr, Pr = e, Jr = t;
    }
    function ri(e, t, n) {
        Hr[_r++] = ei, Hr[_r++] = ti, Hr[_r++] = $r, $r = e;
        var r = ei;
        e = ti;
        var i = 32 - me(r) - 1;
        r &= ~(1 << i), n += 1;
        var o = 32 - me(t) + i;
        if (30 < o) {
            var a = i - i % 5;
            o = (r & (1 << a) - 1).toString(32), r >>= a, i -= a, ei = 1 << 32 - me(t) + i | n << i | r, ti = o + e;
        } else ei = 1 << o | n << i | r, ti = e;
    }
    function ii(e) {
        null !== e.return && (ni(e, 1), ri(e, 1, 0));
    }
    function oi(e) {
        for(; e === Pr;)Pr = Zr[--Xr], Zr[Xr] = null, Jr = Zr[--Xr], Zr[Xr] = null;
        for(; e === $r;)$r = Hr[--_r], Hr[_r] = null, ti = Hr[--_r], Hr[_r] = null, ei = Hr[--_r], Hr[_r] = null;
    }
    var ai = null, li = null, si = !1, ui = null, ci = !1, di = Error(r(519));
    function fi(e) {
        throw yi(Nr(Error(r(418, "")), e)), di;
    }
    function hi(e) {
        var t = e.stateNode, n = e.type, r = e.memoizedProps;
        switch(t[De] = e, t[Fe] = r, n){
            case "dialog":
                Qc("cancel", t), Qc("close", t);
                break;
            case "iframe":
            case "object":
            case "embed":
                Qc("load", t);
                break;
            case "video":
            case "audio":
                for(n = 0; n < Ac.length; n++)Qc(Ac[n], t);
                break;
            case "source":
                Qc("error", t);
                break;
            case "img":
            case "image":
            case "link":
                Qc("error", t), Qc("load", t);
                break;
            case "details":
                Qc("toggle", t);
                break;
            case "input":
                Qc("invalid", t), vt(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0), ht(t);
                break;
            case "select":
                Qc("invalid", t);
                break;
            case "textarea":
                Qc("invalid", t), xt(t, r.value, r.defaultValue, r.children), ht(t);
        }
        "string" != typeof (n = r.children) && "number" != typeof n && "bigint" != typeof n || t.textContent === "" + n || !0 === r.suppressHydrationWarning || $c(t.textContent, n) ? (null != r.popover && (Qc("beforetoggle", t), Qc("toggle", t)), null != r.onScroll && Qc("scroll", t), null != r.onScrollEnd && Qc("scrollend", t), null != r.onClick && (t.onclick = ed), t = !0) : t = !1, t || fi(e);
    }
    function pi(e) {
        for(ai = e.return; ai;)switch(ai.tag){
            case 5:
            case 13:
                return void (ci = !1);
            case 27:
            case 3:
                return void (ci = !0);
            default:
                ai = ai.return;
        }
    }
    function mi(e) {
        if (e !== ai) return !1;
        if (!si) return pi(e), si = !0, !1;
        var t, n = e.tag;
        if ((t = 3 !== n && 27 !== n) && ((t = 5 === n) && (t = !("form" !== (t = e.type) && "button" !== t) || ud(e.type, e.memoizedProps)), t = !t), t && li && fi(e), pi(e), 13 === n) {
            if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(r(317));
            e: {
                for(e = e.nextSibling, n = 0; e;){
                    if (8 === e.nodeType) {
                        if ("/$" === (t = e.data)) {
                            if (0 === n) {
                                li = Id(e.nextSibling);
                                break e;
                            }
                            n--;
                        } else "$" !== t && "$!" !== t && "$?" !== t || n++;
                    }
                    e = e.nextSibling;
                }
                li = null;
            }
        } else 27 === n ? (n = li, gd(e.type) ? (e = Md, Md = null, li = e) : li = n) : li = ai ? Id(e.stateNode.nextSibling) : null;
        return !0;
    }
    function gi() {
        li = ai = null, si = !1;
    }
    function bi() {
        var e = ui;
        return null !== e && (null === Eu ? Eu = e : Eu.push.apply(Eu, e), ui = null), e;
    }
    function yi(e) {
        null === ui ? ui = [
            e
        ] : ui.push(e);
    }
    var vi = O(null), Ii = null, Mi = null;
    function Ei(e, t, n) {
        W(vi, t._currentValue), t._currentValue = n;
    }
    function xi(e) {
        e._currentValue = vi.current, Q(vi);
    }
    function Si(e, t, n) {
        for(; null !== e;){
            var r = e.alternate;
            if ((e.childLanes & t) !== t ? (e.childLanes |= t, null !== r && (r.childLanes |= t)) : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
            e = e.return;
        }
    }
    function wi(e, t, n, i) {
        var o = e.child;
        for(null !== o && (o.return = e); null !== o;){
            var a = o.dependencies;
            if (null !== a) {
                var l = o.child;
                a = a.firstContext;
                e: for(; null !== a;){
                    var s = a;
                    a = o;
                    for(var u = 0; u < t.length; u++)if (s.context === t[u]) {
                        a.lanes |= n, null !== (s = a.alternate) && (s.lanes |= n), Si(a.return, n, e), i || (l = null);
                        break e;
                    }
                    a = s.next;
                }
            } else if (18 === o.tag) {
                if (null === (l = o.return)) throw Error(r(341));
                l.lanes |= n, null !== (a = l.alternate) && (a.lanes |= n), Si(l, n, e), l = null;
            } else l = o.child;
            if (null !== l) l.return = o;
            else for(l = o; null !== l;){
                if (l === e) {
                    l = null;
                    break;
                }
                if (null !== (o = l.sibling)) {
                    o.return = l.return, l = o;
                    break;
                }
                l = l.return;
            }
            o = l;
        }
    }
    function ki(e, t, n, i) {
        e = null;
        for(var o = t, a = !1; null !== o;){
            if (!a) {
                if (524288 & o.flags) a = !0;
                else if (262144 & o.flags) break;
            }
            if (10 === o.tag) {
                var l = o.alternate;
                if (null === l) throw Error(r(387));
                if (null !== (l = l.memoizedProps)) {
                    var s = o.type;
                    _n(o.pendingProps.value, l.value) || (null !== e ? e.push(s) : e = [
                        s
                    ]);
                }
            } else if (o === Z.current) {
                if (null === (l = o.alternate)) throw Error(r(387));
                l.memoizedState.memoizedState !== o.memoizedState.memoizedState && (null !== e ? e.push(Hd) : e = [
                    Hd
                ]);
            }
            o = o.return;
        }
        null !== e && wi(t, e, n, i), t.flags |= 262144;
    }
    function Ni(e) {
        for(e = e.firstContext; null !== e;){
            if (!_n(e.context._currentValue, e.memoizedValue)) return !0;
            e = e.next;
        }
        return !1;
    }
    function Ui(e) {
        Ii = e, Mi = null, null !== (e = e.dependencies) && (e.firstContext = null);
    }
    function Ri(e) {
        return Ci(Ii, e);
    }
    function Li(e, t) {
        return null === Ii && Ui(e), Ci(e, t);
    }
    function Ci(e, t) {
        var n = t._currentValue;
        if (t = {
            context: t,
            memoizedValue: n,
            next: null
        }, null === Mi) {
            if (null === e) throw Error(r(308));
            Mi = t, e.dependencies = {
                lanes: 0,
                firstContext: t
            }, e.flags |= 524288;
        } else Mi = Mi.next = t;
        return n;
    }
    var zi = "undefined" != typeof AbortController ? AbortController : function() {
        var e = [], t = this.signal = {
            aborted: !1,
            addEventListener: function(t, n) {
                e.push(n);
            }
        };
        this.abort = function() {
            t.aborted = !0, e.forEach(function(e) {
                return e();
            });
        };
    }, Ti = e.unstable_scheduleCallback, Di = e.unstable_NormalPriority, Fi = {
        $$typeof: y,
        Consumer: null,
        Provider: null,
        _currentValue: null,
        _currentValue2: null,
        _threadCount: 0
    };
    function Vi() {
        return {
            controller: new zi,
            data: new Map,
            refCount: 0
        };
    }
    function Ai(e) {
        e.refCount--, 0 === e.refCount && Ti(Di, function() {
            e.controller.abort();
        });
    }
    var ji = null, Oi = 0, Qi = 0, qi = null;
    function Wi() {
        if (0 === --Oi && null !== ji) {
            null !== qi && (qi.status = "fulfilled");
            var e = ji;
            ji = null, Qi = 0, qi = null;
            for(var t = 0; t < e.length; t++)(0, e[t])();
        }
    }
    var Gi = T.S;
    T.S = function(e, t) {
        "object" == typeof t && null !== t && "function" == typeof t.then && function(e, t) {
            if (null === ji) {
                var n = ji = [];
                Oi = 0, Qi = zc(), qi = {
                    status: "pending",
                    value: void 0,
                    then: function(e) {
                        n.push(e);
                    }
                };
            }
            Oi++, t.then(Wi, Wi);
        }(0, t), null !== Gi && Gi(e, t);
    };
    var Bi = O(null);
    function Ki() {
        var e = Bi.current;
        return null !== e ? e : au.pooledCache;
    }
    function Yi(e, t) {
        W(Bi, null === t ? Bi.current : t.pool);
    }
    function Zi() {
        var e = Ki();
        return null === e ? null : {
            parent: Fi._currentValue,
            pool: e
        };
    }
    var Xi = Error(r(460)), Pi = Error(r(474)), Ji = Error(r(542)), Hi = {
        then: function() {}
    };
    function _i(e) {
        return "fulfilled" === (e = e.status) || "rejected" === e;
    }
    function $i() {}
    function eo(e, t, n) {
        switch(void 0 === (n = e[n]) ? e.push(t) : n !== t && (t.then($i, $i), t = n), t.status){
            case "fulfilled":
                return t.value;
            case "rejected":
                throw ro(e = t.reason), e;
            default:
                if ("string" == typeof t.status) t.then($i, $i);
                else {
                    if (null !== (e = au) && 100 < e.shellSuspendCounter) throw Error(r(482));
                    (e = t).status = "pending", e.then(function(e) {
                        if ("pending" === t.status) {
                            var n = t;
                            n.status = "fulfilled", n.value = e;
                        }
                    }, function(e) {
                        if ("pending" === t.status) {
                            var n = t;
                            n.status = "rejected", n.reason = e;
                        }
                    });
                }
                switch(t.status){
                    case "fulfilled":
                        return t.value;
                    case "rejected":
                        throw ro(e = t.reason), e;
                }
                throw to = t, Xi;
        }
    }
    var to = null;
    function no() {
        if (null === to) throw Error(r(459));
        var e = to;
        return to = null, e;
    }
    function ro(e) {
        if (e === Xi || e === Ji) throw Error(r(483));
    }
    var io = !1;
    function oo(e) {
        e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                lanes: 0,
                hiddenCallbacks: null
            },
            callbacks: null
        };
    }
    function ao(e, t) {
        e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
            baseState: e.baseState,
            firstBaseUpdate: e.firstBaseUpdate,
            lastBaseUpdate: e.lastBaseUpdate,
            shared: e.shared,
            callbacks: null
        });
    }
    function lo(e) {
        return {
            lane: e,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function so(e, t, n) {
        var r = e.updateQueue;
        if (null === r) return null;
        if (r = r.shared, 2 & ou) {
            var i = r.pending;
            return null === i ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = Vr(e), Fr(e, null, n), t;
        }
        return zr(e, r, t, n), Vr(e);
    }
    function uo(e, t, n) {
        if (null !== (t = t.updateQueue) && (t = t.shared, 4194048 & n)) {
            var r = t.lanes;
            n |= r &= e.pendingLanes, t.lanes = n, Re(e, n);
        }
    }
    function co(e, t) {
        var n = e.updateQueue, r = e.alternate;
        if (null !== r && n === (r = r.updateQueue)) {
            var i = null, o = null;
            if (null !== (n = n.firstBaseUpdate)) {
                do {
                    var a = {
                        lane: n.lane,
                        tag: n.tag,
                        payload: n.payload,
                        callback: null,
                        next: null
                    };
                    null === o ? i = o = a : o = o.next = a, n = n.next;
                }while (null !== n);
                null === o ? i = o = t : o = o.next = t;
            } else i = o = t;
            return n = {
                baseState: r.baseState,
                firstBaseUpdate: i,
                lastBaseUpdate: o,
                shared: r.shared,
                callbacks: r.callbacks
            }, void (e.updateQueue = n);
        }
        null === (e = n.lastBaseUpdate) ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
    }
    var fo = !1;
    function ho() {
        if (fo) {
            if (null !== qi) throw qi;
        }
    }
    function po(e, t, n, r) {
        fo = !1;
        var i = e.updateQueue;
        io = !1;
        var o = i.firstBaseUpdate, a = i.lastBaseUpdate, l = i.shared.pending;
        if (null !== l) {
            i.shared.pending = null;
            var s = l, c = s.next;
            s.next = null, null === a ? o = c : a.next = c, a = s;
            var d = e.alternate;
            null !== d && (l = (d = d.updateQueue).lastBaseUpdate) !== a && (null === l ? d.firstBaseUpdate = c : l.next = c, d.lastBaseUpdate = s);
        }
        if (null !== o) {
            var f = i.baseState;
            for(a = 0, d = c = s = null, l = o;;){
                var h = -536870913 & l.lane, p = h !== l.lane;
                if (p ? (su & h) === h : (r & h) === h) {
                    0 !== h && h === Qi && (fo = !0), null !== d && (d = d.next = {
                        lane: 0,
                        tag: l.tag,
                        payload: l.payload,
                        callback: null,
                        next: null
                    });
                    e: {
                        var m = e, g = l;
                        h = t;
                        var b = n;
                        switch(g.tag){
                            case 1:
                                if ("function" == typeof (m = g.payload)) {
                                    f = m.call(b, f, h);
                                    break e;
                                }
                                f = m;
                                break e;
                            case 3:
                                m.flags = -65537 & m.flags | 128;
                            case 0:
                                if (null == (h = "function" == typeof (m = g.payload) ? m.call(b, f, h) : m)) break e;
                                f = u({}, f, h);
                                break e;
                            case 2:
                                io = !0;
                        }
                    }
                    null !== (h = l.callback) && (e.flags |= 64, p && (e.flags |= 8192), null === (p = i.callbacks) ? i.callbacks = [
                        h
                    ] : p.push(h));
                } else p = {
                    lane: h,
                    tag: l.tag,
                    payload: l.payload,
                    callback: l.callback,
                    next: null
                }, null === d ? (c = d = p, s = f) : d = d.next = p, a |= h;
                if (null === (l = l.next)) {
                    if (null === (l = i.shared.pending)) break;
                    l = (p = l).next, p.next = null, i.lastBaseUpdate = p, i.shared.pending = null;
                }
            }
            null === d && (s = f), i.baseState = s, i.firstBaseUpdate = c, i.lastBaseUpdate = d, null === o && (i.shared.lanes = 0), gu |= a, e.lanes = a, e.memoizedState = f;
        }
    }
    function mo(e, t) {
        if ("function" != typeof e) throw Error(r(191, e));
        e.call(t);
    }
    function go(e, t) {
        var n = e.callbacks;
        if (null !== n) for(e.callbacks = null, e = 0; e < n.length; e++)mo(n[e], t);
    }
    var bo = O(null), yo = O(0);
    function vo(e, t) {
        W(yo, e = pu), W(bo, t), pu = e | t.baseLanes;
    }
    function Io() {
        W(yo, pu), W(bo, bo.current);
    }
    function Mo() {
        pu = yo.current, Q(bo), Q(yo);
    }
    var Eo = 0, xo = null, So = null, wo = null, ko = !1, No = !1, Uo = !1, Ro = 0, Lo = 0, Co = null, zo = 0;
    function To() {
        throw Error(r(321));
    }
    function Do(e, t) {
        if (null === t) return !1;
        for(var n = 0; n < t.length && n < e.length; n++)if (!_n(e[n], t[n])) return !1;
        return !0;
    }
    function Fo(e, t, n, r, i, o) {
        return Eo = o, xo = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, T.H = null === e || null === e.memoizedState ? Pa : Ja, Uo = !1, o = n(r, i), Uo = !1, No && (o = Ao(t, n, r, i)), Vo(e), o;
    }
    function Vo(e) {
        T.H = Xa;
        var t = null !== So && null !== So.next;
        if (Eo = 0, wo = So = xo = null, ko = !1, Lo = 0, Co = null, t) throw Error(r(300));
        null === e || Ll || null !== (e = e.dependencies) && Ni(e) && (Ll = !0);
    }
    function Ao(e, t, n, i) {
        xo = e;
        var o = 0;
        do {
            if (No && (Co = null), Lo = 0, No = !1, 25 <= o) throw Error(r(301));
            if (o += 1, wo = So = null, null != e.updateQueue) {
                var a = e.updateQueue;
                a.lastEffect = null, a.events = null, a.stores = null, null != a.memoCache && (a.memoCache.index = 0);
            }
            T.H = Ha, a = t(n, i);
        }while (No);
        return a;
    }
    function jo() {
        var e = T.H, t = e.useState()[0];
        return t = "function" == typeof t.then ? Bo(t) : t, e = e.useState()[0], (null !== So ? So.memoizedState : null) !== e && (xo.flags |= 1024), t;
    }
    function Oo() {
        var e = 0 !== Ro;
        return Ro = 0, e;
    }
    function Qo(e, t, n) {
        t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
    }
    function qo(e) {
        if (ko) {
            for(e = e.memoizedState; null !== e;){
                var t = e.queue;
                null !== t && (t.pending = null), e = e.next;
            }
            ko = !1;
        }
        Eo = 0, wo = So = xo = null, No = !1, Lo = Ro = 0, Co = null;
    }
    function Wo() {
        var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        return null === wo ? xo.memoizedState = wo = e : wo = wo.next = e, wo;
    }
    function Go() {
        if (null === So) {
            var e = xo.alternate;
            e = null !== e ? e.memoizedState : null;
        } else e = So.next;
        var t = null === wo ? xo.memoizedState : wo.next;
        if (null !== t) wo = t, So = e;
        else {
            if (null === e) {
                if (null === xo.alternate) throw Error(r(467));
                throw Error(r(310));
            }
            e = {
                memoizedState: (So = e).memoizedState,
                baseState: So.baseState,
                baseQueue: So.baseQueue,
                queue: So.queue,
                next: null
            }, null === wo ? xo.memoizedState = wo = e : wo = wo.next = e;
        }
        return wo;
    }
    function Bo(e) {
        var t = Lo;
        return Lo += 1, null === Co && (Co = []), e = eo(Co, e, t), t = xo, null === (null === wo ? t.memoizedState : wo.next) && (t = t.alternate, T.H = null === t || null === t.memoizedState ? Pa : Ja), e;
    }
    function Ko(e) {
        if (null !== e && "object" == typeof e) {
            if ("function" == typeof e.then) return Bo(e);
            if (e.$$typeof === y) return Ri(e);
        }
        throw Error(r(438, String(e)));
    }
    function Yo(e) {
        var t = null, n = xo.updateQueue;
        if (null !== n && (t = n.memoCache), null == t) {
            var r = xo.alternate;
            null !== r && null !== (r = r.updateQueue) && null != (r = r.memoCache) && (t = {
                data: r.data.map(function(e) {
                    return e.slice();
                }),
                index: 0
            });
        }
        if (null == t && (t = {
            data: [],
            index: 0
        }), null === n && (n = {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null
        }, xo.updateQueue = n), n.memoCache = t, void 0 === (n = t.data[t.index])) for(n = t.data[t.index] = Array(e), r = 0; r < e; r++)n[r] = N;
        return t.index++, n;
    }
    function Zo(e, t) {
        return "function" == typeof t ? t(e) : t;
    }
    function Xo(e) {
        return Po(Go(), So, e);
    }
    function Po(e, t, n) {
        var i = e.queue;
        if (null === i) throw Error(r(311));
        i.lastRenderedReducer = n;
        var o = e.baseQueue, a = i.pending;
        if (null !== a) {
            if (null !== o) {
                var l = o.next;
                o.next = a.next, a.next = l;
            }
            t.baseQueue = o = a, i.pending = null;
        }
        if (a = e.baseState, null === o) e.memoizedState = a;
        else {
            var s = l = null, u = null, c = t = o.next, d = !1;
            do {
                var f = -536870913 & c.lane;
                if (f !== c.lane ? (su & f) === f : (Eo & f) === f) {
                    var h = c.revertLane;
                    if (0 === h) null !== u && (u = u.next = {
                        lane: 0,
                        revertLane: 0,
                        action: c.action,
                        hasEagerState: c.hasEagerState,
                        eagerState: c.eagerState,
                        next: null
                    }), f === Qi && (d = !0);
                    else {
                        if ((Eo & h) === h) {
                            c = c.next, h === Qi && (d = !0);
                            continue;
                        }
                        f = {
                            lane: 0,
                            revertLane: c.revertLane,
                            action: c.action,
                            hasEagerState: c.hasEagerState,
                            eagerState: c.eagerState,
                            next: null
                        }, null === u ? (s = u = f, l = a) : u = u.next = f, xo.lanes |= h, gu |= h;
                    }
                    f = c.action, Uo && n(a, f), a = c.hasEagerState ? c.eagerState : n(a, f);
                } else h = {
                    lane: f,
                    revertLane: c.revertLane,
                    action: c.action,
                    hasEagerState: c.hasEagerState,
                    eagerState: c.eagerState,
                    next: null
                }, null === u ? (s = u = h, l = a) : u = u.next = h, xo.lanes |= f, gu |= f;
                c = c.next;
            }while (null !== c && c !== t);
            if (null === u ? l = a : u.next = s, !_n(a, e.memoizedState) && (Ll = !0, d && null !== (n = qi))) throw n;
            e.memoizedState = a, e.baseState = l, e.baseQueue = u, i.lastRenderedState = a;
        }
        return null === o && (i.lanes = 0), [
            e.memoizedState,
            i.dispatch
        ];
    }
    function Jo(e) {
        var t = Go(), n = t.queue;
        if (null === n) throw Error(r(311));
        n.lastRenderedReducer = e;
        var i = n.dispatch, o = n.pending, a = t.memoizedState;
        if (null !== o) {
            n.pending = null;
            var l = o = o.next;
            do a = e(a, l.action), l = l.next;
            while (l !== o);
            _n(a, t.memoizedState) || (Ll = !0), t.memoizedState = a, null === t.baseQueue && (t.baseState = a), n.lastRenderedState = a;
        }
        return [
            a,
            i
        ];
    }
    function Ho(e, t, n) {
        var i = xo, o = Go(), a = si;
        if (a) {
            if (void 0 === n) throw Error(r(407));
            n = n();
        } else n = t();
        var l = !_n((So || o).memoizedState, n);
        if (l && (o.memoizedState = n, Ll = !0), o = o.queue, Ia(2048, 8, ea.bind(null, i, o, e), [
            e
        ]), o.getSnapshot !== t || l || null !== wo && 1 & wo.memoizedState.tag) {
            if (i.flags |= 2048, ba(9, {
                destroy: void 0,
                resource: void 0
            }, $o.bind(null, i, o, n, t), null), null === au) throw Error(r(349));
            a || 124 & Eo || _o(i, t, n);
        }
        return n;
    }
    function _o(e, t, n) {
        e.flags |= 16384, e = {
            getSnapshot: t,
            value: n
        }, null === (t = xo.updateQueue) ? (t = {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null
        }, xo.updateQueue = t, t.stores = [
            e
        ]) : null === (n = t.stores) ? t.stores = [
            e
        ] : n.push(e);
    }
    function $o(e, t, n, r) {
        t.value = n, t.getSnapshot = r, ta(t) && na(e);
    }
    function ea(e, t, n) {
        return n(function() {
            ta(t) && na(e);
        });
    }
    function ta(e) {
        var t = e.getSnapshot;
        e = e.value;
        try {
            var n = t();
            return !_n(e, n);
        } catch (e) {
            return !0;
        }
    }
    function na(e) {
        var t = Dr(e, 2);
        null !== t && Ou(t, e, 2);
    }
    function ra(e) {
        var t = Wo();
        if ("function" == typeof e) {
            var n = e;
            if (e = n(), Uo) {
                pe(!0);
                try {
                    n();
                } finally{
                    pe(!1);
                }
            }
        }
        return t.memoizedState = t.baseState = e, t.queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: Zo,
            lastRenderedState: e
        }, t;
    }
    function ia(e, t, n, r) {
        return e.baseState = n, Po(e, So, "function" == typeof r ? r : Zo);
    }
    function oa(e, t, n, i, o) {
        if (Ka(e)) throw Error(r(485));
        if (null !== (e = t.action)) {
            var a = {
                payload: o,
                action: e,
                next: null,
                isTransition: !0,
                status: "pending",
                value: null,
                reason: null,
                listeners: [],
                then: function(e) {
                    a.listeners.push(e);
                }
            };
            null !== T.T ? n(!0) : a.isTransition = !1, i(a), null === (n = t.pending) ? (a.next = t.pending = a, aa(t, a)) : (a.next = n.next, t.pending = n.next = a);
        }
    }
    function aa(e, t) {
        var n = t.action, r = t.payload, i = e.state;
        if (t.isTransition) {
            var o = T.T, a = {};
            T.T = a;
            try {
                var l = n(i, r), s = T.S;
                null !== s && s(a, l), la(e, t, l);
            } catch (n) {
                ua(e, t, n);
            } finally{
                T.T = o;
            }
        } else try {
            la(e, t, o = n(i, r));
        } catch (n) {
            ua(e, t, n);
        }
    }
    function la(e, t, n) {
        null !== n && "object" == typeof n && "function" == typeof n.then ? n.then(function(n) {
            sa(e, t, n);
        }, function(n) {
            return ua(e, t, n);
        }) : sa(e, t, n);
    }
    function sa(e, t, n) {
        t.status = "fulfilled", t.value = n, ca(t), e.state = n, null !== (t = e.pending) && ((n = t.next) === t ? e.pending = null : (n = n.next, t.next = n, aa(e, n)));
    }
    function ua(e, t, n) {
        var r = e.pending;
        if (e.pending = null, null !== r) {
            r = r.next;
            do t.status = "rejected", t.reason = n, ca(t), t = t.next;
            while (t !== r);
        }
        e.action = null;
    }
    function ca(e) {
        e = e.listeners;
        for(var t = 0; t < e.length; t++)(0, e[t])();
    }
    function da(e, t) {
        return t;
    }
    function fa(e, t) {
        if (si) {
            var n = au.formState;
            if (null !== n) {
                e: {
                    var r = xo;
                    if (si) {
                        if (li) {
                            t: {
                                for(var i = li, o = ci; 8 !== i.nodeType;){
                                    if (!o) {
                                        i = null;
                                        break t;
                                    }
                                    if (null === (i = Id(i.nextSibling))) {
                                        i = null;
                                        break t;
                                    }
                                }
                                i = "F!" === (o = i.data) || "F" === o ? i : null;
                            }
                            if (i) {
                                li = Id(i.nextSibling), r = "F!" === i.data;
                                break e;
                            }
                        }
                        fi(r);
                    }
                    r = !1;
                }
                r && (t = n[0]);
            }
        }
        return (n = Wo()).memoizedState = n.baseState = t, r = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: da,
            lastRenderedState: t
        }, n.queue = r, n = Wa.bind(null, xo, r), r.dispatch = n, r = ra(!1), o = Ba.bind(null, xo, !1, r.queue), i = {
            state: t,
            dispatch: null,
            action: e,
            pending: null
        }, (r = Wo()).queue = i, n = oa.bind(null, xo, i, o, n), i.dispatch = n, r.memoizedState = e, [
            t,
            n,
            !1
        ];
    }
    function ha(e) {
        return pa(Go(), So, e);
    }
    function pa(e, t, n) {
        if (t = Po(e, t, da)[0], e = Xo(Zo)[0], "object" == typeof t && null !== t && "function" == typeof t.then) try {
            var r = Bo(t);
        } catch (e) {
            if (e === Xi) throw Ji;
            throw e;
        }
        else r = t;
        var i = (t = Go()).queue, o = i.dispatch;
        return n !== t.memoizedState && (xo.flags |= 2048, ba(9, {
            destroy: void 0,
            resource: void 0
        }, ma.bind(null, i, n), null)), [
            r,
            o,
            e
        ];
    }
    function ma(e, t) {
        e.action = t;
    }
    function ga(e) {
        var t = Go(), n = So;
        if (null !== n) return pa(t, n, e);
        Go(), t = t.memoizedState;
        var r = (n = Go()).queue.dispatch;
        return n.memoizedState = e, [
            t,
            r,
            !1
        ];
    }
    function ba(e, t, n, r) {
        return e = {
            tag: e,
            create: n,
            deps: r,
            inst: t,
            next: null
        }, null === (t = xo.updateQueue) && (t = {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null
        }, xo.updateQueue = t), null === (n = t.lastEffect) ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
    }
    function ya() {
        return Go().memoizedState;
    }
    function va(e, t, n, r) {
        var i = Wo();
        r = void 0 === r ? null : r, xo.flags |= e, i.memoizedState = ba(1 | t, {
            destroy: void 0,
            resource: void 0
        }, n, r);
    }
    function Ia(e, t, n, r) {
        var i = Go();
        r = void 0 === r ? null : r;
        var o = i.memoizedState.inst;
        null !== So && null !== r && Do(r, So.memoizedState.deps) ? i.memoizedState = ba(t, o, n, r) : (xo.flags |= e, i.memoizedState = ba(1 | t, o, n, r));
    }
    function Ma(e, t) {
        va(8390656, 8, e, t);
    }
    function Ea(e, t) {
        Ia(2048, 8, e, t);
    }
    function xa(e, t) {
        return Ia(4, 2, e, t);
    }
    function Sa(e, t) {
        return Ia(4, 4, e, t);
    }
    function wa(e, t) {
        if ("function" == typeof t) {
            e = e();
            var n = t(e);
            return function() {
                "function" == typeof n ? n() : t(null);
            };
        }
        if (null != t) return e = e(), t.current = e, function() {
            t.current = null;
        };
    }
    function ka(e, t, n) {
        n = null != n ? n.concat([
            e
        ]) : null, Ia(4, 4, wa.bind(null, t, e), n);
    }
    function Na() {}
    function Ua(e, t) {
        var n = Go();
        t = void 0 === t ? null : t;
        var r = n.memoizedState;
        return null !== t && Do(t, r[1]) ? r[0] : (n.memoizedState = [
            e,
            t
        ], e);
    }
    function Ra(e, t) {
        var n = Go();
        t = void 0 === t ? null : t;
        var r = n.memoizedState;
        if (null !== t && Do(t, r[1])) return r[0];
        if (r = e(), Uo) {
            pe(!0);
            try {
                e();
            } finally{
                pe(!1);
            }
        }
        return n.memoizedState = [
            r,
            t
        ], r;
    }
    function La(e, t, n) {
        return void 0 === n || 1073741824 & Eo ? e.memoizedState = t : (e.memoizedState = n, e = ju(), xo.lanes |= e, gu |= e, n);
    }
    function Ca(e, t, n, r) {
        return _n(n, t) ? n : null !== bo.current ? (e = La(e, n, r), _n(e, t) || (Ll = !0), e) : 42 & Eo ? (e = ju(), xo.lanes |= e, gu |= e, t) : (Ll = !0, e.memoizedState = n);
    }
    function za(e, t, n, r, i) {
        var o = F.p;
        F.p = 0 !== o && 8 > o ? o : 8;
        var a, l, s, u = T.T, c = {};
        T.T = c, Ba(e, !1, t, n);
        try {
            var d = i(), f = T.S;
            if (null !== f && f(c, d), null !== d && "object" == typeof d && "function" == typeof d.then) Ga(e, t, (a = r, l = [], s = {
                status: "pending",
                value: null,
                reason: null,
                then: function(e) {
                    l.push(e);
                }
            }, d.then(function() {
                s.status = "fulfilled", s.value = a;
                for(var e = 0; e < l.length; e++)(0, l[e])(a);
            }, function(e) {
                for(s.status = "rejected", s.reason = e, e = 0; e < l.length; e++)(0, l[e])(void 0);
            }), s), Au());
            else Ga(e, t, r, Au());
        } catch (n) {
            Ga(e, t, {
                then: function() {},
                status: "rejected",
                reason: n
            }, Au());
        } finally{
            F.p = o, T.T = u;
        }
    }
    function Ta() {}
    function Da(e, t, n, i) {
        if (5 !== e.tag) throw Error(r(476));
        var o = Fa(e).queue;
        za(e, o, t, V, null === n ? Ta : function() {
            return Va(e), n(i);
        });
    }
    function Fa(e) {
        var t = e.memoizedState;
        if (null !== t) return t;
        var n = {};
        return (t = {
            memoizedState: V,
            baseState: V,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Zo,
                lastRenderedState: V
            },
            next: null
        }).next = {
            memoizedState: n,
            baseState: n,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Zo,
                lastRenderedState: n
            },
            next: null
        }, e.memoizedState = t, null !== (e = e.alternate) && (e.memoizedState = t), t;
    }
    function Va(e) {
        Ga(e, Fa(e).next.queue, {}, Au());
    }
    function Aa() {
        return Ri(Hd);
    }
    function ja() {
        return Go().memoizedState;
    }
    function Oa() {
        return Go().memoizedState;
    }
    function Qa(e) {
        for(var t = e.return; null !== t;){
            switch(t.tag){
                case 24:
                case 3:
                    var n = Au(), r = so(t, e = lo(n), n);
                    return null !== r && (Ou(r, t, n), uo(r, t, n)), t = {
                        cache: Vi()
                    }, void (e.payload = t);
            }
            t = t.return;
        }
    }
    function qa(e, t, n) {
        var r = Au();
        n = {
            lane: r,
            revertLane: 0,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null
        }, Ka(e) ? Ya(t, n) : null !== (n = Tr(e, t, n, r)) && (Ou(n, e, r), Za(n, t, r));
    }
    function Wa(e, t, n) {
        Ga(e, t, n, Au());
    }
    function Ga(e, t, n, r) {
        var i = {
            lane: r,
            revertLane: 0,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (Ka(e)) Ya(t, i);
        else {
            var o = e.alternate;
            if (0 === e.lanes && (null === o || 0 === o.lanes) && null !== (o = t.lastRenderedReducer)) try {
                var a = t.lastRenderedState, l = o(a, n);
                if (i.hasEagerState = !0, i.eagerState = l, _n(l, a)) return zr(e, t, i, 0), null === au && Cr(), !1;
            } catch (e) {}
            if (null !== (n = Tr(e, t, i, r))) return Ou(n, e, r), Za(n, t, r), !0;
        }
        return !1;
    }
    function Ba(e, t, n, i) {
        if (i = {
            lane: 2,
            revertLane: zc(),
            action: i,
            hasEagerState: !1,
            eagerState: null,
            next: null
        }, Ka(e)) {
            if (t) throw Error(r(479));
        } else null !== (t = Tr(e, n, i, 2)) && Ou(t, e, 2);
    }
    function Ka(e) {
        var t = e.alternate;
        return e === xo || null !== t && t === xo;
    }
    function Ya(e, t) {
        No = ko = !0;
        var n = e.pending;
        null === n ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
    }
    function Za(e, t, n) {
        if (4194048 & n) {
            var r = t.lanes;
            n |= r &= e.pendingLanes, t.lanes = n, Re(e, n);
        }
    }
    var Xa = {
        readContext: Ri,
        use: Ko,
        useCallback: To,
        useContext: To,
        useEffect: To,
        useImperativeHandle: To,
        useLayoutEffect: To,
        useInsertionEffect: To,
        useMemo: To,
        useReducer: To,
        useRef: To,
        useState: To,
        useDebugValue: To,
        useDeferredValue: To,
        useTransition: To,
        useSyncExternalStore: To,
        useId: To,
        useHostTransitionStatus: To,
        useFormState: To,
        useActionState: To,
        useOptimistic: To,
        useMemoCache: To,
        useCacheRefresh: To
    }, Pa = {
        readContext: Ri,
        use: Ko,
        useCallback: function(e, t) {
            return Wo().memoizedState = [
                e,
                void 0 === t ? null : t
            ], e;
        },
        useContext: Ri,
        useEffect: Ma,
        useImperativeHandle: function(e, t, n) {
            n = null != n ? n.concat([
                e
            ]) : null, va(4194308, 4, wa.bind(null, t, e), n);
        },
        useLayoutEffect: function(e, t) {
            return va(4194308, 4, e, t);
        },
        useInsertionEffect: function(e, t) {
            va(4, 2, e, t);
        },
        useMemo: function(e, t) {
            var n = Wo();
            t = void 0 === t ? null : t;
            var r = e();
            if (Uo) {
                pe(!0);
                try {
                    e();
                } finally{
                    pe(!1);
                }
            }
            return n.memoizedState = [
                r,
                t
            ], r;
        },
        useReducer: function(e, t, n) {
            var r = Wo();
            if (void 0 !== n) {
                var i = n(t);
                if (Uo) {
                    pe(!0);
                    try {
                        n(t);
                    } finally{
                        pe(!1);
                    }
                }
            } else i = t;
            return r.memoizedState = r.baseState = i, e = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: e,
                lastRenderedState: i
            }, r.queue = e, e = e.dispatch = qa.bind(null, xo, e), [
                r.memoizedState,
                e
            ];
        },
        useRef: function(e) {
            return e = {
                current: e
            }, Wo().memoizedState = e;
        },
        useState: function(e) {
            var t = (e = ra(e)).queue, n = Wa.bind(null, xo, t);
            return t.dispatch = n, [
                e.memoizedState,
                n
            ];
        },
        useDebugValue: Na,
        useDeferredValue: function(e, t) {
            return La(Wo(), e, t);
        },
        useTransition: function() {
            var e = ra(!1);
            return e = za.bind(null, xo, e.queue, !0, !1), Wo().memoizedState = e, [
                !1,
                e
            ];
        },
        useSyncExternalStore: function(e, t, n) {
            var i = xo, o = Wo();
            if (si) {
                if (void 0 === n) throw Error(r(407));
                n = n();
            } else {
                if (n = t(), null === au) throw Error(r(349));
                124 & su || _o(i, t, n);
            }
            o.memoizedState = n;
            var a = {
                value: n,
                getSnapshot: t
            };
            return o.queue = a, Ma(ea.bind(null, i, a, e), [
                e
            ]), i.flags |= 2048, ba(9, {
                destroy: void 0,
                resource: void 0
            }, $o.bind(null, i, a, n, t), null), n;
        },
        useId: function() {
            var e = Wo(), t = au.identifierPrefix;
            if (si) {
                var n = ti;
                t = "\xab" + t + "R" + (n = (ei & ~(1 << 32 - me(ei) - 1)).toString(32) + n), 0 < (n = Ro++) && (t += "H" + n.toString(32)), t += "\xbb";
            } else t = "\xab" + t + "r" + (n = zo++).toString(32) + "\xbb";
            return e.memoizedState = t;
        },
        useHostTransitionStatus: Aa,
        useFormState: fa,
        useActionState: fa,
        useOptimistic: function(e) {
            var t = Wo();
            t.memoizedState = t.baseState = e;
            var n = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: null,
                lastRenderedState: null
            };
            return t.queue = n, t = Ba.bind(null, xo, !0, n), n.dispatch = t, [
                e,
                t
            ];
        },
        useMemoCache: Yo,
        useCacheRefresh: function() {
            return Wo().memoizedState = Qa.bind(null, xo);
        }
    }, Ja = {
        readContext: Ri,
        use: Ko,
        useCallback: Ua,
        useContext: Ri,
        useEffect: Ea,
        useImperativeHandle: ka,
        useInsertionEffect: xa,
        useLayoutEffect: Sa,
        useMemo: Ra,
        useReducer: Xo,
        useRef: ya,
        useState: function() {
            return Xo(Zo);
        },
        useDebugValue: Na,
        useDeferredValue: function(e, t) {
            return Ca(Go(), So.memoizedState, e, t);
        },
        useTransition: function() {
            var e = Xo(Zo)[0], t = Go().memoizedState;
            return [
                "boolean" == typeof e ? e : Bo(e),
                t
            ];
        },
        useSyncExternalStore: Ho,
        useId: ja,
        useHostTransitionStatus: Aa,
        useFormState: ha,
        useActionState: ha,
        useOptimistic: function(e, t) {
            return ia(Go(), 0, e, t);
        },
        useMemoCache: Yo,
        useCacheRefresh: Oa
    }, Ha = {
        readContext: Ri,
        use: Ko,
        useCallback: Ua,
        useContext: Ri,
        useEffect: Ea,
        useImperativeHandle: ka,
        useInsertionEffect: xa,
        useLayoutEffect: Sa,
        useMemo: Ra,
        useReducer: Jo,
        useRef: ya,
        useState: function() {
            return Jo(Zo);
        },
        useDebugValue: Na,
        useDeferredValue: function(e, t) {
            var n = Go();
            return null === So ? La(n, e, t) : Ca(n, So.memoizedState, e, t);
        },
        useTransition: function() {
            var e = Jo(Zo)[0], t = Go().memoizedState;
            return [
                "boolean" == typeof e ? e : Bo(e),
                t
            ];
        },
        useSyncExternalStore: Ho,
        useId: ja,
        useHostTransitionStatus: Aa,
        useFormState: ga,
        useActionState: ga,
        useOptimistic: function(e, t) {
            var n = Go();
            return null !== So ? ia(n, 0, e, t) : (n.baseState = e, [
                e,
                n.queue.dispatch
            ]);
        },
        useMemoCache: Yo,
        useCacheRefresh: Oa
    }, _a = null, $a = 0;
    function el(e) {
        var t = $a;
        return $a += 1, null === _a && (_a = []), eo(_a, e, t);
    }
    function tl(e, t) {
        t = t.props.ref, e.ref = void 0 !== t ? t : null;
    }
    function nl(e, t) {
        if (t.$$typeof === c) throw Error(r(525));
        throw e = Object.prototype.toString.call(t), Error(r(31, "[object Object]" === e ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
    }
    function rl(e) {
        return (0, e._init)(e._payload);
    }
    function il(e) {
        function t(t, n) {
            if (e) {
                var r = t.deletions;
                null === r ? (t.deletions = [
                    n
                ], t.flags |= 16) : r.push(n);
            }
        }
        function n(n, r) {
            if (!e) return null;
            for(; null !== r;)t(n, r), r = r.sibling;
            return null;
        }
        function i(e) {
            for(var t = new Map; null !== e;)null !== e.key ? t.set(e.key, e) : t.set(e.index, e), e = e.sibling;
            return t;
        }
        function o(e, t) {
            return (e = qr(e, t)).index = 0, e.sibling = null, e;
        }
        function a(t, n, r) {
            return t.index = r, e ? null !== (r = t.alternate) ? (r = r.index) < n ? (t.flags |= 67108866, n) : r : (t.flags |= 67108866, n) : (t.flags |= 1048576, n);
        }
        function l(t) {
            return e && null === t.alternate && (t.flags |= 67108866), t;
        }
        function s(e, t, n, r) {
            return null === t || 6 !== t.tag ? ((t = Kr(n, e.mode, r)).return = e, t) : ((t = o(t, n)).return = e, t);
        }
        function u(e, t, n, r) {
            var i = n.type;
            return i === h ? p(e, t, n.props.children, r, n.key) : null !== t && (t.elementType === i || "object" == typeof i && null !== i && i.$$typeof === S && rl(i) === t.type) ? (tl(t = o(t, n.props), n), t.return = e, t) : (tl(t = Gr(n.type, n.key, n.props, null, e.mode, r), n), t.return = e, t);
        }
        function c(e, t, n, r) {
            return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = Yr(n, e.mode, r)).return = e, t) : ((t = o(t, n.children || [])).return = e, t);
        }
        function p(e, t, n, r, i) {
            return null === t || 7 !== t.tag ? ((t = Br(n, e.mode, r, i)).return = e, t) : ((t = o(t, n)).return = e, t);
        }
        function m(e, t, n) {
            if ("string" == typeof t && "" !== t || "number" == typeof t || "bigint" == typeof t) return (t = Kr("" + t, e.mode, n)).return = e, t;
            if ("object" == typeof t && null !== t) {
                switch(t.$$typeof){
                    case d:
                        return tl(n = Gr(t.type, t.key, t.props, null, e.mode, n), t), n.return = e, n;
                    case f:
                        return (t = Yr(t, e.mode, n)).return = e, t;
                    case S:
                        return m(e, t = (0, t._init)(t._payload), n);
                }
                if (z(t) || R(t)) return (t = Br(t, e.mode, n, null)).return = e, t;
                if ("function" == typeof t.then) return m(e, el(t), n);
                if (t.$$typeof === y) return m(e, Li(e, t), n);
                nl(e, t);
            }
            return null;
        }
        function g(e, t, n, r) {
            var i = null !== t ? t.key : null;
            if ("string" == typeof n && "" !== n || "number" == typeof n || "bigint" == typeof n) return null !== i ? null : s(e, t, "" + n, r);
            if ("object" == typeof n && null !== n) {
                switch(n.$$typeof){
                    case d:
                        return n.key === i ? u(e, t, n, r) : null;
                    case f:
                        return n.key === i ? c(e, t, n, r) : null;
                    case S:
                        return g(e, t, n = (i = n._init)(n._payload), r);
                }
                if (z(n) || R(n)) return null !== i ? null : p(e, t, n, r, null);
                if ("function" == typeof n.then) return g(e, t, el(n), r);
                if (n.$$typeof === y) return g(e, t, Li(e, n), r);
                nl(e, n);
            }
            return null;
        }
        function b(e, t, n, r, i) {
            if ("string" == typeof r && "" !== r || "number" == typeof r || "bigint" == typeof r) return s(t, e = e.get(n) || null, "" + r, i);
            if ("object" == typeof r && null !== r) {
                switch(r.$$typeof){
                    case d:
                        return u(t, e = e.get(null === r.key ? n : r.key) || null, r, i);
                    case f:
                        return c(t, e = e.get(null === r.key ? n : r.key) || null, r, i);
                    case S:
                        return b(e, t, n, r = (0, r._init)(r._payload), i);
                }
                if (z(r) || R(r)) return p(t, e = e.get(n) || null, r, i, null);
                if ("function" == typeof r.then) return b(e, t, n, el(r), i);
                if (r.$$typeof === y) return b(e, t, n, Li(t, r), i);
                nl(t, r);
            }
            return null;
        }
        function v(s, u, c, p) {
            if ("object" == typeof c && null !== c && c.type === h && null === c.key && (c = c.props.children), "object" == typeof c && null !== c) {
                switch(c.$$typeof){
                    case d:
                        e: {
                            for(var I = c.key; null !== u;){
                                if (u.key === I) {
                                    if ((I = c.type) === h) {
                                        if (7 === u.tag) {
                                            n(s, u.sibling), (p = o(u, c.props.children)).return = s, s = p;
                                            break e;
                                        }
                                    } else if (u.elementType === I || "object" == typeof I && null !== I && I.$$typeof === S && rl(I) === u.type) {
                                        n(s, u.sibling), tl(p = o(u, c.props), c), p.return = s, s = p;
                                        break e;
                                    }
                                    n(s, u);
                                    break;
                                }
                                t(s, u), u = u.sibling;
                            }
                            c.type === h ? ((p = Br(c.props.children, s.mode, p, c.key)).return = s, s = p) : (tl(p = Gr(c.type, c.key, c.props, null, s.mode, p), c), p.return = s, s = p);
                        }
                        return l(s);
                    case f:
                        e: {
                            for(I = c.key; null !== u;){
                                if (u.key === I) {
                                    if (4 === u.tag && u.stateNode.containerInfo === c.containerInfo && u.stateNode.implementation === c.implementation) {
                                        n(s, u.sibling), (p = o(u, c.children || [])).return = s, s = p;
                                        break e;
                                    }
                                    n(s, u);
                                    break;
                                }
                                t(s, u), u = u.sibling;
                            }
                            (p = Yr(c, s.mode, p)).return = s, s = p;
                        }
                        return l(s);
                    case S:
                        return v(s, u, c = (I = c._init)(c._payload), p);
                }
                if (z(c)) return function(r, o, l, s) {
                    for(var u = null, c = null, d = o, f = o = 0, h = null; null !== d && f < l.length; f++){
                        d.index > f ? (h = d, d = null) : h = d.sibling;
                        var p = g(r, d, l[f], s);
                        if (null === p) {
                            null === d && (d = h);
                            break;
                        }
                        e && d && null === p.alternate && t(r, d), o = a(p, o, f), null === c ? u = p : c.sibling = p, c = p, d = h;
                    }
                    if (f === l.length) return n(r, d), si && ni(r, f), u;
                    if (null === d) {
                        for(; f < l.length; f++)null !== (d = m(r, l[f], s)) && (o = a(d, o, f), null === c ? u = d : c.sibling = d, c = d);
                        return si && ni(r, f), u;
                    }
                    for(d = i(d); f < l.length; f++)null !== (h = b(d, r, f, l[f], s)) && (e && null !== h.alternate && d.delete(null === h.key ? f : h.key), o = a(h, o, f), null === c ? u = h : c.sibling = h, c = h);
                    return e && d.forEach(function(e) {
                        return t(r, e);
                    }), si && ni(r, f), u;
                }(s, u, c, p);
                if (R(c)) {
                    if ("function" != typeof (I = R(c))) throw Error(r(150));
                    return function(o, l, s, u) {
                        if (null == s) throw Error(r(151));
                        for(var c = null, d = null, f = l, h = l = 0, p = null, y = s.next(); null !== f && !y.done; h++, y = s.next()){
                            f.index > h ? (p = f, f = null) : p = f.sibling;
                            var v = g(o, f, y.value, u);
                            if (null === v) {
                                null === f && (f = p);
                                break;
                            }
                            e && f && null === v.alternate && t(o, f), l = a(v, l, h), null === d ? c = v : d.sibling = v, d = v, f = p;
                        }
                        if (y.done) return n(o, f), si && ni(o, h), c;
                        if (null === f) {
                            for(; !y.done; h++, y = s.next())null !== (y = m(o, y.value, u)) && (l = a(y, l, h), null === d ? c = y : d.sibling = y, d = y);
                            return si && ni(o, h), c;
                        }
                        for(f = i(f); !y.done; h++, y = s.next())null !== (y = b(f, o, h, y.value, u)) && (e && null !== y.alternate && f.delete(null === y.key ? h : y.key), l = a(y, l, h), null === d ? c = y : d.sibling = y, d = y);
                        return e && f.forEach(function(e) {
                            return t(o, e);
                        }), si && ni(o, h), c;
                    }(s, u, c = I.call(c), p);
                }
                if ("function" == typeof c.then) return v(s, u, el(c), p);
                if (c.$$typeof === y) return v(s, u, Li(s, c), p);
                nl(s, c);
            }
            return "string" == typeof c && "" !== c || "number" == typeof c || "bigint" == typeof c ? (c = "" + c, null !== u && 6 === u.tag ? (n(s, u.sibling), (p = o(u, c)).return = s, s = p) : (n(s, u), (p = Kr(c, s.mode, p)).return = s, s = p), l(s)) : n(s, u);
        }
        return function(e, t, n, r) {
            try {
                $a = 0;
                var i = v(e, t, n, r);
                return _a = null, i;
            } catch (t) {
                if (t === Xi || t === Ji) throw t;
                var o = Or(29, t, null, e.mode);
                return o.lanes = r, o.return = e, o;
            }
        };
    }
    var ol = il(!0), al = il(!1), ll = O(null), sl = null;
    function ul(e) {
        var t = e.alternate;
        W(hl, 1 & hl.current), W(ll, e), null === sl && (null === t || null !== bo.current || null !== t.memoizedState) && (sl = e);
    }
    function cl(e) {
        if (22 === e.tag) {
            if (W(hl, hl.current), W(ll, e), null === sl) {
                var t = e.alternate;
                null !== t && null !== t.memoizedState && (sl = e);
            }
        } else dl();
    }
    function dl() {
        W(hl, hl.current), W(ll, ll.current);
    }
    function fl(e) {
        Q(ll), sl === e && (sl = null), Q(hl);
    }
    var hl = O(0);
    function pl(e) {
        for(var t = e; null !== t;){
            if (13 === t.tag) {
                var n = t.memoizedState;
                if (null !== n && (null === (n = n.dehydrated) || "$?" === n.data || vd(n))) return t;
            } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
                if (128 & t.flags) return t;
            } else if (null !== t.child) {
                t.child.return = t, t = t.child;
                continue;
            }
            if (t === e) break;
            for(; null === t.sibling;){
                if (null === t.return || t.return === e) return null;
                t = t.return;
            }
            t.sibling.return = t.return, t = t.sibling;
        }
        return null;
    }
    function ml(e, t, n, r) {
        n = null == (n = n(r, t = e.memoizedState)) ? t : u({}, t, n), e.memoizedState = n, 0 === e.lanes && (e.updateQueue.baseState = n);
    }
    var gl = {
        enqueueSetState: function(e, t, n) {
            e = e._reactInternals;
            var r = Au(), i = lo(r);
            i.payload = t, null != n && (i.callback = n), null !== (t = so(e, i, r)) && (Ou(t, e, r), uo(t, e, r));
        },
        enqueueReplaceState: function(e, t, n) {
            e = e._reactInternals;
            var r = Au(), i = lo(r);
            i.tag = 1, i.payload = t, null != n && (i.callback = n), null !== (t = so(e, i, r)) && (Ou(t, e, r), uo(t, e, r));
        },
        enqueueForceUpdate: function(e, t) {
            e = e._reactInternals;
            var n = Au(), r = lo(n);
            r.tag = 2, null != t && (r.callback = t), null !== (t = so(e, r, n)) && (Ou(t, e, n), uo(t, e, n));
        }
    };
    function bl(e, t, n, r, i, o, a) {
        return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(r, o, a) : !t.prototype || !t.prototype.isPureReactComponent || !$n(n, r) || !$n(i, o);
    }
    function yl(e, t, n, r) {
        e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && gl.enqueueReplaceState(t, t.state, null);
    }
    function vl(e, t) {
        var n = t;
        if ("ref" in t) for(var r in n = {}, t)"ref" !== r && (n[r] = t[r]);
        if (e = e.defaultProps) for(var i in n === t && (n = u({}, n)), e)void 0 === n[i] && (n[i] = e[i]);
        return n;
    }
    var Il = "function" == typeof reportError ? reportError : function(e) {
        if ("object" == typeof window && "function" == typeof window.ErrorEvent) {
            var t = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" == typeof e && null !== e && "string" == typeof e.message ? String(e.message) : String(e),
                error: e
            });
            if (!window.dispatchEvent(t)) return;
        }
        console.error(e);
    };
    function Ml(e) {
        Il(e);
    }
    function El(e) {
        console.error(e);
    }
    function xl(e) {
        Il(e);
    }
    function Sl(e, t) {
        try {
            (0, e.onUncaughtError)(t.value, {
                componentStack: t.stack
            });
        } catch (e) {
            setTimeout(function() {
                throw e;
            });
        }
    }
    function wl(e, t, n) {
        try {
            (0, e.onCaughtError)(n.value, {
                componentStack: n.stack,
                errorBoundary: 1 === t.tag ? t.stateNode : null
            });
        } catch (e) {
            setTimeout(function() {
                throw e;
            });
        }
    }
    function kl(e, t, n) {
        return (n = lo(n)).tag = 3, n.payload = {
            element: null
        }, n.callback = function() {
            Sl(e, t);
        }, n;
    }
    function Nl(e) {
        return (e = lo(e)).tag = 3, e;
    }
    function Ul(e, t, n, r) {
        var i = n.type.getDerivedStateFromError;
        if ("function" == typeof i) {
            var o = r.value;
            e.payload = function() {
                return i(o);
            }, e.callback = function() {
                wl(t, n, r);
            };
        }
        var a = n.stateNode;
        null !== a && "function" == typeof a.componentDidCatch && (e.callback = function() {
            wl(t, n, r), "function" != typeof i && (null === Nu ? Nu = new Set([
                this
            ]) : Nu.add(this));
            var e = r.stack;
            this.componentDidCatch(r.value, {
                componentStack: null !== e ? e : ""
            });
        });
    }
    var Rl = Error(r(461)), Ll = !1;
    function Cl(e, t, n, r) {
        t.child = null === e ? al(t, null, n, r) : ol(t, e.child, n, r);
    }
    function zl(e, t, n, r, i) {
        n = n.render;
        var o = t.ref;
        if ("ref" in r) {
            var a = {};
            for(var l in r)"ref" !== l && (a[l] = r[l]);
        } else a = r;
        return Ui(t), r = Fo(e, t, n, a, o, i), l = Oo(), null === e || Ll ? (si && l && ii(t), t.flags |= 1, Cl(e, t, r, i), t.child) : (Qo(e, t, i), _l(e, t, i));
    }
    function Tl(e, t, n, r, i) {
        if (null === e) {
            var o = n.type;
            return "function" != typeof o || Qr(o) || void 0 !== o.defaultProps || null !== n.compare ? ((e = Gr(n.type, null, r, t, t.mode, i)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = o, Dl(e, t, o, r, i));
        }
        if (o = e.child, !$l(e, i)) {
            var a = o.memoizedProps;
            if ((n = null !== (n = n.compare) ? n : $n)(a, r) && e.ref === t.ref) return _l(e, t, i);
        }
        return t.flags |= 1, (e = qr(o, r)).ref = t.ref, e.return = t, t.child = e;
    }
    function Dl(e, t, n, r, i) {
        if (null !== e) {
            var o = e.memoizedProps;
            if ($n(o, r) && e.ref === t.ref) {
                if (Ll = !1, t.pendingProps = r = o, !$l(e, i)) return t.lanes = e.lanes, _l(e, t, i);
                131072 & e.flags && (Ll = !0);
            }
        }
        return jl(e, t, n, r, i);
    }
    function Fl(e, t, n) {
        var r = t.pendingProps, i = r.children, o = null !== e ? e.memoizedState : null;
        if ("hidden" === r.mode) {
            if (128 & t.flags) {
                if (r = null !== o ? o.baseLanes | n : n, null !== e) {
                    for(i = t.child = e.child, o = 0; null !== i;)o = o | i.lanes | i.childLanes, i = i.sibling;
                    t.childLanes = o & ~r;
                } else t.childLanes = 0, t.child = null;
                return Vl(e, t, r, n);
            }
            if (!(536870912 & n)) return t.lanes = t.childLanes = 536870912, Vl(e, t, null !== o ? o.baseLanes | n : n, n);
            t.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, null !== e && Yi(0, null !== o ? o.cachePool : null), null !== o ? vo(t, o) : Io(), cl(t);
        } else null !== o ? (Yi(0, o.cachePool), vo(t, o), dl(), t.memoizedState = null) : (null !== e && Yi(0, null), Io(), dl());
        return Cl(e, t, i, n), t.child;
    }
    function Vl(e, t, n, r) {
        var i = Ki();
        return i = null === i ? null : {
            parent: Fi._currentValue,
            pool: i
        }, t.memoizedState = {
            baseLanes: n,
            cachePool: i
        }, null !== e && Yi(0, null), Io(), cl(t), null !== e && ki(e, t, r, !0), null;
    }
    function Al(e, t) {
        var n = t.ref;
        if (null === n) null !== e && null !== e.ref && (t.flags |= 4194816);
        else {
            if ("function" != typeof n && "object" != typeof n) throw Error(r(284));
            null !== e && e.ref === n || (t.flags |= 4194816);
        }
    }
    function jl(e, t, n, r, i) {
        return Ui(t), n = Fo(e, t, n, r, void 0, i), r = Oo(), null === e || Ll ? (si && r && ii(t), t.flags |= 1, Cl(e, t, n, i), t.child) : (Qo(e, t, i), _l(e, t, i));
    }
    function Ol(e, t, n, r, i, o) {
        return Ui(t), t.updateQueue = null, n = Ao(t, r, n, i), Vo(e), r = Oo(), null === e || Ll ? (si && r && ii(t), t.flags |= 1, Cl(e, t, n, o), t.child) : (Qo(e, t, o), _l(e, t, o));
    }
    function Ql(e, t, n, r, i) {
        if (Ui(t), null === t.stateNode) {
            var o = Ar, a = n.contextType;
            "object" == typeof a && null !== a && (o = Ri(a)), o = new n(r, o), t.memoizedState = null !== o.state && void 0 !== o.state ? o.state : null, o.updater = gl, t.stateNode = o, o._reactInternals = t, (o = t.stateNode).props = r, o.state = t.memoizedState, o.refs = {}, oo(t), a = n.contextType, o.context = "object" == typeof a && null !== a ? Ri(a) : Ar, o.state = t.memoizedState, "function" == typeof (a = n.getDerivedStateFromProps) && (ml(t, n, a, r), o.state = t.memoizedState), "function" == typeof n.getDerivedStateFromProps || "function" == typeof o.getSnapshotBeforeUpdate || "function" != typeof o.UNSAFE_componentWillMount && "function" != typeof o.componentWillMount || (a = o.state, "function" == typeof o.componentWillMount && o.componentWillMount(), "function" == typeof o.UNSAFE_componentWillMount && o.UNSAFE_componentWillMount(), a !== o.state && gl.enqueueReplaceState(o, o.state, null), po(t, r, o, i), ho(), o.state = t.memoizedState), "function" == typeof o.componentDidMount && (t.flags |= 4194308), r = !0;
        } else if (null === e) {
            o = t.stateNode;
            var l = t.memoizedProps, s = vl(n, l);
            o.props = s;
            var u = o.context, c = n.contextType;
            a = Ar, "object" == typeof c && null !== c && (a = Ri(c));
            var d = n.getDerivedStateFromProps;
            c = "function" == typeof d || "function" == typeof o.getSnapshotBeforeUpdate, l = t.pendingProps !== l, c || "function" != typeof o.UNSAFE_componentWillReceiveProps && "function" != typeof o.componentWillReceiveProps || (l || u !== a) && yl(t, o, r, a), io = !1;
            var f = t.memoizedState;
            o.state = f, po(t, r, o, i), ho(), u = t.memoizedState, l || f !== u || io ? ("function" == typeof d && (ml(t, n, d, r), u = t.memoizedState), (s = io || bl(t, n, s, r, f, u, a)) ? (c || "function" != typeof o.UNSAFE_componentWillMount && "function" != typeof o.componentWillMount || ("function" == typeof o.componentWillMount && o.componentWillMount(), "function" == typeof o.UNSAFE_componentWillMount && o.UNSAFE_componentWillMount()), "function" == typeof o.componentDidMount && (t.flags |= 4194308)) : ("function" == typeof o.componentDidMount && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = u), o.props = r, o.state = u, o.context = a, r = s) : ("function" == typeof o.componentDidMount && (t.flags |= 4194308), r = !1);
        } else {
            o = t.stateNode, ao(e, t), c = vl(n, a = t.memoizedProps), o.props = c, d = t.pendingProps, f = o.context, u = n.contextType, s = Ar, "object" == typeof u && null !== u && (s = Ri(u)), (u = "function" == typeof (l = n.getDerivedStateFromProps) || "function" == typeof o.getSnapshotBeforeUpdate) || "function" != typeof o.UNSAFE_componentWillReceiveProps && "function" != typeof o.componentWillReceiveProps || (a !== d || f !== s) && yl(t, o, r, s), io = !1, f = t.memoizedState, o.state = f, po(t, r, o, i), ho();
            var h = t.memoizedState;
            a !== d || f !== h || io || null !== e && null !== e.dependencies && Ni(e.dependencies) ? ("function" == typeof l && (ml(t, n, l, r), h = t.memoizedState), (c = io || bl(t, n, c, r, f, h, s) || null !== e && null !== e.dependencies && Ni(e.dependencies)) ? (u || "function" != typeof o.UNSAFE_componentWillUpdate && "function" != typeof o.componentWillUpdate || ("function" == typeof o.componentWillUpdate && o.componentWillUpdate(r, h, s), "function" == typeof o.UNSAFE_componentWillUpdate && o.UNSAFE_componentWillUpdate(r, h, s)), "function" == typeof o.componentDidUpdate && (t.flags |= 4), "function" == typeof o.getSnapshotBeforeUpdate && (t.flags |= 1024)) : ("function" != typeof o.componentDidUpdate || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), "function" != typeof o.getSnapshotBeforeUpdate || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = h), o.props = r, o.state = h, o.context = s, r = c) : ("function" != typeof o.componentDidUpdate || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), "function" != typeof o.getSnapshotBeforeUpdate || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
        }
        return o = r, Al(e, t), r = !!(128 & t.flags), o || r ? (o = t.stateNode, n = r && "function" != typeof n.getDerivedStateFromError ? null : o.render(), t.flags |= 1, null !== e && r ? (t.child = ol(t, e.child, null, i), t.child = ol(t, null, n, i)) : Cl(e, t, n, i), t.memoizedState = o.state, e = t.child) : e = _l(e, t, i), e;
    }
    function ql(e, t, n, r) {
        return gi(), t.flags |= 256, Cl(e, t, n, r), t.child;
    }
    var Wl = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0,
        hydrationErrors: null
    };
    function Gl(e) {
        return {
            baseLanes: e,
            cachePool: Zi()
        };
    }
    function Bl(e, t, n) {
        return e = null !== e ? e.childLanes & ~n : 0, t && (e |= vu), e;
    }
    function Kl(e, t, n) {
        var i, o = t.pendingProps, a = !1, l = !!(128 & t.flags);
        if ((i = l) || (i = (null === e || null !== e.memoizedState) && !!(2 & hl.current)), i && (a = !0, t.flags &= -129), i = !!(32 & t.flags), t.flags &= -33, null === e) {
            if (si) {
                if (a ? ul(t) : dl(), si) {
                    var s, u = li;
                    if (s = u) {
                        e: {
                            for(s = u, u = ci; 8 !== s.nodeType;){
                                if (!u) {
                                    u = null;
                                    break e;
                                }
                                if (null === (s = Id(s.nextSibling))) {
                                    u = null;
                                    break e;
                                }
                            }
                            u = s;
                        }
                        null !== u ? (t.memoizedState = {
                            dehydrated: u,
                            treeContext: null !== $r ? {
                                id: ei,
                                overflow: ti
                            } : null,
                            retryLane: 536870912,
                            hydrationErrors: null
                        }, (s = Or(18, null, null, 0)).stateNode = u, s.return = t, t.child = s, ai = t, li = null, s = !0) : s = !1;
                    }
                    s || fi(t);
                }
                if (null !== (u = t.memoizedState) && null !== (u = u.dehydrated)) return vd(u) ? t.lanes = 32 : t.lanes = 536870912, null;
                fl(t);
            }
            return u = o.children, o = o.fallback, a ? (dl(), u = Zl({
                mode: "hidden",
                children: u
            }, a = t.mode), o = Br(o, a, n, null), u.return = t, o.return = t, u.sibling = o, t.child = u, (a = t.child).memoizedState = Gl(n), a.childLanes = Bl(e, i, n), t.memoizedState = Wl, o) : (ul(t), Yl(t, u));
        }
        if (null !== (s = e.memoizedState) && null !== (u = s.dehydrated)) {
            if (l) 256 & t.flags ? (ul(t), t.flags &= -257, t = Xl(e, t, n)) : null !== t.memoizedState ? (dl(), t.child = e.child, t.flags |= 128, t = null) : (dl(), a = o.fallback, u = t.mode, o = Zl({
                mode: "visible",
                children: o.children
            }, u), (a = Br(a, u, n, null)).flags |= 2, o.return = t, a.return = t, o.sibling = a, t.child = o, ol(t, e.child, null, n), (o = t.child).memoizedState = Gl(n), o.childLanes = Bl(e, i, n), t.memoizedState = Wl, t = a);
            else if (ul(t), vd(u)) {
                if (i = u.nextSibling && u.nextSibling.dataset) var c = i.dgst;
                i = c, (o = Error(r(419))).stack = "", o.digest = i, yi({
                    value: o,
                    source: null,
                    stack: null
                }), t = Xl(e, t, n);
            } else if (Ll || ki(e, t, n, !1), i = 0 !== (n & e.childLanes), Ll || i) {
                if (null !== (i = au) && 0 !== (o = 0 !== ((o = 42 & (o = n & -n) ? 1 : Le(o)) & (i.suspendedLanes | n)) ? 0 : o) && o !== s.retryLane) throw s.retryLane = o, Dr(e, o), Ou(i, e, o), Rl;
                "$?" === u.data || Ju(), t = Xl(e, t, n);
            } else "$?" === u.data ? (t.flags |= 192, t.child = e.child, t = null) : (e = s.treeContext, li = Id(u.nextSibling), ai = t, si = !0, ui = null, ci = !1, null !== e && (Hr[_r++] = ei, Hr[_r++] = ti, Hr[_r++] = $r, ei = e.id, ti = e.overflow, $r = t), (t = Yl(t, o.children)).flags |= 4096);
            return t;
        }
        return a ? (dl(), a = o.fallback, u = t.mode, c = (s = e.child).sibling, (o = qr(s, {
            mode: "hidden",
            children: o.children
        })).subtreeFlags = 65011712 & s.subtreeFlags, null !== c ? a = qr(c, a) : (a = Br(a, u, n, null)).flags |= 2, a.return = t, o.return = t, o.sibling = a, t.child = o, o = a, a = t.child, null === (u = e.child.memoizedState) ? u = Gl(n) : (null !== (s = u.cachePool) ? (c = Fi._currentValue, s = s.parent !== c ? {
            parent: c,
            pool: c
        } : s) : s = Zi(), u = {
            baseLanes: u.baseLanes | n,
            cachePool: s
        }), a.memoizedState = u, a.childLanes = Bl(e, i, n), t.memoizedState = Wl, o) : (ul(t), e = (n = e.child).sibling, (n = qr(n, {
            mode: "visible",
            children: o.children
        })).return = t, n.sibling = null, null !== e && (null === (i = t.deletions) ? (t.deletions = [
            e
        ], t.flags |= 16) : i.push(e)), t.child = n, t.memoizedState = null, n);
    }
    function Yl(e, t) {
        return (t = Zl({
            mode: "visible",
            children: t
        }, e.mode)).return = e, e.child = t;
    }
    function Zl(e, t) {
        return (e = Or(22, e, null, t)).lanes = 0, e.stateNode = {
            _visibility: 1,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        }, e;
    }
    function Xl(e, t, n) {
        return ol(t, e.child, null, n), (e = Yl(t, t.pendingProps.children)).flags |= 2, t.memoizedState = null, e;
    }
    function Pl(e, t, n) {
        e.lanes |= t;
        var r = e.alternate;
        null !== r && (r.lanes |= t), Si(e.return, t, n);
    }
    function Jl(e, t, n, r, i) {
        var o = e.memoizedState;
        null === o ? e.memoizedState = {
            isBackwards: t,
            rendering: null,
            renderingStartTime: 0,
            last: r,
            tail: n,
            tailMode: i
        } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i);
    }
    function Hl(e, t, n) {
        var r = t.pendingProps, i = r.revealOrder, o = r.tail;
        if (Cl(e, t, r.children, n), 2 & (r = hl.current)) r = 1 & r | 2, t.flags |= 128;
        else {
            if (null !== e && 128 & e.flags) e: for(e = t.child; null !== e;){
                if (13 === e.tag) null !== e.memoizedState && Pl(e, n, t);
                else if (19 === e.tag) Pl(e, n, t);
                else if (null !== e.child) {
                    e.child.return = e, e = e.child;
                    continue;
                }
                if (e === t) break e;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === t) break e;
                    e = e.return;
                }
                e.sibling.return = e.return, e = e.sibling;
            }
            r &= 1;
        }
        switch(W(hl, r), i){
            case "forwards":
                for(n = t.child, i = null; null !== n;)null !== (e = n.alternate) && null === pl(e) && (i = n), n = n.sibling;
                null === (n = i) ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), Jl(t, !1, i, n, o);
                break;
            case "backwards":
                for(n = null, i = t.child, t.child = null; null !== i;){
                    if (null !== (e = i.alternate) && null === pl(e)) {
                        t.child = i;
                        break;
                    }
                    e = i.sibling, i.sibling = n, n = i, i = e;
                }
                Jl(t, !0, n, null, o);
                break;
            case "together":
                Jl(t, !1, null, null, void 0);
                break;
            default:
                t.memoizedState = null;
        }
        return t.child;
    }
    function _l(e, t, n) {
        if (null !== e && (t.dependencies = e.dependencies), gu |= t.lanes, 0 === (n & t.childLanes)) {
            if (null === e) return null;
            if (ki(e, t, n, !1), 0 === (n & t.childLanes)) return null;
        }
        if (null !== e && t.child !== e.child) throw Error(r(153));
        if (null !== t.child) {
            for(n = qr(e = t.child, e.pendingProps), t.child = n, n.return = t; null !== e.sibling;)e = e.sibling, (n = n.sibling = qr(e, e.pendingProps)).return = t;
            n.sibling = null;
        }
        return t.child;
    }
    function $l(e, t) {
        return 0 !== (e.lanes & t) || !(null === (e = e.dependencies) || !Ni(e));
    }
    function es(e, t, n) {
        if (null !== e) {
            if (e.memoizedProps !== t.pendingProps) Ll = !0;
            else {
                if (!($l(e, n) || 128 & t.flags)) return Ll = !1, function(e, t, n) {
                    switch(t.tag){
                        case 3:
                            X(t, t.stateNode.containerInfo), Ei(0, Fi, e.memoizedState.cache), gi();
                            break;
                        case 27:
                        case 5:
                            J(t);
                            break;
                        case 4:
                            X(t, t.stateNode.containerInfo);
                            break;
                        case 10:
                            Ei(0, t.type, t.memoizedProps.value);
                            break;
                        case 13:
                            var r = t.memoizedState;
                            if (null !== r) return null !== r.dehydrated ? (ul(t), t.flags |= 128, null) : 0 !== (n & t.child.childLanes) ? Kl(e, t, n) : (ul(t), null !== (e = _l(e, t, n)) ? e.sibling : null);
                            ul(t);
                            break;
                        case 19:
                            var i = !!(128 & e.flags);
                            if ((r = 0 !== (n & t.childLanes)) || (ki(e, t, n, !1), r = 0 !== (n & t.childLanes)), i) {
                                if (r) return Hl(e, t, n);
                                t.flags |= 128;
                            }
                            if (null !== (i = t.memoizedState) && (i.rendering = null, i.tail = null, i.lastEffect = null), W(hl, hl.current), r) break;
                            return null;
                        case 22:
                        case 23:
                            return t.lanes = 0, Fl(e, t, n);
                        case 24:
                            Ei(0, Fi, e.memoizedState.cache);
                    }
                    return _l(e, t, n);
                }(e, t, n);
                Ll = !!(131072 & e.flags);
            }
        } else Ll = !1, si && 1048576 & t.flags && ri(t, Jr, t.index);
        switch(t.lanes = 0, t.tag){
            case 16:
                e: {
                    e = t.pendingProps;
                    var i = t.elementType, o = i._init;
                    if (i = o(i._payload), t.type = i, "function" != typeof i) {
                        if (null != i) {
                            if ((o = i.$$typeof) === I) {
                                t.tag = 11, t = zl(null, t, i, e, n);
                                break e;
                            }
                            if (o === x) {
                                t.tag = 14, t = Tl(null, t, i, e, n);
                                break e;
                            }
                        }
                        throw t = C(i) || i, Error(r(306, t, ""));
                    }
                    Qr(i) ? (e = vl(i, e), t.tag = 1, t = Ql(null, t, i, e, n)) : (t.tag = 0, t = jl(null, t, i, e, n));
                }
                return t;
            case 0:
                return jl(e, t, t.type, t.pendingProps, n);
            case 1:
                return Ql(e, t, i = t.type, o = vl(i, t.pendingProps), n);
            case 3:
                e: {
                    if (X(t, t.stateNode.containerInfo), null === e) throw Error(r(387));
                    i = t.pendingProps;
                    var a = t.memoizedState;
                    o = a.element, ao(e, t), po(t, i, null, n);
                    var l = t.memoizedState;
                    if (i = l.cache, Ei(0, Fi, i), i !== a.cache && wi(t, [
                        Fi
                    ], n, !0), ho(), i = l.element, a.isDehydrated) {
                        if (a = {
                            element: i,
                            isDehydrated: !1,
                            cache: l.cache
                        }, t.updateQueue.baseState = a, t.memoizedState = a, 256 & t.flags) {
                            t = ql(e, t, i, n);
                            break e;
                        }
                        if (i !== o) {
                            yi(o = Nr(Error(r(424)), t)), t = ql(e, t, i, n);
                            break e;
                        }
                        if (9 === (e = t.stateNode.containerInfo).nodeType) e = e.body;
                        else e = "HTML" === e.nodeName ? e.ownerDocument.body : e;
                        for(li = Id(e.firstChild), ai = t, si = !0, ui = null, ci = !0, n = al(t, null, i, n), t.child = n; n;)n.flags = -3 & n.flags | 4096, n = n.sibling;
                    } else {
                        if (gi(), i === o) {
                            t = _l(e, t, n);
                            break e;
                        }
                        Cl(e, t, i, n);
                    }
                    t = t.child;
                }
                return t;
            case 26:
                return Al(e, t), null === e ? (n = Cd(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : si || (n = t.type, e = t.pendingProps, (i = ad(Y.current).createElement(n))[De] = t, i[Fe] = e, rd(i, n, e), Ze(i), t.stateNode = i) : t.memoizedState = Cd(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
            case 27:
                return J(t), null === e && si && (i = t.stateNode = xd(t.type, t.pendingProps, Y.current), ai = t, ci = !0, o = li, gd(t.type) ? (Md = o, li = Id(i.firstChild)) : li = o), Cl(e, t, t.pendingProps.children, n), Al(e, t), null === e && (t.flags |= 4194304), t.child;
            case 5:
                return null === e && si && ((o = i = li) && (null !== (i = function(e, t, n, r) {
                    for(; 1 === e.nodeType;){
                        var i = n;
                        if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
                            if (!r && ("INPUT" !== e.nodeName || "hidden" !== e.type)) break;
                        } else if (r) {
                            if (!e[qe]) switch(t){
                                case "meta":
                                    if (!e.hasAttribute("itemprop")) break;
                                    return e;
                                case "link":
                                    if ("stylesheet" === (o = e.getAttribute("rel")) && e.hasAttribute("data-precedence")) break;
                                    if (o !== i.rel || e.getAttribute("href") !== (null == i.href || "" === i.href ? null : i.href) || e.getAttribute("crossorigin") !== (null == i.crossOrigin ? null : i.crossOrigin) || e.getAttribute("title") !== (null == i.title ? null : i.title)) break;
                                    return e;
                                case "style":
                                    if (e.hasAttribute("data-precedence")) break;
                                    return e;
                                case "script":
                                    if (((o = e.getAttribute("src")) !== (null == i.src ? null : i.src) || e.getAttribute("type") !== (null == i.type ? null : i.type) || e.getAttribute("crossorigin") !== (null == i.crossOrigin ? null : i.crossOrigin)) && o && e.hasAttribute("async") && !e.hasAttribute("itemprop")) break;
                                    return e;
                                default:
                                    return e;
                            }
                        } else {
                            if ("input" !== t || "hidden" !== e.type) return e;
                            var o = null == i.name ? null : "" + i.name;
                            if ("hidden" === i.type && e.getAttribute("name") === o) return e;
                        }
                        if (null === (e = Id(e.nextSibling))) break;
                    }
                    return null;
                }(i, t.type, t.pendingProps, ci)) ? (t.stateNode = i, ai = t, li = Id(i.firstChild), ci = !1, o = !0) : o = !1), o || fi(t)), J(t), o = t.type, a = t.pendingProps, l = null !== e ? e.memoizedProps : null, i = a.children, ud(o, a) ? i = null : null !== l && ud(o, l) && (t.flags |= 32), null !== t.memoizedState && (o = Fo(e, t, jo, null, null, n), Hd._currentValue = o), Al(e, t), Cl(e, t, i, n), t.child;
            case 6:
                return null === e && si && ((e = n = li) && (null !== (n = function(e, t, n) {
                    if ("" === t) return null;
                    for(; 3 !== e.nodeType;){
                        if ((1 !== e.nodeType || "INPUT" !== e.nodeName || "hidden" !== e.type) && !n) return null;
                        if (null === (e = Id(e.nextSibling))) return null;
                    }
                    return e;
                }(n, t.pendingProps, ci)) ? (t.stateNode = n, ai = t, li = null, e = !0) : e = !1), e || fi(t)), null;
            case 13:
                return Kl(e, t, n);
            case 4:
                return X(t, t.stateNode.containerInfo), i = t.pendingProps, null === e ? t.child = ol(t, null, i, n) : Cl(e, t, i, n), t.child;
            case 11:
                return zl(e, t, t.type, t.pendingProps, n);
            case 7:
                return Cl(e, t, t.pendingProps, n), t.child;
            case 8:
            case 12:
                return Cl(e, t, t.pendingProps.children, n), t.child;
            case 10:
                return i = t.pendingProps, Ei(0, t.type, i.value), Cl(e, t, i.children, n), t.child;
            case 9:
                return o = t.type._context, i = t.pendingProps.children, Ui(t), i = i(o = Ri(o)), t.flags |= 1, Cl(e, t, i, n), t.child;
            case 14:
                return Tl(e, t, t.type, t.pendingProps, n);
            case 15:
                return Dl(e, t, t.type, t.pendingProps, n);
            case 19:
                return Hl(e, t, n);
            case 31:
                return i = t.pendingProps, n = t.mode, i = {
                    mode: i.mode,
                    children: i.children
                }, null === e ? ((n = Zl(i, n)).ref = t.ref, t.child = n, n.return = t, t = n) : ((n = qr(e.child, i)).ref = t.ref, t.child = n, n.return = t, t = n), t;
            case 22:
                return Fl(e, t, n);
            case 24:
                return Ui(t), i = Ri(Fi), null === e ? (null === (o = Ki()) && (o = au, a = Vi(), o.pooledCache = a, a.refCount++, null !== a && (o.pooledCacheLanes |= n), o = a), t.memoizedState = {
                    parent: i,
                    cache: o
                }, oo(t), Ei(0, Fi, o)) : (0 !== (e.lanes & n) && (ao(e, t), po(t, null, null, n), ho()), o = e.memoizedState, a = t.memoizedState, o.parent !== i ? (o = {
                    parent: i,
                    cache: i
                }, t.memoizedState = o, 0 === t.lanes && (t.memoizedState = t.updateQueue.baseState = o), Ei(0, Fi, i)) : (i = a.cache, Ei(0, Fi, i), i !== o.cache && wi(t, [
                    Fi
                ], n, !0))), Cl(e, t, t.pendingProps.children, n), t.child;
            case 29:
                throw t.pendingProps;
        }
        throw Error(r(156, t.tag));
    }
    function ts(e) {
        e.flags |= 4;
    }
    function ns(e, t) {
        if ("stylesheet" !== t.type || 4 & t.state.loading) e.flags &= -16777217;
        else if (e.flags |= 16777216, !Bd(t)) {
            if (null !== (t = ll.current) && ((4194048 & su) === su ? null !== sl : (62914560 & su) !== su && !(536870912 & su) || t !== sl)) throw to = Hi, Pi;
            e.flags |= 8192;
        }
    }
    function rs(e, t) {
        null !== t && (e.flags |= 4), 16384 & e.flags && (t = 22 !== e.tag ? we() : 536870912, e.lanes |= t, Iu |= t);
    }
    function is(e, t) {
        if (!si) switch(e.tailMode){
            case "hidden":
                t = e.tail;
                for(var n = null; null !== t;)null !== t.alternate && (n = t), t = t.sibling;
                null === n ? e.tail = null : n.sibling = null;
                break;
            case "collapsed":
                n = e.tail;
                for(var r = null; null !== n;)null !== n.alternate && (r = n), n = n.sibling;
                null === r ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : r.sibling = null;
        }
    }
    function os(e) {
        var t = null !== e.alternate && e.alternate.child === e.child, n = 0, r = 0;
        if (t) for(var i = e.child; null !== i;)n |= i.lanes | i.childLanes, r |= 65011712 & i.subtreeFlags, r |= 65011712 & i.flags, i.return = e, i = i.sibling;
        else for(i = e.child; null !== i;)n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
        return e.subtreeFlags |= r, e.childLanes = n, t;
    }
    function as(e, t, n) {
        var i = t.pendingProps;
        switch(oi(t), t.tag){
            case 31:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
            case 1:
                return os(t), null;
            case 3:
                return n = t.stateNode, i = null, null !== e && (i = e.memoizedState.cache), t.memoizedState.cache !== i && (t.flags |= 2048), xi(Fi), P(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), null !== e && null !== e.child || (mi(t) ? ts(t) : null === e || e.memoizedState.isDehydrated && !(256 & t.flags) || (t.flags |= 1024, bi())), os(t), null;
            case 26:
                return n = t.memoizedState, null === e ? (ts(t), null !== n ? (os(t), ns(t, n)) : (os(t), t.flags &= -16777217)) : n ? n !== e.memoizedState ? (ts(t), os(t), ns(t, n)) : (os(t), t.flags &= -16777217) : (e.memoizedProps !== i && ts(t), os(t), t.flags &= -16777217), null;
            case 27:
                H(t), n = Y.current;
                var o = t.type;
                if (null !== e && null != t.stateNode) e.memoizedProps !== i && ts(t);
                else {
                    if (!i) {
                        if (null === t.stateNode) throw Error(r(166));
                        return os(t), null;
                    }
                    e = G.current, mi(t) ? hi(t) : (e = xd(o, i, n), t.stateNode = e, ts(t));
                }
                return os(t), null;
            case 5:
                if (H(t), n = t.type, null !== e && null != t.stateNode) e.memoizedProps !== i && ts(t);
                else {
                    if (!i) {
                        if (null === t.stateNode) throw Error(r(166));
                        return os(t), null;
                    }
                    if (e = G.current, mi(t)) hi(t);
                    else {
                        switch(o = ad(Y.current), e){
                            case 1:
                                e = o.createElementNS("http://www.w3.org/2000/svg", n);
                                break;
                            case 2:
                                e = o.createElementNS("http://www.w3.org/1998/Math/MathML", n);
                                break;
                            default:
                                switch(n){
                                    case "svg":
                                        e = o.createElementNS("http://www.w3.org/2000/svg", n);
                                        break;
                                    case "math":
                                        e = o.createElementNS("http://www.w3.org/1998/Math/MathML", n);
                                        break;
                                    case "script":
                                        (e = o.createElement("div")).innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild);
                                        break;
                                    case "select":
                                        e = "string" == typeof i.is ? o.createElement("select", {
                                            is: i.is
                                        }) : o.createElement("select"), i.multiple ? e.multiple = !0 : i.size && (e.size = i.size);
                                        break;
                                    default:
                                        e = "string" == typeof i.is ? o.createElement(n, {
                                            is: i.is
                                        }) : o.createElement(n);
                                }
                        }
                        e[De] = t, e[Fe] = i;
                        e: for(o = t.child; null !== o;){
                            if (5 === o.tag || 6 === o.tag) e.appendChild(o.stateNode);
                            else if (4 !== o.tag && 27 !== o.tag && null !== o.child) {
                                o.child.return = o, o = o.child;
                                continue;
                            }
                            if (o === t) break e;
                            for(; null === o.sibling;){
                                if (null === o.return || o.return === t) break e;
                                o = o.return;
                            }
                            o.sibling.return = o.return, o = o.sibling;
                        }
                        t.stateNode = e;
                        e: switch(rd(e, n, i), n){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                e = !!i.autoFocus;
                                break e;
                            case "img":
                                e = !0;
                                break e;
                            default:
                                e = !1;
                        }
                        e && ts(t);
                    }
                }
                return os(t), t.flags &= -16777217, null;
            case 6:
                if (e && null != t.stateNode) e.memoizedProps !== i && ts(t);
                else {
                    if ("string" != typeof i && null === t.stateNode) throw Error(r(166));
                    if (e = Y.current, mi(t)) {
                        if (e = t.stateNode, n = t.memoizedProps, i = null, null !== (o = ai)) switch(o.tag){
                            case 27:
                            case 5:
                                i = o.memoizedProps;
                        }
                        e[De] = t, (e = !!(e.nodeValue === n || null !== i && !0 === i.suppressHydrationWarning || $c(e.nodeValue, n))) || fi(t);
                    } else (e = ad(e).createTextNode(i))[De] = t, t.stateNode = e;
                }
                return os(t), null;
            case 13:
                if (i = t.memoizedState, null === e || null !== e.memoizedState && null !== e.memoizedState.dehydrated) {
                    if (o = mi(t), null !== i && null !== i.dehydrated) {
                        if (null === e) {
                            if (!o) throw Error(r(318));
                            if (!(o = null !== (o = t.memoizedState) ? o.dehydrated : null)) throw Error(r(317));
                            o[De] = t;
                        } else gi(), !(128 & t.flags) && (t.memoizedState = null), t.flags |= 4;
                        os(t), o = !1;
                    } else o = bi(), null !== e && null !== e.memoizedState && (e.memoizedState.hydrationErrors = o), o = !0;
                    if (!o) return 256 & t.flags ? (fl(t), t) : (fl(t), null);
                }
                if (fl(t), 128 & t.flags) return t.lanes = n, t;
                if (n = null !== i, e = null !== e && null !== e.memoizedState, n) {
                    o = null, null !== (i = t.child).alternate && null !== i.alternate.memoizedState && null !== i.alternate.memoizedState.cachePool && (o = i.alternate.memoizedState.cachePool.pool);
                    var a = null;
                    null !== i.memoizedState && null !== i.memoizedState.cachePool && (a = i.memoizedState.cachePool.pool), a !== o && (i.flags |= 2048);
                }
                return n !== e && n && (t.child.flags |= 8192), rs(t, t.updateQueue), os(t), null;
            case 4:
                return P(), null === e && Gc(t.stateNode.containerInfo), os(t), null;
            case 10:
                return xi(t.type), os(t), null;
            case 19:
                if (Q(hl), null === (o = t.memoizedState)) return os(t), null;
                if (i = !!(128 & t.flags), null === (a = o.rendering)) {
                    if (i) is(o, !1);
                    else {
                        if (0 !== mu || null !== e && 128 & e.flags) for(e = t.child; null !== e;){
                            if (null !== (a = pl(e))) {
                                for(t.flags |= 128, is(o, !1), e = a.updateQueue, t.updateQueue = e, rs(t, e), t.subtreeFlags = 0, e = n, n = t.child; null !== n;)Wr(n, e), n = n.sibling;
                                return W(hl, 1 & hl.current | 2), t.child;
                            }
                            e = e.sibling;
                        }
                        null !== o.tail && re() > wu && (t.flags |= 128, i = !0, is(o, !1), t.lanes = 4194304);
                    }
                } else {
                    if (!i) {
                        if (null !== (e = pl(a))) {
                            if (t.flags |= 128, i = !0, e = e.updateQueue, t.updateQueue = e, rs(t, e), is(o, !0), null === o.tail && "hidden" === o.tailMode && !a.alternate && !si) return os(t), null;
                        } else 2 * re() - o.renderingStartTime > wu && 536870912 !== n && (t.flags |= 128, i = !0, is(o, !1), t.lanes = 4194304);
                    }
                    o.isBackwards ? (a.sibling = t.child, t.child = a) : (null !== (e = o.last) ? e.sibling = a : t.child = a, o.last = a);
                }
                return null !== o.tail ? (t = o.tail, o.rendering = t, o.tail = t.sibling, o.renderingStartTime = re(), t.sibling = null, e = hl.current, W(hl, i ? 1 & e | 2 : 1 & e), t) : (os(t), null);
            case 22:
            case 23:
                return fl(t), Mo(), i = null !== t.memoizedState, null !== e ? null !== e.memoizedState !== i && (t.flags |= 8192) : i && (t.flags |= 8192), i ? !!(536870912 & n) && !(128 & t.flags) && (os(t), 6 & t.subtreeFlags && (t.flags |= 8192)) : os(t), null !== (n = t.updateQueue) && rs(t, n.retryQueue), n = null, null !== e && null !== e.memoizedState && null !== e.memoizedState.cachePool && (n = e.memoizedState.cachePool.pool), i = null, null !== t.memoizedState && null !== t.memoizedState.cachePool && (i = t.memoizedState.cachePool.pool), i !== n && (t.flags |= 2048), null !== e && Q(Bi), null;
            case 24:
                return n = null, null !== e && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), xi(Fi), os(t), null;
            case 25:
            case 30:
                return null;
        }
        throw Error(r(156, t.tag));
    }
    function ls(e, t) {
        switch(oi(t), t.tag){
            case 1:
                return 65536 & (e = t.flags) ? (t.flags = -65537 & e | 128, t) : null;
            case 3:
                return xi(Fi), P(), 65536 & (e = t.flags) && !(128 & e) ? (t.flags = -65537 & e | 128, t) : null;
            case 26:
            case 27:
            case 5:
                return H(t), null;
            case 13:
                if (fl(t), null !== (e = t.memoizedState) && null !== e.dehydrated) {
                    if (null === t.alternate) throw Error(r(340));
                    gi();
                }
                return 65536 & (e = t.flags) ? (t.flags = -65537 & e | 128, t) : null;
            case 19:
                return Q(hl), null;
            case 4:
                return P(), null;
            case 10:
                return xi(t.type), null;
            case 22:
            case 23:
                return fl(t), Mo(), null !== e && Q(Bi), 65536 & (e = t.flags) ? (t.flags = -65537 & e | 128, t) : null;
            case 24:
                return xi(Fi), null;
            default:
                return null;
        }
    }
    function ss(e, t) {
        switch(oi(t), t.tag){
            case 3:
                xi(Fi), P();
                break;
            case 26:
            case 27:
            case 5:
                H(t);
                break;
            case 4:
                P();
                break;
            case 13:
                fl(t);
                break;
            case 19:
                Q(hl);
                break;
            case 10:
                xi(t.type);
                break;
            case 22:
            case 23:
                fl(t), Mo(), null !== e && Q(Bi);
                break;
            case 24:
                xi(Fi);
        }
    }
    function us(e, t) {
        try {
            var n = t.updateQueue, r = null !== n ? n.lastEffect : null;
            if (null !== r) {
                var i = r.next;
                n = i;
                do {
                    if ((n.tag & e) === e) {
                        r = void 0;
                        var o = n.create, a = n.inst;
                        r = o(), a.destroy = r;
                    }
                    n = n.next;
                }while (n !== i);
            }
        } catch (e) {
            hc(t, t.return, e);
        }
    }
    function cs(e, t, n) {
        try {
            var r = t.updateQueue, i = null !== r ? r.lastEffect : null;
            if (null !== i) {
                var o = i.next;
                r = o;
                do {
                    if ((r.tag & e) === e) {
                        var a = r.inst, l = a.destroy;
                        if (void 0 !== l) {
                            a.destroy = void 0, i = t;
                            var s = n, u = l;
                            try {
                                u();
                            } catch (e) {
                                hc(i, s, e);
                            }
                        }
                    }
                    r = r.next;
                }while (r !== o);
            }
        } catch (e) {
            hc(t, t.return, e);
        }
    }
    function ds(e) {
        var t = e.updateQueue;
        if (null !== t) {
            var n = e.stateNode;
            try {
                go(t, n);
            } catch (t) {
                hc(e, e.return, t);
            }
        }
    }
    function fs(e, t, n) {
        n.props = vl(e.type, e.memoizedProps), n.state = e.memoizedState;
        try {
            n.componentWillUnmount();
        } catch (n) {
            hc(e, t, n);
        }
    }
    function hs(e, t) {
        try {
            var n = e.ref;
            if (null !== n) {
                switch(e.tag){
                    case 26:
                    case 27:
                    case 5:
                        var r = e.stateNode;
                        break;
                    default:
                        r = e.stateNode;
                }
                "function" == typeof n ? e.refCleanup = n(r) : n.current = r;
            }
        } catch (n) {
            hc(e, t, n);
        }
    }
    function ps(e, t) {
        var n = e.ref, r = e.refCleanup;
        if (null !== n) {
            if ("function" == typeof r) try {
                r();
            } catch (n) {
                hc(e, t, n);
            } finally{
                e.refCleanup = null, null != (e = e.alternate) && (e.refCleanup = null);
            }
            else if ("function" == typeof n) try {
                n(null);
            } catch (n) {
                hc(e, t, n);
            }
            else n.current = null;
        }
    }
    function ms(e) {
        var t = e.type, n = e.memoizedProps, r = e.stateNode;
        try {
            e: switch(t){
                case "button":
                case "input":
                case "select":
                case "textarea":
                    n.autoFocus && r.focus();
                    break e;
                case "img":
                    n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet);
            }
        } catch (t) {
            hc(e, e.return, t);
        }
    }
    function gs(e, t, n) {
        try {
            var i = e.stateNode;
            !function(e, t, n, i) {
                switch(t){
                    case "div":
                    case "span":
                    case "svg":
                    case "path":
                    case "a":
                    case "g":
                    case "p":
                    case "li":
                        break;
                    case "input":
                        var o = null, a = null, l = null, s = null, u = null, c = null, d = null;
                        for(p in n){
                            var f = n[p];
                            if (n.hasOwnProperty(p) && null != f) switch(p){
                                case "checked":
                                case "value":
                                    break;
                                case "defaultValue":
                                    u = f;
                                default:
                                    i.hasOwnProperty(p) || td(e, t, p, null, i, f);
                            }
                        }
                        for(var h in i){
                            var p = i[h];
                            if (f = n[h], i.hasOwnProperty(h) && (null != p || null != f)) switch(h){
                                case "type":
                                    a = p;
                                    break;
                                case "name":
                                    o = p;
                                    break;
                                case "checked":
                                    c = p;
                                    break;
                                case "defaultChecked":
                                    d = p;
                                    break;
                                case "value":
                                    l = p;
                                    break;
                                case "defaultValue":
                                    s = p;
                                    break;
                                case "children":
                                case "dangerouslySetInnerHTML":
                                    if (null != p) throw Error(r(137, t));
                                    break;
                                default:
                                    p !== f && td(e, t, h, p, i, f);
                            }
                        }
                        return void yt(e, l, s, u, c, d, a, o);
                    case "select":
                        for(a in p = l = s = h = null, n)if (u = n[a], n.hasOwnProperty(a) && null != u) switch(a){
                            case "value":
                                break;
                            case "multiple":
                                p = u;
                            default:
                                i.hasOwnProperty(a) || td(e, t, a, null, i, u);
                        }
                        for(o in i)if (a = i[o], u = n[o], i.hasOwnProperty(o) && (null != a || null != u)) switch(o){
                            case "value":
                                h = a;
                                break;
                            case "defaultValue":
                                s = a;
                                break;
                            case "multiple":
                                l = a;
                            default:
                                a !== u && td(e, t, o, a, i, u);
                        }
                        return t = s, n = l, i = p, void (null != h ? Mt(e, !!n, h, !1) : !!i != !!n && (null != t ? Mt(e, !!n, t, !0) : Mt(e, !!n, n ? [] : "", !1)));
                    case "textarea":
                        for(s in p = h = null, n)if (o = n[s], n.hasOwnProperty(s) && null != o && !i.hasOwnProperty(s)) switch(s){
                            case "value":
                            case "children":
                                break;
                            default:
                                td(e, t, s, null, i, o);
                        }
                        for(l in i)if (o = i[l], a = n[l], i.hasOwnProperty(l) && (null != o || null != a)) switch(l){
                            case "value":
                                h = o;
                                break;
                            case "defaultValue":
                                p = o;
                                break;
                            case "children":
                                break;
                            case "dangerouslySetInnerHTML":
                                if (null != o) throw Error(r(91));
                                break;
                            default:
                                o !== a && td(e, t, l, o, i, a);
                        }
                        return void Et(e, h, p);
                    case "option":
                        for(var m in n)if (h = n[m], n.hasOwnProperty(m) && null != h && !i.hasOwnProperty(m)) {
                            if ("selected" === m) e.selected = !1;
                            else td(e, t, m, null, i, h);
                        }
                        for(u in i)if (h = i[u], p = n[u], i.hasOwnProperty(u) && h !== p && (null != h || null != p)) {
                            if ("selected" === u) e.selected = h && "function" != typeof h && "symbol" != typeof h;
                            else td(e, t, u, h, i, p);
                        }
                        return;
                    case "img":
                    case "link":
                    case "area":
                    case "base":
                    case "br":
                    case "col":
                    case "embed":
                    case "hr":
                    case "keygen":
                    case "meta":
                    case "param":
                    case "source":
                    case "track":
                    case "wbr":
                    case "menuitem":
                        for(var g in n)h = n[g], n.hasOwnProperty(g) && null != h && !i.hasOwnProperty(g) && td(e, t, g, null, i, h);
                        for(c in i)if (h = i[c], p = n[c], i.hasOwnProperty(c) && h !== p && (null != h || null != p)) switch(c){
                            case "children":
                            case "dangerouslySetInnerHTML":
                                if (null != h) throw Error(r(137, t));
                                break;
                            default:
                                td(e, t, c, h, i, p);
                        }
                        return;
                    default:
                        if (Ut(t)) {
                            for(var b in n)h = n[b], n.hasOwnProperty(b) && void 0 !== h && !i.hasOwnProperty(b) && nd(e, t, b, void 0, i, h);
                            for(d in i)h = i[d], p = n[d], !i.hasOwnProperty(d) || h === p || void 0 === h && void 0 === p || nd(e, t, d, h, i, p);
                            return;
                        }
                }
                for(var y in n)h = n[y], n.hasOwnProperty(y) && null != h && !i.hasOwnProperty(y) && td(e, t, y, null, i, h);
                for(f in i)h = i[f], p = n[f], !i.hasOwnProperty(f) || h === p || null == h && null == p || td(e, t, f, h, i, p);
            }(i, e.type, n, t), i[Fe] = t;
        } catch (t) {
            hc(e, e.return, t);
        }
    }
    function bs(e) {
        return 5 === e.tag || 3 === e.tag || 26 === e.tag || 27 === e.tag && gd(e.type) || 4 === e.tag;
    }
    function ys(e) {
        e: for(;;){
            for(; null === e.sibling;){
                if (null === e.return || bs(e.return)) return null;
                e = e.return;
            }
            for(e.sibling.return = e.return, e = e.sibling; 5 !== e.tag && 6 !== e.tag && 18 !== e.tag;){
                if (27 === e.tag && gd(e.type)) continue e;
                if (2 & e.flags) continue e;
                if (null === e.child || 4 === e.tag) continue e;
                e.child.return = e, e = e.child;
            }
            if (!(2 & e.flags)) return e.stateNode;
        }
    }
    function vs(e, t, n) {
        var r = e.tag;
        if (5 === r || 6 === r) e = e.stateNode, t ? (9 === n.nodeType ? n.body : "HTML" === n.nodeName ? n.ownerDocument.body : n).insertBefore(e, t) : ((t = 9 === n.nodeType ? n.body : "HTML" === n.nodeName ? n.ownerDocument.body : n).appendChild(e), null != (n = n._reactRootContainer) || null !== t.onclick || (t.onclick = ed));
        else if (4 !== r && (27 === r && gd(e.type) && (n = e.stateNode, t = null), null !== (e = e.child))) for(vs(e, t, n), e = e.sibling; null !== e;)vs(e, t, n), e = e.sibling;
    }
    function Is(e, t, n) {
        var r = e.tag;
        if (5 === r || 6 === r) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
        else if (4 !== r && (27 === r && gd(e.type) && (n = e.stateNode), null !== (e = e.child))) for(Is(e, t, n), e = e.sibling; null !== e;)Is(e, t, n), e = e.sibling;
    }
    function Ms(e) {
        var t = e.stateNode, n = e.memoizedProps;
        try {
            for(var r = e.type, i = t.attributes; i.length;)t.removeAttributeNode(i[0]);
            rd(t, r, n), t[De] = e, t[Fe] = n;
        } catch (t) {
            hc(e, e.return, t);
        }
    }
    var Es = !1, xs = !1, Ss = !1, ws = "function" == typeof WeakSet ? WeakSet : Set, ks = null;
    function Ns(e, t, n) {
        var r = n.flags;
        switch(n.tag){
            case 0:
            case 11:
            case 15:
                Qs(e, n), 4 & r && us(5, n);
                break;
            case 1:
                if (Qs(e, n), 4 & r) {
                    if (e = n.stateNode, null === t) try {
                        e.componentDidMount();
                    } catch (e) {
                        hc(n, n.return, e);
                    }
                    else {
                        var i = vl(n.type, t.memoizedProps);
                        t = t.memoizedState;
                        try {
                            e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
                        } catch (e) {
                            hc(n, n.return, e);
                        }
                    }
                }
                64 & r && ds(n), 512 & r && hs(n, n.return);
                break;
            case 3:
                if (Qs(e, n), 64 & r && null !== (e = n.updateQueue)) {
                    if (t = null, null !== n.child) switch(n.child.tag){
                        case 27:
                        case 5:
                        case 1:
                            t = n.child.stateNode;
                    }
                    try {
                        go(e, t);
                    } catch (e) {
                        hc(n, n.return, e);
                    }
                }
                break;
            case 27:
                null === t && 4 & r && Ms(n);
            case 26:
            case 5:
                Qs(e, n), null === t && 4 & r && ms(n), 512 & r && hs(n, n.return);
                break;
            case 12:
                Qs(e, n);
                break;
            case 13:
                Qs(e, n), 4 & r && Ts(e, n), 64 & r && null !== (e = n.memoizedState) && null !== (e = e.dehydrated) && function(e, t) {
                    var n = e.ownerDocument;
                    if ("$?" !== e.data || "complete" === n.readyState) t();
                    else {
                        var r = function() {
                            t(), n.removeEventListener("DOMContentLoaded", r);
                        };
                        n.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
                    }
                }(e, n = bc.bind(null, n));
                break;
            case 22:
                if (!(r = null !== n.memoizedState || Es)) {
                    t = null !== t && null !== t.memoizedState || xs, i = Es;
                    var o = xs;
                    Es = r, (xs = t) && !o ? Ws(e, n, !!(8772 & n.subtreeFlags)) : Qs(e, n), Es = i, xs = o;
                }
                break;
            case 30:
                break;
            default:
                Qs(e, n);
        }
    }
    function Us(e) {
        var t = e.alternate;
        null !== t && (e.alternate = null, Us(t)), e.child = null, e.deletions = null, e.sibling = null, 5 === e.tag && null !== (t = e.stateNode) && We(t), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
    }
    var Rs = null, Ls = !1;
    function Cs(e, t, n) {
        for(n = n.child; null !== n;)zs(e, t, n), n = n.sibling;
    }
    function zs(e, t, n) {
        if (he && "function" == typeof he.onCommitFiberUnmount) try {
            he.onCommitFiberUnmount(fe, n);
        } catch (e) {}
        switch(n.tag){
            case 26:
                xs || ps(n, t), Cs(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode).parentNode.removeChild(n);
                break;
            case 27:
                xs || ps(n, t);
                var r = Rs, i = Ls;
                gd(n.type) && (Rs = n.stateNode, Ls = !1), Cs(e, t, n), Sd(n.stateNode), Rs = r, Ls = i;
                break;
            case 5:
                xs || ps(n, t);
            case 6:
                if (r = Rs, i = Ls, Rs = null, Cs(e, t, n), Ls = i, null !== (Rs = r)) {
                    if (Ls) try {
                        (9 === Rs.nodeType ? Rs.body : "HTML" === Rs.nodeName ? Rs.ownerDocument.body : Rs).removeChild(n.stateNode);
                    } catch (e) {
                        hc(n, t, e);
                    }
                    else try {
                        Rs.removeChild(n.stateNode);
                    } catch (e) {
                        hc(n, t, e);
                    }
                }
                break;
            case 18:
                null !== Rs && (Ls ? (bd(9 === (e = Rs).nodeType ? e.body : "HTML" === e.nodeName ? e.ownerDocument.body : e, n.stateNode), Cf(e)) : bd(Rs, n.stateNode));
                break;
            case 4:
                r = Rs, i = Ls, Rs = n.stateNode.containerInfo, Ls = !0, Cs(e, t, n), Rs = r, Ls = i;
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                xs || cs(2, n, t), xs || cs(4, n, t), Cs(e, t, n);
                break;
            case 1:
                xs || (ps(n, t), "function" == typeof (r = n.stateNode).componentWillUnmount && fs(n, t, r)), Cs(e, t, n);
                break;
            case 21:
                Cs(e, t, n);
                break;
            case 22:
                xs = (r = xs) || null !== n.memoizedState, Cs(e, t, n), xs = r;
                break;
            default:
                Cs(e, t, n);
        }
    }
    function Ts(e, t) {
        if (null === t.memoizedState && null !== (e = t.alternate) && null !== (e = e.memoizedState) && null !== (e = e.dehydrated)) try {
            Cf(e);
        } catch (e) {
            hc(t, t.return, e);
        }
    }
    function Ds(e, t) {
        var n = function(e) {
            switch(e.tag){
                case 13:
                case 19:
                    var t = e.stateNode;
                    return null === t && (t = e.stateNode = new ws), t;
                case 22:
                    return null === (t = (e = e.stateNode)._retryCache) && (t = e._retryCache = new ws), t;
                default:
                    throw Error(r(435, e.tag));
            }
        }(e);
        t.forEach(function(t) {
            var r = yc.bind(null, e, t);
            n.has(t) || (n.add(t), t.then(r, r));
        });
    }
    function Fs(e, t) {
        var n = t.deletions;
        if (null !== n) for(var i = 0; i < n.length; i++){
            var o = n[i], a = e, l = t, s = l;
            e: for(; null !== s;){
                switch(s.tag){
                    case 27:
                        if (gd(s.type)) {
                            Rs = s.stateNode, Ls = !1;
                            break e;
                        }
                        break;
                    case 5:
                        Rs = s.stateNode, Ls = !1;
                        break e;
                    case 3:
                    case 4:
                        Rs = s.stateNode.containerInfo, Ls = !0;
                        break e;
                }
                s = s.return;
            }
            if (null === Rs) throw Error(r(160));
            zs(a, l, o), Rs = null, Ls = !1, null !== (a = o.alternate) && (a.return = null), o.return = null;
        }
        if (13878 & t.subtreeFlags) for(t = t.child; null !== t;)As(t, e), t = t.sibling;
    }
    var Vs = null;
    function As(e, t) {
        var n = e.alternate, i = e.flags;
        switch(e.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                Fs(t, e), js(e), 4 & i && (cs(3, e, e.return), us(3, e), cs(5, e, e.return));
                break;
            case 1:
                Fs(t, e), js(e), 512 & i && (xs || null === n || ps(n, n.return)), 64 & i && Es && null !== (e = e.updateQueue) && null !== (i = e.callbacks) && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = null === n ? i : n.concat(i));
                break;
            case 26:
                var o = Vs;
                if (Fs(t, e), js(e), 512 & i && (xs || null === n || ps(n, n.return)), 4 & i) {
                    var a = null !== n ? n.memoizedState : null;
                    if (i = e.memoizedState, null === n) {
                        if (null === i) {
                            if (null === e.stateNode) {
                                e: {
                                    i = e.type, n = e.memoizedProps, o = o.ownerDocument || o;
                                    t: switch(i){
                                        case "title":
                                            (!(a = o.getElementsByTagName("title")[0]) || a[qe] || a[De] || "http://www.w3.org/2000/svg" === a.namespaceURI || a.hasAttribute("itemprop")) && (a = o.createElement(i), o.head.insertBefore(a, o.querySelector("head > title"))), rd(a, i, n), a[De] = e, Ze(a), i = a;
                                            break e;
                                        case "link":
                                            var l = Wd("link", "href", o).get(i + (n.href || ""));
                                            if (l) {
                                                for(var s = 0; s < l.length; s++)if ((a = l[s]).getAttribute("href") === (null == n.href || "" === n.href ? null : n.href) && a.getAttribute("rel") === (null == n.rel ? null : n.rel) && a.getAttribute("title") === (null == n.title ? null : n.title) && a.getAttribute("crossorigin") === (null == n.crossOrigin ? null : n.crossOrigin)) {
                                                    l.splice(s, 1);
                                                    break t;
                                                }
                                            }
                                            rd(a = o.createElement(i), i, n), o.head.appendChild(a);
                                            break;
                                        case "meta":
                                            if (l = Wd("meta", "content", o).get(i + (n.content || ""))) {
                                                for(s = 0; s < l.length; s++)if ((a = l[s]).getAttribute("content") === (null == n.content ? null : "" + n.content) && a.getAttribute("name") === (null == n.name ? null : n.name) && a.getAttribute("property") === (null == n.property ? null : n.property) && a.getAttribute("http-equiv") === (null == n.httpEquiv ? null : n.httpEquiv) && a.getAttribute("charset") === (null == n.charSet ? null : n.charSet)) {
                                                    l.splice(s, 1);
                                                    break t;
                                                }
                                            }
                                            rd(a = o.createElement(i), i, n), o.head.appendChild(a);
                                            break;
                                        default:
                                            throw Error(r(468, i));
                                    }
                                    a[De] = e, Ze(a), i = a;
                                }
                                e.stateNode = i;
                            } else Gd(o, e.type, e.stateNode);
                        } else e.stateNode = Ad(o, i, e.memoizedProps);
                    } else a !== i ? (null === a ? null !== n.stateNode && (n = n.stateNode).parentNode.removeChild(n) : a.count--, null === i ? Gd(o, e.type, e.stateNode) : Ad(o, i, e.memoizedProps)) : null === i && null !== e.stateNode && gs(e, e.memoizedProps, n.memoizedProps);
                }
                break;
            case 27:
                Fs(t, e), js(e), 512 & i && (xs || null === n || ps(n, n.return)), null !== n && 4 & i && gs(e, e.memoizedProps, n.memoizedProps);
                break;
            case 5:
                if (Fs(t, e), js(e), 512 & i && (xs || null === n || ps(n, n.return)), 32 & e.flags) {
                    o = e.stateNode;
                    try {
                        St(o, "");
                    } catch (t) {
                        hc(e, e.return, t);
                    }
                }
                4 & i && null != e.stateNode && gs(e, o = e.memoizedProps, null !== n ? n.memoizedProps : o), 1024 & i && (Ss = !0);
                break;
            case 6:
                if (Fs(t, e), js(e), 4 & i) {
                    if (null === e.stateNode) throw Error(r(162));
                    i = e.memoizedProps, n = e.stateNode;
                    try {
                        n.nodeValue = i;
                    } catch (t) {
                        hc(e, e.return, t);
                    }
                }
                break;
            case 3:
                if (qd = null, o = Vs, Vs = Nd(t.containerInfo), Fs(t, e), Vs = o, js(e), 4 & i && null !== n && n.memoizedState.isDehydrated) try {
                    Cf(t.containerInfo);
                } catch (t) {
                    hc(e, e.return, t);
                }
                Ss && (Ss = !1, Os(e));
                break;
            case 4:
                i = Vs, Vs = Nd(e.stateNode.containerInfo), Fs(t, e), js(e), Vs = i;
                break;
            case 12:
            default:
                Fs(t, e), js(e);
                break;
            case 13:
                Fs(t, e), js(e), 8192 & e.child.flags && null !== e.memoizedState != (null !== n && null !== n.memoizedState) && (Su = re()), 4 & i && null !== (i = e.updateQueue) && (e.updateQueue = null, Ds(e, i));
                break;
            case 22:
                o = null !== e.memoizedState;
                var u = null !== n && null !== n.memoizedState, c = Es, d = xs;
                if (Es = c || o, xs = d || u, Fs(t, e), xs = d, Es = c, js(e), 8192 & i) e: for(t = e.stateNode, t._visibility = o ? -2 & t._visibility : 1 | t._visibility, o && (null === n || u || Es || xs || qs(e)), n = null, t = e;;){
                    if (5 === t.tag || 26 === t.tag) {
                        if (null === n) {
                            u = n = t;
                            try {
                                if (a = u.stateNode, o) "function" == typeof (l = a.style).setProperty ? l.setProperty("display", "none", "important") : l.display = "none";
                                else {
                                    s = u.stateNode;
                                    var f = u.memoizedProps.style, h = null != f && f.hasOwnProperty("display") ? f.display : null;
                                    s.style.display = null == h || "boolean" == typeof h ? "" : ("" + h).trim();
                                }
                            } catch (e) {
                                hc(u, u.return, e);
                            }
                        }
                    } else if (6 === t.tag) {
                        if (null === n) {
                            u = t;
                            try {
                                u.stateNode.nodeValue = o ? "" : u.memoizedProps;
                            } catch (e) {
                                hc(u, u.return, e);
                            }
                        }
                    } else if ((22 !== t.tag && 23 !== t.tag || null === t.memoizedState || t === e) && null !== t.child) {
                        t.child.return = t, t = t.child;
                        continue;
                    }
                    if (t === e) break e;
                    for(; null === t.sibling;){
                        if (null === t.return || t.return === e) break e;
                        n === t && (n = null), t = t.return;
                    }
                    n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
                }
                4 & i && null !== (i = e.updateQueue) && null !== (n = i.retryQueue) && (i.retryQueue = null, Ds(e, n));
                break;
            case 19:
                Fs(t, e), js(e), 4 & i && null !== (i = e.updateQueue) && (e.updateQueue = null, Ds(e, i));
            case 30:
            case 21:
        }
    }
    function js(e) {
        var t = e.flags;
        if (2 & t) {
            try {
                for(var n, i = e.return; null !== i;){
                    if (bs(i)) {
                        n = i;
                        break;
                    }
                    i = i.return;
                }
                if (null == n) throw Error(r(160));
                switch(n.tag){
                    case 27:
                        var o = n.stateNode;
                        Is(e, ys(e), o);
                        break;
                    case 5:
                        var a = n.stateNode;
                        32 & n.flags && (St(a, ""), n.flags &= -33), Is(e, ys(e), a);
                        break;
                    case 3:
                    case 4:
                        var l = n.stateNode.containerInfo;
                        vs(e, ys(e), l);
                        break;
                    default:
                        throw Error(r(161));
                }
            } catch (t) {
                hc(e, e.return, t);
            }
            e.flags &= -3;
        }
        4096 & t && (e.flags &= -4097);
    }
    function Os(e) {
        if (1024 & e.subtreeFlags) for(e = e.child; null !== e;){
            var t = e;
            Os(t), 5 === t.tag && 1024 & t.flags && t.stateNode.reset(), e = e.sibling;
        }
    }
    function Qs(e, t) {
        if (8772 & t.subtreeFlags) for(t = t.child; null !== t;)Ns(e, t.alternate, t), t = t.sibling;
    }
    function qs(e) {
        for(e = e.child; null !== e;){
            var t = e;
            switch(t.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    cs(4, t, t.return), qs(t);
                    break;
                case 1:
                    ps(t, t.return);
                    var n = t.stateNode;
                    "function" == typeof n.componentWillUnmount && fs(t, t.return, n), qs(t);
                    break;
                case 27:
                    Sd(t.stateNode);
                case 26:
                case 5:
                    ps(t, t.return), qs(t);
                    break;
                case 22:
                    null === t.memoizedState && qs(t);
                    break;
                default:
                    qs(t);
            }
            e = e.sibling;
        }
    }
    function Ws(e, t, n) {
        for(n = n && !!(8772 & t.subtreeFlags), t = t.child; null !== t;){
            var r = t.alternate, i = e, o = t, a = o.flags;
            switch(o.tag){
                case 0:
                case 11:
                case 15:
                    Ws(i, o, n), us(4, o);
                    break;
                case 1:
                    if (Ws(i, o, n), "function" == typeof (i = (r = o).stateNode).componentDidMount) try {
                        i.componentDidMount();
                    } catch (e) {
                        hc(r, r.return, e);
                    }
                    if (null !== (i = (r = o).updateQueue)) {
                        var l = r.stateNode;
                        try {
                            var s = i.shared.hiddenCallbacks;
                            if (null !== s) for(i.shared.hiddenCallbacks = null, i = 0; i < s.length; i++)mo(s[i], l);
                        } catch (e) {
                            hc(r, r.return, e);
                        }
                    }
                    n && 64 & a && ds(o), hs(o, o.return);
                    break;
                case 27:
                    Ms(o);
                case 26:
                case 5:
                    Ws(i, o, n), n && null === r && 4 & a && ms(o), hs(o, o.return);
                    break;
                case 12:
                    Ws(i, o, n);
                    break;
                case 13:
                    Ws(i, o, n), n && 4 & a && Ts(i, o);
                    break;
                case 22:
                    null === o.memoizedState && Ws(i, o, n), hs(o, o.return);
                    break;
                case 30:
                    break;
                default:
                    Ws(i, o, n);
            }
            t = t.sibling;
        }
    }
    function Gs(e, t) {
        var n = null;
        null !== e && null !== e.memoizedState && null !== e.memoizedState.cachePool && (n = e.memoizedState.cachePool.pool), e = null, null !== t.memoizedState && null !== t.memoizedState.cachePool && (e = t.memoizedState.cachePool.pool), e !== n && (null != e && e.refCount++, null != n && Ai(n));
    }
    function Bs(e, t) {
        e = null, null !== t.alternate && (e = t.alternate.memoizedState.cache), (t = t.memoizedState.cache) !== e && (t.refCount++, null != e && Ai(e));
    }
    function Ks(e, t, n, r) {
        if (10256 & t.subtreeFlags) for(t = t.child; null !== t;)Ys(e, t, n, r), t = t.sibling;
    }
    function Ys(e, t, n, r) {
        var i = t.flags;
        switch(t.tag){
            case 0:
            case 11:
            case 15:
                Ks(e, t, n, r), 2048 & i && us(9, t);
                break;
            case 1:
            case 13:
            default:
                Ks(e, t, n, r);
                break;
            case 3:
                Ks(e, t, n, r), 2048 & i && (e = null, null !== t.alternate && (e = t.alternate.memoizedState.cache), (t = t.memoizedState.cache) !== e && (t.refCount++, null != e && Ai(e)));
                break;
            case 12:
                if (2048 & i) {
                    Ks(e, t, n, r), e = t.stateNode;
                    try {
                        var o = t.memoizedProps, a = o.id, l = o.onPostCommit;
                        "function" == typeof l && l(a, null === t.alternate ? "mount" : "update", e.passiveEffectDuration, -0);
                    } catch (e) {
                        hc(t, t.return, e);
                    }
                } else Ks(e, t, n, r);
                break;
            case 23:
                break;
            case 22:
                o = t.stateNode, a = t.alternate, null !== t.memoizedState ? 2 & o._visibility ? Ks(e, t, n, r) : Xs(e, t) : 2 & o._visibility ? Ks(e, t, n, r) : (o._visibility |= 2, Zs(e, t, n, r, !!(10256 & t.subtreeFlags))), 2048 & i && Gs(a, t);
                break;
            case 24:
                Ks(e, t, n, r), 2048 & i && Bs(t.alternate, t);
        }
    }
    function Zs(e, t, n, r, i) {
        for(i = i && !!(10256 & t.subtreeFlags), t = t.child; null !== t;){
            var o = e, a = t, l = n, s = r, u = a.flags;
            switch(a.tag){
                case 0:
                case 11:
                case 15:
                    Zs(o, a, l, s, i), us(8, a);
                    break;
                case 23:
                    break;
                case 22:
                    var c = a.stateNode;
                    null !== a.memoizedState ? 2 & c._visibility ? Zs(o, a, l, s, i) : Xs(o, a) : (c._visibility |= 2, Zs(o, a, l, s, i)), i && 2048 & u && Gs(a.alternate, a);
                    break;
                case 24:
                    Zs(o, a, l, s, i), i && 2048 & u && Bs(a.alternate, a);
                    break;
                default:
                    Zs(o, a, l, s, i);
            }
            t = t.sibling;
        }
    }
    function Xs(e, t) {
        if (10256 & t.subtreeFlags) for(t = t.child; null !== t;){
            var n = e, r = t, i = r.flags;
            switch(r.tag){
                case 22:
                    Xs(n, r), 2048 & i && Gs(r.alternate, r);
                    break;
                case 24:
                    Xs(n, r), 2048 & i && Bs(r.alternate, r);
                    break;
                default:
                    Xs(n, r);
            }
            t = t.sibling;
        }
    }
    var Ps = 8192;
    function Js(e) {
        if (e.subtreeFlags & Ps) for(e = e.child; null !== e;)Hs(e), e = e.sibling;
    }
    function Hs(e) {
        switch(e.tag){
            case 26:
                Js(e), e.flags & Ps && null !== e.memoizedState && function(e, t, n) {
                    if (null === Kd) throw Error(r(475));
                    var i = Kd;
                    if (!("stylesheet" !== t.type || "string" == typeof n.media && !1 === matchMedia(n.media).matches || 4 & t.state.loading)) {
                        if (null === t.instance) {
                            var o = zd(n.href), a = e.querySelector(Td(o));
                            if (a) return null !== (e = a._p) && "object" == typeof e && "function" == typeof e.then && (i.count++, i = Zd.bind(i), e.then(i, i)), t.state.loading |= 4, t.instance = a, void Ze(a);
                            a = e.ownerDocument || e, n = Dd(n), (o = wd.get(o)) && Od(n, o), Ze(a = a.createElement("link"));
                            var l = a;
                            l._p = new Promise(function(e, t) {
                                l.onload = e, l.onerror = t;
                            }), rd(a, "link", n), t.instance = a;
                        }
                        null === i.stylesheets && (i.stylesheets = new Map), i.stylesheets.set(t, e), (e = t.state.preload) && !(3 & t.state.loading) && (i.count++, t = Zd.bind(i), e.addEventListener("load", t), e.addEventListener("error", t));
                    }
                }(Vs, e.memoizedState, e.memoizedProps);
                break;
            case 5:
            default:
                Js(e);
                break;
            case 3:
            case 4:
                var t = Vs;
                Vs = Nd(e.stateNode.containerInfo), Js(e), Vs = t;
                break;
            case 22:
                null === e.memoizedState && (null !== (t = e.alternate) && null !== t.memoizedState ? (t = Ps, Ps = 16777216, Js(e), Ps = t) : Js(e));
        }
    }
    function _s(e) {
        var t = e.alternate;
        if (null !== t && null !== (e = t.child)) {
            t.child = null;
            do t = e.sibling, e.sibling = null, e = t;
            while (null !== e);
        }
    }
    function $s(e) {
        var t = e.deletions;
        if (16 & e.flags) {
            if (null !== t) for(var n = 0; n < t.length; n++){
                var r = t[n];
                ks = r, nu(r, e);
            }
            _s(e);
        }
        if (10256 & e.subtreeFlags) for(e = e.child; null !== e;)eu(e), e = e.sibling;
    }
    function eu(e) {
        switch(e.tag){
            case 0:
            case 11:
            case 15:
                $s(e), 2048 & e.flags && cs(9, e, e.return);
                break;
            case 3:
            case 12:
            default:
                $s(e);
                break;
            case 22:
                var t = e.stateNode;
                null !== e.memoizedState && 2 & t._visibility && (null === e.return || 13 !== e.return.tag) ? (t._visibility &= -3, tu(e)) : $s(e);
        }
    }
    function tu(e) {
        var t = e.deletions;
        if (16 & e.flags) {
            if (null !== t) for(var n = 0; n < t.length; n++){
                var r = t[n];
                ks = r, nu(r, e);
            }
            _s(e);
        }
        for(e = e.child; null !== e;){
            switch((t = e).tag){
                case 0:
                case 11:
                case 15:
                    cs(8, t, t.return), tu(t);
                    break;
                case 22:
                    2 & (n = t.stateNode)._visibility && (n._visibility &= -3, tu(t));
                    break;
                default:
                    tu(t);
            }
            e = e.sibling;
        }
    }
    function nu(e, t) {
        for(; null !== ks;){
            var n = ks;
            switch(n.tag){
                case 0:
                case 11:
                case 15:
                    cs(8, n, t);
                    break;
                case 23:
                case 22:
                    if (null !== n.memoizedState && null !== n.memoizedState.cachePool) {
                        var r = n.memoizedState.cachePool.pool;
                        null != r && r.refCount++;
                    }
                    break;
                case 24:
                    Ai(n.memoizedState.cache);
            }
            if (null !== (r = n.child)) r.return = n, ks = r;
            else e: for(n = e; null !== ks;){
                var i = (r = ks).sibling, o = r.return;
                if (Us(r), r === n) {
                    ks = null;
                    break e;
                }
                if (null !== i) {
                    i.return = o, ks = i;
                    break e;
                }
                ks = o;
            }
        }
    }
    var ru = {
        getCacheForType: function(e) {
            var t = Ri(Fi), n = t.data.get(e);
            return void 0 === n && (n = e(), t.data.set(e, n)), n;
        }
    }, iu = "function" == typeof WeakMap ? WeakMap : Map, ou = 0, au = null, lu = null, su = 0, uu = 0, cu = null, du = !1, fu = !1, hu = !1, pu = 0, mu = 0, gu = 0, bu = 0, yu = 0, vu = 0, Iu = 0, Mu = null, Eu = null, xu = !1, Su = 0, wu = 1 / 0, ku = null, Nu = null, Uu = 0, Ru = null, Lu = null, Cu = 0, zu = 0, Tu = null, Du = null, Fu = 0, Vu = null;
    function Au() {
        if (2 & ou && 0 !== su) return su & -su;
        if (null !== T.T) return 0 !== Qi ? Qi : zc();
        return ze();
    }
    function ju() {
        0 === vu && (vu = 536870912 & su && !si ? 536870912 : Se());
        var e = ll.current;
        return null !== e && (e.flags |= 32), vu;
    }
    function Ou(e, t, n) {
        (e !== au || 2 !== uu && 9 !== uu) && null === e.cancelPendingCommit || (Yu(e, 0), Gu(e, su, vu, !1)), Ne(e, n), 2 & ou && e === au || (e === au && (!(2 & ou) && (bu |= n), 4 === mu && Gu(e, su, vu, !1)), wc(e));
    }
    function Qu(e, t, n) {
        if (6 & ou) throw Error(r(327));
        for(var i = !n && !(124 & t) && 0 === (t & e.expiredLanes) || Ee(e, t), o = i ? function(e, t) {
            var n = ou;
            ou |= 2;
            var i = Xu(), o = Pu();
            au !== e || su !== t ? (ku = null, wu = re() + 500, Yu(e, t)) : fu = Ee(e, t);
            e: for(;;)try {
                if (0 !== uu && null !== lu) {
                    t = lu;
                    var a = cu;
                    t: switch(uu){
                        case 1:
                            uu = 0, cu = null, nc(e, t, a, 1);
                            break;
                        case 2:
                        case 9:
                            if (_i(a)) {
                                uu = 0, cu = null, tc(t);
                                break;
                            }
                            t = function() {
                                2 !== uu && 9 !== uu || au !== e || (uu = 7), wc(e);
                            }, a.then(t, t);
                            break e;
                        case 3:
                            uu = 7;
                            break e;
                        case 4:
                            uu = 5;
                            break e;
                        case 7:
                            _i(a) ? (uu = 0, cu = null, tc(t)) : (uu = 0, cu = null, nc(e, t, a, 7));
                            break;
                        case 5:
                            var l = null;
                            switch(lu.tag){
                                case 26:
                                    l = lu.memoizedState;
                                case 5:
                                case 27:
                                    var s = lu;
                                    if (!l || Bd(l)) {
                                        uu = 0, cu = null;
                                        var u = s.sibling;
                                        if (null !== u) lu = u;
                                        else {
                                            var c = s.return;
                                            null !== c ? (lu = c, rc(c)) : lu = null;
                                        }
                                        break t;
                                    }
                            }
                            uu = 0, cu = null, nc(e, t, a, 5);
                            break;
                        case 6:
                            uu = 0, cu = null, nc(e, t, a, 6);
                            break;
                        case 8:
                            Ku(), mu = 6;
                            break e;
                        default:
                            throw Error(r(462));
                    }
                }
                $u();
                break;
            } catch (t) {
                Zu(e, t);
            }
            return Mi = Ii = null, T.H = i, T.A = o, ou = n, null !== lu ? 0 : (au = null, su = 0, Cr(), mu);
        }(e, t) : Hu(e, t, !0), a = i;;){
            if (0 === o) {
                fu && !i && Gu(e, t, 0, !1);
                break;
            }
            if (n = e.current.alternate, !a || Wu(n)) {
                if (2 === o) {
                    if (a = t, e.errorRecoveryDisabledLanes & a) var l = 0;
                    else l = 0 !== (l = -536870913 & e.pendingLanes) ? l : 536870912 & l ? 536870912 : 0;
                    if (0 !== l) {
                        t = l;
                        e: {
                            var s = e;
                            o = Mu;
                            var u = s.current.memoizedState.isDehydrated;
                            if (u && (Yu(s, l).flags |= 256), 2 !== (l = Hu(s, l, !1))) {
                                if (hu && !u) {
                                    s.errorRecoveryDisabledLanes |= a, bu |= a, o = 4;
                                    break e;
                                }
                                a = Eu, Eu = o, null !== a && (null === Eu ? Eu = a : Eu.push.apply(Eu, a));
                            }
                            o = l;
                        }
                        if (a = !1, 2 !== o) continue;
                    }
                }
                if (1 === o) {
                    Yu(e, 0), Gu(e, t, 0, !0);
                    break;
                }
                e: {
                    switch(i = e, a = o){
                        case 0:
                        case 1:
                            throw Error(r(345));
                        case 4:
                            if ((4194048 & t) !== t) break;
                        case 6:
                            Gu(i, t, vu, !du);
                            break e;
                        case 2:
                            Eu = null;
                            break;
                        case 3:
                        case 5:
                            break;
                        default:
                            throw Error(r(329));
                    }
                    if ((62914560 & t) === t && 10 < (o = Su + 300 - re())) {
                        if (Gu(i, t, vu, !du), 0 !== Me(i, 0, !0)) break e;
                        i.timeoutHandle = dd(qu.bind(null, i, n, Eu, ku, xu, t, vu, bu, Iu, du, a, 2, -0, 0), o);
                    } else qu(i, n, Eu, ku, xu, t, vu, bu, Iu, du, a, 0, -0, 0);
                }
                break;
            }
            o = Hu(e, t, !1), a = !1;
        }
        wc(e);
    }
    function qu(e, t, n, i, o, a, l, s, u, c, d, f, h, p) {
        if (e.timeoutHandle = -1, (8192 & (f = t.subtreeFlags) || !(16785408 & ~f)) && (Kd = {
            stylesheets: null,
            count: 0,
            unsuspend: Yd
        }, Hs(t), null !== (f = function() {
            if (null === Kd) throw Error(r(475));
            var e = Kd;
            return e.stylesheets && 0 === e.count && Pd(e, e.stylesheets), 0 < e.count ? function(t) {
                var n = setTimeout(function() {
                    if (e.stylesheets && Pd(e, e.stylesheets), e.unsuspend) {
                        var t = e.unsuspend;
                        e.unsuspend = null, t();
                    }
                }, 6e4);
                return e.unsuspend = t, function() {
                    e.unsuspend = null, clearTimeout(n);
                };
            } : null;
        }()))) return e.cancelPendingCommit = f(oc.bind(null, e, t, a, n, i, o, l, s, u, d, 1, h, p)), void Gu(e, a, l, !c);
        oc(e, t, a, n, i, o, l, s, u);
    }
    function Wu(e) {
        for(var t = e;;){
            var n = t.tag;
            if ((0 === n || 11 === n || 15 === n) && 16384 & t.flags && null !== (n = t.updateQueue) && null !== (n = n.stores)) for(var r = 0; r < n.length; r++){
                var i = n[r], o = i.getSnapshot;
                i = i.value;
                try {
                    if (!_n(o(), i)) return !1;
                } catch (e) {
                    return !1;
                }
            }
            if (n = t.child, 16384 & t.subtreeFlags && null !== n) n.return = t, t = n;
            else {
                if (t === e) break;
                for(; null === t.sibling;){
                    if (null === t.return || t.return === e) return !0;
                    t = t.return;
                }
                t.sibling.return = t.return, t = t.sibling;
            }
        }
        return !0;
    }
    function Gu(e, t, n, r) {
        t &= ~yu, t &= ~bu, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
        for(var i = t; 0 < i;){
            var o = 31 - me(i), a = 1 << o;
            r[o] = -1, i &= ~a;
        }
        0 !== n && Ue(e, n, t);
    }
    function Bu() {
        return !!(6 & ou) || (kc(0), !1);
    }
    function Ku() {
        if (null !== lu) {
            if (0 === uu) var e = lu.return;
            else Mi = Ii = null, qo(e = lu), _a = null, $a = 0, e = lu;
            for(; null !== e;)ss(e.alternate, e), e = e.return;
            lu = null;
        }
    }
    function Yu(e, t) {
        var n = e.timeoutHandle;
        -1 !== n && (e.timeoutHandle = -1, fd(n)), null !== (n = e.cancelPendingCommit) && (e.cancelPendingCommit = null, n()), Ku(), au = e, lu = n = qr(e.current, null), su = t, uu = 0, cu = null, du = !1, fu = Ee(e, t), hu = !1, Iu = vu = yu = bu = gu = mu = 0, Eu = Mu = null, xu = !1, 8 & t && (t |= 32 & t);
        var r = e.entangledLanes;
        if (0 !== r) for(e = e.entanglements, r &= t; 0 < r;){
            var i = 31 - me(r), o = 1 << i;
            t |= e[i], r &= ~o;
        }
        return pu = t, Cr(), n;
    }
    function Zu(e, t) {
        xo = null, T.H = Xa, t === Xi || t === Ji ? (t = no(), uu = 3) : t === Pi ? (t = no(), uu = 4) : uu = t === Rl ? 8 : null !== t && "object" == typeof t && "function" == typeof t.then ? 6 : 1, cu = t, null === lu && (mu = 1, Sl(e, Nr(t, e.current)));
    }
    function Xu() {
        var e = T.H;
        return T.H = Xa, null === e ? Xa : e;
    }
    function Pu() {
        var e = T.A;
        return T.A = ru, e;
    }
    function Ju() {
        mu = 4, du || (4194048 & su) !== su && null !== ll.current || (fu = !0), !(134217727 & gu) && !(134217727 & bu) || null === au || Gu(au, su, vu, !1);
    }
    function Hu(e, t, n) {
        var r = ou;
        ou |= 2;
        var i = Xu(), o = Pu();
        au === e && su === t || (ku = null, Yu(e, t)), t = !1;
        var a = mu;
        e: for(;;)try {
            if (0 !== uu && null !== lu) {
                var l = lu, s = cu;
                switch(uu){
                    case 8:
                        Ku(), a = 6;
                        break e;
                    case 3:
                    case 2:
                    case 9:
                    case 6:
                        null === ll.current && (t = !0);
                        var u = uu;
                        if (uu = 0, cu = null, nc(e, l, s, u), n && fu) {
                            a = 0;
                            break e;
                        }
                        break;
                    default:
                        u = uu, uu = 0, cu = null, nc(e, l, s, u);
                }
            }
            _u(), a = mu;
            break;
        } catch (t) {
            Zu(e, t);
        }
        return t && e.shellSuspendCounter++, Mi = Ii = null, ou = r, T.H = i, T.A = o, null === lu && (au = null, su = 0, Cr()), a;
    }
    function _u() {
        for(; null !== lu;)ec(lu);
    }
    function $u() {
        for(; null !== lu && !te();)ec(lu);
    }
    function ec(e) {
        var t = es(e.alternate, e, pu);
        e.memoizedProps = e.pendingProps, null === t ? rc(e) : lu = t;
    }
    function tc(e) {
        var t = e, n = t.alternate;
        switch(t.tag){
            case 15:
            case 0:
                t = Ol(n, t, t.pendingProps, t.type, void 0, su);
                break;
            case 11:
                t = Ol(n, t, t.pendingProps, t.type.render, t.ref, su);
                break;
            case 5:
                qo(t);
            default:
                ss(n, t), t = es(n, t = lu = Wr(t, pu), pu);
        }
        e.memoizedProps = e.pendingProps, null === t ? rc(e) : lu = t;
    }
    function nc(e, t, n, i) {
        Mi = Ii = null, qo(t), _a = null, $a = 0;
        var o = t.return;
        try {
            if (function(e, t, n, i, o) {
                if (n.flags |= 32768, null !== i && "object" == typeof i && "function" == typeof i.then) {
                    if (null !== (t = n.alternate) && ki(t, n, o, !0), null !== (n = ll.current)) {
                        switch(n.tag){
                            case 13:
                                return null === sl ? Ju() : null === n.alternate && 0 === mu && (mu = 3), n.flags &= -257, n.flags |= 65536, n.lanes = o, i === Hi ? n.flags |= 16384 : (null === (t = n.updateQueue) ? n.updateQueue = new Set([
                                    i
                                ]) : t.add(i), pc(e, i, o)), !1;
                            case 22:
                                return n.flags |= 65536, i === Hi ? n.flags |= 16384 : (null === (t = n.updateQueue) ? (t = {
                                    transitions: null,
                                    markerInstances: null,
                                    retryQueue: new Set([
                                        i
                                    ])
                                }, n.updateQueue = t) : null === (n = t.retryQueue) ? t.retryQueue = new Set([
                                    i
                                ]) : n.add(i), pc(e, i, o)), !1;
                        }
                        throw Error(r(435, n.tag));
                    }
                    return pc(e, i, o), Ju(), !1;
                }
                if (si) return null !== (t = ll.current) ? (!(65536 & t.flags) && (t.flags |= 256), t.flags |= 65536, t.lanes = o, i !== di && yi(Nr(e = Error(r(422), {
                    cause: i
                }), n))) : (i !== di && yi(Nr(t = Error(r(423), {
                    cause: i
                }), n)), (e = e.current.alternate).flags |= 65536, o &= -o, e.lanes |= o, i = Nr(i, n), co(e, o = kl(e.stateNode, i, o)), 4 !== mu && (mu = 2)), !1;
                var a = Error(r(520), {
                    cause: i
                });
                if (a = Nr(a, n), null === Mu ? Mu = [
                    a
                ] : Mu.push(a), 4 !== mu && (mu = 2), null === t) return !0;
                i = Nr(i, n), n = t;
                do {
                    switch(n.tag){
                        case 3:
                            return n.flags |= 65536, e = o & -o, n.lanes |= e, co(n, e = kl(n.stateNode, i, e)), !1;
                        case 1:
                            if (t = n.type, a = n.stateNode, !(128 & n.flags || "function" != typeof t.getDerivedStateFromError && (null === a || "function" != typeof a.componentDidCatch || null !== Nu && Nu.has(a)))) return n.flags |= 65536, o &= -o, n.lanes |= o, Ul(o = Nl(o), e, n, i), co(n, o), !1;
                    }
                    n = n.return;
                }while (null !== n);
                return !1;
            }(e, o, t, n, su)) return mu = 1, Sl(e, Nr(n, e.current)), void (lu = null);
        } catch (t) {
            if (null !== o) throw lu = o, t;
            return mu = 1, Sl(e, Nr(n, e.current)), void (lu = null);
        }
        32768 & t.flags ? (si || 1 === i ? e = !0 : fu || 536870912 & su ? e = !1 : (du = e = !0, (2 === i || 9 === i || 3 === i || 6 === i) && null !== (i = ll.current) && 13 === i.tag && (i.flags |= 16384)), ic(t, e)) : rc(t);
    }
    function rc(e) {
        var t = e;
        do {
            if (32768 & t.flags) return void ic(t, du);
            e = t.return;
            var n = as(t.alternate, t, pu);
            if (null !== n) return void (lu = n);
            if (null !== (t = t.sibling)) return void (lu = t);
            lu = t = e;
        }while (null !== t);
        0 === mu && (mu = 5);
    }
    function ic(e, t) {
        do {
            var n = ls(e.alternate, e);
            if (null !== n) return n.flags &= 32767, void (lu = n);
            if (null !== (n = e.return) && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && null !== (e = e.sibling)) return void (lu = e);
            lu = e = n;
        }while (null !== e);
        mu = 6, lu = null;
    }
    function oc(e, t, n, i, o, a, l, s, u) {
        e.cancelPendingCommit = null;
        do cc();
        while (0 !== Uu);
        if (6 & ou) throw Error(r(327));
        if (null !== t) {
            if (t === e.current) throw Error(r(177));
            if (a = t.lanes | t.childLanes, function(e, t, n, r, i, o) {
                var a = e.pendingLanes;
                e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
                var l = e.entanglements, s = e.expirationTimes, u = e.hiddenUpdates;
                for(n = a & ~n; 0 < n;){
                    var c = 31 - me(n), d = 1 << c;
                    l[c] = 0, s[c] = -1;
                    var f = u[c];
                    if (null !== f) for(u[c] = null, c = 0; c < f.length; c++){
                        var h = f[c];
                        null !== h && (h.lane &= -536870913);
                    }
                    n &= ~d;
                }
                0 !== r && Ue(e, r, 0), 0 !== o && 0 === i && 0 !== e.tag && (e.suspendedLanes |= o & ~(a & ~t));
            }(e, n, a |= Lr, l, s, u), e === au && (lu = au = null, su = 0), Lu = t, Ru = e, Cu = n, zu = a, Tu = o, Du = i, 10256 & t.subtreeFlags || 10256 & t.flags ? (e.callbackNode = null, e.callbackPriority = 0, $(le, function() {
                return dc(), null;
            })) : (e.callbackNode = null, e.callbackPriority = 0), i = !!(13878 & t.flags), 13878 & t.subtreeFlags || i) {
                i = T.T, T.T = null, o = F.p, F.p = 2, l = ou, ou |= 4;
                try {
                    !function(e, t) {
                        if (e = e.containerInfo, id = af, ir(e = rr(e))) {
                            if ("selectionStart" in e) var n = {
                                start: e.selectionStart,
                                end: e.selectionEnd
                            };
                            else e: {
                                var i = (n = (n = e.ownerDocument) && n.defaultView || window).getSelection && n.getSelection();
                                if (i && 0 !== i.rangeCount) {
                                    n = i.anchorNode;
                                    var o = i.anchorOffset, a = i.focusNode;
                                    i = i.focusOffset;
                                    try {
                                        n.nodeType, a.nodeType;
                                    } catch (e) {
                                        n = null;
                                        break e;
                                    }
                                    var l = 0, s = -1, u = -1, c = 0, d = 0, f = e, h = null;
                                    t: for(;;){
                                        for(var p; f !== n || 0 !== o && 3 !== f.nodeType || (s = l + o), f !== a || 0 !== i && 3 !== f.nodeType || (u = l + i), 3 === f.nodeType && (l += f.nodeValue.length), null !== (p = f.firstChild);)h = f, f = p;
                                        for(;;){
                                            if (f === e) break t;
                                            if (h === n && ++c === o && (s = l), h === a && ++d === i && (u = l), null !== (p = f.nextSibling)) break;
                                            h = (f = h).parentNode;
                                        }
                                        f = p;
                                    }
                                    n = -1 === s || -1 === u ? null : {
                                        start: s,
                                        end: u
                                    };
                                } else n = null;
                            }
                            n = n || {
                                start: 0,
                                end: 0
                            };
                        } else n = null;
                        for(od = {
                            focusedElem: e,
                            selectionRange: n
                        }, af = !1, ks = t; null !== ks;)if (e = (t = ks).child, 1024 & t.subtreeFlags && null !== e) e.return = t, ks = e;
                        else for(; null !== ks;){
                            switch(a = (t = ks).alternate, e = t.flags, t.tag){
                                case 0:
                                case 11:
                                case 15:
                                case 5:
                                case 26:
                                case 27:
                                case 6:
                                case 4:
                                case 17:
                                    break;
                                case 1:
                                    if (1024 & e && null !== a) {
                                        e = void 0, n = t, o = a.memoizedProps, a = a.memoizedState, i = n.stateNode;
                                        try {
                                            var m = vl(n.type, o, (n.elementType, n.type));
                                            e = i.getSnapshotBeforeUpdate(m, a), i.__reactInternalSnapshotBeforeUpdate = e;
                                        } catch (e) {
                                            hc(n, n.return, e);
                                        }
                                    }
                                    break;
                                case 3:
                                    if (1024 & e) {
                                        if (9 === (n = (e = t.stateNode.containerInfo).nodeType)) yd(e);
                                        else if (1 === n) switch(e.nodeName){
                                            case "HEAD":
                                            case "HTML":
                                            case "BODY":
                                                yd(e);
                                                break;
                                            default:
                                                e.textContent = "";
                                        }
                                    }
                                    break;
                                default:
                                    if (1024 & e) throw Error(r(163));
                            }
                            if (null !== (e = t.sibling)) {
                                e.return = t.return, ks = e;
                                break;
                            }
                            ks = t.return;
                        }
                    }(e, t);
                } finally{
                    ou = l, F.p = o, T.T = i;
                }
            }
            Uu = 1, ac(), lc(), sc();
        }
    }
    function ac() {
        if (1 === Uu) {
            Uu = 0;
            var e = Ru, t = Lu, n = !!(13878 & t.flags);
            if (13878 & t.subtreeFlags || n) {
                n = T.T, T.T = null;
                var r = F.p;
                F.p = 2;
                var i = ou;
                ou |= 4;
                try {
                    As(t, e);
                    var o = od, a = rr(e.containerInfo), l = o.focusedElem, s = o.selectionRange;
                    if (a !== l && l && l.ownerDocument && nr(l.ownerDocument.documentElement, l)) {
                        if (null !== s && ir(l)) {
                            var u = s.start, c = s.end;
                            if (void 0 === c && (c = u), "selectionStart" in l) l.selectionStart = u, l.selectionEnd = Math.min(c, l.value.length);
                            else {
                                var d = l.ownerDocument || document, f = d && d.defaultView || window;
                                if (f.getSelection) {
                                    var h = f.getSelection(), p = l.textContent.length, m = Math.min(s.start, p), g = void 0 === s.end ? m : Math.min(s.end, p);
                                    !h.extend && m > g && (a = g, g = m, m = a);
                                    var b = tr(l, m), y = tr(l, g);
                                    if (b && y && (1 !== h.rangeCount || h.anchorNode !== b.node || h.anchorOffset !== b.offset || h.focusNode !== y.node || h.focusOffset !== y.offset)) {
                                        var v = d.createRange();
                                        v.setStart(b.node, b.offset), h.removeAllRanges(), m > g ? (h.addRange(v), h.extend(y.node, y.offset)) : (v.setEnd(y.node, y.offset), h.addRange(v));
                                    }
                                }
                            }
                        }
                        for(d = [], h = l; h = h.parentNode;)1 === h.nodeType && d.push({
                            element: h,
                            left: h.scrollLeft,
                            top: h.scrollTop
                        });
                        for("function" == typeof l.focus && l.focus(), l = 0; l < d.length; l++){
                            var I = d[l];
                            I.element.scrollLeft = I.left, I.element.scrollTop = I.top;
                        }
                    }
                    af = !!id, od = id = null;
                } finally{
                    ou = i, F.p = r, T.T = n;
                }
            }
            e.current = t, Uu = 2;
        }
    }
    function lc() {
        if (2 === Uu) {
            Uu = 0;
            var e = Ru, t = Lu, n = !!(8772 & t.flags);
            if (8772 & t.subtreeFlags || n) {
                n = T.T, T.T = null;
                var r = F.p;
                F.p = 2;
                var i = ou;
                ou |= 4;
                try {
                    Ns(e, t.alternate, t);
                } finally{
                    ou = i, F.p = r, T.T = n;
                }
            }
            Uu = 3;
        }
    }
    function sc() {
        if (4 === Uu || 3 === Uu) {
            Uu = 0, ne();
            var e = Ru, t = Lu, n = Cu, r = Du;
            10256 & t.subtreeFlags || 10256 & t.flags ? Uu = 5 : (Uu = 0, Lu = Ru = null, uc(e, e.pendingLanes));
            var i = e.pendingLanes;
            if (0 === i && (Nu = null), Ce(n), t = t.stateNode, he && "function" == typeof he.onCommitFiberRoot) try {
                he.onCommitFiberRoot(fe, t, void 0, !(128 & ~t.current.flags));
            } catch (e) {}
            if (null !== r) {
                t = T.T, i = F.p, F.p = 2, T.T = null;
                try {
                    for(var o = e.onRecoverableError, a = 0; a < r.length; a++){
                        var l = r[a];
                        o(l.value, {
                            componentStack: l.stack
                        });
                    }
                } finally{
                    T.T = t, F.p = i;
                }
            }
            3 & Cu && cc(), wc(e), i = e.pendingLanes, 4194090 & n && 42 & i ? e === Vu ? Fu++ : (Fu = 0, Vu = e) : Fu = 0, kc(0);
        }
    }
    function uc(e, t) {
        0 === (e.pooledCacheLanes &= t) && null != (t = e.pooledCache) && (e.pooledCache = null, Ai(t));
    }
    function cc(e) {
        return ac(), lc(), sc(), dc();
    }
    function dc() {
        if (5 !== Uu) return !1;
        var e = Ru, t = zu;
        zu = 0;
        var n = Ce(Cu), i = T.T, o = F.p;
        try {
            F.p = 32 > n ? 32 : n, T.T = null, n = Tu, Tu = null;
            var a = Ru, l = Cu;
            if (Uu = 0, Lu = Ru = null, Cu = 0, 6 & ou) throw Error(r(331));
            var s = ou;
            if (ou |= 4, eu(a.current), Ys(a, a.current, l, n), ou = s, kc(0, !1), he && "function" == typeof he.onPostCommitFiberRoot) try {
                he.onPostCommitFiberRoot(fe, a);
            } catch (e) {}
            return !0;
        } finally{
            F.p = o, T.T = i, uc(e, t);
        }
    }
    function fc(e, t, n) {
        t = Nr(n, t), null !== (e = so(e, t = kl(e.stateNode, t, 2), 2)) && (Ne(e, 2), wc(e));
    }
    function hc(e, t, n) {
        if (3 === e.tag) fc(e, e, n);
        else for(; null !== t;){
            if (3 === t.tag) {
                fc(t, e, n);
                break;
            }
            if (1 === t.tag) {
                var r = t.stateNode;
                if ("function" == typeof t.type.getDerivedStateFromError || "function" == typeof r.componentDidCatch && (null === Nu || !Nu.has(r))) {
                    e = Nr(n, e), null !== (r = so(t, n = Nl(2), 2)) && (Ul(n, r, t, e), Ne(r, 2), wc(r));
                    break;
                }
            }
            t = t.return;
        }
    }
    function pc(e, t, n) {
        var r = e.pingCache;
        if (null === r) {
            r = e.pingCache = new iu;
            var i = new Set;
            r.set(t, i);
        } else void 0 === (i = r.get(t)) && (i = new Set, r.set(t, i));
        i.has(n) || (hu = !0, i.add(n), e = mc.bind(null, e, t, n), t.then(e, e));
    }
    function mc(e, t, n) {
        var r = e.pingCache;
        null !== r && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, au === e && (su & n) === n && (4 === mu || 3 === mu && (62914560 & su) === su && 300 > re() - Su ? !(2 & ou) && Yu(e, 0) : yu |= n, Iu === su && (Iu = 0)), wc(e);
    }
    function gc(e, t) {
        0 === t && (t = we()), null !== (e = Dr(e, t)) && (Ne(e, t), wc(e));
    }
    function bc(e) {
        var t = e.memoizedState, n = 0;
        null !== t && (n = t.retryLane), gc(e, n);
    }
    function yc(e, t) {
        var n = 0;
        switch(e.tag){
            case 13:
                var i = e.stateNode, o = e.memoizedState;
                null !== o && (n = o.retryLane);
                break;
            case 19:
                i = e.stateNode;
                break;
            case 22:
                i = e.stateNode._retryCache;
                break;
            default:
                throw Error(r(314));
        }
        null !== i && i.delete(t), gc(e, n);
    }
    var vc = null, Ic = null, Mc = !1, Ec = !1, xc = !1, Sc = 0;
    function wc(e) {
        e !== Ic && null === e.next && (null === Ic ? vc = Ic = e : Ic = Ic.next = e), Ec = !0, Mc || (Mc = !0, pd(function() {
            6 & ou ? $(oe, Nc) : Uc();
        }));
    }
    function kc(e, t) {
        if (!xc && Ec) {
            xc = !0;
            do for(var n = !1, r = vc; null !== r;){
                if (0 !== e) {
                    var i = r.pendingLanes;
                    if (0 === i) var o = 0;
                    else {
                        var a = r.suspendedLanes, l = r.pingedLanes;
                        o = (1 << 31 - me(42 | e) + 1) - 1, o = 201326741 & (o &= i & ~(a & ~l)) ? 201326741 & o | 1 : o ? 2 | o : 0;
                    }
                    0 !== o && (n = !0, Cc(r, o));
                } else o = su, !(3 & (o = Me(r, r === au ? o : 0, null !== r.cancelPendingCommit || -1 !== r.timeoutHandle))) || Ee(r, o) || (n = !0, Cc(r, o));
                r = r.next;
            }
            while (n);
            xc = !1;
        }
    }
    function Nc() {
        Uc();
    }
    function Uc() {
        Ec = Mc = !1;
        var e = 0;
        0 !== Sc && (function() {
            var e = window.event;
            if (e && "popstate" === e.type) return e !== cd && (cd = e, !0);
            return cd = null, !1;
        }() && (e = Sc), Sc = 0);
        for(var t = re(), n = null, r = vc; null !== r;){
            var i = r.next, o = Rc(r, t);
            0 === o ? (r.next = null, null === n ? vc = i : n.next = i, null === i && (Ic = n)) : (n = r, (0 !== e || 3 & o) && (Ec = !0)), r = i;
        }
        kc(e);
    }
    function Rc(e, t) {
        for(var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, o = -62914561 & e.pendingLanes; 0 < o;){
            var a = 31 - me(o), l = 1 << a, s = i[a];
            -1 === s ? 0 !== (l & n) && 0 === (l & r) || (i[a] = xe(l, t)) : s <= t && (e.expiredLanes |= l), o &= ~l;
        }
        if (n = su, n = Me(e, e === (t = au) ? n : 0, null !== e.cancelPendingCommit || -1 !== e.timeoutHandle), r = e.callbackNode, 0 === n || e === t && (2 === uu || 9 === uu) || null !== e.cancelPendingCommit) return null !== r && null !== r && ee(r), e.callbackNode = null, e.callbackPriority = 0;
        if (!(3 & n) || Ee(e, n)) {
            if ((t = n & -n) === e.callbackPriority) return t;
            switch(null !== r && ee(r), Ce(n)){
                case 2:
                case 8:
                    n = ae;
                    break;
                case 32:
                default:
                    n = le;
                    break;
                case 268435456:
                    n = ue;
            }
            return r = Lc.bind(null, e), n = $(n, r), e.callbackPriority = t, e.callbackNode = n, t;
        }
        return null !== r && null !== r && ee(r), e.callbackPriority = 2, e.callbackNode = null, 2;
    }
    function Lc(e, t) {
        if (0 !== Uu && 5 !== Uu) return e.callbackNode = null, e.callbackPriority = 0, null;
        var n = e.callbackNode;
        if (cc() && e.callbackNode !== n) return null;
        var r = su;
        return 0 === (r = Me(e, e === au ? r : 0, null !== e.cancelPendingCommit || -1 !== e.timeoutHandle)) ? null : (Qu(e, r, t), Rc(e, re()), null != e.callbackNode && e.callbackNode === n ? Lc.bind(null, e) : null);
    }
    function Cc(e, t) {
        if (cc()) return null;
        Qu(e, t, !0);
    }
    function zc() {
        return 0 === Sc && (Sc = Se()), Sc;
    }
    function Tc(e) {
        return null == e || "symbol" == typeof e || "boolean" == typeof e ? null : "function" == typeof e ? e : Ct("" + e);
    }
    function Dc(e, t) {
        var n = t.ownerDocument.createElement("input");
        return n.name = t.name, n.value = t.value, e.id && n.setAttribute("form", e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
    }
    for(var Fc = 0; Fc < Sr.length; Fc++){
        var Vc = Sr[Fc];
        wr(Vc.toLowerCase(), "on" + (Vc[0].toUpperCase() + Vc.slice(1)));
    }
    wr(gr, "onAnimationEnd"), wr(br, "onAnimationIteration"), wr(yr, "onAnimationStart"), wr("dblclick", "onDoubleClick"), wr("focusin", "onFocus"), wr("focusout", "onBlur"), wr(vr, "onTransitionRun"), wr(Ir, "onTransitionStart"), wr(Mr, "onTransitionCancel"), wr(Er, "onTransitionEnd"), He("onMouseEnter", [
        "mouseout",
        "mouseover"
    ]), He("onMouseLeave", [
        "mouseout",
        "mouseover"
    ]), He("onPointerEnter", [
        "pointerout",
        "pointerover"
    ]), He("onPointerLeave", [
        "pointerout",
        "pointerover"
    ]), Je("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), Je("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), Je("onBeforeInput", [
        "compositionend",
        "keypress",
        "textInput",
        "paste"
    ]), Je("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), Je("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), Je("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var Ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), jc = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Ac));
    function Oc(e, t) {
        t = !!(4 & t);
        for(var n = 0; n < e.length; n++){
            var r = e[n], i = r.event;
            r = r.listeners;
            e: {
                var o = void 0;
                if (t) for(var a = r.length - 1; 0 <= a; a--){
                    var l = r[a], s = l.instance, u = l.currentTarget;
                    if (l = l.listener, s !== o && i.isPropagationStopped()) break e;
                    o = l, i.currentTarget = u;
                    try {
                        o(i);
                    } catch (e) {
                        Il(e);
                    }
                    i.currentTarget = null, o = s;
                }
                else for(a = 0; a < r.length; a++){
                    if (s = (l = r[a]).instance, u = l.currentTarget, l = l.listener, s !== o && i.isPropagationStopped()) break e;
                    o = l, i.currentTarget = u;
                    try {
                        o(i);
                    } catch (e) {
                        Il(e);
                    }
                    i.currentTarget = null, o = s;
                }
            }
        }
    }
    function Qc(e, t) {
        var n = t[Ae];
        void 0 === n && (n = t[Ae] = new Set);
        var r = e + "__bubble";
        n.has(r) || (Bc(t, e, 2, !1), n.add(r));
    }
    function qc(e, t, n) {
        var r = 0;
        t && (r |= 4), Bc(n, e, r, t);
    }
    var Wc = "_reactListening" + Math.random().toString(36).slice(2);
    function Gc(e) {
        if (!e[Wc]) {
            e[Wc] = !0, Xe.forEach(function(t) {
                "selectionchange" !== t && (jc.has(t) || qc(t, !1, e), qc(t, !0, e));
            });
            var t = 9 === e.nodeType ? e : e.ownerDocument;
            null === t || t[Wc] || (t[Wc] = !0, qc("selectionchange", !1, t));
        }
    }
    function Bc(e, t, n, r) {
        switch(hf(t)){
            case 2:
                var i = lf;
                break;
            case 8:
                i = sf;
                break;
            default:
                i = uf;
        }
        n = i.bind(null, t, n, e), i = void 0, !qt || "touchstart" !== t && "touchmove" !== t && "wheel" !== t || (i = !0), r ? void 0 !== i ? e.addEventListener(t, n, {
            capture: !0,
            passive: i
        }) : e.addEventListener(t, n, !0) : void 0 !== i ? e.addEventListener(t, n, {
            passive: i
        }) : e.addEventListener(t, n, !1);
    }
    function Kc(e, t, n, r, i) {
        var a = r;
        if (!(1 & t || 2 & t || null === r)) e: for(;;){
            if (null === r) return;
            var l = r.tag;
            if (3 === l || 4 === l) {
                var s = r.stateNode.containerInfo;
                if (s === i) break;
                if (4 === l) for(l = r.return; null !== l;){
                    var u = l.tag;
                    if ((3 === u || 4 === u) && l.stateNode.containerInfo === i) return;
                    l = l.return;
                }
                for(; null !== s;){
                    if (null === (l = Ge(s))) return;
                    if (5 === (u = l.tag) || 6 === u || 26 === u || 27 === u) {
                        r = a = l;
                        continue e;
                    }
                    s = s.parentNode;
                }
            }
            r = r.return;
        }
        jt(function() {
            var r = a, i = Tt(n), l = [];
            e: {
                var s = xr.get(e);
                if (void 0 !== s) {
                    var u = tn, c = e;
                    switch(e){
                        case "keypress":
                            if (0 === Zt(n)) break e;
                        case "keydown":
                        case "keyup":
                            u = yn;
                            break;
                        case "focusin":
                            c = "focus", u = sn;
                            break;
                        case "focusout":
                            c = "blur", u = sn;
                            break;
                        case "beforeblur":
                        case "afterblur":
                            u = sn;
                            break;
                        case "click":
                            if (2 === n.button) break e;
                        case "auxclick":
                        case "dblclick":
                        case "mousedown":
                        case "mousemove":
                        case "mouseup":
                        case "mouseout":
                        case "mouseover":
                        case "contextmenu":
                            u = an;
                            break;
                        case "drag":
                        case "dragend":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "dragstart":
                        case "drop":
                            u = ln;
                            break;
                        case "touchcancel":
                        case "touchend":
                        case "touchmove":
                        case "touchstart":
                            u = In;
                            break;
                        case gr:
                        case br:
                        case yr:
                            u = un;
                            break;
                        case Er:
                            u = Mn;
                            break;
                        case "scroll":
                        case "scrollend":
                            u = rn;
                            break;
                        case "wheel":
                            u = En;
                            break;
                        case "copy":
                        case "cut":
                        case "paste":
                            u = cn;
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "pointerup":
                            u = vn;
                            break;
                        case "toggle":
                        case "beforetoggle":
                            u = xn;
                    }
                    var d = !!(4 & t), f = !d && ("scroll" === e || "scrollend" === e), h = d ? null !== s ? s + "Capture" : null : s;
                    d = [];
                    for(var p, m = r; null !== m;){
                        var g = m;
                        if (p = g.stateNode, 5 !== (g = g.tag) && 26 !== g && 27 !== g || null === p || null === h || null != (g = Ot(m, h)) && d.push(Yc(m, g, p)), f) break;
                        m = m.return;
                    }
                    0 < d.length && (s = new u(s, c, null, n, i), l.push({
                        event: s,
                        listeners: d
                    }));
                }
            }
            if (!(7 & t)) {
                if (u = "mouseout" === e || "pointerout" === e, (!(s = "mouseover" === e || "pointerover" === e) || n === zt || !(c = n.relatedTarget || n.fromElement) || !Ge(c) && !c[Ve]) && (u || s) && (s = i.window === i ? i : (s = i.ownerDocument) ? s.defaultView || s.parentWindow : window, u ? (u = r, null !== (c = (c = n.relatedTarget || n.toElement) ? Ge(c) : null) && (f = o(c), d = c.tag, c !== f || 5 !== d && 27 !== d && 6 !== d) && (c = null)) : (u = null, c = r), u !== c)) {
                    if (d = an, g = "onMouseLeave", h = "onMouseEnter", m = "mouse", "pointerout" !== e && "pointerover" !== e || (d = vn, g = "onPointerLeave", h = "onPointerEnter", m = "pointer"), f = null == u ? s : Ke(u), p = null == c ? s : Ke(c), (s = new d(g, m + "leave", u, n, i)).target = f, s.relatedTarget = p, g = null, Ge(i) === r && ((d = new d(h, m + "enter", c, n, i)).target = p, d.relatedTarget = f, g = d), f = g, u && c) e: {
                        for(h = c, m = 0, p = d = u; p; p = Xc(p))m++;
                        for(p = 0, g = h; g; g = Xc(g))p++;
                        for(; 0 < m - p;)d = Xc(d), m--;
                        for(; 0 < p - m;)h = Xc(h), p--;
                        for(; m--;){
                            if (d === h || null !== h && d === h.alternate) break e;
                            d = Xc(d), h = Xc(h);
                        }
                        d = null;
                    }
                    else d = null;
                    null !== u && Pc(l, s, u, d, !1), null !== c && null !== f && Pc(l, f, c, d, !0);
                }
                if ("select" === (u = (s = r ? Ke(r) : window).nodeName && s.nodeName.toLowerCase()) || "input" === u && "file" === s.type) var b = qn;
                else if (Fn(s)) {
                    if (Wn) b = Hn;
                    else {
                        b = Pn;
                        var y = Xn;
                    }
                } else !(u = s.nodeName) || "input" !== u.toLowerCase() || "checkbox" !== s.type && "radio" !== s.type ? r && Ut(r.elementType) && (b = qn) : b = Jn;
                switch(b && (b = b(e, r)) ? Vn(l, b, n, i) : (y && y(e, s, r), "focusout" === e && r && "number" === s.type && null != r.memoizedProps.value && It(s, "number", s.value)), y = r ? Ke(r) : window, e){
                    case "focusin":
                        (Fn(y) || "true" === y.contentEditable) && (ar = y, lr = r, sr = null);
                        break;
                    case "focusout":
                        sr = lr = ar = null;
                        break;
                    case "mousedown":
                        ur = !0;
                        break;
                    case "contextmenu":
                    case "mouseup":
                    case "dragend":
                        ur = !1, cr(l, n, i);
                        break;
                    case "selectionchange":
                        if (or) break;
                    case "keydown":
                    case "keyup":
                        cr(l, n, i);
                }
                var v;
                if (wn) e: {
                    switch(e){
                        case "compositionstart":
                            var I = "onCompositionStart";
                            break e;
                        case "compositionend":
                            I = "onCompositionEnd";
                            break e;
                        case "compositionupdate":
                            I = "onCompositionUpdate";
                            break e;
                    }
                    I = void 0;
                }
                else Tn ? Cn(e, n) && (I = "onCompositionEnd") : "keydown" === e && 229 === n.keyCode && (I = "onCompositionStart");
                I && (Un && "ko" !== n.locale && (Tn || "onCompositionStart" !== I ? "onCompositionEnd" === I && Tn && (v = Yt()) : (Bt = "value" in (Gt = i) ? Gt.value : Gt.textContent, Tn = !0)), 0 < (y = Zc(r, I)).length && (I = new dn(I, e, null, n, i), l.push({
                    event: I,
                    listeners: y
                }), v ? I.data = v : null !== (v = zn(n)) && (I.data = v))), (v = Nn ? function(e, t) {
                    switch(e){
                        case "compositionend":
                            return zn(t);
                        case "keypress":
                            return 32 !== t.which ? null : (Ln = !0, Rn);
                        case "textInput":
                            return (e = t.data) === Rn && Ln ? null : e;
                        default:
                            return null;
                    }
                }(e, n) : function(e, t) {
                    if (Tn) return "compositionend" === e || !wn && Cn(e, t) ? (e = Yt(), Kt = Bt = Gt = null, Tn = !1, e) : null;
                    switch(e){
                        case "paste":
                        default:
                            return null;
                        case "keypress":
                            if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                                if (t.char && 1 < t.char.length) return t.char;
                                if (t.which) return String.fromCharCode(t.which);
                            }
                            return null;
                        case "compositionend":
                            return Un && "ko" !== t.locale ? null : t.data;
                    }
                }(e, n)) && 0 < (I = Zc(r, "onBeforeInput")).length && (y = new dn("onBeforeInput", "beforeinput", null, n, i), l.push({
                    event: y,
                    listeners: I
                }), y.data = v), function(e, t, n, r, i) {
                    if ("submit" === t && n && n.stateNode === i) {
                        var o = Tc((i[Fe] || null).action), a = r.submitter;
                        a && null !== (t = (t = a[Fe] || null) ? Tc(t.formAction) : a.getAttribute("formAction")) && (o = t, a = null);
                        var l = new tn("action", "action", null, r, i);
                        e.push({
                            event: l,
                            listeners: [
                                {
                                    instance: null,
                                    listener: function() {
                                        if (r.defaultPrevented) {
                                            if (0 !== Sc) {
                                                var e = a ? Dc(i, a) : new FormData(i);
                                                Da(n, {
                                                    pending: !0,
                                                    data: e,
                                                    method: i.method,
                                                    action: o
                                                }, null, e);
                                            }
                                        } else "function" == typeof o && (l.preventDefault(), e = a ? Dc(i, a) : new FormData(i), Da(n, {
                                            pending: !0,
                                            data: e,
                                            method: i.method,
                                            action: o
                                        }, o, e));
                                    },
                                    currentTarget: i
                                }
                            ]
                        });
                    }
                }(l, e, r, n, i);
            }
            Oc(l, t);
        });
    }
    function Yc(e, t, n) {
        return {
            instance: e,
            listener: t,
            currentTarget: n
        };
    }
    function Zc(e, t) {
        for(var n = t + "Capture", r = []; null !== e;){
            var i = e, o = i.stateNode;
            if (5 !== (i = i.tag) && 26 !== i && 27 !== i || null === o || (null != (i = Ot(e, n)) && r.unshift(Yc(e, i, o)), null != (i = Ot(e, t)) && r.push(Yc(e, i, o))), 3 === e.tag) return r;
            e = e.return;
        }
        return [];
    }
    function Xc(e) {
        if (null === e) return null;
        do e = e.return;
        while (e && 5 !== e.tag && 27 !== e.tag);
        return e || null;
    }
    function Pc(e, t, n, r, i) {
        for(var o = t._reactName, a = []; null !== n && n !== r;){
            var l = n, s = l.alternate, u = l.stateNode;
            if (l = l.tag, null !== s && s === r) break;
            5 !== l && 26 !== l && 27 !== l || null === u || (s = u, i ? null != (u = Ot(n, o)) && a.unshift(Yc(n, u, s)) : i || null != (u = Ot(n, o)) && a.push(Yc(n, u, s))), n = n.return;
        }
        0 !== a.length && e.push({
            event: t,
            listeners: a
        });
    }
    var Jc = /\r\n?/g, Hc = /\u0000|\uFFFD/g;
    function _c(e) {
        return ("string" == typeof e ? e : "" + e).replace(Jc, "\n").replace(Hc, "");
    }
    function $c(e, t) {
        return t = _c(t), _c(e) === t;
    }
    function ed() {}
    function td(e, t, n, i, o, a) {
        switch(n){
            case "children":
                "string" == typeof i ? "body" === t || "textarea" === t && "" === i || St(e, i) : ("number" == typeof i || "bigint" == typeof i) && "body" !== t && St(e, "" + i);
                break;
            case "className":
                it(e, "class", i);
                break;
            case "tabIndex":
                it(e, "tabindex", i);
                break;
            case "dir":
            case "role":
            case "viewBox":
            case "width":
            case "height":
                it(e, n, i);
                break;
            case "style":
                Nt(e, i, a);
                break;
            case "data":
                if ("object" !== t) {
                    it(e, "data", i);
                    break;
                }
            case "src":
            case "href":
                if ("" === i && ("a" !== t || "href" !== n)) {
                    e.removeAttribute(n);
                    break;
                }
                if (null == i || "function" == typeof i || "symbol" == typeof i || "boolean" == typeof i) {
                    e.removeAttribute(n);
                    break;
                }
                i = Ct("" + i), e.setAttribute(n, i);
                break;
            case "action":
            case "formAction":
                if ("function" == typeof i) {
                    e.setAttribute(n, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                    break;
                }
                if ("function" == typeof a && ("formAction" === n ? ("input" !== t && td(e, t, "name", o.name, o, null), td(e, t, "formEncType", o.formEncType, o, null), td(e, t, "formMethod", o.formMethod, o, null), td(e, t, "formTarget", o.formTarget, o, null)) : (td(e, t, "encType", o.encType, o, null), td(e, t, "method", o.method, o, null), td(e, t, "target", o.target, o, null))), null == i || "symbol" == typeof i || "boolean" == typeof i) {
                    e.removeAttribute(n);
                    break;
                }
                i = Ct("" + i), e.setAttribute(n, i);
                break;
            case "onClick":
                null != i && (e.onclick = ed);
                break;
            case "onScroll":
                null != i && Qc("scroll", e);
                break;
            case "onScrollEnd":
                null != i && Qc("scrollend", e);
                break;
            case "dangerouslySetInnerHTML":
                if (null != i) {
                    if ("object" != typeof i || !("__html" in i)) throw Error(r(61));
                    if (null != (n = i.__html)) {
                        if (null != o.children) throw Error(r(60));
                        e.innerHTML = n;
                    }
                }
                break;
            case "multiple":
                e.multiple = i && "function" != typeof i && "symbol" != typeof i;
                break;
            case "muted":
                e.muted = i && "function" != typeof i && "symbol" != typeof i;
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
            case "autoFocus":
                break;
            case "xlinkHref":
                if (null == i || "function" == typeof i || "boolean" == typeof i || "symbol" == typeof i) {
                    e.removeAttribute("xlink:href");
                    break;
                }
                n = Ct("" + i), e.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n);
                break;
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
                null != i && "function" != typeof i && "symbol" != typeof i ? e.setAttribute(n, "" + i) : e.removeAttribute(n);
                break;
            case "inert":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
                i && "function" != typeof i && "symbol" != typeof i ? e.setAttribute(n, "") : e.removeAttribute(n);
                break;
            case "capture":
            case "download":
                !0 === i ? e.setAttribute(n, "") : !1 !== i && null != i && "function" != typeof i && "symbol" != typeof i ? e.setAttribute(n, i) : e.removeAttribute(n);
                break;
            case "cols":
            case "rows":
            case "size":
            case "span":
                null != i && "function" != typeof i && "symbol" != typeof i && !isNaN(i) && 1 <= i ? e.setAttribute(n, i) : e.removeAttribute(n);
                break;
            case "rowSpan":
            case "start":
                null == i || "function" == typeof i || "symbol" == typeof i || isNaN(i) ? e.removeAttribute(n) : e.setAttribute(n, i);
                break;
            case "popover":
                Qc("beforetoggle", e), Qc("toggle", e), rt(e, "popover", i);
                break;
            case "xlinkActuate":
                ot(e, "http://www.w3.org/1999/xlink", "xlink:actuate", i);
                break;
            case "xlinkArcrole":
                ot(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", i);
                break;
            case "xlinkRole":
                ot(e, "http://www.w3.org/1999/xlink", "xlink:role", i);
                break;
            case "xlinkShow":
                ot(e, "http://www.w3.org/1999/xlink", "xlink:show", i);
                break;
            case "xlinkTitle":
                ot(e, "http://www.w3.org/1999/xlink", "xlink:title", i);
                break;
            case "xlinkType":
                ot(e, "http://www.w3.org/1999/xlink", "xlink:type", i);
                break;
            case "xmlBase":
                ot(e, "http://www.w3.org/XML/1998/namespace", "xml:base", i);
                break;
            case "xmlLang":
                ot(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", i);
                break;
            case "xmlSpace":
                ot(e, "http://www.w3.org/XML/1998/namespace", "xml:space", i);
                break;
            case "is":
                rt(e, "is", i);
                break;
            case "innerText":
            case "textContent":
                break;
            default:
                (!(2 < n.length) || "o" !== n[0] && "O" !== n[0] || "n" !== n[1] && "N" !== n[1]) && rt(e, n = Rt.get(n) || n, i);
        }
    }
    function nd(e, t, n, i, o, a) {
        switch(n){
            case "style":
                Nt(e, i, a);
                break;
            case "dangerouslySetInnerHTML":
                if (null != i) {
                    if ("object" != typeof i || !("__html" in i)) throw Error(r(61));
                    if (null != (n = i.__html)) {
                        if (null != o.children) throw Error(r(60));
                        e.innerHTML = n;
                    }
                }
                break;
            case "children":
                "string" == typeof i ? St(e, i) : ("number" == typeof i || "bigint" == typeof i) && St(e, "" + i);
                break;
            case "onScroll":
                null != i && Qc("scroll", e);
                break;
            case "onScrollEnd":
                null != i && Qc("scrollend", e);
                break;
            case "onClick":
                null != i && (e.onclick = ed);
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "innerHTML":
            case "ref":
            case "innerText":
            case "textContent":
                break;
            default:
                Pe.hasOwnProperty(n) || ("o" !== n[0] || "n" !== n[1] || (o = n.endsWith("Capture"), t = n.slice(2, o ? n.length - 7 : void 0), "function" == typeof (a = null != (a = e[Fe] || null) ? a[n] : null) && e.removeEventListener(t, a, o), "function" != typeof i) ? n in e ? e[n] = i : !0 === i ? e.setAttribute(n, "") : rt(e, n, i) : ("function" != typeof a && null !== a && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, i, o)));
        }
    }
    function rd(e, t, n) {
        switch(t){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "img":
                Qc("error", e), Qc("load", e);
                var i, o = !1, a = !1;
                for(i in n)if (n.hasOwnProperty(i)) {
                    var l = n[i];
                    if (null != l) switch(i){
                        case "src":
                            o = !0;
                            break;
                        case "srcSet":
                            a = !0;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            throw Error(r(137, t));
                        default:
                            td(e, t, i, l, n, null);
                    }
                }
                return a && td(e, t, "srcSet", n.srcSet, n, null), void (o && td(e, t, "src", n.src, n, null));
            case "input":
                Qc("invalid", e);
                var s = i = l = a = null, u = null, c = null;
                for(o in n)if (n.hasOwnProperty(o)) {
                    var d = n[o];
                    if (null != d) switch(o){
                        case "name":
                            a = d;
                            break;
                        case "type":
                            l = d;
                            break;
                        case "checked":
                            u = d;
                            break;
                        case "defaultChecked":
                            c = d;
                            break;
                        case "value":
                            i = d;
                            break;
                        case "defaultValue":
                            s = d;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (null != d) throw Error(r(137, t));
                            break;
                        default:
                            td(e, t, o, d, n, null);
                    }
                }
                return vt(e, i, s, u, c, l, a, !1), void ht(e);
            case "select":
                for(a in Qc("invalid", e), o = l = i = null, n)if (n.hasOwnProperty(a) && null != (s = n[a])) switch(a){
                    case "value":
                        i = s;
                        break;
                    case "defaultValue":
                        l = s;
                        break;
                    case "multiple":
                        o = s;
                    default:
                        td(e, t, a, s, n, null);
                }
                return t = i, n = l, e.multiple = !!o, void (null != t ? Mt(e, !!o, t, !1) : null != n && Mt(e, !!o, n, !0));
            case "textarea":
                for(l in Qc("invalid", e), i = a = o = null, n)if (n.hasOwnProperty(l) && null != (s = n[l])) switch(l){
                    case "value":
                        o = s;
                        break;
                    case "defaultValue":
                        a = s;
                        break;
                    case "children":
                        i = s;
                        break;
                    case "dangerouslySetInnerHTML":
                        if (null != s) throw Error(r(91));
                        break;
                    default:
                        td(e, t, l, s, n, null);
                }
                return xt(e, o, a, i), void ht(e);
            case "option":
                for(u in n)if (n.hasOwnProperty(u) && null != (o = n[u])) {
                    if ("selected" === u) e.selected = o && "function" != typeof o && "symbol" != typeof o;
                    else td(e, t, u, o, n, null);
                }
                return;
            case "dialog":
                Qc("beforetoggle", e), Qc("toggle", e), Qc("cancel", e), Qc("close", e);
                break;
            case "iframe":
            case "object":
                Qc("load", e);
                break;
            case "video":
            case "audio":
                for(o = 0; o < Ac.length; o++)Qc(Ac[o], e);
                break;
            case "image":
                Qc("error", e), Qc("load", e);
                break;
            case "details":
                Qc("toggle", e);
                break;
            case "embed":
            case "source":
            case "link":
                Qc("error", e), Qc("load", e);
            case "area":
            case "base":
            case "br":
            case "col":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "track":
            case "wbr":
            case "menuitem":
                for(c in n)if (n.hasOwnProperty(c) && null != (o = n[c])) switch(c){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(r(137, t));
                    default:
                        td(e, t, c, o, n, null);
                }
                return;
            default:
                if (Ut(t)) {
                    for(d in n)n.hasOwnProperty(d) && void 0 !== (o = n[d]) && nd(e, t, d, o, n, void 0);
                    return;
                }
        }
        for(s in n)n.hasOwnProperty(s) && null != (o = n[s]) && td(e, t, s, o, n, null);
    }
    var id = null, od = null;
    function ad(e) {
        return 9 === e.nodeType ? e : e.ownerDocument;
    }
    function ld(e) {
        switch(e){
            case "http://www.w3.org/2000/svg":
                return 1;
            case "http://www.w3.org/1998/Math/MathML":
                return 2;
            default:
                return 0;
        }
    }
    function sd(e, t) {
        if (0 === e) switch(t){
            case "svg":
                return 1;
            case "math":
                return 2;
            default:
                return 0;
        }
        return 1 === e && "foreignObject" === t ? 0 : e;
    }
    function ud(e, t) {
        return "textarea" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "bigint" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
    }
    var cd = null;
    var dd = "function" == typeof setTimeout ? setTimeout : void 0, fd = "function" == typeof clearTimeout ? clearTimeout : void 0, hd = "function" == typeof Promise ? Promise : void 0, pd = "function" == typeof queueMicrotask ? queueMicrotask : void 0 !== hd ? function(e) {
        return hd.resolve(null).then(e).catch(md);
    } : dd;
    function md(e) {
        setTimeout(function() {
            throw e;
        });
    }
    function gd(e) {
        return "head" === e;
    }
    function bd(e, t) {
        var n = t, r = 0, i = 0;
        do {
            var o = n.nextSibling;
            if (e.removeChild(n), o && 8 === o.nodeType) {
                if ("/$" === (n = o.data)) {
                    if (0 < r && 8 > r) {
                        n = r;
                        var a = e.ownerDocument;
                        if (1 & n && Sd(a.documentElement), 2 & n && Sd(a.body), 4 & n) for(Sd(n = a.head), a = n.firstChild; a;){
                            var l = a.nextSibling, s = a.nodeName;
                            a[qe] || "SCRIPT" === s || "STYLE" === s || "LINK" === s && "stylesheet" === a.rel.toLowerCase() || n.removeChild(a), a = l;
                        }
                    }
                    if (0 === i) return e.removeChild(o), void Cf(t);
                    i--;
                } else "$" === n || "$?" === n || "$!" === n ? i++ : r = n.charCodeAt(0) - 48;
            } else r = 0;
            n = o;
        }while (n);
        Cf(t);
    }
    function yd(e) {
        var t = e.firstChild;
        for(t && 10 === t.nodeType && (t = t.nextSibling); t;){
            var n = t;
            switch(t = t.nextSibling, n.nodeName){
                case "HTML":
                case "HEAD":
                case "BODY":
                    yd(n), We(n);
                    continue;
                case "SCRIPT":
                case "STYLE":
                    continue;
                case "LINK":
                    if ("stylesheet" === n.rel.toLowerCase()) continue;
            }
            e.removeChild(n);
        }
    }
    function vd(e) {
        return "$!" === e.data || "$?" === e.data && "complete" === e.ownerDocument.readyState;
    }
    function Id(e) {
        for(; null != e; e = e.nextSibling){
            var t = e.nodeType;
            if (1 === t || 3 === t) break;
            if (8 === t) {
                if ("$" === (t = e.data) || "$!" === t || "$?" === t || "F!" === t || "F" === t) break;
                if ("/$" === t) return null;
            }
        }
        return e;
    }
    var Md = null;
    function Ed(e) {
        e = e.previousSibling;
        for(var t = 0; e;){
            if (8 === e.nodeType) {
                var n = e.data;
                if ("$" === n || "$!" === n || "$?" === n) {
                    if (0 === t) return e;
                    t--;
                } else "/$" === n && t++;
            }
            e = e.previousSibling;
        }
        return null;
    }
    function xd(e, t, n) {
        switch(t = ad(n), e){
            case "html":
                if (!(e = t.documentElement)) throw Error(r(452));
                return e;
            case "head":
                if (!(e = t.head)) throw Error(r(453));
                return e;
            case "body":
                if (!(e = t.body)) throw Error(r(454));
                return e;
            default:
                throw Error(r(451));
        }
    }
    function Sd(e) {
        for(var t = e.attributes; t.length;)e.removeAttributeNode(t[0]);
        We(e);
    }
    var wd = new Map, kd = new Set;
    function Nd(e) {
        return "function" == typeof e.getRootNode ? e.getRootNode() : 9 === e.nodeType ? e : e.ownerDocument;
    }
    var Ud = F.d;
    F.d = {
        f: function() {
            var e = Ud.f(), t = Bu();
            return e || t;
        },
        r: function(e) {
            var t = Be(e);
            null !== t && 5 === t.tag && "form" === t.type ? Va(t) : Ud.r(e);
        },
        D: function(e) {
            Ud.D(e), Ld("dns-prefetch", e, null);
        },
        C: function(e, t) {
            Ud.C(e, t), Ld("preconnect", e, t);
        },
        L: function(e, t, n) {
            Ud.L(e, t, n);
            var r = Rd;
            if (r && e && t) {
                var i = 'link[rel="preload"][as="' + bt(t) + '"]';
                "image" === t && n && n.imageSrcSet ? (i += '[imagesrcset="' + bt(n.imageSrcSet) + '"]', "string" == typeof n.imageSizes && (i += '[imagesizes="' + bt(n.imageSizes) + '"]')) : i += '[href="' + bt(e) + '"]';
                var o = i;
                switch(t){
                    case "style":
                        o = zd(e);
                        break;
                    case "script":
                        o = Fd(e);
                }
                wd.has(o) || (e = u({
                    rel: "preload",
                    href: "image" === t && n && n.imageSrcSet ? void 0 : e,
                    as: t
                }, n), wd.set(o, e), null !== r.querySelector(i) || "style" === t && r.querySelector(Td(o)) || "script" === t && r.querySelector(Vd(o)) || (rd(t = r.createElement("link"), "link", e), Ze(t), r.head.appendChild(t)));
            }
        },
        m: function(e, t) {
            Ud.m(e, t);
            var n = Rd;
            if (n && e) {
                var r = t && "string" == typeof t.as ? t.as : "script", i = 'link[rel="modulepreload"][as="' + bt(r) + '"][href="' + bt(e) + '"]', o = i;
                switch(r){
                    case "audioworklet":
                    case "paintworklet":
                    case "serviceworker":
                    case "sharedworker":
                    case "worker":
                    case "script":
                        o = Fd(e);
                }
                if (!wd.has(o) && (e = u({
                    rel: "modulepreload",
                    href: e
                }, t), wd.set(o, e), null === n.querySelector(i))) {
                    switch(r){
                        case "audioworklet":
                        case "paintworklet":
                        case "serviceworker":
                        case "sharedworker":
                        case "worker":
                        case "script":
                            if (n.querySelector(Vd(o))) return;
                    }
                    rd(r = n.createElement("link"), "link", e), Ze(r), n.head.appendChild(r);
                }
            }
        },
        X: function(e, t) {
            Ud.X(e, t);
            var n = Rd;
            if (n && e) {
                var r = Ye(n).hoistableScripts, i = Fd(e), o = r.get(i);
                o || ((o = n.querySelector(Vd(i))) || (e = u({
                    src: e,
                    async: !0
                }, t), (t = wd.get(i)) && Qd(e, t), Ze(o = n.createElement("script")), rd(o, "link", e), n.head.appendChild(o)), o = {
                    type: "script",
                    instance: o,
                    count: 1,
                    state: null
                }, r.set(i, o));
            }
        },
        S: function(e, t, n) {
            Ud.S(e, t, n);
            var r = Rd;
            if (r && e) {
                var i = Ye(r).hoistableStyles, o = zd(e);
                t = t || "default";
                var a = i.get(o);
                if (!a) {
                    var l = {
                        loading: 0,
                        preload: null
                    };
                    if (a = r.querySelector(Td(o))) l.loading = 5;
                    else {
                        e = u({
                            rel: "stylesheet",
                            href: e,
                            "data-precedence": t
                        }, n), (n = wd.get(o)) && Od(e, n);
                        var s = a = r.createElement("link");
                        Ze(s), rd(s, "link", e), s._p = new Promise(function(e, t) {
                            s.onload = e, s.onerror = t;
                        }), s.addEventListener("load", function() {
                            l.loading |= 1;
                        }), s.addEventListener("error", function() {
                            l.loading |= 2;
                        }), l.loading |= 4, jd(a, t, r);
                    }
                    a = {
                        type: "stylesheet",
                        instance: a,
                        count: 1,
                        state: l
                    }, i.set(o, a);
                }
            }
        },
        M: function(e, t) {
            Ud.M(e, t);
            var n = Rd;
            if (n && e) {
                var r = Ye(n).hoistableScripts, i = Fd(e), o = r.get(i);
                o || ((o = n.querySelector(Vd(i))) || (e = u({
                    src: e,
                    async: !0,
                    type: "module"
                }, t), (t = wd.get(i)) && Qd(e, t), Ze(o = n.createElement("script")), rd(o, "link", e), n.head.appendChild(o)), o = {
                    type: "script",
                    instance: o,
                    count: 1,
                    state: null
                }, r.set(i, o));
            }
        }
    };
    var Rd = "undefined" == typeof document ? null : document;
    function Ld(e, t, n) {
        var r = Rd;
        if (r && "string" == typeof t && t) {
            var i = bt(t);
            i = 'link[rel="' + e + '"][href="' + i + '"]', "string" == typeof n && (i += '[crossorigin="' + n + '"]'), kd.has(i) || (kd.add(i), e = {
                rel: e,
                crossOrigin: n,
                href: t
            }, null === r.querySelector(i) && (rd(t = r.createElement("link"), "link", e), Ze(t), r.head.appendChild(t)));
        }
    }
    function Cd(e, t, n, i) {
        var o = (o = Y.current) ? Nd(o) : null;
        if (!o) throw Error(r(446));
        switch(e){
            case "meta":
            case "title":
                return null;
            case "style":
                return "string" == typeof n.precedence && "string" == typeof n.href ? (t = zd(n.href), (i = (n = Ye(o).hoistableStyles).get(t)) || (i = {
                    type: "style",
                    instance: null,
                    count: 0,
                    state: null
                }, n.set(t, i)), i) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            case "link":
                if ("stylesheet" === n.rel && "string" == typeof n.href && "string" == typeof n.precedence) {
                    e = zd(n.href);
                    var a = Ye(o).hoistableStyles, l = a.get(e);
                    if (l || (o = o.ownerDocument || o, l = {
                        type: "stylesheet",
                        instance: null,
                        count: 0,
                        state: {
                            loading: 0,
                            preload: null
                        }
                    }, a.set(e, l), (a = o.querySelector(Td(e))) && !a._p && (l.instance = a, l.state.loading = 5), wd.has(e) || (n = {
                        rel: "preload",
                        as: "style",
                        href: n.href,
                        crossOrigin: n.crossOrigin,
                        integrity: n.integrity,
                        media: n.media,
                        hrefLang: n.hrefLang,
                        referrerPolicy: n.referrerPolicy
                    }, wd.set(e, n), a || function(e, t, n, r) {
                        e.querySelector('link[rel="preload"][as="style"][' + t + "]") ? r.loading = 1 : (t = e.createElement("link"), r.preload = t, t.addEventListener("load", function() {
                            return r.loading |= 1;
                        }), t.addEventListener("error", function() {
                            return r.loading |= 2;
                        }), rd(t, "link", n), Ze(t), e.head.appendChild(t));
                    }(o, e, n, l.state))), t && null === i) throw Error(r(528, ""));
                    return l;
                }
                if (t && null !== i) throw Error(r(529, ""));
                return null;
            case "script":
                return t = n.async, "string" == typeof (n = n.src) && t && "function" != typeof t && "symbol" != typeof t ? (t = Fd(n), (i = (n = Ye(o).hoistableScripts).get(t)) || (i = {
                    type: "script",
                    instance: null,
                    count: 0,
                    state: null
                }, n.set(t, i)), i) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            default:
                throw Error(r(444, e));
        }
    }
    function zd(e) {
        return 'href="' + bt(e) + '"';
    }
    function Td(e) {
        return 'link[rel="stylesheet"][' + e + "]";
    }
    function Dd(e) {
        return u({}, e, {
            "data-precedence": e.precedence,
            precedence: null
        });
    }
    function Fd(e) {
        return '[src="' + bt(e) + '"]';
    }
    function Vd(e) {
        return "script[async]" + e;
    }
    function Ad(e, t, n) {
        if (t.count++, null === t.instance) switch(t.type){
            case "style":
                var i = e.querySelector('style[data-href~="' + bt(n.href) + '"]');
                if (i) return t.instance = i, Ze(i), i;
                var o = u({}, n, {
                    "data-href": n.href,
                    "data-precedence": n.precedence,
                    href: null,
                    precedence: null
                });
                return Ze(i = (e.ownerDocument || e).createElement("style")), rd(i, "style", o), jd(i, n.precedence, e), t.instance = i;
            case "stylesheet":
                o = zd(n.href);
                var a = e.querySelector(Td(o));
                if (a) return t.state.loading |= 4, t.instance = a, Ze(a), a;
                i = Dd(n), (o = wd.get(o)) && Od(i, o), Ze(a = (e.ownerDocument || e).createElement("link"));
                var l = a;
                return l._p = new Promise(function(e, t) {
                    l.onload = e, l.onerror = t;
                }), rd(a, "link", i), t.state.loading |= 4, jd(a, n.precedence, e), t.instance = a;
            case "script":
                return a = Fd(n.src), (o = e.querySelector(Vd(a))) ? (t.instance = o, Ze(o), o) : (i = n, (o = wd.get(a)) && Qd(i = u({}, n), o), Ze(o = (e = e.ownerDocument || e).createElement("script")), rd(o, "link", i), e.head.appendChild(o), t.instance = o);
            case "void":
                return null;
            default:
                throw Error(r(443, t.type));
        }
        else "stylesheet" === t.type && !(4 & t.state.loading) && (i = t.instance, t.state.loading |= 4, jd(i, n.precedence, e));
        return t.instance;
    }
    function jd(e, t, n) {
        for(var r = n.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), i = r.length ? r[r.length - 1] : null, o = i, a = 0; a < r.length; a++){
            var l = r[a];
            if (l.dataset.precedence === t) o = l;
            else if (o !== i) break;
        }
        o ? o.parentNode.insertBefore(e, o.nextSibling) : (t = 9 === n.nodeType ? n.head : n).insertBefore(e, t.firstChild);
    }
    function Od(e, t) {
        null == e.crossOrigin && (e.crossOrigin = t.crossOrigin), null == e.referrerPolicy && (e.referrerPolicy = t.referrerPolicy), null == e.title && (e.title = t.title);
    }
    function Qd(e, t) {
        null == e.crossOrigin && (e.crossOrigin = t.crossOrigin), null == e.referrerPolicy && (e.referrerPolicy = t.referrerPolicy), null == e.integrity && (e.integrity = t.integrity);
    }
    var qd = null;
    function Wd(e, t, n) {
        if (null === qd) {
            var r = new Map, i = qd = new Map;
            i.set(n, r);
        } else (r = (i = qd).get(n)) || (r = new Map, i.set(n, r));
        if (r.has(e)) return r;
        for(r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++){
            var o = n[i];
            if (!(o[qe] || o[De] || "link" === e && "stylesheet" === o.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== o.namespaceURI) {
                var a = o.getAttribute(t) || "";
                a = e + a;
                var l = r.get(a);
                l ? l.push(o) : r.set(a, [
                    o
                ]);
            }
        }
        return r;
    }
    function Gd(e, t, n) {
        (e = e.ownerDocument || e).head.insertBefore(n, "title" === t ? e.querySelector("head > title") : null);
    }
    function Bd(e) {
        return !!("stylesheet" !== e.type || 3 & e.state.loading);
    }
    var Kd = null;
    function Yd() {}
    function Zd() {
        if (this.count--, 0 === this.count) {
            if (this.stylesheets) Pd(this, this.stylesheets);
            else if (this.unsuspend) {
                var e = this.unsuspend;
                this.unsuspend = null, e();
            }
        }
    }
    var Xd = null;
    function Pd(e, t) {
        e.stylesheets = null, null !== e.unsuspend && (e.count++, Xd = new Map, t.forEach(Jd, e), Xd = null, Zd.call(e));
    }
    function Jd(e, t) {
        if (!(4 & t.state.loading)) {
            var n = Xd.get(e);
            if (n) var r = n.get(null);
            else {
                n = new Map, Xd.set(e, n);
                for(var i = e.querySelectorAll("link[data-precedence],style[data-precedence]"), o = 0; o < i.length; o++){
                    var a = i[o];
                    "LINK" !== a.nodeName && "not all" === a.getAttribute("media") || (n.set(a.dataset.precedence, a), r = a);
                }
                r && n.set(null, r);
            }
            a = (i = t.instance).getAttribute("data-precedence"), (o = n.get(a) || r) === r && n.set(null, i), n.set(a, i), this.count++, r = Zd.bind(this), i.addEventListener("load", r), i.addEventListener("error", r), o ? o.parentNode.insertBefore(i, o.nextSibling) : (e = 9 === e.nodeType ? e.head : e).insertBefore(i, e.firstChild), t.state.loading |= 4;
        }
    }
    var Hd = {
        $$typeof: y,
        Provider: null,
        Consumer: null,
        _currentValue: V,
        _currentValue2: V,
        _threadCount: 0
    };
    function _d(e, t, n, r, i, o, a, l) {
        this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = ke(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ke(0), this.hiddenUpdates = ke(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = o, this.onRecoverableError = a, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = l, this.incompleteTransitions = new Map;
    }
    function $d(e, t, n, r, i, o, a, l, s, u, c, d) {
        return e = new _d(e, t, n, a, l, s, u, d), t = 1, !0 === o && (t |= 24), o = Or(3, null, null, t), e.current = o, o.stateNode = e, (t = Vi()).refCount++, e.pooledCache = t, t.refCount++, o.memoizedState = {
            element: r,
            isDehydrated: n,
            cache: t
        }, oo(o), e;
    }
    function ef(e) {
        return e ? e = Ar : Ar;
    }
    function tf(e, t, n, r, i, o) {
        i = ef(i), null === r.context ? r.context = i : r.pendingContext = i, (r = lo(t)).payload = {
            element: n
        }, null !== (o = void 0 === o ? null : o) && (r.callback = o), null !== (n = so(e, r, t)) && (Ou(n, 0, t), uo(n, e, t));
    }
    function nf(e, t) {
        if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
            var n = e.retryLane;
            e.retryLane = 0 !== n && n < t ? n : t;
        }
    }
    function rf(e, t) {
        nf(e, t), (e = e.alternate) && nf(e, t);
    }
    function of(e) {
        if (13 === e.tag) {
            var t = Dr(e, 67108864);
            null !== t && Ou(t, 0, 67108864), rf(e, 67108864);
        }
    }
    var af = !0;
    function lf(e, t, n, r) {
        var i = T.T;
        T.T = null;
        var o = F.p;
        try {
            F.p = 2, uf(e, t, n, r);
        } finally{
            F.p = o, T.T = i;
        }
    }
    function sf(e, t, n, r) {
        var i = T.T;
        T.T = null;
        var o = F.p;
        try {
            F.p = 8, uf(e, t, n, r);
        } finally{
            F.p = o, T.T = i;
        }
    }
    function uf(e, t, n, r) {
        if (af) {
            var i = cf(r);
            if (null === i) Kc(e, t, r, df, n), Ef(e, r);
            else if (function(e, t, n, r, i) {
                switch(t){
                    case "focusin":
                        return mf = xf(mf, e, t, n, r, i), !0;
                    case "dragenter":
                        return gf = xf(gf, e, t, n, r, i), !0;
                    case "mouseover":
                        return bf = xf(bf, e, t, n, r, i), !0;
                    case "pointerover":
                        var o = i.pointerId;
                        return yf.set(o, xf(yf.get(o) || null, e, t, n, r, i)), !0;
                    case "gotpointercapture":
                        return o = i.pointerId, vf.set(o, xf(vf.get(o) || null, e, t, n, r, i)), !0;
                }
                return !1;
            }(i, e, t, n, r)) r.stopPropagation();
            else if (Ef(e, r), 4 & t && -1 < Mf.indexOf(e)) {
                for(; null !== i;){
                    var o = Be(i);
                    if (null !== o) switch(o.tag){
                        case 3:
                            if ((o = o.stateNode).current.memoizedState.isDehydrated) {
                                var a = Ie(o.pendingLanes);
                                if (0 !== a) {
                                    var l = o;
                                    for(l.pendingLanes |= 2, l.entangledLanes |= 2; a;){
                                        var s = 1 << 31 - me(a);
                                        l.entanglements[1] |= s, a &= ~s;
                                    }
                                    wc(o), !(6 & ou) && (wu = re() + 500, kc(0));
                                }
                            }
                            break;
                        case 13:
                            null !== (l = Dr(o, 2)) && Ou(l, 0, 2), Bu(), rf(o, 2);
                    }
                    if (null === (o = cf(r)) && Kc(e, t, r, df, n), o === i) break;
                    i = o;
                }
                null !== i && r.stopPropagation();
            } else Kc(e, t, r, null, n);
        }
    }
    function cf(e) {
        return ff(e = Tt(e));
    }
    var df = null;
    function ff(e) {
        if (df = null, null !== (e = Ge(e))) {
            var t = o(e);
            if (null === t) e = null;
            else {
                var n = t.tag;
                if (13 === n) {
                    if (null !== (e = a(t))) return e;
                    e = null;
                } else if (3 === n) {
                    if (t.stateNode.current.memoizedState.isDehydrated) return 3 === t.tag ? t.stateNode.containerInfo : null;
                    e = null;
                } else t !== e && (e = null);
            }
        }
        return df = e, null;
    }
    function hf(e) {
        switch(e){
            case "beforetoggle":
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "toggle":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return 2;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return 8;
            case "message":
                switch(ie()){
                    case oe:
                        return 2;
                    case ae:
                        return 8;
                    case le:
                    case se:
                        return 32;
                    case ue:
                        return 268435456;
                    default:
                        return 32;
                }
            default:
                return 32;
        }
    }
    var pf = !1, mf = null, gf = null, bf = null, yf = new Map, vf = new Map, If = [], Mf = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
    function Ef(e, t) {
        switch(e){
            case "focusin":
            case "focusout":
                mf = null;
                break;
            case "dragenter":
            case "dragleave":
                gf = null;
                break;
            case "mouseover":
            case "mouseout":
                bf = null;
                break;
            case "pointerover":
            case "pointerout":
                yf.delete(t.pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                vf.delete(t.pointerId);
        }
    }
    function xf(e, t, n, r, i, o) {
        return null === e || e.nativeEvent !== o ? (e = {
            blockedOn: t,
            domEventName: n,
            eventSystemFlags: r,
            nativeEvent: o,
            targetContainers: [
                i
            ]
        }, null !== t && null !== (t = Be(t)) && of(t), e) : (e.eventSystemFlags |= r, t = e.targetContainers, null !== i && -1 === t.indexOf(i) && t.push(i), e);
    }
    function Sf(e) {
        var t = Ge(e.target);
        if (null !== t) {
            var n = o(t);
            if (null !== n) {
                if (13 === (t = n.tag)) {
                    if (null !== (t = a(n))) return e.blockedOn = t, void function(e, t) {
                        var n = F.p;
                        try {
                            return F.p = e, t();
                        } finally{
                            F.p = n;
                        }
                    }(e.priority, function() {
                        if (13 === n.tag) {
                            var e = Au();
                            e = Le(e);
                            var t = Dr(n, e);
                            null !== t && Ou(t, 0, e), rf(n, e);
                        }
                    });
                } else if (3 === t && n.stateNode.current.memoizedState.isDehydrated) return void (e.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
            }
        }
        e.blockedOn = null;
    }
    function wf(e) {
        if (null !== e.blockedOn) return !1;
        for(var t = e.targetContainers; 0 < t.length;){
            var n = cf(e.nativeEvent);
            if (null !== n) return null !== (t = Be(n)) && of(t), e.blockedOn = n, !1;
            var r = new (n = e.nativeEvent).constructor(n.type, n);
            zt = r, n.target.dispatchEvent(r), zt = null, t.shift();
        }
        return !0;
    }
    function kf(e, t, n) {
        wf(e) && n.delete(t);
    }
    function Nf() {
        pf = !1, null !== mf && wf(mf) && (mf = null), null !== gf && wf(gf) && (gf = null), null !== bf && wf(bf) && (bf = null), yf.forEach(kf), vf.forEach(kf);
    }
    function Uf(t, n) {
        t.blockedOn === n && (t.blockedOn = null, pf || (pf = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, Nf)));
    }
    var Rf = null;
    function Lf(t) {
        Rf !== t && (Rf = t, e.unstable_scheduleCallback(e.unstable_NormalPriority, function() {
            Rf === t && (Rf = null);
            for(var e = 0; e < t.length; e += 3){
                var n = t[e], r = t[e + 1], i = t[e + 2];
                if ("function" != typeof r) {
                    if (null === ff(r || n)) continue;
                    break;
                }
                var o = Be(n);
                null !== o && (t.splice(e, 3), e -= 3, Da(o, {
                    pending: !0,
                    data: i,
                    method: n.method,
                    action: r
                }, r, i));
            }
        }));
    }
    function Cf(e) {
        function t(t) {
            return Uf(t, e);
        }
        null !== mf && Uf(mf, e), null !== gf && Uf(gf, e), null !== bf && Uf(bf, e), yf.forEach(t), vf.forEach(t);
        for(var n = 0; n < If.length; n++){
            var r = If[n];
            r.blockedOn === e && (r.blockedOn = null);
        }
        for(; 0 < If.length && null === (n = If[0]).blockedOn;)Sf(n), null === n.blockedOn && If.shift();
        if (null != (n = (e.ownerDocument || e).$$reactFormReplay)) for(r = 0; r < n.length; r += 3){
            var i = n[r], o = n[r + 1], a = i[Fe] || null;
            if ("function" == typeof o) a || Lf(n);
            else if (a) {
                var l = null;
                if (o && o.hasAttribute("formAction")) {
                    if (i = o, a = o[Fe] || null) l = a.formAction;
                    else if (null !== ff(i)) continue;
                } else l = a.action;
                "function" == typeof l ? n[r + 1] = l : (n.splice(r, 3), r -= 3), Lf(n);
            }
        }
    }
    function zf(e) {
        this._internalRoot = e;
    }
    function Tf(e) {
        this._internalRoot = e;
    }
    Tf.prototype.render = zf.prototype.render = function(e) {
        var t = this._internalRoot;
        if (null === t) throw Error(r(409));
        tf(t.current, Au(), e, t, null, null);
    }, Tf.prototype.unmount = zf.prototype.unmount = function() {
        var e = this._internalRoot;
        if (null !== e) {
            this._internalRoot = null;
            var t = e.containerInfo;
            tf(e.current, 2, null, e, null, null), Bu(), t[Ve] = null;
        }
    }, Tf.prototype.unstable_scheduleHydration = function(e) {
        if (e) {
            var t = ze();
            e = {
                blockedOn: null,
                target: e,
                priority: t
            };
            for(var n = 0; n < If.length && 0 !== t && t < If[n].priority; n++);
            If.splice(n, 0, e), 0 === n && Sf(e);
        }
    };
    var Df = t.version;
    if ("19.1.0" !== Df) throw Error(r(527, Df, "19.1.0"));
    F.findDOMNode = function(e) {
        var t = e._reactInternals;
        if (void 0 === t) {
            if ("function" == typeof e.render) throw Error(r(188));
            throw e = Object.keys(e).join(","), Error(r(268, e));
        }
        return e = function(e) {
            var t = e.alternate;
            if (!t) {
                if (null === (t = o(e))) throw Error(r(188));
                return t !== e ? null : e;
            }
            for(var n = e, i = t;;){
                var a = n.return;
                if (null === a) break;
                var s = a.alternate;
                if (null === s) {
                    if (null !== (i = a.return)) {
                        n = i;
                        continue;
                    }
                    break;
                }
                if (a.child === s.child) {
                    for(s = a.child; s;){
                        if (s === n) return l(a), e;
                        if (s === i) return l(a), t;
                        s = s.sibling;
                    }
                    throw Error(r(188));
                }
                if (n.return !== i.return) n = a, i = s;
                else {
                    for(var u = !1, c = a.child; c;){
                        if (c === n) {
                            u = !0, n = a, i = s;
                            break;
                        }
                        if (c === i) {
                            u = !0, i = a, n = s;
                            break;
                        }
                        c = c.sibling;
                    }
                    if (!u) {
                        for(c = s.child; c;){
                            if (c === n) {
                                u = !0, n = s, i = a;
                                break;
                            }
                            if (c === i) {
                                u = !0, i = s, n = a;
                                break;
                            }
                            c = c.sibling;
                        }
                        if (!u) throw Error(r(189));
                    }
                }
                if (n.alternate !== i) throw Error(r(190));
            }
            if (3 !== n.tag) throw Error(r(188));
            return n.stateNode.current === n ? e : t;
        }(t), e = null === (e = null !== e ? s(e) : null) ? null : e.stateNode;
    };
    var Ff = {
        bundleType: 0,
        version: "19.1.0",
        rendererPackageName: "react-dom",
        currentDispatcherRef: T,
        reconcilerVersion: "19.1.0"
    };
    if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
        var Vf = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (!Vf.isDisabled && Vf.supportsFiber) try {
            fe = Vf.inject(Ff), he = Vf;
        } catch (e) {}
    }
    return $cf61b77dbdb95489$var$v.createRoot = function(e, t) {
        if (!i(e)) throw Error(r(299));
        var n = !1, o = "", a = Ml, l = El, s = xl;
        return null != t && (!0 === t.unstable_strictMode && (n = !0), void 0 !== t.identifierPrefix && (o = t.identifierPrefix), void 0 !== t.onUncaughtError && (a = t.onUncaughtError), void 0 !== t.onCaughtError && (l = t.onCaughtError), void 0 !== t.onRecoverableError && (s = t.onRecoverableError), void 0 !== t.unstable_transitionCallbacks && t.unstable_transitionCallbacks), t = $d(e, 1, !1, null, 0, n, o, a, l, s, 0, null), e[Ve] = t.current, Gc(e), new zf(t);
    }, $cf61b77dbdb95489$var$v.hydrateRoot = function(e, t, n) {
        if (!i(e)) throw Error(r(299));
        var o = !1, a = "", l = Ml, s = El, u = xl, c = null;
        return null != n && (!0 === n.unstable_strictMode && (o = !0), void 0 !== n.identifierPrefix && (a = n.identifierPrefix), void 0 !== n.onUncaughtError && (l = n.onUncaughtError), void 0 !== n.onCaughtError && (s = n.onCaughtError), void 0 !== n.onRecoverableError && (u = n.onRecoverableError), void 0 !== n.unstable_transitionCallbacks && n.unstable_transitionCallbacks, void 0 !== n.formState && (c = n.formState)), (t = $d(e, 1, !0, t, 0, o, a, l, s, u, 0, c)).context = ef(null), n = t.current, (a = lo(o = Le(o = Au()))).callback = null, so(n, a, o), n = o, t.current.lanes = n, Ne(t, n), wc(t), e[Ve] = t.current, Gc(e), new Tf(t);
    }, $cf61b77dbdb95489$var$v.version = "19.1.0", $cf61b77dbdb95489$var$v;
}
var $cf61b77dbdb95489$var$Y, $cf61b77dbdb95489$var$Z, $cf61b77dbdb95489$var$X = {};
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $cf61b77dbdb95489$var$P() {
    return $cf61b77dbdb95489$var$Y || ($cf61b77dbdb95489$var$Y = 1), $cf61b77dbdb95489$var$X;
}
var $cf61b77dbdb95489$var$J, $cf61b77dbdb95489$var$H = ($cf61b77dbdb95489$var$Z || ($cf61b77dbdb95489$var$Z = 1, function e() {
    if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
    } catch (e) {
        console.error(e);
    }
}(), $cf61b77dbdb95489$var$y.exports = $cf61b77dbdb95489$var$K()), $cf61b77dbdb95489$var$y.exports), $cf61b77dbdb95489$var$_ = $cf61b77dbdb95489$var$D(), $cf61b77dbdb95489$var$$ = $cf61b77dbdb95489$var$m($cf61b77dbdb95489$var$_), $cf61b77dbdb95489$var$ee = function() {
    return $cf61b77dbdb95489$var$i(function e() {
        $cf61b77dbdb95489$var$r(this, e), $cf61b77dbdb95489$var$a(this, "subscribers", []);
    }, [
        {
            key: "subscribe",
            value: function(e) {
                var t = this;
                this.subscribers.push(e);
                return {
                    unsubscribe: function() {
                        t.unsubscribe(e);
                    }
                };
            }
        },
        {
            key: "unsubscribe",
            value: function(e) {
                this.subscribers = this.subscribers.filter(function(t) {
                    return t !== e;
                });
            }
        },
        {
            key: "next",
            value: function(e) {
                this.subscribers.forEach(function(t) {
                    return t(e);
                });
            }
        }
    ]);
}(), $cf61b77dbdb95489$var$te = {
    exports: {}
}, $cf61b77dbdb95489$var$ne = {};
var $cf61b77dbdb95489$var$re, $cf61b77dbdb95489$var$ie, $cf61b77dbdb95489$var$oe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $cf61b77dbdb95489$var$ae() {
    return $cf61b77dbdb95489$var$re || ($cf61b77dbdb95489$var$re = 1), $cf61b77dbdb95489$var$oe;
}
var $cf61b77dbdb95489$var$le = ($cf61b77dbdb95489$var$ie || ($cf61b77dbdb95489$var$ie = 1, $cf61b77dbdb95489$var$te.exports = function() {
    if ($cf61b77dbdb95489$var$J) return $cf61b77dbdb95489$var$ne;
    $cf61b77dbdb95489$var$J = 1;
    var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
    function n(t, n, r) {
        var i = null;
        if (void 0 !== r && (i = "" + r), void 0 !== n.key && (i = "" + n.key), "key" in n) for(var o in r = {}, n)"key" !== o && (r[o] = n[o]);
        else r = n;
        return n = r.ref, {
            $$typeof: e,
            type: t,
            key: i,
            ref: void 0 !== n ? n : null,
            props: r
        };
    }
    return $cf61b77dbdb95489$var$ne.Fragment = t, $cf61b77dbdb95489$var$ne.jsx = n, $cf61b77dbdb95489$var$ne.jsxs = n, $cf61b77dbdb95489$var$ne;
}()), $cf61b77dbdb95489$var$te.exports);
function $cf61b77dbdb95489$var$se(e) {
    return $cf61b77dbdb95489$var$le.jsx("svg", {
        strokeWidth: "0",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        height: "1em",
        width: "1em",
        style: e.style ? $cf61b77dbdb95489$var$s({
            overflow: "visible",
            fontSize: "22px"
        }, e.style) : {
            overflow: "visible",
            fontSize: "22px"
        },
        children: $cf61b77dbdb95489$var$le.jsx("path", {
            d: "m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34Z"
        })
    });
}
function $cf61b77dbdb95489$var$ue(e) {
    return $cf61b77dbdb95489$var$le.jsx("svg", {
        strokeWidth: "0",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 320 512",
        height: "1em",
        width: "1em",
        style: e.style ? $cf61b77dbdb95489$var$s({
            overflow: "visible"
        }, e.style) : {
            overflow: "visible"
        },
        children: $cf61b77dbdb95489$var$le.jsx("path", {
            d: "M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"
        })
    });
}
function $cf61b77dbdb95489$var$ce(e) {
    return $cf61b77dbdb95489$var$le.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "Guides",
        x: "0",
        y: "0",
        version: "1.1",
        viewBox: "0 0 179.2 43",
        width: "140",
        height: "40",
        style: e.style ? $cf61b77dbdb95489$var$s({}, e.style) : {},
        children: [
            $cf61b77dbdb95489$var$le.jsx("path", {
                fill: "#3880FF",
                d: "M45 19v.9c0 .3-.2 7.5-3.4 13.2-3.3 5.6-9.4 9.3-9.7 9.5l-.8.4-1.3-.8-7.6-4.4c-.5-.3-.9-.6-1.4-.9-.4-.3-.7-.5-1.1-.8-.8-.7-1.5-1.4-2.1-2.2-.9-1.1-1.6-2.4-2.1-3.7-.9-2.3-1.3-4.8-1.2-7.5.8-.4 1.6-.6 2.4-.6h.6c-.2 2.4.1 4.6.8 6.6 1 2.8 2.9 5.1 5.5 6.6l7.4 4.3c.2-.1.4-.2.6-.4 1.9-1.3 5.3-4.1 7.3-7.6 2.2-3.9 2.8-8.9 3-10.8L38.8 19c.3-1 .4-2.1.5-3.2L45 19z",
                className: "st0"
            }),
            $cf61b77dbdb95489$var$le.jsx("path", {
                fill: "#3880FF",
                d: "M36.3 4.1v10.3c0 .5 0 1.1-.1 1.6s-.1.9-.2 1.3c-.2 1-.5 2-.9 3-.5 1.3-1.3 2.6-2.2 3.7-1.5 1.9-3.5 3.6-5.9 4.8-.9-.6-1.6-1.3-2-2.4 2.1-1 3.9-2.3 5.2-4 1.9-2.3 3-5.1 3-8.1V5.9l-.6-.3c-2-1-6.1-2.6-10.1-2.6-4.5 0-9.1 2-10.9 2.9v3.6c-1 .3-2 .7-3 1.1V4.1l.8-.4C9.7 3.5 16 0 22.5 0s12.8 3.5 13.1 3.6l.7.5z",
                className: "st0"
            }),
            $cf61b77dbdb95489$var$le.jsx("path", {
                fill: "#3880FF",
                d: "M10.5 16.5l-7.4 4.3v.7c.2 2.1.9 6.5 2.9 10 2.2 3.9 6.2 6.9 7.9 8l3.1-1.8c.8.7 1.6 1.4 2.5 2L13.8 43l-.8-.5c-.3-.2-6.4-3.9-9.7-9.5C.1 27.4 0 20.2 0 19.9V19l1.3-.8L9 13.9c.5-.3.9-.5 1.4-.7.4-.2.8-.4 1.3-.5 1-.4 2-.6 3-.7 1.4-.2 2.9-.2 4.3 0 2.4.3 4.8 1.2 7.1 2.7 0 1-.4 2-1 2.9-1.9-1.3-4-2.2-6-2.5-3.1-.6-6-.1-8.6 1.4z",
                className: "st0"
            }),
            $cf61b77dbdb95489$var$le.jsx("g", {
                children: $cf61b77dbdb95489$var$le.jsx("path", {
                    d: "M73.9 23c.9 1 1.3 2.3 1.3 3.7 0 1.9-.6 3.4-1.9 4.5-1.3 1.1-3.1 1.7-5.5 1.7h-8.6v-23h8.4c2.3 0 4.1.5 5.3 1.5 1.2 1 1.8 2.4 1.8 4.2 0 1.5-.4 2.7-1.2 3.6-.8.9-1.8 1.5-3.1 1.8 1.5.3 2.6 1 3.5 2zm-11.7-3h5c1.5 0 2.6-.3 3.4-1 .8-.7 1.2-1.6 1.2-2.8 0-1.2-.4-2.1-1.1-2.8-.8-.7-1.9-1-3.5-1h-4.8V20zm8.7 9.4c.9-.7 1.3-1.7 1.3-3s-.4-2.3-1.3-3c-.9-.7-2.1-1.1-3.7-1.1h-5v8.2h5c1.6-.1 2.8-.4 3.7-1.1zM95.3 24.6H81c.1 2.1.6 3.6 1.7 4.6s2.4 1.5 4 1.5c1.4 0 2.6-.4 3.6-1.1 1-.7 1.6-1.7 1.8-2.9h3.2c-.2 1.2-.7 2.4-1.5 3.3-.8 1-1.7 1.7-2.9 2.3-1.2.5-2.6.8-4.1.8-1.7 0-3.2-.4-4.6-1.1-1.3-.7-2.4-1.8-3.1-3.2-.8-1.4-1.1-3-1.1-4.9 0-1.9.4-3.5 1.1-4.9.8-1.4 1.8-2.5 3.1-3.2 1.3-.7 2.9-1.1 4.6-1.1 1.7 0 3.3.4 4.6 1.1 1.3.7 2.3 1.7 3 3 .7 1.2 1 2.6 1 4.1.1.7 0 1.2-.1 1.7zm-3.5-4.8c-.5-.9-1.2-1.6-2.1-2-.9-.4-1.8-.7-2.8-.7-1.6 0-3 .5-4.1 1.5-1.1 1-1.7 2.5-1.8 4.5h11.5c0-1.3-.2-2.4-.7-3.3zM111.2 16c1.2.9 2.1 2 2.5 3.5V15h3v18h-3v-4.6c-.5 1.5-1.3 2.6-2.5 3.5-1.2.9-2.7 1.3-4.4 1.3-1.6 0-3-.4-4.3-1.1-1.2-.7-2.2-1.8-2.9-3.2-.7-1.4-1.1-3-1.1-4.9 0-1.9.4-3.5 1.1-4.9.7-1.4 1.7-2.5 2.9-3.2 1.2-.7 2.7-1.1 4.3-1.1 1.7-.1 3.1.4 4.4 1.2zm-8 3.1c-1.1 1.2-1.7 2.8-1.7 4.8 0 2.1.5 3.7 1.7 4.8 1.1 1.2 2.6 1.8 4.4 1.8 1.2 0 2.2-.3 3.2-.8.9-.5 1.7-1.3 2.2-2.3.5-1 .8-2.1.8-3.5 0-1.3-.3-2.5-.8-3.5s-1.2-1.8-2.2-2.3c-.9-.5-2-.8-3.2-.8-1.9.1-3.3.7-4.4 1.8zM135 16.6c1.5 1.2 2.4 2.9 2.8 4.9h-3.1c-.2-1.3-.8-2.3-1.8-3-1-.7-2.2-1.1-3.6-1.1-1 0-2 .2-2.9.7-.9.5-1.6 1.2-2.1 2.2-.5 1-.8 2.2-.8 3.7s.3 2.7.8 3.7 1.2 1.7 2.1 2.2c.9.5 1.8.7 2.9.7 1.4 0 2.6-.4 3.6-1.1 1-.7 1.6-1.8 1.8-3h3.1c-.3 2.1-1.3 3.7-2.8 4.9-1.5 1.2-3.4 1.8-5.7 1.8-1.7 0-3.2-.4-4.6-1.1-1.3-.7-2.4-1.8-3.1-3.2-.8-1.4-1.1-3-1.1-4.9 0-1.9.4-3.5 1.1-4.9.8-1.4 1.8-2.5 3.1-3.2 1.3-.7 2.9-1.1 4.6-1.1 2.3-.1 4.2.6 5.7 1.8zM154.5 15.9c1.4.7 2.4 1.8 3.2 3.2.8 1.4 1.2 3 1.2 4.9 0 1.9-.4 3.5-1.2 4.9-.8 1.4-1.8 2.4-3.2 3.2-1.4.7-2.9 1.1-4.6 1.1-1.7 0-3.3-.4-4.6-1.1-1.4-.7-2.4-1.8-3.2-3.2-.8-1.4-1.2-3-1.2-4.9 0-1.9.4-3.5 1.2-4.9.8-1.4 1.9-2.5 3.2-3.2 1.4-.7 2.9-1.1 4.6-1.1 1.7-.1 3.2.3 4.6 1.1zm-7.6 2.2c-.9.5-1.6 1.2-2.2 2.2-.6 1-.8 2.2-.8 3.7 0 1.4.3 2.7.8 3.6.6 1 1.3 1.7 2.2 2.2.9.5 1.9.7 3 .7s2.1-.2 3-.7c.9-.5 1.6-1.2 2.2-2.2.6-1 .8-2.2.8-3.6 0-1.5-.3-2.7-.8-3.7-.6-1-1.3-1.7-2.2-2.2-.9-.5-1.9-.7-3-.7s-2.1.2-3 .7zM177.3 16.7c1.3 1.3 1.9 3.3 1.9 5.8v10.4h-3V22.8c0-1.8-.5-3.2-1.4-4.1-.9-1-2.2-1.4-3.7-1.4-1.6 0-2.9.5-3.9 1.6s-1.5 2.6-1.5 4.6V33h-3V15h3v4.3c.5-1.5 1.3-2.6 2.4-3.4 1.2-.8 2.5-1.2 4-1.2 2.2 0 3.9.6 5.2 2z",
                    className: "st1"
                })
            })
        ]
    });
}
function $cf61b77dbdb95489$var$de() {
    return $cf61b77dbdb95489$var$le.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        children: $cf61b77dbdb95489$var$le.jsx("path", {
            d: "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
        })
    });
}
var $cf61b77dbdb95489$var$fe, $cf61b77dbdb95489$var$he = function() {
    return $cf61b77dbdb95489$var$le.jsx("div", {
        className: "loader"
    });
}, $cf61b77dbdb95489$var$pe = function(e, t) {
    return t.test(e.navigator.userAgent);
}, $cf61b77dbdb95489$export$d0a8044dce8ff2fc = function(e) {
    return function(e, t) {
        return e.matchMedia(t).matches;
    }(e, "(any-pointer:coarse)");
}, $cf61b77dbdb95489$export$4e09c449d6c407f7 = function(e) {
    return $cf61b77dbdb95489$var$pe(e, /(?:Mozilla)(?=.*\b(?:Gecko|AppleWebKit))(?=.*\b(?:Chrome|Safari|Firefox|Opera|Edge|Brave|DuckDuckGo)).*/i);
}, $cf61b77dbdb95489$var$be = function(e) {
    return $cf61b77dbdb95489$var$pe(e, /Mobile DuckDuckGo/i);
}, $cf61b77dbdb95489$export$fedb369cb70207f1 = function(e) {
    return $cf61b77dbdb95489$var$be(e) || $cf61b77dbdb95489$var$pe(e, /iPhone|iPod|Mobile DuckDuckGo/i) || function(e) {
        return !!$cf61b77dbdb95489$var$pe(e, /iPad/i) || !(!$cf61b77dbdb95489$var$pe(e, /Macintosh/i) || !$cf61b77dbdb95489$export$d0a8044dce8ff2fc(e));
    }(e);
}, $cf61b77dbdb95489$export$a11b0059900ceec8 = function(e) {
    return !$cf61b77dbdb95489$var$be(e) && $cf61b77dbdb95489$var$pe(e, /android|sink/i);
}, $cf61b77dbdb95489$var$Ie = function(e) {
    var t;
    return e && 1 == (null === (t = e.ethereum) || void 0 === t ? void 0 : t.isTrust);
}, $cf61b77dbdb95489$export$1e4fed98bcaa1d82 = function(e) {
    return !$cf61b77dbdb95489$export$d0a8044dce8ff2fc(e);
}, $cf61b77dbdb95489$export$d53806e03704a04e = function(e) {
    return $cf61b77dbdb95489$var$pe(e, /(Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet|Windows Phone|SymbianOS|Kindle)/i);
}, $cf61b77dbdb95489$export$84097bf6fe069cb3 = function() {
    var e, t = navigator.userAgent, n = $cf61b77dbdb95489$var$o(new Map([
        [
            "Windows",
            "Windows"
        ],
        [
            "Mac",
            "Mac OS"
        ],
        [
            "Linux",
            "Linux"
        ],
        [
            "iPhone",
            "iOS"
        ],
        [
            "iPad",
            "iOS"
        ],
        [
            "Android",
            "Android"
        ]
    ]));
    try {
        for(n.s(); !(e = n.n()).done;){
            var r = $cf61b77dbdb95489$var$d(e.value, 2), i = r[0], a = r[1];
            if (-1 !== t.indexOf(i)) return a;
        }
    } catch (e) {
        n.e(e);
    } finally{
        n.f();
    }
    return "UNKNOWN";
}, $cf61b77dbdb95489$export$a4581ac54b250a0b = function() {
    var e, t = navigator.userAgent, n = $cf61b77dbdb95489$var$o(new Map([
        [
            "Firefox",
            "Firefox"
        ],
        [
            "Opera",
            "Opera"
        ],
        [
            "OPR",
            "Opera"
        ],
        [
            "Trident",
            "Internet Explorer"
        ],
        [
            "Edge",
            "Edge"
        ],
        [
            "Chrome",
            "Chrome"
        ],
        [
            "Safari",
            "Safari"
        ]
    ]));
    try {
        for(n.s(); !(e = n.n()).done;){
            var r = $cf61b77dbdb95489$var$d(e.value, 2), i = r[0], a = r[1];
            if (-1 !== t.indexOf(i)) return a;
        }
    } catch (e) {
        n.e(e);
    } finally{
        n.f();
    }
    return "UNKNOWN";
}, $cf61b77dbdb95489$var$we = function() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 768, t = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(window.innerWidth <= e), 2), n = t[0], r = t[1];
    return $cf61b77dbdb95489$var$_.useEffect(function() {
        var t = function() {
            r(window.innerWidth <= e);
        };
        return window.addEventListener("resize", t), function() {
            window.removeEventListener("resize", t);
        };
    }, [
        e
    ]), $cf61b77dbdb95489$export$d53806e03704a04e(window) || n;
}, $cf61b77dbdb95489$var$ke = function(e) {
    var t = e.onClick, n = e.children, r = e.className, i = void 0 === r ? "" : r;
    return $cf61b77dbdb95489$var$le.jsx("div", {
        className: "button-icon ".concat(i),
        onClick: t,
        children: n
    });
}, $cf61b77dbdb95489$var$Ne = function(e) {
    var t = $cf61b77dbdb95489$var$we();
    return $cf61b77dbdb95489$var$le.jsx("div", {
        className: e.open ? "alert-wrapper-show" : "alert-wrapper-hide",
        onClick: function() {
            e.closeOnBackdropClick && e.onCloseClick();
        },
        children: $cf61b77dbdb95489$var$le.jsxs("div", {
            className: e.open ? "alert-modal-show" : "alert-modal-hide",
            onClick: function(e) {
                e.stopPropagation();
            },
            children: [
                $cf61b77dbdb95489$var$le.jsxs("div", {
                    className: "alert-header",
                    children: [
                        e.onBackClick ? $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$ke, {
                            onClick: e.onBackClick,
                            children: $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$ue, {})
                        }) : $cf61b77dbdb95489$var$le.jsx("div", {
                            className: "alert-button-icon-empty"
                        }),
                        $cf61b77dbdb95489$var$le.jsx("div", {
                            className: "alert-logo",
                            children: $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$ce, {})
                        }),
                        $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$ke, {
                            onClick: e.onCloseClick,
                            children: $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$se, {})
                        })
                    ]
                }),
                $cf61b77dbdb95489$var$le.jsx("div", {
                    className: "alert-modal-loading-wrapper",
                    style: e.loading ? {
                        opacity: 1,
                        transition: "all ease 0.3s",
                        height: "14px",
                        overflow: "unset",
                        width: "unset"
                    } : {
                        opacity: 0,
                        transition: "all ease 0.3s",
                        height: 0,
                        overflow: "hidden",
                        width: 0
                    },
                    children: $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$he, {})
                }),
                $cf61b77dbdb95489$var$le.jsxs("div", {
                    className: "alert-body",
                    style: {
                        marginBottom: e.extraContent ? "" : "1.8em"
                    },
                    children: [
                        e.children,
                        !t && $cf61b77dbdb95489$var$le.jsxs("div", {
                            className: e.showMore ? "alert-body-extra-show" : "alert-body-extra-hide",
                            children: [
                                e.extraContent && $cf61b77dbdb95489$var$le.jsx("div", {
                                    className: "alert-divider"
                                }),
                                e.showMore && e.extraContent
                            ]
                        })
                    ]
                }),
                !t && e.extraContent && $cf61b77dbdb95489$var$le.jsx("div", {
                    className: "alert-footer",
                    onClick: function() {
                        return e.onClickShowMore && e.onClickShowMore();
                    },
                    children: e.showMore ? "Show less" : "Show more"
                })
            ]
        })
    });
};
function $cf61b77dbdb95489$var$Ue(e, ...t) {
    if (!((n = e) instanceof Uint8Array || ArrayBuffer.isView(n) && "Uint8Array" === n.constructor.name)) throw new Error("Uint8Array expected");
    var n;
    if (t.length > 0 && !t.includes(e.length)) throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function $cf61b77dbdb95489$var$Re(e, t = !0) {
    if (e.destroyed) throw new Error("Hash instance has been destroyed");
    if (t && e.finished) throw new Error("Hash#digest() has already been called");
}
!function(e) {
    e.PENDING = "pending", e.RESOLVED = "resolved", e.REJECTED = "rejected";
}($cf61b77dbdb95489$var$fe || ($cf61b77dbdb95489$var$fe = {}));
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const $cf61b77dbdb95489$var$Le = (e)=>new DataView(e.buffer, e.byteOffset, e.byteLength), $cf61b77dbdb95489$var$Ce = (e, t)=>e << 32 - t | e >>> t;
function $cf61b77dbdb95489$var$ze(e) {
    return "string" == typeof e && (e = function(e) {
        if ("string" != typeof e) throw new Error("utf8ToBytes expected string, got " + typeof e);
        return new Uint8Array((new TextEncoder).encode(e));
    }(e)), $cf61b77dbdb95489$var$Ue(e), e;
}
class $cf61b77dbdb95489$var$Te {
    clone() {
        return this._cloneInto();
    }
}
function $cf61b77dbdb95489$var$De(e) {
    const t = (t)=>e().update($cf61b77dbdb95489$var$ze(t)).digest(), n = e();
    return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = ()=>e(), t;
}
const $cf61b77dbdb95489$var$Fe = (e, t, n)=>e & t ^ ~e & n, $cf61b77dbdb95489$var$Ve = (e, t, n)=>e & t ^ e & n ^ t & n;
class $cf61b77dbdb95489$var$Ae extends $cf61b77dbdb95489$var$Te {
    constructor(e, t, n, r){
        super(), this.blockLen = e, this.outputLen = t, this.padOffset = n, this.isLE = r, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = $cf61b77dbdb95489$var$Le(this.buffer);
    }
    update(e) {
        $cf61b77dbdb95489$var$Re(this);
        const { view: t, buffer: n, blockLen: r } = this, i = (e = $cf61b77dbdb95489$var$ze(e)).length;
        for(let o = 0; o < i;){
            const a = Math.min(r - this.pos, i - o);
            if (a === r) {
                const t = $cf61b77dbdb95489$var$Le(e);
                for(; r <= i - o; o += r)this.process(t, o);
                continue;
            }
            n.set(e.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === r && (this.process(t, 0), this.pos = 0);
        }
        return this.length += e.length, this.roundClean(), this;
    }
    digestInto(e) {
        $cf61b77dbdb95489$var$Re(this), function(e, t) {
            $cf61b77dbdb95489$var$Ue(e);
            const n = t.outputLen;
            if (e.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
        }(e, this), this.finished = !0;
        const { buffer: t, view: n, blockLen: r, isLE: i } = this;
        let { pos: o } = this;
        t[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > r - o && (this.process(n, 0), o = 0);
        for(let e = o; e < r; e++)t[e] = 0;
        !function(e, t, n, r) {
            if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, n, r);
            const i = BigInt(32), o = BigInt(4294967295), a = Number(n >> i & o), l = Number(n & o), s = r ? 4 : 0, u = r ? 0 : 4;
            e.setUint32(t + s, a, r), e.setUint32(t + u, l, r);
        }(n, r - 8, BigInt(8 * this.length), i), this.process(n, 0);
        const a = $cf61b77dbdb95489$var$Le(e), l = this.outputLen;
        if (l % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const s = l / 4, u = this.get();
        if (s > u.length) throw new Error("_sha2: outputLen bigger than state");
        for(let e = 0; e < s; e++)a.setUint32(4 * e, u[e], i);
    }
    digest() {
        const { buffer: e, outputLen: t } = this;
        this.digestInto(e);
        const n = e.slice(0, t);
        return this.destroy(), n;
    }
    _cloneInto(e) {
        e || (e = new this.constructor), e.set(...this.get());
        const { blockLen: t, buffer: n, length: r, finished: i, destroyed: o, pos: a } = this;
        return e.length = r, e.pos = a, e.finished = i, e.destroyed = o, r % t && e.buffer.set(n), e;
    }
}
const $cf61b77dbdb95489$var$je = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
]), $cf61b77dbdb95489$var$Oe = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
]), $cf61b77dbdb95489$var$Qe = new Uint32Array(64);
class $cf61b77dbdb95489$var$qe extends $cf61b77dbdb95489$var$Ae {
    constructor(){
        super(64, 32, 8, !1), this.A = 0 | $cf61b77dbdb95489$var$Oe[0], this.B = 0 | $cf61b77dbdb95489$var$Oe[1], this.C = 0 | $cf61b77dbdb95489$var$Oe[2], this.D = 0 | $cf61b77dbdb95489$var$Oe[3], this.E = 0 | $cf61b77dbdb95489$var$Oe[4], this.F = 0 | $cf61b77dbdb95489$var$Oe[5], this.G = 0 | $cf61b77dbdb95489$var$Oe[6], this.H = 0 | $cf61b77dbdb95489$var$Oe[7];
    }
    get() {
        const { A: e, B: t, C: n, D: r, E: i, F: o, G: a, H: l } = this;
        return [
            e,
            t,
            n,
            r,
            i,
            o,
            a,
            l
        ];
    }
    set(e, t, n, r, i, o, a, l) {
        this.A = 0 | e, this.B = 0 | t, this.C = 0 | n, this.D = 0 | r, this.E = 0 | i, this.F = 0 | o, this.G = 0 | a, this.H = 0 | l;
    }
    process(e, t) {
        for(let n = 0; n < 16; n++, t += 4)$cf61b77dbdb95489$var$Qe[n] = e.getUint32(t, !1);
        for(let e = 16; e < 64; e++){
            const t = $cf61b77dbdb95489$var$Qe[e - 15], n = $cf61b77dbdb95489$var$Qe[e - 2], r = $cf61b77dbdb95489$var$Ce(t, 7) ^ $cf61b77dbdb95489$var$Ce(t, 18) ^ t >>> 3, i = $cf61b77dbdb95489$var$Ce(n, 17) ^ $cf61b77dbdb95489$var$Ce(n, 19) ^ n >>> 10;
            $cf61b77dbdb95489$var$Qe[e] = i + $cf61b77dbdb95489$var$Qe[e - 7] + r + $cf61b77dbdb95489$var$Qe[e - 16] | 0;
        }
        let { A: n, B: r, C: i, D: o, E: a, F: l, G: s, H: u } = this;
        for(let e = 0; e < 64; e++){
            const t = u + ($cf61b77dbdb95489$var$Ce(a, 6) ^ $cf61b77dbdb95489$var$Ce(a, 11) ^ $cf61b77dbdb95489$var$Ce(a, 25)) + $cf61b77dbdb95489$var$Fe(a, l, s) + $cf61b77dbdb95489$var$je[e] + $cf61b77dbdb95489$var$Qe[e] | 0, c = ($cf61b77dbdb95489$var$Ce(n, 2) ^ $cf61b77dbdb95489$var$Ce(n, 13) ^ $cf61b77dbdb95489$var$Ce(n, 22)) + $cf61b77dbdb95489$var$Ve(n, r, i) | 0;
            u = s, s = l, l = a, a = o + t | 0, o = i, i = r, r = n, n = t + c | 0;
        }
        n = n + this.A | 0, r = r + this.B | 0, i = i + this.C | 0, o = o + this.D | 0, a = a + this.E | 0, l = l + this.F | 0, s = s + this.G | 0, u = u + this.H | 0, this.set(n, r, i, o, a, l, s, u);
    }
    roundClean() {
        $cf61b77dbdb95489$var$Qe.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
}
const $cf61b77dbdb95489$var$We = $cf61b77dbdb95489$var$De(()=>new $cf61b77dbdb95489$var$qe);
var $cf61b77dbdb95489$var$Ge = function(e) {
    if (e.length >= 255) throw new TypeError("Alphabet too long");
    const t = new Uint8Array(256);
    for(let e = 0; e < t.length; e++)t[e] = 255;
    for(let n = 0; n < e.length; n++){
        const r = e.charAt(n), i = r.charCodeAt(0);
        if (255 !== t[i]) throw new TypeError(r + " is ambiguous");
        t[i] = n;
    }
    const n = e.length, r = e.charAt(0), i = Math.log(n) / Math.log(256), o = Math.log(256) / Math.log(n);
    function a(e) {
        if ("string" != typeof e) throw new TypeError("Expected String");
        if (0 === e.length) return new Uint8Array;
        let o = 0, a = 0, l = 0;
        for(; e[o] === r;)a++, o++;
        const s = (e.length - o) * i + 1 >>> 0, u = new Uint8Array(s);
        for(; o < e.length;){
            const r = e.charCodeAt(o);
            if (r > 255) return;
            let i = t[r];
            if (255 === i) return;
            let a = 0;
            for(let e = s - 1; (0 !== i || a < l) && -1 !== e; e--, a++)i += n * u[e] >>> 0, u[e] = i % 256 >>> 0, i = i / 256 >>> 0;
            if (0 !== i) throw new Error("Non-zero carry");
            l = a, o++;
        }
        let c = s - l;
        for(; c !== s && 0 === u[c];)c++;
        const d = new Uint8Array(a + (s - c));
        let f = a;
        for(; c !== s;)d[f++] = u[c++];
        return d;
    }
    return {
        encode: function(t) {
            if (t instanceof Uint8Array || (ArrayBuffer.isView(t) ? t = new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : Array.isArray(t) && (t = Uint8Array.from(t))), !(t instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
            if (0 === t.length) return "";
            let i = 0, a = 0, l = 0;
            const s = t.length;
            for(; l !== s && 0 === t[l];)l++, i++;
            const u = (s - l) * o + 1 >>> 0, c = new Uint8Array(u);
            for(; l !== s;){
                let e = t[l], r = 0;
                for(let t = u - 1; (0 !== e || r < a) && -1 !== t; t--, r++)e += 256 * c[t] >>> 0, c[t] = e % n >>> 0, e = e / n >>> 0;
                if (0 !== e) throw new Error("Non-zero carry");
                a = r, l++;
            }
            let d = u - a;
            for(; d !== u && 0 === c[d];)d++;
            let f = r.repeat(i);
            for(; d < u; ++d)f += e.charAt(c[d]);
            return f;
        },
        decodeUnsafe: a,
        decode: function(e) {
            const t = a(e);
            if (t) return t;
            throw new Error("Non-base" + n + " character");
        }
    };
}("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
var $cf61b77dbdb95489$var$Be = function(e) {
    function t(t) {
        var n = t.slice(0, -4), r = t.slice(-4), i = e(n);
        if (!(r[0] ^ i[0] | r[1] ^ i[1] | r[2] ^ i[2] | r[3] ^ i[3])) return n;
    }
    return {
        encode: function(t) {
            var n = Uint8Array.from(t), r = e(n), i = n.length + 4, o = new Uint8Array(i);
            return o.set(n, 0), o.set(r.subarray(0, 4), n.length), $cf61b77dbdb95489$var$Ge.encode(o);
        },
        decode: function(e) {
            var n = t($cf61b77dbdb95489$var$Ge.decode(e));
            if (null == n) throw new Error("Invalid checksum");
            return n;
        },
        decodeUnsafe: function(e) {
            var n = $cf61b77dbdb95489$var$Ge.decodeUnsafe(e);
            if (null != n) return t(n);
        }
    };
}(function(e) {
    return $cf61b77dbdb95489$var$We($cf61b77dbdb95489$var$We(e));
});
function $cf61b77dbdb95489$var$Ke(e, t = 0) {
    return (e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]) >>> 0;
}
function $cf61b77dbdb95489$var$Ye(e, t = 0) {
    return (e[t + 3] << 24 | e[t + 2] << 16 | e[t + 1] << 8 | e[t]) >>> 0;
}
function $cf61b77dbdb95489$var$Ze(e, t = new Uint8Array(4), n = 0) {
    return t[n + 0] = e >>> 24, t[n + 1] = e >>> 16, t[n + 2] = e >>> 8, t[n + 3] = e >>> 0, t;
}
function $cf61b77dbdb95489$var$Xe(e, t = new Uint8Array(4), n = 0) {
    return t[n + 0] = e >>> 0, t[n + 1] = e >>> 8, t[n + 2] = e >>> 16, t[n + 3] = e >>> 24, t;
}
function $cf61b77dbdb95489$var$Pe(e) {
    for(let t = 0; t < e.length; t++)e[t] = 0;
    return e;
}
const $cf61b77dbdb95489$var$Je = new class {
    isAvailable = !1;
    isInstantiated = !1;
    constructor(){
        "undefined" != typeof crypto && "getRandomValues" in crypto && (this.isAvailable = !0, this.isInstantiated = !0);
    }
    randomBytes(e) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        const t = new Uint8Array(e);
        for(let e = 0; e < t.length; e += 65536)crypto.getRandomValues(t.subarray(e, e + Math.min(t.length - e, 65536)));
        return t;
    }
};
function $cf61b77dbdb95489$var$He(e, t = $cf61b77dbdb95489$var$Je) {
    return t.randomBytes(e);
}
function $cf61b77dbdb95489$var$_e(e) {
    const t = new Float64Array(16);
    if (e) for(let n = 0; n < e.length; n++)t[n] = e[n];
    return t;
}
const $cf61b77dbdb95489$var$$e = new Uint8Array(32);
$cf61b77dbdb95489$var$$e[0] = 9;
const $cf61b77dbdb95489$var$et = $cf61b77dbdb95489$var$_e([
    56129,
    1
]);
function $cf61b77dbdb95489$var$tt(e) {
    let t = 1;
    for(let n = 0; n < 16; n++){
        let r = e[n] + t + 65535;
        t = Math.floor(r / 65536), e[n] = r - 65536 * t;
    }
    e[0] += t - 1 + 37 * (t - 1);
}
function $cf61b77dbdb95489$var$nt(e, t, n) {
    const r = ~(n - 1);
    for(let n = 0; n < 16; n++){
        const i = r & (e[n] ^ t[n]);
        e[n] ^= i, t[n] ^= i;
    }
}
function $cf61b77dbdb95489$var$rt(e, t, n) {
    for(let r = 0; r < 16; r++)e[r] = t[r] + n[r];
}
function $cf61b77dbdb95489$var$it(e, t, n) {
    for(let r = 0; r < 16; r++)e[r] = t[r] - n[r];
}
function $cf61b77dbdb95489$var$ot(e, t, n) {
    let r, i, o = 0, a = 0, l = 0, s = 0, u = 0, c = 0, d = 0, f = 0, h = 0, p = 0, m = 0, g = 0, b = 0, y = 0, v = 0, I = 0, M = 0, E = 0, x = 0, S = 0, w = 0, k = 0, N = 0, U = 0, R = 0, L = 0, C = 0, z = 0, T = 0, D = 0, F = 0, V = n[0], A = n[1], j = n[2], O = n[3], Q = n[4], q = n[5], W = n[6], G = n[7], B = n[8], K = n[9], Y = n[10], Z = n[11], X = n[12], P = n[13], J = n[14], H = n[15];
    r = t[0], o += r * V, a += r * A, l += r * j, s += r * O, u += r * Q, c += r * q, d += r * W, f += r * G, h += r * B, p += r * K, m += r * Y, g += r * Z, b += r * X, y += r * P, v += r * J, I += r * H, r = t[1], a += r * V, l += r * A, s += r * j, u += r * O, c += r * Q, d += r * q, f += r * W, h += r * G, p += r * B, m += r * K, g += r * Y, b += r * Z, y += r * X, v += r * P, I += r * J, M += r * H, r = t[2], l += r * V, s += r * A, u += r * j, c += r * O, d += r * Q, f += r * q, h += r * W, p += r * G, m += r * B, g += r * K, b += r * Y, y += r * Z, v += r * X, I += r * P, M += r * J, E += r * H, r = t[3], s += r * V, u += r * A, c += r * j, d += r * O, f += r * Q, h += r * q, p += r * W, m += r * G, g += r * B, b += r * K, y += r * Y, v += r * Z, I += r * X, M += r * P, E += r * J, x += r * H, r = t[4], u += r * V, c += r * A, d += r * j, f += r * O, h += r * Q, p += r * q, m += r * W, g += r * G, b += r * B, y += r * K, v += r * Y, I += r * Z, M += r * X, E += r * P, x += r * J, S += r * H, r = t[5], c += r * V, d += r * A, f += r * j, h += r * O, p += r * Q, m += r * q, g += r * W, b += r * G, y += r * B, v += r * K, I += r * Y, M += r * Z, E += r * X, x += r * P, S += r * J, w += r * H, r = t[6], d += r * V, f += r * A, h += r * j, p += r * O, m += r * Q, g += r * q, b += r * W, y += r * G, v += r * B, I += r * K, M += r * Y, E += r * Z, x += r * X, S += r * P, w += r * J, k += r * H, r = t[7], f += r * V, h += r * A, p += r * j, m += r * O, g += r * Q, b += r * q, y += r * W, v += r * G, I += r * B, M += r * K, E += r * Y, x += r * Z, S += r * X, w += r * P, k += r * J, N += r * H, r = t[8], h += r * V, p += r * A, m += r * j, g += r * O, b += r * Q, y += r * q, v += r * W, I += r * G, M += r * B, E += r * K, x += r * Y, S += r * Z, w += r * X, k += r * P, N += r * J, U += r * H, r = t[9], p += r * V, m += r * A, g += r * j, b += r * O, y += r * Q, v += r * q, I += r * W, M += r * G, E += r * B, x += r * K, S += r * Y, w += r * Z, k += r * X, N += r * P, U += r * J, R += r * H, r = t[10], m += r * V, g += r * A, b += r * j, y += r * O, v += r * Q, I += r * q, M += r * W, E += r * G, x += r * B, S += r * K, w += r * Y, k += r * Z, N += r * X, U += r * P, R += r * J, L += r * H, r = t[11], g += r * V, b += r * A, y += r * j, v += r * O, I += r * Q, M += r * q, E += r * W, x += r * G, S += r * B, w += r * K, k += r * Y, N += r * Z, U += r * X, R += r * P, L += r * J, C += r * H, r = t[12], b += r * V, y += r * A, v += r * j, I += r * O, M += r * Q, E += r * q, x += r * W, S += r * G, w += r * B, k += r * K, N += r * Y, U += r * Z, R += r * X, L += r * P, C += r * J, z += r * H, r = t[13], y += r * V, v += r * A, I += r * j, M += r * O, E += r * Q, x += r * q, S += r * W, w += r * G, k += r * B, N += r * K, U += r * Y, R += r * Z, L += r * X, C += r * P, z += r * J, T += r * H, r = t[14], v += r * V, I += r * A, M += r * j, E += r * O, x += r * Q, S += r * q, w += r * W, k += r * G, N += r * B, U += r * K, R += r * Y, L += r * Z, C += r * X, z += r * P, T += r * J, D += r * H, r = t[15], I += r * V, M += r * A, E += r * j, x += r * O, S += r * Q, w += r * q, k += r * W, N += r * G, U += r * B, R += r * K, L += r * Y, C += r * Z, z += r * X, T += r * P, D += r * J, F += r * H, o += 38 * M, a += 38 * E, l += 38 * x, s += 38 * S, u += 38 * w, c += 38 * k, d += 38 * N, f += 38 * U, h += 38 * R, p += 38 * L, m += 38 * C, g += 38 * z, b += 38 * T, y += 38 * D, v += 38 * F, i = 1, r = o + i + 65535, i = Math.floor(r / 65536), o = r - 65536 * i, r = a + i + 65535, i = Math.floor(r / 65536), a = r - 65536 * i, r = l + i + 65535, i = Math.floor(r / 65536), l = r - 65536 * i, r = s + i + 65535, i = Math.floor(r / 65536), s = r - 65536 * i, r = u + i + 65535, i = Math.floor(r / 65536), u = r - 65536 * i, r = c + i + 65535, i = Math.floor(r / 65536), c = r - 65536 * i, r = d + i + 65535, i = Math.floor(r / 65536), d = r - 65536 * i, r = f + i + 65535, i = Math.floor(r / 65536), f = r - 65536 * i, r = h + i + 65535, i = Math.floor(r / 65536), h = r - 65536 * i, r = p + i + 65535, i = Math.floor(r / 65536), p = r - 65536 * i, r = m + i + 65535, i = Math.floor(r / 65536), m = r - 65536 * i, r = g + i + 65535, i = Math.floor(r / 65536), g = r - 65536 * i, r = b + i + 65535, i = Math.floor(r / 65536), b = r - 65536 * i, r = y + i + 65535, i = Math.floor(r / 65536), y = r - 65536 * i, r = v + i + 65535, i = Math.floor(r / 65536), v = r - 65536 * i, r = I + i + 65535, i = Math.floor(r / 65536), I = r - 65536 * i, o += i - 1 + 37 * (i - 1), i = 1, r = o + i + 65535, i = Math.floor(r / 65536), o = r - 65536 * i, r = a + i + 65535, i = Math.floor(r / 65536), a = r - 65536 * i, r = l + i + 65535, i = Math.floor(r / 65536), l = r - 65536 * i, r = s + i + 65535, i = Math.floor(r / 65536), s = r - 65536 * i, r = u + i + 65535, i = Math.floor(r / 65536), u = r - 65536 * i, r = c + i + 65535, i = Math.floor(r / 65536), c = r - 65536 * i, r = d + i + 65535, i = Math.floor(r / 65536), d = r - 65536 * i, r = f + i + 65535, i = Math.floor(r / 65536), f = r - 65536 * i, r = h + i + 65535, i = Math.floor(r / 65536), h = r - 65536 * i, r = p + i + 65535, i = Math.floor(r / 65536), p = r - 65536 * i, r = m + i + 65535, i = Math.floor(r / 65536), m = r - 65536 * i, r = g + i + 65535, i = Math.floor(r / 65536), g = r - 65536 * i, r = b + i + 65535, i = Math.floor(r / 65536), b = r - 65536 * i, r = y + i + 65535, i = Math.floor(r / 65536), y = r - 65536 * i, r = v + i + 65535, i = Math.floor(r / 65536), v = r - 65536 * i, r = I + i + 65535, i = Math.floor(r / 65536), I = r - 65536 * i, o += i - 1 + 37 * (i - 1), e[0] = o, e[1] = a, e[2] = l, e[3] = s, e[4] = u, e[5] = c, e[6] = d, e[7] = f, e[8] = h, e[9] = p, e[10] = m, e[11] = g, e[12] = b, e[13] = y, e[14] = v, e[15] = I;
}
function $cf61b77dbdb95489$var$at(e, t) {
    $cf61b77dbdb95489$var$ot(e, t, t);
}
function $cf61b77dbdb95489$var$lt(e, t) {
    const n = new Uint8Array(32), r = new Float64Array(80), i = $cf61b77dbdb95489$var$_e(), o = $cf61b77dbdb95489$var$_e(), a = $cf61b77dbdb95489$var$_e(), l = $cf61b77dbdb95489$var$_e(), s = $cf61b77dbdb95489$var$_e(), u = $cf61b77dbdb95489$var$_e();
    for(let t = 0; t < 31; t++)n[t] = e[t];
    n[31] = 127 & e[31] | 64, n[0] &= 248, function(e, t) {
        for(let n = 0; n < 16; n++)e[n] = t[2 * n] + (t[2 * n + 1] << 8);
        e[15] &= 32767;
    }(r, t);
    for(let e = 0; e < 16; e++)o[e] = r[e];
    i[0] = l[0] = 1;
    for(let e = 254; e >= 0; --e){
        const t = n[e >>> 3] >>> (7 & e) & 1;
        $cf61b77dbdb95489$var$nt(i, o, t), $cf61b77dbdb95489$var$nt(a, l, t), $cf61b77dbdb95489$var$rt(s, i, a), $cf61b77dbdb95489$var$it(i, i, a), $cf61b77dbdb95489$var$rt(a, o, l), $cf61b77dbdb95489$var$it(o, o, l), $cf61b77dbdb95489$var$at(l, s), $cf61b77dbdb95489$var$at(u, i), $cf61b77dbdb95489$var$ot(i, a, i), $cf61b77dbdb95489$var$ot(a, o, s), $cf61b77dbdb95489$var$rt(s, i, a), $cf61b77dbdb95489$var$it(i, i, a), $cf61b77dbdb95489$var$at(o, i), $cf61b77dbdb95489$var$it(a, l, u), $cf61b77dbdb95489$var$ot(i, a, $cf61b77dbdb95489$var$et), $cf61b77dbdb95489$var$rt(i, i, l), $cf61b77dbdb95489$var$ot(a, a, i), $cf61b77dbdb95489$var$ot(i, l, u), $cf61b77dbdb95489$var$ot(l, o, r), $cf61b77dbdb95489$var$at(o, s), $cf61b77dbdb95489$var$nt(i, o, t), $cf61b77dbdb95489$var$nt(a, l, t);
    }
    for(let e = 0; e < 16; e++)r[e + 16] = i[e], r[e + 32] = a[e], r[e + 48] = o[e], r[e + 64] = l[e];
    const c = r.subarray(32), d = r.subarray(16);
    !function(e, t) {
        const n = $cf61b77dbdb95489$var$_e();
        for(let e = 0; e < 16; e++)n[e] = t[e];
        for(let e = 253; e >= 0; e--)$cf61b77dbdb95489$var$at(n, n), 2 !== e && 4 !== e && $cf61b77dbdb95489$var$ot(n, n, t);
        for(let t = 0; t < 16; t++)e[t] = n[t];
    }(c, c), $cf61b77dbdb95489$var$ot(d, d, c);
    const f = new Uint8Array(32);
    return function(e, t) {
        const n = $cf61b77dbdb95489$var$_e(), r = $cf61b77dbdb95489$var$_e();
        for(let e = 0; e < 16; e++)r[e] = t[e];
        $cf61b77dbdb95489$var$tt(r), $cf61b77dbdb95489$var$tt(r), $cf61b77dbdb95489$var$tt(r);
        for(let e = 0; e < 2; e++){
            n[0] = r[0] - 65517;
            for(let e = 1; e < 15; e++)n[e] = r[e] - 65535 - (n[e - 1] >> 16 & 1), n[e - 1] &= 65535;
            n[15] = r[15] - 32767 - (n[14] >> 16 & 1);
            const e = n[15] >> 16 & 1;
            n[14] &= 65535, $cf61b77dbdb95489$var$nt(r, n, 1 - e);
        }
        for(let t = 0; t < 16; t++)e[2 * t] = 255 & r[t], e[2 * t + 1] = r[t] >> 8;
    }(f, d), f;
}
function $cf61b77dbdb95489$var$st(e) {
    if (32 !== e.length) throw new Error("x25519: seed must be 32 bytes");
    const t = new Uint8Array(e);
    return {
        publicKey: $cf61b77dbdb95489$var$lt(t, $cf61b77dbdb95489$var$$e),
        secretKey: t
    };
}
function $cf61b77dbdb95489$var$ut(e, t, n = !1) {
    if (32 !== e.length) throw new Error("X25519: incorrect secret key length");
    if (32 !== t.length) throw new Error("X25519: incorrect public key length");
    const r = $cf61b77dbdb95489$var$lt(e, t);
    if (n) {
        let e = 0;
        for(let t = 0; t < r.length; t++)e |= r[t];
        if (0 === e) throw new Error("X25519: invalid shared key");
    }
    return r;
}
function $cf61b77dbdb95489$var$ct(e, t, n) {
    let r, i = 1634760805, o = n[3] << 24 | n[2] << 16 | n[1] << 8 | n[0], a = n[7] << 24 | n[6] << 16 | n[5] << 8 | n[4], l = n[11] << 24 | n[10] << 16 | n[9] << 8 | n[8], s = n[15] << 24 | n[14] << 16 | n[13] << 8 | n[12], u = 857760878, c = t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0], d = t[7] << 24 | t[6] << 16 | t[5] << 8 | t[4], f = t[11] << 24 | t[10] << 16 | t[9] << 8 | t[8], h = t[15] << 24 | t[14] << 16 | t[13] << 8 | t[12], p = 2036477234, m = n[19] << 24 | n[18] << 16 | n[17] << 8 | n[16], g = n[23] << 24 | n[22] << 16 | n[21] << 8 | n[20], b = n[27] << 24 | n[26] << 16 | n[25] << 8 | n[24], y = n[31] << 24 | n[30] << 16 | n[29] << 8 | n[28], v = 1797285236, I = i, M = o, E = a, x = l, S = s, w = u, k = c, N = d, U = f, R = h, L = p, C = m, z = g, T = b, D = y, F = v;
    for(let e = 0; e < 20; e += 2)r = I + z | 0, S ^= r << 7 | r >>> 25, r = S + I | 0, U ^= r << 9 | r >>> 23, r = U + S | 0, z ^= r << 13 | r >>> 19, r = z + U | 0, I ^= r << 18 | r >>> 14, r = w + M | 0, R ^= r << 7 | r >>> 25, r = R + w | 0, T ^= r << 9 | r >>> 23, r = T + R | 0, M ^= r << 13 | r >>> 19, r = M + T | 0, w ^= r << 18 | r >>> 14, r = L + k | 0, D ^= r << 7 | r >>> 25, r = D + L | 0, E ^= r << 9 | r >>> 23, r = E + D | 0, k ^= r << 13 | r >>> 19, r = k + E | 0, L ^= r << 18 | r >>> 14, r = F + C | 0, x ^= r << 7 | r >>> 25, r = x + F | 0, N ^= r << 9 | r >>> 23, r = N + x | 0, C ^= r << 13 | r >>> 19, r = C + N | 0, F ^= r << 18 | r >>> 14, r = I + x | 0, M ^= r << 7 | r >>> 25, r = M + I | 0, E ^= r << 9 | r >>> 23, r = E + M | 0, x ^= r << 13 | r >>> 19, r = x + E | 0, I ^= r << 18 | r >>> 14, r = w + S | 0, k ^= r << 7 | r >>> 25, r = k + w | 0, N ^= r << 9 | r >>> 23, r = N + k | 0, S ^= r << 13 | r >>> 19, r = S + N | 0, w ^= r << 18 | r >>> 14, r = L + R | 0, C ^= r << 7 | r >>> 25, r = C + L | 0, U ^= r << 9 | r >>> 23, r = U + C | 0, R ^= r << 13 | r >>> 19, r = R + U | 0, L ^= r << 18 | r >>> 14, r = F + D | 0, z ^= r << 7 | r >>> 25, r = z + F | 0, T ^= r << 9 | r >>> 23, r = T + z | 0, D ^= r << 13 | r >>> 19, r = D + T | 0, F ^= r << 18 | r >>> 14;
    $cf61b77dbdb95489$var$Xe(I + i | 0, e, 0), $cf61b77dbdb95489$var$Xe(M + o | 0, e, 4), $cf61b77dbdb95489$var$Xe(E + a | 0, e, 8), $cf61b77dbdb95489$var$Xe(x + l | 0, e, 12), $cf61b77dbdb95489$var$Xe(S + s | 0, e, 16), $cf61b77dbdb95489$var$Xe(w + u | 0, e, 20), $cf61b77dbdb95489$var$Xe(k + c | 0, e, 24), $cf61b77dbdb95489$var$Xe(N + d | 0, e, 28), $cf61b77dbdb95489$var$Xe(U + f | 0, e, 32), $cf61b77dbdb95489$var$Xe(R + h | 0, e, 36), $cf61b77dbdb95489$var$Xe(L + p | 0, e, 40), $cf61b77dbdb95489$var$Xe(C + m | 0, e, 44), $cf61b77dbdb95489$var$Xe(z + g | 0, e, 48), $cf61b77dbdb95489$var$Xe(T + b | 0, e, 52), $cf61b77dbdb95489$var$Xe(D + y | 0, e, 56), $cf61b77dbdb95489$var$Xe(F + v | 0, e, 60);
}
function $cf61b77dbdb95489$var$dt(e, t, n) {
    let r = 1;
    for(; n--;)r = r + (255 & e[t]) | 0, e[t] = 255 & r, r >>>= 8, t++;
    if (r > 0) throw new Error("Salsa20: counter overflow");
}
function $cf61b77dbdb95489$var$ft(e, t, n, r, i = 0) {
    if (0 === i) {
        if (24 !== t.length) throw new Error("XSalsa20 nonce must be 24 bytes");
    } else if (32 !== t.length) throw new Error("XSalsa20 nonce with counter must be 32 bytes");
    const o = $cf61b77dbdb95489$var$mt(e, t.subarray(0, 16), new Uint8Array(32)), a = function(e, t, n, r, i = 0) {
        if (32 !== e.length) throw new Error("Salsa20: key size must be 32 bytes");
        if (r.length < n.length) throw new Error("Salsa20: destination is shorter than source");
        let o, a;
        if (0 === i) {
            if (8 !== t.length) throw new Error("Salsa20 nonce must be 8 bytes");
            o = new Uint8Array(16), o.set(t), a = t.length;
        } else {
            if (16 !== t.length) throw new Error("Salsa20 nonce with counter must be 16 bytes");
            o = t, a = 16 - i;
        }
        const l = new Uint8Array(64);
        for(let t = 0; t < n.length; t += 64){
            $cf61b77dbdb95489$var$ct(l, o, e);
            for(let e = t; e < t + 64 && e < n.length; e++)r[e] = n[e] ^ l[e - t];
            $cf61b77dbdb95489$var$dt(o, a, o.length - a);
        }
        return $cf61b77dbdb95489$var$Pe(l), 0 === i && $cf61b77dbdb95489$var$Pe(o), r;
    }(o, t.subarray(16), n, r, i);
    return $cf61b77dbdb95489$var$Pe(o), a;
}
function $cf61b77dbdb95489$var$ht(e, t, n, r = 0) {
    return $cf61b77dbdb95489$var$Pe(n), $cf61b77dbdb95489$var$ft(e, t, n, n, r);
}
const $cf61b77dbdb95489$var$pt = 20;
function $cf61b77dbdb95489$var$mt(e, t, n) {
    let r, i = 1634760805, o = e[3] << 24 | e[2] << 16 | e[1] << 8 | e[0], a = e[7] << 24 | e[6] << 16 | e[5] << 8 | e[4], l = e[11] << 24 | e[10] << 16 | e[9] << 8 | e[8], s = e[15] << 24 | e[14] << 16 | e[13] << 8 | e[12], u = 857760878, c = t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0], d = t[7] << 24 | t[6] << 16 | t[5] << 8 | t[4], f = t[11] << 24 | t[10] << 16 | t[9] << 8 | t[8], h = t[15] << 24 | t[14] << 16 | t[13] << 8 | t[12], p = 2036477234, m = e[19] << 24 | e[18] << 16 | e[17] << 8 | e[16], g = e[23] << 24 | e[22] << 16 | e[21] << 8 | e[20], b = e[27] << 24 | e[26] << 16 | e[25] << 8 | e[24], y = e[31] << 24 | e[30] << 16 | e[29] << 8 | e[28], v = 1797285236;
    for(let e = 0; e < $cf61b77dbdb95489$var$pt; e += 2)r = i + g | 0, s ^= r << 7 | r >>> 25, r = s + i | 0, f ^= r << 9 | r >>> 23, r = f + s | 0, g ^= r << 13 | r >>> 19, r = g + f | 0, i ^= r << 18 | r >>> 14, r = u + o | 0, h ^= r << 7 | r >>> 25, r = h + u | 0, b ^= r << 9 | r >>> 23, r = b + h | 0, o ^= r << 13 | r >>> 19, r = o + b | 0, u ^= r << 18 | r >>> 14, r = p + c | 0, y ^= r << 7 | r >>> 25, r = y + p | 0, a ^= r << 9 | r >>> 23, r = a + y | 0, c ^= r << 13 | r >>> 19, r = c + a | 0, p ^= r << 18 | r >>> 14, r = v + m | 0, l ^= r << 7 | r >>> 25, r = l + v | 0, d ^= r << 9 | r >>> 23, r = d + l | 0, m ^= r << 13 | r >>> 19, r = m + d | 0, v ^= r << 18 | r >>> 14, r = i + l | 0, o ^= r << 7 | r >>> 25, r = o + i | 0, a ^= r << 9 | r >>> 23, r = a + o | 0, l ^= r << 13 | r >>> 19, r = l + a | 0, i ^= r << 18 | r >>> 14, r = u + s | 0, c ^= r << 7 | r >>> 25, r = c + u | 0, d ^= r << 9 | r >>> 23, r = d + c | 0, s ^= r << 13 | r >>> 19, r = s + d | 0, u ^= r << 18 | r >>> 14, r = p + h | 0, m ^= r << 7 | r >>> 25, r = m + p | 0, f ^= r << 9 | r >>> 23, r = f + m | 0, h ^= r << 13 | r >>> 19, r = h + f | 0, p ^= r << 18 | r >>> 14, r = v + y | 0, g ^= r << 7 | r >>> 25, r = g + v | 0, b ^= r << 9 | r >>> 23, r = b + g | 0, y ^= r << 13 | r >>> 19, r = y + b | 0, v ^= r << 18 | r >>> 14;
    return $cf61b77dbdb95489$var$Xe(i, n, 0), $cf61b77dbdb95489$var$Xe(u, n, 4), $cf61b77dbdb95489$var$Xe(p, n, 8), $cf61b77dbdb95489$var$Xe(v, n, 12), $cf61b77dbdb95489$var$Xe(c, n, 16), $cf61b77dbdb95489$var$Xe(d, n, 20), $cf61b77dbdb95489$var$Xe(f, n, 24), $cf61b77dbdb95489$var$Xe(h, n, 28), n;
}
class $cf61b77dbdb95489$var$gt {
    digestLength = 16;
    _buffer = new Uint8Array(16);
    _r = new Uint16Array(10);
    _h = new Uint16Array(10);
    _pad = new Uint16Array(8);
    _leftover = 0;
    _fin = 0;
    _finished = !1;
    constructor(e){
        let t = e[0] | e[1] << 8;
        this._r[0] = 8191 & t;
        let n = e[2] | e[3] << 8;
        this._r[1] = 8191 & (t >>> 13 | n << 3);
        let r = e[4] | e[5] << 8;
        this._r[2] = 7939 & (n >>> 10 | r << 6);
        let i = e[6] | e[7] << 8;
        this._r[3] = 8191 & (r >>> 7 | i << 9);
        let o = e[8] | e[9] << 8;
        this._r[4] = 255 & (i >>> 4 | o << 12), this._r[5] = o >>> 1 & 8190;
        let a = e[10] | e[11] << 8;
        this._r[6] = 8191 & (o >>> 14 | a << 2);
        let l = e[12] | e[13] << 8;
        this._r[7] = 8065 & (a >>> 11 | l << 5);
        let s = e[14] | e[15] << 8;
        this._r[8] = 8191 & (l >>> 8 | s << 8), this._r[9] = s >>> 5 & 127, this._pad[0] = e[16] | e[17] << 8, this._pad[1] = e[18] | e[19] << 8, this._pad[2] = e[20] | e[21] << 8, this._pad[3] = e[22] | e[23] << 8, this._pad[4] = e[24] | e[25] << 8, this._pad[5] = e[26] | e[27] << 8, this._pad[6] = e[28] | e[29] << 8, this._pad[7] = e[30] | e[31] << 8;
    }
    _blocks(e, t, n) {
        let r = this._fin ? 0 : 2048, i = this._h[0], o = this._h[1], a = this._h[2], l = this._h[3], s = this._h[4], u = this._h[5], c = this._h[6], d = this._h[7], f = this._h[8], h = this._h[9], p = this._r[0], m = this._r[1], g = this._r[2], b = this._r[3], y = this._r[4], v = this._r[5], I = this._r[6], M = this._r[7], E = this._r[8], x = this._r[9];
        for(; n >= 16;){
            let S = e[t + 0] | e[t + 1] << 8;
            i += 8191 & S;
            let w = e[t + 2] | e[t + 3] << 8;
            o += 8191 & (S >>> 13 | w << 3);
            let k = e[t + 4] | e[t + 5] << 8;
            a += 8191 & (w >>> 10 | k << 6);
            let N = e[t + 6] | e[t + 7] << 8;
            l += 8191 & (k >>> 7 | N << 9);
            let U = e[t + 8] | e[t + 9] << 8;
            s += 8191 & (N >>> 4 | U << 12), u += U >>> 1 & 8191;
            let R = e[t + 10] | e[t + 11] << 8;
            c += 8191 & (U >>> 14 | R << 2);
            let L = e[t + 12] | e[t + 13] << 8;
            d += 8191 & (R >>> 11 | L << 5);
            let C = e[t + 14] | e[t + 15] << 8;
            f += 8191 & (L >>> 8 | C << 8), h += C >>> 5 | r;
            let z = 0, T = z;
            T += i * p, T += o * (5 * x), T += a * (5 * E), T += l * (5 * M), T += s * (5 * I), z = T >>> 13, T &= 8191, T += u * (5 * v), T += c * (5 * y), T += d * (5 * b), T += f * (5 * g), T += h * (5 * m), z += T >>> 13, T &= 8191;
            let D = z;
            D += i * m, D += o * p, D += a * (5 * x), D += l * (5 * E), D += s * (5 * M), z = D >>> 13, D &= 8191, D += u * (5 * I), D += c * (5 * v), D += d * (5 * y), D += f * (5 * b), D += h * (5 * g), z += D >>> 13, D &= 8191;
            let F = z;
            F += i * g, F += o * m, F += a * p, F += l * (5 * x), F += s * (5 * E), z = F >>> 13, F &= 8191, F += u * (5 * M), F += c * (5 * I), F += d * (5 * v), F += f * (5 * y), F += h * (5 * b), z += F >>> 13, F &= 8191;
            let V = z;
            V += i * b, V += o * g, V += a * m, V += l * p, V += s * (5 * x), z = V >>> 13, V &= 8191, V += u * (5 * E), V += c * (5 * M), V += d * (5 * I), V += f * (5 * v), V += h * (5 * y), z += V >>> 13, V &= 8191;
            let A = z;
            A += i * y, A += o * b, A += a * g, A += l * m, A += s * p, z = A >>> 13, A &= 8191, A += u * (5 * x), A += c * (5 * E), A += d * (5 * M), A += f * (5 * I), A += h * (5 * v), z += A >>> 13, A &= 8191;
            let j = z;
            j += i * v, j += o * y, j += a * b, j += l * g, j += s * m, z = j >>> 13, j &= 8191, j += u * p, j += c * (5 * x), j += d * (5 * E), j += f * (5 * M), j += h * (5 * I), z += j >>> 13, j &= 8191;
            let O = z;
            O += i * I, O += o * v, O += a * y, O += l * b, O += s * g, z = O >>> 13, O &= 8191, O += u * m, O += c * p, O += d * (5 * x), O += f * (5 * E), O += h * (5 * M), z += O >>> 13, O &= 8191;
            let Q = z;
            Q += i * M, Q += o * I, Q += a * v, Q += l * y, Q += s * b, z = Q >>> 13, Q &= 8191, Q += u * g, Q += c * m, Q += d * p, Q += f * (5 * x), Q += h * (5 * E), z += Q >>> 13, Q &= 8191;
            let q = z;
            q += i * E, q += o * M, q += a * I, q += l * v, q += s * y, z = q >>> 13, q &= 8191, q += u * b, q += c * g, q += d * m, q += f * p, q += h * (5 * x), z += q >>> 13, q &= 8191;
            let W = z;
            W += i * x, W += o * E, W += a * M, W += l * I, W += s * v, z = W >>> 13, W &= 8191, W += u * y, W += c * b, W += d * g, W += f * m, W += h * p, z += W >>> 13, W &= 8191, z = (z << 2) + z | 0, z = z + T | 0, T = 8191 & z, z >>>= 13, D += z, i = T, o = D, a = F, l = V, s = A, u = j, c = O, d = Q, f = q, h = W, t += 16, n -= 16;
        }
        this._h[0] = i, this._h[1] = o, this._h[2] = a, this._h[3] = l, this._h[4] = s, this._h[5] = u, this._h[6] = c, this._h[7] = d, this._h[8] = f, this._h[9] = h;
    }
    finish(e, t = 0) {
        const n = new Uint16Array(10);
        let r, i, o, a;
        if (this._leftover) {
            for(a = this._leftover, this._buffer[a++] = 1; a < 16; a++)this._buffer[a] = 0;
            this._fin = 1, this._blocks(this._buffer, 0, 16);
        }
        for(r = this._h[1] >>> 13, this._h[1] &= 8191, a = 2; a < 10; a++)this._h[a] += r, r = this._h[a] >>> 13, this._h[a] &= 8191;
        for(this._h[0] += 5 * r, r = this._h[0] >>> 13, this._h[0] &= 8191, this._h[1] += r, r = this._h[1] >>> 13, this._h[1] &= 8191, this._h[2] += r, n[0] = this._h[0] + 5, r = n[0] >>> 13, n[0] &= 8191, a = 1; a < 10; a++)n[a] = this._h[a] + r, r = n[a] >>> 13, n[a] &= 8191;
        for(n[9] -= 8192, i = (1 ^ r) - 1, a = 0; a < 10; a++)n[a] &= i;
        for(i = ~i, a = 0; a < 10; a++)this._h[a] = this._h[a] & i | n[a];
        for(this._h[0] = 65535 & (this._h[0] | this._h[1] << 13), this._h[1] = 65535 & (this._h[1] >>> 3 | this._h[2] << 10), this._h[2] = 65535 & (this._h[2] >>> 6 | this._h[3] << 7), this._h[3] = 65535 & (this._h[3] >>> 9 | this._h[4] << 4), this._h[4] = 65535 & (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14), this._h[5] = 65535 & (this._h[6] >>> 2 | this._h[7] << 11), this._h[6] = 65535 & (this._h[7] >>> 5 | this._h[8] << 8), this._h[7] = 65535 & (this._h[8] >>> 8 | this._h[9] << 5), o = this._h[0] + this._pad[0], this._h[0] = 65535 & o, a = 1; a < 8; a++)o = (this._h[a] + this._pad[a] | 0) + (o >>> 16) | 0, this._h[a] = 65535 & o;
        return e[t + 0] = this._h[0] >>> 0, e[t + 1] = this._h[0] >>> 8, e[t + 2] = this._h[1] >>> 0, e[t + 3] = this._h[1] >>> 8, e[t + 4] = this._h[2] >>> 0, e[t + 5] = this._h[2] >>> 8, e[t + 6] = this._h[3] >>> 0, e[t + 7] = this._h[3] >>> 8, e[t + 8] = this._h[4] >>> 0, e[t + 9] = this._h[4] >>> 8, e[t + 10] = this._h[5] >>> 0, e[t + 11] = this._h[5] >>> 8, e[t + 12] = this._h[6] >>> 0, e[t + 13] = this._h[6] >>> 8, e[t + 14] = this._h[7] >>> 0, e[t + 15] = this._h[7] >>> 8, this._finished = !0, this;
    }
    update(e) {
        let t, n = 0, r = e.length;
        if (this._leftover) {
            t = 16 - this._leftover, t > r && (t = r);
            for(let r = 0; r < t; r++)this._buffer[this._leftover + r] = e[n + r];
            if (r -= t, n += t, this._leftover += t, this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16), this._leftover = 0;
        }
        if (r >= 16 && (t = r - r % 16, this._blocks(e, n, t), n += t, r -= t), r) {
            for(let t = 0; t < r; t++)this._buffer[this._leftover + t] = e[n + t];
            this._leftover += r;
        }
        return this;
    }
    digest() {
        if (this._finished) throw new Error("Poly1305 was finished");
        let e = new Uint8Array(16);
        return this.finish(e), e;
    }
    clean() {
        return $cf61b77dbdb95489$var$Pe(this._buffer), $cf61b77dbdb95489$var$Pe(this._r), $cf61b77dbdb95489$var$Pe(this._h), $cf61b77dbdb95489$var$Pe(this._pad), this._leftover = 0, this._fin = 0, this._finished = !0, this;
    }
}
function $cf61b77dbdb95489$var$bt(e, t) {
    const n = new $cf61b77dbdb95489$var$gt(e);
    n.update(t);
    const r = n.digest();
    return n.clean(), r;
}
function $cf61b77dbdb95489$var$yt(e, t, n) {
    if (24 !== t.length) throw new Error("secretBox nonce must be 24 bytes");
    const r = new Uint8Array(64), i = new Uint8Array(32);
    i.set(t), $cf61b77dbdb95489$var$ht(e, i, r, 8);
    const o = new Uint8Array(16 + n.length);
    for(let e = 0; e < 32 && e < n.length; e++)o[16 + e] = n[e] ^ r[32 + e];
    n.length > 32 && $cf61b77dbdb95489$var$ft(e, i, n.subarray(32), o.subarray(48), 8);
    const a = $cf61b77dbdb95489$var$bt(r.subarray(0, 32), o.subarray(16));
    for(let e = 0; e < a.length; e++)o[e] = a[e];
    return $cf61b77dbdb95489$var$Pe(a), $cf61b77dbdb95489$var$Pe(r), $cf61b77dbdb95489$var$Pe(i), o;
}
function $cf61b77dbdb95489$var$vt(e, t, n) {
    if (24 !== t.length) throw new Error("secretBox nonce must be 24 bytes");
    if (n.length < 16) throw new Error("secretBox data must be at least 16 bytes");
    const r = new Uint8Array(64), i = new Uint8Array(32);
    i.set(t), $cf61b77dbdb95489$var$ht(e, i, r, 8);
    const o = $cf61b77dbdb95489$var$bt(r.subarray(0, 32), n.subarray(16));
    if (a = o, l = n.subarray(0, 16), 16 !== a.length || 16 !== l.length || !function(e, t) {
        return 0 !== e.length && 0 !== t.length && 0 !== function(e, t) {
            if (e.length !== t.length) return 0;
            let n = 0;
            for(let r = 0; r < e.length; r++)n |= e[r] ^ t[r];
            return 1 & n - 1 >>> 8;
        }(e, t);
    }(a, l)) return null;
    var a, l;
    const s = n.subarray(16), u = new Uint8Array(s.length);
    for(let e = 0; e < 32 && e < s.length; e++)u[e] = s[e] ^ r[32 + e];
    return s.length > 32 && $cf61b77dbdb95489$var$ft(e, i, s.subarray(32), u.subarray(32), 8), $cf61b77dbdb95489$var$Pe(o), $cf61b77dbdb95489$var$Pe(r), $cf61b77dbdb95489$var$Pe(i), u;
}
const $cf61b77dbdb95489$var$It = new Uint8Array(16);
function $cf61b77dbdb95489$var$Mt(e, t) {
    const n = $cf61b77dbdb95489$var$lt(t, e);
    return $cf61b77dbdb95489$var$mt(n, $cf61b77dbdb95489$var$It, n), n;
}
const $cf61b77dbdb95489$var$Et = "utf8: invalid string";
function $cf61b77dbdb95489$var$xt(e) {
    const t = new Uint8Array(function(e) {
        let t = 0;
        for(let n = 0; n < e.length; n++){
            let r = e.charCodeAt(n);
            if (r >= 55296 && r <= 56319) {
                if (n === e.length - 1) throw new Error($cf61b77dbdb95489$var$Et);
                n++;
                const t = e.charCodeAt(n);
                if (t < 56320 || t > 57343) throw new Error($cf61b77dbdb95489$var$Et);
                r = t - 56320 + (r - 55296 << 10) + 65536;
            }
            t += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
        }
        return t;
    }(e));
    let n = 0;
    for(let r = 0; r < e.length; r++){
        let i = e.charCodeAt(r);
        i >= 55296 && i <= 56319 && (i = (i - 55296 << 10) + (e.charCodeAt(++r) - 56320) + 65536), i < 128 ? t[n++] = i : i < 2048 ? (t[n++] = 192 | i >> 6, t[n++] = 128 | 63 & i) : i < 65536 ? (t[n++] = 224 | i >> 12, t[n++] = 128 | i >> 6 & 63, t[n++] = 128 | 63 & i) : (t[n++] = 240 | i >> 18, t[n++] = 128 | i >> 12 & 63, t[n++] = 128 | i >> 6 & 63, t[n++] = 128 | 63 & i);
    }
    return t;
}
const $cf61b77dbdb95489$var$St = 128, $cf61b77dbdb95489$var$wt = Math.pow(2, 32) - 1, $cf61b77dbdb95489$var$kt = new Uint32Array([
    4089235720,
    1779033703,
    2227873595,
    3144134277,
    4271175723,
    1013904242,
    1595750129,
    2773480762,
    2917565137,
    1359893119,
    725511199,
    2600822924,
    4215389547,
    528734635,
    327033209,
    1541459225
]), $cf61b77dbdb95489$var$Nt = [
    [
        0,
        2,
        4,
        6,
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30
    ],
    [
        28,
        20,
        8,
        16,
        18,
        30,
        26,
        12,
        2,
        24,
        0,
        4,
        22,
        14,
        10,
        6
    ],
    [
        22,
        16,
        24,
        0,
        10,
        4,
        30,
        26,
        20,
        28,
        6,
        12,
        14,
        2,
        18,
        8
    ],
    [
        14,
        18,
        6,
        2,
        26,
        24,
        22,
        28,
        4,
        12,
        10,
        20,
        8,
        0,
        30,
        16
    ],
    [
        18,
        0,
        10,
        14,
        4,
        8,
        20,
        30,
        28,
        2,
        22,
        24,
        12,
        16,
        6,
        26
    ],
    [
        4,
        24,
        12,
        20,
        0,
        22,
        16,
        6,
        8,
        26,
        14,
        10,
        30,
        28,
        2,
        18
    ],
    [
        24,
        10,
        2,
        30,
        28,
        26,
        8,
        20,
        0,
        14,
        12,
        6,
        18,
        4,
        16,
        22
    ],
    [
        26,
        22,
        14,
        28,
        24,
        2,
        6,
        18,
        10,
        0,
        30,
        8,
        16,
        12,
        4,
        20
    ],
    [
        12,
        30,
        28,
        18,
        22,
        6,
        0,
        16,
        24,
        4,
        26,
        14,
        2,
        8,
        20,
        10
    ],
    [
        20,
        4,
        16,
        8,
        14,
        12,
        2,
        10,
        30,
        22,
        18,
        28,
        6,
        24,
        26,
        0
    ],
    [
        0,
        2,
        4,
        6,
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30
    ],
    [
        28,
        20,
        8,
        16,
        18,
        30,
        26,
        12,
        2,
        24,
        0,
        4,
        22,
        14,
        10,
        6
    ]
];
class $cf61b77dbdb95489$var$Ut {
    digestLength;
    blockSize = $cf61b77dbdb95489$var$St;
    _state = new Int32Array($cf61b77dbdb95489$var$kt);
    _buffer = new Uint8Array($cf61b77dbdb95489$var$St);
    _bufferLength = 0;
    _ctr = new Uint32Array(4);
    _flag = new Uint32Array(4);
    _lastNode = !1;
    _finished = !1;
    _vtmp = new Uint32Array(32);
    _mtmp = new Uint32Array(32);
    _paddedKey;
    _initialState;
    constructor(e = 64, t){
        if (this.digestLength = e, e < 1 || e > 64) throw new Error("blake2b: wrong digest length");
        t && this.validateConfig(t);
        let n = 0;
        t && t.key && (n = t.key.length);
        let r = 1, i = 1;
        t && t.tree && (r = t.tree.fanout, i = t.tree.maxDepth), this._state[0] ^= e | n << 8 | r << 16 | i << 24, t && t.tree && (this._state[1] ^= t.tree.leafSize, this._state[2] ^= t.tree.nodeOffsetLowBits, this._state[3] ^= t.tree.nodeOffsetHighBits, this._state[4] ^= t.tree.nodeDepth | t.tree.innerDigestLength << 8, this._lastNode = t.tree.lastNode), t && t.salt && (this._state[8] ^= $cf61b77dbdb95489$var$Ye(t.salt, 0), this._state[9] ^= $cf61b77dbdb95489$var$Ye(t.salt, 4), this._state[10] ^= $cf61b77dbdb95489$var$Ye(t.salt, 8), this._state[11] ^= $cf61b77dbdb95489$var$Ye(t.salt, 12)), t && t.personalization && (this._state[12] ^= $cf61b77dbdb95489$var$Ye(t.personalization, 0), this._state[13] ^= $cf61b77dbdb95489$var$Ye(t.personalization, 4), this._state[14] ^= $cf61b77dbdb95489$var$Ye(t.personalization, 8), this._state[15] ^= $cf61b77dbdb95489$var$Ye(t.personalization, 12)), this._initialState = new Uint32Array(this._state), t && t.key && n > 0 && (this._paddedKey = new Uint8Array($cf61b77dbdb95489$var$St), this._paddedKey.set(t.key), this._buffer.set(this._paddedKey), this._bufferLength = $cf61b77dbdb95489$var$St);
    }
    reset() {
        return this._state.set(this._initialState), this._paddedKey ? (this._buffer.set(this._paddedKey), this._bufferLength = $cf61b77dbdb95489$var$St) : this._bufferLength = 0, $cf61b77dbdb95489$var$Pe(this._ctr), $cf61b77dbdb95489$var$Pe(this._flag), this._finished = !1, this;
    }
    validateConfig(e) {
        if (e.key && e.key.length > 64) throw new Error("blake2b: wrong key length");
        if (e.salt && 16 !== e.salt.length) throw new Error("blake2b: wrong salt length");
        if (e.personalization && 16 !== e.personalization.length) throw new Error("blake2b: wrong personalization length");
        if (e.tree) {
            if (e.tree.fanout < 0 || e.tree.fanout > 255) throw new Error("blake2b: wrong tree fanout");
            if (e.tree.maxDepth < 0 || e.tree.maxDepth > 255) throw new Error("blake2b: wrong tree depth");
            if (e.tree.leafSize < 0 || e.tree.leafSize > $cf61b77dbdb95489$var$wt) throw new Error("blake2b: wrong leaf size");
            if (e.tree.innerDigestLength < 0 || e.tree.innerDigestLength > 64) throw new Error("blake2b: wrong tree inner digest length");
        }
    }
    update(e, t = e.length) {
        if (this._finished) throw new Error("blake2b: can't update because hash was finished.");
        const n = $cf61b77dbdb95489$var$St - this._bufferLength;
        let r = 0;
        if (0 === t) return this;
        if (t > n) {
            for(let t = 0; t < n; t++)this._buffer[this._bufferLength + t] = e[r + t];
            this._processBlock($cf61b77dbdb95489$var$St), r += n, t -= n, this._bufferLength = 0;
        }
        for(; t > $cf61b77dbdb95489$var$St;){
            for(let t = 0; t < $cf61b77dbdb95489$var$St; t++)this._buffer[t] = e[r + t];
            this._processBlock($cf61b77dbdb95489$var$St), r += $cf61b77dbdb95489$var$St, t -= $cf61b77dbdb95489$var$St, this._bufferLength = 0;
        }
        for(let n = 0; n < t; n++)this._buffer[this._bufferLength + n] = e[r + n];
        return this._bufferLength += t, this;
    }
    finish(e) {
        if (!this._finished) {
            for(let e = this._bufferLength; e < $cf61b77dbdb95489$var$St; e++)this._buffer[e] = 0;
            this._flag[0] = 4294967295, this._flag[1] = 4294967295, this._lastNode && (this._flag[2] = 4294967295, this._flag[3] = 4294967295), this._processBlock(this._bufferLength), this._finished = !0;
        }
        const t = this._buffer.subarray(0, 64);
        for(let e = 0; e < 16; e++)$cf61b77dbdb95489$var$Xe(this._state[e], t, 4 * e);
        return e.set(t.subarray(0, e.length)), this;
    }
    digest() {
        const e = new Uint8Array(this.digestLength);
        return this.finish(e), e;
    }
    clean() {
        $cf61b77dbdb95489$var$Pe(this._vtmp), $cf61b77dbdb95489$var$Pe(this._mtmp), $cf61b77dbdb95489$var$Pe(this._state), $cf61b77dbdb95489$var$Pe(this._buffer), $cf61b77dbdb95489$var$Pe(this._initialState), this._paddedKey && $cf61b77dbdb95489$var$Pe(this._paddedKey), this._bufferLength = 0, $cf61b77dbdb95489$var$Pe(this._ctr), $cf61b77dbdb95489$var$Pe(this._flag), this._lastNode = !1, this._finished = !1;
    }
    saveState() {
        if (this._finished) throw new Error("blake2b: cannot save finished state");
        return {
            state: new Uint32Array(this._state),
            buffer: new Uint8Array(this._buffer),
            bufferLength: this._bufferLength,
            ctr: new Uint32Array(this._ctr),
            flag: new Uint32Array(this._flag),
            lastNode: this._lastNode,
            paddedKey: this._paddedKey ? new Uint8Array(this._paddedKey) : void 0,
            initialState: new Uint32Array(this._initialState)
        };
    }
    restoreState(e) {
        return this._state.set(e.state), this._buffer.set(e.buffer), this._bufferLength = e.bufferLength, this._ctr.set(e.ctr), this._flag.set(e.flag), this._lastNode = e.lastNode, this._paddedKey && $cf61b77dbdb95489$var$Pe(this._paddedKey), this._paddedKey = e.paddedKey ? new Uint8Array(e.paddedKey) : void 0, this._initialState.set(e.initialState), this;
    }
    cleanSavedState(e) {
        $cf61b77dbdb95489$var$Pe(e.state), $cf61b77dbdb95489$var$Pe(e.buffer), $cf61b77dbdb95489$var$Pe(e.initialState), e.paddedKey && $cf61b77dbdb95489$var$Pe(e.paddedKey), e.bufferLength = 0, $cf61b77dbdb95489$var$Pe(e.ctr), $cf61b77dbdb95489$var$Pe(e.flag), e.lastNode = !1;
    }
    _G(e, t, n, r, i, o, a, l, s, u, c, d, f) {
        let h = e[t], p = e[o], m = e[n], g = e[a], b = e[r], y = e[l], v = e[i], I = e[s], M = 65535 & h, E = h >>> 16, x = 65535 & p, S = p >>> 16;
        M += 65535 & m, E += m >>> 16, x += 65535 & g, S += g >>> 16, E += M >>> 16, x += E >>> 16, S += x >>> 16, p = 65535 & x | S << 16, h = 65535 & M | E << 16, M = 65535 & h, E = h >>> 16, x = 65535 & p, S = p >>> 16, M += 65535 & u, E += u >>> 16, x += 65535 & c, S += c >>> 16, E += M >>> 16, x += E >>> 16, S += x >>> 16, p = 65535 & x | S << 16, h = 65535 & M | E << 16, v ^= h, I ^= p, M = I, I = v, v = M, M = 65535 & b, E = b >>> 16, x = 65535 & y, S = y >>> 16, M += 65535 & v, E += v >>> 16, x += 65535 & I, S += I >>> 16, E += M >>> 16, x += E >>> 16, S += x >>> 16, y = 65535 & x | S << 16, b = 65535 & M | E << 16, m ^= b, g ^= y, M = m << 8 | g >>> 24, m = g << 8 | m >>> 24, g = M, M = 65535 & h, E = h >>> 16, x = 65535 & p, S = p >>> 16, M += 65535 & m, E += m >>> 16, x += 65535 & g, S += g >>> 16, E += M >>> 16, x += E >>> 16, S += x >>> 16, p = 65535 & x | S << 16, h = 65535 & M | E << 16, M = 65535 & h, E = h >>> 16, x = 65535 & p, S = p >>> 16, M += 65535 & d, E += d >>> 16, x += 65535 & f, S += f >>> 16, E += M >>> 16, x += E >>> 16, S += x >>> 16, p = 65535 & x | S << 16, h = 65535 & M | E << 16, v ^= h, I ^= p, M = v << 16 | I >>> 16, v = I << 16 | v >>> 16, I = M, M = 65535 & b, E = b >>> 16, x = 65535 & y, S = y >>> 16, M += 65535 & v, E += v >>> 16, x += 65535 & I, S += I >>> 16, E += M >>> 16, x += E >>> 16, S += x >>> 16, y = 65535 & x | S << 16, b = 65535 & M | E << 16, m ^= b, g ^= y, M = g << 1 | m >>> 31, m = m << 1 | g >>> 31, g = M, e[t] = h, e[o] = p, e[n] = m, e[a] = g, e[r] = b, e[l] = y, e[i] = v, e[s] = I;
    }
    _incrementCounter(e) {
        for(let t = 0; t < 3; t++){
            let n = this._ctr[t] + e;
            if (this._ctr[t] = n >>> 0, this._ctr[t] === n) return;
            e = 1;
        }
    }
    _processBlock(e) {
        this._incrementCounter(e);
        let t = this._vtmp;
        t.set(this._state), t.set($cf61b77dbdb95489$var$kt, 16), t[24] ^= this._ctr[0], t[25] ^= this._ctr[1], t[26] ^= this._ctr[2], t[27] ^= this._ctr[3], t[28] ^= this._flag[0], t[29] ^= this._flag[1], t[30] ^= this._flag[2], t[31] ^= this._flag[3];
        let n = this._mtmp;
        for(let e = 0; e < 32; e++)n[e] = $cf61b77dbdb95489$var$Ye(this._buffer, 4 * e);
        for(let e = 0; e < 12; e++)this._G(t, 0, 8, 16, 24, 1, 9, 17, 25, n[$cf61b77dbdb95489$var$Nt[e][0]], n[$cf61b77dbdb95489$var$Nt[e][0] + 1], n[$cf61b77dbdb95489$var$Nt[e][1]], n[$cf61b77dbdb95489$var$Nt[e][1] + 1]), this._G(t, 2, 10, 18, 26, 3, 11, 19, 27, n[$cf61b77dbdb95489$var$Nt[e][2]], n[$cf61b77dbdb95489$var$Nt[e][2] + 1], n[$cf61b77dbdb95489$var$Nt[e][3]], n[$cf61b77dbdb95489$var$Nt[e][3] + 1]), this._G(t, 4, 12, 20, 28, 5, 13, 21, 29, n[$cf61b77dbdb95489$var$Nt[e][4]], n[$cf61b77dbdb95489$var$Nt[e][4] + 1], n[$cf61b77dbdb95489$var$Nt[e][5]], n[$cf61b77dbdb95489$var$Nt[e][5] + 1]), this._G(t, 6, 14, 22, 30, 7, 15, 23, 31, n[$cf61b77dbdb95489$var$Nt[e][6]], n[$cf61b77dbdb95489$var$Nt[e][6] + 1], n[$cf61b77dbdb95489$var$Nt[e][7]], n[$cf61b77dbdb95489$var$Nt[e][7] + 1]), this._G(t, 0, 10, 20, 30, 1, 11, 21, 31, n[$cf61b77dbdb95489$var$Nt[e][8]], n[$cf61b77dbdb95489$var$Nt[e][8] + 1], n[$cf61b77dbdb95489$var$Nt[e][9]], n[$cf61b77dbdb95489$var$Nt[e][9] + 1]), this._G(t, 2, 12, 22, 24, 3, 13, 23, 25, n[$cf61b77dbdb95489$var$Nt[e][10]], n[$cf61b77dbdb95489$var$Nt[e][10] + 1], n[$cf61b77dbdb95489$var$Nt[e][11]], n[$cf61b77dbdb95489$var$Nt[e][11] + 1]), this._G(t, 4, 14, 16, 26, 5, 15, 17, 27, n[$cf61b77dbdb95489$var$Nt[e][12]], n[$cf61b77dbdb95489$var$Nt[e][12] + 1], n[$cf61b77dbdb95489$var$Nt[e][13]], n[$cf61b77dbdb95489$var$Nt[e][13] + 1]), this._G(t, 6, 8, 18, 28, 7, 9, 19, 29, n[$cf61b77dbdb95489$var$Nt[e][14]], n[$cf61b77dbdb95489$var$Nt[e][14] + 1], n[$cf61b77dbdb95489$var$Nt[e][15]], n[$cf61b77dbdb95489$var$Nt[e][15] + 1]);
        for(let e = 0; e < 16; e++)this._state[e] ^= t[e] ^ t[e + 16];
    }
}
function $cf61b77dbdb95489$var$Rt(e, t = 64, n) {
    const r = new $cf61b77dbdb95489$var$Ut(t, n);
    r.update(e);
    const i = r.digest();
    return r.clean(), i;
}
class $cf61b77dbdb95489$var$Lt {
    digestLength = 64;
    blockSize = 128;
    _stateHi = new Int32Array(8);
    _stateLo = new Int32Array(8);
    _tempHi = new Int32Array(16);
    _tempLo = new Int32Array(16);
    _buffer = new Uint8Array(256);
    _bufferLength = 0;
    _bytesHashed = 0;
    _finished = !1;
    constructor(){
        this.reset();
    }
    _initState() {
        this._stateHi[0] = 1779033703, this._stateHi[1] = 3144134277, this._stateHi[2] = 1013904242, this._stateHi[3] = 2773480762, this._stateHi[4] = 1359893119, this._stateHi[5] = 2600822924, this._stateHi[6] = 528734635, this._stateHi[7] = 1541459225, this._stateLo[0] = 4089235720, this._stateLo[1] = 2227873595, this._stateLo[2] = 4271175723, this._stateLo[3] = 1595750129, this._stateLo[4] = 2917565137, this._stateLo[5] = 725511199, this._stateLo[6] = 4215389547, this._stateLo[7] = 327033209;
    }
    reset() {
        return this._initState(), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this;
    }
    clean() {
        $cf61b77dbdb95489$var$Pe(this._buffer), $cf61b77dbdb95489$var$Pe(this._tempHi), $cf61b77dbdb95489$var$Pe(this._tempLo), this.reset();
    }
    update(e, t = e.length) {
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        let n = 0;
        if (this._bytesHashed += t, this._bufferLength > 0) {
            for(; this._bufferLength < 128 && t > 0;)this._buffer[this._bufferLength++] = e[n++], t--;
            this._bufferLength === this.blockSize && ($cf61b77dbdb95489$var$zt(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize), this._bufferLength = 0);
        }
        for(t >= this.blockSize && (n = $cf61b77dbdb95489$var$zt(this._tempHi, this._tempLo, this._stateHi, this._stateLo, e, n, t), t %= this.blockSize); t > 0;)this._buffer[this._bufferLength++] = e[n++], t--;
        return this;
    }
    finish(e) {
        if (!this._finished) {
            const e = this._bytesHashed, t = this._bufferLength, n = e / 536870912 | 0, r = e << 3, i = e % 128 < 112 ? 128 : 256;
            this._buffer[t] = 128;
            for(let e = t + 1; e < i - 8; e++)this._buffer[e] = 0;
            $cf61b77dbdb95489$var$Ze(n, this._buffer, i - 8), $cf61b77dbdb95489$var$Ze(r, this._buffer, i - 4), $cf61b77dbdb95489$var$zt(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, i), this._finished = !0;
        }
        for(let t = 0; t < this.digestLength / 8; t++)$cf61b77dbdb95489$var$Ze(this._stateHi[t], e, 8 * t), $cf61b77dbdb95489$var$Ze(this._stateLo[t], e, 8 * t + 4);
        return this;
    }
    digest() {
        const e = new Uint8Array(this.digestLength);
        return this.finish(e), e;
    }
    saveState() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : void 0,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    }
    restoreState(e) {
        return this._stateHi.set(e.stateHi), this._stateLo.set(e.stateLo), this._bufferLength = e.bufferLength, e.buffer && this._buffer.set(e.buffer), this._bytesHashed = e.bytesHashed, this._finished = !1, this;
    }
    cleanSavedState(e) {
        $cf61b77dbdb95489$var$Pe(e.stateHi), $cf61b77dbdb95489$var$Pe(e.stateLo), e.buffer && $cf61b77dbdb95489$var$Pe(e.buffer), e.bufferLength = 0, e.bytesHashed = 0;
    }
}
const $cf61b77dbdb95489$var$Ct = new Int32Array([
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
]);
function $cf61b77dbdb95489$var$zt(e, t, n, r, i, o, a) {
    let l, s, u, c, d, f, h, p, m = n[0], g = n[1], b = n[2], y = n[3], v = n[4], I = n[5], M = n[6], E = n[7], x = r[0], S = r[1], w = r[2], k = r[3], N = r[4], U = r[5], R = r[6], L = r[7];
    for(; a >= 128;){
        for(let n = 0; n < 16; n++){
            const r = 8 * n + o;
            e[n] = $cf61b77dbdb95489$var$Ke(i, r), t[n] = $cf61b77dbdb95489$var$Ke(i, r + 4);
        }
        for(let n = 0; n < 80; n++){
            let r = m, i = g, o = b, a = y, C = v, z = I, T = M, D = E, F = x, V = S, A = w, j = k, O = N, Q = U, q = R, W = L;
            if (l = E, s = L, d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = (v >>> 14 | N << 18) ^ (v >>> 18 | N << 14) ^ (N >>> 9 | v << 23), s = (N >>> 14 | v << 18) ^ (N >>> 18 | v << 14) ^ (v >>> 9 | N << 23), d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, l = v & I ^ ~v & M, s = N & U ^ ~N & R, d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, l = $cf61b77dbdb95489$var$Ct[2 * n], s = $cf61b77dbdb95489$var$Ct[2 * n + 1], d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, l = e[n % 16], s = t[n % 16], d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, u = 65535 & h | p << 16, c = 65535 & d | f << 16, l = u, s = c, d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = (m >>> 28 | x << 4) ^ (x >>> 2 | m << 30) ^ (x >>> 7 | m << 25), s = (x >>> 28 | m << 4) ^ (m >>> 2 | x << 30) ^ (m >>> 7 | x << 25), d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, l = m & g ^ m & b ^ g & b, s = x & S ^ x & w ^ S & w, d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, D = 65535 & h | p << 16, W = 65535 & d | f << 16, l = a, s = j, d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = u, s = c, d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, a = 65535 & h | p << 16, j = 65535 & d | f << 16, g = r, b = i, y = o, v = a, I = C, M = z, E = T, m = D, S = F, w = V, k = A, N = j, U = O, R = Q, L = q, x = W, n % 16 == 15) for(let n = 0; n < 16; n++)l = e[n], s = t[n], d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = e[(n + 9) % 16], s = t[(n + 9) % 16], d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, u = e[(n + 1) % 16], c = t[(n + 1) % 16], l = (u >>> 1 | c << 31) ^ (u >>> 8 | c << 24) ^ u >>> 7, s = (c >>> 1 | u << 31) ^ (c >>> 8 | u << 24) ^ (c >>> 7 | u << 25), d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, u = e[(n + 14) % 16], c = t[(n + 14) % 16], l = (u >>> 19 | c << 13) ^ (c >>> 29 | u << 3) ^ u >>> 6, s = (c >>> 19 | u << 13) ^ (u >>> 29 | c << 3) ^ (c >>> 6 | u << 26), d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, e[n] = 65535 & h | p << 16, t[n] = 65535 & d | f << 16;
        }
        l = m, s = x, d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = n[0], s = r[0], d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, n[0] = m = 65535 & h | p << 16, r[0] = x = 65535 & d | f << 16, l = g, s = S, d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = n[1], s = r[1], d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, n[1] = g = 65535 & h | p << 16, r[1] = S = 65535 & d | f << 16, l = b, s = w, d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = n[2], s = r[2], d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, n[2] = b = 65535 & h | p << 16, r[2] = w = 65535 & d | f << 16, l = y, s = k, d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = n[3], s = r[3], d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, n[3] = y = 65535 & h | p << 16, r[3] = k = 65535 & d | f << 16, l = v, s = N, d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = n[4], s = r[4], d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, n[4] = v = 65535 & h | p << 16, r[4] = N = 65535 & d | f << 16, l = I, s = U, d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = n[5], s = r[5], d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, n[5] = I = 65535 & h | p << 16, r[5] = U = 65535 & d | f << 16, l = M, s = R, d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = n[6], s = r[6], d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, n[6] = M = 65535 & h | p << 16, r[6] = R = 65535 & d | f << 16, l = E, s = L, d = 65535 & s, f = s >>> 16, h = 65535 & l, p = l >>> 16, l = n[7], s = r[7], d += 65535 & s, f += s >>> 16, h += 65535 & l, p += l >>> 16, f += d >>> 16, h += f >>> 16, p += h >>> 16, n[7] = E = 65535 & h | p << 16, r[7] = L = 65535 & d | f << 16, o += 128, a -= 128;
    }
    return o;
}
function $cf61b77dbdb95489$var$Tt(e) {
    const t = new Float64Array(16);
    if (e) for(let n = 0; n < e.length; n++)t[n] = e[n];
    return t;
}
new Uint8Array(32)[0] = 9;
const $cf61b77dbdb95489$var$Dt = $cf61b77dbdb95489$var$Tt(), $cf61b77dbdb95489$var$Ft = $cf61b77dbdb95489$var$Tt([
    1
]), $cf61b77dbdb95489$var$Vt = $cf61b77dbdb95489$var$Tt([
    30883,
    4953,
    19914,
    30187,
    55467,
    16705,
    2637,
    112,
    59544,
    30585,
    16505,
    36039,
    65139,
    11119,
    27886,
    20995
]);
$cf61b77dbdb95489$var$Tt([
    61785,
    9906,
    39828,
    60374,
    45398,
    33411,
    5274,
    224,
    53552,
    61171,
    33010,
    6542,
    64743,
    22239,
    55772,
    9222
]), $cf61b77dbdb95489$var$Tt([
    54554,
    36645,
    11616,
    51542,
    42930,
    38181,
    51040,
    26924,
    56412,
    64982,
    57905,
    49316,
    21502,
    52590,
    14035,
    8553
]), $cf61b77dbdb95489$var$Tt([
    26200,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214
]);
const $cf61b77dbdb95489$var$At = $cf61b77dbdb95489$var$Tt([
    41136,
    18958,
    6951,
    50414,
    58488,
    44335,
    6150,
    12099,
    55207,
    15867,
    153,
    11085,
    57099,
    20417,
    9344,
    11139
]);
function $cf61b77dbdb95489$var$jt(e) {
    let t = 1;
    for(let n = 0; n < 16; n++){
        let r = e[n] + t + 65535;
        t = Math.floor(r / 65536), e[n] = r - 65536 * t;
    }
    e[0] += t - 1 + 37 * (t - 1);
}
function $cf61b77dbdb95489$var$Ot(e, t, n) {
    const r = ~(n - 1);
    for(let n = 0; n < 16; n++){
        const i = r & (e[n] ^ t[n]);
        e[n] ^= i, t[n] ^= i;
    }
}
function $cf61b77dbdb95489$var$Qt(e, t) {
    const n = $cf61b77dbdb95489$var$Tt(), r = $cf61b77dbdb95489$var$Tt();
    for(let e = 0; e < 16; e++)r[e] = t[e];
    $cf61b77dbdb95489$var$jt(r), $cf61b77dbdb95489$var$jt(r), $cf61b77dbdb95489$var$jt(r);
    for(let e = 0; e < 2; e++){
        n[0] = r[0] - 65517;
        for(let e = 1; e < 15; e++)n[e] = r[e] - 65535 - (n[e - 1] >> 16 & 1), n[e - 1] &= 65535;
        n[15] = r[15] - 32767 - (n[14] >> 16 & 1);
        const e = n[15] >> 16 & 1;
        n[14] &= 65535, $cf61b77dbdb95489$var$Ot(r, n, 1 - e);
    }
    for(let t = 0; t < 16; t++)e[2 * t] = 255 & r[t], e[2 * t + 1] = r[t] >> 8;
}
function $cf61b77dbdb95489$var$qt(e, t) {
    const n = new Uint8Array(32), r = new Uint8Array(32);
    return $cf61b77dbdb95489$var$Qt(n, e), $cf61b77dbdb95489$var$Qt(r, t), function(e, t) {
        let n = 0;
        for(let r = 0; r < 32; r++)n |= e[r] ^ t[r];
        return (1 & n - 1 >>> 8) - 1;
    }(n, r);
}
function $cf61b77dbdb95489$var$Wt(e, t, n) {
    for(let r = 0; r < 16; r++)e[r] = t[r] + n[r];
}
function $cf61b77dbdb95489$var$Gt(e, t, n) {
    for(let r = 0; r < 16; r++)e[r] = t[r] - n[r];
}
function $cf61b77dbdb95489$var$Bt(e, t, n) {
    let r, i, o = 0, a = 0, l = 0, s = 0, u = 0, c = 0, d = 0, f = 0, h = 0, p = 0, m = 0, g = 0, b = 0, y = 0, v = 0, I = 0, M = 0, E = 0, x = 0, S = 0, w = 0, k = 0, N = 0, U = 0, R = 0, L = 0, C = 0, z = 0, T = 0, D = 0, F = 0, V = n[0], A = n[1], j = n[2], O = n[3], Q = n[4], q = n[5], W = n[6], G = n[7], B = n[8], K = n[9], Y = n[10], Z = n[11], X = n[12], P = n[13], J = n[14], H = n[15];
    r = t[0], o += r * V, a += r * A, l += r * j, s += r * O, u += r * Q, c += r * q, d += r * W, f += r * G, h += r * B, p += r * K, m += r * Y, g += r * Z, b += r * X, y += r * P, v += r * J, I += r * H, r = t[1], a += r * V, l += r * A, s += r * j, u += r * O, c += r * Q, d += r * q, f += r * W, h += r * G, p += r * B, m += r * K, g += r * Y, b += r * Z, y += r * X, v += r * P, I += r * J, M += r * H, r = t[2], l += r * V, s += r * A, u += r * j, c += r * O, d += r * Q, f += r * q, h += r * W, p += r * G, m += r * B, g += r * K, b += r * Y, y += r * Z, v += r * X, I += r * P, M += r * J, E += r * H, r = t[3], s += r * V, u += r * A, c += r * j, d += r * O, f += r * Q, h += r * q, p += r * W, m += r * G, g += r * B, b += r * K, y += r * Y, v += r * Z, I += r * X, M += r * P, E += r * J, x += r * H, r = t[4], u += r * V, c += r * A, d += r * j, f += r * O, h += r * Q, p += r * q, m += r * W, g += r * G, b += r * B, y += r * K, v += r * Y, I += r * Z, M += r * X, E += r * P, x += r * J, S += r * H, r = t[5], c += r * V, d += r * A, f += r * j, h += r * O, p += r * Q, m += r * q, g += r * W, b += r * G, y += r * B, v += r * K, I += r * Y, M += r * Z, E += r * X, x += r * P, S += r * J, w += r * H, r = t[6], d += r * V, f += r * A, h += r * j, p += r * O, m += r * Q, g += r * q, b += r * W, y += r * G, v += r * B, I += r * K, M += r * Y, E += r * Z, x += r * X, S += r * P, w += r * J, k += r * H, r = t[7], f += r * V, h += r * A, p += r * j, m += r * O, g += r * Q, b += r * q, y += r * W, v += r * G, I += r * B, M += r * K, E += r * Y, x += r * Z, S += r * X, w += r * P, k += r * J, N += r * H, r = t[8], h += r * V, p += r * A, m += r * j, g += r * O, b += r * Q, y += r * q, v += r * W, I += r * G, M += r * B, E += r * K, x += r * Y, S += r * Z, w += r * X, k += r * P, N += r * J, U += r * H, r = t[9], p += r * V, m += r * A, g += r * j, b += r * O, y += r * Q, v += r * q, I += r * W, M += r * G, E += r * B, x += r * K, S += r * Y, w += r * Z, k += r * X, N += r * P, U += r * J, R += r * H, r = t[10], m += r * V, g += r * A, b += r * j, y += r * O, v += r * Q, I += r * q, M += r * W, E += r * G, x += r * B, S += r * K, w += r * Y, k += r * Z, N += r * X, U += r * P, R += r * J, L += r * H, r = t[11], g += r * V, b += r * A, y += r * j, v += r * O, I += r * Q, M += r * q, E += r * W, x += r * G, S += r * B, w += r * K, k += r * Y, N += r * Z, U += r * X, R += r * P, L += r * J, C += r * H, r = t[12], b += r * V, y += r * A, v += r * j, I += r * O, M += r * Q, E += r * q, x += r * W, S += r * G, w += r * B, k += r * K, N += r * Y, U += r * Z, R += r * X, L += r * P, C += r * J, z += r * H, r = t[13], y += r * V, v += r * A, I += r * j, M += r * O, E += r * Q, x += r * q, S += r * W, w += r * G, k += r * B, N += r * K, U += r * Y, R += r * Z, L += r * X, C += r * P, z += r * J, T += r * H, r = t[14], v += r * V, I += r * A, M += r * j, E += r * O, x += r * Q, S += r * q, w += r * W, k += r * G, N += r * B, U += r * K, R += r * Y, L += r * Z, C += r * X, z += r * P, T += r * J, D += r * H, r = t[15], I += r * V, M += r * A, E += r * j, x += r * O, S += r * Q, w += r * q, k += r * W, N += r * G, U += r * B, R += r * K, L += r * Y, C += r * Z, z += r * X, T += r * P, D += r * J, F += r * H, o += 38 * M, a += 38 * E, l += 38 * x, s += 38 * S, u += 38 * w, c += 38 * k, d += 38 * N, f += 38 * U, h += 38 * R, p += 38 * L, m += 38 * C, g += 38 * z, b += 38 * T, y += 38 * D, v += 38 * F, i = 1, r = o + i + 65535, i = Math.floor(r / 65536), o = r - 65536 * i, r = a + i + 65535, i = Math.floor(r / 65536), a = r - 65536 * i, r = l + i + 65535, i = Math.floor(r / 65536), l = r - 65536 * i, r = s + i + 65535, i = Math.floor(r / 65536), s = r - 65536 * i, r = u + i + 65535, i = Math.floor(r / 65536), u = r - 65536 * i, r = c + i + 65535, i = Math.floor(r / 65536), c = r - 65536 * i, r = d + i + 65535, i = Math.floor(r / 65536), d = r - 65536 * i, r = f + i + 65535, i = Math.floor(r / 65536), f = r - 65536 * i, r = h + i + 65535, i = Math.floor(r / 65536), h = r - 65536 * i, r = p + i + 65535, i = Math.floor(r / 65536), p = r - 65536 * i, r = m + i + 65535, i = Math.floor(r / 65536), m = r - 65536 * i, r = g + i + 65535, i = Math.floor(r / 65536), g = r - 65536 * i, r = b + i + 65535, i = Math.floor(r / 65536), b = r - 65536 * i, r = y + i + 65535, i = Math.floor(r / 65536), y = r - 65536 * i, r = v + i + 65535, i = Math.floor(r / 65536), v = r - 65536 * i, r = I + i + 65535, i = Math.floor(r / 65536), I = r - 65536 * i, o += i - 1 + 37 * (i - 1), i = 1, r = o + i + 65535, i = Math.floor(r / 65536), o = r - 65536 * i, r = a + i + 65535, i = Math.floor(r / 65536), a = r - 65536 * i, r = l + i + 65535, i = Math.floor(r / 65536), l = r - 65536 * i, r = s + i + 65535, i = Math.floor(r / 65536), s = r - 65536 * i, r = u + i + 65535, i = Math.floor(r / 65536), u = r - 65536 * i, r = c + i + 65535, i = Math.floor(r / 65536), c = r - 65536 * i, r = d + i + 65535, i = Math.floor(r / 65536), d = r - 65536 * i, r = f + i + 65535, i = Math.floor(r / 65536), f = r - 65536 * i, r = h + i + 65535, i = Math.floor(r / 65536), h = r - 65536 * i, r = p + i + 65535, i = Math.floor(r / 65536), p = r - 65536 * i, r = m + i + 65535, i = Math.floor(r / 65536), m = r - 65536 * i, r = g + i + 65535, i = Math.floor(r / 65536), g = r - 65536 * i, r = b + i + 65535, i = Math.floor(r / 65536), b = r - 65536 * i, r = y + i + 65535, i = Math.floor(r / 65536), y = r - 65536 * i, r = v + i + 65535, i = Math.floor(r / 65536), v = r - 65536 * i, r = I + i + 65535, i = Math.floor(r / 65536), I = r - 65536 * i, o += i - 1 + 37 * (i - 1), e[0] = o, e[1] = a, e[2] = l, e[3] = s, e[4] = u, e[5] = c, e[6] = d, e[7] = f, e[8] = h, e[9] = p, e[10] = m, e[11] = g, e[12] = b, e[13] = y, e[14] = v, e[15] = I;
}
function $cf61b77dbdb95489$var$Kt(e, t) {
    $cf61b77dbdb95489$var$Bt(e, t, t);
}
function $cf61b77dbdb95489$var$Yt(e, t) {
    const n = $cf61b77dbdb95489$var$Tt(), r = $cf61b77dbdb95489$var$Tt(), i = $cf61b77dbdb95489$var$Tt(), o = $cf61b77dbdb95489$var$Tt(), a = $cf61b77dbdb95489$var$Tt(), l = $cf61b77dbdb95489$var$Tt(), s = $cf61b77dbdb95489$var$Tt();
    return function(e, t) {
        for(let n = 0; n < 16; n++)e[n] = 0 | t[n];
    }(e[2], $cf61b77dbdb95489$var$Ft), function(e, t) {
        for(let n = 0; n < 16; n++)e[n] = t[2 * n] + (t[2 * n + 1] << 8);
        e[15] &= 32767;
    }(e[1], t), $cf61b77dbdb95489$var$Kt(i, e[1]), $cf61b77dbdb95489$var$Bt(o, i, $cf61b77dbdb95489$var$Vt), $cf61b77dbdb95489$var$Gt(i, i, e[2]), $cf61b77dbdb95489$var$Wt(o, e[2], o), $cf61b77dbdb95489$var$Kt(a, o), $cf61b77dbdb95489$var$Kt(l, a), $cf61b77dbdb95489$var$Bt(s, l, a), $cf61b77dbdb95489$var$Bt(n, s, i), $cf61b77dbdb95489$var$Bt(n, n, o), function(e, t) {
        const n = $cf61b77dbdb95489$var$Tt();
        let r;
        for(r = 0; r < 16; r++)n[r] = t[r];
        for(r = 250; r >= 0; r--)$cf61b77dbdb95489$var$Kt(n, n), 1 !== r && $cf61b77dbdb95489$var$Bt(n, n, t);
        for(r = 0; r < 16; r++)e[r] = n[r];
    }(n, n), $cf61b77dbdb95489$var$Bt(n, n, i), $cf61b77dbdb95489$var$Bt(n, n, o), $cf61b77dbdb95489$var$Bt(n, n, o), $cf61b77dbdb95489$var$Bt(e[0], n, o), $cf61b77dbdb95489$var$Kt(r, e[0]), $cf61b77dbdb95489$var$Bt(r, r, o), $cf61b77dbdb95489$var$qt(r, i) && $cf61b77dbdb95489$var$Bt(e[0], e[0], $cf61b77dbdb95489$var$At), $cf61b77dbdb95489$var$Kt(r, e[0]), $cf61b77dbdb95489$var$Bt(r, r, o), $cf61b77dbdb95489$var$qt(r, i) ? -1 : (function(e) {
        const t = new Uint8Array(32);
        return $cf61b77dbdb95489$var$Qt(t, e), 1 & t[0];
    }(e[0]) === t[31] >> 7 && $cf61b77dbdb95489$var$Gt(e[0], $cf61b77dbdb95489$var$Dt, e[0]), $cf61b77dbdb95489$var$Bt(e[3], e[0], e[1]), 0);
}
function $cf61b77dbdb95489$var$Zt(e) {
    let t = [
        $cf61b77dbdb95489$var$Tt(),
        $cf61b77dbdb95489$var$Tt(),
        $cf61b77dbdb95489$var$Tt(),
        $cf61b77dbdb95489$var$Tt()
    ];
    if ($cf61b77dbdb95489$var$Yt(t, e)) throw new Error("Ed25519: invalid public key");
    let n = $cf61b77dbdb95489$var$Tt(), r = $cf61b77dbdb95489$var$Tt(), i = t[1];
    $cf61b77dbdb95489$var$Wt(n, $cf61b77dbdb95489$var$Ft, i), $cf61b77dbdb95489$var$Gt(r, $cf61b77dbdb95489$var$Ft, i), function(e, t) {
        const n = $cf61b77dbdb95489$var$Tt();
        let r;
        for(r = 0; r < 16; r++)n[r] = t[r];
        for(r = 253; r >= 0; r--)$cf61b77dbdb95489$var$Kt(n, n), 2 !== r && 4 !== r && $cf61b77dbdb95489$var$Bt(n, n, t);
        for(r = 0; r < 16; r++)e[r] = n[r];
    }(r, r), $cf61b77dbdb95489$var$Bt(n, n, r);
    let o = new Uint8Array(32);
    return $cf61b77dbdb95489$var$Qt(o, n), o;
}
function $cf61b77dbdb95489$var$Xt(e) {
    const t = function(e) {
        const t = new $cf61b77dbdb95489$var$Lt;
        t.update(e);
        const n = t.digest();
        return t.clean(), n;
    }(e.subarray(0, 32));
    t[0] &= 248, t[31] &= 127, t[31] |= 64;
    const n = new Uint8Array(t.subarray(0, 32));
    return $cf61b77dbdb95489$var$Pe(t), n;
}
function $cf61b77dbdb95489$var$Pt(e) {
    return $cf61b77dbdb95489$require$Buffer.from(e).toString("hex");
}
async function $cf61b77dbdb95489$var$Jt(e, t) {
    const n = $cf61b77dbdb95489$var$Zt($cf61b77dbdb95489$require$Buffer.from(t)), r = function(e) {
        const t = $cf61b77dbdb95489$var$He(32, e), n = $cf61b77dbdb95489$var$st(t);
        return $cf61b77dbdb95489$var$Pe(t), n;
    }(), i = new $cf61b77dbdb95489$var$Ut(24).update(r.publicKey, 32).update(n, 32).digest(), o = "string" == typeof e ? $cf61b77dbdb95489$var$xt(e) : e, a = function(e, t, n, r) {
        const i = $cf61b77dbdb95489$var$Mt(e, t), o = $cf61b77dbdb95489$var$yt(i, n, r);
        return $cf61b77dbdb95489$var$Pe(i), o;
    }(n, r.secretKey, i, o);
    return $cf61b77dbdb95489$var$Pt(function(...e) {
        let t = 0;
        for(let n = 0; n < e.length; n++)t += e[n].length;
        const n = new Uint8Array(t);
        let r = 0;
        for(let t = 0; t < e.length; t++){
            const i = e[t];
            n.set(i, r), r += i.length;
        }
        return n;
    }(r.publicKey, a));
}
async function $cf61b77dbdb95489$var$Ht(e, t, n) {
    const r = $cf61b77dbdb95489$var$Xt($cf61b77dbdb95489$require$Buffer.from(n)), i = $cf61b77dbdb95489$var$Zt($cf61b77dbdb95489$require$Buffer.from(t)), o = "string" == typeof e ? $cf61b77dbdb95489$var$xt(e) : e, a = o.slice(0, 32), l = o.slice(32), s = function(e, t, n, r) {
        const i = $cf61b77dbdb95489$var$Mt(e, t), o = $cf61b77dbdb95489$var$vt(i, n, r);
        return $cf61b77dbdb95489$var$Pe(i), o;
    }(a, r, new $cf61b77dbdb95489$var$Ut(24).update(a, 32).update(i, 32).digest(), l);
    if (!s) throw new Error("Decryption failed");
    return $cf61b77dbdb95489$require$Buffer.from(s).toString();
}
var $cf61b77dbdb95489$var$_t, $cf61b77dbdb95489$var$$t, $cf61b77dbdb95489$var$en, $cf61b77dbdb95489$var$tn, $cf61b77dbdb95489$var$nn, $cf61b77dbdb95489$var$rn, $cf61b77dbdb95489$var$on, $cf61b77dbdb95489$var$an, $cf61b77dbdb95489$var$ln, $cf61b77dbdb95489$var$sn, $cf61b77dbdb95489$var$un, $cf61b77dbdb95489$var$cn, $cf61b77dbdb95489$var$dn;
!function(e) {
    e.BlockchainRequest = "blockchain_request", e.PermissionRequest = "permission_request", e.SignPayloadRequest = "sign_payload_request", e.OperationRequest = "operation_request", e.BroadcastRequest = "broadcast_request", e.ChangeAccountRequest = "change_account_request", e.BlockchainResponse = "blockchain_response", e.PermissionResponse = "permission_response", e.SignPayloadResponse = "sign_payload_response", e.ProofOfEventChallengeRequest = "proof_of_event_challenge_request", e.ProofOfEventChallengeResponse = "proof_of_event_challenge_response", e.SimulatedProofOfEventChallengeRequest = "simulated_proof_of_event_challenge_request", e.SimulatedProofOfEventChallengeResponse = "simulated_proof_of_event_challenge_response", e.OperationResponse = "operation_response", e.BroadcastResponse = "broadcast_response", e.Acknowledge = "acknowledge", e.Disconnect = "disconnect", e.Error = "error";
}($cf61b77dbdb95489$var$_t || ($cf61b77dbdb95489$var$_t = {})), function(e) {
    e.SIGN = "sign", e.OPERATION_REQUEST = "operation_request", e.ENCRYPT = "encrypt", e.NOTIFICATION = "notification", e.THRESHOLD = "threshold";
}($cf61b77dbdb95489$var$$t || ($cf61b77dbdb95489$var$$t = {})), function(e) {
    e.MAINNET = "mainnet", e.GHOSTNET = "ghostnet", e.WEEKLYNET = "weeklynet", e.DAILYNET = "dailynet", e.DELPHINET = "delphinet", e.EDONET = "edonet", e.FLORENCENET = "florencenet", e.GRANADANET = "granadanet", e.HANGZHOUNET = "hangzhounet", e.ITHACANET = "ithacanet", e.JAKARTANET = "jakartanet", e.KATHMANDUNET = "kathmandunet", e.LIMANET = "limanet", e.MUMBAINET = "mumbainet", e.NAIROBINET = "nairobinet", e.OXFORDNET = "oxfordnet", e.PARISNET = "parisnet", e.QUEBECNET = "quebecnet", e.RIONET = "rionet", e.SEOULNET = "seoulnet", e.SHADOWNET = "shadownet", e.CUSTOM = "custom";
}($cf61b77dbdb95489$var$en || ($cf61b77dbdb95489$var$en = {})), function(e) {
    e.ACTIVATE_ACCOUNT = "activate_account", e.ATTESTATION = "attestation", e.ATTESTATIONS_AGGREGATE = "attestations_aggregate", e.ATTESTATION_WITH_DAL = "attestation_with_dal", e.BALLOT = "ballot", e.DAL_PUBLISH_COMMITMENT = "dal_publish_commitment", e.DELEGATION = "delegation", e.DRAIN_DELEGATE = "drain_delegate", e.DOUBLE_ATTESTATION_EVIDENCE = "double_attestation_evidence", e.DOUBLE_BAKING_EVIDENCE = "double_baking_evidence", e.DOUBLE_ENDORSEMENT_EVIDENCE = "double_endorsement_evidence", e.DOUBLE_PREATTESTATION_EVIDENCE = "double_preattestation_evidence", e.DOUBLE_PREENDORSEMENT_EVIDENCE = "double_preendorsement_evidence", e.ENDORSEMENT = "endorsement", e.ENDORSEMENT_WITH_DAL = "endorsement_with_dal", e.EVENT = "event", e.FAILING_NOOP = "failing_noop", e.INCREASE_PAID_STORAGE = "increase_paid_storage", e.ORIGINATION = "origination", e.PREATTESTATION = "preattestation", e.PREATTESTATIONS_AGGREGATE = "preattestations_aggregate", e.PREENDORSEMENT = "preendorsement", e.PROPOSALS = "proposals", e.REGISTER_GLOBAL_CONSTANT = "register_global_constant", e.REVEAL = "reveal", e.SEED_NONCE_REVELATION = "seed_nonce_revelation", e.SET_DEPOSITS_LIMIT = "set_deposits_limit", e.SMART_ROLLUP_ADD_MESSAGES = "smart_rollup_add_messages", e.SMART_ROLLUP_CEMENT = "smart_rollup_cement", e.SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE = "smart_rollup_execute_outbox_message", e.SMART_ROLLUP_ORIGINATE = "smart_rollup_originate", e.SMART_ROLLUP_PUBLISH = "smart_rollup_publish", e.SMART_ROLLUP_RECOVER_BOND = "smart_rollup_recover_bond", e.SMART_ROLLUP_REFUTE = "smart_rollup_refute", e.SMART_ROLLUP_TIMEOUT = "smart_rollup_timeout", e.TICKET_UPDATES = "ticket_updates", e.TRANSACTION = "transaction", e.TRANSFER_TICKET = "transfer_ticket", e.UPDATE_CONSENSUS_KEY = "update_consensus_key", e.UPDATE_COMPANION_KEY = "update_companion_key", e.VDF_REVELATION = "vdf_revelation", e.DOUBLE_CONSENSUS_OPERATION_EVIDENCE = "double_consensus_operation_evidence", e.DAL_ENTRAPMENT_EVIDENCE = "dal_entrapment_evidence";
}($cf61b77dbdb95489$var$tn || ($cf61b77dbdb95489$var$tn = {})), function(e) {
    e.WEBSITE = "website", e.EXTENSION = "extension", e.P2P = "p2p", e.WALLETCONNECT = "walletconnect";
}($cf61b77dbdb95489$var$nn || ($cf61b77dbdb95489$var$nn = {})), function(e) {
    e.BACKGROUND = "toBackground", e.PAGE = "toPage", e.EXTENSION = "toExtension";
}($cf61b77dbdb95489$var$rn || ($cf61b77dbdb95489$var$rn = {})), function(e) {
    e.BROADCAST_ERROR = "BROADCAST_ERROR", e.NETWORK_NOT_SUPPORTED = "NETWORK_NOT_SUPPORTED", e.NO_ADDRESS_ERROR = "NO_ADDRESS_ERROR", e.NO_PRIVATE_KEY_FOUND_ERROR = "NO_PRIVATE_KEY_FOUND_ERROR", e.NOT_GRANTED_ERROR = "NOT_GRANTED_ERROR", e.PARAMETERS_INVALID_ERROR = "PARAMETERS_INVALID_ERROR", e.TOO_MANY_OPERATIONS = "TOO_MANY_OPERATIONS", e.TRANSACTION_INVALID_ERROR = "TRANSACTION_INVALID_ERROR", e.SIGNATURE_TYPE_NOT_SUPPORTED = "SIGNATURE_TYPE_NOT_SUPPORTED", e.ABORTED_ERROR = "ABORTED_ERROR", e.UNKNOWN_ERROR = "UNKNOWN_ERROR";
}($cf61b77dbdb95489$var$on || ($cf61b77dbdb95489$var$on = {})), function(e) {
    e.NOT_CONNECTED = "NOT_CONNECTED", e.CONNECTING = "CONNECTING", e.CONNECTED = "CONNECTED", e.SECONDARY_TAB_CONNECTED = "SECONDARY_TAB_CONNECTED";
}($cf61b77dbdb95489$var$an || ($cf61b77dbdb95489$var$an = {})), function(e) {
    e.CHROME_MESSAGE = "chrome_message", e.WALLETCONNECT = "walletconnect", e.POST_MESSAGE = "post_message", e.LEDGER = "ledger", e.P2P = "p2p";
}($cf61b77dbdb95489$var$ln || ($cf61b77dbdb95489$var$ln = {}));
class $cf61b77dbdb95489$var$fn {
    static isSupported() {
        return Promise.resolve(!1);
    }
}
!function(e) {
    e.TRANSPORT_P2P_PEERS_DAPP = "beacon:communication-peers-dapp", e.TRANSPORT_P2P_PEERS_WALLET = "beacon:communication-peers-wallet", e.TRANSPORT_POSTMESSAGE_PEERS_DAPP = "beacon:postmessage-peers-dapp", e.TRANSPORT_POSTMESSAGE_PEERS_WALLET = "beacon:postmessage-peers-wallet", e.TRANSPORT_WALLETCONNECT_PEERS_DAPP = "beacon:walletconnect-peers-dapp", e.LAST_SELECTED_WALLET = "beacon:last-selected-wallet", e.ACCOUNTS = "beacon:accounts", e.ACTIVE_ACCOUNT = "beacon:active-account", e.PUSH_TOKENS = "beacon:push-tokens", e.BEACON_SDK_SECRET_SEED = "beacon:sdk-secret-seed", e.BEACON_LAST_ERROR = "beacon:beacon-last-error", e.APP_METADATA_LIST = "beacon:app-metadata-list", e.PERMISSION_LIST = "beacon:permissions", e.ONGOING_PROOF_OF_EVENT_CHALLENGES = "beacon:ongoing-proof-of-event-challenges", e.BEACON_SDK_VERSION = "beacon:sdk_version", e.MATRIX_PRESERVED_STATE = "beacon:sdk-matrix-preserved-state", e.MATRIX_PEER_ROOM_IDS = "beacon:matrix-peer-rooms", e.MATRIX_SELECTED_NODE = "beacon:matrix-selected-node", e.MULTI_NODE_SETUP_DONE = "beacon:multi-node-setup", e.USER_ID = "beacon:user-id", e.ENABLE_METRICS = "beacon:enable_metrics", e.WC_INIT_ERROR = "beacon:wc-init-error", e.WC_2_CORE_PAIRING = "wc@2:core:0.3:pairing", e.WC_2_CLIENT_SESSION = "wc@2:client:0.3:session", e.WC_2_CORE_KEYCHAIN = "wc@2:core:0.3:keychain", e.WC_2_CORE_MESSAGES = "wc@2:core:0.3:messages", e.WC_2_CLIENT_PROPOSAL = "wc@2:client:0.3:proposal", e.WC_2_CORE_SUBSCRIPTION = "wc@2:core:0.3:subscription", e.WC_2_CORE_HISTORY = "wc@2:core:0.3:history", e.WC_2_CORE_EXPIRER = "wc@2:core:0.3:expirer";
}($cf61b77dbdb95489$var$sn || ($cf61b77dbdb95489$var$sn = {})), $cf61b77dbdb95489$var$sn.TRANSPORT_P2P_PEERS_DAPP, $cf61b77dbdb95489$var$sn.TRANSPORT_P2P_PEERS_WALLET, $cf61b77dbdb95489$var$sn.TRANSPORT_POSTMESSAGE_PEERS_DAPP, $cf61b77dbdb95489$var$sn.TRANSPORT_POSTMESSAGE_PEERS_WALLET, $cf61b77dbdb95489$var$sn.TRANSPORT_WALLETCONNECT_PEERS_DAPP, $cf61b77dbdb95489$var$sn.LAST_SELECTED_WALLET, $cf61b77dbdb95489$var$sn.ACCOUNTS, $cf61b77dbdb95489$var$sn.ACTIVE_ACCOUNT, $cf61b77dbdb95489$var$sn.PUSH_TOKENS, $cf61b77dbdb95489$var$sn.BEACON_SDK_SECRET_SEED, $cf61b77dbdb95489$var$sn.BEACON_LAST_ERROR, $cf61b77dbdb95489$var$sn.APP_METADATA_LIST, $cf61b77dbdb95489$var$sn.PERMISSION_LIST, $cf61b77dbdb95489$var$sn.ONGOING_PROOF_OF_EVENT_CHALLENGES, $cf61b77dbdb95489$var$sn.BEACON_SDK_VERSION, $cf61b77dbdb95489$var$sn.MATRIX_PRESERVED_STATE, $cf61b77dbdb95489$var$sn.MATRIX_PEER_ROOM_IDS, $cf61b77dbdb95489$var$sn.MATRIX_SELECTED_NODE, $cf61b77dbdb95489$var$sn.MULTI_NODE_SETUP_DONE, $cf61b77dbdb95489$var$sn.WC_2_CLIENT_SESSION, $cf61b77dbdb95489$var$sn.USER_ID, $cf61b77dbdb95489$var$sn.ENABLE_METRICS, $cf61b77dbdb95489$var$sn.WC_INIT_ERROR, $cf61b77dbdb95489$var$sn.WC_2_CORE_PAIRING, $cf61b77dbdb95489$var$sn.WC_2_CORE_KEYCHAIN, $cf61b77dbdb95489$var$sn.WC_2_CORE_MESSAGES, $cf61b77dbdb95489$var$sn.WC_2_CLIENT_PROPOSAL, $cf61b77dbdb95489$var$sn.WC_2_CORE_SUBSCRIPTION, $cf61b77dbdb95489$var$sn.WC_2_CORE_HISTORY, $cf61b77dbdb95489$var$sn.WC_2_CORE_EXPIRER, function(e) {
    e.RAW = "raw", e.OPERATION = "operation", e.MICHELINE = "micheline";
}($cf61b77dbdb95489$var$un || ($cf61b77dbdb95489$var$un = {}));
class $cf61b77dbdb95489$var$hn {
    type = "postmessage-pairing-request";
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(e, t, n, r, i, o){
        this.id = e, this.name = t, this.icon = i, this.appUrl = o, this.publicKey = n, this.version = r;
    }
}
class $cf61b77dbdb95489$var$pn {
    type = "postmessage-pairing-response";
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(e, t, n, r, i, o){
        this.id = e, this.name = t, this.icon = i, this.appUrl = o, this.publicKey = n, this.version = r;
    }
}
class $cf61b77dbdb95489$var$mn extends $cf61b77dbdb95489$var$pn {
    senderId;
    extensionId;
    constructor(e, t, n, r, i, o, a, l){
        super(e, t, n, r, a, l), this.senderId = i, this.extensionId = o;
    }
}
!function(e) {
    e.LIGHT = "light", e.DARK = "dark";
}($cf61b77dbdb95489$var$cn || ($cf61b77dbdb95489$var$cn = {})), function(e) {
    e.EUROPE_EAST = "europe-east", e.EUROPE_WEST = "europe-west", e.NORTH_AMERICA_EAST = "north-america-east", e.NORTH_AMERICA_WEST = "north-america-west", e.CENTRAL_AMERICA = "central-america", e.SOUTH_AMERICA = "south-america", e.ASIA_EAST = "asia-east", e.ASIA_WEST = "asia-west", e.AFRICA = "africa", e.AUSTRALIA = "australia";
}($cf61b77dbdb95489$var$dn || ($cf61b77dbdb95489$var$dn = {}));
const $cf61b77dbdb95489$var$gn = "https://beacon-backend.prod.gke.papers.tech", $cf61b77dbdb95489$var$bn = [
    (e)=>{}
];
let $cf61b77dbdb95489$var$yn = {
    postMessage: (e, t)=>{
        console.log("GOT MOCK POST MESSAGE", e), $cf61b77dbdb95489$var$bn.forEach((t)=>{
            t({
                data: e
            });
        });
    },
    addEventListener: (e, t)=>{
        $cf61b77dbdb95489$var$bn.push(t);
    },
    removeEventListener: (e, t)=>{
        $cf61b77dbdb95489$var$bn.splice($cf61b77dbdb95489$var$bn.indexOf((e)=>e === t), 1);
    },
    location: {
        origin: "*"
    }
};
try {
    "undefined" != typeof window && ($cf61b77dbdb95489$var$yn = window);
} catch (e) {
    console.log(`not defined: ${e}`);
}
function $cf61b77dbdb95489$var$vn(e) {
    return e;
}
class $cf61b77dbdb95489$var$In {
    storage;
    storageKey;
    constructor(e, t){
        this.storage = e, this.storageKey = t;
    }
    async getAll() {
        return await this.storage.get(this.storageKey) ?? [];
    }
    async getOne(e) {
        return (await this.storage.get(this.storageKey)).find(e);
    }
    async addOne(e, t, n = !0) {
        const r = await this.storage.get(this.storageKey);
        if (r.some(t)) {
            if (n) for(let n = 0; n < r.length; n++)t($cf61b77dbdb95489$var$vn(r)[n]) && (r[n] = e);
        } else r.push(e);
        return this.storage.set(this.storageKey, r);
    }
    async remove(e) {
        const t = (await this.storage.get(this.storageKey)).filter((t)=>!e(t));
        return this.storage.set(this.storageKey, t);
    }
    async removeAll() {
        return this.storage.delete(this.storageKey);
    }
}
let $cf61b77dbdb95489$var$Mn = !!$cf61b77dbdb95489$var$yn.beaconSdkDebugEnabled;
$cf61b77dbdb95489$var$Mn && console.log("[BEACON]: Debug mode is ON (turned on either by the developer or a browser extension)");
class $cf61b77dbdb95489$var$En {
    name;
    constructor(e){
        this.name = e;
    }
    debug(e, ...t) {
        $cf61b77dbdb95489$var$xn.debug(this.name, e, t);
    }
    log(e, ...t) {
        $cf61b77dbdb95489$var$xn.log(this.name, e, t);
    }
    warn(e, ...t) {
        $cf61b77dbdb95489$var$xn.warn(this.name, e, t);
    }
    error(e, ...t) {
        $cf61b77dbdb95489$var$xn.error(this.name, e, t);
    }
    time(e, t) {
        $cf61b77dbdb95489$var$xn.time(e, t);
    }
    timeLog(e, ...t) {
        $cf61b77dbdb95489$var$xn.timeLog(e, t);
    }
}
let $cf61b77dbdb95489$var$xn = new class {
    constructor(){}
    debug(e, t, ...n) {
        this._log("debug", e, t, n);
    }
    log(e, t, ...n) {
        this._log("log", e, t, n);
    }
    warn(e, t, ...n) {
        this._log("warn", e, t, n);
    }
    error(e, t, ...n) {
        this._log("error", e, t, n);
    }
    time(e, t) {
        e ? console.time(t) : console.timeEnd(t);
    }
    timeLog(e, t, ...n) {
        this._log("timeLog", e, t, n);
    }
    _log(e, t, n, r = []) {
        if (!$cf61b77dbdb95489$var$Mn) return;
        let i = `[BEACON] ${(new Date).toISOString()} [${t}](${n})`, o = r;
        switch(r[0] && "string" == typeof r[0] && (i += ` ${r[0]}`, o = r.slice(1)), e){
            case "error":
                console.group(i), console.error(...o);
                break;
            case "warn":
                console.group(i), console.warn(...o);
                break;
            case "debug":
                console.groupCollapsed(i), console.debug(...o);
                break;
            case "timeLog":
                console.group(i), console.timeLog(...o);
                break;
            default:
                console.group(i), console.log(...o);
        }
        console.groupEnd();
    }
};
class $cf61b77dbdb95489$var$Sn {
    async serialize(e) {
        const t = JSON.stringify(e);
        return $cf61b77dbdb95489$var$Be.encode($cf61b77dbdb95489$require$Buffer.from(t));
    }
    async deserialize(e) {
        if ("string" != typeof e) throw new Error("Encoded payload needs to be a string");
        const t = $cf61b77dbdb95489$var$Be.decode(e), n = $cf61b77dbdb95489$require$Buffer.from(t).toString("utf8");
        return JSON.parse(n);
    }
}
const $cf61b77dbdb95489$var$wn = new $cf61b77dbdb95489$var$En("Transport");
class $cf61b77dbdb95489$var$kn {
    type = $cf61b77dbdb95489$var$ln.POST_MESSAGE;
    name;
    _isConnected = $cf61b77dbdb95489$var$an.NOT_CONNECTED;
    peerManager;
    client;
    newPeerListener;
    setEventHandler(e, t) {
        this.client.eventHandlers.set(e, t);
    }
    listeners = [];
    get connectionStatus() {
        return this._isConnected;
    }
    constructor(e, t, n){
        this.name = e, this.client = t, this.peerManager = n;
    }
    static async isAvailable() {
        return Promise.resolve(!1);
    }
    async connect() {
        $cf61b77dbdb95489$var$wn.log("connect"), this._isConnected = $cf61b77dbdb95489$var$an.CONNECTED;
    }
    async disconnect() {
        $cf61b77dbdb95489$var$wn.log("disconnect"), this._isConnected = $cf61b77dbdb95489$var$an.NOT_CONNECTED;
    }
    async send(e, t) {
        if (t) return this.client.sendMessage(e, t);
        {
            const t = (await this.getPeers()).map((t)=>this.client.sendMessage(e, t));
            return (await Promise.all(t))[0];
        }
    }
    async addListener(e) {
        $cf61b77dbdb95489$var$wn.debug("addListener"), this.listeners.push(e);
    }
    async removeListener(e) {
        $cf61b77dbdb95489$var$wn.log("removeListener"), this.listeners = this.listeners.filter((t)=>t !== e);
    }
    async getPeers() {
        return this.peerManager.getPeers();
    }
    async addPeer(e, t = !0) {
        $cf61b77dbdb95489$var$wn.log("addPeer", "adding peer", e), await this.peerManager.addPeer(e), await this.listen(e.publicKey);
    }
    async removePeer(e) {
        $cf61b77dbdb95489$var$wn.log("removePeer", "removing peer", e), await this.peerManager.removePeer(e.publicKey), this.client && await this.client.unsubscribeFromEncryptedMessage(e.publicKey);
    }
    async removeAllPeers() {
        $cf61b77dbdb95489$var$wn.log("removeAllPeers"), await this.peerManager.removeAllPeers(), this.client && await this.client.unsubscribeFromEncryptedMessages();
    }
    async notifyListeners(e, t) {
        0 === this.listeners.length ? $cf61b77dbdb95489$var$wn.warn("notifyListeners", "0 listeners notified!", this) : $cf61b77dbdb95489$var$wn.log("notifyListeners", `Notifying ${this.listeners.length} listeners`, this), this.listeners.forEach((n)=>{
            n(e, t);
        });
    }
}
class $cf61b77dbdb95489$var$Nn {
    storageManager;
    constructor(e, t){
        this.storageManager = new $cf61b77dbdb95489$var$In(e, t);
    }
    async hasPeer(e) {
        return !!await this.getPeer(e);
    }
    async getPeers() {
        return await this.storageManager.getAll() ?? [];
    }
    async getPeer(e) {
        return this.storageManager.getOne((t)=>t.publicKey === e);
    }
    async addPeer(e) {
        return this.storageManager.addOne(e, (t)=>t.publicKey === e.publicKey);
    }
    async removePeer(e) {
        return this.storageManager.remove((t)=>t.publicKey === e);
    }
    async removePeers(e) {
        return this.storageManager.remove((t)=>e.includes(t.publicKey));
    }
    async removeAllPeers() {
        return this.storageManager.removeAll();
    }
}
const $cf61b77dbdb95489$var$Un = 32;
function $cf61b77dbdb95489$var$Rn(e, t, n = $cf61b77dbdb95489$var$Ut) {
    return function(e, t, n, r = $cf61b77dbdb95489$var$Ut) {
        const i = new r;
        if (64 !== i.digestLength) throw new Error("X25519: incorrect digest length");
        const o = i.update(e).update(n).update(t).digest();
        return {
            send: o.subarray(0, $cf61b77dbdb95489$var$Un),
            receive: o.subarray($cf61b77dbdb95489$var$Un)
        };
    }($cf61b77dbdb95489$var$ut(e.secretKey, t), e.publicKey, t, n);
}
function $cf61b77dbdb95489$var$Ln(e, t, n = $cf61b77dbdb95489$var$Ut) {
    return function(e, t, n, r = $cf61b77dbdb95489$var$Ut) {
        const i = new r;
        if (64 !== i.digestLength) throw new Error("X25519: incorrect digest length");
        const o = i.update(e).update(t).update(n).digest();
        return {
            receive: o.subarray(0, $cf61b77dbdb95489$var$Un),
            send: o.subarray($cf61b77dbdb95489$var$Un)
        };
    }($cf61b77dbdb95489$var$ut(e.secretKey, t), e.publicKey, t, n);
}
class $cf61b77dbdb95489$var$Cn {
    keyPair;
    constructor(e){
        this.keyPair = e;
    }
    eventHandlers = new Map;
    isMobileOS = ()=>/(Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet|Windows Phone|SymbianOS|Kindle)/i.test(navigator.userAgent);
    async getPublicKey() {
        return $cf61b77dbdb95489$var$Pt(this.keyPair?.publicKey);
    }
    async getPublicKeyHash() {
        return async function(e) {
            return $cf61b77dbdb95489$var$Pt($cf61b77dbdb95489$var$Rt("string" == typeof e ? $cf61b77dbdb95489$var$xt(e) : e, 32));
        }(this.keyPair.publicKey);
    }
    async createCryptoBoxServer(e, t) {
        return $cf61b77dbdb95489$var$Rn({
            publicKey: $cf61b77dbdb95489$var$Zt(t.publicKey),
            secretKey: $cf61b77dbdb95489$var$Xt(t.secretKey)
        }, $cf61b77dbdb95489$var$Zt($cf61b77dbdb95489$require$Buffer.from(e, "hex")));
    }
    async createCryptoBoxClient(e, t) {
        return $cf61b77dbdb95489$var$Ln({
            publicKey: $cf61b77dbdb95489$var$Zt(t.publicKey),
            secretKey: $cf61b77dbdb95489$var$Xt(t.secretKey)
        }, $cf61b77dbdb95489$var$Zt($cf61b77dbdb95489$require$Buffer.from(e, "hex")));
    }
    async encryptMessageAsymmetric(e, t) {
        return $cf61b77dbdb95489$var$Jt(t, $cf61b77dbdb95489$require$Buffer.from(e, "hex"));
    }
}
class $cf61b77dbdb95489$var$zn extends $cf61b77dbdb95489$var$Cn {
    name;
    constructor(e, t){
        super(t), this.name = e, this.init().catch(console.error);
    }
    async start() {
        await Promise.resolve();
    }
    async getPairingRequestInfo() {
        return new $cf61b77dbdb95489$var$hn(await async function() {
            const e = $cf61b77dbdb95489$var$He(16);
            return [
                e.slice(0, 4),
                e.slice(4, 6),
                e.slice(6, 8),
                e.slice(8, 10),
                e.slice(10, 16)
            ].map(function(e) {
                return $cf61b77dbdb95489$require$Buffer.from(e).toString("hex");
            }).join("-");
        }(), this.name, await this.getPublicKey(), "3");
    }
    async getPairingResponseInfo(e) {
        return new $cf61b77dbdb95489$var$pn(e.id, this.name, await this.getPublicKey(), e.version);
    }
    async unsubscribeFromEncryptedMessage(e) {
        this.activeListeners.get(e) && this.activeListeners.delete(e);
    }
    async unsubscribeFromEncryptedMessages() {
        this.activeListeners.clear();
    }
    async decryptMessage(e, t) {
        const n = await this.createCryptoBoxServer(e, this.keyPair), r = $cf61b77dbdb95489$require$Buffer.from(t, "hex");
        if (r.length >= 40) try {
            return await async function(e, t) {
                const n = $cf61b77dbdb95489$var$vt(t, e.slice(0, 24), e.slice(24));
                if (!n) throw new Error("Decryption failed");
                return $cf61b77dbdb95489$require$Buffer.from(n).toString("utf8");
            }(r, n.receive);
        } catch (e) {}
        throw new Error("Could not decrypt message");
    }
    async encryptMessage(e, t) {
        return async function(e, t) {
            const n = $cf61b77dbdb95489$require$Buffer.from($cf61b77dbdb95489$var$He(24));
            return $cf61b77dbdb95489$var$Pt($cf61b77dbdb95489$require$Buffer.concat([
                n,
                $cf61b77dbdb95489$require$Buffer.from($cf61b77dbdb95489$var$yt(t, n, $cf61b77dbdb95489$require$Buffer.from(e, "utf8")))
            ]));
        }(t, (await this.createCryptoBoxClient(e, this.keyPair)).send);
    }
}
const $cf61b77dbdb95489$var$Tn = new $cf61b77dbdb95489$var$En("IndexedDBStorage");
class $cf61b77dbdb95489$var$Dn extends $cf61b77dbdb95489$var$fn {
    dbName;
    storeNames;
    db = null;
    isSupported = !0;
    constructor(e = "WALLET_CONNECT_V2_INDEXED_DB", t = [
        "keyvaluestorage"
    ]){
        super(), this.dbName = e, this.storeNames = t, this.initDB().then((e)=>this.db = e).catch((e)=>$cf61b77dbdb95489$var$Tn.error(e.message));
    }
    isIndexedDBSupported() {
        return "undefined" != typeof window && "indexedDB" in window ? ($cf61b77dbdb95489$var$Tn.log("isIndexedDBSupported", "IndexedDB is supported in this browser."), !0) : ($cf61b77dbdb95489$var$Tn.error("isIndexedDBSupported", "IndexedDB is not supported in this browser."), !1);
    }
    async initDB() {
        return new Promise((e, t)=>{
            if (this.isSupported = this.isIndexedDBSupported(), !this.isSupported) return void t("IndexedDB is not supported.");
            const n = indexedDB.open(this.dbName);
            n.onupgradeneeded = ()=>{
                const e = n.result;
                this.storeNames.forEach((t)=>{
                    e.objectStoreNames.contains(t) || e.createObjectStore(t);
                });
            }, n.onsuccess = (n)=>{
                const r = n.target.result, i = this.storeNames.filter((e)=>!r.objectStoreNames.contains(e));
                if (i.length > 0) {
                    r.close();
                    const n = r.version + 1, o = indexedDB.open(this.dbName, n);
                    o.onupgradeneeded = ()=>{
                        const e = o.result;
                        i.forEach((t)=>{
                            e.objectStoreNames.contains(t) || e.createObjectStore(t);
                        });
                    }, o.onsuccess = (t)=>{
                        this.db = t.target.result, e(this.db);
                    }, o.onerror = (e)=>t(e.target.error);
                } else this.db = r, e(r);
            }, n.onerror = (e)=>t(e.target.error);
        });
    }
    async transaction(e, t, n) {
        return new Promise((r, i)=>{
            if (!this.isSupported) return void i("IndexedDB is not supported.");
            if (!this.db?.objectStoreNames.contains(t)) return void i(`${t} not found. error: ${(new Error).stack}`);
            const o = this.db.transaction(t, e).objectStore(t);
            n(o).then(r).catch(i);
        });
    }
    get(e, t = this.storeNames[0]) {
        return this.transaction("readonly", t, (t)=>new Promise((n, r)=>{
                const i = t.get(e);
                i.onsuccess = ()=>n(i.result), i.onerror = ()=>r(i.error);
            }));
    }
    set(e, t, n = this.storeNames[0]) {
        return this.transaction("readwrite", n, (n)=>new Promise((r, i)=>{
                const o = n.put(t, e);
                o.onsuccess = ()=>r(), o.onerror = ()=>i(o.error);
            }));
    }
    delete(e, t = this.storeNames[0]) {
        return this.transaction("readwrite", t, (t)=>new Promise((n, r)=>{
                const i = t.delete(e);
                i.onsuccess = ()=>n(), i.onerror = ()=>r(i.error);
            }));
    }
    getAll(e) {
        return this.transaction("readonly", e || this.storeNames[0], (e)=>new Promise((t, n)=>{
                const r = e.getAll();
                r.onsuccess = ()=>t(r.result), r.onerror = ()=>n(r.error);
            }));
    }
    getAllKeys(e) {
        return this.transaction("readonly", e || this.storeNames[0], (e)=>new Promise((t, n)=>{
                const r = e.getAllKeys();
                r.onsuccess = ()=>t(r.result), r.onerror = ()=>n(r.error);
            }));
    }
    clearStore(e) {
        return this.transaction("readwrite", e || this.storeNames[0], (e)=>new Promise((t, n)=>{
                const r = e.clear();
                r.onsuccess = ()=>t(), r.onerror = ()=>n(r.error);
            }));
    }
    getPrefixedKey(e) {
        throw $cf61b77dbdb95489$var$Tn.debug("getPrefixedKey", e), new Error("Method not implemented.");
    }
    subscribeToStorageChanged(e) {
        throw $cf61b77dbdb95489$var$Tn.debug("subscribeToStorageEvent", e), new Error("Method not implemented.");
    }
    async fillStore(e, t, n = [], r = this.storeNames[0]) {
        if (!this.isSupported) return void $cf61b77dbdb95489$var$Tn.error("fillStore", "IndexedDB not supported.");
        const i = indexedDB.open(e);
        i.onerror = (e)=>{
            throw new Error(`Failed to open target database: ${e.target.error}`);
        };
        const o = await new Promise((e, t)=>{
            i.onsuccess = (t)=>e(t.target.result), i.onerror = (e)=>t(e.target.error);
        });
        await this.transaction("readonly", r, async (e)=>{
            const r = e.getAll(), i = e.getAllKeys();
            r.onsuccess = async ()=>{
                i.onsuccess = async ()=>{
                    const e = r.result, a = i.result;
                    if (!o.objectStoreNames.contains(t)) return void $cf61b77dbdb95489$var$Tn.error(`${t} not found. ${(new Error).stack}`);
                    const l = o.transaction(t, "readwrite"), s = l.objectStore(t);
                    a.filter((e)=>!n.includes(e.toString())).forEach((t, n)=>{
                        s.put(e[n], t);
                    }), l.onerror = (e)=>{
                        $cf61b77dbdb95489$var$Tn.error("Transaction error: ", e.target.error);
                    };
                };
            }, i.onerror = ()=>{
                $cf61b77dbdb95489$var$Tn.error("Failed to getAllKeys from source:", i.error);
            }, r.onerror = ()=>{
                $cf61b77dbdb95489$var$Tn.error("Failed to getAll from source:", r.error);
            };
        });
    }
}
var $cf61b77dbdb95489$var$Fn, $cf61b77dbdb95489$var$Vn = function(e, t) {
    return "".concat(e, "?type=tzip10&data=").concat(t);
};
function $cf61b77dbdb95489$var$An(e) {
    return e.map(function(e) {
        for(var t = [
            "Web",
            "web",
            "App",
            "app",
            "Mobile",
            "mobile"
        ], n = 0; n < t.length; n++)e.name.includes(t[n]) && (e.name = e.name.replace(t[n], ""));
        return e.name = e.name.trim(), e;
    });
}
function $cf61b77dbdb95489$var$jn(e, t) {
    var n, r;
    switch(t.type){
        case "web":
            r = $cf61b77dbdb95489$var$Fn.WEB;
            break;
        case "extension":
            r = $cf61b77dbdb95489$var$Fn.EXTENSION;
            break;
        case "ios":
            r = $cf61b77dbdb95489$var$Fn.IOS;
            break;
        default:
            r = $cf61b77dbdb95489$var$Fn.DESKTOP;
    }
    e.links[r] = "ios" === t.type && null !== (n = t.deepLink) && void 0 !== n ? n : t.link;
}
function $cf61b77dbdb95489$var$On(e, t) {
    var n, r = t.slice(0, 4), i = [], a = [], l = $cf61b77dbdb95489$var$o(e);
    try {
        var s = function() {
            var e = n.value, t = void 0;
            r.some(function(n, r) {
                var i = e.key.startsWith(n);
                return i && (t = r), i;
            }), void 0 !== t ? i[t] = e : a.push(e);
        };
        for(l.s(); !(n = l.n()).done;)s();
    } catch (e) {
        l.e(e);
    } finally{
        l.f();
    }
    return a.sort(function(e, t) {
        return e.name < t.name ? -1 : e.name > t.name ? 1 : 0;
    }), [].concat(i, a);
}
function $cf61b77dbdb95489$var$Qn(e) {
    for(var t = [], n = function() {
        var n = e[r];
        if (t.map(function(e) {
            return e.name;
        }).includes(n.name)) {
            var i = t.findIndex(function(e) {
                return e.name === n.name;
            });
            i < 0 && console.error("There should be a wallet"), t[i].descriptions.includes(n.description) || ($cf61b77dbdb95489$var$jn(t[i], n), t[i].descriptions.push(n.description)), t[i].types.push(n.type), t[i].deepLink = n.deepLink, t[i].firefoxId = n.key.includes("firefox") ? n.id : t[i].firefoxId;
        } else {
            var o = $cf61b77dbdb95489$var$s($cf61b77dbdb95489$var$s({}, n), {}, {
                descriptions: [
                    n.description
                ],
                links: [
                    "",
                    "",
                    "",
                    ""
                ],
                types: [
                    n.type
                ],
                firefoxId: n.key.includes("firefox") ? n.id : void 0
            });
            $cf61b77dbdb95489$var$jn(o, n), t.push(o);
        }
    }, r = 0; r < e.length; r++)n();
    return t;
}
!function(e) {
    e[e.WEB = 0] = "WEB", e[e.IOS = 1] = "IOS", e[e.DESKTOP = 2] = "DESKTOP", e[e.EXTENSION = 3] = "EXTENSION";
}($cf61b77dbdb95489$var$Fn || ($cf61b77dbdb95489$var$Fn = {}));
var $cf61b77dbdb95489$var$qn = {}, $cf61b77dbdb95489$var$Wn = function(e, t) {
    return $cf61b77dbdb95489$var$Wn = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(e, t) {
        e.__proto__ = t;
    } || function(e, t) {
        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }, $cf61b77dbdb95489$var$Wn(e, t);
};
function $cf61b77dbdb95489$var$Gn(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    function n() {
        this.constructor = e;
    }
    $cf61b77dbdb95489$var$Wn(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
}
var $cf61b77dbdb95489$var$Bn = function() {
    return $cf61b77dbdb95489$var$Bn = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e;
    }, $cf61b77dbdb95489$var$Bn.apply(this, arguments);
};
function $cf61b77dbdb95489$var$Kn(e, t) {
    var n = {};
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;
        for(r = Object.getOwnPropertySymbols(e); i < r.length; i++)t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
    }
    return n;
}
function $cf61b77dbdb95489$var$Yn(e, t, n, r) {
    var i, o = arguments.length, a = o < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);
    else for(var l = e.length - 1; l >= 0; l--)(i = e[l]) && (a = (o < 3 ? i(a) : o > 3 ? i(t, n, a) : i(t, n)) || a);
    return o > 3 && a && Object.defineProperty(t, n, a), a;
}
function $cf61b77dbdb95489$var$Zn(e, t) {
    return function(n, r) {
        t(n, r, e);
    };
}
function $cf61b77dbdb95489$var$Xn(e, t, n, r, i, o) {
    function a(e) {
        if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
        return e;
    }
    for(var l, s = r.kind, u = "getter" === s ? "get" : "setter" === s ? "set" : "value", c = !t && e ? r.static ? e : e.prototype : null, d = t || (c ? Object.getOwnPropertyDescriptor(c, r.name) : {}), f = !1, h = n.length - 1; h >= 0; h--){
        var p = {};
        for(var m in r)p[m] = "access" === m ? {} : r[m];
        for(var m in r.access)p.access[m] = r.access[m];
        p.addInitializer = function(e) {
            if (f) throw new TypeError("Cannot add initializers after decoration has completed");
            o.push(a(e || null));
        };
        var g = (0, n[h])("accessor" === s ? {
            get: d.get,
            set: d.set
        } : d[u], p);
        if ("accessor" === s) {
            if (void 0 === g) continue;
            if (null === g || "object" != typeof g) throw new TypeError("Object expected");
            (l = a(g.get)) && (d.get = l), (l = a(g.set)) && (d.set = l), (l = a(g.init)) && i.unshift(l);
        } else (l = a(g)) && ("field" === s ? i.unshift(l) : d[u] = l);
    }
    c && Object.defineProperty(c, r.name, d), f = !0;
}
function $cf61b77dbdb95489$var$Pn(e, t, n) {
    for(var r = arguments.length > 2, i = 0; i < t.length; i++)n = r ? t[i].call(e, n) : t[i].call(e);
    return r ? n : void 0;
}
function $cf61b77dbdb95489$var$Jn(e) {
    return "symbol" == typeof e ? e : "".concat(e);
}
function $cf61b77dbdb95489$var$Hn(e, t, n) {
    return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: n ? "".concat(n, " ", t) : t
    });
}
function $cf61b77dbdb95489$var$_n(e, t) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
}
function $cf61b77dbdb95489$var$$n(e, t, n, r) {
    return new (n || (n = Promise))(function(i, o) {
        function a(e) {
            try {
                s(r.next(e));
            } catch (e) {
                o(e);
            }
        }
        function l(e) {
            try {
                s(r.throw(e));
            } catch (e) {
                o(e);
            }
        }
        function s(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, l);
        }
        s((r = r.apply(e, t || [])).next());
    });
}
function $cf61b77dbdb95489$var$er(e, t) {
    var n, r, i, o = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = l(0), a.throw = l(1), a.return = l(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function l(l) {
        return function(s) {
            return function(l) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, l[0] && (o = 0)), o;)try {
                    if (n = 1, r && (i = 2 & l[0] ? r.return : l[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, l[1])).done) return i;
                    switch(r = 0, i && (l = [
                        2 & l[0],
                        i.value
                    ]), l[0]){
                        case 0:
                        case 1:
                            i = l;
                            break;
                        case 4:
                            return o.label++, {
                                value: l[1],
                                done: !1
                            };
                        case 5:
                            o.label++, r = l[1], l = [
                                0
                            ];
                            continue;
                        case 7:
                            l = o.ops.pop(), o.trys.pop();
                            continue;
                        default:
                            if (!(i = o.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== l[0] && 2 !== l[0])) {
                                o = 0;
                                continue;
                            }
                            if (3 === l[0] && (!i || l[1] > i[0] && l[1] < i[3])) {
                                o.label = l[1];
                                break;
                            }
                            if (6 === l[0] && o.label < i[1]) {
                                o.label = i[1], i = l;
                                break;
                            }
                            if (i && o.label < i[2]) {
                                o.label = i[2], o.ops.push(l);
                                break;
                            }
                            i[2] && o.ops.pop(), o.trys.pop();
                            continue;
                    }
                    l = t.call(e, o);
                } catch (e) {
                    l = [
                        6,
                        e
                    ], r = 0;
                } finally{
                    n = i = 0;
                }
                if (5 & l[0]) throw l[1];
                return {
                    value: l[0] ? l[1] : void 0,
                    done: !0
                };
            }([
                l,
                s
            ]);
        };
    }
}
var $cf61b77dbdb95489$var$tr = Object.create ? function(e, t, n, r) {
    void 0 === r && (r = n);
    var i = Object.getOwnPropertyDescriptor(t, n);
    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
        enumerable: !0,
        get: function() {
            return t[n];
        }
    }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
    void 0 === r && (r = n), e[r] = t[n];
};
function $cf61b77dbdb95489$var$nr(e, t) {
    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || $cf61b77dbdb95489$var$tr(t, e, n);
}
function $cf61b77dbdb95489$var$rr(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $cf61b77dbdb95489$var$ir(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}
function $cf61b77dbdb95489$var$or() {
    for(var e = [], t = 0; t < arguments.length; t++)e = e.concat($cf61b77dbdb95489$var$ir(arguments[t]));
    return e;
}
function $cf61b77dbdb95489$var$ar() {
    for(var e = 0, t = 0, n = arguments.length; t < n; t++)e += arguments[t].length;
    var r = Array(e), i = 0;
    for(t = 0; t < n; t++)for(var o = arguments[t], a = 0, l = o.length; a < l; a++, i++)r[i] = o[a];
    return r;
}
function $cf61b77dbdb95489$var$lr(e, t, n) {
    if (n || 2 === arguments.length) for(var r, i = 0, o = t.length; i < o; i++)!r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
    return e.concat(r || Array.prototype.slice.call(t));
}
function $cf61b77dbdb95489$var$sr(e) {
    return this instanceof $cf61b77dbdb95489$var$sr ? (this.v = e, this) : new $cf61b77dbdb95489$var$sr(e);
}
function $cf61b77dbdb95489$var$ur(e, t, n) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var r, i = n.apply(e, t || []), o = [];
    return r = Object.create(("function" == typeof AsyncIterator ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", function(e) {
        return function(t) {
            return Promise.resolve(t).then(e, u);
        };
    }), r[Symbol.asyncIterator] = function() {
        return this;
    }, r;
    function a(e, t) {
        i[e] && (r[e] = function(t) {
            return new Promise(function(n, r) {
                o.push([
                    e,
                    t,
                    n,
                    r
                ]) > 1 || l(e, t);
            });
        }, t && (r[e] = t(r[e])));
    }
    function l(e, t) {
        try {
            (n = i[e](t)).value instanceof $cf61b77dbdb95489$var$sr ? Promise.resolve(n.value.v).then(s, u) : c(o[0][2], n);
        } catch (e) {
            c(o[0][3], e);
        }
        var n;
    }
    function s(e) {
        l("next", e);
    }
    function u(e) {
        l("throw", e);
    }
    function c(e, t) {
        e(t), o.shift(), o.length && l(o[0][0], o[0][1]);
    }
}
function $cf61b77dbdb95489$var$cr(e) {
    var t, n;
    return t = {}, r("next"), r("throw", function(e) {
        throw e;
    }), r("return"), t[Symbol.iterator] = function() {
        return this;
    }, t;
    function r(r, i) {
        t[r] = e[r] ? function(t) {
            return (n = !n) ? {
                value: $cf61b77dbdb95489$var$sr(e[r](t)),
                done: !1
            } : i ? i(t) : t;
        } : i;
    }
}
function $cf61b77dbdb95489$var$dr(e) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var t, n = e[Symbol.asyncIterator];
    return n ? n.call(e) : (e = $cf61b77dbdb95489$var$rr(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function() {
        return this;
    }, t);
    function r(n) {
        t[n] = e[n] && function(t) {
            return new Promise(function(r, i) {
                (function(e, t, n, r) {
                    Promise.resolve(r).then(function(t) {
                        e({
                            value: t,
                            done: n
                        });
                    }, t);
                })(r, i, (t = e[n](t)).done, t.value);
            });
        };
    }
}
function $cf61b77dbdb95489$var$fr(e, t) {
    return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
    }) : e.raw = t, e;
}
var $cf61b77dbdb95489$var$hr = Object.create ? function(e, t) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
    });
} : function(e, t) {
    e.default = t;
}, $cf61b77dbdb95489$var$pr = function(e) {
    return $cf61b77dbdb95489$var$pr = Object.getOwnPropertyNames || function(e) {
        var t = [];
        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[t.length] = n);
        return t;
    }, $cf61b77dbdb95489$var$pr(e);
};
function $cf61b77dbdb95489$var$mr(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for(var n = $cf61b77dbdb95489$var$pr(e), r = 0; r < n.length; r++)"default" !== n[r] && $cf61b77dbdb95489$var$tr(t, e, n[r]);
    return $cf61b77dbdb95489$var$hr(t, e), t;
}
function $cf61b77dbdb95489$var$gr(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $cf61b77dbdb95489$var$br(e, t, n, r) {
    if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
}
function $cf61b77dbdb95489$var$yr(e, t, n, r, i) {
    if ("m" === r) throw new TypeError("Private method is not writable");
    if ("a" === r && !i) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === r ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
}
function $cf61b77dbdb95489$var$vr(e, t) {
    if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
    return "function" == typeof e ? t === e : e.has(t);
}
function $cf61b77dbdb95489$var$Ir(e, t, n) {
    if (null != t) {
        if ("object" != typeof t && "function" != typeof t) throw new TypeError("Object expected.");
        var r, i;
        if (n) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            r = t[Symbol.asyncDispose];
        }
        if (void 0 === r) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            r = t[Symbol.dispose], n && (i = r);
        }
        if ("function" != typeof r) throw new TypeError("Object not disposable.");
        i && (r = function() {
            try {
                i.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        }), e.stack.push({
            value: t,
            dispose: r,
            async: n
        });
    } else n && e.stack.push({
        async: !0
    });
    return t;
}
var $cf61b77dbdb95489$var$Mr = "function" == typeof SuppressedError ? SuppressedError : function(e, t, n) {
    var r = new Error(n);
    return r.name = "SuppressedError", r.error = e, r.suppressed = t, r;
};
function $cf61b77dbdb95489$var$Er(e) {
    function t(t) {
        e.error = e.hasError ? new $cf61b77dbdb95489$var$Mr(t, e.error, "An error was suppressed during disposal.") : t, e.hasError = !0;
    }
    var n, r = 0;
    return function i() {
        for(; n = e.stack.pop();)try {
            if (!n.async && 1 === r) return r = 0, e.stack.push(n), Promise.resolve().then(i);
            if (n.dispose) {
                var o = n.dispose.call(n.value);
                if (n.async) return r |= 2, Promise.resolve(o).then(i, function(e) {
                    return t(e), i();
                });
            } else r |= 1;
        } catch (e) {
            t(e);
        }
        if (1 === r) return e.hasError ? Promise.reject(e.error) : Promise.resolve();
        if (e.hasError) throw e.error;
    }();
}
function $cf61b77dbdb95489$var$xr(e, t) {
    return "string" == typeof e && /^\.\.?\//.test(e) ? e.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(e, n, r, i, o) {
        return n ? t ? ".jsx" : ".js" : !r || i && o ? r + i + "." + o.toLowerCase() + "js" : e;
    }) : e;
}
var $cf61b77dbdb95489$var$Sr, $cf61b77dbdb95489$var$wr = {
    __extends: $cf61b77dbdb95489$var$Gn,
    __assign: $cf61b77dbdb95489$var$Bn,
    __rest: $cf61b77dbdb95489$var$Kn,
    __decorate: $cf61b77dbdb95489$var$Yn,
    __param: $cf61b77dbdb95489$var$Zn,
    __esDecorate: $cf61b77dbdb95489$var$Xn,
    __runInitializers: $cf61b77dbdb95489$var$Pn,
    __propKey: $cf61b77dbdb95489$var$Jn,
    __setFunctionName: $cf61b77dbdb95489$var$Hn,
    __metadata: $cf61b77dbdb95489$var$_n,
    __awaiter: $cf61b77dbdb95489$var$$n,
    __generator: $cf61b77dbdb95489$var$er,
    __createBinding: $cf61b77dbdb95489$var$tr,
    __exportStar: $cf61b77dbdb95489$var$nr,
    __values: $cf61b77dbdb95489$var$rr,
    __read: $cf61b77dbdb95489$var$ir,
    __spread: $cf61b77dbdb95489$var$or,
    __spreadArrays: $cf61b77dbdb95489$var$ar,
    __spreadArray: $cf61b77dbdb95489$var$lr,
    __await: $cf61b77dbdb95489$var$sr,
    __asyncGenerator: $cf61b77dbdb95489$var$ur,
    __asyncDelegator: $cf61b77dbdb95489$var$cr,
    __asyncValues: $cf61b77dbdb95489$var$dr,
    __makeTemplateObject: $cf61b77dbdb95489$var$fr,
    __importStar: $cf61b77dbdb95489$var$mr,
    __importDefault: $cf61b77dbdb95489$var$gr,
    __classPrivateFieldGet: $cf61b77dbdb95489$var$br,
    __classPrivateFieldSet: $cf61b77dbdb95489$var$yr,
    __classPrivateFieldIn: $cf61b77dbdb95489$var$vr,
    __addDisposableResource: $cf61b77dbdb95489$var$Ir,
    __disposeResources: $cf61b77dbdb95489$var$Er,
    __rewriteRelativeImportExtension: $cf61b77dbdb95489$var$xr
}, $cf61b77dbdb95489$var$kr = $cf61b77dbdb95489$var$g(Object.freeze({
    __proto__: null,
    __addDisposableResource: $cf61b77dbdb95489$var$Ir,
    get __assign () {
        return $cf61b77dbdb95489$var$Bn;
    },
    __asyncDelegator: $cf61b77dbdb95489$var$cr,
    __asyncGenerator: $cf61b77dbdb95489$var$ur,
    __asyncValues: $cf61b77dbdb95489$var$dr,
    __await: $cf61b77dbdb95489$var$sr,
    __awaiter: $cf61b77dbdb95489$var$$n,
    __classPrivateFieldGet: $cf61b77dbdb95489$var$br,
    __classPrivateFieldIn: $cf61b77dbdb95489$var$vr,
    __classPrivateFieldSet: $cf61b77dbdb95489$var$yr,
    __createBinding: $cf61b77dbdb95489$var$tr,
    __decorate: $cf61b77dbdb95489$var$Yn,
    __disposeResources: $cf61b77dbdb95489$var$Er,
    __esDecorate: $cf61b77dbdb95489$var$Xn,
    __exportStar: $cf61b77dbdb95489$var$nr,
    __extends: $cf61b77dbdb95489$var$Gn,
    __generator: $cf61b77dbdb95489$var$er,
    __importDefault: $cf61b77dbdb95489$var$gr,
    __importStar: $cf61b77dbdb95489$var$mr,
    __makeTemplateObject: $cf61b77dbdb95489$var$fr,
    __metadata: $cf61b77dbdb95489$var$_n,
    __param: $cf61b77dbdb95489$var$Zn,
    __propKey: $cf61b77dbdb95489$var$Jn,
    __read: $cf61b77dbdb95489$var$ir,
    __rest: $cf61b77dbdb95489$var$Kn,
    __rewriteRelativeImportExtension: $cf61b77dbdb95489$var$xr,
    __runInitializers: $cf61b77dbdb95489$var$Pn,
    __setFunctionName: $cf61b77dbdb95489$var$Hn,
    __spread: $cf61b77dbdb95489$var$or,
    __spreadArray: $cf61b77dbdb95489$var$lr,
    __spreadArrays: $cf61b77dbdb95489$var$ar,
    __values: $cf61b77dbdb95489$var$rr,
    default: $cf61b77dbdb95489$var$wr
})), $cf61b77dbdb95489$var$Nr = {}, $cf61b77dbdb95489$var$Ur = {};
var $cf61b77dbdb95489$var$Rr, $cf61b77dbdb95489$var$Lr = {}, $cf61b77dbdb95489$var$Cr = {}, $cf61b77dbdb95489$var$zr = {};
var $cf61b77dbdb95489$var$Tr, $cf61b77dbdb95489$var$Dr, $cf61b77dbdb95489$var$Fr, $cf61b77dbdb95489$var$Vr, $cf61b77dbdb95489$var$Ar = {};
function $cf61b77dbdb95489$var$jr() {
    return $cf61b77dbdb95489$var$Dr || ($cf61b77dbdb95489$var$Dr = 1, function(e) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        const t = $cf61b77dbdb95489$var$kr;
        t.__exportStar(($cf61b77dbdb95489$var$Rr || ($cf61b77dbdb95489$var$Rr = 1, Object.defineProperty($cf61b77dbdb95489$var$zr, "__esModule", {
            value: !0
        }), $cf61b77dbdb95489$var$zr.ONE_THOUSAND = $cf61b77dbdb95489$var$zr.ONE_HUNDRED = void 0, $cf61b77dbdb95489$var$zr.ONE_HUNDRED = 100, $cf61b77dbdb95489$var$zr.ONE_THOUSAND = 1e3), $cf61b77dbdb95489$var$zr), e), t.__exportStar(function() {
            var e;
            return $cf61b77dbdb95489$var$Tr || ($cf61b77dbdb95489$var$Tr = 1, e = $cf61b77dbdb95489$var$Ar, Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.ONE_YEAR = e.FOUR_WEEKS = e.THREE_WEEKS = e.TWO_WEEKS = e.ONE_WEEK = e.THIRTY_DAYS = e.SEVEN_DAYS = e.FIVE_DAYS = e.THREE_DAYS = e.ONE_DAY = e.TWENTY_FOUR_HOURS = e.TWELVE_HOURS = e.SIX_HOURS = e.THREE_HOURS = e.ONE_HOUR = e.SIXTY_MINUTES = e.THIRTY_MINUTES = e.TEN_MINUTES = e.FIVE_MINUTES = e.ONE_MINUTE = e.SIXTY_SECONDS = e.THIRTY_SECONDS = e.TEN_SECONDS = e.FIVE_SECONDS = e.ONE_SECOND = void 0, e.ONE_SECOND = 1, e.FIVE_SECONDS = 5, e.TEN_SECONDS = 10, e.THIRTY_SECONDS = 30, e.SIXTY_SECONDS = 60, e.ONE_MINUTE = e.SIXTY_SECONDS, e.FIVE_MINUTES = 5 * e.ONE_MINUTE, e.TEN_MINUTES = 10 * e.ONE_MINUTE, e.THIRTY_MINUTES = 30 * e.ONE_MINUTE, e.SIXTY_MINUTES = 60 * e.ONE_MINUTE, e.ONE_HOUR = e.SIXTY_MINUTES, e.THREE_HOURS = 3 * e.ONE_HOUR, e.SIX_HOURS = 6 * e.ONE_HOUR, e.TWELVE_HOURS = 12 * e.ONE_HOUR, e.TWENTY_FOUR_HOURS = 24 * e.ONE_HOUR, e.ONE_DAY = e.TWENTY_FOUR_HOURS, e.THREE_DAYS = 3 * e.ONE_DAY, e.FIVE_DAYS = 5 * e.ONE_DAY, e.SEVEN_DAYS = 7 * e.ONE_DAY, e.THIRTY_DAYS = 30 * e.ONE_DAY, e.ONE_WEEK = e.SEVEN_DAYS, e.TWO_WEEKS = 2 * e.ONE_WEEK, e.THREE_WEEKS = 3 * e.ONE_WEEK, e.FOUR_WEEKS = 4 * e.ONE_WEEK, e.ONE_YEAR = 365 * e.ONE_DAY), $cf61b77dbdb95489$var$Ar;
        }(), e);
    }($cf61b77dbdb95489$var$Cr)), $cf61b77dbdb95489$var$Cr;
}
function $cf61b77dbdb95489$var$Or() {
    return $cf61b77dbdb95489$var$Vr || ($cf61b77dbdb95489$var$Vr = 1, function(e) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        const t = $cf61b77dbdb95489$var$kr;
        t.__exportStar(($cf61b77dbdb95489$var$Sr || ($cf61b77dbdb95489$var$Sr = 1, Object.defineProperty($cf61b77dbdb95489$var$Ur, "__esModule", {
            value: !0
        }), $cf61b77dbdb95489$var$Ur.delay = void 0, $cf61b77dbdb95489$var$Ur.delay = function(e) {
            return new Promise((t)=>{
                setTimeout(()=>{
                    t(!0);
                }, e);
            });
        }), $cf61b77dbdb95489$var$Ur), e), t.__exportStar(function() {
            if ($cf61b77dbdb95489$var$Fr) return $cf61b77dbdb95489$var$Lr;
            $cf61b77dbdb95489$var$Fr = 1, Object.defineProperty($cf61b77dbdb95489$var$Lr, "__esModule", {
                value: !0
            }), $cf61b77dbdb95489$var$Lr.fromMiliseconds = $cf61b77dbdb95489$var$Lr.toMiliseconds = void 0;
            const e = $cf61b77dbdb95489$var$jr();
            return $cf61b77dbdb95489$var$Lr.toMiliseconds = function(t) {
                return t * e.ONE_THOUSAND;
            }, $cf61b77dbdb95489$var$Lr.fromMiliseconds = function(t) {
                return Math.floor(t / e.ONE_THOUSAND);
            }, $cf61b77dbdb95489$var$Lr;
        }(), e);
    }($cf61b77dbdb95489$var$Nr)), $cf61b77dbdb95489$var$Nr;
}
var $cf61b77dbdb95489$var$Qr, $cf61b77dbdb95489$var$qr = {};
var $cf61b77dbdb95489$var$Wr, $cf61b77dbdb95489$var$Gr, $cf61b77dbdb95489$var$Br, $cf61b77dbdb95489$var$Kr = {}, $cf61b77dbdb95489$var$Yr = {};
function $cf61b77dbdb95489$var$Zr() {
    return $cf61b77dbdb95489$var$Gr || ($cf61b77dbdb95489$var$Gr = 1, function(e) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        $cf61b77dbdb95489$var$kr.__exportStar(($cf61b77dbdb95489$var$Wr || ($cf61b77dbdb95489$var$Wr = 1, Object.defineProperty($cf61b77dbdb95489$var$Yr, "__esModule", {
            value: !0
        }), $cf61b77dbdb95489$var$Yr.IWatch = void 0, $cf61b77dbdb95489$var$Yr.IWatch = class {
        }), $cf61b77dbdb95489$var$Yr), e);
    }($cf61b77dbdb95489$var$Kr)), $cf61b77dbdb95489$var$Kr;
}
$cf61b77dbdb95489$var$Br || ($cf61b77dbdb95489$var$Br = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    });
    const t = $cf61b77dbdb95489$var$kr;
    t.__exportStar($cf61b77dbdb95489$var$Or(), e), t.__exportStar(function() {
        if ($cf61b77dbdb95489$var$Qr) return $cf61b77dbdb95489$var$qr;
        $cf61b77dbdb95489$var$Qr = 1, Object.defineProperty($cf61b77dbdb95489$var$qr, "__esModule", {
            value: !0
        }), $cf61b77dbdb95489$var$qr.Watch = void 0;
        class e {
            constructor(){
                this.timestamps = new Map;
            }
            start(e) {
                if (this.timestamps.has(e)) throw new Error(`Watch already started for label: ${e}`);
                this.timestamps.set(e, {
                    started: Date.now()
                });
            }
            stop(e) {
                const t = this.get(e);
                if (void 0 !== t.elapsed) throw new Error(`Watch already stopped for label: ${e}`);
                const n = Date.now() - t.started;
                this.timestamps.set(e, {
                    started: t.started,
                    elapsed: n
                });
            }
            get(e) {
                const t = this.timestamps.get(e);
                if (void 0 === t) throw new Error(`No timestamp found for label: ${e}`);
                return t;
            }
            elapsed(e) {
                const t = this.get(e);
                return t.elapsed || Date.now() - t.started;
            }
        }
        return $cf61b77dbdb95489$var$qr.Watch = e, $cf61b77dbdb95489$var$qr.default = e, $cf61b77dbdb95489$var$qr;
    }(), e), t.__exportStar($cf61b77dbdb95489$var$Zr(), e), t.__exportStar($cf61b77dbdb95489$var$jr(), e);
}($cf61b77dbdb95489$var$qn));
var $cf61b77dbdb95489$var$Xr, $cf61b77dbdb95489$var$Pr = {};
function $cf61b77dbdb95489$var$Jr() {
    if ($cf61b77dbdb95489$var$Xr) return $cf61b77dbdb95489$var$Pr;
    function e(e) {
        let t;
        return "undefined" != typeof window && void 0 !== window[e] && (t = window[e]), t;
    }
    function t(t) {
        const n = e(t);
        if (!n) throw new Error(`${t} is not defined in Window`);
        return n;
    }
    return $cf61b77dbdb95489$var$Xr = 1, Object.defineProperty($cf61b77dbdb95489$var$Pr, "__esModule", {
        value: !0
    }), $cf61b77dbdb95489$var$Pr.getLocalStorage = $cf61b77dbdb95489$var$Pr.getLocalStorageOrThrow = $cf61b77dbdb95489$var$Pr.getCrypto = $cf61b77dbdb95489$var$Pr.getCryptoOrThrow = $cf61b77dbdb95489$var$Pr.getLocation = $cf61b77dbdb95489$var$Pr.getLocationOrThrow = $cf61b77dbdb95489$var$Pr.getNavigator = $cf61b77dbdb95489$var$Pr.getNavigatorOrThrow = $cf61b77dbdb95489$var$Pr.getDocument = $cf61b77dbdb95489$var$Pr.getDocumentOrThrow = $cf61b77dbdb95489$var$Pr.getFromWindowOrThrow = $cf61b77dbdb95489$var$Pr.getFromWindow = void 0, $cf61b77dbdb95489$var$Pr.getFromWindow = e, $cf61b77dbdb95489$var$Pr.getFromWindowOrThrow = t, $cf61b77dbdb95489$var$Pr.getDocumentOrThrow = function() {
        return t("document");
    }, $cf61b77dbdb95489$var$Pr.getDocument = function() {
        return e("document");
    }, $cf61b77dbdb95489$var$Pr.getNavigatorOrThrow = function() {
        return t("navigator");
    }, $cf61b77dbdb95489$var$Pr.getNavigator = function() {
        return e("navigator");
    }, $cf61b77dbdb95489$var$Pr.getLocationOrThrow = function() {
        return t("location");
    }, $cf61b77dbdb95489$var$Pr.getLocation = function() {
        return e("location");
    }, $cf61b77dbdb95489$var$Pr.getCryptoOrThrow = function() {
        return t("crypto");
    }, $cf61b77dbdb95489$var$Pr.getCrypto = function() {
        return e("crypto");
    }, $cf61b77dbdb95489$var$Pr.getLocalStorageOrThrow = function() {
        return t("localStorage");
    }, $cf61b77dbdb95489$var$Pr.getLocalStorage = function() {
        return e("localStorage");
    }, $cf61b77dbdb95489$var$Pr;
}
$cf61b77dbdb95489$var$Jr();
var $cf61b77dbdb95489$var$Hr, $cf61b77dbdb95489$var$_r = {};
!function() {
    if ($cf61b77dbdb95489$var$Hr) return $cf61b77dbdb95489$var$_r;
    $cf61b77dbdb95489$var$Hr = 1, Object.defineProperty($cf61b77dbdb95489$var$_r, "__esModule", {
        value: !0
    }), $cf61b77dbdb95489$var$_r.getWindowMetadata = void 0;
    const e = $cf61b77dbdb95489$var$Jr();
    $cf61b77dbdb95489$var$_r.getWindowMetadata = function() {
        let t, n;
        try {
            t = e.getDocumentOrThrow(), n = e.getLocationOrThrow();
        } catch (e) {
            return null;
        }
        function r(...e) {
            const n = t.getElementsByTagName("meta");
            for(let t = 0; t < n.length; t++){
                const r = n[t], i = [
                    "itemprop",
                    "property",
                    "name"
                ].map((e)=>r.getAttribute(e)).filter((t)=>!!t && e.includes(t));
                if (i.length && i) {
                    const e = r.getAttribute("content");
                    if (e) return e;
                }
            }
            return "";
        }
        const i = function() {
            let e = r("name", "og:site_name", "og:title", "twitter:title");
            return e || (e = t.title), e;
        }();
        return {
            description: r("description", "og:description", "twitter:description", "keywords"),
            url: n.origin,
            icons: function() {
                const e = t.getElementsByTagName("link"), r = [];
                for(let t = 0; t < e.length; t++){
                    const i = e[t], o = i.getAttribute("rel");
                    if (o && o.toLowerCase().indexOf("icon") > -1) {
                        const e = i.getAttribute("href");
                        if (e) {
                            if (-1 === e.toLowerCase().indexOf("https:") && -1 === e.toLowerCase().indexOf("http:") && 0 !== e.indexOf("//")) {
                                let t = n.protocol + "//" + n.host;
                                if (0 === e.indexOf("/")) t += e;
                                else {
                                    const r = n.pathname.split("/");
                                    r.pop();
                                    t += r.join("/") + "/" + e;
                                }
                                r.push(t);
                            } else if (0 === e.indexOf("//")) {
                                const t = n.protocol + e;
                                r.push(t);
                            } else r.push(e);
                        }
                    }
                }
                return r;
            }(),
            name: i
        };
    };
}();
var $cf61b77dbdb95489$var$$r, $cf61b77dbdb95489$var$ei, $cf61b77dbdb95489$var$ti = {}, $cf61b77dbdb95489$var$ni = {};
function $cf61b77dbdb95489$var$ri() {
    if ($cf61b77dbdb95489$var$ei) return $cf61b77dbdb95489$var$$r;
    function e(e, t) {
        if (!e) throw new Error(t || "Assertion failed");
    }
    return $cf61b77dbdb95489$var$ei = 1, $cf61b77dbdb95489$var$$r = e, e.equal = function(e, t, n) {
        if (e != t) throw new Error(n || "Assertion failed: " + e + " != " + t);
    }, $cf61b77dbdb95489$var$$r;
}
var $cf61b77dbdb95489$var$ii, $cf61b77dbdb95489$var$oi, $cf61b77dbdb95489$var$ai, $cf61b77dbdb95489$var$li = {
    exports: {}
}, $cf61b77dbdb95489$var$si = {
    exports: {}
};

function $cf61b77dbdb95489$var$ui() {
    if ($cf61b77dbdb95489$var$oi) return $cf61b77dbdb95489$var$li.exports;
    $cf61b77dbdb95489$var$oi = 1;
    try {
        var e = (parcelRequire("N7Lcz"));
        if ("function" != typeof e.inherits) throw "";
        $cf61b77dbdb95489$var$li.exports = e.inherits;
    } catch (e) {
        $cf61b77dbdb95489$var$li.exports = ($cf61b77dbdb95489$var$ii || ($cf61b77dbdb95489$var$ii = 1, "function" == typeof Object.create ? $cf61b77dbdb95489$var$si.exports = function(e, t) {
            t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }));
        } : $cf61b77dbdb95489$var$si.exports = function(e, t) {
            if (t) {
                e.super_ = t;
                var n = function() {};
                n.prototype = t.prototype, e.prototype = new n, e.prototype.constructor = e;
            }
        }), $cf61b77dbdb95489$var$si.exports);
    }
    return $cf61b77dbdb95489$var$li.exports;
}
function $cf61b77dbdb95489$var$ci() {
    if ($cf61b77dbdb95489$var$ai) return $cf61b77dbdb95489$var$ni;
    $cf61b77dbdb95489$var$ai = 1;
    var e = $cf61b77dbdb95489$var$ri(), t = $cf61b77dbdb95489$var$ui();
    function n(e, t) {
        return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
    }
    function r(e) {
        return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
    }
    function i(e) {
        return 1 === e.length ? "0" + e : e;
    }
    function o(e) {
        return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
    }
    return $cf61b77dbdb95489$var$ni.inherits = t, $cf61b77dbdb95489$var$ni.toArray = function(e, t) {
        if (Array.isArray(e)) return e.slice();
        if (!e) return [];
        var r = [];
        if ("string" == typeof e) {
            if (t) {
                if ("hex" === t) for((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), o = 0; o < e.length; o += 2)r.push(parseInt(e[o] + e[o + 1], 16));
            } else for(var i = 0, o = 0; o < e.length; o++){
                var a = e.charCodeAt(o);
                a < 128 ? r[i++] = a : a < 2048 ? (r[i++] = a >> 6 | 192, r[i++] = 63 & a | 128) : n(e, o) ? (a = 65536 + ((1023 & a) << 10) + (1023 & e.charCodeAt(++o)), r[i++] = a >> 18 | 240, r[i++] = a >> 12 & 63 | 128, r[i++] = a >> 6 & 63 | 128, r[i++] = 63 & a | 128) : (r[i++] = a >> 12 | 224, r[i++] = a >> 6 & 63 | 128, r[i++] = 63 & a | 128);
            }
        } else for(o = 0; o < e.length; o++)r[o] = 0 | e[o];
        return r;
    }, $cf61b77dbdb95489$var$ni.toHex = function(e) {
        for(var t = "", n = 0; n < e.length; n++)t += i(e[n].toString(16));
        return t;
    }, $cf61b77dbdb95489$var$ni.htonl = r, $cf61b77dbdb95489$var$ni.toHex32 = function(e, t) {
        for(var n = "", i = 0; i < e.length; i++){
            var a = e[i];
            "little" === t && (a = r(a)), n += o(a.toString(16));
        }
        return n;
    }, $cf61b77dbdb95489$var$ni.zero2 = i, $cf61b77dbdb95489$var$ni.zero8 = o, $cf61b77dbdb95489$var$ni.join32 = function(t, n, r, i) {
        var o = r - n;
        e(o % 4 == 0);
        for(var a = new Array(o / 4), l = 0, s = n; l < a.length; l++, s += 4){
            var u;
            u = "big" === i ? t[s] << 24 | t[s + 1] << 16 | t[s + 2] << 8 | t[s + 3] : t[s + 3] << 24 | t[s + 2] << 16 | t[s + 1] << 8 | t[s], a[l] = u >>> 0;
        }
        return a;
    }, $cf61b77dbdb95489$var$ni.split32 = function(e, t) {
        for(var n = new Array(4 * e.length), r = 0, i = 0; r < e.length; r++, i += 4){
            var o = e[r];
            "big" === t ? (n[i] = o >>> 24, n[i + 1] = o >>> 16 & 255, n[i + 2] = o >>> 8 & 255, n[i + 3] = 255 & o) : (n[i + 3] = o >>> 24, n[i + 2] = o >>> 16 & 255, n[i + 1] = o >>> 8 & 255, n[i] = 255 & o);
        }
        return n;
    }, $cf61b77dbdb95489$var$ni.rotr32 = function(e, t) {
        return e >>> t | e << 32 - t;
    }, $cf61b77dbdb95489$var$ni.rotl32 = function(e, t) {
        return e << t | e >>> 32 - t;
    }, $cf61b77dbdb95489$var$ni.sum32 = function(e, t) {
        return e + t >>> 0;
    }, $cf61b77dbdb95489$var$ni.sum32_3 = function(e, t, n) {
        return e + t + n >>> 0;
    }, $cf61b77dbdb95489$var$ni.sum32_4 = function(e, t, n, r) {
        return e + t + n + r >>> 0;
    }, $cf61b77dbdb95489$var$ni.sum32_5 = function(e, t, n, r, i) {
        return e + t + n + r + i >>> 0;
    }, $cf61b77dbdb95489$var$ni.sum64 = function(e, t, n, r) {
        var i = e[t], o = r + e[t + 1] >>> 0, a = (o < r ? 1 : 0) + n + i;
        e[t] = a >>> 0, e[t + 1] = o;
    }, $cf61b77dbdb95489$var$ni.sum64_hi = function(e, t, n, r) {
        return (t + r >>> 0 < t ? 1 : 0) + e + n >>> 0;
    }, $cf61b77dbdb95489$var$ni.sum64_lo = function(e, t, n, r) {
        return t + r >>> 0;
    }, $cf61b77dbdb95489$var$ni.sum64_4_hi = function(e, t, n, r, i, o, a, l) {
        var s = 0, u = t;
        return s += (u = u + r >>> 0) < t ? 1 : 0, s += (u = u + o >>> 0) < o ? 1 : 0, e + n + i + a + (s += (u = u + l >>> 0) < l ? 1 : 0) >>> 0;
    }, $cf61b77dbdb95489$var$ni.sum64_4_lo = function(e, t, n, r, i, o, a, l) {
        return t + r + o + l >>> 0;
    }, $cf61b77dbdb95489$var$ni.sum64_5_hi = function(e, t, n, r, i, o, a, l, s, u) {
        var c = 0, d = t;
        return c += (d = d + r >>> 0) < t ? 1 : 0, c += (d = d + o >>> 0) < o ? 1 : 0, c += (d = d + l >>> 0) < l ? 1 : 0, e + n + i + a + s + (c += (d = d + u >>> 0) < u ? 1 : 0) >>> 0;
    }, $cf61b77dbdb95489$var$ni.sum64_5_lo = function(e, t, n, r, i, o, a, l, s, u) {
        return t + r + o + l + u >>> 0;
    }, $cf61b77dbdb95489$var$ni.rotr64_hi = function(e, t, n) {
        return (t << 32 - n | e >>> n) >>> 0;
    }, $cf61b77dbdb95489$var$ni.rotr64_lo = function(e, t, n) {
        return (e << 32 - n | t >>> n) >>> 0;
    }, $cf61b77dbdb95489$var$ni.shr64_hi = function(e, t, n) {
        return e >>> n;
    }, $cf61b77dbdb95489$var$ni.shr64_lo = function(e, t, n) {
        return (e << 32 - n | t >>> n) >>> 0;
    }, $cf61b77dbdb95489$var$ni;
}
var $cf61b77dbdb95489$var$di, $cf61b77dbdb95489$var$fi = {};
function $cf61b77dbdb95489$var$hi() {
    if ($cf61b77dbdb95489$var$di) return $cf61b77dbdb95489$var$fi;
    $cf61b77dbdb95489$var$di = 1;
    var e = $cf61b77dbdb95489$var$ci(), t = $cf61b77dbdb95489$var$ri();
    function n() {
        this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
    }
    return $cf61b77dbdb95489$var$fi.BlockHash = n, n.prototype.update = function(t, n) {
        if (t = e.toArray(t, n), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
            var r = (t = this.pending).length % this._delta8;
            this.pending = t.slice(t.length - r, t.length), 0 === this.pending.length && (this.pending = null), t = e.join32(t, 0, t.length - r, this.endian);
            for(var i = 0; i < t.length; i += this._delta32)this._update(t, i, i + this._delta32);
        }
        return this;
    }, n.prototype.digest = function(e) {
        return this.update(this._pad()), t(null === this.pending), this._digest(e);
    }, n.prototype._pad = function() {
        var e = this.pendingTotal, t = this._delta8, n = t - (e + this.padLength) % t, r = new Array(n + this.padLength);
        r[0] = 128;
        for(var i = 1; i < n; i++)r[i] = 0;
        if (e <<= 3, "big" === this.endian) {
            for(var o = 8; o < this.padLength; o++)r[i++] = 0;
            r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = e >>> 24 & 255, r[i++] = e >>> 16 & 255, r[i++] = e >>> 8 & 255, r[i++] = 255 & e;
        } else for(r[i++] = 255 & e, r[i++] = e >>> 8 & 255, r[i++] = e >>> 16 & 255, r[i++] = e >>> 24 & 255, r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = 0, o = 8; o < this.padLength; o++)r[i++] = 0;
        return r;
    }, $cf61b77dbdb95489$var$fi;
}
var $cf61b77dbdb95489$var$pi, $cf61b77dbdb95489$var$mi, $cf61b77dbdb95489$var$gi, $cf61b77dbdb95489$var$bi, $cf61b77dbdb95489$var$yi, $cf61b77dbdb95489$var$vi, $cf61b77dbdb95489$var$Ii, $cf61b77dbdb95489$var$Mi, $cf61b77dbdb95489$var$Ei, $cf61b77dbdb95489$var$xi, $cf61b77dbdb95489$var$Si, $cf61b77dbdb95489$var$wi, $cf61b77dbdb95489$var$ki = {}, $cf61b77dbdb95489$var$Ni = {};
function $cf61b77dbdb95489$var$Ui() {
    if ($cf61b77dbdb95489$var$pi) return $cf61b77dbdb95489$var$Ni;
    $cf61b77dbdb95489$var$pi = 1;
    var e = $cf61b77dbdb95489$var$ci().rotr32;
    function t(e, t, n) {
        return e & t ^ ~e & n;
    }
    function n(e, t, n) {
        return e & t ^ e & n ^ t & n;
    }
    function r(e, t, n) {
        return e ^ t ^ n;
    }
    return $cf61b77dbdb95489$var$Ni.ft_1 = function(e, i, o, a) {
        return 0 === e ? t(i, o, a) : 1 === e || 3 === e ? r(i, o, a) : 2 === e ? n(i, o, a) : void 0;
    }, $cf61b77dbdb95489$var$Ni.ch32 = t, $cf61b77dbdb95489$var$Ni.maj32 = n, $cf61b77dbdb95489$var$Ni.p32 = r, $cf61b77dbdb95489$var$Ni.s0_256 = function(t) {
        return e(t, 2) ^ e(t, 13) ^ e(t, 22);
    }, $cf61b77dbdb95489$var$Ni.s1_256 = function(t) {
        return e(t, 6) ^ e(t, 11) ^ e(t, 25);
    }, $cf61b77dbdb95489$var$Ni.g0_256 = function(t) {
        return e(t, 7) ^ e(t, 18) ^ t >>> 3;
    }, $cf61b77dbdb95489$var$Ni.g1_256 = function(t) {
        return e(t, 17) ^ e(t, 19) ^ t >>> 10;
    }, $cf61b77dbdb95489$var$Ni;
}
function $cf61b77dbdb95489$var$Ri() {
    if ($cf61b77dbdb95489$var$yi) return $cf61b77dbdb95489$var$bi;
    $cf61b77dbdb95489$var$yi = 1;
    var e = $cf61b77dbdb95489$var$ci(), t = $cf61b77dbdb95489$var$hi(), n = $cf61b77dbdb95489$var$Ui(), r = $cf61b77dbdb95489$var$ri(), i = e.sum32, o = e.sum32_4, a = e.sum32_5, l = n.ch32, s = n.maj32, u = n.s0_256, c = n.s1_256, d = n.g0_256, f = n.g1_256, h = t.BlockHash, p = [
        1116352408,
        1899447441,
        3049323471,
        3921009573,
        961987163,
        1508970993,
        2453635748,
        2870763221,
        3624381080,
        310598401,
        607225278,
        1426881987,
        1925078388,
        2162078206,
        2614888103,
        3248222580,
        3835390401,
        4022224774,
        264347078,
        604807628,
        770255983,
        1249150122,
        1555081692,
        1996064986,
        2554220882,
        2821834349,
        2952996808,
        3210313671,
        3336571891,
        3584528711,
        113926993,
        338241895,
        666307205,
        773529912,
        1294757372,
        1396182291,
        1695183700,
        1986661051,
        2177026350,
        2456956037,
        2730485921,
        2820302411,
        3259730800,
        3345764771,
        3516065817,
        3600352804,
        4094571909,
        275423344,
        430227734,
        506948616,
        659060556,
        883997877,
        958139571,
        1322822218,
        1537002063,
        1747873779,
        1955562222,
        2024104815,
        2227730452,
        2361852424,
        2428436474,
        2756734187,
        3204031479,
        3329325298
    ];
    function m() {
        if (!(this instanceof m)) return new m;
        h.call(this), this.h = [
            1779033703,
            3144134277,
            1013904242,
            2773480762,
            1359893119,
            2600822924,
            528734635,
            1541459225
        ], this.k = p, this.W = new Array(64);
    }
    return e.inherits(m, h), $cf61b77dbdb95489$var$bi = m, m.blockSize = 512, m.outSize = 256, m.hmacStrength = 192, m.padLength = 64, m.prototype._update = function(e, t) {
        for(var n = this.W, h = 0; h < 16; h++)n[h] = e[t + h];
        for(; h < n.length; h++)n[h] = o(f(n[h - 2]), n[h - 7], d(n[h - 15]), n[h - 16]);
        var p = this.h[0], m = this.h[1], g = this.h[2], b = this.h[3], y = this.h[4], v = this.h[5], I = this.h[6], M = this.h[7];
        for(r(this.k.length === n.length), h = 0; h < n.length; h++){
            var E = a(M, c(y), l(y, v, I), this.k[h], n[h]), x = i(u(p), s(p, m, g));
            M = I, I = v, v = y, y = i(b, E), b = g, g = m, m = p, p = i(E, x);
        }
        this.h[0] = i(this.h[0], p), this.h[1] = i(this.h[1], m), this.h[2] = i(this.h[2], g), this.h[3] = i(this.h[3], b), this.h[4] = i(this.h[4], y), this.h[5] = i(this.h[5], v), this.h[6] = i(this.h[6], I), this.h[7] = i(this.h[7], M);
    }, m.prototype._digest = function(t) {
        return "hex" === t ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
    }, $cf61b77dbdb95489$var$bi;
}
function $cf61b77dbdb95489$var$Li() {
    if ($cf61b77dbdb95489$var$Ei) return $cf61b77dbdb95489$var$Mi;
    $cf61b77dbdb95489$var$Ei = 1;
    var e = $cf61b77dbdb95489$var$ci(), t = $cf61b77dbdb95489$var$hi(), n = $cf61b77dbdb95489$var$ri(), r = e.rotr64_hi, i = e.rotr64_lo, o = e.shr64_hi, a = e.shr64_lo, l = e.sum64, s = e.sum64_hi, u = e.sum64_lo, c = e.sum64_4_hi, d = e.sum64_4_lo, f = e.sum64_5_hi, h = e.sum64_5_lo, p = t.BlockHash, m = [
        1116352408,
        3609767458,
        1899447441,
        602891725,
        3049323471,
        3964484399,
        3921009573,
        2173295548,
        961987163,
        4081628472,
        1508970993,
        3053834265,
        2453635748,
        2937671579,
        2870763221,
        3664609560,
        3624381080,
        2734883394,
        310598401,
        1164996542,
        607225278,
        1323610764,
        1426881987,
        3590304994,
        1925078388,
        4068182383,
        2162078206,
        991336113,
        2614888103,
        633803317,
        3248222580,
        3479774868,
        3835390401,
        2666613458,
        4022224774,
        944711139,
        264347078,
        2341262773,
        604807628,
        2007800933,
        770255983,
        1495990901,
        1249150122,
        1856431235,
        1555081692,
        3175218132,
        1996064986,
        2198950837,
        2554220882,
        3999719339,
        2821834349,
        766784016,
        2952996808,
        2566594879,
        3210313671,
        3203337956,
        3336571891,
        1034457026,
        3584528711,
        2466948901,
        113926993,
        3758326383,
        338241895,
        168717936,
        666307205,
        1188179964,
        773529912,
        1546045734,
        1294757372,
        1522805485,
        1396182291,
        2643833823,
        1695183700,
        2343527390,
        1986661051,
        1014477480,
        2177026350,
        1206759142,
        2456956037,
        344077627,
        2730485921,
        1290863460,
        2820302411,
        3158454273,
        3259730800,
        3505952657,
        3345764771,
        106217008,
        3516065817,
        3606008344,
        3600352804,
        1432725776,
        4094571909,
        1467031594,
        275423344,
        851169720,
        430227734,
        3100823752,
        506948616,
        1363258195,
        659060556,
        3750685593,
        883997877,
        3785050280,
        958139571,
        3318307427,
        1322822218,
        3812723403,
        1537002063,
        2003034995,
        1747873779,
        3602036899,
        1955562222,
        1575990012,
        2024104815,
        1125592928,
        2227730452,
        2716904306,
        2361852424,
        442776044,
        2428436474,
        593698344,
        2756734187,
        3733110249,
        3204031479,
        2999351573,
        3329325298,
        3815920427,
        3391569614,
        3928383900,
        3515267271,
        566280711,
        3940187606,
        3454069534,
        4118630271,
        4000239992,
        116418474,
        1914138554,
        174292421,
        2731055270,
        289380356,
        3203993006,
        460393269,
        320620315,
        685471733,
        587496836,
        852142971,
        1086792851,
        1017036298,
        365543100,
        1126000580,
        2618297676,
        1288033470,
        3409855158,
        1501505948,
        4234509866,
        1607167915,
        987167468,
        1816402316,
        1246189591
    ];
    function g() {
        if (!(this instanceof g)) return new g;
        p.call(this), this.h = [
            1779033703,
            4089235720,
            3144134277,
            2227873595,
            1013904242,
            4271175723,
            2773480762,
            1595750129,
            1359893119,
            2917565137,
            2600822924,
            725511199,
            528734635,
            4215389547,
            1541459225,
            327033209
        ], this.k = m, this.W = new Array(160);
    }
    function b(e, t, n, r, i) {
        var o = e & n ^ ~e & i;
        return o < 0 && (o += 4294967296), o;
    }
    function y(e, t, n, r, i, o) {
        var a = t & r ^ ~t & o;
        return a < 0 && (a += 4294967296), a;
    }
    function v(e, t, n, r, i) {
        var o = e & n ^ e & i ^ n & i;
        return o < 0 && (o += 4294967296), o;
    }
    function I(e, t, n, r, i, o) {
        var a = t & r ^ t & o ^ r & o;
        return a < 0 && (a += 4294967296), a;
    }
    function M(e, t) {
        var n = r(e, t, 28) ^ r(t, e, 2) ^ r(t, e, 7);
        return n < 0 && (n += 4294967296), n;
    }
    function E(e, t) {
        var n = i(e, t, 28) ^ i(t, e, 2) ^ i(t, e, 7);
        return n < 0 && (n += 4294967296), n;
    }
    function x(e, t) {
        var n = r(e, t, 14) ^ r(e, t, 18) ^ r(t, e, 9);
        return n < 0 && (n += 4294967296), n;
    }
    function S(e, t) {
        var n = i(e, t, 14) ^ i(e, t, 18) ^ i(t, e, 9);
        return n < 0 && (n += 4294967296), n;
    }
    function w(e, t) {
        var n = r(e, t, 1) ^ r(e, t, 8) ^ o(e, t, 7);
        return n < 0 && (n += 4294967296), n;
    }
    function k(e, t) {
        var n = i(e, t, 1) ^ i(e, t, 8) ^ a(e, t, 7);
        return n < 0 && (n += 4294967296), n;
    }
    function N(e, t) {
        var n = r(e, t, 19) ^ r(t, e, 29) ^ o(e, t, 6);
        return n < 0 && (n += 4294967296), n;
    }
    function U(e, t) {
        var n = i(e, t, 19) ^ i(t, e, 29) ^ a(e, t, 6);
        return n < 0 && (n += 4294967296), n;
    }
    return e.inherits(g, p), $cf61b77dbdb95489$var$Mi = g, g.blockSize = 1024, g.outSize = 512, g.hmacStrength = 192, g.padLength = 128, g.prototype._prepareBlock = function(e, t) {
        for(var n = this.W, r = 0; r < 32; r++)n[r] = e[t + r];
        for(; r < n.length; r += 2){
            var i = N(n[r - 4], n[r - 3]), o = U(n[r - 4], n[r - 3]), a = n[r - 14], l = n[r - 13], s = w(n[r - 30], n[r - 29]), u = k(n[r - 30], n[r - 29]), f = n[r - 32], h = n[r - 31];
            n[r] = c(i, o, a, l, s, u, f, h), n[r + 1] = d(i, o, a, l, s, u, f, h);
        }
    }, g.prototype._update = function(e, t) {
        this._prepareBlock(e, t);
        var r = this.W, i = this.h[0], o = this.h[1], a = this.h[2], c = this.h[3], d = this.h[4], p = this.h[5], m = this.h[6], g = this.h[7], w = this.h[8], k = this.h[9], N = this.h[10], U = this.h[11], R = this.h[12], L = this.h[13], C = this.h[14], z = this.h[15];
        n(this.k.length === r.length);
        for(var T = 0; T < r.length; T += 2){
            var D = C, F = z, V = x(w, k), A = S(w, k), j = b(w, k, N, U, R), O = y(w, k, N, U, R, L), Q = this.k[T], q = this.k[T + 1], W = r[T], G = r[T + 1], B = f(D, F, V, A, j, O, Q, q, W, G), K = h(D, F, V, A, j, O, Q, q, W, G);
            D = M(i, o), F = E(i, o), V = v(i, o, a, c, d), A = I(i, o, a, c, d, p);
            var Y = s(D, F, V, A), Z = u(D, F, V, A);
            C = R, z = L, R = N, L = U, N = w, U = k, w = s(m, g, B, K), k = u(g, g, B, K), m = d, g = p, d = a, p = c, a = i, c = o, i = s(B, K, Y, Z), o = u(B, K, Y, Z);
        }
        l(this.h, 0, i, o), l(this.h, 2, a, c), l(this.h, 4, d, p), l(this.h, 6, m, g), l(this.h, 8, w, k), l(this.h, 10, N, U), l(this.h, 12, R, L), l(this.h, 14, C, z);
    }, g.prototype._digest = function(t) {
        return "hex" === t ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
    }, $cf61b77dbdb95489$var$Mi;
}
function $cf61b77dbdb95489$var$Ci() {
    return $cf61b77dbdb95489$var$wi || ($cf61b77dbdb95489$var$wi = 1, $cf61b77dbdb95489$var$ki.sha1 = function() {
        if ($cf61b77dbdb95489$var$gi) return $cf61b77dbdb95489$var$mi;
        $cf61b77dbdb95489$var$gi = 1;
        var e = $cf61b77dbdb95489$var$ci(), t = $cf61b77dbdb95489$var$hi(), n = $cf61b77dbdb95489$var$Ui(), r = e.rotl32, i = e.sum32, o = e.sum32_5, a = n.ft_1, l = t.BlockHash, s = [
            1518500249,
            1859775393,
            2400959708,
            3395469782
        ];
        function u() {
            if (!(this instanceof u)) return new u;
            l.call(this), this.h = [
                1732584193,
                4023233417,
                2562383102,
                271733878,
                3285377520
            ], this.W = new Array(80);
        }
        return e.inherits(u, l), $cf61b77dbdb95489$var$mi = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 80, u.padLength = 64, u.prototype._update = function(e, t) {
            for(var n = this.W, l = 0; l < 16; l++)n[l] = e[t + l];
            for(; l < n.length; l++)n[l] = r(n[l - 3] ^ n[l - 8] ^ n[l - 14] ^ n[l - 16], 1);
            var u = this.h[0], c = this.h[1], d = this.h[2], f = this.h[3], h = this.h[4];
            for(l = 0; l < n.length; l++){
                var p = ~~(l / 20), m = o(r(u, 5), a(p, c, d, f), h, n[l], s[p]);
                h = f, f = d, d = r(c, 30), c = u, u = m;
            }
            this.h[0] = i(this.h[0], u), this.h[1] = i(this.h[1], c), this.h[2] = i(this.h[2], d), this.h[3] = i(this.h[3], f), this.h[4] = i(this.h[4], h);
        }, u.prototype._digest = function(t) {
            return "hex" === t ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
        }, $cf61b77dbdb95489$var$mi;
    }(), $cf61b77dbdb95489$var$ki.sha224 = function() {
        if ($cf61b77dbdb95489$var$Ii) return $cf61b77dbdb95489$var$vi;
        $cf61b77dbdb95489$var$Ii = 1;
        var e = $cf61b77dbdb95489$var$ci(), t = $cf61b77dbdb95489$var$Ri();
        function n() {
            if (!(this instanceof n)) return new n;
            t.call(this), this.h = [
                3238371032,
                914150663,
                812702999,
                4144912697,
                4290775857,
                1750603025,
                1694076839,
                3204075428
            ];
        }
        return e.inherits(n, t), $cf61b77dbdb95489$var$vi = n, n.blockSize = 512, n.outSize = 224, n.hmacStrength = 192, n.padLength = 64, n.prototype._digest = function(t) {
            return "hex" === t ? e.toHex32(this.h.slice(0, 7), "big") : e.split32(this.h.slice(0, 7), "big");
        }, $cf61b77dbdb95489$var$vi;
    }(), $cf61b77dbdb95489$var$ki.sha256 = $cf61b77dbdb95489$var$Ri(), $cf61b77dbdb95489$var$ki.sha384 = function() {
        if ($cf61b77dbdb95489$var$Si) return $cf61b77dbdb95489$var$xi;
        $cf61b77dbdb95489$var$Si = 1;
        var e = $cf61b77dbdb95489$var$ci(), t = $cf61b77dbdb95489$var$Li();
        function n() {
            if (!(this instanceof n)) return new n;
            t.call(this), this.h = [
                3418070365,
                3238371032,
                1654270250,
                914150663,
                2438529370,
                812702999,
                355462360,
                4144912697,
                1731405415,
                4290775857,
                2394180231,
                1750603025,
                3675008525,
                1694076839,
                1203062813,
                3204075428
            ];
        }
        return e.inherits(n, t), $cf61b77dbdb95489$var$xi = n, n.blockSize = 1024, n.outSize = 384, n.hmacStrength = 192, n.padLength = 128, n.prototype._digest = function(t) {
            return "hex" === t ? e.toHex32(this.h.slice(0, 12), "big") : e.split32(this.h.slice(0, 12), "big");
        }, $cf61b77dbdb95489$var$xi;
    }(), $cf61b77dbdb95489$var$ki.sha512 = $cf61b77dbdb95489$var$Li()), $cf61b77dbdb95489$var$ki;
}
var $cf61b77dbdb95489$var$zi, $cf61b77dbdb95489$var$Ti, $cf61b77dbdb95489$var$Di, $cf61b77dbdb95489$var$Fi, $cf61b77dbdb95489$var$Vi = {};
function $cf61b77dbdb95489$var$Ai() {
    return $cf61b77dbdb95489$var$Fi || ($cf61b77dbdb95489$var$Fi = 1, function(e) {
        var t = e;
        t.utils = $cf61b77dbdb95489$var$ci(), t.common = $cf61b77dbdb95489$var$hi(), t.sha = $cf61b77dbdb95489$var$Ci(), t.ripemd = function() {
            if ($cf61b77dbdb95489$var$zi) return $cf61b77dbdb95489$var$Vi;
            $cf61b77dbdb95489$var$zi = 1;
            var e = $cf61b77dbdb95489$var$ci(), t = $cf61b77dbdb95489$var$hi(), n = e.rotl32, r = e.sum32, i = e.sum32_3, o = e.sum32_4, a = t.BlockHash;
            function l() {
                if (!(this instanceof l)) return new l;
                a.call(this), this.h = [
                    1732584193,
                    4023233417,
                    2562383102,
                    271733878,
                    3285377520
                ], this.endian = "little";
            }
            function s(e, t, n, r) {
                return e <= 15 ? t ^ n ^ r : e <= 31 ? t & n | ~t & r : e <= 47 ? (t | ~n) ^ r : e <= 63 ? t & r | n & ~r : t ^ (n | ~r);
            }
            function u(e) {
                return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
            }
            function c(e) {
                return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
            }
            e.inherits(l, a), $cf61b77dbdb95489$var$Vi.ripemd160 = l, l.blockSize = 512, l.outSize = 160, l.hmacStrength = 192, l.padLength = 64, l.prototype._update = function(e, t) {
                for(var a = this.h[0], l = this.h[1], m = this.h[2], g = this.h[3], b = this.h[4], y = a, v = l, I = m, M = g, E = b, x = 0; x < 80; x++){
                    var S = r(n(o(a, s(x, l, m, g), e[d[x] + t], u(x)), h[x]), b);
                    a = b, b = g, g = n(m, 10), m = l, l = S, S = r(n(o(y, s(79 - x, v, I, M), e[f[x] + t], c(x)), p[x]), E), y = E, E = M, M = n(I, 10), I = v, v = S;
                }
                S = i(this.h[1], m, M), this.h[1] = i(this.h[2], g, E), this.h[2] = i(this.h[3], b, y), this.h[3] = i(this.h[4], a, v), this.h[4] = i(this.h[0], l, I), this.h[0] = S;
            }, l.prototype._digest = function(t) {
                return "hex" === t ? e.toHex32(this.h, "little") : e.split32(this.h, "little");
            };
            var d = [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                7,
                4,
                13,
                1,
                10,
                6,
                15,
                3,
                12,
                0,
                9,
                5,
                2,
                14,
                11,
                8,
                3,
                10,
                14,
                4,
                9,
                15,
                8,
                1,
                2,
                7,
                0,
                6,
                13,
                11,
                5,
                12,
                1,
                9,
                11,
                10,
                0,
                8,
                12,
                4,
                13,
                3,
                7,
                15,
                14,
                5,
                6,
                2,
                4,
                0,
                5,
                9,
                7,
                12,
                2,
                10,
                14,
                1,
                3,
                8,
                11,
                6,
                15,
                13
            ], f = [
                5,
                14,
                7,
                0,
                9,
                2,
                11,
                4,
                13,
                6,
                15,
                8,
                1,
                10,
                3,
                12,
                6,
                11,
                3,
                7,
                0,
                13,
                5,
                10,
                14,
                15,
                8,
                12,
                4,
                9,
                1,
                2,
                15,
                5,
                1,
                3,
                7,
                14,
                6,
                9,
                11,
                8,
                12,
                2,
                10,
                0,
                4,
                13,
                8,
                6,
                4,
                1,
                3,
                11,
                15,
                0,
                5,
                12,
                2,
                13,
                9,
                7,
                10,
                14,
                12,
                15,
                10,
                4,
                1,
                5,
                8,
                7,
                6,
                2,
                13,
                14,
                0,
                3,
                9,
                11
            ], h = [
                11,
                14,
                15,
                12,
                5,
                8,
                7,
                9,
                11,
                13,
                14,
                15,
                6,
                7,
                9,
                8,
                7,
                6,
                8,
                13,
                11,
                9,
                7,
                15,
                7,
                12,
                15,
                9,
                11,
                7,
                13,
                12,
                11,
                13,
                6,
                7,
                14,
                9,
                13,
                15,
                14,
                8,
                13,
                6,
                5,
                12,
                7,
                5,
                11,
                12,
                14,
                15,
                14,
                15,
                9,
                8,
                9,
                14,
                5,
                6,
                8,
                6,
                5,
                12,
                9,
                15,
                5,
                11,
                6,
                8,
                13,
                12,
                5,
                12,
                13,
                14,
                11,
                8,
                5,
                6
            ], p = [
                8,
                9,
                9,
                11,
                13,
                15,
                15,
                5,
                7,
                7,
                8,
                11,
                14,
                14,
                12,
                6,
                9,
                13,
                15,
                7,
                12,
                8,
                9,
                11,
                7,
                7,
                12,
                7,
                6,
                15,
                13,
                11,
                9,
                7,
                15,
                11,
                8,
                6,
                6,
                14,
                12,
                13,
                5,
                14,
                13,
                13,
                7,
                5,
                15,
                5,
                8,
                11,
                14,
                14,
                6,
                14,
                6,
                9,
                12,
                9,
                12,
                5,
                15,
                8,
                8,
                5,
                12,
                9,
                12,
                5,
                14,
                6,
                8,
                13,
                6,
                5,
                15,
                13,
                11,
                11
            ];
            return $cf61b77dbdb95489$var$Vi;
        }(), t.hmac = function() {
            if ($cf61b77dbdb95489$var$Di) return $cf61b77dbdb95489$var$Ti;
            $cf61b77dbdb95489$var$Di = 1;
            var e = $cf61b77dbdb95489$var$ci(), t = $cf61b77dbdb95489$var$ri();
            function n(t, r, i) {
                if (!(this instanceof n)) return new n(t, r, i);
                this.Hash = t, this.blockSize = t.blockSize / 8, this.outSize = t.outSize / 8, this.inner = null, this.outer = null, this._init(e.toArray(r, i));
            }
            return $cf61b77dbdb95489$var$Ti = n, n.prototype._init = function(e) {
                e.length > this.blockSize && (e = (new this.Hash).update(e).digest()), t(e.length <= this.blockSize);
                for(var n = e.length; n < this.blockSize; n++)e.push(0);
                for(n = 0; n < e.length; n++)e[n] ^= 54;
                for(this.inner = (new this.Hash).update(e), n = 0; n < e.length; n++)e[n] ^= 106;
                this.outer = (new this.Hash).update(e);
            }, n.prototype.update = function(e, t) {
                return this.inner.update(e, t), this;
            }, n.prototype.digest = function(e) {
                return this.outer.update(this.inner.digest()), this.outer.digest(e);
            }, $cf61b77dbdb95489$var$Ti;
        }(), t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
    }($cf61b77dbdb95489$var$ti)), $cf61b77dbdb95489$var$ti;
}
function $cf61b77dbdb95489$var$ji(e, ...t) {
    if (!function(e) {
        return e instanceof Uint8Array || ArrayBuffer.isView(e) && "Uint8Array" === e.constructor.name;
    }(e)) throw new Error("Uint8Array expected");
    if (t.length > 0 && !t.includes(e.length)) throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function $cf61b77dbdb95489$var$Oi(e, t = !0) {
    if (e.destroyed) throw new Error("Hash instance has been destroyed");
    if (t && e.finished) throw new Error("Hash#digest() has already been called");
}
const $cf61b77dbdb95489$var$Qi = "object" == typeof globalThis && "crypto" in globalThis ? globalThis.crypto : void 0, $cf61b77dbdb95489$var$qi = (e)=>new DataView(e.buffer, e.byteOffset, e.byteLength); /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
function $cf61b77dbdb95489$var$Wi(e) {
    return "string" == typeof e && (e = function(e) {
        if ("string" != typeof e) throw new Error("utf8ToBytes expected string, got " + typeof e);
        return new Uint8Array((new TextEncoder).encode(e));
    }(e)), $cf61b77dbdb95489$var$ji(e), e;
}
class $cf61b77dbdb95489$var$Gi {
    clone() {
        return this._cloneInto();
    }
}
function $cf61b77dbdb95489$var$Bi(e = 32) {
    if ($cf61b77dbdb95489$var$Qi && "function" == typeof $cf61b77dbdb95489$var$Qi.getRandomValues) return $cf61b77dbdb95489$var$Qi.getRandomValues(new Uint8Array(e));
    if ($cf61b77dbdb95489$var$Qi && "function" == typeof $cf61b77dbdb95489$var$Qi.randomBytes) return $cf61b77dbdb95489$var$Qi.randomBytes(e);
    throw new Error("crypto.getRandomValues must be defined");
}
class $cf61b77dbdb95489$var$Ki extends $cf61b77dbdb95489$var$Gi {
    constructor(e, t, n, r){
        super(), this.blockLen = e, this.outputLen = t, this.padOffset = n, this.isLE = r, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = $cf61b77dbdb95489$var$qi(this.buffer);
    }
    update(e) {
        $cf61b77dbdb95489$var$Oi(this);
        const { view: t, buffer: n, blockLen: r } = this, i = (e = $cf61b77dbdb95489$var$Wi(e)).length;
        for(let o = 0; o < i;){
            const a = Math.min(r - this.pos, i - o);
            if (a === r) {
                const t = $cf61b77dbdb95489$var$qi(e);
                for(; r <= i - o; o += r)this.process(t, o);
                continue;
            }
            n.set(e.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === r && (this.process(t, 0), this.pos = 0);
        }
        return this.length += e.length, this.roundClean(), this;
    }
    digestInto(e) {
        $cf61b77dbdb95489$var$Oi(this), function(e, t) {
            $cf61b77dbdb95489$var$ji(e);
            const n = t.outputLen;
            if (e.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
        }(e, this), this.finished = !0;
        const { buffer: t, view: n, blockLen: r, isLE: i } = this;
        let { pos: o } = this;
        t[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > r - o && (this.process(n, 0), o = 0);
        for(let e = o; e < r; e++)t[e] = 0;
        (function(e, t, n, r) {
            if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, n, r);
            const i = BigInt(32), o = BigInt(4294967295), a = Number(n >> i & o), l = Number(n & o), s = r ? 4 : 0, u = r ? 0 : 4;
            e.setUint32(t + s, a, r), e.setUint32(t + u, l, r);
        })(n, r - 8, BigInt(8 * this.length), i), this.process(n, 0);
        const a = $cf61b77dbdb95489$var$qi(e), l = this.outputLen;
        if (l % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const s = l / 4, u = this.get();
        if (s > u.length) throw new Error("_sha2: outputLen bigger than state");
        for(let e = 0; e < s; e++)a.setUint32(4 * e, u[e], i);
    }
    digest() {
        const { buffer: e, outputLen: t } = this;
        this.digestInto(e);
        const n = e.slice(0, t);
        return this.destroy(), n;
    }
    _cloneInto(e) {
        e || (e = new this.constructor), e.set(...this.get());
        const { blockLen: t, buffer: n, length: r, finished: i, destroyed: o, pos: a } = this;
        return e.length = r, e.pos = a, e.finished = i, e.destroyed = o, r % t && e.buffer.set(n), e;
    }
}
const $cf61b77dbdb95489$var$Yi = BigInt(2 ** 32 - 1), $cf61b77dbdb95489$var$Zi = BigInt(32);
function $cf61b77dbdb95489$var$Xi(e, t = !1) {
    return t ? {
        h: Number(e & $cf61b77dbdb95489$var$Yi),
        l: Number(e >> $cf61b77dbdb95489$var$Zi & $cf61b77dbdb95489$var$Yi)
    } : {
        h: 0 | Number(e >> $cf61b77dbdb95489$var$Zi & $cf61b77dbdb95489$var$Yi),
        l: 0 | Number(e & $cf61b77dbdb95489$var$Yi)
    };
}
const $cf61b77dbdb95489$var$Pi = {
    fromBig: $cf61b77dbdb95489$var$Xi,
    split: function(e, t = !1) {
        let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
        for(let i = 0; i < e.length; i++){
            const { h: o, l: a } = $cf61b77dbdb95489$var$Xi(e[i], t);
            [n[i], r[i]] = [
                o,
                a
            ];
        }
        return [
            n,
            r
        ];
    },
    toBig: (e, t)=>BigInt(e >>> 0) << $cf61b77dbdb95489$var$Zi | BigInt(t >>> 0),
    shrSH: (e, t, n)=>e >>> n,
    shrSL: (e, t, n)=>e << 32 - n | t >>> n,
    rotrSH: (e, t, n)=>e >>> n | t << 32 - n,
    rotrSL: (e, t, n)=>e << 32 - n | t >>> n,
    rotrBH: (e, t, n)=>e << 64 - n | t >>> n - 32,
    rotrBL: (e, t, n)=>e >>> n - 32 | t << 64 - n,
    rotr32H: (e, t)=>t,
    rotr32L: (e, t)=>e,
    rotlSH: (e, t, n)=>e << n | t >>> 32 - n,
    rotlSL: (e, t, n)=>t << n | e >>> 32 - n,
    rotlBH: (e, t, n)=>t << n - 32 | e >>> 64 - n,
    rotlBL: (e, t, n)=>e << n - 32 | t >>> 64 - n,
    add: function(e, t, n, r) {
        const i = (t >>> 0) + (r >>> 0);
        return {
            h: e + n + (i / 2 ** 32 | 0) | 0,
            l: 0 | i
        };
    },
    add3L: (e, t, n)=>(e >>> 0) + (t >>> 0) + (n >>> 0),
    add3H: (e, t, n, r)=>t + n + r + (e / 2 ** 32 | 0) | 0,
    add4L: (e, t, n, r)=>(e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0),
    add4H: (e, t, n, r, i)=>t + n + r + i + (e / 2 ** 32 | 0) | 0,
    add5H: (e, t, n, r, i, o)=>t + n + r + i + o + (e / 2 ** 32 | 0) | 0,
    add5L: (e, t, n, r, i)=>(e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0) + (i >>> 0)
}, [$cf61b77dbdb95489$var$Ji, $cf61b77dbdb95489$var$Hi] = $cf61b77dbdb95489$var$Pi.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
].map((e)=>BigInt(e))), $cf61b77dbdb95489$var$_i = new Uint32Array(80), $cf61b77dbdb95489$var$$i = new Uint32Array(80);
let $cf61b77dbdb95489$var$eo = class extends $cf61b77dbdb95489$var$Ki {
    constructor(){
        super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
    }
    get() {
        const { Ah: e, Al: t, Bh: n, Bl: r, Ch: i, Cl: o, Dh: a, Dl: l, Eh: s, El: u, Fh: c, Fl: d, Gh: f, Gl: h, Hh: p, Hl: m } = this;
        return [
            e,
            t,
            n,
            r,
            i,
            o,
            a,
            l,
            s,
            u,
            c,
            d,
            f,
            h,
            p,
            m
        ];
    }
    set(e, t, n, r, i, o, a, l, s, u, c, d, f, h, p, m) {
        this.Ah = 0 | e, this.Al = 0 | t, this.Bh = 0 | n, this.Bl = 0 | r, this.Ch = 0 | i, this.Cl = 0 | o, this.Dh = 0 | a, this.Dl = 0 | l, this.Eh = 0 | s, this.El = 0 | u, this.Fh = 0 | c, this.Fl = 0 | d, this.Gh = 0 | f, this.Gl = 0 | h, this.Hh = 0 | p, this.Hl = 0 | m;
    }
    process(e, t) {
        for(let n = 0; n < 16; n++, t += 4)$cf61b77dbdb95489$var$_i[n] = e.getUint32(t), $cf61b77dbdb95489$var$$i[n] = e.getUint32(t += 4);
        for(let e = 16; e < 80; e++){
            const t = 0 | $cf61b77dbdb95489$var$_i[e - 15], n = 0 | $cf61b77dbdb95489$var$$i[e - 15], r = $cf61b77dbdb95489$var$Pi.rotrSH(t, n, 1) ^ $cf61b77dbdb95489$var$Pi.rotrSH(t, n, 8) ^ $cf61b77dbdb95489$var$Pi.shrSH(t, n, 7), i = $cf61b77dbdb95489$var$Pi.rotrSL(t, n, 1) ^ $cf61b77dbdb95489$var$Pi.rotrSL(t, n, 8) ^ $cf61b77dbdb95489$var$Pi.shrSL(t, n, 7), o = 0 | $cf61b77dbdb95489$var$_i[e - 2], a = 0 | $cf61b77dbdb95489$var$$i[e - 2], l = $cf61b77dbdb95489$var$Pi.rotrSH(o, a, 19) ^ $cf61b77dbdb95489$var$Pi.rotrBH(o, a, 61) ^ $cf61b77dbdb95489$var$Pi.shrSH(o, a, 6), s = $cf61b77dbdb95489$var$Pi.rotrSL(o, a, 19) ^ $cf61b77dbdb95489$var$Pi.rotrBL(o, a, 61) ^ $cf61b77dbdb95489$var$Pi.shrSL(o, a, 6), u = $cf61b77dbdb95489$var$Pi.add4L(i, s, $cf61b77dbdb95489$var$$i[e - 7], $cf61b77dbdb95489$var$$i[e - 16]), c = $cf61b77dbdb95489$var$Pi.add4H(u, r, l, $cf61b77dbdb95489$var$_i[e - 7], $cf61b77dbdb95489$var$_i[e - 16]);
            $cf61b77dbdb95489$var$_i[e] = 0 | c, $cf61b77dbdb95489$var$$i[e] = 0 | u;
        }
        let { Ah: n, Al: r, Bh: i, Bl: o, Ch: a, Cl: l, Dh: s, Dl: u, Eh: c, El: d, Fh: f, Fl: h, Gh: p, Gl: m, Hh: g, Hl: b } = this;
        for(let e = 0; e < 80; e++){
            const t = $cf61b77dbdb95489$var$Pi.rotrSH(c, d, 14) ^ $cf61b77dbdb95489$var$Pi.rotrSH(c, d, 18) ^ $cf61b77dbdb95489$var$Pi.rotrBH(c, d, 41), y = $cf61b77dbdb95489$var$Pi.rotrSL(c, d, 14) ^ $cf61b77dbdb95489$var$Pi.rotrSL(c, d, 18) ^ $cf61b77dbdb95489$var$Pi.rotrBL(c, d, 41), v = c & f ^ ~c & p, I = d & h ^ ~d & m, M = $cf61b77dbdb95489$var$Pi.add5L(b, y, I, $cf61b77dbdb95489$var$Hi[e], $cf61b77dbdb95489$var$$i[e]), E = $cf61b77dbdb95489$var$Pi.add5H(M, g, t, v, $cf61b77dbdb95489$var$Ji[e], $cf61b77dbdb95489$var$_i[e]), x = 0 | M, S = $cf61b77dbdb95489$var$Pi.rotrSH(n, r, 28) ^ $cf61b77dbdb95489$var$Pi.rotrBH(n, r, 34) ^ $cf61b77dbdb95489$var$Pi.rotrBH(n, r, 39), w = $cf61b77dbdb95489$var$Pi.rotrSL(n, r, 28) ^ $cf61b77dbdb95489$var$Pi.rotrBL(n, r, 34) ^ $cf61b77dbdb95489$var$Pi.rotrBL(n, r, 39), k = n & i ^ n & a ^ i & a, N = r & o ^ r & l ^ o & l;
            g = 0 | p, b = 0 | m, p = 0 | f, m = 0 | h, f = 0 | c, h = 0 | d, ({ h: c, l: d } = $cf61b77dbdb95489$var$Pi.add(0 | s, 0 | u, 0 | E, 0 | x)), s = 0 | a, u = 0 | l, a = 0 | i, l = 0 | o, i = 0 | n, o = 0 | r;
            const U = $cf61b77dbdb95489$var$Pi.add3L(x, w, N);
            n = $cf61b77dbdb95489$var$Pi.add3H(U, E, S, k), r = 0 | U;
        }
        ({ h: n, l: r } = $cf61b77dbdb95489$var$Pi.add(0 | this.Ah, 0 | this.Al, 0 | n, 0 | r)), ({ h: i, l: o } = $cf61b77dbdb95489$var$Pi.add(0 | this.Bh, 0 | this.Bl, 0 | i, 0 | o)), ({ h: a, l: l } = $cf61b77dbdb95489$var$Pi.add(0 | this.Ch, 0 | this.Cl, 0 | a, 0 | l)), ({ h: s, l: u } = $cf61b77dbdb95489$var$Pi.add(0 | this.Dh, 0 | this.Dl, 0 | s, 0 | u)), ({ h: c, l: d } = $cf61b77dbdb95489$var$Pi.add(0 | this.Eh, 0 | this.El, 0 | c, 0 | d)), ({ h: f, l: h } = $cf61b77dbdb95489$var$Pi.add(0 | this.Fh, 0 | this.Fl, 0 | f, 0 | h)), ({ h: p, l: m } = $cf61b77dbdb95489$var$Pi.add(0 | this.Gh, 0 | this.Gl, 0 | p, 0 | m)), ({ h: g, l: b } = $cf61b77dbdb95489$var$Pi.add(0 | this.Hh, 0 | this.Hl, 0 | g, 0 | b)), this.set(n, r, i, o, a, l, s, u, c, d, f, h, p, m, g, b);
    }
    roundClean() {
        $cf61b77dbdb95489$var$_i.fill(0), $cf61b77dbdb95489$var$$i.fill(0);
    }
    destroy() {
        this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
};
const $cf61b77dbdb95489$var$to = function(e) {
    const t = (t)=>e().update($cf61b77dbdb95489$var$Wi(t)).digest(), n = e();
    return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = ()=>e(), t;
}(()=>new $cf61b77dbdb95489$var$eo), $cf61b77dbdb95489$var$no = BigInt(0), $cf61b77dbdb95489$var$ro = BigInt(1), $cf61b77dbdb95489$var$io = BigInt(2); /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
function $cf61b77dbdb95489$var$oo(e) {
    return e instanceof Uint8Array || ArrayBuffer.isView(e) && "Uint8Array" === e.constructor.name;
}
function $cf61b77dbdb95489$var$ao(e) {
    if (!$cf61b77dbdb95489$var$oo(e)) throw new Error("Uint8Array expected");
}
function $cf61b77dbdb95489$var$lo(e, t) {
    if ("boolean" != typeof t) throw new Error(e + " boolean expected, got " + t);
}
const $cf61b77dbdb95489$var$so = Array.from({
    length: 256
}, (e, t)=>t.toString(16).padStart(2, "0"));
function $cf61b77dbdb95489$var$uo(e) {
    $cf61b77dbdb95489$var$ao(e);
    let t = "";
    for(let n = 0; n < e.length; n++)t += $cf61b77dbdb95489$var$so[e[n]];
    return t;
}
function $cf61b77dbdb95489$var$co(e) {
    if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
    return "" === e ? $cf61b77dbdb95489$var$no : BigInt("0x" + e);
}
const $cf61b77dbdb95489$var$fo = 48, $cf61b77dbdb95489$var$ho = 57, $cf61b77dbdb95489$var$po = 65, $cf61b77dbdb95489$var$mo = 70, $cf61b77dbdb95489$var$go = 97, $cf61b77dbdb95489$var$bo = 102;
function $cf61b77dbdb95489$var$yo(e) {
    return e >= $cf61b77dbdb95489$var$fo && e <= $cf61b77dbdb95489$var$ho ? e - $cf61b77dbdb95489$var$fo : e >= $cf61b77dbdb95489$var$po && e <= $cf61b77dbdb95489$var$mo ? e - ($cf61b77dbdb95489$var$po - 10) : e >= $cf61b77dbdb95489$var$go && e <= $cf61b77dbdb95489$var$bo ? e - ($cf61b77dbdb95489$var$go - 10) : void 0;
}
function $cf61b77dbdb95489$var$vo(e) {
    if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
    const t = e.length, n = t / 2;
    if (t % 2) throw new Error("hex string expected, got unpadded hex of length " + t);
    const r = new Uint8Array(n);
    for(let t = 0, i = 0; t < n; t++, i += 2){
        const n = $cf61b77dbdb95489$var$yo(e.charCodeAt(i)), o = $cf61b77dbdb95489$var$yo(e.charCodeAt(i + 1));
        if (void 0 === n || void 0 === o) {
            const t = e[i] + e[i + 1];
            throw new Error('hex string expected, got non-hex character "' + t + '" at index ' + i);
        }
        r[t] = 16 * n + o;
    }
    return r;
}
function $cf61b77dbdb95489$var$Io(e) {
    return $cf61b77dbdb95489$var$ao(e), $cf61b77dbdb95489$var$co($cf61b77dbdb95489$var$uo(Uint8Array.from(e).reverse()));
}
function $cf61b77dbdb95489$var$Mo(e, t) {
    return $cf61b77dbdb95489$var$vo(e.toString(16).padStart(2 * t, "0"));
}
function $cf61b77dbdb95489$var$Eo(e, t) {
    return $cf61b77dbdb95489$var$Mo(e, t).reverse();
}
function $cf61b77dbdb95489$var$xo(e, t, n) {
    let r;
    if ("string" == typeof t) try {
        r = $cf61b77dbdb95489$var$vo(t);
    } catch (t) {
        throw new Error(e + " must be hex string or Uint8Array, cause: " + t);
    }
    else {
        if (!$cf61b77dbdb95489$var$oo(t)) throw new Error(e + " must be hex string or Uint8Array");
        r = Uint8Array.from(t);
    }
    const i = r.length;
    if ("number" == typeof n && i !== n) throw new Error(e + " of length " + n + " expected, got " + i);
    return r;
}
function $cf61b77dbdb95489$var$So(...e) {
    let t = 0;
    for(let n = 0; n < e.length; n++){
        const r = e[n];
        $cf61b77dbdb95489$var$ao(r), t += r.length;
    }
    const n = new Uint8Array(t);
    for(let t = 0, r = 0; t < e.length; t++){
        const i = e[t];
        n.set(i, r), r += i.length;
    }
    return n;
}
const $cf61b77dbdb95489$var$wo = (e)=>"bigint" == typeof e && $cf61b77dbdb95489$var$no <= e;
function $cf61b77dbdb95489$var$ko(e, t, n, r) {
    if (!function(e, t, n) {
        return $cf61b77dbdb95489$var$wo(e) && $cf61b77dbdb95489$var$wo(t) && $cf61b77dbdb95489$var$wo(n) && t <= e && e < n;
    }(t, n, r)) throw new Error("expected valid " + e + ": " + n + " <= n < " + r + ", got " + t);
}
const $cf61b77dbdb95489$var$No = (e)=>($cf61b77dbdb95489$var$io << BigInt(e - 1)) - $cf61b77dbdb95489$var$ro, $cf61b77dbdb95489$var$Uo = {
    bigint: (e)=>"bigint" == typeof e,
    function: (e)=>"function" == typeof e,
    boolean: (e)=>"boolean" == typeof e,
    string: (e)=>"string" == typeof e,
    stringOrUint8Array: (e)=>"string" == typeof e || $cf61b77dbdb95489$var$oo(e),
    isSafeInteger: (e)=>Number.isSafeInteger(e),
    array: (e)=>Array.isArray(e),
    field: (e, t)=>t.Fp.isValid(e),
    hash: (e)=>"function" == typeof e && Number.isSafeInteger(e.outputLen)
};
function $cf61b77dbdb95489$var$Ro(e, t, n = {}) {
    const r = (t, n, r)=>{
        const i = $cf61b77dbdb95489$var$Uo[n];
        if ("function" != typeof i) throw new Error("invalid validator function");
        const o = e[t];
        if (!(r && void 0 === o || i(o, e))) throw new Error("param " + String(t) + " is invalid. Expected " + n + ", got " + o);
    };
    for (const [e, n] of Object.entries(t))r(e, n, !1);
    for (const [e, t] of Object.entries(n))r(e, t, !0);
    return e;
}
function $cf61b77dbdb95489$var$Lo(e) {
    const t = new WeakMap;
    return (n, ...r)=>{
        const i = t.get(n);
        if (void 0 !== i) return i;
        const o = e(n, ...r);
        return t.set(n, o), o;
    };
}
const $cf61b77dbdb95489$var$Co = BigInt(0), $cf61b77dbdb95489$var$zo = BigInt(1), $cf61b77dbdb95489$var$To = BigInt(2), $cf61b77dbdb95489$var$Do = BigInt(3), $cf61b77dbdb95489$var$Fo = BigInt(4), $cf61b77dbdb95489$var$Vo = BigInt(5), $cf61b77dbdb95489$var$Ao = BigInt(8);
function $cf61b77dbdb95489$var$jo(e, t) {
    const n = e % t;
    return n >= $cf61b77dbdb95489$var$Co ? n : t + n;
}
function $cf61b77dbdb95489$var$Oo(e, t, n) {
    if (t < $cf61b77dbdb95489$var$Co) throw new Error("invalid exponent, negatives unsupported");
    if (n <= $cf61b77dbdb95489$var$Co) throw new Error("invalid modulus");
    if (n === $cf61b77dbdb95489$var$zo) return $cf61b77dbdb95489$var$Co;
    let r = $cf61b77dbdb95489$var$zo;
    for(; t > $cf61b77dbdb95489$var$Co;)t & $cf61b77dbdb95489$var$zo && (r = r * e % n), e = e * e % n, t >>= $cf61b77dbdb95489$var$zo;
    return r;
}
function $cf61b77dbdb95489$var$Qo(e, t, n) {
    let r = e;
    for(; t-- > $cf61b77dbdb95489$var$Co;)r *= r, r %= n;
    return r;
}
function $cf61b77dbdb95489$var$qo(e, t) {
    if (e === $cf61b77dbdb95489$var$Co) throw new Error("invert: expected non-zero number");
    if (t <= $cf61b77dbdb95489$var$Co) throw new Error("invert: expected positive modulus, got " + t);
    let n = $cf61b77dbdb95489$var$jo(e, t), r = t, i = $cf61b77dbdb95489$var$Co, o = $cf61b77dbdb95489$var$zo;
    for(; n !== $cf61b77dbdb95489$var$Co;){
        const e = r % n, t = i - o * (r / n);
        r = n, n = e, i = o, o = t;
    }
    if (r !== $cf61b77dbdb95489$var$zo) throw new Error("invert: does not exist");
    return $cf61b77dbdb95489$var$jo(i, t);
}
function $cf61b77dbdb95489$var$Wo(e) {
    if (e % $cf61b77dbdb95489$var$Fo === $cf61b77dbdb95489$var$Do) {
        const t = (e + $cf61b77dbdb95489$var$zo) / $cf61b77dbdb95489$var$Fo;
        return function(e, n) {
            const r = e.pow(n, t);
            if (!e.eql(e.sqr(r), n)) throw new Error("Cannot find square root");
            return r;
        };
    }
    if (e % $cf61b77dbdb95489$var$Ao === $cf61b77dbdb95489$var$Vo) {
        const t = (e - $cf61b77dbdb95489$var$Vo) / $cf61b77dbdb95489$var$Ao;
        return function(e, n) {
            const r = e.mul(n, $cf61b77dbdb95489$var$To), i = e.pow(r, t), o = e.mul(n, i), a = e.mul(e.mul(o, $cf61b77dbdb95489$var$To), i), l = e.mul(o, e.sub(a, e.ONE));
            if (!e.eql(e.sqr(l), n)) throw new Error("Cannot find square root");
            return l;
        };
    }
    return function(e) {
        const t = (e - $cf61b77dbdb95489$var$zo) / $cf61b77dbdb95489$var$To;
        let n, r, i;
        for(n = e - $cf61b77dbdb95489$var$zo, r = 0; n % $cf61b77dbdb95489$var$To === $cf61b77dbdb95489$var$Co; n /= $cf61b77dbdb95489$var$To, r++);
        for(i = $cf61b77dbdb95489$var$To; i < e && $cf61b77dbdb95489$var$Oo(i, t, e) !== e - $cf61b77dbdb95489$var$zo; i++)if (i > 1e3) throw new Error("Cannot find square root: likely non-prime P");
        if (1 === r) {
            const t = (e + $cf61b77dbdb95489$var$zo) / $cf61b77dbdb95489$var$Fo;
            return function(e, n) {
                const r = e.pow(n, t);
                if (!e.eql(e.sqr(r), n)) throw new Error("Cannot find square root");
                return r;
            };
        }
        const o = (n + $cf61b77dbdb95489$var$zo) / $cf61b77dbdb95489$var$To;
        return function(e, a) {
            if (e.pow(a, t) === e.neg(e.ONE)) throw new Error("Cannot find square root");
            let l = r, s = e.pow(e.mul(e.ONE, i), n), u = e.pow(a, o), c = e.pow(a, n);
            for(; !e.eql(c, e.ONE);){
                if (e.eql(c, e.ZERO)) return e.ZERO;
                let t = 1;
                for(let n = e.sqr(c); t < l && !e.eql(n, e.ONE); t++)n = e.sqr(n);
                const n = e.pow(s, $cf61b77dbdb95489$var$zo << BigInt(l - t - 1));
                s = e.sqr(n), u = e.mul(u, n), c = e.mul(c, s), l = t;
            }
            return u;
        };
    }(e);
}
const $cf61b77dbdb95489$var$Go = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $cf61b77dbdb95489$var$Bo(e, t) {
    const n = void 0 !== t ? t : e.toString(2).length;
    return {
        nBitLength: n,
        nByteLength: Math.ceil(n / 8)
    };
}
function $cf61b77dbdb95489$var$Ko(e, t, n = !1, r = {}) {
    if (e <= $cf61b77dbdb95489$var$Co) throw new Error("invalid field: expected ORDER > 0, got " + e);
    const { nBitLength: i, nByteLength: o } = $cf61b77dbdb95489$var$Bo(e, t);
    if (o > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let a;
    const l = Object.freeze({
        ORDER: e,
        isLE: n,
        BITS: i,
        BYTES: o,
        MASK: $cf61b77dbdb95489$var$No(i),
        ZERO: $cf61b77dbdb95489$var$Co,
        ONE: $cf61b77dbdb95489$var$zo,
        create: (t)=>$cf61b77dbdb95489$var$jo(t, e),
        isValid: (t)=>{
            if ("bigint" != typeof t) throw new Error("invalid field element: expected bigint, got " + typeof t);
            return $cf61b77dbdb95489$var$Co <= t && t < e;
        },
        is0: (e)=>e === $cf61b77dbdb95489$var$Co,
        isOdd: (e)=>(e & $cf61b77dbdb95489$var$zo) === $cf61b77dbdb95489$var$zo,
        neg: (t)=>$cf61b77dbdb95489$var$jo(-t, e),
        eql: (e, t)=>e === t,
        sqr: (t)=>$cf61b77dbdb95489$var$jo(t * t, e),
        add: (t, n)=>$cf61b77dbdb95489$var$jo(t + n, e),
        sub: (t, n)=>$cf61b77dbdb95489$var$jo(t - n, e),
        mul: (t, n)=>$cf61b77dbdb95489$var$jo(t * n, e),
        pow: (e, t)=>(function(e, t, n) {
                if (n < $cf61b77dbdb95489$var$Co) throw new Error("invalid exponent, negatives unsupported");
                if (n === $cf61b77dbdb95489$var$Co) return e.ONE;
                if (n === $cf61b77dbdb95489$var$zo) return t;
                let r = e.ONE, i = t;
                for(; n > $cf61b77dbdb95489$var$Co;)n & $cf61b77dbdb95489$var$zo && (r = e.mul(r, i)), i = e.sqr(i), n >>= $cf61b77dbdb95489$var$zo;
                return r;
            })(l, e, t),
        div: (t, n)=>$cf61b77dbdb95489$var$jo(t * $cf61b77dbdb95489$var$qo(n, e), e),
        sqrN: (e)=>e * e,
        addN: (e, t)=>e + t,
        subN: (e, t)=>e - t,
        mulN: (e, t)=>e * t,
        inv: (t)=>$cf61b77dbdb95489$var$qo(t, e),
        sqrt: r.sqrt || ((t)=>(a || (a = $cf61b77dbdb95489$var$Wo(e)), a(l, t))),
        invertBatch: (e)=>(function(e, t) {
                const n = new Array(t.length), r = t.reduce((t, r, i)=>e.is0(r) ? t : (n[i] = t, e.mul(t, r)), e.ONE), i = e.inv(r);
                return t.reduceRight((t, r, i)=>e.is0(r) ? t : (n[i] = e.mul(t, n[i]), e.mul(t, r)), i), n;
            })(l, e),
        cmov: (e, t, n)=>n ? t : e,
        toBytes: (e)=>n ? $cf61b77dbdb95489$var$Eo(e, o) : $cf61b77dbdb95489$var$Mo(e, o),
        fromBytes: (e)=>{
            if (e.length !== o) throw new Error("Field.fromBytes: expected " + o + " bytes, got " + e.length);
            return n ? $cf61b77dbdb95489$var$Io(e) : function(e) {
                return $cf61b77dbdb95489$var$co($cf61b77dbdb95489$var$uo(e));
            }(e);
        }
    });
    return Object.freeze(l);
}
const $cf61b77dbdb95489$var$Yo = BigInt(0), $cf61b77dbdb95489$var$Zo = BigInt(1);
function $cf61b77dbdb95489$var$Xo(e, t) {
    const n = t.negate();
    return e ? n : t;
}
function $cf61b77dbdb95489$var$Po(e, t) {
    if (!Number.isSafeInteger(e) || e <= 0 || e > t) throw new Error("invalid window size, expected [1.." + t + "], got W=" + e);
}
function $cf61b77dbdb95489$var$Jo(e, t) {
    $cf61b77dbdb95489$var$Po(e, t);
    return {
        windows: Math.ceil(t / e) + 1,
        windowSize: 2 ** (e - 1)
    };
}
const $cf61b77dbdb95489$var$Ho = new WeakMap, $cf61b77dbdb95489$var$_o = new WeakMap;
function $cf61b77dbdb95489$var$$o(e) {
    return $cf61b77dbdb95489$var$_o.get(e) || 1;
}
function $cf61b77dbdb95489$var$ea(e, t, n, r) {
    if (function(e, t) {
        if (!Array.isArray(e)) throw new Error("array expected");
        e.forEach((e, n)=>{
            if (!(e instanceof t)) throw new Error("invalid point at index " + n);
        });
    }(n, e), function(e, t) {
        if (!Array.isArray(e)) throw new Error("array of scalars expected");
        e.forEach((e, n)=>{
            if (!t.isValid(e)) throw new Error("invalid scalar at index " + n);
        });
    }(r, t), n.length !== r.length) throw new Error("arrays of points and scalars must have equal length");
    const i = e.ZERO, o = function(e) {
        let t;
        for(t = 0; e > $cf61b77dbdb95489$var$no; e >>= $cf61b77dbdb95489$var$ro, t += 1);
        return t;
    }(BigInt(n.length)), a = o > 12 ? o - 3 : o > 4 ? o - 2 : o ? 2 : 1, l = (1 << a) - 1, s = new Array(l + 1).fill(i);
    let u = i;
    for(let e = Math.floor((t.BITS - 1) / a) * a; e >= 0; e -= a){
        s.fill(i);
        for(let t = 0; t < r.length; t++){
            const i = r[t], o = Number(i >> BigInt(e) & BigInt(l));
            s[o] = s[o].add(n[t]);
        }
        let t = i;
        for(let e = s.length - 1, n = i; e > 0; e--)n = n.add(s[e]), t = t.add(n);
        if (u = u.add(t), 0 !== e) for(let e = 0; e < a; e++)u = u.double();
    }
    return u;
}
function $cf61b77dbdb95489$var$ta(e) {
    return function(e) {
        $cf61b77dbdb95489$var$Ro(e, $cf61b77dbdb95489$var$Go.reduce((e, t)=>(e[t] = "function", e), {
            ORDER: "bigint",
            MASK: "bigint",
            BYTES: "isSafeInteger",
            BITS: "isSafeInteger"
        }));
    }(e.Fp), $cf61b77dbdb95489$var$Ro(e, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    }), Object.freeze({
        ...$cf61b77dbdb95489$var$Bo(e.n, e.nBitLength),
        ...e,
        p: e.Fp.ORDER
    });
}
const $cf61b77dbdb95489$var$na = BigInt(0), $cf61b77dbdb95489$var$ra = BigInt(1), $cf61b77dbdb95489$var$ia = BigInt(2), $cf61b77dbdb95489$var$oa = BigInt(8), $cf61b77dbdb95489$var$aa = {
    zip215: !0
};
function $cf61b77dbdb95489$var$la(e) {
    const t = function(e) {
        const t = $cf61b77dbdb95489$var$ta(e);
        return $cf61b77dbdb95489$var$Ro(e, {
            hash: "function",
            a: "bigint",
            d: "bigint",
            randomBytes: "function"
        }, {
            adjustScalarBytes: "function",
            domain: "function",
            uvRatio: "function",
            mapToCurve: "function"
        }), Object.freeze({
            ...t
        });
    }(e), { Fp: n, n: r, prehash: i, hash: o, randomBytes: a, nByteLength: l, h: s } = t, u = $cf61b77dbdb95489$var$ia << BigInt(8 * l) - $cf61b77dbdb95489$var$ra, c = n.create, d = $cf61b77dbdb95489$var$Ko(t.n, t.nBitLength), f = t.uvRatio || ((e, t)=>{
        try {
            return {
                isValid: !0,
                value: n.sqrt(e * n.inv(t))
            };
        } catch  {
            return {
                isValid: !1,
                value: $cf61b77dbdb95489$var$na
            };
        }
    }), h = t.adjustScalarBytes || ((e)=>e), p = t.domain || ((e, t, n)=>{
        if ($cf61b77dbdb95489$var$lo("phflag", n), t.length || n) throw new Error("Contexts/pre-hash are not supported");
        return e;
    });
    function m(e, t) {
        $cf61b77dbdb95489$var$ko("coordinate " + e, t, $cf61b77dbdb95489$var$na, u);
    }
    function g(e) {
        if (!(e instanceof v)) throw new Error("ExtendedPoint expected");
    }
    const b = $cf61b77dbdb95489$var$Lo((e, t)=>{
        const { ex: r, ey: i, ez: o } = e, a = e.is0();
        null == t && (t = a ? $cf61b77dbdb95489$var$oa : n.inv(o));
        const l = c(r * t), s = c(i * t), u = c(o * t);
        if (a) return {
            x: $cf61b77dbdb95489$var$na,
            y: $cf61b77dbdb95489$var$ra
        };
        if (u !== $cf61b77dbdb95489$var$ra) throw new Error("invZ was invalid");
        return {
            x: l,
            y: s
        };
    }), y = $cf61b77dbdb95489$var$Lo((e)=>{
        const { a: n, d: r } = t;
        if (e.is0()) throw new Error("bad point: ZERO");
        const { ex: i, ey: o, ez: a, et: l } = e, s = c(i * i), u = c(o * o), d = c(a * a), f = c(d * d), h = c(s * n);
        if (c(d * c(h + u)) !== c(f + c(r * c(s * u)))) throw new Error("bad point: equation left != right (1)");
        if (c(i * o) !== c(a * l)) throw new Error("bad point: equation left != right (2)");
        return !0;
    });
    class v {
        constructor(e, t, n, r){
            this.ex = e, this.ey = t, this.ez = n, this.et = r, m("x", e), m("y", t), m("z", n), m("t", r), Object.freeze(this);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(e) {
            if (e instanceof v) throw new Error("extended point not allowed");
            const { x: t, y: n } = e || {};
            return m("x", t), m("y", n), new v(t, n, $cf61b77dbdb95489$var$ra, c(t * n));
        }
        static normalizeZ(e) {
            const t = n.invertBatch(e.map((e)=>e.ez));
            return e.map((e, n)=>e.toAffine(t[n])).map(v.fromAffine);
        }
        static msm(e, t) {
            return $cf61b77dbdb95489$var$ea(v, d, e, t);
        }
        _setWindowSize(e) {
            E.setWindowSize(this, e);
        }
        assertValidity() {
            y(this);
        }
        equals(e) {
            g(e);
            const { ex: t, ey: n, ez: r } = this, { ex: i, ey: o, ez: a } = e, l = c(t * a), s = c(i * r), u = c(n * a), d = c(o * r);
            return l === s && u === d;
        }
        is0() {
            return this.equals(v.ZERO);
        }
        negate() {
            return new v(c(-this.ex), this.ey, this.ez, c(-this.et));
        }
        double() {
            const { a: e } = t, { ex: n, ey: r, ez: i } = this, o = c(n * n), a = c(r * r), l = c($cf61b77dbdb95489$var$ia * c(i * i)), s = c(e * o), u = n + r, d = c(c(u * u) - o - a), f = s + a, h = f - l, p = s - a, m = c(d * h), g = c(f * p), b = c(d * p), y = c(h * f);
            return new v(m, g, y, b);
        }
        add(e) {
            g(e);
            const { a: n, d: r } = t, { ex: i, ey: o, ez: a, et: l } = this, { ex: s, ey: u, ez: d, et: f } = e;
            if (n === BigInt(-1)) {
                const e = c((o - i) * (u + s)), t = c((o + i) * (u - s)), n = c(t - e);
                if (n === $cf61b77dbdb95489$var$na) return this.double();
                const r = c(a * $cf61b77dbdb95489$var$ia * f), h = c(l * $cf61b77dbdb95489$var$ia * d), p = h + r, m = t + e, g = h - r, b = c(p * n), y = c(m * g), I = c(p * g), M = c(n * m);
                return new v(b, y, M, I);
            }
            const h = c(i * s), p = c(o * u), m = c(l * r * f), b = c(a * d), y = c((i + o) * (s + u) - h - p), I = b - m, M = b + m, E = c(p - n * h), x = c(y * I), S = c(M * E), w = c(y * E), k = c(I * M);
            return new v(x, S, k, w);
        }
        subtract(e) {
            return this.add(e.negate());
        }
        wNAF(e) {
            return E.wNAFCached(this, e, v.normalizeZ);
        }
        multiply(e) {
            const t = e;
            $cf61b77dbdb95489$var$ko("scalar", t, $cf61b77dbdb95489$var$ra, r);
            const { p: n, f: i } = this.wNAF(t);
            return v.normalizeZ([
                n,
                i
            ])[0];
        }
        multiplyUnsafe(e, t = v.ZERO) {
            const n = e;
            return $cf61b77dbdb95489$var$ko("scalar", n, $cf61b77dbdb95489$var$na, r), n === $cf61b77dbdb95489$var$na ? M : this.is0() || n === $cf61b77dbdb95489$var$ra ? this : E.wNAFCachedUnsafe(this, n, v.normalizeZ, t);
        }
        isSmallOrder() {
            return this.multiplyUnsafe(s).is0();
        }
        isTorsionFree() {
            return E.unsafeLadder(this, r).is0();
        }
        toAffine(e) {
            return b(this, e);
        }
        clearCofactor() {
            const { h: e } = t;
            return e === $cf61b77dbdb95489$var$ra ? this : this.multiplyUnsafe(e);
        }
        static fromHex(e, r = !1) {
            const { d: i, a: o } = t, a = n.BYTES;
            e = $cf61b77dbdb95489$var$xo("pointHex", e, a), $cf61b77dbdb95489$var$lo("zip215", r);
            const l = e.slice(), s = e[a - 1];
            l[a - 1] = -129 & s;
            const d = $cf61b77dbdb95489$var$Io(l), h = r ? u : n.ORDER;
            $cf61b77dbdb95489$var$ko("pointHex.y", d, $cf61b77dbdb95489$var$na, h);
            const p = c(d * d), m = c(p - $cf61b77dbdb95489$var$ra), g = c(i * p - o);
            let { isValid: b, value: y } = f(m, g);
            if (!b) throw new Error("Point.fromHex: invalid y coordinate");
            const I = (y & $cf61b77dbdb95489$var$ra) === $cf61b77dbdb95489$var$ra, M = !!(128 & s);
            if (!r && y === $cf61b77dbdb95489$var$na && M) throw new Error("Point.fromHex: x=0 and x_0=1");
            return M !== I && (y = c(-y)), v.fromAffine({
                x: y,
                y: d
            });
        }
        static fromPrivateKey(e) {
            return w(e).point;
        }
        toRawBytes() {
            const { x: e, y: t } = this.toAffine(), r = $cf61b77dbdb95489$var$Eo(t, n.BYTES);
            return r[r.length - 1] |= e & $cf61b77dbdb95489$var$ra ? 128 : 0, r;
        }
        toHex() {
            return $cf61b77dbdb95489$var$uo(this.toRawBytes());
        }
    }
    v.BASE = new v(t.Gx, t.Gy, $cf61b77dbdb95489$var$ra, c(t.Gx * t.Gy)), v.ZERO = new v($cf61b77dbdb95489$var$na, $cf61b77dbdb95489$var$ra, $cf61b77dbdb95489$var$ra, $cf61b77dbdb95489$var$na);
    const { BASE: I, ZERO: M } = v, E = function(e, t) {
        return {
            constTimeNegate: $cf61b77dbdb95489$var$Xo,
            hasPrecomputes: (e)=>1 !== $cf61b77dbdb95489$var$$o(e),
            unsafeLadder (t, n, r = e.ZERO) {
                let i = t;
                for(; n > $cf61b77dbdb95489$var$Yo;)n & $cf61b77dbdb95489$var$Zo && (r = r.add(i)), i = i.double(), n >>= $cf61b77dbdb95489$var$Zo;
                return r;
            },
            precomputeWindow (e, n) {
                const { windows: r, windowSize: i } = $cf61b77dbdb95489$var$Jo(n, t), o = [];
                let a = e, l = a;
                for(let e = 0; e < r; e++){
                    l = a, o.push(l);
                    for(let e = 1; e < i; e++)l = l.add(a), o.push(l);
                    a = l.double();
                }
                return o;
            },
            wNAF (n, r, i) {
                const { windows: o, windowSize: a } = $cf61b77dbdb95489$var$Jo(n, t);
                let l = e.ZERO, s = e.BASE;
                const u = BigInt(2 ** n - 1), c = 2 ** n, d = BigInt(n);
                for(let e = 0; e < o; e++){
                    const t = e * a;
                    let n = Number(i & u);
                    i >>= d, n > a && (n -= c, i += $cf61b77dbdb95489$var$Zo);
                    const o = t, f = t + Math.abs(n) - 1, h = e % 2 != 0, p = n < 0;
                    0 === n ? s = s.add($cf61b77dbdb95489$var$Xo(h, r[o])) : l = l.add($cf61b77dbdb95489$var$Xo(p, r[f]));
                }
                return {
                    p: l,
                    f: s
                };
            },
            wNAFUnsafe (n, r, i, o = e.ZERO) {
                const { windows: a, windowSize: l } = $cf61b77dbdb95489$var$Jo(n, t), s = BigInt(2 ** n - 1), u = 2 ** n, c = BigInt(n);
                for(let e = 0; e < a; e++){
                    const t = e * l;
                    if (i === $cf61b77dbdb95489$var$Yo) break;
                    let n = Number(i & s);
                    if (i >>= c, n > l && (n -= u, i += $cf61b77dbdb95489$var$Zo), 0 === n) continue;
                    let a = r[t + Math.abs(n) - 1];
                    n < 0 && (a = a.negate()), o = o.add(a);
                }
                return o;
            },
            getPrecomputes (e, t, n) {
                let r = $cf61b77dbdb95489$var$Ho.get(t);
                return r || (r = this.precomputeWindow(t, e), 1 !== e && $cf61b77dbdb95489$var$Ho.set(t, n(r))), r;
            },
            wNAFCached (e, t, n) {
                const r = $cf61b77dbdb95489$var$$o(e);
                return this.wNAF(r, this.getPrecomputes(r, e, n), t);
            },
            wNAFCachedUnsafe (e, t, n, r) {
                const i = $cf61b77dbdb95489$var$$o(e);
                return 1 === i ? this.unsafeLadder(e, t, r) : this.wNAFUnsafe(i, this.getPrecomputes(i, e, n), t, r);
            },
            setWindowSize (e, n) {
                $cf61b77dbdb95489$var$Po(n, t), $cf61b77dbdb95489$var$_o.set(e, n), $cf61b77dbdb95489$var$Ho.delete(e);
            }
        };
    }(v, 8 * l);
    function x(e) {
        return $cf61b77dbdb95489$var$jo(e, r);
    }
    function S(e) {
        return x($cf61b77dbdb95489$var$Io(e));
    }
    function w(e) {
        const t = n.BYTES;
        e = $cf61b77dbdb95489$var$xo("private key", e, t);
        const r = $cf61b77dbdb95489$var$xo("hashed private key", o(e), 2 * t), i = h(r.slice(0, t)), a = r.slice(t, 2 * t), l = S(i), s = I.multiply(l), u = s.toRawBytes();
        return {
            head: i,
            prefix: a,
            scalar: l,
            point: s,
            pointBytes: u
        };
    }
    function k(e = new Uint8Array, ...t) {
        const n = $cf61b77dbdb95489$var$So(...t);
        return S(o(p(n, $cf61b77dbdb95489$var$xo("context", e), !!i)));
    }
    const N = $cf61b77dbdb95489$var$aa;
    return I._setWindowSize(8), {
        CURVE: t,
        getPublicKey: function(e) {
            return w(e).pointBytes;
        },
        sign: function(e, t, o = {}) {
            e = $cf61b77dbdb95489$var$xo("message", e), i && (e = i(e));
            const { prefix: a, scalar: l, pointBytes: s } = w(t), u = k(o.context, a, e), c = I.multiply(u).toRawBytes(), d = x(u + k(o.context, c, s, e) * l);
            return $cf61b77dbdb95489$var$ko("signature.s", d, $cf61b77dbdb95489$var$na, r), $cf61b77dbdb95489$var$xo("result", $cf61b77dbdb95489$var$So(c, $cf61b77dbdb95489$var$Eo(d, n.BYTES)), 2 * n.BYTES);
        },
        verify: function(e, t, r, o = N) {
            const { context: a, zip215: l } = o, s = n.BYTES;
            e = $cf61b77dbdb95489$var$xo("signature", e, 2 * s), t = $cf61b77dbdb95489$var$xo("message", t), r = $cf61b77dbdb95489$var$xo("publicKey", r, s), void 0 !== l && $cf61b77dbdb95489$var$lo("zip215", l), i && (t = i(t));
            const u = $cf61b77dbdb95489$var$Io(e.slice(s, 2 * s));
            let c, d, f;
            try {
                c = v.fromHex(r, l), d = v.fromHex(e.slice(0, s), l), f = I.multiplyUnsafe(u);
            } catch  {
                return !1;
            }
            if (!l && c.isSmallOrder()) return !1;
            const h = k(a, d.toRawBytes(), c.toRawBytes(), t);
            return d.add(c.multiplyUnsafe(h)).subtract(f).clearCofactor().equals(v.ZERO);
        },
        ExtendedPoint: v,
        utils: {
            getExtendedPublicKey: w,
            randomPrivateKey: ()=>a(n.BYTES),
            precompute: (e = 8, t = v.BASE)=>(t._setWindowSize(e), t.multiply(BigInt(3)), t)
        }
    };
}
BigInt(0), BigInt(1);
const $cf61b77dbdb95489$var$sa = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), $cf61b77dbdb95489$var$ua = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const $cf61b77dbdb95489$var$ca = BigInt(1), $cf61b77dbdb95489$var$da = BigInt(2);
BigInt(3);
const $cf61b77dbdb95489$var$fa = BigInt(5), $cf61b77dbdb95489$var$ha = BigInt(8);
function $cf61b77dbdb95489$var$pa(e) {
    return e[0] &= 248, e[31] &= 127, e[31] |= 64, e;
}
function $cf61b77dbdb95489$var$ma(e, t) {
    const n = $cf61b77dbdb95489$var$sa, r = $cf61b77dbdb95489$var$jo(t * t * t, n), i = function(e) {
        const t = BigInt(10), n = BigInt(20), r = BigInt(40), i = BigInt(80), o = $cf61b77dbdb95489$var$sa, a = e * e % o * e % o, l = $cf61b77dbdb95489$var$Qo(a, $cf61b77dbdb95489$var$da, o) * a % o, s = $cf61b77dbdb95489$var$Qo(l, $cf61b77dbdb95489$var$ca, o) * e % o, u = $cf61b77dbdb95489$var$Qo(s, $cf61b77dbdb95489$var$fa, o) * s % o, c = $cf61b77dbdb95489$var$Qo(u, t, o) * u % o, d = $cf61b77dbdb95489$var$Qo(c, n, o) * c % o, f = $cf61b77dbdb95489$var$Qo(d, r, o) * d % o, h = $cf61b77dbdb95489$var$Qo(f, i, o) * f % o, p = $cf61b77dbdb95489$var$Qo(h, i, o) * f % o, m = $cf61b77dbdb95489$var$Qo(p, t, o) * u % o;
        return {
            pow_p_5_8: $cf61b77dbdb95489$var$Qo(m, $cf61b77dbdb95489$var$da, o) * e % o,
            b2: a
        };
    }(e * $cf61b77dbdb95489$var$jo(r * r * t, n)).pow_p_5_8;
    let o = $cf61b77dbdb95489$var$jo(e * r * i, n);
    const a = $cf61b77dbdb95489$var$jo(t * o * o, n), l = o, s = $cf61b77dbdb95489$var$jo(o * $cf61b77dbdb95489$var$ua, n), u = a === e, c = a === $cf61b77dbdb95489$var$jo(-e, n), d = a === $cf61b77dbdb95489$var$jo(-e * $cf61b77dbdb95489$var$ua, n);
    return u && (o = l), (c || d) && (o = s), ((e, t)=>($cf61b77dbdb95489$var$jo(e, t) & $cf61b77dbdb95489$var$zo) === $cf61b77dbdb95489$var$zo)(o, n) && (o = $cf61b77dbdb95489$var$jo(-o, n)), {
        isValid: u || c,
        value: o
    };
}
const $cf61b77dbdb95489$var$ga = $cf61b77dbdb95489$var$Ko($cf61b77dbdb95489$var$sa, void 0, !0);
$cf61b77dbdb95489$var$la({
    a: BigInt(-1),
    d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
    Fp: $cf61b77dbdb95489$var$ga,
    n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
    h: $cf61b77dbdb95489$var$ha,
    Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
    Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
    hash: $cf61b77dbdb95489$var$to,
    randomBytes: $cf61b77dbdb95489$var$Bi,
    adjustScalarBytes: $cf61b77dbdb95489$var$pa,
    uvRatio: $cf61b77dbdb95489$var$ma
});
var $cf61b77dbdb95489$var$ba = function(e, t) {
    if (e.length >= 255) throw new TypeError("Alphabet too long");
    for(var n = new Uint8Array(256), r = 0; r < n.length; r++)n[r] = 255;
    for(var i = 0; i < e.length; i++){
        var o = e.charAt(i), a = o.charCodeAt(0);
        if (255 !== n[a]) throw new TypeError(o + " is ambiguous");
        n[a] = i;
    }
    var l = e.length, s = e.charAt(0), u = Math.log(l) / Math.log(256), c = Math.log(256) / Math.log(l);
    function d(e) {
        if ("string" != typeof e) throw new TypeError("Expected String");
        if (0 === e.length) return new Uint8Array;
        var t = 0;
        if (" " !== e[t]) {
            for(var r = 0, i = 0; e[t] === s;)r++, t++;
            for(var o = (e.length - t) * u + 1 >>> 0, a = new Uint8Array(o); e[t];){
                var c = n[e.charCodeAt(t)];
                if (255 === c) return;
                for(var d = 0, f = o - 1; (0 !== c || d < i) && -1 !== f; f--, d++)c += l * a[f] >>> 0, a[f] = c % 256 >>> 0, c = c / 256 >>> 0;
                if (0 !== c) throw new Error("Non-zero carry");
                i = d, t++;
            }
            if (" " !== e[t]) {
                for(var h = o - i; h !== o && 0 === a[h];)h++;
                for(var p = new Uint8Array(r + (o - h)), m = r; h !== o;)p[m++] = a[h++];
                return p;
            }
        }
    }
    return {
        encode: function(t) {
            if (t instanceof Uint8Array || (ArrayBuffer.isView(t) ? t = new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : Array.isArray(t) && (t = Uint8Array.from(t))), !(t instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
            if (0 === t.length) return "";
            for(var n = 0, r = 0, i = 0, o = t.length; i !== o && 0 === t[i];)i++, n++;
            for(var a = (o - i) * c + 1 >>> 0, u = new Uint8Array(a); i !== o;){
                for(var d = t[i], f = 0, h = a - 1; (0 !== d || f < r) && -1 !== h; h--, f++)d += 256 * u[h] >>> 0, u[h] = d % l >>> 0, d = d / l >>> 0;
                if (0 !== d) throw new Error("Non-zero carry");
                r = f, i++;
            }
            for(var p = a - r; p !== a && 0 === u[p];)p++;
            for(var m = s.repeat(n); p < a; ++p)m += e.charAt(u[p]);
            return m;
        },
        decodeUnsafe: d,
        decode: function(e) {
            var n = d(e);
            if (n) return n;
            throw new Error(`Non-${t} character`);
        }
    };
}, $cf61b77dbdb95489$var$ya = $cf61b77dbdb95489$var$ba;
const $cf61b77dbdb95489$var$va = (e)=>{
    if (e instanceof Uint8Array && "Uint8Array" === e.constructor.name) return e;
    if (e instanceof ArrayBuffer) return new Uint8Array(e);
    if (ArrayBuffer.isView(e)) return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
    throw new Error("Unknown type, must be binary type");
};
class $cf61b77dbdb95489$var$Ia {
    constructor(e, t, n){
        this.name = e, this.prefix = t, this.baseEncode = n;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $cf61b77dbdb95489$var$Ma {
    constructor(e, t, n){
        if (this.name = e, this.prefix = t, void 0 === t.codePointAt(0)) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = n;
    }
    decode(e) {
        if ("string" == typeof e) {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        }
        throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $cf61b77dbdb95489$var$xa(this, e);
    }
}
class $cf61b77dbdb95489$var$Ea {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $cf61b77dbdb95489$var$xa(this, e);
    }
    decode(e) {
        const t = e[0], n = this.decoders[t];
        if (n) return n.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $cf61b77dbdb95489$var$xa = (e, t)=>new $cf61b77dbdb95489$var$Ea({
        ...e.decoders || {
            [e.prefix]: e
        },
        ...t.decoders || {
            [t.prefix]: t
        }
    });
class $cf61b77dbdb95489$var$Sa {
    constructor(e, t, n, r){
        this.name = e, this.prefix = t, this.baseEncode = n, this.baseDecode = r, this.encoder = new $cf61b77dbdb95489$var$Ia(e, t, n), this.decoder = new $cf61b77dbdb95489$var$Ma(e, t, r);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $cf61b77dbdb95489$var$wa = ({ name: e, prefix: t, encode: n, decode: r })=>new $cf61b77dbdb95489$var$Sa(e, t, n, r), $cf61b77dbdb95489$var$ka = ({ prefix: e, name: t, alphabet: n })=>{
    const { encode: r, decode: i } = $cf61b77dbdb95489$var$ya(n, t);
    return $cf61b77dbdb95489$var$wa({
        prefix: e,
        name: t,
        encode: r,
        decode: (e)=>$cf61b77dbdb95489$var$va(i(e))
    });
}, $cf61b77dbdb95489$var$Na = ({ name: e, prefix: t, bitsPerChar: n, alphabet: r })=>$cf61b77dbdb95489$var$wa({
        prefix: t,
        name: e,
        encode: (e)=>((e, t, n)=>{
                const r = "=" === t[t.length - 1], i = (1 << n) - 1;
                let o = "", a = 0, l = 0;
                for(let r = 0; r < e.length; ++r)for(l = l << 8 | e[r], a += 8; a > n;)a -= n, o += t[i & l >> a];
                if (a && (o += t[i & l << n - a]), r) for(; o.length * n & 7;)o += "=";
                return o;
            })(e, r, n),
        decode: (t)=>((e, t, n, r)=>{
                const i = {};
                for(let e = 0; e < t.length; ++e)i[t[e]] = e;
                let o = e.length;
                for(; "=" === e[o - 1];)--o;
                const a = new Uint8Array(o * n / 8 | 0);
                let l = 0, s = 0, u = 0;
                for(let t = 0; t < o; ++t){
                    const o = i[e[t]];
                    if (void 0 === o) throw new SyntaxError(`Non-${r} character`);
                    s = s << n | o, l += n, l >= 8 && (l -= 8, a[u++] = 255 & s >> l);
                }
                if (l >= n || 255 & s << 8 - l) throw new SyntaxError("Unexpected end of data");
                return a;
            })(t, r, n, e)
    }), $cf61b77dbdb95489$var$Ua = $cf61b77dbdb95489$var$wa({
    prefix: "\0",
    name: "identity",
    encode: (e)=>((e)=>(new TextDecoder).decode(e))(e),
    decode: (e)=>((e)=>(new TextEncoder).encode(e))(e)
});
Object.freeze({
    __proto__: null,
    identity: $cf61b77dbdb95489$var$Ua
});
const $cf61b77dbdb95489$var$Ra = $cf61b77dbdb95489$var$Na({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
Object.freeze({
    __proto__: null,
    base2: $cf61b77dbdb95489$var$Ra
});
const $cf61b77dbdb95489$var$La = $cf61b77dbdb95489$var$Na({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
Object.freeze({
    __proto__: null,
    base8: $cf61b77dbdb95489$var$La
});
const $cf61b77dbdb95489$var$Ca = $cf61b77dbdb95489$var$ka({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
Object.freeze({
    __proto__: null,
    base10: $cf61b77dbdb95489$var$Ca
});
const $cf61b77dbdb95489$var$za = $cf61b77dbdb95489$var$Na({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $cf61b77dbdb95489$var$Ta = $cf61b77dbdb95489$var$Na({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
Object.freeze({
    __proto__: null,
    base16: $cf61b77dbdb95489$var$za,
    base16upper: $cf61b77dbdb95489$var$Ta
});
const $cf61b77dbdb95489$var$Da = $cf61b77dbdb95489$var$Na({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Fa = $cf61b77dbdb95489$var$Na({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Va = $cf61b77dbdb95489$var$Na({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Aa = $cf61b77dbdb95489$var$Na({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$ja = $cf61b77dbdb95489$var$Na({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Oa = $cf61b77dbdb95489$var$Na({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Qa = $cf61b77dbdb95489$var$Na({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$qa = $cf61b77dbdb95489$var$Na({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Wa = $cf61b77dbdb95489$var$Na({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
Object.freeze({
    __proto__: null,
    base32: $cf61b77dbdb95489$var$Da,
    base32upper: $cf61b77dbdb95489$var$Fa,
    base32pad: $cf61b77dbdb95489$var$Va,
    base32padupper: $cf61b77dbdb95489$var$Aa,
    base32hex: $cf61b77dbdb95489$var$ja,
    base32hexupper: $cf61b77dbdb95489$var$Oa,
    base32hexpad: $cf61b77dbdb95489$var$Qa,
    base32hexpadupper: $cf61b77dbdb95489$var$qa,
    base32z: $cf61b77dbdb95489$var$Wa
});
const $cf61b77dbdb95489$var$Ga = $cf61b77dbdb95489$var$ka({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $cf61b77dbdb95489$var$Ba = $cf61b77dbdb95489$var$ka({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
Object.freeze({
    __proto__: null,
    base36: $cf61b77dbdb95489$var$Ga,
    base36upper: $cf61b77dbdb95489$var$Ba
});
const $cf61b77dbdb95489$var$Ka = $cf61b77dbdb95489$var$ka({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $cf61b77dbdb95489$var$Ya = $cf61b77dbdb95489$var$ka({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
Object.freeze({
    __proto__: null,
    base58btc: $cf61b77dbdb95489$var$Ka,
    base58flickr: $cf61b77dbdb95489$var$Ya
});
const $cf61b77dbdb95489$var$Za = $cf61b77dbdb95489$var$Na({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $cf61b77dbdb95489$var$Xa = $cf61b77dbdb95489$var$Na({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $cf61b77dbdb95489$var$Pa = $cf61b77dbdb95489$var$Na({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $cf61b77dbdb95489$var$Ja = $cf61b77dbdb95489$var$Na({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
Object.freeze({
    __proto__: null,
    base64: $cf61b77dbdb95489$var$Za,
    base64pad: $cf61b77dbdb95489$var$Xa,
    base64url: $cf61b77dbdb95489$var$Pa,
    base64urlpad: $cf61b77dbdb95489$var$Ja
});
const $cf61b77dbdb95489$var$Ha = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $cf61b77dbdb95489$var$_a = $cf61b77dbdb95489$var$Ha.reduce((e, t, n)=>(e[n] = t, e), []), $cf61b77dbdb95489$var$$a = $cf61b77dbdb95489$var$Ha.reduce((e, t, n)=>(e[t.codePointAt(0)] = n, e), []);
const $cf61b77dbdb95489$var$el = $cf61b77dbdb95489$var$wa({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: function(e) {
        return e.reduce((e, t)=>e += $cf61b77dbdb95489$var$_a[t], "");
    },
    decode: function(e) {
        const t = [];
        for (const n of e){
            const e = $cf61b77dbdb95489$var$$a[n.codePointAt(0)];
            if (void 0 === e) throw new Error(`Non-base256emoji character: ${n}`);
            t.push(e);
        }
        return new Uint8Array(t);
    }
});
Object.freeze({
    __proto__: null,
    base256emoji: $cf61b77dbdb95489$var$el
});
var $cf61b77dbdb95489$var$tl = function e(t, n, r) {
    n = n || [];
    for(var i = r = r || 0; t >= $cf61b77dbdb95489$var$il;)n[r++] = 255 & t | $cf61b77dbdb95489$var$nl, t /= 128;
    for(; t & $cf61b77dbdb95489$var$rl;)n[r++] = 255 & t | $cf61b77dbdb95489$var$nl, t >>>= 7;
    return n[r] = 0 | t, e.bytes = r - i + 1, n;
}, $cf61b77dbdb95489$var$nl = 128, $cf61b77dbdb95489$var$rl = -128, $cf61b77dbdb95489$var$il = Math.pow(2, 31);
var $cf61b77dbdb95489$var$ol = function e(t, n) {
    var r, i = 0, o = 0, a = n = n || 0, l = t.length;
    do {
        if (a >= l) throw e.bytes = 0, new RangeError("Could not decode varint");
        r = t[a++], i += o < 28 ? (r & $cf61b77dbdb95489$var$ll) << o : (r & $cf61b77dbdb95489$var$ll) * Math.pow(2, o), o += 7;
    }while (r >= $cf61b77dbdb95489$var$al);
    return e.bytes = a - n, i;
}, $cf61b77dbdb95489$var$al = 128, $cf61b77dbdb95489$var$ll = 127;
var $cf61b77dbdb95489$var$sl = Math.pow(2, 7), $cf61b77dbdb95489$var$ul = Math.pow(2, 14), $cf61b77dbdb95489$var$cl = Math.pow(2, 21), $cf61b77dbdb95489$var$dl = Math.pow(2, 28), $cf61b77dbdb95489$var$fl = Math.pow(2, 35), $cf61b77dbdb95489$var$hl = Math.pow(2, 42), $cf61b77dbdb95489$var$pl = Math.pow(2, 49), $cf61b77dbdb95489$var$ml = Math.pow(2, 56), $cf61b77dbdb95489$var$gl = Math.pow(2, 63), $cf61b77dbdb95489$var$bl = {
    encode: $cf61b77dbdb95489$var$tl,
    decode: $cf61b77dbdb95489$var$ol,
    encodingLength: function(e) {
        return e < $cf61b77dbdb95489$var$sl ? 1 : e < $cf61b77dbdb95489$var$ul ? 2 : e < $cf61b77dbdb95489$var$cl ? 3 : e < $cf61b77dbdb95489$var$dl ? 4 : e < $cf61b77dbdb95489$var$fl ? 5 : e < $cf61b77dbdb95489$var$hl ? 6 : e < $cf61b77dbdb95489$var$pl ? 7 : e < $cf61b77dbdb95489$var$ml ? 8 : e < $cf61b77dbdb95489$var$gl ? 9 : 10;
    }
}, $cf61b77dbdb95489$var$yl = $cf61b77dbdb95489$var$bl;
const $cf61b77dbdb95489$var$vl = (e, t, n = 0)=>($cf61b77dbdb95489$var$yl.encode(e, t, n), t), $cf61b77dbdb95489$var$Il = (e)=>$cf61b77dbdb95489$var$yl.encodingLength(e), $cf61b77dbdb95489$var$Ml = (e, t)=>{
    const n = t.byteLength, r = $cf61b77dbdb95489$var$Il(e), i = r + $cf61b77dbdb95489$var$Il(n), o = new Uint8Array(i + n);
    return $cf61b77dbdb95489$var$vl(e, o, 0), $cf61b77dbdb95489$var$vl(n, o, r), o.set(t, i), new $cf61b77dbdb95489$var$El(e, n, t, o);
};
let $cf61b77dbdb95489$var$El = class {
    constructor(e, t, n, r){
        this.code = e, this.size = t, this.digest = n, this.bytes = r;
    }
};
const $cf61b77dbdb95489$var$xl = ({ name: e, code: t, encode: n })=>new $cf61b77dbdb95489$var$Sl(e, t, n);
let $cf61b77dbdb95489$var$Sl = class {
    constructor(e, t, n){
        this.name = e, this.code = t, this.encode = n;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $cf61b77dbdb95489$var$Ml(this.code, t) : t.then((e)=>$cf61b77dbdb95489$var$Ml(this.code, e));
        }
        throw Error("Unknown type, must be binary type");
    }
};
const $cf61b77dbdb95489$var$wl = (e)=>async (t)=>new Uint8Array(await crypto.subtle.digest(e, t)), $cf61b77dbdb95489$var$kl = $cf61b77dbdb95489$var$xl({
    name: "sha2-256",
    code: 18,
    encode: $cf61b77dbdb95489$var$wl("SHA-256")
}), $cf61b77dbdb95489$var$Nl = $cf61b77dbdb95489$var$xl({
    name: "sha2-512",
    code: 19,
    encode: $cf61b77dbdb95489$var$wl("SHA-512")
});
Object.freeze({
    __proto__: null,
    sha256: $cf61b77dbdb95489$var$kl,
    sha512: $cf61b77dbdb95489$var$Nl
});
const $cf61b77dbdb95489$var$Ul = $cf61b77dbdb95489$var$va, $cf61b77dbdb95489$var$Rl = {
    code: 0,
    name: "identity",
    encode: $cf61b77dbdb95489$var$Ul,
    digest: (e)=>$cf61b77dbdb95489$var$Ml(0, $cf61b77dbdb95489$var$Ul(e))
};
Object.freeze({
    __proto__: null,
    identity: $cf61b77dbdb95489$var$Rl
});
new TextEncoder, new TextDecoder;
var $cf61b77dbdb95489$var$Ll = function(e, t) {
    if (e.length >= 255) throw new TypeError("Alphabet too long");
    for(var n = new Uint8Array(256), r = 0; r < n.length; r++)n[r] = 255;
    for(var i = 0; i < e.length; i++){
        var o = e.charAt(i), a = o.charCodeAt(0);
        if (255 !== n[a]) throw new TypeError(o + " is ambiguous");
        n[a] = i;
    }
    var l = e.length, s = e.charAt(0), u = Math.log(l) / Math.log(256), c = Math.log(256) / Math.log(l);
    function d(e) {
        if ("string" != typeof e) throw new TypeError("Expected String");
        if (0 === e.length) return new Uint8Array;
        var t = 0;
        if (" " !== e[t]) {
            for(var r = 0, i = 0; e[t] === s;)r++, t++;
            for(var o = (e.length - t) * u + 1 >>> 0, a = new Uint8Array(o); e[t];){
                var c = n[e.charCodeAt(t)];
                if (255 === c) return;
                for(var d = 0, f = o - 1; (0 !== c || d < i) && -1 !== f; f--, d++)c += l * a[f] >>> 0, a[f] = c % 256 >>> 0, c = c / 256 >>> 0;
                if (0 !== c) throw new Error("Non-zero carry");
                i = d, t++;
            }
            if (" " !== e[t]) {
                for(var h = o - i; h !== o && 0 === a[h];)h++;
                for(var p = new Uint8Array(r + (o - h)), m = r; h !== o;)p[m++] = a[h++];
                return p;
            }
        }
    }
    return {
        encode: function(t) {
            if (t instanceof Uint8Array || (ArrayBuffer.isView(t) ? t = new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : Array.isArray(t) && (t = Uint8Array.from(t))), !(t instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
            if (0 === t.length) return "";
            for(var n = 0, r = 0, i = 0, o = t.length; i !== o && 0 === t[i];)i++, n++;
            for(var a = (o - i) * c + 1 >>> 0, u = new Uint8Array(a); i !== o;){
                for(var d = t[i], f = 0, h = a - 1; (0 !== d || f < r) && -1 !== h; h--, f++)d += 256 * u[h] >>> 0, u[h] = d % l >>> 0, d = d / l >>> 0;
                if (0 !== d) throw new Error("Non-zero carry");
                r = f, i++;
            }
            for(var p = a - r; p !== a && 0 === u[p];)p++;
            for(var m = s.repeat(n); p < a; ++p)m += e.charAt(u[p]);
            return m;
        },
        decodeUnsafe: d,
        decode: function(e) {
            var n = d(e);
            if (n) return n;
            throw new Error(`Non-${t} character`);
        }
    };
}, $cf61b77dbdb95489$var$Cl = $cf61b77dbdb95489$var$Ll;
class $cf61b77dbdb95489$var$zl {
    constructor(e, t, n){
        this.name = e, this.prefix = t, this.baseEncode = n;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $cf61b77dbdb95489$var$Tl {
    constructor(e, t, n){
        if (this.name = e, this.prefix = t, void 0 === t.codePointAt(0)) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = n;
    }
    decode(e) {
        if ("string" == typeof e) {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        }
        throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $cf61b77dbdb95489$var$Fl(this, e);
    }
}
class $cf61b77dbdb95489$var$Dl {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $cf61b77dbdb95489$var$Fl(this, e);
    }
    decode(e) {
        const t = e[0], n = this.decoders[t];
        if (n) return n.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $cf61b77dbdb95489$var$Fl = (e, t)=>new $cf61b77dbdb95489$var$Dl({
        ...e.decoders || {
            [e.prefix]: e
        },
        ...t.decoders || {
            [t.prefix]: t
        }
    });
class $cf61b77dbdb95489$var$Vl {
    constructor(e, t, n, r){
        this.name = e, this.prefix = t, this.baseEncode = n, this.baseDecode = r, this.encoder = new $cf61b77dbdb95489$var$zl(e, t, n), this.decoder = new $cf61b77dbdb95489$var$Tl(e, t, r);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $cf61b77dbdb95489$var$Al = ({ name: e, prefix: t, encode: n, decode: r })=>new $cf61b77dbdb95489$var$Vl(e, t, n, r), $cf61b77dbdb95489$var$jl = ({ prefix: e, name: t, alphabet: n })=>{
    const { encode: r, decode: i } = $cf61b77dbdb95489$var$Cl(n, t);
    return $cf61b77dbdb95489$var$Al({
        prefix: e,
        name: t,
        encode: r,
        decode: (e)=>((e)=>{
                if (e instanceof Uint8Array && "Uint8Array" === e.constructor.name) return e;
                if (e instanceof ArrayBuffer) return new Uint8Array(e);
                if (ArrayBuffer.isView(e)) return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
                throw new Error("Unknown type, must be binary type");
            })(i(e))
    });
}, $cf61b77dbdb95489$var$Ol = ({ name: e, prefix: t, bitsPerChar: n, alphabet: r })=>$cf61b77dbdb95489$var$Al({
        prefix: t,
        name: e,
        encode: (e)=>((e, t, n)=>{
                const r = "=" === t[t.length - 1], i = (1 << n) - 1;
                let o = "", a = 0, l = 0;
                for(let r = 0; r < e.length; ++r)for(l = l << 8 | e[r], a += 8; a > n;)a -= n, o += t[i & l >> a];
                if (a && (o += t[i & l << n - a]), r) for(; o.length * n & 7;)o += "=";
                return o;
            })(e, r, n),
        decode: (t)=>((e, t, n, r)=>{
                const i = {};
                for(let e = 0; e < t.length; ++e)i[t[e]] = e;
                let o = e.length;
                for(; "=" === e[o - 1];)--o;
                const a = new Uint8Array(o * n / 8 | 0);
                let l = 0, s = 0, u = 0;
                for(let t = 0; t < o; ++t){
                    const o = i[e[t]];
                    if (void 0 === o) throw new SyntaxError(`Non-${r} character`);
                    s = s << n | o, l += n, l >= 8 && (l -= 8, a[u++] = 255 & s >> l);
                }
                if (l >= n || 255 & s << 8 - l) throw new SyntaxError("Unexpected end of data");
                return a;
            })(t, r, n, e)
    });
$cf61b77dbdb95489$var$Al({
    prefix: "\0",
    name: "identity",
    encode: (e)=>{
        var t;
        return t = e, (new TextDecoder).decode(t);
    },
    decode: (e)=>((e)=>(new TextEncoder).encode(e))(e)
}), $cf61b77dbdb95489$var$Ol({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
}), $cf61b77dbdb95489$var$Ol({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
}), $cf61b77dbdb95489$var$jl({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
}), $cf61b77dbdb95489$var$Ol({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $cf61b77dbdb95489$var$Ol({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
}), $cf61b77dbdb95489$var$Ol({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Ol({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Ol({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Ol({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Ol({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Ol({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Ol({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Ol({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$Ol({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
}), $cf61b77dbdb95489$var$jl({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $cf61b77dbdb95489$var$jl({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
}), $cf61b77dbdb95489$var$jl({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $cf61b77dbdb95489$var$jl({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
}), $cf61b77dbdb95489$var$Ol({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $cf61b77dbdb95489$var$Ol({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $cf61b77dbdb95489$var$Ol({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $cf61b77dbdb95489$var$Ol({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
const $cf61b77dbdb95489$var$Ql = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $cf61b77dbdb95489$var$ql = $cf61b77dbdb95489$var$Ql.reduce((e, t, n)=>(e[n] = t, e), []), $cf61b77dbdb95489$var$Wl = $cf61b77dbdb95489$var$Ql.reduce((e, t, n)=>(e[t.codePointAt(0)] = n, e), []);
$cf61b77dbdb95489$var$Al({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: function(e) {
        return e.reduce((e, t)=>e += $cf61b77dbdb95489$var$ql[t], "");
    },
    decode: function(e) {
        const t = [];
        for (const n of e){
            const e = $cf61b77dbdb95489$var$Wl[n.codePointAt(0)];
            if (void 0 === e) throw new Error(`Non-base256emoji character: ${n}`);
            t.push(e);
        }
        return new Uint8Array(t);
    }
}), new TextEncoder, new TextDecoder;
var $cf61b77dbdb95489$var$Gl, $cf61b77dbdb95489$var$Bl = {}, $cf61b77dbdb95489$var$Kl = "6.6.1", $cf61b77dbdb95489$var$Yl = {}, $cf61b77dbdb95489$var$Zl = {
    exports: {}
}, $cf61b77dbdb95489$var$Xl = $cf61b77dbdb95489$var$Zl.exports;

function $cf61b77dbdb95489$var$Pl() {
    return $cf61b77dbdb95489$var$Gl || ($cf61b77dbdb95489$var$Gl = 1, function(e, t) {
        function n(e, t) {
            if (!e) throw new Error(t || "Assertion failed");
        }
        function r(e, t) {
            e.super_ = t;
            var n = function() {};
            n.prototype = t.prototype, e.prototype = new n, e.prototype.constructor = e;
        }
        function i(e, t, n) {
            if (i.isBN(e)) return e;
            this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (n = t, t = 10), this._init(e || 0, t || 10, n || "be"));
        }
        var o;
        "object" == typeof e ? e.exports = i : t.BN = i, i.BN = i, i.wordSize = 26;
        try {
            o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : (parcelRequire("6ZWSX")).Buffer;
        } catch (e) {}
        function a(e, t) {
            var n = e.charCodeAt(t);
            return n >= 65 && n <= 70 ? n - 55 : n >= 97 && n <= 102 ? n - 87 : n - 48 & 15;
        }
        function l(e, t, n) {
            var r = a(e, n);
            return n - 1 >= t && (r |= a(e, n - 1) << 4), r;
        }
        function s(e, t, n, r) {
            for(var i = 0, o = Math.min(e.length, n), a = t; a < o; a++){
                var l = e.charCodeAt(a) - 48;
                i *= r, i += l >= 49 ? l - 49 + 10 : l >= 17 ? l - 17 + 10 : l;
            }
            return i;
        }
        i.isBN = function(e) {
            return e instanceof i || null !== e && "object" == typeof e && e.constructor.wordSize === i.wordSize && Array.isArray(e.words);
        }, i.max = function(e, t) {
            return e.cmp(t) > 0 ? e : t;
        }, i.min = function(e, t) {
            return e.cmp(t) < 0 ? e : t;
        }, i.prototype._init = function(e, t, r) {
            if ("number" == typeof e) return this._initNumber(e, t, r);
            if ("object" == typeof e) return this._initArray(e, t, r);
            "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
            var i = 0;
            "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
        }, i.prototype._initNumber = function(e, t, r) {
            e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                67108863 & e
            ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                67108863 & e,
                e / 67108864 & 67108863
            ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                67108863 & e,
                e / 67108864 & 67108863,
                1
            ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
        }, i.prototype._initArray = function(e, t, r) {
            if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                0
            ], this.length = 1, this;
            this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var o, a, l = 0;
            if ("be" === r) for(i = e.length - 1, o = 0; i >= 0; i -= 3)a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << l & 67108863, this.words[o + 1] = a >>> 26 - l & 67108863, (l += 24) >= 26 && (l -= 26, o++);
            else if ("le" === r) for(i = 0, o = 0; i < e.length; i += 3)a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << l & 67108863, this.words[o + 1] = a >>> 26 - l & 67108863, (l += 24) >= 26 && (l -= 26, o++);
            return this.strip();
        }, i.prototype._parseHex = function(e, t, n) {
            this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
            for(var r = 0; r < this.length; r++)this.words[r] = 0;
            var i, o = 0, a = 0;
            if ("be" === n) for(r = e.length - 1; r >= t; r -= 2)i = l(e, t, r) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
            else for(r = (e.length - t) % 2 == 0 ? t + 1 : t; r < e.length; r += 2)i = l(e, t, r) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
            this.strip();
        }, i.prototype._parseBase = function(e, t, n) {
            this.words = [
                0
            ], this.length = 1;
            for(var r = 0, i = 1; i <= 67108863; i *= t)r++;
            r--, i = i / t | 0;
            for(var o = e.length - n, a = o % r, l = Math.min(o, o - a) + n, u = 0, c = n; c < l; c += r)u = s(e, c, c + r, t), this.imuln(i), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
            if (0 !== a) {
                var d = 1;
                for(u = s(e, c, e.length, t), c = 0; c < a; c++)d *= t;
                this.imuln(d), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
            }
            this.strip();
        }, i.prototype.copy = function(e) {
            e.words = new Array(this.length);
            for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
            e.length = this.length, e.negative = this.negative, e.red = this.red;
        }, i.prototype.clone = function() {
            var e = new i(null);
            return this.copy(e), e;
        }, i.prototype._expand = function(e) {
            for(; this.length < e;)this.words[this.length++] = 0;
            return this;
        }, i.prototype.strip = function() {
            for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
            return this._normSign();
        }, i.prototype._normSign = function() {
            return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
        }, i.prototype.inspect = function() {
            return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        };
        var u = [
            "",
            "0",
            "00",
            "000",
            "0000",
            "00000",
            "000000",
            "0000000",
            "00000000",
            "000000000",
            "0000000000",
            "00000000000",
            "000000000000",
            "0000000000000",
            "00000000000000",
            "000000000000000",
            "0000000000000000",
            "00000000000000000",
            "000000000000000000",
            "0000000000000000000",
            "00000000000000000000",
            "000000000000000000000",
            "0000000000000000000000",
            "00000000000000000000000",
            "000000000000000000000000",
            "0000000000000000000000000"
        ], c = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ], d = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            1e7,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64e6,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            243e5,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        function f(e, t, n) {
            n.negative = t.negative ^ e.negative;
            var r = e.length + t.length | 0;
            n.length = r, r = r - 1 | 0;
            var i = 0 | e.words[0], o = 0 | t.words[0], a = i * o, l = 67108863 & a, s = a / 67108864 | 0;
            n.words[0] = l;
            for(var u = 1; u < r; u++){
                for(var c = s >>> 26, d = 67108863 & s, f = Math.min(u, t.length - 1), h = Math.max(0, u - e.length + 1); h <= f; h++){
                    var p = u - h | 0;
                    c += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[h]) + d) / 67108864 | 0, d = 67108863 & a;
                }
                n.words[u] = 0 | d, s = 0 | c;
            }
            return 0 !== s ? n.words[u] = 0 | s : n.length--, n.strip();
        }
        i.prototype.toString = function(e, t) {
            var r;
            if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                r = "";
                for(var i = 0, o = 0, a = 0; a < this.length; a++){
                    var l = this.words[a], s = (16777215 & (l << i | o)).toString(16);
                    o = l >>> 24 - i & 16777215, (i += 2) >= 26 && (i -= 26, a--), r = 0 !== o || a !== this.length - 1 ? u[6 - s.length] + s + r : s + r;
                }
                for(0 !== o && (r = o.toString(16) + r); r.length % t !== 0;)r = "0" + r;
                return 0 !== this.negative && (r = "-" + r), r;
            }
            if (e === (0 | e) && e >= 2 && e <= 36) {
                var f = c[e], h = d[e];
                r = "";
                var p = this.clone();
                for(p.negative = 0; !p.isZero();){
                    var m = p.modn(h).toString(e);
                    r = (p = p.idivn(h)).isZero() ? m + r : u[f - m.length] + m + r;
                }
                for(this.isZero() && (r = "0" + r); r.length % t !== 0;)r = "0" + r;
                return 0 !== this.negative && (r = "-" + r), r;
            }
            n(!1, "Base should be between 2 and 36");
        }, i.prototype.toNumber = function() {
            var e = this.words[0];
            return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
        }, i.prototype.toJSON = function() {
            return this.toString(16);
        }, i.prototype.toBuffer = function(e, t) {
            return n(void 0 !== o), this.toArrayLike(o, e, t);
        }, i.prototype.toArray = function(e, t) {
            return this.toArrayLike(Array, e, t);
        }, i.prototype.toArrayLike = function(e, t, r) {
            var i = this.byteLength(), o = r || Math.max(1, i);
            n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0"), this.strip();
            var a, l, s = "le" === t, u = new e(o), c = this.clone();
            if (s) {
                for(l = 0; !c.isZero(); l++)a = c.andln(255), c.iushrn(8), u[l] = a;
                for(; l < o; l++)u[l] = 0;
            } else {
                for(l = 0; l < o - i; l++)u[l] = 0;
                for(l = 0; !c.isZero(); l++)a = c.andln(255), c.iushrn(8), u[o - l - 1] = a;
            }
            return u;
        }, Math.clz32 ? i.prototype._countBits = function(e) {
            return 32 - Math.clz32(e);
        } : i.prototype._countBits = function(e) {
            var t = e, n = 0;
            return t >= 4096 && (n += 13, t >>>= 13), t >= 64 && (n += 7, t >>>= 7), t >= 8 && (n += 4, t >>>= 4), t >= 2 && (n += 2, t >>>= 2), n + t;
        }, i.prototype._zeroBits = function(e) {
            if (0 === e) return 26;
            var t = e, n = 0;
            return 8191 & t || (n += 13, t >>>= 13), 127 & t || (n += 7, t >>>= 7), 15 & t || (n += 4, t >>>= 4), 3 & t || (n += 2, t >>>= 2), 1 & t || n++, n;
        }, i.prototype.bitLength = function() {
            var e = this.words[this.length - 1], t = this._countBits(e);
            return 26 * (this.length - 1) + t;
        }, i.prototype.zeroBits = function() {
            if (this.isZero()) return 0;
            for(var e = 0, t = 0; t < this.length; t++){
                var n = this._zeroBits(this.words[t]);
                if (e += n, 26 !== n) break;
            }
            return e;
        }, i.prototype.byteLength = function() {
            return Math.ceil(this.bitLength() / 8);
        }, i.prototype.toTwos = function(e) {
            return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
        }, i.prototype.fromTwos = function(e) {
            return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
        }, i.prototype.isNeg = function() {
            return 0 !== this.negative;
        }, i.prototype.neg = function() {
            return this.clone().ineg();
        }, i.prototype.ineg = function() {
            return this.isZero() || (this.negative ^= 1), this;
        }, i.prototype.iuor = function(e) {
            for(; this.length < e.length;)this.words[this.length++] = 0;
            for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
            return this.strip();
        }, i.prototype.ior = function(e) {
            return n(0 === (this.negative | e.negative)), this.iuor(e);
        }, i.prototype.or = function(e) {
            return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
        }, i.prototype.uor = function(e) {
            return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
        }, i.prototype.iuand = function(e) {
            var t;
            t = this.length > e.length ? e : this;
            for(var n = 0; n < t.length; n++)this.words[n] = this.words[n] & e.words[n];
            return this.length = t.length, this.strip();
        }, i.prototype.iand = function(e) {
            return n(0 === (this.negative | e.negative)), this.iuand(e);
        }, i.prototype.and = function(e) {
            return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
        }, i.prototype.uand = function(e) {
            return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
        }, i.prototype.iuxor = function(e) {
            var t, n;
            this.length > e.length ? (t = this, n = e) : (t = e, n = this);
            for(var r = 0; r < n.length; r++)this.words[r] = t.words[r] ^ n.words[r];
            if (this !== t) for(; r < t.length; r++)this.words[r] = t.words[r];
            return this.length = t.length, this.strip();
        }, i.prototype.ixor = function(e) {
            return n(0 === (this.negative | e.negative)), this.iuxor(e);
        }, i.prototype.xor = function(e) {
            return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
        }, i.prototype.uxor = function(e) {
            return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
        }, i.prototype.inotn = function(e) {
            n("number" == typeof e && e >= 0);
            var t = 0 | Math.ceil(e / 26), r = e % 26;
            this._expand(t), r > 0 && t--;
            for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
            return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
        }, i.prototype.notn = function(e) {
            return this.clone().inotn(e);
        }, i.prototype.setn = function(e, t) {
            n("number" == typeof e && e >= 0);
            var r = e / 26 | 0, i = e % 26;
            return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
        }, i.prototype.iadd = function(e) {
            var t, n, r;
            if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
            if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
            this.length > e.length ? (n = this, r = e) : (n = e, r = this);
            for(var i = 0, o = 0; o < r.length; o++)t = (0 | n.words[o]) + (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
            for(; 0 !== i && o < n.length; o++)t = (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
            if (this.length = n.length, 0 !== i) this.words[this.length] = i, this.length++;
            else if (n !== this) for(; o < n.length; o++)this.words[o] = n.words[o];
            return this;
        }, i.prototype.add = function(e) {
            var t;
            return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
        }, i.prototype.isub = function(e) {
            if (0 !== e.negative) {
                e.negative = 0;
                var t = this.iadd(e);
                return e.negative = 1, t._normSign();
            }
            if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
            var n, r, i = this.cmp(e);
            if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
            i > 0 ? (n = this, r = e) : (n = e, r = this);
            for(var o = 0, a = 0; a < r.length; a++)o = (t = (0 | n.words[a]) - (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
            for(; 0 !== o && a < n.length; a++)o = (t = (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
            if (0 === o && a < n.length && n !== this) for(; a < n.length; a++)this.words[a] = n.words[a];
            return this.length = Math.max(this.length, a), n !== this && (this.negative = 1), this.strip();
        }, i.prototype.sub = function(e) {
            return this.clone().isub(e);
        };
        var h = function(e, t, n) {
            var r, i, o, a = e.words, l = t.words, s = n.words, u = 0, c = 0 | a[0], d = 8191 & c, f = c >>> 13, h = 0 | a[1], p = 8191 & h, m = h >>> 13, g = 0 | a[2], b = 8191 & g, y = g >>> 13, v = 0 | a[3], I = 8191 & v, M = v >>> 13, E = 0 | a[4], x = 8191 & E, S = E >>> 13, w = 0 | a[5], k = 8191 & w, N = w >>> 13, U = 0 | a[6], R = 8191 & U, L = U >>> 13, C = 0 | a[7], z = 8191 & C, T = C >>> 13, D = 0 | a[8], F = 8191 & D, V = D >>> 13, A = 0 | a[9], j = 8191 & A, O = A >>> 13, Q = 0 | l[0], q = 8191 & Q, W = Q >>> 13, G = 0 | l[1], B = 8191 & G, K = G >>> 13, Y = 0 | l[2], Z = 8191 & Y, X = Y >>> 13, P = 0 | l[3], J = 8191 & P, H = P >>> 13, _ = 0 | l[4], $ = 8191 & _, ee = _ >>> 13, te = 0 | l[5], ne = 8191 & te, re = te >>> 13, ie = 0 | l[6], oe = 8191 & ie, ae = ie >>> 13, le = 0 | l[7], se = 8191 & le, ue = le >>> 13, ce = 0 | l[8], de = 8191 & ce, fe = ce >>> 13, he = 0 | l[9], pe = 8191 & he, me = he >>> 13;
            n.negative = e.negative ^ t.negative, n.length = 19;
            var ge = (u + (r = Math.imul(d, q)) | 0) + ((8191 & (i = (i = Math.imul(d, W)) + Math.imul(f, q) | 0)) << 13) | 0;
            u = ((o = Math.imul(f, W)) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, r = Math.imul(p, q), i = (i = Math.imul(p, W)) + Math.imul(m, q) | 0, o = Math.imul(m, W);
            var be = (u + (r = r + Math.imul(d, B) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, K) | 0) + Math.imul(f, B) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, r = Math.imul(b, q), i = (i = Math.imul(b, W)) + Math.imul(y, q) | 0, o = Math.imul(y, W), r = r + Math.imul(p, B) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, B) | 0, o = o + Math.imul(m, K) | 0;
            var ye = (u + (r = r + Math.imul(d, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, X) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(f, X) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, r = Math.imul(I, q), i = (i = Math.imul(I, W)) + Math.imul(M, q) | 0, o = Math.imul(M, W), r = r + Math.imul(b, B) | 0, i = (i = i + Math.imul(b, K) | 0) + Math.imul(y, B) | 0, o = o + Math.imul(y, K) | 0, r = r + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(m, Z) | 0, o = o + Math.imul(m, X) | 0;
            var ve = (u + (r = r + Math.imul(d, J) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, H) | 0) + Math.imul(f, J) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(f, H) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, r = Math.imul(x, q), i = (i = Math.imul(x, W)) + Math.imul(S, q) | 0, o = Math.imul(S, W), r = r + Math.imul(I, B) | 0, i = (i = i + Math.imul(I, K) | 0) + Math.imul(M, B) | 0, o = o + Math.imul(M, K) | 0, r = r + Math.imul(b, Z) | 0, i = (i = i + Math.imul(b, X) | 0) + Math.imul(y, Z) | 0, o = o + Math.imul(y, X) | 0, r = r + Math.imul(p, J) | 0, i = (i = i + Math.imul(p, H) | 0) + Math.imul(m, J) | 0, o = o + Math.imul(m, H) | 0;
            var Ie = (u + (r = r + Math.imul(d, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(f, $) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, r = Math.imul(k, q), i = (i = Math.imul(k, W)) + Math.imul(N, q) | 0, o = Math.imul(N, W), r = r + Math.imul(x, B) | 0, i = (i = i + Math.imul(x, K) | 0) + Math.imul(S, B) | 0, o = o + Math.imul(S, K) | 0, r = r + Math.imul(I, Z) | 0, i = (i = i + Math.imul(I, X) | 0) + Math.imul(M, Z) | 0, o = o + Math.imul(M, X) | 0, r = r + Math.imul(b, J) | 0, i = (i = i + Math.imul(b, H) | 0) + Math.imul(y, J) | 0, o = o + Math.imul(y, H) | 0, r = r + Math.imul(p, $) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, $) | 0, o = o + Math.imul(m, ee) | 0;
            var Me = (u + (r = r + Math.imul(d, ne) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, re) | 0) + Math.imul(f, ne) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(f, re) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, r = Math.imul(R, q), i = (i = Math.imul(R, W)) + Math.imul(L, q) | 0, o = Math.imul(L, W), r = r + Math.imul(k, B) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(N, B) | 0, o = o + Math.imul(N, K) | 0, r = r + Math.imul(x, Z) | 0, i = (i = i + Math.imul(x, X) | 0) + Math.imul(S, Z) | 0, o = o + Math.imul(S, X) | 0, r = r + Math.imul(I, J) | 0, i = (i = i + Math.imul(I, H) | 0) + Math.imul(M, J) | 0, o = o + Math.imul(M, H) | 0, r = r + Math.imul(b, $) | 0, i = (i = i + Math.imul(b, ee) | 0) + Math.imul(y, $) | 0, o = o + Math.imul(y, ee) | 0, r = r + Math.imul(p, ne) | 0, i = (i = i + Math.imul(p, re) | 0) + Math.imul(m, ne) | 0, o = o + Math.imul(m, re) | 0;
            var Ee = (u + (r = r + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ae) | 0) + Math.imul(f, oe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(f, ae) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, r = Math.imul(z, q), i = (i = Math.imul(z, W)) + Math.imul(T, q) | 0, o = Math.imul(T, W), r = r + Math.imul(R, B) | 0, i = (i = i + Math.imul(R, K) | 0) + Math.imul(L, B) | 0, o = o + Math.imul(L, K) | 0, r = r + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, X) | 0) + Math.imul(N, Z) | 0, o = o + Math.imul(N, X) | 0, r = r + Math.imul(x, J) | 0, i = (i = i + Math.imul(x, H) | 0) + Math.imul(S, J) | 0, o = o + Math.imul(S, H) | 0, r = r + Math.imul(I, $) | 0, i = (i = i + Math.imul(I, ee) | 0) + Math.imul(M, $) | 0, o = o + Math.imul(M, ee) | 0, r = r + Math.imul(b, ne) | 0, i = (i = i + Math.imul(b, re) | 0) + Math.imul(y, ne) | 0, o = o + Math.imul(y, re) | 0, r = r + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, ae) | 0;
            var xe = (u + (r = r + Math.imul(d, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ue) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(f, ue) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, r = Math.imul(F, q), i = (i = Math.imul(F, W)) + Math.imul(V, q) | 0, o = Math.imul(V, W), r = r + Math.imul(z, B) | 0, i = (i = i + Math.imul(z, K) | 0) + Math.imul(T, B) | 0, o = o + Math.imul(T, K) | 0, r = r + Math.imul(R, Z) | 0, i = (i = i + Math.imul(R, X) | 0) + Math.imul(L, Z) | 0, o = o + Math.imul(L, X) | 0, r = r + Math.imul(k, J) | 0, i = (i = i + Math.imul(k, H) | 0) + Math.imul(N, J) | 0, o = o + Math.imul(N, H) | 0, r = r + Math.imul(x, $) | 0, i = (i = i + Math.imul(x, ee) | 0) + Math.imul(S, $) | 0, o = o + Math.imul(S, ee) | 0, r = r + Math.imul(I, ne) | 0, i = (i = i + Math.imul(I, re) | 0) + Math.imul(M, ne) | 0, o = o + Math.imul(M, re) | 0, r = r + Math.imul(b, oe) | 0, i = (i = i + Math.imul(b, ae) | 0) + Math.imul(y, oe) | 0, o = o + Math.imul(y, ae) | 0, r = r + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, ue) | 0) + Math.imul(m, se) | 0, o = o + Math.imul(m, ue) | 0;
            var Se = (u + (r = r + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, fe) | 0) + Math.imul(f, de) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, r = Math.imul(j, q), i = (i = Math.imul(j, W)) + Math.imul(O, q) | 0, o = Math.imul(O, W), r = r + Math.imul(F, B) | 0, i = (i = i + Math.imul(F, K) | 0) + Math.imul(V, B) | 0, o = o + Math.imul(V, K) | 0, r = r + Math.imul(z, Z) | 0, i = (i = i + Math.imul(z, X) | 0) + Math.imul(T, Z) | 0, o = o + Math.imul(T, X) | 0, r = r + Math.imul(R, J) | 0, i = (i = i + Math.imul(R, H) | 0) + Math.imul(L, J) | 0, o = o + Math.imul(L, H) | 0, r = r + Math.imul(k, $) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(N, $) | 0, o = o + Math.imul(N, ee) | 0, r = r + Math.imul(x, ne) | 0, i = (i = i + Math.imul(x, re) | 0) + Math.imul(S, ne) | 0, o = o + Math.imul(S, re) | 0, r = r + Math.imul(I, oe) | 0, i = (i = i + Math.imul(I, ae) | 0) + Math.imul(M, oe) | 0, o = o + Math.imul(M, ae) | 0, r = r + Math.imul(b, se) | 0, i = (i = i + Math.imul(b, ue) | 0) + Math.imul(y, se) | 0, o = o + Math.imul(y, ue) | 0, r = r + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, de) | 0, o = o + Math.imul(m, fe) | 0;
            var we = (u + (r = r + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, r = Math.imul(j, B), i = (i = Math.imul(j, K)) + Math.imul(O, B) | 0, o = Math.imul(O, K), r = r + Math.imul(F, Z) | 0, i = (i = i + Math.imul(F, X) | 0) + Math.imul(V, Z) | 0, o = o + Math.imul(V, X) | 0, r = r + Math.imul(z, J) | 0, i = (i = i + Math.imul(z, H) | 0) + Math.imul(T, J) | 0, o = o + Math.imul(T, H) | 0, r = r + Math.imul(R, $) | 0, i = (i = i + Math.imul(R, ee) | 0) + Math.imul(L, $) | 0, o = o + Math.imul(L, ee) | 0, r = r + Math.imul(k, ne) | 0, i = (i = i + Math.imul(k, re) | 0) + Math.imul(N, ne) | 0, o = o + Math.imul(N, re) | 0, r = r + Math.imul(x, oe) | 0, i = (i = i + Math.imul(x, ae) | 0) + Math.imul(S, oe) | 0, o = o + Math.imul(S, ae) | 0, r = r + Math.imul(I, se) | 0, i = (i = i + Math.imul(I, ue) | 0) + Math.imul(M, se) | 0, o = o + Math.imul(M, ue) | 0, r = r + Math.imul(b, de) | 0, i = (i = i + Math.imul(b, fe) | 0) + Math.imul(y, de) | 0, o = o + Math.imul(y, fe) | 0;
            var ke = (u + (r = r + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, r = Math.imul(j, Z), i = (i = Math.imul(j, X)) + Math.imul(O, Z) | 0, o = Math.imul(O, X), r = r + Math.imul(F, J) | 0, i = (i = i + Math.imul(F, H) | 0) + Math.imul(V, J) | 0, o = o + Math.imul(V, H) | 0, r = r + Math.imul(z, $) | 0, i = (i = i + Math.imul(z, ee) | 0) + Math.imul(T, $) | 0, o = o + Math.imul(T, ee) | 0, r = r + Math.imul(R, ne) | 0, i = (i = i + Math.imul(R, re) | 0) + Math.imul(L, ne) | 0, o = o + Math.imul(L, re) | 0, r = r + Math.imul(k, oe) | 0, i = (i = i + Math.imul(k, ae) | 0) + Math.imul(N, oe) | 0, o = o + Math.imul(N, ae) | 0, r = r + Math.imul(x, se) | 0, i = (i = i + Math.imul(x, ue) | 0) + Math.imul(S, se) | 0, o = o + Math.imul(S, ue) | 0, r = r + Math.imul(I, de) | 0, i = (i = i + Math.imul(I, fe) | 0) + Math.imul(M, de) | 0, o = o + Math.imul(M, fe) | 0;
            var Ne = (u + (r = r + Math.imul(b, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(b, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, r = Math.imul(j, J), i = (i = Math.imul(j, H)) + Math.imul(O, J) | 0, o = Math.imul(O, H), r = r + Math.imul(F, $) | 0, i = (i = i + Math.imul(F, ee) | 0) + Math.imul(V, $) | 0, o = o + Math.imul(V, ee) | 0, r = r + Math.imul(z, ne) | 0, i = (i = i + Math.imul(z, re) | 0) + Math.imul(T, ne) | 0, o = o + Math.imul(T, re) | 0, r = r + Math.imul(R, oe) | 0, i = (i = i + Math.imul(R, ae) | 0) + Math.imul(L, oe) | 0, o = o + Math.imul(L, ae) | 0, r = r + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, ue) | 0) + Math.imul(N, se) | 0, o = o + Math.imul(N, ue) | 0, r = r + Math.imul(x, de) | 0, i = (i = i + Math.imul(x, fe) | 0) + Math.imul(S, de) | 0, o = o + Math.imul(S, fe) | 0;
            var Ue = (u + (r = r + Math.imul(I, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(I, me) | 0) + Math.imul(M, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(M, me) | 0) + (i >>> 13) | 0) + (Ue >>> 26) | 0, Ue &= 67108863, r = Math.imul(j, $), i = (i = Math.imul(j, ee)) + Math.imul(O, $) | 0, o = Math.imul(O, ee), r = r + Math.imul(F, ne) | 0, i = (i = i + Math.imul(F, re) | 0) + Math.imul(V, ne) | 0, o = o + Math.imul(V, re) | 0, r = r + Math.imul(z, oe) | 0, i = (i = i + Math.imul(z, ae) | 0) + Math.imul(T, oe) | 0, o = o + Math.imul(T, ae) | 0, r = r + Math.imul(R, se) | 0, i = (i = i + Math.imul(R, ue) | 0) + Math.imul(L, se) | 0, o = o + Math.imul(L, ue) | 0, r = r + Math.imul(k, de) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(N, de) | 0, o = o + Math.imul(N, fe) | 0;
            var Re = (u + (r = r + Math.imul(x, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(x, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, r = Math.imul(j, ne), i = (i = Math.imul(j, re)) + Math.imul(O, ne) | 0, o = Math.imul(O, re), r = r + Math.imul(F, oe) | 0, i = (i = i + Math.imul(F, ae) | 0) + Math.imul(V, oe) | 0, o = o + Math.imul(V, ae) | 0, r = r + Math.imul(z, se) | 0, i = (i = i + Math.imul(z, ue) | 0) + Math.imul(T, se) | 0, o = o + Math.imul(T, ue) | 0, r = r + Math.imul(R, de) | 0, i = (i = i + Math.imul(R, fe) | 0) + Math.imul(L, de) | 0, o = o + Math.imul(L, fe) | 0;
            var Le = (u + (r = r + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(N, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(N, me) | 0) + (i >>> 13) | 0) + (Le >>> 26) | 0, Le &= 67108863, r = Math.imul(j, oe), i = (i = Math.imul(j, ae)) + Math.imul(O, oe) | 0, o = Math.imul(O, ae), r = r + Math.imul(F, se) | 0, i = (i = i + Math.imul(F, ue) | 0) + Math.imul(V, se) | 0, o = o + Math.imul(V, ue) | 0, r = r + Math.imul(z, de) | 0, i = (i = i + Math.imul(z, fe) | 0) + Math.imul(T, de) | 0, o = o + Math.imul(T, fe) | 0;
            var Ce = (u + (r = r + Math.imul(R, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(R, me) | 0) + Math.imul(L, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(L, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, r = Math.imul(j, se), i = (i = Math.imul(j, ue)) + Math.imul(O, se) | 0, o = Math.imul(O, ue), r = r + Math.imul(F, de) | 0, i = (i = i + Math.imul(F, fe) | 0) + Math.imul(V, de) | 0, o = o + Math.imul(V, fe) | 0;
            var ze = (u + (r = r + Math.imul(z, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(z, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (ze >>> 26) | 0, ze &= 67108863, r = Math.imul(j, de), i = (i = Math.imul(j, fe)) + Math.imul(O, de) | 0, o = Math.imul(O, fe);
            var Te = (u + (r = r + Math.imul(F, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(F, me) | 0) + Math.imul(V, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(V, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863;
            var De = (u + (r = Math.imul(j, pe)) | 0) + ((8191 & (i = (i = Math.imul(j, me)) + Math.imul(O, pe) | 0)) << 13) | 0;
            return u = ((o = Math.imul(O, me)) + (i >>> 13) | 0) + (De >>> 26) | 0, De &= 67108863, s[0] = ge, s[1] = be, s[2] = ye, s[3] = ve, s[4] = Ie, s[5] = Me, s[6] = Ee, s[7] = xe, s[8] = Se, s[9] = we, s[10] = ke, s[11] = Ne, s[12] = Ue, s[13] = Re, s[14] = Le, s[15] = Ce, s[16] = ze, s[17] = Te, s[18] = De, 0 !== u && (s[19] = u, n.length++), n;
        };
        function p(e, t, n) {
            return (new m).mulp(e, t, n);
        }
        function m(e, t) {
            this.x = e, this.y = t;
        }
        Math.imul || (h = f), i.prototype.mulTo = function(e, t) {
            var n, r = this.length + e.length;
            return n = 10 === this.length && 10 === e.length ? h(this, e, t) : r < 63 ? f(this, e, t) : r < 1024 ? function(e, t, n) {
                n.negative = t.negative ^ e.negative, n.length = e.length + t.length;
                for(var r = 0, i = 0, o = 0; o < n.length - 1; o++){
                    var a = i;
                    i = 0;
                    for(var l = 67108863 & r, s = Math.min(o, t.length - 1), u = Math.max(0, o - e.length + 1); u <= s; u++){
                        var c = o - u, d = (0 | e.words[c]) * (0 | t.words[u]), f = 67108863 & d;
                        l = 67108863 & (f = f + l | 0), i += (a = (a = a + (d / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, a &= 67108863;
                    }
                    n.words[o] = l, r = a, a = i;
                }
                return 0 !== r ? n.words[o] = r : n.length--, n.strip();
            }(this, e, t) : p(this, e, t), n;
        }, m.prototype.makeRBT = function(e) {
            for(var t = new Array(e), n = i.prototype._countBits(e) - 1, r = 0; r < e; r++)t[r] = this.revBin(r, n, e);
            return t;
        }, m.prototype.revBin = function(e, t, n) {
            if (0 === e || e === n - 1) return e;
            for(var r = 0, i = 0; i < t; i++)r |= (1 & e) << t - i - 1, e >>= 1;
            return r;
        }, m.prototype.permute = function(e, t, n, r, i, o) {
            for(var a = 0; a < o; a++)r[a] = t[e[a]], i[a] = n[e[a]];
        }, m.prototype.transform = function(e, t, n, r, i, o) {
            this.permute(o, e, t, n, r, i);
            for(var a = 1; a < i; a <<= 1)for(var l = a << 1, s = Math.cos(2 * Math.PI / l), u = Math.sin(2 * Math.PI / l), c = 0; c < i; c += l)for(var d = s, f = u, h = 0; h < a; h++){
                var p = n[c + h], m = r[c + h], g = n[c + h + a], b = r[c + h + a], y = d * g - f * b;
                b = d * b + f * g, g = y, n[c + h] = p + g, r[c + h] = m + b, n[c + h + a] = p - g, r[c + h + a] = m - b, h !== l && (y = s * d - u * f, f = s * f + u * d, d = y);
            }
        }, m.prototype.guessLen13b = function(e, t) {
            var n = 1 | Math.max(t, e), r = 1 & n, i = 0;
            for(n = n / 2 | 0; n; n >>>= 1)i++;
            return 1 << i + 1 + r;
        }, m.prototype.conjugate = function(e, t, n) {
            if (!(n <= 1)) for(var r = 0; r < n / 2; r++){
                var i = e[r];
                e[r] = e[n - r - 1], e[n - r - 1] = i, i = t[r], t[r] = -t[n - r - 1], t[n - r - 1] = -i;
            }
        }, m.prototype.normalize13b = function(e, t) {
            for(var n = 0, r = 0; r < t / 2; r++){
                var i = 8192 * Math.round(e[2 * r + 1] / t) + Math.round(e[2 * r] / t) + n;
                e[r] = 67108863 & i, n = i < 67108864 ? 0 : i / 67108864 | 0;
            }
            return e;
        }, m.prototype.convert13b = function(e, t, r, i) {
            for(var o = 0, a = 0; a < t; a++)o += 0 | e[a], r[2 * a] = 8191 & o, o >>>= 13, r[2 * a + 1] = 8191 & o, o >>>= 13;
            for(a = 2 * t; a < i; ++a)r[a] = 0;
            n(0 === o), n(!(-8192 & o));
        }, m.prototype.stub = function(e) {
            for(var t = new Array(e), n = 0; n < e; n++)t[n] = 0;
            return t;
        }, m.prototype.mulp = function(e, t, n) {
            var r = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(r), o = this.stub(r), a = new Array(r), l = new Array(r), s = new Array(r), u = new Array(r), c = new Array(r), d = new Array(r), f = n.words;
            f.length = r, this.convert13b(e.words, e.length, a, r), this.convert13b(t.words, t.length, u, r), this.transform(a, o, l, s, r, i), this.transform(u, o, c, d, r, i);
            for(var h = 0; h < r; h++){
                var p = l[h] * c[h] - s[h] * d[h];
                s[h] = l[h] * d[h] + s[h] * c[h], l[h] = p;
            }
            return this.conjugate(l, s, r), this.transform(l, s, f, o, r, i), this.conjugate(f, o, r), this.normalize13b(f, r), n.negative = e.negative ^ t.negative, n.length = e.length + t.length, n.strip();
        }, i.prototype.mul = function(e) {
            var t = new i(null);
            return t.words = new Array(this.length + e.length), this.mulTo(e, t);
        }, i.prototype.mulf = function(e) {
            var t = new i(null);
            return t.words = new Array(this.length + e.length), p(this, e, t);
        }, i.prototype.imul = function(e) {
            return this.clone().mulTo(e, this);
        }, i.prototype.imuln = function(e) {
            n("number" == typeof e), n(e < 67108864);
            for(var t = 0, r = 0; r < this.length; r++){
                var i = (0 | this.words[r]) * e, o = (67108863 & i) + (67108863 & t);
                t >>= 26, t += i / 67108864 | 0, t += o >>> 26, this.words[r] = 67108863 & o;
            }
            return 0 !== t && (this.words[r] = t, this.length++), this.length = 0 === e ? 1 : this.length, this;
        }, i.prototype.muln = function(e) {
            return this.clone().imuln(e);
        }, i.prototype.sqr = function() {
            return this.mul(this);
        }, i.prototype.isqr = function() {
            return this.imul(this.clone());
        }, i.prototype.pow = function(e) {
            var t = function(e) {
                for(var t = new Array(e.bitLength()), n = 0; n < t.length; n++){
                    var r = n / 26 | 0, i = n % 26;
                    t[n] = (e.words[r] & 1 << i) >>> i;
                }
                return t;
            }(e);
            if (0 === t.length) return new i(1);
            for(var n = this, r = 0; r < t.length && 0 === t[r]; r++, n = n.sqr());
            if (++r < t.length) for(var o = n.sqr(); r < t.length; r++, o = o.sqr())0 !== t[r] && (n = n.mul(o));
            return n;
        }, i.prototype.iushln = function(e) {
            n("number" == typeof e && e >= 0);
            var t, r = e % 26, i = (e - r) / 26, o = 67108863 >>> 26 - r << 26 - r;
            if (0 !== r) {
                var a = 0;
                for(t = 0; t < this.length; t++){
                    var l = this.words[t] & o, s = (0 | this.words[t]) - l << r;
                    this.words[t] = s | a, a = l >>> 26 - r;
                }
                a && (this.words[t] = a, this.length++);
            }
            if (0 !== i) {
                for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                for(t = 0; t < i; t++)this.words[t] = 0;
                this.length += i;
            }
            return this.strip();
        }, i.prototype.ishln = function(e) {
            return n(0 === this.negative), this.iushln(e);
        }, i.prototype.iushrn = function(e, t, r) {
            var i;
            n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
            var o = e % 26, a = Math.min((e - o) / 26, this.length), l = 67108863 ^ 67108863 >>> o << o, s = r;
            if (i -= a, i = Math.max(0, i), s) {
                for(var u = 0; u < a; u++)s.words[u] = this.words[u];
                s.length = a;
            }
            if (0 === a) ;
            else if (this.length > a) for(this.length -= a, u = 0; u < this.length; u++)this.words[u] = this.words[u + a];
            else this.words[0] = 0, this.length = 1;
            var c = 0;
            for(u = this.length - 1; u >= 0 && (0 !== c || u >= i); u--){
                var d = 0 | this.words[u];
                this.words[u] = c << 26 - o | d >>> o, c = d & l;
            }
            return s && 0 !== c && (s.words[s.length++] = c), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
        }, i.prototype.ishrn = function(e, t, r) {
            return n(0 === this.negative), this.iushrn(e, t, r);
        }, i.prototype.shln = function(e) {
            return this.clone().ishln(e);
        }, i.prototype.ushln = function(e) {
            return this.clone().iushln(e);
        }, i.prototype.shrn = function(e) {
            return this.clone().ishrn(e);
        }, i.prototype.ushrn = function(e) {
            return this.clone().iushrn(e);
        }, i.prototype.testn = function(e) {
            n("number" == typeof e && e >= 0);
            var t = e % 26, r = (e - t) / 26, i = 1 << t;
            return !(this.length <= r || !(this.words[r] & i));
        }, i.prototype.imaskn = function(e) {
            n("number" == typeof e && e >= 0);
            var t = e % 26, r = (e - t) / 26;
            if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
            if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                var i = 67108863 ^ 67108863 >>> t << t;
                this.words[this.length - 1] &= i;
            }
            return this.strip();
        }, i.prototype.maskn = function(e) {
            return this.clone().imaskn(e);
        }, i.prototype.iaddn = function(e) {
            return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
        }, i.prototype._iaddn = function(e) {
            this.words[0] += e;
            for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
            return this.length = Math.max(this.length, t + 1), this;
        }, i.prototype.isubn = function(e) {
            if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
            if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
            if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
            else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
            return this.strip();
        }, i.prototype.addn = function(e) {
            return this.clone().iaddn(e);
        }, i.prototype.subn = function(e) {
            return this.clone().isubn(e);
        }, i.prototype.iabs = function() {
            return this.negative = 0, this;
        }, i.prototype.abs = function() {
            return this.clone().iabs();
        }, i.prototype._ishlnsubmul = function(e, t, r) {
            var i, o, a = e.length + r;
            this._expand(a);
            var l = 0;
            for(i = 0; i < e.length; i++){
                o = (0 | this.words[i + r]) + l;
                var s = (0 | e.words[i]) * t;
                l = ((o -= 67108863 & s) >> 26) - (s / 67108864 | 0), this.words[i + r] = 67108863 & o;
            }
            for(; i < this.length - r; i++)l = (o = (0 | this.words[i + r]) + l) >> 26, this.words[i + r] = 67108863 & o;
            if (0 === l) return this.strip();
            for(n(-1 === l), l = 0, i = 0; i < this.length; i++)l = (o = -(0 | this.words[i]) + l) >> 26, this.words[i] = 67108863 & o;
            return this.negative = 1, this.strip();
        }, i.prototype._wordDiv = function(e, t) {
            var n = (this.length, e.length), r = this.clone(), o = e, a = 0 | o.words[o.length - 1];
            0 != (n = 26 - this._countBits(a)) && (o = o.ushln(n), r.iushln(n), a = 0 | o.words[o.length - 1]);
            var l, s = r.length - o.length;
            if ("mod" !== t) {
                (l = new i(null)).length = s + 1, l.words = new Array(l.length);
                for(var u = 0; u < l.length; u++)l.words[u] = 0;
            }
            var c = r.clone()._ishlnsubmul(o, 1, s);
            0 === c.negative && (r = c, l && (l.words[s] = 1));
            for(var d = s - 1; d >= 0; d--){
                var f = 67108864 * (0 | r.words[o.length + d]) + (0 | r.words[o.length + d - 1]);
                for(f = Math.min(f / a | 0, 67108863), r._ishlnsubmul(o, f, d); 0 !== r.negative;)f--, r.negative = 0, r._ishlnsubmul(o, 1, d), r.isZero() || (r.negative ^= 1);
                l && (l.words[d] = f);
            }
            return l && l.strip(), r.strip(), "div" !== t && 0 !== n && r.iushrn(n), {
                div: l || null,
                mod: r
            };
        }, i.prototype.divmod = function(e, t, r) {
            var o, a, l;
            return n(!e.isZero()), this.isZero() ? {
                div: new i(0),
                mod: new i(0)
            } : 0 !== this.negative && 0 === e.negative ? (l = this.neg().divmod(e, t), "mod" !== t && (o = l.div.neg()), "div" !== t && (a = l.mod.neg(), r && 0 !== a.negative && a.iadd(e)), {
                div: o,
                mod: a
            }) : 0 === this.negative && 0 !== e.negative ? (l = this.divmod(e.neg(), t), "mod" !== t && (o = l.div.neg()), {
                div: o,
                mod: l.mod
            }) : 0 !== (this.negative & e.negative) ? (l = this.neg().divmod(e.neg(), t), "div" !== t && (a = l.mod.neg(), r && 0 !== a.negative && a.isub(e)), {
                div: l.div,
                mod: a
            }) : e.length > this.length || this.cmp(e) < 0 ? {
                div: new i(0),
                mod: this
            } : 1 === e.length ? "div" === t ? {
                div: this.divn(e.words[0]),
                mod: null
            } : "mod" === t ? {
                div: null,
                mod: new i(this.modn(e.words[0]))
            } : {
                div: this.divn(e.words[0]),
                mod: new i(this.modn(e.words[0]))
            } : this._wordDiv(e, t);
        }, i.prototype.div = function(e) {
            return this.divmod(e, "div", !1).div;
        }, i.prototype.mod = function(e) {
            return this.divmod(e, "mod", !1).mod;
        }, i.prototype.umod = function(e) {
            return this.divmod(e, "mod", !0).mod;
        }, i.prototype.divRound = function(e) {
            var t = this.divmod(e);
            if (t.mod.isZero()) return t.div;
            var n = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, r = e.ushrn(1), i = e.andln(1), o = n.cmp(r);
            return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
        }, i.prototype.modn = function(e) {
            n(e <= 67108863);
            for(var t = 67108864 % e, r = 0, i = this.length - 1; i >= 0; i--)r = (t * r + (0 | this.words[i])) % e;
            return r;
        }, i.prototype.idivn = function(e) {
            n(e <= 67108863);
            for(var t = 0, r = this.length - 1; r >= 0; r--){
                var i = (0 | this.words[r]) + 67108864 * t;
                this.words[r] = i / e | 0, t = i % e;
            }
            return this.strip();
        }, i.prototype.divn = function(e) {
            return this.clone().idivn(e);
        }, i.prototype.egcd = function(e) {
            n(0 === e.negative), n(!e.isZero());
            var t = this, r = e.clone();
            t = 0 !== t.negative ? t.umod(e) : t.clone();
            for(var o = new i(1), a = new i(0), l = new i(0), s = new i(1), u = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++u;
            for(var c = r.clone(), d = t.clone(); !t.isZero();){
                for(var f = 0, h = 1; 0 === (t.words[0] & h) && f < 26; ++f, h <<= 1);
                if (f > 0) for(t.iushrn(f); f-- > 0;)(o.isOdd() || a.isOdd()) && (o.iadd(c), a.isub(d)), o.iushrn(1), a.iushrn(1);
                for(var p = 0, m = 1; 0 === (r.words[0] & m) && p < 26; ++p, m <<= 1);
                if (p > 0) for(r.iushrn(p); p-- > 0;)(l.isOdd() || s.isOdd()) && (l.iadd(c), s.isub(d)), l.iushrn(1), s.iushrn(1);
                t.cmp(r) >= 0 ? (t.isub(r), o.isub(l), a.isub(s)) : (r.isub(t), l.isub(o), s.isub(a));
            }
            return {
                a: l,
                b: s,
                gcd: r.iushln(u)
            };
        }, i.prototype._invmp = function(e) {
            n(0 === e.negative), n(!e.isZero());
            var t = this, r = e.clone();
            t = 0 !== t.negative ? t.umod(e) : t.clone();
            for(var o, a = new i(1), l = new i(0), s = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                for(var u = 0, c = 1; 0 === (t.words[0] & c) && u < 26; ++u, c <<= 1);
                if (u > 0) for(t.iushrn(u); u-- > 0;)a.isOdd() && a.iadd(s), a.iushrn(1);
                for(var d = 0, f = 1; 0 === (r.words[0] & f) && d < 26; ++d, f <<= 1);
                if (d > 0) for(r.iushrn(d); d-- > 0;)l.isOdd() && l.iadd(s), l.iushrn(1);
                t.cmp(r) >= 0 ? (t.isub(r), a.isub(l)) : (r.isub(t), l.isub(a));
            }
            return (o = 0 === t.cmpn(1) ? a : l).cmpn(0) < 0 && o.iadd(e), o;
        }, i.prototype.gcd = function(e) {
            if (this.isZero()) return e.abs();
            if (e.isZero()) return this.abs();
            var t = this.clone(), n = e.clone();
            t.negative = 0, n.negative = 0;
            for(var r = 0; t.isEven() && n.isEven(); r++)t.iushrn(1), n.iushrn(1);
            for(;;){
                for(; t.isEven();)t.iushrn(1);
                for(; n.isEven();)n.iushrn(1);
                var i = t.cmp(n);
                if (i < 0) {
                    var o = t;
                    t = n, n = o;
                } else if (0 === i || 0 === n.cmpn(1)) break;
                t.isub(n);
            }
            return n.iushln(r);
        }, i.prototype.invm = function(e) {
            return this.egcd(e).a.umod(e);
        }, i.prototype.isEven = function() {
            return !(1 & this.words[0]);
        }, i.prototype.isOdd = function() {
            return !(1 & ~this.words[0]);
        }, i.prototype.andln = function(e) {
            return this.words[0] & e;
        }, i.prototype.bincn = function(e) {
            n("number" == typeof e);
            var t = e % 26, r = (e - t) / 26, i = 1 << t;
            if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
            for(var o = i, a = r; 0 !== o && a < this.length; a++){
                var l = 0 | this.words[a];
                o = (l += o) >>> 26, l &= 67108863, this.words[a] = l;
            }
            return 0 !== o && (this.words[a] = o, this.length++), this;
        }, i.prototype.isZero = function() {
            return 1 === this.length && 0 === this.words[0];
        }, i.prototype.cmpn = function(e) {
            var t, r = e < 0;
            if (0 !== this.negative && !r) return -1;
            if (0 === this.negative && r) return 1;
            if (this.strip(), this.length > 1) t = 1;
            else {
                r && (e = -e), n(e <= 67108863, "Number is too big");
                var i = 0 | this.words[0];
                t = i === e ? 0 : i < e ? -1 : 1;
            }
            return 0 !== this.negative ? 0 | -t : t;
        }, i.prototype.cmp = function(e) {
            if (0 !== this.negative && 0 === e.negative) return -1;
            if (0 === this.negative && 0 !== e.negative) return 1;
            var t = this.ucmp(e);
            return 0 !== this.negative ? 0 | -t : t;
        }, i.prototype.ucmp = function(e) {
            if (this.length > e.length) return 1;
            if (this.length < e.length) return -1;
            for(var t = 0, n = this.length - 1; n >= 0; n--){
                var r = 0 | this.words[n], i = 0 | e.words[n];
                if (r !== i) {
                    r < i ? t = -1 : r > i && (t = 1);
                    break;
                }
            }
            return t;
        }, i.prototype.gtn = function(e) {
            return 1 === this.cmpn(e);
        }, i.prototype.gt = function(e) {
            return 1 === this.cmp(e);
        }, i.prototype.gten = function(e) {
            return this.cmpn(e) >= 0;
        }, i.prototype.gte = function(e) {
            return this.cmp(e) >= 0;
        }, i.prototype.ltn = function(e) {
            return -1 === this.cmpn(e);
        }, i.prototype.lt = function(e) {
            return -1 === this.cmp(e);
        }, i.prototype.lten = function(e) {
            return this.cmpn(e) <= 0;
        }, i.prototype.lte = function(e) {
            return this.cmp(e) <= 0;
        }, i.prototype.eqn = function(e) {
            return 0 === this.cmpn(e);
        }, i.prototype.eq = function(e) {
            return 0 === this.cmp(e);
        }, i.red = function(e) {
            return new E(e);
        }, i.prototype.toRed = function(e) {
            return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
        }, i.prototype.fromRed = function() {
            return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, i.prototype._forceRed = function(e) {
            return this.red = e, this;
        }, i.prototype.forceRed = function(e) {
            return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
        }, i.prototype.redAdd = function(e) {
            return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
        }, i.prototype.redIAdd = function(e) {
            return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
        }, i.prototype.redSub = function(e) {
            return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
        }, i.prototype.redISub = function(e) {
            return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
        }, i.prototype.redShl = function(e) {
            return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
        }, i.prototype.redMul = function(e) {
            return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
        }, i.prototype.redIMul = function(e) {
            return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
        }, i.prototype.redSqr = function() {
            return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, i.prototype.redISqr = function() {
            return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, i.prototype.redSqrt = function() {
            return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, i.prototype.redInvm = function() {
            return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, i.prototype.redNeg = function() {
            return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, i.prototype.redPow = function(e) {
            return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
        };
        var g = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function b(e, t) {
            this.name = e, this.p = new i(t, 16), this.n = this.p.bitLength(), this.k = new i(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }
        function y() {
            b.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }
        function v() {
            b.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }
        function I() {
            b.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }
        function M() {
            b.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }
        function E(e) {
            if ("string" == typeof e) {
                var t = i._prime(e);
                this.m = t.p, this.prime = t;
            } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
        }
        function x(e) {
            E.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new i(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }
        b.prototype._tmp = function() {
            var e = new i(null);
            return e.words = new Array(Math.ceil(this.n / 13)), e;
        }, b.prototype.ireduce = function(e) {
            var t, n = e;
            do this.split(n, this.tmp), t = (n = (n = this.imulK(n)).iadd(this.tmp)).bitLength();
            while (t > this.n);
            var r = t < this.n ? -1 : n.ucmp(this.p);
            return 0 === r ? (n.words[0] = 0, n.length = 1) : r > 0 ? n.isub(this.p) : void 0 !== n.strip ? n.strip() : n._strip(), n;
        }, b.prototype.split = function(e, t) {
            e.iushrn(this.n, 0, t);
        }, b.prototype.imulK = function(e) {
            return e.imul(this.k);
        }, r(y, b), y.prototype.split = function(e, t) {
            for(var n = 4194303, r = Math.min(e.length, 9), i = 0; i < r; i++)t.words[i] = e.words[i];
            if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
            var o = e.words[9];
            for(t.words[t.length++] = o & n, i = 10; i < e.length; i++){
                var a = 0 | e.words[i];
                e.words[i - 10] = (a & n) << 4 | o >>> 22, o = a;
            }
            o >>>= 22, e.words[i - 10] = o, 0 === o && e.length > 10 ? e.length -= 10 : e.length -= 9;
        }, y.prototype.imulK = function(e) {
            e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
            for(var t = 0, n = 0; n < e.length; n++){
                var r = 0 | e.words[n];
                t += 977 * r, e.words[n] = 67108863 & t, t = 64 * r + (t / 67108864 | 0);
            }
            return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
        }, r(v, b), r(I, b), r(M, b), M.prototype.imulK = function(e) {
            for(var t = 0, n = 0; n < e.length; n++){
                var r = 19 * (0 | e.words[n]) + t, i = 67108863 & r;
                r >>>= 26, e.words[n] = i, t = r;
            }
            return 0 !== t && (e.words[e.length++] = t), e;
        }, i._prime = function(e) {
            if (g[e]) return g[e];
            var t;
            if ("k256" === e) t = new y;
            else if ("p224" === e) t = new v;
            else if ("p192" === e) t = new I;
            else {
                if ("p25519" !== e) throw new Error("Unknown prime " + e);
                t = new M;
            }
            return g[e] = t, t;
        }, E.prototype._verify1 = function(e) {
            n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
        }, E.prototype._verify2 = function(e, t) {
            n(0 === (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
        }, E.prototype.imod = function(e) {
            return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
        }, E.prototype.neg = function(e) {
            return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
        }, E.prototype.add = function(e, t) {
            this._verify2(e, t);
            var n = e.add(t);
            return n.cmp(this.m) >= 0 && n.isub(this.m), n._forceRed(this);
        }, E.prototype.iadd = function(e, t) {
            this._verify2(e, t);
            var n = e.iadd(t);
            return n.cmp(this.m) >= 0 && n.isub(this.m), n;
        }, E.prototype.sub = function(e, t) {
            this._verify2(e, t);
            var n = e.sub(t);
            return n.cmpn(0) < 0 && n.iadd(this.m), n._forceRed(this);
        }, E.prototype.isub = function(e, t) {
            this._verify2(e, t);
            var n = e.isub(t);
            return n.cmpn(0) < 0 && n.iadd(this.m), n;
        }, E.prototype.shl = function(e, t) {
            return this._verify1(e), this.imod(e.ushln(t));
        }, E.prototype.imul = function(e, t) {
            return this._verify2(e, t), this.imod(e.imul(t));
        }, E.prototype.mul = function(e, t) {
            return this._verify2(e, t), this.imod(e.mul(t));
        }, E.prototype.isqr = function(e) {
            return this.imul(e, e.clone());
        }, E.prototype.sqr = function(e) {
            return this.mul(e, e);
        }, E.prototype.sqrt = function(e) {
            if (e.isZero()) return e.clone();
            var t = this.m.andln(3);
            if (n(t % 2 == 1), 3 === t) {
                var r = this.m.add(new i(1)).iushrn(2);
                return this.pow(e, r);
            }
            for(var o = this.m.subn(1), a = 0; !o.isZero() && 0 === o.andln(1);)a++, o.iushrn(1);
            n(!o.isZero());
            var l = new i(1).toRed(this), s = l.redNeg(), u = this.m.subn(1).iushrn(1), c = this.m.bitLength();
            for(c = new i(2 * c * c).toRed(this); 0 !== this.pow(c, u).cmp(s);)c.redIAdd(s);
            for(var d = this.pow(c, o), f = this.pow(e, o.addn(1).iushrn(1)), h = this.pow(e, o), p = a; 0 !== h.cmp(l);){
                for(var m = h, g = 0; 0 !== m.cmp(l); g++)m = m.redSqr();
                n(g < p);
                var b = this.pow(d, new i(1).iushln(p - g - 1));
                f = f.redMul(b), d = b.redSqr(), h = h.redMul(d), p = g;
            }
            return f;
        }, E.prototype.invm = function(e) {
            var t = e._invmp(this.m);
            return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
        }, E.prototype.pow = function(e, t) {
            if (t.isZero()) return new i(1).toRed(this);
            if (0 === t.cmpn(1)) return e.clone();
            var n = new Array(16);
            n[0] = new i(1).toRed(this), n[1] = e;
            for(var r = 2; r < n.length; r++)n[r] = this.mul(n[r - 1], e);
            var o = n[0], a = 0, l = 0, s = t.bitLength() % 26;
            for(0 === s && (s = 26), r = t.length - 1; r >= 0; r--){
                for(var u = t.words[r], c = s - 1; c >= 0; c--){
                    var d = u >> c & 1;
                    o !== n[0] && (o = this.sqr(o)), 0 !== d || 0 !== a ? (a <<= 1, a |= d, (4 === ++l || 0 === r && 0 === c) && (o = this.mul(o, n[a]), l = 0, a = 0)) : l = 0;
                }
                s = 26;
            }
            return o;
        }, E.prototype.convertTo = function(e) {
            var t = e.umod(this.m);
            return t === e ? t.clone() : t;
        }, E.prototype.convertFrom = function(e) {
            var t = e.clone();
            return t.red = null, t;
        }, i.mont = function(e) {
            return new x(e);
        }, r(x, E), x.prototype.convertTo = function(e) {
            return this.imod(e.ushln(this.shift));
        }, x.prototype.convertFrom = function(e) {
            var t = this.imod(e.mul(this.rinv));
            return t.red = null, t;
        }, x.prototype.imul = function(e, t) {
            if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
            var n = e.imul(t), r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = n.isub(r).iushrn(this.shift), o = i;
            return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
        }, x.prototype.mul = function(e, t) {
            if (e.isZero() || t.isZero()) return new i(0)._forceRed(this);
            var n = e.mul(t), r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), o = n.isub(r).iushrn(this.shift), a = o;
            return o.cmp(this.m) >= 0 ? a = o.isub(this.m) : o.cmpn(0) < 0 && (a = o.iadd(this.m)), a._forceRed(this);
        }, x.prototype.invm = function(e) {
            return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
        };
    }($cf61b77dbdb95489$var$Zl, $cf61b77dbdb95489$var$Xl)), $cf61b77dbdb95489$var$Zl.exports;
}
var $cf61b77dbdb95489$var$Jl, $cf61b77dbdb95489$var$Hl, $cf61b77dbdb95489$var$_l = {};
function $cf61b77dbdb95489$var$$l() {
    return $cf61b77dbdb95489$var$Jl || ($cf61b77dbdb95489$var$Jl = 1, function(e) {
        var t = e;
        function n(e) {
            return 1 === e.length ? "0" + e : e;
        }
        function r(e) {
            for(var t = "", r = 0; r < e.length; r++)t += n(e[r].toString(16));
            return t;
        }
        t.toArray = function(e, t) {
            if (Array.isArray(e)) return e.slice();
            if (!e) return [];
            var n = [];
            if ("string" != typeof e) {
                for(var r = 0; r < e.length; r++)n[r] = 0 | e[r];
                return n;
            }
            if ("hex" === t) {
                (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);
                for(r = 0; r < e.length; r += 2)n.push(parseInt(e[r] + e[r + 1], 16));
            } else for(r = 0; r < e.length; r++){
                var i = e.charCodeAt(r), o = i >> 8, a = 255 & i;
                o ? n.push(o, a) : n.push(a);
            }
            return n;
        }, t.zero2 = n, t.toHex = r, t.encode = function(e, t) {
            return "hex" === t ? r(e) : e;
        };
    }($cf61b77dbdb95489$var$_l)), $cf61b77dbdb95489$var$_l;
}
function $cf61b77dbdb95489$var$es() {
    return $cf61b77dbdb95489$var$Hl || ($cf61b77dbdb95489$var$Hl = 1, function() {
        var e = $cf61b77dbdb95489$var$Yl, t = $cf61b77dbdb95489$var$Pl(), n = $cf61b77dbdb95489$var$ri(), r = $cf61b77dbdb95489$var$$l();
        e.assert = n, e.toArray = r.toArray, e.zero2 = r.zero2, e.toHex = r.toHex, e.encode = r.encode, e.getNAF = function(e, t, n) {
            var r, i = new Array(Math.max(e.bitLength(), n) + 1);
            for(r = 0; r < i.length; r += 1)i[r] = 0;
            var o = 1 << t + 1, a = e.clone();
            for(r = 0; r < i.length; r++){
                var l, s = a.andln(o - 1);
                a.isOdd() ? (l = s > (o >> 1) - 1 ? (o >> 1) - s : s, a.isubn(l)) : l = 0, i[r] = l, a.iushrn(1);
            }
            return i;
        }, e.getJSF = function(e, t) {
            var n = [
                [],
                []
            ];
            e = e.clone(), t = t.clone();
            for(var r, i = 0, o = 0; e.cmpn(-i) > 0 || t.cmpn(-o) > 0;){
                var a, l, s = e.andln(3) + i & 3, u = t.andln(3) + o & 3;
                3 === s && (s = -1), 3 === u && (u = -1), a = 1 & s ? 3 !== (r = e.andln(7) + i & 7) && 5 !== r || 2 !== u ? s : -s : 0, n[0].push(a), l = 1 & u ? 3 !== (r = t.andln(7) + o & 7) && 5 !== r || 2 !== s ? u : -u : 0, n[1].push(l), 2 * i === a + 1 && (i = 1 - i), 2 * o === l + 1 && (o = 1 - o), e.iushrn(1), t.iushrn(1);
            }
            return n;
        }, e.cachedProperty = function(e, t, n) {
            var r = "_" + t;
            e.prototype[t] = function() {
                return void 0 !== this[r] ? this[r] : this[r] = n.call(this);
            };
        }, e.parseBytes = function(t) {
            return "string" == typeof t ? e.toArray(t, "hex") : t;
        }, e.intFromLE = function(e) {
            return new t(e, "hex", "le");
        };
    }()), $cf61b77dbdb95489$var$Yl;
}
var $cf61b77dbdb95489$var$ts, $cf61b77dbdb95489$var$ns = {
    exports: {}
};

function $cf61b77dbdb95489$var$rs() {
    if ($cf61b77dbdb95489$var$ts) return $cf61b77dbdb95489$var$ns.exports;
    var e;
    function t(e) {
        this.rand = e;
    }
    if ($cf61b77dbdb95489$var$ts = 1, $cf61b77dbdb95489$var$ns.exports = function(n) {
        return e || (e = new t(null)), e.generate(n);
    }, $cf61b77dbdb95489$var$ns.exports.Rand = t, t.prototype.generate = function(e) {
        return this._rand(e);
    }, t.prototype._rand = function(e) {
        if (this.rand.getBytes) return this.rand.getBytes(e);
        for(var t = new Uint8Array(e), n = 0; n < t.length; n++)t[n] = this.rand.getByte();
        return t;
    }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? t.prototype._rand = function(e) {
        var t = new Uint8Array(e);
        return self.crypto.getRandomValues(t), t;
    } : self.msCrypto && self.msCrypto.getRandomValues ? t.prototype._rand = function(e) {
        var t = new Uint8Array(e);
        return self.msCrypto.getRandomValues(t), t;
    } : "object" == typeof window && (t.prototype._rand = function() {
        throw new Error("Not implemented yet");
    });
    else try {
        var n = (parcelRequire("5UUfm"));
        if ("function" != typeof n.randomBytes) throw new Error("Not supported");
        t.prototype._rand = function(e) {
            return n.randomBytes(e);
        };
    } catch (e) {}
    return $cf61b77dbdb95489$var$ns.exports;
}
var $cf61b77dbdb95489$var$is, $cf61b77dbdb95489$var$os, $cf61b77dbdb95489$var$as, $cf61b77dbdb95489$var$ls, $cf61b77dbdb95489$var$ss, $cf61b77dbdb95489$var$us, $cf61b77dbdb95489$var$cs, $cf61b77dbdb95489$var$ds, $cf61b77dbdb95489$var$fs, $cf61b77dbdb95489$var$hs = {};
function $cf61b77dbdb95489$var$ps() {
    if ($cf61b77dbdb95489$var$os) return $cf61b77dbdb95489$var$is;
    $cf61b77dbdb95489$var$os = 1;
    var e = $cf61b77dbdb95489$var$Pl(), t = $cf61b77dbdb95489$var$es(), n = t.getNAF, r = t.getJSF, i = t.assert;
    function o(t, n) {
        this.type = t, this.p = new e(n.p, 16), this.red = n.prime ? e.red(n.prime) : e.mont(this.p), this.zero = new e(0).toRed(this.red), this.one = new e(1).toRed(this.red), this.two = new e(2).toRed(this.red), this.n = n.n && new e(n.n, 16), this.g = n.g && this.pointFromJSON(n.g, n.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
        var r = this.n && this.p.div(this.n);
        !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
    }
    function a(e, t) {
        this.curve = e, this.type = t, this.precomputed = null;
    }
    return $cf61b77dbdb95489$var$is = o, o.prototype.point = function() {
        throw new Error("Not implemented");
    }, o.prototype.validate = function() {
        throw new Error("Not implemented");
    }, o.prototype._fixedNafMul = function(e, t) {
        i(e.precomputed);
        var r = e._getDoubles(), o = n(t, 1, this._bitLength), a = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);
        a /= 3;
        var l, s, u = [];
        for(l = 0; l < o.length; l += r.step){
            s = 0;
            for(var c = l + r.step - 1; c >= l; c--)s = (s << 1) + o[c];
            u.push(s);
        }
        for(var d = this.jpoint(null, null, null), f = this.jpoint(null, null, null), h = a; h > 0; h--){
            for(l = 0; l < u.length; l++)(s = u[l]) === h ? f = f.mixedAdd(r.points[l]) : s === -h && (f = f.mixedAdd(r.points[l].neg()));
            d = d.add(f);
        }
        return d.toP();
    }, o.prototype._wnafMul = function(e, t) {
        var r = 4, o = e._getNAFPoints(r);
        r = o.wnd;
        for(var a = o.points, l = n(t, r, this._bitLength), s = this.jpoint(null, null, null), u = l.length - 1; u >= 0; u--){
            for(var c = 0; u >= 0 && 0 === l[u]; u--)c++;
            if (u >= 0 && c++, s = s.dblp(c), u < 0) break;
            var d = l[u];
            i(0 !== d), s = "affine" === e.type ? d > 0 ? s.mixedAdd(a[d - 1 >> 1]) : s.mixedAdd(a[-d - 1 >> 1].neg()) : d > 0 ? s.add(a[d - 1 >> 1]) : s.add(a[-d - 1 >> 1].neg());
        }
        return "affine" === e.type ? s.toP() : s;
    }, o.prototype._wnafMulAdd = function(e, t, i, o, a) {
        var l, s, u, c = this._wnafT1, d = this._wnafT2, f = this._wnafT3, h = 0;
        for(l = 0; l < o; l++){
            var p = (u = t[l])._getNAFPoints(e);
            c[l] = p.wnd, d[l] = p.points;
        }
        for(l = o - 1; l >= 1; l -= 2){
            var m = l - 1, g = l;
            if (1 === c[m] && 1 === c[g]) {
                var b = [
                    t[m],
                    null,
                    null,
                    t[g]
                ];
                0 === t[m].y.cmp(t[g].y) ? (b[1] = t[m].add(t[g]), b[2] = t[m].toJ().mixedAdd(t[g].neg())) : 0 === t[m].y.cmp(t[g].y.redNeg()) ? (b[1] = t[m].toJ().mixedAdd(t[g]), b[2] = t[m].add(t[g].neg())) : (b[1] = t[m].toJ().mixedAdd(t[g]), b[2] = t[m].toJ().mixedAdd(t[g].neg()));
                var y = [
                    -3,
                    -1,
                    -5,
                    -7,
                    0,
                    7,
                    5,
                    1,
                    3
                ], v = r(i[m], i[g]);
                for(h = Math.max(v[0].length, h), f[m] = new Array(h), f[g] = new Array(h), s = 0; s < h; s++){
                    var I = 0 | v[0][s], M = 0 | v[1][s];
                    f[m][s] = y[3 * (I + 1) + (M + 1)], f[g][s] = 0, d[m] = b;
                }
            } else f[m] = n(i[m], c[m], this._bitLength), f[g] = n(i[g], c[g], this._bitLength), h = Math.max(f[m].length, h), h = Math.max(f[g].length, h);
        }
        var E = this.jpoint(null, null, null), x = this._wnafT4;
        for(l = h; l >= 0; l--){
            for(var S = 0; l >= 0;){
                var w = !0;
                for(s = 0; s < o; s++)x[s] = 0 | f[s][l], 0 !== x[s] && (w = !1);
                if (!w) break;
                S++, l--;
            }
            if (l >= 0 && S++, E = E.dblp(S), l < 0) break;
            for(s = 0; s < o; s++){
                var k = x[s];
                0 !== k && (k > 0 ? u = d[s][k - 1 >> 1] : k < 0 && (u = d[s][-k - 1 >> 1].neg()), E = "affine" === u.type ? E.mixedAdd(u) : E.add(u));
            }
        }
        for(l = 0; l < o; l++)d[l] = null;
        return a ? E : E.toP();
    }, o.BasePoint = a, a.prototype.eq = function() {
        throw new Error("Not implemented");
    }, a.prototype.validate = function() {
        return this.curve.validate(this);
    }, o.prototype.decodePoint = function(e, n) {
        e = t.toArray(e, n);
        var r = this.p.byteLength();
        if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? i(e[e.length - 1] % 2 == 0) : 7 === e[0] && i(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
        if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
        throw new Error("Unknown point format");
    }, a.prototype.encodeCompressed = function(e) {
        return this.encode(e, !0);
    }, a.prototype._encode = function(e) {
        var t = this.curve.p.byteLength(), n = this.getX().toArray("be", t);
        return e ? [
            this.getY().isEven() ? 2 : 3
        ].concat(n) : [
            4
        ].concat(n, this.getY().toArray("be", t));
    }, a.prototype.encode = function(e, n) {
        return t.encode(this._encode(n), e);
    }, a.prototype.precompute = function(e) {
        if (this.precomputed) return this;
        var t = {
            doubles: null,
            naf: null,
            beta: null
        };
        return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
    }, a.prototype._hasDoubles = function(e) {
        if (!this.precomputed) return !1;
        var t = this.precomputed.doubles;
        return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
    }, a.prototype._getDoubles = function(e, t) {
        if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
        for(var n = [
            this
        ], r = this, i = 0; i < t; i += e){
            for(var o = 0; o < e; o++)r = r.dbl();
            n.push(r);
        }
        return {
            step: e,
            points: n
        };
    }, a.prototype._getNAFPoints = function(e) {
        if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
        for(var t = [
            this
        ], n = (1 << e) - 1, r = 1 === n ? null : this.dbl(), i = 1; i < n; i++)t[i] = t[i - 1].add(r);
        return {
            wnd: e,
            points: t
        };
    }, a.prototype._getBeta = function() {
        return null;
    }, a.prototype.dblp = function(e) {
        for(var t = this, n = 0; n < e; n++)t = t.dbl();
        return t;
    }, $cf61b77dbdb95489$var$is;
}
function $cf61b77dbdb95489$var$ms() {
    return $cf61b77dbdb95489$var$fs || ($cf61b77dbdb95489$var$fs = 1, function(e) {
        var t = e;
        t.base = $cf61b77dbdb95489$var$ps(), t.short = function() {
            if ($cf61b77dbdb95489$var$ls) return $cf61b77dbdb95489$var$as;
            $cf61b77dbdb95489$var$ls = 1;
            var e = $cf61b77dbdb95489$var$es(), t = $cf61b77dbdb95489$var$Pl(), n = $cf61b77dbdb95489$var$ui(), r = $cf61b77dbdb95489$var$ps(), i = e.assert;
            function o(e) {
                r.call(this, "short", e), this.a = new t(e.a, 16).toRed(this.red), this.b = new t(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
            }
            function a(e, n, i, o) {
                r.BasePoint.call(this, e, "affine"), null === n && null === i ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new t(n, 16), this.y = new t(i, 16), o && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
            }
            function l(e, n, i, o) {
                r.BasePoint.call(this, e, "jacobian"), null === n && null === i && null === o ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new t(0)) : (this.x = new t(n, 16), this.y = new t(i, 16), this.z = new t(o, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
            }
            return n(o, r), $cf61b77dbdb95489$var$as = o, o.prototype._getEndomorphism = function(e) {
                if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
                    var n, r;
                    if (e.beta) n = new t(e.beta, 16).toRed(this.red);
                    else {
                        var o = this._getEndoRoots(this.p);
                        n = (n = o[0].cmp(o[1]) < 0 ? o[0] : o[1]).toRed(this.red);
                    }
                    if (e.lambda) r = new t(e.lambda, 16);
                    else {
                        var a = this._getEndoRoots(this.n);
                        0 === this.g.mul(a[0]).x.cmp(this.g.x.redMul(n)) ? r = a[0] : (r = a[1], i(0 === this.g.mul(r).x.cmp(this.g.x.redMul(n))));
                    }
                    return {
                        beta: n,
                        lambda: r,
                        basis: e.basis ? e.basis.map(function(e) {
                            return {
                                a: new t(e.a, 16),
                                b: new t(e.b, 16)
                            };
                        }) : this._getEndoBasis(r)
                    };
                }
            }, o.prototype._getEndoRoots = function(e) {
                var n = e === this.p ? this.red : t.mont(e), r = new t(2).toRed(n).redInvm(), i = r.redNeg(), o = new t(3).toRed(n).redNeg().redSqrt().redMul(r);
                return [
                    i.redAdd(o).fromRed(),
                    i.redSub(o).fromRed()
                ];
            }, o.prototype._getEndoBasis = function(e) {
                for(var n, r, i, o, a, l, s, u, c, d = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), f = e, h = this.n.clone(), p = new t(1), m = new t(0), g = new t(0), b = new t(1), y = 0; 0 !== f.cmpn(0);){
                    var v = h.div(f);
                    u = h.sub(v.mul(f)), c = g.sub(v.mul(p));
                    var I = b.sub(v.mul(m));
                    if (!i && u.cmp(d) < 0) n = s.neg(), r = p, i = u.neg(), o = c;
                    else if (i && 2 === ++y) break;
                    s = u, h = f, f = u, g = p, p = c, b = m, m = I;
                }
                a = u.neg(), l = c;
                var M = i.sqr().add(o.sqr());
                return a.sqr().add(l.sqr()).cmp(M) >= 0 && (a = n, l = r), i.negative && (i = i.neg(), o = o.neg()), a.negative && (a = a.neg(), l = l.neg()), [
                    {
                        a: i,
                        b: o
                    },
                    {
                        a: a,
                        b: l
                    }
                ];
            }, o.prototype._endoSplit = function(e) {
                var t = this.endo.basis, n = t[0], r = t[1], i = r.b.mul(e).divRound(this.n), o = n.b.neg().mul(e).divRound(this.n), a = i.mul(n.a), l = o.mul(r.a), s = i.mul(n.b), u = o.mul(r.b);
                return {
                    k1: e.sub(a).sub(l),
                    k2: s.add(u).neg()
                };
            }, o.prototype.pointFromX = function(e, n) {
                (e = new t(e, 16)).red || (e = e.toRed(this.red));
                var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), i = r.redSqrt();
                if (0 !== i.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
                var o = i.fromRed().isOdd();
                return (n && !o || !n && o) && (i = i.redNeg()), this.point(e, i);
            }, o.prototype.validate = function(e) {
                if (e.inf) return !0;
                var t = e.x, n = e.y, r = this.a.redMul(t), i = t.redSqr().redMul(t).redIAdd(r).redIAdd(this.b);
                return 0 === n.redSqr().redISub(i).cmpn(0);
            }, o.prototype._endoWnafMulAdd = function(e, t, n) {
                for(var r = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < e.length; o++){
                    var a = this._endoSplit(t[o]), l = e[o], s = l._getBeta();
                    a.k1.negative && (a.k1.ineg(), l = l.neg(!0)), a.k2.negative && (a.k2.ineg(), s = s.neg(!0)), r[2 * o] = l, r[2 * o + 1] = s, i[2 * o] = a.k1, i[2 * o + 1] = a.k2;
                }
                for(var u = this._wnafMulAdd(1, r, i, 2 * o, n), c = 0; c < 2 * o; c++)r[c] = null, i[c] = null;
                return u;
            }, n(a, r.BasePoint), o.prototype.point = function(e, t, n) {
                return new a(this, e, t, n);
            }, o.prototype.pointFromJSON = function(e, t) {
                return a.fromJSON(this, e, t);
            }, a.prototype._getBeta = function() {
                if (this.curve.endo) {
                    var e = this.precomputed;
                    if (e && e.beta) return e.beta;
                    var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
                    if (e) {
                        var n = this.curve, r = function(e) {
                            return n.point(e.x.redMul(n.endo.beta), e.y);
                        };
                        e.beta = t, t.precomputed = {
                            beta: null,
                            naf: e.naf && {
                                wnd: e.naf.wnd,
                                points: e.naf.points.map(r)
                            },
                            doubles: e.doubles && {
                                step: e.doubles.step,
                                points: e.doubles.points.map(r)
                            }
                        };
                    }
                    return t;
                }
            }, a.prototype.toJSON = function() {
                return this.precomputed ? [
                    this.x,
                    this.y,
                    this.precomputed && {
                        doubles: this.precomputed.doubles && {
                            step: this.precomputed.doubles.step,
                            points: this.precomputed.doubles.points.slice(1)
                        },
                        naf: this.precomputed.naf && {
                            wnd: this.precomputed.naf.wnd,
                            points: this.precomputed.naf.points.slice(1)
                        }
                    }
                ] : [
                    this.x,
                    this.y
                ];
            }, a.fromJSON = function(e, t, n) {
                "string" == typeof t && (t = JSON.parse(t));
                var r = e.point(t[0], t[1], n);
                if (!t[2]) return r;
                function i(t) {
                    return e.point(t[0], t[1], n);
                }
                var o = t[2];
                return r.precomputed = {
                    beta: null,
                    doubles: o.doubles && {
                        step: o.doubles.step,
                        points: [
                            r
                        ].concat(o.doubles.points.map(i))
                    },
                    naf: o.naf && {
                        wnd: o.naf.wnd,
                        points: [
                            r
                        ].concat(o.naf.points.map(i))
                    }
                }, r;
            }, a.prototype.inspect = function() {
                return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
            }, a.prototype.isInfinity = function() {
                return this.inf;
            }, a.prototype.add = function(e) {
                if (this.inf) return e;
                if (e.inf) return this;
                if (this.eq(e)) return this.dbl();
                if (this.neg().eq(e)) return this.curve.point(null, null);
                if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
                var t = this.y.redSub(e.y);
                0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
                var n = t.redSqr().redISub(this.x).redISub(e.x), r = t.redMul(this.x.redSub(n)).redISub(this.y);
                return this.curve.point(n, r);
            }, a.prototype.dbl = function() {
                if (this.inf) return this;
                var e = this.y.redAdd(this.y);
                if (0 === e.cmpn(0)) return this.curve.point(null, null);
                var t = this.curve.a, n = this.x.redSqr(), r = e.redInvm(), i = n.redAdd(n).redIAdd(n).redIAdd(t).redMul(r), o = i.redSqr().redISub(this.x.redAdd(this.x)), a = i.redMul(this.x.redSub(o)).redISub(this.y);
                return this.curve.point(o, a);
            }, a.prototype.getX = function() {
                return this.x.fromRed();
            }, a.prototype.getY = function() {
                return this.y.fromRed();
            }, a.prototype.mul = function(e) {
                return e = new t(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([
                    this
                ], [
                    e
                ]) : this.curve._wnafMul(this, e);
            }, a.prototype.mulAdd = function(e, t, n) {
                var r = [
                    this,
                    t
                ], i = [
                    e,
                    n
                ];
                return this.curve.endo ? this.curve._endoWnafMulAdd(r, i) : this.curve._wnafMulAdd(1, r, i, 2);
            }, a.prototype.jmulAdd = function(e, t, n) {
                var r = [
                    this,
                    t
                ], i = [
                    e,
                    n
                ];
                return this.curve.endo ? this.curve._endoWnafMulAdd(r, i, !0) : this.curve._wnafMulAdd(1, r, i, 2, !0);
            }, a.prototype.eq = function(e) {
                return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
            }, a.prototype.neg = function(e) {
                if (this.inf) return this;
                var t = this.curve.point(this.x, this.y.redNeg());
                if (e && this.precomputed) {
                    var n = this.precomputed, r = function(e) {
                        return e.neg();
                    };
                    t.precomputed = {
                        naf: n.naf && {
                            wnd: n.naf.wnd,
                            points: n.naf.points.map(r)
                        },
                        doubles: n.doubles && {
                            step: n.doubles.step,
                            points: n.doubles.points.map(r)
                        }
                    };
                }
                return t;
            }, a.prototype.toJ = function() {
                return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
            }, n(l, r.BasePoint), o.prototype.jpoint = function(e, t, n) {
                return new l(this, e, t, n);
            }, l.prototype.toP = function() {
                if (this.isInfinity()) return this.curve.point(null, null);
                var e = this.z.redInvm(), t = e.redSqr(), n = this.x.redMul(t), r = this.y.redMul(t).redMul(e);
                return this.curve.point(n, r);
            }, l.prototype.neg = function() {
                return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
            }, l.prototype.add = function(e) {
                if (this.isInfinity()) return e;
                if (e.isInfinity()) return this;
                var t = e.z.redSqr(), n = this.z.redSqr(), r = this.x.redMul(t), i = e.x.redMul(n), o = this.y.redMul(t.redMul(e.z)), a = e.y.redMul(n.redMul(this.z)), l = r.redSub(i), s = o.redSub(a);
                if (0 === l.cmpn(0)) return 0 !== s.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                var u = l.redSqr(), c = u.redMul(l), d = r.redMul(u), f = s.redSqr().redIAdd(c).redISub(d).redISub(d), h = s.redMul(d.redISub(f)).redISub(o.redMul(c)), p = this.z.redMul(e.z).redMul(l);
                return this.curve.jpoint(f, h, p);
            }, l.prototype.mixedAdd = function(e) {
                if (this.isInfinity()) return e.toJ();
                if (e.isInfinity()) return this;
                var t = this.z.redSqr(), n = this.x, r = e.x.redMul(t), i = this.y, o = e.y.redMul(t).redMul(this.z), a = n.redSub(r), l = i.redSub(o);
                if (0 === a.cmpn(0)) return 0 !== l.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                var s = a.redSqr(), u = s.redMul(a), c = n.redMul(s), d = l.redSqr().redIAdd(u).redISub(c).redISub(c), f = l.redMul(c.redISub(d)).redISub(i.redMul(u)), h = this.z.redMul(a);
                return this.curve.jpoint(d, f, h);
            }, l.prototype.dblp = function(e) {
                if (0 === e) return this;
                if (this.isInfinity()) return this;
                if (!e) return this.dbl();
                var t;
                if (this.curve.zeroA || this.curve.threeA) {
                    var n = this;
                    for(t = 0; t < e; t++)n = n.dbl();
                    return n;
                }
                var r = this.curve.a, i = this.curve.tinv, o = this.x, a = this.y, l = this.z, s = l.redSqr().redSqr(), u = a.redAdd(a);
                for(t = 0; t < e; t++){
                    var c = o.redSqr(), d = u.redSqr(), f = d.redSqr(), h = c.redAdd(c).redIAdd(c).redIAdd(r.redMul(s)), p = o.redMul(d), m = h.redSqr().redISub(p.redAdd(p)), g = p.redISub(m), b = h.redMul(g);
                    b = b.redIAdd(b).redISub(f);
                    var y = u.redMul(l);
                    t + 1 < e && (s = s.redMul(f)), o = m, l = y, u = b;
                }
                return this.curve.jpoint(o, u.redMul(i), l);
            }, l.prototype.dbl = function() {
                return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
            }, l.prototype._zeroDbl = function() {
                var e, t, n;
                if (this.zOne) {
                    var r = this.x.redSqr(), i = this.y.redSqr(), o = i.redSqr(), a = this.x.redAdd(i).redSqr().redISub(r).redISub(o);
                    a = a.redIAdd(a);
                    var l = r.redAdd(r).redIAdd(r), s = l.redSqr().redISub(a).redISub(a), u = o.redIAdd(o);
                    u = (u = u.redIAdd(u)).redIAdd(u), e = s, t = l.redMul(a.redISub(s)).redISub(u), n = this.y.redAdd(this.y);
                } else {
                    var c = this.x.redSqr(), d = this.y.redSqr(), f = d.redSqr(), h = this.x.redAdd(d).redSqr().redISub(c).redISub(f);
                    h = h.redIAdd(h);
                    var p = c.redAdd(c).redIAdd(c), m = p.redSqr(), g = f.redIAdd(f);
                    g = (g = g.redIAdd(g)).redIAdd(g), e = m.redISub(h).redISub(h), t = p.redMul(h.redISub(e)).redISub(g), n = (n = this.y.redMul(this.z)).redIAdd(n);
                }
                return this.curve.jpoint(e, t, n);
            }, l.prototype._threeDbl = function() {
                var e, t, n;
                if (this.zOne) {
                    var r = this.x.redSqr(), i = this.y.redSqr(), o = i.redSqr(), a = this.x.redAdd(i).redSqr().redISub(r).redISub(o);
                    a = a.redIAdd(a);
                    var l = r.redAdd(r).redIAdd(r).redIAdd(this.curve.a), s = l.redSqr().redISub(a).redISub(a);
                    e = s;
                    var u = o.redIAdd(o);
                    u = (u = u.redIAdd(u)).redIAdd(u), t = l.redMul(a.redISub(s)).redISub(u), n = this.y.redAdd(this.y);
                } else {
                    var c = this.z.redSqr(), d = this.y.redSqr(), f = this.x.redMul(d), h = this.x.redSub(c).redMul(this.x.redAdd(c));
                    h = h.redAdd(h).redIAdd(h);
                    var p = f.redIAdd(f), m = (p = p.redIAdd(p)).redAdd(p);
                    e = h.redSqr().redISub(m), n = this.y.redAdd(this.z).redSqr().redISub(d).redISub(c);
                    var g = d.redSqr();
                    g = (g = (g = g.redIAdd(g)).redIAdd(g)).redIAdd(g), t = h.redMul(p.redISub(e)).redISub(g);
                }
                return this.curve.jpoint(e, t, n);
            }, l.prototype._dbl = function() {
                var e = this.curve.a, t = this.x, n = this.y, r = this.z, i = r.redSqr().redSqr(), o = t.redSqr(), a = n.redSqr(), l = o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)), s = t.redAdd(t), u = (s = s.redIAdd(s)).redMul(a), c = l.redSqr().redISub(u.redAdd(u)), d = u.redISub(c), f = a.redSqr();
                f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                var h = l.redMul(d).redISub(f), p = n.redAdd(n).redMul(r);
                return this.curve.jpoint(c, h, p);
            }, l.prototype.trpl = function() {
                if (!this.curve.zeroA) return this.dbl().add(this);
                var e = this.x.redSqr(), t = this.y.redSqr(), n = this.z.redSqr(), r = t.redSqr(), i = e.redAdd(e).redIAdd(e), o = i.redSqr(), a = this.x.redAdd(t).redSqr().redISub(e).redISub(r), l = (a = (a = (a = a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(), s = r.redIAdd(r);
                s = (s = (s = s.redIAdd(s)).redIAdd(s)).redIAdd(s);
                var u = i.redIAdd(a).redSqr().redISub(o).redISub(l).redISub(s), c = t.redMul(u);
                c = (c = c.redIAdd(c)).redIAdd(c);
                var d = this.x.redMul(l).redISub(c);
                d = (d = d.redIAdd(d)).redIAdd(d);
                var f = this.y.redMul(u.redMul(s.redISub(u)).redISub(a.redMul(l)));
                f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                var h = this.z.redAdd(a).redSqr().redISub(n).redISub(l);
                return this.curve.jpoint(d, f, h);
            }, l.prototype.mul = function(e, n) {
                return e = new t(e, n), this.curve._wnafMul(this, e);
            }, l.prototype.eq = function(e) {
                if ("affine" === e.type) return this.eq(e.toJ());
                if (this === e) return !0;
                var t = this.z.redSqr(), n = e.z.redSqr();
                if (0 !== this.x.redMul(n).redISub(e.x.redMul(t)).cmpn(0)) return !1;
                var r = t.redMul(this.z), i = n.redMul(e.z);
                return 0 === this.y.redMul(i).redISub(e.y.redMul(r)).cmpn(0);
            }, l.prototype.eqXToP = function(e) {
                var t = this.z.redSqr(), n = e.toRed(this.curve.red).redMul(t);
                if (0 === this.x.cmp(n)) return !0;
                for(var r = e.clone(), i = this.curve.redN.redMul(t);;){
                    if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
                    if (n.redIAdd(i), 0 === this.x.cmp(n)) return !0;
                }
            }, l.prototype.inspect = function() {
                return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
            }, l.prototype.isInfinity = function() {
                return 0 === this.z.cmpn(0);
            }, $cf61b77dbdb95489$var$as;
        }(), t.mont = function() {
            if ($cf61b77dbdb95489$var$us) return $cf61b77dbdb95489$var$ss;
            $cf61b77dbdb95489$var$us = 1;
            var e = $cf61b77dbdb95489$var$Pl(), t = $cf61b77dbdb95489$var$ui(), n = $cf61b77dbdb95489$var$ps(), r = $cf61b77dbdb95489$var$es();
            function i(t) {
                n.call(this, "mont", t), this.a = new e(t.a, 16).toRed(this.red), this.b = new e(t.b, 16).toRed(this.red), this.i4 = new e(4).toRed(this.red).redInvm(), this.two = new e(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
            }
            function o(t, r, i) {
                n.BasePoint.call(this, t, "projective"), null === r && null === i ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new e(r, 16), this.z = new e(i, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
            }
            return t(i, n), $cf61b77dbdb95489$var$ss = i, i.prototype.validate = function(e) {
                var t = e.normalize().x, n = t.redSqr(), r = n.redMul(t).redAdd(n.redMul(this.a)).redAdd(t);
                return 0 === r.redSqrt().redSqr().cmp(r);
            }, t(o, n.BasePoint), i.prototype.decodePoint = function(e, t) {
                return this.point(r.toArray(e, t), 1);
            }, i.prototype.point = function(e, t) {
                return new o(this, e, t);
            }, i.prototype.pointFromJSON = function(e) {
                return o.fromJSON(this, e);
            }, o.prototype.precompute = function() {}, o.prototype._encode = function() {
                return this.getX().toArray("be", this.curve.p.byteLength());
            }, o.fromJSON = function(e, t) {
                return new o(e, t[0], t[1] || e.one);
            }, o.prototype.inspect = function() {
                return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
            }, o.prototype.isInfinity = function() {
                return 0 === this.z.cmpn(0);
            }, o.prototype.dbl = function() {
                var e = this.x.redAdd(this.z).redSqr(), t = this.x.redSub(this.z).redSqr(), n = e.redSub(t), r = e.redMul(t), i = n.redMul(t.redAdd(this.curve.a24.redMul(n)));
                return this.curve.point(r, i);
            }, o.prototype.add = function() {
                throw new Error("Not supported on Montgomery curve");
            }, o.prototype.diffAdd = function(e, t) {
                var n = this.x.redAdd(this.z), r = this.x.redSub(this.z), i = e.x.redAdd(e.z), o = e.x.redSub(e.z).redMul(n), a = i.redMul(r), l = t.z.redMul(o.redAdd(a).redSqr()), s = t.x.redMul(o.redISub(a).redSqr());
                return this.curve.point(l, s);
            }, o.prototype.mul = function(e) {
                for(var t = e.clone(), n = this, r = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1))i.push(t.andln(1));
                for(var o = i.length - 1; o >= 0; o--)0 === i[o] ? (n = n.diffAdd(r, this), r = r.dbl()) : (r = n.diffAdd(r, this), n = n.dbl());
                return r;
            }, o.prototype.mulAdd = function() {
                throw new Error("Not supported on Montgomery curve");
            }, o.prototype.jumlAdd = function() {
                throw new Error("Not supported on Montgomery curve");
            }, o.prototype.eq = function(e) {
                return 0 === this.getX().cmp(e.getX());
            }, o.prototype.normalize = function() {
                return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
            }, o.prototype.getX = function() {
                return this.normalize(), this.x.fromRed();
            }, $cf61b77dbdb95489$var$ss;
        }(), t.edwards = function() {
            if ($cf61b77dbdb95489$var$ds) return $cf61b77dbdb95489$var$cs;
            $cf61b77dbdb95489$var$ds = 1;
            var e = $cf61b77dbdb95489$var$es(), t = $cf61b77dbdb95489$var$Pl(), n = $cf61b77dbdb95489$var$ui(), r = $cf61b77dbdb95489$var$ps(), i = e.assert;
            function o(e) {
                this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, r.call(this, "edwards", e), this.a = new t(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new t(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new t(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), i(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
            }
            function a(e, n, i, o, a) {
                r.BasePoint.call(this, e, "projective"), null === n && null === i && null === o ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new t(n, 16), this.y = new t(i, 16), this.z = o ? new t(o, 16) : this.curve.one, this.t = a && new t(a, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
            }
            return n(o, r), $cf61b77dbdb95489$var$cs = o, o.prototype._mulA = function(e) {
                return this.mOneA ? e.redNeg() : this.a.redMul(e);
            }, o.prototype._mulC = function(e) {
                return this.oneC ? e : this.c.redMul(e);
            }, o.prototype.jpoint = function(e, t, n, r) {
                return this.point(e, t, n, r);
            }, o.prototype.pointFromX = function(e, n) {
                (e = new t(e, 16)).red || (e = e.toRed(this.red));
                var r = e.redSqr(), i = this.c2.redSub(this.a.redMul(r)), o = this.one.redSub(this.c2.redMul(this.d).redMul(r)), a = i.redMul(o.redInvm()), l = a.redSqrt();
                if (0 !== l.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
                var s = l.fromRed().isOdd();
                return (n && !s || !n && s) && (l = l.redNeg()), this.point(e, l);
            }, o.prototype.pointFromY = function(e, n) {
                (e = new t(e, 16)).red || (e = e.toRed(this.red));
                var r = e.redSqr(), i = r.redSub(this.c2), o = r.redMul(this.d).redMul(this.c2).redSub(this.a), a = i.redMul(o.redInvm());
                if (0 === a.cmp(this.zero)) {
                    if (n) throw new Error("invalid point");
                    return this.point(this.zero, e);
                }
                var l = a.redSqrt();
                if (0 !== l.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
                return l.fromRed().isOdd() !== n && (l = l.redNeg()), this.point(l, e);
            }, o.prototype.validate = function(e) {
                if (e.isInfinity()) return !0;
                e.normalize();
                var t = e.x.redSqr(), n = e.y.redSqr(), r = t.redMul(this.a).redAdd(n), i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(n)));
                return 0 === r.cmp(i);
            }, n(a, r.BasePoint), o.prototype.pointFromJSON = function(e) {
                return a.fromJSON(this, e);
            }, o.prototype.point = function(e, t, n, r) {
                return new a(this, e, t, n, r);
            }, a.fromJSON = function(e, t) {
                return new a(e, t[0], t[1], t[2]);
            }, a.prototype.inspect = function() {
                return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
            }, a.prototype.isInfinity = function() {
                return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
            }, a.prototype._extDbl = function() {
                var e = this.x.redSqr(), t = this.y.redSqr(), n = this.z.redSqr();
                n = n.redIAdd(n);
                var r = this.curve._mulA(e), i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t), o = r.redAdd(t), a = o.redSub(n), l = r.redSub(t), s = i.redMul(a), u = o.redMul(l), c = i.redMul(l), d = a.redMul(o);
                return this.curve.point(s, u, d, c);
            }, a.prototype._projDbl = function() {
                var e, t, n, r, i, o, a = this.x.redAdd(this.y).redSqr(), l = this.x.redSqr(), s = this.y.redSqr();
                if (this.curve.twisted) {
                    var u = (r = this.curve._mulA(l)).redAdd(s);
                    this.zOne ? (e = a.redSub(l).redSub(s).redMul(u.redSub(this.curve.two)), t = u.redMul(r.redSub(s)), n = u.redSqr().redSub(u).redSub(u)) : (i = this.z.redSqr(), o = u.redSub(i).redISub(i), e = a.redSub(l).redISub(s).redMul(o), t = u.redMul(r.redSub(s)), n = u.redMul(o));
                } else r = l.redAdd(s), i = this.curve._mulC(this.z).redSqr(), o = r.redSub(i).redSub(i), e = this.curve._mulC(a.redISub(r)).redMul(o), t = this.curve._mulC(r).redMul(l.redISub(s)), n = r.redMul(o);
                return this.curve.point(e, t, n);
            }, a.prototype.dbl = function() {
                return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
            }, a.prototype._extAdd = function(e) {
                var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)), n = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)), r = this.t.redMul(this.curve.dd).redMul(e.t), i = this.z.redMul(e.z.redAdd(e.z)), o = n.redSub(t), a = i.redSub(r), l = i.redAdd(r), s = n.redAdd(t), u = o.redMul(a), c = l.redMul(s), d = o.redMul(s), f = a.redMul(l);
                return this.curve.point(u, c, f, d);
            }, a.prototype._projAdd = function(e) {
                var t, n, r = this.z.redMul(e.z), i = r.redSqr(), o = this.x.redMul(e.x), a = this.y.redMul(e.y), l = this.curve.d.redMul(o).redMul(a), s = i.redSub(l), u = i.redAdd(l), c = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(o).redISub(a), d = r.redMul(s).redMul(c);
                return this.curve.twisted ? (t = r.redMul(u).redMul(a.redSub(this.curve._mulA(o))), n = s.redMul(u)) : (t = r.redMul(u).redMul(a.redSub(o)), n = this.curve._mulC(s).redMul(u)), this.curve.point(d, t, n);
            }, a.prototype.add = function(e) {
                return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
            }, a.prototype.mul = function(e) {
                return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
            }, a.prototype.mulAdd = function(e, t, n) {
                return this.curve._wnafMulAdd(1, [
                    this,
                    t
                ], [
                    e,
                    n
                ], 2, !1);
            }, a.prototype.jmulAdd = function(e, t, n) {
                return this.curve._wnafMulAdd(1, [
                    this,
                    t
                ], [
                    e,
                    n
                ], 2, !0);
            }, a.prototype.normalize = function() {
                if (this.zOne) return this;
                var e = this.z.redInvm();
                return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
            }, a.prototype.neg = function() {
                return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
            }, a.prototype.getX = function() {
                return this.normalize(), this.x.fromRed();
            }, a.prototype.getY = function() {
                return this.normalize(), this.y.fromRed();
            }, a.prototype.eq = function(e) {
                return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
            }, a.prototype.eqXToP = function(e) {
                var t = e.toRed(this.curve.red).redMul(this.z);
                if (0 === this.x.cmp(t)) return !0;
                for(var n = e.clone(), r = this.curve.redN.redMul(this.z);;){
                    if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
                    if (t.redIAdd(r), 0 === this.x.cmp(t)) return !0;
                }
            }, a.prototype.toP = a.prototype.normalize, a.prototype.mixedAdd = a.prototype.add, $cf61b77dbdb95489$var$cs;
        }();
    }($cf61b77dbdb95489$var$hs)), $cf61b77dbdb95489$var$hs;
}
var $cf61b77dbdb95489$var$gs, $cf61b77dbdb95489$var$bs, $cf61b77dbdb95489$var$ys, $cf61b77dbdb95489$var$vs, $cf61b77dbdb95489$var$Is, $cf61b77dbdb95489$var$Ms, $cf61b77dbdb95489$var$Es, $cf61b77dbdb95489$var$xs, $cf61b77dbdb95489$var$Ss, $cf61b77dbdb95489$var$ws, $cf61b77dbdb95489$var$ks, $cf61b77dbdb95489$var$Ns, $cf61b77dbdb95489$var$Us, $cf61b77dbdb95489$var$Rs, $cf61b77dbdb95489$var$Ls, $cf61b77dbdb95489$var$Cs, $cf61b77dbdb95489$var$zs, $cf61b77dbdb95489$var$Ts, $cf61b77dbdb95489$var$Ds = {};
function $cf61b77dbdb95489$var$Fs() {
    return $cf61b77dbdb95489$var$ys || ($cf61b77dbdb95489$var$ys = 1, function(e) {
        var t, n = e, r = $cf61b77dbdb95489$var$Ai(), i = $cf61b77dbdb95489$var$ms(), o = $cf61b77dbdb95489$var$es().assert;
        function a(e) {
            "short" === e.type ? this.curve = new i.short(e) : "edwards" === e.type ? this.curve = new i.edwards(e) : this.curve = new i.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, o(this.g.validate(), "Invalid curve"), o(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
        }
        function l(e, t) {
            Object.defineProperty(n, e, {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    var r = new a(t);
                    return Object.defineProperty(n, e, {
                        configurable: !0,
                        enumerable: !0,
                        value: r
                    }), r;
                }
            });
        }
        n.PresetCurve = a, l("p192", {
            type: "short",
            prime: "p192",
            p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
            a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
            b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
            n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
            hash: r.sha256,
            gRed: !1,
            g: [
                "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
                "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
            ]
        }), l("p224", {
            type: "short",
            prime: "p224",
            p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
            a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
            b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
            n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
            hash: r.sha256,
            gRed: !1,
            g: [
                "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
                "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
            ]
        }), l("p256", {
            type: "short",
            prime: null,
            p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
            a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
            b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
            n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
            hash: r.sha256,
            gRed: !1,
            g: [
                "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
                "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
            ]
        }), l("p384", {
            type: "short",
            prime: null,
            p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
            a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
            b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
            n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
            hash: r.sha384,
            gRed: !1,
            g: [
                "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
                "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
            ]
        }), l("p521", {
            type: "short",
            prime: null,
            p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
            a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
            b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
            n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
            hash: r.sha512,
            gRed: !1,
            g: [
                "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
                "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
            ]
        }), l("curve25519", {
            type: "mont",
            prime: "p25519",
            p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
            a: "76d06",
            b: "1",
            n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
            hash: r.sha256,
            gRed: !1,
            g: [
                "9"
            ]
        }), l("ed25519", {
            type: "edwards",
            prime: "p25519",
            p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
            a: "-1",
            c: "1",
            d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
            n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
            hash: r.sha256,
            gRed: !1,
            g: [
                "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
                "6666666666666666666666666666666666666666666666666666666666666658"
            ]
        });
        try {
            t = $cf61b77dbdb95489$var$bs ? $cf61b77dbdb95489$var$gs : ($cf61b77dbdb95489$var$bs = 1, $cf61b77dbdb95489$var$gs = {
                doubles: {
                    step: 4,
                    points: [
                        [
                            "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                            "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
                        ],
                        [
                            "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                            "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
                        ],
                        [
                            "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                            "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
                        ],
                        [
                            "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                            "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
                        ],
                        [
                            "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                            "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
                        ],
                        [
                            "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                            "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
                        ],
                        [
                            "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                            "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
                        ],
                        [
                            "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                            "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
                        ],
                        [
                            "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                            "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
                        ],
                        [
                            "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                            "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
                        ],
                        [
                            "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                            "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
                        ],
                        [
                            "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                            "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
                        ],
                        [
                            "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                            "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
                        ],
                        [
                            "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                            "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
                        ],
                        [
                            "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                            "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
                        ],
                        [
                            "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                            "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
                        ],
                        [
                            "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                            "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
                        ],
                        [
                            "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                            "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
                        ],
                        [
                            "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                            "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
                        ],
                        [
                            "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                            "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
                        ],
                        [
                            "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                            "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
                        ],
                        [
                            "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                            "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
                        ],
                        [
                            "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                            "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
                        ],
                        [
                            "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                            "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
                        ],
                        [
                            "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                            "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
                        ],
                        [
                            "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                            "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
                        ],
                        [
                            "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                            "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
                        ],
                        [
                            "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                            "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
                        ],
                        [
                            "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                            "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
                        ],
                        [
                            "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                            "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
                        ],
                        [
                            "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                            "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
                        ],
                        [
                            "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                            "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
                        ],
                        [
                            "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                            "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
                        ],
                        [
                            "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                            "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
                        ],
                        [
                            "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                            "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
                        ],
                        [
                            "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                            "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
                        ],
                        [
                            "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                            "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
                        ],
                        [
                            "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                            "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
                        ],
                        [
                            "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                            "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
                        ],
                        [
                            "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                            "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
                        ],
                        [
                            "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                            "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
                        ],
                        [
                            "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                            "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
                        ],
                        [
                            "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                            "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
                        ],
                        [
                            "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                            "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
                        ],
                        [
                            "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                            "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
                        ],
                        [
                            "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                            "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
                        ],
                        [
                            "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                            "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
                        ],
                        [
                            "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                            "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
                        ],
                        [
                            "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                            "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
                        ],
                        [
                            "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                            "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
                        ],
                        [
                            "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                            "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
                        ],
                        [
                            "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                            "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
                        ],
                        [
                            "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                            "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
                        ],
                        [
                            "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                            "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
                        ],
                        [
                            "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                            "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
                        ],
                        [
                            "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                            "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
                        ],
                        [
                            "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                            "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
                        ],
                        [
                            "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                            "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
                        ],
                        [
                            "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                            "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
                        ],
                        [
                            "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                            "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
                        ],
                        [
                            "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                            "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
                        ],
                        [
                            "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                            "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
                        ],
                        [
                            "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                            "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
                        ],
                        [
                            "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                            "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
                        ],
                        [
                            "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                            "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
                        ]
                    ]
                },
                naf: {
                    wnd: 7,
                    points: [
                        [
                            "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                            "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
                        ],
                        [
                            "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                            "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
                        ],
                        [
                            "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                            "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
                        ],
                        [
                            "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                            "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
                        ],
                        [
                            "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                            "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
                        ],
                        [
                            "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                            "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
                        ],
                        [
                            "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                            "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
                        ],
                        [
                            "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                            "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
                        ],
                        [
                            "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                            "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
                        ],
                        [
                            "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                            "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
                        ],
                        [
                            "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                            "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
                        ],
                        [
                            "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                            "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
                        ],
                        [
                            "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                            "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
                        ],
                        [
                            "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                            "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
                        ],
                        [
                            "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                            "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
                        ],
                        [
                            "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                            "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
                        ],
                        [
                            "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                            "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
                        ],
                        [
                            "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                            "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
                        ],
                        [
                            "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                            "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
                        ],
                        [
                            "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                            "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
                        ],
                        [
                            "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                            "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
                        ],
                        [
                            "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                            "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
                        ],
                        [
                            "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                            "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
                        ],
                        [
                            "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                            "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
                        ],
                        [
                            "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                            "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
                        ],
                        [
                            "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                            "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
                        ],
                        [
                            "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                            "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
                        ],
                        [
                            "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                            "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
                        ],
                        [
                            "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                            "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
                        ],
                        [
                            "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                            "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
                        ],
                        [
                            "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                            "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
                        ],
                        [
                            "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                            "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
                        ],
                        [
                            "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                            "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
                        ],
                        [
                            "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                            "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
                        ],
                        [
                            "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                            "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
                        ],
                        [
                            "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                            "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
                        ],
                        [
                            "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                            "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
                        ],
                        [
                            "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                            "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
                        ],
                        [
                            "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                            "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
                        ],
                        [
                            "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                            "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
                        ],
                        [
                            "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                            "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
                        ],
                        [
                            "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                            "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
                        ],
                        [
                            "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                            "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
                        ],
                        [
                            "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                            "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
                        ],
                        [
                            "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                            "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
                        ],
                        [
                            "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                            "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
                        ],
                        [
                            "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                            "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
                        ],
                        [
                            "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                            "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
                        ],
                        [
                            "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                            "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
                        ],
                        [
                            "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                            "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
                        ],
                        [
                            "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                            "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
                        ],
                        [
                            "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                            "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
                        ],
                        [
                            "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                            "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
                        ],
                        [
                            "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                            "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
                        ],
                        [
                            "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                            "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
                        ],
                        [
                            "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                            "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
                        ],
                        [
                            "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                            "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
                        ],
                        [
                            "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                            "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
                        ],
                        [
                            "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                            "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
                        ],
                        [
                            "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                            "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
                        ],
                        [
                            "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                            "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
                        ],
                        [
                            "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                            "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
                        ],
                        [
                            "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                            "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
                        ],
                        [
                            "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                            "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
                        ],
                        [
                            "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                            "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
                        ],
                        [
                            "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                            "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
                        ],
                        [
                            "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                            "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
                        ],
                        [
                            "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                            "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
                        ],
                        [
                            "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                            "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
                        ],
                        [
                            "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                            "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
                        ],
                        [
                            "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                            "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
                        ],
                        [
                            "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                            "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
                        ],
                        [
                            "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                            "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
                        ],
                        [
                            "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                            "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
                        ],
                        [
                            "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                            "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
                        ],
                        [
                            "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                            "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
                        ],
                        [
                            "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                            "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
                        ],
                        [
                            "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                            "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
                        ],
                        [
                            "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                            "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
                        ],
                        [
                            "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                            "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
                        ],
                        [
                            "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                            "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
                        ],
                        [
                            "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                            "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
                        ],
                        [
                            "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                            "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
                        ],
                        [
                            "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                            "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
                        ],
                        [
                            "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                            "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
                        ],
                        [
                            "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                            "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
                        ],
                        [
                            "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                            "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
                        ],
                        [
                            "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                            "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
                        ],
                        [
                            "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                            "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
                        ],
                        [
                            "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                            "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
                        ],
                        [
                            "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                            "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
                        ],
                        [
                            "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                            "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
                        ],
                        [
                            "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                            "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
                        ],
                        [
                            "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                            "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
                        ],
                        [
                            "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                            "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
                        ],
                        [
                            "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                            "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
                        ],
                        [
                            "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                            "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
                        ],
                        [
                            "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                            "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
                        ],
                        [
                            "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                            "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
                        ],
                        [
                            "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                            "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
                        ],
                        [
                            "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                            "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
                        ],
                        [
                            "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                            "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
                        ],
                        [
                            "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                            "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
                        ],
                        [
                            "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                            "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
                        ],
                        [
                            "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                            "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
                        ],
                        [
                            "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                            "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
                        ],
                        [
                            "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                            "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
                        ],
                        [
                            "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                            "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
                        ],
                        [
                            "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                            "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
                        ],
                        [
                            "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                            "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
                        ],
                        [
                            "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                            "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
                        ],
                        [
                            "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                            "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
                        ],
                        [
                            "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                            "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
                        ],
                        [
                            "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                            "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
                        ],
                        [
                            "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                            "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
                        ],
                        [
                            "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                            "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
                        ],
                        [
                            "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                            "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
                        ],
                        [
                            "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                            "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
                        ],
                        [
                            "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                            "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
                        ],
                        [
                            "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                            "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
                        ],
                        [
                            "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                            "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
                        ],
                        [
                            "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                            "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
                        ],
                        [
                            "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                            "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
                        ],
                        [
                            "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                            "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
                        ],
                        [
                            "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                            "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
                        ],
                        [
                            "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                            "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
                        ],
                        [
                            "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                            "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
                        ]
                    ]
                }
            });
        } catch (e) {
            t = void 0;
        }
        l("secp256k1", {
            type: "short",
            prime: "k256",
            p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
            a: "0",
            b: "7",
            n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
            h: "1",
            hash: r.sha256,
            beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
            lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
            basis: [
                {
                    a: "3086d221a7d46bcde86c90e49284eb15",
                    b: "-e4437ed6010e88286f547fa90abfe4c3"
                },
                {
                    a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                    b: "3086d221a7d46bcde86c90e49284eb15"
                }
            ],
            gRed: !1,
            g: [
                "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
                "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
                t
            ]
        });
    }($cf61b77dbdb95489$var$Ds)), $cf61b77dbdb95489$var$Ds;
}
function $cf61b77dbdb95489$var$Vs() {
    if ($cf61b77dbdb95489$var$ks) return $cf61b77dbdb95489$var$ws;
    $cf61b77dbdb95489$var$ks = 1;
    var e = $cf61b77dbdb95489$var$Pl(), t = function() {
        if ($cf61b77dbdb95489$var$Is) return $cf61b77dbdb95489$var$vs;
        $cf61b77dbdb95489$var$Is = 1;
        var e = $cf61b77dbdb95489$var$Ai(), t = $cf61b77dbdb95489$var$$l(), n = $cf61b77dbdb95489$var$ri();
        function r(e) {
            if (!(this instanceof r)) return new r(e);
            this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
            var i = t.toArray(e.entropy, e.entropyEnc || "hex"), o = t.toArray(e.nonce, e.nonceEnc || "hex"), a = t.toArray(e.pers, e.persEnc || "hex");
            n(i.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(i, o, a);
        }
        return $cf61b77dbdb95489$var$vs = r, r.prototype._init = function(e, t, n) {
            var r = e.concat(t).concat(n);
            this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
            for(var i = 0; i < this.V.length; i++)this.K[i] = 0, this.V[i] = 1;
            this._update(r), this._reseed = 1, this.reseedInterval = 281474976710656;
        }, r.prototype._hmac = function() {
            return new e.hmac(this.hash, this.K);
        }, r.prototype._update = function(e) {
            var t = this._hmac().update(this.V).update([
                0
            ]);
            e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([
                1
            ]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
        }, r.prototype.reseed = function(e, r, i, o) {
            "string" != typeof r && (o = i, i = r, r = null), e = t.toArray(e, r), i = t.toArray(i, o), n(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(i || [])), this._reseed = 1;
        }, r.prototype.generate = function(e, n, r, i) {
            if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
            "string" != typeof n && (i = r, r = n, n = null), r && (r = t.toArray(r, i || "hex"), this._update(r));
            for(var o = []; o.length < e;)this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
            var a = o.slice(0, e);
            return this._update(r), this._reseed++, t.encode(a, n);
        }, $cf61b77dbdb95489$var$vs;
    }(), n = $cf61b77dbdb95489$var$es(), r = $cf61b77dbdb95489$var$Fs(), i = $cf61b77dbdb95489$var$rs(), o = n.assert, a = function() {
        if ($cf61b77dbdb95489$var$Es) return $cf61b77dbdb95489$var$Ms;
        $cf61b77dbdb95489$var$Es = 1;
        var e = $cf61b77dbdb95489$var$Pl(), t = $cf61b77dbdb95489$var$es().assert;
        function n(e, t) {
            this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
        }
        return $cf61b77dbdb95489$var$Ms = n, n.fromPublic = function(e, t, r) {
            return t instanceof n ? t : new n(e, {
                pub: t,
                pubEnc: r
            });
        }, n.fromPrivate = function(e, t, r) {
            return t instanceof n ? t : new n(e, {
                priv: t,
                privEnc: r
            });
        }, n.prototype.validate = function() {
            var e = this.getPublic();
            return e.isInfinity() ? {
                result: !1,
                reason: "Invalid public key"
            } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
                result: !0,
                reason: null
            } : {
                result: !1,
                reason: "Public key * N != O"
            } : {
                result: !1,
                reason: "Public key is not a point"
            };
        }, n.prototype.getPublic = function(e, t) {
            return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
        }, n.prototype.getPrivate = function(e) {
            return "hex" === e ? this.priv.toString(16, 2) : this.priv;
        }, n.prototype._importPrivate = function(t, n) {
            this.priv = new e(t, n || 16), this.priv = this.priv.umod(this.ec.curve.n);
        }, n.prototype._importPublic = function(e, n) {
            if (e.x || e.y) return "mont" === this.ec.curve.type ? t(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || t(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
            this.pub = this.ec.curve.decodePoint(e, n);
        }, n.prototype.derive = function(e) {
            return e.validate() || t(e.validate(), "public point not validated"), e.mul(this.priv).getX();
        }, n.prototype.sign = function(e, t, n) {
            return this.ec.sign(e, this, t, n);
        }, n.prototype.verify = function(e, t, n) {
            return this.ec.verify(e, t, this, void 0, n);
        }, n.prototype.inspect = function() {
            return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
        }, $cf61b77dbdb95489$var$Ms;
    }(), l = function() {
        if ($cf61b77dbdb95489$var$Ss) return $cf61b77dbdb95489$var$xs;
        $cf61b77dbdb95489$var$Ss = 1;
        var e = $cf61b77dbdb95489$var$Pl(), t = $cf61b77dbdb95489$var$es(), n = t.assert;
        function r(t, i) {
            if (t instanceof r) return t;
            this._importDER(t, i) || (n(t.r && t.s, "Signature without r or s"), this.r = new e(t.r, 16), this.s = new e(t.s, 16), void 0 === t.recoveryParam ? this.recoveryParam = null : this.recoveryParam = t.recoveryParam);
        }
        function i() {
            this.place = 0;
        }
        function o(e, t) {
            var n = e[t.place++];
            if (!(128 & n)) return n;
            var r = 15 & n;
            if (0 === r || r > 4) return !1;
            if (0 === e[t.place]) return !1;
            for(var i = 0, o = 0, a = t.place; o < r; o++, a++)i <<= 8, i |= e[a], i >>>= 0;
            return !(i <= 127) && (t.place = a, i);
        }
        function a(e) {
            for(var t = 0, n = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < n;)t++;
            return 0 === t ? e : e.slice(t);
        }
        function l(e, t) {
            if (t < 128) e.push(t);
            else {
                var n = 1 + (Math.log(t) / Math.LN2 >>> 3);
                for(e.push(128 | n); --n;)e.push(t >>> (n << 3) & 255);
                e.push(t);
            }
        }
        return $cf61b77dbdb95489$var$xs = r, r.prototype._importDER = function(n, r) {
            n = t.toArray(n, r);
            var a = new i;
            if (48 !== n[a.place++]) return !1;
            var l = o(n, a);
            if (!1 === l) return !1;
            if (l + a.place !== n.length) return !1;
            if (2 !== n[a.place++]) return !1;
            var s = o(n, a);
            if (!1 === s) return !1;
            if (128 & n[a.place]) return !1;
            var u = n.slice(a.place, s + a.place);
            if (a.place += s, 2 !== n[a.place++]) return !1;
            var c = o(n, a);
            if (!1 === c) return !1;
            if (n.length !== c + a.place) return !1;
            if (128 & n[a.place]) return !1;
            var d = n.slice(a.place, c + a.place);
            if (0 === u[0]) {
                if (!(128 & u[1])) return !1;
                u = u.slice(1);
            }
            if (0 === d[0]) {
                if (!(128 & d[1])) return !1;
                d = d.slice(1);
            }
            return this.r = new e(u), this.s = new e(d), this.recoveryParam = null, !0;
        }, r.prototype.toDER = function(e) {
            var n = this.r.toArray(), r = this.s.toArray();
            for(128 & n[0] && (n = [
                0
            ].concat(n)), 128 & r[0] && (r = [
                0
            ].concat(r)), n = a(n), r = a(r); !(r[0] || 128 & r[1]);)r = r.slice(1);
            var i = [
                2
            ];
            l(i, n.length), (i = i.concat(n)).push(2), l(i, r.length);
            var o = i.concat(r), s = [
                48
            ];
            return l(s, o.length), s = s.concat(o), t.encode(s, e);
        }, $cf61b77dbdb95489$var$xs;
    }();
    function s(e) {
        if (!(this instanceof s)) return new s(e);
        "string" == typeof e && (o(Object.prototype.hasOwnProperty.call(r, e), "Unknown curve " + e), e = r[e]), e instanceof r.PresetCurve && (e = {
            curve: e
        }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
    }
    return $cf61b77dbdb95489$var$ws = s, s.prototype.keyPair = function(e) {
        return new a(this, e);
    }, s.prototype.keyFromPrivate = function(e, t) {
        return a.fromPrivate(this, e, t);
    }, s.prototype.keyFromPublic = function(e, t) {
        return a.fromPublic(this, e, t);
    }, s.prototype.genKeyPair = function(n) {
        n || (n = {});
        for(var r = new t({
            hash: this.hash,
            pers: n.pers,
            persEnc: n.persEnc || "utf8",
            entropy: n.entropy || i(this.hash.hmacStrength),
            entropyEnc: n.entropy && n.entropyEnc || "utf8",
            nonce: this.n.toArray()
        }), o = this.n.byteLength(), a = this.n.sub(new e(2));;){
            var l = new e(r.generate(o));
            if (!(l.cmp(a) > 0)) return l.iaddn(1), this.keyFromPrivate(l);
        }
    }, s.prototype._truncateToN = function(t, n, r) {
        var i;
        if (e.isBN(t) || "number" == typeof t) i = (t = new e(t, 16)).byteLength();
        else if ("object" == typeof t) i = t.length, t = new e(t, 16);
        else {
            var o = t.toString();
            i = o.length + 1 >>> 1, t = new e(o, 16);
        }
        "number" != typeof r && (r = 8 * i);
        var a = r - this.n.bitLength();
        return a > 0 && (t = t.ushrn(a)), !n && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
    }, s.prototype.sign = function(n, r, i, a) {
        if ("object" == typeof i && (a = i, i = null), a || (a = {}), "string" != typeof n && "number" != typeof n && !e.isBN(n)) {
            o("object" == typeof n && n && "number" == typeof n.length, "Expected message to be an array-like, a hex string, or a BN instance"), o(n.length >>> 0 === n.length);
            for(var s = 0; s < n.length; s++)o((255 & n[s]) === n[s]);
        }
        r = this.keyFromPrivate(r, i), n = this._truncateToN(n, !1, a.msgBitLength), o(!n.isNeg(), "Can not sign a negative message");
        var u = this.n.byteLength(), c = r.getPrivate().toArray("be", u), d = n.toArray("be", u);
        o(new e(d).eq(n), "Can not sign message");
        for(var f = new t({
            hash: this.hash,
            entropy: c,
            nonce: d,
            pers: a.pers,
            persEnc: a.persEnc || "utf8"
        }), h = this.n.sub(new e(1)), p = 0;; p++){
            var m = a.k ? a.k(p) : new e(f.generate(this.n.byteLength()));
            if (!((m = this._truncateToN(m, !0)).cmpn(1) <= 0 || m.cmp(h) >= 0)) {
                var g = this.g.mul(m);
                if (!g.isInfinity()) {
                    var b = g.getX(), y = b.umod(this.n);
                    if (0 !== y.cmpn(0)) {
                        var v = m.invm(this.n).mul(y.mul(r.getPrivate()).iadd(n));
                        if (0 !== (v = v.umod(this.n)).cmpn(0)) {
                            var I = (g.getY().isOdd() ? 1 : 0) | (0 !== b.cmp(y) ? 2 : 0);
                            return a.canonical && v.cmp(this.nh) > 0 && (v = this.n.sub(v), I ^= 1), new l({
                                r: y,
                                s: v,
                                recoveryParam: I
                            });
                        }
                    }
                }
            }
        }
    }, s.prototype.verify = function(e, t, n, r, i) {
        i || (i = {}), e = this._truncateToN(e, !1, i.msgBitLength), n = this.keyFromPublic(n, r);
        var o = (t = new l(t, "hex")).r, a = t.s;
        if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
        if (a.cmpn(1) < 0 || a.cmp(this.n) >= 0) return !1;
        var s, u = a.invm(this.n), c = u.mul(e).umod(this.n), d = u.mul(o).umod(this.n);
        return this.curve._maxwellTrick ? !(s = this.g.jmulAdd(c, n.getPublic(), d)).isInfinity() && s.eqXToP(o) : !(s = this.g.mulAdd(c, n.getPublic(), d)).isInfinity() && 0 === s.getX().umod(this.n).cmp(o);
    }, s.prototype.recoverPubKey = function(t, n, r, i) {
        o((3 & r) === r, "The recovery param is more than two bits"), n = new l(n, i);
        var a = this.n, s = new e(t), u = n.r, c = n.s, d = 1 & r, f = r >> 1;
        if (u.cmp(this.curve.p.umod(this.curve.n)) >= 0 && f) throw new Error("Unable to find sencond key candinate");
        u = f ? this.curve.pointFromX(u.add(this.curve.n), d) : this.curve.pointFromX(u, d);
        var h = n.r.invm(a), p = a.sub(s).mul(h).umod(a), m = c.mul(h).umod(a);
        return this.g.mulAdd(p, u, m);
    }, s.prototype.getKeyRecoveryParam = function(e, t, n, r) {
        if (null !== (t = new l(t, r)).recoveryParam) return t.recoveryParam;
        for(var i = 0; i < 4; i++){
            var o;
            try {
                o = this.recoverPubKey(e, t, i);
            } catch (e) {
                continue;
            }
            if (o.eq(n)) return i;
        }
        throw new Error("Unable to find valid recovery factor");
    }, $cf61b77dbdb95489$var$ws;
}
function $cf61b77dbdb95489$var$As() {
    if ($cf61b77dbdb95489$var$zs) return $cf61b77dbdb95489$var$Cs;
    $cf61b77dbdb95489$var$zs = 1;
    var e = $cf61b77dbdb95489$var$Ai(), t = $cf61b77dbdb95489$var$Fs(), n = $cf61b77dbdb95489$var$es(), r = n.assert, i = n.parseBytes, o = function() {
        if ($cf61b77dbdb95489$var$Us) return $cf61b77dbdb95489$var$Ns;
        $cf61b77dbdb95489$var$Us = 1;
        var e = $cf61b77dbdb95489$var$es(), t = e.assert, n = e.parseBytes, r = e.cachedProperty;
        function i(e, t) {
            this.eddsa = e, this._secret = n(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = n(t.pub);
        }
        return i.fromPublic = function(e, t) {
            return t instanceof i ? t : new i(e, {
                pub: t
            });
        }, i.fromSecret = function(e, t) {
            return t instanceof i ? t : new i(e, {
                secret: t
            });
        }, i.prototype.secret = function() {
            return this._secret;
        }, r(i, "pubBytes", function() {
            return this.eddsa.encodePoint(this.pub());
        }), r(i, "pub", function() {
            return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
        }), r(i, "privBytes", function() {
            var e = this.eddsa, t = this.hash(), n = e.encodingLength - 1, r = t.slice(0, e.encodingLength);
            return r[0] &= 248, r[n] &= 127, r[n] |= 64, r;
        }), r(i, "priv", function() {
            return this.eddsa.decodeInt(this.privBytes());
        }), r(i, "hash", function() {
            return this.eddsa.hash().update(this.secret()).digest();
        }), r(i, "messagePrefix", function() {
            return this.hash().slice(this.eddsa.encodingLength);
        }), i.prototype.sign = function(e) {
            return t(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
        }, i.prototype.verify = function(e, t) {
            return this.eddsa.verify(e, t, this);
        }, i.prototype.getSecret = function(n) {
            return t(this._secret, "KeyPair is public only"), e.encode(this.secret(), n);
        }, i.prototype.getPublic = function(t) {
            return e.encode(this.pubBytes(), t);
        }, $cf61b77dbdb95489$var$Ns = i;
    }(), a = function() {
        if ($cf61b77dbdb95489$var$Ls) return $cf61b77dbdb95489$var$Rs;
        $cf61b77dbdb95489$var$Ls = 1;
        var e = $cf61b77dbdb95489$var$Pl(), t = $cf61b77dbdb95489$var$es(), n = t.assert, r = t.cachedProperty, i = t.parseBytes;
        function o(t, r) {
            this.eddsa = t, "object" != typeof r && (r = i(r)), Array.isArray(r) && (n(r.length === 2 * t.encodingLength, "Signature has invalid size"), r = {
                R: r.slice(0, t.encodingLength),
                S: r.slice(t.encodingLength)
            }), n(r.R && r.S, "Signature without R or S"), t.isPoint(r.R) && (this._R = r.R), r.S instanceof e && (this._S = r.S), this._Rencoded = Array.isArray(r.R) ? r.R : r.Rencoded, this._Sencoded = Array.isArray(r.S) ? r.S : r.Sencoded;
        }
        return r(o, "S", function() {
            return this.eddsa.decodeInt(this.Sencoded());
        }), r(o, "R", function() {
            return this.eddsa.decodePoint(this.Rencoded());
        }), r(o, "Rencoded", function() {
            return this.eddsa.encodePoint(this.R());
        }), r(o, "Sencoded", function() {
            return this.eddsa.encodeInt(this.S());
        }), o.prototype.toBytes = function() {
            return this.Rencoded().concat(this.Sencoded());
        }, o.prototype.toHex = function() {
            return t.encode(this.toBytes(), "hex").toUpperCase();
        }, $cf61b77dbdb95489$var$Rs = o;
    }();
    function l(n) {
        if (r("ed25519" === n, "only tested with ed25519 so far"), !(this instanceof l)) return new l(n);
        n = t[n].curve, this.curve = n, this.g = n.g, this.g.precompute(n.n.bitLength() + 1), this.pointClass = n.point().constructor, this.encodingLength = Math.ceil(n.n.bitLength() / 8), this.hash = e.sha512;
    }
    return $cf61b77dbdb95489$var$Cs = l, l.prototype.sign = function(e, t) {
        e = i(e);
        var n = this.keyFromSecret(t), r = this.hashInt(n.messagePrefix(), e), o = this.g.mul(r), a = this.encodePoint(o), l = this.hashInt(a, n.pubBytes(), e).mul(n.priv()), s = r.add(l).umod(this.curve.n);
        return this.makeSignature({
            R: o,
            S: s,
            Rencoded: a
        });
    }, l.prototype.verify = function(e, t, n) {
        if (e = i(e), (t = this.makeSignature(t)).S().gte(t.eddsa.curve.n) || t.S().isNeg()) return !1;
        var r = this.keyFromPublic(n), o = this.hashInt(t.Rencoded(), r.pubBytes(), e), a = this.g.mul(t.S());
        return t.R().add(r.pub().mul(o)).eq(a);
    }, l.prototype.hashInt = function() {
        for(var e = this.hash(), t = 0; t < arguments.length; t++)e.update(arguments[t]);
        return n.intFromLE(e.digest()).umod(this.curve.n);
    }, l.prototype.keyFromPublic = function(e) {
        return o.fromPublic(this, e);
    }, l.prototype.keyFromSecret = function(e) {
        return o.fromSecret(this, e);
    }, l.prototype.makeSignature = function(e) {
        return e instanceof a ? e : new a(this, e);
    }, l.prototype.encodePoint = function(e) {
        var t = e.getY().toArray("le", this.encodingLength);
        return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
    }, l.prototype.decodePoint = function(e) {
        var t = (e = n.parseBytes(e)).length - 1, r = e.slice(0, t).concat(-129 & e[t]), i = !!(128 & e[t]), o = n.intFromLE(r);
        return this.curve.pointFromY(o, i);
    }, l.prototype.encodeInt = function(e) {
        return e.toArray("le", this.encodingLength);
    }, l.prototype.decodeInt = function(e) {
        return n.intFromLE(e);
    }, l.prototype.isPoint = function(e) {
        return e instanceof this.pointClass;
    }, $cf61b77dbdb95489$var$Cs;
}
function $cf61b77dbdb95489$var$js(e) {
    if (!Number.isSafeInteger(e) || e < 0) throw new Error("positive integer expected, got " + e);
}
function $cf61b77dbdb95489$var$Os(e, ...t) {
    if (!function(e) {
        return e instanceof Uint8Array || ArrayBuffer.isView(e) && "Uint8Array" === e.constructor.name;
    }(e)) throw new Error("Uint8Array expected");
    if (t.length > 0 && !t.includes(e.length)) throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function $cf61b77dbdb95489$var$Qs(e, t = !0) {
    if (e.destroyed) throw new Error("Hash instance has been destroyed");
    if (t && e.finished) throw new Error("Hash#digest() has already been called");
}
function $cf61b77dbdb95489$var$qs(e, t) {
    $cf61b77dbdb95489$var$Os(e);
    const n = t.outputLen;
    if (e.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
}
$cf61b77dbdb95489$var$Ts || ($cf61b77dbdb95489$var$Ts = 1, function(e) {
    var t = e;
    t.version = $cf61b77dbdb95489$var$Kl, t.utils = $cf61b77dbdb95489$var$es(), t.rand = $cf61b77dbdb95489$var$rs(), t.curve = $cf61b77dbdb95489$var$ms(), t.curves = $cf61b77dbdb95489$var$Fs(), t.ec = $cf61b77dbdb95489$var$Vs(), t.eddsa = $cf61b77dbdb95489$var$As();
}($cf61b77dbdb95489$var$Bl));
const $cf61b77dbdb95489$var$Ws = BigInt(2 ** 32 - 1), $cf61b77dbdb95489$var$Gs = BigInt(32);
function $cf61b77dbdb95489$var$Bs(e, t = !1) {
    return t ? {
        h: Number(e & $cf61b77dbdb95489$var$Ws),
        l: Number(e >> $cf61b77dbdb95489$var$Gs & $cf61b77dbdb95489$var$Ws)
    } : {
        h: 0 | Number(e >> $cf61b77dbdb95489$var$Gs & $cf61b77dbdb95489$var$Ws),
        l: 0 | Number(e & $cf61b77dbdb95489$var$Ws)
    };
}
const $cf61b77dbdb95489$var$Ks = "object" == typeof globalThis && "crypto" in globalThis ? globalThis.crypto : void 0;
function $cf61b77dbdb95489$var$Ys(e) {
    return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function $cf61b77dbdb95489$var$Zs(e, t) {
    return e << 32 - t | e >>> t;
}
const $cf61b77dbdb95489$var$Xs = 68 === new Uint8Array(new Uint32Array([
    287454020
]).buffer)[0];
function $cf61b77dbdb95489$var$Ps(e) {
    return e << 24 & 4278190080 | e << 8 & 16711680 | e >>> 8 & 65280 | e >>> 24 & 255;
}
function $cf61b77dbdb95489$var$Js(e) {
    for(let t = 0; t < e.length; t++)e[t] = $cf61b77dbdb95489$var$Ps(e[t]);
}
function $cf61b77dbdb95489$var$Hs(e) {
    return "string" == typeof e && (e = function(e) {
        if ("string" != typeof e) throw new Error("utf8ToBytes expected string, got " + typeof e);
        return new Uint8Array((new TextEncoder).encode(e));
    }(e)), $cf61b77dbdb95489$var$Os(e), e;
}
class $cf61b77dbdb95489$var$_s {
    clone() {
        return this._cloneInto();
    }
}
function $cf61b77dbdb95489$var$$s(e) {
    const t = (t)=>e().update($cf61b77dbdb95489$var$Hs(t)).digest(), n = e();
    return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = ()=>e(), t;
}
function $cf61b77dbdb95489$var$eu(e = 32) {
    if ($cf61b77dbdb95489$var$Ks && "function" == typeof $cf61b77dbdb95489$var$Ks.getRandomValues) return $cf61b77dbdb95489$var$Ks.getRandomValues(new Uint8Array(e));
    if ($cf61b77dbdb95489$var$Ks && "function" == typeof $cf61b77dbdb95489$var$Ks.randomBytes) return $cf61b77dbdb95489$var$Ks.randomBytes(e);
    throw new Error("crypto.getRandomValues must be defined");
}
const $cf61b77dbdb95489$var$tu = [], $cf61b77dbdb95489$var$nu = [], $cf61b77dbdb95489$var$ru = [], $cf61b77dbdb95489$var$iu = BigInt(0), $cf61b77dbdb95489$var$ou = BigInt(1), $cf61b77dbdb95489$var$au = BigInt(2), $cf61b77dbdb95489$var$lu = BigInt(7), $cf61b77dbdb95489$var$su = BigInt(256), $cf61b77dbdb95489$var$uu = BigInt(113);
for(let e = 0, t = $cf61b77dbdb95489$var$ou, n = 1, r = 0; e < 24; e++){
    [n, r] = [
        r,
        (2 * n + 3 * r) % 5
    ], $cf61b77dbdb95489$var$tu.push(2 * (5 * r + n)), $cf61b77dbdb95489$var$nu.push((e + 1) * (e + 2) / 2 % 64);
    let i = $cf61b77dbdb95489$var$iu;
    for(let e = 0; e < 7; e++)t = (t << $cf61b77dbdb95489$var$ou ^ (t >> $cf61b77dbdb95489$var$lu) * $cf61b77dbdb95489$var$uu) % $cf61b77dbdb95489$var$su, t & $cf61b77dbdb95489$var$au && (i ^= $cf61b77dbdb95489$var$ou << ($cf61b77dbdb95489$var$ou << BigInt(e)) - $cf61b77dbdb95489$var$ou);
    $cf61b77dbdb95489$var$ru.push(i);
}
const [$cf61b77dbdb95489$var$cu, $cf61b77dbdb95489$var$du] = function(e, t = !1) {
    let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
    for(let i = 0; i < e.length; i++){
        const { h: o, l: a } = $cf61b77dbdb95489$var$Bs(e[i], t);
        [n[i], r[i]] = [
            o,
            a
        ];
    }
    return [
        n,
        r
    ];
}($cf61b77dbdb95489$var$ru, !0), $cf61b77dbdb95489$var$fu = (e, t, n)=>n > 32 ? ((e, t, n)=>t << n - 32 | e >>> 64 - n)(e, t, n) : ((e, t, n)=>e << n | t >>> 32 - n)(e, t, n), $cf61b77dbdb95489$var$hu = (e, t, n)=>n > 32 ? ((e, t, n)=>e << n - 32 | t >>> 64 - n)(e, t, n) : ((e, t, n)=>t << n | e >>> 32 - n)(e, t, n);
class $cf61b77dbdb95489$var$pu extends $cf61b77dbdb95489$var$_s {
    constructor(e, t, n, r = !1, i = 24){
        if (super(), this.blockLen = e, this.suffix = t, this.outputLen = n, this.enableXOF = r, this.rounds = i, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, $cf61b77dbdb95489$var$js(n), 0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        var o;
        this.state = new Uint8Array(200), this.state32 = (o = this.state, new Uint32Array(o.buffer, o.byteOffset, Math.floor(o.byteLength / 4)));
    }
    keccak() {
        $cf61b77dbdb95489$var$Xs || $cf61b77dbdb95489$var$Js(this.state32), function(e, t = 24) {
            const n = new Uint32Array(10);
            for(let r = 24 - t; r < 24; r++){
                for(let t = 0; t < 10; t++)n[t] = e[t] ^ e[t + 10] ^ e[t + 20] ^ e[t + 30] ^ e[t + 40];
                for(let t = 0; t < 10; t += 2){
                    const r = (t + 8) % 10, i = (t + 2) % 10, o = n[i], a = n[i + 1], l = $cf61b77dbdb95489$var$fu(o, a, 1) ^ n[r], s = $cf61b77dbdb95489$var$hu(o, a, 1) ^ n[r + 1];
                    for(let n = 0; n < 50; n += 10)e[t + n] ^= l, e[t + n + 1] ^= s;
                }
                let t = e[2], i = e[3];
                for(let n = 0; n < 24; n++){
                    const r = $cf61b77dbdb95489$var$nu[n], o = $cf61b77dbdb95489$var$fu(t, i, r), a = $cf61b77dbdb95489$var$hu(t, i, r), l = $cf61b77dbdb95489$var$tu[n];
                    t = e[l], i = e[l + 1], e[l] = o, e[l + 1] = a;
                }
                for(let t = 0; t < 50; t += 10){
                    for(let r = 0; r < 10; r++)n[r] = e[t + r];
                    for(let r = 0; r < 10; r++)e[t + r] ^= ~n[(r + 2) % 10] & n[(r + 4) % 10];
                }
                e[0] ^= $cf61b77dbdb95489$var$cu[r], e[1] ^= $cf61b77dbdb95489$var$du[r];
            }
            n.fill(0);
        }(this.state32, this.rounds), $cf61b77dbdb95489$var$Xs || $cf61b77dbdb95489$var$Js(this.state32), this.posOut = 0, this.pos = 0;
    }
    update(e) {
        $cf61b77dbdb95489$var$Qs(this);
        const { blockLen: t, state: n } = this, r = (e = $cf61b77dbdb95489$var$Hs(e)).length;
        for(let i = 0; i < r;){
            const o = Math.min(t - this.pos, r - i);
            for(let t = 0; t < o; t++)n[this.pos++] ^= e[i++];
            this.pos === t && this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = !0;
        const { state: e, suffix: t, pos: n, blockLen: r } = this;
        e[n] ^= t, 128 & t && n === r - 1 && this.keccak(), e[r - 1] ^= 128, this.keccak();
    }
    writeInto(e) {
        $cf61b77dbdb95489$var$Qs(this, !1), $cf61b77dbdb95489$var$Os(e), this.finish();
        const t = this.state, { blockLen: n } = this;
        for(let r = 0, i = e.length; r < i;){
            this.posOut >= n && this.keccak();
            const o = Math.min(n - this.posOut, i - r);
            e.set(t.subarray(this.posOut, this.posOut + o), r), this.posOut += o, r += o;
        }
        return e;
    }
    xofInto(e) {
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(e);
    }
    xof(e) {
        return $cf61b77dbdb95489$var$js(e), this.xofInto(new Uint8Array(e));
    }
    digestInto(e) {
        if ($cf61b77dbdb95489$var$qs(e, this), this.finished) throw new Error("digest() was already called");
        return this.writeInto(e), this.destroy(), e;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(e) {
        const { blockLen: t, suffix: n, outputLen: r, rounds: i, enableXOF: o } = this;
        return e || (e = new $cf61b77dbdb95489$var$pu(t, n, r, o, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = n, e.outputLen = r, e.enableXOF = o, e.destroyed = this.destroyed, e;
    }
}
var $cf61b77dbdb95489$var$mu, $cf61b77dbdb95489$var$gu, $cf61b77dbdb95489$var$bu;
function $cf61b77dbdb95489$var$yu(e) {
    if (!Number.isSafeInteger(e) || e < 0) throw new Error("positive integer expected, got " + e);
}
function $cf61b77dbdb95489$var$vu(e) {
    return e instanceof Uint8Array || ArrayBuffer.isView(e) && "Uint8Array" === e.constructor.name;
}
function $cf61b77dbdb95489$var$Iu(e, ...t) {
    if (!$cf61b77dbdb95489$var$vu(e)) throw new Error("Uint8Array expected");
    if (t.length > 0 && !t.includes(e.length)) throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function $cf61b77dbdb95489$var$Mu(e, t = !0) {
    if (e.destroyed) throw new Error("Hash instance has been destroyed");
    if (t && e.finished) throw new Error("Hash#digest() has already been called");
}
function $cf61b77dbdb95489$var$Eu(e) {
    if ("boolean" != typeof e) throw new Error(`boolean expected, not ${e}`);
}
$cf61b77dbdb95489$var$mu = 1, $cf61b77dbdb95489$var$gu = 136, $cf61b77dbdb95489$var$bu = 32, $cf61b77dbdb95489$var$$s(()=>new $cf61b77dbdb95489$var$pu($cf61b77dbdb95489$var$gu, $cf61b77dbdb95489$var$mu, $cf61b77dbdb95489$var$bu));
const $cf61b77dbdb95489$var$xu = (e)=>new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4));
if (!(68 === new Uint8Array(new Uint32Array([
    287454020
]).buffer)[0])) throw new Error("Non little-endian hardware is not supported");
function $cf61b77dbdb95489$var$Su(e) {
    if ("string" == typeof e) e = function(e) {
        if ("string" != typeof e) throw new Error("string expected");
        return new Uint8Array((new TextEncoder).encode(e));
    }(e);
    else {
        if (!$cf61b77dbdb95489$var$vu(e)) throw new Error("Uint8Array expected, got " + typeof e);
        e = $cf61b77dbdb95489$var$Nu(e);
    }
    return e;
}
function $cf61b77dbdb95489$var$wu(e, t, n = !0) {
    if (void 0 === t) return new Uint8Array(e);
    if (t.length !== e) throw new Error("invalid output length, expected " + e + ", got: " + t.length);
    if (n && !function(e) {
        return e.byteOffset % 4 == 0;
    }(t)) throw new Error("invalid output, must be aligned");
    return t;
}
function $cf61b77dbdb95489$var$ku(e, t, n, r) {
    if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, n, r);
    const i = BigInt(32), o = BigInt(4294967295), a = Number(n >> i & o), l = Number(n & o);
    e.setUint32(t + 4, a, r), e.setUint32(t + 0, l, r);
}
function $cf61b77dbdb95489$var$Nu(e) {
    return Uint8Array.from(e);
}
function $cf61b77dbdb95489$var$Uu(...e) {
    for(let t = 0; t < e.length; t++)e[t].fill(0);
}
const $cf61b77dbdb95489$var$Ru = (e)=>Uint8Array.from(e.split("").map((e)=>e.charCodeAt(0))), $cf61b77dbdb95489$var$Lu = $cf61b77dbdb95489$var$Ru("expand 16-byte k"), $cf61b77dbdb95489$var$Cu = $cf61b77dbdb95489$var$Ru("expand 32-byte k"), $cf61b77dbdb95489$var$zu = $cf61b77dbdb95489$var$xu($cf61b77dbdb95489$var$Lu), $cf61b77dbdb95489$var$Tu = $cf61b77dbdb95489$var$xu($cf61b77dbdb95489$var$Cu);
function $cf61b77dbdb95489$var$Du(e, t) {
    return e << t | e >>> 32 - t;
}
function $cf61b77dbdb95489$var$Fu(e) {
    return e.byteOffset % 4 == 0;
}
const $cf61b77dbdb95489$var$Vu = 2 ** 32 - 1, $cf61b77dbdb95489$var$Au = new Uint32Array;
const $cf61b77dbdb95489$var$ju = (e, t)=>255 & e[t++] | (255 & e[t++]) << 8;
class $cf61b77dbdb95489$var$Ou {
    constructor(e){
        this.blockLen = 16, this.outputLen = 16, this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.pos = 0, this.finished = !1, $cf61b77dbdb95489$var$Iu(e = $cf61b77dbdb95489$var$Su(e), 32);
        const t = $cf61b77dbdb95489$var$ju(e, 0), n = $cf61b77dbdb95489$var$ju(e, 2), r = $cf61b77dbdb95489$var$ju(e, 4), i = $cf61b77dbdb95489$var$ju(e, 6), o = $cf61b77dbdb95489$var$ju(e, 8), a = $cf61b77dbdb95489$var$ju(e, 10), l = $cf61b77dbdb95489$var$ju(e, 12), s = $cf61b77dbdb95489$var$ju(e, 14);
        this.r[0] = 8191 & t, this.r[1] = 8191 & (t >>> 13 | n << 3), this.r[2] = 7939 & (n >>> 10 | r << 6), this.r[3] = 8191 & (r >>> 7 | i << 9), this.r[4] = 255 & (i >>> 4 | o << 12), this.r[5] = o >>> 1 & 8190, this.r[6] = 8191 & (o >>> 14 | a << 2), this.r[7] = 8065 & (a >>> 11 | l << 5), this.r[8] = 8191 & (l >>> 8 | s << 8), this.r[9] = s >>> 5 & 127;
        for(let t = 0; t < 8; t++)this.pad[t] = $cf61b77dbdb95489$var$ju(e, 16 + 2 * t);
    }
    process(e, t, n = !1) {
        const r = n ? 0 : 2048, { h: i, r: o } = this, a = o[0], l = o[1], s = o[2], u = o[3], c = o[4], d = o[5], f = o[6], h = o[7], p = o[8], m = o[9], g = $cf61b77dbdb95489$var$ju(e, t + 0), b = $cf61b77dbdb95489$var$ju(e, t + 2), y = $cf61b77dbdb95489$var$ju(e, t + 4), v = $cf61b77dbdb95489$var$ju(e, t + 6), I = $cf61b77dbdb95489$var$ju(e, t + 8), M = $cf61b77dbdb95489$var$ju(e, t + 10), E = $cf61b77dbdb95489$var$ju(e, t + 12), x = $cf61b77dbdb95489$var$ju(e, t + 14);
        let S = i[0] + (8191 & g), w = i[1] + (8191 & (g >>> 13 | b << 3)), k = i[2] + (8191 & (b >>> 10 | y << 6)), N = i[3] + (8191 & (y >>> 7 | v << 9)), U = i[4] + (8191 & (v >>> 4 | I << 12)), R = i[5] + (I >>> 1 & 8191), L = i[6] + (8191 & (I >>> 14 | M << 2)), C = i[7] + (8191 & (M >>> 11 | E << 5)), z = i[8] + (8191 & (E >>> 8 | x << 8)), T = i[9] + (x >>> 5 | r), D = 0, F = D + S * a + w * (5 * m) + k * (5 * p) + N * (5 * h) + U * (5 * f);
        D = F >>> 13, F &= 8191, F += R * (5 * d) + L * (5 * c) + C * (5 * u) + z * (5 * s) + T * (5 * l), D += F >>> 13, F &= 8191;
        let V = D + S * l + w * a + k * (5 * m) + N * (5 * p) + U * (5 * h);
        D = V >>> 13, V &= 8191, V += R * (5 * f) + L * (5 * d) + C * (5 * c) + z * (5 * u) + T * (5 * s), D += V >>> 13, V &= 8191;
        let A = D + S * s + w * l + k * a + N * (5 * m) + U * (5 * p);
        D = A >>> 13, A &= 8191, A += R * (5 * h) + L * (5 * f) + C * (5 * d) + z * (5 * c) + T * (5 * u), D += A >>> 13, A &= 8191;
        let j = D + S * u + w * s + k * l + N * a + U * (5 * m);
        D = j >>> 13, j &= 8191, j += R * (5 * p) + L * (5 * h) + C * (5 * f) + z * (5 * d) + T * (5 * c), D += j >>> 13, j &= 8191;
        let O = D + S * c + w * u + k * s + N * l + U * a;
        D = O >>> 13, O &= 8191, O += R * (5 * m) + L * (5 * p) + C * (5 * h) + z * (5 * f) + T * (5 * d), D += O >>> 13, O &= 8191;
        let Q = D + S * d + w * c + k * u + N * s + U * l;
        D = Q >>> 13, Q &= 8191, Q += R * a + L * (5 * m) + C * (5 * p) + z * (5 * h) + T * (5 * f), D += Q >>> 13, Q &= 8191;
        let q = D + S * f + w * d + k * c + N * u + U * s;
        D = q >>> 13, q &= 8191, q += R * l + L * a + C * (5 * m) + z * (5 * p) + T * (5 * h), D += q >>> 13, q &= 8191;
        let W = D + S * h + w * f + k * d + N * c + U * u;
        D = W >>> 13, W &= 8191, W += R * s + L * l + C * a + z * (5 * m) + T * (5 * p), D += W >>> 13, W &= 8191;
        let G = D + S * p + w * h + k * f + N * d + U * c;
        D = G >>> 13, G &= 8191, G += R * u + L * s + C * l + z * a + T * (5 * m), D += G >>> 13, G &= 8191;
        let B = D + S * m + w * p + k * h + N * f + U * d;
        D = B >>> 13, B &= 8191, B += R * c + L * u + C * s + z * l + T * a, D += B >>> 13, B &= 8191, D = (D << 2) + D | 0, D = D + F | 0, F = 8191 & D, D >>>= 13, V += D, i[0] = F, i[1] = V, i[2] = A, i[3] = j, i[4] = O, i[5] = Q, i[6] = q, i[7] = W, i[8] = G, i[9] = B;
    }
    finalize() {
        const { h: e, pad: t } = this, n = new Uint16Array(10);
        let r = e[1] >>> 13;
        e[1] &= 8191;
        for(let t = 2; t < 10; t++)e[t] += r, r = e[t] >>> 13, e[t] &= 8191;
        e[0] += 5 * r, r = e[0] >>> 13, e[0] &= 8191, e[1] += r, r = e[1] >>> 13, e[1] &= 8191, e[2] += r, n[0] = e[0] + 5, r = n[0] >>> 13, n[0] &= 8191;
        for(let t = 1; t < 10; t++)n[t] = e[t] + r, r = n[t] >>> 13, n[t] &= 8191;
        n[9] -= 8192;
        let i = (1 ^ r) - 1;
        for(let e = 0; e < 10; e++)n[e] &= i;
        i = ~i;
        for(let t = 0; t < 10; t++)e[t] = e[t] & i | n[t];
        e[0] = 65535 & (e[0] | e[1] << 13), e[1] = 65535 & (e[1] >>> 3 | e[2] << 10), e[2] = 65535 & (e[2] >>> 6 | e[3] << 7), e[3] = 65535 & (e[3] >>> 9 | e[4] << 4), e[4] = 65535 & (e[4] >>> 12 | e[5] << 1 | e[6] << 14), e[5] = 65535 & (e[6] >>> 2 | e[7] << 11), e[6] = 65535 & (e[7] >>> 5 | e[8] << 8), e[7] = 65535 & (e[8] >>> 8 | e[9] << 5);
        let o = e[0] + t[0];
        e[0] = 65535 & o;
        for(let n = 1; n < 8; n++)o = (e[n] + t[n] | 0) + (o >>> 16) | 0, e[n] = 65535 & o;
        $cf61b77dbdb95489$var$Uu(n);
    }
    update(e) {
        $cf61b77dbdb95489$var$Mu(this);
        const { buffer: t, blockLen: n } = this, r = (e = $cf61b77dbdb95489$var$Su(e)).length;
        for(let i = 0; i < r;){
            const o = Math.min(n - this.pos, r - i);
            if (o !== n) t.set(e.subarray(i, i + o), this.pos), this.pos += o, i += o, this.pos === n && (this.process(t, 0, !1), this.pos = 0);
            else for(; n <= r - i; i += n)this.process(e, i);
        }
        return this;
    }
    destroy() {
        $cf61b77dbdb95489$var$Uu(this.h, this.r, this.buffer, this.pad);
    }
    digestInto(e) {
        $cf61b77dbdb95489$var$Mu(this), function(e, t) {
            $cf61b77dbdb95489$var$Iu(e);
            const n = t.outputLen;
            if (e.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
        }(e, this), this.finished = !0;
        const { buffer: t, h: n } = this;
        let { pos: r } = this;
        if (r) {
            for(t[r++] = 1; r < 16; r++)t[r] = 0;
            this.process(t, 0, !0);
        }
        this.finalize();
        let i = 0;
        for(let t = 0; t < 8; t++)e[i++] = n[t] >>> 0, e[i++] = n[t] >>> 8;
        return e;
    }
    digest() {
        const { buffer: e, outputLen: t } = this;
        this.digestInto(e);
        const n = e.slice(0, t);
        return this.destroy(), n;
    }
}
const $cf61b77dbdb95489$var$Qu = function(e) {
    const t = (t, n)=>e(n).update($cf61b77dbdb95489$var$Su(t)).digest(), n = e(new Uint8Array(32));
    return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = (t)=>e(t), t;
}((e)=>new $cf61b77dbdb95489$var$Ou(e));
const $cf61b77dbdb95489$var$qu = function(e, t) {
    const { allowShortKeys: n, extendNonceFn: r, counterLength: i, counterRight: o, rounds: a } = function(e, t) {
        if (null == t || "object" != typeof t) throw new Error("options must be defined");
        return Object.assign(e, t);
    }({
        allowShortKeys: !1,
        counterLength: 8,
        counterRight: !1,
        rounds: 20
    }, t);
    if ("function" != typeof e) throw new Error("core must be a function");
    return $cf61b77dbdb95489$var$yu(i), $cf61b77dbdb95489$var$yu(a), $cf61b77dbdb95489$var$Eu(o), $cf61b77dbdb95489$var$Eu(n), (t, l, s, u, c = 0)=>{
        $cf61b77dbdb95489$var$Iu(t), $cf61b77dbdb95489$var$Iu(l), $cf61b77dbdb95489$var$Iu(s);
        const d = s.length;
        if (void 0 === u && (u = new Uint8Array(d)), $cf61b77dbdb95489$var$Iu(u), $cf61b77dbdb95489$var$yu(c), c < 0 || c >= $cf61b77dbdb95489$var$Vu) throw new Error("arx: counter overflow");
        if (u.length < d) throw new Error(`arx: output (${u.length}) is shorter than data (${d})`);
        const f = [];
        let h, p, m = t.length;
        if (32 === m) f.push(h = $cf61b77dbdb95489$var$Nu(t)), p = $cf61b77dbdb95489$var$Tu;
        else {
            if (16 !== m || !n) throw new Error(`arx: invalid 32-byte key, got length=${m}`);
            h = new Uint8Array(32), h.set(t), h.set(t, 16), p = $cf61b77dbdb95489$var$zu, f.push(h);
        }
        $cf61b77dbdb95489$var$Fu(l) || f.push(l = $cf61b77dbdb95489$var$Nu(l));
        const g = $cf61b77dbdb95489$var$xu(h);
        if (r) {
            if (24 !== l.length) throw new Error("arx: extended nonce must be 24 bytes");
            r(p, g, $cf61b77dbdb95489$var$xu(l.subarray(0, 16)), g), l = l.subarray(16);
        }
        const b = 16 - i;
        if (b !== l.length) throw new Error(`arx: nonce must be ${b} or 16 bytes`);
        if (12 !== b) {
            const e = new Uint8Array(12);
            e.set(l, o ? 0 : 12 - l.length), l = e, f.push(l);
        }
        const y = $cf61b77dbdb95489$var$xu(l);
        return function(e, t, n, r, i, o, a, l) {
            const s = i.length, u = new Uint8Array(64), c = $cf61b77dbdb95489$var$xu(u), d = $cf61b77dbdb95489$var$Fu(i) && $cf61b77dbdb95489$var$Fu(o), f = d ? $cf61b77dbdb95489$var$xu(i) : $cf61b77dbdb95489$var$Au, h = d ? $cf61b77dbdb95489$var$xu(o) : $cf61b77dbdb95489$var$Au;
            for(let p = 0; p < s; a++){
                if (e(t, n, r, c, a, l), a >= $cf61b77dbdb95489$var$Vu) throw new Error("arx: counter overflow");
                const m = Math.min(64, s - p);
                if (d && 64 === m) {
                    const e = p / 4;
                    if (p % 4 != 0) throw new Error("arx: invalid block position");
                    for(let t, n = 0; n < 16; n++)t = e + n, h[t] = f[t] ^ c[n];
                    p += 64;
                    continue;
                }
                for(let e, t = 0; t < m; t++)e = p + t, o[e] = i[e] ^ u[t];
                p += m;
            }
        }(e, p, g, y, s, u, c, a), $cf61b77dbdb95489$var$Uu(...f), u;
    };
}(function(e, t, n, r, i, o = 20) {
    let a = e[0], l = e[1], s = e[2], u = e[3], c = t[0], d = t[1], f = t[2], h = t[3], p = t[4], m = t[5], g = t[6], b = t[7], y = i, v = n[0], I = n[1], M = n[2], E = a, x = l, S = s, w = u, k = c, N = d, U = f, R = h, L = p, C = m, z = g, T = b, D = y, F = v, V = I, A = M;
    for(let e = 0; e < o; e += 2)E = E + k | 0, D = $cf61b77dbdb95489$var$Du(D ^ E, 16), L = L + D | 0, k = $cf61b77dbdb95489$var$Du(k ^ L, 12), E = E + k | 0, D = $cf61b77dbdb95489$var$Du(D ^ E, 8), L = L + D | 0, k = $cf61b77dbdb95489$var$Du(k ^ L, 7), x = x + N | 0, F = $cf61b77dbdb95489$var$Du(F ^ x, 16), C = C + F | 0, N = $cf61b77dbdb95489$var$Du(N ^ C, 12), x = x + N | 0, F = $cf61b77dbdb95489$var$Du(F ^ x, 8), C = C + F | 0, N = $cf61b77dbdb95489$var$Du(N ^ C, 7), S = S + U | 0, V = $cf61b77dbdb95489$var$Du(V ^ S, 16), z = z + V | 0, U = $cf61b77dbdb95489$var$Du(U ^ z, 12), S = S + U | 0, V = $cf61b77dbdb95489$var$Du(V ^ S, 8), z = z + V | 0, U = $cf61b77dbdb95489$var$Du(U ^ z, 7), w = w + R | 0, A = $cf61b77dbdb95489$var$Du(A ^ w, 16), T = T + A | 0, R = $cf61b77dbdb95489$var$Du(R ^ T, 12), w = w + R | 0, A = $cf61b77dbdb95489$var$Du(A ^ w, 8), T = T + A | 0, R = $cf61b77dbdb95489$var$Du(R ^ T, 7), E = E + N | 0, A = $cf61b77dbdb95489$var$Du(A ^ E, 16), z = z + A | 0, N = $cf61b77dbdb95489$var$Du(N ^ z, 12), E = E + N | 0, A = $cf61b77dbdb95489$var$Du(A ^ E, 8), z = z + A | 0, N = $cf61b77dbdb95489$var$Du(N ^ z, 7), x = x + U | 0, D = $cf61b77dbdb95489$var$Du(D ^ x, 16), T = T + D | 0, U = $cf61b77dbdb95489$var$Du(U ^ T, 12), x = x + U | 0, D = $cf61b77dbdb95489$var$Du(D ^ x, 8), T = T + D | 0, U = $cf61b77dbdb95489$var$Du(U ^ T, 7), S = S + R | 0, F = $cf61b77dbdb95489$var$Du(F ^ S, 16), L = L + F | 0, R = $cf61b77dbdb95489$var$Du(R ^ L, 12), S = S + R | 0, F = $cf61b77dbdb95489$var$Du(F ^ S, 8), L = L + F | 0, R = $cf61b77dbdb95489$var$Du(R ^ L, 7), w = w + k | 0, V = $cf61b77dbdb95489$var$Du(V ^ w, 16), C = C + V | 0, k = $cf61b77dbdb95489$var$Du(k ^ C, 12), w = w + k | 0, V = $cf61b77dbdb95489$var$Du(V ^ w, 8), C = C + V | 0, k = $cf61b77dbdb95489$var$Du(k ^ C, 7);
    let j = 0;
    r[j++] = a + E | 0, r[j++] = l + x | 0, r[j++] = s + S | 0, r[j++] = u + w | 0, r[j++] = c + k | 0, r[j++] = d + N | 0, r[j++] = f + U | 0, r[j++] = h + R | 0, r[j++] = p + L | 0, r[j++] = m + C | 0, r[j++] = g + z | 0, r[j++] = b + T | 0, r[j++] = y + D | 0, r[j++] = v + F | 0, r[j++] = I + V | 0, r[j++] = M + A | 0;
}, {
    counterRight: !1,
    counterLength: 4,
    allowShortKeys: !1
}), $cf61b77dbdb95489$var$Wu = new Uint8Array(16), $cf61b77dbdb95489$var$Gu = (e, t)=>{
    e.update(t);
    const n = t.length % 16;
    n && e.update($cf61b77dbdb95489$var$Wu.subarray(n));
}, $cf61b77dbdb95489$var$Bu = new Uint8Array(32);
function $cf61b77dbdb95489$var$Ku(e, t, n, r, i) {
    const o = e(t, n, $cf61b77dbdb95489$var$Bu), a = $cf61b77dbdb95489$var$Qu.create(o);
    i && $cf61b77dbdb95489$var$Gu(a, i), $cf61b77dbdb95489$var$Gu(a, r);
    const l = new Uint8Array(16), s = ((e)=>new DataView(e.buffer, e.byteOffset, e.byteLength))(l);
    $cf61b77dbdb95489$var$ku(s, 0, BigInt(i ? i.length : 0), !0), $cf61b77dbdb95489$var$ku(s, 8, BigInt(r.length), !0), a.update(l);
    const u = a.digest();
    return $cf61b77dbdb95489$var$Uu(o, l), u;
}
function $cf61b77dbdb95489$var$Yu(e, t, n) {
    return e & t ^ ~e & n;
}
function $cf61b77dbdb95489$var$Zu(e, t, n) {
    return e & t ^ e & n ^ t & n;
}
((e, t)=>{
    function n(n1, ...r) {
        if ($cf61b77dbdb95489$var$Iu(n1), void 0 !== e.nonceLength) {
            const t = r[0];
            if (!t) throw new Error("nonce / iv required");
            e.varSizeNonce ? $cf61b77dbdb95489$var$Iu(t) : $cf61b77dbdb95489$var$Iu(t, e.nonceLength);
        }
        const i = e.tagLength;
        i && void 0 !== r[1] && $cf61b77dbdb95489$var$Iu(r[1]);
        const o = t(n1, ...r), a = (e, t)=>{
            if (void 0 !== t) {
                if (2 !== e) throw new Error("cipher output not supported");
                $cf61b77dbdb95489$var$Iu(t);
            }
        };
        let l = !1;
        return {
            encrypt (e, t) {
                if (l) throw new Error("cannot encrypt() twice with same key + nonce");
                return l = !0, $cf61b77dbdb95489$var$Iu(e), a(o.encrypt.length, t), o.encrypt(e, t);
            },
            decrypt (e, t) {
                if ($cf61b77dbdb95489$var$Iu(e), i && e.length < i) throw new Error("invalid ciphertext length: smaller than tagLength=" + i);
                return a(o.decrypt.length, t), o.decrypt(e, t);
            }
        };
    }
    Object.assign(n, e);
})({
    blockSize: 64,
    nonceLength: 12,
    tagLength: 16
}, ((e)=>(t, n, r)=>({
            encrypt (i, o) {
                const a = i.length;
                (o = $cf61b77dbdb95489$var$wu(a + 16, o, !1)).set(i);
                const l = o.subarray(0, -16);
                e(t, n, l, l, 1);
                const s = $cf61b77dbdb95489$var$Ku(e, t, n, l, r);
                return o.set(s, a), $cf61b77dbdb95489$var$Uu(s), o;
            },
            decrypt (i, o) {
                o = $cf61b77dbdb95489$var$wu(i.length - 16, o, !1);
                const a = i.subarray(0, -16), l = i.subarray(-16), s = $cf61b77dbdb95489$var$Ku(e, t, n, a, r);
                if (!function(e, t) {
                    if (e.length !== t.length) return !1;
                    let n = 0;
                    for(let r = 0; r < e.length; r++)n |= e[r] ^ t[r];
                    return 0 === n;
                }(l, s)) throw new Error("invalid tag");
                return o.set(i.subarray(0, -16)), e(t, n, o, o, 1), $cf61b77dbdb95489$var$Uu(s), o;
            }
        }))($cf61b77dbdb95489$var$qu));
class $cf61b77dbdb95489$var$Xu extends $cf61b77dbdb95489$var$_s {
    constructor(e, t, n, r){
        super(), this.blockLen = e, this.outputLen = t, this.padOffset = n, this.isLE = r, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = $cf61b77dbdb95489$var$Ys(this.buffer);
    }
    update(e) {
        $cf61b77dbdb95489$var$Qs(this);
        const { view: t, buffer: n, blockLen: r } = this, i = (e = $cf61b77dbdb95489$var$Hs(e)).length;
        for(let o = 0; o < i;){
            const a = Math.min(r - this.pos, i - o);
            if (a === r) {
                const t = $cf61b77dbdb95489$var$Ys(e);
                for(; r <= i - o; o += r)this.process(t, o);
                continue;
            }
            n.set(e.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === r && (this.process(t, 0), this.pos = 0);
        }
        return this.length += e.length, this.roundClean(), this;
    }
    digestInto(e) {
        $cf61b77dbdb95489$var$Qs(this), $cf61b77dbdb95489$var$qs(e, this), this.finished = !0;
        const { buffer: t, view: n, blockLen: r, isLE: i } = this;
        let { pos: o } = this;
        t[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > r - o && (this.process(n, 0), o = 0);
        for(let e = o; e < r; e++)t[e] = 0;
        (function(e, t, n, r) {
            if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, n, r);
            const i = BigInt(32), o = BigInt(4294967295), a = Number(n >> i & o), l = Number(n & o), s = r ? 4 : 0, u = r ? 0 : 4;
            e.setUint32(t + s, a, r), e.setUint32(t + u, l, r);
        })(n, r - 8, BigInt(8 * this.length), i), this.process(n, 0);
        const a = $cf61b77dbdb95489$var$Ys(e), l = this.outputLen;
        if (l % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const s = l / 4, u = this.get();
        if (s > u.length) throw new Error("_sha2: outputLen bigger than state");
        for(let e = 0; e < s; e++)a.setUint32(4 * e, u[e], i);
    }
    digest() {
        const { buffer: e, outputLen: t } = this;
        this.digestInto(e);
        const n = e.slice(0, t);
        return this.destroy(), n;
    }
    _cloneInto(e) {
        e || (e = new this.constructor), e.set(...this.get());
        const { blockLen: t, buffer: n, length: r, finished: i, destroyed: o, pos: a } = this;
        return e.length = r, e.pos = a, e.finished = i, e.destroyed = o, r % t && e.buffer.set(n), e;
    }
}
const $cf61b77dbdb95489$var$Pu = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
]), $cf61b77dbdb95489$var$Ju = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
]), $cf61b77dbdb95489$var$Hu = new Uint32Array(64);
class $cf61b77dbdb95489$var$_u extends $cf61b77dbdb95489$var$Xu {
    constructor(){
        super(64, 32, 8, !1), this.A = 0 | $cf61b77dbdb95489$var$Ju[0], this.B = 0 | $cf61b77dbdb95489$var$Ju[1], this.C = 0 | $cf61b77dbdb95489$var$Ju[2], this.D = 0 | $cf61b77dbdb95489$var$Ju[3], this.E = 0 | $cf61b77dbdb95489$var$Ju[4], this.F = 0 | $cf61b77dbdb95489$var$Ju[5], this.G = 0 | $cf61b77dbdb95489$var$Ju[6], this.H = 0 | $cf61b77dbdb95489$var$Ju[7];
    }
    get() {
        const { A: e, B: t, C: n, D: r, E: i, F: o, G: a, H: l } = this;
        return [
            e,
            t,
            n,
            r,
            i,
            o,
            a,
            l
        ];
    }
    set(e, t, n, r, i, o, a, l) {
        this.A = 0 | e, this.B = 0 | t, this.C = 0 | n, this.D = 0 | r, this.E = 0 | i, this.F = 0 | o, this.G = 0 | a, this.H = 0 | l;
    }
    process(e, t) {
        for(let n = 0; n < 16; n++, t += 4)$cf61b77dbdb95489$var$Hu[n] = e.getUint32(t, !1);
        for(let e = 16; e < 64; e++){
            const t = $cf61b77dbdb95489$var$Hu[e - 15], n = $cf61b77dbdb95489$var$Hu[e - 2], r = $cf61b77dbdb95489$var$Zs(t, 7) ^ $cf61b77dbdb95489$var$Zs(t, 18) ^ t >>> 3, i = $cf61b77dbdb95489$var$Zs(n, 17) ^ $cf61b77dbdb95489$var$Zs(n, 19) ^ n >>> 10;
            $cf61b77dbdb95489$var$Hu[e] = i + $cf61b77dbdb95489$var$Hu[e - 7] + r + $cf61b77dbdb95489$var$Hu[e - 16] | 0;
        }
        let { A: n, B: r, C: i, D: o, E: a, F: l, G: s, H: u } = this;
        for(let e = 0; e < 64; e++){
            const t = u + ($cf61b77dbdb95489$var$Zs(a, 6) ^ $cf61b77dbdb95489$var$Zs(a, 11) ^ $cf61b77dbdb95489$var$Zs(a, 25)) + $cf61b77dbdb95489$var$Yu(a, l, s) + $cf61b77dbdb95489$var$Pu[e] + $cf61b77dbdb95489$var$Hu[e] | 0, c = ($cf61b77dbdb95489$var$Zs(n, 2) ^ $cf61b77dbdb95489$var$Zs(n, 13) ^ $cf61b77dbdb95489$var$Zs(n, 22)) + $cf61b77dbdb95489$var$Zu(n, r, i) | 0;
            u = s, s = l, l = a, a = o + t | 0, o = i, i = r, r = n, n = t + c | 0;
        }
        n = n + this.A | 0, r = r + this.B | 0, i = i + this.C | 0, o = o + this.D | 0, a = a + this.E | 0, l = l + this.F | 0, s = s + this.G | 0, u = u + this.H | 0, this.set(n, r, i, o, a, l, s, u);
    }
    roundClean() {
        $cf61b77dbdb95489$var$Hu.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
}
$cf61b77dbdb95489$var$$s(()=>new $cf61b77dbdb95489$var$_u); /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $cf61b77dbdb95489$var$$u = BigInt(0);
function $cf61b77dbdb95489$var$ec(e) {
    return e instanceof Uint8Array || ArrayBuffer.isView(e) && "Uint8Array" === e.constructor.name;
}
function $cf61b77dbdb95489$var$tc(e) {
    if (!$cf61b77dbdb95489$var$ec(e)) throw new Error("Uint8Array expected");
}
const $cf61b77dbdb95489$var$nc = Array.from({
    length: 256
}, (e, t)=>t.toString(16).padStart(2, "0"));
const $cf61b77dbdb95489$var$rc = 48, $cf61b77dbdb95489$var$ic = 57, $cf61b77dbdb95489$var$oc = 65, $cf61b77dbdb95489$var$ac = 70, $cf61b77dbdb95489$var$lc = 97, $cf61b77dbdb95489$var$sc = 102;
function $cf61b77dbdb95489$var$uc(e) {
    return e >= $cf61b77dbdb95489$var$rc && e <= $cf61b77dbdb95489$var$ic ? e - $cf61b77dbdb95489$var$rc : e >= $cf61b77dbdb95489$var$oc && e <= $cf61b77dbdb95489$var$ac ? e - ($cf61b77dbdb95489$var$oc - 10) : e >= $cf61b77dbdb95489$var$lc && e <= $cf61b77dbdb95489$var$sc ? e - ($cf61b77dbdb95489$var$lc - 10) : void 0;
}
function $cf61b77dbdb95489$var$cc(e) {
    if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
    const t = e.length, n = t / 2;
    if (t % 2) throw new Error("hex string expected, got unpadded hex of length " + t);
    const r = new Uint8Array(n);
    for(let t = 0, i = 0; t < n; t++, i += 2){
        const n = $cf61b77dbdb95489$var$uc(e.charCodeAt(i)), o = $cf61b77dbdb95489$var$uc(e.charCodeAt(i + 1));
        if (void 0 === n || void 0 === o) {
            const t = e[i] + e[i + 1];
            throw new Error('hex string expected, got non-hex character "' + t + '" at index ' + i);
        }
        r[t] = 16 * n + o;
    }
    return r;
}
function $cf61b77dbdb95489$var$dc(e) {
    return $cf61b77dbdb95489$var$tc(e), function(e) {
        if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
        return "" === e ? $cf61b77dbdb95489$var$$u : BigInt("0x" + e);
    }(function(e) {
        $cf61b77dbdb95489$var$tc(e);
        let t = "";
        for(let n = 0; n < e.length; n++)t += $cf61b77dbdb95489$var$nc[e[n]];
        return t;
    }(Uint8Array.from(e).reverse()));
}
function $cf61b77dbdb95489$var$fc(e, t) {
    return (function(e, t) {
        return $cf61b77dbdb95489$var$cc(e.toString(16).padStart(2 * t, "0"));
    })(e, t).reverse();
}
function $cf61b77dbdb95489$var$hc(e, t, n) {
    let r;
    if ("string" == typeof t) try {
        r = $cf61b77dbdb95489$var$cc(t);
    } catch (t) {
        throw new Error(e + " must be hex string or Uint8Array, cause: " + t);
    }
    else {
        if (!$cf61b77dbdb95489$var$ec(t)) throw new Error(e + " must be hex string or Uint8Array");
        r = Uint8Array.from(t);
    }
    const i = r.length;
    if ("number" == typeof n && i !== n) throw new Error(e + " of length " + n + " expected, got " + i);
    return r;
}
const $cf61b77dbdb95489$var$pc = (e)=>"bigint" == typeof e && $cf61b77dbdb95489$var$$u <= e;
function $cf61b77dbdb95489$var$mc(e, t, n, r) {
    if (!function(e, t, n) {
        return $cf61b77dbdb95489$var$pc(e) && $cf61b77dbdb95489$var$pc(t) && $cf61b77dbdb95489$var$pc(n) && t <= e && e < n;
    }(t, n, r)) throw new Error("expected valid " + e + ": " + n + " <= n < " + r + ", got " + t);
}
const $cf61b77dbdb95489$var$gc = {
    bigint: (e)=>"bigint" == typeof e,
    function: (e)=>"function" == typeof e,
    boolean: (e)=>"boolean" == typeof e,
    string: (e)=>"string" == typeof e,
    stringOrUint8Array: (e)=>"string" == typeof e || $cf61b77dbdb95489$var$ec(e),
    isSafeInteger: (e)=>Number.isSafeInteger(e),
    array: (e)=>Array.isArray(e),
    field: (e, t)=>t.Fp.isValid(e),
    hash: (e)=>"function" == typeof e && Number.isSafeInteger(e.outputLen)
};
const $cf61b77dbdb95489$var$bc = BigInt(0), $cf61b77dbdb95489$var$yc = BigInt(1);
function $cf61b77dbdb95489$var$vc(e, t) {
    const n = e % t;
    return n >= $cf61b77dbdb95489$var$bc ? n : t + n;
}
function $cf61b77dbdb95489$var$Ic(e, t, n) {
    let r = e;
    for(; t-- > $cf61b77dbdb95489$var$bc;)r *= r, r %= n;
    return r;
}
BigInt(0), BigInt(1), BigInt(0), BigInt(1), BigInt(2), BigInt(8);
const $cf61b77dbdb95489$var$Mc = BigInt(0), $cf61b77dbdb95489$var$Ec = BigInt(1);
function $cf61b77dbdb95489$var$xc(e) {
    return function(e, t, n = {}) {
        const r = (t, n, r)=>{
            const i = $cf61b77dbdb95489$var$gc[n];
            if ("function" != typeof i) throw new Error("invalid validator function");
            const o = e[t];
            if (!(r && void 0 === o || i(o, e))) throw new Error("param " + String(t) + " is invalid. Expected " + n + ", got " + o);
        };
        for (const [e, n] of Object.entries(t))r(e, n, !1);
        for (const [e, t] of Object.entries(n))r(e, t, !0);
    }(e, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    }), Object.freeze({
        ...e
    });
}
function $cf61b77dbdb95489$var$Sc(e) {
    const t = $cf61b77dbdb95489$var$xc(e), { P: n } = t, r = (e)=>$cf61b77dbdb95489$var$vc(e, n), i = t.montgomeryBits, o = Math.ceil(i / 8), a = t.nByteLength, l = t.adjustScalarBytes || ((e)=>e), s = t.powPminus2 || ((e)=>(function(e, t, n) {
            if (t < $cf61b77dbdb95489$var$bc) throw new Error("invalid exponent, negatives unsupported");
            if (n <= $cf61b77dbdb95489$var$bc) throw new Error("invalid modulus");
            if (n === $cf61b77dbdb95489$var$yc) return $cf61b77dbdb95489$var$bc;
            let r = $cf61b77dbdb95489$var$yc;
            for(; t > $cf61b77dbdb95489$var$bc;)t & $cf61b77dbdb95489$var$yc && (r = r * e % n), e = e * e % n, t >>= $cf61b77dbdb95489$var$yc;
            return r;
        })(e, n - BigInt(2), n));
    function u(e, t, n) {
        const i = r(e * (t - n));
        return [
            t = r(t - i),
            n = r(n + i)
        ];
    }
    const c = (t.a - BigInt(2)) / BigInt(4);
    function d(e) {
        return $cf61b77dbdb95489$var$fc(r(e), o);
    }
    function f(e, t) {
        const f = function(e) {
            const t = $cf61b77dbdb95489$var$hc("u coordinate", e, o);
            return 32 === a && (t[31] &= 127), $cf61b77dbdb95489$var$dc(t);
        }(t), h = function(e) {
            const t = $cf61b77dbdb95489$var$hc("scalar", e), n = t.length;
            if (n !== o && n !== a) throw new Error("invalid scalar, expected " + o + " or " + a + " bytes, got " + n);
            return $cf61b77dbdb95489$var$dc(l(t));
        }(e), p = function(e, t) {
            $cf61b77dbdb95489$var$mc("u", e, $cf61b77dbdb95489$var$Mc, n), $cf61b77dbdb95489$var$mc("scalar", t, $cf61b77dbdb95489$var$Mc, n);
            const o = t, a = e;
            let l, d = $cf61b77dbdb95489$var$Ec, f = $cf61b77dbdb95489$var$Mc, h = e, p = $cf61b77dbdb95489$var$Ec, m = $cf61b77dbdb95489$var$Mc;
            for(let e = BigInt(i - 1); e >= $cf61b77dbdb95489$var$Mc; e--){
                const t = o >> e & $cf61b77dbdb95489$var$Ec;
                m ^= t, l = u(m, d, h), d = l[0], h = l[1], l = u(m, f, p), f = l[0], p = l[1], m = t;
                const n = d + f, i = r(n * n), s = d - f, g = r(s * s), b = i - g, y = h + p, v = r((h - p) * n), I = r(y * s), M = v + I, E = v - I;
                h = r(M * M), p = r(a * r(E * E)), d = r(i * g), f = r(b * (i + r(c * b)));
            }
            l = u(m, d, h), d = l[0], h = l[1], l = u(m, f, p), f = l[0], p = l[1];
            const g = s(f);
            return r(d * g);
        }(f, h);
        if (p === $cf61b77dbdb95489$var$Mc) throw new Error("invalid private or public key received");
        return d(p);
    }
    const h = d(t.Gu);
    function p(e) {
        return f(e, h);
    }
    return {
        scalarMult: f,
        scalarMultBase: p,
        getSharedSecret: (e, t)=>f(e, t),
        getPublicKey: (e)=>p(e),
        utils: {
            randomPrivateKey: ()=>t.randomBytes(t.nByteLength)
        },
        GuBytes: h
    };
}
const $cf61b77dbdb95489$var$wc = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
BigInt(0);
const $cf61b77dbdb95489$var$kc = BigInt(1), $cf61b77dbdb95489$var$Nc = BigInt(2), $cf61b77dbdb95489$var$Uc = BigInt(3), $cf61b77dbdb95489$var$Rc = BigInt(5);
function $cf61b77dbdb95489$var$Lc(e) {
    return e[0] &= 248, e[31] &= 127, e[31] |= 64, e;
}
function $cf61b77dbdb95489$var$Cc(e, t = "-") {
    const n = {}, r = "relay" + t;
    return Object.keys(e).forEach((t)=>{
        if (t.startsWith(r)) {
            const i = t.replace(r, ""), o = e[t];
            n[i] = o;
        }
    }), n;
}
function $cf61b77dbdb95489$var$zc(e) {
    if (!e.includes("wc:")) {
        const t = function(e) {
            return $cf61b77dbdb95489$require$Buffer.from(e, "base64").toString("utf-8");
        }(e);
        null != t && t.includes("wc:") && (e = t);
    }
    const t = (e = (e = e.includes("wc://") ? e.replace("wc://", "") : e).includes("wc:") ? e.replace("wc:", "") : e).indexOf(":"), n = -1 !== e.indexOf("?") ? e.indexOf("?") : void 0, r = e.substring(0, t), i = e.substring(t + 1, n).split("@"), o = typeof n < "u" ? e.substring(n) : "", a = new URLSearchParams(o), l = {};
    a.forEach((e, t)=>{
        l[t] = e;
    });
    const s = "string" == typeof l.methods ? l.methods.split(",") : void 0;
    return {
        protocol: r,
        topic: $cf61b77dbdb95489$var$Tc(i[0]),
        version: parseInt(i[1], 10),
        symKey: l.symKey,
        relay: $cf61b77dbdb95489$var$Cc(l),
        methods: s,
        expiryTimestamp: l.expiryTimestamp ? parseInt(l.expiryTimestamp, 10) : void 0
    };
}
function $cf61b77dbdb95489$var$Tc(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
var $cf61b77dbdb95489$var$Dc;
BigInt(8), $cf61b77dbdb95489$var$Sc({
    P: $cf61b77dbdb95489$var$wc,
    a: BigInt(486662),
    montgomeryBits: 255,
    nByteLength: 32,
    Gu: BigInt(9),
    powPminus2: (e)=>{
        const t = $cf61b77dbdb95489$var$wc, { pow_p_5_8: n, b2: r } = function(e) {
            const t = BigInt(10), n = BigInt(20), r = BigInt(40), i = BigInt(80), o = $cf61b77dbdb95489$var$wc, a = e * e % o * e % o, l = $cf61b77dbdb95489$var$Ic(a, $cf61b77dbdb95489$var$Nc, o) * a % o, s = $cf61b77dbdb95489$var$Ic(l, $cf61b77dbdb95489$var$kc, o) * e % o, u = $cf61b77dbdb95489$var$Ic(s, $cf61b77dbdb95489$var$Rc, o) * s % o, c = $cf61b77dbdb95489$var$Ic(u, t, o) * u % o, d = $cf61b77dbdb95489$var$Ic(c, n, o) * c % o, f = $cf61b77dbdb95489$var$Ic(d, r, o) * d % o, h = $cf61b77dbdb95489$var$Ic(f, i, o) * f % o, p = $cf61b77dbdb95489$var$Ic(h, i, o) * f % o, m = $cf61b77dbdb95489$var$Ic(p, t, o) * u % o;
            return {
                pow_p_5_8: $cf61b77dbdb95489$var$Ic(m, $cf61b77dbdb95489$var$Nc, o) * e % o,
                b2: a
            };
        }(e);
        return $cf61b77dbdb95489$var$vc($cf61b77dbdb95489$var$Ic(n, $cf61b77dbdb95489$var$Uc, t) * r, t);
    },
    adjustScalarBytes: $cf61b77dbdb95489$var$Lc,
    randomBytes: $cf61b77dbdb95489$var$eu
}), function(e) {
    e.TOP_WALLETS = "top-wallets", e.WALLETS = "wallets", e.INSTALL = "install", e.BUG_REPORT = "bug-report", e.QR = "qr";
}($cf61b77dbdb95489$var$Dc || ($cf61b77dbdb95489$var$Dc = {}));
var $cf61b77dbdb95489$var$Fc, $cf61b77dbdb95489$var$Vc = new $cf61b77dbdb95489$var$En("useConnect"), $cf61b77dbdb95489$var$Ac = new $cf61b77dbdb95489$var$En("BugReport"), $cf61b77dbdb95489$var$jc = function(e) {
    var t = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(""), 2), r = t[0], i = t[1], o = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(""), 2), a = o[0], l = o[1], s = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), c = s[0], f = s[1], h = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), p = h[0], m = h[1], g = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), b = g[0], y = g[1], v = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(null), 2), I = v[0], M = v[1], E = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), x = E[0], S = E[1], w = new $cf61b77dbdb95489$var$Dn("beacon", [
        "bug_report",
        "metrics"
    ]), k = function() {
        var e = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function e() {
            var t, n, r, i, o;
            return $cf61b77dbdb95489$var$u().w(function(e) {
                for(;;)switch(e.p = e.n){
                    case 0:
                        return t = {}, n = {}, r = [], i = [], e.p = 1, e.n = 2, w.getAllKeys();
                    case 2:
                        return r = e.v.map(function(e) {
                            return e.toString();
                        }), e.n = 3, w.getAll();
                    case 3:
                        i = e.v, e.n = 5;
                        break;
                    case 4:
                        return e.p = 4, o = e.v, $cf61b77dbdb95489$var$Ac.error("indexDBToMetadata", "getAll failed: ", o.message), e.a(2, [
                            n,
                            t
                        ]);
                    case 5:
                        return r.length && i.length && r.length === i.length && r.forEach(function(e, r) {
                            return (e.includes("beacon") ? n : t)[e] = i[r];
                        }), e.a(2, [
                            n,
                            t
                        ]);
                }
            }, e, null, [
                [
                    1,
                    4
                ]
            ]);
        }));
        return function() {
            return e.apply(this, arguments);
        };
    }(), N = function() {
        var e;
        if (!localStorage) return "UNKNOWN";
        var t = Object.keys(localStorage).find(function(e) {
            return e.includes("user-id");
        });
        return t && t.length && null !== (e = localStorage.getItem(t)) && void 0 !== e ? e : "UNKNOWN";
    };
    $cf61b77dbdb95489$var$_.useEffect(function() {
        f(b);
    }, [
        b
    ]);
    var U = function(e, t, n) {
        var r = {
            method: t,
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(n)
        };
        return fetch(e, r);
    }, R = function() {
        var e = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function e() {
            var t, n;
            return $cf61b77dbdb95489$var$u().w(function(e) {
                for(;;)switch(e.n){
                    case 0:
                        return e.n = 1, w.getAll("metrics");
                    case 1:
                        if ((t = e.v) && 0 !== t.length) {
                            e.n = 2;
                            break;
                        }
                        return e.a(2);
                    case 2:
                        n = t.map(function(e) {
                            return JSON.parse(e);
                        }), U("".concat($cf61b77dbdb95489$var$gn, "/performance-metrics/saveAll"), "POST", n).then(function() {
                            w.clearStore("metrics");
                        }).catch(function(e) {
                            console.error("Error while sending metrics:", e.message), M("error");
                        });
                    case 3:
                        return e.a(2);
                }
            }, e);
        }));
        return function() {
            return e.apply(this, arguments);
        };
    }(), L = function() {
        if (!localStorage) return [];
        var e = Object.keys(localStorage).find(function(e) {
            return e.includes("wc-init-error");
        }), t = Object.keys(localStorage).find(function(e) {
            return e.includes("beacon-last-error");
        });
        return [
            e,
            t
        ];
    }, C = function() {
        var t = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function t(n) {
            var i, o, l, s, c;
            return $cf61b77dbdb95489$var$u().w(function(t) {
                for(;;)switch(t.n){
                    case 0:
                        return n.preventDefault(), M(null), S(!1), m(!0), t.n = 1, k();
                    case 1:
                        i = t.v, o = $cf61b77dbdb95489$var$d(i, 2), l = o[0], s = o[1], c = {
                            userId: l[$cf61b77dbdb95489$var$sn.USER_ID] && l[$cf61b77dbdb95489$var$sn.USER_ID].length ? l[$cf61b77dbdb95489$var$sn.USER_ID] : N(),
                            title: r,
                            sdkVersion: "4.6.2",
                            description: a,
                            steps: "<#EMPTY#>",
                            os: $cf61b77dbdb95489$export$84097bf6fe069cb3(),
                            browser: $cf61b77dbdb95489$export$a4581ac54b250a0b(),
                            localStorage: JSON.stringify(l),
                            wcStorage: JSON.stringify(s)
                        }, U("".concat($cf61b77dbdb95489$var$gn, "/bug-report/save"), "POST", c).then(function(e) {
                            if (!e.ok) throw new Error("Network response was not ok");
                            M("success"), setTimeout(function() {
                                return S(!0);
                            }, 600), R();
                            var t = $cf61b77dbdb95489$var$d(L(), 2), n = t[0], r = t[1];
                            n && localStorage.removeItem(n), r && localStorage.removeItem(r);
                        }).catch(function(e) {
                            console.error("Error while sending report:", e.message), M("error");
                        }).then(function() {
                            m(!1), setTimeout(function() {
                                e.onSubmit();
                            }, 5e3);
                        });
                    case 2:
                        return t.a(2);
                }
            }, t);
        }));
        return function(e) {
            return t.apply(this, arguments);
        };
    }();
    return $cf61b77dbdb95489$var$le.jsxs("form", {
        onSubmit: C,
        className: "form-style",
        children: [
            $cf61b77dbdb95489$var$le.jsxs("div", {
                className: "input-group",
                children: [
                    $cf61b77dbdb95489$var$le.jsx("label", {
                        htmlFor: "title",
                        className: "label-style",
                        children: "Title"
                    }),
                    $cf61b77dbdb95489$var$le.jsx("input", {
                        type: "text",
                        id: "title",
                        value: r,
                        onChange: function(e) {
                            return i(e.currentTarget.value);
                        },
                        className: "input-style"
                    })
                ]
            }),
            $cf61b77dbdb95489$var$le.jsxs("div", {
                className: "input-group",
                children: [
                    $cf61b77dbdb95489$var$le.jsx("label", {
                        htmlFor: "description",
                        className: "label-style",
                        children: "Description"
                    }),
                    $cf61b77dbdb95489$var$le.jsx("textarea", {
                        id: "description",
                        value: a,
                        onChange: function(e) {
                            return l(e.currentTarget.value);
                        },
                        className: "textarea-style"
                    })
                ]
            }),
            $cf61b77dbdb95489$var$le.jsxs("div", {
                className: "permissions-group",
                children: [
                    $cf61b77dbdb95489$var$le.jsx("label", {
                        htmlFor: "user-permissions",
                        className: "label-style",
                        children: "You agree to share anonymous data with the developers."
                    }),
                    $cf61b77dbdb95489$var$le.jsx("input", {
                        id: "user-permissions",
                        type: "checkbox",
                        onChange: function() {
                            return y(function(e) {
                                return !e;
                            });
                        }
                    })
                ]
            }),
            $cf61b77dbdb95489$var$le.jsxs("button", {
                type: "submit",
                disabled: !c,
                className: "button-style ".concat(c ? "valid" : "invalid", " ").concat(p ? "button-loading" : ""),
                children: [
                    p || I ? $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$le.Fragment, {
                        children: "\xa0"
                    }) : "Submit",
                    !p && I && $cf61b77dbdb95489$var$le.jsx("span", {
                        className: "success" === I ? "icon success-icon" : "icon error-icon",
                        children: "success" === I ? "\u2713" : "\u2715"
                    }),
                    x && $cf61b77dbdb95489$var$le.jsx("div", {
                        className: "thank-you-message",
                        children: "Thank You!".split("").map(function(e, t) {
                            return $cf61b77dbdb95489$var$le.jsx("span", {
                                style: {
                                    animationDelay: "".concat(.1 * t, "s")
                                },
                                children: e
                            }, t);
                        })
                    })
                ]
            })
        ]
    });
}, $cf61b77dbdb95489$var$Oc = function(e) {
    var t;
    return $cf61b77dbdb95489$var$le.jsxs("div", {
        className: "info-wrapper ".concat(e.border ? "info-border" : ""),
        children: [
            e.icon && $cf61b77dbdb95489$var$le.jsx("div", {
                className: "info-icon ".concat(e.iconBadge ? "info-badge" : ""),
                style: e.bigIcon ? {
                    fontSize: "3.4em"
                } : {},
                children: e.icon
            }),
            $cf61b77dbdb95489$var$le.jsx("h3", {
                className: "info-title",
                children: e.title
            }),
            e.description && $cf61b77dbdb95489$var$le.jsx("div", {
                className: "info-description",
                children: e.description
            }),
            e.data && $cf61b77dbdb95489$var$le.jsx("pre", {
                className: "info-data",
                children: e.data
            }),
            $cf61b77dbdb95489$var$le.jsx("div", {
                className: "info-buttons",
                children: null === (t = e.buttons) || void 0 === t ? void 0 : t.map(function(e, t) {
                    return $cf61b77dbdb95489$var$le.jsx("button", {
                        className: "secondary" !== e.type ? "info-button" : "info-button-secondary",
                        onClick: e.onClick,
                        children: e.label
                    }, t);
                })
            }),
            e.downloadLink && $cf61b77dbdb95489$var$le.jsx("a", {
                className: "downloadLink",
                href: e.downloadLink.url,
                children: e.downloadLink.label
            }),
            e.onShowQRCodeClick && $cf61b77dbdb95489$var$le.jsx("button", {
                id: "qr-code-icon",
                onClick: e.onShowQRCodeClick,
                children: $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$de, {})
            })
        ]
    });
}, $cf61b77dbdb95489$var$Qc = {
    exports: {}
};

var $cf61b77dbdb95489$var$qc = ($cf61b77dbdb95489$var$Fc || ($cf61b77dbdb95489$var$Fc = 1, function(e) {
    function t(e) {
        this.mode = r.MODE_8BIT_BYTE, this.data = e, this.parsedData = [];
        for(var t = 0, n = this.data.length; t < n; t++){
            var i = [], o = this.data.charCodeAt(t);
            o > 65536 ? (i[0] = 240 | (1835008 & o) >>> 18, i[1] = 128 | (258048 & o) >>> 12, i[2] = 128 | (4032 & o) >>> 6, i[3] = 128 | 63 & o) : o > 2048 ? (i[0] = 224 | (61440 & o) >>> 12, i[1] = 128 | (4032 & o) >>> 6, i[2] = 128 | 63 & o) : o > 128 ? (i[0] = 192 | (1984 & o) >>> 6, i[1] = 128 | 63 & o) : i[0] = o, this.parsedData.push(i);
        }
        this.parsedData = Array.prototype.concat.apply([], this.parsedData), this.parsedData.length != this.data.length && (this.parsedData.unshift(191), this.parsedData.unshift(187), this.parsedData.unshift(239));
    }
    function n(e, t) {
        this.typeNumber = e, this.errorCorrectLevel = t, this.modules = null, this.moduleCount = 0, this.dataCache = null, this.dataList = [];
    }
    t.prototype = {
        getLength: function(e) {
            return this.parsedData.length;
        },
        write: function(e) {
            for(var t = 0, n = this.parsedData.length; t < n; t++)e.put(this.parsedData[t], 8);
        }
    }, n.prototype = {
        addData: function(e) {
            var n = new t(e);
            this.dataList.push(n), this.dataCache = null;
        },
        isDark: function(e, t) {
            if (e < 0 || this.moduleCount <= e || t < 0 || this.moduleCount <= t) throw new Error(e + "," + t);
            return this.modules[e][t];
        },
        getModuleCount: function() {
            return this.moduleCount;
        },
        make: function() {
            this.makeImpl(!1, this.getBestMaskPattern());
        },
        makeImpl: function(e, t) {
            this.moduleCount = 4 * this.typeNumber + 17, this.modules = new Array(this.moduleCount);
            for(var r = 0; r < this.moduleCount; r++){
                this.modules[r] = new Array(this.moduleCount);
                for(var i = 0; i < this.moduleCount; i++)this.modules[r][i] = null;
            }
            this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(e, t), this.typeNumber >= 7 && this.setupTypeNumber(e), null == this.dataCache && (this.dataCache = n.createData(this.typeNumber, this.errorCorrectLevel, this.dataList)), this.mapData(this.dataCache, t);
        },
        setupPositionProbePattern: function(e, t) {
            for(var n = -1; n <= 7; n++)if (!(e + n <= -1 || this.moduleCount <= e + n)) for(var r = -1; r <= 7; r++)t + r <= -1 || this.moduleCount <= t + r || (this.modules[e + n][t + r] = 0 <= n && n <= 6 && (0 == r || 6 == r) || 0 <= r && r <= 6 && (0 == n || 6 == n) || 2 <= n && n <= 4 && 2 <= r && r <= 4);
        },
        getBestMaskPattern: function() {
            for(var e = 0, t = 0, n = 0; n < 8; n++){
                this.makeImpl(!0, n);
                var r = g.getLostPoint(this);
                (0 == n || e > r) && (e = r, t = n);
            }
            return t;
        },
        createMovieClip: function(e, t, n) {
            var r = e.createEmptyMovieClip(t, n);
            this.make();
            for(var i = 0; i < this.modules.length; i++)for(var o = 1 * i, a = 0; a < this.modules[i].length; a++){
                var l = 1 * a;
                this.modules[i][a] && (r.beginFill(0, 100), r.moveTo(l, o), r.lineTo(l + 1, o), r.lineTo(l + 1, o + 1), r.lineTo(l, o + 1), r.endFill());
            }
            return r;
        },
        setupTimingPattern: function() {
            for(var e = 8; e < this.moduleCount - 8; e++)null == this.modules[e][6] && (this.modules[e][6] = e % 2 == 0);
            for(var t = 8; t < this.moduleCount - 8; t++)null == this.modules[6][t] && (this.modules[6][t] = t % 2 == 0);
        },
        setupPositionAdjustPattern: function() {
            for(var e = g.getPatternPosition(this.typeNumber), t = 0; t < e.length; t++)for(var n = 0; n < e.length; n++){
                var r = e[t], i = e[n];
                if (null == this.modules[r][i]) for(var o = -2; o <= 2; o++)for(var a = -2; a <= 2; a++)this.modules[r + o][i + a] = -2 == o || 2 == o || -2 == a || 2 == a || 0 == o && 0 == a;
            }
        },
        setupTypeNumber: function(e) {
            for(var t = g.getBCHTypeNumber(this.typeNumber), n = 0; n < 18; n++){
                var r = !e && 1 == (t >> n & 1);
                this.modules[Math.floor(n / 3)][n % 3 + this.moduleCount - 8 - 3] = r;
            }
            for(n = 0; n < 18; n++)r = !e && 1 == (t >> n & 1), this.modules[n % 3 + this.moduleCount - 8 - 3][Math.floor(n / 3)] = r;
        },
        setupTypeInfo: function(e, t) {
            for(var n = this.errorCorrectLevel << 3 | t, r = g.getBCHTypeInfo(n), i = 0; i < 15; i++){
                var o = !e && 1 == (r >> i & 1);
                i < 6 ? this.modules[i][8] = o : i < 8 ? this.modules[i + 1][8] = o : this.modules[this.moduleCount - 15 + i][8] = o;
            }
            for(i = 0; i < 15; i++)o = !e && 1 == (r >> i & 1), i < 8 ? this.modules[8][this.moduleCount - i - 1] = o : i < 9 ? this.modules[8][15 - i - 1 + 1] = o : this.modules[8][15 - i - 1] = o;
            this.modules[this.moduleCount - 8][8] = !e;
        },
        mapData: function(e, t) {
            for(var n = -1, r = this.moduleCount - 1, i = 7, o = 0, a = this.moduleCount - 1; a > 0; a -= 2)for(6 == a && a--;;){
                for(var l = 0; l < 2; l++)if (null == this.modules[r][a - l]) {
                    var s = !1;
                    o < e.length && (s = 1 == (e[o] >>> i & 1)), g.getMask(t, r, a - l) && (s = !s), this.modules[r][a - l] = s, -1 == --i && (o++, i = 7);
                }
                if ((r += n) < 0 || this.moduleCount <= r) {
                    r -= n, n = -n;
                    break;
                }
            }
        }
    }, n.PAD0 = 236, n.PAD1 = 17, n.createData = function(e, t, r) {
        for(var i = I.getRSBlocks(e, t), o = new M, a = 0; a < r.length; a++){
            var l = r[a];
            o.put(l.mode, 4), o.put(l.getLength(), g.getLengthInBits(l.mode, e)), l.write(o);
        }
        var s = 0;
        for(a = 0; a < i.length; a++)s += i[a].dataCount;
        if (o.getLengthInBits() > 8 * s) throw new Error("code length overflow. (" + o.getLengthInBits() + ">" + 8 * s + ")");
        for(o.getLengthInBits() + 4 <= 8 * s && o.put(0, 4); o.getLengthInBits() % 8 != 0;)o.putBit(!1);
        for(; !(o.getLengthInBits() >= 8 * s || (o.put(n.PAD0, 8), o.getLengthInBits() >= 8 * s));)o.put(n.PAD1, 8);
        return n.createBytes(o, i);
    }, n.createBytes = function(e, t) {
        for(var n = 0, r = 0, i = 0, o = new Array(t.length), a = new Array(t.length), l = 0; l < t.length; l++){
            var s = t[l].dataCount, u = t[l].totalCount - s;
            r = Math.max(r, s), i = Math.max(i, u), o[l] = new Array(s);
            for(var c = 0; c < o[l].length; c++)o[l][c] = 255 & e.buffer[c + n];
            n += s;
            var d = g.getErrorCorrectPolynomial(u), f = new v(o[l], d.getLength() - 1).mod(d);
            for(a[l] = new Array(d.getLength() - 1), c = 0; c < a[l].length; c++){
                var h = c + f.getLength() - a[l].length;
                a[l][c] = h >= 0 ? f.get(h) : 0;
            }
        }
        var p = 0;
        for(c = 0; c < t.length; c++)p += t[c].totalCount;
        var m = new Array(p), b = 0;
        for(c = 0; c < r; c++)for(l = 0; l < t.length; l++)c < o[l].length && (m[b++] = o[l][c]);
        for(c = 0; c < i; c++)for(l = 0; l < t.length; l++)c < a[l].length && (m[b++] = a[l][c]);
        return m;
    };
    for(var r = {
        MODE_NUMBER: 1,
        MODE_ALPHA_NUM: 2,
        MODE_8BIT_BYTE: 4,
        MODE_KANJI: 8
    }, i = 1, o = 0, a = 3, l = 2, s = 0, u = 1, c = 2, d = 3, f = 4, h = 5, p = 6, m = 7, g = {
        PATTERN_POSITION_TABLE: [
            [],
            [
                6,
                18
            ],
            [
                6,
                22
            ],
            [
                6,
                26
            ],
            [
                6,
                30
            ],
            [
                6,
                34
            ],
            [
                6,
                22,
                38
            ],
            [
                6,
                24,
                42
            ],
            [
                6,
                26,
                46
            ],
            [
                6,
                28,
                50
            ],
            [
                6,
                30,
                54
            ],
            [
                6,
                32,
                58
            ],
            [
                6,
                34,
                62
            ],
            [
                6,
                26,
                46,
                66
            ],
            [
                6,
                26,
                48,
                70
            ],
            [
                6,
                26,
                50,
                74
            ],
            [
                6,
                30,
                54,
                78
            ],
            [
                6,
                30,
                56,
                82
            ],
            [
                6,
                30,
                58,
                86
            ],
            [
                6,
                34,
                62,
                90
            ],
            [
                6,
                28,
                50,
                72,
                94
            ],
            [
                6,
                26,
                50,
                74,
                98
            ],
            [
                6,
                30,
                54,
                78,
                102
            ],
            [
                6,
                28,
                54,
                80,
                106
            ],
            [
                6,
                32,
                58,
                84,
                110
            ],
            [
                6,
                30,
                58,
                86,
                114
            ],
            [
                6,
                34,
                62,
                90,
                118
            ],
            [
                6,
                26,
                50,
                74,
                98,
                122
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126
            ],
            [
                6,
                26,
                52,
                78,
                104,
                130
            ],
            [
                6,
                30,
                56,
                82,
                108,
                134
            ],
            [
                6,
                34,
                60,
                86,
                112,
                138
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142
            ],
            [
                6,
                34,
                62,
                90,
                118,
                146
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126,
                150
            ],
            [
                6,
                24,
                50,
                76,
                102,
                128,
                154
            ],
            [
                6,
                28,
                54,
                80,
                106,
                132,
                158
            ],
            [
                6,
                32,
                58,
                84,
                110,
                136,
                162
            ],
            [
                6,
                26,
                54,
                82,
                110,
                138,
                166
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142,
                170
            ]
        ],
        G15: 1335,
        G18: 7973,
        G15_MASK: 21522,
        getBCHTypeInfo: function(e) {
            for(var t = e << 10; g.getBCHDigit(t) - g.getBCHDigit(g.G15) >= 0;)t ^= g.G15 << g.getBCHDigit(t) - g.getBCHDigit(g.G15);
            return (e << 10 | t) ^ g.G15_MASK;
        },
        getBCHTypeNumber: function(e) {
            for(var t = e << 12; g.getBCHDigit(t) - g.getBCHDigit(g.G18) >= 0;)t ^= g.G18 << g.getBCHDigit(t) - g.getBCHDigit(g.G18);
            return e << 12 | t;
        },
        getBCHDigit: function(e) {
            for(var t = 0; 0 != e;)t++, e >>>= 1;
            return t;
        },
        getPatternPosition: function(e) {
            return g.PATTERN_POSITION_TABLE[e - 1];
        },
        getMask: function(e, t, n) {
            switch(e){
                case s:
                    return (t + n) % 2 == 0;
                case u:
                    return t % 2 == 0;
                case c:
                    return n % 3 == 0;
                case d:
                    return (t + n) % 3 == 0;
                case f:
                    return (Math.floor(t / 2) + Math.floor(n / 3)) % 2 == 0;
                case h:
                    return t * n % 2 + t * n % 3 == 0;
                case p:
                    return (t * n % 2 + t * n % 3) % 2 == 0;
                case m:
                    return (t * n % 3 + (t + n) % 2) % 2 == 0;
                default:
                    throw new Error("bad maskPattern:" + e);
            }
        },
        getErrorCorrectPolynomial: function(e) {
            for(var t = new v([
                1
            ], 0), n = 0; n < e; n++)t = t.multiply(new v([
                1,
                b.gexp(n)
            ], 0));
            return t;
        },
        getLengthInBits: function(e, t) {
            if (1 <= t && t < 10) switch(e){
                case r.MODE_NUMBER:
                    return 10;
                case r.MODE_ALPHA_NUM:
                    return 9;
                case r.MODE_8BIT_BYTE:
                case r.MODE_KANJI:
                    return 8;
                default:
                    throw new Error("mode:" + e);
            }
            else if (t < 27) switch(e){
                case r.MODE_NUMBER:
                    return 12;
                case r.MODE_ALPHA_NUM:
                    return 11;
                case r.MODE_8BIT_BYTE:
                    return 16;
                case r.MODE_KANJI:
                    return 10;
                default:
                    throw new Error("mode:" + e);
            }
            else {
                if (!(t < 41)) throw new Error("type:" + t);
                switch(e){
                    case r.MODE_NUMBER:
                        return 14;
                    case r.MODE_ALPHA_NUM:
                        return 13;
                    case r.MODE_8BIT_BYTE:
                        return 16;
                    case r.MODE_KANJI:
                        return 12;
                    default:
                        throw new Error("mode:" + e);
                }
            }
        },
        getLostPoint: function(e) {
            for(var t = e.getModuleCount(), n = 0, r = 0; r < t; r++)for(var i = 0; i < t; i++){
                for(var o = 0, a = e.isDark(r, i), l = -1; l <= 1; l++)if (!(r + l < 0 || t <= r + l)) for(var s = -1; s <= 1; s++)i + s < 0 || t <= i + s || 0 == l && 0 == s || a == e.isDark(r + l, i + s) && o++;
                o > 5 && (n += 3 + o - 5);
            }
            for(r = 0; r < t - 1; r++)for(i = 0; i < t - 1; i++){
                var u = 0;
                e.isDark(r, i) && u++, e.isDark(r + 1, i) && u++, e.isDark(r, i + 1) && u++, e.isDark(r + 1, i + 1) && u++, 0 != u && 4 != u || (n += 3);
            }
            for(r = 0; r < t; r++)for(i = 0; i < t - 6; i++)e.isDark(r, i) && !e.isDark(r, i + 1) && e.isDark(r, i + 2) && e.isDark(r, i + 3) && e.isDark(r, i + 4) && !e.isDark(r, i + 5) && e.isDark(r, i + 6) && (n += 40);
            for(i = 0; i < t; i++)for(r = 0; r < t - 6; r++)e.isDark(r, i) && !e.isDark(r + 1, i) && e.isDark(r + 2, i) && e.isDark(r + 3, i) && e.isDark(r + 4, i) && !e.isDark(r + 5, i) && e.isDark(r + 6, i) && (n += 40);
            var c = 0;
            for(i = 0; i < t; i++)for(r = 0; r < t; r++)e.isDark(r, i) && c++;
            return n += Math.abs(100 * c / t / t - 50) / 5 * 10;
        }
    }, b = {
        glog: function(e) {
            if (e < 1) throw new Error("glog(" + e + ")");
            return b.LOG_TABLE[e];
        },
        gexp: function(e) {
            for(; e < 0;)e += 255;
            for(; e >= 256;)e -= 255;
            return b.EXP_TABLE[e];
        },
        EXP_TABLE: new Array(256),
        LOG_TABLE: new Array(256)
    }, y = 0; y < 8; y++)b.EXP_TABLE[y] = 1 << y;
    for(y = 8; y < 256; y++)b.EXP_TABLE[y] = b.EXP_TABLE[y - 4] ^ b.EXP_TABLE[y - 5] ^ b.EXP_TABLE[y - 6] ^ b.EXP_TABLE[y - 8];
    for(y = 0; y < 255; y++)b.LOG_TABLE[b.EXP_TABLE[y]] = y;
    function v(e, t) {
        if (null == e.length) throw new Error(e.length + "/" + t);
        for(var n = 0; n < e.length && 0 == e[n];)n++;
        this.num = new Array(e.length - n + t);
        for(var r = 0; r < e.length - n; r++)this.num[r] = e[r + n];
    }
    function I(e, t) {
        this.totalCount = e, this.dataCount = t;
    }
    function M() {
        this.buffer = [], this.length = 0;
    }
    v.prototype = {
        get: function(e) {
            return this.num[e];
        },
        getLength: function() {
            return this.num.length;
        },
        multiply: function(e) {
            for(var t = new Array(this.getLength() + e.getLength() - 1), n = 0; n < this.getLength(); n++)for(var r = 0; r < e.getLength(); r++)t[n + r] ^= b.gexp(b.glog(this.get(n)) + b.glog(e.get(r)));
            return new v(t, 0);
        },
        mod: function(e) {
            if (this.getLength() - e.getLength() < 0) return this;
            for(var t = b.glog(this.get(0)) - b.glog(e.get(0)), n = new Array(this.getLength()), r = 0; r < this.getLength(); r++)n[r] = this.get(r);
            for(r = 0; r < e.getLength(); r++)n[r] ^= b.gexp(b.glog(e.get(r)) + t);
            return new v(n, 0).mod(e);
        }
    }, I.RS_BLOCK_TABLE = [
        [
            1,
            26,
            19
        ],
        [
            1,
            26,
            16
        ],
        [
            1,
            26,
            13
        ],
        [
            1,
            26,
            9
        ],
        [
            1,
            44,
            34
        ],
        [
            1,
            44,
            28
        ],
        [
            1,
            44,
            22
        ],
        [
            1,
            44,
            16
        ],
        [
            1,
            70,
            55
        ],
        [
            1,
            70,
            44
        ],
        [
            2,
            35,
            17
        ],
        [
            2,
            35,
            13
        ],
        [
            1,
            100,
            80
        ],
        [
            2,
            50,
            32
        ],
        [
            2,
            50,
            24
        ],
        [
            4,
            25,
            9
        ],
        [
            1,
            134,
            108
        ],
        [
            2,
            67,
            43
        ],
        [
            2,
            33,
            15,
            2,
            34,
            16
        ],
        [
            2,
            33,
            11,
            2,
            34,
            12
        ],
        [
            2,
            86,
            68
        ],
        [
            4,
            43,
            27
        ],
        [
            4,
            43,
            19
        ],
        [
            4,
            43,
            15
        ],
        [
            2,
            98,
            78
        ],
        [
            4,
            49,
            31
        ],
        [
            2,
            32,
            14,
            4,
            33,
            15
        ],
        [
            4,
            39,
            13,
            1,
            40,
            14
        ],
        [
            2,
            121,
            97
        ],
        [
            2,
            60,
            38,
            2,
            61,
            39
        ],
        [
            4,
            40,
            18,
            2,
            41,
            19
        ],
        [
            4,
            40,
            14,
            2,
            41,
            15
        ],
        [
            2,
            146,
            116
        ],
        [
            3,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            36,
            16,
            4,
            37,
            17
        ],
        [
            4,
            36,
            12,
            4,
            37,
            13
        ],
        [
            2,
            86,
            68,
            2,
            87,
            69
        ],
        [
            4,
            69,
            43,
            1,
            70,
            44
        ],
        [
            6,
            43,
            19,
            2,
            44,
            20
        ],
        [
            6,
            43,
            15,
            2,
            44,
            16
        ],
        [
            4,
            101,
            81
        ],
        [
            1,
            80,
            50,
            4,
            81,
            51
        ],
        [
            4,
            50,
            22,
            4,
            51,
            23
        ],
        [
            3,
            36,
            12,
            8,
            37,
            13
        ],
        [
            2,
            116,
            92,
            2,
            117,
            93
        ],
        [
            6,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            46,
            20,
            6,
            47,
            21
        ],
        [
            7,
            42,
            14,
            4,
            43,
            15
        ],
        [
            4,
            133,
            107
        ],
        [
            8,
            59,
            37,
            1,
            60,
            38
        ],
        [
            8,
            44,
            20,
            4,
            45,
            21
        ],
        [
            12,
            33,
            11,
            4,
            34,
            12
        ],
        [
            3,
            145,
            115,
            1,
            146,
            116
        ],
        [
            4,
            64,
            40,
            5,
            65,
            41
        ],
        [
            11,
            36,
            16,
            5,
            37,
            17
        ],
        [
            11,
            36,
            12,
            5,
            37,
            13
        ],
        [
            5,
            109,
            87,
            1,
            110,
            88
        ],
        [
            5,
            65,
            41,
            5,
            66,
            42
        ],
        [
            5,
            54,
            24,
            7,
            55,
            25
        ],
        [
            11,
            36,
            12
        ],
        [
            5,
            122,
            98,
            1,
            123,
            99
        ],
        [
            7,
            73,
            45,
            3,
            74,
            46
        ],
        [
            15,
            43,
            19,
            2,
            44,
            20
        ],
        [
            3,
            45,
            15,
            13,
            46,
            16
        ],
        [
            1,
            135,
            107,
            5,
            136,
            108
        ],
        [
            10,
            74,
            46,
            1,
            75,
            47
        ],
        [
            1,
            50,
            22,
            15,
            51,
            23
        ],
        [
            2,
            42,
            14,
            17,
            43,
            15
        ],
        [
            5,
            150,
            120,
            1,
            151,
            121
        ],
        [
            9,
            69,
            43,
            4,
            70,
            44
        ],
        [
            17,
            50,
            22,
            1,
            51,
            23
        ],
        [
            2,
            42,
            14,
            19,
            43,
            15
        ],
        [
            3,
            141,
            113,
            4,
            142,
            114
        ],
        [
            3,
            70,
            44,
            11,
            71,
            45
        ],
        [
            17,
            47,
            21,
            4,
            48,
            22
        ],
        [
            9,
            39,
            13,
            16,
            40,
            14
        ],
        [
            3,
            135,
            107,
            5,
            136,
            108
        ],
        [
            3,
            67,
            41,
            13,
            68,
            42
        ],
        [
            15,
            54,
            24,
            5,
            55,
            25
        ],
        [
            15,
            43,
            15,
            10,
            44,
            16
        ],
        [
            4,
            144,
            116,
            4,
            145,
            117
        ],
        [
            17,
            68,
            42
        ],
        [
            17,
            50,
            22,
            6,
            51,
            23
        ],
        [
            19,
            46,
            16,
            6,
            47,
            17
        ],
        [
            2,
            139,
            111,
            7,
            140,
            112
        ],
        [
            17,
            74,
            46
        ],
        [
            7,
            54,
            24,
            16,
            55,
            25
        ],
        [
            34,
            37,
            13
        ],
        [
            4,
            151,
            121,
            5,
            152,
            122
        ],
        [
            4,
            75,
            47,
            14,
            76,
            48
        ],
        [
            11,
            54,
            24,
            14,
            55,
            25
        ],
        [
            16,
            45,
            15,
            14,
            46,
            16
        ],
        [
            6,
            147,
            117,
            4,
            148,
            118
        ],
        [
            6,
            73,
            45,
            14,
            74,
            46
        ],
        [
            11,
            54,
            24,
            16,
            55,
            25
        ],
        [
            30,
            46,
            16,
            2,
            47,
            17
        ],
        [
            8,
            132,
            106,
            4,
            133,
            107
        ],
        [
            8,
            75,
            47,
            13,
            76,
            48
        ],
        [
            7,
            54,
            24,
            22,
            55,
            25
        ],
        [
            22,
            45,
            15,
            13,
            46,
            16
        ],
        [
            10,
            142,
            114,
            2,
            143,
            115
        ],
        [
            19,
            74,
            46,
            4,
            75,
            47
        ],
        [
            28,
            50,
            22,
            6,
            51,
            23
        ],
        [
            33,
            46,
            16,
            4,
            47,
            17
        ],
        [
            8,
            152,
            122,
            4,
            153,
            123
        ],
        [
            22,
            73,
            45,
            3,
            74,
            46
        ],
        [
            8,
            53,
            23,
            26,
            54,
            24
        ],
        [
            12,
            45,
            15,
            28,
            46,
            16
        ],
        [
            3,
            147,
            117,
            10,
            148,
            118
        ],
        [
            3,
            73,
            45,
            23,
            74,
            46
        ],
        [
            4,
            54,
            24,
            31,
            55,
            25
        ],
        [
            11,
            45,
            15,
            31,
            46,
            16
        ],
        [
            7,
            146,
            116,
            7,
            147,
            117
        ],
        [
            21,
            73,
            45,
            7,
            74,
            46
        ],
        [
            1,
            53,
            23,
            37,
            54,
            24
        ],
        [
            19,
            45,
            15,
            26,
            46,
            16
        ],
        [
            5,
            145,
            115,
            10,
            146,
            116
        ],
        [
            19,
            75,
            47,
            10,
            76,
            48
        ],
        [
            15,
            54,
            24,
            25,
            55,
            25
        ],
        [
            23,
            45,
            15,
            25,
            46,
            16
        ],
        [
            13,
            145,
            115,
            3,
            146,
            116
        ],
        [
            2,
            74,
            46,
            29,
            75,
            47
        ],
        [
            42,
            54,
            24,
            1,
            55,
            25
        ],
        [
            23,
            45,
            15,
            28,
            46,
            16
        ],
        [
            17,
            145,
            115
        ],
        [
            10,
            74,
            46,
            23,
            75,
            47
        ],
        [
            10,
            54,
            24,
            35,
            55,
            25
        ],
        [
            19,
            45,
            15,
            35,
            46,
            16
        ],
        [
            17,
            145,
            115,
            1,
            146,
            116
        ],
        [
            14,
            74,
            46,
            21,
            75,
            47
        ],
        [
            29,
            54,
            24,
            19,
            55,
            25
        ],
        [
            11,
            45,
            15,
            46,
            46,
            16
        ],
        [
            13,
            145,
            115,
            6,
            146,
            116
        ],
        [
            14,
            74,
            46,
            23,
            75,
            47
        ],
        [
            44,
            54,
            24,
            7,
            55,
            25
        ],
        [
            59,
            46,
            16,
            1,
            47,
            17
        ],
        [
            12,
            151,
            121,
            7,
            152,
            122
        ],
        [
            12,
            75,
            47,
            26,
            76,
            48
        ],
        [
            39,
            54,
            24,
            14,
            55,
            25
        ],
        [
            22,
            45,
            15,
            41,
            46,
            16
        ],
        [
            6,
            151,
            121,
            14,
            152,
            122
        ],
        [
            6,
            75,
            47,
            34,
            76,
            48
        ],
        [
            46,
            54,
            24,
            10,
            55,
            25
        ],
        [
            2,
            45,
            15,
            64,
            46,
            16
        ],
        [
            17,
            152,
            122,
            4,
            153,
            123
        ],
        [
            29,
            74,
            46,
            14,
            75,
            47
        ],
        [
            49,
            54,
            24,
            10,
            55,
            25
        ],
        [
            24,
            45,
            15,
            46,
            46,
            16
        ],
        [
            4,
            152,
            122,
            18,
            153,
            123
        ],
        [
            13,
            74,
            46,
            32,
            75,
            47
        ],
        [
            48,
            54,
            24,
            14,
            55,
            25
        ],
        [
            42,
            45,
            15,
            32,
            46,
            16
        ],
        [
            20,
            147,
            117,
            4,
            148,
            118
        ],
        [
            40,
            75,
            47,
            7,
            76,
            48
        ],
        [
            43,
            54,
            24,
            22,
            55,
            25
        ],
        [
            10,
            45,
            15,
            67,
            46,
            16
        ],
        [
            19,
            148,
            118,
            6,
            149,
            119
        ],
        [
            18,
            75,
            47,
            31,
            76,
            48
        ],
        [
            34,
            54,
            24,
            34,
            55,
            25
        ],
        [
            20,
            45,
            15,
            61,
            46,
            16
        ]
    ], I.getRSBlocks = function(e, t) {
        var n = I.getRsBlockTable(e, t);
        if (null == n) throw new Error("bad rs block @ typeNumber:" + e + "/errorCorrectLevel:" + t);
        for(var r = n.length / 3, i = [], o = 0; o < r; o++)for(var a = n[3 * o + 0], l = n[3 * o + 1], s = n[3 * o + 2], u = 0; u < a; u++)i.push(new I(l, s));
        return i;
    }, I.getRsBlockTable = function(e, t) {
        switch(t){
            case i:
                return I.RS_BLOCK_TABLE[4 * (e - 1) + 0];
            case o:
                return I.RS_BLOCK_TABLE[4 * (e - 1) + 1];
            case a:
                return I.RS_BLOCK_TABLE[4 * (e - 1) + 2];
            case l:
                return I.RS_BLOCK_TABLE[4 * (e - 1) + 3];
            default:
                return;
        }
    }, M.prototype = {
        get: function(e) {
            var t = Math.floor(e / 8);
            return 1 == (this.buffer[t] >>> 7 - e % 8 & 1);
        },
        put: function(e, t) {
            for(var n = 0; n < t; n++)this.putBit(1 == (e >>> t - n - 1 & 1));
        },
        getLengthInBits: function() {
            return this.length;
        },
        putBit: function(e) {
            var t = Math.floor(this.length / 8);
            this.buffer.length <= t && this.buffer.push(0), e && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
        }
    };
    var E = [
        [
            17,
            14,
            11,
            7
        ],
        [
            32,
            26,
            20,
            14
        ],
        [
            53,
            42,
            32,
            24
        ],
        [
            78,
            62,
            46,
            34
        ],
        [
            106,
            84,
            60,
            44
        ],
        [
            134,
            106,
            74,
            58
        ],
        [
            154,
            122,
            86,
            64
        ],
        [
            192,
            152,
            108,
            84
        ],
        [
            230,
            180,
            130,
            98
        ],
        [
            271,
            213,
            151,
            119
        ],
        [
            321,
            251,
            177,
            137
        ],
        [
            367,
            287,
            203,
            155
        ],
        [
            425,
            331,
            241,
            177
        ],
        [
            458,
            362,
            258,
            194
        ],
        [
            520,
            412,
            292,
            220
        ],
        [
            586,
            450,
            322,
            250
        ],
        [
            644,
            504,
            364,
            280
        ],
        [
            718,
            560,
            394,
            310
        ],
        [
            792,
            624,
            442,
            338
        ],
        [
            858,
            666,
            482,
            382
        ],
        [
            929,
            711,
            509,
            403
        ],
        [
            1003,
            779,
            565,
            439
        ],
        [
            1091,
            857,
            611,
            461
        ],
        [
            1171,
            911,
            661,
            511
        ],
        [
            1273,
            997,
            715,
            535
        ],
        [
            1367,
            1059,
            751,
            593
        ],
        [
            1465,
            1125,
            805,
            625
        ],
        [
            1528,
            1190,
            868,
            658
        ],
        [
            1628,
            1264,
            908,
            698
        ],
        [
            1732,
            1370,
            982,
            742
        ],
        [
            1840,
            1452,
            1030,
            790
        ],
        [
            1952,
            1538,
            1112,
            842
        ],
        [
            2068,
            1628,
            1168,
            898
        ],
        [
            2188,
            1722,
            1228,
            958
        ],
        [
            2303,
            1809,
            1283,
            983
        ],
        [
            2431,
            1911,
            1351,
            1051
        ],
        [
            2563,
            1989,
            1423,
            1093
        ],
        [
            2699,
            2099,
            1499,
            1139
        ],
        [
            2809,
            2213,
            1579,
            1219
        ],
        [
            2953,
            2331,
            1663,
            1273
        ]
    ];
    function x(e) {
        if (this.options = {
            padding: 4,
            width: 256,
            height: 256,
            typeNumber: 4,
            color: "#000000",
            background: "#ffffff",
            ecl: "M"
        }, "string" == typeof e && (e = {
            content: e
        }), e) for(var t in e)this.options[t] = e[t];
        if ("string" != typeof this.options.content) throw new Error("Expected 'content' as string!");
        if (0 === this.options.content.length) throw new Error("Expected 'content' to be non-empty!");
        if (!(this.options.padding >= 0)) throw new Error("Expected 'padding' value to be non-negative!");
        if (!(this.options.width > 0 && this.options.height > 0)) throw new Error("Expected 'width' or 'height' value to be higher than zero!");
        var r = this.options.content, s = function(e, t) {
            for(var n = function(e) {
                var t = encodeURI(e).toString().replace(/\%[0-9a-fA-F]{2}/g, "a");
                return t.length + (t.length != e ? 3 : 0);
            }(e), r = 1, i = 0, o = 0, a = E.length; o <= a; o++){
                var l = E[o];
                if (!l) throw new Error("Content too long: expected " + i + " but got " + n);
                switch(t){
                    case "L":
                        i = l[0];
                        break;
                    case "M":
                        i = l[1];
                        break;
                    case "Q":
                        i = l[2];
                        break;
                    case "H":
                        i = l[3];
                        break;
                    default:
                        throw new Error("Unknwon error correction level: " + t);
                }
                if (n <= i) break;
                r++;
            }
            if (r > E.length) throw new Error("Content too long");
            return r;
        }(r, this.options.ecl), u = function(e) {
            switch(e){
                case "L":
                    return i;
                case "M":
                    return o;
                case "Q":
                    return a;
                case "H":
                    return l;
                default:
                    throw new Error("Unknwon error correction level: " + e);
            }
        }(this.options.ecl);
        this.qrcode = new n(s, u), this.qrcode.addData(r), this.qrcode.make();
    }
    x.prototype.svg = function(e) {
        var t = this.options || {}, n = this.qrcode.modules;
        void 0 === e && (e = {
            container: t.container || "svg"
        });
        for(var r = void 0 === t.pretty || !!t.pretty, i = r ? "  " : "", o = r ? "\r\n" : "", a = t.width, l = t.height, s = n.length, u = a / (s + 2 * t.padding), c = l / (s + 2 * t.padding), d = void 0 !== t.join && !!t.join, f = void 0 !== t.swap && !!t.swap, h = void 0 === t.xmlDeclaration || !!t.xmlDeclaration, p = void 0 !== t.predefined && !!t.predefined, m = p ? i + '<defs><path id="qrmodule" d="M0 0 h' + c + " v" + u + ' H0 z" style="fill:' + t.color + ';shape-rendering:crispEdges;" /></defs>' + o : "", g = i + '<rect x="0" y="0" width="' + a + '" height="' + l + '" style="fill:' + t.background + ';shape-rendering:crispEdges;"/>' + o, b = "", y = "", v = 0; v < s; v++)for(var I = 0; I < s; I++)if (n[I][v]) {
            var M = I * u + t.padding * u, E = v * c + t.padding * c;
            if (f) {
                var x = M;
                M = E, E = x;
            }
            if (d) {
                var S = u + M, w = c + E;
                M = Number.isInteger(M) ? Number(M) : M.toFixed(2), E = Number.isInteger(E) ? Number(E) : E.toFixed(2), S = Number.isInteger(S) ? Number(S) : S.toFixed(2), y += "M" + M + "," + E + " V" + (w = Number.isInteger(w) ? Number(w) : w.toFixed(2)) + " H" + S + " V" + E + " H" + M + " Z ";
            } else b += p ? i + '<use x="' + M.toString() + '" y="' + E.toString() + '" href="#qrmodule" />' + o : i + '<rect x="' + M.toString() + '" y="' + E.toString() + '" width="' + u + '" height="' + c + '" style="fill:' + t.color + ';shape-rendering:crispEdges;"/>' + o;
        }
        d && (b = i + '<path x="0" y="0" style="fill:' + t.color + ';shape-rendering:crispEdges;" d="' + y + '" />');
        var k = "";
        switch(e.container){
            case "svg":
                h && (k += '<?xml version="1.0" standalone="yes"?>' + o), k += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + a + '" height="' + l + '">' + o, k += m + g + b, k += "</svg>";
                break;
            case "svg-viewbox":
                h && (k += '<?xml version="1.0" standalone="yes"?>' + o), k += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ' + a + " " + l + '">' + o, k += m + g + b, k += "</svg>";
                break;
            case "g":
                k += '<g width="' + a + '" height="' + l + '">' + o, k += m + g + b, k += "</g>";
                break;
            default:
                k += (m + g + b).replace(/^\s+/, "");
        }
        return k;
    }, x.prototype.save = function(e, t) {
        var n = this.svg();
        "function" != typeof t && (t = function(e, t) {});
        try {
            (parcelRequire("kjyEk")).writeFile(e, n, t);
        } catch (e) {
            t(e);
        }
    }, e.exports = x;
}($cf61b77dbdb95489$var$Qc)), $cf61b77dbdb95489$var$Qc.exports), $cf61b77dbdb95489$var$Wc = $cf61b77dbdb95489$var$m($cf61b77dbdb95489$var$qc), $cf61b77dbdb95489$var$Gc = new $cf61b77dbdb95489$var$En("QR"), $cf61b77dbdb95489$var$Bc = function(e, t, n) {
    e.length > 500 && $cf61b77dbdb95489$var$Gc.warn("getQrData", 'The size of the payload in the QR code is quite long and some devices might not be able to scan it anymore. To reduce the QR size, try using a shorter "name", "appUrl" and "iconUrl"');
    try {
        return new $cf61b77dbdb95489$var$Wc({
            color: "black",
            content: e,
            join: !0,
            ecl: "L",
            height: t,
            width: n
        }).svg();
    } catch (e) {
        throw console.error("error", e), e;
    }
}, $cf61b77dbdb95489$var$Kc = function(e) {
    var t = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), r = t[0], i = t[1], o = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(""), 2), a = o[0], l = o[1];
    $cf61b77dbdb95489$var$_.useEffect(function() {
        var t = e.code.startsWith("wc:") ? e.code : $cf61b77dbdb95489$var$Vn("tezos://", e.code), n = e.isMobile ? $cf61b77dbdb95489$var$Bc(t, 300, 300) : $cf61b77dbdb95489$var$Bc(t, 160, 160);
        l(n);
    }, [
        e.code,
        e.isMobile
    ]);
    var s = function() {
        var t = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function t() {
            var n;
            return $cf61b77dbdb95489$var$u().w(function(t) {
                for(;;)switch(t.p = t.n){
                    case 0:
                        return e.onClickQrCode && e.onClickQrCode(), t.p = 1, t.n = 2, navigator.clipboard.writeText(e.code);
                    case 2:
                        r || (i(!0), setTimeout(function() {
                            i(!1);
                        }, 3e3)), t.n = 4;
                        break;
                    case 3:
                        t.p = 3, n = t.v, console.error("Error copying text: ", n);
                    case 4:
                        return t.a(2);
                }
            }, t, null, [
                [
                    1,
                    3
                ]
            ]);
        }));
        return function() {
            return t.apply(this, arguments);
        };
    }();
    return $cf61b77dbdb95489$var$le.jsxs("div", {
        className: "qr-wrapper",
        style: e.isMobile ? {
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "340px",
            textAlign: "center",
            border: "none"
        } : {},
        children: [
            $cf61b77dbdb95489$var$le.jsxs("div", {
                className: "qr-left",
                children: [
                    !e.isMobile && $cf61b77dbdb95489$var$le.jsx("h3", {
                        children: "Or scan to connect"
                    }),
                    !e.isMobile && $cf61b77dbdb95489$var$le.jsx("span", {
                        children: "Open ".concat(e.walletName, " Wallet on your mobile phone and scan.")
                    }),
                    e.isMobile && $cf61b77dbdb95489$var$le.jsx("span", {
                        children: "Scan QR code with a ".concat(e.isWalletConnect ? "WalletConnect" : "Beacon", "-compatible wallet.")
                    })
                ]
            }),
            $cf61b77dbdb95489$var$le.jsxs("div", {
                className: "qr-right",
                style: e.isMobile ? {
                    backgroundColor: "transparent"
                } : {},
                onClick: s,
                children: [
                    $cf61b77dbdb95489$var$le.jsx("div", {
                        dangerouslySetInnerHTML: {
                            __html: a
                        },
                        className: "qr-svg-wrapper"
                    }),
                    r ? $cf61b77dbdb95489$var$le.jsxs("div", {
                        className: "qr-copy-wrapper",
                        children: [
                            $cf61b77dbdb95489$var$le.jsx("svg", {
                                fill: "currentColor",
                                strokeWidth: "0",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 512 512",
                                height: "1em",
                                width: "1em",
                                style: {
                                    overflow: "visible"
                                },
                                children: $cf61b77dbdb95489$var$le.jsx("path", {
                                    d: "M243.8 339.8c-10.9 10.9-28.7 10.9-39.6 0l-64-64c-10.9-10.9-10.9-28.7 0-39.6 10.9-10.9 28.7-10.9 39.6 0l44.2 44.2 108.2-108.2c10.9-10.9 28.7-10.9 39.6 0 10.9 10.9 10.9 28.7 0 39.6l-128 128zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0s256 114.6 256 256zM256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"
                                })
                            }),
                            $cf61b77dbdb95489$var$le.jsx("p", {
                                children: "Copied!"
                            })
                        ]
                    }) : $cf61b77dbdb95489$var$le.jsxs("div", {
                        className: "qr-copy-wrapper",
                        children: [
                            $cf61b77dbdb95489$var$le.jsx("svg", {
                                fill: "currentColor",
                                strokeWidth: "0",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 512 512",
                                height: "1em",
                                width: "1em",
                                style: {
                                    overflow: "visible"
                                },
                                children: $cf61b77dbdb95489$var$le.jsx("path", {
                                    d: "M502.6 70.63 441.35 9.38C435.4 3.371 427.2 0 418.7 0H255.1c-35.35 0-64 28.66-64 64l.02 256c.88 35.4 29.58 64 64.88 64h192c35.2 0 64-28.8 64-64V93.25c0-8.48-3.4-16.62-9.4-22.62zM464 320c0 8.836-7.164 16-16 16H255.1c-8.838 0-16-7.164-16-16V64.13c0-8.836 7.164-16 16-16h128L384 96c0 17.67 14.33 32 32 32h47.1v192zM272 448c0 8.836-7.164 16-16 16H63.1c-8.838 0-16-7.164-16-16l.88-255.9c0-8.836 7.164-16 16-16H160V128H63.99c-35.35 0-64 28.65-64 64L0 448c.002 35.3 28.66 64 64 64h192c35.2 0 64-28.8 64-64v-32h-47.1l-.9 32z"
                                })
                            }),
                            $cf61b77dbdb95489$var$le.jsx("p", {
                                children: "Copy to clipboard"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}, $cf61b77dbdb95489$var$Yc = function(e) {
    var t = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState("selection"), 2), r = t[0], i = t[1], o = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), a = o[0], l = o[1], s = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), c = s[0], f = s[1], h = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(""), 2), p = h[0], m = h[1];
    $cf61b77dbdb95489$var$_.useEffect(function() {
        var t = function() {
            var t = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function t() {
                var n, r;
                return $cf61b77dbdb95489$var$u().w(function(t) {
                    for(;;)switch(t.n){
                        case 0:
                            return t.n = 1, e.p2pPayload;
                        case 1:
                            return n = t.v, t.n = 2, e.wcPayload;
                        case 2:
                            r = t.v, l(!!(n && n.length > 0)), f(!!(r && r.length > 0));
                        case 3:
                            return t.a(2);
                    }
                }, t);
            }));
            return function() {
                return t.apply(this, arguments);
            };
        }();
        t(), i("selection"), m("");
    }, []);
    var g = function() {
        var t = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function t(n) {
            var r, o;
            return $cf61b77dbdb95489$var$u().w(function(t) {
                for(;;)switch(t.n){
                    case 0:
                        if ("p2p" !== n) {
                            t.n = 2;
                            break;
                        }
                        return r = m, t.n = 1, e.p2pPayload;
                    case 1:
                        r(t.v), t.n = 4;
                        break;
                    case 2:
                        return o = m, t.n = 3, e.wcPayload;
                    case 3:
                        o(t.v);
                    case 4:
                        i(n);
                    case 5:
                        return t.a(2);
                }
            }, t);
        }));
        return function(e) {
            return t.apply(this, arguments);
        };
    }();
    return $cf61b77dbdb95489$var$le.jsxs($cf61b77dbdb95489$var$le.Fragment, {
        children: [
            "selection" === r && $cf61b77dbdb95489$var$le.jsxs("div", {
                children: [
                    $cf61b77dbdb95489$var$le.jsx("span", {
                        className: "pair-other-info",
                        children: "Select QR Type"
                    }),
                    $cf61b77dbdb95489$var$le.jsx("br", {}),
                    a && $cf61b77dbdb95489$var$le.jsx("button", {
                        className: "wallets-button",
                        onClick: function() {
                            return g("p2p");
                        },
                        children: "Beacon"
                    }),
                    c && $cf61b77dbdb95489$var$le.jsx("button", {
                        className: "wallets-button",
                        onClick: function() {
                            return g("walletconnect");
                        },
                        children: "WalletConnect"
                    })
                ]
            }),
            "selection" !== r && p && $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Kc, {
                isWalletConnect: "walletconnect" === r,
                isMobile: !0,
                walletName: "AirGap",
                code: p,
                onClickLearnMore: e.onClickLearnMore
            }),
            "selection" !== r && !p && $cf61b77dbdb95489$var$le.jsx("span", {
                style: {
                    color: "#FF4136"
                },
                className: "pair-other-info",
                children: "Not connected."
            })
        ]
    });
}, $cf61b77dbdb95489$var$Zc = function(e) {
    return $cf61b77dbdb95489$var$le.jsxs("div", {
        style: {
            pointerEvents: e.disabled ? "none" : "auto"
        },
        className: e.disabled ? "wallet-disabled" : "",
        children: [
            !e.small && $cf61b77dbdb95489$var$le.jsxs("div", {
                className: "wallet-main ".concat(e.mobile ? "wallet-main-mobile" : ""),
                onClick: e.onClick,
                children: [
                    $cf61b77dbdb95489$var$le.jsxs("div", {
                        className: "wallet-main-left ".concat(e.mobile ? "wallet-main-left-mobile" : ""),
                        children: [
                            $cf61b77dbdb95489$var$le.jsx("h3", {
                                children: e.name
                            }),
                            e.description && $cf61b77dbdb95489$var$le.jsx("p", {
                                children: e.description
                            }),
                            e.tags && e.tags.length > 0 && $cf61b77dbdb95489$var$le.jsx("div", {
                                className: "wallet-main-tags",
                                children: e.tags.map(function(e, t) {
                                    return $cf61b77dbdb95489$var$le.jsx("span", {
                                        className: "wallet-main-tag",
                                        children: e
                                    }, t);
                                })
                            })
                        ]
                    }),
                    $cf61b77dbdb95489$var$le.jsx("div", {
                        className: "wallet-main-right",
                        children: $cf61b77dbdb95489$var$le.jsx("img", {
                            src: e.image,
                            alt: "".concat(e.name, " logo")
                        })
                    })
                ]
            }),
            e.small && $cf61b77dbdb95489$var$le.jsxs("div", {
                className: "wallet-small",
                onClick: e.onClick,
                children: [
                    $cf61b77dbdb95489$var$le.jsx("img", {
                        src: e.image,
                        alt: "".concat(e.name, " logo")
                    }),
                    $cf61b77dbdb95489$var$le.jsx("h3", {
                        children: e.name
                    })
                ]
            })
        ]
    });
}, $cf61b77dbdb95489$var$Xc = function(e) {
    return $cf61b77dbdb95489$var$le.jsxs("div", {
        className: "top-wallets-wrapper",
        children: [
            $cf61b77dbdb95489$var$le.jsxs("div", {
                className: "top-wallets-info",
                children: [
                    $cf61b77dbdb95489$var$le.jsx("h3", {
                        children: "Connect Wallet"
                    }),
                    $cf61b77dbdb95489$var$le.jsxs("span", {
                        children: [
                            "Do you wish to report a bug?",
                            " ",
                            $cf61b77dbdb95489$var$le.jsx("span", {
                                className: "top-wallets-learn-more",
                                onClick: e.onClickLearnMore,
                                children: "Click here"
                            })
                        ]
                    })
                ]
            }),
            $cf61b77dbdb95489$var$le.jsxs("div", {
                style: 1 === e.wallets.length ? {
                    gridTemplateColumns: "1fr"
                } : void 0,
                className: "top-wallets-wallets-main",
                children: [
                    e.wallets.map(function(t) {
                        return $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Zc, {
                            disabled: e.disabled,
                            mobile: e.isMobile,
                            name: t.name,
                            description: t.descriptions.join(" & "),
                            image: t.image,
                            onClick: function() {
                                return e.onClickWallet(t.id);
                            },
                            tags: t.tags
                        }, t.id);
                    }),
                    e.otherWallets && $cf61b77dbdb95489$var$le.jsxs("div", {
                        className: "top-wallets-other-wallets",
                        onClick: e.otherWallets.onClick,
                        children: [
                            $cf61b77dbdb95489$var$le.jsxs("div", {
                                className: "top-wallets-other-wallets-left",
                                children: [
                                    $cf61b77dbdb95489$var$le.jsx("h3", {
                                        children: "Other Wallets"
                                    }),
                                    $cf61b77dbdb95489$var$le.jsx("p", {
                                        children: "See other wallets you can use to connect"
                                    })
                                ]
                            }),
                            $cf61b77dbdb95489$var$le.jsxs("div", {
                                className: "top-wallets-other-wallets-right",
                                children: [
                                    $cf61b77dbdb95489$var$le.jsx("img", {
                                        src: e.otherWallets.images[0],
                                        alt: "Other Wallet 1"
                                    }),
                                    $cf61b77dbdb95489$var$le.jsx("img", {
                                        className: "top-wallets-other-wallets-center-wallet",
                                        src: e.otherWallets.images[1],
                                        alt: "Other Wallet 2"
                                    }),
                                    $cf61b77dbdb95489$var$le.jsx("img", {
                                        src: e.otherWallets.images[2],
                                        alt: "Other Wallet 3"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}, $cf61b77dbdb95489$var$Pc = function(e) {
    return $cf61b77dbdb95489$var$le.jsxs("div", {
        className: "wallets-list-main-wrapper",
        children: [
            $cf61b77dbdb95489$var$le.jsx("div", {
                className: "wallets-list-wrapper",
                children: e.wallets.map(function(t) {
                    return $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Zc, {
                        disabled: e.disabled,
                        name: t.name,
                        description: t.descriptions.join(" & "),
                        image: t.image,
                        small: e.small,
                        onClick: function() {
                            return e.onClickWallet(t.id);
                        }
                    }, t.id);
                })
            }),
            $cf61b77dbdb95489$var$le.jsx("button", {
                className: "wallets-button",
                onClick: e.onClickOther,
                children: e.isMobile ? "Pair wallet on another device" : "Show QR code"
            })
        ]
    });
};
class $cf61b77dbdb95489$var$Jc extends $cf61b77dbdb95489$var$zn {
    activeListeners = new Map;
    async init() {
        this.subscribeToMessages().catch(console.error);
    }
    async listenForEncryptedMessage(e, t) {
        if (this.activeListeners.has(e)) return;
        this.activeListeners.set(e, async (n, r)=>{
            try {
                const i = await this.decryptMessage(e, n.encryptedPayload);
                t(i, r);
            } catch (e) {}
        });
    }
    async sendMessage(e, t) {
        const n = await this.encryptMessage(t.publicKey, e), r = t?.extensionId, i = {
            target: $cf61b77dbdb95489$var$rn.EXTENSION,
            encryptedPayload: n,
            targetId: r
        };
        $cf61b77dbdb95489$var$yn.postMessage(i, $cf61b77dbdb95489$var$yn.location.origin);
    }
    async listenForChannelOpening(e) {
        $cf61b77dbdb95489$var$yn.addEventListener("message", async (t)=>{
            if (t.source !== $cf61b77dbdb95489$var$yn || t.origin !== $cf61b77dbdb95489$var$yn.location.origin) return;
            const n = t?.data?.message;
            if (n && n.target === $cf61b77dbdb95489$var$rn.PAGE && await this.isChannelOpenMessage(n)) {
                const r = $cf61b77dbdb95489$require$Buffer.from(n.payload, "hex");
                if (r.length >= 40) try {
                    const n = JSON.parse(await $cf61b77dbdb95489$var$Ht(r, this.keyPair.publicKey, this.keyPair.secretKey));
                    e(new $cf61b77dbdb95489$var$mn(n.id, n.name, n.publicKey, n.version, await (async (e)=>{
                        /^[A-F0-9]+$/i.test(e) || console.error("PublicKey needs to be in hex format!");
                        const t = $cf61b77dbdb95489$require$Buffer.from($cf61b77dbdb95489$var$Rt($cf61b77dbdb95489$require$Buffer.from(e, "hex"), 5));
                        return $cf61b77dbdb95489$var$Be.encode(t);
                    })(n.publicKey), t?.data?.sender.id));
                } catch (e) {}
            }
        });
    }
    async sendPairingRequest(e) {
        const t = {
            target: $cf61b77dbdb95489$var$rn.EXTENSION,
            payload: await (new $cf61b77dbdb95489$var$Sn).serialize(await this.getPairingRequestInfo()),
            targetId: e
        };
        $cf61b77dbdb95489$var$yn.postMessage(t, $cf61b77dbdb95489$var$yn.location.origin);
    }
    async isChannelOpenMessage(e) {
        return "object" == typeof e && e.hasOwnProperty("payload");
    }
    async subscribeToMessages() {
        $cf61b77dbdb95489$var$yn.addEventListener("message", (e)=>{
            if (e.source === $cf61b77dbdb95489$var$yn && e.origin === $cf61b77dbdb95489$var$yn.location.origin && "object" == typeof e && e) {
                const t = e.data;
                t.message && t.message.target === $cf61b77dbdb95489$var$rn.PAGE && this.activeListeners.forEach((e)=>{
                    e(t.message, {
                        origin: $cf61b77dbdb95489$var$nn.EXTENSION,
                        id: t.sender.id || ""
                    });
                });
            }
        });
    }
}
const $cf61b77dbdb95489$var$Hc = new $cf61b77dbdb95489$var$En("PostMessageTransport");
let $cf61b77dbdb95489$var$_c, $cf61b77dbdb95489$var$$c, $cf61b77dbdb95489$var$ed = !1;
class $cf61b77dbdb95489$var$td extends $cf61b77dbdb95489$var$kn {
    type = $cf61b77dbdb95489$var$ln.POST_MESSAGE;
    constructor(e, t, n, r){
        super(e, new $cf61b77dbdb95489$var$Jc(e, t), new $cf61b77dbdb95489$var$Nn(n, r));
    }
    static async isAvailable() {
        return new Promise((e)=>{
            const t = (n)=>{
                const r = n.data;
                r && "pong" === r.payload && (e(!0), $cf61b77dbdb95489$var$yn.removeEventListener("message", t));
            };
            $cf61b77dbdb95489$var$yn.addEventListener("message", t);
            const n = {
                target: $cf61b77dbdb95489$var$rn.EXTENSION,
                payload: "ping"
            };
            $cf61b77dbdb95489$var$yn.postMessage(n, $cf61b77dbdb95489$var$yn.location.origin);
        });
    }
    static async getAvailableExtensions() {
        return $cf61b77dbdb95489$var$_c || $cf61b77dbdb95489$var$$c || ($cf61b77dbdb95489$var$$c = [], $cf61b77dbdb95489$var$_c = new Promise((e)=>{
            $cf61b77dbdb95489$var$td.listenForExtensions(), setTimeout(()=>{
                e($cf61b77dbdb95489$var$$c ?? []);
            }, 1e3);
        }).finally(()=>{
            $cf61b77dbdb95489$var$_c = void 0;
        }), $cf61b77dbdb95489$var$_c);
    }
    static listenForExtensions() {
        if ($cf61b77dbdb95489$var$ed) return;
        $cf61b77dbdb95489$var$yn.addEventListener("message", (e)=>{
            if (e.source !== $cf61b77dbdb95489$var$yn || e.origin !== $cf61b77dbdb95489$var$yn.location.origin) return;
            const t = e.data, n = t.sender;
            var r;
            t && "pong" === t.payload && n && ($cf61b77dbdb95489$var$Hc.log("getAvailableExtensions", `extension "${n.name}" is available`, n), r = n, $cf61b77dbdb95489$var$$c || ($cf61b77dbdb95489$var$$c = []), $cf61b77dbdb95489$var$$c.some((e)=>e.id === r.id) || ($cf61b77dbdb95489$var$$c.push(r), $cf61b77dbdb95489$var$yn.postMessage("extensionsUpdated", $cf61b77dbdb95489$var$yn.location.origin)));
        });
        const e = {
            target: $cf61b77dbdb95489$var$rn.EXTENSION,
            payload: "ping"
        };
        $cf61b77dbdb95489$var$yn.postMessage(e, $cf61b77dbdb95489$var$yn.location.origin), $cf61b77dbdb95489$var$ed = !0;
    }
    async connect() {
        if ($cf61b77dbdb95489$var$Hc.log("connect"), this._isConnected !== $cf61b77dbdb95489$var$an.NOT_CONNECTED) return;
        this._isConnected = $cf61b77dbdb95489$var$an.CONNECTING;
        const e = await this.getPeers();
        if (e.length > 0) {
            $cf61b77dbdb95489$var$Hc.log("connect", `connecting to ${e.length} peers`);
            const t = e.map(async (e)=>this.listen(e.publicKey));
            Promise.all(t).catch((e)=>$cf61b77dbdb95489$var$Hc.error("connect", e));
        }
        await this.startOpenChannelListener(), await super.connect();
    }
    async startOpenChannelListener() {}
    async getPairingRequestInfo() {
        return this.client.getPairingRequestInfo();
    }
    async listen(e) {
        $cf61b77dbdb95489$var$Hc.log("listen", e), await this.client.listenForEncryptedMessage(e, (e, t)=>{
            const n = {
                origin: $cf61b77dbdb95489$var$nn.EXTENSION,
                id: t.id
            };
            this.notifyListeners(e, n).catch((e)=>{
                throw e;
            });
        }).catch((e)=>{
            throw e;
        });
    }
}
$cf61b77dbdb95489$var$td.getAvailableExtensions();
var $cf61b77dbdb95489$var$nd, $cf61b77dbdb95489$var$rd, $cf61b77dbdb95489$var$id = [
    {
        key: "spire_chrome",
        id: "gpfndedineagiepkpinficbcbbgjoenn",
        name: "Spire",
        shortName: "Spire",
        color: "",
        logo: "data:image/png;base64,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",
        link: "https://spirewallet.com/"
    },
    {
        key: "temple_chrome",
        id: "ookjlbkiijinhpmnjffcofjonbfbgaoc",
        name: "Temple Wallet Chrome",
        shortName: "Temple",
        color: "",
        logo: "data:image/png;base64,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",
        link: "https://templewallet.com/"
    },
    {
        key: "temple_firefox",
        id: "{34ac229e-1cf5-4e4c-8a77-988155c4360f}",
        name: "Temple Wallet Firefox",
        shortName: "Temple",
        color: "",
        logo: "data:image/png;base64,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",
        link: "https://templewallet.com/"
    }
], $cf61b77dbdb95489$var$od = [
    {
        key: "infinity_wallet",
        name: "Infinity Wallet",
        shortName: "Infinity Wallet",
        color: "rgb(52, 147, 218)",
        logo: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAABm3ElEQVR4AezBa7Sld2Ef5uf3f999rnPOnDMz6IIuMwhJIBAgQBDuYMCEAIkvwRDXWWnqFeeymqTOWk3bWUmafulaadN+6KeufOjqstO0TVbc4sSJg11iG4MdMNjEssECobtGc7+ec/bZe7/v++9oBNjYGAvQSDOa/Tz50z/5IZfLdLtf+N2fP/XKUppXpTT3DH33EtwwWlq5KbIXMTc395Rp33en+tnkSJInkvLlYei/sLKv+Z07v2/zQZdJ61k23RmWj/7u+BUpeU2tzb2jxaWDlM3EZmmaVSwnWcHI3Nzc1y2kbUelafaWYTgoXlVq++5+mpOP/eb4gX46+cLinoXP3Xj3ygOeRa1nwe6Fvpz4ys71lHfXvn3L+aP1ZYmbU4ZbSjNa8TUxNzf3x0my2KSsJ/F1tdeff3I4P3R5fHy2PjT0k/uGbvbJtPWzN79m7azvUet7MD7XNace2r2hG3vP1sn6/dR7SjO8tDTNsrm5ue9IakX1hzRJ2WxGC5t18Mqzj/dvr0P9PmW4T935efpfufmetbO+S63v0vhst3nsS7vv2jox/ICUN5RmdCdac3Nzl0tJspmmfUtVX3/2seF16vBe2frnN79mz6d8F1rfoZ3Ts4Uzj0/unO34wa2T/lxpR69Fa25u7jkTWUzTvEFtXnXmkenLS7b/WTX8qxffvedMSqpnqPUd2DndrR+7f/KOreP9X0xp3lGa5kZzc3PPn1hq2oX3nHp4dmutw+uS8U/f8IrlL5QmnWeguf1Nd3omtk/Prj9+/+QHt0/6m007el9K2Wtubu5KkFKa/aVp79053d049MOp1X3tYynp/Qlaz8DO6e6m4/dPPrx9sv54adpXm5ubuxI1pR39uVMPzvamTJZedMfix5tRdn0brT/BzunupuNfnnx0+5SfKE37cnNzc1e00o7eefKr3aLIi25f/Hgzytgfo7n9TXf642yfnl1//P7JR7ZP+WulNC83Nzd3VUgpN2+f6g+qw6PLe9snSpPOt9Dc/qY7fSs7p7v14/dPfnD7ZP0bpWlfaW5u7qqSUm7ZOjm7UeqXl/a2x0qT3h/S3P6mO/1hO2e65viXd9+9fcrfLk37BnNzc1elUpqXbJ2crSXD55fWmzOlTfUHFN/C2ccnd1043v/lUpo3m5ubu6o17ejDx740/vBku9/0hxR/yPhstzndrj+aNO9BMTc3d9UrTfvXto53b+4mw7I/oPgDxue65tiXdt+1dcL7StPsMzc394LQjBZuPXb/5K+cfnhysJsM8TXFH3Dqod2btk4OP1ya5h5zc3MvKO1o8Qee/OLOO8fnujVfU3zN7oW+dLv5M0nzJrTm5uZeeKr/dHy2u72bDnFR8TUnvrJz/daJ/t0p5XZzc3MvSKOllTcf/dLkdeMz3R4XFV8TzXspd5ubm3tBK2k/SrnNRcVF051heeibd5WmudPc3NwLWmmat0936kv6WW2Li5783e27zx+dHkJrbm7uhS1ZfOI/br9x6+Ts+uKiOvRvqMNw0Nzc3LXiT+PWdrrdL5Rm+e5mNNxobm7umtCOFl45THN9s3N836u7cX44pXmFubm5a0PSnnl8+zdKKc2rKJvm5uauNXeVlOaexKa5ublrSh36g2Xou5fUWlfNzc1dU0rT3lpwA5bNzc1dM7q2NaSkHS2t3JRkxdzc3DWj7Tq1He0rkb0YmZubu6ZEVgtibm7umlTMzc1ds4q5ublrVjE3N3fNKubm5q5Zxdzc3DWrmJubu2YVc3Nz16xibm7umlXMzc1ds4q5ublrVjE3N3fNKubm5q5Zxdzc3DWrmJubu2YVc3Nz16xibm7umlXMzc1ds4q5ublrVjE3N3fNKubm5q5Zxdzc3DWrmJubu2YVc3Nz16xibm7umtV6Sq3E3NzcNSVaX1fNzc1dY1pz35Vaq9SBWhkGavVNEkpRU0gkMfddGAbqwDBQq2+SUIqaQiKJue9Ma+6ZG3q6jloJtVLFJQmJp2QYDLVKHdCLSkVC09A0iLlvYRjoOupAotaqiksSEk9JHdRKHaroqINUJDSNWhpJzH17rYuquT9WrdLNqFVFHQYWlgzre/V79+r2bKgra+qeVZrGJX0n22Nl54KyfV5z4Zxy/pzsjuk66TopRW1aSjFXpesYBrVS68Bo0bC2R793U7+2aVhZU/es0rYu6XuZTGRnW7N1Vjl3RnP+nIzHdJ2kQ9S2pTTm/qigNfet1SrdTK2DYdaxuqq/5TaTgy/V3fRSs1tuMqyt6PessbCojlo1xdelm8nuTJnsKFtb2iNHtA8/aPTYV40ee0g5f06GQUqhadVSXHuqzGZqHdR+UJeWdTfdanrwpbqbb9fdcL1+37phdV1dWlIXRmqKr0vfye5U2R0r21vao0e1Dz9o9OhXjR57UDlzmmFQmpamqKUx981ac39Eupnad0xnhv0vsvvqN5jc83rTl75Md90BFlcYBvoZs4kyncmsE7+vto1hz7Jh7xo3HzS961VMdzVnTxs99KDF+75g8b7PGR15TGYzWVhQm5bEtSDdTO17ZlPD5n67r3yd6T2vN7n9Lt3117G0QsUwYzpRZlOZdeL31aYYVpcN62uMbjV9+d3MJsr5MxYeftjifV+w8Du/aeHxh9mdyGhRbVsSc0/LLbe/+3yNJYxc41IHZjN1vKNu7LPz5ncbv+WdJq94BSsrnD+rjMcMg2+SuKRWEmp1SUKtvqE06tKyuroiXad9+CHLn/m0pV//FaPHH1GbwuKylOKFKnWg69SdbXV9r/Eb32n8lnea3H23umeN7QvKzg597xsS31ArCbW6JKFW31CKurikru5hGIwee8TSb/y6pU//koWHv0op6tKylGLOODfd9q7zKVkSI9ewdD27O2pi5/XvtPMDP2xy92s8pZw7LdOpGn9UQq0k1EpCrSTUSkKtLkmolYpRa1hbp2mMHviq1V/4t5Z//ROaC+dYWVWbxgtLZOjZ2aHv7NzzFjs/+GG7r34dbaucPyOTiRrfWkKtJNTqT1TRNoa1NUaL2kcesfqLH7fyqX+nOXWCPXvUpnUtq0MdN+ubhw4naUXjGjV0vebCWcPmfhf+wk84+xN/XX/LLcrxJ+XCeepAPHuCYZDxDpOJ/obrTe55g+66WzTHntQce1wtRSktcdWrqP2gXDirLi+78JG/4uyP/xXdHS9TTp+QC+foB+LZE9Qq47GMx/oD+03vudfsppcqJ45rn3hYLUUpLXFtqrpmffPQ4SStaFyDMp1qts6b3Hm3M3/rv7H9/e+TC+c0x08IkkgllVRSSSWVVBeFkKEihNSKiIqIiogqlVRSCTIMynishunLXm561yu1Z89bePB+tQ7SLhBXrYraD9ozJ3Q3HXLm7/xDWx/8kEx2NSdOyjCICFJJJZVUUkl1UURFCKkVERURVTwlUqtUUkklSK3K7q7a92a332H66ns0W2MLX/4ddehltEBce6quWd88dDjSonGNGWYz5cJZ43vf5vTf/e90d9yuOfK4MpmS+JPURGqV6mkJtRKCKqKqIirV7ws1kVATZTaTyVh/3YtM73m9DNXil+5Tu5ksLFJddSrqMGjPnjS96zVO/r1/bPqquzVPPCa7E0k8I4l4SqiVEFQE1dPiovh9oSYSaqJ0nezuGDY3TF7/RtpFi7/zm4bpVF1cllpdY7pmffPQ4SStaFxDMp0oW+fsvOX7nPkv/4G6vqF54nFJPFPxzYIgqLWKp8W3Fk+Li0KGquzuGlZWTF91j9ouWvqPv2HoOnVxWVRXi4ra99pTx+ze/Xon/8E/0t94k/bRRwRJPFPxtCAIaq0inhLEtxZPi4tCalXGu2oTk9fea1jda/nzv6ZMxoalVVFdQ7pmffPQ4SStaFwjMp2wdc7OW97tzN/5e+rymubYEZri2ZLEdyyeNpmoo5HZK16tLixZ/s3/QDczLK9Ira4Gte+1J4/aveeNTv3D/1G/sV/7+KM0xbMhie9a0HXUavbqewx7Nix/9lMynehX9ii1ukZ0zfrmocNJWtG4BpTpLhfO23nru535ycPq4pLm+DG1iStJmc4oremrXqMurlj+3K9JN5OlZVe6dDPNqWN273mjU3/vv9dvHNA+8ZjaxJWkdB19Z3rP6/Tr+y3/h19WphNZXnGN6Jr1zUOHRSsaL2BJUSa76tY5O297rzM/eVhdXNIeP6G2xZUo3UwtMX3169SlVcuf/VW172V5Ra2DK01EupmcOm5871ud/vv/yLCx3+ixx9S2uBJl1jObmrzuXsPeA1Y+/Qm1m8nKqloHL3Bds7556LBoReMFKomyu6NuXbDzjvc5+zf/rrq4pD1xSm2KIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIJ6W6Yw6mLzyterquuXPfFLte1leVWt15Ygym8qZk8ave7PTf/e/NexZ0z55VG2LIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIJ6WrpPJ1OTVr9fvv87Kpz6hdjNZ2aPW6gWsa9Y3Dx0WrWi8ACVRxmN1vG3n7d/v7F/924aVPdpTp9Qmrnghs45Uk1e+1rC2buUzn1T7XpZX1Vo935Ioswnnzhjf+zZnf/LvGzY2tSdOqk1c8RLpOmU2MXn1vfr911n51CfUbiYrq2qtXqC6Zn3z0GHRisYLTBJlvKPujm2/833O/dX/wrC6pj19Ri1x1QiZddTB9O7XGtbWrXzmk2rfy/KqWqvnSxKZTLhw1vgNb3f2P/+v9Pv2aU+eUksoIa3ahqbQFJoiGlKprgwJXa9Mdk1ec69+/3VWPvUJtZvJ8qqqegHqmvXNQ4dFKxovIEmUnW11d2znbe91/i//DcPauubMWdqobUPTsDCibWlb2tZTolArQ6WioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqK6pMw6DKZ3v9awtm7lM59U+16WV9VaPdeSyGSXC+eN732bs3/7v9YfuE45e4pUhirdoEw6ZXeqTDpl0imzSh1oirq4SNvStp6SvlIrFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFdUl6QaZ7pq85l79vuss//ovMZvK8orqBadrvSBFtrfU2cz2u/+M83/pr+k39ivnz5Aik5ky7aWv0vUuSdQmalvUUasuLqhLja/L7oShej7VUMa7BtXWn/2Ip+z93/4Xzp5WNvYZht5zJ7I7Zmfb+E3vcO7H/xaLG0YPP65MZ7I7YTqVSSfTGbVK19F1JC5pW8PSorqyqC4v6TZX1ZVlSmQ6ldmgxnOqhkxmyqkTtj74w9Rq7z/5n+TcGXXvfqkDqheK1kXVRdULQhJlZ0vtZna+7/3O/9iPq4urFh94VMa7Mt6V8USmU5nMZKjS976uJupopK4sGJaWDHuW1dUV/caSuryIyHQqXY94PpTxxDCw9ec+oi4s2fhf/wfOnjZs7Je+c9mlyGzC7q7d17/FhR/969JuaB96mMlEZh1Dlb6nVoZB+oFKhkrfyWyQbtvCpEMo0a8s6Pat6w9s6q7fq19flelUmcyonlNlMuHkcdsf+CFUm//kf9acO6Xfu4+KWl3tUmnWNw8dFi0aV7kkynhHrYPxW99j50M/Kn1r9MDDmlNnNee3lPFEZp0Mg0sKtVaCbmComslEs7VtdPK89okzRkdPak6dU7YnMlBXRuriIiFD9XxI30vfm979GsPe/VZ+/ZfoO1lcVl0+SZTZVCa7Jq96vfM/9jfUzeuVk8elVrWEppFS1BISSqHEJQltS6Em6kKrllCrZnuiPXVGe+SE5vQFZTJTlxbV5SVChuq5E+l6mU5NX/Va/fqmpS98Rtkdy8KiKq52oWvWNw8dTmobmiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIkijjMX1v9w3vMH7PD5GR5ugJ6XtS1KaoKTSFhKahFAmahrahoC3UqE2jtoWh154fa4+fNDp2Vjl3QWadurygLi+iSj94rmXWydCb3vUqw+YBS5/7tDKZsLSMKgiCIAiCIAiCIAiCIAiCIMLQKbtj3S13uPCRv6q77Q45dwYDpSFFSiFEUUPiokhckopSJKEpagmJ2jY0UVI157YtPHpWc/qs1GpYWzGsLNJXGQbPlXSddJ3pXXcb9l1v4b7Paba3WFwiEVUQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQT0nXrG8eOixaNK5Wiexsq0Nn9w3vNH7PD6mre2V7mxLaQlNQpKApNIWEUkhoGkoRFzWNWqhtUUcFUdtGbVvqoD21rT12SnP6vHS9YWVRXVmUiqG6JC6/kFknQ2/yilepa5sWvvAZZbLL4rJnXaJMxobVddsf/LDdN79V2TqPnqaQ+LoIqSIqEhdF4mmlIFIrJcQltTQkNIWmKls7Rk+cVc5vs7hg2LNMIn11SVxeiXSd9L3py+5SNw5YvO/zys4Wi4skrl7pmvXNQ4dFi8bVKFG2txgGu29+t533/3nDxgFlvOOSUtQgkYKmIJQiQSkEpYiLSqFpxEWlUAqhtgVRm6I2RW0b7dau5sRp5dy2DDGsrRgWW4aqDKSSSiqppJJKKqmkkkoqqaSSSiqppJJKKqmkkkoqqaQSF/Wd0leTV9yt7tlr4bc/p+zusrjk2ZTZzFN273mj7T/9IXXUyngsidoEISGoRNRUmkKtNA0lpEh8TWgaiac1QVGbhhIpVfpBe3pHc/ycoN+/ri610vcMpJJKKqmkkkoqqaSSSiqppJJKKqmkkkoqqaSSSiqpROg6qdX0jpcb9u6z8Hu/rWxdYGGRFFendM365qHDokXjapMo2xfUoRq/9b123v9h/eYBGY+plUJtipQiKZSiJjRFPCWUIkGKS0qhFBKaRmqlFEohKKGEUtSmoQ7a7U57fkJPXd2j7tmLytCJyy9CN5OB6V2vVFfXLPzub8p4zMIS8azIZGxY32fnvT9g+vJXai5ckOqSuCihhIQghURS1FBS1JDEUxJPKwWRoBRCKjUhkYY6WhRFc+acMu3Vjf2G1WXpO+kHEpdThK5TajW942WG9U0LX/miZus8oxEprj7pmvXNQ4dFi8bVJFG2L6hi513vt/PBjxr2XSe7Y6mVUihFUiiFoBQRSVGDpkjQFBKaIgmluKQUhKahaUSlKVIbCkJd3SOjZTn5qNEDXzB6+MvS7+r3XcfisnQddSBxOUXoZiimL7tLXdlj8Uu/Lbs7LCyS+J7UKkOvu/mg8du/37B3n+xsi/gmCQlNIfF1SSFVRFUlcUlTJEE8JS5KPCWVmrC4Kn2vnPyq5rH7jL56n/b0Cf3+fYZ910kf+hmJyylC1yFmt99pWNtr9JUvKRfOMVogxdUlXbO+eeiwaNG4WiTK1gUVO+98n+0PfcSw/wbZHUsdaAqJJAQpkpAQlCIipaguKkU8JSSUIkEpLilFKkqhFOKiyp416qC9/7MWv/hrRo980cJD91u8/z5la0t3463q+qb0PbVX47JLNyON2W2vMKysWLj/d5TxNguLJL5rQ09pTO54hclr/pSk0M98SyEpBCkElQipIqpK00iJpyQuiktKkURqUfesKdvbFr74a0Zf+azm1BPa00eNHvo9zROPG/Zu6m68iRrppmpcduk6UnS33mHYs2704P3KhfOMRqS4eqRr1jcPHRYtGleDRNm6oGLnne+z/YEfMey7XnZ3qD0llEiJWkIJpZCQSEJCkCIiJWpQQlMkLgqlSFCKS0oRpA6ytsHQW/ytf2/xd35Ns3NWQlTZOq995AFlZ6y/+ZBhY590vdSBuOzKdKq2je62lxuWly0+8Huys83CAonvRrqZ2i6Yvuw1Zne9hgwMvW8roYSEoBIhVW2KkqKqkhDiKZEghT17ZXzW4m9+wujBLyizsZRIKdJ3micf0zz5uGHjRYabDrqkm5G43Mp0pjaN7tAd6p41o0ce0Jw/SzuiFFeHdM365qHDokXjSpcoWxdUjN/+ftsf+BHDgRtkZ0f6jrgkQiKJWkIplFBCQgkpUkIpJJQiKVKK6qKmSNAUhKZI4pK1dRVLn/24xd/+tNJN1IVFmlZtR7Qts4n28YdkvKu/6ZBhY590vQyDIAiCIAiCIAiCIAiCIAiCIAiCiHQzmpHutpepS0tGD96vbG8xWiDFdypdR2nNXvoKszteIcMgwyAIgiAIgiAuKpGEhIREUkgVUVURQlyUwtqmsnXK0md/weiB/yi1VxcWaRpKoW0ltCeOaY8d0W/s1990yFMym0kiCIIgCIIgCIIgCIIgCIIgCIKI9B2l1R28XV3Zo33kAeX8WdqW0rjypWvWNm49jBaNK1hKUbYuUKvxO95n+wM/Yjhwo4x3pO8IQfwBiSSUSAkllEKKJCSUIgmlEKSISCmqi0qRoClSK3s2UC39+s9b+q1PSjdTFxfVFGqlVlJoR3RT7RMPy3isf/FBw+Y+6ToZehFBEARBEARBEARBEARBEARBPC0umk1pF8xecqe6uGD04JeVrQuMRiRqrZ6p9L1aGrODt5vd/nJPyTAIgiAIgiAIEiQklFBCJUKIqKoITVjf1J49Z+nTP2d0/29RBxYW1YRafUPTSonm5FHtsSP6jf36mw6RKNOZJIIgCIIgCIIgCIIgCIIgCIJ4WpBupjat7uBL1ZVVo8e+qpw7QzuiFLVWV6xau2Zt49bDpBWNK1QSZXtLxfgd77f9gR/RHbheGW9L35H4dhIXhYQUSighhYKERIJSXFKKIKWoiIvWNhh6y7/6c5Y+/8vSzdSFRTXxLbUjphPtkUdke0t/4y2GzQP0nQw9icspCbMpowWzl9ypjhaMHnlA2b5AO1JL8YxVouoP3Gh2xytZXJS+8x1JSFFLCCoR4qJICav7lZ1Tln/pX1n44m+IysKi6lurpZEUzalj2mNP6vfu07/4oEu6qSQuu9mUdqS79TZ1ZUX72EOac2doWrVpXLlq16xtHDwsaUXjCpRE2d6iDsbveJ/tD3xEf+AGGe9INyPxJ6q+WZDQRBJKKCEhkaAUl5QiGPbupQ6Wf/lfWfnML0rXqYvLauLbGo2YTrRHHlF2dnQvvsWweYC+o+89FzKbMlo0e8kd6mjB6NEHla3z0o7UUjwjiTKbsrxseufdhs39srur+i4klJCQSEUphr0bmnMnrfx/P2Pxvs+Iqi4sqfFt1aaRFM2po9rjTxr27tO/+KBLupnnQroZ7YLultvU5WXt4w9rzp2RplWbxhWqa9Y2Dh6WtKJxhUmibG9RB+O3fb/tD35Ed+B6ZWdH6WcigiAIgiAIgiAIgiAuSiiRFEoohRQSEgkVw8am9IOVf/8xK5/6uPSdurSixjMzGkk31Tz5qLK9o7vxFsO+A9J3DL2IIAiCIAiCIAiCIAiCIAiCIAiCzKbqaNHs0O3qqNU++pCydV7akVqKPyyJDIMy3pHdMYkMg4jZoTt1Nx9SdncEQRAEQRAEQRAEQYRSSChF3buhnDlr5Rf+uaXf+jWpDItLajwjtWkkRXPqqOb4k4aN/fqbDrqkn4kIgiAIgiAIgiAIgiAIgiAIgiDIbKaOFnS33qYuL2ufeFRz7ow0rdo0rkBds7Zx8LCkFY0rSBJle0ut1e7b32/rQx/VH7hB2dmRfob4XgUJ4qKQUEJTSPGUYWOfqFb+3b+0+sl/I11nWFlV4zuSdiSziebJR5WdHd2Ntxj2HZCuk6EncbllMlEXl8wO3k67qH38YWXrvLStWoqvSyKzmXQz/b7rDAdulL5TJrsym6lLe8xuv0tdWpLplMR3rcSwuV+5cNqej/2flj7/q5IYlpbU+I7UppEUzamjmuNPGjb361980FPSzUhcbpnO1NGC7paXqMtr2iOPas6elqZVm8YVpmvWNg4elrSicaVINDtbaq3Gb3+/7Q98VL//OhlvS98hLosgIVHDsHdTEqv/9l9Y+cTHlL4zrOxRfZfaEbOJ9slHle0t/fU3GTYP0M1kGEhcXpHpRF1c1h28Q20XtE88rFw4J22rliKJTKcy2TU7dKftD/yI3Td/HynaY09ots7L7o7+RTfpD76U6VSGgfjOVJcMm5ty4Yw9H/unVj7zCRJ1aVn13alNIymaU0c1x48YNvbrX3wricxmJC63TKfqwqLu5peoS6vaJx/VnD0tTas2jStI16xtHDwsaUXjSpAoO1vS98Zv/37bH/wLhs0XKTtb0veIy6tSqet71VKs/pv/28rP/wtNrYaVParvTW1HMptojzyibG/rb7hV3dwvfccwIC63TKfq0pLulpfQLGiPPKxcOEc7kr5TdsdmL3mZ7T/zEZN736K7+VbaBQsPfFFz6hjdTBlv6265zXDgOplMGHrEM1JRGDY2ZOuctZ/5KSu/+ouUVl1aVn1vatOQojl5THP8CcPGfv2NBz0l3QxxuWU2VRcW9DcdZGlF8+TjmrOnpGnVpnGF6Jq1jYOHJa1oPN8SGW9LP9h963vtfOhHDZsvkvE2fUfiuTCsrolY+bf/3J5//c+UoVf3rKu+d0FtR9JNtUcfV7a3DDfcbNg8IF3H0HsuZDJhYdHslttoR5qjj3HuFN3E7La7bH/wL5i8+l6ZTZV+kOnEwv33KSeOsLCgOXWcyVh/8yHD3k36QfqO6turldGCYX2vcvqEPT/7f1j9lY+rTasuraieJU1DiubUMc3xI4bN/foXH5Ra6WaeC5lOGY10Nx9iaUVz9AnNuVM0DaW4AnTN2sbBw6KVNJ5PibKzzdDbfdt7bf/ZHzNsXic72ww9icuqIgyre0Ss/rt/afVjPy1DVdf3qtWzJqhtK7Op9sgjyvYF/Y23GvYdkL5jGEhcbmU6U5eWzG65jSaao4/or7vRzgd/1OTVb5BuJru7tIvKeMfCV+7THH1MXV6R2Uz75KOa8+cM+w4YNvarS0siGKi+WYm6sKQuLdM02iOPWv3YT1v51CdoR+rSsupZ1jSUaE4cVY4+Ydj3Iv2NB6VW+g4hLqsym6kLC7qbD6nLq9qjjytnT9E0lOJ51jVrGwcPi1Y0ni+JsrOjzKZ23/pe2z/wFw2b18nOlvSDxHNiWN0jWPn4/2P1Yz8tw6Cub6i1erbFRc2IfqZ58hFle0v/4oOGzQPSzxgGxOUUZDZVl5b019+o7t1v+qo3mN71GqlV2d2VhNGCTKZGD3zR6MjD6sKi2jbKbGb0+EOaI4+pTVFX12haddRKs8DCEu0CzYgm9FVz9rSF+37Dnn/9f1n4wn+QhQV1aUVVXRalUUs0J45qjz9h2H+d/saDUqv0HeJyCjKbqQsLupsOqkur2qOPK2dP0TSUgup50jVrGwcPi1Y0nhdRdneU2dT4Le+x/UN/ybDxItm+IP3g64IgCIIgCIIgCIIgCIIgCIIgLgp1eUXqYOUXf9bKx35KGXp1fVOt1WUTNCP6TnPkEWX7vP7Fhwwb+6XrZBhEBEEQBEEQBEEQBEEQBEEQBPH7MpsyWtTd+lL9i14ss16ZTRGXtCOmE6Ov/p7R419V21ZKUduWWrXHnjB68H6jJx6V8+eU8VjZ2ZHdsbJ1XnP6tObIwxbu+7zVX/l5y5/+BaMnHjas7mFxSVVdVk1DabQnj2mOPq5/0fX6G2+lDtLNRARBEARBEARBEARBEARBEATx+zKbqQsLupsOqour2icfVc6dpmkojedF1bW+rnruJcp4LJNd47e8x4U//58Z1vfL1gUZBs+VurQiXW/53/+slZ/9p0rfqXv3qcPgObG4zO7Ywuc+SWXnQ/+J7vob2dmSridxuWU2o1Zqlb5HfEPtaRlWltSmlWFQU8RFo0VDO1K2zlv8/K8a/d5vGfZsqst71OUlT8lkpozPK+dPKxfOs7Co37tJotbqOdGODEsxevjL9vzM/27rwzF7+WsZqswmpLjcys62YWnZ5PVvk6638os/ozl5hOUVtWmp1XOtWds4eFi0aDyXEmV3LLs7dt/0fS589CcMew8oF87JMJC4rGolUReXpO8t//LP2fP//pQMvbp3nzoMnlPtiL7TPPGIcuGc/ubbDBv7mM2kVhKXW4ZBavVHlCJD1R55zOih32MYaBrfkDAaqYuL9J3m/Gnl9DHNiSc1J55UzhxTxtuUxrBnTV1Y8LwoRW0a7Ymj2ice0d9wk/7Gg/S9DB2Jy6ZWapXdXSmN/oZbWVrVHH1MOXeatqU0nmNds7Zx8LBo0XiuJMpkVxlvG7/xXbY/+tcNGweU82elVkEQBEEQBEEQBEEQBEEQBEEQBHFRqIvL0veWf+XfWPnZn5KhV/fuU4fB86IdMfSaIw8r58/qb77NsG+/zKYyDIIgCIIgCIIgCIIgCIIgCIIgCIIgCIK4KIVEc/yI0QNfVGZT2tYfFZpWXVhiaZmlZZaWWVpWFxZpGs+7UtS21Z540ujxh3Q33qJ/8UHpOuk7QRAEQRAEQRAEQRAEQRAEQZChyjBIrTKZEPrrbjWsrmuPP66cOyWlVZvGc6hr1jYOHhYtGs+FRJnsyvYFkz/1Lhd+7G+p6/uU82ekIi67GurisvS95V/6OXs+9lPS9+refeoweF61LXXQPvZVzdlT+oN36jf3y6yTOpB4rqUWSqOcPm7hK7+r7G6powVXrVLUdqQ98aT2sQd1Nx3U33hQ+k76nsSzqpKhMgzSD/5/9uAsZrP7Pgzz8/uf8+7fMjPcJA7JEUWKIrVYuyWSipzUaZxYlGwZKdqiDdwmbtBCAXLRi3oMFOhde1EU7UVQIL2wJVuxnRStNkuuHG12IMurIlOkKFJchstQ4jbbt73vOef/Kzm0HAvwIs7MNxZn+DwxVLFciiiGw681HDikPX5Me+Jp2pFsGhdJ36wfOHJUaNHYbxHKaqlsnbb3rh9z5h/9c3XzkHLqWeEFYX+ljCKnU9FXsy9/1uITv0Qd5OYhWasfCk3rBe3jD2lOPmt4za3q5hX0S1ET4aIbjZQzJ0y+dbdy5oQcT7yslSJHY+1Tx7XHvq274UbDq4+IbiWGAeHCSIakDmKoDAO1ikrZ3RMZ+htfpx66QvvYg5qTzzIaydK4CPpm/cCRo0KLxj4r3Uo5c8reO/+WM//1fy/XNpWTz4p0UWQJOZmKYTD78mcsPv6Lcug5cIWs1Q+VpiVC+9iDmhNP6V77OvXgIdGtxFBdXClHI2V7y/hbd2tOPCUnUy97UeR4rH3quNHD39IduVm95gaGleh7F0JmFVnFUBkGahVDigG1itWeOml0N91iWD9k9OiDmpPPMhrJ0thnfbN+4MhRkS0a+yi6TnPmlL13vNfpn/sf5GJDee5pEeFiyBJyOhPDYPblz1h8/Jfk0Kubh8jqh1LTEEX76Lc1zz2ju/k29cAhZbkikwgXzWii7O0a3f915enjTKcuCRFyNNF85zGjh+4zXP86w7VHWO2ImkQ4V5lV1Cr6yjBQqxhSDKiVYRB9KkOvzif6IzcZNg4ZHXtAOfUcozERSPsj+mb9wJGjQovGfuk67dZpe2+73el/+gtyvqk88x1KQ9hfiQg5nYphMPvyb1h8/CNy6NXNQyKrH2pNQ9Noj31b+8xTute9mfWrRLdLRdh/idFY7G0bfevr2qcel5OZS0YJOZ1pvvOo9uH7DEder3/1YWVvRa1EeMmyilpFXxkGahVDigG1ytqLrGKoRIi2oW0Mh280HLpKe+x+zYln5XhMhP0RfbN+4MhRoUVjP3Sd2NnSvfV2p3/u5+XapuaZ71KKiyKKnMyUrjf78mcsPvEROfTq5iGR1ctC29K22kfuN3rqu7qb3ywPXKWslmRF2HejsVgujR/4htGTj6rjiYhwyYiQ04Xm+DHtg/cYbnqzes1rxGqXrAg/qKhJrWKoDAO1iiFFRa2y9qJWMWAYKKnOJiJC1NRf/1rDoWu0D9+nPfmcHE+IcOFF36wfOHJUaNG4wKLrtFtndG99j1P/zS/ItU3lqeOiNAKBQCAQCAQCgUAgEAgEAoFAIBAIBCJTCDmbk4PZlz5t/slfog7q5iGR1ctKaWlH2kfu0zz5mO62t6ubh8RqWyQhBAKBQCAQCAQCgUAgEAgEAoFAIBCe14xFvzI69k3NYw/L8VhEuKREyPma5vgj2m/frbvlR9SrbqDbVmoKIRAIBAKB8KLIlDmIoTIM1CqGFBVDlbUXtYqBGAZlNSi1kYupHLdi1Ymkv+G1+iteZfzgvZqTz8rJlAgXVvTN+oEjR5MWjQuo9J2yddrqrbc7/U9+numm8uxxEY2LIYOczcXQm33xU+af/Ai1qpuHqNXLUTStHE+0j3xLc/xR3RvfZTi4KXb3RE37KceNHAajBx/SPv6ALA0RLj3BYkPzxCPG3/r3ulvfYnjVq8VyKWr6qwQyBzFUhoFaxZCiYqiy9qJWMRDDwFCplUIuZnI8EjVF34sh9a+5SX/lq40fuFt78jnDZOZCCtE36weOHEWLxgUSQy+2T1u96V3O/JOjcn5Qefa4KI2LIYOczRmq2Rc/Zf6pj5Cpbh6iVi9n0TTqZGb0yH2axx/Wv/lOuXmF2Nkiwn7JpiGr9vgxo2P3kUlpXLLWN7WPP2R0/9f1r3+7etURsbdDViL8RaImNRl6soohRcVQZe3FUEUlhoGhOmuoRMjFTE5GoiZB1EEMVX/kJsMVrzb+5tc0W6fU6dyFEqJv1g8cOYoWjfMVIWpVtk/rb7zNmZ87ql5xlebp4zSNiyGlXCyoafaFT5h/+qNkyo1D1OpSEE2jTmdGD31T89iDVm97r9w8JHa2iLAfIhsyNE8/bvTgPQwdTetSlpsHjY4/anTf13S3vUW94lqx2iOTCH9e1JS1ij5FVjFUUTFUaipDippiGBiqs2ovuk5Eq67P5GQkavqe6AcxDPojN6mLK03u/ipDx2RCOm8h+mb9wJGjaNE4T5Eplru6Q1fZ/tmf19/4WqMnn6QUF0WmXKyRafb5/9f80x8lqRsHqdWlJEqjzhZGD92jPfaA1TveJ9cOiN0thAuuBE3RPPNdzbfvEcsd2rFLWqa6cUD72ING939d94a3qVdeK5Z7ZCK8IGrKrKJPsmcYRMVQqSmGgVrFMDBUL4iuKqsq+oGmUTfmcjwSQ/rzYhhErVa3vI6+Gn/9K+p0RhTnK0TfrG1cdxSt0DhPpVuSafenftby9h/TPvmkSETYT5FJprq+IbOa/da/sfj0r3hB3ThArS49KUpRF+vGD/yJ5t6v6W55o9w4KIbBhZc0RTl1wvj+u7Xbp+R47JKXVW4e1D72kNH9X9fd9jb1qmvFcg8pKplV9J7XMwyiYqjUFMNArWIYGKpUxZBKX2UOoibjkeHAGqNW1PR9khgGguG1t2kfe8j42/fI9QNI5yVrX1wIQfQdy6W9d/y45ft+SvPscwy9F0RNUVPUFDVFTVFT1BQ1RU1RU9QUNUVNUVPUFDVFTVFT1BQ1RU1RU9QUNWWmXGyIbjD/7K9bfPpfeUHdOECtLlWZKZpWP5tqHr1HefaEMBOVqClqipqipqgpaoqaoqaoKWqKmqKmqClqipqipqgpaoqaoqaoKSPU+USdTgw5uFxkrYbDR7THHrD5fxzVHH9Y3byCKGJIpfe8jn4QFUOlphgGahX9wFC9oOkoy0HWXlRiIAsKUauoKWqKmqKmyBS1KjtLOV7Y+eDPGq64Wt06ISKcr+JCqJW+0115jb33fZAoYmdbRGO/ZVa52KRW08/9mvlv/hoR6sYBanVJK0U+84ScLpz+hX+pf8s72XmGrC64mkptRJmLGClDupxkrYbDRzTHH7bxL/5HzfGH1M0r1CZVS/pBVAyVmmIYqFX0A7XKqAxVDlUavCD1ajOIdizKiJr+YiH6qjlzSvf6N9j9Oz9jdPqUC6E4XxFK14khde/+B4abXq+c+K6IYt9lyrWD1N7sNz9m/rl/TYS6tkmtLmlRtM89oxkvnPnn/6vuR96heeZpIeynnIzlYu5ylLUaXn2D5rEHrf+f/5PRt++Ts02RI1HRV2qKYaBW0Q/UKgaaZVE6olZRKR3NMjUdOW7VNqj+coGsyvae1e0/rr/xVs3J50SE81GcrzrIrFbXXm/1lneL2ouh2m+ZVV0/IFYr80/9stnn/m8i1LUNsrqUBXLrhNVi4eSH/2fDre8weuIJstpXUeRorI5aVXU5ykz1msPaR79t8dH/Rfvot8RsHQ2ZYhioVfQDtYqBjCpjoA5SdVat9AOFOmmIEJn+SrUqu0v9NddavvM/YvuMzHQ+ivMUfacGw5verV57g3LqORI1qUlNalKTmtSkJjWpSU1qUpOa1KQmNalJTWpSk5rUlFnl+kH6lennPmby25+khLpYJ9MlLZNupcw37fwXP697+49qnjlOrc6qSU1qUpOa1KQmNalJTWpSk5rUpCY1qUlNalKTmtSkJnVAyNGUpiHT5ShRr361ePJhi1/53zQPf5P5nCjUKvqBWp2VxKrSddIgKtFV+oFMdTqW04moSU1qUpOa1KQmNalJTeqg7C2t3nan/vqb5PZp56P4nkQikUgkEolEIpFIJGqK2UH9DW+hmYi+2i8ZSU0Wh8TensWnftnsi58Umep8nZokEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIoqayXOqO3KZ/599Sts4gKeFiyNGM+RVKM5aZJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQiSUVsXim+e8zs//kXRg9+S0zWRDTUKnr0HUMnavWCqERXqVXUQWSqs5kcj0Rf/UBqVXb2DK+6UXfz27SnTyJIJBKJRCKRSCQSiURSnI+hVyP0r73FcMMNyumTMuybGMiNQyx3zX/jl01+51NklbMFmS4HGaGOx0ZPPqK599/LyVydrxsOXWW44mrDFVfL9SvVxYJ2QjumFBfEQGjkdEqEUqvLVqYUrB8S3zlm8hv/l3LsHjmZiBiJSukbMaRURSW6Sq3UpOvVtqgbM5oiavpBRSZNsXr92/WzmRwG56p1VjonQ0fT6g+/Tt08qDl1krQ/aqoHDrG3a/7ZXzH5ymfJlLO5lC4bgdFYbJ2w9q//d/3vvV7OF+rioNxYY3yFYX1Drm8wn8t2LKcLOZnIEl5QumToRD8w9NSOHET1l0uyLbJbipPfUVe7jCdIl7UI1g6I7zxi9psfsfrx/1J91U2y6+g7pKhEV6mVmmLoRaRcLJguxBAk4QdUq7K9rd54i3rNjcZPPW7Y2HQuWuchkpwuDNccphmTaV/UVA8cYm/H/DO/YvK7v0kOcjaXLj/peeOJcuppoz98XEmGEjSFdirmG3Kxps7X1NEaawv1wFXqxgaTg4a1TXV9wXTBeConU8pYbRuaEH0y9GLoRd/LrHIyZTw1vuePjL99j1JaNcIrnlcKi03x3WPGX/iY7r3/qfrqm+iT1ZKhUis1xdCLbiVHrf7QQp02Sjd4STJFvzJcebU8fJP6+Lew6Vy0zlUmpagHrzYcukYsd11wNUVlOHiI3R3zz3zU5Kufo/ZyOpMuX+l5zYhJkZnCi7L24sxzyulnyWpUUQdDU2gK7USdzFhssLahTtaZL+R8w3DwoFysq9MNdbbBbMZswXgqts5o7vuSyZc/oZx8Ws7XvOLPKYX5uuY7j4rf+TdWt/+0+qqb6Qe6PWqKoRd1YKjq5lSurYkhqEl4aYbKqDW86hptpnPVOld1UCPkoatYOyCWS3+mJiWoSQlqUoKalKAmJahJCWpSwvepSTIcPCT2dsw+81Hjr36O2svpTAqXvQiaVvoPApkpM4WUmWQrMr0gh06zvRJbp+R3U1vJSCmNmkaOxnI8Y7qQ04VcHGA8Z/uEcvxBZfu0nM1lKWR6xZ9TGnW2UJ46Zvy7H7d6113ymptFt6LbJdEvZdvKAwfkeCKGgfDSRYgu9Fe+xryd6GsVpXipWueqDjSNunmlGM1kv6SmsxI1SdQkUZNETRI1SdQkUdOfFzUNBw6wt232mV82/urnRO3lZCaFV/wVIojwgvT9wvMyZSaSTDJFJpli1bFaKWdOEYVMahLUEownMgqZXvEXaBp1OueZx4z+8Df0b/0Jw5VHlCj0S4aUBzbUA5sIanVOImUu1YNXGNY2lK6Tk4mXqjhHUVMIOVuT44moSSK9KL0ovSi9KL0ovSi9KJFIoqa62BBbW+af/qjxVz8n6iAnMxnhFecpglIojWxa2hGjMaMJozHtWI7GsmlkU2RbZNvSjiiNV/w1mobJVDz1iPL131KePiabViyTdqq/+pA6b0Xfk0gkEolEIpFIJBKJRKbSJ7M15uvK0DsXrXOUQZZWthMUMl0IkSlHIyKMf+/z2j/8twydOlt4xUUSIT0vAsUrXrosDeOp8vQx+djXZTsXzUx/1QG5uWCoZDpXUVMOgxhN5WhsyMG5aD0vnYNMGUE7cVY6b5EpS9COjR4+ZnzP79OtDOOJ8IpXvHyk57UjuqV47ri48oT+hmsMVx+itKIfnI8MZJWlkWWE9FIF2swBxUuW6QVZiu+JTOcjBe1Ic/KM0UNPiK1ttWlFBJle8YqXi0BGiEyWu4Zpq3/VlXI2E32lJuE8hPSijBCel+mlyEwlM8l0QSQSiUQikUgkEolEIpFETUYtyz3lsSeIVl1sijqIWr3iFS87mXRLZpv6616jHtwkk1qdlUgkEolEIpFIJBKJRPozUVPk4FykVJyPrGJYSb3zlREyaL77tDj5LPOpev2bmK7TLUVWr3jFy0nsnGb9oO4tdxquP4IqhuqC6pZ0K+eqOFcRog5ib1v0A0lkikyRKTJFpsgUmSJTZIpMkSkyRabIFJlyPNKcPGP0xLNKJeuKV92s3nqnnK7J1Z7I6hV/vYyQdWC1x2pPDr3MSqZXXCQ7p5nMde+5S/+298nRRCxXoqbIFJkiU2SKTJEpMkWmyBSZIlNkikyRKTJFpsgkiWjk7pbc21ZK61y0zlWErFWcOSX6TmjI6lxkW8jUPPUsy45xS/ayTLj5PSqae78sl9tiMpPRIL3i+0WEWqtmZ0u2rZzOGXo5DGK1q/SDzCQQRZZCKSIa2TREIcIrztPOaSYz3e136d/9k+piTSx3RE1npfMWQW3H2lOnxO6WHE2ci9a5Ko1Sqzj1rNjbZbJg6JyLHLXKs6c0T5+kLbItlEYOKzldKLfcoUrl3t+Wy20xmcsoSK/4D7KmZmdLvfpa/S3vVA9dTbeS26fEzo66d4blltg+I5Z7dB1Dx9DTd9RB1IFMoshSKEVEQ2lkKUR4xV9h5zSTme49H9C/5y51bVMst0StCBdSlqI8d1zsbcvpwrlonavSUAflxFPi1Cn1uoNib8dLlSUYUvv0c6w6ZiOaIkuhFNkt1dlC3va3ZGk193xZ7p0Wk5mMBukVZITYPqleddjuB/+x4brbhCJzEN1AP+hyT3R7ytYZsbfDzpbY3WF3S+ycEbunxN4ZsbsjVku6FX0n+k4OHd0g6kAmEbIUSqG0tCOXvZ3TjGe693xAd/tdLDbF3jZZES60qKl57jEx9DLCuWj9mfSSBJmV088oJ75juOFmMr1UORopJ7fE6ZOMi2wLUbwgIwiy25PThbztx9Bo7vmC3DstJjMZBelyV/peYnXnT+nf+F6xu8feriiF6UQItTkgg7wyUakDXaX2dD11T/S7YmdX2d1mb0tsb4udLbZPid3TYnlG7O6I5ZJ+RbcS/ZK+ox15Ubp8hETsnGY81d3+Ad3t75eLDbG3Te0JF1jIaJStU5rvPC5HE6Rz0TorEc5F7G0r331MdCsZIWr6gQVKKM+dZNXJ0ZhoZBSiIIjwgux2mK4b3vQ+gubuz7N3mumcKEiXs9jbVq+6Xv+G25XtbbGzjfSizguKPxWIkNEQwXjCZE5zQI0QmWpWWQfRD2LoZd/RLcWwK3Z3lJ0dlttiZ0c58aTmW38gTp9gPHF5SbFzhvFUd/sHdHe8X87Xxd42dXBWurBKyMlM+9C9ypOPyNnCuWqdj6YVQ1Uef0Ccepb5Oru7hB9INkXZ2VNOn6G0tK0sjRdkCQKlEEEUul05W9f/yN+WbWr+5PPK9hk5nRMF6XKV3VIuDsjJhG4X6S+VyBR6Z/Wd7wnPC0QQhShyNGY6J4raFDLVWqmDLEXsbZnUwegrn5KjMREuGztnGE10t39Ad+cH5GxN7O1Qq/0TctQqD9+jnHhaf8U1wrkpzkdpUZXjDyjHH2G8JjL9wEqrnNwRe0vaRkbjrAgEEc4qRUQhilztyNlc/46/q3/b35OzTbG3I7IiXJYSTSv2dsTOLtEQ4ZwlaophEH0nVkuxuy12zihnTilbp8XutljuUULON9TZuheky8jOGdqx7vYP6O78oJytid0darVfQsi2KKdPah/6GqWIKM5J0vqedI5COXNC+9CfWL3uHbQThhXhrxRJJrG9Ta2UERFEyKYQQSmUQimUIktQGrHak4t1w1t/QkSj+eP/T2yfEpO5jIJ02Wknyt5psX1GzhZkZ98kkSlHY7EatA/crf3m78t2LATp0hbY3aId6e74oP7OD8npTNnZIasM+yLS84qczI3u/oryyD2GtU0ynavifDUjhOaBP1aO3y9nG6KmSCKJJJJIIokkkixEt2K5R1NkabwgSzirFCJoGiJkCSJEKUSI3W05m+re9R/r3/n35XxDLndEVoTLTtPKnS25e4oSApFEEkkkkUQSSSSRRBJJJJFEEkkkkUQSSSSRRE2RKdsR0Rg98A3jL/wr5fiDcjJ3yQvsblEa/e0f1L3vZ+RkoezsUAcviCSSSCKJJJJIIokkkkgiiSSSSCKJJJJIIokk0lnZFGV3T/v1L7BzhvHU+SjOVyk0RXnmCaNv/C51kKMJNckkk0wyySSTTFmKsrtSVivGYyKIIIIIZ0U4K8JZEQjfE7s7jGf6d/2E/kffL+cbcrlNDgiXk6EUVrtiZ4vRyFmZZJJJJplkkkkmmWSSSSaZZJJJJplkkkkmmc5qRjSt5ti9Rp//FeXRu5ktRCkuaYHdLaLo7/ig7n3/iRxPxd4ZcnBWJplkkkkmmWSSSSaZZJJJJplkkkkmmWSSSSaZZBJFjieab/+x9r4/lusHna/iQmhGAu09v6s5dg+LTQLpLxGyCfaWYqgyChGyKURQCqXQNJQiS1CKKC2lECHbQilib09O1/Tv/kn9j75fztbZ2yYHhMtFRGHoNbtbZGPfNI0MyiN3a770MfHYPXJxkHZMpktWYHcbob/jp3Q/9p/RTpWtbWq1/0K2Y7F9RvvVz7B9iumCTOejeF46T1FkO5Injmv+6LPK1paczsn0F4lEou+cFSGbQgRNQyk0DRGyBBGiNETIErJpiEIEEWJvS06m+nf/pP7dH5Czdfa2ycFlI0IMPd0O0r5pxmL7pOYPP6N88w/U+SajCZkuaXvbZNXf8VNWf+c/pxmzexqVsL+SbMc0jeZrn9c88Edy/aDI6nw1axuHj4po0TgfpXhBPP048031xjfTd6IOCN8niKCc2hLLPTkaEUHTEEHbEkEEEZQioiFCNkkTIgqlyKYQRNcxnavXvpZolCcfYneLdkQE0iUtsH1aXvdm9eY3i9WSTBdeIZO9M8pzT2n2tmXTEAXpUhOet7dDHfTv/ZDV3/1HIkbsnCYqwr7KpLRyOtUcu9fks7+orJZyvk6m85N9s7Zx+KiIFo3zFKUR3VL71KPq1TfIV71GrDrq4PtEiCROnRH9SpaGUiiFCEqhFFmCUkRpiSBCREMUSpGlEEEg0a/kdC5ffROlUb7zELtbtCOiuOTtnpbX32S4+Z2iW5HVBTcMcrqQ179RzjaUx+8XO6dpR0RxKQnPW+4wdPr3fsjq7/1XIht2T6Had4nSMJmJk98x/vS/VJ54gANXkukC6Ju1jcNHRbRonK8olEaceVbz3UfVa98gr3iVWC6RhD8VCHFmS3SdbFralgiahgjZFCJE0xKFCNk2NIVSKIUShBcFkuhWTOfqq2+mtMqT32Zvm3ZEFJeysrcjrz4sb34PejLthxg6SiMP36zON7VPPMD2KdoRUVwKArncFd1S/96fsfr7/1hkEVsniSTsr0QpTObsnNR+8WPKN74i168QpbhA+mZt4/BRES0aF0IEzYinH1OeO264+c3MD4quEzWF5wWhiK0thsqoJYK2JYIIIihFREMUSqEpBEqhFIFIIokkEJ7Xr5jM1MM307TKEw+wt007IsKlKna35RXXqre8xwuiVpFEEkkkkUQSSSSRRBJJJJFEEkkkkUQSSSSBEAydKI289mZ1sal9/D52TtGOiOLlLJDLXbHcNdz5M1bv/6fK3iB2TxEEIokkkkgiiSSSSCKJJJJIIokkkkgiiSSSSCKJJJJIlCKnM7GzZfz5X9X+/m+K+QajCZkukL5Z2zh8VESLxgWSpWE0Vp58UPPME4bXvVXMDtCtUCkhoojtbdH1NA2lUAolZGmIIpqWKJRCCSIohVKI8JcJRL9iPFUPv45mpHn8Wyx3GE1cqqJfMds03HoHbUum/RKCvhNCXvc6dX5A++g3le1TcjQhipejTHR7YrVruPNDVv/gv1WWK3ZPE+FiyAgmc7G3rf3Sr2u/+gk5WzBZkNUF1DdrG4ePEi0aF0ggS0M7Vp64X/P044ab3sbiAKtdkShF7O5SB0qhbYmgaQhKjIigaYiQTVCKLEVE+OulWK0YjdXrbqEZax79JstdRhPSJSezKu1Id+u7mW2Svf0UQvSdSPLa1xnWD2kevUfZOinHE4SXk0Ss9sRqx3DHT1u9/8NitWTnBE3joogQ47nY2dJ++deNfu+TcjpnukatLrC+Wds4fJRo0biAAtk0jCaax+9TnnnccMs7WBxitUsJsbtL1zEeoxCUbCloChFEIYISlEIJP7Aguk40I3n4VjmaaI7dw2qX8cSlptYkq/62d8mDV9D3SPsqiKFHcvgWw8YV2mPfULZPyfHMy0UiVntitWO4/aet7vqwWC7ZOSGbxn6LRCmM5+xsaX7714x+9+NyOme6Rq32Qd+sbRw+SrRoXGCBbBrGM82j9yrPPGq49d3MN+lXrJai62gapTZyVNSGaFoiKA0RsglKIYpAIBAIBAKBQCAQXhRDR9vK626V44nmkT9htcd46lLSZjV0K8NNb1cO3iCGlcgUCAQCgUAgEAgEAoFAIBAIBAKBQCC8qAwDWeV1t6mHXq158GvKzik5mflhl4jVnljtGG7/aau7PiyWS7afo2kEAoFAIBAIBAKBQCAQCAQCgUAgEAgEIgqTObtbmt/+VeOvfJzpnNk6tdonfbO2cfgoWjT2QUhKkdOF5tg9ylOPGG69Xa4fVJZ7rJaUoo4KERqtLEEgimgaSkMpAoFAIBAIBAKBQCAQXhRDR2nk9W+U46l48GuiX4rxBOlSUFFWu/Lmd6qHb1a6lcgUCAQCgUAgEAgEAoFAIBAIBAKBQCAQXhR1EEOvXner4YrD2vv/QNk+zWSG9ENrtSeW2+odP2111z8TyyXbz4nSCAQCgUAgEAgEAoFAIBAIBAKBQCAQCEQpcrpgd1vzpV81+uon5HxNTNfIah/1zdrG4aNo0dhPpcjZuubhu5XHH1Bvu4PFQXHmFIFSNDFCyIKmIYJSKEWE8zf0lCJveBPTheaBP5b9SoynLhXN3q687q3qDbeIfkWmiymHXhk6ef2thquu1973VbF7Rk4XSD9scrUnltvqHT9jddc/E8sl28+K0roYUjBdY3dL+8WPGf3eJ+VsISYLmdU+65u1jcNH0aKx30qRi03No/cojz9gePN7lfGC1Z6mjBBqg6YhQjZBCRdS9B0l5JE3y9lCc/8fyL4T4xnSy1lEiJ3T6o0/or7mDXRLsrro6iC6pbzhDYarX6O9998pWyfkfJ1MPzRWe8pqV73jQ1Z3fVgsl2w/SzQuigjmG+xua7/4K0Zf/YSYzpmuyawugr5Z2zh8FC0aF0OEXGxqHr1HeeqYesuPakbr6rArmyCCKLItIgoRLrToeiHVG98iZ2va+74qh16MZ0gvZ3X3tHr9zepr3yb6jkx/E2KoYrkrj7zJ8KrXau77inL6ObnYJNPftFztiuWOeseHrO76sFgu2X6WaOy3SCKCxSa7W9ovfNTo9z7JdCFn6zKri6Rv1jYOH0WLxsUSIRebmof/RHz3EfXmHxWLK0S3kk0hQpSGCIFAIBAIBAKBQCAQCAQCgUAgEF4UfUdW9aa3yfmG9t5/J+sgJnMyvVw1ezvy6mvV179HDIOoVSAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCIQ/lVXZ2ea6NxoO36rc82Xl9HMsNsj0NyWXu2K1rd75D63u+rBYLtl+VmgEAoFAIBAIBAKBQCAQCAQCgUAgEAiUTCLk+kG5u2X0bz+i/YPfkPN1pmsyq4uob9Y2Dh9Fi8bFFCEXm5pH7+WZR9XXv1NuHqLbE1Eoxb6KEH1H7Q03vV2uHdB+43dkHcRkTqa/ERHUQexsKVsnxO6W2N0Su1tiuUOEbBpRir9I7G3Lqw6rN7+HrGT6m5Wy2xbX3mq47g3KPV9SzpyQi00yXWy53BGrXfXOf2j1k/+dWC7FmedEaey3yJRCrh+Uu6eNfusXtX/0WTlbE5O5zOoi65u1jcNH0aJx0YWcb2ieuE88dUy+9q3y4NV0q/+/PXgN9vuu78T+ev9+v///f266HUm2Zck3jM01kIQkXJI0CUm23Z3pTrPpdLaddqZ90D5oH/RZO5o+6dOdfdx2tp2ddqFZAjSbbJrdTmETQgBj7jcbsA02+CbJknWxpCMdnf/v+6l0DCykkIBBtqzzf71QJK6rROZz2bqi7nyrtmfd8NDHVBtltkKVl0eUyOYl3QvPU2U8eIe6503avW8y3vUmddudatd+NR/1p4/J5Q1tukQ3iPJdmV9RK+vc83a6CZrvSiu6TjKRKtviuuvGJpsXOPx64x1v0n31o7rzZ9Tqbqq8bDY3dPMt46/+vq1/77+UK1ty/jR973pLlRJW93LhnMmf/x+Gz39ILa3IbFlVeQXM+7Xdh48qA3qviGjLq7pnH5Xj39Re8wtqzwHZ2pTWpEiRIkWKFClSpEiRIkWKFClSpEiRIkWKFClStqUa5uqOt2p71g0PfUy2Nlleo5XrKpFxi4tn1DDV3vibxnf9R8Zf/T3tze82vv5d2uverr3mV7T736nu/xXtyH2Mm/pnH9dtbWpLq1Llmppv6Wcz4+t+RVtb0s2bVEmjhjBZYTJlmDJuydgEKVKkSJEiRYoUKVKkSJEiRYoUKVKkSJEiRcqLqtTWC3L7G4xH3qD72sd158+wtEa57uryBWlz46/+A/Pf+S90m1fk4jlJJ0WKFClSpEiRIkWKFClSpEiRIkWKFClSpEiRIkUlrO7jwhnDR/6ZyRc+LNMZsxVV5RUR835t9+GjpQb0XiFJp2Yrcuwx3cmntbverPYcZGtTqiGut4yNtqXufKu2Z52HP6rb2tKWVqhyXSRsbnDpvLrj58x/97/SfvU/4LZ7GXrGTZlvyZVNGeeu6Wbr6o43m7/pHWr9Np7+OmePy/JupXRt1MR4/y/LroMyzlUbmXTsvk2+9lHDA3+k9tyi9h+mzaWNJK63NFw6x5E3GA/dr3v0k7rzZ7SlFddLUJcvCMZf/Qfm7/7PZGvk0nlJXHeFYHUfF0/r/+I9Jl/6czWZaUsrqsorJcm8X9t9+CgG9F5BSadmK3LsMd2Jb2l3vkntPcjWlrSGuN7SRplfUXf9PHv38/BH1XxLZqsoP1MJmxvMt3jzb5n/3f9au/sNuo2L6soFGefSSlpJK2klrVFb6spFSafu+gXu/nndk1/m+adY3q1VU21Ud/+ybu9hxi36sOc23dc+qf/z/1336Kd1zx9Th+5V+w/RRhlHxPUWV10+z5E3GA/fr/vmZ9WF52W24mctqMsXJDG+6/fMf+M/kXlx6byIl0Wo1XUunNZ/5D36L/+FNkzUbBXllZRk3q/tPnwUA3qvsHS9mi7J8cd1J5/k0OvV3ltkPqeNJK671qRdUXf9PHv26776cTVekdmKn5mEzQ3GufbW3za++z9n1wG5cJY2F3+zIG1k65LxtiO85pfksc/wwgmZreo2L2uvfae67Qg1Z8+t8sjnTf71/yRnnlEre+T5p3Unn1K33iN7DtFGakRcbylsXuD2+423vcbw+Bd54QTTFRI/C0FdPi9db3zX75n/+j+UhksXRFx3hVBr61w4JR95j+6hv6SbMFtxI0gy79d2Hz6KAb0bQNIzWZITT8jzT3PbfWrfrdRcxhFx3bUm45a65xfYvdfwyKe1rU2ZLfupJWxeZBzVW39b+43/lNV1Lp2jNT+2ohsbW5dl351q722Grz+gq6bb3FBHXmf+xrexa13/0Mf1H/pf5PQzamlNhqkapnLqSd2pZ7Rb7mTf7bSRNiKut1Rx5aIcvNd46B7Dtx/SvfC8mi6Rzk8jqMsXGKba2/++8Z3/oaTn8kURysuidq1z/qT+I+/VP/xRukFmy24USeb92u7DRzGgd4NI1zOZyslvyeln1G33yK5bmW9RcxFBEARBEARBEARBEARBEARBEKRIGxm31F1vZbpL981PyzgynXnJEi5fpI3qLb+t/dp/zNp+2XhBWhMEQRAEQRAEQbworWTrsrrj9Vw8qb75eW15TffCSbYu6r/1Fd3HPyCnn2W2Qj+4Jn2v+ok8/7Tu9LOs38G+w4xzxi0RQRAEQRAEQRAEQRAEQRAEQRAEaSVbm9xyj/GWu/RPPcwLzzFZIp2XIqjLF9Rkyi/9++ptv0c3yOYFXYsUQRAEQRAEQRAEQRAEQRAEQRAEcdXu/Zw/afjIe3QPf4yul+myG0mSeb+2+/BRDOjdQNL1DFOef1JOH+PWu9hzG+OcNkriess40kbt7p9jusa3P6+bX2GY+YklXL5INfXm39be/vus7JVLF9D8VNoo01Vttqx77HN0HZuXDN/8gjzxZTYvyXSJrvf90veqH+T5p+X5p1i/nfUj1Jw2l8R1V022trjlHg7eo559VM6dYDIlvZ9EUJcvqMmMX/x76q1/TzLh0gVpRYVCkLheatd+zp40fOQ98rWP03VMl91oksz7td2Hj2JA7waTrpe+59RTujPPqIN3svcQbU4bJXG9Zb6FUne9mcmqPPEFmV9hMvVjS7h8kSr1xt9Sb/v7rOzl8gY1IiTESzff1Pbdoj/xqDz7TZkui9B1MkxI54dJ19MPnDnG6WfYd4j1O6Q1xjmJ666azLfUwbs4cCfHviHnTjBMSe/HEdTmBkvLvPXfVW/+O/QzLm9Ia1IIqlGF+J7ET62KRO3ez9nnDH/5Xt0jHydhuuxGlGTer+0+fBQD1bvhFF1P13H6Gd3Z4+rgEfYekrFoI4nrKpH5XFLqzjeqybI8+WV1ZUMmMwTlh4ttVzYI7v93+Pm/y8peubQhbSQhrgoJ8dK0UXbfwrkndN/8IpNlhoGuJ/GjFV1P13PmuJx5Ru27Re0/Ig3jnMR1V022ttTBu9h/hBOPy9njDBPSofxwQbG5wWSJN/4ub/gd6aZy6SKtEbSSKqmSKhRVVCgEiZekClG793P2Od1H38MjD5AwXUJQbjSJeb+2+/BRDOjdqLqe9Dz/jO7scfbdzp5DVNHmrrvCOJd06o43qH5JnnpYrmwwTEnnhwtXNlxT9/26vOnvsLRXLm/IOBKCFKqRokL85IpMVzh7Wh77DN0gXefH1vWSyJljujPH1N6Dav8RaZjPietvHGWcq4N3su92OfltOXdC+oGu9yNtbjBZ5vXv5v7flH7G5Q3aKEqKtJJWtrWSKmmkFYoqKhTiJxS1to+zz+n+6r3yyAOSYrrsRpZk3q+s3no0DKR3I+sH0snzz+jOnVAHblf7bpc2Ms4R1924Rddz+30yLPPs12Rzg2FKOsq/lXBlw7Z73iWv+y2W9rB5mRoRKcS2VEmhNRISP7HpMuee1z36SdcknZ9IP5COs8fl7An2HFT7j0gV8y0S11XQRhnn6uBd7D3EqW/LuRPSD3Q95UVBYfMisxVe9xvc92sMMzYv0RqFKhTVqJIiVbZV0ZqIVElrKKqokPhx1Nq6nDup+6v3yqMPSGG6REK5YVXVvF9Zu+0oGZL0bnT9gHDmmLxwkr23svcQVbQ5iest45b0gzp0nwxLHHtENi/ST0lnW8LmRdJx1zu479dZ2s2VTWkj4kUlIuWqokiVFBHbEj+22aqcOqZ79AGFdJ2fWD+QcPaE7uyzrK6zfgfBfIvEdRW0UarUwTvZc6s8/zRnjpHQT0hUa2xelKVV7vs1de876Wdy+RLVpIoq26ooL6qiSkRaSZVtrWhNEmlFUCUV2xI/TK3tk3On5K/eK48+IIXpDHHDq5r3K2uHjiYZkvReDfrBtjPHdOdOsOcWte8whTYS1998Lv2EQ69lWJZT3+bCKdoorbF1SfVTufNXeM07WdrD1hVac018R1xVKClSrirbilRJOhER4kdKhaUVjj0uj/4V/SDpvCT9IAnnnpNzx2VtXe2/k4RxJK6vhHGUNsq+O9h7G+dPcfYYmxvMN5lvsWuf3Psu7nibZEk2N2mNKqokkSppjSqEVlShqEaVFGklVba1kioptJIKmlRsKyLs2ifnTsnH3iuPfkIqTGeIV4ea9ytrh44mGZL0Xi36gcKZY7oXTrLnFrXvdqoY56ITEREREREREREREREREREREREREREREZHCfIthKgfuZW0/mxdlvslkyq51OfI2Dv8i0zW25rRGvKhKqsRVhXJVEVK+o6iiUFEhQkhFRERERLVSu9Z13/gE3/isTGak85L1A8K55+TcCVlbV/vvRDHfEp2IiIiIiIiIiIiIiIiIiIiIiIiIiIiIiAjzLSlq3yF18LBkSdoos2VZv0fu+mVufROW2LxCKz+giirXBKmS1qiyrRVVKKoQqZJW0pptrVFNXNVKWhNRu9Z54ZR87L3y9U+Iq6ZLiFePmvcra4eOJhmS9F5N+sG2s8d1559j90G1fjtVjFtUKBQKhUKhUCgUCoVCoVAoFAqFQvmOYj6XoVcHj8j6PTJZl6VbueV1rN9LvyTzubQmVSgKVbZVie8IylUlRVzVyrZqgooXFQqFQpGuYzLRfeHPeO7bMl0i8VPpB4Rzz8nZ47K6Tx2407b5FhUKhUKhUCgUCoVCoVAoFAqFQqFQKC9qczS1ez+3vEb23yO7j7D7LlZuJROZz6XKttYQWlGNhCpao8o1qZIqqryoqEaVbVW0kpAqac221mxb3cP5U/KJ98nXPy6umi4jXl1q3q+sHTqaZEjSe7XpB9vOHJcXTrLrIPsPU0Wbe1m0LbpO7Tooe25lsosWmRetUUU1qZLyg4IqqRJXVXlRUaTKi4oqUaITV8X3abqVgzz3hDz4AVqTfiDxU+sHhHPP6c4dY3VdHbjTtvEK4rpro1Rjtqx2H2Btv3RT2bgsly/RmuoiRaqkNapIqKKa76miiipBkNakNS8qqhEUWiGipEqW9qjzp+WT/1wefUASpstenWrer6wdOppkSPRejboexdljvHCS3QfZf5gq2hxxfYXWMDKbqeVlNDYus3WZ1hBCEKSKKtuqbKuSxLagiioRCVqR2FYlQiJIP2F5j3zqg/KNT8nyGomfma4nOHdSd+4Yq+vqwJ22jVuI6ytU0eYomQxqtsR0QpVszWXrClXEtiBV0hrlqtCKarZV2VZlW5UgrZHYVo1qJLSS5b3q4ln51PvlsU9IOqZLCMqr0LxfWTt0NDEk6b1adb1rcvY4L5xk90H2H6aKcS4iCIIgCIIgCIIgCIIgCIIgCIIgrWhNTSZqdU2mM6lRrsyZX6E1dJK4JlVUkdgW25JIFVVeVBSphqCock2U6nr27OfJz8hH3ytVTKZ+5rqehHMn5eyzrO2T/XdJQ9sSEQRBEARBEARBEARBEARBEARBkCKtKGoyYWVFra4ymVBFa4yjzOe0kdiWKmmNKoJCFdX8/1QJ0pq0Jq1Ja7K8W9u8yGf/SL7xcel6pkte5eb9ytqho0kGSe/VrOtdk7PHeeEkuw7I3tt1DW1O4rorUk36npUVtbaL6Uw02ZrLvNEKRYhIFVW2VdlWJYlU0YqgShCkFdUosraf00/r/vyfqFNPy8pu15TroOtJ5IWTnHlWVtdl/U4RxjmJl0taQ5hMWF5Wq2ssLUnXUWiN1mQ+Zz6nja6JSGtU+Z7WaI0qWmMcGUeqSNhzi5pf5HN/JI99jK6T6bJryqtXMe9X1g4dTTJIeq92XS+uOntczp6QtQPsPSJVjFuIl0PGJq6aTFldZmWXms7oOqlinDMfaY1xRNGK8qIqElqThEJrtLKtNUknK3u4eEb+8p/qHv8Cq3tI57rqekl44SRnnmFtH+t3SWHcQrxc0ppUQ5hMWFpidZXVVZZmDANdJ4nvSmu0RjWqGEcKrVFFkE5NJsxmrB+iG9VnPyhf/yhdJ9Nl5aYwH9xkapgK6pmv8qkPkHD456SK+WXSeVm0Jq3RdWp5maUZe/eqS5fl4kUuXWKc04pq0kbXVBUJVSSuSRV9r5Rtw4S1dTbO8OB75bEHZHk33aCU6636iaBOfJMH349w9y9JFfNN4uVTpBqtkahhYDJhZZlxZBzVlS02N2W+pc23pIpCNRL6AVHTCcPAZKKmE7Vrn1y+zAPvk4c/Qt/LZFm5SRSD7yo3jRqmgnr26zz4ft6OIz9n2/wK8fJpTVqj69RsiaVltXsXW3OZz9m6wpUtxjlVVKmEriOh72WYqL6j79UwUWu7dS+cVZ96n3z1o8xW1TBVVV4u1U9kGnXicT75Pqq451ckUVuXiZdflYyjbYkaJmq6xFKjmmqN1qiiimoIXadc1XWSqL5naQ9XzvPAe+VL/y/DTKbLqlBuGoObUVH9VFDPfI1Pvo934fBbRNT8Eum8rFqT1gjVdSwtKVdVozXVGlVU+Z4gHeKa6ntmq2ycVp/8A3n4z5mtyHRZVXlZFdUNMl1WJx7ngX9O16u73iZFzTdI5xVTJePIOLqmutB19L3yI7SmhMmqXDjHJ/9P+dK/ZrIss2VVbjr9ytqho0kG0rvZdL0knD3O2ePsvZV9t9OKNifxSkiVtCatSSvb0tF1dB1dR9fRdSRSSCeTFc6fkgf+UB76MLMVma6oKq+YdNL3vHCS00+x+wDrd1JF2yJxI0iRKmklraSVtJJW0krGEmS6Jpc31IN/IF/8M6bLMltV5WY071fWDh2NDJLezajrpQtnj3HmWfbeyr4jtMY4dyNIkSqpkiqpkiqpkirSM1tW55/nwffJw/+G2YpMV1SVV1w66XvOneDkt9l7kP130Rrj3KtBdMzWuLKhHvxD+cKfMl2R2aqqcpOa9ytrh45GBvRuVuklHWePc/ZZ9h6SvXdQI20UEQRBEARBEARBEARBEARBEARBEARBEARBEARBEATpeqbL6sLzfOp9uoc+zGxVZiuqNTeMdNJPeOEEp77F3ttk/W6q0eYigiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiDp1GyFzUvq0++XL/xLpisyW1WtuXnVvF9ZO3Q0MqB3M+t66TvOHuP0M7L3sOw9TI3SGnFjKXS9mi6pi6f59Pt1X/mQmq3JbEW15oaTToYJ557jucdlzyHZfzc1l7ERN6CO2TJXLqlPf0A+98fMVmW2qlpzk5v3K2uHjkYG9G526aUf5OyznP4W+47I+h20UbW5iBtG16vJkto4zaffLw99mOmqzFZUa25Y6WSYcu6EnHyMPYdl/920xjhH3DDSMV1WW5fUZz4on/tjJkuytEu1ZgeY9ytrh45GBvR2gnTSD5w9xvPfYv1O1o9QWzKOiFdc16vpkto4zWc+IA99mMmKzFZUa254iUyX1LnjcuIR9t3JgTsZR1VzqXjFJcxW1NYl9ZkPyuf+BZOZLO9Rrdkh5v3K2qGjkQG9naLrZZioM8/KqcdZv0v23k5Dm3vlhH5gsqQ2TvHZD8pXPsRkRWYrqjWvHpHpsjp3Qo59lX13qoN3qDQZ55RXTj+o2ZLavMhn/4V87o8ZZrK8R7VmB5n3K2uHjkYG9HaSdDKZqjPPyolH1N7buOVuaUU1lJdXGKZMptq5p/jUB+Srf8FkRWYrqjWvPpHZijp3XI49xJ5b5eC94qrWUF5eoZ8xWeLiaT7zfvninzFZluXdqjU7zLxfWTt0NDKgt9Okk+ky507Ik19SS6vceo9kQqHK9Re6gckSiTr2kHzyPbrHHmS2JrMV1ZpXsyytcf6UPP4ZNZ1y233STVFUeVl0PcOMfuDk4/KJ98nX/4LpsiytqdbsQPN+Ze3Q0ciA3o4UmS2rjbO6Jz7LlTOy/hq1uldXqHJ9hPT0E6YzNi/w1X8jD/6BnHhCVvcxmakqN4MsrajNC7pvfobLp2Tf3Wp1ny6hXFWui3T0EyZLar4pj32cT/4z9cyXZHmXzFZVa3aoeb+yduhoGNDbwTJbkXEu3/oKxx9SOjlwhMmyuCa2tUahUCgUCoVCoVAoFArlqo6upx+YzGhbfPvLPPA+Hvp/1OZFVveprqfKTaNKZqsi8u2HOPYV1UrWb2e6KkJCoYoqCoVCoVAoFAqFQqFQrgrp6AaGKSme/hoPfkB9+U+58LzatZ9+oJodbN6vrB06Ggb0drIqNUzVbEXOHJNvfZrnHtX6XtYOsrqb9CjSkSAkxFXxAxIS0tF1pKfrmSwxXWJ+SR17mC/9iXzhT9TJbzBbleXdKDelKtVP1PIuOXdcvvVZTjyipWTtAKu7yQRFQoKQEFfFD0hISEfXkZ6up58wmVGjeu4RvvKn8rk/4tmHZTKTlb0oC+aDhe9TJGr3AW2+pfvmZ+Wpr3D767R7f1lueaOs38XSLgrjnBqlzV1T1VwTUelIRzq6nqHjymV15hl14mF56nM89XU2zqqlNXYddE1Vc3Mr19Sug9q4pXvyy/LMV7nttdq9vyS3vknW72ZlDxXanNakzVGqCiWi0pGQjm6g75hvqnPPcfyb8tSX5NkvqHPPqaVVtfugiKpm4UU5cNsvvIAlTCz8gKTT5lf0G2epYs8t7Ludfa/TDhyRXftleQ/TZSZLpPM94xab59XGeXX5DBeekVNPqBNPqrPHdeMWS2tqsiSilJ0o6bRxS79xTm1tsuegrB9h/X7twB3sOqBb3stshWFG1/uecYsrF9XGC+rSWS4+K88/oU48qc4c013ZYGlVTdckUcrCD7iUA7f9wgtYwsTCDxVR1fRbl9XmRTW/wnRFLe+S2Zqs7GKyRDrflXGTSy8YL13k8nnZ3CBRs1Umy3SdhX8ropRu6zKbF9XWJtNltbQmszVZ2c10mXS+K+0Kly9oGxfU5fOyeYGiZitquqrreqUs/EiXBgt/q1Ikxuky02XXVGuqmu78Sc4+g5LWqFJdp7pBugn9oKYrLK0hFn64Uq5pkyUmS66paqo13YXTnDuGktaoUulUP0g3qH6iJktMV0hcE5Sy8DcbLLwk6TrR0a8pLyo/qLwoFl6KpJO+ox+UVdeUH1ReFAsvRWdhYWHHGlxTZWFhYYdJdBYWFnaszsLCwo7VWVhY2LE6CwsLO1ZnYWFhx+osLCzsWJ2FhYUda/A9ZWFhYWfpLCws7FiD7yoLCws7zOA7ysLCwk4SdK4qCwsLO1FnYWFhx+osLCzsWJ2FhYUda2htFAsLCztNq9JVa6rKwsLCDlOls7CwsGN1FhYWdqzBd5WFhYWdpOgsLCzsWJ2FhYUdq7OwsLBjdRYWFnaoMviesrCwsLN0mKMsLCzsNGOnnFe2LCws7DSXh27oz1TVrqpatbCwsGOk6y50/WR2IukuW1hY2FG6YXqhq3H+FVVnLSws7DTHhvTDF7T2Ts3CwsKOUa76+rC6f/LJjTNbv7+1UYVYWFjYCVqSJ7v7f2vf47tvW3pGcsnCwsLOkO7MbFf3aOeqfjL9YtcNT1tYWNgRhuns84ffsuepzlXT5f6j/TSPoCwsLNz0piv9J/pJnu1cdejNK9/Yc3jpMcmGhYWFm1q6buPIL649sHZwcqLzHcN06aP9MPmahYWFm1rS/Ss85arOd3RD+1D6+hzmFhYWbk7J1rA8fKDruydc1fmOw29Zu7z/7tW/SNc9bGFh4aY0TJf+8jXv2v+1XbdMN13V+T79dPjTfjJ8PMloYWHhZjNPV/9zUt/wHZ3vc/gta5cP3r/7D9MPH7GwsHAzqcnyyv92328e+Nzawemm7+j8NUfeuvbxg/ctfwinLCws3BRKPfHa39jzT1b3D0/5Pp0fop9M/mk3DB+0sLBwUximS/9tuu7r/pr+te+431+36+D0MsNzG6fnt1YbX2dhYeFVq58u/eP7333g/1pdn5xL/ID+te+431+XxOqByXP0z2+cnt9RbbzbwsLCq850edcf3P/u9X+0un9yLFH+msGP0PWZ3/aGlY9UG3cfe/jsrmrtFy0sLLxqdP3wx6/9jd3/48r68GSi+SH6177jfj9Kuoyr+ydPpOtOXji5+RpVt1tYWLjhdf3wx6/73Vv++9X16RPpND9C/9p33O9v0vWZr+6bPNFPJt+6+Px4W7XxHgsLCzes6fKuP7j/3fv/h9X16RPpjP4G/Wvfcb+/Tddna2Xv5Ol+0j168dS4S7U3WlhYuOH006V/fP+71//Ryv7Jt9Jp/hb9a99xvx9H12e+tGdyohu6L2+cbs+n6+6pNu6xsLDwSqtSTwzT5f/m/nfvf9/q/smziebH0L/2Hff7cXV9xuU9w5m9R5a+srRr+vDFU+N6VbtXlYWFhZdfkvlkeeV/fd3vHPzvDty7+snV9cmZRPkxDX5Cw6ybD7Puudlq/yHq8We+fO5ftfn4D6uN77SwsPBy2ez64c/66eRP7vvN9Y+u7h+e8hIMXqJh1m3sv2f5oZX1yVMbp698+pmvXPj1yO9sXb70jsRuCwsLP2sjnuv64RPD0uT/fs279j6YLs+s7h8ueokGP4Vh1rVdt0zPLO8dPrO8d/rY5vnxw09/sV5Pfq1ae/v8yub9id0WFhZeqibdmWE6+zwemCznwTvetvtbXd89teuW6UU/pcHPwDDtxt23TZ8f1+v0dK1/BA9ubYy3P/X5c3eQN1Rrh1sb7+r64a75lUvLKrvEzMLCwneNuNx13YWun5ytak93/XAcj8x2dY8efsuep8Sxrndq1y3TuZ+R/w8ACjwHRhCoSwAAAABJRU5ErkJggg==",
        deepLink: "infinity://",
        downloadLink: "https://infinitywallet.io/download"
    },
    {
        key: "galleon_desktop",
        name: "Galleon",
        shortName: "Galleon",
        color: "",
        logo: "data:image/png;base64,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",
        deepLink: "galleon://",
        downloadLink: "https://cryptonomic.tech/galleon.html"
    },
    {
        key: "umami_desktop",
        name: "Umami",
        shortName: "Umami",
        color: "",
        logo: "data:image/png;base64,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",
        deepLink: "umami://",
        downloadLink: "https://umamiwallet.com/#download"
    },
    {
        key: "atomex_desktop",
        name: "Atomex Wallet",
        shortName: "Atomex",
        color: "",
        logo: "data:image/png;base64,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",
        deepLink: "atomex://",
        downloadLink: "https://atomex.me/"
    }
], $cf61b77dbdb95489$var$ad = [
    {
        key: "metamask_tezos_web",
        name: "MetaMask",
        shortName: "MetaMask",
        color: "",
        logo: "data:image/png;base64,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",
        links: {
            mainnet: "https://metamask.tezos.com/",
            ghostnet: "https://metamask.tezos.com/",
            weeklynet: "https://metamask.tezos.com/",
            dailynet: "https://metamask.tezos.com/",
            delphinet: "https://metamask.tezos.com/",
            edonet: "https://metamask.tezos.com/",
            florencenet: "https://metamask.tezos.com/",
            granadanet: "https://metamask.tezos.com/",
            hangzhounet: "https://metamask.tezos.com/",
            ithacanet: "https://metamask.tezos.com/",
            jakartanet: "https://metamask.tezos.com/",
            kathmandunet: "https://metamask.tezos.com/",
            limanet: "https://metamask.tezos.com/",
            mumbainet: "https://metamask.tezos.com/",
            nairobinet: "https://metamask.tezos.com/",
            oxfordnet: "https://metamask.tezos.com/",
            parisnet: "https://metamask.tezos.com/",
            quebecnet: "https://metamask.tezos.com/",
            rionet: "https://metamask.tezos.com/",
            seoulnet: "https://metamask.tezos.com/",
            shadownet: "https://metamask.tezos.com/"
        }
    },
    {
        key: "kukai_web",
        name: "Kukai Wallet",
        shortName: "Kukai",
        color: "",
        logo: "data:image/png;base64,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",
        supportedInteractionStandards: [
            "wallet_connect"
        ],
        links: {
            mainnet: "https://wallet.kukai.app",
            ghostnet: "https://ghostnet.kukai.app",
            weeklynet: "https://weeklynet.kukai.app",
            dailynet: "https://dailynet.kukai.app",
            delphinet: "https://testnet.kukai.app",
            edonet: "https://edonet.kukai.app",
            florencenet: "https://florencenet.kukai.app",
            granadanet: "https://granadanet.kukai.app",
            hangzhounet: "https://hangzhounet.kukai.app",
            ithacanet: "https://ithacanet.kukai.app",
            jakartanet: "https://jakartanet.kukai.app",
            kathmandunet: "https://kathmandunet.kukai.app",
            limanet: "https://limanet.kukai.app",
            mumbainet: "https://mumbainet.kukai.app",
            nairobinet: "https://nairobinet.kukai.app",
            oxfordnet: "https://oxfordnet.kukai.app",
            parisnet: "https://parisnet.kukai.app",
            quebecnet: "https://quebecnet.kukai.app",
            rionet: "https://rionet.kukai.app",
            seoulnet: "https://seoulnet.kukai.app",
            shadownet: "https://shadownet.kukai.app"
        }
    },
    {
        key: "tzsafe",
        name: "TzSafe",
        shortName: "TzSafe",
        color: "rgb(235, 52, 72)",
        logo: "data:image/svg+xml;base64,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",
        links: {
            mainnet: "https://tzsafe.marigold.dev",
            ghostnet: "https://ghostnet.tzsafe.marigold.dev",
            weeklynet: "https://ghostnet.tzsafe.marigold.dev",
            dailynet: "https://ghostnet.tzsafe.marigold.dev",
            delphinet: "https://ghostnet.tzsafe.marigold.dev",
            edonet: "https://ghostnet.tzsafe.marigold.dev",
            florencenet: "https://ghostnet.tzsafe.marigold.dev",
            granadanet: "https://ghostnet.tzsafe.marigold.dev",
            hangzhounet: "https://ghostnet.tzsafe.marigold.dev",
            ithacanet: "https://ghostnet.tzsafe.marigold.dev",
            jakartanet: "https://ghostnet.tzsafe.marigold.dev",
            kathmandunet: "https://ghostnet.tzsafe.marigold.dev",
            limanet: "https://ghostnet.tzsafe.marigold.dev",
            mumbainet: "https://ghostnet.tzsafe.marigold.dev",
            nairobinet: "https://ghostnet.tzsafe.marigold.dev",
            oxfordnet: "https://ghostnet.tzsafe.marigold.dev",
            parisnet: "https://ghostnet.tzsafe.marigold.dev",
            quebecnet: "https://ghostnet.tzsafe.marigold.dev",
            rionet: "https://ghostnet.tzsafe.marigold.dev",
            seoulnet: "https://ghostnet.tzsafe.marigold.dev",
            shadownet: "https://ghostnet.tzsafe.marigold.dev"
        }
    }
], $cf61b77dbdb95489$var$ld = [
    {
        key: "airgap_ios",
        name: "AirGap Wallet",
        shortName: "AirGap",
        color: "rgb(4, 235, 204)",
        logo: "data:image/png;base64,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",
        universalLink: "https://wallet.airgap.it",
        deepLink: "airgap-wallet://"
    },
    {
        key: "plenty_wallet_ios",
        name: "Plenty Wallet - your portal to web3 ",
        shortName: "Plenty Wallet",
        color: "",
        logo: "data:image/png;base64,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",
        universalLink: "https://www.naan.app/",
        deepLink: "naan://"
    },
    {
        key: "altme_wallet",
        name: "Altme Wallet",
        shortName: "Altme",
        color: "",
        logo: "data:image/png;base64,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",
        universalLink: "https://app.altme.io/app/download"
    },
    {
        key: "temple_ios",
        name: "Temple Wallet",
        shortName: "Temple",
        color: "",
        logo: "data:image/png;base64,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",
        universalLink: "https://templewallet.com",
        deepLink: "temple://"
    },
    {
        key: "atomex_ios",
        name: "Atomex Wallet",
        shortName: "Atomex",
        color: "",
        logo: "data:image/png;base64,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",
        universalLink: "https://atomex.me",
        deepLink: "atomex://"
    },
    {
        key: "umami_ios",
        name: "Umami Mobile",
        shortName: "Umami Mobile",
        color: "",
        logo: "data:image/png;base64,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",
        deepLink: "umami://",
        universalLink: "https://umamiwallet.com/"
    },
    {
        key: "trust_ios",
        name: "Trust Wallet",
        shortName: "Trust Wallet",
        color: "",
        supportedInteractionStandards: [
            "wallet_connect"
        ],
        logo: "data:image/png;base64,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",
        universalLink: "https://link.trustwallet.com",
        deepLink: "trust://"
    },
    {
        key: "exodus_mobile",
        name: "Exodus Mobile",
        shortName: "Exodus",
        color: "",
        logo: "data:image/svg+xml;base64,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",
        supportedInteractionStandards: [
            "beacon"
        ],
        deepLink: "exodus://wc",
        universalLink: "https://www.exodus.com/"
    },
    {
        key: "kukai_ios",
        name: "Kukai Wallet",
        shortName: "Kukai",
        color: "",
        logo: "data:image/png;base64,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",
        supportedInteractionStandards: [
            "wallet_connect"
        ],
        universalLink: "https://wallet.kukai.app",
        deepLink: "kukai://"
    },
    {
        key: "fireblocks_ios",
        name: "Fireblocks Wallet",
        shortName: "Fireblocks",
        color: "",
        logo: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTAwMHB4IiBoZWlnaHQ9IjEwMDBweCIgdmlld0JveD0iMCAwIDExMiAxMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+RmlyZUJsb2NrcyBOYXZ5PC90aXRsZT4KICAgIDxnIGlkPSJGaXJlQmxvY2tzLU5hdnkiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCcmFuZC9Mb2dvbWFyayIgZmlsbD0iIzAwMkU3RiI+CiAgICAgICAgICAgIDxnIGlkPSJCcmFuZC9CcmFuZG1hcmsvTmF2eSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTEyLDAgQzExMi41NTIyODUsMS40NTI4NTkxN2UtMTUgMTEzLDAuNDQ3NzE1MjUgMTEzLDEgTDExMywxIEwxMTMsMTEyIEMxMTMsMTEyLjU1MjI4NSAxMTIuNTUyMjg1LDExMyAxMTIsMTEzIEwxMTIsMTEzIEwxLDExMyBDMC40NDc3MTUyNSwxMTMgNi43NjM1Mzc1MWUtMTcsMTEyLjU1MjI4NSAwLDExMiBMMCwxMTIgTDAsMSBDMS40ODY2NzY4NmUtMTUsMC40NDc3MTUyNSAwLjQ0NzcxNTI1LDEuMDE0NTMwNjNlLTE2IDEsMCBMMSwwIFogTTU2LjQ5OTc0ODksMzEuMzg4ODg4OSBMMjUuMTEwODYsODEuNjExMTExMSBMODcuODg4NjM3OCw4MS42MTExMTExIEw1Ni40OTk3NDg5LDMxLjM4ODg4ODkgWiIgaWQ9IkJyYW5kL0JyYW5kbWFyayI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=",
        supportedInteractionStandards: [
            "wallet_connect"
        ],
        universalLink: ""
    }
], $cf61b77dbdb95489$var$sd = function(e) {
    var t, n, r = e.title, i = e.handleUpdateState, o = localStorage ? localStorage.getItem($cf61b77dbdb95489$var$sn.WC_INIT_ERROR) : void 0, a = $cf61b77dbdb95489$var$le.jsxs($cf61b77dbdb95489$var$le.Fragment, {
        children: [
            $cf61b77dbdb95489$var$le.jsx("h3", {
                style: {
                    color: "#FF4136",
                    margin: "0.6px"
                },
                children: "A network error occurred."
            }),
            $cf61b77dbdb95489$var$le.jsxs("h4", {
                className: "body-style",
                children: [
                    "This issue does not concern your wallet or dApp. If the problem persists, please report it to the Beacon team",
                    " ",
                    $cf61b77dbdb95489$var$le.jsx("span", {
                        style: {
                            textDecoration: "underline",
                            color: "#007bff",
                            cursor: "pointer"
                        },
                        onClick: function() {
                            return i($cf61b77dbdb95489$var$Dc.BUG_REPORT);
                        },
                        children: "here"
                    })
                ]
            }),
            o && (t = o, n = function(e) {
                return $cf61b77dbdb95489$var$le.jsx("span", {
                    children: e
                });
            }, t.toLowerCase().includes("failed to connect to relayer") ? n($cf61b77dbdb95489$var$le.jsxs($cf61b77dbdb95489$var$le.Fragment, {
                children: [
                    "It looks like your network provider is blocking requests to the WalletConnect relayer. As a workaround try connecting through a VPN as shown",
                    " ",
                    $cf61b77dbdb95489$var$le.jsx("a", {
                        href: "https://docs.walletbeacon.io/guides/failed-to-connect",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "here"
                    }),
                    "."
                ]
            })) : n(t))
        ]
    });
    return $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Oc, {
        title: r,
        description: a,
        border: !0
    });
}, $cf61b77dbdb95489$var$ud = function(e) {
    var t, r, i = e.wallet, o = e.isWCWorking, a = e.isMobile, l = e.qrCode, s = e.defaultPairing, c = e.handleUpdateState, f = e.handleIsLoading, h = !(null != i && null !== (t = i.supportedInteractionStandards) && void 0 !== t && t.includes("wallet_connect")) || o, p = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(l), 2), m = p[0], g = p[1];
    return $cf61b77dbdb95489$var$_.useEffect(function() {
        var e = function() {
            var e = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function e() {
                var t;
                return $cf61b77dbdb95489$var$u().w(function(e) {
                    for(;;)switch(e.n){
                        case 0:
                            if (!m) {
                                e.n = 1;
                                break;
                            }
                            return e.a(2);
                        case 1:
                            return t = g, e.n = 2, s;
                        case 2:
                            t(e.v), f(!1);
                        case 3:
                            return e.a(2);
                    }
                }, e);
            }));
            return function() {
                return e.apply(this, arguments);
            };
        }();
        e();
    }, [
        m
    ]), m && 0 !== m.length ? $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$le.Fragment, {
        children: h ? $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Kc, {
            isWalletConnect: (null == i || null === (r = i.supportedInteractionStandards) || void 0 === r ? void 0 : r.includes("wallet_connect")) || !1,
            isMobile: a,
            walletName: (null == i ? void 0 : i.name) || "AirGap",
            code: m,
            onClickLearnMore: function() {},
            onClickQrCode: function() {}
        }) : $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$sd, {
            title: "Connect with ".concat(null == i ? void 0 : i.name, " Mobile"),
            handleUpdateState: c
        })
    }) : $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$le.Fragment, {});
}, $cf61b77dbdb95489$var$cd = new Map([
    [
        "kukai_ios",
        "Mobile"
    ],
    [
        "acurast_ios",
        "Lite"
    ]
]), $cf61b77dbdb95489$var$dd = function(e) {
    var t, r = e.wallet, i = e.handleUpdateState, o = e.handleDeepLinking, a = e.wcPayload, l = e.p2pPayload, s = e.handleUpdateQRCode, c = e.handleDisplayQRExtra, d = e.onClose;
    return $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Oc, {
        border: !0,
        title: "Connect with ".concat(null == r ? void 0 : r.name, " ").concat(null !== (t = $cf61b77dbdb95489$var$cd.get(null == r ? void 0 : r.id)) && void 0 !== t ? t : ""),
        description: "",
        buttons: [
            {
                label: "Use App",
                type: "primary",
                onClick: function() {
                    r ? o(r) : console.error("No wallet found.");
                }
            }
        ],
        downloadLink: null != r && r.name.toLowerCase().includes("kukai") && $cf61b77dbdb95489$export$fedb369cb70207f1(window) ? {
            label: "Get Kukai Mobile >",
            url: "https://ios.kukai.app"
        } : void 0,
        onShowQRCodeClick: $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function e() {
            var t, n;
            return $cf61b77dbdb95489$var$u().w(function(e) {
                for(;;)switch(e.n){
                    case 0:
                        return e.n = 1, null != r && null !== (t = r.supportedInteractionStandards) && void 0 !== t && t.includes("wallet_connect") ? a : l;
                    case 1:
                        if ((n = e.v).length) {
                            e.n = 2;
                            break;
                        }
                        return d(), e.a(2);
                    case 2:
                        s(n), i($cf61b77dbdb95489$var$Dc.QR), c(!0);
                    case 3:
                        return e.a(2);
                }
            }, e);
        }))
    });
}, $cf61b77dbdb95489$var$fd = [], $cf61b77dbdb95489$var$hd = [], $cf61b77dbdb95489$var$pd = [], $cf61b77dbdb95489$var$md = [
    {
        key: "airgap_ios",
        name: "AirGap Wallet",
        shortName: "AirGap",
        color: "rgb(4, 235, 204)",
        logo: "data:image/png;base64,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",
        universalLink: "https://wallet.airgap.it",
        deepLink: "airgap-wallet://"
    },
    {
        key: "nova_ios",
        name: "Nova Wallet",
        shortName: "Nova",
        color: "",
        logo: "data:image/png;base64,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",
        universalLink: "https://novawallet.io",
        deepLink: "nova://"
    },
    {
        key: "fearless_ios",
        name: "Fearless Wallet",
        shortName: "fearless",
        color: "",
        logo: "data:image/png;base64,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",
        universalLink: "https://fearlesswallet.io",
        deepLink: "fearless://"
    },
    {
        key: "acurast-lite",
        name: "Acurast Lite",
        shortName: "Acurast",
        color: "",
        universalLink: "https://hub.acurast.com/",
        logo: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAITElEQVR4Ae3BL88lZxnA4R83bzIjmQRG4HD1FaAQqJGIsaPATUXTL0CCI+0UDDVgO4omBL7ACWJGnYN4EOczFAESFDSbpumf7e67u+95d+e5f9f1nffee+9/H374IZLyCSSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJad2hR9P9AH7zZ/juHVX6xw6/fRcdyB16NOM78MMfUa3fvYsOJtCj6HoYJqpVNig7OphAj2KcoWmp1rqgAwp0c10Pw0S1ygZlRwcU6ObGGZqWaq0LOqhAN9X1MExUq2xQdnRQgW5qnKFpqda6oAMLdDNdD8NEtcoGZUcHFuhmxhmalmqtCzq4QDfR9TBMVKtsUHZ0cIFuYpyhaanWuqAKBHpwXQ/DRLXKBmVHFQj04MYZmpZqrQuqRKAH1fUwTFSrbFB2VIlAD2qcoWmp1rqgigR6MF0Pw0S1ygZlRxUJ9GDGGZqWaq0LqkygB9H1MExUq2xQdlSZQA9inKFpqda6oAoFemVdD8NEtcoGZUcVCvTKxhmalmqtC6pUoFfS9TBMVKtsUHZUqUCvZJyhaanWuqCKBXppXQ/DRLXKBmVHFQv00sYZmpZqrQuqXKCX0vUwTFSrbFB2VLlAL2WcoWmp1rqgBAK9sK6HYaJaZYOyowQCvbBxhqalWuuCkgj0QroeholqlQ3KjpII9ELGGZqWaq0LSiTQvXU9DBPVKhuUHSUS6N7GGZqWaq0LSibQvXQ9DBPVKhuUHSUT6F7GGZqWaq0LSijQc3U9DBPVKhuUHSUU6LnGGZqWaq0LSirQM3U9DBPVKhuUHSUV6JnGGZqWaq0LSizQt+p6GCaqVTYoO0os0LcaZ2haqrUuKLlAT9X1MExUq2xQdpRcoKcaZ2haqrUuSAT6hq6HYaJaZYOyIxHoG8YZmpZqrQvSE4G+outhmKhW2aDsSE8E+opxhqalWuuC9IU79IWuh2GiWmWDsvNMH/wV3nqbQ/rvf+CXP4F/fYruKdAXxhmalmqtC8+1LhxW08I4oxcQ6Imuh2GiWmWDsvNclxNczxzWMEHXo3sK9MQ4Q9NSrXXh3taFw2paGGd0T4HoehgmqlU2KDv3djnB9cxhDRN0PbqHQIwzNC3VWhde2LpwWE0L44zuIUiu62GYqFbZoOy8sMsJrmcOa5ig69FzBMmNMzQt1VoXXtq6cFhNC+OMniNIrOthmKhW2aDsvLTLCa5nDmuYoOvRMwSJjTM0LdVaF17ZunBYTQvjjJ4hSKrrYZioVtmg7LyyywmuZw5rmKDr0bcIkhpnaFqqtS48mHXhsJoWxhl9iyChrodholplg7LzYC4nuJ45rGGCrkdPESQ0ztC0VGtdeHDrwmE1LYwzeoogma6HYaJaZYOy8+AuJ7ieOaxhgq5HXxMkM87QtFRrXbiZdeGwmhbGGX1NkEjXwzBRrbJB2bmZywmuZw5rmKDr0ZcEiYwzNC3VWhdubl04rKaFcUZfEiTR9TBMVKtsUHZu7nKC65nDGiboevS5IIlxhqalWuvCo1kXDqtpYZzR54IEuh6GiWqVDcrOo7mc4HrmsIYJuh59JkhgnKFpqda68OjWhcNqWhhn9Jmgcl0Pw0S1ygZl59FdTnA9c1jDBF1PekHlxhmalmqtC6/NunBYTQvjTHpBxboeholqlQ3KzmtzOcH1zGENE3Q9qQUVG2doWqq1Lrx268JhNS2MM6kFlep6GCaqVTYoO6/d5QTXM4c1TND1pBVUapyhaanWuvDGWBcOq2lhnEkrqFDXwzBRrbJB2XljXE5wPXNYwwRdT0pBhcYZmpZqrQtvnHXhsJoWxpmUgsp0PQwT1SoblJ03zuUE1zOHNUzQ9aRzR2V+NsK//0m1Pv6AN9a6wK9XDqlpYZzhD78ilTsq88lH8MlH6DW4nOB6hrfe5pCGCf70e/jXp6QRSA9oXTispoVxJpVAekCXE1zPHNYwQdeTRiA9sHXhsJoWxpk0AumBXU5wPXNYwwRdTwqBdAPrwmE1LYwzKQTSDVxOcD1zWMMEXU/1AulG1oXDaloYZ6oXSDdyOcH1zGENE3Q9VQukG1oXDqtpYZypWiDd0OUE1zOHNUzQ9VQrkG5sXTispoVxplqBdGOXE1zPHNYwQddTpUB6BOvCYTUtjDNVCqRHcDnB9cxhDRN87/tU5w7pkXz8PrzzPof105/DX/5IVe6QHsnf/wa/+DF6gwSS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLT+D+wylfk1Cv3pAAAAAElFTkSuQmCC",
        deepLink: "acurast://"
    }
], $cf61b77dbdb95489$var$gd = function(e) {
    var t, r, i, o, a, l = e.pairingPayload.walletConnectSyncCode, c = e.pairingPayload.p2pSyncCode, h = e.pairingPayload.postmessageSyncCode, p = $cf61b77dbdb95489$var$we(), m = function(e, t) {
        var r = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState([]), 2), i = r[0], o = r[1];
        $cf61b77dbdb95489$var$_.useEffect(function() {
            $cf61b77dbdb95489$var$td.getAvailableExtensions().then(o);
            var e = function() {
                var e = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function e(t) {
                    var n;
                    return $cf61b77dbdb95489$var$u().w(function(e) {
                        for(;;)switch(e.n){
                            case 0:
                                if ("extensionsUpdated" !== t.data) {
                                    e.n = 2;
                                    break;
                                }
                                return e.n = 1, $cf61b77dbdb95489$var$td.getAvailableExtensions();
                            case 1:
                                n = e.v, o(n);
                            case 2:
                                return e.a(2);
                        }
                    }, e);
                }));
                return function(t) {
                    return e.apply(this, arguments);
                };
            }();
            return $cf61b77dbdb95489$var$yn.addEventListener("message", e), function() {
                return $cf61b77dbdb95489$var$yn.removeEventListener("message", e);
            };
        }, []);
        var a = $cf61b77dbdb95489$var$_.useMemo(function() {
            var n = [].concat($cf61b77dbdb95489$var$f($cf61b77dbdb95489$var$od.filter(function(e) {
                return !i.some(function(t) {
                    return e.name === t.name;
                });
            }).map(function(e) {
                return {
                    id: e.key,
                    key: e.key,
                    name: e.shortName,
                    image: e.logo,
                    description: "Desktop App",
                    supportedInteractionStandards: e.supportedInteractionStandards,
                    type: "desktop",
                    link: e.downloadLink,
                    deepLink: e.deepLink
                };
            })), $cf61b77dbdb95489$var$f($cf61b77dbdb95489$var$id.map(function(e) {
                return {
                    id: e.id,
                    key: e.key,
                    name: e.shortName,
                    image: e.logo,
                    description: "Browser Extension",
                    supportedInteractionStandards: e.supportedInteractionStandards,
                    type: "extension",
                    link: e.link
                };
            })), $cf61b77dbdb95489$var$f($cf61b77dbdb95489$var$ld.map(function(e) {
                return {
                    id: e.key,
                    key: e.key,
                    name: e.shortName,
                    image: e.logo,
                    description: "Mobile App",
                    supportedInteractionStandards: e.supportedInteractionStandards,
                    type: "ios",
                    link: e.universalLink,
                    deepLink: e.deepLink
                };
            })), $cf61b77dbdb95489$var$f($cf61b77dbdb95489$var$ad.map(function(t) {
                var n = t.links[null != e ? e : $cf61b77dbdb95489$var$en.MAINNET];
                return {
                    id: t.key,
                    key: t.key,
                    name: t.shortName,
                    image: t.logo,
                    description: "Web App",
                    supportedInteractionStandards: t.supportedInteractionStandards,
                    type: "web",
                    link: null != n ? n : t.links.mainnet
                };
            })), $cf61b77dbdb95489$var$f(i.filter(function(e) {
                return !$cf61b77dbdb95489$var$id.some(function(t) {
                    return t.id === e.id;
                });
            }).map(function(e) {
                var t, n, r, i;
                return {
                    id: e.id,
                    key: e.id,
                    name: null !== (t = null !== (n = e.shortName) && void 0 !== n ? n : e.name) && void 0 !== t ? t : "",
                    image: null !== (r = e.iconUrl) && void 0 !== r ? r : "",
                    description: "Browser Extension",
                    type: "extension",
                    link: null !== (i = e.link) && void 0 !== i ? i : ""
                };
            })));
            return $cf61b77dbdb95489$var$On($cf61b77dbdb95489$var$Qn($cf61b77dbdb95489$var$An(n)), null != t ? t : [
                "kukai",
                "temple",
                "plenty",
                "umami"
            ]);
        }, [
            i,
            e,
            t
        ]);
        return $cf61b77dbdb95489$var$_.useMemo(function() {
            return new Map(a.map(function(e) {
                return [
                    e.id,
                    e
                ];
            }));
        }, [
            a
        ]);
    }(null === (t = e.pairingPayload) || void 0 === t ? void 0 : t.networkType, e.substratePairing ? void 0 : e.featuredWallets), g = function(e, t) {
        var n = $cf61b77dbdb95489$var$_.useMemo(function() {
            var t = $cf61b77dbdb95489$var$hd.map(function(e) {
                return {
                    id: e.key,
                    key: e.key,
                    name: e.shortName,
                    image: e.logo,
                    description: "Desktop App",
                    supportedInteractionStandards: e.supportedInteractionStandards,
                    type: "desktop",
                    link: e.downloadLink,
                    deepLink: e.deepLink
                };
            }), n = $cf61b77dbdb95489$var$fd.map(function(e) {
                return {
                    id: e.id,
                    key: e.key,
                    name: e.shortName,
                    image: e.logo,
                    description: "Browser Extension",
                    supportedInteractionStandards: e.supportedInteractionStandards,
                    type: "extension",
                    link: e.link
                };
            }), r = $cf61b77dbdb95489$var$md.map(function(e) {
                return {
                    id: e.key,
                    key: e.key,
                    name: e.shortName,
                    image: e.logo,
                    description: "Mobile App",
                    supportedInteractionStandards: e.supportedInteractionStandards,
                    type: "ios",
                    link: e.universalLink,
                    deepLink: e.deepLink
                };
            }), i = $cf61b77dbdb95489$var$pd.map(function(t) {
                var n, r = null !== (n = t.links[null != e ? e : $cf61b77dbdb95489$var$en.MAINNET]) && void 0 !== n ? n : t.links.mainnet;
                return {
                    id: t.key,
                    key: t.key,
                    name: t.shortName,
                    image: t.logo,
                    description: "Web App",
                    supportedInteractionStandards: t.supportedInteractionStandards,
                    type: "web",
                    link: r
                };
            });
            return [].concat($cf61b77dbdb95489$var$f(t), $cf61b77dbdb95489$var$f(n), $cf61b77dbdb95489$var$f(r), $cf61b77dbdb95489$var$f(i));
        }, [
            e
        ]), r = $cf61b77dbdb95489$var$_.useMemo(function() {
            var e = $cf61b77dbdb95489$var$On($cf61b77dbdb95489$var$Qn($cf61b77dbdb95489$var$An(n)), null != t ? t : [
                "acurast-lite",
                "airgap_ios",
                "nova_ios",
                "fearless_ios"
            ]);
            if (!t || t.length > 1) return e;
            var r = e.filter(function(e) {
                return e.id === t[0];
            });
            return r.length > 0 ? r : e;
        }, [
            n,
            t
        ]);
        return $cf61b77dbdb95489$var$_.useMemo(function() {
            return new Map(r.map(function(e) {
                return [
                    e.id,
                    e
                ];
            }));
        }, [
            r
        ]);
    }(null === (r = e.pairingPayload) || void 0 === r ? void 0 : r.networkType, e.substratePairing ? e.featuredWallets : void 0), b = function(e, t, r, i, o, a) {
        var l = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(), 2), c = l[0], f = l[1], h = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), p = h[0], m = h[1], g = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(), 2), b = g[0], y = g[1], v = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState($cf61b77dbdb95489$var$Dc.TOP_WALLETS), 2), I = v[0], M = v[1], E = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), x = E[0], S = E[1], w = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), k = w[0], N = w[1], U = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!0), 2), R = U[0], L = U[1], C = function(e) {
            !e || e.types.length <= 1 && !e.types.includes("ios") && !e.types.includes("desktop") || $cf61b77dbdb95489$export$d53806e03704a04e(window) && 1 === e.types.length && e.types.includes("desktop") || M($cf61b77dbdb95489$var$Dc.INSTALL);
        }, z = function() {
            var i = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function n(i, a) {
                var l, s, c, d, h, p, g, b, v, I;
                return $cf61b77dbdb95489$var$u().w(function(n) {
                    for(;;)switch(n.n){
                        case 0:
                            if (m(!0), N(!1), s = o.get(i), f(s), localStorage.setItem($cf61b77dbdb95489$var$sn.LAST_SELECTED_WALLET, JSON.stringify({
                                key: null == s ? void 0 : s.key,
                                type: "mobile",
                                icon: null == s ? void 0 : s.image
                            })), null == s || !s.types.includes("web") || 1 !== (null == s ? void 0 : s.types.length)) {
                                n.n = 1;
                                break;
                            }
                            return D(a, s), n.a(2);
                        case 1:
                            if (!s || null === (l = s.supportedInteractionStandards) || void 0 === l || !l.includes("wallet_connect")) {
                                n.n = 7;
                                break;
                            }
                            return p = $cf61b77dbdb95489$var$zc, n.n = 2, t;
                        case 2:
                            if (c = !!p(n.v).symKey, L(c), c || null == s || !s.name.toLowerCase().includes("kukai")) {
                                n.n = 3;
                                break;
                            }
                            return y("error"), C(s), m(!1), n.a(2);
                        case 3:
                            if (!c) {
                                n.n = 6;
                                break;
                            }
                            if (!e || !s.types.includes("ios") || 1 !== s.types.length) {
                                n.n = 4;
                                break;
                            }
                            F(s), n.n = 6;
                            break;
                        case 4:
                            return g = y, n.n = 5, t;
                        case 5:
                            g(n.v), C(s);
                        case 6:
                            m(!1), n.n = 13;
                            break;
                        case 7:
                            if (!($cf61b77dbdb95489$export$d53806e03704a04e(window) && null != s && s.types.includes("ios") && e) || null != s && s.name.toLowerCase().includes("acurast")) {
                                n.n = 10;
                                break;
                            }
                            if (y(""), !a.pairingPayload) {
                                n.n = 9;
                                break;
                            }
                            return b = $cf61b77dbdb95489$var$Vn, v = $cf61b77dbdb95489$export$fedb369cb70207f1(window) && s.deepLink ? s.deepLink : $cf61b77dbdb95489$export$a11b0059900ceec8(window) ? s.links[$cf61b77dbdb95489$var$Fn.IOS] : "tezos://", n.n = 8, r;
                        case 8:
                            d = b(v, n.v), T(d), $cf61b77dbdb95489$export$a11b0059900ceec8(window) ? window.open(d, "_blank", "noopener") : ((h = document.createElement("a")).setAttribute("href", d), h.setAttribute("rel", "noopener"), h.dispatchEvent(new MouseEvent("click", {
                                view: window,
                                bubbles: !0,
                                cancelable: !0
                            }))), m(!1);
                        case 9:
                            n.n = 13;
                            break;
                        case 10:
                            if (C(s), !a.pairingPayload) {
                                n.n = 12;
                                break;
                            }
                            return I = y, n.n = 11, r;
                        case 11:
                            I(n.v);
                        case 12:
                            m(!1);
                        case 13:
                            return n.a(2);
                    }
                }, n);
            }));
            return function(e, t) {
                return i.apply(this, arguments);
            };
        }(), T = function(e) {
            var t, n = JSON.parse(null !== (t = localStorage.getItem($cf61b77dbdb95489$var$sn.LAST_SELECTED_WALLET)) && void 0 !== t ? t : "{}");
            n.key && (n = $cf61b77dbdb95489$var$s($cf61b77dbdb95489$var$s({}, n), {}, {
                url: e
            }), localStorage.setItem($cf61b77dbdb95489$var$sn.LAST_SELECTED_WALLET, JSON.stringify(n)));
        }, D = function() {
            var e = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function e(n, i) {
                var o, a, l, s, c, d, f, h, p;
                return $cf61b77dbdb95489$var$u().w(function(e) {
                    for(;;)switch(e.n){
                        case 0:
                            if (n.pairingPayload) {
                                e.n = 1;
                                break;
                            }
                            return e.a(2);
                        case 1:
                            if (m(!0), (a = window.open("", "_blank")) && (a.opener = null), l = "", null === (o = i.supportedInteractionStandards) || void 0 === o || !o.includes("wallet_connect") || i.name.toLowerCase().includes("kukai")) {
                                e.n = 5;
                                break;
                            }
                            return c = $cf61b77dbdb95489$var$zc, e.n = 2, t;
                        case 2:
                            if (s = !!c(e.v).symKey, L(s), s) {
                                e.n = 3;
                                break;
                            }
                            return e.a(2);
                        case 3:
                            return d = "".concat(i.links[$cf61b77dbdb95489$var$Fn.WEB], "/wc?uri="), f = encodeURIComponent, e.n = 4, t;
                        case 4:
                            l = d.concat.call(d, f(e.v)), e.n = 7;
                            break;
                        case 5:
                            return h = $cf61b77dbdb95489$var$Vn, p = i.links[$cf61b77dbdb95489$var$Fn.WEB], e.n = 6, r;
                        case 6:
                            l = h(p, e.v);
                        case 7:
                            a ? a.location.href = l : window.open(l, "_blank", "noopener"), localStorage.setItem($cf61b77dbdb95489$var$sn.LAST_SELECTED_WALLET, JSON.stringify({
                                key: i.key,
                                name: i.name,
                                type: "web",
                                icon: null == i ? void 0 : i.image
                            }));
                        case 8:
                            return e.a(2);
                    }
                }, e);
            }));
            return function(t, n) {
                return e.apply(this, arguments);
            };
        }(), F = function() {
            var e = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function e(n) {
                var i, o, l, s, c, d;
                return $cf61b77dbdb95489$var$u().w(function(e) {
                    for(;;)switch(e.n){
                        case 0:
                            return localStorage.setItem($cf61b77dbdb95489$var$sn.LAST_SELECTED_WALLET, JSON.stringify({
                                key: null == n ? void 0 : n.key,
                                type: "mobile",
                                icon: null == n ? void 0 : n.image
                            })), e.n = 1, null != n && null !== (i = n.supportedInteractionStandards) && void 0 !== i && i.includes("wallet_connect") ? t : r;
                        case 1:
                            if (s = e.v, null != n && null !== (o = n.links[$cf61b77dbdb95489$var$Fn.IOS]) && void 0 !== o && o.length) {
                                e.n = 3;
                                break;
                            }
                            if (s.length) {
                                e.n = 2;
                                break;
                            }
                            return a(), e.a(2);
                        case 2:
                            return y(s), M($cf61b77dbdb95489$var$Dc.QR), S(!0), e.a(2);
                        case 3:
                            c = $cf61b77dbdb95489$var$Vn(n.links[$cf61b77dbdb95489$var$Fn.IOS], s), null != n && null !== (l = n.supportedInteractionStandards) && void 0 !== l && l.includes("wallet_connect") && (c = "".concat(n.links[$cf61b77dbdb95489$var$Fn.IOS], "wc?uri=").concat(encodeURIComponent(s))), T(c), $cf61b77dbdb95489$var$Vc.log("DO DEEPLINK WITH " + c), $cf61b77dbdb95489$var$Ie(window) && $cf61b77dbdb95489$export$a11b0059900ceec8(window) && (window.location.href = "".concat(s)), $cf61b77dbdb95489$export$a11b0059900ceec8(window) ? window.open(c, "_blank", "noopener") : ((d = document.createElement("a")).setAttribute("href", c), d.setAttribute("rel", "noopener"), d.dispatchEvent(new MouseEvent("click", {
                                view: window,
                                bubbles: !0,
                                cancelable: !0
                            })));
                        case 4:
                            return e.a(2);
                    }
                }, e);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), V = function() {
            var e = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function e() {
                var t, n, r, o, a, l, s, d;
                return $cf61b77dbdb95489$var$u().w(function(e) {
                    for(;;)switch(e.n){
                        case 0:
                            return N(!1), r = $cf61b77dbdb95489$var$rn.EXTENSION, e.n = 1, i;
                        case 1:
                            if (o = e.v, a = null == c ? void 0 : c.id, t = {
                                target: r,
                                payload: o,
                                targetId: a
                            }, $cf61b77dbdb95489$var$yn.postMessage(t, $cf61b77dbdb95489$var$yn.location.origin), null == c || !c.firefoxId) {
                                e.n = 3;
                                break;
                            }
                            return l = $cf61b77dbdb95489$var$rn.EXTENSION, e.n = 2, i;
                        case 2:
                            s = e.v, d = null == c ? void 0 : c.firefoxId, n = {
                                target: l,
                                payload: s,
                                targetId: d
                            }, $cf61b77dbdb95489$var$yn.postMessage(n, $cf61b77dbdb95489$var$yn.location.origin);
                        case 3:
                            localStorage.setItem($cf61b77dbdb95489$var$sn.LAST_SELECTED_WALLET, JSON.stringify({
                                key: null == c ? void 0 : c.key,
                                name: null == c ? void 0 : c.name,
                                type: "extension",
                                icon: null == c ? void 0 : c.image
                            }));
                        case 4:
                            return e.a(2);
                    }
                }, e);
            }));
            return function() {
                return e.apply(this, arguments);
            };
        }(), A = function() {
            var e = $cf61b77dbdb95489$var$n($cf61b77dbdb95489$var$u().m(function e() {
                var t, n, i;
                return $cf61b77dbdb95489$var$u().w(function(e) {
                    for(;;)switch(e.n){
                        case 0:
                            if (N(!1), !r) {
                                e.n = 2;
                                break;
                            }
                            return n = $cf61b77dbdb95489$var$Vn, i = (null == c ? void 0 : c.deepLink) || "", e.n = 1, r;
                        case 1:
                            t = n(i, e.v), window.open(t, "_blank", "noopener");
                        case 2:
                            localStorage.setItem($cf61b77dbdb95489$var$sn.LAST_SELECTED_WALLET, JSON.stringify({
                                key: null == c ? void 0 : c.key,
                                name: null == c ? void 0 : c.name,
                                type: "desktop",
                                icon: null == c ? void 0 : c.image
                            }));
                        case 3:
                            return e.a(2);
                    }
                }, e);
            }));
            return function() {
                return e.apply(this, arguments);
            };
        }();
        return [
            c,
            p,
            b,
            I,
            x,
            k,
            R,
            z,
            D,
            F,
            function() {
                localStorage.setItem($cf61b77dbdb95489$var$sn.LAST_SELECTED_WALLET, JSON.stringify({
                    key: "wallet",
                    name: "wallet",
                    type: "web",
                    icon: "data:image/svg+xml;base64,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"
                })), M($cf61b77dbdb95489$var$Dc.QR);
            },
            V,
            function() {
                N(!1), window.open((null == c ? void 0 : c.links[$cf61b77dbdb95489$var$Fn.EXTENSION]) || "", "_blank", "noopener");
            },
            A,
            function() {
                N(!1), window.open((null == c ? void 0 : c.links[$cf61b77dbdb95489$var$Fn.DESKTOP]) || "", "_blank", "noopener");
            },
            function(e) {
                return M(e);
            },
            function(e) {
                return y(e);
            },
            function() {
                return N(function(e) {
                    return !e;
                });
            },
            function(e) {
                return S(e);
            },
            function(e) {
                return m(e);
            }
        ];
    }(p, l, c, h, e.substratePairing ? g : m, e.onClose), y = $cf61b77dbdb95489$var$d(b, 20), v = y[0], I = y[1], M = y[2], E = y[3], x = y[4], S = y[5], w = y[6], k = y[7], N = y[8], U = y[9], R = y[10], L = y[11], C = y[12], z = y[13], T = y[14], D = y[15], F = y[16], V = y[17], A = y[18], j = y[19], O = navigator.onLine, Q = Array.from(e.substratePairing ? g.values() : m.values()), q = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), W = q[0], G = q[1];
    $cf61b77dbdb95489$var$_.useEffect(function() {
        e.openBugReport && E !== $cf61b77dbdb95489$var$Dc.BUG_REPORT && D($cf61b77dbdb95489$var$Dc.BUG_REPORT);
    }, [
        e.openBugReport
    ]), $cf61b77dbdb95489$var$_.useEffect(function() {
        e.open || E !== $cf61b77dbdb95489$var$Dc.BUG_REPORT || G(!0);
    }, [
        E,
        e.open
    ]), $cf61b77dbdb95489$var$_.useEffect(function() {
        var t = m.size;
        e.substratePairing && (t = g.size), 1 === t && k(Q[0].id, e);
    }, [
        m,
        g
    ]);
    var B = function(e) {
        var t = e.isMobile;
        return $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$ud, {
            wallet: v,
            isWCWorking: w,
            isMobile: t,
            qrCode: M,
            defaultPairing: c,
            handleUpdateState: D,
            handleIsLoading: j
        });
    }, K = function() {
        if (j(!1), !v) throw new Error("Wallet undefined");
        return $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$dd, {
            wallet: v,
            handleUpdateState: D,
            handleDeepLinking: U,
            wcPayload: l,
            p2pPayload: c,
            handleUpdateQRCode: F,
            handleDisplayQRExtra: A,
            onClose: e.onClose
        });
    };
    return $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Ne, $cf61b77dbdb95489$var$s($cf61b77dbdb95489$var$s({}, e), {}, {
        closeOnBackdropClick: E !== $cf61b77dbdb95489$var$Dc.BUG_REPORT,
        loading: I,
        onCloseClick: e.onClose,
        open: e.open,
        showMore: S,
        extraContent: E !== $cf61b77dbdb95489$var$Dc.TOP_WALLETS || p ? void 0 : $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Pc, {
            small: !0,
            disabled: I,
            wallets: Q.slice(-(Q.length - 4)),
            isMobile: p,
            onClickWallet: function(t) {
                return k(t, e);
            },
            onClickOther: R
        }),
        onClickShowMore: V,
        onBackClick: 1 === Q.length ? void 0 : [
            $cf61b77dbdb95489$var$Dc.INSTALL,
            $cf61b77dbdb95489$var$Dc.QR
        ].includes(E) || E === $cf61b77dbdb95489$var$Dc.WALLETS && p ? function() {
            return D($cf61b77dbdb95489$var$Dc.TOP_WALLETS);
        } : "bug-report" === E ? function() {
            if (!W) return D($cf61b77dbdb95489$var$Dc.TOP_WALLETS);
            e.onClose();
        } : void 0,
        children: $cf61b77dbdb95489$var$le.jsxs("div", {
            children: [
                E === $cf61b77dbdb95489$var$Dc.INSTALL && $cf61b77dbdb95489$var$le.jsxs("div", {
                    style: {
                        opacity: 1,
                        height: "unset",
                        overflow: "unset",
                        transform: "scale(1)",
                        transition: "all ease 0.3s",
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.9em"
                    },
                    children: [
                        O && (null == v ? void 0 : v.types.includes("web")) && $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Oc, {
                            border: !0,
                            title: "Connect with ".concat(null == v ? void 0 : v.name, " Web"),
                            description: "(It will open the wallet in a new tab)",
                            buttons: [
                                {
                                    label: "Use Browser",
                                    type: "primary",
                                    onClick: function() {
                                        return N(e, v);
                                    }
                                }
                            ]
                        }),
                        !p && (null == v ? void 0 : v.types.includes("extension")) && $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Oc, {
                            border: !0,
                            title: v.firefoxId ? "Connect with ".concat(null == v ? void 0 : v.name, " Browser Extension") : "Install ".concat(null == v ? void 0 : v.name, " Wallet"),
                            description: v.firefoxId ? "Please connect below to use your ".concat(null == v ? void 0 : v.name, " Wallet browser extension.") : "To connect your ".concat(null == v ? void 0 : v.name, " Wallet, install the browser extension."),
                            buttons: v.firefoxId ? [
                                {
                                    label: "Use Extension",
                                    type: "primary",
                                    onClick: function() {
                                        return L();
                                    }
                                }
                            ] : [
                                {
                                    label: "Install extension",
                                    type: "primary",
                                    onClick: function() {
                                        return C();
                                    }
                                }
                            ]
                        }),
                        !$cf61b77dbdb95489$export$d53806e03704a04e(window) && (null == v ? void 0 : v.types.includes("desktop")) && $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Oc, {
                            border: !0,
                            title: "Connect with ".concat(null == v ? void 0 : v.name, " Desktop App"),
                            description: "If you don't have the desktop app installed, click below to download it.",
                            buttons: [
                                {
                                    label: "Open desktop app",
                                    type: "primary",
                                    onClick: function() {
                                        return z();
                                    }
                                },
                                {
                                    label: "Download desktop app",
                                    type: "secondary",
                                    onClick: function() {
                                        return T();
                                    }
                                }
                            ]
                        }),
                        !$cf61b77dbdb95489$export$d53806e03704a04e(window) && (null !== (i = null == M ? void 0 : M.length) && void 0 !== i ? i : 0) > 0 && (null == v ? void 0 : v.types.includes("ios")) && (null == v ? void 0 : v.types.length) > 1 && $cf61b77dbdb95489$var$le.jsx(B, {
                            isMobile: !1
                        }),
                        !$cf61b77dbdb95489$export$d53806e03704a04e(window) && (null !== (o = null == M ? void 0 : M.length) && void 0 !== o ? o : 0) > 0 && (null == v ? void 0 : v.types.includes("ios")) && (null == v ? void 0 : v.types.length) <= 1 && $cf61b77dbdb95489$var$le.jsx(B, {
                            isMobile: !0
                        }),
                        $cf61b77dbdb95489$export$d53806e03704a04e(window) && (null == v ? void 0 : v.types.includes("ios")) && (w && null != v && null !== (a = v.supportedInteractionStandards) && void 0 !== a && a.includes("wallet_connect") || null != v && v.name.toLowerCase().includes("acurast") ? $cf61b77dbdb95489$var$le.jsx(K, {}) : $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$sd, {
                            title: "Connect with ".concat(null == v ? void 0 : v.name, " Mobile"),
                            handleUpdateState: D
                        }))
                    ]
                }),
                E === $cf61b77dbdb95489$var$Dc.QR && $cf61b77dbdb95489$var$le.jsx("div", {
                    style: {
                        opacity: 1,
                        height: "unset",
                        overflow: "unset",
                        transform: "scale(1)",
                        transition: "all ease 0.3s",
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.9em"
                    },
                    children: x ? $cf61b77dbdb95489$var$le.jsx(B, {
                        isMobile: !0
                    }) : $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Yc, {
                        walletList: Q,
                        onClickLearnMore: function() {},
                        p2pPayload: c,
                        wcPayload: l
                    })
                }),
                E === $cf61b77dbdb95489$var$Dc.WALLETS && $cf61b77dbdb95489$var$le.jsx("div", {
                    style: {
                        opacity: 1,
                        height: "unset",
                        overflow: "unset",
                        transform: "scale(1)",
                        transition: "all ease 0.3s"
                    },
                    children: $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Pc, {
                        wallets: Q.slice(-(Q.length - (p ? 3 : 4))),
                        isMobile: p,
                        onClickWallet: function(t) {
                            return k(t, e);
                        },
                        onClickOther: R
                    })
                }),
                E === $cf61b77dbdb95489$var$Dc.BUG_REPORT && $cf61b77dbdb95489$var$le.jsx("div", {
                    style: {
                        opacity: 1,
                        height: "unset",
                        overflow: "unset",
                        transform: "scale(1)",
                        transition: "all ease 0.3s",
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.9em"
                    },
                    children: $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$jc, {
                        onSubmit: e.onClose
                    })
                }),
                ![
                    $cf61b77dbdb95489$var$Dc.QR,
                    $cf61b77dbdb95489$var$Dc.WALLETS,
                    $cf61b77dbdb95489$var$Dc.BUG_REPORT,
                    $cf61b77dbdb95489$var$Dc.INSTALL
                ].includes(E) && $cf61b77dbdb95489$var$le.jsx("div", {
                    style: {
                        opacity: 1,
                        height: "unset",
                        overflow: "unset",
                        transform: "scale(1)",
                        transition: "all ease 0.3s"
                    },
                    children: $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Xc, {
                        wallets: p ? Q.slice(0, 3) : Q.slice(0, 4),
                        isMobile: p,
                        onClickWallet: function(t) {
                            return k(t, e);
                        },
                        onClickLearnMore: function() {
                            return D($cf61b77dbdb95489$var$Dc.BUG_REPORT);
                        },
                        disabled: I,
                        otherWallets: p && Q.length >= 6 ? {
                            images: [
                                Q[3].image,
                                Q[4].image,
                                Q[5].image
                            ],
                            onClick: function() {
                                return D($cf61b77dbdb95489$var$Dc.WALLETS);
                            }
                        } : void 0
                    })
                })
            ]
        })
    }));
}, $cf61b77dbdb95489$var$bd = function(e) {
    var t = e.title, n = e.body, r = e.data, i = e.open, o = e.onClose, a = e.closeOnBackdropClick;
    return $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Ne, {
        open: i,
        closeOnBackdropClick: a,
        onCloseClick: o,
        children: $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Oc, {
            bigIcon: !0,
            icon: $cf61b77dbdb95489$var$le.jsxs("svg", {
                fill: "currentColor",
                strokeWidth: "0",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
                height: "1em",
                width: "1em",
                style: {
                    overflow: "hidden"
                },
                color: "#494949",
                children: [
                    $cf61b77dbdb95489$var$le.jsx("path", {
                        d: "M85.57 446.25h340.86a32 32 0 0 0 28.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0 0 28.17 47.17Z",
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "32px"
                    }),
                    $cf61b77dbdb95489$var$le.jsx("path", {
                        d: "m250.26 195.39 5.74 122 5.73-121.95a5.74 5.74 0 0 0-5.79-6h0a5.74 5.74 0 0 0-5.68 5.95Z",
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "32px"
                    }),
                    $cf61b77dbdb95489$var$le.jsx("path", {
                        d: "M256 397.25a20 20 0 1 1 20-20 20 20 0 0 1-20 20Z"
                    })
                ]
            }),
            title: t || "No title",
            description: n || "No description",
            data: r,
            buttons: [
                {
                    label: "Close",
                    type: "primary",
                    onClick: o
                }
            ]
        })
    });
}, $cf61b77dbdb95489$var$yd = $cf61b77dbdb95489$var$cn.LIGHT, $cf61b77dbdb95489$export$ba2c82ed48ac7fc5 = function(e) {
    $cf61b77dbdb95489$var$yd = e;
}, $cf61b77dbdb95489$export$5573a5bab3e074b5 = function() {
    return $cf61b77dbdb95489$var$yd;
}, $cf61b77dbdb95489$var$Md = !1, $cf61b77dbdb95489$var$Ed = new $cf61b77dbdb95489$var$ee, $cf61b77dbdb95489$var$xd = new $cf61b77dbdb95489$var$ee, $cf61b77dbdb95489$export$a91ff26452e0a161 = function(e) {
    $cf61b77dbdb95489$var$Md ? $cf61b77dbdb95489$var$xd.next(e) : function(e) {
        var t = document.createElement("beacon-alert");
        document.body.prepend(t);
        var n = t.attachShadow({
            mode: "open"
        }), r = document.createElement("style");
        r.textContent = '.alert-wrapper-show{animation:fadeIn .3s ease forwards}.alert-wrapper-hide,.alert-wrapper-show{align-items:center;background-color:rgba(0,0,0,.6);display:flex;height:100%;justify-content:center;left:0;overflow:hidden;position:fixed;top:0;width:100vw;z-index:99999}.alert-wrapper-hide{animation:fadeOut .3s ease forwards}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.theme__dark .alert-modal-hide,.theme__dark .alert-modal-show{background-color:#27334c}.theme__dark .alert-footer{-webkit-box-shadow:0 -4px 12px rgba(0,0,0,.2);-moz-box-shadow:0 -4px 12px rgba(0,0,0,.2);box-shadow:0 -4px 12px rgba(0,0,0,.2);color:#fff}.theme__dark .alert-logo svg g{fill:#fff}.alert-modal-hide,.alert-modal-show{background-color:#fff;border-radius:32px;opacity:1;width:480px}.alert-modal-loading-wrapper{align-items:center;display:flex;justify-content:center;position:relative;width:480px}.alert-header{align-items:center;display:flex;justify-content:space-between;padding:1.2em 1.8em 0}.alert-button-icon-empty{height:24px;padding:2px;width:24px}.alert-logo{align-items:center;display:flex;justify-content:center;margin:0 6em}.alert-logo svg{height:28px}.alert-body{padding:1.8em 1.8em 0;transition:all .3s ease}.alert-footer{align-items:center;-webkit-box-shadow:0 -4px 12px rgb(50 50 50/6%);-moz-box-shadow:0 -4px 12px rgb(50 50 50/6%);box-shadow:0 -4px 12px rgb(50 50 50/6%);color:grey;cursor:pointer;display:flex;font-size:.938rem;font-weight:700;height:64px;justify-content:center}.alert-body-extra-show{max-height:35vh;overflow:hidden;transition:all .3s ease}.alert-body-extra-hide{max-height:0;overflow:hidden;transition:all .3s ease}.alert-divider{border-radius:6px;border-top:1px solid #aaaaaa42;width:100%}@media only screen and (max-width:800px){.alert-logo{margin:0 2em}.alert-wrapper-hide,.alert-wrapper-show{align-items:flex-end;width:100%}.alert-modal-show{width:100%}.alert-modal-hide,.alert-modal-show{border-bottom-left-radius:0;border-bottom-right-radius:0;padding-bottom:1.8em}}@media only screen and (max-width:300px){.alert-wrapper-hide,.alert-wrapper-show{align-items:flex-end;width:100vw}.alert-body{padding:.8em;padding:.4em .8em .8em}.alert-logo{margin:0;transform:scale(.8)}}.form-style{gap:20px;margin:0 auto;max-width:500px;min-width:100%}.form-style,.input-group{display:flex;flex-direction:column}.input-group{margin-bottom:15px}.label-style{margin-bottom:8px}.theme__light .label-style{color:#000}.input-style,.textarea-style{background-color:#fff;border:1px solid #ccc;border-radius:5px;box-sizing:border-box;color:#000;padding:10px;width:100%}.theme__dark .input-style,.theme__dark .textarea-style{background-color:#25334b;color:#fff}.input-style.invalid,.textarea-style.invalid{border-color:#f76b8a;border-width:medium}.textarea-style{height:8rem}.button-style{border:none;border-radius:5px;color:#fff;cursor:pointer;margin-top:20px;padding:10px 20px}.button-style.valid{background-color:#007bff}.button-style.invalid{background-color:#65afff}.error-label{color:#f76b8a;display:inline;font-size:.7rem}.permissions-group{align-items:center;display:flex;flex-wrap:wrap}.permissions-group label{flex-grow:1;font-size:.7rem}.permissions-group input{flex-shrink:0}@media screen and (max-height:700px){.textarea-style{height:6rem}}.button-loading:after{animation:button-loading-spinner 1s ease infinite;border:4px solid transparent;border-radius:50%;border-top-color:#fff;content:"";height:16px;left:0;margin:auto;position:absolute;right:0;width:16px}@keyframes button-loading-spinner{0%{transform:rotate(0turn)}to{transform:rotate(1turn)}}.icon{border:2px solid #fff;border-radius:50%;display:inline-block;margin-bottom:3px;opacity:0;padding:5px;transition:opacity .3s ease;width:1rem}.success-icon{animation:successAnimation .6s ease forwards}.error-icon{animation:fadeIn .3s ease forwards}@keyframes successAnimation{0%{opacity:0;transform:rotate(0deg)}to{opacity:1;transform:rotate(1turn)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.thank-you-message{display:inline-block;margin-left:10px}.thank-you-message span{animation:fadeInLetter .3s ease forwards;opacity:0}@keyframes fadeInLetter{to{opacity:1}}.info-wrapper{align-items:center;border-radius:10px;display:flex;flex-direction:column;gap:.5rem;justify-content:center;padding:30px}.info-border{border:1px solid #aaaaaa42}.info-icon{align-items:center;border-radius:6px;display:flex;font-size:28px;height:40px;justify-content:center;margin-bottom:.2rem;width:40px}.info-badge{background-color:#3880ff;-webkit-box-shadow:0 0 12px -4px rgba(0,0,0,.3);-moz-box-shadow:0 0 12px -4px rgba(0,0,0,.3);box-shadow:0 0 12px -4px rgba(0,0,0,.3);font-size:38px}.theme__dark .info-title{color:#fff}.theme__dark .info-description{color:#aeaeae}.info-title{color:#334155;font-size:16px;margin:0;text-align:center}.info-description{max-width:300px;text-align:center}.info-data,.info-description{color:#7c828b;font-size:12.8px;font-weight:300;line-height:1.25rem;margin:0}.info-data{max-height:300px;overflow:scroll}.info-buttons{align-items:center;display:flex;gap:.6rem}.info-button{background-color:#3880ff;border:1px solid #3880ff;border-radius:6px;color:#fff;cursor:pointer;font-size:12.8px;margin-top:1rem;padding:.6rem 1.2rem;transition:all .2s ease;width:180px}.info-button:hover{background-color:#166afc}.info-button-secondary{background-color:transparent;border:1px solid #3880ff;border-radius:6px;color:#3880ff;cursor:pointer;margin-top:1rem;padding:.6em 1.2rem;transition:all .2s ease;width:180px}.info-button-secondary:hover{background-color:#e8f0ff}.downloadLink{color:gray;font-size:smaller;padding:.5rem;text-decoration:none}button#qr-code-icon{align-self:self-end;background-color:transparent;border:none;min-width:2.5rem;padding:1.5px;position:absolute;right:.3rem;top:.3rem}button#qr-code-icon svg{width:25px}@media only screen and (max-width:300px){button#qr-code-icon{min-width:1.5rem}}@media only screen and (max-width:800px){.info-title{font-size:14.4px;line-height:1rem}.info-description{font-size:.65rem}.qr-more-info{font-size:.75rem}.info-wrapper{max-height:180px;padding:1.2em;position:relative}.info-icon{font-size:1.8rem;height:40px;width:40px}.info-button{font-size:16px;font-weight:700;padding:.5em 1.6em}}.loader{background-color:#ddd;bottom:0;left:0;overflow:hidden;position:relative;width:100%}.loader,.loader:before{height:3px;position:absolute}.loader:before{-webkit-animation:lineAnim 1s linear infinite;-moz-animation:lineAnim 1s linear infinite;animation:lineAnim 1s linear infinite;background-color:#3880ff;content:"";left:-50%;width:40%}@keyframes lineAnim{0%{left:-40%}50%{left:20%;width:80%}to{left:100%;width:100%}}.pair-other-info{align-items:center;color:#b5b8be;flex-direction:column}.pair-other-info,.qr-wrapper{display:flex;justify-content:center}.qr-wrapper{align-items:flex-start;border:1px solid #aaaaaa42;border-radius:10px;gap:.5em;height:200px;padding:30px}.qr-left{display:flex;flex-direction:column;height:100%;max-width:16em}.qr-left h3{color:#334155;font-size:1em;margin:0 0 .4em}.theme__dark .qr-left h3{color:#fff}.theme__dark .qr-copy-wrapper p,.theme__dark .qr-left span{color:#aeaeae}.qr-left span{color:#7c828b;font-size:.8rem;font-weight:300;line-height:1.35em;margin:0}.qr-more-info{cursor:pointer;font-size:.95em!important;margin-left:6px!important;text-decoration:underline}.qr-right{align-items:center;border-radius:6px;cursor:pointer;display:flex;flex-direction:column;justify-content:center;transition:all .2s ease}.theme__dark .qr-right:hover{background-color:hsla(0,0%,93%,.492)}.qr-right:hover{background-color:#eee}.qr-copy-wrapper{align-items:center;color:#7c828b;display:flex;gap:.6em;margin-bottom:8px;margin-top:18px}.qr-copy-wrapper svg{font-size:1em}.qr-copy-wrapper p{font-size:.8em;margin:0}.qr-svg-wrapper{background-color:#fff;border-radius:10px}.qr-svg-wrapper svg rect{fill:transparent!important}@media only screen and (max-width:800px){.qr-wrapper{align-items:center;flex-direction:column;height:340px;justify-content:center}.qr-left{margin:.6em 0}.qr-left h3{font-size:1em;line-height:1em}.qr-left p{font-size:.75em;text-align:center}.qr-left>div{align-items:center;display:flex;justify-content:center}.qr-more-info{font-size:.75em}}.top-wallets-wrapper{margin-bottom:1.8em}.top-wallets-info{align-items:center;display:flex;flex-direction:column;justify-content:center}.theme__dark .top-wallets-info h3{color:#fff}.theme__dark .top-wallets-info span{color:#b5b8be}.theme__dark .top-wallets-other-wallets-left h3{color:#fff}.top-wallets-info h3{color:#334155;font-size:.938rem;margin:0;text-align:center}.top-wallets-info span{color:#7c828b;font-size:.8em;font-weight:300;line-height:1.35em;margin:6px 0 12px;max-width:300px;text-align:center}.top-wallets-learn-more{cursor:pointer;font-size:.95em!important;text-decoration:underline}.top-wallets-wallets-main{display:grid;gap:1em;grid-template-columns:repeat(2,1fr);margin-top:1em}.top-wallets-other-wallets{border-radius:12px;-webkit-box-shadow:0 0 12px -4px rgba(0,0,0,.3);-moz-box-shadow:0 0 12px -4px rgba(0,0,0,.3);box-shadow:0 0 12px -4px rgba(0,0,0,.3);cursor:pointer;display:flex;gap:1.25em;justify-content:space-between;padding:1.25em;transition:all .2s ease}.top-wallets-other-wallets-left{max-width:148px}.top-wallets-other-wallets-left h3{color:#334155;font-size:1em;margin:0}.top-wallets-other-wallets-left p{color:#94a3b8;font-size:.85em;font-size:.75em;font-weight:300;line-height:1.35em;margin:0;max-width:400px}.top-wallets-other-wallets-right{align-items:center;display:flex;justify-content:center}.top-wallets-other-wallets-right img{border-radius:8px;-webkit-box-shadow:0 0 12px -4px rgba(0,0,0,.3);-moz-box-shadow:0 0 12px -4px rgba(0,0,0,.3);box-shadow:0 0 12px -4px rgba(0,0,0,.3);height:2.4em;width:2.4em}.top-wallets-other-wallets-center-wallet{transform:perspective(500px) translateZ(100px)}@media only screen and (max-width:800px){.top-wallets-info h3{font-size:1em}.top-wallets-info p{font-size:.75em}.top-wallets-other-wallets{align-items:center;flex-direction:column;justify-content:center;text-align:center}.top-wallets-other-wallets-left{order:1}.top-wallets-other-wallets-left h3{font-size:.85em}.top-wallets-other-wallets-left p{font-size:.65em}}@media only screen and (max-width:400px){.top-wallets-other-wallets-right{max-width:50px;transform:scale(.8)}}.wallet-main{border-radius:12px;-webkit-box-shadow:0 0 12px -4px rgba(0,0,0,.3);-moz-box-shadow:0 0 12px -4px rgba(0,0,0,.3);box-shadow:0 0 12px -4px rgba(0,0,0,.3);cursor:pointer;display:flex;gap:1.25em;justify-content:space-between;padding:15px;transition:all .2s ease}.wallet-disabled{opacity:.5}.wallet-main:hover{transform:scale(1.01)}.wallet-main:active{transform:scale(.99)}.wallet-main-left{flex:1;max-width:148px}.theme__dark .wallet-main-left h3{color:#fff}.theme__dark .top-wallets-info p{color:#b5b8be}.theme__dark .wallet-main-right,.theme__dark .wallet-small img{-webkit-box-shadow:0 0 12px -4px rgba(0,0,0,.63);-moz-box-shadow:0 0 12px -4px rgba(0,0,0,.63);box-shadow:0 0 12px -4px rgba(0,0,0,.63)}.theme__dark .wallet-small h3{color:#fff}.wallet-main-left h3{color:#1c1e21;font-size:1em;margin:0}.wallet-main-left p{color:#7c828b;font-size:.65em;font-weight:300;line-height:1.35em;margin:0;max-width:400px}.wallet-main-right{align-items:center;border-radius:8px;-webkit-box-shadow:0 0 12px -4px rgba(0,0,0,.3);-moz-box-shadow:0 0 12px -4px rgba(0,0,0,.3);box-shadow:0 0 12px -4px rgba(0,0,0,.3);display:flex;justify-content:center;overflow:hidden}.wallet-main-right img{height:3.2em;width:3.2em}.wallet-main-tags{display:flex;gap:6px}.wallet-main-tag{color:#3880ff;font-size:.75em;font-weight:600;margin:6px 0 0;text-transform:uppercase}.wallet-small{align-items:center;display:flex;flex-direction:column;gap:.5em;justify-content:center}.wallet-small img{border-radius:10px;-webkit-box-shadow:0 0 12px -4px rgba(0,0,0,.3);-moz-box-shadow:0 0 12px -4px rgba(0,0,0,.3);box-shadow:0 0 12px -4px rgba(0,0,0,.3);cursor:pointer;height:2.5em;padding:.4em;transition:all .2s ease;width:2.5em}.wallet-small img:hover{transform:scale(1.01)}.wallet-small img:active{transform:scale(.99)}.wallet-small h3{color:#334155;font-size:.8em;margin:0;text-align:center}.wallet-main-mobile{align-items:center;flex-direction:column;gap:1em;justify-content:center}.wallet-main-left-mobile{order:1}.wallet-main-left-mobile h3{font-size:.9em;text-align:center}.wallet-main-left-mobile p{font-size:.65em;text-align:center}@media only screen and (max-width:800px){.wallet-main{padding:.65em 15px}.wallet-main-mobile{padding:1.25em}}.wallets-button{background-color:transparent;border:1px solid #3880ff;border-radius:6px;color:#3880ff;cursor:pointer;font-size:.9em;margin-bottom:1.8em;padding:12px 0;transition:all .2s ease;width:100%}.wallets-button:hover{background-color:#3880ff;color:#fff}.wallets-list-main-wrapper{position:relative}.wallets-list-wrapper{display:grid;gap:1.2em 0;grid-template-columns:repeat(4,1fr);max-height:180px;overflow-y:auto;padding:1.8em 0}@media only screen and (max-width:800px){.wallets-list-wrapper{display:flex;flex-direction:column;gap:12px;margin-top:0;max-height:300px;padding:1.6em .6em}.wallets-list-main-wrapper:before{background:radial-gradient(circle,hsla(0,0%,67%,.733) 0,hsla(0,0%,76%,.128) 100%);content:"";height:1px;left:-24px;position:absolute;top:0;width:calc(100% + 48px)}}.button-icon{fill:#64748b;align-items:center;border:1px solid #f0f0f1;border-radius:100%;cursor:pointer;display:flex;height:24px;justify-content:center;margin-left:auto;padding:2px;transition:all .2s ease;width:24px}.button-icon:hover{fill:#e2e8f0;background-color:#475569;border:1px solid #475569}.theme__dark .button-icon{fill:#94a3b8;border:1px solid #475569}.theme__dark .button-icon:hover{fill:#f1f5f9;background-color:#64748b;border:1px solid #64748b}.body-style{color:#000}.theme__dark .body-style{color:#fff}\n/*# sourceMappingURL=data:application/json;base64,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 */', n.appendChild(r);
        var i = document.createElement("div");
        n.appendChild(i), setTimeout(function() {
            return $cf61b77dbdb95489$var$H.createRoot(i).render($cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Ud, $cf61b77dbdb95489$var$s({}, e)));
        }, 50), $cf61b77dbdb95489$var$Md = !0;
    }(e), $cf61b77dbdb95489$var$Ed.next(!0);
}, $cf61b77dbdb95489$export$3a3f4d84f6f396b9 = function() {
    var e = Promise.resolve("");
    $cf61b77dbdb95489$export$a91ff26452e0a161({
        title: "",
        body: "",
        buttons: [],
        openBugReport: !0,
        pairingPayload: {
            walletConnectSyncCode: e,
            p2pSyncCode: e,
            postmessageSyncCode: e,
            networkType: $cf61b77dbdb95489$var$en.MAINNET
        }
    });
}, $cf61b77dbdb95489$export$3e63366088f78025 = function() {
    $cf61b77dbdb95489$var$Ed.next(!1);
}, $cf61b77dbdb95489$export$8380cfcaeb3894a6 = function() {
    $cf61b77dbdb95489$export$3e63366088f78025();
}, $cf61b77dbdb95489$var$Ud = function(e) {
    var t = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!0), 2), n = t[0], r = t[1], i = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), o = i[0], a = i[1], l = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(e), 2), u = l[0], c = l[1];
    $cf61b77dbdb95489$var$_.useEffect(function() {
        var e = [];
        return e.push($cf61b77dbdb95489$var$Ed.subscribe(function(e) {
            return r(e);
        })), e.push($cf61b77dbdb95489$var$xd.subscribe(function(e) {
            return c(e);
        })), function() {
            return e.forEach(function(e) {
                return e.unsubscribe();
            });
        };
    }, []), $cf61b77dbdb95489$var$_.useEffect(function() {
        n ? a(!0) : setTimeout(function() {
            return a(!1);
        }, 300);
    }, [
        n
    ]);
    var f = $cf61b77dbdb95489$var$s($cf61b77dbdb95489$var$s({}, u), {}, {
        onClose: function() {
            $cf61b77dbdb95489$export$3e63366088f78025(), u.closeButtonCallback && u.closeButtonCallback();
        },
        open: n,
        closeOnBackdropClick: !0
    }), h = function() {
        return u.pairingPayload || u.openBugReport ? $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$gd, $cf61b77dbdb95489$var$s({}, f)) : $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$bd, $cf61b77dbdb95489$var$s({}, f));
    };
    return $cf61b77dbdb95489$var$le.jsxs("div", {
        className: "theme__".concat($cf61b77dbdb95489$export$5573a5bab3e074b5()),
        children: [
            o && $cf61b77dbdb95489$var$le.jsx(h, {}),
            " "
        ]
    });
}, $cf61b77dbdb95489$var$Rd = $cf61b77dbdb95489$var$od, $cf61b77dbdb95489$var$Ld = $cf61b77dbdb95489$var$id, $cf61b77dbdb95489$var$Cd = $cf61b77dbdb95489$var$ad, $cf61b77dbdb95489$var$zd = $cf61b77dbdb95489$var$ld, $cf61b77dbdb95489$export$aef0bf0b2d04be = function() {
    return $cf61b77dbdb95489$var$Rd;
}, $cf61b77dbdb95489$export$c8e7c1daea1a7d77 = function(e) {
    $cf61b77dbdb95489$var$Rd = e;
}, $cf61b77dbdb95489$export$ff6f27c71dedea72 = function() {
    return $cf61b77dbdb95489$var$Ld;
}, $cf61b77dbdb95489$export$52f45817c3388413 = function(e) {
    $cf61b77dbdb95489$var$Ld = e;
}, $cf61b77dbdb95489$export$6924bc0a2358113f = function() {
    return $cf61b77dbdb95489$var$Cd;
}, $cf61b77dbdb95489$export$d843bfebb480c881 = function(e) {
    $cf61b77dbdb95489$var$Cd = e;
}, $cf61b77dbdb95489$export$cc7f6510f00b58d6 = function() {
    return $cf61b77dbdb95489$var$zd;
}, $cf61b77dbdb95489$export$af64c7ad68fb9259 = function(e) {
    $cf61b77dbdb95489$var$zd = e;
};
!function(e) {
    e[e.DESKTOP = 0] = "DESKTOP", e[e.IOS = 1] = "IOS", e[e.ANDROID = 2] = "ANDROID";
}($cf61b77dbdb95489$var$nd || ($cf61b77dbdb95489$var$nd = {})), function(e) {
    e.IOS = "ios", e.ANDROID = "android", e.EXTENSION = "extension", e.DESKTOP = "desktop", e.WEB = "web";
}($cf61b77dbdb95489$var$rd || ($cf61b77dbdb95489$var$rd = {}));
var $cf61b77dbdb95489$export$3370ee24730992a3 = $cf61b77dbdb95489$var$i(function e() {
    $cf61b77dbdb95489$var$r(this, e);
});
var $cf61b77dbdb95489$var$Wd, $cf61b77dbdb95489$var$Gd = function(e) {
    var t, n, r, i, o, a, l = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!0), 2), u = l[0], c = l[1], f = e.label.includes("{{wallet}}") && e.walletInfo, h = e.label.includes("Request sent to"), p = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState([
        0,
        0
    ]), 2), m = $cf61b77dbdb95489$var$d(p[0], 2), g = m[0], b = m[1], y = p[1], v = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), I = v[0], M = v[1], E = (t = function(e) {
        var t = $cf61b77dbdb95489$var$d(e.offset, 2), n = t[0], r = t[1];
        y([
            n,
            r
        ]);
    }, n = $cf61b77dbdb95489$var$_.useRef({
        startX: 0,
        startY: 0,
        isDragging: !1
    }), r = $cf61b77dbdb95489$var$_.useRef([
        0,
        0
    ]), i = function(e) {
        e.preventDefault(), n.current.isDragging = !0, n.current.startX = e.clientX - r.current[0], n.current.startY = e.clientY - r.current[1], document.addEventListener("mousemove", o), document.addEventListener("mouseup", a);
    }, o = function(e) {
        if (n.current.isDragging) {
            var i = e.clientX - n.current.startX, o = e.clientY - n.current.startY;
            r.current = [
                i,
                o
            ], t({
                offset: [
                    i,
                    o
                ]
            });
        }
    }, a = function() {
        n.current.isDragging = !1, document.removeEventListener("mousemove", o), document.removeEventListener("mouseup", a);
    }, function() {
        return {
            onMouseDown: i
        };
    }), x = $cf61b77dbdb95489$export$d53806e03704a04e(window);
    $cf61b77dbdb95489$var$_.useEffect(function() {
        h && (c(!1), setTimeout(function() {
            c(!0);
        }, 3e3));
    }, [
        h
    ]), $cf61b77dbdb95489$var$_.useEffect(function() {
        e.open && M(!1);
    }, [
        e.open
    ]);
    var S, w, k;
    return $cf61b77dbdb95489$var$le.jsxs("div", $cf61b77dbdb95489$var$s($cf61b77dbdb95489$var$s({
        onAnimationEnd: function() {
            e.open && M(!0);
        },
        style: {
            position: "absolute",
            transform: "translate3d(".concat(g, "px, ").concat(b, "px, 0)"),
            touchAction: "none",
            minWidth: x ? void 0 : 460,
            animation: e.open && I ? "none" : void 0
        },
        className: e.open ? "toast-wrapper-show" : "toast-wrapper-hide"
    }, x ? void 0 : E()), {}, {
        children: [
            $cf61b77dbdb95489$var$le.jsxs("div", {
                className: "toast-header",
                children: [
                    $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$he, {}),
                    f && e.walletInfo && $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$le.Fragment, {
                        children: (S = e.label, w = e.walletInfo, k = /({{\s*wallet\s*}})/g, S.split(k).map(function(e, t) {
                            return e.match(k) ? $cf61b77dbdb95489$var$le.jsxs($cf61b77dbdb95489$var$$.Fragment, {
                                children: [
                                    $cf61b77dbdb95489$var$le.jsx("img", {
                                        draggable: !1,
                                        src: w.icon,
                                        alt: "".concat(w.name, " icon")
                                    }),
                                    $cf61b77dbdb95489$var$le.jsx("h3", {
                                        children: w.name
                                    })
                                ]
                            }, t) : $cf61b77dbdb95489$var$le.jsx("p", {
                                className: "toast-label",
                                children: e
                            }, t);
                        }))
                    }),
                    !f && $cf61b77dbdb95489$var$le.jsx("p", {
                        className: "toast-label",
                        children: e.label
                    }),
                    !$cf61b77dbdb95489$export$d53806e03704a04e(window) && e.openWalletAction && $cf61b77dbdb95489$var$le.jsx("div", {
                        className: "toast-action-button",
                        onClick: e.openWalletAction,
                        children: "Open Wallet"
                    }),
                    $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$ke, {
                        onClick: e.onClickClose,
                        children: $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$se, {})
                    })
                ]
            }),
            e.actions && u && $cf61b77dbdb95489$var$le.jsx("div", {
                className: "toast-body",
                children: e.actions.map(function(e, t) {
                    return $cf61b77dbdb95489$var$le.jsxs("div", {
                        className: "toast-action-wrapper",
                        children: [
                            $cf61b77dbdb95489$var$le.jsx("p", {
                                className: "toast-action-label ".concat(e.isBold ? "toast-action-bold" : ""),
                                children: e.text
                            }),
                            e.actionText && $cf61b77dbdb95489$var$le.jsx("div", {
                                className: "toast-action-button",
                                onClick: e.actionCallback,
                                children: e.actionText
                            })
                        ]
                    }, t);
                })
            })
        ]
    }));
}, $cf61b77dbdb95489$var$Bd = !1, $cf61b77dbdb95489$var$Kd = new $cf61b77dbdb95489$var$ee, $cf61b77dbdb95489$var$Yd = new $cf61b77dbdb95489$var$ee, $cf61b77dbdb95489$var$Zd = 0, $cf61b77dbdb95489$var$Xd = 0, $cf61b77dbdb95489$export$39c365eaabfb0a68 = function(e) {
    var t = Date.now();
    t - $cf61b77dbdb95489$var$Zd > 2e3 ? $cf61b77dbdb95489$var$Xd = 1 : $cf61b77dbdb95489$var$Xd++, $cf61b77dbdb95489$var$Zd = t, $cf61b77dbdb95489$var$Bd ? setTimeout(function() {
        return $cf61b77dbdb95489$var$Kd.next(e);
    }, 1 === $cf61b77dbdb95489$var$Xd ? 0 : 500 + 100 * ($cf61b77dbdb95489$var$Xd - 2)) : function(e) {
        var t = document.createElement("beacon-toast");
        document.body.prepend(t);
        var n = t.attachShadow({
            mode: "open"
        }), r = document.createElement("style");
        r.textContent = '.toast-wrapper-show{animation:toastIn .3s ease forwards}.toast-wrapper-hide,.toast-wrapper-show{background-color:#fff;border-radius:6px;-webkit-box-shadow:0 4px 11px -4px rgba(0,0,0,.45);-moz-box-shadow:0 4px 11px -4px rgba(0,0,0,.45);box-shadow:0 4px 11px -4px rgba(0,0,0,.45);cursor:move;max-width:460px;overflow:hidden;position:fixed;right:12px;top:12px;user-select:none;z-index:1000000}.toast-wrapper-hide{animation:toastOut .3s ease forwards}@keyframes toastIn{0%{opacity:0;transform:translateY(-150px) scale(.2)}to{opacity:1;transform:translateY(0) scale(1)}}@keyframes toastOut{0%{opacity:1;transform:translateY(0) scale(1)}to{opacity:0;transform:translateY(-150px) scale(.2)}}.toast-header{align-items:center;display:flex;gap:6px;overflow:hidden;padding:0 .6em 0 1.2em;position:relative}.toast-header img{width:24px}.toast-header h3{color:#334155;font-size:.8em;font-weight:700;margin:14px auto 13px 0}.toast-label{color:#334155;font-size:.9em;margin:1em 0}.toast-button-icon{margin-left:auto}.toast-body{padding:.6em 1.2em}.toast-action-wrapper{align-items:center;display:flex;justify-content:space-between}.toast-action-label{color:#64748b;font-size:.8em;margin:.8em 0}.toast-action-bold{color:#334155;font-weight:700}.toast-action-button{border-radius:6px;color:#3880ff;cursor:pointer;font-size:.8em;font-weight:600;padding:.4em .8em;transition:all .2s ease}.toast-action-button:hover{background-color:#e4eeff;transition:all .2s ease}@media only screen and (max-width:800px){.toast-wrapper-hide,.toast-wrapper-show{width:calc(100% - 24px)}}.theme__dark .toast-wrapper-hide,.theme__dark .toast-wrapper-show{background-color:#27334c;-webkit-box-shadow:0 4px 11px -4px rgba(0,0,0,.65);-moz-box-shadow:0 4px 11px -4px rgba(0,0,0,.65);box-shadow:0 4px 11px -4px rgba(0,0,0,.65)}.theme__dark .toast-header h3,.theme__dark .toast-label{color:#e2e8f0}.theme__dark .toast-action-label{color:#94a3b8}.theme__dark .toast-action-bold{color:#e2e8f0}.theme__dark .toast-action-button{color:#60a5fa}.theme__dark .toast-action-button:hover{background-color:#1e293b}.loader{background-color:#ddd;bottom:0;left:0;overflow:hidden;position:relative;width:100%}.loader,.loader:before{height:3px;position:absolute}.loader:before{-webkit-animation:lineAnim 1s linear infinite;-moz-animation:lineAnim 1s linear infinite;animation:lineAnim 1s linear infinite;background-color:#3880ff;content:"";left:-50%;width:40%}@keyframes lineAnim{0%{left:-40%}50%{left:20%;width:80%}to{left:100%;width:100%}}.button-icon{fill:#64748b;align-items:center;border:1px solid #f0f0f1;border-radius:100%;cursor:pointer;display:flex;height:24px;justify-content:center;margin-left:auto;padding:2px;transition:all .2s ease;width:24px}.button-icon:hover{fill:#e2e8f0;background-color:#475569;border:1px solid #475569}.theme__dark .button-icon{fill:#94a3b8;border:1px solid #475569}.theme__dark .button-icon:hover{fill:#f1f5f9;background-color:#64748b;border:1px solid #64748b}\n/*# sourceMappingURL=data:application/json;base64,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 */', n.appendChild(r);
        var i = document.createElement("div");
        n.appendChild(i), setTimeout(function() {
            return $cf61b77dbdb95489$var$H.createRoot(i).render($cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Hd, $cf61b77dbdb95489$var$s({}, e)));
        }, 50), $cf61b77dbdb95489$var$Bd = !0;
    }(e), $cf61b77dbdb95489$var$Wd && (clearTimeout($cf61b77dbdb95489$var$Wd), $cf61b77dbdb95489$var$Wd = void 0), $cf61b77dbdb95489$var$Wd = e.timer ? setTimeout(function() {
        return $cf61b77dbdb95489$export$c96659240d08478b();
    }, e.timer) : void 0, $cf61b77dbdb95489$var$Yd.next(!0);
}, $cf61b77dbdb95489$export$c96659240d08478b = function() {
    $cf61b77dbdb95489$var$Kd.next(void 0), $cf61b77dbdb95489$var$Yd.next(!1);
}, $cf61b77dbdb95489$var$Hd = function(e) {
    var t = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(e), 2), n = t[0], r = t[1], i = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!0), 2), o = i[0], a = i[1], l = $cf61b77dbdb95489$var$d($cf61b77dbdb95489$var$_.useState(!1), 2), s = l[0], u = l[1];
    return $cf61b77dbdb95489$var$_.useEffect(function() {
        var e = [];
        return e.push($cf61b77dbdb95489$var$Kd.subscribe(function(e) {
            r(e);
        })), e.push($cf61b77dbdb95489$var$Yd.subscribe(function(e) {
            a(e);
        })), function() {
            return e.forEach(function(e) {
                return e.unsubscribe();
            });
        };
    }, []), $cf61b77dbdb95489$var$_.useEffect(function() {
        n ? o && u(!0) : u(!1);
    }, [
        o,
        n
    ]), $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$le.Fragment, {
        children: $cf61b77dbdb95489$var$le.jsx("div", {
            className: "theme__".concat($cf61b77dbdb95489$export$5573a5bab3e074b5()),
            children: s && n && $cf61b77dbdb95489$var$le.jsx($cf61b77dbdb95489$var$Gd, {
                label: n.body,
                open: o,
                onClickClose: $cf61b77dbdb95489$export$c96659240d08478b,
                actions: n.actions,
                walletInfo: n.walletInfo,
                openWalletAction: n.openWalletAction
            })
        })
    });
};







const $e9c0aef9005508c3$export$b139bd30bc162c86 = (text)=>{
    if (text.length >= 12) return `${text.substr(0, 5)}...${text.substr(-5)}`;
    return text;
};



const $0b587c8852746f57$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('BeaconEvents');
const $0b587c8852746f57$var$SUCCESS_TIMER = 5000;
var $0b587c8852746f57$export$8d08de21eea96a9c;
(function(BeaconEvent) {
    BeaconEvent["PERMISSION_REQUEST_SENT"] = "PERMISSION_REQUEST_SENT";
    BeaconEvent["PERMISSION_REQUEST_SUCCESS"] = "PERMISSION_REQUEST_SUCCESS";
    BeaconEvent["PERMISSION_REQUEST_ERROR"] = "PERMISSION_REQUEST_ERROR";
    BeaconEvent["PROOF_OF_EVENT_CHALLENGE_REQUEST_SENT"] = "PROOF_OF_EVENT_CHALLENGE_REQUEST_SENT";
    BeaconEvent["PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS"] = "PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS";
    BeaconEvent["PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR"] = "PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR";
    BeaconEvent["SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SENT"] = "SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SENT";
    BeaconEvent["SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS"] = "SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS";
    BeaconEvent["SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR"] = "SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR";
    BeaconEvent["OPERATION_REQUEST_SENT"] = "OPERATION_REQUEST_SENT";
    BeaconEvent["OPERATION_REQUEST_SUCCESS"] = "OPERATION_REQUEST_SUCCESS";
    BeaconEvent["OPERATION_REQUEST_ERROR"] = "OPERATION_REQUEST_ERROR";
    BeaconEvent["SIGN_REQUEST_SENT"] = "SIGN_REQUEST_SENT";
    BeaconEvent["SIGN_REQUEST_SUCCESS"] = "SIGN_REQUEST_SUCCESS";
    BeaconEvent["SIGN_REQUEST_ERROR"] = "SIGN_REQUEST_ERROR";
    BeaconEvent["BLOCKCHAIN_REQUEST_SUCCESS"] = "BLOCKCHAIN_REQUEST_SUCCESS";
    // TODO: ENCRYPTION
    // ENCRYPT_REQUEST_SENT = 'ENCRYPT_REQUEST_SENT',
    // ENCRYPT_REQUEST_SUCCESS = 'ENCRYPT_REQUEST_SUCCESS',
    // ENCRYPT_REQUEST_ERROR = 'ENCRYPT_REQUEST_ERROR',
    BeaconEvent["BROADCAST_REQUEST_SENT"] = "BROADCAST_REQUEST_SENT";
    BeaconEvent["BROADCAST_REQUEST_SUCCESS"] = "BROADCAST_REQUEST_SUCCESS";
    BeaconEvent["BROADCAST_REQUEST_ERROR"] = "BROADCAST_REQUEST_ERROR";
    BeaconEvent["ACKNOWLEDGE_RECEIVED"] = "ACKNOWLEDGE_RECEIVED";
    BeaconEvent["LOCAL_RATE_LIMIT_REACHED"] = "LOCAL_RATE_LIMIT_REACHED";
    BeaconEvent["NO_PERMISSIONS"] = "NO_PERMISSIONS";
    BeaconEvent["ACTIVE_ACCOUNT_SET"] = "ACTIVE_ACCOUNT_SET";
    BeaconEvent["ACTIVE_TRANSPORT_SET"] = "ACTIVE_TRANSPORT_SET";
    BeaconEvent["SHOW_PREPARE"] = "SHOW_PREPARE";
    BeaconEvent["HIDE_UI"] = "HIDE_UI";
    BeaconEvent["INVALID_ACTIVE_ACCOUNT_STATE"] = "INVALID_ACTIVE_ACCOUNT_STATE";
    BeaconEvent["INVALID_ACCOUNT_DEACTIVATED"] = "INVALID_ACCOUNT_DEACTIVATED";
    BeaconEvent["PAIR_INIT"] = "PAIR_INIT";
    BeaconEvent["PAIR_SUCCESS"] = "PAIR_SUCCESS";
    BeaconEvent["CHANNEL_CLOSED"] = "CHANNEL_CLOSED";
    BeaconEvent["GENERIC_ERROR"] = "GENERIC_ERROR";
    BeaconEvent["OPEN_BUG_REPORT"] = "OPEN_BUG_REPORT";
    BeaconEvent["RELAYER_ERROR"] = "RELAYER_ERROR";
    BeaconEvent["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    BeaconEvent["UNKNOWN"] = "UNKNOWN";
})($0b587c8852746f57$export$8d08de21eea96a9c || ($0b587c8852746f57$export$8d08de21eea96a9c = {}));
/**
 * Show a "Request sent" toast
 */ const $0b587c8852746f57$var$showSentToast = async (data)=>{
    let openWalletAction;
    const actions = [];
    if (data.walletInfo.deeplink) {
        if (data.walletInfo.type === 'web' || data.walletInfo.type === 'mobile' && (0, $cf61b77dbdb95489$export$d0a8044dce8ff2fc)(window) || data.walletInfo.type === 'desktop' && !(0, $cf61b77dbdb95489$export$d0a8044dce8ff2fc)(window)) {
            const link = data.walletInfo.deeplink;
            openWalletAction = async ()=>{
                const a = document.createElement('a');
                a.setAttribute('rel', 'noopener');
                a.setAttribute('href', link);
                a.setAttribute('target', '_blank');
                a.dispatchEvent(new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: true
                }));
            };
        }
    }
    actions.push({
        text: `No answer from your wallet received yet. Please make sure the wallet is open.`,
        isBold: true
    });
    actions.push({
        text: 'Wallet not receiving request?',
        actionText: 'Reset Connection',
        actionCallback: async ()=>{
            (0, $cf61b77dbdb95489$export$c96659240d08478b)();
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const resetCallback = data.extraInfo.resetCallback;
            if (resetCallback) {
                $0b587c8852746f57$var$logger.log('showSentToast', 'resetCallback invoked');
                await resetCallback();
            }
        }
    });
    actions.push({
        text: 'Do you wish to report a bug?',
        actionText: 'Open',
        actionCallback: async ()=>{
            (0, $cf61b77dbdb95489$export$c96659240d08478b)();
            (0, $cf61b77dbdb95489$export$3a3f4d84f6f396b9)();
        }
    });
    (0, $cf61b77dbdb95489$export$39c365eaabfb0a68)({
        body: `Request sent to\u00A0 {{wallet}}`,
        walletInfo: data.walletInfo,
        state: 'loading',
        timer: (0, $cf61b77dbdb95489$export$d53806e03704a04e)(window) ? $0b587c8852746f57$var$SUCCESS_TIMER : 0,
        actions: actions,
        openWalletAction: openWalletAction
    });
};
const $0b587c8852746f57$var$showAcknowledgedToast = async (data)=>{
    (0, $cf61b77dbdb95489$export$39c365eaabfb0a68)({
        body: 'Awaiting confirmation in\u00A0 {{wallet}}',
        state: 'acknowledge',
        walletInfo: data.walletInfo
    });
};
const $0b587c8852746f57$var$showPrepare = async (data)=>{
    const text = data.walletInfo ? `Preparing Request for\u00A0 {{wallet}}...` : 'Preparing Request...';
    (0, $cf61b77dbdb95489$export$39c365eaabfb0a68)({
        body: text,
        state: 'prepare',
        walletInfo: data.walletInfo
    });
};
const $0b587c8852746f57$var$hideUI = (elements)=>{
    if (elements?.includes('alert')) (0, $cf61b77dbdb95489$export$3e63366088f78025)();
    if (elements?.includes('toast') || !elements) (0, $cf61b77dbdb95489$export$c96659240d08478b)();
};
/**
 * Show a "No Permission" alert
 */ const $0b587c8852746f57$var$showNoPermissionAlert = async ()=>{
    (0, $cf61b77dbdb95489$export$a91ff26452e0a161)({
        title: 'No Permission',
        body: 'Please allow the wallet to handle this type of request.'
    });
};
/**
 * Show an "Invalid state" alert
 */ const $0b587c8852746f57$var$showInvalidActiveAccountState = async ()=>{
    (0, $cf61b77dbdb95489$export$a91ff26452e0a161)({
        title: 'Invalid state',
        body: `An active account has been received, but no active subscription was found for BeaconEvent.ACTIVE_ACCOUNT_SET.
    For more information, visit: https://docs.walletbeacon.io/guides/migration-guide`
    });
};
/**
 * Show an "account deactivated" error alert
 */ const $0b587c8852746f57$var$showInvalidAccountDeactivated = async ()=>{
    await (0, $cf61b77dbdb95489$export$a91ff26452e0a161)({
        title: 'Error',
        body: `Your session has expired. Please pair with your wallet again.`
    });
};
/**
 * Show an "Invalid state" alert
 */ const $0b587c8852746f57$var$showGenericErrorAlert = async (errorMessage)=>{
    (0, $cf61b77dbdb95489$export$a91ff26452e0a161)({
        title: `${errorMessage}`,
        body: 'Please try again. If this problem persists please send us a bug report.',
        buttons: [
            {
                label: 'Send Report',
                type: 'primary',
                onClick: ()=>(0, $cf61b77dbdb95489$export$3a3f4d84f6f396b9)()
            }
        ]
    });
};
/**
 * Show an error toast
 *
 * @param beaconError The beacon error
 */ const $0b587c8852746f57$var$showErrorToast = async (response, buttons)=>{
    const error = response.errorResponse.errorType ? (0, $3797c71f856a2ed6$export$2e2bcd8739ae039)(response.errorResponse.errorType, response.errorResponse.errorData) : new (0, $4e2584c02ef3f2b6$export$c9a8ac1e67341255)();
    const actions = [
        {
            text: error.title,
            isBold: true
        }
    ];
    if (response.errorResponse.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).TRANSACTION_INVALID_ERROR && response.errorResponse.errorData) {
        const err = response.errorResponse.errorData;
        const errorMessages = response.errorMessages;
        let hasHumandReadableError = false;
        if (err[0]?.contract_handle && errorMessages && errorMessages?.[err[0].contract_handle]) {
            const errCode = err[1]?.with?.int ?? err[1]?.with?.string;
            const contractErrors = errorMessages?.[err[0].contract_handle];
            if (errCode && contractErrors?.[errCode]) {
                actions.push({
                    text: contractErrors?.[errCode],
                    isBold: true
                });
                hasHumandReadableError = true;
            }
        }
        if (!hasHumandReadableError) actions.push({
            text: error.description
        });
        actions.push({
            text: '',
            actionText: 'Show Details',
            actionCallback: async ()=>{
                (0, $cf61b77dbdb95489$export$c96659240d08478b)();
                (0, $cf61b77dbdb95489$export$a91ff26452e0a161)({
                    title: error.title,
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    body: error.fullDescription.description,
                    data: error.fullDescription.data,
                    buttons: buttons
                });
            }
        });
    }
    (0, $cf61b77dbdb95489$export$39c365eaabfb0a68)({
        body: `{{wallet}}\u00A0 has returned an error`,
        timer: response.errorResponse.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR ? $0b587c8852746f57$var$SUCCESS_TIMER : undefined,
        state: 'finished',
        walletInfo: response.walletInfo,
        actions: actions
    });
};
/**
 * Show a rate limit reached toast
 */ const $0b587c8852746f57$var$showRateLimitReached = async ()=>{
    (0, $cf61b77dbdb95489$export$a91ff26452e0a161)({
        title: 'Error',
        body: 'Rate limit reached. Please slow down',
        buttons: [
            {
                text: 'Done',
                style: 'outline'
            }
        ],
        timer: 3000
    });
};
/**
 * Show a "connection successful" alert for 1.5 seconds
 */ const $0b587c8852746f57$var$showExtensionConnectedAlert = ()=>{
    (0, $cf61b77dbdb95489$export$3e63366088f78025)();
};
const $0b587c8852746f57$var$showBugReportForm = async ()=>{
    await (0, $cf61b77dbdb95489$export$3a3f4d84f6f396b9)();
};
const $0b587c8852746f57$var$showRelayerErrorAlert = async ()=>{
    (0, $cf61b77dbdb95489$export$a91ff26452e0a161)({
        title: 'Error',
        body: `Failed to connect to the relayer. Please check that your system time is synchronized with the current time and reload the page.`,
        buttons: [
            {
                text: 'Done',
                style: 'outline'
            }
        ],
        timer: 1500
    });
};
/**
 * Show a "channel closed" alert for 1.5 seconds
 */ const $0b587c8852746f57$var$showChannelClosedAlert = async ()=>{
// openAlert({
//   title: 'Channel closed',
//   body: `Your peer has closed the connection.`,
//   buttons: [{ text: 'Done', style: 'outline' }],
//   timer: 1500
// })
};
const $0b587c8852746f57$var$showInternalErrorAlert = async (data)=>{
    const buttons = [
        ...data.buttons ?? []
    ];
    buttons.push({
        text: 'Done',
        style: 'outline'
    });
    const alertConfig = {
        title: 'Internal Error',
        body: data.text,
        buttons: buttons
    };
    (0, $cf61b77dbdb95489$export$a91ff26452e0a161)(alertConfig);
};
/**
 * Show a connect alert with QR code
 *
 * @param data The data that is emitted by the PAIR_INIT event
 */ const $0b587c8852746f57$var$showPairAlert = async (data)=>{
    $0b587c8852746f57$var$logger.log('showPairAlert');
    const alertConfig = {
        title: 'Choose your preferred wallet',
        body: `<p></p>`,
        pairingPayload: {
            p2pSyncCode: data.p2pPeerInfo,
            walletConnectSyncCode: data.walletConnectPeerInfo,
            postmessageSyncCode: data.postmessagePeerInfo,
            networkType: data.networkType
        },
        // eslint-disable-next-line @typescript-eslint/unbound-method
        closeButtonCallback: data.abortedHandler,
        disclaimerText: data.disclaimerText,
        analytics: data.analytics,
        featuredWallets: data.featuredWallets,
        substratePairing: data.substratePairing
    };
    (0, $cf61b77dbdb95489$export$a91ff26452e0a161)(alertConfig);
};
/**
 * Show a "Permission Granted" alert
 *
 * @param data The data that is emitted by the PERMISSION_REQUEST_SUCCESS event
 */ const $0b587c8852746f57$var$showPermissionSuccessAlert = async (data)=>{
    const { output: output } = data;
    const actions = [
        {
            text: 'Address',
            actionText: (0, $e9c0aef9005508c3$export$b139bd30bc162c86)(output.address),
            isBold: true
        }
    ];
    if (output.network.type !== 'substrate') {
        actions.push({
            text: 'Network',
            actionText: `${output.network.type}`
        });
        actions.push({
            text: 'Permissions',
            actionText: output.scopes.join(', ')
        });
    }
    (0, $cf61b77dbdb95489$export$39c365eaabfb0a68)({
        body: `{{wallet}}\u00A0 has granted permission`,
        timer: $0b587c8852746f57$var$SUCCESS_TIMER,
        walletInfo: data.walletInfo,
        state: 'finished',
        actions: actions
    });
};
const $0b587c8852746f57$var$showProofOfEventChallengeSuccessAlert = async (data)=>{
    const { output: output } = data;
    (0, $cf61b77dbdb95489$export$39c365eaabfb0a68)({
        body: `{{wallet}}\u00A0 has ${output.isAccepted ? 'accepted' : 'refused'} the challenge`,
        timer: $0b587c8852746f57$var$SUCCESS_TIMER,
        walletInfo: data.walletInfo,
        state: 'finished',
        actions: output.isAccepted ? [
            {
                text: `Payload hash: ${output.payloadHash}`,
                actionText: 'Copy to clipboard',
                actionCallback: async ()=>{
                    navigator.clipboard.writeText(output.payloadHash).then(()=>{
                        $0b587c8852746f57$var$logger.log('showSignSuccessAlert', 'Copying to clipboard was successful!');
                    }, (err)=>{
                        $0b587c8852746f57$var$logger.error('showSignSuccessAlert', 'Could not copy text to clipboard: ', err);
                    });
                    (0, $cf61b77dbdb95489$export$c96659240d08478b)();
                }
            }
        ] : []
    });
};
const $0b587c8852746f57$var$showSimulatedProofOfEventChallengeSuccessAlert = async (data)=>{
    const { output: output } = data;
    (0, $cf61b77dbdb95489$export$39c365eaabfb0a68)({
        body: !output.errorMessage ? `{{wallet}}\u00A0 has returned the list of operation` : `{{wallet}}\u00A0 has returned an error`,
        timer: $0b587c8852746f57$var$SUCCESS_TIMER,
        walletInfo: data.walletInfo,
        state: 'finished',
        actions: !output.errorMessage ? [
            {
                text: 'Operation list',
                actionText: 'Copy to clipboard',
                actionCallback: async ()=>{
                    navigator.clipboard.writeText(output.operationsList).then(()=>{
                        $0b587c8852746f57$var$logger.log('showSignSuccessAlert', 'Copying to clipboard was successful!');
                    }, (err)=>{
                        $0b587c8852746f57$var$logger.error('showSignSuccessAlert', 'Could not copy text to clipboard: ', err);
                    });
                    (0, $cf61b77dbdb95489$export$c96659240d08478b)();
                }
            }
        ] : [
            {
                text: 'Error message',
                actionText: output.errorMessage
            }
        ]
    });
};
/**
 * Show an "Operation Broadcasted" alert
 *
 * @param data The data that is emitted by the OPERATION_REQUEST_SUCCESS event
 */ const $0b587c8852746f57$var$showOperationSuccessAlert = async (data)=>{
    const { account: account, output: output, blockExplorer: blockExplorer } = data;
    (0, $cf61b77dbdb95489$export$39c365eaabfb0a68)({
        body: `{{wallet}}\u00A0 successfully submitted operation`,
        timer: $0b587c8852746f57$var$SUCCESS_TIMER,
        state: 'finished',
        walletInfo: data.walletInfo,
        actions: [
            {
                text: (0, $e9c0aef9005508c3$export$b139bd30bc162c86)(output.transactionHash),
                isBold: true,
                actionText: `Open Blockexplorer`,
                actionLogo: 'external',
                actionCallback: async ()=>{
                    const link = await blockExplorer.getTransactionLink(output.transactionHash, account.network);
                    window.open(link, '_blank', 'noopener');
                    (0, $cf61b77dbdb95489$export$c96659240d08478b)();
                }
            }
        ]
    });
};
/**
 * Show a "Transaction Signed" alert
 *
 * @param data The data that is emitted by the SIGN_REQUEST_SUCCESS event
 */ const $0b587c8852746f57$var$showSignSuccessAlert = async (data)=>{
    const output = data.output;
    (0, $cf61b77dbdb95489$export$39c365eaabfb0a68)({
        body: `{{wallet}}\u00A0 successfully signed payload`,
        timer: $0b587c8852746f57$var$SUCCESS_TIMER,
        state: 'finished',
        walletInfo: data.walletInfo,
        actions: [
            {
                text: `Signature: ${(0, $e9c0aef9005508c3$export$b139bd30bc162c86)(output.signature)}`,
                actionText: 'Copy to clipboard',
                actionCallback: async ()=>{
                    navigator.clipboard.writeText(output.signature).then(()=>{
                        $0b587c8852746f57$var$logger.log('showSignSuccessAlert', 'Copying to clipboard was successful!');
                    }, (err)=>{
                        $0b587c8852746f57$var$logger.error('showSignSuccessAlert', 'Could not copy text to clipboard: ', err);
                    });
                    (0, $cf61b77dbdb95489$export$c96659240d08478b)();
                }
            }
        ]
    });
};
/**
 * Show a "Transaction Signed" alert
 *
 * @param data The data that is emitted by the ENCRYPT_REQUEST_SUCCESS event
 */ // TODO: ENCRYPTION
// const showEncryptSuccessAlert = async (
//   data: BeaconEventType[BeaconEvent.ENCRYPT_REQUEST_SUCCESS]
// ): Promise<void> => {
//   const output = data.output
//   openToast({
//     body: `{{wallet}}\u00A0 successfully ${
//       data.output.cryptoOperation === EncryptionOperation.ENCRYPT ? 'encrypted' : 'decrypted'
//     } payload`,
//     timer: SUCCESS_TIMER,
//     state: 'finished',
//     walletInfo: data.walletInfo,
//     actions: [
//       {
//         text: `Payload: <strong>${shortenString(output.payload)}</strong>`,
//         actionText: 'Copy to clipboard',
//         actionCallback: async (): Promise<void> => {
//           navigator.clipboard.writeText(output.payload).then(
//             () => {
//               logger.log('showSignSuccessAlert', 'Copying to clipboard was successful!')
//             },
//             (err) => {
//               logger.error('showSignSuccessAlert', 'Could not copy text to clipboard: ', err)
//             }
//           )
//           closeToast()
//         }
//       }
//     ]
//   })
// }
const $0b587c8852746f57$var$showBlockchainRequestSuccessToast = async (data)=>{
    (0, $cf61b77dbdb95489$export$39c365eaabfb0a68)({
        body: `{{wallet}}\u00A0 request successfully executed`,
        timer: $0b587c8852746f57$var$SUCCESS_TIMER,
        state: 'finished',
        walletInfo: data.walletInfo
    });
};
/**
 * Show a "Broadcasted" alert
 *
 * @param data The data that is emitted by the BROADCAST_REQUEST_SUCCESS event
 */ const $0b587c8852746f57$var$showBroadcastSuccessAlert = async (data)=>{
    const { network: network, output: output, blockExplorer: blockExplorer } = data;
    (0, $cf61b77dbdb95489$export$39c365eaabfb0a68)({
        body: `{{wallet}}\u00A0 successfully injected operation`,
        timer: $0b587c8852746f57$var$SUCCESS_TIMER,
        state: 'finished',
        walletInfo: data.walletInfo,
        actions: [
            {
                text: (0, $e9c0aef9005508c3$export$b139bd30bc162c86)(output.transactionHash),
                isBold: true,
                actionText: `Open Blockexplorer`,
                actionLogo: 'external',
                actionCallback: async ()=>{
                    const link = await blockExplorer.getTransactionLink(output.transactionHash, network);
                    window.open(link, '_blank', 'noopener');
                    (0, $cf61b77dbdb95489$export$c96659240d08478b)();
                }
            }
        ]
    });
};
const $0b587c8852746f57$var$emptyHandler = ()=>async ()=>{
    //
    };
const $0b587c8852746f57$export$5adc6eca9673555d = {
    [$0b587c8852746f57$export$8d08de21eea96a9c.PERMISSION_REQUEST_SENT]: $0b587c8852746f57$var$showSentToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.PERMISSION_REQUEST_SUCCESS]: $0b587c8852746f57$var$showPermissionSuccessAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.PERMISSION_REQUEST_ERROR]: $0b587c8852746f57$var$showErrorToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.PROOF_OF_EVENT_CHALLENGE_REQUEST_SENT]: $0b587c8852746f57$var$showSentToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS]: $0b587c8852746f57$var$showProofOfEventChallengeSuccessAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR]: $0b587c8852746f57$var$showErrorToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SENT]: $0b587c8852746f57$var$showSentToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS]: $0b587c8852746f57$var$showSimulatedProofOfEventChallengeSuccessAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR]: $0b587c8852746f57$var$showErrorToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.OPERATION_REQUEST_SENT]: $0b587c8852746f57$var$showSentToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.OPERATION_REQUEST_SUCCESS]: $0b587c8852746f57$var$showOperationSuccessAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.OPERATION_REQUEST_ERROR]: $0b587c8852746f57$var$showErrorToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.SIGN_REQUEST_SENT]: $0b587c8852746f57$var$showSentToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.SIGN_REQUEST_SUCCESS]: $0b587c8852746f57$var$showSignSuccessAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.SIGN_REQUEST_ERROR]: $0b587c8852746f57$var$showErrorToast,
    // TODO: ENCRYPTION
    // [BeaconEvent.ENCRYPT_REQUEST_SENT]: showSentToast,
    // [BeaconEvent.ENCRYPT_REQUEST_SUCCESS]: showEncryptSuccessAlert,
    // [BeaconEvent.ENCRYPT_REQUEST_ERROR]: showErrorToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.BROADCAST_REQUEST_SENT]: $0b587c8852746f57$var$showSentToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.BROADCAST_REQUEST_SUCCESS]: $0b587c8852746f57$var$showBroadcastSuccessAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.BROADCAST_REQUEST_ERROR]: $0b587c8852746f57$var$showErrorToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.ACKNOWLEDGE_RECEIVED]: $0b587c8852746f57$var$showAcknowledgedToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.LOCAL_RATE_LIMIT_REACHED]: $0b587c8852746f57$var$showRateLimitReached,
    [$0b587c8852746f57$export$8d08de21eea96a9c.NO_PERMISSIONS]: $0b587c8852746f57$var$showNoPermissionAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.ACTIVE_ACCOUNT_SET]: $0b587c8852746f57$var$emptyHandler(),
    [$0b587c8852746f57$export$8d08de21eea96a9c.ACTIVE_TRANSPORT_SET]: $0b587c8852746f57$var$emptyHandler(),
    [$0b587c8852746f57$export$8d08de21eea96a9c.INVALID_ACTIVE_ACCOUNT_STATE]: $0b587c8852746f57$var$showInvalidActiveAccountState,
    [$0b587c8852746f57$export$8d08de21eea96a9c.GENERIC_ERROR]: $0b587c8852746f57$var$showGenericErrorAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.INVALID_ACCOUNT_DEACTIVATED]: $0b587c8852746f57$var$showInvalidAccountDeactivated,
    [$0b587c8852746f57$export$8d08de21eea96a9c.SHOW_PREPARE]: $0b587c8852746f57$var$showPrepare,
    [$0b587c8852746f57$export$8d08de21eea96a9c.HIDE_UI]: $0b587c8852746f57$var$hideUI,
    [$0b587c8852746f57$export$8d08de21eea96a9c.PAIR_INIT]: $0b587c8852746f57$var$showPairAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.PAIR_SUCCESS]: $0b587c8852746f57$var$showExtensionConnectedAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.OPEN_BUG_REPORT]: $0b587c8852746f57$var$showBugReportForm,
    [$0b587c8852746f57$export$8d08de21eea96a9c.RELAYER_ERROR]: $0b587c8852746f57$var$showRelayerErrorAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.CHANNEL_CLOSED]: $0b587c8852746f57$var$showChannelClosedAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.INTERNAL_ERROR]: $0b587c8852746f57$var$showInternalErrorAlert,
    [$0b587c8852746f57$export$8d08de21eea96a9c.BLOCKCHAIN_REQUEST_SUCCESS]: $0b587c8852746f57$var$showBlockchainRequestSuccessToast,
    [$0b587c8852746f57$export$8d08de21eea96a9c.UNKNOWN]: $0b587c8852746f57$var$emptyHandler()
};
class $0b587c8852746f57$export$61dd0f845b797b20 {
    callbackMap = {
        [$0b587c8852746f57$export$8d08de21eea96a9c.PERMISSION_REQUEST_SENT]: [
            $0b587c8852746f57$export$5adc6eca9673555d.PERMISSION_REQUEST_SENT
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.PERMISSION_REQUEST_SUCCESS]: [
            $0b587c8852746f57$export$5adc6eca9673555d.PERMISSION_REQUEST_SUCCESS
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.PERMISSION_REQUEST_ERROR]: [
            $0b587c8852746f57$export$5adc6eca9673555d.PERMISSION_REQUEST_ERROR
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.PROOF_OF_EVENT_CHALLENGE_REQUEST_SENT]: [
            $0b587c8852746f57$export$5adc6eca9673555d.PERMISSION_REQUEST_SENT
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS]: [
            $0b587c8852746f57$export$5adc6eca9673555d.PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR]: [
            $0b587c8852746f57$export$5adc6eca9673555d.PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SENT]: [
            $0b587c8852746f57$export$5adc6eca9673555d.SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SENT
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS]: [
            $0b587c8852746f57$export$5adc6eca9673555d.SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR]: [
            $0b587c8852746f57$export$5adc6eca9673555d.SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.OPERATION_REQUEST_SENT]: [
            $0b587c8852746f57$export$5adc6eca9673555d.OPERATION_REQUEST_SENT
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.OPERATION_REQUEST_SUCCESS]: [
            $0b587c8852746f57$export$5adc6eca9673555d.OPERATION_REQUEST_SUCCESS
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.OPERATION_REQUEST_ERROR]: [
            $0b587c8852746f57$export$5adc6eca9673555d.OPERATION_REQUEST_ERROR
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.SIGN_REQUEST_SENT]: [
            $0b587c8852746f57$export$5adc6eca9673555d.SIGN_REQUEST_SENT
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.SIGN_REQUEST_SUCCESS]: [
            $0b587c8852746f57$export$5adc6eca9673555d.SIGN_REQUEST_SUCCESS
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.SIGN_REQUEST_ERROR]: [
            $0b587c8852746f57$export$5adc6eca9673555d.SIGN_REQUEST_ERROR
        ],
        // TODO: ENCRYPTION
        // [BeaconEvent.ENCRYPT_REQUEST_SENT]: [defaultEventCallbacks.ENCRYPT_REQUEST_SENT],
        // [BeaconEvent.ENCRYPT_REQUEST_SUCCESS]: [defaultEventCallbacks.ENCRYPT_REQUEST_SUCCESS],
        // [BeaconEvent.ENCRYPT_REQUEST_ERROR]: [defaultEventCallbacks.ENCRYPT_REQUEST_ERROR],
        [$0b587c8852746f57$export$8d08de21eea96a9c.BROADCAST_REQUEST_SENT]: [
            $0b587c8852746f57$export$5adc6eca9673555d.BROADCAST_REQUEST_SENT
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.BROADCAST_REQUEST_SUCCESS]: [
            $0b587c8852746f57$export$5adc6eca9673555d.BROADCAST_REQUEST_SUCCESS
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.BROADCAST_REQUEST_ERROR]: [
            $0b587c8852746f57$export$5adc6eca9673555d.BROADCAST_REQUEST_ERROR
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.BLOCKCHAIN_REQUEST_SUCCESS]: [
            $0b587c8852746f57$export$5adc6eca9673555d.BLOCKCHAIN_REQUEST_SUCCESS
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.ACKNOWLEDGE_RECEIVED]: [
            $0b587c8852746f57$export$5adc6eca9673555d.ACKNOWLEDGE_RECEIVED
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.LOCAL_RATE_LIMIT_REACHED]: [
            $0b587c8852746f57$export$5adc6eca9673555d.LOCAL_RATE_LIMIT_REACHED
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.NO_PERMISSIONS]: [
            $0b587c8852746f57$export$5adc6eca9673555d.NO_PERMISSIONS
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.ACTIVE_ACCOUNT_SET]: [
            $0b587c8852746f57$export$5adc6eca9673555d.ACTIVE_ACCOUNT_SET
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.ACTIVE_TRANSPORT_SET]: [
            $0b587c8852746f57$export$5adc6eca9673555d.ACTIVE_TRANSPORT_SET
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.INVALID_ACTIVE_ACCOUNT_STATE]: [
            $0b587c8852746f57$export$5adc6eca9673555d.INVALID_ACTIVE_ACCOUNT_STATE
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.GENERIC_ERROR]: [
            $0b587c8852746f57$var$showGenericErrorAlert
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.INVALID_ACCOUNT_DEACTIVATED]: [
            $0b587c8852746f57$export$5adc6eca9673555d.INVALID_ACCOUNT_DEACTIVATED
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.SHOW_PREPARE]: [
            $0b587c8852746f57$export$5adc6eca9673555d.SHOW_PREPARE
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.HIDE_UI]: [
            $0b587c8852746f57$export$5adc6eca9673555d.HIDE_UI
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.PAIR_INIT]: [
            $0b587c8852746f57$export$5adc6eca9673555d.PAIR_INIT
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.PAIR_SUCCESS]: [
            $0b587c8852746f57$export$5adc6eca9673555d.PAIR_SUCCESS
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.OPEN_BUG_REPORT]: [
            $0b587c8852746f57$var$showBugReportForm
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.CHANNEL_CLOSED]: [
            $0b587c8852746f57$export$5adc6eca9673555d.CHANNEL_CLOSED
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.INTERNAL_ERROR]: [
            $0b587c8852746f57$export$5adc6eca9673555d.INTERNAL_ERROR
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.RELAYER_ERROR]: [
            $0b587c8852746f57$export$5adc6eca9673555d.RELAYER_ERROR
        ],
        [$0b587c8852746f57$export$8d08de21eea96a9c.UNKNOWN]: [
            $0b587c8852746f57$export$5adc6eca9673555d.UNKNOWN
        ]
    };
    constructor(eventsToOverride = {}, overrideAll){
        if (overrideAll) this.setAllHandlers();
        this.overrideDefaults(eventsToOverride);
    }
    /**
     * A method to subscribe to a specific beacon event and register a callback
     *
     * @param event The event being emitted
     * @param eventCallback The callback that will be invoked
     */ async on(event, eventCallback) {
        const listeners = this.callbackMap[event] || [];
        listeners.push(eventCallback);
        this.callbackMap[event] = listeners;
    }
    /**
     * Emit a beacon event
     *
     * @param event The event being emitted
     * @param data The data to be emit
     */ async emit(event, data, eventCallback) {
        const listeners = this.callbackMap[event];
        if (listeners && listeners.length > 0) listeners.forEach(async (listener)=>{
            try {
                await listener(data, eventCallback);
            } catch (listenerError) {
                $0b587c8852746f57$var$logger.error(`error handling event ${event}`, listenerError);
            }
        });
    }
    /**
     * Override beacon event default callbacks. This can be used to disable default alert/toast behaviour
     *
     * @param eventsToOverride An object with the events to override
     */ overrideDefaults(eventsToOverride) {
        Object.keys(eventsToOverride).forEach((untypedEvent)=>{
            const eventType = untypedEvent;
            const event = eventsToOverride[eventType];
            if (event) this.callbackMap[eventType] = [
                event.handler
            ];
        });
    }
    /**
     * Set all event callbacks to a specific handler.
     */ setAllHandlers(handler) {
        Object.keys(this.callbackMap).forEach((untypedEvent)=>{
            const eventType = untypedEvent;
            this.callbackMap[eventType] = [];
            if (handler) this.callbackMap[eventType].push(handler);
            else this.callbackMap[eventType].push((...data)=>{
                $0b587c8852746f57$var$logger.log(untypedEvent, ...data);
            });
        });
    }
}







const $f67be757e09f85ed$export$404463f191aa95a1 = {
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BlockchainRequest]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).OPERATION_REQUEST_SENT,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).BLOCKCHAIN_REQUEST_SUCCESS,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).OPERATION_REQUEST_ERROR
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BlockchainResponse]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).PERMISSION_REQUEST_SENT,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).PERMISSION_REQUEST_SUCCESS,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).PERMISSION_REQUEST_ERROR
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionResponse]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).ProofOfEventChallengeRequest]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).PROOF_OF_EVENT_CHALLENGE_REQUEST_SENT,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).ProofOfEventChallengeResponse]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SimulatedProofOfEventChallengeRequest]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SENT,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_SUCCESS,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).SIMULATED_PROOF_OF_EVENT_CHALLENGE_REQUEST_ERROR
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SimulatedProofOfEventChallengeResponse]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).OperationRequest]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).OPERATION_REQUEST_SENT,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).OPERATION_REQUEST_SUCCESS,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).OPERATION_REQUEST_ERROR
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).OperationResponse]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SignPayloadRequest]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).SIGN_REQUEST_SENT,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).SIGN_REQUEST_SUCCESS,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).SIGN_REQUEST_ERROR
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SignPayloadResponse]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN
    },
    // TODO: ENCRYPTION
    // [BeaconMessageType.EncryptPayloadRequest]: {
    //   sent: BeaconEvent.ENCRYPT_REQUEST_SENT,
    //   success: BeaconEvent.ENCRYPT_REQUEST_SUCCESS,
    //   error: BeaconEvent.ENCRYPT_REQUEST_ERROR
    // },
    // [BeaconMessageType.EncryptPayloadResponse]: {
    //   sent: BeaconEvent.UNKNOWN,
    //   success: BeaconEvent.UNKNOWN,
    //   error: BeaconEvent.UNKNOWN
    // },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BroadcastRequest]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).BROADCAST_REQUEST_SENT,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).BROADCAST_REQUEST_SUCCESS,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).BROADCAST_REQUEST_ERROR
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BroadcastResponse]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).ChangeAccountRequest]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Acknowledge]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Disconnect]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN
    },
    [(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Error]: {
        sent: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        success: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN,
        error: (0, $0b587c8852746f57$export$8d08de21eea96a9c).UNKNOWN
    }
};



class $25c511c856dc2eb1$export$82ed714956b51ba3 {
    rpcUrls;
    constructor(rpcUrls){
        this.rpcUrls = rpcUrls;
    }
    async getLinkForNetwork(network) {
        return this.rpcUrls[network.type];
    }
}


class $7b8b53b866777765$export$442259b92d03942a extends (0, $25c511c856dc2eb1$export$82ed714956b51ba3) {
    rpcUrls;
    constructor(rpcUrls = {
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).MAINNET]: 'https://tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).GHOSTNET]: 'https://ghostnet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).WEEKLYNET]: 'https://weeklynet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).DAILYNET]: 'https://dailynet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).DELPHINET]: 'https://delphinet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).EDONET]: 'https://edonet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).FLORENCENET]: 'https://florencenet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).GRANADANET]: 'https://granadanet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).HANGZHOUNET]: 'https://hangzhounet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).ITHACANET]: 'https://ithacanet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).JAKARTANET]: 'https://jakartanet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).KATHMANDUNET]: 'https://kathmandunet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).LIMANET]: 'https://limanet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).MUMBAINET]: 'https://mumbainet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).NAIROBINET]: 'https://nairobinet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).OXFORDNET]: 'https://oxfordnet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).PARISNET]: 'https://parisnet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).CUSTOM]: 'https://seoulnet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).QUEBECNET]: 'https://quebecnet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).RIONET]: 'https://rionet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).SEOULNET]: 'https://seoulnet.tzkt.io',
        [(0, $3ebc4504403abbff$export$4a868a35d3b57055).SHADOWNET]: 'https://shadownet.tzkt.io'
    }){
        super(rpcUrls);
        this.rpcUrls = rpcUrls;
    }
    async getAddressLink(address, network) {
        const blockExplorer = await this.getLinkForNetwork(network);
        return `${blockExplorer}/${address}`;
    }
    async getTransactionLink(transactionId, network) {
        const blockExplorer = await this.getLinkForNetwork(network);
        return `${blockExplorer}/${transactionId}`;
    }
}






const $2287499d8335a19b$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('DappPostMessageTransport');
class $2287499d8335a19b$export$19e7f83c69b45796 extends (0, $6c4533a0ab3f42b7$export$9a11a09f0f7983f7) {
    constructor(name, keyPair, storage){
        super(name, keyPair, storage, (0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_POSTMESSAGE_PEERS_DAPP);
    }
    async startOpenChannelListener() {
        return this.client.listenForChannelOpening(async (peer)=>{
            $2287499d8335a19b$var$logger.log('connect', `received PostMessagePairingResponse`, peer);
            await this.addPeer(peer);
            this._isConnected = (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).CONNECTED;
            if (this.newPeerListener) {
                this.newPeerListener(peer);
                this.newPeerListener = undefined; // TODO: Remove this once we use the id
            }
        });
    }
    async listenForNewPeer(newPeerListener) {
        $2287499d8335a19b$var$logger.log('listenForNewPeer');
        this.newPeerListener = newPeerListener;
    }
    async stopListeningForNewPeers() {
        $2287499d8335a19b$var$logger.log('stopListeningForNewPeers');
        this.newPeerListener = undefined;
    }
}





const $d6f4097412eef67b$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('DappP2PTransport');
class $d6f4097412eef67b$export$19867205fe4e985f extends (0, $3d81b3dc1d4c3571$export$f05ea4a0ac7b2e6c) {
    constructor(name, keyPair, storage, matrixNodes, iconUrl, appUrl){
        super(name, keyPair, storage, matrixNodes, (0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_P2P_PEERS_DAPP, iconUrl, appUrl);
    }
    async startOpenChannelListener() {
        return this.client.listenForChannelOpening(async (peer)=>{
            $d6f4097412eef67b$var$logger.log('listenForNewPeer', `new publicKey`, peer.publicKey);
            await this.addPeer(peer);
            this._isConnected = (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).CONNECTED;
            if (this.newPeerListener) {
                this.newPeerListener(peer);
                this.newPeerListener = undefined; // TODO: Remove this once we use the id
            }
        });
    }
    async listenForNewPeer(newPeerListener) {
        $d6f4097412eef67b$var$logger.log('listenForNewPeer');
        this.newPeerListener = newPeerListener;
    }
    async stopListeningForNewPeers() {
        $d6f4097412eef67b$var$logger.log('stopListeningForNewPeers');
        this.newPeerListener = undefined;
    }
}






var $7etJZ = parcelRequire("7etJZ");

var $7etJZ = parcelRequire("7etJZ");
var $7c6109395b060f04$exports = {};
"use strict";
Object.defineProperty($7c6109395b060f04$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("9EePZ")), $7c6109395b060f04$exports);

$7WQrb.__exportStar((parcelRequire("iD73S")), $7c6109395b060f04$exports);

$7WQrb.__exportStar((parcelRequire("dTXLC")), $7c6109395b060f04$exports);

$7WQrb.__exportStar((parcelRequire("2MWZl")), $7c6109395b060f04$exports);


class $2dd102fe42a3c147$export$ab429ec7e240e546 {
}




class $1b66579f2b4dad8b$export$d31d5212998928bd extends (0, $2dd102fe42a3c147$export$ab429ec7e240e546) {
    constructor(e){
        super();
    }
}
const $1b66579f2b4dad8b$export$31c453b5fe09788d = (0, $7c6109395b060f04$exports.FIVE_SECONDS), $1b66579f2b4dad8b$export$f3340c1af6bee4b5 = {
    pulse: "heartbeat_pulse"
};
class $1b66579f2b4dad8b$export$996c9b2cd7645b55 extends $1b66579f2b4dad8b$export$d31d5212998928bd {
    constructor(e){
        super(e), this.events = new (0, $7etJZ.EventEmitter), this.interval = $1b66579f2b4dad8b$export$31c453b5fe09788d, this.interval = e?.interval || $1b66579f2b4dad8b$export$31c453b5fe09788d;
    }
    static async init(e) {
        const t = new $1b66579f2b4dad8b$export$996c9b2cd7645b55(e);
        return await t.init(), t;
    }
    async init() {
        await this.initialize();
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async initialize() {
        this.intervalRef = setInterval(()=>this.pulse(), (0, $7c6109395b060f04$exports.toMiliseconds)(this.interval));
    }
    pulse() {
        this.events.emit($1b66579f2b4dad8b$export$f3340c1af6bee4b5.pulse);
    }
}


const $d3904a4891ee1c9a$var$suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
const $d3904a4891ee1c9a$var$suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
const $d3904a4891ee1c9a$var$JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $d3904a4891ee1c9a$var$jsonParseTransform(key, value) {
    if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
        $d3904a4891ee1c9a$var$warnKeyDropped(key);
        return;
    }
    return value;
}
function $d3904a4891ee1c9a$var$warnKeyDropped(key) {
    console.warn(`[destr] Dropping "${key}" key to prevent prototype pollution.`);
}
function $d3904a4891ee1c9a$export$2e2bcd8739ae039(value, options = {}) {
    if (typeof value !== "string") return value;
    if (value[0] === '"' && value[value.length - 1] === '"' && value.indexOf("\\") === -1) return value.slice(1, -1);
    const _value = value.trim();
    if (_value.length <= 9) switch(_value.toLowerCase()){
        case "true":
            return true;
        case "false":
            return false;
        case "undefined":
            return void 0;
        case "null":
            return null;
        case "nan":
            return Number.NaN;
        case "infinity":
            return Number.POSITIVE_INFINITY;
        case "-infinity":
            return Number.NEGATIVE_INFINITY;
    }
    if (!$d3904a4891ee1c9a$var$JsonSigRx.test(value)) {
        if (options.strict) throw new SyntaxError("[destr] Invalid JSON");
        return value;
    }
    try {
        if ($d3904a4891ee1c9a$var$suspectProtoRx.test(value) || $d3904a4891ee1c9a$var$suspectConstructorRx.test(value)) {
            if (options.strict) throw new Error("[destr] Possible prototype pollution");
            return JSON.parse(value, $d3904a4891ee1c9a$var$jsonParseTransform);
        }
        return JSON.parse(value);
    } catch (error) {
        if (options.strict) throw error;
        return value;
    }
}
function $d3904a4891ee1c9a$export$4b2a7c187ff4b28c(value, options = {}) {
    return $d3904a4891ee1c9a$export$2e2bcd8739ae039(value, {
        ...options,
        strict: true
    });
}



var $6ZWSX = parcelRequire("6ZWSX");
var $3820ed7f5c64e381$require$Buffer = $6ZWSX.Buffer;
function $3820ed7f5c64e381$var$wrapToPromise(value) {
    if (!value || typeof value.then !== "function") return Promise.resolve(value);
    return value;
}
function $3820ed7f5c64e381$export$8b22cf2602fb60ce(function_, ...arguments_) {
    try {
        return $3820ed7f5c64e381$var$wrapToPromise(function_(...arguments_));
    } catch (error) {
        return Promise.reject(error);
    }
}
function $3820ed7f5c64e381$var$isPrimitive(value) {
    const type = typeof value;
    return value === null || type !== "object" && type !== "function";
}
function $3820ed7f5c64e381$var$isPureObject(value) {
    const proto = Object.getPrototypeOf(value);
    return !proto || proto.isPrototypeOf(Object);
}
function $3820ed7f5c64e381$export$4368d992c4eafac0(value) {
    if ($3820ed7f5c64e381$var$isPrimitive(value)) return String(value);
    if ($3820ed7f5c64e381$var$isPureObject(value) || Array.isArray(value)) return JSON.stringify(value);
    if (typeof value.toJSON === "function") return $3820ed7f5c64e381$export$4368d992c4eafac0(value.toJSON());
    throw new Error("[unstorage] Cannot stringify value!");
}
const $3820ed7f5c64e381$var$BASE64_PREFIX = "base64:";
function $3820ed7f5c64e381$export$2408f22a0fab9ae5(value) {
    if (typeof value === "string") return value;
    return $3820ed7f5c64e381$var$BASE64_PREFIX + $3820ed7f5c64e381$var$base64Encode(value);
}
function $3820ed7f5c64e381$export$f1e1789686576879(value) {
    if (typeof value !== "string") return value;
    if (!value.startsWith($3820ed7f5c64e381$var$BASE64_PREFIX)) return value;
    return $3820ed7f5c64e381$var$base64Decode(value.slice($3820ed7f5c64e381$var$BASE64_PREFIX.length));
}
function $3820ed7f5c64e381$var$base64Decode(input) {
    if (globalThis.Buffer) return $3820ed7f5c64e381$require$Buffer.from(input, "base64");
    return Uint8Array.from(globalThis.atob(input), (c)=>c.codePointAt(0));
}
function $3820ed7f5c64e381$var$base64Encode(input) {
    if (globalThis.Buffer) return $3820ed7f5c64e381$require$Buffer.from(input).toString("base64");
    return globalThis.btoa(String.fromCodePoint(...input));
}
const $3820ed7f5c64e381$var$storageKeyProperties = [
    "has",
    "hasItem",
    "get",
    "getItem",
    "getItemRaw",
    "set",
    "setItem",
    "setItemRaw",
    "del",
    "remove",
    "removeItem",
    "getMeta",
    "setMeta",
    "removeMeta",
    "getKeys",
    "clear",
    "mount",
    "unmount"
];
function $3820ed7f5c64e381$export$ffb5f4729a158638(storage, base) {
    base = $3820ed7f5c64e381$export$7ccc53e8f1e7dfc5(base);
    if (!base) return storage;
    const nsStorage = {
        ...storage
    };
    for (const property of $3820ed7f5c64e381$var$storageKeyProperties)nsStorage[property] = (key = "", ...args)=>// @ts-ignore
        storage[property](base + key, ...args);
    nsStorage.getKeys = (key = "", ...arguments_)=>storage.getKeys(base + key, ...arguments_).then((keys)=>keys.map((key2)=>key2.slice(base.length)));
    nsStorage.keys = nsStorage.getKeys;
    nsStorage.getItems = async (items, commonOptions)=>{
        const prefixedItems = items.map((item)=>typeof item === "string" ? base + item : {
                ...item,
                key: base + item.key
            });
        const results = await storage.getItems(prefixedItems, commonOptions);
        return results.map((entry)=>({
                key: entry.key.slice(base.length),
                value: entry.value
            }));
    };
    nsStorage.setItems = async (items, commonOptions)=>{
        const prefixedItems = items.map((item)=>({
                key: base + item.key,
                value: item.value,
                options: item.options
            }));
        return storage.setItems(prefixedItems, commonOptions);
    };
    return nsStorage;
}
function $3820ed7f5c64e381$export$407448d2b89b1813(key) {
    if (!key) return "";
    return key.split("?")[0]?.replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "") || "";
}
function $3820ed7f5c64e381$export$35e795649ee09318(...keys) {
    return $3820ed7f5c64e381$export$407448d2b89b1813(keys.join(":"));
}
function $3820ed7f5c64e381$export$7ccc53e8f1e7dfc5(base) {
    base = $3820ed7f5c64e381$export$407448d2b89b1813(base);
    return base ? base + ":" : "";
}
function $3820ed7f5c64e381$export$2d1720544b23b823(key, depth) {
    if (depth === void 0) return true;
    let substrCount = 0;
    let index = key.indexOf(":");
    while(index > -1){
        substrCount++;
        index = key.indexOf(":", index + 1);
    }
    return substrCount <= depth;
}
function $3820ed7f5c64e381$export$db3b6bfb95261072(key, base) {
    if (base) return key.startsWith(base) && key[key.length - 1] !== "$";
    return key[key.length - 1] !== "$";
}


function $20f36d051f0d8a54$export$b5cf55d52d4cddb(factory) {
    return factory;
}
const $20f36d051f0d8a54$var$DRIVER_NAME = "memory";
const $20f36d051f0d8a54$var$memory = $20f36d051f0d8a54$export$b5cf55d52d4cddb(()=>{
    const data = /* @__PURE__ */ new Map();
    return {
        name: $20f36d051f0d8a54$var$DRIVER_NAME,
        getInstance: ()=>data,
        hasItem (key) {
            return data.has(key);
        },
        getItem (key) {
            return data.get(key) ?? null;
        },
        getItemRaw (key) {
            return data.get(key) ?? null;
        },
        setItem (key, value) {
            data.set(key, value);
        },
        setItemRaw (key, value) {
            data.set(key, value);
        },
        removeItem (key) {
            data.delete(key);
        },
        getKeys () {
            return [
                ...data.keys()
            ];
        },
        clear () {
            data.clear();
        },
        dispose () {
            data.clear();
        }
    };
});
function $20f36d051f0d8a54$export$d184a47a971dd4b9(options = {}) {
    const context = {
        mounts: {
            "": options.driver || $20f36d051f0d8a54$var$memory()
        },
        mountpoints: [
            ""
        ],
        watching: false,
        watchListeners: [],
        unwatch: {}
    };
    const getMount = (key)=>{
        for (const base of context.mountpoints){
            if (key.startsWith(base)) return {
                base: base,
                relativeKey: key.slice(base.length),
                driver: context.mounts[base]
            };
        }
        return {
            base: "",
            relativeKey: key,
            driver: context.mounts[""]
        };
    };
    const getMounts = (base, includeParent)=>{
        return context.mountpoints.filter((mountpoint)=>mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint)).map((mountpoint)=>({
                relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
                mountpoint: mountpoint,
                driver: context.mounts[mountpoint]
            }));
    };
    const onChange = (event, key)=>{
        if (!context.watching) return;
        key = (0, $3820ed7f5c64e381$export$407448d2b89b1813)(key);
        for (const listener of context.watchListeners)listener(event, key);
    };
    const startWatch = async ()=>{
        if (context.watching) return;
        context.watching = true;
        for(const mountpoint in context.mounts)context.unwatch[mountpoint] = await $20f36d051f0d8a54$var$watch(context.mounts[mountpoint], onChange, mountpoint);
    };
    const stopWatch = async ()=>{
        if (!context.watching) return;
        for(const mountpoint in context.unwatch)await context.unwatch[mountpoint]();
        context.unwatch = {};
        context.watching = false;
    };
    const runBatch = (items, commonOptions, cb)=>{
        const batches = /* @__PURE__ */ new Map();
        const getBatch = (mount)=>{
            let batch = batches.get(mount.base);
            if (!batch) {
                batch = {
                    driver: mount.driver,
                    base: mount.base,
                    items: []
                };
                batches.set(mount.base, batch);
            }
            return batch;
        };
        for (const item of items){
            const isStringItem = typeof item === "string";
            const key = (0, $3820ed7f5c64e381$export$407448d2b89b1813)(isStringItem ? item : item.key);
            const value = isStringItem ? void 0 : item.value;
            const options2 = isStringItem || !item.options ? commonOptions : {
                ...commonOptions,
                ...item.options
            };
            const mount = getMount(key);
            getBatch(mount).items.push({
                key: key,
                value: value,
                relativeKey: mount.relativeKey,
                options: options2
            });
        }
        return Promise.all([
            ...batches.values()
        ].map((batch)=>cb(batch))).then((r)=>r.flat());
    };
    const storage = {
        // Item
        hasItem (key, opts = {}) {
            key = (0, $3820ed7f5c64e381$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.hasItem, relativeKey, opts);
        },
        getItem (key, opts = {}) {
            key = (0, $3820ed7f5c64e381$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.getItem, relativeKey, opts).then((value)=>(0, $d3904a4891ee1c9a$export$2e2bcd8739ae039)(value));
        },
        getItems (items, commonOptions = {}) {
            return runBatch(items, commonOptions, (batch)=>{
                if (batch.driver.getItems) return (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(batch.driver.getItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        options: item.options
                    })), commonOptions).then((r)=>r.map((item)=>({
                            key: (0, $3820ed7f5c64e381$export$35e795649ee09318)(batch.base, item.key),
                            value: (0, $d3904a4891ee1c9a$export$2e2bcd8739ae039)(item.value)
                        })));
                return Promise.all(batch.items.map((item)=>{
                    return (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(batch.driver.getItem, item.relativeKey, item.options).then((value)=>({
                            key: item.key,
                            value: (0, $d3904a4891ee1c9a$export$2e2bcd8739ae039)(value)
                        }));
                }));
            });
        },
        getItemRaw (key, opts = {}) {
            key = (0, $3820ed7f5c64e381$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.getItemRaw) return (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.getItemRaw, relativeKey, opts);
            return (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.getItem, relativeKey, opts).then((value)=>(0, $3820ed7f5c64e381$export$f1e1789686576879)(value));
        },
        async setItem (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key);
            key = (0, $3820ed7f5c64e381$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.setItem) return;
            await (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.setItem, relativeKey, (0, $3820ed7f5c64e381$export$4368d992c4eafac0)(value), opts);
            if (!driver.watch) onChange("update", key);
        },
        async setItems (items, commonOptions) {
            await runBatch(items, commonOptions, async (batch)=>{
                if (batch.driver.setItems) return (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(batch.driver.setItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        value: (0, $3820ed7f5c64e381$export$4368d992c4eafac0)(item.value),
                        options: item.options
                    })), commonOptions);
                if (!batch.driver.setItem) return;
                await Promise.all(batch.items.map((item)=>{
                    return (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(batch.driver.setItem, item.relativeKey, (0, $3820ed7f5c64e381$export$4368d992c4eafac0)(item.value), item.options);
                }));
            });
        },
        async setItemRaw (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key, opts);
            key = (0, $3820ed7f5c64e381$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.setItemRaw) await (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.setItemRaw, relativeKey, value, opts);
            else if (driver.setItem) await (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.setItem, relativeKey, (0, $3820ed7f5c64e381$export$2408f22a0fab9ae5)(value), opts);
            else return;
            if (!driver.watch) onChange("update", key);
        },
        async removeItem (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                removeMeta: opts
            };
            key = (0, $3820ed7f5c64e381$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.removeItem) return;
            await (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.removeItem, relativeKey, opts);
            if (opts.removeMeta || opts.removeMata) await (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.removeItem, relativeKey + "$", opts);
            if (!driver.watch) onChange("remove", key);
        },
        // Meta
        async getMeta (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                nativeOnly: opts
            };
            key = (0, $3820ed7f5c64e381$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            const meta = /* @__PURE__ */ Object.create(null);
            if (driver.getMeta) Object.assign(meta, await (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.getMeta, relativeKey, opts));
            if (!opts.nativeOnly) {
                const value = await (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.getItem, relativeKey + "$", opts).then((value_)=>(0, $d3904a4891ee1c9a$export$2e2bcd8739ae039)(value_));
                if (value && typeof value === "object") {
                    if (typeof value.atime === "string") value.atime = new Date(value.atime);
                    if (typeof value.mtime === "string") value.mtime = new Date(value.mtime);
                    Object.assign(meta, value);
                }
            }
            return meta;
        },
        setMeta (key, value, opts = {}) {
            return this.setItem(key + "$", value, opts);
        },
        removeMeta (key, opts = {}) {
            return this.removeItem(key + "$", opts);
        },
        // Keys
        async getKeys (base, opts = {}) {
            base = (0, $3820ed7f5c64e381$export$7ccc53e8f1e7dfc5)(base);
            const mounts = getMounts(base, true);
            let maskedMounts = [];
            const allKeys = [];
            let allMountsSupportMaxDepth = true;
            for (const mount of mounts){
                if (!mount.driver.flags?.maxDepth) allMountsSupportMaxDepth = false;
                const rawKeys = await (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(mount.driver.getKeys, mount.relativeBase, opts);
                for (const key of rawKeys){
                    const fullKey = mount.mountpoint + (0, $3820ed7f5c64e381$export$407448d2b89b1813)(key);
                    if (!maskedMounts.some((p)=>fullKey.startsWith(p))) allKeys.push(fullKey);
                }
                maskedMounts = [
                    mount.mountpoint,
                    ...maskedMounts.filter((p)=>!p.startsWith(mount.mountpoint))
                ];
            }
            const shouldFilterByDepth = opts.maxDepth !== void 0 && !allMountsSupportMaxDepth;
            return allKeys.filter((key)=>(!shouldFilterByDepth || (0, $3820ed7f5c64e381$export$2d1720544b23b823)(key, opts.maxDepth)) && (0, $3820ed7f5c64e381$export$db3b6bfb95261072)(key, base));
        },
        // Utils
        async clear (base, opts = {}) {
            base = (0, $3820ed7f5c64e381$export$7ccc53e8f1e7dfc5)(base);
            await Promise.all(getMounts(base, false).map(async (m)=>{
                if (m.driver.clear) return (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(m.driver.clear, m.relativeBase, opts);
                if (m.driver.removeItem) {
                    const keys = await m.driver.getKeys(m.relativeBase || "", opts);
                    return Promise.all(keys.map((key)=>m.driver.removeItem(key, opts)));
                }
            }));
        },
        async dispose () {
            await Promise.all(Object.values(context.mounts).map((driver)=>$20f36d051f0d8a54$var$dispose(driver)));
        },
        async watch (callback) {
            await startWatch();
            context.watchListeners.push(callback);
            return async ()=>{
                context.watchListeners = context.watchListeners.filter((listener)=>listener !== callback);
                if (context.watchListeners.length === 0) await stopWatch();
            };
        },
        async unwatch () {
            context.watchListeners = [];
            await stopWatch();
        },
        // Mount
        mount (base, driver) {
            base = (0, $3820ed7f5c64e381$export$7ccc53e8f1e7dfc5)(base);
            if (base && context.mounts[base]) throw new Error(`already mounted at ${base}`);
            if (base) {
                context.mountpoints.push(base);
                context.mountpoints.sort((a, b)=>b.length - a.length);
            }
            context.mounts[base] = driver;
            if (context.watching) Promise.resolve($20f36d051f0d8a54$var$watch(driver, onChange, base)).then((unwatcher)=>{
                context.unwatch[base] = unwatcher;
            }).catch(console.error);
            return storage;
        },
        async unmount (base, _dispose = true) {
            base = (0, $3820ed7f5c64e381$export$7ccc53e8f1e7dfc5)(base);
            if (!base || !context.mounts[base]) return;
            if (context.watching && base in context.unwatch) {
                context.unwatch[base]?.();
                delete context.unwatch[base];
            }
            if (_dispose) await $20f36d051f0d8a54$var$dispose(context.mounts[base]);
            context.mountpoints = context.mountpoints.filter((key)=>key !== base);
            delete context.mounts[base];
        },
        getMount (key = "") {
            key = (0, $3820ed7f5c64e381$export$407448d2b89b1813)(key) + ":";
            const m = getMount(key);
            return {
                driver: m.driver,
                base: m.base
            };
        },
        getMounts (base = "", opts = {}) {
            base = (0, $3820ed7f5c64e381$export$407448d2b89b1813)(base);
            const mounts = getMounts(base, opts.parents);
            return mounts.map((m)=>({
                    driver: m.driver,
                    base: m.mountpoint
                }));
        },
        // Aliases
        keys: (base, opts = {})=>storage.getKeys(base, opts),
        get: (key, opts = {})=>storage.getItem(key, opts),
        set: (key, value, opts = {})=>storage.setItem(key, value, opts),
        has: (key, opts = {})=>storage.hasItem(key, opts),
        del: (key, opts = {})=>storage.removeItem(key, opts),
        remove: (key, opts = {})=>storage.removeItem(key, opts)
    };
    return storage;
}
async function $20f36d051f0d8a54$export$b8801ea43165ed7d(storage, base) {
    base = (0, $3820ed7f5c64e381$export$7ccc53e8f1e7dfc5)(base);
    const keys = await storage.getKeys(base);
    const snapshot2 = {};
    await Promise.all(keys.map(async (key)=>{
        snapshot2[key.slice(base.length)] = await storage.getItem(key);
    }));
    return snapshot2;
}
async function $20f36d051f0d8a54$export$11e5d4541284dd1e(driver, snapshot2, base = "") {
    base = (0, $3820ed7f5c64e381$export$7ccc53e8f1e7dfc5)(base);
    await Promise.all(Object.entries(snapshot2).map((e)=>driver.setItem(base + e[0], e[1])));
}
function $20f36d051f0d8a54$var$watch(driver, onChange, base) {
    return driver.watch ? driver.watch((event, key)=>onChange(event, base + key)) : ()=>{};
}
async function $20f36d051f0d8a54$var$dispose(driver) {
    if (typeof driver.dispose === "function") await (0, $3820ed7f5c64e381$export$8b22cf2602fb60ce)(driver.dispose);
}
const $20f36d051f0d8a54$export$108bed33247a8bd7 = {
    "azure-app-configuration": "unstorage/drivers/azure-app-configuration",
    "azureAppConfiguration": "unstorage/drivers/azure-app-configuration",
    "azure-cosmos": "unstorage/drivers/azure-cosmos",
    "azureCosmos": "unstorage/drivers/azure-cosmos",
    "azure-key-vault": "unstorage/drivers/azure-key-vault",
    "azureKeyVault": "unstorage/drivers/azure-key-vault",
    "azure-storage-blob": "unstorage/drivers/azure-storage-blob",
    "azureStorageBlob": "unstorage/drivers/azure-storage-blob",
    "azure-storage-table": "unstorage/drivers/azure-storage-table",
    "azureStorageTable": "unstorage/drivers/azure-storage-table",
    "capacitor-preferences": "unstorage/drivers/capacitor-preferences",
    "capacitorPreferences": "unstorage/drivers/capacitor-preferences",
    "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
    "cloudflareKVBinding": "unstorage/drivers/cloudflare-kv-binding",
    "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http",
    "cloudflareKVHttp": "unstorage/drivers/cloudflare-kv-http",
    "cloudflare-r2-binding": "unstorage/drivers/cloudflare-r2-binding",
    "cloudflareR2Binding": "unstorage/drivers/cloudflare-r2-binding",
    "db0": "unstorage/drivers/db0",
    "deno-kv-node": "unstorage/drivers/deno-kv-node",
    "denoKVNode": "unstorage/drivers/deno-kv-node",
    "deno-kv": "unstorage/drivers/deno-kv",
    "denoKV": "unstorage/drivers/deno-kv",
    "fs-lite": "unstorage/drivers/fs-lite",
    "fsLite": "unstorage/drivers/fs-lite",
    "fs": "unstorage/drivers/fs",
    "github": "unstorage/drivers/github",
    "http": "unstorage/drivers/http",
    "indexedb": "unstorage/drivers/indexedb",
    "localstorage": "unstorage/drivers/localstorage",
    "lru-cache": "unstorage/drivers/lru-cache",
    "lruCache": "unstorage/drivers/lru-cache",
    "memory": "unstorage/drivers/memory",
    "mongodb": "unstorage/drivers/mongodb",
    "netlify-blobs": "unstorage/drivers/netlify-blobs",
    "netlifyBlobs": "unstorage/drivers/netlify-blobs",
    "null": "unstorage/drivers/null",
    "overlay": "unstorage/drivers/overlay",
    "planetscale": "unstorage/drivers/planetscale",
    "redis": "unstorage/drivers/redis",
    "s3": "unstorage/drivers/s3",
    "session-storage": "unstorage/drivers/session-storage",
    "sessionStorage": "unstorage/drivers/session-storage",
    "uploadthing": "unstorage/drivers/uploadthing",
    "upstash": "unstorage/drivers/upstash",
    "vercel-blob": "unstorage/drivers/vercel-blob",
    "vercelBlob": "unstorage/drivers/vercel-blob",
    "vercel-kv": "unstorage/drivers/vercel-kv",
    "vercelKV": "unstorage/drivers/vercel-kv",
    "vercel-runtime-cache": "unstorage/drivers/vercel-runtime-cache",
    "vercelRuntimeCache": "unstorage/drivers/vercel-runtime-cache"
};


function $816683f8c32a91e9$var$_slicedToArray(r, e) {
    return $816683f8c32a91e9$var$_arrayWithHoles(r) || $816683f8c32a91e9$var$_iterableToArrayLimit(r, e) || $816683f8c32a91e9$var$_unsupportedIterableToArray(r, e) || $816683f8c32a91e9$var$_nonIterableRest();
}
function $816683f8c32a91e9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $816683f8c32a91e9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $816683f8c32a91e9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $816683f8c32a91e9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $816683f8c32a91e9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $816683f8c32a91e9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $816683f8c32a91e9$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $816683f8c32a91e9$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        };
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $816683f8c32a91e9$export$f51a9068ac82ea43(dbName, storeName) {
    var dbp;
    var getDB = function getDB() {
        if (dbp) return dbp;
        var request = indexedDB.open(dbName);
        request.onupgradeneeded = function() {
            return request.result.createObjectStore(storeName);
        };
        dbp = $816683f8c32a91e9$export$b327150396135fe7(request);
        dbp.then(function(db) {
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = function() {
                return dbp = undefined;
            };
        }, function() {});
        return dbp;
    };
    return function(txMode, callback) {
        return getDB().then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $816683f8c32a91e9$var$defaultGetStoreFunc;
function $816683f8c32a91e9$var$defaultGetStore() {
    if (!$816683f8c32a91e9$var$defaultGetStoreFunc) $816683f8c32a91e9$var$defaultGetStoreFunc = $816683f8c32a91e9$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $816683f8c32a91e9$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return $816683f8c32a91e9$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.put(value, key);
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return Promise.all(keys.map(function(key) {
            return $816683f8c32a91e9$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        return(// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($816683f8c32a91e9$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.delete(key);
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.clear();
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
function $816683f8c32a91e9$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $816683f8c32a91e9$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $816683f8c32a91e9$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $816683f8c32a91e9$export$b327150396135fe7(store.getAll());
        var items = [];
        return $816683f8c32a91e9$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $816683f8c32a91e9$export$b327150396135fe7(store.getAllKeys()),
            $816683f8c32a91e9$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $816683f8c32a91e9$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore('readonly', function(store) {
            return $816683f8c32a91e9$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}


const $81c2e06d24b89184$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $81c2e06d24b89184$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, "$1\"$2n\"$3");
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $81c2e06d24b89184$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $81c2e06d24b89184$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $81c2e06d24b89184$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $81c2e06d24b89184$var$JSONStringify(value) || "";
}


function $5e575ac853f40acc$var$C(i) {
    return i;
}
const $5e575ac853f40acc$var$x = "idb-keyval";
var $5e575ac853f40acc$var$z = (i = {})=>{
    const t = i.base && i.base.length > 0 ? `${i.base}:` : "", e = (s)=>t + s;
    let n;
    return i.dbName && i.storeName && (n = (0, $816683f8c32a91e9$export$f51a9068ac82ea43)(i.dbName, i.storeName)), {
        name: $5e575ac853f40acc$var$x,
        options: i,
        async hasItem (s) {
            return !(typeof await (0, $816683f8c32a91e9$export$3988ae62b71be9a3)(e(s), n) > "u");
        },
        async getItem (s) {
            return await (0, $816683f8c32a91e9$export$3988ae62b71be9a3)(e(s), n) ?? null;
        },
        setItem (s, a) {
            return (0, $816683f8c32a91e9$export$adaa4cf7ef1b65be)(e(s), a, n);
        },
        removeItem (s) {
            return (0, $816683f8c32a91e9$export$1d2f21e549771e67)(e(s), n);
        },
        getKeys () {
            return (0, $816683f8c32a91e9$export$ed97f33186d4b816)(n);
        },
        clear () {
            return (0, $816683f8c32a91e9$export$42ffd38884aecdac)(n);
        }
    };
};
const $5e575ac853f40acc$var$D = "WALLET_CONNECT_V2_INDEXED_DB", $5e575ac853f40acc$var$E = "keyvaluestorage";
class $5e575ac853f40acc$var$_ {
    constructor(){
        this.indexedDb = (0, $20f36d051f0d8a54$export$d184a47a971dd4b9)({
            driver: $5e575ac853f40acc$var$z({
                dbName: $5e575ac853f40acc$var$D,
                storeName: $5e575ac853f40acc$var$E
            })
        });
    }
    async getKeys() {
        return this.indexedDb.getKeys();
    }
    async getEntries() {
        return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((t)=>[
                t.key,
                t.value
            ]);
    }
    async getItem(t) {
        const e = await this.indexedDb.getItem(t);
        if (e !== null) return e;
    }
    async setItem(t, e) {
        await this.indexedDb.setItem(t, (0, $81c2e06d24b89184$export$abc3f407e87918a4)(e));
    }
    async removeItem(t) {
        await this.indexedDb.removeItem(t);
    }
}
var $5e575ac853f40acc$var$l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $5e575ac853f40acc$var$c = {
    exports: {}
};
(function() {
    let i;
    function t() {}
    i = t, i.prototype.getItem = function(e) {
        return this.hasOwnProperty(e) ? String(this[e]) : null;
    }, i.prototype.setItem = function(e, n) {
        this[e] = String(n);
    }, i.prototype.removeItem = function(e) {
        delete this[e];
    }, i.prototype.clear = function() {
        const e = this;
        Object.keys(e).forEach(function(n) {
            e[n] = void 0, delete e[n];
        });
    }, i.prototype.key = function(e) {
        return e = e || 0, Object.keys(this)[e];
    }, i.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    }), typeof $5e575ac853f40acc$var$l < "u" && $5e575ac853f40acc$var$l.localStorage ? $5e575ac853f40acc$var$c.exports = $5e575ac853f40acc$var$l.localStorage : typeof window < "u" && window.localStorage ? $5e575ac853f40acc$var$c.exports = window.localStorage : $5e575ac853f40acc$var$c.exports = new t;
})();
function $5e575ac853f40acc$var$k(i) {
    var t;
    return [
        i[0],
        (0, $81c2e06d24b89184$export$84137bb44359aed5)((t = i[1]) != null ? t : "")
    ];
}
class $5e575ac853f40acc$var$K {
    constructor(){
        this.localStorage = $5e575ac853f40acc$var$c.exports;
    }
    async getKeys() {
        return Object.keys(this.localStorage);
    }
    async getEntries() {
        return Object.entries(this.localStorage).map($5e575ac853f40acc$var$k);
    }
    async getItem(t) {
        const e = this.localStorage.getItem(t);
        if (e !== null) return (0, $81c2e06d24b89184$export$84137bb44359aed5)(e);
    }
    async setItem(t, e) {
        this.localStorage.setItem(t, (0, $81c2e06d24b89184$export$abc3f407e87918a4)(e));
    }
    async removeItem(t) {
        this.localStorage.removeItem(t);
    }
}
const $5e575ac853f40acc$var$N = "wc_storage_version", $5e575ac853f40acc$var$y = 1, $5e575ac853f40acc$var$O = async (i, t, e)=>{
    const n = $5e575ac853f40acc$var$N, s = await t.getItem(n);
    if (s && s >= $5e575ac853f40acc$var$y) {
        e(t);
        return;
    }
    const a = await i.getKeys();
    if (!a.length) {
        e(t);
        return;
    }
    const m = [];
    for(; a.length;){
        const r = a.shift();
        if (!r) continue;
        const o = r.toLowerCase();
        if (o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect")) {
            const f = await i.getItem(r);
            await t.setItem(r, f), m.push(r);
        }
    }
    await t.setItem(n, $5e575ac853f40acc$var$y), e(t), $5e575ac853f40acc$var$j(i, m);
}, $5e575ac853f40acc$var$j = async (i, t)=>{
    t.length && t.forEach(async (e)=>{
        await i.removeItem(e);
    });
};
class $5e575ac853f40acc$export$8536778e426ddf92 {
    constructor(){
        this.initialized = !1, this.setInitialized = (e)=>{
            this.storage = e, this.initialized = !0;
        };
        const t = new $5e575ac853f40acc$var$K;
        this.storage = t;
        try {
            const e = new $5e575ac853f40acc$var$_;
            $5e575ac853f40acc$var$O(t, e, this.setInitialized);
        } catch  {
            this.initialized = !0;
        }
    }
    async getKeys() {
        return await this.initialize(), this.storage.getKeys();
    }
    async getEntries() {
        return await this.initialize(), this.storage.getEntries();
    }
    async getItem(t) {
        return await this.initialize(), this.storage.getItem(t);
    }
    async setItem(t, e) {
        return await this.initialize(), this.storage.setItem(t, e);
    }
    async removeItem(t) {
        return await this.initialize(), this.storage.removeItem(t);
    }
    async initialize() {
        this.initialized || await new Promise((t)=>{
            const e = setInterval(()=>{
                this.initialized && (clearInterval(e), t());
            }, 20);
        });
    }
}


var $03ceb28a240053b3$exports = {};
'use strict';
var $54bda3badc858a5e$exports = {};
'use strict';
function $54bda3badc858a5e$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
$54bda3badc858a5e$exports = $54bda3badc858a5e$var$format;
function $54bda3badc858a5e$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $54bda3badc858a5e$var$tryStringify;
    var offset = 1;
    if (typeof f === 'object' && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(' ');
    }
    if (typeof f !== 'string') return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = '';
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === 'string') {
                        str += '\'' + args[a] + '\'';
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === 'function') {
                        str += args[a].name || '<anonymous>';
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += '%';
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}


$03ceb28a240053b3$exports = $03ceb28a240053b3$var$pino;
const $03ceb28a240053b3$var$_console = $03ceb28a240053b3$var$pfGlobalThisOrFallback().console || {};
const $03ceb28a240053b3$var$stdSerializers = {
    mapHttpRequest: $03ceb28a240053b3$var$mock,
    mapHttpResponse: $03ceb28a240053b3$var$mock,
    wrapRequestSerializer: $03ceb28a240053b3$var$passthrough,
    wrapResponseSerializer: $03ceb28a240053b3$var$passthrough,
    wrapErrorSerializer: $03ceb28a240053b3$var$passthrough,
    req: $03ceb28a240053b3$var$mock,
    res: $03ceb28a240053b3$var$mock,
    err: $03ceb28a240053b3$var$asErrValue
};
function $03ceb28a240053b3$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== '!stdSerializers.err';
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $03ceb28a240053b3$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== 'function') throw Error('pino: transmit option must have a send function');
    const proto = opts.browser.write || $03ceb28a240053b3$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $03ceb28a240053b3$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf('!stdSerializers.err') > -1) stdErrSerialize = false;
    const levels = [
        'error',
        'fatal',
        'warn',
        'info',
        'debug',
        'trace'
    ];
    if (typeof proto === 'function') proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = 'silent';
    const level = opts.level || 'info';
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $03ceb28a240053b3$var$noop;
    Object.defineProperty(logger, 'levelVal', {
        get: getLevelVal
    });
    Object.defineProperty(logger, 'level', {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $03ceb28a240053b3$var$getTimeFunction(opts)
    };
    logger.levels = $03ceb28a240053b3$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $03ceb28a240053b3$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $03ceb28a240053b3$var$createLogEventShape();
    function getLevelVal() {
        return this.level === 'silent' ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== 'silent' && !this.levels.values[level]) throw Error('unknown level ' + level);
        this._level = level;
        $03ceb28a240053b3$var$set(setOpts, logger, 'error', 'log') // <-- must stay first
        ;
        $03ceb28a240053b3$var$set(setOpts, logger, 'fatal', 'error');
        $03ceb28a240053b3$var$set(setOpts, logger, 'warn', 'error');
        $03ceb28a240053b3$var$set(setOpts, logger, 'info', 'log');
        $03ceb28a240053b3$var$set(setOpts, logger, 'debug', 'log');
        $03ceb28a240053b3$var$set(setOpts, logger, 'trace', 'log');
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error('missing bindings for child Pino');
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $03ceb28a240053b3$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $03ceb28a240053b3$var$bind(parent, bindings, 'error');
            this.fatal = $03ceb28a240053b3$var$bind(parent, bindings, 'fatal');
            this.warn = $03ceb28a240053b3$var$bind(parent, bindings, 'warn');
            this.info = $03ceb28a240053b3$var$bind(parent, bindings, 'info');
            this.debug = $03ceb28a240053b3$var$bind(parent, bindings, 'debug');
            this.trace = $03ceb28a240053b3$var$bind(parent, bindings, 'trace');
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $03ceb28a240053b3$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$03ceb28a240053b3$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: 'trace',
        20: 'debug',
        30: 'info',
        40: 'warn',
        50: 'error',
        60: 'fatal'
    }
};
$03ceb28a240053b3$var$pino.stdSerializers = $03ceb28a240053b3$var$stdSerializers;
$03ceb28a240053b3$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $03ceb28a240053b3$var$nullTime,
    epochTime: $03ceb28a240053b3$var$epochTime,
    unixTime: $03ceb28a240053b3$var$unixTime,
    isoTime: $03ceb28a240053b3$var$isoTime
});
function $03ceb28a240053b3$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $03ceb28a240053b3$var$noop : proto[level] ? proto[level] : $03ceb28a240053b3$var$_console[level] || $03ceb28a240053b3$var$_console[fallback] || $03ceb28a240053b3$var$noop;
    $03ceb28a240053b3$var$wrap(opts, logger, level);
}
function $03ceb28a240053b3$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $03ceb28a240053b3$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $03ceb28a240053b3$var$_console ? $03ceb28a240053b3$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $03ceb28a240053b3$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $03ceb28a240053b3$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $03ceb28a240053b3$var$pino.levels.values[transmitLevel];
                const methodValue = $03ceb28a240053b3$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $03ceb28a240053b3$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $03ceb28a240053b3$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $03ceb28a240053b3$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $03ceb28a240053b3$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $03ceb28a240053b3$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === 'object') {
        while(lvl-- && typeof argsCloned[0] === 'object')Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $54bda3badc858a5e$exports(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === 'string') msg = $54bda3badc858a5e$exports(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $03ceb28a240053b3$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $03ceb28a240053b3$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === 'object' && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $03ceb28a240053b3$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $03ceb28a240053b3$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $03ceb28a240053b3$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $03ceb28a240053b3$var$createLogEventShape(bindings);
}
function $03ceb28a240053b3$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: '',
            value: 0
        }
    };
}
function $03ceb28a240053b3$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $03ceb28a240053b3$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === 'function') return opts.timestamp;
    if (opts.timestamp === false) return $03ceb28a240053b3$var$nullTime;
    return $03ceb28a240053b3$var$epochTime;
}
function $03ceb28a240053b3$var$mock() {
    return {};
}
function $03ceb28a240053b3$var$passthrough(a) {
    return a;
}
function $03ceb28a240053b3$var$noop() {}
function $03ceb28a240053b3$var$nullTime() {
    return false;
}
function $03ceb28a240053b3$var$epochTime() {
    return Date.now();
}
function $03ceb28a240053b3$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $03ceb28a240053b3$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $03ceb28a240053b3$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== 'undefined' && o;
    }
    try {
        if (typeof globalThis !== 'undefined') return globalThis;
        Object.defineProperty(Object.prototype, 'globalThis', {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 



const $704ed3be9612b960$export$341ee22b43fe3f8e = {
    level: "info"
}, $704ed3be9612b960$export$fdd446d41f74bf3a = "custom_context", $704ed3be9612b960$export$64bef9d49cc9288f = 1024000;
class $704ed3be9612b960$var$O {
    constructor(e){
        this.nodeValue = e, this.sizeInBytes = new TextEncoder().encode(this.nodeValue).length, this.next = null;
    }
    get value() {
        return this.nodeValue;
    }
    get size() {
        return this.sizeInBytes;
    }
}
class $704ed3be9612b960$var$d {
    constructor(e){
        this.head = null, this.tail = null, this.lengthInNodes = 0, this.maxSizeInBytes = e, this.sizeInBytes = 0;
    }
    append(e) {
        const t = new $704ed3be9612b960$var$O(e);
        if (t.size > this.maxSizeInBytes) throw new Error(`[LinkedList] Value too big to insert into list: ${e} with size ${t.size}`);
        for(; this.size + t.size > this.maxSizeInBytes;)this.shift();
        this.head ? (this.tail && (this.tail.next = t), this.tail = t) : (this.head = t, this.tail = t), this.lengthInNodes++, this.sizeInBytes += t.size;
    }
    shift() {
        if (!this.head) return;
        const e = this.head;
        this.head = this.head.next, this.head || (this.tail = null), this.lengthInNodes--, this.sizeInBytes -= e.size;
    }
    toArray() {
        const e = [];
        let t = this.head;
        for(; t !== null;)e.push(t.value), t = t.next;
        return e;
    }
    get length() {
        return this.lengthInNodes;
    }
    get size() {
        return this.sizeInBytes;
    }
    toOrderedArray() {
        return Array.from(this);
    }
    [Symbol.iterator]() {
        let e = this.head;
        return {
            next: ()=>{
                if (!e) return {
                    done: !0,
                    value: null
                };
                const t = e.value;
                return e = e.next, {
                    done: !1,
                    value: t
                };
            }
        };
    }
}
class $704ed3be9612b960$var$L {
    constructor(e, t = $704ed3be9612b960$export$64bef9d49cc9288f){
        this.level = e ?? "error", this.levelValue = (0, $03ceb28a240053b3$exports.levels).values[this.level], this.MAX_LOG_SIZE_IN_BYTES = t, this.logs = new $704ed3be9612b960$var$d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    forwardToConsole(e, t) {
        t === (0, $03ceb28a240053b3$exports.levels).values.error ? console.error(e) : t === (0, $03ceb28a240053b3$exports.levels).values.warn ? console.warn(e) : t === (0, $03ceb28a240053b3$exports.levels).values.debug ? console.debug(e) : t === (0, $03ceb28a240053b3$exports.levels).values.trace ? console.trace(e) : console.log(e);
    }
    appendToLogs(e) {
        this.logs.append((0, $81c2e06d24b89184$export$abc3f407e87918a4)({
            timestamp: new Date().toISOString(),
            log: e
        }));
        const t = typeof e == "string" ? JSON.parse(e).level : e.level;
        t >= this.levelValue && this.forwardToConsole(e, t);
    }
    getLogs() {
        return this.logs;
    }
    clearLogs() {
        this.logs = new $704ed3be9612b960$var$d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    getLogArray() {
        return Array.from(this.logs);
    }
    logsToBlob(e) {
        const t = this.getLogArray();
        return t.push((0, $81c2e06d24b89184$export$abc3f407e87918a4)({
            extraMetadata: e
        })), new Blob(t, {
            type: "application/json"
        });
    }
}
class $704ed3be9612b960$var$m {
    constructor(e, t = $704ed3be9612b960$export$64bef9d49cc9288f){
        this.baseChunkLogger = new $704ed3be9612b960$var$L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
    downloadLogsBlobInBrowser(e) {
        const t = URL.createObjectURL(this.logsToBlob(e)), o = document.createElement("a");
        o.href = t, o.download = `walletconnect-logs-${new Date().toISOString()}.txt`, document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(t);
    }
}
class $704ed3be9612b960$var$B {
    constructor(e, t = $704ed3be9612b960$export$64bef9d49cc9288f){
        this.baseChunkLogger = new $704ed3be9612b960$var$L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
}
var $704ed3be9612b960$var$x = Object.defineProperty, $704ed3be9612b960$var$S = Object.defineProperties, $704ed3be9612b960$var$_ = Object.getOwnPropertyDescriptors, $704ed3be9612b960$var$p = Object.getOwnPropertySymbols, $704ed3be9612b960$var$T = Object.prototype.hasOwnProperty, $704ed3be9612b960$var$z = Object.prototype.propertyIsEnumerable, $704ed3be9612b960$var$f = (r, e, t)=>e in r ? $704ed3be9612b960$var$x(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $704ed3be9612b960$var$i = (r, e)=>{
    for(var t in e || (e = {}))$704ed3be9612b960$var$T.call(e, t) && $704ed3be9612b960$var$f(r, t, e[t]);
    if ($704ed3be9612b960$var$p) for (var t of $704ed3be9612b960$var$p(e))$704ed3be9612b960$var$z.call(e, t) && $704ed3be9612b960$var$f(r, t, e[t]);
    return r;
}, $704ed3be9612b960$var$g = (r, e)=>$704ed3be9612b960$var$S(r, $704ed3be9612b960$var$_(e));
function $704ed3be9612b960$export$bad2475df51c8ecc(r) {
    return $704ed3be9612b960$var$g($704ed3be9612b960$var$i({}, r), {
        level: r?.level || $704ed3be9612b960$export$341ee22b43fe3f8e.level
    });
}
function $704ed3be9612b960$export$e8faae0482d84e9e(r, e = $704ed3be9612b960$export$fdd446d41f74bf3a) {
    return r[e] || "";
}
function $704ed3be9612b960$export$758f352b7265b00e(r, e, t = $704ed3be9612b960$export$fdd446d41f74bf3a) {
    return r[t] = e, r;
}
function $704ed3be9612b960$export$a283a9a0054a3c25(r, e = $704ed3be9612b960$export$fdd446d41f74bf3a) {
    let t = "";
    return typeof r.bindings > "u" ? t = $704ed3be9612b960$export$e8faae0482d84e9e(r, e) : t = r.bindings().context || "", t;
}
function $704ed3be9612b960$export$307261146df20465(r, e, t = $704ed3be9612b960$export$fdd446d41f74bf3a) {
    const o = $704ed3be9612b960$export$a283a9a0054a3c25(r, t);
    return o.trim() ? `${o}/${e}` : e;
}
function $704ed3be9612b960$export$4929e0372308a636(r, e, t = $704ed3be9612b960$export$fdd446d41f74bf3a) {
    const o = $704ed3be9612b960$export$307261146df20465(r, e, t), a = r.child({
        context: o
    });
    return $704ed3be9612b960$export$758f352b7265b00e(a, o, t);
}
function $704ed3be9612b960$export$2ca1453636a43a7(r) {
    var e, t;
    const o = new $704ed3be9612b960$var$m((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($03ceb28a240053b3$exports)))($704ed3be9612b960$var$g($704ed3be9612b960$var$i({}, r.opts), {
            level: "trace",
            browser: $704ed3be9612b960$var$g($704ed3be9612b960$var$i({}, (t = r.opts) == null ? void 0 : t.browser), {
                write: (a)=>o.write(a)
            })
        })),
        chunkLoggerController: o
    };
}
function $704ed3be9612b960$export$495ac2973e46cb97(r) {
    var e;
    const t = new $704ed3be9612b960$var$B((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($03ceb28a240053b3$exports)))($704ed3be9612b960$var$g($704ed3be9612b960$var$i({}, r.opts), {
            level: "trace"
        }), t),
        chunkLoggerController: t
    };
}
function $704ed3be9612b960$export$15eba7fb5aaf9303(r) {
    return typeof r.loggerOverride < "u" && typeof r.loggerOverride != "string" ? {
        logger: r.loggerOverride,
        chunkLoggerController: null
    } : typeof window < "u" ? $704ed3be9612b960$export$2ca1453636a43a7(r) : $704ed3be9612b960$export$495ac2973e46cb97(r);
}




var $7etJZ = parcelRequire("7etJZ");
class $bace94c1ef08d1bc$export$ed533416df113881 extends (0, $2dd102fe42a3c147$export$ab429ec7e240e546) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bace94c1ef08d1bc$export$a4e7e56f03915894 {
    constructor(s, t, e){
        this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$45b2c2643615b67 extends (0, $2dd102fe42a3c147$export$ab429ec7e240e546) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $bace94c1ef08d1bc$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bace94c1ef08d1bc$export$3b0872bbd7e675a2 extends (0, $2dd102fe42a3c147$export$ab429ec7e240e546) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$9a0f755fd4f79434 extends (0, $2dd102fe42a3c147$export$ab429ec7e240e546) {
    constructor(s){
        super();
    }
}
class $bace94c1ef08d1bc$export$a7f17ba6c54777e7 {
    constructor(s, t, e, f){
        this.core = s, this.logger = t, this.name = e;
    }
}
class $bace94c1ef08d1bc$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $bace94c1ef08d1bc$export$300eed987e764b57 extends (0, $2dd102fe42a3c147$export$ab429ec7e240e546) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$41aaa3c39f6f2861 extends (0, $2dd102fe42a3c147$export$ab429ec7e240e546) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bace94c1ef08d1bc$export$873b0b865d85ddb6 {
    constructor(s, t, e){
        this.core = s, this.logger = t, this.store = e;
    }
}
class $bace94c1ef08d1bc$export$7db533fb638f979d {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$4264a8ec567679e5 {
    constructor(s, t, e){
        this.core = s, this.logger = t, this.telemetryEnabled = e;
    }
}
class $bace94c1ef08d1bc$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))) {
    constructor(){
        super();
    }
}
class $bace94c1ef08d1bc$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bace94c1ef08d1bc$export$623dd0f793f15643 extends (0, $7etJZ.EventEmitter) {
    constructor(){
        super();
    }
}
class $bace94c1ef08d1bc$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}






function $88cd1e73c7abe0b8$var$En(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $88cd1e73c7abe0b8$var$fe(t, ...e) {
    if (!$88cd1e73c7abe0b8$var$En(t)) throw new Error("Uint8Array expected");
    if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function $88cd1e73c7abe0b8$var$De(t, e = !0) {
    if (t.destroyed) throw new Error("Hash instance has been destroyed");
    if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function $88cd1e73c7abe0b8$var$gn(t, e) {
    $88cd1e73c7abe0b8$var$fe(t);
    const n = e.outputLen;
    if (t.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
}
const $88cd1e73c7abe0b8$var$it = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0; /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $88cd1e73c7abe0b8$var$_t = (t)=>new DataView(t.buffer, t.byteOffset, t.byteLength);
function $88cd1e73c7abe0b8$var$yn(t) {
    if (typeof t != "string") throw new Error("utf8ToBytes expected string, got " + typeof t);
    return new Uint8Array(new TextEncoder().encode(t));
}
function $88cd1e73c7abe0b8$var$de(t) {
    return typeof t == "string" && (t = $88cd1e73c7abe0b8$var$yn(t)), $88cd1e73c7abe0b8$var$fe(t), t;
}
class $88cd1e73c7abe0b8$var$xn {
    clone() {
        return this._cloneInto();
    }
}
function $88cd1e73c7abe0b8$var$Bn(t) {
    const e = (r)=>t().update($88cd1e73c7abe0b8$var$de(r)).digest(), n = t();
    return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = ()=>t(), e;
}
function $88cd1e73c7abe0b8$var$he(t = 32) {
    if ($88cd1e73c7abe0b8$var$it && typeof $88cd1e73c7abe0b8$var$it.getRandomValues == "function") return $88cd1e73c7abe0b8$var$it.getRandomValues(new Uint8Array(t));
    if ($88cd1e73c7abe0b8$var$it && typeof $88cd1e73c7abe0b8$var$it.randomBytes == "function") return $88cd1e73c7abe0b8$var$it.randomBytes(t);
    throw new Error("crypto.getRandomValues must be defined");
}
function $88cd1e73c7abe0b8$var$Cn(t, e, n, r) {
    if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, n, r);
    const o = BigInt(32), s = BigInt(4294967295), a = Number(n >> o & s), u = Number(n & s), i = r ? 4 : 0, D = r ? 0 : 4;
    t.setUint32(e + i, a, r), t.setUint32(e + D, u, r);
}
class $88cd1e73c7abe0b8$var$An extends $88cd1e73c7abe0b8$var$xn {
    constructor(e, n, r, o){
        super(), this.blockLen = e, this.outputLen = n, this.padOffset = r, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = $88cd1e73c7abe0b8$var$_t(this.buffer);
    }
    update(e) {
        $88cd1e73c7abe0b8$var$De(this);
        const { view: n, buffer: r, blockLen: o } = this;
        e = $88cd1e73c7abe0b8$var$de(e);
        const s = e.length;
        for(let a = 0; a < s;){
            const u = Math.min(o - this.pos, s - a);
            if (u === o) {
                const i = $88cd1e73c7abe0b8$var$_t(e);
                for(; o <= s - a; a += o)this.process(i, a);
                continue;
            }
            r.set(e.subarray(a, a + u), this.pos), this.pos += u, a += u, this.pos === o && (this.process(n, 0), this.pos = 0);
        }
        return this.length += e.length, this.roundClean(), this;
    }
    digestInto(e) {
        $88cd1e73c7abe0b8$var$De(this), $88cd1e73c7abe0b8$var$gn(e, this), this.finished = !0;
        const { buffer: n, view: r, blockLen: o, isLE: s } = this;
        let { pos: a } = this;
        n[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(r, 0), a = 0);
        for(let l = a; l < o; l++)n[l] = 0;
        $88cd1e73c7abe0b8$var$Cn(r, o - 8, BigInt(this.length * 8), s), this.process(r, 0);
        const u = $88cd1e73c7abe0b8$var$_t(e), i = this.outputLen;
        if (i % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const D = i / 4, c = this.get();
        if (D > c.length) throw new Error("_sha2: outputLen bigger than state");
        for(let l = 0; l < D; l++)u.setUint32(4 * l, c[l], s);
    }
    digest() {
        const { buffer: e, outputLen: n } = this;
        this.digestInto(e);
        const r = e.slice(0, n);
        return this.destroy(), r;
    }
    _cloneInto(e) {
        e || (e = new this.constructor), e.set(...this.get());
        const { blockLen: n, buffer: r, length: o, finished: s, destroyed: a, pos: u } = this;
        return e.length = o, e.pos = u, e.finished = s, e.destroyed = a, o % n && e.buffer.set(r), e;
    }
}
const $88cd1e73c7abe0b8$var$wt = BigInt(2 ** 32 - 1), $88cd1e73c7abe0b8$var$St = BigInt(32);
function $88cd1e73c7abe0b8$var$le(t, e = !1) {
    return e ? {
        h: Number(t & $88cd1e73c7abe0b8$var$wt),
        l: Number(t >> $88cd1e73c7abe0b8$var$St & $88cd1e73c7abe0b8$var$wt)
    } : {
        h: Number(t >> $88cd1e73c7abe0b8$var$St & $88cd1e73c7abe0b8$var$wt) | 0,
        l: Number(t & $88cd1e73c7abe0b8$var$wt) | 0
    };
}
function $88cd1e73c7abe0b8$var$mn(t, e = !1) {
    let n = new Uint32Array(t.length), r = new Uint32Array(t.length);
    for(let o = 0; o < t.length; o++){
        const { h: s, l: a } = $88cd1e73c7abe0b8$var$le(t[o], e);
        [n[o], r[o]] = [
            s,
            a
        ];
    }
    return [
        n,
        r
    ];
}
const $88cd1e73c7abe0b8$var$_n = (t, e)=>BigInt(t >>> 0) << $88cd1e73c7abe0b8$var$St | BigInt(e >>> 0), $88cd1e73c7abe0b8$var$Sn = (t, e, n)=>t >>> n, $88cd1e73c7abe0b8$var$vn = (t, e, n)=>t << 32 - n | e >>> n, $88cd1e73c7abe0b8$var$In = (t, e, n)=>t >>> n | e << 32 - n, $88cd1e73c7abe0b8$var$Un = (t, e, n)=>t << 32 - n | e >>> n, $88cd1e73c7abe0b8$var$Tn = (t, e, n)=>t << 64 - n | e >>> n - 32, $88cd1e73c7abe0b8$var$Fn = (t, e, n)=>t >>> n - 32 | e << 64 - n, $88cd1e73c7abe0b8$var$Nn = (t, e)=>e, $88cd1e73c7abe0b8$var$Ln = (t, e)=>t, $88cd1e73c7abe0b8$var$On = (t, e, n)=>t << n | e >>> 32 - n, $88cd1e73c7abe0b8$var$Hn = (t, e, n)=>e << n | t >>> 32 - n, $88cd1e73c7abe0b8$var$zn = (t, e, n)=>e << n - 32 | t >>> 64 - n, $88cd1e73c7abe0b8$var$Mn = (t, e, n)=>t << n - 32 | e >>> 64 - n;
function $88cd1e73c7abe0b8$var$qn(t, e, n, r) {
    const o = (e >>> 0) + (r >>> 0);
    return {
        h: t + n + (o / 2 ** 32 | 0) | 0,
        l: o | 0
    };
}
const $88cd1e73c7abe0b8$var$$n = (t, e, n)=>(t >>> 0) + (e >>> 0) + (n >>> 0), $88cd1e73c7abe0b8$var$kn = (t, e, n, r)=>e + n + r + (t / 2 ** 32 | 0) | 0, $88cd1e73c7abe0b8$var$Rn = (t, e, n, r)=>(t >>> 0) + (e >>> 0) + (n >>> 0) + (r >>> 0), $88cd1e73c7abe0b8$var$jn = (t, e, n, r, o)=>e + n + r + o + (t / 2 ** 32 | 0) | 0, $88cd1e73c7abe0b8$var$Zn = (t, e, n, r, o)=>(t >>> 0) + (e >>> 0) + (n >>> 0) + (r >>> 0) + (o >>> 0), $88cd1e73c7abe0b8$var$Gn = (t, e, n, r, o, s)=>e + n + r + o + s + (t / 2 ** 32 | 0) | 0, $88cd1e73c7abe0b8$var$x = {
    fromBig: $88cd1e73c7abe0b8$var$le,
    split: $88cd1e73c7abe0b8$var$mn,
    toBig: $88cd1e73c7abe0b8$var$_n,
    shrSH: $88cd1e73c7abe0b8$var$Sn,
    shrSL: $88cd1e73c7abe0b8$var$vn,
    rotrSH: $88cd1e73c7abe0b8$var$In,
    rotrSL: $88cd1e73c7abe0b8$var$Un,
    rotrBH: $88cd1e73c7abe0b8$var$Tn,
    rotrBL: $88cd1e73c7abe0b8$var$Fn,
    rotr32H: $88cd1e73c7abe0b8$var$Nn,
    rotr32L: $88cd1e73c7abe0b8$var$Ln,
    rotlSH: $88cd1e73c7abe0b8$var$On,
    rotlSL: $88cd1e73c7abe0b8$var$Hn,
    rotlBH: $88cd1e73c7abe0b8$var$zn,
    rotlBL: $88cd1e73c7abe0b8$var$Mn,
    add: $88cd1e73c7abe0b8$var$qn,
    add3L: $88cd1e73c7abe0b8$var$$n,
    add3H: $88cd1e73c7abe0b8$var$kn,
    add4L: $88cd1e73c7abe0b8$var$Rn,
    add4H: $88cd1e73c7abe0b8$var$jn,
    add5H: $88cd1e73c7abe0b8$var$Gn,
    add5L: $88cd1e73c7abe0b8$var$Zn
}, [$88cd1e73c7abe0b8$var$Vn, $88cd1e73c7abe0b8$var$Yn] = (()=>$88cd1e73c7abe0b8$var$x.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((t)=>BigInt(t))))(), $88cd1e73c7abe0b8$var$P = new Uint32Array(80), $88cd1e73c7abe0b8$var$Q = new Uint32Array(80);
class $88cd1e73c7abe0b8$var$Jn extends $88cd1e73c7abe0b8$var$An {
    constructor(){
        super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
    }
    get() {
        const { Ah: e, Al: n, Bh: r, Bl: o, Ch: s, Cl: a, Dh: u, Dl: i, Eh: D, El: c, Fh: l, Fl: p, Gh: w, Gl: h, Hh: g, Hl: S } = this;
        return [
            e,
            n,
            r,
            o,
            s,
            a,
            u,
            i,
            D,
            c,
            l,
            p,
            w,
            h,
            g,
            S
        ];
    }
    set(e, n, r, o, s, a, u, i, D, c, l, p, w, h, g, S) {
        this.Ah = e | 0, this.Al = n | 0, this.Bh = r | 0, this.Bl = o | 0, this.Ch = s | 0, this.Cl = a | 0, this.Dh = u | 0, this.Dl = i | 0, this.Eh = D | 0, this.El = c | 0, this.Fh = l | 0, this.Fl = p | 0, this.Gh = w | 0, this.Gl = h | 0, this.Hh = g | 0, this.Hl = S | 0;
    }
    process(e, n) {
        for(let d = 0; d < 16; d++, n += 4)$88cd1e73c7abe0b8$var$P[d] = e.getUint32(n), $88cd1e73c7abe0b8$var$Q[d] = e.getUint32(n += 4);
        for(let d = 16; d < 80; d++){
            const m = $88cd1e73c7abe0b8$var$P[d - 15] | 0, F = $88cd1e73c7abe0b8$var$Q[d - 15] | 0, q = $88cd1e73c7abe0b8$var$x.rotrSH(m, F, 1) ^ $88cd1e73c7abe0b8$var$x.rotrSH(m, F, 8) ^ $88cd1e73c7abe0b8$var$x.shrSH(m, F, 7), z = $88cd1e73c7abe0b8$var$x.rotrSL(m, F, 1) ^ $88cd1e73c7abe0b8$var$x.rotrSL(m, F, 8) ^ $88cd1e73c7abe0b8$var$x.shrSL(m, F, 7), I = $88cd1e73c7abe0b8$var$P[d - 2] | 0, O = $88cd1e73c7abe0b8$var$Q[d - 2] | 0, ot = $88cd1e73c7abe0b8$var$x.rotrSH(I, O, 19) ^ $88cd1e73c7abe0b8$var$x.rotrBH(I, O, 61) ^ $88cd1e73c7abe0b8$var$x.shrSH(I, O, 6), tt = $88cd1e73c7abe0b8$var$x.rotrSL(I, O, 19) ^ $88cd1e73c7abe0b8$var$x.rotrBL(I, O, 61) ^ $88cd1e73c7abe0b8$var$x.shrSL(I, O, 6), st = $88cd1e73c7abe0b8$var$x.add4L(z, tt, $88cd1e73c7abe0b8$var$Q[d - 7], $88cd1e73c7abe0b8$var$Q[d - 16]), at = $88cd1e73c7abe0b8$var$x.add4H(st, q, ot, $88cd1e73c7abe0b8$var$P[d - 7], $88cd1e73c7abe0b8$var$P[d - 16]);
            $88cd1e73c7abe0b8$var$P[d] = at | 0, $88cd1e73c7abe0b8$var$Q[d] = st | 0;
        }
        let { Ah: r, Al: o, Bh: s, Bl: a, Ch: u, Cl: i, Dh: D, Dl: c, Eh: l, El: p, Fh: w, Fl: h, Gh: g, Gl: S, Hh: v, Hl: L } = this;
        for(let d = 0; d < 80; d++){
            const m = $88cd1e73c7abe0b8$var$x.rotrSH(l, p, 14) ^ $88cd1e73c7abe0b8$var$x.rotrSH(l, p, 18) ^ $88cd1e73c7abe0b8$var$x.rotrBH(l, p, 41), F = $88cd1e73c7abe0b8$var$x.rotrSL(l, p, 14) ^ $88cd1e73c7abe0b8$var$x.rotrSL(l, p, 18) ^ $88cd1e73c7abe0b8$var$x.rotrBL(l, p, 41), q = l & w ^ ~l & g, z = p & h ^ ~p & S, I = $88cd1e73c7abe0b8$var$x.add5L(L, F, z, $88cd1e73c7abe0b8$var$Yn[d], $88cd1e73c7abe0b8$var$Q[d]), O = $88cd1e73c7abe0b8$var$x.add5H(I, v, m, q, $88cd1e73c7abe0b8$var$Vn[d], $88cd1e73c7abe0b8$var$P[d]), ot = I | 0, tt = $88cd1e73c7abe0b8$var$x.rotrSH(r, o, 28) ^ $88cd1e73c7abe0b8$var$x.rotrBH(r, o, 34) ^ $88cd1e73c7abe0b8$var$x.rotrBH(r, o, 39), st = $88cd1e73c7abe0b8$var$x.rotrSL(r, o, 28) ^ $88cd1e73c7abe0b8$var$x.rotrBL(r, o, 34) ^ $88cd1e73c7abe0b8$var$x.rotrBL(r, o, 39), at = r & s ^ r & u ^ s & u, Ct = o & a ^ o & i ^ a & i;
            v = g | 0, L = S | 0, g = w | 0, S = h | 0, w = l | 0, h = p | 0, ({ h: l, l: p } = $88cd1e73c7abe0b8$var$x.add(D | 0, c | 0, O | 0, ot | 0)), D = u | 0, c = i | 0, u = s | 0, i = a | 0, s = r | 0, a = o | 0;
            const At = $88cd1e73c7abe0b8$var$x.add3L(ot, st, Ct);
            r = $88cd1e73c7abe0b8$var$x.add3H(At, O, tt, at), o = At | 0;
        }
        ({ h: r, l: o } = $88cd1e73c7abe0b8$var$x.add(this.Ah | 0, this.Al | 0, r | 0, o | 0)), ({ h: s, l: a } = $88cd1e73c7abe0b8$var$x.add(this.Bh | 0, this.Bl | 0, s | 0, a | 0)), ({ h: u, l: i } = $88cd1e73c7abe0b8$var$x.add(this.Ch | 0, this.Cl | 0, u | 0, i | 0)), ({ h: D, l: c } = $88cd1e73c7abe0b8$var$x.add(this.Dh | 0, this.Dl | 0, D | 0, c | 0)), ({ h: l, l: p } = $88cd1e73c7abe0b8$var$x.add(this.Eh | 0, this.El | 0, l | 0, p | 0)), ({ h: w, l: h } = $88cd1e73c7abe0b8$var$x.add(this.Fh | 0, this.Fl | 0, w | 0, h | 0)), ({ h: g, l: S } = $88cd1e73c7abe0b8$var$x.add(this.Gh | 0, this.Gl | 0, g | 0, S | 0)), ({ h: v, l: L } = $88cd1e73c7abe0b8$var$x.add(this.Hh | 0, this.Hl | 0, v | 0, L | 0)), this.set(r, o, s, a, u, i, D, c, l, p, w, h, g, S, v, L);
    }
    roundClean() {
        $88cd1e73c7abe0b8$var$P.fill(0), $88cd1e73c7abe0b8$var$Q.fill(0);
    }
    destroy() {
        this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
const $88cd1e73c7abe0b8$var$Kn = $88cd1e73c7abe0b8$var$Bn(()=>new $88cd1e73c7abe0b8$var$Jn); /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $88cd1e73c7abe0b8$var$vt = BigInt(0), $88cd1e73c7abe0b8$var$be = BigInt(1), $88cd1e73c7abe0b8$var$Wn = BigInt(2);
function $88cd1e73c7abe0b8$var$It(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $88cd1e73c7abe0b8$var$Ut(t) {
    if (!$88cd1e73c7abe0b8$var$It(t)) throw new Error("Uint8Array expected");
}
function $88cd1e73c7abe0b8$var$Tt(t, e) {
    if (typeof e != "boolean") throw new Error(t + " boolean expected, got " + e);
}
const $88cd1e73c7abe0b8$var$Xn = Array.from({
    length: 256
}, (t, e)=>e.toString(16).padStart(2, "0"));
function $88cd1e73c7abe0b8$var$Ft(t) {
    $88cd1e73c7abe0b8$var$Ut(t);
    let e = "";
    for(let n = 0; n < t.length; n++)e += $88cd1e73c7abe0b8$var$Xn[t[n]];
    return e;
}
function $88cd1e73c7abe0b8$var$pe(t) {
    if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
    return t === "" ? $88cd1e73c7abe0b8$var$vt : BigInt("0x" + t);
}
const $88cd1e73c7abe0b8$var$K = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $88cd1e73c7abe0b8$var$we(t) {
    if (t >= $88cd1e73c7abe0b8$var$K._0 && t <= $88cd1e73c7abe0b8$var$K._9) return t - $88cd1e73c7abe0b8$var$K._0;
    if (t >= $88cd1e73c7abe0b8$var$K.A && t <= $88cd1e73c7abe0b8$var$K.F) return t - ($88cd1e73c7abe0b8$var$K.A - 10);
    if (t >= $88cd1e73c7abe0b8$var$K.a && t <= $88cd1e73c7abe0b8$var$K.f) return t - ($88cd1e73c7abe0b8$var$K.a - 10);
}
function $88cd1e73c7abe0b8$var$Ee(t) {
    if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
    const e = t.length, n = e / 2;
    if (e % 2) throw new Error("hex string expected, got unpadded hex of length " + e);
    const r = new Uint8Array(n);
    for(let o = 0, s = 0; o < n; o++, s += 2){
        const a = $88cd1e73c7abe0b8$var$we(t.charCodeAt(s)), u = $88cd1e73c7abe0b8$var$we(t.charCodeAt(s + 1));
        if (a === void 0 || u === void 0) {
            const i = t[s] + t[s + 1];
            throw new Error('hex string expected, got non-hex character "' + i + '" at index ' + s);
        }
        r[o] = a * 16 + u;
    }
    return r;
}
function $88cd1e73c7abe0b8$var$Pn(t) {
    return $88cd1e73c7abe0b8$var$pe($88cd1e73c7abe0b8$var$Ft(t));
}
function $88cd1e73c7abe0b8$var$Et(t) {
    return $88cd1e73c7abe0b8$var$Ut(t), $88cd1e73c7abe0b8$var$pe($88cd1e73c7abe0b8$var$Ft(Uint8Array.from(t).reverse()));
}
function $88cd1e73c7abe0b8$var$ge(t, e) {
    return $88cd1e73c7abe0b8$var$Ee(t.toString(16).padStart(e * 2, "0"));
}
function $88cd1e73c7abe0b8$var$Nt(t, e) {
    return $88cd1e73c7abe0b8$var$ge(t, e).reverse();
}
function $88cd1e73c7abe0b8$var$W(t, e, n) {
    let r;
    if (typeof e == "string") try {
        r = $88cd1e73c7abe0b8$var$Ee(e);
    } catch (s) {
        throw new Error(t + " must be hex string or Uint8Array, cause: " + s);
    }
    else if ($88cd1e73c7abe0b8$var$It(e)) r = Uint8Array.from(e);
    else throw new Error(t + " must be hex string or Uint8Array");
    const o = r.length;
    if (typeof n == "number" && o !== n) throw new Error(t + " of length " + n + " expected, got " + o);
    return r;
}
function $88cd1e73c7abe0b8$var$ye(...t) {
    let e = 0;
    for(let r = 0; r < t.length; r++){
        const o = t[r];
        $88cd1e73c7abe0b8$var$Ut(o), e += o.length;
    }
    const n = new Uint8Array(e);
    for(let r = 0, o = 0; r < t.length; r++){
        const s = t[r];
        n.set(s, o), o += s.length;
    }
    return n;
}
const $88cd1e73c7abe0b8$var$Lt = (t)=>typeof t == "bigint" && $88cd1e73c7abe0b8$var$vt <= t;
function $88cd1e73c7abe0b8$var$Qn(t, e, n) {
    return $88cd1e73c7abe0b8$var$Lt(t) && $88cd1e73c7abe0b8$var$Lt(e) && $88cd1e73c7abe0b8$var$Lt(n) && e <= t && t < n;
}
function $88cd1e73c7abe0b8$var$ft(t, e, n, r) {
    if (!$88cd1e73c7abe0b8$var$Qn(e, n, r)) throw new Error("expected valid " + t + ": " + n + " <= n < " + r + ", got " + e);
}
function $88cd1e73c7abe0b8$var$tr(t) {
    let e;
    for(e = 0; t > $88cd1e73c7abe0b8$var$vt; t >>= $88cd1e73c7abe0b8$var$be, e += 1);
    return e;
}
const $88cd1e73c7abe0b8$var$er = (t)=>($88cd1e73c7abe0b8$var$Wn << BigInt(t - 1)) - $88cd1e73c7abe0b8$var$be, $88cd1e73c7abe0b8$var$nr = {
    bigint: (t)=>typeof t == "bigint",
    function: (t)=>typeof t == "function",
    boolean: (t)=>typeof t == "boolean",
    string: (t)=>typeof t == "string",
    stringOrUint8Array: (t)=>typeof t == "string" || $88cd1e73c7abe0b8$var$It(t),
    isSafeInteger: (t)=>Number.isSafeInteger(t),
    array: (t)=>Array.isArray(t),
    field: (t, e)=>e.Fp.isValid(t),
    hash: (t)=>typeof t == "function" && Number.isSafeInteger(t.outputLen)
};
function $88cd1e73c7abe0b8$var$Ot(t, e, n = {}) {
    const r = (o, s, a)=>{
        const u = $88cd1e73c7abe0b8$var$nr[s];
        if (typeof u != "function") throw new Error("invalid validator function");
        const i = t[o];
        if (!(a && i === void 0) && !u(i, t)) throw new Error("param " + String(o) + " is invalid. Expected " + s + ", got " + i);
    };
    for (const [o, s] of Object.entries(e))r(o, s, !1);
    for (const [o, s] of Object.entries(n))r(o, s, !0);
    return t;
}
function $88cd1e73c7abe0b8$var$xe(t) {
    const e = new WeakMap;
    return (n, ...r)=>{
        const o = e.get(n);
        if (o !== void 0) return o;
        const s = t(n, ...r);
        return e.set(n, s), s;
    };
}
const $88cd1e73c7abe0b8$var$M = BigInt(0), $88cd1e73c7abe0b8$var$N = BigInt(1), $88cd1e73c7abe0b8$var$nt = BigInt(2), $88cd1e73c7abe0b8$var$rr = BigInt(3), $88cd1e73c7abe0b8$var$Ht = BigInt(4), $88cd1e73c7abe0b8$var$Be = BigInt(5), $88cd1e73c7abe0b8$var$Ce = BigInt(8);
function $88cd1e73c7abe0b8$var$H(t, e) {
    const n = t % e;
    return n >= $88cd1e73c7abe0b8$var$M ? n : e + n;
}
function $88cd1e73c7abe0b8$var$or(t, e, n) {
    if (e < $88cd1e73c7abe0b8$var$M) throw new Error("invalid exponent, negatives unsupported");
    if (n <= $88cd1e73c7abe0b8$var$M) throw new Error("invalid modulus");
    if (n === $88cd1e73c7abe0b8$var$N) return $88cd1e73c7abe0b8$var$M;
    let r = $88cd1e73c7abe0b8$var$N;
    for(; e > $88cd1e73c7abe0b8$var$M;)e & $88cd1e73c7abe0b8$var$N && (r = r * t % n), t = t * t % n, e >>= $88cd1e73c7abe0b8$var$N;
    return r;
}
function $88cd1e73c7abe0b8$var$J(t, e, n) {
    let r = t;
    for(; e-- > $88cd1e73c7abe0b8$var$M;)r *= r, r %= n;
    return r;
}
function $88cd1e73c7abe0b8$var$Ae(t, e) {
    if (t === $88cd1e73c7abe0b8$var$M) throw new Error("invert: expected non-zero number");
    if (e <= $88cd1e73c7abe0b8$var$M) throw new Error("invert: expected positive modulus, got " + e);
    let n = $88cd1e73c7abe0b8$var$H(t, e), r = e, o = $88cd1e73c7abe0b8$var$M, s = $88cd1e73c7abe0b8$var$N;
    for(; n !== $88cd1e73c7abe0b8$var$M;){
        const u = r / n, i = r % n, D = o - s * u;
        r = n, n = i, o = s, s = D;
    }
    if (r !== $88cd1e73c7abe0b8$var$N) throw new Error("invert: does not exist");
    return $88cd1e73c7abe0b8$var$H(o, e);
}
function $88cd1e73c7abe0b8$var$sr(t) {
    const e = (t - $88cd1e73c7abe0b8$var$N) / $88cd1e73c7abe0b8$var$nt;
    let n, r, o;
    for(n = t - $88cd1e73c7abe0b8$var$N, r = 0; n % $88cd1e73c7abe0b8$var$nt === $88cd1e73c7abe0b8$var$M; n /= $88cd1e73c7abe0b8$var$nt, r++);
    for(o = $88cd1e73c7abe0b8$var$nt; o < t && $88cd1e73c7abe0b8$var$or(o, e, t) !== t - $88cd1e73c7abe0b8$var$N; o++)if (o > 1e3) throw new Error("Cannot find square root: likely non-prime P");
    if (r === 1) {
        const a = (t + $88cd1e73c7abe0b8$var$N) / $88cd1e73c7abe0b8$var$Ht;
        return function(i, D) {
            const c = i.pow(D, a);
            if (!i.eql(i.sqr(c), D)) throw new Error("Cannot find square root");
            return c;
        };
    }
    const s = (n + $88cd1e73c7abe0b8$var$N) / $88cd1e73c7abe0b8$var$nt;
    return function(u, i) {
        if (u.pow(i, e) === u.neg(u.ONE)) throw new Error("Cannot find square root");
        let D = r, c = u.pow(u.mul(u.ONE, o), n), l = u.pow(i, s), p = u.pow(i, n);
        for(; !u.eql(p, u.ONE);){
            if (u.eql(p, u.ZERO)) return u.ZERO;
            let w = 1;
            for(let g = u.sqr(p); w < D && !u.eql(g, u.ONE); w++)g = u.sqr(g);
            const h = u.pow(c, $88cd1e73c7abe0b8$var$N << BigInt(D - w - 1));
            c = u.sqr(h), l = u.mul(l, h), p = u.mul(p, c), D = w;
        }
        return l;
    };
}
function $88cd1e73c7abe0b8$var$ir(t) {
    if (t % $88cd1e73c7abe0b8$var$Ht === $88cd1e73c7abe0b8$var$rr) {
        const e = (t + $88cd1e73c7abe0b8$var$N) / $88cd1e73c7abe0b8$var$Ht;
        return function(r, o) {
            const s = r.pow(o, e);
            if (!r.eql(r.sqr(s), o)) throw new Error("Cannot find square root");
            return s;
        };
    }
    if (t % $88cd1e73c7abe0b8$var$Ce === $88cd1e73c7abe0b8$var$Be) {
        const e = (t - $88cd1e73c7abe0b8$var$Be) / $88cd1e73c7abe0b8$var$Ce;
        return function(r, o) {
            const s = r.mul(o, $88cd1e73c7abe0b8$var$nt), a = r.pow(s, e), u = r.mul(o, a), i = r.mul(r.mul(u, $88cd1e73c7abe0b8$var$nt), a), D = r.mul(u, r.sub(i, r.ONE));
            if (!r.eql(r.sqr(D), o)) throw new Error("Cannot find square root");
            return D;
        };
    }
    return $88cd1e73c7abe0b8$var$sr(t);
}
const $88cd1e73c7abe0b8$var$ur = (t, e)=>($88cd1e73c7abe0b8$var$H(t, e) & $88cd1e73c7abe0b8$var$N) === $88cd1e73c7abe0b8$var$N, $88cd1e73c7abe0b8$var$cr = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $88cd1e73c7abe0b8$var$ar(t) {
    const e = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    }, n = $88cd1e73c7abe0b8$var$cr.reduce((r, o)=>(r[o] = "function", r), e);
    return $88cd1e73c7abe0b8$var$Ot(t, n);
}
function $88cd1e73c7abe0b8$var$fr(t, e, n) {
    if (n < $88cd1e73c7abe0b8$var$M) throw new Error("invalid exponent, negatives unsupported");
    if (n === $88cd1e73c7abe0b8$var$M) return t.ONE;
    if (n === $88cd1e73c7abe0b8$var$N) return e;
    let r = t.ONE, o = e;
    for(; n > $88cd1e73c7abe0b8$var$M;)n & $88cd1e73c7abe0b8$var$N && (r = t.mul(r, o)), o = t.sqr(o), n >>= $88cd1e73c7abe0b8$var$N;
    return r;
}
function $88cd1e73c7abe0b8$var$Dr(t, e) {
    const n = new Array(e.length), r = e.reduce((s, a, u)=>t.is0(a) ? s : (n[u] = s, t.mul(s, a)), t.ONE), o = t.inv(r);
    return e.reduceRight((s, a, u)=>t.is0(a) ? s : (n[u] = t.mul(s, n[u]), t.mul(s, a)), o), n;
}
function $88cd1e73c7abe0b8$var$me(t, e) {
    const n = e !== void 0 ? e : t.toString(2).length, r = Math.ceil(n / 8);
    return {
        nBitLength: n,
        nByteLength: r
    };
}
function $88cd1e73c7abe0b8$var$_e(t, e, n = !1, r = {}) {
    if (t <= $88cd1e73c7abe0b8$var$M) throw new Error("invalid field: expected ORDER > 0, got " + t);
    const { nBitLength: o, nByteLength: s } = $88cd1e73c7abe0b8$var$me(t, e);
    if (s > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let a;
    const u = Object.freeze({
        ORDER: t,
        isLE: n,
        BITS: o,
        BYTES: s,
        MASK: $88cd1e73c7abe0b8$var$er(o),
        ZERO: $88cd1e73c7abe0b8$var$M,
        ONE: $88cd1e73c7abe0b8$var$N,
        create: (i)=>$88cd1e73c7abe0b8$var$H(i, t),
        isValid: (i)=>{
            if (typeof i != "bigint") throw new Error("invalid field element: expected bigint, got " + typeof i);
            return $88cd1e73c7abe0b8$var$M <= i && i < t;
        },
        is0: (i)=>i === $88cd1e73c7abe0b8$var$M,
        isOdd: (i)=>(i & $88cd1e73c7abe0b8$var$N) === $88cd1e73c7abe0b8$var$N,
        neg: (i)=>$88cd1e73c7abe0b8$var$H(-i, t),
        eql: (i, D)=>i === D,
        sqr: (i)=>$88cd1e73c7abe0b8$var$H(i * i, t),
        add: (i, D)=>$88cd1e73c7abe0b8$var$H(i + D, t),
        sub: (i, D)=>$88cd1e73c7abe0b8$var$H(i - D, t),
        mul: (i, D)=>$88cd1e73c7abe0b8$var$H(i * D, t),
        pow: (i, D)=>$88cd1e73c7abe0b8$var$fr(u, i, D),
        div: (i, D)=>$88cd1e73c7abe0b8$var$H(i * $88cd1e73c7abe0b8$var$Ae(D, t), t),
        sqrN: (i)=>i * i,
        addN: (i, D)=>i + D,
        subN: (i, D)=>i - D,
        mulN: (i, D)=>i * D,
        inv: (i)=>$88cd1e73c7abe0b8$var$Ae(i, t),
        sqrt: r.sqrt || ((i)=>(a || (a = $88cd1e73c7abe0b8$var$ir(t)), a(u, i))),
        invertBatch: (i)=>$88cd1e73c7abe0b8$var$Dr(u, i),
        cmov: (i, D, c)=>c ? D : i,
        toBytes: (i)=>n ? $88cd1e73c7abe0b8$var$Nt(i, s) : $88cd1e73c7abe0b8$var$ge(i, s),
        fromBytes: (i)=>{
            if (i.length !== s) throw new Error("Field.fromBytes: expected " + s + " bytes, got " + i.length);
            return n ? $88cd1e73c7abe0b8$var$Et(i) : $88cd1e73c7abe0b8$var$Pn(i);
        }
    });
    return Object.freeze(u);
}
const $88cd1e73c7abe0b8$var$Se = BigInt(0), $88cd1e73c7abe0b8$var$gt = BigInt(1);
function $88cd1e73c7abe0b8$var$zt(t, e) {
    const n = e.negate();
    return t ? n : e;
}
function $88cd1e73c7abe0b8$var$ve(t, e) {
    if (!Number.isSafeInteger(t) || t <= 0 || t > e) throw new Error("invalid window size, expected [1.." + e + "], got W=" + t);
}
function $88cd1e73c7abe0b8$var$Mt(t, e) {
    $88cd1e73c7abe0b8$var$ve(t, e);
    const n = Math.ceil(e / t) + 1, r = 2 ** (t - 1);
    return {
        windows: n,
        windowSize: r
    };
}
function $88cd1e73c7abe0b8$var$dr(t, e) {
    if (!Array.isArray(t)) throw new Error("array expected");
    t.forEach((n, r)=>{
        if (!(n instanceof e)) throw new Error("invalid point at index " + r);
    });
}
function $88cd1e73c7abe0b8$var$hr(t, e) {
    if (!Array.isArray(t)) throw new Error("array of scalars expected");
    t.forEach((n, r)=>{
        if (!e.isValid(n)) throw new Error("invalid scalar at index " + r);
    });
}
const $88cd1e73c7abe0b8$var$qt = new WeakMap, $88cd1e73c7abe0b8$var$Ie = new WeakMap;
function $88cd1e73c7abe0b8$var$$t(t) {
    return $88cd1e73c7abe0b8$var$Ie.get(t) || 1;
}
function $88cd1e73c7abe0b8$var$lr(t, e) {
    return {
        constTimeNegate: $88cd1e73c7abe0b8$var$zt,
        hasPrecomputes (n) {
            return $88cd1e73c7abe0b8$var$$t(n) !== 1;
        },
        unsafeLadder (n, r, o = t.ZERO) {
            let s = n;
            for(; r > $88cd1e73c7abe0b8$var$Se;)r & $88cd1e73c7abe0b8$var$gt && (o = o.add(s)), s = s.double(), r >>= $88cd1e73c7abe0b8$var$gt;
            return o;
        },
        precomputeWindow (n, r) {
            const { windows: o, windowSize: s } = $88cd1e73c7abe0b8$var$Mt(r, e), a = [];
            let u = n, i = u;
            for(let D = 0; D < o; D++){
                i = u, a.push(i);
                for(let c = 1; c < s; c++)i = i.add(u), a.push(i);
                u = i.double();
            }
            return a;
        },
        wNAF (n, r, o) {
            const { windows: s, windowSize: a } = $88cd1e73c7abe0b8$var$Mt(n, e);
            let u = t.ZERO, i = t.BASE;
            const D = BigInt(2 ** n - 1), c = 2 ** n, l = BigInt(n);
            for(let p = 0; p < s; p++){
                const w = p * a;
                let h = Number(o & D);
                o >>= l, h > a && (h -= c, o += $88cd1e73c7abe0b8$var$gt);
                const g = w, S = w + Math.abs(h) - 1, v = p % 2 !== 0, L = h < 0;
                h === 0 ? i = i.add($88cd1e73c7abe0b8$var$zt(v, r[g])) : u = u.add($88cd1e73c7abe0b8$var$zt(L, r[S]));
            }
            return {
                p: u,
                f: i
            };
        },
        wNAFUnsafe (n, r, o, s = t.ZERO) {
            const { windows: a, windowSize: u } = $88cd1e73c7abe0b8$var$Mt(n, e), i = BigInt(2 ** n - 1), D = 2 ** n, c = BigInt(n);
            for(let l = 0; l < a; l++){
                const p = l * u;
                if (o === $88cd1e73c7abe0b8$var$Se) break;
                let w = Number(o & i);
                if (o >>= c, w > u && (w -= D, o += $88cd1e73c7abe0b8$var$gt), w === 0) continue;
                let h = r[p + Math.abs(w) - 1];
                w < 0 && (h = h.negate()), s = s.add(h);
            }
            return s;
        },
        getPrecomputes (n, r, o) {
            let s = $88cd1e73c7abe0b8$var$qt.get(r);
            return s || (s = this.precomputeWindow(r, n), n !== 1 && $88cd1e73c7abe0b8$var$qt.set(r, o(s))), s;
        },
        wNAFCached (n, r, o) {
            const s = $88cd1e73c7abe0b8$var$$t(n);
            return this.wNAF(s, this.getPrecomputes(s, n, o), r);
        },
        wNAFCachedUnsafe (n, r, o, s) {
            const a = $88cd1e73c7abe0b8$var$$t(n);
            return a === 1 ? this.unsafeLadder(n, r, s) : this.wNAFUnsafe(a, this.getPrecomputes(a, n, o), r, s);
        },
        setWindowSize (n, r) {
            $88cd1e73c7abe0b8$var$ve(r, e), $88cd1e73c7abe0b8$var$Ie.set(n, r), $88cd1e73c7abe0b8$var$qt.delete(n);
        }
    };
}
function $88cd1e73c7abe0b8$var$br(t, e, n, r) {
    if ($88cd1e73c7abe0b8$var$dr(n, t), $88cd1e73c7abe0b8$var$hr(r, e), n.length !== r.length) throw new Error("arrays of points and scalars must have equal length");
    const o = t.ZERO, s = $88cd1e73c7abe0b8$var$tr(BigInt(n.length)), a = s > 12 ? s - 3 : s > 4 ? s - 2 : s ? 2 : 1, u = (1 << a) - 1, i = new Array(u + 1).fill(o), D = Math.floor((e.BITS - 1) / a) * a;
    let c = o;
    for(let l = D; l >= 0; l -= a){
        i.fill(o);
        for(let w = 0; w < r.length; w++){
            const h = r[w], g = Number(h >> BigInt(l) & BigInt(u));
            i[g] = i[g].add(n[w]);
        }
        let p = o;
        for(let w = i.length - 1, h = o; w > 0; w--)h = h.add(i[w]), p = p.add(h);
        if (c = c.add(p), l !== 0) for(let w = 0; w < a; w++)c = c.double();
    }
    return c;
}
function $88cd1e73c7abe0b8$var$pr(t) {
    return $88cd1e73c7abe0b8$var$ar(t.Fp), $88cd1e73c7abe0b8$var$Ot(t, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    }), Object.freeze({
        ...$88cd1e73c7abe0b8$var$me(t.n, t.nBitLength),
        ...t,
        p: t.Fp.ORDER
    });
}
const $88cd1e73c7abe0b8$var$G = BigInt(0), $88cd1e73c7abe0b8$var$j = BigInt(1), $88cd1e73c7abe0b8$var$yt = BigInt(2), $88cd1e73c7abe0b8$var$wr = BigInt(8), $88cd1e73c7abe0b8$var$Er = {
    zip215: !0
};
function $88cd1e73c7abe0b8$var$gr(t) {
    const e = $88cd1e73c7abe0b8$var$pr(t);
    return $88cd1e73c7abe0b8$var$Ot(t, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    }), Object.freeze({
        ...e
    });
}
function $88cd1e73c7abe0b8$var$yr(t) {
    const e = $88cd1e73c7abe0b8$var$gr(t), { Fp: n, n: r, prehash: o, hash: s, randomBytes: a, nByteLength: u, h: i } = e, D = $88cd1e73c7abe0b8$var$yt << BigInt(u * 8) - $88cd1e73c7abe0b8$var$j, c = n.create, l = $88cd1e73c7abe0b8$var$_e(e.n, e.nBitLength), p = e.uvRatio || ((y, f)=>{
        try {
            return {
                isValid: !0,
                value: n.sqrt(y * n.inv(f))
            };
        } catch  {
            return {
                isValid: !1,
                value: $88cd1e73c7abe0b8$var$G
            };
        }
    }), w = e.adjustScalarBytes || ((y)=>y), h = e.domain || ((y, f, b)=>{
        if ($88cd1e73c7abe0b8$var$Tt("phflag", b), f.length || b) throw new Error("Contexts/pre-hash are not supported");
        return y;
    });
    function g(y, f) {
        $88cd1e73c7abe0b8$var$ft("coordinate " + y, f, $88cd1e73c7abe0b8$var$G, D);
    }
    function S(y) {
        if (!(y instanceof d)) throw new Error("ExtendedPoint expected");
    }
    const v = $88cd1e73c7abe0b8$var$xe((y, f)=>{
        const { ex: b, ey: E, ez: B } = y, C = y.is0();
        f == null && (f = C ? $88cd1e73c7abe0b8$var$wr : n.inv(B));
        const A = c(b * f), U = c(E * f), _ = c(B * f);
        if (C) return {
            x: $88cd1e73c7abe0b8$var$G,
            y: $88cd1e73c7abe0b8$var$j
        };
        if (_ !== $88cd1e73c7abe0b8$var$j) throw new Error("invZ was invalid");
        return {
            x: A,
            y: U
        };
    }), L = $88cd1e73c7abe0b8$var$xe((y)=>{
        const { a: f, d: b } = e;
        if (y.is0()) throw new Error("bad point: ZERO");
        const { ex: E, ey: B, ez: C, et: A } = y, U = c(E * E), _ = c(B * B), T = c(C * C), $ = c(T * T), R = c(U * f), V = c(T * c(R + _)), Y = c($ + c(b * c(U * _)));
        if (V !== Y) throw new Error("bad point: equation left != right (1)");
        const Z = c(E * B), X = c(C * A);
        if (Z !== X) throw new Error("bad point: equation left != right (2)");
        return !0;
    });
    class d {
        constructor(f, b, E, B){
            this.ex = f, this.ey = b, this.ez = E, this.et = B, g("x", f), g("y", b), g("z", E), g("t", B), Object.freeze(this);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(f) {
            if (f instanceof d) throw new Error("extended point not allowed");
            const { x: b, y: E } = f || {};
            return g("x", b), g("y", E), new d(b, E, $88cd1e73c7abe0b8$var$j, c(b * E));
        }
        static normalizeZ(f) {
            const b = n.invertBatch(f.map((E)=>E.ez));
            return f.map((E, B)=>E.toAffine(b[B])).map(d.fromAffine);
        }
        static msm(f, b) {
            return $88cd1e73c7abe0b8$var$br(d, l, f, b);
        }
        _setWindowSize(f) {
            q.setWindowSize(this, f);
        }
        assertValidity() {
            L(this);
        }
        equals(f) {
            S(f);
            const { ex: b, ey: E, ez: B } = this, { ex: C, ey: A, ez: U } = f, _ = c(b * U), T = c(C * B), $ = c(E * U), R = c(A * B);
            return _ === T && $ === R;
        }
        is0() {
            return this.equals(d.ZERO);
        }
        negate() {
            return new d(c(-this.ex), this.ey, this.ez, c(-this.et));
        }
        double() {
            const { a: f } = e, { ex: b, ey: E, ez: B } = this, C = c(b * b), A = c(E * E), U = c($88cd1e73c7abe0b8$var$yt * c(B * B)), _ = c(f * C), T = b + E, $ = c(c(T * T) - C - A), R = _ + A, V = R - U, Y = _ - A, Z = c($ * V), X = c(R * Y), et = c($ * Y), pt = c(V * R);
            return new d(Z, X, pt, et);
        }
        add(f) {
            S(f);
            const { a: b, d: E } = e, { ex: B, ey: C, ez: A, et: U } = this, { ex: _, ey: T, ez: $, et: R } = f;
            if (b === BigInt(-1)) {
                const re = c((C - B) * (T + _)), oe = c((C + B) * (T - _)), mt = c(oe - re);
                if (mt === $88cd1e73c7abe0b8$var$G) return this.double();
                const se = c(A * $88cd1e73c7abe0b8$var$yt * R), ie = c(U * $88cd1e73c7abe0b8$var$yt * $), ue = ie + se, ce = oe + re, ae = ie - se, Dn = c(ue * mt), dn = c(ce * ae), hn = c(ue * ae), ln = c(mt * ce);
                return new d(Dn, dn, ln, hn);
            }
            const V = c(B * _), Y = c(C * T), Z = c(U * E * R), X = c(A * $), et = c((B + C) * (_ + T) - V - Y), pt = X - Z, ee = X + Z, ne = c(Y - b * V), un = c(et * pt), cn = c(ee * ne), an = c(et * ne), fn = c(pt * ee);
            return new d(un, cn, fn, an);
        }
        subtract(f) {
            return this.add(f.negate());
        }
        wNAF(f) {
            return q.wNAFCached(this, f, d.normalizeZ);
        }
        multiply(f) {
            const b = f;
            $88cd1e73c7abe0b8$var$ft("scalar", b, $88cd1e73c7abe0b8$var$j, r);
            const { p: E, f: B } = this.wNAF(b);
            return d.normalizeZ([
                E,
                B
            ])[0];
        }
        multiplyUnsafe(f, b = d.ZERO) {
            const E = f;
            return $88cd1e73c7abe0b8$var$ft("scalar", E, $88cd1e73c7abe0b8$var$G, r), E === $88cd1e73c7abe0b8$var$G ? F : this.is0() || E === $88cd1e73c7abe0b8$var$j ? this : q.wNAFCachedUnsafe(this, E, d.normalizeZ, b);
        }
        isSmallOrder() {
            return this.multiplyUnsafe(i).is0();
        }
        isTorsionFree() {
            return q.unsafeLadder(this, r).is0();
        }
        toAffine(f) {
            return v(this, f);
        }
        clearCofactor() {
            const { h: f } = e;
            return f === $88cd1e73c7abe0b8$var$j ? this : this.multiplyUnsafe(f);
        }
        static fromHex(f, b = !1) {
            const { d: E, a: B } = e, C = n.BYTES;
            f = $88cd1e73c7abe0b8$var$W("pointHex", f, C), $88cd1e73c7abe0b8$var$Tt("zip215", b);
            const A = f.slice(), U = f[C - 1];
            A[C - 1] = U & -129;
            const _ = $88cd1e73c7abe0b8$var$Et(A), T = b ? D : n.ORDER;
            $88cd1e73c7abe0b8$var$ft("pointHex.y", _, $88cd1e73c7abe0b8$var$G, T);
            const $ = c(_ * _), R = c($ - $88cd1e73c7abe0b8$var$j), V = c(E * $ - B);
            let { isValid: Y, value: Z } = p(R, V);
            if (!Y) throw new Error("Point.fromHex: invalid y coordinate");
            const X = (Z & $88cd1e73c7abe0b8$var$j) === $88cd1e73c7abe0b8$var$j, et = (U & 128) !== 0;
            if (!b && Z === $88cd1e73c7abe0b8$var$G && et) throw new Error("Point.fromHex: x=0 and x_0=1");
            return et !== X && (Z = c(-Z)), d.fromAffine({
                x: Z,
                y: _
            });
        }
        static fromPrivateKey(f) {
            return O(f).point;
        }
        toRawBytes() {
            const { x: f, y: b } = this.toAffine(), E = $88cd1e73c7abe0b8$var$Nt(b, n.BYTES);
            return E[E.length - 1] |= f & $88cd1e73c7abe0b8$var$j ? 128 : 0, E;
        }
        toHex() {
            return $88cd1e73c7abe0b8$var$Ft(this.toRawBytes());
        }
    }
    d.BASE = new d(e.Gx, e.Gy, $88cd1e73c7abe0b8$var$j, c(e.Gx * e.Gy)), d.ZERO = new d($88cd1e73c7abe0b8$var$G, $88cd1e73c7abe0b8$var$j, $88cd1e73c7abe0b8$var$j, $88cd1e73c7abe0b8$var$G);
    const { BASE: m, ZERO: F } = d, q = $88cd1e73c7abe0b8$var$lr(d, u * 8);
    function z(y) {
        return $88cd1e73c7abe0b8$var$H(y, r);
    }
    function I(y) {
        return z($88cd1e73c7abe0b8$var$Et(y));
    }
    function O(y) {
        const f = n.BYTES;
        y = $88cd1e73c7abe0b8$var$W("private key", y, f);
        const b = $88cd1e73c7abe0b8$var$W("hashed private key", s(y), 2 * f), E = w(b.slice(0, f)), B = b.slice(f, 2 * f), C = I(E), A = m.multiply(C), U = A.toRawBytes();
        return {
            head: E,
            prefix: B,
            scalar: C,
            point: A,
            pointBytes: U
        };
    }
    function ot(y) {
        return O(y).pointBytes;
    }
    function tt(y = new Uint8Array, ...f) {
        const b = $88cd1e73c7abe0b8$var$ye(...f);
        return I(s(h(b, $88cd1e73c7abe0b8$var$W("context", y), !!o)));
    }
    function st(y, f, b = {}) {
        y = $88cd1e73c7abe0b8$var$W("message", y), o && (y = o(y));
        const { prefix: E, scalar: B, pointBytes: C } = O(f), A = tt(b.context, E, y), U = m.multiply(A).toRawBytes(), _ = tt(b.context, U, C, y), T = z(A + _ * B);
        $88cd1e73c7abe0b8$var$ft("signature.s", T, $88cd1e73c7abe0b8$var$G, r);
        const $ = $88cd1e73c7abe0b8$var$ye(U, $88cd1e73c7abe0b8$var$Nt(T, n.BYTES));
        return $88cd1e73c7abe0b8$var$W("result", $, n.BYTES * 2);
    }
    const at = $88cd1e73c7abe0b8$var$Er;
    function Ct(y, f, b, E = at) {
        const { context: B, zip215: C } = E, A = n.BYTES;
        y = $88cd1e73c7abe0b8$var$W("signature", y, 2 * A), f = $88cd1e73c7abe0b8$var$W("message", f), b = $88cd1e73c7abe0b8$var$W("publicKey", b, A), C !== void 0 && $88cd1e73c7abe0b8$var$Tt("zip215", C), o && (f = o(f));
        const U = $88cd1e73c7abe0b8$var$Et(y.slice(A, 2 * A));
        let _, T, $;
        try {
            _ = d.fromHex(b, C), T = d.fromHex(y.slice(0, A), C), $ = m.multiplyUnsafe(U);
        } catch  {
            return !1;
        }
        if (!C && _.isSmallOrder()) return !1;
        const R = tt(B, T.toRawBytes(), _.toRawBytes(), f);
        return T.add(_.multiplyUnsafe(R)).subtract($).clearCofactor().equals(d.ZERO);
    }
    return m._setWindowSize(8), {
        CURVE: e,
        getPublicKey: ot,
        sign: st,
        verify: Ct,
        ExtendedPoint: d,
        utils: {
            getExtendedPublicKey: O,
            randomPrivateKey: ()=>a(n.BYTES),
            precompute (y = 8, f = d.BASE) {
                return f._setWindowSize(y), f.multiply(BigInt(3)), f;
            }
        }
    };
}
BigInt(0), BigInt(1);
const $88cd1e73c7abe0b8$var$kt = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), $88cd1e73c7abe0b8$var$Ue = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const $88cd1e73c7abe0b8$var$xr = BigInt(1), $88cd1e73c7abe0b8$var$Te = BigInt(2);
BigInt(3);
const $88cd1e73c7abe0b8$var$Br = BigInt(5), $88cd1e73c7abe0b8$var$Cr = BigInt(8);
function $88cd1e73c7abe0b8$var$Ar(t) {
    const e = BigInt(10), n = BigInt(20), r = BigInt(40), o = BigInt(80), s = $88cd1e73c7abe0b8$var$kt, u = t * t % s * t % s, i = $88cd1e73c7abe0b8$var$J(u, $88cd1e73c7abe0b8$var$Te, s) * u % s, D = $88cd1e73c7abe0b8$var$J(i, $88cd1e73c7abe0b8$var$xr, s) * t % s, c = $88cd1e73c7abe0b8$var$J(D, $88cd1e73c7abe0b8$var$Br, s) * D % s, l = $88cd1e73c7abe0b8$var$J(c, e, s) * c % s, p = $88cd1e73c7abe0b8$var$J(l, n, s) * l % s, w = $88cd1e73c7abe0b8$var$J(p, r, s) * p % s, h = $88cd1e73c7abe0b8$var$J(w, o, s) * w % s, g = $88cd1e73c7abe0b8$var$J(h, o, s) * w % s, S = $88cd1e73c7abe0b8$var$J(g, e, s) * c % s;
    return {
        pow_p_5_8: $88cd1e73c7abe0b8$var$J(S, $88cd1e73c7abe0b8$var$Te, s) * t % s,
        b2: u
    };
}
function $88cd1e73c7abe0b8$var$mr(t) {
    return t[0] &= 248, t[31] &= 127, t[31] |= 64, t;
}
function $88cd1e73c7abe0b8$var$_r(t, e) {
    const n = $88cd1e73c7abe0b8$var$kt, r = $88cd1e73c7abe0b8$var$H(e * e * e, n), o = $88cd1e73c7abe0b8$var$H(r * r * e, n), s = $88cd1e73c7abe0b8$var$Ar(t * o).pow_p_5_8;
    let a = $88cd1e73c7abe0b8$var$H(t * r * s, n);
    const u = $88cd1e73c7abe0b8$var$H(e * a * a, n), i = a, D = $88cd1e73c7abe0b8$var$H(a * $88cd1e73c7abe0b8$var$Ue, n), c = u === t, l = u === $88cd1e73c7abe0b8$var$H(-t, n), p = u === $88cd1e73c7abe0b8$var$H(-t * $88cd1e73c7abe0b8$var$Ue, n);
    return c && (a = i), (l || p) && (a = D), $88cd1e73c7abe0b8$var$ur(a, n) && (a = $88cd1e73c7abe0b8$var$H(-a, n)), {
        isValid: c || l,
        value: a
    };
}
const $88cd1e73c7abe0b8$var$Sr = (()=>$88cd1e73c7abe0b8$var$_e($88cd1e73c7abe0b8$var$kt, void 0, !0))(), $88cd1e73c7abe0b8$var$vr = (()=>({
        a: BigInt(-1),
        d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
        Fp: $88cd1e73c7abe0b8$var$Sr,
        n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
        h: $88cd1e73c7abe0b8$var$Cr,
        Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
        Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
        hash: $88cd1e73c7abe0b8$var$Kn,
        randomBytes: $88cd1e73c7abe0b8$var$he,
        adjustScalarBytes: $88cd1e73c7abe0b8$var$mr,
        uvRatio: $88cd1e73c7abe0b8$var$_r
    }))(), $88cd1e73c7abe0b8$var$Rt = (()=>$88cd1e73c7abe0b8$var$yr($88cd1e73c7abe0b8$var$vr))(), $88cd1e73c7abe0b8$export$51745f7832485c34 = "EdDSA", $88cd1e73c7abe0b8$export$f51b45e220f2ba98 = "JWT", $88cd1e73c7abe0b8$export$a3e35a0f952eb3ef = ".", $88cd1e73c7abe0b8$export$d2e6fe38c55f8e23 = "base64url", $88cd1e73c7abe0b8$export$c09c2801e10a2b95 = "utf8", $88cd1e73c7abe0b8$export$1e9219c0b91a4257 = "utf8", $88cd1e73c7abe0b8$export$d4057275de9d060b = ":", $88cd1e73c7abe0b8$export$acf13c61a1a0ccf3 = "did", $88cd1e73c7abe0b8$export$b908fe81ccf30934 = "key", $88cd1e73c7abe0b8$export$7bd18b7a7a4d0471 = "base58btc", $88cd1e73c7abe0b8$export$6d6d3d2e39be8d68 = "z", $88cd1e73c7abe0b8$export$9902a33a5776d1fc = "K36", $88cd1e73c7abe0b8$export$ca477e91394a742a = 32, $88cd1e73c7abe0b8$export$f09ad228919f26fb = 32;
function $88cd1e73c7abe0b8$var$Xt(t) {
    return globalThis.Buffer != null ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : t;
}
function $88cd1e73c7abe0b8$var$Le(t = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? $88cd1e73c7abe0b8$var$Xt(globalThis.Buffer.allocUnsafe(t)) : new Uint8Array(t);
}
function $88cd1e73c7abe0b8$var$Oe(t, e) {
    e || (e = t.reduce((o, s)=>o + s.length, 0));
    const n = $88cd1e73c7abe0b8$var$Le(e);
    let r = 0;
    for (const o of t)n.set(o, r), r += o.length;
    return $88cd1e73c7abe0b8$var$Xt(n);
}
function $88cd1e73c7abe0b8$var$Ir(t, e) {
    if (t.length >= 255) throw new TypeError("Alphabet too long");
    for(var n = new Uint8Array(256), r = 0; r < n.length; r++)n[r] = 255;
    for(var o = 0; o < t.length; o++){
        var s = t.charAt(o), a = s.charCodeAt(0);
        if (n[a] !== 255) throw new TypeError(s + " is ambiguous");
        n[a] = o;
    }
    var u = t.length, i = t.charAt(0), D = Math.log(u) / Math.log(256), c = Math.log(256) / Math.log(u);
    function l(h) {
        if (h instanceof Uint8Array || (ArrayBuffer.isView(h) ? h = new Uint8Array(h.buffer, h.byteOffset, h.byteLength) : Array.isArray(h) && (h = Uint8Array.from(h))), !(h instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (h.length === 0) return "";
        for(var g = 0, S = 0, v = 0, L = h.length; v !== L && h[v] === 0;)v++, g++;
        for(var d = (L - v) * c + 1 >>> 0, m = new Uint8Array(d); v !== L;){
            for(var F = h[v], q = 0, z = d - 1; (F !== 0 || q < S) && z !== -1; z--, q++)F += 256 * m[z] >>> 0, m[z] = F % u >>> 0, F = F / u >>> 0;
            if (F !== 0) throw new Error("Non-zero carry");
            S = q, v++;
        }
        for(var I = d - S; I !== d && m[I] === 0;)I++;
        for(var O = i.repeat(g); I < d; ++I)O += t.charAt(m[I]);
        return O;
    }
    function p(h) {
        if (typeof h != "string") throw new TypeError("Expected String");
        if (h.length === 0) return new Uint8Array;
        var g = 0;
        if (h[g] !== " ") {
            for(var S = 0, v = 0; h[g] === i;)S++, g++;
            for(var L = (h.length - g) * D + 1 >>> 0, d = new Uint8Array(L); h[g];){
                var m = n[h.charCodeAt(g)];
                if (m === 255) return;
                for(var F = 0, q = L - 1; (m !== 0 || F < v) && q !== -1; q--, F++)m += u * d[q] >>> 0, d[q] = m % 256 >>> 0, m = m / 256 >>> 0;
                if (m !== 0) throw new Error("Non-zero carry");
                v = F, g++;
            }
            if (h[g] !== " ") {
                for(var z = L - v; z !== L && d[z] === 0;)z++;
                for(var I = new Uint8Array(S + (L - z)), O = S; z !== L;)I[O++] = d[z++];
                return I;
            }
        }
    }
    function w(h) {
        var g = p(h);
        if (g) return g;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: l,
        decodeUnsafe: p,
        decode: w
    };
}
var $88cd1e73c7abe0b8$var$Ur = $88cd1e73c7abe0b8$var$Ir, $88cd1e73c7abe0b8$var$Tr = $88cd1e73c7abe0b8$var$Ur;
const $88cd1e73c7abe0b8$var$He = (t)=>{
    if (t instanceof Uint8Array && t.constructor.name === "Uint8Array") return t;
    if (t instanceof ArrayBuffer) return new Uint8Array(t);
    if (ArrayBuffer.isView(t)) return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $88cd1e73c7abe0b8$var$Fr = (t)=>new TextEncoder().encode(t), $88cd1e73c7abe0b8$var$Nr = (t)=>new TextDecoder().decode(t);
class $88cd1e73c7abe0b8$var$Lr {
    constructor(e, n, r){
        this.name = e, this.prefix = n, this.baseEncode = r;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $88cd1e73c7abe0b8$var$Or {
    constructor(e, n, r){
        if (this.name = e, this.prefix = n, n.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = n.codePointAt(0), this.baseDecode = r;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $88cd1e73c7abe0b8$var$ze(this, e);
    }
}
class $88cd1e73c7abe0b8$var$Hr {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $88cd1e73c7abe0b8$var$ze(this, e);
    }
    decode(e) {
        const n = e[0], r = this.decoders[n];
        if (r) return r.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $88cd1e73c7abe0b8$var$ze = (t, e)=>new $88cd1e73c7abe0b8$var$Hr({
        ...t.decoders || {
            [t.prefix]: t
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $88cd1e73c7abe0b8$var$zr {
    constructor(e, n, r, o){
        this.name = e, this.prefix = n, this.baseEncode = r, this.baseDecode = o, this.encoder = new $88cd1e73c7abe0b8$var$Lr(e, n, r), this.decoder = new $88cd1e73c7abe0b8$var$Or(e, n, o);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $88cd1e73c7abe0b8$var$Bt = ({ name: t, prefix: e, encode: n, decode: r })=>new $88cd1e73c7abe0b8$var$zr(t, e, n, r), $88cd1e73c7abe0b8$var$ht = ({ prefix: t, name: e, alphabet: n })=>{
    const { encode: r, decode: o } = $88cd1e73c7abe0b8$var$Tr(n, e);
    return $88cd1e73c7abe0b8$var$Bt({
        prefix: t,
        name: e,
        encode: r,
        decode: (s)=>$88cd1e73c7abe0b8$var$He(o(s))
    });
}, $88cd1e73c7abe0b8$var$Mr = (t, e, n, r)=>{
    const o = {};
    for(let c = 0; c < e.length; ++c)o[e[c]] = c;
    let s = t.length;
    for(; t[s - 1] === "=";)--s;
    const a = new Uint8Array(s * n / 8 | 0);
    let u = 0, i = 0, D = 0;
    for(let c = 0; c < s; ++c){
        const l = o[t[c]];
        if (l === void 0) throw new SyntaxError(`Non-${r} character`);
        i = i << n | l, u += n, u >= 8 && (u -= 8, a[D++] = 255 & i >> u);
    }
    if (u >= n || 255 & i << 8 - u) throw new SyntaxError("Unexpected end of data");
    return a;
}, $88cd1e73c7abe0b8$var$qr = (t, e, n)=>{
    const r = e[e.length - 1] === "=", o = (1 << n) - 1;
    let s = "", a = 0, u = 0;
    for(let i = 0; i < t.length; ++i)for(u = u << 8 | t[i], a += 8; a > n;)a -= n, s += e[o & u >> a];
    if (a && (s += e[o & u << n - a]), r) for(; s.length * n & 7;)s += "=";
    return s;
}, $88cd1e73c7abe0b8$var$k = ({ name: t, prefix: e, bitsPerChar: n, alphabet: r })=>$88cd1e73c7abe0b8$var$Bt({
        prefix: e,
        name: t,
        encode (o) {
            return $88cd1e73c7abe0b8$var$qr(o, r, n);
        },
        decode (o) {
            return $88cd1e73c7abe0b8$var$Mr(o, r, n, t);
        }
    }), $88cd1e73c7abe0b8$var$$r = $88cd1e73c7abe0b8$var$Bt({
    prefix: "\0",
    name: "identity",
    encode: (t)=>$88cd1e73c7abe0b8$var$Nr(t),
    decode: (t)=>$88cd1e73c7abe0b8$var$Fr(t)
});
var $88cd1e73c7abe0b8$var$kr = Object.freeze({
    __proto__: null,
    identity: $88cd1e73c7abe0b8$var$$r
});
const $88cd1e73c7abe0b8$var$Rr = $88cd1e73c7abe0b8$var$k({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $88cd1e73c7abe0b8$var$jr = Object.freeze({
    __proto__: null,
    base2: $88cd1e73c7abe0b8$var$Rr
});
const $88cd1e73c7abe0b8$var$Zr = $88cd1e73c7abe0b8$var$k({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $88cd1e73c7abe0b8$var$Gr = Object.freeze({
    __proto__: null,
    base8: $88cd1e73c7abe0b8$var$Zr
});
const $88cd1e73c7abe0b8$var$Vr = $88cd1e73c7abe0b8$var$ht({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $88cd1e73c7abe0b8$var$Yr = Object.freeze({
    __proto__: null,
    base10: $88cd1e73c7abe0b8$var$Vr
});
const $88cd1e73c7abe0b8$var$Jr = $88cd1e73c7abe0b8$var$k({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $88cd1e73c7abe0b8$var$Kr = $88cd1e73c7abe0b8$var$k({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $88cd1e73c7abe0b8$var$Wr = Object.freeze({
    __proto__: null,
    base16: $88cd1e73c7abe0b8$var$Jr,
    base16upper: $88cd1e73c7abe0b8$var$Kr
});
const $88cd1e73c7abe0b8$var$Xr = $88cd1e73c7abe0b8$var$k({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $88cd1e73c7abe0b8$var$Pr = $88cd1e73c7abe0b8$var$k({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $88cd1e73c7abe0b8$var$Qr = $88cd1e73c7abe0b8$var$k({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $88cd1e73c7abe0b8$var$to = $88cd1e73c7abe0b8$var$k({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $88cd1e73c7abe0b8$var$eo = $88cd1e73c7abe0b8$var$k({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $88cd1e73c7abe0b8$var$no = $88cd1e73c7abe0b8$var$k({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $88cd1e73c7abe0b8$var$ro = $88cd1e73c7abe0b8$var$k({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $88cd1e73c7abe0b8$var$oo = $88cd1e73c7abe0b8$var$k({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $88cd1e73c7abe0b8$var$so = $88cd1e73c7abe0b8$var$k({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $88cd1e73c7abe0b8$var$io = Object.freeze({
    __proto__: null,
    base32: $88cd1e73c7abe0b8$var$Xr,
    base32upper: $88cd1e73c7abe0b8$var$Pr,
    base32pad: $88cd1e73c7abe0b8$var$Qr,
    base32padupper: $88cd1e73c7abe0b8$var$to,
    base32hex: $88cd1e73c7abe0b8$var$eo,
    base32hexupper: $88cd1e73c7abe0b8$var$no,
    base32hexpad: $88cd1e73c7abe0b8$var$ro,
    base32hexpadupper: $88cd1e73c7abe0b8$var$oo,
    base32z: $88cd1e73c7abe0b8$var$so
});
const $88cd1e73c7abe0b8$var$uo = $88cd1e73c7abe0b8$var$ht({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $88cd1e73c7abe0b8$var$co = $88cd1e73c7abe0b8$var$ht({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $88cd1e73c7abe0b8$var$ao = Object.freeze({
    __proto__: null,
    base36: $88cd1e73c7abe0b8$var$uo,
    base36upper: $88cd1e73c7abe0b8$var$co
});
const $88cd1e73c7abe0b8$var$fo = $88cd1e73c7abe0b8$var$ht({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $88cd1e73c7abe0b8$var$Do = $88cd1e73c7abe0b8$var$ht({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $88cd1e73c7abe0b8$var$ho = Object.freeze({
    __proto__: null,
    base58btc: $88cd1e73c7abe0b8$var$fo,
    base58flickr: $88cd1e73c7abe0b8$var$Do
});
const $88cd1e73c7abe0b8$var$lo = $88cd1e73c7abe0b8$var$k({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $88cd1e73c7abe0b8$var$bo = $88cd1e73c7abe0b8$var$k({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $88cd1e73c7abe0b8$var$po = $88cd1e73c7abe0b8$var$k({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $88cd1e73c7abe0b8$var$wo = $88cd1e73c7abe0b8$var$k({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $88cd1e73c7abe0b8$var$Eo = Object.freeze({
    __proto__: null,
    base64: $88cd1e73c7abe0b8$var$lo,
    base64pad: $88cd1e73c7abe0b8$var$bo,
    base64url: $88cd1e73c7abe0b8$var$po,
    base64urlpad: $88cd1e73c7abe0b8$var$wo
});
const $88cd1e73c7abe0b8$var$Me = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $88cd1e73c7abe0b8$var$go = $88cd1e73c7abe0b8$var$Me.reduce((t, e, n)=>(t[n] = e, t), []), $88cd1e73c7abe0b8$var$yo = $88cd1e73c7abe0b8$var$Me.reduce((t, e, n)=>(t[e.codePointAt(0)] = n, t), []);
function $88cd1e73c7abe0b8$var$xo(t) {
    return t.reduce((e, n)=>(e += $88cd1e73c7abe0b8$var$go[n], e), "");
}
function $88cd1e73c7abe0b8$var$Bo(t) {
    const e = [];
    for (const n of t){
        const r = $88cd1e73c7abe0b8$var$yo[n.codePointAt(0)];
        if (r === void 0) throw new Error(`Non-base256emoji character: ${n}`);
        e.push(r);
    }
    return new Uint8Array(e);
}
const $88cd1e73c7abe0b8$var$Co = $88cd1e73c7abe0b8$var$Bt({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $88cd1e73c7abe0b8$var$xo,
    decode: $88cd1e73c7abe0b8$var$Bo
});
var $88cd1e73c7abe0b8$var$Ao = Object.freeze({
    __proto__: null,
    base256emoji: $88cd1e73c7abe0b8$var$Co
}), $88cd1e73c7abe0b8$var$mo = $88cd1e73c7abe0b8$var$$e, $88cd1e73c7abe0b8$var$qe = 128, $88cd1e73c7abe0b8$var$_o = 127, $88cd1e73c7abe0b8$var$So = ~$88cd1e73c7abe0b8$var$_o, $88cd1e73c7abe0b8$var$vo = Math.pow(2, 31);
function $88cd1e73c7abe0b8$var$$e(t, e, n) {
    e = e || [], n = n || 0;
    for(var r = n; t >= $88cd1e73c7abe0b8$var$vo;)e[n++] = t & 255 | $88cd1e73c7abe0b8$var$qe, t /= 128;
    for(; t & $88cd1e73c7abe0b8$var$So;)e[n++] = t & 255 | $88cd1e73c7abe0b8$var$qe, t >>>= 7;
    return e[n] = t | 0, $88cd1e73c7abe0b8$var$$e.bytes = n - r + 1, e;
}
var $88cd1e73c7abe0b8$var$Io = $88cd1e73c7abe0b8$var$Pt, $88cd1e73c7abe0b8$var$Uo = 128, $88cd1e73c7abe0b8$var$ke = 127;
function $88cd1e73c7abe0b8$var$Pt(t, r) {
    var n = 0, r = r || 0, o = 0, s = r, a, u = t.length;
    do {
        if (s >= u) throw $88cd1e73c7abe0b8$var$Pt.bytes = 0, new RangeError("Could not decode varint");
        a = t[s++], n += o < 28 ? (a & $88cd1e73c7abe0b8$var$ke) << o : (a & $88cd1e73c7abe0b8$var$ke) * Math.pow(2, o), o += 7;
    }while (a >= $88cd1e73c7abe0b8$var$Uo);
    return $88cd1e73c7abe0b8$var$Pt.bytes = s - r, n;
}
var $88cd1e73c7abe0b8$var$To = Math.pow(2, 7), $88cd1e73c7abe0b8$var$Fo = Math.pow(2, 14), $88cd1e73c7abe0b8$var$No = Math.pow(2, 21), $88cd1e73c7abe0b8$var$Lo = Math.pow(2, 28), $88cd1e73c7abe0b8$var$Oo = Math.pow(2, 35), $88cd1e73c7abe0b8$var$Ho = Math.pow(2, 42), $88cd1e73c7abe0b8$var$zo = Math.pow(2, 49), $88cd1e73c7abe0b8$var$Mo = Math.pow(2, 56), $88cd1e73c7abe0b8$var$qo = Math.pow(2, 63), $88cd1e73c7abe0b8$var$$o = function(t) {
    return t < $88cd1e73c7abe0b8$var$To ? 1 : t < $88cd1e73c7abe0b8$var$Fo ? 2 : t < $88cd1e73c7abe0b8$var$No ? 3 : t < $88cd1e73c7abe0b8$var$Lo ? 4 : t < $88cd1e73c7abe0b8$var$Oo ? 5 : t < $88cd1e73c7abe0b8$var$Ho ? 6 : t < $88cd1e73c7abe0b8$var$zo ? 7 : t < $88cd1e73c7abe0b8$var$Mo ? 8 : t < $88cd1e73c7abe0b8$var$qo ? 9 : 10;
}, $88cd1e73c7abe0b8$var$ko = {
    encode: $88cd1e73c7abe0b8$var$mo,
    decode: $88cd1e73c7abe0b8$var$Io,
    encodingLength: $88cd1e73c7abe0b8$var$$o
}, $88cd1e73c7abe0b8$var$Re = $88cd1e73c7abe0b8$var$ko;
const $88cd1e73c7abe0b8$var$je = (t, e, n = 0)=>($88cd1e73c7abe0b8$var$Re.encode(t, e, n), e), $88cd1e73c7abe0b8$var$Ze = (t)=>$88cd1e73c7abe0b8$var$Re.encodingLength(t), $88cd1e73c7abe0b8$var$Qt = (t, e)=>{
    const n = e.byteLength, r = $88cd1e73c7abe0b8$var$Ze(t), o = r + $88cd1e73c7abe0b8$var$Ze(n), s = new Uint8Array(o + n);
    return $88cd1e73c7abe0b8$var$je(t, s, 0), $88cd1e73c7abe0b8$var$je(n, s, r), s.set(e, o), new $88cd1e73c7abe0b8$var$Ro(t, n, e, s);
};
class $88cd1e73c7abe0b8$var$Ro {
    constructor(e, n, r, o){
        this.code = e, this.size = n, this.digest = r, this.bytes = o;
    }
}
const $88cd1e73c7abe0b8$var$Ge = ({ name: t, code: e, encode: n })=>new $88cd1e73c7abe0b8$var$jo(t, e, n);
class $88cd1e73c7abe0b8$var$jo {
    constructor(e, n, r){
        this.name = e, this.code = n, this.encode = r;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const n = this.encode(e);
            return n instanceof Uint8Array ? $88cd1e73c7abe0b8$var$Qt(this.code, n) : n.then((r)=>$88cd1e73c7abe0b8$var$Qt(this.code, r));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $88cd1e73c7abe0b8$var$Ve = (t)=>async (e)=>new Uint8Array(await crypto.subtle.digest(t, e)), $88cd1e73c7abe0b8$var$Zo = $88cd1e73c7abe0b8$var$Ge({
    name: "sha2-256",
    code: 18,
    encode: $88cd1e73c7abe0b8$var$Ve("SHA-256")
}), $88cd1e73c7abe0b8$var$Go = $88cd1e73c7abe0b8$var$Ge({
    name: "sha2-512",
    code: 19,
    encode: $88cd1e73c7abe0b8$var$Ve("SHA-512")
});
var $88cd1e73c7abe0b8$var$Vo = Object.freeze({
    __proto__: null,
    sha256: $88cd1e73c7abe0b8$var$Zo,
    sha512: $88cd1e73c7abe0b8$var$Go
});
const $88cd1e73c7abe0b8$var$Ye = 0, $88cd1e73c7abe0b8$var$Yo = "identity", $88cd1e73c7abe0b8$var$Je = $88cd1e73c7abe0b8$var$He, $88cd1e73c7abe0b8$var$Jo = (t)=>$88cd1e73c7abe0b8$var$Qt($88cd1e73c7abe0b8$var$Ye, $88cd1e73c7abe0b8$var$Je(t)), $88cd1e73c7abe0b8$var$Ko = {
    code: $88cd1e73c7abe0b8$var$Ye,
    name: $88cd1e73c7abe0b8$var$Yo,
    encode: $88cd1e73c7abe0b8$var$Je,
    digest: $88cd1e73c7abe0b8$var$Jo
};
var $88cd1e73c7abe0b8$var$Wo = Object.freeze({
    __proto__: null,
    identity: $88cd1e73c7abe0b8$var$Ko
});
new TextEncoder, new TextDecoder;
const $88cd1e73c7abe0b8$var$Ke = {
    ...$88cd1e73c7abe0b8$var$kr,
    ...$88cd1e73c7abe0b8$var$jr,
    ...$88cd1e73c7abe0b8$var$Gr,
    ...$88cd1e73c7abe0b8$var$Yr,
    ...$88cd1e73c7abe0b8$var$Wr,
    ...$88cd1e73c7abe0b8$var$io,
    ...$88cd1e73c7abe0b8$var$ao,
    ...$88cd1e73c7abe0b8$var$ho,
    ...$88cd1e73c7abe0b8$var$Eo,
    ...$88cd1e73c7abe0b8$var$Ao
};
({
    ...$88cd1e73c7abe0b8$var$Vo,
    ...$88cd1e73c7abe0b8$var$Wo
});
function $88cd1e73c7abe0b8$var$We(t, e, n, r) {
    return {
        name: t,
        prefix: e,
        encoder: {
            name: t,
            prefix: e,
            encode: n
        },
        decoder: {
            decode: r
        }
    };
}
const $88cd1e73c7abe0b8$var$Xe = $88cd1e73c7abe0b8$var$We("utf8", "u", (t)=>"u" + new TextDecoder("utf8").decode(t), (t)=>new TextEncoder().encode(t.substring(1))), $88cd1e73c7abe0b8$var$te = $88cd1e73c7abe0b8$var$We("ascii", "a", (t)=>{
    let e = "a";
    for(let n = 0; n < t.length; n++)e += String.fromCharCode(t[n]);
    return e;
}, (t)=>{
    t = t.substring(1);
    const e = $88cd1e73c7abe0b8$var$Le(t.length);
    for(let n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
    return e;
}), $88cd1e73c7abe0b8$var$Pe = {
    utf8: $88cd1e73c7abe0b8$var$Xe,
    "utf-8": $88cd1e73c7abe0b8$var$Xe,
    hex: $88cd1e73c7abe0b8$var$Ke.base16,
    latin1: $88cd1e73c7abe0b8$var$te,
    ascii: $88cd1e73c7abe0b8$var$te,
    binary: $88cd1e73c7abe0b8$var$te,
    ...$88cd1e73c7abe0b8$var$Ke
};
function $88cd1e73c7abe0b8$var$ct(t, e = "utf8") {
    const n = $88cd1e73c7abe0b8$var$Pe[e];
    if (!n) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(t.buffer, t.byteOffset, t.byteLength).toString("utf8") : n.encoder.encode(t).substring(1);
}
function $88cd1e73c7abe0b8$var$rt(t, e = "utf8") {
    const n = $88cd1e73c7abe0b8$var$Pe[e];
    if (!n) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? $88cd1e73c7abe0b8$var$Xt(globalThis.Buffer.from(t, "utf-8")) : n.decoder.decode(`${n.prefix}${t}`);
}
function $88cd1e73c7abe0b8$export$2030d1af6cd0ef93(t) {
    return (0, $81c2e06d24b89184$export$84137bb44359aed5)($88cd1e73c7abe0b8$var$ct($88cd1e73c7abe0b8$var$rt(t, $88cd1e73c7abe0b8$export$d2e6fe38c55f8e23), $88cd1e73c7abe0b8$export$c09c2801e10a2b95));
}
function $88cd1e73c7abe0b8$export$84046f8082657cdf(t) {
    return $88cd1e73c7abe0b8$var$ct($88cd1e73c7abe0b8$var$rt((0, $81c2e06d24b89184$export$abc3f407e87918a4)(t), $88cd1e73c7abe0b8$export$c09c2801e10a2b95), $88cd1e73c7abe0b8$export$d2e6fe38c55f8e23);
}
function $88cd1e73c7abe0b8$export$1b29ef9371459e10(t) {
    const e = $88cd1e73c7abe0b8$var$rt($88cd1e73c7abe0b8$export$9902a33a5776d1fc, $88cd1e73c7abe0b8$export$7bd18b7a7a4d0471), n = $88cd1e73c7abe0b8$export$6d6d3d2e39be8d68 + $88cd1e73c7abe0b8$var$ct($88cd1e73c7abe0b8$var$Oe([
        e,
        t
    ]), $88cd1e73c7abe0b8$export$7bd18b7a7a4d0471);
    return [
        $88cd1e73c7abe0b8$export$acf13c61a1a0ccf3,
        $88cd1e73c7abe0b8$export$b908fe81ccf30934,
        n
    ].join($88cd1e73c7abe0b8$export$d4057275de9d060b);
}
function $88cd1e73c7abe0b8$export$86ac046d72244356(t) {
    const [e, n, r] = t.split($88cd1e73c7abe0b8$export$d4057275de9d060b);
    if (e !== $88cd1e73c7abe0b8$export$acf13c61a1a0ccf3 || n !== $88cd1e73c7abe0b8$export$b908fe81ccf30934) throw new Error('Issuer must be a DID with method "key"');
    if (r.slice(0, 1) !== $88cd1e73c7abe0b8$export$6d6d3d2e39be8d68) throw new Error("Issuer must be a key in mulicodec format");
    const o = $88cd1e73c7abe0b8$var$rt(r.slice(1), $88cd1e73c7abe0b8$export$7bd18b7a7a4d0471);
    if ($88cd1e73c7abe0b8$var$ct(o.slice(0, 2), $88cd1e73c7abe0b8$export$7bd18b7a7a4d0471) !== $88cd1e73c7abe0b8$export$9902a33a5776d1fc) throw new Error('Issuer must be a public key with type "Ed25519"');
    const s = o.slice(2);
    if (s.length !== $88cd1e73c7abe0b8$export$ca477e91394a742a) throw new Error("Issuer must be a public key with length 32 bytes");
    return s;
}
function $88cd1e73c7abe0b8$export$d9746ef301b2089b(t) {
    return $88cd1e73c7abe0b8$var$ct(t, $88cd1e73c7abe0b8$export$d2e6fe38c55f8e23);
}
function $88cd1e73c7abe0b8$export$c37aeb372ac07c0e(t) {
    return $88cd1e73c7abe0b8$var$rt(t, $88cd1e73c7abe0b8$export$d2e6fe38c55f8e23);
}
function $88cd1e73c7abe0b8$export$cfdd1f2478131e3d(t) {
    return $88cd1e73c7abe0b8$var$rt([
        $88cd1e73c7abe0b8$export$84046f8082657cdf(t.header),
        $88cd1e73c7abe0b8$export$84046f8082657cdf(t.payload)
    ].join($88cd1e73c7abe0b8$export$a3e35a0f952eb3ef), $88cd1e73c7abe0b8$export$1e9219c0b91a4257);
}
function $88cd1e73c7abe0b8$export$13923bea59211b58(t) {
    const e = $88cd1e73c7abe0b8$var$ct(t, $88cd1e73c7abe0b8$export$1e9219c0b91a4257).split($88cd1e73c7abe0b8$export$a3e35a0f952eb3ef), n = $88cd1e73c7abe0b8$export$2030d1af6cd0ef93(e[0]), r = $88cd1e73c7abe0b8$export$2030d1af6cd0ef93(e[1]);
    return {
        header: n,
        payload: r
    };
}
function $88cd1e73c7abe0b8$export$1b70f4551c751d68(t) {
    return [
        $88cd1e73c7abe0b8$export$84046f8082657cdf(t.header),
        $88cd1e73c7abe0b8$export$84046f8082657cdf(t.payload),
        $88cd1e73c7abe0b8$export$d9746ef301b2089b(t.signature)
    ].join($88cd1e73c7abe0b8$export$a3e35a0f952eb3ef);
}
function $88cd1e73c7abe0b8$export$9a62e6c0a30e00bc(t) {
    const e = t.split($88cd1e73c7abe0b8$export$a3e35a0f952eb3ef), n = $88cd1e73c7abe0b8$export$2030d1af6cd0ef93(e[0]), r = $88cd1e73c7abe0b8$export$2030d1af6cd0ef93(e[1]), o = $88cd1e73c7abe0b8$export$c37aeb372ac07c0e(e[2]), s = $88cd1e73c7abe0b8$var$rt(e.slice(0, 2).join($88cd1e73c7abe0b8$export$a3e35a0f952eb3ef), $88cd1e73c7abe0b8$export$1e9219c0b91a4257);
    return {
        header: n,
        payload: r,
        signature: o,
        data: s
    };
}
function $88cd1e73c7abe0b8$export$a949d36eab55b41f(t = $88cd1e73c7abe0b8$var$he($88cd1e73c7abe0b8$export$f09ad228919f26fb)) {
    const e = $88cd1e73c7abe0b8$var$Rt.getPublicKey(t);
    return {
        secretKey: $88cd1e73c7abe0b8$var$Oe([
            t,
            e
        ]),
        publicKey: e
    };
}
async function $88cd1e73c7abe0b8$export$a8dda30659d36d45(t, e, n, r, o = (0, $7c6109395b060f04$exports.fromMiliseconds)(Date.now())) {
    const s = {
        alg: $88cd1e73c7abe0b8$export$51745f7832485c34,
        typ: $88cd1e73c7abe0b8$export$f51b45e220f2ba98
    }, a = $88cd1e73c7abe0b8$export$1b29ef9371459e10(r.publicKey), u = o + n, i = {
        iss: a,
        sub: t,
        aud: e,
        iat: o,
        exp: u
    }, D = $88cd1e73c7abe0b8$export$cfdd1f2478131e3d({
        header: s,
        payload: i
    }), c = $88cd1e73c7abe0b8$var$Rt.sign(D, r.secretKey.slice(0, 32));
    return $88cd1e73c7abe0b8$export$1b70f4551c751d68({
        header: s,
        payload: i,
        signature: c
    });
}
async function $88cd1e73c7abe0b8$export$7b6fc79aa8c5b79c(t) {
    const { header: e, payload: n, data: r, signature: o } = $88cd1e73c7abe0b8$export$9a62e6c0a30e00bc(t);
    if (e.alg !== $88cd1e73c7abe0b8$export$51745f7832485c34 || e.typ !== $88cd1e73c7abe0b8$export$f51b45e220f2ba98) throw new Error("JWT must use EdDSA algorithm");
    const s = $88cd1e73c7abe0b8$export$86ac046d72244356(n.iss);
    return $88cd1e73c7abe0b8$var$Rt.verify(o, r, s);
}



var $hPtJY = parcelRequire("hPtJY");
var $48968958eb8b72e8$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $48968958eb8b72e8$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = 'browser';
    }
    return BrowserInfo;
}();
var $48968958eb8b72e8$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = 'node';
        this.name = 'node';
        this.os = $hPtJY.platform;
    }
    return NodeInfo;
}();
var $48968958eb8b72e8$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = 'bot-device';
    }
    return SearchBotDeviceInfo;
}();
var $48968958eb8b72e8$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = 'bot';
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $48968958eb8b72e8$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = 'react-native';
        this.name = 'react-native';
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS = 3;
var $48968958eb8b72e8$var$userAgentRules = [
    [
        'aol',
        /AOLShield\/([0-9\._]+)/
    ],
    [
        'edge',
        /Edge\/([0-9\._]+)/
    ],
    [
        'edge-ios',
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        'yandexbrowser',
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        'kakaotalk',
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        'samsung',
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        'silk',
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        'miui',
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        'beaker',
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        'edge-chromium',
        /EdgA?\/([0-9\.]+)/
    ],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'chrome',
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'phantomjs',
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'crios',
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'firefox',
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        'fxios',
        /FxiOS\/([0-9\.]+)/
    ],
    [
        'opera-mini',
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        'opera',
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        'opera',
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'pie',
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        'pie',
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        'netfront',
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        'ie',
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        'ie',
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        'ie',
        /MSIE\s(7\.0)/
    ],
    [
        'bb10',
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        'android',
        /Android\s([0-9\.]+)/
    ],
    [
        'ios',
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        'safari',
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        'facebook',
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        'instagram',
        /Instagram\s([0-9\.]+)/
    ],
    [
        'ios-webview',
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        'ios-webview',
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        'curl',
        /^curl\/([0-9\.]+)$/
    ],
    [
        'searchbot',
        $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX
    ]
];
var $48968958eb8b72e8$var$operatingSystemRules = [
    [
        'iOS',
        /iP(hone|od|ad)/
    ],
    [
        'Android OS',
        /Android/
    ],
    [
        'BlackBerry OS',
        /BlackBerry|BB10/
    ],
    [
        'Windows Mobile',
        /IEMobile/
    ],
    [
        'Amazon OS',
        /Kindle/
    ],
    [
        'Windows 3.11',
        /Win16/
    ],
    [
        'Windows 95',
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        'Windows 98',
        /(Windows 98)|(Win98)/
    ],
    [
        'Windows 2000',
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        'Windows XP',
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        'Windows Server 2003',
        /(Windows NT 5.2)/
    ],
    [
        'Windows Vista',
        /(Windows NT 6.0)/
    ],
    [
        'Windows 7',
        /(Windows NT 6.1)/
    ],
    [
        'Windows 8',
        /(Windows NT 6.2)/
    ],
    [
        'Windows 8.1',
        /(Windows NT 6.3)/
    ],
    [
        'Windows 10',
        /(Windows NT 10.0)/
    ],
    [
        'Windows ME',
        /Windows ME/
    ],
    [
        'Windows CE',
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        'Open BSD',
        /OpenBSD/
    ],
    [
        'Sun OS',
        /SunOS/
    ],
    [
        'Chrome OS',
        /CrOS/
    ],
    [
        'Linux',
        /(Linux)|(X11)/
    ],
    [
        'Mac OS',
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        'QNX',
        /QNX/
    ],
    [
        'BeOS',
        /BeOS/
    ],
    [
        'OS/2',
        /OS\/2/
    ]
];
function $48968958eb8b72e8$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $48968958eb8b72e8$export$1184956100eddc3c(userAgent);
    if (typeof document === 'undefined' && typeof navigator !== 'undefined' && navigator.product === 'ReactNative') return new $48968958eb8b72e8$export$7c78fe95a9d9b03e();
    if (typeof navigator !== 'undefined') return $48968958eb8b72e8$export$1184956100eddc3c(navigator.userAgent);
    return $48968958eb8b72e8$export$bf2c6630ab904918();
}
function $48968958eb8b72e8$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== '' && $48968958eb8b72e8$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $48968958eb8b72e8$export$89ca9f8ca1a50fd5(ua) {
    var data = $48968958eb8b72e8$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $48968958eb8b72e8$export$1184956100eddc3c(ua) {
    var matchedRule = $48968958eb8b72e8$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') return new $48968958eb8b72e8$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split('.').join('_').split('_').slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS) versionParts = $48968958eb8b72e8$var$__spreadArray($48968958eb8b72e8$var$__spreadArray([], versionParts, true), $48968958eb8b72e8$var$createVersionParts($48968958eb8b72e8$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join('.');
    var os = $48968958eb8b72e8$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $48968958eb8b72e8$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $48968958eb8b72e8$export$8fa985da04a86f0(name, version, os);
}
function $48968958eb8b72e8$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $48968958eb8b72e8$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $48968958eb8b72e8$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $48968958eb8b72e8$export$bf2c6630ab904918() {
    var isNode = false;
    return isNode ? new $48968958eb8b72e8$export$62457c674e0167c0($hPtJY.version.slice(1)) : null;
}
function $48968958eb8b72e8$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push('0');
    return output;
}



var $9cba2bd26fe13e26$exports = {};
"use strict";
Object.defineProperty($9cba2bd26fe13e26$exports, "__esModule", {
    value: true
});
$9cba2bd26fe13e26$exports.getLocalStorage = $9cba2bd26fe13e26$exports.getLocalStorageOrThrow = $9cba2bd26fe13e26$exports.getCrypto = $9cba2bd26fe13e26$exports.getCryptoOrThrow = $9cba2bd26fe13e26$exports.getLocation = $9cba2bd26fe13e26$exports.getLocationOrThrow = $9cba2bd26fe13e26$exports.getNavigator = $9cba2bd26fe13e26$exports.getNavigatorOrThrow = $9cba2bd26fe13e26$exports.getDocument = $9cba2bd26fe13e26$exports.getDocumentOrThrow = $9cba2bd26fe13e26$exports.getFromWindowOrThrow = $9cba2bd26fe13e26$exports.getFromWindow = void 0;
function $9cba2bd26fe13e26$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
$9cba2bd26fe13e26$exports.getFromWindow = $9cba2bd26fe13e26$var$getFromWindow;
function $9cba2bd26fe13e26$var$getFromWindowOrThrow(name) {
    const res = $9cba2bd26fe13e26$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
$9cba2bd26fe13e26$exports.getFromWindowOrThrow = $9cba2bd26fe13e26$var$getFromWindowOrThrow;
function $9cba2bd26fe13e26$var$getDocumentOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("document");
}
$9cba2bd26fe13e26$exports.getDocumentOrThrow = $9cba2bd26fe13e26$var$getDocumentOrThrow;
function $9cba2bd26fe13e26$var$getDocument() {
    return $9cba2bd26fe13e26$var$getFromWindow("document");
}
$9cba2bd26fe13e26$exports.getDocument = $9cba2bd26fe13e26$var$getDocument;
function $9cba2bd26fe13e26$var$getNavigatorOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("navigator");
}
$9cba2bd26fe13e26$exports.getNavigatorOrThrow = $9cba2bd26fe13e26$var$getNavigatorOrThrow;
function $9cba2bd26fe13e26$var$getNavigator() {
    return $9cba2bd26fe13e26$var$getFromWindow("navigator");
}
$9cba2bd26fe13e26$exports.getNavigator = $9cba2bd26fe13e26$var$getNavigator;
function $9cba2bd26fe13e26$var$getLocationOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("location");
}
$9cba2bd26fe13e26$exports.getLocationOrThrow = $9cba2bd26fe13e26$var$getLocationOrThrow;
function $9cba2bd26fe13e26$var$getLocation() {
    return $9cba2bd26fe13e26$var$getFromWindow("location");
}
$9cba2bd26fe13e26$exports.getLocation = $9cba2bd26fe13e26$var$getLocation;
function $9cba2bd26fe13e26$var$getCryptoOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("crypto");
}
$9cba2bd26fe13e26$exports.getCryptoOrThrow = $9cba2bd26fe13e26$var$getCryptoOrThrow;
function $9cba2bd26fe13e26$var$getCrypto() {
    return $9cba2bd26fe13e26$var$getFromWindow("crypto");
}
$9cba2bd26fe13e26$exports.getCrypto = $9cba2bd26fe13e26$var$getCrypto;
function $9cba2bd26fe13e26$var$getLocalStorageOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("localStorage");
}
$9cba2bd26fe13e26$exports.getLocalStorageOrThrow = $9cba2bd26fe13e26$var$getLocalStorageOrThrow;
function $9cba2bd26fe13e26$var$getLocalStorage() {
    return $9cba2bd26fe13e26$var$getFromWindow("localStorage");
}
$9cba2bd26fe13e26$exports.getLocalStorage = $9cba2bd26fe13e26$var$getLocalStorage;


var $6824eb17eeee766a$exports = {};
"use strict";
Object.defineProperty($6824eb17eeee766a$exports, "__esModule", {
    value: true
});
$6824eb17eeee766a$exports.getWindowMetadata = void 0;

function $6824eb17eeee766a$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $9cba2bd26fe13e26$exports.getDocumentOrThrow();
        loc = $9cba2bd26fe13e26$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$6824eb17eeee766a$exports.getWindowMetadata = $6824eb17eeee766a$var$getWindowMetadata;


const $4b9cd088fca23de9$export$83d89fbfd8236492 = "logger/5.8.0";


"use strict";
let $97a8d5981d597bb7$var$_permanentCensorErrors = false;
let $97a8d5981d597bb7$var$_censorErrors = false;
const $97a8d5981d597bb7$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $97a8d5981d597bb7$var$_logLevel = $97a8d5981d597bb7$var$LogLevels["default"];
let $97a8d5981d597bb7$var$_globalLogger = null;
function $97a8d5981d597bb7$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $97a8d5981d597bb7$var$_normalizeError = $97a8d5981d597bb7$var$_checkNormalize();
var $97a8d5981d597bb7$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($97a8d5981d597bb7$export$243e62d78d3b544d || ($97a8d5981d597bb7$export$243e62d78d3b544d = {}));
var $97a8d5981d597bb7$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($97a8d5981d597bb7$export$d4e71bc0b80dc0fb || ($97a8d5981d597bb7$export$d4e71bc0b80dc0fb = {}));
const $97a8d5981d597bb7$var$HEX = "0123456789abcdef";
class $97a8d5981d597bb7$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($97a8d5981d597bb7$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($97a8d5981d597bb7$var$_logLevel > $97a8d5981d597bb7$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($97a8d5981d597bb7$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $97a8d5981d597bb7$var$HEX[value[i] >> 4];
                        hex += $97a8d5981d597bb7$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https:/\/links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($97a8d5981d597bb7$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $97a8d5981d597bb7$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$97a8d5981d597bb7$var$_globalLogger) $97a8d5981d597bb7$var$_globalLogger = new $97a8d5981d597bb7$export$efa9a398d6368992((0, $4b9cd088fca23de9$export$83d89fbfd8236492));
        return $97a8d5981d597bb7$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($97a8d5981d597bb7$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $97a8d5981d597bb7$var$_censorErrors = !!censorship;
        $97a8d5981d597bb7$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $97a8d5981d597bb7$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $97a8d5981d597bb7$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $97a8d5981d597bb7$var$_logLevel = level;
    }
    static from(version) {
        return new $97a8d5981d597bb7$export$efa9a398d6368992(version);
    }
}
$97a8d5981d597bb7$export$efa9a398d6368992.errors = $97a8d5981d597bb7$export$d4e71bc0b80dc0fb;
$97a8d5981d597bb7$export$efa9a398d6368992.levels = $97a8d5981d597bb7$export$243e62d78d3b544d;


const $95fe903f324809f2$export$83d89fbfd8236492 = "bytes/5.8.0";


"use strict";
const $7b88b6e03e4708f2$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $95fe903f324809f2$export$83d89fbfd8236492));
///////////////////////////////
function $7b88b6e03e4708f2$var$isHexable(value) {
    return !!value.toHexString;
}
function $7b88b6e03e4708f2$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $7b88b6e03e4708f2$export$9a14abb1a440cd5e(value) {
    return $7b88b6e03e4708f2$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $7b88b6e03e4708f2$export$c6fabfbfd097fc30(value);
}
function $7b88b6e03e4708f2$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $7b88b6e03e4708f2$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$7b88b6e03e4708f2$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$7b88b6e03e4708f2$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $7b88b6e03e4708f2$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $7b88b6e03e4708f2$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($7b88b6e03e4708f2$var$isHexable(value)) value = value.toHexString();
    if ($7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(result));
    }
    if ($7b88b6e03e4708f2$export$c6fabfbfd097fc30(value)) return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(value));
    return $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $7b88b6e03e4708f2$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$7b88b6e03e4708f2$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $7b88b6e03e4708f2$var$addSlice(result);
}
function $7b88b6e03e4708f2$export$a8f4574d0e56446c(value) {
    let result = $7b88b6e03e4708f2$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d(value, length) {
    value = $7b88b6e03e4708f2$export$3131421a7d01b4fb(value);
    if (value.length > length) $7b88b6e03e4708f2$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $7b88b6e03e4708f2$var$addSlice(result);
}
function $7b88b6e03e4708f2$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $7b88b6e03e4708f2$var$HexCharacters = "0123456789abcdef";
function $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $7b88b6e03e4708f2$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $7b88b6e03e4708f2$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($7b88b6e03e4708f2$var$isHexable(value)) return value.toHexString();
    if ($7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($7b88b6e03e4708f2$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $7b88b6e03e4708f2$var$HexCharacters[(v & 0xf0) >> 4] + $7b88b6e03e4708f2$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $7b88b6e03e4708f2$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(data);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $7b88b6e03e4708f2$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(data);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(data) || data.length % 2) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $7b88b6e03e4708f2$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $7b88b6e03e4708f2$export$6916af760a341dd3(value) {
    const trimmed = $7b88b6e03e4708f2$export$967bc0082a978949($7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $7b88b6e03e4708f2$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value);
    if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $7b88b6e03e4708f2$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $7b88b6e03e4708f2$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $7b88b6e03e4708f2$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($7b88b6e03e4708f2$export$9a14abb1a440cd5e(signature)) {
        let bytes = $7b88b6e03e4708f2$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d($7b88b6e03e4708f2$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result.r)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result.s)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result.s, 32);
        const vs = $7b88b6e03e4708f2$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result._vs)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $7b88b6e03e4708f2$export$71bb9d78a59bbe25(signature) {
    signature = $7b88b6e03e4708f2$export$7fb170f1e457988f(signature);
    return $7b88b6e03e4708f2$export$2b0d6b5fbe698c70($7b88b6e03e4708f2$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}



var $dEXSZ = parcelRequire("dEXSZ");


const $a38aef31efdfa85e$export$83d89fbfd8236492 = "bignumber/5.8.0";


"use strict";
var $0df4577496dcf693$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).BN;
const $0df4577496dcf693$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $a38aef31efdfa85e$export$83d89fbfd8236492));
const $0df4577496dcf693$var$_constructorGuard = {};
const $0df4577496dcf693$var$MAX_SAFE = 0x1fffffffffffff;
function $0df4577496dcf693$export$a3d0a7fa9b65683b(value) {
    return value != null && ($0df4577496dcf693$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value) || typeof value === "bigint" || (0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(value));
}
// Only warn about passing 10 into radix once
let $0df4577496dcf693$var$_warnedToStringRadix = false;
class $0df4577496dcf693$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $0df4577496dcf693$var$_constructorGuard) $0df4577496dcf693$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $0df4577496dcf693$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).add($0df4577496dcf693$var$toBN(other)));
    }
    sub(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).sub($0df4577496dcf693$var$toBN(other)));
    }
    div(other) {
        const o = $0df4577496dcf693$export$d97aa349ed20696.from(other);
        if (o.isZero()) $0df4577496dcf693$var$throwFault("division-by-zero", "div");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).div($0df4577496dcf693$var$toBN(other)));
    }
    mul(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).mul($0df4577496dcf693$var$toBN(other)));
    }
    mod(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (value.isNeg()) $0df4577496dcf693$var$throwFault("division-by-zero", "mod");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (value.isNeg()) $0df4577496dcf693$var$throwFault("negative-power", "pow");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "and");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).and(value));
    }
    or(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "or");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "xor");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "mask");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "shl");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "shr");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $0df4577496dcf693$var$toBN(this).eq($0df4577496dcf693$var$toBN(other));
    }
    lt(other) {
        return $0df4577496dcf693$var$toBN(this).lt($0df4577496dcf693$var$toBN(other));
    }
    lte(other) {
        return $0df4577496dcf693$var$toBN(this).lte($0df4577496dcf693$var$toBN(other));
    }
    gt(other) {
        return $0df4577496dcf693$var$toBN(this).gt($0df4577496dcf693$var$toBN(other));
    }
    gte(other) {
        return $0df4577496dcf693$var$toBN(this).gte($0df4577496dcf693$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $0df4577496dcf693$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $0df4577496dcf693$var$toBN(this).toNumber();
        } catch (error) {
            $0df4577496dcf693$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $0df4577496dcf693$var$logger.throwError("this platform does not support BigInt", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$0df4577496dcf693$var$_warnedToStringRadix) {
                    $0df4577496dcf693$var$_warnedToStringRadix = true;
                    $0df4577496dcf693$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $0df4577496dcf693$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
            else $0df4577496dcf693$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $0df4577496dcf693$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $0df4577496dcf693$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $0df4577496dcf693$export$d97aa349ed20696($0df4577496dcf693$var$_constructorGuard, $0df4577496dcf693$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $0df4577496dcf693$export$d97aa349ed20696($0df4577496dcf693$var$_constructorGuard, $0df4577496dcf693$var$toHex(new $0df4577496dcf693$var$BN(value)));
            return $0df4577496dcf693$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $0df4577496dcf693$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $0df4577496dcf693$var$MAX_SAFE || value <= -$0df4577496dcf693$var$MAX_SAFE) $0df4577496dcf693$var$throwFault("overflow", "BigNumber.from", value);
            return $0df4577496dcf693$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $0df4577496dcf693$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(anyValue)) return $0df4577496dcf693$export$d97aa349ed20696.from((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $0df4577496dcf693$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(hex) || hex[0] === "-" && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(hex.substring(1))) return $0df4577496dcf693$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $0df4577496dcf693$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $0df4577496dcf693$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $0df4577496dcf693$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $0df4577496dcf693$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $0df4577496dcf693$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $0df4577496dcf693$var$toBigNumber(value) {
    return $0df4577496dcf693$export$d97aa349ed20696.from($0df4577496dcf693$var$toHex(value));
}
function $0df4577496dcf693$var$toBN(value) {
    const hex = $0df4577496dcf693$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $0df4577496dcf693$var$BN("-" + hex.substring(3), 16);
    return new $0df4577496dcf693$var$BN(hex.substring(2), 16);
}
function $0df4577496dcf693$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $0df4577496dcf693$var$logger.throwError(fault, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
function $0df4577496dcf693$export$51e4a08295f7770f(value) {
    return new $0df4577496dcf693$var$BN(value, 36).toString(16);
}
function $0df4577496dcf693$export$1293db5d29c264ff(value) {
    return new $0df4577496dcf693$var$BN(value, 16).toString(36);
}


var $140ac3b566c7a94d$exports = {};
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var INPUT_ERROR = 'input is invalid type';
    var FINALIZE_ERROR = 'finalize already called';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && false;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && $140ac3b566c7a94d$exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        'hex',
        'buffer',
        'arrayBuffer',
        'array',
        'digest'
    ];
    var CSHAKE_BYTEPAD = {
        '128': 168,
        '256': 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods['cshake' + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods['kmac' + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, 'hex');
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, 'hex');
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, 'hex');
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods['shake' + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, 'hex');
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                'KMAC',
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: 'keccak',
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: 'sha3',
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: 'shake',
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: 'cshake',
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: 'kmac',
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + '_' + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== 'sha3') {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== 'string') {
            if (type === 'object') {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = '', block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) $140ac3b566c7a94d$exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();



"use strict";
function $1dbc6131e27af3ca$export$f8151fce47ad1c35(data) {
    return '0x' + (0, (/*@__PURE__*/$parcel$interopDefault($140ac3b566c7a94d$exports))).keccak_256((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data));
}




const $82765913239667f9$export$83d89fbfd8236492 = "rlp/5.8.0";


"use strict";
const $6ff2d0f6bfa15181$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $82765913239667f9$export$83d89fbfd8236492));
function $6ff2d0f6bfa15181$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $6ff2d0f6bfa15181$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($6ff2d0f6bfa15181$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $6ff2d0f6bfa15181$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $7b88b6e03e4708f2$export$9a14abb1a440cd5e)(object)) $6ff2d0f6bfa15181$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $6ff2d0f6bfa15181$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $6ff2d0f6bfa15181$export$c564cdbbe6da493(object) {
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)($6ff2d0f6bfa15181$var$_encode(object));
}
function $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $6ff2d0f6bfa15181$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $6ff2d0f6bfa15181$var$logger.throwError("child data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $6ff2d0f6bfa15181$var$_decode(data, offset) {
    if (data.length === 0) $6ff2d0f6bfa15181$var$logger.throwError("data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data short segment too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data long segment too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data[offset])
    };
}
function $6ff2d0f6bfa15181$export$2f872c0f2117be69(data) {
    const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
    const decoded = $6ff2d0f6bfa15181$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $6ff2d0f6bfa15181$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}



const $f0caac95ce71359f$export$83d89fbfd8236492 = "address/5.8.0";


"use strict";
const $8aee8aee2d40605d$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $f0caac95ce71359f$export$83d89fbfd8236492));
function $8aee8aee2d40605d$var$getChecksumAddress(address) {
    if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(address, 20)) $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $8aee8aee2d40605d$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $8aee8aee2d40605d$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $8aee8aee2d40605d$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$8aee8aee2d40605d$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$8aee8aee2d40605d$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $8aee8aee2d40605d$var$safeDigits = Math.floor($8aee8aee2d40605d$var$log10($8aee8aee2d40605d$var$MAX_SAFE_INTEGER));
function $8aee8aee2d40605d$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $8aee8aee2d40605d$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $8aee8aee2d40605d$var$safeDigits){
        let block = expanded.substring(0, $8aee8aee2d40605d$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $8aee8aee2d40605d$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $8aee8aee2d40605d$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $8aee8aee2d40605d$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $8aee8aee2d40605d$var$ibanChecksum(address)) $8aee8aee2d40605d$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $0df4577496dcf693$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $8aee8aee2d40605d$var$getChecksumAddress("0x" + result);
    } else $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $8aee8aee2d40605d$export$977e255126d763d6(address) {
    try {
        $8aee8aee2d40605d$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $8aee8aee2d40605d$export$962c4ddada9f668f(address) {
    let base36 = (0, $0df4577496dcf693$export$1293db5d29c264ff)($8aee8aee2d40605d$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $8aee8aee2d40605d$var$ibanChecksum("XE00" + base36) + base36;
}
function $8aee8aee2d40605d$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $8aee8aee2d40605d$export$88411125f012957a(transaction.from);
    } catch (error) {
        $8aee8aee2d40605d$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $8aee8aee2d40605d$export$88411125f012957a((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $6ff2d0f6bfa15181$export$c564cdbbe6da493)([
        from,
        nonce
    ])), 12));
}
function $8aee8aee2d40605d$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(salt) !== 32) $8aee8aee2d40605d$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(initCodeHash) !== 32) $8aee8aee2d40605d$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $8aee8aee2d40605d$export$88411125f012957a((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        "0xff",
        $8aee8aee2d40605d$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}





const $c5333cf79421e056$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(-1);
const $c5333cf79421e056$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(0);
const $c5333cf79421e056$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(1);
const $c5333cf79421e056$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(2);
const $c5333cf79421e056$export$c8db55bd7405209e = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("1000000000000000000");
const $c5333cf79421e056$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $c5333cf79421e056$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $c5333cf79421e056$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");




const $ec235c03b0398629$export$83d89fbfd8236492 = "properties/5.8.0";


"use strict";
var $a463a6b5f08d6875$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $a463a6b5f08d6875$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $ec235c03b0398629$export$83d89fbfd8236492));
function $a463a6b5f08d6875$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $a463a6b5f08d6875$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $a463a6b5f08d6875$export$d503dd157d963b60(object) {
    return $a463a6b5f08d6875$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $a463a6b5f08d6875$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $a463a6b5f08d6875$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $a463a6b5f08d6875$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $a463a6b5f08d6875$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $a463a6b5f08d6875$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$a463a6b5f08d6875$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $a463a6b5f08d6875$var$_deepCopy(object) {
    if ($a463a6b5f08d6875$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$a463a6b5f08d6875$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $a463a6b5f08d6875$export$104236534534f9be(result, key, $a463a6b5f08d6875$export$6c40052bed430212(value));
        }
        return result;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $a463a6b5f08d6875$export$6c40052bed430212(object) {
    return $a463a6b5f08d6875$var$_deepCopy(object);
}
class $a463a6b5f08d6875$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $a463a6b5f08d6875$export$6c40052bed430212(info[key]);
    }
}




var $dEXSZ = parcelRequire("dEXSZ");

var $kiSKt = parcelRequire("kiSKt");
var $63aabbf7dfa8a956$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $63aabbf7dfa8a956$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function $63aabbf7dfa8a956$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $63aabbf7dfa8a956$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $63aabbf7dfa8a956$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, 'default') ? n['default'] : n;
}
function $63aabbf7dfa8a956$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, 'default') && Object.keys(n).length === 1 ? n['default'] : n;
}
function $63aabbf7dfa8a956$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, '__esModule', {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $63aabbf7dfa8a956$var$commonjsRequire() {
    throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}
var $63aabbf7dfa8a956$var$minimalisticAssert = $63aabbf7dfa8a956$var$assert;
function $63aabbf7dfa8a956$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$63aabbf7dfa8a956$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};
var $63aabbf7dfa8a956$var$utils_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    'use strict';
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== 'string') {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return '0' + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = '';
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === 'hex') return toHex(arr);
        else return arr;
    };
});
var $63aabbf7dfa8a956$var$utils_1$1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    'use strict';
    var utils = exports;
    utils.assert = $63aabbf7dfa8a956$var$minimalisticAssert;
    utils.toArray = $63aabbf7dfa8a956$var$utils_1.toArray;
    utils.zero2 = $63aabbf7dfa8a956$var$utils_1.zero2;
    utils.toHex = $63aabbf7dfa8a956$var$utils_1.toHex;
    utils.encode = $63aabbf7dfa8a956$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        var i;
        for(i = 0; i < naf.length; i += 1)naf[i] = 0;
        var ws = 1 << w + 1;
        var k = num.clone();
        for(i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = '_' + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(bytes, 'hex', 'le');
    }
    utils.intFromLE = intFromLE;
});
'use strict';
var $63aabbf7dfa8a956$var$getNAF = $63aabbf7dfa8a956$var$utils_1$1.getNAF;
var $63aabbf7dfa8a956$var$getJSF = $63aabbf7dfa8a956$var$utils_1$1.getJSF;
var $63aabbf7dfa8a956$var$assert$1 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $63aabbf7dfa8a956$var$base = $63aabbf7dfa8a956$var$BaseCurve;
$63aabbf7dfa8a956$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$63aabbf7dfa8a956$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $63aabbf7dfa8a956$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $63aabbf7dfa8a956$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $63aabbf7dfa8a956$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $63aabbf7dfa8a956$var$assert$1(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $63aabbf7dfa8a956$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $63aabbf7dfa8a956$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $63aabbf7dfa8a956$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $63aabbf7dfa8a956$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$63aabbf7dfa8a956$var$BaseCurve.BasePoint = $63aabbf7dfa8a956$var$BasePoint;
$63aabbf7dfa8a956$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$63aabbf7dfa8a956$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$63aabbf7dfa8a956$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $63aabbf7dfa8a956$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $63aabbf7dfa8a956$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $63aabbf7dfa8a956$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$63aabbf7dfa8a956$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$63aabbf7dfa8a956$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$63aabbf7dfa8a956$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $63aabbf7dfa8a956$var$utils_1$1.encode(this._encode(compact), enc);
};
$63aabbf7dfa8a956$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$63aabbf7dfa8a956$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$63aabbf7dfa8a956$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $63aabbf7dfa8a956$var$inherits_browser = $63aabbf7dfa8a956$var$createCommonjsModule(function(module) {
    if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
'use strict';
var $63aabbf7dfa8a956$var$assert$2 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$ShortCurve(conf) {
    $63aabbf7dfa8a956$var$base.call(this, 'short', conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$ShortCurve, $63aabbf7dfa8a956$var$base);
var $63aabbf7dfa8a956$var$short_1 = $63aabbf7dfa8a956$var$ShortCurve;
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $63aabbf7dfa8a956$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $63aabbf7dfa8a956$var$Point(curve, x, y, isRed) {
    $63aabbf7dfa8a956$var$base.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$Point, $63aabbf7dfa8a956$var$base.BasePoint);
$63aabbf7dfa8a956$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $63aabbf7dfa8a956$var$Point(this, x, y, isRed);
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $63aabbf7dfa8a956$var$Point.fromJSON(this, obj, red);
};
$63aabbf7dfa8a956$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$63aabbf7dfa8a956$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$63aabbf7dfa8a956$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$63aabbf7dfa8a956$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$63aabbf7dfa8a956$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$63aabbf7dfa8a956$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$63aabbf7dfa8a956$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$63aabbf7dfa8a956$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$63aabbf7dfa8a956$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$63aabbf7dfa8a956$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$63aabbf7dfa8a956$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$63aabbf7dfa8a956$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$63aabbf7dfa8a956$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$63aabbf7dfa8a956$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$63aabbf7dfa8a956$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $63aabbf7dfa8a956$var$JPoint(curve, x, y, z) {
    $63aabbf7dfa8a956$var$base.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$JPoint, $63aabbf7dfa8a956$var$base.BasePoint);
$63aabbf7dfa8a956$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $63aabbf7dfa8a956$var$JPoint(this, x, y, z);
};
$63aabbf7dfa8a956$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$63aabbf7dfa8a956$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$63aabbf7dfa8a956$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$63aabbf7dfa8a956$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$63aabbf7dfa8a956$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$63aabbf7dfa8a956$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$63aabbf7dfa8a956$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$63aabbf7dfa8a956$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $63aabbf7dfa8a956$var$curve_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    'use strict';
    var curve = exports;
    curve.base = $63aabbf7dfa8a956$var$base;
    curve.short = $63aabbf7dfa8a956$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $63aabbf7dfa8a956$var$curves_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    'use strict';
    var curves = exports;
    var assert = $63aabbf7dfa8a956$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === 'short') this.curve = new $63aabbf7dfa8a956$var$curve_1.short(options);
        else if (options.type === 'edwards') this.curve = new $63aabbf7dfa8a956$var$curve_1.edwards(options);
        else this.curve = new $63aabbf7dfa8a956$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), 'Invalid curve');
        assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve('p192', {
        type: 'short',
        prime: 'p192',
        p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
        a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
        b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
        n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
            '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
        ]
    });
    defineCurve('p224', {
        type: 'short',
        prime: 'p224',
        p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
        a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
        b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
        n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
            'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
        ]
    });
    defineCurve('p256', {
        type: 'short',
        prime: null,
        p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
        a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
        b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
        n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
            '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
        ]
    });
    defineCurve('p384', {
        type: 'short',
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve('p521', {
        type: 'short',
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve('curve25519', {
        type: 'mont',
        prime: 'p25519',
        p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
        a: '76d06',
        b: '1',
        n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            '9'
        ]
    });
    defineCurve('ed25519', {
        type: 'edwards',
        prime: 'p25519',
        p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
        a: '-1',
        c: '1',
        // -121665 * (121666^(-1)) (mod P)
        d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
        n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
            // 4/5
            '6666666666666666666666666666666666666666666666666666666666666658'
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve('secp256k1', {
        type: 'short',
        prime: 'k256',
        p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
        a: '0',
        b: '7',
        n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
        h: '1',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        // Precomputed endomorphism
        beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
        lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
        basis: [
            {
                a: '3086d221a7d46bcde86c90e49284eb15',
                b: '-e4437ed6010e88286f547fa90abfe4c3'
            },
            {
                a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
                b: '3086d221a7d46bcde86c90e49284eb15'
            }
        ],
        gRed: false,
        g: [
            '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
            '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
            pre
        ]
    });
});
'use strict';
function $63aabbf7dfa8a956$var$HmacDRBG(options) {
    if (!(this instanceof $63aabbf7dfa8a956$var$HmacDRBG)) return new $63aabbf7dfa8a956$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $63aabbf7dfa8a956$var$utils_1.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $63aabbf7dfa8a956$var$utils_1.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $63aabbf7dfa8a956$var$utils_1.toArray(options.pers, options.persEnc || 'hex');
    $63aabbf7dfa8a956$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
var $63aabbf7dfa8a956$var$hmacDrbg = $63aabbf7dfa8a956$var$HmacDRBG;
$63aabbf7dfa8a956$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac(this.hash, this.K);
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $63aabbf7dfa8a956$var$utils_1.toArray(entropy, entropyEnc);
    add = $63aabbf7dfa8a956$var$utils_1.toArray(add, addEnc);
    $63aabbf7dfa8a956$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $63aabbf7dfa8a956$var$utils_1.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $63aabbf7dfa8a956$var$utils_1.encode(res, enc);
};
'use strict';
var $63aabbf7dfa8a956$var$assert$3 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $63aabbf7dfa8a956$var$key = $63aabbf7dfa8a956$var$KeyPair;
$63aabbf7dfa8a956$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $63aabbf7dfa8a956$var$KeyPair) return pub;
    return new $63aabbf7dfa8a956$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$63aabbf7dfa8a956$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $63aabbf7dfa8a956$var$KeyPair) return priv;
    return new $63aabbf7dfa8a956$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$63aabbf7dfa8a956$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$63aabbf7dfa8a956$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$63aabbf7dfa8a956$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$63aabbf7dfa8a956$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $63aabbf7dfa8a956$var$assert$3(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $63aabbf7dfa8a956$var$assert$3(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$63aabbf7dfa8a956$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $63aabbf7dfa8a956$var$assert$3(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$63aabbf7dfa8a956$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};
'use strict';
var $63aabbf7dfa8a956$var$assert$4 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$Signature(options, enc) {
    if (options instanceof $63aabbf7dfa8a956$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $63aabbf7dfa8a956$var$assert$4(options.r && options.s, 'Signature without r or s');
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $63aabbf7dfa8a956$var$signature = $63aabbf7dfa8a956$var$Signature;
function $63aabbf7dfa8a956$var$Position() {
    this.place = 0;
}
function $63aabbf7dfa8a956$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $63aabbf7dfa8a956$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$63aabbf7dfa8a956$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $63aabbf7dfa8a956$var$utils_1$1.toArray(data, enc);
    var p = new $63aabbf7dfa8a956$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $63aabbf7dfa8a956$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $63aabbf7dfa8a956$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $63aabbf7dfa8a956$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(s);
    this.recoveryParam = null;
    return true;
};
function $63aabbf7dfa8a956$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$63aabbf7dfa8a956$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $63aabbf7dfa8a956$var$rmPadding(r);
    s = $63aabbf7dfa8a956$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $63aabbf7dfa8a956$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $63aabbf7dfa8a956$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $63aabbf7dfa8a956$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $63aabbf7dfa8a956$var$utils_1$1.encode(res, enc);
};
'use strict';
var $63aabbf7dfa8a956$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error('unsupported');
};
var $63aabbf7dfa8a956$var$assert$5 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$EC(options) {
    if (!(this instanceof $63aabbf7dfa8a956$var$EC)) return new $63aabbf7dfa8a956$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $63aabbf7dfa8a956$var$assert$5(Object.prototype.hasOwnProperty.call($63aabbf7dfa8a956$var$curves_1, options), 'Unknown curve ' + options);
        options = $63aabbf7dfa8a956$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $63aabbf7dfa8a956$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $63aabbf7dfa8a956$var$ec = $63aabbf7dfa8a956$var$EC;
$63aabbf7dfa8a956$var$EC.prototype.keyPair = function keyPair(options) {
    return new $63aabbf7dfa8a956$var$key(this, options);
};
$63aabbf7dfa8a956$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $63aabbf7dfa8a956$var$key.fromPrivate(this, priv, enc);
};
$63aabbf7dfa8a956$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $63aabbf7dfa8a956$var$key.fromPublic(this, pub, enc);
};
$63aabbf7dfa8a956$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $63aabbf7dfa8a956$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $63aabbf7dfa8a956$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$63aabbf7dfa8a956$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).isBN(msg) || typeof msg === 'number') {
        msg = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$63aabbf7dfa8a956$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !(0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).isBN(msg)) {
        $63aabbf7dfa8a956$var$assert$5(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $63aabbf7dfa8a956$var$assert$5(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$63aabbf7dfa8a956$var$assert$5((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $63aabbf7dfa8a956$var$assert$5(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $63aabbf7dfa8a956$var$assert$5(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $63aabbf7dfa8a956$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $63aabbf7dfa8a956$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$63aabbf7dfa8a956$var$EC.prototype.verify = function verify(msg, signature$1, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, 'hex');
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$63aabbf7dfa8a956$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $63aabbf7dfa8a956$var$assert$5((3 & j) === j, 'The recovery param is more than two bits');
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$63aabbf7dfa8a956$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};
var $63aabbf7dfa8a956$var$elliptic_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    'use strict';
    var elliptic = exports;
    elliptic.version = "6.6.1";
    elliptic.utils = $63aabbf7dfa8a956$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error('unsupported');
    };
    elliptic.curve = $63aabbf7dfa8a956$var$curve_1;
    elliptic.curves = $63aabbf7dfa8a956$var$curves_1;
    // Protocols
    elliptic.ec = $63aabbf7dfa8a956$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $63aabbf7dfa8a956$export$129fe12d32abc311 = $63aabbf7dfa8a956$var$elliptic_1.ec;





const $a512adda7ad1dfdc$export$83d89fbfd8236492 = "signing-key/5.8.0";


"use strict";
const $ff9f75f56da7c459$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $a512adda7ad1dfdc$export$83d89fbfd8236492));
let $ff9f75f56da7c459$var$_curve = null;
function $ff9f75f56da7c459$var$getCurve() {
    if (!$ff9f75f56da7c459$var$_curve) $ff9f75f56da7c459$var$_curve = new (0, $63aabbf7dfa8a956$export$129fe12d32abc311)("secp256k1");
    return $ff9f75f56da7c459$var$_curve;
}
class $ff9f75f56da7c459$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "curve", "secp256k1");
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "privateKey", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(privateKey));
        if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(this.privateKey) !== 32) $ff9f75f56da7c459$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.privateKey));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.publicKey));
        const p1 = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.privateKey));
        const digestBytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(digest);
        if (digestBytes.length !== 32) $ff9f75f56da7c459$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)({
            recoveryParam: signature.recoveryParam,
            r: (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)("0x" + signature.r.toString(16), 32),
            s: (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.privateKey));
        const otherKeyPair = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)($ff9f75f56da7c459$export$4a89473d39301224(otherKey)));
        return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $ff9f75f56da7c459$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
    const rs = {
        r: (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.r),
        s: (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.s)
    };
    return "0x" + $ff9f75f56da7c459$var$getCurve().recoverPubKey((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $ff9f75f56da7c459$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(key);
    if (bytes.length === 32) {
        const signingKey = new $ff9f75f56da7c459$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $ff9f75f56da7c459$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}



const $8ffd0867b0da9487$export$83d89fbfd8236492 = "transactions/5.7.0";


"use strict";
const $0a7021bc70fec74d$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $8ffd0867b0da9487$export$83d89fbfd8236492));
var $0a7021bc70fec74d$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($0a7021bc70fec74d$export$80349e05e0724e11 || ($0a7021bc70fec74d$export$80349e05e0724e11 = {}));
///////////////////////////////
function $0a7021bc70fec74d$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $8aee8aee2d40605d$export$88411125f012957a)(value);
}
function $0a7021bc70fec74d$var$handleNumber(value) {
    if (value === "0x") return 0, $c5333cf79421e056$export$aaef8a3eae948f03;
    return (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
}
// Legacy Transaction Fields
const $0a7021bc70fec74d$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $0a7021bc70fec74d$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $0a7021bc70fec74d$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $ff9f75f56da7c459$export$4a89473d39301224)(key);
    return (0, $8aee8aee2d40605d$export$88411125f012957a)((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$15da666eba198c18)(publicKey, 1)), 12));
}
function $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, signature) {
    return $0a7021bc70fec74d$export$e67e2732ba9803f9((0, $ff9f75f56da7c459$export$952dd09fbe0232b7)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(digest), signature));
}
function $0a7021bc70fec74d$var$formatNumber(value, name) {
    const result = (0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toHexString());
    if (result.length > 32) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $0a7021bc70fec74d$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $8aee8aee2d40605d$export$88411125f012957a)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(storageKey) !== 32) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $0a7021bc70fec74d$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $0a7021bc70fec74d$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $0a7021bc70fec74d$var$accessSetify(set[0], set[1]);
        }
        return $0a7021bc70fec74d$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $0a7021bc70fec74d$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $0a7021bc70fec74d$var$formatAccessList(value) {
    return $0a7021bc70fec74d$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $0a7021bc70fec74d$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.gasPrice);
        const maxFeePerGas = (0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $0a7021bc70fec74d$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $0a7021bc70fec74d$var$formatNumber(transaction.chainId || 0, "chainId"),
        $0a7021bc70fec74d$var$formatNumber(transaction.nonce || 0, "nonce"),
        $0a7021bc70fec74d$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $0a7021bc70fec74d$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $8aee8aee2d40605d$export$88411125f012957a)(transaction.to) : "0x",
        $0a7021bc70fec74d$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $0a7021bc70fec74d$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
        fields.push($0a7021bc70fec74d$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
        "0x02",
        $6ff2d0f6bfa15181$export$c564cdbbe6da493(fields)
    ]);
}
function $0a7021bc70fec74d$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $0a7021bc70fec74d$var$formatNumber(transaction.chainId || 0, "chainId"),
        $0a7021bc70fec74d$var$formatNumber(transaction.nonce || 0, "nonce"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $8aee8aee2d40605d$export$88411125f012957a)(transaction.to) : "0x",
        $0a7021bc70fec74d$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $0a7021bc70fec74d$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
        fields.push($0a7021bc70fec74d$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
        "0x01",
        $6ff2d0f6bfa15181$export$c564cdbbe6da493(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $0a7021bc70fec74d$var$_serialize(transaction, signature) {
    (0, $a463a6b5f08d6875$export$ae5a316ba623b73a)(transaction, $0a7021bc70fec74d$var$allowedTransactionKeys);
    const raw = [];
    $0a7021bc70fec74d$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(value);
            if (value.length > fieldInfo.maxLength) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $0a7021bc70fec74d$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $7b88b6e03e4708f2$export$9a14abb1a440cd5e)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $6ff2d0f6bfa15181$export$c564cdbbe6da493(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $0a7021bc70fec74d$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $0a7021bc70fec74d$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(v));
    raw.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.r)));
    raw.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.s)));
    return $6ff2d0f6bfa15181$export$c564cdbbe6da493(raw);
}
function $0a7021bc70fec74d$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $0a7021bc70fec74d$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $0a7021bc70fec74d$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $0a7021bc70fec74d$var$_serializeEip2930(transaction, signature);
        case 2:
            return $0a7021bc70fec74d$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $0a7021bc70fec74d$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $0a7021bc70fec74d$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $0a7021bc70fec74d$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $0a7021bc70fec74d$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(fields[1], 32);
    tx.s = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(fields[2], 32);
    try {
        const digest = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(serialize(tx));
        tx.from = $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $0a7021bc70fec74d$var$_parseEip1559(payload) {
    const transaction = $6ff2d0f6bfa15181$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(payload));
    const maxPriorityFeePerGas = $0a7021bc70fec74d$var$handleNumber(transaction[2]);
    const maxFeePerGas = $0a7021bc70fec74d$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[4]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[5]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $0a7021bc70fec74d$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(payload);
    $0a7021bc70fec74d$var$_parseEipSignature(tx, transaction.slice(9), $0a7021bc70fec74d$var$_serializeEip1559);
    return tx;
}
function $0a7021bc70fec74d$var$_parseEip2930(payload) {
    const transaction = $6ff2d0f6bfa15181$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(payload));
    const tx = {
        type: 1,
        chainId: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $0a7021bc70fec74d$var$handleNumber(transaction[2]),
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[3]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[4]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $0a7021bc70fec74d$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(payload);
    $0a7021bc70fec74d$var$_parseEipSignature(tx, transaction.slice(8), $0a7021bc70fec74d$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $0a7021bc70fec74d$var$_parse(rawTransaction) {
    const transaction = $6ff2d0f6bfa15181$export$2f872c0f2117be69(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $0a7021bc70fec74d$var$handleNumber(transaction[1]),
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[2]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[3]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(transaction[7], 32);
    tx.s = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(transaction[8], 32);
    if ((0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.r).isZero() && (0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)($6ff2d0f6bfa15181$export$c564cdbbe6da493(raw));
        try {
            tx.from = $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, {
                r: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(tx.r),
                s: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $0a7021bc70fec74d$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $0a7021bc70fec74d$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $0a7021bc70fec74d$var$_parseEip2930(payload);
        case 2:
            return $0a7021bc70fec74d$var$_parseEip1559(payload);
        default:
            break;
    }
    return $0a7021bc70fec74d$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}



var $74e9859baf4497ef$exports = {};
'use strict';
Object.defineProperty($74e9859baf4497ef$exports, '__esModule', {
    value: true
});
var $3a397656998e9fe7$exports = {};
'use strict';
Object.defineProperty($3a397656998e9fe7$exports, '__esModule', {
    value: true
});
function $3a397656998e9fe7$var$compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
$3a397656998e9fe7$exports.compare = $3a397656998e9fe7$var$compare;


var $475c4a512fd4a246$exports = {};
'use strict';
Object.defineProperty($475c4a512fd4a246$exports, '__esModule', {
    value: true
});
var $6082a548169c7b42$exports = {};
'use strict';
Object.defineProperty($6082a548169c7b42$exports, '__esModule', {
    value: true
});
function $6082a548169c7b42$var$alloc(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return globalThis.Buffer.alloc(size);
    return new Uint8Array(size);
}
function $6082a548169c7b42$var$allocUnsafe(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return globalThis.Buffer.allocUnsafe(size);
    return new Uint8Array(size);
}
$6082a548169c7b42$exports.alloc = $6082a548169c7b42$var$alloc;
$6082a548169c7b42$exports.allocUnsafe = $6082a548169c7b42$var$allocUnsafe;


function $475c4a512fd4a246$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = $6082a548169c7b42$exports.allocUnsafe(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}
$475c4a512fd4a246$exports.concat = $475c4a512fd4a246$var$concat;


var $41b0be3b2401ec7e$exports = {};
'use strict';
Object.defineProperty($41b0be3b2401ec7e$exports, '__esModule', {
    value: true
});
function $41b0be3b2401ec7e$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$41b0be3b2401ec7e$exports.equals = $41b0be3b2401ec7e$var$equals;


var $a4ed053a1131469e$exports = {};
'use strict';
Object.defineProperty($a4ed053a1131469e$exports, '__esModule', {
    value: true
});
var $5884b53a084a924d$exports = {};
'use strict';
var $b633fa38a7f8a649$exports = {};
'use strict';
Object.defineProperty($b633fa38a7f8a649$exports, '__esModule', {
    value: true
});
var $fab4e33fc8c0336e$exports = {};
'use strict';
Object.defineProperty($fab4e33fc8c0336e$exports, '__esModule', {
    value: true
});
var $de6c852f920490b4$exports = {};
'use strict';
Object.defineProperty($de6c852f920490b4$exports, '__esModule', {
    value: true
});
var $0340df4a7a7e39d8$exports = {};
'use strict';
function $0340df4a7a7e39d8$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === ' ') return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        if (source[psz] === ' ') return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $0340df4a7a7e39d8$var$src = $0340df4a7a7e39d8$var$base;
var $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX = $0340df4a7a7e39d8$var$src;
$0340df4a7a7e39d8$exports = $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX;


var $4d55dbc11a5f1aec$exports = {};
'use strict';
Object.defineProperty($4d55dbc11a5f1aec$exports, '__esModule', {
    value: true
});
const $4d55dbc11a5f1aec$var$empty = new Uint8Array(0);
const $4d55dbc11a5f1aec$var$toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, '0'), '');
const $4d55dbc11a5f1aec$var$fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $4d55dbc11a5f1aec$var$empty;
};
const $4d55dbc11a5f1aec$var$equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $4d55dbc11a5f1aec$var$coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === 'Uint8Array') return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error('Unknown type, must be binary type');
};
const $4d55dbc11a5f1aec$var$isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $4d55dbc11a5f1aec$var$fromString = (str)=>new TextEncoder().encode(str);
const $4d55dbc11a5f1aec$var$toString = (b)=>new TextDecoder().decode(b);
$4d55dbc11a5f1aec$exports.coerce = $4d55dbc11a5f1aec$var$coerce;
$4d55dbc11a5f1aec$exports.empty = $4d55dbc11a5f1aec$var$empty;
$4d55dbc11a5f1aec$exports.equals = $4d55dbc11a5f1aec$var$equals;
$4d55dbc11a5f1aec$exports.fromHex = $4d55dbc11a5f1aec$var$fromHex;
$4d55dbc11a5f1aec$exports.fromString = $4d55dbc11a5f1aec$var$fromString;
$4d55dbc11a5f1aec$exports.isBinary = $4d55dbc11a5f1aec$var$isBinary;
$4d55dbc11a5f1aec$exports.toHex = $4d55dbc11a5f1aec$var$toHex;
$4d55dbc11a5f1aec$exports.toString = $4d55dbc11a5f1aec$var$toString;


class $de6c852f920490b4$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error('Unknown type, must be binary type');
    }
}
class $de6c852f920490b4$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error('Invalid prefix character');
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === 'string') {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error('Can only multibase decode strings');
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
}
class $de6c852f920490b4$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $de6c852f920490b4$var$or = (left, right)=>new $de6c852f920490b4$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $de6c852f920490b4$var$Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $de6c852f920490b4$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $de6c852f920490b4$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $de6c852f920490b4$var$from = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $de6c852f920490b4$var$Codec(name, prefix, encode, decode);
const $de6c852f920490b4$var$baseX = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = $0340df4a7a7e39d8$exports(alphabet, name);
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>$4d55dbc11a5f1aec$exports.coerce(decode(text))
    });
};
const $de6c852f920490b4$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === '=')--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError('Unexpected end of data');
    return out;
};
const $de6c852f920490b4$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === '=';
    const mask = (1 << bitsPerChar) - 1;
    let out = '';
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += '=';
    return out;
};
const $de6c852f920490b4$var$rfc4648 = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode (input) {
            return $de6c852f920490b4$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $de6c852f920490b4$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};
$de6c852f920490b4$exports.Codec = $de6c852f920490b4$var$Codec;
$de6c852f920490b4$exports.baseX = $de6c852f920490b4$var$baseX;
$de6c852f920490b4$exports.from = $de6c852f920490b4$var$from;
$de6c852f920490b4$exports.or = $de6c852f920490b4$var$or;
$de6c852f920490b4$exports.rfc4648 = $de6c852f920490b4$var$rfc4648;



const $fab4e33fc8c0336e$var$identity = $de6c852f920490b4$exports.from({
    prefix: '\0',
    name: 'identity',
    encode: (buf)=>$4d55dbc11a5f1aec$exports.toString(buf),
    decode: (str)=>$4d55dbc11a5f1aec$exports.fromString(str)
});
$fab4e33fc8c0336e$exports.identity = $fab4e33fc8c0336e$var$identity;


var $444f725972ab843c$exports = {};
'use strict';
Object.defineProperty($444f725972ab843c$exports, '__esModule', {
    value: true
});

const $444f725972ab843c$var$base2 = $de6c852f920490b4$exports.rfc4648({
    prefix: '0',
    name: 'base2',
    alphabet: '01',
    bitsPerChar: 1
});
$444f725972ab843c$exports.base2 = $444f725972ab843c$var$base2;


var $7330be652d1faeae$exports = {};
'use strict';
Object.defineProperty($7330be652d1faeae$exports, '__esModule', {
    value: true
});

const $7330be652d1faeae$var$base8 = $de6c852f920490b4$exports.rfc4648({
    prefix: '7',
    name: 'base8',
    alphabet: '01234567',
    bitsPerChar: 3
});
$7330be652d1faeae$exports.base8 = $7330be652d1faeae$var$base8;


var $7c7f7dd3c1547a66$exports = {};
'use strict';
Object.defineProperty($7c7f7dd3c1547a66$exports, '__esModule', {
    value: true
});

const $7c7f7dd3c1547a66$var$base10 = $de6c852f920490b4$exports.baseX({
    prefix: '9',
    name: 'base10',
    alphabet: '0123456789'
});
$7c7f7dd3c1547a66$exports.base10 = $7c7f7dd3c1547a66$var$base10;


var $4e3d0e6f3707af45$exports = {};
'use strict';
Object.defineProperty($4e3d0e6f3707af45$exports, '__esModule', {
    value: true
});

const $4e3d0e6f3707af45$var$base16 = $de6c852f920490b4$exports.rfc4648({
    prefix: 'f',
    name: 'base16',
    alphabet: '0123456789abcdef',
    bitsPerChar: 4
});
const $4e3d0e6f3707af45$var$base16upper = $de6c852f920490b4$exports.rfc4648({
    prefix: 'F',
    name: 'base16upper',
    alphabet: '0123456789ABCDEF',
    bitsPerChar: 4
});
$4e3d0e6f3707af45$exports.base16 = $4e3d0e6f3707af45$var$base16;
$4e3d0e6f3707af45$exports.base16upper = $4e3d0e6f3707af45$var$base16upper;


var $6d183b7418ac11d8$exports = {};
'use strict';
Object.defineProperty($6d183b7418ac11d8$exports, '__esModule', {
    value: true
});

const $6d183b7418ac11d8$var$base32 = $de6c852f920490b4$exports.rfc4648({
    prefix: 'b',
    name: 'base32',
    alphabet: 'abcdefghijklmnopqrstuvwxyz234567',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32upper = $de6c852f920490b4$exports.rfc4648({
    prefix: 'B',
    name: 'base32upper',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32pad = $de6c852f920490b4$exports.rfc4648({
    prefix: 'c',
    name: 'base32pad',
    alphabet: 'abcdefghijklmnopqrstuvwxyz234567=',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32padupper = $de6c852f920490b4$exports.rfc4648({
    prefix: 'C',
    name: 'base32padupper',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hex = $de6c852f920490b4$exports.rfc4648({
    prefix: 'v',
    name: 'base32hex',
    alphabet: '0123456789abcdefghijklmnopqrstuv',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexupper = $de6c852f920490b4$exports.rfc4648({
    prefix: 'V',
    name: 'base32hexupper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpad = $de6c852f920490b4$exports.rfc4648({
    prefix: 't',
    name: 'base32hexpad',
    alphabet: '0123456789abcdefghijklmnopqrstuv=',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpadupper = $de6c852f920490b4$exports.rfc4648({
    prefix: 'T',
    name: 'base32hexpadupper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV=',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32z = $de6c852f920490b4$exports.rfc4648({
    prefix: 'h',
    name: 'base32z',
    alphabet: 'ybndrfg8ejkmcpqxot1uwisza345h769',
    bitsPerChar: 5
});
$6d183b7418ac11d8$exports.base32 = $6d183b7418ac11d8$var$base32;
$6d183b7418ac11d8$exports.base32hex = $6d183b7418ac11d8$var$base32hex;
$6d183b7418ac11d8$exports.base32hexpad = $6d183b7418ac11d8$var$base32hexpad;
$6d183b7418ac11d8$exports.base32hexpadupper = $6d183b7418ac11d8$var$base32hexpadupper;
$6d183b7418ac11d8$exports.base32hexupper = $6d183b7418ac11d8$var$base32hexupper;
$6d183b7418ac11d8$exports.base32pad = $6d183b7418ac11d8$var$base32pad;
$6d183b7418ac11d8$exports.base32padupper = $6d183b7418ac11d8$var$base32padupper;
$6d183b7418ac11d8$exports.base32upper = $6d183b7418ac11d8$var$base32upper;
$6d183b7418ac11d8$exports.base32z = $6d183b7418ac11d8$var$base32z;


var $2478ed668ff199ad$exports = {};
'use strict';
Object.defineProperty($2478ed668ff199ad$exports, '__esModule', {
    value: true
});

const $2478ed668ff199ad$var$base36 = $de6c852f920490b4$exports.baseX({
    prefix: 'k',
    name: 'base36',
    alphabet: '0123456789abcdefghijklmnopqrstuvwxyz'
});
const $2478ed668ff199ad$var$base36upper = $de6c852f920490b4$exports.baseX({
    prefix: 'K',
    name: 'base36upper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
});
$2478ed668ff199ad$exports.base36 = $2478ed668ff199ad$var$base36;
$2478ed668ff199ad$exports.base36upper = $2478ed668ff199ad$var$base36upper;


var $bb23e06a31e86f7c$exports = {};
'use strict';
Object.defineProperty($bb23e06a31e86f7c$exports, '__esModule', {
    value: true
});

const $bb23e06a31e86f7c$var$base58btc = $de6c852f920490b4$exports.baseX({
    name: 'base58btc',
    prefix: 'z',
    alphabet: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
});
const $bb23e06a31e86f7c$var$base58flickr = $de6c852f920490b4$exports.baseX({
    name: 'base58flickr',
    prefix: 'Z',
    alphabet: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'
});
$bb23e06a31e86f7c$exports.base58btc = $bb23e06a31e86f7c$var$base58btc;
$bb23e06a31e86f7c$exports.base58flickr = $bb23e06a31e86f7c$var$base58flickr;


var $de0d70bb34ca5e4e$exports = {};
'use strict';
Object.defineProperty($de0d70bb34ca5e4e$exports, '__esModule', {
    value: true
});

const $de0d70bb34ca5e4e$var$base64 = $de6c852f920490b4$exports.rfc4648({
    prefix: 'm',
    name: 'base64',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64pad = $de6c852f920490b4$exports.rfc4648({
    prefix: 'M',
    name: 'base64pad',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64url = $de6c852f920490b4$exports.rfc4648({
    prefix: 'u',
    name: 'base64url',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64urlpad = $de6c852f920490b4$exports.rfc4648({
    prefix: 'U',
    name: 'base64urlpad',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=',
    bitsPerChar: 6
});
$de0d70bb34ca5e4e$exports.base64 = $de0d70bb34ca5e4e$var$base64;
$de0d70bb34ca5e4e$exports.base64pad = $de0d70bb34ca5e4e$var$base64pad;
$de0d70bb34ca5e4e$exports.base64url = $de0d70bb34ca5e4e$var$base64url;
$de0d70bb34ca5e4e$exports.base64urlpad = $de0d70bb34ca5e4e$var$base64urlpad;


var $c9e395f0a3e1277d$exports = {};
'use strict';
Object.defineProperty($c9e395f0a3e1277d$exports, '__esModule', {
    value: true
});

const $c9e395f0a3e1277d$var$alphabet = Array.from('\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42');
const $c9e395f0a3e1277d$var$alphabetBytesToChars = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $c9e395f0a3e1277d$var$alphabetCharsToBytes = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $c9e395f0a3e1277d$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $c9e395f0a3e1277d$var$alphabetBytesToChars[c];
        return p;
    }, '');
}
function $c9e395f0a3e1277d$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $c9e395f0a3e1277d$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $c9e395f0a3e1277d$var$base256emoji = $de6c852f920490b4$exports.from({
    prefix: '\uD83D\uDE80',
    name: 'base256emoji',
    encode: $c9e395f0a3e1277d$var$encode,
    decode: $c9e395f0a3e1277d$var$decode
});
$c9e395f0a3e1277d$exports.base256emoji = $c9e395f0a3e1277d$var$base256emoji;


var $fc5536b924e664f3$exports = {};
'use strict';
Object.defineProperty($fc5536b924e664f3$exports, '__esModule', {
    value: true
});
var $baed353b52eedd46$exports = {};
'use strict';
Object.defineProperty($baed353b52eedd46$exports, '__esModule', {
    value: true
});
var $f302a42295b946b3$exports = {};
'use strict';
Object.defineProperty($f302a42295b946b3$exports, '__esModule', {
    value: true
});

var $32dd57f0aae68c66$exports = {};
'use strict';
Object.defineProperty($32dd57f0aae68c66$exports, '__esModule', {
    value: true
});
var $fa05a038af787ba8$exports = {};
'use strict';
var $fa05a038af787ba8$var$encode_1 = $fa05a038af787ba8$var$encode;
var $fa05a038af787ba8$var$MSB = 128, $fa05a038af787ba8$var$REST = 127, $fa05a038af787ba8$var$MSBALL = ~$fa05a038af787ba8$var$REST, $fa05a038af787ba8$var$INT = Math.pow(2, 31);
function $fa05a038af787ba8$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $fa05a038af787ba8$var$INT){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num /= 128;
    }
    while(num & $fa05a038af787ba8$var$MSBALL){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $fa05a038af787ba8$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $fa05a038af787ba8$var$decode = $fa05a038af787ba8$var$read;
var $fa05a038af787ba8$var$MSB$1 = 128, $fa05a038af787ba8$var$REST$1 = 127;
function $fa05a038af787ba8$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $fa05a038af787ba8$var$read.bytes = 0;
            throw new RangeError('Could not decode varint');
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $fa05a038af787ba8$var$REST$1) << shift : (b & $fa05a038af787ba8$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $fa05a038af787ba8$var$MSB$1);
    $fa05a038af787ba8$var$read.bytes = counter - offset;
    return res;
}
var $fa05a038af787ba8$var$N1 = Math.pow(2, 7);
var $fa05a038af787ba8$var$N2 = Math.pow(2, 14);
var $fa05a038af787ba8$var$N3 = Math.pow(2, 21);
var $fa05a038af787ba8$var$N4 = Math.pow(2, 28);
var $fa05a038af787ba8$var$N5 = Math.pow(2, 35);
var $fa05a038af787ba8$var$N6 = Math.pow(2, 42);
var $fa05a038af787ba8$var$N7 = Math.pow(2, 49);
var $fa05a038af787ba8$var$N8 = Math.pow(2, 56);
var $fa05a038af787ba8$var$N9 = Math.pow(2, 63);
var $fa05a038af787ba8$var$length = function(value) {
    return value < $fa05a038af787ba8$var$N1 ? 1 : value < $fa05a038af787ba8$var$N2 ? 2 : value < $fa05a038af787ba8$var$N3 ? 3 : value < $fa05a038af787ba8$var$N4 ? 4 : value < $fa05a038af787ba8$var$N5 ? 5 : value < $fa05a038af787ba8$var$N6 ? 6 : value < $fa05a038af787ba8$var$N7 ? 7 : value < $fa05a038af787ba8$var$N8 ? 8 : value < $fa05a038af787ba8$var$N9 ? 9 : 10;
};
var $fa05a038af787ba8$var$varint = {
    encode: $fa05a038af787ba8$var$encode_1,
    decode: $fa05a038af787ba8$var$decode,
    encodingLength: $fa05a038af787ba8$var$length
};
var $fa05a038af787ba8$var$_brrp_varint = $fa05a038af787ba8$var$varint;
var $fa05a038af787ba8$var$varint$1 = $fa05a038af787ba8$var$_brrp_varint;
$fa05a038af787ba8$exports = $fa05a038af787ba8$var$varint$1;


const $32dd57f0aae68c66$var$decode = (data, offset = 0)=>{
    const code = $fa05a038af787ba8$exports.decode(data, offset);
    return [
        code,
        $fa05a038af787ba8$exports.decode.bytes
    ];
};
const $32dd57f0aae68c66$var$encodeTo = (int, target, offset = 0)=>{
    $fa05a038af787ba8$exports.encode(int, target, offset);
    return target;
};
const $32dd57f0aae68c66$var$encodingLength = (int)=>{
    return $fa05a038af787ba8$exports.encodingLength(int);
};
$32dd57f0aae68c66$exports.decode = $32dd57f0aae68c66$var$decode;
$32dd57f0aae68c66$exports.encodeTo = $32dd57f0aae68c66$var$encodeTo;
$32dd57f0aae68c66$exports.encodingLength = $32dd57f0aae68c66$var$encodingLength;


const $f302a42295b946b3$var$create = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $32dd57f0aae68c66$exports.encodingLength(code);
    const digestOffset = sizeOffset + $32dd57f0aae68c66$exports.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $32dd57f0aae68c66$exports.encodeTo(code, bytes, 0);
    $32dd57f0aae68c66$exports.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes);
};
const $f302a42295b946b3$var$decode = (multihash)=>{
    const bytes$1 = $4d55dbc11a5f1aec$exports.coerce(multihash);
    const [code, sizeOffset] = $32dd57f0aae68c66$exports.decode(bytes$1);
    const [size, digestOffset] = $32dd57f0aae68c66$exports.decode(bytes$1.subarray(sizeOffset));
    const digest = bytes$1.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error('Incorrect length');
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes$1);
};
const $f302a42295b946b3$var$equals = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && $4d55dbc11a5f1aec$exports.equals(a.bytes, b.bytes);
};
class $f302a42295b946b3$var$Digest {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}
$f302a42295b946b3$exports.Digest = $f302a42295b946b3$var$Digest;
$f302a42295b946b3$exports.create = $f302a42295b946b3$var$create;
$f302a42295b946b3$exports.decode = $f302a42295b946b3$var$decode;
$f302a42295b946b3$exports.equals = $f302a42295b946b3$var$equals;


const $baed353b52eedd46$var$from = ({ name: name, code: code, encode: encode })=>new $baed353b52eedd46$var$Hasher(name, code, encode);
class $baed353b52eedd46$var$Hasher {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $f302a42295b946b3$exports.create(this.code, result) : result.then((digest$1)=>$f302a42295b946b3$exports.create(this.code, digest$1));
        } else throw Error('Unknown type, must be binary type');
    }
}
$baed353b52eedd46$exports.Hasher = $baed353b52eedd46$var$Hasher;
$baed353b52eedd46$exports.from = $baed353b52eedd46$var$from;


const $fc5536b924e664f3$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $fc5536b924e664f3$var$sha256 = $baed353b52eedd46$exports.from({
    name: 'sha2-256',
    code: 18,
    encode: $fc5536b924e664f3$var$sha('SHA-256')
});
const $fc5536b924e664f3$var$sha512 = $baed353b52eedd46$exports.from({
    name: 'sha2-512',
    code: 19,
    encode: $fc5536b924e664f3$var$sha('SHA-512')
});
$fc5536b924e664f3$exports.sha256 = $fc5536b924e664f3$var$sha256;
$fc5536b924e664f3$exports.sha512 = $fc5536b924e664f3$var$sha512;


var $60ad3b9242aa2ade$exports = {};
'use strict';
Object.defineProperty($60ad3b9242aa2ade$exports, '__esModule', {
    value: true
});


const $60ad3b9242aa2ade$var$code = 0;
const $60ad3b9242aa2ade$var$name = 'identity';
const $60ad3b9242aa2ade$var$encode = $4d55dbc11a5f1aec$exports.coerce;
const $60ad3b9242aa2ade$var$digest = (input)=>$f302a42295b946b3$exports.create($60ad3b9242aa2ade$var$code, $60ad3b9242aa2ade$var$encode(input));
const $60ad3b9242aa2ade$var$identity = {
    code: $60ad3b9242aa2ade$var$code,
    name: $60ad3b9242aa2ade$var$name,
    encode: $60ad3b9242aa2ade$var$encode,
    digest: $60ad3b9242aa2ade$var$digest
};
$60ad3b9242aa2ade$exports.identity = $60ad3b9242aa2ade$var$identity;


var $00eb0d0ec1c470ae$exports = {};
'use strict';
Object.defineProperty($00eb0d0ec1c470ae$exports, '__esModule', {
    value: true
});

const $00eb0d0ec1c470ae$var$name = 'raw';
const $00eb0d0ec1c470ae$var$code = 85;
const $00eb0d0ec1c470ae$var$encode = (node)=>$4d55dbc11a5f1aec$exports.coerce(node);
const $00eb0d0ec1c470ae$var$decode = (data)=>$4d55dbc11a5f1aec$exports.coerce(data);
$00eb0d0ec1c470ae$exports.code = $00eb0d0ec1c470ae$var$code;
$00eb0d0ec1c470ae$exports.decode = $00eb0d0ec1c470ae$var$decode;
$00eb0d0ec1c470ae$exports.encode = $00eb0d0ec1c470ae$var$encode;
$00eb0d0ec1c470ae$exports.name = $00eb0d0ec1c470ae$var$name;


var $5df44c55fa70023d$exports = {};
'use strict';
Object.defineProperty($5df44c55fa70023d$exports, '__esModule', {
    value: true
});
const $5df44c55fa70023d$var$textEncoder = new TextEncoder();
const $5df44c55fa70023d$var$textDecoder = new TextDecoder();
const $5df44c55fa70023d$var$name = 'json';
const $5df44c55fa70023d$var$code = 512;
const $5df44c55fa70023d$var$encode = (node)=>$5df44c55fa70023d$var$textEncoder.encode(JSON.stringify(node));
const $5df44c55fa70023d$var$decode = (data)=>JSON.parse($5df44c55fa70023d$var$textDecoder.decode(data));
$5df44c55fa70023d$exports.code = $5df44c55fa70023d$var$code;
$5df44c55fa70023d$exports.decode = $5df44c55fa70023d$var$decode;
$5df44c55fa70023d$exports.encode = $5df44c55fa70023d$var$encode;
$5df44c55fa70023d$exports.name = $5df44c55fa70023d$var$name;


var $ce2f798d02e53aa4$exports = {};
'use strict';
Object.defineProperty($ce2f798d02e53aa4$exports, '__esModule', {
    value: true
});
var $75176e30f12252bd$exports = {};
'use strict';
Object.defineProperty($75176e30f12252bd$exports, '__esModule', {
    value: true
});





class $75176e30f12252bd$var$CID {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $75176e30f12252bd$var$hidden,
            byteLength: $75176e30f12252bd$var$hidden,
            code: $75176e30f12252bd$var$readonly,
            version: $75176e30f12252bd$var$readonly,
            multihash: $75176e30f12252bd$var$readonly,
            bytes: $75176e30f12252bd$var$readonly,
            _baseCache: $75176e30f12252bd$var$hidden,
            asCID: $75176e30f12252bd$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error('Cannot convert a non dag-pb CID to CIDv0');
                    if (multihash.code !== $75176e30f12252bd$var$SHA_256_CODE) throw new Error('Cannot convert non sha2-256 multihash CID to CIDv0');
                    return $75176e30f12252bd$var$CID.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest$1 } = this.multihash;
                    const multihash = $f302a42295b946b3$exports.create(code, digest$1);
                    return $75176e30f12252bd$var$CID.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $f302a42295b946b3$exports.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $75176e30f12252bd$var$toStringV0(bytes, _baseCache, base || $bb23e06a31e86f7c$exports.base58btc.encoder);
            default:
                return $75176e30f12252bd$var$toStringV1(bytes, _baseCache, base || $6d183b7418ac11d8$exports.base32.encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return 'CID';
    }
    [Symbol.for('nodejs.util.inspect.custom')]() {
        return 'CID(' + this.toString() + ')';
    }
    static isCID(value) {
        $75176e30f12252bd$var$deprecate(/^0\.0/, $75176e30f12252bd$var$IS_CID_DEPRECATION);
        return !!(value && (value[$75176e30f12252bd$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error('Deprecated, use .toString()');
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error('Deprecated .buffer property, use .bytes to get Uint8Array instead');
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $75176e30f12252bd$var$CID) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $75176e30f12252bd$var$CID(version, code, multihash, bytes || $75176e30f12252bd$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$75176e30f12252bd$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest$1 = $f302a42295b946b3$exports.decode(multihash);
            return $75176e30f12252bd$var$CID.create(version, code, digest$1);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== 'number') throw new Error('String codecs are no longer supported');
        switch(version){
            case 0:
                if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$75176e30f12252bd$var$DAG_PB_CODE}) block encoding`);
                else return new $75176e30f12252bd$var$CID(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $75176e30f12252bd$var$encodeCID(version, code, digest.bytes);
                    return new $75176e30f12252bd$var$CID(version, code, digest, bytes);
                }
            default:
                throw new Error('Invalid version');
        }
    }
    static createV0(digest) {
        return $75176e30f12252bd$var$CID.create(0, $75176e30f12252bd$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $75176e30f12252bd$var$CID.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $75176e30f12252bd$var$CID.decodeFirst(bytes);
        if (remainder.length) throw new Error('Incorrect length');
        return cid;
    }
    static decodeFirst(bytes$1) {
        const specs = $75176e30f12252bd$var$CID.inspectBytes(bytes$1);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = $4d55dbc11a5f1aec$exports.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error('Incorrect length');
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest$1 = new $f302a42295b946b3$exports.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $75176e30f12252bd$var$CID.createV0(digest$1) : $75176e30f12252bd$var$CID.createV1(specs.codec, digest$1);
        return [
            cid,
            bytes$1.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $32dd57f0aae68c66$exports.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $75176e30f12252bd$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $75176e30f12252bd$var$parseCIDtoBytes(source, base);
        const cid = $75176e30f12252bd$var$CID.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $75176e30f12252bd$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case 'Q':
            {
                const decoder = base || $bb23e06a31e86f7c$exports.base58btc;
                return [
                    $bb23e06a31e86f7c$exports.base58btc.prefix,
                    decoder.decode(`${$bb23e06a31e86f7c$exports.base58btc.prefix}${source}`)
                ];
            }
        case $bb23e06a31e86f7c$exports.base58btc.prefix:
            {
                const decoder = base || $bb23e06a31e86f7c$exports.base58btc;
                return [
                    $bb23e06a31e86f7c$exports.base58btc.prefix,
                    decoder.decode(source)
                ];
            }
        case $6d183b7418ac11d8$exports.base32.prefix:
            {
                const decoder = base || $6d183b7418ac11d8$exports.base32;
                return [
                    $6d183b7418ac11d8$exports.base32.prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error('To parse non base32 or base58btc encoded CID multibase decoder must be provided');
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $75176e30f12252bd$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== $bb23e06a31e86f7c$exports.base58btc.prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$DAG_PB_CODE = 112;
const $75176e30f12252bd$var$SHA_256_CODE = 18;
const $75176e30f12252bd$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $32dd57f0aae68c66$exports.encodingLength(version);
    const hashOffset = codeOffset + $32dd57f0aae68c66$exports.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $32dd57f0aae68c66$exports.encodeTo(version, bytes, 0);
    $32dd57f0aae68c66$exports.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $75176e30f12252bd$var$cidSymbol = Symbol.for('@ipld/js-cid/CID');
const $75176e30f12252bd$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $75176e30f12252bd$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $75176e30f12252bd$var$version = '0.0.0-dev';
const $75176e30f12252bd$var$deprecate = (range, message)=>{
    if (range.test($75176e30f12252bd$var$version)) console.warn(message);
    else throw new Error(message);
};
const $75176e30f12252bd$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;
$75176e30f12252bd$exports.CID = $75176e30f12252bd$var$CID;






$ce2f798d02e53aa4$exports.CID = $75176e30f12252bd$exports.CID;
$ce2f798d02e53aa4$exports.varint = $32dd57f0aae68c66$exports;
$ce2f798d02e53aa4$exports.bytes = $4d55dbc11a5f1aec$exports;
$ce2f798d02e53aa4$exports.hasher = $baed353b52eedd46$exports;
$ce2f798d02e53aa4$exports.digest = $f302a42295b946b3$exports;







const $b633fa38a7f8a649$var$bases = {
    ...$fab4e33fc8c0336e$exports,
    ...$444f725972ab843c$exports,
    ...$7330be652d1faeae$exports,
    ...$7c7f7dd3c1547a66$exports,
    ...$4e3d0e6f3707af45$exports,
    ...$6d183b7418ac11d8$exports,
    ...$2478ed668ff199ad$exports,
    ...$bb23e06a31e86f7c$exports,
    ...$de0d70bb34ca5e4e$exports,
    ...$c9e395f0a3e1277d$exports
};
const $b633fa38a7f8a649$var$hashes = {
    ...$fc5536b924e664f3$exports,
    ...$60ad3b9242aa2ade$exports
};
const $b633fa38a7f8a649$var$codecs = {
    raw: $00eb0d0ec1c470ae$exports,
    json: $5df44c55fa70023d$exports
};
$b633fa38a7f8a649$exports.CID = $75176e30f12252bd$exports.CID;
$b633fa38a7f8a649$exports.hasher = $baed353b52eedd46$exports;
$b633fa38a7f8a649$exports.digest = $f302a42295b946b3$exports;
$b633fa38a7f8a649$exports.varint = $32dd57f0aae68c66$exports;
$b633fa38a7f8a649$exports.bytes = $4d55dbc11a5f1aec$exports;
$b633fa38a7f8a649$exports.bases = $b633fa38a7f8a649$var$bases;
$b633fa38a7f8a649$exports.codecs = $b633fa38a7f8a649$var$codecs;
$b633fa38a7f8a649$exports.hashes = $b633fa38a7f8a649$var$hashes;



function $5884b53a084a924d$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $5884b53a084a924d$var$string = $5884b53a084a924d$var$createCodec('utf8', 'u', (buf)=>{
    const decoder = new TextDecoder('utf8');
    return 'u' + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $5884b53a084a924d$var$ascii = $5884b53a084a924d$var$createCodec('ascii', 'a', (buf)=>{
    let string = 'a';
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = $6082a548169c7b42$exports.allocUnsafe(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $5884b53a084a924d$var$BASES = {
    utf8: $5884b53a084a924d$var$string,
    'utf-8': $5884b53a084a924d$var$string,
    hex: $b633fa38a7f8a649$exports.bases.base16,
    latin1: $5884b53a084a924d$var$ascii,
    ascii: $5884b53a084a924d$var$ascii,
    binary: $5884b53a084a924d$var$ascii,
    ...$b633fa38a7f8a649$exports.bases
};
$5884b53a084a924d$exports = $5884b53a084a924d$var$BASES;


function $a4ed053a1131469e$var$fromString(string, encoding = 'utf8') {
    const base = $5884b53a084a924d$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === 'utf8' || encoding === 'utf-8') && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(string, 'utf8');
    return base.decoder.decode(`${base.prefix}${string}`);
}
$a4ed053a1131469e$exports.fromString = $a4ed053a1131469e$var$fromString;


var $bdf44057d833ab1f$exports = {};
'use strict';
Object.defineProperty($bdf44057d833ab1f$exports, '__esModule', {
    value: true
});

function $bdf44057d833ab1f$var$toString(array, encoding = 'utf8') {
    const base = $5884b53a084a924d$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === 'utf8' || encoding === 'utf-8') && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString('utf8');
    return base.encoder.encode(array).substring(1);
}
$bdf44057d833ab1f$exports.toString = $bdf44057d833ab1f$var$toString;


var $61fd98a3451cab50$exports = {};
'use strict';
Object.defineProperty($61fd98a3451cab50$exports, '__esModule', {
    value: true
});

function $61fd98a3451cab50$var$xor(a, b) {
    if (a.length !== b.length) throw new Error('Inputs should have the same length');
    const result = $6082a548169c7b42$exports.allocUnsafe(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return result;
}
$61fd98a3451cab50$exports.xor = $61fd98a3451cab50$var$xor;


$74e9859baf4497ef$exports.compare = $3a397656998e9fe7$exports.compare;
$74e9859baf4497ef$exports.concat = $475c4a512fd4a246$exports.concat;
$74e9859baf4497ef$exports.equals = $41b0be3b2401ec7e$exports.equals;
$74e9859baf4497ef$exports.fromString = $a4ed053a1131469e$exports.fromString;
$74e9859baf4497ef$exports.toString = $bdf44057d833ab1f$exports.toString;
$74e9859baf4497ef$exports.xor = $61fd98a3451cab50$exports.xor;



var $1zUcV = parcelRequire("1zUcV");
function $e654830c96bdc727$var$e(s, r, i = "string") {
    if (!s[r] || typeof s[r] !== i) throw new Error(`Missing or invalid "${r}" param`);
}
function $e654830c96bdc727$var$l(s, r) {
    let i = !0;
    return r.forEach((t)=>{
        t in s || (i = !1);
    }), i;
}
function $e654830c96bdc727$var$f(s, r) {
    return Array.isArray(s) ? s.length === r : Object.keys(s).length === r;
}
function $e654830c96bdc727$var$w(s, r) {
    return Array.isArray(s) ? s.length >= r : Object.keys(s).length >= r;
}
function $e654830c96bdc727$var$u(s, r, i) {
    return (i.length ? $e654830c96bdc727$var$w(s, r.length) : $e654830c96bdc727$var$f(s, r.length)) ? $e654830c96bdc727$var$l(s, r) : !1;
}
function $e654830c96bdc727$var$n(s, r, i = "_") {
    const t = s.split(i);
    return t[t.length - 1].trim().toLowerCase() === r.trim().toLowerCase();
}
function $e654830c96bdc727$export$c75580565fa025bd(s) {
    return $e654830c96bdc727$export$f576347163de0984(s.method) && $e654830c96bdc727$export$dae2311546d43680(s.params);
}
function $e654830c96bdc727$export$f576347163de0984(s) {
    return $e654830c96bdc727$var$n(s, "subscribe");
}
function $e654830c96bdc727$export$dae2311546d43680(s) {
    return $e654830c96bdc727$var$u(s, [
        "topic"
    ], []);
}
function $e654830c96bdc727$export$8fa7cf76b41caee0(s) {
    return $e654830c96bdc727$export$71d4d33ac7f7a269(s.method) && $e654830c96bdc727$export$71e8d1aa48c3e86f(s.params);
}
function $e654830c96bdc727$export$71d4d33ac7f7a269(s) {
    return $e654830c96bdc727$var$n(s, "publish");
}
function $e654830c96bdc727$export$71e8d1aa48c3e86f(s) {
    return $e654830c96bdc727$var$u(s, [
        "message",
        "topic",
        "ttl"
    ], [
        "prompt",
        "tag"
    ]);
}
function $e654830c96bdc727$export$83e292763180b41b(s) {
    return $e654830c96bdc727$export$568d956f39536025(s.method) && $e654830c96bdc727$export$cbc597c53c3b4f80(s.params);
}
function $e654830c96bdc727$export$568d956f39536025(s) {
    return $e654830c96bdc727$var$n(s, "unsubscribe");
}
function $e654830c96bdc727$export$cbc597c53c3b4f80(s) {
    return $e654830c96bdc727$var$u(s, [
        "id",
        "topic"
    ], []);
}
function $e654830c96bdc727$export$43cf4100d6287b8e(s) {
    return $e654830c96bdc727$export$3cb4ad320e3a46a4(s.method) && $e654830c96bdc727$export$6366ff9a39f2da4c(s.params);
}
function $e654830c96bdc727$export$3cb4ad320e3a46a4(s) {
    return $e654830c96bdc727$var$n(s, "subscription");
}
function $e654830c96bdc727$export$6366ff9a39f2da4c(s) {
    return $e654830c96bdc727$var$u(s, [
        "id",
        "data"
    ], []);
}
function $e654830c96bdc727$export$abdf96c288cb375(s) {
    if (!$e654830c96bdc727$export$f576347163de0984(s.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!$e654830c96bdc727$export$dae2311546d43680(s.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const r = s.params;
    return $e654830c96bdc727$var$e(r, "topic"), r;
}
function $e654830c96bdc727$export$eac3e45ac5c5c9fa(s) {
    if (!$e654830c96bdc727$export$71d4d33ac7f7a269(s.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!$e654830c96bdc727$export$71e8d1aa48c3e86f(s.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const r = s.params;
    return $e654830c96bdc727$var$e(r, "topic"), $e654830c96bdc727$var$e(r, "message"), $e654830c96bdc727$var$e(r, "ttl", "number"), r;
}
function $e654830c96bdc727$export$78baa72f78156594(s) {
    if (!$e654830c96bdc727$export$568d956f39536025(s.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!$e654830c96bdc727$export$cbc597c53c3b4f80(s.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const r = s.params;
    return $e654830c96bdc727$var$e(r, "id"), r;
}
function $e654830c96bdc727$export$4d5822edd41f3b48(s) {
    if (!$e654830c96bdc727$export$3cb4ad320e3a46a4(s.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!$e654830c96bdc727$export$6366ff9a39f2da4c(s.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const r = s.params;
    return $e654830c96bdc727$var$e(r, "id"), $e654830c96bdc727$var$e(r, "data"), r;
}
const $e654830c96bdc727$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe",
        batchFetchMessages: "waku_batchFetchMessages"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe",
        batchFetchMessages: "irn_batchFetchMessages"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe",
        batchFetchMessages: "iridium_batchFetchMessages"
    }
};



var $6ZWSX = parcelRequire("6ZWSX");
var $a5d33cfc7f8e5437$require$Buffer = $6ZWSX.Buffer;
const $a5d33cfc7f8e5437$var$Pe = ":";
function $a5d33cfc7f8e5437$export$4764229d78de4437(e) {
    const [t, n] = e.split($a5d33cfc7f8e5437$var$Pe);
    return {
        namespace: t,
        reference: n
    };
}
function $a5d33cfc7f8e5437$export$a5999672e4930644(e) {
    const { namespace: t, reference: n } = e;
    return [
        t,
        n
    ].join($a5d33cfc7f8e5437$var$Pe);
}
function $a5d33cfc7f8e5437$export$276ab0158c66e3d(e) {
    const [t, n, r] = e.split($a5d33cfc7f8e5437$var$Pe);
    return {
        namespace: t,
        reference: n,
        address: r
    };
}
function $a5d33cfc7f8e5437$export$566a25328fb93a18(e) {
    const { namespace: t, reference: n, address: r } = e;
    return [
        t,
        n,
        r
    ].join($a5d33cfc7f8e5437$var$Pe);
}
function $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, t) {
    const n = [];
    return e.forEach((r)=>{
        const o = t(r);
        n.includes(o) || n.push(o);
    }), n;
}
function $a5d33cfc7f8e5437$export$2806d446053abd1d(e) {
    const { address: t } = $a5d33cfc7f8e5437$export$276ab0158c66e3d(e);
    return t;
}
function $a5d33cfc7f8e5437$export$93512919ec2ab555(e) {
    const { namespace: t, reference: n } = $a5d33cfc7f8e5437$export$276ab0158c66e3d(e);
    return $a5d33cfc7f8e5437$export$a5999672e4930644({
        namespace: t,
        reference: n
    });
}
function $a5d33cfc7f8e5437$export$40283ddc77f27f6e(e, t) {
    const { namespace: n, reference: r } = $a5d33cfc7f8e5437$export$4764229d78de4437(t);
    return $a5d33cfc7f8e5437$export$566a25328fb93a18({
        namespace: n,
        reference: r,
        address: e
    });
}
function $a5d33cfc7f8e5437$export$aa4a6b630dfcfa83(e) {
    return $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, $a5d33cfc7f8e5437$export$2806d446053abd1d);
}
function $a5d33cfc7f8e5437$export$d5ee58c6b13696e9(e) {
    return $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, $a5d33cfc7f8e5437$export$93512919ec2ab555);
}
function $a5d33cfc7f8e5437$export$23329703ad972840(e, t = []) {
    const n = [];
    return Object.keys(e).forEach((r)=>{
        if (t.length && !t.includes(r)) return;
        const o = e[r];
        n.push(...o.accounts);
    }), n;
}
function $a5d33cfc7f8e5437$export$6281ff29da5f85fe(e, t = []) {
    const n = [];
    return Object.keys(e).forEach((r)=>{
        if (t.length && !t.includes(r)) return;
        const o = e[r];
        n.push(...$a5d33cfc7f8e5437$export$d5ee58c6b13696e9(o.accounts));
    }), n;
}
function $a5d33cfc7f8e5437$export$d1109eeb751412cf(e, t = []) {
    const n = [];
    return Object.keys(e).forEach((r)=>{
        if (t.length && !t.includes(r)) return;
        const o = e[r];
        n.push(...$a5d33cfc7f8e5437$export$376384387cd15b27(r, o));
    }), n;
}
function $a5d33cfc7f8e5437$export$376384387cd15b27(e, t) {
    return e.includes(":") ? [
        e
    ] : t.chains || [];
}
const $a5d33cfc7f8e5437$export$f12873d77424d47b = "ReactNative", $a5d33cfc7f8e5437$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $a5d33cfc7f8e5437$export$657dee6d5648750a = " ", $a5d33cfc7f8e5437$export$96c3628b3b9d2079 = ":", $a5d33cfc7f8e5437$export$98238152dfccf046 = "/", $a5d33cfc7f8e5437$export$7f882bb969de14a3 = 2, $a5d33cfc7f8e5437$export$77baccb4c6bd5852 = 1e3, $a5d33cfc7f8e5437$export$e08b61c98317d88c = "js";
function $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() {
    return false;
}
function $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() {
    return !(0, $9cba2bd26fe13e26$exports.getDocument)() && !!(0, $9cba2bd26fe13e26$exports.getNavigator)() && navigator.product === $a5d33cfc7f8e5437$export$f12873d77424d47b;
}
function $a5d33cfc7f8e5437$export$a11b0059900ceec8() {
    return $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u" && ($parcel$global == null ? void 0 : $parcel$global.Platform.OS) === "android";
}
function $a5d33cfc7f8e5437$export$41a665f744414057() {
    return $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u" && ($parcel$global == null ? void 0 : $parcel$global.Platform.OS) === "ios";
}
function $a5d33cfc7f8e5437$export$4e09c449d6c407f7() {
    return !$a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() && !!(0, $9cba2bd26fe13e26$exports.getNavigator)() && !!(0, $9cba2bd26fe13e26$exports.getDocument)();
}
function $a5d33cfc7f8e5437$export$57570b1603cf6adb() {
    return $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative : $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.node : $a5d33cfc7f8e5437$export$4e09c449d6c407f7() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser : $a5d33cfc7f8e5437$export$86b1301a63b15dd9.unknown;
}
function $a5d33cfc7f8e5437$export$fb2283f4a44fb53() {
    var e;
    try {
        return $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $a5d33cfc7f8e5437$export$c4147c69f6845da(e, t) {
    const n = new URLSearchParams(e);
    for (const r of Object.keys(t).sort())if (t.hasOwnProperty(r)) {
        const o = t[r];
        o !== void 0 && n.set(r, o);
    }
    return n.toString();
}
function $a5d33cfc7f8e5437$export$ba31e015127122bb() {
    return (0, $6824eb17eeee766a$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $a5d33cfc7f8e5437$export$6b05aa0115b6fc2d(e, t) {
    var n;
    const r = $a5d33cfc7f8e5437$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: t,
        env: r
    };
    return r === "browser" && (o.host = ((n = (0, $9cba2bd26fe13e26$exports.getLocation)()) == null ? void 0 : n.host) || "unknown"), o;
}
function $a5d33cfc7f8e5437$export$20d4a3cb5829b8b6() {
    if ($a5d33cfc7f8e5437$export$57570b1603cf6adb() === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: n, Version: r } = $parcel$global.Platform;
        return [
            n,
            r
        ].join("-");
    }
    const e = (0, $48968958eb8b72e8$export$17b446b869dad473)();
    if (e === null) return "unknown";
    const t = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        t,
        e.name,
        e.version
    ].join("-") : [
        t,
        e.version
    ].join("-");
}
function $a5d33cfc7f8e5437$export$4389b0987726d52d() {
    var e;
    const t = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
    return t === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser ? [
        t,
        ((e = (0, $9cba2bd26fe13e26$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : t;
}
function $a5d33cfc7f8e5437$export$b55a4c6e272b719f(e, t, n) {
    const r = $a5d33cfc7f8e5437$export$20d4a3cb5829b8b6(), o = $a5d33cfc7f8e5437$export$4389b0987726d52d();
    return [
        [
            e,
            t
        ].join("-"),
        [
            $a5d33cfc7f8e5437$export$e08b61c98317d88c,
            n
        ].join("-"),
        r,
        o
    ].join("/");
}
function $a5d33cfc7f8e5437$export$d875b3963ef774f5({ protocol: e, version: t, relayUrl: n, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: c, packageName: u }) {
    const a = n.split("?"), l = $a5d33cfc7f8e5437$export$b55a4c6e272b719f(e, t, r), f = {
        auth: o,
        ua: l,
        projectId: s,
        useOnCloseEvent: i || void 0,
        packageName: u || void 0,
        bundleId: c || void 0
    }, d = $a5d33cfc7f8e5437$export$c4147c69f6845da(a[1] || "", f);
    return a[0] + "?" + d;
}
function $a5d33cfc7f8e5437$export$ed08891a8a54eb(e) {
    let t = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const n = typeof t < "u" ? e.split("://")[1] : e;
    return t = t === "wss" ? "https" : "http", [
        t,
        n
    ].join("://");
}
function $a5d33cfc7f8e5437$export$804de46662e4ac95(e, t, n) {
    if (!e[t] || typeof e[t] !== n) throw new Error(`Missing or invalid "${t}" param`);
}
function $a5d33cfc7f8e5437$export$1e21530e896c0b0b(e, t = $a5d33cfc7f8e5437$export$7f882bb969de14a3) {
    return $a5d33cfc7f8e5437$export$7f00885504704576(e.split($a5d33cfc7f8e5437$export$98238152dfccf046), t);
}
function $a5d33cfc7f8e5437$export$80bffd46c37a96f6(e) {
    return $a5d33cfc7f8e5437$export$1e21530e896c0b0b(e).join($a5d33cfc7f8e5437$export$657dee6d5648750a);
}
function $a5d33cfc7f8e5437$export$1468a49de573f7f9(e, t) {
    return e.filter((n)=>t.includes(n)).length === e.length;
}
function $a5d33cfc7f8e5437$export$7f00885504704576(e, t = $a5d33cfc7f8e5437$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - t, 0));
}
function $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $a5d33cfc7f8e5437$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $a5d33cfc7f8e5437$export$592ef47eabb05614(e, t) {
    const n = {};
    return Object.keys(e).forEach((r)=>{
        n[r] = t(e[r]);
    }), n;
}
const $a5d33cfc7f8e5437$export$85c927578394b28b = (e)=>e;
function $a5d33cfc7f8e5437$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (t)=>t.toUpperCase());
}
function $a5d33cfc7f8e5437$export$9a00dee1beb8f576(e) {
    return e.split($a5d33cfc7f8e5437$export$657dee6d5648750a).map((t)=>$a5d33cfc7f8e5437$export$e9f8fcacef3bca4b(t)).join($a5d33cfc7f8e5437$export$657dee6d5648750a);
}
function $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb(e = (0, $7c6109395b060f04$exports.FIVE_MINUTES), t) {
    const n = (0, $7c6109395b060f04$exports.toMiliseconds)(e || (0, $7c6109395b060f04$exports.FIVE_MINUTES));
    let r, o, s, i;
    return {
        resolve: (c)=>{
            s && r && (clearTimeout(s), r(c), i = Promise.resolve(c));
        },
        reject: (c)=>{
            s && o && (clearTimeout(s), o(c));
        },
        done: ()=>new Promise((c, u)=>{
                if (i) return c(i);
                s = setTimeout(()=>{
                    const a = new Error(t);
                    i = Promise.reject(a), u(a);
                }, n), r = c, o = u;
            })
    };
}
function $a5d33cfc7f8e5437$export$3da2293b007ed708(e, t, n) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(n)), t);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $a5d33cfc7f8e5437$export$187ab6574b2ae23f(e, t) {
    if (typeof t == "string" && t.startsWith(`${e}:`)) return t;
    if (e.toLowerCase() === "topic") {
        if (typeof t != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${t}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof t != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${t}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $a5d33cfc7f8e5437$export$43ab92477f8713b9(e) {
    return $a5d33cfc7f8e5437$export$187ab6574b2ae23f("topic", e);
}
function $a5d33cfc7f8e5437$export$bd13103c2e5cc0c3(e) {
    return $a5d33cfc7f8e5437$export$187ab6574b2ae23f("id", e);
}
function $a5d33cfc7f8e5437$export$93adeb0f16e8e51d(e) {
    const [t, n] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (t === "topic" && typeof n == "string") r.topic = n;
    else if (t === "id" && Number.isInteger(Number(n))) r.id = Number(n);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${t}:${n}`);
    return r;
}
function $a5d33cfc7f8e5437$export$b136d03015bfc12(e, t) {
    return (0, $7c6109395b060f04$exports.fromMiliseconds)((t || Date.now()) + (0, $7c6109395b060f04$exports.toMiliseconds)(e));
}
function $a5d33cfc7f8e5437$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $7c6109395b060f04$exports.toMiliseconds)(e);
}
function $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9(e, t) {
    return `${e}${t ? `:${t}` : ""}`;
}
function $a5d33cfc7f8e5437$export$9826fe7ad3921016(e = [], t = []) {
    return [
        ...new Set([
            ...e,
            ...t
        ])
    ];
}
async function $a5d33cfc7f8e5437$export$694a208c8abca99a({ id: e, topic: t, wcDeepLink: n }) {
    var r;
    try {
        if (!n) return;
        const o = typeof n == "string" ? JSON.parse(n) : n, s = o?.href;
        if (typeof s != "string") return;
        const i = $a5d33cfc7f8e5437$export$50b95b57215c848b(s, e, t), c = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
        if (c === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser) {
            if (!((r = (0, $9cba2bd26fe13e26$exports.getDocument)()) != null && r.hasFocus())) {
                console.warn("Document does not have focus, skipping deeplink.");
                return;
            }
            $a5d33cfc7f8e5437$export$435b055258496866(i);
        } else c === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(i);
    } catch (o) {
        console.error(o);
    }
}
function $a5d33cfc7f8e5437$export$50b95b57215c848b(e, t, n) {
    const r = `requestId=${t}&sessionTopic=${n}`;
    e.endsWith("/") && (e = e.slice(0, -1));
    let o = `${e}`;
    if (e.startsWith("https://t.me")) {
        const s = e.includes("?") ? "&startapp=" : "?startapp=";
        o = `${o}${s}${$a5d33cfc7f8e5437$export$37cc283d8fbd3462(r, !0)}`;
    } else o = `${o}/wc?${r}`;
    return o;
}
function $a5d33cfc7f8e5437$export$435b055258496866(e) {
    let t = "_self";
    $a5d33cfc7f8e5437$export$e6c5ffa684aac4d7() ? t = "_top" : ($a5d33cfc7f8e5437$export$859b6b071fc07ffd() || e.startsWith("https://") || e.startsWith("http://")) && (t = "_blank"), window.open(e, t, "noreferrer noopener");
}
async function $a5d33cfc7f8e5437$export$e55bfdac47149a32(e, t) {
    let n = "";
    try {
        if ($a5d33cfc7f8e5437$export$4e09c449d6c407f7() && (n = localStorage.getItem(t), n)) return n;
        n = await e.getItem(t);
    } catch (r) {
        console.error(r);
    }
    return n;
}
function $a5d33cfc7f8e5437$export$f8aaf09178dd8b96(e, t) {
    return e.filter((n)=>t.includes(n));
}
function $a5d33cfc7f8e5437$export$e35f0b82969c30c3(e, t) {
    if (!e.includes(t)) return null;
    const n = e.split(/([&,?,=])/), r = n.indexOf(t);
    return n[r + 2];
}
function $a5d33cfc7f8e5437$export$abe4376e1bf796d6() {
    return typeof crypto < "u" && crypto != null && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (e)=>{
        const t = Math.random() * 16 | 0;
        return (e === "x" ? t : t & 3 | 8).toString(16);
    });
}
function $a5d33cfc7f8e5437$export$b4bb0f87d8376dd4() {
    return false;
}
function $a5d33cfc7f8e5437$export$859b6b071fc07ffd() {
    return typeof window < "u" && (!!window.TelegramWebviewProxy || !!window.Telegram || !!window.TelegramWebviewProxyProto);
}
function $a5d33cfc7f8e5437$export$e6c5ffa684aac4d7() {
    try {
        return window.self !== window.top;
    } catch  {
        return !1;
    }
}
function $a5d33cfc7f8e5437$export$37cc283d8fbd3462(e, t = !1) {
    const n = $a5d33cfc7f8e5437$require$Buffer.from(e).toString("base64");
    return t ? n.replace(/[=]/g, "") : n;
}
function $a5d33cfc7f8e5437$export$c537b38001c583b7(e) {
    return $a5d33cfc7f8e5437$require$Buffer.from(e, "base64").toString("utf-8");
}
function $a5d33cfc7f8e5437$export$e772c8ff12451969(e) {
    return new Promise((t)=>setTimeout(t, e));
}
function $a5d33cfc7f8e5437$var$Ne(e) {
    if (!Number.isSafeInteger(e) || e < 0) throw new Error("positive integer expected, got " + e);
}
function $a5d33cfc7f8e5437$var$xo(e) {
    return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function $a5d33cfc7f8e5437$var$je(e, ...t) {
    if (!$a5d33cfc7f8e5437$var$xo(e)) throw new Error("Uint8Array expected");
    if (t.length > 0 && !t.includes(e.length)) throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function $a5d33cfc7f8e5437$var$ot(e) {
    if (typeof e != "function" || typeof e.create != "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $a5d33cfc7f8e5437$var$Ne(e.outputLen), $a5d33cfc7f8e5437$var$Ne(e.blockLen);
}
function $a5d33cfc7f8e5437$var$me(e, t = !0) {
    if (e.destroyed) throw new Error("Hash instance has been destroyed");
    if (t && e.finished) throw new Error("Hash#digest() has already been called");
}
function $a5d33cfc7f8e5437$var$sn(e, t) {
    $a5d33cfc7f8e5437$var$je(e);
    const n = t.outputLen;
    if (e.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
}
const $a5d33cfc7f8e5437$var$Ce = BigInt(2 ** 32 - 1), $a5d33cfc7f8e5437$var$cn = BigInt(32);
function $a5d33cfc7f8e5437$var$Oo(e, t = !1) {
    return t ? {
        h: Number(e & $a5d33cfc7f8e5437$var$Ce),
        l: Number(e >> $a5d33cfc7f8e5437$var$cn & $a5d33cfc7f8e5437$var$Ce)
    } : {
        h: Number(e >> $a5d33cfc7f8e5437$var$cn & $a5d33cfc7f8e5437$var$Ce) | 0,
        l: Number(e & $a5d33cfc7f8e5437$var$Ce) | 0
    };
}
function $a5d33cfc7f8e5437$var$Io(e, t = !1) {
    let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
    for(let o = 0; o < e.length; o++){
        const { h: s, l: i } = $a5d33cfc7f8e5437$var$Oo(e[o], t);
        [n[o], r[o]] = [
            s,
            i
        ];
    }
    return [
        n,
        r
    ];
}
const $a5d33cfc7f8e5437$var$Ao = (e, t, n)=>e << n | t >>> 32 - n, $a5d33cfc7f8e5437$var$No = (e, t, n)=>t << n | e >>> 32 - n, $a5d33cfc7f8e5437$var$So = (e, t, n)=>t << n - 32 | e >>> 64 - n, $a5d33cfc7f8e5437$var$Uo = (e, t, n)=>e << n - 32 | t >>> 64 - n, $a5d33cfc7f8e5437$var$be = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
function $a5d33cfc7f8e5437$var$_o(e) {
    return new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4));
}
function $a5d33cfc7f8e5437$var$st(e) {
    return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function $a5d33cfc7f8e5437$var$J(e, t) {
    return e << 32 - t | e >>> t;
}
const $a5d33cfc7f8e5437$var$an = (()=>new Uint8Array(new Uint32Array([
        287454020
    ]).buffer)[0] === 68)();
function $a5d33cfc7f8e5437$var$To(e) {
    return e << 24 & 4278190080 | e << 8 & 16711680 | e >>> 8 & 65280 | e >>> 24 & 255;
}
function $a5d33cfc7f8e5437$var$un(e) {
    for(let t = 0; t < e.length; t++)e[t] = $a5d33cfc7f8e5437$var$To(e[t]);
}
function $a5d33cfc7f8e5437$var$$o(e) {
    if (typeof e != "string") throw new Error("utf8ToBytes expected string, got " + typeof e);
    return new Uint8Array(new TextEncoder().encode(e));
}
function $a5d33cfc7f8e5437$var$we(e) {
    return typeof e == "string" && (e = $a5d33cfc7f8e5437$var$$o(e)), $a5d33cfc7f8e5437$var$je(e), e;
}
class $a5d33cfc7f8e5437$var$it {
    clone() {
        return this._cloneInto();
    }
}
function $a5d33cfc7f8e5437$var$fn(e) {
    const t = (r)=>e().update($a5d33cfc7f8e5437$var$we(r)).digest(), n = e();
    return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = ()=>e(), t;
}
function $a5d33cfc7f8e5437$var$Se(e = 32) {
    if ($a5d33cfc7f8e5437$var$be && typeof $a5d33cfc7f8e5437$var$be.getRandomValues == "function") return $a5d33cfc7f8e5437$var$be.getRandomValues(new Uint8Array(e));
    if ($a5d33cfc7f8e5437$var$be && typeof $a5d33cfc7f8e5437$var$be.randomBytes == "function") return $a5d33cfc7f8e5437$var$be.randomBytes(e);
    throw new Error("crypto.getRandomValues must be defined");
}
const $a5d33cfc7f8e5437$var$ln = [], $a5d33cfc7f8e5437$var$dn = [], $a5d33cfc7f8e5437$var$hn = [], $a5d33cfc7f8e5437$var$Ro = BigInt(0), $a5d33cfc7f8e5437$var$Ue = BigInt(1), $a5d33cfc7f8e5437$var$Po = BigInt(2), $a5d33cfc7f8e5437$var$Lo = BigInt(7), $a5d33cfc7f8e5437$var$Bo = BigInt(256), $a5d33cfc7f8e5437$var$jo = BigInt(113);
for(let e = 0, t = $a5d33cfc7f8e5437$var$Ue, n = 1, r = 0; e < 24; e++){
    [n, r] = [
        r,
        (2 * n + 3 * r) % 5
    ], $a5d33cfc7f8e5437$var$ln.push(2 * (5 * r + n)), $a5d33cfc7f8e5437$var$dn.push((e + 1) * (e + 2) / 2 % 64);
    let o = $a5d33cfc7f8e5437$var$Ro;
    for(let s = 0; s < 7; s++)t = (t << $a5d33cfc7f8e5437$var$Ue ^ (t >> $a5d33cfc7f8e5437$var$Lo) * $a5d33cfc7f8e5437$var$jo) % $a5d33cfc7f8e5437$var$Bo, t & $a5d33cfc7f8e5437$var$Po && (o ^= $a5d33cfc7f8e5437$var$Ue << ($a5d33cfc7f8e5437$var$Ue << BigInt(s)) - $a5d33cfc7f8e5437$var$Ue);
    $a5d33cfc7f8e5437$var$hn.push(o);
}
const [$a5d33cfc7f8e5437$var$Co, $a5d33cfc7f8e5437$var$ko] = $a5d33cfc7f8e5437$var$Io($a5d33cfc7f8e5437$var$hn, !0), $a5d33cfc7f8e5437$var$pn = (e, t, n)=>n > 32 ? $a5d33cfc7f8e5437$var$So(e, t, n) : $a5d33cfc7f8e5437$var$Ao(e, t, n), $a5d33cfc7f8e5437$var$gn = (e, t, n)=>n > 32 ? $a5d33cfc7f8e5437$var$Uo(e, t, n) : $a5d33cfc7f8e5437$var$No(e, t, n);
function $a5d33cfc7f8e5437$var$Do(e, t = 24) {
    const n = new Uint32Array(10);
    for(let r = 24 - t; r < 24; r++){
        for(let i = 0; i < 10; i++)n[i] = e[i] ^ e[i + 10] ^ e[i + 20] ^ e[i + 30] ^ e[i + 40];
        for(let i = 0; i < 10; i += 2){
            const c = (i + 8) % 10, u = (i + 2) % 10, a = n[u], l = n[u + 1], f = $a5d33cfc7f8e5437$var$pn(a, l, 1) ^ n[c], d = $a5d33cfc7f8e5437$var$gn(a, l, 1) ^ n[c + 1];
            for(let g = 0; g < 50; g += 10)e[i + g] ^= f, e[i + g + 1] ^= d;
        }
        let o = e[2], s = e[3];
        for(let i = 0; i < 24; i++){
            const c = $a5d33cfc7f8e5437$var$dn[i], u = $a5d33cfc7f8e5437$var$pn(o, s, c), a = $a5d33cfc7f8e5437$var$gn(o, s, c), l = $a5d33cfc7f8e5437$var$ln[i];
            o = e[l], s = e[l + 1], e[l] = u, e[l + 1] = a;
        }
        for(let i = 0; i < 50; i += 10){
            for(let c = 0; c < 10; c++)n[c] = e[i + c];
            for(let c = 0; c < 10; c++)e[i + c] ^= ~n[(c + 2) % 10] & n[(c + 4) % 10];
        }
        e[0] ^= $a5d33cfc7f8e5437$var$Co[r], e[1] ^= $a5d33cfc7f8e5437$var$ko[r];
    }
    n.fill(0);
}
class $a5d33cfc7f8e5437$var$Bt extends $a5d33cfc7f8e5437$var$it {
    constructor(t, n, r, o = !1, s = 24){
        if (super(), this.blockLen = t, this.suffix = n, this.outputLen = r, this.enableXOF = o, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, $a5d33cfc7f8e5437$var$Ne(r), 0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200), this.state32 = $a5d33cfc7f8e5437$var$_o(this.state);
    }
    keccak() {
        $a5d33cfc7f8e5437$var$an || $a5d33cfc7f8e5437$var$un(this.state32), $a5d33cfc7f8e5437$var$Do(this.state32, this.rounds), $a5d33cfc7f8e5437$var$an || $a5d33cfc7f8e5437$var$un(this.state32), this.posOut = 0, this.pos = 0;
    }
    update(t) {
        $a5d33cfc7f8e5437$var$me(this);
        const { blockLen: n, state: r } = this;
        t = $a5d33cfc7f8e5437$var$we(t);
        const o = t.length;
        for(let s = 0; s < o;){
            const i = Math.min(n - this.pos, o - s);
            for(let c = 0; c < i; c++)r[this.pos++] ^= t[s++];
            this.pos === n && this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = !0;
        const { state: t, suffix: n, pos: r, blockLen: o } = this;
        t[r] ^= n, n & 128 && r === o - 1 && this.keccak(), t[o - 1] ^= 128, this.keccak();
    }
    writeInto(t) {
        $a5d33cfc7f8e5437$var$me(this, !1), $a5d33cfc7f8e5437$var$je(t), this.finish();
        const n = this.state, { blockLen: r } = this;
        for(let o = 0, s = t.length; o < s;){
            this.posOut >= r && this.keccak();
            const i = Math.min(r - this.posOut, s - o);
            t.set(n.subarray(this.posOut, this.posOut + i), o), this.posOut += i, o += i;
        }
        return t;
    }
    xofInto(t) {
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(t);
    }
    xof(t) {
        return $a5d33cfc7f8e5437$var$Ne(t), this.xofInto(new Uint8Array(t));
    }
    digestInto(t) {
        if ($a5d33cfc7f8e5437$var$sn(t, this), this.finished) throw new Error("digest() was already called");
        return this.writeInto(t), this.destroy(), t;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(t) {
        const { blockLen: n, suffix: r, outputLen: o, rounds: s, enableXOF: i } = this;
        return t || (t = new $a5d33cfc7f8e5437$var$Bt(n, r, o, i, s)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = s, t.suffix = r, t.outputLen = o, t.enableXOF = i, t.destroyed = this.destroyed, t;
    }
}
const $a5d33cfc7f8e5437$var$Mo = (e, t, n)=>$a5d33cfc7f8e5437$var$fn(()=>new $a5d33cfc7f8e5437$var$Bt(t, e, n)), $a5d33cfc7f8e5437$var$Vo = $a5d33cfc7f8e5437$var$Mo(1, 136, 32), $a5d33cfc7f8e5437$var$Ho = "https://rpc.walletconnect.org/v1";
function $a5d33cfc7f8e5437$export$13666321730419b4(e) {
    const t = `Ethereum Signed Message:
${e.length}`, n = new TextEncoder().encode(t + e);
    return "0x" + $a5d33cfc7f8e5437$require$Buffer.from($a5d33cfc7f8e5437$var$Vo(n)).toString("hex");
}
async function $a5d33cfc7f8e5437$export$ab54e47fdf2903bb(e, t, n, r, o, s) {
    switch(n.t){
        case "eip191":
            return $a5d33cfc7f8e5437$export$b5da105d64914e5a(e, t, n.s);
        case "eip1271":
            return await $a5d33cfc7f8e5437$export$9bffe3330373b76b(e, t, n.s, r, o, s);
        default:
            throw new Error(`verifySignature failed: Attempted to verify CacaoSignature with unknown type: ${n.t}`);
    }
}
function $a5d33cfc7f8e5437$export$b5da105d64914e5a(e, t, n) {
    return (0, $0a7021bc70fec74d$export$23cc18f96d8510e2)($a5d33cfc7f8e5437$export$13666321730419b4(t), n).toLowerCase() === e.toLowerCase();
}
async function $a5d33cfc7f8e5437$export$9bffe3330373b76b(e, t, n, r, o, s) {
    const i = $a5d33cfc7f8e5437$export$4764229d78de4437(r);
    if (!i.namespace || !i.reference) throw new Error(`isValidEip1271Signature failed: chainId must be in CAIP-2 format, received: ${r}`);
    try {
        const c = "0x1626ba7e", u = "0000000000000000000000000000000000000000000000000000000000000040", a = "0000000000000000000000000000000000000000000000000000000000000041", l = n.substring(2), f = $a5d33cfc7f8e5437$export$13666321730419b4(t).substring(2), d = c + f + u + a + l, g = await fetch(`${s || $a5d33cfc7f8e5437$var$Ho}/?chainId=${r}&projectId=${o}`, {
            method: "POST",
            body: JSON.stringify({
                id: $a5d33cfc7f8e5437$var$Ko(),
                jsonrpc: "2.0",
                method: "eth_call",
                params: [
                    {
                        to: e,
                        data: d
                    },
                    "latest"
                ]
            })
        }), { result: y } = await g.json();
        return y ? y.slice(0, c.length).toLowerCase() === c.toLowerCase() : !1;
    } catch (c) {
        return console.error("isValidEip1271Signature: ", c), !1;
    }
}
function $a5d33cfc7f8e5437$var$Ko() {
    return Date.now() + Math.floor(Math.random() * 1e3);
}
var $a5d33cfc7f8e5437$var$Fo = Object.defineProperty, $a5d33cfc7f8e5437$var$qo = Object.defineProperties, $a5d33cfc7f8e5437$var$Go = Object.getOwnPropertyDescriptors, $a5d33cfc7f8e5437$var$wn = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$Wo = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$zo = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$En = (e, t, n)=>t in e ? $a5d33cfc7f8e5437$var$Fo(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n, $a5d33cfc7f8e5437$var$at = (e, t)=>{
    for(var n in t || (t = {}))$a5d33cfc7f8e5437$var$Wo.call(t, n) && $a5d33cfc7f8e5437$var$En(e, n, t[n]);
    if ($a5d33cfc7f8e5437$var$wn) for (var n of $a5d33cfc7f8e5437$var$wn(t))$a5d33cfc7f8e5437$var$zo.call(t, n) && $a5d33cfc7f8e5437$var$En(e, n, t[n]);
    return e;
}, $a5d33cfc7f8e5437$var$vn = (e, t)=>$a5d33cfc7f8e5437$var$qo(e, $a5d33cfc7f8e5437$var$Go(t));
const $a5d33cfc7f8e5437$var$Jo = "did:pkh:", $a5d33cfc7f8e5437$export$a524ae552db7912 = (e)=>e?.split(":"), $a5d33cfc7f8e5437$export$85f23c05c80b194 = (e)=>{
    const t = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (t) return e.includes($a5d33cfc7f8e5437$var$Jo) ? t[3] : t[1];
}, $a5d33cfc7f8e5437$export$a8b149927aef7051 = (e)=>{
    const t = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (t) return t[2] + ":" + t[3];
}, $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9 = (e)=>{
    const t = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (t) return t.pop();
};
async function $a5d33cfc7f8e5437$export$b7d566fce8e2b970(e) {
    const { cacao: t, projectId: n } = e, { s: r, p: o } = t, s = $a5d33cfc7f8e5437$export$25868d1e8e76735f(o, o.iss), i = $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9(o.iss);
    return await $a5d33cfc7f8e5437$export$ab54e47fdf2903bb(i, s, r, $a5d33cfc7f8e5437$export$a8b149927aef7051(o.iss), n);
}
const $a5d33cfc7f8e5437$export$25868d1e8e76735f = (e, t)=>{
    const n = `${e.domain} wants you to sign in with your Ethereum account:`, r = $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9(t);
    if (!e.aud && !e.uri) throw new Error("Either `aud` or `uri` is required to construct the message");
    let o = e.statement || void 0;
    const s = `URI: ${e.aud || e.uri}`, i = `Version: ${e.version}`, c = `Chain ID: ${$a5d33cfc7f8e5437$export$85f23c05c80b194(t)}`, u = `Nonce: ${e.nonce}`, a = `Issued At: ${e.iat}`, l = e.exp ? `Expiration Time: ${e.exp}` : void 0, f = e.nbf ? `Not Before: ${e.nbf}` : void 0, d = e.requestId ? `Request ID: ${e.requestId}` : void 0, g = e.resources ? `Resources:${e.resources.map((h)=>`
- ${h}`).join("")}` : void 0, y = $a5d33cfc7f8e5437$export$3bb18ae0fb9a9fa9(e.resources);
    if (y) {
        const h = $a5d33cfc7f8e5437$export$d34522c9e5a1aed1(y);
        o = $a5d33cfc7f8e5437$export$51673931d3a8308d(o, h);
    }
    return [
        n,
        r,
        "",
        o,
        "",
        s,
        i,
        c,
        u,
        a,
        l,
        f,
        d,
        g
    ].filter((h)=>h != null).join(`
`);
};
function $a5d33cfc7f8e5437$export$905974078a05d5f9(e, t, n) {
    return n.includes("did:pkh:") || (n = `did:pkh:${n}`), {
        h: {
            t: "caip122"
        },
        p: {
            iss: n,
            domain: e.domain,
            aud: e.aud,
            version: e.version,
            nonce: e.nonce,
            iat: e.iat,
            statement: e.statement,
            requestId: e.requestId,
            resources: e.resources,
            nbf: e.nbf,
            exp: e.exp
        },
        s: t
    };
}
function $a5d33cfc7f8e5437$export$2bfa2ac7d9bc193c(e) {
    var t;
    const { authPayload: n, chains: r, methods: o } = e, s = n.statement || "";
    if (!(r != null && r.length)) return n;
    const i = n.chains, c = $a5d33cfc7f8e5437$export$f8aaf09178dd8b96(i, r);
    if (!(c != null && c.length)) throw new Error("No supported chains");
    const u = $a5d33cfc7f8e5437$export$8db308c294c84efd(n.resources);
    if (!u) return n;
    $a5d33cfc7f8e5437$export$ae8075c482503f32(u);
    const a = $a5d33cfc7f8e5437$export$9595a56724061288(u, "eip155");
    let l = n?.resources || [];
    if (a != null && a.length) {
        const f = $a5d33cfc7f8e5437$export$e1a9af3d61db3b68(a), d = $a5d33cfc7f8e5437$export$f8aaf09178dd8b96(f, o);
        if (!(d != null && d.length)) throw new Error(`Supported methods don't satisfy the requested: ${JSON.stringify(f)}, supported: ${JSON.stringify(o)}`);
        const g = $a5d33cfc7f8e5437$export$987cafd76db78dd1("request", d, {
            chains: c
        }), y = $a5d33cfc7f8e5437$export$317cb0007b0867c1(u, "eip155", g);
        l = ((t = n?.resources) == null ? void 0 : t.slice(0, -1)) || [], l.push($a5d33cfc7f8e5437$export$79a538532b4f11f7(y));
    }
    return $a5d33cfc7f8e5437$var$vn($a5d33cfc7f8e5437$var$at({}, n), {
        statement: $a5d33cfc7f8e5437$export$fb351782bc6f001e(s, $a5d33cfc7f8e5437$export$3bb18ae0fb9a9fa9(l)),
        chains: c,
        resources: n != null && n.resources || l.length > 0 ? l : void 0
    });
}
function $a5d33cfc7f8e5437$export$8db308c294c84efd(e) {
    const t = $a5d33cfc7f8e5437$export$3bb18ae0fb9a9fa9(e);
    if (t && $a5d33cfc7f8e5437$export$d9f11bd9fec5a64(t)) return $a5d33cfc7f8e5437$export$d34522c9e5a1aed1(t);
}
function $a5d33cfc7f8e5437$export$771534f1eaa353c(e, t) {
    var n;
    return (n = e?.att) == null ? void 0 : n.hasOwnProperty(t);
}
function $a5d33cfc7f8e5437$export$9595a56724061288(e, t) {
    var n, r;
    return (n = e?.att) != null && n[t] ? Object.keys((r = e?.att) == null ? void 0 : r[t]) : [];
}
function $a5d33cfc7f8e5437$export$d4548b739f9dafe(e) {
    return e?.map((t)=>Object.keys(t)) || [];
}
function $a5d33cfc7f8e5437$export$e1a9af3d61db3b68(e) {
    return e?.map((t)=>{
        var n;
        return (n = t.split("/")) == null ? void 0 : n[1];
    }) || [];
}
function $a5d33cfc7f8e5437$export$e510a73ee562749(e) {
    return $a5d33cfc7f8e5437$require$Buffer.from(JSON.stringify(e)).toString("base64");
}
function $a5d33cfc7f8e5437$export$c62426fdd000a97e(e) {
    return JSON.parse($a5d33cfc7f8e5437$require$Buffer.from(e, "base64").toString("utf-8"));
}
function $a5d33cfc7f8e5437$export$ae8075c482503f32(e) {
    if (!e) throw new Error("No recap provided, value is undefined");
    if (!e.att) throw new Error("No `att` property found");
    const t = Object.keys(e.att);
    if (!(t != null && t.length)) throw new Error("No resources found in `att` property");
    t.forEach((n)=>{
        const r = e.att[n];
        if (Array.isArray(r)) throw new Error(`Resource must be an object: ${n}`);
        if (typeof r != "object") throw new Error(`Resource must be an object: ${n}`);
        if (!Object.keys(r).length) throw new Error(`Resource object is empty: ${n}`);
        Object.keys(r).forEach((o)=>{
            const s = r[o];
            if (!Array.isArray(s)) throw new Error(`Ability limits ${o} must be an array of objects, found: ${s}`);
            if (!s.length) throw new Error(`Value of ${o} is empty array, must be an array with objects`);
            s.forEach((i)=>{
                if (typeof i != "object") throw new Error(`Ability limits (${o}) must be an array of objects, found: ${i}`);
            });
        });
    });
}
function $a5d33cfc7f8e5437$export$eea18a04b33506ed(e, t, n, r = {}) {
    return n?.sort((o, s)=>o.localeCompare(s)), {
        att: {
            [e]: $a5d33cfc7f8e5437$export$987cafd76db78dd1(t, n, r)
        }
    };
}
function $a5d33cfc7f8e5437$export$317cb0007b0867c1(e, t, n) {
    var r;
    return e.att[t] = $a5d33cfc7f8e5437$var$at({}, n), ((r = Object.keys(e.att)) == null ? void 0 : r.sort((o, s)=>o.localeCompare(s))).reduce((o, s)=>(o.att[s] = e.att[s], o), {
        att: {}
    });
}
function $a5d33cfc7f8e5437$export$987cafd76db78dd1(e, t, n = {}) {
    t = t?.sort((o, s)=>o.localeCompare(s));
    const r = t.map((o)=>({
            [`${e}/${o}`]: [
                n
            ]
        }));
    return Object.assign({}, ...r);
}
function $a5d33cfc7f8e5437$export$79a538532b4f11f7(e) {
    return $a5d33cfc7f8e5437$export$ae8075c482503f32(e), `urn:recap:${$a5d33cfc7f8e5437$export$e510a73ee562749(e).replace(/=/g, "")}`;
}
function $a5d33cfc7f8e5437$export$d34522c9e5a1aed1(e) {
    const t = $a5d33cfc7f8e5437$export$c62426fdd000a97e(e.replace("urn:recap:", ""));
    return $a5d33cfc7f8e5437$export$ae8075c482503f32(t), t;
}
function $a5d33cfc7f8e5437$export$2bc35d2a08a09ad5(e, t, n) {
    const r = $a5d33cfc7f8e5437$export$eea18a04b33506ed(e, t, n);
    return $a5d33cfc7f8e5437$export$79a538532b4f11f7(r);
}
function $a5d33cfc7f8e5437$export$d9f11bd9fec5a64(e) {
    return e && e.includes("urn:recap:");
}
function $a5d33cfc7f8e5437$export$c7a40c552af428b5(e, t) {
    const n = $a5d33cfc7f8e5437$export$d34522c9e5a1aed1(e), r = $a5d33cfc7f8e5437$export$d34522c9e5a1aed1(t), o = $a5d33cfc7f8e5437$export$2445df2492ef2cbd(n, r);
    return $a5d33cfc7f8e5437$export$79a538532b4f11f7(o);
}
function $a5d33cfc7f8e5437$export$2445df2492ef2cbd(e, t) {
    $a5d33cfc7f8e5437$export$ae8075c482503f32(e), $a5d33cfc7f8e5437$export$ae8075c482503f32(t);
    const n = Object.keys(e.att).concat(Object.keys(t.att)).sort((o, s)=>o.localeCompare(s)), r = {
        att: {}
    };
    return n.forEach((o)=>{
        var s, i;
        Object.keys(((s = e.att) == null ? void 0 : s[o]) || {}).concat(Object.keys(((i = t.att) == null ? void 0 : i[o]) || {})).sort((c, u)=>c.localeCompare(u)).forEach((c)=>{
            var u, a;
            r.att[o] = $a5d33cfc7f8e5437$var$vn($a5d33cfc7f8e5437$var$at({}, r.att[o]), {
                [c]: ((u = e.att[o]) == null ? void 0 : u[c]) || ((a = t.att[o]) == null ? void 0 : a[c])
            });
        });
    }), r;
}
function $a5d33cfc7f8e5437$export$51673931d3a8308d(e = "", t) {
    $a5d33cfc7f8e5437$export$ae8075c482503f32(t);
    const n = "I further authorize the stated URI to perform the following actions on my behalf: ";
    if (e.includes(n)) return e;
    const r = [];
    let o = 0;
    Object.keys(t.att).forEach((c)=>{
        const u = Object.keys(t.att[c]).map((f)=>({
                ability: f.split("/")[0],
                action: f.split("/")[1]
            }));
        u.sort((f, d)=>f.action.localeCompare(d.action));
        const a = {};
        u.forEach((f)=>{
            a[f.ability] || (a[f.ability] = []), a[f.ability].push(f.action);
        });
        const l = Object.keys(a).map((f)=>(o++, `(${o}) '${f}': '${a[f].join("', '")}' for '${c}'.`));
        r.push(l.join(", ").replace(".,", "."));
    });
    const s = r.join(" "), i = `${n}${s}`;
    return `${e ? e + " " : ""}${i}`;
}
function $a5d33cfc7f8e5437$export$d6c6a43d36418efe(e) {
    var t;
    const n = $a5d33cfc7f8e5437$export$d34522c9e5a1aed1(e);
    $a5d33cfc7f8e5437$export$ae8075c482503f32(n);
    const r = (t = n.att) == null ? void 0 : t.eip155;
    return r ? Object.keys(r).map((o)=>o.split("/")[1]) : [];
}
function $a5d33cfc7f8e5437$export$372f88051a611988(e) {
    const t = $a5d33cfc7f8e5437$export$d34522c9e5a1aed1(e);
    $a5d33cfc7f8e5437$export$ae8075c482503f32(t);
    const n = [];
    return Object.values(t.att).forEach((r)=>{
        Object.values(r).forEach((o)=>{
            var s;
            (s = o?.[0]) != null && s.chains && n.push(o[0].chains);
        });
    }), [
        ...new Set(n.flat())
    ];
}
function $a5d33cfc7f8e5437$export$fb351782bc6f001e(e, t) {
    if (!t) return e;
    const n = $a5d33cfc7f8e5437$export$d34522c9e5a1aed1(t);
    return $a5d33cfc7f8e5437$export$ae8075c482503f32(n), $a5d33cfc7f8e5437$export$51673931d3a8308d(e, n);
}
function $a5d33cfc7f8e5437$export$3bb18ae0fb9a9fa9(e) {
    if (!e) return;
    const t = e?.[e.length - 1];
    return $a5d33cfc7f8e5437$export$d9f11bd9fec5a64(t) ? t : void 0;
}
function $a5d33cfc7f8e5437$var$ht(e) {
    if (!Number.isSafeInteger(e) || e < 0) throw new Error("positive integer expected, got " + e);
}
function $a5d33cfc7f8e5437$var$Ln(e) {
    return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function $a5d33cfc7f8e5437$var$F(e, ...t) {
    if (!$a5d33cfc7f8e5437$var$Ln(e)) throw new Error("Uint8Array expected");
    if (t.length > 0 && !t.includes(e.length)) throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function $a5d33cfc7f8e5437$var$Bn(e, t = !0) {
    if (e.destroyed) throw new Error("Hash instance has been destroyed");
    if (t && e.finished) throw new Error("Hash#digest() has already been called");
}
function $a5d33cfc7f8e5437$var$ss(e, t) {
    $a5d33cfc7f8e5437$var$F(e);
    const n = t.outputLen;
    if (e.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
}
function $a5d33cfc7f8e5437$var$jn(e) {
    if (typeof e != "boolean") throw new Error(`boolean expected, not ${e}`);
}
const $a5d33cfc7f8e5437$var$se = (e)=>new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), $a5d33cfc7f8e5437$var$is = (e)=>new DataView(e.buffer, e.byteOffset, e.byteLength), $a5d33cfc7f8e5437$var$cs = new Uint8Array(new Uint32Array([
    287454020
]).buffer)[0] === 68;
if (!$a5d33cfc7f8e5437$var$cs) throw new Error("Non little-endian hardware is not supported");
function $a5d33cfc7f8e5437$var$as(e) {
    if (typeof e != "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(e));
}
function $a5d33cfc7f8e5437$var$pt(e) {
    if (typeof e == "string") e = $a5d33cfc7f8e5437$var$as(e);
    else if ($a5d33cfc7f8e5437$var$Ln(e)) e = $a5d33cfc7f8e5437$var$gt(e);
    else throw new Error("Uint8Array expected, got " + typeof e);
    return e;
}
function $a5d33cfc7f8e5437$var$us(e, t) {
    if (t == null || typeof t != "object") throw new Error("options must be defined");
    return Object.assign(e, t);
}
function $a5d33cfc7f8e5437$var$fs(e, t) {
    if (e.length !== t.length) return !1;
    let n = 0;
    for(let r = 0; r < e.length; r++)n |= e[r] ^ t[r];
    return n === 0;
}
const $a5d33cfc7f8e5437$var$ls = (e, t)=>{
    function n(r, ...o) {
        if ($a5d33cfc7f8e5437$var$F(r), e.nonceLength !== void 0) {
            const l = o[0];
            if (!l) throw new Error("nonce / iv required");
            e.varSizeNonce ? $a5d33cfc7f8e5437$var$F(l) : $a5d33cfc7f8e5437$var$F(l, e.nonceLength);
        }
        const s = e.tagLength;
        s && o[1] !== void 0 && $a5d33cfc7f8e5437$var$F(o[1]);
        const i = t(r, ...o), c = (l, f)=>{
            if (f !== void 0) {
                if (l !== 2) throw new Error("cipher output not supported");
                $a5d33cfc7f8e5437$var$F(f);
            }
        };
        let u = !1;
        return {
            encrypt (l, f) {
                if (u) throw new Error("cannot encrypt() twice with same key + nonce");
                return u = !0, $a5d33cfc7f8e5437$var$F(l), c(i.encrypt.length, f), i.encrypt(l, f);
            },
            decrypt (l, f) {
                if ($a5d33cfc7f8e5437$var$F(l), s && l.length < s) throw new Error("invalid ciphertext length: smaller than tagLength=" + s);
                return c(i.decrypt.length, f), i.decrypt(l, f);
            }
        };
    }
    return Object.assign(n, e), n;
};
function $a5d33cfc7f8e5437$var$Cn(e, t, n = !0) {
    if (t === void 0) return new Uint8Array(e);
    if (t.length !== e) throw new Error("invalid output length, expected " + e + ", got: " + t.length);
    if (n && !$a5d33cfc7f8e5437$var$ds(t)) throw new Error("invalid output, must be aligned");
    return t;
}
function $a5d33cfc7f8e5437$var$kn(e, t, n, r) {
    if (typeof e.setBigUint64 == "function") return e.setBigUint64(t, n, r);
    const o = BigInt(32), s = BigInt(4294967295), i = Number(n >> o & s), c = Number(n & s), u = r ? 4 : 0, a = r ? 0 : 4;
    e.setUint32(t + u, i, r), e.setUint32(t + a, c, r);
}
function $a5d33cfc7f8e5437$var$ds(e) {
    return e.byteOffset % 4 === 0;
}
function $a5d33cfc7f8e5437$var$gt(e) {
    return Uint8Array.from(e);
}
function $a5d33cfc7f8e5437$var$Ee(...e) {
    for(let t = 0; t < e.length; t++)e[t].fill(0);
}
const $a5d33cfc7f8e5437$var$Dn = (e)=>Uint8Array.from(e.split("").map((t)=>t.charCodeAt(0))), $a5d33cfc7f8e5437$var$hs = $a5d33cfc7f8e5437$var$Dn("expand 16-byte k"), $a5d33cfc7f8e5437$var$ps = $a5d33cfc7f8e5437$var$Dn("expand 32-byte k"), $a5d33cfc7f8e5437$var$gs = $a5d33cfc7f8e5437$var$se($a5d33cfc7f8e5437$var$hs), $a5d33cfc7f8e5437$var$ys = $a5d33cfc7f8e5437$var$se($a5d33cfc7f8e5437$var$ps);
function $a5d33cfc7f8e5437$var$x(e, t) {
    return e << t | e >>> 32 - t;
}
function $a5d33cfc7f8e5437$var$yt(e) {
    return e.byteOffset % 4 === 0;
}
const $a5d33cfc7f8e5437$var$Ve = 64, $a5d33cfc7f8e5437$var$ms = 16, $a5d33cfc7f8e5437$var$Mn = 2 ** 32 - 1, $a5d33cfc7f8e5437$var$Vn = new Uint32Array;
function $a5d33cfc7f8e5437$var$bs(e, t, n, r, o, s, i, c) {
    const u = o.length, a = new Uint8Array($a5d33cfc7f8e5437$var$Ve), l = $a5d33cfc7f8e5437$var$se(a), f = $a5d33cfc7f8e5437$var$yt(o) && $a5d33cfc7f8e5437$var$yt(s), d = f ? $a5d33cfc7f8e5437$var$se(o) : $a5d33cfc7f8e5437$var$Vn, g = f ? $a5d33cfc7f8e5437$var$se(s) : $a5d33cfc7f8e5437$var$Vn;
    for(let y = 0; y < u; i++){
        if (e(t, n, r, l, i, c), i >= $a5d33cfc7f8e5437$var$Mn) throw new Error("arx: counter overflow");
        const h = Math.min($a5d33cfc7f8e5437$var$Ve, u - y);
        if (f && h === $a5d33cfc7f8e5437$var$Ve) {
            const m = y / 4;
            if (y % 4 !== 0) throw new Error("arx: invalid block position");
            for(let B = 0, b; B < $a5d33cfc7f8e5437$var$ms; B++)b = m + B, g[b] = d[b] ^ l[B];
            y += $a5d33cfc7f8e5437$var$Ve;
            continue;
        }
        for(let m = 0, B; m < h; m++)B = y + m, s[B] = o[B] ^ a[m];
        y += h;
    }
}
function $a5d33cfc7f8e5437$var$ws(e, t) {
    const { allowShortKeys: n, extendNonceFn: r, counterLength: o, counterRight: s, rounds: i } = $a5d33cfc7f8e5437$var$us({
        allowShortKeys: !1,
        counterLength: 8,
        counterRight: !1,
        rounds: 20
    }, t);
    if (typeof e != "function") throw new Error("core must be a function");
    return $a5d33cfc7f8e5437$var$ht(o), $a5d33cfc7f8e5437$var$ht(i), $a5d33cfc7f8e5437$var$jn(s), $a5d33cfc7f8e5437$var$jn(n), (c, u, a, l, f = 0)=>{
        $a5d33cfc7f8e5437$var$F(c), $a5d33cfc7f8e5437$var$F(u), $a5d33cfc7f8e5437$var$F(a);
        const d = a.length;
        if (l === void 0 && (l = new Uint8Array(d)), $a5d33cfc7f8e5437$var$F(l), $a5d33cfc7f8e5437$var$ht(f), f < 0 || f >= $a5d33cfc7f8e5437$var$Mn) throw new Error("arx: counter overflow");
        if (l.length < d) throw new Error(`arx: output (${l.length}) is shorter than data (${d})`);
        const g = [];
        let y = c.length, h, m;
        if (y === 32) g.push(h = $a5d33cfc7f8e5437$var$gt(c)), m = $a5d33cfc7f8e5437$var$ys;
        else if (y === 16 && n) h = new Uint8Array(32), h.set(c), h.set(c, 16), m = $a5d33cfc7f8e5437$var$gs, g.push(h);
        else throw new Error(`arx: invalid 32-byte key, got length=${y}`);
        $a5d33cfc7f8e5437$var$yt(u) || g.push(u = $a5d33cfc7f8e5437$var$gt(u));
        const B = $a5d33cfc7f8e5437$var$se(h);
        if (r) {
            if (u.length !== 24) throw new Error("arx: extended nonce must be 24 bytes");
            r(m, B, $a5d33cfc7f8e5437$var$se(u.subarray(0, 16)), B), u = u.subarray(16);
        }
        const b = 16 - o;
        if (b !== u.length) throw new Error(`arx: nonce must be ${b} or 16 bytes`);
        if (b !== 12) {
            const I = new Uint8Array(12);
            I.set(u, s ? 0 : 12 - u.length), u = I, g.push(u);
        }
        const _ = $a5d33cfc7f8e5437$var$se(u);
        return $a5d33cfc7f8e5437$var$bs(e, m, B, _, a, l, f, i), $a5d33cfc7f8e5437$var$Ee(...g), l;
    };
}
const $a5d33cfc7f8e5437$var$M = (e, t)=>e[t++] & 255 | (e[t++] & 255) << 8;
class $a5d33cfc7f8e5437$var$Es {
    constructor(t){
        this.blockLen = 16, this.outputLen = 16, this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.pos = 0, this.finished = !1, t = $a5d33cfc7f8e5437$var$pt(t), $a5d33cfc7f8e5437$var$F(t, 32);
        const n = $a5d33cfc7f8e5437$var$M(t, 0), r = $a5d33cfc7f8e5437$var$M(t, 2), o = $a5d33cfc7f8e5437$var$M(t, 4), s = $a5d33cfc7f8e5437$var$M(t, 6), i = $a5d33cfc7f8e5437$var$M(t, 8), c = $a5d33cfc7f8e5437$var$M(t, 10), u = $a5d33cfc7f8e5437$var$M(t, 12), a = $a5d33cfc7f8e5437$var$M(t, 14);
        this.r[0] = n & 8191, this.r[1] = (n >>> 13 | r << 3) & 8191, this.r[2] = (r >>> 10 | o << 6) & 7939, this.r[3] = (o >>> 7 | s << 9) & 8191, this.r[4] = (s >>> 4 | i << 12) & 255, this.r[5] = i >>> 1 & 8190, this.r[6] = (i >>> 14 | c << 2) & 8191, this.r[7] = (c >>> 11 | u << 5) & 8065, this.r[8] = (u >>> 8 | a << 8) & 8191, this.r[9] = a >>> 5 & 127;
        for(let l = 0; l < 8; l++)this.pad[l] = $a5d33cfc7f8e5437$var$M(t, 16 + 2 * l);
    }
    process(t, n, r = !1) {
        const o = r ? 0 : 2048, { h: s, r: i } = this, c = i[0], u = i[1], a = i[2], l = i[3], f = i[4], d = i[5], g = i[6], y = i[7], h = i[8], m = i[9], B = $a5d33cfc7f8e5437$var$M(t, n + 0), b = $a5d33cfc7f8e5437$var$M(t, n + 2), _ = $a5d33cfc7f8e5437$var$M(t, n + 4), I = $a5d33cfc7f8e5437$var$M(t, n + 6), k = $a5d33cfc7f8e5437$var$M(t, n + 8), E = $a5d33cfc7f8e5437$var$M(t, n + 10), L = $a5d33cfc7f8e5437$var$M(t, n + 12), j = $a5d33cfc7f8e5437$var$M(t, n + 14);
        let v = s[0] + (B & 8191), O = s[1] + ((B >>> 13 | b << 3) & 8191), w = s[2] + ((b >>> 10 | _ << 6) & 8191), R = s[3] + ((_ >>> 7 | I << 9) & 8191), A = s[4] + ((I >>> 4 | k << 12) & 8191), T = s[5] + (k >>> 1 & 8191), N = s[6] + ((k >>> 14 | E << 2) & 8191), S = s[7] + ((E >>> 11 | L << 5) & 8191), U = s[8] + ((L >>> 8 | j << 8) & 8191), $ = s[9] + (j >>> 5 | o), p = 0, C = p + v * c + O * (5 * m) + w * (5 * h) + R * (5 * y) + A * (5 * g);
        p = C >>> 13, C &= 8191, C += T * (5 * d) + N * (5 * f) + S * (5 * l) + U * (5 * a) + $ * (5 * u), p += C >>> 13, C &= 8191;
        let D = p + v * u + O * c + w * (5 * m) + R * (5 * h) + A * (5 * y);
        p = D >>> 13, D &= 8191, D += T * (5 * g) + N * (5 * d) + S * (5 * f) + U * (5 * l) + $ * (5 * a), p += D >>> 13, D &= 8191;
        let P = p + v * a + O * u + w * c + R * (5 * m) + A * (5 * h);
        p = P >>> 13, P &= 8191, P += T * (5 * y) + N * (5 * g) + S * (5 * d) + U * (5 * f) + $ * (5 * l), p += P >>> 13, P &= 8191;
        let G = p + v * l + O * a + w * u + R * c + A * (5 * m);
        p = G >>> 13, G &= 8191, G += T * (5 * h) + N * (5 * y) + S * (5 * g) + U * (5 * d) + $ * (5 * f), p += G >>> 13, G &= 8191;
        let X = p + v * f + O * l + w * a + R * u + A * c;
        p = X >>> 13, X &= 8191, X += T * (5 * m) + N * (5 * h) + S * (5 * y) + U * (5 * g) + $ * (5 * d), p += X >>> 13, X &= 8191;
        let Z = p + v * d + O * f + w * l + R * a + A * u;
        p = Z >>> 13, Z &= 8191, Z += T * c + N * (5 * m) + S * (5 * h) + U * (5 * y) + $ * (5 * g), p += Z >>> 13, Z &= 8191;
        let he = p + v * g + O * d + w * f + R * l + A * a;
        p = he >>> 13, he &= 8191, he += T * u + N * c + S * (5 * m) + U * (5 * h) + $ * (5 * y), p += he >>> 13, he &= 8191;
        let pe = p + v * y + O * g + w * d + R * f + A * l;
        p = pe >>> 13, pe &= 8191, pe += T * a + N * u + S * c + U * (5 * m) + $ * (5 * h), p += pe >>> 13, pe &= 8191;
        let ge = p + v * h + O * y + w * g + R * d + A * f;
        p = ge >>> 13, ge &= 8191, ge += T * l + N * a + S * u + U * c + $ * (5 * m), p += ge >>> 13, ge &= 8191;
        let ye = p + v * m + O * h + w * y + R * g + A * d;
        p = ye >>> 13, ye &= 8191, ye += T * f + N * l + S * a + U * u + $ * c, p += ye >>> 13, ye &= 8191, p = (p << 2) + p | 0, p = p + C | 0, C = p & 8191, p = p >>> 13, D += p, s[0] = C, s[1] = D, s[2] = P, s[3] = G, s[4] = X, s[5] = Z, s[6] = he, s[7] = pe, s[8] = ge, s[9] = ye;
    }
    finalize() {
        const { h: t, pad: n } = this, r = new Uint16Array(10);
        let o = t[1] >>> 13;
        t[1] &= 8191;
        for(let c = 2; c < 10; c++)t[c] += o, o = t[c] >>> 13, t[c] &= 8191;
        t[0] += o * 5, o = t[0] >>> 13, t[0] &= 8191, t[1] += o, o = t[1] >>> 13, t[1] &= 8191, t[2] += o, r[0] = t[0] + 5, o = r[0] >>> 13, r[0] &= 8191;
        for(let c = 1; c < 10; c++)r[c] = t[c] + o, o = r[c] >>> 13, r[c] &= 8191;
        r[9] -= 8192;
        let s = (o ^ 1) - 1;
        for(let c = 0; c < 10; c++)r[c] &= s;
        s = ~s;
        for(let c = 0; c < 10; c++)t[c] = t[c] & s | r[c];
        t[0] = (t[0] | t[1] << 13) & 65535, t[1] = (t[1] >>> 3 | t[2] << 10) & 65535, t[2] = (t[2] >>> 6 | t[3] << 7) & 65535, t[3] = (t[3] >>> 9 | t[4] << 4) & 65535, t[4] = (t[4] >>> 12 | t[5] << 1 | t[6] << 14) & 65535, t[5] = (t[6] >>> 2 | t[7] << 11) & 65535, t[6] = (t[7] >>> 5 | t[8] << 8) & 65535, t[7] = (t[8] >>> 8 | t[9] << 5) & 65535;
        let i = t[0] + n[0];
        t[0] = i & 65535;
        for(let c = 1; c < 8; c++)i = (t[c] + n[c] | 0) + (i >>> 16) | 0, t[c] = i & 65535;
        $a5d33cfc7f8e5437$var$Ee(r);
    }
    update(t) {
        $a5d33cfc7f8e5437$var$Bn(this);
        const { buffer: n, blockLen: r } = this;
        t = $a5d33cfc7f8e5437$var$pt(t);
        const o = t.length;
        for(let s = 0; s < o;){
            const i = Math.min(r - this.pos, o - s);
            if (i === r) {
                for(; r <= o - s; s += r)this.process(t, s);
                continue;
            }
            n.set(t.subarray(s, s + i), this.pos), this.pos += i, s += i, this.pos === r && (this.process(n, 0, !1), this.pos = 0);
        }
        return this;
    }
    destroy() {
        $a5d33cfc7f8e5437$var$Ee(this.h, this.r, this.buffer, this.pad);
    }
    digestInto(t) {
        $a5d33cfc7f8e5437$var$Bn(this), $a5d33cfc7f8e5437$var$ss(t, this), this.finished = !0;
        const { buffer: n, h: r } = this;
        let { pos: o } = this;
        if (o) {
            for(n[o++] = 1; o < 16; o++)n[o] = 0;
            this.process(n, 0, !0);
        }
        this.finalize();
        let s = 0;
        for(let i = 0; i < 8; i++)t[s++] = r[i] >>> 0, t[s++] = r[i] >>> 8;
        return t;
    }
    digest() {
        const { buffer: t, outputLen: n } = this;
        this.digestInto(t);
        const r = t.slice(0, n);
        return this.destroy(), r;
    }
}
function $a5d33cfc7f8e5437$var$vs(e) {
    const t = (r, o)=>e(o).update($a5d33cfc7f8e5437$var$pt(r)).digest(), n = e(new Uint8Array(32));
    return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = (r)=>e(r), t;
}
const $a5d33cfc7f8e5437$var$xs = $a5d33cfc7f8e5437$var$vs((e)=>new $a5d33cfc7f8e5437$var$Es(e));
function $a5d33cfc7f8e5437$var$Os(e, t, n, r, o, s = 20) {
    let i = e[0], c = e[1], u = e[2], a = e[3], l = t[0], f = t[1], d = t[2], g = t[3], y = t[4], h = t[5], m = t[6], B = t[7], b = o, _ = n[0], I = n[1], k = n[2], E = i, L = c, j = u, v = a, O = l, w = f, R = d, A = g, T = y, N = h, S = m, U = B, $ = b, p = _, C = I, D = k;
    for(let G = 0; G < s; G += 2)E = E + O | 0, $ = $a5d33cfc7f8e5437$var$x($ ^ E, 16), T = T + $ | 0, O = $a5d33cfc7f8e5437$var$x(O ^ T, 12), E = E + O | 0, $ = $a5d33cfc7f8e5437$var$x($ ^ E, 8), T = T + $ | 0, O = $a5d33cfc7f8e5437$var$x(O ^ T, 7), L = L + w | 0, p = $a5d33cfc7f8e5437$var$x(p ^ L, 16), N = N + p | 0, w = $a5d33cfc7f8e5437$var$x(w ^ N, 12), L = L + w | 0, p = $a5d33cfc7f8e5437$var$x(p ^ L, 8), N = N + p | 0, w = $a5d33cfc7f8e5437$var$x(w ^ N, 7), j = j + R | 0, C = $a5d33cfc7f8e5437$var$x(C ^ j, 16), S = S + C | 0, R = $a5d33cfc7f8e5437$var$x(R ^ S, 12), j = j + R | 0, C = $a5d33cfc7f8e5437$var$x(C ^ j, 8), S = S + C | 0, R = $a5d33cfc7f8e5437$var$x(R ^ S, 7), v = v + A | 0, D = $a5d33cfc7f8e5437$var$x(D ^ v, 16), U = U + D | 0, A = $a5d33cfc7f8e5437$var$x(A ^ U, 12), v = v + A | 0, D = $a5d33cfc7f8e5437$var$x(D ^ v, 8), U = U + D | 0, A = $a5d33cfc7f8e5437$var$x(A ^ U, 7), E = E + w | 0, D = $a5d33cfc7f8e5437$var$x(D ^ E, 16), S = S + D | 0, w = $a5d33cfc7f8e5437$var$x(w ^ S, 12), E = E + w | 0, D = $a5d33cfc7f8e5437$var$x(D ^ E, 8), S = S + D | 0, w = $a5d33cfc7f8e5437$var$x(w ^ S, 7), L = L + R | 0, $ = $a5d33cfc7f8e5437$var$x($ ^ L, 16), U = U + $ | 0, R = $a5d33cfc7f8e5437$var$x(R ^ U, 12), L = L + R | 0, $ = $a5d33cfc7f8e5437$var$x($ ^ L, 8), U = U + $ | 0, R = $a5d33cfc7f8e5437$var$x(R ^ U, 7), j = j + A | 0, p = $a5d33cfc7f8e5437$var$x(p ^ j, 16), T = T + p | 0, A = $a5d33cfc7f8e5437$var$x(A ^ T, 12), j = j + A | 0, p = $a5d33cfc7f8e5437$var$x(p ^ j, 8), T = T + p | 0, A = $a5d33cfc7f8e5437$var$x(A ^ T, 7), v = v + O | 0, C = $a5d33cfc7f8e5437$var$x(C ^ v, 16), N = N + C | 0, O = $a5d33cfc7f8e5437$var$x(O ^ N, 12), v = v + O | 0, C = $a5d33cfc7f8e5437$var$x(C ^ v, 8), N = N + C | 0, O = $a5d33cfc7f8e5437$var$x(O ^ N, 7);
    let P = 0;
    r[P++] = i + E | 0, r[P++] = c + L | 0, r[P++] = u + j | 0, r[P++] = a + v | 0, r[P++] = l + O | 0, r[P++] = f + w | 0, r[P++] = d + R | 0, r[P++] = g + A | 0, r[P++] = y + T | 0, r[P++] = h + N | 0, r[P++] = m + S | 0, r[P++] = B + U | 0, r[P++] = b + $ | 0, r[P++] = _ + p | 0, r[P++] = I + C | 0, r[P++] = k + D | 0;
}
const $a5d33cfc7f8e5437$var$Is = $a5d33cfc7f8e5437$var$ws($a5d33cfc7f8e5437$var$Os, {
    counterRight: !1,
    counterLength: 4,
    allowShortKeys: !1
}), $a5d33cfc7f8e5437$var$As = new Uint8Array(16), $a5d33cfc7f8e5437$var$Hn = (e, t)=>{
    e.update(t);
    const n = t.length % 16;
    n && e.update($a5d33cfc7f8e5437$var$As.subarray(n));
}, $a5d33cfc7f8e5437$var$Ns = new Uint8Array(32);
function $a5d33cfc7f8e5437$var$Kn(e, t, n, r, o) {
    const s = e(t, n, $a5d33cfc7f8e5437$var$Ns), i = $a5d33cfc7f8e5437$var$xs.create(s);
    o && $a5d33cfc7f8e5437$var$Hn(i, o), $a5d33cfc7f8e5437$var$Hn(i, r);
    const c = new Uint8Array(16), u = $a5d33cfc7f8e5437$var$is(c);
    $a5d33cfc7f8e5437$var$kn(u, 0, BigInt(o ? o.length : 0), !0), $a5d33cfc7f8e5437$var$kn(u, 8, BigInt(r.length), !0), i.update(c);
    const a = i.digest();
    return $a5d33cfc7f8e5437$var$Ee(s, c), a;
}
const $a5d33cfc7f8e5437$var$Ss = (e)=>(t, n, r)=>({
            encrypt (s, i) {
                const c = s.length;
                i = $a5d33cfc7f8e5437$var$Cn(c + 16, i, !1), i.set(s);
                const u = i.subarray(0, -16);
                e(t, n, u, u, 1);
                const a = $a5d33cfc7f8e5437$var$Kn(e, t, n, u, r);
                return i.set(a, c), $a5d33cfc7f8e5437$var$Ee(a), i;
            },
            decrypt (s, i) {
                i = $a5d33cfc7f8e5437$var$Cn(s.length - 16, i, !1);
                const c = s.subarray(0, -16), u = s.subarray(-16), a = $a5d33cfc7f8e5437$var$Kn(e, t, n, c, r);
                if (!$a5d33cfc7f8e5437$var$fs(u, a)) throw new Error("invalid tag");
                return i.set(s.subarray(0, -16)), e(t, n, i, i, 1), $a5d33cfc7f8e5437$var$Ee(a), i;
            }
        }), $a5d33cfc7f8e5437$var$Fn = $a5d33cfc7f8e5437$var$ls({
    blockSize: 64,
    nonceLength: 12,
    tagLength: 16
}, $a5d33cfc7f8e5437$var$Ss($a5d33cfc7f8e5437$var$Is));
class $a5d33cfc7f8e5437$var$qn extends $a5d33cfc7f8e5437$var$it {
    constructor(t, n){
        super(), this.finished = !1, this.destroyed = !1, $a5d33cfc7f8e5437$var$ot(t);
        const r = $a5d33cfc7f8e5437$var$we(n);
        if (this.iHash = t.create(), typeof this.iHash.update != "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
        const o = this.blockLen, s = new Uint8Array(o);
        s.set(r.length > o ? t.create().update(r).digest() : r);
        for(let i = 0; i < s.length; i++)s[i] ^= 54;
        this.iHash.update(s), this.oHash = t.create();
        for(let i = 0; i < s.length; i++)s[i] ^= 106;
        this.oHash.update(s), s.fill(0);
    }
    update(t) {
        return $a5d33cfc7f8e5437$var$me(this), this.iHash.update(t), this;
    }
    digestInto(t) {
        $a5d33cfc7f8e5437$var$me(this), $a5d33cfc7f8e5437$var$je(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
    }
    digest() {
        const t = new Uint8Array(this.oHash.outputLen);
        return this.digestInto(t), t;
    }
    _cloneInto(t) {
        t || (t = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: n, iHash: r, finished: o, destroyed: s, blockLen: i, outputLen: c } = this;
        return t, t.finished = o, t.destroyed = s, t.blockLen = i, t.outputLen = c, t.oHash = n._cloneInto(t.oHash), t.iHash = r._cloneInto(t.iHash), t;
    }
    destroy() {
        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
}
const $a5d33cfc7f8e5437$var$mt = (e, t, n)=>new $a5d33cfc7f8e5437$var$qn(e, t).update(n).digest();
$a5d33cfc7f8e5437$var$mt.create = (e, t)=>new $a5d33cfc7f8e5437$var$qn(e, t);
function $a5d33cfc7f8e5437$var$Us(e, t, n) {
    return $a5d33cfc7f8e5437$var$ot(e), n === void 0 && (n = new Uint8Array(e.outputLen)), $a5d33cfc7f8e5437$var$mt(e, $a5d33cfc7f8e5437$var$we(n), $a5d33cfc7f8e5437$var$we(t));
}
const $a5d33cfc7f8e5437$var$bt = new Uint8Array([
    0
]), $a5d33cfc7f8e5437$var$Gn = new Uint8Array;
function $a5d33cfc7f8e5437$var$_s(e, t, n, r = 32) {
    if ($a5d33cfc7f8e5437$var$ot(e), $a5d33cfc7f8e5437$var$Ne(r), r > 255 * e.outputLen) throw new Error("Length should be <= 255*HashLen");
    const o = Math.ceil(r / e.outputLen);
    n === void 0 && (n = $a5d33cfc7f8e5437$var$Gn);
    const s = new Uint8Array(o * e.outputLen), i = $a5d33cfc7f8e5437$var$mt.create(e, t), c = i._cloneInto(), u = new Uint8Array(i.outputLen);
    for(let a = 0; a < o; a++)$a5d33cfc7f8e5437$var$bt[0] = a + 1, c.update(a === 0 ? $a5d33cfc7f8e5437$var$Gn : u).update(n).update($a5d33cfc7f8e5437$var$bt).digestInto(u), s.set(u, e.outputLen * a), i._cloneInto(c);
    return i.destroy(), c.destroy(), u.fill(0), $a5d33cfc7f8e5437$var$bt.fill(0), s.slice(0, r);
}
const $a5d33cfc7f8e5437$var$Ts = (e, t, n, r, o)=>$a5d33cfc7f8e5437$var$_s(e, $a5d33cfc7f8e5437$var$Us(e, t, n), r, o);
function $a5d33cfc7f8e5437$var$$s(e, t, n, r) {
    if (typeof e.setBigUint64 == "function") return e.setBigUint64(t, n, r);
    const o = BigInt(32), s = BigInt(4294967295), i = Number(n >> o & s), c = Number(n & s), u = r ? 4 : 0, a = r ? 0 : 4;
    e.setUint32(t + u, i, r), e.setUint32(t + a, c, r);
}
function $a5d33cfc7f8e5437$var$Rs(e, t, n) {
    return e & t ^ ~e & n;
}
function $a5d33cfc7f8e5437$var$Ps(e, t, n) {
    return e & t ^ e & n ^ t & n;
}
class $a5d33cfc7f8e5437$var$Ls extends $a5d33cfc7f8e5437$var$it {
    constructor(t, n, r, o){
        super(), this.blockLen = t, this.outputLen = n, this.padOffset = r, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = $a5d33cfc7f8e5437$var$st(this.buffer);
    }
    update(t) {
        $a5d33cfc7f8e5437$var$me(this);
        const { view: n, buffer: r, blockLen: o } = this;
        t = $a5d33cfc7f8e5437$var$we(t);
        const s = t.length;
        for(let i = 0; i < s;){
            const c = Math.min(o - this.pos, s - i);
            if (c === o) {
                const u = $a5d33cfc7f8e5437$var$st(t);
                for(; o <= s - i; i += o)this.process(u, i);
                continue;
            }
            r.set(t.subarray(i, i + c), this.pos), this.pos += c, i += c, this.pos === o && (this.process(n, 0), this.pos = 0);
        }
        return this.length += t.length, this.roundClean(), this;
    }
    digestInto(t) {
        $a5d33cfc7f8e5437$var$me(this), $a5d33cfc7f8e5437$var$sn(t, this), this.finished = !0;
        const { buffer: n, view: r, blockLen: o, isLE: s } = this;
        let { pos: i } = this;
        n[i++] = 128, this.buffer.subarray(i).fill(0), this.padOffset > o - i && (this.process(r, 0), i = 0);
        for(let f = i; f < o; f++)n[f] = 0;
        $a5d33cfc7f8e5437$var$$s(r, o - 8, BigInt(this.length * 8), s), this.process(r, 0);
        const c = $a5d33cfc7f8e5437$var$st(t), u = this.outputLen;
        if (u % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const a = u / 4, l = this.get();
        if (a > l.length) throw new Error("_sha2: outputLen bigger than state");
        for(let f = 0; f < a; f++)c.setUint32(4 * f, l[f], s);
    }
    digest() {
        const { buffer: t, outputLen: n } = this;
        this.digestInto(t);
        const r = t.slice(0, n);
        return this.destroy(), r;
    }
    _cloneInto(t) {
        t || (t = new this.constructor), t.set(...this.get());
        const { blockLen: n, buffer: r, length: o, finished: s, destroyed: i, pos: c } = this;
        return t.length = o, t.pos = c, t.finished = s, t.destroyed = i, o % n && t.buffer.set(r), t;
    }
}
const $a5d33cfc7f8e5437$var$Bs = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
]), $a5d33cfc7f8e5437$var$ie = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
]), $a5d33cfc7f8e5437$var$ce = new Uint32Array(64);
class $a5d33cfc7f8e5437$var$js extends $a5d33cfc7f8e5437$var$Ls {
    constructor(){
        super(64, 32, 8, !1), this.A = $a5d33cfc7f8e5437$var$ie[0] | 0, this.B = $a5d33cfc7f8e5437$var$ie[1] | 0, this.C = $a5d33cfc7f8e5437$var$ie[2] | 0, this.D = $a5d33cfc7f8e5437$var$ie[3] | 0, this.E = $a5d33cfc7f8e5437$var$ie[4] | 0, this.F = $a5d33cfc7f8e5437$var$ie[5] | 0, this.G = $a5d33cfc7f8e5437$var$ie[6] | 0, this.H = $a5d33cfc7f8e5437$var$ie[7] | 0;
    }
    get() {
        const { A: t, B: n, C: r, D: o, E: s, F: i, G: c, H: u } = this;
        return [
            t,
            n,
            r,
            o,
            s,
            i,
            c,
            u
        ];
    }
    set(t, n, r, o, s, i, c, u) {
        this.A = t | 0, this.B = n | 0, this.C = r | 0, this.D = o | 0, this.E = s | 0, this.F = i | 0, this.G = c | 0, this.H = u | 0;
    }
    process(t, n) {
        for(let f = 0; f < 16; f++, n += 4)$a5d33cfc7f8e5437$var$ce[f] = t.getUint32(n, !1);
        for(let f = 16; f < 64; f++){
            const d = $a5d33cfc7f8e5437$var$ce[f - 15], g = $a5d33cfc7f8e5437$var$ce[f - 2], y = $a5d33cfc7f8e5437$var$J(d, 7) ^ $a5d33cfc7f8e5437$var$J(d, 18) ^ d >>> 3, h = $a5d33cfc7f8e5437$var$J(g, 17) ^ $a5d33cfc7f8e5437$var$J(g, 19) ^ g >>> 10;
            $a5d33cfc7f8e5437$var$ce[f] = h + $a5d33cfc7f8e5437$var$ce[f - 7] + y + $a5d33cfc7f8e5437$var$ce[f - 16] | 0;
        }
        let { A: r, B: o, C: s, D: i, E: c, F: u, G: a, H: l } = this;
        for(let f = 0; f < 64; f++){
            const d = $a5d33cfc7f8e5437$var$J(c, 6) ^ $a5d33cfc7f8e5437$var$J(c, 11) ^ $a5d33cfc7f8e5437$var$J(c, 25), g = l + d + $a5d33cfc7f8e5437$var$Rs(c, u, a) + $a5d33cfc7f8e5437$var$Bs[f] + $a5d33cfc7f8e5437$var$ce[f] | 0, h = ($a5d33cfc7f8e5437$var$J(r, 2) ^ $a5d33cfc7f8e5437$var$J(r, 13) ^ $a5d33cfc7f8e5437$var$J(r, 22)) + $a5d33cfc7f8e5437$var$Ps(r, o, s) | 0;
            l = a, a = u, u = c, c = i + g | 0, i = s, s = o, o = r, r = g + h | 0;
        }
        r = r + this.A | 0, o = o + this.B | 0, s = s + this.C | 0, i = i + this.D | 0, c = c + this.E | 0, u = u + this.F | 0, a = a + this.G | 0, l = l + this.H | 0, this.set(r, o, s, i, c, u, a, l);
    }
    roundClean() {
        $a5d33cfc7f8e5437$var$ce.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
}
const $a5d33cfc7f8e5437$var$He = $a5d33cfc7f8e5437$var$fn(()=>new $a5d33cfc7f8e5437$var$js); /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $a5d33cfc7f8e5437$var$Wn = BigInt(0);
function $a5d33cfc7f8e5437$var$wt(e) {
    return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function $a5d33cfc7f8e5437$var$zn(e) {
    if (!$a5d33cfc7f8e5437$var$wt(e)) throw new Error("Uint8Array expected");
}
const $a5d33cfc7f8e5437$var$Cs = Array.from({
    length: 256
}, (e, t)=>t.toString(16).padStart(2, "0"));
function $a5d33cfc7f8e5437$var$ks(e) {
    $a5d33cfc7f8e5437$var$zn(e);
    let t = "";
    for(let n = 0; n < e.length; n++)t += $a5d33cfc7f8e5437$var$Cs[e[n]];
    return t;
}
function $a5d33cfc7f8e5437$var$Ds(e) {
    if (typeof e != "string") throw new Error("hex string expected, got " + typeof e);
    return e === "" ? $a5d33cfc7f8e5437$var$Wn : BigInt("0x" + e);
}
const $a5d33cfc7f8e5437$var$ee = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $a5d33cfc7f8e5437$var$Jn(e) {
    if (e >= $a5d33cfc7f8e5437$var$ee._0 && e <= $a5d33cfc7f8e5437$var$ee._9) return e - $a5d33cfc7f8e5437$var$ee._0;
    if (e >= $a5d33cfc7f8e5437$var$ee.A && e <= $a5d33cfc7f8e5437$var$ee.F) return e - ($a5d33cfc7f8e5437$var$ee.A - 10);
    if (e >= $a5d33cfc7f8e5437$var$ee.a && e <= $a5d33cfc7f8e5437$var$ee.f) return e - ($a5d33cfc7f8e5437$var$ee.a - 10);
}
function $a5d33cfc7f8e5437$var$Yn(e) {
    if (typeof e != "string") throw new Error("hex string expected, got " + typeof e);
    const t = e.length, n = t / 2;
    if (t % 2) throw new Error("hex string expected, got unpadded hex of length " + t);
    const r = new Uint8Array(n);
    for(let o = 0, s = 0; o < n; o++, s += 2){
        const i = $a5d33cfc7f8e5437$var$Jn(e.charCodeAt(s)), c = $a5d33cfc7f8e5437$var$Jn(e.charCodeAt(s + 1));
        if (i === void 0 || c === void 0) {
            const u = e[s] + e[s + 1];
            throw new Error('hex string expected, got non-hex character "' + u + '" at index ' + s);
        }
        r[o] = i * 16 + c;
    }
    return r;
}
function $a5d33cfc7f8e5437$var$Xn(e) {
    return $a5d33cfc7f8e5437$var$zn(e), $a5d33cfc7f8e5437$var$Ds($a5d33cfc7f8e5437$var$ks(Uint8Array.from(e).reverse()));
}
function $a5d33cfc7f8e5437$var$Ms(e, t) {
    return $a5d33cfc7f8e5437$var$Yn(e.toString(16).padStart(t * 2, "0"));
}
function $a5d33cfc7f8e5437$var$Vs(e, t) {
    return $a5d33cfc7f8e5437$var$Ms(e, t).reverse();
}
function $a5d33cfc7f8e5437$var$Zn(e, t, n) {
    let r;
    if (typeof t == "string") try {
        r = $a5d33cfc7f8e5437$var$Yn(t);
    } catch (s) {
        throw new Error(e + " must be hex string or Uint8Array, cause: " + s);
    }
    else if ($a5d33cfc7f8e5437$var$wt(t)) r = Uint8Array.from(t);
    else throw new Error(e + " must be hex string or Uint8Array");
    const o = r.length;
    if (typeof n == "number" && o !== n) throw new Error(e + " of length " + n + " expected, got " + o);
    return r;
}
const $a5d33cfc7f8e5437$var$Et = (e)=>typeof e == "bigint" && $a5d33cfc7f8e5437$var$Wn <= e;
function $a5d33cfc7f8e5437$var$Hs(e, t, n) {
    return $a5d33cfc7f8e5437$var$Et(e) && $a5d33cfc7f8e5437$var$Et(t) && $a5d33cfc7f8e5437$var$Et(n) && t <= e && e < n;
}
function $a5d33cfc7f8e5437$var$Qn(e, t, n, r) {
    if (!$a5d33cfc7f8e5437$var$Hs(t, n, r)) throw new Error("expected valid " + e + ": " + n + " <= n < " + r + ", got " + t);
}
const $a5d33cfc7f8e5437$var$Ks = {
    bigint: (e)=>typeof e == "bigint",
    function: (e)=>typeof e == "function",
    boolean: (e)=>typeof e == "boolean",
    string: (e)=>typeof e == "string",
    stringOrUint8Array: (e)=>typeof e == "string" || $a5d33cfc7f8e5437$var$wt(e),
    isSafeInteger: (e)=>Number.isSafeInteger(e),
    array: (e)=>Array.isArray(e),
    field: (e, t)=>t.Fp.isValid(e),
    hash: (e)=>typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function $a5d33cfc7f8e5437$var$Fs(e, t, n = {}) {
    const r = (o, s, i)=>{
        const c = $a5d33cfc7f8e5437$var$Ks[s];
        if (typeof c != "function") throw new Error("invalid validator function");
        const u = e[o];
        if (!(i && u === void 0) && !c(u, e)) throw new Error("param " + String(o) + " is invalid. Expected " + s + ", got " + u);
    };
    for (const [o, s] of Object.entries(t))r(o, s, !1);
    for (const [o, s] of Object.entries(n))r(o, s, !0);
    return e;
}
const $a5d33cfc7f8e5437$var$ve = BigInt(0), $a5d33cfc7f8e5437$var$Ke = BigInt(1);
function $a5d33cfc7f8e5437$var$er(e, t) {
    const n = e % t;
    return n >= $a5d33cfc7f8e5437$var$ve ? n : t + n;
}
function $a5d33cfc7f8e5437$var$qs(e, t, n) {
    if (t < $a5d33cfc7f8e5437$var$ve) throw new Error("invalid exponent, negatives unsupported");
    if (n <= $a5d33cfc7f8e5437$var$ve) throw new Error("invalid modulus");
    if (n === $a5d33cfc7f8e5437$var$Ke) return $a5d33cfc7f8e5437$var$ve;
    let r = $a5d33cfc7f8e5437$var$Ke;
    for(; t > $a5d33cfc7f8e5437$var$ve;)t & $a5d33cfc7f8e5437$var$Ke && (r = r * e % n), e = e * e % n, t >>= $a5d33cfc7f8e5437$var$Ke;
    return r;
}
function $a5d33cfc7f8e5437$var$z(e, t, n) {
    let r = e;
    for(; t-- > $a5d33cfc7f8e5437$var$ve;)r *= r, r %= n;
    return r;
}
BigInt(0), BigInt(1), BigInt(0), BigInt(1), BigInt(2), BigInt(8);
const $a5d33cfc7f8e5437$var$xe = BigInt(0), $a5d33cfc7f8e5437$var$vt = BigInt(1);
function $a5d33cfc7f8e5437$var$Gs(e) {
    return $a5d33cfc7f8e5437$var$Fs(e, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    }), Object.freeze({
        ...e
    });
}
function $a5d33cfc7f8e5437$var$Ws(e) {
    const t = $a5d33cfc7f8e5437$var$Gs(e), { P: n } = t, r = (b)=>$a5d33cfc7f8e5437$var$er(b, n), o = t.montgomeryBits, s = Math.ceil(o / 8), i = t.nByteLength, c = t.adjustScalarBytes || ((b)=>b), u = t.powPminus2 || ((b)=>$a5d33cfc7f8e5437$var$qs(b, n - BigInt(2), n));
    function a(b, _, I) {
        const k = r(b * (_ - I));
        return _ = r(_ - k), I = r(I + k), [
            _,
            I
        ];
    }
    const l = (t.a - BigInt(2)) / BigInt(4);
    function f(b, _) {
        $a5d33cfc7f8e5437$var$Qn("u", b, $a5d33cfc7f8e5437$var$xe, n), $a5d33cfc7f8e5437$var$Qn("scalar", _, $a5d33cfc7f8e5437$var$xe, n);
        const I = _, k = b;
        let E = $a5d33cfc7f8e5437$var$vt, L = $a5d33cfc7f8e5437$var$xe, j = b, v = $a5d33cfc7f8e5437$var$vt, O = $a5d33cfc7f8e5437$var$xe, w;
        for(let A = BigInt(o - 1); A >= $a5d33cfc7f8e5437$var$xe; A--){
            const T = I >> A & $a5d33cfc7f8e5437$var$vt;
            O ^= T, w = a(O, E, j), E = w[0], j = w[1], w = a(O, L, v), L = w[0], v = w[1], O = T;
            const N = E + L, S = r(N * N), U = E - L, $ = r(U * U), p = S - $, C = j + v, D = j - v, P = r(D * N), G = r(C * U), X = P + G, Z = P - G;
            j = r(X * X), v = r(k * r(Z * Z)), E = r(S * $), L = r(p * (S + r(l * p)));
        }
        w = a(O, E, j), E = w[0], j = w[1], w = a(O, L, v), L = w[0], v = w[1];
        const R = u(L);
        return r(E * R);
    }
    function d(b) {
        return $a5d33cfc7f8e5437$var$Vs(r(b), s);
    }
    function g(b) {
        const _ = $a5d33cfc7f8e5437$var$Zn("u coordinate", b, s);
        return i === 32 && (_[31] &= 127), $a5d33cfc7f8e5437$var$Xn(_);
    }
    function y(b) {
        const _ = $a5d33cfc7f8e5437$var$Zn("scalar", b), I = _.length;
        if (I !== s && I !== i) {
            let k = "" + s + " or " + i;
            throw new Error("invalid scalar, expected " + k + " bytes, got " + I);
        }
        return $a5d33cfc7f8e5437$var$Xn(c(_));
    }
    function h(b, _) {
        const I = g(_), k = y(b), E = f(I, k);
        if (E === $a5d33cfc7f8e5437$var$xe) throw new Error("invalid private or public key received");
        return d(E);
    }
    const m = d(t.Gu);
    function B(b) {
        return h(b, m);
    }
    return {
        scalarMult: h,
        scalarMultBase: B,
        getSharedSecret: (b, _)=>h(b, _),
        getPublicKey: (b)=>B(b),
        utils: {
            randomPrivateKey: ()=>t.randomBytes(t.nByteLength)
        },
        GuBytes: m
    };
}
const $a5d33cfc7f8e5437$var$xt = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
BigInt(0);
const $a5d33cfc7f8e5437$var$zs = BigInt(1), $a5d33cfc7f8e5437$var$tr = BigInt(2), $a5d33cfc7f8e5437$var$Js = BigInt(3), $a5d33cfc7f8e5437$var$Ys = BigInt(5);
BigInt(8);
function $a5d33cfc7f8e5437$var$Xs(e) {
    const t = BigInt(10), n = BigInt(20), r = BigInt(40), o = BigInt(80), s = $a5d33cfc7f8e5437$var$xt, c = e * e % s * e % s, u = $a5d33cfc7f8e5437$var$z(c, $a5d33cfc7f8e5437$var$tr, s) * c % s, a = $a5d33cfc7f8e5437$var$z(u, $a5d33cfc7f8e5437$var$zs, s) * e % s, l = $a5d33cfc7f8e5437$var$z(a, $a5d33cfc7f8e5437$var$Ys, s) * a % s, f = $a5d33cfc7f8e5437$var$z(l, t, s) * l % s, d = $a5d33cfc7f8e5437$var$z(f, n, s) * f % s, g = $a5d33cfc7f8e5437$var$z(d, r, s) * d % s, y = $a5d33cfc7f8e5437$var$z(g, o, s) * g % s, h = $a5d33cfc7f8e5437$var$z(y, o, s) * g % s, m = $a5d33cfc7f8e5437$var$z(h, t, s) * l % s;
    return {
        pow_p_5_8: $a5d33cfc7f8e5437$var$z(m, $a5d33cfc7f8e5437$var$tr, s) * e % s,
        b2: c
    };
}
function $a5d33cfc7f8e5437$var$Zs(e) {
    return e[0] &= 248, e[31] &= 127, e[31] |= 64, e;
}
const $a5d33cfc7f8e5437$var$Ot = (()=>$a5d33cfc7f8e5437$var$Ws({
        P: $a5d33cfc7f8e5437$var$xt,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (e)=>{
            const t = $a5d33cfc7f8e5437$var$xt, { pow_p_5_8: n, b2: r } = $a5d33cfc7f8e5437$var$Xs(e);
            return $a5d33cfc7f8e5437$var$er($a5d33cfc7f8e5437$var$z(n, $a5d33cfc7f8e5437$var$Js, t) * r, t);
        },
        adjustScalarBytes: $a5d33cfc7f8e5437$var$Zs,
        randomBytes: $a5d33cfc7f8e5437$var$Se
    }))(), $a5d33cfc7f8e5437$export$f7403969428298bd = "base10", $a5d33cfc7f8e5437$export$49eb910ab2518105 = "base16", $a5d33cfc7f8e5437$export$9bff723d552e6bcf = "base64pad", $a5d33cfc7f8e5437$export$e9cf21fb8029e645 = "base64url", $a5d33cfc7f8e5437$export$9560dad2a83e4f04 = "utf8", $a5d33cfc7f8e5437$export$3425bd336a9673d8 = 0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4 = 1, $a5d33cfc7f8e5437$export$d79eac6ee921504f = 2, $a5d33cfc7f8e5437$var$ei = 0, $a5d33cfc7f8e5437$var$nr = 1, $a5d33cfc7f8e5437$var$Te = 12, $a5d33cfc7f8e5437$var$St = 32;
function $a5d33cfc7f8e5437$export$a949d36eab55b41f() {
    const e = $a5d33cfc7f8e5437$var$Ot.utils.randomPrivateKey(), t = $a5d33cfc7f8e5437$var$Ot.getPublicKey(e);
    return {
        privateKey: (0, $74e9859baf4497ef$exports.toString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105),
        publicKey: (0, $74e9859baf4497ef$exports.toString)(t, $a5d33cfc7f8e5437$export$49eb910ab2518105)
    };
}
function $a5d33cfc7f8e5437$export$d15a28e4f1821243() {
    const e = $a5d33cfc7f8e5437$var$Se($a5d33cfc7f8e5437$var$St);
    return (0, $74e9859baf4497ef$exports.toString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$f8378f68e053f5c6(e, t) {
    const n = $a5d33cfc7f8e5437$var$Ot.getSharedSecret((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105), (0, $74e9859baf4497ef$exports.fromString)(t, $a5d33cfc7f8e5437$export$49eb910ab2518105)), r = $a5d33cfc7f8e5437$var$Ts($a5d33cfc7f8e5437$var$He, n, void 0, void 0, $a5d33cfc7f8e5437$var$St);
    return (0, $74e9859baf4497ef$exports.toString)(r, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$1e87d19d4aab5805(e) {
    const t = $a5d33cfc7f8e5437$var$He((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105));
    return (0, $74e9859baf4497ef$exports.toString)(t, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$d4c241cec96564c1(e) {
    const t = $a5d33cfc7f8e5437$var$He((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$9560dad2a83e4f04));
    return (0, $74e9859baf4497ef$exports.toString)(t, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$e9d2f9ba70428fb6(e) {
    return (0, $74e9859baf4497ef$exports.fromString)(`${e}`, $a5d33cfc7f8e5437$export$f7403969428298bd);
}
function $a5d33cfc7f8e5437$export$7547a514ee29b9d4(e) {
    return Number((0, $74e9859baf4497ef$exports.toString)(e, $a5d33cfc7f8e5437$export$f7403969428298bd));
}
function $a5d33cfc7f8e5437$export$5b0f6292f11d1d18(e) {
    const t = $a5d33cfc7f8e5437$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $a5d33cfc7f8e5437$export$3425bd336a9673d8);
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(t) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const n = typeof e.senderPublicKey < "u" ? (0, $74e9859baf4497ef$exports.fromString)(e.senderPublicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $74e9859baf4497ef$exports.fromString)(e.iv, $a5d33cfc7f8e5437$export$49eb910ab2518105) : $a5d33cfc7f8e5437$var$Se($a5d33cfc7f8e5437$var$Te), o = (0, $74e9859baf4497ef$exports.fromString)(e.symKey, $a5d33cfc7f8e5437$export$49eb910ab2518105), s = $a5d33cfc7f8e5437$var$Fn(o, r).encrypt((0, $74e9859baf4497ef$exports.fromString)(e.message, $a5d33cfc7f8e5437$export$9560dad2a83e4f04));
    return $a5d33cfc7f8e5437$export$dfdc1655ccc5b9cb({
        type: t,
        sealed: s,
        iv: r,
        senderPublicKey: n,
        encoding: e.encoding
    });
}
function $a5d33cfc7f8e5437$export$e85a0c9a1067c5d3(e) {
    const t = (0, $74e9859baf4497ef$exports.fromString)(e.symKey, $a5d33cfc7f8e5437$export$49eb910ab2518105), { sealed: n, iv: r } = $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e), o = $a5d33cfc7f8e5437$var$Fn(t, r).decrypt(n);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $74e9859baf4497ef$exports.toString)(o, $a5d33cfc7f8e5437$export$9560dad2a83e4f04);
}
function $a5d33cfc7f8e5437$export$99abb28d1c4baa95(e, t) {
    const n = $a5d33cfc7f8e5437$export$e9d2f9ba70428fb6($a5d33cfc7f8e5437$export$d79eac6ee921504f), r = $a5d33cfc7f8e5437$var$Se($a5d33cfc7f8e5437$var$Te), o = (0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$9560dad2a83e4f04);
    return $a5d33cfc7f8e5437$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        encoding: t
    });
}
function $a5d33cfc7f8e5437$export$6b54347426d28ee3(e, t) {
    const { sealed: n } = $a5d33cfc7f8e5437$export$efcd34ab6248d3cd({
        encoded: e,
        encoding: t
    });
    return (0, $74e9859baf4497ef$exports.toString)(n, $a5d33cfc7f8e5437$export$9560dad2a83e4f04);
}
function $a5d33cfc7f8e5437$export$dfdc1655ccc5b9cb(e) {
    const { encoding: t = $a5d33cfc7f8e5437$export$9bff723d552e6bcf } = e;
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(e.type) === $a5d33cfc7f8e5437$export$d79eac6ee921504f) return (0, $74e9859baf4497ef$exports.toString)((0, $74e9859baf4497ef$exports.concat)([
        e.type,
        e.sealed
    ]), t);
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(e.type) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $74e9859baf4497ef$exports.toString)((0, $74e9859baf4497ef$exports.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), t);
    }
    return (0, $74e9859baf4497ef$exports.toString)((0, $74e9859baf4497ef$exports.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), t);
}
function $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e) {
    const { encoded: t, encoding: n = $a5d33cfc7f8e5437$export$9bff723d552e6bcf } = e, r = (0, $74e9859baf4497ef$exports.fromString)(t, n), o = r.slice($a5d33cfc7f8e5437$var$ei, $a5d33cfc7f8e5437$var$nr), s = $a5d33cfc7f8e5437$var$nr;
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(o) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        const a = s + $a5d33cfc7f8e5437$var$St, l = a + $a5d33cfc7f8e5437$var$Te, f = r.slice(s, a), d = r.slice(a, l), g = r.slice(l);
        return {
            type: o,
            sealed: g,
            iv: d,
            senderPublicKey: f
        };
    }
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(o) === $a5d33cfc7f8e5437$export$d79eac6ee921504f) {
        const a = r.slice(s), l = $a5d33cfc7f8e5437$var$Se($a5d33cfc7f8e5437$var$Te);
        return {
            type: o,
            sealed: a,
            iv: l
        };
    }
    const i = s + $a5d33cfc7f8e5437$var$Te, c = r.slice(s, i), u = r.slice(i);
    return {
        type: o,
        sealed: u,
        iv: c
    };
}
function $a5d33cfc7f8e5437$export$177f3e316562333d(e, t) {
    const n = $a5d33cfc7f8e5437$export$efcd34ab6248d3cd({
        encoded: e,
        encoding: t?.encoding
    });
    return $a5d33cfc7f8e5437$export$7949f60f2444aef2({
        type: $a5d33cfc7f8e5437$export$7547a514ee29b9d4(n.type),
        senderPublicKey: typeof n.senderPublicKey < "u" ? (0, $74e9859baf4497ef$exports.toString)(n.senderPublicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105) : void 0,
        receiverPublicKey: t?.receiverPublicKey
    });
}
function $a5d33cfc7f8e5437$export$7949f60f2444aef2(e) {
    const t = e?.type || $a5d33cfc7f8e5437$export$3425bd336a9673d8;
    if (t === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: t,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $a5d33cfc7f8e5437$export$8c165704db2d5c15(e) {
    return e.type === $a5d33cfc7f8e5437$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
function $a5d33cfc7f8e5437$export$599538f59a4a14c3(e) {
    return e.type === $a5d33cfc7f8e5437$export$d79eac6ee921504f;
}
function $a5d33cfc7f8e5437$export$63aed4db4cd72ee8(e) {
    return new (0, $1zUcV.ec)("p256").keyFromPublic({
        x: $a5d33cfc7f8e5437$require$Buffer.from(e.x, "base64").toString("hex"),
        y: $a5d33cfc7f8e5437$require$Buffer.from(e.y, "base64").toString("hex")
    }, "hex");
}
function $a5d33cfc7f8e5437$var$hi(e) {
    let t = e.replace(/-/g, "+").replace(/_/g, "/");
    const n = t.length % 4;
    return n > 0 && (t += "=".repeat(4 - n)), t;
}
function $a5d33cfc7f8e5437$var$pi(e) {
    return $a5d33cfc7f8e5437$require$Buffer.from($a5d33cfc7f8e5437$var$hi(e), "base64");
}
function $a5d33cfc7f8e5437$export$f65520390041ee33(e, t) {
    const [n, r, o] = e.split("."), s = $a5d33cfc7f8e5437$var$pi(o);
    if (s.length !== 64) throw new Error("Invalid signature length");
    const i = s.slice(0, 32).toString("hex"), c = s.slice(32, 64).toString("hex"), u = `${n}.${r}`, a = $a5d33cfc7f8e5437$var$He(u), l = $a5d33cfc7f8e5437$export$63aed4db4cd72ee8(t), f = (0, $74e9859baf4497ef$exports.toString)(a, $a5d33cfc7f8e5437$export$49eb910ab2518105);
    if (!l.verify(f, {
        r: i,
        s: c
    })) throw new Error("Invalid signature");
    return (0, $88cd1e73c7abe0b8$export$9a62e6c0a30e00bc)(e).payload;
}
const $a5d33cfc7f8e5437$export$822d0bd1635d5360 = "irn";
function $a5d33cfc7f8e5437$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $a5d33cfc7f8e5437$export$822d0bd1635d5360
    };
}
function $a5d33cfc7f8e5437$export$604e3deb95e1b734(e) {
    const t = (0, $e654830c96bdc727$export$af490b3b9a6de00f)[e];
    if (typeof t > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return t;
}
function $a5d33cfc7f8e5437$export$3d24f408c2ac468a(e, t = "-") {
    const n = {}, r = "relay" + t;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            n[s] = i;
        }
    }), n;
}
function $a5d33cfc7f8e5437$export$59f58847421cfb28(e) {
    if (!e.includes("wc:")) {
        const a = $a5d33cfc7f8e5437$export$c537b38001c583b7(e);
        a != null && a.includes("wc:") && (e = a);
    }
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const t = e.indexOf(":"), n = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, t), o = e.substring(t + 1, n).split("@"), s = typeof n < "u" ? e.substring(n) : "", i = new URLSearchParams(s), c = {};
    i.forEach((a, l)=>{
        c[l] = a;
    });
    const u = typeof c.methods == "string" ? c.methods.split(",") : void 0;
    return {
        protocol: r,
        topic: $a5d33cfc7f8e5437$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: c.symKey,
        relay: $a5d33cfc7f8e5437$export$3d24f408c2ac468a(c),
        methods: u,
        expiryTimestamp: c.expiryTimestamp ? parseInt(c.expiryTimestamp, 10) : void 0
    };
}
function $a5d33cfc7f8e5437$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $a5d33cfc7f8e5437$export$65c55c7ccd19bb8f(e, t = "-") {
    const n = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = n + t + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $a5d33cfc7f8e5437$export$b2786ede34fb2350(e) {
    const t = new URLSearchParams, n = $a5d33cfc7f8e5437$export$65c55c7ccd19bb8f(e.relay);
    Object.keys(n).sort().forEach((o)=>{
        t.set(o, n[o]);
    }), t.set("symKey", e.symKey), e.expiryTimestamp && t.set("expiryTimestamp", e.expiryTimestamp.toString()), e.methods && t.set("methods", e.methods.join(","));
    const r = t.toString();
    return `${e.protocol}:${e.topic}@${e.version}?${r}`;
}
function $a5d33cfc7f8e5437$export$556cb6cc912028c2(e, t, n) {
    return `${e}?wc_ev=${n}&topic=${t}`;
}
var $a5d33cfc7f8e5437$var$vi = Object.defineProperty, $a5d33cfc7f8e5437$var$xi = Object.defineProperties, $a5d33cfc7f8e5437$var$Oi = Object.getOwnPropertyDescriptors, $a5d33cfc7f8e5437$var$ur = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$Ii = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$Ai = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$fr = (e, t, n)=>t in e ? $a5d33cfc7f8e5437$var$vi(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n, $a5d33cfc7f8e5437$var$Ni = (e, t)=>{
    for(var n in t || (t = {}))$a5d33cfc7f8e5437$var$Ii.call(t, n) && $a5d33cfc7f8e5437$var$fr(e, n, t[n]);
    if ($a5d33cfc7f8e5437$var$ur) for (var n of $a5d33cfc7f8e5437$var$ur(t))$a5d33cfc7f8e5437$var$Ai.call(t, n) && $a5d33cfc7f8e5437$var$fr(e, n, t[n]);
    return e;
}, $a5d33cfc7f8e5437$var$Si = (e, t)=>$a5d33cfc7f8e5437$var$xi(e, $a5d33cfc7f8e5437$var$Oi(t));
function $a5d33cfc7f8e5437$export$d46695d9c3664fe9(e) {
    const t = [];
    return e.forEach((n)=>{
        const [r, o] = n.split(":");
        t.push(`${r}:${o}`);
    }), t;
}
function $a5d33cfc7f8e5437$export$fb6db6038e742b14(e) {
    const t = [];
    return Object.values(e).forEach((n)=>{
        t.push(...$a5d33cfc7f8e5437$export$d46695d9c3664fe9(n.accounts));
    }), t;
}
function $a5d33cfc7f8e5437$export$7dcf4808e17b15ac(e, t) {
    const n = [];
    return Object.values(e).forEach((r)=>{
        $a5d33cfc7f8e5437$export$d46695d9c3664fe9(r.accounts).includes(t) && n.push(...r.methods);
    }), n;
}
function $a5d33cfc7f8e5437$export$94ee6d00e384a22(e, t) {
    const n = [];
    return Object.values(e).forEach((r)=>{
        $a5d33cfc7f8e5437$export$d46695d9c3664fe9(r.accounts).includes(t) && n.push(...r.events);
    }), n;
}
function $a5d33cfc7f8e5437$export$a8daa26a7c60ef90(e, t) {
    const n = $a5d33cfc7f8e5437$export$93f7b81dc815a714(e, t);
    if (n) throw new Error(n.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $a5d33cfc7f8e5437$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: t, optionalNamespaces: n = {} }, supportedNamespaces: r } = e, o = $a5d33cfc7f8e5437$export$2994550cda701c96(t), s = $a5d33cfc7f8e5437$export$2994550cda701c96(n), i = {};
    Object.keys(r).forEach((a)=>{
        const l = r[a].chains, f = r[a].methods, d = r[a].events, g = r[a].accounts;
        l.forEach((y)=>{
            if (!g.some((h)=>h.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${a}`);
        }), i[a] = {
            chains: l,
            methods: f,
            events: d,
            accounts: g
        };
    });
    const c = $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4(t, i, "approve()");
    if (c) throw new Error(c.message);
    const u = {};
    return !Object.keys(t).length && !Object.keys(n).length ? i : (Object.keys(o).forEach((a)=>{
        const l = r[a].chains.filter((y)=>{
            var h, m;
            return (m = (h = o[a]) == null ? void 0 : h.chains) == null ? void 0 : m.includes(y);
        }), f = r[a].methods.filter((y)=>{
            var h, m;
            return (m = (h = o[a]) == null ? void 0 : h.methods) == null ? void 0 : m.includes(y);
        }), d = r[a].events.filter((y)=>{
            var h, m;
            return (m = (h = o[a]) == null ? void 0 : h.events) == null ? void 0 : m.includes(y);
        }), g = l.map((y)=>r[a].accounts.filter((h)=>h.includes(`${y}:`))).flat();
        u[a] = {
            chains: l,
            methods: f,
            events: d,
            accounts: g
        };
    }), Object.keys(s).forEach((a)=>{
        var l, f, d, g, y, h;
        if (!r[a]) return;
        const m = (f = (l = s[a]) == null ? void 0 : l.chains) == null ? void 0 : f.filter((I)=>r[a].chains.includes(I)), B = r[a].methods.filter((I)=>{
            var k, E;
            return (E = (k = s[a]) == null ? void 0 : k.methods) == null ? void 0 : E.includes(I);
        }), b = r[a].events.filter((I)=>{
            var k, E;
            return (E = (k = s[a]) == null ? void 0 : k.events) == null ? void 0 : E.includes(I);
        }), _ = m?.map((I)=>r[a].accounts.filter((k)=>k.includes(`${I}:`))).flat();
        u[a] = {
            chains: $a5d33cfc7f8e5437$export$9826fe7ad3921016((d = u[a]) == null ? void 0 : d.chains, m),
            methods: $a5d33cfc7f8e5437$export$9826fe7ad3921016((g = u[a]) == null ? void 0 : g.methods, B),
            events: $a5d33cfc7f8e5437$export$9826fe7ad3921016((y = u[a]) == null ? void 0 : y.events, b),
            accounts: $a5d33cfc7f8e5437$export$9826fe7ad3921016((h = u[a]) == null ? void 0 : h.accounts, _)
        };
    }), u);
}
function $a5d33cfc7f8e5437$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8(e) {
    return $a5d33cfc7f8e5437$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $a5d33cfc7f8e5437$export$2994550cda701c96(e) {
    var t, n, r;
    const o = {};
    if (!$a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const c = $a5d33cfc7f8e5437$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, u = i.methods || [], a = i.events || [], l = $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8(s);
        o[l] = $a5d33cfc7f8e5437$var$Si($a5d33cfc7f8e5437$var$Ni({}, o[l]), {
            chains: $a5d33cfc7f8e5437$export$9826fe7ad3921016(c, (t = o[l]) == null ? void 0 : t.chains),
            methods: $a5d33cfc7f8e5437$export$9826fe7ad3921016(u, (n = o[l]) == null ? void 0 : n.methods),
            events: $a5d33cfc7f8e5437$export$9826fe7ad3921016(a, (r = o[l]) == null ? void 0 : r.events)
        });
    }
    return o;
}
function $a5d33cfc7f8e5437$export$293459f1cc8d700(e) {
    const t = {};
    return e?.forEach((n)=>{
        const [r, o] = n.split(":");
        t[r] || (t[r] = {
            accounts: [],
            chains: [],
            events: []
        }), t[r].accounts.push(n), t[r].chains.push(`${r}:${o}`);
    }), t;
}
function $a5d33cfc7f8e5437$export$b5744b1c39447540(e, t) {
    t = t.map((r)=>r.replace("did:pkh:", ""));
    const n = $a5d33cfc7f8e5437$export$293459f1cc8d700(t);
    for (const [r, o] of Object.entries(n))o.methods ? o.methods = $a5d33cfc7f8e5437$export$9826fe7ad3921016(o.methods, e) : o.methods = e, o.events = [
        "chainChanged",
        "accountsChanged"
    ];
    return n;
}
const $a5d33cfc7f8e5437$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $a5d33cfc7f8e5437$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $a5d33cfc7f8e5437$export$500d4c4a8fafe35(e, t) {
    const { message: n, code: r } = $a5d33cfc7f8e5437$export$77b3faa414a0ce61[e];
    return {
        message: t ? `${n} ${t}` : n,
        code: r
    };
}
function $a5d33cfc7f8e5437$export$8203ef1531c8b5b5(e, t) {
    const { message: n, code: r } = $a5d33cfc7f8e5437$export$990de0b632caca05[e];
    return {
        message: t ? `${n} ${t}` : n,
        code: r
    };
}
function $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e, t) {
    return Array.isArray(e) ? typeof t < "u" && e.length ? e.every(t) : !0 : !1;
}
function $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $a5d33cfc7f8e5437$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, t) {
    return t && $a5d33cfc7f8e5437$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $a5d33cfc7f8e5437$export$d6781b696a0576d1(e, t) {
    return t && $a5d33cfc7f8e5437$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $a5d33cfc7f8e5437$export$6fc4971bf8f326a(e, t) {
    const { requiredNamespaces: n } = t, r = Object.keys(e.namespaces), o = Object.keys(n);
    let s = !0;
    return $a5d33cfc7f8e5437$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: c, methods: u, events: a } = e.namespaces[i], l = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(c), f = n[i];
        (!$a5d33cfc7f8e5437$export$1468a49de573f7f9($a5d33cfc7f8e5437$export$376384387cd15b27(i, f), l) || !$a5d33cfc7f8e5437$export$1468a49de573f7f9(f.methods, u) || !$a5d33cfc7f8e5437$export$1468a49de573f7f9(f.events, a)) && (s = !1);
    }), s) : !1;
}
function $a5d33cfc7f8e5437$export$e544b39f0a22e47a(e) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $a5d33cfc7f8e5437$export$49e4a5b6862e3c71(e) {
    if ($a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const t = e.split(":");
        if (t.length === 3) {
            const n = t[0] + ":" + t[1];
            return !!t[2] && $a5d33cfc7f8e5437$export$e544b39f0a22e47a(n);
        }
    }
    return !1;
}
function $a5d33cfc7f8e5437$export$bef94a5618bf18bf(e) {
    function t(n) {
        try {
            return typeof new URL(n) < "u";
        } catch  {
            return !1;
        }
    }
    try {
        if ($a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1)) {
            if (t(e)) return !0;
            const n = $a5d33cfc7f8e5437$export$c537b38001c583b7(e);
            return t(n);
        }
    } catch  {}
    return !1;
}
function $a5d33cfc7f8e5437$export$f657f7976bb2769d(e) {
    var t;
    return (t = e?.proposer) == null ? void 0 : t.publicKey;
}
function $a5d33cfc7f8e5437$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $a5d33cfc7f8e5437$export$5e1c5c89613c213f(e, t) {
    let n = null;
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e?.publicKey, !1) || (n = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t} controller public key should be a string`)), n;
}
function $a5d33cfc7f8e5437$export$c12fced8176774f3(e) {
    let t = !0;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) ? e.length && (t = e.every((n)=>$a5d33cfc7f8e5437$export$ee898ca48ab56c74(n, !1))) : t = !1, t;
}
function $a5d33cfc7f8e5437$export$df46c123d7e298ce(e, t, n) {
    let r = null;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(t) && t.length ? t.forEach((o)=>{
        r || $a5d33cfc7f8e5437$export$e544b39f0a22e47a(o) || (r = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${n}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $a5d33cfc7f8e5437$export$e544b39f0a22e47a(e) || (r = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${n}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $a5d33cfc7f8e5437$export$94ae96fb66f29e08(e, t, n) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $a5d33cfc7f8e5437$export$df46c123d7e298ce(o, $a5d33cfc7f8e5437$export$376384387cd15b27(o, s), `${t} ${n}`);
        i && (r = i);
    }), r;
}
function $a5d33cfc7f8e5437$export$d5644026aaffb9e7(e, t) {
    let n = null;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        n || $a5d33cfc7f8e5437$export$49e4a5b6862e3c71(r) || (n = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${t}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : n = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${t}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), n;
}
function $a5d33cfc7f8e5437$export$2a2012e7bfa1cfb4(e, t) {
    let n = null;
    return Object.values(e).forEach((r)=>{
        if (n) return;
        const o = $a5d33cfc7f8e5437$export$d5644026aaffb9e7(r?.accounts, `${t} namespace`);
        o && (n = o);
    }), n;
}
function $a5d33cfc7f8e5437$export$b32541d63753af56(e, t) {
    let n = null;
    return $a5d33cfc7f8e5437$export$c12fced8176774f3(e?.methods) ? $a5d33cfc7f8e5437$export$c12fced8176774f3(e?.events) || (n = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${t}, events should be an array of strings or empty array for no events`)) : n = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${t}, methods should be an array of strings or empty array for no methods`), n;
}
function $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, t) {
    let n = null;
    return Object.values(e).forEach((r)=>{
        if (n) return;
        const o = $a5d33cfc7f8e5437$export$b32541d63753af56(r, `${t}, namespace`);
        o && (n = o);
    }), n;
}
function $a5d33cfc7f8e5437$export$9e2b2cae22c6a8b3(e, t, n) {
    let r = null;
    if (e && $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) {
        const o = $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, t);
        o && (r = o);
        const s = $a5d33cfc7f8e5437$export$94ae96fb66f29e08(e, t, n);
        s && (r = s);
    } else r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t}, ${n} should be an object with data`);
    return r;
}
function $a5d33cfc7f8e5437$export$93f7b81dc815a714(e, t) {
    let n = null;
    if (e && $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) {
        const r = $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, t);
        r && (n = r);
        const o = $a5d33cfc7f8e5437$export$2a2012e7bfa1cfb4(e, t);
        o && (n = o);
    } else n = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t}, namespaces should be an object with data`);
    return n;
}
function $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b(e) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.protocol, !0);
}
function $a5d33cfc7f8e5437$export$6294c30b976bd21e(e, t) {
    let n = !1;
    return t && !e ? n = !0 : e && $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        n = $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b(r);
    }), n;
}
function $a5d33cfc7f8e5437$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $a5d33cfc7f8e5437$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $a5d33cfc7f8e5437$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$a5d33cfc7f8e5437$export$d6781b696a0576d1(e.code, !1) || !e.message || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.message, !1));
}
function $a5d33cfc7f8e5437$export$1a2af3c017fb6d42(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.method, !1));
}
function $a5d33cfc7f8e5437$export$1ae38cf0a848f651(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || $a5d33cfc7f8e5437$export$fce6876652108ab(e.result) && $a5d33cfc7f8e5437$export$fce6876652108ab(e.error) || !$a5d33cfc7f8e5437$export$d6781b696a0576d1(e.id, !1) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $a5d33cfc7f8e5437$export$cbe4cdc5960cfa11(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.name, !1));
}
function $a5d33cfc7f8e5437$export$144fc36610eb6522(e, t) {
    return !(!$a5d33cfc7f8e5437$export$e544b39f0a22e47a(t) || !$a5d33cfc7f8e5437$export$fb6db6038e742b14(e).includes(t));
}
function $a5d33cfc7f8e5437$export$8db4804e3a6de711(e, t, n) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(n, !1) ? $a5d33cfc7f8e5437$export$7dcf4808e17b15ac(e, t).includes(n) : !1;
}
function $a5d33cfc7f8e5437$export$df2c67ef8baad16b(e, t, n) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(n, !1) ? $a5d33cfc7f8e5437$export$94ee6d00e384a22(e, t).includes(n) : !1;
}
function $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4(e, t, n) {
    let r = null;
    const o = $a5d33cfc7f8e5437$var$Wi(e), s = $a5d33cfc7f8e5437$var$zi(t), i = Object.keys(o), c = Object.keys(s), u = $a5d33cfc7f8e5437$var$Sr(Object.keys(e)), a = $a5d33cfc7f8e5437$var$Sr(Object.keys(t)), l = u.filter((f)=>!a.includes(f));
    return l.length && (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces keys don't satisfy requiredNamespaces.
      Required: ${l.toString()}
      Received: ${Object.keys(t).toString()}`)), $a5d33cfc7f8e5437$export$1468a49de573f7f9(i, c) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${c.toString()}`)), Object.keys(t).forEach((f)=>{
        if (!f.includes(":") || r) return;
        const d = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(t[f].accounts);
        d.includes(f) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces accounts don't satisfy namespace accounts for ${f}
        Required: ${f}
        Approved: ${d.toString()}`));
    }), i.forEach((f)=>{
        r || ($a5d33cfc7f8e5437$export$1468a49de573f7f9(o[f].methods, s[f].methods) ? $a5d33cfc7f8e5437$export$1468a49de573f7f9(o[f].events, s[f].events) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces events don't satisfy namespace events for ${f}`)) : r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces methods don't satisfy namespace methods for ${f}`));
    }), r;
}
function $a5d33cfc7f8e5437$var$Wi(e) {
    const t = {};
    return Object.keys(e).forEach((n)=>{
        var r;
        n.includes(":") ? t[n] = e[n] : (r = e[n].chains) == null || r.forEach((o)=>{
            t[o] = {
                methods: e[n].methods,
                events: e[n].events
            };
        });
    }), t;
}
function $a5d33cfc7f8e5437$var$Sr(e) {
    return [
        ...new Set(e.map((t)=>t.includes(":") ? t.split(":")[0] : t))
    ];
}
function $a5d33cfc7f8e5437$var$zi(e) {
    const t = {};
    return Object.keys(e).forEach((n)=>{
        if (n.includes(":")) t[n] = e[n];
        else {
            const r = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(e[n].accounts);
            r?.forEach((o)=>{
                t[o] = {
                    accounts: e[n].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[n].methods,
                    events: e[n].events
                };
            });
        }
    }), t;
}
function $a5d33cfc7f8e5437$export$59fba2af1ac782b(e, t) {
    return $a5d33cfc7f8e5437$export$d6781b696a0576d1(e, !1) && e <= t.max && e >= t.min;
}
function $a5d33cfc7f8e5437$export$53c2fd0173ad2b80() {
    const e = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
    return new Promise((t)=>{
        switch(e){
            case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser:
                t($a5d33cfc7f8e5437$export$2f147c609a999e49());
                break;
            case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative:
                t($a5d33cfc7f8e5437$export$1444c95b1570bd12());
                break;
            case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.node:
                t($a5d33cfc7f8e5437$export$aec5b2d627eec500());
                break;
            default:
                t(!0);
        }
    });
}
function $a5d33cfc7f8e5437$export$2f147c609a999e49() {
    return $a5d33cfc7f8e5437$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $a5d33cfc7f8e5437$export$1444c95b1570bd12() {
    if ($a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $a5d33cfc7f8e5437$export$aec5b2d627eec500() {
    return !0;
}
function $a5d33cfc7f8e5437$export$600a1ee4bc680996(e) {
    switch($a5d33cfc7f8e5437$export$57570b1603cf6adb()){
        case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser:
            $a5d33cfc7f8e5437$export$d32b24f18d96c5f2(e);
            break;
        case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative:
            $a5d33cfc7f8e5437$export$904edb1c18ec91c7(e);
            break;
        case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.node:
            break;
    }
}
function $a5d33cfc7f8e5437$export$d32b24f18d96c5f2(e) {
    !$a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && $a5d33cfc7f8e5437$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $a5d33cfc7f8e5437$export$904edb1c18ec91c7(e) {
    $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((t)=>e(t?.isConnected));
}
const $a5d33cfc7f8e5437$var$Lt = {};
class $a5d33cfc7f8e5437$export$b72d712fed4d036d {
    static get(t) {
        return $a5d33cfc7f8e5437$var$Lt[t];
    }
    static set(t, n) {
        $a5d33cfc7f8e5437$var$Lt[t] = n;
    }
    static delete(t) {
        delete $a5d33cfc7f8e5437$var$Lt[t];
    }
}




var $7etJZ = parcelRequire("7etJZ");
var $201d0312d0bb8021$exports = {};
$parcel$export($201d0312d0bb8021$exports, "parseConnectionError", () => $ab82c37acb5ed82a$export$f555d7d8f922e407);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcError", () => $21f900087ef2a598$exports.formatJsonRpcError);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcRequest", () => $21f900087ef2a598$exports.formatJsonRpcRequest);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcResult", () => $21f900087ef2a598$exports.formatJsonRpcResult);
$parcel$export($201d0312d0bb8021$exports, "getBigIntRpcId", () => $21f900087ef2a598$exports.getBigIntRpcId);
$parcel$export($201d0312d0bb8021$exports, "IJsonRpcProvider", () => $21f900087ef2a598$exports.IJsonRpcProvider);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcError", () => $21f900087ef2a598$exports.isJsonRpcError);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcRequest", () => $21f900087ef2a598$exports.isJsonRpcRequest);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResponse", () => $21f900087ef2a598$exports.isJsonRpcResponse);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResult", () => $21f900087ef2a598$exports.isJsonRpcResult);
$parcel$export($201d0312d0bb8021$exports, "isLocalhostUrl", () => $21f900087ef2a598$exports.isLocalhostUrl);
$parcel$export($201d0312d0bb8021$exports, "isReactNative", () => $21f900087ef2a598$exports.isReactNative);
$parcel$export($201d0312d0bb8021$exports, "isWsUrl", () => $21f900087ef2a598$exports.isWsUrl);
$parcel$export($201d0312d0bb8021$exports, "parseConnectionError", () => $21f900087ef2a598$exports.parseConnectionError);
$parcel$export($201d0312d0bb8021$exports, "payloadId", () => $21f900087ef2a598$exports.payloadId);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcError", () => $3bb3ddc7bbc938cc$export$9f7302ae26c3f77);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcRequest", () => $3bb3ddc7bbc938cc$export$11d081ebb32d4398);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcResult", () => $3bb3ddc7bbc938cc$export$478fdea01c2a3198);
$parcel$export($201d0312d0bb8021$exports, "getBigIntRpcId", () => $3bb3ddc7bbc938cc$export$799a3db5df197877);
$parcel$export($201d0312d0bb8021$exports, "payloadId", () => $3bb3ddc7bbc938cc$export$2f5364a5d4b80251);
$parcel$export($201d0312d0bb8021$exports, "IJsonRpcProvider", () => $ef27bcc9f85079c4$export$46957420a688a16d);
$parcel$export($201d0312d0bb8021$exports, "isLocalhostUrl", () => $ceb127018999f416$export$8eb4a0a481601f29);
$parcel$export($201d0312d0bb8021$exports, "isWsUrl", () => $ceb127018999f416$export$4e4463e75eccf20c);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcError", () => $2e45abd1d679ec32$export$5662a1047b4d1d15);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcRequest", () => $2e45abd1d679ec32$export$f6e4034abe07d2a5);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResponse", () => $2e45abd1d679ec32$export$308ba927de2bcbe8);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResult", () => $2e45abd1d679ec32$export$cb3d3b20e3223d77);
const $fb0266a13f89cf1a$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $fb0266a13f89cf1a$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $fb0266a13f89cf1a$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $fb0266a13f89cf1a$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $fb0266a13f89cf1a$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $fb0266a13f89cf1a$export$125ebd30471ac25c = "SERVER_ERROR";
const $fb0266a13f89cf1a$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $fb0266a13f89cf1a$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $fb0266a13f89cf1a$export$cca5387ab287e1ae = {
    [$fb0266a13f89cf1a$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$fb0266a13f89cf1a$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$fb0266a13f89cf1a$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$fb0266a13f89cf1a$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$fb0266a13f89cf1a$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$fb0266a13f89cf1a$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $fb0266a13f89cf1a$export$d166979eca925bce = $fb0266a13f89cf1a$export$125ebd30471ac25c;



function $ab82c37acb5ed82a$export$e463129eb4bc487f(code) {
    return code <= (0, $fb0266a13f89cf1a$export$fff5b44b15c75f69)[0] && code >= (0, $fb0266a13f89cf1a$export$fff5b44b15c75f69)[1];
}
function $ab82c37acb5ed82a$export$2ae0ec6393ab16c3(code) {
    return (0, $fb0266a13f89cf1a$export$af84821b5448ca78).includes(code);
}
function $ab82c37acb5ed82a$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $ab82c37acb5ed82a$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)).includes(type)) return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce];
    return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[type];
}
function $ab82c37acb5ed82a$export$60a3bac005957e12(code) {
    const match = Object.values((0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)).find((e)=>e.code === code);
    if (!match) return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce];
    return match;
}
function $ab82c37acb5ed82a$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$ab82c37acb5ed82a$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($ab82c37acb5ed82a$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $ab82c37acb5ed82a$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $ab82c37acb5ed82a$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}


var $21f900087ef2a598$exports = {};
"use strict";
Object.defineProperty($21f900087ef2a598$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("ljFVp")), $21f900087ef2a598$exports);

$7WQrb.__exportStar((parcelRequire("5vmD7")), $21f900087ef2a598$exports);


const $c1abc8a6542d5235$export$d1694901a048d7c8 = (0, $21f900087ef2a598$exports.isNode);




function $3bb3ddc7bbc938cc$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $3bb3ddc7bbc938cc$export$799a3db5df197877(entropy = 6) {
    return BigInt($3bb3ddc7bbc938cc$export$2f5364a5d4b80251(entropy));
}
function $3bb3ddc7bbc938cc$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $3bb3ddc7bbc938cc$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $3bb3ddc7bbc938cc$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $3bb3ddc7bbc938cc$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $3bb3ddc7bbc938cc$export$5201d50a34753d71(error, data)
    };
}
function $3bb3ddc7bbc938cc$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $ab82c37acb5ed82a$export$e1599abf47b5b568)((0, $fb0266a13f89cf1a$export$f6e3abf3038d348f));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $ab82c37acb5ed82a$export$e1599abf47b5b568)((0, $fb0266a13f89cf1a$export$125ebd30471ac25c))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $ab82c37acb5ed82a$export$2ae0ec6393ab16c3)(error.code)) error = (0, $ab82c37acb5ed82a$export$60a3bac005957e12)(error.code);
    return error;
}


function $d805e0076f614f48$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $d805e0076f614f48$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $d805e0076f614f48$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $d805e0076f614f48$export$8e8b9bea55b56df2(route) {
    if ($d805e0076f614f48$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $d805e0076f614f48$export$2d48faaafcc8fbdc(route) {
    return !$d805e0076f614f48$export$c7e2040809cad2c4(route) && $d805e0076f614f48$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $d805e0076f614f48$export$be298a4710fab756(route) {
    return !$d805e0076f614f48$export$c7e2040809cad2c4(route) && $d805e0076f614f48$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}


class $ef27bcc9f85079c4$export$ab429ec7e240e546 {
}
class $ef27bcc9f85079c4$export$77d426dd89724fbe extends $ef27bcc9f85079c4$export$ab429ec7e240e546 {
    constructor(c){
        super();
    }
}
class $ef27bcc9f85079c4$export$cb916a2eed49af33 extends $ef27bcc9f85079c4$export$ab429ec7e240e546 {
    constructor(){
        super();
    }
}
class $ef27bcc9f85079c4$export$46957420a688a16d extends $ef27bcc9f85079c4$export$cb916a2eed49af33 {
    constructor(c){
        super();
    }
}




const $ceb127018999f416$var$HTTP_REGEX = "^https?:";
const $ceb127018999f416$var$WS_REGEX = "^wss?:";
function $ceb127018999f416$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $ceb127018999f416$var$matchRegexProtocol(url, regex) {
    const protocol = $ceb127018999f416$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $ceb127018999f416$export$206c3129b8bb1b4f(url) {
    return $ceb127018999f416$var$matchRegexProtocol(url, $ceb127018999f416$var$HTTP_REGEX);
}
function $ceb127018999f416$export$4e4463e75eccf20c(url) {
    return $ceb127018999f416$var$matchRegexProtocol(url, $ceb127018999f416$var$WS_REGEX);
}
function $ceb127018999f416$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}


function $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $2e45abd1d679ec32$export$f6e4034abe07d2a5(payload) {
    return $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $2e45abd1d679ec32$export$308ba927de2bcbe8(payload) {
    return $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) && ($2e45abd1d679ec32$export$cb3d3b20e3223d77(payload) || $2e45abd1d679ec32$export$5662a1047b4d1d15(payload));
}
function $2e45abd1d679ec32$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $2e45abd1d679ec32$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $2e45abd1d679ec32$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}




class $a22b629dd83c07d0$export$da28308012bf6748 extends (0, $ef27bcc9f85079c4$export$46957420a688a16d) {
    constructor(t){
        super(t), this.events = new (0, $7etJZ.EventEmitter), this.hasRegisteredEventListeners = !1, this.connection = this.setConnection(t), this.connection.connected && this.registerEventListeners();
    }
    async connect(t = this.connection) {
        await this.open(t);
    }
    async disconnect() {
        await this.close();
    }
    on(t, e) {
        this.events.on(t, e);
    }
    once(t, e) {
        this.events.once(t, e);
    }
    off(t, e) {
        this.events.off(t, e);
    }
    removeListener(t, e) {
        this.events.removeListener(t, e);
    }
    async request(t, e) {
        return this.requestStrict((0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(t.method, t.params || [], t.id || (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString()), e);
    }
    async requestStrict(t, e) {
        return new Promise(async (i, s)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (n) {
                s(n);
            }
            this.events.on(`${t.id}`, (n)=>{
                (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(n) ? s(n.error) : i(n.result);
            });
            try {
                await this.connection.send(t, e);
            } catch (n) {
                s(n);
            }
        });
    }
    setConnection(t = this.connection) {
        return t;
    }
    onPayload(t) {
        this.events.emit("payload", t), (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(t) ? this.events.emit(`${t.id}`, t) : this.events.emit("message", {
            type: t.method,
            data: t.params
        });
    }
    onClose(t) {
        t && t.code === 3e3 && this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${t.code} ${t.reason ? `(${t.reason})` : ""}`)), this.events.emit("disconnect");
    }
    async open(t = this.connection) {
        this.connection === t && this.connection.connected || (this.connection.connected && this.close(), typeof t == "string" && (await this.connection.open(t), t = this.connection), this.connection = this.setConnection(t), await this.connection.open(), this.registerEventListeners(), this.events.emit("connect"));
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        this.hasRegisteredEventListeners || (this.connection.on("payload", (t)=>this.onPayload(t)), this.connection.on("close", (t)=>this.onClose(t)), this.connection.on("error", (t)=>this.events.emit("error", t)), this.connection.on("register_error", (t)=>this.onClose()), this.hasRegisteredEventListeners = !0);
    }
}




var $7etJZ = parcelRequire("7etJZ");



const $f6230024aa4de9c4$var$v = ()=>typeof WebSocket < "u" ? WebSocket : typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" ? $parcel$global.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : (parcelRequire("fvaAM")), $f6230024aa4de9c4$var$w = ()=>typeof WebSocket < "u" || typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", $f6230024aa4de9c4$var$d = (r)=>r.split("?")[0], $f6230024aa4de9c4$var$h = 10, $f6230024aa4de9c4$var$b = $f6230024aa4de9c4$var$v();
class $f6230024aa4de9c4$export$ea0df116fa892998 {
    constructor(e){
        if (this.url = e, this.events = new (0, $7etJZ.EventEmitter), this.registering = !1, !(0, $ceb127018999f416$export$4e4463e75eccf20c)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        this.url = e;
    }
    get connected() {
        return typeof this.socket < "u";
    }
    get connecting() {
        return this.registering;
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async open(e = this.url) {
        await this.register(e);
    }
    async close() {
        return new Promise((e, t)=>{
            if (typeof this.socket > "u") {
                t(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (n)=>{
                this.onClose(n), e();
            }, this.socket.close();
        });
    }
    async send(e) {
        typeof this.socket > "u" && (this.socket = await this.register());
        try {
            this.socket.send((0, $81c2e06d24b89184$export$abc3f407e87918a4)(e));
        } catch (t) {
            this.onError(e.id, t);
        }
    }
    register(e = this.url) {
        if (!(0, $ceb127018999f416$export$4e4463e75eccf20c)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        if (this.registering) {
            const t = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= t || this.events.listenerCount("open") >= t) && this.events.setMaxListeners(t + 1), new Promise((n, s)=>{
                this.events.once("register_error", (o)=>{
                    this.resetMaxListeners(), s(o);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.socket > "u") return s(new Error("WebSocket connection is missing or invalid"));
                    n(this.socket);
                });
            });
        }
        return this.url = e, this.registering = !0, new Promise((t, n)=>{
            const s = (0, $21f900087ef2a598$exports.isReactNative)() ? void 0 : {
                rejectUnauthorized: !(0, $ceb127018999f416$export$8eb4a0a481601f29)(e)
            }, o = new $f6230024aa4de9c4$var$b(e, [], s);
            $f6230024aa4de9c4$var$w() ? o.onerror = (i)=>{
                const a = i;
                n(this.emitError(a.error));
            } : o.on("error", (i)=>{
                n(this.emitError(i));
            }), o.onopen = ()=>{
                this.onOpen(o), t(o);
            };
        });
    }
    onOpen(e) {
        e.onmessage = (t)=>this.onPayload(t), e.onclose = (t)=>this.onClose(t), this.socket = e, this.registering = !1, this.events.emit("open");
    }
    onClose(e) {
        this.socket = void 0, this.registering = !1, this.events.emit("close", e);
    }
    onPayload(e) {
        if (typeof e.data > "u") return;
        const t = typeof e.data == "string" ? (0, $81c2e06d24b89184$export$84137bb44359aed5)(e.data) : e.data;
        this.events.emit("payload", t);
    }
    onError(e, t) {
        const n = this.parseError(t), s = n.message || n.toString(), o = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(e, s);
        this.events.emit("payload", o);
    }
    parseError(e, t = this.url) {
        return (0, $ab82c37acb5ed82a$export$f555d7d8f922e407)(e, $f6230024aa4de9c4$var$d(t), "WS");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $f6230024aa4de9c4$var$h && this.events.setMaxListeners($f6230024aa4de9c4$var$h);
    }
    emitError(e) {
        const t = this.parseError(new Error(e?.message || `WebSocket connection failed for host: ${$f6230024aa4de9c4$var$d(this.url)}`));
        return this.events.emit("register_error", t), t;
    }
}



var $6cqMT = parcelRequire("6cqMT");

const $e9e439c110f17033$export$51b1c900ac262bdf = "wc", $e9e439c110f17033$export$f30bd3c8747cdfbe = 2, $e9e439c110f17033$export$d47601f9de5ee22b = "core", $e9e439c110f17033$export$f258d29ae5e3d545 = `${$e9e439c110f17033$export$51b1c900ac262bdf}@2:${$e9e439c110f17033$export$d47601f9de5ee22b}:`, $e9e439c110f17033$export$db0fdb6d486555c2 = {
    name: $e9e439c110f17033$export$d47601f9de5ee22b,
    logger: "error"
}, $e9e439c110f17033$export$ba920abfe854b85d = {
    database: ":memory:"
}, $e9e439c110f17033$export$92a79f21481c803d = "crypto", $e9e439c110f17033$export$3613aa6e652146e4 = "client_ed25519_seed", $e9e439c110f17033$export$c4bc5e31a4d0ec78 = (0, $7c6109395b060f04$exports.ONE_DAY), $e9e439c110f17033$export$9d7218f72e8dc49b = "keychain", $e9e439c110f17033$export$34f82f4ba0c3d769 = "0.3", $e9e439c110f17033$export$9662bbc7d10cf481 = "messages", $e9e439c110f17033$export$19dfd1896412c038 = "0.3", $e9e439c110f17033$export$8ddbe6611b67d926 = (0, $7c6109395b060f04$exports.SIX_HOURS), $e9e439c110f17033$export$9d92662178f2abd1 = "publisher", $e9e439c110f17033$export$822d0bd1635d5360 = "irn", $e9e439c110f17033$export$5176ffa6778d6637 = "error", $e9e439c110f17033$export$a68061e6c48f332a = "wss://relay.walletconnect.org", $e9e439c110f17033$export$602d6e27611c3fcb = "relayer", $e9e439c110f17033$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $e9e439c110f17033$export$119b4645f6b233c8 = "_subscription", $e9e439c110f17033$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $e9e439c110f17033$export$11ccd39be2c57d6 = .1, $e9e439c110f17033$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $e9e439c110f17033$export$5f30917a6f8c9025 = "2.18.0", $e9e439c110f17033$export$fb3eab7adf12329d = 1e4, $e9e439c110f17033$export$326e296bb8673773 = {
    link_mode: "link_mode",
    relay: "relay"
}, $e9e439c110f17033$export$629a342182ba24b = "0.3", $e9e439c110f17033$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $e9e439c110f17033$export$1989eec3a412fb97 = "WALLETCONNECT_LINK_MODE_APPS", $e9e439c110f17033$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $e9e439c110f17033$export$9d35d0a6a3599be = (0, $7c6109395b060f04$exports.THIRTY_DAYS), $e9e439c110f17033$export$9c3a96bb670cddb8 = "subscription", $e9e439c110f17033$export$fb57e03bef4c4cea = "0.3", $e9e439c110f17033$export$9a2ddbfe54f8af77 = (0, $7c6109395b060f04$exports.FIVE_SECONDS) * 1e3, $e9e439c110f17033$export$390360ea476c6145 = "pairing", $e9e439c110f17033$export$5593ec74b27d1b18 = "0.3", $e9e439c110f17033$export$ee4b1978d0aedfad = (0, $7c6109395b060f04$exports.THIRTY_DAYS), $e9e439c110f17033$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $e9e439c110f17033$export$ca3c0b962acf7b75 = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, $e9e439c110f17033$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $e9e439c110f17033$export$160142c73cb99dc3 = "history", $e9e439c110f17033$export$8eba9ce85616c607 = "0.3", $e9e439c110f17033$export$4ddf883392bbc828 = "expirer", $e9e439c110f17033$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $e9e439c110f17033$export$717295846191925d = "0.3", $e9e439c110f17033$export$3cfe73d6765db74 = (0, $7c6109395b060f04$exports.ONE_DAY), $e9e439c110f17033$export$3b58f2450f2297e3 = "verify-api", $e9e439c110f17033$var$Ss = "https://verify.walletconnect.com", $e9e439c110f17033$var$Et = "https://verify.walletconnect.org", $e9e439c110f17033$export$7e3b1a28ddecdbaa = $e9e439c110f17033$var$Et, $e9e439c110f17033$export$412739528655ee2f = `${$e9e439c110f17033$export$7e3b1a28ddecdbaa}/v3`, $e9e439c110f17033$export$be24df03c4baa778 = [
    $e9e439c110f17033$var$Ss,
    $e9e439c110f17033$var$Et
], $e9e439c110f17033$export$40c022d2cffe0adc = "echo", $e9e439c110f17033$export$3c48c4faab79aab1 = "https://echo.walletconnect.com", $e9e439c110f17033$export$2f94b15ed52f7de9 = "event-client", $e9e439c110f17033$export$6736f9bb609b5d34 = {
    pairing_started: "pairing_started",
    pairing_uri_validation_success: "pairing_uri_validation_success",
    pairing_uri_not_expired: "pairing_uri_not_expired",
    store_new_pairing: "store_new_pairing",
    subscribing_pairing_topic: "subscribing_pairing_topic",
    subscribe_pairing_topic_success: "subscribe_pairing_topic_success",
    existing_pairing: "existing_pairing",
    pairing_not_expired: "pairing_not_expired",
    emit_inactive_pairing: "emit_inactive_pairing",
    emit_session_proposal: "emit_session_proposal",
    subscribing_to_pairing_topic: "subscribing_to_pairing_topic"
}, $e9e439c110f17033$export$e1dc85b7b7495247 = {
    no_wss_connection: "no_wss_connection",
    no_internet_connection: "no_internet_connection",
    malformed_pairing_uri: "malformed_pairing_uri",
    active_pairing_already_exists: "active_pairing_already_exists",
    subscribe_pairing_topic_failure: "subscribe_pairing_topic_failure",
    pairing_expired: "pairing_expired",
    proposal_expired: "proposal_expired",
    proposal_listener_not_found: "proposal_listener_not_found"
}, $e9e439c110f17033$export$16ed3f27a411eba0 = {
    session_approve_started: "session_approve_started",
    proposal_not_expired: "proposal_not_expired",
    session_namespaces_validation_success: "session_namespaces_validation_success",
    create_session_topic: "create_session_topic",
    subscribing_session_topic: "subscribing_session_topic",
    subscribe_session_topic_success: "subscribe_session_topic_success",
    publishing_session_approve: "publishing_session_approve",
    session_approve_publish_success: "session_approve_publish_success",
    store_session: "store_session",
    publishing_session_settle: "publishing_session_settle",
    session_settle_publish_success: "session_settle_publish_success"
}, $e9e439c110f17033$export$bc50109885e83402 = {
    no_internet_connection: "no_internet_connection",
    no_wss_connection: "no_wss_connection",
    proposal_expired: "proposal_expired",
    subscribe_session_topic_failure: "subscribe_session_topic_failure",
    session_approve_publish_failure: "session_approve_publish_failure",
    session_settle_publish_failure: "session_settle_publish_failure",
    session_approve_namespace_validation_failure: "session_approve_namespace_validation_failure",
    proposal_not_found: "proposal_not_found"
}, $e9e439c110f17033$export$6540f02663742dde = {
    authenticated_session_approve_started: "authenticated_session_approve_started",
    authenticated_session_not_expired: "authenticated_session_not_expired",
    chains_caip2_compliant: "chains_caip2_compliant",
    chains_evm_compliant: "chains_evm_compliant",
    create_authenticated_session_topic: "create_authenticated_session_topic",
    cacaos_verified: "cacaos_verified",
    store_authenticated_session: "store_authenticated_session",
    subscribing_authenticated_session_topic: "subscribing_authenticated_session_topic",
    subscribe_authenticated_session_topic_success: "subscribe_authenticated_session_topic_success",
    publishing_authenticated_session_approve: "publishing_authenticated_session_approve",
    authenticated_session_approve_publish_success: "authenticated_session_approve_publish_success"
}, $e9e439c110f17033$export$aca4f34441e6cd3a = {
    no_internet_connection: "no_internet_connection",
    no_wss_connection: "no_wss_connection",
    missing_session_authenticate_request: "missing_session_authenticate_request",
    session_authenticate_request_expired: "session_authenticate_request_expired",
    chains_caip2_compliant_failure: "chains_caip2_compliant_failure",
    chains_evm_compliant_failure: "chains_evm_compliant_failure",
    invalid_cacao: "invalid_cacao",
    subscribe_authenticated_session_topic_failure: "subscribe_authenticated_session_topic_failure",
    authenticated_session_approve_publish_failure: "authenticated_session_approve_publish_failure",
    authenticated_session_pending_request_not_found: "authenticated_session_pending_request_not_found"
}, $e9e439c110f17033$export$c73857c3a3d16b1c = .1, $e9e439c110f17033$export$e020229e09910965 = "event-client", $e9e439c110f17033$export$79348045429687e2 = 86400, $e9e439c110f17033$export$bb6a8925f3cb1ca = "https://pulse.walletconnect.org/batch";
function $e9e439c110f17033$var$zs(o, e) {
    if (o.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), s = 0; s < t.length; s++)t[s] = 255;
    for(var i = 0; i < o.length; i++){
        var r = o.charAt(i), n = r.charCodeAt(0);
        if (t[n] !== 255) throw new TypeError(r + " is ambiguous");
        t[n] = i;
    }
    var a = o.length, c = o.charAt(0), h = Math.log(a) / Math.log(256), u = Math.log(256) / Math.log(a);
    function d(l) {
        if (l instanceof Uint8Array || (ArrayBuffer.isView(l) ? l = new Uint8Array(l.buffer, l.byteOffset, l.byteLength) : Array.isArray(l) && (l = Uint8Array.from(l))), !(l instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (l.length === 0) return "";
        for(var g = 0, w = 0, b = 0, D = l.length; b !== D && l[b] === 0;)b++, g++;
        for(var P = (D - b) * u + 1 >>> 0, f = new Uint8Array(P); b !== D;){
            for(var N = l[b], k = 0, O = P - 1; (N !== 0 || k < w) && O !== -1; O--, k++)N += 256 * f[O] >>> 0, f[O] = N % a >>> 0, N = N / a >>> 0;
            if (N !== 0) throw new Error("Non-zero carry");
            w = k, b++;
        }
        for(var L = P - w; L !== P && f[L] === 0;)L++;
        for(var ee = c.repeat(g); L < P; ++L)ee += o.charAt(f[L]);
        return ee;
    }
    function y(l) {
        if (typeof l != "string") throw new TypeError("Expected String");
        if (l.length === 0) return new Uint8Array;
        var g = 0;
        if (l[g] !== " ") {
            for(var w = 0, b = 0; l[g] === c;)w++, g++;
            for(var D = (l.length - g) * h + 1 >>> 0, P = new Uint8Array(D); l[g];){
                var f = t[l.charCodeAt(g)];
                if (f === 255) return;
                for(var N = 0, k = D - 1; (f !== 0 || N < b) && k !== -1; k--, N++)f += a * P[k] >>> 0, P[k] = f % 256 >>> 0, f = f / 256 >>> 0;
                if (f !== 0) throw new Error("Non-zero carry");
                b = N, g++;
            }
            if (l[g] !== " ") {
                for(var O = D - b; O !== D && P[O] === 0;)O++;
                for(var L = new Uint8Array(w + (D - O)), ee = w; O !== D;)L[ee++] = P[O++];
                return L;
            }
        }
    }
    function m(l) {
        var g = y(l);
        if (g) return g;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: d,
        decodeUnsafe: y,
        decode: m
    };
}
var $e9e439c110f17033$var$Ls = $e9e439c110f17033$var$zs, $e9e439c110f17033$var$$s = $e9e439c110f17033$var$Ls;
const $e9e439c110f17033$var$Ot = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $e9e439c110f17033$var$ks = (o)=>new TextEncoder().encode(o), $e9e439c110f17033$var$Us = (o)=>new TextDecoder().decode(o);
class $e9e439c110f17033$var$Fs {
    constructor(e, t, s){
        this.name = e, this.prefix = t, this.baseEncode = s;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $e9e439c110f17033$var$Ms {
    constructor(e, t, s){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = s;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $e9e439c110f17033$var$At(this, e);
    }
}
class $e9e439c110f17033$var$Ks {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $e9e439c110f17033$var$At(this, e);
    }
    decode(e) {
        const t = e[0], s = this.decoders[t];
        if (s) return s.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $e9e439c110f17033$var$At = (o, e)=>new $e9e439c110f17033$var$Ks({
        ...o.decoders || {
            [o.prefix]: o
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $e9e439c110f17033$var$Bs {
    constructor(e, t, s, i){
        this.name = e, this.prefix = t, this.baseEncode = s, this.baseDecode = i, this.encoder = new $e9e439c110f17033$var$Fs(e, t, s), this.decoder = new $e9e439c110f17033$var$Ms(e, t, i);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $e9e439c110f17033$var$ne = ({ name: o, prefix: e, encode: t, decode: s })=>new $e9e439c110f17033$var$Bs(o, e, t, s), $e9e439c110f17033$var$W = ({ prefix: o, name: e, alphabet: t })=>{
    const { encode: s, decode: i } = $e9e439c110f17033$var$$s(t, e);
    return $e9e439c110f17033$var$ne({
        prefix: o,
        name: e,
        encode: s,
        decode: (r)=>$e9e439c110f17033$var$Ot(i(r))
    });
}, $e9e439c110f17033$var$Vs = (o, e, t, s)=>{
    const i = {};
    for(let u = 0; u < e.length; ++u)i[e[u]] = u;
    let r = o.length;
    for(; o[r - 1] === "=";)--r;
    const n = new Uint8Array(r * t / 8 | 0);
    let a = 0, c = 0, h = 0;
    for(let u = 0; u < r; ++u){
        const d = i[o[u]];
        if (d === void 0) throw new SyntaxError(`Non-${s} character`);
        c = c << t | d, a += t, a >= 8 && (a -= 8, n[h++] = 255 & c >> a);
    }
    if (a >= t || 255 & c << 8 - a) throw new SyntaxError("Unexpected end of data");
    return n;
}, $e9e439c110f17033$var$js = (o, e, t)=>{
    const s = e[e.length - 1] === "=", i = (1 << t) - 1;
    let r = "", n = 0, a = 0;
    for(let c = 0; c < o.length; ++c)for(a = a << 8 | o[c], n += 8; n > t;)n -= t, r += e[i & a >> n];
    if (n && (r += e[i & a << t - n]), s) for(; r.length * t & 7;)r += "=";
    return r;
}, $e9e439c110f17033$var$_ = ({ name: o, prefix: e, bitsPerChar: t, alphabet: s })=>$e9e439c110f17033$var$ne({
        prefix: e,
        name: o,
        encode (i) {
            return $e9e439c110f17033$var$js(i, s, t);
        },
        decode (i) {
            return $e9e439c110f17033$var$Vs(i, s, t, o);
        }
    }), $e9e439c110f17033$var$qs = $e9e439c110f17033$var$ne({
    prefix: "\0",
    name: "identity",
    encode: (o)=>$e9e439c110f17033$var$Us(o),
    decode: (o)=>$e9e439c110f17033$var$ks(o)
});
var $e9e439c110f17033$var$Gs = Object.freeze({
    __proto__: null,
    identity: $e9e439c110f17033$var$qs
});
const $e9e439c110f17033$var$Hs = $e9e439c110f17033$var$_({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $e9e439c110f17033$var$Ys = Object.freeze({
    __proto__: null,
    base2: $e9e439c110f17033$var$Hs
});
const $e9e439c110f17033$var$Js = $e9e439c110f17033$var$_({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $e9e439c110f17033$var$Xs = Object.freeze({
    __proto__: null,
    base8: $e9e439c110f17033$var$Js
});
const $e9e439c110f17033$var$Ws = $e9e439c110f17033$var$W({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $e9e439c110f17033$var$Zs = Object.freeze({
    __proto__: null,
    base10: $e9e439c110f17033$var$Ws
});
const $e9e439c110f17033$var$Qs = $e9e439c110f17033$var$_({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $e9e439c110f17033$var$er = $e9e439c110f17033$var$_({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $e9e439c110f17033$var$tr = Object.freeze({
    __proto__: null,
    base16: $e9e439c110f17033$var$Qs,
    base16upper: $e9e439c110f17033$var$er
});
const $e9e439c110f17033$var$ir = $e9e439c110f17033$var$_({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $e9e439c110f17033$var$sr = $e9e439c110f17033$var$_({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $e9e439c110f17033$var$rr = $e9e439c110f17033$var$_({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$nr = $e9e439c110f17033$var$_({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$or = $e9e439c110f17033$var$_({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $e9e439c110f17033$var$ar = $e9e439c110f17033$var$_({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $e9e439c110f17033$var$cr = $e9e439c110f17033$var$_({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$hr = $e9e439c110f17033$var$_({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$lr = $e9e439c110f17033$var$_({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $e9e439c110f17033$var$ur = Object.freeze({
    __proto__: null,
    base32: $e9e439c110f17033$var$ir,
    base32upper: $e9e439c110f17033$var$sr,
    base32pad: $e9e439c110f17033$var$rr,
    base32padupper: $e9e439c110f17033$var$nr,
    base32hex: $e9e439c110f17033$var$or,
    base32hexupper: $e9e439c110f17033$var$ar,
    base32hexpad: $e9e439c110f17033$var$cr,
    base32hexpadupper: $e9e439c110f17033$var$hr,
    base32z: $e9e439c110f17033$var$lr
});
const $e9e439c110f17033$var$dr = $e9e439c110f17033$var$W({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $e9e439c110f17033$var$pr = $e9e439c110f17033$var$W({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $e9e439c110f17033$var$gr = Object.freeze({
    __proto__: null,
    base36: $e9e439c110f17033$var$dr,
    base36upper: $e9e439c110f17033$var$pr
});
const $e9e439c110f17033$var$yr = $e9e439c110f17033$var$W({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $e9e439c110f17033$var$Dr = $e9e439c110f17033$var$W({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $e9e439c110f17033$var$mr = Object.freeze({
    __proto__: null,
    base58btc: $e9e439c110f17033$var$yr,
    base58flickr: $e9e439c110f17033$var$Dr
});
const $e9e439c110f17033$var$br = $e9e439c110f17033$var$_({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $e9e439c110f17033$var$fr = $e9e439c110f17033$var$_({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $e9e439c110f17033$var$vr = $e9e439c110f17033$var$_({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $e9e439c110f17033$var$_r = $e9e439c110f17033$var$_({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $e9e439c110f17033$var$Er = Object.freeze({
    __proto__: null,
    base64: $e9e439c110f17033$var$br,
    base64pad: $e9e439c110f17033$var$fr,
    base64url: $e9e439c110f17033$var$vr,
    base64urlpad: $e9e439c110f17033$var$_r
});
const $e9e439c110f17033$var$Nt = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $e9e439c110f17033$var$wr = $e9e439c110f17033$var$Nt.reduce((o, e, t)=>(o[t] = e, o), []), $e9e439c110f17033$var$Ir = $e9e439c110f17033$var$Nt.reduce((o, e, t)=>(o[e.codePointAt(0)] = t, o), []);
function $e9e439c110f17033$var$Tr(o) {
    return o.reduce((e, t)=>(e += $e9e439c110f17033$var$wr[t], e), "");
}
function $e9e439c110f17033$var$Cr(o) {
    const e = [];
    for (const t of o){
        const s = $e9e439c110f17033$var$Ir[t.codePointAt(0)];
        if (s === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(s);
    }
    return new Uint8Array(e);
}
const $e9e439c110f17033$var$Pr = $e9e439c110f17033$var$ne({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $e9e439c110f17033$var$Tr,
    decode: $e9e439c110f17033$var$Cr
});
var $e9e439c110f17033$var$Sr = Object.freeze({
    __proto__: null,
    base256emoji: $e9e439c110f17033$var$Pr
}), $e9e439c110f17033$var$Rr = $e9e439c110f17033$var$Lt, $e9e439c110f17033$var$zt = 128, $e9e439c110f17033$var$xr = 127, $e9e439c110f17033$var$Or = ~$e9e439c110f17033$var$xr, $e9e439c110f17033$var$Ar = Math.pow(2, 31);
function $e9e439c110f17033$var$Lt(o, e, t) {
    e = e || [], t = t || 0;
    for(var s = t; o >= $e9e439c110f17033$var$Ar;)e[t++] = o & 255 | $e9e439c110f17033$var$zt, o /= 128;
    for(; o & $e9e439c110f17033$var$Or;)e[t++] = o & 255 | $e9e439c110f17033$var$zt, o >>>= 7;
    return e[t] = o | 0, $e9e439c110f17033$var$Lt.bytes = t - s + 1, e;
}
var $e9e439c110f17033$var$Nr = $e9e439c110f17033$var$_e, $e9e439c110f17033$var$zr = 128, $e9e439c110f17033$var$$t = 127;
function $e9e439c110f17033$var$_e(o, s) {
    var t = 0, s = s || 0, i = 0, r = s, n, a = o.length;
    do {
        if (r >= a) throw $e9e439c110f17033$var$_e.bytes = 0, new RangeError("Could not decode varint");
        n = o[r++], t += i < 28 ? (n & $e9e439c110f17033$var$$t) << i : (n & $e9e439c110f17033$var$$t) * Math.pow(2, i), i += 7;
    }while (n >= $e9e439c110f17033$var$zr);
    return $e9e439c110f17033$var$_e.bytes = r - s, t;
}
var $e9e439c110f17033$var$Lr = Math.pow(2, 7), $e9e439c110f17033$var$$r = Math.pow(2, 14), $e9e439c110f17033$var$kr = Math.pow(2, 21), $e9e439c110f17033$var$Ur = Math.pow(2, 28), $e9e439c110f17033$var$Fr = Math.pow(2, 35), $e9e439c110f17033$var$Mr = Math.pow(2, 42), $e9e439c110f17033$var$Kr = Math.pow(2, 49), $e9e439c110f17033$var$Br = Math.pow(2, 56), $e9e439c110f17033$var$Vr = Math.pow(2, 63), $e9e439c110f17033$var$jr = function(o) {
    return o < $e9e439c110f17033$var$Lr ? 1 : o < $e9e439c110f17033$var$$r ? 2 : o < $e9e439c110f17033$var$kr ? 3 : o < $e9e439c110f17033$var$Ur ? 4 : o < $e9e439c110f17033$var$Fr ? 5 : o < $e9e439c110f17033$var$Mr ? 6 : o < $e9e439c110f17033$var$Kr ? 7 : o < $e9e439c110f17033$var$Br ? 8 : o < $e9e439c110f17033$var$Vr ? 9 : 10;
}, $e9e439c110f17033$var$qr = {
    encode: $e9e439c110f17033$var$Rr,
    decode: $e9e439c110f17033$var$Nr,
    encodingLength: $e9e439c110f17033$var$jr
}, $e9e439c110f17033$var$kt = $e9e439c110f17033$var$qr;
const $e9e439c110f17033$var$Ut = (o, e, t = 0)=>($e9e439c110f17033$var$kt.encode(o, e, t), e), $e9e439c110f17033$var$Ft = (o)=>$e9e439c110f17033$var$kt.encodingLength(o), $e9e439c110f17033$var$Ee = (o, e)=>{
    const t = e.byteLength, s = $e9e439c110f17033$var$Ft(o), i = s + $e9e439c110f17033$var$Ft(t), r = new Uint8Array(i + t);
    return $e9e439c110f17033$var$Ut(o, r, 0), $e9e439c110f17033$var$Ut(t, r, s), r.set(e, i), new $e9e439c110f17033$var$Gr(o, t, e, r);
};
class $e9e439c110f17033$var$Gr {
    constructor(e, t, s, i){
        this.code = e, this.size = t, this.digest = s, this.bytes = i;
    }
}
const $e9e439c110f17033$var$Mt = ({ name: o, code: e, encode: t })=>new $e9e439c110f17033$var$Hr(o, e, t);
class $e9e439c110f17033$var$Hr {
    constructor(e, t, s){
        this.name = e, this.code = t, this.encode = s;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $e9e439c110f17033$var$Ee(this.code, t) : t.then((s)=>$e9e439c110f17033$var$Ee(this.code, s));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $e9e439c110f17033$var$Kt = (o)=>async (e)=>new Uint8Array(await crypto.subtle.digest(o, e)), $e9e439c110f17033$var$Yr = $e9e439c110f17033$var$Mt({
    name: "sha2-256",
    code: 18,
    encode: $e9e439c110f17033$var$Kt("SHA-256")
}), $e9e439c110f17033$var$Jr = $e9e439c110f17033$var$Mt({
    name: "sha2-512",
    code: 19,
    encode: $e9e439c110f17033$var$Kt("SHA-512")
});
var $e9e439c110f17033$var$Xr = Object.freeze({
    __proto__: null,
    sha256: $e9e439c110f17033$var$Yr,
    sha512: $e9e439c110f17033$var$Jr
});
const $e9e439c110f17033$var$Bt = 0, $e9e439c110f17033$var$Wr = "identity", $e9e439c110f17033$var$Vt = $e9e439c110f17033$var$Ot, $e9e439c110f17033$var$Zr = (o)=>$e9e439c110f17033$var$Ee($e9e439c110f17033$var$Bt, $e9e439c110f17033$var$Vt(o)), $e9e439c110f17033$var$Qr = {
    code: $e9e439c110f17033$var$Bt,
    name: $e9e439c110f17033$var$Wr,
    encode: $e9e439c110f17033$var$Vt,
    digest: $e9e439c110f17033$var$Zr
};
var $e9e439c110f17033$var$en = Object.freeze({
    __proto__: null,
    identity: $e9e439c110f17033$var$Qr
});
new TextEncoder, new TextDecoder;
const $e9e439c110f17033$var$jt = {
    ...$e9e439c110f17033$var$Gs,
    ...$e9e439c110f17033$var$Ys,
    ...$e9e439c110f17033$var$Xs,
    ...$e9e439c110f17033$var$Zs,
    ...$e9e439c110f17033$var$tr,
    ...$e9e439c110f17033$var$ur,
    ...$e9e439c110f17033$var$gr,
    ...$e9e439c110f17033$var$mr,
    ...$e9e439c110f17033$var$Er,
    ...$e9e439c110f17033$var$Sr
};
({
    ...$e9e439c110f17033$var$Xr,
    ...$e9e439c110f17033$var$en
});
function $e9e439c110f17033$var$tn(o = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? globalThis.Buffer.allocUnsafe(o) : new Uint8Array(o);
}
function $e9e439c110f17033$var$qt(o, e, t, s) {
    return {
        name: o,
        prefix: e,
        encoder: {
            name: o,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: s
        }
    };
}
const $e9e439c110f17033$var$Gt = $e9e439c110f17033$var$qt("utf8", "u", (o)=>"u" + new TextDecoder("utf8").decode(o), (o)=>new TextEncoder().encode(o.substring(1))), $e9e439c110f17033$var$we = $e9e439c110f17033$var$qt("ascii", "a", (o)=>{
    let e = "a";
    for(let t = 0; t < o.length; t++)e += String.fromCharCode(o[t]);
    return e;
}, (o)=>{
    o = o.substring(1);
    const e = $e9e439c110f17033$var$tn(o.length);
    for(let t = 0; t < o.length; t++)e[t] = o.charCodeAt(t);
    return e;
}), $e9e439c110f17033$var$sn = {
    utf8: $e9e439c110f17033$var$Gt,
    "utf-8": $e9e439c110f17033$var$Gt,
    hex: $e9e439c110f17033$var$jt.base16,
    latin1: $e9e439c110f17033$var$we,
    ascii: $e9e439c110f17033$var$we,
    binary: $e9e439c110f17033$var$we,
    ...$e9e439c110f17033$var$jt
};
function $e9e439c110f17033$var$rn(o, e = "utf8") {
    const t = $e9e439c110f17033$var$sn[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(o, "utf8") : t.decoder.decode(`${t.prefix}${o}`);
}
class $e9e439c110f17033$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.keychain = new Map, this.name = $e9e439c110f17033$export$9d7218f72e8dc49b, this.version = $e9e439c110f17033$export$34f82f4ba0c3d769, this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                const s = await this.getKeyChain();
                typeof s < "u" && (this.keychain = s), this.initialized = !0;
            }
        }, this.has = (s)=>(this.isInitialized(), this.keychain.has(s)), this.set = async (s, i)=>{
            this.isInitialized(), this.keychain.set(s, i), await this.persist();
        }, this.get = (s)=>{
            this.isInitialized();
            const i = this.keychain.get(s);
            if (typeof i > "u") {
                const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${s}`);
                throw new Error(r);
            }
            return i;
        }, this.del = async (s)=>{
            this.isInitialized(), this.keychain.delete(s), await this.persist();
        }, this.core = e, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(t, this.name);
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $a5d33cfc7f8e5437$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$8ac8b6291b7ccf24 {
    constructor(e, t, s){
        this.core = e, this.logger = t, this.name = $e9e439c110f17033$export$92a79f21481c803d, this.randomSessionIdentifier = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), this.initialized = !1, this.init = async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }, this.hasKeys = (i)=>(this.isInitialized(), this.keychain.has(i)), this.getClientId = async ()=>{
            this.isInitialized();
            const i = await this.getClientSeed(), r = $88cd1e73c7abe0b8$export$a949d36eab55b41f(i);
            return $88cd1e73c7abe0b8$export$1b29ef9371459e10(r.publicKey);
        }, this.generateKeyPair = ()=>{
            this.isInitialized();
            const i = (0, $a5d33cfc7f8e5437$export$a949d36eab55b41f)();
            return this.setPrivateKey(i.publicKey, i.privateKey);
        }, this.signJWT = async (i)=>{
            this.isInitialized();
            const r = await this.getClientSeed(), n = $88cd1e73c7abe0b8$export$a949d36eab55b41f(r), a = this.randomSessionIdentifier, c = $e9e439c110f17033$export$c4bc5e31a4d0ec78;
            return await $88cd1e73c7abe0b8$export$a8dda30659d36d45(a, i, c, n);
        }, this.generateSharedKey = (i, r, n)=>{
            this.isInitialized();
            const a = this.getPrivateKey(i), c = (0, $a5d33cfc7f8e5437$export$f8378f68e053f5c6)(a, r);
            return this.setSymKey(c, n);
        }, this.setSymKey = async (i, r)=>{
            this.isInitialized();
            const n = r || (0, $a5d33cfc7f8e5437$export$1e87d19d4aab5805)(i);
            return await this.keychain.set(n, i), n;
        }, this.deleteKeyPair = async (i)=>{
            this.isInitialized(), await this.keychain.del(i);
        }, this.deleteSymKey = async (i)=>{
            this.isInitialized(), await this.keychain.del(i);
        }, this.encode = async (i, r, n)=>{
            this.isInitialized();
            const a = (0, $a5d33cfc7f8e5437$export$7949f60f2444aef2)(n), c = (0, $81c2e06d24b89184$export$abc3f407e87918a4)(r);
            if ((0, $a5d33cfc7f8e5437$export$599538f59a4a14c3)(a)) return (0, $a5d33cfc7f8e5437$export$99abb28d1c4baa95)(c, n?.encoding);
            if ((0, $a5d33cfc7f8e5437$export$8c165704db2d5c15)(a)) {
                const y = a.senderPublicKey, m = a.receiverPublicKey;
                i = await this.generateSharedKey(y, m);
            }
            const h = this.getSymKey(i), { type: u, senderPublicKey: d } = a;
            return (0, $a5d33cfc7f8e5437$export$5b0f6292f11d1d18)({
                type: u,
                symKey: h,
                message: c,
                senderPublicKey: d,
                encoding: n?.encoding
            });
        }, this.decode = async (i, r, n)=>{
            this.isInitialized();
            const a = (0, $a5d33cfc7f8e5437$export$177f3e316562333d)(r, n);
            if ((0, $a5d33cfc7f8e5437$export$599538f59a4a14c3)(a)) {
                const c = (0, $a5d33cfc7f8e5437$export$6b54347426d28ee3)(r, n?.encoding);
                return (0, $81c2e06d24b89184$export$84137bb44359aed5)(c);
            }
            if ((0, $a5d33cfc7f8e5437$export$8c165704db2d5c15)(a)) {
                const c = a.receiverPublicKey, h = a.senderPublicKey;
                i = await this.generateSharedKey(c, h);
            }
            try {
                const c = this.getSymKey(i), h = (0, $a5d33cfc7f8e5437$export$e85a0c9a1067c5d3)({
                    symKey: c,
                    encoded: r,
                    encoding: n?.encoding
                });
                return (0, $81c2e06d24b89184$export$84137bb44359aed5)(h);
            } catch (c) {
                this.logger.error(`Failed to decode message from topic: '${i}', clientId: '${await this.getClientId()}'`), this.logger.error(c);
            }
        }, this.getPayloadType = (i, r = (0, $a5d33cfc7f8e5437$export$9bff723d552e6bcf))=>{
            const n = (0, $a5d33cfc7f8e5437$export$efcd34ab6248d3cd)({
                encoded: i,
                encoding: r
            });
            return (0, $a5d33cfc7f8e5437$export$7547a514ee29b9d4)(n.type);
        }, this.getPayloadSenderPublicKey = (i, r = (0, $a5d33cfc7f8e5437$export$9bff723d552e6bcf))=>{
            const n = (0, $a5d33cfc7f8e5437$export$efcd34ab6248d3cd)({
                encoded: i,
                encoding: r
            });
            return n.senderPublicKey ? (0, $74e9859baf4497ef$exports.toString)(n.senderPublicKey, (0, $a5d33cfc7f8e5437$export$49eb910ab2518105)) : void 0;
        }, this.core = e, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(t, this.name), this.keychain = s || new $e9e439c110f17033$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($e9e439c110f17033$export$3613aa6e652146e4);
        } catch  {
            e = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), await this.keychain.set($e9e439c110f17033$export$3613aa6e652146e4, e);
        }
        return $e9e439c110f17033$var$rn(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$4a2542d0790ac2fd extends (0, $bace94c1ef08d1bc$export$e67570fe0a885c47) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, this.messages = new Map, this.name = $e9e439c110f17033$export$9662bbc7d10cf481, this.version = $e9e439c110f17033$export$19dfd1896412c038, this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const s = await this.getRelayerMessages();
                    typeof s < "u" && (this.messages = s), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (s) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(s);
                } finally{
                    this.initialized = !0;
                }
            }
        }, this.set = async (s, i)=>{
            this.isInitialized();
            const r = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(i);
            let n = this.messages.get(s);
            return typeof n > "u" && (n = {}), typeof n[r] < "u" || (n[r] = i, this.messages.set(s, n), await this.persist()), r;
        }, this.get = (s)=>{
            this.isInitialized();
            let i = this.messages.get(s);
            return typeof i > "u" && (i = {}), i;
        }, this.has = (s, i)=>{
            this.isInitialized();
            const r = this.get(s), n = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(i);
            return typeof r[n] < "u";
        }, this.del = async (s)=>{
            this.isInitialized(), this.messages.delete(s), await this.persist();
        }, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $a5d33cfc7f8e5437$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $e9e439c110f17033$var$nn = Object.defineProperty, $e9e439c110f17033$var$on = Object.defineProperties, $e9e439c110f17033$var$an = Object.getOwnPropertyDescriptors, $e9e439c110f17033$var$Xt = Object.getOwnPropertySymbols, $e9e439c110f17033$var$cn = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$hn = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Wt = (o, e, t)=>e in o ? $e9e439c110f17033$var$nn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $e9e439c110f17033$var$Zt = (o, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$cn.call(e, t) && $e9e439c110f17033$var$Wt(o, t, e[t]);
    if ($e9e439c110f17033$var$Xt) for (var t of $e9e439c110f17033$var$Xt(e))$e9e439c110f17033$var$hn.call(e, t) && $e9e439c110f17033$var$Wt(o, t, e[t]);
    return o;
}, $e9e439c110f17033$var$Qt = (o, e)=>$e9e439c110f17033$var$on(o, $e9e439c110f17033$var$an(e));
class $e9e439c110f17033$var$ln extends (0, $bace94c1ef08d1bc$export$3b0872bbd7e675a2) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$9d92662178f2abd1, this.queue = new Map, this.publishTimeout = (0, $7c6109395b060f04$exports.toMiliseconds)((0, $7c6109395b060f04$exports.ONE_MINUTE)), this.initialPublishTimeout = (0, $7c6109395b060f04$exports.toMiliseconds)((0, $7c6109395b060f04$exports.ONE_SECOND) * 15), this.needsTransportRestart = !1, this.publish = async (s, i, r)=>{
            var n;
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: s,
                    message: i,
                    opts: r
                }
            });
            const a = r?.ttl || $e9e439c110f17033$export$8ddbe6611b67d926, c = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(r), h = r?.prompt || !1, u = r?.tag || 0, d = r?.id || (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString(), y = {
                topic: s,
                message: i,
                opts: {
                    ttl: a,
                    relay: c,
                    prompt: h,
                    tag: u,
                    id: d,
                    attestation: r?.attestation
                }
            }, m = `Failed to publish payload, please try again. id:${d} tag:${u}`;
            try {
                const l = new Promise(async (g)=>{
                    const w = ({ id: D })=>{
                        y.opts.id === D && (this.removeRequestFromQueue(D), this.relayer.events.removeListener($e9e439c110f17033$export$d56245796e2837d.publish, w), g(y));
                    };
                    this.relayer.events.on($e9e439c110f17033$export$d56245796e2837d.publish, w);
                    const b = (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(new Promise((D, P)=>{
                        this.rpcPublish({
                            topic: s,
                            message: i,
                            ttl: a,
                            prompt: h,
                            tag: u,
                            id: d,
                            attestation: r?.attestation
                        }).then(D).catch((f)=>{
                            this.logger.warn(f, f?.message), P(f);
                        });
                    }), this.initialPublishTimeout, `Failed initial publish, retrying.... id:${d} tag:${u}`);
                    try {
                        await b, this.events.removeListener($e9e439c110f17033$export$d56245796e2837d.publish, w);
                    } catch (D) {
                        this.queue.set(d, $e9e439c110f17033$var$Qt($e9e439c110f17033$var$Zt({}, y), {
                            attempt: 1
                        })), this.logger.warn(D, D?.message);
                    }
                });
                this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        id: d,
                        topic: s,
                        message: i,
                        opts: r
                    }
                }), await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(l, this.publishTimeout, m);
            } catch (l) {
                if (this.logger.debug("Failed to Publish Payload"), this.logger.error(l), (n = r?.internal) != null && n.throwOnFailedPublish) throw l;
            } finally{
                this.queue.delete(d);
            }
        }, this.on = (s, i)=>{
            this.events.on(s, i);
        }, this.once = (s, i)=>{
            this.events.once(s, i);
        }, this.off = (s, i)=>{
            this.events.off(s, i);
        }, this.removeListener = (s, i)=>{
            this.events.removeListener(s, i);
        }, this.relayer = e, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    async rpcPublish(e) {
        var t, s, i, r;
        const { topic: n, message: a, ttl: c = $e9e439c110f17033$export$8ddbe6611b67d926, prompt: h, tag: u, id: d, attestation: y } = e, m = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)((0, $a5d33cfc7f8e5437$export$cf77af25151525db)().protocol).publish,
            params: {
                topic: n,
                message: a,
                ttl: c,
                prompt: h,
                tag: u,
                attestation: y
            },
            id: d
        };
        (0, $a5d33cfc7f8e5437$export$fce6876652108ab)((t = m.params) == null ? void 0 : t.prompt) && ((s = m.params) == null || delete s.prompt), (0, $a5d33cfc7f8e5437$export$fce6876652108ab)((i = m.params) == null ? void 0 : i.tag) && ((r = m.params) == null || delete r.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: m
        });
        const l = await this.relayer.request(m);
        return this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.publish, e), this.logger.debug("Successfully Published Payload"), l;
    }
    removeRequestFromQueue(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e, t)=>{
            const s = e.attempt + 1;
            this.queue.set(t, $e9e439c110f17033$var$Qt($e9e439c110f17033$var$Zt({}, e), {
                attempt: s
            }));
            const { topic: i, message: r, opts: n, attestation: a } = e;
            this.logger.warn({}, `Publisher: queue->publishing: ${e.opts.id}, tag: ${e.opts.tag}, attempt: ${s}`), await this.rpcPublish({
                topic: i,
                message: r,
                ttl: n.ttl,
                prompt: n.prompt,
                tag: n.tag,
                id: n.id,
                attestation: a
            }), this.logger.warn({}, `Publisher: queue->published: ${e.opts.id}`);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $1b66579f2b4dad8b$export$f3340c1af6bee4b5).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($e9e439c110f17033$export$d56245796e2837d.message_ack, (e)=>{
            this.removeRequestFromQueue(e.id.toString());
        });
    }
}
class $e9e439c110f17033$var$un {
    constructor(){
        this.map = new Map, this.set = (e, t)=>{
            const s = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...s,
                t
            ]);
        }, this.get = (e)=>this.map.get(e) || [], this.exists = (e, t)=>this.get(e).includes(t), this.delete = (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const s = this.get(e);
            if (!this.exists(e, t)) return;
            const i = s.filter((r)=>r !== t);
            if (!i.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, i);
        }, this.clear = ()=>{
            this.map.clear();
        };
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $e9e439c110f17033$var$dn = Object.defineProperty, $e9e439c110f17033$var$pn = Object.defineProperties, $e9e439c110f17033$var$gn = Object.getOwnPropertyDescriptors, $e9e439c110f17033$var$ei = Object.getOwnPropertySymbols, $e9e439c110f17033$var$yn = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Dn = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$ti = (o, e, t)=>e in o ? $e9e439c110f17033$var$dn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $e9e439c110f17033$var$Z = (o, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$yn.call(e, t) && $e9e439c110f17033$var$ti(o, t, e[t]);
    if ($e9e439c110f17033$var$ei) for (var t of $e9e439c110f17033$var$ei(e))$e9e439c110f17033$var$Dn.call(e, t) && $e9e439c110f17033$var$ti(o, t, e[t]);
    return o;
}, $e9e439c110f17033$var$Ie = (o, e)=>$e9e439c110f17033$var$pn(o, $e9e439c110f17033$var$gn(e));
class $e9e439c110f17033$export$60959659b2c22881 extends (0, $bace94c1ef08d1bc$export$300eed987e764b57) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.subscriptions = new Map, this.topicMap = new $e9e439c110f17033$var$un, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$9c3a96bb670cddb8, this.version = $e9e439c110f17033$export$fb57e03bef4c4cea, this.pending = new Map, this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.subscribeTimeout = (0, $7c6109395b060f04$exports.toMiliseconds)((0, $7c6109395b060f04$exports.ONE_MINUTE)), this.initialSubscribeTimeout = (0, $7c6109395b060f04$exports.toMiliseconds)((0, $7c6109395b060f04$exports.ONE_SECOND) * 15), this.batchSubscribeTopicsLimit = 500, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId(), await this.restore()), this.initialized = !0;
        }, this.subscribe = async (s, i)=>{
            this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: s,
                    opts: i
                }
            });
            try {
                const r = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(i), n = {
                    topic: s,
                    relay: r,
                    transportType: i?.transportType
                };
                this.pending.set(s, n);
                const a = await this.rpcSubscribe(s, r, i);
                return typeof a == "string" && (this.onSubscribe(a, n), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: s,
                        opts: i
                    }
                })), a;
            } catch (r) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(r), r;
            }
        }, this.unsubscribe = async (s, i)=>{
            await this.restartToComplete(), this.isInitialized(), typeof i?.id < "u" ? await this.unsubscribeById(s, i.id, i) : await this.unsubscribeByTopic(s, i);
        }, this.isSubscribed = async (s)=>{
            if (this.topics.includes(s)) return !0;
            const i = `${this.pendingSubscriptionWatchLabel}_${s}`;
            return await new Promise((r, n)=>{
                const a = new (0, $7c6109395b060f04$exports.Watch);
                a.start(i);
                const c = setInterval(()=>{
                    (!this.pending.has(s) && this.topics.includes(s) || this.cached.some((h)=>h.topic === s)) && (clearInterval(c), a.stop(i), r(!0)), a.elapsed(i) >= $e9e439c110f17033$export$9a2ddbfe54f8af77 && (clearInterval(c), a.stop(i), n(new Error("Subscription resolution timeout")));
                }, this.pollingInterval);
            }).catch(()=>!1);
        }, this.on = (s, i)=>{
            this.events.on(s, i);
        }, this.once = (s, i)=>{
            this.events.once(s, i);
        }, this.off = (s, i)=>{
            this.events.off(s, i);
        }, this.removeListener = (s, i)=>{
            this.events.removeListener(s, i);
        }, this.start = async ()=>{
            await this.onConnect();
        }, this.stop = async ()=>{
            await this.onDisconnect();
        }, this.restart = async ()=>{
            await this.restore(), await this.onRestart();
        }, this.checkPending = async ()=>{
            if (this.pending.size === 0 && (!this.initialized || !this.relayer.connected)) return;
            const s = [];
            this.pending.forEach((i)=>{
                s.push(i);
            }), await this.batchSubscribe(s);
        }, this.registerEventListeners = ()=>{
            this.relayer.core.heartbeat.on((0, $1b66579f2b4dad8b$export$f3340c1af6bee4b5).pulse, async ()=>{
                await this.checkPending();
            }), this.events.on($e9e439c110f17033$export$24ff3e54e94ef413.created, async (s)=>{
                const i = $e9e439c110f17033$export$24ff3e54e94ef413.created;
                this.logger.info(`Emitting ${i}`), this.logger.debug({
                    type: "event",
                    event: i,
                    data: s
                }), await this.persist();
            }), this.events.on($e9e439c110f17033$export$24ff3e54e94ef413.deleted, async (s)=>{
                const i = $e9e439c110f17033$export$24ff3e54e94ef413.deleted;
                this.logger.info(`Emitting ${i}`), this.logger.debug({
                    type: "event",
                    event: i,
                    data: s
                }), await this.persist();
            });
        }, this.relayer = e, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    hasSubscription(e, t) {
        let s = !1;
        try {
            s = this.getSubscription(e).topic === t;
        } catch  {}
        return s;
    }
    reset() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const s = this.topicMap.get(e);
        await Promise.all(s.map(async (i)=>await this.unsubscribeById(e, i, t)));
    }
    async unsubscribeById(e, t, s) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: s
            }
        });
        try {
            const i = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(s);
            await this.rpcUnsubscribe(e, t, i);
            const r = (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, r), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: s
                }
            });
        } catch (i) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(i), i;
        }
    }
    async rpcSubscribe(e, t, s) {
        var i;
        s?.transportType === $e9e439c110f17033$export$326e296bb8673773.relay && await this.restartToComplete();
        const r = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: r
        });
        const n = (i = s?.internal) == null ? void 0 : i.throwOnFailedPublish;
        try {
            const a = this.getSubscriptionId(e);
            if (s?.transportType === $e9e439c110f17033$export$326e296bb8673773.link_mode) return setTimeout(()=>{
                (this.relayer.connected || this.relayer.connecting) && this.relayer.request(r).catch((u)=>this.logger.warn(u));
            }, (0, $7c6109395b060f04$exports.toMiliseconds)((0, $7c6109395b060f04$exports.ONE_SECOND))), a;
            const c = new Promise(async (u)=>{
                const d = (y)=>{
                    y.topic === e && (this.events.removeListener($e9e439c110f17033$export$24ff3e54e94ef413.created, d), u(y.id));
                };
                this.events.on($e9e439c110f17033$export$24ff3e54e94ef413.created, d);
                try {
                    const y = await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(new Promise((m, l)=>{
                        this.relayer.request(r).catch((g)=>{
                            this.logger.warn(g, g?.message), l(g);
                        }).then(m);
                    }), this.initialSubscribeTimeout, `Subscribing to ${e} failed, please try again`);
                    this.events.removeListener($e9e439c110f17033$export$24ff3e54e94ef413.created, d), u(y);
                } catch  {}
            }), h = await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(c, this.subscribeTimeout, `Subscribing to ${e} failed, please try again`);
            if (!h && n) throw new Error(`Subscribing to ${e} failed, please try again`);
            return h ? a : null;
        } catch (a) {
            if (this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled), n) throw a;
        }
        return null;
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, s = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((i)=>i.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        });
        try {
            await await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(new Promise((i)=>{
                this.relayer.request(s).catch((r)=>this.logger.warn(r)).then(i);
            }), this.subscribeTimeout, "rpcBatchSubscribe failed, please try again");
        } catch  {
            this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
        }
    }
    async rpcBatchFetchMessages(e) {
        if (!e.length) return;
        const t = e[0].relay, s = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(t.protocol).batchFetchMessages,
            params: {
                topics: e.map((r)=>r.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        });
        let i;
        try {
            i = await await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(new Promise((r, n)=>{
                this.relayer.request(s).catch((a)=>{
                    this.logger.warn(a), n(a);
                }).then(r);
            }), this.subscribeTimeout, "rpcBatchFetchMessages failed, please try again");
        } catch  {
            this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
        }
        return i;
    }
    rpcUnsubscribe(e, t, s) {
        const i = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(s.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        }), this.relayer.request(i);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $e9e439c110f17033$var$Ie($e9e439c110f17033$var$Z({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $e9e439c110f17033$var$Z({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, s) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, s), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t);
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $e9e439c110f17033$var$Z({}, t)), this.topicMap.set(t.topic, e), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(s);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const s = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(s.topic, e), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.deleted, $e9e439c110f17033$var$Ie($e9e439c110f17033$var$Z({}, s), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.sync);
    }
    async onRestart() {
        if (this.cached.length) {
            const e = [
                ...this.cached
            ], t = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let s = 0; s < t; s++){
                const i = e.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchSubscribe(i);
            }
        }
        this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        e.length && (await this.rpcBatchSubscribe(e), this.onBatchSubscribe(e.map((t)=>$e9e439c110f17033$var$Ie($e9e439c110f17033$var$Z({}, t), {
                id: this.getSubscriptionId(t.topic)
            }))));
    }
    async batchFetchMessages(e) {
        if (!e.length) return;
        this.logger.trace(`Fetching batch messages for ${e.length} subscriptions`);
        const t = await this.rpcBatchFetchMessages(e);
        t && t.messages && (await (0, $a5d33cfc7f8e5437$export$e772c8ff12451969)((0, $7c6109395b060f04$exports.toMiliseconds)((0, $7c6109395b060f04$exports.ONE_SECOND))), await this.relayer.handleBatchMessageEvents(t.messages));
    }
    async onConnect() {
        await this.restart(), this.reset();
    }
    onDisconnect() {
        this.onDisable();
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete() {
        !this.relayer.connected && !this.relayer.connecting && await this.relayer.transportOpen();
    }
    getSubscriptionId(e) {
        return (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(e + this.clientId);
    }
}
var $e9e439c110f17033$var$mn = Object.defineProperty, $e9e439c110f17033$var$si = Object.getOwnPropertySymbols, $e9e439c110f17033$var$bn = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$fn = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$ri = (o, e, t)=>e in o ? $e9e439c110f17033$var$mn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $e9e439c110f17033$var$ni = (o, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$bn.call(e, t) && $e9e439c110f17033$var$ri(o, t, e[t]);
    if ($e9e439c110f17033$var$si) for (var t of $e9e439c110f17033$var$si(e))$e9e439c110f17033$var$fn.call(e, t) && $e9e439c110f17033$var$ri(o, t, e[t]);
    return o;
};
class $e9e439c110f17033$export$70e73aa29a3d4407 extends (0, $bace94c1ef08d1bc$export$9a0f755fd4f79434) {
    constructor(e){
        super(e), this.protocol = "wc", this.version = 2, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$602d6e27611c3fcb, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.hasExperiencedNetworkDisruption = !1, this.heartBeatTimeout = (0, $7c6109395b060f04$exports.toMiliseconds)((0, $7c6109395b060f04$exports.THIRTY_SECONDS) + (0, $7c6109395b060f04$exports.FIVE_SECONDS)), this.requestsInFlight = [], this.connectTimeout = (0, $7c6109395b060f04$exports.toMiliseconds)((0, $7c6109395b060f04$exports.ONE_SECOND) * 15), this.request = async (t)=>{
            var s, i;
            this.logger.debug("Publishing Request Payload");
            const r = t.id || (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString();
            await this.toEstablishConnection();
            try {
                this.logger.trace({
                    id: r,
                    method: t.method,
                    topic: (s = t.params) == null ? void 0 : s.topic
                }, "relayer.request - publishing...");
                const n = `${r}:${((i = t.params) == null ? void 0 : i.tag) || ""}`;
                this.requestsInFlight.push(n);
                const a = await this.provider.request(t);
                return this.requestsInFlight = this.requestsInFlight.filter((c)=>c !== n), a;
            } catch (n) {
                throw this.logger.debug(`Failed to Publish Request: ${r}`), n;
            }
        }, this.resetPingTimeout = ()=>{
            if ((0, $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee)()) try {
                clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(()=>{
                    var t, s, i;
                    this.logger.debug({}, "pingTimeout: Connection stalled, terminating..."), (i = (s = (t = this.provider) == null ? void 0 : t.connection) == null ? void 0 : s.socket) == null || i.terminate();
                }, this.heartBeatTimeout);
            } catch (t) {
                this.logger.warn(t, t?.message);
            }
        }, this.onPayloadHandler = (t)=>{
            this.onProviderPayload(t), this.resetPingTimeout();
        }, this.onConnectHandler = ()=>{
            this.logger.warn({}, "Relayer connected \uD83D\uDEDC"), this.startPingTimeout(), this.events.emit($e9e439c110f17033$export$d56245796e2837d.connect);
        }, this.onDisconnectHandler = ()=>{
            this.logger.warn({}, "Relayer disconnected \uD83D\uDED1"), this.requestsInFlight = [], this.onProviderDisconnect();
        }, this.onProviderErrorHandler = (t)=>{
            this.logger.fatal(t, `Fatal socket error: ${t?.message}`), this.events.emit($e9e439c110f17033$export$d56245796e2837d.error, t), this.logger.fatal("Fatal socket error received, closing transport"), this.transportClose();
        }, this.registerProviderListeners = ()=>{
            this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
        }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $704ed3be9612b960$export$4929e0372308a636)(e.logger, this.name) : (0, (/*@__PURE__*/$parcel$interopDefault($03ceb28a240053b3$exports)))((0, $704ed3be9612b960$export$bad2475df51c8ecc)({
            level: e.logger || $e9e439c110f17033$export$5176ffa6778d6637
        })), this.messages = new $e9e439c110f17033$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $e9e439c110f17033$export$60959659b2c22881(this, this.logger), this.publisher = new $e9e439c110f17033$var$ln(this, this.logger), this.relayUrl = e?.relayUrl || $e9e439c110f17033$export$a68061e6c48f332a, this.projectId = e.projectId, (0, $a5d33cfc7f8e5437$export$a11b0059900ceec8)() ? this.packageName = (0, $a5d33cfc7f8e5437$export$fb2283f4a44fb53)() : (0, $a5d33cfc7f8e5437$export$41a665f744414057)() && (this.bundleId = (0, $a5d33cfc7f8e5437$export$fb2283f4a44fb53)()), this.provider = {};
    }
    async init() {
        if (this.logger.trace("Initialized"), this.registerEventListeners(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]), this.initialized = !0, this.subscriber.cached.length > 0) try {
            await this.transportOpen();
        } catch (e) {
            this.logger.warn(e, e?.message);
        }
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    get connected() {
        var e, t, s;
        return ((s = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : s.readyState) === 1;
    }
    get connecting() {
        var e, t, s;
        return ((s = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : s.readyState) === 0;
    }
    async publish(e, t, s) {
        this.isInitialized(), await this.publisher.publish(e, t, s), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now(),
            transportType: $e9e439c110f17033$export$326e296bb8673773.relay
        });
    }
    async subscribe(e, t) {
        var s, i, r;
        this.isInitialized(), (!(t != null && t.transportType) || t?.transportType === "relay") && await this.toEstablishConnection();
        const n = typeof ((s = t?.internal) == null ? void 0 : s.throwOnFailedPublish) > "u" ? !0 : (i = t?.internal) == null ? void 0 : i.throwOnFailedPublish;
        let a = ((r = this.subscriber.topicMap.get(e)) == null ? void 0 : r[0]) || "", c;
        const h = (u)=>{
            u.topic === e && (this.subscriber.off($e9e439c110f17033$export$24ff3e54e94ef413.created, h), c());
        };
        return await Promise.all([
            new Promise((u)=>{
                c = u, this.subscriber.on($e9e439c110f17033$export$24ff3e54e94ef413.created, h);
            }),
            new Promise(async (u, d)=>{
                a = await this.subscriber.subscribe(e, $e9e439c110f17033$var$ni({
                    internal: {
                        throwOnFailedPublish: n
                    }
                }, t)).catch((y)=>{
                    n && d(y);
                }) || a, u();
            })
        ]), a;
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportDisconnect() {
        this.provider.disconnect && (this.hasExperiencedNetworkDisruption || this.connected) ? await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.provider.disconnect(), 2e3, "provider.disconnect()").catch(()=>this.onProviderDisconnect()) : this.onProviderDisconnect();
    }
    async transportClose() {
        this.transportExplicitlyClosed = !0, await this.transportDisconnect();
    }
    async transportOpen(e) {
        if (this.connectPromise ? (this.logger.debug({}, "Waiting for existing connection attempt to resolve..."), await this.connectPromise, this.logger.debug({}, "Existing connection attempt resolved")) : (this.connectPromise = new Promise(async (t, s)=>{
            await this.connect(e).then(t).catch(s).finally(()=>{
                this.connectPromise = void 0;
            });
        }), await this.connectPromise), !this.connected) throw new Error(`Couldn't establish socket connection to the relay server: ${this.relayUrl}`);
    }
    async restartTransport(e) {
        this.logger.debug({}, "Restarting transport..."), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.confirmOnlineStateOrThrow(), await this.transportClose(), await this.transportOpen());
    }
    async confirmOnlineStateOrThrow() {
        if (!await (0, $a5d33cfc7f8e5437$export$53c2fd0173ad2b80)()) throw new Error("No internet connection detected. Please restart your network and try again.");
    }
    async handleBatchMessageEvents(e) {
        if (e?.length === 0) {
            this.logger.trace("Batch message events is empty. Ignoring...");
            return;
        }
        const t = e.sort((s, i)=>s.publishedAt - i.publishedAt);
        this.logger.debug(`Batch of ${t.length} message events sorted`);
        for (const s of t)try {
            await this.onMessageEvent(s);
        } catch (i) {
            this.logger.warn(i, "Error while processing batch message event: " + i?.message);
        }
        this.logger.trace(`Batch of ${t.length} message events processed`);
    }
    async onLinkMessageEvent(e, t) {
        const { topic: s } = e;
        if (!t.sessionExists) {
            const i = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $7c6109395b060f04$exports.FIVE_MINUTES)), r = {
                topic: s,
                expiry: i,
                relay: {
                    protocol: "irn"
                },
                active: !1
            };
            await this.core.pairing.pairings.set(s, r);
        }
        this.events.emit($e9e439c110f17033$export$d56245796e2837d.message, e), await this.recordMessageEvent(e);
    }
    async connect(e) {
        await this.confirmOnlineStateOrThrow(), e && e !== this.relayUrl && (this.relayUrl = e, await this.transportDisconnect()), this.connectionAttemptInProgress = !0, this.transportExplicitlyClosed = !1;
        let t = 1;
        for(; t < 6;){
            try {
                this.logger.debug({}, `Connecting to ${this.relayUrl}, attempt: ${t}...`), await this.createProvider(), await new Promise(async (s, i)=>{
                    const r = ()=>{
                        i(new Error("Connection interrupted while trying to subscribe"));
                    };
                    this.provider.once($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, r), await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(new Promise((n, a)=>{
                        this.provider.connect().then(n).catch(a);
                    }), this.connectTimeout, `Socket stalled when trying to connect to ${this.relayUrl}`).catch((n)=>{
                        i(n);
                    }).finally(()=>{
                        this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, r), clearTimeout(this.reconnectTimeout), this.reconnectTimeout = void 0;
                    }), await new Promise(async (n, a)=>{
                        const c = ()=>{
                            a(new Error("Connection interrupted while trying to subscribe"));
                        };
                        this.provider.once($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, c), await this.subscriber.start().then(n).catch(a).finally(()=>{
                            this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, c);
                        });
                    }), this.hasExperiencedNetworkDisruption = !1, s();
                });
            } catch (s) {
                await this.subscriber.stop();
                const i = s;
                this.logger.warn({}, i.message), this.hasExperiencedNetworkDisruption = !0;
            } finally{
                this.connectionAttemptInProgress = !1;
            }
            if (this.connected) {
                this.logger.debug({}, `Connected to ${this.relayUrl} successfully on attempt: ${t}`);
                break;
            }
            await new Promise((s)=>setTimeout(s, (0, $7c6109395b060f04$exports.toMiliseconds)(t * 1))), t++;
        }
    }
    startPingTimeout() {
        var e, t, s, i, r;
        if ((0, $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee)()) try {
            (t = (e = this.provider) == null ? void 0 : e.connection) != null && t.socket && ((r = (i = (s = this.provider) == null ? void 0 : s.connection) == null ? void 0 : i.socket) == null || r.on("ping", ()=>{
                this.resetPingTimeout();
            })), this.resetPingTimeout();
        } catch (n) {
            this.logger.warn(n, n?.message);
        }
    }
    async createProvider() {
        this.provider.connection && this.unregisterProviderListeners();
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $a22b629dd83c07d0$export$da28308012bf6748)(new (0, $f6230024aa4de9c4$export$ea0df116fa892998)((0, $a5d33cfc7f8e5437$export$d875b3963ef774f5)({
            sdkVersion: $e9e439c110f17033$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0,
            bundleId: this.bundleId,
            packageName: this.packageName
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e) {
        const { topic: t, message: s } = e;
        await this.messages.set(t, s);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: s } = e;
        if (!s || s.length === 0) return this.logger.warn(`Ignoring invalid/empty message: ${s}`), !0;
        if (!await this.subscriber.isSubscribed(t)) return this.logger.warn(`Ignoring message for non-subscribed topic ${t}`), !0;
        const i = this.messages.has(t, s);
        return i && this.logger.warn(`Ignoring duplicate message: ${s}`), i;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(e)) {
            if (!e.method.endsWith($e9e439c110f17033$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: s, message: i, publishedAt: r, attestation: n } = t.data, a = {
                topic: s,
                message: i,
                publishedAt: r,
                transportType: $e9e439c110f17033$export$326e296bb8673773.relay,
                attestation: n
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($e9e439c110f17033$var$ni({
                type: "event",
                event: t.id
            }, a)), this.events.emit(t.id, a), await this.acknowledgePayload(e), await this.onMessageEvent(a);
        } else (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(e) && this.events.emit($e9e439c110f17033$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (this.events.emit($e9e439c110f17033$export$d56245796e2837d.message, e), await this.recordMessageEvent(e));
    }
    async acknowledgePayload(e) {
        const t = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(e.id, !0);
        await this.provider.connection.send(t);
    }
    unregisterProviderListeners() {
        this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.error, this.onProviderErrorHandler), clearTimeout(this.pingTimeout);
    }
    async registerEventListeners() {
        let e = await (0, $a5d33cfc7f8e5437$export$53c2fd0173ad2b80)();
        (0, $a5d33cfc7f8e5437$export$600a1ee4bc680996)(async (t)=>{
            e !== t && (e = t, t ? await this.transportOpen().catch((s)=>this.logger.error(s, s?.message)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportDisconnect(), this.transportExplicitlyClosed = !1));
        });
    }
    async onProviderDisconnect() {
        await this.subscriber.stop(), clearTimeout(this.pingTimeout), this.events.emit($e9e439c110f17033$export$d56245796e2837d.disconnect), this.connectionAttemptInProgress = !1, !this.transportExplicitlyClosed && (this.reconnectTimeout || this.connectPromise || (this.reconnectTimeout = setTimeout(async ()=>{
            clearTimeout(this.reconnectTimeout), await this.transportOpen().catch((e)=>this.logger.error(e, e?.message));
        }, (0, $7c6109395b060f04$exports.toMiliseconds)($e9e439c110f17033$export$11ccd39be2c57d6))));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        await this.confirmOnlineStateOrThrow(), !this.connected && await this.transportOpen();
    }
}
var $e9e439c110f17033$var$vn = Object.defineProperty, $e9e439c110f17033$var$ai = Object.getOwnPropertySymbols, $e9e439c110f17033$var$_n = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$En = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$ci = (o, e, t)=>e in o ? $e9e439c110f17033$var$vn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $e9e439c110f17033$var$hi = (o, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$_n.call(e, t) && $e9e439c110f17033$var$ci(o, t, e[t]);
    if ($e9e439c110f17033$var$ai) for (var t of $e9e439c110f17033$var$ai(e))$e9e439c110f17033$var$En.call(e, t) && $e9e439c110f17033$var$ci(o, t, e[t]);
    return o;
};
class $e9e439c110f17033$export$390f32400eaf98c9 extends (0, $bace94c1ef08d1bc$export$a7f17ba6c54777e7) {
    constructor(e, t, s, i = $e9e439c110f17033$export$f258d29ae5e3d545, r){
        super(e, t, s, i), this.core = e, this.logger = t, this.name = s, this.map = new Map, this.version = $e9e439c110f17033$export$629a342182ba24b, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.recentlyDeleted = [], this.recentlyDeletedLimit = 200, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((n)=>{
                this.getKey && n !== null && !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(n) ? this.map.set(this.getKey(n), n) : (0, $a5d33cfc7f8e5437$export$f657f7976bb2769d)(n) ? this.map.set(n.id, n) : (0, $a5d33cfc7f8e5437$export$c96d5113768aaf5e)(n) && this.map.set(n.topic, n);
            }), this.cached = [], this.initialized = !0);
        }, this.set = async (n, a)=>{
            this.isInitialized(), this.map.has(n) ? await this.update(n, a) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: n,
                value: a
            }), this.map.set(n, a), await this.persist());
        }, this.get = (n)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: n
            }), this.getData(n)), this.getAll = (n)=>(this.isInitialized(), n ? this.values.filter((a)=>Object.keys(n).every((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($6cqMT)))(a[c], n[c]))) : this.values), this.update = async (n, a)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: n,
                update: a
            });
            const c = $e9e439c110f17033$var$hi($e9e439c110f17033$var$hi({}, this.getData(n)), a);
            this.map.set(n, c), await this.persist();
        }, this.delete = async (n, a)=>{
            this.isInitialized(), this.map.has(n) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: n,
                reason: a
            }), this.map.delete(n), this.addToRecentlyDeleted(n), await this.persist());
        }, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(t, this.name), this.storagePrefix = i, this.getKey = r;
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    addToRecentlyDeleted(e) {
        this.recentlyDeleted.push(e), this.recentlyDeleted.length >= this.recentlyDeletedLimit && this.recentlyDeleted.splice(0, this.recentlyDeletedLimit / 2);
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            if (this.recentlyDeleted.includes(e)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Record was recently deleted - ${this.name}: ${e}`);
                throw this.logger.error(i), new Error(i);
            }
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(s), new Error(s);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.name = $e9e439c110f17033$export$390360ea476c6145, this.version = $e9e439c110f17033$export$5593ec74b27d1b18, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.ignoredPayloadTypes = [
            (0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4)
        ], this.registeredMethods = [], this.init = async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }, this.register = ({ methods: s })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...s
                ])
            ];
        }, this.create = async (s)=>{
            this.isInitialized();
            const i = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), r = await this.core.crypto.setSymKey(i), n = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $7c6109395b060f04$exports.FIVE_MINUTES)), a = {
                protocol: $e9e439c110f17033$export$822d0bd1635d5360
            }, c = {
                topic: r,
                expiry: n,
                relay: a,
                active: !1,
                methods: s?.methods
            }, h = (0, $a5d33cfc7f8e5437$export$b2786ede34fb2350)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: r,
                symKey: i,
                relay: a,
                expiryTimestamp: n,
                methods: s?.methods
            });
            return this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.create, c), this.core.expirer.set(r, n), await this.pairings.set(r, c), await this.core.relayer.subscribe(r, {
                transportType: s?.transportType
            }), {
                topic: r,
                uri: h
            };
        }, this.pair = async (s)=>{
            this.isInitialized();
            const i = this.core.eventClient.createEvent({
                properties: {
                    topic: s?.uri,
                    trace: [
                        $e9e439c110f17033$export$6736f9bb609b5d34.pairing_started
                    ]
                }
            });
            this.isValidPair(s, i);
            const { topic: r, symKey: n, relay: a, expiryTimestamp: c, methods: h } = (0, $a5d33cfc7f8e5437$export$59f58847421cfb28)(s.uri);
            i.props.properties.topic = r, i.addTrace($e9e439c110f17033$export$6736f9bb609b5d34.pairing_uri_validation_success), i.addTrace($e9e439c110f17033$export$6736f9bb609b5d34.pairing_uri_not_expired);
            let u;
            if (this.pairings.keys.includes(r)) {
                if (u = this.pairings.get(r), i.addTrace($e9e439c110f17033$export$6736f9bb609b5d34.existing_pairing), u.active) throw i.setError($e9e439c110f17033$export$e1dc85b7b7495247.active_pairing_already_exists), new Error(`Pairing already exists: ${r}. Please try again with a new connection URI.`);
                i.addTrace($e9e439c110f17033$export$6736f9bb609b5d34.pairing_not_expired);
            }
            const d = c || (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $7c6109395b060f04$exports.FIVE_MINUTES)), y = {
                topic: r,
                relay: a,
                expiry: d,
                active: !1,
                methods: h
            };
            this.core.expirer.set(r, d), await this.pairings.set(r, y), i.addTrace($e9e439c110f17033$export$6736f9bb609b5d34.store_new_pairing), s.activatePairing && await this.activate({
                topic: r
            }), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.create, y), i.addTrace($e9e439c110f17033$export$6736f9bb609b5d34.emit_inactive_pairing), this.core.crypto.keychain.has(r) || await this.core.crypto.setSymKey(n, r), i.addTrace($e9e439c110f17033$export$6736f9bb609b5d34.subscribing_pairing_topic);
            try {
                await this.core.relayer.confirmOnlineStateOrThrow();
            } catch  {
                i.setError($e9e439c110f17033$export$e1dc85b7b7495247.no_internet_connection);
            }
            try {
                await this.core.relayer.subscribe(r, {
                    relay: a
                });
            } catch (m) {
                throw i.setError($e9e439c110f17033$export$e1dc85b7b7495247.subscribe_pairing_topic_failure), m;
            }
            return i.addTrace($e9e439c110f17033$export$6736f9bb609b5d34.subscribe_pairing_topic_success), y;
        }, this.activate = async ({ topic: s })=>{
            this.isInitialized();
            const i = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $7c6109395b060f04$exports.FIVE_MINUTES));
            this.core.expirer.set(s, i), await this.pairings.update(s, {
                active: !0,
                expiry: i
            });
        }, this.ping = async (s)=>{
            this.isInitialized(), await this.isValidPing(s), this.logger.warn("ping() is deprecated and will be removed in the next major release.");
            const { topic: i } = s;
            if (this.pairings.keys.includes(i)) {
                const r = await this.sendRequest(i, "wc_pairingPing", {}), { done: n, resolve: a, reject: c } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", r), ({ error: h })=>{
                    h ? c(h) : a();
                }), await n();
            }
        }, this.updateExpiry = async ({ topic: s, expiry: i })=>{
            this.isInitialized(), await this.pairings.update(s, {
                expiry: i
            });
        }, this.updateMetadata = async ({ topic: s, metadata: i })=>{
            this.isInitialized(), await this.pairings.update(s, {
                peerMetadata: i
            });
        }, this.getPairings = ()=>(this.isInitialized(), this.pairings.values), this.disconnect = async (s)=>{
            this.isInitialized(), await this.isValidDisconnect(s);
            const { topic: i } = s;
            this.pairings.keys.includes(i) && (await this.sendRequest(i, "wc_pairingDelete", (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.deletePairing(i));
        }, this.formatUriFromPairing = (s)=>{
            this.isInitialized();
            const { topic: i, relay: r, expiry: n, methods: a } = s, c = this.core.crypto.keychain.get(i);
            return (0, $a5d33cfc7f8e5437$export$b2786ede34fb2350)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: i,
                symKey: c,
                relay: r,
                expiryTimestamp: n,
                methods: a
            });
        }, this.sendRequest = async (s, i, r)=>{
            const n = (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(i, r), a = await this.core.crypto.encode(s, n), c = $e9e439c110f17033$export$d94d6986a8185883[i].req;
            return this.core.history.set(s, n), this.core.relayer.publish(s, a, c), n.id;
        }, this.sendResult = async (s, i, r)=>{
            const n = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(s, r), a = await this.core.crypto.encode(i, n), c = await this.core.history.get(i, s), h = $e9e439c110f17033$export$d94d6986a8185883[c.request.method].res;
            await this.core.relayer.publish(i, a, h), await this.core.history.resolve(n);
        }, this.sendError = async (s, i, r)=>{
            const n = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(s, r), a = await this.core.crypto.encode(i, n), c = await this.core.history.get(i, s), h = $e9e439c110f17033$export$d94d6986a8185883[c.request.method] ? $e9e439c110f17033$export$d94d6986a8185883[c.request.method].res : $e9e439c110f17033$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(i, a, h), await this.core.history.resolve(n);
        }, this.deletePairing = async (s, i)=>{
            await this.core.relayer.unsubscribe(s), await Promise.all([
                this.pairings.delete(s, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(s),
                i ? Promise.resolve() : this.core.expirer.del(s)
            ]);
        }, this.cleanup = async ()=>{
            const s = this.pairings.getAll().filter((i)=>(0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(i.expiry));
            await Promise.all(s.map((i)=>this.deletePairing(i.topic)));
        }, this.onRelayEventRequest = (s)=>{
            const { topic: i, payload: r } = s;
            switch(r.method){
                case "wc_pairingPing":
                    return this.onPairingPingRequest(i, r);
                case "wc_pairingDelete":
                    return this.onPairingDeleteRequest(i, r);
                default:
                    return this.onUnknownRpcMethodRequest(i, r);
            }
        }, this.onRelayEventResponse = async (s)=>{
            const { topic: i, payload: r } = s, n = (await this.core.history.get(i, r.id)).request.method;
            switch(n){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(i, r);
                default:
                    return this.onUnknownRpcMethodResponse(n);
            }
        }, this.onPairingPingRequest = async (s, i)=>{
            const { id: r } = i;
            try {
                this.isValidPing({
                    topic: s
                }), await this.sendResult(r, s, !0), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.ping, {
                    id: r,
                    topic: s
                });
            } catch (n) {
                await this.sendError(r, s, n), this.logger.error(n);
            }
        }, this.onPairingPingResponse = (s, i)=>{
            const { id: r } = i;
            setTimeout(()=>{
                (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(i) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", r), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(i) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", r), {
                    error: i.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = async (s, i)=>{
            const { id: r } = i;
            try {
                this.isValidDisconnect({
                    topic: s
                }), await this.deletePairing(s), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.delete, {
                    id: r,
                    topic: s
                });
            } catch (n) {
                await this.sendError(r, s, n), this.logger.error(n);
            }
        }, this.onUnknownRpcMethodRequest = async (s, i)=>{
            const { id: r, method: n } = i;
            try {
                if (this.registeredMethods.includes(n)) return;
                const a = (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", n);
                await this.sendError(r, s, a), this.logger.error(a);
            } catch (a) {
                await this.sendError(r, s, a), this.logger.error(a);
            }
        }, this.onUnknownRpcMethodResponse = (s)=>{
            this.registeredMethods.includes(s) || this.logger.error((0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", s));
        }, this.isValidPair = (s, i)=>{
            var r;
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() params: ${s}`);
                throw i.setError($e9e439c110f17033$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (!(0, $a5d33cfc7f8e5437$export$bef94a5618bf18bf)(s.uri)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() uri: ${s.uri}`);
                throw i.setError($e9e439c110f17033$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            const n = (0, $a5d33cfc7f8e5437$export$59f58847421cfb28)(s?.uri);
            if (!((r = n?.relay) != null && r.protocol)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#relay-protocol");
                throw i.setError($e9e439c110f17033$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (!(n != null && n.symKey)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#symKey");
                throw i.setError($e9e439c110f17033$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (n != null && n.expiryTimestamp && (0, $7c6109395b060f04$exports.toMiliseconds)(n?.expiryTimestamp) < Date.now()) {
                i.setError($e9e439c110f17033$export$e1dc85b7b7495247.pairing_expired);
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
                throw new Error(a);
            }
        }, this.isValidPing = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${s}`);
                throw new Error(r);
            }
            const { topic: i } = s;
            await this.isValidPairingTopic(i);
        }, this.isValidDisconnect = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${s}`);
                throw new Error(r);
            }
            const { topic: i } = s;
            await this.isValidPairingTopic(i);
        }, this.isValidPairingTopic = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(s, !1)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${s}`);
                throw new Error(i);
            }
            if (!this.pairings.keys.includes(s)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${s}`);
                throw new Error(i);
            }
            if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.pairings.get(s).expiry)) {
                await this.deletePairing(s);
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${s}`);
                throw new Error(i);
            }
        }, this.core = e, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(t, this.name), this.pairings = new $e9e439c110f17033$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($e9e439c110f17033$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: s, transportType: i } = e;
            if (!this.pairings.keys.includes(t) || i === $e9e439c110f17033$export$326e296bb8673773.link_mode || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(s))) return;
            const r = await this.core.crypto.decode(t, s);
            try {
                (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(r) ? (this.core.history.set(t, r), this.onRelayEventRequest({
                    topic: t,
                    payload: r
                })) : (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(r) && (await this.core.history.resolve(r), await this.onRelayEventResponse({
                    topic: t,
                    payload: r
                }), this.core.history.delete(t, r.id));
            } catch (n) {
                this.logger.error(n);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($e9e439c110f17033$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $a5d33cfc7f8e5437$export$93adeb0f16e8e51d)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.expire, {
                topic: t
            }));
        });
    }
}
class $e9e439c110f17033$export$eeb4f10f25d479cb extends (0, $bace94c1ef08d1bc$export$45b2c2643615b67) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.records = new Map, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$160142c73cb99dc3, this.version = $e9e439c110f17033$export$8eba9ce85616c607, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((s)=>this.records.set(s.id, s)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.set = (s, i, r)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: s,
                request: i,
                chainId: r
            }), this.records.has(i.id)) return;
            const n = {
                id: i.id,
                topic: s,
                request: {
                    method: i.method,
                    params: i.params || null
                },
                chainId: r,
                expiry: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $7c6109395b060f04$exports.THIRTY_DAYS))
            };
            this.records.set(n.id, n), this.persist(), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.created, n);
        }, this.resolve = async (s)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: s
            }), !this.records.has(s.id)) return;
            const i = await this.getRecord(s.id);
            typeof i.response > "u" && (i.response = (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) ? {
                error: s.error
            } : {
                result: s.result
            }, this.records.set(i.id, i), this.persist(), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.updated, i));
        }, this.get = async (s, i)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: s,
                id: i
            }), await this.getRecord(i)), this.delete = (s, i)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: i
            }), this.values.forEach((r)=>{
                if (r.topic === s) {
                    if (typeof i < "u" && r.id !== i) return;
                    this.records.delete(r.id), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.deleted, r);
                }
            }), this.persist();
        }, this.exists = async (s, i)=>(this.isInitialized(), this.records.has(i) ? (await this.getRecord(i)).topic === s : !1), this.on = (s, i)=>{
            this.events.on(s, i);
        }, this.once = (s, i)=>{
            this.events.once(s, i);
        }, this.off = (s, i)=>{
            this.events.off(s, i);
        }, this.removeListener = (s, i)=>{
            this.events.removeListener(s, i);
        }, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(t, this.name);
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const s = {
                topic: t.topic,
                request: (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(s);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(s);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($e9e439c110f17033$export$a682338b5ffca937.created, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.events.on($e9e439c110f17033$export$a682338b5ffca937.updated, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.events.on($e9e439c110f17033$export$a682338b5ffca937.deleted, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.core.heartbeat.on((0, $1b66579f2b4dad8b$export$f3340c1af6bee4b5).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.isInitialized();
            let e = !1;
            this.records.forEach((t)=>{
                (0, $7c6109395b060f04$exports.toMiliseconds)(t.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${t.id}`), this.records.delete(t.id), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.deleted, t, !1), e = !0);
            }), e && this.persist();
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$e76805ce609031cb extends (0, $bace94c1ef08d1bc$export$41aaa3c39f6f2861) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.expirations = new Map, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$4ddf883392bbc828, this.version = $e9e439c110f17033$export$717295846191925d, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((s)=>this.expirations.set(s.target, s)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.has = (s)=>{
            try {
                const i = this.formatTarget(s);
                return typeof this.getExpiration(i) < "u";
            } catch  {
                return !1;
            }
        }, this.set = (s, i)=>{
            this.isInitialized();
            const r = this.formatTarget(s), n = {
                target: r,
                expiry: i
            };
            this.expirations.set(r, n), this.checkExpiry(r, n), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.created, {
                target: r,
                expiration: n
            });
        }, this.get = (s)=>{
            this.isInitialized();
            const i = this.formatTarget(s);
            return this.getExpiration(i);
        }, this.del = (s)=>{
            if (this.isInitialized(), this.has(s)) {
                const i = this.formatTarget(s), r = this.getExpiration(i);
                this.expirations.delete(i), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.deleted, {
                    target: i,
                    expiration: r
                });
            }
        }, this.on = (s, i)=>{
            this.events.on(s, i);
        }, this.once = (s, i)=>{
            this.events.once(s, i);
        }, this.off = (s, i)=>{
            this.events.off(s, i);
        }, this.removeListener = (s, i)=>{
            this.events.removeListener(s, i);
        }, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(t, this.name);
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $a5d33cfc7f8e5437$export$43ab92477f8713b9)(e);
        if (typeof e == "number") return (0, $a5d33cfc7f8e5437$export$bd13103c2e5cc0c3)(e);
        const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.warn(s), new Error(s);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: s } = t;
        (0, $7c6109395b060f04$exports.toMiliseconds)(s) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $1b66579f2b4dad8b$export$f3340c1af6bee4b5).pulse, ()=>this.checkExpirations()), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.created, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.expired, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$91a8e56769aeb334 extends (0, $bace94c1ef08d1bc$export$873b0b865d85ddb6) {
    constructor(e, t, s){
        super(e, t, s), this.core = e, this.logger = t, this.store = s, this.name = $e9e439c110f17033$export$3b58f2450f2297e3, this.verifyUrlV3 = $e9e439c110f17033$export$412739528655ee2f, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.version = $e9e439c110f17033$export$f30bd3c8747cdfbe, this.init = async ()=>{
            var i;
            this.isDevEnv || (this.publicKey = await this.store.getItem(this.storeKey), this.publicKey && (0, $7c6109395b060f04$exports.toMiliseconds)((i = this.publicKey) == null ? void 0 : i.expiresAt) < Date.now() && (this.logger.debug("verify v2 public key expired"), await this.removePublicKey()));
        }, this.register = async (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$4e09c449d6c407f7)() || this.isDevEnv) return;
            const r = window.location.origin, { id: n, decryptedId: a } = i, c = `${this.verifyUrlV3}/attestation?projectId=${this.core.projectId}&origin=${r}&id=${n}&decryptedId=${a}`;
            try {
                const h = (0, $9cba2bd26fe13e26$exports.getDocument)(), u = this.startAbortTimer((0, $7c6109395b060f04$exports.ONE_SECOND) * 5), d = await new Promise((y, m)=>{
                    const l = ()=>{
                        window.removeEventListener("message", w), h.body.removeChild(g), m("attestation aborted");
                    };
                    this.abortController.signal.addEventListener("abort", l);
                    const g = h.createElement("iframe");
                    g.src = c, g.style.display = "none", g.addEventListener("error", l, {
                        signal: this.abortController.signal
                    });
                    const w = (b)=>{
                        if (b.data && typeof b.data == "string") try {
                            const D = JSON.parse(b.data);
                            if (D.type === "verify_attestation") {
                                if ((0, $88cd1e73c7abe0b8$export$9a62e6c0a30e00bc)(D.attestation).payload.id !== n) return;
                                clearInterval(u), h.body.removeChild(g), this.abortController.signal.removeEventListener("abort", l), window.removeEventListener("message", w), y(D.attestation === null ? "" : D.attestation);
                            }
                        } catch (D) {
                            this.logger.warn(D);
                        }
                    };
                    h.body.appendChild(g), window.addEventListener("message", w, {
                        signal: this.abortController.signal
                    });
                });
                return this.logger.debug("jwt attestation", d), d;
            } catch (h) {
                this.logger.warn(h);
            }
            return "";
        }, this.resolve = async (i)=>{
            if (this.isDevEnv) return "";
            const { attestationId: r, hash: n, encryptedId: a } = i;
            if (r === "") {
                this.logger.debug("resolve: attestationId is empty, skipping");
                return;
            }
            if (r) {
                if ((0, $88cd1e73c7abe0b8$export$9a62e6c0a30e00bc)(r).payload.id !== a) return;
                const h = await this.isValidJwtAttestation(r);
                if (h) {
                    if (!h.isVerified) {
                        this.logger.warn("resolve: jwt attestation: origin url not verified");
                        return;
                    }
                    return h;
                }
            }
            if (!n) return;
            const c = this.getVerifyUrl(i?.verifyUrl);
            return this.fetchAttestation(n, c);
        }, this.fetchAttestation = async (i, r)=>{
            this.logger.debug(`resolving attestation: ${i} from url: ${r}`);
            const n = this.startAbortTimer((0, $7c6109395b060f04$exports.ONE_SECOND) * 5), a = await fetch(`${r}/attestation/${i}?v2Supported=true`, {
                signal: this.abortController.signal
            });
            return clearTimeout(n), a.status === 200 ? await a.json() : void 0;
        }, this.getVerifyUrl = (i)=>{
            let r = i || $e9e439c110f17033$export$7e3b1a28ddecdbaa;
            return $e9e439c110f17033$export$be24df03c4baa778.includes(r) || (this.logger.info(`verify url: ${r}, not included in trusted list, assigning default: ${$e9e439c110f17033$export$7e3b1a28ddecdbaa}`), r = $e9e439c110f17033$export$7e3b1a28ddecdbaa), r;
        }, this.fetchPublicKey = async ()=>{
            try {
                this.logger.debug(`fetching public key from: ${this.verifyUrlV3}`);
                const i = this.startAbortTimer((0, $7c6109395b060f04$exports.FIVE_SECONDS)), r = await fetch(`${this.verifyUrlV3}/public-key`, {
                    signal: this.abortController.signal
                });
                return clearTimeout(i), await r.json();
            } catch (i) {
                this.logger.warn(i);
            }
        }, this.persistPublicKey = async (i)=>{
            this.logger.debug("persisting public key to local storage", i), await this.store.setItem(this.storeKey, i), this.publicKey = i;
        }, this.removePublicKey = async ()=>{
            this.logger.debug("removing verify v2 public key from storage"), await this.store.removeItem(this.storeKey), this.publicKey = void 0;
        }, this.isValidJwtAttestation = async (i)=>{
            const r = await this.getPublicKey();
            try {
                if (r) return this.validateAttestation(i, r);
            } catch (a) {
                this.logger.error(a), this.logger.warn("error validating attestation");
            }
            const n = await this.fetchAndPersistPublicKey();
            try {
                if (n) return this.validateAttestation(i, n);
            } catch (a) {
                this.logger.error(a), this.logger.warn("error validating attestation");
            }
        }, this.getPublicKey = async ()=>this.publicKey ? this.publicKey : await this.fetchAndPersistPublicKey(), this.fetchAndPersistPublicKey = async ()=>{
            if (this.fetchPromise) return await this.fetchPromise, this.publicKey;
            this.fetchPromise = new Promise(async (r)=>{
                const n = await this.fetchPublicKey();
                n && (await this.persistPublicKey(n), r(n));
            });
            const i = await this.fetchPromise;
            return this.fetchPromise = void 0, i;
        }, this.validateAttestation = (i, r)=>{
            const n = (0, $a5d33cfc7f8e5437$export$f65520390041ee33)(i, r.publicKey), a = {
                hasExpired: (0, $7c6109395b060f04$exports.toMiliseconds)(n.exp) < Date.now(),
                payload: n
            };
            if (a.hasExpired) throw this.logger.warn("resolve: jwt attestation expired"), new Error("JWT attestation expired");
            return {
                origin: a.payload.origin,
                isScam: a.payload.isScam,
                isVerified: a.payload.isVerified
            };
        }, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(t, this.name), this.abortController = new AbortController, this.isDevEnv = (0, $a5d33cfc7f8e5437$export$b4bb0f87d8376dd4)(), this.init();
    }
    get storeKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//verify:public:key";
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    startAbortTimer(e) {
        return this.abortController = new AbortController, setTimeout(()=>this.abortController.abort(), (0, $7c6109395b060f04$exports.toMiliseconds)(e));
    }
}
class $e9e439c110f17033$export$c393c48c5b0cf59a extends (0, $bace94c1ef08d1bc$export$7db533fb638f979d) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.context = $e9e439c110f17033$export$40c022d2cffe0adc, this.registerDeviceToken = async (s)=>{
            const { clientId: i, token: r, notificationType: n, enableEncrypted: a = !1 } = s, c = `${$e9e439c110f17033$export$3c48c4faab79aab1}/${this.projectId}/clients`;
            await fetch(c, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    client_id: i,
                    type: n,
                    token: r,
                    always_raw: a
                })
            });
        }, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(t, this.context);
    }
}
var $e9e439c110f17033$var$wn = Object.defineProperty, $e9e439c110f17033$var$Di = Object.getOwnPropertySymbols, $e9e439c110f17033$var$In = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Tn = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$mi = (o, e, t)=>e in o ? $e9e439c110f17033$var$wn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $e9e439c110f17033$var$Q = (o, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$In.call(e, t) && $e9e439c110f17033$var$mi(o, t, e[t]);
    if ($e9e439c110f17033$var$Di) for (var t of $e9e439c110f17033$var$Di(e))$e9e439c110f17033$var$Tn.call(e, t) && $e9e439c110f17033$var$mi(o, t, e[t]);
    return o;
};
class $e9e439c110f17033$export$f4a30e909fe70796 extends (0, $bace94c1ef08d1bc$export$4264a8ec567679e5) {
    constructor(e, t, s = !0){
        super(e, t, s), this.core = e, this.logger = t, this.context = $e9e439c110f17033$export$e020229e09910965, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.storageVersion = $e9e439c110f17033$export$c73857c3a3d16b1c, this.events = new Map, this.shouldPersist = !1, this.init = async ()=>{
            if (!(0, $a5d33cfc7f8e5437$export$b4bb0f87d8376dd4)()) try {
                const i = {
                    eventId: (0, $a5d33cfc7f8e5437$export$abe4376e1bf796d6)(),
                    timestamp: Date.now(),
                    domain: this.getAppDomain(),
                    props: {
                        event: "INIT",
                        type: "",
                        properties: {
                            client_id: await this.core.crypto.getClientId(),
                            user_agent: (0, $a5d33cfc7f8e5437$export$b55a4c6e272b719f)(this.core.relayer.protocol, this.core.relayer.version, $e9e439c110f17033$export$5f30917a6f8c9025)
                        }
                    }
                };
                await this.sendEvent([
                    i
                ]);
            } catch (i) {
                this.logger.warn(i);
            }
        }, this.createEvent = (i)=>{
            const { event: r = "ERROR", type: n = "", properties: { topic: a, trace: c } } = i, h = (0, $a5d33cfc7f8e5437$export$abe4376e1bf796d6)(), u = this.core.projectId || "", d = Date.now(), y = $e9e439c110f17033$var$Q({
                eventId: h,
                timestamp: d,
                props: {
                    event: r,
                    type: n,
                    properties: {
                        topic: a,
                        trace: c
                    }
                },
                bundleId: u,
                domain: this.getAppDomain()
            }, this.setMethods(h));
            return this.telemetryEnabled && (this.events.set(h, y), this.shouldPersist = !0), y;
        }, this.getEvent = (i)=>{
            const { eventId: r, topic: n } = i;
            if (r) return this.events.get(r);
            const a = Array.from(this.events.values()).find((c)=>c.props.properties.topic === n);
            if (a) return $e9e439c110f17033$var$Q($e9e439c110f17033$var$Q({}, a), this.setMethods(a.eventId));
        }, this.deleteEvent = (i)=>{
            const { eventId: r } = i;
            this.events.delete(r), this.shouldPersist = !0;
        }, this.setEventListeners = ()=>{
            this.core.heartbeat.on((0, $1b66579f2b4dad8b$export$f3340c1af6bee4b5).pulse, async ()=>{
                this.shouldPersist && await this.persist(), this.events.forEach((i)=>{
                    (0, $7c6109395b060f04$exports.fromMiliseconds)(Date.now()) - (0, $7c6109395b060f04$exports.fromMiliseconds)(i.timestamp) > $e9e439c110f17033$export$79348045429687e2 && (this.events.delete(i.eventId), this.shouldPersist = !0);
                });
            });
        }, this.setMethods = (i)=>({
                addTrace: (r)=>this.addTrace(i, r),
                setError: (r)=>this.setError(i, r)
            }), this.addTrace = (i, r)=>{
            const n = this.events.get(i);
            n && (n.props.properties.trace.push(r), this.events.set(i, n), this.shouldPersist = !0);
        }, this.setError = (i, r)=>{
            const n = this.events.get(i);
            n && (n.props.type = r, n.timestamp = Date.now(), this.events.set(i, n), this.shouldPersist = !0);
        }, this.persist = async ()=>{
            await this.core.storage.setItem(this.storageKey, Array.from(this.events.values())), this.shouldPersist = !1;
        }, this.restore = async ()=>{
            try {
                const i = await this.core.storage.getItem(this.storageKey) || [];
                if (!i.length) return;
                i.forEach((r)=>{
                    this.events.set(r.eventId, $e9e439c110f17033$var$Q($e9e439c110f17033$var$Q({}, r), this.setMethods(r.eventId)));
                });
            } catch (i) {
                this.logger.warn(i);
            }
        }, this.submit = async ()=>{
            if (!this.telemetryEnabled || this.events.size === 0) return;
            const i = [];
            for (const [r, n] of this.events)n.props.type && i.push(n);
            if (i.length !== 0) try {
                if ((await this.sendEvent(i)).ok) for (const r of i)this.events.delete(r.eventId), this.shouldPersist = !0;
            } catch (r) {
                this.logger.warn(r);
            }
        }, this.sendEvent = async (i)=>{
            const r = this.getAppDomain() ? "" : "&sp=desktop";
            return await fetch(`${$e9e439c110f17033$export$bb6a8925f3cb1ca}?projectId=${this.core.projectId}&st=events_sdk&sv=js-${$e9e439c110f17033$export$5f30917a6f8c9025}${r}`, {
                method: "POST",
                body: JSON.stringify(i)
            });
        }, this.getAppDomain = ()=>(0, $a5d33cfc7f8e5437$export$ba31e015127122bb)().url, this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(t, this.context), this.telemetryEnabled = s, s ? this.restore().then(async ()=>{
            await this.submit(), this.setEventListeners();
        }) : this.persist();
    }
    get storageKey() {
        return this.storagePrefix + this.storageVersion + this.core.customStoragePrefix + "//" + this.context;
    }
}
var $e9e439c110f17033$var$Cn = Object.defineProperty, $e9e439c110f17033$var$fi = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Pn = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Sn = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$vi = (o, e, t)=>e in o ? $e9e439c110f17033$var$Cn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $e9e439c110f17033$var$_i = (o, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Pn.call(e, t) && $e9e439c110f17033$var$vi(o, t, e[t]);
    if ($e9e439c110f17033$var$fi) for (var t of $e9e439c110f17033$var$fi(e))$e9e439c110f17033$var$Sn.call(e, t) && $e9e439c110f17033$var$vi(o, t, e[t]);
    return o;
};
class $e9e439c110f17033$export$2e2bcd8739ae039 extends (0, $bace94c1ef08d1bc$export$ed533416df113881) {
    constructor(e){
        var t;
        super(e), this.protocol = $e9e439c110f17033$export$51b1c900ac262bdf, this.version = $e9e439c110f17033$export$f30bd3c8747cdfbe, this.name = $e9e439c110f17033$export$d47601f9de5ee22b, this.events = new (0, $7etJZ.EventEmitter), this.initialized = !1, this.on = (n, a)=>this.events.on(n, a), this.once = (n, a)=>this.events.once(n, a), this.off = (n, a)=>this.events.off(n, a), this.removeListener = (n, a)=>this.events.removeListener(n, a), this.dispatchEnvelope = ({ topic: n, message: a, sessionExists: c })=>{
            if (!n || !a) return;
            const h = {
                topic: n,
                message: a,
                publishedAt: Date.now(),
                transportType: $e9e439c110f17033$export$326e296bb8673773.link_mode
            };
            this.relayer.onLinkMessageEvent(h, {
                sessionExists: c
            });
        }, this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $e9e439c110f17033$export$a68061e6c48f332a, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
        const s = (0, $704ed3be9612b960$export$bad2475df51c8ecc)({
            level: typeof e?.logger == "string" && e.logger ? e.logger : $e9e439c110f17033$export$db0fdb6d486555c2.logger,
            name: $e9e439c110f17033$export$d47601f9de5ee22b
        }), { logger: i, chunkLoggerController: r } = (0, $704ed3be9612b960$export$15eba7fb5aaf9303)({
            opts: s,
            maxSizeInBytes: e?.maxLogBlobSizeInBytes,
            loggerOverride: e?.logger
        });
        this.logChunkController = r, (t = this.logChunkController) != null && t.downloadLogsBlobInBrowser && (window.downloadLogsBlobInBrowser = async ()=>{
            var n, a;
            (n = this.logChunkController) != null && n.downloadLogsBlobInBrowser && ((a = this.logChunkController) == null || a.downloadLogsBlobInBrowser({
                clientId: await this.crypto.getClientId()
            }));
        }), this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(i, this.name), this.heartbeat = new (0, $1b66579f2b4dad8b$export$996c9b2cd7645b55), this.crypto = new $e9e439c110f17033$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $e9e439c110f17033$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $e9e439c110f17033$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, $5e575ac853f40acc$export$8536778e426ddf92)($e9e439c110f17033$var$_i($e9e439c110f17033$var$_i({}, $e9e439c110f17033$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $e9e439c110f17033$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $e9e439c110f17033$export$3370ee24730992a3(this, this.logger), this.verify = new $e9e439c110f17033$export$91a8e56769aeb334(this, this.logger, this.storage), this.echoClient = new $e9e439c110f17033$export$c393c48c5b0cf59a(this.projectId || "", this.logger), this.linkModeSupportedApps = [], this.eventClient = new $e9e439c110f17033$export$f4a30e909fe70796(this, this.logger, e?.telemetryEnabled);
    }
    static async init(e) {
        const t = new $e9e439c110f17033$export$2e2bcd8739ae039(e);
        await t.initialize();
        const s = await t.crypto.getClientId();
        return await t.storage.setItem($e9e439c110f17033$export$9e4ca561755938da, s), t;
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async getLogsBlob() {
        var e;
        return (e = this.logChunkController) == null ? void 0 : e.logsToBlob({
            clientId: await this.crypto.getClientId()
        });
    }
    async addLinkModeSupportedApp(e) {
        this.linkModeSupportedApps.includes(e) || (this.linkModeSupportedApps.push(e), await this.storage.setItem($e9e439c110f17033$export$1989eec3a412fb97, this.linkModeSupportedApps));
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.linkModeSupportedApps = await this.storage.getItem($e9e439c110f17033$export$1989eec3a412fb97) || [], this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
}
const $e9e439c110f17033$export$4143ab5b91744744 = $e9e439c110f17033$export$2e2bcd8739ae039;







var $7etJZ = parcelRequire("7etJZ");

const $4a472e843fedf2e2$export$4fa962fc67384e02 = "wc", $4a472e843fedf2e2$export$61085c48796ff049 = 2, $4a472e843fedf2e2$export$94715592c220319a = "client", $4a472e843fedf2e2$export$7fa6f9ee1e2cab96 = `${$4a472e843fedf2e2$export$4fa962fc67384e02}@${$4a472e843fedf2e2$export$61085c48796ff049}:${$4a472e843fedf2e2$export$94715592c220319a}:`, $4a472e843fedf2e2$export$8dffb3242f2c5f72 = {
    name: $4a472e843fedf2e2$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.org"
}, $4a472e843fedf2e2$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire",
    session_authenticate: "session_authenticate",
    session_request_expire: "session_request_expire"
}, $4a472e843fedf2e2$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $4a472e843fedf2e2$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $4a472e843fedf2e2$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $4a472e843fedf2e2$export$160142c73cb99dc3 = "history", $4a472e843fedf2e2$export$8eba9ce85616c607 = "0.3", $4a472e843fedf2e2$export$ae6c7a4f7ed730a1 = "proposal", $4a472e843fedf2e2$export$6db28e89b135a53c = (0, $7c6109395b060f04$exports.THIRTY_DAYS), $4a472e843fedf2e2$export$1e6a4dc5172f4830 = "Proposal expired", $4a472e843fedf2e2$export$a069e98a8dfeec1e = "session", $4a472e843fedf2e2$export$84b1b9dbcdea0475 = (0, $7c6109395b060f04$exports.SEVEN_DAYS), $4a472e843fedf2e2$export$2db42d5151ad6eb8 = "engine", $4a472e843fedf2e2$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        },
        reject: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !1,
            tag: 1120
        },
        autoReject: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !1,
            tag: 1121
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.ONE_DAY),
            prompt: !1,
            tag: 1115
        }
    },
    wc_sessionAuthenticate: {
        req: {
            ttl: (0, $7c6109395b060f04$exports.ONE_HOUR),
            prompt: !0,
            tag: 1116
        },
        res: {
            ttl: (0, $7c6109395b060f04$exports.ONE_HOUR),
            prompt: !1,
            tag: 1117
        },
        reject: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !1,
            tag: 1118
        },
        autoReject: {
            ttl: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
            prompt: !1,
            tag: 1119
        }
    }
}, $4a472e843fedf2e2$export$409f0c0a13a1b7c6 = {
    min: (0, $7c6109395b060f04$exports.FIVE_MINUTES),
    max: (0, $7c6109395b060f04$exports.SEVEN_DAYS)
}, $4a472e843fedf2e2$export$8602b201748df21a = {
    idle: "IDLE",
    active: "ACTIVE"
}, $4a472e843fedf2e2$export$40b296af21bd38a4 = "request", $4a472e843fedf2e2$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest",
    "wc_sessionAuthenticate"
], $4a472e843fedf2e2$export$e24c518fa7fc04c = "wc", $4a472e843fedf2e2$export$af233b4aa2e30834 = 1.5, $4a472e843fedf2e2$export$e8b9bbdca3ac0ed = "auth", $4a472e843fedf2e2$export$ab815cb37981e7e0 = "authKeys", $4a472e843fedf2e2$export$5d9af9e20f678626 = "pairingTopics", $4a472e843fedf2e2$export$3643b3579d091159 = "requests", $4a472e843fedf2e2$export$323ba3ebb8028ed0 = `${$4a472e843fedf2e2$export$e24c518fa7fc04c}@${1.5}:${$4a472e843fedf2e2$export$e8b9bbdca3ac0ed}:`, $4a472e843fedf2e2$export$efef74cb455ac30f = `${$4a472e843fedf2e2$export$323ba3ebb8028ed0}:PUB_KEY`;
var $4a472e843fedf2e2$var$ys = Object.defineProperty, $4a472e843fedf2e2$var$ws = Object.defineProperties, $4a472e843fedf2e2$var$ms = Object.getOwnPropertyDescriptors, $4a472e843fedf2e2$var$gt = Object.getOwnPropertySymbols, $4a472e843fedf2e2$var$_s = Object.prototype.hasOwnProperty, $4a472e843fedf2e2$var$Es = Object.prototype.propertyIsEnumerable, $4a472e843fedf2e2$var$yt = (q, o, e)=>o in q ? $4a472e843fedf2e2$var$ys(q, o, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : q[o] = e, $4a472e843fedf2e2$var$I = (q, o)=>{
    for(var e in o || (o = {}))$4a472e843fedf2e2$var$_s.call(o, e) && $4a472e843fedf2e2$var$yt(q, e, o[e]);
    if ($4a472e843fedf2e2$var$gt) for (var e of $4a472e843fedf2e2$var$gt(o))$4a472e843fedf2e2$var$Es.call(o, e) && $4a472e843fedf2e2$var$yt(q, e, o[e]);
    return q;
}, $4a472e843fedf2e2$var$D = (q, o)=>$4a472e843fedf2e2$var$ws(q, $4a472e843fedf2e2$var$ms(o));
class $4a472e843fedf2e2$var$Rs extends (0, $bace94c1ef08d1bc$export$87df43c730effa30) {
    constructor(o){
        super(o), this.name = $4a472e843fedf2e2$export$2db42d5151ad6eb8, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.initialized = !1, this.requestQueue = {
            state: $4a472e843fedf2e2$export$8602b201748df21a.idle,
            queue: []
        }, this.sessionRequestQueue = {
            state: $4a472e843fedf2e2$export$8602b201748df21a.idle,
            queue: []
        }, this.requestQueueDelay = (0, $7c6109395b060f04$exports.ONE_SECOND), this.expectedPairingMethodMap = new Map, this.recentlyDeletedMap = new Map, this.recentlyDeletedLimit = 200, this.relayMessageCache = [], this.init = async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), await this.registerLinkModeListeners(), this.client.core.pairing.register({
                methods: Object.keys($4a472e843fedf2e2$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(()=>{
                this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
            }, (0, $7c6109395b060f04$exports.toMiliseconds)(this.requestQueueDelay)));
        }, this.connect = async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            const t = $4a472e843fedf2e2$var$D($4a472e843fedf2e2$var$I({}, e), {
                requiredNamespaces: e.requiredNamespaces || {},
                optionalNamespaces: e.optionalNamespaces || {}
            });
            await this.isValidConnect(t);
            const { pairingTopic: s, requiredNamespaces: i, optionalNamespaces: r, sessionProperties: n, relays: a } = t;
            let c = s, h, p = !1;
            try {
                if (c) {
                    const E = this.client.core.pairing.pairings.get(c);
                    this.client.logger.warn("connect() with existing pairing topic is deprecated and will be removed in the next major release."), p = E.active;
                }
            } catch (E) {
                throw this.client.logger.error(`connect() -> pairing.get(${c}) failed`), E;
            }
            if (!c || !p) {
                const { topic: E, uri: S } = await this.client.core.pairing.create();
                c = E, h = S;
            }
            if (!c) {
                const { message: E } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `connect() pairing topic: ${c}`);
                throw new Error(E);
            }
            const d = await this.client.core.crypto.generateKeyPair(), l = $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionPropose.req.ttl || (0, $7c6109395b060f04$exports.FIVE_MINUTES), w = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)(l), m = $4a472e843fedf2e2$var$I({
                requiredNamespaces: i,
                optionalNamespaces: r,
                relays: a ?? [
                    {
                        protocol: (0, $e9e439c110f17033$export$822d0bd1635d5360)
                    }
                ],
                proposer: {
                    publicKey: d,
                    metadata: this.client.metadata
                },
                expiryTimestamp: w,
                pairingTopic: c
            }, n && {
                sessionProperties: n
            }), { reject: y, resolve: _, done: R } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)(l, $4a472e843fedf2e2$export$1e6a4dc5172f4830);
            this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), async ({ error: E, session: S })=>{
                if (E) y(E);
                else if (S) {
                    S.self.publicKey = d;
                    const M = $4a472e843fedf2e2$var$D($4a472e843fedf2e2$var$I({}, S), {
                        pairingTopic: m.pairingTopic,
                        requiredNamespaces: m.requiredNamespaces,
                        optionalNamespaces: m.optionalNamespaces,
                        transportType: (0, $e9e439c110f17033$export$326e296bb8673773).relay
                    });
                    await this.client.session.set(S.topic, M), await this.setExpiry(S.topic, S.expiry), c && await this.client.core.pairing.updateMetadata({
                        topic: c,
                        metadata: S.peer.metadata
                    }), this.cleanupDuplicatePairings(M), _(M);
                }
            });
            const V = await this.sendRequest({
                topic: c,
                method: "wc_sessionPropose",
                params: m,
                throwOnFailedPublish: !0
            });
            return await this.setProposal(V, $4a472e843fedf2e2$var$I({
                id: V
            }, m)), {
                uri: h,
                approval: R
            };
        }, this.pair = async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                return await this.client.core.pairing.pair(e);
            } catch (t) {
                throw this.client.logger.error("pair() failed"), t;
            }
        }, this.approve = async (e)=>{
            var t, s, i;
            const r = this.client.core.eventClient.createEvent({
                properties: {
                    topic: (t = e?.id) == null ? void 0 : t.toString(),
                    trace: [
                        (0, $e9e439c110f17033$export$16ed3f27a411eba0).session_approve_started
                    ]
                }
            });
            try {
                this.isInitialized(), await this.confirmOnlineStateOrThrow();
            } catch (N) {
                throw r.setError((0, $e9e439c110f17033$export$bc50109885e83402).no_internet_connection), N;
            }
            try {
                await this.isValidProposalId(e?.id);
            } catch (N) {
                throw this.client.logger.error(`approve() -> proposal.get(${e?.id}) failed`), r.setError((0, $e9e439c110f17033$export$bc50109885e83402).proposal_not_found), N;
            }
            try {
                await this.isValidApprove(e);
            } catch (N) {
                throw this.client.logger.error("approve() -> isValidApprove() failed"), r.setError((0, $e9e439c110f17033$export$bc50109885e83402).session_approve_namespace_validation_failure), N;
            }
            const { id: n, relayProtocol: a, namespaces: c, sessionProperties: h, sessionConfig: p } = e, d = this.client.proposal.get(n);
            this.client.core.eventClient.deleteEvent({
                eventId: r.eventId
            });
            const { pairingTopic: l, proposer: w, requiredNamespaces: m, optionalNamespaces: y } = d;
            let _ = (s = this.client.core.eventClient) == null ? void 0 : s.getEvent({
                topic: l
            });
            _ || (_ = (i = this.client.core.eventClient) == null ? void 0 : i.createEvent({
                type: (0, $e9e439c110f17033$export$16ed3f27a411eba0).session_approve_started,
                properties: {
                    topic: l,
                    trace: [
                        (0, $e9e439c110f17033$export$16ed3f27a411eba0).session_approve_started,
                        (0, $e9e439c110f17033$export$16ed3f27a411eba0).session_namespaces_validation_success
                    ]
                }
            }));
            const R = await this.client.core.crypto.generateKeyPair(), V = w.publicKey, E = await this.client.core.crypto.generateSharedKey(R, V), S = $4a472e843fedf2e2$var$I($4a472e843fedf2e2$var$I({
                relay: {
                    protocol: a ?? "irn"
                },
                namespaces: c,
                controller: {
                    publicKey: R,
                    metadata: this.client.metadata
                },
                expiry: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)
            }, h && {
                sessionProperties: h
            }), p && {
                sessionConfig: p
            }), M = (0, $e9e439c110f17033$export$326e296bb8673773).relay;
            _.addTrace((0, $e9e439c110f17033$export$16ed3f27a411eba0).subscribing_session_topic);
            try {
                await this.client.core.relayer.subscribe(E, {
                    transportType: M
                });
            } catch (N) {
                throw _.setError((0, $e9e439c110f17033$export$bc50109885e83402).subscribe_session_topic_failure), N;
            }
            _.addTrace((0, $e9e439c110f17033$export$16ed3f27a411eba0).subscribe_session_topic_success);
            const W = $4a472e843fedf2e2$var$D($4a472e843fedf2e2$var$I({}, S), {
                topic: E,
                requiredNamespaces: m,
                optionalNamespaces: y,
                pairingTopic: l,
                acknowledged: !1,
                self: S.controller,
                peer: {
                    publicKey: w.publicKey,
                    metadata: w.metadata
                },
                controller: R,
                transportType: (0, $e9e439c110f17033$export$326e296bb8673773).relay
            });
            await this.client.session.set(E, W), _.addTrace((0, $e9e439c110f17033$export$16ed3f27a411eba0).store_session);
            try {
                _.addTrace((0, $e9e439c110f17033$export$16ed3f27a411eba0).publishing_session_settle), await this.sendRequest({
                    topic: E,
                    method: "wc_sessionSettle",
                    params: S,
                    throwOnFailedPublish: !0
                }).catch((N)=>{
                    throw _?.setError((0, $e9e439c110f17033$export$bc50109885e83402).session_settle_publish_failure), N;
                }), _.addTrace((0, $e9e439c110f17033$export$16ed3f27a411eba0).session_settle_publish_success), _.addTrace((0, $e9e439c110f17033$export$16ed3f27a411eba0).publishing_session_approve), await this.sendResult({
                    id: n,
                    topic: l,
                    result: {
                        relay: {
                            protocol: a ?? "irn"
                        },
                        responderPublicKey: R
                    },
                    throwOnFailedPublish: !0
                }).catch((N)=>{
                    throw _?.setError((0, $e9e439c110f17033$export$bc50109885e83402).session_approve_publish_failure), N;
                }), _.addTrace((0, $e9e439c110f17033$export$16ed3f27a411eba0).session_approve_publish_success);
            } catch (N) {
                throw this.client.logger.error(N), this.client.session.delete(E, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.relayer.unsubscribe(E), N;
            }
            return this.client.core.eventClient.deleteEvent({
                eventId: _.eventId
            }), await this.client.core.pairing.updateMetadata({
                topic: l,
                metadata: w.metadata
            }), await this.client.proposal.delete(n, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: l
            }), await this.setExpiry(E, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), {
                topic: E,
                acknowledged: ()=>Promise.resolve(this.client.session.get(E))
            };
        }, this.reject = async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidReject(e);
            } catch (r) {
                throw this.client.logger.error("reject() -> isValidReject() failed"), r;
            }
            const { id: t, reason: s } = e;
            let i;
            try {
                i = this.client.proposal.get(t).pairingTopic;
            } catch (r) {
                throw this.client.logger.error(`reject() -> proposal.get(${t}) failed`), r;
            }
            i && (await this.sendError({
                id: t,
                topic: i,
                error: s,
                rpcOpts: $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionPropose.reject
            }), await this.client.proposal.delete(t, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")));
        }, this.update = async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidUpdate(e);
            } catch (p) {
                throw this.client.logger.error("update() -> isValidUpdate() failed"), p;
            }
            const { topic: t, namespaces: s } = e, { done: i, resolve: r, reject: n } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)(), a = (0, $3bb3ddc7bbc938cc$export$2f5364a5d4b80251)(), c = (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString(), h = this.client.session.get(t).namespaces;
            return this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", a), ({ error: p })=>{
                p ? n(p) : r();
            }), await this.client.session.update(t, {
                namespaces: s
            }), await this.sendRequest({
                topic: t,
                method: "wc_sessionUpdate",
                params: {
                    namespaces: s
                },
                throwOnFailedPublish: !0,
                clientRpcId: a,
                relayRpcId: c
            }).catch((p)=>{
                this.client.logger.error(p), this.client.session.update(t, {
                    namespaces: h
                }), n(p);
            }), {
                acknowledged: i
            };
        }, this.extend = async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidExtend(e);
            } catch (a) {
                throw this.client.logger.error("extend() -> isValidExtend() failed"), a;
            }
            const { topic: t } = e, s = (0, $3bb3ddc7bbc938cc$export$2f5364a5d4b80251)(), { done: i, resolve: r, reject: n } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", s), ({ error: a })=>{
                a ? n(a) : r();
            }), await this.setExpiry(t, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), this.sendRequest({
                topic: t,
                method: "wc_sessionExtend",
                params: {},
                clientRpcId: s,
                throwOnFailedPublish: !0
            }).catch((a)=>{
                n(a);
            }), {
                acknowledged: i
            };
        }, this.request = async (e)=>{
            this.isInitialized();
            try {
                await this.isValidRequest(e);
            } catch (w) {
                throw this.client.logger.error("request() -> isValidRequest() failed"), w;
            }
            const { chainId: t, request: s, topic: i, expiry: r = $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionRequest.req.ttl } = e, n = this.client.session.get(i);
            n?.transportType === (0, $e9e439c110f17033$export$326e296bb8673773).relay && await this.confirmOnlineStateOrThrow();
            const a = (0, $3bb3ddc7bbc938cc$export$2f5364a5d4b80251)(), c = (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString(), { done: h, resolve: p, reject: d } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)(r, "Request expired. Please try again.");
            this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", a), ({ error: w, result: m })=>{
                w ? d(w) : p(m);
            });
            const l = this.getAppLinkIfEnabled(n.peer.metadata, n.transportType);
            return l ? (await this.sendRequest({
                clientRpcId: a,
                relayRpcId: c,
                topic: i,
                method: "wc_sessionRequest",
                params: {
                    request: $4a472e843fedf2e2$var$D($4a472e843fedf2e2$var$I({}, s), {
                        expiryTimestamp: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)(r)
                    }),
                    chainId: t
                },
                expiry: r,
                throwOnFailedPublish: !0,
                appLink: l
            }).catch((w)=>d(w)), this.client.events.emit("session_request_sent", {
                topic: i,
                request: s,
                chainId: t,
                id: a
            }), await h()) : await Promise.all([
                new Promise(async (w)=>{
                    await this.sendRequest({
                        clientRpcId: a,
                        relayRpcId: c,
                        topic: i,
                        method: "wc_sessionRequest",
                        params: {
                            request: $4a472e843fedf2e2$var$D($4a472e843fedf2e2$var$I({}, s), {
                                expiryTimestamp: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)(r)
                            }),
                            chainId: t
                        },
                        expiry: r,
                        throwOnFailedPublish: !0
                    }).catch((m)=>d(m)), this.client.events.emit("session_request_sent", {
                        topic: i,
                        request: s,
                        chainId: t,
                        id: a
                    }), w();
                }),
                new Promise(async (w)=>{
                    var m;
                    if (!((m = n.sessionConfig) != null && m.disableDeepLink)) {
                        const y = await (0, $a5d33cfc7f8e5437$export$e55bfdac47149a32)(this.client.core.storage, $4a472e843fedf2e2$export$a26ccd6441b7d638);
                        await (0, $a5d33cfc7f8e5437$export$694a208c8abca99a)({
                            id: a,
                            topic: i,
                            wcDeepLink: y
                        });
                    }
                    w();
                }),
                h()
            ]).then((w)=>w[2]);
        }, this.respond = async (e)=>{
            this.isInitialized(), await this.isValidRespond(e);
            const { topic: t, response: s } = e, { id: i } = s, r = this.client.session.get(t);
            r.transportType === (0, $e9e439c110f17033$export$326e296bb8673773).relay && await this.confirmOnlineStateOrThrow();
            const n = this.getAppLinkIfEnabled(r.peer.metadata, r.transportType);
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? await this.sendResult({
                id: i,
                topic: t,
                result: s.result,
                throwOnFailedPublish: !0,
                appLink: n
            }) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && await this.sendError({
                id: i,
                topic: t,
                error: s.error,
                appLink: n
            }), this.cleanupAfterResponse(e);
        }, this.ping = async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidPing(e);
            } catch (s) {
                throw this.client.logger.error("ping() -> isValidPing() failed"), s;
            }
            const { topic: t } = e;
            if (this.client.session.keys.includes(t)) {
                const s = (0, $3bb3ddc7bbc938cc$export$2f5364a5d4b80251)(), i = (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString(), { done: r, resolve: n, reject: a } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", s), ({ error: c })=>{
                    c ? a(c) : n();
                }), await Promise.all([
                    this.sendRequest({
                        topic: t,
                        method: "wc_sessionPing",
                        params: {},
                        throwOnFailedPublish: !0,
                        clientRpcId: s,
                        relayRpcId: i
                    }),
                    r()
                ]);
            } else this.client.core.pairing.pairings.keys.includes(t) && (this.client.logger.warn("ping() on pairing topic is deprecated and will be removed in the next major release."), await this.client.core.pairing.ping({
                topic: t
            }));
        }, this.emit = async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow(), await this.isValidEmit(e);
            const { topic: t, event: s, chainId: i } = e, r = (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString(), n = (0, $3bb3ddc7bbc938cc$export$2f5364a5d4b80251)();
            await this.sendRequest({
                topic: t,
                method: "wc_sessionEvent",
                params: {
                    event: s,
                    chainId: i
                },
                throwOnFailedPublish: !0,
                relayRpcId: r,
                clientRpcId: n
            });
        }, this.disconnect = async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow(), await this.isValidDisconnect(e);
            const { topic: t } = e;
            if (this.client.session.keys.includes(t)) await this.sendRequest({
                topic: t,
                method: "wc_sessionDelete",
                params: (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
            }), await this.deleteSession({
                topic: t,
                emitEvent: !1
            });
            else if (this.client.core.pairing.pairings.keys.includes(t)) await this.client.core.pairing.disconnect({
                topic: t
            });
            else {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISMATCHED_TOPIC", `Session or pairing topic not found: ${t}`);
                throw new Error(s);
            }
        }, this.find = (e)=>(this.isInitialized(), this.client.session.getAll().filter((t)=>(0, $a5d33cfc7f8e5437$export$6fc4971bf8f326a)(t, e))), this.getPendingSessionRequests = ()=>this.client.pendingRequest.getAll(), this.authenticate = async (e, t)=>{
            var s;
            this.isInitialized(), this.isValidAuthenticate(e);
            const i = t && this.client.core.linkModeSupportedApps.includes(t) && ((s = this.client.metadata.redirect) == null ? void 0 : s.linkMode), r = i ? (0, $e9e439c110f17033$export$326e296bb8673773).link_mode : (0, $e9e439c110f17033$export$326e296bb8673773).relay;
            r === (0, $e9e439c110f17033$export$326e296bb8673773).relay && await this.confirmOnlineStateOrThrow();
            const { chains: n, statement: a = "", uri: c, domain: h, nonce: p, type: d, exp: l, nbf: w, methods: m = [], expiry: y } = e, _ = [
                ...e.resources || []
            ], { topic: R, uri: V } = await this.client.core.pairing.create({
                methods: [
                    "wc_sessionAuthenticate"
                ],
                transportType: r
            });
            this.client.logger.info({
                message: "Generated new pairing",
                pairing: {
                    topic: R,
                    uri: V
                }
            });
            const E = await this.client.core.crypto.generateKeyPair(), S = (0, $a5d33cfc7f8e5437$export$1e87d19d4aab5805)(E);
            if (await Promise.all([
                this.client.auth.authKeys.set($4a472e843fedf2e2$export$efef74cb455ac30f, {
                    responseTopic: S,
                    publicKey: E
                }),
                this.client.auth.pairingTopics.set(S, {
                    topic: S,
                    pairingTopic: R
                })
            ]), await this.client.core.relayer.subscribe(S, {
                transportType: r
            }), this.client.logger.info(`sending request to new pairing topic: ${R}`), m.length > 0) {
                const { namespace: O } = (0, $a5d33cfc7f8e5437$export$4764229d78de4437)(n[0]);
                let T = (0, $a5d33cfc7f8e5437$export$2bc35d2a08a09ad5)(O, "request", m);
                (0, $a5d33cfc7f8e5437$export$3bb18ae0fb9a9fa9)(_) && (T = (0, $a5d33cfc7f8e5437$export$c7a40c552af428b5)(T, _.pop())), _.push(T);
            }
            const M = y && y > $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl ? y : $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl, W = {
                authPayload: {
                    type: d ?? "caip122",
                    chains: n,
                    statement: a,
                    aud: c,
                    domain: h,
                    version: "1",
                    nonce: p,
                    iat: new Date().toISOString(),
                    exp: l,
                    nbf: w,
                    resources: _
                },
                requester: {
                    publicKey: E,
                    metadata: this.client.metadata
                },
                expiryTimestamp: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)(M)
            }, N = {
                eip155: {
                    chains: n,
                    methods: [
                        ...new Set([
                            "personal_sign",
                            ...m
                        ])
                    ],
                    events: [
                        "chainChanged",
                        "accountsChanged"
                    ]
                }
            }, Ve = {
                requiredNamespaces: {},
                optionalNamespaces: N,
                relays: [
                    {
                        protocol: "irn"
                    }
                ],
                pairingTopic: R,
                proposer: {
                    publicKey: E,
                    metadata: this.client.metadata
                },
                expiryTimestamp: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionPropose.req.ttl)
            }, { done: mt, resolve: Me, reject: Ee } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)(M, "Request expired"), ce = async ({ error: O, session: T })=>{
                if (this.events.off((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", G), Re), O) Ee(O);
                else if (T) {
                    T.self.publicKey = E, await this.client.session.set(T.topic, T), await this.setExpiry(T.topic, T.expiry), R && await this.client.core.pairing.updateMetadata({
                        topic: R,
                        metadata: T.peer.metadata
                    });
                    const le = this.client.session.get(T.topic);
                    await this.deleteProposal(Z), Me({
                        session: le
                    });
                }
            }, Re = async (O)=>{
                var T, le, ke;
                if (await this.deletePendingAuthRequest(G, {
                    message: "fulfilled",
                    code: 0
                }), O.error) {
                    const te = (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", "wc_sessionAuthenticate");
                    return O.error.code === te.code ? void 0 : (this.events.off((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), ce), Ee(O.error.message));
                }
                await this.deleteProposal(Z), this.events.off((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), ce);
                const { cacaos: $e, responder: j } = O.result, Ie = [], Ke = [];
                for (const te of $e){
                    await (0, $a5d33cfc7f8e5437$export$b7d566fce8e2b970)({
                        cacao: te,
                        projectId: this.client.core.projectId
                    }) || (this.client.logger.error(te, "Signature verification failed"), Ee((0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("SESSION_SETTLEMENT_FAILED", "Signature verification failed")));
                    const { p: fe } = te, ve = (0, $a5d33cfc7f8e5437$export$3bb18ae0fb9a9fa9)(fe.resources), Ue = [
                        (0, $a5d33cfc7f8e5437$export$a8b149927aef7051)(fe.iss)
                    ], _t = (0, $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9)(fe.iss);
                    if (ve) {
                        const qe = (0, $a5d33cfc7f8e5437$export$d6c6a43d36418efe)(ve), Et = (0, $a5d33cfc7f8e5437$export$372f88051a611988)(ve);
                        Ie.push(...qe), Ue.push(...Et);
                    }
                    for (const qe of Ue)Ke.push(`${qe}:${_t}`);
                }
                const ee = await this.client.core.crypto.generateSharedKey(E, j.publicKey);
                let pe;
                Ie.length > 0 && (pe = {
                    topic: ee,
                    acknowledged: !0,
                    self: {
                        publicKey: E,
                        metadata: this.client.metadata
                    },
                    peer: j,
                    controller: j.publicKey,
                    expiry: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475),
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    relay: {
                        protocol: "irn"
                    },
                    pairingTopic: R,
                    namespaces: (0, $a5d33cfc7f8e5437$export$b5744b1c39447540)([
                        ...new Set(Ie)
                    ], [
                        ...new Set(Ke)
                    ]),
                    transportType: r
                }, await this.client.core.relayer.subscribe(ee, {
                    transportType: r
                }), await this.client.session.set(ee, pe), R && await this.client.core.pairing.updateMetadata({
                    topic: R,
                    metadata: j.metadata
                }), pe = this.client.session.get(ee)), (T = this.client.metadata.redirect) != null && T.linkMode && (le = j.metadata.redirect) != null && le.linkMode && (ke = j.metadata.redirect) != null && ke.universal && t && (this.client.core.addLinkModeSupportedApp(j.metadata.redirect.universal), this.client.session.update(ee, {
                    transportType: (0, $e9e439c110f17033$export$326e296bb8673773).link_mode
                })), Me({
                    auths: $e,
                    session: pe
                });
            }, G = (0, $3bb3ddc7bbc938cc$export$2f5364a5d4b80251)(), Z = (0, $3bb3ddc7bbc938cc$export$2f5364a5d4b80251)();
            this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), ce), this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", G), Re);
            let Se;
            try {
                if (i) {
                    const O = (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)("wc_sessionAuthenticate", W, G);
                    this.client.core.history.set(R, O);
                    const T = await this.client.core.crypto.encode("", O, {
                        type: (0, $a5d33cfc7f8e5437$export$d79eac6ee921504f),
                        encoding: (0, $a5d33cfc7f8e5437$export$e9cf21fb8029e645)
                    });
                    Se = (0, $a5d33cfc7f8e5437$export$556cb6cc912028c2)(t, R, T);
                } else await Promise.all([
                    this.sendRequest({
                        topic: R,
                        method: "wc_sessionAuthenticate",
                        params: W,
                        expiry: e.expiry,
                        throwOnFailedPublish: !0,
                        clientRpcId: G
                    }),
                    this.sendRequest({
                        topic: R,
                        method: "wc_sessionPropose",
                        params: Ve,
                        expiry: $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionPropose.req.ttl,
                        throwOnFailedPublish: !0,
                        clientRpcId: Z
                    })
                ]);
            } catch (O) {
                throw this.events.off((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), ce), this.events.off((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", G), Re), O;
            }
            return await this.setProposal(Z, $4a472e843fedf2e2$var$I({
                id: Z
            }, Ve)), await this.setAuthRequest(G, {
                request: $4a472e843fedf2e2$var$D($4a472e843fedf2e2$var$I({}, W), {
                    verifyContext: {}
                }),
                pairingTopic: R,
                transportType: r
            }), {
                uri: Se ?? V,
                response: mt
            };
        }, this.approveSessionAuthenticate = async (e)=>{
            const { id: t, auths: s } = e, i = this.client.core.eventClient.createEvent({
                properties: {
                    topic: t.toString(),
                    trace: [
                        (0, $e9e439c110f17033$export$6540f02663742dde).authenticated_session_approve_started
                    ]
                }
            });
            try {
                this.isInitialized();
            } catch (y) {
                throw i.setError((0, $e9e439c110f17033$export$aca4f34441e6cd3a).no_internet_connection), y;
            }
            const r = this.getPendingAuthRequest(t);
            if (!r) throw i.setError((0, $e9e439c110f17033$export$aca4f34441e6cd3a).authenticated_session_pending_request_not_found), new Error(`Could not find pending auth request with id ${t}`);
            const n = r.transportType || (0, $e9e439c110f17033$export$326e296bb8673773).relay;
            n === (0, $e9e439c110f17033$export$326e296bb8673773).relay && await this.confirmOnlineStateOrThrow();
            const a = r.requester.publicKey, c = await this.client.core.crypto.generateKeyPair(), h = (0, $a5d33cfc7f8e5437$export$1e87d19d4aab5805)(a), p = {
                type: (0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4),
                receiverPublicKey: a,
                senderPublicKey: c
            }, d = [], l = [];
            for (const y of s){
                if (!await (0, $a5d33cfc7f8e5437$export$b7d566fce8e2b970)({
                    cacao: y,
                    projectId: this.client.core.projectId
                })) {
                    i.setError((0, $e9e439c110f17033$export$aca4f34441e6cd3a).invalid_cacao);
                    const S = (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("SESSION_SETTLEMENT_FAILED", "Signature verification failed");
                    throw await this.sendError({
                        id: t,
                        topic: h,
                        error: S,
                        encodeOpts: p
                    }), new Error(S.message);
                }
                i.addTrace((0, $e9e439c110f17033$export$6540f02663742dde).cacaos_verified);
                const { p: _ } = y, R = (0, $a5d33cfc7f8e5437$export$3bb18ae0fb9a9fa9)(_.resources), V = [
                    (0, $a5d33cfc7f8e5437$export$a8b149927aef7051)(_.iss)
                ], E = (0, $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9)(_.iss);
                if (R) {
                    const S = (0, $a5d33cfc7f8e5437$export$d6c6a43d36418efe)(R), M = (0, $a5d33cfc7f8e5437$export$372f88051a611988)(R);
                    d.push(...S), V.push(...M);
                }
                for (const S of V)l.push(`${S}:${E}`);
            }
            const w = await this.client.core.crypto.generateSharedKey(c, a);
            i.addTrace((0, $e9e439c110f17033$export$6540f02663742dde).create_authenticated_session_topic);
            let m;
            if (d?.length > 0) {
                m = {
                    topic: w,
                    acknowledged: !0,
                    self: {
                        publicKey: c,
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: a,
                        metadata: r.requester.metadata
                    },
                    controller: a,
                    expiry: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475),
                    authentication: s,
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    relay: {
                        protocol: "irn"
                    },
                    pairingTopic: r.pairingTopic,
                    namespaces: (0, $a5d33cfc7f8e5437$export$b5744b1c39447540)([
                        ...new Set(d)
                    ], [
                        ...new Set(l)
                    ]),
                    transportType: n
                }, i.addTrace((0, $e9e439c110f17033$export$6540f02663742dde).subscribing_authenticated_session_topic);
                try {
                    await this.client.core.relayer.subscribe(w, {
                        transportType: n
                    });
                } catch (y) {
                    throw i.setError((0, $e9e439c110f17033$export$aca4f34441e6cd3a).subscribe_authenticated_session_topic_failure), y;
                }
                i.addTrace((0, $e9e439c110f17033$export$6540f02663742dde).subscribe_authenticated_session_topic_success), await this.client.session.set(w, m), i.addTrace((0, $e9e439c110f17033$export$6540f02663742dde).store_authenticated_session), await this.client.core.pairing.updateMetadata({
                    topic: r.pairingTopic,
                    metadata: r.requester.metadata
                });
            }
            i.addTrace((0, $e9e439c110f17033$export$6540f02663742dde).publishing_authenticated_session_approve);
            try {
                await this.sendResult({
                    topic: h,
                    id: t,
                    result: {
                        cacaos: s,
                        responder: {
                            publicKey: c,
                            metadata: this.client.metadata
                        }
                    },
                    encodeOpts: p,
                    throwOnFailedPublish: !0,
                    appLink: this.getAppLinkIfEnabled(r.requester.metadata, n)
                });
            } catch (y) {
                throw i.setError((0, $e9e439c110f17033$export$aca4f34441e6cd3a).authenticated_session_approve_publish_failure), y;
            }
            return await this.client.auth.requests.delete(t, {
                message: "fulfilled",
                code: 0
            }), await this.client.core.pairing.activate({
                topic: r.pairingTopic
            }), this.client.core.eventClient.deleteEvent({
                eventId: i.eventId
            }), {
                session: m
            };
        }, this.rejectSessionAuthenticate = async (e)=>{
            this.isInitialized();
            const { id: t, reason: s } = e, i = this.getPendingAuthRequest(t);
            if (!i) throw new Error(`Could not find pending auth request with id ${t}`);
            i.transportType === (0, $e9e439c110f17033$export$326e296bb8673773).relay && await this.confirmOnlineStateOrThrow();
            const r = i.requester.publicKey, n = await this.client.core.crypto.generateKeyPair(), a = (0, $a5d33cfc7f8e5437$export$1e87d19d4aab5805)(r), c = {
                type: (0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4),
                receiverPublicKey: r,
                senderPublicKey: n
            };
            await this.sendError({
                id: t,
                topic: a,
                error: s,
                encodeOpts: c,
                rpcOpts: $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionAuthenticate.reject,
                appLink: this.getAppLinkIfEnabled(i.requester.metadata, i.transportType)
            }), await this.client.auth.requests.delete(t, {
                message: "rejected",
                code: 0
            }), await this.client.proposal.delete(t, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED"));
        }, this.formatAuthMessage = (e)=>{
            this.isInitialized();
            const { request: t, iss: s } = e;
            return (0, $a5d33cfc7f8e5437$export$25868d1e8e76735f)(t, s);
        }, this.processRelayMessageCache = ()=>{
            setTimeout(async ()=>{
                if (this.relayMessageCache.length !== 0) for(; this.relayMessageCache.length > 0;)try {
                    const e = this.relayMessageCache.shift();
                    e && await this.onRelayMessage(e);
                } catch (e) {
                    this.client.logger.error(e);
                }
            }, 50);
        }, this.cleanupDuplicatePairings = async (e)=>{
            if (e.pairingTopic) try {
                const t = this.client.core.pairing.pairings.get(e.pairingTopic), s = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var r, n;
                    return ((r = i.peerMetadata) == null ? void 0 : r.url) && ((n = i.peerMetadata) == null ? void 0 : n.url) === e.peer.metadata.url && i.topic && i.topic !== t.topic;
                });
                if (s.length === 0) return;
                this.client.logger.info(`Cleaning up ${s.length} duplicate pairing(s)`), await Promise.all(s.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (t) {
                this.client.logger.error(t);
            }
        }, this.deleteSession = async (e)=>{
            var t;
            const { topic: s, expirerHasDeleted: i = !1, emitEvent: r = !0, id: n = 0 } = e, { self: a } = this.client.session.get(s);
            await this.client.core.relayer.unsubscribe(s), await this.client.session.delete(s, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.addToRecentlyDeleted(s, "session"), this.client.core.crypto.keychain.has(a.publicKey) && await this.client.core.crypto.deleteKeyPair(a.publicKey), this.client.core.crypto.keychain.has(s) && await this.client.core.crypto.deleteSymKey(s), i || this.client.core.expirer.del(s), this.client.core.storage.removeItem($4a472e843fedf2e2$export$a26ccd6441b7d638).catch((c)=>this.client.logger.warn(c)), this.getPendingSessionRequests().forEach((c)=>{
                c.topic === s && this.deletePendingSessionRequest(c.id, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED"));
            }), s === ((t = this.sessionRequestQueue.queue[0]) == null ? void 0 : t.topic) && (this.sessionRequestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.idle), r && this.client.events.emit("session_delete", {
                id: n,
                topic: s
            });
        }, this.deleteProposal = async (e, t)=>{
            if (t) try {
                const s = this.client.proposal.get(e), i = this.client.core.eventClient.getEvent({
                    topic: s.pairingTopic
                });
                i?.setError((0, $e9e439c110f17033$export$bc50109885e83402).proposal_expired);
            } catch  {}
            await Promise.all([
                this.client.proposal.delete(e, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                t ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.addToRecentlyDeleted(e, "proposal");
        }, this.deletePendingSessionRequest = async (e, t, s = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(e, t),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.addToRecentlyDeleted(e, "request"), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i)=>i.id !== e), s && (this.sessionRequestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.idle, this.client.events.emit("session_request_expire", {
                id: e
            }));
        }, this.deletePendingAuthRequest = async (e, t, s = !1)=>{
            await Promise.all([
                this.client.auth.requests.delete(e, t),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]);
        }, this.setExpiry = async (e, t)=>{
            this.client.session.keys.includes(e) && (this.client.core.expirer.set(e, t), await this.client.session.update(e, {
                expiry: t
            }));
        }, this.setProposal = async (e, t)=>{
            this.client.core.expirer.set(e, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionPropose.req.ttl)), await this.client.proposal.set(e, t);
        }, this.setAuthRequest = async (e, t)=>{
            const { request: s, pairingTopic: i, transportType: r = (0, $e9e439c110f17033$export$326e296bb8673773).relay } = t;
            this.client.core.expirer.set(e, s.expiryTimestamp), await this.client.auth.requests.set(e, {
                authPayload: s.authPayload,
                requester: s.requester,
                expiryTimestamp: s.expiryTimestamp,
                id: e,
                pairingTopic: i,
                verifyContext: s.verifyContext,
                transportType: r
            });
        }, this.setPendingSessionRequest = async (e)=>{
            const { id: t, topic: s, params: i, verifyContext: r } = e, n = i.request.expiryTimestamp || (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionRequest.req.ttl);
            this.client.core.expirer.set(t, n), await this.client.pendingRequest.set(t, {
                id: t,
                topic: s,
                params: i,
                verifyContext: r
            });
        }, this.sendRequest = async (e)=>{
            const { topic: t, method: s, params: i, expiry: r, relayRpcId: n, clientRpcId: a, throwOnFailedPublish: c, appLink: h } = e, p = (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(s, i, a);
            let d;
            const l = !!h;
            try {
                const y = l ? (0, $a5d33cfc7f8e5437$export$e9cf21fb8029e645) : (0, $a5d33cfc7f8e5437$export$9bff723d552e6bcf);
                d = await this.client.core.crypto.encode(t, p, {
                    encoding: y
                });
            } catch (y) {
                throw await this.cleanup(), this.client.logger.error(`sendRequest() -> core.crypto.encode() for topic ${t} failed`), y;
            }
            let w;
            if ($4a472e843fedf2e2$export$63c37d8ae5931ad5.includes(s)) {
                const y = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify(p)), _ = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(d);
                w = await this.client.core.verify.register({
                    id: _,
                    decryptedId: y
                });
            }
            const m = $4a472e843fedf2e2$export$4edb1ca37014192d[s].req;
            if (m.attestation = w, r && (m.ttl = r), n && (m.id = n), this.client.core.history.set(t, p), l) {
                const y = (0, $a5d33cfc7f8e5437$export$556cb6cc912028c2)(h, t, d);
                await $parcel$global.Linking.openURL(y, this.client.name);
            } else {
                const y = $4a472e843fedf2e2$export$4edb1ca37014192d[s].req;
                r && (y.ttl = r), n && (y.id = n), c ? (y.internal = $4a472e843fedf2e2$var$D($4a472e843fedf2e2$var$I({}, y.internal), {
                    throwOnFailedPublish: !0
                }), await this.client.core.relayer.publish(t, d, y)) : this.client.core.relayer.publish(t, d, y).catch((_)=>this.client.logger.error(_));
            }
            return p.id;
        }, this.sendResult = async (e)=>{
            const { id: t, topic: s, result: i, throwOnFailedPublish: r, encodeOpts: n, appLink: a } = e, c = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(t, i);
            let h;
            const p = a && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u";
            try {
                const l = p ? (0, $a5d33cfc7f8e5437$export$e9cf21fb8029e645) : (0, $a5d33cfc7f8e5437$export$9bff723d552e6bcf);
                h = await this.client.core.crypto.encode(s, c, $4a472e843fedf2e2$var$D($4a472e843fedf2e2$var$I({}, n || {}), {
                    encoding: l
                }));
            } catch (l) {
                throw await this.cleanup(), this.client.logger.error(`sendResult() -> core.crypto.encode() for topic ${s} failed`), l;
            }
            let d;
            try {
                d = await this.client.core.history.get(s, t);
            } catch (l) {
                throw this.client.logger.error(`sendResult() -> history.get(${s}, ${t}) failed`), l;
            }
            if (p) {
                const l = (0, $a5d33cfc7f8e5437$export$556cb6cc912028c2)(a, s, h);
                await $parcel$global.Linking.openURL(l, this.client.name);
            } else {
                const l = $4a472e843fedf2e2$export$4edb1ca37014192d[d.request.method].res;
                r ? (l.internal = $4a472e843fedf2e2$var$D($4a472e843fedf2e2$var$I({}, l.internal), {
                    throwOnFailedPublish: !0
                }), await this.client.core.relayer.publish(s, h, l)) : this.client.core.relayer.publish(s, h, l).catch((w)=>this.client.logger.error(w));
            }
            await this.client.core.history.resolve(c);
        }, this.sendError = async (e)=>{
            const { id: t, topic: s, error: i, encodeOpts: r, rpcOpts: n, appLink: a } = e, c = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(t, i);
            let h;
            const p = a && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u";
            try {
                const l = p ? (0, $a5d33cfc7f8e5437$export$e9cf21fb8029e645) : (0, $a5d33cfc7f8e5437$export$9bff723d552e6bcf);
                h = await this.client.core.crypto.encode(s, c, $4a472e843fedf2e2$var$D($4a472e843fedf2e2$var$I({}, r || {}), {
                    encoding: l
                }));
            } catch (l) {
                throw await this.cleanup(), this.client.logger.error(`sendError() -> core.crypto.encode() for topic ${s} failed`), l;
            }
            let d;
            try {
                d = await this.client.core.history.get(s, t);
            } catch (l) {
                throw this.client.logger.error(`sendError() -> history.get(${s}, ${t}) failed`), l;
            }
            if (p) {
                const l = (0, $a5d33cfc7f8e5437$export$556cb6cc912028c2)(a, s, h);
                await $parcel$global.Linking.openURL(l, this.client.name);
            } else {
                const l = n || $4a472e843fedf2e2$export$4edb1ca37014192d[d.request.method].res;
                this.client.core.relayer.publish(s, h, l);
            }
            await this.client.core.history.resolve(c);
        }, this.cleanup = async ()=>{
            const e = [], t = [];
            this.client.session.getAll().forEach((s)=>{
                let i = !1;
                (0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(s.expiry) && (i = !0), this.client.core.crypto.keychain.has(s.topic) || (i = !0), i && e.push(s.topic);
            }), this.client.proposal.getAll().forEach((s)=>{
                (0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(s.expiryTimestamp) && t.push(s.id);
            }), await Promise.all([
                ...e.map((s)=>this.deleteSession({
                        topic: s
                    })),
                ...t.map((s)=>this.deleteProposal(s))
            ]);
        }, this.onRelayEventRequest = async (e)=>{
            this.requestQueue.queue.push(e), await this.processRequestsQueue();
        }, this.processRequestsQueue = async ()=>{
            if (this.requestQueue.state === $4a472e843fedf2e2$export$8602b201748df21a.active) {
                this.client.logger.info("Request queue already active, skipping...");
                return;
            }
            for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0;){
                this.requestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.active;
                const e = this.requestQueue.queue.shift();
                if (e) try {
                    await this.processRequest(e);
                } catch (t) {
                    this.client.logger.warn(t);
                }
            }
            this.requestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.idle;
        }, this.processRequest = async (e)=>{
            const { topic: t, payload: s, attestation: i, transportType: r, encryptedId: n } = e, a = s.method;
            if (!this.shouldIgnorePairingRequest({
                topic: t,
                requestMethod: a
            })) switch(a){
                case "wc_sessionPropose":
                    return await this.onSessionProposeRequest({
                        topic: t,
                        payload: s,
                        attestation: i,
                        encryptedId: n
                    });
                case "wc_sessionSettle":
                    return await this.onSessionSettleRequest(t, s);
                case "wc_sessionUpdate":
                    return await this.onSessionUpdateRequest(t, s);
                case "wc_sessionExtend":
                    return await this.onSessionExtendRequest(t, s);
                case "wc_sessionPing":
                    return await this.onSessionPingRequest(t, s);
                case "wc_sessionDelete":
                    return await this.onSessionDeleteRequest(t, s);
                case "wc_sessionRequest":
                    return await this.onSessionRequest({
                        topic: t,
                        payload: s,
                        attestation: i,
                        encryptedId: n,
                        transportType: r
                    });
                case "wc_sessionEvent":
                    return await this.onSessionEventRequest(t, s);
                case "wc_sessionAuthenticate":
                    return await this.onSessionAuthenticateRequest({
                        topic: t,
                        payload: s,
                        attestation: i,
                        encryptedId: n,
                        transportType: r
                    });
                default:
                    return this.client.logger.info(`Unsupported request method ${a}`);
            }
        }, this.onRelayEventResponse = async (e)=>{
            const { topic: t, payload: s, transportType: i } = e, r = (await this.client.core.history.get(t, s.id)).request.method;
            switch(r){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(t, s, i);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(t, s);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(t, s);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(t, s);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(t, s);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(t, s);
                case "wc_sessionAuthenticate":
                    return this.onSessionAuthenticateResponse(t, s);
                default:
                    return this.client.logger.info(`Unsupported response method ${r}`);
            }
        }, this.onRelayEventUnknownPayload = (e)=>{
            const { topic: t } = e, { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Decoded payload on topic ${t} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(s);
        }, this.shouldIgnorePairingRequest = (e)=>{
            const { topic: t, requestMethod: s } = e, i = this.expectedPairingMethodMap.get(t);
            return !i || i.includes(s) ? !1 : !!(i.includes("wc_sessionAuthenticate") && this.client.events.listenerCount("session_authenticate") > 0);
        }, this.onSessionProposeRequest = async (e)=>{
            const { topic: t, payload: s, attestation: i, encryptedId: r } = e, { params: n, id: a } = s;
            try {
                const c = this.client.core.eventClient.getEvent({
                    topic: t
                });
                this.client.events.listenerCount("session_proposal") === 0 && (console.warn("No listener for session_proposal event"), c?.setError((0, $e9e439c110f17033$export$e1dc85b7b7495247).proposal_listener_not_found)), this.isValidConnect($4a472e843fedf2e2$var$I({}, s.params));
                const h = n.expiryTimestamp || (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionPropose.req.ttl), p = $4a472e843fedf2e2$var$I({
                    id: a,
                    pairingTopic: t,
                    expiryTimestamp: h
                }, n);
                await this.setProposal(a, p);
                const d = await this.getVerifyContext({
                    attestationId: i,
                    hash: (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify(s)),
                    encryptedId: r,
                    metadata: p.proposer.metadata
                });
                c?.addTrace((0, $e9e439c110f17033$export$6736f9bb609b5d34).emit_session_proposal), this.client.events.emit("session_proposal", {
                    id: a,
                    params: p,
                    verifyContext: d
                });
            } catch (c) {
                await this.sendError({
                    id: a,
                    topic: t,
                    error: c,
                    rpcOpts: $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionPropose.autoReject
                }), this.client.logger.error(c);
            }
        }, this.onSessionProposeResponse = async (e, t, s)=>{
            const { id: i } = t;
            if ((0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(t)) {
                const { result: r } = t;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: r
                });
                const n = this.client.proposal.get(i);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: n
                });
                const a = n.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: a
                });
                const c = r.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: c
                });
                const h = await this.client.core.crypto.generateSharedKey(a, c);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    sessionTopic: h
                });
                const p = await this.client.core.relayer.subscribe(h, {
                    transportType: s
                });
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: p
                }), await this.client.core.pairing.activate({
                    topic: e
                });
            } else if ((0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(t)) {
                await this.client.proposal.delete(i, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED"));
                const r = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect");
                if (this.events.listenerCount(r) === 0) throw new Error(`emitting ${r} without any listeners, 954`);
                this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), {
                    error: t.error
                });
            }
        }, this.onSessionSettleRequest = async (e, t)=>{
            const { id: s, params: i } = t;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: r, controller: n, expiry: a, namespaces: c, sessionProperties: h, sessionConfig: p } = t.params, d = $4a472e843fedf2e2$var$D($4a472e843fedf2e2$var$I($4a472e843fedf2e2$var$I({
                    topic: e,
                    relay: r,
                    expiry: a,
                    namespaces: c,
                    acknowledged: !0,
                    pairingTopic: "",
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    controller: n.publicKey,
                    self: {
                        publicKey: "",
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: n.publicKey,
                        metadata: n.metadata
                    }
                }, h && {
                    sessionProperties: h
                }), p && {
                    sessionConfig: p
                }), {
                    transportType: (0, $e9e439c110f17033$export$326e296bb8673773).relay
                }), l = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect");
                if (this.events.listenerCount(l) === 0) throw new Error(`emitting ${l} without any listeners 997`);
                this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), {
                    session: d
                }), await this.sendResult({
                    id: t.id,
                    topic: e,
                    result: !0,
                    throwOnFailedPublish: !0
                });
            } catch (r) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: r
                }), this.client.logger.error(r);
            }
        }, this.onSessionSettleResponse = async (e, t)=>{
            const { id: s } = t;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(t) ? (await this.client.session.update(e, {
                acknowledged: !0
            }), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_approve", s), {})) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(t) && (await this.client.session.delete(e, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_approve", s), {
                error: t.error
            }));
        }, this.onSessionUpdateRequest = async (e, t)=>{
            const { params: s, id: i } = t;
            try {
                const r = `${e}_session_update`, n = (0, $a5d33cfc7f8e5437$export$b72d712fed4d036d).get(r);
                if (n && this.isRequestOutOfSync(n, i)) {
                    this.client.logger.warn(`Discarding out of sync request - ${i}`), this.sendError({
                        id: i,
                        topic: e,
                        error: (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("INVALID_UPDATE_REQUEST")
                    });
                    return;
                }
                this.isValidUpdate($4a472e843fedf2e2$var$I({
                    topic: e
                }, s));
                try {
                    (0, $a5d33cfc7f8e5437$export$b72d712fed4d036d).set(r, i), await this.client.session.update(e, {
                        namespaces: s.namespaces
                    }), await this.sendResult({
                        id: i,
                        topic: e,
                        result: !0,
                        throwOnFailedPublish: !0
                    });
                } catch (a) {
                    throw (0, $a5d33cfc7f8e5437$export$b72d712fed4d036d).delete(r), a;
                }
                this.client.events.emit("session_update", {
                    id: i,
                    topic: e,
                    params: s
                });
            } catch (r) {
                await this.sendError({
                    id: i,
                    topic: e,
                    error: r
                }), this.client.logger.error(r);
            }
        }, this.isRequestOutOfSync = (e, t)=>t.toString().slice(0, -3) < e.toString().slice(0, -3), this.onSessionUpdateResponse = (e, t)=>{
            const { id: s } = t, i = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(t) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", s), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(t) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", s), {
                error: t.error
            });
        }, this.onSessionExtendRequest = async (e, t)=>{
            const { id: s } = t;
            try {
                this.isValidExtend({
                    topic: e
                }), await this.setExpiry(e, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), await this.sendResult({
                    id: s,
                    topic: e,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_extend", {
                    id: s,
                    topic: e
                });
            } catch (i) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: i
                }), this.client.logger.error(i);
            }
        }, this.onSessionExtendResponse = (e, t)=>{
            const { id: s } = t, i = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(t) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", s), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(t) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", s), {
                error: t.error
            });
        }, this.onSessionPingRequest = async (e, t)=>{
            const { id: s } = t;
            try {
                this.isValidPing({
                    topic: e
                }), await this.sendResult({
                    id: s,
                    topic: e,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_ping", {
                    id: s,
                    topic: e
                });
            } catch (i) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: i
                }), this.client.logger.error(i);
            }
        }, this.onSessionPingResponse = (e, t)=>{
            const { id: s } = t, i = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            setTimeout(()=>{
                (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(t) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", s), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(t) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", s), {
                    error: t.error
                });
            }, 500);
        }, this.onSessionDeleteRequest = async (e, t)=>{
            const { id: s } = t;
            try {
                this.isValidDisconnect({
                    topic: e,
                    reason: t.params
                }), Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $e9e439c110f17033$export$d56245796e2837d).publish, async ()=>{
                            i(await this.deleteSession({
                                topic: e,
                                id: s
                            }));
                        });
                    }),
                    this.sendResult({
                        id: s,
                        topic: e,
                        result: !0,
                        throwOnFailedPublish: !0
                    }),
                    this.cleanupPendingSentRequestsForTopic({
                        topic: e,
                        error: (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
                    })
                ]).catch((i)=>this.client.logger.error(i));
            } catch (i) {
                this.client.logger.error(i);
            }
        }, this.onSessionRequest = async (e)=>{
            var t, s, i;
            const { topic: r, payload: n, attestation: a, encryptedId: c, transportType: h } = e, { id: p, params: d } = n;
            try {
                await this.isValidRequest($4a472e843fedf2e2$var$I({
                    topic: r
                }, d));
                const l = this.client.session.get(r), w = await this.getVerifyContext({
                    attestationId: a,
                    hash: (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify((0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)("wc_sessionRequest", d, p))),
                    encryptedId: c,
                    metadata: l.peer.metadata,
                    transportType: h
                }), m = {
                    id: p,
                    topic: r,
                    params: d,
                    verifyContext: w
                };
                await this.setPendingSessionRequest(m), h === (0, $e9e439c110f17033$export$326e296bb8673773).link_mode && (t = l.peer.metadata.redirect) != null && t.universal && this.client.core.addLinkModeSupportedApp((s = l.peer.metadata.redirect) == null ? void 0 : s.universal), (i = this.client.signConfig) != null && i.disableRequestQueue ? this.emitSessionRequest(m) : (this.addSessionRequestToSessionRequestQueue(m), this.processSessionRequestQueue());
            } catch (l) {
                await this.sendError({
                    id: p,
                    topic: r,
                    error: l
                }), this.client.logger.error(l);
            }
        }, this.onSessionRequestResponse = (e, t)=>{
            const { id: s } = t, i = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(t) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", s), {
                result: t.result
            }) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(t) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", s), {
                error: t.error
            });
        }, this.onSessionEventRequest = async (e, t)=>{
            const { id: s, params: i } = t;
            try {
                const r = `${e}_session_event_${i.event.name}`, n = (0, $a5d33cfc7f8e5437$export$b72d712fed4d036d).get(r);
                if (n && this.isRequestOutOfSync(n, s)) {
                    this.client.logger.info(`Discarding out of sync request - ${s}`);
                    return;
                }
                this.isValidEmit($4a472e843fedf2e2$var$I({
                    topic: e
                }, i)), this.client.events.emit("session_event", {
                    id: s,
                    topic: e,
                    params: i
                }), (0, $a5d33cfc7f8e5437$export$b72d712fed4d036d).set(r, s);
            } catch (r) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: r
                }), this.client.logger.error(r);
            }
        }, this.onSessionAuthenticateResponse = (e, t)=>{
            const { id: s } = t;
            this.client.logger.trace({
                type: "method",
                method: "onSessionAuthenticateResponse",
                topic: e,
                payload: t
            }), (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(t) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", s), {
                result: t.result
            }) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(t) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", s), {
                error: t.error
            });
        }, this.onSessionAuthenticateRequest = async (e)=>{
            var t;
            const { topic: s, payload: i, attestation: r, encryptedId: n, transportType: a } = e;
            try {
                const { requester: c, authPayload: h, expiryTimestamp: p } = i.params, d = await this.getVerifyContext({
                    attestationId: r,
                    hash: (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify(i)),
                    encryptedId: n,
                    metadata: c.metadata,
                    transportType: a
                }), l = {
                    requester: c,
                    pairingTopic: s,
                    id: i.id,
                    authPayload: h,
                    verifyContext: d,
                    expiryTimestamp: p
                };
                await this.setAuthRequest(i.id, {
                    request: l,
                    pairingTopic: s,
                    transportType: a
                }), a === (0, $e9e439c110f17033$export$326e296bb8673773).link_mode && (t = c.metadata.redirect) != null && t.universal && this.client.core.addLinkModeSupportedApp(c.metadata.redirect.universal), this.client.events.emit("session_authenticate", {
                    topic: s,
                    params: i.params,
                    id: i.id,
                    verifyContext: d
                });
            } catch (c) {
                this.client.logger.error(c);
                const h = i.params.requester.publicKey, p = await this.client.core.crypto.generateKeyPair(), d = this.getAppLinkIfEnabled(i.params.requester.metadata, a), l = {
                    type: (0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4),
                    receiverPublicKey: h,
                    senderPublicKey: p
                };
                await this.sendError({
                    id: i.id,
                    topic: s,
                    error: c,
                    encodeOpts: l,
                    rpcOpts: $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionAuthenticate.autoReject,
                    appLink: d
                });
            }
        }, this.addSessionRequestToSessionRequestQueue = (e)=>{
            this.sessionRequestQueue.queue.push(e);
        }, this.cleanupAfterResponse = (e)=>{
            this.deletePendingSessionRequest(e.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.sessionRequestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.idle, this.processSessionRequestQueue();
            }, (0, $7c6109395b060f04$exports.toMiliseconds)(this.requestQueueDelay));
        }, this.cleanupPendingSentRequestsForTopic = ({ topic: e, error: t })=>{
            const s = this.client.core.history.pending;
            s.length > 0 && s.filter((i)=>i.topic === e && i.request.method === "wc_sessionRequest").forEach((i)=>{
                const r = i.request.id, n = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", r);
                if (this.events.listenerCount(n) === 0) throw new Error(`emitting ${n} without any listeners`);
                this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", i.request.id), {
                    error: t
                });
            });
        }, this.processSessionRequestQueue = ()=>{
            if (this.sessionRequestQueue.state === $4a472e843fedf2e2$export$8602b201748df21a.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const e = this.sessionRequestQueue.queue[0];
            if (!e) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                this.sessionRequestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.active, this.emitSessionRequest(e);
            } catch (t) {
                this.client.logger.error(t);
            }
        }, this.emitSessionRequest = (e)=>{
            this.client.events.emit("session_request", e);
        }, this.onPairingCreated = (e)=>{
            if (e.methods && this.expectedPairingMethodMap.set(e.topic, e.methods), e.active) return;
            const t = this.client.proposal.getAll().find((s)=>s.pairingTopic === e.topic);
            t && this.onSessionProposeRequest({
                topic: e.topic,
                payload: (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)("wc_sessionPropose", {
                    requiredNamespaces: t.requiredNamespaces,
                    optionalNamespaces: t.optionalNamespaces,
                    relays: t.relays,
                    proposer: t.proposer,
                    sessionProperties: t.sessionProperties
                }, t.id)
            });
        }, this.isValidConnect = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(e)}`);
                throw new Error(a);
            }
            const { pairingTopic: t, requiredNamespaces: s, optionalNamespaces: i, sessionProperties: r, relays: n } = e;
            if ((0, $a5d33cfc7f8e5437$export$fce6876652108ab)(t) || await this.isValidPairingTopic(t), !(0, $a5d33cfc7f8e5437$export$6294c30b976bd21e)(n, !0)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() relays: ${n}`);
                throw new Error(a);
            }
            !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(s) && (0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(s) !== 0 && this.validateNamespaces(s, "requiredNamespaces"), !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(i) && (0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $a5d33cfc7f8e5437$export$fce6876652108ab)(r) || this.validateSessionProps(r, "sessionProperties");
        }, this.validateNamespaces = (e, t)=>{
            const s = (0, $a5d33cfc7f8e5437$export$9e2b2cae22c6a8b3)(e, "connect()", t);
            if (s) throw new Error(s.message);
        }, this.isValidApprove = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) throw new Error((0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() params: ${e}`).message);
            const { id: t, namespaces: s, relayProtocol: i, sessionProperties: r } = e;
            this.checkRecentlyDeleted(t), await this.isValidProposalId(t);
            const n = this.client.proposal.get(t), a = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(s, "approve()");
            if (a) throw new Error(a.message);
            const c = (0, $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4)(n.requiredNamespaces, s, "approve()");
            if (c) throw new Error(c.message);
            if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(i, !0)) {
                const { message: h } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(h);
            }
            (0, $a5d33cfc7f8e5437$export$fce6876652108ab)(r) || this.validateSessionProps(r, "sessionProperties");
        }, this.isValidReject = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() params: ${e}`);
                throw new Error(i);
            }
            const { id: t, reason: s } = e;
            if (this.checkRecentlyDeleted(t), await this.isValidProposalId(t), !(0, $a5d33cfc7f8e5437$export$766fe78377d96f2a)(s)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(s)}`);
                throw new Error(i);
            }
        }, this.isValidSessionSettleRequest = (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: c } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${e}`);
                throw new Error(c);
            }
            const { relay: t, controller: s, namespaces: i, expiry: r } = e;
            if (!(0, $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b)(t)) {
                const { message: c } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(c);
            }
            const n = (0, $a5d33cfc7f8e5437$export$5e1c5c89613c213f)(s, "onSessionSettleRequest()");
            if (n) throw new Error(n.message);
            const a = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(r)) {
                const { message: c } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(c);
            }
        }, this.isValidUpdate = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `update() params: ${e}`);
                throw new Error(a);
            }
            const { topic: t, namespaces: s } = e;
            this.checkRecentlyDeleted(t), await this.isValidSessionTopic(t);
            const i = this.client.session.get(t), r = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(s, "update()");
            if (r) throw new Error(r.message);
            const n = (0, $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4)(i.requiredNamespaces, s, "update()");
            if (n) throw new Error(n.message);
        }, this.isValidExtend = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `extend() params: ${e}`);
                throw new Error(s);
            }
            const { topic: t } = e;
            this.checkRecentlyDeleted(t), await this.isValidSessionTopic(t);
        }, this.isValidRequest = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() params: ${e}`);
                throw new Error(a);
            }
            const { topic: t, request: s, chainId: i, expiry: r } = e;
            this.checkRecentlyDeleted(t), await this.isValidSessionTopic(t);
            const { namespaces: n } = this.client.session.get(t);
            if (!(0, $a5d33cfc7f8e5437$export$144fc36610eb6522)(n, i)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $a5d33cfc7f8e5437$export$1a2af3c017fb6d42)(s)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() ${JSON.stringify(s)}`);
                throw new Error(a);
            }
            if (!(0, $a5d33cfc7f8e5437$export$8db4804e3a6de711)(n, i, s.method)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() method: ${s.method}`);
                throw new Error(a);
            }
            if (r && !(0, $a5d33cfc7f8e5437$export$59fba2af1ac782b)(r, $4a472e843fedf2e2$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() expiry: ${r}. Expiry must be a number (in seconds) between ${$4a472e843fedf2e2$export$409f0c0a13a1b7c6.min} and ${$4a472e843fedf2e2$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }, this.isValidRespond = async (e)=>{
            var t;
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() params: ${e}`);
                throw new Error(r);
            }
            const { topic: s, response: i } = e;
            try {
                await this.isValidSessionTopic(s);
            } catch (r) {
                throw (t = e?.response) != null && t.id && this.cleanupAfterResponse(e), r;
            }
            if (!(0, $a5d33cfc7f8e5437$export$1ae38cf0a848f651)(i)) {
                const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(i)}`);
                throw new Error(r);
            }
        }, this.isValidPing = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${e}`);
                throw new Error(s);
            }
            const { topic: t } = e;
            await this.isValidSessionOrPairingTopic(t);
        }, this.isValidEmit = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: n } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() params: ${e}`);
                throw new Error(n);
            }
            const { topic: t, event: s, chainId: i } = e;
            await this.isValidSessionTopic(t);
            const { namespaces: r } = this.client.session.get(t);
            if (!(0, $a5d33cfc7f8e5437$export$144fc36610eb6522)(r, i)) {
                const { message: n } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(n);
            }
            if (!(0, $a5d33cfc7f8e5437$export$cbe4cdc5960cfa11)(s)) {
                const { message: n } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
                throw new Error(n);
            }
            if (!(0, $a5d33cfc7f8e5437$export$df2c67ef8baad16b)(r, i, s.name)) {
                const { message: n } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
                throw new Error(n);
            }
        }, this.isValidDisconnect = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${e}`);
                throw new Error(s);
            }
            const { topic: t } = e;
            await this.isValidSessionOrPairingTopic(t);
        }, this.isValidAuthenticate = (e)=>{
            const { chains: t, uri: s, domain: i, nonce: r } = e;
            if (!Array.isArray(t) || t.length === 0) throw new Error("chains is required and must be a non-empty array");
            if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(s, !1)) throw new Error("uri is required parameter");
            if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(i, !1)) throw new Error("domain is required parameter");
            if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(r, !1)) throw new Error("nonce is required parameter");
            if ([
                ...new Set(t.map((a)=>(0, $a5d33cfc7f8e5437$export$4764229d78de4437)(a).namespace))
            ].length > 1) throw new Error("Multi-namespace requests are not supported. Please request single namespace only.");
            const { namespace: n } = (0, $a5d33cfc7f8e5437$export$4764229d78de4437)(t[0]);
            if (n !== "eip155") throw new Error("Only eip155 namespace is supported for authenticated sessions. Please use .connect() for non-eip155 chains.");
        }, this.getVerifyContext = async (e)=>{
            const { attestationId: t, hash: s, encryptedId: i, metadata: r, transportType: n } = e, a = {
                verified: {
                    verifyUrl: r.verifyUrl || (0, $e9e439c110f17033$export$7e3b1a28ddecdbaa),
                    validation: "UNKNOWN",
                    origin: r.url || ""
                }
            };
            try {
                if (n === (0, $e9e439c110f17033$export$326e296bb8673773).link_mode) {
                    const h = this.getAppLinkIfEnabled(r, n);
                    return a.verified.validation = h && new URL(h).origin === new URL(r.url).origin ? "VALID" : "INVALID", a;
                }
                const c = await this.client.core.verify.resolve({
                    attestationId: t,
                    hash: s,
                    encryptedId: i,
                    verifyUrl: r.verifyUrl
                });
                c && (a.verified.origin = c.origin, a.verified.isScam = c.isScam, a.verified.validation = c.origin === new URL(r.url).origin ? "VALID" : "INVALID");
            } catch (c) {
                this.client.logger.warn(c);
            }
            return this.client.logger.debug(`Verify context: ${JSON.stringify(a)}`), a;
        }, this.validateSessionProps = (e, t)=>{
            Object.values(e).forEach((s)=>{
                if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(s, !1)) {
                    const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `${t} must be in Record<string, string> format. Received: ${JSON.stringify(s)}`);
                    throw new Error(i);
                }
            });
        }, this.getPendingAuthRequest = (e)=>{
            const t = this.client.auth.requests.get(e);
            return typeof t == "object" ? t : void 0;
        }, this.addToRecentlyDeleted = (e, t)=>{
            if (this.recentlyDeletedMap.set(e, t), this.recentlyDeletedMap.size >= this.recentlyDeletedLimit) {
                let s = 0;
                const i = this.recentlyDeletedLimit / 2;
                for (const r of this.recentlyDeletedMap.keys()){
                    if (s++ >= i) break;
                    this.recentlyDeletedMap.delete(r);
                }
            }
        }, this.checkRecentlyDeleted = (e)=>{
            const t = this.recentlyDeletedMap.get(e);
            if (t) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Record was recently deleted - ${t}: ${e}`);
                throw new Error(s);
            }
        }, this.isLinkModeEnabled = (e, t)=>{
            var s, i, r, n, a, c, h, p, d;
            return !e || t !== (0, $e9e439c110f17033$export$326e296bb8673773).link_mode ? !1 : ((i = (s = this.client.metadata) == null ? void 0 : s.redirect) == null ? void 0 : i.linkMode) === !0 && ((n = (r = this.client.metadata) == null ? void 0 : r.redirect) == null ? void 0 : n.universal) !== void 0 && ((c = (a = this.client.metadata) == null ? void 0 : a.redirect) == null ? void 0 : c.universal) !== "" && ((h = e?.redirect) == null ? void 0 : h.universal) !== void 0 && ((p = e?.redirect) == null ? void 0 : p.universal) !== "" && ((d = e?.redirect) == null ? void 0 : d.linkMode) === !0 && this.client.core.linkModeSupportedApps.includes(e.redirect.universal) && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u";
        }, this.getAppLinkIfEnabled = (e, t)=>{
            var s;
            return this.isLinkModeEnabled(e, t) ? (s = e?.redirect) == null ? void 0 : s.universal : void 0;
        }, this.handleLinkModeMessage = ({ url: e })=>{
            if (!e || !e.includes("wc_ev") || !e.includes("topic")) return;
            const t = (0, $a5d33cfc7f8e5437$export$e35f0b82969c30c3)(e, "topic") || "", s = decodeURIComponent((0, $a5d33cfc7f8e5437$export$e35f0b82969c30c3)(e, "wc_ev") || ""), i = this.client.session.keys.includes(t);
            i && this.client.session.update(t, {
                transportType: (0, $e9e439c110f17033$export$326e296bb8673773).link_mode
            }), this.client.core.dispatchEnvelope({
                topic: t,
                message: s,
                sessionExists: i
            });
        }, this.registerLinkModeListeners = async ()=>{
            var e;
            if ((0, $a5d33cfc7f8e5437$export$b4bb0f87d8376dd4)() || (0, $a5d33cfc7f8e5437$export$f7a1e23e542d38e3)() && (e = this.client.metadata.redirect) != null && e.linkMode) {
                const t = $parcel$global == null ? void 0 : $parcel$global.Linking;
                if (typeof t < "u") {
                    t.addEventListener("url", this.handleLinkModeMessage, this.client.name);
                    const s = await t.getInitialURL();
                    s && setTimeout(()=>{
                        this.handleLinkModeMessage({
                            url: s
                        });
                    }, 50);
                }
            }
        };
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(o);
        }
    }
    async confirmOnlineStateOrThrow() {
        await this.client.core.relayer.confirmOnlineStateOrThrow();
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $e9e439c110f17033$export$d56245796e2837d).message, (o)=>{
            !this.initialized || this.relayMessageCache.length > 0 ? this.relayMessageCache.push(o) : this.onRelayMessage(o);
        });
    }
    async onRelayMessage(o) {
        const { topic: e, message: t, attestation: s, transportType: i } = o, { publicKey: r } = this.client.auth.authKeys.keys.includes($4a472e843fedf2e2$export$efef74cb455ac30f) ? this.client.auth.authKeys.get($4a472e843fedf2e2$export$efef74cb455ac30f) : {
            responseTopic: void 0,
            publicKey: void 0
        }, n = await this.client.core.crypto.decode(e, t, {
            receiverPublicKey: r,
            encoding: i === (0, $e9e439c110f17033$export$326e296bb8673773).link_mode ? (0, $a5d33cfc7f8e5437$export$e9cf21fb8029e645) : (0, $a5d33cfc7f8e5437$export$9bff723d552e6bcf)
        });
        try {
            (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(n) ? (this.client.core.history.set(e, n), this.onRelayEventRequest({
                topic: e,
                payload: n,
                attestation: s,
                transportType: i,
                encryptedId: (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(t)
            })) : (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(n) ? (await this.client.core.history.resolve(n), await this.onRelayEventResponse({
                topic: e,
                payload: n,
                transportType: i
            }), this.client.core.history.delete(e, n.id)) : this.onRelayEventUnknownPayload({
                topic: e,
                payload: n,
                transportType: i
            });
        } catch (a) {
            this.client.logger.error(a);
        }
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $e9e439c110f17033$export$9013719d9206b0c1).expired, async (o)=>{
            const { topic: e, id: t } = (0, $a5d33cfc7f8e5437$export$93adeb0f16e8e51d)(o.target);
            if (t && this.client.pendingRequest.keys.includes(t)) return await this.deletePendingSessionRequest(t, (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED"), !0);
            if (t && this.client.auth.requests.keys.includes(t)) return await this.deletePendingAuthRequest(t, (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED"), !0);
            e ? this.client.session.keys.includes(e) && (await this.deleteSession({
                topic: e,
                expirerHasDeleted: !0
            }), this.client.events.emit("session_expire", {
                topic: e
            })) : t && (await this.deleteProposal(t, !0), this.client.events.emit("proposal_expire", {
                id: t
            }));
        });
    }
    registerPairingEvents() {
        this.client.core.pairing.events.on((0, $e9e439c110f17033$export$ca3c0b962acf7b75).create, (o)=>this.onPairingCreated(o)), this.client.core.pairing.events.on((0, $e9e439c110f17033$export$ca3c0b962acf7b75).delete, (o)=>{
            this.addToRecentlyDeleted(o.topic, "pairing");
        });
    }
    isValidPairingTopic(o) {
        if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(o, !1)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${o}`);
            throw new Error(e);
        }
        if (!this.client.core.pairing.pairings.keys.includes(o)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${o}`);
            throw new Error(e);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.core.pairing.pairings.get(o).expiry)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${o}`);
            throw new Error(e);
        }
    }
    async isValidSessionTopic(o) {
        if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(o, !1)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic should be a string: ${o}`);
            throw new Error(e);
        }
        if (this.checkRecentlyDeleted(o), !this.client.session.keys.includes(o)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session topic doesn't exist: ${o}`);
            throw new Error(e);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.session.get(o).expiry)) {
            await this.deleteSession({
                topic: o
            });
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `session topic: ${o}`);
            throw new Error(e);
        }
        if (!this.client.core.crypto.keychain.has(o)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic does not exist in keychain: ${o}`);
            throw await this.deleteSession({
                topic: o
            }), new Error(e);
        }
    }
    async isValidSessionOrPairingTopic(o) {
        if (this.checkRecentlyDeleted(o), this.client.session.keys.includes(o)) await this.isValidSessionTopic(o);
        else if (this.client.core.pairing.pairings.keys.includes(o)) this.isValidPairingTopic(o);
        else if ((0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(o, !1)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${o}`);
            throw new Error(e);
        } else {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${o}`);
            throw new Error(e);
        }
    }
    async isValidProposalId(o) {
        if (!(0, $a5d33cfc7f8e5437$export$53551be28ad5e34d)(o)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `proposal id should be a number: ${o}`);
            throw new Error(e);
        }
        if (!this.client.proposal.keys.includes(o)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `proposal id doesn't exist: ${o}`);
            throw new Error(e);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.proposal.get(o).expiryTimestamp)) {
            await this.deleteProposal(o);
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `proposal id: ${o}`);
            throw new Error(e);
        }
    }
}
class $4a472e843fedf2e2$var$Ss extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(o, e){
        super(o, e, $4a472e843fedf2e2$export$ae6c7a4f7ed730a1, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96), this.core = o, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$wt extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(o, e){
        super(o, e, $4a472e843fedf2e2$export$a069e98a8dfeec1e, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96), this.core = o, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$Is extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(o, e){
        super(o, e, $4a472e843fedf2e2$export$40b296af21bd38a4, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96, (t)=>t.id), this.core = o, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$fs extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(o, e){
        super(o, e, $4a472e843fedf2e2$export$ab815cb37981e7e0, $4a472e843fedf2e2$export$323ba3ebb8028ed0, ()=>$4a472e843fedf2e2$export$efef74cb455ac30f), this.core = o, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$vs extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(o, e){
        super(o, e, $4a472e843fedf2e2$export$5d9af9e20f678626, $4a472e843fedf2e2$export$323ba3ebb8028ed0), this.core = o, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$qs extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(o, e){
        super(o, e, $4a472e843fedf2e2$export$3643b3579d091159, $4a472e843fedf2e2$export$323ba3ebb8028ed0, (t)=>t.id), this.core = o, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$Ts {
    constructor(o, e){
        this.core = o, this.logger = e, this.authKeys = new $4a472e843fedf2e2$var$fs(this.core, this.logger), this.pairingTopics = new $4a472e843fedf2e2$var$vs(this.core, this.logger), this.requests = new $4a472e843fedf2e2$var$qs(this.core, this.logger);
    }
    async init() {
        await this.authKeys.init(), await this.pairingTopics.init(), await this.requests.init();
    }
}
class $4a472e843fedf2e2$export$2e2bcd8739ae039 extends (0, $bace94c1ef08d1bc$export$2ebcf6eeacedad44) {
    constructor(o){
        super(o), this.protocol = $4a472e843fedf2e2$export$4fa962fc67384e02, this.version = $4a472e843fedf2e2$export$61085c48796ff049, this.name = $4a472e843fedf2e2$export$8dffb3242f2c5f72.name, this.events = new (0, $7etJZ.EventEmitter), this.on = (t, s)=>this.events.on(t, s), this.once = (t, s)=>this.events.once(t, s), this.off = (t, s)=>this.events.off(t, s), this.removeListener = (t, s)=>this.events.removeListener(t, s), this.removeAllListeners = (t)=>this.events.removeAllListeners(t), this.connect = async (t)=>{
            try {
                return await this.engine.connect(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.pair = async (t)=>{
            try {
                return await this.engine.pair(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.approve = async (t)=>{
            try {
                return await this.engine.approve(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.reject = async (t)=>{
            try {
                return await this.engine.reject(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.update = async (t)=>{
            try {
                return await this.engine.update(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.extend = async (t)=>{
            try {
                return await this.engine.extend(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.request = async (t)=>{
            try {
                return await this.engine.request(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.respond = async (t)=>{
            try {
                return await this.engine.respond(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.ping = async (t)=>{
            try {
                return await this.engine.ping(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.emit = async (t)=>{
            try {
                return await this.engine.emit(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.disconnect = async (t)=>{
            try {
                return await this.engine.disconnect(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.find = (t)=>{
            try {
                return this.engine.find(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.getPendingSessionRequests = ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.authenticate = async (t, s)=>{
            try {
                return await this.engine.authenticate(t, s);
            } catch (i) {
                throw this.logger.error(i.message), i;
            }
        }, this.formatAuthMessage = (t)=>{
            try {
                return this.engine.formatAuthMessage(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.approveSessionAuthenticate = async (t)=>{
            try {
                return await this.engine.approveSessionAuthenticate(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.rejectSessionAuthenticate = async (t)=>{
            try {
                return await this.engine.rejectSessionAuthenticate(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.name = o?.name || $4a472e843fedf2e2$export$8dffb3242f2c5f72.name, this.metadata = o?.metadata || (0, $a5d33cfc7f8e5437$export$ba31e015127122bb)(), this.signConfig = o?.signConfig;
        const e = typeof o?.logger < "u" && typeof o?.logger != "string" ? o.logger : (0, (/*@__PURE__*/$parcel$interopDefault($03ceb28a240053b3$exports)))((0, $704ed3be9612b960$export$bad2475df51c8ecc)({
            level: o?.logger || $4a472e843fedf2e2$export$8dffb3242f2c5f72.logger
        }));
        this.core = o?.core || new (0, $e9e439c110f17033$export$4143ab5b91744744)(o), this.logger = (0, $704ed3be9612b960$export$4929e0372308a636)(e, this.name), this.session = new $4a472e843fedf2e2$var$wt(this.core, this.logger), this.proposal = new $4a472e843fedf2e2$var$Ss(this.core, this.logger), this.pendingRequest = new $4a472e843fedf2e2$var$Is(this.core, this.logger), this.engine = new $4a472e843fedf2e2$var$Rs(this), this.auth = new $4a472e843fedf2e2$var$Ts(this.core, this.logger);
    }
    static async init(o) {
        const e = new $4a472e843fedf2e2$export$2e2bcd8739ae039(o);
        return await e.initialize(), e;
    }
    get context() {
        return (0, $704ed3be9612b960$export$a283a9a0054a3c25)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.auth.init(), await this.engine.init(), this.logger.info("SignClient Initialization Success"), setTimeout(()=>{
                this.engine.processRelayMessageCache();
            }, (0, $7c6109395b060f04$exports.toMiliseconds)((0, $7c6109395b060f04$exports.ONE_SECOND)));
        } catch (o) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(o.message), o;
        }
    }
}
const $4a472e843fedf2e2$export$90b8cff65c105172 = $4a472e843fedf2e2$var$wt, $4a472e843fedf2e2$export$bdf4ba258ec679dc = $4a472e843fedf2e2$export$2e2bcd8739ae039;



/**
 *  @category Error
 *  @description Error that indicates the wallet returned an invalid namespace
 */ class $25bd6556c6bb5256$export$7221abf9e1c5a9d3 extends Error {
    messageWc;
    codeWc;
    data;
    name = 'InvalidReceivedSessionNamespace';
    constructor(messageWc, codeWc, type, data){
        super();
        this.messageWc = messageWc;
        this.codeWc = codeWc;
        this.data = data;
        const baseMessage = `${codeWc}: ${messageWc}.`;
        this.message = data ? type === 'incomplete' ? ` ${baseMessage} "${data}" is missing in the session namespace.` : ` ${baseMessage} "${data}" is invalid.` : baseMessage;
    }
}
class $25bd6556c6bb5256$export$1cde3ed2cbe72e01 extends Error {
    name = 'NotConnected';
    constructor(){
        super('Not connected, no active session');
    }
}
class $25bd6556c6bb5256$export$7e47d038b16ef45 extends Error {
    name = 'InvalidSession';
    constructor(message){
        super(message);
    }
}
class $25bd6556c6bb5256$export$4249c9bca2aaa9d6 extends Error {
    requiredScopes;
    name = 'MissingRequiredScope';
    constructor(requiredScopes){
        super(`Required permission scope were not granted for "${requiredScopes}"`);
        this.requiredScopes = requiredScopes;
    }
}
class $25bd6556c6bb5256$export$c452d961b2f5bbc8 extends Error {
    name = 'ActiveNetworkUnspecified';
    constructor(){
        super('Please specify the active network using the "setActiveNetwork" method.');
    }
}
class $25bd6556c6bb5256$export$9f2fae8b078ef617 extends Error {
    name = 'ActiveAccountUnspecified';
    constructor(){
        super('Please specify the active account using the "setActiveAccount" method.');
    }
}
class $25bd6556c6bb5256$export$b2b15e10d2216872 extends Error {
    network;
    pkh;
    name = 'InvalidNetworkOrAccount';
    constructor(network, pkh){
        super(`No permission. The combination "${network}" and "${pkh}" is not part of the active session.`);
        this.network = network;
        this.pkh = pkh;
    }
}




const $b3ff264909373f94$var$TEZOS_PLACEHOLDER = 'tezos';
const $b3ff264909373f94$var$BEACON_SDK_VERSION = 'beacon_sdk_version';
const $b3ff264909373f94$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('WalletConnectCommunicationClient');
var $b3ff264909373f94$export$559e0d74bdbaf281;
(function(PermissionScopeMethods) {
    PermissionScopeMethods["GET_ACCOUNTS"] = "tezos_getAccounts";
    PermissionScopeMethods["OPERATION_REQUEST"] = "tezos_send";
    PermissionScopeMethods["SIGN"] = "tezos_sign";
})($b3ff264909373f94$export$559e0d74bdbaf281 || ($b3ff264909373f94$export$559e0d74bdbaf281 = {}));
var $b3ff264909373f94$export$f1e62dbda8d1b508;
(function(PermissionScopeEvents) {
    PermissionScopeEvents["CHAIN_CHANGED"] = "chainChanged";
    PermissionScopeEvents["ACCOUNTS_CHANGED"] = "accountsChanged";
    PermissionScopeEvents["REQUEST_ACKNOWLEDGED"] = "requestAcknowledged";
})($b3ff264909373f94$export$f1e62dbda8d1b508 || ($b3ff264909373f94$export$f1e62dbda8d1b508 = {}));
function $b3ff264909373f94$var$getStringBetween(str, startChar, endChar) {
    if (!str || !startChar || !endChar) return '';
    const startIndex = str.indexOf(startChar);
    const endIndex = str.indexOf(endChar, startIndex + 1);
    if (startIndex === -1 || endIndex === -1) throw new Error('String not found');
    return str.substring(startIndex + 1, endIndex);
}
class $b3ff264909373f94$export$155bb858c3ee1d84 extends (0, $a78bfde4d24b2c3a$export$ff98bc0bfc6c5f28) {
    wcOptions;
    isLeader;
    activeListeners = new Map();
    channelOpeningListeners = new Map();
    static instance;
    signClient;
    storage = new (0, $1fb6b7142554ff86$export$3095297bb9e84116)();
    session;
    activeAccountOrPbk;
    activeNetwork;
    disconnectionEvents = new Set();
    pingInterval;
    /**
     * this queue stores each active message id
     * [0] newest message
     * [length - 1] oldest message
     */ messageIds = [];
    /**
     * Tracks the last time session extension was attempted (Unix timestamp in seconds)
     * Used to prevent duplicate re-extension attempts that can cause relay conflicts
     */ lastExtensionAttempt = 0;
    constructor(wcOptions, isLeader){
        super();
        this.wcOptions = wcOptions;
        this.isLeader = isLeader;
        this.storage.onMessageHandler = this.onStorageMessageHandler.bind(this);
        this.storage.onErrorHandler = this.onStorageErrorHandler.bind(this);
    }
    static getInstance(wcOptions, isLeader) {
        if (!this.instance) this.instance = new $b3ff264909373f94$export$155bb858c3ee1d84(wcOptions, isLeader);
        return $b3ff264909373f94$export$155bb858c3ee1d84.instance;
    }
    getTopicFromSession(session) {
        return session.topic;
    }
    async listenForEncryptedMessage(senderPublicKey, messageCallback) {
        if (this.activeListeners.has(senderPublicKey)) return;
        const callbackFunction = async (message)=>{
            messageCallback(message);
        };
        this.activeListeners.set(senderPublicKey, callbackFunction);
    }
    async listenForChannelOpening(messageCallback) {
        const callbackFunction = async (pairingResponse)=>{
            messageCallback(pairingResponse);
        };
        this.channelOpeningListeners.set('channelOpening', callbackFunction);
    }
    /**
     * WC Sign client doesn't sync between intances, meaning that a dApp signClient instance state may
     * differ from a wallet state
     */ async refreshState() {
        await this.closeSignClient();
        const client = await this.getSignClient();
        const lastIndex = client.session.keys.length - 1;
        if (lastIndex > -1) {
            const restoredSession = client.session.get(client.session.keys[lastIndex]);
            // Validate session is not stale
            if (await this.isSessionValid(restoredSession)) {
                this.session = restoredSession;
                this.updateStorageWallet(this.session);
                this.setDefaultAccountAndNetwork();
            } else {
                $b3ff264909373f94$var$logger.warn('Restored session is stale during refresh, cleaning up');
                await this.cleanupStaleSession(restoredSession);
                this.clearState();
            }
        } else this.clearState();
    }
    clearEvents() {
        this.signClient?.removeAllListeners('session_event');
        this.signClient?.removeAllListeners('session_update');
        this.signClient?.removeAllListeners('session_delete');
        this.signClient?.removeAllListeners('session_expire');
        this.signClient?.removeAllListeners('session_extend');
        this.signClient?.removeAllListeners('proposal_expire');
        this.signClient?.core.pairing.events.removeAllListeners('pairing_delete');
        this.signClient?.core.pairing.events.removeAllListeners('pairing_expire');
    }
    onStorageMessageHandler(type) {
        if (!this.isMobileOS()) return;
        $b3ff264909373f94$var$logger.debug('onStorageMessageHandler', type);
        if (type === 'RESET') {
            this.clearEvents();
            // no need to invoke `closeSignClinet` as the other tab already closed the connection
            this.signClient = undefined;
            this.clearState();
            this.messageIds = [];
            return;
        }
        this.refreshState();
    }
    onStorageErrorHandler(data) {
        $b3ff264909373f94$var$logger.error('onStorageError', data);
    }
    async unsubscribeFromEncryptedMessages() {
        this.activeListeners.clear();
        this.channelOpeningListeners.clear();
    }
    async unsubscribeFromEncryptedMessage(_senderPublicKey) {
    // implementation
    }
    async closeSignClient() {
        if (!this.signClient) {
            $b3ff264909373f94$var$logger.error('No client active');
            return;
        }
        await this.signClient.core.relayer.transportClose();
        this.signClient.core.events.removeAllListeners();
        this.signClient.core.relayer.events.removeAllListeners();
        this.signClient.core.heartbeat.stop();
        this.signClient.core.relayer.provider.events.removeAllListeners();
        this.signClient.core.relayer.subscriber.events.removeAllListeners();
        this.signClient.core.relayer.provider.connection.events.removeAllListeners();
        this.clearEvents();
        this.signClient = undefined;
    }
    async ping() {
        const client = await this.getSignClient();
        if (!client || !this.session) {
            $b3ff264909373f94$var$logger.error('No session available.');
            return;
        }
        client.ping({
            topic: this.session.topic
        }).then(()=>{
            if (this.messageIds.length) this.acknowledgeRequest(this.messageIds[0]);
        }).catch((error)=>{
            $b3ff264909373f94$var$logger.error(`ping catch handler: ${error.message}`);
        }).then(()=>{
            clearInterval(this.pingInterval);
            this.pingInterval = undefined;
        });
    }
    async checkWalletReadiness(_topic) {
        if (this.isMobileOS() || this.pingInterval) return;
        this.ping();
        this.pingInterval = setInterval(()=>{
            this.ping();
        }, 30000);
    }
    async sendMessage(_message, _peer) {
        const serializer = new (0, $33b837e22eef79cd$export$ef852775387a0be7)();
        const message = await serializer.deserialize(_message);
        if (!message) return;
        this.messageIds.unshift(message.id);
        switch(message.type){
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest:
                this.requestPermissions(message);
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).OperationRequest:
                this.sendOperations(message);
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SignPayloadRequest:
                this.signPayload(message);
                break;
            default:
                return;
        }
    }
    async fetchAccounts(topic, chainId) {
        const signClient = await this.getSignClient();
        if (!signClient) return;
        return signClient.request({
            topic: topic,
            chainId: chainId,
            request: {
                method: $b3ff264909373f94$export$559e0d74bdbaf281.GET_ACCOUNTS,
                params: {}
            }
        });
    }
    async notifyListenersWithPermissionResponse(session, network, sessionEventId) {
        let publicKey;
        if (session.sessionProperties?.pubkey && session.sessionProperties?.algo && session.sessionProperties?.address) {
            publicKey = session.sessionProperties?.pubkey;
            $b3ff264909373f94$var$logger.log('[requestPermissions]: Have pubkey in sessionProperties, skipping "get_accounts" call', session.sessionProperties);
        } else {
            const accounts = this.getTezosNamespace(session.namespaces).accounts;
            const addressOrPbk = accounts[0].split(':', 3)[2];
            if ((0, $efd1a952be4e6fd9$export$212c5439ed082413)(addressOrPbk)) publicKey = addressOrPbk;
            else {
                if (network.type !== this.wcOptions.network) throw new Error('Network in permission request is not the same as preferred network!');
                const result = await this.fetchAccounts(session.topic, `${$b3ff264909373f94$var$TEZOS_PLACEHOLDER}:${network.type}`);
                if (!result || result.length < 1) throw new Error('No account shared by wallet');
                if (result.some((account)=>!account.pubkey)) throw new Error('Public Key in `tezos_getAccounts` is empty!');
                publicKey = result[0]?.pubkey;
            }
        }
        if (!publicKey) throw new Error('Public Key in `tezos_getAccounts` is empty!');
        const permissionResponse = {
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionResponse,
            appMetadata: {
                senderId: this.getTopicFromSession(session),
                name: session.peer.metadata.name,
                icon: session.peer.metadata.icons[0]
            },
            publicKey: publicKey,
            network: network,
            scopes: [
                (0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).SIGN,
                (0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).OPERATION_REQUEST
            ],
            id: sessionEventId ?? this.messageIds.pop() ?? '',
            walletType: 'implicit'
        };
        this.notifyListeners(this.getTopicFromSession(session), permissionResponse);
    }
    async requestPermissions(message) {
        $b3ff264909373f94$var$logger.log('#### Requesting permissions');
        if (!this.getPermittedMethods().includes($b3ff264909373f94$export$559e0d74bdbaf281.GET_ACCOUNTS)) throw new (0, $25bd6556c6bb5256$export$4249c9bca2aaa9d6)($b3ff264909373f94$export$559e0d74bdbaf281.GET_ACCOUNTS);
        if (this.activeAccountOrPbk) try {
            await this.openSession();
        } catch (error) {
            $b3ff264909373f94$var$logger.error(error.message);
            return;
        }
        this.setDefaultAccountAndNetwork();
        this.notifyListenersWithPermissionResponse(this.getSession(), message.network);
    }
    /**
     * @description Once the session is establish, send payload to be approved and signed by the wallet.
     * @error MissingRequiredScope is thrown if permission to sign payload was not granted
     */ async signPayload(signPayloadRequest) {
        const signClient = await this.getSignClient();
        if (!signClient) return;
        const session = this.getSession();
        if (!this.getPermittedMethods().includes($b3ff264909373f94$export$559e0d74bdbaf281.SIGN)) throw new (0, $25bd6556c6bb5256$export$4249c9bca2aaa9d6)($b3ff264909373f94$export$559e0d74bdbaf281.SIGN);
        // Extend session if needed before making request
        await this.checkAndExtendSession();
        const network = this.getActiveNetwork();
        const account = await this.getAccountOrPK();
        this.validateNetworkAndAccount(network, account);
        this.checkWalletReadiness(this.getTopicFromSession(session));
        // TODO: Type
        signClient.request({
            topic: session.topic,
            chainId: `${$b3ff264909373f94$var$TEZOS_PLACEHOLDER}:${network}`,
            request: {
                method: $b3ff264909373f94$export$559e0d74bdbaf281.SIGN,
                params: {
                    account: (0, $efd1a952be4e6fd9$export$212c5439ed082413)(account) ? await (0, $efd1a952be4e6fd9$export$a28ea21350b9dd16)(account) : account,
                    payload: signPayloadRequest.payload
                }
            }
        }).then((response)=>{
            const signPayloadResponse = {
                type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SignPayloadResponse,
                signingType: signPayloadRequest.signingType,
                signature: response?.signature,
                id: this.messageIds.pop()
            };
            this.notifyListeners(this.getTopicFromSession(session), signPayloadResponse);
            if (this.session && this.messageIds.length) this.checkWalletReadiness(this.getTopicFromSession(session));
        }).catch(async ()=>{
            const errorResponse = {
                type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Error,
                id: this.messageIds.pop(),
                errorType: (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR
            };
            this.notifyListeners(this.getTopicFromSession(session), errorResponse);
            if (this.session && this.messageIds.length) this.checkWalletReadiness(this.getTopicFromSession(session));
        });
    }
    /**
     * @description Once the session is established, send Tezos operations to be approved, signed and inject by the wallet.
     * @error MissingRequiredScope is thrown if permission to send operation was not granted
     */ async sendOperations(operationRequest) {
        const signClient = await this.getSignClient();
        if (!signClient) return;
        const session = this.getSession();
        if (!this.getPermittedMethods().includes($b3ff264909373f94$export$559e0d74bdbaf281.OPERATION_REQUEST)) throw new (0, $25bd6556c6bb5256$export$4249c9bca2aaa9d6)($b3ff264909373f94$export$559e0d74bdbaf281.OPERATION_REQUEST);
        // Extend session if needed before making request
        await this.checkAndExtendSession();
        const network = this.getActiveNetwork();
        const account = await this.getAccountOrPK();
        this.validateNetworkAndAccount(network, account);
        this.checkWalletReadiness(this.getTopicFromSession(session));
        signClient.request({
            topic: session.topic,
            chainId: `${$b3ff264909373f94$var$TEZOS_PLACEHOLDER}:${network}`,
            request: {
                method: $b3ff264909373f94$export$559e0d74bdbaf281.OPERATION_REQUEST,
                params: {
                    account: (0, $efd1a952be4e6fd9$export$212c5439ed082413)(account) ? await (0, $efd1a952be4e6fd9$export$a28ea21350b9dd16)(account) : account,
                    operations: operationRequest.operationDetails
                }
            }
        }).then((response)=>{
            const sendOperationResponse = {
                type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).OperationResponse,
                transactionHash: response.operationHash ?? response.transactionHash ?? response.hash ?? '',
                id: this.messageIds.pop() ?? ''
            };
            this.notifyListeners(this.getTopicFromSession(session), sendOperationResponse);
            if (this.session && this.messageIds.length) this.checkWalletReadiness(this.getTopicFromSession(session));
        }).catch(async ()=>{
            const errorResponse = {
                type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Error,
                id: this.messageIds.pop(),
                errorType: (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR
            };
            this.notifyListeners(this.getTopicFromSession(session), errorResponse);
            if (this.session && this.messageIds.length) this.checkWalletReadiness(this.getTopicFromSession(session));
        });
    }
    isMobileSesion(session) {
        const redirect = session.peer.metadata.redirect;
        return !!redirect && !!redirect.native && !redirect.native.includes('http') && !redirect.native.includes('ws');
    }
    /**
     * Function used to fix appSwitching with web wallets when pairing through 'Other wallet flow'
     * @param session the newly created session
     */ updateStorageWallet(session) {
        const selectedWallet = JSON.parse(localStorage.getItem((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).LAST_SELECTED_WALLET) ?? '{}');
        if (!selectedWallet.key) return;
        if (this.isMobileSesion(session)) selectedWallet.type = 'mobile';
        else selectedWallet.type = 'web';
        localStorage.setItem((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).LAST_SELECTED_WALLET, JSON.stringify(selectedWallet));
    }
    async init(forceNewConnection = false) {
        $b3ff264909373f94$var$logger.warn('init');
        this.disconnectionEvents.size && this.disconnectionEvents.clear();
        if (forceNewConnection) await this.closePairings();
        const signClient = await this.getSignClient();
        if (!signClient) throw new Error('Failed to connect to the relayer.');
        const lastIndex = signClient.session.keys.length - 1;
        if (lastIndex > -1) {
            const restoredSession = signClient.session.get(signClient.session.keys[lastIndex]);
            // Validate session is not stale
            if (await this.isSessionValid(restoredSession)) {
                this.session = restoredSession;
                this.updateStorageWallet(this.session);
                this.setDefaultAccountAndNetwork();
                // Check if session needs extension (within 24 hours of expiry)
                await this.checkAndExtendSession();
                return undefined;
            } else {
                $b3ff264909373f94$var$logger.warn('Restored session is stale, cleaning up and creating new connection');
                await this.cleanupStaleSession(restoredSession);
            // Fall through to create new connection below
            }
        }
        $b3ff264909373f94$var$logger.warn('before create');
        const permissionScopeParams = {
            networks: [
                this.wcOptions.network
            ],
            events: [],
            methods: [
                $b3ff264909373f94$export$559e0d74bdbaf281.GET_ACCOUNTS,
                $b3ff264909373f94$export$559e0d74bdbaf281.OPERATION_REQUEST,
                $b3ff264909373f94$export$559e0d74bdbaf281.SIGN
            ]
        };
        const optionalPermissionScopeParams = {
            networks: [
                this.wcOptions.network
            ],
            events: [
                $b3ff264909373f94$export$f1e62dbda8d1b508.REQUEST_ACKNOWLEDGED
            ],
            methods: []
        };
        const connectParams = {
            requiredNamespaces: {
                [$b3ff264909373f94$var$TEZOS_PLACEHOLDER]: this.permissionScopeParamsToNamespaces(permissionScopeParams)
            },
            optionalNamespaces: {
                [$b3ff264909373f94$var$TEZOS_PLACEHOLDER]: this.permissionScopeParamsToNamespaces(optionalPermissionScopeParams)
            },
            sessionProperties: {
                [$b3ff264909373f94$var$BEACON_SDK_VERSION]: (0, $217f751cff903b1b$export$31499a9cd224b78c)
            }
        };
        const { uri: uri, approval: approval } = await Promise.race([
            signClient.connect(connectParams),
            new Promise((_, reject)=>setTimeout(()=>reject(new Error('The connection timed out.')), 60000))
        ]).catch((error)=>{
            $b3ff264909373f94$var$logger.error(`Init error: ${error.message}`);
            localStorage && localStorage.setItem((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_INIT_ERROR, error.message);
            throw new Error(error.message);
        });
        // Extract topic from uri. Format is wc:topic@2...
        const topic = $b3ff264909373f94$var$getStringBetween(uri, ':', '@');
        if (!topic) return;
        let hasResponse = false;
        signClient.core.pairing.ping({
            topic: topic
        }).then(async ()=>{
            if (!hasResponse) {
                // Only show "waiting for acknowledge" message if pong arrives before response
                const fun = this.eventHandlers.get("WC_ACK_NOTIFICATION" /* ClientEvents.WC_ACK_NOTIFICATION */ );
                fun && fun('pending');
            }
        }).catch((err)=>{
            console.error('--------', err);
        });
        approval().then((session)=>{
            $b3ff264909373f94$var$logger.debug('session open');
            hasResponse = true;
            this.updateStorageWallet(session);
            const pairingResponse = new (0, $e10c8d28a45e9074$export$5edcb89f336f8361)(session.topic, session.peer.metadata.name, session.peer.publicKey, '3', session.topic, session.peer.metadata.name);
            this.channelOpeningListeners.forEach((listener)=>{
                listener(pairingResponse);
            });
            if (session?.controller !== this.session?.controller) {
                $b3ff264909373f94$var$logger.debug('Controller doesnt match, closing active session', [
                    session.pairingTopic
                ]);
                this.activeAccountOrPbk && this.closeActiveSession(this.activeAccountOrPbk, false);
                this.session = undefined; // close the previous session
            }
            // We need this check in the event the user aborts the sync process on the wallet side
            // but there is already a connection set
            this.session = this.session ?? session;
            $b3ff264909373f94$var$logger.debug('Session is now', [
                session.pairingTopic
            ]);
            this.validateReceivedNamespace(permissionScopeParams, this.session.namespaces);
        }).catch(async (error)=>{
            hasResponse = true;
            if (!error.message || !error.message.length || error.message.toLowerCase().includes('expir')) {
                const fun = this.eventHandlers.get("CLOSE_ALERT" /* ClientEvents.CLOSE_ALERT */ );
                fun && fun((0, $809a8ab02b228419$export$6d07abd9f0bba447).WALLETCONNECT);
                return;
            }
            $b3ff264909373f94$var$logger.error('Error happened!', [
                error.message
            ]);
            if (this.activeListeners.size === 0) {
                $b3ff264909373f94$var$logger.debug('No active listeners', []);
                const fun = this.eventHandlers.get("WC_ACK_NOTIFICATION" /* ClientEvents.WC_ACK_NOTIFICATION */ );
                fun && fun('error');
            } else {
                const _pairingTopic = topic ?? signClient.core.pairing.getPairings()[0]?.topic;
                $b3ff264909373f94$var$logger.debug('New pairing topic?', []);
                const errorResponse = {
                    type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Error,
                    id: this.messageIds.pop(),
                    errorType: (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR
                };
                this.notifyListeners(_pairingTopic, errorResponse);
            }
        }).then(async ()=>{
            const isLeader = await this.isLeader();
            if (!isLeader && !this.isMobileOS()) {
                await this.closeSignClient();
                this.clearState();
            }
        });
        $b3ff264909373f94$var$logger.warn('return uri and topic');
        return {
            uri: uri ?? '',
            topic: topic
        };
    }
    async close() {
        this.storage.backup();
        await this.closePairings();
        this.unsubscribeFromEncryptedMessages();
        this.messageIds = [];
    }
    subscribeToSessionEvents(signClient) {
        // JWT validation error
        const baseHandler = signClient.core.relayer.onProviderErrorHandler;
        const handler = async (event)=>{
            $b3ff264909373f94$var$logger.error('subscribeToSessionEvents', event);
            if (event.message?.includes('JWT validation error')) {
                const fun = this.eventHandlers.get("ON_RELAYER_ERROR" /* ClientEvents.ON_RELAYER_ERROR */ );
                fun && fun((0, $809a8ab02b228419$export$6d07abd9f0bba447).WALLETCONNECT);
            }
            await this.close();
            this.clearState();
            signClient.core.relayer.onProviderErrorHandler = baseHandler;
        };
        signClient.core.relayer.onProviderErrorHandler = handler;
        signClient.on('session_event', (event)=>{
            if (event.params.event.name === $b3ff264909373f94$export$f1e62dbda8d1b508.REQUEST_ACKNOWLEDGED && this.messageIds.length) this.acknowledgeRequest(this.messageIds[0]);
        });
        signClient.on('session_update', (event)=>{
            const session = signClient.session.get(event.topic);
            if (!session) {
                $b3ff264909373f94$var$logger.warn('session_update', 'topic does not exist');
                return;
            }
            this.session = session;
            this.updateActiveAccount(this.getTezosNamespace(event.params.namespaces).accounts, session);
        });
        signClient.on('session_delete', (event)=>{
            this.disconnectionEvents.add('session_delete');
            this.disconnect(signClient, {
                type: 'session',
                topic: event.topic
            });
        });
        signClient.on('session_expire', (event)=>{
            this.disconnectionEvents.add('session_expire');
            this.disconnect(signClient, {
                type: 'session',
                topic: event.topic
            });
        });
        signClient.core.pairing.events.on('pairing_delete', (event)=>{
            $b3ff264909373f94$var$logger.debug('Pairing deleted', {
                topic: event.topic
            });
        // Don't disconnect session - pairings can be deleted while sessions remain active
        // Sessions communicate directly through the relay after initial pairing
        });
        signClient.core.pairing.events.on('pairing_expire', (event)=>{
            $b3ff264909373f94$var$logger.debug('Pairing expired', {
                topic: event.topic
            });
        // Don't disconnect session - pairings expire, but sessions can outlive them. Only disconnect on session_expire/session_delete
        });
        signClient.on('proposal_expire', (event)=>{
            $b3ff264909373f94$var$logger.debug('Session proposal expired', event.id);
        });
        signClient.on('session_extend', (event)=>{
            $b3ff264909373f94$var$logger.debug('Session extended', event.topic);
            // Session was extended by 7 days
            // Update our session reference if it matches
            if (this.session && this.session.topic === event.topic) {
                const updatedSession = signClient.session.get(event.topic);
                if (updatedSession) {
                    this.session = updatedSession;
                    $b3ff264909373f94$var$logger.log('Active session extended, new expiry:', new Date(updatedSession.expiry * 1000));
                }
            }
        });
    }
    async acknowledgeRequest(id) {
        const session = this.getSession();
        const acknowledgeResponse = {
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Acknowledge,
            id: id
        };
        this.notifyListeners(this.getTopicFromSession(session), acknowledgeResponse);
    }
    async updateActiveAccount(accounts, session) {
        try {
            if (accounts.length) {
                const [_namespace, chainId, addressOrPbk] = accounts[0].split(':', 3);
                const session = this.getSession();
                let publicKey;
                this.activeNetwork = chainId;
                this.activeAccountOrPbk = addressOrPbk;
                if (!(0, $efd1a952be4e6fd9$export$212c5439ed082413)(addressOrPbk)) {
                    const token = accounts[1] ? accounts[1].split(':', 3)[2] : '';
                    if ((0, $efd1a952be4e6fd9$export$212c5439ed082413)(token)) publicKey = token;
                    else {
                        const result = await this.fetchAccounts(session.topic, `${$b3ff264909373f94$var$TEZOS_PLACEHOLDER}:${chainId}`);
                        publicKey = result?.find(({ address: _address })=>addressOrPbk === _address)?.pubkey;
                    }
                } else publicKey = addressOrPbk;
                if (!publicKey) throw new Error('Public key for the new account not provided');
                this.notifyListeners(this.getTopicFromSession(session), {
                    id: await (0, $788668db41590f82$export$2dbe1b699c206fb)(),
                    type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).ChangeAccountRequest,
                    publicKey: publicKey,
                    network: {
                        type: chainId
                    },
                    scopes: [
                        (0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).SIGN,
                        (0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).OPERATION_REQUEST
                    ],
                    walletType: 'implicit'
                });
            } else this.notifyListenersWithPermissionResponse(session, {
                type: this.wcOptions.network
            }, 'session_update');
        } catch  {}
    }
    async disconnect(signClient, trigger) {
        const session = await this.onSessionClosed(signClient, trigger.topic);
        if (!this.activeAccountOrPbk) {
            const fun = this.eventHandlers.get("RESET_STATE" /* ClientEvents.RESET_STATE */ );
            fun && fun((0, $809a8ab02b228419$export$6d07abd9f0bba447).WALLETCONNECT);
        }
        if (!session) return;
        this.notifyListeners(this.getTopicFromSession(session), {
            id: await (0, $788668db41590f82$export$2dbe1b699c206fb)(),
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Disconnect
        });
        this.clearState();
    }
    async onSessionClosed(signClient, sessionTopic) {
        if (!this.session || this.session.topic !== sessionTopic) return undefined;
        try {
            // todo close the matching session and not just the first one
            if (!this.session.pairingTopic) await signClient.core.pairing.disconnect({
                topic: signClient.core.pairing.getPairings()[0]?.topic
            });
            else await signClient.core.pairing.disconnect({
                topic: this.session.pairingTopic
            });
        } catch (error) {
            // If the pairing was already closed, `disconnect` will throw an error.
            $b3ff264909373f94$var$logger.warn(error.message);
        }
        return this.session;
    }
    async getPairingRequestInfo() {
        let _uri = '', _topic = '';
        try {
            $b3ff264909373f94$var$logger.warn('getPairingRequestInfo');
            const { uri: uri, topic: topic } = await this.init(true) ?? {
                uri: '',
                topic: ''
            };
            _uri = uri;
            _topic = topic;
        } catch (error) {
            console.warn(error.message);
        }
        return new (0, $40e5f66fcc7157a8$export$6e43c36514596f83)(_topic, 'WalletConnect', await (0, $788668db41590f82$export$2dbe1b699c206fb)(), (0, $217f751cff903b1b$export$2220237b3fa2434a), await (0, $788668db41590f82$export$2dbe1b699c206fb)(), _uri);
    }
    async closePairings() {
        if (!this.signClient) return;
        await this.closeSessions();
        const signClient = await this.getSignClient();
        const pairings = signClient.pairing.getAll() ?? [];
        pairings.length && await Promise.allSettled(pairings.map((pairing)=>signClient.disconnect({
                topic: pairing.topic,
                reason: {
                    code: 0,
                    message: 'Force new connection'
                }
            })));
        await this.closeSignClient();
        this.isMobileOS() && await this.storage.resetState();
        this.isMobileOS() && this.storage.notify('RESET');
    }
    async closeSessions() {
        if (!this.signClient) return;
        const signClient = await this.getSignClient();
        const sessions = signClient.session.getAll() ?? [];
        sessions.length && await Promise.allSettled(sessions.map((session)=>signClient.disconnect({
                topic: session.topic,
                reason: {
                    code: 0,
                    message: 'Force new connection'
                }
            })));
        this.clearState();
    }
    async openSession() {
        const signClient = await this.getSignClient();
        const pairingTopic = signClient.core.pairing.getPairings()[0]?.topic;
        $b3ff264909373f94$var$logger.debug('Starting open session with', [
            pairingTopic
        ]);
        if (!signClient) throw new Error('Transport error.');
        const permissionScopeParams = {
            networks: [
                this.wcOptions.network
            ],
            events: [],
            methods: [
                $b3ff264909373f94$export$559e0d74bdbaf281.GET_ACCOUNTS,
                $b3ff264909373f94$export$559e0d74bdbaf281.OPERATION_REQUEST,
                $b3ff264909373f94$export$559e0d74bdbaf281.SIGN
            ]
        };
        const optionalPermissionScopeParams = {
            networks: [
                this.wcOptions.network
            ],
            events: [
                $b3ff264909373f94$export$f1e62dbda8d1b508.REQUEST_ACKNOWLEDGED
            ],
            methods: []
        };
        const connectParams = {
            requiredNamespaces: {
                [$b3ff264909373f94$var$TEZOS_PLACEHOLDER]: this.permissionScopeParamsToNamespaces(permissionScopeParams)
            },
            optionalNamespaces: {
                [$b3ff264909373f94$var$TEZOS_PLACEHOLDER]: this.permissionScopeParamsToNamespaces(optionalPermissionScopeParams)
            },
            sessionProperties: {
                [$b3ff264909373f94$var$BEACON_SDK_VERSION]: (0, $217f751cff903b1b$export$31499a9cd224b78c)
            },
            pairingTopic: pairingTopic
        };
        $b3ff264909373f94$var$logger.debug('Checking wallet readiness', [
            pairingTopic
        ]);
        this.checkWalletReadiness(pairingTopic);
        try {
            $b3ff264909373f94$var$logger.debug('connect', [
                pairingTopic
            ]);
            const { approval: approval } = await Promise.race([
                signClient.connect(connectParams),
                new Promise((_, reject)=>setTimeout(()=>reject(new Error('The connection timed out.')), 60000))
            ]);
            $b3ff264909373f94$var$logger.debug('before await approal', [
                pairingTopic
            ]);
            const session = await approval();
            $b3ff264909373f94$var$logger.debug('after await approal, have session', [
                pairingTopic
            ]);
            // if I have successfully opened a session and I already have one opened
            if (session?.controller !== this.session?.controller) {
                $b3ff264909373f94$var$logger.debug('Controller doesnt match, closing active session', [
                    pairingTopic
                ]);
                this.activeAccountOrPbk && this.closeActiveSession(this.activeAccountOrPbk, false);
                this.session = undefined; // close the previous session
            }
            // I still need this check in the event the user aborts the sync process on the wallet side
            // but there is already a connection set
            this.session = this.session ?? session;
            $b3ff264909373f94$var$logger.debug('Session is now', [
                session.pairingTopic,
                pairingTopic
            ]);
            this.validateReceivedNamespace(permissionScopeParams, this.session.namespaces);
        } catch (error) {
            if (!error.message || !error.message.length || error.message.toLowerCase().includes('expir')) {
                const fun = this.eventHandlers.get("CLOSE_ALERT" /* ClientEvents.CLOSE_ALERT */ );
                fun && fun((0, $809a8ab02b228419$export$6d07abd9f0bba447).WALLETCONNECT);
            } else {
                $b3ff264909373f94$var$logger.debug('Error happened!', [
                    pairingTopic
                ]);
                $b3ff264909373f94$var$logger.error(error.message);
                if (this.activeListeners.size === 0) {
                    $b3ff264909373f94$var$logger.debug('No active listeners', [
                        pairingTopic
                    ]);
                    const fun = this.eventHandlers.get("WC_ACK_NOTIFICATION" /* ClientEvents.WC_ACK_NOTIFICATION */ );
                    fun && fun('error');
                } else {
                    $b3ff264909373f94$var$logger.debug('New pairing topic?', [
                        pairingTopic
                    ]);
                    const errorResponse = {
                        type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Error,
                        id: this.messageIds.pop(),
                        errorType: (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR
                    };
                    this.notifyListeners(pairingTopic, errorResponse);
                }
            }
        }
        if (this.session) {
            $b3ff264909373f94$var$logger.debug('Have session, returning', [
                pairingTopic
            ]);
            return this.session;
        } else {
            $b3ff264909373f94$var$logger.debug('Nope, aborting', [
                pairingTopic
            ]);
            throw new (0, $25bd6556c6bb5256$export$7e47d038b16ef45)('No session set.' + pairingTopic);
        }
    }
    permissionScopeParamsToNamespaces(permissionScopeParams) {
        return {
            chains: permissionScopeParams.networks.map((network)=>`${$b3ff264909373f94$var$TEZOS_PLACEHOLDER}:${network}`),
            methods: permissionScopeParams.methods,
            events: permissionScopeParams.events ?? []
        };
    }
    validateReceivedNamespace(scope, receivedNamespaces) {
        if (receivedNamespaces[$b3ff264909373f94$var$TEZOS_PLACEHOLDER]) {
            this.validateMethods(scope.methods, receivedNamespaces[$b3ff264909373f94$var$TEZOS_PLACEHOLDER].methods);
            if (scope.events) this.validateEvents(scope.events, receivedNamespaces['tezos'].events);
            this.validateAccounts(scope.networks, receivedNamespaces[$b3ff264909373f94$var$TEZOS_PLACEHOLDER].accounts);
        } else {
            this.clearState();
            throw new (0, $25bd6556c6bb5256$export$7221abf9e1c5a9d3)('All namespaces must be approved', (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)('USER_REJECTED').code, 'incomplete', 'tezos');
        }
    }
    validateMethods(requiredMethods, receivedMethods) {
        const missingMethods = [];
        requiredMethods.forEach((method)=>{
            if (!receivedMethods.includes(method)) missingMethods.push(method);
        });
        if (missingMethods.length > 0) {
            this.clearState();
            throw new (0, $25bd6556c6bb5256$export$7221abf9e1c5a9d3)('All methods must be approved', (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)('USER_REJECTED_METHODS').code, 'incomplete', missingMethods);
        }
    }
    validateEvents(requiredEvents, receivedEvents) {
        const missingEvents = [];
        requiredEvents.forEach((method)=>{
            if (!receivedEvents.includes(method)) missingEvents.push(method);
        });
        if (missingEvents.length > 0) {
            this.clearState();
            throw new (0, $25bd6556c6bb5256$export$7221abf9e1c5a9d3)('All events must be approved', (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)('USER_REJECTED_EVENTS').code, 'incomplete', missingEvents);
        }
    }
    validateAccounts(requiredNetwork, receivedAccounts) {
        if (receivedAccounts.length === 0) {
            this.clearState();
            throw new (0, $25bd6556c6bb5256$export$7221abf9e1c5a9d3)('Accounts must not be empty', (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)('USER_REJECTED_CHAINS').code, 'incomplete');
        }
        const receivedChains = [];
        const invalidChains = [];
        const missingChains = [];
        const invalidChainsNamespace = [];
        receivedAccounts.forEach((chain)=>{
            const accountId = chain.split(':');
            if (accountId.length !== 3) invalidChains.push(chain);
            if (accountId[0] !== $b3ff264909373f94$var$TEZOS_PLACEHOLDER) invalidChainsNamespace.push(chain);
            const network = accountId[1];
            if (!receivedChains.includes(network)) receivedChains.push(network);
        });
        if (invalidChains.length > 0) {
            this.clearState();
            throw new (0, $25bd6556c6bb5256$export$7221abf9e1c5a9d3)('Accounts must be CAIP-10 compliant', (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)('USER_REJECTED_CHAINS').code, 'invalid', invalidChains);
        }
        if (invalidChainsNamespace.length > 0) {
            this.clearState();
            throw new (0, $25bd6556c6bb5256$export$7221abf9e1c5a9d3)('Accounts must be defined in matching namespace', (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)('UNSUPPORTED_ACCOUNTS').code, 'invalid', invalidChainsNamespace);
        }
        requiredNetwork.forEach((network)=>{
            if (!receivedChains.includes(network)) missingChains.push(network);
        });
        if (missingChains.length > 0) {
            this.clearState();
            throw new (0, $25bd6556c6bb5256$export$7221abf9e1c5a9d3)('All chains must have at least one account', (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)('USER_REJECTED_CHAINS').code, 'incomplete', missingChains);
        }
    }
    async closeActiveSession(account, notify = true) {
        try {
            this.validateNetworkAndAccount(this.getActiveNetwork(), account);
        } catch (error) {
            $b3ff264909373f94$var$logger.error(error.message);
            return;
        }
        const session = this.getSession();
        if (notify && this.messageIds.length) {
            const errorResponse = {
                type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Disconnect,
                id: this.messageIds.pop(),
                errorType: (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR
            };
            this.notifyListeners(this.getTopicFromSession(session), errorResponse);
            this.messageIds = []; // reset
        }
        await this.signClient?.disconnect({
            topic: session.topic,
            reason: {
                code: 0,
                message: 'Force new connection'
            }
        });
    }
    validateNetworkAndAccount(network, account) {
        if (!this.getTezosNamespace().accounts.includes(`${$b3ff264909373f94$var$TEZOS_PLACEHOLDER}:${network}:${account}`)) throw new (0, $25bd6556c6bb5256$export$b2b15e10d2216872)(network, account);
    }
    /**
     * @description Access the active network
     * @error ActiveNetworkUnspecified thorwn when there are multiple Tezos networks in the session and none is set as the active one
     */ getActiveNetwork() {
        if (!this.activeNetwork) {
            this.getSession();
            throw new (0, $25bd6556c6bb5256$export$c452d961b2f5bbc8)();
        }
        return this.activeNetwork;
    }
    setDefaultAccountAndNetwork() {
        const activeAccount = this.getAccounts();
        if (activeAccount.length) this.activeAccountOrPbk = activeAccount[0];
        const activeNetwork = this.getNetworks();
        if (activeNetwork.length) this.activeNetwork = activeNetwork[0];
    }
    /**
     * @description Return all connected accounts from the active session
     * @error NotConnected if no active session
     */ getAccounts() {
        return this.getTezosNamespace().accounts.map((account)=>account.split(':')[2]);
    }
    /**
     * @description Return all networks from the namespace of the active session
     * @error NotConnected if no active session
     */ getNetworks() {
        return this.getPermittedNetwork();
    }
    getTezosNamespace(namespaces = this.getSession().namespaces) {
        if ($b3ff264909373f94$var$TEZOS_PLACEHOLDER in namespaces) return namespaces[$b3ff264909373f94$var$TEZOS_PLACEHOLDER];
        else throw new (0, $25bd6556c6bb5256$export$7e47d038b16ef45)('Tezos not found in namespaces');
    }
    getPermittedMethods() {
        return this.getTezosRequiredNamespace().methods;
    }
    getPermittedNetwork() {
        return this.getTezosRequiredNamespace().chains.map((chain)=>chain.split(':')[1]);
    }
    getTezosRequiredNamespace() {
        return {
            chains: [
                `${$b3ff264909373f94$var$TEZOS_PLACEHOLDER}:${this.wcOptions.network}`
            ],
            events: [],
            methods: [
                'tezos_getAccounts',
                'tezos_send',
                'tezos_sign'
            ]
        };
    // if (TEZOS_PLACEHOLDER in this.getSession().requiredNamespaces) {
    //   return this.getSession().requiredNamespaces[TEZOS_PLACEHOLDER] as {
    //     chains: string[]
    //     methods: string[]
    //     events: string[]
    //   }
    // } else {
    //   throw new InvalidSession('Tezos not found in requiredNamespaces')
    // }
    }
    async notifyListeners(topic, partialResponse) {
        const response = {
            ...partialResponse,
            version: '2',
            senderId: topic
        };
        const serializer = new (0, $33b837e22eef79cd$export$ef852775387a0be7)();
        const serialized = await serializer.serialize(response);
        this.activeListeners.forEach((listener)=>{
            listener(serialized);
        });
    }
    currentSession() {
        return this.session;
    }
    async tryConnectToRelayer() {
        const urls = new Set([
            this.wcOptions.opts.relayUrl,
            undefined,
            'wss://relay.walletconnect.com',
            'wss://relay.walletconnect.org',
            'wss://us-east-1.relay.walletconnect.com',
            'wss://eu-central-1.relay.walletconnect.com',
            'wss://ap-southeast-1.relay.walletconnect.com'
        ]);
        const errMessages = new Set();
        for (const relayUrl of urls)try {
            return await (0, $4a472e843fedf2e2$export$2e2bcd8739ae039).init({
                ...this.wcOptions.opts,
                relayUrl: relayUrl
            });
        } catch (err) {
            errMessages.add(err.message);
            $b3ff264909373f94$var$logger.warn(`Failed to connect to ${relayUrl}: ${err.message}`);
        }
        throw new Error(`Failed to connect to relayer: ${Array.from(errMessages).join(',')}`);
    }
    async getSignClient() {
        if (this.signClient === undefined) try {
            this.signClient = await this.tryConnectToRelayer();
            this.subscribeToSessionEvents(this.signClient);
        } catch (error) {
            $b3ff264909373f94$var$logger.error(error.message);
            localStorage && localStorage.setItem((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).WC_INIT_ERROR, error.message);
            return undefined;
        }
        return this.signClient;
    }
    getSession() {
        if (!this.session) throw new (0, $25bd6556c6bb5256$export$1cde3ed2cbe72e01)();
        return this.session;
    }
    /**
     * @description Access the public key hash (or public key) of the active account
     * @error ActiveAccountUnspecified thrown when there are multiple Tezos account in the session and none is set as the active one
     */ async getAccountOrPK() {
        if (!this.activeAccountOrPbk) {
            this.getSession();
            throw new (0, $25bd6556c6bb5256$export$9f2fae8b078ef617)();
        }
        return this.activeAccountOrPbk;
    }
    clearState() {
        this.session = undefined;
        this.activeAccountOrPbk = undefined;
        this.activeNetwork = undefined;
        this.lastExtensionAttempt = 0;
    }
    /**
     * @description Checks if session is close to expiry and extends it if needed
     * Extends session by 7 days if it will expire within 24 hours
     * Uses defensive error handling to prevent relay message conflicts (TrustWallet issue)
     */ async checkAndExtendSession() {
        try {
            if (!this.session) return;
            const signClient = await this.getSignClient();
            if (!signClient) return;
            const ONE_HOUR_IN_SECONDS = 3600;
            const ONE_DAY_IN_SECONDS = 86400;
            const now = Math.floor(Date.now() / 1000);
            const timeUntilExpiry = this.session.expiry - now;
            const timeSinceLastExtension = now - this.lastExtensionAttempt;
            // Skip if we recently attempted extension (within last hour)
            if (timeSinceLastExtension < ONE_HOUR_IN_SECONDS && this.lastExtensionAttempt > 0) {
                $b3ff264909373f94$var$logger.debug('Skipping session extension - recently attempted', {
                    minutesSinceLastAttempt: (timeSinceLastExtension / 60).toFixed(1)
                });
                return;
            }
            // If session expires in the next 24 hours, extend it
            if (timeUntilExpiry < ONE_DAY_IN_SECONDS && timeUntilExpiry > 0) {
                $b3ff264909373f94$var$logger.log('Session expires soon, extending...', {
                    topic: this.session.topic,
                    currentExpiry: new Date(this.session.expiry * 1000),
                    hoursRemaining: (timeUntilExpiry / 3600).toFixed(1)
                });
                // Update attempt timestamp before calling extend
                this.lastExtensionAttempt = now;
                try {
                    await signClient.extend({
                        topic: this.session.topic
                    });
                    // Update our session reference with new expiry
                    const updatedSession = signClient.session.get(this.session.topic);
                    if (updatedSession) {
                        this.session = updatedSession;
                        $b3ff264909373f94$var$logger.log('Session extended successfully', {
                            newExpiry: new Date(updatedSession.expiry * 1000)
                        });
                    }
                } catch (extendErr) {
                    // Log but don't throw - session might still be valid for a while
                    // This error may be harmless (e.g., "No matching key" from duplicate relay messages)
                    $b3ff264909373f94$var$logger.warn('Session extension failed, continuing anyway', {
                        error: extendErr.message,
                        remainingHours: (timeUntilExpiry / 3600).toFixed(1)
                    });
                }
            }
        } catch (err) {
            // Catch any unexpected errors to ensure extension never blocks operations
            $b3ff264909373f94$var$logger.error('Unexpected error in checkAndExtendSession', err.message);
        }
    }
    /**
     * @description Validates if a restored session is still valid and usable
     * @param session The session to validate
     * @returns true if session is valid, false if stale/expired
     */ async isSessionValid(session) {
        // Check if Session is expired
        const now = Math.floor(Date.now() / 1000);
        if (session.expiry <= now) {
            $b3ff264909373f94$var$logger.warn('Session validation failed: session expired', {
                expiry: session.expiry,
                now: now
            });
            return false;
        }
        // Check if Wallet is still responsive
        try {
            const signClient = await this.getSignClient();
            if (!signClient) {
                $b3ff264909373f94$var$logger.warn('Session validation failed: no sign client available');
                return false;
            }
            await signClient.ping({
                topic: session.topic
            });
            $b3ff264909373f94$var$logger.debug('Session validation passed: session is valid');
            return true;
        } catch (err) {
            $b3ff264909373f94$var$logger.warn('Session validation failed: ping failed', err.message);
            return false;
        }
    }
    /**
     * @description Cleans up a stale session by disconnecting and removing it
     * @param session The stale session to cleanup
     */ async cleanupStaleSession(session) {
        try {
            const signClient = await this.getSignClient();
            if (signClient) await signClient.disconnect({
                topic: session.topic,
                reason: (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)('USER_DISCONNECTED')
            });
            $b3ff264909373f94$var$logger.debug('Stale session cleaned up successfully', session.topic);
        } catch (err) {
            $b3ff264909373f94$var$logger.warn('Error cleaning up stale session', err.message);
        // Continue even if cleanup fails - session is stale
        }
    }
}





class $d26e51b83ef4cfff$export$9da242c25352d7d7 extends (0, $58c6d5fc9cc0fe50$export$86495b081fef8e52) {
    wcOptions;
    isLeader;
    type = (0, $809a8ab02b228419$export$6d07abd9f0bba447).WALLETCONNECT;
    isReady = new (0, $247a3319916bcc85$export$babe85162c870d79)();
    constructor(name, _keyPair, storage, storageKey, wcOptions, isLeader){
        super(name, (0, $b3ff264909373f94$export$155bb858c3ee1d84).getInstance(wcOptions, isLeader), new (0, $3514bc91c0d3d509$export$a1f30c6c22927bc5)(storage, storageKey));
        this.wcOptions = wcOptions;
        this.isLeader = isLeader;
    }
    static async isAvailable() {
        return Promise.resolve(true);
    }
    /**
     * Returns a promise that blocks the execution flow when awaited if the transport hasn't resolved yet; otherwise, it returns true.
     */ waitForResolution() {
        return this.isReady.promise;
    }
    async connect() {
        if ([
            (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).CONNECTED,
            (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).CONNECTING
        ].includes(this._isConnected)) return;
        this._isConnected = (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).CONNECTING;
        const isLeader = await this.isLeader();
        if (isLeader) await this.client.init();
        const knownPeers = await this.getPeers();
        if (knownPeers.length > 0) knownPeers.map(async (peer)=>this.listen(peer.publicKey));
        await this.startOpenChannelListener();
        await super.connect();
        if (!isLeader) this._isConnected = (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).SECONDARY_TAB_CONNECTED;
        this.isReady.resolve(true);
    }
    wasDisconnectedByWallet() {
        return !!this.client.disconnectionEvents.size;
    }
    closeClient() {
        this.client.closeSignClient();
    }
    async hasPairings() {
        return await this.client.storage.hasPairings() ? true : !!this.client.signClient?.pairing.getAll()?.length;
    }
    async hasSessions() {
        return await this.client.storage.hasSessions() ? true : !!this.client.signClient?.session.getAll()?.length;
    }
    /**
     * Forcefully updates any DApps running on the same session
     * Typical use case: localStorage changes to reflect to indexDB
     * @param type the message type
     */ forceUpdate(type) {
        this.client.storage.notify(type);
    }
    async getPeers() {
        const client = (0, $b3ff264909373f94$export$155bb858c3ee1d84).getInstance(this.wcOptions, this.isLeader);
        const session = client.currentSession();
        if (!session) return [];
        return [
            {
                senderId: session.peer.publicKey,
                extensionId: session.peer.metadata.name,
                id: session.peer.publicKey,
                type: 'walletconnect-pairing-response',
                name: session.peer.metadata.name,
                publicKey: session.peer.publicKey,
                version: 'first'
            }
        ];
    }
    async disconnect() {
        await this.client.close();
        await super.disconnect();
        this.isReady = new (0, $247a3319916bcc85$export$babe85162c870d79)();
    }
    async startOpenChannelListener() {
    //
    }
    async doClientCleanup() {
        await this.client.unsubscribeFromEncryptedMessages();
    }
    getPairingRequestInfo() {
        return this.client.getPairingRequestInfo();
    }
    async listen(publicKey) {
        await this.client.listenForEncryptedMessage(publicKey, (message)=>{
            const connectionContext = {
                origin: (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).WALLETCONNECT,
                id: publicKey
            };
            this.notifyListeners(message, connectionContext).catch((error)=>{
                throw error;
            });
        }).catch((error)=>{
            throw error;
        });
    }
}






const $c91053a773bf928b$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('DappWalletConnectTransport');
class $c91053a773bf928b$export$ebc3eb59dc548885 extends (0, $d26e51b83ef4cfff$export$9da242c25352d7d7) {
    constructor(name, keyPair, storage, wcOptions, isLeader){
        super(name, keyPair, storage, (0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_WALLETCONNECT_PEERS_DAPP, wcOptions, isLeader);
        this.client.listenForChannelOpening(async (peer)=>{
            await this.addPeer(peer);
            this._isConnected = (0, $cf61b77dbdb95489$export$d53806e03704a04e)(window) || await isLeader() ? (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).CONNECTED : (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).SECONDARY_TAB_CONNECTED;
            this.isReady.isPending() && this.isReady.resolve(true);
            if (this.newPeerListener) {
                this.newPeerListener(peer);
                this.newPeerListener = undefined; // TODO: Remove this once we use the id
            }
        });
    }
    async listenForNewPeer(newPeerListener) {
        // logger.log('listenForNewPeer')
        this.newPeerListener = newPeerListener;
    }
    async stopListeningForNewPeers() {
        $c91053a773bf928b$var$logger.log('stopListeningForNewPeers');
        this.newPeerListener = undefined;
    }
}






var $6ZWSX = parcelRequire("6ZWSX");
var $5527220553c094b9$require$Buffer = $6ZWSX.Buffer;
const $5527220553c094b9$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('DAppClient');
class $5527220553c094b9$export$89c4f9f6e64272f0 extends (0, $a9ae2c45e15f00d9$export$1f2bb630327ac4b6) {
    /**
     * The description of the app
     */ description;
    /**
     * The block explorer used by the SDK
     */ blockExplorer;
    /**
     * Automatically switch between apps on Mobile Devices (Enabled by Default)
     */ enableAppSwitching;
    /**
     * Enable metrics tracking (Disabled by Default)
     */ enableMetrics;
    userId;
    network;
    events = new (0, $0b587c8852746f57$export$61dd0f845b797b20)();
    postMessageTransport;
    p2pTransport;
    walletConnectTransport;
    wcProjectId;
    wcRelayUrl;
    isGetActiveAccountHandled = false;
    openRequestsOtherTabs = new Set();
    /**
     * A map of requests that are currently "open", meaning we have sent them to a wallet and are still awaiting a response.
     */ openRequests = new Map();
    /**
     * The currently active account. For all requests that are associated to a specific request (operation request, signing request),
     * the active account is used to determine the network and destination wallet
     */ _activeAccount = new (0, $247a3319916bcc85$export$babe85162c870d79)();
    /**
     * The currently active peer. This is used to address a peer in case the active account is not set. (Eg. for permission requests)
     */ _activePeer = new (0, $247a3319916bcc85$export$babe85162c870d79)();
    _initPromise;
    isInitPending = false;
    activeAccountLoaded;
    appMetadataManager;
    disclaimerText;
    errorMessages;
    featuredWallets;
    storageValidator;
    beaconIDB = new (0, $15e359ec5ec6b30e$export$685d695cbf574ee8)('beacon', [
        'bug_report',
        'metrics'
    ]);
    debounceSetActiveAccount = false;
    multiTabChannel = new (0, $ee79f0831fdf2471$export$8cb546401f8ec14b)('beacon-sdk-channel', this.onBCMessageHandler.bind(this), this.onElectedLeaderhandler.bind(this));
    constructor(config){
        super({
            storage: config && config.storage ? config.storage : new (0, $59e826bfd354e77a$export$19fffca37ef3e106)(),
            ...config
        });
        this.description = config.description;
        this.wcProjectId = config.walletConnectOptions?.projectId || '24469fd0a06df227b6e5f7dc7de0ff4f';
        this.wcRelayUrl = config.walletConnectOptions?.relayUrl;
        this.featuredWallets = config.featuredWallets;
        this.events = new (0, $0b587c8852746f57$export$61dd0f845b797b20)(config.eventHandlers, config.disableDefaultEvents ?? false);
        this.blockExplorer = config.blockExplorer ?? new (0, $7b8b53b866777765$export$442259b92d03942a)();
        this.network = config.network ?? {
            type: config.preferredNetwork ?? (0, $3ebc4504403abbff$export$4a868a35d3b57055).MAINNET
        };
        (0, $cf61b77dbdb95489$export$ba2c82ed48ac7fc5)(config.colorMode ?? (0, $92037e38839d1f95$export$e9cc541a1d84538e).LIGHT);
        this.disclaimerText = config.disclaimerText;
        this.errorMessages = config.errorMessages ?? {};
        this.appMetadataManager = new (0, $8f0d28279074bcb8$export$50a53e4bf19e8f0f)(this.storage);
        this.storageValidator = new (0, $742007c4a02b555f$export$8683b41bf72c2f8a)(this.storage);
        this.enableAppSwitching = config.enableAppSwitching === undefined ? true : !!config.enableAppSwitching;
        this.enableMetrics = config.enableMetrics ? true : false;
        // Subscribe to storage changes and update the active account if it changes on other tabs
        this.storage.subscribeToStorageChanged(async (event)=>{
            if (event.eventType === 'storageCleared') {
                this.setActiveAccount(undefined);
                return;
            }
            if (event.eventType === 'entryModified') {
                if (event.key === this.storage.getPrefixedKey((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ACTIVE_ACCOUNT)) {
                    const accountIdentifier = event.newValue;
                    if (!accountIdentifier || accountIdentifier === 'undefined') this.setActiveAccount(undefined);
                    else {
                        const account = await this.getAccount(accountIdentifier);
                        this.setActiveAccount(account);
                    }
                    return;
                }
                if (event.key === this.storage.getPrefixedKey((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ENABLE_METRICS)) {
                    this.enableMetrics = !!await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ENABLE_METRICS);
                    return;
                }
                if (event.key === this.storage.getPrefixedKey((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).BEACON_SDK_SECRET_SEED)) {
                    this._keyPair = new (0, $247a3319916bcc85$export$babe85162c870d79)();
                    this._beaconId = new (0, $247a3319916bcc85$export$babe85162c870d79)();
                    await this.initSDK();
                    return;
                }
            }
        });
        this.activeAccountLoaded = this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ACTIVE_ACCOUNT).then(async (activeAccountIdentifier)=>{
            if (activeAccountIdentifier) {
                const account = await this.accountManager.getAccount(activeAccountIdentifier);
                await this.setActiveAccount(account);
                return account;
            } else {
                await this.setActiveAccount(undefined);
                return undefined;
            }
        }).catch(async (storageError)=>{
            $5527220553c094b9$var$logger.error(storageError);
            await this.resetInvalidState(false);
            this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).INVALID_ACCOUNT_DEACTIVATED);
            return undefined;
        });
        this.handleResponse = async (message, connectionInfo)=>{
            const typedMessage = message.version === '3' ? message.message : message;
            let appMetadata = message.version === '3' ? typedMessage.blockchainData?.appMetadata : typedMessage.appMetadata;
            if (!appMetadata && message.version === '3') {
                const storedMetadata = await Promise.all([
                    this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_P2P_PEERS_DAPP),
                    this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_WALLETCONNECT_PEERS_DAPP),
                    this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_POSTMESSAGE_PEERS_DAPP)
                ]);
                for (const peers of storedMetadata){
                    const peer = peers.find((peer)=>peer.senderId === message.senderId);
                    if (!peer) continue;
                    const wallet = await this.getWalletInfo();
                    appMetadata = {
                        name: peer.name,
                        senderId: peer.senderId,
                        icon: wallet.icon
                    };
                    break;
                }
            }
            if (this.openRequestsOtherTabs.has(message.id)) {
                this.multiTabChannel.postMessage({
                    type: 'RESPONSE',
                    data: {
                        message: message,
                        connectionInfo: connectionInfo
                    },
                    id: message.id
                });
                if (typedMessage.type !== (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Acknowledge) this.openRequestsOtherTabs.delete(message.id);
                return;
            }
            const openRequest = this.openRequests.get(message.id);
            $5527220553c094b9$var$logger.log('### openRequest ###', openRequest);
            $5527220553c094b9$var$logger.log('handleResponse', 'Received message', message, connectionInfo);
            $5527220553c094b9$var$logger.log('### message ###', JSON.stringify(message));
            $5527220553c094b9$var$logger.log('### connectionInfo ###', connectionInfo);
            const handleDisconnect = async ()=>{
                this.analytics.track('event', 'DAppClient', 'Disconnect received from Wallet');
                const relevantTransport = connectionInfo.origin === (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).P2P ? this.p2pTransport : connectionInfo.origin === (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).WALLETCONNECT ? this.walletConnectTransport : this.postMessageTransport ?? await this.transport;
                if (relevantTransport) {
                    const peers = await relevantTransport.getPeers();
                    const peer = peers.find((peerEl)=>peerEl.senderId === message.senderId);
                    if (peer) await relevantTransport.removePeer(peer);
                }
                await this.removeAccountsForPeerIds([
                    message.senderId
                ]);
                await this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).CHANNEL_CLOSED);
            };
            if (openRequest && typedMessage.type === (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Acknowledge) {
                this.analytics.track('event', 'DAppClient', 'Acknowledge received from Wallet');
                $5527220553c094b9$var$logger.log('handleResponse', `acknowledge message received for ${message.id}`);
                this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).ACKNOWLEDGE_RECEIVED, {
                    message: typedMessage,
                    extraInfo: {},
                    walletInfo: await this.getWalletInfo()
                }).catch(console.error);
            } else if (openRequest) {
                if (typedMessage.type === (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionResponse && appMetadata) await this.appMetadataManager.addAppMetadata(appMetadata);
                if (typedMessage.type === (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Error) openRequest.reject(typedMessage);
                else openRequest.resolve({
                    message: message,
                    connectionInfo: connectionInfo
                });
                this.openRequests.delete(typedMessage.id);
            } else {
                if (typedMessage.type === (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Disconnect) await handleDisconnect();
                else if (typedMessage.type === (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).ChangeAccountRequest) await this.onNewAccount(typedMessage, connectionInfo);
            }
            if (this._transport.isResolved()) {
                const transport = await this.transport;
                if (transport instanceof (0, $d26e51b83ef4cfff$export$9da242c25352d7d7) && !this.openRequests.has('session_update')) this.openRequests.set('session_update', new (0, $247a3319916bcc85$export$babe85162c870d79)());
            }
        };
        this.storageValidator.validate().then(async (isValid)=>{
            const account = await this.activeAccountLoaded;
            if (!isValid) {
                const info = await this.getWalletInfo(undefined, account, false);
                info.type = info.type === 'extension' && account?.origin.type === (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).P2P ? 'mobile' : info.type;
                await this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).LAST_SELECTED_WALLET, {
                    icon: info.icon ?? '',
                    key: info.name,
                    type: info.type ?? 'web',
                    name: info.name,
                    url: info.deeplink
                });
                const nowValid = await this.storageValidator.validate();
                if (!nowValid) this.resetInvalidState(false);
            }
            if (account && account.origin.type !== 'p2p') this.init();
        }).catch((err)=>$5527220553c094b9$var$logger.error(err.message));
        this.sendMetrics('enable-metrics?' + this.addQueryParam('version', (0, $217f751cff903b1b$export$31499a9cd224b78c)), undefined, (res)=>{
            if (!res.ok) res.status === 426 ? console.error('Metrics are no longer supported for this version, please upgrade.') : console.warn('Network error encountered. Metrics sharing have been automatically disabled.');
            this.enableMetrics = res.ok;
            this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ENABLE_METRICS, res.ok);
        }, ()=>{
            this.enableMetrics = false;
            this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ENABLE_METRICS, false);
        });
        this.initUserID().catch((err)=>$5527220553c094b9$var$logger.error(err.message));
    }
    async checkIfBCLeaderExists() {
        // broadcast channel does not work on mobile
        if ((0, $cf61b77dbdb95489$export$d53806e03704a04e)(window)) return true;
        const hasLeader = await this.multiTabChannel.hasLeader();
        if (hasLeader) return this.multiTabChannel.isLeader();
        await this.multiTabChannel.getLeadership();
        return this.multiTabChannel.isLeader();
    }
    async onElectedLeaderhandler() {
        if (!this._transport.isResolved()) return;
        const tranport = await this.transport;
        if (tranport.type !== (0, $809a8ab02b228419$export$6d07abd9f0bba447).WALLETCONNECT) return;
        if (tranport.connectionStatus === (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).CONNECTED) return;
        await tranport.connect();
    }
    async onBCMessageHandler(message) {
        switch(message.type){
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest:
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).OperationRequest:
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SignPayloadRequest:
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BroadcastRequest:
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).ProofOfEventChallengeRequest:
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SimulatedProofOfEventChallengeRequest:
                this.prepareRequest(message);
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BlockchainRequest:
                this.prepareRequest(message, true);
                break;
            case 'RESPONSE':
                this.handleResponse(message.data.message, message.data.connectionInfo);
                break;
            case 'DISCONNECT':
                this._transport.isResolved() && this.disconnect();
                break;
            default:
                $5527220553c094b9$var$logger.error('onBCMessageHandler', 'message type not recognized', message);
        }
    }
    async prepareRequest(message, isV3 = false) {
        if (!this.multiTabChannel.isLeader()) return;
        // block until the transport is ready
        const transport = await this._transport.promise;
        await transport.waitForResolution();
        this.openRequestsOtherTabs.add(message.id);
        isV3 ? this.makeRequestV3(message.data, message.id) : this.makeRequest(message.data, false, message.id);
    }
    async createStateSnapshot() {
        if (!localStorage || !this.enableMetrics) return;
        const keys = Object.values((0, $8d1a6d1de5294bad$export$2fdc5139b636713c)).filter((key)=>!key.includes('wc@2') && !key.includes('secret') && !key.includes('account'));
        try {
            for (const key of keys)await this.beaconIDB.set(key, this.storage.getPrefixedKey(key));
        } catch (err) {
            $5527220553c094b9$var$logger.error('createStateSnapshot', err.message);
        }
    }
    async initUserID() {
        const id = await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).USER_ID);
        if (id) {
            this.userId = id;
            return;
        }
        this.userId = await (0, $788668db41590f82$export$2dbe1b699c206fb)();
        this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).USER_ID, this.userId);
    }
    async initInternalTransports() {
        const seed = await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).BEACON_SDK_SECRET_SEED);
        if (!seed) throw new Error('Secret seed not found');
        const keyPair = await (0, $efd1a952be4e6fd9$export$f73c212cf4258056)(seed);
        if (this.postMessageTransport || this.p2pTransport || this.walletConnectTransport) return;
        this.postMessageTransport = new (0, $2287499d8335a19b$export$19e7f83c69b45796)(this.name, keyPair, this.storage);
        await this.addListener(this.postMessageTransport);
        this.p2pTransport = new (0, $d6f4097412eef67b$export$19867205fe4e985f)(this.name, keyPair, this.storage, this.matrixNodes, this.iconUrl, this.appUrl);
        await this.addListener(this.p2pTransport);
        const wcOptions = {
            projectId: this.wcProjectId,
            relayUrl: this.wcRelayUrl,
            metadata: {
                name: this.name,
                description: this.description ?? '',
                url: this.appUrl ?? '',
                icons: this.iconUrl ? [
                    this.iconUrl
                ] : []
            }
        };
        this.walletConnectTransport = new (0, $c91053a773bf928b$export$ebc3eb59dc548885)(this.name, keyPair, this.storage, {
            network: this.network.type,
            opts: wcOptions
        }, this.checkIfBCLeaderExists.bind(this));
        this.initEvents();
        await this.addListener(this.walletConnectTransport);
    }
    initEvents() {
        if (!this.walletConnectTransport) return;
        this.walletConnectTransport.setEventHandler("CLOSE_ALERT" /* ClientEvents.CLOSE_ALERT */ , this.hideUI.bind(this, [
            'alert',
            'toast'
        ]));
        this.walletConnectTransport.setEventHandler("RESET_STATE" /* ClientEvents.RESET_STATE */ , this.channelClosedHandler.bind(this));
        this.walletConnectTransport.setEventHandler("WC_ACK_NOTIFICATION" /* ClientEvents.WC_ACK_NOTIFICATION */ , this.wcToastHandler.bind(this));
        this.walletConnectTransport.setEventHandler("ON_RELAYER_ERROR" /* ClientEvents.ON_RELAYER_ERROR */ , this.onRelayerError.bind(this));
    }
    async onRelayerError() {
        await this.resetInvalidState(false);
        this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).RELAYER_ERROR);
    }
    async wcToastHandler(status) {
        const walletInfo = await (async ()=>{
            try {
                return await this.getWalletInfo();
            } catch  {
                return {
                    name: 'wallet'
                };
            }
        })();
        await this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).HIDE_UI, [
            'alert'
        ]);
        if (status === 'pending') this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).ACKNOWLEDGE_RECEIVED, {
            message: {},
            extraInfo: {},
            walletInfo: walletInfo
        });
        else this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).PERMISSION_REQUEST_ERROR, {
            errorResponse: {
                errorType: (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR
            },
            walletInfo: walletInfo
        });
    }
    async channelClosedHandler(type) {
        const transport = await this.transport;
        if (transport.type !== type) return;
        await this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).CHANNEL_CLOSED);
        this.setActiveAccount(undefined);
        await this.disconnect();
    }
    /**
     * Destroy the instance.
     *
     * WARNING: Call `destroy` whenever you no longer need dAppClient
     * as it frees internal subscriptions to the transport and therefore the instance may no longer work properly.
     * If you wish to disconnect your dApp, use `disconnect` instead.
     */ async destroy() {
        await this.createStateSnapshot();
        await super.destroy();
    }
    async init(transport, substratePairing) {
        if (this._initPromise) return this._initPromise;
        try {
            await this.activeAccountLoaded;
        } catch  {
        //
        }
        this._initPromise = new Promise(async (resolve)=>{
            if (transport) {
                await this.addListener(transport);
                resolve(await super.init(transport));
            } else if (this._transport.isSettled()) {
                await (await this.transport).connect();
                resolve(await super.init(await this.transport));
            } else {
                const activeAccount = await this.getActiveAccount();
                const stopListening = ()=>{
                    if (this.postMessageTransport) this.postMessageTransport.stopListeningForNewPeers().catch(console.error);
                    if (this.p2pTransport) this.p2pTransport.stopListeningForNewPeers().catch(console.error);
                    if (this.walletConnectTransport) this.walletConnectTransport.stopListeningForNewPeers().catch(console.error);
                };
                await this.initInternalTransports();
                if (!this.postMessageTransport || !this.p2pTransport || !this.walletConnectTransport) return;
                this.postMessageTransport.connect().then().catch(console.error);
                if (activeAccount && activeAccount.origin) {
                    const origin = activeAccount.origin.type;
                    // Select the transport that matches the active account
                    if (origin === (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).EXTENSION) resolve(await super.init(this.postMessageTransport));
                    else if (origin === (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).P2P) resolve(await super.init(this.p2pTransport));
                    else if (origin === (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).WALLETCONNECT) resolve(await super.init(this.walletConnectTransport));
                } else {
                    const p2pTransport = this.p2pTransport;
                    const postMessageTransport = this.postMessageTransport;
                    const walletConnectTransport = this.walletConnectTransport;
                    postMessageTransport.listenForNewPeer((peer)=>{
                        $5527220553c094b9$var$logger.log('init', 'postmessage transport peer connected', peer);
                        this.analytics.track('event', 'DAppClient', 'Extension connected', {
                            peerName: peer.name
                        });
                        this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).PAIR_SUCCESS, peer).catch((emitError)=>console.warn(emitError));
                        this.setActivePeer(peer).catch(console.error);
                        this.setTransport(this.postMessageTransport).catch(console.error);
                        stopListening();
                        resolve((0, $809a8ab02b228419$export$6d07abd9f0bba447).POST_MESSAGE);
                    }).catch(console.error);
                    p2pTransport.listenForNewPeer((peer)=>{
                        $5527220553c094b9$var$logger.log('init', 'p2p transport peer connected', peer);
                        this.analytics.track('event', 'DAppClient', 'Beacon Wallet connected', {
                            peerName: peer.name
                        });
                        this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).PAIR_SUCCESS, peer).catch((emitError)=>console.warn(emitError));
                        this.setActivePeer(peer).catch(console.error);
                        this.setTransport(this.p2pTransport).catch(console.error);
                        stopListening();
                        resolve((0, $809a8ab02b228419$export$6d07abd9f0bba447).P2P);
                    }).catch(console.error);
                    walletConnectTransport.listenForNewPeer((peer)=>{
                        $5527220553c094b9$var$logger.log('init', 'walletconnect transport peer connected', peer);
                        this.analytics.track('event', 'DAppClient', 'WalletConnect Wallet connected', {
                            peerName: peer.name
                        });
                        this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).PAIR_SUCCESS, peer).catch((emitError)=>console.warn(emitError));
                        this.setActivePeer(peer).catch(console.error);
                        this.setTransport(this.walletConnectTransport).catch(console.error);
                        stopListening();
                        resolve((0, $809a8ab02b228419$export$6d07abd9f0bba447).WALLETCONNECT);
                    }).catch(console.error);
                    (0, $6c4533a0ab3f42b7$export$9a11a09f0f7983f7).getAvailableExtensions().then(async (extensions)=>{
                        this.analytics.track('event', 'DAppClient', 'Extensions detected', {
                            extensions: extensions
                        });
                    }).catch((error)=>{
                        this._initPromise = undefined;
                        console.error(error);
                    });
                    const abortHandler = async ()=>{
                        $5527220553c094b9$var$logger.log('init', 'ABORTED');
                        this.sendMetrics('performance-metrics/save', await this.buildPayload('connect', 'abort'));
                        await Promise.all([
                            postMessageTransport.disconnect(),
                            // p2pTransport.disconnect(), do not abort connection manually
                            walletConnectTransport.disconnect()
                        ]);
                        this.postMessageTransport = this.walletConnectTransport = this.p2pTransport = undefined;
                        this._activeAccount.isResolved() && this.clearActiveAccount();
                        this._initPromise = undefined;
                    };
                    const serializer = new (0, $33b837e22eef79cd$export$ef852775387a0be7)();
                    const p2pPeerInfo = new Promise(async (resolve)=>{
                        try {
                            await p2pTransport.connect();
                        } catch (err) {
                            $5527220553c094b9$var$logger.error(err);
                            await this.hideUI([
                                'alert'
                            ]); // hide pairing alert
                            setTimeout(()=>this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).GENERIC_ERROR, err.message), 1000);
                            abortHandler();
                            resolve('');
                            return;
                        }
                        resolve(await serializer.serialize(await p2pTransport.getPairingRequestInfo()));
                    });
                    const walletConnectPeerInfo = new Promise(async (resolve)=>{
                        resolve((await walletConnectTransport.getPairingRequestInfo()).uri);
                    });
                    const postmessagePeerInfo = new Promise(async (resolve)=>{
                        resolve(await serializer.serialize(await postMessageTransport.getPairingRequestInfo()));
                    });
                    this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).PAIR_INIT, {
                        p2pPeerInfo: p2pPeerInfo,
                        postmessagePeerInfo: postmessagePeerInfo,
                        walletConnectPeerInfo: walletConnectPeerInfo,
                        networkType: this.network.type,
                        abortedHandler: abortHandler.bind(this),
                        disclaimerText: this.disclaimerText,
                        analytics: this.analytics,
                        featuredWallets: this.featuredWallets,
                        substratePairing: substratePairing
                    }).catch((emitError)=>console.warn(emitError));
                }
            }
        });
        return this._initPromise;
    }
    /**
     * Returns the active account
     */ async getActiveAccount() {
        return this._activeAccount.promise;
    }
    async isInvalidState(account) {
        const activeAccount = await this._activeAccount.promise;
        return !activeAccount ? false : activeAccount?.address !== account?.address && !this.isGetActiveAccountHandled;
    }
    async resetInvalidState(emit = true) {
        this.accountManager.removeAllAccounts();
        this._activeAccount = (0, $247a3319916bcc85$export$babe85162c870d79).resolve(undefined);
        this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ACTIVE_ACCOUNT, undefined);
        emit && this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).INVALID_ACTIVE_ACCOUNT_STATE);
        !emit && this.hideUI([
            'alert'
        ]);
        await Promise.all([
            this.postMessageTransport?.disconnect(),
            this.walletConnectTransport?.disconnect()
        ]);
        this.postMessageTransport = this.p2pTransport = this.walletConnectTransport = undefined;
        await this.setActivePeer(undefined);
        await this.setTransport(undefined);
        this._initPromise = undefined;
    }
    /**
     * Sets the active account
     *
     * @param account The account that will be set as the active account
     */ async setActiveAccount(account) {
        if (!this.isGetActiveAccountHandled) console.warn(`An active account has been received, but no active subscription was found for BeaconEvent.ACTIVE_ACCOUNT_SET.
        For more information, visit: https://docs.walletbeacon.io/guides/migration-guide`);
        if (account && this._activeAccount.isSettled() && await this.isInvalidState(account)) {
            const tranport = await this.transport;
            if (tranport instanceof (0, $d26e51b83ef4cfff$export$9da242c25352d7d7) && tranport.wasDisconnectedByWallet()) {
                await this.resetInvalidState();
                return;
            }
        }
        // when I'm resetting the activeAccount
        if (!account && this._activeAccount.isResolved() && await this.getActiveAccount()) {
            const transport = await this.transport;
            const activeAccount = await this.getActiveAccount();
            if (!transport || !activeAccount) return;
            if (!this.debounceSetActiveAccount && transport instanceof (0, $d26e51b83ef4cfff$export$9da242c25352d7d7)) {
                this.debounceSetActiveAccount = true;
                this._initPromise = undefined;
                this.postMessageTransport = this.p2pTransport = this.walletConnectTransport = undefined;
                if (this.multiTabChannel.isLeader() || (0, $cf61b77dbdb95489$export$d53806e03704a04e)(window)) {
                    await transport.disconnect();
                    this.openRequestsOtherTabs.clear();
                } else this.multiTabChannel.postMessage({
                    type: 'DISCONNECT'
                });
                Array.from(this.openRequests.entries()).filter(([id, _promise])=>id !== 'session_update').forEach(([id, promise])=>{
                    promise.reject({
                        type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Error,
                        errorType: (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR,
                        id: id,
                        senderId: '',
                        version: '2'
                    });
                });
                this.openRequests.clear();
                this.debounceSetActiveAccount = false;
            }
        }
        if (this._activeAccount.isSettled()) // If the promise has already been resolved we need to create a new one.
        this._activeAccount = (0, $247a3319916bcc85$export$babe85162c870d79).resolve(account);
        else this._activeAccount.resolve(account);
        if (!this.isGetActiveAccountHandled && this._transport.isResolved()) {
            const transport = await this.transport;
            if (transport instanceof (0, $d26e51b83ef4cfff$export$9da242c25352d7d7) && transport.wasDisconnectedByWallet()) {
                await this.resetInvalidState();
                return;
            }
        }
        if (account) {
            const origin = account.origin.type;
            await this.initInternalTransports();
            // Select the transport that matches the active account
            if (origin === (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).EXTENSION) await this.setTransport(this.postMessageTransport);
            else if (origin === (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).P2P) await this.setTransport(this.p2pTransport);
            else if (origin === (0, $6a40437df5c178f8$export$bb47f81d5b009d7f).WALLETCONNECT) {
                await this.setTransport(this.walletConnectTransport);
                this.walletConnectTransport?.forceUpdate('INIT');
            }
            if (this._transport.isResolved()) {
                const transport = await this.transport;
                if (transport.connectionStatus === (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).NOT_CONNECTED) await transport.connect();
            }
            const peer = await this.getPeer(account);
            await this.setActivePeer(peer);
        } else {
            await this.setActivePeer(undefined);
            await this.setTransport(undefined);
        }
        await this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).ACTIVE_ACCOUNT, account ? account.accountIdentifier : undefined);
        await this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).ACTIVE_ACCOUNT_SET, account);
        return;
    }
    /**
     * Clear the active account
     */ clearActiveAccount() {
        return this.setActiveAccount();
    }
    async setColorMode(colorMode) {
        return (0, $cf61b77dbdb95489$export$ba2c82ed48ac7fc5)(colorMode);
    }
    async getColorMode() {
        return (0, $cf61b77dbdb95489$export$5573a5bab3e074b5)();
    }
    /**
     * @deprecated
     *
     * Use getOwnAppMetadata instead
     */ async getAppMetadata() {
        return this.getOwnAppMetadata();
    }
    async showPrepare() {
        const walletInfo = await (async ()=>{
            try {
                return await this.getWalletInfo();
            } catch  {
                return undefined;
            }
        })();
        await this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).SHOW_PREPARE, {
            walletInfo: walletInfo
        });
    }
    async hideUI(elements) {
        await this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).HIDE_UI, elements);
    }
    async tryToAppSwitch() {
        if (!(0, $cf61b77dbdb95489$export$d53806e03704a04e)(window) || !this.enableAppSwitching) return;
        const wallet = await this.getWalletInfo();
        if (wallet.type !== 'mobile' || !wallet.deeplink) return;
        const link = (0, $cf61b77dbdb95489$export$fedb369cb70207f1)(window) ? wallet.deeplink : `${wallet.deeplink}wc?uri=`;
        if (!link?.length) return;
        window.location = link;
    }
    addQueryParam(paramName, paramValue) {
        return paramName + '=' + paramValue;
    }
    async buildPayload(action, status) {
        const wallet = await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).LAST_SELECTED_WALLET);
        const transport = this._activeAccount.isResolved() ? (await this.getActiveAccount())?.origin.type ?? 'UNKNOWN' : 'UNKNOWN';
        return {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: this.userId,
                os: (0, $cf61b77dbdb95489$export$84097bf6fe069cb3)(),
                walletName: wallet?.name ?? 'init',
                walletType: wallet?.type ?? 'init',
                sdkVersion: (0, $217f751cff903b1b$export$31499a9cd224b78c),
                transport: transport,
                time: new Date(),
                action: action,
                status: status
            })
        };
    }
    async updateMetricsStorage(payload) {
        const queue = await this.beaconIDB.getAllKeys('metrics');
        if (queue.length >= 1000) {
            const key = queue.shift();
            this.beaconIDB.delete(key.toString(), 'metrics');
        }
        this.beaconIDB.set(String(Date.now()), payload, 'metrics');
    }
    sendMetrics(uri, options, thenHandler, catchHandler) {
        if (!this.enableMetrics && uri === 'performance-metrics/save') options && this.updateMetricsStorage(options.body);
        if (!this.enableMetrics) return;
        fetch(`${(0, $217f751cff903b1b$export$b27b0287c31e45de)}/${uri}`, options).then((res)=>thenHandler && thenHandler(res)).catch((err)=>{
            console.warn('Network error encountered. Metrics sharing have been automatically disabled.');
            $5527220553c094b9$var$logger.error(err.message);
            this.enableMetrics = false; // in the event of a network error, stop sending metrics
            catchHandler && catchHandler(err);
        });
    }
    async checkMakeRequest() {
        const isResolved = this._transport.isResolved();
        const isWCInstance = isResolved && await this.transport instanceof (0, $d26e51b83ef4cfff$export$9da242c25352d7d7);
        await this.multiTabChannel.init();
        const isLeader = this.multiTabChannel.isLeader();
        return !isResolved || !isWCInstance || isLeader || (0, $cf61b77dbdb95489$export$d53806e03704a04e)(window);
    }
    /**
     * Will remove the account from the local storage and set a new active account if necessary.
     *
     * @param accountIdentifier ID of the account
     */ async removeAccount(accountIdentifier) {
        const removeAccountResult = super.removeAccount(accountIdentifier);
        const activeAccount = await this.getActiveAccount();
        if (activeAccount && activeAccount.accountIdentifier === accountIdentifier) await this.setActiveAccount(undefined);
        return removeAccountResult;
    }
    /**
     * Remove all accounts and set active account to undefined
     */ async removeAllAccounts() {
        await super.removeAllAccounts();
        await this.setActiveAccount(undefined);
    }
    /**
     * Removes a peer and all the accounts that have been connected through that peer
     *
     * @param peer Peer to be removed
     */ async removePeer(peer, sendDisconnectToPeer = false) {
        const transport = await this.transport;
        const removePeerResult = transport.removePeer(peer);
        await this.removeAccountsForPeers([
            peer
        ]);
        if (sendDisconnectToPeer) await this.sendDisconnectToPeer(peer, transport);
        return removePeerResult;
    }
    /**
     * Remove all peers and all accounts that have been connected through those peers
     */ async removeAllPeers(sendDisconnectToPeers = false) {
        const transport = await this.transport;
        const peers = await transport.getPeers();
        const removePeerResult = transport.removeAllPeers();
        await this.removeAccountsForPeers(peers);
        if (sendDisconnectToPeers) {
            const disconnectPromises = peers.map((peer)=>this.sendDisconnectToPeer(peer, transport));
            await Promise.all(disconnectPromises);
        }
        return removePeerResult;
    }
    /**
     * Allows the user to subscribe to specific events that are fired in the SDK
     *
     * @param internalEvent The event to subscribe to
     * @param eventCallback The callback that will be called when the event occurs
     */ async subscribeToEvent(internalEvent, eventCallback) {
        if (internalEvent === (0, $0b587c8852746f57$export$8d08de21eea96a9c).ACTIVE_ACCOUNT_SET) this.isGetActiveAccountHandled = true;
        await this.events.on(internalEvent, eventCallback);
    }
    /**
     * Check if we have permissions to send the specific message type to the active account.
     * If no active account is set, only permission requests are allowed.
     *
     * @param type The type of the message
     */ async checkPermissions(type) {
        if ([
            (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest,
            (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).ProofOfEventChallengeRequest,
            (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SimulatedProofOfEventChallengeRequest
        ].includes(type)) return true;
        const activeAccount = await this.getActiveAccount();
        if (!activeAccount) throw await this.sendInternalError('No active account set!');
        const permissions = activeAccount.scopes;
        switch(type){
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).OperationRequest:
                return permissions.includes((0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).OPERATION_REQUEST);
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SignPayloadRequest:
                return permissions.includes((0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).SIGN);
            // TODO: ENCRYPTION
            // case BeaconMessageType.EncryptPayloadRequest:
            //   return permissions.includes(PermissionScope.ENCRYPT)
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BroadcastRequest:
                return true;
            default:
                return false;
        }
    }
    async sendNotification(title, message, payload, protocolIdentifier) {
        const activeAccount = await this.getActiveAccount();
        if (!activeAccount || activeAccount && !activeAccount.scopes.includes((0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).NOTIFICATION) && !activeAccount.notification) throw new Error('notification permissions not given');
        if (!activeAccount.notification?.token) throw new Error('No AccessToken');
        const url = activeAccount.notification?.apiUrl;
        if (!url) throw new Error('No Push URL set');
        return this.sendNotificationWithAccessToken({
            url: url,
            recipient: activeAccount.address,
            title: title,
            body: message,
            payload: payload,
            protocolIdentifier: protocolIdentifier,
            accessToken: activeAccount.notification?.token
        });
    }
    blockchains = new Map();
    addBlockchain(chain) {
        this.blockchains.set(chain.identifier, chain);
        chain.getWalletLists().then((walletLists)=>{
            (0, $cf61b77dbdb95489$export$c8e7c1daea1a7d77)(walletLists.desktopList);
            (0, $cf61b77dbdb95489$export$52f45817c3388413)(walletLists.extensionList);
            (0, $cf61b77dbdb95489$export$d843bfebb480c881)(walletLists.webList);
            (0, $cf61b77dbdb95489$export$af64c7ad68fb9259)(walletLists.iOSList);
        });
    }
    removeBlockchain(chainIdentifier) {
        this.blockchains.delete(chainIdentifier);
    }
    async permissionRequest(input) {
        $5527220553c094b9$var$logger.log('permissionRequest', input);
        const blockchain = this.blockchains.get(input.blockchainIdentifier);
        if (!blockchain) throw new Error(`Blockchain "${input.blockchainIdentifier}" not supported by dAppClient`);
        const request = {
            ...input,
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest,
            blockchainData: {
                ...input.blockchainData,
                appMetadata: await this.getOwnAppMetadata()
            }
        };
        $5527220553c094b9$var$logger.log('REQUESTION PERMIMISSION V3', 'xxx', request);
        this.sendMetrics('performance-metrics/save', await this.buildPayload('connect', 'start'));
        const logId = `makeRequestV3 ${Date.now()}`;
        $5527220553c094b9$var$logger.time(true, logId);
        const { message: response, connectionInfo: connectionInfo } = await this.makeRequestV3(request).catch(async (requestError)=>{
            requestError.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR ? this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'abort')) : this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'error'));
            $5527220553c094b9$var$logger.time(false, logId);
            throw await this.handleRequestError(request, requestError);
        });
        $5527220553c094b9$var$logger.time(false, logId);
        this.sendMetrics('performance-metrics/save', await this.buildPayload('connect', 'start'));
        $5527220553c094b9$var$logger.log('RESPONSE V3', response, connectionInfo);
        const partialAccountInfos = await blockchain.getAccountInfosFromPermissionResponse(response.message);
        const accountInfo = {
            accountIdentifier: partialAccountInfos[0].accountId,
            senderId: response.senderId,
            origin: {
                type: connectionInfo.origin,
                id: connectionInfo.id
            },
            address: partialAccountInfos[0].address,
            publicKey: partialAccountInfos[0].publicKey,
            scopes: response.message.blockchainData.scopes,
            connectedAt: new Date().getTime(),
            chainData: response.message.blockchainData
        };
        await this.accountManager.addAccount(accountInfo);
        await this.setActiveAccount(accountInfo);
        await blockchain.handleResponse({
            request: request,
            account: accountInfo,
            output: response,
            blockExplorer: this.blockExplorer,
            connectionContext: connectionInfo,
            walletInfo: await this.getWalletInfo()
        });
        await this.notifySuccess(request, {
            account: accountInfo,
            output: {
                address: partialAccountInfos[0].address,
                network: {
                    type: 'substrate'
                },
                scopes: []
            },
            blockExplorer: this.blockExplorer,
            connectionContext: connectionInfo,
            walletInfo: await this.getWalletInfo()
        });
        // return output
        return response.message;
    }
    async request(input) {
        $5527220553c094b9$var$logger.log('request', input);
        const blockchain = this.blockchains.get(input.blockchainIdentifier);
        if (!blockchain) throw new Error(`Blockchain "${blockchain}" not supported by dAppClient`);
        await blockchain.validateRequest(input);
        const activeAccount = await this.getActiveAccount();
        if (!activeAccount) throw await this.sendInternalError('No active account!');
        const request = {
            ...input,
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BlockchainRequest,
            accountId: activeAccount.accountIdentifier
        };
        this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'start'));
        const logId = `makeRequestV3 ${Date.now()}`;
        $5527220553c094b9$var$logger.time(true, logId);
        const res = await this.checkMakeRequest() ? this.makeRequestV3(request) : this.makeRequestBC(request);
        res.catch(async (requestError)=>{
            requestError.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR ? this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'abort')) : this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'error'));
            $5527220553c094b9$var$logger.time(false, logId);
            throw await this.handleRequestError(request, requestError);
        });
        const { message: response, connectionInfo: connectionInfo } = await res;
        $5527220553c094b9$var$logger.time(false, logId);
        this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'success'));
        await blockchain.handleResponse({
            request: request,
            account: activeAccount,
            output: response,
            blockExplorer: this.blockExplorer,
            connectionContext: connectionInfo,
            walletInfo: await this.getWalletInfo()
        });
        await this.notifySuccess(request, {
            walletInfo: await this.getWalletInfo()
        });
        return response.message;
    }
    /**
     * Send a permission request to the DApp. This should be done as the first step. The wallet will respond
     * with an publicKey and permissions that were given. The account returned will be set as the "activeAccount"
     * and will be used for the following requests.
     *
     * @param input The message details we need to prepare the PermissionRequest message.
     */ async requestPermissions(input) {
        if (input?.network) throw new Error('[BEACON] the "network" property is no longer accepted in input. Please provide it when instantiating DAppClient.');
        const request = {
            appMetadata: await this.getOwnAppMetadata(),
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest,
            network: this.network,
            scopes: input && input.scopes ? input.scopes : [
                (0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).OPERATION_REQUEST,
                (0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).SIGN
            ]
        };
        this.analytics.track('event', 'DAppClient', 'Permission requested');
        this.sendMetrics('performance-metrics/save', await this.buildPayload('connect', 'start'));
        const logId = `makeRequest ${Date.now()}`;
        $5527220553c094b9$var$logger.time(true, logId);
        const res = await this.checkMakeRequest() || !await this.getActiveAccount() ? this.makeRequest(request, undefined, undefined) : this.makeRequestBC(request);
        res.catch(async (requestError)=>{
            requestError.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR ? this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'abort')) : this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'error'));
            $5527220553c094b9$var$logger.time(false, logId);
            throw await this.handleRequestError(request, requestError);
        });
        const { message: message, connectionInfo: connectionInfo } = await res;
        $5527220553c094b9$var$logger.time(false, logId);
        this.sendMetrics('performance-metrics/save', await this.buildPayload('connect', 'success'));
        $5527220553c094b9$var$logger.log('requestPermissions', '######## MESSAGE #######');
        $5527220553c094b9$var$logger.log('requestPermissions', message);
        const accountInfo = await this.onNewAccount(message, connectionInfo);
        $5527220553c094b9$var$logger.log('requestPermissions', '######## ACCOUNT INFO #######');
        $5527220553c094b9$var$logger.log('requestPermissions', JSON.stringify(accountInfo));
        await this.accountManager.addAccount(accountInfo);
        const output = {
            ...message,
            walletKey: accountInfo.walletKey,
            address: accountInfo.address,
            accountInfo: accountInfo
        };
        await this.notifySuccess(request, {
            account: accountInfo,
            output: output,
            blockExplorer: this.blockExplorer,
            connectionContext: connectionInfo,
            walletInfo: await this.getWalletInfo()
        });
        this.analytics.track('event', 'DAppClient', 'Permission received', {
            address: accountInfo.address
        });
        return output;
    }
    /**
     * Send a proof of event request to the wallet. The wallet will either accept or decline the challenge.
     * If it is accepted, the challenge will be stored, meaning that even if the user refresh the page, the DAppClient will keep checking if the challenge has been fulfilled.
     * Once the challenge is stored, a challenge stored message will be sent to the wallet.
     * It's **highly recommended** to run a proof of event challenge to check the identity of an abstracted account
     *
     * @param input The message details we need to prepare the ProofOfEventChallenge message.
     */ async requestProofOfEventChallenge(input) {
        const activeAccount = await this.getActiveAccount();
        if (!activeAccount) throw new Error('Please request permissions before doing a proof of event challenge');
        if (activeAccount.walletType !== 'abstracted_account' && activeAccount.verificationType !== 'proof_of_event') throw new Error('This wallet is not an abstracted account and thus cannot perform proof of event');
        const request = {
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).ProofOfEventChallengeRequest,
            contractAddress: activeAccount.address,
            payload: input.payload
        };
        this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'start'));
        const logId = `makeRequest ${Date.now()}`;
        $5527220553c094b9$var$logger.time(true, logId);
        const res = await this.checkMakeRequest() ? this.makeRequest(request) : this.makeRequestBC(request);
        res.catch(async (requestError)=>{
            requestError.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR ? this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'abort')) : this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'error'));
            $5527220553c094b9$var$logger.time(false, logId);
            throw await this.handleRequestError(request, requestError);
        });
        const { message: message, connectionInfo: connectionInfo } = await res;
        $5527220553c094b9$var$logger.time(false, logId);
        this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'success'));
        this.analytics.track('event', 'DAppClient', `Proof of event challenge ${message.isAccepted ? 'accepted' : 'refused'}`, {
            address: activeAccount.address
        });
        await this.notifySuccess(request, {
            account: activeAccount,
            output: message,
            blockExplorer: this.blockExplorer,
            connectionContext: connectionInfo,
            walletInfo: await this.getWalletInfo()
        });
        return message;
    }
    /**
     * Send a simulated proof of event request to the wallet. The wallet will either accept or decline the challenge.
     * It's the same than `requestProofOfEventChallenge` but rather than executing operations on the blockchain to prove the identity,
     * The wallet will return a list of operations that you'll be able to run on your side to verify the identity of the abstracted account
     * It's **highly recommended** to run a proof of event challenge to check the identity of an abstracted account
     *
     * @param input The message details we need to prepare the SimulatedProofOfEventChallenge message.
     */ async requestSimulatedProofOfEventChallenge(input) {
        const activeAccount = await this.getActiveAccount();
        if (!activeAccount) throw new Error('Please request permissions before doing a proof of event challenge');
        if (activeAccount.walletType !== 'abstracted_account' && activeAccount.verificationType !== 'proof_of_event') throw new Error('This wallet is not an abstracted account and thus cannot perform a simulated proof of event');
        const request = {
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SimulatedProofOfEventChallengeRequest,
            contractAddress: activeAccount.address,
            ...input
        };
        const logId = `makeRequest ${Date.now()}`;
        $5527220553c094b9$var$logger.time(true, logId);
        const res = await this.checkMakeRequest() ? this.makeRequest(request) : this.makeRequestBC(request);
        res.catch(async (requestError)=>{
            requestError.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR ? this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'abort')) : this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'error'));
            $5527220553c094b9$var$logger.time(false, logId);
            throw await this.handleRequestError(request, requestError);
        });
        const { message: message, connectionInfo: connectionInfo } = await res;
        $5527220553c094b9$var$logger.time(false, logId);
        this.analytics.track('event', 'DAppClient', `Simulated proof of event challenge ${!message.errorMessage ? 'accepted' : 'refused'}`, {
            address: activeAccount.address
        });
        await this.notifySuccess(request, {
            account: activeAccount,
            output: message,
            blockExplorer: this.blockExplorer,
            connectionContext: connectionInfo,
            walletInfo: await this.getWalletInfo()
        });
        return message;
    }
    /**
     * This method will send a "SignPayloadRequest" to the wallet. This method is meant to be used to sign
     * arbitrary data (eg. a string). It will return the signature in the format of "edsig..."
     *
     * @param input The message details we need to prepare the SignPayloadRequest message.
     */ async requestSignPayload(input) {
        if (!input.payload) throw await this.sendInternalError('Payload must be provided');
        const activeAccount = await this.getActiveAccount();
        if (!activeAccount) throw await this.sendInternalError('No active account!');
        const payload = input.payload;
        if (typeof payload !== 'string') throw new Error('Payload must be a string');
        const signingType = (()=>{
            switch(input.signingType){
                case (0, $1135dc71db7da99c$export$ecff5c1a4386a2e0).OPERATION:
                    if (!payload.startsWith('03')) throw new Error('When using signing type "OPERATION", the payload must start with prefix "03"');
                    return (0, $1135dc71db7da99c$export$ecff5c1a4386a2e0).OPERATION;
                case (0, $1135dc71db7da99c$export$ecff5c1a4386a2e0).MICHELINE:
                    if (!payload.startsWith('05')) throw new Error('When using signing type "MICHELINE", the payload must start with prefix "05"');
                    return (0, $1135dc71db7da99c$export$ecff5c1a4386a2e0).MICHELINE;
                case (0, $1135dc71db7da99c$export$ecff5c1a4386a2e0).RAW:
                default:
                    return (0, $1135dc71db7da99c$export$ecff5c1a4386a2e0).RAW;
            }
        })();
        this.analytics.track('event', 'DAppClient', 'Signature requested');
        const request = {
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SignPayloadRequest,
            signingType: signingType,
            payload: payload,
            sourceAddress: input.sourceAddress || activeAccount.address
        };
        this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'start'));
        const logId = `makeRequest ${Date.now()}`;
        $5527220553c094b9$var$logger.time(true, logId);
        const res = await this.checkMakeRequest() ? this.makeRequest(request) : this.makeRequestBC(request);
        res.catch(async (requestError)=>{
            requestError.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR ? this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'abort')) : this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'error'));
            $5527220553c094b9$var$logger.time(false, logId);
            throw await this.handleRequestError(request, requestError);
        });
        const { message: message, connectionInfo: connectionInfo } = await res;
        $5527220553c094b9$var$logger.time(false, logId);
        this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'success'));
        await this.notifySuccess(request, {
            account: activeAccount,
            output: message,
            connectionContext: connectionInfo,
            walletInfo: await this.getWalletInfo()
        });
        this.analytics.track('event', 'DAppClient', 'Signature response');
        return message;
    }
    /**
     * This method will send an "EncryptPayloadRequest" to the wallet. This method is meant to be used to encrypt or decrypt
     * arbitrary data (eg. a string). It will return the encrypted or decrypted payload
     *
     * @param input The message details we need to prepare the EncryptPayloadRequest message.
     */ // TODO: ENCRYPTION
    // public async requestEncryptPayload(
    //   input: RequestEncryptPayloadInput
    // ): Promise<EncryptPayloadResponseOutput> {
    //   if (!input.payload) {
    //     throw await this.sendInternalError('Payload must be provided')
    //   }
    //   const activeAccount: AccountInfo | undefined = await this.getActiveAccount()
    //   if (!activeAccount) {
    //     throw await this.sendInternalError('No active account!')
    //   }
    //   const payload = input.payload
    //   if (typeof payload !== 'string') {
    //     throw new Error('Payload must be a string')
    //   }
    //   if (typeof input.encryptionCryptoOperation === 'undefined') {
    //     throw new Error('encryptionCryptoOperation must be defined')
    //   }
    //   if (typeof input.encryptionType === 'undefined') {
    //     throw new Error('encryptionType must be defined')
    //   }
    //   const request: EncryptPayloadRequestInput = {
    //     type: BeaconMessageType.EncryptPayloadRequest,
    //     cryptoOperation: input.encryptionCryptoOperation,
    //     encryptionType: input.encryptionType,
    //     payload,
    //     sourceAddress: input.sourceAddress || activeAccount.address
    //   }
    //   const { message, connectionInfo } = await this.makeRequest<
    //     EncryptPayloadRequest,
    //     EncryptPayloadResponse
    //   >(request).catch(async (requestError: ErrorResponse) => {
    //     throw await this.handleRequestError(request, requestError)
    //   })
    //   await this.notifySuccess(request, {
    //     account: activeAccount,
    //     output: message,
    //     connectionContext: connectionInfo,
    //     walletInfo: await this.getWalletInfo()
    //   })
    //   return message
    // }
    /**
     * This method sends an OperationRequest to the wallet. This method should be used for all kinds of operations,
     * eg. transaction or delegation. Not all properties have to be provided. Data like "counter" and fees will be
     * fetched and calculated by the wallet (but they can still be provided if required).
     *
     * @param input The message details we need to prepare the OperationRequest message.
     */ async requestOperation(input) {
        if (!input.operationDetails) throw await this.sendInternalError('Operation details must be provided');
        const activeAccount = await this.getActiveAccount();
        if (!activeAccount) throw await this.sendInternalError('No active account!');
        const request = {
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).OperationRequest,
            network: activeAccount.network || this.network,
            operationDetails: input.operationDetails,
            sourceAddress: activeAccount.address || ''
        };
        this.analytics.track('event', 'DAppClient', 'Operation requested');
        this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'start'));
        const logId = `makeRequest ${Date.now()}`;
        $5527220553c094b9$var$logger.time(true, logId);
        const res = await this.checkMakeRequest() ? this.makeRequest(request) : this.makeRequestBC(request);
        res.catch(async (requestError)=>{
            requestError.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR ? this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'abort')) : this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'error'));
            $5527220553c094b9$var$logger.time(false, logId);
            throw await this.handleRequestError(request, requestError);
        });
        const { message: message, connectionInfo: connectionInfo } = await res;
        $5527220553c094b9$var$logger.time(false, logId);
        this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'success'));
        await this.notifySuccess(request, {
            account: activeAccount,
            output: message,
            blockExplorer: this.blockExplorer,
            connectionContext: connectionInfo,
            walletInfo: await this.getWalletInfo()
        });
        this.analytics.track('event', 'DAppClient', 'Operation response');
        return message;
    }
    /**
     * Sends a "BroadcastRequest" to the wallet. This method can be used to inject an already signed transaction
     * to the network.
     *
     * @param input The message details we need to prepare the BroadcastRequest message.
     */ async requestBroadcast(input) {
        if (!input.signedTransaction) throw await this.sendInternalError('Signed transaction must be provided');
        // Add error message for deprecation of network
        // TODO: Remove when we remove deprecated preferredNetwork
        if (input.network !== undefined && this.network.type !== input.network?.type) console.error('[BEACON] The network specified in the DAppClient constructor does not match the network set in the broadcast request. Please set the network in the constructor. Setting it during the Broadcast Request is deprecated.');
        const request = {
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BroadcastRequest,
            network: this.network,
            signedTransaction: input.signedTransaction
        };
        this.analytics.track('event', 'DAppClient', 'Broadcast requested');
        this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'start'));
        const logId = `makeRequest ${Date.now()}`;
        $5527220553c094b9$var$logger.time(true, logId);
        const res = await this.checkMakeRequest() ? this.makeRequest(request) : this.makeRequestBC(request);
        res.catch(async (requestError)=>{
            requestError.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).ABORTED_ERROR ? this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'abort')) : this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'error'));
            $5527220553c094b9$var$logger.time(false, logId);
            throw await this.handleRequestError(request, requestError);
        });
        const { message: message, connectionInfo: connectionInfo } = await res;
        $5527220553c094b9$var$logger.time(false, logId);
        this.sendMetrics('performance-metrics/save', await this.buildPayload('message', 'success'));
        await this.notifySuccess(request, {
            network: this.network,
            output: message,
            blockExplorer: this.blockExplorer,
            connectionContext: connectionInfo,
            walletInfo: await this.getWalletInfo()
        });
        this.analytics.track('event', 'DAppClient', 'Broadcast response');
        return message;
    }
    async setActivePeer(peer) {
        if (this._activePeer.isSettled()) // If the promise has already been resolved we need to create a new one.
        this._activePeer = (0, $247a3319916bcc85$export$babe85162c870d79).resolve(peer);
        else this._activePeer.resolve(peer);
        if (!peer) return;
        await this.initInternalTransports();
        if (peer.type === 'postmessage-pairing-response') await this.setTransport(this.postMessageTransport);
        else if (peer.type === 'p2p-pairing-response') await this.setTransport(this.p2pTransport);
    }
    /**
     * A "setter" for when the transport needs to be changed.
     */ async setTransport(transport) {
        if (!transport) this._initPromise = undefined;
        const result = super.setTransport(transport);
        const event = transport ? {
            ...transport
        } : undefined;
        // remove keyPair, to prevent dApps from accidentaly leaking the privateKey
        if (event) event.client = {
            ...event.client,
            keyPair: undefined
        };
        await this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).ACTIVE_TRANSPORT_SET, event);
        return result;
    }
    /**
     * This method will emit an internal error message.
     *
     * @param errorMessage The error message to send.
     */ async sendInternalError(errorMessage) {
        await this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).INTERNAL_ERROR, {
            text: errorMessage
        });
        throw new Error(errorMessage);
    }
    /**
     * This method will remove all accounts associated with a specific peer.
     *
     * @param peersToRemove An array of peers for which accounts should be removed
     */ async removeAccountsForPeers(peersToRemove) {
        const peerIdsToRemove = peersToRemove.map((peer)=>peer.senderId);
        return this.removeAccountsForPeerIds(peerIdsToRemove);
    }
    async removeAccountsForPeerIds(peerIds) {
        const accounts = await this.accountManager.getAccounts();
        // Remove all accounts with origin of the specified peer
        const accountsToRemove = accounts.filter((account)=>peerIds.includes(account.senderId));
        const accountIdentifiersToRemove = accountsToRemove.map((accountInfo)=>accountInfo.accountIdentifier);
        await this.accountManager.removeAccounts(accountIdentifiersToRemove);
        // Check if one of the accounts that was removed was the active account and if yes, set it to undefined
        const activeAccount = await this.getActiveAccount();
        if (activeAccount) {
            if (accountIdentifiersToRemove.includes(activeAccount.accountIdentifier)) await this.setActiveAccount(undefined);
        }
    }
    /**
     * This message handles errors that we receive from the wallet.
     *
     * @param request The request we sent
     * @param beaconError The error we received
     */ async handleRequestError(request, beaconError) {
        $5527220553c094b9$var$logger.error('handleRequestError', 'error response', beaconError);
        if (beaconError.errorType) {
            const buttons = [];
            if (beaconError.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).NO_PRIVATE_KEY_FOUND_ERROR) {
                const actionCallback = async ()=>{
                    const operationRequest = request;
                    // if the account we requested is not available, we remove it locally
                    let accountInfo;
                    if (operationRequest.sourceAddress && operationRequest.network) {
                        const accountIdentifier = await (0, $707e3c5710107d55$export$f481d8b6bb80ca4a)(operationRequest.sourceAddress, operationRequest.network);
                        accountInfo = await this.getAccount(accountIdentifier);
                        if (accountInfo) await this.removeAccount(accountInfo.accountIdentifier);
                    }
                };
                buttons.push({
                    text: 'Remove account',
                    actionCallback: actionCallback
                });
            }
            const peer = await this.getPeer();
            const activeAccount = await this.getActiveAccount();
            // If we sent a permission request, received an error and there is no active account, we need to reset the DAppClient.
            // This most likely means that the user rejected the first permission request after pairing a wallet, so we "forget" the paired wallet to allow the user to pair again.
            if (request.type === (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest && await this.getActiveAccount() === undefined) {
                this._initPromise = undefined;
                this.postMessageTransport = undefined;
                this.p2pTransport = undefined;
                this.walletConnectTransport = undefined;
                await this.setTransport();
                await this.setActivePeer();
            }
            this.events.emit((0, $f67be757e09f85ed$export$404463f191aa95a1)[request.type].error, {
                errorResponse: beaconError,
                walletInfo: await this.getWalletInfo(peer, activeAccount),
                errorMessages: this.errorMessages
            }, buttons).catch((emitError)=>$5527220553c094b9$var$logger.error('handleRequestError', emitError));
            throw (0, $3797c71f856a2ed6$export$2e2bcd8739ae039)(beaconError.errorType, beaconError.errorData);
        }
        throw beaconError;
    }
    /**
     * This message will send an event when we receive a successful response to one of the requests we sent.
     *
     * @param request The request we sent
     * @param response The response we received
     */ async notifySuccess(request, response) {
        this.events.emit((0, $f67be757e09f85ed$export$404463f191aa95a1)[request.type].success, response).catch((emitError)=>console.warn(emitError));
    }
    async getWalletInfoFromStorage() {
        return await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).LAST_SELECTED_WALLET);
    }
    async updateStorageWallet(walletInfo) {
        const wallet = await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).LAST_SELECTED_WALLET);
        if (!wallet) return;
        wallet.name = walletInfo.name;
        wallet.icon = walletInfo.icon ?? wallet.icon;
        this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).LAST_SELECTED_WALLET, wallet);
    }
    async getWalletInfo(peer, account, readFromStorage = true) {
        const selectedAccount = account ? account : await this.getActiveAccount();
        const selectedPeer = peer ? peer : await this.getPeer(selectedAccount);
        let walletInfo;
        if (selectedAccount) walletInfo = await this.appMetadataManager.getAppMetadata(selectedAccount.senderId);
        let storageWallet;
        if (readFromStorage) storageWallet = await this.getWalletInfoFromStorage();
        if (!walletInfo) {
            walletInfo = {
                name: selectedPeer?.name ?? storageWallet?.key ?? '',
                icon: selectedPeer?.icon ?? storageWallet?.icon,
                type: storageWallet?.type
            };
            this.updateStorageWallet(walletInfo);
        }
        const lowerCaseCompare = (str1, str2)=>{
            if (str1 && str2) return str1.toLowerCase() === str2.toLowerCase();
            return false;
        };
        const getOrgName = (name)=>name.split(/[_\s]+/)[0];
        const apps = [
            ...(0, $cf61b77dbdb95489$export$cc7f6510f00b58d6)(),
            ...(0, $cf61b77dbdb95489$export$6924bc0a2358113f)(),
            ...(0, $cf61b77dbdb95489$export$aef0bf0b2d04be)(),
            ...(0, $cf61b77dbdb95489$export$ff6f27c71dedea72)()
        ].filter((app)=>lowerCaseCompare(getOrgName(app.key), getOrgName(walletInfo?.name ?? 'wallet')));
        // TODO: Remove once all wallets send the icon?
        const mobile = apps.find((app)=>app.universalLink || app.key.includes('ios') || app.key.includes('mobile'));
        const browser = apps.find((app)=>app.links);
        const desktop = apps.find((app)=>app.downloadLink);
        const extension = apps.find((app)=>app.id);
        const appTypeMap = {
            extension: {
                app: extension,
                type: 'extension'
            },
            desktop: {
                app: desktop,
                type: 'desktop'
            },
            mobile: {
                app: mobile,
                type: 'mobile'
            },
            web: {
                app: browser,
                type: 'web'
            }
        };
        const defaultType = ()=>{
            if ((0, $cf61b77dbdb95489$export$4e09c449d6c407f7)(window) && browser) return {
                app: browser,
                type: 'web'
            };
            if ((0, $cf61b77dbdb95489$export$1e4fed98bcaa1d82)(window) && desktop) return {
                app: desktop,
                type: 'desktop'
            };
            if ((0, $cf61b77dbdb95489$export$4e09c449d6c407f7)(window) && extension) return {
                app: extension,
                type: 'extension'
            };
            if (mobile) return {
                app: mobile,
                type: 'mobile'
            };
            return {
                app: undefined,
                type: undefined
            };
        };
        const { app: app, type: type } = storageWallet ? appTypeMap[storageWallet.type] : defaultType();
        if (app) {
            let deeplink;
            if (app.hasOwnProperty('links')) deeplink = app.links[selectedAccount?.network.type ?? this.network.type];
            else if (app.hasOwnProperty('deepLink')) deeplink = app.deepLink;
            return {
                name: app?.name ?? walletInfo.name,
                icon: app?.logo ?? walletInfo.icon,
                deeplink: deeplink,
                type: type
            };
        }
        return walletInfo;
    }
    async getPeer(account) {
        let peer;
        if (account) {
            $5527220553c094b9$var$logger.log('getPeer', 'We have an account', account);
            const postMessagePeers = await this.postMessageTransport?.getPeers() ?? [];
            const p2pPeers = await this.p2pTransport?.getPeers() ?? [];
            const walletConnectPeers = await this.walletConnectTransport?.getPeers() ?? [];
            const peers = [
                ...postMessagePeers,
                ...p2pPeers,
                ...walletConnectPeers
            ];
            $5527220553c094b9$var$logger.log('getPeer', 'Found peers', peers, account);
            peer = peers.find((peerEl)=>peerEl.senderId === account.senderId);
            if (!peer) // We could not find an exact match for a sender, so we most likely received it over a relay
            peer = peers.find((peerEl)=>peerEl.id === account.origin.id);
        } else {
            peer = await this._activePeer.promise;
            $5527220553c094b9$var$logger.log('getPeer', 'Active peer', peer);
        }
        return peer;
    }
    async makeRequest(requestInput, skipResponse, otherTabMessageId) {
        const messageId = otherTabMessageId ?? await (0, $788668db41590f82$export$2dbe1b699c206fb)();
        if (this._initPromise && this.isInitPending) {
            await Promise.all([
                this.postMessageTransport?.disconnect(),
                this.walletConnectTransport?.disconnect()
            ]);
            this._initPromise = undefined;
            this.hideUI([
                'toast'
            ]);
        }
        $5527220553c094b9$var$logger.log('makeRequest', 'starting');
        this.isInitPending = true;
        await this.init();
        this.isInitPending = false;
        $5527220553c094b9$var$logger.log('makeRequest', 'after init');
        if (await this.addRequestAndCheckIfRateLimited()) {
            this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).LOCAL_RATE_LIMIT_REACHED).catch((emitError)=>console.warn(emitError));
            throw new Error('rate limit reached');
        }
        if (!await this.checkPermissions(requestInput.type)) {
            this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).NO_PERMISSIONS).catch((emitError)=>console.warn(emitError));
            throw new Error('No permissions to send this request to wallet!');
        }
        if (!this.beaconId) throw await this.sendInternalError('BeaconID not defined');
        const request = {
            id: messageId,
            version: '2',
            senderId: await (0, $1c5c036caa7dc2d6$export$c00969587a4639cc)(await this.beaconId),
            ...requestInput
        };
        let exposed;
        if (!skipResponse) {
            exposed = new (0, $247a3319916bcc85$export$babe85162c870d79)();
            this.addOpenRequest(request.id, exposed);
        }
        const payload = await new (0, $33b837e22eef79cd$export$ef852775387a0be7)().serialize(request);
        const account = await this.getActiveAccount();
        const peer = await this.getPeer(account);
        const walletInfo = await this.getWalletInfo(peer, account);
        $5527220553c094b9$var$logger.log('makeRequest', 'sending message', request);
        try {
            (await this.transport).send(payload, peer);
            if (request.type !== (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest || this._activeAccount.isResolved() && await this._activeAccount.promise) this.tryToAppSwitch();
        } catch (sendError) {
            this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).INTERNAL_ERROR, {
                text: 'Unable to send message. If this problem persists, please reset the connection and pair your wallet again.',
                buttons: [
                    {
                        text: 'Reset Connection',
                        actionCallback: async ()=>{
                            (0, $cf61b77dbdb95489$export$c96659240d08478b)();
                            this.disconnect();
                        }
                    }
                ]
            });
            throw sendError;
        }
        if (!otherTabMessageId) this.events.emit((0, $f67be757e09f85ed$export$404463f191aa95a1)[requestInput.type].sent, {
            walletInfo: {
                ...walletInfo,
                name: walletInfo.name ?? 'Wallet'
            },
            extraInfo: {
                resetCallback: async ()=>{
                    this.disconnect();
                }
            }
        }).catch((emitError)=>console.warn(emitError));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return exposed?.promise; // TODO: fix type
    }
    /**
     * This method handles sending of requests to the DApp. It makes sure that the DAppClient is initialized and connected
     * to the transport. After that rate limits and permissions will be checked, an ID is attached and the request is sent
     * to the DApp over the transport.
     *
     * @param requestInput The BeaconMessage to be sent to the wallet
     * @param account The account that the message will be sent to
     */ async makeRequestV3(requestInput, otherTabMessageId) {
        if (this._initPromise && this.isInitPending) {
            await Promise.all([
                this.postMessageTransport?.disconnect(),
                this.walletConnectTransport?.disconnect()
            ]);
            this._initPromise = undefined;
            this.hideUI([
                'toast'
            ]);
        }
        const messageId = otherTabMessageId ?? await (0, $788668db41590f82$export$2dbe1b699c206fb)();
        $5527220553c094b9$var$logger.log('makeRequest', 'starting');
        this.isInitPending = true;
        await this.init(undefined, true);
        this.isInitPending = false;
        $5527220553c094b9$var$logger.log('makeRequest', 'after init');
        if (await this.addRequestAndCheckIfRateLimited()) {
            this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).LOCAL_RATE_LIMIT_REACHED).catch((emitError)=>console.warn(emitError));
            throw new Error('rate limit reached');
        }
        if (!this.beaconId) throw await this.sendInternalError('BeaconID not defined');
        const request = {
            id: messageId,
            version: '3',
            senderId: await (0, $1c5c036caa7dc2d6$export$c00969587a4639cc)(await this.beaconId),
            message: requestInput
        };
        const exposed = new (0, $247a3319916bcc85$export$babe85162c870d79)();
        this.addOpenRequest(request.id, exposed);
        const payload = await new (0, $33b837e22eef79cd$export$ef852775387a0be7)().serialize(request);
        const account = await this.getActiveAccount();
        const peer = await this.getPeer(account);
        const walletInfo = await this.getWalletInfo(peer, account);
        $5527220553c094b9$var$logger.log('makeRequest', 'sending message', request);
        try {
            (await this.transport).send(payload, peer);
            if (request.message.type !== (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest || this._activeAccount.isResolved() && await this._activeAccount.promise) this.tryToAppSwitch();
        } catch (sendError) {
            this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).INTERNAL_ERROR, {
                text: 'Unable to send message. If this problem persists, please reset the connection and pair your wallet again.',
                buttons: [
                    {
                        text: 'Reset Connection',
                        actionCallback: async ()=>{
                            (0, $cf61b77dbdb95489$export$c96659240d08478b)();
                            this.disconnect();
                        }
                    }
                ]
            });
            throw sendError;
        }
        const index = requestInput.type;
        this.events.emit((0, $f67be757e09f85ed$export$404463f191aa95a1)[index].sent, {
            walletInfo: {
                ...walletInfo,
                name: walletInfo.name ?? 'Wallet'
            },
            extraInfo: {
                resetCallback: async ()=>{
                    this.disconnect();
                }
            }
        }).catch((emitError)=>console.warn(emitError));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return exposed.promise; // TODO: fix type
    }
    async makeRequestBC(request) {
        if (!this._transport.isResolved()) return;
        const transport = await this.transport;
        if (transport.type !== (0, $809a8ab02b228419$export$6d07abd9f0bba447).WALLETCONNECT) return;
        if (await this.addRequestAndCheckIfRateLimited()) {
            this.events.emit((0, $0b587c8852746f57$export$8d08de21eea96a9c).LOCAL_RATE_LIMIT_REACHED).catch((emitError)=>console.warn(emitError));
            throw new Error('rate limit reached');
        }
        const id = await (0, $788668db41590f82$export$2dbe1b699c206fb)();
        this.multiTabChannel.postMessage({
            type: request.type,
            data: request,
            id: id
        });
        if (request.type !== (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest || this._activeAccount.isResolved() && await this._activeAccount.promise) this.tryToAppSwitch();
        this.events.emit((0, $f67be757e09f85ed$export$404463f191aa95a1)[(0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest].sent, {
            walletInfo: await this.getWalletInfo(),
            extraInfo: {
                resetCallback: ()=>this.disconnect()
            }
        }).catch((emitError)=>console.warn(emitError));
        const exposed = new (0, $247a3319916bcc85$export$babe85162c870d79)();
        this.addOpenRequest(id, exposed);
        return exposed.promise;
    }
    async disconnect() {
        if (!this._transport.isResolved()) throw new Error('No transport available.');
        const transport = await this.transport;
        if (transport.connectionStatus === (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).NOT_CONNECTED) throw new Error('Not connected.');
        await this.createStateSnapshot();
        this.sendMetrics('performance-metrics/save', await this.buildPayload('disconnect', 'start'));
        await this.clearActiveAccount();
        if (!(transport instanceof (0, $d26e51b83ef4cfff$export$9da242c25352d7d7))) await transport.disconnect();
        this.postMessageTransport = undefined;
        this.p2pTransport = undefined;
        this.walletConnectTransport = undefined;
        this.sendMetrics('performance-metrics/save', await this.buildPayload('disconnect', 'success'));
    }
    /**
     * Adds a requests to the "openRequests" set so we know what messages have already been answered/handled.
     *
     * @param id The ID of the message
     * @param promise A promise that resolves once the response for that specific message is received
     */ addOpenRequest(id, promise) {
        $5527220553c094b9$var$logger.log('addOpenRequest', this.name, `adding request ${id} and waiting for answer`);
        this.openRequests.set(id, promise);
    }
    async sendNotificationWithAccessToken(notification) {
        const { url: url, recipient: recipient, title: title, body: body, payload: payload, protocolIdentifier: protocolIdentifier, accessToken: accessToken } = notification;
        const timestamp = new Date().toISOString();
        const keypair = await this.keyPair;
        const rawPublicKey = keypair.publicKey;
        const prefix = $5527220553c094b9$require$Buffer.from(new Uint8Array([
            13,
            15,
            37,
            217
        ]));
        const publicKey = (0, $7e3a089a80d0b268$export$2e2bcd8739ae039).encode($5527220553c094b9$require$Buffer.concat([
            prefix,
            $5527220553c094b9$require$Buffer.from(rawPublicKey)
        ]));
        const constructedString = [
            'Tezos Signed Message: ',
            recipient,
            title,
            body,
            timestamp,
            payload
        ].join(' ');
        const bytes = (0, $efd1a952be4e6fd9$export$7ea66e3774a60b67)(constructedString);
        const payloadBytes = "0501" + bytes.length.toString(16).padStart(8, '0') + bytes;
        const signature = await (0, $efd1a952be4e6fd9$export$1d9a7a8a40780de)(payloadBytes, {
            secretKey: $5527220553c094b9$require$Buffer.from(keypair.secretKey)
        });
        const notificationResponse = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${url}/send`, {
            recipient: recipient,
            title: title,
            body: body,
            timestamp: timestamp,
            payload: payload,
            accessToken: accessToken,
            protocolIdentifier: protocolIdentifier,
            sender: {
                name: this.name,
                publicKey: publicKey,
                signature: signature
            }
        });
        return notificationResponse.data;
    }
    async onNewAccount(message, connectionInfo) {
        // TODO: Migration code. Remove sometime after 1.0.0 release.
        const tempPK = message.publicKey || message.pubkey || message.pubKey;
        const publicKey = !!tempPK ? (0, $efd1a952be4e6fd9$export$49a0f573bf6332f8)(tempPK) : undefined;
        if (!publicKey && !message.address) throw new Error('PublicKey or Address must be defined');
        const address = message.address ?? await (0, $efd1a952be4e6fd9$export$a28ea21350b9dd16)(publicKey);
        if (!(0, $efd1a952be4e6fd9$export$1987372119294ebb)(address)) throw new Error(`Invalid address: "${address}"`);
        if (message.walletType === 'abstracted_account' && address.substring(0, 3) !== (0, $15a40981d98388e5$export$f3c76c19efc1480d)) throw new Error(`Invalid abstracted account address "${address}", it should be a ${(0, $15a40981d98388e5$export$f3c76c19efc1480d)} address`);
        $5527220553c094b9$var$logger.log('######## MESSAGE #######');
        $5527220553c094b9$var$logger.log('onNewAccount', message);
        const walletKey = (await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).LAST_SELECTED_WALLET))?.key;
        const accountInfo = {
            accountIdentifier: await (0, $707e3c5710107d55$export$f481d8b6bb80ca4a)(address, message.network),
            senderId: message.senderId,
            origin: {
                type: connectionInfo.origin,
                id: connectionInfo.id
            },
            walletKey: walletKey,
            address: address,
            publicKey: publicKey,
            network: message.network,
            scopes: message.scopes,
            threshold: message.threshold,
            notification: message.notification,
            connectedAt: new Date().getTime(),
            walletType: message.walletType ?? 'implicit',
            verificationType: message.verificationType,
            ...message.verificationType === 'proof_of_event' ? {
                hasVerifiedChallenge: false
            } : {}
        };
        $5527220553c094b9$var$logger.log('accountInfo', '######## ACCOUNT INFO #######');
        $5527220553c094b9$var$logger.log('accountInfo', accountInfo);
        await this.accountManager.addAccount(accountInfo);
        await this.setActiveAccount(accountInfo);
        return accountInfo;
    }
}






let $709a4935e9866802$var$_instance;
const $709a4935e9866802$export$156a5106377fc5bb = (config, reset)=>{
    if ($709a4935e9866802$var$_instance && reset) {
        $709a4935e9866802$var$_instance.disconnect();
        $709a4935e9866802$var$_instance = undefined;
    }
    if ($709a4935e9866802$var$_instance) return $709a4935e9866802$var$_instance;
    if (!$709a4935e9866802$var$_instance) $709a4935e9866802$var$_instance = new (0, $5527220553c094b9$export$89c4f9f6e64272f0)(config);
    return $709a4935e9866802$var$_instance;
};




// ==========================================================================================
// parent error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Parent error class all taquito errors to extend from
 */ class $8b6476b09e20f53e$export$e5619b407b1c8b0a extends Error {
}
/**
 *  @category Error
 *  @description Error that indicates invalid user inputs
 */ class $8b6476b09e20f53e$export$9d3f3bc8b6d48950 extends $8b6476b09e20f53e$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error returned by RPC node
 */ class $8b6476b09e20f53e$export$5460eff990f31920 extends $8b6476b09e20f53e$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates TezosToolKit has not been configured appropriately
 */ class $8b6476b09e20f53e$export$32f4d70b2fb302b1 extends $8b6476b09e20f53e$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates a requested action is not supported by Taquito
 */ class $8b6476b09e20f53e$export$34bc216509d47ce6 extends $8b6476b09e20f53e$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error during a network operation
 */ class $8b6476b09e20f53e$export$bae979e68e4dc802 extends $8b6476b09e20f53e$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates user attempts an action without necessary permissions
 */ class $8b6476b09e20f53e$export$9c81d48c1e1840ac extends $8b6476b09e20f53e$export$e5619b407b1c8b0a {
}
// ==========================================================================================
// common error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Error that indicates an invalid originated or implicit address being passed or used
 */ class $8b6476b09e20f53e$export$66c44d927ffead98 extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidAddressError';
        this.message = `Invalid address "${address}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid block hash being passed or used
 */ class $8b6476b09e20f53e$export$16fabd343bcdfd7b extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(blockHash, errorDetail){
        super();
        this.blockHash = blockHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidBlockHashError';
        this.message = `Invalid block hash "${blockHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid amount of tez being passed as a parameter
 */ class $8b6476b09e20f53e$export$d8bf6d22cce8e288 extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(amount){
        super();
        this.amount = amount;
        this.name = 'InvalidAmountError';
        this.message = `Invalid amount "${amount}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid derivation path being passed or used
 */ class $8b6476b09e20f53e$export$522ca3df7030c309 extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(derivationPath, errorDetail){
        super();
        this.derivationPath = derivationPath;
        this.errorDetail = errorDetail;
        this.name = 'InvalidDerivationPathError';
        this.message = `Invalid derivation path "${derivationPath}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid hex string have been passed or used
 */ class $8b6476b09e20f53e$export$1888d6928c74d5ee extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(hexString, errorDetail){
        super();
        this.hexString = hexString;
        this.errorDetail = errorDetail;
        this.name = 'InvalidHexStringError';
        this.message = `Invalid hex string "${hexString}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid message being passed or used
 */ class $8b6476b09e20f53e$export$a5124d7665e9d8ad extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(msg, errorDetail){
        super();
        this.msg = msg;
        this.errorDetail = errorDetail;
        this.name = 'InvalidMessageError';
        this.message = `Invalid message "${msg}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid view parameter of a smart contract
 */ class $8b6476b09e20f53e$export$f9ce6a924724628b extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(viewName, sigs, args, cause){
        super();
        this.viewName = viewName;
        this.sigs = sigs;
        this.args = args;
        this.cause = cause;
        this.name = 'InvalidViewParameterError';
        this.message = `Invalid view arguments ${JSON.stringify(args)} received for name "${viewName}" expecting one of the following signatures ${JSON.stringify(sigs)}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid private key being passed or used
 */ class $8b6476b09e20f53e$export$adf223add86ae0aa extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(errorDetail){
        super();
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyError';
        this.message = `Invalid private key`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an Invalid Public Key being passed or used
 */ class $8b6476b09e20f53e$export$f675822ed489f01f extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(publicKey, errorDetail){
        super();
        this.publicKey = publicKey;
        this.errorDetail = errorDetail;
        this.name = 'InvalidPublicKeyError';
        this.message = `Invalid public key "${publicKey}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid signature being passed or used
 */ class $8b6476b09e20f53e$export$ccc2f68ef106615a extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(signature, errorDetail){
        super();
        this.signature = signature;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSignatureError';
        this.message = `Invalid signature "${signature}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid contract address being passed or used
 */ class $8b6476b09e20f53e$export$193774326795229b extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(contractAddress, errorDetail){
        super();
        this.contractAddress = contractAddress;
        this.errorDetail = errorDetail;
        this.name = 'InvalidContractAddressError';
        this.message = `Invalid contract address "${contractAddress}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid chain id being passed or used
 */ class $8b6476b09e20f53e$export$4836eb835ffca5b2 extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(chainId, errorDetail){
        super();
        this.chainId = chainId;
        this.errorDetail = errorDetail;
        this.name = 'InvalidChainIdError';
        this.message = `Invalid chain id "${chainId}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid public key hash being passed or used
 */ class $8b6476b09e20f53e$export$a3d7df0ca9d9410c extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(keyHash, errorDetail){
        super();
        this.keyHash = keyHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyHashError';
        this.message = `Invalid public key hash "${keyHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation hash being passed or used
 */ class $8b6476b09e20f53e$export$1a1c2023d3ec7a8a extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(operationHash, errorDetail){
        super();
        this.operationHash = operationHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationHashError';
        this.message = `Invalid operation hash "${operationHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation kind being passed or used
 */ class $8b6476b09e20f53e$export$bc5be87550569b55 extends $8b6476b09e20f53e$export$9d3f3bc8b6d48950 {
    constructor(operationKind, errorDetail){
        super();
        this.operationKind = operationKind;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationKindError';
        this.message = `Invalid operation kind "${operationKind}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description General error that indicates something is no longer supported and/or deprecated
 */ class $8b6476b09e20f53e$export$11034991807c583d extends $8b6476b09e20f53e$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'DeprecationError';
    }
}
/**
 *  @category Error
 *  @description General error that indicates an action is prohibited or not allowed
 */ class $8b6476b09e20f53e$export$4041d915d9096adf extends $8b6476b09e20f53e$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ProhibitedActionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure in grabbing the public key
 */ class $8b6476b09e20f53e$export$183b043cd3c947f9 extends $8b6476b09e20f53e$export$e5619b407b1c8b0a {
    constructor(pkh, cause){
        super();
        this.pkh = pkh;
        this.cause = cause;
        this.name = 'PublicKeyNotFoundError';
        this.message = `Public key not found of this address "${pkh}" in either wallet or contract API.`;
    }
}


var $42fd859874341478$exports = {};
/*! typedarray-to-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /**
 * Convert a typed array to a Buffer without a copy
 *
 * Author:   Feross Aboukhadijeh <https://feross.org>
 * License:  MIT
 *
 * `npm install typedarray-to-buffer`
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $42fd859874341478$require$Buffer = $6ZWSX.Buffer;
$42fd859874341478$exports = function typedarrayToBuffer(arr) {
    return ArrayBuffer.isView(arr) ? $42fd859874341478$require$Buffer.from(arr.buffer, arr.byteOffset, arr.byteLength) : $42fd859874341478$require$Buffer.from(arr);
};



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $e7f526111d047632$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
/**
 *  @category Error
 *  @description Error that indicates a general failure in making the HTTP request
 */ class $e7f526111d047632$export$358d9e688c05bde3 extends (0, $8b6476b09e20f53e$export$bae979e68e4dc802) {
    constructor(method, url, cause){
        super();
        this.method = method;
        this.url = url;
        this.cause = cause;
        this.name = 'HttpRequestFailed';
        this.message = `${method} ${url} ${String(cause)}`;
    }
}
/**
 *  @category Error
 *  @description Error thrown when the endpoint returns an HTTP error to the client
 */ class $e7f526111d047632$export$d2f2761cbe9cebf2 extends (0, $8b6476b09e20f53e$export$bae979e68e4dc802) {
    constructor(message, status, statusText, body, url){
        super();
        this.message = message;
        this.status = status;
        this.statusText = statusText;
        this.body = body;
        this.url = url;
        this.name = 'HttpResponseError';
    }
}
/**
 *  @category Error
 *  @description Error
 */ class $e7f526111d047632$export$faa3cc8a16ea23df extends (0, $8b6476b09e20f53e$export$bae979e68e4dc802) {
    constructor(timeout, url){
        super();
        this.timeout = timeout;
        this.url = url;
        this.name = 'HttpTimeoutError';
        this.message = `HTTP request timeout of ${timeout}ms exceeded`;
    }
}
/**
 * Hypertext Transfer Protocol (HTTP) response status codes.
 * @see {@link https://en.wikipedia.org/wiki/List_of_HTTP_status_codes}
 */ var $e7f526111d047632$export$bc3aa03eb4b395cf;
(function(STATUS_CODE) {
    /**
     * The server has received the request headers and the client should proceed to send the request body
     * (in the case of a request for which a body needs to be sent; for example, a POST request).
     * Sending a large request body to a server after a request has been rejected for inappropriate headers would be inefficient.
     * To have a server check the request's headers, a client must send Expect: 100-continue as a header in its initial request
     * and receive a 100 Continue status code in response before sending the body. The response 417 Expectation Failed indicates the request should not be continued.
     */ STATUS_CODE[STATUS_CODE["CONTINUE"] = 100] = "CONTINUE";
    /**
     * The requester has asked the server to switch protocols and the server has agreed to do so.
     */ STATUS_CODE[STATUS_CODE["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    /**
     * A WebDAV request may contain many sub-requests involving file operations, requiring a long time to complete the request.
     * This code indicates that the server has received and is processing the request, but no response is available yet.
     * This prevents the client from timing out and assuming the request was lost.
     */ STATUS_CODE[STATUS_CODE["PROCESSING"] = 102] = "PROCESSING";
    /**
     * Standard response for successful HTTP requests.
     * The actual response will depend on the request method used.
     * In a GET request, the response will contain an entity corresponding to the requested resource.
     * In a POST request, the response will contain an entity describing or containing the result of the action.
     */ STATUS_CODE[STATUS_CODE["OK"] = 200] = "OK";
    /**
     * The request has been fulfilled, resulting in the creation of a new resource.
     */ STATUS_CODE[STATUS_CODE["CREATED"] = 201] = "CREATED";
    /**
     * The request has been accepted for processing, but the processing has not been completed.
     * The request might or might not be eventually acted upon, and may be disallowed when processing occurs.
     */ STATUS_CODE[STATUS_CODE["ACCEPTED"] = 202] = "ACCEPTED";
    /**
     * SINCE HTTP/1.1
     * The server is a transforming proxy that received a 200 OK from its origin,
     * but is returning a modified version of the origin's response.
     */ STATUS_CODE[STATUS_CODE["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    /**
     * The server successfully processed the request and is not returning any content.
     */ STATUS_CODE[STATUS_CODE["NO_CONTENT"] = 204] = "NO_CONTENT";
    /**
     * The server successfully processed the request, but is not returning any content.
     * Unlike a 204 response, this response requires that the requester reset the document view.
     */ STATUS_CODE[STATUS_CODE["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    /**
     * The server is delivering only part of the resource (byte serving) due to a range header sent by the client.
     * The range header is used by HTTP clients to enable resuming of interrupted downloads,
     * or split a download into multiple simultaneous streams.
     */ STATUS_CODE[STATUS_CODE["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    /**
     * The message body that follows is an XML message and can contain a number of separate response codes,
     * depending on how many sub-requests were made.
     */ STATUS_CODE[STATUS_CODE["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    /**
     * The members of a DAV binding have already been enumerated in a preceding part of the (multistatus) response,
     * and are not being included again.
     */ STATUS_CODE[STATUS_CODE["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
    /**
     * The server has fulfilled a request for the resource,
     * and the response is a representation of the result of one or more instance-manipulations applied to the current instance.
     */ STATUS_CODE[STATUS_CODE["IM_USED"] = 226] = "IM_USED";
    /**
     * Indicates multiple options for the resource from which the client may choose (via agent-driven content negotiation).
     * For example, this code could be used to present multiple video format options,
     * to list files with different filename extensions, or to suggest word-sense disambiguation.
     */ STATUS_CODE[STATUS_CODE["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    /**
     * This and all future requests should be directed to the given URI.
     */ STATUS_CODE[STATUS_CODE["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    /**
     * This is an example of industry practice contradicting the standard.
     * The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect
     * (the original describing phrase was "Moved Temporarily"), but popular browsers implemented 302
     * with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307
     * to distinguish between the two behaviours. However, some Web applications and frameworks
     * use the 302 status code as if it were the 303.
     */ STATUS_CODE[STATUS_CODE["FOUND"] = 302] = "FOUND";
    /**
     * SINCE HTTP/1.1
     * The response to the request can be found under another URI using a GET method.
     * When received in response to a POST (or PUT/DELETE), the client should presume that
     * the server has received the data and should issue a redirect with a separate GET message.
     */ STATUS_CODE[STATUS_CODE["SEE_OTHER"] = 303] = "SEE_OTHER";
    /**
     * Indicates that the resource has not been modified since the version specified by the request headers If-Modified-Since or If-None-Match.
     * In such case, there is no need to retransmit the resource since the client still has a previously-downloaded copy.
     */ STATUS_CODE[STATUS_CODE["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    /**
     * SINCE HTTP/1.1
     * The requested resource is available only through a proxy, the address for which is provided in the response.
     * Many HTTP clients (such as Mozilla and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.
     */ STATUS_CODE[STATUS_CODE["USE_PROXY"] = 305] = "USE_PROXY";
    /**
     * No longer used. Originally meant "Subsequent requests should use the specified proxy."
     */ STATUS_CODE[STATUS_CODE["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
    /**
     * SINCE HTTP/1.1
     * In this case, the request should be repeated with another URI; however, future requests should still use the original URI.
     * In contrast to how 302 was historically implemented, the request method is not allowed to be changed when reissuing the original request.
     * For example, a POST request should be repeated using another POST request.
     */ STATUS_CODE[STATUS_CODE["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    /**
     * The request and all future requests should be repeated using another URI.
     * 307 and 308 parallel the behaviors of 302 and 301, but do not allow the HTTP method to change.
     * So, for example, submitting a form to a permanently redirected resource may continue smoothly.
     */ STATUS_CODE[STATUS_CODE["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    /**
     * The server cannot or will not process the request due to an apparent client error
     * (e.g., malformed request syntax, too large size, invalid request message framing, or deceptive request routing).
     */ STATUS_CODE[STATUS_CODE["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    /**
     * Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet
     * been provided. The response must include a WWW-Authenticate header field containing a challenge applicable to the
     * requested resource. See Basic access authentication and Digest access authentication. 401 semantically means
     * "unauthenticated",i.e. the user does not have the necessary credentials.
     */ STATUS_CODE[STATUS_CODE["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    /**
     * Reserved for future use. The original intention was that this code might be used as part of some form of digital
     * cash or micro payment scheme, but that has not happened, and this code is not usually used.
     * Google Developers API uses this status if a particular developer has exceeded the daily limit on requests.
     */ STATUS_CODE[STATUS_CODE["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    /**
     * The request was valid, but the server is refusing action.
     * The user might not have the necessary permissions for a resource.
     */ STATUS_CODE[STATUS_CODE["FORBIDDEN"] = 403] = "FORBIDDEN";
    /**
     * The requested resource could not be found but may be available in the future.
     * Subsequent requests by the client are permissible.
     */ STATUS_CODE[STATUS_CODE["NOT_FOUND"] = 404] = "NOT_FOUND";
    /**
     * A request method is not supported for the requested resource;
     * for example, a GET request on a form that requires data to be presented via POST, or a PUT request on a read-only resource.
     */ STATUS_CODE[STATUS_CODE["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    /**
     * The requested resource is capable of generating only content not acceptable according to the Accept headers sent in the request.
     */ STATUS_CODE[STATUS_CODE["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    /**
     * The client must first authenticate itself with the proxy.
     */ STATUS_CODE[STATUS_CODE["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    /**
     * The server timed out waiting for the request.
     * According to HTTP specifications:
     * "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
     */ STATUS_CODE[STATUS_CODE["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    /**
     * Indicates that the request could not be processed because of conflict in the request,
     * such as an edit conflict between multiple simultaneous updates.
     */ STATUS_CODE[STATUS_CODE["CONFLICT"] = 409] = "CONFLICT";
    /**
     * Indicates that the resource requested is no longer available and will not be available again.
     * This should be used when a resource has been intentionally removed and the resource should be purged.
     * Upon receiving a 410 status code, the client should not request the resource in the future.
     * Clients such as search engines should remove the resource from their indices.
     * Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
     */ STATUS_CODE[STATUS_CODE["GONE"] = 410] = "GONE";
    /**
     * The request did not specify the length of its content, which is required by the requested resource.
     */ STATUS_CODE[STATUS_CODE["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    /**
     * The server does not meet one of the preconditions that the requester put on the request.
     */ STATUS_CODE[STATUS_CODE["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    /**
     * The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".
     */ STATUS_CODE[STATUS_CODE["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    /**
     * The URI provided was too long for the server to process. Often the result of too much data being encoded as a query-string of a GET request,
     * in which case it should be converted to a POST request.
     * Called "Request-URI Too Long" previously.
     */ STATUS_CODE[STATUS_CODE["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
    /**
     * The request entity has a media type which the server or resource does not support.
     * For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
     */ STATUS_CODE[STATUS_CODE["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    /**
     * The client has asked for a portion of the file (byte serving), but the server cannot supply that portion.
     * For example, if the client asked for a part of the file that lies beyond the end of the file.
     * Called "Requested Range Not Satisfiable" previously.
     */ STATUS_CODE[STATUS_CODE["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
    /**
     * The server cannot meet the requirements of the Expect request-header field.
     */ STATUS_CODE[STATUS_CODE["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    /**
     * This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol,
     * and is not expected to be implemented by actual HTTP servers. The RFC specifies this code should be returned by
     * teapots requested to brew coffee. This HTTP status is used as an Easter egg in some websites, including Google.com.
     */ STATUS_CODE[STATUS_CODE["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
    /**
     * The request was directed at a server that is not able to produce a response (for example because a connection reuse).
     */ STATUS_CODE[STATUS_CODE["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    /**
     * The request was well-formed but was unable to be followed due to semantic errors.
     */ STATUS_CODE[STATUS_CODE["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    /**
     * The resource that is being accessed is locked.
     */ STATUS_CODE[STATUS_CODE["LOCKED"] = 423] = "LOCKED";
    /**
     * The request failed due to failure of a previous request (e.g., a PROPPATCH).
     */ STATUS_CODE[STATUS_CODE["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    /**
     * The client should switch to a different protocol such as TLS/1.0, given in the Upgrade header field.
     */ STATUS_CODE[STATUS_CODE["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    /**
     * The origin server requires the request to be conditional.
     * Intended to prevent "the 'lost update' problem, where a client
     * GETs a resource's state, modifies it, and PUTs it back to the server,
     * when meanwhile a third party has modified the state on the server, leading to a conflict."
     */ STATUS_CODE[STATUS_CODE["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    /**
     * The user has sent too many requests in a given amount of time. Intended for use with rate-limiting schemes.
     */ STATUS_CODE[STATUS_CODE["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    /**
     * The server is unwilling to process the request because either an individual header field,
     * or all the header fields collectively, are too large.
     */ STATUS_CODE[STATUS_CODE["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    /**
     * A server operator has received a legal demand to deny access to a resource or to a set of resources
     * that includes the requested resource. The code 451 was chosen as a reference to the novel Fahrenheit 451.
     */ STATUS_CODE[STATUS_CODE["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    /**
     * A generic error message, given when an unexpected condition was encountered and no more specific message is suitable.
     */ STATUS_CODE[STATUS_CODE["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    /**
     * The server either does not recognize the request method, or it lacks the ability to fulfill the request.
     * Usually this implies future availability (e.g., a new feature of a web-service API).
     */ STATUS_CODE[STATUS_CODE["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    /**
     * The server was acting as a gateway or proxy and received an invalid response from the upstream server.
     */ STATUS_CODE[STATUS_CODE["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    /**
     * The server is currently unavailable (because it is overloaded or down for maintenance).
     * Generally, this is a temporary state.
     */ STATUS_CODE[STATUS_CODE["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    /**
     * The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.
     */ STATUS_CODE[STATUS_CODE["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    /**
     * The server does not support the HTTP protocol version used in the request
     */ STATUS_CODE[STATUS_CODE["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    /**
     * Transparent content negotiation for the request results in a circular reference.
     */ STATUS_CODE[STATUS_CODE["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
    /**
     * The server is unable to store the representation needed to complete the request.
     */ STATUS_CODE[STATUS_CODE["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    /**
     * The server detected an infinite loop while processing the request.
     */ STATUS_CODE[STATUS_CODE["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
    /**
     * Further extensions to the request are required for the server to fulfill it.
     */ STATUS_CODE[STATUS_CODE["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
    /**
     * The client needs to authenticate to gain network access.
     * Intended for use by intercepting proxies used to control access to the network (e.g., "captive portals" used
     * to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).
     */ STATUS_CODE[STATUS_CODE["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})($e7f526111d047632$export$bc3aa03eb4b395cf || ($e7f526111d047632$export$bc3aa03eb4b395cf = {}));
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $e7f526111d047632$export$a4ad2735b021c132 = {
    "commitHash": "2e05f6f865be17a1b367b284542b24ffa9823271",
    "version": "19.2.1"
};
/**
 * @packageDocumentation
 * @module @taquito/http-utils
 */ var $e7f526111d047632$var$_a;
let $e7f526111d047632$var$fetch = globalThis === null || globalThis === void 0 ? void 0 : globalThis.fetch;
// Will only use browser fetch if we are in a browser environment,
// default to the more stable node-fetch otherwise
const $e7f526111d047632$var$isNode = false;

if ($e7f526111d047632$var$isNode) $e7f526111d047632$var$fetch = (parcelRequire("fLVpN"));
class $e7f526111d047632$export$aac4ca225fe02187 {
    constructor(timeout = 30000){
        this.timeout = timeout;
    }
    serialize(obj) {
        if (!obj) return '';
        const str = [];
        for(const p in obj)// eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(p) && typeof obj[p] !== 'undefined') {
            const prop = typeof obj[p].toJSON === 'function' ? obj[p].toJSON() : obj[p];
            // query arguments can have no value so we need some way of handling that
            // example https://domain.com/query?all
            if (prop === null) {
                str.push(encodeURIComponent(p));
                continue;
            }
            // another use case is multiple arguments with the same name
            // they are passed as array
            if (Array.isArray(prop)) {
                prop.forEach((item)=>{
                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(item));
                });
                continue;
            }
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(prop));
        }
        const serialized = str.join('&');
        if (serialized) return `?${serialized}`;
        else return '';
    }
    /**
     *
     * @param options contains options to be passed for the HTTP request (url, method and timeout)
     * @throws {@link HttpRequestFailed} | {@link HttpResponseError} | {@link HttpTimeoutError}
     */ createRequest({ url: url, method: method, timeout: timeout = this.timeout, query: query, headers: headers = {}, json: json = true }, data) {
        return $e7f526111d047632$var$__awaiter(this, void 0, void 0, function*() {
            // Serializes query params
            const urlWithQuery = url + this.serialize(query);
            // Adds default header entry if there aren't any Content-Type header
            if (!headers['Content-Type']) headers['Content-Type'] = 'application/json';
            // Creates a new AbortController instance to handle timeouts
            const controller = new AbortController();
            const t = setTimeout(()=>controller.abort(), timeout);
            try {
                const response = yield $e7f526111d047632$var$fetch(urlWithQuery, {
                    method: method,
                    headers: headers,
                    body: JSON.stringify(data),
                    signal: controller.signal
                });
                if (typeof response === 'undefined') throw new Error('Response is undefined');
                // Handle responses with status code >= 400
                if (response.status >= 400) {
                    const errorData = yield response.text();
                    throw new $e7f526111d047632$export$d2f2761cbe9cebf2(`Http error response: (${response.status}) ${errorData}`, response.status, response.statusText, errorData, urlWithQuery);
                }
                if (json) return response.json();
                else return response.text();
            } catch (e) {
                if (e instanceof Error && e.name === 'AbortError') throw new $e7f526111d047632$export$faa3cc8a16ea23df(timeout, urlWithQuery);
                else if (e instanceof $e7f526111d047632$export$d2f2761cbe9cebf2) throw e;
                else throw new $e7f526111d047632$export$358d9e688c05bde3(String(method), urlWithQuery, e);
            } finally{
                clearTimeout(t);
            }
        });
    }
}


var $42f5864281cc433e$exports = {};
(function(globalObject) {
    'use strict';
    /*
 *      bignumber.js v9.3.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = '[BigNumber Error] ', tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ', BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: '',
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ',',
            decimalSeparator: '.',
            fractionGroupSize: 0,
            fractionGroupSeparator: '\xA0',
            suffix: ''
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz', alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == 'number') && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, 'Base');
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == 'number') {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == '.') // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += '0');
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == 'object') {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = 'RANGE')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + ' cannot be zero: ' + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = 'CRYPTO')) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + 'crypto unavailable');
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + ' not true or false: ' + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = 'FORMAT')) {
                        v = obj[p];
                        if (typeof v == 'object') FORMAT = v;
                        else throw Error(bignumberError + p + ' not an object: ' + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = 'ALPHABET')) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + ' invalid: ' + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + 'Object expected: ' + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == '[object Array]') {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + 'Invalid BigNumber: ' + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + 'crypto unavailable');
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = '0123456789';
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf('.'), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace('.', '');
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // The index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, '0');
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += '0', len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne + (id === 2 && e > ne);
                    str = toFixedPoint(str, e, '0');
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += '.'; i--; str += '0');
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += '.';
                            for(; i--; str += '0');
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? '-' + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, '');
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, '0');
            return n.s < 0 ? '-' + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + 'Exponent not an integer: ' + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times('1e' + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber('0.5');
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += '0';
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = '5e' + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf('e') + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + '');
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == '9999' || !rep && n == '4999') {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == 'object') {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == 'object') {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != 'object') throw Error(bignumberError + 'Argument not an object: ' + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split('.'), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || '', intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = '-' + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'), '$&' + (format.fractionGroupSeparator || '')) : fractionPart) : intPart;
            }
            return (format.prefix || '') + str + (format.suffix || '');
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + 'Argument ' + (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = 'Infinity';
                    if (s < 0) str = '-' + str;
                } else str = 'NaN';
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, '0');
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, '0');
                } else {
                    intCheck(b, 2, ALPHABET.length, 'Base');
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = '-' + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + '';
        for(; i < j;){
            s = a[i++] + '';
            z = LOG_BASE - s.length;
            for(; z--; s = '0' + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || 'Argument') + (typeof n == 'number' ? n < min || n > max ? ' out of range: ' : ' not an integer: ' : ' not a primitive number: ') + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) + (e < 0 ? 'e' : 'e+') + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + '.'; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber['default'] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return BigNumber;
    });
    else if ($42f5864281cc433e$exports) $42f5864281cc433e$exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != 'undefined' && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})($42f5864281cc433e$exports);



var $6ZWSX = parcelRequire("6ZWSX");
var $6c853ef3ed869bb2$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($6c853ef3ed869bb2$exports, "__esModule", {
    value: true
});
$6c853ef3ed869bb2$exports.convertSecretKeyToX25519 = $6c853ef3ed869bb2$exports.convertPublicKeyToX25519 = $6c853ef3ed869bb2$exports.verify = $6c853ef3ed869bb2$exports.sign = $6c853ef3ed869bb2$exports.extractPublicKeyFromSecretKey = $6c853ef3ed869bb2$exports.generateKeyPair = $6c853ef3ed869bb2$exports.generateKeyPairFromSeed = $6c853ef3ed869bb2$exports.SEED_LENGTH = $6c853ef3ed869bb2$exports.SECRET_KEY_LENGTH = $6c853ef3ed869bb2$exports.PUBLIC_KEY_LENGTH = $6c853ef3ed869bb2$exports.SIGNATURE_LENGTH = void 0;
var $6401c14576bf7a04$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($6401c14576bf7a04$exports, "__esModule", {
    value: true
});
$6401c14576bf7a04$exports.randomStringForEntropy = $6401c14576bf7a04$exports.randomString = $6401c14576bf7a04$exports.randomUint32 = $6401c14576bf7a04$exports.randomBytes = $6401c14576bf7a04$exports.defaultRandomSource = void 0;
var $9281b61c5141982a$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($9281b61c5141982a$exports, "__esModule", {
    value: true
});
$9281b61c5141982a$exports.SystemRandomSource = void 0;
var $2fb235bc0f7ef097$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($2fb235bc0f7ef097$exports, "__esModule", {
    value: true
});
$2fb235bc0f7ef097$exports.BrowserRandomSource = void 0;
const $2fb235bc0f7ef097$var$QUOTA = 65536;
class $2fb235bc0f7ef097$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== 'undefined' ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $2fb235bc0f7ef097$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $2fb235bc0f7ef097$var$QUOTA)));
        return out;
    }
}
$2fb235bc0f7ef097$exports.BrowserRandomSource = $2fb235bc0f7ef097$var$BrowserRandomSource;


var $8ec22cd8b3ef0a46$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($8ec22cd8b3ef0a46$exports, "__esModule", {
    value: true
});
$8ec22cd8b3ef0a46$exports.NodeRandomSource = void 0;
var $53559a41a7596ea9$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($53559a41a7596ea9$exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $53559a41a7596ea9$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
$53559a41a7596ea9$exports.wipe = $53559a41a7596ea9$var$wipe;



class $8ec22cd8b3ef0a46$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("kjyEk"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $53559a41a7596ea9$exports.wipe)(buffer);
        return out;
    }
}
$8ec22cd8b3ef0a46$exports.NodeRandomSource = $8ec22cd8b3ef0a46$var$NodeRandomSource;


class $9281b61c5141982a$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $2fb235bc0f7ef097$exports.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $8ec22cd8b3ef0a46$exports.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
$9281b61c5141982a$exports.SystemRandomSource = $9281b61c5141982a$var$SystemRandomSource;


var $f0b308eb62313e88$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($f0b308eb62313e88$exports, "__esModule", {
    value: true
});
var $81588307855e8dae$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($81588307855e8dae$exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $81588307855e8dae$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
$81588307855e8dae$exports.mul = Math.imul || $81588307855e8dae$var$imulShim;
/** 32-bit integer addition.  */ function $81588307855e8dae$var$add(a, b) {
    return a + b | 0;
}
$81588307855e8dae$exports.add = $81588307855e8dae$var$add;
/**  32-bit integer subtraction.  */ function $81588307855e8dae$var$sub(a, b) {
    return a - b | 0;
}
$81588307855e8dae$exports.sub = $81588307855e8dae$var$sub;
/** 32-bit integer left rotation */ function $81588307855e8dae$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
$81588307855e8dae$exports.rotl = $81588307855e8dae$var$rotl;
/** 32-bit integer left rotation */ function $81588307855e8dae$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
$81588307855e8dae$exports.rotr = $81588307855e8dae$var$rotr;
function $81588307855e8dae$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ $81588307855e8dae$exports.isInteger = Number.isInteger || $81588307855e8dae$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ $81588307855e8dae$exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ $81588307855e8dae$exports.isSafeInteger = function(n) {
    return $81588307855e8dae$exports.isInteger(n) && n >= -$81588307855e8dae$exports.MAX_SAFE_INTEGER && n <= $81588307855e8dae$exports.MAX_SAFE_INTEGER;
};


// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $f0b308eb62313e88$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
$f0b308eb62313e88$exports.readInt16BE = $f0b308eb62313e88$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $f0b308eb62313e88$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
$f0b308eb62313e88$exports.readUint16BE = $f0b308eb62313e88$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $f0b308eb62313e88$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
$f0b308eb62313e88$exports.readInt16LE = $f0b308eb62313e88$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $f0b308eb62313e88$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
$f0b308eb62313e88$exports.readUint16LE = $f0b308eb62313e88$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
$f0b308eb62313e88$exports.writeUint16BE = $f0b308eb62313e88$var$writeUint16BE;
$f0b308eb62313e88$exports.writeInt16BE = $f0b308eb62313e88$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
$f0b308eb62313e88$exports.writeUint16LE = $f0b308eb62313e88$var$writeUint16LE;
$f0b308eb62313e88$exports.writeInt16LE = $f0b308eb62313e88$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $f0b308eb62313e88$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
$f0b308eb62313e88$exports.readInt32BE = $f0b308eb62313e88$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $f0b308eb62313e88$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
$f0b308eb62313e88$exports.readUint32BE = $f0b308eb62313e88$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $f0b308eb62313e88$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
$f0b308eb62313e88$exports.readInt32LE = $f0b308eb62313e88$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $f0b308eb62313e88$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
$f0b308eb62313e88$exports.readUint32LE = $f0b308eb62313e88$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
$f0b308eb62313e88$exports.writeUint32BE = $f0b308eb62313e88$var$writeUint32BE;
$f0b308eb62313e88$exports.writeInt32BE = $f0b308eb62313e88$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
$f0b308eb62313e88$exports.writeUint32LE = $f0b308eb62313e88$var$writeUint32LE;
$f0b308eb62313e88$exports.writeInt32LE = $f0b308eb62313e88$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $f0b308eb62313e88$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $f0b308eb62313e88$var$readInt32BE(array, offset);
    var lo = $f0b308eb62313e88$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$f0b308eb62313e88$exports.readInt64BE = $f0b308eb62313e88$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $f0b308eb62313e88$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $f0b308eb62313e88$var$readUint32BE(array, offset);
    var lo = $f0b308eb62313e88$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$f0b308eb62313e88$exports.readUint64BE = $f0b308eb62313e88$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $f0b308eb62313e88$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $f0b308eb62313e88$var$readInt32LE(array, offset);
    var hi = $f0b308eb62313e88$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$f0b308eb62313e88$exports.readInt64LE = $f0b308eb62313e88$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $f0b308eb62313e88$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $f0b308eb62313e88$var$readUint32LE(array, offset);
    var hi = $f0b308eb62313e88$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$f0b308eb62313e88$exports.readUint64LE = $f0b308eb62313e88$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $f0b308eb62313e88$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $f0b308eb62313e88$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
$f0b308eb62313e88$exports.writeUint64BE = $f0b308eb62313e88$var$writeUint64BE;
$f0b308eb62313e88$exports.writeInt64BE = $f0b308eb62313e88$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $f0b308eb62313e88$var$writeUint32LE(value >>> 0, out, offset);
    $f0b308eb62313e88$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
$f0b308eb62313e88$exports.writeUint64LE = $f0b308eb62313e88$var$writeUint64LE;
$f0b308eb62313e88$exports.writeInt64LE = $f0b308eb62313e88$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $f0b308eb62313e88$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$f0b308eb62313e88$exports.readUintBE = $f0b308eb62313e88$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $f0b308eb62313e88$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$f0b308eb62313e88$exports.readUintLE = $f0b308eb62313e88$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$81588307855e8dae$exports.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$f0b308eb62313e88$exports.writeUintBE = $f0b308eb62313e88$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$81588307855e8dae$exports.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$f0b308eb62313e88$exports.writeUintLE = $f0b308eb62313e88$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $f0b308eb62313e88$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
$f0b308eb62313e88$exports.readFloat32BE = $f0b308eb62313e88$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $f0b308eb62313e88$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
$f0b308eb62313e88$exports.readFloat32LE = $f0b308eb62313e88$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $f0b308eb62313e88$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
$f0b308eb62313e88$exports.readFloat64BE = $f0b308eb62313e88$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $f0b308eb62313e88$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
$f0b308eb62313e88$exports.readFloat64LE = $f0b308eb62313e88$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
$f0b308eb62313e88$exports.writeFloat32BE = $f0b308eb62313e88$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
$f0b308eb62313e88$exports.writeFloat32LE = $f0b308eb62313e88$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
$f0b308eb62313e88$exports.writeFloat64BE = $f0b308eb62313e88$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $f0b308eb62313e88$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
$f0b308eb62313e88$exports.writeFloat64LE = $f0b308eb62313e88$var$writeFloat64LE;



$6401c14576bf7a04$exports.defaultRandomSource = new $9281b61c5141982a$exports.SystemRandomSource();
function $6401c14576bf7a04$var$randomBytes(length, prng = $6401c14576bf7a04$exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
$6401c14576bf7a04$exports.randomBytes = $6401c14576bf7a04$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $6401c14576bf7a04$var$randomUint32(prng = $6401c14576bf7a04$exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $6401c14576bf7a04$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $f0b308eb62313e88$exports.readUint32LE)(buf);
    // Clean the buffer.
    (0, $53559a41a7596ea9$exports.wipe)(buf);
    return result;
}
$6401c14576bf7a04$exports.randomUint32 = $6401c14576bf7a04$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $6401c14576bf7a04$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $6401c14576bf7a04$var$randomString(length, charset = $6401c14576bf7a04$var$ALPHANUMERIC, prng = $6401c14576bf7a04$exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = '';
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $6401c14576bf7a04$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $53559a41a7596ea9$exports.wipe)(buf);
    }
    return out;
}
$6401c14576bf7a04$exports.randomString = $6401c14576bf7a04$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $6401c14576bf7a04$var$randomStringForEntropy(bits, charset = $6401c14576bf7a04$var$ALPHANUMERIC, prng = $6401c14576bf7a04$exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $6401c14576bf7a04$var$randomString(length, charset, prng);
}
$6401c14576bf7a04$exports.randomStringForEntropy = $6401c14576bf7a04$var$randomStringForEntropy;


var $64618b3cac198456$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($64618b3cac198456$exports, "__esModule", {
    value: true
});


$64618b3cac198456$exports.DIGEST_LENGTH = 64;
$64618b3cac198456$exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $64618b3cac198456$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = $64618b3cac198456$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $64618b3cac198456$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $53559a41a7596ea9$exports.wipe(this._buffer);
        $53559a41a7596ea9$exports.wipe(this._tempHi);
        $53559a41a7596ea9$exports.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < $64618b3cac198456$exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $64618b3cac198456$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $64618b3cac198456$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $f0b308eb62313e88$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $f0b308eb62313e88$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $64618b3cac198456$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $f0b308eb62313e88$exports.writeUint32BE(this._stateHi[i], out, i * 8);
            $f0b308eb62313e88$exports.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $53559a41a7596ea9$exports.wipe(savedState.stateHi);
        $53559a41a7596ea9$exports.wipe(savedState.stateLo);
        if (savedState.buffer) $53559a41a7596ea9$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
$64618b3cac198456$exports.SHA512 = $64618b3cac198456$var$SHA512;
// Constants
var $64618b3cac198456$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $64618b3cac198456$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $f0b308eb62313e88$exports.readUint32BE(m, j);
            wl[i] = $f0b308eb62313e88$exports.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $64618b3cac198456$var$K[i * 2];
            l = $64618b3cac198456$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $64618b3cac198456$var$hash(data) {
    var h = new $64618b3cac198456$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$64618b3cac198456$exports.hash = $64618b3cac198456$var$hash;



$6c853ef3ed869bb2$exports.SIGNATURE_LENGTH = 64;
$6c853ef3ed869bb2$exports.PUBLIC_KEY_LENGTH = 32;
$6c853ef3ed869bb2$exports.SECRET_KEY_LENGTH = 64;
$6c853ef3ed869bb2$exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $6c853ef3ed869bb2$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $6c853ef3ed869bb2$var$_9 = new Uint8Array(32);
$6c853ef3ed869bb2$var$_9[0] = 9;
const $6c853ef3ed869bb2$var$gf0 = $6c853ef3ed869bb2$var$gf();
const $6c853ef3ed869bb2$var$gf1 = $6c853ef3ed869bb2$var$gf([
    1
]);
const $6c853ef3ed869bb2$var$D = $6c853ef3ed869bb2$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $6c853ef3ed869bb2$var$D2 = $6c853ef3ed869bb2$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $6c853ef3ed869bb2$var$X = $6c853ef3ed869bb2$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $6c853ef3ed869bb2$var$Y = $6c853ef3ed869bb2$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $6c853ef3ed869bb2$var$I = $6c853ef3ed869bb2$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $6c853ef3ed869bb2$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $6c853ef3ed869bb2$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $6c853ef3ed869bb2$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $6c853ef3ed869bb2$var$pack25519(o, n) {
    const m = $6c853ef3ed869bb2$var$gf();
    const t = $6c853ef3ed869bb2$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $6c853ef3ed869bb2$var$car25519(t);
    $6c853ef3ed869bb2$var$car25519(t);
    $6c853ef3ed869bb2$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $6c853ef3ed869bb2$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $6c853ef3ed869bb2$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $6c853ef3ed869bb2$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $6c853ef3ed869bb2$var$pack25519(c, a);
    $6c853ef3ed869bb2$var$pack25519(d, b);
    return $6c853ef3ed869bb2$var$verify32(c, d);
}
function $6c853ef3ed869bb2$var$par25519(a) {
    const d = new Uint8Array(32);
    $6c853ef3ed869bb2$var$pack25519(d, a);
    return d[0] & 1;
}
function $6c853ef3ed869bb2$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $6c853ef3ed869bb2$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $6c853ef3ed869bb2$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $6c853ef3ed869bb2$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $6c853ef3ed869bb2$var$square(o, a) {
    $6c853ef3ed869bb2$var$mul(o, a, a);
}
function $6c853ef3ed869bb2$var$inv25519(o, i) {
    const c = $6c853ef3ed869bb2$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $6c853ef3ed869bb2$var$square(c, c);
        if (a !== 2 && a !== 4) $6c853ef3ed869bb2$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $6c853ef3ed869bb2$var$pow2523(o, i) {
    const c = $6c853ef3ed869bb2$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $6c853ef3ed869bb2$var$square(c, c);
        if (a !== 1) $6c853ef3ed869bb2$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $6c853ef3ed869bb2$var$edadd(p, q) {
    const a = $6c853ef3ed869bb2$var$gf(), b = $6c853ef3ed869bb2$var$gf(), c = $6c853ef3ed869bb2$var$gf(), d = $6c853ef3ed869bb2$var$gf(), e = $6c853ef3ed869bb2$var$gf(), f = $6c853ef3ed869bb2$var$gf(), g = $6c853ef3ed869bb2$var$gf(), h = $6c853ef3ed869bb2$var$gf(), t = $6c853ef3ed869bb2$var$gf();
    $6c853ef3ed869bb2$var$sub(a, p[1], p[0]);
    $6c853ef3ed869bb2$var$sub(t, q[1], q[0]);
    $6c853ef3ed869bb2$var$mul(a, a, t);
    $6c853ef3ed869bb2$var$add(b, p[0], p[1]);
    $6c853ef3ed869bb2$var$add(t, q[0], q[1]);
    $6c853ef3ed869bb2$var$mul(b, b, t);
    $6c853ef3ed869bb2$var$mul(c, p[3], q[3]);
    $6c853ef3ed869bb2$var$mul(c, c, $6c853ef3ed869bb2$var$D2);
    $6c853ef3ed869bb2$var$mul(d, p[2], q[2]);
    $6c853ef3ed869bb2$var$add(d, d, d);
    $6c853ef3ed869bb2$var$sub(e, b, a);
    $6c853ef3ed869bb2$var$sub(f, d, c);
    $6c853ef3ed869bb2$var$add(g, d, c);
    $6c853ef3ed869bb2$var$add(h, b, a);
    $6c853ef3ed869bb2$var$mul(p[0], e, f);
    $6c853ef3ed869bb2$var$mul(p[1], h, g);
    $6c853ef3ed869bb2$var$mul(p[2], g, f);
    $6c853ef3ed869bb2$var$mul(p[3], e, h);
}
function $6c853ef3ed869bb2$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$6c853ef3ed869bb2$var$sel25519(p[i], q[i], b);
}
function $6c853ef3ed869bb2$var$pack(r, p) {
    const tx = $6c853ef3ed869bb2$var$gf(), ty = $6c853ef3ed869bb2$var$gf(), zi = $6c853ef3ed869bb2$var$gf();
    $6c853ef3ed869bb2$var$inv25519(zi, p[2]);
    $6c853ef3ed869bb2$var$mul(tx, p[0], zi);
    $6c853ef3ed869bb2$var$mul(ty, p[1], zi);
    $6c853ef3ed869bb2$var$pack25519(r, ty);
    r[31] ^= $6c853ef3ed869bb2$var$par25519(tx) << 7;
}
function $6c853ef3ed869bb2$var$scalarmult(p, q, s) {
    $6c853ef3ed869bb2$var$set25519(p[0], $6c853ef3ed869bb2$var$gf0);
    $6c853ef3ed869bb2$var$set25519(p[1], $6c853ef3ed869bb2$var$gf1);
    $6c853ef3ed869bb2$var$set25519(p[2], $6c853ef3ed869bb2$var$gf1);
    $6c853ef3ed869bb2$var$set25519(p[3], $6c853ef3ed869bb2$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $6c853ef3ed869bb2$var$cswap(p, q, b);
        $6c853ef3ed869bb2$var$edadd(q, p);
        $6c853ef3ed869bb2$var$edadd(p, p);
        $6c853ef3ed869bb2$var$cswap(p, q, b);
    }
}
function $6c853ef3ed869bb2$var$scalarbase(p, s) {
    const q = [
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf()
    ];
    $6c853ef3ed869bb2$var$set25519(q[0], $6c853ef3ed869bb2$var$X);
    $6c853ef3ed869bb2$var$set25519(q[1], $6c853ef3ed869bb2$var$Y);
    $6c853ef3ed869bb2$var$set25519(q[2], $6c853ef3ed869bb2$var$gf1);
    $6c853ef3ed869bb2$var$mul(q[3], $6c853ef3ed869bb2$var$X, $6c853ef3ed869bb2$var$Y);
    $6c853ef3ed869bb2$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $6c853ef3ed869bb2$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $6c853ef3ed869bb2$exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${$6c853ef3ed869bb2$exports.SEED_LENGTH} bytes`);
    const d = (0, $64618b3cac198456$exports.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf()
    ];
    $6c853ef3ed869bb2$var$scalarbase(p, d);
    $6c853ef3ed869bb2$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$6c853ef3ed869bb2$exports.generateKeyPairFromSeed = $6c853ef3ed869bb2$var$generateKeyPairFromSeed;
function $6c853ef3ed869bb2$var$generateKeyPair(prng) {
    const seed = (0, $6401c14576bf7a04$exports.randomBytes)(32, prng);
    const result = $6c853ef3ed869bb2$var$generateKeyPairFromSeed(seed);
    (0, $53559a41a7596ea9$exports.wipe)(seed);
    return result;
}
$6c853ef3ed869bb2$exports.generateKeyPair = $6c853ef3ed869bb2$var$generateKeyPair;
function $6c853ef3ed869bb2$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== $6c853ef3ed869bb2$exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${$6c853ef3ed869bb2$exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
$6c853ef3ed869bb2$exports.extractPublicKeyFromSecretKey = $6c853ef3ed869bb2$var$extractPublicKeyFromSecretKey;
const $6c853ef3ed869bb2$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $6c853ef3ed869bb2$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $6c853ef3ed869bb2$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $6c853ef3ed869bb2$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $6c853ef3ed869bb2$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $6c853ef3ed869bb2$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $6c853ef3ed869bb2$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $6c853ef3ed869bb2$var$sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf()
    ];
    const d = (0, $64618b3cac198456$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new $64618b3cac198456$exports.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $6c853ef3ed869bb2$var$reduce(r);
    $6c853ef3ed869bb2$var$scalarbase(p, r);
    $6c853ef3ed869bb2$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $6c853ef3ed869bb2$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $6c853ef3ed869bb2$var$modL(signature.subarray(32), x);
    return signature;
}
$6c853ef3ed869bb2$exports.sign = $6c853ef3ed869bb2$var$sign;
function $6c853ef3ed869bb2$var$unpackneg(r, p) {
    const t = $6c853ef3ed869bb2$var$gf(), chk = $6c853ef3ed869bb2$var$gf(), num = $6c853ef3ed869bb2$var$gf(), den = $6c853ef3ed869bb2$var$gf(), den2 = $6c853ef3ed869bb2$var$gf(), den4 = $6c853ef3ed869bb2$var$gf(), den6 = $6c853ef3ed869bb2$var$gf();
    $6c853ef3ed869bb2$var$set25519(r[2], $6c853ef3ed869bb2$var$gf1);
    $6c853ef3ed869bb2$var$unpack25519(r[1], p);
    $6c853ef3ed869bb2$var$square(num, r[1]);
    $6c853ef3ed869bb2$var$mul(den, num, $6c853ef3ed869bb2$var$D);
    $6c853ef3ed869bb2$var$sub(num, num, r[2]);
    $6c853ef3ed869bb2$var$add(den, r[2], den);
    $6c853ef3ed869bb2$var$square(den2, den);
    $6c853ef3ed869bb2$var$square(den4, den2);
    $6c853ef3ed869bb2$var$mul(den6, den4, den2);
    $6c853ef3ed869bb2$var$mul(t, den6, num);
    $6c853ef3ed869bb2$var$mul(t, t, den);
    $6c853ef3ed869bb2$var$pow2523(t, t);
    $6c853ef3ed869bb2$var$mul(t, t, num);
    $6c853ef3ed869bb2$var$mul(t, t, den);
    $6c853ef3ed869bb2$var$mul(t, t, den);
    $6c853ef3ed869bb2$var$mul(r[0], t, den);
    $6c853ef3ed869bb2$var$square(chk, r[0]);
    $6c853ef3ed869bb2$var$mul(chk, chk, den);
    if ($6c853ef3ed869bb2$var$neq25519(chk, num)) $6c853ef3ed869bb2$var$mul(r[0], r[0], $6c853ef3ed869bb2$var$I);
    $6c853ef3ed869bb2$var$square(chk, r[0]);
    $6c853ef3ed869bb2$var$mul(chk, chk, den);
    if ($6c853ef3ed869bb2$var$neq25519(chk, num)) return -1;
    if ($6c853ef3ed869bb2$var$par25519(r[0]) === p[31] >> 7) $6c853ef3ed869bb2$var$sub(r[0], $6c853ef3ed869bb2$var$gf0, r[0]);
    $6c853ef3ed869bb2$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $6c853ef3ed869bb2$var$verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf()
    ];
    const q = [
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf()
    ];
    if (signature.length !== $6c853ef3ed869bb2$exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${$6c853ef3ed869bb2$exports.SIGNATURE_LENGTH} bytes`);
    if ($6c853ef3ed869bb2$var$unpackneg(q, publicKey)) return false;
    const hs = new $64618b3cac198456$exports.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $6c853ef3ed869bb2$var$reduce(h);
    $6c853ef3ed869bb2$var$scalarmult(p, q, h);
    $6c853ef3ed869bb2$var$scalarbase(q, signature.subarray(32));
    $6c853ef3ed869bb2$var$edadd(p, q);
    $6c853ef3ed869bb2$var$pack(t, p);
    if ($6c853ef3ed869bb2$var$verify32(signature, t)) return false;
    return true;
}
$6c853ef3ed869bb2$exports.verify = $6c853ef3ed869bb2$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $6c853ef3ed869bb2$var$convertPublicKeyToX25519(publicKey) {
    let q = [
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf(),
        $6c853ef3ed869bb2$var$gf()
    ];
    if ($6c853ef3ed869bb2$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $6c853ef3ed869bb2$var$gf();
    let b = $6c853ef3ed869bb2$var$gf();
    let y = q[1];
    $6c853ef3ed869bb2$var$add(a, $6c853ef3ed869bb2$var$gf1, y);
    $6c853ef3ed869bb2$var$sub(b, $6c853ef3ed869bb2$var$gf1, y);
    $6c853ef3ed869bb2$var$inv25519(b, b);
    $6c853ef3ed869bb2$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $6c853ef3ed869bb2$var$pack25519(z, a);
    return z;
}
$6c853ef3ed869bb2$exports.convertPublicKeyToX25519 = $6c853ef3ed869bb2$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $6c853ef3ed869bb2$var$convertSecretKeyToX25519(secretKey) {
    const d = (0, $64618b3cac198456$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $53559a41a7596ea9$exports.wipe)(d);
    return o;
}
$6c853ef3ed869bb2$exports.convertSecretKeyToX25519 = $6c853ef3ed869bb2$var$convertSecretKeyToX25519;


var $1fbb9568f45194cc$exports = {};
"use strict";
// Copyright (C) 2017 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($1fbb9568f45194cc$exports, "__esModule", {
    value: true
});


$1fbb9568f45194cc$exports.BLOCK_SIZE = 128;
$1fbb9568f45194cc$exports.DIGEST_LENGTH = 64;
$1fbb9568f45194cc$exports.KEY_LENGTH = 64;
$1fbb9568f45194cc$exports.PERSONALIZATION_LENGTH = 16;
$1fbb9568f45194cc$exports.SALT_LENGTH = 16;
$1fbb9568f45194cc$exports.MAX_LEAF_SIZE = Math.pow(2, 32) - 1;
$1fbb9568f45194cc$exports.MAX_FANOUT = 255;
$1fbb9568f45194cc$exports.MAX_MAX_DEPTH = 255; // not a typo
var $1fbb9568f45194cc$var$IV = new Uint32Array([
    // low bits // high bits
    0xf3bcc908,
    0x6a09e667,
    0x84caa73b,
    0xbb67ae85,
    0xfe94f82b,
    0x3c6ef372,
    0x5f1d36f1,
    0xa54ff53a,
    0xade682d1,
    0x510e527f,
    0x2b3e6c1f,
    0x9b05688c,
    0xfb41bd6b,
    0x1f83d9ab,
    0x137e2179,
    0x5be0cd19
]);
// Note: sigma values are doubled since we store
// 64-bit ints as two 32-bit ints in arrays.
var $1fbb9568f45194cc$var$SIGMA = [
    [
        0,
        2,
        4,
        6,
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30
    ],
    [
        28,
        20,
        8,
        16,
        18,
        30,
        26,
        12,
        2,
        24,
        0,
        4,
        22,
        14,
        10,
        6
    ],
    [
        22,
        16,
        24,
        0,
        10,
        4,
        30,
        26,
        20,
        28,
        6,
        12,
        14,
        2,
        18,
        8
    ],
    [
        14,
        18,
        6,
        2,
        26,
        24,
        22,
        28,
        4,
        12,
        10,
        20,
        8,
        0,
        30,
        16
    ],
    [
        18,
        0,
        10,
        14,
        4,
        8,
        20,
        30,
        28,
        2,
        22,
        24,
        12,
        16,
        6,
        26
    ],
    [
        4,
        24,
        12,
        20,
        0,
        22,
        16,
        6,
        8,
        26,
        14,
        10,
        30,
        28,
        2,
        18
    ],
    [
        24,
        10,
        2,
        30,
        28,
        26,
        8,
        20,
        0,
        14,
        12,
        6,
        18,
        4,
        16,
        22
    ],
    [
        26,
        22,
        14,
        28,
        24,
        2,
        6,
        18,
        10,
        0,
        30,
        8,
        16,
        12,
        4,
        20
    ],
    [
        12,
        30,
        28,
        18,
        22,
        6,
        0,
        16,
        24,
        4,
        26,
        14,
        2,
        8,
        20,
        10
    ],
    [
        20,
        4,
        16,
        8,
        14,
        12,
        2,
        10,
        30,
        22,
        18,
        28,
        6,
        24,
        26,
        0
    ],
    [
        0,
        2,
        4,
        6,
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30
    ],
    [
        28,
        20,
        8,
        16,
        18,
        30,
        26,
        12,
        2,
        24,
        0,
        4,
        22,
        14,
        10,
        6
    ]
];
/**
 * BLAKE2b hash function.
 */ var $1fbb9568f45194cc$var$BLAKE2b = /** @class */ function() {
    function BLAKE2b(digestLength, config) {
        if (digestLength === void 0) digestLength = 64;
        this.digestLength = digestLength;
        this.blockSize = $1fbb9568f45194cc$exports.BLOCK_SIZE;
        // Note: Int32Arrays for state and message are used for performance reasons.
        this._state = new Int32Array($1fbb9568f45194cc$var$IV); // hash state, initialized with IV
        this._buffer = new Uint8Array($1fbb9568f45194cc$exports.BLOCK_SIZE); // buffer for data
        this._bufferLength = 0; // number of bytes in buffer
        this._ctr = new Uint32Array(4);
        this._flag = new Uint32Array(4);
        this._lastNode = false;
        this._finished = false;
        this._vtmp = new Uint32Array(32);
        this._mtmp = new Uint32Array(32);
        // Validate digest length.
        if (digestLength < 1 || digestLength > $1fbb9568f45194cc$exports.DIGEST_LENGTH) throw new Error("blake2b: wrong digest length");
        // Validate config, if present.
        if (config) this.validateConfig(config);
        // Get key length from config.
        var keyLength = 0;
        if (config && config.key) keyLength = config.key.length;
        // Get tree fanout and maxDepth from config.
        var fanout = 1;
        var maxDepth = 1;
        if (config && config.tree) {
            fanout = config.tree.fanout;
            maxDepth = config.tree.maxDepth;
        }
        // Xor common parameters into state.
        this._state[0] ^= digestLength | keyLength << 8 | fanout << 16 | maxDepth << 24;
        // Xor tree parameters into state.
        if (config && config.tree) {
            this._state[1] ^= config.tree.leafSize;
            this._state[2] ^= config.tree.nodeOffsetLowBits;
            this._state[3] ^= config.tree.nodeOffsetHighBits;
            this._state[4] ^= config.tree.nodeDepth | config.tree.innerDigestLength << 8;
            this._lastNode = config.tree.lastNode;
        }
        // Xor salt into state.
        if (config && config.salt) {
            this._state[8] ^= $f0b308eb62313e88$exports.readUint32LE(config.salt, 0);
            this._state[9] ^= $f0b308eb62313e88$exports.readUint32LE(config.salt, 4);
            this._state[10] ^= $f0b308eb62313e88$exports.readUint32LE(config.salt, 8);
            this._state[11] ^= $f0b308eb62313e88$exports.readUint32LE(config.salt, 12);
        }
        // Xor personalization into state.
        if (config && config.personalization) {
            this._state[12] ^= $f0b308eb62313e88$exports.readUint32LE(config.personalization, 0);
            this._state[13] ^= $f0b308eb62313e88$exports.readUint32LE(config.personalization, 4);
            this._state[14] ^= $f0b308eb62313e88$exports.readUint32LE(config.personalization, 8);
            this._state[15] ^= $f0b308eb62313e88$exports.readUint32LE(config.personalization, 12);
        }
        // Save a copy of initialized state for reset.
        this._initialState = new Uint32Array(this._state);
        // Process key.
        if (config && config.key && keyLength > 0) {
            this._paddedKey = new Uint8Array($1fbb9568f45194cc$exports.BLOCK_SIZE);
            this._paddedKey.set(config.key);
            // Put padded key into buffer.
            this._buffer.set(this._paddedKey);
            this._bufferLength = $1fbb9568f45194cc$exports.BLOCK_SIZE;
        }
    }
    BLAKE2b.prototype.reset = function() {
        // Restore initial state.
        this._state.set(this._initialState);
        if (this._paddedKey) {
            // Put padded key into buffer.
            this._buffer.set(this._paddedKey);
            this._bufferLength = $1fbb9568f45194cc$exports.BLOCK_SIZE;
        } else this._bufferLength = 0;
        // Clear counters and flags.
        $53559a41a7596ea9$exports.wipe(this._ctr);
        $53559a41a7596ea9$exports.wipe(this._flag);
        this._finished = false;
        return this;
    };
    BLAKE2b.prototype.validateConfig = function(config) {
        if (config.key && config.key.length > $1fbb9568f45194cc$exports.KEY_LENGTH) throw new Error("blake2b: wrong key length");
        if (config.salt && config.salt.length !== $1fbb9568f45194cc$exports.SALT_LENGTH) throw new Error("blake2b: wrong salt length");
        if (config.personalization && config.personalization.length !== $1fbb9568f45194cc$exports.PERSONALIZATION_LENGTH) throw new Error("blake2b: wrong personalization length");
        if (config.tree) {
            if (config.tree.fanout < 0 || config.tree.fanout > $1fbb9568f45194cc$exports.MAX_FANOUT) throw new Error("blake2b: wrong tree fanout");
            if (config.tree.maxDepth < 0 || config.tree.maxDepth > $1fbb9568f45194cc$exports.MAX_MAX_DEPTH) throw new Error("blake2b: wrong tree depth");
            if (config.tree.leafSize < 0 || config.tree.leafSize > $1fbb9568f45194cc$exports.MAX_LEAF_SIZE) throw new Error("blake2b: wrong leaf size");
            if (config.tree.innerDigestLength < 0 || config.tree.innerDigestLength > $1fbb9568f45194cc$exports.DIGEST_LENGTH) throw new Error("blake2b: wrong tree inner digest length");
        }
    };
    BLAKE2b.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("blake2b: can't update because hash was finished.");
        var left = $1fbb9568f45194cc$exports.BLOCK_SIZE - this._bufferLength;
        var dataPos = 0;
        if (dataLength === 0) return this;
        // Finish buffer.
        if (dataLength > left) {
            for(var i = 0; i < left; i++)this._buffer[this._bufferLength + i] = data[dataPos + i];
            this._processBlock($1fbb9568f45194cc$exports.BLOCK_SIZE);
            dataPos += left;
            dataLength -= left;
            this._bufferLength = 0;
        }
        // Process data blocks.
        while(dataLength > $1fbb9568f45194cc$exports.BLOCK_SIZE){
            for(var i = 0; i < $1fbb9568f45194cc$exports.BLOCK_SIZE; i++)this._buffer[i] = data[dataPos + i];
            this._processBlock($1fbb9568f45194cc$exports.BLOCK_SIZE);
            dataPos += $1fbb9568f45194cc$exports.BLOCK_SIZE;
            dataLength -= $1fbb9568f45194cc$exports.BLOCK_SIZE;
            this._bufferLength = 0;
        }
        // Copy leftovers to buffer.
        for(var i = 0; i < dataLength; i++)this._buffer[this._bufferLength + i] = data[dataPos + i];
        this._bufferLength += dataLength;
        return this;
    };
    BLAKE2b.prototype.finish = function(out) {
        if (!this._finished) {
            for(var i = this._bufferLength; i < $1fbb9568f45194cc$exports.BLOCK_SIZE; i++)this._buffer[i] = 0;
            // Set last block flag.
            this._flag[0] = 0xffffffff;
            this._flag[1] = 0xffffffff;
            // Set last node flag if last node in tree.
            if (this._lastNode) {
                this._flag[2] = 0xffffffff;
                this._flag[3] = 0xffffffff;
            }
            this._processBlock(this._bufferLength);
            this._finished = true;
        }
        // Reuse buffer as temporary space for digest.
        var tmp = this._buffer.subarray(0, 64);
        for(var i = 0; i < 16; i++)$f0b308eb62313e88$exports.writeUint32LE(this._state[i], tmp, i * 4);
        out.set(tmp.subarray(0, out.length));
        return this;
    };
    BLAKE2b.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    BLAKE2b.prototype.clean = function() {
        $53559a41a7596ea9$exports.wipe(this._vtmp);
        $53559a41a7596ea9$exports.wipe(this._mtmp);
        $53559a41a7596ea9$exports.wipe(this._state);
        $53559a41a7596ea9$exports.wipe(this._buffer);
        $53559a41a7596ea9$exports.wipe(this._initialState);
        if (this._paddedKey) $53559a41a7596ea9$exports.wipe(this._paddedKey);
        this._bufferLength = 0;
        $53559a41a7596ea9$exports.wipe(this._ctr);
        $53559a41a7596ea9$exports.wipe(this._flag);
        this._lastNode = false;
        this._finished = false;
    };
    BLAKE2b.prototype.saveState = function() {
        if (this._finished) throw new Error("blake2b: cannot save finished state");
        return {
            state: new Uint32Array(this._state),
            buffer: new Uint8Array(this._buffer),
            bufferLength: this._bufferLength,
            ctr: new Uint32Array(this._ctr),
            flag: new Uint32Array(this._flag),
            lastNode: this._lastNode,
            paddedKey: this._paddedKey ? new Uint8Array(this._paddedKey) : undefined,
            initialState: new Uint32Array(this._initialState)
        };
    };
    BLAKE2b.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._buffer.set(savedState.buffer);
        this._bufferLength = savedState.bufferLength;
        this._ctr.set(savedState.ctr);
        this._flag.set(savedState.flag);
        this._lastNode = savedState.lastNode;
        if (this._paddedKey) $53559a41a7596ea9$exports.wipe(this._paddedKey);
        this._paddedKey = savedState.paddedKey ? new Uint8Array(savedState.paddedKey) : undefined;
        this._initialState.set(savedState.initialState);
        return this;
    };
    BLAKE2b.prototype.cleanSavedState = function(savedState) {
        $53559a41a7596ea9$exports.wipe(savedState.state);
        $53559a41a7596ea9$exports.wipe(savedState.buffer);
        $53559a41a7596ea9$exports.wipe(savedState.initialState);
        if (savedState.paddedKey) $53559a41a7596ea9$exports.wipe(savedState.paddedKey);
        savedState.bufferLength = 0;
        $53559a41a7596ea9$exports.wipe(savedState.ctr);
        $53559a41a7596ea9$exports.wipe(savedState.flag);
        savedState.lastNode = false;
    };
    BLAKE2b.prototype._G = function(v, al, bl, cl, dl, ah, bh, ch, dh, ml0, mh0, ml1, mh1) {
        var vla = v[al], vha = v[ah], vlb = v[bl], vhb = v[bh], vlc = v[cl], vhc = v[ch], vld = v[dl], vhd = v[dh];
        // 64-bit: va += vb
        var w = vla & 0xffff, x = vla >>> 16, y = vha & 0xffff, z = vha >>> 16;
        w += vlb & 0xffff;
        x += vlb >>> 16;
        y += vhb & 0xffff;
        z += vhb >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: va += m[sigma[r][2 * i + 0]]
        w = vla & 0xffff;
        x = vla >>> 16;
        y = vha & 0xffff;
        z = vha >>> 16;
        w += ml0 & 0xffff;
        x += ml0 >>> 16;
        y += mh0 & 0xffff;
        z += mh0 >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: vd ^= va
        vld ^= vla;
        vhd ^= vha;
        // 64-bit: rot(vd, 32)
        w = vhd;
        vhd = vld;
        vld = w;
        // 64-bit: vc += vd
        w = vlc & 0xffff;
        x = vlc >>> 16;
        y = vhc & 0xffff;
        z = vhc >>> 16;
        w += vld & 0xffff;
        x += vld >>> 16;
        y += vhd & 0xffff;
        z += vhd >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vhc = y & 0xffff | z << 16;
        vlc = w & 0xffff | x << 16;
        // 64-bit: vb ^= vc
        vlb ^= vlc;
        vhb ^= vhc;
        // 64-bit: rot(vb, 24)
        w = vlb << 8 | vhb >>> 24;
        vlb = vhb << 8 | vlb >>> 24;
        vhb = w;
        // 64-bit: va += vb
        w = vla & 0xffff;
        x = vla >>> 16;
        y = vha & 0xffff;
        z = vha >>> 16;
        w += vlb & 0xffff;
        x += vlb >>> 16;
        y += vhb & 0xffff;
        z += vhb >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: va += m[sigma[r][2 * i + 1]
        w = vla & 0xffff;
        x = vla >>> 16;
        y = vha & 0xffff;
        z = vha >>> 16;
        w += ml1 & 0xffff;
        x += ml1 >>> 16;
        y += mh1 & 0xffff;
        z += mh1 >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: vd ^= va
        vld ^= vla;
        vhd ^= vha;
        // 64-bit: rot(vd, 16)
        w = vld << 16 | vhd >>> 16;
        vld = vhd << 16 | vld >>> 16;
        vhd = w;
        // 64-bit: vc += vd
        w = vlc & 0xffff;
        x = vlc >>> 16;
        y = vhc & 0xffff;
        z = vhc >>> 16;
        w += vld & 0xffff;
        x += vld >>> 16;
        y += vhd & 0xffff;
        z += vhd >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vhc = y & 0xffff | z << 16;
        vlc = w & 0xffff | x << 16;
        // 64-bit: vb ^= vc
        vlb ^= vlc;
        vhb ^= vhc;
        // 64-bit: rot(vb, 63)
        w = vhb << 1 | vlb >>> 31;
        vlb = vlb << 1 | vhb >>> 31;
        vhb = w;
        v[al] = vla;
        v[ah] = vha;
        v[bl] = vlb;
        v[bh] = vhb;
        v[cl] = vlc;
        v[ch] = vhc;
        v[dl] = vld;
        v[dh] = vhd;
    };
    BLAKE2b.prototype._incrementCounter = function(n) {
        for(var i = 0; i < 3; i++){
            var a = this._ctr[i] + n;
            this._ctr[i] = a >>> 0;
            if (this._ctr[i] === a) return;
            n = 1;
        }
    };
    BLAKE2b.prototype._processBlock = function(length) {
        this._incrementCounter(length);
        var v = this._vtmp;
        v.set(this._state);
        v.set($1fbb9568f45194cc$var$IV, 16);
        v[24] ^= this._ctr[0];
        v[25] ^= this._ctr[1];
        v[26] ^= this._ctr[2];
        v[27] ^= this._ctr[3];
        v[28] ^= this._flag[0];
        v[29] ^= this._flag[1];
        v[30] ^= this._flag[2];
        v[31] ^= this._flag[3];
        var m = this._mtmp;
        for(var i = 0; i < 32; i++)m[i] = $f0b308eb62313e88$exports.readUint32LE(this._buffer, i * 4);
        for(var r = 0; r < 12; r++){
            this._G(v, 0, 8, 16, 24, 1, 9, 17, 25, m[$1fbb9568f45194cc$var$SIGMA[r][0]], m[$1fbb9568f45194cc$var$SIGMA[r][0] + 1], m[$1fbb9568f45194cc$var$SIGMA[r][1]], m[$1fbb9568f45194cc$var$SIGMA[r][1] + 1]);
            this._G(v, 2, 10, 18, 26, 3, 11, 19, 27, m[$1fbb9568f45194cc$var$SIGMA[r][2]], m[$1fbb9568f45194cc$var$SIGMA[r][2] + 1], m[$1fbb9568f45194cc$var$SIGMA[r][3]], m[$1fbb9568f45194cc$var$SIGMA[r][3] + 1]);
            this._G(v, 4, 12, 20, 28, 5, 13, 21, 29, m[$1fbb9568f45194cc$var$SIGMA[r][4]], m[$1fbb9568f45194cc$var$SIGMA[r][4] + 1], m[$1fbb9568f45194cc$var$SIGMA[r][5]], m[$1fbb9568f45194cc$var$SIGMA[r][5] + 1]);
            this._G(v, 6, 14, 22, 30, 7, 15, 23, 31, m[$1fbb9568f45194cc$var$SIGMA[r][6]], m[$1fbb9568f45194cc$var$SIGMA[r][6] + 1], m[$1fbb9568f45194cc$var$SIGMA[r][7]], m[$1fbb9568f45194cc$var$SIGMA[r][7] + 1]);
            this._G(v, 0, 10, 20, 30, 1, 11, 21, 31, m[$1fbb9568f45194cc$var$SIGMA[r][8]], m[$1fbb9568f45194cc$var$SIGMA[r][8] + 1], m[$1fbb9568f45194cc$var$SIGMA[r][9]], m[$1fbb9568f45194cc$var$SIGMA[r][9] + 1]);
            this._G(v, 2, 12, 22, 24, 3, 13, 23, 25, m[$1fbb9568f45194cc$var$SIGMA[r][10]], m[$1fbb9568f45194cc$var$SIGMA[r][10] + 1], m[$1fbb9568f45194cc$var$SIGMA[r][11]], m[$1fbb9568f45194cc$var$SIGMA[r][11] + 1]);
            this._G(v, 4, 14, 16, 26, 5, 15, 17, 27, m[$1fbb9568f45194cc$var$SIGMA[r][12]], m[$1fbb9568f45194cc$var$SIGMA[r][12] + 1], m[$1fbb9568f45194cc$var$SIGMA[r][13]], m[$1fbb9568f45194cc$var$SIGMA[r][13] + 1]);
            this._G(v, 6, 8, 18, 28, 7, 9, 19, 29, m[$1fbb9568f45194cc$var$SIGMA[r][14]], m[$1fbb9568f45194cc$var$SIGMA[r][14] + 1], m[$1fbb9568f45194cc$var$SIGMA[r][15]], m[$1fbb9568f45194cc$var$SIGMA[r][15] + 1]);
        }
        for(var i = 0; i < 16; i++)this._state[i] ^= v[i] ^ v[i + 16];
    };
    return BLAKE2b;
}();
$1fbb9568f45194cc$exports.BLAKE2b = $1fbb9568f45194cc$var$BLAKE2b;
function $1fbb9568f45194cc$var$hash(data, digestLength, config) {
    if (digestLength === void 0) digestLength = $1fbb9568f45194cc$exports.DIGEST_LENGTH;
    var h = new $1fbb9568f45194cc$var$BLAKE2b(digestLength, config);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$1fbb9568f45194cc$exports.hash = $1fbb9568f45194cc$var$hash;


var $c8d6b1f140f0b27a$exports = {};
var $f2fc3dd0f2723bed$exports = {};
// Blake2B in pure Javascript
// Adapted from the reference implementation in RFC7693
// Ported to Javascript by DC - https://github.com/dcposch
var $c7a0d2b49b511ad5$exports = {};
const $c7a0d2b49b511ad5$var$ERROR_MSG_INPUT = 'Input must be an string, Buffer or Uint8Array';
// For convenience, let people hash a string, not just a Uint8Array
function $c7a0d2b49b511ad5$var$normalizeInput(input) {
    let ret;
    if (input instanceof Uint8Array) ret = input;
    else if (typeof input === 'string') {
        const encoder = new TextEncoder();
        ret = encoder.encode(input);
    } else throw new Error($c7a0d2b49b511ad5$var$ERROR_MSG_INPUT);
    return ret;
}
// Converts a Uint8Array to a hexadecimal string
// For example, toHex([255, 0, 255]) returns "ff00ff"
function $c7a0d2b49b511ad5$var$toHex(bytes) {
    return Array.prototype.map.call(bytes, function(n) {
        return (n < 16 ? '0' : '') + n.toString(16);
    }).join('');
}
// Converts any value in [0...2^32-1] to an 8-character hex string
function $c7a0d2b49b511ad5$var$uint32ToHex(val) {
    return (0x100000000 + val).toString(16).substring(1);
}
// For debugging: prints out hash state in the same format as the RFC
// sample computation exactly, so that you can diff
function $c7a0d2b49b511ad5$var$debugPrint(label, arr, size) {
    let msg = '\n' + label + ' = ';
    for(let i = 0; i < arr.length; i += 2){
        if (size === 32) {
            msg += $c7a0d2b49b511ad5$var$uint32ToHex(arr[i]).toUpperCase();
            msg += ' ';
            msg += $c7a0d2b49b511ad5$var$uint32ToHex(arr[i + 1]).toUpperCase();
        } else if (size === 64) {
            msg += $c7a0d2b49b511ad5$var$uint32ToHex(arr[i + 1]).toUpperCase();
            msg += $c7a0d2b49b511ad5$var$uint32ToHex(arr[i]).toUpperCase();
        } else throw new Error('Invalid size ' + size);
        if (i % 6 === 4) msg += '\n' + new Array(label.length + 4).join(' ');
        else if (i < arr.length - 2) msg += ' ';
    }
    console.log(msg);
}
// For performance testing: generates N bytes of input, hashes M times
// Measures and prints MB/second hash performance each time
function $c7a0d2b49b511ad5$var$testSpeed(hashFn, N, M) {
    let startMs = new Date().getTime();
    const input = new Uint8Array(N);
    for(let i = 0; i < N; i++)input[i] = i % 256;
    const genMs = new Date().getTime();
    console.log('Generated random input in ' + (genMs - startMs) + 'ms');
    startMs = genMs;
    for(let i = 0; i < M; i++){
        const hashHex = hashFn(input);
        const hashMs = new Date().getTime();
        const ms = hashMs - startMs;
        startMs = hashMs;
        console.log('Hashed in ' + ms + 'ms: ' + hashHex.substring(0, 20) + '...');
        console.log(Math.round(N / 1048576 / (ms / 1000) * 100) / 100 + ' MB PER SECOND');
    }
}
$c7a0d2b49b511ad5$exports = {
    normalizeInput: $c7a0d2b49b511ad5$var$normalizeInput,
    toHex: $c7a0d2b49b511ad5$var$toHex,
    debugPrint: $c7a0d2b49b511ad5$var$debugPrint,
    testSpeed: $c7a0d2b49b511ad5$var$testSpeed
};


// 64-bit unsigned addition
// Sets v[a,a+1] += v[b,b+1]
// v should be a Uint32Array
function $f2fc3dd0f2723bed$var$ADD64AA(v, a, b) {
    const o0 = v[a] + v[b];
    let o1 = v[a + 1] + v[b + 1];
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// 64-bit unsigned addition
// Sets v[a,a+1] += b
// b0 is the low 32 bits of b, b1 represents the high 32 bits
function $f2fc3dd0f2723bed$var$ADD64AC(v, a, b0, b1) {
    let o0 = v[a] + b0;
    if (b0 < 0) o0 += 0x100000000;
    let o1 = v[a + 1] + b1;
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// Little-endian byte access
function $f2fc3dd0f2723bed$var$B2B_GET32(arr, i) {
    return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
}
// G Mixing function
// The ROTRs are inlined for speed
function $f2fc3dd0f2723bed$var$B2B_G(a, b, c, d, ix, iy) {
    const x0 = $f2fc3dd0f2723bed$var$m[ix];
    const x1 = $f2fc3dd0f2723bed$var$m[ix + 1];
    const y0 = $f2fc3dd0f2723bed$var$m[iy];
    const y1 = $f2fc3dd0f2723bed$var$m[iy + 1];
    $f2fc3dd0f2723bed$var$ADD64AA($f2fc3dd0f2723bed$var$v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
    ;
    $f2fc3dd0f2723bed$var$ADD64AC($f2fc3dd0f2723bed$var$v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
    ;
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
    let xor0 = $f2fc3dd0f2723bed$var$v[d] ^ $f2fc3dd0f2723bed$var$v[a];
    let xor1 = $f2fc3dd0f2723bed$var$v[d + 1] ^ $f2fc3dd0f2723bed$var$v[a + 1];
    $f2fc3dd0f2723bed$var$v[d] = xor1;
    $f2fc3dd0f2723bed$var$v[d + 1] = xor0;
    $f2fc3dd0f2723bed$var$ADD64AA($f2fc3dd0f2723bed$var$v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
    xor0 = $f2fc3dd0f2723bed$var$v[b] ^ $f2fc3dd0f2723bed$var$v[c];
    xor1 = $f2fc3dd0f2723bed$var$v[b + 1] ^ $f2fc3dd0f2723bed$var$v[c + 1];
    $f2fc3dd0f2723bed$var$v[b] = xor0 >>> 24 ^ xor1 << 8;
    $f2fc3dd0f2723bed$var$v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
    $f2fc3dd0f2723bed$var$ADD64AA($f2fc3dd0f2723bed$var$v, a, b);
    $f2fc3dd0f2723bed$var$ADD64AC($f2fc3dd0f2723bed$var$v, a, y0, y1);
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
    xor0 = $f2fc3dd0f2723bed$var$v[d] ^ $f2fc3dd0f2723bed$var$v[a];
    xor1 = $f2fc3dd0f2723bed$var$v[d + 1] ^ $f2fc3dd0f2723bed$var$v[a + 1];
    $f2fc3dd0f2723bed$var$v[d] = xor0 >>> 16 ^ xor1 << 16;
    $f2fc3dd0f2723bed$var$v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
    $f2fc3dd0f2723bed$var$ADD64AA($f2fc3dd0f2723bed$var$v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
    xor0 = $f2fc3dd0f2723bed$var$v[b] ^ $f2fc3dd0f2723bed$var$v[c];
    xor1 = $f2fc3dd0f2723bed$var$v[b + 1] ^ $f2fc3dd0f2723bed$var$v[c + 1];
    $f2fc3dd0f2723bed$var$v[b] = xor1 >>> 31 ^ xor0 << 1;
    $f2fc3dd0f2723bed$var$v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
}
// Initialization Vector
const $f2fc3dd0f2723bed$var$BLAKE2B_IV32 = new Uint32Array([
    0xf3bcc908,
    0x6a09e667,
    0x84caa73b,
    0xbb67ae85,
    0xfe94f82b,
    0x3c6ef372,
    0x5f1d36f1,
    0xa54ff53a,
    0xade682d1,
    0x510e527f,
    0x2b3e6c1f,
    0x9b05688c,
    0xfb41bd6b,
    0x1f83d9ab,
    0x137e2179,
    0x5be0cd19
]);
const $f2fc3dd0f2723bed$var$SIGMA8 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3
];
// These are offsets into a uint64 buffer.
// Multiply them all by 2 to make them offsets into a uint32 buffer,
// because this is Javascript and we don't have uint64s
const $f2fc3dd0f2723bed$var$SIGMA82 = new Uint8Array($f2fc3dd0f2723bed$var$SIGMA8.map(function(x) {
    return x * 2;
}));
// Compression function. 'last' flag indicates last block.
// Note we're representing 16 uint64s as 32 uint32s
const $f2fc3dd0f2723bed$var$v = new Uint32Array(32);
const $f2fc3dd0f2723bed$var$m = new Uint32Array(32);
function $f2fc3dd0f2723bed$var$blake2bCompress(ctx, last) {
    let i = 0;
    // init work variables
    for(i = 0; i < 16; i++){
        $f2fc3dd0f2723bed$var$v[i] = ctx.h[i];
        $f2fc3dd0f2723bed$var$v[i + 16] = $f2fc3dd0f2723bed$var$BLAKE2B_IV32[i];
    }
    // low 64 bits of offset
    $f2fc3dd0f2723bed$var$v[24] = $f2fc3dd0f2723bed$var$v[24] ^ ctx.t;
    $f2fc3dd0f2723bed$var$v[25] = $f2fc3dd0f2723bed$var$v[25] ^ ctx.t / 0x100000000;
    // high 64 bits not supported, offset may not be higher than 2**53-1
    // last block flag set ?
    if (last) {
        $f2fc3dd0f2723bed$var$v[28] = ~$f2fc3dd0f2723bed$var$v[28];
        $f2fc3dd0f2723bed$var$v[29] = ~$f2fc3dd0f2723bed$var$v[29];
    }
    // get little-endian words
    for(i = 0; i < 32; i++)$f2fc3dd0f2723bed$var$m[i] = $f2fc3dd0f2723bed$var$B2B_GET32(ctx.b, 4 * i);
    // twelve rounds of mixing
    // uncomment the DebugPrint calls to log the computation
    // and match the RFC sample documentation
    // util.debugPrint('          m[16]', m, 64)
    for(i = 0; i < 12; i++){
        // util.debugPrint('   (i=' + (i < 10 ? ' ' : '') + i + ') v[16]', v, 64)
        $f2fc3dd0f2723bed$var$B2B_G(0, 8, 16, 24, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 0], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 1]);
        $f2fc3dd0f2723bed$var$B2B_G(2, 10, 18, 26, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 2], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 3]);
        $f2fc3dd0f2723bed$var$B2B_G(4, 12, 20, 28, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 4], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 5]);
        $f2fc3dd0f2723bed$var$B2B_G(6, 14, 22, 30, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 6], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 7]);
        $f2fc3dd0f2723bed$var$B2B_G(0, 10, 20, 30, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 8], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 9]);
        $f2fc3dd0f2723bed$var$B2B_G(2, 12, 22, 24, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 10], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 11]);
        $f2fc3dd0f2723bed$var$B2B_G(4, 14, 16, 26, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 12], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 13]);
        $f2fc3dd0f2723bed$var$B2B_G(6, 8, 18, 28, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 14], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 15]);
    }
    // util.debugPrint('   (i=12) v[16]', v, 64)
    for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ $f2fc3dd0f2723bed$var$v[i] ^ $f2fc3dd0f2723bed$var$v[i + 16];
// util.debugPrint('h[8]', ctx.h, 64)
}
// reusable parameterBlock
const $f2fc3dd0f2723bed$var$parameterBlock = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0 // 60: personal
]);
// Creates a BLAKE2b hashing context
// Requires an output length between 1 and 64 bytes
// Takes an optional Uint8Array key
// Takes an optinal Uint8Array salt
// Takes an optinal Uint8Array personal
function $f2fc3dd0f2723bed$var$blake2bInit(outlen, key, salt, personal) {
    if (outlen === 0 || outlen > 64) throw new Error('Illegal output length, expected 0 < length <= 64');
    if (key && key.length > 64) throw new Error('Illegal key, expected Uint8Array with 0 < length <= 64');
    if (salt && salt.length !== 16) throw new Error('Illegal salt, expected Uint8Array with length is 16');
    if (personal && personal.length !== 16) throw new Error('Illegal personal, expected Uint8Array with length is 16');
    // state, 'param block'
    const ctx = {
        b: new Uint8Array(128),
        h: new Uint32Array(16),
        t: 0,
        c: 0,
        outlen: outlen // output length in bytes
    };
    // initialize parameterBlock before usage
    $f2fc3dd0f2723bed$var$parameterBlock.fill(0);
    $f2fc3dd0f2723bed$var$parameterBlock[0] = outlen;
    if (key) $f2fc3dd0f2723bed$var$parameterBlock[1] = key.length;
    $f2fc3dd0f2723bed$var$parameterBlock[2] = 1 // fanout
    ;
    $f2fc3dd0f2723bed$var$parameterBlock[3] = 1 // depth
    ;
    if (salt) $f2fc3dd0f2723bed$var$parameterBlock.set(salt, 32);
    if (personal) $f2fc3dd0f2723bed$var$parameterBlock.set(personal, 48);
    // initialize hash state
    for(let i = 0; i < 16; i++)ctx.h[i] = $f2fc3dd0f2723bed$var$BLAKE2B_IV32[i] ^ $f2fc3dd0f2723bed$var$B2B_GET32($f2fc3dd0f2723bed$var$parameterBlock, i * 4);
    // key the hash, if applicable
    if (key) {
        $f2fc3dd0f2723bed$var$blake2bUpdate(ctx, key);
        // at the end
        ctx.c = 128;
    }
    return ctx;
}
// Updates a BLAKE2b streaming hash
// Requires hash context and Uint8Array (byte array)
function $f2fc3dd0f2723bed$var$blake2bUpdate(ctx, input) {
    for(let i = 0; i < input.length; i++){
        if (ctx.c === 128) {
            // buffer full ?
            ctx.t += ctx.c // add counters
            ;
            $f2fc3dd0f2723bed$var$blake2bCompress(ctx, false) // compress (not last)
            ;
            ctx.c = 0 // counter to zero
            ;
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2b streaming hash
// Returns a Uint8Array containing the message digest
function $f2fc3dd0f2723bed$var$blake2bFinal(ctx) {
    ctx.t += ctx.c // mark last block offset
    ;
    while(ctx.c < 128)// fill up with zeros
    ctx.b[ctx.c++] = 0;
    $f2fc3dd0f2723bed$var$blake2bCompress(ctx, true) // final block flag = 1
    ;
    // little endian convert and store
    const out = new Uint8Array(ctx.outlen);
    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
    return out;
}
// Computes the BLAKE2B hash of a string or byte array, and returns a Uint8Array
//
// Returns a n-byte Uint8Array
//
// Parameters:
// - input - the input bytes, as a string, Buffer or Uint8Array
// - key - optional key Uint8Array, up to 64 bytes
// - outlen - optional output length in bytes, default 64
// - salt - optional salt bytes, string, Buffer or Uint8Array
// - personal - optional personal bytes, string, Buffer or Uint8Array
function $f2fc3dd0f2723bed$var$blake2b(input, key, outlen, salt, personal) {
    // preprocess inputs
    outlen = outlen || 64;
    input = $c7a0d2b49b511ad5$exports.normalizeInput(input);
    if (salt) salt = $c7a0d2b49b511ad5$exports.normalizeInput(salt);
    if (personal) personal = $c7a0d2b49b511ad5$exports.normalizeInput(personal);
    // do the math
    const ctx = $f2fc3dd0f2723bed$var$blake2bInit(outlen, key, salt, personal);
    $f2fc3dd0f2723bed$var$blake2bUpdate(ctx, input);
    return $f2fc3dd0f2723bed$var$blake2bFinal(ctx);
}
// Computes the BLAKE2B hash of a string or byte array
//
// Returns an n-byte hash in hex, all lowercase
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 64 bytes
// - outlen - optional output length in bytes, default 64
// - salt - optional salt bytes, string, Buffer or Uint8Array
// - personal - optional personal bytes, string, Buffer or Uint8Array
function $f2fc3dd0f2723bed$var$blake2bHex(input, key, outlen, salt, personal) {
    const output = $f2fc3dd0f2723bed$var$blake2b(input, key, outlen, salt, personal);
    return $c7a0d2b49b511ad5$exports.toHex(output);
}
$f2fc3dd0f2723bed$exports = {
    blake2b: $f2fc3dd0f2723bed$var$blake2b,
    blake2bHex: $f2fc3dd0f2723bed$var$blake2bHex,
    blake2bInit: $f2fc3dd0f2723bed$var$blake2bInit,
    blake2bUpdate: $f2fc3dd0f2723bed$var$blake2bUpdate,
    blake2bFinal: $f2fc3dd0f2723bed$var$blake2bFinal
};


var $d2c89e155cff8bdb$exports = {};
// BLAKE2s hash function in pure Javascript
// Adapted from the reference implementation in RFC7693
// Ported to Javascript by DC - https://github.com/dcposch

// Little-endian byte access.
// Expects a Uint8Array and an index
// Returns the little-endian uint32 at v[i..i+3]
function $d2c89e155cff8bdb$var$B2S_GET32(v, i) {
    return v[i] ^ v[i + 1] << 8 ^ v[i + 2] << 16 ^ v[i + 3] << 24;
}
// Mixing function G.
function $d2c89e155cff8bdb$var$B2S_G(a, b, c, d, x, y) {
    $d2c89e155cff8bdb$var$v[a] = $d2c89e155cff8bdb$var$v[a] + $d2c89e155cff8bdb$var$v[b] + x;
    $d2c89e155cff8bdb$var$v[d] = $d2c89e155cff8bdb$var$ROTR32($d2c89e155cff8bdb$var$v[d] ^ $d2c89e155cff8bdb$var$v[a], 16);
    $d2c89e155cff8bdb$var$v[c] = $d2c89e155cff8bdb$var$v[c] + $d2c89e155cff8bdb$var$v[d];
    $d2c89e155cff8bdb$var$v[b] = $d2c89e155cff8bdb$var$ROTR32($d2c89e155cff8bdb$var$v[b] ^ $d2c89e155cff8bdb$var$v[c], 12);
    $d2c89e155cff8bdb$var$v[a] = $d2c89e155cff8bdb$var$v[a] + $d2c89e155cff8bdb$var$v[b] + y;
    $d2c89e155cff8bdb$var$v[d] = $d2c89e155cff8bdb$var$ROTR32($d2c89e155cff8bdb$var$v[d] ^ $d2c89e155cff8bdb$var$v[a], 8);
    $d2c89e155cff8bdb$var$v[c] = $d2c89e155cff8bdb$var$v[c] + $d2c89e155cff8bdb$var$v[d];
    $d2c89e155cff8bdb$var$v[b] = $d2c89e155cff8bdb$var$ROTR32($d2c89e155cff8bdb$var$v[b] ^ $d2c89e155cff8bdb$var$v[c], 7);
}
// 32-bit right rotation
// x should be a uint32
// y must be between 1 and 31, inclusive
function $d2c89e155cff8bdb$var$ROTR32(x, y) {
    return x >>> y ^ x << 32 - y;
}
// Initialization Vector.
const $d2c89e155cff8bdb$var$BLAKE2S_IV = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
const $d2c89e155cff8bdb$var$SIGMA = new Uint8Array([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0
]);
// Compression function. "last" flag indicates last block
const $d2c89e155cff8bdb$var$v = new Uint32Array(16);
const $d2c89e155cff8bdb$var$m = new Uint32Array(16);
function $d2c89e155cff8bdb$var$blake2sCompress(ctx, last) {
    let i = 0;
    for(i = 0; i < 8; i++){
        // init work variables
        $d2c89e155cff8bdb$var$v[i] = ctx.h[i];
        $d2c89e155cff8bdb$var$v[i + 8] = $d2c89e155cff8bdb$var$BLAKE2S_IV[i];
    }
    $d2c89e155cff8bdb$var$v[12] ^= ctx.t // low 32 bits of offset
    ;
    $d2c89e155cff8bdb$var$v[13] ^= ctx.t / 0x100000000 // high 32 bits
    ;
    if (last) // last block flag set ?
    $d2c89e155cff8bdb$var$v[14] = ~$d2c89e155cff8bdb$var$v[14];
    for(i = 0; i < 16; i++)// get little-endian words
    $d2c89e155cff8bdb$var$m[i] = $d2c89e155cff8bdb$var$B2S_GET32(ctx.b, 4 * i);
    // ten rounds of mixing
    // uncomment the DebugPrint calls to log the computation
    // and match the RFC sample documentation
    // util.debugPrint('          m[16]', m, 32)
    for(i = 0; i < 10; i++){
        // util.debugPrint('   (i=' + i + ')  v[16]', v, 32)
        $d2c89e155cff8bdb$var$B2S_G(0, 4, 8, 12, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 0]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 1]]);
        $d2c89e155cff8bdb$var$B2S_G(1, 5, 9, 13, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 2]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 3]]);
        $d2c89e155cff8bdb$var$B2S_G(2, 6, 10, 14, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 4]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 5]]);
        $d2c89e155cff8bdb$var$B2S_G(3, 7, 11, 15, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 6]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 7]]);
        $d2c89e155cff8bdb$var$B2S_G(0, 5, 10, 15, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 8]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 9]]);
        $d2c89e155cff8bdb$var$B2S_G(1, 6, 11, 12, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 10]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 11]]);
        $d2c89e155cff8bdb$var$B2S_G(2, 7, 8, 13, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 12]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 13]]);
        $d2c89e155cff8bdb$var$B2S_G(3, 4, 9, 14, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 14]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 15]]);
    }
    // util.debugPrint('   (i=10) v[16]', v, 32)
    for(i = 0; i < 8; i++)ctx.h[i] ^= $d2c89e155cff8bdb$var$v[i] ^ $d2c89e155cff8bdb$var$v[i + 8];
// util.debugPrint('h[8]', ctx.h, 32)
}
// Creates a BLAKE2s hashing context
// Requires an output length between 1 and 32 bytes
// Takes an optional Uint8Array key
function $d2c89e155cff8bdb$var$blake2sInit(outlen, key) {
    if (!(outlen > 0 && outlen <= 32)) throw new Error('Incorrect output length, should be in [1, 32]');
    const keylen = key ? key.length : 0;
    if (key && !(keylen > 0 && keylen <= 32)) throw new Error('Incorrect key length, should be in [1, 32]');
    const ctx = {
        h: new Uint32Array($d2c89e155cff8bdb$var$BLAKE2S_IV),
        b: new Uint8Array(64),
        c: 0,
        t: 0,
        outlen: outlen // output length in bytes
    };
    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
    if (keylen > 0) {
        $d2c89e155cff8bdb$var$blake2sUpdate(ctx, key);
        ctx.c = 64 // at the end
        ;
    }
    return ctx;
}
// Updates a BLAKE2s streaming hash
// Requires hash context and Uint8Array (byte array)
function $d2c89e155cff8bdb$var$blake2sUpdate(ctx, input) {
    for(let i = 0; i < input.length; i++){
        if (ctx.c === 64) {
            // buffer full ?
            ctx.t += ctx.c // add counters
            ;
            $d2c89e155cff8bdb$var$blake2sCompress(ctx, false) // compress (not last)
            ;
            ctx.c = 0 // counter to zero
            ;
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2s streaming hash
// Returns a Uint8Array containing the message digest
function $d2c89e155cff8bdb$var$blake2sFinal(ctx) {
    ctx.t += ctx.c // mark last block offset
    ;
    while(ctx.c < 64)// fill up with zeros
    ctx.b[ctx.c++] = 0;
    $d2c89e155cff8bdb$var$blake2sCompress(ctx, true) // final block flag = 1
    ;
    // little endian convert and store
    const out = new Uint8Array(ctx.outlen);
    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3) & 0xff;
    return out;
}
// Computes the BLAKE2S hash of a string or byte array, and returns a Uint8Array
//
// Returns a n-byte Uint8Array
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 32 bytes
// - outlen - optional output length in bytes, default 64
function $d2c89e155cff8bdb$var$blake2s(input, key, outlen) {
    // preprocess inputs
    outlen = outlen || 32;
    input = $c7a0d2b49b511ad5$exports.normalizeInput(input);
    // do the math
    const ctx = $d2c89e155cff8bdb$var$blake2sInit(outlen, key);
    $d2c89e155cff8bdb$var$blake2sUpdate(ctx, input);
    return $d2c89e155cff8bdb$var$blake2sFinal(ctx);
}
// Computes the BLAKE2S hash of a string or byte array
//
// Returns an n-byte hash in hex, all lowercase
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 32 bytes
// - outlen - optional output length in bytes, default 64
function $d2c89e155cff8bdb$var$blake2sHex(input, key, outlen) {
    const output = $d2c89e155cff8bdb$var$blake2s(input, key, outlen);
    return $c7a0d2b49b511ad5$exports.toHex(output);
}
$d2c89e155cff8bdb$exports = {
    blake2s: $d2c89e155cff8bdb$var$blake2s,
    blake2sHex: $d2c89e155cff8bdb$var$blake2sHex,
    blake2sInit: $d2c89e155cff8bdb$var$blake2sInit,
    blake2sUpdate: $d2c89e155cff8bdb$var$blake2sUpdate,
    blake2sFinal: $d2c89e155cff8bdb$var$blake2sFinal
};


$c8d6b1f140f0b27a$exports = {
    blake2b: $f2fc3dd0f2723bed$exports.blake2b,
    blake2bHex: $f2fc3dd0f2723bed$exports.blake2bHex,
    blake2bInit: $f2fc3dd0f2723bed$exports.blake2bInit,
    blake2bUpdate: $f2fc3dd0f2723bed$exports.blake2bUpdate,
    blake2bFinal: $f2fc3dd0f2723bed$exports.blake2bFinal,
    blake2s: $d2c89e155cff8bdb$exports.blake2s,
    blake2sHex: $d2c89e155cff8bdb$exports.blake2sHex,
    blake2sInit: $d2c89e155cff8bdb$exports.blake2sInit,
    blake2sUpdate: $d2c89e155cff8bdb$exports.blake2sUpdate,
    blake2sFinal: $d2c89e155cff8bdb$exports.blake2sFinal
};


var $47f81b414571e8df$exports = {};
'use strict';

var $47f81b414571e8df$require$sha256 = $510ad3657d73a9d2$exports.sha256;
var $43cbd7d7c6308c33$exports = {};
'use strict';
var $b72d51f7de447f14$exports = {};
var $ffe97ee45317695e$exports = {};
'use strict';
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $ffe97ee45317695e$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Find code of next character
            var charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            var carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$ffe97ee45317695e$exports = $ffe97ee45317695e$var$base;


const $b72d51f7de447f14$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
$b72d51f7de447f14$exports = $ffe97ee45317695e$exports($b72d51f7de447f14$var$ALPHABET);


$43cbd7d7c6308c33$exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var payloadU8 = Uint8Array.from(payload);
        var checksum = checksumFn(payloadU8);
        var length = payloadU8.length + 4;
        var both = new Uint8Array(length);
        both.set(payloadU8, 0);
        both.set(checksum.subarray(0, 4), payloadU8.length);
        return $b72d51f7de447f14$exports.encode(both, length);
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $b72d51f7de447f14$exports.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $b72d51f7de447f14$exports.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error('Invalid checksum');
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};


// SHA256(SHA256(buffer))
function $47f81b414571e8df$var$sha256x2(buffer) {
    return $47f81b414571e8df$require$sha256($47f81b414571e8df$require$sha256(buffer));
}
$47f81b414571e8df$exports = $43cbd7d7c6308c33$exports($47f81b414571e8df$var$sha256x2);





var $1zUcV = parcelRequire("1zUcV");

var $201657d342d01b1b$export$e77cfe0b08ec163;
(function(Prefix) {
    Prefix["TZ1"] = "tz1";
    Prefix["TZ2"] = "tz2";
    Prefix["TZ3"] = "tz3";
    Prefix["TZ4"] = "tz4";
    Prefix["KT"] = "KT";
    Prefix["KT1"] = "KT1";
    Prefix["EDSK2"] = "edsk2";
    Prefix["SPSK"] = "spsk";
    Prefix["P2SK"] = "p2sk";
    Prefix["EDPK"] = "edpk";
    Prefix["SPPK"] = "sppk";
    Prefix["P2PK"] = "p2pk";
    Prefix["BLPK"] = "BLpk";
    Prefix["EDESK"] = "edesk";
    Prefix["SPESK"] = "spesk";
    Prefix["P2ESK"] = "p2esk";
    Prefix["EDSK"] = "edsk";
    Prefix["EDSIG"] = "edsig";
    Prefix["SPSIG"] = "spsig";
    Prefix["P2SIG"] = "p2sig";
    Prefix["SIG"] = "sig";
    Prefix["NET"] = "Net";
    Prefix["NCE"] = "nce";
    Prefix["B"] = "B";
    Prefix["O"] = "o";
    Prefix["LO"] = "Lo";
    Prefix["LLO"] = "LLo";
    Prefix["P"] = "P";
    Prefix["CO"] = "Co";
    Prefix["ID"] = "id";
    Prefix["EXPR"] = "expr";
    Prefix["TZ"] = "TZ";
    Prefix["VH"] = "vh";
    Prefix["SASK"] = "sask";
    Prefix["ZET1"] = "zet1";
    Prefix["SR1"] = "sr1";
    Prefix["SRC1"] = "src1";
})($201657d342d01b1b$export$e77cfe0b08ec163 || ($201657d342d01b1b$export$e77cfe0b08ec163 = {}));
const $201657d342d01b1b$export$82e9f45cca5ba907 = {
    [$201657d342d01b1b$export$e77cfe0b08ec163.TZ1]: new Uint8Array([
        6,
        161,
        159
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.TZ2]: new Uint8Array([
        6,
        161,
        161
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.TZ3]: new Uint8Array([
        6,
        161,
        164
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.TZ4]: new Uint8Array([
        6,
        161,
        166
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.KT]: new Uint8Array([
        2,
        90,
        121
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.KT1]: new Uint8Array([
        2,
        90,
        121
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.EDSK]: new Uint8Array([
        43,
        246,
        78,
        7
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.EDSK2]: new Uint8Array([
        13,
        15,
        58,
        7
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.SPSK]: new Uint8Array([
        17,
        162,
        224,
        201
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.P2SK]: new Uint8Array([
        16,
        81,
        238,
        189
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.EDPK]: new Uint8Array([
        13,
        15,
        37,
        217
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.SPPK]: new Uint8Array([
        3,
        254,
        226,
        86
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.P2PK]: new Uint8Array([
        3,
        178,
        139,
        127
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.BLPK]: new Uint8Array([
        6,
        149,
        135,
        204
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.EDESK]: new Uint8Array([
        7,
        90,
        60,
        179,
        41
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.SPESK]: new Uint8Array([
        0x09,
        0xed,
        0xf1,
        0xae,
        0x96
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.P2ESK]: new Uint8Array([
        0x09,
        0x30,
        0x39,
        0x73,
        0xab
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.EDSIG]: new Uint8Array([
        9,
        245,
        205,
        134,
        18
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.SPSIG]: new Uint8Array([
        13,
        115,
        101,
        19,
        63
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.P2SIG]: new Uint8Array([
        54,
        240,
        44,
        52
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.SIG]: new Uint8Array([
        4,
        130,
        43
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.NET]: new Uint8Array([
        87,
        82,
        0
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.NCE]: new Uint8Array([
        69,
        220,
        169
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.B]: new Uint8Array([
        1,
        52
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.O]: new Uint8Array([
        5,
        116
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.LO]: new Uint8Array([
        133,
        233
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.LLO]: new Uint8Array([
        29,
        159,
        109
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.P]: new Uint8Array([
        2,
        170
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.CO]: new Uint8Array([
        79,
        179
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.ID]: new Uint8Array([
        153,
        103
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.EXPR]: new Uint8Array([
        13,
        44,
        64,
        27
    ]),
    // Legacy prefix
    [$201657d342d01b1b$export$e77cfe0b08ec163.TZ]: new Uint8Array([
        2,
        90,
        121
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.VH]: new Uint8Array([
        1,
        106,
        242
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.SASK]: new Uint8Array([
        11,
        237,
        20,
        92
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.ZET1]: new Uint8Array([
        18,
        71,
        40,
        223
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.SR1]: new Uint8Array([
        6,
        124,
        117
    ]),
    [$201657d342d01b1b$export$e77cfe0b08ec163.SRC1]: new Uint8Array([
        17,
        165,
        134,
        138
    ])
};
const $201657d342d01b1b$export$2a5ba4495636ee46 = {
    [$201657d342d01b1b$export$e77cfe0b08ec163.TZ1]: 20,
    [$201657d342d01b1b$export$e77cfe0b08ec163.TZ2]: 20,
    [$201657d342d01b1b$export$e77cfe0b08ec163.TZ3]: 20,
    [$201657d342d01b1b$export$e77cfe0b08ec163.TZ4]: 20,
    [$201657d342d01b1b$export$e77cfe0b08ec163.KT]: 20,
    [$201657d342d01b1b$export$e77cfe0b08ec163.KT1]: 20,
    [$201657d342d01b1b$export$e77cfe0b08ec163.EDPK]: 32,
    [$201657d342d01b1b$export$e77cfe0b08ec163.SPPK]: 33,
    [$201657d342d01b1b$export$e77cfe0b08ec163.P2PK]: 33,
    //working with value in comment for base58.ml line 445 but not consistent with the three above
    [$201657d342d01b1b$export$e77cfe0b08ec163.BLPK]: 48,
    [$201657d342d01b1b$export$e77cfe0b08ec163.EDSIG]: 64,
    [$201657d342d01b1b$export$e77cfe0b08ec163.SPSIG]: 64,
    [$201657d342d01b1b$export$e77cfe0b08ec163.P2SIG]: 64,
    [$201657d342d01b1b$export$e77cfe0b08ec163.SIG]: 64,
    [$201657d342d01b1b$export$e77cfe0b08ec163.NET]: 4,
    [$201657d342d01b1b$export$e77cfe0b08ec163.B]: 32,
    [$201657d342d01b1b$export$e77cfe0b08ec163.P]: 32,
    [$201657d342d01b1b$export$e77cfe0b08ec163.O]: 32,
    [$201657d342d01b1b$export$e77cfe0b08ec163.VH]: 32,
    [$201657d342d01b1b$export$e77cfe0b08ec163.SASK]: 169,
    [$201657d342d01b1b$export$e77cfe0b08ec163.ZET1]: 43,
    [$201657d342d01b1b$export$e77cfe0b08ec163.SR1]: 20,
    [$201657d342d01b1b$export$e77cfe0b08ec163.SRC1]: 32
};
/**
 * @description Verify signature of a payload
 *
 * @param messageBytes The forged message including the magic byte (11 for block,
 *        12 for preattestation/preendorsement, 13 for attestation/endorsement, 3 for generic, 5 for the PACK format of michelson)
 * @param publicKey The public key to verify the signature against
 * @param signature The signature to verify
 * @returns A boolean indicating if the signature matches
 * @throws {@link InvalidPublicKeyError} | {@link InvalidSignatureError} | {@link InvalidMessageError}
 * @example
 * ```
 * const message = '03d0c10e3ed11d7c6e3357f6ef335bab9e8f2bd54d0ce20c482e241191a6e4b8ce6c01be917311d9ac46959750e405d57e268e2ed9e174a80794fbd504e12a4a000141eb3781afed2f69679ff2bbe1c5375950b0e40d00ff000000005e05050505050507070100000024747a32526773486e74516b72794670707352466261313652546656503539684b72654a4d07070100000024747a315a6672455263414c42776d4171776f6e525859565142445439426a4e6a42484a750001';
 * const pk = 'sppk7c7hkPj47yjYFEHX85q46sFJGw6RBrqoVSHwAJAT4e14KJwzoey';
 * const sig = 'spsig1cdLkp1RLgUHAp13aRFkZ6MQDPp7xCnjAExGL3MBSdMDmT6JgQSX8cufyDgJRM3sinFtiCzLbsyP6d365EHoNevxhT47nx'
 *
 * const response = verifySignature(message, pk, sig);
 * ```
 *
 */ function $201657d342d01b1b$export$ab54e47fdf2903bb(messageBytes, publicKey, signature, watermark) {
    const pkPrefix = $201657d342d01b1b$export$2fc642945002cd1a(publicKey);
    const sigPrefix = $201657d342d01b1b$var$validateSigAndExtractPrefix(signature);
    const decodedPublicKey = $201657d342d01b1b$export$b9856b5e6fd1a05f(publicKey, $201657d342d01b1b$export$82e9f45cca5ba907[pkPrefix]);
    const decodedSig = $201657d342d01b1b$export$b9856b5e6fd1a05f(signature, $201657d342d01b1b$export$82e9f45cca5ba907[sigPrefix]);
    let messageBuf = $201657d342d01b1b$export$80feccbc0acd4657($201657d342d01b1b$var$validateMessageNotEmpty(messageBytes));
    if (typeof watermark !== 'undefined') messageBuf = $201657d342d01b1b$export$196099622a18a454(watermark, messageBuf);
    const bytesHash = (0, $1fbb9568f45194cc$exports.hash)(messageBuf, 32);
    if (pkPrefix === $201657d342d01b1b$export$e77cfe0b08ec163.EDPK) return $201657d342d01b1b$var$verifyEdSignature(decodedSig, bytesHash, decodedPublicKey);
    else if (pkPrefix === $201657d342d01b1b$export$e77cfe0b08ec163.SPPK) return $201657d342d01b1b$var$verifySpSignature(decodedSig, bytesHash, decodedPublicKey);
    else if (pkPrefix === $201657d342d01b1b$export$e77cfe0b08ec163.P2PK) return $201657d342d01b1b$var$verifyP2Signature(decodedSig, bytesHash, decodedPublicKey);
    else return false;
}
function $201657d342d01b1b$var$validateMessageNotEmpty(message) {
    if (message === '') throw new (0, $8b6476b09e20f53e$export$a5124d7665e9d8ad)(message, `can't be empty`);
    return message;
}
function $201657d342d01b1b$export$2fc642945002cd1a(publicKey) {
    if (publicKey === '') throw new (0, $8b6476b09e20f53e$export$f675822ed489f01f)(publicKey, `can't be empty`);
    const pkPrefix = publicKey.substring(0, 4);
    const publicKeyValidation = $201657d342d01b1b$export$7e268ff6bd252dc4(publicKey);
    if (publicKeyValidation !== $201657d342d01b1b$export$f9bf9a3c544b4010.VALID) throw new (0, $8b6476b09e20f53e$export$f675822ed489f01f)(publicKey, $201657d342d01b1b$export$a2057601792df650(publicKeyValidation));
    return pkPrefix;
}
function $201657d342d01b1b$var$validateSigAndExtractPrefix(signature) {
    const signaturePrefix = signature.startsWith('sig') ? signature.substring(0, 3) : signature.substring(0, 5);
    const validation = $201657d342d01b1b$export$f680e6c2b3919edb(signature);
    if (validation !== $201657d342d01b1b$export$f9bf9a3c544b4010.VALID) throw new (0, $8b6476b09e20f53e$export$ccc2f68ef106615a)(signature, $201657d342d01b1b$export$a2057601792df650(validation));
    return signaturePrefix;
}
function $201657d342d01b1b$var$verifyEdSignature(decodedSig, bytesHash, decodedPublicKey) {
    try {
        return (0, $6c853ef3ed869bb2$exports.verify)(decodedPublicKey, bytesHash, decodedSig);
    } catch (e) {
        return false;
    }
}
function $201657d342d01b1b$var$verifySpSignature(decodedSig, bytesHash, decodedPublicKey) {
    const key = new (0, (/*@__PURE__*/$parcel$interopDefault($1zUcV))).ec('secp256k1').keyFromPublic(decodedPublicKey);
    return $201657d342d01b1b$var$verifySpOrP2Sig(decodedSig, bytesHash, key);
}
function $201657d342d01b1b$var$verifyP2Signature(decodedSig, bytesHash, decodedPublicKey) {
    const key = new (0, (/*@__PURE__*/$parcel$interopDefault($1zUcV))).ec('p256').keyFromPublic(decodedPublicKey);
    return $201657d342d01b1b$var$verifySpOrP2Sig(decodedSig, bytesHash, key);
}
function $201657d342d01b1b$var$verifySpOrP2Sig(decodedSig, bytesHash, key) {
    const hexSig = $201657d342d01b1b$export$b0491dd0626f8a03((0, (/*@__PURE__*/$parcel$interopDefault($42fd859874341478$exports)))(decodedSig));
    const match = hexSig.match(/([a-f\d]{64})/gi);
    if (match) try {
        const [r, s] = match;
        return key.verify(bytesHash, {
            r: r,
            s: s
        });
    } catch (e) {
        return false;
    }
    return false;
}
/**
 *  @category Error
 *  @description Error that indicates invalid protocol hash being passed or used
 */ class $201657d342d01b1b$export$cad3798ff1c849c5 extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(protocolHash, errorDetails){
        super();
        this.protocolHash = protocolHash;
        this.errorDetails = errorDetails;
        this.name = 'InvalidProtocolHashError';
        this.name = 'InvalidProtocolHashError';
        this.message = `The protocol hash '${protocolHash}' is invalid`;
        errorDetails && (this.message += `: ${errorDetails}`);
    }
}
/**
 *  @category Error
 *  @description Error that indicates unable to convert data type from one to another
 */ class $201657d342d01b1b$export$ec375d495b3854fb extends (0, $8b6476b09e20f53e$export$34bc216509d47ce6) {
    constructor(value, desiredType){
        super();
        this.value = value;
        this.desiredType = desiredType;
        this.name = 'ValueConversionError';
        this.message = `Unable to convert ${value} to a ${desiredType}`;
    }
}
var $201657d342d01b1b$export$f9bf9a3c544b4010;
(function(ValidationResult) {
    ValidationResult[ValidationResult["NO_PREFIX_MATCHED"] = 0] = "NO_PREFIX_MATCHED";
    ValidationResult[ValidationResult["INVALID_CHECKSUM"] = 1] = "INVALID_CHECKSUM";
    ValidationResult[ValidationResult["INVALID_LENGTH"] = 2] = "INVALID_LENGTH";
    ValidationResult[ValidationResult["VALID"] = 3] = "VALID";
})($201657d342d01b1b$export$f9bf9a3c544b4010 || ($201657d342d01b1b$export$f9bf9a3c544b4010 = {}));
function $201657d342d01b1b$export$cf38fb338883777c(value) {
    if (typeof value !== 'string') return false;
    return value in $201657d342d01b1b$export$82e9f45cca5ba907;
}
/**
 * @description This function is called by the validation functions ([[validateAddress]], [[validateChain]], [[validateContractAddress]], [[validateKeyHash]], [[validateSignature]], [[validatePublicKey]]).
 * Verify if the value has the right prefix or return `NO_PREFIX_MATCHED`,
 * decode the value using base58 and return `INVALID_CHECKSUM` if it fails,
 * check if the length of the value matches the prefix type or return `INVALID_LENGTH`.
 * If all checks pass, return `VALID`.
 *
 * @param value Value to validate
 * @param prefixes prefix the value should have
 */ function $201657d342d01b1b$var$validatePrefixedValue(value, prefixes) {
    const match = new RegExp(`^(${prefixes.join('|')})`).exec(value);
    if (!match || match.length === 0) return $201657d342d01b1b$export$f9bf9a3c544b4010.NO_PREFIX_MATCHED;
    const prefixKey = match[0];
    if (!$201657d342d01b1b$export$cf38fb338883777c(prefixKey)) return $201657d342d01b1b$export$f9bf9a3c544b4010.NO_PREFIX_MATCHED;
    // Check whether annotation exist before starting validation
    if (value.includes('%')) value = value.split('%')[0];
    const kt1Regex = /^(KT1\w{33})$/;
    if (!kt1Regex.test(value) && prefixKey === 'KT1') return $201657d342d01b1b$export$f9bf9a3c544b4010.INVALID_CHECKSUM;
    // decodeUnsafe return undefined if decoding fail
    let decoded = (0, (/*@__PURE__*/$parcel$interopDefault($47f81b414571e8df$exports))).decodeUnsafe(value);
    if (!decoded) return $201657d342d01b1b$export$f9bf9a3c544b4010.INVALID_CHECKSUM;
    decoded = decoded.slice($201657d342d01b1b$export$82e9f45cca5ba907[prefixKey].length);
    if (decoded.length !== $201657d342d01b1b$export$2a5ba4495636ee46[prefixKey]) return $201657d342d01b1b$export$f9bf9a3c544b4010.INVALID_LENGTH;
    return $201657d342d01b1b$export$f9bf9a3c544b4010.VALID;
}
const $201657d342d01b1b$var$implicitPrefix = [
    $201657d342d01b1b$export$e77cfe0b08ec163.TZ1,
    $201657d342d01b1b$export$e77cfe0b08ec163.TZ2,
    $201657d342d01b1b$export$e77cfe0b08ec163.TZ3,
    $201657d342d01b1b$export$e77cfe0b08ec163.TZ4
];
const $201657d342d01b1b$var$contractPrefix = [
    $201657d342d01b1b$export$e77cfe0b08ec163.KT1
];
const $201657d342d01b1b$var$signaturePrefix = [
    $201657d342d01b1b$export$e77cfe0b08ec163.EDSIG,
    $201657d342d01b1b$export$e77cfe0b08ec163.P2SIG,
    $201657d342d01b1b$export$e77cfe0b08ec163.SPSIG,
    $201657d342d01b1b$export$e77cfe0b08ec163.SIG
];
const $201657d342d01b1b$var$pkPrefix = [
    $201657d342d01b1b$export$e77cfe0b08ec163.EDPK,
    $201657d342d01b1b$export$e77cfe0b08ec163.SPPK,
    $201657d342d01b1b$export$e77cfe0b08ec163.P2PK,
    $201657d342d01b1b$export$e77cfe0b08ec163.BLPK
];
const $201657d342d01b1b$var$operationPrefix = [
    $201657d342d01b1b$export$e77cfe0b08ec163.O
];
const $201657d342d01b1b$var$protocolPrefix = [
    $201657d342d01b1b$export$e77cfe0b08ec163.P
];
const $201657d342d01b1b$var$blockPrefix = [
    $201657d342d01b1b$export$e77cfe0b08ec163.B
];
const $201657d342d01b1b$var$smartRollupPrefix = [
    $201657d342d01b1b$export$e77cfe0b08ec163.SR1
];
/**
 * @description Used to check if an address or a contract address is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateAddress } from '@taquito/utils';
 * const pkh = 'tz1L9r8mWmRPndRhuvMCWESLGSVeFzQ9NAWx'
 * const validation = validateAddress(pkh)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $201657d342d01b1b$export$f78173835dcde49f(value) {
    return $201657d342d01b1b$var$validatePrefixedValue(value, [
        ...$201657d342d01b1b$var$implicitPrefix,
        ...$201657d342d01b1b$var$contractPrefix,
        ...$201657d342d01b1b$var$smartRollupPrefix
    ]);
}
/**
 * @description Used to check if a chain id is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateChain } from '@taquito/utils';
 * const chainId = 'NetXdQprcVkpaWU'
 * const validation = validateChain(chainId)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $201657d342d01b1b$export$cb16a5d2af893df6(value) {
    return $201657d342d01b1b$var$validatePrefixedValue(value, [
        $201657d342d01b1b$export$e77cfe0b08ec163.NET
    ]);
}
/**
 * @description Used to check if a contract address is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateContractAddress } from '@taquito/utils';
 * const contractAddress = 'KT1JVErLYTgtY8uGGZ4mso2npTSxqVLDRVbC'
 * const validation = validateContractAddress(contractAddress)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $201657d342d01b1b$export$2ed905adbd9a56f2(value) {
    return $201657d342d01b1b$var$validatePrefixedValue(value, $201657d342d01b1b$var$contractPrefix);
}
/**
 * @description Used to check if a key hash is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateKeyHash } from '@taquito/utils';
 * const keyHashWithoutPrefix = '1L9r8mWmRPndRhuvMCWESLGSVeFzQ9NAWx'
 * const validation = validateKeyHash(keyHashWithoutPrefix)
 * console.log(validation)
 * // This example return 0 which correspond to NO_PREFIX_MATCHED
 * ```
 */ function $201657d342d01b1b$export$dbd3afbe999d4c3d(value) {
    return $201657d342d01b1b$var$validatePrefixedValue(value, $201657d342d01b1b$var$implicitPrefix);
}
/**
 * @description Used to check if a signature is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateSignature } from '@taquito/utils';
 * const signature = 'edsigtkpiSSschcaCt9pUVrpNPf7TTcgvgDEDD6NCEHMy8NNQJCGnMfLZzYoQj74yLjo9wx6MPVV29CvVzgi7qEcEUok3k7AuMg'
 * const validation = validateSignature(signature)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $201657d342d01b1b$export$f680e6c2b3919edb(value) {
    return $201657d342d01b1b$var$validatePrefixedValue(value, $201657d342d01b1b$var$signaturePrefix);
}
/**
 * @description Used to check if a public key is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validatePublicKey } from '@taquito/utils';
 * const publicKey = 'edpkvS5QFv7KRGfa3b87gg9DBpxSm3NpSwnjhUjNBQrRUUR66F7C9g'
 * const validation = validatePublicKey(publicKey)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $201657d342d01b1b$export$7e268ff6bd252dc4(value) {
    return $201657d342d01b1b$var$validatePrefixedValue(value, $201657d342d01b1b$var$pkPrefix);
}
/**
 * @description Used to check if an operation hash is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateOperation } from '@taquito/utils';
 * const operationHash = 'oo6JPEAy8VuMRGaFuMmLNFFGdJgiaKfnmT1CpHJfKP3Ye5ZahiP'
 * const validation = validateOperation(operationHash)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $201657d342d01b1b$export$a92a48117d546c9(value) {
    return $201657d342d01b1b$var$validatePrefixedValue(value, $201657d342d01b1b$var$operationPrefix);
}
/**
 * @description Used to check if a protocol hash is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateProtocol } from '@taquito/utils';
 * const protocolHash = 'PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx'
 * const validation = validateProtocol(protocolHash)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $201657d342d01b1b$export$6090822dce1c45f9(value) {
    return $201657d342d01b1b$var$validatePrefixedValue(value, $201657d342d01b1b$var$protocolPrefix);
}
/**
 * @description Used to check if a block hash is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateBlock } from '@taquito/utils';
 * const blockHash = 'PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx'
 * const validation = validateBlock(blockHash)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $201657d342d01b1b$export$8a53803420cdc9be(value) {
    return $201657d342d01b1b$var$validatePrefixedValue(value, $201657d342d01b1b$var$blockPrefix);
}
/**
 * @description Used to check if a spending key is valid.
 * @returns 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 */ function $201657d342d01b1b$export$ac37c7680f9b1515(value) {
    return $201657d342d01b1b$var$validatePrefixedValue(value, [
        $201657d342d01b1b$export$e77cfe0b08ec163.SASK
    ]);
}
function $201657d342d01b1b$export$a2057601792df650(validation) {
    switch(validation){
        case $201657d342d01b1b$export$f9bf9a3c544b4010.NO_PREFIX_MATCHED:
            return 'with unsupported prefix';
        case $201657d342d01b1b$export$f9bf9a3c544b4010.INVALID_CHECKSUM:
            return 'failed checksum';
        case $201657d342d01b1b$export$f9bf9a3c544b4010.INVALID_LENGTH:
            return 'with incorrect length';
        default:
            return '';
    }
}
function $201657d342d01b1b$export$9fbea988cfe61232(value) {
    return $201657d342d01b1b$var$validatePrefixedValue(value, [
        ...$201657d342d01b1b$var$smartRollupPrefix
    ]);
}
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $201657d342d01b1b$export$a4ad2735b021c132 = {
    "commitHash": "2e05f6f865be17a1b367b284542b24ffa9823271",
    "version": "19.2.1"
};
const $201657d342d01b1b$var$TZ_DECIMALS = 6;
const $201657d342d01b1b$var$MTZ_DECIMALS = 3;
function $201657d342d01b1b$var$getDecimal(format) {
    switch(format){
        case 'tz':
            return $201657d342d01b1b$var$TZ_DECIMALS;
        case 'mtz':
            return $201657d342d01b1b$var$MTZ_DECIMALS;
        case 'mutez':
        default:
            return 0;
    }
}
function $201657d342d01b1b$export$d9468344d3651243(from = 'mutez', to = 'mutez', amount) {
    const bigNum = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(amount);
    if (bigNum.isNaN()) return amount;
    return bigNum.multipliedBy(Math.pow(10, $201657d342d01b1b$var$getDecimal(from))).dividedBy(Math.pow(10, $201657d342d01b1b$var$getDecimal(to)));
}
/**
 * @packageDocumentation
 * @module @taquito/utils
 */ /*
 * Some code in this file is originally from sotez and eztz
 * Copyright (c) 2018 Andrew Kishino
 * Copyright (c) 2017 Stephen Andrews
 */ /**
 *
 * @description Hash a string using the BLAKE2b algorithm, base58 encode the hash obtained and appends the prefix 'expr' to it
 *
 * @param value Value in hex
 */ function $201657d342d01b1b$export$8069b2d054f1e0a(value) {
    const blakeHash = (0, (/*@__PURE__*/$parcel$interopDefault($c8d6b1f140f0b27a$exports))).blake2b($201657d342d01b1b$export$80feccbc0acd4657(value), undefined, 32);
    return $201657d342d01b1b$export$8ff626c40517d3d3(blakeHash, $201657d342d01b1b$export$82e9f45cca5ba907['expr']);
}
/**
 *
 * @description Return the operation hash of a signed operation
 * @param value Value in hex of a signed operation
 */ function $201657d342d01b1b$export$376bc9d4074c78c9(value) {
    const blakeHash = (0, (/*@__PURE__*/$parcel$interopDefault($c8d6b1f140f0b27a$exports))).blake2b($201657d342d01b1b$export$80feccbc0acd4657(value), undefined, 32);
    return $201657d342d01b1b$export$8ff626c40517d3d3(blakeHash, $201657d342d01b1b$export$82e9f45cca5ba907.o);
}
/**
 *
 * @description Base58 encode a string or a Uint8Array and append a prefix to it
 *
 * @param value Value to base58 encode
 * @param prefix prefix to append to the encoded string
 */ function $201657d342d01b1b$export$8ff626c40517d3d3(value, prefix) {
    const payloadAr = typeof value === 'string' ? Uint8Array.from((0, $6ZWSX.Buffer).from(value, 'hex')) : value;
    const n = new Uint8Array(prefix.length + payloadAr.length);
    n.set(prefix);
    n.set(payloadAr, prefix.length);
    return (0, (/*@__PURE__*/$parcel$interopDefault($47f81b414571e8df$exports))).encode((0, $6ZWSX.Buffer).from(n.buffer));
}
/**
 *
 * @description Base58 decode a string and remove the prefix from it
 *
 * @param value Value to base58 decode
 * @param prefix prefix to remove from the decoded string
 */ const $201657d342d01b1b$export$b9856b5e6fd1a05f = (enc, prefixArg)=>(0, (/*@__PURE__*/$parcel$interopDefault($47f81b414571e8df$exports))).decode(enc).slice(prefixArg.length);
/**
 *
 * @description Base58 decode a string with predefined prefix
 *
 * @param value Value to base58 decode
 */ function $201657d342d01b1b$export$c5fd02d48c871a17(payload) {
    const buf = (0, (/*@__PURE__*/$parcel$interopDefault($47f81b414571e8df$exports))).decode(payload);
    const prefixMap = {
        [$201657d342d01b1b$export$82e9f45cca5ba907.tz1.toString()]: '0000',
        [$201657d342d01b1b$export$82e9f45cca5ba907.tz2.toString()]: '0001',
        [$201657d342d01b1b$export$82e9f45cca5ba907.tz3.toString()]: '0002'
    };
    const pref = prefixMap[new Uint8Array(buf.slice(0, 3)).toString()];
    if (pref) {
        // tz addresses
        const hex = $201657d342d01b1b$export$b0491dd0626f8a03(buf.slice(3));
        return pref + hex;
    } else // other (kt addresses)
    return '01' + $201657d342d01b1b$export$b0491dd0626f8a03(buf.slice(3, 42)) + '00';
}
/**
 *
 * @description b58 decode a string without predefined prefix
 * @param value
 * @returns string of bytes
 */ function $201657d342d01b1b$export$9a7f049521ad14d8(payload) {
    const buf = (0, (/*@__PURE__*/$parcel$interopDefault($47f81b414571e8df$exports))).decode(payload);
    // tz4 address currently
    return $201657d342d01b1b$export$b0491dd0626f8a03(buf.slice(3, 42));
}
/**
 *
 * @description Base58 encode an address using predefined prefix
 *
 * @param value Address to base58 encode (tz1, tz2, tz3 or KT1)
 * @deprecated use encodeAddress instead, same functionality with a more descriptive name
 */ function $201657d342d01b1b$export$e56436d18a720ec1(value) {
    if (value.substring(0, 2) === '00') {
        const pref = {
            '0000': $201657d342d01b1b$export$82e9f45cca5ba907.tz1,
            '0001': $201657d342d01b1b$export$82e9f45cca5ba907.tz2,
            '0002': $201657d342d01b1b$export$82e9f45cca5ba907.tz3
        };
        return $201657d342d01b1b$export$8ff626c40517d3d3(value.substring(4), pref[value.substring(0, 4)]);
    }
    return $201657d342d01b1b$export$8ff626c40517d3d3(value.substring(2, 42), $201657d342d01b1b$export$82e9f45cca5ba907.KT);
}
/**
 *
 * @description Base58 encode an address using predefined prefix (tz1, tz2, tz3, or KT1 without annotation)
 *
 * @param value Address to base58 encode (tz1, tz2, tz3 or KT1). Supports value with or without '0x' prefix
 */ function $201657d342d01b1b$export$b149ba8ff44e4e70(value) {
    if (value.substring(0, 2) === '0x') value = value.slice(2);
    if (value.substring(0, 2) === '00') {
        const pref = {
            '0000': $201657d342d01b1b$export$82e9f45cca5ba907.tz1,
            '0001': $201657d342d01b1b$export$82e9f45cca5ba907.tz2,
            '0002': $201657d342d01b1b$export$82e9f45cca5ba907.tz3
        };
        return $201657d342d01b1b$export$8ff626c40517d3d3(value.substring(4), pref[value.substring(0, 4)]);
    }
    return $201657d342d01b1b$export$8ff626c40517d3d3(value.substring(2, 42), $201657d342d01b1b$export$82e9f45cca5ba907.KT);
}
/**
 *
 * @description Base58 encode an address without predefined prefix
 * @param value Address to base58 encode (tz4) hex dec
 * @returns return address
 */ function $201657d342d01b1b$export$205862d7f4889ee4(value) {
    return $201657d342d01b1b$export$8ff626c40517d3d3(value, $201657d342d01b1b$export$82e9f45cca5ba907.tz4);
}
/**
 *
 * @description Base58 encode a key according to its prefix
 *
 * @param value Key to base58 encode
 */ function $201657d342d01b1b$export$a0511d6cbab6225d(value) {
    if (value[0] === '0') {
        const pref = {
            '00': new Uint8Array([
                13,
                15,
                37,
                217
            ]),
            '01': new Uint8Array([
                3,
                254,
                226,
                86
            ]),
            '02': new Uint8Array([
                3,
                178,
                139,
                127
            ])
        };
        return $201657d342d01b1b$export$8ff626c40517d3d3(value.substring(2), pref[value.substring(0, 2)]);
    }
}
/**
 *
 * @description Base58 encode a key hash according to its prefix
 *
 * @param value Key hash to base58 encode
 */ function $201657d342d01b1b$export$1ef834a164cef85e(value) {
    if (value[0] === '0') {
        const pref = {
            '00': new Uint8Array([
                6,
                161,
                159
            ]),
            '01': new Uint8Array([
                6,
                161,
                161
            ]),
            '02': new Uint8Array([
                6,
                161,
                164
            ])
        };
        return $201657d342d01b1b$export$8ff626c40517d3d3(value.substring(2), pref[value.substring(0, 2)]);
    }
}
/**
 *
 * @description Convert an hex string to a Uint8Array
 *
 * @param hex Hex string to convert
 * @throws {@link ValueConversionError}
 */ const $201657d342d01b1b$export$80feccbc0acd4657 = (hex)=>{
    if (hex.length % 2 !== 0) throw new (0, $8b6476b09e20f53e$export$1888d6928c74d5ee)(hex, `: Expecting even number of characters`);
    const hexDigits = $201657d342d01b1b$export$b2f5d0058897e6e6(hex);
    if (!hexDigits.match(/^([\da-f]{2})*$/gi)) throw new (0, $8b6476b09e20f53e$export$1888d6928c74d5ee)(hex, `: Only characters 0-9, a-f and A-F are expected. Optionally, it can be prefixed with '0x'`);
    const out = new Uint8Array(hexDigits.length / 2);
    let j = 0;
    for(let i = 0; i < hexDigits.length; i += 2){
        const v = parseInt(hexDigits.slice(i, i + 2), 16);
        if (Number.isNaN(v)) throw new $201657d342d01b1b$export$ec375d495b3854fb(hex, 'Uint8Array');
        out[j++] = v;
    }
    return out;
};
/**
 *
 * @description Merge 2 buffers together
 *
 * @param b1 First buffer
 * @param b2 Second buffer
 */ const $201657d342d01b1b$export$196099622a18a454 = (b1, b2)=>{
    const r = new Uint8Array(b1.length + b2.length);
    r.set(b1);
    r.set(b2, b1.length);
    return r;
};
/**
 *
 * @description Flatten a michelson json representation to an array
 *
 * @param s michelson json
 */ const $201657d342d01b1b$export$b9f9ab98e553df31 = function me2(s) {
    let ret = [];
    if (Object.prototype.hasOwnProperty.call(s, 'prim')) {
        if (s.prim === 'Pair') {
            ret.push(me2(s.args[0]));
            ret = ret.concat(me2(s.args[1]));
        } else if (s.prim === 'Elt') ret = {
            key: me2(s.args[0]),
            val: me2(s.args[1])
        };
        else if (s.prim === 'True') ret = true;
        else if (s.prim === 'False') ret = false;
    } else if (Array.isArray(s)) {
        const sc = s.length;
        for(let i = 0; i < sc; i++){
            const n = me2(s[i]);
            if (typeof n.key !== 'undefined') {
                if (Array.isArray(ret)) ret = {
                    keys: [],
                    vals: []
                };
                ret.keys.push(n.key);
                ret.vals.push(n.val);
            } else ret.push(n);
        }
    } else if (Object.prototype.hasOwnProperty.call(s, 'string')) ret = s.string;
    else if (Object.prototype.hasOwnProperty.call(s, 'int')) ret = parseInt(s.int, 10);
    else ret = s;
    return ret;
};
/**
 *
 * @description Convert a Uint8Array to an hex string
 *
 * @param buffer Uint8Array to convert
 */ const $201657d342d01b1b$export$b0491dd0626f8a03 = (buffer)=>{
    const hexParts = [];
    buffer.forEach((byte)=>{
        const hex = byte.toString(16);
        const paddedHex = `00${hex}`.slice(-2);
        hexParts.push(paddedHex);
    });
    return hexParts.join('');
};
/**
 *
 *  @description Gets Tezos address (PKH) from Public Key
 *
 *  @param publicKey Public Key
 *  @returns A string of the Tezos address (PKH) that was derived from the given Public Key
 */ const $201657d342d01b1b$export$7d56ebd247473b77 = (publicKey)=>{
    let encodingPrefix;
    let prefixLen;
    const keyPrefix = $201657d342d01b1b$export$2fc642945002cd1a(publicKey);
    const decoded = $201657d342d01b1b$export$b9856b5e6fd1a05f(publicKey, $201657d342d01b1b$export$82e9f45cca5ba907[keyPrefix]);
    switch(keyPrefix){
        case $201657d342d01b1b$export$e77cfe0b08ec163.EDPK:
            encodingPrefix = $201657d342d01b1b$export$82e9f45cca5ba907[$201657d342d01b1b$export$e77cfe0b08ec163.TZ1];
            prefixLen = $201657d342d01b1b$export$2a5ba4495636ee46[$201657d342d01b1b$export$e77cfe0b08ec163.TZ1];
            break;
        case $201657d342d01b1b$export$e77cfe0b08ec163.SPPK:
            encodingPrefix = $201657d342d01b1b$export$82e9f45cca5ba907[$201657d342d01b1b$export$e77cfe0b08ec163.TZ2];
            prefixLen = $201657d342d01b1b$export$2a5ba4495636ee46[$201657d342d01b1b$export$e77cfe0b08ec163.TZ2];
            break;
        case $201657d342d01b1b$export$e77cfe0b08ec163.P2PK:
            encodingPrefix = $201657d342d01b1b$export$82e9f45cca5ba907[$201657d342d01b1b$export$e77cfe0b08ec163.TZ3];
            prefixLen = $201657d342d01b1b$export$2a5ba4495636ee46[$201657d342d01b1b$export$e77cfe0b08ec163.TZ3];
            break;
        case $201657d342d01b1b$export$e77cfe0b08ec163.BLPK:
            encodingPrefix = $201657d342d01b1b$export$82e9f45cca5ba907[$201657d342d01b1b$export$e77cfe0b08ec163.TZ4];
            prefixLen = $201657d342d01b1b$export$2a5ba4495636ee46[$201657d342d01b1b$export$e77cfe0b08ec163.TZ4];
    }
    const hashed = (0, $1fbb9568f45194cc$exports.hash)(decoded, prefixLen);
    const result = $201657d342d01b1b$export$8ff626c40517d3d3(hashed, encodingPrefix);
    return result;
};
/**
 *
 * @description Convert a string to bytes
 *
 * @param str String to convert
 * @deprecated use stringToBytes instead, same functionality with a more descriptive name
 */ function $201657d342d01b1b$export$ccee8129914e4ca9(str) {
    return (0, $6ZWSX.Buffer).from(str, 'utf8').toString('hex');
}
/**
 *
 * @description Convert a string to a byte string representation
 *
 * @param str String to convert
 */ function $201657d342d01b1b$export$c8dd6bc66a63753c(str) {
    return (0, $6ZWSX.Buffer).from(str, 'utf8').toString('hex');
}
/**
 *
 * @description Convert bytes to a string
 *
 * @param str Bytes to convert
 * @deprecated use hexStringToBytes instead, same functionality with a more descriptive name
 */ function $201657d342d01b1b$export$a3e285b44709418b(hex) {
    return (0, $6ZWSX.Buffer).from($201657d342d01b1b$export$80feccbc0acd4657(hex)).toString('utf8');
}
/**
 *
 * @description Convert byte string representation to string
 *
 * @param str byte string to convert
 */ function $201657d342d01b1b$export$7c746b75f47c9c7d(hex) {
    return (0, $6ZWSX.Buffer).from($201657d342d01b1b$export$80feccbc0acd4657(hex)).toString('utf8');
}
/**
 *
 * @description Convert hex string/UintArray/Buffer to bytes
 *
 * @param hex String value to convert to bytes
 */ function $201657d342d01b1b$export$865538231a1956e8(hex) {
    const hexDigits = $201657d342d01b1b$export$b2f5d0058897e6e6(hex);
    if (!hexDigits.match(/^(0x)?([\da-f]{2})*$/gi)) throw new (0, $8b6476b09e20f53e$export$1888d6928c74d5ee)(hex, `: Expecting even number of characters: 0-9, a-z, A-Z, optionally prefixed with 0x`);
    return (0, $6ZWSX.Buffer).from(hexDigits, 'hex');
}
/**
 *
 * @description Converts a number or Bignumber to hexadecimal  string
 *
 * @param val The value  that will be converted to a hexadecimal string value
 */ function $201657d342d01b1b$export$80dcf81a50eb2909(val, bitLength = 8) {
    return (0, $6ZWSX.Buffer).from($201657d342d01b1b$export$a992125d2f1448ce(val, bitLength), 'hex');
}
function $201657d342d01b1b$export$3e269bbf0f7d8bcd(val, bitLength = 8) {
    return (0, $6ZWSX.Buffer).from($201657d342d01b1b$export$a992125d2f1448ce(val, bitLength), 'hex');
}
/**
 *
 * @description Converts a number or BigNumber to a padded hexadecimal string
 * @param val The value that will be converted into a padded hexadecimal string value
 * @param bitLength The length of bits
 *
 */ function $201657d342d01b1b$export$a992125d2f1448ce(val, bitLength = 8) {
    if (new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).isPositive()) {
        const nibbleLength = Math.ceil(bitLength / 4);
        const hex = val.toString(16);
        // check whether nibble (4 bits) length is higher or lower than the current hex string length
        let targetLength = hex.length >= nibbleLength ? hex.length : nibbleLength;
        // make sure the hex string target length is even
        targetLength = targetLength % 2 == 0 ? targetLength : targetLength + 1;
        return $201657d342d01b1b$var$padHexWithZero(hex, targetLength);
    } else {
        const twosCompliment = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(2).pow(bitLength).minus(new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).abs());
        return twosCompliment.toString(16);
    }
}
function $201657d342d01b1b$var$padHexWithZero(hex, targetLength) {
    const padString = '0';
    if (hex.length >= targetLength) return hex;
    else {
        const padLength = targetLength - hex.length;
        return padString.repeat(padLength) + hex;
    }
}
/**
 *
 * @description Strips the first 2 characters of a hex string (0x)
 *
 * @param hex string to strip prefix from
 */ function $201657d342d01b1b$export$b2f5d0058897e6e6(hex) {
    return hex.startsWith('0x') ? hex.slice(2) : hex;
}



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $5db8d2af09626b01$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5db8d2af09626b01$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
const $5db8d2af09626b01$export$df531a306ef6bb82 = 'main';
const $5db8d2af09626b01$export$20a0ad8102085d6c = {
    block: 'head'
};
var $5db8d2af09626b01$var$RPCMethodName;
(function(RPCMethodName) {
    RPCMethodName["GET_BAKING_RIGHTS"] = "getBakingRights";
    RPCMethodName["GET_BALLOTS"] = "getBallots";
    RPCMethodName["GET_BALLOT_LIST"] = "getBallotList";
    RPCMethodName["GET_BIG_MAP_KEY"] = "getBigMapKey";
    RPCMethodName["GET_BIG_MAP_EXPR"] = "getBigMapExpr";
    RPCMethodName["GET_BLOCK_HASH"] = "getBlockHash";
    RPCMethodName["GET_BLOCK"] = "getBlock";
    RPCMethodName["GET_BLOCK_HEADER"] = "getBlockHeader";
    RPCMethodName["GET_BLOCK_METADATA"] = "getBlockMetadata";
    RPCMethodName["GET_BALANCE"] = "getBalance";
    RPCMethodName["GET_CHAIN_ID"] = "getChainId";
    RPCMethodName["GET_CONSTANTS"] = "getConstants";
    RPCMethodName["GET_CONTRACT"] = "getContract";
    RPCMethodName["GET_CURRENT_PERIOD"] = "getCurrentPeriod";
    RPCMethodName["GET_CURRENT_PROPOSAL"] = "getCurrentProposal";
    RPCMethodName["GET_CURRENT_QUORUM"] = "getCurrentQuorum";
    RPCMethodName["GET_DELEGATE"] = "getDelegate";
    RPCMethodName["GET_DELEGATES"] = "getDelegates";
    RPCMethodName["GET_VOTING_INFO"] = "getVotingInfo";
    RPCMethodName["GET_ATTESTATION_RIGHTS"] = "getAttestationRights";
    RPCMethodName["GET_ENDORSING_RIGHTS"] = "getEndorsingRights";
    RPCMethodName["GET_ENTRYPOINTS"] = "getEntrypoints";
    RPCMethodName["GET_LIVE_BLOCKS"] = "getLiveBlocks";
    RPCMethodName["GET_MANAGER_KEY"] = "getManagerKey";
    RPCMethodName["GET_NORMALIZED_SCRIPT"] = "getNormalizedScript";
    RPCMethodName["GET_PROPOSALS"] = "getProposals";
    RPCMethodName["GET_PROTOCOLS"] = "getProtocols";
    RPCMethodName["GET_SAPLING_DIFF_BY_CONTRACT"] = "getSaplingDiffByContract";
    RPCMethodName["GET_SAPLING_DIFF_BY_ID"] = "getSaplingDiffById";
    RPCMethodName["GET_SCRIPT"] = "getScript";
    RPCMethodName["GET_STORAGE"] = "getStorage";
    RPCMethodName["GET_SUCCESSOR_PERIOD"] = "getSuccessorPeriod";
    RPCMethodName["GET_VOTES_LISTINGS"] = "getVotesListings";
    RPCMethodName["PACK_DATA"] = "packData";
    RPCMethodName["GET_STORAGE_USED_SPACE"] = "getStorageUsedSpace";
    RPCMethodName["GET_STORAGE_PAID_SPACE"] = "getStoragePaidSpace";
    RPCMethodName["GET_TICKET_BALANCE"] = "getTicketBalance";
    RPCMethodName["GET_ALL_TICKET_BALANCES"] = "getAllTicketBalances";
    RPCMethodName["GET_PENDING_OPERATIONS"] = "getPendingOperations";
})($5db8d2af09626b01$var$RPCMethodName || ($5db8d2af09626b01$var$RPCMethodName = {}));
/**
 * Casts object/array items to BigNumber
 * @param data input object or array
 * @param keys keys for processing or all items if not defined
 *
 */ function $5db8d2af09626b01$export$ef5b1cb6f241eca7(data, keys) {
    const returnArray = Array.isArray(data);
    if (typeof keys === 'undefined') keys = Object.keys(data);
    const response = returnArray ? [] : {};
    keys.forEach((key)=>{
        const item = data[key];
        let res;
        if (typeof item === 'undefined') return;
        if (Array.isArray(item)) {
            res = $5db8d2af09626b01$export$ef5b1cb6f241eca7(item);
            response[key] = res;
            return;
        }
        res = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(item);
        response[key] = res;
    });
    return response;
}
const $5db8d2af09626b01$var$defaultTtl = 1000;
/***
 * @description RpcClientCache acts as a decorator over the RpcClient instance by caching responses for the period defined by the ttl.
 */ class $5db8d2af09626b01$export$696832b05866dc5e {
    /**
     *
     * @param rpcClient rpcClient responsible of the interaction with Tezos network through an rpc node
     * @param ttl number representing the time to live (default 1000 milliseconds)
     *
     * @example new RpcClientCache(new RpcClient('https://mainnet.ecadinfra.com/'))
     */ constructor(rpcClient, ttl = $5db8d2af09626b01$var$defaultTtl){
        this.rpcClient = rpcClient;
        this.ttl = ttl;
        this._cache = {};
    }
    getAllCachedData() {
        return this._cache;
    }
    /**
     * @description Remove all the data in the cache.
     *
     */ deleteAllCachedData() {
        for(const key in this._cache)delete this._cache[key];
    }
    formatCacheKey(rpcUrl, rpcMethodName, rpcMethodParams, rpcMethodData) {
        let paramsToString = '';
        rpcMethodParams.forEach((param)=>{
            paramsToString = typeof param === 'object' ? paramsToString + JSON.stringify(param) + '/' : paramsToString + param + '/';
        });
        return rpcMethodData ? `${rpcUrl}/${rpcMethodName}/${paramsToString}${JSON.stringify(rpcMethodData)}/` : `${rpcUrl}/${rpcMethodName}/${paramsToString}`;
    }
    has(key) {
        return key in this._cache;
    }
    get(key) {
        return this._cache[key].response;
    }
    put(key, response) {
        const handle = setTimeout(()=>{
            return this.remove(key);
        }, this.ttl);
        Object.assign(this._cache, {
            [key]: {
                handle: handle,
                response: response
            }
        });
    }
    remove(key) {
        if (key in this._cache) delete this._cache[key];
    }
    validateAddress(address) {
        const addressValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(address);
        if (addressValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(address, (0, $201657d342d01b1b$export$a2057601792df650)(addressValidation));
    }
    validateContract(address) {
        const addressValidation = (0, $201657d342d01b1b$export$2ed905adbd9a56f2)(address);
        if (addressValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$193774326795229b)(address, (0, $201657d342d01b1b$export$a2057601792df650)(addressValidation));
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Get the block's hash, its unique identifier.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-hash
     */ getBlockHash({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_BLOCK_HASH, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBlockHash({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List the ancestors of the given block which, if referred to as the branch in an operation header, are recent enough for that operation to be included in the current block.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-live-blocks
     */ getLiveBlocks({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_LIVE_BLOCKS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getLiveBlocks({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address address from which we want to retrieve the balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the spendable balance of a contract, excluding frozen bonds
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-balance
     */ getBalance(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_BALANCE, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBalance(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve the storage
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the data of the contract.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-storage
     */ getStorage(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateContract(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_STORAGE, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getStorage(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve the script
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the code and data of the contract.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-script
     */ getScript(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateContract(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_SCRIPT, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getScript(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve the script
     * @param unparsingMode default is { unparsing_mode: "Readable" }
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the script of the contract and normalize it using the requested unparsing mode.
     */ getNormalizedScript(address, unparsingMode = {
        unparsing_mode: 'Readable'
    }, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateContract(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_NORMALIZED_SCRIPT, [
                block,
                address
            ], unparsingMode);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getNormalizedScript(address, unparsingMode, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the complete status of a contract.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id
     */ getContract(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_CONTRACT, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getContract(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve the manager
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the manager of an implicit contract
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-manager-key
     */ getManagerKey(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_MANAGER_KEY, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getManagerKey(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve the delegate (baker)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the delegate of a contract, if any
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-delegate
     */ getDelegate(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_DELEGATE, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getDelegate(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @deprecated Deprecated in favor of getBigMapKeyByID
     * @param address contract address from which we want to retrieve the big map key
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the value associated with a key in the big map storage of the contract.
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-context-contracts-contract-id-big-map-get
     */ getBigMapKey(address, key, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            const keyUrl = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_BIG_MAP_KEY, [
                block,
                address
            ], key);
            if (this.has(keyUrl)) return this.get(keyUrl);
            else {
                const response = this.rpcClient.getBigMapKey(address, key, {
                    block: block
                });
                this.put(keyUrl, response);
                return response;
            }
        });
    }
    /**
     * @param id Big Map ID
     * @param expr Expression hash to query (A b58check encoded Blake2b hash of the expression (The expression can be packed using the pack_data method))
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the value associated with a key in a big map.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-big-maps-big-map-id-script-expr
     */ getBigMapExpr(id, expr, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_BIG_MAP_EXPR, [
                block,
                id,
                expr
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBigMapExpr(id, expr, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address delegate address which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Everything about a delegate
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-delegates-pkh
     */ getDelegates(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_DELEGATES, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getDelegates(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address delegate address which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the delegate info (e.g. voting power) found in the listings of the current voting period
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-delegates-pkh-voting-info
     */ getVotingInfo(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_VOTING_INFO, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getVotingInfo(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description All constants
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-constants
     */ getConstants({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_CONSTANTS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getConstants({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head) and version.
     * @description All the information about a block
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id
     * @example getBlock() will default to `/main/chains/block/head?version=0` which shows { kind: endorsement }
     * @example getBlock({ block: 'head~2', version: 1 }) will return an offset of 2 from head blocks and shows { kind: attestation }
     * @example getBlock({ block: 'BL8fTiWcSxWCjiMVnDkbh6EuhqVPZzgWheJ2dqwrxYRm9AephXh~2' }) will return an offset of 2 blocks from given block hash..
     */ getBlock({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_BLOCK, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBlock({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The whole block header
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-header
     */ getBlockHeader({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_BLOCK_HEADER, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBlockHeader({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head) and version
     * @description All the metadata associated to the block
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-metadata
     */ getBlockMetadata({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_BLOCK_METADATA, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBlockMetadata({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param args contains optional query arguments (level, cycle, delegate, consensus_key, and max_round)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Retrieves the list of delegates allowed to bake a block.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-helpers-baking-rights
     */ getBakingRights(args = {}, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_BAKING_RIGHTS, [
                block,
                args
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBakingRights(args, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param args contains optional query arguments (level, cycle, delegate, and consensus_key)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Retrieves the delegates allowed to attest a block
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-helpers-endorsing-rights
     */ getAttestationRights(args = {}, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_ATTESTATION_RIGHTS, [
                block,
                args
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getAttestationRights(args, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @deprecated Deprecated in favor of getAttestationRights
     * @param args contains optional query arguments (level, cycle, delegate, and consensus_key)
     * @param options contains generic configuration for rpc calls
     * @description Retrieves the delegates allowed to endorse a block
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-helpers-endorsing-rights
     */ getEndorsingRights(args = {}, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_ENDORSING_RIGHTS, [
                block,
                args
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getEndorsingRights(args, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Ballots casted so far during a voting period
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-ballot-list
     */ getBallotList({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_BALLOT_LIST, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBallotList({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Sum of ballots casted so far during a voting period
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-ballots
     */ getBallots({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_BALLOTS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBallots({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Current proposal under evaluation.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-current-proposal
     */ getCurrentProposal({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_CURRENT_PROPOSAL, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getCurrentProposal({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Current expected quorum.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-current-quorum
     */ getCurrentQuorum({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_CURRENT_QUORUM, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getCurrentQuorum({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List of delegates with their voting power
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-listings
     */ getVotesListings({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_VOTES_LISTINGS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getVotesListings({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List of proposals with number of supporters
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-proposals
     */ getProposals({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_PROPOSALS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getProposals({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param data operation contents to forge
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Forge an operation returning the unsigned bytes
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-helpers-forge-operations
     */ forgeOperations(data, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpcClient.forgeOperations(data, {
                block: block
            });
        });
    }
    /**
     * @param signedOpBytes signed bytes to inject
     * @description Inject an operation in node and broadcast it and return the ID of the operation
     * @see https://tezos.gitlab.io/api/rpc.html#post-injection-operation
     */ injectOperation(signedOpBytes) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpcClient.injectOperation(signedOpBytes);
        });
    }
    /**
     * @param ops Operations to apply
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Simulate the application of the operations with the context of the given block and return the result of each operation application
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-helpers-preapply-operations
     */ preapplyOperations(ops, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpcClient.preapplyOperations(ops, {
                block: block
            });
        });
    }
    /**
     * @param contract address of the contract we want to get the entrypoints of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Return the list of entrypoints of the contract
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-entrypoints
     * @version 005_PsBABY5H
     */ getEntrypoints(contract, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateContract(contract);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_ENTRYPOINTS, [
                block,
                contract
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getEntrypoints(contract, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @deprecated Deprecated in favor of simulateOperation
     * @param op Operation to run
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Run an operation with the context of the given block and without signature checks and return the operation application result, including the consumed gas.
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-helpers-scripts-run-operation
     */ runOperation(op, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpcClient.runOperation(op, {
                block: block
            });
        });
    }
    /**
     * @param op Operation to simulate
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Simulate running an operation at some future moment (based on the number of blocks given in the `latency` argument), and return the operation application result.
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/oxford-openapi.json
     */ simulateOperation(op, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpcClient.simulateOperation(op, {
                block: block
            });
        });
    }
    /**
     * @param code Code to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Run a Michelson script in the current context
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-helpers-scripts-run-code
     */ runCode(code, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpcClient.runCode(code, {
                block: block
            });
        });
    }
    /**
     * @param viewScriptParams Parameters of the script view to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Simulate a call to a michelson view
     */ runScriptView(_a, _b) {
        var { unparsing_mode: unparsing_mode = 'Readable' } = _a, rest = $5db8d2af09626b01$var$__rest(_a, [
            "unparsing_mode"
        ]);
        var _c = _b === void 0 ? $5db8d2af09626b01$export$20a0ad8102085d6c : _b, block = _c.block;
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpcClient.runScriptView(Object.assign({
                unparsing_mode: unparsing_mode
            }, rest), {
                block: block
            });
        });
    }
    /**
     * @param viewParams Parameters of the view to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Simulate a call to a view following the TZIP-4 standard. See https://gitlab.com/tzip/tzip/-/blob/master/proposals/tzip-4/tzip-4.md#view-entrypoints.
     */ runView(_a, _b) {
        var { unparsing_mode: unparsing_mode = 'Readable' } = _a, rest = $5db8d2af09626b01$var$__rest(_a, [
            "unparsing_mode"
        ]);
        var _c = _b === void 0 ? $5db8d2af09626b01$export$20a0ad8102085d6c : _b, block = _c.block;
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpcClient.runView(Object.assign({
                unparsing_mode: unparsing_mode
            }, rest), {
                block: block
            });
        });
    }
    getChainId() {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_CHAIN_ID, []);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getChainId();
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param data Data to pack
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Computes the serialized version of a data expression using the same algorithm as script instruction PACK
     * Note: You should always verify the packed bytes before signing or requesting that they be signed when using the RPC to pack.
     * This precaution helps protect you and your applications users from RPC nodes that have been compromised.
     * A node that is operated by a bad actor, or compromised by a bad actor could return a fully formed operation that does not correspond to the input provided to the RPC endpoint.
     * A safer solution to pack and sign data would be to use the `packDataBytes` function available in the `@taquito/michel-codec` package.
     * @example packData({ data: { string: "test" }, type: { prim: "string" } })
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-helpers-scripts-pack-data
     */ packData(data, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.PACK_DATA, [
                block
            ], data);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.packData(data, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     *
     * @description Return rpc root url
     */ getRpcUrl() {
        return this.rpcClient.getRpcUrl();
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the voting period (index, kind, starting position) and related information (position, remaining) of the interrogated block
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-current-period
     */ getCurrentPeriod({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_CURRENT_PERIOD, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getCurrentPeriod({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the voting period (index, kind, starting position) and related information (position, remaining) of the next block.Useful to craft operations that will be valid in the next block
     * @example getSuccessorPeriod() will default to successor voting period for /main/chains/block/head.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-successor-period
     */ getSuccessorPeriod({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_SUCCESSOR_PERIOD, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getSuccessorPeriod({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param id Sapling state ID
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the root and a diff of a state starting from an optional offset which is zero by default
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-sapling-sapling-state-id-get-diff
     */ getSaplingDiffById(id, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_SAPLING_DIFF_BY_ID, [
                block,
                id
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getSaplingDiffById(id, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param contract address of the contract we want to get the sapling diff
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the root and a diff of a state starting from an optional offset which is zero by default
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-single-sapling-get-diff
     */ getSaplingDiffByContract(contract, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_SAPLING_DIFF_BY_CONTRACT, [
                block,
                contract
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getSaplingDiffByContract(contract, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description get current and next protocol
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-protocols
     */ getProtocols({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_PROTOCOLS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getProtocols({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param contract address of the contract we want to retrieve storage information of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the used storage space of the contract
     * @see https://tezos.gitlab.io/lima/rpc.html#get-block-id-context-contracts-contract-id-storage
     */ getStorageUsedSpace(contract, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_STORAGE_USED_SPACE, [
                block,
                contract
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getStorageUsedSpace(contract, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param contract address of the contract we want to retrieve storage information of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
  =   * @description Access the paid storage space of the contract
     * @see https://tezos.gitlab.io/lima/rpc.html#get-block-id-context-contracts-contract-id-storage
     */ getStoragePaidSpace(contract, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_STORAGE_PAID_SPACE, [
                block,
                contract
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getStoragePaidSpace(contract, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param contract implicit or originated address we want to retrieve ticket balance of
     * @param ticket object to specify a ticket by ticketer, content type and content
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the contract's balance of ticket with specified ticketer, content type, and content.
     * @example ticket { ticketer: 'address', content_type: { prim: "string" }, content: { string: 'ticket1' } }
     * @see https://tezos.gitlab.io/protocols/016_mumbai.html#rpc-changes
     */ getTicketBalance(contract, ticket, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_TICKET_BALANCE, [
                block,
                contract
            ], ticket);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getTicketBalance(contract, ticket, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param contract originated address we want to retrieve ticket balances of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the complete list of tickets owned by the given contract by scanning the contract's storage.
     * @see https://tezos.gitlab.io/protocols/016_mumbai.html#rpc-changes
     */ getAllTicketBalances(contract, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_ALL_TICKET_BALANCES, [
                block,
                contract
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getAllTicketBalances(contract, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @description List the prevalidated operations in mempool (accessibility of mempool depends on each rpc endpoint)
     * @param args has 5 optional properties. We support version 1 as default will output { applied: { kind: endorsement} } version 2 will output { validated: { kind: attestation} }. The rest of the properties is to filter pending operations response
     * @default args { version: '1', applied: true, refused: true, outdated, true, branchRefused: true, branchDelayed: true, validationPass: undefined }
     * @see https://tezos.gitlab.io/CHANGES.html?highlight=pending_operations#id4
     */ getPendingOperations(args = {}) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $5db8d2af09626b01$var$RPCMethodName.GET_PENDING_OPERATIONS, [
                args
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getPendingOperations(args);
                this.put(key, response);
                return response;
            }
        });
    }
}
var $5db8d2af09626b01$export$b6b4c0fac32b8f7a;
(function(OPERATION_METADATA) {
    OPERATION_METADATA["TOO_LARGE"] = "too large";
})($5db8d2af09626b01$export$b6b4c0fac32b8f7a || ($5db8d2af09626b01$export$b6b4c0fac32b8f7a = {}));
var $5db8d2af09626b01$export$a9040e943c00f226;
(function(METADATA_BALANCE_UPDATES_CATEGORY) {
    METADATA_BALANCE_UPDATES_CATEGORY["BAKING_BONUSES"] = "baking bonuses";
    METADATA_BALANCE_UPDATES_CATEGORY["BAKING_REWARDS"] = "baking rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["BLOCK_FEES"] = "block fees";
    METADATA_BALANCE_UPDATES_CATEGORY["BONDS"] = "bonds";
    METADATA_BALANCE_UPDATES_CATEGORY["BOOTSTRAP"] = "bootstrap";
    METADATA_BALANCE_UPDATES_CATEGORY["BURNED"] = "burned";
    METADATA_BALANCE_UPDATES_CATEGORY["COMMITMENT"] = "commitment";
    METADATA_BALANCE_UPDATES_CATEGORY["DELEGATE_DENOMINATOR"] = "delegate_denominator";
    METADATA_BALANCE_UPDATES_CATEGORY["DELEGATOR_NUMERATOR"] = "delegator_numerator";
    METADATA_BALANCE_UPDATES_CATEGORY["DEPOSITS"] = "deposits";
    METADATA_BALANCE_UPDATES_CATEGORY["ENDORSING_REWARDS"] = "endorsing rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["INVOICE"] = "invoice";
    METADATA_BALANCE_UPDATES_CATEGORY["LOST_ENDORSING_REWARDS"] = "lost endorsing rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["MINTED"] = "minted";
    METADATA_BALANCE_UPDATES_CATEGORY["NONCE_REVELATION_REWARDS"] = "nonce revelation rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["PUNISHMENTS"] = "punishments";
    METADATA_BALANCE_UPDATES_CATEGORY["SMART_ROLLUP_REFUTATION_PUNISHMENTS"] = "smart_rollup_refutation_punishments";
    METADATA_BALANCE_UPDATES_CATEGORY["SMART_ROLLUP_REFUTATION_REWARDS"] = "smart_rollup_refutation_rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["STORAGE_FEES"] = "storage fees";
    METADATA_BALANCE_UPDATES_CATEGORY["SUBSIDY"] = "subsidy";
    METADATA_BALANCE_UPDATES_CATEGORY["UNSTAKED_DEPOSITS"] = "unstaked_deposits";
})($5db8d2af09626b01$export$a9040e943c00f226 || ($5db8d2af09626b01$export$a9040e943c00f226 = {}));
var $5db8d2af09626b01$export$2506b8b43ba71fde;
(function(PvmKind) {
    PvmKind["WASM2"] = "wasm_2_0_0";
    PvmKind["ARITH"] = "arith";
    PvmKind["RISCV"] = "riscv";
})($5db8d2af09626b01$export$2506b8b43ba71fde || ($5db8d2af09626b01$export$2506b8b43ba71fde = {}));
var $5db8d2af09626b01$export$c6a11810c2696976;
(function(SmartRollupRefutationOptions) {
    SmartRollupRefutationOptions["START"] = "start";
    SmartRollupRefutationOptions["MOVE"] = "move";
})($5db8d2af09626b01$export$c6a11810c2696976 || ($5db8d2af09626b01$export$c6a11810c2696976 = {}));
var $5db8d2af09626b01$export$91a9220bb843dc78;
(function(SmartRollupInputProofKind) {
    SmartRollupInputProofKind["INBOX_PROOF"] = "inbox_proof";
    SmartRollupInputProofKind["REVEAL_PROOF"] = "reveal_proof";
    SmartRollupInputProofKind["FIRST_INPUT"] = "first_input";
})($5db8d2af09626b01$export$91a9220bb843dc78 || ($5db8d2af09626b01$export$91a9220bb843dc78 = {}));
var $5db8d2af09626b01$export$6b51c844e2b0334d;
(function(SmartRollupRefuteRevealProofKind) {
    SmartRollupRefuteRevealProofKind["RAW_DATA_PROOF"] = "raw_data_proof";
    SmartRollupRefuteRevealProofKind["METADATA_PROOF"] = "metadata_proof";
    SmartRollupRefuteRevealProofKind["DAL_PAGE_PROOF"] = "dal_page_proof";
})($5db8d2af09626b01$export$6b51c844e2b0334d || ($5db8d2af09626b01$export$6b51c844e2b0334d = {}));
var $5db8d2af09626b01$export$9326a2a3b9cae4b1;
(function(SmartRollupRefuteGameStatusOptions) {
    SmartRollupRefuteGameStatusOptions["ONGOING"] = "ongoing";
    SmartRollupRefuteGameStatusOptions["ENDED"] = "ended";
})($5db8d2af09626b01$export$9326a2a3b9cae4b1 || ($5db8d2af09626b01$export$9326a2a3b9cae4b1 = {}));
var $5db8d2af09626b01$export$ef2fea9367dd59a2;
(function(SmartRollupRefuteGameEndedPlayerOutcomes) {
    SmartRollupRefuteGameEndedPlayerOutcomes["LOSER"] = "loser";
    SmartRollupRefuteGameEndedPlayerOutcomes["DRAW"] = "draw";
})($5db8d2af09626b01$export$ef2fea9367dd59a2 || ($5db8d2af09626b01$export$ef2fea9367dd59a2 = {}));
var $5db8d2af09626b01$export$e0c6dafa14dbf762;
(function(SmartRollupRefuteGameEndedReason) {
    SmartRollupRefuteGameEndedReason["CONFLICT_RESOLVED"] = "conflict_resolved";
    SmartRollupRefuteGameEndedReason["TIMEOUT"] = "timeout";
})($5db8d2af09626b01$export$e0c6dafa14dbf762 || ($5db8d2af09626b01$export$e0c6dafa14dbf762 = {}));
var $5db8d2af09626b01$export$b64a25b4a099ca08;
(function(OpKind) {
    OpKind["ORIGINATION"] = "origination";
    OpKind["DELEGATION"] = "delegation";
    OpKind["REVEAL"] = "reveal";
    OpKind["TRANSACTION"] = "transaction";
    OpKind["ACTIVATION"] = "activate_account";
    OpKind["ATTESTATION"] = "attestation";
    OpKind["ENDORSEMENT"] = "endorsement";
    OpKind["PREATTESTATION"] = "preattestation";
    OpKind["PREENDORSEMENT"] = "preendorsement";
    OpKind["SET_DEPOSITS_LIMIT"] = "set_deposits_limit";
    OpKind["DOUBLE_PREATTESTATION_EVIDENCE"] = "double_preattestation_evidence";
    OpKind["DOUBLE_PREENDORSEMENT_EVIDENCE"] = "double_preendorsement_evidence";
    OpKind["ATTESTATION_WITH_SLOT"] = "attestation_with_slot";
    OpKind["ENDORSEMENT_WITH_SLOT"] = "endorsement_with_slot";
    OpKind["SEED_NONCE_REVELATION"] = "seed_nonce_revelation";
    OpKind["DOUBLE_ATTESTATION_EVIDENCE"] = "double_attestation_evidence";
    OpKind["DOUBLE_ENDORSEMENT_EVIDENCE"] = "double_endorsement_evidence";
    OpKind["DOUBLE_BAKING_EVIDENCE"] = "double_baking_evidence";
    OpKind["PROPOSALS"] = "proposals";
    OpKind["BALLOT"] = "ballot";
    OpKind["FAILING_NOOP"] = "failing_noop";
    OpKind["REGISTER_GLOBAL_CONSTANT"] = "register_global_constant";
    OpKind["TRANSFER_TICKET"] = "transfer_ticket";
    OpKind["INCREASE_PAID_STORAGE"] = "increase_paid_storage";
    OpKind["UPDATE_CONSENSUS_KEY"] = "update_consensus_key";
    OpKind["DRAIN_DELEGATE"] = "drain_delegate";
    OpKind["VDF_REVELATION"] = "vdf_revelation";
    OpKind["EVENT"] = "event";
    OpKind["TICKET_UPDATES"] = "ticket_updates";
    OpKind["SMART_ROLLUP_ORIGINATE"] = "smart_rollup_originate";
    OpKind["SMART_ROLLUP_ADD_MESSAGES"] = "smart_rollup_add_messages";
    OpKind["SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE"] = "smart_rollup_execute_outbox_message";
    OpKind["SMART_ROLLUP_PUBLISH"] = "smart_rollup_publish";
    OpKind["SMART_ROLLUP_CEMENT"] = "smart_rollup_cement";
    OpKind["SMART_ROLLUP_RECOVER_BOND"] = "smart_rollup_recover_bond";
    OpKind["SMART_ROLLUP_REFUTE"] = "smart_rollup_refute";
    OpKind["SMART_ROLLUP_TIMEOUT"] = "smart_rollup_timeout";
})($5db8d2af09626b01$export$b64a25b4a099ca08 || ($5db8d2af09626b01$export$b64a25b4a099ca08 = {}));
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $5db8d2af09626b01$export$a4ad2735b021c132 = {
    "commitHash": "2e05f6f865be17a1b367b284542b24ffa9823271",
    "version": "19.2.1"
};
/***
 * @description RpcClient allows interaction with Tezos network through an rpc node
 */ class $5db8d2af09626b01$export$60aeb6b70d862cfd {
    /**
     *
     * @param url rpc root url
     * @param chain chain (default main)
     * @param httpBackend Http backend that issue http request.
     * You can override it by providing your own if you which to hook in the request/response
     *
     * @example new RpcClient('https://mainnet.ecadinfra.com/', 'main') this will use https://mainnet.ecadinfra.com//chains/main
     */ constructor(url, chain = $5db8d2af09626b01$export$df531a306ef6bb82, httpBackend = new (0, $e7f526111d047632$export$aac4ca225fe02187)()){
        this.url = url;
        this.chain = chain;
        this.httpBackend = httpBackend;
    }
    createURL(path) {
        // Trim trailing slashes because it is assumed to be included in path
        // the regex solution is prone to ReDoS. Please see: https://stackoverflow.com/questions/6680825/return-string-without-trailing-slash#comment124306698_6680877
        // We also got a CodeQL error for the regex based solution
        let rootUrl = this.url;
        while(rootUrl.endsWith('/'))rootUrl = rootUrl.slice(0, -1);
        return `${rootUrl}${path}`;
    }
    validateAddress(address) {
        const addressValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(address);
        if (addressValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(address, (0, $201657d342d01b1b$export$a2057601792df650)(addressValidation));
    }
    validateContract(address) {
        const addressValidation = (0, $201657d342d01b1b$export$2ed905adbd9a56f2)(address);
        if (addressValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$193774326795229b)(address, (0, $201657d342d01b1b$export$a2057601792df650)(addressValidation));
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Get the block's hash, its unique identifier.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-hash
     */ getBlockHash({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const hash = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/hash`),
                method: 'GET'
            });
            return hash;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List the ancestors of the given block which, if referred to as the branch in an operation header, are recent enough for that operation to be included in the current block.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-live-blocks
     */ getLiveBlocks({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const blocks = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/live_blocks`),
                method: 'GET'
            });
            return blocks;
        });
    }
    /**
     * @param address address from which we want to retrieve the balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the spendable balance of a contract, excluding frozen bonds
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-balance
     */ getBalance(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            const balance = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/balance`),
                method: 'GET'
            });
            return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(balance);
        });
    }
    /**
     * @param address contract address from which we want to retrieve the storage
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the data of the contract.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-storage
     */ getStorage(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateContract(address);
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/storage`),
                method: 'GET'
            });
        });
    }
    /**
     * @param address contract address from which we want to retrieve the script
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the code and data of the contract.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-script
     */ getScript(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateContract(address);
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/script`),
                method: 'GET'
            });
        });
    }
    /**
     * @param address contract address from which we want to retrieve the script
     * @param unparsingMode default is { unparsing_mode: "Readable" }
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the script of the contract and normalize it using the requested unparsing mode.
     */ getNormalizedScript(address, unparsingMode = {
        unparsing_mode: 'Readable'
    }, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateContract(address);
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/script/normalized`),
                method: 'POST'
            }, unparsingMode);
        });
    }
    /**
     * @param address contract address from which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the complete status of a contract.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id
     */ getContract(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            const contractResponse = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}`),
                method: 'GET'
            });
            return Object.assign(Object.assign({}, contractResponse), {
                balance: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(contractResponse.balance)
            });
        });
    }
    /**
     * @param address contract address from which we want to retrieve the manager
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the manager of an implicit contract
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-manager-key
     */ getManagerKey(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/manager_key`),
                method: 'GET'
            });
        });
    }
    /**
     * @param address contract address from which we want to retrieve the delegate (baker)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the delegate of a contract, if any
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-delegate
     */ getDelegate(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            let delegate;
            try {
                delegate = yield this.httpBackend.createRequest({
                    url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/delegate`),
                    method: 'GET'
                });
            } catch (ex) {
                if (ex instanceof (0, $e7f526111d047632$export$d2f2761cbe9cebf2) && ex.status === (0, $e7f526111d047632$export$bc3aa03eb4b395cf).NOT_FOUND) delegate = null;
                else throw ex;
            }
            return delegate;
        });
    }
    /**
     * @deprecated Deprecated in favor of getBigMapKeyByID
     * @param address contract address from which we want to retrieve the big map key
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the value associated with a key in the big map storage of the contract.
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-context-contracts-contract-id-big-map-get
     */ getBigMapKey(address, key, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/big_map_get`),
                method: 'POST'
            }, key);
        });
    }
    /**
     * @param id Big Map ID
     * @param expr Expression hash to query (A b58check encoded Blake2b hash of the expression (The expression can be packed using the pack_data method))
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the value associated with a key in a big map.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-big-maps-big-map-id-script-expr
     */ getBigMapExpr(id, expr, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/big_maps/${id}/${expr}`),
                method: 'GET'
            });
        });
    }
    /**
     * @param address delegate address which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Everything about a delegate
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-delegates-pkh
     */ getDelegates(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/delegates/${address}`),
                method: 'GET'
            });
            const castedResponse = $5db8d2af09626b01$export$ef5b1cb6f241eca7(response, [
                'balance',
                'full_balance',
                'current_frozen_deposits',
                'frozen_deposits',
                'frozen_balance',
                'frozen_deposits_limit',
                'staking_balance',
                'delegated_balance',
                'voting_power',
                'total_delegated_stake',
                'staking_denominator'
            ]);
            return Object.assign(Object.assign(Object.assign({}, response), castedResponse), {
                frozen_balance_by_cycle: response.frozen_balance_by_cycle ? response.frozen_balance_by_cycle.map((_a)=>{
                    var { deposit: deposit, deposits: deposits, fees: fees, rewards: rewards } = _a, rest = $5db8d2af09626b01$var$__rest(_a, [
                        "deposit",
                        "deposits",
                        "fees",
                        "rewards"
                    ]);
                    const castedToBigNumber = $5db8d2af09626b01$export$ef5b1cb6f241eca7({
                        deposit: deposit,
                        deposits: deposits,
                        fees: fees,
                        rewards: rewards
                    }, [
                        'deposit',
                        'deposits',
                        'fees',
                        'rewards'
                    ]);
                    return Object.assign(Object.assign({}, rest), {
                        deposit: castedToBigNumber.deposit,
                        deposits: castedToBigNumber.deposits,
                        fees: castedToBigNumber.fees,
                        rewards: castedToBigNumber.rewards
                    });
                }) : undefined
            });
        });
    }
    /**
     * @param address delegate address which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the delegate info (e.g. voting power) found in the listings of the current voting period
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-delegates-pkh-voting-info
     */ getVotingInfo(address, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateAddress(address);
            return yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/delegates/${address}/voting_info`),
                method: 'GET'
            });
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description All constants
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-constants
     */ getConstants({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/constants`),
                method: 'GET'
            });
            const castedResponse = $5db8d2af09626b01$export$ef5b1cb6f241eca7(response, [
                'time_between_blocks',
                'hard_gas_limit_per_operation',
                'hard_gas_limit_per_block',
                'proof_of_work_threshold',
                'tokens_per_roll',
                'seed_nonce_revelation_tip',
                'block_security_deposit',
                'endorsement_security_deposit',
                'block_reward',
                'endorsement_reward',
                'cost_per_byte',
                'hard_storage_limit_per_operation',
                'test_chain_duration',
                'baking_reward_per_endorsement',
                'delay_per_missing_endorsement',
                'minimal_block_delay',
                'liquidity_baking_subsidy',
                'cache_layout',
                'baking_reward_fixed_portion',
                'baking_reward_bonus_per_slot',
                'endorsing_reward_per_slot',
                'double_baking_punishment',
                'delay_increment_per_round',
                'tx_rollup_commitment_bond',
                'vdf_difficulty',
                'sc_rollup_stake_amount',
                'minimal_stake'
            ]);
            return Object.assign(Object.assign({}, response), castedResponse);
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head) and version.
     * @description All the information about a block
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id
     * @example getBlock() will default to `/main/chains/block/head?version=0` which shows { kind: endorsement }
     * @example getBlock({ block: 'head~2', version: 1 }) will return an offset of 2 from head blocks and shows { kind: attestation }
     * @example getBlock({ block: 'BL8fTiWcSxWCjiMVnDkbh6EuhqVPZzgWheJ2dqwrxYRm9AephXh~2' }) will return an offset of 2 blocks from given block hash..
     */ getBlock({ block: block, version: version } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const requestOptions = {
                url: this.createURL(`/chains/${this.chain}/blocks/${block}`),
                method: 'GET'
            };
            if (version !== undefined) requestOptions.query = {
                version: version
            };
            return yield this.httpBackend.createRequest(requestOptions);
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The whole block header
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-header
     */ getBlockHeader({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/header`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head) and version
     * @description All the metadata associated to the block
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-metadata
     */ getBlockMetadata({ block: block, version: version } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const requestOptions = {
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/metadata`),
                method: 'GET'
            };
            if (version !== undefined) requestOptions.query = {
                version: version
            };
            return yield this.httpBackend.createRequest(requestOptions);
        });
    }
    /**
     * @param args contains optional query arguments (level, cycle, delegate, consensus_key, and max_round)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Retrieves the list of delegates allowed to bake a block.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-helpers-baking-rights
     */ getBakingRights(args = {}, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/baking_rights`),
                method: 'GET',
                query: args
            });
            return response;
        });
    }
    /**
     * @param args contains optional query arguments (level, cycle, delegate, and consensus_key)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Retrieves the delegates allowed to attest a block
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-helpers-endorsing-rights
     */ getAttestationRights(args = {}, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/attestation_rights`),
                method: 'GET',
                query: args
            });
            return response;
        });
    }
    /**
     * @deprecated Deprecated in favor of getAttestationRights
     * @param args contains optional query arguments (level, cycle, delegate, and consensus_key)
     * @param options contains generic configuration for rpc calls
     * @description Retrieves the delegates allowed to endorse a block
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-helpers-endorsing-rights
     */ getEndorsingRights(args = {}, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/endorsing_rights`),
                method: 'GET',
                query: args
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Ballots casted so far during a voting period
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-ballot-list
     */ getBallotList({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/ballot_list`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Sum of ballots casted so far during a voting period
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-ballots
     */ getBallots({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/ballots`),
                method: 'GET'
            });
            const casted = $5db8d2af09626b01$export$ef5b1cb6f241eca7(response, [
                'yay',
                'nay',
                'pass'
            ]);
            return casted;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Current proposal under evaluation.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-current-proposal
     */ getCurrentProposal({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/current_proposal`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Current expected quorum.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-current-quorum
     */ getCurrentQuorum({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/current_quorum`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List of delegates with their voting power
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-listings
     */ getVotesListings({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/listings`),
                method: 'GET'
            });
            response.map((item)=>{
                if (item.voting_power) item.voting_power = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(item.voting_power);
                return item;
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List of proposals with number of supporters
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-proposals
     */ getProposals({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/proposals`),
                method: 'GET'
            });
            response.map((item)=>{
                return item[1] = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(item[1]);
            });
            return response;
        });
    }
    /**
     * @param data operation contents to forge
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Forge an operation returning the unsigned bytes
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-helpers-forge-operations
     */ forgeOperations(data, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/forge/operations`),
                method: 'POST'
            }, data);
        });
    }
    /**
     * @param signedOpBytes signed bytes to inject
     * @description Inject an operation in node and broadcast it and return the ID of the operation
     * @see https://tezos.gitlab.io/api/rpc.html#post-injection-operation
     */ injectOperation(signedOpBytes) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/injection/operation`),
                method: 'POST'
            }, signedOpBytes);
        });
    }
    /**
     * @param ops Operations to apply
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Simulate the application of the operations with the context of the given block and return the result of each operation application
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-helpers-preapply-operations
     */ preapplyOperations(ops, { block: block, version: version } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const requestOptions = {
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/preapply/operations`),
                method: 'POST'
            };
            if (version !== undefined) requestOptions.query = {
                version: version
            };
            return yield this.httpBackend.createRequest(requestOptions, ops);
        });
    }
    /**
     * @param contract address of the contract we want to get the entrypoints of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Return the list of entrypoints of the contract
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-entrypoints
     * @version 005_PsBABY5H
     */ getEntrypoints(contract, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            this.validateContract(contract);
            const contractResponse = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/entrypoints`),
                method: 'GET'
            });
            return contractResponse;
        });
    }
    /**
     * @deprecated Deprecated in favor of simulateOperation
     * @param op Operation to run
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Run an operation with the context of the given block and without signature checks and return the operation application result, including the consumed gas.
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-helpers-scripts-run-operation
     */ runOperation(op, { block: block, version: version } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const requestOptions = {
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/run_operation`),
                method: 'POST'
            };
            if (version !== undefined) requestOptions.query = {
                version: version
            };
            return yield this.httpBackend.createRequest(requestOptions, op);
        });
    }
    /**
     * @param op Operation to simulate
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Simulate running an operation at some future moment (based on the number of blocks given in the `latency` argument), and return the operation application result.
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/oxford-openapi.json
     */ simulateOperation(op, { block: block, version: version } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const requestOptions = {
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/simulate_operation`),
                method: 'POST'
            };
            if (version !== undefined) requestOptions.query = {
                version: version
            };
            return yield this.httpBackend.createRequest(requestOptions, op);
        });
    }
    /**
     * @param code Code to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Run a Michelson script in the current context
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-helpers-scripts-run-code
     */ runCode(code, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/run_code`),
                method: 'POST'
            }, code);
            return response;
        });
    }
    /**
     * @param viewScriptParams Parameters of the script view to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Simulate a call to a michelson view
     */ runScriptView(_a, _b) {
        var { unparsing_mode: unparsing_mode = 'Readable' } = _a, rest = $5db8d2af09626b01$var$__rest(_a, [
            "unparsing_mode"
        ]);
        var _c = _b === void 0 ? $5db8d2af09626b01$export$20a0ad8102085d6c : _b, block = _c.block;
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/run_script_view`),
                method: 'POST'
            }, Object.assign({
                unparsing_mode: unparsing_mode
            }, rest));
        });
    }
    /**
     * @param viewParams Parameters of the view to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Simulate a call to a view following the TZIP-4 standard. See https://gitlab.com/tzip/tzip/-/blob/master/proposals/tzip-4/tzip-4.md#view-entrypoints.
     */ runView(_a, _b) {
        var { unparsing_mode: unparsing_mode = 'Readable' } = _a, rest = $5db8d2af09626b01$var$__rest(_a, [
            "unparsing_mode"
        ]);
        var _c = _b === void 0 ? $5db8d2af09626b01$export$20a0ad8102085d6c : _b, block = _c.block;
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/run_view`),
                method: 'POST'
            }, Object.assign({
                unparsing_mode: unparsing_mode
            }, rest));
        });
    }
    getChainId() {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/chain_id`),
                method: 'GET'
            });
        });
    }
    /**
     * @param data Data to pack
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Computes the serialized version of a data expression using the same algorithm as script instruction PACK
     * Note: You should always verify the packed bytes before signing or requesting that they be signed when using the RPC to pack.
     * This precaution helps protect you and your applications users from RPC nodes that have been compromised.
     * A node that is operated by a bad actor, or compromised by a bad actor could return a fully formed operation that does not correspond to the input provided to the RPC endpoint.
     * A safer solution to pack and sign data would be to use the `packDataBytes` function available in the `@taquito/michel-codec` package.
     * @example packData({ data: { string: "test" }, type: { prim: "string" } })
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-helpers-scripts-pack-data
     */ packData(data, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const _a = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/pack_data`),
                method: 'POST'
            }, data), { gas: gas } = _a, rest = $5db8d2af09626b01$var$__rest(_a, [
                "gas"
            ]);
            let formattedGas = gas;
            const tryBigNumber = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(gas || '');
            if (!tryBigNumber.isNaN()) formattedGas = tryBigNumber;
            return Object.assign({
                gas: formattedGas
            }, rest);
        });
    }
    /**
     *
     * @description Return rpc root url
     */ getRpcUrl() {
        return this.url;
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the voting period (index, kind, starting position) and related information (position, remaining) of the interrogated block
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-current-period
     */ getCurrentPeriod({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/current_period`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the voting period (index, kind, starting position) and related information (position, remaining) of the next block.Useful to craft operations that will be valid in the next block
     * @example getSuccessorPeriod() will default to successor voting period for /main/chains/block/head.
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-votes-successor-period
     */ getSuccessorPeriod({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/successor_period`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param id Sapling state ID
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the root and a diff of a state starting from an optional offset which is zero by default
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-sapling-sapling-state-id-get-diff
     */ getSaplingDiffById(id, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/sapling/${id}/get_diff`),
                method: 'GET'
            });
        });
    }
    /**
     * @param contract address of the contract we want to get the sapling diff
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the root and a diff of a state starting from an optional offset which is zero by default
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-single-sapling-get-diff
     */ getSaplingDiffByContract(contract, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/single_sapling_get_diff`),
                method: 'GET'
            });
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description get current and next protocol
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-protocols
     */ getProtocols({ block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/protocols`),
                method: 'GET'
            });
        });
    }
    /**
     * @param contract address of the contract we want to retrieve storage information of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the used storage space of the contract
     * @see https://tezos.gitlab.io/lima/rpc.html#get-block-id-context-contracts-contract-id-storage
     */ getStorageUsedSpace(contract, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/storage/used_space`),
                method: 'GET'
            });
        });
    }
    /**
     * @param contract address of the contract we want to retrieve storage information of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
  =   * @description Access the paid storage space of the contract
     * @see https://tezos.gitlab.io/lima/rpc.html#get-block-id-context-contracts-contract-id-storage
     */ getStoragePaidSpace(contract, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/storage/paid_space`),
                method: 'GET'
            });
        });
    }
    /**
     * @param contract implicit or originated address we want to retrieve ticket balance of
     * @param ticket object to specify a ticket by ticketer, content type and content
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the contract's balance of ticket with specified ticketer, content type, and content.
     * @example ticket { ticketer: 'address', content_type: { prim: "string" }, content: { string: 'ticket1' } }
     * @see https://tezos.gitlab.io/protocols/016_mumbai.html#rpc-changes
     */ getTicketBalance(contract, ticket, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/ticket_balance`),
                method: 'POST'
            }, ticket);
        });
    }
    /**
     * @param contract originated address we want to retrieve ticket balances of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the complete list of tickets owned by the given contract by scanning the contract's storage.
     * @see https://tezos.gitlab.io/protocols/016_mumbai.html#rpc-changes
     */ getAllTicketBalances(contract, { block: block } = $5db8d2af09626b01$export$20a0ad8102085d6c) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/all_ticket_balances`),
                method: 'GET'
            });
        });
    }
    /**
     * @description List the prevalidated operations in mempool (accessibility of mempool depends on each rpc endpoint)
     * @param args has 5 optional properties. We support version 1 as default will output { applied: { kind: endorsement} } version 2 will output { validated: { kind: attestation} }. The rest of the properties is to filter pending operations response
     * @default args { version: '1', applied: true, refused: true, outdated, true, branchRefused: true, branchDelayed: true, validationPass: undefined }
     * @see https://tezos.gitlab.io/CHANGES.html?highlight=pending_operations#id4
     */ getPendingOperations(args = {}) {
        return $5db8d2af09626b01$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/mempool/pending_operations`),
                method: 'GET',
                query: args
            });
        });
    }
}




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $702e4d306615a028$var$extendStatics = function(d, b) {
    $702e4d306615a028$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $702e4d306615a028$var$extendStatics(d, b);
};
function $702e4d306615a028$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $702e4d306615a028$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $702e4d306615a028$export$18ce0697a983be9b = function() {
    $702e4d306615a028$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $702e4d306615a028$export$18ce0697a983be9b.apply(this, arguments);
};
function $702e4d306615a028$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $702e4d306615a028$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $702e4d306615a028$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $702e4d306615a028$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $702e4d306615a028$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $702e4d306615a028$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $702e4d306615a028$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $702e4d306615a028$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $702e4d306615a028$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $702e4d306615a028$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $702e4d306615a028$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $702e4d306615a028$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $702e4d306615a028$export$45d3717a4c69092e(o, m, p);
}
function $702e4d306615a028$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $702e4d306615a028$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $702e4d306615a028$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($702e4d306615a028$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $702e4d306615a028$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $702e4d306615a028$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $702e4d306615a028$export$10c90e4f7922046c(v) {
    return this instanceof $702e4d306615a028$export$10c90e4f7922046c ? (this.v = v, this) : new $702e4d306615a028$export$10c90e4f7922046c(v);
}
function $702e4d306615a028$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $702e4d306615a028$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $702e4d306615a028$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $702e4d306615a028$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $702e4d306615a028$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $702e4d306615a028$export$19a8beecd37a4c45 === "function" ? $702e4d306615a028$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $702e4d306615a028$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $702e4d306615a028$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $702e4d306615a028$var$ownKeys = function(o) {
    $702e4d306615a028$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $702e4d306615a028$var$ownKeys(o);
};
function $702e4d306615a028$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $702e4d306615a028$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $702e4d306615a028$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $702e4d306615a028$var$__setModuleDefault(result, mod);
    return result;
}
function $702e4d306615a028$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $702e4d306615a028$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $702e4d306615a028$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $702e4d306615a028$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $702e4d306615a028$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $702e4d306615a028$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $702e4d306615a028$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $702e4d306615a028$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $702e4d306615a028$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $702e4d306615a028$export$2e2bcd8739ae039 = {
    __extends: $702e4d306615a028$export$a8ba968b8961cb8a,
    __assign: $702e4d306615a028$export$18ce0697a983be9b,
    __rest: $702e4d306615a028$export$3c9a16f847548506,
    __decorate: $702e4d306615a028$export$29e00dfd3077644b,
    __param: $702e4d306615a028$export$d5ad3fd78186038f,
    __esDecorate: $702e4d306615a028$export$3a84e1ae4e97e9b0,
    __runInitializers: $702e4d306615a028$export$d831c04e792af3d,
    __propKey: $702e4d306615a028$export$6a2a36740a146cb8,
    __setFunctionName: $702e4d306615a028$export$d1a06452d3489bc7,
    __metadata: $702e4d306615a028$export$f1db080c865becb9,
    __awaiter: $702e4d306615a028$export$1050f835b63b671e,
    __generator: $702e4d306615a028$export$67ebef60e6f28a6,
    __createBinding: $702e4d306615a028$export$45d3717a4c69092e,
    __exportStar: $702e4d306615a028$export$f33643c0debef087,
    __values: $702e4d306615a028$export$19a8beecd37a4c45,
    __read: $702e4d306615a028$export$8d051b38c9118094,
    __spread: $702e4d306615a028$export$afc72e2116322959,
    __spreadArrays: $702e4d306615a028$export$6388937ca91ccae8,
    __spreadArray: $702e4d306615a028$export$1216008129fb82ed,
    __await: $702e4d306615a028$export$10c90e4f7922046c,
    __asyncGenerator: $702e4d306615a028$export$e427f37a30a4de9b,
    __asyncDelegator: $702e4d306615a028$export$bbd80228419bb833,
    __asyncValues: $702e4d306615a028$export$e3b29a3d6162315f,
    __makeTemplateObject: $702e4d306615a028$export$4fb47efe1390b86f,
    __importStar: $702e4d306615a028$export$c21735bcef00d192,
    __importDefault: $702e4d306615a028$export$da59b14a69baef04,
    __classPrivateFieldGet: $702e4d306615a028$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $702e4d306615a028$export$d40a35129aaff81f,
    __classPrivateFieldIn: $702e4d306615a028$export$81fdc39f203e4e04,
    __addDisposableResource: $702e4d306615a028$export$88ac25d8e944e405,
    __disposeResources: $702e4d306615a028$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $702e4d306615a028$export$889dfb5d17574b0b
};




function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}




function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});


function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34)) errors = (0, $702e4d306615a028$export$1216008129fb82ed)((0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(errors)), (0, $702e4d306615a028$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f587043ffd615a90$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && 'closed' in value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.remove) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.add) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $528e75db69787807$export$8793edee2d425525() {}


var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}


var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8343668acd7c4a9b$export$f55210826850c514));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $92213d3dd6a83b5d$export$3e205fbb5df021e0)(error);
    else (0, $18eb28ff53cc4943$export$ebf645db02d3e99f)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $528e75db69787807$export$8793edee2d425525),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $528e75db69787807$export$8793edee2d425525)
};



var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();


function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}


function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7569c528cdd9d182$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0f1e8e2d1fe93adf$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.next) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.error) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $cf8ce74b80455e9f$export$60959659b2c22881) || $4f562137a990678a$var$isObserver(value) && (0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(value);
}




var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});




var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $43504509ae7aa03d$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $4f562137a990678a$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);


var $7aced346698c521d$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038));


var $93f4d2c1cc93ee63$var$isArray = Array.isArray;
var $93f4d2c1cc93ee63$var$getPrototypeOf = Object.getPrototypeOf, $93f4d2c1cc93ee63$var$objectProto = Object.prototype, $93f4d2c1cc93ee63$var$getKeys = Object.keys;
function $93f4d2c1cc93ee63$export$8871b3799a14360f(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if ($93f4d2c1cc93ee63$var$isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if ($93f4d2c1cc93ee63$var$isPOJO(first_1)) {
            var keys = $93f4d2c1cc93ee63$var$getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function $93f4d2c1cc93ee63$var$isPOJO(obj) {
    return obj && typeof obj === 'object' && $93f4d2c1cc93ee63$var$getPrototypeOf(obj) === $93f4d2c1cc93ee63$var$objectProto;
}



var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};



function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]);
}



function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();



function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]);
}




function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $702e4d306615a028$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $702e4d306615a028$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $702e4d306615a028$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $702e4d306615a028$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $702e4d306615a028$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $4f562137a990678a$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]();
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $18eb28ff53cc4943$export$ebf645db02d3e99f));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $54b99b9095e84ce4$export$cf4785e597badab3)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $702e4d306615a028$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $702e4d306615a028$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $702e4d306615a028$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}


function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}



function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}




function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $cf8ce74b80455e9f$export$60959659b2c22881));


function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}





function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}



function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)((0, $54b99b9095e84ce4$export$cf4785e597badab3)(input), scheduler);
}


function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return (0, $e3a1d71c442b5de9$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return (0, $0ce5b91768be0a6d$export$b34673931371729a)(input, scheduler);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return (0, $7ea29ae5d684fb04$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return (0, $3a22bf76b9b6de63$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return (0, $7999ea1c5b71ad25$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}



function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $8f2bbfa9b5105688$export$49c44dfc2bb21d70)(input, scheduler) : (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input);
}






function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}


var $e6cd63efe08c02de$var$isArray = Array.isArray;
function $e6cd63efe08c02de$var$callOrApply(fn, args) {
    return $e6cd63efe08c02de$var$isArray(args) ? fn.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(args))) : fn(args);
}
function $e6cd63efe08c02de$export$559affaa48f4288d(fn) {
    return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(args) {
        return $e6cd63efe08c02de$var$callOrApply(fn, args);
    });
}




function $cd8e5ea142a386bd$export$187e35932e88c15c(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.schedule);
}


function $3b29c258456d9a89$var$last(arr) {
    return arr[arr.length - 1];
}
function $3b29c258456d9a89$export$9ae19b645239a61b(args) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$29534b2f653ae592(args) {
    return (0, $cd8e5ea142a386bd$export$187e35932e88c15c)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $3b29c258456d9a89$var$last(args) === 'number' ? args.pop() : defaultValue;
}


function $00d6f9870244ce2a$export$79c7e160a7743efd(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}




function $0e8b72f41887b114$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    var resultSelector = (0, $3b29c258456d9a89$export$9ae19b645239a61b)(args);
    var _a = (0, $93f4d2c1cc93ee63$export$8871b3799a14360f)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, $2fe2b696577919a5$export$6788812c4e6611e6)([], scheduler);
    var result = new (0, $4f562137a990678a$export$77cea355fa80b5f4)($0e8b72f41887b114$export$f04dcfb475ed2128(observables, scheduler, keys ? function(values) {
        return (0, $00d6f9870244ce2a$export$79c7e160a7743efd)(keys, values);
    } : (0, $7569c528cdd9d182$export$f0954fd7d5368655)));
    return resultSelector ? result.pipe((0, $e6cd63efe08c02de$export$559affaa48f4288d)(resultSelector)) : result;
}
function $0e8b72f41887b114$export$f04dcfb475ed2128(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, $7569c528cdd9d182$export$f0954fd7d5368655);
    return function(subscriber) {
        $0e8b72f41887b114$var$maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                $0e8b72f41887b114$var$maybeSchedule(scheduler, function() {
                    var source = (0, $2fe2b696577919a5$export$6788812c4e6611e6)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function $0e8b72f41887b114$var$maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscription, scheduler, execute);
    else execute();
}







function $9cbbbba4f565a378$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $46964ba1b403cbfc$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(resultSelector)) return $46964ba1b403cbfc$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        return (0, $9cbbbba4f565a378$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}



function $4707859e785b3da6$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)((0, $7569c528cdd9d182$export$f0954fd7d5368655), concurrent);
}


function $3a4e37c3b56570cb$export$b314777ae20abca9() {
    return (0, $4707859e785b3da6$export$18aef43295bbe906)(1);
}




function $82eda875fdd470db$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $3a4e37c3b56570cb$export$b314777ae20abca9)()((0, $2fe2b696577919a5$export$6788812c4e6611e6)(args, (0, $3b29c258456d9a89$export$29534b2f653ae592)(args)));
}



function $8312939aeeb1a4f7$export$260e5c0943f31606(observableFactory) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(observableFactory()).subscribe(subscriber);
    });
}


var $8faf6f2806f38bc2$export$ccb33e29d92c9a58 = new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $8faf6f2806f38bc2$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $8faf6f2806f38bc2$var$emptyScheduled(scheduler) : $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
}
function $8faf6f2806f38bc2$var$emptyScheduled(scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}



var $29707ec27f94d999$export$96c94437c95d7862 = new (0, $4f562137a990678a$export$77cea355fa80b5f4)((0, $528e75db69787807$export$8793edee2d425525));
function $29707ec27f94d999$export$b3e22bcfd64c1022() {
    return $29707ec27f94d999$export$96c94437c95d7862;
}



function $195e3b3043565ec4$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(args, scheduler);
}



function $48a6b248e7e71175$export$d02631cccf789723(start, count, scheduler) {
    if (count == null) {
        count = start;
        start = 0;
    }
    if (count <= 0) return 0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
    var end = count + start;
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(scheduler ? function(subscriber) {
        var n = start;
        return scheduler.schedule(function() {
            if (n < end) {
                subscriber.next(n++);
                this.schedule();
            } else subscriber.complete();
        });
    } : function(subscriber) {
        var n = start;
        while(n < end && !subscriber.closed)subscriber.next(n++);
        subscriber.complete();
    });
}



var $94bcb2181a19339b$export$c1895ea2d519a677 = {
    now: function() {
        return ($94bcb2181a19339b$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $4a1890c700519557$export$915d2682b0aa0991 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $94bcb2181a19339b$export$c1895ea2d519a677);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038));



function $8250ab9260498953$export$8bf7aba4a9e09055(errorOrErrorFactory, scheduler) {
    var errorFactory = (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(errorOrErrorFactory) ? errorOrErrorFactory : function() {
        return errorOrErrorFactory;
    };
    var init = function(subscriber) {
        return subscriber.error(errorFactory());
    };
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(scheduler ? function(subscriber) {
        return scheduler.schedule(init, 0, subscriber);
    } : init);
}





var $25237a26c7d2a6e0$export$e19cd5f9376f8cee = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $8343668acd7c4a9b$export$f55210826850c514));



var $7031d5c115ea3033$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $7031d5c115ea3033$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
        return setInterval.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $7031d5c115ea3033$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};



var $d97bc7fc19653fdc$export$b5369ffd7cb2211b = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $7031d5c115ea3033$export$f0ca5e16f6f68711).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $7031d5c115ea3033$export$f0ca5e16f6f68711).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $25237a26c7d2a6e0$export$e19cd5f9376f8cee));




var $35afd13d3a3f6ae1$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $94bcb2181a19339b$export$c1895ea2d519a677).now;
    return Scheduler;
}();


var $5aa4ef89729a15e9$export$4114a3ec92faa3c6 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $35afd13d3a3f6ae1$export$d3e54bb8584cda7c).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $35afd13d3a3f6ae1$export$d3e54bb8584cda7c));


var $2b2c2daf44a1044e$export$8d6b71a2b178fc32 = new (0, $5aa4ef89729a15e9$export$4114a3ec92faa3c6)((0, $d97bc7fc19653fdc$export$b5369ffd7cb2211b));
var $2b2c2daf44a1044e$export$12af436354f1a4f7 = $2b2c2daf44a1044e$export$8d6b71a2b178fc32;



function $3f3032e6ea410a39$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}


function $bce9e90ba9895d75$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $2b2c2daf44a1044e$export$12af436354f1a4f7);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $cd8e5ea142a386bd$export$187e35932e88c15c)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var due = (0, $3f3032e6ea410a39$export$c03bb0116ee09d4b)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}





function $b910c27483c6e6a0$export$3dede90624df3ba9(selector) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(selector(err, $b910c27483c6e6a0$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}



function $9ee54e147202c320$export$c28c8388be0ab31a(project, resultSelector) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(resultSelector) ? (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)(project, resultSelector, 1) : (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)(project, 1);
}




function $6fb8b1c12553edae$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $7569c528cdd9d182$export$f0954fd7d5368655);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $6fb8b1c12553edae$var$defaultCompare;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $6fb8b1c12553edae$var$defaultCompare(a, b) {
    return a === b;
}


function $5b7702bd13db251d$export$571da16e28367bde(key, compare) {
    return (0, $6fb8b1c12553edae$export$779c5fb865a0172e)(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}




function $f8cf36c2ee00b02d$export$23c7d6c8dcd743fe() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return function(source) {
        return (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(source, (0, $195e3b3043565ec4$export$ba255e9e49e00608).apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(values))));
    };
}



function $98aaadcfa91e6727$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}


var $6cabd83f99ce6113$export$78f6d1b1dbcda304 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});






function $e53e80f9042754be$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
    } : (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}




function $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b(defaultValue) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}





function $8c2c9c105ebfd25b$export$c8ea5e9f84346833(errorFactory) {
    if (errorFactory === void 0) errorFactory = $8c2c9c105ebfd25b$var$defaultErrorFactory;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
function $8c2c9c105ebfd25b$var$defaultErrorFactory() {
    return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
}



function $b9a90ca4d933af63$export$43128fadae87b74a(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, $7569c528cdd9d182$export$f0954fd7d5368655), (0, $e53e80f9042754be$export$b7df5d561049483a)(1), hasDefaultValue ? (0, $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b)(defaultValue) : (0, $8c2c9c105ebfd25b$export$c8ea5e9f84346833)(function() {
            return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
        }));
    };
}


function $4be1a9d761a9d3e3$export$c44985b87d605eff() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error('list of properties cannot be empty.');
    return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
            if (typeof p !== 'undefined') currentProp = p;
            else return undefined;
        }
        return currentProp;
    });
}







function $0a82afceb3f717e3$export$18d0766d894cba0c() {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var connection = null;
        source._refCount++;
        var refCounter = (0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, undefined, undefined, undefined, function() {
            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
                connection = null;
                return;
            }
            var sharedConnection = source._connection;
            var conn = connection;
            connection = null;
            if (sharedConnection && (!conn || sharedConnection === conn)) sharedConnection.unsubscribe();
            subscriber.unsubscribe();
        });
        source.subscribe(refCounter);
        if (!refCounter.closed) connection = source.connect();
    });
}




var $822a6f5e2267cfc3$export$9038dea0172d3ba9 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._subject = null;
        _this._refCount = 0;
        _this._connection = null;
        if ((0, $992c4a42843eb1d0$export$ebec8610810318c5)(source)) _this.lift = source.lift;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype._teardown = function() {
        this._refCount = 0;
        var _connection = this._connection;
        this._subject = this._connection = null;
        _connection === null || _connection === void 0 || _connection.unsubscribe();
    };
    ConnectableObservable.prototype.connect = function() {
        var _this = this;
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new (0, $8343668acd7c4a9b$export$f55210826850c514)();
            var subject_1 = this.getSubject();
            connection.add(this.source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subject_1, undefined, function() {
                _this._teardown();
                subject_1.complete();
            }, function(err) {
                _this._teardown();
                subject_1.error(err);
            }, function() {
                return _this._teardown();
            })));
            if (connection.closed) {
                this._connection = null;
                connection = (0, $8343668acd7c4a9b$export$f55210826850c514).EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return (0, $0a82afceb3f717e3$export$18d0766d894cba0c)()(this);
    };
    return ConnectableObservable;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));







function $fc2a12698404757c$export$86a55c2f04dd8842(subscribable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        return subscribable.subscribe(subscriber);
    });
}


var $fce5886f151ea80b$var$DEFAULT_CONFIG = {
    connector: function() {
        return new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    }
};
function $fce5886f151ea80b$export$64605811ab45167f(selector, config) {
    if (config === void 0) config = $fce5886f151ea80b$var$DEFAULT_CONFIG;
    var connector = config.connector;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var subject = connector();
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(selector((0, $fc2a12698404757c$export$86a55c2f04dd8842)(subject))).subscribe(subscriber);
        subscriber.add(source.subscribe(subject));
    });
}


function $6ea7c671d75007cb$export$1364843af8d5a963(subjectOrSubjectFactory, selector) {
    var subjectFactory = (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function() {
        return subjectOrSubjectFactory;
    };
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(selector)) return (0, $fce5886f151ea80b$export$64605811ab45167f)(selector, {
        connector: subjectFactory
    });
    return function(source) {
        return new (0, $822a6f5e2267cfc3$export$9038dea0172d3ba9)(source, subjectFactory);
    };
}



function $dc522c7fdf273a70$export$89b472e03be495df(selector) {
    return selector ? function(source) {
        return (0, $fce5886f151ea80b$export$64605811ab45167f)(selector)(source);
    } : function(source) {
        return (0, $6ea7c671d75007cb$export$1364843af8d5a963)(new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)())(source);
    };
}






function $bd9ef8e0f52c62f6$export$9369b12211e1fce4(configOrCount) {
    if (configOrCount === void 0) configOrCount = Infinity;
    var config;
    if (configOrCount && typeof configOrCount === 'object') config = configOrCount;
    else config = {
        count: configOrCount
    };
    var _a = config.count, count = _a === void 0 ? Infinity : _a, delay = config.delay, _b = config.resetOnSuccess, resetOnSuccess = _b === void 0 ? false : _b;
    return count <= 0 ? (0, $7569c528cdd9d182$export$f0954fd7d5368655) : (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var soFar = 0;
        var innerSub;
        var subscribeForRetry = function() {
            var syncUnsub = false;
            innerSub = source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
                if (resetOnSuccess) soFar = 0;
                subscriber.next(value);
            }, undefined, function(err) {
                if (soFar++ < count) {
                    var resub_1 = function() {
                        if (innerSub) {
                            innerSub.unsubscribe();
                            innerSub = null;
                            subscribeForRetry();
                        } else syncUnsub = true;
                    };
                    if (delay != null) {
                        var notifier = typeof delay === 'number' ? (0, $bce9e90ba9895d75$export$9dc4ecf953986f04)(delay) : (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(delay(err, soFar));
                        var notifierSubscriber_1 = (0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function() {
                            notifierSubscriber_1.unsubscribe();
                            resub_1();
                        }, function() {
                            subscriber.complete();
                        });
                        notifier.subscribe(notifierSubscriber_1);
                    } else resub_1();
                } else subscriber.error(err);
            }));
            if (syncUnsub) {
                innerSub.unsubscribe();
                innerSub = null;
                subscribeForRetry();
            }
        };
        subscribeForRetry();
    });
}






function $0cd9b6b86141760f$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $0cd9b6b86141760f$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $0cd9b6b86141760f$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(on.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(args)))).subscribe(onSubscriber);
}



function $cd8167599454f872$export$db61d692014e534e(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)({
        connector: function() {
            return new (0, $4a1890c700519557$export$915d2682b0aa0991)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}




function $b52129d9072c7912$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(values);
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        (scheduler ? (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(values, source, scheduler) : (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(values, source)).subscribe(subscriber);
    });
}




function $2fbcbd7f7704e649$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}





function $e890d5c5b4491f33$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(notifier).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function() {
            return subscriber.complete();
        }, (0, $528e75db69787807$export$8793edee2d425525)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}



function $106fa5810fba1e6e$export$9384c7afe4015e42(predicate, inclusive) {
    if (inclusive === void 0) inclusive = false;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var result = predicate(value, index++);
            (result || inclusive) && subscriber.next(value);
            !result && subscriber.complete();
        }));
    });
}





function $3e7edc5b22925f26$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $7569c528cdd9d182$export$f0954fd7d5368655);
}








var $9491af11bb0ab327$export$66d311bf29d5c89c = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) info = null;
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function $9491af11bb0ab327$export$83e74882c5df8fe1(config, schedulerArg) {
    var _a = (0, $3f3032e6ea410a39$export$c03bb0116ee09d4b)(config) ? {
        first: config
    } : typeof config === 'number' ? {
        each: config
    } : config, first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? $9491af11bb0ab327$var$timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : (0, $2b2c2daf44a1044e$export$8d6b71a2b178fc32) : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function(delay) {
            timerSubscription = (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                try {
                    originalSourceSubscription.unsubscribe();
                    (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen
                    })).subscribe(subscriber);
                } catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            seen++;
            subscriber.next(lastValue = value);
            each > 0 && startTimer(each);
        }, undefined, undefined, function() {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            lastValue = null;
        }));
        !seen && startTimer(first != null ? typeof first === 'number' ? first : +first - scheduler.now() : each);
    });
}
function $9491af11bb0ab327$var$timeoutErrorFactory(info) {
    throw new $9491af11bb0ab327$export$66d311bf29d5c89c(info);
}


var $136cf104cc6d8233$exports = {};
'use strict';
$136cf104cc6d8233$exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};






var $6ZWSX = parcelRequire("6ZWSX");
var $cbefca4388d58836$require$Buffer = $6ZWSX.Buffer;
var $cbefca4388d58836$var$_a$1;
/**
 *  @category Error
 *  @description Error that indicates an invalid map type being passed or used
 */ class $cbefca4388d58836$export$4eeb8f7279af263f extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(mapType, reason){
        super();
        this.mapType = mapType;
        this.reason = reason;
        this.message = `The map type '${JSON.stringify(mapType)}' is invalid. Reason: ${reason}.`;
        this.name = 'InvalidMapTypeError';
    }
}
// Retrieve a unique symbol associated with the key from the environment
// Used in order to identify all object that are of type MichelsonMap even if they come from different module
const $cbefca4388d58836$var$michelsonMapTypeSymbol = Symbol.for('taquito-michelson-map-type-symbol');
/**
 *
 * @throws {@link InvalidMapTypeError} when the argument passed to mapType is not a valid map type
 */ function $cbefca4388d58836$var$validateMapType(value) {
    if (!('prim' in value)) throw new $cbefca4388d58836$export$4eeb8f7279af263f(value, `Missing 'prim' field`);
    if (![
        'map',
        'big_map'
    ].includes(value.prim)) throw new $cbefca4388d58836$export$4eeb8f7279af263f(value, `The prim field should be 'map' or 'big_map'`);
    if (!('args' in value)) throw new $cbefca4388d58836$export$4eeb8f7279af263f(value, `Missing 'args' field`);
    if (!Array.isArray(value.args)) throw new $cbefca4388d58836$export$4eeb8f7279af263f(value, `The 'args' field should be an array`);
    if (value.args.length !== 2) throw new $cbefca4388d58836$export$4eeb8f7279af263f(value, `The 'args' field should have 2 elements`);
}
/**
 *  @category Error
 *  @description Error that indicates a map type mismatch, where an attempt to set a key or value in a Map doesn't match the defined type of the Map
 */ class $cbefca4388d58836$export$eecdd5fe7341b29b extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(value, type, objectType, reason){
        super();
        this.value = value;
        this.type = type;
        this.reason = reason;
        this.name = 'MapTypecheckError';
        this.message = `The ${objectType} provided: ${JSON.stringify(value)} is not compatible with the expected michelson type: ${JSON.stringify(type)}. Reason: ${JSON.stringify(reason)}.`;
        this.name = 'MapTypecheckError';
    }
}
/**
 * @description Michelson Map is an abstraction over the michelson native map. It supports complex Pair as key
 */ class $cbefca4388d58836$export$485fc446a4c98bc8 {
    // Used to check if an object is a michelson map.
    // Using instanceof was not working for project that had multiple instance of taquito dependencies
    // as the class constructor is different
    static isMichelsonMap(obj) {
        return obj && obj[$cbefca4388d58836$var$michelsonMapTypeSymbol] === true;
    }
    /**
     * @param mapType If specified key and value will be type-checked before being added to the map
     *
     * @example new MichelsonMap({ prim: "map", args: [{prim: "string"}, {prim: "int"}]})
     */ constructor(mapType){
        this.valueMap = new Map();
        this.keyMap = new Map();
        this[$cbefca4388d58836$var$_a$1] = true;
        if (mapType) this.setType(mapType);
    }
    setType(mapType) {
        $cbefca4388d58836$var$validateMapType(mapType);
        this.keySchema = new $cbefca4388d58836$export$19342e026b58ebb7(mapType.args[0]);
        this.valueSchema = new $cbefca4388d58836$export$19342e026b58ebb7(mapType.args[1]);
    }
    removeType() {
        this.keySchema = undefined;
        this.valueSchema = undefined;
    }
    static fromLiteral(obj, mapType) {
        const map = new $cbefca4388d58836$export$485fc446a4c98bc8(mapType);
        Object.keys(obj).forEach((key)=>{
            map.set(key, obj[key]);
        });
        return map;
    }
    typecheckKey(key) {
        if (!this.keySchema) return;
        this.keySchema.Typecheck(key);
    }
    typecheckValue(value) {
        if (!this.valueSchema) return;
        this.valueSchema.Typecheck(value);
    }
    /**
     * @throws {@link MapTypecheckError} when the argument passed does not match the expected schema for value
     */ assertTypecheckValue(value) {
        try {
            this.typecheckValue(value);
        } catch (e) {
            throw new $cbefca4388d58836$export$eecdd5fe7341b29b(value, this.valueSchema, 'value', e);
        }
    }
    /**
     * @throws {@link MapTypecheckError} when the argument passed does not match the expected schema for key
     */ assertTypecheckKey(key) {
        try {
            this.typecheckKey(key);
        } catch (e) {
            throw new $cbefca4388d58836$export$eecdd5fe7341b29b(key, this.keySchema, 'key', e);
        }
    }
    serializeDeterministically(key) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($136cf104cc6d8233$exports)))(key);
    }
    *keys() {
        for (const [key] of this.entries())yield key;
    }
    *values() {
        for (const [, value] of this.entries())yield value;
    }
    *entries() {
        for (const key of this.valueMap.keys())// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        yield [
            this.keyMap.get(key),
            this.valueMap.get(key)
        ];
    }
    get(key) {
        this.assertTypecheckKey(key);
        const strKey = this.serializeDeterministically(key);
        return this.valueMap.get(strKey);
    }
    /**
     *
     * @description Set a key and a value in the MichelsonMap. If the key already exists, override the current value.
     *
     * @example map.set("myKey", "myValue") // Using a string as key
     *
     * @example map.set({0: "test", 1: "test1"}, "myValue") // Using a pair as key
     *
     * @warn The same key can be represented in multiple ways, depending on the type of the key. This duplicate key situation will cause a runtime error (duplicate key) when sending the map data to the Tezos RPC node.
     *
     * For example, consider a contract with a map whose key is of type boolean.  If you set the following values in MichelsonMap: map.set(false, "myValue") and map.set(null, "myValue").
     *
     * You will get two unique entries in the MichelsonMap. These values will both be evaluated as falsy by the MichelsonEncoder and ultimately rejected by the Tezos RPC.
     */ set(key, value) {
        this.assertTypecheckKey(key);
        this.assertTypecheckValue(value);
        const strKey = this.serializeDeterministically(key);
        this.keyMap.set(strKey, key);
        this.valueMap.set(strKey, value);
    }
    delete(key) {
        this.assertTypecheckKey(key);
        this.keyMap.delete(this.serializeDeterministically(key));
        this.valueMap.delete(this.serializeDeterministically(key));
    }
    has(key) {
        this.assertTypecheckKey(key);
        const strKey = this.serializeDeterministically(key);
        return this.keyMap.has(strKey) && this.valueMap.has(strKey);
    }
    clear() {
        this.keyMap.clear();
        this.valueMap.clear();
    }
    get size() {
        return this.keyMap.size;
    }
    forEach(cb) {
        for (const [key, value] of this.entries())cb(value, key, this);
    }
}
$cbefca4388d58836$var$_a$1 = $cbefca4388d58836$var$michelsonMapTypeSymbol;
/**
 *  @category Error
 *  @description Error that indicates a failure when encoding invalid or incorrect data (e.g. if an address is expected but a number is received)
 */ class $cbefca4388d58836$var$TokenValidationError extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(value, token, baseMessage){
        super();
        this.value = value;
        this.token = token;
        this.name = 'TokenValidationError';
        const annot = this.token.annot();
        const annotText = annot ? `[${annot}] ` : '';
        this.message = `${annotText}${baseMessage}`;
    }
}
class $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        this.val = val;
        this.idx = idx;
        this.fac = fac;
        this.createToken = this.fac;
    }
    typeWithoutAnnotations() {
        const handleMichelsonExpression = (val)=>{
            if (typeof val === 'object') {
                if (Array.isArray(val)) {
                    const array = val;
                    return array.map((item)=>handleMichelsonExpression(item));
                }
                const extended = val;
                if (extended.args) return {
                    prim: extended.prim,
                    args: extended.args.map((x)=>handleMichelsonExpression(x))
                };
                else return {
                    prim: extended.prim
                };
            }
            return val;
        };
        const handleMichelsonExtended = (val)=>{
            if (val.args) return {
                prim: val.prim,
                args: val.args.map((x)=>handleMichelsonExpression(x))
            };
            else return {
                prim: val.prim
            };
        };
        return handleMichelsonExtended(this.val);
    }
    annot() {
        return (Array.isArray(this.val.annots) && this.val.annots.length > 0 ? this.val.annots[0] : String(this.idx)).replace(/(%|:)(_Liq_entry_)?/, '');
    }
    hasAnnotations() {
        return Array.isArray(this.val.annots) && this.val.annots.length;
    }
    get tokenVal() {
        return this.val;
    }
    ExtractSignature() {
        return [
            [
                this.ExtractSchema()
            ]
        ];
    }
}
class $cbefca4388d58836$var$ComparableToken extends $cbefca4388d58836$export$50792b0e93539fde {
    compare(o1, o2) {
        if (o1 === o2) return 0;
        return o1 < o2 ? -1 : 1;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Big Map types
 */ class $cbefca4388d58836$export$f8bbc082a20b2e9d extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'BigMapValidationError';
    }
}
class $cbefca4388d58836$var$BigMapToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get ValueSchema() {
        return this.createToken(this.val.args[1], 0);
    }
    get KeySchema() {
        return this.createToken(this.val.args[0], 0);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            big_map: {
                key: this.KeySchema.ExtractSchema(),
                value: this.ValueSchema.ExtractSchema()
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$BigMapToken.prim,
            schema: {
                key: this.KeySchema.generateSchema(),
                value: this.ValueSchema.generateSchema()
            }
        };
    }
    /**
     * @throws {@link BigMapValidationError}
     */ validate(value) {
        if (!$cbefca4388d58836$export$485fc446a4c98bc8.isMichelsonMap(value)) throw new $cbefca4388d58836$export$f8bbc082a20b2e9d(value, this, `Value ${JSON.stringify(value)} is not a MichelsonMap`);
    }
    objLitToMichelsonMap(val) {
        if (val instanceof $cbefca4388d58836$export$485fc446a4c98bc8) return val;
        if (typeof val === 'object') {
            if (Object.keys(val).length === 0) return new $cbefca4388d58836$export$485fc446a4c98bc8();
            else return $cbefca4388d58836$export$485fc446a4c98bc8.fromLiteral(val);
        }
        return val;
    }
    /**
     * @throws {@link BigMapValidationError}
     */ Encode(args) {
        const val = this.objLitToMichelsonMap(args.pop());
        this.validate(val);
        return Array.from(val.keys()).sort((a, b)=>this.KeySchema.compare(a, b)).map((key)=>{
            return {
                prim: 'Elt',
                args: [
                    this.KeySchema.EncodeObject(key),
                    this.ValueSchema.EncodeObject(val.get(key))
                ]
            };
        });
    }
    /**
     * @throws {@link BigMapValidationError}
     */ EncodeObject(args, semantic) {
        const val = this.objLitToMichelsonMap(args);
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$BigMapToken.prim]) return semantic[$cbefca4388d58836$var$BigMapToken.prim](val, this.val);
        return Array.from(val.keys()).sort((a, b)=>this.KeySchema.compare(a, b)).map((key)=>{
            return {
                prim: 'Elt',
                args: [
                    this.KeySchema.EncodeObject(key),
                    this.ValueSchema.EncodeObject(val.get(key))
                ]
            };
        });
    }
    /**
     * @throws {@link InvalidMapTypeError} when the argument passed to val is an array but not a valid map type
     * @throws {@link BigMapValidationError} when the value is invalid
     */ Execute(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$BigMapToken.prim]) return semantic[$cbefca4388d58836$var$BigMapToken.prim](val, this.val);
        if (Array.isArray(val)) {
            // Athens is returning an empty array for big map in storage
            // Internal: In taquito v5 it is still used to decode big map diff (as if they were a regular map)
            const map = new $cbefca4388d58836$export$485fc446a4c98bc8(this.val);
            val.forEach((current)=>{
                map.set(this.KeySchema.ToKey(current.args[0]), this.ValueSchema.Execute(current.args[1]));
            });
            return map;
        } else if ('int' in val) // Babylon is returning an int with the big map id in contract storage
        return val.int;
        else throw new $cbefca4388d58836$export$f8bbc082a20b2e9d(val, this, `Big map is expecting either an array (Athens) or an object with an int property (Babylon). Got ${JSON.stringify(val)}`);
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$BigMapToken.prim === tokenToFind) tokens.push(this);
        this.KeySchema.findAndReturnTokens(tokenToFind, tokens);
        this.ValueSchema.findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$cbefca4388d58836$var$BigMapToken.prim = 'big_map';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing an OrToken
 */ class $cbefca4388d58836$export$323d5d85c5838f7a extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'OrValidationError';
    }
}
class $cbefca4388d58836$var$OrToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Encode(args) {
        const label = args[args.length - 1];
        const leftToken = this.createToken(this.val.args[0], this.idx);
        let keyCount = 1;
        if (leftToken instanceof $cbefca4388d58836$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(this.val.args[1], this.idx + keyCount);
        if (String(leftToken.annot()) === String(label) && !(leftToken instanceof $cbefca4388d58836$var$OrToken)) {
            args.pop();
            return {
                prim: 'Left',
                args: [
                    leftToken.Encode(args)
                ]
            };
        } else if (String(rightToken.annot()) === String(label) && !(rightToken instanceof $cbefca4388d58836$var$OrToken)) {
            args.pop();
            return {
                prim: 'Right',
                args: [
                    rightToken.Encode(args)
                ]
            };
        } else {
            if (leftToken instanceof $cbefca4388d58836$var$OrToken) {
                const val = leftToken.Encode(args);
                if (val) return {
                    prim: 'Left',
                    args: [
                        val
                    ]
                };
            }
            if (rightToken instanceof $cbefca4388d58836$var$OrToken) {
                const val = rightToken.Encode(args);
                if (val) return {
                    prim: 'Right',
                    args: [
                        val
                    ]
                };
            }
            return null;
        }
    }
    ExtractSignature() {
        const leftToken = this.createToken(this.val.args[0], this.idx);
        let keyCount = 1;
        if (leftToken instanceof $cbefca4388d58836$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(this.val.args[1], this.idx + keyCount);
        const newSig = [];
        if (leftToken instanceof $cbefca4388d58836$var$OrToken) newSig.push(...leftToken.ExtractSignature());
        else for (const sig of leftToken.ExtractSignature())newSig.push([
            leftToken.annot(),
            ...sig
        ]);
        if (rightToken instanceof $cbefca4388d58836$var$OrToken) newSig.push(...rightToken.ExtractSignature());
        else for (const sig of rightToken.ExtractSignature())newSig.push([
            rightToken.annot(),
            ...sig
        ]);
        return newSig;
    }
    /**
     * @throws {@link OrValidationError}
     */ EncodeObject(args, semantic) {
        this.validateJavascriptObject(args);
        const label = Object.keys(args)[0];
        const leftToken = this.createToken(this.val.args[0], this.idx);
        let keyCount = 1;
        if (leftToken instanceof $cbefca4388d58836$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(this.val.args[1], this.idx + keyCount);
        if (String(leftToken.annot()) === String(label) && !(leftToken instanceof $cbefca4388d58836$var$OrToken)) return {
            prim: 'Left',
            args: [
                leftToken.EncodeObject(args[label], semantic)
            ]
        };
        else if (String(rightToken.annot()) === String(label) && !(rightToken instanceof $cbefca4388d58836$var$OrToken)) return {
            prim: 'Right',
            args: [
                rightToken.EncodeObject(args[label], semantic)
            ]
        };
        else {
            if (leftToken instanceof $cbefca4388d58836$var$OrToken) {
                const val = leftToken.EncodeObject(args, semantic);
                if (val) return {
                    prim: 'Left',
                    args: [
                        val
                    ]
                };
            }
            if (rightToken instanceof $cbefca4388d58836$var$OrToken) {
                const val = rightToken.EncodeObject(args, semantic);
                if (val) return {
                    prim: 'Right',
                    args: [
                        val
                    ]
                };
            }
            return null;
        }
    }
    /**
     * @throws {@link OrValidationError}
     */ validateJavascriptObject(args) {
        if (typeof args !== 'object' || Array.isArray(args) || args === null || Object.keys(args).length !== 1) throw new $cbefca4388d58836$export$323d5d85c5838f7a(args, this, `EncodeObject expects an object with a single key but got: ${JSON.stringify(args)}`);
    }
    /**
     * @throws {@link OrValidationError}
     */ Execute(val, semantics) {
        const leftToken = this.createToken(this.val.args[0], this.idx);
        let keyCount = 1;
        if (leftToken instanceof $cbefca4388d58836$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(this.val.args[1], this.idx + keyCount);
        if (val.prim === 'Right') {
            if (rightToken instanceof $cbefca4388d58836$var$OrToken) return rightToken.Execute(val.args[0], semantics);
            else return {
                [rightToken.annot()]: rightToken.Execute(val.args[0], semantics)
            };
        } else if (val.prim === 'Left') {
            if (leftToken instanceof $cbefca4388d58836$var$OrToken) return leftToken.Execute(val.args[0], semantics);
            return {
                [leftToken.annot()]: leftToken.Execute(val.args[0], semantics)
            };
        } else throw new $cbefca4388d58836$export$323d5d85c5838f7a(val, this, `Was expecting Left or Right prim but got: ${JSON.stringify(val.prim)}`);
    }
    traversal(getLeftValue, getRightValue, concat) {
        const leftToken = this.createToken(this.val.args[0], this.idx);
        let keyCount = 1;
        let leftValue;
        if (leftToken instanceof $cbefca4388d58836$var$OrToken) {
            leftValue = getLeftValue(leftToken);
            keyCount = Object.keys(leftToken.ExtractSchema()).length;
        } else leftValue = {
            [leftToken.annot()]: getLeftValue(leftToken)
        };
        const rightToken = this.createToken(this.val.args[1], this.idx + keyCount);
        let rightValue;
        if (rightToken instanceof $cbefca4388d58836$var$OrToken) rightValue = getRightValue(rightToken);
        else rightValue = {
            [rightToken.annot()]: getRightValue(rightToken)
        };
        const res = concat(leftValue, rightValue);
        return res;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return this.traversal((leftToken)=>leftToken.ExtractSchema(), (rightToken)=>rightToken.ExtractSchema(), (leftValue, rightValue)=>Object.assign(Object.assign({}, leftValue), rightValue));
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$OrToken.prim,
            schema: this.traversal((leftToken)=>{
                if (leftToken instanceof $cbefca4388d58836$var$OrToken) return leftToken.generateSchema().schema;
                else return leftToken.generateSchema();
            }, (rightToken)=>{
                if (rightToken instanceof $cbefca4388d58836$var$OrToken) return rightToken.generateSchema().schema;
                else return rightToken.generateSchema();
            }, (leftValue, rightValue)=>Object.assign(Object.assign({}, leftValue), rightValue))
        };
    }
    findToken(label) {
        const leftToken = this.createToken(this.val.args[0], this.idx);
        let keyCount = 1;
        if (leftToken instanceof $cbefca4388d58836$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(this.val.args[1], this.idx + keyCount);
        if (String(leftToken.annot()) === String(label) && !(leftToken instanceof $cbefca4388d58836$var$OrToken) && leftToken instanceof $cbefca4388d58836$var$ComparableToken) return leftToken;
        else if (String(rightToken.annot()) === String(label) && !(rightToken instanceof $cbefca4388d58836$var$OrToken) && rightToken instanceof $cbefca4388d58836$var$ComparableToken) return rightToken;
        else {
            if (leftToken instanceof $cbefca4388d58836$var$OrToken) {
                const tok = leftToken.findToken(label);
                if (tok) return tok;
            }
            if (rightToken instanceof $cbefca4388d58836$var$OrToken) {
                const tok = rightToken.findToken(label);
                if (tok) return tok;
            }
            return null;
        }
    }
    compare(val1, val2) {
        const labelVal1 = Object.keys(val1)[0];
        const labelVal2 = Object.keys(val2)[0];
        if (labelVal1 === labelVal2) {
            const token = this.findToken(labelVal1);
            if (token instanceof $cbefca4388d58836$var$ComparableToken) return token.compare(val1[labelVal1], val2[labelVal1]);
        } else {
            const encoded1 = JSON.stringify(this.EncodeObject(val1));
            const encoded2 = JSON.stringify(this.EncodeObject(val2));
            return encoded1 < encoded2 ? -1 : 1;
        }
    }
    ToKey(val) {
        return this.Execute(val);
    }
    ToBigMapKey(val) {
        return {
            key: this.EncodeObject(val),
            type: this.typeWithoutAnnotations()
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$OrToken.prim === tokenToFind) tokens.push(this);
        this.traversal((leftToken)=>leftToken.findAndReturnTokens(tokenToFind, tokens), (rightToken)=>rightToken.findAndReturnTokens(tokenToFind, tokens), (leftValue, rightValue)=>Object.assign(Object.assign({}, leftValue), rightValue));
        return tokens;
    }
}
$cbefca4388d58836$var$OrToken.prim = 'or';
/**
 *  @category Error
 *  @description Error that indicates in invalid token argument being passed
 */ class $cbefca4388d58836$export$8c55d85f07253962 extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(message){
        super(message);
        this.message = message;
        this.name = 'TokenArgumentValidationError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure occurring when doing a comparison of tokens
 */ class $cbefca4388d58836$export$562171fb2a9d2fdb extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(val1, val2){
        super();
        this.val1 = val1;
        this.val2 = val2;
        this.name = 'TokenComparisonError';
        this.message = `Tokens ${JSON.stringify(val1)} and ${JSON.stringify(val2)} are not comparable`;
    }
}
// collapse comb pair
/**
 * @throws {@link TokenArgumentValidationError}
 */ function $cbefca4388d58836$var$collapse$1(val, prim = $cbefca4388d58836$var$PairToken.prim) {
    if (Array.isArray(val)) return $cbefca4388d58836$var$collapse$1({
        prim: prim,
        args: val
    }, prim);
    if (val.args === undefined) throw new $cbefca4388d58836$export$8c55d85f07253962(`The value ${JSON.stringify(val)} is an invalid PairToken with no arguments, a pair must have two or more arguments.`);
    if (val.args.length > 2) return [
        val.args[0],
        {
            prim: prim,
            args: val.args.slice(1)
        }
    ];
    return [
        val.args[0],
        val.args[1]
    ];
}
class $cbefca4388d58836$var$PairToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(Array.isArray(val) ? {
            prim: $cbefca4388d58836$var$PairToken.prim,
            args: val
        } : val.prim ? val : {
            prim: $cbefca4388d58836$var$PairToken.prim,
            args: val
        }, idx, fac);
    }
    args() {
        // collapse comb pair
        return $cbefca4388d58836$var$collapse$1(this.val);
    }
    tokens() {
        let cnt = 0;
        return this.args().map((a)=>{
            const tok = this.createToken(a, this.idx + cnt);
            if (tok instanceof $cbefca4388d58836$var$PairToken) cnt += Object.keys(tok.ExtractSchema()).length;
            else cnt++;
            return tok;
        });
    }
    Encode(args) {
        return {
            prim: 'Pair',
            args: this.tokens().map((t)=>t.Encode(args))
        };
    }
    ExtractSignature() {
        const args = this.args();
        const leftToken = this.createToken(args[0], this.idx);
        let keyCount = 1;
        if (leftToken instanceof $cbefca4388d58836$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(args[1], this.idx + keyCount);
        const newSig = [];
        for (const leftSig of leftToken.ExtractSignature())for (const rightSig of rightToken.ExtractSignature())newSig.push([
            ...leftSig,
            ...rightSig
        ]);
        return newSig;
    }
    ToBigMapKey(val) {
        return {
            key: this.EncodeObject(val),
            type: this.typeWithoutAnnotations()
        };
    }
    ToKey(val) {
        return this.Execute(val);
    }
    EncodeObject(args, semantic) {
        const [leftToken, rightToken] = this.tokens();
        let leftValue;
        if (leftToken instanceof $cbefca4388d58836$var$PairToken && !leftToken.hasAnnotations()) leftValue = args;
        else leftValue = args[leftToken.annot()];
        let rightValue;
        if (rightToken instanceof $cbefca4388d58836$var$PairToken && !rightToken.hasAnnotations()) rightValue = args;
        else rightValue = args[rightToken.annot()];
        return {
            prim: 'Pair',
            args: [
                leftToken.EncodeObject(leftValue, semantic),
                rightToken.EncodeObject(rightValue, semantic)
            ]
        };
    }
    traversal(getLeftValue, getRightValue) {
        const args = this.args();
        const leftToken = this.createToken(args[0], this.idx);
        let keyCount = 1;
        let leftValue;
        if (leftToken instanceof $cbefca4388d58836$var$PairToken && !leftToken.hasAnnotations()) {
            leftValue = getLeftValue(leftToken);
            if (leftToken instanceof $cbefca4388d58836$var$PairToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        } else leftValue = {
            [leftToken.annot()]: getLeftValue(leftToken)
        };
        const rightToken = this.createToken(args[1], this.idx + keyCount);
        let rightValue;
        if (rightToken instanceof $cbefca4388d58836$var$PairToken && !rightToken.hasAnnotations()) rightValue = getRightValue(rightToken);
        else rightValue = {
            [rightToken.annot()]: getRightValue(rightToken)
        };
        const res = Object.assign(Object.assign({}, leftValue), rightValue);
        return res;
    }
    Execute(val, semantics) {
        const args = $cbefca4388d58836$var$collapse$1(val, 'Pair');
        return this.traversal((leftToken)=>leftToken.Execute(args[0], semantics), (rightToken)=>rightToken.Execute(args[1], semantics));
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return this.traversal((leftToken)=>leftToken.ExtractSchema(), (rightToken)=>rightToken.ExtractSchema());
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$PairToken.prim,
            schema: this.traversal((leftToken)=>{
                if (leftToken instanceof $cbefca4388d58836$var$PairToken && !leftToken.hasAnnotations()) return leftToken.generateSchema().schema;
                else return leftToken.generateSchema();
            }, (rightToken)=>{
                if (rightToken instanceof $cbefca4388d58836$var$PairToken && !rightToken.hasAnnotations()) return rightToken.generateSchema().schema;
                else return rightToken.generateSchema();
            })
        };
    }
    /**
     * @throws {@link TokenComparisonError}
     */ compare(val1, val2) {
        const [leftToken, rightToken] = this.tokens();
        const getValue = (token, args)=>{
            if (token instanceof $cbefca4388d58836$var$PairToken && !token.hasAnnotations()) return args;
            else return args[token.annot()];
        };
        if (leftToken instanceof $cbefca4388d58836$var$ComparableToken && rightToken instanceof $cbefca4388d58836$var$ComparableToken) {
            const result = leftToken.compare(getValue(leftToken, val1), getValue(leftToken, val2));
            if (result === 0) return rightToken.compare(getValue(rightToken, val1), getValue(rightToken, val2));
            return result;
        }
        throw new $cbefca4388d58836$export$562171fb2a9d2fdb(val1, val2);
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$PairToken.prim === tokenToFind) tokens.push(this);
        this.tokens().map((t)=>t.findAndReturnTokens(tokenToFind, tokens));
        return tokens;
    }
}
$cbefca4388d58836$var$PairToken.prim = 'pair';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Nat
 */ class $cbefca4388d58836$export$366b98b49aef7be5 extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'NatValidationError';
    }
}
class $cbefca4388d58836$var$NatToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val[Object.keys(val)[0]]);
    }
    /**
     * @throws {@link NatValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            int: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).toFixed()
        };
    }
    /**
     * @throws {@link NatValidationError}
     */ validate(val) {
        const bigNumber = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val);
        if (bigNumber.isNaN()) throw new $cbefca4388d58836$export$366b98b49aef7be5(val, this, `Value is not a number: ${JSON.stringify(val)}`);
        if (bigNumber.isNegative()) throw new $cbefca4388d58836$export$366b98b49aef7be5(val, this, `Value cannot be negative: ${JSON.stringify(val)}`);
    }
    /**
     * @throws {@link NatValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$NatToken.prim]) return semantic[$cbefca4388d58836$var$NatToken.prim](val);
        return {
            int: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).toFixed()
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$NatToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$NatToken.prim,
            schema: $cbefca4388d58836$var$NatToken.prim
        };
    }
    ToBigMapKey(val) {
        return {
            key: {
                int: String(val)
            },
            type: {
                prim: $cbefca4388d58836$var$NatToken.prim
            }
        };
    }
    ToKey({ int: int }) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(int);
    }
    compare(nat1, nat2) {
        const o1 = Number(nat1);
        const o2 = Number(nat2);
        if (o1 === o2) return 0;
        return o1 < o2 ? -1 : 1;
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$NatToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$NatToken.prim = 'nat';
class $cbefca4388d58836$var$StringToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return val[Object.keys(val)[0]];
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$StringToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$StringToken.prim,
            schema: $cbefca4388d58836$var$StringToken.prim
        };
    }
    Encode(args) {
        const val = args.pop();
        return {
            string: val
        };
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$StringToken.prim]) return semantic[$cbefca4388d58836$var$StringToken.prim](val);
        return {
            string: val
        };
    }
    ToKey({ string: string }) {
        return string;
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $cbefca4388d58836$var$StringToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$StringToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$StringToken.prim = 'string';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing an Address
 */ class $cbefca4388d58836$export$c95a19675a95f686 extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'AddressValidationError';
    }
}
class $cbefca4388d58836$var$AddressToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    ToBigMapKey(val) {
        const decoded = (0, $201657d342d01b1b$export$c5fd02d48c871a17)(val);
        return {
            key: {
                bytes: decoded
            },
            type: {
                prim: 'bytes'
            }
        };
    }
    /**
     * @throws {@link AddressValidationError}
     */ validate(value) {
        if ((0, $201657d342d01b1b$export$f78173835dcde49f)(value) !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new $cbefca4388d58836$export$c95a19675a95f686(value, this, `Address is not valid: ${JSON.stringify(value)}`);
    }
    /**
     * @throws {@link AddressValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link AddressValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$AddressToken.prim]) return semantic[$cbefca4388d58836$var$AddressToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link AddressValidationError}
     */ Execute(val) {
        if (val.string) return val.string;
        if (!val.bytes) throw new $cbefca4388d58836$export$c95a19675a95f686(val, this, `cannot be missing both string and bytes: ${JSON.stringify(val)}`);
        return (0, $201657d342d01b1b$export$b149ba8ff44e4e70)(val.bytes);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$AddressToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$AddressToken.prim,
            schema: $cbefca4388d58836$var$AddressToken.prim
        };
    }
    /**
     * @throws {@link AddressValidationError}
     */ ToKey({ bytes: bytes, string: string }) {
        if (string) return string;
        if (!bytes) throw new $cbefca4388d58836$export$c95a19675a95f686({
            bytes: bytes,
            string: string
        }, this, `cannot be missing both string and bytes ${JSON.stringify({
            string: string,
            bytes: bytes
        })}`);
        return (0, $201657d342d01b1b$export$b149ba8ff44e4e70)(bytes);
    }
    compare(address1, address2) {
        const isImplicit = (address)=>{
            return address.startsWith('tz');
        };
        const implicit1 = isImplicit(address1);
        const implicit2 = isImplicit(address2);
        if (implicit1 && !implicit2) return -1;
        else if (implicit2 && !implicit1) return 1;
        return super.compare(address1, address2);
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$AddressToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$AddressToken.prim = 'address';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Map
 */ class $cbefca4388d58836$export$5f25b74245a0411c extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'MapValidationError';
    }
}
class $cbefca4388d58836$var$MapToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get ValueSchema() {
        return this.createToken(this.val.args[1], 0);
    }
    get KeySchema() {
        return this.createToken(this.val.args[0], 0);
    }
    /**
     * @throws {@link MapValidationError}
     */ validate(value) {
        if (!$cbefca4388d58836$export$485fc446a4c98bc8.isMichelsonMap(value)) throw new $cbefca4388d58836$export$5f25b74245a0411c(value, this, `Value ${JSON.stringify(value)} is not a valid MichelsonMap`);
    }
    Execute(val, semantics) {
        const map = new $cbefca4388d58836$export$485fc446a4c98bc8(this.val);
        val.forEach((current)=>{
            map.set(this.KeySchema.ToKey(current.args[0]), this.ValueSchema.Execute(current.args[1], semantics));
        });
        return map;
    }
    objLitToMichelsonMap(val) {
        if (val instanceof $cbefca4388d58836$export$485fc446a4c98bc8) return val;
        if (typeof val === 'object') {
            if (Object.keys(val).length === 0) return new $cbefca4388d58836$export$485fc446a4c98bc8();
            else return $cbefca4388d58836$export$485fc446a4c98bc8.fromLiteral(val);
        }
        return val;
    }
    /**
     * @throws {@link MapValidationError}
     */ Encode(args) {
        const val = this.objLitToMichelsonMap(args.pop());
        this.validate(val);
        return Array.from(val.keys()).sort((a, b)=>this.KeySchema.compare(a, b)).map((key)=>{
            return {
                prim: 'Elt',
                args: [
                    this.KeySchema.EncodeObject(key),
                    this.ValueSchema.EncodeObject(val.get(key))
                ]
            };
        });
    }
    /**
     * @throws {@link MapValidationError}
     */ EncodeObject(args, semantic) {
        const val = this.objLitToMichelsonMap(args);
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$MapToken.prim]) return semantic[$cbefca4388d58836$var$MapToken.prim](val);
        return Array.from(val.keys()).sort((a, b)=>this.KeySchema.compare(a, b)).map((key)=>{
            return {
                prim: 'Elt',
                args: [
                    this.KeySchema.EncodeObject(key),
                    this.ValueSchema.EncodeObject(val.get(key))
                ]
            };
        });
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            map: {
                key: this.KeySchema.ExtractSchema(),
                value: this.ValueSchema.ExtractSchema()
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$MapToken.prim,
            schema: {
                key: this.KeySchema.generateSchema(),
                value: this.ValueSchema.generateSchema()
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$MapToken.prim === tokenToFind) tokens.push(this);
        this.KeySchema.findAndReturnTokens(tokenToFind, tokens);
        this.ValueSchema.findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$cbefca4388d58836$var$MapToken.prim = 'map';
class $cbefca4388d58836$var$BoolToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return String(val.prim).toLowerCase() === 'true' ? true : false;
    }
    Encode(args) {
        const val = args.pop();
        return {
            prim: val ? 'True' : 'False'
        };
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$BoolToken.prim]) return semantic[$cbefca4388d58836$var$BoolToken.prim](val);
        return {
            prim: val ? 'True' : 'False'
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$BoolToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$BoolToken.prim,
            schema: $cbefca4388d58836$var$BoolToken.prim
        };
    }
    ToBigMapKey(val) {
        return {
            key: this.EncodeObject(val),
            type: {
                prim: $cbefca4388d58836$var$BoolToken.prim
            }
        };
    }
    ToKey(val) {
        return this.EncodeObject(val);
    }
    compare(val1, val2) {
        if (val1 && val2 || !val1 && !val2) return 0;
        else if (val1) return 1;
        else return -1;
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$BoolToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$BoolToken.prim = 'bool';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Contract
 */ class $cbefca4388d58836$export$4d36cb06e9af864a extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'ContractValidationError';
    }
}
class $cbefca4388d58836$var$ContractToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link ContractValidationError}
     */ validate(value) {
        // tz1,tz2 and tz3 seems to be valid contract values (for Unit contract)
        if ((0, $201657d342d01b1b$export$f78173835dcde49f)(value) !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new $cbefca4388d58836$export$4d36cb06e9af864a(value, this, `Value ${JSON.stringify(value)} is not a valid contract address.`);
        return null;
    }
    /**
     * @throws {@link ContractValidationError}
     */ Execute(val) {
        if (val.string) return val.string;
        if (!val.bytes) throw new $cbefca4388d58836$export$4d36cb06e9af864a(val, this, `Value ${JSON.stringify(val)} is not a valid contract address. must contain bytes or string.`);
        return (0, $201657d342d01b1b$export$b149ba8ff44e4e70)(val.bytes);
    }
    /**
     * @throws {@link ContractValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link ContractValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$ContractToken.prim]) return semantic[$cbefca4388d58836$var$ContractToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$ContractToken.prim;
    }
    generateSchema() {
        const valueSchema = this.createToken(this.val.args[0], 0);
        return {
            __michelsonType: $cbefca4388d58836$var$ContractToken.prim,
            schema: {
                parameter: this.val.args[0] ? valueSchema.generateSchema() : {}
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$ContractToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$ContractToken.prim = 'contract';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a List
 */ class $cbefca4388d58836$export$bba6abe6d545f230 extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'ListValidationError';
    }
}
class $cbefca4388d58836$var$ListToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get valueSchema() {
        return this.createToken(this.val.args[0], this.idx);
    }
    /**
     * @throws {@link ListValidationError}
     */ validate(value) {
        if (!Array.isArray(value)) throw new $cbefca4388d58836$export$bba6abe6d545f230(value, this, `Value ${JSON.stringify(value)} is not a valid array`);
    }
    /**
     * @throws {@link ListValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        const schema = this.createToken(this.val.args[0], 0);
        return val.reduce((prev, current)=>{
            return [
                ...prev,
                schema.EncodeObject(current)
            ];
        }, []);
    }
    /**
     * @throws {@link ListValidationError}
     */ Execute(val, semantics) {
        const schema = this.createToken(this.val.args[0], 0);
        this.validate(val);
        return val.reduce((prev, current)=>{
            return [
                ...prev,
                schema.Execute(current, semantics)
            ];
        }, []);
    }
    /**
     * @throws {@link ListValidationError}
     */ EncodeObject(args, semantic) {
        const schema = this.createToken(this.val.args[0], 0);
        this.validate(args);
        if (semantic && semantic[$cbefca4388d58836$var$ListToken.prim]) return semantic[$cbefca4388d58836$var$ListToken.prim](args);
        return args.reduce((prev, current)=>{
            return [
                ...prev,
                schema.EncodeObject(current)
            ];
        }, []);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            [$cbefca4388d58836$var$ListToken.prim]: this.valueSchema.ExtractSchema()
        };
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$ListToken.prim,
            schema: this.valueSchema.generateSchema()
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$ListToken.prim === tokenToFind) tokens.push(this);
        this.createToken(this.val.args[0], this.idx).findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$cbefca4388d58836$var$ListToken.prim = 'list';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Mutez
 */ class $cbefca4388d58836$export$b534343d605edcc extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'MutezValidationError';
    }
}
class $cbefca4388d58836$var$MutezToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val[Object.keys(val)[0]]);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$MutezToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$MutezToken.prim,
            schema: $cbefca4388d58836$var$MutezToken.prim
        };
    }
    /**
     * @throws {@link MutezValidationError}
     */ validate(val) {
        const bigNumber = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val);
        if (bigNumber.isNaN()) throw new $cbefca4388d58836$export$b534343d605edcc(val, this, `Value is not a number: ${val}`);
    }
    /**
     * @throws {@link MutezValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            int: String(val).toString()
        };
    }
    /**
     * @throws {@link MutezValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$MutezToken.prim]) return semantic[$cbefca4388d58836$var$MutezToken.prim](val);
        return {
            int: String(val).toString()
        };
    }
    ToBigMapKey(val) {
        return {
            key: {
                int: String(val)
            },
            type: {
                prim: $cbefca4388d58836$var$MutezToken.prim
            }
        };
    }
    ToKey({ int: int }) {
        return int;
    }
    compare(mutez1, mutez2) {
        const o1 = Number(mutez1);
        const o2 = Number(mutez2);
        if (o1 === o2) return 0;
        return o1 < o2 ? -1 : 1;
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$MutezToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$MutezToken.prim = 'mutez';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Bytes
 */ class $cbefca4388d58836$export$e22dd01a9e7c6e99 extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'BytesValidationError';
    }
}
class $cbefca4388d58836$var$BytesToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    ToBigMapKey(val) {
        return {
            key: {
                bytes: val
            },
            type: {
                prim: $cbefca4388d58836$var$BytesToken.prim
            }
        };
    }
    /**
     * @throws {@link BytesValidationError}
     */ validate(val) {
        if (typeof val === 'string' && /^[0-9a-fA-F]*$/.test(val) && val.length % 2 === 0) return;
        throw new $cbefca4388d58836$export$e22dd01a9e7c6e99(val, this, `Invalid bytes: ${val}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $cbefca4388d58836$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link BytesValidationError}
     */ Encode(args) {
        let val = args.pop();
        val = (0, $201657d342d01b1b$export$b2f5d0058897e6e6)(this.convertUint8ArrayToHexString(val));
        this.validate(val);
        return {
            bytes: String(val).toString()
        };
    }
    /**
     * @throws {@link BytesValidationError}
     */ EncodeObject(val, semantic) {
        val = this.convertUint8ArrayToHexString(val);
        if (typeof val === 'string') val = (0, $201657d342d01b1b$export$b2f5d0058897e6e6)(val);
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$BytesToken.prim]) return semantic[$cbefca4388d58836$var$BytesToken.prim](val);
        return {
            bytes: String(val).toString()
        };
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$BytesToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$BytesToken.prim,
            schema: $cbefca4388d58836$var$BytesToken.prim
        };
    }
    ToKey({ bytes: bytes, string: string }) {
        if (string) return string;
        return bytes;
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$BytesToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$BytesToken.prim = 'bytes';
class $cbefca4388d58836$var$OptionToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    subToken() {
        return this.createToken(this.val.args[0], this.idx);
    }
    schema() {
        return this.createToken(this.val.args[0], 0);
    }
    annot() {
        return Array.isArray(this.val.annots) ? super.annot() : this.createToken(this.val.args[0], this.idx).annot();
    }
    Encode(args) {
        const value = args;
        if (value === undefined || value === null) return {
            prim: 'None'
        };
        else if (Array.isArray(value) && (value[value.length - 1] === undefined || value[value.length - 1] === null)) {
            value.pop();
            return {
                prim: 'None'
            };
        }
        return {
            prim: 'Some',
            args: [
                this.schema().Encode(args)
            ]
        };
    }
    EncodeObject(args, semantic) {
        let value = args;
        if (value === undefined || value === null) return {
            prim: 'None'
        };
        value = typeof value === 'object' && 'Some' in value ? value['Some'] : value;
        return {
            prim: 'Some',
            args: [
                this.schema().EncodeObject(value, semantic)
            ]
        };
    }
    Execute(val, semantics) {
        if (val.prim === 'None') return null;
        return {
            Some: this.schema().Execute(val.args[0], semantics)
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            Some: this.schema().ExtractSchema()
        };
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$OptionToken.prim,
            schema: this.schema().generateSchema()
        };
    }
    ExtractSignature() {
        return [
            ...this.schema().ExtractSignature()
        ];
    }
    get KeySchema() {
        return this.schema();
    }
    compare(val1, val2) {
        if (!val1) return -1;
        else if (!val2) return 1;
        return this.KeySchema.compare(val1, val2);
    }
    ToKey(val) {
        return this.Execute(val);
    }
    ToBigMapKey(val) {
        return {
            key: this.EncodeObject(val),
            type: this.typeWithoutAnnotations()
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$OptionToken.prim === tokenToFind) tokens.push(this);
        this.subToken().findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$cbefca4388d58836$var$OptionToken.prim = 'option';
class $cbefca4388d58836$var$TimestampToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        if (val.string && /^\d+$/.test(val.string)) return new Date(Number(val.string) * 1000).toISOString();
        else if (val.string) return new Date(val.string).toISOString();
        else if (val.int) return new Date(Number(val.int) * 1000).toISOString();
    }
    Encode(args) {
        const val = args.pop();
        if (typeof val === 'number') return {
            int: String(val)
        };
        else return {
            string: val
        };
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$TimestampToken.prim]) return semantic[$cbefca4388d58836$var$TimestampToken.prim](val);
        if (typeof val === 'number') return {
            int: String(val)
        };
        else return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$TimestampToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$TimestampToken.prim,
            schema: $cbefca4388d58836$var$TimestampToken.prim
        };
    }
    ToKey({ string: string }) {
        return string;
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $cbefca4388d58836$var$TimestampToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$TimestampToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$TimestampToken.prim = 'timestamp';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Int
 */ class $cbefca4388d58836$export$a192a91ba6ce6f9 extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'IntValidationError';
    }
}
class $cbefca4388d58836$var$IntToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val[Object.keys(val)[0]]);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$IntToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$IntToken.prim,
            schema: $cbefca4388d58836$var$IntToken.prim
        };
    }
    /**
     * @throws {@link IntValidationError}
     */ validate(val) {
        const bigNumber = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val);
        if (bigNumber.isNaN()) throw new $cbefca4388d58836$export$a192a91ba6ce6f9(val, this, `Value is not a number: ${JSON.stringify(val)}`);
    }
    /**
     * @throws {@link IntValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            int: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).toFixed()
        };
    }
    /**
     * @throws {@link IntValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$IntToken.prim]) return semantic[$cbefca4388d58836$var$IntToken.prim](val);
        return {
            int: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).toFixed()
        };
    }
    ToBigMapKey(val) {
        return {
            key: {
                int: String(val)
            },
            type: {
                prim: $cbefca4388d58836$var$IntToken.prim
            }
        };
    }
    ToKey({ int: int }) {
        return int;
    }
    compare(int1, int2) {
        const o1 = Number(int1);
        const o2 = Number(int2);
        if (o1 === o2) return 0;
        return o1 < o2 ? -1 : 1;
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$IntToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$IntToken.prim = 'int';
class $cbefca4388d58836$var$UnitToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Encode(args) {
        args.pop();
        return {
            prim: 'Unit'
        };
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$UnitToken.prim]) return semantic[$cbefca4388d58836$var$UnitToken.prim](val);
        return {
            prim: 'Unit'
        };
    }
    Execute(_val) {
        return $cbefca4388d58836$export$d703b7d35511419c;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$UnitToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$UnitToken.prim,
            schema: $cbefca4388d58836$var$UnitToken.prim
        };
    }
    compare(_val1, _val2) {
        return 0;
    }
    ToKey(_val) {
        return $cbefca4388d58836$export$d703b7d35511419c;
    }
    ToBigMapKey(_val) {
        return {
            key: {
                prim: 'Unit'
            },
            type: {
                prim: $cbefca4388d58836$var$UnitToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$UnitToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$UnitToken.prim = 'unit';
const $cbefca4388d58836$var$publicKeyPrefixLength = 4;
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Key
 */ class $cbefca4388d58836$export$9c29d49ec877779c extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'KeyValidationError';
    }
}
class $cbefca4388d58836$var$KeyToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        if (val.string) return val.string;
        return (0, $201657d342d01b1b$export$a0511d6cbab6225d)(val.bytes);
    }
    /**
     * @throws {@link KeyValidationError}
     */ validate(value) {
        if ((0, $201657d342d01b1b$export$7e268ff6bd252dc4)(value) !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new $cbefca4388d58836$export$9c29d49ec877779c(value, this, 'Key is not valid');
    }
    /**
     * @throws {@link KeyValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link KeyValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$KeyToken.prim]) return semantic[$cbefca4388d58836$var$KeyToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$KeyToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$KeyToken.prim,
            schema: $cbefca4388d58836$var$KeyToken.prim
        };
    }
    ToKey(val) {
        return this.Execute(val);
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $cbefca4388d58836$var$KeyToken.prim
            }
        };
    }
    compare(key1, key2) {
        const keyPrefix1 = this.getPrefix(key1);
        const keyPrefix2 = this.getPrefix(key2);
        if (keyPrefix1 === (0, $201657d342d01b1b$export$e77cfe0b08ec163).EDPK && keyPrefix2 !== (0, $201657d342d01b1b$export$e77cfe0b08ec163).EDPK) return -1;
        else if (keyPrefix1 === (0, $201657d342d01b1b$export$e77cfe0b08ec163).SPPK && keyPrefix2 !== (0, $201657d342d01b1b$export$e77cfe0b08ec163).SPPK) return keyPrefix2 === (0, $201657d342d01b1b$export$e77cfe0b08ec163).EDPK ? 1 : -1;
        else if (keyPrefix1 === (0, $201657d342d01b1b$export$e77cfe0b08ec163).P2PK) {
            if (keyPrefix2 !== (0, $201657d342d01b1b$export$e77cfe0b08ec163).P2PK) return 1;
            const keyBytes1 = this.getP256PublicKeyComparableBytes(key1);
            const keyBytes2 = this.getP256PublicKeyComparableBytes(key2);
            return $cbefca4388d58836$require$Buffer.compare(keyBytes1, keyBytes2);
        }
        return super.compare(key1, key2);
    }
    getPrefix(val) {
        return val.substring(0, $cbefca4388d58836$var$publicKeyPrefixLength);
    }
    getP256PublicKeyComparableBytes(p2pk) {
        return (0, $201657d342d01b1b$export$b9856b5e6fd1a05f)(p2pk, (0, $201657d342d01b1b$export$82e9f45cca5ba907)[(0, $201657d342d01b1b$export$e77cfe0b08ec163).P2PK]).slice(1);
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$KeyToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$KeyToken.prim = 'key';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Key Hash
 */ class $cbefca4388d58836$export$8ae52bbf96f5e9de extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'KeyHashValidationError';
    }
}
class $cbefca4388d58836$var$KeyHashToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        if (val.string) return val.string;
        return (0, $201657d342d01b1b$export$1ef834a164cef85e)(val.bytes);
    }
    /**
     * @throws {@link KeyHashValidationError}
     */ validate(value) {
        if ((0, $201657d342d01b1b$export$dbd3afbe999d4c3d)(value) !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new $cbefca4388d58836$export$8ae52bbf96f5e9de(value, this, `KeyHash is not valid: ${JSON.stringify(value)}`);
    }
    /**
     * @throws {@link KeyHashValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link KeyHashValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$KeyHashToken.prim]) return semantic[$cbefca4388d58836$var$KeyHashToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$KeyHashToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$KeyHashToken.prim,
            schema: $cbefca4388d58836$var$KeyHashToken.prim
        };
    }
    ToKey({ string: string, bytes: bytes }) {
        if (string) return string;
        return (0, $201657d342d01b1b$export$1ef834a164cef85e)(bytes);
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $cbefca4388d58836$var$KeyHashToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$KeyHashToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$KeyHashToken.prim = 'key_hash';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Signature
 */ class $cbefca4388d58836$export$41950d69fe7deb27 extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'SignatureValidationError';
    }
}
class $cbefca4388d58836$var$SignatureToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        if (val.string) return val.string;
        // TODO decode the signature
        return val.bytes;
    }
    /**
     * @throws {@link SignatureValidationError}
     */ validate(value) {
        if ((0, $201657d342d01b1b$export$f680e6c2b3919edb)(value) !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new $cbefca4388d58836$export$41950d69fe7deb27(value, this, 'Signature is not valid');
    }
    /**
     * @throws {@link SignatureValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link SignatureValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$SignatureToken.prim]) return semantic[$cbefca4388d58836$var$SignatureToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$SignatureToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$SignatureToken.prim,
            schema: $cbefca4388d58836$var$SignatureToken.prim
        };
    }
    ToKey(val) {
        return this.Execute(val);
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $cbefca4388d58836$var$SignatureToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$SignatureToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$SignatureToken.prim = 'signature';
class $cbefca4388d58836$var$LambdaToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get paramSchema() {
        return this.createToken(this.val.args[0], this.idx);
    }
    get returnSchema() {
        return this.createToken(this.val.args[1], this.idx + 1);
    }
    Execute(val) {
        if (val.string) return val.string;
        else return val;
    }
    Encode(args) {
        const val = args.pop();
        return val;
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$LambdaToken.prim]) return semantic[$cbefca4388d58836$var$LambdaToken.prim](val);
        return val;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            [$cbefca4388d58836$var$LambdaToken.prim]: {
                parameters: this.paramSchema.ExtractSchema(),
                returns: this.returnSchema.ExtractSchema()
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$LambdaToken.prim,
            schema: {
                parameters: this.paramSchema.generateSchema(),
                returns: this.returnSchema.generateSchema()
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$LambdaToken.prim === tokenToFind) tokens.push(this);
        this.createToken(this.val.args[0], this.idx).findAndReturnTokens(tokenToFind, tokens);
        this.createToken(this.val.args[1], this.idx).findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$cbefca4388d58836$var$LambdaToken.prim = 'lambda';
class $cbefca4388d58836$var$OperationToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return val.string;
    }
    Encode(...args) {
        const val = args.pop();
        return {
            string: val
        };
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$OperationToken.prim]) return semantic[$cbefca4388d58836$var$OperationToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$OperationToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$OperationToken.prim,
            schema: $cbefca4388d58836$var$OperationToken.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$OperationToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$OperationToken.prim = 'operation';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Set
 */ class $cbefca4388d58836$export$786223ef641acb63 extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'SetValidationError';
    }
}
class $cbefca4388d58836$var$SetToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get KeySchema() {
        return this.createToken(this.val.args[0], 0);
    }
    /**
     * @throws {@link SetValidationError}
     */ validate(value) {
        if (!Array.isArray(value)) throw new $cbefca4388d58836$export$786223ef641acb63(value, this, `Value ${JSON.stringify(value)} is not an array`);
    }
    /**
     * @throws {@link SetValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return val.sort((a, b)=>this.KeySchema.compare(a, b)).reduce((prev, current)=>{
            return [
                ...prev,
                this.KeySchema.EncodeObject(current)
            ];
        }, []);
    }
    Execute(val, semantics) {
        return val.reduce((prev, current)=>{
            return [
                ...prev,
                this.KeySchema.Execute(current, semantics)
            ];
        }, []);
    }
    /**
     * @throws {@link SetValidationError}
     */ EncodeObject(args, semantic) {
        this.validate(args);
        if (semantic && semantic[$cbefca4388d58836$var$SetToken.prim]) return semantic[$cbefca4388d58836$var$SetToken.prim](args);
        return args.sort((a, b)=>this.KeySchema.compare(a, b)).reduce((prev, current)=>{
            return [
                ...prev,
                this.KeySchema.EncodeObject(current)
            ];
        }, []);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$SetToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$SetToken.prim,
            schema: this.KeySchema.generateSchema()
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$SetToken.prim === tokenToFind) tokens.push(this);
        this.KeySchema.findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$cbefca4388d58836$var$SetToken.prim = 'set';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a ChainID
 */ class $cbefca4388d58836$export$ec6d6a37188dd52 extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'ChainIDValidationError';
    }
}
class $cbefca4388d58836$var$ChainIDToken extends $cbefca4388d58836$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link ChainIDValidationError}
     */ validate(value) {
        if ((0, $201657d342d01b1b$export$cb16a5d2af893df6)(value) !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new $cbefca4388d58836$export$ec6d6a37188dd52(value, this, `Value ${JSON.stringify(value)} is not a valid ChainID`);
    }
    Execute(val) {
        return val[Object.keys(val)[0]];
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$ChainIDToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$ChainIDToken.prim,
            schema: $cbefca4388d58836$var$ChainIDToken.prim
        };
    }
    /**
     * @throws {@link ChainIDValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link ChainIDValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$ChainIDToken.prim]) return semantic[$cbefca4388d58836$var$ChainIDToken.prim](val);
        return {
            string: val
        };
    }
    ToKey({ string: string }) {
        return string;
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $cbefca4388d58836$var$ChainIDToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$ChainIDToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$ChainIDToken.prim = 'chain_id';
/**
 *  @category Error
 *  @description Error that indicates a failure when encoding and sending a ticket to the blockchain
 */ class $cbefca4388d58836$export$b30bdb452623318c extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(){
        super();
        this.name = 'TicketEncodeError';
        this.message = 'Tickets cannot be sent to the blockchain; they are created on-chain';
    }
}
const $cbefca4388d58836$var$ticketerType$1 = {
    prim: 'contract'
};
const $cbefca4388d58836$var$amountType$1 = {
    prim: 'int'
};
class $cbefca4388d58836$var$TicketToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get valueToken() {
        return this.createToken(this.val.args[0], this.idx);
    }
    /**
     * @throws {@link EncodeTicketError}
     */ Encode(_args) {
        throw new $cbefca4388d58836$export$b30bdb452623318c();
    }
    /**
     * @throws {@link EncodeTicketError}
     */ EncodeObject(args, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$TicketToken.prim]) return semantic[$cbefca4388d58836$var$TicketToken.prim](args, this.val);
        throw new $cbefca4388d58836$export$b30bdb452623318c();
    }
    Execute(val, semantics) {
        if (semantics && semantics[$cbefca4388d58836$var$TicketToken.prim]) return semantics[$cbefca4388d58836$var$TicketToken.prim](val, this.val);
        const ticketer = this.createToken($cbefca4388d58836$var$ticketerType$1, this.idx);
        const value = this.valueToken;
        const amount = this.createToken($cbefca4388d58836$var$amountType$1, this.idx);
        if (undefined === val.args[2] && undefined !== val.args[1].args) return {
            ticketer: ticketer.Execute(val.args[0], semantics),
            value: value.Execute(val.args[1].args[0], semantics),
            amount: amount.Execute(val.args[1].args[1], semantics)
        };
        return {
            ticketer: ticketer.Execute(val.args[0], semantics),
            value: value.Execute(val.args[1], semantics),
            amount: amount.Execute(val.args[2], semantics)
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            ticketer: $cbefca4388d58836$var$ContractToken.prim,
            value: this.valueToken.ExtractSchema(),
            amount: $cbefca4388d58836$var$IntToken.prim
        };
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$TicketToken.prim,
            schema: {
                value: this.valueToken.generateSchema(),
                ticketer: {
                    __michelsonType: $cbefca4388d58836$var$ContractToken.prim,
                    schema: $cbefca4388d58836$var$ContractToken.prim
                },
                amount: {
                    __michelsonType: $cbefca4388d58836$var$IntToken.prim,
                    schema: $cbefca4388d58836$var$IntToken.prim
                }
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$TicketToken.prim === tokenToFind) tokens.push(this);
        this.valueToken.findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$cbefca4388d58836$var$TicketToken.prim = 'ticket';
/**
 *  @category Error
 *  @description Error that indicates a failure when encoding and sending a ticket to the blockchain
 */ class $cbefca4388d58836$var$EncodeTicketDeprecatedError extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(){
        super();
        this.name = 'TicketDeprecatedEncodeError';
        this.message = 'Ticket_deprecated cannot be sent to the blockchain; they are created on-chain';
    }
}
const $cbefca4388d58836$var$ticketerType = {
    prim: 'contract'
};
const $cbefca4388d58836$var$amountType = {
    prim: 'int'
};
class $cbefca4388d58836$var$TicketDeprecatedToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get valueToken() {
        return this.createToken(this.val.args[0], this.idx);
    }
    /**
     * @throws {@link EncodeTicketDeprecatedError}
     */ Encode(_args) {
        throw new $cbefca4388d58836$var$EncodeTicketDeprecatedError();
    }
    /**
     * @throws {@link EncodeTicketDeprecatedError}
     */ EncodeObject(args, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$TicketDeprecatedToken.prim]) return semantic[$cbefca4388d58836$var$TicketDeprecatedToken.prim](args, this.val);
        throw new $cbefca4388d58836$var$EncodeTicketDeprecatedError();
    }
    Execute(val, semantics) {
        if (semantics && semantics[$cbefca4388d58836$var$TicketDeprecatedToken.prim]) return semantics[$cbefca4388d58836$var$TicketDeprecatedToken.prim](val, this.val);
        const ticketer = this.createToken($cbefca4388d58836$var$ticketerType, this.idx);
        const value = this.valueToken;
        const amount = this.createToken($cbefca4388d58836$var$amountType, this.idx);
        if (undefined === val.args[2] && undefined !== val.args[1].args) return {
            ticketer: ticketer.Execute(val.args[0], semantics),
            value: value.Execute(val.args[1].args[0], semantics),
            amount: amount.Execute(val.args[1].args[1], semantics)
        };
        return {
            ticketer: ticketer.Execute(val.args[0], semantics),
            value: value.Execute(val.args[1], semantics),
            amount: amount.Execute(val.args[2], semantics)
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            ticketer: $cbefca4388d58836$var$ContractToken.prim,
            value: this.valueToken.ExtractSchema(),
            amount: $cbefca4388d58836$var$IntToken.prim
        };
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$TicketDeprecatedToken.prim,
            schema: {
                value: this.valueToken.generateSchema(),
                ticketer: {
                    __michelsonType: $cbefca4388d58836$var$ContractToken.prim,
                    schema: $cbefca4388d58836$var$ContractToken.prim
                },
                amount: {
                    __michelsonType: $cbefca4388d58836$var$IntToken.prim,
                    schema: $cbefca4388d58836$var$IntToken.prim
                }
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$TicketDeprecatedToken.prim === tokenToFind) tokens.push(this);
        this.valueToken.findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$cbefca4388d58836$var$TicketDeprecatedToken.prim = 'ticket_deprecated';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Never Token
 */ class $cbefca4388d58836$var$NeverTokenError extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'NeverTokenError';
    }
}
class $cbefca4388d58836$var$NeverToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link NeverTokenError}
     */ Encode(args) {
        const val = args.pop();
        throw new $cbefca4388d58836$var$NeverTokenError(val, this, `Assigning a value to the type never is forbidden. Trying to assign ${JSON.stringify(val)}.`);
    }
    /**
     * @throws {@link NeverTokenError}
     */ EncodeObject(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$NeverToken.prim]) return semantic[$cbefca4388d58836$var$NeverToken.prim](val);
        throw new $cbefca4388d58836$var$NeverTokenError(val, this, `Assigning a value to the type never is forbidden. Trying to assign ${JSON.stringify(val)}.`);
    }
    /**
     * @throws {@link NeverTokenError}
     */ Execute(val) {
        throw new $cbefca4388d58836$var$NeverTokenError(val, this, `There is no literal value for the type never. Trying to execute ${JSON.stringify(val)}.`);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$NeverToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$NeverToken.prim,
            schema: $cbefca4388d58836$var$NeverToken.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$NeverToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$NeverToken.prim = 'never';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Sapling State
 */ class $cbefca4388d58836$var$SaplingStateValidationError extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'SaplingStateValidationError';
    }
}
class $cbefca4388d58836$var$SaplingStateToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    isValid(val) {
        return typeof val === 'object' && Object.keys(val).length === 0;
    }
    /**
     * @throws {@link SaplingStateValidationError}
     */ Execute(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$SaplingStateToken.prim]) return semantic[$cbefca4388d58836$var$SaplingStateToken.prim](val, this.val);
        if ('int' in val) return val.int;
        else throw new $cbefca4388d58836$var$SaplingStateValidationError(val, this, `Sapling state is expecting an object with an int property. Got ${JSON.stringify(val)}`);
    }
    /**
     * @throws {@link SaplingStateValidationError}
     */ Encode(args) {
        const val = args.pop();
        if (this.isValid(val)) return [];
        else throw new $cbefca4388d58836$var$SaplingStateValidationError(val, this, `Invalid sapling_state. Received: ${JSON.stringify(val)} while expecting: {}`);
    }
    /**
     * @throws {@link SaplingStateValidationError}
     */ EncodeObject(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$SaplingStateToken.prim]) return semantic[$cbefca4388d58836$var$SaplingStateToken.prim](val);
        if (this.isValid(val)) return [];
        else throw new $cbefca4388d58836$var$SaplingStateValidationError(val, this, `Invalid sapling_state. Received: ${JSON.stringify(val)} while expecting: {}`);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            [$cbefca4388d58836$var$SaplingStateToken.prim]: {
                'memo-size': Number(this.val.args[0]['int'])
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$SaplingStateToken.prim,
            schema: {
                memoSize: this.val.args[0]['int']
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$SaplingStateToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$SaplingStateToken.prim = 'sapling_state';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Sapling Transaction
 */ class $cbefca4388d58836$var$SaplingTransactionValidationError extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'SaplingTransactionValidationError';
    }
}
class $cbefca4388d58836$var$SaplingTransactionToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link SaplingTransactionValidationError}
     */ Execute(_val) {
        throw new $cbefca4388d58836$var$SaplingTransactionValidationError(_val, this, `There is no literal value for the sapling_transaction type. Got: ${JSON.stringify(_val)}.`);
    }
    /**
     * @throws {@link SaplingTransactionValidationError}
     */ validateBytes(val) {
        const bytes = /^(0x|0X)?([0-9a-fA-F]*$)/.exec(val);
        if (bytes && bytes[2].length % 2 === 0) return bytes[2];
        else throw new $cbefca4388d58836$var$SaplingTransactionValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $cbefca4388d58836$require$Buffer.from(val).toString('hex') : val;
    }
    Encode(args) {
        let val = args.pop();
        val = this.validateBytes(this.convertUint8ArrayToHexString(val));
        return {
            bytes: String(val).toString()
        };
    }
    EncodeObject(val, semantic) {
        val = this.validateBytes(this.convertUint8ArrayToHexString(val));
        if (semantic && semantic[$cbefca4388d58836$var$SaplingTransactionToken.prim]) return semantic[$cbefca4388d58836$var$SaplingTransactionToken.prim](val);
        return {
            bytes: String(val).toString()
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            [$cbefca4388d58836$var$SaplingTransactionToken.prim]: {
                'memo-size': Number(this.val.args[0]['int'])
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$SaplingTransactionToken.prim,
            schema: {
                memoSize: this.val.args[0]['int']
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$SaplingTransactionToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$SaplingTransactionToken.prim = 'sapling_transaction';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Sapling Transaction Deprecated
 */ class $cbefca4388d58836$var$SaplingTransactionDeprecatedValidationError extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'SaplingTransactionDeprecatedValidationError';
    }
}
class $cbefca4388d58836$var$SaplingTransactionDeprecatedToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link SaplingTransactionDeprecatedValidationError}
     */ Execute(_val) {
        throw new $cbefca4388d58836$var$SaplingTransactionDeprecatedValidationError(_val, this, `There is no literal value for the sapling_transaction_deprecated type. Got: ${JSON.stringify(_val)}.`);
    }
    /**
     * @throws {@link SaplingTransactionDeprecatedValidationError}
     */ validateBytes(val) {
        const bytes = /^(0x|0X)?([0-9a-fA-F]*$)/.exec(val);
        if (bytes && bytes[2].length % 2 === 0) return bytes[2];
        else throw new $cbefca4388d58836$var$SaplingTransactionDeprecatedValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $cbefca4388d58836$require$Buffer.from(val).toString('hex') : val;
    }
    Encode(args) {
        let val = args.pop();
        val = this.validateBytes(this.convertUint8ArrayToHexString(val));
        return {
            bytes: String(val).toString()
        };
    }
    EncodeObject(val, semantic) {
        val = this.validateBytes(this.convertUint8ArrayToHexString(val));
        if (semantic && semantic[$cbefca4388d58836$var$SaplingTransactionDeprecatedToken.prim]) return semantic[$cbefca4388d58836$var$SaplingTransactionDeprecatedToken.prim](val);
        return {
            bytes: String(val).toString()
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            [$cbefca4388d58836$var$SaplingTransactionDeprecatedToken.prim]: {
                'memo-size': Number(this.val.args[0]['int'])
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$SaplingTransactionDeprecatedToken.prim,
            schema: {
                memoSize: this.val.args[0]['int']
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$SaplingTransactionDeprecatedToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$SaplingTransactionDeprecatedToken.prim = 'sapling_transaction_deprecated';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a BLS12-381 scalar field Fr
 */ class $cbefca4388d58836$var$Bls12381frValidationError extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'Bls12381frValidationError';
    }
}
class $cbefca4388d58836$var$Bls12381frToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link Bls12381frValidationError}
     */ validate(val) {
        if (/^[0-9a-fA-F]*$/.test(val) && val.length % 2 === 0) return;
        throw new $cbefca4388d58836$var$Bls12381frValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $cbefca4388d58836$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link Bls12381frValidationError}
     */ Encode(args) {
        let val = args.pop();
        if (typeof val === 'number') return {
            int: val.toString()
        };
        else {
            val = this.convertUint8ArrayToHexString(val);
            this.validate(val);
            return {
                bytes: val
            };
        }
    }
    /**
     * @throws {@link Bls12381frValidationError}
     */ EncodeObject(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$Bls12381frToken.prim]) return semantic[$cbefca4388d58836$var$Bls12381frToken.prim](val);
        if (typeof val === 'number') return {
            int: val.toString()
        };
        else {
            val = this.convertUint8ArrayToHexString(val);
            this.validate(val);
            return {
                bytes: val
            };
        }
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$Bls12381frToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$Bls12381frToken.prim,
            schema: $cbefca4388d58836$var$Bls12381frToken.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$Bls12381frToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
// An element of the BLS12-381 scalar field Fr
// see https://tezos.gitlab.io/michelson-reference/#type-bls12_381_fr
$cbefca4388d58836$var$Bls12381frToken.prim = 'bls12_381_fr';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a BLS12-381 curve G1
 */ class $cbefca4388d58836$var$Bls12381g1ValidationError extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'Bls12381g1ValidationError';
    }
}
class $cbefca4388d58836$var$Bls12381g1Token extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link Bls12381g1ValidationError}
     */ validate(val) {
        if (/^[0-9a-fA-F]*$/.test(val) && val.length % 2 === 0) return;
        throw new $cbefca4388d58836$var$Bls12381g1ValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $cbefca4388d58836$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link Bls12381g1ValidationError}
     */ Encode(args) {
        let val = args.pop();
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        return {
            bytes: val
        };
    }
    /**
     * @throws {@link Bls12381g1ValidationError}
     */ EncodeObject(val, semantic) {
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$Bls12381g1Token.prim]) return semantic[$cbefca4388d58836$var$Bls12381g1Token.prim](val);
        return {
            bytes: val
        };
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$Bls12381g1Token.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$Bls12381g1Token.prim,
            schema: $cbefca4388d58836$var$Bls12381g1Token.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$Bls12381g1Token.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
// A point on the BLS12-381 curve G1
// See https://tezos.gitlab.io/michelson-reference/#type-bls12_381_g1
$cbefca4388d58836$var$Bls12381g1Token.prim = 'bls12_381_g1';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a BLS12-381 curve G2
 */ class $cbefca4388d58836$var$Bls12381g2ValidationError extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'Bls12381g2ValidationError';
    }
}
class $cbefca4388d58836$var$Bls12381g2Token extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link Bls12381g2ValidationError}
     */ validate(val) {
        if (/^[0-9a-fA-F]*$/.test(val) && val.length % 2 === 0) return;
        throw new $cbefca4388d58836$var$Bls12381g2ValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $cbefca4388d58836$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link Bls12381g2ValidationError}
     */ Encode(args) {
        let val = args.pop();
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        return {
            bytes: val
        };
    }
    /**
     * @throws {@link Bls12381g2ValidationError}
     */ EncodeObject(val, semantic) {
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$Bls12381g2Token.prim]) return semantic[$cbefca4388d58836$var$Bls12381g2Token.prim](val);
        return {
            bytes: val
        };
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$Bls12381g2Token.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$Bls12381g2Token.prim,
            schema: $cbefca4388d58836$var$Bls12381g2Token.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$Bls12381g2Token.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
// A point on the BLS12-381 curve G2
// See https://tezos.gitlab.io/michelson-reference/#type-bls12_381_g2
$cbefca4388d58836$var$Bls12381g2Token.prim = 'bls12_381_g2';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Chest
 */ class $cbefca4388d58836$var$ChestValidationError extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'ChestValidationError';
    }
}
class $cbefca4388d58836$var$ChestToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ validate(val) {
        if (/^[0-9a-fA-F]*$/.test(val) && val.length % 2 == 0) return;
        throw new $cbefca4388d58836$var$ChestValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $cbefca4388d58836$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ Encode(args) {
        let val = args.pop();
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        return {
            bytes: val
        };
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ EncodeObject(val, semantic) {
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$ChestToken.prim]) return semantic[$cbefca4388d58836$var$ChestToken.prim](val);
        return {
            bytes: val
        };
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$ChestToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$ChestToken.prim,
            schema: $cbefca4388d58836$var$ChestToken.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$ChestToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$ChestToken.prim = 'chest';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Chest Key
 */ class $cbefca4388d58836$var$ChestKeyValidationError extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'ChestKeyValidationError';
    }
}
class $cbefca4388d58836$var$ChestKeyToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ validate(val) {
        if (/^[0-9a-fA-F]*$/.test(val) && val.length % 2 === 0) return;
        throw new $cbefca4388d58836$var$ChestKeyValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $cbefca4388d58836$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ Encode(args) {
        let val = args.pop();
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        return {
            bytes: val
        };
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ EncodeObject(val, semantic) {
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        if (semantic && semantic[$cbefca4388d58836$var$ChestKeyToken.prim]) return semantic[$cbefca4388d58836$var$ChestKeyToken.prim](val);
        return {
            bytes: val
        };
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$ChestKeyToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$ChestKeyToken.prim,
            schema: $cbefca4388d58836$var$ChestKeyToken.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$ChestKeyToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$ChestKeyToken.prim = 'chest_key';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding a Global Constant
 */ class $cbefca4388d58836$var$GlobalConstantEncodingError extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'GlobalConstantEncodingError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing executing a Global Constant
 */ class $cbefca4388d58836$var$GlobalConstantDecodingError extends $cbefca4388d58836$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'GlobalConstantDecodingError';
    }
}
class $cbefca4388d58836$var$GlobalConstantToken extends $cbefca4388d58836$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link GlobalConstantDecodingError}
     */ Execute(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$GlobalConstantToken.prim]) return semantic[$cbefca4388d58836$var$GlobalConstantToken.prim](val, this.val);
        else throw new $cbefca4388d58836$var$GlobalConstantDecodingError(val, this, `Unable to decode a value represented by a global constants. Please provide an expanded script to the Michelson-Encoder or semantics for the decoding. The following global constant hash was encountered: ${this.val.args[0]['string']}.`);
    }
    /**
     * @throws {@link GlobalConstantEncodingError}
     */ Encode(args) {
        throw new $cbefca4388d58836$var$GlobalConstantEncodingError(args, this, `Unable to encode a script containing global constants. Please provide an expanded script to the Michelson-Encoder. The following global constant hash was encountered: ${this.val.args[0]['string']}.`);
    }
    /**
     * @throws {@link GlobalConstantEncodingError}
     */ EncodeObject(val, semantic) {
        if (semantic && semantic[$cbefca4388d58836$var$GlobalConstantToken.prim]) return semantic[$cbefca4388d58836$var$GlobalConstantToken.prim](val);
        throw new $cbefca4388d58836$var$GlobalConstantEncodingError(val, this, `Unable to encode a script containing global constants. Please provide an expanded script to the Michelson-Encoder. The following global constant hash was encountered: ${this.val.args[0]['string']}.`);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $cbefca4388d58836$var$GlobalConstantToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $cbefca4388d58836$var$GlobalConstantToken.prim,
            schema: {
                hash: this.val.args[0]['string']
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($cbefca4388d58836$var$GlobalConstantToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$cbefca4388d58836$var$GlobalConstantToken.prim = 'constant';
const $cbefca4388d58836$var$tokens = [
    $cbefca4388d58836$var$PairToken,
    $cbefca4388d58836$var$NatToken,
    $cbefca4388d58836$var$StringToken,
    $cbefca4388d58836$var$BigMapToken,
    $cbefca4388d58836$var$AddressToken,
    $cbefca4388d58836$var$MapToken,
    $cbefca4388d58836$var$BoolToken,
    $cbefca4388d58836$var$OrToken,
    $cbefca4388d58836$var$ContractToken,
    $cbefca4388d58836$var$ListToken,
    $cbefca4388d58836$var$MutezToken,
    $cbefca4388d58836$var$BytesToken,
    $cbefca4388d58836$var$OptionToken,
    $cbefca4388d58836$var$TimestampToken,
    $cbefca4388d58836$var$IntToken,
    $cbefca4388d58836$var$UnitToken,
    $cbefca4388d58836$var$KeyToken,
    $cbefca4388d58836$var$KeyHashToken,
    $cbefca4388d58836$var$SignatureToken,
    $cbefca4388d58836$var$LambdaToken,
    $cbefca4388d58836$var$OperationToken,
    $cbefca4388d58836$var$SetToken,
    $cbefca4388d58836$var$ChainIDToken,
    $cbefca4388d58836$var$TicketToken,
    $cbefca4388d58836$var$TicketDeprecatedToken,
    $cbefca4388d58836$var$NeverToken,
    $cbefca4388d58836$var$SaplingStateToken,
    $cbefca4388d58836$var$SaplingTransactionToken,
    $cbefca4388d58836$var$SaplingTransactionDeprecatedToken,
    $cbefca4388d58836$var$Bls12381frToken,
    $cbefca4388d58836$var$Bls12381g1Token,
    $cbefca4388d58836$var$Bls12381g2Token,
    $cbefca4388d58836$var$ChestToken,
    $cbefca4388d58836$var$ChestKeyToken,
    $cbefca4388d58836$var$GlobalConstantToken
];
/**
 *  @category Error
 *  @description Error that indicates a script having an invalid type or it being unsupported by the Michelson Encoder. Note some protocol changes might affect this, we encourage users to open an issue so we can look into implementing support for said types.
 */ class $cbefca4388d58836$var$InvalidTokenError extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(message, data){
        super(message);
        this.message = message;
        this.data = data;
        this.name = 'Invalid token error';
    }
}
/**
 *
 * @description Create a token from a value
 * @throws {@link InvalidTokenError} If the value passed is not supported by the Michelson Encoder
 */ function $cbefca4388d58836$var$createToken(val, idx) {
    if (Array.isArray(val)) return new $cbefca4388d58836$var$PairToken(val, idx, $cbefca4388d58836$var$createToken);
    const t = $cbefca4388d58836$var$tokens.find((x)=>x.prim === val.prim);
    if (!t) throw new $cbefca4388d58836$var$InvalidTokenError(`Malformed data: ${JSON.stringify(val)}. Expected a value with a valid prim property`, val);
    return new t(val, idx, $cbefca4388d58836$var$createToken);
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 *  @category Error
 *  @description Error that indicates a failure when encoding (transforming JS parameter into JSON Michelson) the parameter of the view
 */ class $cbefca4388d58836$export$a638dccee41148ef extends (0, $8b6476b09e20f53e$export$f9ce6a924724628b) {
    constructor(viewName, sigs, args, cause){
        super(viewName, sigs, args, cause);
        this.viewName = viewName;
        this.sigs = sigs;
        this.args = args;
        this.cause = cause;
        this.name = 'ParameterEncodingError';
        this.message = `Could not encode parameter ${JSON.stringify(args)} received for name "${viewName}" expecting one of the following signatures ${JSON.stringify(sigs)}`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid on-chain view found on the script
 */ class $cbefca4388d58836$export$665c9bb21f47bbf5 extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(script, reason){
        super();
        this.script = script;
        this.reason = reason;
        this.name = 'InvalidScriptError';
        let message = `Invalid on-chain view found in the following script.`;
        if (reason) message += ` Reason: ${reason}.`;
        message += `Script: ${JSON.stringify(script)}`;
        this.message = message;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid RPC response being passed or used
 */ class $cbefca4388d58836$export$9048a16c3828c4af extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(script, reason){
        super();
        this.script = script;
        this.reason = reason;
        this.name = 'InvalidRpcResponseError';
        let message = `Invalid RPC response passed as argument(s).`;
        if (reason) message += ` Reason: ${reason}.`;
        message += ` Received: ${JSON.stringify(script)}`;
        this.message = message;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid big map schema being passed or used
 */ class $cbefca4388d58836$export$53f8cfbabadba878 extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(message){
        super(message);
        this.message = message;
        this.name = 'InvalidBigMapSchemaError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid big map diff being passed or used
 */ class $cbefca4388d58836$export$3279952fe20c0e7f extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(message, value){
        super(message);
        this.message = message;
        this.value = value;
        this.name = 'InvalidBigMapDiffError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when trying to encode big maps
 */ class $cbefca4388d58836$export$b5954e3349c86d5c extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(obj, details, schema, value){
        super();
        this.details = details;
        this.schema = schema;
        this.value = value;
        this.name = 'BigMapEncodingError';
        this.message = `Unable to encode the big map ${obj}. Schema is: ${JSON.stringify(schema)}. The ${obj} is: ${JSON.stringify(value)}. Error details: ${details}`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when trying to encode storage
 */ class $cbefca4388d58836$export$d46c9c80bc2bb9f6 extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(obj, details, schema, value, semantics){
        super();
        this.details = details;
        this.schema = schema;
        this.value = value;
        this.semantics = semantics;
        this.name = 'StorageEncodingError';
        this.message = `Unable to encode ${obj}. The schema is: ${JSON.stringify(schema)}, the value is: ${JSON.stringify(value)}.${semantics ? `And the semantic is: ${JSON.stringify(semantics)}` : ''}. Error details: ${details}`;
    }
}
/**
 *  @category Error
 *  @description General error that indicates a function not being passed a necessary argument
 */ class $cbefca4388d58836$export$4431adf7a9948431 extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(message){
        super(message);
        this.message = message;
        this.name = 'MissingArgumentError';
    }
}
var $cbefca4388d58836$var$_a;
const $cbefca4388d58836$var$schemaTypeSymbol = Symbol.for('taquito-schema-type-symbol');
// collapse comb pair
function $cbefca4388d58836$var$collapse(val, prim = $cbefca4388d58836$var$PairToken.prim) {
    var _b, _c;
    if (Array.isArray(val)) return $cbefca4388d58836$var$collapse({
        prim: prim,
        args: val
    }, prim);
    const extended = val;
    if (extended.prim === prim && extended.args && extended.args.length > 2) return Object.assign(Object.assign({}, extended), {
        args: [
            (_b = extended.args) === null || _b === void 0 ? void 0 : _b[0],
            {
                prim: prim,
                args: (_c = extended.args) === null || _c === void 0 ? void 0 : _c.slice(1)
            }
        ]
    });
    return extended;
}
function $cbefca4388d58836$export$9cb4719e2e525b7a(a, b) {
    if (a === undefined || b === undefined) return a === b;
    const ac = $cbefca4388d58836$var$collapse(a);
    const bc = $cbefca4388d58836$var$collapse(b);
    return ac.prim === bc.prim && (ac.args === undefined && bc.args === undefined || ac.args !== undefined && bc.args !== undefined && ac.args.length === bc.args.length && ac.args.every((v, i)=>{
        var _b, _c;
        return $cbefca4388d58836$export$9cb4719e2e525b7a(v, (_c = (_b = bc.args) === null || _b === void 0 ? void 0 : _b[i]) !== null && _c !== void 0 ? _c : {});
    })) && (ac.annots === undefined && bc.annots === undefined || ac.annots !== undefined && bc.annots !== undefined && ac.annots.length === bc.annots.length && ac.annots.every((v, i)=>{
        var _b;
        return v === ((_b = bc.annots) === null || _b === void 0 ? void 0 : _b[i]);
    }));
}
/**
 * @warn Our current smart contract abstraction feature is currently in preview. Its API is not final, and it may not cover every use case (yet). We will greatly appreciate any feedback on this feature.
 */ class $cbefca4388d58836$export$19342e026b58ebb7 {
    static isSchema(obj) {
        return obj && obj[$cbefca4388d58836$var$schemaTypeSymbol] === true;
    }
    /**
     * @throws {@link InvalidRpcResponseError}
     */ static fromRPCResponse(val) {
        if (!val) throw new $cbefca4388d58836$export$9048a16c3828c4af(val, 'the RPC response is empty');
        if (!val.script) throw new $cbefca4388d58836$export$9048a16c3828c4af(val, 'the RPC response has no script');
        if (!Array.isArray(val.script.code)) throw new $cbefca4388d58836$export$9048a16c3828c4af(val, 'The response.script.code should be an array');
        let code = val.script.code;
        while(code.length === 1 && Array.isArray(code[0]))code = code[0];
        const storage = code.find((x)=>'prim' in x && x.prim === 'storage');
        if (!storage || !Array.isArray(storage.args)) throw new $cbefca4388d58836$export$9048a16c3828c4af(val, 'The response.script.code has an element of type {prim: "storage"}, but its args is not an array');
        return new $cbefca4388d58836$export$19342e026b58ebb7(storage.args[0]);
    }
    isExpressionExtended(val) {
        return 'prim' in val && Array.isArray(val.args);
    }
    constructor(val){
        this.val = val;
        this[$cbefca4388d58836$var$_a] = true;
        this.root = $cbefca4388d58836$var$createToken(val, 0);
        if (this.root instanceof $cbefca4388d58836$var$BigMapToken) this.bigMap = this.root;
        else if (this.isExpressionExtended(val) && val.prim === 'pair') {
            const exp = val.args[0];
            if (this.isExpressionExtended(exp) && exp.prim === 'big_map') this.bigMap = new $cbefca4388d58836$var$BigMapToken(exp, 0, $cbefca4388d58836$var$createToken);
        }
    }
    removeTopLevelAnnotation(obj) {
        // PairToken and OrToken can have redundant top level annotation in their storage
        if (this.root instanceof $cbefca4388d58836$var$PairToken || this.root instanceof $cbefca4388d58836$var$OrToken) {
            if (this.root.hasAnnotations() && typeof obj === 'object' && Object.keys(obj).length === 1) return obj[Object.keys(obj)[0]];
        }
        return obj;
    }
    Execute(val, semantics) {
        const storage = this.root.Execute(val, semantics);
        return this.removeTopLevelAnnotation(storage);
    }
    Typecheck(val) {
        if (this.root instanceof $cbefca4388d58836$var$BigMapToken && Number.isInteger(Number(val))) return;
        if (this.root instanceof $cbefca4388d58836$var$TicketToken && val.ticketer && val.value && val.amount) return;
        if (this.root instanceof $cbefca4388d58836$var$TicketDeprecatedToken && val.ticketer && val.value && val.amount) return;
        if (this.root instanceof $cbefca4388d58836$var$MapToken && this.root.ValueSchema instanceof $cbefca4388d58836$var$BigMapToken) return;
        this.root.EncodeObject(val);
    }
    /**
     * @throws {@link InvalidBigMapSchemaError}
     * @throws {@link InvalidBigMapDiffError}
     */ ExecuteOnBigMapDiff(diff, semantics) {
        if (!this.bigMap) throw new $cbefca4388d58836$export$53f8cfbabadba878('Big map schema is undefined');
        if (!Array.isArray(diff)) throw new $cbefca4388d58836$export$3279952fe20c0e7f(`Big map diff must be an array, got: ${JSON.stringify(diff)}`, diff);
        const eltFormat = diff.map(({ key: key, value: value })=>({
                args: [
                    key,
                    value
                ]
            }));
        return this.bigMap.Execute(eltFormat, semantics);
    }
    /**
     * @throws {@link InvalidBigMapSchemaError}
     */ ExecuteOnBigMapValue(key, semantics) {
        if (!this.bigMap) throw new $cbefca4388d58836$export$53f8cfbabadba878('Big map schema is undefined');
        return this.bigMap.ValueSchema.Execute(key, semantics);
    }
    /**
     * @throws {@link InvalidBigMapSchemaError}
     * @throws {@link BigMapEncodingError}
     */ EncodeBigMapKey(key) {
        if (!this.bigMap) throw new $cbefca4388d58836$export$53f8cfbabadba878('Big map schema is undefined');
        try {
            return this.bigMap.KeySchema.ToBigMapKey(key);
        } catch (ex) {
            throw new $cbefca4388d58836$export$b5954e3349c86d5c('key', ex, this.bigMap.KeySchema, key);
        }
    }
    /**
     * @throws {@link TokenValidationError}
     * @throws {@link StorageEncodingError}
     */ Encode(value, semantics) {
        try {
            return this.root.EncodeObject(value, semantics);
        } catch (ex) {
            if (ex instanceof $cbefca4388d58836$var$TokenValidationError) throw ex;
            throw new $cbefca4388d58836$export$d46c9c80bc2bb9f6('storage object', ex, this.root, value, semantics);
        }
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return this.removeTopLevelAnnotation(this.root.ExtractSchema());
    }
    /**
     * @description Produce a representation of the storage schema.
     * Note: Provide guidance on how to write the storage object for the origination operation with Taquito.
     */ generateSchema() {
        return this.removeTopLevelAnnotation(this.root.generateSchema());
    }
    /**
     * @deprecated
     * @throws {@link InvalidBigMapSchemaError}
     */ ComputeState(tx, state) {
        if (!this.bigMap) throw new $cbefca4388d58836$export$53f8cfbabadba878('Big map schema is undefined');
        const bigMap = tx.reduce((prev, current)=>{
            return Object.assign(Object.assign({}, prev), this.ExecuteOnBigMapDiff(current.contents[0].metadata.operation_result.big_map_diff));
        }, {});
        return Object.assign(Object.assign({}, this.Execute(state)), {
            [this.bigMap.annot()]: bigMap
        });
    }
    /**
     * @description Look up in top-level pairs of the storage to find a value matching the specified type
     *
     * @returns The first value found that match the type or `undefined` if no value is found
     *
     * @param storage storage to parse to find the value
     * @param valueType type of value to look for
     *
     */ FindFirstInTopLevelPair(storage, valueType) {
        return this.findValue(this.root['val'], storage, valueType);
    }
    // TODO check these type casts
    /**
     * @throws {@link MissingArgumentError}
     */ findValue(schema, storage, valueToFind) {
        if ($cbefca4388d58836$export$9cb4719e2e525b7a(valueToFind, schema)) return storage;
        if (Array.isArray(schema) || schema.prim === 'pair') {
            const sch = $cbefca4388d58836$var$collapse(schema);
            const strg = $cbefca4388d58836$var$collapse(storage, 'Pair');
            if (sch.args === undefined || strg.args === undefined) throw new $cbefca4388d58836$export$4431adf7a9948431('Tokens have no arguments'); // unlikely
            if (sch.args[0]) return(// unsafe
            this.findValue(sch.args[0], strg.args[0], valueToFind) || this.findValue(sch.args[1], strg.args[1], valueToFind));
        }
    }
    /**
     * @description Look up the schema to find any occurrence of a particular token.
     *
     * @returns an array of tokens of the specified kind or an empty array if no token was found
     *
     * @param tokenToFind string representing the prim property of the token to find
     *
     * @example
     * ```
     * Useful to find all global constants in a script, an array of GlobalConstantToken is returned:
     *
     * const schema = new Schema(script);
     * const allGlobalConstantTokens = schema.findToken('constant');
     * ```
     *
     */ findToken(tokenToFind) {
        const tokens = [];
        return this.root.findAndReturnTokens(tokenToFind, tokens);
    }
}
$cbefca4388d58836$var$_a = $cbefca4388d58836$var$schemaTypeSymbol;
/**
 * @warn Our current smart contract abstraction feature is currently in preview. It's API is not final, and it may not cover every use case (yet). We will greatly appreciate any feedback on this feature.
 */ class $cbefca4388d58836$export$54a0993a9ed335cf {
    /**
     *
     * @description Create an instance of ParameterSchema from a contract script
     *
     * @param val contract script obtained from the RPC
     * @returns ParameterSchema
     * @throws {InvalidRpcResponseError} If the RPC response is invalid
     */ static fromRPCResponse(val) {
        if (!val) throw new $cbefca4388d58836$export$9048a16c3828c4af(val, 'the RPC response is empty');
        if (!val.script) throw new $cbefca4388d58836$export$9048a16c3828c4af(val, 'the RPC response has no script');
        if (!Array.isArray(val.script.code)) throw new $cbefca4388d58836$export$9048a16c3828c4af(val, 'The response.script.code should be an array');
        const parameter = val.script.code.find((x)=>'prim' in x && x.prim === 'parameter');
        if (!parameter) throw new $cbefca4388d58836$export$9048a16c3828c4af(val, `The response.script.code should have an element of type {prim: "parameter"}`);
        if (!Array.isArray(parameter.args)) throw new $cbefca4388d58836$export$9048a16c3828c4af(val, `The response.script.code has an element of type {prim: "parameter"}, but its args is not an array`);
        return new $cbefca4388d58836$export$54a0993a9ed335cf(parameter.args[0]);
    }
    /**
     * @description Check if the Contract parameter is multiple entry point or not
     */ get isMultipleEntryPoint() {
        return this.root instanceof $cbefca4388d58836$var$OrToken || this.root instanceof $cbefca4388d58836$var$OptionToken && this.root.subToken() instanceof $cbefca4388d58836$var$OrToken;
    }
    /**
     * @description Check if the Contract parameter has an annotation or not
     */ get hasAnnotation() {
        if (this.isMultipleEntryPoint) return Object.keys(this.ExtractSchema())[0] !== '0';
        else return true;
    }
    /**
     * @description Return the schema of the parameter of a specific entry point
     * @throws {@link InvalidTokenError}
     */ constructor(val){
        this.root = $cbefca4388d58836$var$createToken(val, 0);
    }
    /**
     * @description Returns the javascript object equivalent of the Micheline value provided
     */ Execute(val, semantics) {
        return this.root.Execute(val, semantics);
    }
    /**
     * @description Returns a micheline formatted object for the values provided
     * @throws {@link TokenValidationError}
     * @throws {@link ParameterEncodingError}
     */ Encode(...args) {
        try {
            return this.root.Encode(args.reverse());
        } catch (ex) {
            if (ex instanceof $cbefca4388d58836$var$TokenValidationError) throw ex;
            throw new $cbefca4388d58836$export$a638dccee41148ef('Unable to encode parameter', this.root, args, ex);
        }
    }
    /**
     * @description Returns a micheline formatted object for the javascript object provided
     * @throws {@link TokenValidationError}
     * @throws {@link ParameterEncodingError}
     */ EncodeObject(value, semantics) {
        try {
            return this.root.EncodeObject(value, semantics);
        } catch (ex) {
            if (ex instanceof $cbefca4388d58836$var$TokenValidationError) throw ex;
            throw new $cbefca4388d58836$export$a638dccee41148ef('Unable to encode parameter object', this.root, value, ex);
        }
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return this.root.ExtractSchema();
    }
    /**
     * @description Produce a schema grouping together all the entry points of a contract.
     */ generateSchema() {
        return this.root.generateSchema();
    }
    ExtractSignatures() {
        return this.root.ExtractSignature();
    }
}
class $cbefca4388d58836$export$d422a5b447f0dce1 {
    /**
     *
     * @description Create an instance of ViewSchema for each view in a script
     *
     * @param val contract script obtained from the RPC
     * @returns array of ViewSchema or empty array if there is no view in the contract
     * @throws {@link InvalidScriptError}
     */ static fromRPCResponse(val) {
        const allViewSchema = [];
        const views = val && val.script && Array.isArray(val.script.code) && val.script.code.filter((x)=>x.prim === 'view');
        if (views) views.forEach((view)=>{
            allViewSchema.push(new $cbefca4388d58836$export$d422a5b447f0dce1(view.args));
        });
        return allViewSchema;
    }
    /**
     * @throws {@link InvalidScriptError}
     */ constructor(viewArgs){
        if (!viewArgs) throw new $cbefca4388d58836$export$665c9bb21f47bbf5(viewArgs, 'the args are not defined');
        if (viewArgs.length !== 4) throw new $cbefca4388d58836$export$665c9bb21f47bbf5(viewArgs, `there should be exactly 4 arguments`);
        if (!('string' in viewArgs[0]) || !viewArgs[0]['string']) throw new $cbefca4388d58836$export$665c9bb21f47bbf5(viewArgs, `The first argument should be a string, representing the view name. It should be in the form: { string: 'viewName' }`);
        this.viewName = viewArgs[0]['string'];
        this.viewArgsType = viewArgs[1];
        this.viewReturnType = viewArgs[2];
        this.instructions = viewArgs[3];
        this.rootArgsType = $cbefca4388d58836$var$createToken(this.viewArgsType, 0);
        this.rootReturnType = $cbefca4388d58836$var$createToken(this.viewReturnType, 0);
    }
    /**
     *
     * @description Transform the view parameter into Michelson
     *
     * @param args parameter of the view in js format
     * @returns parameter of the view in Michelson
     * @throws {@link ParameterEncodingError}
     */ encodeViewArgs(args) {
        try {
            return this.rootArgsType.EncodeObject(args);
        } catch (ex) {
            throw new $cbefca4388d58836$export$a638dccee41148ef(this.viewName, undefined, args, ex);
        }
    }
    /**
     *
     * @description Transform the view result from Michelson to readable data
     *
     * @param val result of the view in JSON Michelson
     * @param semantics optional semantics to override the default decoding behavior
     * @returns result of the view in a readable format
     */ decodeViewResult(val, semantics) {
        return this.rootReturnType.Execute(val, semantics);
    }
    /**
     *
     * @description Return the signature of the view parameter
     */ extractArgsSchema() {
        return this.rootArgsType.ExtractSchema();
    }
    /**
     *
     * @description Return the format of the view result
     */ extractResultSchema() {
        return this.rootReturnType.ExtractSchema();
    }
}
class $cbefca4388d58836$export$769a4ec051ed522c {
    constructor(tag, type){
        this.tag = tag;
        this.type = type;
    }
    static fromMichelineValue(val) {
        var _a, _b;
        return new $cbefca4388d58836$export$769a4ec051ed522c((_a = val.annots) === null || _a === void 0 ? void 0 : _a[0], (_b = val.args) === null || _b === void 0 ? void 0 : _b[0]);
    }
    static fromRPCResponse(val) {
        const allEventSchema = [];
        val.script.code.forEach((code)=>{
            if (!('prim' in code) || code.prim !== 'code' || !('args' in code) || !code.args) return;
            allEventSchema.push(...$cbefca4388d58836$export$769a4ec051ed522c.extractEventsRecursively(code.args));
        });
        return $cbefca4388d58836$export$769a4ec051ed522c.removeDuplicates(allEventSchema);
    }
    static removeDuplicates(events) {
        const uniqueEvents = [];
        events.forEach((event)=>{
            const idx = uniqueEvents.findIndex((e)=>e.tag === event.tag && $cbefca4388d58836$export$9cb4719e2e525b7a(e.type, event.type));
            if (idx === -1) uniqueEvents.push(event);
        });
        return uniqueEvents;
    }
    static extractEventsRecursively(code) {
        if (Array.isArray(code)) return code.flatMap((c)=>$cbefca4388d58836$export$769a4ec051ed522c.extractEventsRecursively(c));
        if (!('prim' in code)) return [];
        if (code.prim === 'EMIT') return [
            $cbefca4388d58836$export$769a4ec051ed522c.fromMichelineValue(code)
        ];
        if (!('args' in code) || !code.args) return [];
        return code.args.flatMap((c)=>$cbefca4388d58836$export$769a4ec051ed522c.extractEventsRecursively(c));
    }
}
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $cbefca4388d58836$export$a4ad2735b021c132 = {
    "commitHash": "2e05f6f865be17a1b367b284542b24ffa9823271",
    "version": "19.2.1"
};
/**
 * @packageDocumentation
 * @module @taquito/michelson-encoder
 */ const $cbefca4388d58836$export$d703b7d35511419c = Symbol();
const $cbefca4388d58836$export$19923f35e11d5203 = {};





// Michelson abstract syntax tree types https://tezos.gitlab.io/whitedoc/michelson.html#concrete-syntax
const $463f724b64570f1c$export$ad6cc7932321c4f3 = Symbol('source_reference');
/**
 *  @category Error
 *  @description Error that indicates a failure when performing the scan step when parsing Michelson
 */ class $463f724b64570f1c$var$ScanError extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(src, idx, message){
        super();
        this.src = src;
        this.idx = idx;
        this.message = message;
        this.name = 'ScanError';
    }
}
var $463f724b64570f1c$var$Literal;
(function(Literal) {
    Literal[Literal["Comment"] = 0] = "Comment";
    Literal[Literal["Number"] = 1] = "Number";
    Literal[Literal["String"] = 2] = "String";
    Literal[Literal["Bytes"] = 3] = "Bytes";
    Literal[Literal["Ident"] = 4] = "Ident";
})($463f724b64570f1c$var$Literal || ($463f724b64570f1c$var$Literal = {}));
const $463f724b64570f1c$var$isSpace = new RegExp('\\s');
const $463f724b64570f1c$var$isIdentStart = new RegExp('[:@%_A-Za-z]');
const $463f724b64570f1c$var$isIdent = new RegExp('[@%_\\.A-Za-z0-9]');
const $463f724b64570f1c$var$isDigit = new RegExp('[0-9]');
const $463f724b64570f1c$var$isHex = new RegExp('[0-9a-fA-F]');
function* $463f724b64570f1c$var$scan(src, scanComments = false) {
    let i = 0;
    while(i < src.length){
        // Skip space
        while(i < src.length && $463f724b64570f1c$var$isSpace.test(src[i]))i++;
        if (i === src.length) return;
        const s = src[i];
        const start = i;
        if ($463f724b64570f1c$var$isIdentStart.test(s)) {
            // Identifier
            i++;
            while(i < src.length && $463f724b64570f1c$var$isIdent.test(src[i]))i++;
            yield {
                t: $463f724b64570f1c$var$Literal.Ident,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if (src.length - i > 1 && src.substring(i, i + 2) === '0x') {
            // Bytes
            i += 2;
            while(i < src.length && $463f724b64570f1c$var$isHex.test(src[i]))i++;
            if ((i - start & 1) !== 0) throw new $463f724b64570f1c$var$ScanError(src, i, 'Bytes literal length is expected to be power of two');
            yield {
                t: $463f724b64570f1c$var$Literal.Bytes,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if ($463f724b64570f1c$var$isDigit.test(s) || s === '-') {
            // Number
            if (s === '-') i++;
            const ii = i;
            while(i < src.length && $463f724b64570f1c$var$isDigit.test(src[i]))i++;
            if (ii === i) throw new $463f724b64570f1c$var$ScanError(src, i, 'Number literal is too short');
            yield {
                t: $463f724b64570f1c$var$Literal.Number,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if (s === '"') {
            // String
            i++;
            let esc = false;
            for(; i < src.length && (esc || src[i] !== '"'); i++)if (!esc && src[i] === '\\') esc = true;
            else esc = false;
            if (i === src.length) throw new $463f724b64570f1c$var$ScanError(src, i, 'Unterminated string literal');
            i++;
            yield {
                t: $463f724b64570f1c$var$Literal.String,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if (s === '#') {
            // Comment
            i++;
            while(i < src.length && src[i] !== '\n')i++;
            if (scanComments) yield {
                t: $463f724b64570f1c$var$Literal.Comment,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if (src.length - i > 1 && src.substring(i, i + 2) === '/*') {
            // C style comment
            i += 2;
            while(i < src.length && !(src.length - i > 1 && src.substring(i, i + 2) === '*/'))i++;
            if (i === src.length) throw new $463f724b64570f1c$var$ScanError(src, i, 'Unterminated C style comment');
            i += 2;
            if (scanComments) yield {
                t: $463f724b64570f1c$var$Literal.Comment,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if (s === '(' || s === ')' || s === '{' || s === '}' || s === ';') {
            i++;
            yield {
                t: s,
                v: s,
                first: start,
                last: i
            };
        } else throw new $463f724b64570f1c$var$ScanError(src, i, `Invalid character at offset ${i}: \`${s}'`);
    }
}
// Michelson types
const $463f724b64570f1c$export$8bd888d100ea60f = Symbol('ref_contract');
var $463f724b64570f1c$export$377bbedb5576dfa8;
(function(Protocol) {
    Protocol["Ps9mPmXa"] = "Ps9mPmXaRzmzk35gbAYNCAw6UXdE2qoABTHbN2oEEc1qM7CwT9P";
    Protocol["PtCJ7pwo"] = "PtCJ7pwoxe8JasnHY8YonnLYjcVHmhiARPJvqcC6VfHT5s8k8sY";
    Protocol["PsYLVpVv"] = "PsYLVpVvgbLhAhoqAkMFUo6gudkJ9weNXhUYCiLDzcUpFpkk8Wt";
    Protocol["PsddFKi3"] = "PsddFKi32cMJ2qPjf43Qv5GDWLDPZb3T3bF6fLKiF5HtvHNU7aP";
    Protocol["Pt24m4xi"] = "Pt24m4xiPbLDhVgVfABUjirbmda3yohdN82Sp9FeuAXJ4eV9otd";
    Protocol["PsBABY5H"] = "PsBABY5HQTSkA4297zNHfsZNKtxULfL18y95qb3m53QJiXGmrbU";
    Protocol["PsBabyM1"] = "PsBabyM1eUXZseaJdmXFApDSBqj8YBfwELoxZHHW77EMcAbbwAS";
    Protocol["PsCARTHA"] = "PsCARTHAGazKbHtnKfLzQg3kms52kSRpgnDY982a9oYsSXRLQEb";
    Protocol["PsDELPH1"] = "PsDELPH1Kxsxt8f9eWbxQeRxkjfbxoqM52jvs5Y5fBxWWh4ifpo";
    Protocol["PtEdoTez"] = "PtEdoTezd3RHSC31mpxxo1npxFjoWWcFgQtxapi51Z8TLu6v6Uq";
    Protocol["PtEdo2Zk"] = "PtEdo2ZkT9oKpimTah6x2embF25oss54njMuPzkJTEi5RqfdZFA";
    Protocol["PsFLorena"] = "PsFLorenaUUuikDWvMDr6fGBRG8kt3e3D3fHoXK1j1BFRxeSH4i";
    Protocol["PtGRANADs"] = "PtGRANADsDU8R9daYKAgWnQYAJ64omN1o3KMGVCykShA97vQbvV";
    Protocol["PtHangzH"] = "PtHangzHogokSuiMHemCuowEavgYTP8J5qQ9fQS793MHYFpCY3r";
    Protocol["PtHangz2"] = "PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx";
    Protocol["PsiThaCa"] = "PsiThaCaT47Zboaw71QWScM8sXeMM7bbQFncK9FLqYc6EKdpjVP";
    Protocol["Psithaca2"] = "Psithaca2MLRFYargivpo7YvUr7wUDqyxrdhC5CQq78mRvimz6A";
    Protocol["PtJakarta"] = "PtJakartaiDz69SfDDLXJSiuZqTSeSKRDbKVZC8MNzJnvRjvnGw";
    Protocol["PtJakart2"] = "PtJakart2xVj7pYXJBXrqHgd82rdkLey5ZeeGwDgPp9rhQUbSqY";
    Protocol["PtKathman"] = "PtKathmankSpLLDALzWw7CGD2j2MtyveTwboEYokqUCP4a1LxMg";
    Protocol["PtLimaPtL"] = "PtLimaPtLMwfNinJi9rCfDPWea8dFgTZ1MeJ9f1m2SRic6ayiwW";
    Protocol["PtMumbaii"] = "PtMumbaiiFFEGbew1rRjzSPyzRbA51Tm3RVZL5suHPxSZYDhCEc";
    Protocol["PtMumbai2"] = "PtMumbai2TmsJHNGRkD8v8YDbtao7BLUC3wjASn1inAKLFCjaH1";
    Protocol["PtNairobi"] = "PtNairobiyssHuh87hEhfVBGCVrK3WnS8Z2FT4ymB5tAa4r1nQf";
    Protocol["ProxfordY"] = "ProxfordYmVfjWnRcgjWH36fW6PArwqykTFzotUxRs6gmTcZDuH";
    Protocol["ProtoALpha"] = "ProtoALphaALphaALphaALphaALphaALphaALphaALphaDdp3zK";
})($463f724b64570f1c$export$377bbedb5576dfa8 || ($463f724b64570f1c$export$377bbedb5576dfa8 = {}));
const $463f724b64570f1c$export$6af6ef9b852714c9 = $463f724b64570f1c$export$377bbedb5576dfa8.Psithaca2;
const $463f724b64570f1c$var$protoLevel = {
    Ps9mPmXaRzmzk35gbAYNCAw6UXdE2qoABTHbN2oEEc1qM7CwT9P: 0,
    PtCJ7pwoxe8JasnHY8YonnLYjcVHmhiARPJvqcC6VfHT5s8k8sY: 1,
    PsYLVpVvgbLhAhoqAkMFUo6gudkJ9weNXhUYCiLDzcUpFpkk8Wt: 2,
    PsddFKi32cMJ2qPjf43Qv5GDWLDPZb3T3bF6fLKiF5HtvHNU7aP: 3,
    Pt24m4xiPbLDhVgVfABUjirbmda3yohdN82Sp9FeuAXJ4eV9otd: 4,
    PsBABY5HQTSkA4297zNHfsZNKtxULfL18y95qb3m53QJiXGmrbU: 5,
    PsBabyM1eUXZseaJdmXFApDSBqj8YBfwELoxZHHW77EMcAbbwAS: 5,
    PsCARTHAGazKbHtnKfLzQg3kms52kSRpgnDY982a9oYsSXRLQEb: 6,
    PsDELPH1Kxsxt8f9eWbxQeRxkjfbxoqM52jvs5Y5fBxWWh4ifpo: 7,
    PtEdoTezd3RHSC31mpxxo1npxFjoWWcFgQtxapi51Z8TLu6v6Uq: 8,
    PtEdo2ZkT9oKpimTah6x2embF25oss54njMuPzkJTEi5RqfdZFA: 8,
    PsFLorenaUUuikDWvMDr6fGBRG8kt3e3D3fHoXK1j1BFRxeSH4i: 9,
    PtGRANADsDU8R9daYKAgWnQYAJ64omN1o3KMGVCykShA97vQbvV: 10,
    PtHangzHogokSuiMHemCuowEavgYTP8J5qQ9fQS793MHYFpCY3r: 11,
    PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx: 11,
    PsiThaCaT47Zboaw71QWScM8sXeMM7bbQFncK9FLqYc6EKdpjVP: 12,
    Psithaca2MLRFYargivpo7YvUr7wUDqyxrdhC5CQq78mRvimz6A: 12,
    PtJakartaiDz69SfDDLXJSiuZqTSeSKRDbKVZC8MNzJnvRjvnGw: 13,
    PtJakart2xVj7pYXJBXrqHgd82rdkLey5ZeeGwDgPp9rhQUbSqY: 13,
    PtKathmankSpLLDALzWw7CGD2j2MtyveTwboEYokqUCP4a1LxMg: 14,
    PtLimaPtLMwfNinJi9rCfDPWea8dFgTZ1MeJ9f1m2SRic6ayiwW: 15,
    PtMumbaiiFFEGbew1rRjzSPyzRbA51Tm3RVZL5suHPxSZYDhCEc: 16,
    PtMumbai2TmsJHNGRkD8v8YDbtao7BLUC3wjASn1inAKLFCjaH1: 16,
    PtNairobiyssHuh87hEhfVBGCVrK3WnS8Z2FT4ymB5tAa4r1nQf: 17,
    ProxfordYmVfjWnRcgjWH36fW6PArwqykTFzotUxRs6gmTcZDuH: 19,
    ProtoALphaALphaALphaALphaALphaALphaALphaALphaDdp3zK: 20
};
function $463f724b64570f1c$export$d42f6d6be949e71e(a, b) {
    return $463f724b64570f1c$var$protoLevel[a] >= $463f724b64570f1c$var$protoLevel[b];
}
function $463f724b64570f1c$export$d0c06cb7d5b8a84b(a, b) {
    return $463f724b64570f1c$var$protoLevel[a] < $463f724b64570f1c$var$protoLevel[b];
}
/**
 *  @category Error
 *  @description Error that indicates macros failed to be expanded
 */ class $463f724b64570f1c$export$12eefc679432101a extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(prim, message){
        super();
        this.prim = prim;
        this.message = message;
        this.name = 'MacroError';
    }
}
function $463f724b64570f1c$var$assertArgs$1(ex, n) {
    var _a, _b;
    if (n === 0 && ex.args === undefined || ((_a = ex.args) === null || _a === void 0 ? void 0 : _a.length) === n) return true;
    throw new $463f724b64570f1c$export$12eefc679432101a(ex, `macro ${ex.prim} expects ${n} arguments, was given ${(_b = ex.args) === null || _b === void 0 ? void 0 : _b.length}`);
}
function $463f724b64570f1c$var$assertNoAnnots(ex) {
    if (ex.annots === undefined) return true;
    throw new $463f724b64570f1c$export$12eefc679432101a(ex, `unexpected annotation on macro ${ex.prim}: ${ex.annots}`);
}
function $463f724b64570f1c$var$assertIntArg(ex, arg) {
    if ('int' in arg) return true;
    throw new $463f724b64570f1c$export$12eefc679432101a(ex, `macro ${ex.prim} expects int argument`);
}
function $463f724b64570f1c$var$parsePairUnpairExpr(p, expr, annotations, agg) {
    let i = 0;
    let ai = 0;
    const ann = [
        null,
        null
    ];
    // Left expression
    let lexpr;
    if (i === expr.length) throw new $463f724b64570f1c$export$12eefc679432101a(p, `unexpected end: ${p.prim}`);
    let c = expr[i++];
    switch(c){
        case 'P':
            {
                const { r: r, n: n, an: an } = $463f724b64570f1c$var$parsePairUnpairExpr(p, expr.slice(i), annotations.slice(ai), agg);
                lexpr = r;
                i += n;
                ai += an;
                break;
            }
        case 'A':
            if (ai !== annotations.length) ann[0] = annotations[ai++];
            break;
        default:
            throw new $463f724b64570f1c$export$12eefc679432101a(p, `${p.prim}: unexpected character: ${c}`);
    }
    // Right expression
    let rexpr;
    if (i === expr.length) throw new $463f724b64570f1c$export$12eefc679432101a(p, `unexpected end: ${p.prim}`);
    c = expr[i++];
    switch(c){
        case 'P':
            {
                const { r: r, n: n, an: an } = $463f724b64570f1c$var$parsePairUnpairExpr(p, expr.slice(i), annotations.slice(ai), agg);
                rexpr = r.map(([v, a])=>[
                        v + 1,
                        a
                    ]);
                i += n;
                ai += an;
                break;
            }
        case 'I':
            if (ai !== annotations.length) ann[1] = annotations[ai++];
            break;
        default:
            throw new $463f724b64570f1c$export$12eefc679432101a(p, `${p.prim}: unexpected character: ${c}`);
    }
    return {
        r: agg(lexpr, rexpr, [
            0,
            ann
        ]),
        n: i,
        an: ai
    };
}
function $463f724b64570f1c$var$parseSetMapCadr(p, expr, vann, term) {
    const c = expr[0];
    switch(c){
        case 'A':
            return expr.length > 1 ? [
                {
                    prim: 'DUP'
                },
                {
                    prim: 'DIP',
                    args: [
                        [
                            {
                                prim: 'CAR',
                                annots: [
                                    '@%%'
                                ]
                            },
                            $463f724b64570f1c$var$parseSetMapCadr(p, expr.slice(1), [], term)
                        ]
                    ]
                },
                {
                    prim: 'CDR',
                    annots: [
                        '@%%'
                    ]
                },
                {
                    prim: 'SWAP'
                },
                {
                    prim: 'PAIR',
                    annots: [
                        '%@',
                        '%@',
                        ...vann
                    ]
                }
            ] : term.a;
        case 'D':
            return expr.length > 1 ? [
                {
                    prim: 'DUP'
                },
                {
                    prim: 'DIP',
                    args: [
                        [
                            {
                                prim: 'CDR',
                                annots: [
                                    '@%%'
                                ]
                            },
                            $463f724b64570f1c$var$parseSetMapCadr(p, expr.slice(1), [], term)
                        ]
                    ]
                },
                {
                    prim: 'CAR',
                    annots: [
                        '@%%'
                    ]
                },
                {
                    prim: 'PAIR',
                    annots: [
                        '%@',
                        '%@',
                        ...vann
                    ]
                }
            ] : term.d;
        default:
            throw new $463f724b64570f1c$export$12eefc679432101a(p, `${p.prim}: unexpected character: ${c}`);
    }
}
function $463f724b64570f1c$var$trimLast(a, v) {
    let l = a.length;
    while(l > 0 && a[l - 1] === v)l--;
    return a.slice(0, l);
}
function $463f724b64570f1c$var$filterAnnotations(a) {
    const fields = [];
    const rest = [];
    if (a !== undefined) for (const v of a)(v.length !== 0 && v[0] === '%' ? fields : rest).push(v);
    return {
        fields: fields,
        rest: rest
    };
}
function $463f724b64570f1c$var$mkPrim({ prim: prim, annots: annots, args: args }) {
    return Object.assign(Object.assign({
        prim: prim
    }, annots && {
        annots: annots
    }), args && {
        args: args
    });
}
const $463f724b64570f1c$var$pairRe = /^P[PAI]{3,}R$/;
const $463f724b64570f1c$var$unpairRe = /^UNP[PAI]{2,}R$/;
const $463f724b64570f1c$var$cadrRe = /^C[AD]{2,}R$/;
const $463f724b64570f1c$var$setCadrRe = /^SET_C[AD]+R$/;
const $463f724b64570f1c$var$mapCadrRe = /^MAP_C[AD]+R$/;
const $463f724b64570f1c$var$diipRe = /^DI{2,}P$/;
const $463f724b64570f1c$var$duupRe = /^DU+P$/;
function $463f724b64570f1c$var$expandMacros(ex, opt) {
    const proto = (opt === null || opt === void 0 ? void 0 : opt.protocol) || $463f724b64570f1c$export$6af6ef9b852714c9;
    function mayRename(annots) {
        return annots !== undefined ? [
            {
                prim: 'RENAME',
                annots: annots
            }
        ] : [];
    }
    switch(ex.prim){
        // Compare
        case 'CMPEQ':
        case 'CMPNEQ':
        case 'CMPLT':
        case 'CMPGT':
        case 'CMPLE':
        case 'CMPGE':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 0)) return [
                {
                    prim: 'COMPARE'
                },
                $463f724b64570f1c$var$mkPrim({
                    prim: ex.prim.slice(3),
                    annots: ex.annots
                })
            ];
            break;
        case 'IFEQ':
        case 'IFNEQ':
        case 'IFLT':
        case 'IFGT':
        case 'IFLE':
        case 'IFGE':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 2)) return [
                {
                    prim: ex.prim.slice(2)
                },
                $463f724b64570f1c$var$mkPrim({
                    prim: 'IF',
                    annots: ex.annots,
                    args: ex.args
                })
            ];
            break;
        case 'IFCMPEQ':
        case 'IFCMPNEQ':
        case 'IFCMPLT':
        case 'IFCMPGT':
        case 'IFCMPLE':
        case 'IFCMPGE':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 2)) return [
                {
                    prim: 'COMPARE'
                },
                {
                    prim: ex.prim.slice(5)
                },
                $463f724b64570f1c$var$mkPrim({
                    prim: 'IF',
                    annots: ex.annots,
                    args: ex.args
                })
            ];
            break;
        // Fail
        case 'FAIL':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 0) && $463f724b64570f1c$var$assertNoAnnots(ex)) return [
                {
                    prim: 'UNIT'
                },
                {
                    prim: 'FAILWITH'
                }
            ];
            break;
        // Assertion macros
        case 'ASSERT':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 0) && $463f724b64570f1c$var$assertNoAnnots(ex)) return [
                {
                    prim: 'IF',
                    args: [
                        [],
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ]
                    ]
                }
            ];
            break;
        case 'ASSERT_EQ':
        case 'ASSERT_NEQ':
        case 'ASSERT_LT':
        case 'ASSERT_GT':
        case 'ASSERT_LE':
        case 'ASSERT_GE':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 0) && $463f724b64570f1c$var$assertNoAnnots(ex)) return [
                {
                    prim: ex.prim.slice(7)
                },
                {
                    prim: 'IF',
                    args: [
                        [],
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ]
                    ]
                }
            ];
            break;
        case 'ASSERT_CMPEQ':
        case 'ASSERT_CMPNEQ':
        case 'ASSERT_CMPLT':
        case 'ASSERT_CMPGT':
        case 'ASSERT_CMPLE':
        case 'ASSERT_CMPGE':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 0) && $463f724b64570f1c$var$assertNoAnnots(ex)) return [
                [
                    {
                        prim: 'COMPARE'
                    },
                    {
                        prim: ex.prim.slice(10)
                    }
                ],
                {
                    prim: 'IF',
                    args: [
                        [],
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ]
                    ]
                }
            ];
            break;
        case 'ASSERT_NONE':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 0) && $463f724b64570f1c$var$assertNoAnnots(ex)) return [
                {
                    prim: 'IF_NONE',
                    args: [
                        [],
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ]
                    ]
                }
            ];
            break;
        case 'ASSERT_SOME':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 0)) return [
                {
                    prim: 'IF_NONE',
                    args: [
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ],
                        mayRename(ex.annots)
                    ]
                }
            ];
            break;
        case 'ASSERT_LEFT':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 0)) return [
                {
                    prim: 'IF_LEFT',
                    args: [
                        mayRename(ex.annots),
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ]
                    ]
                }
            ];
            break;
        case 'ASSERT_RIGHT':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 0)) return [
                {
                    prim: 'IF_LEFT',
                    args: [
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ],
                        mayRename(ex.annots)
                    ]
                }
            ];
            break;
        // Syntactic conveniences
        case 'IF_SOME':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 2)) return [
                $463f724b64570f1c$var$mkPrim({
                    prim: 'IF_NONE',
                    annots: ex.annots,
                    args: [
                        ex.args[1],
                        ex.args[0]
                    ]
                })
            ];
            break;
        case 'IF_RIGHT':
            if ($463f724b64570f1c$var$assertArgs$1(ex, 2)) return [
                $463f724b64570f1c$var$mkPrim({
                    prim: 'IF_LEFT',
                    annots: ex.annots,
                    args: [
                        ex.args[1],
                        ex.args[0]
                    ]
                })
            ];
            break;
        // CAR/CDR n
        case 'CAR':
        case 'CDR':
            if (ex.args !== undefined) {
                if ($463f724b64570f1c$var$assertArgs$1(ex, 1) && $463f724b64570f1c$var$assertIntArg(ex, ex.args[0])) {
                    const n = parseInt(ex.args[0].int, 10);
                    return $463f724b64570f1c$var$mkPrim({
                        prim: 'GET',
                        args: [
                            {
                                int: ex.prim === 'CAR' ? String(n * 2 + 1) : String(n * 2)
                            }
                        ],
                        annots: ex.annots
                    });
                }
            } else return ex;
    }
    // More syntactic conveniences
    // PAPPAIIR macro
    if ($463f724b64570f1c$var$pairRe.test(ex.prim)) {
        if ($463f724b64570f1c$var$assertArgs$1(ex, 0)) {
            const { fields: fields, rest: rest } = $463f724b64570f1c$var$filterAnnotations(ex.annots);
            const { r: r } = $463f724b64570f1c$var$parsePairUnpairExpr(ex, ex.prim.slice(1), fields, (l, r, top)=>[
                    ...l || [],
                    ...r || [],
                    top
                ]);
            return r.map(([v, a], i)=>{
                const ann = [
                    ...$463f724b64570f1c$var$trimLast(a, null).map((v)=>v === null ? '%' : v),
                    ...v === 0 && i === r.length - 1 ? rest : []
                ];
                const leaf = $463f724b64570f1c$var$mkPrim({
                    prim: 'PAIR',
                    annots: ann.length !== 0 ? ann : undefined
                });
                return v === 0 ? leaf : {
                    prim: 'DIP',
                    args: v === 1 ? [
                        [
                            leaf
                        ]
                    ] : [
                        {
                            int: String(v)
                        },
                        [
                            leaf
                        ]
                    ]
                };
            });
        }
    }
    // UNPAPPAIIR macro
    if ($463f724b64570f1c$var$unpairRe.test(ex.prim)) {
        if ($463f724b64570f1c$export$d0c06cb7d5b8a84b(proto, $463f724b64570f1c$export$377bbedb5576dfa8.PtEdo2Zk) && $463f724b64570f1c$var$assertArgs$1(ex, 0)) {
            const { r: r } = $463f724b64570f1c$var$parsePairUnpairExpr(ex, ex.prim.slice(3), ex.annots || [], (l, r, top)=>[
                    top,
                    ...r || [],
                    ...l || []
                ]);
            return r.map(([v, a])=>{
                const leaf = [
                    {
                        prim: 'DUP'
                    },
                    $463f724b64570f1c$var$mkPrim({
                        prim: 'CAR',
                        annots: a[0] !== null ? [
                            a[0]
                        ] : undefined
                    }),
                    {
                        prim: 'DIP',
                        args: [
                            [
                                $463f724b64570f1c$var$mkPrim({
                                    prim: 'CDR',
                                    annots: a[1] !== null ? [
                                        a[1]
                                    ] : undefined
                                })
                            ]
                        ]
                    }
                ];
                return v === 0 ? leaf : {
                    prim: 'DIP',
                    args: v === 1 ? [
                        [
                            leaf
                        ]
                    ] : [
                        {
                            int: String(v)
                        },
                        [
                            leaf
                        ]
                    ]
                };
            });
        } else {
            if (ex.prim === 'UNPAIR') return ex;
            if ($463f724b64570f1c$var$assertArgs$1(ex, 0)) {
                // 008_edo: annotations are deprecated
                const { r: r } = $463f724b64570f1c$var$parsePairUnpairExpr(ex, ex.prim.slice(3), [], (l, r, top)=>[
                        top,
                        ...r || [],
                        ...l || []
                    ]);
                return r.map(([v])=>{
                    const leaf = $463f724b64570f1c$var$mkPrim({
                        prim: 'UNPAIR'
                    });
                    return v === 0 ? leaf : {
                        prim: 'DIP',
                        args: v === 1 ? [
                            [
                                leaf
                            ]
                        ] : [
                            {
                                int: String(v)
                            },
                            [
                                leaf
                            ]
                        ]
                    };
                });
            }
        }
    }
    // C[AD]+R macro
    if ($463f724b64570f1c$var$cadrRe.test(ex.prim)) {
        if ($463f724b64570f1c$var$assertArgs$1(ex, 0)) {
            const ch = [
                ...ex.prim.slice(1, ex.prim.length - 1)
            ];
            return ch.map((c, i)=>{
                const ann = i === ch.length - 1 ? ex.annots : undefined;
                switch(c){
                    case 'A':
                        return $463f724b64570f1c$var$mkPrim({
                            prim: 'CAR',
                            annots: ann
                        });
                    case 'D':
                        return $463f724b64570f1c$var$mkPrim({
                            prim: 'CDR',
                            annots: ann
                        });
                    default:
                        throw new $463f724b64570f1c$export$12eefc679432101a(ex, `unexpected character: ${c}`);
                }
            });
        }
    }
    // SET_C[AD]+R macro
    if ($463f724b64570f1c$var$setCadrRe.test(ex.prim)) {
        if ($463f724b64570f1c$var$assertArgs$1(ex, 0)) {
            const { fields: fields, rest: rest } = $463f724b64570f1c$var$filterAnnotations(ex.annots);
            if (fields.length > 1) throw new $463f724b64570f1c$export$12eefc679432101a(ex, `unexpected annotation on macro ${ex.prim}: ${fields}`);
            const term = fields.length !== 0 ? {
                a: [
                    {
                        prim: 'DUP'
                    },
                    {
                        prim: 'CAR',
                        annots: fields
                    },
                    {
                        prim: 'DROP'
                    },
                    {
                        prim: 'CDR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'SWAP'
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            fields[0],
                            '%@'
                        ]
                    }
                ],
                d: [
                    {
                        prim: 'DUP'
                    },
                    {
                        prim: 'CDR',
                        annots: fields
                    },
                    {
                        prim: 'DROP'
                    },
                    {
                        prim: 'CAR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            '%@',
                            fields[0]
                        ]
                    }
                ]
            } : {
                a: [
                    {
                        prim: 'CDR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'SWAP'
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            '%',
                            '%@'
                        ]
                    }
                ],
                d: [
                    {
                        prim: 'CAR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            '%@',
                            '%'
                        ]
                    }
                ]
            };
            return $463f724b64570f1c$var$parseSetMapCadr(ex, ex.prim.slice(5, ex.prim.length - 1), rest, term);
        }
    }
    // MAP_C[AD]+R macro
    if ($463f724b64570f1c$var$mapCadrRe.test(ex.prim)) {
        if ($463f724b64570f1c$var$assertArgs$1(ex, 1)) {
            const { fields: fields } = $463f724b64570f1c$var$filterAnnotations(ex.annots);
            if (fields.length > 1) throw new $463f724b64570f1c$export$12eefc679432101a(ex, `unexpected annotation on macro ${ex.prim}: ${fields}`);
            const term = {
                a: [
                    {
                        prim: 'DUP'
                    },
                    {
                        prim: 'CDR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'DIP',
                        args: [
                            [
                                $463f724b64570f1c$var$mkPrim({
                                    prim: 'CAR',
                                    annots: fields.length !== 0 ? [
                                        '@' + fields[0].slice(1)
                                    ] : undefined
                                }),
                                ex.args[0]
                            ]
                        ]
                    },
                    {
                        prim: 'SWAP'
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            fields.length !== 0 ? fields[0] : '%',
                            '%@'
                        ]
                    }
                ],
                d: [
                    {
                        prim: 'DUP'
                    },
                    $463f724b64570f1c$var$mkPrim({
                        prim: 'CDR',
                        annots: fields.length !== 0 ? [
                            '@' + fields[0].slice(1)
                        ] : undefined
                    }),
                    ex.args[0],
                    {
                        prim: 'SWAP'
                    },
                    {
                        prim: 'CAR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            '%@',
                            fields.length !== 0 ? fields[0] : '%'
                        ]
                    }
                ]
            };
            return $463f724b64570f1c$var$parseSetMapCadr(ex, ex.prim.slice(5, ex.prim.length - 1), [], term);
        }
    }
    // Expand deprecated DI...IP to [DIP n]
    if ($463f724b64570f1c$var$diipRe.test(ex.prim)) {
        if ($463f724b64570f1c$var$assertArgs$1(ex, 1)) {
            let n = 0;
            while(ex.prim[1 + n] === 'I')n++;
            return $463f724b64570f1c$var$mkPrim({
                prim: 'DIP',
                args: [
                    {
                        int: String(n)
                    },
                    ex.args[0]
                ]
            });
        }
    }
    // Expand DU...UP and DUP n
    if ($463f724b64570f1c$var$duupRe.test(ex.prim)) {
        let n = 0;
        while(ex.prim[1 + n] === 'U')n++;
        if ($463f724b64570f1c$export$d0c06cb7d5b8a84b(proto, $463f724b64570f1c$export$377bbedb5576dfa8.PtEdo2Zk)) {
            if (n === 1) {
                if (ex.args === undefined) return ex; // skip
                if ($463f724b64570f1c$var$assertArgs$1(ex, 1) && $463f724b64570f1c$var$assertIntArg(ex, ex.args[0])) n = parseInt(ex.args[0].int, 10);
            } else $463f724b64570f1c$var$assertArgs$1(ex, 0);
            if (n === 1) return [
                $463f724b64570f1c$var$mkPrim({
                    prim: 'DUP',
                    annots: ex.annots
                })
            ];
            else if (n === 2) return [
                {
                    prim: 'DIP',
                    args: [
                        [
                            $463f724b64570f1c$var$mkPrim({
                                prim: 'DUP',
                                annots: ex.annots
                            })
                        ]
                    ]
                },
                {
                    prim: 'SWAP'
                }
            ];
            else return [
                {
                    prim: 'DIP',
                    args: [
                        {
                            int: String(n - 1)
                        },
                        [
                            $463f724b64570f1c$var$mkPrim({
                                prim: 'DUP',
                                annots: ex.annots
                            })
                        ]
                    ]
                },
                {
                    prim: 'DIG',
                    args: [
                        {
                            int: String(n)
                        }
                    ]
                }
            ];
        } else {
            if (n === 1) return ex;
            if ($463f724b64570f1c$var$assertArgs$1(ex, 0)) return $463f724b64570f1c$var$mkPrim({
                prim: 'DUP',
                args: [
                    {
                        int: String(n)
                    }
                ],
                annots: ex.annots
            });
        }
    }
    return ex;
}
function $463f724b64570f1c$var$expandGlobalConstants(ex, hashAndValue) {
    if (ex.args !== undefined && ex.args.length === 1 && 'string' in ex.args[0] && ex.args[0].string in hashAndValue) return hashAndValue[ex.args[0].string];
    return ex;
}
/**
 *  @category Error
 *  @description Error that indicates a failure when parsing Micheline expressions
 */ class $463f724b64570f1c$export$2038bc0381931c3c extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    /**
     * @param token A token caused the error
     * @param message An error message
     */ constructor(token, message){
        super();
        this.token = token;
        this.message = message;
        this.name = 'MichelineParseError';
    }
}
/**
 *  @category Error
 *  @description Error indicates a failure when parsing Micheline JSON
 */ class $463f724b64570f1c$export$796bd0427cfd15b1 extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    /**
     * @param node A node caused the error
     * @param message An error message
     */ constructor(node, message){
        super();
        this.node = node;
        this.message = message;
        this.name = 'JSONParseError';
    }
}
const $463f724b64570f1c$var$errEOF = new $463f724b64570f1c$export$2038bc0381931c3c(null, 'Unexpected EOF');
function $463f724b64570f1c$var$isAnnotation(tok) {
    return tok.t === $463f724b64570f1c$var$Literal.Ident && (tok.v[0] === '@' || tok.v[0] === '%' || tok.v[0] === ':');
}
const $463f724b64570f1c$var$intRe = new RegExp('^-?[0-9]+$');
const $463f724b64570f1c$var$bytesRe = new RegExp('^([0-9a-fA-F]{2})*$');
/**
 * Converts and validates Michelson expressions between JSON-based Michelson and Micheline
 *
 * Pretty Print a Michelson Smart Contract:
 * ```
 * const contract = await Tezos.contract.at("KT1Vsw3kh9638gqWoHTjvHCoHLPKvCbMVbCg");
 * const p = new Parser();
 *
 * const michelsonCode = p.parseJSON(contract.script.code);
 * const storage = p.parseJSON(contract.script.storage);
 *
 * console.log("Pretty print Michelson smart contract:");
 * console.log(emitMicheline(michelsonCode, {indent:"    ", newline: "\n",}));
 *
 * console.log("Pretty print Storage:");
 * console.log(emitMicheline(storage, {indent:"    ", newline: "\n",}));
 * ```
 *
 * Encode a Michelson expression for initial storage of a smart contract
 * ```
 * const src = `(Pair (Pair { Elt 1
 *                (Pair (Pair "tz1gjaF81ZRRvdzjobyfVNsAeSC6PScjfQwN" "tz1KqTpEZ7Yob7QbPE4Hy4Wo8fHG8LhKxZSx")
 *                      0x0501000000026869) }
 *          10000000)
 *    (Pair 2 333))`;
 *
 * const p = new Parser();
 *
 * const exp = p.parseMichelineExpression(src);
 * console.log(JSON.stringify(exp));
 * ```
 */ class $463f724b64570f1c$export$7acfa6ed01010e37 {
    constructor(opt){
        this.opt = opt;
    }
    expand(ex) {
        var _a, _b, _c;
        if (((_a = this.opt) === null || _a === void 0 ? void 0 : _a.expandGlobalConstant) !== undefined && ex.prim === 'constant') {
            const ret = $463f724b64570f1c$var$expandGlobalConstants(ex, this.opt.expandGlobalConstant);
            if (ret !== ex) ret[$463f724b64570f1c$export$ad6cc7932321c4f3] = Object.assign(Object.assign({}, ex[$463f724b64570f1c$export$ad6cc7932321c4f3] || {
                first: 0,
                last: 0
            }), {
                globalConstant: ex
            });
            return ret;
        }
        if (((_b = this.opt) === null || _b === void 0 ? void 0 : _b.expandMacros) !== undefined ? (_c = this.opt) === null || _c === void 0 ? void 0 : _c.expandMacros : true) {
            const ret = $463f724b64570f1c$var$expandMacros(ex, this.opt);
            if (ret !== ex) ret[$463f724b64570f1c$export$ad6cc7932321c4f3] = Object.assign(Object.assign({}, ex[$463f724b64570f1c$export$ad6cc7932321c4f3] || {
                first: 0,
                last: 0
            }), {
                macro: ex
            });
            return ret;
        } else return ex;
    }
    parseListExpr(scanner, start) {
        var _a;
        const ref = {
            first: start.first,
            last: start.last
        };
        const expectBracket = start.t === '(';
        let tok;
        if (expectBracket) {
            tok = scanner.next();
            if (tok.done) throw $463f724b64570f1c$var$errEOF;
            ref.last = tok.value.last;
        } else tok = {
            value: start
        };
        if (tok.value.t !== $463f724b64570f1c$var$Literal.Ident) throw new $463f724b64570f1c$export$2038bc0381931c3c(tok.value, `not an identifier: ${tok.value.v}`);
        const ret = {
            prim: tok.value.v,
            [$463f724b64570f1c$export$ad6cc7932321c4f3]: ref
        };
        for(;;){
            const tok = scanner.next();
            if (tok.done) {
                if (expectBracket) throw $463f724b64570f1c$var$errEOF;
                break;
            } else if (tok.value.t === ')') {
                if (!expectBracket) throw new $463f724b64570f1c$export$2038bc0381931c3c(tok.value, 'unexpected closing bracket');
                ref.last = tok.value.last;
                break;
            } else if ($463f724b64570f1c$var$isAnnotation(tok.value)) {
                ret.annots = ret.annots || [];
                ret.annots.push(tok.value.v);
                ref.last = tok.value.last;
            } else {
                ret.args = ret.args || [];
                const arg = this.parseExpr(scanner, tok.value);
                ref.last = ((_a = arg[$463f724b64570f1c$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.last) || ref.last;
                ret.args.push(arg);
            }
        }
        return this.expand(ret);
    }
    parseArgs(scanner, start) {
        var _a;
        // Identifier with arguments
        const ref = {
            first: start.first,
            last: start.last
        };
        const p = {
            prim: start.v,
            [$463f724b64570f1c$export$ad6cc7932321c4f3]: ref
        };
        for(;;){
            const t = scanner.next();
            if (t.done || t.value.t === '}' || t.value.t === ';') return [
                p,
                t
            ];
            if ($463f724b64570f1c$var$isAnnotation(t.value)) {
                ref.last = t.value.last;
                p.annots = p.annots || [];
                p.annots.push(t.value.v);
            } else {
                const arg = this.parseExpr(scanner, t.value);
                ref.last = ((_a = arg[$463f724b64570f1c$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.last) || ref.last;
                p.args = p.args || [];
                p.args.push(arg);
            }
        }
    }
    parseSequenceExpr(scanner, start) {
        var _a, _b;
        const ref = {
            first: start.first,
            last: start.last
        };
        const seq = [];
        seq[$463f724b64570f1c$export$ad6cc7932321c4f3] = ref;
        const expectBracket = start.t === '{';
        let tok = start.t === '{' ? null : {
            value: start
        };
        for(;;){
            if (tok === null) {
                tok = scanner.next();
                if (!tok.done) ref.last = tok.value.last;
            }
            if (tok.done) {
                if (expectBracket) throw $463f724b64570f1c$var$errEOF;
                else return seq;
            }
            if (tok.value.t === '}') {
                if (!expectBracket) throw new $463f724b64570f1c$export$2038bc0381931c3c(tok.value, 'unexpected closing bracket');
                else return seq;
            } else if (tok.value.t === $463f724b64570f1c$var$Literal.Ident) {
                // Identifier with arguments
                const [itm, n] = this.parseArgs(scanner, tok.value);
                ref.last = ((_a = itm[$463f724b64570f1c$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.last) || ref.last;
                seq.push(this.expand(itm));
                tok = n;
            } else {
                // Other
                const ex = this.parseExpr(scanner, tok.value);
                ref.last = ((_b = ex[$463f724b64570f1c$export$ad6cc7932321c4f3]) === null || _b === void 0 ? void 0 : _b.last) || ref.last;
                seq.push(ex);
                tok = null;
            }
            if (tok === null) {
                tok = scanner.next();
                if (!tok.done) ref.last = tok.value.last;
            }
            if (!tok.done && tok.value.t === ';') tok = null;
        }
    }
    parseExpr(scanner, tok) {
        switch(tok.t){
            case $463f724b64570f1c$var$Literal.Ident:
                return this.expand({
                    prim: tok.v,
                    [$463f724b64570f1c$export$ad6cc7932321c4f3]: {
                        first: tok.first,
                        last: tok.last
                    }
                });
            case $463f724b64570f1c$var$Literal.Number:
                return {
                    int: tok.v,
                    [$463f724b64570f1c$export$ad6cc7932321c4f3]: {
                        first: tok.first,
                        last: tok.last
                    }
                };
            case $463f724b64570f1c$var$Literal.String:
                return {
                    string: JSON.parse(tok.v),
                    [$463f724b64570f1c$export$ad6cc7932321c4f3]: {
                        first: tok.first,
                        last: tok.last
                    }
                };
            case $463f724b64570f1c$var$Literal.Bytes:
                return {
                    bytes: tok.v.slice(2),
                    [$463f724b64570f1c$export$ad6cc7932321c4f3]: {
                        first: tok.first,
                        last: tok.last
                    }
                };
            case '{':
                return this.parseSequenceExpr(scanner, tok);
            default:
                return this.parseListExpr(scanner, tok);
        }
    }
    /**
     * Parses a Micheline sequence expression, such as smart contract source. Enclosing curly brackets may be omitted.
     * @param src A Micheline sequence `{parameter ...; storage int; code { DUP ; ...};}` or `parameter ...; storage int; code { DUP ; ...};`
     */ parseSequence(src) {
        if (typeof src !== 'string') throw new TypeError(`string type was expected, got ${typeof src} instead`);
        const scanner = $463f724b64570f1c$var$scan(src);
        const tok = scanner.next();
        if (tok.done) return null;
        return this.parseSequenceExpr(scanner, tok.value);
    }
    /**
     * Parse a Micheline sequence expression. Enclosing curly brackets may be omitted.
     * @param src A Michelson list expression such as `(Pair {Elt "0" 0} 0)` or `Pair {Elt "0" 0} 0`
     * @returns An AST node or null for empty document.
     */ parseList(src) {
        if (typeof src !== 'string') throw new TypeError(`string type was expected, got ${typeof src} instead`);
        const scanner = $463f724b64570f1c$var$scan(src);
        const tok = scanner.next();
        if (tok.done) return null;
        return this.parseListExpr(scanner, tok.value);
    }
    /**
     * Parse any Michelson expression
     * @param src A Michelson expression such as `(Pair {Elt "0" 0} 0)` or `{parameter ...; storage int; code { DUP ; ...};}`
     * @returns An AST node or null for empty document.
     */ parseMichelineExpression(src) {
        if (typeof src !== 'string') throw new TypeError(`string type was expected, got ${typeof src} instead`);
        const scanner = $463f724b64570f1c$var$scan(src);
        const tok = scanner.next();
        if (tok.done) return null;
        return this.parseExpr(scanner, tok.value);
    }
    /**
     * Parse a Micheline sequence expression, such as smart contract source. Enclosing curly brackets may be omitted.
     * An alias for `parseSequence`
     * @param src A Micheline sequence `{parameter ...; storage int; code { DUP ; ...};}` or `parameter ...; storage int; code { DUP ; ...};`
     */ parseScript(src) {
        return this.parseSequence(src);
    }
    /**
     * Parse a Micheline sequence expression. Enclosing curly brackets may be omitted.
     * An alias for `parseList`
     * @param src A Michelson list expression such as `(Pair {Elt "0" 0} 0)` or `Pair {Elt "0" 0} 0`
     * @returns An AST node or null for empty document.
     */ parseData(src) {
        return this.parseList(src);
    }
    /**
     * Takes a JSON-encoded Michelson, validates it, strips away unneeded properties and optionally expands macros (See {@link ParserOptions}).
     * @param src An object containing JSON-encoded Michelson, usually returned by `JSON.parse()`
     */ parseJSON(src) {
        if (typeof src !== 'object') throw new TypeError(`object type was expected, got ${typeof src} instead`);
        if (Array.isArray(src)) {
            const ret = [];
            for (const n of src){
                if (n === null || typeof n !== 'object') throw new $463f724b64570f1c$export$796bd0427cfd15b1(n, `unexpected sequence element: ${n}`);
                ret.push(this.parseJSON(n));
            }
            return ret;
        } else if ('prim' in src) {
            const p = src;
            if (typeof p.prim === 'string' && (p.annots === undefined || Array.isArray(p.annots)) && (p.args === undefined || Array.isArray(p.args))) {
                const ret = {
                    prim: p.prim
                };
                if (p.annots !== undefined) {
                    for (const a of p.annots){
                        if (typeof a !== 'string') throw new $463f724b64570f1c$export$796bd0427cfd15b1(a, `string expected: ${a}`);
                    }
                    ret.annots = p.annots;
                }
                if (p.args !== undefined) {
                    ret.args = [];
                    for (const a of p.args){
                        if (a === null || typeof a !== 'object') throw new $463f724b64570f1c$export$796bd0427cfd15b1(a, `unexpected argument: ${a}`);
                        ret.args.push(this.parseJSON(a));
                    }
                }
                return this.expand(ret);
            }
            throw new $463f724b64570f1c$export$796bd0427cfd15b1(src, `malformed prim expression: ${src}`);
        } else if ('string' in src) {
            if (typeof src.string === 'string') return {
                string: src.string
            };
            throw new $463f724b64570f1c$export$796bd0427cfd15b1(src, `malformed string literal: ${src}`);
        } else if ('int' in src) {
            if (typeof src.int === 'string' && $463f724b64570f1c$var$intRe.test(src.int)) return {
                int: src.int
            };
            throw new $463f724b64570f1c$export$796bd0427cfd15b1(src, `malformed int literal: ${src}`);
        } else if ('bytes' in src) {
            if (typeof src.bytes === 'string' && $463f724b64570f1c$var$bytesRe.test(src.bytes)) return {
                bytes: src.bytes
            };
            throw new $463f724b64570f1c$export$796bd0427cfd15b1(src, `malformed bytes literal: ${src}`);
        } else throw new $463f724b64570f1c$export$796bd0427cfd15b1(src, `unexpected object: ${src}`);
    }
}
class $463f724b64570f1c$var$Formatter {
    constructor(opt, lev = 0){
        this.opt = opt;
        this.lev = lev;
    }
    indent(n = 0) {
        var _a;
        let ret = '';
        if (((_a = this.opt) === null || _a === void 0 ? void 0 : _a.indent) !== undefined) for(let i = this.lev + n; i > 0; i--)ret += this.opt.indent;
        return ret;
    }
    get lf() {
        var _a;
        return ((_a = this.opt) === null || _a === void 0 ? void 0 : _a.newline) || '';
    }
    get lfsp() {
        var _a;
        return ((_a = this.opt) === null || _a === void 0 ? void 0 : _a.newline) || ' ';
    }
    down(n) {
        return new $463f724b64570f1c$var$Formatter(this.opt, this.lev + n);
    }
}
function $463f724b64570f1c$var$hasArgs(node) {
    return 'prim' in node && (node.annots !== undefined && node.annots.length !== 0 || node.args !== undefined && node.args.length !== 0);
}
function $463f724b64570f1c$var$isMultiline(node) {
    if (node.args !== undefined) for (const a of node.args){
        if (Array.isArray(a) || $463f724b64570f1c$var$hasArgs(a)) return true;
    }
    return false;
}
function $463f724b64570f1c$var$emitExpr(node, f, foldMacros) {
    var _a;
    const macro = (_a = node[$463f724b64570f1c$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.macro;
    if (foldMacros && macro) return $463f724b64570f1c$var$emitExpr(macro, f, foldMacros);
    if (Array.isArray(node)) return $463f724b64570f1c$var$emitSeq(node, f, foldMacros);
    else if ('string' in node) return JSON.stringify(node.string);
    else if ('int' in node) return node.int;
    else if ('bytes' in node) return '0x' + node.bytes;
    else {
        if ((node.annots === undefined || node.annots.length === 0) && (node.args === undefined || node.args.length === 0)) return node.prim;
        let ret = '(' + node.prim;
        if (node.annots !== undefined) for (const a of node.annots)ret += ' ' + a;
        if (node.args !== undefined) {
            const multiline = $463f724b64570f1c$var$isMultiline(node);
            for (const a of node.args)if (multiline) ret += f.lfsp + f.indent(1) + $463f724b64570f1c$var$emitExpr(a, f.down(1), foldMacros);
            else ret += ' ' + $463f724b64570f1c$var$emitExpr(a, f, foldMacros);
        }
        return ret + ')';
    }
}
function $463f724b64570f1c$var$emitSeq(node, f, foldMacros) {
    let ret = '{' + f.lf;
    let i = node.length;
    for (const el of node){
        ret += f.indent(1);
        if ('prim' in el) {
            ret += el.prim;
            if (el.annots !== undefined) for (const a of el.annots)ret += ' ' + a;
            if (el.args !== undefined) {
                const multiline = $463f724b64570f1c$var$isMultiline(el);
                for (const a of el.args)if (multiline) ret += f.lfsp + f.indent(2) + $463f724b64570f1c$var$emitExpr(a, f.down(2), foldMacros);
                else ret += ' ' + $463f724b64570f1c$var$emitExpr(a, f, foldMacros);
            }
        } else ret += $463f724b64570f1c$var$emitExpr(el, f.down(1), foldMacros);
        ret += i > 1 ? ';' + f.lfsp : f.lf;
        i--;
    }
    return ret + f.indent() + '}';
}
/**
 * Formats Micheline expression
 * @param expr An AST node
 * @param opt Options
 */ function $463f724b64570f1c$export$613fc3a7f2c0f56c(expr, opt, foldMacros = false) {
    if (typeof expr !== 'object') throw new TypeError(`object type was expected, got ${typeof expr} instead`);
    return $463f724b64570f1c$var$emitExpr(expr, new $463f724b64570f1c$var$Formatter(opt), foldMacros);
}
const $463f724b64570f1c$var$H = [
    1779033703,
    -1150833019,
    1013904242,
    -1521486534,
    1359893119,
    -1694144372,
    528734635,
    1541459225
];
const $463f724b64570f1c$var$K = [
    1116352408,
    1899447441,
    -1245643825,
    -373957723,
    961987163,
    1508970993,
    -1841331548,
    -1424204075,
    -670586216,
    310598401,
    607225278,
    1426881987,
    1925078388,
    -2132889090,
    -1680079193,
    -1046744716,
    -459576895,
    -272742522,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    -1740746414,
    -1473132947,
    -1341970488,
    -1084653625,
    -958395405,
    -710438585,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    -2117940946,
    -1838011259,
    -1564481375,
    -1474664885,
    -1035236496,
    -949202525,
    -778901479,
    -694614492,
    -200395387,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    -2067236844,
    -1933114872,
    -1866530822,
    -1538233109,
    -1090935817,
    -965641998
];
/**
 *  @category Error
 *  @description Error that indicates a failure when decoding a base58 encoding
 */ class $463f724b64570f1c$var$Base58DecodingError extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'Base58DecodingError';
    }
}
// https://tools.ietf.org/html/rfc6234
function $463f724b64570f1c$var$sha256(msg) {
    // pad the message
    const r = (msg.length + 9) % 64;
    const pad = r === 0 ? 0 : 64 - r;
    if (msg.length > 268435455) throw new (0, $8b6476b09e20f53e$export$a5124d7665e9d8ad)('', `: Invalid length ${msg.length} is too big -- SHA-256.`);
    const l = msg.length << 3;
    const buffer = [
        ...msg,
        0x80,
        ...new Array(pad).fill(0),
        0,
        0,
        0,
        0,
        l >> 24 & 0xff,
        l >> 16 & 0xff,
        l >> 8 & 0xff,
        l & 0xff
    ];
    function ror(x, n) {
        return x >>> n | x << 32 - n;
    }
    const h = [
        ...$463f724b64570f1c$var$H
    ];
    const w = new Array(64);
    const v = new Array(8);
    for(let offset = 0; offset < buffer.length; offset += 64){
        let q = offset;
        let i = 0;
        while(i < 16){
            w[i] = buffer[q] << 24 | buffer[q + 1] << 16 | buffer[q + 2] << 8 | buffer[q + 3];
            q += 4;
            i++;
        }
        while(i < 64){
            const s0 = ror(w[i - 15], 7) ^ ror(w[i - 15], 18) ^ w[i - 15] >>> 3;
            const s1 = ror(w[i - 2], 17) ^ ror(w[i - 2], 19) ^ w[i - 2] >>> 10;
            w[i] = (s1 | 0) + w[i - 7] + s0 + w[i - 16] | 0;
            i++;
        }
        for(let i = 0; i < 8; i++)v[i] = h[i];
        for(let i = 0; i < 64; i++){
            const b0 = ror(v[0], 2) ^ ror(v[0], 13) ^ ror(v[0], 22);
            const b1 = ror(v[4], 6) ^ ror(v[4], 11) ^ ror(v[4], 25);
            const t1 = v[7] + b1 + (v[4] & v[5] ^ ~v[4] & v[6]) + $463f724b64570f1c$var$K[i] + w[i] | 0;
            const t2 = b0 + (v[0] & v[1] ^ v[0] & v[2] ^ v[1] & v[2]) | 0;
            v[7] = v[6];
            v[6] = v[5];
            v[5] = v[4];
            v[4] = v[3] + t1 | 0;
            v[3] = v[2];
            v[2] = v[1];
            v[1] = v[0];
            v[0] = t1 + t2 | 0;
        }
        for(let i = 0; i < 8; i++)h[i] = h[i] + v[i] | 0;
    }
    const digest = [];
    for (const v of h){
        digest.push(v >> 24 & 0xff);
        digest.push(v >> 16 & 0xff);
        digest.push(v >> 8 & 0xff);
        digest.push(v & 0xff);
    }
    return digest;
}
const $463f724b64570f1c$var$base58alphabetFwd = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    -1,
    17,
    18,
    19,
    20,
    21,
    -1,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    -1,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57
];
const $463f724b64570f1c$var$base58alphabetBwd = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    25,
    26,
    27,
    28,
    29,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    60,
    61,
    62,
    63,
    64,
    65,
    66,
    67,
    68,
    69,
    70,
    71,
    72,
    73
];
function $463f724b64570f1c$var$byteAt(src, i) {
    const c = src.charCodeAt(i) - 49;
    if (c >= $463f724b64570f1c$var$base58alphabetFwd.length || $463f724b64570f1c$var$base58alphabetFwd[c] === -1) throw new $463f724b64570f1c$var$Base58DecodingError(`Unexpected character at position ${i}: ${src[i]}`);
    return $463f724b64570f1c$var$base58alphabetFwd[c];
}
function $463f724b64570f1c$var$decodeBase58(src) {
    const acc = [];
    let i = 0;
    // count and skip leading zeros
    while(i < src.length && $463f724b64570f1c$var$byteAt(src, i) === 0)i++;
    let zeros = i;
    while(i < src.length){
        let carry = $463f724b64570f1c$var$byteAt(src, i++);
        /*
            for every symbol x
            acc = acc * 58 + x
            where acc is a little endian arbitrary length integer
            */ let ii = 0;
        while(carry !== 0 || ii < acc.length){
            const m = (acc[ii] || 0) * 58 + carry;
            acc[ii++] = m % 256;
            carry = Math.floor(m / 256);
        }
    }
    while(zeros-- > 0)acc.push(0);
    return acc.reverse();
}
function $463f724b64570f1c$var$encodeBase58(src) {
    const acc = [];
    let i = 0;
    // count and skip leading zeros
    while(i < src.length && src[i] === 0)i++;
    let zeros = i;
    while(i < src.length){
        let carry = src[i++];
        let ii = 0;
        while(carry !== 0 || ii < acc.length){
            const m = (acc[ii] || 0) * 256 + carry;
            acc[ii++] = m % 58;
            carry = Math.floor(m / 58);
        }
    }
    while(zeros-- > 0)acc.push(0);
    acc.reverse();
    return String.fromCharCode(...acc.map((v)=>$463f724b64570f1c$var$base58alphabetBwd[v] + 49));
}
function $463f724b64570f1c$var$decodeBase58Check(src) {
    const buffer = $463f724b64570f1c$var$decodeBase58(src);
    if (buffer.length < 4) throw new $463f724b64570f1c$var$Base58DecodingError(`Data is too short ${buffer.length}`);
    const data = buffer.slice(0, buffer.length - 4);
    const sum = buffer.slice(buffer.length - 4);
    const computed = $463f724b64570f1c$var$sha256($463f724b64570f1c$var$sha256(data));
    if (sum[0] !== computed[0] || sum[1] !== computed[1] || sum[2] !== computed[2] || sum[3] !== computed[3]) throw new $463f724b64570f1c$var$Base58DecodingError('Invalid checksum');
    return data;
}
function $463f724b64570f1c$var$encodeBase58Check(src) {
    const sum = $463f724b64570f1c$var$sha256($463f724b64570f1c$var$sha256(src));
    return $463f724b64570f1c$var$encodeBase58([
        ...src,
        ...sum.slice(0, 4)
    ]);
}
/**
 *  @category Error
 *  @description Error that indicates an invalid Michelson being passed or used
 */ class $463f724b64570f1c$var$InvalidMichelsonError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'InvalidMichelsonError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid type expression being passed or used
 */ class $463f724b64570f1c$var$InvalidTypeExpressionError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'InvalidTypeExpressionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid data expression being passed or used
 */ class $463f724b64570f1c$var$InvalidDataExpressionError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'InvalidDataExpressionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid contract entrypoint being referenced or passed
 */ class $463f724b64570f1c$var$InvalidEntrypointError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(entrypoint){
        super();
        this.entrypoint = entrypoint;
        this.name = 'InvalidEntrypointError';
        this.message = `Contract has no entrypoint named: "${entrypoint}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure happening when trying to encode Tezos ID
 */ class $463f724b64570f1c$var$TezosIdEncodeError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'TezosIdEncodeError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a general error happening when trying to create a LongInteger
 */ class $463f724b64570f1c$var$LongIntegerError extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'LongIntegerError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure occurring when trying to parse a hex byte
 */ class $463f724b64570f1c$var$HexParseError extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(hexByte){
        super();
        this.hexByte = hexByte;
        this.name = 'HexParseError';
        this.message = `Unable to parse hex byte "${hexByte}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a Michelson failure occurring
 */ class $463f724b64570f1c$export$61ae7f08643aa181 extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    /**
     * @param val Value of a AST node caused the error
     * @param path Path to a node caused the error
     * @param message An error message
     */ constructor(val, message){
        super();
        this.val = val;
        this.message = message;
        this.name = 'MichelsonError';
    }
}
function $463f724b64570f1c$export$d0f88f1112d519ce(err) {
    return err instanceof $463f724b64570f1c$export$61ae7f08643aa181;
}
class $463f724b64570f1c$export$c9afdd965e51c08a extends $463f724b64570f1c$export$61ae7f08643aa181 {
    /**
     * @param val Value of a type node caused the error
     * @param data Value of a data node caused the error
     * @param message An error message
     */ constructor(val, message, data){
        super(val, message);
        this.val = val;
        this.message = message;
        this.name = 'MichelsonTypeError';
        if (data !== undefined) this.data = data;
    }
}
// Ad hoc big integer parser
class $463f724b64570f1c$var$LongInteger {
    append(c) {
        let i = 0;
        while(c !== 0 || i < this.buf.length){
            const m = (this.buf[i] || 0) * 10 + c;
            this.buf[i++] = m % 256;
            c = Math.floor(m / 256);
        }
    }
    constructor(arg){
        this.neg = false;
        this.buf = [];
        if (arg === undefined) return;
        if (typeof arg === 'string') for(let i = 0; i < arg.length; i++){
            const c = arg.charCodeAt(i);
            if (i === 0 && c === 0x2d) this.neg = true;
            else {
                if (c < 0x30 || c > 0x39) throw new $463f724b64570f1c$var$LongIntegerError(`unexpected character in integer constant "${arg[i]}"`);
                this.append(c - 0x30);
            }
        }
        else if (arg < 0) {
            this.neg = true;
            this.append(-arg);
        } else this.append(arg);
    }
    cmp(arg) {
        if (this.neg !== arg.neg) return (arg.neg ? 1 : 0) - (this.neg ? 1 : 0);
        else {
            let ret = 0;
            if (this.buf.length !== arg.buf.length) ret = this.buf.length < arg.buf.length ? -1 : 1;
            else if (this.buf.length !== 0) {
                let i = arg.buf.length - 1;
                while(i >= 0 && this.buf[i] === arg.buf[i])i--;
                ret = i < 0 ? 0 : this.buf[i] < arg.buf[i] ? -1 : 1;
            }
            return !this.neg ? ret : ret === 0 ? 0 : -ret;
        }
    }
    get sign() {
        return this.buf.length === 0 ? 0 : this.neg ? -1 : 1;
    }
}
function $463f724b64570f1c$var$parseBytes(s) {
    const ret = [];
    for(let i = 0; i < s.length; i += 2){
        const x = parseInt(s.slice(i, i + 2), 16);
        if (Number.isNaN(x)) return null;
        ret.push(x);
    }
    return ret;
}
function $463f724b64570f1c$var$isDecimal(x) {
    try {
        new $463f724b64570f1c$var$LongInteger(x);
        return true;
    } catch (_a) {
        return false;
    }
}
function $463f724b64570f1c$var$isNatural(x) {
    try {
        return new $463f724b64570f1c$var$LongInteger(x).sign >= 0;
    } catch (_a) {
        return false;
    }
}
const $463f724b64570f1c$var$annRe = /^(@%|@%%|%@|[@:%]([_0-9a-zA-Z][_0-9a-zA-Z.%@]*)?)$/;
function $463f724b64570f1c$var$unpackAnnotations(p, opt) {
    if (Array.isArray(p)) return {};
    let field;
    let type;
    let vars;
    if (p.annots !== undefined) {
        for (const v of p.annots)if (v.length !== 0) {
            if (!$463f724b64570f1c$var$annRe.test(v) || !(opt === null || opt === void 0 ? void 0 : opt.specialVar) && (v === '@%' || v === '@%%') || !(opt === null || opt === void 0 ? void 0 : opt.specialFields) && v === '%@') throw new $463f724b64570f1c$export$61ae7f08643aa181(p, `${p.prim}: unexpected annotation: ${v}`);
            switch(v[0]){
                case '%':
                    if ((opt === null || opt === void 0 ? void 0 : opt.emptyFields) || v.length > 1) {
                        field = field || [];
                        field.push(v);
                    }
                    break;
                case ':':
                    if (v.length > 1) {
                        type = type || [];
                        type.push(v);
                    }
                    break;
                case '@':
                    if ((opt === null || opt === void 0 ? void 0 : opt.emptyVar) || v.length > 1) {
                        vars = vars || [];
                        vars.push(v);
                    }
                    break;
            }
        }
    }
    return {
        f: field,
        t: type,
        v: vars
    };
}
const $463f724b64570f1c$var$tezosPrefix = {
    BlockHash: [
        32,
        [
            1,
            52
        ]
    ],
    OperationHash: [
        32,
        [
            5,
            116
        ]
    ],
    OperationListHash: [
        32,
        [
            133,
            233
        ]
    ],
    OperationListListHash: [
        32,
        [
            29,
            159,
            109
        ]
    ],
    ProtocolHash: [
        32,
        [
            2,
            170
        ]
    ],
    ContextHash: [
        32,
        [
            79,
            199
        ]
    ],
    ED25519PublicKeyHash: [
        20,
        [
            6,
            161,
            159
        ]
    ],
    SECP256K1PublicKeyHash: [
        20,
        [
            6,
            161,
            161
        ]
    ],
    P256PublicKeyHash: [
        20,
        [
            6,
            161,
            164
        ]
    ],
    ContractHash: [
        20,
        [
            2,
            90,
            121
        ]
    ],
    CryptoboxPublicKeyHash: [
        16,
        [
            153,
            103
        ]
    ],
    ED25519Seed: [
        32,
        [
            13,
            15,
            58,
            7
        ]
    ],
    ED25519PublicKey: [
        32,
        [
            13,
            15,
            37,
            217
        ]
    ],
    SECP256K1SecretKey: [
        32,
        [
            17,
            162,
            224,
            201
        ]
    ],
    P256SecretKey: [
        32,
        [
            16,
            81,
            238,
            189
        ]
    ],
    ED25519EncryptedSeed: [
        56,
        [
            7,
            90,
            60,
            179,
            41
        ]
    ],
    SECP256K1EncryptedSecretKey: [
        56,
        [
            9,
            237,
            241,
            174,
            150
        ]
    ],
    P256EncryptedSecretKey: [
        56,
        [
            9,
            48,
            57,
            115,
            171
        ]
    ],
    SECP256K1PublicKey: [
        33,
        [
            3,
            254,
            226,
            86
        ]
    ],
    P256PublicKey: [
        33,
        [
            3,
            178,
            139,
            127
        ]
    ],
    SECP256K1Scalar: [
        33,
        [
            38,
            248,
            136
        ]
    ],
    SECP256K1Element: [
        33,
        [
            5,
            92,
            0
        ]
    ],
    ED25519SecretKey: [
        64,
        [
            43,
            246,
            78,
            7
        ]
    ],
    ED25519Signature: [
        64,
        [
            9,
            245,
            205,
            134,
            18
        ]
    ],
    SECP256K1Signature: [
        64,
        [
            13,
            115,
            101,
            19,
            63
        ]
    ],
    P256Signature: [
        64,
        [
            54,
            240,
            44,
            52
        ]
    ],
    GenericSignature: [
        64,
        [
            4,
            130,
            43
        ]
    ],
    ChainID: [
        4,
        [
            87,
            82,
            0
        ]
    ],
    RollupAddress: [
        20,
        [
            1,
            128,
            120,
            31
        ]
    ]
};
function $463f724b64570f1c$var$checkDecodeTezosID(id, ...types) {
    const buf = $463f724b64570f1c$var$decodeBase58Check(id);
    for (const t of types){
        const [plen, p] = $463f724b64570f1c$var$tezosPrefix[t];
        if (buf.length === plen + p.length) {
            let i = 0;
            while(i < p.length && buf[i] === p[i])i++;
            if (i === p.length) return [
                t,
                buf.slice(p.length)
            ];
        }
    }
    return null;
}
function $463f724b64570f1c$var$encodeTezosID(id, data) {
    const [plen, p] = $463f724b64570f1c$var$tezosPrefix[id];
    if (data.length !== plen) throw new $463f724b64570f1c$var$TezosIdEncodeError(`Incorrect data length for ${id}: ${data.length}`);
    return $463f724b64570f1c$var$encodeBase58Check([
        ...p,
        ...data
    ]);
}
function $463f724b64570f1c$var$unpackComb(id, v) {
    const vv = v;
    const args = Array.isArray(vv) ? vv : vv.args;
    if (args.length === 2) {
        // it's a way to make a union of two interfaces not an interface with two independent properties of union types
        const ret = id === 'pair' ? {
            prim: 'pair',
            args: args
        } : {
            prim: 'Pair',
            args: args
        };
        return ret;
    }
    return Object.assign(Object.assign({}, Array.isArray(vv) ? {
        prim: id
    } : vv), {
        args: [
            args[0],
            {
                prim: id,
                args: args.slice(1)
            }
        ]
    });
}
function $463f724b64570f1c$var$isPairType(t) {
    return Array.isArray(t) || t.prim === 'pair';
}
function $463f724b64570f1c$var$isPairData(d) {
    return Array.isArray(d) || 'prim' in d && d.prim === 'Pair';
}
const $463f724b64570f1c$var$rfc3339Re = /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])[T ]([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]|60)(\.[0-9]+)?(Z|[+-]([01][0-9]|2[0-3]):([0-5][0-9]))$/;
function $463f724b64570f1c$var$parseDate(a) {
    if ('string' in a) {
        if ($463f724b64570f1c$var$isNatural(a.string)) return new Date(parseInt(a.string, 10));
        else if ($463f724b64570f1c$var$rfc3339Re.test(a.string)) {
            const x = new Date(a.string);
            if (!Number.isNaN(x.valueOf)) return x;
        }
    } else if ($463f724b64570f1c$var$isDecimal(a.int)) return new Date(parseInt(a.int, 10));
    return null;
}
function $463f724b64570f1c$var$parseHex(s) {
    const res = [];
    for(let i = 0; i < s.length; i += 2){
        const ss = s.slice(i, i + 2);
        const x = parseInt(ss, 16);
        if (Number.isNaN(x)) throw new $463f724b64570f1c$var$HexParseError(ss);
        res.push(x);
    }
    return res;
}
function $463f724b64570f1c$var$hexBytes(bytes) {
    return bytes.map((x)=>(x >> 4 & 0xf).toString(16) + (x & 0xf).toString(16)).join('');
}
// Michelson validator
const $463f724b64570f1c$var$maxViewNameLength = 31;
const $463f724b64570f1c$var$noArgInstructionIDs = {
    ABS: true,
    ADD: true,
    ADDRESS: true,
    AMOUNT: true,
    AND: true,
    APPLY: true,
    BALANCE: true,
    BLAKE2B: true,
    CAR: true,
    CDR: true,
    CHAIN_ID: true,
    CHECK_SIGNATURE: true,
    COMPARE: true,
    CONCAT: true,
    CONS: true,
    EDIV: true,
    EQ: true,
    EXEC: true,
    FAILWITH: true,
    GE: true,
    GET_AND_UPDATE: true,
    GT: true,
    HASH_KEY: true,
    IMPLICIT_ACCOUNT: true,
    INT: true,
    ISNAT: true,
    JOIN_TICKETS: true,
    KECCAK: true,
    LE: true,
    LEVEL: true,
    LSL: true,
    LSR: true,
    LT: true,
    MEM: true,
    MUL: true,
    NEG: true,
    NEQ: true,
    NEVER: true,
    NOT: true,
    NOW: true,
    OR: true,
    PACK: true,
    PAIRING_CHECK: true,
    READ_TICKET: true,
    SAPLING_VERIFY_UPDATE: true,
    SELF: true,
    SELF_ADDRESS: true,
    SENDER: true,
    SET_DELEGATE: true,
    SHA256: true,
    SHA3: true,
    SHA512: true,
    SIZE: true,
    SLICE: true,
    SOME: true,
    SOURCE: true,
    SPLIT_TICKET: true,
    SUB: true,
    SWAP: true,
    TICKET: true,
    TICKET_DEPRECATED: true,
    TOTAL_VOTING_POWER: true,
    TRANSFER_TOKENS: true,
    UNIT: true,
    VOTING_POWER: true,
    XOR: true,
    RENAME: true,
    OPEN_CHEST: true,
    SUB_MUTEZ: true,
    MIN_BLOCK_TIME: true,
    BYTES: true,
    NAT: true
};
const $463f724b64570f1c$export$f3fe68d730702c17 = Object.assign({}, $463f724b64570f1c$var$noArgInstructionIDs, {
    CONTRACT: true,
    CREATE_CONTRACT: true,
    DIG: true,
    DIP: true,
    DROP: true,
    DUG: true,
    DUP: true,
    EMIT: true,
    EMPTY_BIG_MAP: true,
    EMPTY_MAP: true,
    EMPTY_SET: true,
    GET: true,
    IF: true,
    IF_CONS: true,
    IF_LEFT: true,
    IF_NONE: true,
    ITER: true,
    LAMBDA: true,
    LAMBDA_REC: true,
    LEFT: true,
    LOOP: true,
    LOOP_LEFT: true,
    MAP: true,
    NIL: true,
    NONE: true,
    PAIR: true,
    PUSH: true,
    RIGHT: true,
    SAPLING_EMPTY_STATE: true,
    UNPACK: true,
    UNPAIR: true,
    UPDATE: true,
    CAST: true,
    VIEW: true
});
const $463f724b64570f1c$var$simpleComparableTypeIDs = {
    unit: true,
    never: true,
    bool: true,
    int: true,
    nat: true,
    string: true,
    chain_id: true,
    bytes: true,
    mutez: true,
    key_hash: true,
    key: true,
    signature: true,
    timestamp: true,
    address: true,
    tx_rollup_l2_address: true
};
const $463f724b64570f1c$var$typeIDs = Object.assign({}, $463f724b64570f1c$var$simpleComparableTypeIDs, {
    or: true,
    pair: true,
    set: true,
    big_map: true,
    contract: true,
    lambda: true,
    list: true,
    map: true,
    operation: true,
    option: true,
    bls12_381_g1: true,
    bls12_381_g2: true,
    bls12_381_fr: true,
    sapling_transaction: true,
    sapling_transaction_deprecated: true,
    sapling_state: true,
    ticket: true,
    chest_key: true,
    chest: true
});
class $463f724b64570f1c$export$6565c3cd336fa0c4 extends $463f724b64570f1c$export$61ae7f08643aa181 {
    /**
     * @param val Value of a node caused the error
     * @param message An error message
     */ constructor(val, message){
        super(val, message);
        this.val = val;
        this.message = message;
        this.name = 'MichelsonValidationError';
    }
}
function $463f724b64570f1c$var$isPrim(ex) {
    return 'prim' in ex;
}
function $463f724b64570f1c$var$isPrimOrSeq(ex) {
    return Array.isArray(ex) || 'prim' in ex;
}
function $463f724b64570f1c$var$assertPrim(ex) {
    if ($463f724b64570f1c$var$isPrim(ex)) return true;
    throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'prim expression expected');
}
function $463f724b64570f1c$var$assertSeq(ex) {
    if (Array.isArray(ex)) return true;
    throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'sequence expression expected');
}
function $463f724b64570f1c$var$assertPrimOrSeq(ex) {
    if ($463f724b64570f1c$var$isPrimOrSeq(ex)) return true;
    throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'prim or sequence expression expected');
}
function $463f724b64570f1c$var$assertNatural(i) {
    if (i.int[0] === '-') throw new $463f724b64570f1c$export$6565c3cd336fa0c4(i, 'natural number expected');
}
function $463f724b64570f1c$var$assertIntLiteral(ex) {
    if ('int' in ex) return true;
    throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'int literal expected');
}
function $463f724b64570f1c$var$assertStringLiteral(ex) {
    if ('string' in ex) return true;
    throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'string literal expected');
}
function $463f724b64570f1c$var$assertArgs(ex, n) {
    var _a;
    if (n === 0 && ex.args === undefined || ((_a = ex.args) === null || _a === void 0 ? void 0 : _a.length) === n) return true;
    throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, `${n} arguments expected`);
}
/**
 * Checks if the node is a valid Michelson code (sequence of instructions).
 * This is a type guard function which either returns true of throws an exception.
 * @param ex An AST node
 */ function $463f724b64570f1c$export$57f49bebc69f7bbc(ex) {
    var _a, _b;
    if (Array.isArray(ex)) {
        for (const n of ex){
            if (!Array.isArray(n) && !$463f724b64570f1c$var$isPrim(n)) throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'sequence or prim expected');
            $463f724b64570f1c$export$57f49bebc69f7bbc(n);
        }
        return true;
    }
    if ($463f724b64570f1c$var$assertPrim(ex)) {
        if (Object.prototype.hasOwnProperty.call($463f724b64570f1c$var$noArgInstructionIDs, ex.prim)) {
            $463f724b64570f1c$var$assertArgs(ex, 0);
            return true;
        }
        switch(ex.prim){
            case 'DROP':
            case 'PAIR':
            case 'UNPAIR':
            case 'DUP':
            case 'UPDATE':
            case 'GET':
                if (ex.args !== undefined && $463f724b64570f1c$var$assertArgs(ex, 1)) /* istanbul ignore else */ {
                    if ($463f724b64570f1c$var$assertIntLiteral(ex.args[0])) $463f724b64570f1c$var$assertNatural(ex.args[0]);
                }
                break;
            case 'DIG':
            case 'DUG':
            case 'SAPLING_EMPTY_STATE':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1)) /* istanbul ignore else */ {
                    if ($463f724b64570f1c$var$assertIntLiteral(ex.args[0])) $463f724b64570f1c$var$assertNatural(ex.args[0]);
                }
                break;
            case 'NONE':
            case 'LEFT':
            case 'RIGHT':
            case 'NIL':
            case 'CAST':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1)) $463f724b64570f1c$export$176936cdb34aed2f(ex.args[0]);
                break;
            case 'UNPACK':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1)) $463f724b64570f1c$export$a32a137820025fa5(ex.args[0]);
                break;
            case 'CONTRACT':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1)) $463f724b64570f1c$export$167bd1e3110eb198(ex.args[0]);
                break;
            case 'IF_NONE':
            case 'IF_LEFT':
            case 'IF_CONS':
            case 'IF':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 2)) {
                    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertSeq(ex.args[0])) $463f724b64570f1c$export$57f49bebc69f7bbc(ex.args[0]);
                    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertSeq(ex.args[1])) $463f724b64570f1c$export$57f49bebc69f7bbc(ex.args[1]);
                }
                break;
            case 'MAP':
            case 'ITER':
            case 'LOOP':
            case 'LOOP_LEFT':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1)) $463f724b64570f1c$export$57f49bebc69f7bbc(ex.args[0]);
                break;
            case 'CREATE_CONTRACT':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1)) $463f724b64570f1c$export$ac03cc731bd7a006(ex.args[0]);
                break;
            case 'DIP':
                if (((_a = ex.args) === null || _a === void 0 ? void 0 : _a.length) === 2) {
                    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertIntLiteral(ex.args[0])) $463f724b64570f1c$var$assertNatural(ex.args[0]);
                    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertSeq(ex.args[1])) $463f724b64570f1c$export$57f49bebc69f7bbc(ex.args[1]);
                } else if (((_b = ex.args) === null || _b === void 0 ? void 0 : _b.length) === 1) /* istanbul ignore else */ {
                    if ($463f724b64570f1c$var$assertSeq(ex.args[0])) $463f724b64570f1c$export$57f49bebc69f7bbc(ex.args[0]);
                } else throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, '1 or 2 arguments expected');
                break;
            case 'PUSH':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 2)) {
                    $463f724b64570f1c$export$61842f5d814f90cb(ex.args[0]);
                    $463f724b64570f1c$export$3cc4ed4ae67ac731(ex.args[1]);
                }
                break;
            case 'EMPTY_SET':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1)) $463f724b64570f1c$export$d5e5c91702354d8f(ex.args[0]);
                break;
            case 'EMPTY_MAP':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 2)) {
                    $463f724b64570f1c$export$d5e5c91702354d8f(ex.args[0]);
                    $463f724b64570f1c$export$176936cdb34aed2f(ex.args[1]);
                }
                break;
            case 'EMPTY_BIG_MAP':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 2)) {
                    $463f724b64570f1c$export$d5e5c91702354d8f(ex.args[0]);
                    $463f724b64570f1c$export$5a64892aaade38d6(ex.args[1]);
                }
                break;
            case 'LAMBDA_REC':
            case 'LAMBDA':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 3)) {
                    $463f724b64570f1c$export$176936cdb34aed2f(ex.args[0]);
                    $463f724b64570f1c$export$176936cdb34aed2f(ex.args[1]);
                    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertSeq(ex.args[2])) $463f724b64570f1c$export$57f49bebc69f7bbc(ex.args[2]);
                }
                break;
            case 'VIEW':
                /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 2)) {
                    if ($463f724b64570f1c$var$assertStringLiteral(ex.args[0])) $463f724b64570f1c$export$bfa50b833f100a15(ex.args[0]);
                    if ($463f724b64570f1c$export$176936cdb34aed2f(ex.args[1])) $463f724b64570f1c$export$61842f5d814f90cb(ex.args[1]);
                }
                break;
            case 'EMIT':
                if (ex.args && ex.args.length > 0) $463f724b64570f1c$var$assertArgs(ex, 1);
                else $463f724b64570f1c$var$assertArgs(ex, 0);
                break;
            default:
                throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'instruction expected');
        }
    }
    return true;
}
function $463f724b64570f1c$export$d5e5c91702354d8f(ex) {
    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertPrimOrSeq(ex)) {
        if (Array.isArray(ex) || ex.prim === 'pair' || ex.prim === 'or' || ex.prim === 'option') $463f724b64570f1c$var$traverseType(ex, (ex)=>$463f724b64570f1c$export$d5e5c91702354d8f(ex));
        else if (!Object.prototype.hasOwnProperty.call($463f724b64570f1c$var$simpleComparableTypeIDs, ex.prim)) throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, `${ex.prim}: type is not comparable`);
    }
    return true;
}
function $463f724b64570f1c$export$a32a137820025fa5(ex) {
    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertPrimOrSeq(ex)) {
        if ($463f724b64570f1c$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($463f724b64570f1c$var$typeIDs, ex.prim) || ex.prim === 'big_map' || ex.prim === 'operation' || ex.prim === 'sapling_state' || ex.prim === 'ticket') throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, `${ex.prim}: type can't be used inside PACK/UNPACK instructions`);
            $463f724b64570f1c$var$traverseType(ex, (ex)=>$463f724b64570f1c$export$a32a137820025fa5(ex));
        }
    }
    return true;
}
function $463f724b64570f1c$export$61842f5d814f90cb(ex) {
    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertPrimOrSeq(ex)) {
        if ($463f724b64570f1c$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($463f724b64570f1c$var$typeIDs, ex.prim) || ex.prim === 'big_map' || ex.prim === 'operation' || ex.prim === 'sapling_state' || ex.prim === 'ticket' || ex.prim === 'contract') throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, `${ex.prim}: type can't be pushed`);
            $463f724b64570f1c$var$traverseType(ex, (ex)=>$463f724b64570f1c$export$61842f5d814f90cb(ex));
        }
    }
    return true;
}
function $463f724b64570f1c$export$f3036b1da0a36541(ex) {
    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertPrimOrSeq(ex)) {
        if ($463f724b64570f1c$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($463f724b64570f1c$var$typeIDs, ex.prim) || ex.prim === 'operation' || ex.prim === 'contract') throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, `${ex.prim}: type can't be used as part of a storage`);
            $463f724b64570f1c$var$traverseType(ex, (ex)=>$463f724b64570f1c$export$f3036b1da0a36541(ex));
        }
    }
    return true;
}
function $463f724b64570f1c$export$167bd1e3110eb198(ex) {
    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertPrimOrSeq(ex)) {
        if ($463f724b64570f1c$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($463f724b64570f1c$var$typeIDs, ex.prim) || ex.prim === 'operation') throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, `${ex.prim}: type can't be used as part of a parameter`);
            $463f724b64570f1c$var$traverseType(ex, (ex)=>$463f724b64570f1c$export$167bd1e3110eb198(ex));
        }
    }
    return true;
}
function $463f724b64570f1c$export$5a64892aaade38d6(ex) {
    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertPrimOrSeq(ex)) {
        if ($463f724b64570f1c$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($463f724b64570f1c$var$typeIDs, ex.prim) || ex.prim === 'big_map' || ex.prim === 'operation' || ex.prim === 'sapling_state') throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, `${ex.prim}: type can't be used inside a big_map`);
            $463f724b64570f1c$var$traverseType(ex, (ex)=>$463f724b64570f1c$export$5a64892aaade38d6(ex));
        }
    }
    return true;
}
const $463f724b64570f1c$var$viewRe = new RegExp('^[a-zA-Z0-9_.%@]*$');
function $463f724b64570f1c$export$bfa50b833f100a15(name) {
    if (name.string.length > $463f724b64570f1c$var$maxViewNameLength) throw new $463f724b64570f1c$export$6565c3cd336fa0c4(name, `view name too long: ${name.string}`);
    if (!$463f724b64570f1c$var$viewRe.test(name.string)) throw new $463f724b64570f1c$export$6565c3cd336fa0c4(name, `invalid character(s) in view name: ${name.string}`);
}
/**
 * Checks if the node is a valid Michelson type expression.
 * This is a type guard function which either returns true of throws an exception.
 * @param ex An AST node
 */ function $463f724b64570f1c$export$176936cdb34aed2f(ex) {
    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertPrimOrSeq(ex)) {
        if ($463f724b64570f1c$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($463f724b64570f1c$var$typeIDs, ex.prim)) throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'type expected');
            $463f724b64570f1c$var$traverseType(ex, (ex)=>$463f724b64570f1c$export$176936cdb34aed2f(ex));
        }
    }
    return true;
}
function $463f724b64570f1c$var$traverseType(ex, cb) {
    if (Array.isArray(ex) || ex.prim === 'pair') {
        const args = Array.isArray(ex) ? ex : ex.args;
        if (args === undefined || args.length < 2) throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'at least 2 arguments expected');
        args.forEach((a)=>{
            if ($463f724b64570f1c$var$assertPrimOrSeq(a)) cb(a);
        });
        return true;
    }
    switch(ex.prim){
        case 'option':
        case 'list':
            /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1) && $463f724b64570f1c$var$assertPrimOrSeq(ex.args[0])) cb(ex.args[0]);
            break;
        case 'contract':
            /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1)) $463f724b64570f1c$export$167bd1e3110eb198(ex.args[0]);
            break;
        case 'or':
            /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 2) && $463f724b64570f1c$var$assertPrimOrSeq(ex.args[0]) && $463f724b64570f1c$var$assertPrimOrSeq(ex.args[1])) {
                cb(ex.args[0]);
                cb(ex.args[1]);
            }
            break;
        case 'lambda':
            /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 2)) {
                $463f724b64570f1c$export$176936cdb34aed2f(ex.args[0]);
                $463f724b64570f1c$export$176936cdb34aed2f(ex.args[1]);
            }
            break;
        case 'set':
            /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1)) $463f724b64570f1c$export$d5e5c91702354d8f(ex.args[0]);
            break;
        case 'map':
            /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 2) && $463f724b64570f1c$var$assertPrimOrSeq(ex.args[0]) && $463f724b64570f1c$var$assertPrimOrSeq(ex.args[1])) {
                $463f724b64570f1c$export$d5e5c91702354d8f(ex.args[0]);
                cb(ex.args[1]);
            }
            break;
        case 'big_map':
            /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 2) && $463f724b64570f1c$var$assertPrimOrSeq(ex.args[0]) && $463f724b64570f1c$var$assertPrimOrSeq(ex.args[1])) {
                $463f724b64570f1c$export$d5e5c91702354d8f(ex.args[0]);
                $463f724b64570f1c$export$5a64892aaade38d6(ex.args[1]);
                cb(ex.args[1]);
            }
            break;
        case 'ticket':
            /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1) && $463f724b64570f1c$var$assertPrimOrSeq(ex.args[0])) $463f724b64570f1c$export$d5e5c91702354d8f(ex.args[0]);
            break;
        case 'sapling_state':
        case 'sapling_transaction':
            if ($463f724b64570f1c$var$assertArgs(ex, 1)) $463f724b64570f1c$var$assertIntLiteral(ex.args[0]);
            break;
        default:
            $463f724b64570f1c$var$assertArgs(ex, 0);
    }
    return true;
}
/**
 * Checks if the node is a valid Michelson data literal such as `(Pair {Elt "0" 0} 0)`.
 * This is a type guard function which either returns true of throws an exception.
 * @param ex An AST node
 */ function $463f724b64570f1c$export$3cc4ed4ae67ac731(ex) {
    if ('int' in ex || 'string' in ex || 'bytes' in ex) return true;
    if (Array.isArray(ex)) {
        let mapElts = 0;
        for (const n of ex)if ($463f724b64570f1c$var$isPrim(n) && n.prim === 'Elt') {
            /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(n, 2)) {
                $463f724b64570f1c$export$3cc4ed4ae67ac731(n.args[0]);
                $463f724b64570f1c$export$3cc4ed4ae67ac731(n.args[1]);
            }
            mapElts++;
        } else $463f724b64570f1c$export$3cc4ed4ae67ac731(n);
        if (mapElts !== 0 && mapElts !== ex.length) throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, "data entries and map elements can't be intermixed");
        return true;
    }
    if ($463f724b64570f1c$var$isPrim(ex)) switch(ex.prim){
        case 'Unit':
        case 'True':
        case 'False':
        case 'None':
            $463f724b64570f1c$var$assertArgs(ex, 0);
            break;
        case 'Pair':
            /* istanbul ignore else */ if (ex.args === undefined || ex.args.length < 2) throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'at least 2 arguments expected');
            for (const a of ex.args)$463f724b64570f1c$export$3cc4ed4ae67ac731(a);
            break;
        case 'Left':
        case 'Right':
        case 'Some':
            /* istanbul ignore else */ if ($463f724b64570f1c$var$assertArgs(ex, 1)) $463f724b64570f1c$export$3cc4ed4ae67ac731(ex.args[0]);
            break;
        case 'Lambda_rec':
            if (ex.args) $463f724b64570f1c$export$57f49bebc69f7bbc(ex.args);
            break;
        default:
            if (Object.prototype.hasOwnProperty.call($463f724b64570f1c$export$f3fe68d730702c17, ex.prim)) $463f724b64570f1c$export$57f49bebc69f7bbc(ex);
            else throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'data entry or instruction expected');
    }
    else throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, 'data entry expected');
    return true;
}
/**
 * Checks if the node is a valid Michelson smart contract source containing all required and valid properties such as `parameter`, `storage` and `code`.
 * This is a type guard function which either returns true of throws an exception.
 * @param ex An AST node
 */ function $463f724b64570f1c$export$ac03cc731bd7a006(ex) {
    /* istanbul ignore else */ if ($463f724b64570f1c$var$assertSeq(ex)) {
        const toplevelSec = {};
        const views = {};
        for (const sec of ex)if ($463f724b64570f1c$var$assertPrim(sec)) {
            if (sec.prim !== 'view') {
                if (sec.prim in toplevelSec) throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, `duplicate contract section: ${sec.prim}`);
                toplevelSec[sec.prim] = true;
            }
            /* istanbul ignore else */ switch(sec.prim){
                case 'code':
                    if ($463f724b64570f1c$var$assertArgs(sec, 1)) /* istanbul ignore else */ {
                        if ($463f724b64570f1c$var$assertSeq(sec.args[0])) $463f724b64570f1c$export$57f49bebc69f7bbc(sec.args[0]);
                    }
                    break;
                case 'parameter':
                    if ($463f724b64570f1c$var$assertArgs(sec, 1)) $463f724b64570f1c$export$167bd1e3110eb198(sec.args[0]);
                    if (sec.annots) throw new $463f724b64570f1c$export$6565c3cd336fa0c4(sec, 'Annotation must be part of the parameter type');
                    break;
                case 'storage':
                    if ($463f724b64570f1c$var$assertArgs(sec, 1)) $463f724b64570f1c$export$f3036b1da0a36541(sec.args[0]);
                    break;
                case 'view':
                    if ($463f724b64570f1c$var$assertArgs(sec, 4)) {
                        if ($463f724b64570f1c$var$assertStringLiteral(sec.args[0])) {
                            const name = sec.args[0];
                            if (name.string in views) throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, `duplicate view name: ${name.string}`);
                            views[name.string] = true;
                            $463f724b64570f1c$export$bfa50b833f100a15(name);
                        }
                        $463f724b64570f1c$export$61842f5d814f90cb(sec.args[1]);
                        $463f724b64570f1c$export$61842f5d814f90cb(sec.args[2]);
                        if ($463f724b64570f1c$var$assertSeq(sec.args[3])) $463f724b64570f1c$export$57f49bebc69f7bbc(sec.args[3]);
                    }
                    break;
                default:
                    throw new $463f724b64570f1c$export$6565c3cd336fa0c4(ex, `unexpected contract section: ${sec.prim}`);
            }
        }
    }
    return true;
}
/**
 * Checks if the node is a valid Michelson smart contract source containing all required and valid properties such as `parameter`, `storage` and `code`.
 * @param ex An AST node
 */ function $463f724b64570f1c$export$ee5fb880e1050817(ex) {
    try {
        $463f724b64570f1c$export$ac03cc731bd7a006(ex);
        return true;
    } catch (_a) {
        return false;
    }
}
/**
 * Checks if the node is a valid Michelson data literal such as `(Pair {Elt "0" 0} 0)`.
 * @param ex An AST node
 */ function $463f724b64570f1c$export$bbb3f6f181a55892(ex) {
    try {
        $463f724b64570f1c$export$3cc4ed4ae67ac731(ex);
        return true;
    } catch (_a) {
        return false;
    }
}
/**
 * Checks if the node is a valid Michelson code (sequence of instructions).
 * @param ex An AST node
 */ function $463f724b64570f1c$export$a2dcce50fb4b57ad(ex) {
    try {
        $463f724b64570f1c$export$57f49bebc69f7bbc(ex);
        return true;
    } catch (_a) {
        return false;
    }
}
/**
 * Checks if the node is a valid Michelson type expression.
 * @param ex An AST node
 */ function $463f724b64570f1c$export$a417c0bb2942f1a4(ex) {
    try {
        $463f724b64570f1c$export$176936cdb34aed2f(ex);
        return true;
    } catch (_a) {
        return false;
    }
}
function $463f724b64570f1c$export$517b0c6d75337fc8(p) {
    return Object.prototype.hasOwnProperty.call($463f724b64570f1c$export$f3fe68d730702c17, p.prim);
}
function $463f724b64570f1c$export$5cb2cbfd0cef2950(d) {
    if (!Array.isArray(d)) return false;
    for (const v of d)if ('prim' in v) {
        if ($463f724b64570f1c$export$517b0c6d75337fc8(v)) throw new $463f724b64570f1c$export$61ae7f08643aa181(d, `Instruction outside of a lambda: ${JSON.stringify(d)}`);
        else if (v.prim === 'Elt') throw new $463f724b64570f1c$export$61ae7f08643aa181(d, `Elt item outside of a map literal: ${JSON.stringify(d)}`);
    }
    return true;
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $463f724b64570f1c$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
// The order is important!
// The position represent the encoding value.
const $463f724b64570f1c$var$primitives = [
    'parameter',
    'storage',
    'code',
    'False',
    'Elt',
    'Left',
    'None',
    'Pair',
    'Right',
    'Some',
    'True',
    'Unit',
    'PACK',
    'UNPACK',
    'BLAKE2B',
    'SHA256',
    'SHA512',
    'ABS',
    'ADD',
    'AMOUNT',
    'AND',
    'BALANCE',
    'CAR',
    'CDR',
    'CHECK_SIGNATURE',
    'COMPARE',
    'CONCAT',
    'CONS',
    'CREATE_ACCOUNT',
    'CREATE_CONTRACT',
    'IMPLICIT_ACCOUNT',
    'DIP',
    'DROP',
    'DUP',
    'EDIV',
    'EMPTY_MAP',
    'EMPTY_SET',
    'EQ',
    'EXEC',
    'FAILWITH',
    'GE',
    'GET',
    'GT',
    'HASH_KEY',
    'IF',
    'IF_CONS',
    'IF_LEFT',
    'IF_NONE',
    'INT',
    'LAMBDA',
    'LE',
    'LEFT',
    'LOOP',
    'LSL',
    'LSR',
    'LT',
    'MAP',
    'MEM',
    'MUL',
    'NEG',
    'NEQ',
    'NIL',
    'NONE',
    'NOT',
    'NOW',
    'OR',
    'PAIR',
    'PUSH',
    'RIGHT',
    'SIZE',
    'SOME',
    'SOURCE',
    'SENDER',
    'SELF',
    'STEPS_TO_QUOTA',
    'SUB',
    'SWAP',
    'TRANSFER_TOKENS',
    'SET_DELEGATE',
    'UNIT',
    'UPDATE',
    'XOR',
    'ITER',
    'LOOP_LEFT',
    'ADDRESS',
    'CONTRACT',
    'ISNAT',
    'CAST',
    'RENAME',
    'bool',
    'contract',
    'int',
    'key',
    'key_hash',
    'lambda',
    'list',
    'map',
    'big_map',
    'nat',
    'option',
    'or',
    'pair',
    'set',
    'signature',
    'string',
    'bytes',
    'mutez',
    'timestamp',
    'unit',
    'operation',
    'address',
    'SLICE',
    'DIG',
    'DUG',
    'EMPTY_BIG_MAP',
    'APPLY',
    'chain_id',
    'CHAIN_ID',
    'LEVEL',
    'SELF_ADDRESS',
    'never',
    'NEVER',
    'UNPAIR',
    'VOTING_POWER',
    'TOTAL_VOTING_POWER',
    'KECCAK',
    'SHA3',
    'PAIRING_CHECK',
    'bls12_381_g1',
    'bls12_381_g2',
    'bls12_381_fr',
    'sapling_state',
    'sapling_transaction_deprecated',
    'SAPLING_EMPTY_STATE',
    'SAPLING_VERIFY_UPDATE',
    'ticket',
    'TICKET_DEPRECATED',
    'READ_TICKET',
    'SPLIT_TICKET',
    'JOIN_TICKETS',
    'GET_AND_UPDATE',
    'chest',
    'chest_key',
    'OPEN_CHEST',
    'VIEW',
    'view',
    'constant',
    'SUB_MUTEZ',
    'tx_rollup_l2_address',
    'MIN_BLOCK_TIME',
    'sapling_transaction',
    'EMIT',
    'Lambda_rec',
    'LAMBDA_REC',
    'TICKET',
    'BYTES',
    'NAT'
];
const $463f724b64570f1c$var$primTags = Object.assign({}, ...$463f724b64570f1c$var$primitives.map((v, i)=>({
        [v]: i
    })));
var $463f724b64570f1c$var$Tag;
(function(Tag) {
    Tag[Tag["Int"] = 0] = "Int";
    Tag[Tag["String"] = 1] = "String";
    Tag[Tag["Sequence"] = 2] = "Sequence";
    Tag[Tag["Prim0"] = 3] = "Prim0";
    Tag[Tag["Prim0Annot"] = 4] = "Prim0Annot";
    Tag[Tag["Prim1"] = 5] = "Prim1";
    Tag[Tag["Prim1Annot"] = 6] = "Prim1Annot";
    Tag[Tag["Prim2"] = 7] = "Prim2";
    Tag[Tag["Prim2Annot"] = 8] = "Prim2Annot";
    Tag[Tag["Prim"] = 9] = "Prim";
    Tag[Tag["Bytes"] = 10] = "Bytes";
})($463f724b64570f1c$var$Tag || ($463f724b64570f1c$var$Tag = {}));
class $463f724b64570f1c$var$Writer {
    constructor(){
        this.buffer = [];
    }
    get length() {
        return this.buffer.length;
    }
    writeBytes(val) {
        this.buffer.push(...val.map((v)=>v & 0xff));
    }
    writeUint8(val) {
        const v = val | 0;
        this.buffer.push(v & 0xff);
    }
    writeUint16(val) {
        const v = val | 0;
        this.buffer.push(v >> 8 & 0xff);
        this.buffer.push(v & 0xff);
    }
    writeUint32(val) {
        const v = val | 0;
        this.buffer.push(v >> 24 & 0xff);
        this.buffer.push(v >> 16 & 0xff);
        this.buffer.push(v >> 8 & 0xff);
        this.buffer.push(v & 0xff);
    }
    writeInt8(val) {
        this.writeUint8(val);
    }
    writeInt16(val) {
        this.writeUint16(val);
    }
    writeInt32(val) {
        this.writeUint32(val);
    }
}
const $463f724b64570f1c$var$boundsErr = new Error('bounds out of range');
class $463f724b64570f1c$var$Reader {
    constructor(buffer, idx = 0, cap = buffer.length){
        this.buffer = buffer;
        this.idx = idx;
        this.cap = cap;
    }
    /** Remaining length */ get length() {
        return this.cap - this.idx;
    }
    readBytes(len) {
        if (this.cap - this.idx < len) throw $463f724b64570f1c$var$boundsErr;
        const ret = this.buffer.slice(this.idx, this.idx + len);
        this.idx += len;
        return ret;
    }
    reader(len) {
        if (this.cap - this.idx < len) throw $463f724b64570f1c$var$boundsErr;
        const ret = new $463f724b64570f1c$var$Reader(this.buffer, this.idx, this.idx + len);
        this.idx += len;
        return ret;
    }
    copy() {
        return new $463f724b64570f1c$var$Reader(this.buffer, this.idx, this.cap);
    }
    readUint8() {
        if (this.cap - this.idx < 1) throw $463f724b64570f1c$var$boundsErr;
        return this.buffer[this.idx++] >>> 0;
    }
    readUint16() {
        if (this.cap - this.idx < 2) throw $463f724b64570f1c$var$boundsErr;
        const x0 = this.buffer[this.idx++];
        const x1 = this.buffer[this.idx++];
        return (x0 << 8 | x1) >>> 0;
    }
    readUint32() {
        if (this.cap - this.idx < 4) throw $463f724b64570f1c$var$boundsErr;
        const x0 = this.buffer[this.idx++];
        const x1 = this.buffer[this.idx++];
        const x2 = this.buffer[this.idx++];
        const x3 = this.buffer[this.idx++];
        return (x0 << 24 | x1 << 16 | x2 << 8 | x3) >>> 0;
    }
    readInt8() {
        if (this.cap - this.idx < 1) throw $463f724b64570f1c$var$boundsErr;
        const x = this.buffer[this.idx++];
        return x << 24 >> 24;
    }
    readInt16() {
        if (this.cap - this.idx < 2) throw $463f724b64570f1c$var$boundsErr;
        const x0 = this.buffer[this.idx++];
        const x1 = this.buffer[this.idx++];
        return (x0 << 8 | x1) << 16 >> 16;
    }
    readInt32() {
        if (this.cap - this.idx < 4) throw $463f724b64570f1c$var$boundsErr;
        const x0 = this.buffer[this.idx++];
        const x1 = this.buffer[this.idx++];
        const x2 = this.buffer[this.idx++];
        const x3 = this.buffer[this.idx++];
        return x0 << 24 | x1 << 16 | x2 << 8 | x3;
    }
}
var $463f724b64570f1c$var$ContractID;
(function(ContractID) {
    ContractID[ContractID["Implicit"] = 0] = "Implicit";
    ContractID[ContractID["Originated"] = 1] = "Originated";
})($463f724b64570f1c$var$ContractID || ($463f724b64570f1c$var$ContractID = {}));
var $463f724b64570f1c$var$PublicKeyHashID;
(function(PublicKeyHashID) {
    PublicKeyHashID[PublicKeyHashID["ED25519"] = 0] = "ED25519";
    PublicKeyHashID[PublicKeyHashID["SECP256K1"] = 1] = "SECP256K1";
    PublicKeyHashID[PublicKeyHashID["P256"] = 2] = "P256";
})($463f724b64570f1c$var$PublicKeyHashID || ($463f724b64570f1c$var$PublicKeyHashID = {}));
function $463f724b64570f1c$var$readPublicKeyHash(rd) {
    let type;
    const tag = rd.readUint8();
    switch(tag){
        case $463f724b64570f1c$var$PublicKeyHashID.ED25519:
            type = 'ED25519PublicKeyHash';
            break;
        case $463f724b64570f1c$var$PublicKeyHashID.SECP256K1:
            type = 'SECP256K1PublicKeyHash';
            break;
        case $463f724b64570f1c$var$PublicKeyHashID.P256:
            type = 'P256PublicKeyHash';
            break;
        default:
            throw new Error(`unknown public key hash tag: ${tag}`);
    }
    return {
        type: type,
        hash: rd.readBytes(20)
    };
}
function $463f724b64570f1c$var$readAddress(rd) {
    let address;
    const tag = rd.readUint8();
    switch(tag){
        case $463f724b64570f1c$var$ContractID.Implicit:
            address = $463f724b64570f1c$var$readPublicKeyHash(rd);
            break;
        case $463f724b64570f1c$var$ContractID.Originated:
            address = {
                type: 'ContractHash',
                hash: rd.readBytes(20)
            };
            rd.readBytes(1);
            break;
        default:
            throw new Error(`unknown address tag: ${tag}`);
    }
    if (rd.length !== 0) {
        // entry point
        const dec = new TextDecoder();
        address.entryPoint = dec.decode(new Uint8Array(rd.readBytes(rd.length)));
    }
    return address;
}
function $463f724b64570f1c$var$writePublicKeyHash(a, w) {
    let tag;
    switch(a.type){
        case 'ED25519PublicKeyHash':
            tag = $463f724b64570f1c$var$PublicKeyHashID.ED25519;
            break;
        case 'SECP256K1PublicKeyHash':
            tag = $463f724b64570f1c$var$PublicKeyHashID.SECP256K1;
            break;
        case 'P256PublicKeyHash':
            tag = $463f724b64570f1c$var$PublicKeyHashID.P256;
            break;
        default:
            throw new Error(`unexpected address type: ${a.type}`);
    }
    w.writeUint8(tag);
    w.writeBytes(Array.from(a.hash));
}
function $463f724b64570f1c$var$writeAddress(a, w) {
    if (a.type === 'ContractHash') {
        w.writeUint8($463f724b64570f1c$var$ContractID.Originated);
        w.writeBytes(Array.from(a.hash));
        w.writeUint8(0);
    } else {
        w.writeUint8($463f724b64570f1c$var$ContractID.Implicit);
        $463f724b64570f1c$var$writePublicKeyHash(a, w);
    }
    if (a.entryPoint !== undefined && a.entryPoint !== '' && a.entryPoint !== 'default') {
        const enc = new TextEncoder();
        const bytes = enc.encode(a.entryPoint);
        w.writeBytes(Array.from(bytes));
    }
}
var $463f724b64570f1c$var$PublicKeyID;
(function(PublicKeyID) {
    PublicKeyID[PublicKeyID["ED25519"] = 0] = "ED25519";
    PublicKeyID[PublicKeyID["SECP256K1"] = 1] = "SECP256K1";
    PublicKeyID[PublicKeyID["P256"] = 2] = "P256";
})($463f724b64570f1c$var$PublicKeyID || ($463f724b64570f1c$var$PublicKeyID = {}));
function $463f724b64570f1c$var$readPublicKey(rd) {
    let ln;
    let type;
    const tag = rd.readUint8();
    switch(tag){
        case $463f724b64570f1c$var$PublicKeyID.ED25519:
            type = 'ED25519PublicKey';
            ln = 32;
            break;
        case $463f724b64570f1c$var$PublicKeyID.SECP256K1:
            type = 'SECP256K1PublicKey';
            ln = 33;
            break;
        case $463f724b64570f1c$var$PublicKeyID.P256:
            type = 'P256PublicKey';
            ln = 33;
            break;
        default:
            throw new Error(`unknown public key tag: ${tag}`);
    }
    return {
        type: type,
        publicKey: rd.readBytes(ln)
    };
}
function $463f724b64570f1c$var$writePublicKey(pk, w) {
    let tag;
    switch(pk.type){
        case 'ED25519PublicKey':
            tag = $463f724b64570f1c$var$PublicKeyID.ED25519;
            break;
        case 'SECP256K1PublicKey':
            tag = $463f724b64570f1c$var$PublicKeyID.SECP256K1;
            break;
        case 'P256PublicKey':
            tag = $463f724b64570f1c$var$PublicKeyID.P256;
            break;
        default:
            throw new Error(`unexpected public key type: ${pk.type}`);
    }
    w.writeUint8(tag);
    w.writeBytes(Array.from(pk.publicKey));
}
function $463f724b64570f1c$var$writeExpr(expr, wr, tf) {
    var _a, _b;
    const [e, args] = tf(expr);
    if (Array.isArray(e)) {
        const w = new $463f724b64570f1c$var$Writer();
        for (const v of e){
            const a = args.next();
            if (a.done) throw new Error('REPORT ME: iterator is done');
            $463f724b64570f1c$var$writeExpr(v, w, a.value);
        }
        wr.writeUint8($463f724b64570f1c$var$Tag.Sequence);
        wr.writeUint32(w.length);
        wr.writeBytes(w.buffer);
        return;
    }
    if ('string' in e) {
        const enc = new TextEncoder();
        const bytes = enc.encode(e.string);
        wr.writeUint8($463f724b64570f1c$var$Tag.String);
        wr.writeUint32(bytes.length);
        wr.writeBytes(Array.from(bytes));
        return;
    }
    if ('int' in e) {
        wr.writeUint8($463f724b64570f1c$var$Tag.Int);
        let val = BigInt(e.int);
        const sign = val < 0;
        if (sign) val = -val;
        let i = 0;
        do {
            const bits = i === 0 ? BigInt(6) : BigInt(7);
            let byte = val & (BigInt(1) << bits) - BigInt(1);
            val >>= bits;
            if (val) byte |= BigInt(0x80);
            if (i === 0 && sign) byte |= BigInt(0x40);
            wr.writeUint8(Number(byte));
            i++;
        }while (val);
        return;
    }
    if ('bytes' in e) {
        const bytes = $463f724b64570f1c$var$parseHex(e.bytes);
        wr.writeUint8($463f724b64570f1c$var$Tag.Bytes);
        wr.writeUint32(bytes.length);
        wr.writeBytes(bytes);
        return;
    }
    const prim = $463f724b64570f1c$var$primTags[e.prim];
    if (prim === undefined) throw new TypeError(`Can't encode primary: ${e.prim}`);
    const tag = (((_a = e.args) === null || _a === void 0 ? void 0 : _a.length) || 0) < 3 ? $463f724b64570f1c$var$Tag.Prim0 + (((_b = e.args) === null || _b === void 0 ? void 0 : _b.length) || 0) * 2 + (e.annots === undefined || e.annots.length === 0 ? 0 : 1) : $463f724b64570f1c$var$Tag.Prim;
    wr.writeUint8(tag);
    wr.writeUint8(prim);
    if (e.args !== undefined) {
        if (e.args.length < 3) for (const v of e.args){
            const a = args.next();
            if (a.done) throw new Error('REPORT ME: iterator is done');
            $463f724b64570f1c$var$writeExpr(v, wr, a.value);
        }
        else {
            const w = new $463f724b64570f1c$var$Writer();
            for (const v of e.args){
                const a = args.next();
                if (a.done) throw new Error('REPORT ME: iterator is done');
                $463f724b64570f1c$var$writeExpr(v, w, a.value);
            }
            wr.writeUint32(w.length);
            wr.writeBytes(w.buffer);
        }
    }
    if (e.annots !== undefined && e.annots.length !== 0) {
        const enc = new TextEncoder();
        const bytes = enc.encode(e.annots.join(' '));
        wr.writeUint32(bytes.length);
        wr.writeBytes(Array.from(bytes));
    } else if (e.args !== undefined && e.args.length >= 3) wr.writeUint32(0);
}
function $463f724b64570f1c$var$readExpr(rd, tf) {
    function* passThrough() {
        while(true)yield $463f724b64570f1c$var$readPassThrough;
    }
    const [args, tr] = tf;
    const tag = rd.readUint8();
    switch(tag){
        case $463f724b64570f1c$var$Tag.Int:
            {
                const buf = [];
                let byte;
                do {
                    byte = rd.readInt8();
                    buf.push(byte);
                }while ((byte & 0x80) !== 0);
                let val = BigInt(0);
                let sign = false;
                for(let i = buf.length - 1; i >= 0; i--){
                    const bits = i === 0 ? BigInt(6) : BigInt(7);
                    const byte = BigInt(buf[i]);
                    val <<= bits;
                    val |= byte & (BigInt(1) << bits) - BigInt(1);
                    if (i === 0) sign = !!(byte & BigInt(0x40));
                }
                if (sign) val = -val;
                return tr({
                    int: String(val)
                });
            }
        case $463f724b64570f1c$var$Tag.String:
            {
                const length = rd.readUint32();
                const bytes = rd.readBytes(length);
                const dec = new TextDecoder();
                return tr({
                    string: dec.decode(new Uint8Array(bytes))
                });
            }
        case $463f724b64570f1c$var$Tag.Bytes:
            {
                const length = rd.readUint32();
                const bytes = rd.readBytes(length);
                const hex = $463f724b64570f1c$var$hexBytes(Array.from(bytes));
                return tr({
                    bytes: hex
                });
            }
        case $463f724b64570f1c$var$Tag.Sequence:
            {
                const length = rd.readUint32();
                let res = [];
                let savedrd = rd.copy();
                // make two passes
                let it = passThrough();
                for(let n = 0; n < 2; n++){
                    const r = savedrd.reader(length);
                    res = [];
                    while(r.length > 0){
                        const a = it.next();
                        if (a.done) throw new Error('REPORT ME: iterator is done');
                        res.push($463f724b64570f1c$var$readExpr(r, a.value));
                    }
                    // make a second pass with injected side effects
                    it = args(res);
                    savedrd = rd;
                }
                return tr(res);
            }
        default:
            {
                if (tag > 9) throw new Error(`Unknown tag: ${tag}`);
                const p = rd.readUint8();
                if (p >= $463f724b64570f1c$var$primitives.length) throw new Error(`Unknown primitive tag: ${p}`);
                const prim = $463f724b64570f1c$var$primitives[p];
                const argn = tag - 3 >> 1;
                let res = {
                    prim: prim
                };
                // make two passes
                let it = passThrough();
                let savedrd = rd.copy();
                for(let n = 0; n < 2; n++){
                    res = {
                        prim: prim
                    };
                    if (argn < 3) for(let i = 0; i < argn; i++){
                        const a = it.next();
                        if (a.done) throw new Error('REPORT ME: iterator is done');
                        res.args = res.args || [];
                        res.args.push($463f724b64570f1c$var$readExpr(savedrd, a.value));
                    }
                    else {
                        res.args = res.args || [];
                        const length = savedrd.readUint32();
                        const r = savedrd.reader(length);
                        while(r.length > 0){
                            const a = it.next();
                            if (a.done) throw new Error('REPORT ME: iterator is done');
                            res.args.push($463f724b64570f1c$var$readExpr(r, a.value));
                        }
                    }
                    // make a second pass with injected side effects
                    it = args(res);
                    savedrd = rd;
                }
                if ((tag - 3 & 1) === 1 || argn === 3) {
                    // read annotations
                    const length = rd.readUint32();
                    if (length !== 0) {
                        const bytes = rd.readBytes(length);
                        const dec = new TextDecoder();
                        res.annots = dec.decode(new Uint8Array(bytes)).split(' ');
                    }
                }
                return tr(res);
            }
    }
}
const $463f724b64570f1c$var$isOrData = (e)=>'prim' in e && (e.prim === 'Left' || e.prim === 'Right');
const $463f724b64570f1c$var$isOptionData = (e)=>'prim' in e && (e.prim === 'Some' || e.prim === 'None');
const $463f724b64570f1c$var$getWriteTransformFunc = (t)=>{
    if ($463f724b64570f1c$var$isPairType(t)) return (d)=>{
        if (!$463f724b64570f1c$var$isPairData(d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `pair expected: ${JSON.stringify(d)}`, d);
        $463f724b64570f1c$export$5cb2cbfd0cef2950(d);
        // combs aren't used in pack format
        const tc = $463f724b64570f1c$var$unpackComb('pair', t);
        const dc = $463f724b64570f1c$var$unpackComb('Pair', d);
        return [
            dc,
            function*() {
                for (const a of tc.args)yield $463f724b64570f1c$var$getWriteTransformFunc(a);
            }()
        ];
    };
    switch(t.prim){
        case 'or':
            return (d)=>{
                if (!$463f724b64570f1c$var$isOrData(d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `or expected: ${JSON.stringify(d)}`, d);
                return [
                    d,
                    function*() {
                        yield $463f724b64570f1c$var$getWriteTransformFunc(t.args[d.prim === 'Left' ? 0 : 1]);
                    }()
                ];
            };
        case 'option':
            return (d)=>{
                if (!$463f724b64570f1c$var$isOptionData(d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `option expected: ${JSON.stringify(d)}`, d);
                return [
                    d,
                    function*() {
                        const dd = d;
                        // TODO: refactor and remove ts-ignore
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        if (dd.prim === 'Some') yield $463f724b64570f1c$var$getWriteTransformFunc(t.args[0]);
                    }()
                ];
            };
        case 'list':
        case 'set':
            return (d)=>{
                if (!Array.isArray(d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `${t.prim} expected: ${JSON.stringify(d)}`, d);
                return [
                    d,
                    function*() {
                        for (const _v of d)yield $463f724b64570f1c$var$getWriteTransformFunc(t.args[0]);
                    }()
                ];
            };
        case 'map':
            return (d)=>{
                if (!Array.isArray(d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `map expected: ${JSON.stringify(d)}`, d);
                return [
                    d,
                    function*() {
                        for (const _elt of d)yield (elt)=>{
                            if (!('prim' in elt) || elt.prim !== 'Elt') throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `map element expected: ${JSON.stringify(elt)}`, elt);
                            return [
                                elt,
                                function*() {
                                    for (const a of t.args)yield $463f724b64570f1c$var$getWriteTransformFunc(a);
                                }()
                            ];
                        };
                    }()
                ];
            };
        case 'chain_id':
            return (d)=>{
                if (!('bytes' in d) && !('string' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `chain id expected: ${JSON.stringify(d)}`, d);
                let bytes;
                if ('string' in d) {
                    const id = $463f724b64570f1c$var$checkDecodeTezosID(d.string, 'ChainID');
                    if (id === null) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `chain id base58 expected: ${d.string}`, d);
                    bytes = {
                        bytes: $463f724b64570f1c$var$hexBytes(id[1])
                    };
                } else bytes = d;
                return [
                    bytes,
                    [][Symbol.iterator]()
                ];
            };
        case 'signature':
            return (d)=>{
                if (!('bytes' in d) && !('string' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `signature expected: ${JSON.stringify(d)}`, d);
                let bytes;
                if ('string' in d) {
                    const sig = $463f724b64570f1c$var$checkDecodeTezosID(d.string, 'ED25519Signature', 'SECP256K1Signature', 'P256Signature', 'GenericSignature');
                    if (sig === null) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `signature base58 expected: ${d.string}`, d);
                    bytes = {
                        bytes: $463f724b64570f1c$var$hexBytes(sig[1])
                    };
                } else bytes = d;
                return [
                    bytes,
                    [][Symbol.iterator]()
                ];
            };
        case 'key_hash':
            return (d)=>{
                if (!('bytes' in d) && !('string' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `key hash expected: ${JSON.stringify(d)}`, d);
                let bytes;
                if ('string' in d) {
                    const pkh = $463f724b64570f1c$var$checkDecodeTezosID(d.string, 'ED25519PublicKeyHash', 'SECP256K1PublicKeyHash', 'P256PublicKeyHash');
                    if (pkh === null) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `key hash base58 expected: ${d.string}`, d);
                    const w = new $463f724b64570f1c$var$Writer();
                    $463f724b64570f1c$var$writePublicKeyHash({
                        type: pkh[0],
                        hash: pkh[1]
                    }, w);
                    bytes = {
                        bytes: $463f724b64570f1c$var$hexBytes(w.buffer)
                    };
                } else bytes = d;
                return [
                    bytes,
                    [][Symbol.iterator]()
                ];
            };
        case 'key':
            return (d)=>{
                if (!('bytes' in d) && !('string' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `public key expected: ${JSON.stringify(d)}`, d);
                let bytes;
                if ('string' in d) {
                    const key = $463f724b64570f1c$var$checkDecodeTezosID(d.string, 'ED25519PublicKey', 'SECP256K1PublicKey', 'P256PublicKey');
                    if (key === null) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `public key base58 expected: ${d.string}`, d);
                    const w = new $463f724b64570f1c$var$Writer();
                    $463f724b64570f1c$var$writePublicKey({
                        type: key[0],
                        publicKey: key[1]
                    }, w);
                    bytes = {
                        bytes: $463f724b64570f1c$var$hexBytes(w.buffer)
                    };
                } else bytes = d;
                return [
                    bytes,
                    [][Symbol.iterator]()
                ];
            };
        case 'address':
            return (d)=>{
                if (!('bytes' in d) && !('string' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `address expected: ${JSON.stringify(d)}`, d);
                let bytes;
                if ('string' in d) {
                    const s = d.string.split('%');
                    const address = $463f724b64570f1c$var$checkDecodeTezosID(s[0], 'ED25519PublicKeyHash', 'SECP256K1PublicKeyHash', 'P256PublicKeyHash', 'ContractHash');
                    if (address === null) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `address base58 expected: ${d.string}`, d);
                    const w = new $463f724b64570f1c$var$Writer();
                    $463f724b64570f1c$var$writeAddress({
                        type: address[0],
                        hash: address[1],
                        entryPoint: s.length > 1 ? s[1] : undefined
                    }, w);
                    bytes = {
                        bytes: $463f724b64570f1c$var$hexBytes(w.buffer)
                    };
                } else bytes = d;
                return [
                    bytes,
                    [][Symbol.iterator]()
                ];
            };
        case 'timestamp':
            return (d)=>{
                if (!('string' in d) && !('int' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `timestamp expected: ${JSON.stringify(d)}`, d);
                let int;
                if ('string' in d) {
                    const p = $463f724b64570f1c$var$parseDate(d);
                    if (p === null) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `can't parse date: ${d.string}`, d);
                    int = {
                        int: String(Math.floor(p.getTime() / 1000))
                    };
                } else int = d;
                return [
                    int,
                    [][Symbol.iterator]()
                ];
            };
        default:
            return $463f724b64570f1c$var$writePassThrough;
    }
};
const $463f724b64570f1c$var$isPushInstruction = (e)=>'prim' in e && e.prim === 'PUSH';
const $463f724b64570f1c$var$writePassThrough = (e)=>{
    if ($463f724b64570f1c$var$isPushInstruction(e)) {
        $463f724b64570f1c$export$57f49bebc69f7bbc(e);
        // capture inlined type definition
        return [
            e,
            function*() {
                yield $463f724b64570f1c$var$writePassThrough;
                yield $463f724b64570f1c$var$getWriteTransformFunc(e.args[0]);
            }()
        ];
    }
    return [
        e,
        function*() {
            while(true)yield $463f724b64570f1c$var$writePassThrough;
        }()
    ];
};
/**
 * Serializes any value of packable type to its optimized binary representation
 * identical to the one used by PACK and UNPACK Michelson instructions.
 * Without a type definition (not recommended) the data will be encoded as a binary form of a generic Michelson expression.
 * Type definition allows some types like `timestamp` and `address` and other base58 representable types to be encoded to
 * corresponding optimized binary forms borrowed from the Tezos protocol
 *
 * ```typescript
 * const data: MichelsonData = {
 *     string: "KT1RvkwF4F7pz1gCoxkyZrG1RkrxQy3gmFTv%foo"
 * };
 *
 * const typ: MichelsonType = {
 *     prim: "address"
 * };
 *
 * const packed = packData(data, typ);
 *
 * // 050a0000001901be41ee922ddd2cf33201e49d32da0afec571dce300666f6f
 * ```
 *
 * Without a type definition the base58 encoded address will be treated as a string
 * ```typescript
 * const data: MichelsonData = {
 *     string: "KT1RvkwF4F7pz1gCoxkyZrG1RkrxQy3gmFTv%foo"
 * };
 *
 * const packed = packData(data);
 *
 * // 0501000000284b543152766b7746344637707a3167436f786b795a724731526b7278517933676d46547625666f6f
 * ```
 * @param d Data object
 * @param t Optional type definition
 * @returns Binary representation as numeric array
 */ function $463f724b64570f1c$export$e29f66ea0caa0188(d, t) {
    const w = new $463f724b64570f1c$var$Writer();
    w.writeUint8(5);
    $463f724b64570f1c$var$writeExpr(d, w, t !== undefined ? $463f724b64570f1c$var$getWriteTransformFunc(t) : $463f724b64570f1c$var$writePassThrough);
    return w.buffer;
}
/**
 * Serializes any value of packable type to its optimized binary representation
 * identical to the one used by PACK and UNPACK Michelson instructions.
 * Same as {@link packData} but returns a `bytes` Michelson data literal instead of an array
 *
 * ```typescript
 * const data: MichelsonData = {
 *     string: "2019-09-26T10:59:51Z"
 * };
 *
 * const typ: MichelsonType = {
 *     prim: "timestamp"
 * };
 *
 * const packed = packDataBytes(data, typ);
 *
 * // { bytes: "0500a7e8e4d80b" }
 * ```
 * @param d Data object
 * @param t Optional type definition
 * @returns Binary representation as a bytes literal
 */ function $463f724b64570f1c$export$ec5c026f9926015c(d, t) {
    return {
        bytes: $463f724b64570f1c$var$hexBytes($463f724b64570f1c$export$e29f66ea0caa0188(d, t))
    };
}
const $463f724b64570f1c$var$getReadTransformFuncs = (t)=>{
    if ($463f724b64570f1c$var$isPairType(t)) return [
        (d)=>{
            if (!$463f724b64570f1c$var$isPairData(d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `pair expected: ${JSON.stringify(d)}`, d);
            const tc = $463f724b64570f1c$var$unpackComb('pair', t);
            return function*() {
                for (const a of tc.args)yield $463f724b64570f1c$var$getReadTransformFuncs(a);
            }();
        },
        (d)=>d
    ];
    switch(t.prim){
        case 'or':
            return [
                (d)=>{
                    if (!$463f724b64570f1c$var$isOrData(d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `or expected: ${JSON.stringify(d)}`, d);
                    return function*() {
                        yield $463f724b64570f1c$var$getReadTransformFuncs(t.args[d.prim === 'Left' ? 0 : 1]);
                    }();
                },
                (d)=>d
            ];
        case 'option':
            return [
                (d)=>{
                    if (!$463f724b64570f1c$var$isOptionData(d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `option expected: ${JSON.stringify(d)}`, d);
                    return function*() {
                        // TODO: refactor and remove ts-ignore
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        if (d.prim === 'Some') yield $463f724b64570f1c$var$getReadTransformFuncs(t.args[0]);
                    }();
                },
                (d)=>d
            ];
        case 'list':
        case 'set':
            return [
                (d)=>{
                    if (!Array.isArray(d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `${t.prim} expected: ${JSON.stringify(d)}`, d);
                    return function*() {
                        while(true)yield $463f724b64570f1c$var$getReadTransformFuncs(t.args[0]);
                    }();
                },
                (d)=>d
            ];
        case 'map':
            return [
                (d)=>{
                    if (!Array.isArray(d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `map expected: ${JSON.stringify(d)}`, d);
                    return function*() {
                        while(true)yield [
                            (elt)=>{
                                if (!('prim' in elt) || elt.prim !== 'Elt') throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `map element expected: ${JSON.stringify(elt)}`, elt);
                                return function*() {
                                    for (const a of t.args)yield $463f724b64570f1c$var$getReadTransformFuncs(a);
                                }();
                            },
                            (elt)=>elt
                        ];
                    }();
                },
                (d)=>d
            ];
        case 'chain_id':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('bytes' in d) && !('string' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `chain id expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const bytes = $463f724b64570f1c$var$parseBytes(d.bytes);
                    if (bytes === null) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `can't parse bytes: ${d.bytes}`, d);
                    return {
                        string: $463f724b64570f1c$var$encodeTezosID('ChainID', bytes)
                    };
                }
            ];
        case 'signature':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('bytes' in d) && !('string' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `signature expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const bytes = $463f724b64570f1c$var$parseBytes(d.bytes);
                    if (bytes === null) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `can't parse bytes: ${d.bytes}`, d);
                    return {
                        string: $463f724b64570f1c$var$encodeTezosID('GenericSignature', bytes)
                    };
                }
            ];
        case 'key_hash':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('bytes' in d) && !('string' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `key hash expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const bytes = $463f724b64570f1c$var$parseBytes(d.bytes);
                    if (bytes === null) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `can't parse bytes: ${d.bytes}`, d);
                    const rd = new $463f724b64570f1c$var$Reader(new Uint8Array(bytes));
                    const addr = $463f724b64570f1c$var$readPublicKeyHash(rd);
                    return {
                        string: $463f724b64570f1c$var$encodeTezosID(addr.type, addr.hash) + (addr.entryPoint ? '%' + addr.entryPoint : '')
                    };
                }
            ];
        case 'key':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('bytes' in d) && !('string' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `public key expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const bytes = $463f724b64570f1c$var$parseBytes(d.bytes);
                    if (bytes === null) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `can't parse bytes: ${d.bytes}`, d);
                    const rd = new $463f724b64570f1c$var$Reader(new Uint8Array(bytes));
                    const pk = $463f724b64570f1c$var$readPublicKey(rd);
                    return {
                        string: $463f724b64570f1c$var$encodeTezosID(pk.type, pk.publicKey)
                    };
                }
            ];
        case 'address':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('bytes' in d) && !('string' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `address expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const bytes = $463f724b64570f1c$var$parseBytes(d.bytes);
                    if (bytes === null) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `can't parse bytes: ${d.bytes}`, d);
                    const rd = new $463f724b64570f1c$var$Reader(new Uint8Array(bytes));
                    const addr = $463f724b64570f1c$var$readAddress(rd);
                    return {
                        string: $463f724b64570f1c$var$encodeTezosID(addr.type, addr.hash) + (addr.entryPoint ? '%' + addr.entryPoint : '')
                    };
                }
            ];
        case 'timestamp':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('int' in d) && !('string' in d)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `address expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const date = new Date(parseInt(d.int, 10) * 1000);
                    return {
                        string: date.toISOString().slice(0, 19) + 'Z'
                    };
                }
            ];
        default:
            return $463f724b64570f1c$var$readPassThrough;
    }
};
const $463f724b64570f1c$var$readPassThrough = [
    (e)=>{
        if ($463f724b64570f1c$var$isPushInstruction(e)) {
            $463f724b64570f1c$export$57f49bebc69f7bbc(e);
            // capture inlined type definition
            return function*() {
                yield $463f724b64570f1c$var$readPassThrough;
                yield $463f724b64570f1c$var$getReadTransformFuncs(e.args[0]);
            }();
        }
        return function*() {
            while(true)yield $463f724b64570f1c$var$readPassThrough;
        }();
    },
    (e)=>e
];
/**
 * Deserialize a byte array into the corresponding Michelson value.
 * Without a type definition (not recommended) the binary data will be treated as a binary form of a generic Michelson expression and returned as is.
 * Type definition allows some types like `timestamp` and `address` and other types usually encoded in optimized binary forms to be transformed
 * back to their string representations like base58 and ISO timestamps.
 *
 * ```typescript
 * const src = [0x05, 0x00, 0xa7, 0xe8, 0xe4, 0xd8, 0x0b];
 *
 * const typ: MichelsonType = {
 *     prim: "timestamp"
 * };
 *
 * const data = unpackData(src, typ);
 *
 * // { string: "2019-09-26T10:59:51Z" }
 * ```
 *
 * Same binary data without a type definition
 * ```typescript
 * const src = [0x05, 0x00, 0xa7, 0xe8, 0xe4, 0xd8, 0x0b];
 *
 * const data = unpackData(src);
 *
 * // { int: "1569495591" }
 * ```
 * @param src Byte array
 * @param t Optional type definition
 * @returns Deserialized data
 */ function $463f724b64570f1c$export$ce0ea93f941cfe05(src, t) {
    const r = new $463f724b64570f1c$var$Reader(src);
    if (r.readUint8() !== 5) throw new Error('incorrect packed data magic number');
    const ex = $463f724b64570f1c$var$readExpr(r, t !== undefined ? $463f724b64570f1c$var$getReadTransformFuncs(t) : $463f724b64570f1c$var$readPassThrough);
    if ($463f724b64570f1c$export$3cc4ed4ae67ac731(ex)) return ex;
    throw new Error(); // never
}
/**
 * Deserialize a byte array into the corresponding Michelson value.
 * Same as {@link unpackData} but takes a `bytes` Michelson data literal instead of an array
 *
 * ```typescript
 * const src = { bytes: "0500a7e8e4d80b" };
 *
 * const typ: MichelsonType = {
 *     prim: "timestamp"
 * };
 *
 * const data = unpackDataBytes(src, typ);
 *
 * // { string: "2019-09-26T10:59:51Z" }
 * ```
 * @param src Bytes object
 * @param t Optional type definition
 * @returns Deserialized data
 */ function $463f724b64570f1c$export$19053657e689bb0(src, t) {
    const bytes = $463f724b64570f1c$var$parseBytes(src.bytes);
    if (bytes === null) throw new Error(`can't parse bytes: "${src.bytes}"`);
    return $463f724b64570f1c$export$ce0ea93f941cfe05(bytes, t);
}
// helper functions also used by validator
function $463f724b64570f1c$export$d476e2924803ffc4(b) {
    const bytes = $463f724b64570f1c$var$parseBytes(b.bytes);
    if (bytes === null) throw new Error(`can't parse bytes: "${b.bytes}"`);
    const rd = new $463f724b64570f1c$var$Reader(new Uint8Array(bytes));
    return $463f724b64570f1c$var$readAddress(rd);
}
function $463f724b64570f1c$export$39bdd4124a6764aa(b) {
    const bytes = $463f724b64570f1c$var$parseBytes(b.bytes);
    if (bytes === null) throw new Error(`can't parse bytes: "${b.bytes}"`);
    const rd = new $463f724b64570f1c$var$Reader(new Uint8Array(bytes));
    return $463f724b64570f1c$var$readPublicKeyHash(rd);
}
function $463f724b64570f1c$export$28ad8e7080e9bd54(b) {
    const bytes = $463f724b64570f1c$var$parseBytes(b.bytes);
    if (bytes === null) throw new Error(`can't parse bytes: "${b.bytes}"`);
    const rd = new $463f724b64570f1c$var$Reader(new Uint8Array(bytes));
    return $463f724b64570f1c$var$readPublicKey(rd);
}
class $463f724b64570f1c$export$4077f6a2bcdec605 extends $463f724b64570f1c$export$61ae7f08643aa181 {
    /**
     * @param val Value of a type node caused the error
     * @param stackState Current stack state
     * @param message An error message
     */ constructor(val, stackState, message){
        super(val, message);
        this.val = val;
        this.stackState = stackState;
        this.message = message;
        this.name = 'MichelsonInstructionError';
    }
}
// 'sequence as a pair' edo syntax helpers
function $463f724b64570f1c$var$typeID(t) {
    return Array.isArray(t) ? 'pair' : t.prim;
}
function $463f724b64570f1c$var$typeArgs(t) {
    return 'prim' in t ? t.args : t;
}
function $463f724b64570f1c$var$assertScalarTypesEqual(a, b, field = false) {
    if ($463f724b64570f1c$var$typeID(a) !== $463f724b64570f1c$var$typeID(b)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(a, `types mismatch: ${$463f724b64570f1c$var$typeID(a)} != ${$463f724b64570f1c$var$typeID(b)}`, undefined);
    const ann = [
        $463f724b64570f1c$var$unpackAnnotations(a),
        $463f724b64570f1c$var$unpackAnnotations(b)
    ];
    if (ann[0].t && ann[1].t && ann[0].t[0] !== ann[1].t[0]) throw new $463f724b64570f1c$export$c9afdd965e51c08a(a, `${$463f724b64570f1c$var$typeID(a)}: type names mismatch: ${ann[0].t[0]} != ${ann[1].t[0]}`, undefined);
    if (field && ann[0].f && ann[1].f && ann[0].f[0] !== ann[1].f[0]) throw new $463f724b64570f1c$export$c9afdd965e51c08a(a, `${$463f724b64570f1c$var$typeID(a)}: field names mismatch: ${ann[0].f[0]} != ${ann[1].f}`, undefined);
    if ($463f724b64570f1c$var$isPairType(a)) {
        const aArgs = $463f724b64570f1c$var$unpackComb('pair', a);
        const bArgs = $463f724b64570f1c$var$unpackComb('pair', b);
        $463f724b64570f1c$var$assertScalarTypesEqual(aArgs.args[0], bArgs.args[0], true);
        $463f724b64570f1c$var$assertScalarTypesEqual(aArgs.args[1], bArgs.args[1], true);
        return;
    }
    switch(a.prim){
        case 'option':
        case 'list':
        case 'contract':
        case 'set':
        case 'ticket':
            $463f724b64570f1c$var$assertScalarTypesEqual(a.args[0], b.args[0]);
            break;
        case 'or':
            $463f724b64570f1c$var$assertScalarTypesEqual(a.args[0], b.args[0], true);
            $463f724b64570f1c$var$assertScalarTypesEqual(a.args[1], b.args[1], true);
            break;
        case 'lambda':
        case 'map':
        case 'big_map':
            $463f724b64570f1c$var$assertScalarTypesEqual(a.args[0], b.args[0]);
            $463f724b64570f1c$var$assertScalarTypesEqual(a.args[1], b.args[1]);
            break;
        case 'sapling_state':
        case 'sapling_transaction':
            if (parseInt(a.args[0].int, 10) !== parseInt(b.args[0].int, 10)) throw new $463f724b64570f1c$export$c9afdd965e51c08a(a, `${$463f724b64570f1c$var$typeID(a)}: type argument mismatch: ${a.args[0].int} != ${b.args[0].int}`, undefined);
    }
}
function $463f724b64570f1c$var$assertStacksEqual(a, b) {
    if (a.length !== b.length) throw new $463f724b64570f1c$export$c9afdd965e51c08a(a, `stack length mismatch: ${a.length} != ${b.length}`, undefined);
    for(let i = 0; i < a.length; i++)$463f724b64570f1c$var$assertScalarTypesEqual(a[i], b[i]);
}
function $463f724b64570f1c$export$1244433858b68826(t, field = false) {
    var _a, _b, _c;
    if (!Array.isArray(t)) {
        const ann = $463f724b64570f1c$var$unpackAnnotations(t);
        if ((((_a = ann.t) === null || _a === void 0 ? void 0 : _a.length) || 0) > 1) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `${t.prim}: at most one type annotation allowed: ${t.annots}`, undefined);
        if (field) {
            if ((((_b = ann.f) === null || _b === void 0 ? void 0 : _b.length) || 0) > 1) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `${t.prim}: at most one field annotation allowed: ${t.annots}`, undefined);
        } else {
            if ((((_c = ann.f) === null || _c === void 0 ? void 0 : _c.length) || 0) > 0) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `${t.prim}: field annotations aren't allowed: ${t.annots}`, undefined);
        }
    }
    if ($463f724b64570f1c$var$isPairType(t)) {
        const args = $463f724b64570f1c$var$typeArgs(t);
        for (const a of args)$463f724b64570f1c$export$1244433858b68826(a, true);
        return;
    }
    switch(t.prim){
        case 'option':
        case 'list':
        case 'contract':
        case 'set':
            $463f724b64570f1c$export$1244433858b68826(t.args[0]);
            break;
        case 'or':
            for (const a of t.args)$463f724b64570f1c$export$1244433858b68826(a, true);
            break;
        case 'lambda':
        case 'map':
        case 'big_map':
            $463f724b64570f1c$export$1244433858b68826(t.args[0]);
            $463f724b64570f1c$export$1244433858b68826(t.args[1]);
    }
}
// Simplified version of assertMichelsonInstruction() for previously validated data
function $463f724b64570f1c$var$isFunction(d) {
    if (!Array.isArray(d)) return false;
    for (const v of d){
        if (!(Array.isArray(v) && $463f724b64570f1c$var$isFunction(v) || 'prim' in v && $463f724b64570f1c$export$517b0c6d75337fc8(v))) return false;
    }
    return true;
}
function $463f724b64570f1c$var$assertDataValidInternal(d, t, ctx) {
    if ($463f724b64570f1c$var$isPairType(t)) {
        if ($463f724b64570f1c$var$isPairData(d)) {
            $463f724b64570f1c$export$5cb2cbfd0cef2950(d);
            const dc = $463f724b64570f1c$var$unpackComb('Pair', d);
            const tc = $463f724b64570f1c$var$unpackComb('pair', t);
            $463f724b64570f1c$var$assertDataValidInternal(dc.args[0], tc.args[0], ctx);
            $463f724b64570f1c$var$assertDataValidInternal(dc.args[1], tc.args[1], ctx);
            return;
        }
        throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `pair expected: ${JSON.stringify(d)}`, d);
    }
    switch(t.prim){
        // Atomic literals
        case 'int':
            if ('int' in d && $463f724b64570f1c$var$isDecimal(d.int)) return;
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `integer value expected: ${JSON.stringify(d)}`, d);
        case 'nat':
        case 'mutez':
            if ('int' in d && $463f724b64570f1c$var$isNatural(d.int)) return;
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `natural value expected: ${JSON.stringify(d)}`, d);
        case 'string':
            if ('string' in d) return;
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `string value expected: ${JSON.stringify(d)}`, d);
        case 'bytes':
        case 'bls12_381_g1':
        case 'bls12_381_g2':
            if ('bytes' in d && $463f724b64570f1c$var$parseBytes(d.bytes) !== null) return;
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `bytes value expected: ${JSON.stringify(d)}`, d);
        case 'bool':
            if ('prim' in d && (d.prim === 'True' || d.prim === 'False')) return;
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `boolean value expected: ${JSON.stringify(d)}`, d);
        case 'key_hash':
            if ('string' in d && $463f724b64570f1c$var$checkDecodeTezosID(d.string, 'ED25519PublicKeyHash', 'SECP256K1PublicKeyHash', 'P256PublicKeyHash') !== null) return;
            else if ('bytes' in d) try {
                $463f724b64570f1c$export$39bdd4124a6764aa(d);
                return;
            } catch (err) {
            // ignore message
            }
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `key hash expected: ${JSON.stringify(d)}`, d);
        case 'timestamp':
            if (('string' in d || 'int' in d) && $463f724b64570f1c$var$parseDate(d) !== null) return;
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `timestamp expected: ${JSON.stringify(d)}`, d);
        case 'address':
            if ('string' in d) {
                let address = d.string;
                const ep = d.string.indexOf('%');
                if (ep >= 0) // trim entry point
                address = d.string.slice(0, ep);
                if ($463f724b64570f1c$var$checkDecodeTezosID(address, 'ED25519PublicKeyHash', 'SECP256K1PublicKeyHash', 'P256PublicKeyHash', 'ContractHash', 'RollupAddress') !== null) return;
            } else if ('bytes' in d) try {
                $463f724b64570f1c$export$d476e2924803ffc4(d);
                return;
            } catch (err) {
            // ignore message
            }
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `address expected: ${JSON.stringify(d)}`, d);
        case 'key':
            if ('string' in d && $463f724b64570f1c$var$checkDecodeTezosID(d.string, 'ED25519PublicKey', 'SECP256K1PublicKey', 'P256PublicKey') !== null) return;
            else if ('bytes' in d) try {
                $463f724b64570f1c$export$28ad8e7080e9bd54(d);
                return;
            } catch (err) {
            // ignore message
            }
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `public key expected: ${JSON.stringify(d)}`, d);
        case 'unit':
            if ('prim' in d && d.prim === 'Unit') return;
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `unit value expected: ${JSON.stringify(d)}`, d);
        case 'signature':
            if ('bytes' in d || 'string' in d && $463f724b64570f1c$var$checkDecodeTezosID(d.string, 'ED25519Signature', 'SECP256K1Signature', 'P256Signature', 'GenericSignature') !== null) return;
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `signature expected: ${JSON.stringify(d)}`, d);
        case 'chain_id':
            if ('bytes' in d || 'string' in d) {
                const x = 'string' in d ? $463f724b64570f1c$var$decodeBase58Check(d.string) : $463f724b64570f1c$var$parseBytes(d.bytes);
                if (x !== null) return;
            }
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `chain id expected: ${JSON.stringify(d)}`, d);
        // Complex types
        case 'option':
            if ('prim' in d) {
                if (d.prim === 'None') return;
                else if (d.prim === 'Some') {
                    $463f724b64570f1c$var$assertDataValidInternal(d.args[0], t.args[0], ctx);
                    return;
                }
            }
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `option expected: ${JSON.stringify(d)}`, d);
        case 'list':
        case 'set':
            if ($463f724b64570f1c$export$5cb2cbfd0cef2950(d)) {
                //let prev: MichelsonData | undefined;
                for (const v of d)$463f724b64570f1c$var$assertDataValidInternal(v, t.args[0], ctx);
                return;
            }
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `${t.prim} expected: ${JSON.stringify(d)}`, d);
        case 'or':
            if ('prim' in d) {
                if (d.prim === 'Left') {
                    $463f724b64570f1c$var$assertDataValidInternal(d.args[0], t.args[0], ctx);
                    return;
                } else if (d.prim === 'Right') {
                    $463f724b64570f1c$var$assertDataValidInternal(d.args[0], t.args[1], ctx);
                    return;
                }
            }
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `union (or) expected: ${JSON.stringify(d)}`, d);
        case 'lambda':
            if ($463f724b64570f1c$var$isFunction(d)) {
                const ret = $463f724b64570f1c$var$functionTypeInternal(d, [
                    t.args[0]
                ], ctx);
                if ('failed' in ret) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `function is failed with error type: ${ret.failed}`, d);
                if (ret.length !== 1) throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, 'function must return a value', d);
                $463f724b64570f1c$var$assertScalarTypesEqual(t.args[1], ret[0]);
                return;
            }
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `function expected: ${JSON.stringify(d)}`, d);
        case 'map':
        case 'big_map':
            if (Array.isArray(d)) {
                //let prev: MichelsonMapElt | undefined;
                for (const v of d){
                    if (!('prim' in v) || v.prim !== 'Elt') throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `map elements expected: ${JSON.stringify(d)}`, d);
                    $463f724b64570f1c$var$assertDataValidInternal(v.args[0], t.args[0], ctx);
                    $463f724b64570f1c$var$assertDataValidInternal(v.args[1], t.args[1], ctx);
                }
                return;
            }
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `${t.prim} expected: ${JSON.stringify(d)}`, d);
        case 'bls12_381_fr':
            if ('int' in d && $463f724b64570f1c$var$isDecimal(d.int) || 'bytes' in d && $463f724b64570f1c$var$parseBytes(d.bytes) !== null) return;
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `BLS12-381 element expected: ${JSON.stringify(d)}`, d);
        case 'sapling_state':
            if (Array.isArray(d)) return;
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `sapling state expected: ${JSON.stringify(d)}`, d);
        case 'ticket':
            $463f724b64570f1c$var$assertDataValidInternal(d, {
                prim: 'pair',
                args: [
                    {
                        prim: 'address'
                    },
                    t.args[0],
                    {
                        prim: 'nat'
                    }
                ]
            }, ctx);
            return;
        default:
            throw new $463f724b64570f1c$export$c9afdd965e51c08a(t, `type ${$463f724b64570f1c$var$typeID(t)} don't have Michelson literal representation`, d);
    }
}
function $463f724b64570f1c$var$instructionListType(inst, stack, ctx) {
    let ret = stack;
    let s = stack;
    let i = 0;
    for (const op of inst){
        const ft = $463f724b64570f1c$var$functionTypeInternal(op, s, ctx);
        ret = ft;
        if ('failed' in ft) break;
        s = ft;
        i++;
    }
    if ('failed' in ret && ret.level == 0 && (!('prim' in ret.failed) || ret.failed.prim !== 'never') && i !== inst.length - 1) throw new $463f724b64570f1c$export$4077f6a2bcdec605(inst, ret, 'FAIL must appear in a tail position');
    if ((ctx === null || ctx === void 0 ? void 0 : ctx.traceCallback) !== undefined) {
        const trace = {
            op: inst,
            in: stack,
            out: ret
        };
        ctx.traceCallback(trace);
    }
    return 'failed' in ret ? {
        failed: ret.failed,
        level: ret.level + 1
    } : ret;
}
function $463f724b64570f1c$var$functionTypeInternal(inst, stack, ctx) {
    const proto = (ctx === null || ctx === void 0 ? void 0 : ctx.protocol) || $463f724b64570f1c$export$6af6ef9b852714c9;
    if (Array.isArray(inst)) return $463f724b64570f1c$var$instructionListType(inst, stack, ctx);
    const instruction = inst; // Make it const for type guarding
    // make sure the stack has enough number of arguments of specific types
    function args(n, ...typeIds) {
        if (stack.length < typeIds.length + n) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: stack must have at least ${typeIds.length} element(s)`);
        let i = n;
        for (const ids of typeIds){
            if (ids !== null && ids.length !== 0) {
                let ii = 0;
                while(ii < ids.length && ids[ii] !== $463f724b64570f1c$var$typeID(stack[i]))ii++;
                if (ii === ids.length) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: stack type mismatch: [${i}] expected to be ${ids}, got ${$463f724b64570f1c$var$typeID(stack[i])} instead`);
            }
            i++;
        }
        return stack.slice(n, typeIds.length + n);
    }
    function rethrow(fn) {
        return (...args)=>{
            try {
                return fn(...args);
            } catch (err) {
                if (err instanceof $463f724b64570f1c$export$61ae7f08643aa181) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, err.message);
                else throw err;
            }
        };
    }
    function rethrowTypeGuard(fn) {
        return (arg)=>{
            try {
                return fn(arg);
            } catch (err) {
                if (err instanceof $463f724b64570f1c$export$61ae7f08643aa181) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, err.message);
                else throw err;
            }
        };
    }
    const argAnn = rethrow($463f724b64570f1c$var$unpackAnnotations);
    const ensureStacksEqual = rethrow($463f724b64570f1c$var$assertStacksEqual);
    const ensureTypesEqual = rethrow($463f724b64570f1c$var$assertScalarTypesEqual);
    const ensureComparableType = rethrowTypeGuard($463f724b64570f1c$export$d5e5c91702354d8f);
    const ensurePackableType = rethrowTypeGuard($463f724b64570f1c$export$a32a137820025fa5);
    const ensureStorableType = rethrowTypeGuard($463f724b64570f1c$export$f3036b1da0a36541);
    const ensurePushableType = rethrowTypeGuard($463f724b64570f1c$export$61842f5d814f90cb);
    const ensureBigMapStorableType = rethrowTypeGuard($463f724b64570f1c$export$5a64892aaade38d6);
    // unpack instruction annotations and assert their maximum number
    function instructionAnn(num, opt) {
        const a = argAnn(instruction, Object.assign(Object.assign({}, opt), {
            emptyFields: num.f !== undefined && num.f > 1,
            emptyVar: num.v !== undefined && num.v > 1
        }));
        const assertNum = (a, n, type)=>{
            if (a && a.length > (n || 0)) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: at most ${n || 0} ${type} annotations allowed`);
        };
        assertNum(a.f, num.f, 'field');
        assertNum(a.t, num.t, 'type');
        assertNum(a.v, num.v, 'variable');
        return a;
    }
    // also keeps annotation class if null is provided
    function annotate(tt, a) {
        const tx = tt;
        const t = Array.isArray(tx) ? {
            prim: 'pair',
            args: tx
        } : tx;
        const src = argAnn(t);
        const ann = a.v !== undefined || a.t !== undefined || a.f !== undefined ? [
            ...(a.v === null ? src.v : a.v) || [],
            ...(a.t === null ? src.t : a.t) || [],
            ...(a.f === null ? src.f : a.f) || []
        ] : undefined;
        const rest = $463f724b64570f1c$var$__rest(t, [
            "annots"
        ]);
        return Object.assign(Object.assign({}, rest), ann && ann.length !== 0 && {
            annots: ann
        });
    }
    // shortcut to copy at most one variable annotation from the instruction to the type
    function annotateVar(t, def) {
        const ia = instructionAnn({
            v: 1
        });
        return annotate(t, {
            v: ia.v !== undefined ? ia.v : def !== undefined ? [
                def
            ] : null,
            t: null
        });
    }
    // annotate CAR/CDR/UNPAIR/GET
    function annotateField(arg, field, insAnn, n, defField) {
        var _a, _b, _c, _d;
        const fieldAnn = (_a = argAnn(field).f) === null || _a === void 0 ? void 0 : _a[0]; // field's field annotation
        const insFieldAnn = (_b = insAnn.f) === null || _b === void 0 ? void 0 : _b[n];
        if (insFieldAnn !== undefined && insFieldAnn !== '%' && fieldAnn !== undefined && insFieldAnn !== fieldAnn) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: field names doesn't match: ${insFieldAnn} !== ${fieldAnn}`);
        const insVarAnn = (_c = insAnn.v) === null || _c === void 0 ? void 0 : _c[n]; // nth instruction's variable annotation
        const varAnn = (_d = argAnn(arg).v) === null || _d === void 0 ? void 0 : _d[0]; // instruction argument's variable annotation
        return annotate(field, {
            t: null,
            v: insVarAnn ? insVarAnn === '@%' ? fieldAnn ? [
                '@' + fieldAnn.slice(1)
            ] : undefined : insVarAnn === '@%%' ? varAnn ? [
                '@' + varAnn.slice(1) + '.' + (fieldAnn ? fieldAnn.slice(1) : defField)
            ] : fieldAnn ? [
                '@' + fieldAnn.slice(1)
            ] : undefined : [
                insVarAnn
            ] : null
        });
    }
    // comb helper functions
    function getN(src, n, i = n) {
        const p = $463f724b64570f1c$var$unpackComb('pair', src);
        if (i === 1) return [
            p.args[0]
        ];
        else if (i === 2) return p.args;
        const right = p.args[1];
        if ($463f724b64570f1c$var$isPairType(right)) return [
            p.args[0],
            ...getN(right, n, i - 1)
        ];
        else throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: at least ${n} fields are expected`);
    }
    function getNth(src, n, i = n) {
        if (i === 0) return src;
        const p = $463f724b64570f1c$var$unpackComb('pair', src);
        if (i === 1) return p.args[0];
        const right = p.args[1];
        if ($463f724b64570f1c$var$isPairType(right)) return getNth(right, n, i - 2);
        else if (i === 2) return right;
        throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: at least ${n + 1} fields are expected`);
    }
    function updateNth(src, x, n, i = n) {
        if (i === 0) return x;
        const p = $463f724b64570f1c$var$unpackComb('pair', src);
        if (i === 1) return Object.assign(Object.assign({}, p), {
            args: [
                x,
                p.args[1]
            ]
        });
        const right = p.args[1];
        if ($463f724b64570f1c$var$isPairType(right)) return Object.assign(Object.assign({}, p), {
            args: [
                p.args[0],
                updateNth(right, x, n, i - 2)
            ]
        });
        else if (i === 2) return Object.assign(Object.assign({}, p), {
            args: [
                p.args[0],
                x
            ]
        });
        throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: at least ${n + 1} fields are expected`);
    }
    const varSuffix = (a, suffix)=>[
            '@' + (a.v ? a.v[0].slice(1) + '.' : '') + suffix
        ];
    function branchType(br0, br1) {
        if ('failed' in br0 || 'failed' in br1) return 'failed' in br0 ? br1 : br0;
        else {
            ensureStacksEqual(br0, br1);
            return br0;
        }
    }
    const retStack = ((instruction)=>{
        var _a, _b, _c, _d, _e;
        switch(instruction.prim){
            case 'DUP':
                {
                    const n = instruction.args ? parseInt(instruction.args[0].int, 10) : 1;
                    if (n === 0) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, 'DUP 0 is forbidden');
                    const s = args(n - 1, null)[0];
                    if ($463f724b64570f1c$var$typeID(s) === 'ticket') throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, "ticket can't be DUPed");
                    return [
                        s,
                        ...stack
                    ];
                }
            case 'SWAP':
                {
                    const s = args(0, null, null);
                    instructionAnn({});
                    return [
                        s[1],
                        s[0],
                        ...stack.slice(2)
                    ];
                }
            case 'SOME':
                return [
                    annotate({
                        prim: 'option',
                        args: [
                            args(0, null)[0]
                        ]
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack.slice(1)
                ];
            case 'UNIT':
                return [
                    annotate({
                        prim: 'unit'
                    }, instructionAnn({
                        v: 1,
                        t: 1
                    })),
                    ...stack
                ];
            case 'PAIR':
                {
                    const n = instruction.args ? parseInt(instruction.args[0].int, 10) : 2;
                    if (n < 2) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `PAIR ${n} is forbidden`);
                    const s = args(0, ...new Array(n).fill(null));
                    const ia = instructionAnn({
                        f: n,
                        t: 1,
                        v: 1
                    }, {
                        specialFields: true
                    });
                    const trim = (s)=>{
                        const i = s.lastIndexOf('.');
                        return s.slice(i > 0 ? i + 1 : 1);
                    };
                    const retArgs = s.map((v, i)=>{
                        var _a;
                        const va = argAnn(v);
                        const f = ia.f && ia.f.length > i && ia.f[i] !== '%' ? ia.f[i] === '%@' ? va.v ? [
                            '%' + trim(((_a = va.v) === null || _a === void 0 ? void 0 : _a[0]) || '')
                        ] : undefined : [
                            ia.f[i]
                        ] : undefined;
                        return annotate(v, {
                            v: null,
                            t: null,
                            f: f
                        });
                    });
                    return [
                        annotate({
                            prim: 'pair',
                            args: retArgs
                        }, {
                            t: ia.t,
                            v: ia.v
                        }),
                        ...stack.slice(n)
                    ];
                }
            case 'UNPAIR':
                {
                    const n = instruction.args ? parseInt(instruction.args[0].int, 10) : 2;
                    if (n < 2) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `UNPAIR ${n} is forbidden`);
                    const s = args(0, [
                        'pair'
                    ])[0];
                    const ia = instructionAnn({
                        f: 2,
                        v: 2
                    }, {
                        specialVar: true
                    });
                    const fields = getN(s, n);
                    return [
                        ...fields.map((field, i)=>annotateField(s, field, ia, i, i === 0 ? 'car' : 'cdr')),
                        ...stack.slice(1)
                    ];
                }
            case 'CAR':
            case 'CDR':
                {
                    const s = $463f724b64570f1c$var$unpackComb('pair', args(0, [
                        'pair'
                    ])[0]);
                    const field = s.args[instruction.prim === 'CAR' ? 0 : 1];
                    const ia = instructionAnn({
                        f: 1,
                        v: 1
                    }, {
                        specialVar: true
                    });
                    return [
                        annotateField(s, field, ia, 0, instruction.prim.toLocaleLowerCase()),
                        ...stack.slice(1)
                    ];
                }
            case 'CONS':
                {
                    const s = args(0, null, [
                        'list'
                    ]);
                    ensureTypesEqual(s[0], s[1].args[0]);
                    return [
                        annotateVar({
                            prim: 'list',
                            args: [
                                s[1].args[0]
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'SIZE':
                args(0, [
                    'string',
                    'list',
                    'set',
                    'map',
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack.slice(1)
                ];
            case 'MEM':
                {
                    const s = args(0, null, [
                        'set',
                        'map',
                        'big_map'
                    ]);
                    ensureComparableType(s[0]);
                    ensureTypesEqual(s[0], s[1].args[0]);
                    return [
                        annotateVar({
                            prim: 'bool'
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'GET':
                if (instruction.args) {
                    // comb operation
                    const n = parseInt(instruction.args[0].int, 10);
                    const s = args(0, [
                        'pair'
                    ])[0];
                    return [
                        annotateVar(getNth(s, n)),
                        ...stack.slice(1)
                    ];
                } else {
                    // map operation
                    const s = args(0, null, [
                        'map',
                        'big_map'
                    ]);
                    ensureComparableType(s[0]);
                    ensureTypesEqual(s[0], s[1].args[0]);
                    return [
                        annotateVar({
                            prim: 'option',
                            args: [
                                s[1].args[1]
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'UPDATE':
                if (instruction.args) {
                    // comb operation
                    const n = parseInt(instruction.args[0].int, 10);
                    const s = args(0, null, [
                        'pair'
                    ]);
                    return [
                        annotateVar(updateNth(s[1], s[0], n)),
                        ...stack.slice(2)
                    ];
                } else {
                    // map operation
                    const s0 = args(0, null, [
                        'bool',
                        'option'
                    ]);
                    ensureComparableType(s0[0]);
                    if (s0[1].prim === 'bool') {
                        const s1 = args(2, [
                            'set'
                        ]);
                        ensureTypesEqual(s0[0], s1[0].args[0]);
                        return [
                            annotateVar({
                                prim: 'set',
                                args: [
                                    annotate(s0[0], {
                                        t: null
                                    })
                                ]
                            }),
                            ...stack.slice(3)
                        ];
                    }
                    const s1 = args(2, [
                        'map',
                        'big_map'
                    ]);
                    ensureTypesEqual(s0[0], s1[0].args[0]);
                    if (s1[0].prim === 'map') return [
                        annotateVar({
                            prim: 'map',
                            args: [
                                annotate(s0[0], {
                                    t: null
                                }),
                                annotate(s0[1].args[0], {
                                    t: null
                                })
                            ]
                        }),
                        ...stack.slice(3)
                    ];
                    ensureBigMapStorableType(s0[1].args[0]);
                    return [
                        annotateVar({
                            prim: 'big_map',
                            args: [
                                annotate(s0[0], {
                                    t: null
                                }),
                                annotate(s0[1].args[0], {
                                    t: null
                                })
                            ]
                        }),
                        ...stack.slice(3)
                    ];
                }
            case 'GET_AND_UPDATE':
                {
                    const ia = instructionAnn({
                        v: 2
                    });
                    const s = args(0, null, [
                        'option'
                    ], [
                        'map',
                        'big_map'
                    ]);
                    ensureComparableType(s[0]);
                    ensureTypesEqual(s[0], s[2].args[0]);
                    ensureTypesEqual(s[1].args[0], s[2].args[1]);
                    const va = (_a = ia.v) === null || _a === void 0 ? void 0 : _a.map((v)=>v !== '@' ? [
                            v
                        ] : undefined);
                    if (s[2].prim === 'map') return [
                        annotate({
                            prim: 'option',
                            args: [
                                s[2].args[1]
                            ]
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[0]
                        }),
                        annotate({
                            prim: 'map',
                            args: [
                                annotate(s[0], {
                                    t: null
                                }),
                                annotate(s[1].args[0], {
                                    t: null
                                })
                            ]
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[1]
                        }),
                        ...stack.slice(3)
                    ];
                    ensureBigMapStorableType(s[1].args[0]);
                    return [
                        annotate({
                            prim: 'option',
                            args: [
                                s[2].args[1]
                            ]
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[0]
                        }),
                        annotate({
                            prim: 'big_map',
                            args: [
                                annotate(s[0], {
                                    t: null
                                }),
                                annotate(s[1].args[0], {
                                    t: null
                                })
                            ]
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[1]
                        }),
                        ...stack.slice(3)
                    ];
                }
            case 'EXEC':
                {
                    const s = args(0, null, [
                        'lambda'
                    ]);
                    ensureTypesEqual(s[0], s[1].args[0]);
                    return [
                        annotateVar(s[1].args[1]),
                        ...stack.slice(2)
                    ];
                }
            case 'APPLY':
                {
                    const s = args(0, null, [
                        'lambda'
                    ]);
                    ensureStorableType(s[0]);
                    ensurePushableType(s[0]);
                    if (!$463f724b64570f1c$var$isPairType(s[1].args[0])) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: function's argument must be a pair: ${$463f724b64570f1c$var$typeID(s[1].args[0])}`);
                    const pt = s[1].args[0];
                    ensureTypesEqual(s[0], $463f724b64570f1c$var$typeArgs(pt)[0]);
                    return [
                        annotateVar({
                            prim: 'lambda',
                            args: [
                                $463f724b64570f1c$var$typeArgs(pt)[1],
                                s[1].args[1]
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'FAILWITH':
                {
                    const s = args(0, null)[0];
                    if (!$463f724b64570f1c$export$d0c06cb7d5b8a84b(proto, $463f724b64570f1c$export$377bbedb5576dfa8.PtEdo2Zk)) ensurePackableType(s);
                    return {
                        failed: s,
                        level: 0
                    };
                }
            case 'NEVER':
                args(0, [
                    'never'
                ]);
                return {
                    failed: {
                        prim: 'never'
                    },
                    level: 0
                };
            case 'RENAME':
                return [
                    annotateVar(args(0, null)[0]),
                    ...stack.slice(1)
                ];
            case 'CONCAT':
                {
                    const s0 = args(0, [
                        'string',
                        'list',
                        'bytes'
                    ]);
                    if (s0[0].prim === 'list') {
                        if ($463f724b64570f1c$var$typeID(s0[0].args[0]) !== 'string' && $463f724b64570f1c$var$typeID(s0[0].args[0]) !== 'bytes') throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't concatenate list of ${$463f724b64570f1c$var$typeID(s0[0].args[0])}'s`);
                        return [
                            annotateVar(s0[0].args[0]),
                            ...stack.slice(1)
                        ];
                    }
                    const s1 = args(1, [
                        'string',
                        'bytes'
                    ]);
                    if (s0[0].prim !== s1[0].prim) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't concatenate ${s0[0].prim} with ${s1[0].prim}`);
                    return [
                        annotateVar(s1[0]),
                        ...stack.slice(2)
                    ];
                }
            case 'SLICE':
                return [
                    annotateVar({
                        prim: 'option',
                        args: [
                            args(0, [
                                'nat'
                            ], [
                                'nat'
                            ], [
                                'string',
                                'bytes'
                            ])[2]
                        ]
                    }, '@slice'),
                    ...stack.slice(3)
                ];
            case 'PACK':
                {
                    const s = args(0, null)[0];
                    ensurePackableType(s);
                    return [
                        annotateVar({
                            prim: 'bytes'
                        }, '@packed'),
                        ...stack.slice(1)
                    ];
                }
            case 'ADD':
                {
                    const s = args(0, [
                        'nat',
                        'int',
                        'timestamp',
                        'mutez',
                        'bls12_381_g1',
                        'bls12_381_g2',
                        'bls12_381_fr'
                    ], [
                        'nat',
                        'int',
                        'timestamp',
                        'mutez',
                        'bls12_381_g1',
                        'bls12_381_g2',
                        'bls12_381_fr'
                    ]);
                    if (s[0].prim === 'nat' && s[1].prim === 'int' || s[0].prim === 'int' && s[1].prim === 'nat') return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'int' && s[1].prim === 'timestamp' || s[0].prim === 'timestamp' && s[1].prim === 'int') return [
                        annotateVar({
                            prim: 'timestamp'
                        }),
                        ...stack.slice(2)
                    ];
                    else if ((s[0].prim === 'int' || s[0].prim === 'nat' || s[0].prim === 'mutez' || s[0].prim === 'bls12_381_g1' || s[0].prim === 'bls12_381_g2' || s[0].prim === 'bls12_381_fr') && s[0].prim === s[1].prim) return [
                        annotateVar(s[0]),
                        ...stack.slice(2)
                    ];
                    throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't add ${s[0].prim} to ${s[1].prim}`);
                }
            case 'SUB':
                {
                    const s = $463f724b64570f1c$export$d0c06cb7d5b8a84b(proto, $463f724b64570f1c$export$377bbedb5576dfa8.PsiThaCa) ? args(0, [
                        'nat',
                        'int',
                        'timestamp',
                        'mutez'
                    ], [
                        'nat',
                        'int',
                        'timestamp',
                        'mutez'
                    ]) : args(0, [
                        'nat',
                        'int',
                        'timestamp'
                    ], [
                        'nat',
                        'int',
                        'timestamp'
                    ]);
                    if ((s[0].prim === 'nat' || s[0].prim === 'int') && (s[1].prim === 'nat' || s[1].prim === 'int') || s[0].prim === 'timestamp' && s[1].prim === 'timestamp') return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'timestamp' && s[1].prim === 'int') return [
                        annotateVar({
                            prim: 'timestamp'
                        }),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'mutez' && s[1].prim === 'mutez') return [
                        annotateVar({
                            prim: 'mutez'
                        }),
                        ...stack.slice(2)
                    ];
                    throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't subtract ${s[0].prim} from ${s[1].prim}`);
                }
            case 'SUB_MUTEZ':
                args(0, [
                    'mutez'
                ], [
                    'mutez'
                ]);
                return [
                    annotateVar({
                        prim: 'option',
                        args: [
                            {
                                prim: 'mutez'
                            }
                        ]
                    }),
                    ...stack.slice(2)
                ];
            case 'MUL':
                {
                    const s = args(0, [
                        'nat',
                        'int',
                        'mutez',
                        'bls12_381_g1',
                        'bls12_381_g2',
                        'bls12_381_fr'
                    ], [
                        'nat',
                        'int',
                        'mutez',
                        'bls12_381_g1',
                        'bls12_381_g2',
                        'bls12_381_fr'
                    ]);
                    if (s[0].prim === 'nat' && s[1].prim === 'int' || s[0].prim === 'int' && s[1].prim === 'nat') return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'nat' && s[1].prim === 'mutez' || s[0].prim === 'mutez' && s[1].prim === 'nat') return [
                        annotateVar({
                            prim: 'mutez'
                        }),
                        ...stack.slice(2)
                    ];
                    else if ((s[0].prim === 'bls12_381_g1' || s[0].prim === 'bls12_381_g2' || s[0].prim === 'bls12_381_fr') && s[1].prim === 'bls12_381_fr' || (s[0].prim === 'nat' || s[0].prim === 'int') && s[0].prim === s[1].prim) return [
                        annotateVar(s[0]),
                        ...stack.slice(2)
                    ];
                    else if ((s[0].prim === 'nat' || s[0].prim === 'int') && s[1].prim === 'bls12_381_fr' || (s[1].prim === 'nat' || s[1].prim === 'int') && s[0].prim === 'bls12_381_fr') return [
                        annotateVar({
                            prim: 'bls12_381_fr'
                        }),
                        ...stack.slice(2)
                    ];
                    throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't multiply ${s[0].prim} by ${s[1].prim}`);
                }
            case 'EDIV':
                {
                    const res = (a, b)=>({
                            prim: 'option',
                            args: [
                                {
                                    prim: 'pair',
                                    args: [
                                        {
                                            prim: a
                                        },
                                        {
                                            prim: b
                                        }
                                    ]
                                }
                            ]
                        });
                    const s = args(0, [
                        'nat',
                        'int',
                        'mutez'
                    ], [
                        'nat',
                        'int',
                        'mutez'
                    ]);
                    if (s[0].prim === 'nat' && s[1].prim === 'nat') return [
                        annotateVar(res('nat', 'nat')),
                        ...stack.slice(2)
                    ];
                    else if ((s[0].prim === 'nat' || s[0].prim === 'int') && (s[1].prim === 'nat' || s[1].prim === 'int')) return [
                        annotateVar(res('int', 'nat')),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'mutez' && s[1].prim === 'nat') return [
                        annotateVar(res('mutez', 'mutez')),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'mutez' && s[1].prim === 'mutez') return [
                        annotateVar(res('nat', 'mutez')),
                        ...stack.slice(2)
                    ];
                    throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't euclideally divide ${s[0].prim} by ${s[1].prim}`);
                }
            case 'ABS':
                args(0, [
                    'int'
                ]);
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack.slice(1)
                ];
            case 'ISNAT':
                args(0, [
                    'int'
                ]);
                return [
                    annotateVar({
                        prim: 'option',
                        args: [
                            {
                                prim: 'nat'
                            }
                        ]
                    }),
                    ...stack.slice(1)
                ];
            case 'INT':
                args(0, [
                    'nat',
                    'bls12_381_fr',
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'int'
                    }),
                    ...stack.slice(1)
                ];
            case 'BYTES':
                args(0, [
                    'nat',
                    'int'
                ]);
                return [
                    annotateVar({
                        prim: 'bytes'
                    }),
                    ...stack.slice(1)
                ];
            case 'NAT':
                args(0, [
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack.slice(1)
                ];
            case 'NEG':
                {
                    const s = args(0, [
                        'nat',
                        'int',
                        'bls12_381_g1',
                        'bls12_381_g2',
                        'bls12_381_fr'
                    ])[0];
                    if (s.prim === 'nat' || s.prim === 'int') return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(1)
                    ];
                    return [
                        annotateVar(s),
                        ...stack.slice(1)
                    ];
                }
            case 'LSL':
            case 'LSR':
                args(0, [
                    'nat',
                    'bytes'
                ], [
                    'nat',
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack.slice(2)
                ];
            case 'OR':
            case 'XOR':
                {
                    const s = args(0, [
                        'nat',
                        'bytes',
                        'bool'
                    ], [
                        'nat',
                        'bytes',
                        'bool'
                    ]);
                    if (s[0].prim !== s[1].prim) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: both arguments must be of the same type: ${s[0].prim}, ${s[1].prim}`);
                    return [
                        annotateVar(s[1]),
                        ...stack.slice(2)
                    ];
                }
            case 'AND':
                {
                    const s = args(0, [
                        'nat',
                        'bytes',
                        'bool',
                        'int'
                    ], [
                        'nat',
                        'bytes',
                        'bool'
                    ]);
                    if ((s[0].prim !== 'int' || s[1].prim !== 'nat') && s[0].prim !== s[1].prim) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: both arguments must be of the same type: ${s[0].prim}, ${s[1].prim}`);
                    return [
                        annotateVar(s[1]),
                        ...stack.slice(2)
                    ];
                }
            case 'NOT':
                {
                    const s = args(0, [
                        'nat',
                        'bytes',
                        'bool',
                        'int'
                    ])[0];
                    if (s.prim === 'bool') return [
                        annotateVar({
                            prim: 'bool'
                        }),
                        ...stack.slice(1)
                    ];
                    return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'COMPARE':
                {
                    const s = args(0, null, null);
                    ensureComparableType(s[0]);
                    ensureComparableType(s[1]);
                    return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'EQ':
            case 'NEQ':
            case 'LT':
            case 'GT':
            case 'LE':
            case 'GE':
                args(0, [
                    'int'
                ]);
                return [
                    annotateVar({
                        prim: 'bool'
                    }),
                    ...stack.slice(1)
                ];
            case 'SELF':
                {
                    if ((ctx === null || ctx === void 0 ? void 0 : ctx.contract) === undefined) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: contract required`);
                    const ia = instructionAnn({
                        f: 1,
                        v: 1
                    });
                    const ep = $463f724b64570f1c$export$7755930f2db79bc5(ctx.contract, (_b = ia.f) === null || _b === void 0 ? void 0 : _b[0]);
                    if (ep === null) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: contract has no entrypoint ${ep}`);
                    return [
                        annotate({
                            prim: 'contract',
                            args: [
                                ep
                            ]
                        }, {
                            v: ia.v ? ia.v : [
                                '@self'
                            ]
                        }),
                        ...stack
                    ];
                }
            case 'TRANSFER_TOKENS':
                {
                    const s = args(0, null, [
                        'mutez'
                    ], [
                        'contract'
                    ]);
                    ensureTypesEqual(s[0], s[2].args[0]);
                    return [
                        annotateVar({
                            prim: 'operation'
                        }),
                        ...stack.slice(3)
                    ];
                }
            case 'SET_DELEGATE':
                {
                    const s = args(0, [
                        'option'
                    ])[0];
                    if ($463f724b64570f1c$var$typeID(s.args[0]) !== 'key_hash') throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: key hash expected: ${$463f724b64570f1c$var$typeID(s.args[0])}`);
                    return [
                        annotateVar({
                            prim: 'operation'
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'IMPLICIT_ACCOUNT':
                args(0, [
                    'key_hash'
                ]);
                return [
                    annotateVar({
                        prim: 'contract',
                        args: [
                            {
                                prim: 'unit'
                            }
                        ]
                    }),
                    ...stack.slice(1)
                ];
            case 'NOW':
                return [
                    annotateVar({
                        prim: 'timestamp'
                    }, '@now'),
                    ...stack
                ];
            case 'AMOUNT':
                return [
                    annotateVar({
                        prim: 'mutez'
                    }, '@amount'),
                    ...stack
                ];
            case 'BALANCE':
                return [
                    annotateVar({
                        prim: 'mutez'
                    }, '@balance'),
                    ...stack
                ];
            case 'CHECK_SIGNATURE':
                args(0, [
                    'key'
                ], [
                    'signature'
                ], [
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'bool'
                    }),
                    ...stack.slice(3)
                ];
            case 'BLAKE2B':
            case 'SHA256':
            case 'SHA512':
            case 'KECCAK':
            case 'SHA3':
                args(0, [
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'bytes'
                    }),
                    ...stack.slice(1)
                ];
            case 'HASH_KEY':
                args(0, [
                    'key'
                ]);
                return [
                    annotateVar({
                        prim: 'key_hash'
                    }),
                    ...stack.slice(1)
                ];
            case 'SOURCE':
                return [
                    annotateVar({
                        prim: 'address'
                    }, '@source'),
                    ...stack
                ];
            case 'SENDER':
                return [
                    annotateVar({
                        prim: 'address'
                    }, '@sender'),
                    ...stack
                ];
            case 'ADDRESS':
                {
                    const s = args(0, [
                        'contract'
                    ])[0];
                    const ia = instructionAnn({
                        v: 1
                    });
                    return [
                        annotate({
                            prim: 'address',
                            [$463f724b64570f1c$export$8bd888d100ea60f]: s
                        }, {
                            v: ia.v ? ia.v : varSuffix(argAnn(s), 'address')
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'SELF_ADDRESS':
                {
                    const addr = {
                        prim: 'address'
                    };
                    if ((ctx === null || ctx === void 0 ? void 0 : ctx.contract) !== undefined) addr[$463f724b64570f1c$export$8bd888d100ea60f] = {
                        prim: 'contract',
                        args: [
                            $463f724b64570f1c$export$8df01cc5695a993c(ctx.contract, 'parameter').args[0]
                        ]
                    };
                    return [
                        annotateVar(addr, '@address'),
                        ...stack
                    ];
                }
            case 'CHAIN_ID':
                return [
                    annotateVar({
                        prim: 'chain_id'
                    }),
                    ...stack
                ];
            case 'DROP':
                {
                    instructionAnn({});
                    const n = instruction.args !== undefined ? parseInt(instruction.args[0].int, 10) : 1;
                    args(n - 1, null);
                    return stack.slice(n);
                }
            case 'DIG':
                {
                    instructionAnn({});
                    const n = parseInt(instruction.args[0].int, 10);
                    return [
                        args(n, null)[0],
                        ...stack.slice(0, n),
                        ...stack.slice(n + 1)
                    ];
                }
            case 'DUG':
                {
                    instructionAnn({});
                    const n = parseInt(instruction.args[0].int, 10);
                    return [
                        ...stack.slice(1, n + 1),
                        args(0, null)[0],
                        ...stack.slice(n + 1)
                    ];
                }
            case 'NONE':
                $463f724b64570f1c$export$1244433858b68826(instruction.args[0]);
                return [
                    annotate({
                        prim: 'option',
                        args: [
                            instruction.args[0]
                        ]
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack
                ];
            case 'LEFT':
            case 'RIGHT':
                {
                    const s = args(0, null)[0];
                    const ia = instructionAnn({
                        f: 2,
                        t: 1,
                        v: 1
                    }, {
                        specialFields: true
                    });
                    const va = argAnn(s);
                    const children = [
                        annotate(s, {
                            t: null,
                            v: null,
                            f: ia.f && ia.f.length > 0 && ia.f[0] !== '%' ? ia.f[0] === '%@' ? va.v ? [
                                '%' + va.v[0].slice(1)
                            ] : undefined : ia.f : undefined
                        }),
                        annotate(instruction.args[0], {
                            t: null,
                            f: ia.f && ia.f.length > 1 && ia.f[1] !== '%' ? ia.f : undefined
                        })
                    ];
                    return [
                        annotate({
                            prim: 'or',
                            args: instruction.prim === 'LEFT' ? children : [
                                children[1],
                                children[0]
                            ]
                        }, {
                            t: ia.t,
                            v: ia.v
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'NIL':
                $463f724b64570f1c$export$1244433858b68826(instruction.args[0]);
                return [
                    annotate({
                        prim: 'list',
                        args: [
                            instruction.args[0]
                        ]
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack
                ];
            case 'UNPACK':
                args(0, [
                    'bytes'
                ]);
                $463f724b64570f1c$export$1244433858b68826(instruction.args[0]);
                return [
                    annotateVar({
                        prim: 'option',
                        args: [
                            instruction.args[0]
                        ]
                    }, '@unpacked'),
                    ...stack.slice(1)
                ];
            case 'CONTRACT':
                {
                    const s = args(0, [
                        'address'
                    ])[0];
                    $463f724b64570f1c$export$1244433858b68826(instruction.args[0]);
                    const ia = instructionAnn({
                        v: 1,
                        f: 1
                    });
                    const contract = s[$463f724b64570f1c$export$8bd888d100ea60f];
                    if (contract !== undefined) {
                        const ep = $463f724b64570f1c$export$7755930f2db79bc5(contract, (_c = ia.f) === null || _c === void 0 ? void 0 : _c[0]);
                        if (ep === null) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: contract has no entrypoint ${ep}`);
                        ensureTypesEqual(ep, instruction.args[0]);
                    }
                    return [
                        annotate({
                            prim: 'option',
                            args: [
                                {
                                    prim: 'contract',
                                    args: [
                                        instruction.args[0]
                                    ]
                                }
                            ]
                        }, {
                            v: ia.v ? ia.v : varSuffix(argAnn(s), 'contract')
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'CAST':
                {
                    instructionAnn({});
                    const s = args(0, null)[0];
                    $463f724b64570f1c$export$1244433858b68826(instruction.args[0]);
                    ensureTypesEqual(instruction.args[0], s);
                    return [
                        instruction.args[0],
                        ...stack.slice(1)
                    ];
                }
            case 'IF_NONE':
                {
                    instructionAnn({});
                    const s = args(0, [
                        'option'
                    ])[0];
                    const tail = stack.slice(1);
                    const br0 = $463f724b64570f1c$var$functionTypeInternal(instruction.args[0], tail, ctx);
                    const br1 = $463f724b64570f1c$var$functionTypeInternal(instruction.args[1], [
                        annotate(s.args[0], {
                            t: null,
                            v: varSuffix(argAnn(s), 'some')
                        }),
                        ...tail
                    ], ctx);
                    return branchType(br0, br1);
                }
            case 'IF_LEFT':
                {
                    instructionAnn({});
                    const s = args(0, [
                        'or'
                    ])[0];
                    const va = argAnn(s);
                    const lefta = argAnn(s.args[0]);
                    const righta = argAnn(s.args[1]);
                    const tail = stack.slice(1);
                    const br0 = $463f724b64570f1c$var$functionTypeInternal(instruction.args[0], [
                        annotate(s.args[0], {
                            t: null,
                            v: varSuffix(va, lefta.f ? lefta.f[0].slice(1) : 'left')
                        }),
                        ...tail
                    ], ctx);
                    const br1 = $463f724b64570f1c$var$functionTypeInternal(instruction.args[1], [
                        annotate(s.args[1], {
                            t: null,
                            v: varSuffix(va, righta.f ? righta.f[0].slice(1) : 'right')
                        }),
                        ...tail
                    ], ctx);
                    return branchType(br0, br1);
                }
            case 'IF_CONS':
                {
                    instructionAnn({});
                    const s = args(0, [
                        'list'
                    ])[0];
                    const va = argAnn(s);
                    const tail = stack.slice(1);
                    const br0 = $463f724b64570f1c$var$functionTypeInternal(instruction.args[0], [
                        annotate(s.args[0], {
                            t: null,
                            v: varSuffix(va, 'hd')
                        }),
                        annotate(s, {
                            t: null,
                            v: varSuffix(va, 'tl')
                        }),
                        ...tail
                    ], ctx);
                    const br1 = $463f724b64570f1c$var$functionTypeInternal(instruction.args[1], tail, ctx);
                    return branchType(br0, br1);
                }
            case 'IF':
                {
                    instructionAnn({});
                    args(0, [
                        'bool'
                    ]);
                    const tail = stack.slice(1);
                    const br0 = $463f724b64570f1c$var$functionTypeInternal(instruction.args[0], tail, ctx);
                    const br1 = $463f724b64570f1c$var$functionTypeInternal(instruction.args[1], tail, ctx);
                    return branchType(br0, br1);
                }
            case 'MAP':
                {
                    const s = args(0, [
                        'list',
                        'map',
                        'option'
                    ])[0];
                    const tail = stack.slice(1);
                    const elt = s.prim === 'map' ? {
                        prim: 'pair',
                        args: s.args
                    } : s.args[0];
                    const body = $463f724b64570f1c$var$functionTypeInternal(instruction.args[0], [
                        annotate(elt, {
                            t: null,
                            v: varSuffix(argAnn(s), 'elt')
                        }),
                        ...tail
                    ], ctx);
                    if ('failed' in body) {
                        if (!('prim' in body.failed) || body.failed.prim !== 'never') throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: FAIL is not allowed in MAP`);
                        return {
                            failed: body.failed,
                            level: body.level + 1
                        };
                    }
                    if (body.length < 1) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: function must return a value`);
                    ensureStacksEqual(body.slice(1), tail);
                    return s.prim === 'list' ? [
                        annotateVar({
                            prim: 'list',
                            args: [
                                body[0]
                            ]
                        }),
                        ...tail
                    ] : s.prim === 'map' ? [
                        annotateVar({
                            prim: 'map',
                            args: [
                                s.args[0],
                                body[0]
                            ]
                        }),
                        ...tail
                    ] : [
                        annotateVar({
                            prim: 'option',
                            args: [
                                body[0]
                            ]
                        }),
                        ...tail
                    ];
                }
            case 'ITER':
                {
                    instructionAnn({});
                    const s = args(0, [
                        'set',
                        'list',
                        'map'
                    ])[0];
                    const tail = stack.slice(1);
                    const elt = s.prim === 'map' ? {
                        prim: 'pair',
                        args: s.args
                    } : s.args[0];
                    const body = $463f724b64570f1c$var$functionTypeInternal(instruction.args[0], [
                        annotate(elt, {
                            t: null,
                            v: varSuffix(argAnn(s), 'elt')
                        }),
                        ...tail
                    ], ctx);
                    if ('failed' in body) return {
                        failed: body.failed,
                        level: body.level + 1
                    };
                    ensureStacksEqual(body, tail);
                    return tail;
                }
            case 'LOOP':
                {
                    instructionAnn({});
                    args(0, [
                        'bool'
                    ]);
                    const tail = stack.slice(1);
                    const body = $463f724b64570f1c$var$functionTypeInternal(instruction.args[0], tail, ctx);
                    if ('failed' in body) return {
                        failed: body.failed,
                        level: body.level + 1
                    };
                    ensureStacksEqual(body, [
                        {
                            prim: 'bool'
                        },
                        ...tail
                    ]);
                    return tail;
                }
            case 'LOOP_LEFT':
                {
                    instructionAnn({});
                    const s = args(0, [
                        'or'
                    ])[0];
                    const tail = stack.slice(1);
                    const body = $463f724b64570f1c$var$functionTypeInternal(instruction.args[0], [
                        annotate(s.args[0], {
                            t: null,
                            v: varSuffix(argAnn(s), 'left')
                        }),
                        ...tail
                    ], ctx);
                    if ('failed' in body) return {
                        failed: body.failed,
                        level: body.level + 1
                    };
                    ensureStacksEqual(body, [
                        s,
                        ...tail
                    ]);
                    return [
                        annotate(s.args[1], {
                            t: null,
                            v: instructionAnn({
                                v: 1
                            }).v
                        }),
                        ...tail
                    ];
                }
            case 'DIP':
                {
                    instructionAnn({});
                    const n = instruction.args.length === 2 ? parseInt(instruction.args[0].int, 10) : 1;
                    args(n - 1, null);
                    const head = stack.slice(0, n);
                    const tail = stack.slice(n);
                    // ternary operator is a type guard so use it instead of just `instruction.args.length - 1`
                    const body = instruction.args.length === 2 ? $463f724b64570f1c$var$functionTypeInternal(instruction.args[1], tail, ctx) : $463f724b64570f1c$var$functionTypeInternal(instruction.args[0], tail, ctx);
                    if ('failed' in body) return {
                        failed: body.failed,
                        level: body.level + 1
                    };
                    return [
                        ...head,
                        ...body
                    ];
                }
            case 'CREATE_CONTRACT':
                {
                    const ia = instructionAnn({
                        v: 2
                    });
                    const s = args(0, [
                        'option'
                    ], [
                        'mutez'
                    ], null);
                    if ($463f724b64570f1c$var$typeID(s[0].args[0]) !== 'key_hash') throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: key hash expected: ${$463f724b64570f1c$var$typeID(s[0].args[0])}`);
                    if (ensureStorableType(s[2])) {
                        $463f724b64570f1c$export$c8575dc38549dc3a(instruction.args[0]);
                        $463f724b64570f1c$var$assertScalarTypesEqual($463f724b64570f1c$export$8df01cc5695a993c(instruction.args[0], 'storage').args[0], s[2]);
                    }
                    const va = (_d = ia.v) === null || _d === void 0 ? void 0 : _d.map((v)=>v !== '@' ? [
                            v
                        ] : undefined);
                    return [
                        annotate({
                            prim: 'operation'
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[0]
                        }),
                        annotate({
                            prim: 'address',
                            [$463f724b64570f1c$export$8bd888d100ea60f]: {
                                prim: 'contract',
                                args: [
                                    $463f724b64570f1c$export$8df01cc5695a993c(instruction.args[0], 'parameter').args[0]
                                ]
                            }
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[1]
                        }),
                        ...stack.slice(3)
                    ];
                }
            case 'PUSH':
                $463f724b64570f1c$export$1244433858b68826(instruction.args[0]);
                $463f724b64570f1c$var$assertDataValidInternal(instruction.args[1], instruction.args[0], Object.assign(Object.assign({}, ctx), {
                    contract: undefined
                }));
                return [
                    annotateVar(instruction.args[0]),
                    ...stack
                ];
            case 'EMPTY_SET':
                $463f724b64570f1c$export$1244433858b68826(instruction.args[0]);
                ensureComparableType(instruction.args[0]);
                return [
                    annotate({
                        prim: 'set',
                        args: instruction.args
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack
                ];
            case 'EMPTY_MAP':
                $463f724b64570f1c$export$1244433858b68826(instruction.args[0]);
                ensureComparableType(instruction.args[0]);
                $463f724b64570f1c$export$1244433858b68826(instruction.args[1]);
                return [
                    annotate({
                        prim: 'map',
                        args: instruction.args
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack
                ];
            case 'EMPTY_BIG_MAP':
                $463f724b64570f1c$export$1244433858b68826(instruction.args[0]);
                ensureComparableType(instruction.args[0]);
                $463f724b64570f1c$export$1244433858b68826(instruction.args[1]);
                ensureBigMapStorableType(instruction.args[0]);
                return [
                    annotate({
                        prim: 'big_map',
                        args: instruction.args
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack
                ];
            case 'LAMBDA_REC':
            case 'LAMBDA':
                {
                    $463f724b64570f1c$export$1244433858b68826(instruction.args[0]);
                    $463f724b64570f1c$export$1244433858b68826(instruction.args[1]);
                    const s = [
                        instruction.args[0]
                    ];
                    if (instruction.prim === 'LAMBDA_REC') s.push({
                        prim: 'lambda',
                        args: [
                            instruction.args[0],
                            instruction.args[1]
                        ]
                    });
                    const body = $463f724b64570f1c$var$functionTypeInternal(instruction.args[2], s, Object.assign(Object.assign({}, ctx), {
                        contract: undefined
                    }));
                    if ('failed' in body) return {
                        failed: body.failed,
                        level: body.level + 1
                    };
                    if (body.length !== 1) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: function must return a value`);
                    ensureTypesEqual(instruction.args[1], body[0]);
                    return [
                        annotateVar({
                            prim: 'lambda',
                            args: [
                                instruction.args[0],
                                instruction.args[1]
                            ]
                        }),
                        ...stack
                    ];
                }
            case 'LEVEL':
                return [
                    annotateVar({
                        prim: 'nat'
                    }, '@level'),
                    ...stack
                ];
            case 'TOTAL_VOTING_POWER':
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack
                ];
            case 'VOTING_POWER':
                args(0, [
                    'key_hash'
                ]);
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack.slice(1)
                ];
            case 'TICKET':
                {
                    const s = args(0, null, [
                        'nat'
                    ])[0];
                    ensureComparableType(s);
                    if ($463f724b64570f1c$export$d0c06cb7d5b8a84b(proto, $463f724b64570f1c$export$377bbedb5576dfa8.PtLimaPtL)) return [
                        annotate({
                            prim: 'ticket',
                            args: [
                                s
                            ]
                        }, instructionAnn({
                            t: 1,
                            v: 1
                        })),
                        ...stack.slice(2)
                    ];
                    else return [
                        annotateVar({
                            prim: 'option',
                            args: [
                                annotate({
                                    prim: 'ticket',
                                    args: [
                                        s
                                    ]
                                }, instructionAnn({
                                    t: 1,
                                    v: 1
                                }))
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'JOIN_TICKETS':
                {
                    const s = $463f724b64570f1c$var$unpackComb('pair', args(0, [
                        'pair'
                    ])[0]);
                    if ($463f724b64570f1c$var$typeID(s.args[0]) !== 'ticket') throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: ticket expected: ${$463f724b64570f1c$var$typeID(s.args[0])}`);
                    ensureTypesEqual(s.args[0], s.args[1]);
                    return [
                        annotateVar({
                            prim: 'option',
                            args: [
                                annotate(s.args[0], {
                                    t: null
                                })
                            ]
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'SPLIT_TICKET':
                {
                    const s = args(0, [
                        'ticket'
                    ], [
                        'pair'
                    ]);
                    const p = $463f724b64570f1c$var$unpackComb('pair', s[1]);
                    if ($463f724b64570f1c$var$typeID(p.args[0]) !== 'nat') throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: nat expected: ${$463f724b64570f1c$var$typeID(p.args[0])}`);
                    ensureTypesEqual(p.args[0], p.args[1]);
                    return [
                        annotateVar({
                            prim: 'option',
                            args: [
                                {
                                    prim: 'pair',
                                    args: [
                                        annotate(s[0], {
                                            t: null
                                        }),
                                        annotate(s[0], {
                                            t: null
                                        })
                                    ]
                                }
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'READ_TICKET':
                {
                    const ia = instructionAnn({
                        v: 2
                    });
                    const s = args(0, [
                        'ticket'
                    ])[0];
                    const va = (_e = ia.v) === null || _e === void 0 ? void 0 : _e.map((v)=>v !== '@' ? [
                            v
                        ] : undefined);
                    return [
                        annotate({
                            prim: 'pair',
                            args: [
                                {
                                    prim: 'address'
                                },
                                annotate(s.args[0], {
                                    t: null
                                }),
                                {
                                    prim: 'nat'
                                }
                            ]
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[0]
                        }),
                        annotate(s, {
                            v: va === null || va === void 0 ? void 0 : va[1],
                            t: null
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'PAIRING_CHECK':
                {
                    const p = args(0, [
                        'list'
                    ])[0].args[0];
                    if (!$463f724b64570f1c$var$isPairType(p)) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: pair expected: ${$463f724b64570f1c$var$typeID(p)}`);
                    const c = $463f724b64570f1c$var$unpackComb('pair', p);
                    if ($463f724b64570f1c$var$typeID(c.args[0]) !== 'bls12_381_g1') throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: bls12_381_g1 expected: ${$463f724b64570f1c$var$typeID(c.args[0])}`);
                    if ($463f724b64570f1c$var$typeID(c.args[1]) !== 'bls12_381_g2') throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: bls12_381_g2 expected: ${$463f724b64570f1c$var$typeID(c.args[1])}`);
                    return [
                        annotateVar({
                            prim: 'bool'
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'SAPLING_EMPTY_STATE':
                return [
                    annotate({
                        prim: 'sapling_state',
                        args: [
                            instruction.args[0]
                        ]
                    }, instructionAnn({
                        v: 1,
                        t: 1
                    })),
                    ...stack
                ];
            case 'SAPLING_VERIFY_UPDATE':
                {
                    const s = args(0, [
                        'sapling_transaction'
                    ], [
                        'sapling_state'
                    ]);
                    if (parseInt(s[0].args[0].int, 10) !== parseInt(s[1].args[0].int, 10)) throw new $463f724b64570f1c$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: sapling memo size mismatch: ${s[0].args[0].int} != ${s[1].args[0].int}`);
                    return $463f724b64570f1c$export$d0c06cb7d5b8a84b(proto, $463f724b64570f1c$export$377bbedb5576dfa8.PtJakarta) ? [
                        annotateVar({
                            prim: 'option',
                            args: [
                                {
                                    prim: 'pair',
                                    args: [
                                        {
                                            prim: 'int'
                                        },
                                        annotate(s[1], {
                                            t: null
                                        })
                                    ]
                                }
                            ]
                        }),
                        ...stack.slice(2)
                    ] : [
                        annotateVar({
                            prim: 'option',
                            args: [
                                {
                                    prim: 'pair',
                                    args: [
                                        {
                                            prim: 'bytes'
                                        },
                                        {
                                            prim: 'pair',
                                            args: [
                                                {
                                                    prim: 'int'
                                                },
                                                annotate(s[1], {
                                                    t: null
                                                })
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'OPEN_CHEST':
                args(0, [
                    'chest_key'
                ], [
                    'chest'
                ], [
                    'nat'
                ]);
                return [
                    annotateVar({
                        prim: 'or',
                        args: [
                            {
                                prim: 'bytes'
                            },
                            {
                                prim: 'bool'
                            }
                        ]
                    }),
                    ...stack.slice(3)
                ];
            case 'VIEW':
                {
                    const s = args(0, null, [
                        'address'
                    ]);
                    ensurePushableType(s[0]);
                    return [
                        annotateVar({
                            prim: 'option',
                            args: [
                                instruction.args[1]
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'MIN_BLOCK_TIME':
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack
                ];
            case 'EMIT':
                {
                    const ia = instructionAnn({
                        f: 1,
                        t: 1
                    });
                    if (instruction.args) {
                        const s = args(0, null);
                        ensureTypesEqual(s[0], instruction.args[0]);
                        return [
                            annotate({
                                prim: 'operation'
                            }, ia),
                            ...stack.slice(1)
                        ];
                    }
                    return [
                        annotate({
                            prim: 'operation'
                        }, ia),
                        ...stack.slice(1)
                    ];
                }
            default:
                throw new $463f724b64570f1c$export$61ae7f08643aa181(instruction, `unexpected instruction: ${instruction.prim}`);
        }
    })(instruction);
    if ((ctx === null || ctx === void 0 ? void 0 : ctx.traceCallback) !== undefined) {
        const trace = {
            op: instruction,
            in: stack,
            out: retStack
        };
        ctx.traceCallback(trace);
    }
    return retStack;
}
function $463f724b64570f1c$export$8df01cc5695a993c(contract, section) {
    for (const s of contract){
        if (s.prim === section) return s;
    }
    throw new $463f724b64570f1c$export$61ae7f08643aa181(contract, `missing contract section: ${section}`);
}
function $463f724b64570f1c$export$579f744ea06231e6(contract) {
    const views = {};
    for (const s of contract)if (s.prim === 'view') views[s.args[0].string] = s;
    return views;
}
function $463f724b64570f1c$var$isContract(v) {
    if (Array.isArray(v)) for (const s of v){
        if ('prim' in s && (s.prim === 'parameter' || s.prim === 'storage' || s.prim === 'code')) return true;
    }
    return false;
}
function $463f724b64570f1c$export$7755930f2db79bc5(src, ep) {
    ep = ep || '%default';
    const entryPoint = $463f724b64570f1c$export$d1db0bdebeb6f9c7(src).find((x)=>x[0] === ep);
    if (entryPoint !== undefined) return entryPoint[1];
    else if (ep === '%default') return $463f724b64570f1c$var$isContract(src) ? $463f724b64570f1c$export$8df01cc5695a993c(src, 'parameter').args[0] : src;
    return null;
}
function $463f724b64570f1c$var$isOrType(t) {
    return Array.isArray(t) || t.prim === 'or';
}
function $463f724b64570f1c$export$d1db0bdebeb6f9c7(src) {
    if ($463f724b64570f1c$var$isContract(src)) {
        const param = $463f724b64570f1c$export$8df01cc5695a993c(src, 'parameter');
        const ch = $463f724b64570f1c$export$d1db0bdebeb6f9c7(param.args[0]);
        const a = $463f724b64570f1c$var$unpackAnnotations(param);
        return a.f ? [
            [
                a.f[0],
                param.args[0]
            ],
            ...ch
        ] : ch;
    }
    if ($463f724b64570f1c$var$isOrType(src)) {
        const args = $463f724b64570f1c$var$typeArgs(src);
        const getArg = (n)=>{
            const a = $463f724b64570f1c$var$unpackAnnotations(args[n]);
            if ($463f724b64570f1c$var$typeID(args[n]) === 'or') {
                const ch = $463f724b64570f1c$export$d1db0bdebeb6f9c7(args[n]);
                return a.f ? [
                    [
                        a.f[0],
                        args[n]
                    ],
                    ...ch
                ] : ch;
            }
            return a.f ? [
                [
                    a.f[0],
                    args[n]
                ]
            ] : [];
        };
        return [
            ...getArg(0),
            ...getArg(1)
        ];
    }
    return [];
}
// Contract validation
function $463f724b64570f1c$export$c8575dc38549dc3a(contract, ctx) {
    const assertSection = (parameter, storage, ret, code)=>{
        $463f724b64570f1c$export$1244433858b68826(parameter, true);
        $463f724b64570f1c$export$1244433858b68826(storage);
        const arg = {
            prim: 'pair',
            args: [
                Object.assign(Object.assign({}, parameter), {
                    annots: [
                        '@parameter'
                    ]
                }),
                Object.assign(Object.assign({}, storage), {
                    annots: [
                        '@storage'
                    ]
                })
            ]
        };
        const out = $463f724b64570f1c$var$functionTypeInternal(code, [
            arg
        ], Object.assign(Object.assign({}, ctx), {
            contract: contract
        }));
        if ('failed' in out) return out;
        try {
            $463f724b64570f1c$var$assertStacksEqual(out, [
                ret
            ]);
        } catch (err) {
            if (err instanceof $463f724b64570f1c$export$61ae7f08643aa181) throw new $463f724b64570f1c$export$4077f6a2bcdec605(code, out, err.message);
            else throw err;
        }
        return out;
    };
    const parameter = $463f724b64570f1c$export$8df01cc5695a993c(contract, 'parameter').args[0];
    const storage = $463f724b64570f1c$export$8df01cc5695a993c(contract, 'storage').args[0];
    const code = $463f724b64570f1c$export$8df01cc5695a993c(contract, 'code').args[0];
    const expected = {
        prim: 'pair',
        args: [
            {
                prim: 'list',
                args: [
                    {
                        prim: 'operation'
                    }
                ]
            },
            storage
        ]
    };
    const ret = assertSection(parameter, storage, expected, code);
    for (const view of Object.values($463f724b64570f1c$export$579f744ea06231e6(contract)))assertSection(view.args[1], storage, view.args[2], view.args[3]);
    return ret;
}
// Exported wrapper functions
function $463f724b64570f1c$export$bfa000df77e731bb(d, t, ctx) {
    $463f724b64570f1c$export$1244433858b68826(t);
    $463f724b64570f1c$var$assertDataValidInternal(d, t, ctx || null);
}
function $463f724b64570f1c$export$6c6e04233ab45653(inst, stack, ctx) {
    for (const t of stack)$463f724b64570f1c$export$1244433858b68826(t);
    if ((ctx === null || ctx === void 0 ? void 0 : ctx.contract) !== undefined) for (const typesec of [
        'parameter',
        'storage'
    ]){
        const sec = $463f724b64570f1c$export$8df01cc5695a993c(ctx.contract, typesec).args[0];
        $463f724b64570f1c$export$1244433858b68826(sec);
    }
    return $463f724b64570f1c$var$functionTypeInternal(inst, stack, ctx || null);
}
function $463f724b64570f1c$export$9a1889dd325b72ec(a, b, field = false) {
    if (Array.isArray(a)) {
        // type guards don't work for parametrized generic types
        for (const v of a)$463f724b64570f1c$export$1244433858b68826(v);
        for (const v of b)$463f724b64570f1c$export$1244433858b68826(v);
    } else {
        $463f724b64570f1c$export$1244433858b68826(a);
        $463f724b64570f1c$export$1244433858b68826(b);
    }
    $463f724b64570f1c$var$assertScalarTypesEqual(a, b, field);
}
function $463f724b64570f1c$export$ffb78e2356513436(t, field = false) {
    try {
        $463f724b64570f1c$export$1244433858b68826(t, field);
        return true;
    } catch (_a) {
        return false;
    }
}
function $463f724b64570f1c$export$934c96dee53ab2da(contract, ctx) {
    try {
        return $463f724b64570f1c$export$c8575dc38549dc3a(contract, ctx);
    } catch (_a) {
        return null;
    }
}
function $463f724b64570f1c$export$29c430453b4c95e0(d, t, ctx) {
    try {
        $463f724b64570f1c$export$bfa000df77e731bb(d, t, ctx);
        return true;
    } catch (_a) {
        return false;
    }
}
function $463f724b64570f1c$export$3b6f3791234881ee(a, b, field = false) {
    try {
        $463f724b64570f1c$export$9a1889dd325b72ec(a, b, field);
        return true;
    } catch (_a) {
        return false;
    }
}
class $463f724b64570f1c$export$8517d80acf00e19a {
    constructor(contract, opt){
        this.contract = contract;
        this.ctx = Object.assign({
            contract: contract
        }, opt);
        this.output = $463f724b64570f1c$export$c8575dc38549dc3a(contract, this.ctx);
    }
    static parse(src, opt) {
        const p = new $463f724b64570f1c$export$7acfa6ed01010e37(opt);
        const expr = typeof src === 'string' ? p.parseScript(src) : p.parseJSON(src);
        if (expr === null) throw new $463f724b64570f1c$var$InvalidMichelsonError('empty Michelson');
        if ($463f724b64570f1c$export$ac03cc731bd7a006(expr)) return new $463f724b64570f1c$export$8517d80acf00e19a(expr, opt);
    }
    static parseTypeExpression(src, opt) {
        const p = new $463f724b64570f1c$export$7acfa6ed01010e37(opt);
        const expr = typeof src === 'string' ? p.parseScript(src) : p.parseJSON(src);
        if (expr === null) throw new $463f724b64570f1c$var$InvalidTypeExpressionError('empty type expression');
        // remove assertTypeAnnotationsValid from if block because: () => void || throw error
        if ($463f724b64570f1c$export$176936cdb34aed2f(expr)) {
            $463f724b64570f1c$export$1244433858b68826(expr);
            return expr;
        }
    }
    static parseDataExpression(src, opt) {
        const p = new $463f724b64570f1c$export$7acfa6ed01010e37(opt);
        const expr = typeof src === 'string' ? p.parseScript(src) : p.parseJSON(src);
        if (expr === null) throw new $463f724b64570f1c$var$InvalidDataExpressionError('empty data expression');
        if ($463f724b64570f1c$export$3cc4ed4ae67ac731(expr)) return expr;
        throw undefined;
    }
    section(section) {
        return $463f724b64570f1c$export$8df01cc5695a993c(this.contract, section);
    }
    entryPoints() {
        return $463f724b64570f1c$export$d1db0bdebeb6f9c7(this.contract);
    }
    entryPoint(ep) {
        return $463f724b64570f1c$export$7755930f2db79bc5(this.contract, ep);
    }
    assertDataValid(d, t) {
        $463f724b64570f1c$export$bfa000df77e731bb(d, t, this.ctx);
    }
    isDataValid(d, t) {
        return $463f724b64570f1c$export$29c430453b4c95e0(d, t, this.ctx);
    }
    assertParameterValid(ep, d) {
        const t = this.entryPoint(ep || undefined);
        if (t === null) throw new $463f724b64570f1c$var$InvalidEntrypointError(ep === null || ep === void 0 ? void 0 : ep.toString());
        this.assertDataValid(d, t);
    }
    isParameterValid(ep, d) {
        try {
            this.assertParameterValid(ep, d);
            return true;
        } catch (_a) {
            return false;
        }
    }
    functionType(inst, stack) {
        return $463f724b64570f1c$export$6c6e04233ab45653(inst, stack, this.ctx);
    }
}
// TODO: dummyContract not used anywhere in the codebase can be deleted?
const $463f724b64570f1c$export$29db4a2abc9c69d0 = new $463f724b64570f1c$export$8517d80acf00e19a([
    {
        prim: 'parameter',
        args: [
            {
                prim: 'unit'
            }
        ]
    },
    {
        prim: 'storage',
        args: [
            {
                prim: 'unit'
            }
        ]
    },
    {
        prim: 'code',
        args: [
            [
                {
                    prim: 'CAR'
                },
                {
                    prim: 'NIL',
                    args: [
                        {
                            prim: 'operation'
                        }
                    ]
                },
                {
                    prim: 'PAIR'
                }
            ]
        ]
    }
]);
function $463f724b64570f1c$export$e494c4e6706dd74d(s) {
    if ('failed' in s) return `[FAILED: ${$463f724b64570f1c$export$613fc3a7f2c0f56c(s.failed)}]`;
    return s.map((v, i)=>{
        const ann = $463f724b64570f1c$var$unpackAnnotations(v);
        return `[${i}${ann.v ? '/' + ann.v[0] : ''}]: ${$463f724b64570f1c$export$613fc3a7f2c0f56c(v)}`;
    }).join('\n');
}
function $463f724b64570f1c$export$7bac1955562dedc2(blocks, cb) {
    return (v)=>{
        var _a;
        if (Array.isArray(v) && !blocks) return;
        const macro = (_a = v.op[$463f724b64570f1c$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.macro;
        const msg = `${macro ? 'Macro' : 'Op'}: ${macro ? $463f724b64570f1c$export$613fc3a7f2c0f56c(macro, undefined, true) + ' / ' : ''}${$463f724b64570f1c$export$613fc3a7f2c0f56c(v.op)}
Input:
${$463f724b64570f1c$export$e494c4e6706dd74d(v.in)}
Output:
${$463f724b64570f1c$export$e494c4e6706dd74d(v.out)}
`;
        cb(msg);
    };
}
function $463f724b64570f1c$export$7b5b869ee98c16ab(err) {
    var _a;
    if (err instanceof $463f724b64570f1c$export$4077f6a2bcdec605) {
        const macro = (_a = err.val[$463f724b64570f1c$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.macro;
        return `${macro ? 'Macro' : 'Op'}: ${macro ? $463f724b64570f1c$export$613fc3a7f2c0f56c(macro, undefined, true) + ' / ' : ''}${$463f724b64570f1c$export$613fc3a7f2c0f56c(err.val)}
Stack:
${$463f724b64570f1c$export$e494c4e6706dd74d(err.stackState)}
`;
    } else if (err instanceof $463f724b64570f1c$export$c9afdd965e51c08a) {
        const type = Array.isArray(err.val) ? '[' + err.val.map((v, i)=>`[${i}]: ${$463f724b64570f1c$export$613fc3a7f2c0f56c(v)}`).join('; ') + ']' : $463f724b64570f1c$export$613fc3a7f2c0f56c(err.val);
        return `Type: ${type}
${err.data ? `Data: ${$463f724b64570f1c$export$613fc3a7f2c0f56c(err.data)}
` : ''}
`;
    } else return `Value: ${$463f724b64570f1c$export$613fc3a7f2c0f56c(err.val)}`;
}
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $463f724b64570f1c$export$a4ad2735b021c132 = {
    "commitHash": "2e05f6f865be17a1b367b284542b24ffa9823271",
    "version": "19.2.1"
};






var $6ZWSX = parcelRequire("6ZWSX");
var $2c9dd9fad62b5317$require$Buffer = $6ZWSX.Buffer;
const $2c9dd9fad62b5317$var$toHexString = (bytes)=>bytes.reduce((str, byte)=>str + byte.toString(16).padStart(2, '0'), '');
const $2c9dd9fad62b5317$var$pad = (num, paddingLen = 8)=>{
    return num.toString(16).padStart(paddingLen, '0');
};
/*
 * Some code in this file is originally from sotez
 * Copyright (c) 2018 Andrew Kishino
 */ // See: https://tezos.gitlab.io/protocols/005_babylon.html#transactions-now-have-an-entrypoint
const $2c9dd9fad62b5317$var$ENTRYPOINT_MAX_LENGTH = 31;
var $2c9dd9fad62b5317$export$9a139b626817ea5b;
(function(CODEC) {
    CODEC["SECRET"] = "secret";
    CODEC["RAW"] = "raw";
    CODEC["TZ1"] = "tz1";
    CODEC["BRANCH"] = "branch";
    CODEC["ZARITH"] = "zarith";
    CODEC["PUBLIC_KEY"] = "public_key";
    CODEC["PKH"] = "pkh";
    CODEC["PKH_ARR"] = "pkhArr";
    CODEC["DELEGATE"] = "delegate";
    CODEC["SCRIPT"] = "script";
    CODEC["BALLOT_STATEMENT"] = "ballotStmt";
    CODEC["PROPOSAL"] = "proposal";
    CODEC["PROPOSAL_ARR"] = "proposalArr";
    CODEC["INT32"] = "int32";
    CODEC["INT16"] = "int16";
    CODEC["PARAMETERS"] = "parameters";
    CODEC["ADDRESS"] = "address";
    CODEC["SMART_CONTRACT_ADDRESS"] = "smart_contract_address";
    CODEC["SMART_ROLLUP_ADDRESS"] = "smart_rollup_address";
    CODEC["SMART_ROLLUP_COMMITMENT_HASH"] = "smart_rollup_commitment_hash";
    CODEC["VALUE"] = "value";
    CODEC["PADDED_BYTES"] = "padded_bytes";
    CODEC["SMART_ROLLUP_MESSAGE"] = "smart_rollup_message";
    CODEC["MANAGER"] = "manager";
    CODEC["BLOCK_PAYLOAD_HASH"] = "blockPayloadHash";
    CODEC["ENTRYPOINT"] = "entrypoint";
    CODEC["OPERATION"] = "operation";
    CODEC["OP_ACTIVATE_ACCOUNT"] = "activate_account";
    CODEC["OP_DELEGATION"] = "delegation";
    CODEC["OP_TRANSACTION"] = "transaction";
    CODEC["OP_ORIGINATION"] = "origination";
    CODEC["OP_BALLOT"] = "ballot";
    CODEC["OP_FAILING_NOOP"] = "failing_noop";
    CODEC["OP_ATTESTATION"] = "attestation";
    CODEC["OP_ENDORSEMENT"] = "endorsement";
    CODEC["OP_SEED_NONCE_REVELATION"] = "seed_nonce_revelation";
    CODEC["OP_REVEAL"] = "reveal";
    CODEC["OP_PROPOSALS"] = "proposals";
    CODEC["OP_REGISTER_GLOBAL_CONSTANT"] = "register_global_constant";
    CODEC["OP_TRANSFER_TICKET"] = "transfer_ticket";
    CODEC["BURN_LIMIT"] = "burn_limit";
    CODEC["OP_INCREASE_PAID_STORAGE"] = "increase_paid_storage";
    CODEC["OP_UPDATE_CONSENSUS_KEY"] = "update_consensus_key";
    CODEC["OP_DRAIN_DELEGATE"] = "drain_delegate";
    CODEC["DEPOSITS_LIMIT"] = "deposits_limit";
    CODEC["OP_SET_DEPOSITS_LIMIT"] = "set_deposits_limit";
    CODEC["OP_SMART_ROLLUP_ORIGINATE"] = "smart_rollup_originate";
    CODEC["PVM_KIND"] = "pvm_kind";
    CODEC["OP_SMART_ROLLUP_ADD_MESSAGES"] = "smart_rollup_add_messages";
    CODEC["OP_SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE"] = "smart_rollup_execute_outbox_message";
})($2c9dd9fad62b5317$export$9a139b626817ea5b || ($2c9dd9fad62b5317$export$9a139b626817ea5b = {}));
// See https://tezos.gitlab.io/whitedoc/michelson.html#full-grammar
const $2c9dd9fad62b5317$export$db07a1141a5b36ad = {
    '00': 'parameter',
    '01': 'storage',
    '02': 'code',
    '03': 'False',
    '04': 'Elt',
    '05': 'Left',
    '06': 'None',
    '07': 'Pair',
    '08': 'Right',
    '09': 'Some',
    '0a': 'True',
    '0b': 'Unit',
    '0c': 'PACK',
    '0d': 'UNPACK',
    '0e': 'BLAKE2B',
    '0f': 'SHA256',
    '10': 'SHA512',
    '11': 'ABS',
    '12': 'ADD',
    '13': 'AMOUNT',
    '14': 'AND',
    '15': 'BALANCE',
    '16': 'CAR',
    '17': 'CDR',
    '18': 'CHECK_SIGNATURE',
    '19': 'COMPARE',
    '1a': 'CONCAT',
    '1b': 'CONS',
    '1c': 'CREATE_ACCOUNT',
    '1d': 'CREATE_CONTRACT',
    '1e': 'IMPLICIT_ACCOUNT',
    '1f': 'DIP',
    '20': 'DROP',
    '21': 'DUP',
    '22': 'EDIV',
    '23': 'EMPTY_MAP',
    '24': 'EMPTY_SET',
    '25': 'EQ',
    '26': 'EXEC',
    '27': 'FAILWITH',
    '28': 'GE',
    '29': 'GET',
    '2a': 'GT',
    '2b': 'HASH_KEY',
    '2c': 'IF',
    '2d': 'IF_CONS',
    '2e': 'IF_LEFT',
    '2f': 'IF_NONE',
    '30': 'INT',
    '31': 'LAMBDA',
    '32': 'LE',
    '33': 'LEFT',
    '34': 'LOOP',
    '35': 'LSL',
    '36': 'LSR',
    '37': 'LT',
    '38': 'MAP',
    '39': 'MEM',
    '3a': 'MUL',
    '3b': 'NEG',
    '3c': 'NEQ',
    '3d': 'NIL',
    '3e': 'NONE',
    '3f': 'NOT',
    '40': 'NOW',
    '41': 'OR',
    '42': 'PAIR',
    '43': 'PUSH',
    '44': 'RIGHT',
    '45': 'SIZE',
    '46': 'SOME',
    '47': 'SOURCE',
    '48': 'SENDER',
    '49': 'SELF',
    '4a': 'STEPS_TO_QUOTA',
    '4b': 'SUB',
    '4c': 'SWAP',
    '4d': 'TRANSFER_TOKENS',
    '4e': 'SET_DELEGATE',
    '4f': 'UNIT',
    '50': 'UPDATE',
    '51': 'XOR',
    '52': 'ITER',
    '53': 'LOOP_LEFT',
    '54': 'ADDRESS',
    '55': 'CONTRACT',
    '56': 'ISNAT',
    '57': 'CAST',
    '58': 'RENAME',
    '59': 'bool',
    '5a': 'contract',
    '5b': 'int',
    '5c': 'key',
    '5d': 'key_hash',
    '5e': 'lambda',
    '5f': 'list',
    '60': 'map',
    '61': 'big_map',
    '62': 'nat',
    '63': 'option',
    '64': 'or',
    '65': 'pair',
    '66': 'set',
    '67': 'signature',
    '68': 'string',
    '69': 'bytes',
    '6a': 'mutez',
    '6b': 'timestamp',
    '6c': 'unit',
    '6d': 'operation',
    '6e': 'address',
    '6f': 'SLICE',
    '70': 'DIG',
    '71': 'DUG',
    '72': 'EMPTY_BIG_MAP',
    '73': 'APPLY',
    '74': 'chain_id',
    '75': 'CHAIN_ID',
    '76': 'LEVEL',
    '77': 'SELF_ADDRESS',
    '78': 'never',
    '79': 'NEVER',
    '7a': 'UNPAIR',
    '7b': 'VOTING_POWER',
    '7c': 'TOTAL_VOTING_POWER',
    '7d': 'KECCAK',
    '7e': 'SHA3',
    '7f': 'PAIRING_CHECK',
    '80': 'bls12_381_g1',
    '81': 'bls12_381_g2',
    '82': 'bls12_381_fr',
    '83': 'sapling_state',
    '84': 'sapling_transaction_deprecated',
    '85': 'SAPLING_EMPTY_STATE',
    '86': 'SAPLING_VERIFY_UPDATE',
    '87': 'ticket',
    '88': 'TICKET_DEPRECATED',
    '89': 'READ_TICKET',
    '8a': 'SPLIT_TICKET',
    '8b': 'JOIN_TICKETS',
    '8c': 'GET_AND_UPDATE',
    '8d': 'chest',
    '8e': 'chest_key',
    '8f': 'OPEN_CHEST',
    '90': 'VIEW',
    '91': 'view',
    '92': 'constant',
    '93': 'SUB_MUTEZ',
    '94': 'tx_rollup_l2_address',
    '95': 'MIN_BLOCK_TIME',
    '96': 'sapling_transaction',
    '97': 'EMIT',
    '98': 'Lambda_rec',
    '99': 'LAMBDA_REC',
    '9a': 'TICKET',
    '9b': 'BYTES',
    '9c': 'NAT'
};
const $2c9dd9fad62b5317$export$dc55b1858372fe66 = (()=>{
    const result = {};
    Object.keys($2c9dd9fad62b5317$export$db07a1141a5b36ad).forEach((key)=>{
        result[$2c9dd9fad62b5317$export$db07a1141a5b36ad[key]] = key;
    });
    return result;
})();
// See https://tezos.gitlab.io/shell/p2p_api.html?highlight=p2p
const $2c9dd9fad62b5317$var$kindMapping = {
    0x04: 'activate_account',
    0x6b: 'reveal',
    0x6e: 'delegation',
    0x6c: 'transaction',
    0x6d: 'origination',
    0x06: 'ballot',
    0x15: 'attestation',
    0x01: 'seed_nonce_revelation',
    0x05: 'proposals',
    0x6f: 'register_global_constant',
    0x9e: 'transfer_ticket',
    0x70: 'set_deposits_limit',
    0x71: 'increase_paid_storage',
    0x72: 'update_consensus_key',
    0x09: 'drain_delegate',
    0xc8: 'smart_rollup_originate',
    0xc9: 'smart_rollup_add_messages',
    0xce: 'smart_rollup_execute_outbox_message',
    0x11: 'failing_noop'
};
const $2c9dd9fad62b5317$var$kindMappingReverse = (()=>{
    const result = {};
    Object.keys($2c9dd9fad62b5317$var$kindMapping).forEach((key)=>{
        const keyNum = typeof key === 'string' ? parseInt(key, 10) : key;
        result[$2c9dd9fad62b5317$var$kindMapping[keyNum]] = $2c9dd9fad62b5317$var$pad(keyNum, 2);
    });
    return result;
})();
// See https://tezos.gitlab.io/protocols/005_babylon.html#transactions-now-have-an-entrypoint
const $2c9dd9fad62b5317$var$entrypointMapping = {
    '00': 'default',
    '01': 'root',
    '02': 'do',
    '03': 'set_delegate',
    '04': 'remove_delegate',
    '05': 'deposit',
    '06': 'stake',
    '07': 'unstake',
    '08': 'finalize_unstake',
    '09': 'set_delegate_parameters'
};
const $2c9dd9fad62b5317$var$entrypointMappingReverse = (()=>{
    const result = {};
    Object.keys($2c9dd9fad62b5317$var$entrypointMapping).forEach((key)=>{
        result[$2c9dd9fad62b5317$var$entrypointMapping[key]] = key;
    });
    return result;
})();
/**
 *  @category Error
 *  @description Error that indicates an invalid operation content being passed or used
 */ class $2c9dd9fad62b5317$var$InvalidOperationSchemaError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(operation, errorDetail){
        super();
        this.operation = operation;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationSchemaError';
        this.message = `Invalid operation content recevied`;
        errorDetail && (this.message += ` ${errorDetail}.`);
    }
}
/**
 *  @category Error
 *  @description Error that indicates an entrypoint name exceeding maximum length
 */ class $2c9dd9fad62b5317$var$OversizedEntryPointError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(entrypoint){
        super();
        this.entrypoint = entrypoint;
        this.name = 'OversizedEntryPointError';
        this.message = `Invalid entrypoint length "${entrypoint.length}", maximum length is "${$2c9dd9fad62b5317$var$ENTRYPOINT_MAX_LENGTH}".`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid ballot value being used
 */ class $2c9dd9fad62b5317$var$InvalidBallotValueError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(ballotValue){
        super();
        this.ballotValue = ballotValue;
        this.name = 'InvalidBallotValueError';
        this.message = `Invalid ballot value "${ballotValue}" expecting one of the following: "yay", "nay", "pass".`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when trying to decode ballot value
 */ class $2c9dd9fad62b5317$var$DecodeBallotValueError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(ballotValue){
        super();
        this.ballotValue = ballotValue;
        this.name = 'DecodeBallotValueError';
        this.message = `Invalid ballot value "${ballotValue}", cannot be decoded.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates unexpected Michelson Value being passed or used
 */ class $2c9dd9fad62b5317$var$UnexpectedMichelsonValueError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(value){
        super();
        this.value = value;
        this.name = 'UnexpectedMichelsonValueError';
        this.message = `Invalid Michelson value "${value}", unalbe to encode.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when trying to decode an operation
 */ class $2c9dd9fad62b5317$var$OperationDecodingError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'OperationDecodingError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when trying to encode an operation
 */ class $2c9dd9fad62b5317$var$OperationEncodingError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'OperationEncodingError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an unsupported operation being passed or used
 */ class $2c9dd9fad62b5317$var$UnsupportedOperationError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(op){
        super();
        this.op = op;
        this.name = 'UnsupportedOperationError';
        this.message = `Unsupported operation "${op}", can submit an issue on our github for feature request.`;
    }
}
/**
 * @cateogry Error
 * @description Error that indicates an unsupported pvm being passed or used
 */ class $2c9dd9fad62b5317$var$UnsupportedPvmKindError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(pvm){
        super();
        this.pvm = pvm;
        this.name = 'UnsupportedPvmKindError';
        this.message = `Invalid Pvm kind "${pvm}" expecting either "arith" or "wasm_2_0_0".`;
    }
}
/**
 * @category Error
 * @description Error that indicates an unsupported pvm to decode
 */ class $2c9dd9fad62b5317$var$DecodePvmKindError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(pvm){
        super();
        this.pvm = pvm;
        this.name = 'DecodePvmKindError';
        this.message = `Invalid Pvm kind "${pvm}", cannot be decoded.`;
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid Smart Rollup Address (sr1)
 */ class $2c9dd9fad62b5317$var$InvalidSmartRollupAddressError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSmartRollupAddress';
        this.message = `Invalid smart rollup address "${address}"`;
        errorDetail && (this.message += ` ${errorDetail}.`);
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid Smart Rollup commitment hash (src1)
 */ class $2c9dd9fad62b5317$var$InvalidSmartRollupCommitmentHashError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(hash, errorDetail){
        super();
        this.hash = hash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSmartRollupCommitmentHashError';
        this.message = `Invalid smart rollup commitment hash "${hash}"`;
        errorDetail && (this.message += ` ${errorDetail}.`);
    }
}
class $2c9dd9fad62b5317$export$2ea09c189c142295 {
    static fromHexString(hex) {
        const lowHex = hex.toLowerCase();
        if (/^(([a-f]|\d){2})*$/.test(lowHex)) {
            const arr = new Uint8Array((lowHex.match(/([a-z]|\d){2}/g) || []).map((byte)=>parseInt(byte, 16)));
            return new $2c9dd9fad62b5317$export$2ea09c189c142295(arr);
        } else throw new (0, $8b6476b09e20f53e$export$1888d6928c74d5ee)(lowHex);
    }
    constructor(arr, offset = 0){
        this.arr = arr;
        this.offset = offset;
    }
    consume(count) {
        const subArr = this.arr.subarray(this.offset, this.offset + count);
        this.offset += count;
        return subArr;
    }
    get(idx) {
        return this.arr[this.offset + idx];
    }
    length() {
        return this.arr.length - this.offset;
    }
    slice(start, end) {
        return new $2c9dd9fad62b5317$export$2ea09c189c142295(this.arr.slice(start, end));
    }
}
const $2c9dd9fad62b5317$var$isPrim = (value)=>{
    return 'prim' in value;
};
const $2c9dd9fad62b5317$var$isBytes = (value)=>{
    return 'bytes' in value && typeof value.bytes === 'string';
};
const $2c9dd9fad62b5317$var$isString = (value)=>{
    return 'string' in value && typeof value.string === 'string';
};
const $2c9dd9fad62b5317$var$isInt = (value)=>{
    return 'int' in value && typeof value.int === 'string';
};
const $2c9dd9fad62b5317$var$scriptEncoder = (script)=>{
    const code = $2c9dd9fad62b5317$var$valueEncoder(script.code);
    const storage = $2c9dd9fad62b5317$var$valueEncoder(script.storage);
    return `${$2c9dd9fad62b5317$var$pad(code.length / 2, 8)}${code}${$2c9dd9fad62b5317$var$pad(storage.length / 2, 8)}${storage}`;
};
const $2c9dd9fad62b5317$var$scriptDecoder = (value)=>{
    const code = $2c9dd9fad62b5317$var$extractRequiredLen(value);
    const storage = $2c9dd9fad62b5317$var$extractRequiredLen(value);
    return {
        code: $2c9dd9fad62b5317$var$valueDecoder(new $2c9dd9fad62b5317$export$2ea09c189c142295(code)),
        storage: $2c9dd9fad62b5317$var$valueDecoder(new $2c9dd9fad62b5317$export$2ea09c189c142295(storage))
    };
};
const $2c9dd9fad62b5317$var$valueEncoder = (value)=>{
    if (Array.isArray(value)) {
        const encoded = value.map((x)=>$2c9dd9fad62b5317$var$valueEncoder(x)).join('');
        const len = encoded.length / 2;
        return `02${$2c9dd9fad62b5317$var$pad(len)}${encoded}`;
    } else if ($2c9dd9fad62b5317$var$isPrim(value)) return $2c9dd9fad62b5317$var$primEncoder(value);
    else if ($2c9dd9fad62b5317$var$isBytes(value)) return $2c9dd9fad62b5317$var$bytesEncoder(value);
    else if ($2c9dd9fad62b5317$var$isString(value)) return $2c9dd9fad62b5317$var$stringEncoder(value);
    else if ($2c9dd9fad62b5317$var$isInt(value)) return $2c9dd9fad62b5317$var$intEncoder(value);
    throw new $2c9dd9fad62b5317$var$UnexpectedMichelsonValueError(JSON.stringify(value));
};
const $2c9dd9fad62b5317$var$valueDecoder = (value)=>{
    const preamble = value.consume(1);
    switch(preamble[0]){
        case 0x0a:
            return $2c9dd9fad62b5317$var$bytesDecoder(value);
        case 0x01:
            return $2c9dd9fad62b5317$var$stringDecoder(value);
        case 0x00:
            return $2c9dd9fad62b5317$var$intDecoder(value);
        case 0x02:
            {
                const val = new $2c9dd9fad62b5317$export$2ea09c189c142295($2c9dd9fad62b5317$var$extractRequiredLen(value));
                const results = [];
                while(val.length() > 0)results.push($2c9dd9fad62b5317$var$valueDecoder(val));
                return results;
            }
        default:
            return $2c9dd9fad62b5317$var$primDecoder(value, preamble);
    }
};
const $2c9dd9fad62b5317$var$extractRequiredLen = (value, bytesLength = 4)=>{
    const len = value.consume(bytesLength);
    const valueLen = parseInt($2c9dd9fad62b5317$require$Buffer.from(len).toString('hex'), 16);
    return value.consume(valueLen);
};
/**
 * @description parse bytes into multiple items of an array
 * @param value Uint8ArrayConsumer class of forged segment to parse
 * @param bytesLength default 4 bytes for length of variable bytes
 * @returns array of Uint8Array values for each array item
 */ const $2c9dd9fad62b5317$var$stripLengthPrefixFromBytes = (value, bytesLength = 4)=>{
    const ret = [];
    let values = value;
    while(values.length()){
        const len = values.consume(bytesLength);
        const valueLen = parseInt($2c9dd9fad62b5317$require$Buffer.from(len).toString('hex'), 16);
        ret.push(values.consume(valueLen));
        values = values.slice(valueLen + bytesLength);
    }
    return ret;
};
const $2c9dd9fad62b5317$var$bytesEncoder = (value)=>{
    if (!/^([A-Fa-f0-9]{2})*$/.test(value.bytes)) throw new (0, $8b6476b09e20f53e$export$1888d6928c74d5ee)(value.bytes);
    const len = value.bytes.length / 2;
    return `0a${$2c9dd9fad62b5317$var$pad(len)}${value.bytes}`;
};
const $2c9dd9fad62b5317$var$bytesDecoder = (value)=>{
    const bytes = $2c9dd9fad62b5317$var$extractRequiredLen(value);
    return {
        bytes: $2c9dd9fad62b5317$require$Buffer.from(bytes).toString('hex')
    };
};
const $2c9dd9fad62b5317$var$stringEncoder = (value)=>{
    const str = $2c9dd9fad62b5317$require$Buffer.from(value.string, 'utf8').toString('hex');
    const hexLength = str.length / 2;
    return `01${$2c9dd9fad62b5317$var$pad(hexLength)}${str}`;
};
const $2c9dd9fad62b5317$var$stringDecoder = (value)=>{
    const str = $2c9dd9fad62b5317$var$extractRequiredLen(value);
    return {
        string: $2c9dd9fad62b5317$require$Buffer.from(str).toString('utf8')
    };
};
const $2c9dd9fad62b5317$var$intEncoder = ({ int: int })=>{
    const num = new (0, $42f5864281cc433e$exports.BigNumber)(int, 10);
    const positiveMark = num.toString(2)[0] === '-' ? '1' : '0';
    const binary = num.toString(2).replace(/-/g, '');
    const pad = binary.length <= 6 ? 6 : (binary.length - 6) % 7 ? binary.length + 7 - (binary.length - 6) % 7 : binary.length;
    const splitted = binary.padStart(pad, '0').match(/\d{6,7}/g);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const reversed = splitted.reverse();
    reversed[0] = positiveMark + reversed[0];
    const numHex = reversed.map((x, i)=>// Add one to the last chunk
        parseInt((i === reversed.length - 1 ? '0' : '1') + x, 2).toString(16).padStart(2, '0'));
    return `00${numHex.join('')}`;
};
const $2c9dd9fad62b5317$var$intDecoder = (value)=>{
    let c = value.consume(1)[0];
    const hexNumber = [];
    const isNotLastChunkMask = 128;
    while(c & isNotLastChunkMask){
        hexNumber.push(c);
        c = value.consume(1)[0];
    }
    hexNumber.push(c);
    const isNegative = !!(64 & hexNumber[0]);
    hexNumber[0] = hexNumber[0] & 127;
    const numBin = hexNumber.map((x, i)=>x.toString(2).slice(i === 0 ? -6 : -7).padStart(i === 0 ? 6 : 7, '0')).reverse();
    let num = new (0, $42f5864281cc433e$exports.BigNumber)(numBin.join(''), 2);
    if (isNegative) num = num.times(-1);
    return {
        int: num.toFixed()
    };
};
const $2c9dd9fad62b5317$var$primEncoder = (value)=>{
    const hasAnnot = +Array.isArray(value.annots);
    const argsCount = Array.isArray(value.args) ? value.args.length : 0;
    // Specify the number of args max is 3 without annotation
    const preamble = $2c9dd9fad62b5317$var$pad(Math.min(2 * argsCount + hasAnnot + 0x03, 9), 2);
    const op = $2c9dd9fad62b5317$export$dc55b1858372fe66[value.prim];
    let encodedArgs = (value.args || []).map((arg)=>$2c9dd9fad62b5317$var$valueEncoder(arg)).join('');
    const encodedAnnots = Array.isArray(value.annots) ? $2c9dd9fad62b5317$var$encodeAnnots(value.annots) : '';
    if ((value.prim === 'LAMBDA' || value.prim === 'LAMBDA_REC') && argsCount) encodedArgs = $2c9dd9fad62b5317$var$pad(encodedArgs.length / 2) + encodedArgs + $2c9dd9fad62b5317$var$pad(0);
    if ((value.prim === 'pair' || value.prim === 'Pair') && argsCount > 2) encodedArgs = encodedAnnots === '' ? $2c9dd9fad62b5317$var$pad(encodedArgs.length / 2) + encodedArgs + $2c9dd9fad62b5317$var$pad(0) : $2c9dd9fad62b5317$var$pad(encodedArgs.length / 2) + encodedArgs;
    if (value.prim === 'view' && value.args) encodedArgs = $2c9dd9fad62b5317$var$pad(encodedArgs.length / 2) + encodedArgs + $2c9dd9fad62b5317$var$pad(0);
    return `${preamble}${op}${encodedArgs}${encodedAnnots}`;
};
const $2c9dd9fad62b5317$var$primDecoder = (value, preamble)=>{
    const hasAnnot = (preamble[0] - 0x03) % 2 === 1;
    let argsCount = Math.floor((preamble[0] - 0x03) / 2);
    const op = value.consume(1)[0].toString(16).padStart(2, '0');
    const result = {
        prim: $2c9dd9fad62b5317$export$db07a1141a5b36ad[op]
    };
    if ($2c9dd9fad62b5317$export$db07a1141a5b36ad[op] === 'LAMBDA' || $2c9dd9fad62b5317$export$db07a1141a5b36ad[op] === 'LAMBDA_REC') value.consume(4);
    if ($2c9dd9fad62b5317$export$db07a1141a5b36ad[op] === 'view') {
        if (argsCount != 0) return $2c9dd9fad62b5317$var$primViewDecoder(value, result);
        else return result;
    }
    let combPairArgs;
    let combPairAnnots;
    if (($2c9dd9fad62b5317$export$db07a1141a5b36ad[op] === 'pair' || $2c9dd9fad62b5317$export$db07a1141a5b36ad[op] === 'Pair') && argsCount > 2) {
        combPairArgs = $2c9dd9fad62b5317$var$decodeCombPair(value);
        argsCount = 0;
        combPairAnnots = $2c9dd9fad62b5317$var$decodeAnnots(value);
    }
    const args = new Array(argsCount).fill(0).map(()=>$2c9dd9fad62b5317$var$valueDecoder(value));
    if ($2c9dd9fad62b5317$export$db07a1141a5b36ad[op] === 'LAMBDA' || $2c9dd9fad62b5317$export$db07a1141a5b36ad[op] === 'LAMBDA_REC') value.consume(4);
    if (combPairArgs) result['args'] = combPairArgs;
    else if (args.length) result['args'] = args;
    if (combPairAnnots && combPairAnnots[0] !== '') result['annots'] = combPairAnnots;
    else if (hasAnnot) result['annots'] = $2c9dd9fad62b5317$var$decodeAnnots(value);
    return result;
};
const $2c9dd9fad62b5317$var$primViewDecoder = (value, result)=>{
    value.consume(4);
    result['args'] = new Array(4).fill(0).map(()=>$2c9dd9fad62b5317$var$valueDecoder(value));
    value.consume(4);
    return result;
};
const $2c9dd9fad62b5317$var$decodeCombPair = (val)=>{
    const array = new $2c9dd9fad62b5317$export$2ea09c189c142295($2c9dd9fad62b5317$var$extractRequiredLen(val));
    const args = [];
    while(array.length() > 0)args.push($2c9dd9fad62b5317$var$valueDecoder(array));
    return args;
};
const $2c9dd9fad62b5317$var$encodeAnnots = (value)=>{
    const mergedAnnot = value.map((x)=>{
        return $2c9dd9fad62b5317$require$Buffer.from(x, 'utf8').toString('hex');
    }).join('20');
    const len = mergedAnnot.length / 2;
    return `${$2c9dd9fad62b5317$var$pad(len)}${mergedAnnot}`;
};
const $2c9dd9fad62b5317$var$decodeAnnots = (val)=>{
    const len = val.consume(4);
    const annotLen = parseInt($2c9dd9fad62b5317$require$Buffer.from(len).toString('hex'), 16);
    const restOfAnnot = val.consume(annotLen);
    const restOfAnnotHex = $2c9dd9fad62b5317$require$Buffer.from(restOfAnnot).toString('hex');
    return restOfAnnotHex.split('20').map((x)=>$2c9dd9fad62b5317$require$Buffer.from(x, 'hex').toString('utf8'));
};
// https://tezos.gitlab.io/shell/p2p_api.html specifies data types and structure for forging
const $2c9dd9fad62b5317$var$prefixEncoder = (prefix$1)=>(str)=>{
        return (0, $201657d342d01b1b$export$b0491dd0626f8a03)($2c9dd9fad62b5317$require$Buffer.from((0, $201657d342d01b1b$export$b9856b5e6fd1a05f)(str, (0, $201657d342d01b1b$export$82e9f45cca5ba907)[prefix$1])));
    };
const $2c9dd9fad62b5317$var$prefixDecoder = (pre)=>(str)=>{
        const val = str.consume((0, $201657d342d01b1b$export$2a5ba4495636ee46)[pre]);
        return (0, $201657d342d01b1b$export$8ff626c40517d3d3)(val, (0, $201657d342d01b1b$export$82e9f45cca5ba907)[pre]);
    };
const $2c9dd9fad62b5317$var$tz1Decoder = $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ1);
const $2c9dd9fad62b5317$var$branchDecoder = $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).B);
const $2c9dd9fad62b5317$var$publicKeyHashDecoder = (val)=>{
    const prefix = val.consume(1);
    if (prefix[0] === 0x00) return $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ1)(val);
    else if (prefix[0] === 0x01) return $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ2)(val);
    else if (prefix[0] === 0x02) return $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ3)(val);
};
const $2c9dd9fad62b5317$var$publicKeyHashesDecoder = (val)=>{
    if (!$2c9dd9fad62b5317$var$boolDecoder(val)) return undefined;
    const publicKeyHashes = [];
    val.consume(4);
    while(val.length() > 0)publicKeyHashes.push($2c9dd9fad62b5317$var$publicKeyHashDecoder(val));
    return publicKeyHashes;
};
const $2c9dd9fad62b5317$var$branchEncoder = $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).B);
const $2c9dd9fad62b5317$var$tz1Encoder = $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ1);
const $2c9dd9fad62b5317$var$boolEncoder = (bool)=>bool ? 'ff' : '00';
const $2c9dd9fad62b5317$var$proposalEncoder = (proposal)=>{
    return $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).P)(proposal);
};
const $2c9dd9fad62b5317$var$proposalDecoder = (proposal)=>{
    return $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).P)(proposal);
};
const $2c9dd9fad62b5317$var$proposalsDecoder = (proposal)=>{
    const proposals = [];
    proposal.consume(4);
    while(proposal.length() > 0)proposals.push($2c9dd9fad62b5317$var$proposalDecoder(proposal));
    return proposals;
};
const $2c9dd9fad62b5317$var$proposalsEncoder = (proposals)=>{
    return $2c9dd9fad62b5317$var$pad(32 * proposals.length) + proposals.map((x)=>$2c9dd9fad62b5317$var$proposalEncoder(x)).join('');
};
const $2c9dd9fad62b5317$var$ballotEncoder = (ballot)=>{
    switch(ballot){
        case 'yay':
            return '00';
        case 'nay':
            return '01';
        case 'pass':
            return '02';
        default:
            throw new $2c9dd9fad62b5317$var$InvalidBallotValueError(ballot);
    }
};
const $2c9dd9fad62b5317$var$ballotDecoder = (ballot)=>{
    const value = ballot.consume(1);
    switch(value[0]){
        case 0x00:
            return 'yay';
        case 0x01:
            return 'nay';
        case 0x02:
            return 'pass';
        default:
            throw new $2c9dd9fad62b5317$var$DecodeBallotValueError(value[0].toString());
    }
};
const $2c9dd9fad62b5317$var$pvmKindEncoder = (pvm)=>{
    switch(pvm){
        case 'arith':
            return '00';
        case 'wasm_2_0_0':
            return '01';
        case 'riscv':
            return '02';
        default:
            throw new $2c9dd9fad62b5317$var$UnsupportedPvmKindError(pvm);
    }
};
const $2c9dd9fad62b5317$var$pvmKindDecoder = (pvm)=>{
    const value = pvm.consume(1);
    switch(value[0]){
        case 0x00:
            return 'arith';
        case 0x01:
            return 'wasm_2_0_0';
        case 0x02:
            return 'riscv';
        default:
            throw new $2c9dd9fad62b5317$var$DecodePvmKindError(value[0].toString());
    }
};
const $2c9dd9fad62b5317$var$delegateEncoder = (val)=>{
    if (val) return $2c9dd9fad62b5317$var$boolEncoder(true) + $2c9dd9fad62b5317$var$publicKeyHashEncoder(val);
    else return $2c9dd9fad62b5317$var$boolEncoder(false);
};
const $2c9dd9fad62b5317$var$int32Encoder = (val)=>{
    const num = parseInt(String(val), 10);
    const byte = [];
    for(let i = 0; i < 4; i++){
        const shiftBy = (4 - (i + 1)) * 8;
        byte.push((num & 0xff << shiftBy) >> shiftBy);
    }
    return $2c9dd9fad62b5317$require$Buffer.from(byte).toString('hex');
};
const $2c9dd9fad62b5317$var$int32Decoder = (val)=>{
    const num = val.consume(4);
    let finalNum = 0;
    for(let i = 0; i < num.length; i++)finalNum = finalNum | num[i] << (num.length - (i + 1)) * 8;
    return finalNum;
};
const $2c9dd9fad62b5317$var$int16Encoder = (val)=>{
    const num = parseInt(String(val), 10);
    const byte = [];
    for(let i = 0; i < 2; i++){
        const shiftBy = (2 - (i + 1)) * 8;
        byte.push((num & 0xff << shiftBy) >> shiftBy);
    }
    return $2c9dd9fad62b5317$require$Buffer.from(byte).toString('hex');
};
const $2c9dd9fad62b5317$var$int16Decoder = (val)=>{
    const num = val.consume(2);
    let finalNum = 0;
    for(let i = 0; i < num.length; i++)finalNum = finalNum | num[i] << (num.length - (i + 1)) * 8;
    return finalNum;
};
const $2c9dd9fad62b5317$var$boolDecoder = (val)=>{
    const bool = val.consume(1);
    return bool[0] === 0xff;
};
const $2c9dd9fad62b5317$var$delegateDecoder = (val)=>{
    const hasDelegate = $2c9dd9fad62b5317$var$boolDecoder(val);
    if (hasDelegate) return $2c9dd9fad62b5317$var$publicKeyHashDecoder(val);
};
const $2c9dd9fad62b5317$var$publicKeyHashEncoder = (val)=>{
    const pubkeyPrefix = val.substring(0, 3);
    switch(pubkeyPrefix){
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ1:
            return '00' + $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ1)(val);
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ2:
            return '01' + $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ2)(val);
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ3:
            return '02' + $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ3)(val);
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ4:
            return '03' + $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ4)(val);
        default:
            throw new (0, $8b6476b09e20f53e$export$a3d7df0ca9d9410c)(val, (0, $201657d342d01b1b$export$a2057601792df650)((0, $201657d342d01b1b$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting one for the following "${(0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ1}", "${(0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ2}", "${(0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ3}" or "${(0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ4}".`);
    }
};
const $2c9dd9fad62b5317$var$publicKeyHashesEncoder = (val)=>{
    if (!val) return $2c9dd9fad62b5317$var$boolEncoder(false);
    if (val.length === 0) return $2c9dd9fad62b5317$var$boolEncoder(true) + $2c9dd9fad62b5317$var$pad(0);
    const publicKeyHashes = val.reduce((prev, curr)=>{
        return prev + $2c9dd9fad62b5317$var$publicKeyHashEncoder(curr);
    }, '');
    return $2c9dd9fad62b5317$var$boolEncoder(true) + $2c9dd9fad62b5317$var$pad(publicKeyHashes.length / 2) + publicKeyHashes;
};
const $2c9dd9fad62b5317$var$publicKeyEncoder = (val)=>{
    const pubkeyPrefix = val.substring(0, 4);
    switch(pubkeyPrefix){
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).EDPK:
            return '00' + $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).EDPK)(val);
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).SPPK:
            return '01' + $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).SPPK)(val);
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).P2PK:
            return '02' + $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).P2PK)(val);
        default:
            throw new (0, $8b6476b09e20f53e$export$f675822ed489f01f)(val, (0, $201657d342d01b1b$export$a2057601792df650)((0, $201657d342d01b1b$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting one of the following '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).EDPK}', '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).SPPK}', '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).P2PK}' or '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).BLPK}'.`);
    }
};
const $2c9dd9fad62b5317$var$addressEncoder = (val)=>{
    const pubkeyPrefix = val.substring(0, 3);
    switch(pubkeyPrefix){
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ1:
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ2:
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ3:
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ4:
            return '00' + $2c9dd9fad62b5317$var$publicKeyHashEncoder(val);
        case (0, $201657d342d01b1b$export$e77cfe0b08ec163).KT1:
            return '01' + $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).KT1)(val) + '00';
        default:
            throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(val, (0, $201657d342d01b1b$export$a2057601792df650)((0, $201657d342d01b1b$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting one of the following prefix '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ1}', ${(0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ2}', '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ3}', '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).TZ4}' or '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).KT1}'.`);
    }
};
const $2c9dd9fad62b5317$var$smartRollupAddressEncoder = (val)=>{
    if (val.substring(0, 3) !== (0, $201657d342d01b1b$export$e77cfe0b08ec163).SR1) throw new $2c9dd9fad62b5317$var$InvalidSmartRollupAddressError(val, (0, $201657d342d01b1b$export$a2057601792df650)((0, $201657d342d01b1b$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).SR1}'.`);
    return $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).SR1)(val);
};
const $2c9dd9fad62b5317$var$smartContractAddressEncoder = (val)=>{
    const prefix = val.substring(0, 3);
    if (prefix === (0, $201657d342d01b1b$export$e77cfe0b08ec163).KT1) return '01' + $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).KT1)(val) + '00';
    throw new (0, $8b6476b09e20f53e$export$193774326795229b)(val, (0, $201657d342d01b1b$export$a2057601792df650)((0, $201657d342d01b1b$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).KT1}'.`);
};
const $2c9dd9fad62b5317$var$publicKeyDecoder = (val)=>{
    const preamble = val.consume(1);
    switch(preamble[0]){
        case 0x00:
            return $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).EDPK)(val);
        case 0x01:
            return $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).SPPK)(val);
        case 0x02:
            return $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).P2PK)(val);
        default:
            throw new (0, $8b6476b09e20f53e$export$f675822ed489f01f)(val.toString(), (0, $201657d342d01b1b$export$a2057601792df650)((0, $201657d342d01b1b$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED));
    }
};
const $2c9dd9fad62b5317$var$smartRollupCommitmentHashEncoder = (val)=>{
    const prefix = val.substring(0, 4);
    if (prefix === (0, $201657d342d01b1b$export$e77cfe0b08ec163).SRC1) return $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).SRC1)(val);
    throw new $2c9dd9fad62b5317$var$InvalidSmartRollupCommitmentHashError(val, (0, $201657d342d01b1b$export$a2057601792df650)((0, $201657d342d01b1b$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).SRC1}'`);
};
const $2c9dd9fad62b5317$var$addressDecoder = (val)=>{
    const preamble = val.consume(1);
    switch(preamble[0]){
        case 0x00:
            return $2c9dd9fad62b5317$var$publicKeyHashDecoder(val);
        case 0x01:
            {
                const address = $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).KT1)(val);
                val.consume(1);
                return address;
            }
        default:
            throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(val.toString(), ': Unable to decode.');
    }
};
const $2c9dd9fad62b5317$var$smartRollupAddressDecoder = (val)=>{
    const address = $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).SR1)(val);
    if (address.substring(0, 3) !== (0, $201657d342d01b1b$export$e77cfe0b08ec163).SR1) throw new $2c9dd9fad62b5317$var$InvalidSmartRollupAddressError(address, (0, $201657d342d01b1b$export$a2057601792df650)((0, $201657d342d01b1b$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).SR1}'.`);
    return address;
};
const $2c9dd9fad62b5317$var$smartContractAddressDecoder = (val)=>{
    const preamble = val.consume(1);
    if (preamble[0] === 0x01) {
        const scAddress = $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).KT1)(val);
        val.consume(1);
        return scAddress;
    }
    throw new (0, $8b6476b09e20f53e$export$193774326795229b)(val.toString(), (0, $201657d342d01b1b$export$a2057601792df650)((0, $201657d342d01b1b$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED));
};
const $2c9dd9fad62b5317$var$smartRollupCommitmentHashDecoder = (val)=>{
    const address = $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).SRC1)(val);
    if (address.substring(0, 4) !== (0, $201657d342d01b1b$export$e77cfe0b08ec163).SRC1) throw new $2c9dd9fad62b5317$var$InvalidSmartRollupCommitmentHashError(address, (0, $201657d342d01b1b$export$a2057601792df650)((0, $201657d342d01b1b$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $201657d342d01b1b$export$e77cfe0b08ec163).SRC1}'`);
    return address;
};
const $2c9dd9fad62b5317$var$zarithEncoder = (n)=>{
    const fn = [];
    let nn = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(n, 10);
    if (nn.isNaN()) throw new TypeError(`Invalid zarith number ${n}`);
    // eslint-disable-next-line no-constant-condition
    while(true)if (nn.lt(128)) {
        if (nn.lt(16)) fn.push('0');
        fn.push(nn.toString(16));
        break;
    } else {
        let b = nn.mod(128);
        nn = nn.minus(b);
        nn = nn.dividedBy(128);
        b = b.plus(128);
        fn.push(b.toString(16));
    }
    return fn.join('');
};
const $2c9dd9fad62b5317$var$zarithDecoder = (n)=>{
    let mostSignificantByte = 0;
    while(mostSignificantByte < n.length() && (n.get(mostSignificantByte) & 128) !== 0)mostSignificantByte += 1;
    let num = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    for(let i = mostSignificantByte; i >= 0; i -= 1){
        const tmp = n.get(i) & 0x7f;
        num = num.multipliedBy(128);
        num = num.plus(tmp);
    }
    n.consume(mostSignificantByte + 1);
    return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(num).toString();
};
const $2c9dd9fad62b5317$var$entrypointDecoder = (value)=>{
    const preamble = $2c9dd9fad62b5317$var$pad(value.consume(1)[0], 2);
    if (preamble in $2c9dd9fad62b5317$var$entrypointMapping) return $2c9dd9fad62b5317$var$entrypointMapping[preamble];
    else {
        const entry = $2c9dd9fad62b5317$var$extractRequiredLen(value, 1);
        const entrypoint = $2c9dd9fad62b5317$require$Buffer.from(entry).toString('utf8');
        if (entrypoint.length > $2c9dd9fad62b5317$var$ENTRYPOINT_MAX_LENGTH) throw new $2c9dd9fad62b5317$var$OversizedEntryPointError(entrypoint);
        return entrypoint;
    }
};
const $2c9dd9fad62b5317$var$parametersDecoder = (val)=>{
    const preamble = val.consume(1);
    if (preamble[0] === 0x00) return;
    else {
        const encodedEntrypoint = $2c9dd9fad62b5317$var$entrypointDecoder(val);
        const params = $2c9dd9fad62b5317$var$extractRequiredLen(val);
        const parameters = $2c9dd9fad62b5317$var$valueDecoder(new $2c9dd9fad62b5317$export$2ea09c189c142295(params));
        return {
            entrypoint: encodedEntrypoint,
            value: parameters
        };
    }
};
const $2c9dd9fad62b5317$var$entrypointEncoder = (entrypoint)=>{
    if (entrypoint in $2c9dd9fad62b5317$var$entrypointMappingReverse) return `${$2c9dd9fad62b5317$var$entrypointMappingReverse[entrypoint]}`;
    else {
        if (entrypoint.length > $2c9dd9fad62b5317$var$ENTRYPOINT_MAX_LENGTH) throw new $2c9dd9fad62b5317$var$OversizedEntryPointError(entrypoint);
        const value = {
            string: entrypoint
        };
        return `ff${$2c9dd9fad62b5317$var$valueEncoder(value).slice(8)}`;
    }
};
const $2c9dd9fad62b5317$var$parametersEncoder = (val)=>{
    if (!val || val.entrypoint === 'default' && 'prim' in val.value && val.value.prim === 'Unit') return '00';
    const encodedEntrypoint = $2c9dd9fad62b5317$var$entrypointEncoder(val.entrypoint);
    const parameters = $2c9dd9fad62b5317$var$valueEncoder(val.value);
    const length = (parameters.length / 2).toString(16).padStart(8, '0');
    return `ff${encodedEntrypoint}${length}${parameters}`;
};
const $2c9dd9fad62b5317$var$valueParameterEncoder = (value)=>{
    const valueEncoded = $2c9dd9fad62b5317$var$valueEncoder(value);
    return `${$2c9dd9fad62b5317$var$pad(valueEncoded.length / 2)}${valueEncoded}`;
};
const $2c9dd9fad62b5317$var$valueParameterDecoder = (val)=>{
    const value = $2c9dd9fad62b5317$var$extractRequiredLen(val);
    return $2c9dd9fad62b5317$var$valueDecoder(new $2c9dd9fad62b5317$export$2ea09c189c142295(value));
};
const $2c9dd9fad62b5317$var$blockPayloadHashEncoder = $2c9dd9fad62b5317$var$prefixEncoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).VH);
const $2c9dd9fad62b5317$var$blockPayloadHashDecoder = $2c9dd9fad62b5317$var$prefixDecoder((0, $201657d342d01b1b$export$e77cfe0b08ec163).VH);
const $2c9dd9fad62b5317$var$entrypointNameEncoder = (entrypoint)=>{
    const value = {
        string: entrypoint
    };
    return `${$2c9dd9fad62b5317$var$valueEncoder(value).slice(2)}`;
};
const $2c9dd9fad62b5317$var$entrypointNameDecoder = (val)=>{
    const entry = $2c9dd9fad62b5317$var$extractRequiredLen(val);
    return $2c9dd9fad62b5317$require$Buffer.from(entry).toString('utf8');
};
const $2c9dd9fad62b5317$var$burnLimitEncoder = (val)=>{
    return !val ? '00' : `ff${$2c9dd9fad62b5317$var$zarithEncoder(val)}`;
};
const $2c9dd9fad62b5317$var$burnLimitDecoder = (value)=>{
    const prefix = value.consume(1);
    if ($2c9dd9fad62b5317$require$Buffer.from(prefix).toString('hex') !== '00') return $2c9dd9fad62b5317$var$zarithDecoder(value);
};
const $2c9dd9fad62b5317$var$depositsLimitEncoder = (val)=>{
    return !val ? '00' : `ff${$2c9dd9fad62b5317$var$zarithEncoder(val)}`;
};
const $2c9dd9fad62b5317$var$depositsLimitDecoder = (value)=>{
    const prefix = value.consume(1);
    if ($2c9dd9fad62b5317$require$Buffer.from(prefix).toString('hex') !== '00') return $2c9dd9fad62b5317$var$zarithDecoder(value);
};
const $2c9dd9fad62b5317$var$paddedBytesEncoder = (val, paddingLength = 8)=>{
    return `${$2c9dd9fad62b5317$var$pad(val.length / 2, paddingLength)}${val}`;
};
const $2c9dd9fad62b5317$var$paddedBytesDecoder = (val)=>{
    const value = $2c9dd9fad62b5317$var$extractRequiredLen(val);
    return $2c9dd9fad62b5317$require$Buffer.from(value).toString('hex');
};
const $2c9dd9fad62b5317$var$smartRollupMessageEncoder = (val)=>{
    const message = val.reduce((prev, curr)=>{
        return prev + `${$2c9dd9fad62b5317$var$pad(curr.length / 2)}${curr}`;
    }, '');
    return `${$2c9dd9fad62b5317$var$pad(message.length / 2)}${message}`;
};
const $2c9dd9fad62b5317$var$smartRollupMessageDecoder = (val)=>{
    const valueArray = $2c9dd9fad62b5317$var$extractRequiredLen(val);
    const ret = $2c9dd9fad62b5317$var$stripLengthPrefixFromBytes(new $2c9dd9fad62b5317$export$2ea09c189c142295(valueArray));
    return ret.map((value)=>$2c9dd9fad62b5317$require$Buffer.from(value).toString('hex'));
};
const $2c9dd9fad62b5317$var$ManagerOperationSchema = {
    branch: $2c9dd9fad62b5317$export$9a139b626817ea5b.BRANCH,
    contents: [
        $2c9dd9fad62b5317$export$9a139b626817ea5b.OPERATION
    ]
};
const $2c9dd9fad62b5317$var$ActivationSchema = {
    pkh: $2c9dd9fad62b5317$export$9a139b626817ea5b.TZ1,
    secret: $2c9dd9fad62b5317$export$9a139b626817ea5b.SECRET
};
const $2c9dd9fad62b5317$var$RevealSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    public_key: $2c9dd9fad62b5317$export$9a139b626817ea5b.PUBLIC_KEY
};
const $2c9dd9fad62b5317$var$DelegationSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    delegate: $2c9dd9fad62b5317$export$9a139b626817ea5b.DELEGATE
};
const $2c9dd9fad62b5317$var$TransactionSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    amount: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    destination: $2c9dd9fad62b5317$export$9a139b626817ea5b.ADDRESS,
    parameters: $2c9dd9fad62b5317$export$9a139b626817ea5b.PARAMETERS
};
const $2c9dd9fad62b5317$var$OriginationSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    balance: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    delegate: $2c9dd9fad62b5317$export$9a139b626817ea5b.DELEGATE,
    script: $2c9dd9fad62b5317$export$9a139b626817ea5b.SCRIPT
};
const $2c9dd9fad62b5317$var$BallotSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    period: $2c9dd9fad62b5317$export$9a139b626817ea5b.INT32,
    proposal: $2c9dd9fad62b5317$export$9a139b626817ea5b.PROPOSAL,
    ballot: $2c9dd9fad62b5317$export$9a139b626817ea5b.BALLOT_STATEMENT
};
const $2c9dd9fad62b5317$var$AttestationSchema = {
    slot: $2c9dd9fad62b5317$export$9a139b626817ea5b.INT16,
    level: $2c9dd9fad62b5317$export$9a139b626817ea5b.INT32,
    round: $2c9dd9fad62b5317$export$9a139b626817ea5b.INT32,
    block_payload_hash: $2c9dd9fad62b5317$export$9a139b626817ea5b.BLOCK_PAYLOAD_HASH
};
const $2c9dd9fad62b5317$var$EndorsementSchema = {
    slot: $2c9dd9fad62b5317$export$9a139b626817ea5b.INT16,
    level: $2c9dd9fad62b5317$export$9a139b626817ea5b.INT32,
    round: $2c9dd9fad62b5317$export$9a139b626817ea5b.INT32,
    block_payload_hash: $2c9dd9fad62b5317$export$9a139b626817ea5b.BLOCK_PAYLOAD_HASH
};
const $2c9dd9fad62b5317$var$SeedNonceRevelationSchema = {
    level: $2c9dd9fad62b5317$export$9a139b626817ea5b.INT32,
    nonce: $2c9dd9fad62b5317$export$9a139b626817ea5b.RAW
};
const $2c9dd9fad62b5317$var$ProposalsSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    period: $2c9dd9fad62b5317$export$9a139b626817ea5b.INT32,
    proposals: $2c9dd9fad62b5317$export$9a139b626817ea5b.PROPOSAL_ARR
};
const $2c9dd9fad62b5317$var$RegisterGlobalConstantSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    value: $2c9dd9fad62b5317$export$9a139b626817ea5b.VALUE
};
const $2c9dd9fad62b5317$var$TransferTicketSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    ticket_contents: $2c9dd9fad62b5317$export$9a139b626817ea5b.VALUE,
    ticket_ty: $2c9dd9fad62b5317$export$9a139b626817ea5b.VALUE,
    ticket_ticketer: $2c9dd9fad62b5317$export$9a139b626817ea5b.ADDRESS,
    ticket_amount: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    destination: $2c9dd9fad62b5317$export$9a139b626817ea5b.ADDRESS,
    entrypoint: $2c9dd9fad62b5317$export$9a139b626817ea5b.ENTRYPOINT
};
const $2c9dd9fad62b5317$var$IncreasePaidStorageSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    amount: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    destination: $2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_CONTRACT_ADDRESS
};
const $2c9dd9fad62b5317$var$UpdateConsensusKeySchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    pk: $2c9dd9fad62b5317$export$9a139b626817ea5b.PUBLIC_KEY
};
const $2c9dd9fad62b5317$var$DrainDelegateSchema = {
    consensus_key: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    delegate: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    destination: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH
};
const $2c9dd9fad62b5317$var$SetDepositsLimitSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.DEPOSITS_LIMIT
};
const $2c9dd9fad62b5317$var$SmartRollupOriginateSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    pvm_kind: $2c9dd9fad62b5317$export$9a139b626817ea5b.PVM_KIND,
    kernel: $2c9dd9fad62b5317$export$9a139b626817ea5b.PADDED_BYTES,
    parameters_ty: $2c9dd9fad62b5317$export$9a139b626817ea5b.VALUE,
    whitelist: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH_ARR
};
const $2c9dd9fad62b5317$var$SmartRollupAddMessagesSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    message: $2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_ROLLUP_MESSAGE
};
const $2c9dd9fad62b5317$var$SmartRollupExecuteOutboxMessageSchema = {
    source: $2c9dd9fad62b5317$export$9a139b626817ea5b.PKH,
    fee: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    counter: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    gas_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    storage_limit: $2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH,
    rollup: $2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_ROLLUP_ADDRESS,
    cemented_commitment: $2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_ROLLUP_COMMITMENT_HASH,
    output_proof: $2c9dd9fad62b5317$export$9a139b626817ea5b.PADDED_BYTES
};
const $2c9dd9fad62b5317$var$FailingNoopSchema = {
    arbitrary: $2c9dd9fad62b5317$export$9a139b626817ea5b.PADDED_BYTES
};
const $2c9dd9fad62b5317$var$operationEncoder = (encoders)=>(operation)=>{
        if (!(operation.kind in encoders) || !(operation.kind in $2c9dd9fad62b5317$var$kindMappingReverse)) throw new (0, $8b6476b09e20f53e$export$bc5be87550569b55)(operation.kind);
        return $2c9dd9fad62b5317$var$kindMappingReverse[operation.kind] + encoders[operation.kind](operation);
    };
const $2c9dd9fad62b5317$var$operationDecoder = (decoders)=>(value)=>{
        const op = value.consume(1);
        const operationName = $2c9dd9fad62b5317$var$kindMapping[op[0]];
        if (operationName === undefined) throw new $2c9dd9fad62b5317$var$UnsupportedOperationError(op[0].toString());
        const decodedObj = decoders[operationName](value);
        if (typeof decodedObj !== 'object') throw new $2c9dd9fad62b5317$var$OperationDecodingError('Invalid operation, cannot be decoded.');
        return Object.assign({
            kind: operationName
        }, decodedObj);
    };
const $2c9dd9fad62b5317$var$schemaEncoder = (encoders)=>(schema)=>(value)=>{
            const keys = Object.keys(schema);
            return keys.reduce((prev, key)=>{
                const valueToEncode = schema[key];
                if (value && Array.isArray(valueToEncode)) {
                    const encoder = encoders[valueToEncode[0]];
                    const values = value[key];
                    if (!Array.isArray(values)) throw new $2c9dd9fad62b5317$var$OperationEncodingError(`Invalid operation value "${JSON.stringify(values)}" of key "${key}, expected value to be Array.`);
                    return prev + values.reduce((prevBytes, current)=>prevBytes + encoder(current), '');
                } else {
                    const encoder = encoders[valueToEncode];
                    return prev + encoder(value[key]);
                }
            }, '');
        };
const $2c9dd9fad62b5317$var$schemaDecoder = (decoders)=>(schema)=>(value)=>{
            const keys = Object.keys(schema);
            return keys.reduce((prev, key)=>{
                const valueToEncode = schema[key];
                if (Array.isArray(valueToEncode)) {
                    const decoder = decoders[valueToEncode[0]];
                    const decoded = [];
                    const lastLength = value.length();
                    while(value.length() > 0){
                        decoded.push(decoder(value));
                        if (lastLength === value.length()) throw new $2c9dd9fad62b5317$var$OperationDecodingError('Unable to decode value');
                    }
                    return Object.assign(Object.assign({}, prev), {
                        [key]: decoded
                    });
                } else {
                    const decoder = decoders[valueToEncode];
                    const result = decoder(value);
                    if (typeof result !== 'undefined') return Object.assign(Object.assign({}, prev), {
                        [key]: result
                    });
                    else return Object.assign({}, prev);
                }
            }, {});
        };
const $2c9dd9fad62b5317$export$1e344c6b2c4b13e7 = {
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SECRET]: (val)=>$2c9dd9fad62b5317$var$toHexString(val.consume(20)),
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.RAW]: (val)=>$2c9dd9fad62b5317$var$toHexString(val.consume(32)),
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.TZ1]: $2c9dd9fad62b5317$var$tz1Decoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.BRANCH]: $2c9dd9fad62b5317$var$branchDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH]: $2c9dd9fad62b5317$var$zarithDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PUBLIC_KEY]: $2c9dd9fad62b5317$var$publicKeyDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PKH]: $2c9dd9fad62b5317$var$publicKeyHashDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PKH_ARR]: $2c9dd9fad62b5317$var$publicKeyHashesDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.DELEGATE]: $2c9dd9fad62b5317$var$delegateDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.INT32]: $2c9dd9fad62b5317$var$int32Decoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SCRIPT]: $2c9dd9fad62b5317$var$scriptDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.BALLOT_STATEMENT]: $2c9dd9fad62b5317$var$ballotDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PROPOSAL]: $2c9dd9fad62b5317$var$proposalDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PROPOSAL_ARR]: $2c9dd9fad62b5317$var$proposalsDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PARAMETERS]: $2c9dd9fad62b5317$var$parametersDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.ADDRESS]: $2c9dd9fad62b5317$var$addressDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_ROLLUP_ADDRESS]: $2c9dd9fad62b5317$var$smartRollupAddressDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_CONTRACT_ADDRESS]: $2c9dd9fad62b5317$var$smartContractAddressDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_ROLLUP_COMMITMENT_HASH]: $2c9dd9fad62b5317$var$smartRollupCommitmentHashDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.VALUE]: $2c9dd9fad62b5317$var$valueParameterDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.INT16]: $2c9dd9fad62b5317$var$int16Decoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.BLOCK_PAYLOAD_HASH]: $2c9dd9fad62b5317$var$blockPayloadHashDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.ENTRYPOINT]: $2c9dd9fad62b5317$var$entrypointNameDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.BURN_LIMIT]: $2c9dd9fad62b5317$var$burnLimitDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.DEPOSITS_LIMIT]: $2c9dd9fad62b5317$var$depositsLimitDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PVM_KIND]: $2c9dd9fad62b5317$var$pvmKindDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PADDED_BYTES]: $2c9dd9fad62b5317$var$paddedBytesDecoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_ROLLUP_MESSAGE]: $2c9dd9fad62b5317$var$smartRollupMessageDecoder
};
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OPERATION] = $2c9dd9fad62b5317$var$operationDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_ACTIVATE_ACCOUNT] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$ActivationSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_FAILING_NOOP] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$FailingNoopSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_DELEGATION] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$DelegationSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_TRANSACTION] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$TransactionSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_ORIGINATION] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$OriginationSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_BALLOT] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$BallotSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_ATTESTATION] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$AttestationSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_ENDORSEMENT] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$EndorsementSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_SEED_NONCE_REVELATION] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$SeedNonceRevelationSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_PROPOSALS] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$ProposalsSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_REVEAL] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$RevealSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_REGISTER_GLOBAL_CONSTANT] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$RegisterGlobalConstantSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_TRANSFER_TICKET] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$TransferTicketSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_INCREASE_PAID_STORAGE] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$IncreasePaidStorageSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_UPDATE_CONSENSUS_KEY] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$UpdateConsensusKeySchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_DRAIN_DELEGATE] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$DrainDelegateSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_SMART_ROLLUP_ORIGINATE] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$SmartRollupOriginateSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_SMART_ROLLUP_ADD_MESSAGES] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$SmartRollupAddMessagesSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$SmartRollupExecuteOutboxMessageSchema)(val);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.MANAGER] = $2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$ManagerOperationSchema);
$2c9dd9fad62b5317$export$1e344c6b2c4b13e7[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_SET_DEPOSITS_LIMIT] = (val)=>$2c9dd9fad62b5317$var$schemaDecoder($2c9dd9fad62b5317$export$1e344c6b2c4b13e7)($2c9dd9fad62b5317$var$SetDepositsLimitSchema)(val);
const $2c9dd9fad62b5317$export$589f0c556f2c67ce = {
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SECRET]: (val)=>val,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.RAW]: (val)=>val,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.TZ1]: $2c9dd9fad62b5317$var$tz1Encoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.BRANCH]: $2c9dd9fad62b5317$var$branchEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.ZARITH]: $2c9dd9fad62b5317$var$zarithEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PUBLIC_KEY]: $2c9dd9fad62b5317$var$publicKeyEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PKH]: $2c9dd9fad62b5317$var$publicKeyHashEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PKH_ARR]: $2c9dd9fad62b5317$var$publicKeyHashesEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.DELEGATE]: $2c9dd9fad62b5317$var$delegateEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SCRIPT]: $2c9dd9fad62b5317$var$scriptEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.BALLOT_STATEMENT]: $2c9dd9fad62b5317$var$ballotEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PROPOSAL]: $2c9dd9fad62b5317$var$proposalEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PROPOSAL_ARR]: $2c9dd9fad62b5317$var$proposalsEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.INT32]: $2c9dd9fad62b5317$var$int32Encoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PARAMETERS]: $2c9dd9fad62b5317$var$parametersEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.ADDRESS]: $2c9dd9fad62b5317$var$addressEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_ROLLUP_ADDRESS]: $2c9dd9fad62b5317$var$smartRollupAddressEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_CONTRACT_ADDRESS]: $2c9dd9fad62b5317$var$smartContractAddressEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_ROLLUP_COMMITMENT_HASH]: $2c9dd9fad62b5317$var$smartRollupCommitmentHashEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.VALUE]: $2c9dd9fad62b5317$var$valueParameterEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.INT16]: $2c9dd9fad62b5317$var$int16Encoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.BLOCK_PAYLOAD_HASH]: $2c9dd9fad62b5317$var$blockPayloadHashEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.ENTRYPOINT]: $2c9dd9fad62b5317$var$entrypointNameEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.BURN_LIMIT]: $2c9dd9fad62b5317$var$burnLimitEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.DEPOSITS_LIMIT]: $2c9dd9fad62b5317$var$depositsLimitEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PVM_KIND]: $2c9dd9fad62b5317$var$pvmKindEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.PADDED_BYTES]: $2c9dd9fad62b5317$var$paddedBytesEncoder,
    [$2c9dd9fad62b5317$export$9a139b626817ea5b.SMART_ROLLUP_MESSAGE]: $2c9dd9fad62b5317$var$smartRollupMessageEncoder
};
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OPERATION] = $2c9dd9fad62b5317$var$operationEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_ACTIVATE_ACCOUNT] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$ActivationSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_DELEGATION] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$DelegationSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_TRANSACTION] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$TransactionSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_ORIGINATION] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$OriginationSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_BALLOT] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$BallotSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_ATTESTATION] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$AttestationSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_ENDORSEMENT] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$EndorsementSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_SEED_NONCE_REVELATION] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$SeedNonceRevelationSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_PROPOSALS] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$ProposalsSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_REVEAL] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$RevealSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_REGISTER_GLOBAL_CONSTANT] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$RegisterGlobalConstantSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_TRANSFER_TICKET] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$TransferTicketSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_INCREASE_PAID_STORAGE] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$IncreasePaidStorageSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_UPDATE_CONSENSUS_KEY] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$UpdateConsensusKeySchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_DRAIN_DELEGATE] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$DrainDelegateSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_SMART_ROLLUP_ORIGINATE] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$SmartRollupOriginateSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_SMART_ROLLUP_ADD_MESSAGES] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$SmartRollupAddMessagesSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$SmartRollupExecuteOutboxMessageSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.MANAGER] = $2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$ManagerOperationSchema);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_SET_DEPOSITS_LIMIT] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$SetDepositsLimitSchema)(val);
$2c9dd9fad62b5317$export$589f0c556f2c67ce[$2c9dd9fad62b5317$export$9a139b626817ea5b.OP_FAILING_NOOP] = (val)=>$2c9dd9fad62b5317$var$schemaEncoder($2c9dd9fad62b5317$export$589f0c556f2c67ce)($2c9dd9fad62b5317$var$FailingNoopSchema)(val);
const $2c9dd9fad62b5317$var$OperationKindMapping = {
    activate_account: $2c9dd9fad62b5317$var$ActivationSchema,
    reveal: $2c9dd9fad62b5317$var$RevealSchema,
    delegation: $2c9dd9fad62b5317$var$DelegationSchema,
    transaction: $2c9dd9fad62b5317$var$TransactionSchema,
    origination: $2c9dd9fad62b5317$var$OriginationSchema,
    ballot: $2c9dd9fad62b5317$var$BallotSchema,
    attestation: $2c9dd9fad62b5317$var$AttestationSchema,
    endorsement: $2c9dd9fad62b5317$var$EndorsementSchema,
    seed_nonce_revelation: $2c9dd9fad62b5317$var$SeedNonceRevelationSchema,
    proposals: $2c9dd9fad62b5317$var$ProposalsSchema,
    register_global_constant: $2c9dd9fad62b5317$var$RegisterGlobalConstantSchema,
    transfer_ticket: $2c9dd9fad62b5317$var$TransferTicketSchema,
    increase_paid_storage: $2c9dd9fad62b5317$var$IncreasePaidStorageSchema,
    update_consensus_key: $2c9dd9fad62b5317$var$UpdateConsensusKeySchema,
    drain_delegate: $2c9dd9fad62b5317$var$DrainDelegateSchema,
    set_deposits_limit: $2c9dd9fad62b5317$var$SetDepositsLimitSchema,
    smart_rollup_originate: $2c9dd9fad62b5317$var$SmartRollupOriginateSchema,
    smart_rollup_add_messages: $2c9dd9fad62b5317$var$SmartRollupAddMessagesSchema,
    smart_rollup_execute_outbox_message: $2c9dd9fad62b5317$var$SmartRollupExecuteOutboxMessageSchema,
    failing_noop: $2c9dd9fad62b5317$var$FailingNoopSchema
};
// Asymmetric difference: only account for things in arr2 that are not present in arr1, not vice versa
const $2c9dd9fad62b5317$var$getArrayDifference = (arr1, arr2)=>{
    return arr2.filter((x)=>!arr1.includes(x));
};
const $2c9dd9fad62b5317$var$deleteArrayElementByValue = (array, item)=>{
    return array.filter((e)=>e !== item);
};
/**
 * @returns A boolean value to indicate whether the operation kind is valid or not
 */ const $2c9dd9fad62b5317$var$validateOperationKind = (opKind)=>{
    const opKindList = Object.keys($2c9dd9fad62b5317$var$OperationKindMapping);
    return opKindList.includes(opKind);
};
/**
 *  returns 0 when the two array of properties are identical or the passed property
 *  does not have any missing parameters from the corresponding schema
 *
 *  @returns array element differences if there are missing required property keys
 */ const $2c9dd9fad62b5317$var$validateMissingProperty = (operationContent)=>{
    const kind = operationContent.kind;
    const keys = Object.keys(operationContent);
    const cleanKeys = $2c9dd9fad62b5317$var$deleteArrayElementByValue(keys, 'kind');
    const schemaKeys = Object.keys($2c9dd9fad62b5317$var$OperationKindMapping[kind]);
    return $2c9dd9fad62b5317$var$getArrayDifference(cleanKeys, schemaKeys);
};
var $2c9dd9fad62b5317$export$cf68b74f12b4139e;
(function(ProtocolsHash) {
    ProtocolsHash["Pt24m4xi"] = "Pt24m4xiPbLDhVgVfABUjirbmda3yohdN82Sp9FeuAXJ4eV9otd";
    ProtocolsHash["PsBABY5H"] = "PsBABY5HQTSkA4297zNHfsZNKtxULfL18y95qb3m53QJiXGmrbU";
    ProtocolsHash["PsBabyM1"] = "PsBabyM1eUXZseaJdmXFApDSBqj8YBfwELoxZHHW77EMcAbbwAS";
    ProtocolsHash["PsCARTHA"] = "PsCARTHAGazKbHtnKfLzQg3kms52kSRpgnDY982a9oYsSXRLQEb";
    ProtocolsHash["PsDELPH1"] = "PsDELPH1Kxsxt8f9eWbxQeRxkjfbxoqM52jvs5Y5fBxWWh4ifpo";
    ProtocolsHash["PtEdo2Zk"] = "PtEdo2ZkT9oKpimTah6x2embF25oss54njMuPzkJTEi5RqfdZFA";
    ProtocolsHash["PsFLorena"] = "PsFLorenaUUuikDWvMDr6fGBRG8kt3e3D3fHoXK1j1BFRxeSH4i";
    ProtocolsHash["PtGRANADs"] = "PtGRANADsDU8R9daYKAgWnQYAJ64omN1o3KMGVCykShA97vQbvV";
    ProtocolsHash["PtHangz2"] = "PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx";
    ProtocolsHash["Psithaca2"] = "Psithaca2MLRFYargivpo7YvUr7wUDqyxrdhC5CQq78mRvimz6A";
    ProtocolsHash["PtJakart2"] = "PtJakart2xVj7pYXJBXrqHgd82rdkLey5ZeeGwDgPp9rhQUbSqY";
    ProtocolsHash["PtKathman"] = "PtKathmankSpLLDALzWw7CGD2j2MtyveTwboEYokqUCP4a1LxMg";
    ProtocolsHash["PtLimaPtL"] = "PtLimaPtLMwfNinJi9rCfDPWea8dFgTZ1MeJ9f1m2SRic6ayiwW";
    ProtocolsHash["PtMumbaii"] = "PtMumbaiiFFEGbew1rRjzSPyzRbA51Tm3RVZL5suHPxSZYDhCEc";
    ProtocolsHash["PtMumbai2"] = "PtMumbai2TmsJHNGRkD8v8YDbtao7BLUC3wjASn1inAKLFCjaH1";
    ProtocolsHash["PtNairobi"] = "PtNairobiyssHuh87hEhfVBGCVrK3WnS8Z2FT4ymB5tAa4r1nQf";
    ProtocolsHash["ProxfordY"] = "ProxfordYmVfjWnRcgjWH36fW6PArwqykTFzotUxRs6gmTcZDuH";
    ProtocolsHash["ProtoALpha"] = "ProtoALphaALphaALphaALphaALphaALphaALphaALphaDdp3zK";
})($2c9dd9fad62b5317$export$cf68b74f12b4139e || ($2c9dd9fad62b5317$export$cf68b74f12b4139e = {}));
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $2c9dd9fad62b5317$export$a4ad2735b021c132 = {
    "commitHash": "2e05f6f865be17a1b367b284542b24ffa9823271",
    "version": "19.2.1"
};
/**
 * @packageDocumentation
 * @module @taquito/local-forging
 */ const $2c9dd9fad62b5317$var$PROTOCOL_CURRENT = $2c9dd9fad62b5317$export$cf68b74f12b4139e.ProxfordY;
function $2c9dd9fad62b5317$export$620fe4e858113ce9(codec, _proto) {
    return {
        encoder: $2c9dd9fad62b5317$export$589f0c556f2c67ce[codec],
        decoder: (hex)=>{
            const consumer = $2c9dd9fad62b5317$export$2ea09c189c142295.fromHexString(hex);
            return $2c9dd9fad62b5317$export$1e344c6b2c4b13e7[codec](consumer);
        }
    };
}
//
class $2c9dd9fad62b5317$export$99b12ddbeed7bd69 {
    constructor(protocolHash = $2c9dd9fad62b5317$var$PROTOCOL_CURRENT){
        this.protocolHash = protocolHash;
        this.codec = $2c9dd9fad62b5317$export$620fe4e858113ce9($2c9dd9fad62b5317$export$9a139b626817ea5b.MANAGER, this.protocolHash);
    }
    forge(params) {
        const branchValidation = (0, $201657d342d01b1b$export$8a53803420cdc9be)(params.branch);
        if (branchValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$16fabd343bcdfd7b)(params.branch, (0, $201657d342d01b1b$export$a2057601792df650)(branchValidation));
        for (const content of params.contents){
            if (!$2c9dd9fad62b5317$var$validateOperationKind(content.kind)) throw new (0, $8b6476b09e20f53e$export$bc5be87550569b55)(content.kind);
            const diff = $2c9dd9fad62b5317$var$validateMissingProperty(content);
            if (diff.length === 1) {
                if (content.kind === 'delegation' && diff[0] === 'delegate') continue;
                else if (content.kind === 'origination' && diff[0] === 'delegate') continue;
                else if (content.kind === 'transaction' && diff[0] === 'parameters') continue;
                else if (content.kind === 'set_deposits_limit' && diff[0] === 'limit') continue;
                else if (content.kind === 'smart_rollup_originate' && diff[0] === 'whitelist') continue;
                else throw new $2c9dd9fad62b5317$var$InvalidOperationSchemaError(content, `missing properties "${diff.join(', ')}"`);
            } else if (diff.length > 1) throw new $2c9dd9fad62b5317$var$InvalidOperationSchemaError(content, `missing properties "${diff.join(', ')}"`);
        }
        const forged = this.codec.encoder(params).toLowerCase();
        return Promise.resolve(forged);
    }
    parse(hex) {
        return Promise.resolve(this.codec.decoder(hex));
    }
}
const $2c9dd9fad62b5317$export$2eabd168525372f1 = new $2c9dd9fad62b5317$export$99b12ddbeed7bd69();


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $7f31e5493257f9b5$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7f31e5493257f9b5$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7f31e5493257f9b5$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $7f31e5493257f9b5$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
function $7f31e5493257f9b5$var$formatErrorMessage(error, stringToReplace) {
    const body = JSON.parse(error.body);
    if (body[0] && body[0].kind && body[0].msg) {
        const newBody = JSON.stringify({
            kind: body[0].kind,
            id: body[0].id,
            msg: body[0].msg.replace(stringToReplace, '')
        });
        return new (0, $e7f526111d047632$export$d2f2761cbe9cebf2)(`Http error response: (${error.status}) ${newBody}`, error.status, error.statusText, newBody, error.url);
    } else return error;
}
class $7f31e5493257f9b5$export$e81caaa38ad97a2 {
    constructor(context){
        this.context = context;
    }
    inject(signedOperationBytes) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            let hash;
            try {
                hash = yield this.context.rpc.injectOperation(signedOperationBytes);
            } catch (error) {
                const stringToStrip = '. You may want to use --replace to provide adequate fee and replace it';
                if (error instanceof (0, $e7f526111d047632$export$d2f2761cbe9cebf2) && error.message.includes(stringToStrip)) throw $7f31e5493257f9b5$var$formatErrorMessage(error, stringToStrip);
                else throw error;
            }
            return hash;
        });
    }
}
/**
 *  @category Error
 *  @description Error that indicates no signer has been configured in the TezosToolkit instance
 */ class $7f31e5493257f9b5$var$UnconfiguredSignerError extends (0, $8b6476b09e20f53e$export$32f4d70b2fb302b1) {
    constructor(){
        super();
        this.name = 'UnconfiguredSignerError';
        this.message = 'No signer has been configured. Please configure one by calling setProvider({signer}) on your TezosToolkit instance.';
    }
}
/**
 * @description Default signer implementation which does nothing and produce invalid signature
 * @throw {@link UnconfiguredSignerError}
 */ class $7f31e5493257f9b5$var$NoopSigner {
    publicKey() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            throw new $7f31e5493257f9b5$var$UnconfiguredSignerError();
        });
    }
    publicKeyHash() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            throw new $7f31e5493257f9b5$var$UnconfiguredSignerError();
        });
    }
    secretKey() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            throw new $7f31e5493257f9b5$var$UnconfiguredSignerError();
        });
    }
    sign(_bytes, _watermark) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            throw new $7f31e5493257f9b5$var$UnconfiguredSignerError();
        });
    }
}
function $7f31e5493257f9b5$var$createObservableFromSubscription(sub) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)((subscriber)=>{
        sub.on('data', (data)=>{
            subscriber.next(data);
        });
        sub.on('error', (error)=>{
            subscriber.error(error);
        });
        sub.on('close', ()=>{
            subscriber.complete();
        });
        return ()=>{
            sub.close();
        };
    });
}
/**
 * @deprecated default reveal gasLimit please use getRevealGasLimit(address) instead, removing hardcoded gasLimit of delegation, origination and transfer
 */ const $7f31e5493257f9b5$export$675c8beda367aa70 = {
    DELEGATION: 10600,
    ORIGINATION: 10600,
    TRANSFER: 10600,
    REVEAL_TZ1: 1000,
    REVEAL_TZ2: 1000,
    REVEAL_TZ3: 2000,
    REVEAL_TZ4: 2000
};
/**
 * @deprecated default reveal fee please use getRevealFee(address) instead, removing hardcoded fee of delegation, origination and transfer
 */ const $7f31e5493257f9b5$export$5253b4cb14a0057d = {
    DELEGATION: 1257,
    ORIGINATION: 10000,
    TRANSFER: 10000,
    REVEAL: 374
};
/**
 * @deprecated default reveal storageLimit please use REVEAL_STORAGE_LIMIT instead, removing hardcoded storageLimit of delegation, origination and transfer
 */ const $7f31e5493257f9b5$export$309032a94a558206 = {
    DELEGATION: 0,
    ORIGINATION: 257,
    TRANSFER: 257,
    REVEAL: 0
};
// value is based on octez-client reveal operation gasLimit of each address type
const $7f31e5493257f9b5$var$REVEAL_GAS_LIMIT = {
    TZ1: 169,
    TZ2: 155,
    TZ3: 445,
    TZ4: 1674
};
// value is based on octez-client reveal operation fee of each address type
const $7f31e5493257f9b5$var$REVEAL_FEE = {
    TZ1: 276,
    TZ2: 276,
    TZ3: 305,
    TZ4: 477
};
// value is based on octez-client reveal operation storageLimit of all address type
const $7f31e5493257f9b5$export$7dc909734d086289 = 0;
// protocol constants
const $7f31e5493257f9b5$export$c39b0b5305f5c11f = 257;
// protocol constants
const $7f31e5493257f9b5$export$961faea0d634ab07 = 250;
var $7f31e5493257f9b5$export$8b0851cfdd1d5bdc;
(function(Protocols) {
    Protocols["Pt24m4xi"] = "Pt24m4xiPbLDhVgVfABUjirbmda3yohdN82Sp9FeuAXJ4eV9otd";
    Protocols["PsBABY5H"] = "PsBABY5HQTSkA4297zNHfsZNKtxULfL18y95qb3m53QJiXGmrbU";
    Protocols["PsBabyM1"] = "PsBabyM1eUXZseaJdmXFApDSBqj8YBfwELoxZHHW77EMcAbbwAS";
    Protocols["PsCARTHA"] = "PsCARTHAGazKbHtnKfLzQg3kms52kSRpgnDY982a9oYsSXRLQEb";
    Protocols["PsDELPH1"] = "PsDELPH1Kxsxt8f9eWbxQeRxkjfbxoqM52jvs5Y5fBxWWh4ifpo";
    Protocols["PtEdo2Zk"] = "PtEdo2ZkT9oKpimTah6x2embF25oss54njMuPzkJTEi5RqfdZFA";
    Protocols["PsFLorena"] = "PsFLorenaUUuikDWvMDr6fGBRG8kt3e3D3fHoXK1j1BFRxeSH4i";
    Protocols["PtGRANADs"] = "PtGRANADsDU8R9daYKAgWnQYAJ64omN1o3KMGVCykShA97vQbvV";
    Protocols["PtHangz2"] = "PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx";
    Protocols["PsiThaCa"] = "PsiThaCaT47Zboaw71QWScM8sXeMM7bbQFncK9FLqYc6EKdpjVP";
    Protocols["Psithaca2"] = "Psithaca2MLRFYargivpo7YvUr7wUDqyxrdhC5CQq78mRvimz6A";
    Protocols["PtJakart2"] = "PtJakart2xVj7pYXJBXrqHgd82rdkLey5ZeeGwDgPp9rhQUbSqY";
    Protocols["PtKathman"] = "PtKathmankSpLLDALzWw7CGD2j2MtyveTwboEYokqUCP4a1LxMg";
    Protocols["PtLimaPtL"] = "PtLimaPtLMwfNinJi9rCfDPWea8dFgTZ1MeJ9f1m2SRic6ayiwW";
    Protocols["PtMumbaii"] = "PtMumbaiiFFEGbew1rRjzSPyzRbA51Tm3RVZL5suHPxSZYDhCEc";
    Protocols["PtMumbai2"] = "PtMumbai2TmsJHNGRkD8v8YDbtao7BLUC3wjASn1inAKLFCjaH1";
    Protocols["PtNairobi"] = "PtNairobiyssHuh87hEhfVBGCVrK3WnS8Z2FT4ymB5tAa4r1nQf";
    Protocols["ProxfordY"] = "ProxfordYmVfjWnRcgjWH36fW6PArwqykTFzotUxRs6gmTcZDuH";
    Protocols["ProtoALpha"] = "ProtoALphaALphaALphaALphaALphaALphaALphaALphaDdp3zK";
})($7f31e5493257f9b5$export$8b0851cfdd1d5bdc || ($7f31e5493257f9b5$export$8b0851cfdd1d5bdc = {}));
const $7f31e5493257f9b5$export$6c805ddc3bf825c2 = {
    '004': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.Pt24m4xi
    ],
    '005': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PsBABY5H,
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PsBabyM1
    ],
    '006': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PsCARTHA
    ],
    '007': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PsDELPH1
    ],
    '008': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PtEdo2Zk
    ],
    '009': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PsFLorena
    ],
    '010': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PtGRANADs
    ],
    '011': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PtHangz2
    ],
    '012': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PsiThaCa,
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.Psithaca2
    ],
    '013': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PtJakart2
    ],
    '014': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PtKathman
    ],
    '015': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PtLimaPtL
    ],
    '016': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PtMumbai2
    ],
    '017': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PtNairobi
    ],
    '019': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.ProxfordY
    ],
    '020': [
        $7f31e5493257f9b5$export$8b0851cfdd1d5bdc.ProtoALpha
    ]
};
var $7f31e5493257f9b5$export$89b6ee632056a8b6;
(function(ChainIds) {
    ChainIds["MAINNET"] = "NetXdQprcVkpaWU";
    ChainIds["CARTHAGENET"] = "NetXjD3HPJJjmcd";
    ChainIds["DELPHINET"] = "NetXm8tYqnMWky1";
    ChainIds["EDONET"] = "NetXSgo1ZT2DRUG";
    ChainIds["FLORENCENET"] = "NetXxkAx4woPLyu";
    ChainIds["GRANADANET"] = "NetXz969SFaFn8k";
    ChainIds["HANGZHOUNET"] = "NetXZSsxBpMQeAT";
    ChainIds["ITHACANET"] = "NetXbhmtAbMukLc";
    ChainIds["ITHACANET2"] = "NetXnHfVqm9iesp";
    ChainIds["JAKARTANET2"] = "NetXLH1uAxK7CCh";
    ChainIds["KATHMANDUNET"] = "NetXazhm4yetmff";
    ChainIds["LIMANET"] = "NetXizpkH94bocH";
    ChainIds["MUMBAINET"] = "NetXQw6nWSnrJ5t";
    ChainIds["MUMBAINET2"] = "NetXgbcrNtXD2yA";
    ChainIds["NAIROBINET"] = "NetXyuzvDo2Ugzb";
    ChainIds["OXFORDNET2"] = "NetXxWsskGahzQB";
})($7f31e5493257f9b5$export$89b6ee632056a8b6 || ($7f31e5493257f9b5$export$89b6ee632056a8b6 = {}));
// A fixed fee reveal operation gasLimit accepted by both simulate and injection endpoint is between 1.2-5 times of actual gas consumption (3.5 fails occasionally with gas exhausted; 4 fails occasionally with fee too low)
const $7f31e5493257f9b5$export$199fe2d87a4763cf = (address)=>Math.round($7f31e5493257f9b5$var$getRevealGasLimitInternal(address) * 37 / 10);
const $7f31e5493257f9b5$var$getRevealGasLimitInternal = (address)=>{
    switch(address.substring(0, 3)){
        case 'tz1':
            return $7f31e5493257f9b5$var$REVEAL_GAS_LIMIT.TZ1;
        case 'tz2':
            return $7f31e5493257f9b5$var$REVEAL_GAS_LIMIT.TZ2;
        case 'tz3':
            return $7f31e5493257f9b5$var$REVEAL_GAS_LIMIT.TZ3;
        case 'tz4':
            return $7f31e5493257f9b5$var$REVEAL_GAS_LIMIT.TZ4;
        default:
            throw new Error(`Cannot estimate reveal gas limit for ${address}`);
    }
};
const $7f31e5493257f9b5$export$2a009c06b05c06b7 = (address)=>Math.round($7f31e5493257f9b5$export$970feb211f171a98(address) * 12 / 10);
const $7f31e5493257f9b5$export$970feb211f171a98 = (address)=>{
    switch(address.substring(0, 3)){
        case 'tz1':
            return $7f31e5493257f9b5$var$REVEAL_FEE.TZ1;
        case 'tz2':
            return $7f31e5493257f9b5$var$REVEAL_FEE.TZ2;
        case 'tz3':
            return $7f31e5493257f9b5$var$REVEAL_FEE.TZ3;
        case 'tz4':
            return $7f31e5493257f9b5$var$REVEAL_FEE.TZ4;
        default:
            throw new Error(`Cannot estimate reveal fee for ${address}`);
    }
};
/**
 *  @category Error
 *  @description Error that indicates invalid smart contract parameters being passed or used
 */ class $7f31e5493257f9b5$export$e569b97a5d46005c extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(smartContractMethodName, sigs, invalidParams){
        super();
        this.smartContractMethodName = smartContractMethodName;
        this.sigs = sigs;
        this.invalidParams = invalidParams;
        this.name = 'InvalidParameterError';
        this.message = `${smartContractMethodName} Received ${invalidParams.length} arguments while expecting one of the following signatures (${JSON.stringify(sigs)})`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid delegation source contract address being passed or used
 */ class $7f31e5493257f9b5$export$ccd4de17604f1cb4 extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(source){
        super();
        this.source = source;
        this.name = `InvalidDelegationSource`;
        this.message = `Since Babylon delegation source can no longer be a contract address ${source}. Please use the smart contract abstraction to set your delegate.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid smart contract code parameter being passed or used
 */ class $7f31e5493257f9b5$export$6831bff83789e2ca extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(message, data){
        super();
        this.message = message;
        this.data = data;
        this.name = 'InvalidCodeParameter';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid smart contract init parameter being passed or used
 */ class $7f31e5493257f9b5$export$12aaf24e6220866b extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(message, data){
        super();
        this.message = message;
        this.data = data;
        this.name = 'InvalidInitParameter';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when conducting a view simulation
 */ class $7f31e5493257f9b5$export$7a371d5bcddb4bc0 extends (0, $8b6476b09e20f53e$export$5460eff990f31920) {
    constructor(message, viewName, failWith, cause){
        super();
        this.message = message;
        this.viewName = viewName;
        this.failWith = failWith;
        this.cause = cause;
        this.name = 'ViewSimulationError';
    }
}
const $7f31e5493257f9b5$export$6ead28c0ab00fb75 = (error)=>{
    if ($7f31e5493257f9b5$var$isJsonString(error.body)) {
        const parsedError = JSON.parse(error.body);
        if (Array.isArray(parsedError) && 'with' in parsedError[parsedError.length - 1]) return parsedError[parsedError.length - 1].with;
    }
};
const $7f31e5493257f9b5$var$isJsonString = (str)=>{
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};
/**
 *  @category Error
 *  @description Error that indicates invalid or unconfigured context when executing a view
 */ class $7f31e5493257f9b5$export$ff1e6a1fdce32aa4 extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(info){
        super();
        this.info = info;
        this.name = 'InvalidViewSimulationContext';
        this.message = `${info} Please configure the context of the view execution in the executeView method.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a mistake happening during the reveal operation
 */ class $7f31e5493257f9b5$export$eb140f52edb72859 extends (0, $8b6476b09e20f53e$export$5460eff990f31920) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'RevealOperationError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a mistake in the parameters in the preparation of an Origination operation
 */ class $7f31e5493257f9b5$export$161bb6caa7045707 extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid balance being passed or used
 */ class $7f31e5493257f9b5$export$94f1b86f3b704c27 extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'InvalidBalanceError';
    }
}
const $7f31e5493257f9b5$export$eb3995ea1d48ce9e = ({ pkh: pkh, secret: secret })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ACTIVATION,
            pkh: pkh,
            secret: secret
        };
    });
const $7f31e5493257f9b5$export$64dd15b44cde1e0b = ({ code: code, init: init, balance: balance = '0', delegate: delegate, storage: storage, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, mutez: mutez = false })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        if (storage !== undefined && init !== undefined) throw new $7f31e5493257f9b5$export$161bb6caa7045707('Storage and Init cannot be set a the same time. Please either use storage or init but not both.');
        if (!Array.isArray(code)) throw new $7f31e5493257f9b5$export$6831bff83789e2ca('Wrong code parameter type, expected an array', code);
        let contractStorage;
        if (storage !== undefined) {
            const storageType = code.find((p)=>'prim' in p && p.prim === 'storage');
            if ((storageType === null || storageType === void 0 ? void 0 : storageType.args) === undefined) throw new $7f31e5493257f9b5$export$6831bff83789e2ca('The storage section is missing from the script', code);
            const schema = new (0, $cbefca4388d58836$export$19342e026b58ebb7)(storageType.args[0]); // TODO
            contractStorage = schema.Encode(storage);
        } else if (init !== undefined && typeof init === 'object') contractStorage = init;
        else throw new $7f31e5493257f9b5$export$12aaf24e6220866b('Wrong init parameter type, expected JSON Michelson', init);
        const script = {
            code: code,
            storage: contractStorage
        };
        if (isNaN(Number(balance))) throw new $7f31e5493257f9b5$export$94f1b86f3b704c27(`Invalid Balance "${balance}", cannot be converted to a number`);
        const operation = {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            balance: mutez ? balance.toString() : (0, $201657d342d01b1b$export$d9468344d3651243)('tz', 'mutez', balance).toString(),
            script: script
        };
        if (delegate) operation.delegate = delegate;
        return operation;
    });
const $7f31e5493257f9b5$export$f3a9991068ba8db1 = ({ to: to, amount: amount, parameter: parameter, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, mutez: mutez = false })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            amount: mutez ? amount.toString() : (0, $201657d342d01b1b$export$d9468344d3651243)('tz', 'mutez', amount).toString(),
            destination: to,
            parameters: parameter
        };
    });
const $7f31e5493257f9b5$export$f6ca8c66abd5d967 = ({ delegate: delegate, source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        const operation = {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            delegate: delegate
        };
        return operation;
    });
const $7f31e5493257f9b5$export$1823ae131c107679 = ({ fee: fee, gasLimit: gasLimit, storageLimit: storageLimit }, source)=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            delegate: source
        };
    });
const $7f31e5493257f9b5$export$638a1bb58510476 = ({ fee: fee, gasLimit: gasLimit, storageLimit: storageLimit }, source, publicKey)=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REVEAL,
            fee: fee,
            public_key: publicKey,
            source: source,
            gas_limit: gasLimit !== null && gasLimit !== void 0 ? gasLimit : $7f31e5493257f9b5$export$199fe2d87a4763cf(source),
            storage_limit: storageLimit
        };
    });
const $7f31e5493257f9b5$export$36ba5bd34bec1f48 = ({ value: value, source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT,
            value: value,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            source: source
        };
    });
const $7f31e5493257f9b5$export$c2b0bb52eb4f8f40 = ({ ticketContents: ticketContents, ticketTy: ticketTy, ticketTicketer: ticketTicketer, ticketAmount: ticketAmount, destination: destination, entrypoint: entrypoint, source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSFER_TICKET,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            source: source,
            ticket_contents: ticketContents,
            ticket_ty: ticketTy,
            ticket_ticketer: ticketTicketer,
            ticket_amount: ticketAmount,
            destination: destination,
            entrypoint: entrypoint
        };
    });
const $7f31e5493257f9b5$export$8bbbca5738264f6e = ({ source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, amount: amount, destination: destination })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            amount: amount,
            destination: destination
        };
    });
const $7f31e5493257f9b5$export$3f02b23ff3ed5b1f = ({ consensus_key: consensus_key, delegate: delegate, destination: destination })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DRAIN_DELEGATE,
            consensus_key: consensus_key,
            delegate: delegate,
            destination: destination
        };
    });
const $7f31e5493257f9b5$export$21e0e83bb1296bf6 = ({ source: source, proposal: proposal, ballot: ballot })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).BALLOT,
            source: source,
            proposal: proposal,
            ballot: ballot
        };
    });
const $7f31e5493257f9b5$export$a50446e8b0c2fbdd = ({ source: source, proposals: proposals })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).PROPOSALS,
            source: source,
            proposals: proposals
        };
    });
const $7f31e5493257f9b5$export$ca68d75e3dde8c6 = ({ source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, pk: pk })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).UPDATE_CONSENSUS_KEY,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            pk: pk
        };
    });
const $7f31e5493257f9b5$export$e778921f9c3d1912 = ({ source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, message: message })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            message: message
        };
    });
const $7f31e5493257f9b5$export$7119c95759340192 = ({ source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, pvmKind: pvmKind, kernel: kernel, parametersType: parametersType })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            pvm_kind: pvmKind,
            kernel: kernel,
            parameters_ty: parametersType
        };
    });
const $7f31e5493257f9b5$export$4b4c6fb209c7f56d = ({ source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, rollup: rollup, cementedCommitment: cementedCommitment, outputProof: outputProof })=>$7f31e5493257f9b5$var$__awaiter(void 0, void 0, void 0, function*() {
        return {
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            rollup: rollup,
            cemented_commitment: cementedCommitment,
            output_proof: outputProof
        };
    });
const $7f31e5493257f9b5$var$attachKind = (op, kind)=>{
    return Object.assign(Object.assign({}, op), {
        kind: kind
    });
};
const $7f31e5493257f9b5$var$findWithKind = (arr, kind)=>{
    if (Array.isArray(arr)) {
        const found = arr.find((op)=>op.kind === kind);
        if (found && $7f31e5493257f9b5$var$isKind(found, kind)) return found;
    }
};
const $7f31e5493257f9b5$var$isKind = (op, kind)=>{
    return op.kind === kind;
};
const $7f31e5493257f9b5$var$isOpWithGasBuffer = (op)=>{
    if (op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION && op.parameters) return true;
    else return [
        'origination',
        'register_global_constant',
        'transfer_ticket',
        'update_consensus_key',
        'smart_rollup_add_messages',
        'smart_rollup_originate'
    ].indexOf(op.kind) !== -1;
};
const $7f31e5493257f9b5$var$isOpWithFee = (op)=>{
    return [
        'transaction',
        'delegation',
        'origination',
        'reveal',
        'register_global_constant',
        'increase_paid_storage',
        'transfer_ticket',
        'update_consensus_key',
        'smart_rollup_add_messages',
        'smart_rollup_originate',
        'smart_rollup_execute_outbox_message'
    ].indexOf(op.kind) !== -1;
};
const $7f31e5493257f9b5$var$isOpRequireReveal = (op)=>{
    return [
        'transaction',
        'delegation',
        'origination',
        'register_global_constant',
        'increase_paid_storage',
        'transfer_ticket',
        'update_consensus_key',
        'smart_rollup_add_messages',
        'smart_rollup_originate',
        'smart_rollup_execute_outbox_message'
    ].indexOf(op.kind) !== -1;
};
const $7f31e5493257f9b5$var$hasMetadata = (op)=>{
    return 'metadata' in op;
};
const $7f31e5493257f9b5$var$hasMetadataWithResult = (op)=>{
    return $7f31e5493257f9b5$var$hasMetadata(op) && 'operation_result' in op.metadata;
};
const $7f31e5493257f9b5$var$hasMetadataWithInternalOperationResult = (op)=>{
    return $7f31e5493257f9b5$var$hasMetadata(op) && 'internal_operation_results' in op.metadata;
};
const $7f31e5493257f9b5$var$isErrorWithMessage = (error)=>{
    return 'with' in error;
};
/**
 *  @category Error
 *  @description Generic tezos error that will be thrown when a mistake occurs when doing an operation; more details here https://tezos.gitlab.io/api/errors.html
 */ class $7f31e5493257f9b5$export$a971cb9d7d565551 extends (0, $8b6476b09e20f53e$export$5460eff990f31920) {
    constructor(errors, errorDetails, operationsWithResults){
        super();
        this.errors = errors;
        this.errorDetails = errorDetails;
        this.operationsWithResults = operationsWithResults;
        this.name = 'TezosOperationError';
        // Last error is 'often' the one with more detail
        this.lastError = errors[errors.length - 1];
        this.message = `(${this.kind}) ${this.id}`;
        if ($7f31e5493257f9b5$var$isErrorWithMessage(this.lastError)) {
            if (this.lastError.with.string) this.message = this.lastError.with.string;
            else if (this.lastError.with.int) this.message = this.lastError.with.int;
            else this.message = JSON.stringify(this.lastError.with);
        }
    }
    get id() {
        return this.lastError.id;
    }
    get kind() {
        return this.lastError.kind;
    }
}
/**
 *  @category Error
 *  @description Tezos error that will be thrown when a mistake happens during the preapply stage
 */ class $7f31e5493257f9b5$export$82778791b4c7e912 extends Error {
    constructor(result){
        super();
        this.result = result;
        this.name = 'TezosPreapplyFailureError';
        this.message = 'Preapply returned an unexpected result';
    }
}
// Flatten all operation content results and internal operation results into a single array
// Some cases where we can have multiple operation results or internal operation results are:
// - When an operation includes a reveal operation
// - When an operation is made using the batch API
// - Smart contract call can contains internal operation results when they call other smart contract internally or originate contracts
const $7f31e5493257f9b5$var$flattenOperationResult = (response)=>{
    const results = Array.isArray(response) ? response : [
        response
    ];
    const returnedResults = [];
    for(let i = 0; i < results.length; i++)for(let j = 0; j < results[i].contents.length; j++){
        const content = results[i].contents[j];
        if ($7f31e5493257f9b5$var$hasMetadataWithResult(content) && 'fee' in content) {
            returnedResults.push(Object.assign({
                fee: content.fee
            }, content.metadata.operation_result));
            if (Array.isArray(content.metadata.internal_operation_results)) content.metadata.internal_operation_results.forEach((x)=>returnedResults.push(x.result));
        }
    }
    return returnedResults;
};
/***
 * @description Flatten all error from preapply response (including internal error)
 */ const $7f31e5493257f9b5$var$flattenErrors = (response, status = 'failed')=>{
    const results = Array.isArray(response) ? response : [
        response
    ];
    let errors = [];
    // Transaction that do not fail will be backtracked in case one failure occur
    for(let i = 0; i < results.length; i++)for(let j = 0; j < results[i].contents.length; j++){
        const content = results[i].contents[j];
        if ($7f31e5493257f9b5$var$hasMetadata(content)) {
            if ($7f31e5493257f9b5$var$hasMetadataWithResult(content) && content.metadata.operation_result.status === status) errors = errors.concat(content.metadata.operation_result.errors || []);
            if ($7f31e5493257f9b5$var$hasMetadataWithInternalOperationResult(content) && Array.isArray(content.metadata.internal_operation_results)) {
                for (const internalResult of content.metadata.internal_operation_results)if ('result' in internalResult && internalResult.result.status === status) errors = errors.concat(internalResult.result.errors || []);
            }
        }
    }
    return errors;
};
/**
 *  @category Error
 *  @description Error that indicates a general failure happening during an origination operation.
 */ class $7f31e5493257f9b5$var$OriginationOperationError extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'OriginationOperationError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid estimate value being passed
 */ class $7f31e5493257f9b5$export$274a49fe3e42e72c extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'InvalidEstimateValueError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid confirmation count has been passed or configured
 */ class $7f31e5493257f9b5$var$InvalidConfirmationCountError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(invalidConfirmations){
        super();
        this.invalidConfirmations = invalidConfirmations;
        this.name = 'InvalidConfirmationCountError';
        this.message = `Invalid confirmation count ${invalidConfirmations} expecting at least 1`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates that confirmation polling timed out
 */ class $7f31e5493257f9b5$var$ConfirmationTimeoutError extends (0, $8b6476b09e20f53e$export$bae979e68e4dc802) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ConfirmationTimeoutError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an error being returned from the RPC response
 */ class $7f31e5493257f9b5$var$RPCResponseError extends (0, $8b6476b09e20f53e$export$5460eff990f31920) {
    constructor(message, cause){
        super();
        this.message = message;
        this.cause = cause;
        this.name = 'RPCResponseError';
    }
}
/**
 * @description Utility class to interact with Tezos operations
 */ class $7f31e5493257f9b5$export$ab5aad00225c5662 {
    get includedInBlock() {
        return this._foundAt;
    }
    /**
     *
     * @param hash Operation hash
     * @param raw Raw operation that was injected
     * @param context Taquito context allowing access to rpc and signer
     * @throws {@link InvalidOperationHashError}
     */ constructor(hash, raw, results, context){
        this.hash = hash;
        this.raw = raw;
        this.results = results;
        this.context = context;
        this._pollingConfig$ = new (0, $4a1890c700519557$export$915d2682b0aa0991)(1);
        this.currentHead$ = this._pollingConfig$.pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((config)=>{
            return new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(config).pipe((0, $9491af11bb0ab327$export$83e74882c5df8fe1)({
                each: config.timeout * 1000,
                with: ()=>(0, $8250ab9260498953$export$8bf7aba4a9e09055)(()=>new $7f31e5493257f9b5$var$ConfirmationTimeoutError(`Confirmation polling timed out`))
            }));
        }), (0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)(()=>{
            return (0, $8312939aeeb1a4f7$export$260e5c0943f31606)(()=>$7f31e5493257f9b5$var$createObservableFromSubscription(this.context.stream.subscribeBlock('head'))).pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((newHead)=>{
                var _a, _b;
                const prevHead = (_b = (_a = this.lastHead) === null || _a === void 0 ? void 0 : _a.header.level) !== null && _b !== void 0 ? _b : newHead.header.level - 1;
                return (0, $48a6b248e7e71175$export$d02631cccf789723)(prevHead + 1, newHead.header.level - prevHead - 1).pipe((0, $9ee54e147202c320$export$c28c8388be0ab31a)((level)=>this.context.readProvider.getBlock(level)), (0, $f8cf36c2ee00b02d$export$23c7d6c8dcd743fe)(newHead));
            }), (0, $3e7edc5b22925f26$export$3f23594af5f37336)((newHead)=>this.lastHead = newHead));
        }), (0, $cd8167599454f872$export$db61d692014e534e)({
            refCount: true
        }));
        // Observable that emit once operation is seen in a block
        this.confirmed$ = this.currentHead$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((head)=>{
            for(let i = 3; i >= 0; i--)head.operations[i].forEach((op)=>{
                if (op.hash === this.hash) this._foundAt = head.header.level;
            });
            if (head.header.level - this._foundAt >= 0) return this._foundAt;
        }), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)((x)=>x !== undefined), (0, $b9a90ca4d933af63$export$43128fadae87b74a)(), (0, $cd8167599454f872$export$db61d692014e534e)());
        this._foundAt = Number.POSITIVE_INFINITY;
        if ((0, $201657d342d01b1b$export$a92a48117d546c9)(this.hash) !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$1a1c2023d3ec7a8a)(this.hash);
        this.confirmed$.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)(), (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>{
            return (0, $195e3b3043565ec4$export$ba255e9e49e00608)((0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58));
        })).subscribe();
    }
    get revealOperation() {
        return Array.isArray(this.results) && this.results.find((op)=>op.kind === 'reveal');
    }
    get revealStatus() {
        if (this.revealOperation) return this.revealOperation.metadata.operation_result.status;
        else return 'unknown';
    }
    get status() {
        return this.results.map((result)=>{
            if ($7f31e5493257f9b5$var$hasMetadataWithResult(result)) return result.metadata.operation_result.status;
            else return 'unknown';
        })[0] || 'unknown';
    }
    /**
     *
     * @param confirmations [0] Number of confirmation to wait for
     * @param timeout [180] Timeout
     */ confirmation(confirmations, timeout) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof confirmations !== 'undefined' && confirmations < 1) throw new $7f31e5493257f9b5$var$InvalidConfirmationCountError(confirmations);
            const { defaultConfirmationCount: defaultConfirmationCount, confirmationPollingTimeoutSecond: confirmationPollingTimeoutSecond } = this.context.config;
            this._pollingConfig$.next({
                timeout: timeout || confirmationPollingTimeoutSecond
            });
            const conf = confirmations !== undefined ? confirmations : defaultConfirmationCount;
            return new Promise((resolve, reject)=>{
                this.confirmed$.pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)(()=>this.currentHead$), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)((head)=>head.header.level - this._foundAt >= conf - 1), (0, $b9a90ca4d933af63$export$43128fadae87b74a)()).subscribe({
                    error: (e)=>reject(e),
                    complete: ()=>resolve(this._foundAt + (conf - 1))
                });
            });
        });
    }
}
class $7f31e5493257f9b5$export$57d05bbf047997b6 extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    sumProp(arr, prop) {
        return arr.reduce((prev, current)=>{
            return prop in current ? Number(current[prop]) + prev : prev;
        }, 0);
    }
    getOriginatedContractAddresses() {
        const originationOpResults = this.results.filter((x)=>x.kind === 'origination');
        let addresses = [];
        for (const res of originationOpResults)if (res.metadata.operation_result.originated_contracts) addresses = [
            ...addresses,
            ...res.metadata.operation_result.originated_contracts
        ];
        return addresses;
    }
    get status() {
        return this.results.filter((result)=>$7f31e5493257f9b5$var$BATCH_KINDS.indexOf(result.kind) !== -1).map((result)=>{
            if ($7f31e5493257f9b5$var$hasMetadataWithResult(result)) {
                const opResult = result.metadata.operation_result;
                return opResult.status;
            } else return 'unknown';
        })[0] || 'unknown';
    }
    get fee() {
        return this.sumProp(this.params, 'fee');
    }
    get gasLimit() {
        return this.sumProp(this.params, 'gas_limit');
    }
    get storageLimit() {
        return this.sumProp(this.params, 'storage_limit');
    }
    get consumedGas() {
        (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).ROUND_UP
        });
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(this.consumedMilliGas).dividedBy(1000).toString();
    }
    get consumedMilliGas() {
        return String(this.sumProp($7f31e5493257f9b5$var$flattenOperationResult({
            contents: this.results
        }), 'consumed_milligas'));
    }
    get storageDiff() {
        return String(this.sumProp($7f31e5493257f9b5$var$flattenOperationResult({
            contents: this.results
        }), 'paid_storage_size_diff'));
    }
    get errors() {
        return $7f31e5493257f9b5$var$flattenErrors({
            contents: this.results
        });
    }
}
class $7f31e5493257f9b5$var$Provider {
    get rpc() {
        return this.context.rpc;
    }
    get signer() {
        return this.context.signer;
    }
    constructor(context){
        this.context = context;
    }
    forge({ opOb: { branch: branch, contents: contents, protocol: protocol }, counter: counter }) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const forgedBytes = yield this.context.forger.forge({
                branch: branch,
                contents: contents
            });
            return {
                opbytes: forgedBytes,
                opOb: {
                    branch: branch,
                    contents: contents,
                    protocol: protocol
                },
                counter: counter
            };
        });
    }
    estimate(_a, estimator) {
        var { fee: fee, gasLimit: gasLimit, storageLimit: storageLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "gasLimit",
            "storageLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            let calculatedFee = fee;
            let calculatedGas = gasLimit;
            let calculatedStorage = storageLimit;
            if (calculatedFee && calculatedFee % 1 !== 0) throw new $7f31e5493257f9b5$export$274a49fe3e42e72c(`Fee value must not be a decimal: ${calculatedFee}`);
            if (calculatedGas && calculatedGas % 1 !== 0) throw new $7f31e5493257f9b5$export$274a49fe3e42e72c(`Gas Limit value must not be a decimal: ${calculatedGas}`);
            if (calculatedStorage && calculatedStorage % 1 !== 0) throw new $7f31e5493257f9b5$export$274a49fe3e42e72c(`Storage Limit value must not be a decimal: ${calculatedStorage}`);
            if (fee === undefined || gasLimit === undefined || storageLimit === undefined) {
                const estimation = yield estimator(Object.assign({
                    fee: fee,
                    gasLimit: gasLimit,
                    storageLimit: storageLimit
                }, rest));
                calculatedFee !== null && calculatedFee !== void 0 ? calculatedFee : calculatedFee = estimation.suggestedFeeMutez;
                calculatedGas !== null && calculatedGas !== void 0 ? calculatedGas : calculatedGas = estimation.gasLimit;
                calculatedStorage !== null && calculatedStorage !== void 0 ? calculatedStorage : calculatedStorage = estimation.storageLimit;
            }
            return {
                fee: calculatedFee,
                gasLimit: calculatedGas,
                storageLimit: calculatedStorage
            };
        });
    }
    getRPCOp(param) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            switch(param.kind){
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION:
                    return $7f31e5493257f9b5$export$f3a9991068ba8db1(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION:
                    return $7f31e5493257f9b5$export$64dd15b44cde1e0b((yield this.context.parser.prepareCodeOrigination(Object.assign({}, param))));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION:
                    return $7f31e5493257f9b5$export$f6ca8c66abd5d967(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT:
                    return $7f31e5493257f9b5$export$36ba5bd34bec1f48(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                    return $7f31e5493257f9b5$export$8bbbca5738264f6e(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSFER_TICKET:
                    return $7f31e5493257f9b5$export$c2b0bb52eb4f8f40(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES:
                    return $7f31e5493257f9b5$export$e778921f9c3d1912(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE:
                    return $7f31e5493257f9b5$export$7119c95759340192(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE:
                    return $7f31e5493257f9b5$export$4b4c6fb209c7f56d(Object.assign({}, param));
                default:
                    throw new (0, $8b6476b09e20f53e$export$bc5be87550569b55)(param.kind);
            }
        });
    }
    runOperation(op) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return {
                opResponse: yield this.rpc.runOperation(op),
                op: op,
                context: this.context.clone()
            };
        });
    }
    simulate(op) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return {
                opResponse: yield this.rpc.simulateOperation(op),
                op: op,
                context: this.context.clone()
            };
        });
    }
    isRevealOpNeeded(op, pkh) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return !(yield this.isAccountRevealRequired(pkh)) || !this.isRevealRequiredForOpType(op) ? false : true;
        });
    }
    isAccountRevealRequired(publicKeyHash) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return !(yield this.context.readProvider.isAccountRevealed(publicKeyHash, 'head'));
        });
    }
    isRevealRequiredForOpType(op) {
        let opRequireReveal = false;
        for (const operation of op)if ($7f31e5493257f9b5$var$isOpRequireReveal(operation)) opRequireReveal = true;
        return opRequireReveal;
    }
    signAndInject(forgedBytes) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const signed = yield this.signer.sign(forgedBytes.opbytes, new Uint8Array([
                3
            ]));
            forgedBytes.opbytes = signed.sbytes;
            forgedBytes.opOb.signature = signed.prefixSig;
            const opResponse = [];
            const results = yield this.rpc.preapplyOperations([
                forgedBytes.opOb
            ]);
            if (!Array.isArray(results)) throw new $7f31e5493257f9b5$export$82778791b4c7e912(results);
            for(let i = 0; i < results.length; i++)for(let j = 0; j < results[i].contents.length; j++)opResponse.push(results[i].contents[j]);
            const errors = $7f31e5493257f9b5$var$flattenErrors(results);
            if (errors.length) throw new $7f31e5493257f9b5$export$a971cb9d7d565551(errors, 'Error occurred during validation simulation of operation', opResponse);
            return {
                hash: yield this.context.injector.inject(forgedBytes.opbytes),
                forgedBytes: forgedBytes,
                opResponse: opResponse,
                context: this.context.clone()
            };
        });
    }
}
class $7f31e5493257f9b5$export$970d9c5f24c420ee {
    constructor(walletProvider, context){
        this.walletProvider = walletProvider;
        this.context = context;
        this.operations = [];
    }
    /**
     *
     * @description Add a transaction operation to the batch
     *
     * @param params Transfer operation parameter
     */ withTransfer(params) {
        const toValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(params.to);
        if (toValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.to, (0, $201657d342d01b1b$export$a2057601792df650)(toValidation));
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION
        }, params));
        return this;
    }
    /**
     *
     * @description Add a contract call to the batch
     *
     * @param params Call a contract method
     * @param options Generic operation parameters
     */ withContractCall(params, options = {}) {
        return this.withTransfer(params.toTransferParams(options));
    }
    /**
     *
     * @description Add a delegation operation to the batch
     *
     * @param params Delegation operation parameter
     */ withDelegation(params) {
        var _a;
        const delegateValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)((_a = params.delegate) !== null && _a !== void 0 ? _a : '');
        if (params.delegate && delegateValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.delegate, (0, $201657d342d01b1b$export$a2057601792df650)(delegateValidation));
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION
        }, params));
        return this;
    }
    /**
     *
     * @description Add an origination operation to the batch
     *
     * @param params Origination operation parameter
     */ withOrigination(params) {
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION
        }, params));
        return this;
    }
    /**
     *
     * @description Add an IncreasePaidStorage operation to the batch
     *
     * @param param IncreasePaidStorage operation parameter
     */ withIncreasePaidStorage(params) {
        const destinationValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(params.destination);
        if (destinationValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.destination, (0, $201657d342d01b1b$export$a2057601792df650)(destinationValidation));
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE
        }, params));
        return this;
    }
    mapOperation(param) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            switch(param.kind){
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION:
                    return this.walletProvider.mapTransferParamsToWalletParams(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                            return param;
                        }));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION:
                    return this.walletProvider.mapOriginateParamsToWalletParams(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                            return this.context.parser.prepareCodeOrigination(Object.assign({}, param));
                        }));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION:
                    return this.walletProvider.mapDelegateParamsToWalletParams(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                            return param;
                        }));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                    return this.walletProvider.mapIncreasePaidStorageWalletParams(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                            return param;
                        }));
                default:
                    throw new (0, $8b6476b09e20f53e$export$bc5be87550569b55)(JSON.stringify(param.kind));
            }
        });
    }
    /**
     *
     * @description Add a group operation to the batch. Operation will be applied in the order they are in the params array
     *
     * @param params Operations parameter
     * @throws {@link InvalidOperationKindError}
     */ with(params) {
        for (const param of params)switch(param.kind){
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION:
                this.withTransfer(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION:
                this.withOrigination(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION:
                this.withDelegation(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                this.withIncreasePaidStorage(param);
                break;
            default:
                throw new (0, $8b6476b09e20f53e$export$bc5be87550569b55)(JSON.stringify(param.kind));
        }
        return this;
    }
    /**
     *
     * @description Submit batch operation to wallet
     *
     */ send() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const ops = [];
            for (const op of this.operations)ops.push((yield this.mapOperation(op)));
            const opHash = yield this.walletProvider.sendOperations(ops);
            return this.context.operationFactory.createBatchOperation(opHash);
        });
    }
}
class $7f31e5493257f9b5$export$bcca3ea514774656 {
    constructor(context){
        this.context = context;
        this.walletCommand = (send)=>{
            return {
                send: send
            };
        };
    }
    get walletProvider() {
        return this.context.walletProvider;
    }
    /**
     * @description Retrieve the PKH of the account that is currently in use by the wallet
     *
     * @param option Option to use while fetching the PKH.
     * If forceRefetch is specified the wallet provider implementation will refetch the PKH from the wallet
     */ pkh({ forceRefetch: forceRefetch } = {}) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._pkh || forceRefetch) this._pkh = yield this.walletProvider.getPKH();
            return this._pkh;
        });
    }
    /**
     * @description Retrieve the PK of the account that is currently in use by the wallet
     *
     * @param option Option to use while fetching the PK.
     * If forceRefetch is specified the wallet provider implementation will refetch the PK from the wallet
     */ pk({ forceRefetch: forceRefetch } = {}) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._pk || forceRefetch) this._pk = yield this.walletProvider.getPK();
            return this._pk;
        });
    }
    /**
     *
     * @description Originate a new contract according to the script in parameters.
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param originateParams Originate operation parameter
     */ originate(params) {
        return this.walletCommand(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapOriginateParamsToWalletParams(()=>this.context.parser.prepareCodeOrigination(Object.assign({}, params)));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createOriginationOperation(opHash);
            }));
    }
    /**
     *
     * @description Set the delegate for a contract.
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param delegateParams operation parameter
     */ setDelegate(params) {
        var _a;
        const delegateValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)((_a = params.delegate) !== null && _a !== void 0 ? _a : '');
        if (params.delegate && delegateValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.delegate, (0, $201657d342d01b1b$export$a2057601792df650)(delegateValidation));
        return this.walletCommand(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapDelegateParamsToWalletParams(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                        return params;
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createDelegationOperation(opHash);
            }));
    }
    /**
     *
     * @description failing_noop operation that is guaranteed to fail. DISCLAIMER: Not all wallets support signing failing_noop operations.
     *
     * @returns Signature for a failing_noop
     *
     * @param params operation parameter
     */ signFailingNoop(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const op = {
                kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).FAILING_NOOP,
                arbitrary: params.arbitrary
            };
            const hash = yield this.context.readProvider.getBlockHash(params.basedOnBlock);
            const forgedBytes = yield this.context.forger.forge({
                branch: hash,
                contents: [
                    op
                ]
            });
            const signature = yield this.walletProvider.sign(forgedBytes, Uint8Array.from([
                3
            ]));
            return {
                signature: signature,
                bytes: forgedBytes,
                signedContent: {
                    branch: hash,
                    contents: [
                        {
                            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).FAILING_NOOP,
                            arbitrary: params.arbitrary
                        }
                    ]
                }
            };
        });
    }
    /**
     *
     * @description Register the current address as delegate.
     *
     * @returns An operation handle with the result from the rpc node
     *
     */ registerDelegate() {
        return this.walletCommand(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapDelegateParamsToWalletParams(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                        const delegate = yield this.pkh();
                        return {
                            delegate: delegate
                        };
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createDelegationOperation(opHash);
            }));
    }
    /**
     *
     * @description Transfer tezos tokens from current address to a specific address or call a smart contract.
     *
     * @returns A wallet command from which we can send the operation to the wallet
     *
     * @param params operation parameter
     */ transfer(params) {
        const toValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(params.to);
        if (toValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.to, (0, $201657d342d01b1b$export$a2057601792df650)(toValidation));
        return this.walletCommand(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapTransferParamsToWalletParams(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                        return params;
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createTransactionOperation(opHash);
            }));
    }
    /**
     *
     * @description
     *
     * @returns
     *
     * @param params
     */ increasePaidStorage(params) {
        const destinationValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(params.destination);
        if (destinationValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.destination, (0, $201657d342d01b1b$export$a2057601792df650)(destinationValidation));
        return this.walletCommand(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapIncreasePaidStorageWalletParams(()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                        return params;
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createIncreasePaidStorageOperation(opHash);
            }));
    }
    /**
     *
     * @description Create a batch of operation
     *
     * @returns A batch object from which we can add more operation or send a command to the wallet to execute the batch
     *
     * @param params List of operation to initialize the batch with
     */ batch(params) {
        const batch = new $7f31e5493257f9b5$export$970d9c5f24c420ee(this.walletProvider, this.context);
        if (Array.isArray(params)) batch.with(params);
        return batch;
    }
    /**
     *
     * @description Create an smart contract abstraction for the address specified. Calling entrypoints with the returned
     * smart contract abstraction will leverage the wallet provider to make smart contract calls
     *
     * @param address Smart contract address
     * @throws {@link InvalidContractAddressError} If the contract address is not valid
     */ at(address, contractAbstractionComposer = (x)=>x) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const addressValidation = (0, $201657d342d01b1b$export$2ed905adbd9a56f2)(address);
            if (addressValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$193774326795229b)(address, (0, $201657d342d01b1b$export$a2057601792df650)(addressValidation));
            const rpc = this.context.withExtensions().rpc;
            const readProvider = this.context.withExtensions().readProvider;
            const script = yield readProvider.getScript(address, 'head');
            const entrypoints = yield readProvider.getEntrypoints(address);
            const abs = new $7f31e5493257f9b5$export$25cde19dc6218700(address, script, this, this.context.contract, entrypoints, rpc, readProvider);
            return contractAbstractionComposer(abs, this.context);
        });
    }
    /**
     * @deprecated Deprecated in favor of {@link Wallet.pk} will be removed in v19.1
     * @description Retrieve the PK of the account that is currently in use by the wallet
     */ getPK() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.pk();
        });
    }
}
const $7f31e5493257f9b5$var$receiptFromOperation = (op, { ALLOCATION_BURN: ALLOCATION_BURN, ORIGINATION_BURN: ORIGINATION_BURN } = {
    ALLOCATION_BURN: 257,
    ORIGINATION_BURN: 257
})=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).config({
        DECIMAL_PLACES: 0,
        ROUNDING_MODE: (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).ROUND_UP
    });
    const operationResults = $7f31e5493257f9b5$var$flattenOperationResult({
        contents: op
    });
    let totalMilliGas = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    let totalStorage = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    let totalFee = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    let totalOriginationBurn = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    let totalAllocationBurn = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    let totalPaidStorageDiff = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    operationResults.forEach((result)=>{
        totalFee = totalFee.plus(result.fee || 0);
        totalOriginationBurn = totalOriginationBurn.plus(Array.isArray(result.originated_contracts) ? result.originated_contracts.length * ORIGINATION_BURN : 0);
        totalAllocationBurn = totalAllocationBurn.plus('allocated_destination_contract' in result ? ALLOCATION_BURN : 0);
        totalMilliGas = totalMilliGas.plus(result.consumed_milligas || 0);
        totalPaidStorageDiff = totalPaidStorageDiff.plus('paid_storage_size_diff' in result ? Number(result.paid_storage_size_diff) || 0 : 0);
    });
    totalStorage = totalStorage.plus(totalAllocationBurn).plus(totalOriginationBurn).plus(totalPaidStorageDiff);
    return {
        totalFee: totalFee,
        totalMilliGas: totalMilliGas,
        totalGas: totalMilliGas.dividedBy(1000),
        totalStorage: totalStorage,
        totalAllocationBurn: totalAllocationBurn,
        totalOriginationBurn: totalOriginationBurn,
        totalPaidStorageDiff: totalPaidStorageDiff,
        totalStorageBurn: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(totalStorage.multipliedBy($7f31e5493257f9b5$export$961faea0d634ab07))
    };
};
/**
 *  @category Error
 *  @description Error that indicates undefined confirmation has not been specified or configured
 */ class $7f31e5493257f9b5$var$ConfirmationUndefinedError extends (0, $8b6476b09e20f53e$export$32f4d70b2fb302b1) {
    constructor(){
        super();
        this.name = 'ConfirmationUndefinedError';
        this.message = 'Default confirmation count can not be undefined';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a generic failure when trying to fetch an observable
 */ class $7f31e5493257f9b5$var$ObservableError extends (0, $8b6476b09e20f53e$export$bae979e68e4dc802) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ObservableError';
    }
}
const $7f31e5493257f9b5$var$MAX_BRANCH_ANCESTORS = 60;
/**
 * @description WalletOperation allows to monitor operation inclusion on chains and surface information related to the operation
 */ class $7f31e5493257f9b5$export$903c688feb2d259e {
    operationResults() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this._operationResult.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)()).toPromise();
        });
    }
    /**
     * @description Receipt expose the total amount of tezos token burn and spent on fees
     * The promise returned by receipt will resolve only once the transaction is included
     */ receipt() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const results = yield this.operationResults();
            if (!results) throw new $7f31e5493257f9b5$var$ObservableError('Unable to get operation results');
            return $7f31e5493257f9b5$var$receiptFromOperation(results);
        });
    }
    /**
     *
     * @param opHash Operation hash
     * @param raw Raw operation that was injected
     * @param context Taquito context allowing access to rpc and signer
     * @throws {InvalidOperationHashError}
     */ constructor(opHash, context, _newHead$){
        this.opHash = opHash;
        this.context = context;
        this._newHead$ = _newHead$;
        this._operationResult = new (0, $4a1890c700519557$export$915d2682b0aa0991)(1);
        this._includedInBlock = new (0, $4a1890c700519557$export$915d2682b0aa0991)(1);
        this._included = false;
        this.newHead$ = this._newHead$.pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((newHead)=>{
            var _a, _b;
            const prevHead = (_b = (_a = this.lastHead) === null || _a === void 0 ? void 0 : _a.header.level) !== null && _b !== void 0 ? _b : newHead.header.level - 1;
            return (0, $48a6b248e7e71175$export$d02631cccf789723)(prevHead + 1, newHead.header.level - prevHead - 1).pipe((0, $9ee54e147202c320$export$c28c8388be0ab31a)((level)=>this.context.readProvider.getBlock(level)), (0, $f8cf36c2ee00b02d$export$23c7d6c8dcd743fe)(newHead));
        }), (0, $3e7edc5b22925f26$export$3f23594af5f37336)((newHead)=>this.lastHead = newHead), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)({
            connector: ()=>new (0, $4a1890c700519557$export$915d2682b0aa0991)(1),
            resetOnError: false,
            resetOnComplete: false,
            resetOnRefCountZero: false
        }));
        // Observable that emit once operation is seen in a block
        this.confirmed$ = this.newHead$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((head)=>{
            for (const opGroup of head.operations){
                for (const op of opGroup)if (op.hash === this.opHash) {
                    this._included = true;
                    this._includedInBlock.next(head);
                    this._operationResult.next(op.contents);
                    // Return the block where the operation was found
                    return head;
                }
            }
        }), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)((x)=>{
            return typeof x !== 'undefined';
        }), (0, $b9a90ca4d933af63$export$43128fadae87b74a)(), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)({
            connector: ()=>new (0, $4a1890c700519557$export$915d2682b0aa0991)(1),
            resetOnError: false,
            resetOnComplete: false,
            resetOnRefCountZero: false
        }));
        if ((0, $201657d342d01b1b$export$a92a48117d546c9)(this.opHash) !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$1a1c2023d3ec7a8a)(this.opHash);
        this.confirmed$.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)(), (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>(0, $195e3b3043565ec4$export$ba255e9e49e00608)(undefined))).subscribe();
    }
    getCurrentConfirmation() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 0;
            return (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
                this._includedInBlock,
                (0, $2fe2b696577919a5$export$6788812c4e6611e6)(this.context.readProvider.getBlock('head'))
            ]).pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)(([foundAtBlock, head])=>{
                return head.header.level - foundAtBlock.header.level + 1;
            }), (0, $b9a90ca4d933af63$export$43128fadae87b74a)()).toPromise();
        });
    }
    isInCurrentBranch(tipBlockIdentifier = 'head') {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            // By default it is assumed that the operation is in the current branch
            if (!this._included) return true;
            const tipBlockHeaderLevel = yield this.context.readProvider.getBlockLevel(tipBlockIdentifier);
            const inclusionBlock = yield this._includedInBlock.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)()).toPromise();
            if (!inclusionBlock) throw new $7f31e5493257f9b5$var$ObservableError('Inclusion block is undefined');
            const levelDiff = tipBlockHeaderLevel - inclusionBlock.header.level;
            // Block produced before the operation is included are assumed to be part of the current branch
            if (levelDiff <= 0) return true;
            const tipBlockLevel = Math.min(inclusionBlock.header.level + levelDiff, inclusionBlock.header.level + $7f31e5493257f9b5$var$MAX_BRANCH_ANCESTORS);
            const blocks = new Set((yield this.context.readProvider.getLiveBlocks(tipBlockLevel)));
            return blocks.has(inclusionBlock.hash);
        });
    }
    confirmationObservable(confirmations) {
        if (typeof confirmations !== 'undefined' && confirmations < 1) throw new $7f31e5493257f9b5$var$InvalidConfirmationCountError(confirmations);
        const { defaultConfirmationCount: defaultConfirmationCount } = this.context.config;
        const conf = confirmations !== undefined ? confirmations : defaultConfirmationCount;
        if (conf === undefined) throw new $7f31e5493257f9b5$var$ConfirmationUndefinedError();
        return (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
            this._includedInBlock,
            this.newHead$
        ]).pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)(([, previousHead], [, newHead])=>{
            return previousHead.hash === newHead.hash;
        }), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([foundAtBlock, head])=>{
            return {
                block: head,
                expectedConfirmation: conf,
                currentConfirmation: head.header.level - foundAtBlock.header.level + 1,
                completed: head.header.level - foundAtBlock.header.level >= conf - 1,
                isInCurrentBranch: ()=>this.isInCurrentBranch(head.hash)
            };
        }), (0, $106fa5810fba1e6e$export$9384c7afe4015e42)(({ completed: completed })=>!completed, true));
    }
    /**
     *
     * @param confirmations [0] Number of confirmation to wait for
     */ confirmation(confirmations) {
        return this.confirmationObservable(confirmations).toPromise();
    }
}
class $7f31e5493257f9b5$export$8fc855f2a23d265f extends $7f31e5493257f9b5$export$903c688feb2d259e {
    constructor(opHash, context, newHead$){
        super(opHash, context, newHead$);
        this.opHash = opHash;
        this.context = context;
    }
    revealOperation() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $7f31e5493257f9b5$var$ObservableError('operationResult returned undefined');
            return operationResult.find((x)=>x.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REVEAL);
        });
    }
    transactionOperation() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $7f31e5493257f9b5$var$ObservableError('operationResult returned undefined');
            return operationResult.find((x)=>x.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION);
        });
    }
    status() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 'pending';
            const op = yield this.transactionOperation();
            if (!op) return 'unknown';
            return op.metadata.operation_result.status;
        });
    }
}
class $7f31e5493257f9b5$export$fc9b2020ddc4a55c extends $7f31e5493257f9b5$export$903c688feb2d259e {
    constructor(opHash, context, newHead$){
        super(opHash, context, newHead$);
        this.opHash = opHash;
        this.context = context;
    }
    originationOperation() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (operationResult) return $7f31e5493257f9b5$var$findWithKind(operationResult, (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION);
            else throw new $7f31e5493257f9b5$var$ObservableError('Unable to fetch operation result');
        });
    }
    revealOperation() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (operationResult) return $7f31e5493257f9b5$var$findWithKind(operationResult, (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REVEAL);
            else throw new $7f31e5493257f9b5$var$ObservableError('Unable to fetch operation result');
        });
    }
    status() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 'pending';
            const op = yield this.originationOperation();
            if (!op) return 'unknown';
            return op.metadata.operation_result.status;
        });
    }
    contract() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const op = yield this.originationOperation();
            const address = ((op === null || op === void 0 ? void 0 : op.metadata.operation_result.originated_contracts) || [])[0];
            return this.context.wallet.at(address);
        });
    }
}
class $7f31e5493257f9b5$export$ac7733ff4c8bbbf1 extends $7f31e5493257f9b5$export$903c688feb2d259e {
    constructor(opHash, context, newHead$){
        super(opHash, context, newHead$);
        this.opHash = opHash;
        this.context = context;
    }
    revealOperation() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (operationResult) return operationResult.find((x)=>x.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REVEAL);
            else throw new $7f31e5493257f9b5$var$ObservableError('Unable to fetch operation result');
        });
    }
    delegationOperation() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (operationResult) return operationResult.find((x)=>x.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION);
            else throw new $7f31e5493257f9b5$var$ObservableError('Unable to fetch operation result');
        });
    }
    status() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 'pending';
            const op = yield this.delegationOperation();
            if (!op) return 'unknown';
            return op.metadata.operation_result.status;
        });
    }
}
class $7f31e5493257f9b5$export$7e71cfc210e8a8fd {
    constructor(context){
        this.context = context;
    }
    getPKH() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.context.signer.publicKeyHash();
        });
    }
    getPK() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.context.signer.publicKey();
        });
    }
    mapTransferParamsToWalletParams(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return $7f31e5493257f9b5$var$attachKind((yield params()), (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION);
        });
    }
    mapOriginateParamsToWalletParams(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return $7f31e5493257f9b5$var$attachKind((yield params()), (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION);
        });
    }
    mapDelegateParamsToWalletParams(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return $7f31e5493257f9b5$var$attachKind((yield params()), (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION);
        });
    }
    mapIncreasePaidStorageWalletParams(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return $7f31e5493257f9b5$var$attachKind((yield params()), (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE);
        });
    }
    sendOperations(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const op = yield this.context.batch.batch(params).send();
            return op.hash;
        });
    }
    sign(bytes, watermark) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { prefixSig: prefixSig } = yield this.context.signer.sign(bytes, watermark);
            return prefixSig;
        });
    }
}
/**
 * @description Utility class to send smart contract operation
 * The format for the arguments is the object representation
 */ class $7f31e5493257f9b5$export$c767420b65354e4c {
    constructor(provider, address, parameterSchema, name, args = 'unit', isMultipleEntrypoint = true, isAnonymous = false){
        this.provider = provider;
        this.address = address;
        this.parameterSchema = parameterSchema;
        this.name = name;
        this.args = args;
        this.isMultipleEntrypoint = isMultipleEntrypoint;
        this.isAnonymous = isAnonymous;
    }
    /**
     * @description Get the signature of the smart contract method
     */ getSignature() {
        return this.isAnonymous ? this.parameterSchema.ExtractSchema()[this.name] : this.parameterSchema.ExtractSchema();
    }
    /**
     *
     * @description Send the smart contract operation
     *
     * @param Options generic operation parameter
     */ send(params = {}) {
        if (this.provider instanceof $7f31e5493257f9b5$export$bcca3ea514774656) return this.provider.transfer(this.toTransferParams(params)).send();
        else return this.provider.transfer(this.toTransferParams(params));
    }
    /**
     *
     * @description Create transfer params to be used with TezosToolkit.contract.transfer methods
     *
     * @param Options generic transfer operation parameters
     */ toTransferParams({ fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, source: source, amount: amount = 0, mutez: mutez = false } = {}) {
        const fullTransferParams = {
            to: this.address,
            amount: amount,
            fee: fee,
            mutez: mutez,
            source: source,
            gasLimit: gasLimit,
            storageLimit: storageLimit,
            parameter: {
                entrypoint: this.isMultipleEntrypoint ? this.name : $7f31e5493257f9b5$export$a4f3c2bebc69dfa9,
                value: this.isAnonymous ? this.parameterSchema.EncodeObject({
                    [this.name]: this.args
                }) : this.parameterSchema.EncodeObject(this.args)
            }
        };
        return fullTransferParams;
    }
}
/**
 * @description Utility class to send smart contract operation
 * The format for the arguments is the flattened representation
 */ class $7f31e5493257f9b5$export$1fd08f6bbb20232a {
    constructor(provider, address, parameterSchema, name, args, isMultipleEntrypoint = true, isAnonymous = false){
        this.provider = provider;
        this.address = address;
        this.parameterSchema = parameterSchema;
        this.name = name;
        this.args = args;
        this.isMultipleEntrypoint = isMultipleEntrypoint;
        this.isAnonymous = isAnonymous;
    }
    validateArgs(args, schema, name) {
        const sigs = schema.ExtractSignatures();
        if (!sigs.find((x)=>x.length === args.length)) throw new $7f31e5493257f9b5$export$e569b97a5d46005c(name, sigs, args);
    }
    /**
     * @description Get the schema of the smart contract method
     */ get schema() {
        return this.isAnonymous ? this.parameterSchema.ExtractSchema()[this.name] : this.parameterSchema.ExtractSchema();
    }
    /**
     * @description Get the signature of the smart contract method
     */ getSignature() {
        if (this.isAnonymous) {
            const sig = this.parameterSchema.ExtractSignatures().find((x)=>x[0] === this.name);
            if (sig) {
                sig.shift();
                return sig;
            }
        } else {
            const sig = this.parameterSchema.ExtractSignatures();
            return sig.length == 1 ? sig[0] : sig;
        }
    }
    /**
     *
     * @description Send the smart contract operation
     *
     * @param Options generic operation parameter
     */ send(params = {}) {
        if (this.provider instanceof $7f31e5493257f9b5$export$bcca3ea514774656) return this.provider.transfer(this.toTransferParams(params)).send();
        else return this.provider.transfer(this.toTransferParams(params));
    }
    /**
     *
     * @description Create transfer params to be used with TezosToolkit.contract.transfer methods
     *
     * @param Options generic transfer operation parameters
     */ toTransferParams({ fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, source: source, amount: amount = 0, mutez: mutez = false } = {}) {
        const fullTransferParams = {
            to: this.address,
            amount: amount,
            fee: fee,
            mutez: mutez,
            source: source,
            gasLimit: gasLimit,
            storageLimit: storageLimit,
            parameter: {
                entrypoint: this.isMultipleEntrypoint ? this.name : $7f31e5493257f9b5$export$a4f3c2bebc69dfa9,
                value: this.isAnonymous ? this.parameterSchema.Encode(this.name, ...this.args) : this.parameterSchema.Encode(...this.args)
            }
        };
        return fullTransferParams;
    }
}
class $7f31e5493257f9b5$var$OnChainView {
    constructor(_rpc, _readProvider, _contractAddress, _smartContractViewSchema, _contractStorageType, _args = 'Unit'){
        this._rpc = _rpc;
        this._readProvider = _readProvider;
        this._contractAddress = _contractAddress;
        this._smartContractViewSchema = _smartContractViewSchema;
        this._contractStorageType = _contractStorageType;
        this._args = _args;
    }
    /**
     * @description Get the signature of the smart contract view
     */ getSignature() {
        return {
            parameter: this._smartContractViewSchema.extractArgsSchema(),
            result: this._smartContractViewSchema.extractResultSchema()
        };
    }
    /**
     * @description Get the result of the view simulation
     * @param executionContext.source the public key hash of the account who initialized this view execution.
     * @param executionContext.viewCaller the contract address which is the caller of view.
     */ executeView(executionContext) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            this.verifyContextExecution(executionContext);
            const chainId = yield this._readProvider.getChainId();
            const viewArgs = this.transformArgsToMichelson();
            const scriptView = {
                contract: this._contractAddress,
                view: this._smartContractViewSchema.viewName,
                input: viewArgs,
                chain_id: chainId,
                source: executionContext.viewCaller
            };
            if (executionContext.source) scriptView.payer = executionContext.source;
            return this.executeViewAndDecodeResult(scriptView);
        });
    }
    verifyContextExecution(executionContext) {
        if (executionContext.source && (0, $201657d342d01b1b$export$f78173835dcde49f)(executionContext.source) !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new $7f31e5493257f9b5$export$ff1e6a1fdce32aa4(`The source account who initialized the view execution is invalid: ${executionContext.source}.`);
        if (!executionContext.viewCaller || (0, $201657d342d01b1b$export$f78173835dcde49f)(executionContext.viewCaller) !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new $7f31e5493257f9b5$export$ff1e6a1fdce32aa4(`The contract which is the caller of view is invalid: ${executionContext.viewCaller}.`);
    }
    transformArgsToMichelson() {
        try {
            return this._smartContractViewSchema.encodeViewArgs(this._args);
        } catch (error) {
            throw new (0, $8b6476b09e20f53e$export$f9ce6a924724628b)(this._smartContractViewSchema.viewName, this.getSignature(), this._args, error);
        }
    }
    /**
     * @description Loops through the view's instructions and replace BALANCE, SENDER, SELF_ADDRESS and AMOUNT with Michelson expressions that match the current context, if applicable.
     *
     * Certain specific instructions have different semantics in view:
     * BALANCE represents the current amount of mutez held by the contract where view is;
     * SENDER represents the contract which is the caller of view;
     * SELF_ADDRESS represents the contract where view is;
     * AMOUNT is always 0 mutez.
     *
     */ adaptViewCodeToContext(instructions, viewCaller, contractBalance) {
        const instructionsToReplace = {
            BALANCE: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'mutez'
                        },
                        {
                            int: contractBalance
                        }
                    ]
                }
            ],
            SENDER: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'address'
                        },
                        {
                            string: viewCaller
                        }
                    ]
                }
            ],
            SELF_ADDRESS: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'address'
                        },
                        {
                            string: this._contractAddress
                        }
                    ]
                }
            ],
            AMOUNT: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'mutez'
                        },
                        {
                            int: '0'
                        }
                    ]
                }
            ]
        };
        instructions.forEach((inst, i)=>{
            if (inst.prim in instructionsToReplace) instructions[i] = Object(instructionsToReplace)[inst.prim];
            if (inst.args && inst.args.length !== 0) this.adaptViewCodeToContext(inst.args, viewCaller, contractBalance);
            else if (Array.isArray(inst)) this.adaptViewCodeToContext(inst, viewCaller, contractBalance);
        });
        return instructions;
    }
    executeViewAndDecodeResult(viewScript) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            let storage;
            try {
                storage = (yield this._rpc.runScriptView(viewScript)).data;
            } catch (error) {
                const failWith = $7f31e5493257f9b5$export$6ead28c0ab00fb75(error);
                throw failWith ? new $7f31e5493257f9b5$export$7a371d5bcddb4bc0(`The simulation of the on-chain view named ${this._smartContractViewSchema.viewName} failed with: ${JSON.stringify(failWith)}`, this._smartContractViewSchema.viewName, failWith, error) : error;
            }
            return this._smartContractViewSchema.decodeViewResult(storage);
        });
    }
}
class $7f31e5493257f9b5$var$ContractMethodFactory {
    constructor(provider, contractAddress){
        this.provider = provider;
        this.contractAddress = contractAddress;
    }
    createContractMethodFlatParams(smartContractMethodSchema, smartContractMethodName, args, isMultipleEntrypoint = true, isAnonymous = false) {
        return new $7f31e5493257f9b5$export$1fd08f6bbb20232a(this.provider, this.contractAddress, smartContractMethodSchema, smartContractMethodName, args, isMultipleEntrypoint, isAnonymous);
    }
    createContractMethodObjectParam(smartContractMethodSchema, smartContractMethodName, args, isMultipleEntrypoint = true, isAnonymous = false) {
        return new $7f31e5493257f9b5$export$c767420b65354e4c(this.provider, this.contractAddress, smartContractMethodSchema, smartContractMethodName, args, isMultipleEntrypoint, isAnonymous);
    }
    createContractViewObjectParam(rpc, readProvider, smartContractViewSchema, contractStorageType, viewArgs) {
        return new $7f31e5493257f9b5$var$OnChainView(rpc, readProvider, this.contractAddress, smartContractViewSchema, contractStorageType, viewArgs);
    }
}
const $7f31e5493257f9b5$export$a4f3c2bebc69dfa9 = 'default';
/**
 * @description Utility class to retrieve data from a smart contract's storage without incurring fees via a contract's view method
 */ class $7f31e5493257f9b5$export$63fe1d55d80baff5 {
    constructor(currentContract, name, callbackParametersSchema, parameterSchema, args, rpc, readProvider){
        this.currentContract = currentContract;
        this.name = name;
        this.callbackParametersSchema = callbackParametersSchema;
        this.parameterSchema = parameterSchema;
        this.args = args;
        this.rpc = rpc;
        this.readProvider = readProvider;
    }
    read(chainId) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const chainIdValidation = (0, $201657d342d01b1b$export$cb16a5d2af893df6)(chainId !== null && chainId !== void 0 ? chainId : '');
            if ((0, $201657d342d01b1b$export$2ed905adbd9a56f2)(chainId !== null && chainId !== void 0 ? chainId : '') == (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$11034991807c583d)(`Since version 12, the lambda view no longer depends on a lambda contract. The read method no longer accepts a contract address as a parameter.`);
            else if (chainId && chainIdValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$4836eb835ffca5b2)(chainId, (0, $201657d342d01b1b$export$a2057601792df650)(chainIdValidation));
            const arg = this.parameterSchema.Encode(...this.args);
            const result = yield this.rpc.runView({
                contract: this.currentContract.address,
                entrypoint: this.name,
                input: arg,
                chain_id: chainId ? chainId : yield this.readProvider.getChainId()
            });
            return this.callbackParametersSchema.Execute(result.data);
        });
    }
}
const $7f31e5493257f9b5$var$validateArgs = (args, schema, name)=>{
    const sigs = schema.ExtractSignatures();
    if (!sigs.find((x)=>x.length === args.length)) throw new $7f31e5493257f9b5$export$e569b97a5d46005c(name, sigs, args);
};
// lambda view tzip4
const $7f31e5493257f9b5$var$isView = (entrypoint)=>{
    let isView = false;
    if ('prim' in entrypoint && entrypoint.prim === 'pair' && entrypoint.args) {
        const lastElement = entrypoint.args[entrypoint.args.length - 1];
        if ('prim' in lastElement && lastElement.prim === 'contract') isView = true;
    }
    return isView;
};
/**
 * @description Smart contract abstraction
 */ class $7f31e5493257f9b5$export$25cde19dc6218700 {
    constructor(address, script, provider, storageProvider, entrypoints, rpc, readProvider){
        this.address = address;
        this.script = script;
        this.storageProvider = storageProvider;
        this.entrypoints = entrypoints;
        this.rpc = rpc;
        this.readProvider = readProvider;
        /**
         * @deprecated use methodsObject instead, flat params of methods can't sufficiently represent all Michelson values
         * @description Contains methods that are implemented by the target Tezos Smart Contract, and offers the user to call the Smart Contract methods as if they were native TS/JS methods.
         * NB: if the contract contains annotation it will include named properties; if not it will be indexed by a number.
         */ this.methods = {};
        /**
         * @description Contains methods that are implemented by the target Tezos Smart Contract, and offers the user to call the Smart Contract methods as if they were native TS/JS methods.
         * `methodsObject` serves the exact same purpose as the `methods` member. The difference is that it allows passing the parameter in an object format when calling the smart contract method (instead of the flattened representation)
         * NB: if the contract contains annotation it will include named properties; if not it will be indexed by a number.
         *
         */ this.methodsObject = {};
        /**
         * @description Contains lamda views (tzip4) that are implemented by the target Tezos Smart Contract, and offers the user to call the lambda views as if they were native TS/JS methods.
         * NB: These are the view defined in the tzip4 standard, not the views introduced by the Hangzhou protocol.
         */ this.views = {};
        /**
         * @description Contains on-chain views that are defined by the target Tezos Smart Contract, and offers the user to simulate the views execution as if they were native TS/JS methods.
         * NB: the expected format for the parameter when calling a smart contract view is the object format (same format as for the storage) and not the flattened representation.
         *
         */ this.contractViews = {};
        this.contractMethodFactory = new $7f31e5493257f9b5$var$ContractMethodFactory(provider, address);
        this.schema = (0, $cbefca4388d58836$export$19342e026b58ebb7).fromRPCResponse({
            script: this.script
        });
        this.parameterSchema = (0, $cbefca4388d58836$export$54a0993a9ed335cf).fromRPCResponse({
            script: this.script
        });
        this.viewSchema = (0, $cbefca4388d58836$export$d422a5b447f0dce1).fromRPCResponse({
            script: this.script
        });
        if (this.viewSchema.length !== 0) this._initializeOnChainViews(this, rpc, this.readProvider, this.viewSchema);
        this.eventSchema = (0, $cbefca4388d58836$export$769a4ec051ed522c).fromRPCResponse({
            script: this.script
        });
        this._initializeMethods(this, this.entrypoints.entrypoints, this.rpc, this.readProvider);
    }
    _initializeMethods(currentContract, entrypoints, rpc, readProvider) {
        const parameterSchema = this.parameterSchema;
        const keys = Object.keys(entrypoints);
        if (parameterSchema.isMultipleEntryPoint) {
            keys.forEach((smartContractMethodName)=>{
                const smartContractMethodSchema = new (0, $cbefca4388d58836$export$54a0993a9ed335cf)(entrypoints[smartContractMethodName]);
                this.methods[smartContractMethodName] = function(...args) {
                    return currentContract.contractMethodFactory.createContractMethodFlatParams(smartContractMethodSchema, smartContractMethodName, args);
                };
                this.methodsObject[smartContractMethodName] = function(args) {
                    return currentContract.contractMethodFactory.createContractMethodObjectParam(smartContractMethodSchema, smartContractMethodName, args);
                };
                if ($7f31e5493257f9b5$var$isView(entrypoints[smartContractMethodName])) {
                    const view = function(...args) {
                        const entrypointParamWithoutCallback = entrypoints[smartContractMethodName].args[0];
                        const smartContractMethodSchemaWithoutCallback = new (0, $cbefca4388d58836$export$54a0993a9ed335cf)(entrypointParamWithoutCallback);
                        const parametersCallback = entrypoints[smartContractMethodName].args[1].args[0];
                        const smartContractMethodCallbackSchema = new (0, $cbefca4388d58836$export$54a0993a9ed335cf)(parametersCallback);
                        $7f31e5493257f9b5$var$validateArgs(args, smartContractMethodSchemaWithoutCallback, smartContractMethodName);
                        return new $7f31e5493257f9b5$export$63fe1d55d80baff5(currentContract, smartContractMethodName, smartContractMethodCallbackSchema, smartContractMethodSchemaWithoutCallback, args, rpc, readProvider);
                    };
                    this.views[smartContractMethodName] = view;
                }
            });
            // Deal with methods with no annotations which were not discovered by the RPC endpoint
            // Methods with no annotations are discovered using parameter schema
            const anonymousMethods = Object.keys(parameterSchema.ExtractSchema()).filter((key)=>Object.keys(entrypoints).indexOf(key) === -1);
            anonymousMethods.forEach((smartContractMethodName)=>{
                this.methods[smartContractMethodName] = function(...args) {
                    return currentContract.contractMethodFactory.createContractMethodFlatParams(parameterSchema, smartContractMethodName, args, false, true);
                };
                this.methodsObject[smartContractMethodName] = function(args) {
                    return currentContract.contractMethodFactory.createContractMethodObjectParam(parameterSchema, smartContractMethodName, args, false, true);
                };
            });
        } else {
            const smartContractMethodSchema = this.parameterSchema;
            this.methods[$7f31e5493257f9b5$export$a4f3c2bebc69dfa9] = function(...args) {
                return currentContract.contractMethodFactory.createContractMethodFlatParams(smartContractMethodSchema, $7f31e5493257f9b5$export$a4f3c2bebc69dfa9, args, false);
            };
            this.methodsObject[$7f31e5493257f9b5$export$a4f3c2bebc69dfa9] = function(args) {
                return currentContract.contractMethodFactory.createContractMethodObjectParam(smartContractMethodSchema, $7f31e5493257f9b5$export$a4f3c2bebc69dfa9, args, false);
            };
        }
    }
    _initializeOnChainViews(currentContract, rpc, readProvider, allContractViews) {
        const storageType = this.schema.val;
        allContractViews.forEach((viewSchema)=>{
            this.contractViews[viewSchema.viewName] = function(args) {
                return currentContract.contractMethodFactory.createContractViewObjectParam(rpc, readProvider, viewSchema, storageType, args);
            };
        });
    }
    /**
     * @description Return a friendly representation of the smart contract storage
     */ storage() {
        return this.storageProvider.getStorage(this.address, this.schema);
    }
    /**
     *
     * @description Return a friendly representation of the smart contract big map value
     *
     * @param key BigMap key to fetch
     *
     * @deprecated getBigMapKey has been deprecated in favor of getBigMapKeyByID
     *
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-context-contracts-contract-id-big-map-get
     */ bigMap(key) {
        return this.storageProvider.getBigMapKey(this.address, key, this.schema);
    }
}
const $7f31e5493257f9b5$var$setDelegate = (key)=>{
    return [
        {
            prim: 'DROP'
        },
        {
            prim: 'NIL',
            args: [
                {
                    prim: 'operation'
                }
            ]
        },
        {
            prim: 'PUSH',
            args: [
                {
                    prim: 'key_hash'
                },
                {
                    string: key
                }
            ]
        },
        {
            prim: 'SOME'
        },
        {
            prim: 'SET_DELEGATE'
        },
        {
            prim: 'CONS'
        }
    ];
};
const $7f31e5493257f9b5$var$transferImplicit = (key, mutez)=>{
    return [
        {
            prim: 'DROP'
        },
        {
            prim: 'NIL',
            args: [
                {
                    prim: 'operation'
                }
            ]
        },
        {
            prim: 'PUSH',
            args: [
                {
                    prim: 'key_hash'
                },
                {
                    string: key
                }
            ]
        },
        {
            prim: 'IMPLICIT_ACCOUNT'
        },
        {
            prim: 'PUSH',
            args: [
                {
                    prim: 'mutez'
                },
                {
                    int: `${mutez}`
                }
            ]
        },
        {
            prim: 'UNIT'
        },
        {
            prim: 'TRANSFER_TOKENS'
        },
        {
            prim: 'CONS'
        }
    ];
};
const $7f31e5493257f9b5$var$removeDelegate = ()=>{
    return [
        {
            prim: 'DROP'
        },
        {
            prim: 'NIL',
            args: [
                {
                    prim: 'operation'
                }
            ]
        },
        {
            prim: 'NONE',
            args: [
                {
                    prim: 'key_hash'
                }
            ]
        },
        {
            prim: 'SET_DELEGATE'
        },
        {
            prim: 'CONS'
        }
    ];
};
const $7f31e5493257f9b5$var$transferToContract = (key, amount)=>{
    return [
        {
            prim: 'DROP'
        },
        {
            prim: 'NIL',
            args: [
                {
                    prim: 'operation'
                }
            ]
        },
        {
            prim: 'PUSH',
            args: [
                {
                    prim: 'address'
                },
                {
                    string: key
                }
            ]
        },
        {
            prim: 'CONTRACT',
            args: [
                {
                    prim: 'unit'
                }
            ]
        },
        {
            prim: 'IF_NONE',
            args: [
                [
                    {
                        prim: 'UNIT'
                    },
                    {
                        prim: 'FAILWITH'
                    }
                ],
                []
            ]
        },
        {
            prim: 'PUSH',
            args: [
                {
                    prim: 'mutez'
                },
                {
                    int: `${amount}`
                }
            ]
        },
        {
            prim: 'UNIT'
        },
        {
            prim: 'TRANSFER_TOKENS'
        },
        {
            prim: 'CONS'
        }
    ];
};
const $7f31e5493257f9b5$export$914bd5860575a041 = {
    setDelegate: $7f31e5493257f9b5$var$setDelegate,
    removeDelegate: $7f31e5493257f9b5$var$removeDelegate,
    transferImplicit: $7f31e5493257f9b5$var$transferImplicit,
    transferToContract: $7f31e5493257f9b5$var$transferToContract
};
const $7f31e5493257f9b5$var$code = [
    {
        prim: 'parameter',
        args: [
            {
                prim: 'lambda',
                args: [
                    {
                        prim: 'unit'
                    },
                    {
                        prim: 'pair',
                        args: [
                            {
                                prim: 'list',
                                args: [
                                    {
                                        prim: 'operation'
                                    }
                                ]
                            },
                            {
                                prim: 'unit'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        prim: 'storage',
        args: [
            {
                prim: 'unit'
            }
        ]
    },
    {
        prim: 'code',
        args: [
            [
                {
                    prim: 'CAR'
                },
                {
                    prim: 'UNIT'
                },
                {
                    prim: 'EXEC'
                }
            ]
        ]
    }
];
const $7f31e5493257f9b5$var$storage = 'Unit';
const $7f31e5493257f9b5$export$7f921264ee025945 = {
    code: $7f31e5493257f9b5$var$code,
    storage: $7f31e5493257f9b5$var$storage
};
function $7f31e5493257f9b5$export$f672e0b6f7222cd7(functioncomposer1, functioncomposer2) {
    return (contractAbstraction, context)=>functioncomposer2(functioncomposer1(contractAbstraction, context), context);
}
class $7f31e5493257f9b5$export$1e644e089fcc2014 {
    constructor(id, provider){
        this.id = id;
        this.provider = provider;
    }
    /**
     *
     * @description Fetch the sapling state
     *
     * @param block optional block level to fetch the values from (head will be use by default)
     * @returns Return a json object of the sapling_state
     *
     */ getSaplingDiff(block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.provider.getSaplingDiffByID(this.id.toString(), block);
        });
    }
    getId() {
        return this.id.toString();
    }
}
class $7f31e5493257f9b5$export$ba473e7c149ab4dc {
    constructor(id, schema, provider){
        this.id = id;
        this.schema = schema;
        this.provider = provider;
    }
    /**
     *
     * @description Fetch one value in a big map
     *
     * @param keysToEncode Key to query (will be encoded properly according to the schema)
     * @param block optional block level to fetch the values from (head will be use by default)
     * @returns Return a well formatted json object of a big map value or undefined if the key is not found in the big map
     *
     */ get(keyToEncode, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const id = yield this.provider.getBigMapKeyByID(this.id.toString(), keyToEncode, this.schema, block);
                return id;
            } catch (e) {
                if (e instanceof (0, $e7f526111d047632$export$d2f2761cbe9cebf2) && e.status === (0, $e7f526111d047632$export$bc3aa03eb4b395cf).NOT_FOUND) return undefined;
                else throw e;
            }
        });
    }
    /**
     *
     * @description Fetch multiple values in a big map
     * All values will be fetched on the same block level. If a block is specified in the request, the values will be fetched at it.
     * Otherwise, a first request will be done to the node to fetch the level of the head and all values will be fetched at this level.
     * If one of the keys does not exist in the big map, its value will be set to undefined.
     *
     * @param keysToEncode Array of keys to query (will be encoded properly according to the schema)
     * @param block optional block level to fetch the values from
     * @param batchSize optional batch size representing the number of requests to execute in parallel
     * @returns A MichelsonMap containing the keys queried in the big map and their value in a well-formatted JSON object format
     *
     */ getMultipleValues(keysToEncode, block, batchSize = 5) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.provider.getBigMapKeysByID(this.id.toString(), keysToEncode, this.schema, block, batchSize);
        });
    }
    toJSON() {
        return this.id.toString();
    }
    toString() {
        return this.id.toString();
    }
}
/**
 * @description Override the default michelson encoder semantic to provide richer abstraction over storage properties
 * @param provider ContractProvider (contract API)
 */ // Override the default michelson encoder semantic to provide richer abstraction over storage properties
const $7f31e5493257f9b5$export$c616f2921e28f4d2 = (provider)=>({
        // Provide a specific abstraction for BigMaps
        big_map: (val, code)=>{
            if (!val || !('int' in val) || val.int === undefined) // Return an empty object in case of missing big map ID
            return {};
            else {
                const schema = new (0, $cbefca4388d58836$export$19342e026b58ebb7)(code);
                return new $7f31e5493257f9b5$export$ba473e7c149ab4dc(new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val.int), schema, provider);
            }
        },
        sapling_state: (val)=>{
            if (!val || !('int' in val) || val.int === undefined) // Return an empty object in case of missing sapling state ID
            return {};
            else return new $7f31e5493257f9b5$export$1e644e089fcc2014(new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val.int), provider);
        }
    });
var $7f31e5493257f9b5$var$_PrepareProvider_counters;
const $7f31e5493257f9b5$var$mergeLimits = (userDefinedLimit, defaultLimits)=>{
    var _a, _b, _c;
    return {
        fee: (_a = userDefinedLimit.fee) !== null && _a !== void 0 ? _a : defaultLimits.fee,
        gasLimit: (_b = userDefinedLimit.gasLimit) !== null && _b !== void 0 ? _b : defaultLimits.gasLimit,
        storageLimit: (_c = userDefinedLimit.storageLimit) !== null && _c !== void 0 ? _c : defaultLimits.storageLimit
    };
};
/**
 * @description PrepareProvider is a utility class to output the prepared format of an operation
 */ class $7f31e5493257f9b5$export$c3ce3aa140a1bd8b extends $7f31e5493257f9b5$var$Provider {
    constructor(context){
        super(context);
        this.context = context;
        $7f31e5493257f9b5$var$_PrepareProvider_counters.set(this, void 0);
        $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
    }
    getBlockHash(block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.context.readProvider.getBlockHash(block !== null && block !== void 0 ? block : 'head~2');
        });
    }
    getProtocolHash() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.context.readProvider.getNextProtocol('head');
        });
    }
    getHeadCounter(pkh) {
        var _a;
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return (_a = this.context.readProvider.getCounter(pkh, 'head')) !== null && _a !== void 0 ? _a : '0';
        });
    }
    adjustGasForBatchOperation(gasLimitBlock, gaslimitOp, numberOfOps) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).min(gaslimitOp, gasLimitBlock.div(numberOfOps + 1));
    }
    getOperationLimits(constants, numberOfOps) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { hard_gas_limit_per_operation: hard_gas_limit_per_operation, hard_gas_limit_per_block: hard_gas_limit_per_block, hard_storage_limit_per_operation: hard_storage_limit_per_operation } = constants;
            return {
                fee: 0,
                gasLimit: numberOfOps ? Math.floor(this.adjustGasForBatchOperation(hard_gas_limit_per_block, hard_gas_limit_per_operation, numberOfOps).toNumber()) : hard_gas_limit_per_operation.toNumber(),
                storageLimit: hard_storage_limit_per_operation.toNumber()
            };
        });
    }
    getFee(op, pkh, headCounter) {
        if (!$7f31e5493257f9b5$var$__classPrivateFieldGet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, "f")[pkh] || $7f31e5493257f9b5$var$__classPrivateFieldGet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, "f")[pkh] < headCounter) $7f31e5493257f9b5$var$__classPrivateFieldGet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, "f")[pkh] = headCounter;
        const opCounter = ++$7f31e5493257f9b5$var$__classPrivateFieldGet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, "f")[pkh];
        return {
            counter: `${opCounter}`,
            fee: typeof op.fee === 'undefined' ? '0' : `${op.fee}`,
            gas_limit: typeof op.gas_limit === 'undefined' ? '0' : `${op.gas_limit}`,
            storage_limit: typeof op.storage_limit === 'undefined' ? '0' : `${op.storage_limit}`
        };
    }
    getSource(op, pkh, source) {
        return {
            source: typeof op.source === 'undefined' ? source || pkh : op.source
        };
    }
    addRevealOperationIfNeeded(operation, publicKeyHash) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if ($7f31e5493257f9b5$var$isOpRequireReveal(operation)) {
                const ops = [
                    operation
                ];
                const { publicKey: publicKey, pkh: pkh } = yield this.getKeys();
                if (yield this.isAccountRevealRequired(publicKeyHash)) {
                    if (!publicKey) throw new (0, $8b6476b09e20f53e$export$183b043cd3c947f9)(pkh);
                    ops.unshift((yield $7f31e5493257f9b5$export$638a1bb58510476({
                        fee: $7f31e5493257f9b5$export$2a009c06b05c06b7(pkh),
                        storageLimit: $7f31e5493257f9b5$export$7dc909734d086289,
                        gasLimit: $7f31e5493257f9b5$export$199fe2d87a4763cf(pkh)
                    }, publicKeyHash, publicKey)));
                    return ops;
                }
            }
            return operation;
        });
    }
    getKeys() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const isSignerConfigured = this.context.isAnySignerConfigured();
            return {
                pkh: isSignerConfigured ? yield this.signer.publicKeyHash() : yield this.context.walletProvider.getPKH(),
                publicKey: isSignerConfigured ? yield this.signer.publicKey() : undefined
            };
        });
    }
    convertIntoArray(op) {
        if (Array.isArray(op)) return [
            ...op
        ];
        else return [
            op
        ];
    }
    constructOpContents(ops, headCounter, pkh, source, currentVotingPeriod) {
        return ops.map((op)=>{
            switch(op.kind){
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ACTIVATION:
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DRAIN_DELEGATE:
                    return Object.assign({}, op);
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION:
                    return Object.assign(Object.assign(Object.assign(Object.assign({}, op), {
                        balance: typeof op.balance !== 'undefined' ? `${op.balance}` : '0'
                    }), this.getSource(op, pkh, source)), this.getFee(op, pkh, headCounter));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION:
                    {
                        const cops = Object.assign(Object.assign(Object.assign(Object.assign({}, op), {
                            amount: typeof op.amount !== 'undefined' ? `${op.amount}` : '0'
                        }), this.getSource(op, pkh, source)), this.getFee(op, pkh, headCounter));
                        if (cops.source.toLowerCase().startsWith('kt1')) throw new (0, $8b6476b09e20f53e$export$11034991807c583d)(`KT1 addresses are not supported as source since ${$7f31e5493257f9b5$export$8b0851cfdd1d5bdc.PsBabyM1}`);
                        return cops;
                    }
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REVEAL:
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION:
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT:
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).UPDATE_CONSENSUS_KEY:
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES:
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE:
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE:
                    return Object.assign(Object.assign(Object.assign({}, op), this.getSource(op, pkh, source)), this.getFee(op, pkh, headCounter));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSFER_TICKET:
                    return Object.assign(Object.assign(Object.assign(Object.assign({}, op), {
                        ticket_amount: `${op.ticket_amount}`
                    }), this.getSource(op, pkh, source)), this.getFee(op, pkh, headCounter));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                    return Object.assign(Object.assign(Object.assign(Object.assign({}, op), {
                        amount: `${op.amount}`
                    }), this.getSource(op, pkh, source)), this.getFee(op, pkh, headCounter));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).BALLOT:
                    if (currentVotingPeriod === undefined) throw new $7f31e5493257f9b5$var$RPCResponseError(`Failed to get the current voting period index`);
                    return Object.assign(Object.assign({}, op), {
                        period: currentVotingPeriod === null || currentVotingPeriod === void 0 ? void 0 : currentVotingPeriod.voting_period.index
                    });
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).PROPOSALS:
                    if (currentVotingPeriod === undefined) throw new $7f31e5493257f9b5$var$RPCResponseError(`Failed to get the current voting period index`);
                    return Object.assign(Object.assign({}, op), {
                        period: currentVotingPeriod === null || currentVotingPeriod === void 0 ? void 0 : currentVotingPeriod.voting_period.index
                    });
                default:
                    throw new (0, $8b6476b09e20f53e$export$bc5be87550569b55)(op.kind);
            }
        });
    }
    /**
     *
     * @description Method to prepare an activation operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ activate({ pkh: pkh, secret: secret }) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const op = yield $7f31e5493257f9b5$export$eb3995ea1d48ce9e({
                pkh: pkh,
                secret: secret
            });
            const ops = this.convertIntoArray(op);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a reveal operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ reveal({ fee: fee, gasLimit: gasLimit, storageLimit: storageLimit }) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh, publicKey: publicKey } = yield this.getKeys();
            if (!publicKey) throw new (0, $8b6476b09e20f53e$export$183b043cd3c947f9)(pkh);
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const mergedEstimates = $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS);
            const op = yield $7f31e5493257f9b5$export$638a1bb58510476({
                fee: mergedEstimates.fee,
                gasLimit: mergedEstimates.gasLimit,
                storageLimit: mergedEstimates.storageLimit
            }, pkh, publicKey);
            const ops = this.convertIntoArray(op);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare an origination operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ originate(_a, source) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $7f31e5493257f9b5$export$64dd15b44cde1e0b((yield this.context.parser.prepareCodeOrigination(Object.assign(Object.assign({}, rest), $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)))));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a transaction operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ transaction(_a) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $7f31e5493257f9b5$export$f3a9991068ba8db1(Object.assign(Object.assign({}, rest), $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a delegation operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ delegation(_a) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $7f31e5493257f9b5$export$f6ca8c66abd5d967(Object.assign(Object.assign({}, rest), $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a register delegate operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ registerDelegate({ fee: fee, storageLimit: storageLimit, gasLimit: gasLimit }, source) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const mergedEstimates = $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS);
            const op = yield $7f31e5493257f9b5$export$1823ae131c107679({
                fee: mergedEstimates.fee,
                storageLimit: mergedEstimates.storageLimit,
                gasLimit: mergedEstimates.gasLimit
            }, pkh);
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a register_global_constant operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ registerGlobalConstant(_a) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $7f31e5493257f9b5$export$36ba5bd34bec1f48(Object.assign(Object.assign({}, rest), $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare an update_consensus_key operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ updateConsensusKey(_a, source) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $7f31e5493257f9b5$export$ca68d75e3dde8c6(Object.assign(Object.assign({}, rest), $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare an increase_paid_storage operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ increasePaidStorage(_a) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $7f31e5493257f9b5$export$8bbbca5738264f6e(Object.assign(Object.assign({}, rest), $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a ballot operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ ballot(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const op = yield $7f31e5493257f9b5$export$21e0e83bb1296bf6(Object.assign({}, params));
            const ops = this.convertIntoArray(op);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            let currentVotingPeriod;
            try {
                currentVotingPeriod = yield this.rpc.getCurrentPeriod();
            } catch (e) {
                throw new $7f31e5493257f9b5$var$RPCResponseError('Failed to get the current voting period index');
            }
            const contents = this.constructOpContents(ops, headCounter, pkh, undefined, currentVotingPeriod);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a proposals operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ proposals(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const op = yield $7f31e5493257f9b5$export$a50446e8b0c2fbdd(Object.assign({}, params));
            const ops = this.convertIntoArray(op);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            let currentVotingPeriod;
            try {
                currentVotingPeriod = yield this.rpc.getCurrentPeriod();
            } catch (e) {
                throw new $7f31e5493257f9b5$var$RPCResponseError('Failed to get the current voting period index');
            }
            const contents = this.constructOpContents(ops, headCounter, pkh, undefined, currentVotingPeriod);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a drain_delegate operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ drainDelegate(params, source) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const op = yield $7f31e5493257f9b5$export$3f02b23ff3ed5b1f(Object.assign({}, params));
            const ops = this.convertIntoArray(op);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a transfer_ticket operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ transferTicket(_a) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $7f31e5493257f9b5$export$c2b0bb52eb4f8f40(Object.assign(Object.assign({}, rest), $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a smart_rollup_add_messages operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ smartRollupAddMessages(_a) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $7f31e5493257f9b5$export$e778921f9c3d1912(Object.assign(Object.assign({}, rest), $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a smart_rollup_originate operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ smartRollupOriginate(_a) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $7f31e5493257f9b5$export$7119c95759340192(Object.assign(Object.assign({}, $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)), rest));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a smart_rollup_execute_outbox_message operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ smartRollupExecuteOutboxMessage(_a) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $7f31e5493257f9b5$export$4b4c6fb209c7f56d(Object.assign(Object.assign({}, rest), $7f31e5493257f9b5$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a batch operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ batch(batchParams, estimates) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh, publicKey: publicKey } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants, batchParams.length);
            const revealNeeded = yield this.isRevealOpNeeded(batchParams, pkh);
            const ops = [];
            if (!estimates) {
                for (const op of batchParams)if ($7f31e5493257f9b5$var$isOpWithFee(op)) {
                    const limits = $7f31e5493257f9b5$var$mergeLimits(op, DEFAULT_PARAMS);
                    ops.push((yield this.getRPCOp(Object.assign(Object.assign({}, op), limits))));
                } else ops.push(Object.assign({}, op));
            } else {
                for (const op of batchParams)if ($7f31e5493257f9b5$var$isOpWithFee(op)) {
                    const e = estimates.shift();
                    const limits = $7f31e5493257f9b5$var$mergeLimits(op, {
                        fee: e.suggestedFeeMutez,
                        storageLimit: e.storageLimit,
                        gasLimit: e.gasLimit
                    });
                    ops.push((yield this.getRPCOp(Object.assign(Object.assign({}, op), limits))));
                } else ops.push(Object.assign({}, op));
            }
            if (revealNeeded) {
                if (!publicKey) throw new (0, $8b6476b09e20f53e$export$183b043cd3c947f9)(pkh);
                ops.unshift((yield $7f31e5493257f9b5$export$638a1bb58510476({
                    fee: $7f31e5493257f9b5$export$2a009c06b05c06b7(pkh),
                    storageLimit: $7f31e5493257f9b5$export$7dc909734d086289,
                    gasLimit: $7f31e5493257f9b5$export$199fe2d87a4763cf(pkh)
                }, pkh, publicKey)));
            }
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a batch operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ contractCall(contractMethod) {
        var _a, _b, _c;
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            const { pkh: pkh } = yield this.getKeys();
            $7f31e5493257f9b5$var$__classPrivateFieldSet(this, $7f31e5493257f9b5$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const params = contractMethod.toTransferParams();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const estimateLimits = $7f31e5493257f9b5$var$mergeLimits({
                fee: params.fee,
                storageLimit: params.storageLimit,
                gasLimit: params.gasLimit
            }, DEFAULT_PARAMS);
            const op = {
                kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION,
                fee: (_a = params.fee) !== null && _a !== void 0 ? _a : estimateLimits.fee,
                gas_limit: (_b = params.gasLimit) !== null && _b !== void 0 ? _b : estimateLimits.gasLimit,
                storage_limit: (_c = params.storageLimit) !== null && _c !== void 0 ? _c : estimateLimits.storageLimit,
                amount: String(params.amount),
                destination: params.to,
                parameters: params.parameter
            };
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const contents = this.constructOpContents(ops, headCounter, pkh);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to convert a PreparedOperation to the params needed for the preapplyOperation method
     * @param prepared a Prepared Operation
     * @returns a PreapplyParams object
     */ toPreapply(prepared) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { opOb: { contents: contents, branch: branch, protocol: protocol } } = prepared;
            const forgeParams = this.toForge(prepared);
            const forged = yield this.context.forger.forge(forgeParams);
            const sig = yield this.context.signer.sign(forged, new Uint8Array([
                3
            ]));
            return [
                {
                    contents: contents,
                    branch: branch,
                    protocol: protocol,
                    signature: sig.prefixSig
                }
            ];
        });
    }
    /**
     *
     * @description Method to convert a PreparedOperation to the params needed for forging
     * @param param a Prepared Operation
     * @returns a ForgeParams object
     */ toForge({ opOb: { contents: contents, branch: branch } }) {
        return {
            branch: branch,
            contents: contents
        };
    }
}
$7f31e5493257f9b5$var$_PrepareProvider_counters = new WeakMap();
const $7f31e5493257f9b5$var$BATCH_KINDS = [
    (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ACTIVATION,
    (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION,
    (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION,
    (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION
];
class $7f31e5493257f9b5$export$7a235871f213c08c extends $7f31e5493257f9b5$var$Provider {
    constructor(context, estimator){
        super(context);
        this.estimator = estimator;
        this.operations = [];
        this.prepare = new $7f31e5493257f9b5$export$c3ce3aa140a1bd8b(this.context);
    }
    /**
     *
     * @description Add a transaction operation to the batch
     *
     * @param params Transfer operation parameter
     */ withTransfer(params) {
        const toValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(params.to);
        if (params.amount < 0) throw new (0, $8b6476b09e20f53e$export$d8bf6d22cce8e288)(params.amount.toString());
        if (toValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.to, (0, $201657d342d01b1b$export$a2057601792df650)(toValidation));
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION
        }, params));
        return this;
    }
    /**
     *
     * @description Transfer tickets from a Tezos address (tz1,tz2 or tz3) to a smart contract address( KT1)
     *
     * @param params Transfer operation parameter
     */ withTransferTicket(params) {
        const destinationValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(params.destination);
        if (destinationValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.destination, (0, $201657d342d01b1b$export$a2057601792df650)(destinationValidation));
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSFER_TICKET
        }, params));
        return this;
    }
    /**
     *
     * @description Add a contract call to the batch
     *
     * @param params Call a contract method
     * @param options Generic operation parameters
     */ withContractCall(params, options = {}) {
        return this.withTransfer(params.toTransferParams(options));
    }
    /**
     *
     * @description Add a delegation operation to the batch
     *
     * @param params Delegation operation parameter
     */ withDelegation(params) {
        var _a;
        const sourceValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(params.source);
        if (params.source && sourceValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.source, (0, $201657d342d01b1b$export$a2057601792df650)(sourceValidation));
        const delegateValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)((_a = params.delegate) !== null && _a !== void 0 ? _a : '');
        if (params.delegate && delegateValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.delegate, (0, $201657d342d01b1b$export$a2057601792df650)(delegateValidation));
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION
        }, params));
        return this;
    }
    /**
     *
     * @description Add an activation operation to the batch
     *
     * @param params Activation operation parameter
     * @throws {@link InvalidKeyHashError}
     */ withActivation({ pkh: pkh, secret: secret }) {
        const pkhValidation = (0, $201657d342d01b1b$export$dbd3afbe999d4c3d)(pkh);
        if (pkhValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$a3d7df0ca9d9410c)(pkh, (0, $201657d342d01b1b$export$a2057601792df650)(pkhValidation));
        this.operations.push({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ACTIVATION,
            pkh: pkh,
            secret: secret
        });
        return this;
    }
    /**
     *
     * @description Add an origination operation to the batch
     *
     * @param params Origination operation parameter
     */ withOrigination(params) {
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION
        }, params));
        return this;
    }
    /**
     *
     * @description Add a register a global constant operation to the batch
     *
     * @param params RegisterGlobalConstant operation parameter
     */ withRegisterGlobalConstant(params) {
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT
        }, params));
        return this;
    }
    /**
     *
     * @description Add an increase paid storage operation to the batch
     *
     * @param params IncreasePaidStorage operation parameter
     */ withIncreasePaidStorage(params) {
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE
        }, params));
        return this;
    }
    /**
     *
     * @description Add a smart rollup add messages operation to the batch
     *
     * @param params Rollup origination operation parameter
     */ withSmartRollupAddMessages(params) {
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES
        }, params));
        return this;
    }
    /**
     *
     * @description Add a smart rollup originate operation to the batch
     *
     * @param params Smart Rollup Originate operation parameter
     */ withSmartRollupOriginate(params) {
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE
        }, params));
        return this;
    }
    /**
     *
     * @description Add a smart rollup execute outbox message to the batch
     *
     * @param params Smart Rollup Execute Outbox Message operation parameter
     */ withSmartRollupExecuteOutboxMessage(params) {
        this.operations.push(Object.assign({
            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE
        }, params));
        return this;
    }
    getRPCOp(param) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            switch(param.kind){
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION:
                    return $7f31e5493257f9b5$export$f3a9991068ba8db1(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION:
                    return $7f31e5493257f9b5$export$64dd15b44cde1e0b((yield this.context.parser.prepareCodeOrigination(Object.assign({}, param))));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION:
                    return $7f31e5493257f9b5$export$f6ca8c66abd5d967(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT:
                    return $7f31e5493257f9b5$export$36ba5bd34bec1f48(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                    return $7f31e5493257f9b5$export$8bbbca5738264f6e(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSFER_TICKET:
                    return $7f31e5493257f9b5$export$c2b0bb52eb4f8f40(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES:
                    return $7f31e5493257f9b5$export$e778921f9c3d1912(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE:
                    return $7f31e5493257f9b5$export$7119c95759340192(Object.assign({}, param));
                case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE:
                    return $7f31e5493257f9b5$export$4b4c6fb209c7f56d(Object.assign({}, param));
                default:
                    throw new (0, $8b6476b09e20f53e$export$bc5be87550569b55)(JSON.stringify(param.kind));
            }
        });
    }
    /**
     *
     * @description Add a group operation to the batch. Operation will be applied in the order they are in the params array
     *
     * @param params Operations parameter
     * @throws {@link InvalidOperationKindError}
     */ with(params) {
        for (const param of params)switch(param.kind){
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION:
                this.withTransfer(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION:
                this.withOrigination(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION:
                this.withDelegation(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ACTIVATION:
                this.withActivation(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT:
                this.withRegisterGlobalConstant(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                this.withIncreasePaidStorage(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSFER_TICKET:
                this.withTransferTicket(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES:
                this.withSmartRollupAddMessages(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE:
                this.withSmartRollupOriginate(param);
                break;
            case (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE:
                this.withSmartRollupExecuteOutboxMessage(param);
                break;
            default:
                throw new (0, $8b6476b09e20f53e$export$bc5be87550569b55)(JSON.stringify(param.kind));
        }
        return this;
    }
    /**
     *
     * @description Forge and Inject the operation batch
     *
     * @param params Optionally specify the source of the operation
     */ send(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const source = params && params.source || publicKeyHash;
            const estimates = yield this.estimator.batch(this.operations);
            if (estimates.length !== this.operations.length) estimates.shift();
            const preparedOp = yield this.prepare.batch(this.operations, estimates);
            const opBytes = yield this.forge(preparedOp);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$57d05bbf047997b6(hash, preparedOp.opOb.contents, source, forgedBytes, opResponse, context);
        });
    }
}
class $7f31e5493257f9b5$var$RPCBatchProvider {
    constructor(context, estimator){
        this.context = context;
        this.estimator = estimator;
    }
    /***
     *
     * @description Batch a group of operation together. Operations will be applied in the order in which they are added to the batch
     *
     * @param params List of operation to batch together
     */ batch(params) {
        const batch = new $7f31e5493257f9b5$export$7a235871f213c08c(this.context, this.estimator);
        if (Array.isArray(params)) batch.with(params);
        return batch;
    }
}
class $7f31e5493257f9b5$var$BatchWalletOperation extends $7f31e5493257f9b5$export$903c688feb2d259e {
    constructor(opHash, context, newHead$){
        super(opHash, context, newHead$);
        this.opHash = opHash;
        this.context = context;
        this.getOriginatedContractAddresses = ()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                const opResult = yield this.operationResults();
                if (!opResult) throw new $7f31e5493257f9b5$var$ObservableError('Unable to fetch operation results');
                else {
                    const originationOpResults = opResult.filter((x)=>x.kind === 'origination');
                    let addresses = [];
                    for (const res of originationOpResults)if (res.metadata.operation_result.originated_contracts) addresses = [
                        ...addresses,
                        ...res.metadata.operation_result.originated_contracts
                    ];
                    return addresses;
                }
            });
    }
    revealOperation() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $7f31e5493257f9b5$var$ObservableError('Unable to fetch operation results');
            else return operationResult.find((x)=>x.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REVEAL);
        });
    }
    status() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 'pending';
            const op = yield this.operationResults();
            if (op) return op.filter((result)=>$7f31e5493257f9b5$var$BATCH_KINDS.indexOf(result.kind) !== -1).map((result)=>{
                if ($7f31e5493257f9b5$var$hasMetadataWithResult(result)) {
                    const opResult = result.metadata.operation_result;
                    return opResult.status;
                } else return 'unknown';
            })[0] || 'unknown';
            else throw new $7f31e5493257f9b5$var$ObservableError('Unable to fetch operation results');
        });
    }
}
class $7f31e5493257f9b5$var$IncreasePaidStorageWalletOperation extends $7f31e5493257f9b5$export$903c688feb2d259e {
    constructor(opHash, context, newHead$){
        super(opHash, context, newHead$);
        this.opHash = opHash;
        this.context = context;
    }
    revealOperation() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $7f31e5493257f9b5$var$ObservableError('Unable to fetch operation result');
            else return operationResult.find((x)=>x.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REVEAL);
        });
    }
    increasePaidStorageOperation() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $7f31e5493257f9b5$var$ObservableError('Unable to fetch operation result');
            else return operationResult.find((x)=>x.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE);
        });
    }
    status() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 'pending';
            const op = yield this.increasePaidStorageOperation();
            if (!op) return 'unknown';
            return op.metadata.operation_result.status;
        });
    }
}
function $7f31e5493257f9b5$var$timeoutAfter(timeoutMillisec) {
    return function inner(source) {
        return new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(null).pipe((0, $9491af11bb0ab327$export$83e74882c5df8fe1)({
            each: timeoutMillisec,
            with: ()=>(0, $8250ab9260498953$export$8bf7aba4a9e09055)(()=>new $7f31e5493257f9b5$var$ConfirmationTimeoutError(`Confirmation polling timed out`))
        }), (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)(()=>source));
    };
}
const $7f31e5493257f9b5$var$createNewPollingBasedHeadObservable = (sharedHeadOb, context, _scheduler)=>{
    return sharedHeadOb.pipe($7f31e5493257f9b5$var$timeoutAfter(context.config.confirmationPollingTimeoutSecond * 1000), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)({
        connector: ()=>new (0, $4a1890c700519557$export$915d2682b0aa0991)(1),
        resetOnError: false,
        resetOnComplete: false,
        resetOnRefCountZero: false
    }));
};
class $7f31e5493257f9b5$var$OperationFactory {
    constructor(context){
        this.context = context;
        // Cache the last block for one second across all operations
        this.sharedHeadObs = (0, $8312939aeeb1a4f7$export$260e5c0943f31606)(()=>{
            return $7f31e5493257f9b5$var$createObservableFromSubscription(this.context.stream.subscribeBlock('head'));
        });
    }
    createNewHeadObservable() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return $7f31e5493257f9b5$var$createNewPollingBasedHeadObservable(this.sharedHeadObs, this.context);
        });
    }
    createPastBlockWalker(startBlock, count = 1) {
        return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(this.context.readProvider.getBlock(startBlock)).pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((block)=>{
            if (count === 1) return (0, $195e3b3043565ec4$export$ba255e9e49e00608)(block);
            return (0, $48a6b248e7e71175$export$d02631cccf789723)(block.header.level, count - 1).pipe((0, $b52129d9072c7912$export$a4fe86229b0e9bdd)(block), (0, $9ee54e147202c320$export$c28c8388be0ab31a)((level)=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                    return this.context.readProvider.getBlock(typeof level === 'number' ? level : level.header.level);
                })));
        }));
    }
    createHeadObservableFromConfig({ blockIdentifier: blockIdentifier }) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const observableSequence = [];
            if (blockIdentifier) observableSequence.push(this.createPastBlockWalker(blockIdentifier));
            observableSequence.push((yield this.createNewHeadObservable()));
            return (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(...observableSequence);
        });
    }
    createOperation(hash, config = {}) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return new $7f31e5493257f9b5$export$903c688feb2d259e(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
    createBatchOperation(hash, config = {}) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return new $7f31e5493257f9b5$var$BatchWalletOperation(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
    createTransactionOperation(hash, config = {}) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return new $7f31e5493257f9b5$export$8fc855f2a23d265f(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
    createDelegationOperation(hash, config = {}) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return new $7f31e5493257f9b5$export$ac7733ff4c8bbbf1(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
    createOriginationOperation(hash, config = {}) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return new $7f31e5493257f9b5$export$fc9b2020ddc4a55c(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
    createIncreasePaidStorageOperation(hash, config = {}) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return new $7f31e5493257f9b5$var$IncreasePaidStorageWalletOperation(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
}
class $7f31e5493257f9b5$var$RpcTzProvider extends $7f31e5493257f9b5$var$Provider {
    constructor(context){
        super(context);
        this.prepare = new $7f31e5493257f9b5$export$c3ce3aa140a1bd8b(this.context);
    }
    getBalance(address) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const addressValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(address);
            if (addressValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(address, (0, $201657d342d01b1b$export$a2057601792df650)(addressValidation));
            return this.context.readProvider.getBalance(address, 'head');
        });
    }
    getDelegate(address) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const addressValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(address);
            if (addressValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(address, (0, $201657d342d01b1b$export$a2057601792df650)(addressValidation));
            return this.context.readProvider.getDelegate(address, 'head');
        });
    }
    activate(pkh, secret) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const pkhValidation = (0, $201657d342d01b1b$export$dbd3afbe999d4c3d)(pkh);
            if (pkhValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$a3d7df0ca9d9410c)(pkh, (0, $201657d342d01b1b$export$a2057601792df650)(pkhValidation));
            const prepared = yield this.prepare.activate({
                pkh: pkh,
                secret: secret
            });
            const forgedBytes = yield this.forge(prepared);
            const bytes = `${forgedBytes.opbytes}00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000`;
            return new $7f31e5493257f9b5$export$ab5aad00225c5662((yield this.rpc.injectOperation(bytes)), Object.assign(Object.assign({}, forgedBytes), {
                opbytes: bytes
            }), [], this.context.clone());
        });
    }
}
const $7f31e5493257f9b5$var$MINIMAL_FEE_MUTEZ = 100;
const $7f31e5493257f9b5$var$MINIMAL_FEE_PER_BYTE_MUTEZ = 1;
const $7f31e5493257f9b5$var$MINIMAL_FEE_PER_GAS_MUTEZ = 0.1;
/**
 * Examples of use :
 *
 *  Estimate a transfer operation :
 * ```
 * // Assuming that provider and signer are already configured...
 *
 * const amount = 2;
 * const address = 'tz1h3rQ8wBxFd8L9B3d7Jhaawu6Z568XU3xY';
 *
 * // Estimate gasLimit, storageLimit and fees for a transfer operation
 * const est = await Tezos.estimate.transfer({ to: address, amount: amount })
 * console.log(est.burnFeeMutez, est.gasLimit, est.minimalFeeMutez, est.storageLimit,
 *  est.suggestedFeeMutez, est.totalCost, est.usingBaseFeeMutez)
 *
 * ```
 *
 * Estimate a contract origination :
 * ```
 * // generic.json is referring to a Michelson Smart Contract
 *
 * const genericMultisigJSON = require('./generic.json')
 * const est = await Tezos.estimate.originate({
 *   code: genericMultisigJSON,
 *   storage: {
 *     stored_counter: 0,
 *     threshold: 1,
 *     keys: ['edpkuLxx9PQD8fZ45eUzrK3BhfDZJHhBuK4Zi49DcEGANwd2rpX82t']
 *   }
 * })
 * console.log(est.burnFeeMutez, est.gasLimit, est.minimalFeeMutez, est.storageLimit,
 *   est.suggestedFeeMutez, est.totalCost, est.usingBaseFeeMutez)
 *
 * ```
 */ class $7f31e5493257f9b5$export$f24de3004fef8471 {
    constructor(_milligasLimit, _storageLimit, opSize, minimalFeePerStorageByteMutez, /**
     * @description Base fee in mutez (1 mutez = 1e10−6 tez)
     */ baseFeeMutez = $7f31e5493257f9b5$var$MINIMAL_FEE_MUTEZ){
        this._milligasLimit = _milligasLimit;
        this._storageLimit = _storageLimit;
        this.opSize = opSize;
        this.minimalFeePerStorageByteMutez = minimalFeePerStorageByteMutez;
        this.baseFeeMutez = baseFeeMutez;
    }
    /**
     * @description The number of Mutez that will be burned for the storage of the [operation](https://tezos.gitlab.io/user/glossary.html#operations). (Storage + Allocation fees)
     */ get burnFeeMutez() {
        return this.roundUp(Number(this.storageLimit) * Number(this.minimalFeePerStorageByteMutez));
    }
    /**
     * @description  The limit on the amount of storage an [operation](https://tezos.gitlab.io/user/glossary.html#operations) can use with 20 buffer.
     */ get storageLimit() {
        return Math.max(Number(this._storageLimit), 0);
    }
    /**
     * @description The limit on the amount of [gas](https://tezos.gitlab.io/user/glossary.html#gas) a given operation can consume with 100 buffer depends on the operation.
     */ get gasLimit() {
        return this.roundUp(Number(this._milligasLimit) / 1000);
    }
    get operationFeeMutez() {
        return this.gasLimit * $7f31e5493257f9b5$var$MINIMAL_FEE_PER_GAS_MUTEZ + Number(this.opSize) * $7f31e5493257f9b5$var$MINIMAL_FEE_PER_BYTE_MUTEZ;
    }
    roundUp(nanotez) {
        return Math.ceil(Number(nanotez));
    }
    /**
     * @description Minimum fees for the [operation](https://tezos.gitlab.io/user/glossary.html#operations) according to [baker](https://tezos.gitlab.io/user/glossary.html#baker) defaults.
     */ get minimalFeeMutez() {
        return this.roundUp(this.operationFeeMutez + $7f31e5493257f9b5$var$MINIMAL_FEE_MUTEZ);
    }
    /**
     * @description The suggested fee for the operation which includes minimal fees and a small buffer.
     */ get suggestedFeeMutez() {
        return this.roundUp(this.operationFeeMutez + $7f31e5493257f9b5$var$MINIMAL_FEE_MUTEZ * 1.2);
    }
    /**
     * @description Fees according to your specified base fee will ensure that at least minimum fees are used.
     */ get usingBaseFeeMutez() {
        return Math.max(Number(this.baseFeeMutez), $7f31e5493257f9b5$var$MINIMAL_FEE_MUTEZ) + this.roundUp(this.operationFeeMutez);
    }
    /**
     * @description The sum of `minimalFeeMutez` + `burnFeeMutez`.
     */ get totalCost() {
        return this.minimalFeeMutez + this.burnFeeMutez;
    }
    /**
     * @description Since Delphinet, consumed gas is provided in milligas for more precision.
     * This function returns an estimation of the gas that operation will consume in milligas.
     */ get consumedMilligas() {
        return Number(this._milligasLimit);
    }
    static createEstimateInstanceFromProperties(estimateProperties) {
        let milligasLimit = 0;
        let storageLimit = 0;
        let opSize = 0;
        let minimalFeePerStorageByteMutez = 0;
        let baseFeeMutez;
        estimateProperties.forEach((estimate)=>{
            milligasLimit += estimate.milligasLimit;
            storageLimit += estimate.storageLimit;
            opSize += estimate.opSize;
            minimalFeePerStorageByteMutez = Math.max(estimate.minimalFeePerStorageByteMutez, minimalFeePerStorageByteMutez);
            if (estimate.baseFeeMutez) baseFeeMutez = baseFeeMutez ? baseFeeMutez + estimate.baseFeeMutez : estimate.baseFeeMutez;
        });
        return new $7f31e5493257f9b5$export$f24de3004fef8471(milligasLimit, storageLimit, opSize, minimalFeePerStorageByteMutez, baseFeeMutez);
    }
    static createArrayEstimateInstancesFromProperties(estimateProperties) {
        return estimateProperties.map((x)=>new $7f31e5493257f9b5$export$f24de3004fef8471(x.milligasLimit, x.storageLimit, x.opSize, x.minimalFeePerStorageByteMutez, x.baseFeeMutez));
    }
}
/**
 *  @category Error
 *  @description Error that indicates unable to get public key to estimate reveal operation in Wallet API
 */ class $7f31e5493257f9b5$export$921226cb1345c97b extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(){
        super();
        this.name = 'RevealEstimateError';
        this.message = 'Public key is unknown, unable to estimate the reveal operation in Wallet API.';
    }
}
// stub signature that won't be verified by tezos rpc simulate_operation
const $7f31e5493257f9b5$var$STUB_SIGNATURE = 'edsigtkpiSSschcaCt9pUVrpNPf7TTcgvgDEDD6NCEHMy8NNQJCGnMfLZzYoQj74yLjo9wx6MPVV29CvVzgi7qEcEUok3k7AuMg';
class $7f31e5493257f9b5$export$a0b53ef5867b3b16 extends $7f31e5493257f9b5$var$Provider {
    constructor(){
        super(...arguments);
        this.OP_SIZE_REVEAL = 324; // injecting size tz1=320, tz2=322, tz3=322, tz4=420(not supported)
        this.MILLIGAS_BUFFER = 100000; // 100 buffer depends on operation kind
        this.STORAGE_BUFFER = 20; // according to octez-client
        this.prepare = new $7f31e5493257f9b5$export$c3ce3aa140a1bd8b(this.context);
    }
    getKeys() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const isSignerConfigured = this.context.isAnySignerConfigured();
            return {
                publicKeyHash: isSignerConfigured ? yield this.signer.publicKeyHash() : yield this.context.walletProvider.getPKH(),
                publicKey: isSignerConfigured ? yield this.signer.publicKey() : undefined
            };
        });
    }
    getEstimationPropertiesFromOperationContent(content, size, costPerByte, originationSize) {
        const operationResults = $7f31e5493257f9b5$var$flattenOperationResult({
            contents: [
                content
            ]
        });
        let consumedMilligas = 0;
        let accumulatedStorage = 0;
        operationResults.forEach((result)=>{
            consumedMilligas += Number(result.consumed_milligas) || 0;
            // transfer to unrevealed implicit
            accumulatedStorage += 'allocated_destination_contract' in result ? originationSize : 0;
            // originate
            accumulatedStorage += 'originated_contracts' in result && Array.isArray(result.originated_contracts) ? result.originated_contracts.length * originationSize : 0;
            // register_global_constants
            accumulatedStorage += 'storage_size' in result && 'global_address' in result ? Number(result.storage_size) || 0 : 0;
            // transfer_ticket, originate, contract_call
            accumulatedStorage += 'paid_storage_size_diff' in result ? Number(result.paid_storage_size_diff) || 0 : 0;
            //smart_rollup_originate
            accumulatedStorage += 'genesis_commitment_hash' in result ? Number(result.size) || 0 : 0;
        });
        if ($7f31e5493257f9b5$var$isOpWithFee(content)) return {
            milligasLimit: $7f31e5493257f9b5$var$isOpWithGasBuffer(content) ? consumedMilligas + Number(this.MILLIGAS_BUFFER) : consumedMilligas,
            storageLimit: accumulatedStorage > 0 ? accumulatedStorage + this.STORAGE_BUFFER : 0,
            opSize: size,
            minimalFeePerStorageByteMutez: costPerByte.toNumber()
        };
        else return {
            milligasLimit: 0,
            storageLimit: 0,
            opSize: size,
            minimalFeePerStorageByteMutez: costPerByte.toNumber(),
            baseFeeMutez: 0
        };
    }
    calculateEstimates(op, constants) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { opbytes: opbytes, opOb: { branch: branch, contents: contents } } = yield this.forge(op);
            const operation = {
                operation: {
                    branch: branch,
                    contents: contents,
                    signature: $7f31e5493257f9b5$var$STUB_SIGNATURE
                },
                chain_id: yield this.context.readProvider.getChainId()
            };
            const { opResponse: opResponse } = yield this.simulate(operation);
            const { cost_per_byte: cost_per_byte, origination_size: origination_size } = constants;
            const errors = [
                ...$7f31e5493257f9b5$var$flattenErrors(opResponse, 'backtracked'),
                ...$7f31e5493257f9b5$var$flattenErrors(opResponse)
            ];
            // Fail early in case of errors
            if (errors.length) throw new $7f31e5493257f9b5$export$a971cb9d7d565551(errors, 'Error occurred during estimation', opResponse.contents);
            let numberOfOps = 1;
            if (Array.isArray(op.opOb.contents) && op.opOb.contents.length > 1) numberOfOps = opResponse.contents[0].kind === 'reveal' ? op.opOb.contents.length - 1 : op.opOb.contents.length;
            return opResponse.contents.map((x)=>{
                return this.getEstimationPropertiesFromOperationContent(x, // diff between estimated and injecting OP_SIZE is 124-126, we added buffer to use 130
                x.kind === 'reveal' ? this.OP_SIZE_REVEAL / 2 : (opbytes.length + 130) / 2 / numberOfOps, cost_per_byte, origination_size !== null && origination_size !== void 0 ? origination_size : 257 // protocol constants
                );
            });
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an origination operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param OriginationOperation Originate operation parameter
     */ originate(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const preparedOperation = yield this.prepare.originate(params);
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an transfer operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param TransferOperation Originate operation parameter
     */ transfer(_a) {
        var _b;
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const toValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(rest.to);
            if (toValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(rest.to, (0, $201657d342d01b1b$export$a2057601792df650)(toValidation));
            const sourceValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)((_b = rest.source) !== null && _b !== void 0 ? _b : '');
            if (rest.source && sourceValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(rest.source, (0, $201657d342d01b1b$export$a2057601792df650)(sourceValidation));
            if (rest.amount < 0) throw new (0, $8b6476b09e20f53e$export$d8bf6d22cce8e288)(rest.amount.toString());
            const preparedOperation = yield this.prepare.transaction(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a transferTicket operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param TransferTicketParams operation parameter
     */ transferTicket(_a) {
        var _b;
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const destinationValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(rest.destination);
            if (destinationValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(rest.destination, (0, $201657d342d01b1b$export$a2057601792df650)(destinationValidation));
            const sourceValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)((_b = rest.source) !== null && _b !== void 0 ? _b : '');
            if (rest.source && sourceValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(rest.source, (0, $201657d342d01b1b$export$a2057601792df650)(sourceValidation));
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.transferTicket(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a delegate operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Estimate
     */ setDelegate(_a) {
        var _b;
        var { fee: fee, gasLimit: gasLimit, storageLimit: storageLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "gasLimit",
            "storageLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const sourceValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(rest.source);
            if (rest.source && sourceValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(rest.source, (0, $201657d342d01b1b$export$a2057601792df650)(sourceValidation));
            const delegateValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)((_b = rest.delegate) !== null && _b !== void 0 ? _b : '');
            if (rest.delegate && delegateValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(rest.delegate, (0, $201657d342d01b1b$export$a2057601792df650)(delegateValidation));
            const preparedOperation = yield this.prepare.delegation(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a each operation in the batch
     *
     * @returns An array of Estimate objects. If a reveal operation is needed, the first element of the array is the Estimate for the reveal operation.
     */ batch(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperations = yield this.prepare.batch(params);
            const estimateProperties = yield this.calculateEstimates(preparedOperations, protocolConstants);
            return $7f31e5493257f9b5$export$f24de3004fef8471.createArrayEstimateInstancesFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a delegate operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Estimate
     */ registerDelegate(_a, source) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const pkh = (yield this.getKeys()).publicKeyHash;
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const checkSource = source || pkh;
            const preparedOperation = yield this.prepare.registerDelegate(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest), checkSource);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees to reveal the current account
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation or undefined if the account is already revealed
     *
     * @param Estimate
     */ reveal(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { publicKeyHash: publicKeyHash, publicKey: publicKey } = yield this.getKeys();
            if (!publicKey) throw new $7f31e5493257f9b5$export$921226cb1345c97b();
            if (yield this.isAccountRevealRequired(publicKeyHash)) {
                const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
                const preparedOperation = params ? yield this.prepare.reveal(params) : yield this.prepare.reveal({});
                const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
                return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
            }
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an registerGlobalConstant operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param params registerGlobalConstant operation parameter
     */ registerGlobalConstant(_a) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const preparedOperation = yield this.prepare.registerGlobalConstant(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit, and fees for an increasePaidStorage operation
     *
     * @returns An estimation of gasLimit, storageLimit, and fees for the operation
     *
     * @param params increasePaidStorage operation parameters
     */ increasePaidStorage(_a) {
        var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $7f31e5493257f9b5$var$__rest(_a, [
            "fee",
            "storageLimit",
            "gasLimit"
        ]);
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (rest.amount < 0) throw new (0, $8b6476b09e20f53e$export$d8bf6d22cce8e288)(rest.amount.toString());
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.increasePaidStorage(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an Update Consensus Key operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Estimate
     */ updateConsensusKey(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.updateConsensusKey(params);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a smart_rollup_add_messages operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Estimate
     */ smartRollupAddMessages(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.smartRollupAddMessages(params);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an Smart Rollup Originate operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param SmartRollupOriginateParams
     */ smartRollupOriginate(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.smartRollupOriginate(params);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a smart_rollup_execute_outbox_message operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Estimate
     */ smartRollupExecuteOutboxMessage(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.smartRollupExecuteOutboxMessage(params);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') estimateProperties.shift();
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for contract call
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the contract call
     *
     * @param Estimate
     */ contractCall(contractMethod) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.contractCall(contractMethod);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $7f31e5493257f9b5$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
}
/**
 * @description Delegation operation provide utility function to fetch newly issued delegation
 *
 * @warn Currently support only one delegation per operation
 */ class $7f31e5493257f9b5$export$ce3dabbdbcbbc321 extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const delegationOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'delegation');
        const result = delegationOp && delegationOp.metadata && delegationOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get delegate() {
        return this.params.delegate;
    }
    get isRegisterOperation() {
        return this.delegate === this.source;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedGas() {
        (0, $42f5864281cc433e$exports.BigNumber).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, $42f5864281cc433e$exports.BigNumber).ROUND_UP
        });
        return this.consumedMilliGas ? new (0, $42f5864281cc433e$exports.BigNumber)(this.consumedMilliGas).dividedBy(1000).toString() : undefined;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
}
/**
 * @description Origination operation provide utility function to fetch newly originated contract
 *
 * @warn Currently support only one origination per operation
 */ class $7f31e5493257f9b5$export$ec1f5c67b17f835a extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, raw, results, context, contractProvider){
        super(hash, raw, results, context);
        this.params = params;
        this.contractProvider = contractProvider;
        const originatedContracts = this.operationResults && this.operationResults.originated_contracts;
        if (Array.isArray(originatedContracts)) this.contractAddress = originatedContracts[0];
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get operationResults() {
        const originationOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'origination');
        const result = originationOp && $7f31e5493257f9b5$var$hasMetadataWithResult(originationOp) && originationOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedGas() {
        (0, $42f5864281cc433e$exports.BigNumber).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, $42f5864281cc433e$exports.BigNumber).ROUND_UP
        });
        return this.consumedMilliGas ? new (0, $42f5864281cc433e$exports.BigNumber)(this.consumedMilliGas).dividedBy(1000).toString() : undefined;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get storageDiff() {
        const storageDiff = this.operationResults && this.operationResults.paid_storage_size_diff;
        return storageDiff ? storageDiff : undefined;
    }
    get storageSize() {
        const storageSize = this.operationResults && this.operationResults.storage_size;
        return storageSize ? storageSize : undefined;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
    /**
     * @description Provide the contract abstract of the newly originated contract
     * @throws {@link OriginationOperationError}
     */ contract(confirmations, timeout) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.contractAddress) throw new $7f31e5493257f9b5$var$OriginationOperationError('No contract was originated in this operation');
            yield this.confirmation(confirmations, timeout);
            return this.contractProvider.at(this.contractAddress);
        });
    }
}
/**
 * @description RegisterGlobalConstantOperation provides utility functions to fetch a newly issued operation of kind register_global_constant
 */ class $7f31e5493257f9b5$export$3b8dda899a5ab452 extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
        this.globalConstantHash = this.operationResults && this.operationResults.global_address;
    }
    get operationResults() {
        const registerGlobalConstantOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'register_global_constant');
        const result = registerGlobalConstantOp && registerGlobalConstantOp.metadata && registerGlobalConstantOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get registeredExpression() {
        return this.params.value;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
    get consumedGas() {
        (0, $42f5864281cc433e$exports.BigNumber).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, $42f5864281cc433e$exports.BigNumber).ROUND_UP
        });
        return this.consumedMilliGas ? new (0, $42f5864281cc433e$exports.BigNumber)(this.consumedMilliGas).dividedBy(1000).toString() : undefined;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
}
/**
 * @description Reveal operation provides utility functions to fetch a newly issued revelation
 */ class $7f31e5493257f9b5$export$14d3da7f07184894 extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const revealOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'reveal');
        return revealOp ? [
            revealOp
        ] : [];
    }
    get status() {
        const operationResults = this.operationResults;
        const txResult = operationResults[0];
        if (txResult) return txResult.metadata.operation_result.status;
        else return 'unknown';
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get publicKey() {
        return this.params.public_key;
    }
    sumProp(arr, prop) {
        return arr.reduce((prev, current)=>{
            return prop in current ? Number(current[prop]) + prev : prev;
        }, 0);
    }
    get consumedGas() {
        (0, $42f5864281cc433e$exports.BigNumber).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, $42f5864281cc433e$exports.BigNumber).ROUND_UP
        });
        return new (0, $42f5864281cc433e$exports.BigNumber)(this.consumedMilliGas).dividedBy(1000).toString();
    }
    get consumedMilliGas() {
        return String(this.sumProp($7f31e5493257f9b5$var$flattenOperationResult({
            contents: this.operationResults
        }), 'consumed_milligas'));
    }
    get storageDiff() {
        return String(this.sumProp($7f31e5493257f9b5$var$flattenOperationResult({
            contents: this.operationResults
        }), 'paid_storage_size_diff'));
    }
    get storageSize() {
        return String(this.sumProp($7f31e5493257f9b5$var$flattenOperationResult({
            contents: this.operationResults
        }), 'storage_size'));
    }
    get errors() {
        return $7f31e5493257f9b5$var$flattenErrors({
            contents: this.operationResults
        });
    }
}
/**
 * @description Transaction operation provides utility functions to fetch a newly issued transaction
 *
 * @warn Currently supports one transaction per operation
 */ class $7f31e5493257f9b5$export$831ca37464f9fe3 extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const transactionOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'transaction');
        return transactionOp ? [
            transactionOp
        ] : [];
    }
    get status() {
        const operationResults = this.operationResults;
        const txResult = operationResults[0];
        if (txResult) return txResult.metadata.operation_result.status;
        else return 'unknown';
    }
    get amount() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(this.params.amount);
    }
    get destination() {
        return this.params.destination;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    sumProp(arr, prop) {
        return arr.reduce((prev, current)=>{
            return prop in current ? Number(current[prop]) + prev : prev;
        }, 0);
    }
    get consumedGas() {
        (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).ROUND_UP
        });
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(this.consumedMilliGas).dividedBy(1000).toString();
    }
    get consumedMilliGas() {
        return String(this.sumProp($7f31e5493257f9b5$var$flattenOperationResult({
            contents: this.operationResults
        }), 'consumed_milligas'));
    }
    get storageDiff() {
        return String(this.sumProp($7f31e5493257f9b5$var$flattenOperationResult({
            contents: this.operationResults
        }), 'paid_storage_size_diff'));
    }
    get storageSize() {
        return String(this.sumProp($7f31e5493257f9b5$var$flattenOperationResult({
            contents: this.operationResults
        }), 'storage_size'));
    }
    get errors() {
        return $7f31e5493257f9b5$var$flattenErrors({
            contents: this.operationResults
        });
    }
}
/**
 *
 * @description IncreasePaidStorageOperation provides utility functions to fetch a new operation of kind increase_paid_storage
 *
 */ class $7f31e5493257f9b5$export$8d528f7d576e7bf3 extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const increasePaidStorageOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'increase_paid_storage');
        const result = increasePaidStorageOp && increasePaidStorageOp.metadata && increasePaidStorageOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get amount() {
        return this.params.amount;
    }
    get destination() {
        return this.params.destination;
    }
}
/**
 *
 * @description UpdateConsensusKeyOperation provides utility to fetch properties for Operation of kind UpdateConsensusKey
 *
 */ class $7f31e5493257f9b5$export$fd8ddc29035a3b9d extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const updateConsensusKeyOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'update_consensus_key');
        const result = updateConsensusKeyOp && updateConsensusKeyOp.metadata && updateConsensusKeyOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get pk() {
        return this.params.pk;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
}
/**
 * @description SmartRollupAddMessagesOperation provides utility to fetch properties of SmartRollupAddMessages
 */ class $7f31e5493257f9b5$export$80c7f5b8306f2de6 extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const smartRollupAddMessagesOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'smart_rollup_add_messages');
        const result = smartRollupAddMessagesOp && smartRollupAddMessagesOp.metadata && smartRollupAddMessagesOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get message() {
        return this.params.message;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
}
/**
 *
 * @description SmartRollupOriginate Operation provides utility to fetch properties for Operation of kind SmartRollupOriginate
 *
 */ class $7f31e5493257f9b5$export$392a36414e72aa5d extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const smartRollupOriginateOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE);
        const result = smartRollupOriginateOp && smartRollupOriginateOp.metadata && smartRollupOriginateOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get pvmKind() {
        return this.params.pvm_kind;
    }
    get kernel() {
        return this.params.kernel;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
}
/**
 *
 * @description BallotOperation provides utility functions to fetch a new operation of kind ballot
 *
 */ class $7f31e5493257f9b5$export$7c85c5993418b9a9 extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const ballotOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'ballot');
        const result = ballotOp;
        return result ? result : undefined;
    }
    get period() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.period;
    }
    get proposal() {
        return this.params.proposal;
    }
    get ballot() {
        return this.params.ballot;
    }
}
/**
 *
 * @description DrainDelegateOperation provides utility functions to fetch a new operation of kind drain_delegate
 *
 */ class $7f31e5493257f9b5$export$a70f4d895fdd289e extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
    }
    get operationResults() {
        const drainDelegateOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'drain_delegate');
        const result = drainDelegateOp && drainDelegateOp.metadata && drainDelegateOp.metadata.balance_updates;
        return result ? result : undefined;
    }
    get consensusKey() {
        return this.params.consensus_key;
    }
    get delegate() {
        return this.params.delegate;
    }
    get destination() {
        return this.params.destination;
    }
}
/**
 *
 * @description ProposalsOperation provides utility functions to fetch a new operation of kind proposals
 *
 */ class $7f31e5493257f9b5$export$f85d38729ebbe78f extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const proposalsOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'proposals');
        const result = proposalsOp;
        return result ? result : undefined;
    }
    get proposals() {
        return this.params.proposals;
    }
    get period() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.period;
    }
}
/**
 *
 * @description Transfer tickets from a Tezos address (tz1, tz2 or tz3) to a smart contract address (KT1) (everything on layer 1 at this step)
 *
 * @warn Currently only supports one L2 ticket holder transfer at once. ie. one collection of tickets owned by tz1, tz2 or tz3 to a smart contract.
 */ class $7f31e5493257f9b5$export$e2d2edc8d45e91bd extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const transferOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSFER_TICKET);
        const result = transferOp && transferOp.metadata && transferOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedGas() {
        (0, $42f5864281cc433e$exports.BigNumber).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, $42f5864281cc433e$exports.BigNumber).ROUND_UP
        });
        return this.consumedMilliGas ? new (0, $42f5864281cc433e$exports.BigNumber)(this.consumedMilliGas).dividedBy(1000).toString() : undefined;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
}
/**
 *
 * @description SmartRollupExecuteOutboxMessage Operation provides utility to fetch properties for Operation of kind SmartRollupExecuteOutboxMessage
 *
 */ class $7f31e5493257f9b5$var$SmartRollupExecuteOutboxMessageOperation extends $7f31e5493257f9b5$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const smartRollupExecuteOutboxMessageOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE);
        const result = smartRollupExecuteOutboxMessageOp && smartRollupExecuteOutboxMessageOp.metadata && smartRollupExecuteOutboxMessageOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get rollup() {
        return this.params.rollup;
    }
    get cementedCommitment() {
        return this.params.cemented_commitment;
    }
    get outputProof() {
        return this.params.output_proof;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
}
class $7f31e5493257f9b5$var$RpcContractProvider extends $7f31e5493257f9b5$var$Provider {
    constructor(context, estimator){
        super(context);
        this.estimator = estimator;
        this.contractProviderTypeSymbol = Symbol.for('taquito-contract-provider-type-symbol');
        this.prepare = new $7f31e5493257f9b5$export$c3ce3aa140a1bd8b(this.context);
    }
    /**
     *
     * @description Return a well formatted json object of the contract storage
     *
     * @param contract contract address you want to get the storage from
     * @param schema optional schema can either be the contract script rpc response or a michelson-encoder schema
     * @throws {@link InvalidContractAddressError}
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-script
     */ getStorage(contract, schema) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const contractValidation = (0, $201657d342d01b1b$export$2ed905adbd9a56f2)(contract);
            if (contractValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$193774326795229b)(contract, (0, $201657d342d01b1b$export$a2057601792df650)(contractValidation));
            const script = yield this.context.readProvider.getScript(contract, 'head');
            if (!schema) schema = script;
            let contractSchema;
            if ((0, $cbefca4388d58836$export$19342e026b58ebb7).isSchema(schema)) contractSchema = schema;
            else contractSchema = (0, $cbefca4388d58836$export$19342e026b58ebb7).fromRPCResponse({
                script: schema
            });
            return contractSchema.Execute(script.storage, $7f31e5493257f9b5$export$c616f2921e28f4d2(this)); // Cast into T because only the caller can know the true type of the storage
        });
    }
    /**
     *
     * @description Return a well formatted json object of the contract big map storage
     *
     * @param contract contract address you want to get the storage from
     * @param key contract big map key to fetch value from
     * @param schema optional schema can either be the contract script rpc response or a michelson-encoder schema
     * @throws {@link InvalidContractAddressError}
     * @deprecated Deprecated in favor of getBigMapKeyByID
     *
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-context-contracts-contract-id-big-map-get
     */ getBigMapKey(contract, key, schema) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const contractValidation = (0, $201657d342d01b1b$export$2ed905adbd9a56f2)(contract);
            if (contractValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$193774326795229b)(contract, (0, $201657d342d01b1b$export$a2057601792df650)(contractValidation));
            if (!schema) schema = (yield this.rpc.getContract(contract)).script;
            let contractSchema;
            if ((0, $cbefca4388d58836$export$19342e026b58ebb7).isSchema(schema)) contractSchema = schema;
            else contractSchema = (0, $cbefca4388d58836$export$19342e026b58ebb7).fromRPCResponse({
                script: schema
            });
            const encodedKey = contractSchema.EncodeBigMapKey(key);
            const val = yield this.rpc.getBigMapKey(contract, encodedKey);
            return contractSchema.ExecuteOnBigMapValue(val); // Cast into T because only the caller can know the true type of the storage
        });
    }
    /**
     *
     * @description Return a well formatted json object of a big map value
     *
     * @param id Big Map ID
     * @param keyToEncode key to query (will be encoded properly according to the schema)
     * @param schema Big Map schema (can be determined using your contract type)
     * @param block optional block level to fetch the values from
     *
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-big-maps-big-map-id-script-expr
     */ getBigMapKeyByID(id, keyToEncode, schema, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { key: key, type: type } = schema.EncodeBigMapKey(keyToEncode);
            const { packed: packed } = yield this.context.packer.packData({
                data: key,
                type: type
            });
            const encodedExpr = (0, $201657d342d01b1b$export$8069b2d054f1e0a)(packed);
            const bigMapValue = block ? yield this.context.readProvider.getBigMapValue({
                id: id.toString(),
                expr: encodedExpr
            }, block) : yield this.context.readProvider.getBigMapValue({
                id: id.toString(),
                expr: encodedExpr
            }, 'head');
            return schema.ExecuteOnBigMapValue(bigMapValue, $7f31e5493257f9b5$export$c616f2921e28f4d2(this));
        });
    }
    /**
     *
     * @description Fetch multiple values in a big map
     * All values will be fetched on the same block level. If a block is specified in the request, the values will be fetched at it.
     * Otherwise, a first request will be done to the node to fetch the level of the head and all values will be fetched at this level.
     * If one of the keys does not exist in the big map, its value will be set to undefined.
     *
     * @param id Big Map ID
     * @param keys Array of keys to query (will be encoded properly according to the schema)
     * @param schema Big Map schema (can be determined using your contract type)
     * @param block optional block level to fetch the values from
     * @param batchSize optional batch size representing the number of requests to execute in parallel
     * @returns A MichelsonMap containing the keys queried in the big map and their value in a well-formatted JSON object format
     *
     */ getBigMapKeysByID(id, keys, schema, block, batchSize = 5) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const level = yield this.getBlockForRequest(keys, block);
            const bigMapValues = new (0, $cbefca4388d58836$export$485fc446a4c98bc8)();
            // Execute batch of promises in series
            let position = 0;
            let results = [];
            while(position < keys.length){
                const keysBatch = keys.slice(position, position + batchSize);
                const batch = keysBatch.map((keyToEncode)=>this.getBigMapValueOrUndefined(keyToEncode, id, schema, level));
                results = [
                    ...results,
                    ...yield Promise.all(batch)
                ];
                position += batchSize;
            }
            for(let i = 0; i < results.length; i++)bigMapValues.set(keys[i], results[i]);
            return bigMapValues;
        });
    }
    getBlockForRequest(keys, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return keys.length === 1 || typeof block !== 'undefined' ? block : yield this.context.readProvider.getBlockLevel('head');
        });
    }
    getBigMapValueOrUndefined(keyToEncode, id, schema, level) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield this.getBigMapKeyByID(id, keyToEncode, schema, level);
            } catch (ex) {
                if (ex instanceof (0, $e7f526111d047632$export$d2f2761cbe9cebf2) && ex.status === (0, $e7f526111d047632$export$bc3aa03eb4b395cf).NOT_FOUND) return;
                else throw ex;
            }
        });
    }
    /**
     *
     * @description Return a well formatted json object of a sapling state
     *
     * @param id Sapling state ID
     * @param block optional block level to fetch the value from
     *
     */ getSaplingDiffByID(id, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const saplingState = block ? yield this.context.readProvider.getSaplingDiffById({
                id: id.toString()
            }, block) : yield this.context.readProvider.getSaplingDiffById({
                id: id.toString()
            }, 'head');
            return saplingState;
        });
    }
    /**
     *
     * @description Originate a new contract according to the script in parameters. Will sign and inject an operation using the current context
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @warn You cannot specify storage and init at the same time (use init to pass the raw michelson representation of storage)
     *
     * @param OriginationOperation Originate operation parameter
     */ originate(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const estimate = yield this.estimate(params, this.estimator.originate.bind(this.estimator));
            const preparedOrigination = yield this.prepare.originate(Object.assign(Object.assign({}, params), estimate));
            const content = preparedOrigination.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).ORIGINATION);
            const forgedOrigination = yield this.forge(preparedOrigination);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(forgedOrigination);
            return new $7f31e5493257f9b5$export$ec1f5c67b17f835a(hash, content, forgedBytes, opResponse, context, this);
        });
    }
    /**
     *
     * @description Set the delegate for a contract. Will sign and inject an operation using the current context
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param SetDelegate operation parameter
     */ setDelegate(params) {
        var _a;
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const sourceValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(params.source);
            if (params.source && sourceValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.source, (0, $201657d342d01b1b$export$a2057601792df650)(sourceValidation));
            const delegateValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)((_a = params.delegate) !== null && _a !== void 0 ? _a : '');
            if (params.delegate && delegateValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.delegate, (0, $201657d342d01b1b$export$a2057601792df650)(delegateValidation));
            // Since babylon delegation source cannot smart contract
            if (/kt1/i.test(params.source)) throw new $7f31e5493257f9b5$export$ccd4de17604f1cb4(params.source);
            const publicKeyHash = yield this.signer.publicKeyHash();
            const sourceOrDefault = params.source || publicKeyHash;
            const estimate = yield this.estimate(params, this.estimator.setDelegate.bind(this.estimator));
            const preparedDelegation = yield this.prepare.delegation(Object.assign(Object.assign({}, params), estimate));
            const content = preparedDelegation.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION);
            const opBytes = yield this.forge(preparedDelegation);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$ce3dabbdbcbbc321(hash, content, sourceOrDefault, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Register the current address as delegate. Will sign and inject an operation using the current context
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param RegisterDelegate operation parameter
     */ registerDelegate(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const estimate = yield this.estimate(params, this.estimator.registerDelegate.bind(this.estimator));
            const source = yield this.signer.publicKeyHash();
            const prepared = yield this.prepare.registerDelegate(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DELEGATION);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$ce3dabbdbcbbc321(hash, content, source, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Transfer tz from current address to a specific address. Will sign and inject an operation using the current context
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param Transfer operation parameter
     */ transfer(params) {
        var _a;
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const toValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(params.to);
            if (toValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.to, (0, $201657d342d01b1b$export$a2057601792df650)(toValidation));
            const sourceValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)((_a = params.source) !== null && _a !== void 0 ? _a : '');
            if (params.source && sourceValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.source, (0, $201657d342d01b1b$export$a2057601792df650)(sourceValidation));
            if (params.amount < 0) throw new (0, $8b6476b09e20f53e$export$d8bf6d22cce8e288)(params.amount.toString());
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.transfer.bind(this.estimator));
            const source = params.source || publicKeyHash;
            const prepared = yield this.prepare.transaction(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSACTION);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$831ca37464f9fe3(hash, content, source, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Transfer Tickets to a smart contract address
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param TransferTicketParams operation parameter
     */ transferTicket(params) {
        var _a, _b;
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const destinationValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)(params.destination);
            if (destinationValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.destination, (0, $201657d342d01b1b$export$a2057601792df650)(destinationValidation));
            const sourceValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)((_a = params.source) !== null && _a !== void 0 ? _a : '');
            if (params.source && sourceValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.source, (0, $201657d342d01b1b$export$a2057601792df650)(sourceValidation));
            const publicKeyHash = yield this.signer.publicKeyHash();
            const source = (_b = params.source) !== null && _b !== void 0 ? _b : publicKeyHash;
            const estimate = yield this.estimate(params, this.estimator.transferTicket.bind(this.estimator));
            const prepared = yield this.prepare.transferTicket(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).TRANSFER_TICKET);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$e2d2edc8d45e91bd(hash, content, source, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Reveal the current address. Will throw an error if the address is already revealed.
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param RevealParams operation parameter
     */ reveal(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimateReveal = yield this.estimator.reveal(params);
            if (estimateReveal) {
                const estimated = yield this.estimate(params, ()=>$7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
                        return estimateReveal;
                    }));
                const prepared = yield this.prepare.reveal(Object.assign(Object.assign({}, params), estimated));
                const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REVEAL);
                const opBytes = yield this.forge(prepared);
                const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
                return new $7f31e5493257f9b5$export$14d3da7f07184894(hash, content, publicKeyHash, forgedBytes, opResponse, context);
            } else throw new $7f31e5493257f9b5$export$eb140f52edb72859(`The publicKeyHash '${publicKeyHash}' has already been revealed.`);
        });
    }
    /**
     *
     * @description Register a Micheline expression in a global table of constants. Will sign and inject an operation using the current context
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param params registerGlobalConstant operation parameter
     */ registerGlobalConstant(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.registerGlobalConstant.bind(this.estimator));
            const prepared = yield this.prepare.registerGlobalConstant(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$3b8dda899a5ab452(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Increase the paid storage of a smart contract
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param params increasePaidStorage operation parameter
     */ increasePaidStorage(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (params.amount < 0) throw new (0, $8b6476b09e20f53e$export$d8bf6d22cce8e288)(params.amount.toString());
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.increasePaidStorage.bind(this.estimator));
            const prepared = yield this.prepare.increasePaidStorage(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$8d528f7d576e7bf3(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Transfers the spendable balance of the delegate to destination when consensus_key is the active consensus key of delegate
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param params drainDelegate operation parameter
     */ drainDelegate(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const prepared = yield this.prepare.drainDelegate(params);
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).DRAIN_DELEGATE);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$a70f4d895fdd289e(hash, content, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Submit a ballot vote to a specified proposal
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param BallotParams Ballot operation parameter
     */ ballot(params) {
        var _a, _b;
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const sourceValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)((_a = params.source) !== null && _a !== void 0 ? _a : '');
            if (params.source && sourceValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.source, (0, $201657d342d01b1b$export$a2057601792df650)(sourceValidation));
            const source = (_b = params.source) !== null && _b !== void 0 ? _b : publicKeyHash;
            const prepared = yield this.prepare.ballot(Object.assign(Object.assign({}, params), {
                source: source
            }));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).BALLOT);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$7c85c5993418b9a9(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Submit or upvote a proposal during the Proposal period
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param ProposalsParams Proposals operation parameter
     */ proposals(params) {
        var _a, _b;
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const sourceValidation = (0, $201657d342d01b1b$export$f78173835dcde49f)((_a = params.source) !== null && _a !== void 0 ? _a : '');
            if (params.source && sourceValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$66c44d927ffead98)(params.source, (0, $201657d342d01b1b$export$a2057601792df650)(sourceValidation));
            const source = (_b = params.source) !== null && _b !== void 0 ? _b : publicKeyHash;
            const prepared = yield this.prepare.proposals(Object.assign(Object.assign({}, params), {
                source: source
            }));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).PROPOSALS);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$f85d38729ebbe78f(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Updates the consensus key of the baker to public_key starting from the current cycle plus PRESERVED_CYCLES + 1
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param UpdateConsensusKeyParams
     */ updateConsensusKey(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.updateConsensusKey.bind(this.estimator));
            const prepared = yield this.prepare.updateConsensusKey(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).UPDATE_CONSENSUS_KEY);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$fd8ddc29035a3b9d(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     * @description Adds messages to the rollup inbox that can be executed/claimed after it gets cemented
     * @param SmartRollupAddMessagesParams
     * @returns An operation handle with results from the RPC node
     */ smartRollupAddMessages(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.smartRollupAddMessages.bind(this.estimator));
            const prepared = yield this.prepare.smartRollupAddMessages(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$80c7f5b8306f2de6(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     * @description Creates a smart rollup originate operation
     * @param SmartRollupOriginateParams
     * @returns An operation handle with results from the RPC node
     */ smartRollupOriginate(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.smartRollupOriginate.bind(this.estimator));
            const prepared = yield this.prepare.smartRollupOriginate(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$export$392a36414e72aa5d(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     * @description Execute a message from a smart rollup's outbox of a cemented commitment
     * @param SmartRollupExecuteOutboxMessageParams
     * @returns An operation handle with results from the RPC node
     */ smartRollupExecuteOutboxMessage(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.smartRollupExecuteOutboxMessage.bind(this.estimator));
            const prepared = yield this.prepare.smartRollupExecuteOutboxMessage(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $5db8d2af09626b01$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $7f31e5493257f9b5$var$SmartRollupExecuteOutboxMessageOperation(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description A failing_noop operation that is guaranteed to fail.
     *
     * @returns A FailingNoopOperation object representing the signed failing_noop operation
     *
     * @param params failingNoop operation parameter
     */ failingNoop(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const op = {
                kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).FAILING_NOOP,
                arbitrary: params.arbitrary
            };
            const hash = yield this.context.readProvider.getBlockHash(params.basedOnBlock);
            const forged = yield this.context.forger.forge({
                branch: hash,
                contents: [
                    op
                ]
            });
            const { prefixSig: prefixSig } = yield this.signer.sign(forged, new Uint8Array([
                3
            ]));
            return {
                signature: prefixSig,
                bytes: forged,
                signedContent: {
                    branch: hash,
                    contents: [
                        {
                            kind: (0, $5db8d2af09626b01$export$b64a25b4a099ca08).FAILING_NOOP,
                            arbitrary: params.arbitrary
                        }
                    ]
                }
            };
        });
    }
    /**
     *
     * @description Create an smart contract abstraction for the address specified.
     *
     * @param address Smart contract address
     * @throws {@link InvalidContractAddressError}
     */ at(address, contractAbstractionComposer = (x)=>x) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const addressValidation = (0, $201657d342d01b1b$export$2ed905adbd9a56f2)(address);
            if (addressValidation !== (0, $201657d342d01b1b$export$f9bf9a3c544b4010).VALID) throw new (0, $8b6476b09e20f53e$export$193774326795229b)(address, (0, $201657d342d01b1b$export$a2057601792df650)(addressValidation));
            const rpc = this.context.withExtensions().rpc;
            const readProvider = this.context.withExtensions().readProvider;
            const script = yield readProvider.getScript(address, 'head');
            const entrypoints = yield readProvider.getEntrypoints(address);
            const abs = new $7f31e5493257f9b5$export$25cde19dc6218700(address, script, this, this, entrypoints, rpc, readProvider);
            return contractAbstractionComposer(abs, this.context);
        });
    }
    /**
     *
     * @description Batch a group of operation together. Operations will be applied in the order in which they are added to the batch
     *
     * @returns A batch object from which we can add more operation or send a command to execute the batch
     *
     * @param params List of operation to batch together
     */ batch(params) {
        const batch = new $7f31e5493257f9b5$export$7a235871f213c08c(this.context, this.estimator);
        if (Array.isArray(params)) batch.with(params);
        return batch;
    }
}
class $7f31e5493257f9b5$export$9b8795d63420af7f {
    constructor(context){
        this.context = context;
    }
    getNextProto() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.context.proto) {
                const nextProto = yield this.context.readProvider.getNextProtocol('head');
                this.context.proto = nextProto;
            }
            return this.context.proto;
        });
    }
    parseScript(src) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const parser = new (0, $463f724b64570f1c$export$7acfa6ed01010e37)({
                protocol: yield this.getNextProto()
            });
            return parser.parseScript(src);
        });
    }
    parseMichelineExpression(src) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const parser = new (0, $463f724b64570f1c$export$7acfa6ed01010e37)({
                protocol: yield this.getNextProto()
            });
            return parser.parseMichelineExpression(src);
        });
    }
    parseJSON(src) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const parser = new (0, $463f724b64570f1c$export$7acfa6ed01010e37)({
                protocol: yield this.getNextProto()
            });
            return parser.parseJSON(src);
        });
    }
    prepareCodeOrigination(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const parsedParams = params;
            parsedParams.code = yield this.formatCodeParam(params.code);
            if (params.init) parsedParams.init = yield this.formatInitParam(params.init);
            else if (params.storage) {
                const storageType = parsedParams.code.find((p)=>'prim' in p && p.prim === 'storage');
                if (!(storageType === null || storageType === void 0 ? void 0 : storageType.args)) throw new $7f31e5493257f9b5$export$6831bff83789e2ca('The storage section is missing from the script', params.code);
                const schema = new (0, $cbefca4388d58836$export$19342e026b58ebb7)(storageType.args[0]);
                const globalconstantsHashAndValue = yield this.findGlobalConstantsHashAndValue(schema);
                if (Object.keys(globalconstantsHashAndValue).length !== 0) {
                    // If there are global constants in the storage part of the contract code,
                    // they need to be locally expanded in order to encode the storage arguments
                    const p = new (0, $463f724b64570f1c$export$7acfa6ed01010e37)({
                        expandGlobalConstant: globalconstantsHashAndValue
                    });
                    const storageTypeNoGlobalConst = p.parseJSON(storageType.args[0]);
                    const schemaNoGlobalConst = new (0, $cbefca4388d58836$export$19342e026b58ebb7)(storageTypeNoGlobalConst);
                    parsedParams.init = schemaNoGlobalConst.Encode(params.storage);
                } else parsedParams.init = schema.Encode(params.storage);
                delete parsedParams.storage;
            }
            return parsedParams;
        });
    }
    formatCodeParam(code) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            let parsedCode;
            if (typeof code === 'string') {
                const c = yield this.parseScript(code);
                if (c === null) throw new $7f31e5493257f9b5$export$6831bff83789e2ca('Unable to parse', code);
                parsedCode = c;
            } else {
                const c = yield this.parseJSON(code);
                const order = [
                    'parameter',
                    'storage',
                    'code'
                ];
                // Ensure correct ordering for RPC
                parsedCode = c.sort((a, b)=>order.indexOf(a.prim) - order.indexOf(b.prim));
            }
            return parsedCode;
        });
    }
    formatInitParam(init) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            let parsedInit;
            if (typeof init === 'string') {
                const c = yield this.parseMichelineExpression(init);
                if (c === null) throw new $7f31e5493257f9b5$export$12aaf24e6220866b('Invalid init parameter', init);
                parsedInit = c;
            } else parsedInit = yield this.parseJSON(init);
            return parsedInit;
        });
    }
    findGlobalConstantsHashAndValue(schema) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const globalConstantTokens = schema.findToken('constant');
            const globalConstantsHashAndValue = {};
            if (globalConstantTokens.length !== 0) for (const token of globalConstantTokens){
                const tokenArgs = token.tokenVal.args;
                if (tokenArgs) {
                    const expression = tokenArgs[0];
                    if (expression.string) {
                        const hash = expression.string;
                        const michelineValue = yield this.context.globalConstantsProvider.getGlobalConstantByHash(hash);
                        Object.assign(globalConstantsHashAndValue, {
                            [hash]: michelineValue
                        });
                    }
                }
            }
            return globalConstantsHashAndValue;
        });
    }
}
class $7f31e5493257f9b5$export$8307dfe42d1d942a {
    constructor(context){
        this.context = context;
    }
    packData(data) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.context.rpc.packData(data);
        });
    }
}
/**
 *  @category Error
 *  @description Error that indicates that a global constant does not exist
 */ class $7f31e5493257f9b5$export$e37bdb7f2d71b099 extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(hash){
        super();
        this.hash = hash;
        this.name = 'GlobalConstantNotFound';
        this.message = `Please load the value associated with the constant ${hash} using the loadGlobalConstant method of the DefaultGlobalConstantsProvider.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates the global constant provider not being configured under TezosToolkit
 */ class $7f31e5493257f9b5$export$d5855e69e0afe7f9 extends (0, $8b6476b09e20f53e$export$32f4d70b2fb302b1) {
    constructor(){
        super();
        this.name = 'UnconfiguredGlobalConstantsProviderError';
        this.message = 'No global constants provider has been configured. Please configure one by calling setGlobalConstantsProvider({globalConstantsProvider}) on your TezosToolkit instance.';
    }
}
class $7f31e5493257f9b5$var$NoopGlobalConstantsProvider {
    getGlobalConstantByHash(_hash) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            throw new $7f31e5493257f9b5$export$d5855e69e0afe7f9();
        });
    }
}
/**
 * @description Converts calls from TzReadProvider into calls to the wrapped RpcClient in a format it can understand.
 */ class $7f31e5493257f9b5$export$1c914715e594734e {
    constructor(rpc){
        this.rpc = rpc;
    }
    /**
     * @description Access the balance of a contract.
     * @param address address from which we want to retrieve the balance
     * @param block from which we want to retrieve the balance
     * @returns the balance in mutez
     */ getBalance(address, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getBalance(address, {
                block: String(block)
            });
        });
    }
    /**
     * @description Access the delegate of a contract, if any.
     * @param address contract address from which we want to retrieve the delegate (baker)
     * @param block from which we want to retrieve the delegate
     * @returns the public key hash of the delegate or null if no delegate
     */ getDelegate(address, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getDelegate(address, {
                block: String(block)
            });
        });
    }
    /**
     * @description Access the next protocol hash
     * @param block from which we want to retrieve the next protocol hash
     */ getNextProtocol(block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const protocols = yield this.rpc.getProtocols({
                block: String(block)
            });
            return protocols.next_protocol;
        });
    }
    /**
     * @description Access protocol constants used in Taquito
     * @param block from which we want to retrieve the constants
     */ getProtocolConstants(block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { time_between_blocks: time_between_blocks, minimal_block_delay: minimal_block_delay, hard_gas_limit_per_operation: hard_gas_limit_per_operation, hard_gas_limit_per_block: hard_gas_limit_per_block, hard_storage_limit_per_operation: hard_storage_limit_per_operation, cost_per_byte: cost_per_byte, smart_rollup_origination_size: smart_rollup_origination_size } = yield this.rpc.getConstants({
                block: String(block)
            });
            return {
                time_between_blocks: time_between_blocks,
                minimal_block_delay: minimal_block_delay,
                hard_gas_limit_per_operation: hard_gas_limit_per_operation,
                hard_gas_limit_per_block: hard_gas_limit_per_block,
                hard_storage_limit_per_operation: hard_storage_limit_per_operation,
                cost_per_byte: cost_per_byte,
                smart_rollup_origination_size: smart_rollup_origination_size
            };
        });
    }
    /**
     * @description Access the script (code and storage) of a smart contract
     * @param contract contract address from which we want to retrieve the script
     * @param block from which we want to retrieve the storage value
     * @returns Note: The code must be in the JSON format and not contain global constant
     */ getScript(contract, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { script: script } = yield this.rpc.getContract(contract, {
                block: String(block)
            });
            return script;
        });
    }
    /**
     * @description Access the storage value of a contract
     * @param contract contract address from which we want to retrieve the storage
     * @param block from which we want to retrieve the storage value
     */ getStorage(contract, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getStorage(contract, {
                block: String(block)
            });
        });
    }
    /**
     * @description Access the block hash
     */ getBlockHash(block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { hash: hash } = yield this.rpc.getBlockHeader({
                block: String(block)
            });
            return hash;
        });
    }
    /**
     * @description Access the block level
     */ getBlockLevel(block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { level: level } = yield this.rpc.getBlockHeader({
                block: String(block)
            });
            return level;
        });
    }
    /**
     * @description Access the counter of an address
     * @param pkh from which we want to retrieve the counter
     * @param block from which we want to retrieve the counter
     */ getCounter(pkh, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { counter: counter } = yield this.rpc.getContract(pkh, {
                block: String(block)
            });
            return counter || '0';
        });
    }
    /**
     * @description Access the timestamp of a block
     * @param block from which we want to retrieve the timestamp
     * @returns date ISO format zero UTC offset ("2022-01-19T22:37:07Z")
     */ getBlockTimestamp(block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { timestamp: timestamp } = yield this.rpc.getBlockHeader({
                block: String(block)
            });
            return timestamp;
        });
    }
    /**
     * @description Access the value associated with a key in a big map.
     * @param bigMapQuery Big Map ID and Expression hash to query (A b58check encoded Blake2b hash of the expression)
     * @param block from which we want to retrieve the big map value
     */ getBigMapValue(bigMapQuery, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getBigMapExpr(bigMapQuery.id, bigMapQuery.expr, {
                block: String(block)
            });
        });
    }
    /**
     * @description Access the value associated with a sapling state ID.
     * @param id Sapling state ID
     * @param block from which we want to retrieve the sapling state
     */ getSaplingDiffById(saplingStateQuery, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getSaplingDiffById(saplingStateQuery.id, {
                block: String(block)
            });
        });
    }
    /**
     * @description Access the sapling state of a smart contract.
     * @param contractAddress The address of the smart contract
     * @param block The block you want to retrieve the sapling state from
     */ getSaplingDiffByContract(contractAddress, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getSaplingDiffByContract(contractAddress, {
                block: String(block)
            });
        });
    }
    /**
     * @description Return the list of entrypoints of the contract
     * @param contract address of the contract we want to get the entrypoints of
     */ getEntrypoints(contract) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getEntrypoints(contract);
        });
    }
    /**
     * @description Access the chain id
     */ getChainId() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getChainId();
        });
    }
    /**
     * @description Indicate if an account is revealed
     * @param publicKeyHash of the account
     * @param block from which we want to know if the account is revealed
     */ isAccountRevealed(publicKeyHash, block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const manager = yield this.rpc.getManagerKey(publicKeyHash, {
                block: String(block)
            });
            const haveManager = manager && typeof manager === 'object' ? !!manager.key : !!manager;
            return haveManager;
        });
    }
    /**
     * @description Return all the information about a block
     * @param block from which we want to retrieve the information
     */ getBlock(block) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getBlock({
                block: String(block)
            });
        });
    }
    /**
     * @description Return a list of the ancestors of the given block which, if referred to as the branch in an operation header, are recent enough for that operation to be included in the current block.
     * @param block from which we want to retrieve the information
     */ getLiveBlocks(block) {
        return this.rpc.getLiveBlocks({
            block: String(block)
        });
    }
}
/**
 *  @category Error
 *  @description Error that indicates an unsupported event being passed or used
 */ class $7f31e5493257f9b5$var$UnsupportedEventError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(type){
        super();
        this.type = type;
        this.name = 'UnsupportedEventError';
        this.message = `Unsupported event type "${type}" expecting one of the "data", "error", or "close".`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid filter expression being passed or used
 */ class $7f31e5493257f9b5$var$InvalidFilterExpressionError extends (0, $8b6476b09e20f53e$export$9d3f3bc8b6d48950) {
    constructor(invalidExpression){
        super();
        this.invalidExpression = invalidExpression;
        this.name = 'InvalidFilterExpressionError';
        this.message = `Invalid filter expression expecting the object to contain either and/or property`;
    }
}
const $7f31e5493257f9b5$var$opHashFilter = (op, filter)=>op.hash === filter.opHash;
const $7f31e5493257f9b5$var$sourceFilter = (x, filter)=>{
    switch(x.kind){
        case 'attestation':
            return 'metadata' in x && x.metadata.delegate === filter.source;
        case 'endorsement':
            return 'metadata' in x && x.metadata.delegate === filter.source;
        case 'activate_account':
            return 'metadata' in x && x.pkh === filter.source;
        default:
            return 'source' in x && x.source === filter.source;
    }
};
const $7f31e5493257f9b5$var$kindFilter = (x, filter)=>'kind' in x && x.kind === filter.kind;
const $7f31e5493257f9b5$var$destinationFilter = (x, filter)=>{
    switch(x.kind){
        case 'delegation':
            return x.delegate === filter.destination;
        case 'origination':
            if ('metadata' in x && 'operation_result' in x.metadata && 'originated_contracts' in x.metadata.operation_result && Array.isArray(x.metadata.operation_result.originated_contracts)) return x.metadata.operation_result.originated_contracts.some((contract)=>contract === filter.destination);
            break;
        case 'transaction':
            return x.destination === filter.destination;
        default:
            return false;
    }
};
const $7f31e5493257f9b5$var$eventFilter = (result, address, tag, excludeFailedOperations)=>{
    if (result.kind !== 'event') return false;
    if (tag && result.tag !== tag) return false;
    if (address && result.source !== address) return false;
    if (excludeFailedOperations && result.result.status !== 'applied') return false;
    return true;
};
const $7f31e5493257f9b5$var$evaluateOpFilter = (op, filter)=>{
    if ('opHash' in filter) return $7f31e5493257f9b5$var$opHashFilter(op, filter);
    else if ('source' in filter) return $7f31e5493257f9b5$var$sourceFilter(op, filter);
    else if ('kind' in filter) return $7f31e5493257f9b5$var$kindFilter(op, filter);
    else if ('destination' in filter) return $7f31e5493257f9b5$var$destinationFilter(op, filter);
    return false;
};
const $7f31e5493257f9b5$var$evaluateExpression = (op, exp)=>{
    if (Array.isArray(exp.and)) return exp.and.every((x)=>$7f31e5493257f9b5$var$evaluateFilter(op, x));
    else if (Array.isArray(exp.or)) return exp.or.some((x)=>$7f31e5493257f9b5$var$evaluateFilter(op, x));
    else throw new $7f31e5493257f9b5$var$InvalidFilterExpressionError(exp);
};
const $7f31e5493257f9b5$var$evaluateFilter = (op, filter)=>{
    const filters = [];
    if (!Array.isArray(filter)) filters.push(filter);
    else filters.push(...filter);
    return filters.every((filterOrExp)=>{
        if ('and' in filterOrExp || 'or' in filterOrExp) return $7f31e5493257f9b5$var$evaluateExpression(op, filterOrExp);
        else return $7f31e5493257f9b5$var$evaluateOpFilter(op, filterOrExp);
    });
};
/* eslint-disable no-dupe-class-members */ class $7f31e5493257f9b5$export$6e8e62b94261634 {
    constructor(obs, shouldRetry = false, operatorFunction = (0, $bd9ef8e0f52c62f6$export$9369b12211e1fce4)()){
        this.shouldRetry = shouldRetry;
        this.operatorFunction = operatorFunction;
        this.errorListeners = [];
        this.messageListeners = [];
        this.closeListeners = [];
        this.completed$ = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
        obs.pipe((0, $e890d5c5b4491f33$export$ac8dfd3a7ad06e80)(this.completed$), (0, $3e7edc5b22925f26$export$3f23594af5f37336)((data)=>{
            this.call(this.messageListeners, data);
        }, (error)=>{
            this.call(this.errorListeners, error);
        }, ()=>{
            this.call(this.closeListeners);
        }), this.shouldRetry ? operatorFunction : (0, $3e7edc5b22925f26$export$3f23594af5f37336)(), (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>(0, $29707ec27f94d999$export$96c94437c95d7862))).subscribe();
    }
    call(listeners, value) {
        for (const l of listeners)try {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            l(value);
        } catch (ex) {
            console.error(ex);
        }
    }
    remove(listeners, value) {
        const idx = listeners.indexOf(value);
        if (idx !== -1) listeners.splice(idx, 1);
    }
    on(type, cb) {
        switch(type){
            case 'data':
                this.messageListeners.push(cb);
                break;
            case 'error':
                this.errorListeners.push(cb);
                break;
            case 'close':
                this.closeListeners.push(cb);
                break;
            default:
                throw new $7f31e5493257f9b5$var$UnsupportedEventError(type);
        }
    }
    off(type, cb) {
        switch(type){
            case 'data':
                this.remove(this.messageListeners, cb);
                break;
            case 'error':
                this.remove(this.errorListeners, cb);
                break;
            case 'close':
                this.remove(this.closeListeners, cb);
                break;
            default:
                throw new $7f31e5493257f9b5$var$UnsupportedEventError(type);
        }
    }
    close() {
        this.completed$.next();
    }
}
const $7f31e5493257f9b5$var$defaultConfigStreamer = {
    shouldObservableSubscriptionRetry: false,
    observableSubscriptionRetryFunction: (0, $bd9ef8e0f52c62f6$export$9369b12211e1fce4)()
};
const $7f31e5493257f9b5$var$getLastBlock = (context)=>{
    return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(context.rpc.getBlock()).pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)());
};
const $7f31e5493257f9b5$var$applyFilter = (filter)=>(0, $9ee54e147202c320$export$c28c8388be0ab31a)((block)=>{
        return new (0, $4f562137a990678a$export$77cea355fa80b5f4)((sub)=>{
            for (const ops of block.operations)for (const op of ops){
                for (const content of op.contents)if ($7f31e5493257f9b5$var$evaluateFilter(Object.assign({
                    hash: op.hash
                }, content), filter)) sub.next(Object.assign({
                    hash: op.hash
                }, content));
            }
            sub.complete();
        });
    });
const $7f31e5493257f9b5$var$applyEventFilter = (filter)=>(0, $9ee54e147202c320$export$c28c8388be0ab31a)((block)=>{
        return new (0, $4f562137a990678a$export$77cea355fa80b5f4)((sub)=>{
            for (const ops of block.operations){
                for (const op of ops)for (const content of op.contents){
                    const tx = content;
                    const internalOpResults = tx.metadata.internal_operation_results;
                    if (internalOpResults) {
                        for (const event of internalOpResults)if ($7f31e5493257f9b5$var$eventFilter(event, filter === null || filter === void 0 ? void 0 : filter.address, filter === null || filter === void 0 ? void 0 : filter.tag, filter === null || filter === void 0 ? void 0 : filter.excludeFailedOperations)) sub.next(Object.assign({
                            opHash: op.hash,
                            blockHash: block.hash,
                            level: block.header.level
                        }, event));
                    }
                }
            }
            sub.complete();
        });
    });
class $7f31e5493257f9b5$export$fcbb611d52e45815 {
    constructor(context, config = {}){
        this.context = context;
        this._config$ = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(Object.assign(Object.assign({}, $7f31e5493257f9b5$var$defaultConfigStreamer), config));
        this.timer$ = this._config$.pipe((0, $4be1a9d761a9d3e3$export$c44985b87d605eff)('pollingIntervalMilliseconds'), (0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((pollingIntervalMilliseconds)=>{
            if (!pollingIntervalMilliseconds) return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(this.getConfirmationPollingInterval()).pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((interval)=>{
                return (0, $bce9e90ba9895d75$export$9dc4ecf953986f04)(0, interval);
            }));
            else return (0, $bce9e90ba9895d75$export$9dc4ecf953986f04)(0, pollingIntervalMilliseconds);
        }));
        this.newBlock$ = this.timer$.pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)(()=>$7f31e5493257f9b5$var$getLastBlock(this.context)), (0, $5b7702bd13db251d$export$571da16e28367bde)('hash'), (0, $dc522c7fdf273a70$export$89b472e03be495df)(), (0, $0a82afceb3f717e3$export$18d0766d894cba0c)());
    }
    get config() {
        return this._config$.getValue();
    }
    getConfirmationPollingInterval() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.config.pollingIntervalMilliseconds) {
                const defaultIntervalTestnetsMainnet = 5000;
                const defaultIntervalSandbox = 1000;
                try {
                    const constants = yield this.context.readProvider.getProtocolConstants('head');
                    const blockTime = constants.minimal_block_delay ? constants.minimal_block_delay.multipliedBy(1000) : constants.time_between_blocks ? constants.time_between_blocks[0].multipliedBy(1000) : new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(defaultIntervalTestnetsMainnet);
                    const confirmationPollingInterval = blockTime.dividedBy(3);
                    this.config.pollingIntervalMilliseconds = confirmationPollingInterval.toNumber() === 0 ? defaultIntervalSandbox : confirmationPollingInterval.toNumber();
                } catch (exception) {
                    return defaultIntervalTestnetsMainnet;
                }
            }
            return this.config.pollingIntervalMilliseconds;
        });
    }
    subscribeBlock(_filter) {
        return new $7f31e5493257f9b5$export$6e8e62b94261634(this.newBlock$, this.config.shouldObservableSubscriptionRetry, this.config.observableSubscriptionRetryFunction);
    }
    subscribe(_filter) {
        return new $7f31e5493257f9b5$export$6e8e62b94261634(this.newBlock$.pipe((0, $4be1a9d761a9d3e3$export$c44985b87d605eff)('hash')), this.config.shouldObservableSubscriptionRetry, this.config.observableSubscriptionRetryFunction);
    }
    subscribeOperation(filter) {
        return new $7f31e5493257f9b5$export$6e8e62b94261634(this.newBlock$.pipe($7f31e5493257f9b5$var$applyFilter(filter)), this.config.shouldObservableSubscriptionRetry, this.config.observableSubscriptionRetryFunction);
    }
    subscribeEvent(eventFilter) {
        return new $7f31e5493257f9b5$export$6e8e62b94261634(this.newBlock$.pipe($7f31e5493257f9b5$var$applyEventFilter(eventFilter)), this.config.shouldObservableSubscriptionRetry, this.config.observableSubscriptionRetryFunction);
    }
}
class $7f31e5493257f9b5$export$4839b713e89da7ba {
    constructor(context){
        this.context = context;
    }
    getNextProto() {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.context.proto) {
                const nextProto = yield this.context.readProvider.getNextProtocol('head');
                this.context.proto = nextProto;
            }
            return this.context.proto;
        });
    }
    forge({ branch: branch, contents: contents }) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const forger = new (0, $2c9dd9fad62b5317$export$99b12ddbeed7bd69)((yield this.getNextProto()));
            return forger.forge({
                branch: branch,
                contents: contents
            });
        });
    }
}
const $7f31e5493257f9b5$export$a85a981d7f4618bf = {
    defaultConfirmationCount: 1,
    confirmationPollingTimeoutSecond: 180
};
/**
 * @description Encapsulate common service used throughout different part of the library
 */ class $7f31e5493257f9b5$export$841858b892ce1f4c {
    constructor(_rpc, _signer = new $7f31e5493257f9b5$var$NoopSigner(), _proto, _config = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(Object.assign({}, $7f31e5493257f9b5$export$a85a981d7f4618bf)), forger, injector, packer, wallet, parser, globalConstantsProvider, readProvider, stream){
        this._rpc = _rpc;
        this._signer = _signer;
        this._proto = _proto;
        this._config = _config;
        this.providerDecorator = [];
        this.tz = new $7f31e5493257f9b5$var$RpcTzProvider(this);
        this.estimate = new $7f31e5493257f9b5$export$a0b53ef5867b3b16(this);
        this.contract = new $7f31e5493257f9b5$var$RpcContractProvider(this, this.estimate);
        this.prepare = new $7f31e5493257f9b5$export$c3ce3aa140a1bd8b(this);
        this.batch = new $7f31e5493257f9b5$var$RPCBatchProvider(this, this.estimate);
        this.wallet = new $7f31e5493257f9b5$export$bcca3ea514774656(this);
        /**
         * @description Applies the decorators on a cloned instance of the context and returned this cloned instance.
         * The decorators are functions that inject logic into the context.
         * They are provided by the extensions set on the TezosToolkit by calling the registerProviderDecorator method.
         */ this.withExtensions = ()=>{
            let clonedContext = this.clone();
            this.providerDecorator.forEach((decorator)=>{
                clonedContext = decorator(clonedContext);
            });
            return clonedContext;
        };
        if (typeof this._rpc === 'string') this._rpcClient = new (0, $5db8d2af09626b01$export$60aeb6b70d862cfd)(this._rpc);
        else this._rpcClient = this._rpc;
        this._forger = forger ? forger : new $7f31e5493257f9b5$export$4839b713e89da7ba(this);
        this._injector = injector ? injector : new $7f31e5493257f9b5$export$e81caaa38ad97a2(this);
        this.operationFactory = new $7f31e5493257f9b5$var$OperationFactory(this);
        this._walletProvider = wallet ? wallet : new $7f31e5493257f9b5$export$7e71cfc210e8a8fd(this);
        this._parser = parser ? parser : new $7f31e5493257f9b5$export$9b8795d63420af7f(this);
        this._packer = packer ? packer : new $7f31e5493257f9b5$export$8307dfe42d1d942a(this);
        this._globalConstantsProvider = globalConstantsProvider ? globalConstantsProvider : new $7f31e5493257f9b5$var$NoopGlobalConstantsProvider();
        this._readProvider = readProvider ? readProvider : new $7f31e5493257f9b5$export$1c914715e594734e(this._rpcClient);
        this._stream = stream ? stream : new $7f31e5493257f9b5$export$fcbb611d52e45815(this);
    }
    get config() {
        return this._config.getValue();
    }
    set config(value) {
        this._config.next(Object.assign({}, value));
    }
    setPartialConfig(value) {
        this._config.next(Object.assign(Object.assign({}, this._config.getValue()), value));
    }
    get rpc() {
        return this._rpcClient;
    }
    set rpc(value) {
        this._rpcClient = value;
    }
    get injector() {
        return this._injector;
    }
    set injector(value) {
        this._injector = value;
    }
    get forger() {
        return this._forger;
    }
    set forger(value) {
        this._forger = value;
    }
    get signer() {
        return this._signer;
    }
    set signer(value) {
        this._signer = value;
    }
    get walletProvider() {
        return this._walletProvider;
    }
    set walletProvider(value) {
        this._walletProvider = value;
    }
    set proto(value) {
        this._proto = value;
    }
    get proto() {
        return this._proto;
    }
    get parser() {
        return this._parser;
    }
    set parser(value) {
        this._parser = value;
    }
    get packer() {
        return this._packer;
    }
    set packer(value) {
        this._packer = value;
    }
    get globalConstantsProvider() {
        return this._globalConstantsProvider;
    }
    set globalConstantsProvider(value) {
        this._globalConstantsProvider = value;
    }
    get readProvider() {
        return this._readProvider;
    }
    set readProvider(value) {
        this._readProvider = value;
    }
    get stream() {
        return this._stream;
    }
    set stream(value) {
        this._stream = value;
    }
    isAnyProtocolActive(protocol = []) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            if (this._proto) return protocol.includes(this._proto);
            else {
                const next_protocol = yield this.readProvider.getNextProtocol('head');
                return protocol.includes(next_protocol);
            }
        });
    }
    isAnySignerConfigured() {
        return !(this.signer instanceof $7f31e5493257f9b5$var$NoopSigner);
    }
    /**
     * @description Create a copy of the current context. Useful when you have long running operation and you do not want a context change to affect the operation
     */ clone() {
        return new $7f31e5493257f9b5$export$841858b892ce1f4c(this.rpc, this.signer, this.proto, this._config, this.forger, this._injector, this.packer, this._walletProvider, this._parser, this._globalConstantsProvider, this._readProvider, this._stream);
    }
    /**
     * @description Allows extensions set on the TezosToolkit to inject logic into the context
     */ registerProviderDecorator(fx) {
        this.providerDecorator.push(fx);
    }
}
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $7f31e5493257f9b5$var$VERSION = {
    "commitHash": "2e05f6f865be17a1b367b284542b24ffa9823271",
    "version": "19.2.1"
};
/**
 *  @category Error
 *  @description Error that indicates CompositeForger.forge() results doesn't match each other
 */ class $7f31e5493257f9b5$var$ForgingMismatchError extends (0, $8b6476b09e20f53e$export$e5619b407b1c8b0a) {
    constructor(results){
        super();
        this.results = results;
        this.name = 'ForgingMismatchError';
        this.message = `Forging mismatch error`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates no forger has been configured for CompositeForger
 */ class $7f31e5493257f9b5$var$UnspecifiedForgerError extends (0, $8b6476b09e20f53e$export$32f4d70b2fb302b1) {
    constructor(){
        super();
        this.name = 'UnspecifiedForgerError';
        this.message = 'No forger has been configured. Please configure new CompositeForger([rpcForger, localForger]) with your TezosToolkit instance.';
    }
}
class $7f31e5493257f9b5$export$b97726c11624d323 {
    constructor(forgers){
        this.forgers = forgers;
        if (forgers.length === 0) throw new $7f31e5493257f9b5$var$UnspecifiedForgerError();
    }
    forge({ branch: branch, contents: contents }) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const results = yield Promise.all(this.forgers.map((forger)=>{
                return forger.forge({
                    branch: branch,
                    contents: contents
                });
            }));
            if (results.length === 0) throw new $7f31e5493257f9b5$var$UnspecifiedForgerError();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            let lastResult = results.pop(); // Assumed to be more than one since we
            while(results.length){
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const currentResult = results.pop();
                if (currentResult !== lastResult) throw new $7f31e5493257f9b5$var$ForgingMismatchError([
                    lastResult,
                    currentResult
                ]);
                lastResult = currentResult;
            }
            return lastResult;
        });
    }
}
class $7f31e5493257f9b5$export$376487449fdf3d19 {
    constructor(context){
        this.context = context;
    }
    forge({ branch: branch, contents: contents }) {
        return this.context.rpc.forgeOperations({
            branch: branch,
            contents: contents
        });
    }
}
class $7f31e5493257f9b5$export$5a9951b6b3403c22 {
    prepareCodeOrigination(params) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            return params;
        });
    }
}
class $7f31e5493257f9b5$export$672bcfa981578382 {
    packData(data) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const { bytes: bytes } = (0, $463f724b64570f1c$export$ec5c026f9926015c)(data.data, data.type);
            return {
                packed: bytes
            };
        });
    }
}
class $7f31e5493257f9b5$export$5a51e32d682f4b88 {
    constructor(){
        this._globalConstantsLibrary = {};
    }
    /**
     *
     * @description Allows to load global constant hashes and their corresponding Michelson JSON values
     */ loadGlobalConstant(globalConstant) {
        for(const hash in globalConstant)Object.assign(this._globalConstantsLibrary, {
            [hash]: globalConstant[hash]
        });
    }
    /**
     *
     * @description Retrieve the Michelson value of a global constant based on its hash
     *
     * @param hash a string representing the global constant hash
     * @returns Expr, the JSON Michelson value
     */ getGlobalConstantByHash(hash) {
        return $7f31e5493257f9b5$var$__awaiter(this, void 0, void 0, function*() {
            const value = this._globalConstantsLibrary[hash];
            if (!value) throw new $7f31e5493257f9b5$export$e37bdb7f2d71b099(hash);
            return value;
        });
    }
}
/**
 * @packageDocumentation
 * @module @taquito/taquito
 */ /**
 * @description Facade class that surfaces all of the libraries capability and allow it's configuration
 *
 * @param _rpc The RPC server to use
 */ class $7f31e5493257f9b5$export$7e3881046cc8cfeb {
    constructor(_rpc){
        this._rpc = _rpc;
        this._options = {};
        this.format = (0, $201657d342d01b1b$export$d9468344d3651243);
        if (typeof this._rpc === 'string') this._rpcClient = new (0, $5db8d2af09626b01$export$60aeb6b70d862cfd)(this._rpc);
        else this._rpcClient = this._rpc;
        this._context = new $7f31e5493257f9b5$export$841858b892ce1f4c(_rpc);
        this._wallet = new $7f31e5493257f9b5$export$bcca3ea514774656(this._context);
        this.setProvider({
            rpc: this._rpcClient
        });
        this.batch = this._context.batch.batch.bind(this._context.batch);
    }
    /**
     * @description Sets configuration on the Tezos Taquito instance. Allows user to choose which signer, rpc client, rpc url, forger and so forth
     *
     * @param options rpc url or rpcClient to use to interact with the Tezos network
     *
     * @example Tezos.setProvider({rpc: 'https://mainnet.ecadinfra.com/', signer: new InMemorySigner.fromSecretKey(“edsk...”)})
     * @example Tezos.setProvider({ config: { confirmationPollingTimeoutSecond: 300 }})
     *
     */ setProvider({ rpc: rpc, stream: stream, signer: signer, protocol: protocol, config: config, forger: forger, wallet: wallet, packer: packer, globalConstantsProvider: globalConstantsProvider, readProvider: readProvider, parserProvider: parserProvider, injectorProvider: injectorProvider }) {
        this.setRpcProvider(rpc);
        this.setStreamProvider(stream);
        this.setSignerProvider(signer);
        this.setForgerProvider(forger);
        this.setWalletProvider(wallet);
        this.setPackerProvider(packer);
        this.setGlobalConstantsProvider(globalConstantsProvider);
        this.setReadProvider(readProvider);
        this.setParserProvider(parserProvider);
        this.setInjectorProvider(injectorProvider);
        this._context.proto = protocol;
        if (config) this._context.setPartialConfig(config);
    }
    /**
     * @description Sets signer provider on the Tezos Taquito instance.
     *
     * @param options signer to use to interact with the Tezos network
     *
     * @example Tezos.setSignerProvider(new InMemorySigner.fromSecretKey('edsk...'))
     *
     */ setSignerProvider(signer) {
        if (!this._options.signer && typeof signer === 'undefined') {
            this._context.signer = new $7f31e5493257f9b5$var$NoopSigner();
            this._options.signer = signer;
        } else if (typeof signer !== 'undefined') {
            this._context.signer = signer;
            this._options.signer = signer;
        }
    }
    /**
     * @description Sets rpc provider on the Tezos Taquito instance
     *
     * @param options rpc url or rpcClient to use to interact with the Tezos network
     *
     * @example Tezos.setRpcProvider('https://mainnet.ecadinfra.com/')
     *
     */ setRpcProvider(rpc) {
        if (typeof rpc === 'string') this._rpcClient = new (0, $5db8d2af09626b01$export$60aeb6b70d862cfd)(rpc);
        else if (rpc === undefined) ;
        else this._rpcClient = rpc;
        this._options.rpc = this._rpcClient;
        this._context.rpc = this._rpcClient;
    }
    /**
     * @description Sets forger provider on the Tezos Taquito instance
     * The `LocalForger` from `@taquito/local-forging` is set by default.
     *
     * @param options forger to use to interact with the Tezos network
     *
     * @example Tezos.setForgerProvider(this.getFactory(RpcForger)())
     *
     */ setForgerProvider(forger) {
        if (typeof forger !== 'undefined') {
            this._options.forger = forger;
            this._context.forger = forger;
        } else if (this._options.forger === undefined) {
            const f = this.getFactory($7f31e5493257f9b5$export$4839b713e89da7ba)();
            this._options.forger = f;
            this._context.forger = f;
        }
    }
    /**
     * @description Sets stream provider on the Tezos Taquito instance
     *
     * @param options stream to use to interact with the Tezos network
     *
     * @example Tezos.setStreamProvider(...)
     *
     */ setStreamProvider(stream) {
        if (typeof stream === 'string') {
            const s = new $7f31e5493257f9b5$export$fcbb611d52e45815(new $7f31e5493257f9b5$export$841858b892ce1f4c(new (0, $5db8d2af09626b01$export$60aeb6b70d862cfd)(stream)));
            this._options.stream = s;
            this._context.stream = s;
        } else if (typeof stream !== 'undefined') {
            this._options.stream = stream;
            this._context.stream = stream;
        } else if (this._options.stream === undefined) {
            const s = this.getFactory($7f31e5493257f9b5$export$fcbb611d52e45815)();
            this._options.stream = s;
            this._context.stream = s;
        }
    }
    /**
     * @description Sets wallet provider on the Tezos Taquito instance
     *
     * @param options wallet to use to interact with the Tezos network
     *
     * @example Tezos.setWalletProvider(...)
     *
     */ setWalletProvider(wallet) {
        if (!this._options.wallet && typeof wallet === 'undefined') {
            const w = this.getFactory($7f31e5493257f9b5$export$7e71cfc210e8a8fd)();
            this._options.wallet = w;
            this._context.walletProvider = w;
        } else if (typeof wallet !== 'undefined') {
            this._options.wallet = wallet;
            this._context.walletProvider = wallet;
        }
    }
    /**
     * @description Sets Packer provider on the Tezos Taquito instance
     *
     * @param options packer to use to interact with the Tezos network
     *
     * @example Tezos.setPackerProvider(new MichelCodecPacker())
     *
     */ setPackerProvider(packer) {
        if (!this._options.packer && typeof packer === 'undefined') {
            const p = this.getFactory($7f31e5493257f9b5$export$8307dfe42d1d942a)();
            this._context.packer = p;
            this._options.packer = p;
        } else if (typeof packer !== 'undefined') {
            this._context.packer = packer;
            this._options.packer = packer;
        }
    }
    /**
     * @description Sets global constants provider on the Tezos Taquito instance
     *
     * @param options globalConstantsProvider to use to interact with the Tezos network
     *
     * @example
     * ```
     * const globalConst = new DefaultGlobalConstantsProvider();
     * globalConst.loadGlobalConstant({
     *  "expruu5BTdW7ajqJ9XPTF3kgcV78pRiaBW3Gq31mgp3WSYjjUBYxre": { prim: "int" },
     *  // ...
     * })
     * Tezos.setGlobalConstantsProvider(globalConst);
     * ```
     *
     */ setGlobalConstantsProvider(globalConstantsProvider) {
        if (!this._options.globalConstantsProvider && typeof globalConstantsProvider === 'undefined') {
            const g = new $7f31e5493257f9b5$var$NoopGlobalConstantsProvider();
            this._context.globalConstantsProvider = g;
            this._options.globalConstantsProvider = g;
        } else if (typeof globalConstantsProvider !== 'undefined') {
            this._context.globalConstantsProvider = globalConstantsProvider;
            this._options.globalConstantsProvider = globalConstantsProvider;
        }
    }
    /**
     * @description Sets read provider on the Tezos Taquito instance
     * By default reads are done from the RPC usign the RpcReadAdapter class, this can be overridden to read from an indexer that implements the TzReadProvider interface
     *
     * @param options TzReadProvider to use to interact with the Tezos network
     *
     */ setReadProvider(readProvider) {
        const readP = readProvider ? readProvider : new $7f31e5493257f9b5$export$1c914715e594734e(this._context.rpc);
        this._options.readProvider = readP;
        this._context.readProvider = readP;
    }
    /**
     * @description Sets parser provider on the Tezos Taquito instance
     *
     * @param options parserProvider to use to interact with the Tezos network
     *
     */ setParserProvider(parserProvider) {
        if (!this._options.parserProvider && typeof parserProvider === 'undefined') {
            const p = new $7f31e5493257f9b5$export$9b8795d63420af7f(this._context);
            this._context.parser = p;
            this._options.parserProvider = p;
        } else if (typeof parserProvider !== 'undefined') {
            this._context.parser = parserProvider;
            this._options.parserProvider = parserProvider;
        }
    }
    /**
     * @description Sets injector provider on the Tezos Taquito instance
     *
     * @param options Injector to use to interact with the Tezos network by default RpcInjector
     *
     */ setInjectorProvider(injectorProvider) {
        if (!this._options.injectorProvider && typeof injectorProvider === 'undefined') {
            const i = new $7f31e5493257f9b5$export$e81caaa38ad97a2(this._context);
            this._context.injector = i;
            this._options.injectorProvider = i;
        } else if (typeof injectorProvider !== 'undefined') {
            this._context.injector = injectorProvider;
            this._options.injectorProvider = injectorProvider;
        }
    }
    /**
     * @description Provide access to tezos account management
     */ get tz() {
        return this._context.tz;
    }
    /**
     * @description Provide access to smart contract utilities
     */ get contract() {
        return this._context.contract;
    }
    /**
     * @description Provide access to tezos operation preparation utilities
     */ get prepare() {
        return this._context.prepare;
    }
    get wallet() {
        return this._wallet;
    }
    get operation() {
        return this._context.operationFactory;
    }
    /**
     * @description Provide access to operation estimation utilities
     */ get estimate() {
        return this._context.estimate;
    }
    /**
     * @description Provide access to streaming utilities backed by an streamer implementation
     */ get stream() {
        return this._context.stream;
    }
    /**
     * @description Provide access to the currently used rpc client
     */ get rpc() {
        return this._context.rpc;
    }
    /**
     * @description Provide access to the currently used signer
     */ get signer() {
        return this._context.signer;
    }
    /**
     * @description Provide access to the currently used globalConstantsProvider
     */ get globalConstants() {
        return this._context.globalConstantsProvider;
    }
    /**
     * @description Allow to add a module to the TezosToolkit instance. This method adds the appropriate Providers(s) required by the module to the internal context.
     *
     * @param module extension to add to the TezosToolkit instance
     *
     * @example Tezos.addExtension(new Tzip16Module());
     */ addExtension(module) {
        if (Array.isArray(module)) module.forEach((extension)=>extension.configureContext(this._context));
        else module.configureContext(this._context);
    }
    getFactory(ctor) {
        return (...args)=>{
            return new ctor(this._context, ...args);
        };
    }
    /**
     * @description Gets an object containing the version of Taquito library and git sha of the commit this library is compiled from
     */ getVersionInfo() {
        return $7f31e5493257f9b5$var$VERSION;
    }
}



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $16f6c354b96bd06b$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
/**
 *  @category Error
 *  @description Error that indicates the Beacon wallet not being initialized
 */ class $16f6c354b96bd06b$export$e4da2ce9a9c6df80 extends (0, $8b6476b09e20f53e$export$9c81d48c1e1840ac) {
    constructor(){
        super();
        this.name = 'BeaconWalletNotInitialized';
        this.message = 'BeaconWallet needs to be initialized by calling `await BeaconWallet.requestPermissions({network: {type: "chosen_network"}})` first.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates missing required persmission scopes
 */ class $16f6c354b96bd06b$export$718a8bb30e8a4f55 extends (0, $8b6476b09e20f53e$export$9c81d48c1e1840ac) {
    constructor(requiredScopes){
        super();
        this.requiredScopes = requiredScopes;
        this.name = 'MissingRequiredScopes';
        this.message = `Required permissions scopes: ${requiredScopes.join(',')} were not granted.`;
    }
}
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $16f6c354b96bd06b$export$a4ad2735b021c132 = {
    "commitHash": "2e05f6f865be17a1b367b284542b24ffa9823271",
    "version": "19.2.1"
};
/**
 * @packageDocumentation
 * @module @taquito/beacon-wallet
 */ class $16f6c354b96bd06b$export$e5d731035abe2ea9 {
    constructor(options){
        this.client = (0, $709a4935e9866802$export$156a5106377fc5bb)(options);
        this.client.subscribeToEvent((0, $0b587c8852746f57$export$8d08de21eea96a9c).ACTIVE_ACCOUNT_SET, (data)=>$16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
                this.account = data;
            }));
    }
    validateRequiredScopesOrFail(permissionScopes, requiredScopes) {
        const mandatoryScope = new Set(requiredScopes);
        for (const scope of permissionScopes)if (mandatoryScope.has(scope)) mandatoryScope.delete(scope);
        if (mandatoryScope.size > 0) throw new $16f6c354b96bd06b$export$718a8bb30e8a4f55(Array.from(mandatoryScope));
    }
    requestPermissions(request) {
        return $16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.client.requestPermissions(request);
        });
    }
    getPKH() {
        return $16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.account) throw new $16f6c354b96bd06b$export$e4da2ce9a9c6df80();
            return this.account.address;
        });
    }
    getPK() {
        var _a;
        return $16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.account) throw new $16f6c354b96bd06b$export$e4da2ce9a9c6df80();
            return (_a = this.account.publicKey) !== null && _a !== void 0 ? _a : '';
        });
    }
    mapTransferParamsToWalletParams(params) {
        return $16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
            let walletParams;
            yield this.client.showPrepare();
            try {
                walletParams = yield params();
            } catch (err) {
                yield this.client.hideUI([
                    'alert'
                ]);
                throw err;
            }
            return this.removeDefaultParams(walletParams, (yield (0, $7f31e5493257f9b5$export$f3a9991068ba8db1)(this.formatParameters(walletParams))));
        });
    }
    mapIncreasePaidStorageWalletParams(params) {
        return $16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
            let walletParams;
            yield this.client.showPrepare();
            try {
                walletParams = yield params();
            } catch (err) {
                yield this.client.hideUI([
                    'alert'
                ]);
                throw err;
            }
            return this.removeDefaultParams(walletParams, (yield (0, $7f31e5493257f9b5$export$8bbbca5738264f6e)(this.formatParameters(walletParams))));
        });
    }
    mapOriginateParamsToWalletParams(params) {
        return $16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
            let walletParams;
            yield this.client.showPrepare();
            try {
                walletParams = yield params();
            } catch (err) {
                yield this.client.hideUI([
                    'alert'
                ]);
                throw err;
            }
            return this.removeDefaultParams(walletParams, (yield (0, $7f31e5493257f9b5$export$64dd15b44cde1e0b)(this.formatParameters(walletParams))));
        });
    }
    mapDelegateParamsToWalletParams(params) {
        return $16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
            let walletParams;
            yield this.client.showPrepare();
            try {
                walletParams = yield params();
            } catch (err) {
                yield this.client.hideUI([
                    'alert'
                ]);
                throw err;
            }
            return this.removeDefaultParams(walletParams, (yield (0, $7f31e5493257f9b5$export$f6ca8c66abd5d967)(this.formatParameters(walletParams))));
        });
    }
    formatParameters(params) {
        if (params.fee) params.fee = params.fee.toString();
        if (params.storageLimit) params.storageLimit = params.storageLimit.toString();
        if (params.gasLimit) params.gasLimit = params.gasLimit.toString();
        return params;
    }
    removeDefaultParams(params, operatedParams) {
        // If fee, storageLimit or gasLimit is undefined by user
        // in case of beacon wallet, dont override it by
        // defaults.
        if (!params.fee) delete operatedParams.fee;
        if (!params.storageLimit) delete operatedParams.storage_limit;
        if (!params.gasLimit) delete operatedParams.gas_limit;
        return operatedParams;
    }
    sendOperations(params) {
        return $16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.account) throw new $16f6c354b96bd06b$export$e4da2ce9a9c6df80();
            const permissions = this.account.scopes;
            this.validateRequiredScopesOrFail(permissions, [
                (0, $23ff6a3db924eefa$export$daafb2ca9aa4674b).OPERATION_REQUEST
            ]);
            const { transactionHash: transactionHash } = yield this.client.requestOperation({
                operationDetails: params
            });
            return transactionHash;
        });
    }
    /**
     *
     * @description Removes all beacon values from the storage. After using this method, this instance is no longer usable.
     * You will have to instantiate a new BeaconWallet.
     */ disconnect() {
        return $16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.client.destroy();
        });
    }
    /**
     *
     * @description This method removes the active account from local storage by setting it to undefined.
     */ clearActiveAccount() {
        return $16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.client.setActiveAccount();
        });
    }
    sign(bytes, watermark) {
        return $16f6c354b96bd06b$var$__awaiter(this, void 0, void 0, function*() {
            let bb = (0, $201657d342d01b1b$export$80feccbc0acd4657)(bytes);
            if (typeof watermark !== 'undefined') bb = (0, $201657d342d01b1b$export$196099622a18a454)(watermark, bb);
            const watermarkedBytes = (0, $201657d342d01b1b$export$b0491dd0626f8a03)((0, (/*@__PURE__*/$parcel$interopDefault($42fd859874341478$exports)))(bb));
            const signingType = this.getSigningType(watermark);
            if (signingType !== (0, $1135dc71db7da99c$export$ecff5c1a4386a2e0).OPERATION) throw new (0, $8b6476b09e20f53e$export$34bc216509d47ce6)(`Taquito Beacon Wallet currently only supports signing operations, not ${signingType}`);
            const { signature: signature } = yield this.client.requestSignPayload({
                payload: watermarkedBytes,
                signingType: signingType
            });
            return signature;
        });
    }
    getSigningType(watermark) {
        if (!watermark || watermark.length === 0) return (0, $1135dc71db7da99c$export$ecff5c1a4386a2e0).RAW;
        if (watermark.length === 1) {
            if (watermark[0] === 5) return (0, $1135dc71db7da99c$export$ecff5c1a4386a2e0).MICHELINE;
            if (watermark[0] === 3) return (0, $1135dc71db7da99c$export$ecff5c1a4386a2e0).OPERATION;
        }
        throw new Error(`Invalid watermark ${JSON.stringify(watermark)}`);
    }
}


// ==========================================================================================
// parent error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Parent error class all taquito errors to extend from
 */ class $c61afbb8e2f8b25e$export$e5619b407b1c8b0a extends Error {
}
/**
 *  @category Error
 *  @description Error that indicates invalid user inputs
 */ class $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 extends $c61afbb8e2f8b25e$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error returned by RPC node
 */ class $c61afbb8e2f8b25e$export$5460eff990f31920 extends $c61afbb8e2f8b25e$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates TezosToolKit has not been configured appropriately
 */ class $c61afbb8e2f8b25e$export$32f4d70b2fb302b1 extends $c61afbb8e2f8b25e$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates a requested action is not supported by Taquito
 */ class $c61afbb8e2f8b25e$export$34bc216509d47ce6 extends $c61afbb8e2f8b25e$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error during a network operation
 */ class $c61afbb8e2f8b25e$export$bae979e68e4dc802 extends $c61afbb8e2f8b25e$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates user attempts an action without necessary permissions
 */ class $c61afbb8e2f8b25e$export$9c81d48c1e1840ac extends $c61afbb8e2f8b25e$export$e5619b407b1c8b0a {
}
// ==========================================================================================
// common error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Error that indicates an invalid originated or implicit address being passed or used
 */ class $c61afbb8e2f8b25e$export$66c44d927ffead98 extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidAddressError';
        this.message = `Invalid address "${address}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
class $c61afbb8e2f8b25e$export$be6cb9338b7137e0 extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidStakingAddressError';
        this.message = `Invalid staking address "${address}", you can only set destination as your own address`;
    }
}
class $c61afbb8e2f8b25e$export$1623a856d8b6cc2a extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidFinalizeUnstakeAmountError';
        this.message = `The amount can only be 0 when finalizing an unstake`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid block hash being passed or used
 */ class $c61afbb8e2f8b25e$export$16fabd343bcdfd7b extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(blockHash, errorDetail){
        super();
        this.blockHash = blockHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidBlockHashError';
        this.message = `Invalid block hash "${blockHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid amount of tez being passed as a parameter
 */ class $c61afbb8e2f8b25e$export$d8bf6d22cce8e288 extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(amount){
        super();
        this.amount = amount;
        this.name = 'InvalidAmountError';
        this.message = `Invalid amount "${amount}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid derivation path being passed or used
 */ class $c61afbb8e2f8b25e$export$522ca3df7030c309 extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(derivationPath, errorDetail){
        super();
        this.derivationPath = derivationPath;
        this.errorDetail = errorDetail;
        this.name = 'InvalidDerivationPathError';
        this.message = `Invalid derivation path "${derivationPath}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid hex string have been passed or used
 */ class $c61afbb8e2f8b25e$export$1888d6928c74d5ee extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(hexString, errorDetail){
        super();
        this.hexString = hexString;
        this.errorDetail = errorDetail;
        this.name = 'InvalidHexStringError';
        this.message = `Invalid hex string "${hexString}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid message being passed or used
 */ class $c61afbb8e2f8b25e$export$a5124d7665e9d8ad extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(msg, errorDetail){
        super();
        this.msg = msg;
        this.errorDetail = errorDetail;
        this.name = 'InvalidMessageError';
        this.message = `Invalid message "${msg}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid view parameter of a smart contract
 */ class $c61afbb8e2f8b25e$export$f9ce6a924724628b extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(viewName, sigs, args, cause){
        super();
        this.viewName = viewName;
        this.sigs = sigs;
        this.args = args;
        this.cause = cause;
        this.name = 'InvalidViewParameterError';
        this.message = `Invalid view arguments ${JSON.stringify(args)} received for name "${viewName}" expecting one of the following signatures ${JSON.stringify(sigs)}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid private key being passed or used
 */ class $c61afbb8e2f8b25e$export$adf223add86ae0aa extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(errorDetail){
        super();
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyError';
        this.message = `Invalid private key`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an Invalid Public Key being passed or used
 */ class $c61afbb8e2f8b25e$export$f675822ed489f01f extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(publicKey, errorDetail){
        super();
        this.publicKey = publicKey;
        this.errorDetail = errorDetail;
        this.name = 'InvalidPublicKeyError';
        this.message = `Invalid public key "${publicKey}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid signature being passed or used
 */ class $c61afbb8e2f8b25e$export$ccc2f68ef106615a extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(signature, errorDetail){
        super();
        this.signature = signature;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSignatureError';
        this.message = `Invalid signature "${signature}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid contract address being passed or used
 */ class $c61afbb8e2f8b25e$export$193774326795229b extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(contractAddress, errorDetail){
        super();
        this.contractAddress = contractAddress;
        this.errorDetail = errorDetail;
        this.name = 'InvalidContractAddressError';
        this.message = `Invalid contract address "${contractAddress}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid chain id being passed or used
 */ class $c61afbb8e2f8b25e$export$4836eb835ffca5b2 extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(chainId, errorDetail){
        super();
        this.chainId = chainId;
        this.errorDetail = errorDetail;
        this.name = 'InvalidChainIdError';
        this.message = `Invalid chain id "${chainId}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid public key hash being passed or used
 */ class $c61afbb8e2f8b25e$export$a3d7df0ca9d9410c extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(keyHash, errorDetail){
        super();
        this.keyHash = keyHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyHashError';
        this.message = `Invalid public key hash "${keyHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation hash being passed or used
 */ class $c61afbb8e2f8b25e$export$1a1c2023d3ec7a8a extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(operationHash, errorDetail){
        super();
        this.operationHash = operationHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationHashError';
        this.message = `Invalid operation hash "${operationHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation kind being passed or used
 */ class $c61afbb8e2f8b25e$export$bc5be87550569b55 extends $c61afbb8e2f8b25e$export$9d3f3bc8b6d48950 {
    constructor(operationKind, errorDetail){
        super();
        this.operationKind = operationKind;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationKindError';
        this.message = `Invalid operation kind "${operationKind}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description General error that indicates something is no longer supported and/or deprecated
 */ class $c61afbb8e2f8b25e$export$11034991807c583d extends $c61afbb8e2f8b25e$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'DeprecationError';
    }
}
/**
 *  @category Error
 *  @description General error that indicates an action is prohibited or not allowed
 */ class $c61afbb8e2f8b25e$export$4041d915d9096adf extends $c61afbb8e2f8b25e$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ProhibitedActionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure in grabbing the public key
 */ class $c61afbb8e2f8b25e$export$183b043cd3c947f9 extends $c61afbb8e2f8b25e$export$e5619b407b1c8b0a {
    constructor(pkh, cause){
        super();
        this.pkh = pkh;
        this.cause = cause;
        this.name = 'PublicKeyNotFoundError';
        this.message = `Public key not found of this address "${pkh}" in either wallet or contract API.`;
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $6cc77aa71b64d012$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
/**
 *  @category Error
 *  @description Error that indicates a general failure in making the HTTP request
 */ class $6cc77aa71b64d012$export$358d9e688c05bde3 extends (0, $c61afbb8e2f8b25e$export$bae979e68e4dc802) {
    constructor(method, url, cause){
        super();
        this.method = method;
        this.url = url;
        this.cause = cause;
        this.name = 'HttpRequestFailed';
        this.message = `${method} ${url} ${String(cause)}`;
    }
}
/**
 *  @category Error
 *  @description Error thrown when the endpoint returns an HTTP error to the client
 */ class $6cc77aa71b64d012$export$d2f2761cbe9cebf2 extends (0, $c61afbb8e2f8b25e$export$bae979e68e4dc802) {
    constructor(message, status, statusText, body, url){
        super();
        this.message = message;
        this.status = status;
        this.statusText = statusText;
        this.body = body;
        this.url = url;
        this.name = 'HttpResponseError';
    }
}
/**
 *  @category Error
 *  @description Error
 */ class $6cc77aa71b64d012$export$faa3cc8a16ea23df extends (0, $c61afbb8e2f8b25e$export$bae979e68e4dc802) {
    constructor(timeout, url){
        super();
        this.timeout = timeout;
        this.url = url;
        this.name = 'HttpTimeoutError';
        this.message = `HTTP request timeout of ${timeout}ms exceeded`;
    }
}
/**
 * Hypertext Transfer Protocol (HTTP) response status codes.
 * @see {@link https://en.wikipedia.org/wiki/List_of_HTTP_status_codes}
 */ var $6cc77aa71b64d012$export$bc3aa03eb4b395cf;
(function(STATUS_CODE) {
    /**
     * The server has received the request headers and the client should proceed to send the request body
     * (in the case of a request for which a body needs to be sent; for example, a POST request).
     * Sending a large request body to a server after a request has been rejected for inappropriate headers would be inefficient.
     * To have a server check the request's headers, a client must send Expect: 100-continue as a header in its initial request
     * and receive a 100 Continue status code in response before sending the body. The response 417 Expectation Failed indicates the request should not be continued.
     */ STATUS_CODE[STATUS_CODE["CONTINUE"] = 100] = "CONTINUE";
    /**
     * The requester has asked the server to switch protocols and the server has agreed to do so.
     */ STATUS_CODE[STATUS_CODE["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    /**
     * A WebDAV request may contain many sub-requests involving file operations, requiring a long time to complete the request.
     * This code indicates that the server has received and is processing the request, but no response is available yet.
     * This prevents the client from timing out and assuming the request was lost.
     */ STATUS_CODE[STATUS_CODE["PROCESSING"] = 102] = "PROCESSING";
    /**
     * Standard response for successful HTTP requests.
     * The actual response will depend on the request method used.
     * In a GET request, the response will contain an entity corresponding to the requested resource.
     * In a POST request, the response will contain an entity describing or containing the result of the action.
     */ STATUS_CODE[STATUS_CODE["OK"] = 200] = "OK";
    /**
     * The request has been fulfilled, resulting in the creation of a new resource.
     */ STATUS_CODE[STATUS_CODE["CREATED"] = 201] = "CREATED";
    /**
     * The request has been accepted for processing, but the processing has not been completed.
     * The request might or might not be eventually acted upon, and may be disallowed when processing occurs.
     */ STATUS_CODE[STATUS_CODE["ACCEPTED"] = 202] = "ACCEPTED";
    /**
     * SINCE HTTP/1.1
     * The server is a transforming proxy that received a 200 OK from its origin,
     * but is returning a modified version of the origin's response.
     */ STATUS_CODE[STATUS_CODE["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    /**
     * The server successfully processed the request and is not returning any content.
     */ STATUS_CODE[STATUS_CODE["NO_CONTENT"] = 204] = "NO_CONTENT";
    /**
     * The server successfully processed the request, but is not returning any content.
     * Unlike a 204 response, this response requires that the requester reset the document view.
     */ STATUS_CODE[STATUS_CODE["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    /**
     * The server is delivering only part of the resource (byte serving) due to a range header sent by the client.
     * The range header is used by HTTP clients to enable resuming of interrupted downloads,
     * or split a download into multiple simultaneous streams.
     */ STATUS_CODE[STATUS_CODE["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    /**
     * The message body that follows is an XML message and can contain a number of separate response codes,
     * depending on how many sub-requests were made.
     */ STATUS_CODE[STATUS_CODE["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    /**
     * The members of a DAV binding have already been enumerated in a preceding part of the (multistatus) response,
     * and are not being included again.
     */ STATUS_CODE[STATUS_CODE["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
    /**
     * The server has fulfilled a request for the resource,
     * and the response is a representation of the result of one or more instance-manipulations applied to the current instance.
     */ STATUS_CODE[STATUS_CODE["IM_USED"] = 226] = "IM_USED";
    /**
     * Indicates multiple options for the resource from which the client may choose (via agent-driven content negotiation).
     * For example, this code could be used to present multiple video format options,
     * to list files with different filename extensions, or to suggest word-sense disambiguation.
     */ STATUS_CODE[STATUS_CODE["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    /**
     * This and all future requests should be directed to the given URI.
     */ STATUS_CODE[STATUS_CODE["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    /**
     * This is an example of industry practice contradicting the standard.
     * The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect
     * (the original describing phrase was "Moved Temporarily"), but popular browsers implemented 302
     * with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307
     * to distinguish between the two behaviours. However, some Web applications and frameworks
     * use the 302 status code as if it were the 303.
     */ STATUS_CODE[STATUS_CODE["FOUND"] = 302] = "FOUND";
    /**
     * SINCE HTTP/1.1
     * The response to the request can be found under another URI using a GET method.
     * When received in response to a POST (or PUT/DELETE), the client should presume that
     * the server has received the data and should issue a redirect with a separate GET message.
     */ STATUS_CODE[STATUS_CODE["SEE_OTHER"] = 303] = "SEE_OTHER";
    /**
     * Indicates that the resource has not been modified since the version specified by the request headers If-Modified-Since or If-None-Match.
     * In such case, there is no need to retransmit the resource since the client still has a previously-downloaded copy.
     */ STATUS_CODE[STATUS_CODE["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    /**
     * SINCE HTTP/1.1
     * The requested resource is available only through a proxy, the address for which is provided in the response.
     * Many HTTP clients (such as Mozilla and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.
     */ STATUS_CODE[STATUS_CODE["USE_PROXY"] = 305] = "USE_PROXY";
    /**
     * No longer used. Originally meant "Subsequent requests should use the specified proxy."
     */ STATUS_CODE[STATUS_CODE["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
    /**
     * SINCE HTTP/1.1
     * In this case, the request should be repeated with another URI; however, future requests should still use the original URI.
     * In contrast to how 302 was historically implemented, the request method is not allowed to be changed when reissuing the original request.
     * For example, a POST request should be repeated using another POST request.
     */ STATUS_CODE[STATUS_CODE["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    /**
     * The request and all future requests should be repeated using another URI.
     * 307 and 308 parallel the behaviors of 302 and 301, but do not allow the HTTP method to change.
     * So, for example, submitting a form to a permanently redirected resource may continue smoothly.
     */ STATUS_CODE[STATUS_CODE["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    /**
     * The server cannot or will not process the request due to an apparent client error
     * (e.g., malformed request syntax, too large size, invalid request message framing, or deceptive request routing).
     */ STATUS_CODE[STATUS_CODE["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    /**
     * Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet
     * been provided. The response must include a WWW-Authenticate header field containing a challenge applicable to the
     * requested resource. See Basic access authentication and Digest access authentication. 401 semantically means
     * "unauthenticated",i.e. the user does not have the necessary credentials.
     */ STATUS_CODE[STATUS_CODE["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    /**
     * Reserved for future use. The original intention was that this code might be used as part of some form of digital
     * cash or micro payment scheme, but that has not happened, and this code is not usually used.
     * Google Developers API uses this status if a particular developer has exceeded the daily limit on requests.
     */ STATUS_CODE[STATUS_CODE["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    /**
     * The request was valid, but the server is refusing action.
     * The user might not have the necessary permissions for a resource.
     */ STATUS_CODE[STATUS_CODE["FORBIDDEN"] = 403] = "FORBIDDEN";
    /**
     * The requested resource could not be found but may be available in the future.
     * Subsequent requests by the client are permissible.
     */ STATUS_CODE[STATUS_CODE["NOT_FOUND"] = 404] = "NOT_FOUND";
    /**
     * A request method is not supported for the requested resource;
     * for example, a GET request on a form that requires data to be presented via POST, or a PUT request on a read-only resource.
     */ STATUS_CODE[STATUS_CODE["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    /**
     * The requested resource is capable of generating only content not acceptable according to the Accept headers sent in the request.
     */ STATUS_CODE[STATUS_CODE["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    /**
     * The client must first authenticate itself with the proxy.
     */ STATUS_CODE[STATUS_CODE["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    /**
     * The server timed out waiting for the request.
     * According to HTTP specifications:
     * "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
     */ STATUS_CODE[STATUS_CODE["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    /**
     * Indicates that the request could not be processed because of conflict in the request,
     * such as an edit conflict between multiple simultaneous updates.
     */ STATUS_CODE[STATUS_CODE["CONFLICT"] = 409] = "CONFLICT";
    /**
     * Indicates that the resource requested is no longer available and will not be available again.
     * This should be used when a resource has been intentionally removed and the resource should be purged.
     * Upon receiving a 410 status code, the client should not request the resource in the future.
     * Clients such as search engines should remove the resource from their indices.
     * Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
     */ STATUS_CODE[STATUS_CODE["GONE"] = 410] = "GONE";
    /**
     * The request did not specify the length of its content, which is required by the requested resource.
     */ STATUS_CODE[STATUS_CODE["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    /**
     * The server does not meet one of the preconditions that the requester put on the request.
     */ STATUS_CODE[STATUS_CODE["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    /**
     * The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".
     */ STATUS_CODE[STATUS_CODE["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    /**
     * The URI provided was too long for the server to process. Often the result of too much data being encoded as a query-string of a GET request,
     * in which case it should be converted to a POST request.
     * Called "Request-URI Too Long" previously.
     */ STATUS_CODE[STATUS_CODE["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
    /**
     * The request entity has a media type which the server or resource does not support.
     * For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
     */ STATUS_CODE[STATUS_CODE["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    /**
     * The client has asked for a portion of the file (byte serving), but the server cannot supply that portion.
     * For example, if the client asked for a part of the file that lies beyond the end of the file.
     * Called "Requested Range Not Satisfiable" previously.
     */ STATUS_CODE[STATUS_CODE["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
    /**
     * The server cannot meet the requirements of the Expect request-header field.
     */ STATUS_CODE[STATUS_CODE["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    /**
     * This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol,
     * and is not expected to be implemented by actual HTTP servers. The RFC specifies this code should be returned by
     * teapots requested to brew coffee. This HTTP status is used as an Easter egg in some websites, including Google.com.
     */ STATUS_CODE[STATUS_CODE["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
    /**
     * The request was directed at a server that is not able to produce a response (for example because a connection reuse).
     */ STATUS_CODE[STATUS_CODE["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    /**
     * The request was well-formed but was unable to be followed due to semantic errors.
     */ STATUS_CODE[STATUS_CODE["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    /**
     * The resource that is being accessed is locked.
     */ STATUS_CODE[STATUS_CODE["LOCKED"] = 423] = "LOCKED";
    /**
     * The request failed due to failure of a previous request (e.g., a PROPPATCH).
     */ STATUS_CODE[STATUS_CODE["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    /**
     * The client should switch to a different protocol such as TLS/1.0, given in the Upgrade header field.
     */ STATUS_CODE[STATUS_CODE["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    /**
     * The origin server requires the request to be conditional.
     * Intended to prevent "the 'lost update' problem, where a client
     * GETs a resource's state, modifies it, and PUTs it back to the server,
     * when meanwhile a third party has modified the state on the server, leading to a conflict."
     */ STATUS_CODE[STATUS_CODE["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    /**
     * The user has sent too many requests in a given amount of time. Intended for use with rate-limiting schemes.
     */ STATUS_CODE[STATUS_CODE["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    /**
     * The server is unwilling to process the request because either an individual header field,
     * or all the header fields collectively, are too large.
     */ STATUS_CODE[STATUS_CODE["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    /**
     * A server operator has received a legal demand to deny access to a resource or to a set of resources
     * that includes the requested resource. The code 451 was chosen as a reference to the novel Fahrenheit 451.
     */ STATUS_CODE[STATUS_CODE["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    /**
     * A generic error message, given when an unexpected condition was encountered and no more specific message is suitable.
     */ STATUS_CODE[STATUS_CODE["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    /**
     * The server either does not recognize the request method, or it lacks the ability to fulfill the request.
     * Usually this implies future availability (e.g., a new feature of a web-service API).
     */ STATUS_CODE[STATUS_CODE["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    /**
     * The server was acting as a gateway or proxy and received an invalid response from the upstream server.
     */ STATUS_CODE[STATUS_CODE["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    /**
     * The server is currently unavailable (because it is overloaded or down for maintenance).
     * Generally, this is a temporary state.
     */ STATUS_CODE[STATUS_CODE["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    /**
     * The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.
     */ STATUS_CODE[STATUS_CODE["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    /**
     * The server does not support the HTTP protocol version used in the request
     */ STATUS_CODE[STATUS_CODE["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    /**
     * Transparent content negotiation for the request results in a circular reference.
     */ STATUS_CODE[STATUS_CODE["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
    /**
     * The server is unable to store the representation needed to complete the request.
     */ STATUS_CODE[STATUS_CODE["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    /**
     * The server detected an infinite loop while processing the request.
     */ STATUS_CODE[STATUS_CODE["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
    /**
     * Further extensions to the request are required for the server to fulfill it.
     */ STATUS_CODE[STATUS_CODE["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
    /**
     * The client needs to authenticate to gain network access.
     * Intended for use by intercepting proxies used to control access to the network (e.g., "captive portals" used
     * to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).
     */ STATUS_CODE[STATUS_CODE["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})($6cc77aa71b64d012$export$bc3aa03eb4b395cf || ($6cc77aa71b64d012$export$bc3aa03eb4b395cf = {}));
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $6cc77aa71b64d012$export$a4ad2735b021c132 = {
    "commitHash": "6a2c52b9e48b299dfc856149c1fa3388e77180ad",
    "version": "22.0.0"
};
/**
 * @packageDocumentation
 * @module @taquito/http-utils
 */ var $6cc77aa71b64d012$var$_a;
let $6cc77aa71b64d012$var$fetch = globalThis === null || globalThis === void 0 ? void 0 : globalThis.fetch;
// Will only use browser fetch if we are in a browser environment,
// default to the more stable node-fetch otherwise
const $6cc77aa71b64d012$var$isNode = false;

if ($6cc77aa71b64d012$var$isNode) $6cc77aa71b64d012$var$fetch = (parcelRequire("fLVpN"));
class $6cc77aa71b64d012$export$aac4ca225fe02187 {
    constructor(timeout = 30000){
        this.timeout = timeout;
    }
    serialize(obj) {
        if (!obj) return '';
        const str = [];
        for(const p in obj)// eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(p) && typeof obj[p] !== 'undefined') {
            const prop = typeof obj[p].toJSON === 'function' ? obj[p].toJSON() : obj[p];
            // query arguments can have no value so we need some way of handling that
            // example https://domain.com/query?all
            if (prop === null) {
                str.push(encodeURIComponent(p));
                continue;
            }
            // another use case is multiple arguments with the same name
            // they are passed as array
            if (Array.isArray(prop)) {
                prop.forEach((item)=>{
                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(item));
                });
                continue;
            }
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(prop));
        }
        const serialized = str.join('&');
        if (serialized) return `?${serialized}`;
        else return '';
    }
    /**
     *
     * @param options contains options to be passed for the HTTP request (url, method and timeout)
     * @throws {@link HttpRequestFailed} | {@link HttpResponseError} | {@link HttpTimeoutError}
     */ createRequest(_a, data_1) {
        return $6cc77aa71b64d012$var$__awaiter(this, arguments, void 0, function*({ url: url, method: method, timeout: timeout = this.timeout, query: query, headers: headers = {}, json: json = true }, data) {
            // Serializes query params
            const urlWithQuery = url + this.serialize(query);
            // Adds default header entry if there aren't any Content-Type header
            if (!headers['Content-Type']) headers['Content-Type'] = 'application/json';
            // Creates a new AbortController instance to handle timeouts
            const controller = new AbortController();
            const t = setTimeout(()=>controller.abort(), timeout);
            try {
                const response = yield $6cc77aa71b64d012$var$fetch(urlWithQuery, {
                    keepalive: false,
                    method: method,
                    headers: headers,
                    body: JSON.stringify(data),
                    signal: controller.signal
                });
                if (typeof response === 'undefined') throw new Error('Response is undefined');
                // Handle responses with status code >= 400
                if (response.status >= 400) {
                    const errorData = yield response.text();
                    throw new $6cc77aa71b64d012$export$d2f2761cbe9cebf2(`Http error response: (${response.status}) ${errorData}`, response.status, response.statusText, errorData, urlWithQuery);
                }
                if (json) return response.json();
                else return response.text();
            } catch (e) {
                if (e instanceof Error && e.name === 'AbortError') throw new $6cc77aa71b64d012$export$faa3cc8a16ea23df(timeout, urlWithQuery);
                else if (e instanceof $6cc77aa71b64d012$export$d2f2761cbe9cebf2) throw e;
                else throw new $6cc77aa71b64d012$export$358d9e688c05bde3(String(method), urlWithQuery, e);
            } finally{
                clearTimeout(t);
            }
        });
    }
}




var $6ZWSX = parcelRequire("6ZWSX");
var $8a7cb90d2411b4d4$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($8a7cb90d2411b4d4$exports, "__esModule", {
    value: true
});
$8a7cb90d2411b4d4$exports.convertSecretKeyToX25519 = $8a7cb90d2411b4d4$exports.convertPublicKeyToX25519 = $8a7cb90d2411b4d4$exports.verify = $8a7cb90d2411b4d4$exports.sign = $8a7cb90d2411b4d4$exports.extractPublicKeyFromSecretKey = $8a7cb90d2411b4d4$exports.generateKeyPair = $8a7cb90d2411b4d4$exports.generateKeyPairFromSeed = $8a7cb90d2411b4d4$exports.SEED_LENGTH = $8a7cb90d2411b4d4$exports.SECRET_KEY_LENGTH = $8a7cb90d2411b4d4$exports.PUBLIC_KEY_LENGTH = $8a7cb90d2411b4d4$exports.SIGNATURE_LENGTH = void 0;
var $0a4a8bd4d32ff4d2$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($0a4a8bd4d32ff4d2$exports, "__esModule", {
    value: true
});
$0a4a8bd4d32ff4d2$exports.randomStringForEntropy = $0a4a8bd4d32ff4d2$exports.randomString = $0a4a8bd4d32ff4d2$exports.randomUint32 = $0a4a8bd4d32ff4d2$exports.randomBytes = $0a4a8bd4d32ff4d2$exports.defaultRandomSource = void 0;
var $87c068c76b318af4$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($87c068c76b318af4$exports, "__esModule", {
    value: true
});
$87c068c76b318af4$exports.SystemRandomSource = void 0;
var $c0757b7f896cfcb1$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($c0757b7f896cfcb1$exports, "__esModule", {
    value: true
});
$c0757b7f896cfcb1$exports.BrowserRandomSource = void 0;
const $c0757b7f896cfcb1$var$QUOTA = 65536;
class $c0757b7f896cfcb1$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== 'undefined' ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $c0757b7f896cfcb1$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $c0757b7f896cfcb1$var$QUOTA)));
        return out;
    }
}
$c0757b7f896cfcb1$exports.BrowserRandomSource = $c0757b7f896cfcb1$var$BrowserRandomSource;


var $23d8b187930cb74c$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($23d8b187930cb74c$exports, "__esModule", {
    value: true
});
$23d8b187930cb74c$exports.NodeRandomSource = void 0;
var $10d15b8f838059d8$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($10d15b8f838059d8$exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $10d15b8f838059d8$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
$10d15b8f838059d8$exports.wipe = $10d15b8f838059d8$var$wipe;



class $23d8b187930cb74c$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("kjyEk"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $10d15b8f838059d8$exports.wipe)(buffer);
        return out;
    }
}
$23d8b187930cb74c$exports.NodeRandomSource = $23d8b187930cb74c$var$NodeRandomSource;


class $87c068c76b318af4$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $c0757b7f896cfcb1$exports.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $23d8b187930cb74c$exports.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
$87c068c76b318af4$exports.SystemRandomSource = $87c068c76b318af4$var$SystemRandomSource;


var $d1d6bce100502330$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($d1d6bce100502330$exports, "__esModule", {
    value: true
});
var $fef570d1d00b1d06$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($fef570d1d00b1d06$exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $fef570d1d00b1d06$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
$fef570d1d00b1d06$exports.mul = Math.imul || $fef570d1d00b1d06$var$imulShim;
/** 32-bit integer addition.  */ function $fef570d1d00b1d06$var$add(a, b) {
    return a + b | 0;
}
$fef570d1d00b1d06$exports.add = $fef570d1d00b1d06$var$add;
/**  32-bit integer subtraction.  */ function $fef570d1d00b1d06$var$sub(a, b) {
    return a - b | 0;
}
$fef570d1d00b1d06$exports.sub = $fef570d1d00b1d06$var$sub;
/** 32-bit integer left rotation */ function $fef570d1d00b1d06$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
$fef570d1d00b1d06$exports.rotl = $fef570d1d00b1d06$var$rotl;
/** 32-bit integer left rotation */ function $fef570d1d00b1d06$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
$fef570d1d00b1d06$exports.rotr = $fef570d1d00b1d06$var$rotr;
function $fef570d1d00b1d06$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ $fef570d1d00b1d06$exports.isInteger = Number.isInteger || $fef570d1d00b1d06$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ $fef570d1d00b1d06$exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ $fef570d1d00b1d06$exports.isSafeInteger = function(n) {
    return $fef570d1d00b1d06$exports.isInteger(n) && n >= -$fef570d1d00b1d06$exports.MAX_SAFE_INTEGER && n <= $fef570d1d00b1d06$exports.MAX_SAFE_INTEGER;
};


// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $d1d6bce100502330$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
$d1d6bce100502330$exports.readInt16BE = $d1d6bce100502330$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $d1d6bce100502330$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
$d1d6bce100502330$exports.readUint16BE = $d1d6bce100502330$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $d1d6bce100502330$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
$d1d6bce100502330$exports.readInt16LE = $d1d6bce100502330$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $d1d6bce100502330$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
$d1d6bce100502330$exports.readUint16LE = $d1d6bce100502330$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
$d1d6bce100502330$exports.writeUint16BE = $d1d6bce100502330$var$writeUint16BE;
$d1d6bce100502330$exports.writeInt16BE = $d1d6bce100502330$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
$d1d6bce100502330$exports.writeUint16LE = $d1d6bce100502330$var$writeUint16LE;
$d1d6bce100502330$exports.writeInt16LE = $d1d6bce100502330$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $d1d6bce100502330$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
$d1d6bce100502330$exports.readInt32BE = $d1d6bce100502330$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $d1d6bce100502330$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
$d1d6bce100502330$exports.readUint32BE = $d1d6bce100502330$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $d1d6bce100502330$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
$d1d6bce100502330$exports.readInt32LE = $d1d6bce100502330$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $d1d6bce100502330$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
$d1d6bce100502330$exports.readUint32LE = $d1d6bce100502330$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
$d1d6bce100502330$exports.writeUint32BE = $d1d6bce100502330$var$writeUint32BE;
$d1d6bce100502330$exports.writeInt32BE = $d1d6bce100502330$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
$d1d6bce100502330$exports.writeUint32LE = $d1d6bce100502330$var$writeUint32LE;
$d1d6bce100502330$exports.writeInt32LE = $d1d6bce100502330$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $d1d6bce100502330$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $d1d6bce100502330$var$readInt32BE(array, offset);
    var lo = $d1d6bce100502330$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$d1d6bce100502330$exports.readInt64BE = $d1d6bce100502330$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $d1d6bce100502330$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $d1d6bce100502330$var$readUint32BE(array, offset);
    var lo = $d1d6bce100502330$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$d1d6bce100502330$exports.readUint64BE = $d1d6bce100502330$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $d1d6bce100502330$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $d1d6bce100502330$var$readInt32LE(array, offset);
    var hi = $d1d6bce100502330$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$d1d6bce100502330$exports.readInt64LE = $d1d6bce100502330$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $d1d6bce100502330$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $d1d6bce100502330$var$readUint32LE(array, offset);
    var hi = $d1d6bce100502330$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$d1d6bce100502330$exports.readUint64LE = $d1d6bce100502330$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $d1d6bce100502330$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $d1d6bce100502330$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
$d1d6bce100502330$exports.writeUint64BE = $d1d6bce100502330$var$writeUint64BE;
$d1d6bce100502330$exports.writeInt64BE = $d1d6bce100502330$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $d1d6bce100502330$var$writeUint32LE(value >>> 0, out, offset);
    $d1d6bce100502330$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
$d1d6bce100502330$exports.writeUint64LE = $d1d6bce100502330$var$writeUint64LE;
$d1d6bce100502330$exports.writeInt64LE = $d1d6bce100502330$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $d1d6bce100502330$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$d1d6bce100502330$exports.readUintBE = $d1d6bce100502330$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $d1d6bce100502330$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$d1d6bce100502330$exports.readUintLE = $d1d6bce100502330$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$fef570d1d00b1d06$exports.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$d1d6bce100502330$exports.writeUintBE = $d1d6bce100502330$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$fef570d1d00b1d06$exports.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$d1d6bce100502330$exports.writeUintLE = $d1d6bce100502330$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $d1d6bce100502330$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
$d1d6bce100502330$exports.readFloat32BE = $d1d6bce100502330$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $d1d6bce100502330$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
$d1d6bce100502330$exports.readFloat32LE = $d1d6bce100502330$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $d1d6bce100502330$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
$d1d6bce100502330$exports.readFloat64BE = $d1d6bce100502330$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $d1d6bce100502330$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
$d1d6bce100502330$exports.readFloat64LE = $d1d6bce100502330$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
$d1d6bce100502330$exports.writeFloat32BE = $d1d6bce100502330$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
$d1d6bce100502330$exports.writeFloat32LE = $d1d6bce100502330$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
$d1d6bce100502330$exports.writeFloat64BE = $d1d6bce100502330$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $d1d6bce100502330$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
$d1d6bce100502330$exports.writeFloat64LE = $d1d6bce100502330$var$writeFloat64LE;



$0a4a8bd4d32ff4d2$exports.defaultRandomSource = new $87c068c76b318af4$exports.SystemRandomSource();
function $0a4a8bd4d32ff4d2$var$randomBytes(length, prng = $0a4a8bd4d32ff4d2$exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
$0a4a8bd4d32ff4d2$exports.randomBytes = $0a4a8bd4d32ff4d2$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $0a4a8bd4d32ff4d2$var$randomUint32(prng = $0a4a8bd4d32ff4d2$exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $0a4a8bd4d32ff4d2$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $d1d6bce100502330$exports.readUint32LE)(buf);
    // Clean the buffer.
    (0, $10d15b8f838059d8$exports.wipe)(buf);
    return result;
}
$0a4a8bd4d32ff4d2$exports.randomUint32 = $0a4a8bd4d32ff4d2$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $0a4a8bd4d32ff4d2$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $0a4a8bd4d32ff4d2$var$randomString(length, charset = $0a4a8bd4d32ff4d2$var$ALPHANUMERIC, prng = $0a4a8bd4d32ff4d2$exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = '';
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $0a4a8bd4d32ff4d2$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $10d15b8f838059d8$exports.wipe)(buf);
    }
    return out;
}
$0a4a8bd4d32ff4d2$exports.randomString = $0a4a8bd4d32ff4d2$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $0a4a8bd4d32ff4d2$var$randomStringForEntropy(bits, charset = $0a4a8bd4d32ff4d2$var$ALPHANUMERIC, prng = $0a4a8bd4d32ff4d2$exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $0a4a8bd4d32ff4d2$var$randomString(length, charset, prng);
}
$0a4a8bd4d32ff4d2$exports.randomStringForEntropy = $0a4a8bd4d32ff4d2$var$randomStringForEntropy;


var $ec99c2ae07f44038$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($ec99c2ae07f44038$exports, "__esModule", {
    value: true
});


$ec99c2ae07f44038$exports.DIGEST_LENGTH = 64;
$ec99c2ae07f44038$exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $ec99c2ae07f44038$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = $ec99c2ae07f44038$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $ec99c2ae07f44038$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $10d15b8f838059d8$exports.wipe(this._buffer);
        $10d15b8f838059d8$exports.wipe(this._tempHi);
        $10d15b8f838059d8$exports.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < $ec99c2ae07f44038$exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $ec99c2ae07f44038$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $ec99c2ae07f44038$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $d1d6bce100502330$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $d1d6bce100502330$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $ec99c2ae07f44038$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $d1d6bce100502330$exports.writeUint32BE(this._stateHi[i], out, i * 8);
            $d1d6bce100502330$exports.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $10d15b8f838059d8$exports.wipe(savedState.stateHi);
        $10d15b8f838059d8$exports.wipe(savedState.stateLo);
        if (savedState.buffer) $10d15b8f838059d8$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
$ec99c2ae07f44038$exports.SHA512 = $ec99c2ae07f44038$var$SHA512;
// Constants
var $ec99c2ae07f44038$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $ec99c2ae07f44038$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $d1d6bce100502330$exports.readUint32BE(m, j);
            wl[i] = $d1d6bce100502330$exports.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $ec99c2ae07f44038$var$K[i * 2];
            l = $ec99c2ae07f44038$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $ec99c2ae07f44038$var$hash(data) {
    var h = new $ec99c2ae07f44038$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$ec99c2ae07f44038$exports.hash = $ec99c2ae07f44038$var$hash;



$8a7cb90d2411b4d4$exports.SIGNATURE_LENGTH = 64;
$8a7cb90d2411b4d4$exports.PUBLIC_KEY_LENGTH = 32;
$8a7cb90d2411b4d4$exports.SECRET_KEY_LENGTH = 64;
$8a7cb90d2411b4d4$exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $8a7cb90d2411b4d4$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $8a7cb90d2411b4d4$var$_9 = new Uint8Array(32);
$8a7cb90d2411b4d4$var$_9[0] = 9;
const $8a7cb90d2411b4d4$var$gf0 = $8a7cb90d2411b4d4$var$gf();
const $8a7cb90d2411b4d4$var$gf1 = $8a7cb90d2411b4d4$var$gf([
    1
]);
const $8a7cb90d2411b4d4$var$D = $8a7cb90d2411b4d4$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $8a7cb90d2411b4d4$var$D2 = $8a7cb90d2411b4d4$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $8a7cb90d2411b4d4$var$X = $8a7cb90d2411b4d4$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $8a7cb90d2411b4d4$var$Y = $8a7cb90d2411b4d4$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $8a7cb90d2411b4d4$var$I = $8a7cb90d2411b4d4$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $8a7cb90d2411b4d4$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $8a7cb90d2411b4d4$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $8a7cb90d2411b4d4$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $8a7cb90d2411b4d4$var$pack25519(o, n) {
    const m = $8a7cb90d2411b4d4$var$gf();
    const t = $8a7cb90d2411b4d4$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $8a7cb90d2411b4d4$var$car25519(t);
    $8a7cb90d2411b4d4$var$car25519(t);
    $8a7cb90d2411b4d4$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $8a7cb90d2411b4d4$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $8a7cb90d2411b4d4$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $8a7cb90d2411b4d4$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $8a7cb90d2411b4d4$var$pack25519(c, a);
    $8a7cb90d2411b4d4$var$pack25519(d, b);
    return $8a7cb90d2411b4d4$var$verify32(c, d);
}
function $8a7cb90d2411b4d4$var$par25519(a) {
    const d = new Uint8Array(32);
    $8a7cb90d2411b4d4$var$pack25519(d, a);
    return d[0] & 1;
}
function $8a7cb90d2411b4d4$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $8a7cb90d2411b4d4$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $8a7cb90d2411b4d4$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $8a7cb90d2411b4d4$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $8a7cb90d2411b4d4$var$square(o, a) {
    $8a7cb90d2411b4d4$var$mul(o, a, a);
}
function $8a7cb90d2411b4d4$var$inv25519(o, i) {
    const c = $8a7cb90d2411b4d4$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $8a7cb90d2411b4d4$var$square(c, c);
        if (a !== 2 && a !== 4) $8a7cb90d2411b4d4$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $8a7cb90d2411b4d4$var$pow2523(o, i) {
    const c = $8a7cb90d2411b4d4$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $8a7cb90d2411b4d4$var$square(c, c);
        if (a !== 1) $8a7cb90d2411b4d4$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $8a7cb90d2411b4d4$var$edadd(p, q) {
    const a = $8a7cb90d2411b4d4$var$gf(), b = $8a7cb90d2411b4d4$var$gf(), c = $8a7cb90d2411b4d4$var$gf(), d = $8a7cb90d2411b4d4$var$gf(), e = $8a7cb90d2411b4d4$var$gf(), f = $8a7cb90d2411b4d4$var$gf(), g = $8a7cb90d2411b4d4$var$gf(), h = $8a7cb90d2411b4d4$var$gf(), t = $8a7cb90d2411b4d4$var$gf();
    $8a7cb90d2411b4d4$var$sub(a, p[1], p[0]);
    $8a7cb90d2411b4d4$var$sub(t, q[1], q[0]);
    $8a7cb90d2411b4d4$var$mul(a, a, t);
    $8a7cb90d2411b4d4$var$add(b, p[0], p[1]);
    $8a7cb90d2411b4d4$var$add(t, q[0], q[1]);
    $8a7cb90d2411b4d4$var$mul(b, b, t);
    $8a7cb90d2411b4d4$var$mul(c, p[3], q[3]);
    $8a7cb90d2411b4d4$var$mul(c, c, $8a7cb90d2411b4d4$var$D2);
    $8a7cb90d2411b4d4$var$mul(d, p[2], q[2]);
    $8a7cb90d2411b4d4$var$add(d, d, d);
    $8a7cb90d2411b4d4$var$sub(e, b, a);
    $8a7cb90d2411b4d4$var$sub(f, d, c);
    $8a7cb90d2411b4d4$var$add(g, d, c);
    $8a7cb90d2411b4d4$var$add(h, b, a);
    $8a7cb90d2411b4d4$var$mul(p[0], e, f);
    $8a7cb90d2411b4d4$var$mul(p[1], h, g);
    $8a7cb90d2411b4d4$var$mul(p[2], g, f);
    $8a7cb90d2411b4d4$var$mul(p[3], e, h);
}
function $8a7cb90d2411b4d4$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$8a7cb90d2411b4d4$var$sel25519(p[i], q[i], b);
}
function $8a7cb90d2411b4d4$var$pack(r, p) {
    const tx = $8a7cb90d2411b4d4$var$gf(), ty = $8a7cb90d2411b4d4$var$gf(), zi = $8a7cb90d2411b4d4$var$gf();
    $8a7cb90d2411b4d4$var$inv25519(zi, p[2]);
    $8a7cb90d2411b4d4$var$mul(tx, p[0], zi);
    $8a7cb90d2411b4d4$var$mul(ty, p[1], zi);
    $8a7cb90d2411b4d4$var$pack25519(r, ty);
    r[31] ^= $8a7cb90d2411b4d4$var$par25519(tx) << 7;
}
function $8a7cb90d2411b4d4$var$scalarmult(p, q, s) {
    $8a7cb90d2411b4d4$var$set25519(p[0], $8a7cb90d2411b4d4$var$gf0);
    $8a7cb90d2411b4d4$var$set25519(p[1], $8a7cb90d2411b4d4$var$gf1);
    $8a7cb90d2411b4d4$var$set25519(p[2], $8a7cb90d2411b4d4$var$gf1);
    $8a7cb90d2411b4d4$var$set25519(p[3], $8a7cb90d2411b4d4$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $8a7cb90d2411b4d4$var$cswap(p, q, b);
        $8a7cb90d2411b4d4$var$edadd(q, p);
        $8a7cb90d2411b4d4$var$edadd(p, p);
        $8a7cb90d2411b4d4$var$cswap(p, q, b);
    }
}
function $8a7cb90d2411b4d4$var$scalarbase(p, s) {
    const q = [
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf()
    ];
    $8a7cb90d2411b4d4$var$set25519(q[0], $8a7cb90d2411b4d4$var$X);
    $8a7cb90d2411b4d4$var$set25519(q[1], $8a7cb90d2411b4d4$var$Y);
    $8a7cb90d2411b4d4$var$set25519(q[2], $8a7cb90d2411b4d4$var$gf1);
    $8a7cb90d2411b4d4$var$mul(q[3], $8a7cb90d2411b4d4$var$X, $8a7cb90d2411b4d4$var$Y);
    $8a7cb90d2411b4d4$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $8a7cb90d2411b4d4$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $8a7cb90d2411b4d4$exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${$8a7cb90d2411b4d4$exports.SEED_LENGTH} bytes`);
    const d = (0, $ec99c2ae07f44038$exports.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf()
    ];
    $8a7cb90d2411b4d4$var$scalarbase(p, d);
    $8a7cb90d2411b4d4$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$8a7cb90d2411b4d4$exports.generateKeyPairFromSeed = $8a7cb90d2411b4d4$var$generateKeyPairFromSeed;
function $8a7cb90d2411b4d4$var$generateKeyPair(prng) {
    const seed = (0, $0a4a8bd4d32ff4d2$exports.randomBytes)(32, prng);
    const result = $8a7cb90d2411b4d4$var$generateKeyPairFromSeed(seed);
    (0, $10d15b8f838059d8$exports.wipe)(seed);
    return result;
}
$8a7cb90d2411b4d4$exports.generateKeyPair = $8a7cb90d2411b4d4$var$generateKeyPair;
function $8a7cb90d2411b4d4$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== $8a7cb90d2411b4d4$exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${$8a7cb90d2411b4d4$exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
$8a7cb90d2411b4d4$exports.extractPublicKeyFromSecretKey = $8a7cb90d2411b4d4$var$extractPublicKeyFromSecretKey;
const $8a7cb90d2411b4d4$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $8a7cb90d2411b4d4$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $8a7cb90d2411b4d4$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $8a7cb90d2411b4d4$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $8a7cb90d2411b4d4$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $8a7cb90d2411b4d4$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $8a7cb90d2411b4d4$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $8a7cb90d2411b4d4$var$sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf()
    ];
    const d = (0, $ec99c2ae07f44038$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new $ec99c2ae07f44038$exports.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $8a7cb90d2411b4d4$var$reduce(r);
    $8a7cb90d2411b4d4$var$scalarbase(p, r);
    $8a7cb90d2411b4d4$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $8a7cb90d2411b4d4$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $8a7cb90d2411b4d4$var$modL(signature.subarray(32), x);
    return signature;
}
$8a7cb90d2411b4d4$exports.sign = $8a7cb90d2411b4d4$var$sign;
function $8a7cb90d2411b4d4$var$unpackneg(r, p) {
    const t = $8a7cb90d2411b4d4$var$gf(), chk = $8a7cb90d2411b4d4$var$gf(), num = $8a7cb90d2411b4d4$var$gf(), den = $8a7cb90d2411b4d4$var$gf(), den2 = $8a7cb90d2411b4d4$var$gf(), den4 = $8a7cb90d2411b4d4$var$gf(), den6 = $8a7cb90d2411b4d4$var$gf();
    $8a7cb90d2411b4d4$var$set25519(r[2], $8a7cb90d2411b4d4$var$gf1);
    $8a7cb90d2411b4d4$var$unpack25519(r[1], p);
    $8a7cb90d2411b4d4$var$square(num, r[1]);
    $8a7cb90d2411b4d4$var$mul(den, num, $8a7cb90d2411b4d4$var$D);
    $8a7cb90d2411b4d4$var$sub(num, num, r[2]);
    $8a7cb90d2411b4d4$var$add(den, r[2], den);
    $8a7cb90d2411b4d4$var$square(den2, den);
    $8a7cb90d2411b4d4$var$square(den4, den2);
    $8a7cb90d2411b4d4$var$mul(den6, den4, den2);
    $8a7cb90d2411b4d4$var$mul(t, den6, num);
    $8a7cb90d2411b4d4$var$mul(t, t, den);
    $8a7cb90d2411b4d4$var$pow2523(t, t);
    $8a7cb90d2411b4d4$var$mul(t, t, num);
    $8a7cb90d2411b4d4$var$mul(t, t, den);
    $8a7cb90d2411b4d4$var$mul(t, t, den);
    $8a7cb90d2411b4d4$var$mul(r[0], t, den);
    $8a7cb90d2411b4d4$var$square(chk, r[0]);
    $8a7cb90d2411b4d4$var$mul(chk, chk, den);
    if ($8a7cb90d2411b4d4$var$neq25519(chk, num)) $8a7cb90d2411b4d4$var$mul(r[0], r[0], $8a7cb90d2411b4d4$var$I);
    $8a7cb90d2411b4d4$var$square(chk, r[0]);
    $8a7cb90d2411b4d4$var$mul(chk, chk, den);
    if ($8a7cb90d2411b4d4$var$neq25519(chk, num)) return -1;
    if ($8a7cb90d2411b4d4$var$par25519(r[0]) === p[31] >> 7) $8a7cb90d2411b4d4$var$sub(r[0], $8a7cb90d2411b4d4$var$gf0, r[0]);
    $8a7cb90d2411b4d4$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $8a7cb90d2411b4d4$var$verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf()
    ];
    const q = [
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf()
    ];
    if (signature.length !== $8a7cb90d2411b4d4$exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${$8a7cb90d2411b4d4$exports.SIGNATURE_LENGTH} bytes`);
    if ($8a7cb90d2411b4d4$var$unpackneg(q, publicKey)) return false;
    const hs = new $ec99c2ae07f44038$exports.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $8a7cb90d2411b4d4$var$reduce(h);
    $8a7cb90d2411b4d4$var$scalarmult(p, q, h);
    $8a7cb90d2411b4d4$var$scalarbase(q, signature.subarray(32));
    $8a7cb90d2411b4d4$var$edadd(p, q);
    $8a7cb90d2411b4d4$var$pack(t, p);
    if ($8a7cb90d2411b4d4$var$verify32(signature, t)) return false;
    return true;
}
$8a7cb90d2411b4d4$exports.verify = $8a7cb90d2411b4d4$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $8a7cb90d2411b4d4$var$convertPublicKeyToX25519(publicKey) {
    let q = [
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf(),
        $8a7cb90d2411b4d4$var$gf()
    ];
    if ($8a7cb90d2411b4d4$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $8a7cb90d2411b4d4$var$gf();
    let b = $8a7cb90d2411b4d4$var$gf();
    let y = q[1];
    $8a7cb90d2411b4d4$var$add(a, $8a7cb90d2411b4d4$var$gf1, y);
    $8a7cb90d2411b4d4$var$sub(b, $8a7cb90d2411b4d4$var$gf1, y);
    $8a7cb90d2411b4d4$var$inv25519(b, b);
    $8a7cb90d2411b4d4$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $8a7cb90d2411b4d4$var$pack25519(z, a);
    return z;
}
$8a7cb90d2411b4d4$exports.convertPublicKeyToX25519 = $8a7cb90d2411b4d4$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $8a7cb90d2411b4d4$var$convertSecretKeyToX25519(secretKey) {
    const d = (0, $ec99c2ae07f44038$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $10d15b8f838059d8$exports.wipe)(d);
    return o;
}
$8a7cb90d2411b4d4$exports.convertSecretKeyToX25519 = $8a7cb90d2411b4d4$var$convertSecretKeyToX25519;


var $8f4015cf8a40b3fc$exports = {};
"use strict";
// Copyright (C) 2017 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($8f4015cf8a40b3fc$exports, "__esModule", {
    value: true
});


$8f4015cf8a40b3fc$exports.BLOCK_SIZE = 128;
$8f4015cf8a40b3fc$exports.DIGEST_LENGTH = 64;
$8f4015cf8a40b3fc$exports.KEY_LENGTH = 64;
$8f4015cf8a40b3fc$exports.PERSONALIZATION_LENGTH = 16;
$8f4015cf8a40b3fc$exports.SALT_LENGTH = 16;
$8f4015cf8a40b3fc$exports.MAX_LEAF_SIZE = Math.pow(2, 32) - 1;
$8f4015cf8a40b3fc$exports.MAX_FANOUT = 255;
$8f4015cf8a40b3fc$exports.MAX_MAX_DEPTH = 255; // not a typo
var $8f4015cf8a40b3fc$var$IV = new Uint32Array([
    // low bits // high bits
    0xf3bcc908,
    0x6a09e667,
    0x84caa73b,
    0xbb67ae85,
    0xfe94f82b,
    0x3c6ef372,
    0x5f1d36f1,
    0xa54ff53a,
    0xade682d1,
    0x510e527f,
    0x2b3e6c1f,
    0x9b05688c,
    0xfb41bd6b,
    0x1f83d9ab,
    0x137e2179,
    0x5be0cd19
]);
// Note: sigma values are doubled since we store
// 64-bit ints as two 32-bit ints in arrays.
var $8f4015cf8a40b3fc$var$SIGMA = [
    [
        0,
        2,
        4,
        6,
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30
    ],
    [
        28,
        20,
        8,
        16,
        18,
        30,
        26,
        12,
        2,
        24,
        0,
        4,
        22,
        14,
        10,
        6
    ],
    [
        22,
        16,
        24,
        0,
        10,
        4,
        30,
        26,
        20,
        28,
        6,
        12,
        14,
        2,
        18,
        8
    ],
    [
        14,
        18,
        6,
        2,
        26,
        24,
        22,
        28,
        4,
        12,
        10,
        20,
        8,
        0,
        30,
        16
    ],
    [
        18,
        0,
        10,
        14,
        4,
        8,
        20,
        30,
        28,
        2,
        22,
        24,
        12,
        16,
        6,
        26
    ],
    [
        4,
        24,
        12,
        20,
        0,
        22,
        16,
        6,
        8,
        26,
        14,
        10,
        30,
        28,
        2,
        18
    ],
    [
        24,
        10,
        2,
        30,
        28,
        26,
        8,
        20,
        0,
        14,
        12,
        6,
        18,
        4,
        16,
        22
    ],
    [
        26,
        22,
        14,
        28,
        24,
        2,
        6,
        18,
        10,
        0,
        30,
        8,
        16,
        12,
        4,
        20
    ],
    [
        12,
        30,
        28,
        18,
        22,
        6,
        0,
        16,
        24,
        4,
        26,
        14,
        2,
        8,
        20,
        10
    ],
    [
        20,
        4,
        16,
        8,
        14,
        12,
        2,
        10,
        30,
        22,
        18,
        28,
        6,
        24,
        26,
        0
    ],
    [
        0,
        2,
        4,
        6,
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30
    ],
    [
        28,
        20,
        8,
        16,
        18,
        30,
        26,
        12,
        2,
        24,
        0,
        4,
        22,
        14,
        10,
        6
    ]
];
/**
 * BLAKE2b hash function.
 */ var $8f4015cf8a40b3fc$var$BLAKE2b = /** @class */ function() {
    function BLAKE2b(digestLength, config) {
        if (digestLength === void 0) digestLength = 64;
        this.digestLength = digestLength;
        this.blockSize = $8f4015cf8a40b3fc$exports.BLOCK_SIZE;
        // Note: Int32Arrays for state and message are used for performance reasons.
        this._state = new Int32Array($8f4015cf8a40b3fc$var$IV); // hash state, initialized with IV
        this._buffer = new Uint8Array($8f4015cf8a40b3fc$exports.BLOCK_SIZE); // buffer for data
        this._bufferLength = 0; // number of bytes in buffer
        this._ctr = new Uint32Array(4);
        this._flag = new Uint32Array(4);
        this._lastNode = false;
        this._finished = false;
        this._vtmp = new Uint32Array(32);
        this._mtmp = new Uint32Array(32);
        // Validate digest length.
        if (digestLength < 1 || digestLength > $8f4015cf8a40b3fc$exports.DIGEST_LENGTH) throw new Error("blake2b: wrong digest length");
        // Validate config, if present.
        if (config) this.validateConfig(config);
        // Get key length from config.
        var keyLength = 0;
        if (config && config.key) keyLength = config.key.length;
        // Get tree fanout and maxDepth from config.
        var fanout = 1;
        var maxDepth = 1;
        if (config && config.tree) {
            fanout = config.tree.fanout;
            maxDepth = config.tree.maxDepth;
        }
        // Xor common parameters into state.
        this._state[0] ^= digestLength | keyLength << 8 | fanout << 16 | maxDepth << 24;
        // Xor tree parameters into state.
        if (config && config.tree) {
            this._state[1] ^= config.tree.leafSize;
            this._state[2] ^= config.tree.nodeOffsetLowBits;
            this._state[3] ^= config.tree.nodeOffsetHighBits;
            this._state[4] ^= config.tree.nodeDepth | config.tree.innerDigestLength << 8;
            this._lastNode = config.tree.lastNode;
        }
        // Xor salt into state.
        if (config && config.salt) {
            this._state[8] ^= $d1d6bce100502330$exports.readUint32LE(config.salt, 0);
            this._state[9] ^= $d1d6bce100502330$exports.readUint32LE(config.salt, 4);
            this._state[10] ^= $d1d6bce100502330$exports.readUint32LE(config.salt, 8);
            this._state[11] ^= $d1d6bce100502330$exports.readUint32LE(config.salt, 12);
        }
        // Xor personalization into state.
        if (config && config.personalization) {
            this._state[12] ^= $d1d6bce100502330$exports.readUint32LE(config.personalization, 0);
            this._state[13] ^= $d1d6bce100502330$exports.readUint32LE(config.personalization, 4);
            this._state[14] ^= $d1d6bce100502330$exports.readUint32LE(config.personalization, 8);
            this._state[15] ^= $d1d6bce100502330$exports.readUint32LE(config.personalization, 12);
        }
        // Save a copy of initialized state for reset.
        this._initialState = new Uint32Array(this._state);
        // Process key.
        if (config && config.key && keyLength > 0) {
            this._paddedKey = new Uint8Array($8f4015cf8a40b3fc$exports.BLOCK_SIZE);
            this._paddedKey.set(config.key);
            // Put padded key into buffer.
            this._buffer.set(this._paddedKey);
            this._bufferLength = $8f4015cf8a40b3fc$exports.BLOCK_SIZE;
        }
    }
    BLAKE2b.prototype.reset = function() {
        // Restore initial state.
        this._state.set(this._initialState);
        if (this._paddedKey) {
            // Put padded key into buffer.
            this._buffer.set(this._paddedKey);
            this._bufferLength = $8f4015cf8a40b3fc$exports.BLOCK_SIZE;
        } else this._bufferLength = 0;
        // Clear counters and flags.
        $10d15b8f838059d8$exports.wipe(this._ctr);
        $10d15b8f838059d8$exports.wipe(this._flag);
        this._finished = false;
        return this;
    };
    BLAKE2b.prototype.validateConfig = function(config) {
        if (config.key && config.key.length > $8f4015cf8a40b3fc$exports.KEY_LENGTH) throw new Error("blake2b: wrong key length");
        if (config.salt && config.salt.length !== $8f4015cf8a40b3fc$exports.SALT_LENGTH) throw new Error("blake2b: wrong salt length");
        if (config.personalization && config.personalization.length !== $8f4015cf8a40b3fc$exports.PERSONALIZATION_LENGTH) throw new Error("blake2b: wrong personalization length");
        if (config.tree) {
            if (config.tree.fanout < 0 || config.tree.fanout > $8f4015cf8a40b3fc$exports.MAX_FANOUT) throw new Error("blake2b: wrong tree fanout");
            if (config.tree.maxDepth < 0 || config.tree.maxDepth > $8f4015cf8a40b3fc$exports.MAX_MAX_DEPTH) throw new Error("blake2b: wrong tree depth");
            if (config.tree.leafSize < 0 || config.tree.leafSize > $8f4015cf8a40b3fc$exports.MAX_LEAF_SIZE) throw new Error("blake2b: wrong leaf size");
            if (config.tree.innerDigestLength < 0 || config.tree.innerDigestLength > $8f4015cf8a40b3fc$exports.DIGEST_LENGTH) throw new Error("blake2b: wrong tree inner digest length");
        }
    };
    BLAKE2b.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("blake2b: can't update because hash was finished.");
        var left = $8f4015cf8a40b3fc$exports.BLOCK_SIZE - this._bufferLength;
        var dataPos = 0;
        if (dataLength === 0) return this;
        // Finish buffer.
        if (dataLength > left) {
            for(var i = 0; i < left; i++)this._buffer[this._bufferLength + i] = data[dataPos + i];
            this._processBlock($8f4015cf8a40b3fc$exports.BLOCK_SIZE);
            dataPos += left;
            dataLength -= left;
            this._bufferLength = 0;
        }
        // Process data blocks.
        while(dataLength > $8f4015cf8a40b3fc$exports.BLOCK_SIZE){
            for(var i = 0; i < $8f4015cf8a40b3fc$exports.BLOCK_SIZE; i++)this._buffer[i] = data[dataPos + i];
            this._processBlock($8f4015cf8a40b3fc$exports.BLOCK_SIZE);
            dataPos += $8f4015cf8a40b3fc$exports.BLOCK_SIZE;
            dataLength -= $8f4015cf8a40b3fc$exports.BLOCK_SIZE;
            this._bufferLength = 0;
        }
        // Copy leftovers to buffer.
        for(var i = 0; i < dataLength; i++)this._buffer[this._bufferLength + i] = data[dataPos + i];
        this._bufferLength += dataLength;
        return this;
    };
    BLAKE2b.prototype.finish = function(out) {
        if (!this._finished) {
            for(var i = this._bufferLength; i < $8f4015cf8a40b3fc$exports.BLOCK_SIZE; i++)this._buffer[i] = 0;
            // Set last block flag.
            this._flag[0] = 0xffffffff;
            this._flag[1] = 0xffffffff;
            // Set last node flag if last node in tree.
            if (this._lastNode) {
                this._flag[2] = 0xffffffff;
                this._flag[3] = 0xffffffff;
            }
            this._processBlock(this._bufferLength);
            this._finished = true;
        }
        // Reuse buffer as temporary space for digest.
        var tmp = this._buffer.subarray(0, 64);
        for(var i = 0; i < 16; i++)$d1d6bce100502330$exports.writeUint32LE(this._state[i], tmp, i * 4);
        out.set(tmp.subarray(0, out.length));
        return this;
    };
    BLAKE2b.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    BLAKE2b.prototype.clean = function() {
        $10d15b8f838059d8$exports.wipe(this._vtmp);
        $10d15b8f838059d8$exports.wipe(this._mtmp);
        $10d15b8f838059d8$exports.wipe(this._state);
        $10d15b8f838059d8$exports.wipe(this._buffer);
        $10d15b8f838059d8$exports.wipe(this._initialState);
        if (this._paddedKey) $10d15b8f838059d8$exports.wipe(this._paddedKey);
        this._bufferLength = 0;
        $10d15b8f838059d8$exports.wipe(this._ctr);
        $10d15b8f838059d8$exports.wipe(this._flag);
        this._lastNode = false;
        this._finished = false;
    };
    BLAKE2b.prototype.saveState = function() {
        if (this._finished) throw new Error("blake2b: cannot save finished state");
        return {
            state: new Uint32Array(this._state),
            buffer: new Uint8Array(this._buffer),
            bufferLength: this._bufferLength,
            ctr: new Uint32Array(this._ctr),
            flag: new Uint32Array(this._flag),
            lastNode: this._lastNode,
            paddedKey: this._paddedKey ? new Uint8Array(this._paddedKey) : undefined,
            initialState: new Uint32Array(this._initialState)
        };
    };
    BLAKE2b.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._buffer.set(savedState.buffer);
        this._bufferLength = savedState.bufferLength;
        this._ctr.set(savedState.ctr);
        this._flag.set(savedState.flag);
        this._lastNode = savedState.lastNode;
        if (this._paddedKey) $10d15b8f838059d8$exports.wipe(this._paddedKey);
        this._paddedKey = savedState.paddedKey ? new Uint8Array(savedState.paddedKey) : undefined;
        this._initialState.set(savedState.initialState);
        return this;
    };
    BLAKE2b.prototype.cleanSavedState = function(savedState) {
        $10d15b8f838059d8$exports.wipe(savedState.state);
        $10d15b8f838059d8$exports.wipe(savedState.buffer);
        $10d15b8f838059d8$exports.wipe(savedState.initialState);
        if (savedState.paddedKey) $10d15b8f838059d8$exports.wipe(savedState.paddedKey);
        savedState.bufferLength = 0;
        $10d15b8f838059d8$exports.wipe(savedState.ctr);
        $10d15b8f838059d8$exports.wipe(savedState.flag);
        savedState.lastNode = false;
    };
    BLAKE2b.prototype._G = function(v, al, bl, cl, dl, ah, bh, ch, dh, ml0, mh0, ml1, mh1) {
        var vla = v[al], vha = v[ah], vlb = v[bl], vhb = v[bh], vlc = v[cl], vhc = v[ch], vld = v[dl], vhd = v[dh];
        // 64-bit: va += vb
        var w = vla & 0xffff, x = vla >>> 16, y = vha & 0xffff, z = vha >>> 16;
        w += vlb & 0xffff;
        x += vlb >>> 16;
        y += vhb & 0xffff;
        z += vhb >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: va += m[sigma[r][2 * i + 0]]
        w = vla & 0xffff;
        x = vla >>> 16;
        y = vha & 0xffff;
        z = vha >>> 16;
        w += ml0 & 0xffff;
        x += ml0 >>> 16;
        y += mh0 & 0xffff;
        z += mh0 >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: vd ^= va
        vld ^= vla;
        vhd ^= vha;
        // 64-bit: rot(vd, 32)
        w = vhd;
        vhd = vld;
        vld = w;
        // 64-bit: vc += vd
        w = vlc & 0xffff;
        x = vlc >>> 16;
        y = vhc & 0xffff;
        z = vhc >>> 16;
        w += vld & 0xffff;
        x += vld >>> 16;
        y += vhd & 0xffff;
        z += vhd >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vhc = y & 0xffff | z << 16;
        vlc = w & 0xffff | x << 16;
        // 64-bit: vb ^= vc
        vlb ^= vlc;
        vhb ^= vhc;
        // 64-bit: rot(vb, 24)
        w = vlb << 8 | vhb >>> 24;
        vlb = vhb << 8 | vlb >>> 24;
        vhb = w;
        // 64-bit: va += vb
        w = vla & 0xffff;
        x = vla >>> 16;
        y = vha & 0xffff;
        z = vha >>> 16;
        w += vlb & 0xffff;
        x += vlb >>> 16;
        y += vhb & 0xffff;
        z += vhb >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: va += m[sigma[r][2 * i + 1]
        w = vla & 0xffff;
        x = vla >>> 16;
        y = vha & 0xffff;
        z = vha >>> 16;
        w += ml1 & 0xffff;
        x += ml1 >>> 16;
        y += mh1 & 0xffff;
        z += mh1 >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 0xffff | z << 16;
        vla = w & 0xffff | x << 16;
        // 64-bit: vd ^= va
        vld ^= vla;
        vhd ^= vha;
        // 64-bit: rot(vd, 16)
        w = vld << 16 | vhd >>> 16;
        vld = vhd << 16 | vld >>> 16;
        vhd = w;
        // 64-bit: vc += vd
        w = vlc & 0xffff;
        x = vlc >>> 16;
        y = vhc & 0xffff;
        z = vhc >>> 16;
        w += vld & 0xffff;
        x += vld >>> 16;
        y += vhd & 0xffff;
        z += vhd >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vhc = y & 0xffff | z << 16;
        vlc = w & 0xffff | x << 16;
        // 64-bit: vb ^= vc
        vlb ^= vlc;
        vhb ^= vhc;
        // 64-bit: rot(vb, 63)
        w = vhb << 1 | vlb >>> 31;
        vlb = vlb << 1 | vhb >>> 31;
        vhb = w;
        v[al] = vla;
        v[ah] = vha;
        v[bl] = vlb;
        v[bh] = vhb;
        v[cl] = vlc;
        v[ch] = vhc;
        v[dl] = vld;
        v[dh] = vhd;
    };
    BLAKE2b.prototype._incrementCounter = function(n) {
        for(var i = 0; i < 3; i++){
            var a = this._ctr[i] + n;
            this._ctr[i] = a >>> 0;
            if (this._ctr[i] === a) return;
            n = 1;
        }
    };
    BLAKE2b.prototype._processBlock = function(length) {
        this._incrementCounter(length);
        var v = this._vtmp;
        v.set(this._state);
        v.set($8f4015cf8a40b3fc$var$IV, 16);
        v[24] ^= this._ctr[0];
        v[25] ^= this._ctr[1];
        v[26] ^= this._ctr[2];
        v[27] ^= this._ctr[3];
        v[28] ^= this._flag[0];
        v[29] ^= this._flag[1];
        v[30] ^= this._flag[2];
        v[31] ^= this._flag[3];
        var m = this._mtmp;
        for(var i = 0; i < 32; i++)m[i] = $d1d6bce100502330$exports.readUint32LE(this._buffer, i * 4);
        for(var r = 0; r < 12; r++){
            this._G(v, 0, 8, 16, 24, 1, 9, 17, 25, m[$8f4015cf8a40b3fc$var$SIGMA[r][0]], m[$8f4015cf8a40b3fc$var$SIGMA[r][0] + 1], m[$8f4015cf8a40b3fc$var$SIGMA[r][1]], m[$8f4015cf8a40b3fc$var$SIGMA[r][1] + 1]);
            this._G(v, 2, 10, 18, 26, 3, 11, 19, 27, m[$8f4015cf8a40b3fc$var$SIGMA[r][2]], m[$8f4015cf8a40b3fc$var$SIGMA[r][2] + 1], m[$8f4015cf8a40b3fc$var$SIGMA[r][3]], m[$8f4015cf8a40b3fc$var$SIGMA[r][3] + 1]);
            this._G(v, 4, 12, 20, 28, 5, 13, 21, 29, m[$8f4015cf8a40b3fc$var$SIGMA[r][4]], m[$8f4015cf8a40b3fc$var$SIGMA[r][4] + 1], m[$8f4015cf8a40b3fc$var$SIGMA[r][5]], m[$8f4015cf8a40b3fc$var$SIGMA[r][5] + 1]);
            this._G(v, 6, 14, 22, 30, 7, 15, 23, 31, m[$8f4015cf8a40b3fc$var$SIGMA[r][6]], m[$8f4015cf8a40b3fc$var$SIGMA[r][6] + 1], m[$8f4015cf8a40b3fc$var$SIGMA[r][7]], m[$8f4015cf8a40b3fc$var$SIGMA[r][7] + 1]);
            this._G(v, 0, 10, 20, 30, 1, 11, 21, 31, m[$8f4015cf8a40b3fc$var$SIGMA[r][8]], m[$8f4015cf8a40b3fc$var$SIGMA[r][8] + 1], m[$8f4015cf8a40b3fc$var$SIGMA[r][9]], m[$8f4015cf8a40b3fc$var$SIGMA[r][9] + 1]);
            this._G(v, 2, 12, 22, 24, 3, 13, 23, 25, m[$8f4015cf8a40b3fc$var$SIGMA[r][10]], m[$8f4015cf8a40b3fc$var$SIGMA[r][10] + 1], m[$8f4015cf8a40b3fc$var$SIGMA[r][11]], m[$8f4015cf8a40b3fc$var$SIGMA[r][11] + 1]);
            this._G(v, 4, 14, 16, 26, 5, 15, 17, 27, m[$8f4015cf8a40b3fc$var$SIGMA[r][12]], m[$8f4015cf8a40b3fc$var$SIGMA[r][12] + 1], m[$8f4015cf8a40b3fc$var$SIGMA[r][13]], m[$8f4015cf8a40b3fc$var$SIGMA[r][13] + 1]);
            this._G(v, 6, 8, 18, 28, 7, 9, 19, 29, m[$8f4015cf8a40b3fc$var$SIGMA[r][14]], m[$8f4015cf8a40b3fc$var$SIGMA[r][14] + 1], m[$8f4015cf8a40b3fc$var$SIGMA[r][15]], m[$8f4015cf8a40b3fc$var$SIGMA[r][15] + 1]);
        }
        for(var i = 0; i < 16; i++)this._state[i] ^= v[i] ^ v[i + 16];
    };
    return BLAKE2b;
}();
$8f4015cf8a40b3fc$exports.BLAKE2b = $8f4015cf8a40b3fc$var$BLAKE2b;
function $8f4015cf8a40b3fc$var$hash(data, digestLength, config) {
    if (digestLength === void 0) digestLength = $8f4015cf8a40b3fc$exports.DIGEST_LENGTH;
    var h = new $8f4015cf8a40b3fc$var$BLAKE2b(digestLength, config);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$8f4015cf8a40b3fc$exports.hash = $8f4015cf8a40b3fc$var$hash;



var $f6c042d01dfc9475$exports = {};
'use strict';

var $f6c042d01dfc9475$require$sha256 = $510ad3657d73a9d2$exports.sha256;
var $33f1b51c22873f45$exports = {};
'use strict';
var $f67759212cb47dc0$exports = {};
var $dc310f0424c95daa$exports = {};
'use strict';
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $dc310f0424c95daa$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Find code of next character
            var charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            var carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$dc310f0424c95daa$exports = $dc310f0424c95daa$var$base;


const $f67759212cb47dc0$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
$f67759212cb47dc0$exports = $dc310f0424c95daa$exports($f67759212cb47dc0$var$ALPHABET);


$33f1b51c22873f45$exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var payloadU8 = Uint8Array.from(payload);
        var checksum = checksumFn(payloadU8);
        var length = payloadU8.length + 4;
        var both = new Uint8Array(length);
        both.set(payloadU8, 0);
        both.set(checksum.subarray(0, 4), payloadU8.length);
        return $f67759212cb47dc0$exports.encode(both, length);
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $f67759212cb47dc0$exports.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $f67759212cb47dc0$exports.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error('Invalid checksum');
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};


// SHA256(SHA256(buffer))
function $f6c042d01dfc9475$var$sha256x2(buffer) {
    return $f6c042d01dfc9475$require$sha256($f6c042d01dfc9475$require$sha256(buffer));
}
$f6c042d01dfc9475$exports = $33f1b51c22873f45$exports($f6c042d01dfc9475$var$sha256x2);


// ==========================================================================================
// parent error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Parent error class all taquito errors to extend from
 */ class $c34ebaa6f129c2ed$export$e5619b407b1c8b0a extends Error {
}
/**
 *  @category Error
 *  @description Error that indicates invalid user inputs
 */ class $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 extends $c34ebaa6f129c2ed$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error returned by RPC node
 */ class $c34ebaa6f129c2ed$export$5460eff990f31920 extends $c34ebaa6f129c2ed$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates TezosToolKit has not been configured appropriately
 */ class $c34ebaa6f129c2ed$export$32f4d70b2fb302b1 extends $c34ebaa6f129c2ed$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates a requested action is not supported by Taquito
 */ class $c34ebaa6f129c2ed$export$34bc216509d47ce6 extends $c34ebaa6f129c2ed$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error during a network operation
 */ class $c34ebaa6f129c2ed$export$bae979e68e4dc802 extends $c34ebaa6f129c2ed$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates user attempts an action without necessary permissions
 */ class $c34ebaa6f129c2ed$export$9c81d48c1e1840ac extends $c34ebaa6f129c2ed$export$e5619b407b1c8b0a {
}
// ==========================================================================================
// common error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Error that indicates an invalid originated or implicit address being passed or used
 */ class $c34ebaa6f129c2ed$export$66c44d927ffead98 extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidAddressError';
        this.message = `Invalid address "${address}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
class $c34ebaa6f129c2ed$export$be6cb9338b7137e0 extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidStakingAddressError';
        this.message = `Invalid staking address "${address}", you can only set destination as your own address`;
    }
}
class $c34ebaa6f129c2ed$export$1623a856d8b6cc2a extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidFinalizeUnstakeAmountError';
        this.message = `The amount can only be 0 when finalizing an unstake`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid block hash being passed or used
 */ class $c34ebaa6f129c2ed$export$16fabd343bcdfd7b extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(blockHash, errorDetail){
        super();
        this.blockHash = blockHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidBlockHashError';
        this.message = `Invalid block hash "${blockHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid amount of tez being passed as a parameter
 */ class $c34ebaa6f129c2ed$export$d8bf6d22cce8e288 extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(amount){
        super();
        this.amount = amount;
        this.name = 'InvalidAmountError';
        this.message = `Invalid amount "${amount}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid derivation path being passed or used
 */ class $c34ebaa6f129c2ed$export$522ca3df7030c309 extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(derivationPath, errorDetail){
        super();
        this.derivationPath = derivationPath;
        this.errorDetail = errorDetail;
        this.name = 'InvalidDerivationPathError';
        this.message = `Invalid derivation path "${derivationPath}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid hex string have been passed or used
 */ class $c34ebaa6f129c2ed$export$1888d6928c74d5ee extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(hexString, errorDetail){
        super();
        this.hexString = hexString;
        this.errorDetail = errorDetail;
        this.name = 'InvalidHexStringError';
        this.message = `Invalid hex string "${hexString}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid message being passed or used
 */ class $c34ebaa6f129c2ed$export$a5124d7665e9d8ad extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(msg, errorDetail){
        super();
        this.msg = msg;
        this.errorDetail = errorDetail;
        this.name = 'InvalidMessageError';
        this.message = `Invalid message "${msg}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid view parameter of a smart contract
 */ class $c34ebaa6f129c2ed$export$f9ce6a924724628b extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(viewName, sigs, args, cause){
        super();
        this.viewName = viewName;
        this.sigs = sigs;
        this.args = args;
        this.cause = cause;
        this.name = 'InvalidViewParameterError';
        this.message = `Invalid view arguments ${JSON.stringify(args)} received for name "${viewName}" expecting one of the following signatures ${JSON.stringify(sigs)}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid private key being passed or used
 */ class $c34ebaa6f129c2ed$export$adf223add86ae0aa extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(errorDetail){
        super();
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyError';
        this.message = `Invalid private key`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an Invalid Public Key being passed or used
 */ class $c34ebaa6f129c2ed$export$f675822ed489f01f extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(publicKey, errorDetail){
        super();
        this.publicKey = publicKey;
        this.errorDetail = errorDetail;
        this.name = 'InvalidPublicKeyError';
        this.message = `Invalid public key "${publicKey}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid signature being passed or used
 */ class $c34ebaa6f129c2ed$export$ccc2f68ef106615a extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(signature, errorDetail){
        super();
        this.signature = signature;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSignatureError';
        this.message = `Invalid signature "${signature}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid contract address being passed or used
 */ class $c34ebaa6f129c2ed$export$193774326795229b extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(contractAddress, errorDetail){
        super();
        this.contractAddress = contractAddress;
        this.errorDetail = errorDetail;
        this.name = 'InvalidContractAddressError';
        this.message = `Invalid contract address "${contractAddress}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid chain id being passed or used
 */ class $c34ebaa6f129c2ed$export$4836eb835ffca5b2 extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(chainId, errorDetail){
        super();
        this.chainId = chainId;
        this.errorDetail = errorDetail;
        this.name = 'InvalidChainIdError';
        this.message = `Invalid chain id "${chainId}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid public key hash being passed or used
 */ class $c34ebaa6f129c2ed$export$a3d7df0ca9d9410c extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(keyHash, errorDetail){
        super();
        this.keyHash = keyHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyHashError';
        this.message = `Invalid public key hash "${keyHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation hash being passed or used
 */ class $c34ebaa6f129c2ed$export$1a1c2023d3ec7a8a extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(operationHash, errorDetail){
        super();
        this.operationHash = operationHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationHashError';
        this.message = `Invalid operation hash "${operationHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation kind being passed or used
 */ class $c34ebaa6f129c2ed$export$bc5be87550569b55 extends $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950 {
    constructor(operationKind, errorDetail){
        super();
        this.operationKind = operationKind;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationKindError';
        this.message = `Invalid operation kind "${operationKind}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description General error that indicates something is no longer supported and/or deprecated
 */ class $c34ebaa6f129c2ed$export$11034991807c583d extends $c34ebaa6f129c2ed$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'DeprecationError';
    }
}
/**
 *  @category Error
 *  @description General error that indicates an action is prohibited or not allowed
 */ class $c34ebaa6f129c2ed$export$4041d915d9096adf extends $c34ebaa6f129c2ed$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ProhibitedActionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure in grabbing the public key
 */ class $c34ebaa6f129c2ed$export$183b043cd3c947f9 extends $c34ebaa6f129c2ed$export$e5619b407b1c8b0a {
    constructor(pkh, cause){
        super();
        this.pkh = pkh;
        this.cause = cause;
        this.name = 'PublicKeyNotFoundError';
        this.message = `Public key not found of this address "${pkh}" in either wallet or contract API.`;
    }
}




var $1zUcV = parcelRequire("1zUcV");

// ref https://gitlab.com/tezos/tezos/-/blob/master/src/lib_crypto/base58.ml
var $6ed3c564aba0f912$export$e77cfe0b08ec163;
(function(Prefix) {
    Prefix["TZ1"] = "tz1";
    Prefix["TZ2"] = "tz2";
    Prefix["TZ3"] = "tz3";
    Prefix["TZ4"] = "tz4";
    Prefix["KT"] = "KT";
    Prefix["KT1"] = "KT1";
    Prefix["EDSK"] = "edsk";
    Prefix["EDSK2"] = "edsk2";
    Prefix["SPSK"] = "spsk";
    Prefix["P2SK"] = "p2sk";
    Prefix["BLSK"] = "BLsk";
    Prefix["EDPK"] = "edpk";
    Prefix["SPPK"] = "sppk";
    Prefix["P2PK"] = "p2pk";
    Prefix["BLPK"] = "BLpk";
    Prefix["EDESK"] = "edesk";
    Prefix["SPESK"] = "spesk";
    Prefix["P2ESK"] = "p2esk";
    Prefix["BLESK"] = "BLesk";
    Prefix["EDSIG"] = "edsig";
    Prefix["SPSIG"] = "spsig";
    Prefix["P2SIG"] = "p2sig";
    Prefix["BLSIG"] = "BLsig";
    Prefix["SIG"] = "sig";
    Prefix["NET"] = "Net";
    Prefix["NCE"] = "nce";
    Prefix["B"] = "B";
    Prefix["O"] = "o";
    Prefix["LO"] = "Lo";
    Prefix["LLO"] = "LLo";
    Prefix["P"] = "P";
    Prefix["CO"] = "Co";
    Prefix["ID"] = "id";
    Prefix["EXPR"] = "expr";
    Prefix["TZ"] = "TZ";
    Prefix["VH"] = "vh";
    Prefix["SASK"] = "sask";
    Prefix["ZET1"] = "zet1";
    Prefix["SR1"] = "sr1";
    Prefix["SRC1"] = "src1";
    Prefix["SH"] = "sh";
})($6ed3c564aba0f912$export$e77cfe0b08ec163 || ($6ed3c564aba0f912$export$e77cfe0b08ec163 = {}));
const $6ed3c564aba0f912$export$82e9f45cca5ba907 = {
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ1]: new Uint8Array([
        6,
        161,
        159
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ2]: new Uint8Array([
        6,
        161,
        161
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ3]: new Uint8Array([
        6,
        161,
        164
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ4]: new Uint8Array([
        6,
        161,
        166
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.KT]: new Uint8Array([
        2,
        90,
        121
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.KT1]: new Uint8Array([
        2,
        90,
        121
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.EDSK]: new Uint8Array([
        43,
        246,
        78,
        7
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.EDSK2]: new Uint8Array([
        13,
        15,
        58,
        7
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SPSK]: new Uint8Array([
        17,
        162,
        224,
        201
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.P2SK]: new Uint8Array([
        16,
        81,
        238,
        189
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.BLSK]: new Uint8Array([
        3,
        150,
        192,
        40
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.EDPK]: new Uint8Array([
        13,
        15,
        37,
        217
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SPPK]: new Uint8Array([
        3,
        254,
        226,
        86
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.P2PK]: new Uint8Array([
        3,
        178,
        139,
        127
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.BLPK]: new Uint8Array([
        6,
        149,
        135,
        204
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.EDESK]: new Uint8Array([
        7,
        90,
        60,
        179,
        41
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SPESK]: new Uint8Array([
        0x09,
        0xed,
        0xf1,
        0xae,
        0x96
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.P2ESK]: new Uint8Array([
        0x09,
        0x30,
        0x39,
        0x73,
        0xab
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.BLESK]: new Uint8Array([
        2,
        5,
        30,
        53,
        25
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.EDSIG]: new Uint8Array([
        9,
        245,
        205,
        134,
        18
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SPSIG]: new Uint8Array([
        13,
        115,
        101,
        19,
        63
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.P2SIG]: new Uint8Array([
        54,
        240,
        44,
        52
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.BLSIG]: new Uint8Array([
        40,
        171,
        64,
        207
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SIG]: new Uint8Array([
        4,
        130,
        43
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.NET]: new Uint8Array([
        87,
        82,
        0
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.NCE]: new Uint8Array([
        69,
        220,
        169
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.B]: new Uint8Array([
        1,
        52
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.O]: new Uint8Array([
        5,
        116
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.LO]: new Uint8Array([
        133,
        233
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.LLO]: new Uint8Array([
        29,
        159,
        109
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.P]: new Uint8Array([
        2,
        170
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.CO]: new Uint8Array([
        79,
        179
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.ID]: new Uint8Array([
        153,
        103
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.EXPR]: new Uint8Array([
        13,
        44,
        64,
        27
    ]),
    // Legacy prefix
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ]: new Uint8Array([
        2,
        90,
        121
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.VH]: new Uint8Array([
        1,
        106,
        242
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SASK]: new Uint8Array([
        11,
        237,
        20,
        92
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.ZET1]: new Uint8Array([
        18,
        71,
        40,
        223
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SR1]: new Uint8Array([
        6,
        124,
        117
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SRC1]: new Uint8Array([
        17,
        165,
        134,
        138
    ]),
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SH]: new Uint8Array([
        2,
        116,
        180
    ])
};
const $6ed3c564aba0f912$export$2a5ba4495636ee46 = {
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ1]: 20,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ2]: 20,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ3]: 20,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ4]: 20,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.KT]: 20,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.KT1]: 20,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.EDPK]: 32,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SPPK]: 33,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.P2PK]: 33,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.BLPK]: 48,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.EDSIG]: 64,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SPSIG]: 64,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.P2SIG]: 64,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.BLSIG]: 96,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SIG]: 64,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.NET]: 4,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.B]: 32,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.P]: 32,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.O]: 32,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.VH]: 32,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SASK]: 169,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.ZET1]: 43,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SR1]: 20,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SRC1]: 32,
    [$6ed3c564aba0f912$export$e77cfe0b08ec163.SH]: 48
};
/**
 * @description Verify signature of a payload
 *
 * @param messageBytes The forged message including the magic byte (11 for block,
 *        12 for preattestation, 13 for attestation, 3 for generic, 5 for the PACK format of michelson)
 * @param publicKey The public key to verify the signature against
 * @param signature The signature to verify
 * @returns A boolean indicating if the signature matches
 * @throws {@link InvalidPublicKeyError} | {@link InvalidSignatureError} | {@link InvalidMessageError}
 * @example
 * ```
 * const message = '03d0c10e3ed11d7c6e3357f6ef335bab9e8f2bd54d0ce20c482e241191a6e4b8ce6c01be917311d9ac46959750e405d57e268e2ed9e174a80794fbd504e12a4a000141eb3781afed2f69679ff2bbe1c5375950b0e40d00ff000000005e05050505050507070100000024747a32526773486e74516b72794670707352466261313652546656503539684b72654a4d07070100000024747a315a6672455263414c42776d4171776f6e525859565142445439426a4e6a42484a750001';
 * const pk = 'sppk7c7hkPj47yjYFEHX85q46sFJGw6RBrqoVSHwAJAT4e14KJwzoey';
 * const sig = 'spsig1cdLkp1RLgUHAp13aRFkZ6MQDPp7xCnjAExGL3MBSdMDmT6JgQSX8cufyDgJRM3sinFtiCzLbsyP6d365EHoNevxhT47nx'
 *
 * const response = verifySignature(message, pk, sig);
 * ```
 *
 */ function $6ed3c564aba0f912$export$ab54e47fdf2903bb(messageBytes, publicKey, signature, watermark) {
    const pkPrefix = $6ed3c564aba0f912$export$2fc642945002cd1a(publicKey);
    const sigPrefix = $6ed3c564aba0f912$var$validateSigAndExtractPrefix(signature);
    const decodedPublicKey = $6ed3c564aba0f912$export$b9856b5e6fd1a05f(publicKey, $6ed3c564aba0f912$export$82e9f45cca5ba907[pkPrefix]);
    const decodedSig = $6ed3c564aba0f912$export$b9856b5e6fd1a05f(signature, $6ed3c564aba0f912$export$82e9f45cca5ba907[sigPrefix]);
    let messageBuf = $6ed3c564aba0f912$export$80feccbc0acd4657($6ed3c564aba0f912$var$validateMessageNotEmpty(messageBytes));
    if (typeof watermark !== 'undefined') messageBuf = $6ed3c564aba0f912$export$196099622a18a454(watermark, messageBuf);
    const bytesHash = (0, $8f4015cf8a40b3fc$exports.hash)(messageBuf, 32);
    if (pkPrefix === $6ed3c564aba0f912$export$e77cfe0b08ec163.EDPK) return $6ed3c564aba0f912$var$verifyEdSignature(decodedSig, bytesHash, decodedPublicKey);
    else if (pkPrefix === $6ed3c564aba0f912$export$e77cfe0b08ec163.SPPK) return $6ed3c564aba0f912$var$verifySpSignature(decodedSig, bytesHash, decodedPublicKey);
    else if (pkPrefix === $6ed3c564aba0f912$export$e77cfe0b08ec163.P2PK) return $6ed3c564aba0f912$var$verifyP2Signature(decodedSig, bytesHash, decodedPublicKey);
    else return false;
}
function $6ed3c564aba0f912$var$validateMessageNotEmpty(message) {
    if (message === '') throw new (0, $c34ebaa6f129c2ed$export$a5124d7665e9d8ad)(message, `can't be empty`);
    return message;
}
function $6ed3c564aba0f912$export$2fc642945002cd1a(publicKey) {
    if (publicKey === '') throw new (0, $c34ebaa6f129c2ed$export$f675822ed489f01f)(publicKey, `can't be empty`);
    const pkPrefix = publicKey.substring(0, 4);
    const publicKeyValidation = $6ed3c564aba0f912$export$7e268ff6bd252dc4(publicKey);
    if (publicKeyValidation !== $6ed3c564aba0f912$export$f9bf9a3c544b4010.VALID) throw new (0, $c34ebaa6f129c2ed$export$f675822ed489f01f)(publicKey, $6ed3c564aba0f912$export$a2057601792df650(publicKeyValidation));
    return pkPrefix;
}
function $6ed3c564aba0f912$var$validateSigAndExtractPrefix(signature) {
    const signaturePrefix = signature.startsWith('sig') ? signature.substring(0, 3) : signature.substring(0, 5);
    const validation = $6ed3c564aba0f912$export$f680e6c2b3919edb(signature);
    if (validation !== $6ed3c564aba0f912$export$f9bf9a3c544b4010.VALID) throw new (0, $c34ebaa6f129c2ed$export$ccc2f68ef106615a)(signature, $6ed3c564aba0f912$export$a2057601792df650(validation));
    return signaturePrefix;
}
function $6ed3c564aba0f912$var$verifyEdSignature(decodedSig, bytesHash, decodedPublicKey) {
    try {
        return (0, $8a7cb90d2411b4d4$exports.verify)(decodedPublicKey, bytesHash, decodedSig);
    } catch (e) {
        return false;
    }
}
function $6ed3c564aba0f912$var$verifySpSignature(decodedSig, bytesHash, decodedPublicKey) {
    const key = new (0, (/*@__PURE__*/$parcel$interopDefault($1zUcV))).ec('secp256k1').keyFromPublic(decodedPublicKey);
    return $6ed3c564aba0f912$var$verifySpOrP2Sig(decodedSig, bytesHash, key);
}
function $6ed3c564aba0f912$var$verifyP2Signature(decodedSig, bytesHash, decodedPublicKey) {
    const key = new (0, (/*@__PURE__*/$parcel$interopDefault($1zUcV))).ec('p256').keyFromPublic(decodedPublicKey);
    return $6ed3c564aba0f912$var$verifySpOrP2Sig(decodedSig, bytesHash, key);
}
function $6ed3c564aba0f912$var$verifySpOrP2Sig(decodedSig, bytesHash, key) {
    const hexSig = $6ed3c564aba0f912$export$b0491dd0626f8a03((0, (/*@__PURE__*/$parcel$interopDefault($42fd859874341478$exports)))(decodedSig));
    const match = hexSig.match(/([a-f\d]{64})/gi);
    if (match) try {
        const [r, s] = match;
        return key.verify(bytesHash, {
            r: r,
            s: s
        });
    } catch (e) {
        return false;
    }
    return false;
}
/**
 *  @category Error
 *  @description Error that indicates invalid protocol hash being passed or used
 */ class $6ed3c564aba0f912$export$cad3798ff1c849c5 extends (0, $c34ebaa6f129c2ed$export$9d3f3bc8b6d48950) {
    constructor(protocolHash, errorDetails){
        super();
        this.protocolHash = protocolHash;
        this.errorDetails = errorDetails;
        this.name = 'InvalidProtocolHashError';
        this.name = 'InvalidProtocolHashError';
        this.message = `The protocol hash '${protocolHash}' is invalid`;
        errorDetails && (this.message += `: ${errorDetails}`);
    }
}
/**
 *  @category Error
 *  @description Error that indicates unable to convert data type from one to another
 */ class $6ed3c564aba0f912$export$ec375d495b3854fb extends (0, $c34ebaa6f129c2ed$export$34bc216509d47ce6) {
    constructor(value, desiredType){
        super();
        this.value = value;
        this.desiredType = desiredType;
        this.name = 'ValueConversionError';
        this.message = `Unable to convert ${value} to a ${desiredType}`;
    }
}
var $6ed3c564aba0f912$export$f9bf9a3c544b4010;
(function(ValidationResult) {
    ValidationResult[ValidationResult["NO_PREFIX_MATCHED"] = 0] = "NO_PREFIX_MATCHED";
    ValidationResult[ValidationResult["INVALID_CHECKSUM"] = 1] = "INVALID_CHECKSUM";
    ValidationResult[ValidationResult["INVALID_LENGTH"] = 2] = "INVALID_LENGTH";
    ValidationResult[ValidationResult["VALID"] = 3] = "VALID";
})($6ed3c564aba0f912$export$f9bf9a3c544b4010 || ($6ed3c564aba0f912$export$f9bf9a3c544b4010 = {}));
function $6ed3c564aba0f912$export$cf38fb338883777c(value) {
    if (typeof value !== 'string') return false;
    return value in $6ed3c564aba0f912$export$82e9f45cca5ba907;
}
/**
 * @description This function is called by the validation functions ([[validateAddress]], [[validateChain]], [[validateContractAddress]], [[validateKeyHash]], [[validateSignature]], [[validatePublicKey]]).
 * Verify if the value has the right prefix or return `NO_PREFIX_MATCHED`,
 * decode the value using base58 and return `INVALID_CHECKSUM` if it fails,
 * check if the length of the value matches the prefix type or return `INVALID_LENGTH`.
 * If all checks pass, return `VALID`.
 *
 * @param value Value to validate
 * @param prefixes prefix the value should have
 */ function $6ed3c564aba0f912$var$validatePrefixedValue(value, prefixes) {
    const match = new RegExp(`^(${prefixes.join('|')})`).exec(value);
    if (!match || match.length === 0) return $6ed3c564aba0f912$export$f9bf9a3c544b4010.NO_PREFIX_MATCHED;
    const prefixKey = match[0];
    if (!$6ed3c564aba0f912$export$cf38fb338883777c(prefixKey)) return $6ed3c564aba0f912$export$f9bf9a3c544b4010.NO_PREFIX_MATCHED;
    // Check whether annotation exist before starting validation
    if (value.includes('%')) value = value.split('%')[0];
    const kt1Regex = /^(KT1\w{33})$/;
    if (!kt1Regex.test(value) && prefixKey === 'KT1') return $6ed3c564aba0f912$export$f9bf9a3c544b4010.INVALID_CHECKSUM;
    // decodeUnsafe return undefined if decoding fail
    let decoded = (0, (/*@__PURE__*/$parcel$interopDefault($f6c042d01dfc9475$exports))).decodeUnsafe(value);
    if (!decoded) return $6ed3c564aba0f912$export$f9bf9a3c544b4010.INVALID_CHECKSUM;
    decoded = decoded.slice($6ed3c564aba0f912$export$82e9f45cca5ba907[prefixKey].length);
    if (decoded.length !== $6ed3c564aba0f912$export$2a5ba4495636ee46[prefixKey]) return $6ed3c564aba0f912$export$f9bf9a3c544b4010.INVALID_LENGTH;
    return $6ed3c564aba0f912$export$f9bf9a3c544b4010.VALID;
}
const $6ed3c564aba0f912$var$implicitPrefix = [
    $6ed3c564aba0f912$export$e77cfe0b08ec163.TZ1,
    $6ed3c564aba0f912$export$e77cfe0b08ec163.TZ2,
    $6ed3c564aba0f912$export$e77cfe0b08ec163.TZ3,
    $6ed3c564aba0f912$export$e77cfe0b08ec163.TZ4
];
const $6ed3c564aba0f912$var$contractPrefix = [
    $6ed3c564aba0f912$export$e77cfe0b08ec163.KT1
];
const $6ed3c564aba0f912$var$signaturePrefix = [
    $6ed3c564aba0f912$export$e77cfe0b08ec163.EDSIG,
    $6ed3c564aba0f912$export$e77cfe0b08ec163.P2SIG,
    $6ed3c564aba0f912$export$e77cfe0b08ec163.SPSIG,
    $6ed3c564aba0f912$export$e77cfe0b08ec163.SIG
];
const $6ed3c564aba0f912$var$pkPrefix = [
    $6ed3c564aba0f912$export$e77cfe0b08ec163.EDPK,
    $6ed3c564aba0f912$export$e77cfe0b08ec163.SPPK,
    $6ed3c564aba0f912$export$e77cfe0b08ec163.P2PK,
    $6ed3c564aba0f912$export$e77cfe0b08ec163.BLPK
];
const $6ed3c564aba0f912$var$operationPrefix = [
    $6ed3c564aba0f912$export$e77cfe0b08ec163.O
];
const $6ed3c564aba0f912$var$protocolPrefix = [
    $6ed3c564aba0f912$export$e77cfe0b08ec163.P
];
const $6ed3c564aba0f912$var$blockPrefix = [
    $6ed3c564aba0f912$export$e77cfe0b08ec163.B
];
const $6ed3c564aba0f912$var$smartRollupPrefix = [
    $6ed3c564aba0f912$export$e77cfe0b08ec163.SR1
];
/**
 * @description Used to check if an address or a contract address is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateAddress } from '@taquito/utils';
 * const pkh = 'tz1L9r8mWmRPndRhuvMCWESLGSVeFzQ9NAWx'
 * const validation = validateAddress(pkh)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $6ed3c564aba0f912$export$f78173835dcde49f(value) {
    return $6ed3c564aba0f912$var$validatePrefixedValue(value, [
        ...$6ed3c564aba0f912$var$implicitPrefix,
        ...$6ed3c564aba0f912$var$contractPrefix,
        ...$6ed3c564aba0f912$var$smartRollupPrefix
    ]);
}
/**
 * @description Used to check if a chain id is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateChain } from '@taquito/utils';
 * const chainId = 'NetXdQprcVkpaWU'
 * const validation = validateChain(chainId)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $6ed3c564aba0f912$export$cb16a5d2af893df6(value) {
    return $6ed3c564aba0f912$var$validatePrefixedValue(value, [
        $6ed3c564aba0f912$export$e77cfe0b08ec163.NET
    ]);
}
/**
 * @description Used to check if a contract address is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateContractAddress } from '@taquito/utils';
 * const contractAddress = 'KT1JVErLYTgtY8uGGZ4mso2npTSxqVLDRVbC'
 * const validation = validateContractAddress(contractAddress)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $6ed3c564aba0f912$export$2ed905adbd9a56f2(value) {
    return $6ed3c564aba0f912$var$validatePrefixedValue(value, $6ed3c564aba0f912$var$contractPrefix);
}
/**
 * @description Used to check if a key hash is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateKeyHash } from '@taquito/utils';
 * const keyHashWithoutPrefix = '1L9r8mWmRPndRhuvMCWESLGSVeFzQ9NAWx'
 * const validation = validateKeyHash(keyHashWithoutPrefix)
 * console.log(validation)
 * // This example return 0 which correspond to NO_PREFIX_MATCHED
 * ```
 */ function $6ed3c564aba0f912$export$dbd3afbe999d4c3d(value) {
    return $6ed3c564aba0f912$var$validatePrefixedValue(value, $6ed3c564aba0f912$var$implicitPrefix);
}
/**
 * @description Used to check if a signature is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateSignature } from '@taquito/utils';
 * const signature = 'edsigtkpiSSschcaCt9pUVrpNPf7TTcgvgDEDD6NCEHMy8NNQJCGnMfLZzYoQj74yLjo9wx6MPVV29CvVzgi7qEcEUok3k7AuMg'
 * const validation = validateSignature(signature)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $6ed3c564aba0f912$export$f680e6c2b3919edb(value) {
    return $6ed3c564aba0f912$var$validatePrefixedValue(value, $6ed3c564aba0f912$var$signaturePrefix);
}
/**
 * @description Used to check if a public key is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validatePublicKey } from '@taquito/utils';
 * const publicKey = 'edpkvS5QFv7KRGfa3b87gg9DBpxSm3NpSwnjhUjNBQrRUUR66F7C9g'
 * const validation = validatePublicKey(publicKey)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $6ed3c564aba0f912$export$7e268ff6bd252dc4(value) {
    return $6ed3c564aba0f912$var$validatePrefixedValue(value, $6ed3c564aba0f912$var$pkPrefix);
}
/**
 * @description Used to check if an operation hash is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateOperation } from '@taquito/utils';
 * const operationHash = 'oo6JPEAy8VuMRGaFuMmLNFFGdJgiaKfnmT1CpHJfKP3Ye5ZahiP'
 * const validation = validateOperation(operationHash)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $6ed3c564aba0f912$export$a92a48117d546c9(value) {
    return $6ed3c564aba0f912$var$validatePrefixedValue(value, $6ed3c564aba0f912$var$operationPrefix);
}
/**
 * @description Used to check if a protocol hash is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateProtocol } from '@taquito/utils';
 * const protocolHash = 'PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx'
 * const validation = validateProtocol(protocolHash)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $6ed3c564aba0f912$export$6090822dce1c45f9(value) {
    return $6ed3c564aba0f912$var$validatePrefixedValue(value, $6ed3c564aba0f912$var$protocolPrefix);
}
/**
 * @description Used to check if a block hash is valid.
 *
 * @returns
 * 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 * @example
 * ```
 * import { validateBlock } from '@taquito/utils';
 * const blockHash = 'PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx'
 * const validation = validateBlock(blockHash)
 * console.log(validation)
 * // This example return 3 which correspond to VALID
 * ```
 */ function $6ed3c564aba0f912$export$8a53803420cdc9be(value) {
    return $6ed3c564aba0f912$var$validatePrefixedValue(value, $6ed3c564aba0f912$var$blockPrefix);
}
/**
 * @description Used to check if a spending key is valid.
 * @returns 0 (NO_PREFIX_MATCHED), 1 (INVALID_CHECKSUM), 2 (INVALID_LENGTH) or 3 (VALID).
 *
 */ function $6ed3c564aba0f912$export$ac37c7680f9b1515(value) {
    return $6ed3c564aba0f912$var$validatePrefixedValue(value, [
        $6ed3c564aba0f912$export$e77cfe0b08ec163.SASK
    ]);
}
function $6ed3c564aba0f912$export$a2057601792df650(validation) {
    switch(validation){
        case $6ed3c564aba0f912$export$f9bf9a3c544b4010.NO_PREFIX_MATCHED:
            return 'with unsupported prefix';
        case $6ed3c564aba0f912$export$f9bf9a3c544b4010.INVALID_CHECKSUM:
            return 'failed checksum';
        case $6ed3c564aba0f912$export$f9bf9a3c544b4010.INVALID_LENGTH:
            return 'with incorrect length';
        default:
            return '';
    }
}
function $6ed3c564aba0f912$export$9fbea988cfe61232(value) {
    return $6ed3c564aba0f912$var$validatePrefixedValue(value, [
        ...$6ed3c564aba0f912$var$smartRollupPrefix
    ]);
}
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $6ed3c564aba0f912$export$a4ad2735b021c132 = {
    "commitHash": "6a2c52b9e48b299dfc856149c1fa3388e77180ad",
    "version": "22.0.0"
};
const $6ed3c564aba0f912$var$TZ_DECIMALS = 6;
const $6ed3c564aba0f912$var$MTZ_DECIMALS = 3;
function $6ed3c564aba0f912$var$getDecimal(format) {
    switch(format){
        case 'tz':
            return $6ed3c564aba0f912$var$TZ_DECIMALS;
        case 'mtz':
            return $6ed3c564aba0f912$var$MTZ_DECIMALS;
        case 'mutez':
        default:
            return 0;
    }
}
function $6ed3c564aba0f912$export$d9468344d3651243(from = 'mutez', to = 'mutez', amount) {
    const bigNum = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(amount);
    if (bigNum.isNaN()) return amount;
    return bigNum.multipliedBy(Math.pow(10, $6ed3c564aba0f912$var$getDecimal(from))).dividedBy(Math.pow(10, $6ed3c564aba0f912$var$getDecimal(to)));
}
/**
 * @packageDocumentation
 * @module @taquito/utils
 */ /*
 * Some code in this file is originally from sotez and eztz
 * Copyright (c) 2018 Andrew Kishino
 * Copyright (c) 2017 Stephen Andrews
 */ /**
 *
 * @description Hash a string using the BLAKE2b algorithm, base58 encode the hash obtained and appends the prefix 'expr' to it
 *
 * @param value Value in hex
 */ function $6ed3c564aba0f912$export$8069b2d054f1e0a(value) {
    const blakeHash = (0, (/*@__PURE__*/$parcel$interopDefault($c8d6b1f140f0b27a$exports))).blake2b($6ed3c564aba0f912$export$80feccbc0acd4657(value), undefined, 32);
    return $6ed3c564aba0f912$export$8ff626c40517d3d3(blakeHash, $6ed3c564aba0f912$export$82e9f45cca5ba907['expr']);
}
/**
 *
 * @description Return the operation hash of a signed operation
 * @param value Value in hex of a signed operation
 */ function $6ed3c564aba0f912$export$376bc9d4074c78c9(value) {
    const blakeHash = (0, (/*@__PURE__*/$parcel$interopDefault($c8d6b1f140f0b27a$exports))).blake2b($6ed3c564aba0f912$export$80feccbc0acd4657(value), undefined, 32);
    return $6ed3c564aba0f912$export$8ff626c40517d3d3(blakeHash, $6ed3c564aba0f912$export$82e9f45cca5ba907.o);
}
/**
 *
 * @description Base58 encode a string or a Uint8Array and append a prefix to it
 *
 * @param value Value to base58 encode
 * @param prefix prefix to append to the encoded string
 */ function $6ed3c564aba0f912$export$8ff626c40517d3d3(value, prefix) {
    const payloadAr = typeof value === 'string' ? Uint8Array.from((0, $6ZWSX.Buffer).from(value, 'hex')) : value;
    const n = new Uint8Array(prefix.length + payloadAr.length);
    n.set(prefix);
    n.set(payloadAr, prefix.length);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f6c042d01dfc9475$exports))).encode((0, $6ZWSX.Buffer).from(n.buffer));
}
/**
 *
 * @description Base58 decode a string and remove the prefix from it
 *
 * @param value Value to base58 decode
 * @param prefix prefix to remove from the decoded string
 */ const $6ed3c564aba0f912$export$b9856b5e6fd1a05f = (enc, prefixArg)=>(0, (/*@__PURE__*/$parcel$interopDefault($f6c042d01dfc9475$exports))).decode(enc).slice(prefixArg.length);
/**
 *
 * @description Base58 decode a string with predefined prefix
 *
 * @param value Value to base58 decode
 */ function $6ed3c564aba0f912$export$c5fd02d48c871a17(payload) {
    const buf = (0, (/*@__PURE__*/$parcel$interopDefault($f6c042d01dfc9475$exports))).decode(payload);
    const prefixMap = {
        [$6ed3c564aba0f912$export$82e9f45cca5ba907.tz1.toString()]: '0000',
        [$6ed3c564aba0f912$export$82e9f45cca5ba907.tz2.toString()]: '0001',
        [$6ed3c564aba0f912$export$82e9f45cca5ba907.tz3.toString()]: '0002',
        [$6ed3c564aba0f912$export$82e9f45cca5ba907.tz4.toString()]: '0003'
    };
    const pref = prefixMap[new Uint8Array(buf.slice(0, 3)).toString()];
    if (pref) {
        // tz addresses
        const hex = $6ed3c564aba0f912$export$b0491dd0626f8a03(buf.slice(3));
        return pref + hex;
    } else // other (kt addresses)
    return '01' + $6ed3c564aba0f912$export$b0491dd0626f8a03(buf.slice(3, 42)) + '00';
}
/**
 *
 * @description b58 decode a string without predefined prefix
 * @param value
 * @returns string of bytes
 * @deprecated use b58decode instead
 */ function $6ed3c564aba0f912$export$9a7f049521ad14d8(payload) {
    const buf = (0, (/*@__PURE__*/$parcel$interopDefault($f6c042d01dfc9475$exports))).decode(payload);
    // tz4 address currently
    return $6ed3c564aba0f912$export$b0491dd0626f8a03(buf.slice(3, 42));
}
/**
 *
 * @description Base58 encode an address using predefined prefix
 *
 * @param value Address to base58 encode (tz1, tz2, tz3 or KT1)
 * @deprecated use encodeAddress instead, same functionality with a more descriptive name
 */ function $6ed3c564aba0f912$export$e56436d18a720ec1(value) {
    if (value.substring(0, 2) === '00') {
        const pref = {
            '0000': $6ed3c564aba0f912$export$82e9f45cca5ba907.tz1,
            '0001': $6ed3c564aba0f912$export$82e9f45cca5ba907.tz2,
            '0002': $6ed3c564aba0f912$export$82e9f45cca5ba907.tz3,
            '0003': $6ed3c564aba0f912$export$82e9f45cca5ba907.tz4
        };
        return $6ed3c564aba0f912$export$8ff626c40517d3d3(value.substring(4), pref[value.substring(0, 4)]);
    }
    return $6ed3c564aba0f912$export$8ff626c40517d3d3(value.substring(2, 42), $6ed3c564aba0f912$export$82e9f45cca5ba907.KT);
}
/**
 *
 * @description Base58 encode an address using predefined prefix (tz1, tz2, tz3, or KT1 without annotation)
 *
 * @param value Address to base58 encode (tz1, tz2, tz3 or KT1). Supports value with or without '0x' prefix
 */ function $6ed3c564aba0f912$export$b149ba8ff44e4e70(value) {
    if (value.substring(0, 2) === '0x') value = value.slice(2);
    if (value.substring(0, 2) === '00') {
        const pref = {
            '0000': $6ed3c564aba0f912$export$82e9f45cca5ba907.tz1,
            '0001': $6ed3c564aba0f912$export$82e9f45cca5ba907.tz2,
            '0002': $6ed3c564aba0f912$export$82e9f45cca5ba907.tz3,
            '0003': $6ed3c564aba0f912$export$82e9f45cca5ba907.tz4
        };
        return $6ed3c564aba0f912$export$8ff626c40517d3d3(value.substring(4), pref[value.substring(0, 4)]);
    }
    return $6ed3c564aba0f912$export$8ff626c40517d3d3(value.substring(2, 42), $6ed3c564aba0f912$export$82e9f45cca5ba907.KT);
}
/**
 *
 * @description Base58 encode an address without predefined prefix
 * @param value Address to base58 encode (tz4) hex dec
 * @returns return address
 * @deprecated use encodeAddress instead
 */ function $6ed3c564aba0f912$export$205862d7f4889ee4(value) {
    return $6ed3c564aba0f912$export$8ff626c40517d3d3(value, $6ed3c564aba0f912$export$82e9f45cca5ba907.tz4);
}
/**
 *
 * @description Base58 encode a key according to its prefix
 *
 * @param value Key to base58 encode
 */ function $6ed3c564aba0f912$export$a0511d6cbab6225d(value) {
    if (value[0] === '0') {
        const pref = {
            '00': new Uint8Array([
                13,
                15,
                37,
                217
            ]),
            '01': new Uint8Array([
                3,
                254,
                226,
                86
            ]),
            '02': new Uint8Array([
                3,
                178,
                139,
                127
            ])
        };
        return $6ed3c564aba0f912$export$8ff626c40517d3d3(value.substring(2), pref[value.substring(0, 2)]);
    }
}
/**
 *
 * @description Base58 encode a key hash according to its prefix
 *
 * @param value Key hash to base58 encode
 */ function $6ed3c564aba0f912$export$1ef834a164cef85e(value) {
    if (value[0] === '0') {
        const pref = {
            '00': new Uint8Array([
                6,
                161,
                159
            ]),
            '01': new Uint8Array([
                6,
                161,
                161
            ]),
            '02': new Uint8Array([
                6,
                161,
                164
            ]),
            '03': new Uint8Array([
                6,
                161,
                167
            ])
        };
        return $6ed3c564aba0f912$export$8ff626c40517d3d3(value.substring(2), pref[value.substring(0, 2)]);
    }
}
/**
 *
 * @description Convert an hex string to a Uint8Array
 *
 * @param hex Hex string to convert
 * @throws {@link ValueConversionError}
 */ const $6ed3c564aba0f912$export$80feccbc0acd4657 = (hex)=>{
    if (hex.length % 2 !== 0) throw new (0, $c34ebaa6f129c2ed$export$1888d6928c74d5ee)(hex, `: Expecting even number of characters`);
    const hexDigits = $6ed3c564aba0f912$export$b2f5d0058897e6e6(hex);
    if (!hexDigits.match(/^([\da-f]{2})*$/gi)) throw new (0, $c34ebaa6f129c2ed$export$1888d6928c74d5ee)(hex, `: Only characters 0-9, a-f and A-F are expected. Optionally, it can be prefixed with '0x'`);
    const out = new Uint8Array(hexDigits.length / 2);
    let j = 0;
    for(let i = 0; i < hexDigits.length; i += 2){
        const v = parseInt(hexDigits.slice(i, i + 2), 16);
        if (Number.isNaN(v)) throw new $6ed3c564aba0f912$export$ec375d495b3854fb(hex, 'Uint8Array');
        out[j++] = v;
    }
    return out;
};
/**
 *
 * @description Merge 2 buffers together
 *
 * @param b1 First buffer
 * @param b2 Second buffer
 */ const $6ed3c564aba0f912$export$196099622a18a454 = (b1, b2)=>{
    const r = new Uint8Array(b1.length + b2.length);
    r.set(b1);
    r.set(b2, b1.length);
    return r;
};
/**
 *
 * @description Flatten a michelson json representation to an array
 *
 * @param s michelson json
 */ const $6ed3c564aba0f912$export$b9f9ab98e553df31 = function me2(s) {
    let ret = [];
    if (Object.prototype.hasOwnProperty.call(s, 'prim')) {
        if (s.prim === 'Pair') {
            ret.push(me2(s.args[0]));
            ret = ret.concat(me2(s.args[1]));
        } else if (s.prim === 'Elt') ret = {
            key: me2(s.args[0]),
            val: me2(s.args[1])
        };
        else if (s.prim === 'True') ret = true;
        else if (s.prim === 'False') ret = false;
    } else if (Array.isArray(s)) {
        const sc = s.length;
        for(let i = 0; i < sc; i++){
            const n = me2(s[i]);
            if (typeof n.key !== 'undefined') {
                if (Array.isArray(ret)) ret = {
                    keys: [],
                    vals: []
                };
                ret.keys.push(n.key);
                ret.vals.push(n.val);
            } else ret.push(n);
        }
    } else if (Object.prototype.hasOwnProperty.call(s, 'string')) ret = s.string;
    else if (Object.prototype.hasOwnProperty.call(s, 'int')) ret = parseInt(s.int, 10);
    else ret = s;
    return ret;
};
/**
 *
 * @description Convert a Uint8Array to an hex string
 *
 * @param buffer Uint8Array to convert
 */ const $6ed3c564aba0f912$export$b0491dd0626f8a03 = (buffer)=>{
    const hexParts = [];
    buffer.forEach((byte)=>{
        const hex = byte.toString(16);
        const paddedHex = `00${hex}`.slice(-2);
        hexParts.push(paddedHex);
    });
    return hexParts.join('');
};
/**
 *
 *  @description Gets Tezos address (PKH) from Public Key
 *
 *  @param publicKey Public Key
 *  @returns A string of the Tezos address (PKH) that was derived from the given Public Key
 */ const $6ed3c564aba0f912$export$7d56ebd247473b77 = (publicKey)=>{
    let encodingPrefix;
    let prefixLen;
    const keyPrefix = $6ed3c564aba0f912$export$2fc642945002cd1a(publicKey);
    const decoded = $6ed3c564aba0f912$export$b9856b5e6fd1a05f(publicKey, $6ed3c564aba0f912$export$82e9f45cca5ba907[keyPrefix]);
    switch(keyPrefix){
        case $6ed3c564aba0f912$export$e77cfe0b08ec163.EDPK:
            encodingPrefix = $6ed3c564aba0f912$export$82e9f45cca5ba907[$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ1];
            prefixLen = $6ed3c564aba0f912$export$2a5ba4495636ee46[$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ1];
            break;
        case $6ed3c564aba0f912$export$e77cfe0b08ec163.SPPK:
            encodingPrefix = $6ed3c564aba0f912$export$82e9f45cca5ba907[$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ2];
            prefixLen = $6ed3c564aba0f912$export$2a5ba4495636ee46[$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ2];
            break;
        case $6ed3c564aba0f912$export$e77cfe0b08ec163.P2PK:
            encodingPrefix = $6ed3c564aba0f912$export$82e9f45cca5ba907[$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ3];
            prefixLen = $6ed3c564aba0f912$export$2a5ba4495636ee46[$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ3];
            break;
        case $6ed3c564aba0f912$export$e77cfe0b08ec163.BLPK:
            encodingPrefix = $6ed3c564aba0f912$export$82e9f45cca5ba907[$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ4];
            prefixLen = $6ed3c564aba0f912$export$2a5ba4495636ee46[$6ed3c564aba0f912$export$e77cfe0b08ec163.TZ4];
    }
    const hashed = (0, $8f4015cf8a40b3fc$exports.hash)(decoded, prefixLen);
    const result = $6ed3c564aba0f912$export$8ff626c40517d3d3(hashed, encodingPrefix);
    return result;
};
/**
 *
 * @description Convert a string to bytes
 *
 * @param str String to convert
 * @deprecated use stringToBytes instead, same functionality with a more descriptive name
 */ function $6ed3c564aba0f912$export$ccee8129914e4ca9(str) {
    return (0, $6ZWSX.Buffer).from(str, 'utf8').toString('hex');
}
/**
 *
 * @description Convert a string to a byte string representation
 *
 * @param str String to convert
 */ function $6ed3c564aba0f912$export$c8dd6bc66a63753c(str) {
    return (0, $6ZWSX.Buffer).from(str, 'utf8').toString('hex');
}
/**
 *
 * @description Convert bytes to a string
 *
 * @param str Bytes to convert
 * @deprecated use hexStringToBytes instead, same functionality with a more descriptive name
 */ function $6ed3c564aba0f912$export$a3e285b44709418b(hex) {
    return (0, $6ZWSX.Buffer).from($6ed3c564aba0f912$export$80feccbc0acd4657(hex)).toString('utf8');
}
/**
 *
 * @description Convert byte string representation to string
 *
 * @param str byte string to convert
 */ function $6ed3c564aba0f912$export$7c746b75f47c9c7d(hex) {
    return (0, $6ZWSX.Buffer).from($6ed3c564aba0f912$export$80feccbc0acd4657(hex)).toString('utf8');
}
/**
 *
 * @description Convert hex string/UintArray/Buffer to bytes
 *
 * @param hex String value to convert to bytes
 */ function $6ed3c564aba0f912$export$865538231a1956e8(hex) {
    const hexDigits = $6ed3c564aba0f912$export$b2f5d0058897e6e6(hex);
    if (!hexDigits.match(/^(0x)?([\da-f]{2})*$/gi)) throw new (0, $c34ebaa6f129c2ed$export$1888d6928c74d5ee)(hex, `: Expecting even number of characters: 0-9, a-z, A-Z, optionally prefixed with 0x`);
    return (0, $6ZWSX.Buffer).from(hexDigits, 'hex');
}
/**
 *
 * @description Converts a number or Bignumber to hexadecimal  string
 *
 * @param val The value  that will be converted to a hexadecimal string value
 */ function $6ed3c564aba0f912$export$80dcf81a50eb2909(val, bitLength = 8) {
    return (0, $6ZWSX.Buffer).from($6ed3c564aba0f912$export$a992125d2f1448ce(val, bitLength), 'hex');
}
function $6ed3c564aba0f912$export$3e269bbf0f7d8bcd(val, bitLength = 8) {
    return (0, $6ZWSX.Buffer).from($6ed3c564aba0f912$export$a992125d2f1448ce(val, bitLength), 'hex');
}
/**
 *
 * @description Converts a number or BigNumber to a padded hexadecimal string
 * @param val The value that will be converted into a padded hexadecimal string value
 * @param bitLength The length of bits
 *
 */ function $6ed3c564aba0f912$export$a992125d2f1448ce(val, bitLength = 8) {
    if (new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).isPositive()) {
        const nibbleLength = Math.ceil(bitLength / 4);
        const hex = val.toString(16);
        // check whether nibble (4 bits) length is higher or lower than the current hex string length
        let targetLength = hex.length >= nibbleLength ? hex.length : nibbleLength;
        // make sure the hex string target length is even
        targetLength = targetLength % 2 == 0 ? targetLength : targetLength + 1;
        return $6ed3c564aba0f912$var$padHexWithZero(hex, targetLength);
    } else {
        const twosCompliment = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(2).pow(bitLength).minus(new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).abs());
        return twosCompliment.toString(16);
    }
}
function $6ed3c564aba0f912$var$padHexWithZero(hex, targetLength) {
    const padString = '0';
    if (hex.length >= targetLength) return hex;
    else {
        const padLength = targetLength - hex.length;
        return padString.repeat(padLength) + hex;
    }
}
/**
 *
 * @description Strips the first 2 characters of a hex string (0x)
 *
 * @param hex string to strip prefix from
 */ function $6ed3c564aba0f912$export$b2f5d0058897e6e6(hex) {
    return hex.startsWith('0x') ? hex.slice(2) : hex;
}


// ==========================================================================================
// parent error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Parent error class all taquito errors to extend from
 */ class $dc90d6af72bbfdd0$export$e5619b407b1c8b0a extends Error {
}
/**
 *  @category Error
 *  @description Error that indicates invalid user inputs
 */ class $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 extends $dc90d6af72bbfdd0$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error returned by RPC node
 */ class $dc90d6af72bbfdd0$export$5460eff990f31920 extends $dc90d6af72bbfdd0$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates TezosToolKit has not been configured appropriately
 */ class $dc90d6af72bbfdd0$export$32f4d70b2fb302b1 extends $dc90d6af72bbfdd0$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates a requested action is not supported by Taquito
 */ class $dc90d6af72bbfdd0$export$34bc216509d47ce6 extends $dc90d6af72bbfdd0$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error during a network operation
 */ class $dc90d6af72bbfdd0$export$bae979e68e4dc802 extends $dc90d6af72bbfdd0$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates user attempts an action without necessary permissions
 */ class $dc90d6af72bbfdd0$export$9c81d48c1e1840ac extends $dc90d6af72bbfdd0$export$e5619b407b1c8b0a {
}
// ==========================================================================================
// common error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Error that indicates an invalid originated or implicit address being passed or used
 */ class $dc90d6af72bbfdd0$export$66c44d927ffead98 extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidAddressError';
        this.message = `Invalid address "${address}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
class $dc90d6af72bbfdd0$export$be6cb9338b7137e0 extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidStakingAddressError';
        this.message = `Invalid staking address "${address}", you can only set destination as your own address`;
    }
}
class $dc90d6af72bbfdd0$export$1623a856d8b6cc2a extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidFinalizeUnstakeAmountError';
        this.message = `The amount can only be 0 when finalizing an unstake`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid block hash being passed or used
 */ class $dc90d6af72bbfdd0$export$16fabd343bcdfd7b extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(blockHash, errorDetail){
        super();
        this.blockHash = blockHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidBlockHashError';
        this.message = `Invalid block hash "${blockHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid amount of tez being passed as a parameter
 */ class $dc90d6af72bbfdd0$export$d8bf6d22cce8e288 extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(amount){
        super();
        this.amount = amount;
        this.name = 'InvalidAmountError';
        this.message = `Invalid amount "${amount}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid derivation path being passed or used
 */ class $dc90d6af72bbfdd0$export$522ca3df7030c309 extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(derivationPath, errorDetail){
        super();
        this.derivationPath = derivationPath;
        this.errorDetail = errorDetail;
        this.name = 'InvalidDerivationPathError';
        this.message = `Invalid derivation path "${derivationPath}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid hex string have been passed or used
 */ class $dc90d6af72bbfdd0$export$1888d6928c74d5ee extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(hexString, errorDetail){
        super();
        this.hexString = hexString;
        this.errorDetail = errorDetail;
        this.name = 'InvalidHexStringError';
        this.message = `Invalid hex string "${hexString}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid message being passed or used
 */ class $dc90d6af72bbfdd0$export$a5124d7665e9d8ad extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(msg, errorDetail){
        super();
        this.msg = msg;
        this.errorDetail = errorDetail;
        this.name = 'InvalidMessageError';
        this.message = `Invalid message "${msg}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid view parameter of a smart contract
 */ class $dc90d6af72bbfdd0$export$f9ce6a924724628b extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(viewName, sigs, args, cause){
        super();
        this.viewName = viewName;
        this.sigs = sigs;
        this.args = args;
        this.cause = cause;
        this.name = 'InvalidViewParameterError';
        this.message = `Invalid view arguments ${JSON.stringify(args)} received for name "${viewName}" expecting one of the following signatures ${JSON.stringify(sigs)}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid private key being passed or used
 */ class $dc90d6af72bbfdd0$export$adf223add86ae0aa extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(errorDetail){
        super();
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyError';
        this.message = `Invalid private key`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an Invalid Public Key being passed or used
 */ class $dc90d6af72bbfdd0$export$f675822ed489f01f extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(publicKey, errorDetail){
        super();
        this.publicKey = publicKey;
        this.errorDetail = errorDetail;
        this.name = 'InvalidPublicKeyError';
        this.message = `Invalid public key "${publicKey}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid signature being passed or used
 */ class $dc90d6af72bbfdd0$export$ccc2f68ef106615a extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(signature, errorDetail){
        super();
        this.signature = signature;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSignatureError';
        this.message = `Invalid signature "${signature}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid contract address being passed or used
 */ class $dc90d6af72bbfdd0$export$193774326795229b extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(contractAddress, errorDetail){
        super();
        this.contractAddress = contractAddress;
        this.errorDetail = errorDetail;
        this.name = 'InvalidContractAddressError';
        this.message = `Invalid contract address "${contractAddress}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid chain id being passed or used
 */ class $dc90d6af72bbfdd0$export$4836eb835ffca5b2 extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(chainId, errorDetail){
        super();
        this.chainId = chainId;
        this.errorDetail = errorDetail;
        this.name = 'InvalidChainIdError';
        this.message = `Invalid chain id "${chainId}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid public key hash being passed or used
 */ class $dc90d6af72bbfdd0$export$a3d7df0ca9d9410c extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(keyHash, errorDetail){
        super();
        this.keyHash = keyHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyHashError';
        this.message = `Invalid public key hash "${keyHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation hash being passed or used
 */ class $dc90d6af72bbfdd0$export$1a1c2023d3ec7a8a extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(operationHash, errorDetail){
        super();
        this.operationHash = operationHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationHashError';
        this.message = `Invalid operation hash "${operationHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation kind being passed or used
 */ class $dc90d6af72bbfdd0$export$bc5be87550569b55 extends $dc90d6af72bbfdd0$export$9d3f3bc8b6d48950 {
    constructor(operationKind, errorDetail){
        super();
        this.operationKind = operationKind;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationKindError';
        this.message = `Invalid operation kind "${operationKind}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description General error that indicates something is no longer supported and/or deprecated
 */ class $dc90d6af72bbfdd0$export$11034991807c583d extends $dc90d6af72bbfdd0$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'DeprecationError';
    }
}
/**
 *  @category Error
 *  @description General error that indicates an action is prohibited or not allowed
 */ class $dc90d6af72bbfdd0$export$4041d915d9096adf extends $dc90d6af72bbfdd0$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ProhibitedActionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure in grabbing the public key
 */ class $dc90d6af72bbfdd0$export$183b043cd3c947f9 extends $dc90d6af72bbfdd0$export$e5619b407b1c8b0a {
    constructor(pkh, cause){
        super();
        this.pkh = pkh;
        this.cause = cause;
        this.name = 'PublicKeyNotFoundError';
        this.message = `Public key not found of this address "${pkh}" in either wallet or contract API.`;
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $f93002942e85739a$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f93002942e85739a$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
const $f93002942e85739a$export$df531a306ef6bb82 = 'main';
const $f93002942e85739a$export$20a0ad8102085d6c = {
    block: 'head'
};
var $f93002942e85739a$var$RPCMethodName;
(function(RPCMethodName) {
    RPCMethodName["GET_BAKING_RIGHTS"] = "getBakingRights";
    RPCMethodName["GET_BALLOTS"] = "getBallots";
    RPCMethodName["GET_BALLOT_LIST"] = "getBallotList";
    RPCMethodName["GET_BIG_MAP_KEY"] = "getBigMapKey";
    RPCMethodName["GET_BIG_MAP_EXPR"] = "getBigMapExpr";
    RPCMethodName["GET_BLOCK_HASH"] = "getBlockHash";
    RPCMethodName["GET_BLOCK"] = "getBlock";
    RPCMethodName["GET_BLOCK_HEADER"] = "getBlockHeader";
    RPCMethodName["GET_BLOCK_METADATA"] = "getBlockMetadata";
    RPCMethodName["GET_BALANCE"] = "getBalance";
    RPCMethodName["GET_SPENDABLE"] = "getSpendable";
    RPCMethodName["GET_BALANCE_AND_FROZEN_BONDS"] = "getBalanceAndFrozenBonds";
    RPCMethodName["GET_SPENDABLE_AND_FROZEN_BONDS"] = "getSpendableAndFrozenBonds";
    RPCMethodName["GET_FULL_BALANCE"] = "getFullBalance";
    RPCMethodName["GET_STAKED_BALANCE"] = "getStakedBalance";
    RPCMethodName["GET_UNSTAKED_FINALIZABLE_BALANCE"] = "getUnstakedFinalizableBalance";
    RPCMethodName["GET_UNSTAKED_FROZEN_BALANCE"] = "getUnstakedFrozenBalance";
    RPCMethodName["GET_UNSTAKE_REQUESTS"] = "getUnstakeRequests";
    RPCMethodName["GET_CHAIN_ID"] = "getChainId";
    RPCMethodName["GET_CONSTANTS"] = "getConstants";
    RPCMethodName["GET_CONTRACT"] = "getContract";
    RPCMethodName["GET_CURRENT_PERIOD"] = "getCurrentPeriod";
    RPCMethodName["GET_CURRENT_PROPOSAL"] = "getCurrentProposal";
    RPCMethodName["GET_CURRENT_QUORUM"] = "getCurrentQuorum";
    RPCMethodName["GET_DELEGATE"] = "getDelegate";
    RPCMethodName["GET_ALL_DELEGATES"] = "getAllDelegates";
    RPCMethodName["GET_DELEGATES"] = "getDelegates";
    RPCMethodName["GET_VOTING_INFO"] = "getVotingInfo";
    RPCMethodName["GET_ATTESTATION_RIGHTS"] = "getAttestationRights";
    RPCMethodName["GET_ENTRYPOINTS"] = "getEntrypoints";
    RPCMethodName["GET_LIVE_BLOCKS"] = "getLiveBlocks";
    RPCMethodName["GET_MANAGER_KEY"] = "getManagerKey";
    RPCMethodName["GET_NORMALIZED_SCRIPT"] = "getNormalizedScript";
    RPCMethodName["GET_PROPOSALS"] = "getProposals";
    RPCMethodName["GET_PROTOCOLS"] = "getProtocols";
    RPCMethodName["GET_SAPLING_DIFF_BY_CONTRACT"] = "getSaplingDiffByContract";
    RPCMethodName["GET_PROTOCOL_ACTIVATIONS"] = "getProtocolActivations";
    RPCMethodName["GET_SAPLING_DIFF_BY_ID"] = "getSaplingDiffById";
    RPCMethodName["GET_SCRIPT"] = "getScript";
    RPCMethodName["GET_STORAGE"] = "getStorage";
    RPCMethodName["GET_SUCCESSOR_PERIOD"] = "getSuccessorPeriod";
    RPCMethodName["GET_VOTES_LISTINGS"] = "getVotesListings";
    RPCMethodName["PACK_DATA"] = "packData";
    RPCMethodName["GET_STORAGE_USED_SPACE"] = "getStorageUsedSpace";
    RPCMethodName["GET_STORAGE_PAID_SPACE"] = "getStoragePaidSpace";
    RPCMethodName["GET_TICKET_BALANCE"] = "getTicketBalance";
    RPCMethodName["GET_ALL_TICKET_BALANCES"] = "getAllTicketBalances";
    RPCMethodName["GET_ADAPTIVE_ISSUANCE_LAUNCH_CYCLE"] = "getAdaptiveIssuanceLaunchCycle";
    RPCMethodName["GET_PENDING_OPERATIONS"] = "getPendingOperations";
})($f93002942e85739a$var$RPCMethodName || ($f93002942e85739a$var$RPCMethodName = {}));
/**
 * Casts object/array items to BigNumber
 * @param data input object or array
 * @param keys keys for processing or all items if not defined
 *
 */ function $f93002942e85739a$export$ef5b1cb6f241eca7(data, keys) {
    const returnArray = Array.isArray(data);
    if (typeof keys === 'undefined') keys = Object.keys(data);
    const response = returnArray ? [] : {};
    keys.forEach((key)=>{
        const item = data[key];
        let res;
        if (typeof item === 'undefined') return;
        if (Array.isArray(item)) {
            res = $f93002942e85739a$export$ef5b1cb6f241eca7(item);
            response[key] = res;
            return;
        }
        res = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(item);
        response[key] = res;
    });
    return response;
}
const $f93002942e85739a$var$defaultTtl = 1000;
/***
 * @description RpcClientCache acts as a decorator over the RpcClient instance by caching responses for the period defined by the ttl.
 */ class $f93002942e85739a$export$696832b05866dc5e {
    /**
     *
     * @param rpcClient rpcClient responsible of the interaction with Tezos network through an rpc node
     * @param ttl number representing the time to live (default 1000 milliseconds)
     *
     * @example new RpcClientCache(new RpcClient('https://mainnet.tezos.ecadinfra.com/'))
     */ constructor(rpcClient, ttl = $f93002942e85739a$var$defaultTtl){
        this.rpcClient = rpcClient;
        this.ttl = ttl;
        this._cache = {};
    }
    getAllCachedData() {
        return this._cache;
    }
    /**
     * @description Remove all the data in the cache.
     *
     */ deleteAllCachedData() {
        for(const key in this._cache)delete this._cache[key];
    }
    formatCacheKey(rpcUrl, rpcMethodName, rpcMethodParams, rpcMethodData) {
        let paramsToString = '';
        rpcMethodParams.forEach((param)=>{
            paramsToString = typeof param === 'object' ? paramsToString + JSON.stringify(param) + '/' : paramsToString + param + '/';
        });
        return rpcMethodData ? `${rpcUrl}/${rpcMethodName}/${paramsToString}${JSON.stringify(rpcMethodData)}/` : `${rpcUrl}/${rpcMethodName}/${paramsToString}`;
    }
    has(key) {
        return key in this._cache;
    }
    get(key) {
        return this._cache[key].response;
    }
    put(key, response) {
        const handle = setTimeout(()=>{
            return this.remove(key);
        }, this.ttl);
        Object.assign(this._cache, {
            [key]: {
                handle: handle,
                response: response
            }
        });
    }
    remove(key) {
        if (key in this._cache) delete this._cache[key];
    }
    validateAddress(address) {
        const addressValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(address);
        if (addressValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $dc90d6af72bbfdd0$export$66c44d927ffead98)(address, (0, $6ed3c564aba0f912$export$a2057601792df650)(addressValidation));
    }
    validateContract(address) {
        const addressValidation = (0, $6ed3c564aba0f912$export$2ed905adbd9a56f2)(address);
        if (addressValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $dc90d6af72bbfdd0$export$193774326795229b)(address, (0, $6ed3c564aba0f912$export$a2057601792df650)(addressValidation));
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Get the block's hash, its unique identifier.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-hash
     */ getBlockHash() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_BLOCK_HASH, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBlockHash({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List the ancestors of the given block which, if referred to as the branch in an operation header, are recent enough for that operation to be included in the current block.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-live-blocks
     */ getLiveBlocks() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_LIVE_BLOCKS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getLiveBlocks({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address address from which we want to retrieve the spendable balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The spendable balance of a contract (in mutez), also known as liquid balance. Corresponds to tez owned by the contract that are neither staked, nor in unstaked requests, nor in frozen bonds. Identical to the 'spendable' RPC.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-balance
     */ getBalance(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_BALANCE, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBalance(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address address from which we want to retrieve the balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The spendable balance of a contract (in mutez), also known as liquid balance. Corresponds to tez owned by the contract that are neither staked, nor in unstaked requests, nor in frozen bonds. Identical to the 'balance' RPC.
     */ getSpendable(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_SPENDABLE, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getSpendable(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address address from which we want to retrieve balance and frozen bonds
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The sum (in mutez) of the spendable balance and frozen bonds of a contract. Corresponds to the contract's full balance from which staked funds and unstake requests have been excluded. Identical to the 'spendable_and_frozen_bonds' RPC.
     */ getBalanceAndFrozenBonds(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_BALANCE_AND_FROZEN_BONDS, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBalanceAndFrozenBonds(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address address from which we want to retrieve spendable and frozen bonds
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The sum (in mutez) of the spendable balance and frozen bonds of a contract. Corresponds to the contract's full balance from which staked funds and unstake requests have been excluded. Identical to the 'balance_and_frozen_bonds' RPC.
     */ getSpendableAndFrozenBonds(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_SPENDABLE_AND_FROZEN_BONDS, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getSpendableAndFrozenBonds(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address address from which we want to retrieve the full balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the full balance of a contract, including frozen bonds and stake.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-full-balance
     */ getFullBalance(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_FULL_BALANCE, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getFullBalance(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address address from which we want to retrieve the staked balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the staked balance of a contract. Returns None if the contract is originated, or neither delegated nor a delegate.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-staked-balance
     */ getStakedBalance(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_STAKED_BALANCE, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getStakedBalance(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address address from which we want to retrieve the unstaked finalizable balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the balance of a contract that was requested for an unstake operation, and is no longer frozen, which means it will appear in the spendable balance of the contract after any stake/unstake/finalize_unstake operation. Returns None if the contract is originated.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-unstaked-finalizable-balance
     */ getUnstakedFinalizableBalance(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_UNSTAKED_FINALIZABLE_BALANCE, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getUnstakedFinalizableBalance(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address address from which we want to retrieve the unstaked frozen balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the balance of a contract that was requested for an unstake operation, but is still frozen for the duration of the slashing period. Returns None if the contract is originated.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-unstaked-frozen-balance
     */ getUnstakedFrozenBalance(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_UNSTAKED_FROZEN_BALANCE, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getUnstakedFrozenBalance(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address address from which we want to retrieve the unstake requests
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the unstake requests of the contract. The requests that appear in the finalizable field can be finalized, which means that the contract can transfer these (no longer frozen) funds to their spendable balance with a [finalize_unstake] operation call. Returns null if there is no unstake request pending.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-unstake-requests
     */ getUnstakeRequests(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_UNSTAKE_REQUESTS, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getUnstakeRequests(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve the storage
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the data of the contract.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-storage
     */ getStorage(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateContract(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_STORAGE, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getStorage(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve the script
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the code and data of the contract.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-script
     */ getScript(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateContract(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_SCRIPT, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getScript(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve the script
     * @param unparsingMode default is { unparsing_mode: "Readable" }
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the script of the contract and normalize it using the requested unparsing mode.
     */ getNormalizedScript(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, unparsingMode = {
            unparsing_mode: 'Readable'
        }, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateContract(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_NORMALIZED_SCRIPT, [
                block,
                address
            ], unparsingMode);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getNormalizedScript(address, unparsingMode, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the complete status of a contract.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id
     */ getContract(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_CONTRACT, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getContract(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve the manager
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the manager of an implicit contract
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-manager-key
     */ getManagerKey(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_MANAGER_KEY, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getManagerKey(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address contract address from which we want to retrieve the delegate (baker)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the delegate of a contract, if any
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-delegate
     */ getDelegate(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_DELEGATE, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getDelegate(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @deprecated Deprecated in favor of getBigMapKeyByID
     * @param address contract address from which we want to retrieve the big map key
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the value associated with a key in the big map storage of the contract.
     * @see https://tezos.gitlab.io/active/rpc.html#post-block-id-context-contracts-contract-id-big-map-get
     */ getBigMapKey(address_1, key_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, key, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const keyUrl = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_BIG_MAP_KEY, [
                block,
                address
            ], key);
            if (this.has(keyUrl)) return this.get(keyUrl);
            else {
                const response = this.rpcClient.getBigMapKey(address, key, {
                    block: block
                });
                this.put(keyUrl, response);
                return response;
            }
        });
    }
    /**
     * @param id Big Map ID
     * @param expr Expression hash to query (A b58check encoded Blake2b hash of the expression (The expression can be packed using the pack_data method))
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the value associated with a key in a big map.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-big-maps-big-map-id-script-expr
     */ getBigMapExpr(id_1, expr_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(id, expr, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_BIG_MAP_EXPR, [
                block,
                id,
                expr
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBigMapExpr(id, expr, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param args contains optional query arguments (active, inactive, with_minimal_stake, without_minimal_stake)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Lists all registered delegates by default with query arguments to filter unneeded values.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-delegates-pkh
     */ getAllDelegates() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(args = {}, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_ALL_DELEGATES, [
                block,
                args
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getAllDelegates(args, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address delegate address which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Everything about a delegate
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-delegates-pkh
     */ getDelegates(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_DELEGATES, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getDelegates(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param address delegate address which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the delegate info (e.g. voting power) found in the listings of the current voting period
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-delegates-pkh-voting-info
     */ getVotingInfo(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_VOTING_INFO, [
                block,
                address
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getVotingInfo(address, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description All constants
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-constants
     */ getConstants() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_CONSTANTS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getConstants({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head) and version.
     * @description All the information about a block
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id
     * @example getBlock() will default to `/main/chains/block/head?version=1`
     * @example getBlock({ block: 'head~2') will return an offset of 2 from head blocks
     * @example getBlock({ block: 'BL8fTiWcSxWCjiMVnDkbh6EuhqVPZzgWheJ2dqwrxYRm9AephXh~2' }) will return an offset of 2 blocks from given block hash..
     */ getBlock() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_BLOCK, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBlock({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The whole block header
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-header
     */ getBlockHeader() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_BLOCK_HEADER, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBlockHeader({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head) and version
     * @description All the metadata associated to the block
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-metadata
     */ getBlockMetadata() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_BLOCK_METADATA, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBlockMetadata({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param args contains optional query arguments (level, cycle, delegate, consensus_key, and max_round)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Retrieves the list of delegates allowed to bake a block.
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ getBakingRights() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(args = {}, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_BAKING_RIGHTS, [
                block,
                args
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBakingRights(args, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param args contains optional query arguments (level, cycle, delegate, and consensus_key)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Retrieves the delegates allowed to attest a block
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ getAttestationRights() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(args = {}, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_ATTESTATION_RIGHTS, [
                block,
                args
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getAttestationRights(args, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Ballots casted so far during a voting period
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-ballot-list
     */ getBallotList() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_BALLOT_LIST, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBallotList({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Sum of ballots casted so far during a voting period
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-ballots
     */ getBallots() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_BALLOTS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getBallots({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Current proposal under evaluation.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-current-proposal
     */ getCurrentProposal() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_CURRENT_PROPOSAL, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getCurrentProposal({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Current expected quorum.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-current-quorum
     */ getCurrentQuorum() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_CURRENT_QUORUM, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getCurrentQuorum({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List of delegates with their voting power
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-listings
     */ getVotesListings() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_VOTES_LISTINGS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getVotesListings({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List of proposals with number of supporters
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-proposals
     */ getProposals() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_PROPOSALS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getProposals({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param data operation contents to forge
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Forge an operation returning the unsigned bytes
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ forgeOperations(data_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(data, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.rpcClient.forgeOperations(data, {
                block: block
            });
        });
    }
    /**
     * @param signedOpBytes signed bytes to inject
     * @description Inject an operation in node and broadcast it and return the ID of the operation
     * @see https://tezos.gitlab.io/shell/rpc.html#post-injection-operation
     */ injectOperation(signedOpBytes) {
        return $f93002942e85739a$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpcClient.injectOperation(signedOpBytes);
        });
    }
    /**
     * @param ops Operations to apply
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Simulate the application of the operations with the context of the given block and return the result of each operation application
     * @see https://tezos.gitlab.io/active/rpc.html#post-block-id-helpers-preapply-operations
     */ preapplyOperations(ops_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(ops, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.rpcClient.preapplyOperations(ops, {
                block: block
            });
        });
    }
    /**
     * @param contract address of the contract we want to get the entrypoints of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Return the list of entrypoints of the contract
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-entrypoints
     * @version 005_PsBABY5H
     */ getEntrypoints(contract_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateContract(contract);
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_ENTRYPOINTS, [
                block,
                contract
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getEntrypoints(contract, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @deprecated Deprecated in favor of simulateOperation
     * @param op Operation to run
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Run an operation with the context of the given block and without signature checks and return the operation application result, including the consumed gas.
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ runOperation(op_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(op, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.rpcClient.runOperation(op, {
                block: block
            });
        });
    }
    /**
     * @param op Operation to simulate
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Simulate running an operation at some future moment (based on the number of blocks given in the `latency` argument), and return the operation application result.
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ simulateOperation(op_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(op, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.rpcClient.simulateOperation(op, {
                block: block
            });
        });
    }
    /**
     * @param code Code to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Run a Michelson script in the current context
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ runCode(code_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(code, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.rpcClient.runCode(code, {
                block: block
            });
        });
    }
    /**
     * @param viewScriptParams Parameters of the script view to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Simulate a call to a michelson view
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ runScriptView(_a, _b) {
        return $f93002942e85739a$var$__awaiter(this, void 0, void 0, function*() {
            var { unparsing_mode: unparsing_mode = 'Readable' } = _a, rest = $f93002942e85739a$var$__rest(_a, [
                "unparsing_mode"
            ]);
            var _c = _b === void 0 ? $f93002942e85739a$export$20a0ad8102085d6c : _b, block = _c.block;
            return this.rpcClient.runScriptView(Object.assign({
                unparsing_mode: unparsing_mode
            }, rest), {
                block: block
            });
        });
    }
    /**
     * @param viewParams Parameters of the view to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Simulate a call to a view following the TZIP-4 standard.
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ runView(_a, _b) {
        return $f93002942e85739a$var$__awaiter(this, void 0, void 0, function*() {
            var { unparsing_mode: unparsing_mode = 'Readable' } = _a, rest = $f93002942e85739a$var$__rest(_a, [
                "unparsing_mode"
            ]);
            var _c = _b === void 0 ? $f93002942e85739a$export$20a0ad8102085d6c : _b, block = _c.block;
            return this.rpcClient.runView(Object.assign({
                unparsing_mode: unparsing_mode
            }, rest), {
                block: block
            });
        });
    }
    getChainId() {
        return $f93002942e85739a$var$__awaiter(this, void 0, void 0, function*() {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_CHAIN_ID, []);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getChainId();
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param data Data to pack
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Computes the serialized version of a data expression using the same algorithm as script instruction PACK
     * Note: You should always verify the packed bytes before signing or requesting that they be signed when using the RPC to pack.
     * This precaution helps protect you and your applications users from RPC nodes that have been compromised.
     * A node that is operated by a bad actor, or compromised by a bad actor could return a fully formed operation that does not correspond to the input provided to the RPC endpoint.
     * A safer solution to pack and sign data would be to use the `packDataBytes` function available in the `@taquito/michel-codec` package.
     * @example packData({ data: { string: "test" }, type: { prim: "string" } })
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ packData(data_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(data, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.PACK_DATA, [
                block
            ], data);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.packData(data, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     *
     * @description Return rpc root url
     */ getRpcUrl() {
        return this.rpcClient.getRpcUrl();
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the voting period (index, kind, starting position) and related information (position, remaining) of the interrogated block
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-current-period
     */ getCurrentPeriod() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_CURRENT_PERIOD, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getCurrentPeriod({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the voting period (index, kind, starting position) and related information (position, remaining) of the next block.Useful to craft operations that will be valid in the next block
     * @example getSuccessorPeriod() will default to successor voting period for /main/chains/block/head.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-successor-period
     */ getSuccessorPeriod() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_SUCCESSOR_PERIOD, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getSuccessorPeriod({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param id Sapling state ID
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the root and a diff of a state starting from an optional offset which is zero by default
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-sapling-sapling-state-id-get-diff
     */ getSaplingDiffById(id_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(id, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_SAPLING_DIFF_BY_ID, [
                block,
                id
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getSaplingDiffById(id, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param contract address of the contract we want to get the sapling diff
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the root and a diff of a state starting from an optional offset which is zero by default
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-single-sapling-get-diff
     */ getSaplingDiffByContract(contract_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_SAPLING_DIFF_BY_CONTRACT, [
                block,
                contract
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getSaplingDiffByContract(contract, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description get current and next protocol
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-protocols
     */ getProtocols() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_PROTOCOLS, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getProtocols({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description get current and next protocol
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-protocols
     */ getProtocolActivations() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(protocol = '') {
            if (protocol) {
                const protocolValidation = (0, $6ed3c564aba0f912$export$6090822dce1c45f9)(protocol);
                if (protocolValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new Error(`Invalid protocol hash "${protocol}" ${(0, $6ed3c564aba0f912$export$a2057601792df650)(protocolValidation)}`);
            }
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_PROTOCOL_ACTIVATIONS, [
                protocol
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getProtocolActivations(protocol);
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param contract address of the contract we want to retrieve storage information of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the used storage space of the contract
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ getStorageUsedSpace(contract_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_STORAGE_USED_SPACE, [
                block,
                contract
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getStorageUsedSpace(contract, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param contract address of the contract we want to retrieve storage information of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
  =   * @description Access the paid storage space of the contract
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ getStoragePaidSpace(contract_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_STORAGE_PAID_SPACE, [
                block,
                contract
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getStoragePaidSpace(contract, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param contract implicit or originated address we want to retrieve ticket balance of
     * @param ticket object to specify a ticket by ticketer, content type and content
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the contract's balance of ticket with specified ticketer, content type, and content.
     * @example ticket { ticketer: 'address', content_type: { prim: "string" }, content: { string: 'ticket1' } }
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ getTicketBalance(contract_1, ticket_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, ticket, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_TICKET_BALANCE, [
                block,
                contract
            ], ticket);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getTicketBalance(contract, ticket, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @param contract originated address we want to retrieve ticket balances of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the complete list of tickets owned by the given contract by scanning the contract's storage.
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ getAllTicketBalances(contract_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_ALL_TICKET_BALANCES, [
                block,
                contract
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getAllTicketBalances(contract, {
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @description Returns the cycle at which the launch of the Adaptive Issuance feature is set to happen. A result of null means that the feature is not yet set to launch.
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-adaptive-issuance-launch-cycle
     */ getAdaptiveIssuanceLaunchCycle() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_ADAPTIVE_ISSUANCE_LAUNCH_CYCLE, [
                block
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getAdaptiveIssuanceLaunchCycle({
                    block: block
                });
                this.put(key, response);
                return response;
            }
        });
    }
    /**
     * @description List the prevalidated operations in mempool (accessibility of mempool depends on each rpc endpoint)
     * @param args has 5 optional properties
     * @default args { version: '2', validated: true, refused: true, outdated, true, branchRefused: true, branchDelayed: true, validationPass: undefined }
     */ getPendingOperations() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(args = {}) {
            const key = this.formatCacheKey(this.rpcClient.getRpcUrl(), $f93002942e85739a$var$RPCMethodName.GET_PENDING_OPERATIONS, [
                args
            ]);
            if (this.has(key)) return this.get(key);
            else {
                const response = this.rpcClient.getPendingOperations(args);
                this.put(key, response);
                return response;
            }
        });
    }
}
var $f93002942e85739a$export$b6b4c0fac32b8f7a;
(function(OPERATION_METADATA) {
    OPERATION_METADATA["TOO_LARGE"] = "too large";
})($f93002942e85739a$export$b6b4c0fac32b8f7a || ($f93002942e85739a$export$b6b4c0fac32b8f7a = {}));
var $f93002942e85739a$export$a9040e943c00f226;
(function(METADATA_BALANCE_UPDATES_CATEGORY) {
    METADATA_BALANCE_UPDATES_CATEGORY["BAKING_BONUSES"] = "baking bonuses";
    METADATA_BALANCE_UPDATES_CATEGORY["BAKING_REWARDS"] = "baking rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["BLOCK_FEES"] = "block fees";
    METADATA_BALANCE_UPDATES_CATEGORY["BONDS"] = "bonds";
    METADATA_BALANCE_UPDATES_CATEGORY["BOOTSTRAP"] = "bootstrap";
    METADATA_BALANCE_UPDATES_CATEGORY["BURNED"] = "burned";
    METADATA_BALANCE_UPDATES_CATEGORY["COMMITMENT"] = "commitment";
    METADATA_BALANCE_UPDATES_CATEGORY["DELEGATE_DENOMINATOR"] = "delegate_denominator";
    METADATA_BALANCE_UPDATES_CATEGORY["DELEGATOR_NUMERATOR"] = "delegator_numerator";
    METADATA_BALANCE_UPDATES_CATEGORY["DEPOSITS"] = "deposits";
    METADATA_BALANCE_UPDATES_CATEGORY["ENDORSING_REWARDS"] = "endorsing rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["INVOICE"] = "invoice";
    METADATA_BALANCE_UPDATES_CATEGORY["LOST_ENDORSING_REWARDS"] = "lost endorsing rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["LOST_ATTESTING_REWARDS"] = "lost attesting rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["MINTED"] = "minted";
    METADATA_BALANCE_UPDATES_CATEGORY["NONCE_REVELATION_REWARDS"] = "nonce revelation rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["PUNISHMENTS"] = "punishments";
    METADATA_BALANCE_UPDATES_CATEGORY["SMART_ROLLUP_REFUTATION_PUNISHMENTS"] = "smart_rollup_refutation_punishments";
    METADATA_BALANCE_UPDATES_CATEGORY["SMART_ROLLUP_REFUTATION_REWARDS"] = "smart_rollup_refutation_rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["STORAGE_FEES"] = "storage fees";
    METADATA_BALANCE_UPDATES_CATEGORY["SUBSIDY"] = "subsidy";
    METADATA_BALANCE_UPDATES_CATEGORY["UNSTAKED_DEPOSITS"] = "unstaked_deposits";
    METADATA_BALANCE_UPDATES_CATEGORY["DOUBLE_SIGNING_EVIDENCE_REWARDS"] = "double signing evidence rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["FEES"] = "fees";
    METADATA_BALANCE_UPDATES_CATEGORY["LEGACY_DEPOSITS"] = "legacy_deposits";
    METADATA_BALANCE_UPDATES_CATEGORY["LEGACY_FEES"] = "legacy_fees";
    METADATA_BALANCE_UPDATES_CATEGORY["LEGACY_REWARDS"] = "legacy_rewards";
    METADATA_BALANCE_UPDATES_CATEGORY["REWARDS"] = "rewards";
})($f93002942e85739a$export$a9040e943c00f226 || ($f93002942e85739a$export$a9040e943c00f226 = {}));
var $f93002942e85739a$export$2506b8b43ba71fde;
(function(PvmKind) {
    PvmKind["WASM2"] = "wasm_2_0_0";
    PvmKind["ARITH"] = "arith";
    PvmKind["RISCV"] = "riscv";
})($f93002942e85739a$export$2506b8b43ba71fde || ($f93002942e85739a$export$2506b8b43ba71fde = {}));
var $f93002942e85739a$export$c6a11810c2696976;
(function(SmartRollupRefutationOptions) {
    SmartRollupRefutationOptions["START"] = "start";
    SmartRollupRefutationOptions["MOVE"] = "move";
})($f93002942e85739a$export$c6a11810c2696976 || ($f93002942e85739a$export$c6a11810c2696976 = {}));
var $f93002942e85739a$export$91a9220bb843dc78;
(function(SmartRollupInputProofKind) {
    SmartRollupInputProofKind["INBOX_PROOF"] = "inbox_proof";
    SmartRollupInputProofKind["REVEAL_PROOF"] = "reveal_proof";
    SmartRollupInputProofKind["FIRST_INPUT"] = "first_input";
})($f93002942e85739a$export$91a9220bb843dc78 || ($f93002942e85739a$export$91a9220bb843dc78 = {}));
var $f93002942e85739a$export$6b51c844e2b0334d;
(function(SmartRollupRefuteRevealProofKind) {
    SmartRollupRefuteRevealProofKind["RAW_DATA_PROOF"] = "raw_data_proof";
    SmartRollupRefuteRevealProofKind["METADATA_PROOF"] = "metadata_proof";
    SmartRollupRefuteRevealProofKind["DAL_PAGE_PROOF"] = "dal_page_proof";
    SmartRollupRefuteRevealProofKind["DAL_PARAMETERS_PROOF"] = "dal_parameters_proof";
})($f93002942e85739a$export$6b51c844e2b0334d || ($f93002942e85739a$export$6b51c844e2b0334d = {}));
var $f93002942e85739a$export$9326a2a3b9cae4b1;
(function(SmartRollupRefuteGameStatusOptions) {
    SmartRollupRefuteGameStatusOptions["ONGOING"] = "ongoing";
    SmartRollupRefuteGameStatusOptions["ENDED"] = "ended";
})($f93002942e85739a$export$9326a2a3b9cae4b1 || ($f93002942e85739a$export$9326a2a3b9cae4b1 = {}));
var $f93002942e85739a$export$ef2fea9367dd59a2;
(function(SmartRollupRefuteGameEndedPlayerOutcomes) {
    SmartRollupRefuteGameEndedPlayerOutcomes["LOSER"] = "loser";
    SmartRollupRefuteGameEndedPlayerOutcomes["DRAW"] = "draw";
})($f93002942e85739a$export$ef2fea9367dd59a2 || ($f93002942e85739a$export$ef2fea9367dd59a2 = {}));
var $f93002942e85739a$export$e0c6dafa14dbf762;
(function(SmartRollupRefuteGameEndedReason) {
    SmartRollupRefuteGameEndedReason["CONFLICT_RESOLVED"] = "conflict_resolved";
    SmartRollupRefuteGameEndedReason["TIMEOUT"] = "timeout";
})($f93002942e85739a$export$e0c6dafa14dbf762 || ($f93002942e85739a$export$e0c6dafa14dbf762 = {}));
var $f93002942e85739a$export$b64a25b4a099ca08;
(function(OpKind) {
    OpKind["ORIGINATION"] = "origination";
    OpKind["DELEGATION"] = "delegation";
    OpKind["REVEAL"] = "reveal";
    OpKind["TRANSACTION"] = "transaction";
    OpKind["ACTIVATION"] = "activate_account";
    OpKind["ATTESTATION"] = "attestation";
    OpKind["ENDORSEMENT"] = "endorsement";
    OpKind["PREATTESTATION"] = "preattestation";
    OpKind["PREENDORSEMENT"] = "preendorsement";
    OpKind["SET_DEPOSITS_LIMIT"] = "set_deposits_limit";
    OpKind["DOUBLE_PREATTESTATION_EVIDENCE"] = "double_preattestation_evidence";
    OpKind["DOUBLE_PREENDORSEMENT_EVIDENCE"] = "double_preendorsement_evidence";
    OpKind["ATTESTATION_WITH_DAL"] = "attestation_with_dal";
    OpKind["ENDORSEMENT_WITH_DAL"] = "endorsement_with_dal";
    OpKind["SEED_NONCE_REVELATION"] = "seed_nonce_revelation";
    OpKind["DOUBLE_ATTESTATION_EVIDENCE"] = "double_attestation_evidence";
    OpKind["DOUBLE_ENDORSEMENT_EVIDENCE"] = "double_endorsement_evidence";
    OpKind["DOUBLE_BAKING_EVIDENCE"] = "double_baking_evidence";
    OpKind["PROPOSALS"] = "proposals";
    OpKind["BALLOT"] = "ballot";
    OpKind["FAILING_NOOP"] = "failing_noop";
    OpKind["REGISTER_GLOBAL_CONSTANT"] = "register_global_constant";
    OpKind["TRANSFER_TICKET"] = "transfer_ticket";
    OpKind["INCREASE_PAID_STORAGE"] = "increase_paid_storage";
    OpKind["UPDATE_CONSENSUS_KEY"] = "update_consensus_key";
    OpKind["DRAIN_DELEGATE"] = "drain_delegate";
    OpKind["VDF_REVELATION"] = "vdf_revelation";
    OpKind["EVENT"] = "event";
    OpKind["TICKET_UPDATES"] = "ticket_updates";
    OpKind["SMART_ROLLUP_ORIGINATE"] = "smart_rollup_originate";
    OpKind["SMART_ROLLUP_ADD_MESSAGES"] = "smart_rollup_add_messages";
    OpKind["SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE"] = "smart_rollup_execute_outbox_message";
    OpKind["SMART_ROLLUP_PUBLISH"] = "smart_rollup_publish";
    OpKind["SMART_ROLLUP_CEMENT"] = "smart_rollup_cement";
    OpKind["SMART_ROLLUP_RECOVER_BOND"] = "smart_rollup_recover_bond";
    OpKind["SMART_ROLLUP_REFUTE"] = "smart_rollup_refute";
    OpKind["SMART_ROLLUP_TIMEOUT"] = "smart_rollup_timeout";
    OpKind["DAL_PUBLISH_COMMITMENT"] = "dal_publish_commitment";
    OpKind["DAL_ENTRAPMENT_EVIDENCE"] = "dal_entrapment_evidence";
})($f93002942e85739a$export$b64a25b4a099ca08 || ($f93002942e85739a$export$b64a25b4a099ca08 = {}));
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $f93002942e85739a$export$a4ad2735b021c132 = {
    "commitHash": "6a2c52b9e48b299dfc856149c1fa3388e77180ad",
    "version": "22.0.0"
};
/***
 * @description RpcClient allows interaction with Tezos network through an rpc node
 */ class $f93002942e85739a$export$60aeb6b70d862cfd {
    /**
     *
     * @param url rpc root url
     * @param chain chain (default main)
     * @param httpBackend Http backend that issue http request.
     * You can override it by providing your own if you which to hook in the request/response
     *
     * @example new RpcClient('https://mainnet.tezos.ecadinfra.com/', 'main') this will use https://mainnet.tezos.ecadinfra.com//chains/main
     */ constructor(url, chain = $f93002942e85739a$export$df531a306ef6bb82, httpBackend = new (0, $6cc77aa71b64d012$export$aac4ca225fe02187)()){
        this.url = url;
        this.chain = chain;
        this.httpBackend = httpBackend;
    }
    createURL(path) {
        // Trim trailing slashes because it is assumed to be included in path
        // the regex solution is prone to ReDoS. Please see: https://stackoverflow.com/questions/6680825/return-string-without-trailing-slash#comment124306698_6680877
        // We also got a CodeQL error for the regex based solution
        let rootUrl = this.url;
        while(rootUrl.endsWith('/'))rootUrl = rootUrl.slice(0, -1);
        return `${rootUrl}${path}`;
    }
    validateAddress(address) {
        const addressValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(address);
        if (addressValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $dc90d6af72bbfdd0$export$66c44d927ffead98)(address, (0, $6ed3c564aba0f912$export$a2057601792df650)(addressValidation));
    }
    validateContract(address) {
        const addressValidation = (0, $6ed3c564aba0f912$export$2ed905adbd9a56f2)(address);
        if (addressValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $dc90d6af72bbfdd0$export$193774326795229b)(address, (0, $6ed3c564aba0f912$export$a2057601792df650)(addressValidation));
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Get the block's hash, its unique identifier.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-hash
     */ getBlockHash() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const hash = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/hash`),
                method: 'GET'
            });
            return hash;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List the ancestors of the given block which, if referred to as the branch in an operation header, are recent enough for that operation to be included in the current block.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-live-blocks
     */ getLiveBlocks() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const blocks = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/live_blocks`),
                method: 'GET'
            });
            return blocks;
        });
    }
    /**
     * @param address address from which we want to retrieve the spendable balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The spendable balance of a contract (in mutez), also known as liquid balance. Corresponds to tez owned by the contract that are neither staked, nor in unstaked requests, nor in frozen bonds. Identical to the 'spendable' RPC.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-balance
     */ getBalance(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const balance = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/balance`),
                method: 'GET'
            });
            return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(balance);
        });
    }
    /**
     * @param address address from which we want to retrieve the spendable balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The spendable balance of a contract (in mutez), also known as liquid balance. Corresponds to tez owned by the contract that are neither staked, nor in unstaked requests, nor in frozen bonds. Identical to the 'balance' RPC.
     */ getSpendable(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const balance = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/spendable`),
                method: 'GET'
            });
            return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(balance);
        });
    }
    /**
     * @param address address from which we want to retrieve balance and frozen bonds
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The sum (in mutez) of the spendable balance and frozen bonds of a contract. Corresponds to the contract's full balance from which staked funds and unstake requests have been excluded. Identical to the 'spendable_and_frozen_bonds' RPC.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-full-balance
     */ getBalanceAndFrozenBonds(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const balance = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/balance_and_frozen_bonds`),
                method: 'GET'
            });
            return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(balance);
        });
    }
    /**
     * @param address address from which we want to retrieve spendable and frozen bonds
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The sum (in mutez) of the spendable balance and frozen bonds of a contract. Corresponds to the contract's full balance from which staked funds and unstake requests have been excluded. Identical to the 'balance_and_frozen_bonds' RPC.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-full-balance
     */ getSpendableAndFrozenBonds(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const balance = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/spendable_and_frozen_bonds`),
                method: 'GET'
            });
            return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(balance);
        });
    }
    /**
     * @param address address from which we want to retrieve the full balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the full balance of a contract, including frozen bonds and stake.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-full-balance
     */ getFullBalance(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const balance = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/full_balance`),
                method: 'GET'
            });
            return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(balance);
        });
    }
    /**
     * @param address address from which we want to retrieve the staked balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the staked balance of a contract. Returns None if the contract is originated, or neither delegated nor a delegate.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-staked-balance
     */ getStakedBalance(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const balance = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/staked_balance`),
                method: 'GET'
            });
            return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(balance);
        });
    }
    /**
     * @param address address from which we want to retrieve the unstaked finalizable balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the balance of a contract that was requested for an unstake operation, and is no longer frozen, which means it will appear in the spendable balance of the contract after any stake/unstake/finalize_unstake operation. Returns None if the contract is originated.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-unstaked-finalizable-balance
     */ getUnstakedFinalizableBalance(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const balance = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/unstaked_finalizable_balance`),
                method: 'GET'
            });
            return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(balance);
        });
    }
    /**
     * @param address address from which we want to retrieve the unstaked frozen balance
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the balance of a contract that was requested for an unstake operation, but is still frozen for the duration of the slashing period. Returns None if the contract is originated.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-unstaked-frozen-balance
     */ getUnstakedFrozenBalance(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const balance = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/unstaked_frozen_balance`),
                method: 'GET'
            });
            return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(balance);
        });
    }
    /**
     * @param address address from which we want to retrieve the unstaked requests
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the unstake requests of the contract. The requests that appear in the finalizable field can be finalized, which means that the contract can transfer these (no longer frozen) funds to their spendable balance with a [finalize_unstake] operation call. Returns null if there is no unstake request pending.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-unstake-requests
     */ getUnstakeRequests(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/unstake_requests`),
                method: 'GET'
            });
            return response === null ? null : {
                finalizable: response.finalizable.map((_a)=>{
                    var { amount: amount } = _a, rest = $f93002942e85739a$var$__rest(_a, [
                        "amount"
                    ]);
                    const castedToBigNumber = $f93002942e85739a$export$ef5b1cb6f241eca7({
                        amount: amount
                    }, [
                        'amount'
                    ]);
                    return Object.assign(Object.assign({}, rest), {
                        amount: castedToBigNumber.amount
                    });
                }),
                unfinalizable: {
                    delegate: response.unfinalizable.delegate,
                    requests: response.unfinalizable.requests.map(({ amount: amount, cycle: cycle })=>{
                        const castedToBigNumber = $f93002942e85739a$export$ef5b1cb6f241eca7({
                            amount: amount
                        }, [
                            'amount'
                        ]);
                        return {
                            cycle: cycle,
                            amount: castedToBigNumber.amount
                        };
                    })
                }
            };
        });
    }
    /**
     * @param address contract address from which we want to retrieve the storage
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the data of the contract.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-storage
     */ getStorage(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateContract(address);
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/storage`),
                method: 'GET'
            });
        });
    }
    /**
     * @param address contract address from which we want to retrieve the script
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the code and data of the contract.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-script
     */ getScript(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateContract(address);
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/script`),
                method: 'GET'
            });
        });
    }
    /**
     * @param address contract address from which we want to retrieve the script
     * @param unparsingMode default is { unparsing_mode: "Readable" }
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the script of the contract and normalize it using the requested unparsing mode.
     */ getNormalizedScript(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, unparsingMode = {
            unparsing_mode: 'Readable'
        }, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateContract(address);
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/script/normalized`),
                method: 'POST'
            }, unparsingMode);
        });
    }
    /**
     * @param address contract address from which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the complete status of a contract.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id
     */ getContract(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const contractResponse = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}`),
                method: 'GET'
            });
            return Object.assign(Object.assign({}, contractResponse), {
                balance: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(contractResponse.balance)
            });
        });
    }
    /**
     * @param address contract address from which we want to retrieve the manager
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the manager of an implicit contract
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-manager-key
     */ getManagerKey(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/manager_key`),
                method: 'GET'
            });
        });
    }
    /**
     * @param address contract address from which we want to retrieve the delegate (baker)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the delegate of a contract, if any
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-delegate
     */ getDelegate(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            let delegate;
            try {
                delegate = yield this.httpBackend.createRequest({
                    url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/delegate`),
                    method: 'GET'
                });
            } catch (ex) {
                if (ex instanceof (0, $6cc77aa71b64d012$export$d2f2761cbe9cebf2) && ex.status === (0, $6cc77aa71b64d012$export$bc3aa03eb4b395cf).NOT_FOUND) delegate = null;
                else throw ex;
            }
            return delegate;
        });
    }
    /**
     * @deprecated Deprecated in favor of getBigMapKeyByID
     * @param address contract address from which we want to retrieve the big map key
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the value associated with a key in the big map storage of the contract.
     * @see https://tezos.gitlab.io/active/rpc.html#post-block-id-context-contracts-contract-id-big-map-get
     */ getBigMapKey(address_1, key_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, key, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${address}/big_map_get`),
                method: 'POST'
            }, key);
        });
    }
    /**
     * @param id Big Map ID
     * @param expr Expression hash to query (A b58check encoded Blake2b hash of the expression (The expression can be packed using the pack_data method))
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the value associated with a key in a big map.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-big-maps-big-map-id-script-expr
     */ getBigMapExpr(id_1, expr_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(id, expr, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/big_maps/${id}/${expr}`),
                method: 'GET'
            });
        });
    }
    /**
     * @param args contains optional query arguments (active, inactive, with_minimal_stake, without_minimal_stake)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Lists all registered delegates by default with query arguments to filter unneeded values.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-delegates-pkh
     */ getAllDelegates() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(args = {}, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/delegates`),
                method: 'GET',
                query: args
            });
        });
    }
    /**
     * @param address delegate address which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Everything about a delegate
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-delegates-pkh
     */ getDelegates(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/delegates/${address}`),
                method: 'GET'
            });
            const castedResponse = $f93002942e85739a$export$ef5b1cb6f241eca7(response, [
                'balance',
                'full_balance',
                'current_frozen_deposits',
                'frozen_deposits',
                'frozen_balance',
                'frozen_deposits_limit',
                'staking_balance',
                'delegated_balance',
                'voting_power',
                'total_delegated_stake',
                'staking_denominator'
            ]);
            if (response.frozen_balance_by_cycle) return Object.assign(Object.assign(Object.assign({}, response), castedResponse), {
                frozen_balance_by_cycle: response.frozen_balance_by_cycle.map((_a)=>{
                    var { deposit: deposit, deposits: deposits, fees: fees, rewards: rewards } = _a, rest = $f93002942e85739a$var$__rest(_a, [
                        "deposit",
                        "deposits",
                        "fees",
                        "rewards"
                    ]);
                    const castedToBigNumber = $f93002942e85739a$export$ef5b1cb6f241eca7({
                        deposit: deposit,
                        deposits: deposits,
                        fees: fees,
                        rewards: rewards
                    }, [
                        'deposit',
                        'deposits',
                        'fees',
                        'rewards'
                    ]);
                    return Object.assign(Object.assign({}, rest), {
                        deposit: castedToBigNumber.deposit,
                        deposits: castedToBigNumber.deposits,
                        fees: castedToBigNumber.fees,
                        rewards: castedToBigNumber.rewards
                    });
                })
            });
            else return Object.assign(Object.assign({}, response), castedResponse);
        });
    }
    /**
     * @param address delegate address which we want to retrieve
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the delegate info (e.g. voting power) found in the listings of the current voting period
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-delegates-pkh-voting-info
     */ getVotingInfo(address_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(address, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateAddress(address);
            return yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/delegates/${address}/voting_info`),
                method: 'GET'
            });
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description All constants
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-constants
     */ getConstants() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/constants`),
                method: 'GET'
            });
            const castedResponse = $f93002942e85739a$export$ef5b1cb6f241eca7(response, [
                'time_between_blocks',
                'hard_gas_limit_per_operation',
                'hard_gas_limit_per_block',
                'proof_of_work_threshold',
                'tokens_per_roll',
                'seed_nonce_revelation_tip',
                'block_security_deposit',
                'endorsement_security_deposit',
                'block_reward',
                'endorsement_reward',
                'cost_per_byte',
                'hard_storage_limit_per_operation',
                'test_chain_duration',
                'baking_reward_per_endorsement',
                'delay_per_missing_endorsement',
                'minimal_block_delay',
                'liquidity_baking_subsidy',
                'cache_layout',
                'baking_reward_fixed_portion',
                'baking_reward_bonus_per_slot',
                'endorsing_reward_per_slot',
                'double_baking_punishment',
                'delay_increment_per_round',
                'tx_rollup_commitment_bond',
                'vdf_difficulty',
                'sc_rollup_stake_amount',
                'minimal_stake'
            ]);
            return Object.assign(Object.assign({}, response), castedResponse);
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head) and version.
     * @description All the information about a block
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id
     * @example getBlock() will default to `/main/chains/block/head?version=1`
     * @example getBlock({ block: 'head~2' }) will return an offset of 2 from head blocks
     * @example getBlock({ block: 'BL8fTiWcSxWCjiMVnDkbh6EuhqVPZzgWheJ2dqwrxYRm9AephXh~2' }) will return an offset of 2 blocks from given block hash..
     */ getBlock() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block, version: version } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const requestOptions = {
                url: this.createURL(`/chains/${this.chain}/blocks/${block}`),
                method: 'GET'
            };
            if (version !== undefined) requestOptions.query = {
                version: version
            };
            return yield this.httpBackend.createRequest(requestOptions);
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description The whole block header
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-header
     */ getBlockHeader() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/header`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head) and version
     * @description All the metadata associated to the block
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-metadata
     */ getBlockMetadata() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block, version: version } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const requestOptions = {
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/metadata`),
                method: 'GET'
            };
            if (version !== undefined) requestOptions.query = {
                version: version
            };
            return yield this.httpBackend.createRequest(requestOptions);
        });
    }
    /**
     * @param args contains optional query arguments (level, cycle, delegate, consensus_key, and max_round)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Retrieves the list of delegates allowed to bake a block.
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ getBakingRights() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(args = {}, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/baking_rights`),
                method: 'GET',
                query: args
            });
            return response;
        });
    }
    /**
     * @param args contains optional query arguments (level, cycle, delegate, and consensus_key)
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Retrieves the delegates allowed to attest a block
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ getAttestationRights() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(args = {}, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/attestation_rights`),
                method: 'GET',
                query: args
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Ballots casted so far during a voting period
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-ballot-list
     */ getBallotList() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/ballot_list`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Sum of ballots casted so far during a voting period
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-ballots
     */ getBallots() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/ballots`),
                method: 'GET'
            });
            const casted = $f93002942e85739a$export$ef5b1cb6f241eca7(response, [
                'yay',
                'nay',
                'pass'
            ]);
            return casted;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Current proposal under evaluation.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-current-proposal
     */ getCurrentProposal() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/current_proposal`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Current expected quorum.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-current-quorum
     */ getCurrentQuorum() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/current_quorum`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List of delegates with their voting power
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-listings
     */ getVotesListings() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/listings`),
                method: 'GET'
            });
            response.map((item)=>{
                if (item.voting_power) item.voting_power = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(item.voting_power);
                return item;
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description List of proposals with number of supporters
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-proposals
     */ getProposals() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/proposals`),
                method: 'GET'
            });
            response.map((item)=>{
                return item[1] = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(item[1]);
            });
            return response;
        });
    }
    /**
     * @param data operation contents to forge
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Forge an operation returning the unsigned bytes
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ forgeOperations(data_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(data, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/forge/operations`),
                method: 'POST'
            }, data);
        });
    }
    /**
     * @param signedOpBytes signed bytes to inject
     * @description Inject an operation in node and broadcast it and return the ID of the operation
     * @see https://tezos.gitlab.io/shell/rpc.html#post-injection-operation
     */ injectOperation(signedOpBytes) {
        return $f93002942e85739a$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/injection/operation`),
                method: 'POST'
            }, signedOpBytes);
        });
    }
    /**
     * @param ops Operations to apply
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Simulate the application of the operations with the context of the given block and return the result of each operation application
     * @see https://tezos.gitlab.io/active/rpc.html#post-block-id-helpers-preapply-operations
     */ preapplyOperations(ops_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(ops, { block: block, version: version } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const requestOptions = {
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/preapply/operations`),
                method: 'POST'
            };
            if (version !== undefined) requestOptions.query = {
                version: version
            };
            return yield this.httpBackend.createRequest(requestOptions, ops);
        });
    }
    /**
     * @param contract address of the contract we want to get the entrypoints of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Return the list of entrypoints of the contract
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-entrypoints
     * @version 005_PsBABY5H
     */ getEntrypoints(contract_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            this.validateContract(contract);
            const contractResponse = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/entrypoints`),
                method: 'GET'
            });
            return contractResponse;
        });
    }
    /**
     * @deprecated Deprecated in favor of simulateOperation
     * @param op Operation to run
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Run an operation with the context of the given block and without signature checks and return the operation application result, including the consumed gas.
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ runOperation(op_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(op, { block: block, version: version } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const requestOptions = {
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/run_operation`),
                method: 'POST'
            };
            if (version !== undefined) requestOptions.query = {
                version: version
            };
            return yield this.httpBackend.createRequest(requestOptions, op);
        });
    }
    /**
     * @param op Operation to simulate
     * @param options contains generic configuration for rpc calls to specified block and version
     * @description Simulate running an operation at some future moment (based on the number of blocks given in the `latency` argument), and return the operation application result.
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ simulateOperation(op_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(op, { block: block, version: version } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const requestOptions = {
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/simulate_operation`),
                method: 'POST'
            };
            if (version !== undefined) requestOptions.query = {
                version: version
            };
            return yield this.httpBackend.createRequest(requestOptions, op);
        });
    }
    /**
     * @param code Code to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Run a Michelson script in the current context
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ runCode(code_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(code, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/run_code`),
                method: 'POST'
            }, code);
            return response;
        });
    }
    /**
     * @param viewScriptParams Parameters of the script view to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Simulate a call to a michelson view
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ runScriptView(_a, _b) {
        return $f93002942e85739a$var$__awaiter(this, void 0, void 0, function*() {
            var { unparsing_mode: unparsing_mode = 'Readable' } = _a, rest = $f93002942e85739a$var$__rest(_a, [
                "unparsing_mode"
            ]);
            var _c = _b === void 0 ? $f93002942e85739a$export$20a0ad8102085d6c : _b, block = _c.block;
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/run_script_view`),
                method: 'POST'
            }, Object.assign({
                unparsing_mode: unparsing_mode
            }, rest));
        });
    }
    /**
     * @param viewParams Parameters of the view to run
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Simulate a call to a view following the TZIP-4 standard.
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ runView(_a, _b) {
        return $f93002942e85739a$var$__awaiter(this, void 0, void 0, function*() {
            var { unparsing_mode: unparsing_mode = 'Readable' } = _a, rest = $f93002942e85739a$var$__rest(_a, [
                "unparsing_mode"
            ]);
            var _c = _b === void 0 ? $f93002942e85739a$export$20a0ad8102085d6c : _b, block = _c.block;
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/run_view`),
                method: 'POST'
            }, Object.assign({
                unparsing_mode: unparsing_mode
            }, rest));
        });
    }
    getChainId() {
        return $f93002942e85739a$var$__awaiter(this, void 0, void 0, function*() {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/chain_id`),
                method: 'GET'
            });
        });
    }
    /**
     * @param data Data to pack
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Computes the serialized version of a data expression using the same algorithm as script instruction PACK
     * Note: You should always verify the packed bytes before signing or requesting that they be signed when using the RPC to pack.
     * This precaution helps protect you and your applications users from RPC nodes that have been compromised.
     * A node that is operated by a bad actor, or compromised by a bad actor could return a fully formed operation that does not correspond to the input provided to the RPC endpoint.
     * A safer solution to pack and sign data would be to use the `packDataBytes` function available in the `@taquito/michel-codec` package.
     * @example packData({ data: { string: "test" }, type: { prim: "string" } })
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ packData(data_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(data, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const _a = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/helpers/scripts/pack_data`),
                method: 'POST'
            }, data), { gas: gas } = _a, rest = $f93002942e85739a$var$__rest(_a, [
                "gas"
            ]);
            let formattedGas = gas;
            const tryBigNumber = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(gas || '');
            if (!tryBigNumber.isNaN()) formattedGas = tryBigNumber;
            return Object.assign({
                gas: formattedGas
            }, rest);
        });
    }
    /**
     *
     * @description Return rpc root url
     */ getRpcUrl() {
        return this.url;
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the voting period (index, kind, starting position) and related information (position, remaining) of the interrogated block
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-current-period
     */ getCurrentPeriod() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/current_period`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the voting period (index, kind, starting position) and related information (position, remaining) of the next block.Useful to craft operations that will be valid in the next block
     * @example getSuccessorPeriod() will default to successor voting period for /main/chains/block/head.
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-votes-successor-period
     */ getSuccessorPeriod() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            const response = yield this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/votes/successor_period`),
                method: 'GET'
            });
            return response;
        });
    }
    /**
     * @param id Sapling state ID
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the root and a diff of a state starting from an optional offset which is zero by default
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-sapling-sapling-state-id-get-diff
     */ getSaplingDiffById(id_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(id, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/sapling/${id}/get_diff`),
                method: 'GET'
            });
        });
    }
    /**
     * @param contract address of the contract we want to get the sapling diff
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Returns the root and a diff of a state starting from an optional offset which is zero by default
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-contracts-contract-id-single-sapling-get-diff
     */ getSaplingDiffByContract(contract_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/single_sapling_get_diff`),
                method: 'GET'
            });
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description get current and next protocol
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-protocols
     */ getProtocols() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/protocols`),
                method: 'GET'
            });
        });
    }
    /**
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description get current and next protocol
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-protocols
     */ getProtocolActivations() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(protocol = '') {
            if (protocol) {
                const protocolValidation = (0, $6ed3c564aba0f912$export$6090822dce1c45f9)(protocol);
                if (protocolValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new Error(`Invalid protocol hash "${protocol}" ${(0, $6ed3c564aba0f912$export$a2057601792df650)(protocolValidation)}`);
            }
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/protocols/${protocol}`),
                method: 'GET'
            });
        });
    }
    /**
     * @param contract address of the contract we want to retrieve storage information of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the used storage space of the contract
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ getStorageUsedSpace(contract_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/storage/used_space`),
                method: 'GET'
            });
        });
    }
    /**
     * @param contract address of the contract we want to retrieve storage information of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the paid storage space of the contract
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/alpha-openapi.json
     */ getStoragePaidSpace(contract_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/storage/paid_space`),
                method: 'GET'
            });
        });
    }
    /**
     * @param contract implicit or originated address we want to retrieve ticket balance of
     * @param ticket object to specify a ticket by ticketer, content type and content
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the contract's balance of ticket with specified ticketer, content type, and content.
     * @example ticket { ticketer: 'address', content_type: { prim: "string" }, content: { string: 'ticket1' } }
     * @see https://tezos.gitlab.io/protocols/016_mumbai.html#rpc-changes
     */ getTicketBalance(contract_1, ticket_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, ticket, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/ticket_balance`),
                method: 'POST'
            }, ticket);
        });
    }
    /**
     * @param contract originated address we want to retrieve ticket balances of
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @description Access the complete list of tickets owned by the given contract by scanning the contract's storage.
     * @see https://tezos.gitlab.io/protocols/016_mumbai.html#rpc-changes
     */ getAllTicketBalances(contract_1) {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(contract, { block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/contracts/${contract}/all_ticket_balances`),
                method: 'GET'
            });
        });
    }
    /**
     * @description Returns the cycle at which the launch of the Adaptive Issuance feature is set to happen. A result of null means that the feature is not yet set to launch.
     * @param options contains generic configuration for rpc calls to specified block (default to head)
     * @see https://tezos.gitlab.io/active/rpc.html#get-block-id-context-adaptive-issuance-launch-cycle
     */ getAdaptiveIssuanceLaunchCycle() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*({ block: block } = $f93002942e85739a$export$20a0ad8102085d6c) {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/blocks/${block}/context/adaptive_issuance_launch_cycle`),
                method: 'GET'
            });
        });
    }
    /**
     * @description List the prevalidated operations in mempool (accessibility of mempool depends on each rpc endpoint)
     * @param args has 5 optional properties
     * @default args { version: '2', validated: true, refused: true, outdated, true, branchRefused: true, branchDelayed: true, validationPass: undefined, source: undefined, operationHash: undefined }
     * @see https://gitlab.com/tezos/tezos/-/blob/master/docs/api/rio-mempool-openapi.json
     */ getPendingOperations() {
        return $f93002942e85739a$var$__awaiter(this, arguments, void 0, function*(args = {}) {
            return this.httpBackend.createRequest({
                url: this.createURL(`/chains/${this.chain}/mempool/pending_operations`),
                method: 'GET',
                query: args
            });
        });
    }
}



// ==========================================================================================
// parent error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Parent error class all taquito errors to extend from
 */ class $580df0c6131ecaba$export$e5619b407b1c8b0a extends Error {
}
/**
 *  @category Error
 *  @description Error that indicates invalid user inputs
 */ class $580df0c6131ecaba$export$9d3f3bc8b6d48950 extends $580df0c6131ecaba$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error returned by RPC node
 */ class $580df0c6131ecaba$export$5460eff990f31920 extends $580df0c6131ecaba$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates TezosToolKit has not been configured appropriately
 */ class $580df0c6131ecaba$export$32f4d70b2fb302b1 extends $580df0c6131ecaba$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates a requested action is not supported by Taquito
 */ class $580df0c6131ecaba$export$34bc216509d47ce6 extends $580df0c6131ecaba$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error during a network operation
 */ class $580df0c6131ecaba$export$bae979e68e4dc802 extends $580df0c6131ecaba$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates user attempts an action without necessary permissions
 */ class $580df0c6131ecaba$export$9c81d48c1e1840ac extends $580df0c6131ecaba$export$e5619b407b1c8b0a {
}
// ==========================================================================================
// common error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Error that indicates an invalid originated or implicit address being passed or used
 */ class $580df0c6131ecaba$export$66c44d927ffead98 extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidAddressError';
        this.message = `Invalid address "${address}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
class $580df0c6131ecaba$export$be6cb9338b7137e0 extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidStakingAddressError';
        this.message = `Invalid staking address "${address}", you can only set destination as your own address`;
    }
}
class $580df0c6131ecaba$export$1623a856d8b6cc2a extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidFinalizeUnstakeAmountError';
        this.message = `The amount can only be 0 when finalizing an unstake`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid block hash being passed or used
 */ class $580df0c6131ecaba$export$16fabd343bcdfd7b extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(blockHash, errorDetail){
        super();
        this.blockHash = blockHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidBlockHashError';
        this.message = `Invalid block hash "${blockHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid amount of tez being passed as a parameter
 */ class $580df0c6131ecaba$export$d8bf6d22cce8e288 extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(amount){
        super();
        this.amount = amount;
        this.name = 'InvalidAmountError';
        this.message = `Invalid amount "${amount}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid derivation path being passed or used
 */ class $580df0c6131ecaba$export$522ca3df7030c309 extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(derivationPath, errorDetail){
        super();
        this.derivationPath = derivationPath;
        this.errorDetail = errorDetail;
        this.name = 'InvalidDerivationPathError';
        this.message = `Invalid derivation path "${derivationPath}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid hex string have been passed or used
 */ class $580df0c6131ecaba$export$1888d6928c74d5ee extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(hexString, errorDetail){
        super();
        this.hexString = hexString;
        this.errorDetail = errorDetail;
        this.name = 'InvalidHexStringError';
        this.message = `Invalid hex string "${hexString}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid message being passed or used
 */ class $580df0c6131ecaba$export$a5124d7665e9d8ad extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(msg, errorDetail){
        super();
        this.msg = msg;
        this.errorDetail = errorDetail;
        this.name = 'InvalidMessageError';
        this.message = `Invalid message "${msg}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid view parameter of a smart contract
 */ class $580df0c6131ecaba$export$f9ce6a924724628b extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(viewName, sigs, args, cause){
        super();
        this.viewName = viewName;
        this.sigs = sigs;
        this.args = args;
        this.cause = cause;
        this.name = 'InvalidViewParameterError';
        this.message = `Invalid view arguments ${JSON.stringify(args)} received for name "${viewName}" expecting one of the following signatures ${JSON.stringify(sigs)}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid private key being passed or used
 */ class $580df0c6131ecaba$export$adf223add86ae0aa extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(errorDetail){
        super();
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyError';
        this.message = `Invalid private key`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an Invalid Public Key being passed or used
 */ class $580df0c6131ecaba$export$f675822ed489f01f extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(publicKey, errorDetail){
        super();
        this.publicKey = publicKey;
        this.errorDetail = errorDetail;
        this.name = 'InvalidPublicKeyError';
        this.message = `Invalid public key "${publicKey}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid signature being passed or used
 */ class $580df0c6131ecaba$export$ccc2f68ef106615a extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(signature, errorDetail){
        super();
        this.signature = signature;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSignatureError';
        this.message = `Invalid signature "${signature}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid contract address being passed or used
 */ class $580df0c6131ecaba$export$193774326795229b extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(contractAddress, errorDetail){
        super();
        this.contractAddress = contractAddress;
        this.errorDetail = errorDetail;
        this.name = 'InvalidContractAddressError';
        this.message = `Invalid contract address "${contractAddress}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid chain id being passed or used
 */ class $580df0c6131ecaba$export$4836eb835ffca5b2 extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(chainId, errorDetail){
        super();
        this.chainId = chainId;
        this.errorDetail = errorDetail;
        this.name = 'InvalidChainIdError';
        this.message = `Invalid chain id "${chainId}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid public key hash being passed or used
 */ class $580df0c6131ecaba$export$a3d7df0ca9d9410c extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(keyHash, errorDetail){
        super();
        this.keyHash = keyHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyHashError';
        this.message = `Invalid public key hash "${keyHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation hash being passed or used
 */ class $580df0c6131ecaba$export$1a1c2023d3ec7a8a extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(operationHash, errorDetail){
        super();
        this.operationHash = operationHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationHashError';
        this.message = `Invalid operation hash "${operationHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation kind being passed or used
 */ class $580df0c6131ecaba$export$bc5be87550569b55 extends $580df0c6131ecaba$export$9d3f3bc8b6d48950 {
    constructor(operationKind, errorDetail){
        super();
        this.operationKind = operationKind;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationKindError';
        this.message = `Invalid operation kind "${operationKind}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description General error that indicates something is no longer supported and/or deprecated
 */ class $580df0c6131ecaba$export$11034991807c583d extends $580df0c6131ecaba$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'DeprecationError';
    }
}
/**
 *  @category Error
 *  @description General error that indicates an action is prohibited or not allowed
 */ class $580df0c6131ecaba$export$4041d915d9096adf extends $580df0c6131ecaba$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ProhibitedActionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure in grabbing the public key
 */ class $580df0c6131ecaba$export$183b043cd3c947f9 extends $580df0c6131ecaba$export$e5619b407b1c8b0a {
    constructor(pkh, cause){
        super();
        this.pkh = pkh;
        this.cause = cause;
        this.name = 'PublicKeyNotFoundError';
        this.message = `Public key not found of this address "${pkh}" in either wallet or contract API.`;
    }
}





// ==========================================================================================
// parent error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Parent error class all taquito errors to extend from
 */ class $df4bb72c68281fa2$export$e5619b407b1c8b0a extends Error {
}
/**
 *  @category Error
 *  @description Error that indicates invalid user inputs
 */ class $df4bb72c68281fa2$export$9d3f3bc8b6d48950 extends $df4bb72c68281fa2$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error returned by RPC node
 */ class $df4bb72c68281fa2$export$5460eff990f31920 extends $df4bb72c68281fa2$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates TezosToolKit has not been configured appropriately
 */ class $df4bb72c68281fa2$export$32f4d70b2fb302b1 extends $df4bb72c68281fa2$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates a requested action is not supported by Taquito
 */ class $df4bb72c68281fa2$export$34bc216509d47ce6 extends $df4bb72c68281fa2$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error during a network operation
 */ class $df4bb72c68281fa2$export$bae979e68e4dc802 extends $df4bb72c68281fa2$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates user attempts an action without necessary permissions
 */ class $df4bb72c68281fa2$export$9c81d48c1e1840ac extends $df4bb72c68281fa2$export$e5619b407b1c8b0a {
}
// ==========================================================================================
// common error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Error that indicates an invalid originated or implicit address being passed or used
 */ class $df4bb72c68281fa2$export$66c44d927ffead98 extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidAddressError';
        this.message = `Invalid address "${address}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
class $df4bb72c68281fa2$export$be6cb9338b7137e0 extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidStakingAddressError';
        this.message = `Invalid staking address "${address}", you can only set destination as your own address`;
    }
}
class $df4bb72c68281fa2$export$1623a856d8b6cc2a extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidFinalizeUnstakeAmountError';
        this.message = `The amount can only be 0 when finalizing an unstake`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid block hash being passed or used
 */ class $df4bb72c68281fa2$export$16fabd343bcdfd7b extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(blockHash, errorDetail){
        super();
        this.blockHash = blockHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidBlockHashError';
        this.message = `Invalid block hash "${blockHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid amount of tez being passed as a parameter
 */ class $df4bb72c68281fa2$export$d8bf6d22cce8e288 extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(amount){
        super();
        this.amount = amount;
        this.name = 'InvalidAmountError';
        this.message = `Invalid amount "${amount}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid derivation path being passed or used
 */ class $df4bb72c68281fa2$export$522ca3df7030c309 extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(derivationPath, errorDetail){
        super();
        this.derivationPath = derivationPath;
        this.errorDetail = errorDetail;
        this.name = 'InvalidDerivationPathError';
        this.message = `Invalid derivation path "${derivationPath}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid hex string have been passed or used
 */ class $df4bb72c68281fa2$export$1888d6928c74d5ee extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(hexString, errorDetail){
        super();
        this.hexString = hexString;
        this.errorDetail = errorDetail;
        this.name = 'InvalidHexStringError';
        this.message = `Invalid hex string "${hexString}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid message being passed or used
 */ class $df4bb72c68281fa2$export$a5124d7665e9d8ad extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(msg, errorDetail){
        super();
        this.msg = msg;
        this.errorDetail = errorDetail;
        this.name = 'InvalidMessageError';
        this.message = `Invalid message "${msg}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid view parameter of a smart contract
 */ class $df4bb72c68281fa2$export$f9ce6a924724628b extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(viewName, sigs, args, cause){
        super();
        this.viewName = viewName;
        this.sigs = sigs;
        this.args = args;
        this.cause = cause;
        this.name = 'InvalidViewParameterError';
        this.message = `Invalid view arguments ${JSON.stringify(args)} received for name "${viewName}" expecting one of the following signatures ${JSON.stringify(sigs)}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid private key being passed or used
 */ class $df4bb72c68281fa2$export$adf223add86ae0aa extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(errorDetail){
        super();
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyError';
        this.message = `Invalid private key`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an Invalid Public Key being passed or used
 */ class $df4bb72c68281fa2$export$f675822ed489f01f extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(publicKey, errorDetail){
        super();
        this.publicKey = publicKey;
        this.errorDetail = errorDetail;
        this.name = 'InvalidPublicKeyError';
        this.message = `Invalid public key "${publicKey}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid signature being passed or used
 */ class $df4bb72c68281fa2$export$ccc2f68ef106615a extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(signature, errorDetail){
        super();
        this.signature = signature;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSignatureError';
        this.message = `Invalid signature "${signature}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid contract address being passed or used
 */ class $df4bb72c68281fa2$export$193774326795229b extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(contractAddress, errorDetail){
        super();
        this.contractAddress = contractAddress;
        this.errorDetail = errorDetail;
        this.name = 'InvalidContractAddressError';
        this.message = `Invalid contract address "${contractAddress}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid chain id being passed or used
 */ class $df4bb72c68281fa2$export$4836eb835ffca5b2 extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(chainId, errorDetail){
        super();
        this.chainId = chainId;
        this.errorDetail = errorDetail;
        this.name = 'InvalidChainIdError';
        this.message = `Invalid chain id "${chainId}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid public key hash being passed or used
 */ class $df4bb72c68281fa2$export$a3d7df0ca9d9410c extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(keyHash, errorDetail){
        super();
        this.keyHash = keyHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyHashError';
        this.message = `Invalid public key hash "${keyHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation hash being passed or used
 */ class $df4bb72c68281fa2$export$1a1c2023d3ec7a8a extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(operationHash, errorDetail){
        super();
        this.operationHash = operationHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationHashError';
        this.message = `Invalid operation hash "${operationHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation kind being passed or used
 */ class $df4bb72c68281fa2$export$bc5be87550569b55 extends $df4bb72c68281fa2$export$9d3f3bc8b6d48950 {
    constructor(operationKind, errorDetail){
        super();
        this.operationKind = operationKind;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationKindError';
        this.message = `Invalid operation kind "${operationKind}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description General error that indicates something is no longer supported and/or deprecated
 */ class $df4bb72c68281fa2$export$11034991807c583d extends $df4bb72c68281fa2$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'DeprecationError';
    }
}
/**
 *  @category Error
 *  @description General error that indicates an action is prohibited or not allowed
 */ class $df4bb72c68281fa2$export$4041d915d9096adf extends $df4bb72c68281fa2$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ProhibitedActionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure in grabbing the public key
 */ class $df4bb72c68281fa2$export$183b043cd3c947f9 extends $df4bb72c68281fa2$export$e5619b407b1c8b0a {
    constructor(pkh, cause){
        super();
        this.pkh = pkh;
        this.cause = cause;
        this.name = 'PublicKeyNotFoundError';
        this.message = `Public key not found of this address "${pkh}" in either wallet or contract API.`;
    }
}





var $6ZWSX = parcelRequire("6ZWSX");
var $c46b7dbea18e1f8c$require$Buffer = $6ZWSX.Buffer;
var $c46b7dbea18e1f8c$var$_a$1;
/**
 *  @category Error
 *  @description Error that indicates an invalid map type being passed or used
 */ class $c46b7dbea18e1f8c$export$4eeb8f7279af263f extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(mapType, reason){
        super();
        this.mapType = mapType;
        this.reason = reason;
        this.message = `The map type '${JSON.stringify(mapType)}' is invalid. Reason: ${reason}.`;
        this.name = 'InvalidMapTypeError';
    }
}
// Retrieve a unique symbol associated with the key from the environment
// Used in order to identify all object that are of type MichelsonMap even if they come from different module
const $c46b7dbea18e1f8c$var$michelsonMapTypeSymbol = Symbol.for('taquito-michelson-map-type-symbol');
/**
 *
 * @throws {@link InvalidMapTypeError} when the argument passed to mapType is not a valid map type
 */ function $c46b7dbea18e1f8c$var$validateMapType(value) {
    if (!('prim' in value)) throw new $c46b7dbea18e1f8c$export$4eeb8f7279af263f(value, `Missing 'prim' field`);
    if (![
        'map',
        'big_map'
    ].includes(value.prim)) throw new $c46b7dbea18e1f8c$export$4eeb8f7279af263f(value, `The prim field should be 'map' or 'big_map'`);
    if (!('args' in value)) throw new $c46b7dbea18e1f8c$export$4eeb8f7279af263f(value, `Missing 'args' field`);
    if (!Array.isArray(value.args)) throw new $c46b7dbea18e1f8c$export$4eeb8f7279af263f(value, `The 'args' field should be an array`);
    if (value.args.length !== 2) throw new $c46b7dbea18e1f8c$export$4eeb8f7279af263f(value, `The 'args' field should have 2 elements`);
}
/**
 *  @category Error
 *  @description Error that indicates a map type mismatch, where an attempt to set a key or value in a Map doesn't match the defined type of the Map
 */ class $c46b7dbea18e1f8c$export$eecdd5fe7341b29b extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(value, type, objectType, reason){
        super();
        this.value = value;
        this.type = type;
        this.reason = reason;
        this.name = 'MapTypecheckError';
        this.message = `The ${objectType} provided: ${JSON.stringify(value)} is not compatible with the expected michelson type: ${JSON.stringify(type)}. Reason: ${JSON.stringify(reason)}.`;
        this.name = 'MapTypecheckError';
    }
}
/**
 * @description Michelson Map is an abstraction over the michelson native map. It supports complex Pair as key
 */ class $c46b7dbea18e1f8c$export$485fc446a4c98bc8 {
    // Used to check if an object is a michelson map.
    // Using instanceof was not working for project that had multiple instance of taquito dependencies
    // as the class constructor is different
    static isMichelsonMap(obj) {
        return obj && obj[$c46b7dbea18e1f8c$var$michelsonMapTypeSymbol] === true;
    }
    /**
     * @param mapType If specified key and value will be type-checked before being added to the map
     *
     * @example new MichelsonMap({ prim: "map", args: [{prim: "string"}, {prim: "int"}]})
     */ constructor(mapType){
        this.valueMap = new Map();
        this.keyMap = new Map();
        this[$c46b7dbea18e1f8c$var$_a$1] = true;
        if (mapType) this.setType(mapType);
    }
    setType(mapType) {
        $c46b7dbea18e1f8c$var$validateMapType(mapType);
        this.keySchema = new $c46b7dbea18e1f8c$export$19342e026b58ebb7(mapType.args[0]);
        this.valueSchema = new $c46b7dbea18e1f8c$export$19342e026b58ebb7(mapType.args[1]);
    }
    removeType() {
        this.keySchema = undefined;
        this.valueSchema = undefined;
    }
    static fromLiteral(obj, mapType) {
        const map = new $c46b7dbea18e1f8c$export$485fc446a4c98bc8(mapType);
        Object.keys(obj).forEach((key)=>{
            map.set(key, obj[key]);
        });
        return map;
    }
    typecheckKey(key) {
        if (!this.keySchema) return;
        this.keySchema.Typecheck(key);
    }
    typecheckValue(value) {
        if (!this.valueSchema) return;
        this.valueSchema.Typecheck(value);
    }
    /**
     * @throws {@link MapTypecheckError} when the argument passed does not match the expected schema for value
     */ assertTypecheckValue(value) {
        try {
            this.typecheckValue(value);
        } catch (e) {
            throw new $c46b7dbea18e1f8c$export$eecdd5fe7341b29b(value, this.valueSchema, 'value', e);
        }
    }
    /**
     * @throws {@link MapTypecheckError} when the argument passed does not match the expected schema for key
     */ assertTypecheckKey(key) {
        try {
            this.typecheckKey(key);
        } catch (e) {
            throw new $c46b7dbea18e1f8c$export$eecdd5fe7341b29b(key, this.keySchema, 'key', e);
        }
    }
    serializeDeterministically(key) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($136cf104cc6d8233$exports)))(key);
    }
    *keys() {
        for (const [key] of this.entries())yield key;
    }
    *values() {
        for (const [, value] of this.entries())yield value;
    }
    *entries() {
        for (const key of this.valueMap.keys())// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        yield [
            this.keyMap.get(key),
            this.valueMap.get(key)
        ];
    }
    get(key) {
        this.assertTypecheckKey(key);
        const strKey = this.serializeDeterministically(key);
        return this.valueMap.get(strKey);
    }
    /**
     *
     * @description Set a key and a value in the MichelsonMap. If the key already exists, override the current value.
     *
     * @example map.set("myKey", "myValue") // Using a string as key
     *
     * @example map.set({0: "test", 1: "test1"}, "myValue") // Using a pair as key
     *
     * @warn The same key can be represented in multiple ways, depending on the type of the key. This duplicate key situation will cause a runtime error (duplicate key) when sending the map data to the Tezos RPC node.
     *
     * For example, consider a contract with a map whose key is of type boolean.  If you set the following values in MichelsonMap: map.set(false, "myValue") and map.set(null, "myValue").
     *
     * You will get two unique entries in the MichelsonMap. These values will both be evaluated as falsy by the MichelsonEncoder and ultimately rejected by the Tezos RPC.
     */ set(key, value) {
        this.assertTypecheckKey(key);
        this.assertTypecheckValue(value);
        const strKey = this.serializeDeterministically(key);
        this.keyMap.set(strKey, key);
        this.valueMap.set(strKey, value);
    }
    delete(key) {
        this.assertTypecheckKey(key);
        this.keyMap.delete(this.serializeDeterministically(key));
        this.valueMap.delete(this.serializeDeterministically(key));
    }
    has(key) {
        this.assertTypecheckKey(key);
        const strKey = this.serializeDeterministically(key);
        return this.keyMap.has(strKey) && this.valueMap.has(strKey);
    }
    clear() {
        this.keyMap.clear();
        this.valueMap.clear();
    }
    get size() {
        return this.keyMap.size;
    }
    forEach(cb) {
        for (const [key, value] of this.entries())cb(value, key, this);
    }
}
$c46b7dbea18e1f8c$var$_a$1 = $c46b7dbea18e1f8c$var$michelsonMapTypeSymbol;
/**
 *  @category Error
 *  @description Error that indicates a failure when encoding invalid or incorrect data (e.g. if an address is expected but a number is received)
 */ class $c46b7dbea18e1f8c$var$TokenValidationError extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(value, token, baseMessage){
        super();
        this.value = value;
        this.token = token;
        this.name = 'TokenValidationError';
        const annot = this.token.annot();
        const annotText = annot ? `[${annot}] ` : '';
        this.message = `${annotText}${baseMessage}`;
    }
}
class $c46b7dbea18e1f8c$export$50792b0e93539fde {
    /**
     * @description Gets the strategy used for field numbering in Token execute/encode/decode to convert Michelson values to/from javascript objects, returns a value of type {@link FieldNumberingStrategy} that controls how field numbers are calculated
     */ static get fieldNumberingStrategy() {
        return $c46b7dbea18e1f8c$export$50792b0e93539fde._fieldNumberingStrategy;
    }
    /**
     * @description Sets the strategy used for field numbering in Token execute/encode/decode to convert Michelson values to/from javascript objects, accepts a value of type {@link FieldNumberingStrategy} that controls how field numbers are calculated
     */ static set fieldNumberingStrategy(value) {
        $c46b7dbea18e1f8c$export$50792b0e93539fde._fieldNumberingStrategy = value;
    }
    constructor(val, idx, fac, parentTokenType){
        this.val = val;
        this.idx = idx;
        this.fac = fac;
        this.parentTokenType = parentTokenType;
        this.createToken = this.fac;
    }
    typeWithoutAnnotations() {
        const handleMichelsonExpression = (val)=>{
            if (typeof val === 'object') {
                if (Array.isArray(val)) {
                    const array = val;
                    return array.map((item)=>handleMichelsonExpression(item));
                }
                const extended = val;
                if (extended.args) return {
                    prim: extended.prim,
                    args: extended.args.map((x)=>handleMichelsonExpression(x))
                };
                else return {
                    prim: extended.prim
                };
            }
            return val;
        };
        const handleMichelsonExtended = (val)=>{
            if (val.args) return {
                prim: val.prim,
                args: val.args.map((x)=>handleMichelsonExpression(x))
            };
            else return {
                prim: val.prim
            };
        };
        return handleMichelsonExtended(this.val);
    }
    annot() {
        return (Array.isArray(this.val.annots) && this.val.annots.length > 0 ? this.val.annots[0] : String(this.idx)).replace(/(%|:)(_Liq_entry_)?/, '');
    }
    hasAnnotations() {
        return Array.isArray(this.val.annots) && this.val.annots.length;
    }
    get tokenVal() {
        return this.val;
    }
    ExtractSignature() {
        return [
            [
                this.ExtractSchema()
            ]
        ];
    }
}
$c46b7dbea18e1f8c$export$50792b0e93539fde._fieldNumberingStrategy = 'Latest';
class $c46b7dbea18e1f8c$var$ComparableToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    compare(o1, o2) {
        if (o1 === o2) return 0;
        return o1 < o2 ? -1 : 1;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Big Map types
 */ class $c46b7dbea18e1f8c$export$f8bbc082a20b2e9d extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'BigMapValidationError';
    }
}
class $c46b7dbea18e1f8c$var$BigMapToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get ValueSchema() {
        return this.createToken(this.val.args[1], 0);
    }
    get KeySchema() {
        return this.createToken(this.val.args[0], 0);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            big_map: {
                key: this.KeySchema.ExtractSchema(),
                value: this.ValueSchema.ExtractSchema()
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$BigMapToken.prim,
            schema: {
                key: this.KeySchema.generateSchema(),
                value: this.ValueSchema.generateSchema()
            }
        };
    }
    /**
     * @throws {@link BigMapValidationError}
     */ validate(value) {
        if (!$c46b7dbea18e1f8c$export$485fc446a4c98bc8.isMichelsonMap(value)) throw new $c46b7dbea18e1f8c$export$f8bbc082a20b2e9d(value, this, `Value ${JSON.stringify(value)} is not a MichelsonMap`);
    }
    objLitToMichelsonMap(val) {
        if (val instanceof $c46b7dbea18e1f8c$export$485fc446a4c98bc8) return val;
        if (typeof val === 'object') {
            if (Object.keys(val).length === 0) return new $c46b7dbea18e1f8c$export$485fc446a4c98bc8();
            else return $c46b7dbea18e1f8c$export$485fc446a4c98bc8.fromLiteral(val);
        }
        return val;
    }
    /**
     * @throws {@link BigMapValidationError}
     */ Encode(args) {
        const val = this.objLitToMichelsonMap(args.pop());
        this.validate(val);
        return Array.from(val.keys()).sort((a, b)=>this.KeySchema.compare(a, b)).map((key)=>{
            return {
                prim: 'Elt',
                args: [
                    this.KeySchema.EncodeObject(key),
                    this.ValueSchema.EncodeObject(val.get(key))
                ]
            };
        });
    }
    /**
     * @throws {@link BigMapValidationError}
     */ EncodeObject(args, semantic) {
        const val = this.objLitToMichelsonMap(args);
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$BigMapToken.prim]) return semantic[$c46b7dbea18e1f8c$var$BigMapToken.prim](val, this.val);
        return Array.from(val.keys()).sort((a, b)=>this.KeySchema.compare(a, b)).map((key)=>{
            return {
                prim: 'Elt',
                args: [
                    this.KeySchema.EncodeObject(key),
                    this.ValueSchema.EncodeObject(val.get(key))
                ]
            };
        });
    }
    /**
     * @throws {@link InvalidMapTypeError} when the argument passed to val is an array but not a valid map type
     * @throws {@link BigMapValidationError} when the value is invalid
     */ Execute(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$BigMapToken.prim]) return semantic[$c46b7dbea18e1f8c$var$BigMapToken.prim](val, this.val);
        if (Array.isArray(val)) {
            // Athens is returning an empty array for big map in storage
            // Internal: In taquito v5 it is still used to decode big map diff (as if they were a regular map)
            const map = new $c46b7dbea18e1f8c$export$485fc446a4c98bc8(this.val);
            val.forEach((current)=>{
                map.set(this.KeySchema.ToKey(current.args[0]), this.ValueSchema.Execute(current.args[1]));
            });
            return map;
        } else if ('int' in val) // Babylon is returning an int with the big map id in contract storage
        return val.int;
        else throw new $c46b7dbea18e1f8c$export$f8bbc082a20b2e9d(val, this, `Big map is expecting either an array (Athens) or an object with an int property (Babylon). Got ${JSON.stringify(val)}`);
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$BigMapToken.prim === tokenToFind) tokens.push(this);
        this.KeySchema.findAndReturnTokens(tokenToFind, tokens);
        this.ValueSchema.findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$BigMapToken.prim = 'big_map';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing an OrToken
 */ class $c46b7dbea18e1f8c$export$323d5d85c5838f7a extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'OrValidationError';
    }
}
class $c46b7dbea18e1f8c$var$OrToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac, parentTokenType){
        super(val, idx, fac, parentTokenType);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
        this.parentTokenType = parentTokenType;
    }
    Encode(args) {
        const label = args[args.length - 1];
        const leftToken = this.createToken(this.val.args[0], this.getIdxForChildren(), 'Or');
        let keyCount = 1;
        if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(this.val.args[1], this.getIdxForChildren() + keyCount, 'Or');
        if (String(leftToken.annot()) === String(label) && !(leftToken instanceof $c46b7dbea18e1f8c$var$OrToken)) {
            args.pop();
            return {
                prim: 'Left',
                args: [
                    leftToken.Encode(args)
                ]
            };
        } else if (String(rightToken.annot()) === String(label) && !(rightToken instanceof $c46b7dbea18e1f8c$var$OrToken)) {
            args.pop();
            return {
                prim: 'Right',
                args: [
                    rightToken.Encode(args)
                ]
            };
        } else {
            if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) {
                const val = leftToken.Encode(args);
                if (val) return {
                    prim: 'Left',
                    args: [
                        val
                    ]
                };
            }
            if (rightToken instanceof $c46b7dbea18e1f8c$var$OrToken) {
                const val = rightToken.Encode(args);
                if (val) return {
                    prim: 'Right',
                    args: [
                        val
                    ]
                };
            }
            return null;
        }
    }
    ExtractSignature() {
        const leftToken = this.createToken(this.val.args[0], this.getIdxForChildren(), 'Or');
        let keyCount = 1;
        if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(this.val.args[1], this.getIdxForChildren() + keyCount, 'Or');
        const newSig = [];
        if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) newSig.push(...leftToken.ExtractSignature());
        else for (const sig of leftToken.ExtractSignature())newSig.push([
            leftToken.annot(),
            ...sig
        ]);
        if (rightToken instanceof $c46b7dbea18e1f8c$var$OrToken) newSig.push(...rightToken.ExtractSignature());
        else for (const sig of rightToken.ExtractSignature())newSig.push([
            rightToken.annot(),
            ...sig
        ]);
        return newSig;
    }
    /**
     * @throws {@link OrValidationError}
     */ EncodeObject(args, semantic) {
        this.validateJavascriptObject(args);
        const label = Object.keys(args)[0];
        const leftToken = this.createToken(this.val.args[0], this.getIdxForChildren(), 'Or');
        let keyCount = 1;
        if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(this.val.args[1], this.getIdxForChildren() + keyCount, 'Or');
        if (String(leftToken.annot()) === String(label) && !(leftToken instanceof $c46b7dbea18e1f8c$var$OrToken)) return {
            prim: 'Left',
            args: [
                leftToken.EncodeObject(args[label], semantic)
            ]
        };
        else if (String(rightToken.annot()) === String(label) && !(rightToken instanceof $c46b7dbea18e1f8c$var$OrToken)) return {
            prim: 'Right',
            args: [
                rightToken.EncodeObject(args[label], semantic)
            ]
        };
        else {
            if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) {
                const val = leftToken.EncodeObject(args, semantic);
                if (val) return {
                    prim: 'Left',
                    args: [
                        val
                    ]
                };
            }
            if (rightToken instanceof $c46b7dbea18e1f8c$var$OrToken) {
                const val = rightToken.EncodeObject(args, semantic);
                if (val) return {
                    prim: 'Right',
                    args: [
                        val
                    ]
                };
            }
            return null;
        }
    }
    /**
     * @throws {@link OrValidationError}
     */ validateJavascriptObject(args) {
        if (typeof args !== 'object' || Array.isArray(args) || args === null || Object.keys(args).length !== 1) throw new $c46b7dbea18e1f8c$export$323d5d85c5838f7a(args, this, `EncodeObject expects an object with a single key but got: ${JSON.stringify(args)}`);
    }
    /**
     * @throws {@link OrValidationError}
     */ Execute(val, semantics) {
        const leftToken = this.createToken(this.val.args[0], this.getIdxForChildren(), 'Or');
        let keyCount = 1;
        if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(this.val.args[1], this.getIdxForChildren() + keyCount, 'Or');
        if (val.prim === 'Right') {
            if (rightToken instanceof $c46b7dbea18e1f8c$var$OrToken) return rightToken.Execute(val.args[0], semantics);
            else return {
                [rightToken.annot()]: rightToken.Execute(val.args[0], semantics)
            };
        } else if (val.prim === 'Left') {
            if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) return leftToken.Execute(val.args[0], semantics);
            return {
                [leftToken.annot()]: leftToken.Execute(val.args[0], semantics)
            };
        } else throw new $c46b7dbea18e1f8c$export$323d5d85c5838f7a(val, this, `Was expecting Left or Right prim but got: ${JSON.stringify(val.prim)}`);
    }
    traversal(getLeftValue, getRightValue, concat) {
        const leftToken = this.createToken(this.val.args[0], this.getIdxForChildren(), 'Or');
        let keyCount = 1;
        let leftValue;
        if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) {
            leftValue = getLeftValue(leftToken);
            keyCount = Object.keys(leftToken.ExtractSchema()).length;
        } else leftValue = {
            [leftToken.annot()]: getLeftValue(leftToken)
        };
        const rightToken = this.createToken(this.val.args[1], this.getIdxForChildren() + keyCount, 'Or');
        let rightValue;
        if (rightToken instanceof $c46b7dbea18e1f8c$var$OrToken) rightValue = getRightValue(rightToken);
        else rightValue = {
            [rightToken.annot()]: getRightValue(rightToken)
        };
        const res = concat(leftValue, rightValue);
        return res;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return this.traversal((leftToken)=>leftToken.ExtractSchema(), (rightToken)=>rightToken.ExtractSchema(), (leftValue, rightValue)=>Object.assign(Object.assign({}, leftValue), rightValue));
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$OrToken.prim,
            schema: this.traversal((leftToken)=>{
                if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) return leftToken.generateSchema().schema;
                else return leftToken.generateSchema();
            }, (rightToken)=>{
                if (rightToken instanceof $c46b7dbea18e1f8c$var$OrToken) return rightToken.generateSchema().schema;
                else return rightToken.generateSchema();
            }, (leftValue, rightValue)=>Object.assign(Object.assign({}, leftValue), rightValue))
        };
    }
    findToken(label) {
        const leftToken = this.createToken(this.val.args[0], this.getIdxForChildren(), 'Or');
        let keyCount = 1;
        if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(this.val.args[1], this.getIdxForChildren() + keyCount, 'Or');
        if (String(leftToken.annot()) === String(label) && !(leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) && leftToken instanceof $c46b7dbea18e1f8c$var$ComparableToken) return leftToken;
        else if (String(rightToken.annot()) === String(label) && !(rightToken instanceof $c46b7dbea18e1f8c$var$OrToken) && rightToken instanceof $c46b7dbea18e1f8c$var$ComparableToken) return rightToken;
        else {
            if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) {
                const tok = leftToken.findToken(label);
                if (tok) return tok;
            }
            if (rightToken instanceof $c46b7dbea18e1f8c$var$OrToken) {
                const tok = rightToken.findToken(label);
                if (tok) return tok;
            }
            return null;
        }
    }
    compare(val1, val2) {
        const labelVal1 = Object.keys(val1)[0];
        const labelVal2 = Object.keys(val2)[0];
        if (labelVal1 === labelVal2) {
            const token = this.findToken(labelVal1);
            if (token instanceof $c46b7dbea18e1f8c$var$ComparableToken) return token.compare(val1[labelVal1], val2[labelVal1]);
        } else {
            const encoded1 = JSON.stringify(this.EncodeObject(val1));
            const encoded2 = JSON.stringify(this.EncodeObject(val2));
            return encoded1 < encoded2 ? -1 : 1;
        }
    }
    ToKey(val) {
        return this.Execute(val);
    }
    ToBigMapKey(val) {
        return {
            key: this.EncodeObject(val),
            type: this.typeWithoutAnnotations()
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$OrToken.prim === tokenToFind) tokens.push(this);
        this.traversal((leftToken)=>leftToken.findAndReturnTokens(tokenToFind, tokens), (rightToken)=>rightToken.findAndReturnTokens(tokenToFind, tokens), (leftValue, rightValue)=>Object.assign(Object.assign({}, leftValue), rightValue));
        return tokens;
    }
    getIdxForChildren() {
        if ($c46b7dbea18e1f8c$export$50792b0e93539fde.fieldNumberingStrategy === 'Legacy') return this.idx;
        return this.parentTokenType === 'Or' ? this.idx : 0;
    }
}
$c46b7dbea18e1f8c$var$OrToken.prim = 'or';
/**
 *  @category Error
 *  @description Error that indicates in invalid token argument being passed
 */ class $c46b7dbea18e1f8c$export$8c55d85f07253962 extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(message){
        super(message);
        this.message = message;
        this.name = 'TokenArgumentValidationError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure occurring when doing a comparison of tokens
 */ class $c46b7dbea18e1f8c$export$562171fb2a9d2fdb extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(val1, val2){
        super();
        this.val1 = val1;
        this.val2 = val2;
        this.name = 'TokenComparisonError';
        this.message = `Tokens ${JSON.stringify(val1)} and ${JSON.stringify(val2)} are not comparable`;
    }
}
// collapse comb pair
/**
 * @throws {@link TokenArgumentValidationError}
 */ function $c46b7dbea18e1f8c$var$collapse$1(val, prim = $c46b7dbea18e1f8c$var$PairToken.prim) {
    if (Array.isArray(val)) return $c46b7dbea18e1f8c$var$collapse$1({
        prim: prim,
        args: val
    }, prim);
    if (val.args === undefined) throw new $c46b7dbea18e1f8c$export$8c55d85f07253962(`The value ${JSON.stringify(val)} is an invalid PairToken with no arguments, a pair must have two or more arguments.`);
    if (val.args.length > 2) return [
        val.args[0],
        {
            prim: prim,
            args: val.args.slice(1)
        }
    ];
    return [
        val.args[0],
        val.args[1]
    ];
}
class $c46b7dbea18e1f8c$var$PairToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac, parentTokenType){
        super(Array.isArray(val) ? {
            prim: $c46b7dbea18e1f8c$var$PairToken.prim,
            args: val
        } : val.prim ? val : {
            prim: $c46b7dbea18e1f8c$var$PairToken.prim,
            args: val
        }, idx, fac, parentTokenType);
    }
    args() {
        // collapse comb pair
        return $c46b7dbea18e1f8c$var$collapse$1(this.val);
    }
    tokens() {
        let cnt = 0;
        return this.args().map((a)=>{
            const tok = this.createToken(a, this.getIdxForChildren() + cnt, 'Pair');
            if (tok instanceof $c46b7dbea18e1f8c$var$PairToken) cnt += Object.keys(tok.ExtractSchema()).length;
            else cnt++;
            return tok;
        });
    }
    Encode(args) {
        return {
            prim: 'Pair',
            args: this.tokens().map((t)=>t.Encode(args))
        };
    }
    ExtractSignature() {
        const args = this.args();
        const leftToken = this.createToken(args[0], this.getIdxForChildren(), 'Pair');
        let keyCount = 1;
        if (leftToken instanceof $c46b7dbea18e1f8c$var$OrToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        const rightToken = this.createToken(args[1], this.getIdxForChildren() + keyCount, 'Pair');
        const newSig = [];
        for (const leftSig of leftToken.ExtractSignature())for (const rightSig of rightToken.ExtractSignature())newSig.push([
            ...leftSig,
            ...rightSig
        ]);
        return newSig;
    }
    ToBigMapKey(val) {
        return {
            key: this.EncodeObject(val),
            type: this.typeWithoutAnnotations()
        };
    }
    ToKey(val) {
        return this.Execute(val);
    }
    EncodeObject(args, semantic) {
        const [leftToken, rightToken] = this.tokens();
        let leftValue;
        if (leftToken instanceof $c46b7dbea18e1f8c$var$PairToken && !leftToken.hasAnnotations()) leftValue = args;
        else leftValue = args[leftToken.annot()];
        let rightValue;
        if (rightToken instanceof $c46b7dbea18e1f8c$var$PairToken && !rightToken.hasAnnotations()) rightValue = args;
        else rightValue = args[rightToken.annot()];
        return {
            prim: 'Pair',
            args: [
                leftToken.EncodeObject(leftValue, semantic),
                rightToken.EncodeObject(rightValue, semantic)
            ]
        };
    }
    traversal(getLeftValue, getRightValue) {
        const args = this.args();
        const leftToken = this.createToken(args[0], this.getIdxForChildren(), 'Pair');
        let keyCount = 1;
        let leftValue;
        if (leftToken instanceof $c46b7dbea18e1f8c$var$PairToken && !leftToken.hasAnnotations()) {
            leftValue = getLeftValue(leftToken);
            if (leftToken instanceof $c46b7dbea18e1f8c$var$PairToken) keyCount = Object.keys(leftToken.ExtractSchema()).length;
        } else leftValue = {
            [leftToken.annot()]: getLeftValue(leftToken)
        };
        const rightToken = this.createToken(args[1], this.getIdxForChildren() + keyCount, 'Pair');
        let rightValue;
        if (rightToken instanceof $c46b7dbea18e1f8c$var$PairToken && !rightToken.hasAnnotations()) rightValue = getRightValue(rightToken);
        else rightValue = {
            [rightToken.annot()]: getRightValue(rightToken)
        };
        const res = Object.assign(Object.assign({}, leftValue), rightValue);
        return res;
    }
    Execute(val, semantics) {
        const args = $c46b7dbea18e1f8c$var$collapse$1(val, 'Pair');
        return this.traversal((leftToken)=>leftToken.Execute(args[0], semantics), (rightToken)=>rightToken.Execute(args[1], semantics));
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return this.traversal((leftToken)=>leftToken.ExtractSchema(), (rightToken)=>rightToken.ExtractSchema());
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$PairToken.prim,
            schema: this.traversal((leftToken)=>{
                if (leftToken instanceof $c46b7dbea18e1f8c$var$PairToken && !leftToken.hasAnnotations()) return leftToken.generateSchema().schema;
                else return leftToken.generateSchema();
            }, (rightToken)=>{
                if (rightToken instanceof $c46b7dbea18e1f8c$var$PairToken && !rightToken.hasAnnotations()) return rightToken.generateSchema().schema;
                else return rightToken.generateSchema();
            })
        };
    }
    /**
     * @throws {@link TokenComparisonError}
     */ compare(val1, val2) {
        const [leftToken, rightToken] = this.tokens();
        const getValue = (token, args)=>{
            if (token instanceof $c46b7dbea18e1f8c$var$PairToken && !token.hasAnnotations()) return args;
            else return args[token.annot()];
        };
        if (leftToken instanceof $c46b7dbea18e1f8c$var$ComparableToken && rightToken instanceof $c46b7dbea18e1f8c$var$ComparableToken) {
            const result = leftToken.compare(getValue(leftToken, val1), getValue(leftToken, val2));
            if (result === 0) return rightToken.compare(getValue(rightToken, val1), getValue(rightToken, val2));
            return result;
        }
        throw new $c46b7dbea18e1f8c$export$562171fb2a9d2fdb(val1, val2);
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$PairToken.prim === tokenToFind) tokens.push(this);
        this.tokens().map((t)=>t.findAndReturnTokens(tokenToFind, tokens));
        return tokens;
    }
    getIdxForChildren() {
        if ($c46b7dbea18e1f8c$export$50792b0e93539fde.fieldNumberingStrategy === 'Legacy') return this.idx;
        return this.parentTokenType === 'Pair' ? this.idx : 0;
    }
}
$c46b7dbea18e1f8c$var$PairToken.prim = 'pair';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Nat
 */ class $c46b7dbea18e1f8c$export$366b98b49aef7be5 extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'NatValidationError';
    }
}
class $c46b7dbea18e1f8c$var$NatToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val[Object.keys(val)[0]]);
    }
    /**
     * @throws {@link NatValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            int: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).toFixed()
        };
    }
    /**
     * @throws {@link NatValidationError}
     */ validate(val) {
        const bigNumber = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val);
        if (bigNumber.isNaN()) throw new $c46b7dbea18e1f8c$export$366b98b49aef7be5(val, this, `Value is not a number: ${JSON.stringify(val)}`);
        if (bigNumber.isNegative()) throw new $c46b7dbea18e1f8c$export$366b98b49aef7be5(val, this, `Value cannot be negative: ${JSON.stringify(val)}`);
    }
    /**
     * @throws {@link NatValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$NatToken.prim]) return semantic[$c46b7dbea18e1f8c$var$NatToken.prim](val);
        return {
            int: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).toFixed()
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$NatToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$NatToken.prim,
            schema: $c46b7dbea18e1f8c$var$NatToken.prim
        };
    }
    ToBigMapKey(val) {
        return {
            key: {
                int: String(val)
            },
            type: {
                prim: $c46b7dbea18e1f8c$var$NatToken.prim
            }
        };
    }
    ToKey({ int: int }) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(int);
    }
    compare(nat1, nat2) {
        const o1 = Number(nat1);
        const o2 = Number(nat2);
        if (o1 === o2) return 0;
        return o1 < o2 ? -1 : 1;
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$NatToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$NatToken.prim = 'nat';
class $c46b7dbea18e1f8c$var$StringToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return val[Object.keys(val)[0]];
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$StringToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$StringToken.prim,
            schema: $c46b7dbea18e1f8c$var$StringToken.prim
        };
    }
    Encode(args) {
        const val = args.pop();
        return {
            string: val
        };
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$StringToken.prim]) return semantic[$c46b7dbea18e1f8c$var$StringToken.prim](val);
        return {
            string: val
        };
    }
    ToKey({ string: string }) {
        return string;
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $c46b7dbea18e1f8c$var$StringToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$StringToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$StringToken.prim = 'string';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing an Address
 */ class $c46b7dbea18e1f8c$export$c95a19675a95f686 extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'AddressValidationError';
    }
}
class $c46b7dbea18e1f8c$var$AddressToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    ToBigMapKey(val) {
        const decoded = (0, $6ed3c564aba0f912$export$c5fd02d48c871a17)(val);
        return {
            key: {
                bytes: decoded
            },
            type: {
                prim: 'bytes'
            }
        };
    }
    /**
     * @throws {@link AddressValidationError}
     */ validate(value) {
        if ((0, $6ed3c564aba0f912$export$f78173835dcde49f)(value) !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new $c46b7dbea18e1f8c$export$c95a19675a95f686(value, this, `Address is not valid: ${JSON.stringify(value)}`);
    }
    /**
     * @throws {@link AddressValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link AddressValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$AddressToken.prim]) return semantic[$c46b7dbea18e1f8c$var$AddressToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link AddressValidationError}
     */ Execute(val) {
        if (val.string) return val.string;
        if (!val.bytes) throw new $c46b7dbea18e1f8c$export$c95a19675a95f686(val, this, `cannot be missing both string and bytes: ${JSON.stringify(val)}`);
        return (0, $6ed3c564aba0f912$export$b149ba8ff44e4e70)(val.bytes);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$AddressToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$AddressToken.prim,
            schema: $c46b7dbea18e1f8c$var$AddressToken.prim
        };
    }
    /**
     * @throws {@link AddressValidationError}
     */ ToKey({ bytes: bytes, string: string }) {
        if (string) return string;
        if (!bytes) throw new $c46b7dbea18e1f8c$export$c95a19675a95f686({
            bytes: bytes,
            string: string
        }, this, `cannot be missing both string and bytes ${JSON.stringify({
            string: string,
            bytes: bytes
        })}`);
        return (0, $6ed3c564aba0f912$export$b149ba8ff44e4e70)(bytes);
    }
    compare(address1, address2) {
        const isImplicit = (address)=>{
            return address.startsWith('tz');
        };
        const implicit1 = isImplicit(address1);
        const implicit2 = isImplicit(address2);
        if (implicit1 && !implicit2) return -1;
        else if (implicit2 && !implicit1) return 1;
        return super.compare(address1, address2);
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$AddressToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$AddressToken.prim = 'address';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Map
 */ class $c46b7dbea18e1f8c$export$5f25b74245a0411c extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'MapValidationError';
    }
}
class $c46b7dbea18e1f8c$var$MapToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get ValueSchema() {
        return this.createToken(this.val.args[1], 0);
    }
    get KeySchema() {
        return this.createToken(this.val.args[0], 0);
    }
    /**
     * @throws {@link MapValidationError}
     */ validate(value) {
        if (!$c46b7dbea18e1f8c$export$485fc446a4c98bc8.isMichelsonMap(value)) throw new $c46b7dbea18e1f8c$export$5f25b74245a0411c(value, this, `Value ${JSON.stringify(value)} is not a valid MichelsonMap`);
    }
    Execute(val, semantics) {
        const map = new $c46b7dbea18e1f8c$export$485fc446a4c98bc8(this.val);
        val.forEach((current)=>{
            map.set(this.KeySchema.ToKey(current.args[0]), this.ValueSchema.Execute(current.args[1], semantics));
        });
        return map;
    }
    objLitToMichelsonMap(val) {
        if (val instanceof $c46b7dbea18e1f8c$export$485fc446a4c98bc8) return val;
        if (typeof val === 'object') {
            if (Object.keys(val).length === 0) return new $c46b7dbea18e1f8c$export$485fc446a4c98bc8();
            else return $c46b7dbea18e1f8c$export$485fc446a4c98bc8.fromLiteral(val);
        }
        return val;
    }
    /**
     * @throws {@link MapValidationError}
     */ Encode(args) {
        const val = this.objLitToMichelsonMap(args.pop());
        this.validate(val);
        return Array.from(val.keys()).sort((a, b)=>this.KeySchema.compare(a, b)).map((key)=>{
            return {
                prim: 'Elt',
                args: [
                    this.KeySchema.EncodeObject(key),
                    this.ValueSchema.EncodeObject(val.get(key))
                ]
            };
        });
    }
    /**
     * @throws {@link MapValidationError}
     */ EncodeObject(args, semantic) {
        const val = this.objLitToMichelsonMap(args);
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$MapToken.prim]) return semantic[$c46b7dbea18e1f8c$var$MapToken.prim](val);
        return Array.from(val.keys()).sort((a, b)=>this.KeySchema.compare(a, b)).map((key)=>{
            return {
                prim: 'Elt',
                args: [
                    this.KeySchema.EncodeObject(key),
                    this.ValueSchema.EncodeObject(val.get(key))
                ]
            };
        });
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            map: {
                key: this.KeySchema.ExtractSchema(),
                value: this.ValueSchema.ExtractSchema()
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$MapToken.prim,
            schema: {
                key: this.KeySchema.generateSchema(),
                value: this.ValueSchema.generateSchema()
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$MapToken.prim === tokenToFind) tokens.push(this);
        this.KeySchema.findAndReturnTokens(tokenToFind, tokens);
        this.ValueSchema.findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$MapToken.prim = 'map';
class $c46b7dbea18e1f8c$var$BoolToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return String(val.prim).toLowerCase() === 'true' ? true : false;
    }
    Encode(args) {
        const val = args.pop();
        return {
            prim: val ? 'True' : 'False'
        };
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$BoolToken.prim]) return semantic[$c46b7dbea18e1f8c$var$BoolToken.prim](val);
        return {
            prim: val ? 'True' : 'False'
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$BoolToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$BoolToken.prim,
            schema: $c46b7dbea18e1f8c$var$BoolToken.prim
        };
    }
    ToBigMapKey(val) {
        return {
            key: this.EncodeObject(val),
            type: {
                prim: $c46b7dbea18e1f8c$var$BoolToken.prim
            }
        };
    }
    ToKey(val) {
        return this.EncodeObject(val);
    }
    compare(val1, val2) {
        if (val1 && val2 || !val1 && !val2) return 0;
        else if (val1) return 1;
        else return -1;
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$BoolToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$BoolToken.prim = 'bool';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Contract
 */ class $c46b7dbea18e1f8c$export$4d36cb06e9af864a extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'ContractValidationError';
    }
}
class $c46b7dbea18e1f8c$var$ContractToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link ContractValidationError}
     */ validate(value) {
        // tz1,tz2 and tz3 seems to be valid contract values (for Unit contract)
        if ((0, $6ed3c564aba0f912$export$f78173835dcde49f)(value) !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new $c46b7dbea18e1f8c$export$4d36cb06e9af864a(value, this, `Value ${JSON.stringify(value)} is not a valid contract address.`);
        return null;
    }
    /**
     * @throws {@link ContractValidationError}
     */ Execute(val) {
        if (val.string) return val.string;
        if (!val.bytes) throw new $c46b7dbea18e1f8c$export$4d36cb06e9af864a(val, this, `Value ${JSON.stringify(val)} is not a valid contract address. must contain bytes or string.`);
        return (0, $6ed3c564aba0f912$export$b149ba8ff44e4e70)(val.bytes);
    }
    /**
     * @throws {@link ContractValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link ContractValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$ContractToken.prim]) return semantic[$c46b7dbea18e1f8c$var$ContractToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$ContractToken.prim;
    }
    generateSchema() {
        const valueSchema = this.createToken(this.val.args[0], 0);
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$ContractToken.prim,
            schema: {
                parameter: this.val.args[0] ? valueSchema.generateSchema() : {}
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$ContractToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$ContractToken.prim = 'contract';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a List
 */ class $c46b7dbea18e1f8c$export$bba6abe6d545f230 extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'ListValidationError';
    }
}
class $c46b7dbea18e1f8c$var$ListToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get valueSchema() {
        return this.createToken(this.val.args[0], this.idx);
    }
    /**
     * @throws {@link ListValidationError}
     */ validate(value) {
        if (!Array.isArray(value)) throw new $c46b7dbea18e1f8c$export$bba6abe6d545f230(value, this, `Value ${JSON.stringify(value)} is not a valid array`);
    }
    /**
     * @throws {@link ListValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        const schema = this.createToken(this.val.args[0], 0);
        return val.reduce((prev, current)=>{
            return [
                ...prev,
                schema.EncodeObject(current)
            ];
        }, []);
    }
    /**
     * @throws {@link ListValidationError}
     */ Execute(val, semantics) {
        const schema = this.createToken(this.val.args[0], 0);
        this.validate(val);
        return val.reduce((prev, current)=>{
            return [
                ...prev,
                schema.Execute(current, semantics)
            ];
        }, []);
    }
    /**
     * @throws {@link ListValidationError}
     */ EncodeObject(args, semantic) {
        const schema = this.createToken(this.val.args[0], 0);
        this.validate(args);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$ListToken.prim]) return semantic[$c46b7dbea18e1f8c$var$ListToken.prim](args);
        return args.reduce((prev, current)=>{
            return [
                ...prev,
                schema.EncodeObject(current)
            ];
        }, []);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            [$c46b7dbea18e1f8c$var$ListToken.prim]: this.valueSchema.ExtractSchema()
        };
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$ListToken.prim,
            schema: this.valueSchema.generateSchema()
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$ListToken.prim === tokenToFind) tokens.push(this);
        this.createToken(this.val.args[0], this.idx).findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$ListToken.prim = 'list';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Mutez
 */ class $c46b7dbea18e1f8c$export$b534343d605edcc extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'MutezValidationError';
    }
}
class $c46b7dbea18e1f8c$var$MutezToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val[Object.keys(val)[0]]);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$MutezToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$MutezToken.prim,
            schema: $c46b7dbea18e1f8c$var$MutezToken.prim
        };
    }
    /**
     * @throws {@link MutezValidationError}
     */ validate(val) {
        const bigNumber = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val);
        if (bigNumber.isNaN()) throw new $c46b7dbea18e1f8c$export$b534343d605edcc(val, this, `Value is not a number: ${val}`);
    }
    /**
     * @throws {@link MutezValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            int: String(val).toString()
        };
    }
    /**
     * @throws {@link MutezValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$MutezToken.prim]) return semantic[$c46b7dbea18e1f8c$var$MutezToken.prim](val);
        return {
            int: String(val).toString()
        };
    }
    ToBigMapKey(val) {
        return {
            key: {
                int: String(val)
            },
            type: {
                prim: $c46b7dbea18e1f8c$var$MutezToken.prim
            }
        };
    }
    ToKey({ int: int }) {
        return int;
    }
    compare(mutez1, mutez2) {
        const o1 = Number(mutez1);
        const o2 = Number(mutez2);
        if (o1 === o2) return 0;
        return o1 < o2 ? -1 : 1;
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$MutezToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$MutezToken.prim = 'mutez';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Bytes
 */ class $c46b7dbea18e1f8c$export$e22dd01a9e7c6e99 extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'BytesValidationError';
    }
}
class $c46b7dbea18e1f8c$var$BytesToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    ToBigMapKey(val) {
        return {
            key: {
                bytes: val
            },
            type: {
                prim: $c46b7dbea18e1f8c$var$BytesToken.prim
            }
        };
    }
    /**
     * @throws {@link BytesValidationError}
     */ validate(val) {
        if (typeof val === 'string' && /^[0-9a-fA-F]*$/.test(val) && val.length % 2 === 0) return;
        throw new $c46b7dbea18e1f8c$export$e22dd01a9e7c6e99(val, this, `Invalid bytes: ${val}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $c46b7dbea18e1f8c$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link BytesValidationError}
     */ Encode(args) {
        let val = args.pop();
        val = (0, $6ed3c564aba0f912$export$b2f5d0058897e6e6)(this.convertUint8ArrayToHexString(val));
        this.validate(val);
        return {
            bytes: String(val).toString()
        };
    }
    /**
     * @throws {@link BytesValidationError}
     */ EncodeObject(val, semantic) {
        val = this.convertUint8ArrayToHexString(val);
        if (typeof val === 'string') val = (0, $6ed3c564aba0f912$export$b2f5d0058897e6e6)(val);
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$BytesToken.prim]) return semantic[$c46b7dbea18e1f8c$var$BytesToken.prim](val);
        return {
            bytes: String(val).toString()
        };
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$BytesToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$BytesToken.prim,
            schema: $c46b7dbea18e1f8c$var$BytesToken.prim
        };
    }
    ToKey({ bytes: bytes, string: string }) {
        if (string) return string;
        return bytes;
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$BytesToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$BytesToken.prim = 'bytes';
class $c46b7dbea18e1f8c$var$OptionToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    subToken() {
        return this.createToken(this.val.args[0], this.idx);
    }
    schema() {
        return this.createToken(this.val.args[0], 0);
    }
    annot() {
        return Array.isArray(this.val.annots) ? super.annot() : this.createToken(this.val.args[0], this.idx).annot();
    }
    Encode(args) {
        const value = args;
        if (value === undefined || value === null) return {
            prim: 'None'
        };
        else if (Array.isArray(value) && (value[value.length - 1] === undefined || value[value.length - 1] === null)) {
            value.pop();
            return {
                prim: 'None'
            };
        }
        return {
            prim: 'Some',
            args: [
                this.schema().Encode(args)
            ]
        };
    }
    EncodeObject(args, semantic) {
        let value = args;
        if (value === undefined || value === null) return {
            prim: 'None'
        };
        value = typeof value === 'object' && 'Some' in value ? value['Some'] : value;
        return {
            prim: 'Some',
            args: [
                this.schema().EncodeObject(value, semantic)
            ]
        };
    }
    Execute(val, semantics) {
        if (val.prim === 'None') return null;
        return {
            Some: this.schema().Execute(val.args[0], semantics)
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            Some: this.schema().ExtractSchema()
        };
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$OptionToken.prim,
            schema: this.schema().generateSchema()
        };
    }
    ExtractSignature() {
        return [
            ...this.schema().ExtractSignature()
        ];
    }
    get KeySchema() {
        return this.schema();
    }
    compare(val1, val2) {
        if (!val1) return -1;
        else if (!val2) return 1;
        return this.KeySchema.compare(val1, val2);
    }
    ToKey(val) {
        return this.Execute(val);
    }
    ToBigMapKey(val) {
        return {
            key: this.EncodeObject(val),
            type: this.typeWithoutAnnotations()
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$OptionToken.prim === tokenToFind) tokens.push(this);
        this.subToken().findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$OptionToken.prim = 'option';
class $c46b7dbea18e1f8c$var$TimestampToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        if (val.string && /^\d+$/.test(val.string)) return new Date(Number(val.string) * 1000).toISOString();
        else if (val.string) return new Date(val.string).toISOString();
        else if (val.int) return new Date(Number(val.int) * 1000).toISOString();
    }
    Encode(args) {
        const val = args.pop();
        if (typeof val === 'number') return {
            int: String(val)
        };
        else return {
            string: val
        };
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$TimestampToken.prim]) return semantic[$c46b7dbea18e1f8c$var$TimestampToken.prim](val);
        if (typeof val === 'number') return {
            int: String(val)
        };
        else return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$TimestampToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$TimestampToken.prim,
            schema: $c46b7dbea18e1f8c$var$TimestampToken.prim
        };
    }
    ToKey({ string: string }) {
        return string;
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $c46b7dbea18e1f8c$var$TimestampToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$TimestampToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$TimestampToken.prim = 'timestamp';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Int
 */ class $c46b7dbea18e1f8c$export$a192a91ba6ce6f9 extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'IntValidationError';
    }
}
class $c46b7dbea18e1f8c$var$IntToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val[Object.keys(val)[0]]);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$IntToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$IntToken.prim,
            schema: $c46b7dbea18e1f8c$var$IntToken.prim
        };
    }
    /**
     * @throws {@link IntValidationError}
     */ validate(val) {
        const bigNumber = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val);
        if (bigNumber.isNaN()) throw new $c46b7dbea18e1f8c$export$a192a91ba6ce6f9(val, this, `Value is not a number: ${JSON.stringify(val)}`);
    }
    /**
     * @throws {@link IntValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            int: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).toFixed()
        };
    }
    /**
     * @throws {@link IntValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$IntToken.prim]) return semantic[$c46b7dbea18e1f8c$var$IntToken.prim](val);
        return {
            int: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val).toFixed()
        };
    }
    ToBigMapKey(val) {
        return {
            key: {
                int: String(val)
            },
            type: {
                prim: $c46b7dbea18e1f8c$var$IntToken.prim
            }
        };
    }
    ToKey({ int: int }) {
        return int;
    }
    compare(int1, int2) {
        const o1 = Number(int1);
        const o2 = Number(int2);
        if (o1 === o2) return 0;
        return o1 < o2 ? -1 : 1;
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$IntToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$IntToken.prim = 'int';
class $c46b7dbea18e1f8c$var$UnitToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Encode(args) {
        args.pop();
        return {
            prim: 'Unit'
        };
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$UnitToken.prim]) return semantic[$c46b7dbea18e1f8c$var$UnitToken.prim](val);
        return {
            prim: 'Unit'
        };
    }
    Execute(_val) {
        return $c46b7dbea18e1f8c$export$d703b7d35511419c;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$UnitToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$UnitToken.prim,
            schema: $c46b7dbea18e1f8c$var$UnitToken.prim
        };
    }
    compare(_val1, _val2) {
        return 0;
    }
    ToKey(_val) {
        return $c46b7dbea18e1f8c$export$d703b7d35511419c;
    }
    ToBigMapKey(_val) {
        return {
            key: {
                prim: 'Unit'
            },
            type: {
                prim: $c46b7dbea18e1f8c$var$UnitToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$UnitToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$UnitToken.prim = 'unit';
const $c46b7dbea18e1f8c$var$publicKeyPrefixLength = 4;
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Key
 */ class $c46b7dbea18e1f8c$export$9c29d49ec877779c extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'KeyValidationError';
    }
}
class $c46b7dbea18e1f8c$var$KeyToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        if (val.string) return val.string;
        return (0, $6ed3c564aba0f912$export$a0511d6cbab6225d)(val.bytes);
    }
    /**
     * @throws {@link KeyValidationError}
     */ validate(value) {
        if ((0, $6ed3c564aba0f912$export$7e268ff6bd252dc4)(value) !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new $c46b7dbea18e1f8c$export$9c29d49ec877779c(value, this, 'Key is not valid');
    }
    /**
     * @throws {@link KeyValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link KeyValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$KeyToken.prim]) return semantic[$c46b7dbea18e1f8c$var$KeyToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$KeyToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$KeyToken.prim,
            schema: $c46b7dbea18e1f8c$var$KeyToken.prim
        };
    }
    ToKey(val) {
        return this.Execute(val);
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $c46b7dbea18e1f8c$var$KeyToken.prim
            }
        };
    }
    compare(key1, key2) {
        const keyPrefix1 = this.getPrefix(key1);
        const keyPrefix2 = this.getPrefix(key2);
        if (keyPrefix1 === (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDPK && keyPrefix2 !== (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDPK) return -1;
        else if (keyPrefix1 === (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPPK && keyPrefix2 !== (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPPK) return keyPrefix2 === (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDPK ? 1 : -1;
        else if (keyPrefix1 === (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2PK) {
            if (keyPrefix2 !== (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2PK) return 1;
            const keyBytes1 = this.getP256PublicKeyComparableBytes(key1);
            const keyBytes2 = this.getP256PublicKeyComparableBytes(key2);
            return $c46b7dbea18e1f8c$require$Buffer.compare(keyBytes1, keyBytes2);
        }
        return super.compare(key1, key2);
    }
    getPrefix(val) {
        return val.substring(0, $c46b7dbea18e1f8c$var$publicKeyPrefixLength);
    }
    getP256PublicKeyComparableBytes(p2pk) {
        return (0, $6ed3c564aba0f912$export$b9856b5e6fd1a05f)(p2pk, (0, $6ed3c564aba0f912$export$82e9f45cca5ba907)[(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2PK]).slice(1);
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$KeyToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$KeyToken.prim = 'key';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing Key Hash
 */ class $c46b7dbea18e1f8c$export$8ae52bbf96f5e9de extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'KeyHashValidationError';
    }
}
class $c46b7dbea18e1f8c$var$KeyHashToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        if (val.string) return val.string;
        return (0, $6ed3c564aba0f912$export$1ef834a164cef85e)(val.bytes);
    }
    /**
     * @throws {@link KeyHashValidationError}
     */ validate(value) {
        if ((0, $6ed3c564aba0f912$export$dbd3afbe999d4c3d)(value) !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new $c46b7dbea18e1f8c$export$8ae52bbf96f5e9de(value, this, `KeyHash is not valid: ${JSON.stringify(value)}`);
    }
    /**
     * @throws {@link KeyHashValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link KeyHashValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$KeyHashToken.prim]) return semantic[$c46b7dbea18e1f8c$var$KeyHashToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$KeyHashToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$KeyHashToken.prim,
            schema: $c46b7dbea18e1f8c$var$KeyHashToken.prim
        };
    }
    ToKey({ string: string, bytes: bytes }) {
        if (string) return string;
        return (0, $6ed3c564aba0f912$export$1ef834a164cef85e)(bytes);
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $c46b7dbea18e1f8c$var$KeyHashToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$KeyHashToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$KeyHashToken.prim = 'key_hash';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Signature
 */ class $c46b7dbea18e1f8c$export$41950d69fe7deb27 extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'SignatureValidationError';
    }
}
class $c46b7dbea18e1f8c$var$SignatureToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        if (val.string) return val.string;
        // TODO decode the signature
        return val.bytes;
    }
    /**
     * @throws {@link SignatureValidationError}
     */ validate(value) {
        if ((0, $6ed3c564aba0f912$export$f680e6c2b3919edb)(value) !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new $c46b7dbea18e1f8c$export$41950d69fe7deb27(value, this, 'Signature is not valid');
    }
    /**
     * @throws {@link SignatureValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link SignatureValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$SignatureToken.prim]) return semantic[$c46b7dbea18e1f8c$var$SignatureToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$SignatureToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$SignatureToken.prim,
            schema: $c46b7dbea18e1f8c$var$SignatureToken.prim
        };
    }
    ToKey(val) {
        return this.Execute(val);
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $c46b7dbea18e1f8c$var$SignatureToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$SignatureToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$SignatureToken.prim = 'signature';
class $c46b7dbea18e1f8c$var$LambdaToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get paramSchema() {
        return this.createToken(this.val.args[0], this.idx);
    }
    get returnSchema() {
        return this.createToken(this.val.args[1], this.idx + 1);
    }
    Execute(val) {
        if (val.string) return val.string;
        else return val;
    }
    Encode(args) {
        const val = args.pop();
        return val;
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$LambdaToken.prim]) return semantic[$c46b7dbea18e1f8c$var$LambdaToken.prim](val);
        return val;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            [$c46b7dbea18e1f8c$var$LambdaToken.prim]: {
                parameters: this.paramSchema.ExtractSchema(),
                returns: this.returnSchema.ExtractSchema()
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$LambdaToken.prim,
            schema: {
                parameters: this.paramSchema.generateSchema(),
                returns: this.returnSchema.generateSchema()
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$LambdaToken.prim === tokenToFind) tokens.push(this);
        this.createToken(this.val.args[0], this.idx).findAndReturnTokens(tokenToFind, tokens);
        this.createToken(this.val.args[1], this.idx).findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$LambdaToken.prim = 'lambda';
class $c46b7dbea18e1f8c$var$OperationToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    Execute(val) {
        return val.string;
    }
    Encode(...args) {
        const val = args.pop();
        return {
            string: val
        };
    }
    EncodeObject(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$OperationToken.prim]) return semantic[$c46b7dbea18e1f8c$var$OperationToken.prim](val);
        return {
            string: val
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$OperationToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$OperationToken.prim,
            schema: $c46b7dbea18e1f8c$var$OperationToken.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$OperationToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$OperationToken.prim = 'operation';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Set
 */ class $c46b7dbea18e1f8c$export$786223ef641acb63 extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'SetValidationError';
    }
}
class $c46b7dbea18e1f8c$var$SetToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get KeySchema() {
        return this.createToken(this.val.args[0], 0);
    }
    /**
     * @throws {@link SetValidationError}
     */ validate(value) {
        if (!Array.isArray(value)) throw new $c46b7dbea18e1f8c$export$786223ef641acb63(value, this, `Value ${JSON.stringify(value)} is not an array`);
    }
    /**
     * @throws {@link SetValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return val.sort((a, b)=>this.KeySchema.compare(a, b)).reduce((prev, current)=>{
            return [
                ...prev,
                this.KeySchema.EncodeObject(current)
            ];
        }, []);
    }
    Execute(val, semantics) {
        return val.reduce((prev, current)=>{
            return [
                ...prev,
                this.KeySchema.Execute(current, semantics)
            ];
        }, []);
    }
    /**
     * @throws {@link SetValidationError}
     */ EncodeObject(args, semantic) {
        this.validate(args);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$SetToken.prim]) return semantic[$c46b7dbea18e1f8c$var$SetToken.prim](args);
        return args.sort((a, b)=>this.KeySchema.compare(a, b)).reduce((prev, current)=>{
            return [
                ...prev,
                this.KeySchema.EncodeObject(current)
            ];
        }, []);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$SetToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$SetToken.prim,
            schema: this.KeySchema.generateSchema()
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$SetToken.prim === tokenToFind) tokens.push(this);
        this.KeySchema.findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$SetToken.prim = 'set';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a ChainID
 */ class $c46b7dbea18e1f8c$export$ec6d6a37188dd52 extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'ChainIDValidationError';
    }
}
class $c46b7dbea18e1f8c$var$ChainIDToken extends $c46b7dbea18e1f8c$var$ComparableToken {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link ChainIDValidationError}
     */ validate(value) {
        if ((0, $6ed3c564aba0f912$export$cb16a5d2af893df6)(value) !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new $c46b7dbea18e1f8c$export$ec6d6a37188dd52(value, this, `Value ${JSON.stringify(value)} is not a valid ChainID`);
    }
    Execute(val) {
        return val[Object.keys(val)[0]];
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$ChainIDToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$ChainIDToken.prim,
            schema: $c46b7dbea18e1f8c$var$ChainIDToken.prim
        };
    }
    /**
     * @throws {@link ChainIDValidationError}
     */ Encode(args) {
        const val = args.pop();
        this.validate(val);
        return {
            string: val
        };
    }
    /**
     * @throws {@link ChainIDValidationError}
     */ EncodeObject(val, semantic) {
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$ChainIDToken.prim]) return semantic[$c46b7dbea18e1f8c$var$ChainIDToken.prim](val);
        return {
            string: val
        };
    }
    ToKey({ string: string }) {
        return string;
    }
    ToBigMapKey(val) {
        return {
            key: {
                string: val
            },
            type: {
                prim: $c46b7dbea18e1f8c$var$ChainIDToken.prim
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$ChainIDToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$ChainIDToken.prim = 'chain_id';
/**
 *  @category Error
 *  @description Error that indicates a failure when encoding and sending a ticket to the blockchain
 */ class $c46b7dbea18e1f8c$export$b30bdb452623318c extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(){
        super();
        this.name = 'TicketEncodeError';
        this.message = 'Tickets cannot be sent to the blockchain; they are created on-chain';
    }
}
const $c46b7dbea18e1f8c$var$ticketerType$1 = {
    prim: 'contract'
};
const $c46b7dbea18e1f8c$var$amountType$1 = {
    prim: 'int'
};
class $c46b7dbea18e1f8c$var$TicketToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get valueToken() {
        return this.createToken(this.val.args[0], this.idx);
    }
    /**
     * @throws {@link EncodeTicketError}
     */ Encode(_args) {
        throw new $c46b7dbea18e1f8c$export$b30bdb452623318c();
    }
    /**
     * @throws {@link EncodeTicketError}
     */ EncodeObject(args, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$TicketToken.prim]) return semantic[$c46b7dbea18e1f8c$var$TicketToken.prim](args, this.val);
        throw new $c46b7dbea18e1f8c$export$b30bdb452623318c();
    }
    Execute(val, semantics) {
        if (semantics && semantics[$c46b7dbea18e1f8c$var$TicketToken.prim]) return semantics[$c46b7dbea18e1f8c$var$TicketToken.prim](val, this.val);
        const ticketer = this.createToken($c46b7dbea18e1f8c$var$ticketerType$1, this.idx);
        const value = this.valueToken;
        const amount = this.createToken($c46b7dbea18e1f8c$var$amountType$1, this.idx);
        if (undefined === val.args[2] && undefined !== val.args[1].args) return {
            ticketer: ticketer.Execute(val.args[0], semantics),
            value: value.Execute(val.args[1].args[0], semantics),
            amount: amount.Execute(val.args[1].args[1], semantics)
        };
        return {
            ticketer: ticketer.Execute(val.args[0], semantics),
            value: value.Execute(val.args[1], semantics),
            amount: amount.Execute(val.args[2], semantics)
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            ticketer: $c46b7dbea18e1f8c$var$ContractToken.prim,
            value: this.valueToken.ExtractSchema(),
            amount: $c46b7dbea18e1f8c$var$IntToken.prim
        };
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$TicketToken.prim,
            schema: {
                value: this.valueToken.generateSchema(),
                ticketer: {
                    __michelsonType: $c46b7dbea18e1f8c$var$ContractToken.prim,
                    schema: $c46b7dbea18e1f8c$var$ContractToken.prim
                },
                amount: {
                    __michelsonType: $c46b7dbea18e1f8c$var$IntToken.prim,
                    schema: $c46b7dbea18e1f8c$var$IntToken.prim
                }
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$TicketToken.prim === tokenToFind) tokens.push(this);
        this.valueToken.findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$TicketToken.prim = 'ticket';
/**
 *  @category Error
 *  @description Error that indicates a failure when encoding and sending a ticket to the blockchain
 */ class $c46b7dbea18e1f8c$var$EncodeTicketDeprecatedError extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(){
        super();
        this.name = 'TicketDeprecatedEncodeError';
        this.message = 'Ticket_deprecated cannot be sent to the blockchain; they are created on-chain';
    }
}
const $c46b7dbea18e1f8c$var$ticketerType = {
    prim: 'contract'
};
const $c46b7dbea18e1f8c$var$amountType = {
    prim: 'int'
};
class $c46b7dbea18e1f8c$var$TicketDeprecatedToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    get valueToken() {
        return this.createToken(this.val.args[0], this.idx);
    }
    /**
     * @throws {@link EncodeTicketDeprecatedError}
     */ Encode(_args) {
        throw new $c46b7dbea18e1f8c$var$EncodeTicketDeprecatedError();
    }
    /**
     * @throws {@link EncodeTicketDeprecatedError}
     */ EncodeObject(args, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$TicketDeprecatedToken.prim]) return semantic[$c46b7dbea18e1f8c$var$TicketDeprecatedToken.prim](args, this.val);
        throw new $c46b7dbea18e1f8c$var$EncodeTicketDeprecatedError();
    }
    Execute(val, semantics) {
        if (semantics && semantics[$c46b7dbea18e1f8c$var$TicketDeprecatedToken.prim]) return semantics[$c46b7dbea18e1f8c$var$TicketDeprecatedToken.prim](val, this.val);
        const ticketer = this.createToken($c46b7dbea18e1f8c$var$ticketerType, this.idx);
        const value = this.valueToken;
        const amount = this.createToken($c46b7dbea18e1f8c$var$amountType, this.idx);
        if (undefined === val.args[2] && undefined !== val.args[1].args) return {
            ticketer: ticketer.Execute(val.args[0], semantics),
            value: value.Execute(val.args[1].args[0], semantics),
            amount: amount.Execute(val.args[1].args[1], semantics)
        };
        return {
            ticketer: ticketer.Execute(val.args[0], semantics),
            value: value.Execute(val.args[1], semantics),
            amount: amount.Execute(val.args[2], semantics)
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            ticketer: $c46b7dbea18e1f8c$var$ContractToken.prim,
            value: this.valueToken.ExtractSchema(),
            amount: $c46b7dbea18e1f8c$var$IntToken.prim
        };
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$TicketDeprecatedToken.prim,
            schema: {
                value: this.valueToken.generateSchema(),
                ticketer: {
                    __michelsonType: $c46b7dbea18e1f8c$var$ContractToken.prim,
                    schema: $c46b7dbea18e1f8c$var$ContractToken.prim
                },
                amount: {
                    __michelsonType: $c46b7dbea18e1f8c$var$IntToken.prim,
                    schema: $c46b7dbea18e1f8c$var$IntToken.prim
                }
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$TicketDeprecatedToken.prim === tokenToFind) tokens.push(this);
        this.valueToken.findAndReturnTokens(tokenToFind, tokens);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$TicketDeprecatedToken.prim = 'ticket_deprecated';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Never Token
 */ class $c46b7dbea18e1f8c$var$NeverTokenError extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'NeverTokenError';
    }
}
class $c46b7dbea18e1f8c$var$NeverToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link NeverTokenError}
     */ Encode(args) {
        const val = args.pop();
        throw new $c46b7dbea18e1f8c$var$NeverTokenError(val, this, `Assigning a value to the type never is forbidden. Trying to assign ${JSON.stringify(val)}.`);
    }
    /**
     * @throws {@link NeverTokenError}
     */ EncodeObject(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$NeverToken.prim]) return semantic[$c46b7dbea18e1f8c$var$NeverToken.prim](val);
        throw new $c46b7dbea18e1f8c$var$NeverTokenError(val, this, `Assigning a value to the type never is forbidden. Trying to assign ${JSON.stringify(val)}.`);
    }
    /**
     * @throws {@link NeverTokenError}
     */ Execute(val) {
        throw new $c46b7dbea18e1f8c$var$NeverTokenError(val, this, `There is no literal value for the type never. Trying to execute ${JSON.stringify(val)}.`);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$NeverToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$NeverToken.prim,
            schema: $c46b7dbea18e1f8c$var$NeverToken.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$NeverToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$NeverToken.prim = 'never';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Sapling State
 */ class $c46b7dbea18e1f8c$var$SaplingStateValidationError extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'SaplingStateValidationError';
    }
}
class $c46b7dbea18e1f8c$var$SaplingStateToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    isValid(val) {
        return typeof val === 'object' && Object.keys(val).length === 0;
    }
    /**
     * @throws {@link SaplingStateValidationError}
     */ Execute(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$SaplingStateToken.prim]) return semantic[$c46b7dbea18e1f8c$var$SaplingStateToken.prim](val, this.val);
        if ('int' in val) return val.int;
        else throw new $c46b7dbea18e1f8c$var$SaplingStateValidationError(val, this, `Sapling state is expecting an object with an int property. Got ${JSON.stringify(val)}`);
    }
    /**
     * @throws {@link SaplingStateValidationError}
     */ Encode(args) {
        const val = args.pop();
        if (this.isValid(val)) return [];
        else throw new $c46b7dbea18e1f8c$var$SaplingStateValidationError(val, this, `Invalid sapling_state. Received: ${JSON.stringify(val)} while expecting: {}`);
    }
    /**
     * @throws {@link SaplingStateValidationError}
     */ EncodeObject(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$SaplingStateToken.prim]) return semantic[$c46b7dbea18e1f8c$var$SaplingStateToken.prim](val);
        if (this.isValid(val)) return [];
        else throw new $c46b7dbea18e1f8c$var$SaplingStateValidationError(val, this, `Invalid sapling_state. Received: ${JSON.stringify(val)} while expecting: {}`);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            [$c46b7dbea18e1f8c$var$SaplingStateToken.prim]: {
                'memo-size': Number(this.val.args[0]['int'])
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$SaplingStateToken.prim,
            schema: {
                memoSize: this.val.args[0]['int']
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$SaplingStateToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$SaplingStateToken.prim = 'sapling_state';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Sapling Transaction
 */ class $c46b7dbea18e1f8c$var$SaplingTransactionValidationError extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'SaplingTransactionValidationError';
    }
}
class $c46b7dbea18e1f8c$var$SaplingTransactionToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link SaplingTransactionValidationError}
     */ Execute(_val) {
        throw new $c46b7dbea18e1f8c$var$SaplingTransactionValidationError(_val, this, `There is no literal value for the sapling_transaction type. Got: ${JSON.stringify(_val)}.`);
    }
    /**
     * @throws {@link SaplingTransactionValidationError}
     */ validateBytes(val) {
        const bytes = /^(0x|0X)?([0-9a-fA-F]*$)/.exec(val);
        if (bytes && bytes[2].length % 2 === 0) return bytes[2];
        else throw new $c46b7dbea18e1f8c$var$SaplingTransactionValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $c46b7dbea18e1f8c$require$Buffer.from(val).toString('hex') : val;
    }
    Encode(args) {
        let val = args.pop();
        val = this.validateBytes(this.convertUint8ArrayToHexString(val));
        return {
            bytes: String(val).toString()
        };
    }
    EncodeObject(val, semantic) {
        val = this.validateBytes(this.convertUint8ArrayToHexString(val));
        if (semantic && semantic[$c46b7dbea18e1f8c$var$SaplingTransactionToken.prim]) return semantic[$c46b7dbea18e1f8c$var$SaplingTransactionToken.prim](val);
        return {
            bytes: String(val).toString()
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            [$c46b7dbea18e1f8c$var$SaplingTransactionToken.prim]: {
                'memo-size': Number(this.val.args[0]['int'])
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$SaplingTransactionToken.prim,
            schema: {
                memoSize: this.val.args[0]['int']
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$SaplingTransactionToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$SaplingTransactionToken.prim = 'sapling_transaction';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Sapling Transaction Deprecated
 */ class $c46b7dbea18e1f8c$var$SaplingTransactionDeprecatedValidationError extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'SaplingTransactionDeprecatedValidationError';
    }
}
class $c46b7dbea18e1f8c$var$SaplingTransactionDeprecatedToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link SaplingTransactionDeprecatedValidationError}
     */ Execute(_val) {
        throw new $c46b7dbea18e1f8c$var$SaplingTransactionDeprecatedValidationError(_val, this, `There is no literal value for the sapling_transaction_deprecated type. Got: ${JSON.stringify(_val)}.`);
    }
    /**
     * @throws {@link SaplingTransactionDeprecatedValidationError}
     */ validateBytes(val) {
        const bytes = /^(0x|0X)?([0-9a-fA-F]*$)/.exec(val);
        if (bytes && bytes[2].length % 2 === 0) return bytes[2];
        else throw new $c46b7dbea18e1f8c$var$SaplingTransactionDeprecatedValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $c46b7dbea18e1f8c$require$Buffer.from(val).toString('hex') : val;
    }
    Encode(args) {
        let val = args.pop();
        val = this.validateBytes(this.convertUint8ArrayToHexString(val));
        return {
            bytes: String(val).toString()
        };
    }
    EncodeObject(val, semantic) {
        val = this.validateBytes(this.convertUint8ArrayToHexString(val));
        if (semantic && semantic[$c46b7dbea18e1f8c$var$SaplingTransactionDeprecatedToken.prim]) return semantic[$c46b7dbea18e1f8c$var$SaplingTransactionDeprecatedToken.prim](val);
        return {
            bytes: String(val).toString()
        };
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return {
            [$c46b7dbea18e1f8c$var$SaplingTransactionDeprecatedToken.prim]: {
                'memo-size': Number(this.val.args[0]['int'])
            }
        };
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$SaplingTransactionDeprecatedToken.prim,
            schema: {
                memoSize: this.val.args[0]['int']
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$SaplingTransactionDeprecatedToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$SaplingTransactionDeprecatedToken.prim = 'sapling_transaction_deprecated';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a BLS12-381 scalar field Fr
 */ class $c46b7dbea18e1f8c$var$Bls12381frValidationError extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'Bls12381frValidationError';
    }
}
class $c46b7dbea18e1f8c$var$Bls12381frToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link Bls12381frValidationError}
     */ validate(val) {
        if (/^[0-9a-fA-F]*$/.test(val) && val.length % 2 === 0) return;
        throw new $c46b7dbea18e1f8c$var$Bls12381frValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $c46b7dbea18e1f8c$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link Bls12381frValidationError}
     */ Encode(args) {
        let val = args.pop();
        if (typeof val === 'number') return {
            int: val.toString()
        };
        else {
            val = this.convertUint8ArrayToHexString(val);
            this.validate(val);
            return {
                bytes: val
            };
        }
    }
    /**
     * @throws {@link Bls12381frValidationError}
     */ EncodeObject(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$Bls12381frToken.prim]) return semantic[$c46b7dbea18e1f8c$var$Bls12381frToken.prim](val);
        if (typeof val === 'number') return {
            int: val.toString()
        };
        else {
            val = this.convertUint8ArrayToHexString(val);
            this.validate(val);
            return {
                bytes: val
            };
        }
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$Bls12381frToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$Bls12381frToken.prim,
            schema: $c46b7dbea18e1f8c$var$Bls12381frToken.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$Bls12381frToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
// An element of the BLS12-381 scalar field Fr
// see https://tezos.gitlab.io/michelson-reference/#type-bls12_381_fr
$c46b7dbea18e1f8c$var$Bls12381frToken.prim = 'bls12_381_fr';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a BLS12-381 curve G1
 */ class $c46b7dbea18e1f8c$var$Bls12381g1ValidationError extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'Bls12381g1ValidationError';
    }
}
class $c46b7dbea18e1f8c$var$Bls12381g1Token extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link Bls12381g1ValidationError}
     */ validate(val) {
        if (/^[0-9a-fA-F]*$/.test(val) && val.length % 2 === 0) return;
        throw new $c46b7dbea18e1f8c$var$Bls12381g1ValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $c46b7dbea18e1f8c$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link Bls12381g1ValidationError}
     */ Encode(args) {
        let val = args.pop();
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        return {
            bytes: val
        };
    }
    /**
     * @throws {@link Bls12381g1ValidationError}
     */ EncodeObject(val, semantic) {
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$Bls12381g1Token.prim]) return semantic[$c46b7dbea18e1f8c$var$Bls12381g1Token.prim](val);
        return {
            bytes: val
        };
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$Bls12381g1Token.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$Bls12381g1Token.prim,
            schema: $c46b7dbea18e1f8c$var$Bls12381g1Token.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$Bls12381g1Token.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
// A point on the BLS12-381 curve G1
// See https://tezos.gitlab.io/michelson-reference/#type-bls12_381_g1
$c46b7dbea18e1f8c$var$Bls12381g1Token.prim = 'bls12_381_g1';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a BLS12-381 curve G2
 */ class $c46b7dbea18e1f8c$var$Bls12381g2ValidationError extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'Bls12381g2ValidationError';
    }
}
class $c46b7dbea18e1f8c$var$Bls12381g2Token extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link Bls12381g2ValidationError}
     */ validate(val) {
        if (/^[0-9a-fA-F]*$/.test(val) && val.length % 2 === 0) return;
        throw new $c46b7dbea18e1f8c$var$Bls12381g2ValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $c46b7dbea18e1f8c$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link Bls12381g2ValidationError}
     */ Encode(args) {
        let val = args.pop();
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        return {
            bytes: val
        };
    }
    /**
     * @throws {@link Bls12381g2ValidationError}
     */ EncodeObject(val, semantic) {
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$Bls12381g2Token.prim]) return semantic[$c46b7dbea18e1f8c$var$Bls12381g2Token.prim](val);
        return {
            bytes: val
        };
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$Bls12381g2Token.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$Bls12381g2Token.prim,
            schema: $c46b7dbea18e1f8c$var$Bls12381g2Token.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$Bls12381g2Token.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
// A point on the BLS12-381 curve G2
// See https://tezos.gitlab.io/michelson-reference/#type-bls12_381_g2
$c46b7dbea18e1f8c$var$Bls12381g2Token.prim = 'bls12_381_g2';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Chest
 */ class $c46b7dbea18e1f8c$var$ChestValidationError extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'ChestValidationError';
    }
}
class $c46b7dbea18e1f8c$var$ChestToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ validate(val) {
        if (/^[0-9a-fA-F]*$/.test(val) && val.length % 2 == 0) return;
        throw new $c46b7dbea18e1f8c$var$ChestValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $c46b7dbea18e1f8c$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ Encode(args) {
        let val = args.pop();
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        return {
            bytes: val
        };
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ EncodeObject(val, semantic) {
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$ChestToken.prim]) return semantic[$c46b7dbea18e1f8c$var$ChestToken.prim](val);
        return {
            bytes: val
        };
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$ChestToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$ChestToken.prim,
            schema: $c46b7dbea18e1f8c$var$ChestToken.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$ChestToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$ChestToken.prim = 'chest';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding/executing a Chest Key
 */ class $c46b7dbea18e1f8c$var$ChestKeyValidationError extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'ChestKeyValidationError';
    }
}
class $c46b7dbea18e1f8c$var$ChestKeyToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ validate(val) {
        if (/^[0-9a-fA-F]*$/.test(val) && val.length % 2 === 0) return;
        throw new $c46b7dbea18e1f8c$var$ChestKeyValidationError(val, this, `Invalid bytes: ${JSON.stringify(val)}`);
    }
    convertUint8ArrayToHexString(val) {
        return val.constructor === Uint8Array ? $c46b7dbea18e1f8c$require$Buffer.from(val).toString('hex') : val;
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ Encode(args) {
        let val = args.pop();
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        return {
            bytes: val
        };
    }
    /**
     * @throws {@link ChestKeyValidationError}
     */ EncodeObject(val, semantic) {
        val = this.convertUint8ArrayToHexString(val);
        this.validate(val);
        if (semantic && semantic[$c46b7dbea18e1f8c$var$ChestKeyToken.prim]) return semantic[$c46b7dbea18e1f8c$var$ChestKeyToken.prim](val);
        return {
            bytes: val
        };
    }
    Execute(val) {
        return val.bytes;
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$ChestKeyToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$ChestKeyToken.prim,
            schema: $c46b7dbea18e1f8c$var$ChestKeyToken.prim
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$ChestKeyToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$ChestKeyToken.prim = 'chest_key';
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing encoding a Global Constant
 */ class $c46b7dbea18e1f8c$var$GlobalConstantEncodingError extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'GlobalConstantEncodingError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure happening when parsing executing a Global Constant
 */ class $c46b7dbea18e1f8c$var$GlobalConstantDecodingError extends $c46b7dbea18e1f8c$var$TokenValidationError {
    constructor(value, token, message){
        super(value, token, message);
        this.value = value;
        this.token = token;
        this.name = 'GlobalConstantDecodingError';
    }
}
class $c46b7dbea18e1f8c$var$GlobalConstantToken extends $c46b7dbea18e1f8c$export$50792b0e93539fde {
    constructor(val, idx, fac){
        super(val, idx, fac);
        this.val = val;
        this.idx = idx;
        this.fac = fac;
    }
    /**
     * @throws {@link GlobalConstantDecodingError}
     */ Execute(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$GlobalConstantToken.prim]) return semantic[$c46b7dbea18e1f8c$var$GlobalConstantToken.prim](val, this.val);
        else throw new $c46b7dbea18e1f8c$var$GlobalConstantDecodingError(val, this, `Unable to decode a value represented by a global constants. Please provide an expanded script to the Michelson-Encoder or semantics for the decoding. The following global constant hash was encountered: ${this.val.args[0]['string']}.`);
    }
    /**
     * @throws {@link GlobalConstantEncodingError}
     */ Encode(args) {
        throw new $c46b7dbea18e1f8c$var$GlobalConstantEncodingError(args, this, `Unable to encode a script containing global constants. Please provide an expanded script to the Michelson-Encoder. The following global constant hash was encountered: ${this.val.args[0]['string']}.`);
    }
    /**
     * @throws {@link GlobalConstantEncodingError}
     */ EncodeObject(val, semantic) {
        if (semantic && semantic[$c46b7dbea18e1f8c$var$GlobalConstantToken.prim]) return semantic[$c46b7dbea18e1f8c$var$GlobalConstantToken.prim](val);
        throw new $c46b7dbea18e1f8c$var$GlobalConstantEncodingError(val, this, `Unable to encode a script containing global constants. Please provide an expanded script to the Michelson-Encoder. The following global constant hash was encountered: ${this.val.args[0]['string']}.`);
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return $c46b7dbea18e1f8c$var$GlobalConstantToken.prim;
    }
    generateSchema() {
        return {
            __michelsonType: $c46b7dbea18e1f8c$var$GlobalConstantToken.prim,
            schema: {
                hash: this.val.args[0]['string']
            }
        };
    }
    findAndReturnTokens(tokenToFind, tokens) {
        if ($c46b7dbea18e1f8c$var$GlobalConstantToken.prim === tokenToFind) tokens.push(this);
        return tokens;
    }
}
$c46b7dbea18e1f8c$var$GlobalConstantToken.prim = 'constant';
const $c46b7dbea18e1f8c$var$tokens = [
    $c46b7dbea18e1f8c$var$PairToken,
    $c46b7dbea18e1f8c$var$NatToken,
    $c46b7dbea18e1f8c$var$StringToken,
    $c46b7dbea18e1f8c$var$BigMapToken,
    $c46b7dbea18e1f8c$var$AddressToken,
    $c46b7dbea18e1f8c$var$MapToken,
    $c46b7dbea18e1f8c$var$BoolToken,
    $c46b7dbea18e1f8c$var$OrToken,
    $c46b7dbea18e1f8c$var$ContractToken,
    $c46b7dbea18e1f8c$var$ListToken,
    $c46b7dbea18e1f8c$var$MutezToken,
    $c46b7dbea18e1f8c$var$BytesToken,
    $c46b7dbea18e1f8c$var$OptionToken,
    $c46b7dbea18e1f8c$var$TimestampToken,
    $c46b7dbea18e1f8c$var$IntToken,
    $c46b7dbea18e1f8c$var$UnitToken,
    $c46b7dbea18e1f8c$var$KeyToken,
    $c46b7dbea18e1f8c$var$KeyHashToken,
    $c46b7dbea18e1f8c$var$SignatureToken,
    $c46b7dbea18e1f8c$var$LambdaToken,
    $c46b7dbea18e1f8c$var$OperationToken,
    $c46b7dbea18e1f8c$var$SetToken,
    $c46b7dbea18e1f8c$var$ChainIDToken,
    $c46b7dbea18e1f8c$var$TicketToken,
    $c46b7dbea18e1f8c$var$TicketDeprecatedToken,
    $c46b7dbea18e1f8c$var$NeverToken,
    $c46b7dbea18e1f8c$var$SaplingStateToken,
    $c46b7dbea18e1f8c$var$SaplingTransactionToken,
    $c46b7dbea18e1f8c$var$SaplingTransactionDeprecatedToken,
    $c46b7dbea18e1f8c$var$Bls12381frToken,
    $c46b7dbea18e1f8c$var$Bls12381g1Token,
    $c46b7dbea18e1f8c$var$Bls12381g2Token,
    $c46b7dbea18e1f8c$var$ChestToken,
    $c46b7dbea18e1f8c$var$ChestKeyToken,
    $c46b7dbea18e1f8c$var$GlobalConstantToken
];
/**
 *  @category Error
 *  @description Error that indicates a script having an invalid type or it being unsupported by the Michelson Encoder. Note some protocol changes might affect this, we encourage users to open an issue so we can look into implementing support for said types.
 */ class $c46b7dbea18e1f8c$var$InvalidTokenError extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(message, data){
        super(message);
        this.message = message;
        this.data = data;
        this.name = 'Invalid token error';
    }
}
/**
 *
 * @description Create a token from a value
 * @throws {@link InvalidTokenError} If the value passed is not supported by the Michelson Encoder
 */ function $c46b7dbea18e1f8c$var$createToken(val, idx, parentTokenType) {
    if (Array.isArray(val)) return new $c46b7dbea18e1f8c$var$PairToken(val, idx, $c46b7dbea18e1f8c$var$createToken, parentTokenType);
    const t = $c46b7dbea18e1f8c$var$tokens.find((x)=>x.prim === val.prim);
    if (!t) throw new $c46b7dbea18e1f8c$var$InvalidTokenError(`Malformed data: ${JSON.stringify(val)}. Expected a value with a valid prim property`, val);
    return new t(val, idx, $c46b7dbea18e1f8c$var$createToken, parentTokenType);
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 *  @category Error
 *  @description Error that indicates a failure when encoding (transforming JS parameter into JSON Michelson) the parameter of the view
 */ class $c46b7dbea18e1f8c$export$a638dccee41148ef extends (0, $df4bb72c68281fa2$export$f9ce6a924724628b) {
    constructor(viewName, sigs, args, cause){
        super(viewName, sigs, args, cause);
        this.viewName = viewName;
        this.sigs = sigs;
        this.args = args;
        this.cause = cause;
        this.name = 'ParameterEncodingError';
        this.message = `Could not encode parameter ${JSON.stringify(args)} received for name "${viewName}" expecting one of the following signatures ${JSON.stringify(sigs)}`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid on-chain view found on the script
 */ class $c46b7dbea18e1f8c$export$665c9bb21f47bbf5 extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(script, reason){
        super();
        this.script = script;
        this.reason = reason;
        this.name = 'InvalidScriptError';
        let message = `Invalid on-chain view found in the following script.`;
        if (reason) message += ` Reason: ${reason}.`;
        message += `Script: ${JSON.stringify(script)}`;
        this.message = message;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid RPC response being passed or used
 */ class $c46b7dbea18e1f8c$export$9048a16c3828c4af extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(script, reason){
        super();
        this.script = script;
        this.reason = reason;
        this.name = 'InvalidRpcResponseError';
        let message = `Invalid RPC response passed as argument(s).`;
        if (reason) message += ` Reason: ${reason}.`;
        message += ` Received: ${JSON.stringify(script)}`;
        this.message = message;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid big map schema being passed or used
 */ class $c46b7dbea18e1f8c$export$53f8cfbabadba878 extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(message){
        super(message);
        this.message = message;
        this.name = 'InvalidBigMapSchemaError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid big map diff being passed or used
 */ class $c46b7dbea18e1f8c$export$3279952fe20c0e7f extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(message, value){
        super(message);
        this.message = message;
        this.value = value;
        this.name = 'InvalidBigMapDiffError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when trying to encode big maps
 */ class $c46b7dbea18e1f8c$export$b5954e3349c86d5c extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(obj, details, schema, value){
        super();
        this.details = details;
        this.schema = schema;
        this.value = value;
        this.name = 'BigMapEncodingError';
        this.message = `Unable to encode the big map ${obj}. Schema is: ${JSON.stringify(schema)}. The ${obj} is: ${JSON.stringify(value)}. Error details: ${details}`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when trying to encode storage
 */ class $c46b7dbea18e1f8c$export$d46c9c80bc2bb9f6 extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(obj, details, schema, value, semantics){
        super();
        this.details = details;
        this.schema = schema;
        this.value = value;
        this.semantics = semantics;
        this.name = 'StorageEncodingError';
        this.message = `Unable to encode ${obj}. The schema is: ${JSON.stringify(schema)}, the value is: ${JSON.stringify(value)}.${semantics ? `And the semantic is: ${JSON.stringify(semantics)}` : ''}. Error details: ${details}`;
    }
}
/**
 *  @category Error
 *  @description General error that indicates a function not being passed a necessary argument
 */ class $c46b7dbea18e1f8c$export$4431adf7a9948431 extends (0, $df4bb72c68281fa2$export$e5619b407b1c8b0a) {
    constructor(message){
        super(message);
        this.message = message;
        this.name = 'MissingArgumentError';
    }
}
var $c46b7dbea18e1f8c$var$_a;
const $c46b7dbea18e1f8c$var$schemaTypeSymbol = Symbol.for('taquito-schema-type-symbol');
// collapse comb pair
function $c46b7dbea18e1f8c$var$collapse(val, prim = $c46b7dbea18e1f8c$var$PairToken.prim) {
    var _b, _c;
    if (Array.isArray(val)) return $c46b7dbea18e1f8c$var$collapse({
        prim: prim,
        args: val
    }, prim);
    const extended = val;
    if (extended.prim === prim && extended.args && extended.args.length > 2) return Object.assign(Object.assign({}, extended), {
        args: [
            (_b = extended.args) === null || _b === void 0 ? void 0 : _b[0],
            {
                prim: prim,
                args: (_c = extended.args) === null || _c === void 0 ? void 0 : _c.slice(1)
            }
        ]
    });
    return extended;
}
function $c46b7dbea18e1f8c$export$9cb4719e2e525b7a(a, b) {
    if (a === undefined || b === undefined) return a === b;
    const ac = $c46b7dbea18e1f8c$var$collapse(a);
    const bc = $c46b7dbea18e1f8c$var$collapse(b);
    return ac.prim === bc.prim && (ac.args === undefined && bc.args === undefined || ac.args !== undefined && bc.args !== undefined && ac.args.length === bc.args.length && ac.args.every((v, i)=>{
        var _b, _c;
        return $c46b7dbea18e1f8c$export$9cb4719e2e525b7a(v, (_c = (_b = bc.args) === null || _b === void 0 ? void 0 : _b[i]) !== null && _c !== void 0 ? _c : {});
    })) && (ac.annots === undefined && bc.annots === undefined || ac.annots !== undefined && bc.annots !== undefined && ac.annots.length === bc.annots.length && ac.annots.every((v, i)=>{
        var _b;
        return v === ((_b = bc.annots) === null || _b === void 0 ? void 0 : _b[i]);
    }));
}
/**
 * @warn Our current smart contract abstraction feature is currently in preview. Its API is not final, and it may not cover every use case (yet). We will greatly appreciate any feedback on this feature.
 */ class $c46b7dbea18e1f8c$export$19342e026b58ebb7 {
    static isSchema(obj) {
        return obj && obj[$c46b7dbea18e1f8c$var$schemaTypeSymbol] === true;
    }
    /**
     * @throws {@link InvalidRpcResponseError}
     */ static fromRPCResponse(val) {
        if (!val) throw new $c46b7dbea18e1f8c$export$9048a16c3828c4af(val, 'the RPC response is empty');
        if (!val.script) throw new $c46b7dbea18e1f8c$export$9048a16c3828c4af(val, 'the RPC response has no script');
        if (!Array.isArray(val.script.code)) throw new $c46b7dbea18e1f8c$export$9048a16c3828c4af(val, 'The response.script.code should be an array');
        let code = val.script.code;
        while(code.length === 1 && Array.isArray(code[0]))code = code[0];
        const storage = code.find((x)=>'prim' in x && x.prim === 'storage');
        if (!storage || !Array.isArray(storage.args)) throw new $c46b7dbea18e1f8c$export$9048a16c3828c4af(val, 'The response.script.code has an element of type {prim: "storage"}, but its args is not an array');
        return new $c46b7dbea18e1f8c$export$19342e026b58ebb7(storage.args[0]);
    }
    isExpressionExtended(val) {
        return 'prim' in val && Array.isArray(val.args);
    }
    constructor(val){
        this.val = val;
        this[$c46b7dbea18e1f8c$var$_a] = true;
        this.root = $c46b7dbea18e1f8c$var$createToken(val, 0);
        if (this.root instanceof $c46b7dbea18e1f8c$var$BigMapToken) this.bigMap = this.root;
        else if (this.isExpressionExtended(val) && val.prim === 'pair') {
            const exp = val.args[0];
            if (this.isExpressionExtended(exp) && exp.prim === 'big_map') this.bigMap = new $c46b7dbea18e1f8c$var$BigMapToken(exp, 0, $c46b7dbea18e1f8c$var$createToken);
        }
    }
    removeTopLevelAnnotation(obj) {
        // PairToken and OrToken can have redundant top level annotation in their storage
        if (this.root instanceof $c46b7dbea18e1f8c$var$PairToken || this.root instanceof $c46b7dbea18e1f8c$var$OrToken) {
            if (this.root.hasAnnotations() && typeof obj === 'object' && Object.keys(obj).length === 1) return obj[Object.keys(obj)[0]];
        }
        return obj;
    }
    Execute(val, semantics) {
        const storage = this.root.Execute(val, semantics);
        return this.removeTopLevelAnnotation(storage);
    }
    Typecheck(val) {
        if (this.root instanceof $c46b7dbea18e1f8c$var$BigMapToken && Number.isInteger(Number(val))) return;
        if (this.root instanceof $c46b7dbea18e1f8c$var$TicketToken && val.ticketer && val.value && val.amount) return;
        if (this.root instanceof $c46b7dbea18e1f8c$var$TicketDeprecatedToken && val.ticketer && val.value && val.amount) return;
        if (this.root instanceof $c46b7dbea18e1f8c$var$MapToken && this.root.ValueSchema instanceof $c46b7dbea18e1f8c$var$BigMapToken) return;
        this.root.EncodeObject(val);
    }
    /**
     * @throws {@link InvalidBigMapSchemaError}
     * @throws {@link InvalidBigMapDiffError}
     */ ExecuteOnBigMapDiff(diff, semantics) {
        if (!this.bigMap) throw new $c46b7dbea18e1f8c$export$53f8cfbabadba878('Big map schema is undefined');
        if (!Array.isArray(diff)) throw new $c46b7dbea18e1f8c$export$3279952fe20c0e7f(`Big map diff must be an array, got: ${JSON.stringify(diff)}`, diff);
        const eltFormat = diff.map(({ key: key, value: value })=>({
                args: [
                    key,
                    value
                ]
            }));
        return this.bigMap.Execute(eltFormat, semantics);
    }
    /**
     * @throws {@link InvalidBigMapSchemaError}
     */ ExecuteOnBigMapValue(key, semantics) {
        if (!this.bigMap) throw new $c46b7dbea18e1f8c$export$53f8cfbabadba878('Big map schema is undefined');
        return this.bigMap.ValueSchema.Execute(key, semantics);
    }
    /**
     * @throws {@link InvalidBigMapSchemaError}
     * @throws {@link BigMapEncodingError}
     */ EncodeBigMapKey(key) {
        if (!this.bigMap) throw new $c46b7dbea18e1f8c$export$53f8cfbabadba878('Big map schema is undefined');
        try {
            return this.bigMap.KeySchema.ToBigMapKey(key);
        } catch (ex) {
            throw new $c46b7dbea18e1f8c$export$b5954e3349c86d5c('key', ex, this.bigMap.KeySchema, key);
        }
    }
    /**
     * @throws {@link TokenValidationError}
     * @throws {@link StorageEncodingError}
     */ Encode(value, semantics) {
        try {
            return this.root.EncodeObject(value, semantics);
        } catch (ex) {
            if (ex instanceof $c46b7dbea18e1f8c$var$TokenValidationError) throw ex;
            throw new $c46b7dbea18e1f8c$export$d46c9c80bc2bb9f6('storage object', ex, this.root, value, semantics);
        }
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return this.removeTopLevelAnnotation(this.root.ExtractSchema());
    }
    /**
     * @description Produce a representation of the storage schema.
     * Note: Provide guidance on how to write the storage object for the origination operation with Taquito.
     */ generateSchema() {
        return this.removeTopLevelAnnotation(this.root.generateSchema());
    }
    /**
     * @deprecated
     * @throws {@link InvalidBigMapSchemaError}
     */ ComputeState(tx, state) {
        if (!this.bigMap) throw new $c46b7dbea18e1f8c$export$53f8cfbabadba878('Big map schema is undefined');
        const bigMap = tx.reduce((prev, current)=>{
            return Object.assign(Object.assign({}, prev), this.ExecuteOnBigMapDiff(current.contents[0].metadata.operation_result.big_map_diff));
        }, {});
        return Object.assign(Object.assign({}, this.Execute(state)), {
            [this.bigMap.annot()]: bigMap
        });
    }
    /**
     * @description Look up in top-level pairs of the storage to find a value matching the specified type
     *
     * @returns The first value found that match the type or `undefined` if no value is found
     *
     * @param storage storage to parse to find the value
     * @param valueType type of value to look for
     *
     */ FindFirstInTopLevelPair(storage, valueType) {
        return this.findValue(this.root['val'], storage, valueType);
    }
    // TODO check these type casts
    /**
     * @throws {@link MissingArgumentError}
     */ findValue(schema, storage, valueToFind) {
        if ($c46b7dbea18e1f8c$export$9cb4719e2e525b7a(valueToFind, schema)) return storage;
        if (Array.isArray(schema) || schema.prim === 'pair') {
            const sch = $c46b7dbea18e1f8c$var$collapse(schema);
            const strg = $c46b7dbea18e1f8c$var$collapse(storage, 'Pair');
            if (sch.args === undefined || strg.args === undefined) throw new $c46b7dbea18e1f8c$export$4431adf7a9948431('Tokens have no arguments'); // unlikely
            if (sch.args[0]) return(// unsafe
            this.findValue(sch.args[0], strg.args[0], valueToFind) || this.findValue(sch.args[1], strg.args[1], valueToFind));
        }
    }
    /**
     * @description Look up the schema to find any occurrence of a particular token.
     *
     * @returns an array of tokens of the specified kind or an empty array if no token was found
     *
     * @param tokenToFind string representing the prim property of the token to find
     *
     * @example
     * ```
     * Useful to find all global constants in a script, an array of GlobalConstantToken is returned:
     *
     * const schema = new Schema(script);
     * const allGlobalConstantTokens = schema.findToken('constant');
     * ```
     *
     */ findToken(tokenToFind) {
        const tokens = [];
        return this.root.findAndReturnTokens(tokenToFind, tokens);
    }
}
$c46b7dbea18e1f8c$var$_a = $c46b7dbea18e1f8c$var$schemaTypeSymbol;
/**
 * @warn Our current smart contract abstraction feature is currently in preview. It's API is not final, and it may not cover every use case (yet). We will greatly appreciate any feedback on this feature.
 */ class $c46b7dbea18e1f8c$export$54a0993a9ed335cf {
    /**
     *
     * @description Create an instance of ParameterSchema from a contract script
     *
     * @param val contract script obtained from the RPC
     * @returns ParameterSchema
     * @throws {InvalidRpcResponseError} If the RPC response is invalid
     */ static fromRPCResponse(val) {
        if (!val) throw new $c46b7dbea18e1f8c$export$9048a16c3828c4af(val, 'the RPC response is empty');
        if (!val.script) throw new $c46b7dbea18e1f8c$export$9048a16c3828c4af(val, 'the RPC response has no script');
        if (!Array.isArray(val.script.code)) throw new $c46b7dbea18e1f8c$export$9048a16c3828c4af(val, 'The response.script.code should be an array');
        const parameter = val.script.code.find((x)=>'prim' in x && x.prim === 'parameter');
        if (!parameter) throw new $c46b7dbea18e1f8c$export$9048a16c3828c4af(val, `The response.script.code should have an element of type {prim: "parameter"}`);
        if (!Array.isArray(parameter.args)) throw new $c46b7dbea18e1f8c$export$9048a16c3828c4af(val, `The response.script.code has an element of type {prim: "parameter"}, but its args is not an array`);
        return new $c46b7dbea18e1f8c$export$54a0993a9ed335cf(parameter.args[0]);
    }
    /**
     * @description Check if the Contract parameter is multiple entry point or not
     */ get isMultipleEntryPoint() {
        return this.root instanceof $c46b7dbea18e1f8c$var$OrToken || this.root instanceof $c46b7dbea18e1f8c$var$OptionToken && this.root.subToken() instanceof $c46b7dbea18e1f8c$var$OrToken;
    }
    /**
     * @description Check if the Contract parameter has an annotation or not
     */ get hasAnnotation() {
        if (this.isMultipleEntryPoint) return Object.keys(this.ExtractSchema())[0] !== '0';
        else return true;
    }
    /**
     * @description Return the schema of the parameter of a specific entry point
     * @throws {@link InvalidTokenError}
     */ constructor(val){
        this.root = $c46b7dbea18e1f8c$var$createToken(val, 0);
    }
    /**
     * @description Returns the javascript object equivalent of the Micheline value provided
     */ Execute(val, semantics) {
        return this.root.Execute(val, semantics);
    }
    /**
     * @description Returns a micheline formatted object for the values provided
     * @throws {@link TokenValidationError}
     * @throws {@link ParameterEncodingError}
     */ Encode(...args) {
        try {
            return this.root.Encode(args.reverse());
        } catch (ex) {
            if (ex instanceof $c46b7dbea18e1f8c$var$TokenValidationError) throw ex;
            throw new $c46b7dbea18e1f8c$export$a638dccee41148ef('Unable to encode parameter', this.root, args, ex);
        }
    }
    /**
     * @description Returns a micheline formatted object for the javascript object provided
     * @throws {@link TokenValidationError}
     * @throws {@link ParameterEncodingError}
     */ EncodeObject(value, semantics) {
        try {
            return this.root.EncodeObject(value, semantics);
        } catch (ex) {
            if (ex instanceof $c46b7dbea18e1f8c$var$TokenValidationError) throw ex;
            throw new $c46b7dbea18e1f8c$export$a638dccee41148ef('Unable to encode parameter object', this.root, value, ex);
        }
    }
    /**
     * @deprecated ExtractSchema has been deprecated in favor of generateSchema
     *
     */ ExtractSchema() {
        return this.root.ExtractSchema();
    }
    /**
     * @description Produce a schema grouping together all the entry points of a contract.
     */ generateSchema() {
        return this.root.generateSchema();
    }
    ExtractSignatures() {
        return this.root.ExtractSignature();
    }
}
class $c46b7dbea18e1f8c$export$d422a5b447f0dce1 {
    /**
     *
     * @description Create an instance of ViewSchema for each view in a script
     *
     * @param val contract script obtained from the RPC
     * @returns array of ViewSchema or empty array if there is no view in the contract
     * @throws {@link InvalidScriptError}
     */ static fromRPCResponse(val) {
        const allViewSchema = [];
        const views = val && val.script && Array.isArray(val.script.code) && val.script.code.filter((x)=>x.prim === 'view');
        if (views) views.forEach((view)=>{
            allViewSchema.push(new $c46b7dbea18e1f8c$export$d422a5b447f0dce1(view.args));
        });
        return allViewSchema;
    }
    /**
     * @throws {@link InvalidScriptError}
     */ constructor(viewArgs){
        if (!viewArgs) throw new $c46b7dbea18e1f8c$export$665c9bb21f47bbf5(viewArgs, 'the args are not defined');
        if (viewArgs.length !== 4) throw new $c46b7dbea18e1f8c$export$665c9bb21f47bbf5(viewArgs, `there should be exactly 4 arguments`);
        if (!('string' in viewArgs[0]) || !viewArgs[0]['string']) throw new $c46b7dbea18e1f8c$export$665c9bb21f47bbf5(viewArgs, `The first argument should be a string, representing the view name. It should be in the form: { string: 'viewName' }`);
        this.viewName = viewArgs[0]['string'];
        this.viewArgsType = viewArgs[1];
        this.viewReturnType = viewArgs[2];
        this.instructions = viewArgs[3];
        this.rootArgsType = $c46b7dbea18e1f8c$var$createToken(this.viewArgsType, 0);
        this.rootReturnType = $c46b7dbea18e1f8c$var$createToken(this.viewReturnType, 0);
    }
    /**
     *
     * @description Transform the view parameter into Michelson
     *
     * @param args parameter of the view in js format
     * @returns parameter of the view in Michelson
     * @throws {@link ParameterEncodingError}
     */ encodeViewArgs(args) {
        try {
            return this.rootArgsType.EncodeObject(args);
        } catch (ex) {
            throw new $c46b7dbea18e1f8c$export$a638dccee41148ef(this.viewName, undefined, args, ex);
        }
    }
    /**
     *
     * @description Transform the view result from Michelson to readable data
     *
     * @param val result of the view in JSON Michelson
     * @param semantics optional semantics to override the default decoding behavior
     * @returns result of the view in a readable format
     */ decodeViewResult(val, semantics) {
        return this.rootReturnType.Execute(val, semantics);
    }
    /**
     *
     * @description Return the signature of the view parameter
     */ extractArgsSchema() {
        return this.rootArgsType.ExtractSchema();
    }
    /**
     *
     * @description Return the format of the view result
     */ extractResultSchema() {
        return this.rootReturnType.ExtractSchema();
    }
}
class $c46b7dbea18e1f8c$export$769a4ec051ed522c {
    constructor(tag, type){
        this.tag = tag;
        this.type = type;
    }
    static fromMichelineValue(val) {
        var _a, _b;
        return new $c46b7dbea18e1f8c$export$769a4ec051ed522c((_a = val.annots) === null || _a === void 0 ? void 0 : _a[0], (_b = val.args) === null || _b === void 0 ? void 0 : _b[0]);
    }
    static fromRPCResponse(val) {
        const allEventSchema = [];
        val.script.code.forEach((code)=>{
            if (!('prim' in code) || code.prim !== 'code' || !('args' in code) || !code.args) return;
            allEventSchema.push(...$c46b7dbea18e1f8c$export$769a4ec051ed522c.extractEventsRecursively(code.args));
        });
        return $c46b7dbea18e1f8c$export$769a4ec051ed522c.removeDuplicates(allEventSchema);
    }
    static removeDuplicates(events) {
        const uniqueEvents = [];
        events.forEach((event)=>{
            const idx = uniqueEvents.findIndex((e)=>e.tag === event.tag && $c46b7dbea18e1f8c$export$9cb4719e2e525b7a(e.type, event.type));
            if (idx === -1) uniqueEvents.push(event);
        });
        return uniqueEvents;
    }
    static extractEventsRecursively(code) {
        if (Array.isArray(code)) return code.flatMap((c)=>$c46b7dbea18e1f8c$export$769a4ec051ed522c.extractEventsRecursively(c));
        if (!('prim' in code)) return [];
        if (code.prim === 'EMIT') return [
            $c46b7dbea18e1f8c$export$769a4ec051ed522c.fromMichelineValue(code)
        ];
        if (!('args' in code) || !code.args) return [];
        return code.args.flatMap((c)=>$c46b7dbea18e1f8c$export$769a4ec051ed522c.extractEventsRecursively(c));
    }
}
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $c46b7dbea18e1f8c$export$a4ad2735b021c132 = {
    "commitHash": "6a2c52b9e48b299dfc856149c1fa3388e77180ad",
    "version": "22.0.0"
};
/**
 * @packageDocumentation
 * @module @taquito/michelson-encoder
 */ const $c46b7dbea18e1f8c$export$d703b7d35511419c = Symbol();
const $c46b7dbea18e1f8c$export$19923f35e11d5203 = {};




// ==========================================================================================
// parent error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Parent error class all taquito errors to extend from
 */ class $eb894799b0e29f04$export$e5619b407b1c8b0a extends Error {
}
/**
 *  @category Error
 *  @description Error that indicates invalid user inputs
 */ class $eb894799b0e29f04$export$9d3f3bc8b6d48950 extends $eb894799b0e29f04$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error returned by RPC node
 */ class $eb894799b0e29f04$export$5460eff990f31920 extends $eb894799b0e29f04$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates TezosToolKit has not been configured appropriately
 */ class $eb894799b0e29f04$export$32f4d70b2fb302b1 extends $eb894799b0e29f04$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates a requested action is not supported by Taquito
 */ class $eb894799b0e29f04$export$34bc216509d47ce6 extends $eb894799b0e29f04$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error during a network operation
 */ class $eb894799b0e29f04$export$bae979e68e4dc802 extends $eb894799b0e29f04$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates user attempts an action without necessary permissions
 */ class $eb894799b0e29f04$export$9c81d48c1e1840ac extends $eb894799b0e29f04$export$e5619b407b1c8b0a {
}
// ==========================================================================================
// common error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Error that indicates an invalid originated or implicit address being passed or used
 */ class $eb894799b0e29f04$export$66c44d927ffead98 extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidAddressError';
        this.message = `Invalid address "${address}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
class $eb894799b0e29f04$export$be6cb9338b7137e0 extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidStakingAddressError';
        this.message = `Invalid staking address "${address}", you can only set destination as your own address`;
    }
}
class $eb894799b0e29f04$export$1623a856d8b6cc2a extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidFinalizeUnstakeAmountError';
        this.message = `The amount can only be 0 when finalizing an unstake`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid block hash being passed or used
 */ class $eb894799b0e29f04$export$16fabd343bcdfd7b extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(blockHash, errorDetail){
        super();
        this.blockHash = blockHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidBlockHashError';
        this.message = `Invalid block hash "${blockHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid amount of tez being passed as a parameter
 */ class $eb894799b0e29f04$export$d8bf6d22cce8e288 extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(amount){
        super();
        this.amount = amount;
        this.name = 'InvalidAmountError';
        this.message = `Invalid amount "${amount}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid derivation path being passed or used
 */ class $eb894799b0e29f04$export$522ca3df7030c309 extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(derivationPath, errorDetail){
        super();
        this.derivationPath = derivationPath;
        this.errorDetail = errorDetail;
        this.name = 'InvalidDerivationPathError';
        this.message = `Invalid derivation path "${derivationPath}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid hex string have been passed or used
 */ class $eb894799b0e29f04$export$1888d6928c74d5ee extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(hexString, errorDetail){
        super();
        this.hexString = hexString;
        this.errorDetail = errorDetail;
        this.name = 'InvalidHexStringError';
        this.message = `Invalid hex string "${hexString}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid message being passed or used
 */ class $eb894799b0e29f04$export$a5124d7665e9d8ad extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(msg, errorDetail){
        super();
        this.msg = msg;
        this.errorDetail = errorDetail;
        this.name = 'InvalidMessageError';
        this.message = `Invalid message "${msg}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid view parameter of a smart contract
 */ class $eb894799b0e29f04$export$f9ce6a924724628b extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(viewName, sigs, args, cause){
        super();
        this.viewName = viewName;
        this.sigs = sigs;
        this.args = args;
        this.cause = cause;
        this.name = 'InvalidViewParameterError';
        this.message = `Invalid view arguments ${JSON.stringify(args)} received for name "${viewName}" expecting one of the following signatures ${JSON.stringify(sigs)}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid private key being passed or used
 */ class $eb894799b0e29f04$export$adf223add86ae0aa extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(errorDetail){
        super();
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyError';
        this.message = `Invalid private key`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an Invalid Public Key being passed or used
 */ class $eb894799b0e29f04$export$f675822ed489f01f extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(publicKey, errorDetail){
        super();
        this.publicKey = publicKey;
        this.errorDetail = errorDetail;
        this.name = 'InvalidPublicKeyError';
        this.message = `Invalid public key "${publicKey}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid signature being passed or used
 */ class $eb894799b0e29f04$export$ccc2f68ef106615a extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(signature, errorDetail){
        super();
        this.signature = signature;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSignatureError';
        this.message = `Invalid signature "${signature}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid contract address being passed or used
 */ class $eb894799b0e29f04$export$193774326795229b extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(contractAddress, errorDetail){
        super();
        this.contractAddress = contractAddress;
        this.errorDetail = errorDetail;
        this.name = 'InvalidContractAddressError';
        this.message = `Invalid contract address "${contractAddress}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid chain id being passed or used
 */ class $eb894799b0e29f04$export$4836eb835ffca5b2 extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(chainId, errorDetail){
        super();
        this.chainId = chainId;
        this.errorDetail = errorDetail;
        this.name = 'InvalidChainIdError';
        this.message = `Invalid chain id "${chainId}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid public key hash being passed or used
 */ class $eb894799b0e29f04$export$a3d7df0ca9d9410c extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(keyHash, errorDetail){
        super();
        this.keyHash = keyHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyHashError';
        this.message = `Invalid public key hash "${keyHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation hash being passed or used
 */ class $eb894799b0e29f04$export$1a1c2023d3ec7a8a extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(operationHash, errorDetail){
        super();
        this.operationHash = operationHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationHashError';
        this.message = `Invalid operation hash "${operationHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation kind being passed or used
 */ class $eb894799b0e29f04$export$bc5be87550569b55 extends $eb894799b0e29f04$export$9d3f3bc8b6d48950 {
    constructor(operationKind, errorDetail){
        super();
        this.operationKind = operationKind;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationKindError';
        this.message = `Invalid operation kind "${operationKind}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description General error that indicates something is no longer supported and/or deprecated
 */ class $eb894799b0e29f04$export$11034991807c583d extends $eb894799b0e29f04$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'DeprecationError';
    }
}
/**
 *  @category Error
 *  @description General error that indicates an action is prohibited or not allowed
 */ class $eb894799b0e29f04$export$4041d915d9096adf extends $eb894799b0e29f04$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ProhibitedActionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure in grabbing the public key
 */ class $eb894799b0e29f04$export$183b043cd3c947f9 extends $eb894799b0e29f04$export$e5619b407b1c8b0a {
    constructor(pkh, cause){
        super();
        this.pkh = pkh;
        this.cause = cause;
        this.name = 'PublicKeyNotFoundError';
        this.message = `Public key not found of this address "${pkh}" in either wallet or contract API.`;
    }
}


// Michelson abstract syntax tree types https://tezos.gitlab.io/whitedoc/michelson.html#concrete-syntax
const $a98ce94f10ce3b87$export$ad6cc7932321c4f3 = Symbol('source_reference');
/**
 *  @category Error
 *  @description Error that indicates a failure when performing the scan step when parsing Michelson
 */ class $a98ce94f10ce3b87$var$ScanError extends (0, $eb894799b0e29f04$export$e5619b407b1c8b0a) {
    constructor(src, idx, message){
        super();
        this.src = src;
        this.idx = idx;
        this.message = message;
        this.name = 'ScanError';
    }
}
var $a98ce94f10ce3b87$var$Literal;
(function(Literal) {
    Literal[Literal["Comment"] = 0] = "Comment";
    Literal[Literal["Number"] = 1] = "Number";
    Literal[Literal["String"] = 2] = "String";
    Literal[Literal["Bytes"] = 3] = "Bytes";
    Literal[Literal["Ident"] = 4] = "Ident";
})($a98ce94f10ce3b87$var$Literal || ($a98ce94f10ce3b87$var$Literal = {}));
const $a98ce94f10ce3b87$var$isSpace = new RegExp('\\s');
const $a98ce94f10ce3b87$var$isIdentStart = new RegExp('[:@%_A-Za-z]');
const $a98ce94f10ce3b87$var$isIdent = new RegExp('[@%_\\.A-Za-z0-9]');
const $a98ce94f10ce3b87$var$isDigit = new RegExp('[0-9]');
const $a98ce94f10ce3b87$var$isHex = new RegExp('[0-9a-fA-F]');
function* $a98ce94f10ce3b87$var$scan(src, scanComments = false) {
    let i = 0;
    while(i < src.length){
        // Skip space
        while(i < src.length && $a98ce94f10ce3b87$var$isSpace.test(src[i]))i++;
        if (i === src.length) return;
        const s = src[i];
        const start = i;
        if ($a98ce94f10ce3b87$var$isIdentStart.test(s)) {
            // Identifier
            i++;
            while(i < src.length && $a98ce94f10ce3b87$var$isIdent.test(src[i]))i++;
            yield {
                t: $a98ce94f10ce3b87$var$Literal.Ident,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if (src.length - i > 1 && src.substring(i, i + 2) === '0x') {
            // Bytes
            i += 2;
            while(i < src.length && $a98ce94f10ce3b87$var$isHex.test(src[i]))i++;
            if ((i - start & 1) !== 0) throw new $a98ce94f10ce3b87$var$ScanError(src, i, 'Bytes literal length is expected to be power of two');
            yield {
                t: $a98ce94f10ce3b87$var$Literal.Bytes,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if ($a98ce94f10ce3b87$var$isDigit.test(s) || s === '-') {
            // Number
            if (s === '-') i++;
            const ii = i;
            while(i < src.length && $a98ce94f10ce3b87$var$isDigit.test(src[i]))i++;
            if (ii === i) throw new $a98ce94f10ce3b87$var$ScanError(src, i, 'Number literal is too short');
            yield {
                t: $a98ce94f10ce3b87$var$Literal.Number,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if (s === '"') {
            // String
            i++;
            let esc = false;
            for(; i < src.length && (esc || src[i] !== '"'); i++)if (!esc && src[i] === '\\') esc = true;
            else esc = false;
            if (i === src.length) throw new $a98ce94f10ce3b87$var$ScanError(src, i, 'Unterminated string literal');
            i++;
            yield {
                t: $a98ce94f10ce3b87$var$Literal.String,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if (s === '#') {
            // Comment
            i++;
            while(i < src.length && src[i] !== '\n')i++;
            if (scanComments) yield {
                t: $a98ce94f10ce3b87$var$Literal.Comment,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if (src.length - i > 1 && src.substring(i, i + 2) === '/*') {
            // C style comment
            i += 2;
            while(i < src.length && !(src.length - i > 1 && src.substring(i, i + 2) === '*/'))i++;
            if (i === src.length) throw new $a98ce94f10ce3b87$var$ScanError(src, i, 'Unterminated C style comment');
            i += 2;
            if (scanComments) yield {
                t: $a98ce94f10ce3b87$var$Literal.Comment,
                v: src.slice(start, i),
                first: start,
                last: i
            };
        } else if (s === '(' || s === ')' || s === '{' || s === '}' || s === ';') {
            i++;
            yield {
                t: s,
                v: s,
                first: start,
                last: i
            };
        } else throw new $a98ce94f10ce3b87$var$ScanError(src, i, `Invalid character at offset ${i}: \`${s}'`);
    }
}
// Michelson types
const $a98ce94f10ce3b87$export$8bd888d100ea60f = Symbol('ref_contract');
var $a98ce94f10ce3b87$export$377bbedb5576dfa8;
(function(Protocol) {
    Protocol["Ps9mPmXa"] = "Ps9mPmXaRzmzk35gbAYNCAw6UXdE2qoABTHbN2oEEc1qM7CwT9P";
    Protocol["PtCJ7pwo"] = "PtCJ7pwoxe8JasnHY8YonnLYjcVHmhiARPJvqcC6VfHT5s8k8sY";
    Protocol["PsYLVpVv"] = "PsYLVpVvgbLhAhoqAkMFUo6gudkJ9weNXhUYCiLDzcUpFpkk8Wt";
    Protocol["PsddFKi3"] = "PsddFKi32cMJ2qPjf43Qv5GDWLDPZb3T3bF6fLKiF5HtvHNU7aP";
    Protocol["Pt24m4xi"] = "Pt24m4xiPbLDhVgVfABUjirbmda3yohdN82Sp9FeuAXJ4eV9otd";
    Protocol["PsBABY5H"] = "PsBABY5HQTSkA4297zNHfsZNKtxULfL18y95qb3m53QJiXGmrbU";
    Protocol["PsBabyM1"] = "PsBabyM1eUXZseaJdmXFApDSBqj8YBfwELoxZHHW77EMcAbbwAS";
    Protocol["PsCARTHA"] = "PsCARTHAGazKbHtnKfLzQg3kms52kSRpgnDY982a9oYsSXRLQEb";
    Protocol["PsDELPH1"] = "PsDELPH1Kxsxt8f9eWbxQeRxkjfbxoqM52jvs5Y5fBxWWh4ifpo";
    Protocol["PtEdoTez"] = "PtEdoTezd3RHSC31mpxxo1npxFjoWWcFgQtxapi51Z8TLu6v6Uq";
    Protocol["PtEdo2Zk"] = "PtEdo2ZkT9oKpimTah6x2embF25oss54njMuPzkJTEi5RqfdZFA";
    Protocol["PsFLorena"] = "PsFLorenaUUuikDWvMDr6fGBRG8kt3e3D3fHoXK1j1BFRxeSH4i";
    Protocol["PtGRANADs"] = "PtGRANADsDU8R9daYKAgWnQYAJ64omN1o3KMGVCykShA97vQbvV";
    Protocol["PtHangzH"] = "PtHangzHogokSuiMHemCuowEavgYTP8J5qQ9fQS793MHYFpCY3r";
    Protocol["PtHangz2"] = "PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx";
    Protocol["PsiThaCa"] = "PsiThaCaT47Zboaw71QWScM8sXeMM7bbQFncK9FLqYc6EKdpjVP";
    Protocol["Psithaca2"] = "Psithaca2MLRFYargivpo7YvUr7wUDqyxrdhC5CQq78mRvimz6A";
    Protocol["PtJakarta"] = "PtJakartaiDz69SfDDLXJSiuZqTSeSKRDbKVZC8MNzJnvRjvnGw";
    Protocol["PtJakart2"] = "PtJakart2xVj7pYXJBXrqHgd82rdkLey5ZeeGwDgPp9rhQUbSqY";
    Protocol["PtKathman"] = "PtKathmankSpLLDALzWw7CGD2j2MtyveTwboEYokqUCP4a1LxMg";
    Protocol["PtLimaPtL"] = "PtLimaPtLMwfNinJi9rCfDPWea8dFgTZ1MeJ9f1m2SRic6ayiwW";
    Protocol["PtMumbaii"] = "PtMumbaiiFFEGbew1rRjzSPyzRbA51Tm3RVZL5suHPxSZYDhCEc";
    Protocol["PtMumbai2"] = "PtMumbai2TmsJHNGRkD8v8YDbtao7BLUC3wjASn1inAKLFCjaH1";
    Protocol["PtNairobi"] = "PtNairobiyssHuh87hEhfVBGCVrK3WnS8Z2FT4ymB5tAa4r1nQf";
    Protocol["ProxfordY"] = "ProxfordYmVfjWnRcgjWH36fW6PArwqykTFzotUxRs6gmTcZDuH";
    Protocol["PtParisBx"] = "PtParisBxoLz5gzMmn3d9WBQNoPSZakgnkMC2VNuQ3KXfUtUQeZ";
    Protocol["PsParisCZ"] = "PsParisCZo7KAh1Z1smVd9ZMZ1HHn5gkzbM94V3PLCpknFWhUAi";
    Protocol["PsQuebecn"] = "PsQuebecnLByd3JwTiGadoG4nGWi3HYiLXUjkibeFV8dCFeVMUg";
    Protocol["PsRiotuma"] = "PsRiotumaAMotcRoDWW1bysEhQy2n1M5fy8JgRp8jjRfHGmfeA7";
    Protocol["ProtoALpha"] = "ProtoALphaALphaALphaALphaALphaALphaALphaALphaDdp3zK";
})($a98ce94f10ce3b87$export$377bbedb5576dfa8 || ($a98ce94f10ce3b87$export$377bbedb5576dfa8 = {}));
const $a98ce94f10ce3b87$export$6af6ef9b852714c9 = $a98ce94f10ce3b87$export$377bbedb5576dfa8.PsRiotuma;
const $a98ce94f10ce3b87$var$protoLevel = {
    Ps9mPmXaRzmzk35gbAYNCAw6UXdE2qoABTHbN2oEEc1qM7CwT9P: 0,
    PtCJ7pwoxe8JasnHY8YonnLYjcVHmhiARPJvqcC6VfHT5s8k8sY: 1,
    PsYLVpVvgbLhAhoqAkMFUo6gudkJ9weNXhUYCiLDzcUpFpkk8Wt: 2,
    PsddFKi32cMJ2qPjf43Qv5GDWLDPZb3T3bF6fLKiF5HtvHNU7aP: 3,
    Pt24m4xiPbLDhVgVfABUjirbmda3yohdN82Sp9FeuAXJ4eV9otd: 4,
    PsBABY5HQTSkA4297zNHfsZNKtxULfL18y95qb3m53QJiXGmrbU: 5,
    PsBabyM1eUXZseaJdmXFApDSBqj8YBfwELoxZHHW77EMcAbbwAS: 5,
    PsCARTHAGazKbHtnKfLzQg3kms52kSRpgnDY982a9oYsSXRLQEb: 6,
    PsDELPH1Kxsxt8f9eWbxQeRxkjfbxoqM52jvs5Y5fBxWWh4ifpo: 7,
    PtEdoTezd3RHSC31mpxxo1npxFjoWWcFgQtxapi51Z8TLu6v6Uq: 8,
    PtEdo2ZkT9oKpimTah6x2embF25oss54njMuPzkJTEi5RqfdZFA: 8,
    PsFLorenaUUuikDWvMDr6fGBRG8kt3e3D3fHoXK1j1BFRxeSH4i: 9,
    PtGRANADsDU8R9daYKAgWnQYAJ64omN1o3KMGVCykShA97vQbvV: 10,
    PtHangzHogokSuiMHemCuowEavgYTP8J5qQ9fQS793MHYFpCY3r: 11,
    PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx: 11,
    PsiThaCaT47Zboaw71QWScM8sXeMM7bbQFncK9FLqYc6EKdpjVP: 12,
    Psithaca2MLRFYargivpo7YvUr7wUDqyxrdhC5CQq78mRvimz6A: 12,
    PtJakartaiDz69SfDDLXJSiuZqTSeSKRDbKVZC8MNzJnvRjvnGw: 13,
    PtJakart2xVj7pYXJBXrqHgd82rdkLey5ZeeGwDgPp9rhQUbSqY: 13,
    PtKathmankSpLLDALzWw7CGD2j2MtyveTwboEYokqUCP4a1LxMg: 14,
    PtLimaPtLMwfNinJi9rCfDPWea8dFgTZ1MeJ9f1m2SRic6ayiwW: 15,
    PtMumbaiiFFEGbew1rRjzSPyzRbA51Tm3RVZL5suHPxSZYDhCEc: 16,
    PtMumbai2TmsJHNGRkD8v8YDbtao7BLUC3wjASn1inAKLFCjaH1: 16,
    PtNairobiyssHuh87hEhfVBGCVrK3WnS8Z2FT4ymB5tAa4r1nQf: 17,
    ProxfordYmVfjWnRcgjWH36fW6PArwqykTFzotUxRs6gmTcZDuH: 19,
    PtParisBxoLz5gzMmn3d9WBQNoPSZakgnkMC2VNuQ3KXfUtUQeZ: 20,
    PsParisCZo7KAh1Z1smVd9ZMZ1HHn5gkzbM94V3PLCpknFWhUAi: 20,
    PsQuebecnLByd3JwTiGadoG4nGWi3HYiLXUjkibeFV8dCFeVMUg: 21,
    PsRiotumaAMotcRoDWW1bysEhQy2n1M5fy8JgRp8jjRfHGmfeA7: 22,
    ProtoALphaALphaALphaALphaALphaALphaALphaALphaDdp3zK: 23
};
function $a98ce94f10ce3b87$export$d42f6d6be949e71e(a, b) {
    return $a98ce94f10ce3b87$var$protoLevel[a] >= $a98ce94f10ce3b87$var$protoLevel[b];
}
function $a98ce94f10ce3b87$export$d0c06cb7d5b8a84b(a, b) {
    return $a98ce94f10ce3b87$var$protoLevel[a] < $a98ce94f10ce3b87$var$protoLevel[b];
}
/**
 *  @category Error
 *  @description Error that indicates macros failed to be expanded
 */ class $a98ce94f10ce3b87$export$12eefc679432101a extends (0, $eb894799b0e29f04$export$e5619b407b1c8b0a) {
    constructor(prim, message){
        super();
        this.prim = prim;
        this.message = message;
        this.name = 'MacroError';
    }
}
function $a98ce94f10ce3b87$var$assertArgs$1(ex, n) {
    var _a, _b;
    if (n === 0 && ex.args === undefined || ((_a = ex.args) === null || _a === void 0 ? void 0 : _a.length) === n) return true;
    throw new $a98ce94f10ce3b87$export$12eefc679432101a(ex, `macro ${ex.prim} expects ${n} arguments, was given ${(_b = ex.args) === null || _b === void 0 ? void 0 : _b.length}`);
}
function $a98ce94f10ce3b87$var$assertNoAnnots(ex) {
    if (ex.annots === undefined) return true;
    throw new $a98ce94f10ce3b87$export$12eefc679432101a(ex, `unexpected annotation on macro ${ex.prim}: ${ex.annots}`);
}
function $a98ce94f10ce3b87$var$assertIntArg(ex, arg) {
    if ('int' in arg) return true;
    throw new $a98ce94f10ce3b87$export$12eefc679432101a(ex, `macro ${ex.prim} expects int argument`);
}
function $a98ce94f10ce3b87$var$parsePairUnpairExpr(p, expr, annotations, agg) {
    let i = 0;
    let ai = 0;
    const ann = [
        null,
        null
    ];
    // Left expression
    let lexpr;
    if (i === expr.length) throw new $a98ce94f10ce3b87$export$12eefc679432101a(p, `unexpected end: ${p.prim}`);
    let c = expr[i++];
    switch(c){
        case 'P':
            {
                const { r: r, n: n, an: an } = $a98ce94f10ce3b87$var$parsePairUnpairExpr(p, expr.slice(i), annotations.slice(ai), agg);
                lexpr = r;
                i += n;
                ai += an;
                break;
            }
        case 'A':
            if (ai !== annotations.length) ann[0] = annotations[ai++];
            break;
        default:
            throw new $a98ce94f10ce3b87$export$12eefc679432101a(p, `${p.prim}: unexpected character: ${c}`);
    }
    // Right expression
    let rexpr;
    if (i === expr.length) throw new $a98ce94f10ce3b87$export$12eefc679432101a(p, `unexpected end: ${p.prim}`);
    c = expr[i++];
    switch(c){
        case 'P':
            {
                const { r: r, n: n, an: an } = $a98ce94f10ce3b87$var$parsePairUnpairExpr(p, expr.slice(i), annotations.slice(ai), agg);
                rexpr = r.map(([v, a])=>[
                        v + 1,
                        a
                    ]);
                i += n;
                ai += an;
                break;
            }
        case 'I':
            if (ai !== annotations.length) ann[1] = annotations[ai++];
            break;
        default:
            throw new $a98ce94f10ce3b87$export$12eefc679432101a(p, `${p.prim}: unexpected character: ${c}`);
    }
    return {
        r: agg(lexpr, rexpr, [
            0,
            ann
        ]),
        n: i,
        an: ai
    };
}
function $a98ce94f10ce3b87$var$parseSetMapCadr(p, expr, vann, term) {
    const c = expr[0];
    switch(c){
        case 'A':
            return expr.length > 1 ? [
                {
                    prim: 'DUP'
                },
                {
                    prim: 'DIP',
                    args: [
                        [
                            {
                                prim: 'CAR',
                                annots: [
                                    '@%%'
                                ]
                            },
                            $a98ce94f10ce3b87$var$parseSetMapCadr(p, expr.slice(1), [], term)
                        ]
                    ]
                },
                {
                    prim: 'CDR',
                    annots: [
                        '@%%'
                    ]
                },
                {
                    prim: 'SWAP'
                },
                {
                    prim: 'PAIR',
                    annots: [
                        '%@',
                        '%@',
                        ...vann
                    ]
                }
            ] : term.a;
        case 'D':
            return expr.length > 1 ? [
                {
                    prim: 'DUP'
                },
                {
                    prim: 'DIP',
                    args: [
                        [
                            {
                                prim: 'CDR',
                                annots: [
                                    '@%%'
                                ]
                            },
                            $a98ce94f10ce3b87$var$parseSetMapCadr(p, expr.slice(1), [], term)
                        ]
                    ]
                },
                {
                    prim: 'CAR',
                    annots: [
                        '@%%'
                    ]
                },
                {
                    prim: 'PAIR',
                    annots: [
                        '%@',
                        '%@',
                        ...vann
                    ]
                }
            ] : term.d;
        default:
            throw new $a98ce94f10ce3b87$export$12eefc679432101a(p, `${p.prim}: unexpected character: ${c}`);
    }
}
function $a98ce94f10ce3b87$var$trimLast(a, v) {
    let l = a.length;
    while(l > 0 && a[l - 1] === v)l--;
    return a.slice(0, l);
}
function $a98ce94f10ce3b87$var$filterAnnotations(a) {
    const fields = [];
    const rest = [];
    if (a !== undefined) for (const v of a)(v.length !== 0 && v[0] === '%' ? fields : rest).push(v);
    return {
        fields: fields,
        rest: rest
    };
}
function $a98ce94f10ce3b87$var$mkPrim({ prim: prim, annots: annots, args: args }) {
    return Object.assign(Object.assign({
        prim: prim
    }, annots && {
        annots: annots
    }), args && {
        args: args
    });
}
const $a98ce94f10ce3b87$var$pairRe = /^P[PAI]{3,}R$/;
const $a98ce94f10ce3b87$var$unpairRe = /^UNP[PAI]{2,}R$/;
const $a98ce94f10ce3b87$var$cadrRe = /^C[AD]{2,}R$/;
const $a98ce94f10ce3b87$var$setCadrRe = /^SET_C[AD]+R$/;
const $a98ce94f10ce3b87$var$mapCadrRe = /^MAP_C[AD]+R$/;
const $a98ce94f10ce3b87$var$diipRe = /^DI{2,}P$/;
const $a98ce94f10ce3b87$var$duupRe = /^DU+P$/;
function $a98ce94f10ce3b87$var$expandMacros(ex, opt) {
    const proto = (opt === null || opt === void 0 ? void 0 : opt.protocol) || $a98ce94f10ce3b87$export$6af6ef9b852714c9;
    function mayRename(annots) {
        return annots !== undefined ? [
            {
                prim: 'RENAME',
                annots: annots
            }
        ] : [];
    }
    switch(ex.prim){
        // Compare
        case 'CMPEQ':
        case 'CMPNEQ':
        case 'CMPLT':
        case 'CMPGT':
        case 'CMPLE':
        case 'CMPGE':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0)) return [
                {
                    prim: 'COMPARE'
                },
                $a98ce94f10ce3b87$var$mkPrim({
                    prim: ex.prim.slice(3),
                    annots: ex.annots
                })
            ];
            break;
        case 'IFEQ':
        case 'IFNEQ':
        case 'IFLT':
        case 'IFGT':
        case 'IFLE':
        case 'IFGE':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 2)) return [
                {
                    prim: ex.prim.slice(2)
                },
                $a98ce94f10ce3b87$var$mkPrim({
                    prim: 'IF',
                    annots: ex.annots,
                    args: ex.args
                })
            ];
            break;
        case 'IFCMPEQ':
        case 'IFCMPNEQ':
        case 'IFCMPLT':
        case 'IFCMPGT':
        case 'IFCMPLE':
        case 'IFCMPGE':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 2)) return [
                {
                    prim: 'COMPARE'
                },
                {
                    prim: ex.prim.slice(5)
                },
                $a98ce94f10ce3b87$var$mkPrim({
                    prim: 'IF',
                    annots: ex.annots,
                    args: ex.args
                })
            ];
            break;
        // Fail
        case 'FAIL':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0) && $a98ce94f10ce3b87$var$assertNoAnnots(ex)) return [
                {
                    prim: 'UNIT'
                },
                {
                    prim: 'FAILWITH'
                }
            ];
            break;
        // Assertion macros
        case 'ASSERT':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0) && $a98ce94f10ce3b87$var$assertNoAnnots(ex)) return [
                {
                    prim: 'IF',
                    args: [
                        [],
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ]
                    ]
                }
            ];
            break;
        case 'ASSERT_EQ':
        case 'ASSERT_NEQ':
        case 'ASSERT_LT':
        case 'ASSERT_GT':
        case 'ASSERT_LE':
        case 'ASSERT_GE':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0) && $a98ce94f10ce3b87$var$assertNoAnnots(ex)) return [
                {
                    prim: ex.prim.slice(7)
                },
                {
                    prim: 'IF',
                    args: [
                        [],
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ]
                    ]
                }
            ];
            break;
        case 'ASSERT_CMPEQ':
        case 'ASSERT_CMPNEQ':
        case 'ASSERT_CMPLT':
        case 'ASSERT_CMPGT':
        case 'ASSERT_CMPLE':
        case 'ASSERT_CMPGE':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0) && $a98ce94f10ce3b87$var$assertNoAnnots(ex)) return [
                [
                    {
                        prim: 'COMPARE'
                    },
                    {
                        prim: ex.prim.slice(10)
                    }
                ],
                {
                    prim: 'IF',
                    args: [
                        [],
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ]
                    ]
                }
            ];
            break;
        case 'ASSERT_NONE':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0) && $a98ce94f10ce3b87$var$assertNoAnnots(ex)) return [
                {
                    prim: 'IF_NONE',
                    args: [
                        [],
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ]
                    ]
                }
            ];
            break;
        case 'ASSERT_SOME':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0)) return [
                {
                    prim: 'IF_NONE',
                    args: [
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ],
                        mayRename(ex.annots)
                    ]
                }
            ];
            break;
        case 'ASSERT_LEFT':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0)) return [
                {
                    prim: 'IF_LEFT',
                    args: [
                        mayRename(ex.annots),
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ]
                    ]
                }
            ];
            break;
        case 'ASSERT_RIGHT':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0)) return [
                {
                    prim: 'IF_LEFT',
                    args: [
                        [
                            [
                                {
                                    prim: 'UNIT'
                                },
                                {
                                    prim: 'FAILWITH'
                                }
                            ]
                        ],
                        mayRename(ex.annots)
                    ]
                }
            ];
            break;
        // Syntactic conveniences
        case 'IF_SOME':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 2)) return [
                $a98ce94f10ce3b87$var$mkPrim({
                    prim: 'IF_NONE',
                    annots: ex.annots,
                    args: [
                        ex.args[1],
                        ex.args[0]
                    ]
                })
            ];
            break;
        case 'IF_RIGHT':
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 2)) return [
                $a98ce94f10ce3b87$var$mkPrim({
                    prim: 'IF_LEFT',
                    annots: ex.annots,
                    args: [
                        ex.args[1],
                        ex.args[0]
                    ]
                })
            ];
            break;
        // CAR/CDR n
        case 'CAR':
        case 'CDR':
            if (ex.args !== undefined) {
                if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 1) && $a98ce94f10ce3b87$var$assertIntArg(ex, ex.args[0])) {
                    const n = parseInt(ex.args[0].int, 10);
                    return $a98ce94f10ce3b87$var$mkPrim({
                        prim: 'GET',
                        args: [
                            {
                                int: ex.prim === 'CAR' ? String(n * 2 + 1) : String(n * 2)
                            }
                        ],
                        annots: ex.annots
                    });
                }
            } else return ex;
    }
    // More syntactic conveniences
    // PAPPAIIR macro
    if ($a98ce94f10ce3b87$var$pairRe.test(ex.prim)) {
        if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0)) {
            const { fields: fields, rest: rest } = $a98ce94f10ce3b87$var$filterAnnotations(ex.annots);
            const { r: r } = $a98ce94f10ce3b87$var$parsePairUnpairExpr(ex, ex.prim.slice(1), fields, (l, r, top)=>[
                    ...l || [],
                    ...r || [],
                    top
                ]);
            return r.map(([v, a], i)=>{
                const ann = [
                    ...$a98ce94f10ce3b87$var$trimLast(a, null).map((v)=>v === null ? '%' : v),
                    ...v === 0 && i === r.length - 1 ? rest : []
                ];
                const leaf = $a98ce94f10ce3b87$var$mkPrim({
                    prim: 'PAIR',
                    annots: ann.length !== 0 ? ann : undefined
                });
                return v === 0 ? leaf : {
                    prim: 'DIP',
                    args: v === 1 ? [
                        [
                            leaf
                        ]
                    ] : [
                        {
                            int: String(v)
                        },
                        [
                            leaf
                        ]
                    ]
                };
            });
        }
    }
    // UNPAPPAIIR macro
    if ($a98ce94f10ce3b87$var$unpairRe.test(ex.prim)) {
        if ($a98ce94f10ce3b87$export$d0c06cb7d5b8a84b(proto, $a98ce94f10ce3b87$export$377bbedb5576dfa8.PtEdo2Zk) && $a98ce94f10ce3b87$var$assertArgs$1(ex, 0)) {
            const { r: r } = $a98ce94f10ce3b87$var$parsePairUnpairExpr(ex, ex.prim.slice(3), ex.annots || [], (l, r, top)=>[
                    top,
                    ...r || [],
                    ...l || []
                ]);
            return r.map(([v, a])=>{
                const leaf = [
                    {
                        prim: 'DUP'
                    },
                    $a98ce94f10ce3b87$var$mkPrim({
                        prim: 'CAR',
                        annots: a[0] !== null ? [
                            a[0]
                        ] : undefined
                    }),
                    {
                        prim: 'DIP',
                        args: [
                            [
                                $a98ce94f10ce3b87$var$mkPrim({
                                    prim: 'CDR',
                                    annots: a[1] !== null ? [
                                        a[1]
                                    ] : undefined
                                })
                            ]
                        ]
                    }
                ];
                return v === 0 ? leaf : {
                    prim: 'DIP',
                    args: v === 1 ? [
                        [
                            leaf
                        ]
                    ] : [
                        {
                            int: String(v)
                        },
                        [
                            leaf
                        ]
                    ]
                };
            });
        } else {
            if (ex.prim === 'UNPAIR') return ex;
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0)) {
                // 008_edo: annotations are deprecated
                const { r: r } = $a98ce94f10ce3b87$var$parsePairUnpairExpr(ex, ex.prim.slice(3), [], (l, r, top)=>[
                        top,
                        ...r || [],
                        ...l || []
                    ]);
                return r.map(([v])=>{
                    const leaf = $a98ce94f10ce3b87$var$mkPrim({
                        prim: 'UNPAIR'
                    });
                    return v === 0 ? leaf : {
                        prim: 'DIP',
                        args: v === 1 ? [
                            [
                                leaf
                            ]
                        ] : [
                            {
                                int: String(v)
                            },
                            [
                                leaf
                            ]
                        ]
                    };
                });
            }
        }
    }
    // C[AD]+R macro
    if ($a98ce94f10ce3b87$var$cadrRe.test(ex.prim)) {
        if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0)) {
            const ch = [
                ...ex.prim.slice(1, ex.prim.length - 1)
            ];
            return ch.map((c, i)=>{
                const ann = i === ch.length - 1 ? ex.annots : undefined;
                switch(c){
                    case 'A':
                        return $a98ce94f10ce3b87$var$mkPrim({
                            prim: 'CAR',
                            annots: ann
                        });
                    case 'D':
                        return $a98ce94f10ce3b87$var$mkPrim({
                            prim: 'CDR',
                            annots: ann
                        });
                    default:
                        throw new $a98ce94f10ce3b87$export$12eefc679432101a(ex, `unexpected character: ${c}`);
                }
            });
        }
    }
    // SET_C[AD]+R macro
    if ($a98ce94f10ce3b87$var$setCadrRe.test(ex.prim)) {
        if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0)) {
            const { fields: fields, rest: rest } = $a98ce94f10ce3b87$var$filterAnnotations(ex.annots);
            if (fields.length > 1) throw new $a98ce94f10ce3b87$export$12eefc679432101a(ex, `unexpected annotation on macro ${ex.prim}: ${fields}`);
            const term = fields.length !== 0 ? {
                a: [
                    {
                        prim: 'DUP'
                    },
                    {
                        prim: 'CAR',
                        annots: fields
                    },
                    {
                        prim: 'DROP'
                    },
                    {
                        prim: 'CDR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'SWAP'
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            fields[0],
                            '%@'
                        ]
                    }
                ],
                d: [
                    {
                        prim: 'DUP'
                    },
                    {
                        prim: 'CDR',
                        annots: fields
                    },
                    {
                        prim: 'DROP'
                    },
                    {
                        prim: 'CAR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            '%@',
                            fields[0]
                        ]
                    }
                ]
            } : {
                a: [
                    {
                        prim: 'CDR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'SWAP'
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            '%',
                            '%@'
                        ]
                    }
                ],
                d: [
                    {
                        prim: 'CAR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            '%@',
                            '%'
                        ]
                    }
                ]
            };
            return $a98ce94f10ce3b87$var$parseSetMapCadr(ex, ex.prim.slice(5, ex.prim.length - 1), rest, term);
        }
    }
    // MAP_C[AD]+R macro
    if ($a98ce94f10ce3b87$var$mapCadrRe.test(ex.prim)) {
        if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 1)) {
            const { fields: fields } = $a98ce94f10ce3b87$var$filterAnnotations(ex.annots);
            if (fields.length > 1) throw new $a98ce94f10ce3b87$export$12eefc679432101a(ex, `unexpected annotation on macro ${ex.prim}: ${fields}`);
            const term = {
                a: [
                    {
                        prim: 'DUP'
                    },
                    {
                        prim: 'CDR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'DIP',
                        args: [
                            [
                                $a98ce94f10ce3b87$var$mkPrim({
                                    prim: 'CAR',
                                    annots: fields.length !== 0 ? [
                                        '@' + fields[0].slice(1)
                                    ] : undefined
                                }),
                                ex.args[0]
                            ]
                        ]
                    },
                    {
                        prim: 'SWAP'
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            fields.length !== 0 ? fields[0] : '%',
                            '%@'
                        ]
                    }
                ],
                d: [
                    {
                        prim: 'DUP'
                    },
                    $a98ce94f10ce3b87$var$mkPrim({
                        prim: 'CDR',
                        annots: fields.length !== 0 ? [
                            '@' + fields[0].slice(1)
                        ] : undefined
                    }),
                    ex.args[0],
                    {
                        prim: 'SWAP'
                    },
                    {
                        prim: 'CAR',
                        annots: [
                            '@%%'
                        ]
                    },
                    {
                        prim: 'PAIR',
                        annots: [
                            '%@',
                            fields.length !== 0 ? fields[0] : '%'
                        ]
                    }
                ]
            };
            return $a98ce94f10ce3b87$var$parseSetMapCadr(ex, ex.prim.slice(5, ex.prim.length - 1), [], term);
        }
    }
    // Expand deprecated DI...IP to [DIP n]
    if ($a98ce94f10ce3b87$var$diipRe.test(ex.prim)) {
        if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 1)) {
            let n = 0;
            while(ex.prim[1 + n] === 'I')n++;
            return $a98ce94f10ce3b87$var$mkPrim({
                prim: 'DIP',
                args: [
                    {
                        int: String(n)
                    },
                    ex.args[0]
                ]
            });
        }
    }
    // Expand DU...UP and DUP n
    if ($a98ce94f10ce3b87$var$duupRe.test(ex.prim)) {
        let n = 0;
        while(ex.prim[1 + n] === 'U')n++;
        if ($a98ce94f10ce3b87$export$d0c06cb7d5b8a84b(proto, $a98ce94f10ce3b87$export$377bbedb5576dfa8.PtEdo2Zk)) {
            if (n === 1) {
                if (ex.args === undefined) return ex; // skip
                if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 1) && $a98ce94f10ce3b87$var$assertIntArg(ex, ex.args[0])) n = parseInt(ex.args[0].int, 10);
            } else $a98ce94f10ce3b87$var$assertArgs$1(ex, 0);
            if (n === 1) return [
                $a98ce94f10ce3b87$var$mkPrim({
                    prim: 'DUP',
                    annots: ex.annots
                })
            ];
            else if (n === 2) return [
                {
                    prim: 'DIP',
                    args: [
                        [
                            $a98ce94f10ce3b87$var$mkPrim({
                                prim: 'DUP',
                                annots: ex.annots
                            })
                        ]
                    ]
                },
                {
                    prim: 'SWAP'
                }
            ];
            else return [
                {
                    prim: 'DIP',
                    args: [
                        {
                            int: String(n - 1)
                        },
                        [
                            $a98ce94f10ce3b87$var$mkPrim({
                                prim: 'DUP',
                                annots: ex.annots
                            })
                        ]
                    ]
                },
                {
                    prim: 'DIG',
                    args: [
                        {
                            int: String(n)
                        }
                    ]
                }
            ];
        } else {
            if (n === 1) return ex;
            if ($a98ce94f10ce3b87$var$assertArgs$1(ex, 0)) return $a98ce94f10ce3b87$var$mkPrim({
                prim: 'DUP',
                args: [
                    {
                        int: String(n)
                    }
                ],
                annots: ex.annots
            });
        }
    }
    return ex;
}
function $a98ce94f10ce3b87$var$expandGlobalConstants(ex, hashAndValue) {
    if (ex.args !== undefined && ex.args.length === 1 && 'string' in ex.args[0] && ex.args[0].string in hashAndValue) return hashAndValue[ex.args[0].string];
    return ex;
}
/**
 *  @category Error
 *  @description Error that indicates a failure when parsing Micheline expressions
 */ class $a98ce94f10ce3b87$export$2038bc0381931c3c extends (0, $eb894799b0e29f04$export$e5619b407b1c8b0a) {
    /**
     * @param token A token caused the error
     * @param message An error message
     */ constructor(token, message){
        super();
        this.token = token;
        this.message = message;
        this.name = 'MichelineParseError';
    }
}
/**
 *  @category Error
 *  @description Error indicates a failure when parsing Micheline JSON
 */ class $a98ce94f10ce3b87$export$796bd0427cfd15b1 extends (0, $eb894799b0e29f04$export$e5619b407b1c8b0a) {
    /**
     * @param node A node caused the error
     * @param message An error message
     */ constructor(node, message){
        super();
        this.node = node;
        this.message = message;
        this.name = 'JSONParseError';
    }
}
const $a98ce94f10ce3b87$var$errEOF = new $a98ce94f10ce3b87$export$2038bc0381931c3c(null, 'Unexpected EOF');
function $a98ce94f10ce3b87$var$isAnnotation(tok) {
    return tok.t === $a98ce94f10ce3b87$var$Literal.Ident && (tok.v[0] === '@' || tok.v[0] === '%' || tok.v[0] === ':');
}
const $a98ce94f10ce3b87$var$intRe = new RegExp('^-?[0-9]+$');
const $a98ce94f10ce3b87$var$bytesRe = new RegExp('^([0-9a-fA-F]{2})*$');
/**
 * Converts and validates Michelson expressions between JSON-based Michelson and Micheline
 *
 * Pretty Print a Michelson Smart Contract:
 * ```
 * const contract = await Tezos.contract.at("KT1Vsw3kh9638gqWoHTjvHCoHLPKvCbMVbCg");
 * const p = new Parser();
 *
 * const michelsonCode = p.parseJSON(contract.script.code);
 * const storage = p.parseJSON(contract.script.storage);
 *
 * console.log("Pretty print Michelson smart contract:");
 * console.log(emitMicheline(michelsonCode, {indent:"    ", newline: "\n",}));
 *
 * console.log("Pretty print Storage:");
 * console.log(emitMicheline(storage, {indent:"    ", newline: "\n",}));
 * ```
 *
 * Encode a Michelson expression for initial storage of a smart contract
 * ```
 * const src = `(Pair (Pair { Elt 1
 *                (Pair (Pair "tz1gjaF81ZRRvdzjobyfVNsAeSC6PScjfQwN" "tz1KqTpEZ7Yob7QbPE4Hy4Wo8fHG8LhKxZSx")
 *                      0x0501000000026869) }
 *          10000000)
 *    (Pair 2 333))`;
 *
 * const p = new Parser();
 *
 * const exp = p.parseMichelineExpression(src);
 * console.log(JSON.stringify(exp));
 * ```
 */ class $a98ce94f10ce3b87$export$7acfa6ed01010e37 {
    constructor(opt){
        this.opt = opt;
    }
    expand(ex) {
        var _a, _b, _c;
        if (((_a = this.opt) === null || _a === void 0 ? void 0 : _a.expandGlobalConstant) !== undefined && ex.prim === 'constant') {
            const ret = $a98ce94f10ce3b87$var$expandGlobalConstants(ex, this.opt.expandGlobalConstant);
            if (ret !== ex) ret[$a98ce94f10ce3b87$export$ad6cc7932321c4f3] = Object.assign(Object.assign({}, ex[$a98ce94f10ce3b87$export$ad6cc7932321c4f3] || {
                first: 0,
                last: 0
            }), {
                globalConstant: ex
            });
            return ret;
        }
        if (((_b = this.opt) === null || _b === void 0 ? void 0 : _b.expandMacros) !== undefined ? (_c = this.opt) === null || _c === void 0 ? void 0 : _c.expandMacros : true) {
            const ret = $a98ce94f10ce3b87$var$expandMacros(ex, this.opt);
            if (ret !== ex) ret[$a98ce94f10ce3b87$export$ad6cc7932321c4f3] = Object.assign(Object.assign({}, ex[$a98ce94f10ce3b87$export$ad6cc7932321c4f3] || {
                first: 0,
                last: 0
            }), {
                macro: ex
            });
            return ret;
        } else return ex;
    }
    parseListExpr(scanner, start) {
        var _a;
        const ref = {
            first: start.first,
            last: start.last
        };
        const expectBracket = start.t === '(';
        let tok;
        if (expectBracket) {
            tok = scanner.next();
            if (tok.done) throw $a98ce94f10ce3b87$var$errEOF;
            ref.last = tok.value.last;
        } else tok = {
            value: start
        };
        if (tok.value.t !== $a98ce94f10ce3b87$var$Literal.Ident) throw new $a98ce94f10ce3b87$export$2038bc0381931c3c(tok.value, `not an identifier: ${tok.value.v}`);
        const ret = {
            prim: tok.value.v,
            [$a98ce94f10ce3b87$export$ad6cc7932321c4f3]: ref
        };
        for(;;){
            const tok = scanner.next();
            if (tok.done) {
                if (expectBracket) throw $a98ce94f10ce3b87$var$errEOF;
                break;
            } else if (tok.value.t === ')') {
                if (!expectBracket) throw new $a98ce94f10ce3b87$export$2038bc0381931c3c(tok.value, 'unexpected closing bracket');
                ref.last = tok.value.last;
                break;
            } else if ($a98ce94f10ce3b87$var$isAnnotation(tok.value)) {
                ret.annots = ret.annots || [];
                ret.annots.push(tok.value.v);
                ref.last = tok.value.last;
            } else {
                ret.args = ret.args || [];
                const arg = this.parseExpr(scanner, tok.value);
                ref.last = ((_a = arg[$a98ce94f10ce3b87$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.last) || ref.last;
                ret.args.push(arg);
            }
        }
        return this.expand(ret);
    }
    parseArgs(scanner, start) {
        var _a;
        // Identifier with arguments
        const ref = {
            first: start.first,
            last: start.last
        };
        const p = {
            prim: start.v,
            [$a98ce94f10ce3b87$export$ad6cc7932321c4f3]: ref
        };
        for(;;){
            const t = scanner.next();
            if (t.done || t.value.t === '}' || t.value.t === ';') return [
                p,
                t
            ];
            if ($a98ce94f10ce3b87$var$isAnnotation(t.value)) {
                ref.last = t.value.last;
                p.annots = p.annots || [];
                p.annots.push(t.value.v);
            } else {
                const arg = this.parseExpr(scanner, t.value);
                ref.last = ((_a = arg[$a98ce94f10ce3b87$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.last) || ref.last;
                p.args = p.args || [];
                p.args.push(arg);
            }
        }
    }
    parseSequenceExpr(scanner, start) {
        var _a, _b;
        const ref = {
            first: start.first,
            last: start.last
        };
        const seq = [];
        seq[$a98ce94f10ce3b87$export$ad6cc7932321c4f3] = ref;
        const expectBracket = start.t === '{';
        let tok = start.t === '{' ? null : {
            value: start
        };
        for(;;){
            if (tok === null) {
                tok = scanner.next();
                if (!tok.done) ref.last = tok.value.last;
            }
            if (tok.done) {
                if (expectBracket) throw $a98ce94f10ce3b87$var$errEOF;
                else return seq;
            }
            if (tok.value.t === '}') {
                if (!expectBracket) throw new $a98ce94f10ce3b87$export$2038bc0381931c3c(tok.value, 'unexpected closing bracket');
                else return seq;
            } else if (tok.value.t === $a98ce94f10ce3b87$var$Literal.Ident) {
                // Identifier with arguments
                const [itm, n] = this.parseArgs(scanner, tok.value);
                ref.last = ((_a = itm[$a98ce94f10ce3b87$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.last) || ref.last;
                seq.push(this.expand(itm));
                tok = n;
            } else {
                // Other
                const ex = this.parseExpr(scanner, tok.value);
                ref.last = ((_b = ex[$a98ce94f10ce3b87$export$ad6cc7932321c4f3]) === null || _b === void 0 ? void 0 : _b.last) || ref.last;
                seq.push(ex);
                tok = null;
            }
            if (tok === null) {
                tok = scanner.next();
                if (!tok.done) ref.last = tok.value.last;
            }
            if (!tok.done && tok.value.t === ';') tok = null;
        }
    }
    parseExpr(scanner, tok) {
        switch(tok.t){
            case $a98ce94f10ce3b87$var$Literal.Ident:
                return this.expand({
                    prim: tok.v,
                    [$a98ce94f10ce3b87$export$ad6cc7932321c4f3]: {
                        first: tok.first,
                        last: tok.last
                    }
                });
            case $a98ce94f10ce3b87$var$Literal.Number:
                return {
                    int: tok.v,
                    [$a98ce94f10ce3b87$export$ad6cc7932321c4f3]: {
                        first: tok.first,
                        last: tok.last
                    }
                };
            case $a98ce94f10ce3b87$var$Literal.String:
                return {
                    string: JSON.parse(tok.v),
                    [$a98ce94f10ce3b87$export$ad6cc7932321c4f3]: {
                        first: tok.first,
                        last: tok.last
                    }
                };
            case $a98ce94f10ce3b87$var$Literal.Bytes:
                return {
                    bytes: tok.v.slice(2),
                    [$a98ce94f10ce3b87$export$ad6cc7932321c4f3]: {
                        first: tok.first,
                        last: tok.last
                    }
                };
            case '{':
                return this.parseSequenceExpr(scanner, tok);
            default:
                return this.parseListExpr(scanner, tok);
        }
    }
    /**
     * Parses a Micheline sequence expression, such as smart contract source. Enclosing curly brackets may be omitted.
     * @param src A Micheline sequence `{parameter ...; storage int; code { DUP ; ...};}` or `parameter ...; storage int; code { DUP ; ...};`
     */ parseSequence(src) {
        if (typeof src !== 'string') throw new TypeError(`string type was expected, got ${typeof src} instead`);
        const scanner = $a98ce94f10ce3b87$var$scan(src);
        const tok = scanner.next();
        if (tok.done) return null;
        return this.parseSequenceExpr(scanner, tok.value);
    }
    /**
     * Parse a Micheline sequence expression. Enclosing curly brackets may be omitted.
     * @param src A Michelson list expression such as `(Pair {Elt "0" 0} 0)` or `Pair {Elt "0" 0} 0`
     * @returns An AST node or null for empty document.
     */ parseList(src) {
        if (typeof src !== 'string') throw new TypeError(`string type was expected, got ${typeof src} instead`);
        const scanner = $a98ce94f10ce3b87$var$scan(src);
        const tok = scanner.next();
        if (tok.done) return null;
        return this.parseListExpr(scanner, tok.value);
    }
    /**
     * Parse any Michelson expression
     * @param src A Michelson expression such as `(Pair {Elt "0" 0} 0)` or `{parameter ...; storage int; code { DUP ; ...};}`
     * @returns An AST node or null for empty document.
     */ parseMichelineExpression(src) {
        if (typeof src !== 'string') throw new TypeError(`string type was expected, got ${typeof src} instead`);
        const scanner = $a98ce94f10ce3b87$var$scan(src);
        const tok = scanner.next();
        if (tok.done) return null;
        return this.parseExpr(scanner, tok.value);
    }
    /**
     * Parse a Micheline sequence expression, such as smart contract source. Enclosing curly brackets may be omitted.
     * An alias for `parseSequence`
     * @param src A Micheline sequence `{parameter ...; storage int; code { DUP ; ...};}` or `parameter ...; storage int; code { DUP ; ...};`
     */ parseScript(src) {
        return this.parseSequence(src);
    }
    /**
     * Parse a Micheline sequence expression. Enclosing curly brackets may be omitted.
     * An alias for `parseList`
     * @param src A Michelson list expression such as `(Pair {Elt "0" 0} 0)` or `Pair {Elt "0" 0} 0`
     * @returns An AST node or null for empty document.
     */ parseData(src) {
        return this.parseList(src);
    }
    /**
     * Takes a JSON-encoded Michelson, validates it, strips away unneeded properties and optionally expands macros (See {@link ParserOptions}).
     * @param src An object containing JSON-encoded Michelson, usually returned by `JSON.parse()`
     */ parseJSON(src) {
        if (typeof src !== 'object') throw new TypeError(`object type was expected, got ${typeof src} instead`);
        if (Array.isArray(src)) {
            const ret = [];
            for (const n of src){
                if (n === null || typeof n !== 'object') throw new $a98ce94f10ce3b87$export$796bd0427cfd15b1(n, `unexpected sequence element: ${n}`);
                ret.push(this.parseJSON(n));
            }
            return ret;
        } else if ('prim' in src) {
            const p = src;
            if (typeof p.prim === 'string' && (p.annots === undefined || Array.isArray(p.annots)) && (p.args === undefined || Array.isArray(p.args))) {
                const ret = {
                    prim: p.prim
                };
                if (p.annots !== undefined) {
                    for (const a of p.annots){
                        if (typeof a !== 'string') throw new $a98ce94f10ce3b87$export$796bd0427cfd15b1(a, `string expected: ${a}`);
                    }
                    ret.annots = p.annots;
                }
                if (p.args !== undefined) {
                    ret.args = [];
                    for (const a of p.args){
                        if (a === null || typeof a !== 'object') throw new $a98ce94f10ce3b87$export$796bd0427cfd15b1(a, `unexpected argument: ${a}`);
                        ret.args.push(this.parseJSON(a));
                    }
                }
                return this.expand(ret);
            }
            throw new $a98ce94f10ce3b87$export$796bd0427cfd15b1(src, `malformed prim expression: ${src}`);
        } else if ('string' in src) {
            if (typeof src.string === 'string') return {
                string: src.string
            };
            throw new $a98ce94f10ce3b87$export$796bd0427cfd15b1(src, `malformed string literal: ${src}`);
        } else if ('int' in src) {
            if (typeof src.int === 'string' && $a98ce94f10ce3b87$var$intRe.test(src.int)) return {
                int: src.int
            };
            throw new $a98ce94f10ce3b87$export$796bd0427cfd15b1(src, `malformed int literal: ${src}`);
        } else if ('bytes' in src) {
            if (typeof src.bytes === 'string' && $a98ce94f10ce3b87$var$bytesRe.test(src.bytes)) return {
                bytes: src.bytes
            };
            throw new $a98ce94f10ce3b87$export$796bd0427cfd15b1(src, `malformed bytes literal: ${src}`);
        } else throw new $a98ce94f10ce3b87$export$796bd0427cfd15b1(src, `unexpected object: ${src}`);
    }
}
class $a98ce94f10ce3b87$var$Formatter {
    constructor(opt, lev = 0){
        this.opt = opt;
        this.lev = lev;
    }
    indent(n = 0) {
        var _a;
        let ret = '';
        if (((_a = this.opt) === null || _a === void 0 ? void 0 : _a.indent) !== undefined) for(let i = this.lev + n; i > 0; i--)ret += this.opt.indent;
        return ret;
    }
    get lf() {
        var _a;
        return ((_a = this.opt) === null || _a === void 0 ? void 0 : _a.newline) || '';
    }
    get lfsp() {
        var _a;
        return ((_a = this.opt) === null || _a === void 0 ? void 0 : _a.newline) || ' ';
    }
    down(n) {
        return new $a98ce94f10ce3b87$var$Formatter(this.opt, this.lev + n);
    }
}
function $a98ce94f10ce3b87$var$hasArgs(node) {
    return 'prim' in node && (node.annots !== undefined && node.annots.length !== 0 || node.args !== undefined && node.args.length !== 0);
}
function $a98ce94f10ce3b87$var$isMultiline(node) {
    if (node.args !== undefined) for (const a of node.args){
        if (Array.isArray(a) || $a98ce94f10ce3b87$var$hasArgs(a)) return true;
    }
    return false;
}
function $a98ce94f10ce3b87$var$emitExpr(node, f, foldMacros) {
    var _a;
    const macro = (_a = node[$a98ce94f10ce3b87$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.macro;
    if (foldMacros && macro) return $a98ce94f10ce3b87$var$emitExpr(macro, f, foldMacros);
    if (Array.isArray(node)) return $a98ce94f10ce3b87$var$emitSeq(node, f, foldMacros);
    else if ('string' in node) return JSON.stringify(node.string);
    else if ('int' in node) return node.int;
    else if ('bytes' in node) return '0x' + node.bytes;
    else {
        if ((node.annots === undefined || node.annots.length === 0) && (node.args === undefined || node.args.length === 0)) return node.prim;
        let ret = '(' + node.prim;
        if (node.annots !== undefined) for (const a of node.annots)ret += ' ' + a;
        if (node.args !== undefined) {
            const multiline = $a98ce94f10ce3b87$var$isMultiline(node);
            for (const a of node.args)if (multiline) ret += f.lfsp + f.indent(1) + $a98ce94f10ce3b87$var$emitExpr(a, f.down(1), foldMacros);
            else ret += ' ' + $a98ce94f10ce3b87$var$emitExpr(a, f, foldMacros);
        }
        return ret + ')';
    }
}
function $a98ce94f10ce3b87$var$emitSeq(node, f, foldMacros) {
    let ret = '{' + f.lf;
    let i = node.length;
    for (const el of node){
        ret += f.indent(1);
        if ('prim' in el) {
            ret += el.prim;
            if (el.annots !== undefined) for (const a of el.annots)ret += ' ' + a;
            if (el.args !== undefined) {
                const multiline = $a98ce94f10ce3b87$var$isMultiline(el);
                for (const a of el.args)if (multiline) ret += f.lfsp + f.indent(2) + $a98ce94f10ce3b87$var$emitExpr(a, f.down(2), foldMacros);
                else ret += ' ' + $a98ce94f10ce3b87$var$emitExpr(a, f, foldMacros);
            }
        } else ret += $a98ce94f10ce3b87$var$emitExpr(el, f.down(1), foldMacros);
        ret += i > 1 ? ';' + f.lfsp : f.lf;
        i--;
    }
    return ret + f.indent() + '}';
}
/**
 * Formats Micheline expression
 * @param expr An AST node
 * @param opt Options
 */ function $a98ce94f10ce3b87$export$613fc3a7f2c0f56c(expr, opt, foldMacros = false) {
    if (typeof expr !== 'object') throw new TypeError(`object type was expected, got ${typeof expr} instead`);
    return $a98ce94f10ce3b87$var$emitExpr(expr, new $a98ce94f10ce3b87$var$Formatter(opt), foldMacros);
}
const $a98ce94f10ce3b87$var$H = [
    1779033703,
    -1150833019,
    1013904242,
    -1521486534,
    1359893119,
    -1694144372,
    528734635,
    1541459225
];
const $a98ce94f10ce3b87$var$K = [
    1116352408,
    1899447441,
    -1245643825,
    -373957723,
    961987163,
    1508970993,
    -1841331548,
    -1424204075,
    -670586216,
    310598401,
    607225278,
    1426881987,
    1925078388,
    -2132889090,
    -1680079193,
    -1046744716,
    -459576895,
    -272742522,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    -1740746414,
    -1473132947,
    -1341970488,
    -1084653625,
    -958395405,
    -710438585,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    -2117940946,
    -1838011259,
    -1564481375,
    -1474664885,
    -1035236496,
    -949202525,
    -778901479,
    -694614492,
    -200395387,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    -2067236844,
    -1933114872,
    -1866530822,
    -1538233109,
    -1090935817,
    -965641998
];
/**
 *  @category Error
 *  @description Error that indicates a failure when decoding a base58 encoding
 */ class $a98ce94f10ce3b87$var$Base58DecodingError extends (0, $eb894799b0e29f04$export$e5619b407b1c8b0a) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'Base58DecodingError';
    }
}
// https://tools.ietf.org/html/rfc6234
function $a98ce94f10ce3b87$var$sha256(msg) {
    // pad the message
    const r = (msg.length + 9) % 64;
    const pad = r === 0 ? 0 : 64 - r;
    if (msg.length > 268435455) throw new (0, $eb894799b0e29f04$export$a5124d7665e9d8ad)('', `: Invalid length ${msg.length} is too big -- SHA-256.`);
    const l = msg.length << 3;
    const buffer = [
        ...msg,
        0x80,
        ...new Array(pad).fill(0),
        0,
        0,
        0,
        0,
        l >> 24 & 0xff,
        l >> 16 & 0xff,
        l >> 8 & 0xff,
        l & 0xff
    ];
    function ror(x, n) {
        return x >>> n | x << 32 - n;
    }
    const h = [
        ...$a98ce94f10ce3b87$var$H
    ];
    const w = new Array(64);
    const v = new Array(8);
    for(let offset = 0; offset < buffer.length; offset += 64){
        let q = offset;
        let i = 0;
        while(i < 16){
            w[i] = buffer[q] << 24 | buffer[q + 1] << 16 | buffer[q + 2] << 8 | buffer[q + 3];
            q += 4;
            i++;
        }
        while(i < 64){
            const s0 = ror(w[i - 15], 7) ^ ror(w[i - 15], 18) ^ w[i - 15] >>> 3;
            const s1 = ror(w[i - 2], 17) ^ ror(w[i - 2], 19) ^ w[i - 2] >>> 10;
            w[i] = (s1 | 0) + w[i - 7] + s0 + w[i - 16] | 0;
            i++;
        }
        for(let i = 0; i < 8; i++)v[i] = h[i];
        for(let i = 0; i < 64; i++){
            const b0 = ror(v[0], 2) ^ ror(v[0], 13) ^ ror(v[0], 22);
            const b1 = ror(v[4], 6) ^ ror(v[4], 11) ^ ror(v[4], 25);
            const t1 = v[7] + b1 + (v[4] & v[5] ^ ~v[4] & v[6]) + $a98ce94f10ce3b87$var$K[i] + w[i] | 0;
            const t2 = b0 + (v[0] & v[1] ^ v[0] & v[2] ^ v[1] & v[2]) | 0;
            v[7] = v[6];
            v[6] = v[5];
            v[5] = v[4];
            v[4] = v[3] + t1 | 0;
            v[3] = v[2];
            v[2] = v[1];
            v[1] = v[0];
            v[0] = t1 + t2 | 0;
        }
        for(let i = 0; i < 8; i++)h[i] = h[i] + v[i] | 0;
    }
    const digest = [];
    for (const v of h){
        digest.push(v >> 24 & 0xff);
        digest.push(v >> 16 & 0xff);
        digest.push(v >> 8 & 0xff);
        digest.push(v & 0xff);
    }
    return digest;
}
const $a98ce94f10ce3b87$var$base58alphabetFwd = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    -1,
    17,
    18,
    19,
    20,
    21,
    -1,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    -1,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57
];
const $a98ce94f10ce3b87$var$base58alphabetBwd = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    25,
    26,
    27,
    28,
    29,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    60,
    61,
    62,
    63,
    64,
    65,
    66,
    67,
    68,
    69,
    70,
    71,
    72,
    73
];
function $a98ce94f10ce3b87$var$byteAt(src, i) {
    const c = src.charCodeAt(i) - 49;
    if (c >= $a98ce94f10ce3b87$var$base58alphabetFwd.length || $a98ce94f10ce3b87$var$base58alphabetFwd[c] === -1) throw new $a98ce94f10ce3b87$var$Base58DecodingError(`Unexpected character at position ${i}: ${src[i]}`);
    return $a98ce94f10ce3b87$var$base58alphabetFwd[c];
}
function $a98ce94f10ce3b87$var$decodeBase58(src) {
    const acc = [];
    let i = 0;
    // count and skip leading zeros
    while(i < src.length && $a98ce94f10ce3b87$var$byteAt(src, i) === 0)i++;
    let zeros = i;
    while(i < src.length){
        let carry = $a98ce94f10ce3b87$var$byteAt(src, i++);
        /*
            for every symbol x
            acc = acc * 58 + x
            where acc is a little endian arbitrary length integer
            */ let ii = 0;
        while(carry !== 0 || ii < acc.length){
            const m = (acc[ii] || 0) * 58 + carry;
            acc[ii++] = m % 256;
            carry = Math.floor(m / 256);
        }
    }
    while(zeros-- > 0)acc.push(0);
    return acc.reverse();
}
function $a98ce94f10ce3b87$var$encodeBase58(src) {
    const acc = [];
    let i = 0;
    // count and skip leading zeros
    while(i < src.length && src[i] === 0)i++;
    let zeros = i;
    while(i < src.length){
        let carry = src[i++];
        let ii = 0;
        while(carry !== 0 || ii < acc.length){
            const m = (acc[ii] || 0) * 256 + carry;
            acc[ii++] = m % 58;
            carry = Math.floor(m / 58);
        }
    }
    while(zeros-- > 0)acc.push(0);
    acc.reverse();
    return String.fromCharCode(...acc.map((v)=>$a98ce94f10ce3b87$var$base58alphabetBwd[v] + 49));
}
function $a98ce94f10ce3b87$var$decodeBase58Check(src) {
    const buffer = $a98ce94f10ce3b87$var$decodeBase58(src);
    if (buffer.length < 4) throw new $a98ce94f10ce3b87$var$Base58DecodingError(`Data is too short ${buffer.length}`);
    const data = buffer.slice(0, buffer.length - 4);
    const sum = buffer.slice(buffer.length - 4);
    const computed = $a98ce94f10ce3b87$var$sha256($a98ce94f10ce3b87$var$sha256(data));
    if (sum[0] !== computed[0] || sum[1] !== computed[1] || sum[2] !== computed[2] || sum[3] !== computed[3]) throw new $a98ce94f10ce3b87$var$Base58DecodingError('Invalid checksum');
    return data;
}
function $a98ce94f10ce3b87$var$encodeBase58Check(src) {
    const sum = $a98ce94f10ce3b87$var$sha256($a98ce94f10ce3b87$var$sha256(src));
    return $a98ce94f10ce3b87$var$encodeBase58([
        ...src,
        ...sum.slice(0, 4)
    ]);
}
/**
 *  @category Error
 *  @description Error that indicates an invalid Michelson being passed or used
 */ class $a98ce94f10ce3b87$var$InvalidMichelsonError extends (0, $eb894799b0e29f04$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'InvalidMichelsonError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid type expression being passed or used
 */ class $a98ce94f10ce3b87$var$InvalidTypeExpressionError extends (0, $eb894799b0e29f04$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'InvalidTypeExpressionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid data expression being passed or used
 */ class $a98ce94f10ce3b87$var$InvalidDataExpressionError extends (0, $eb894799b0e29f04$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'InvalidDataExpressionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid contract entrypoint being referenced or passed
 */ class $a98ce94f10ce3b87$var$InvalidEntrypointError extends (0, $eb894799b0e29f04$export$9d3f3bc8b6d48950) {
    constructor(entrypoint){
        super();
        this.entrypoint = entrypoint;
        this.name = 'InvalidEntrypointError';
        this.message = `Contract has no entrypoint named: "${entrypoint}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure happening when trying to encode Tezos ID
 */ class $a98ce94f10ce3b87$var$TezosIdEncodeError extends (0, $eb894799b0e29f04$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'TezosIdEncodeError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a general error happening when trying to create a LongInteger
 */ class $a98ce94f10ce3b87$var$LongIntegerError extends (0, $eb894799b0e29f04$export$e5619b407b1c8b0a) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'LongIntegerError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure occurring when trying to parse a hex byte
 */ class $a98ce94f10ce3b87$var$HexParseError extends (0, $eb894799b0e29f04$export$e5619b407b1c8b0a) {
    constructor(hexByte){
        super();
        this.hexByte = hexByte;
        this.name = 'HexParseError';
        this.message = `Unable to parse hex byte "${hexByte}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a Michelson failure occurring
 */ class $a98ce94f10ce3b87$export$61ae7f08643aa181 extends (0, $eb894799b0e29f04$export$e5619b407b1c8b0a) {
    /**
     * @param val Value of a AST node caused the error
     * @param path Path to a node caused the error
     * @param message An error message
     */ constructor(val, message){
        super();
        this.val = val;
        this.message = message;
        this.name = 'MichelsonError';
    }
}
function $a98ce94f10ce3b87$export$d0f88f1112d519ce(err) {
    return err instanceof $a98ce94f10ce3b87$export$61ae7f08643aa181;
}
class $a98ce94f10ce3b87$export$c9afdd965e51c08a extends $a98ce94f10ce3b87$export$61ae7f08643aa181 {
    /**
     * @param val Value of a type node caused the error
     * @param data Value of a data node caused the error
     * @param message An error message
     */ constructor(val, message, data){
        super(val, message);
        this.val = val;
        this.message = message;
        this.name = 'MichelsonTypeError';
        if (data !== undefined) this.data = data;
    }
}
// Ad hoc big integer parser
class $a98ce94f10ce3b87$var$LongInteger {
    append(c) {
        let i = 0;
        while(c !== 0 || i < this.buf.length){
            const m = (this.buf[i] || 0) * 10 + c;
            this.buf[i++] = m % 256;
            c = Math.floor(m / 256);
        }
    }
    constructor(arg){
        this.neg = false;
        this.buf = [];
        if (arg === undefined) return;
        if (typeof arg === 'string') for(let i = 0; i < arg.length; i++){
            const c = arg.charCodeAt(i);
            if (i === 0 && c === 0x2d) this.neg = true;
            else {
                if (c < 0x30 || c > 0x39) throw new $a98ce94f10ce3b87$var$LongIntegerError(`unexpected character in integer constant "${arg[i]}"`);
                this.append(c - 0x30);
            }
        }
        else if (arg < 0) {
            this.neg = true;
            this.append(-arg);
        } else this.append(arg);
    }
    cmp(arg) {
        if (this.neg !== arg.neg) return (arg.neg ? 1 : 0) - (this.neg ? 1 : 0);
        else {
            let ret = 0;
            if (this.buf.length !== arg.buf.length) ret = this.buf.length < arg.buf.length ? -1 : 1;
            else if (this.buf.length !== 0) {
                let i = arg.buf.length - 1;
                while(i >= 0 && this.buf[i] === arg.buf[i])i--;
                ret = i < 0 ? 0 : this.buf[i] < arg.buf[i] ? -1 : 1;
            }
            return !this.neg ? ret : ret === 0 ? 0 : -ret;
        }
    }
    get sign() {
        return this.buf.length === 0 ? 0 : this.neg ? -1 : 1;
    }
}
function $a98ce94f10ce3b87$var$parseBytes(s) {
    const ret = [];
    for(let i = 0; i < s.length; i += 2){
        const x = parseInt(s.slice(i, i + 2), 16);
        if (Number.isNaN(x)) return null;
        ret.push(x);
    }
    return ret;
}
function $a98ce94f10ce3b87$var$isDecimal(x) {
    try {
        new $a98ce94f10ce3b87$var$LongInteger(x);
        return true;
    } catch (_a) {
        return false;
    }
}
function $a98ce94f10ce3b87$var$isNatural(x) {
    try {
        return new $a98ce94f10ce3b87$var$LongInteger(x).sign >= 0;
    } catch (_a) {
        return false;
    }
}
const $a98ce94f10ce3b87$var$annRe = /^(@%|@%%|%@|[@:%]([_0-9a-zA-Z][_0-9a-zA-Z.%@]*)?)$/;
function $a98ce94f10ce3b87$var$unpackAnnotations(p, opt) {
    if (Array.isArray(p)) return {};
    let field;
    let type;
    let vars;
    if (p.annots !== undefined) {
        for (const v of p.annots)if (v.length !== 0) {
            if (!$a98ce94f10ce3b87$var$annRe.test(v) || !(opt === null || opt === void 0 ? void 0 : opt.specialVar) && (v === '@%' || v === '@%%') || !(opt === null || opt === void 0 ? void 0 : opt.specialFields) && v === '%@') throw new $a98ce94f10ce3b87$export$61ae7f08643aa181(p, `${p.prim}: unexpected annotation: ${v}`);
            switch(v[0]){
                case '%':
                    if ((opt === null || opt === void 0 ? void 0 : opt.emptyFields) || v.length > 1) {
                        field = field || [];
                        field.push(v);
                    }
                    break;
                case ':':
                    if (v.length > 1) {
                        type = type || [];
                        type.push(v);
                    }
                    break;
                case '@':
                    if ((opt === null || opt === void 0 ? void 0 : opt.emptyVar) || v.length > 1) {
                        vars = vars || [];
                        vars.push(v);
                    }
                    break;
            }
        }
    }
    return {
        f: field,
        t: type,
        v: vars
    };
}
const $a98ce94f10ce3b87$var$tezosPrefix = {
    BlockHash: [
        32,
        [
            1,
            52
        ]
    ],
    OperationHash: [
        32,
        [
            5,
            116
        ]
    ],
    OperationListHash: [
        32,
        [
            133,
            233
        ]
    ],
    OperationListListHash: [
        32,
        [
            29,
            159,
            109
        ]
    ],
    ProtocolHash: [
        32,
        [
            2,
            170
        ]
    ],
    ContextHash: [
        32,
        [
            79,
            199
        ]
    ],
    ED25519PublicKeyHash: [
        20,
        [
            6,
            161,
            159
        ]
    ],
    SECP256K1PublicKeyHash: [
        20,
        [
            6,
            161,
            161
        ]
    ],
    P256PublicKeyHash: [
        20,
        [
            6,
            161,
            164
        ]
    ],
    ContractHash: [
        20,
        [
            2,
            90,
            121
        ]
    ],
    CryptoboxPublicKeyHash: [
        16,
        [
            153,
            103
        ]
    ],
    ED25519Seed: [
        32,
        [
            13,
            15,
            58,
            7
        ]
    ],
    ED25519PublicKey: [
        32,
        [
            13,
            15,
            37,
            217
        ]
    ],
    SECP256K1SecretKey: [
        32,
        [
            17,
            162,
            224,
            201
        ]
    ],
    P256SecretKey: [
        32,
        [
            16,
            81,
            238,
            189
        ]
    ],
    ED25519EncryptedSeed: [
        56,
        [
            7,
            90,
            60,
            179,
            41
        ]
    ],
    SECP256K1EncryptedSecretKey: [
        56,
        [
            9,
            237,
            241,
            174,
            150
        ]
    ],
    P256EncryptedSecretKey: [
        56,
        [
            9,
            48,
            57,
            115,
            171
        ]
    ],
    SECP256K1PublicKey: [
        33,
        [
            3,
            254,
            226,
            86
        ]
    ],
    P256PublicKey: [
        33,
        [
            3,
            178,
            139,
            127
        ]
    ],
    SECP256K1Scalar: [
        33,
        [
            38,
            248,
            136
        ]
    ],
    SECP256K1Element: [
        33,
        [
            5,
            92,
            0
        ]
    ],
    ED25519SecretKey: [
        64,
        [
            43,
            246,
            78,
            7
        ]
    ],
    ED25519Signature: [
        64,
        [
            9,
            245,
            205,
            134,
            18
        ]
    ],
    SECP256K1Signature: [
        64,
        [
            13,
            115,
            101,
            19,
            63
        ]
    ],
    P256Signature: [
        64,
        [
            54,
            240,
            44,
            52
        ]
    ],
    GenericSignature: [
        64,
        [
            4,
            130,
            43
        ]
    ],
    ChainID: [
        4,
        [
            87,
            82,
            0
        ]
    ],
    RollupAddress: [
        20,
        [
            1,
            128,
            120,
            31
        ]
    ]
};
function $a98ce94f10ce3b87$var$checkDecodeTezosID(id, ...types) {
    const buf = $a98ce94f10ce3b87$var$decodeBase58Check(id);
    for (const t of types){
        const [plen, p] = $a98ce94f10ce3b87$var$tezosPrefix[t];
        if (buf.length === plen + p.length) {
            let i = 0;
            while(i < p.length && buf[i] === p[i])i++;
            if (i === p.length) return [
                t,
                buf.slice(p.length)
            ];
        }
    }
    return null;
}
function $a98ce94f10ce3b87$var$encodeTezosID(id, data) {
    const [plen, p] = $a98ce94f10ce3b87$var$tezosPrefix[id];
    if (data.length !== plen) throw new $a98ce94f10ce3b87$var$TezosIdEncodeError(`Incorrect data length for ${id}: ${data.length}`);
    return $a98ce94f10ce3b87$var$encodeBase58Check([
        ...p,
        ...data
    ]);
}
function $a98ce94f10ce3b87$var$unpackComb(id, v) {
    const vv = v;
    const args = Array.isArray(vv) ? vv : vv.args;
    if (args.length === 2) {
        // it's a way to make a union of two interfaces not an interface with two independent properties of union types
        const ret = id === 'pair' ? {
            prim: 'pair',
            args: args
        } : {
            prim: 'Pair',
            args: args
        };
        return ret;
    }
    return Object.assign(Object.assign({}, Array.isArray(vv) ? {
        prim: id
    } : vv), {
        args: [
            args[0],
            {
                prim: id,
                args: args.slice(1)
            }
        ]
    });
}
function $a98ce94f10ce3b87$var$isPairType(t) {
    return Array.isArray(t) || t.prim === 'pair';
}
function $a98ce94f10ce3b87$var$isPairData(d) {
    return Array.isArray(d) || 'prim' in d && d.prim === 'Pair';
}
const $a98ce94f10ce3b87$var$rfc3339Re = /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])[T ]([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]|60)(\.[0-9]+)?(Z|[+-]([01][0-9]|2[0-3]):([0-5][0-9]))$/;
function $a98ce94f10ce3b87$var$parseDate(a) {
    if ('string' in a) {
        if ($a98ce94f10ce3b87$var$isNatural(a.string)) return new Date(parseInt(a.string, 10));
        else if ($a98ce94f10ce3b87$var$rfc3339Re.test(a.string)) {
            const x = new Date(a.string);
            if (!Number.isNaN(x.valueOf)) return x;
        }
    } else if ($a98ce94f10ce3b87$var$isDecimal(a.int)) return new Date(parseInt(a.int, 10));
    return null;
}
function $a98ce94f10ce3b87$var$parseHex(s) {
    const res = [];
    for(let i = 0; i < s.length; i += 2){
        const ss = s.slice(i, i + 2);
        const x = parseInt(ss, 16);
        if (Number.isNaN(x)) throw new $a98ce94f10ce3b87$var$HexParseError(ss);
        res.push(x);
    }
    return res;
}
function $a98ce94f10ce3b87$var$hexBytes(bytes) {
    return bytes.map((x)=>(x >> 4 & 0xf).toString(16) + (x & 0xf).toString(16)).join('');
}
// Michelson validator
const $a98ce94f10ce3b87$var$maxViewNameLength = 31;
const $a98ce94f10ce3b87$var$noArgInstructionIDs = {
    ABS: true,
    ADD: true,
    ADDRESS: true,
    AMOUNT: true,
    AND: true,
    APPLY: true,
    BALANCE: true,
    BLAKE2B: true,
    CAR: true,
    CDR: true,
    CHAIN_ID: true,
    CHECK_SIGNATURE: true,
    COMPARE: true,
    CONCAT: true,
    CONS: true,
    EDIV: true,
    EQ: true,
    EXEC: true,
    FAILWITH: true,
    GE: true,
    GET_AND_UPDATE: true,
    GT: true,
    HASH_KEY: true,
    IMPLICIT_ACCOUNT: true,
    INT: true,
    ISNAT: true,
    JOIN_TICKETS: true,
    KECCAK: true,
    LE: true,
    LEVEL: true,
    LSL: true,
    LSR: true,
    LT: true,
    MEM: true,
    MUL: true,
    NEG: true,
    NEQ: true,
    NEVER: true,
    NOT: true,
    NOW: true,
    OR: true,
    PACK: true,
    PAIRING_CHECK: true,
    READ_TICKET: true,
    SAPLING_VERIFY_UPDATE: true,
    SELF: true,
    SELF_ADDRESS: true,
    SENDER: true,
    SET_DELEGATE: true,
    SHA256: true,
    SHA3: true,
    SHA512: true,
    SIZE: true,
    SLICE: true,
    SOME: true,
    SOURCE: true,
    SPLIT_TICKET: true,
    SUB: true,
    SWAP: true,
    TICKET: true,
    TICKET_DEPRECATED: true,
    TOTAL_VOTING_POWER: true,
    TRANSFER_TOKENS: true,
    UNIT: true,
    VOTING_POWER: true,
    XOR: true,
    RENAME: true,
    OPEN_CHEST: true,
    SUB_MUTEZ: true,
    MIN_BLOCK_TIME: true,
    BYTES: true,
    NAT: true
};
const $a98ce94f10ce3b87$export$f3fe68d730702c17 = Object.assign({}, $a98ce94f10ce3b87$var$noArgInstructionIDs, {
    CONTRACT: true,
    CREATE_CONTRACT: true,
    DIG: true,
    DIP: true,
    DROP: true,
    DUG: true,
    DUP: true,
    EMIT: true,
    EMPTY_BIG_MAP: true,
    EMPTY_MAP: true,
    EMPTY_SET: true,
    GET: true,
    IF: true,
    IF_CONS: true,
    IF_LEFT: true,
    IF_NONE: true,
    ITER: true,
    LAMBDA: true,
    LAMBDA_REC: true,
    LEFT: true,
    LOOP: true,
    LOOP_LEFT: true,
    MAP: true,
    NIL: true,
    NONE: true,
    PAIR: true,
    PUSH: true,
    RIGHT: true,
    SAPLING_EMPTY_STATE: true,
    UNPACK: true,
    UNPAIR: true,
    UPDATE: true,
    CAST: true,
    VIEW: true
});
const $a98ce94f10ce3b87$var$simpleComparableTypeIDs = {
    unit: true,
    never: true,
    bool: true,
    int: true,
    nat: true,
    string: true,
    chain_id: true,
    bytes: true,
    mutez: true,
    key_hash: true,
    key: true,
    signature: true,
    timestamp: true,
    address: true,
    tx_rollup_l2_address: true
};
const $a98ce94f10ce3b87$var$typeIDs = Object.assign({}, $a98ce94f10ce3b87$var$simpleComparableTypeIDs, {
    or: true,
    pair: true,
    set: true,
    big_map: true,
    contract: true,
    lambda: true,
    list: true,
    map: true,
    operation: true,
    option: true,
    bls12_381_g1: true,
    bls12_381_g2: true,
    bls12_381_fr: true,
    sapling_transaction: true,
    sapling_transaction_deprecated: true,
    sapling_state: true,
    ticket: true,
    chest_key: true,
    chest: true
});
class $a98ce94f10ce3b87$export$6565c3cd336fa0c4 extends $a98ce94f10ce3b87$export$61ae7f08643aa181 {
    /**
     * @param val Value of a node caused the error
     * @param message An error message
     */ constructor(val, message){
        super(val, message);
        this.val = val;
        this.message = message;
        this.name = 'MichelsonValidationError';
    }
}
function $a98ce94f10ce3b87$var$isPrim(ex) {
    return 'prim' in ex;
}
function $a98ce94f10ce3b87$var$isPrimOrSeq(ex) {
    return Array.isArray(ex) || 'prim' in ex;
}
function $a98ce94f10ce3b87$var$assertPrim(ex) {
    if ($a98ce94f10ce3b87$var$isPrim(ex)) return true;
    throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'prim expression expected');
}
function $a98ce94f10ce3b87$var$assertSeq(ex) {
    if (Array.isArray(ex)) return true;
    throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'sequence expression expected');
}
function $a98ce94f10ce3b87$var$assertPrimOrSeq(ex) {
    if ($a98ce94f10ce3b87$var$isPrimOrSeq(ex)) return true;
    throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'prim or sequence expression expected');
}
function $a98ce94f10ce3b87$var$assertNatural(i) {
    if (i.int[0] === '-') throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(i, 'natural number expected');
}
function $a98ce94f10ce3b87$var$assertIntLiteral(ex) {
    if ('int' in ex) return true;
    throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'int literal expected');
}
function $a98ce94f10ce3b87$var$assertStringLiteral(ex) {
    if ('string' in ex) return true;
    throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'string literal expected');
}
// usually an address
function $a98ce94f10ce3b87$var$assertStringOrBytes(ex) {
    if ('string' in ex || 'bytes' in ex) return true;
    throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'string or bytes literal expected');
}
function $a98ce94f10ce3b87$var$assertArgs(ex, n) {
    var _a;
    if (n === 0 && ex.args === undefined || ((_a = ex.args) === null || _a === void 0 ? void 0 : _a.length) === n) return true;
    throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, `${n} arguments expected`);
}
/**
 * Checks if the node is a valid Michelson code (sequence of instructions).
 * This is a type guard function which either returns true of throws an exception.
 * @param ex An AST node
 */ function $a98ce94f10ce3b87$export$57f49bebc69f7bbc(ex) {
    var _a, _b;
    if (Array.isArray(ex)) {
        for (const n of ex){
            if (!Array.isArray(n) && !$a98ce94f10ce3b87$var$isPrim(n)) throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'sequence or prim expected');
            $a98ce94f10ce3b87$export$57f49bebc69f7bbc(n);
        }
        return true;
    }
    if ($a98ce94f10ce3b87$var$assertPrim(ex)) {
        if (Object.prototype.hasOwnProperty.call($a98ce94f10ce3b87$var$noArgInstructionIDs, ex.prim)) {
            $a98ce94f10ce3b87$var$assertArgs(ex, 0);
            return true;
        }
        switch(ex.prim){
            case 'DROP':
            case 'PAIR':
            case 'UNPAIR':
            case 'DUP':
            case 'UPDATE':
            case 'GET':
                if (ex.args !== undefined && $a98ce94f10ce3b87$var$assertArgs(ex, 1)) /* istanbul ignore else */ {
                    if ($a98ce94f10ce3b87$var$assertIntLiteral(ex.args[0])) $a98ce94f10ce3b87$var$assertNatural(ex.args[0]);
                }
                break;
            case 'DIG':
            case 'DUG':
            case 'SAPLING_EMPTY_STATE':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1)) /* istanbul ignore else */ {
                    if ($a98ce94f10ce3b87$var$assertIntLiteral(ex.args[0])) $a98ce94f10ce3b87$var$assertNatural(ex.args[0]);
                }
                break;
            case 'NONE':
            case 'LEFT':
            case 'RIGHT':
            case 'NIL':
            case 'CAST':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1)) $a98ce94f10ce3b87$export$176936cdb34aed2f(ex.args[0]);
                break;
            case 'UNPACK':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1)) $a98ce94f10ce3b87$export$a32a137820025fa5(ex.args[0]);
                break;
            case 'CONTRACT':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1)) $a98ce94f10ce3b87$export$167bd1e3110eb198(ex.args[0]);
                break;
            case 'IF_NONE':
            case 'IF_LEFT':
            case 'IF_CONS':
            case 'IF':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 2)) {
                    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertSeq(ex.args[0])) $a98ce94f10ce3b87$export$57f49bebc69f7bbc(ex.args[0]);
                    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertSeq(ex.args[1])) $a98ce94f10ce3b87$export$57f49bebc69f7bbc(ex.args[1]);
                }
                break;
            case 'MAP':
            case 'ITER':
            case 'LOOP':
            case 'LOOP_LEFT':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1)) $a98ce94f10ce3b87$export$57f49bebc69f7bbc(ex.args[0]);
                break;
            case 'CREATE_CONTRACT':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1)) $a98ce94f10ce3b87$export$ac03cc731bd7a006(ex.args[0]);
                break;
            case 'DIP':
                if (((_a = ex.args) === null || _a === void 0 ? void 0 : _a.length) === 2) {
                    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertIntLiteral(ex.args[0])) $a98ce94f10ce3b87$var$assertNatural(ex.args[0]);
                    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertSeq(ex.args[1])) $a98ce94f10ce3b87$export$57f49bebc69f7bbc(ex.args[1]);
                } else if (((_b = ex.args) === null || _b === void 0 ? void 0 : _b.length) === 1) /* istanbul ignore else */ {
                    if ($a98ce94f10ce3b87$var$assertSeq(ex.args[0])) $a98ce94f10ce3b87$export$57f49bebc69f7bbc(ex.args[0]);
                } else throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, '1 or 2 arguments expected');
                break;
            case 'PUSH':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 2)) {
                    $a98ce94f10ce3b87$export$61842f5d814f90cb(ex.args[0]);
                    $a98ce94f10ce3b87$export$3cc4ed4ae67ac731(ex.args[1]);
                }
                break;
            case 'EMPTY_SET':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1)) $a98ce94f10ce3b87$export$d5e5c91702354d8f(ex.args[0]);
                break;
            case 'EMPTY_MAP':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 2)) {
                    $a98ce94f10ce3b87$export$d5e5c91702354d8f(ex.args[0]);
                    $a98ce94f10ce3b87$export$176936cdb34aed2f(ex.args[1]);
                }
                break;
            case 'EMPTY_BIG_MAP':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 2)) {
                    $a98ce94f10ce3b87$export$d5e5c91702354d8f(ex.args[0]);
                    $a98ce94f10ce3b87$export$5a64892aaade38d6(ex.args[1]);
                }
                break;
            case 'LAMBDA_REC':
            case 'LAMBDA':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 3)) {
                    $a98ce94f10ce3b87$export$176936cdb34aed2f(ex.args[0]);
                    $a98ce94f10ce3b87$export$176936cdb34aed2f(ex.args[1]);
                    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertSeq(ex.args[2])) $a98ce94f10ce3b87$export$57f49bebc69f7bbc(ex.args[2]);
                }
                break;
            case 'VIEW':
                /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 2)) {
                    if ($a98ce94f10ce3b87$var$assertStringLiteral(ex.args[0])) $a98ce94f10ce3b87$export$bfa50b833f100a15(ex.args[0]);
                    if ($a98ce94f10ce3b87$export$176936cdb34aed2f(ex.args[1])) $a98ce94f10ce3b87$export$61842f5d814f90cb(ex.args[1]);
                }
                break;
            case 'EMIT':
                if (ex.args && ex.args.length > 0) $a98ce94f10ce3b87$var$assertArgs(ex, 1);
                else $a98ce94f10ce3b87$var$assertArgs(ex, 0);
                break;
            default:
                throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'instruction expected');
        }
    }
    return true;
}
function $a98ce94f10ce3b87$export$d5e5c91702354d8f(ex) {
    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertPrimOrSeq(ex)) {
        if (Array.isArray(ex) || ex.prim === 'pair' || ex.prim === 'or' || ex.prim === 'option') $a98ce94f10ce3b87$var$traverseType(ex, (ex)=>$a98ce94f10ce3b87$export$d5e5c91702354d8f(ex));
        else if (!Object.prototype.hasOwnProperty.call($a98ce94f10ce3b87$var$simpleComparableTypeIDs, ex.prim)) throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, `${ex.prim}: type is not comparable`);
    }
    return true;
}
function $a98ce94f10ce3b87$export$a32a137820025fa5(ex) {
    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertPrimOrSeq(ex)) {
        if ($a98ce94f10ce3b87$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($a98ce94f10ce3b87$var$typeIDs, ex.prim) || ex.prim === 'big_map' || ex.prim === 'operation' || ex.prim === 'sapling_state' || ex.prim === 'ticket') throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, `${ex.prim}: type can't be used inside PACK/UNPACK instructions`);
            $a98ce94f10ce3b87$var$traverseType(ex, (ex)=>$a98ce94f10ce3b87$export$a32a137820025fa5(ex));
        }
    }
    return true;
}
function $a98ce94f10ce3b87$export$61842f5d814f90cb(ex) {
    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertPrimOrSeq(ex)) {
        if ($a98ce94f10ce3b87$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($a98ce94f10ce3b87$var$typeIDs, ex.prim) || ex.prim === 'big_map' || ex.prim === 'operation' || ex.prim === 'sapling_state' || ex.prim === 'ticket' || ex.prim === 'contract') throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, `${ex.prim}: type can't be pushed`);
            $a98ce94f10ce3b87$var$traverseType(ex, (ex)=>$a98ce94f10ce3b87$export$61842f5d814f90cb(ex));
        }
    }
    return true;
}
function $a98ce94f10ce3b87$export$f3036b1da0a36541(ex) {
    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertPrimOrSeq(ex)) {
        if ($a98ce94f10ce3b87$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($a98ce94f10ce3b87$var$typeIDs, ex.prim) || ex.prim === 'operation' || ex.prim === 'contract') throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, `${ex.prim}: type can't be used as part of a storage`);
            $a98ce94f10ce3b87$var$traverseType(ex, (ex)=>$a98ce94f10ce3b87$export$f3036b1da0a36541(ex));
        }
    }
    return true;
}
function $a98ce94f10ce3b87$export$167bd1e3110eb198(ex) {
    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertPrimOrSeq(ex)) {
        if ($a98ce94f10ce3b87$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($a98ce94f10ce3b87$var$typeIDs, ex.prim) || ex.prim === 'operation') throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, `${ex.prim}: type can't be used as part of a parameter`);
            $a98ce94f10ce3b87$var$traverseType(ex, (ex)=>$a98ce94f10ce3b87$export$167bd1e3110eb198(ex));
        }
    }
    return true;
}
function $a98ce94f10ce3b87$export$5a64892aaade38d6(ex) {
    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertPrimOrSeq(ex)) {
        if ($a98ce94f10ce3b87$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($a98ce94f10ce3b87$var$typeIDs, ex.prim) || ex.prim === 'big_map' || ex.prim === 'operation' || ex.prim === 'sapling_state') throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, `${ex.prim}: type can't be used inside a big_map`);
            $a98ce94f10ce3b87$var$traverseType(ex, (ex)=>$a98ce94f10ce3b87$export$5a64892aaade38d6(ex));
        }
    }
    return true;
}
const $a98ce94f10ce3b87$var$viewRe = new RegExp('^[a-zA-Z0-9_.%@]*$');
function $a98ce94f10ce3b87$export$bfa50b833f100a15(name) {
    if (name.string.length > $a98ce94f10ce3b87$var$maxViewNameLength) throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(name, `view name too long: ${name.string}`);
    if (!$a98ce94f10ce3b87$var$viewRe.test(name.string)) throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(name, `invalid character(s) in view name: ${name.string}`);
}
/**
 * Checks if the node is a valid Michelson type expression.
 * This is a type guard function which either returns true of throws an exception.
 * @param ex An AST node
 */ function $a98ce94f10ce3b87$export$176936cdb34aed2f(ex) {
    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertPrimOrSeq(ex)) {
        if ($a98ce94f10ce3b87$var$isPrim(ex)) {
            if (!Object.prototype.hasOwnProperty.call($a98ce94f10ce3b87$var$typeIDs, ex.prim)) throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'type expected');
            $a98ce94f10ce3b87$var$traverseType(ex, (ex)=>$a98ce94f10ce3b87$export$176936cdb34aed2f(ex));
        }
    }
    return true;
}
function $a98ce94f10ce3b87$var$traverseType(ex, cb) {
    if (Array.isArray(ex) || ex.prim === 'pair') {
        const args = Array.isArray(ex) ? ex : ex.args;
        if (args === undefined || args.length < 2) throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'at least 2 arguments expected');
        args.forEach((a)=>{
            if ($a98ce94f10ce3b87$var$assertPrimOrSeq(a)) cb(a);
        });
        return true;
    }
    switch(ex.prim){
        case 'option':
        case 'list':
            /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1) && $a98ce94f10ce3b87$var$assertPrimOrSeq(ex.args[0])) cb(ex.args[0]);
            break;
        case 'contract':
            /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1)) $a98ce94f10ce3b87$export$167bd1e3110eb198(ex.args[0]);
            break;
        case 'or':
            /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 2) && $a98ce94f10ce3b87$var$assertPrimOrSeq(ex.args[0]) && $a98ce94f10ce3b87$var$assertPrimOrSeq(ex.args[1])) {
                cb(ex.args[0]);
                cb(ex.args[1]);
            }
            break;
        case 'lambda':
            /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 2)) {
                $a98ce94f10ce3b87$export$176936cdb34aed2f(ex.args[0]);
                $a98ce94f10ce3b87$export$176936cdb34aed2f(ex.args[1]);
            }
            break;
        case 'set':
            /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1)) $a98ce94f10ce3b87$export$d5e5c91702354d8f(ex.args[0]);
            break;
        case 'map':
            /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 2) && $a98ce94f10ce3b87$var$assertPrimOrSeq(ex.args[0]) && $a98ce94f10ce3b87$var$assertPrimOrSeq(ex.args[1])) {
                $a98ce94f10ce3b87$export$d5e5c91702354d8f(ex.args[0]);
                cb(ex.args[1]);
            }
            break;
        case 'big_map':
            /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 2) && $a98ce94f10ce3b87$var$assertPrimOrSeq(ex.args[0]) && $a98ce94f10ce3b87$var$assertPrimOrSeq(ex.args[1])) {
                $a98ce94f10ce3b87$export$d5e5c91702354d8f(ex.args[0]);
                $a98ce94f10ce3b87$export$5a64892aaade38d6(ex.args[1]);
                cb(ex.args[1]);
            }
            break;
        case 'ticket':
            /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1) && $a98ce94f10ce3b87$var$assertPrimOrSeq(ex.args[0])) $a98ce94f10ce3b87$export$d5e5c91702354d8f(ex.args[0]);
            break;
        case 'sapling_state':
        case 'sapling_transaction':
            if ($a98ce94f10ce3b87$var$assertArgs(ex, 1)) $a98ce94f10ce3b87$var$assertIntLiteral(ex.args[0]);
            break;
        default:
            $a98ce94f10ce3b87$var$assertArgs(ex, 0);
    }
    return true;
}
/**
 * Checks if the node is a valid Michelson data literal such as `(Pair {Elt "0" 0} 0)`.
 * This is a type guard function which either returns true of throws an exception.
 * @param ex An AST node
 */ function $a98ce94f10ce3b87$export$3cc4ed4ae67ac731(ex) {
    if ('int' in ex || 'string' in ex || 'bytes' in ex) return true;
    if (Array.isArray(ex)) {
        let mapElts = 0;
        for (const n of ex)if ($a98ce94f10ce3b87$var$isPrim(n) && n.prim === 'Elt') {
            /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(n, 2)) {
                $a98ce94f10ce3b87$export$3cc4ed4ae67ac731(n.args[0]);
                $a98ce94f10ce3b87$export$3cc4ed4ae67ac731(n.args[1]);
            }
            mapElts++;
        } else $a98ce94f10ce3b87$export$3cc4ed4ae67ac731(n);
        if (mapElts !== 0 && mapElts !== ex.length) throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, "data entries and map elements can't be intermixed");
        return true;
    }
    if ($a98ce94f10ce3b87$var$isPrim(ex)) switch(ex.prim){
        case 'Unit':
        case 'True':
        case 'False':
        case 'None':
            $a98ce94f10ce3b87$var$assertArgs(ex, 0);
            break;
        case 'Pair':
            /* istanbul ignore else */ if (ex.args === undefined || ex.args.length < 2) throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'at least 2 arguments expected');
            for (const a of ex.args)$a98ce94f10ce3b87$export$3cc4ed4ae67ac731(a);
            break;
        case 'Left':
        case 'Right':
        case 'Some':
            /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertArgs(ex, 1)) $a98ce94f10ce3b87$export$3cc4ed4ae67ac731(ex.args[0]);
            break;
        case 'Lambda_rec':
            if (ex.args) $a98ce94f10ce3b87$export$57f49bebc69f7bbc(ex.args);
            break;
        case 'Ticket':
            if ($a98ce94f10ce3b87$var$assertArgs(ex, 4)) {
                $a98ce94f10ce3b87$var$assertStringOrBytes(ex.args[0]);
                $a98ce94f10ce3b87$export$176936cdb34aed2f(ex.args[1]);
                $a98ce94f10ce3b87$export$3cc4ed4ae67ac731(ex.args[2]);
                $a98ce94f10ce3b87$var$assertIntLiteral(ex.args[3]);
            }
            break;
        default:
            if (Object.prototype.hasOwnProperty.call($a98ce94f10ce3b87$export$f3fe68d730702c17, ex.prim)) $a98ce94f10ce3b87$export$57f49bebc69f7bbc(ex);
            else throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'data entry or instruction expected');
    }
    else throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, 'data entry expected');
    return true;
}
/**
 * Checks if the node is a valid Michelson smart contract source containing all required and valid properties such as `parameter`, `storage` and `code`.
 * This is a type guard function which either returns true of throws an exception.
 * @param ex An AST node
 */ function $a98ce94f10ce3b87$export$ac03cc731bd7a006(ex) {
    /* istanbul ignore else */ if ($a98ce94f10ce3b87$var$assertSeq(ex)) {
        const toplevelSec = {};
        const views = {};
        for (const sec of ex)if ($a98ce94f10ce3b87$var$assertPrim(sec)) {
            if (sec.prim !== 'view') {
                if (sec.prim in toplevelSec) throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, `duplicate contract section: ${sec.prim}`);
                toplevelSec[sec.prim] = true;
            }
            /* istanbul ignore else */ switch(sec.prim){
                case 'code':
                    if ($a98ce94f10ce3b87$var$assertArgs(sec, 1)) /* istanbul ignore else */ {
                        if ($a98ce94f10ce3b87$var$assertSeq(sec.args[0])) $a98ce94f10ce3b87$export$57f49bebc69f7bbc(sec.args[0]);
                    }
                    break;
                case 'parameter':
                    if ($a98ce94f10ce3b87$var$assertArgs(sec, 1)) $a98ce94f10ce3b87$export$167bd1e3110eb198(sec.args[0]);
                    if (sec.annots) throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(sec, 'Annotation must be part of the parameter type');
                    break;
                case 'storage':
                    if ($a98ce94f10ce3b87$var$assertArgs(sec, 1)) $a98ce94f10ce3b87$export$f3036b1da0a36541(sec.args[0]);
                    break;
                case 'view':
                    if ($a98ce94f10ce3b87$var$assertArgs(sec, 4)) {
                        if ($a98ce94f10ce3b87$var$assertStringLiteral(sec.args[0])) {
                            const name = sec.args[0];
                            if (name.string in views) throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, `duplicate view name: ${name.string}`);
                            views[name.string] = true;
                            $a98ce94f10ce3b87$export$bfa50b833f100a15(name);
                        }
                        $a98ce94f10ce3b87$export$61842f5d814f90cb(sec.args[1]);
                        $a98ce94f10ce3b87$export$61842f5d814f90cb(sec.args[2]);
                        if ($a98ce94f10ce3b87$var$assertSeq(sec.args[3])) $a98ce94f10ce3b87$export$57f49bebc69f7bbc(sec.args[3]);
                    }
                    break;
                default:
                    throw new $a98ce94f10ce3b87$export$6565c3cd336fa0c4(ex, `unexpected contract section: ${sec.prim}`);
            }
        }
    }
    return true;
}
/**
 * Checks if the node is a valid Michelson smart contract source containing all required and valid properties such as `parameter`, `storage` and `code`.
 * @param ex An AST node
 */ function $a98ce94f10ce3b87$export$ee5fb880e1050817(ex) {
    try {
        $a98ce94f10ce3b87$export$ac03cc731bd7a006(ex);
        return true;
    } catch (_a) {
        return false;
    }
}
/**
 * Checks if the node is a valid Michelson data literal such as `(Pair {Elt "0" 0} 0)`.
 * @param ex An AST node
 */ function $a98ce94f10ce3b87$export$bbb3f6f181a55892(ex) {
    try {
        $a98ce94f10ce3b87$export$3cc4ed4ae67ac731(ex);
        return true;
    } catch (_a) {
        return false;
    }
}
/**
 * Checks if the node is a valid Michelson code (sequence of instructions).
 * @param ex An AST node
 */ function $a98ce94f10ce3b87$export$a2dcce50fb4b57ad(ex) {
    try {
        $a98ce94f10ce3b87$export$57f49bebc69f7bbc(ex);
        return true;
    } catch (_a) {
        return false;
    }
}
/**
 * Checks if the node is a valid Michelson type expression.
 * @param ex An AST node
 */ function $a98ce94f10ce3b87$export$a417c0bb2942f1a4(ex) {
    try {
        $a98ce94f10ce3b87$export$176936cdb34aed2f(ex);
        return true;
    } catch (_a) {
        return false;
    }
}
function $a98ce94f10ce3b87$export$517b0c6d75337fc8(p) {
    return Object.prototype.hasOwnProperty.call($a98ce94f10ce3b87$export$f3fe68d730702c17, p.prim);
}
function $a98ce94f10ce3b87$export$5cb2cbfd0cef2950(d) {
    if (!Array.isArray(d)) return false;
    for (const v of d)if ('prim' in v) {
        if ($a98ce94f10ce3b87$export$517b0c6d75337fc8(v)) throw new $a98ce94f10ce3b87$export$61ae7f08643aa181(d, `Instruction outside of a lambda: ${JSON.stringify(d)}`);
        else if (v.prim === 'Elt') throw new $a98ce94f10ce3b87$export$61ae7f08643aa181(d, `Elt item outside of a map literal: ${JSON.stringify(d)}`);
    }
    return true;
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $a98ce94f10ce3b87$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
// The order is important!
// The position represent the encoding value.
const $a98ce94f10ce3b87$var$primitives = [
    'parameter',
    'storage',
    'code',
    'False',
    'Elt',
    'Left',
    'None',
    'Pair',
    'Right',
    'Some',
    'True',
    'Unit',
    'PACK',
    'UNPACK',
    'BLAKE2B',
    'SHA256',
    'SHA512',
    'ABS',
    'ADD',
    'AMOUNT',
    'AND',
    'BALANCE',
    'CAR',
    'CDR',
    'CHECK_SIGNATURE',
    'COMPARE',
    'CONCAT',
    'CONS',
    'CREATE_ACCOUNT',
    'CREATE_CONTRACT',
    'IMPLICIT_ACCOUNT',
    'DIP',
    'DROP',
    'DUP',
    'EDIV',
    'EMPTY_MAP',
    'EMPTY_SET',
    'EQ',
    'EXEC',
    'FAILWITH',
    'GE',
    'GET',
    'GT',
    'HASH_KEY',
    'IF',
    'IF_CONS',
    'IF_LEFT',
    'IF_NONE',
    'INT',
    'LAMBDA',
    'LE',
    'LEFT',
    'LOOP',
    'LSL',
    'LSR',
    'LT',
    'MAP',
    'MEM',
    'MUL',
    'NEG',
    'NEQ',
    'NIL',
    'NONE',
    'NOT',
    'NOW',
    'OR',
    'PAIR',
    'PUSH',
    'RIGHT',
    'SIZE',
    'SOME',
    'SOURCE',
    'SENDER',
    'SELF',
    'STEPS_TO_QUOTA',
    'SUB',
    'SWAP',
    'TRANSFER_TOKENS',
    'SET_DELEGATE',
    'UNIT',
    'UPDATE',
    'XOR',
    'ITER',
    'LOOP_LEFT',
    'ADDRESS',
    'CONTRACT',
    'ISNAT',
    'CAST',
    'RENAME',
    'bool',
    'contract',
    'int',
    'key',
    'key_hash',
    'lambda',
    'list',
    'map',
    'big_map',
    'nat',
    'option',
    'or',
    'pair',
    'set',
    'signature',
    'string',
    'bytes',
    'mutez',
    'timestamp',
    'unit',
    'operation',
    'address',
    'SLICE',
    'DIG',
    'DUG',
    'EMPTY_BIG_MAP',
    'APPLY',
    'chain_id',
    'CHAIN_ID',
    'LEVEL',
    'SELF_ADDRESS',
    'never',
    'NEVER',
    'UNPAIR',
    'VOTING_POWER',
    'TOTAL_VOTING_POWER',
    'KECCAK',
    'SHA3',
    'PAIRING_CHECK',
    'bls12_381_g1',
    'bls12_381_g2',
    'bls12_381_fr',
    'sapling_state',
    'sapling_transaction_deprecated',
    'SAPLING_EMPTY_STATE',
    'SAPLING_VERIFY_UPDATE',
    'ticket',
    'TICKET_DEPRECATED',
    'READ_TICKET',
    'SPLIT_TICKET',
    'JOIN_TICKETS',
    'GET_AND_UPDATE',
    'chest',
    'chest_key',
    'OPEN_CHEST',
    'VIEW',
    'view',
    'constant',
    'SUB_MUTEZ',
    'tx_rollup_l2_address',
    'MIN_BLOCK_TIME',
    'sapling_transaction',
    'EMIT',
    'Lambda_rec',
    'LAMBDA_REC',
    'TICKET',
    'BYTES',
    'NAT',
    'Ticket'
];
const $a98ce94f10ce3b87$var$primTags = Object.assign({}, ...$a98ce94f10ce3b87$var$primitives.map((v, i)=>({
        [v]: i
    })));
var $a98ce94f10ce3b87$var$Tag;
(function(Tag) {
    Tag[Tag["Int"] = 0] = "Int";
    Tag[Tag["String"] = 1] = "String";
    Tag[Tag["Sequence"] = 2] = "Sequence";
    Tag[Tag["Prim0"] = 3] = "Prim0";
    Tag[Tag["Prim0Annot"] = 4] = "Prim0Annot";
    Tag[Tag["Prim1"] = 5] = "Prim1";
    Tag[Tag["Prim1Annot"] = 6] = "Prim1Annot";
    Tag[Tag["Prim2"] = 7] = "Prim2";
    Tag[Tag["Prim2Annot"] = 8] = "Prim2Annot";
    Tag[Tag["Prim"] = 9] = "Prim";
    Tag[Tag["Bytes"] = 10] = "Bytes";
})($a98ce94f10ce3b87$var$Tag || ($a98ce94f10ce3b87$var$Tag = {}));
class $a98ce94f10ce3b87$var$Writer {
    constructor(){
        this.buffer = [];
    }
    get length() {
        return this.buffer.length;
    }
    writeBytes(val) {
        this.buffer.push(...val.map((v)=>v & 0xff));
    }
    writeUint8(val) {
        const v = val | 0;
        this.buffer.push(v & 0xff);
    }
    writeUint16(val) {
        const v = val | 0;
        this.buffer.push(v >> 8 & 0xff);
        this.buffer.push(v & 0xff);
    }
    writeUint32(val) {
        const v = val | 0;
        this.buffer.push(v >> 24 & 0xff);
        this.buffer.push(v >> 16 & 0xff);
        this.buffer.push(v >> 8 & 0xff);
        this.buffer.push(v & 0xff);
    }
    writeInt8(val) {
        this.writeUint8(val);
    }
    writeInt16(val) {
        this.writeUint16(val);
    }
    writeInt32(val) {
        this.writeUint32(val);
    }
}
const $a98ce94f10ce3b87$var$boundsErr = new Error('bounds out of range');
class $a98ce94f10ce3b87$var$Reader {
    constructor(buffer, idx = 0, cap = buffer.length){
        this.buffer = buffer;
        this.idx = idx;
        this.cap = cap;
    }
    /** Remaining length */ get length() {
        return this.cap - this.idx;
    }
    readBytes(len) {
        if (this.cap - this.idx < len) throw $a98ce94f10ce3b87$var$boundsErr;
        const ret = this.buffer.slice(this.idx, this.idx + len);
        this.idx += len;
        return ret;
    }
    reader(len) {
        if (this.cap - this.idx < len) throw $a98ce94f10ce3b87$var$boundsErr;
        const ret = new $a98ce94f10ce3b87$var$Reader(this.buffer, this.idx, this.idx + len);
        this.idx += len;
        return ret;
    }
    copy() {
        return new $a98ce94f10ce3b87$var$Reader(this.buffer, this.idx, this.cap);
    }
    readUint8() {
        if (this.cap - this.idx < 1) throw $a98ce94f10ce3b87$var$boundsErr;
        return this.buffer[this.idx++] >>> 0;
    }
    readUint16() {
        if (this.cap - this.idx < 2) throw $a98ce94f10ce3b87$var$boundsErr;
        const x0 = this.buffer[this.idx++];
        const x1 = this.buffer[this.idx++];
        return (x0 << 8 | x1) >>> 0;
    }
    readUint32() {
        if (this.cap - this.idx < 4) throw $a98ce94f10ce3b87$var$boundsErr;
        const x0 = this.buffer[this.idx++];
        const x1 = this.buffer[this.idx++];
        const x2 = this.buffer[this.idx++];
        const x3 = this.buffer[this.idx++];
        return (x0 << 24 | x1 << 16 | x2 << 8 | x3) >>> 0;
    }
    readInt8() {
        if (this.cap - this.idx < 1) throw $a98ce94f10ce3b87$var$boundsErr;
        const x = this.buffer[this.idx++];
        return x << 24 >> 24;
    }
    readInt16() {
        if (this.cap - this.idx < 2) throw $a98ce94f10ce3b87$var$boundsErr;
        const x0 = this.buffer[this.idx++];
        const x1 = this.buffer[this.idx++];
        return (x0 << 8 | x1) << 16 >> 16;
    }
    readInt32() {
        if (this.cap - this.idx < 4) throw $a98ce94f10ce3b87$var$boundsErr;
        const x0 = this.buffer[this.idx++];
        const x1 = this.buffer[this.idx++];
        const x2 = this.buffer[this.idx++];
        const x3 = this.buffer[this.idx++];
        return x0 << 24 | x1 << 16 | x2 << 8 | x3;
    }
}
var $a98ce94f10ce3b87$var$ContractID;
(function(ContractID) {
    ContractID[ContractID["Implicit"] = 0] = "Implicit";
    ContractID[ContractID["Originated"] = 1] = "Originated";
})($a98ce94f10ce3b87$var$ContractID || ($a98ce94f10ce3b87$var$ContractID = {}));
var $a98ce94f10ce3b87$var$PublicKeyHashID;
(function(PublicKeyHashID) {
    PublicKeyHashID[PublicKeyHashID["ED25519"] = 0] = "ED25519";
    PublicKeyHashID[PublicKeyHashID["SECP256K1"] = 1] = "SECP256K1";
    PublicKeyHashID[PublicKeyHashID["P256"] = 2] = "P256";
})($a98ce94f10ce3b87$var$PublicKeyHashID || ($a98ce94f10ce3b87$var$PublicKeyHashID = {}));
function $a98ce94f10ce3b87$var$readPublicKeyHash(rd) {
    let type;
    const tag = rd.readUint8();
    switch(tag){
        case $a98ce94f10ce3b87$var$PublicKeyHashID.ED25519:
            type = 'ED25519PublicKeyHash';
            break;
        case $a98ce94f10ce3b87$var$PublicKeyHashID.SECP256K1:
            type = 'SECP256K1PublicKeyHash';
            break;
        case $a98ce94f10ce3b87$var$PublicKeyHashID.P256:
            type = 'P256PublicKeyHash';
            break;
        default:
            throw new Error(`unknown public key hash tag: ${tag}`);
    }
    return {
        type: type,
        hash: rd.readBytes(20)
    };
}
function $a98ce94f10ce3b87$var$readAddress(rd) {
    let address;
    const tag = rd.readUint8();
    switch(tag){
        case $a98ce94f10ce3b87$var$ContractID.Implicit:
            address = $a98ce94f10ce3b87$var$readPublicKeyHash(rd);
            break;
        case $a98ce94f10ce3b87$var$ContractID.Originated:
            address = {
                type: 'ContractHash',
                hash: rd.readBytes(20)
            };
            rd.readBytes(1);
            break;
        default:
            throw new Error(`unknown address tag: ${tag}`);
    }
    if (rd.length !== 0) {
        // entry point
        const dec = new TextDecoder();
        address.entryPoint = dec.decode(new Uint8Array(rd.readBytes(rd.length)));
    }
    return address;
}
function $a98ce94f10ce3b87$var$writePublicKeyHash(a, w) {
    let tag;
    switch(a.type){
        case 'ED25519PublicKeyHash':
            tag = $a98ce94f10ce3b87$var$PublicKeyHashID.ED25519;
            break;
        case 'SECP256K1PublicKeyHash':
            tag = $a98ce94f10ce3b87$var$PublicKeyHashID.SECP256K1;
            break;
        case 'P256PublicKeyHash':
            tag = $a98ce94f10ce3b87$var$PublicKeyHashID.P256;
            break;
        default:
            throw new Error(`unexpected address type: ${a.type}`);
    }
    w.writeUint8(tag);
    w.writeBytes(Array.from(a.hash));
}
function $a98ce94f10ce3b87$var$writeAddress(a, w) {
    if (a.type === 'ContractHash') {
        w.writeUint8($a98ce94f10ce3b87$var$ContractID.Originated);
        w.writeBytes(Array.from(a.hash));
        w.writeUint8(0);
    } else {
        w.writeUint8($a98ce94f10ce3b87$var$ContractID.Implicit);
        $a98ce94f10ce3b87$var$writePublicKeyHash(a, w);
    }
    if (a.entryPoint !== undefined && a.entryPoint !== '' && a.entryPoint !== 'default') {
        const enc = new TextEncoder();
        const bytes = enc.encode(a.entryPoint);
        w.writeBytes(Array.from(bytes));
    }
}
var $a98ce94f10ce3b87$var$PublicKeyID;
(function(PublicKeyID) {
    PublicKeyID[PublicKeyID["ED25519"] = 0] = "ED25519";
    PublicKeyID[PublicKeyID["SECP256K1"] = 1] = "SECP256K1";
    PublicKeyID[PublicKeyID["P256"] = 2] = "P256";
})($a98ce94f10ce3b87$var$PublicKeyID || ($a98ce94f10ce3b87$var$PublicKeyID = {}));
function $a98ce94f10ce3b87$var$readPublicKey(rd) {
    let ln;
    let type;
    const tag = rd.readUint8();
    switch(tag){
        case $a98ce94f10ce3b87$var$PublicKeyID.ED25519:
            type = 'ED25519PublicKey';
            ln = 32;
            break;
        case $a98ce94f10ce3b87$var$PublicKeyID.SECP256K1:
            type = 'SECP256K1PublicKey';
            ln = 33;
            break;
        case $a98ce94f10ce3b87$var$PublicKeyID.P256:
            type = 'P256PublicKey';
            ln = 33;
            break;
        default:
            throw new Error(`unknown public key tag: ${tag}`);
    }
    return {
        type: type,
        publicKey: rd.readBytes(ln)
    };
}
function $a98ce94f10ce3b87$var$writePublicKey(pk, w) {
    let tag;
    switch(pk.type){
        case 'ED25519PublicKey':
            tag = $a98ce94f10ce3b87$var$PublicKeyID.ED25519;
            break;
        case 'SECP256K1PublicKey':
            tag = $a98ce94f10ce3b87$var$PublicKeyID.SECP256K1;
            break;
        case 'P256PublicKey':
            tag = $a98ce94f10ce3b87$var$PublicKeyID.P256;
            break;
        default:
            throw new Error(`unexpected public key type: ${pk.type}`);
    }
    w.writeUint8(tag);
    w.writeBytes(Array.from(pk.publicKey));
}
function $a98ce94f10ce3b87$var$writeExpr(expr, wr, tf) {
    var _a, _b;
    const [e, args] = tf(expr);
    if (Array.isArray(e)) {
        const w = new $a98ce94f10ce3b87$var$Writer();
        for (const v of e){
            const a = args.next();
            if (a.done) throw new Error('REPORT ME: iterator is done');
            $a98ce94f10ce3b87$var$writeExpr(v, w, a.value);
        }
        wr.writeUint8($a98ce94f10ce3b87$var$Tag.Sequence);
        wr.writeUint32(w.length);
        wr.writeBytes(w.buffer);
        return;
    }
    if ('string' in e) {
        const enc = new TextEncoder();
        const bytes = enc.encode(e.string);
        wr.writeUint8($a98ce94f10ce3b87$var$Tag.String);
        wr.writeUint32(bytes.length);
        wr.writeBytes(Array.from(bytes));
        return;
    }
    if ('int' in e) {
        wr.writeUint8($a98ce94f10ce3b87$var$Tag.Int);
        let val = BigInt(e.int);
        const sign = val < 0;
        if (sign) val = -val;
        let i = 0;
        do {
            const bits = i === 0 ? BigInt(6) : BigInt(7);
            let byte = val & (BigInt(1) << bits) - BigInt(1);
            val >>= bits;
            if (val) byte |= BigInt(0x80);
            if (i === 0 && sign) byte |= BigInt(0x40);
            wr.writeUint8(Number(byte));
            i++;
        }while (val);
        return;
    }
    if ('bytes' in e) {
        const bytes = $a98ce94f10ce3b87$var$parseHex(e.bytes);
        wr.writeUint8($a98ce94f10ce3b87$var$Tag.Bytes);
        wr.writeUint32(bytes.length);
        wr.writeBytes(bytes);
        return;
    }
    const prim = $a98ce94f10ce3b87$var$primTags[e.prim];
    if (prim === undefined) throw new TypeError(`Can't encode primary: ${e.prim}`);
    const tag = (((_a = e.args) === null || _a === void 0 ? void 0 : _a.length) || 0) < 3 ? $a98ce94f10ce3b87$var$Tag.Prim0 + (((_b = e.args) === null || _b === void 0 ? void 0 : _b.length) || 0) * 2 + (e.annots === undefined || e.annots.length === 0 ? 0 : 1) : $a98ce94f10ce3b87$var$Tag.Prim;
    wr.writeUint8(tag);
    wr.writeUint8(prim);
    if (e.args !== undefined) {
        if (e.args.length < 3) for (const v of e.args){
            const a = args.next();
            if (a.done) throw new Error('REPORT ME: iterator is done');
            $a98ce94f10ce3b87$var$writeExpr(v, wr, a.value);
        }
        else {
            const w = new $a98ce94f10ce3b87$var$Writer();
            for (const v of e.args){
                const a = args.next();
                if (a.done) throw new Error('REPORT ME: iterator is done');
                $a98ce94f10ce3b87$var$writeExpr(v, w, a.value);
            }
            wr.writeUint32(w.length);
            wr.writeBytes(w.buffer);
        }
    }
    if (e.annots !== undefined && e.annots.length !== 0) {
        const enc = new TextEncoder();
        const bytes = enc.encode(e.annots.join(' '));
        wr.writeUint32(bytes.length);
        wr.writeBytes(Array.from(bytes));
    } else if (e.args !== undefined && e.args.length >= 3) wr.writeUint32(0);
}
function $a98ce94f10ce3b87$var$readExpr(rd, tf) {
    function* passThrough() {
        while(true)yield $a98ce94f10ce3b87$var$readPassThrough;
    }
    const [args, tr] = tf;
    const tag = rd.readUint8();
    switch(tag){
        case $a98ce94f10ce3b87$var$Tag.Int:
            {
                const buf = [];
                let byte;
                do {
                    byte = rd.readInt8();
                    buf.push(byte);
                }while ((byte & 0x80) !== 0);
                let val = BigInt(0);
                let sign = false;
                for(let i = buf.length - 1; i >= 0; i--){
                    const bits = i === 0 ? BigInt(6) : BigInt(7);
                    const byte = BigInt(buf[i]);
                    val <<= bits;
                    val |= byte & (BigInt(1) << bits) - BigInt(1);
                    if (i === 0) sign = !!(byte & BigInt(0x40));
                }
                if (sign) val = -val;
                return tr({
                    int: String(val)
                });
            }
        case $a98ce94f10ce3b87$var$Tag.String:
            {
                const length = rd.readUint32();
                const bytes = rd.readBytes(length);
                const dec = new TextDecoder();
                return tr({
                    string: dec.decode(new Uint8Array(bytes))
                });
            }
        case $a98ce94f10ce3b87$var$Tag.Bytes:
            {
                const length = rd.readUint32();
                const bytes = rd.readBytes(length);
                const hex = $a98ce94f10ce3b87$var$hexBytes(Array.from(bytes));
                return tr({
                    bytes: hex
                });
            }
        case $a98ce94f10ce3b87$var$Tag.Sequence:
            {
                const length = rd.readUint32();
                let res = [];
                let savedrd = rd.copy();
                // make two passes
                let it = passThrough();
                for(let n = 0; n < 2; n++){
                    const r = savedrd.reader(length);
                    res = [];
                    while(r.length > 0){
                        const a = it.next();
                        if (a.done) throw new Error('REPORT ME: iterator is done');
                        res.push($a98ce94f10ce3b87$var$readExpr(r, a.value));
                    }
                    // make a second pass with injected side effects
                    it = args(res);
                    savedrd = rd;
                }
                return tr(res);
            }
        default:
            {
                if (tag > 9) throw new Error(`Unknown tag: ${tag}`);
                const p = rd.readUint8();
                if (p >= $a98ce94f10ce3b87$var$primitives.length) throw new Error(`Unknown primitive tag: ${p}`);
                const prim = $a98ce94f10ce3b87$var$primitives[p];
                const argn = tag - 3 >> 1;
                let res = {
                    prim: prim
                };
                // make two passes
                let it = passThrough();
                let savedrd = rd.copy();
                for(let n = 0; n < 2; n++){
                    res = {
                        prim: prim
                    };
                    if (argn < 3) for(let i = 0; i < argn; i++){
                        const a = it.next();
                        if (a.done) throw new Error('REPORT ME: iterator is done');
                        res.args = res.args || [];
                        res.args.push($a98ce94f10ce3b87$var$readExpr(savedrd, a.value));
                    }
                    else {
                        res.args = res.args || [];
                        const length = savedrd.readUint32();
                        const r = savedrd.reader(length);
                        while(r.length > 0){
                            const a = it.next();
                            if (a.done) throw new Error('REPORT ME: iterator is done');
                            res.args.push($a98ce94f10ce3b87$var$readExpr(r, a.value));
                        }
                    }
                    // make a second pass with injected side effects
                    it = args(res);
                    savedrd = rd;
                }
                if ((tag - 3 & 1) === 1 || argn === 3) {
                    // read annotations
                    const length = rd.readUint32();
                    if (length !== 0) {
                        const bytes = rd.readBytes(length);
                        const dec = new TextDecoder();
                        res.annots = dec.decode(new Uint8Array(bytes)).split(' ');
                    }
                }
                return tr(res);
            }
    }
}
const $a98ce94f10ce3b87$var$isOrData = (e)=>'prim' in e && (e.prim === 'Left' || e.prim === 'Right');
const $a98ce94f10ce3b87$var$isOptionData = (e)=>'prim' in e && (e.prim === 'Some' || e.prim === 'None');
const $a98ce94f10ce3b87$var$getWriteTransformFunc = (t)=>{
    if ($a98ce94f10ce3b87$var$isPairType(t)) return (d)=>{
        if (!$a98ce94f10ce3b87$var$isPairData(d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `pair expected: ${JSON.stringify(d)}`, d);
        $a98ce94f10ce3b87$export$5cb2cbfd0cef2950(d);
        // combs aren't used in pack format
        const tc = $a98ce94f10ce3b87$var$unpackComb('pair', t);
        const dc = $a98ce94f10ce3b87$var$unpackComb('Pair', d);
        return [
            dc,
            function*() {
                for (const a of tc.args)yield $a98ce94f10ce3b87$var$getWriteTransformFunc(a);
            }()
        ];
    };
    switch(t.prim){
        case 'or':
            return (d)=>{
                if (!$a98ce94f10ce3b87$var$isOrData(d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `or expected: ${JSON.stringify(d)}`, d);
                return [
                    d,
                    function*() {
                        yield $a98ce94f10ce3b87$var$getWriteTransformFunc(t.args[d.prim === 'Left' ? 0 : 1]);
                    }()
                ];
            };
        case 'option':
            return (d)=>{
                if (!$a98ce94f10ce3b87$var$isOptionData(d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `option expected: ${JSON.stringify(d)}`, d);
                return [
                    d,
                    function*() {
                        const dd = d;
                        // TODO: refactor and remove ts-ignore
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        if (dd.prim === 'Some') yield $a98ce94f10ce3b87$var$getWriteTransformFunc(t.args[0]);
                    }()
                ];
            };
        case 'list':
        case 'set':
            return (d)=>{
                if (!Array.isArray(d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `${t.prim} expected: ${JSON.stringify(d)}`, d);
                return [
                    d,
                    function*() {
                        for (const _v of d)yield $a98ce94f10ce3b87$var$getWriteTransformFunc(t.args[0]);
                    }()
                ];
            };
        case 'map':
            return (d)=>{
                if (!Array.isArray(d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `map expected: ${JSON.stringify(d)}`, d);
                return [
                    d,
                    function*() {
                        for (const _elt of d)yield (elt)=>{
                            if (!('prim' in elt) || elt.prim !== 'Elt') throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `map element expected: ${JSON.stringify(elt)}`, elt);
                            return [
                                elt,
                                function*() {
                                    for (const a of t.args)yield $a98ce94f10ce3b87$var$getWriteTransformFunc(a);
                                }()
                            ];
                        };
                    }()
                ];
            };
        case 'chain_id':
            return (d)=>{
                if (!('bytes' in d) && !('string' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `chain id expected: ${JSON.stringify(d)}`, d);
                let bytes;
                if ('string' in d) {
                    const id = $a98ce94f10ce3b87$var$checkDecodeTezosID(d.string, 'ChainID');
                    if (id === null) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `chain id base58 expected: ${d.string}`, d);
                    bytes = {
                        bytes: $a98ce94f10ce3b87$var$hexBytes(id[1])
                    };
                } else bytes = d;
                return [
                    bytes,
                    [][Symbol.iterator]()
                ];
            };
        case 'signature':
            return (d)=>{
                if (!('bytes' in d) && !('string' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `signature expected: ${JSON.stringify(d)}`, d);
                let bytes;
                if ('string' in d) {
                    const sig = $a98ce94f10ce3b87$var$checkDecodeTezosID(d.string, 'ED25519Signature', 'SECP256K1Signature', 'P256Signature', 'GenericSignature');
                    if (sig === null) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `signature base58 expected: ${d.string}`, d);
                    bytes = {
                        bytes: $a98ce94f10ce3b87$var$hexBytes(sig[1])
                    };
                } else bytes = d;
                return [
                    bytes,
                    [][Symbol.iterator]()
                ];
            };
        case 'key_hash':
            return (d)=>{
                if (!('bytes' in d) && !('string' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `key hash expected: ${JSON.stringify(d)}`, d);
                let bytes;
                if ('string' in d) {
                    const pkh = $a98ce94f10ce3b87$var$checkDecodeTezosID(d.string, 'ED25519PublicKeyHash', 'SECP256K1PublicKeyHash', 'P256PublicKeyHash');
                    if (pkh === null) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `key hash base58 expected: ${d.string}`, d);
                    const w = new $a98ce94f10ce3b87$var$Writer();
                    $a98ce94f10ce3b87$var$writePublicKeyHash({
                        type: pkh[0],
                        hash: pkh[1]
                    }, w);
                    bytes = {
                        bytes: $a98ce94f10ce3b87$var$hexBytes(w.buffer)
                    };
                } else bytes = d;
                return [
                    bytes,
                    [][Symbol.iterator]()
                ];
            };
        case 'key':
            return (d)=>{
                if (!('bytes' in d) && !('string' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `public key expected: ${JSON.stringify(d)}`, d);
                let bytes;
                if ('string' in d) {
                    const key = $a98ce94f10ce3b87$var$checkDecodeTezosID(d.string, 'ED25519PublicKey', 'SECP256K1PublicKey', 'P256PublicKey');
                    if (key === null) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `public key base58 expected: ${d.string}`, d);
                    const w = new $a98ce94f10ce3b87$var$Writer();
                    $a98ce94f10ce3b87$var$writePublicKey({
                        type: key[0],
                        publicKey: key[1]
                    }, w);
                    bytes = {
                        bytes: $a98ce94f10ce3b87$var$hexBytes(w.buffer)
                    };
                } else bytes = d;
                return [
                    bytes,
                    [][Symbol.iterator]()
                ];
            };
        case 'address':
            return (d)=>{
                if (!('bytes' in d) && !('string' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `address expected: ${JSON.stringify(d)}`, d);
                let bytes;
                if ('string' in d) {
                    const s = d.string.split('%');
                    const address = $a98ce94f10ce3b87$var$checkDecodeTezosID(s[0], 'ED25519PublicKeyHash', 'SECP256K1PublicKeyHash', 'P256PublicKeyHash', 'ContractHash');
                    if (address === null) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `address base58 expected: ${d.string}`, d);
                    const w = new $a98ce94f10ce3b87$var$Writer();
                    $a98ce94f10ce3b87$var$writeAddress({
                        type: address[0],
                        hash: address[1],
                        entryPoint: s.length > 1 ? s[1] : undefined
                    }, w);
                    bytes = {
                        bytes: $a98ce94f10ce3b87$var$hexBytes(w.buffer)
                    };
                } else bytes = d;
                return [
                    bytes,
                    [][Symbol.iterator]()
                ];
            };
        case 'timestamp':
            return (d)=>{
                if (!('string' in d) && !('int' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `timestamp expected: ${JSON.stringify(d)}`, d);
                let int;
                if ('string' in d) {
                    const p = $a98ce94f10ce3b87$var$parseDate(d);
                    if (p === null) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `can't parse date: ${d.string}`, d);
                    int = {
                        int: String(Math.floor(p.getTime() / 1000))
                    };
                } else int = d;
                return [
                    int,
                    [][Symbol.iterator]()
                ];
            };
        default:
            return $a98ce94f10ce3b87$var$writePassThrough;
    }
};
const $a98ce94f10ce3b87$var$isPushInstruction = (e)=>'prim' in e && e.prim === 'PUSH';
const $a98ce94f10ce3b87$var$writePassThrough = (e)=>{
    if ($a98ce94f10ce3b87$var$isPushInstruction(e)) {
        $a98ce94f10ce3b87$export$57f49bebc69f7bbc(e);
        // capture inlined type definition
        return [
            e,
            function*() {
                yield $a98ce94f10ce3b87$var$writePassThrough;
                yield $a98ce94f10ce3b87$var$getWriteTransformFunc(e.args[0]);
            }()
        ];
    }
    return [
        e,
        function*() {
            while(true)yield $a98ce94f10ce3b87$var$writePassThrough;
        }()
    ];
};
/**
 * Serializes any value of packable type to its optimized binary representation
 * identical to the one used by PACK and UNPACK Michelson instructions.
 * Without a type definition (not recommended) the data will be encoded as a binary form of a generic Michelson expression.
 * Type definition allows some types like `timestamp` and `address` and other base58 representable types to be encoded to
 * corresponding optimized binary forms borrowed from the Tezos protocol
 *
 * ```typescript
 * const data: MichelsonData = {
 *     string: "KT1RvkwF4F7pz1gCoxkyZrG1RkrxQy3gmFTv%foo"
 * };
 *
 * const typ: MichelsonType = {
 *     prim: "address"
 * };
 *
 * const packed = packData(data, typ);
 *
 * // 050a0000001901be41ee922ddd2cf33201e49d32da0afec571dce300666f6f
 * ```
 *
 * Without a type definition the base58 encoded address will be treated as a string
 * ```typescript
 * const data: MichelsonData = {
 *     string: "KT1RvkwF4F7pz1gCoxkyZrG1RkrxQy3gmFTv%foo"
 * };
 *
 * const packed = packData(data);
 *
 * // 0501000000284b543152766b7746344637707a3167436f786b795a724731526b7278517933676d46547625666f6f
 * ```
 * @param d Data object
 * @param t Optional type definition
 * @returns Binary representation as numeric array
 */ function $a98ce94f10ce3b87$export$e29f66ea0caa0188(d, t) {
    const w = new $a98ce94f10ce3b87$var$Writer();
    w.writeUint8(5);
    $a98ce94f10ce3b87$var$writeExpr(d, w, t !== undefined ? $a98ce94f10ce3b87$var$getWriteTransformFunc(t) : $a98ce94f10ce3b87$var$writePassThrough);
    return w.buffer;
}
/**
 * Serializes any value of packable type to its optimized binary representation
 * identical to the one used by PACK and UNPACK Michelson instructions.
 * Same as {@link packData} but returns a `bytes` Michelson data literal instead of an array
 *
 * ```typescript
 * const data: MichelsonData = {
 *     string: "2019-09-26T10:59:51Z"
 * };
 *
 * const typ: MichelsonType = {
 *     prim: "timestamp"
 * };
 *
 * const packed = packDataBytes(data, typ);
 *
 * // { bytes: "0500a7e8e4d80b" }
 * ```
 * @param d Data object
 * @param t Optional type definition
 * @returns Binary representation as a bytes literal
 */ function $a98ce94f10ce3b87$export$ec5c026f9926015c(d, t) {
    return {
        bytes: $a98ce94f10ce3b87$var$hexBytes($a98ce94f10ce3b87$export$e29f66ea0caa0188(d, t))
    };
}
const $a98ce94f10ce3b87$var$getReadTransformFuncs = (t)=>{
    if ($a98ce94f10ce3b87$var$isPairType(t)) return [
        (d)=>{
            if (!$a98ce94f10ce3b87$var$isPairData(d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `pair expected: ${JSON.stringify(d)}`, d);
            const tc = $a98ce94f10ce3b87$var$unpackComb('pair', t);
            return function*() {
                for (const a of tc.args)yield $a98ce94f10ce3b87$var$getReadTransformFuncs(a);
            }();
        },
        (d)=>d
    ];
    switch(t.prim){
        case 'or':
            return [
                (d)=>{
                    if (!$a98ce94f10ce3b87$var$isOrData(d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `or expected: ${JSON.stringify(d)}`, d);
                    return function*() {
                        yield $a98ce94f10ce3b87$var$getReadTransformFuncs(t.args[d.prim === 'Left' ? 0 : 1]);
                    }();
                },
                (d)=>d
            ];
        case 'option':
            return [
                (d)=>{
                    if (!$a98ce94f10ce3b87$var$isOptionData(d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `option expected: ${JSON.stringify(d)}`, d);
                    return function*() {
                        // TODO: refactor and remove ts-ignore
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        if (d.prim === 'Some') yield $a98ce94f10ce3b87$var$getReadTransformFuncs(t.args[0]);
                    }();
                },
                (d)=>d
            ];
        case 'list':
        case 'set':
            return [
                (d)=>{
                    if (!Array.isArray(d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `${t.prim} expected: ${JSON.stringify(d)}`, d);
                    return function*() {
                        while(true)yield $a98ce94f10ce3b87$var$getReadTransformFuncs(t.args[0]);
                    }();
                },
                (d)=>d
            ];
        case 'map':
            return [
                (d)=>{
                    if (!Array.isArray(d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `map expected: ${JSON.stringify(d)}`, d);
                    return function*() {
                        while(true)yield [
                            (elt)=>{
                                if (!('prim' in elt) || elt.prim !== 'Elt') throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `map element expected: ${JSON.stringify(elt)}`, elt);
                                return function*() {
                                    for (const a of t.args)yield $a98ce94f10ce3b87$var$getReadTransformFuncs(a);
                                }();
                            },
                            (elt)=>elt
                        ];
                    }();
                },
                (d)=>d
            ];
        case 'chain_id':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('bytes' in d) && !('string' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `chain id expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const bytes = $a98ce94f10ce3b87$var$parseBytes(d.bytes);
                    if (bytes === null) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `can't parse bytes: ${d.bytes}`, d);
                    return {
                        string: $a98ce94f10ce3b87$var$encodeTezosID('ChainID', bytes)
                    };
                }
            ];
        case 'signature':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('bytes' in d) && !('string' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `signature expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const bytes = $a98ce94f10ce3b87$var$parseBytes(d.bytes);
                    if (bytes === null) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `can't parse bytes: ${d.bytes}`, d);
                    return {
                        string: $a98ce94f10ce3b87$var$encodeTezosID('GenericSignature', bytes)
                    };
                }
            ];
        case 'key_hash':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('bytes' in d) && !('string' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `key hash expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const bytes = $a98ce94f10ce3b87$var$parseBytes(d.bytes);
                    if (bytes === null) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `can't parse bytes: ${d.bytes}`, d);
                    const rd = new $a98ce94f10ce3b87$var$Reader(new Uint8Array(bytes));
                    const addr = $a98ce94f10ce3b87$var$readPublicKeyHash(rd);
                    return {
                        string: $a98ce94f10ce3b87$var$encodeTezosID(addr.type, addr.hash) + (addr.entryPoint ? '%' + addr.entryPoint : '')
                    };
                }
            ];
        case 'key':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('bytes' in d) && !('string' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `public key expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const bytes = $a98ce94f10ce3b87$var$parseBytes(d.bytes);
                    if (bytes === null) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `can't parse bytes: ${d.bytes}`, d);
                    const rd = new $a98ce94f10ce3b87$var$Reader(new Uint8Array(bytes));
                    const pk = $a98ce94f10ce3b87$var$readPublicKey(rd);
                    return {
                        string: $a98ce94f10ce3b87$var$encodeTezosID(pk.type, pk.publicKey)
                    };
                }
            ];
        case 'address':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('bytes' in d) && !('string' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `address expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const bytes = $a98ce94f10ce3b87$var$parseBytes(d.bytes);
                    if (bytes === null) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `can't parse bytes: ${d.bytes}`, d);
                    const rd = new $a98ce94f10ce3b87$var$Reader(new Uint8Array(bytes));
                    const addr = $a98ce94f10ce3b87$var$readAddress(rd);
                    return {
                        string: $a98ce94f10ce3b87$var$encodeTezosID(addr.type, addr.hash) + (addr.entryPoint ? '%' + addr.entryPoint : '')
                    };
                }
            ];
        case 'timestamp':
            return [
                ()=>[][Symbol.iterator](),
                (d)=>{
                    if (!('int' in d) && !('string' in d)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `address expected: ${JSON.stringify(d)}`, d);
                    if ('string' in d) return d;
                    const date = new Date(parseInt(d.int, 10) * 1000);
                    return {
                        string: date.toISOString().slice(0, 19) + 'Z'
                    };
                }
            ];
        default:
            return $a98ce94f10ce3b87$var$readPassThrough;
    }
};
const $a98ce94f10ce3b87$var$readPassThrough = [
    (e)=>{
        if ($a98ce94f10ce3b87$var$isPushInstruction(e)) {
            $a98ce94f10ce3b87$export$57f49bebc69f7bbc(e);
            // capture inlined type definition
            return function*() {
                yield $a98ce94f10ce3b87$var$readPassThrough;
                yield $a98ce94f10ce3b87$var$getReadTransformFuncs(e.args[0]);
            }();
        }
        return function*() {
            while(true)yield $a98ce94f10ce3b87$var$readPassThrough;
        }();
    },
    (e)=>e
];
/**
 * Deserialize a byte array into the corresponding Michelson value.
 * Without a type definition (not recommended) the binary data will be treated as a binary form of a generic Michelson expression and returned as is.
 * Type definition allows some types like `timestamp` and `address` and other types usually encoded in optimized binary forms to be transformed
 * back to their string representations like base58 and ISO timestamps.
 *
 * ```typescript
 * const src = [0x05, 0x00, 0xa7, 0xe8, 0xe4, 0xd8, 0x0b];
 *
 * const typ: MichelsonType = {
 *     prim: "timestamp"
 * };
 *
 * const data = unpackData(src, typ);
 *
 * // { string: "2019-09-26T10:59:51Z" }
 * ```
 *
 * Same binary data without a type definition
 * ```typescript
 * const src = [0x05, 0x00, 0xa7, 0xe8, 0xe4, 0xd8, 0x0b];
 *
 * const data = unpackData(src);
 *
 * // { int: "1569495591" }
 * ```
 * @param src Byte array
 * @param t Optional type definition
 * @returns Deserialized data
 */ function $a98ce94f10ce3b87$export$ce0ea93f941cfe05(src, t) {
    const r = new $a98ce94f10ce3b87$var$Reader(src);
    if (r.readUint8() !== 5) throw new Error('incorrect packed data magic number');
    const ex = $a98ce94f10ce3b87$var$readExpr(r, t !== undefined ? $a98ce94f10ce3b87$var$getReadTransformFuncs(t) : $a98ce94f10ce3b87$var$readPassThrough);
    if ($a98ce94f10ce3b87$export$3cc4ed4ae67ac731(ex)) return ex;
    throw new Error(); // never
}
/**
 * Deserialize a byte array into the corresponding Michelson value.
 * Same as {@link unpackData} but takes a `bytes` Michelson data literal instead of an array
 *
 * ```typescript
 * const src = { bytes: "0500a7e8e4d80b" };
 *
 * const typ: MichelsonType = {
 *     prim: "timestamp"
 * };
 *
 * const data = unpackDataBytes(src, typ);
 *
 * // { string: "2019-09-26T10:59:51Z" }
 * ```
 * @param src Bytes object
 * @param t Optional type definition
 * @returns Deserialized data
 */ function $a98ce94f10ce3b87$export$19053657e689bb0(src, t) {
    const bytes = $a98ce94f10ce3b87$var$parseBytes(src.bytes);
    if (bytes === null) throw new Error(`can't parse bytes: "${src.bytes}"`);
    return $a98ce94f10ce3b87$export$ce0ea93f941cfe05(bytes, t);
}
// helper functions also used by validator
function $a98ce94f10ce3b87$export$d476e2924803ffc4(b) {
    const bytes = $a98ce94f10ce3b87$var$parseBytes(b.bytes);
    if (bytes === null) throw new Error(`can't parse bytes: "${b.bytes}"`);
    const rd = new $a98ce94f10ce3b87$var$Reader(new Uint8Array(bytes));
    return $a98ce94f10ce3b87$var$readAddress(rd);
}
function $a98ce94f10ce3b87$export$39bdd4124a6764aa(b) {
    const bytes = $a98ce94f10ce3b87$var$parseBytes(b.bytes);
    if (bytes === null) throw new Error(`can't parse bytes: "${b.bytes}"`);
    const rd = new $a98ce94f10ce3b87$var$Reader(new Uint8Array(bytes));
    return $a98ce94f10ce3b87$var$readPublicKeyHash(rd);
}
function $a98ce94f10ce3b87$export$28ad8e7080e9bd54(b) {
    const bytes = $a98ce94f10ce3b87$var$parseBytes(b.bytes);
    if (bytes === null) throw new Error(`can't parse bytes: "${b.bytes}"`);
    const rd = new $a98ce94f10ce3b87$var$Reader(new Uint8Array(bytes));
    return $a98ce94f10ce3b87$var$readPublicKey(rd);
}
class $a98ce94f10ce3b87$export$4077f6a2bcdec605 extends $a98ce94f10ce3b87$export$61ae7f08643aa181 {
    /**
     * @param val Value of a type node caused the error
     * @param stackState Current stack state
     * @param message An error message
     */ constructor(val, stackState, message){
        super(val, message);
        this.val = val;
        this.stackState = stackState;
        this.message = message;
        this.name = 'MichelsonInstructionError';
    }
}
// 'sequence as a pair' edo syntax helpers
function $a98ce94f10ce3b87$var$typeID(t) {
    return Array.isArray(t) ? 'pair' : t.prim;
}
function $a98ce94f10ce3b87$var$typeArgs(t) {
    return 'prim' in t ? t.args : t;
}
function $a98ce94f10ce3b87$var$assertScalarTypesEqual(a, b, field = false) {
    if ($a98ce94f10ce3b87$var$typeID(a) !== $a98ce94f10ce3b87$var$typeID(b)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(a, `types mismatch: ${$a98ce94f10ce3b87$var$typeID(a)} != ${$a98ce94f10ce3b87$var$typeID(b)}`, undefined);
    const ann = [
        $a98ce94f10ce3b87$var$unpackAnnotations(a),
        $a98ce94f10ce3b87$var$unpackAnnotations(b)
    ];
    if (ann[0].t && ann[1].t && ann[0].t[0] !== ann[1].t[0]) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(a, `${$a98ce94f10ce3b87$var$typeID(a)}: type names mismatch: ${ann[0].t[0]} != ${ann[1].t[0]}`, undefined);
    if (field && ann[0].f && ann[1].f && ann[0].f[0] !== ann[1].f[0]) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(a, `${$a98ce94f10ce3b87$var$typeID(a)}: field names mismatch: ${ann[0].f[0]} != ${ann[1].f}`, undefined);
    if ($a98ce94f10ce3b87$var$isPairType(a)) {
        const aArgs = $a98ce94f10ce3b87$var$unpackComb('pair', a);
        const bArgs = $a98ce94f10ce3b87$var$unpackComb('pair', b);
        $a98ce94f10ce3b87$var$assertScalarTypesEqual(aArgs.args[0], bArgs.args[0], true);
        $a98ce94f10ce3b87$var$assertScalarTypesEqual(aArgs.args[1], bArgs.args[1], true);
        return;
    }
    switch(a.prim){
        case 'option':
        case 'list':
        case 'contract':
        case 'set':
        case 'ticket':
            $a98ce94f10ce3b87$var$assertScalarTypesEqual(a.args[0], b.args[0]);
            break;
        case 'or':
            $a98ce94f10ce3b87$var$assertScalarTypesEqual(a.args[0], b.args[0], true);
            $a98ce94f10ce3b87$var$assertScalarTypesEqual(a.args[1], b.args[1], true);
            break;
        case 'lambda':
        case 'map':
        case 'big_map':
            $a98ce94f10ce3b87$var$assertScalarTypesEqual(a.args[0], b.args[0]);
            $a98ce94f10ce3b87$var$assertScalarTypesEqual(a.args[1], b.args[1]);
            break;
        case 'sapling_state':
        case 'sapling_transaction':
            if (parseInt(a.args[0].int, 10) !== parseInt(b.args[0].int, 10)) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(a, `${$a98ce94f10ce3b87$var$typeID(a)}: type argument mismatch: ${a.args[0].int} != ${b.args[0].int}`, undefined);
    }
}
function $a98ce94f10ce3b87$var$assertStacksEqual(a, b) {
    if (a.length !== b.length) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(a, `stack length mismatch: ${a.length} != ${b.length}`, undefined);
    for(let i = 0; i < a.length; i++)$a98ce94f10ce3b87$var$assertScalarTypesEqual(a[i], b[i]);
}
function $a98ce94f10ce3b87$export$1244433858b68826(t, field = false) {
    var _a, _b, _c;
    if (!Array.isArray(t)) {
        const ann = $a98ce94f10ce3b87$var$unpackAnnotations(t);
        if ((((_a = ann.t) === null || _a === void 0 ? void 0 : _a.length) || 0) > 1) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `${t.prim}: at most one type annotation allowed: ${t.annots}`, undefined);
        if (field) {
            if ((((_b = ann.f) === null || _b === void 0 ? void 0 : _b.length) || 0) > 1) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `${t.prim}: at most one field annotation allowed: ${t.annots}`, undefined);
        } else {
            if ((((_c = ann.f) === null || _c === void 0 ? void 0 : _c.length) || 0) > 0) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `${t.prim}: field annotations aren't allowed: ${t.annots}`, undefined);
        }
    }
    if ($a98ce94f10ce3b87$var$isPairType(t)) {
        const args = $a98ce94f10ce3b87$var$typeArgs(t);
        for (const a of args)$a98ce94f10ce3b87$export$1244433858b68826(a, true);
        return;
    }
    switch(t.prim){
        case 'option':
        case 'list':
        case 'contract':
        case 'set':
            $a98ce94f10ce3b87$export$1244433858b68826(t.args[0]);
            break;
        case 'or':
            for (const a of t.args)$a98ce94f10ce3b87$export$1244433858b68826(a, true);
            break;
        case 'lambda':
        case 'map':
        case 'big_map':
            $a98ce94f10ce3b87$export$1244433858b68826(t.args[0]);
            $a98ce94f10ce3b87$export$1244433858b68826(t.args[1]);
    }
}
// Simplified version of assertMichelsonInstruction() for previously validated data
function $a98ce94f10ce3b87$var$isFunction(d) {
    if (!Array.isArray(d)) return false;
    for (const v of d){
        if (!(Array.isArray(v) && $a98ce94f10ce3b87$var$isFunction(v) || 'prim' in v && $a98ce94f10ce3b87$export$517b0c6d75337fc8(v))) return false;
    }
    return true;
}
function $a98ce94f10ce3b87$var$assertDataValidInternal(d, t, ctx) {
    if ($a98ce94f10ce3b87$var$isPairType(t)) {
        if ($a98ce94f10ce3b87$var$isPairData(d)) {
            $a98ce94f10ce3b87$export$5cb2cbfd0cef2950(d);
            const dc = $a98ce94f10ce3b87$var$unpackComb('Pair', d);
            const tc = $a98ce94f10ce3b87$var$unpackComb('pair', t);
            $a98ce94f10ce3b87$var$assertDataValidInternal(dc.args[0], tc.args[0], ctx);
            $a98ce94f10ce3b87$var$assertDataValidInternal(dc.args[1], tc.args[1], ctx);
            return;
        }
        throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `pair expected: ${JSON.stringify(d)}`, d);
    }
    switch(t.prim){
        // Atomic literals
        case 'int':
            if ('int' in d && $a98ce94f10ce3b87$var$isDecimal(d.int)) return;
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `integer value expected: ${JSON.stringify(d)}`, d);
        case 'nat':
        case 'mutez':
            if ('int' in d && $a98ce94f10ce3b87$var$isNatural(d.int)) return;
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `natural value expected: ${JSON.stringify(d)}`, d);
        case 'string':
            if ('string' in d) return;
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `string value expected: ${JSON.stringify(d)}`, d);
        case 'bytes':
        case 'bls12_381_g1':
        case 'bls12_381_g2':
            if ('bytes' in d && $a98ce94f10ce3b87$var$parseBytes(d.bytes) !== null) return;
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `bytes value expected: ${JSON.stringify(d)}`, d);
        case 'bool':
            if ('prim' in d && (d.prim === 'True' || d.prim === 'False')) return;
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `boolean value expected: ${JSON.stringify(d)}`, d);
        case 'key_hash':
            if ('string' in d && $a98ce94f10ce3b87$var$checkDecodeTezosID(d.string, 'ED25519PublicKeyHash', 'SECP256K1PublicKeyHash', 'P256PublicKeyHash') !== null) return;
            else if ('bytes' in d) try {
                $a98ce94f10ce3b87$export$39bdd4124a6764aa(d);
                return;
            } catch (err) {
            // ignore message
            }
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `key hash expected: ${JSON.stringify(d)}`, d);
        case 'timestamp':
            if (('string' in d || 'int' in d) && $a98ce94f10ce3b87$var$parseDate(d) !== null) return;
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `timestamp expected: ${JSON.stringify(d)}`, d);
        case 'address':
            if ('string' in d) {
                let address = d.string;
                const ep = d.string.indexOf('%');
                if (ep >= 0) // trim entry point
                address = d.string.slice(0, ep);
                if ($a98ce94f10ce3b87$var$checkDecodeTezosID(address, 'ED25519PublicKeyHash', 'SECP256K1PublicKeyHash', 'P256PublicKeyHash', 'ContractHash', 'RollupAddress') !== null) return;
            } else if ('bytes' in d) try {
                $a98ce94f10ce3b87$export$d476e2924803ffc4(d);
                return;
            } catch (err) {
            // ignore message
            }
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `address expected: ${JSON.stringify(d)}`, d);
        case 'key':
            if ('string' in d && $a98ce94f10ce3b87$var$checkDecodeTezosID(d.string, 'ED25519PublicKey', 'SECP256K1PublicKey', 'P256PublicKey') !== null) return;
            else if ('bytes' in d) try {
                $a98ce94f10ce3b87$export$28ad8e7080e9bd54(d);
                return;
            } catch (err) {
            // ignore message
            }
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `public key expected: ${JSON.stringify(d)}`, d);
        case 'unit':
            if ('prim' in d && d.prim === 'Unit') return;
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `unit value expected: ${JSON.stringify(d)}`, d);
        case 'signature':
            if ('bytes' in d || 'string' in d && $a98ce94f10ce3b87$var$checkDecodeTezosID(d.string, 'ED25519Signature', 'SECP256K1Signature', 'P256Signature', 'GenericSignature') !== null) return;
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `signature expected: ${JSON.stringify(d)}`, d);
        case 'chain_id':
            if ('bytes' in d || 'string' in d) {
                const x = 'string' in d ? $a98ce94f10ce3b87$var$decodeBase58Check(d.string) : $a98ce94f10ce3b87$var$parseBytes(d.bytes);
                if (x !== null) return;
            }
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `chain id expected: ${JSON.stringify(d)}`, d);
        // Complex types
        case 'option':
            if ('prim' in d) {
                if (d.prim === 'None') return;
                else if (d.prim === 'Some') {
                    $a98ce94f10ce3b87$var$assertDataValidInternal(d.args[0], t.args[0], ctx);
                    return;
                }
            }
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `option expected: ${JSON.stringify(d)}`, d);
        case 'list':
        case 'set':
            if ($a98ce94f10ce3b87$export$5cb2cbfd0cef2950(d)) {
                //let prev: MichelsonData | undefined;
                for (const v of d)$a98ce94f10ce3b87$var$assertDataValidInternal(v, t.args[0], ctx);
                return;
            }
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `${t.prim} expected: ${JSON.stringify(d)}`, d);
        case 'or':
            if ('prim' in d) {
                if (d.prim === 'Left') {
                    $a98ce94f10ce3b87$var$assertDataValidInternal(d.args[0], t.args[0], ctx);
                    return;
                } else if (d.prim === 'Right') {
                    $a98ce94f10ce3b87$var$assertDataValidInternal(d.args[0], t.args[1], ctx);
                    return;
                }
            }
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `union (or) expected: ${JSON.stringify(d)}`, d);
        case 'lambda':
            if ($a98ce94f10ce3b87$var$isFunction(d)) {
                const ret = $a98ce94f10ce3b87$var$functionTypeInternal(d, [
                    t.args[0]
                ], ctx);
                if ('failed' in ret) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `function is failed with error type: ${ret.failed}`, d);
                if (ret.length !== 1) throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, 'function must return a value', d);
                $a98ce94f10ce3b87$var$assertScalarTypesEqual(t.args[1], ret[0]);
                return;
            }
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `function expected: ${JSON.stringify(d)}`, d);
        case 'map':
        case 'big_map':
            if (Array.isArray(d)) {
                //let prev: MichelsonMapElt | undefined;
                for (const v of d){
                    if (!('prim' in v) || v.prim !== 'Elt') throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `map elements expected: ${JSON.stringify(d)}`, d);
                    $a98ce94f10ce3b87$var$assertDataValidInternal(v.args[0], t.args[0], ctx);
                    $a98ce94f10ce3b87$var$assertDataValidInternal(v.args[1], t.args[1], ctx);
                }
                return;
            }
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `${t.prim} expected: ${JSON.stringify(d)}`, d);
        case 'bls12_381_fr':
            if ('int' in d && $a98ce94f10ce3b87$var$isDecimal(d.int) || 'bytes' in d && $a98ce94f10ce3b87$var$parseBytes(d.bytes) !== null) return;
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `BLS12-381 element expected: ${JSON.stringify(d)}`, d);
        case 'sapling_state':
            if (Array.isArray(d)) return;
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `sapling state expected: ${JSON.stringify(d)}`, d);
        case 'ticket':
            if ('prim' in d && d.prim === 'Ticket') {
                $a98ce94f10ce3b87$var$assertDataValidInternal(d.args[0], {
                    prim: 'address'
                }, ctx);
                $a98ce94f10ce3b87$export$9a1889dd325b72ec(d.args[1], t.args[0]);
                $a98ce94f10ce3b87$var$assertDataValidInternal(d.args[2], t.args[0], ctx);
                $a98ce94f10ce3b87$var$assertDataValidInternal(d.args[3], {
                    prim: 'nat'
                }, ctx);
                return;
            } else if ($a98ce94f10ce3b87$var$isPairData(d)) {
                // backward compatibility
                $a98ce94f10ce3b87$var$assertDataValidInternal(d, {
                    prim: 'pair',
                    args: [
                        {
                            prim: 'address'
                        },
                        t.args[0],
                        {
                            prim: 'nat'
                        }
                    ]
                }, ctx);
                return;
            }
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `ticket expected: ${JSON.stringify(d)}`, d);
        default:
            throw new $a98ce94f10ce3b87$export$c9afdd965e51c08a(t, `type ${$a98ce94f10ce3b87$var$typeID(t)} don't have Michelson literal representation`, d);
    }
}
function $a98ce94f10ce3b87$var$instructionListType(inst, stack, ctx) {
    let ret = stack;
    let s = stack;
    let i = 0;
    for (const op of inst){
        const ft = $a98ce94f10ce3b87$var$functionTypeInternal(op, s, ctx);
        ret = ft;
        if ('failed' in ft) break;
        s = ft;
        i++;
    }
    if ('failed' in ret && ret.level == 0 && (!('prim' in ret.failed) || ret.failed.prim !== 'never') && i !== inst.length - 1) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(inst, ret, 'FAIL must appear in a tail position');
    if ((ctx === null || ctx === void 0 ? void 0 : ctx.traceCallback) !== undefined) {
        const trace = {
            op: inst,
            in: stack,
            out: ret
        };
        ctx.traceCallback(trace);
    }
    return 'failed' in ret ? {
        failed: ret.failed,
        level: ret.level + 1
    } : ret;
}
function $a98ce94f10ce3b87$var$functionTypeInternal(inst, stack, ctx) {
    const proto = (ctx === null || ctx === void 0 ? void 0 : ctx.protocol) || $a98ce94f10ce3b87$export$6af6ef9b852714c9;
    if (Array.isArray(inst)) return $a98ce94f10ce3b87$var$instructionListType(inst, stack, ctx);
    const instruction = inst; // Make it const for type guarding
    // make sure the stack has enough number of arguments of specific types
    function args(n, ...typeIds) {
        if (stack.length < typeIds.length + n) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: stack must have at least ${typeIds.length} element(s)`);
        let i = n;
        for (const ids of typeIds){
            if (ids !== null && ids.length !== 0) {
                let ii = 0;
                while(ii < ids.length && ids[ii] !== $a98ce94f10ce3b87$var$typeID(stack[i]))ii++;
                if (ii === ids.length) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: stack type mismatch: [${i}] expected to be ${ids}, got ${$a98ce94f10ce3b87$var$typeID(stack[i])} instead`);
            }
            i++;
        }
        return stack.slice(n, typeIds.length + n);
    }
    function rethrow(fn) {
        return (...args)=>{
            try {
                return fn(...args);
            } catch (err) {
                if (err instanceof $a98ce94f10ce3b87$export$61ae7f08643aa181) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, err.message);
                else throw err;
            }
        };
    }
    function rethrowTypeGuard(fn) {
        return (arg)=>{
            try {
                return fn(arg);
            } catch (err) {
                if (err instanceof $a98ce94f10ce3b87$export$61ae7f08643aa181) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, err.message);
                else throw err;
            }
        };
    }
    const argAnn = rethrow($a98ce94f10ce3b87$var$unpackAnnotations);
    const ensureStacksEqual = rethrow($a98ce94f10ce3b87$var$assertStacksEqual);
    const ensureTypesEqual = rethrow($a98ce94f10ce3b87$var$assertScalarTypesEqual);
    const ensureComparableType = rethrowTypeGuard($a98ce94f10ce3b87$export$d5e5c91702354d8f);
    const ensurePackableType = rethrowTypeGuard($a98ce94f10ce3b87$export$a32a137820025fa5);
    const ensureStorableType = rethrowTypeGuard($a98ce94f10ce3b87$export$f3036b1da0a36541);
    const ensurePushableType = rethrowTypeGuard($a98ce94f10ce3b87$export$61842f5d814f90cb);
    const ensureBigMapStorableType = rethrowTypeGuard($a98ce94f10ce3b87$export$5a64892aaade38d6);
    // unpack instruction annotations and assert their maximum number
    function instructionAnn(num, opt) {
        const a = argAnn(instruction, Object.assign(Object.assign({}, opt), {
            emptyFields: num.f !== undefined && num.f > 1,
            emptyVar: num.v !== undefined && num.v > 1
        }));
        const assertNum = (a, n, type)=>{
            if (a && a.length > (n || 0)) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: at most ${n || 0} ${type} annotations allowed`);
        };
        assertNum(a.f, num.f, 'field');
        assertNum(a.t, num.t, 'type');
        assertNum(a.v, num.v, 'variable');
        return a;
    }
    // also keeps annotation class if null is provided
    function annotate(tt, a) {
        const tx = tt;
        const t = Array.isArray(tx) ? {
            prim: 'pair',
            args: tx
        } : tx;
        const src = argAnn(t);
        const ann = a.v !== undefined || a.t !== undefined || a.f !== undefined ? [
            ...(a.v === null ? src.v : a.v) || [],
            ...(a.t === null ? src.t : a.t) || [],
            ...(a.f === null ? src.f : a.f) || []
        ] : undefined;
        const rest = $a98ce94f10ce3b87$var$__rest(t, [
            "annots"
        ]);
        return Object.assign(Object.assign({}, rest), ann && ann.length !== 0 && {
            annots: ann
        });
    }
    // shortcut to copy at most one variable annotation from the instruction to the type
    function annotateVar(t, def) {
        const ia = instructionAnn({
            v: 1
        });
        return annotate(t, {
            v: ia.v !== undefined ? ia.v : def !== undefined ? [
                def
            ] : null,
            t: null
        });
    }
    // annotate CAR/CDR/UNPAIR/GET
    function annotateField(arg, field, insAnn, n, defField) {
        var _a, _b, _c, _d;
        const fieldAnn = (_a = argAnn(field).f) === null || _a === void 0 ? void 0 : _a[0]; // field's field annotation
        const insFieldAnn = (_b = insAnn.f) === null || _b === void 0 ? void 0 : _b[n];
        if (insFieldAnn !== undefined && insFieldAnn !== '%' && fieldAnn !== undefined && insFieldAnn !== fieldAnn) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: field names doesn't match: ${insFieldAnn} !== ${fieldAnn}`);
        const insVarAnn = (_c = insAnn.v) === null || _c === void 0 ? void 0 : _c[n]; // nth instruction's variable annotation
        const varAnn = (_d = argAnn(arg).v) === null || _d === void 0 ? void 0 : _d[0]; // instruction argument's variable annotation
        return annotate(field, {
            t: null,
            v: insVarAnn ? insVarAnn === '@%' ? fieldAnn ? [
                '@' + fieldAnn.slice(1)
            ] : undefined : insVarAnn === '@%%' ? varAnn ? [
                '@' + varAnn.slice(1) + '.' + (fieldAnn ? fieldAnn.slice(1) : defField)
            ] : fieldAnn ? [
                '@' + fieldAnn.slice(1)
            ] : undefined : [
                insVarAnn
            ] : null
        });
    }
    // comb helper functions
    function getN(src, n, i = n) {
        const p = $a98ce94f10ce3b87$var$unpackComb('pair', src);
        if (i === 1) return [
            p.args[0]
        ];
        else if (i === 2) return p.args;
        const right = p.args[1];
        if ($a98ce94f10ce3b87$var$isPairType(right)) return [
            p.args[0],
            ...getN(right, n, i - 1)
        ];
        else throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: at least ${n} fields are expected`);
    }
    function getNth(src, n, i = n) {
        if (i === 0) return src;
        const p = $a98ce94f10ce3b87$var$unpackComb('pair', src);
        if (i === 1) return p.args[0];
        const right = p.args[1];
        if ($a98ce94f10ce3b87$var$isPairType(right)) return getNth(right, n, i - 2);
        else if (i === 2) return right;
        throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: at least ${n + 1} fields are expected`);
    }
    function updateNth(src, x, n, i = n) {
        if (i === 0) return x;
        const p = $a98ce94f10ce3b87$var$unpackComb('pair', src);
        if (i === 1) return Object.assign(Object.assign({}, p), {
            args: [
                x,
                p.args[1]
            ]
        });
        const right = p.args[1];
        if ($a98ce94f10ce3b87$var$isPairType(right)) return Object.assign(Object.assign({}, p), {
            args: [
                p.args[0],
                updateNth(right, x, n, i - 2)
            ]
        });
        else if (i === 2) return Object.assign(Object.assign({}, p), {
            args: [
                p.args[0],
                x
            ]
        });
        throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: at least ${n + 1} fields are expected`);
    }
    const varSuffix = (a, suffix)=>[
            '@' + (a.v ? a.v[0].slice(1) + '.' : '') + suffix
        ];
    function branchType(br0, br1) {
        if ('failed' in br0 || 'failed' in br1) return 'failed' in br0 ? br1 : br0;
        else {
            ensureStacksEqual(br0, br1);
            return br0;
        }
    }
    const retStack = ((instruction)=>{
        var _a, _b, _c, _d, _e;
        switch(instruction.prim){
            case 'DUP':
                {
                    const n = instruction.args ? parseInt(instruction.args[0].int, 10) : 1;
                    if (n === 0) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, 'DUP 0 is forbidden');
                    const s = args(n - 1, null)[0];
                    if ($a98ce94f10ce3b87$var$typeID(s) === 'ticket') throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, "ticket can't be DUPed");
                    return [
                        s,
                        ...stack
                    ];
                }
            case 'SWAP':
                {
                    const s = args(0, null, null);
                    instructionAnn({});
                    return [
                        s[1],
                        s[0],
                        ...stack.slice(2)
                    ];
                }
            case 'SOME':
                return [
                    annotate({
                        prim: 'option',
                        args: [
                            args(0, null)[0]
                        ]
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack.slice(1)
                ];
            case 'UNIT':
                return [
                    annotate({
                        prim: 'unit'
                    }, instructionAnn({
                        v: 1,
                        t: 1
                    })),
                    ...stack
                ];
            case 'PAIR':
                {
                    const n = instruction.args ? parseInt(instruction.args[0].int, 10) : 2;
                    if (n < 2) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `PAIR ${n} is forbidden`);
                    const s = args(0, ...new Array(n).fill(null));
                    const ia = instructionAnn({
                        f: n,
                        t: 1,
                        v: 1
                    }, {
                        specialFields: true
                    });
                    const trim = (s)=>{
                        const i = s.lastIndexOf('.');
                        return s.slice(i > 0 ? i + 1 : 1);
                    };
                    const retArgs = s.map((v, i)=>{
                        var _a;
                        const va = argAnn(v);
                        const f = ia.f && ia.f.length > i && ia.f[i] !== '%' ? ia.f[i] === '%@' ? va.v ? [
                            '%' + trim(((_a = va.v) === null || _a === void 0 ? void 0 : _a[0]) || '')
                        ] : undefined : [
                            ia.f[i]
                        ] : undefined;
                        return annotate(v, {
                            v: null,
                            t: null,
                            f: f
                        });
                    });
                    return [
                        annotate({
                            prim: 'pair',
                            args: retArgs
                        }, {
                            t: ia.t,
                            v: ia.v
                        }),
                        ...stack.slice(n)
                    ];
                }
            case 'UNPAIR':
                {
                    const n = instruction.args ? parseInt(instruction.args[0].int, 10) : 2;
                    if (n < 2) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `UNPAIR ${n} is forbidden`);
                    const s = args(0, [
                        'pair'
                    ])[0];
                    const ia = instructionAnn({
                        f: 2,
                        v: 2
                    }, {
                        specialVar: true
                    });
                    const fields = getN(s, n);
                    return [
                        ...fields.map((field, i)=>annotateField(s, field, ia, i, i === 0 ? 'car' : 'cdr')),
                        ...stack.slice(1)
                    ];
                }
            case 'CAR':
            case 'CDR':
                {
                    const s = $a98ce94f10ce3b87$var$unpackComb('pair', args(0, [
                        'pair'
                    ])[0]);
                    const field = s.args[instruction.prim === 'CAR' ? 0 : 1];
                    const ia = instructionAnn({
                        f: 1,
                        v: 1
                    }, {
                        specialVar: true
                    });
                    return [
                        annotateField(s, field, ia, 0, instruction.prim.toLocaleLowerCase()),
                        ...stack.slice(1)
                    ];
                }
            case 'CONS':
                {
                    const s = args(0, null, [
                        'list'
                    ]);
                    ensureTypesEqual(s[0], s[1].args[0]);
                    return [
                        annotateVar({
                            prim: 'list',
                            args: [
                                s[1].args[0]
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'SIZE':
                args(0, [
                    'string',
                    'list',
                    'set',
                    'map',
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack.slice(1)
                ];
            case 'MEM':
                {
                    const s = args(0, null, [
                        'set',
                        'map',
                        'big_map'
                    ]);
                    ensureComparableType(s[0]);
                    ensureTypesEqual(s[0], s[1].args[0]);
                    return [
                        annotateVar({
                            prim: 'bool'
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'GET':
                if (instruction.args) {
                    // comb operation
                    const n = parseInt(instruction.args[0].int, 10);
                    const s = args(0, [
                        'pair'
                    ])[0];
                    return [
                        annotateVar(getNth(s, n)),
                        ...stack.slice(1)
                    ];
                } else {
                    // map operation
                    const s = args(0, null, [
                        'map',
                        'big_map'
                    ]);
                    ensureComparableType(s[0]);
                    ensureTypesEqual(s[0], s[1].args[0]);
                    return [
                        annotateVar({
                            prim: 'option',
                            args: [
                                s[1].args[1]
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'UPDATE':
                if (instruction.args) {
                    // comb operation
                    const n = parseInt(instruction.args[0].int, 10);
                    const s = args(0, null, [
                        'pair'
                    ]);
                    return [
                        annotateVar(updateNth(s[1], s[0], n)),
                        ...stack.slice(2)
                    ];
                } else {
                    // map operation
                    const s0 = args(0, null, [
                        'bool',
                        'option'
                    ]);
                    ensureComparableType(s0[0]);
                    if (s0[1].prim === 'bool') {
                        const s1 = args(2, [
                            'set'
                        ]);
                        ensureTypesEqual(s0[0], s1[0].args[0]);
                        return [
                            annotateVar({
                                prim: 'set',
                                args: [
                                    annotate(s0[0], {
                                        t: null
                                    })
                                ]
                            }),
                            ...stack.slice(3)
                        ];
                    }
                    const s1 = args(2, [
                        'map',
                        'big_map'
                    ]);
                    ensureTypesEqual(s0[0], s1[0].args[0]);
                    if (s1[0].prim === 'map') return [
                        annotateVar({
                            prim: 'map',
                            args: [
                                annotate(s0[0], {
                                    t: null
                                }),
                                annotate(s0[1].args[0], {
                                    t: null
                                })
                            ]
                        }),
                        ...stack.slice(3)
                    ];
                    ensureBigMapStorableType(s0[1].args[0]);
                    return [
                        annotateVar({
                            prim: 'big_map',
                            args: [
                                annotate(s0[0], {
                                    t: null
                                }),
                                annotate(s0[1].args[0], {
                                    t: null
                                })
                            ]
                        }),
                        ...stack.slice(3)
                    ];
                }
            case 'GET_AND_UPDATE':
                {
                    const ia = instructionAnn({
                        v: 2
                    });
                    const s = args(0, null, [
                        'option'
                    ], [
                        'map',
                        'big_map'
                    ]);
                    ensureComparableType(s[0]);
                    ensureTypesEqual(s[0], s[2].args[0]);
                    ensureTypesEqual(s[1].args[0], s[2].args[1]);
                    const va = (_a = ia.v) === null || _a === void 0 ? void 0 : _a.map((v)=>v !== '@' ? [
                            v
                        ] : undefined);
                    if (s[2].prim === 'map') return [
                        annotate({
                            prim: 'option',
                            args: [
                                s[2].args[1]
                            ]
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[0]
                        }),
                        annotate({
                            prim: 'map',
                            args: [
                                annotate(s[0], {
                                    t: null
                                }),
                                annotate(s[1].args[0], {
                                    t: null
                                })
                            ]
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[1]
                        }),
                        ...stack.slice(3)
                    ];
                    ensureBigMapStorableType(s[1].args[0]);
                    return [
                        annotate({
                            prim: 'option',
                            args: [
                                s[2].args[1]
                            ]
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[0]
                        }),
                        annotate({
                            prim: 'big_map',
                            args: [
                                annotate(s[0], {
                                    t: null
                                }),
                                annotate(s[1].args[0], {
                                    t: null
                                })
                            ]
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[1]
                        }),
                        ...stack.slice(3)
                    ];
                }
            case 'EXEC':
                {
                    const s = args(0, null, [
                        'lambda'
                    ]);
                    ensureTypesEqual(s[0], s[1].args[0]);
                    return [
                        annotateVar(s[1].args[1]),
                        ...stack.slice(2)
                    ];
                }
            case 'APPLY':
                {
                    const s = args(0, null, [
                        'lambda'
                    ]);
                    ensureStorableType(s[0]);
                    ensurePushableType(s[0]);
                    if (!$a98ce94f10ce3b87$var$isPairType(s[1].args[0])) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: function's argument must be a pair: ${$a98ce94f10ce3b87$var$typeID(s[1].args[0])}`);
                    const pt = s[1].args[0];
                    ensureTypesEqual(s[0], $a98ce94f10ce3b87$var$typeArgs(pt)[0]);
                    return [
                        annotateVar({
                            prim: 'lambda',
                            args: [
                                $a98ce94f10ce3b87$var$typeArgs(pt)[1],
                                s[1].args[1]
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'FAILWITH':
                {
                    const s = args(0, null)[0];
                    if (!$a98ce94f10ce3b87$export$d0c06cb7d5b8a84b(proto, $a98ce94f10ce3b87$export$377bbedb5576dfa8.PtEdo2Zk)) ensurePackableType(s);
                    return {
                        failed: s,
                        level: 0
                    };
                }
            case 'NEVER':
                args(0, [
                    'never'
                ]);
                return {
                    failed: {
                        prim: 'never'
                    },
                    level: 0
                };
            case 'RENAME':
                return [
                    annotateVar(args(0, null)[0]),
                    ...stack.slice(1)
                ];
            case 'CONCAT':
                {
                    const s0 = args(0, [
                        'string',
                        'list',
                        'bytes'
                    ]);
                    if (s0[0].prim === 'list') {
                        if ($a98ce94f10ce3b87$var$typeID(s0[0].args[0]) !== 'string' && $a98ce94f10ce3b87$var$typeID(s0[0].args[0]) !== 'bytes') throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't concatenate list of ${$a98ce94f10ce3b87$var$typeID(s0[0].args[0])}'s`);
                        return [
                            annotateVar(s0[0].args[0]),
                            ...stack.slice(1)
                        ];
                    }
                    const s1 = args(1, [
                        'string',
                        'bytes'
                    ]);
                    if (s0[0].prim !== s1[0].prim) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't concatenate ${s0[0].prim} with ${s1[0].prim}`);
                    return [
                        annotateVar(s1[0]),
                        ...stack.slice(2)
                    ];
                }
            case 'SLICE':
                return [
                    annotateVar({
                        prim: 'option',
                        args: [
                            args(0, [
                                'nat'
                            ], [
                                'nat'
                            ], [
                                'string',
                                'bytes'
                            ])[2]
                        ]
                    }, '@slice'),
                    ...stack.slice(3)
                ];
            case 'PACK':
                {
                    const s = args(0, null)[0];
                    ensurePackableType(s);
                    return [
                        annotateVar({
                            prim: 'bytes'
                        }, '@packed'),
                        ...stack.slice(1)
                    ];
                }
            case 'ADD':
                {
                    const s = args(0, [
                        'nat',
                        'int',
                        'timestamp',
                        'mutez',
                        'bls12_381_g1',
                        'bls12_381_g2',
                        'bls12_381_fr'
                    ], [
                        'nat',
                        'int',
                        'timestamp',
                        'mutez',
                        'bls12_381_g1',
                        'bls12_381_g2',
                        'bls12_381_fr'
                    ]);
                    if (s[0].prim === 'nat' && s[1].prim === 'int' || s[0].prim === 'int' && s[1].prim === 'nat') return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'int' && s[1].prim === 'timestamp' || s[0].prim === 'timestamp' && s[1].prim === 'int') return [
                        annotateVar({
                            prim: 'timestamp'
                        }),
                        ...stack.slice(2)
                    ];
                    else if ((s[0].prim === 'int' || s[0].prim === 'nat' || s[0].prim === 'mutez' || s[0].prim === 'bls12_381_g1' || s[0].prim === 'bls12_381_g2' || s[0].prim === 'bls12_381_fr') && s[0].prim === s[1].prim) return [
                        annotateVar(s[0]),
                        ...stack.slice(2)
                    ];
                    throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't add ${s[0].prim} to ${s[1].prim}`);
                }
            case 'SUB':
                {
                    const s = $a98ce94f10ce3b87$export$d0c06cb7d5b8a84b(proto, $a98ce94f10ce3b87$export$377bbedb5576dfa8.PsiThaCa) ? args(0, [
                        'nat',
                        'int',
                        'timestamp',
                        'mutez'
                    ], [
                        'nat',
                        'int',
                        'timestamp',
                        'mutez'
                    ]) : args(0, [
                        'nat',
                        'int',
                        'timestamp'
                    ], [
                        'nat',
                        'int',
                        'timestamp'
                    ]);
                    if ((s[0].prim === 'nat' || s[0].prim === 'int') && (s[1].prim === 'nat' || s[1].prim === 'int') || s[0].prim === 'timestamp' && s[1].prim === 'timestamp') return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'timestamp' && s[1].prim === 'int') return [
                        annotateVar({
                            prim: 'timestamp'
                        }),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'mutez' && s[1].prim === 'mutez') return [
                        annotateVar({
                            prim: 'mutez'
                        }),
                        ...stack.slice(2)
                    ];
                    throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't subtract ${s[0].prim} from ${s[1].prim}`);
                }
            case 'SUB_MUTEZ':
                args(0, [
                    'mutez'
                ], [
                    'mutez'
                ]);
                return [
                    annotateVar({
                        prim: 'option',
                        args: [
                            {
                                prim: 'mutez'
                            }
                        ]
                    }),
                    ...stack.slice(2)
                ];
            case 'MUL':
                {
                    const s = args(0, [
                        'nat',
                        'int',
                        'mutez',
                        'bls12_381_g1',
                        'bls12_381_g2',
                        'bls12_381_fr'
                    ], [
                        'nat',
                        'int',
                        'mutez',
                        'bls12_381_g1',
                        'bls12_381_g2',
                        'bls12_381_fr'
                    ]);
                    if (s[0].prim === 'nat' && s[1].prim === 'int' || s[0].prim === 'int' && s[1].prim === 'nat') return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'nat' && s[1].prim === 'mutez' || s[0].prim === 'mutez' && s[1].prim === 'nat') return [
                        annotateVar({
                            prim: 'mutez'
                        }),
                        ...stack.slice(2)
                    ];
                    else if ((s[0].prim === 'bls12_381_g1' || s[0].prim === 'bls12_381_g2' || s[0].prim === 'bls12_381_fr') && s[1].prim === 'bls12_381_fr' || (s[0].prim === 'nat' || s[0].prim === 'int') && s[0].prim === s[1].prim) return [
                        annotateVar(s[0]),
                        ...stack.slice(2)
                    ];
                    else if ((s[0].prim === 'nat' || s[0].prim === 'int') && s[1].prim === 'bls12_381_fr' || (s[1].prim === 'nat' || s[1].prim === 'int') && s[0].prim === 'bls12_381_fr') return [
                        annotateVar({
                            prim: 'bls12_381_fr'
                        }),
                        ...stack.slice(2)
                    ];
                    throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't multiply ${s[0].prim} by ${s[1].prim}`);
                }
            case 'EDIV':
                {
                    const res = (a, b)=>({
                            prim: 'option',
                            args: [
                                {
                                    prim: 'pair',
                                    args: [
                                        {
                                            prim: a
                                        },
                                        {
                                            prim: b
                                        }
                                    ]
                                }
                            ]
                        });
                    const s = args(0, [
                        'nat',
                        'int',
                        'mutez'
                    ], [
                        'nat',
                        'int',
                        'mutez'
                    ]);
                    if (s[0].prim === 'nat' && s[1].prim === 'nat') return [
                        annotateVar(res('nat', 'nat')),
                        ...stack.slice(2)
                    ];
                    else if ((s[0].prim === 'nat' || s[0].prim === 'int') && (s[1].prim === 'nat' || s[1].prim === 'int')) return [
                        annotateVar(res('int', 'nat')),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'mutez' && s[1].prim === 'nat') return [
                        annotateVar(res('mutez', 'mutez')),
                        ...stack.slice(2)
                    ];
                    else if (s[0].prim === 'mutez' && s[1].prim === 'mutez') return [
                        annotateVar(res('nat', 'mutez')),
                        ...stack.slice(2)
                    ];
                    throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: can't euclideally divide ${s[0].prim} by ${s[1].prim}`);
                }
            case 'ABS':
                args(0, [
                    'int'
                ]);
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack.slice(1)
                ];
            case 'ISNAT':
                args(0, [
                    'int'
                ]);
                return [
                    annotateVar({
                        prim: 'option',
                        args: [
                            {
                                prim: 'nat'
                            }
                        ]
                    }),
                    ...stack.slice(1)
                ];
            case 'INT':
                args(0, [
                    'nat',
                    'bls12_381_fr',
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'int'
                    }),
                    ...stack.slice(1)
                ];
            case 'BYTES':
                args(0, [
                    'nat',
                    'int'
                ]);
                return [
                    annotateVar({
                        prim: 'bytes'
                    }),
                    ...stack.slice(1)
                ];
            case 'NAT':
                args(0, [
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack.slice(1)
                ];
            case 'NEG':
                {
                    const s = args(0, [
                        'nat',
                        'int',
                        'bls12_381_g1',
                        'bls12_381_g2',
                        'bls12_381_fr'
                    ])[0];
                    if (s.prim === 'nat' || s.prim === 'int') return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(1)
                    ];
                    return [
                        annotateVar(s),
                        ...stack.slice(1)
                    ];
                }
            case 'LSL':
            case 'LSR':
                args(0, [
                    'nat',
                    'bytes'
                ], [
                    'nat',
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack.slice(2)
                ];
            case 'OR':
            case 'XOR':
                {
                    const s = args(0, [
                        'nat',
                        'bytes',
                        'bool'
                    ], [
                        'nat',
                        'bytes',
                        'bool'
                    ]);
                    if (s[0].prim !== s[1].prim) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: both arguments must be of the same type: ${s[0].prim}, ${s[1].prim}`);
                    return [
                        annotateVar(s[1]),
                        ...stack.slice(2)
                    ];
                }
            case 'AND':
                {
                    const s = args(0, [
                        'nat',
                        'bytes',
                        'bool',
                        'int'
                    ], [
                        'nat',
                        'bytes',
                        'bool'
                    ]);
                    if ((s[0].prim !== 'int' || s[1].prim !== 'nat') && s[0].prim !== s[1].prim) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: both arguments must be of the same type: ${s[0].prim}, ${s[1].prim}`);
                    return [
                        annotateVar(s[1]),
                        ...stack.slice(2)
                    ];
                }
            case 'NOT':
                {
                    const s = args(0, [
                        'nat',
                        'bytes',
                        'bool',
                        'int'
                    ])[0];
                    if (s.prim === 'bool') return [
                        annotateVar({
                            prim: 'bool'
                        }),
                        ...stack.slice(1)
                    ];
                    return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'COMPARE':
                {
                    const s = args(0, null, null);
                    ensureComparableType(s[0]);
                    ensureComparableType(s[1]);
                    return [
                        annotateVar({
                            prim: 'int'
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'EQ':
            case 'NEQ':
            case 'LT':
            case 'GT':
            case 'LE':
            case 'GE':
                args(0, [
                    'int'
                ]);
                return [
                    annotateVar({
                        prim: 'bool'
                    }),
                    ...stack.slice(1)
                ];
            case 'SELF':
                {
                    if ((ctx === null || ctx === void 0 ? void 0 : ctx.contract) === undefined) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: contract required`);
                    const ia = instructionAnn({
                        f: 1,
                        v: 1
                    });
                    const ep = $a98ce94f10ce3b87$export$7755930f2db79bc5(ctx.contract, (_b = ia.f) === null || _b === void 0 ? void 0 : _b[0]);
                    if (ep === null) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: contract has no entrypoint ${ep}`);
                    return [
                        annotate({
                            prim: 'contract',
                            args: [
                                ep
                            ]
                        }, {
                            v: ia.v ? ia.v : [
                                '@self'
                            ]
                        }),
                        ...stack
                    ];
                }
            case 'TRANSFER_TOKENS':
                {
                    const s = args(0, null, [
                        'mutez'
                    ], [
                        'contract'
                    ]);
                    ensureTypesEqual(s[0], s[2].args[0]);
                    return [
                        annotateVar({
                            prim: 'operation'
                        }),
                        ...stack.slice(3)
                    ];
                }
            case 'SET_DELEGATE':
                {
                    const s = args(0, [
                        'option'
                    ])[0];
                    if ($a98ce94f10ce3b87$var$typeID(s.args[0]) !== 'key_hash') throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: key hash expected: ${$a98ce94f10ce3b87$var$typeID(s.args[0])}`);
                    return [
                        annotateVar({
                            prim: 'operation'
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'IMPLICIT_ACCOUNT':
                args(0, [
                    'key_hash'
                ]);
                return [
                    annotateVar({
                        prim: 'contract',
                        args: [
                            {
                                prim: 'unit'
                            }
                        ]
                    }),
                    ...stack.slice(1)
                ];
            case 'NOW':
                return [
                    annotateVar({
                        prim: 'timestamp'
                    }, '@now'),
                    ...stack
                ];
            case 'AMOUNT':
                return [
                    annotateVar({
                        prim: 'mutez'
                    }, '@amount'),
                    ...stack
                ];
            case 'BALANCE':
                return [
                    annotateVar({
                        prim: 'mutez'
                    }, '@balance'),
                    ...stack
                ];
            case 'CHECK_SIGNATURE':
                args(0, [
                    'key'
                ], [
                    'signature'
                ], [
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'bool'
                    }),
                    ...stack.slice(3)
                ];
            case 'BLAKE2B':
            case 'SHA256':
            case 'SHA512':
            case 'KECCAK':
            case 'SHA3':
                args(0, [
                    'bytes'
                ]);
                return [
                    annotateVar({
                        prim: 'bytes'
                    }),
                    ...stack.slice(1)
                ];
            case 'HASH_KEY':
                args(0, [
                    'key'
                ]);
                return [
                    annotateVar({
                        prim: 'key_hash'
                    }),
                    ...stack.slice(1)
                ];
            case 'SOURCE':
                return [
                    annotateVar({
                        prim: 'address'
                    }, '@source'),
                    ...stack
                ];
            case 'SENDER':
                return [
                    annotateVar({
                        prim: 'address'
                    }, '@sender'),
                    ...stack
                ];
            case 'ADDRESS':
                {
                    const s = args(0, [
                        'contract'
                    ])[0];
                    const ia = instructionAnn({
                        v: 1
                    });
                    return [
                        annotate({
                            prim: 'address',
                            [$a98ce94f10ce3b87$export$8bd888d100ea60f]: s
                        }, {
                            v: ia.v ? ia.v : varSuffix(argAnn(s), 'address')
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'SELF_ADDRESS':
                {
                    const addr = {
                        prim: 'address'
                    };
                    if ((ctx === null || ctx === void 0 ? void 0 : ctx.contract) !== undefined) addr[$a98ce94f10ce3b87$export$8bd888d100ea60f] = {
                        prim: 'contract',
                        args: [
                            $a98ce94f10ce3b87$export$8df01cc5695a993c(ctx.contract, 'parameter').args[0]
                        ]
                    };
                    return [
                        annotateVar(addr, '@address'),
                        ...stack
                    ];
                }
            case 'CHAIN_ID':
                return [
                    annotateVar({
                        prim: 'chain_id'
                    }),
                    ...stack
                ];
            case 'DROP':
                {
                    instructionAnn({});
                    const n = instruction.args !== undefined ? parseInt(instruction.args[0].int, 10) : 1;
                    args(n - 1, null);
                    return stack.slice(n);
                }
            case 'DIG':
                {
                    instructionAnn({});
                    const n = parseInt(instruction.args[0].int, 10);
                    return [
                        args(n, null)[0],
                        ...stack.slice(0, n),
                        ...stack.slice(n + 1)
                    ];
                }
            case 'DUG':
                {
                    instructionAnn({});
                    const n = parseInt(instruction.args[0].int, 10);
                    return [
                        ...stack.slice(1, n + 1),
                        args(0, null)[0],
                        ...stack.slice(n + 1)
                    ];
                }
            case 'NONE':
                $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[0]);
                return [
                    annotate({
                        prim: 'option',
                        args: [
                            instruction.args[0]
                        ]
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack
                ];
            case 'LEFT':
            case 'RIGHT':
                {
                    const s = args(0, null)[0];
                    const ia = instructionAnn({
                        f: 2,
                        t: 1,
                        v: 1
                    }, {
                        specialFields: true
                    });
                    const va = argAnn(s);
                    const children = [
                        annotate(s, {
                            t: null,
                            v: null,
                            f: ia.f && ia.f.length > 0 && ia.f[0] !== '%' ? ia.f[0] === '%@' ? va.v ? [
                                '%' + va.v[0].slice(1)
                            ] : undefined : ia.f : undefined
                        }),
                        annotate(instruction.args[0], {
                            t: null,
                            f: ia.f && ia.f.length > 1 && ia.f[1] !== '%' ? ia.f : undefined
                        })
                    ];
                    return [
                        annotate({
                            prim: 'or',
                            args: instruction.prim === 'LEFT' ? children : [
                                children[1],
                                children[0]
                            ]
                        }, {
                            t: ia.t,
                            v: ia.v
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'NIL':
                $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[0]);
                return [
                    annotate({
                        prim: 'list',
                        args: [
                            instruction.args[0]
                        ]
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack
                ];
            case 'UNPACK':
                args(0, [
                    'bytes'
                ]);
                $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[0]);
                return [
                    annotateVar({
                        prim: 'option',
                        args: [
                            instruction.args[0]
                        ]
                    }, '@unpacked'),
                    ...stack.slice(1)
                ];
            case 'CONTRACT':
                {
                    const s = args(0, [
                        'address'
                    ])[0];
                    $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[0]);
                    const ia = instructionAnn({
                        v: 1,
                        f: 1
                    });
                    const contract = s[$a98ce94f10ce3b87$export$8bd888d100ea60f];
                    if (contract !== undefined) {
                        const ep = $a98ce94f10ce3b87$export$7755930f2db79bc5(contract, (_c = ia.f) === null || _c === void 0 ? void 0 : _c[0]);
                        if (ep === null) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: contract has no entrypoint ${ep}`);
                        ensureTypesEqual(ep, instruction.args[0]);
                    }
                    return [
                        annotate({
                            prim: 'option',
                            args: [
                                {
                                    prim: 'contract',
                                    args: [
                                        instruction.args[0]
                                    ]
                                }
                            ]
                        }, {
                            v: ia.v ? ia.v : varSuffix(argAnn(s), 'contract')
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'CAST':
                {
                    instructionAnn({});
                    const s = args(0, null)[0];
                    $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[0]);
                    ensureTypesEqual(instruction.args[0], s);
                    return [
                        instruction.args[0],
                        ...stack.slice(1)
                    ];
                }
            case 'IF_NONE':
                {
                    instructionAnn({});
                    const s = args(0, [
                        'option'
                    ])[0];
                    const tail = stack.slice(1);
                    const br0 = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[0], tail, ctx);
                    const br1 = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[1], [
                        annotate(s.args[0], {
                            t: null,
                            v: varSuffix(argAnn(s), 'some')
                        }),
                        ...tail
                    ], ctx);
                    return branchType(br0, br1);
                }
            case 'IF_LEFT':
                {
                    instructionAnn({});
                    const s = args(0, [
                        'or'
                    ])[0];
                    const va = argAnn(s);
                    const lefta = argAnn(s.args[0]);
                    const righta = argAnn(s.args[1]);
                    const tail = stack.slice(1);
                    const br0 = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[0], [
                        annotate(s.args[0], {
                            t: null,
                            v: varSuffix(va, lefta.f ? lefta.f[0].slice(1) : 'left')
                        }),
                        ...tail
                    ], ctx);
                    const br1 = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[1], [
                        annotate(s.args[1], {
                            t: null,
                            v: varSuffix(va, righta.f ? righta.f[0].slice(1) : 'right')
                        }),
                        ...tail
                    ], ctx);
                    return branchType(br0, br1);
                }
            case 'IF_CONS':
                {
                    instructionAnn({});
                    const s = args(0, [
                        'list'
                    ])[0];
                    const va = argAnn(s);
                    const tail = stack.slice(1);
                    const br0 = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[0], [
                        annotate(s.args[0], {
                            t: null,
                            v: varSuffix(va, 'hd')
                        }),
                        annotate(s, {
                            t: null,
                            v: varSuffix(va, 'tl')
                        }),
                        ...tail
                    ], ctx);
                    const br1 = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[1], tail, ctx);
                    return branchType(br0, br1);
                }
            case 'IF':
                {
                    instructionAnn({});
                    args(0, [
                        'bool'
                    ]);
                    const tail = stack.slice(1);
                    const br0 = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[0], tail, ctx);
                    const br1 = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[1], tail, ctx);
                    return branchType(br0, br1);
                }
            case 'MAP':
                {
                    const s = args(0, [
                        'list',
                        'map',
                        'option'
                    ])[0];
                    const tail = stack.slice(1);
                    const elt = s.prim === 'map' ? {
                        prim: 'pair',
                        args: s.args
                    } : s.args[0];
                    const body = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[0], [
                        annotate(elt, {
                            t: null,
                            v: varSuffix(argAnn(s), 'elt')
                        }),
                        ...tail
                    ], ctx);
                    if ('failed' in body) {
                        if (!('prim' in body.failed) || body.failed.prim !== 'never') throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: FAIL is not allowed in MAP`);
                        return {
                            failed: body.failed,
                            level: body.level + 1
                        };
                    }
                    if (body.length < 1) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: function must return a value`);
                    ensureStacksEqual(body.slice(1), tail);
                    return s.prim === 'list' ? [
                        annotateVar({
                            prim: 'list',
                            args: [
                                body[0]
                            ]
                        }),
                        ...tail
                    ] : s.prim === 'map' ? [
                        annotateVar({
                            prim: 'map',
                            args: [
                                s.args[0],
                                body[0]
                            ]
                        }),
                        ...tail
                    ] : [
                        annotateVar({
                            prim: 'option',
                            args: [
                                body[0]
                            ]
                        }),
                        ...tail
                    ];
                }
            case 'ITER':
                {
                    instructionAnn({});
                    const s = args(0, [
                        'set',
                        'list',
                        'map'
                    ])[0];
                    const tail = stack.slice(1);
                    const elt = s.prim === 'map' ? {
                        prim: 'pair',
                        args: s.args
                    } : s.args[0];
                    const body = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[0], [
                        annotate(elt, {
                            t: null,
                            v: varSuffix(argAnn(s), 'elt')
                        }),
                        ...tail
                    ], ctx);
                    if ('failed' in body) return {
                        failed: body.failed,
                        level: body.level + 1
                    };
                    ensureStacksEqual(body, tail);
                    return tail;
                }
            case 'LOOP':
                {
                    instructionAnn({});
                    args(0, [
                        'bool'
                    ]);
                    const tail = stack.slice(1);
                    const body = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[0], tail, ctx);
                    if ('failed' in body) return {
                        failed: body.failed,
                        level: body.level + 1
                    };
                    ensureStacksEqual(body, [
                        {
                            prim: 'bool'
                        },
                        ...tail
                    ]);
                    return tail;
                }
            case 'LOOP_LEFT':
                {
                    instructionAnn({});
                    const s = args(0, [
                        'or'
                    ])[0];
                    const tail = stack.slice(1);
                    const body = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[0], [
                        annotate(s.args[0], {
                            t: null,
                            v: varSuffix(argAnn(s), 'left')
                        }),
                        ...tail
                    ], ctx);
                    if ('failed' in body) return {
                        failed: body.failed,
                        level: body.level + 1
                    };
                    ensureStacksEqual(body, [
                        s,
                        ...tail
                    ]);
                    return [
                        annotate(s.args[1], {
                            t: null,
                            v: instructionAnn({
                                v: 1
                            }).v
                        }),
                        ...tail
                    ];
                }
            case 'DIP':
                {
                    instructionAnn({});
                    const n = instruction.args.length === 2 ? parseInt(instruction.args[0].int, 10) : 1;
                    args(n - 1, null);
                    const head = stack.slice(0, n);
                    const tail = stack.slice(n);
                    // ternary operator is a type guard so use it instead of just `instruction.args.length - 1`
                    const body = instruction.args.length === 2 ? $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[1], tail, ctx) : $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[0], tail, ctx);
                    if ('failed' in body) return {
                        failed: body.failed,
                        level: body.level + 1
                    };
                    return [
                        ...head,
                        ...body
                    ];
                }
            case 'CREATE_CONTRACT':
                {
                    const ia = instructionAnn({
                        v: 2
                    });
                    const s = args(0, [
                        'option'
                    ], [
                        'mutez'
                    ], null);
                    if ($a98ce94f10ce3b87$var$typeID(s[0].args[0]) !== 'key_hash') throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: key hash expected: ${$a98ce94f10ce3b87$var$typeID(s[0].args[0])}`);
                    if (ensureStorableType(s[2])) {
                        $a98ce94f10ce3b87$export$c8575dc38549dc3a(instruction.args[0]);
                        $a98ce94f10ce3b87$var$assertScalarTypesEqual($a98ce94f10ce3b87$export$8df01cc5695a993c(instruction.args[0], 'storage').args[0], s[2]);
                    }
                    const va = (_d = ia.v) === null || _d === void 0 ? void 0 : _d.map((v)=>v !== '@' ? [
                            v
                        ] : undefined);
                    return [
                        annotate({
                            prim: 'operation'
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[0]
                        }),
                        annotate({
                            prim: 'address',
                            [$a98ce94f10ce3b87$export$8bd888d100ea60f]: {
                                prim: 'contract',
                                args: [
                                    $a98ce94f10ce3b87$export$8df01cc5695a993c(instruction.args[0], 'parameter').args[0]
                                ]
                            }
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[1]
                        }),
                        ...stack.slice(3)
                    ];
                }
            case 'PUSH':
                $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[0]);
                $a98ce94f10ce3b87$var$assertDataValidInternal(instruction.args[1], instruction.args[0], Object.assign(Object.assign({}, ctx), {
                    contract: undefined
                }));
                return [
                    annotateVar(instruction.args[0]),
                    ...stack
                ];
            case 'EMPTY_SET':
                $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[0]);
                ensureComparableType(instruction.args[0]);
                return [
                    annotate({
                        prim: 'set',
                        args: instruction.args
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack
                ];
            case 'EMPTY_MAP':
                $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[0]);
                ensureComparableType(instruction.args[0]);
                $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[1]);
                return [
                    annotate({
                        prim: 'map',
                        args: instruction.args
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack
                ];
            case 'EMPTY_BIG_MAP':
                $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[0]);
                ensureComparableType(instruction.args[0]);
                $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[1]);
                ensureBigMapStorableType(instruction.args[0]);
                return [
                    annotate({
                        prim: 'big_map',
                        args: instruction.args
                    }, instructionAnn({
                        t: 1,
                        v: 1
                    })),
                    ...stack
                ];
            case 'LAMBDA_REC':
            case 'LAMBDA':
                {
                    $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[0]);
                    $a98ce94f10ce3b87$export$1244433858b68826(instruction.args[1]);
                    const s = [
                        instruction.args[0]
                    ];
                    if (instruction.prim === 'LAMBDA_REC') s.push({
                        prim: 'lambda',
                        args: [
                            instruction.args[0],
                            instruction.args[1]
                        ]
                    });
                    const body = $a98ce94f10ce3b87$var$functionTypeInternal(instruction.args[2], s, Object.assign(Object.assign({}, ctx), {
                        contract: undefined
                    }));
                    if ('failed' in body) return {
                        failed: body.failed,
                        level: body.level + 1
                    };
                    if (body.length !== 1) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: function must return a value`);
                    ensureTypesEqual(instruction.args[1], body[0]);
                    return [
                        annotateVar({
                            prim: 'lambda',
                            args: [
                                instruction.args[0],
                                instruction.args[1]
                            ]
                        }),
                        ...stack
                    ];
                }
            case 'LEVEL':
                return [
                    annotateVar({
                        prim: 'nat'
                    }, '@level'),
                    ...stack
                ];
            case 'TOTAL_VOTING_POWER':
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack
                ];
            case 'VOTING_POWER':
                args(0, [
                    'key_hash'
                ]);
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack.slice(1)
                ];
            case 'TICKET':
                {
                    const s = args(0, null, [
                        'nat'
                    ])[0];
                    ensureComparableType(s);
                    if ($a98ce94f10ce3b87$export$d0c06cb7d5b8a84b(proto, $a98ce94f10ce3b87$export$377bbedb5576dfa8.PtLimaPtL)) return [
                        annotate({
                            prim: 'ticket',
                            args: [
                                s
                            ]
                        }, instructionAnn({
                            t: 1,
                            v: 1
                        })),
                        ...stack.slice(2)
                    ];
                    else return [
                        annotateVar({
                            prim: 'option',
                            args: [
                                annotate({
                                    prim: 'ticket',
                                    args: [
                                        s
                                    ]
                                }, instructionAnn({
                                    t: 1,
                                    v: 1
                                }))
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'JOIN_TICKETS':
                {
                    const s = $a98ce94f10ce3b87$var$unpackComb('pair', args(0, [
                        'pair'
                    ])[0]);
                    if ($a98ce94f10ce3b87$var$typeID(s.args[0]) !== 'ticket') throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: ticket expected: ${$a98ce94f10ce3b87$var$typeID(s.args[0])}`);
                    ensureTypesEqual(s.args[0], s.args[1]);
                    return [
                        annotateVar({
                            prim: 'option',
                            args: [
                                annotate(s.args[0], {
                                    t: null
                                })
                            ]
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'SPLIT_TICKET':
                {
                    const s = args(0, [
                        'ticket'
                    ], [
                        'pair'
                    ]);
                    const p = $a98ce94f10ce3b87$var$unpackComb('pair', s[1]);
                    if ($a98ce94f10ce3b87$var$typeID(p.args[0]) !== 'nat') throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: nat expected: ${$a98ce94f10ce3b87$var$typeID(p.args[0])}`);
                    ensureTypesEqual(p.args[0], p.args[1]);
                    return [
                        annotateVar({
                            prim: 'option',
                            args: [
                                {
                                    prim: 'pair',
                                    args: [
                                        annotate(s[0], {
                                            t: null
                                        }),
                                        annotate(s[0], {
                                            t: null
                                        })
                                    ]
                                }
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'READ_TICKET':
                {
                    const ia = instructionAnn({
                        v: 2
                    });
                    const s = args(0, [
                        'ticket'
                    ])[0];
                    const va = (_e = ia.v) === null || _e === void 0 ? void 0 : _e.map((v)=>v !== '@' ? [
                            v
                        ] : undefined);
                    return [
                        annotate({
                            prim: 'pair',
                            args: [
                                {
                                    prim: 'address'
                                },
                                annotate(s.args[0], {
                                    t: null
                                }),
                                {
                                    prim: 'nat'
                                }
                            ]
                        }, {
                            v: va === null || va === void 0 ? void 0 : va[0]
                        }),
                        annotate(s, {
                            v: va === null || va === void 0 ? void 0 : va[1],
                            t: null
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'PAIRING_CHECK':
                {
                    const p = args(0, [
                        'list'
                    ])[0].args[0];
                    if (!$a98ce94f10ce3b87$var$isPairType(p)) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: pair expected: ${$a98ce94f10ce3b87$var$typeID(p)}`);
                    const c = $a98ce94f10ce3b87$var$unpackComb('pair', p);
                    if ($a98ce94f10ce3b87$var$typeID(c.args[0]) !== 'bls12_381_g1') throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: bls12_381_g1 expected: ${$a98ce94f10ce3b87$var$typeID(c.args[0])}`);
                    if ($a98ce94f10ce3b87$var$typeID(c.args[1]) !== 'bls12_381_g2') throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: bls12_381_g2 expected: ${$a98ce94f10ce3b87$var$typeID(c.args[1])}`);
                    return [
                        annotateVar({
                            prim: 'bool'
                        }),
                        ...stack.slice(1)
                    ];
                }
            case 'SAPLING_EMPTY_STATE':
                return [
                    annotate({
                        prim: 'sapling_state',
                        args: [
                            instruction.args[0]
                        ]
                    }, instructionAnn({
                        v: 1,
                        t: 1
                    })),
                    ...stack
                ];
            case 'SAPLING_VERIFY_UPDATE':
                {
                    const s = args(0, [
                        'sapling_transaction'
                    ], [
                        'sapling_state'
                    ]);
                    if (parseInt(s[0].args[0].int, 10) !== parseInt(s[1].args[0].int, 10)) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(instruction, stack, `${instruction.prim}: sapling memo size mismatch: ${s[0].args[0].int} != ${s[1].args[0].int}`);
                    return $a98ce94f10ce3b87$export$d0c06cb7d5b8a84b(proto, $a98ce94f10ce3b87$export$377bbedb5576dfa8.PtJakarta) ? [
                        annotateVar({
                            prim: 'option',
                            args: [
                                {
                                    prim: 'pair',
                                    args: [
                                        {
                                            prim: 'int'
                                        },
                                        annotate(s[1], {
                                            t: null
                                        })
                                    ]
                                }
                            ]
                        }),
                        ...stack.slice(2)
                    ] : [
                        annotateVar({
                            prim: 'option',
                            args: [
                                {
                                    prim: 'pair',
                                    args: [
                                        {
                                            prim: 'bytes'
                                        },
                                        {
                                            prim: 'pair',
                                            args: [
                                                {
                                                    prim: 'int'
                                                },
                                                annotate(s[1], {
                                                    t: null
                                                })
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'OPEN_CHEST':
                args(0, [
                    'chest_key'
                ], [
                    'chest'
                ], [
                    'nat'
                ]);
                return [
                    annotateVar({
                        prim: 'or',
                        args: [
                            {
                                prim: 'bytes'
                            },
                            {
                                prim: 'bool'
                            }
                        ]
                    }),
                    ...stack.slice(3)
                ];
            case 'VIEW':
                {
                    const s = args(0, null, [
                        'address'
                    ]);
                    ensurePushableType(s[0]);
                    return [
                        annotateVar({
                            prim: 'option',
                            args: [
                                instruction.args[1]
                            ]
                        }),
                        ...stack.slice(2)
                    ];
                }
            case 'MIN_BLOCK_TIME':
                return [
                    annotateVar({
                        prim: 'nat'
                    }),
                    ...stack
                ];
            case 'EMIT':
                {
                    const ia = instructionAnn({
                        f: 1,
                        t: 1
                    });
                    if (instruction.args) {
                        const s = args(0, null);
                        ensureTypesEqual(s[0], instruction.args[0]);
                        return [
                            annotate({
                                prim: 'operation'
                            }, ia),
                            ...stack.slice(1)
                        ];
                    }
                    return [
                        annotate({
                            prim: 'operation'
                        }, ia),
                        ...stack.slice(1)
                    ];
                }
            default:
                throw new $a98ce94f10ce3b87$export$61ae7f08643aa181(instruction, `unexpected instruction: ${instruction.prim}`);
        }
    })(instruction);
    if ((ctx === null || ctx === void 0 ? void 0 : ctx.traceCallback) !== undefined) {
        const trace = {
            op: instruction,
            in: stack,
            out: retStack
        };
        ctx.traceCallback(trace);
    }
    return retStack;
}
function $a98ce94f10ce3b87$export$8df01cc5695a993c(contract, section) {
    for (const s of contract){
        if (s.prim === section) return s;
    }
    throw new $a98ce94f10ce3b87$export$61ae7f08643aa181(contract, `missing contract section: ${section}`);
}
function $a98ce94f10ce3b87$export$579f744ea06231e6(contract) {
    const views = {};
    for (const s of contract)if (s.prim === 'view') views[s.args[0].string] = s;
    return views;
}
function $a98ce94f10ce3b87$var$isContract(v) {
    if (Array.isArray(v)) for (const s of v){
        if ('prim' in s && (s.prim === 'parameter' || s.prim === 'storage' || s.prim === 'code')) return true;
    }
    return false;
}
function $a98ce94f10ce3b87$export$7755930f2db79bc5(src, ep) {
    ep = ep || '%default';
    const entryPoint = $a98ce94f10ce3b87$export$d1db0bdebeb6f9c7(src).find((x)=>x[0] === ep);
    if (entryPoint !== undefined) return entryPoint[1];
    else if (ep === '%default') return $a98ce94f10ce3b87$var$isContract(src) ? $a98ce94f10ce3b87$export$8df01cc5695a993c(src, 'parameter').args[0] : src;
    return null;
}
function $a98ce94f10ce3b87$var$isOrType(t) {
    return Array.isArray(t) || t.prim === 'or';
}
function $a98ce94f10ce3b87$export$d1db0bdebeb6f9c7(src) {
    if ($a98ce94f10ce3b87$var$isContract(src)) {
        const param = $a98ce94f10ce3b87$export$8df01cc5695a993c(src, 'parameter');
        const ch = $a98ce94f10ce3b87$export$d1db0bdebeb6f9c7(param.args[0]);
        const a = $a98ce94f10ce3b87$var$unpackAnnotations(param);
        return a.f ? [
            [
                a.f[0],
                param.args[0]
            ],
            ...ch
        ] : ch;
    }
    if ($a98ce94f10ce3b87$var$isOrType(src)) {
        const args = $a98ce94f10ce3b87$var$typeArgs(src);
        const getArg = (n)=>{
            const a = $a98ce94f10ce3b87$var$unpackAnnotations(args[n]);
            if ($a98ce94f10ce3b87$var$typeID(args[n]) === 'or') {
                const ch = $a98ce94f10ce3b87$export$d1db0bdebeb6f9c7(args[n]);
                return a.f ? [
                    [
                        a.f[0],
                        args[n]
                    ],
                    ...ch
                ] : ch;
            }
            return a.f ? [
                [
                    a.f[0],
                    args[n]
                ]
            ] : [];
        };
        return [
            ...getArg(0),
            ...getArg(1)
        ];
    }
    return [];
}
// Contract validation
function $a98ce94f10ce3b87$export$c8575dc38549dc3a(contract, ctx) {
    const assertSection = (parameter, storage, ret, code)=>{
        $a98ce94f10ce3b87$export$1244433858b68826(parameter, true);
        $a98ce94f10ce3b87$export$1244433858b68826(storage);
        const arg = {
            prim: 'pair',
            args: [
                Object.assign(Object.assign({}, parameter), {
                    annots: [
                        '@parameter'
                    ]
                }),
                Object.assign(Object.assign({}, storage), {
                    annots: [
                        '@storage'
                    ]
                })
            ]
        };
        const out = $a98ce94f10ce3b87$var$functionTypeInternal(code, [
            arg
        ], Object.assign(Object.assign({}, ctx), {
            contract: contract
        }));
        if ('failed' in out) return out;
        try {
            $a98ce94f10ce3b87$var$assertStacksEqual(out, [
                ret
            ]);
        } catch (err) {
            if (err instanceof $a98ce94f10ce3b87$export$61ae7f08643aa181) throw new $a98ce94f10ce3b87$export$4077f6a2bcdec605(code, out, err.message);
            else throw err;
        }
        return out;
    };
    const parameter = $a98ce94f10ce3b87$export$8df01cc5695a993c(contract, 'parameter').args[0];
    const storage = $a98ce94f10ce3b87$export$8df01cc5695a993c(contract, 'storage').args[0];
    const code = $a98ce94f10ce3b87$export$8df01cc5695a993c(contract, 'code').args[0];
    const expected = {
        prim: 'pair',
        args: [
            {
                prim: 'list',
                args: [
                    {
                        prim: 'operation'
                    }
                ]
            },
            storage
        ]
    };
    const ret = assertSection(parameter, storage, expected, code);
    for (const view of Object.values($a98ce94f10ce3b87$export$579f744ea06231e6(contract)))assertSection(view.args[1], storage, view.args[2], view.args[3]);
    return ret;
}
// Exported wrapper functions
function $a98ce94f10ce3b87$export$bfa000df77e731bb(d, t, ctx) {
    $a98ce94f10ce3b87$export$1244433858b68826(t);
    $a98ce94f10ce3b87$var$assertDataValidInternal(d, t, ctx || null);
}
function $a98ce94f10ce3b87$export$6c6e04233ab45653(inst, stack, ctx) {
    for (const t of stack)$a98ce94f10ce3b87$export$1244433858b68826(t);
    if ((ctx === null || ctx === void 0 ? void 0 : ctx.contract) !== undefined) for (const typesec of [
        'parameter',
        'storage'
    ]){
        const sec = $a98ce94f10ce3b87$export$8df01cc5695a993c(ctx.contract, typesec).args[0];
        $a98ce94f10ce3b87$export$1244433858b68826(sec);
    }
    return $a98ce94f10ce3b87$var$functionTypeInternal(inst, stack, ctx || null);
}
function $a98ce94f10ce3b87$export$9a1889dd325b72ec(a, b, field = false) {
    if (Array.isArray(a)) {
        // type guards don't work for parametrized generic types
        for (const v of a)$a98ce94f10ce3b87$export$1244433858b68826(v);
        for (const v of b)$a98ce94f10ce3b87$export$1244433858b68826(v);
    } else {
        $a98ce94f10ce3b87$export$1244433858b68826(a);
        $a98ce94f10ce3b87$export$1244433858b68826(b);
    }
    $a98ce94f10ce3b87$var$assertScalarTypesEqual(a, b, field);
}
function $a98ce94f10ce3b87$export$ffb78e2356513436(t, field = false) {
    try {
        $a98ce94f10ce3b87$export$1244433858b68826(t, field);
        return true;
    } catch (_a) {
        return false;
    }
}
function $a98ce94f10ce3b87$export$934c96dee53ab2da(contract, ctx) {
    try {
        return $a98ce94f10ce3b87$export$c8575dc38549dc3a(contract, ctx);
    } catch (_a) {
        return null;
    }
}
function $a98ce94f10ce3b87$export$29c430453b4c95e0(d, t, ctx) {
    try {
        $a98ce94f10ce3b87$export$bfa000df77e731bb(d, t, ctx);
        return true;
    } catch (_a) {
        return false;
    }
}
function $a98ce94f10ce3b87$export$3b6f3791234881ee(a, b, field = false) {
    try {
        $a98ce94f10ce3b87$export$9a1889dd325b72ec(a, b, field);
        return true;
    } catch (_a) {
        return false;
    }
}
class $a98ce94f10ce3b87$export$8517d80acf00e19a {
    constructor(contract, opt){
        this.contract = contract;
        this.ctx = Object.assign({
            contract: contract
        }, opt);
        this.output = $a98ce94f10ce3b87$export$c8575dc38549dc3a(contract, this.ctx);
    }
    static parse(src, opt) {
        const p = new $a98ce94f10ce3b87$export$7acfa6ed01010e37(opt);
        const expr = typeof src === 'string' ? p.parseScript(src) : p.parseJSON(src);
        if (expr === null) throw new $a98ce94f10ce3b87$var$InvalidMichelsonError('empty Michelson');
        if ($a98ce94f10ce3b87$export$ac03cc731bd7a006(expr)) return new $a98ce94f10ce3b87$export$8517d80acf00e19a(expr, opt);
    }
    static parseTypeExpression(src, opt) {
        const p = new $a98ce94f10ce3b87$export$7acfa6ed01010e37(opt);
        const expr = typeof src === 'string' ? p.parseScript(src) : p.parseJSON(src);
        if (expr === null) throw new $a98ce94f10ce3b87$var$InvalidTypeExpressionError('empty type expression');
        // remove assertTypeAnnotationsValid from if block because: () => void || throw error
        if ($a98ce94f10ce3b87$export$176936cdb34aed2f(expr)) {
            $a98ce94f10ce3b87$export$1244433858b68826(expr);
            return expr;
        }
    }
    static parseDataExpression(src, opt) {
        const p = new $a98ce94f10ce3b87$export$7acfa6ed01010e37(opt);
        const expr = typeof src === 'string' ? p.parseScript(src) : p.parseJSON(src);
        if (expr === null) throw new $a98ce94f10ce3b87$var$InvalidDataExpressionError('empty data expression');
        if ($a98ce94f10ce3b87$export$3cc4ed4ae67ac731(expr)) return expr;
        throw undefined;
    }
    section(section) {
        return $a98ce94f10ce3b87$export$8df01cc5695a993c(this.contract, section);
    }
    entryPoints() {
        return $a98ce94f10ce3b87$export$d1db0bdebeb6f9c7(this.contract);
    }
    entryPoint(ep) {
        return $a98ce94f10ce3b87$export$7755930f2db79bc5(this.contract, ep);
    }
    assertDataValid(d, t) {
        $a98ce94f10ce3b87$export$bfa000df77e731bb(d, t, this.ctx);
    }
    isDataValid(d, t) {
        return $a98ce94f10ce3b87$export$29c430453b4c95e0(d, t, this.ctx);
    }
    assertParameterValid(ep, d) {
        const t = this.entryPoint(ep || undefined);
        if (t === null) throw new $a98ce94f10ce3b87$var$InvalidEntrypointError(ep === null || ep === void 0 ? void 0 : ep.toString());
        this.assertDataValid(d, t);
    }
    isParameterValid(ep, d) {
        try {
            this.assertParameterValid(ep, d);
            return true;
        } catch (_a) {
            return false;
        }
    }
    functionType(inst, stack) {
        return $a98ce94f10ce3b87$export$6c6e04233ab45653(inst, stack, this.ctx);
    }
}
// TODO: dummyContract not used anywhere in the codebase can be deleted?
const $a98ce94f10ce3b87$export$29db4a2abc9c69d0 = new $a98ce94f10ce3b87$export$8517d80acf00e19a([
    {
        prim: 'parameter',
        args: [
            {
                prim: 'unit'
            }
        ]
    },
    {
        prim: 'storage',
        args: [
            {
                prim: 'unit'
            }
        ]
    },
    {
        prim: 'code',
        args: [
            [
                {
                    prim: 'CAR'
                },
                {
                    prim: 'NIL',
                    args: [
                        {
                            prim: 'operation'
                        }
                    ]
                },
                {
                    prim: 'PAIR'
                }
            ]
        ]
    }
]);
function $a98ce94f10ce3b87$export$e494c4e6706dd74d(s) {
    if ('failed' in s) return `[FAILED: ${$a98ce94f10ce3b87$export$613fc3a7f2c0f56c(s.failed)}]`;
    return s.map((v, i)=>{
        const ann = $a98ce94f10ce3b87$var$unpackAnnotations(v);
        return `[${i}${ann.v ? '/' + ann.v[0] : ''}]: ${$a98ce94f10ce3b87$export$613fc3a7f2c0f56c(v)}`;
    }).join('\n');
}
function $a98ce94f10ce3b87$export$7bac1955562dedc2(blocks, cb) {
    return (v)=>{
        var _a;
        if (Array.isArray(v) && !blocks) return;
        const macro = (_a = v.op[$a98ce94f10ce3b87$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.macro;
        const msg = `${macro ? 'Macro' : 'Op'}: ${macro ? $a98ce94f10ce3b87$export$613fc3a7f2c0f56c(macro, undefined, true) + ' / ' : ''}${$a98ce94f10ce3b87$export$613fc3a7f2c0f56c(v.op)}
Input:
${$a98ce94f10ce3b87$export$e494c4e6706dd74d(v.in)}
Output:
${$a98ce94f10ce3b87$export$e494c4e6706dd74d(v.out)}
`;
        cb(msg);
    };
}
function $a98ce94f10ce3b87$export$7b5b869ee98c16ab(err) {
    var _a;
    if (err instanceof $a98ce94f10ce3b87$export$4077f6a2bcdec605) {
        const macro = (_a = err.val[$a98ce94f10ce3b87$export$ad6cc7932321c4f3]) === null || _a === void 0 ? void 0 : _a.macro;
        return `${macro ? 'Macro' : 'Op'}: ${macro ? $a98ce94f10ce3b87$export$613fc3a7f2c0f56c(macro, undefined, true) + ' / ' : ''}${$a98ce94f10ce3b87$export$613fc3a7f2c0f56c(err.val)}
Stack:
${$a98ce94f10ce3b87$export$e494c4e6706dd74d(err.stackState)}
`;
    } else if (err instanceof $a98ce94f10ce3b87$export$c9afdd965e51c08a) {
        const type = Array.isArray(err.val) ? '[' + err.val.map((v, i)=>`[${i}]: ${$a98ce94f10ce3b87$export$613fc3a7f2c0f56c(v)}`).join('; ') + ']' : $a98ce94f10ce3b87$export$613fc3a7f2c0f56c(err.val);
        return `Type: ${type}
${err.data ? `Data: ${$a98ce94f10ce3b87$export$613fc3a7f2c0f56c(err.data)}
` : ''}
`;
    } else return `Value: ${$a98ce94f10ce3b87$export$613fc3a7f2c0f56c(err.val)}`;
}
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $a98ce94f10ce3b87$export$a4ad2735b021c132 = {
    "commitHash": "6a2c52b9e48b299dfc856149c1fa3388e77180ad",
    "version": "22.0.0"
};



// ==========================================================================================
// parent error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Parent error class all taquito errors to extend from
 */ class $6cde2a3388731e1b$export$e5619b407b1c8b0a extends Error {
}
/**
 *  @category Error
 *  @description Error that indicates invalid user inputs
 */ class $6cde2a3388731e1b$export$9d3f3bc8b6d48950 extends $6cde2a3388731e1b$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error returned by RPC node
 */ class $6cde2a3388731e1b$export$5460eff990f31920 extends $6cde2a3388731e1b$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates TezosToolKit has not been configured appropriately
 */ class $6cde2a3388731e1b$export$32f4d70b2fb302b1 extends $6cde2a3388731e1b$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates a requested action is not supported by Taquito
 */ class $6cde2a3388731e1b$export$34bc216509d47ce6 extends $6cde2a3388731e1b$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error during a network operation
 */ class $6cde2a3388731e1b$export$bae979e68e4dc802 extends $6cde2a3388731e1b$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates user attempts an action without necessary permissions
 */ class $6cde2a3388731e1b$export$9c81d48c1e1840ac extends $6cde2a3388731e1b$export$e5619b407b1c8b0a {
}
// ==========================================================================================
// common error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Error that indicates an invalid originated or implicit address being passed or used
 */ class $6cde2a3388731e1b$export$66c44d927ffead98 extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidAddressError';
        this.message = `Invalid address "${address}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
class $6cde2a3388731e1b$export$be6cb9338b7137e0 extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidStakingAddressError';
        this.message = `Invalid staking address "${address}", you can only set destination as your own address`;
    }
}
class $6cde2a3388731e1b$export$1623a856d8b6cc2a extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidFinalizeUnstakeAmountError';
        this.message = `The amount can only be 0 when finalizing an unstake`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid block hash being passed or used
 */ class $6cde2a3388731e1b$export$16fabd343bcdfd7b extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(blockHash, errorDetail){
        super();
        this.blockHash = blockHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidBlockHashError';
        this.message = `Invalid block hash "${blockHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid amount of tez being passed as a parameter
 */ class $6cde2a3388731e1b$export$d8bf6d22cce8e288 extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(amount){
        super();
        this.amount = amount;
        this.name = 'InvalidAmountError';
        this.message = `Invalid amount "${amount}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid derivation path being passed or used
 */ class $6cde2a3388731e1b$export$522ca3df7030c309 extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(derivationPath, errorDetail){
        super();
        this.derivationPath = derivationPath;
        this.errorDetail = errorDetail;
        this.name = 'InvalidDerivationPathError';
        this.message = `Invalid derivation path "${derivationPath}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid hex string have been passed or used
 */ class $6cde2a3388731e1b$export$1888d6928c74d5ee extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(hexString, errorDetail){
        super();
        this.hexString = hexString;
        this.errorDetail = errorDetail;
        this.name = 'InvalidHexStringError';
        this.message = `Invalid hex string "${hexString}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid message being passed or used
 */ class $6cde2a3388731e1b$export$a5124d7665e9d8ad extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(msg, errorDetail){
        super();
        this.msg = msg;
        this.errorDetail = errorDetail;
        this.name = 'InvalidMessageError';
        this.message = `Invalid message "${msg}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid view parameter of a smart contract
 */ class $6cde2a3388731e1b$export$f9ce6a924724628b extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(viewName, sigs, args, cause){
        super();
        this.viewName = viewName;
        this.sigs = sigs;
        this.args = args;
        this.cause = cause;
        this.name = 'InvalidViewParameterError';
        this.message = `Invalid view arguments ${JSON.stringify(args)} received for name "${viewName}" expecting one of the following signatures ${JSON.stringify(sigs)}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid private key being passed or used
 */ class $6cde2a3388731e1b$export$adf223add86ae0aa extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(errorDetail){
        super();
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyError';
        this.message = `Invalid private key`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an Invalid Public Key being passed or used
 */ class $6cde2a3388731e1b$export$f675822ed489f01f extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(publicKey, errorDetail){
        super();
        this.publicKey = publicKey;
        this.errorDetail = errorDetail;
        this.name = 'InvalidPublicKeyError';
        this.message = `Invalid public key "${publicKey}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid signature being passed or used
 */ class $6cde2a3388731e1b$export$ccc2f68ef106615a extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(signature, errorDetail){
        super();
        this.signature = signature;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSignatureError';
        this.message = `Invalid signature "${signature}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid contract address being passed or used
 */ class $6cde2a3388731e1b$export$193774326795229b extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(contractAddress, errorDetail){
        super();
        this.contractAddress = contractAddress;
        this.errorDetail = errorDetail;
        this.name = 'InvalidContractAddressError';
        this.message = `Invalid contract address "${contractAddress}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid chain id being passed or used
 */ class $6cde2a3388731e1b$export$4836eb835ffca5b2 extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(chainId, errorDetail){
        super();
        this.chainId = chainId;
        this.errorDetail = errorDetail;
        this.name = 'InvalidChainIdError';
        this.message = `Invalid chain id "${chainId}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid public key hash being passed or used
 */ class $6cde2a3388731e1b$export$a3d7df0ca9d9410c extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(keyHash, errorDetail){
        super();
        this.keyHash = keyHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyHashError';
        this.message = `Invalid public key hash "${keyHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation hash being passed or used
 */ class $6cde2a3388731e1b$export$1a1c2023d3ec7a8a extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(operationHash, errorDetail){
        super();
        this.operationHash = operationHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationHashError';
        this.message = `Invalid operation hash "${operationHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation kind being passed or used
 */ class $6cde2a3388731e1b$export$bc5be87550569b55 extends $6cde2a3388731e1b$export$9d3f3bc8b6d48950 {
    constructor(operationKind, errorDetail){
        super();
        this.operationKind = operationKind;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationKindError';
        this.message = `Invalid operation kind "${operationKind}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description General error that indicates something is no longer supported and/or deprecated
 */ class $6cde2a3388731e1b$export$11034991807c583d extends $6cde2a3388731e1b$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'DeprecationError';
    }
}
/**
 *  @category Error
 *  @description General error that indicates an action is prohibited or not allowed
 */ class $6cde2a3388731e1b$export$4041d915d9096adf extends $6cde2a3388731e1b$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ProhibitedActionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure in grabbing the public key
 */ class $6cde2a3388731e1b$export$183b043cd3c947f9 extends $6cde2a3388731e1b$export$e5619b407b1c8b0a {
    constructor(pkh, cause){
        super();
        this.pkh = pkh;
        this.cause = cause;
        this.name = 'PublicKeyNotFoundError';
        this.message = `Public key not found of this address "${pkh}" in either wallet or contract API.`;
    }
}




var $6ZWSX = parcelRequire("6ZWSX");
var $02a40dc8333f1de2$require$Buffer = $6ZWSX.Buffer;
const $02a40dc8333f1de2$var$toHexString = (bytes)=>bytes.reduce((str, byte)=>str + byte.toString(16).padStart(2, '0'), '');
const $02a40dc8333f1de2$var$pad = (num, paddingLen = 8)=>{
    return num.toString(16).padStart(paddingLen, '0');
};
/*
 * Some code in this file is originally from sotez
 * Copyright (c) 2018 Andrew Kishino
 */ // See: https://tezos.gitlab.io/protocols/005_babylon.html#transactions-now-have-an-entrypoint
const $02a40dc8333f1de2$var$ENTRYPOINT_MAX_LENGTH$1 = 31;
var $02a40dc8333f1de2$export$9a139b626817ea5b;
(function(CODEC) {
    CODEC["SECRET"] = "secret";
    CODEC["RAW"] = "raw";
    CODEC["TZ1"] = "tz1";
    CODEC["BRANCH"] = "branch";
    CODEC["ZARITH"] = "zarith";
    CODEC["PUBLIC_KEY"] = "public_key";
    CODEC["PKH"] = "pkh";
    CODEC["PKH_ARR"] = "pkhArr";
    CODEC["DELEGATE"] = "delegate";
    CODEC["SCRIPT"] = "script";
    CODEC["BALLOT_STATEMENT"] = "ballotStmt";
    CODEC["PROPOSAL"] = "proposal";
    CODEC["PROPOSAL_ARR"] = "proposalArr";
    CODEC["INT32"] = "int32";
    CODEC["INT16"] = "int16";
    CODEC["PARAMETERS"] = "parameters";
    CODEC["ADDRESS"] = "address";
    CODEC["SMART_CONTRACT_ADDRESS"] = "smart_contract_address";
    CODEC["SMART_ROLLUP_ADDRESS"] = "smart_rollup_address";
    CODEC["SMART_ROLLUP_COMMITMENT_HASH"] = "smart_rollup_commitment_hash";
    CODEC["VALUE"] = "value";
    CODEC["PADDED_BYTES"] = "padded_bytes";
    CODEC["SMART_ROLLUP_MESSAGE"] = "smart_rollup_message";
    CODEC["MANAGER"] = "manager";
    CODEC["BLOCK_PAYLOAD_HASH"] = "blockPayloadHash";
    CODEC["ENTRYPOINT"] = "entrypoint";
    CODEC["OPERATION"] = "operation";
    CODEC["OP_ACTIVATE_ACCOUNT"] = "activate_account";
    CODEC["OP_DELEGATION"] = "delegation";
    CODEC["OP_TRANSACTION"] = "transaction";
    CODEC["OP_ORIGINATION"] = "origination";
    CODEC["OP_BALLOT"] = "ballot";
    CODEC["OP_FAILING_NOOP"] = "failing_noop";
    CODEC["OP_ATTESTATION"] = "attestation";
    CODEC["OP_ATTESTATION_WITH_DAL"] = "attestation_with_dal";
    CODEC["OP_SEED_NONCE_REVELATION"] = "seed_nonce_revelation";
    CODEC["OP_REVEAL"] = "reveal";
    CODEC["OP_PROPOSALS"] = "proposals";
    CODEC["OP_REGISTER_GLOBAL_CONSTANT"] = "register_global_constant";
    CODEC["OP_TRANSFER_TICKET"] = "transfer_ticket";
    CODEC["BURN_LIMIT"] = "burn_limit";
    CODEC["OP_INCREASE_PAID_STORAGE"] = "increase_paid_storage";
    CODEC["OP_UPDATE_CONSENSUS_KEY"] = "update_consensus_key";
    CODEC["SIGNATURE_PROOF"] = "signature_proof";
    CODEC["OP_DRAIN_DELEGATE"] = "drain_delegate";
    CODEC["DEPOSITS_LIMIT"] = "deposits_limit";
    CODEC["OP_SET_DEPOSITS_LIMIT"] = "set_deposits_limit";
    CODEC["OP_SMART_ROLLUP_ORIGINATE"] = "smart_rollup_originate";
    CODEC["PVM_KIND"] = "pvm_kind";
    CODEC["OP_SMART_ROLLUP_ADD_MESSAGES"] = "smart_rollup_add_messages";
    CODEC["OP_SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE"] = "smart_rollup_execute_outbox_message";
    CODEC["OP_DAL_PUBLISH_COMMITMENT"] = "dal_publish_commitment";
    CODEC["SLOT_HEADER"] = "slot_header";
})($02a40dc8333f1de2$export$9a139b626817ea5b || ($02a40dc8333f1de2$export$9a139b626817ea5b = {}));
// See https://tezos.gitlab.io/shell/p2p_api.html#alpha-michelson-v1-primitives-enumeration-unsigned-8-bit-integer
const $02a40dc8333f1de2$export$db07a1141a5b36ad = {
    '00': 'parameter',
    '01': 'storage',
    '02': 'code',
    '03': 'False',
    '04': 'Elt',
    '05': 'Left',
    '06': 'None',
    '07': 'Pair',
    '08': 'Right',
    '09': 'Some',
    '0a': 'True',
    '0b': 'Unit',
    '0c': 'PACK',
    '0d': 'UNPACK',
    '0e': 'BLAKE2B',
    '0f': 'SHA256',
    '10': 'SHA512',
    '11': 'ABS',
    '12': 'ADD',
    '13': 'AMOUNT',
    '14': 'AND',
    '15': 'BALANCE',
    '16': 'CAR',
    '17': 'CDR',
    '18': 'CHECK_SIGNATURE',
    '19': 'COMPARE',
    '1a': 'CONCAT',
    '1b': 'CONS',
    '1c': 'CREATE_ACCOUNT',
    '1d': 'CREATE_CONTRACT',
    '1e': 'IMPLICIT_ACCOUNT',
    '1f': 'DIP',
    '20': 'DROP',
    '21': 'DUP',
    '22': 'EDIV',
    '23': 'EMPTY_MAP',
    '24': 'EMPTY_SET',
    '25': 'EQ',
    '26': 'EXEC',
    '27': 'FAILWITH',
    '28': 'GE',
    '29': 'GET',
    '2a': 'GT',
    '2b': 'HASH_KEY',
    '2c': 'IF',
    '2d': 'IF_CONS',
    '2e': 'IF_LEFT',
    '2f': 'IF_NONE',
    '30': 'INT',
    '31': 'LAMBDA',
    '32': 'LE',
    '33': 'LEFT',
    '34': 'LOOP',
    '35': 'LSL',
    '36': 'LSR',
    '37': 'LT',
    '38': 'MAP',
    '39': 'MEM',
    '3a': 'MUL',
    '3b': 'NEG',
    '3c': 'NEQ',
    '3d': 'NIL',
    '3e': 'NONE',
    '3f': 'NOT',
    '40': 'NOW',
    '41': 'OR',
    '42': 'PAIR',
    '43': 'PUSH',
    '44': 'RIGHT',
    '45': 'SIZE',
    '46': 'SOME',
    '47': 'SOURCE',
    '48': 'SENDER',
    '49': 'SELF',
    '4a': 'STEPS_TO_QUOTA',
    '4b': 'SUB',
    '4c': 'SWAP',
    '4d': 'TRANSFER_TOKENS',
    '4e': 'SET_DELEGATE',
    '4f': 'UNIT',
    '50': 'UPDATE',
    '51': 'XOR',
    '52': 'ITER',
    '53': 'LOOP_LEFT',
    '54': 'ADDRESS',
    '55': 'CONTRACT',
    '56': 'ISNAT',
    '57': 'CAST',
    '58': 'RENAME',
    '59': 'bool',
    '5a': 'contract',
    '5b': 'int',
    '5c': 'key',
    '5d': 'key_hash',
    '5e': 'lambda',
    '5f': 'list',
    '60': 'map',
    '61': 'big_map',
    '62': 'nat',
    '63': 'option',
    '64': 'or',
    '65': 'pair',
    '66': 'set',
    '67': 'signature',
    '68': 'string',
    '69': 'bytes',
    '6a': 'mutez',
    '6b': 'timestamp',
    '6c': 'unit',
    '6d': 'operation',
    '6e': 'address',
    '6f': 'SLICE',
    '70': 'DIG',
    '71': 'DUG',
    '72': 'EMPTY_BIG_MAP',
    '73': 'APPLY',
    '74': 'chain_id',
    '75': 'CHAIN_ID',
    '76': 'LEVEL',
    '77': 'SELF_ADDRESS',
    '78': 'never',
    '79': 'NEVER',
    '7a': 'UNPAIR',
    '7b': 'VOTING_POWER',
    '7c': 'TOTAL_VOTING_POWER',
    '7d': 'KECCAK',
    '7e': 'SHA3',
    '7f': 'PAIRING_CHECK',
    '80': 'bls12_381_g1',
    '81': 'bls12_381_g2',
    '82': 'bls12_381_fr',
    '83': 'sapling_state',
    '84': 'sapling_transaction_deprecated',
    '85': 'SAPLING_EMPTY_STATE',
    '86': 'SAPLING_VERIFY_UPDATE',
    '87': 'ticket',
    '88': 'TICKET_DEPRECATED',
    '89': 'READ_TICKET',
    '8a': 'SPLIT_TICKET',
    '8b': 'JOIN_TICKETS',
    '8c': 'GET_AND_UPDATE',
    '8d': 'chest',
    '8e': 'chest_key',
    '8f': 'OPEN_CHEST',
    '90': 'VIEW',
    '91': 'view',
    '92': 'constant',
    '93': 'SUB_MUTEZ',
    '94': 'tx_rollup_l2_address',
    '95': 'MIN_BLOCK_TIME',
    '96': 'sapling_transaction',
    '97': 'EMIT',
    '98': 'Lambda_rec',
    '99': 'LAMBDA_REC',
    '9a': 'TICKET',
    '9b': 'BYTES',
    '9c': 'NAT',
    '9d': 'Ticket'
};
const $02a40dc8333f1de2$export$dc55b1858372fe66 = (()=>{
    const result = {};
    Object.keys($02a40dc8333f1de2$export$db07a1141a5b36ad).forEach((key)=>{
        result[$02a40dc8333f1de2$export$db07a1141a5b36ad[key]] = key;
    });
    return result;
})();
// See https://tezos.gitlab.io/shell/p2p_api.html
const $02a40dc8333f1de2$var$kindMapping$1 = {
    0x04: 'activate_account',
    0x6b: 'reveal',
    0x6e: 'delegation',
    0x6c: 'transaction',
    0x6d: 'origination',
    0x06: 'ballot',
    0x15: 'attestation',
    0x17: 'attestation_with_dal',
    0x01: 'seed_nonce_revelation',
    0x05: 'proposals',
    0x6f: 'register_global_constant',
    0x9e: 'transfer_ticket',
    0x70: 'set_deposits_limit',
    0x71: 'increase_paid_storage',
    0x72: 'update_consensus_key',
    0x09: 'drain_delegate',
    0xc8: 'smart_rollup_originate',
    0xc9: 'smart_rollup_add_messages',
    0xce: 'smart_rollup_execute_outbox_message',
    0xe6: 'dal_publish_commitment',
    0x11: 'failing_noop'
};
const $02a40dc8333f1de2$var$kindMappingReverse$1 = (()=>{
    const result = {};
    Object.keys($02a40dc8333f1de2$var$kindMapping$1).forEach((key)=>{
        const keyNum = typeof key === 'string' ? parseInt(key, 10) : key;
        result[$02a40dc8333f1de2$var$kindMapping$1[keyNum]] = $02a40dc8333f1de2$var$pad(keyNum, 2);
    });
    return result;
})();
// See https://tezos.gitlab.io/protocols/005_babylon.html#transactions-now-have-an-entrypoint
const $02a40dc8333f1de2$var$entrypointMapping$1 = {
    '00': 'default',
    '01': 'root',
    '02': 'do',
    '03': 'set_delegate',
    '04': 'remove_delegate',
    '05': 'deposit',
    '06': 'stake',
    '07': 'unstake',
    '08': 'finalize_unstake',
    '09': 'set_delegate_parameters'
};
const $02a40dc8333f1de2$var$entrypointMappingReverse$1 = (()=>{
    const result = {};
    Object.keys($02a40dc8333f1de2$var$entrypointMapping$1).forEach((key)=>{
        result[$02a40dc8333f1de2$var$entrypointMapping$1[key]] = key;
    });
    return result;
})();
/**
 *  @category Error
 *  @description Error that indicates an invalid operation content being passed or used
 */ class $02a40dc8333f1de2$var$InvalidOperationSchemaError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(operation, errorDetail){
        super();
        this.operation = operation;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationSchemaError';
        this.message = `Invalid operation content recevied`;
        errorDetail && (this.message += ` ${errorDetail}.`);
    }
}
/**
 *  @category Error
 *  @description Error that indicates an entrypoint name exceeding maximum length
 */ class $02a40dc8333f1de2$var$OversizedEntryPointError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(entrypoint){
        super();
        this.entrypoint = entrypoint;
        this.name = 'OversizedEntryPointError';
        this.message = `Invalid entrypoint length "${entrypoint.length}", maximum length is "${$02a40dc8333f1de2$var$ENTRYPOINT_MAX_LENGTH$1}".`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid ballot value being used
 */ class $02a40dc8333f1de2$var$InvalidBallotValueError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(ballotValue){
        super();
        this.ballotValue = ballotValue;
        this.name = 'InvalidBallotValueError';
        this.message = `Invalid ballot value "${ballotValue}" expecting one of the following: "yay", "nay", "pass".`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when trying to decode ballot value
 */ class $02a40dc8333f1de2$var$DecodeBallotValueError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(ballotValue){
        super();
        this.ballotValue = ballotValue;
        this.name = 'DecodeBallotValueError';
        this.message = `Invalid ballot value "${ballotValue}", cannot be decoded.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates unexpected Michelson Value being passed or used
 */ class $02a40dc8333f1de2$var$UnexpectedMichelsonValueError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(value){
        super();
        this.value = value;
        this.name = 'UnexpectedMichelsonValueError';
        this.message = `Invalid Michelson value "${value}", unalbe to encode.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when trying to decode an operation
 */ class $02a40dc8333f1de2$var$OperationDecodingError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'OperationDecodingError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when trying to encode an operation
 */ class $02a40dc8333f1de2$var$OperationEncodingError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'OperationEncodingError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an unsupported operation being passed or used
 */ class $02a40dc8333f1de2$var$UnsupportedOperationError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(op){
        super();
        this.op = op;
        this.name = 'UnsupportedOperationError';
        this.message = `Unsupported operation "${op}", can submit an issue on our github for feature request.`;
    }
}
/**
 * @cateogry Error
 * @description Error that indicates an unsupported pvm being passed or used
 */ class $02a40dc8333f1de2$var$UnsupportedPvmKindError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(pvm){
        super();
        this.pvm = pvm;
        this.name = 'UnsupportedPvmKindError';
        this.message = `Invalid Pvm kind "${pvm}" expecting either "arith" or "wasm_2_0_0".`;
    }
}
/**
 * @category Error
 * @description Error that indicates an unsupported pvm to decode
 */ class $02a40dc8333f1de2$var$DecodePvmKindError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(pvm){
        super();
        this.pvm = pvm;
        this.name = 'DecodePvmKindError';
        this.message = `Invalid Pvm kind "${pvm}", cannot be decoded.`;
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid Smart Rollup Address (sr1)
 */ class $02a40dc8333f1de2$var$InvalidSmartRollupAddressError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSmartRollupAddress';
        this.message = `Invalid smart rollup address "${address}"`;
        errorDetail && (this.message += ` ${errorDetail}.`);
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid Smart Rollup commitment hash (src1)
 */ class $02a40dc8333f1de2$var$InvalidSmartRollupCommitmentHashError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(hash, errorDetail){
        super();
        this.hash = hash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSmartRollupCommitmentHashError';
        this.message = `Invalid smart rollup commitment hash "${hash}"`;
        errorDetail && (this.message += ` ${errorDetail}.`);
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid dal commitment (sh)
 */ class $02a40dc8333f1de2$var$InvalidDalCommitmentError extends (0, $6cde2a3388731e1b$export$9d3f3bc8b6d48950) {
    constructor(commitment, errorDetail){
        super();
        this.commitment = commitment;
        this.errorDetail = errorDetail;
        this.name = 'InvalidDalCommitmentError';
        this.message = `Invalid dal commitment "${commitment}"`;
        errorDetail && (this.message += ` ${errorDetail}.`);
    }
}
class $02a40dc8333f1de2$export$2ea09c189c142295 {
    static fromHexString(hex) {
        const lowHex = hex.toLowerCase();
        if (/^(([a-f]|\d){2})*$/.test(lowHex)) {
            const arr = new Uint8Array((lowHex.match(/([a-z]|\d){2}/g) || []).map((byte)=>parseInt(byte, 16)));
            return new $02a40dc8333f1de2$export$2ea09c189c142295(arr);
        } else throw new (0, $6cde2a3388731e1b$export$1888d6928c74d5ee)(lowHex);
    }
    constructor(arr, offset = 0){
        this.arr = arr;
        this.offset = offset;
    }
    consume(count) {
        const subArr = this.arr.subarray(this.offset, this.offset + count);
        this.offset += count;
        return subArr;
    }
    get(idx) {
        return this.arr[this.offset + idx];
    }
    length() {
        return this.arr.length - this.offset;
    }
    slice(start, end) {
        return new $02a40dc8333f1de2$export$2ea09c189c142295(this.arr.slice(start, end));
    }
}
const $02a40dc8333f1de2$var$isPrim = (value)=>{
    return 'prim' in value;
};
const $02a40dc8333f1de2$var$isBytes = (value)=>{
    return 'bytes' in value && typeof value.bytes === 'string';
};
const $02a40dc8333f1de2$var$isString = (value)=>{
    return 'string' in value && typeof value.string === 'string';
};
const $02a40dc8333f1de2$var$isInt = (value)=>{
    return 'int' in value && typeof value.int === 'string';
};
const $02a40dc8333f1de2$var$scriptEncoder = (script)=>{
    const code = $02a40dc8333f1de2$var$valueEncoder(script.code);
    const storage = $02a40dc8333f1de2$var$valueEncoder(script.storage);
    return `${$02a40dc8333f1de2$var$pad(code.length / 2, 8)}${code}${$02a40dc8333f1de2$var$pad(storage.length / 2, 8)}${storage}`;
};
const $02a40dc8333f1de2$var$scriptDecoder = (value)=>{
    const code = $02a40dc8333f1de2$var$extractRequiredLen(value);
    const storage = $02a40dc8333f1de2$var$extractRequiredLen(value);
    return {
        code: $02a40dc8333f1de2$var$valueDecoder(new $02a40dc8333f1de2$export$2ea09c189c142295(code)),
        storage: $02a40dc8333f1de2$var$valueDecoder(new $02a40dc8333f1de2$export$2ea09c189c142295(storage))
    };
};
const $02a40dc8333f1de2$var$valueEncoder = (value)=>{
    if (Array.isArray(value)) {
        const encoded = value.map((x)=>$02a40dc8333f1de2$var$valueEncoder(x)).join('');
        const len = encoded.length / 2;
        return `02${$02a40dc8333f1de2$var$pad(len)}${encoded}`;
    } else if ($02a40dc8333f1de2$var$isPrim(value)) return $02a40dc8333f1de2$var$primEncoder(value);
    else if ($02a40dc8333f1de2$var$isBytes(value)) return $02a40dc8333f1de2$var$bytesEncoder(value);
    else if ($02a40dc8333f1de2$var$isString(value)) return $02a40dc8333f1de2$var$stringEncoder(value);
    else if ($02a40dc8333f1de2$var$isInt(value)) return $02a40dc8333f1de2$var$intEncoder(value);
    throw new $02a40dc8333f1de2$var$UnexpectedMichelsonValueError(JSON.stringify(value));
};
const $02a40dc8333f1de2$var$valueDecoder = (value)=>{
    const preamble = value.consume(1);
    switch(preamble[0]){
        case 0x0a:
            return $02a40dc8333f1de2$var$bytesDecoder(value);
        case 0x01:
            return $02a40dc8333f1de2$var$stringDecoder(value);
        case 0x00:
            return $02a40dc8333f1de2$var$intDecoder(value);
        case 0x02:
            {
                const val = new $02a40dc8333f1de2$export$2ea09c189c142295($02a40dc8333f1de2$var$extractRequiredLen(value));
                const results = [];
                while(val.length() > 0)results.push($02a40dc8333f1de2$var$valueDecoder(val));
                return results;
            }
        default:
            return $02a40dc8333f1de2$var$primDecoder(value, preamble);
    }
};
const $02a40dc8333f1de2$var$extractRequiredLen = (value, bytesLength = 4)=>{
    const len = value.consume(bytesLength);
    const valueLen = parseInt($02a40dc8333f1de2$require$Buffer.from(len).toString('hex'), 16);
    return value.consume(valueLen);
};
/**
 * @description parse bytes into multiple items of an array
 * @param value Uint8ArrayConsumer class of forged segment to parse
 * @param bytesLength default 4 bytes for length of variable bytes
 * @returns array of Uint8Array values for each array item
 */ const $02a40dc8333f1de2$var$stripLengthPrefixFromBytes = (value, bytesLength = 4)=>{
    const ret = [];
    let values = value;
    while(values.length()){
        const len = values.consume(bytesLength);
        const valueLen = parseInt($02a40dc8333f1de2$require$Buffer.from(len).toString('hex'), 16);
        ret.push(values.consume(valueLen));
        values = values.slice(valueLen + bytesLength);
    }
    return ret;
};
const $02a40dc8333f1de2$var$bytesEncoder = (value)=>{
    if (!/^([A-Fa-f0-9]{2})*$/.test(value.bytes)) throw new (0, $6cde2a3388731e1b$export$1888d6928c74d5ee)(value.bytes);
    const len = value.bytes.length / 2;
    return `0a${$02a40dc8333f1de2$var$pad(len)}${value.bytes}`;
};
const $02a40dc8333f1de2$var$bytesDecoder = (value)=>{
    const bytes = $02a40dc8333f1de2$var$extractRequiredLen(value);
    return {
        bytes: $02a40dc8333f1de2$require$Buffer.from(bytes).toString('hex')
    };
};
const $02a40dc8333f1de2$var$stringEncoder = (value)=>{
    const str = $02a40dc8333f1de2$require$Buffer.from(value.string, 'utf8').toString('hex');
    const hexLength = str.length / 2;
    return `01${$02a40dc8333f1de2$var$pad(hexLength)}${str}`;
};
const $02a40dc8333f1de2$var$stringDecoder = (value)=>{
    const str = $02a40dc8333f1de2$var$extractRequiredLen(value);
    return {
        string: $02a40dc8333f1de2$require$Buffer.from(str).toString('utf8')
    };
};
const $02a40dc8333f1de2$var$intEncoder = ({ int: int })=>{
    const num = new (0, $42f5864281cc433e$exports.BigNumber)(int, 10);
    const positiveMark = num.toString(2)[0] === '-' ? '1' : '0';
    const binary = num.toString(2).replace(/-/g, '');
    const pad = binary.length <= 6 ? 6 : (binary.length - 6) % 7 ? binary.length + 7 - (binary.length - 6) % 7 : binary.length;
    const splitted = binary.padStart(pad, '0').match(/\d{6,7}/g);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const reversed = splitted.reverse();
    reversed[0] = positiveMark + reversed[0];
    const numHex = reversed.map((x, i)=>// Add one to the last chunk
        parseInt((i === reversed.length - 1 ? '0' : '1') + x, 2).toString(16).padStart(2, '0'));
    return `00${numHex.join('')}`;
};
const $02a40dc8333f1de2$var$intDecoder = (value)=>{
    let c = value.consume(1)[0];
    const hexNumber = [];
    const isNotLastChunkMask = 128;
    while(c & isNotLastChunkMask){
        hexNumber.push(c);
        c = value.consume(1)[0];
    }
    hexNumber.push(c);
    const isNegative = !!(64 & hexNumber[0]);
    hexNumber[0] = hexNumber[0] & 127;
    const numBin = hexNumber.map((x, i)=>x.toString(2).slice(i === 0 ? -6 : -7).padStart(i === 0 ? 6 : 7, '0')).reverse();
    let num = new (0, $42f5864281cc433e$exports.BigNumber)(numBin.join(''), 2);
    if (isNegative) num = num.times(-1);
    return {
        int: num.toFixed()
    };
};
const $02a40dc8333f1de2$var$primEncoder = (value)=>{
    const hasAnnot = +Array.isArray(value.annots);
    const argsCount = Array.isArray(value.args) ? value.args.length : 0;
    // Specify the number of args max is 3 without annotation
    const preamble = $02a40dc8333f1de2$var$pad(Math.min(2 * argsCount + hasAnnot + 0x03, 9), 2);
    const op = $02a40dc8333f1de2$export$dc55b1858372fe66[value.prim];
    let encodedArgs = (value.args || []).map((arg)=>$02a40dc8333f1de2$var$valueEncoder(arg)).join('');
    const encodedAnnots = Array.isArray(value.annots) ? $02a40dc8333f1de2$var$encodeAnnots(value.annots) : '';
    if ((value.prim === 'LAMBDA' || value.prim === 'LAMBDA_REC') && argsCount) encodedArgs = $02a40dc8333f1de2$var$pad(encodedArgs.length / 2) + encodedArgs + $02a40dc8333f1de2$var$pad(0);
    if ((value.prim === 'pair' || value.prim === 'Pair') && argsCount > 2) encodedArgs = encodedAnnots === '' ? $02a40dc8333f1de2$var$pad(encodedArgs.length / 2) + encodedArgs + $02a40dc8333f1de2$var$pad(0) : $02a40dc8333f1de2$var$pad(encodedArgs.length / 2) + encodedArgs;
    if (value.prim === 'view' && value.args) encodedArgs = $02a40dc8333f1de2$var$pad(encodedArgs.length / 2) + encodedArgs + $02a40dc8333f1de2$var$pad(0);
    return `${preamble}${op}${encodedArgs}${encodedAnnots}`;
};
const $02a40dc8333f1de2$var$primDecoder = (value, preamble)=>{
    const hasAnnot = (preamble[0] - 0x03) % 2 === 1;
    let argsCount = Math.floor((preamble[0] - 0x03) / 2);
    const op = value.consume(1)[0].toString(16).padStart(2, '0');
    const result = {
        prim: $02a40dc8333f1de2$export$db07a1141a5b36ad[op]
    };
    if ($02a40dc8333f1de2$export$db07a1141a5b36ad[op] === 'LAMBDA' || $02a40dc8333f1de2$export$db07a1141a5b36ad[op] === 'LAMBDA_REC') value.consume(4);
    if ($02a40dc8333f1de2$export$db07a1141a5b36ad[op] === 'view') {
        if (argsCount != 0) return $02a40dc8333f1de2$var$primViewDecoder(value, result);
        else return result;
    }
    let combPairArgs;
    let combPairAnnots;
    if (($02a40dc8333f1de2$export$db07a1141a5b36ad[op] === 'pair' || $02a40dc8333f1de2$export$db07a1141a5b36ad[op] === 'Pair') && argsCount > 2) {
        combPairArgs = $02a40dc8333f1de2$var$decodeCombPair(value);
        argsCount = 0;
        combPairAnnots = $02a40dc8333f1de2$var$decodeAnnots(value);
    }
    const args = new Array(argsCount).fill(0).map(()=>$02a40dc8333f1de2$var$valueDecoder(value));
    if ($02a40dc8333f1de2$export$db07a1141a5b36ad[op] === 'LAMBDA' || $02a40dc8333f1de2$export$db07a1141a5b36ad[op] === 'LAMBDA_REC') value.consume(4);
    if (combPairArgs) result['args'] = combPairArgs;
    else if (args.length) result['args'] = args;
    if (combPairAnnots && combPairAnnots[0] !== '') result['annots'] = combPairAnnots;
    else if (hasAnnot) result['annots'] = $02a40dc8333f1de2$var$decodeAnnots(value);
    return result;
};
const $02a40dc8333f1de2$var$primViewDecoder = (value, result)=>{
    value.consume(4);
    result['args'] = new Array(4).fill(0).map(()=>$02a40dc8333f1de2$var$valueDecoder(value));
    value.consume(4);
    return result;
};
const $02a40dc8333f1de2$var$decodeCombPair = (val)=>{
    const array = new $02a40dc8333f1de2$export$2ea09c189c142295($02a40dc8333f1de2$var$extractRequiredLen(val));
    const args = [];
    while(array.length() > 0)args.push($02a40dc8333f1de2$var$valueDecoder(array));
    return args;
};
const $02a40dc8333f1de2$var$encodeAnnots = (value)=>{
    const mergedAnnot = value.map((x)=>{
        return $02a40dc8333f1de2$require$Buffer.from(x, 'utf8').toString('hex');
    }).join('20');
    const len = mergedAnnot.length / 2;
    return `${$02a40dc8333f1de2$var$pad(len)}${mergedAnnot}`;
};
const $02a40dc8333f1de2$var$decodeAnnots = (val)=>{
    const len = val.consume(4);
    const annotLen = parseInt($02a40dc8333f1de2$require$Buffer.from(len).toString('hex'), 16);
    const restOfAnnot = val.consume(annotLen);
    const restOfAnnotHex = $02a40dc8333f1de2$require$Buffer.from(restOfAnnot).toString('hex');
    return restOfAnnotHex.split('20').map((x)=>$02a40dc8333f1de2$require$Buffer.from(x, 'hex').toString('utf8'));
};
// https://tezos.gitlab.io/shell/p2p_api.html specifies data types and structure for forging
const $02a40dc8333f1de2$var$prefixEncoder$1 = (prefix$1)=>(str)=>{
        return (0, $6ed3c564aba0f912$export$b0491dd0626f8a03)($02a40dc8333f1de2$require$Buffer.from((0, $6ed3c564aba0f912$export$b9856b5e6fd1a05f)(str, (0, $6ed3c564aba0f912$export$82e9f45cca5ba907)[prefix$1])));
    };
const $02a40dc8333f1de2$var$prefixDecoder$1 = (pre)=>(str)=>{
        const val = str.consume((0, $6ed3c564aba0f912$export$2a5ba4495636ee46)[pre]);
        return (0, $6ed3c564aba0f912$export$8ff626c40517d3d3)(val, (0, $6ed3c564aba0f912$export$82e9f45cca5ba907)[pre]);
    };
const $02a40dc8333f1de2$var$tz1Decoder$1 = $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1);
const $02a40dc8333f1de2$var$branchDecoder$1 = $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).B);
const $02a40dc8333f1de2$var$publicKeyHashDecoder$1 = (val)=>{
    const prefix = val.consume(1);
    if (prefix[0] === 0x00) return $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1)(val);
    else if (prefix[0] === 0x01) return $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2)(val);
    else if (prefix[0] === 0x02) return $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3)(val);
    else if (prefix[0] === 0x03) return $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ4)(val);
};
const $02a40dc8333f1de2$var$publicKeyHashesDecoder$1 = (val)=>{
    if (!$02a40dc8333f1de2$var$boolDecoder$1(val)) return;
    const publicKeyHashes = [];
    val.consume(4);
    while(val.length() > 0)publicKeyHashes.push($02a40dc8333f1de2$var$publicKeyHashDecoder$1(val));
    return publicKeyHashes;
};
const $02a40dc8333f1de2$var$branchEncoder$1 = $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).B);
const $02a40dc8333f1de2$var$tz1Encoder$1 = $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1);
const $02a40dc8333f1de2$var$boolEncoder$1 = (bool)=>bool ? 'ff' : '00';
const $02a40dc8333f1de2$var$proposalEncoder$1 = (proposal)=>{
    return $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P)(proposal);
};
const $02a40dc8333f1de2$var$proposalDecoder$1 = (proposal)=>{
    return $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P)(proposal);
};
const $02a40dc8333f1de2$var$proposalsDecoder$1 = (proposal)=>{
    const proposals = [];
    proposal.consume(4);
    while(proposal.length() > 0)proposals.push($02a40dc8333f1de2$var$proposalDecoder$1(proposal));
    return proposals;
};
const $02a40dc8333f1de2$var$proposalsEncoder$1 = (proposals)=>{
    return $02a40dc8333f1de2$var$pad(32 * proposals.length) + proposals.map((x)=>$02a40dc8333f1de2$var$proposalEncoder$1(x)).join('');
};
const $02a40dc8333f1de2$var$ballotEncoder$1 = (ballot)=>{
    switch(ballot){
        case 'yay':
            return '00';
        case 'nay':
            return '01';
        case 'pass':
            return '02';
        default:
            throw new $02a40dc8333f1de2$var$InvalidBallotValueError(ballot);
    }
};
const $02a40dc8333f1de2$var$ballotDecoder$1 = (ballot)=>{
    const value = ballot.consume(1);
    switch(value[0]){
        case 0x00:
            return 'yay';
        case 0x01:
            return 'nay';
        case 0x02:
            return 'pass';
        default:
            throw new $02a40dc8333f1de2$var$DecodeBallotValueError(value[0].toString());
    }
};
const $02a40dc8333f1de2$var$pvmKindEncoder$1 = (pvm)=>{
    switch(pvm){
        case 'arith':
            return '00';
        case 'wasm_2_0_0':
            return '01';
        case 'riscv':
            return '02';
        default:
            throw new $02a40dc8333f1de2$var$UnsupportedPvmKindError(pvm);
    }
};
const $02a40dc8333f1de2$var$pvmKindDecoder$1 = (pvm)=>{
    const value = pvm.consume(1);
    switch(value[0]){
        case 0x00:
            return 'arith';
        case 0x01:
            return 'wasm_2_0_0';
        case 0x02:
            return 'riscv';
        default:
            throw new $02a40dc8333f1de2$var$DecodePvmKindError(value[0].toString());
    }
};
const $02a40dc8333f1de2$var$delegateEncoder$1 = (val)=>{
    if (val) return $02a40dc8333f1de2$var$boolEncoder$1(true) + $02a40dc8333f1de2$var$publicKeyHashEncoder$1(val);
    else return $02a40dc8333f1de2$var$boolEncoder$1(false);
};
const $02a40dc8333f1de2$var$int32Encoder$1 = (val)=>{
    const num = parseInt(String(val), 10);
    const byte = [];
    for(let i = 0; i < 4; i++){
        const shiftBy = (4 - (i + 1)) * 8;
        byte.push((num & 0xff << shiftBy) >> shiftBy);
    }
    return $02a40dc8333f1de2$require$Buffer.from(byte).toString('hex');
};
const $02a40dc8333f1de2$var$int32Decoder$1 = (val)=>{
    const num = val.consume(4);
    let finalNum = 0;
    for(let i = 0; i < num.length; i++)finalNum = finalNum | num[i] << (num.length - (i + 1)) * 8;
    return finalNum;
};
const $02a40dc8333f1de2$var$int16Encoder$1 = (val)=>{
    const num = parseInt(String(val), 10);
    const byte = [];
    for(let i = 0; i < 2; i++){
        const shiftBy = (2 - (i + 1)) * 8;
        byte.push((num & 0xff << shiftBy) >> shiftBy);
    }
    return $02a40dc8333f1de2$require$Buffer.from(byte).toString('hex');
};
const $02a40dc8333f1de2$var$int16Decoder$1 = (val)=>{
    const num = val.consume(2);
    let finalNum = 0;
    for(let i = 0; i < num.length; i++)finalNum = finalNum | num[i] << (num.length - (i + 1)) * 8;
    return finalNum;
};
const $02a40dc8333f1de2$var$boolDecoder$1 = (val)=>{
    const bool = val.consume(1);
    return bool[0] === 0xff;
};
const $02a40dc8333f1de2$var$delegateDecoder$1 = (val)=>{
    const hasDelegate = $02a40dc8333f1de2$var$boolDecoder$1(val);
    if (hasDelegate) return $02a40dc8333f1de2$var$publicKeyHashDecoder$1(val);
};
const $02a40dc8333f1de2$var$publicKeyHashEncoder$1 = (val)=>{
    const pubkeyPrefix = val.substring(0, 3);
    switch(pubkeyPrefix){
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1:
            return '00' + $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1)(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2:
            return '01' + $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2)(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3:
            return '02' + $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3)(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ4:
            return '03' + $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ4)(val);
        default:
            throw new (0, $c34ebaa6f129c2ed$export$a3d7df0ca9d9410c)(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting one for the following "${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1}", "${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2}", "${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3}" or "${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ4}".`);
    }
};
const $02a40dc8333f1de2$var$publicKeyHashesEncoder$1 = (val)=>{
    if (!val) return $02a40dc8333f1de2$var$boolEncoder$1(false);
    if (val.length === 0) return $02a40dc8333f1de2$var$boolEncoder$1(true) + $02a40dc8333f1de2$var$pad(0);
    const publicKeyHashes = val.reduce((prev, curr)=>{
        return prev + $02a40dc8333f1de2$var$publicKeyHashEncoder$1(curr);
    }, '');
    return $02a40dc8333f1de2$var$boolEncoder$1(true) + $02a40dc8333f1de2$var$pad(publicKeyHashes.length / 2) + publicKeyHashes;
};
const $02a40dc8333f1de2$var$publicKeyEncoder$1 = (val)=>{
    const pubkeyPrefix = val.substring(0, 4);
    switch(pubkeyPrefix){
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDPK:
            return '00' + $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDPK)(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPPK:
            return '01' + $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPPK)(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2PK:
            return '02' + $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2PK)(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).BLPK:
            return '03' + $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).BLPK)(val);
        default:
            throw new (0, $c34ebaa6f129c2ed$export$f675822ed489f01f)(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting one of the following '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDPK}', '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPPK}', '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2PK}' or '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).BLPK}'.`);
    }
};
const $02a40dc8333f1de2$var$addressEncoder$1 = (val)=>{
    const pubkeyPrefix = val.substring(0, 3);
    switch(pubkeyPrefix){
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1:
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2:
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3:
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ4:
            return '00' + $02a40dc8333f1de2$var$publicKeyHashEncoder$1(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1:
            return '01' + $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1)(val) + '00';
        default:
            throw new (0, $6cde2a3388731e1b$export$66c44d927ffead98)(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting one of the following prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1}', ${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2}', '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3}', '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ4}' or '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1}'.`);
    }
};
const $02a40dc8333f1de2$var$smartRollupAddressEncoder$1 = (val)=>{
    if (val.substring(0, 3) !== (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1) throw new $02a40dc8333f1de2$var$InvalidSmartRollupAddressError(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1}'.`);
    return $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1)(val);
};
const $02a40dc8333f1de2$var$smartContractAddressEncoder$1 = (val)=>{
    const prefix = val.substring(0, 3);
    if (prefix === (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1) return '01' + $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1)(val) + '00';
    throw new (0, $6cde2a3388731e1b$export$193774326795229b)(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1}'.`);
};
const $02a40dc8333f1de2$var$publicKeyDecoder$1 = (val)=>{
    const preamble = val.consume(1);
    switch(preamble[0]){
        case 0x00:
            return $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDPK)(val);
        case 0x01:
            return $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPPK)(val);
        case 0x02:
            return $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2PK)(val);
        case 0x03:
            return $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).BLPK)(val);
        default:
            throw new (0, $c34ebaa6f129c2ed$export$f675822ed489f01f)(val.toString(), (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED));
    }
};
const $02a40dc8333f1de2$var$smartRollupCommitmentHashEncoder$1 = (val)=>{
    const prefix = val.substring(0, 4);
    if (prefix === (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1) return $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1)(val);
    throw new $02a40dc8333f1de2$var$InvalidSmartRollupCommitmentHashError(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1}'`);
};
const $02a40dc8333f1de2$var$addressDecoder$1 = (val)=>{
    const preamble = val.consume(1);
    switch(preamble[0]){
        case 0x00:
            return $02a40dc8333f1de2$var$publicKeyHashDecoder$1(val);
        case 0x01:
            {
                const address = $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1)(val);
                val.consume(1);
                return address;
            }
        default:
            throw new (0, $6cde2a3388731e1b$export$66c44d927ffead98)(val.toString(), ': Unable to decode.');
    }
};
const $02a40dc8333f1de2$var$smartRollupAddressDecoder$1 = (val)=>{
    const address = $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1)(val);
    if (address.substring(0, 3) !== (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1) throw new $02a40dc8333f1de2$var$InvalidSmartRollupAddressError(address, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1}'.`);
    return address;
};
const $02a40dc8333f1de2$var$smartContractAddressDecoder$1 = (val)=>{
    const preamble = val.consume(1);
    if (preamble[0] === 0x01) {
        const scAddress = $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1)(val);
        val.consume(1);
        return scAddress;
    }
    throw new (0, $6cde2a3388731e1b$export$193774326795229b)(val.toString(), (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED));
};
const $02a40dc8333f1de2$var$smartRollupCommitmentHashDecoder$1 = (val)=>{
    const address = $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1)(val);
    if (address.substring(0, 4) !== (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1) throw new $02a40dc8333f1de2$var$InvalidSmartRollupCommitmentHashError(address, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1}'`);
    return address;
};
const $02a40dc8333f1de2$var$zarithEncoder$1 = (n)=>{
    const fn = [];
    let nn = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(n, 10);
    if (nn.isNaN()) throw new TypeError(`Invalid zarith number ${n}`);
    // eslint-disable-next-line no-constant-condition
    while(true)if (nn.lt(128)) {
        if (nn.lt(16)) fn.push('0');
        fn.push(nn.toString(16));
        break;
    } else {
        let b = nn.mod(128);
        nn = nn.minus(b);
        nn = nn.dividedBy(128);
        b = b.plus(128);
        fn.push(b.toString(16));
    }
    return fn.join('');
};
const $02a40dc8333f1de2$var$zarithDecoder$1 = (n)=>{
    let mostSignificantByte = 0;
    while(mostSignificantByte < n.length() && (n.get(mostSignificantByte) & 128) !== 0)mostSignificantByte += 1;
    let num = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    for(let i = mostSignificantByte; i >= 0; i -= 1){
        const tmp = n.get(i) & 0x7f;
        num = num.multipliedBy(128);
        num = num.plus(tmp);
    }
    n.consume(mostSignificantByte + 1);
    return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(num).toString();
};
const $02a40dc8333f1de2$var$entrypointDecoder$1 = (value)=>{
    const preamble = $02a40dc8333f1de2$var$pad(value.consume(1)[0], 2);
    if (preamble in $02a40dc8333f1de2$var$entrypointMapping$1) return $02a40dc8333f1de2$var$entrypointMapping$1[preamble];
    else {
        const entry = $02a40dc8333f1de2$var$extractRequiredLen(value, 1);
        const entrypoint = $02a40dc8333f1de2$require$Buffer.from(entry).toString('utf8');
        if (entrypoint.length > $02a40dc8333f1de2$var$ENTRYPOINT_MAX_LENGTH$1) throw new $02a40dc8333f1de2$var$OversizedEntryPointError(entrypoint);
        return entrypoint;
    }
};
const $02a40dc8333f1de2$var$parametersDecoder$1 = (val)=>{
    const preamble = val.consume(1);
    if (preamble[0] === 0x00) return;
    else {
        const encodedEntrypoint = $02a40dc8333f1de2$var$entrypointDecoder$1(val);
        const params = $02a40dc8333f1de2$var$extractRequiredLen(val);
        const parameters = $02a40dc8333f1de2$var$valueDecoder(new $02a40dc8333f1de2$export$2ea09c189c142295(params));
        return {
            entrypoint: encodedEntrypoint,
            value: parameters
        };
    }
};
const $02a40dc8333f1de2$var$entrypointEncoder$1 = (entrypoint)=>{
    if (entrypoint in $02a40dc8333f1de2$var$entrypointMappingReverse$1) return `${$02a40dc8333f1de2$var$entrypointMappingReverse$1[entrypoint]}`;
    else {
        if (entrypoint.length > $02a40dc8333f1de2$var$ENTRYPOINT_MAX_LENGTH$1) throw new $02a40dc8333f1de2$var$OversizedEntryPointError(entrypoint);
        const value = {
            string: entrypoint
        };
        return `ff${$02a40dc8333f1de2$var$valueEncoder(value).slice(8)}`;
    }
};
const $02a40dc8333f1de2$var$parametersEncoder$1 = (val)=>{
    if (!val || val.entrypoint === 'default' && 'prim' in val.value && val.value.prim === 'Unit') return '00';
    const encodedEntrypoint = $02a40dc8333f1de2$var$entrypointEncoder$1(val.entrypoint);
    const parameters = $02a40dc8333f1de2$var$valueEncoder(val.value);
    const length = $02a40dc8333f1de2$var$pad(parameters.length / 2);
    return `ff${encodedEntrypoint}${length}${parameters}`;
};
const $02a40dc8333f1de2$var$valueParameterEncoder$1 = (value)=>{
    const valueEncoded = $02a40dc8333f1de2$var$valueEncoder(value);
    return `${$02a40dc8333f1de2$var$pad(valueEncoded.length / 2)}${valueEncoded}`;
};
const $02a40dc8333f1de2$var$valueParameterDecoder$1 = (val)=>{
    const value = $02a40dc8333f1de2$var$extractRequiredLen(val);
    return $02a40dc8333f1de2$var$valueDecoder(new $02a40dc8333f1de2$export$2ea09c189c142295(value));
};
const $02a40dc8333f1de2$var$blockPayloadHashEncoder$1 = $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).VH);
const $02a40dc8333f1de2$var$blockPayloadHashDecoder$1 = $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).VH);
const $02a40dc8333f1de2$var$entrypointNameEncoder$1 = (entrypoint)=>{
    const value = {
        string: entrypoint
    };
    return `${$02a40dc8333f1de2$var$valueEncoder(value).slice(2)}`;
};
const $02a40dc8333f1de2$var$entrypointNameDecoder$1 = (val)=>{
    const entry = $02a40dc8333f1de2$var$extractRequiredLen(val);
    return $02a40dc8333f1de2$require$Buffer.from(entry).toString('utf8');
};
const $02a40dc8333f1de2$var$burnLimitEncoder$1 = (val)=>{
    return !val ? '00' : `ff${$02a40dc8333f1de2$var$zarithEncoder$1(val)}`;
};
const $02a40dc8333f1de2$var$burnLimitDecoder$1 = (value)=>{
    const prefix = value.consume(1);
    if ($02a40dc8333f1de2$require$Buffer.from(prefix).toString('hex') !== '00') return $02a40dc8333f1de2$var$zarithDecoder$1(value);
};
const $02a40dc8333f1de2$var$depositsLimitEncoder$1 = (val)=>{
    return !val ? '00' : `ff${$02a40dc8333f1de2$var$zarithEncoder$1(val)}`;
};
const $02a40dc8333f1de2$var$depositsLimitDecoder$1 = (value)=>{
    const prefix = value.consume(1);
    if ($02a40dc8333f1de2$require$Buffer.from(prefix).toString('hex') !== '00') return $02a40dc8333f1de2$var$zarithDecoder$1(value);
};
const $02a40dc8333f1de2$var$signatureV1Encoder = (val)=>{
    const signaturePrefix = val.substring(0, 5);
    switch(signaturePrefix){
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDSIG:
            return $02a40dc8333f1de2$var$paddedBytesEncoder$1($02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDSIG)(val));
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPSIG:
            return $02a40dc8333f1de2$var$paddedBytesEncoder$1($02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPSIG)(val));
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2SIG:
            return $02a40dc8333f1de2$var$paddedBytesEncoder$1($02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2SIG)(val));
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).BLSIG:
            return $02a40dc8333f1de2$var$paddedBytesEncoder$1($02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).BLSIG)(val));
        default:
            throw new (0, $6cde2a3388731e1b$export$ccc2f68ef106615a)(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting one of the following '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDSIG}', '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPSIG}', '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2SIG}' or '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).BLSIG}'.`);
    }
};
const $02a40dc8333f1de2$var$signatureV1Decoder = (val)=>{
    val.consume(4);
    if (val.length().toString() === '96') return $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).BLSIG)(val);
    else throw new (0, $6cde2a3388731e1b$export$4041d915d9096adf)('currently we only support decoding of BLSIG signatures');
};
const $02a40dc8333f1de2$var$signatureProofEncoder = (val)=>{
    if (val) return $02a40dc8333f1de2$var$boolEncoder$1(true) + $02a40dc8333f1de2$var$signatureV1Encoder(val);
    else return $02a40dc8333f1de2$var$boolEncoder$1(false);
};
const $02a40dc8333f1de2$var$signatureProofDecoder = (value)=>{
    const hasProof = $02a40dc8333f1de2$var$boolDecoder$1(value);
    if (hasProof) return $02a40dc8333f1de2$var$signatureV1Decoder(value);
};
const $02a40dc8333f1de2$var$paddedBytesEncoder$1 = (val, paddingLength = 8)=>{
    return `${$02a40dc8333f1de2$var$pad(val.length / 2, paddingLength)}${val}`;
};
const $02a40dc8333f1de2$var$paddedBytesDecoder$1 = (val)=>{
    const value = $02a40dc8333f1de2$var$extractRequiredLen(val);
    return $02a40dc8333f1de2$require$Buffer.from(value).toString('hex');
};
const $02a40dc8333f1de2$var$smartRollupMessageEncoder$1 = (val)=>{
    const message = val.reduce((prev, curr)=>{
        return prev + `${$02a40dc8333f1de2$var$pad(curr.length / 2)}${curr}`;
    }, '');
    return `${$02a40dc8333f1de2$var$pad(message.length / 2)}${message}`;
};
const $02a40dc8333f1de2$var$smartRollupMessageDecoder$1 = (val)=>{
    const valueArray = $02a40dc8333f1de2$var$extractRequiredLen(val);
    const ret = $02a40dc8333f1de2$var$stripLengthPrefixFromBytes(new $02a40dc8333f1de2$export$2ea09c189c142295(valueArray));
    return ret.map((value)=>$02a40dc8333f1de2$require$Buffer.from(value).toString('hex'));
};
const $02a40dc8333f1de2$var$dalCommitmentEncoder$1 = (val)=>{
    const prefix = val.substring(0, 2);
    if (prefix === (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH) return $02a40dc8333f1de2$var$prefixEncoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH)(val);
    throw new $02a40dc8333f1de2$var$InvalidDalCommitmentError(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH}'`);
};
const $02a40dc8333f1de2$var$dalCommitmentDecoder$1 = (val)=>{
    const commitment = $02a40dc8333f1de2$var$prefixDecoder$1((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH)(val);
    if (commitment.substring(0, 2) !== (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH) throw new $02a40dc8333f1de2$var$InvalidDalCommitmentError(commitment, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH}'`);
    return commitment;
};
const $02a40dc8333f1de2$var$slotHeaderEncoder$1 = (val)=>{
    return $02a40dc8333f1de2$var$pad(val.slot_index, 2) + $02a40dc8333f1de2$var$dalCommitmentEncoder$1(val.commitment) + val.commitment_proof;
};
const $02a40dc8333f1de2$var$slotHeaderDecoder$1 = (val)=>{
    const preamble = val.consume(1);
    return {
        slot_index: Number(preamble[0].toString(10)),
        commitment: $02a40dc8333f1de2$var$dalCommitmentDecoder$1(val),
        commitment_proof: $02a40dc8333f1de2$var$toHexString(val.consume(96))
    };
};
const $02a40dc8333f1de2$var$ManagerOperationSchema$1 = {
    branch: $02a40dc8333f1de2$export$9a139b626817ea5b.BRANCH,
    contents: [
        $02a40dc8333f1de2$export$9a139b626817ea5b.OPERATION
    ]
};
const $02a40dc8333f1de2$var$ActivationSchema$1 = {
    pkh: $02a40dc8333f1de2$export$9a139b626817ea5b.TZ1,
    secret: $02a40dc8333f1de2$export$9a139b626817ea5b.SECRET
};
const $02a40dc8333f1de2$var$RevealSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    public_key: $02a40dc8333f1de2$export$9a139b626817ea5b.PUBLIC_KEY
};
const $02a40dc8333f1de2$var$DelegationSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    delegate: $02a40dc8333f1de2$export$9a139b626817ea5b.DELEGATE
};
const $02a40dc8333f1de2$var$TransactionSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    amount: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    destination: $02a40dc8333f1de2$export$9a139b626817ea5b.ADDRESS,
    parameters: $02a40dc8333f1de2$export$9a139b626817ea5b.PARAMETERS
};
const $02a40dc8333f1de2$var$OriginationSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    balance: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    delegate: $02a40dc8333f1de2$export$9a139b626817ea5b.DELEGATE,
    script: $02a40dc8333f1de2$export$9a139b626817ea5b.SCRIPT
};
const $02a40dc8333f1de2$var$BallotSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    period: $02a40dc8333f1de2$export$9a139b626817ea5b.INT32,
    proposal: $02a40dc8333f1de2$export$9a139b626817ea5b.PROPOSAL,
    ballot: $02a40dc8333f1de2$export$9a139b626817ea5b.BALLOT_STATEMENT
};
const $02a40dc8333f1de2$var$AttestationSchema$1 = {
    slot: $02a40dc8333f1de2$export$9a139b626817ea5b.INT16,
    level: $02a40dc8333f1de2$export$9a139b626817ea5b.INT32,
    round: $02a40dc8333f1de2$export$9a139b626817ea5b.INT32,
    block_payload_hash: $02a40dc8333f1de2$export$9a139b626817ea5b.BLOCK_PAYLOAD_HASH
};
const $02a40dc8333f1de2$var$AttestationWithDalSchema$1 = {
    slot: $02a40dc8333f1de2$export$9a139b626817ea5b.INT16,
    level: $02a40dc8333f1de2$export$9a139b626817ea5b.INT32,
    round: $02a40dc8333f1de2$export$9a139b626817ea5b.INT32,
    block_payload_hash: $02a40dc8333f1de2$export$9a139b626817ea5b.BLOCK_PAYLOAD_HASH,
    dal_attestation: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH
};
const $02a40dc8333f1de2$var$SeedNonceRevelationSchema$1 = {
    level: $02a40dc8333f1de2$export$9a139b626817ea5b.INT32,
    nonce: $02a40dc8333f1de2$export$9a139b626817ea5b.RAW
};
const $02a40dc8333f1de2$var$ProposalsSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    period: $02a40dc8333f1de2$export$9a139b626817ea5b.INT32,
    proposals: $02a40dc8333f1de2$export$9a139b626817ea5b.PROPOSAL_ARR
};
const $02a40dc8333f1de2$var$RegisterGlobalConstantSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    value: $02a40dc8333f1de2$export$9a139b626817ea5b.VALUE
};
const $02a40dc8333f1de2$var$TransferTicketSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    ticket_contents: $02a40dc8333f1de2$export$9a139b626817ea5b.VALUE,
    ticket_ty: $02a40dc8333f1de2$export$9a139b626817ea5b.VALUE,
    ticket_ticketer: $02a40dc8333f1de2$export$9a139b626817ea5b.ADDRESS,
    ticket_amount: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    destination: $02a40dc8333f1de2$export$9a139b626817ea5b.ADDRESS,
    entrypoint: $02a40dc8333f1de2$export$9a139b626817ea5b.ENTRYPOINT
};
const $02a40dc8333f1de2$var$IncreasePaidStorageSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    amount: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    destination: $02a40dc8333f1de2$export$9a139b626817ea5b.SMART_CONTRACT_ADDRESS
};
const $02a40dc8333f1de2$var$UpdateConsensusKeySchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    pk: $02a40dc8333f1de2$export$9a139b626817ea5b.PUBLIC_KEY,
    proof: $02a40dc8333f1de2$export$9a139b626817ea5b.SIGNATURE_PROOF
};
const $02a40dc8333f1de2$var$DrainDelegateSchema$1 = {
    consensus_key: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    delegate: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    destination: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH
};
const $02a40dc8333f1de2$var$SetDepositsLimitSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    limit: $02a40dc8333f1de2$export$9a139b626817ea5b.DEPOSITS_LIMIT
};
const $02a40dc8333f1de2$var$SmartRollupOriginateSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    pvm_kind: $02a40dc8333f1de2$export$9a139b626817ea5b.PVM_KIND,
    kernel: $02a40dc8333f1de2$export$9a139b626817ea5b.PADDED_BYTES,
    parameters_ty: $02a40dc8333f1de2$export$9a139b626817ea5b.VALUE,
    whitelist: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH_ARR
};
const $02a40dc8333f1de2$var$SmartRollupAddMessagesSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    message: $02a40dc8333f1de2$export$9a139b626817ea5b.SMART_ROLLUP_MESSAGE
};
const $02a40dc8333f1de2$var$SmartRollupExecuteOutboxMessageSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    rollup: $02a40dc8333f1de2$export$9a139b626817ea5b.SMART_ROLLUP_ADDRESS,
    cemented_commitment: $02a40dc8333f1de2$export$9a139b626817ea5b.SMART_ROLLUP_COMMITMENT_HASH,
    output_proof: $02a40dc8333f1de2$export$9a139b626817ea5b.PADDED_BYTES
};
const $02a40dc8333f1de2$var$DalPublishCommitmentSchema$1 = {
    source: $02a40dc8333f1de2$export$9a139b626817ea5b.PKH,
    fee: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    counter: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    gas_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    storage_limit: $02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH,
    slot_header: $02a40dc8333f1de2$export$9a139b626817ea5b.SLOT_HEADER
};
const $02a40dc8333f1de2$var$FailingNoopSchema$1 = {
    arbitrary: $02a40dc8333f1de2$export$9a139b626817ea5b.PADDED_BYTES
};
const $02a40dc8333f1de2$var$operationEncoder$1 = (encoders)=>(operation)=>{
        if (!(operation.kind in encoders) || !(operation.kind in $02a40dc8333f1de2$var$kindMappingReverse$1)) throw new (0, $6cde2a3388731e1b$export$bc5be87550569b55)(operation.kind);
        return $02a40dc8333f1de2$var$kindMappingReverse$1[operation.kind] + encoders[operation.kind](operation);
    };
const $02a40dc8333f1de2$var$operationDecoder$1 = (decoders)=>(value)=>{
        const op = value.consume(1);
        const operationName = $02a40dc8333f1de2$var$kindMapping$1[op[0]];
        if (operationName === undefined) throw new $02a40dc8333f1de2$var$UnsupportedOperationError(op[0].toString());
        const decodedObj = decoders[operationName](value);
        if (typeof decodedObj !== 'object') throw new $02a40dc8333f1de2$var$OperationDecodingError('Invalid operation, cannot be decoded.');
        return Object.assign({
            kind: operationName
        }, decodedObj);
    };
const $02a40dc8333f1de2$var$schemaEncoder$1 = (encoders)=>(schema)=>(value)=>{
            const keys = Object.keys(schema);
            return keys.reduce((prev, key)=>{
                const valueToEncode = schema[key];
                if (value && Array.isArray(valueToEncode)) {
                    const encoder = encoders[valueToEncode[0]];
                    const values = value[key];
                    if (!Array.isArray(values)) throw new $02a40dc8333f1de2$var$OperationEncodingError(`Invalid operation value "${JSON.stringify(values)}" of key "${key}, expected value to be Array.`);
                    return prev + values.reduce((prevBytes, current)=>prevBytes + encoder(current), '');
                } else {
                    const encoder = encoders[valueToEncode];
                    return prev + encoder(value[key]);
                }
            }, '');
        };
const $02a40dc8333f1de2$var$schemaDecoder$1 = (decoders)=>(schema)=>(value)=>{
            const keys = Object.keys(schema);
            return keys.reduce((prev, key)=>{
                const valueToEncode = schema[key];
                if (Array.isArray(valueToEncode)) {
                    const decoder = decoders[valueToEncode[0]];
                    const decoded = [];
                    const lastLength = value.length();
                    while(value.length() > 0){
                        decoded.push(decoder(value));
                        if (lastLength === value.length()) throw new $02a40dc8333f1de2$var$OperationDecodingError('Unable to decode value');
                    }
                    return Object.assign(Object.assign({}, prev), {
                        [key]: decoded
                    });
                } else {
                    const decoder = decoders[valueToEncode];
                    const result = decoder(value);
                    if (typeof result !== 'undefined') return Object.assign(Object.assign({}, prev), {
                        [key]: result
                    });
                    else return Object.assign({}, prev);
                }
            }, {});
        };
const $02a40dc8333f1de2$export$1e344c6b2c4b13e7 = {
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SECRET]: (val)=>$02a40dc8333f1de2$var$toHexString(val.consume(20)),
    [$02a40dc8333f1de2$export$9a139b626817ea5b.RAW]: (val)=>$02a40dc8333f1de2$var$toHexString(val.consume(32)),
    [$02a40dc8333f1de2$export$9a139b626817ea5b.TZ1]: $02a40dc8333f1de2$var$tz1Decoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.BRANCH]: $02a40dc8333f1de2$var$branchDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH]: $02a40dc8333f1de2$var$zarithDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PUBLIC_KEY]: $02a40dc8333f1de2$var$publicKeyDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PKH]: $02a40dc8333f1de2$var$publicKeyHashDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PKH_ARR]: $02a40dc8333f1de2$var$publicKeyHashesDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.DELEGATE]: $02a40dc8333f1de2$var$delegateDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.INT32]: $02a40dc8333f1de2$var$int32Decoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SCRIPT]: $02a40dc8333f1de2$var$scriptDecoder,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.BALLOT_STATEMENT]: $02a40dc8333f1de2$var$ballotDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PROPOSAL]: $02a40dc8333f1de2$var$proposalDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PROPOSAL_ARR]: $02a40dc8333f1de2$var$proposalsDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PARAMETERS]: $02a40dc8333f1de2$var$parametersDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.ADDRESS]: $02a40dc8333f1de2$var$addressDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SMART_ROLLUP_ADDRESS]: $02a40dc8333f1de2$var$smartRollupAddressDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SMART_CONTRACT_ADDRESS]: $02a40dc8333f1de2$var$smartContractAddressDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SMART_ROLLUP_COMMITMENT_HASH]: $02a40dc8333f1de2$var$smartRollupCommitmentHashDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.VALUE]: $02a40dc8333f1de2$var$valueParameterDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.INT16]: $02a40dc8333f1de2$var$int16Decoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.BLOCK_PAYLOAD_HASH]: $02a40dc8333f1de2$var$blockPayloadHashDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.ENTRYPOINT]: $02a40dc8333f1de2$var$entrypointNameDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.BURN_LIMIT]: $02a40dc8333f1de2$var$burnLimitDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.DEPOSITS_LIMIT]: $02a40dc8333f1de2$var$depositsLimitDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SIGNATURE_PROOF]: $02a40dc8333f1de2$var$signatureProofDecoder,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PVM_KIND]: $02a40dc8333f1de2$var$pvmKindDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PADDED_BYTES]: $02a40dc8333f1de2$var$paddedBytesDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SMART_ROLLUP_MESSAGE]: $02a40dc8333f1de2$var$smartRollupMessageDecoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SLOT_HEADER]: $02a40dc8333f1de2$var$slotHeaderDecoder$1
};
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OPERATION] = $02a40dc8333f1de2$var$operationDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_ACTIVATE_ACCOUNT] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$ActivationSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_FAILING_NOOP] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$FailingNoopSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_DELEGATION] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$DelegationSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_TRANSACTION] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$TransactionSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_ORIGINATION] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$OriginationSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_BALLOT] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$BallotSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_ATTESTATION] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$AttestationSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_ATTESTATION_WITH_DAL] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$AttestationWithDalSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_SEED_NONCE_REVELATION] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$SeedNonceRevelationSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_PROPOSALS] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$ProposalsSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_REVEAL] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$RevealSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_REGISTER_GLOBAL_CONSTANT] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$RegisterGlobalConstantSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_TRANSFER_TICKET] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$TransferTicketSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_INCREASE_PAID_STORAGE] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$IncreasePaidStorageSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_UPDATE_CONSENSUS_KEY] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$UpdateConsensusKeySchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_DRAIN_DELEGATE] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$DrainDelegateSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_SMART_ROLLUP_ORIGINATE] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$SmartRollupOriginateSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_SMART_ROLLUP_ADD_MESSAGES] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$SmartRollupAddMessagesSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$SmartRollupExecuteOutboxMessageSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_DAL_PUBLISH_COMMITMENT] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$DalPublishCommitmentSchema$1)(val);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.MANAGER] = $02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$ManagerOperationSchema$1);
$02a40dc8333f1de2$export$1e344c6b2c4b13e7[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_SET_DEPOSITS_LIMIT] = (val)=>$02a40dc8333f1de2$var$schemaDecoder$1($02a40dc8333f1de2$export$1e344c6b2c4b13e7)($02a40dc8333f1de2$var$SetDepositsLimitSchema$1)(val);
/*
 * Some code in this file is originally from sotez
 * Copyright (c) 2018 Andrew Kishino
 */ // See: https://tezos.gitlab.io/protocols/005_babylon.html#transactions-now-have-an-entrypoint
const $02a40dc8333f1de2$var$ENTRYPOINT_MAX_LENGTH = 31;
var $02a40dc8333f1de2$var$CODEC;
(function(CODEC) {
    CODEC["SECRET"] = "secret";
    CODEC["RAW"] = "raw";
    CODEC["TZ1"] = "tz1";
    CODEC["BRANCH"] = "branch";
    CODEC["ZARITH"] = "zarith";
    CODEC["PUBLIC_KEY"] = "public_key";
    CODEC["PKH"] = "pkh";
    CODEC["PKH_ARR"] = "pkhArr";
    CODEC["DELEGATE"] = "delegate";
    CODEC["SCRIPT"] = "script";
    CODEC["BALLOT_STATEMENT"] = "ballotStmt";
    CODEC["PROPOSAL"] = "proposal";
    CODEC["PROPOSAL_ARR"] = "proposalArr";
    CODEC["INT32"] = "int32";
    CODEC["INT16"] = "int16";
    CODEC["PARAMETERS"] = "parameters";
    CODEC["ADDRESS"] = "address";
    CODEC["SMART_CONTRACT_ADDRESS"] = "smart_contract_address";
    CODEC["SMART_ROLLUP_ADDRESS"] = "smart_rollup_address";
    CODEC["SMART_ROLLUP_COMMITMENT_HASH"] = "smart_rollup_commitment_hash";
    CODEC["VALUE"] = "value";
    CODEC["PADDED_BYTES"] = "padded_bytes";
    CODEC["SMART_ROLLUP_MESSAGE"] = "smart_rollup_message";
    CODEC["MANAGER"] = "manager";
    CODEC["BLOCK_PAYLOAD_HASH"] = "blockPayloadHash";
    CODEC["ENTRYPOINT"] = "entrypoint";
    CODEC["OPERATION"] = "operation";
    CODEC["OP_ACTIVATE_ACCOUNT"] = "activate_account";
    CODEC["OP_DELEGATION"] = "delegation";
    CODEC["OP_TRANSACTION"] = "transaction";
    CODEC["OP_ORIGINATION"] = "origination";
    CODEC["OP_BALLOT"] = "ballot";
    CODEC["OP_FAILING_NOOP"] = "failing_noop";
    CODEC["OP_ATTESTATION"] = "attestation";
    CODEC["OP_ATTESTATION_WITH_DAL"] = "attestation_with_dal";
    CODEC["OP_SEED_NONCE_REVELATION"] = "seed_nonce_revelation";
    CODEC["OP_REVEAL"] = "reveal";
    CODEC["OP_PROPOSALS"] = "proposals";
    CODEC["OP_REGISTER_GLOBAL_CONSTANT"] = "register_global_constant";
    CODEC["OP_TRANSFER_TICKET"] = "transfer_ticket";
    CODEC["BURN_LIMIT"] = "burn_limit";
    CODEC["OP_INCREASE_PAID_STORAGE"] = "increase_paid_storage";
    CODEC["OP_UPDATE_CONSENSUS_KEY"] = "update_consensus_key";
    CODEC["OP_DRAIN_DELEGATE"] = "drain_delegate";
    CODEC["DEPOSITS_LIMIT"] = "deposits_limit";
    CODEC["OP_SET_DEPOSITS_LIMIT"] = "set_deposits_limit";
    CODEC["OP_SMART_ROLLUP_ORIGINATE"] = "smart_rollup_originate";
    CODEC["PVM_KIND"] = "pvm_kind";
    CODEC["OP_SMART_ROLLUP_ADD_MESSAGES"] = "smart_rollup_add_messages";
    CODEC["OP_SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE"] = "smart_rollup_execute_outbox_message";
    CODEC["OP_DAL_PUBLISH_COMMITMENT"] = "dal_publish_commitment";
    CODEC["SLOT_HEADER"] = "slot_header";
})($02a40dc8333f1de2$var$CODEC || ($02a40dc8333f1de2$var$CODEC = {}));
// See https://tezos.gitlab.io/shell/p2p_api.html#alpha-michelson-v1-primitives-enumeration-unsigned-8-bit-integer
const $02a40dc8333f1de2$var$opMapping = {
    '00': 'parameter',
    '01': 'storage',
    '02': 'code',
    '03': 'False',
    '04': 'Elt',
    '05': 'Left',
    '06': 'None',
    '07': 'Pair',
    '08': 'Right',
    '09': 'Some',
    '0a': 'True',
    '0b': 'Unit',
    '0c': 'PACK',
    '0d': 'UNPACK',
    '0e': 'BLAKE2B',
    '0f': 'SHA256',
    '10': 'SHA512',
    '11': 'ABS',
    '12': 'ADD',
    '13': 'AMOUNT',
    '14': 'AND',
    '15': 'BALANCE',
    '16': 'CAR',
    '17': 'CDR',
    '18': 'CHECK_SIGNATURE',
    '19': 'COMPARE',
    '1a': 'CONCAT',
    '1b': 'CONS',
    '1c': 'CREATE_ACCOUNT',
    '1d': 'CREATE_CONTRACT',
    '1e': 'IMPLICIT_ACCOUNT',
    '1f': 'DIP',
    '20': 'DROP',
    '21': 'DUP',
    '22': 'EDIV',
    '23': 'EMPTY_MAP',
    '24': 'EMPTY_SET',
    '25': 'EQ',
    '26': 'EXEC',
    '27': 'FAILWITH',
    '28': 'GE',
    '29': 'GET',
    '2a': 'GT',
    '2b': 'HASH_KEY',
    '2c': 'IF',
    '2d': 'IF_CONS',
    '2e': 'IF_LEFT',
    '2f': 'IF_NONE',
    '30': 'INT',
    '31': 'LAMBDA',
    '32': 'LE',
    '33': 'LEFT',
    '34': 'LOOP',
    '35': 'LSL',
    '36': 'LSR',
    '37': 'LT',
    '38': 'MAP',
    '39': 'MEM',
    '3a': 'MUL',
    '3b': 'NEG',
    '3c': 'NEQ',
    '3d': 'NIL',
    '3e': 'NONE',
    '3f': 'NOT',
    '40': 'NOW',
    '41': 'OR',
    '42': 'PAIR',
    '43': 'PUSH',
    '44': 'RIGHT',
    '45': 'SIZE',
    '46': 'SOME',
    '47': 'SOURCE',
    '48': 'SENDER',
    '49': 'SELF',
    '4a': 'STEPS_TO_QUOTA',
    '4b': 'SUB',
    '4c': 'SWAP',
    '4d': 'TRANSFER_TOKENS',
    '4e': 'SET_DELEGATE',
    '4f': 'UNIT',
    '50': 'UPDATE',
    '51': 'XOR',
    '52': 'ITER',
    '53': 'LOOP_LEFT',
    '54': 'ADDRESS',
    '55': 'CONTRACT',
    '56': 'ISNAT',
    '57': 'CAST',
    '58': 'RENAME',
    '59': 'bool',
    '5a': 'contract',
    '5b': 'int',
    '5c': 'key',
    '5d': 'key_hash',
    '5e': 'lambda',
    '5f': 'list',
    '60': 'map',
    '61': 'big_map',
    '62': 'nat',
    '63': 'option',
    '64': 'or',
    '65': 'pair',
    '66': 'set',
    '67': 'signature',
    '68': 'string',
    '69': 'bytes',
    '6a': 'mutez',
    '6b': 'timestamp',
    '6c': 'unit',
    '6d': 'operation',
    '6e': 'address',
    '6f': 'SLICE',
    '70': 'DIG',
    '71': 'DUG',
    '72': 'EMPTY_BIG_MAP',
    '73': 'APPLY',
    '74': 'chain_id',
    '75': 'CHAIN_ID',
    '76': 'LEVEL',
    '77': 'SELF_ADDRESS',
    '78': 'never',
    '79': 'NEVER',
    '7a': 'UNPAIR',
    '7b': 'VOTING_POWER',
    '7c': 'TOTAL_VOTING_POWER',
    '7d': 'KECCAK',
    '7e': 'SHA3',
    '7f': 'PAIRING_CHECK',
    '80': 'bls12_381_g1',
    '81': 'bls12_381_g2',
    '82': 'bls12_381_fr',
    '83': 'sapling_state',
    '84': 'sapling_transaction_deprecated',
    '85': 'SAPLING_EMPTY_STATE',
    '86': 'SAPLING_VERIFY_UPDATE',
    '87': 'ticket',
    '88': 'TICKET_DEPRECATED',
    '89': 'READ_TICKET',
    '8a': 'SPLIT_TICKET',
    '8b': 'JOIN_TICKETS',
    '8c': 'GET_AND_UPDATE',
    '8d': 'chest',
    '8e': 'chest_key',
    '8f': 'OPEN_CHEST',
    '90': 'VIEW',
    '91': 'view',
    '92': 'constant',
    '93': 'SUB_MUTEZ',
    '94': 'tx_rollup_l2_address',
    '95': 'MIN_BLOCK_TIME',
    '96': 'sapling_transaction',
    '97': 'EMIT',
    '98': 'Lambda_rec',
    '99': 'LAMBDA_REC',
    '9a': 'TICKET',
    '9b': 'BYTES',
    '9c': 'NAT',
    '9d': 'Ticket'
};
(()=>{
    const result = {};
    Object.keys($02a40dc8333f1de2$var$opMapping).forEach((key)=>{
        result[$02a40dc8333f1de2$var$opMapping[key]] = key;
    });
    return result;
})();
// See https://tezos.gitlab.io/shell/p2p_api.html
const $02a40dc8333f1de2$var$kindMapping = {
    0x04: 'activate_account',
    0x6b: 'reveal',
    0x6e: 'delegation',
    0x6c: 'transaction',
    0x6d: 'origination',
    0x06: 'ballot',
    0x15: 'attestation',
    0x17: 'attestation_with_dal',
    0x01: 'seed_nonce_revelation',
    0x05: 'proposals',
    0x6f: 'register_global_constant',
    0x9e: 'transfer_ticket',
    0x70: 'set_deposits_limit',
    0x71: 'increase_paid_storage',
    0x72: 'update_consensus_key',
    0x09: 'drain_delegate',
    0xc8: 'smart_rollup_originate',
    0xc9: 'smart_rollup_add_messages',
    0xce: 'smart_rollup_execute_outbox_message',
    0xe6: 'dal_publish_commitment',
    0x11: 'failing_noop'
};
const $02a40dc8333f1de2$var$kindMappingReverse = (()=>{
    const result = {};
    Object.keys($02a40dc8333f1de2$var$kindMapping).forEach((key)=>{
        const keyNum = typeof key === 'string' ? parseInt(key, 10) : key;
        result[$02a40dc8333f1de2$var$kindMapping[keyNum]] = $02a40dc8333f1de2$var$pad(keyNum, 2);
    });
    return result;
})();
// See https://tezos.gitlab.io/protocols/005_babylon.html#transactions-now-have-an-entrypoint
const $02a40dc8333f1de2$var$entrypointMapping = {
    '00': 'default',
    '01': 'root',
    '02': 'do',
    '03': 'set_delegate',
    '04': 'remove_delegate',
    '05': 'deposit',
    '06': 'stake',
    '07': 'unstake',
    '08': 'finalize_unstake',
    '09': 'set_delegate_parameters'
};
const $02a40dc8333f1de2$var$entrypointMappingReverse = (()=>{
    const result = {};
    Object.keys($02a40dc8333f1de2$var$entrypointMapping).forEach((key)=>{
        result[$02a40dc8333f1de2$var$entrypointMapping[key]] = key;
    });
    return result;
})();
// https://tezos.gitlab.io/shell/p2p_api.html specifies data types and structure for forging
const $02a40dc8333f1de2$var$prefixEncoder = (prefix$1)=>(str)=>{
        return (0, $6ed3c564aba0f912$export$b0491dd0626f8a03)($02a40dc8333f1de2$require$Buffer.from((0, $6ed3c564aba0f912$export$b9856b5e6fd1a05f)(str, (0, $6ed3c564aba0f912$export$82e9f45cca5ba907)[prefix$1])));
    };
const $02a40dc8333f1de2$var$prefixDecoder = (pre)=>(str)=>{
        const val = str.consume((0, $6ed3c564aba0f912$export$2a5ba4495636ee46)[pre]);
        return (0, $6ed3c564aba0f912$export$8ff626c40517d3d3)(val, (0, $6ed3c564aba0f912$export$82e9f45cca5ba907)[pre]);
    };
const $02a40dc8333f1de2$var$tz1Decoder = $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1);
const $02a40dc8333f1de2$var$branchDecoder = $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).B);
const $02a40dc8333f1de2$var$publicKeyHashDecoder = (val)=>{
    const prefix = val.consume(1);
    if (prefix[0] === 0x00) return $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1)(val);
    else if (prefix[0] === 0x01) return $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2)(val);
    else if (prefix[0] === 0x02) return $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3)(val);
};
const $02a40dc8333f1de2$var$publicKeyHashesDecoder = (val)=>{
    if (!$02a40dc8333f1de2$var$boolDecoder(val)) return undefined;
    const publicKeyHashes = [];
    val.consume(4);
    while(val.length() > 0)publicKeyHashes.push($02a40dc8333f1de2$var$publicKeyHashDecoder(val));
    return publicKeyHashes;
};
const $02a40dc8333f1de2$var$branchEncoder = $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).B);
const $02a40dc8333f1de2$var$tz1Encoder = $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1);
const $02a40dc8333f1de2$var$boolEncoder = (bool)=>bool ? 'ff' : '00';
const $02a40dc8333f1de2$var$proposalEncoder = (proposal)=>{
    return $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P)(proposal);
};
const $02a40dc8333f1de2$var$proposalDecoder = (proposal)=>{
    return $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P)(proposal);
};
const $02a40dc8333f1de2$var$proposalsDecoder = (proposal)=>{
    const proposals = [];
    proposal.consume(4);
    while(proposal.length() > 0)proposals.push($02a40dc8333f1de2$var$proposalDecoder(proposal));
    return proposals;
};
const $02a40dc8333f1de2$var$proposalsEncoder = (proposals)=>{
    return $02a40dc8333f1de2$var$pad(32 * proposals.length) + proposals.map((x)=>$02a40dc8333f1de2$var$proposalEncoder(x)).join('');
};
const $02a40dc8333f1de2$var$ballotEncoder = (ballot)=>{
    switch(ballot){
        case 'yay':
            return '00';
        case 'nay':
            return '01';
        case 'pass':
            return '02';
        default:
            throw new $02a40dc8333f1de2$var$InvalidBallotValueError(ballot);
    }
};
const $02a40dc8333f1de2$var$ballotDecoder = (ballot)=>{
    const value = ballot.consume(1);
    switch(value[0]){
        case 0x00:
            return 'yay';
        case 0x01:
            return 'nay';
        case 0x02:
            return 'pass';
        default:
            throw new $02a40dc8333f1de2$var$DecodeBallotValueError(value[0].toString());
    }
};
const $02a40dc8333f1de2$var$pvmKindEncoder = (pvm)=>{
    switch(pvm){
        case 'arith':
            return '00';
        case 'wasm_2_0_0':
            return '01';
        case 'riscv':
            return '02';
        default:
            throw new $02a40dc8333f1de2$var$UnsupportedPvmKindError(pvm);
    }
};
const $02a40dc8333f1de2$var$pvmKindDecoder = (pvm)=>{
    const value = pvm.consume(1);
    switch(value[0]){
        case 0x00:
            return 'arith';
        case 0x01:
            return 'wasm_2_0_0';
        case 0x02:
            return 'riscv';
        default:
            throw new $02a40dc8333f1de2$var$DecodePvmKindError(value[0].toString());
    }
};
const $02a40dc8333f1de2$var$delegateEncoder = (val)=>{
    if (val) return $02a40dc8333f1de2$var$boolEncoder(true) + $02a40dc8333f1de2$var$publicKeyHashEncoder(val);
    else return $02a40dc8333f1de2$var$boolEncoder(false);
};
const $02a40dc8333f1de2$var$int32Encoder = (val)=>{
    const num = parseInt(String(val), 10);
    const byte = [];
    for(let i = 0; i < 4; i++){
        const shiftBy = (4 - (i + 1)) * 8;
        byte.push((num & 0xff << shiftBy) >> shiftBy);
    }
    return $02a40dc8333f1de2$require$Buffer.from(byte).toString('hex');
};
const $02a40dc8333f1de2$var$int32Decoder = (val)=>{
    const num = val.consume(4);
    let finalNum = 0;
    for(let i = 0; i < num.length; i++)finalNum = finalNum | num[i] << (num.length - (i + 1)) * 8;
    return finalNum;
};
const $02a40dc8333f1de2$var$int16Encoder = (val)=>{
    const num = parseInt(String(val), 10);
    const byte = [];
    for(let i = 0; i < 2; i++){
        const shiftBy = (2 - (i + 1)) * 8;
        byte.push((num & 0xff << shiftBy) >> shiftBy);
    }
    return $02a40dc8333f1de2$require$Buffer.from(byte).toString('hex');
};
const $02a40dc8333f1de2$var$int16Decoder = (val)=>{
    const num = val.consume(2);
    let finalNum = 0;
    for(let i = 0; i < num.length; i++)finalNum = finalNum | num[i] << (num.length - (i + 1)) * 8;
    return finalNum;
};
const $02a40dc8333f1de2$var$boolDecoder = (val)=>{
    const bool = val.consume(1);
    return bool[0] === 0xff;
};
const $02a40dc8333f1de2$var$delegateDecoder = (val)=>{
    const hasDelegate = $02a40dc8333f1de2$var$boolDecoder(val);
    if (hasDelegate) return $02a40dc8333f1de2$var$publicKeyHashDecoder(val);
};
const $02a40dc8333f1de2$var$publicKeyHashEncoder = (val)=>{
    const pubkeyPrefix = val.substring(0, 3);
    switch(pubkeyPrefix){
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1:
            return '00' + $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1)(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2:
            return '01' + $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2)(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3:
            return '02' + $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3)(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ4:
            return '03' + $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ4)(val);
        default:
            throw new (0, $c34ebaa6f129c2ed$export$a3d7df0ca9d9410c)(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting one for the following "${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1}", "${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2}", "${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3}" or "${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ4}".`);
    }
};
const $02a40dc8333f1de2$var$publicKeyHashesEncoder = (val)=>{
    if (!val) return $02a40dc8333f1de2$var$boolEncoder(false);
    if (val.length === 0) return $02a40dc8333f1de2$var$boolEncoder(true) + $02a40dc8333f1de2$var$pad(0);
    const publicKeyHashes = val.reduce((prev, curr)=>{
        return prev + $02a40dc8333f1de2$var$publicKeyHashEncoder(curr);
    }, '');
    return $02a40dc8333f1de2$var$boolEncoder(true) + $02a40dc8333f1de2$var$pad(publicKeyHashes.length / 2) + publicKeyHashes;
};
const $02a40dc8333f1de2$var$publicKeyEncoder = (val)=>{
    const pubkeyPrefix = val.substring(0, 4);
    switch(pubkeyPrefix){
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDPK:
            return '00' + $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDPK)(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPPK:
            return '01' + $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPPK)(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2PK:
            return '02' + $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2PK)(val);
        default:
            throw new (0, $c34ebaa6f129c2ed$export$f675822ed489f01f)(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting one of the following '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDPK}', '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPPK}', '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2PK}' or '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).BLPK}'.`);
    }
};
const $02a40dc8333f1de2$var$addressEncoder = (val)=>{
    const pubkeyPrefix = val.substring(0, 3);
    switch(pubkeyPrefix){
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1:
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2:
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3:
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ4:
            return '00' + $02a40dc8333f1de2$var$publicKeyHashEncoder(val);
        case (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1:
            return '01' + $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1)(val) + '00';
        default:
            throw new (0, $6cde2a3388731e1b$export$66c44d927ffead98)(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting one of the following prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ1}', ${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ2}', '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ3}', '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).TZ4}' or '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1}'.`);
    }
};
const $02a40dc8333f1de2$var$smartRollupAddressEncoder = (val)=>{
    if (val.substring(0, 3) !== (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1) throw new $02a40dc8333f1de2$var$InvalidSmartRollupAddressError(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1}'.`);
    return $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1)(val);
};
const $02a40dc8333f1de2$var$smartContractAddressEncoder = (val)=>{
    const prefix = val.substring(0, 3);
    if (prefix === (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1) return '01' + $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1)(val) + '00';
    throw new (0, $6cde2a3388731e1b$export$193774326795229b)(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1}'.`);
};
const $02a40dc8333f1de2$var$publicKeyDecoder = (val)=>{
    const preamble = val.consume(1);
    switch(preamble[0]){
        case 0x00:
            return $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).EDPK)(val);
        case 0x01:
            return $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SPPK)(val);
        case 0x02:
            return $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).P2PK)(val);
        default:
            throw new (0, $c34ebaa6f129c2ed$export$f675822ed489f01f)(val.toString(), (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED));
    }
};
const $02a40dc8333f1de2$var$smartRollupCommitmentHashEncoder = (val)=>{
    const prefix = val.substring(0, 4);
    if (prefix === (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1) return $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1)(val);
    throw new $02a40dc8333f1de2$var$InvalidSmartRollupCommitmentHashError(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1}'`);
};
const $02a40dc8333f1de2$var$addressDecoder = (val)=>{
    const preamble = val.consume(1);
    switch(preamble[0]){
        case 0x00:
            return $02a40dc8333f1de2$var$publicKeyHashDecoder(val);
        case 0x01:
            {
                const address = $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1)(val);
                val.consume(1);
                return address;
            }
        default:
            throw new (0, $6cde2a3388731e1b$export$66c44d927ffead98)(val.toString(), ': Unable to decode.');
    }
};
const $02a40dc8333f1de2$var$smartRollupAddressDecoder = (val)=>{
    const address = $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1)(val);
    if (address.substring(0, 3) !== (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1) throw new $02a40dc8333f1de2$var$InvalidSmartRollupAddressError(address, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SR1}'.`);
    return address;
};
const $02a40dc8333f1de2$var$smartContractAddressDecoder = (val)=>{
    const preamble = val.consume(1);
    if (preamble[0] === 0x01) {
        const scAddress = $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).KT1)(val);
        val.consume(1);
        return scAddress;
    }
    throw new (0, $6cde2a3388731e1b$export$193774326795229b)(val.toString(), (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED));
};
const $02a40dc8333f1de2$var$smartRollupCommitmentHashDecoder = (val)=>{
    const address = $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1)(val);
    if (address.substring(0, 4) !== (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1) throw new $02a40dc8333f1de2$var$InvalidSmartRollupCommitmentHashError(address, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SRC1}'`);
    return address;
};
const $02a40dc8333f1de2$var$zarithEncoder = (n)=>{
    const fn = [];
    let nn = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(n, 10);
    if (nn.isNaN()) throw new TypeError(`Invalid zarith number ${n}`);
    // eslint-disable-next-line no-constant-condition
    while(true)if (nn.lt(128)) {
        if (nn.lt(16)) fn.push('0');
        fn.push(nn.toString(16));
        break;
    } else {
        let b = nn.mod(128);
        nn = nn.minus(b);
        nn = nn.dividedBy(128);
        b = b.plus(128);
        fn.push(b.toString(16));
    }
    return fn.join('');
};
const $02a40dc8333f1de2$var$zarithDecoder = (n)=>{
    let mostSignificantByte = 0;
    while(mostSignificantByte < n.length() && (n.get(mostSignificantByte) & 128) !== 0)mostSignificantByte += 1;
    let num = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    for(let i = mostSignificantByte; i >= 0; i -= 1){
        const tmp = n.get(i) & 0x7f;
        num = num.multipliedBy(128);
        num = num.plus(tmp);
    }
    n.consume(mostSignificantByte + 1);
    return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(num).toString();
};
const $02a40dc8333f1de2$var$entrypointDecoder = (value)=>{
    const preamble = $02a40dc8333f1de2$var$pad(value.consume(1)[0], 2);
    if (preamble in $02a40dc8333f1de2$var$entrypointMapping) return $02a40dc8333f1de2$var$entrypointMapping[preamble];
    else {
        const entry = $02a40dc8333f1de2$var$extractRequiredLen(value, 1);
        const entrypoint = $02a40dc8333f1de2$require$Buffer.from(entry).toString('utf8');
        if (entrypoint.length > $02a40dc8333f1de2$var$ENTRYPOINT_MAX_LENGTH) throw new $02a40dc8333f1de2$var$OversizedEntryPointError(entrypoint);
        return entrypoint;
    }
};
const $02a40dc8333f1de2$var$parametersDecoder = (val)=>{
    const preamble = val.consume(1);
    if (preamble[0] === 0x00) return;
    else {
        const encodedEntrypoint = $02a40dc8333f1de2$var$entrypointDecoder(val);
        const params = $02a40dc8333f1de2$var$extractRequiredLen(val);
        const parameters = $02a40dc8333f1de2$var$valueDecoder(new $02a40dc8333f1de2$export$2ea09c189c142295(params));
        return {
            entrypoint: encodedEntrypoint,
            value: parameters
        };
    }
};
const $02a40dc8333f1de2$var$entrypointEncoder = (entrypoint)=>{
    if (entrypoint in $02a40dc8333f1de2$var$entrypointMappingReverse) return `${$02a40dc8333f1de2$var$entrypointMappingReverse[entrypoint]}`;
    else {
        if (entrypoint.length > $02a40dc8333f1de2$var$ENTRYPOINT_MAX_LENGTH) throw new $02a40dc8333f1de2$var$OversizedEntryPointError(entrypoint);
        const value = {
            string: entrypoint
        };
        return `ff${$02a40dc8333f1de2$var$valueEncoder(value).slice(8)}`;
    }
};
const $02a40dc8333f1de2$var$parametersEncoder = (val)=>{
    if (!val || val.entrypoint === 'default' && 'prim' in val.value && val.value.prim === 'Unit') return '00';
    const encodedEntrypoint = $02a40dc8333f1de2$var$entrypointEncoder(val.entrypoint);
    const parameters = $02a40dc8333f1de2$var$valueEncoder(val.value);
    const length = $02a40dc8333f1de2$var$pad(parameters.length / 2);
    return `ff${encodedEntrypoint}${length}${parameters}`;
};
const $02a40dc8333f1de2$var$valueParameterEncoder = (value)=>{
    const valueEncoded = $02a40dc8333f1de2$var$valueEncoder(value);
    return `${$02a40dc8333f1de2$var$pad(valueEncoded.length / 2)}${valueEncoded}`;
};
const $02a40dc8333f1de2$var$valueParameterDecoder = (val)=>{
    const value = $02a40dc8333f1de2$var$extractRequiredLen(val);
    return $02a40dc8333f1de2$var$valueDecoder(new $02a40dc8333f1de2$export$2ea09c189c142295(value));
};
const $02a40dc8333f1de2$var$blockPayloadHashEncoder = $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).VH);
const $02a40dc8333f1de2$var$blockPayloadHashDecoder = $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).VH);
const $02a40dc8333f1de2$var$entrypointNameEncoder = (entrypoint)=>{
    const value = {
        string: entrypoint
    };
    return `${$02a40dc8333f1de2$var$valueEncoder(value).slice(2)}`;
};
const $02a40dc8333f1de2$var$entrypointNameDecoder = (val)=>{
    const entry = $02a40dc8333f1de2$var$extractRequiredLen(val);
    return $02a40dc8333f1de2$require$Buffer.from(entry).toString('utf8');
};
const $02a40dc8333f1de2$var$burnLimitEncoder = (val)=>{
    return !val ? '00' : `ff${$02a40dc8333f1de2$var$zarithEncoder(val)}`;
};
const $02a40dc8333f1de2$var$burnLimitDecoder = (value)=>{
    const prefix = value.consume(1);
    if ($02a40dc8333f1de2$require$Buffer.from(prefix).toString('hex') !== '00') return $02a40dc8333f1de2$var$zarithDecoder(value);
};
const $02a40dc8333f1de2$var$depositsLimitEncoder = (val)=>{
    return !val ? '00' : `ff${$02a40dc8333f1de2$var$zarithEncoder(val)}`;
};
const $02a40dc8333f1de2$var$depositsLimitDecoder = (value)=>{
    const prefix = value.consume(1);
    if ($02a40dc8333f1de2$require$Buffer.from(prefix).toString('hex') !== '00') return $02a40dc8333f1de2$var$zarithDecoder(value);
};
const $02a40dc8333f1de2$var$paddedBytesEncoder = (val, paddingLength = 8)=>{
    return `${$02a40dc8333f1de2$var$pad(val.length / 2, paddingLength)}${val}`;
};
const $02a40dc8333f1de2$var$paddedBytesDecoder = (val)=>{
    const value = $02a40dc8333f1de2$var$extractRequiredLen(val);
    return $02a40dc8333f1de2$require$Buffer.from(value).toString('hex');
};
const $02a40dc8333f1de2$var$smartRollupMessageEncoder = (val)=>{
    const message = val.reduce((prev, curr)=>{
        return prev + `${$02a40dc8333f1de2$var$pad(curr.length / 2)}${curr}`;
    }, '');
    return `${$02a40dc8333f1de2$var$pad(message.length / 2)}${message}`;
};
const $02a40dc8333f1de2$var$smartRollupMessageDecoder = (val)=>{
    const valueArray = $02a40dc8333f1de2$var$extractRequiredLen(val);
    const ret = $02a40dc8333f1de2$var$stripLengthPrefixFromBytes(new $02a40dc8333f1de2$export$2ea09c189c142295(valueArray));
    return ret.map((value)=>$02a40dc8333f1de2$require$Buffer.from(value).toString('hex'));
};
const $02a40dc8333f1de2$var$dalCommitmentEncoder = (val)=>{
    const prefix = val.substring(0, 2);
    if (prefix === (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH) return $02a40dc8333f1de2$var$prefixEncoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH)(val);
    throw new $02a40dc8333f1de2$var$InvalidDalCommitmentError(val, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH}'`);
};
const $02a40dc8333f1de2$var$dalCommitmentDecoder = (val)=>{
    const commitment = $02a40dc8333f1de2$var$prefixDecoder((0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH)(val);
    if (commitment.substring(0, 2) !== (0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH) throw new $02a40dc8333f1de2$var$InvalidDalCommitmentError(commitment, (0, $6ed3c564aba0f912$export$a2057601792df650)((0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).NO_PREFIX_MATCHED) + ` expecting prefix '${(0, $6ed3c564aba0f912$export$e77cfe0b08ec163).SH}'`);
    return commitment;
};
const $02a40dc8333f1de2$var$slotHeaderEncoder = (val)=>{
    return $02a40dc8333f1de2$var$pad(val.slot_index, 2) + $02a40dc8333f1de2$var$dalCommitmentEncoder(val.commitment) + val.commitment_proof;
};
const $02a40dc8333f1de2$var$slotHeaderDecoder = (val)=>{
    const preamble = val.consume(1);
    return {
        slot_index: Number(preamble[0].toString(10)),
        commitment: $02a40dc8333f1de2$var$dalCommitmentDecoder(val),
        commitment_proof: $02a40dc8333f1de2$var$toHexString(val.consume(96))
    };
};
const $02a40dc8333f1de2$var$ManagerOperationSchema = {
    branch: $02a40dc8333f1de2$var$CODEC.BRANCH,
    contents: [
        $02a40dc8333f1de2$var$CODEC.OPERATION
    ]
};
const $02a40dc8333f1de2$var$ActivationSchema = {
    pkh: $02a40dc8333f1de2$var$CODEC.TZ1,
    secret: $02a40dc8333f1de2$var$CODEC.SECRET
};
const $02a40dc8333f1de2$var$RevealSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    public_key: $02a40dc8333f1de2$var$CODEC.PUBLIC_KEY
};
const $02a40dc8333f1de2$var$DelegationSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    delegate: $02a40dc8333f1de2$var$CODEC.DELEGATE
};
const $02a40dc8333f1de2$var$TransactionSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    amount: $02a40dc8333f1de2$var$CODEC.ZARITH,
    destination: $02a40dc8333f1de2$var$CODEC.ADDRESS,
    parameters: $02a40dc8333f1de2$var$CODEC.PARAMETERS
};
const $02a40dc8333f1de2$var$OriginationSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    balance: $02a40dc8333f1de2$var$CODEC.ZARITH,
    delegate: $02a40dc8333f1de2$var$CODEC.DELEGATE,
    script: $02a40dc8333f1de2$var$CODEC.SCRIPT
};
const $02a40dc8333f1de2$var$BallotSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    period: $02a40dc8333f1de2$var$CODEC.INT32,
    proposal: $02a40dc8333f1de2$var$CODEC.PROPOSAL,
    ballot: $02a40dc8333f1de2$var$CODEC.BALLOT_STATEMENT
};
const $02a40dc8333f1de2$var$AttestationSchema = {
    slot: $02a40dc8333f1de2$var$CODEC.INT16,
    level: $02a40dc8333f1de2$var$CODEC.INT32,
    round: $02a40dc8333f1de2$var$CODEC.INT32,
    block_payload_hash: $02a40dc8333f1de2$var$CODEC.BLOCK_PAYLOAD_HASH
};
const $02a40dc8333f1de2$var$AttestationWithDalSchema = {
    slot: $02a40dc8333f1de2$var$CODEC.INT16,
    level: $02a40dc8333f1de2$var$CODEC.INT32,
    round: $02a40dc8333f1de2$var$CODEC.INT32,
    block_payload_hash: $02a40dc8333f1de2$var$CODEC.BLOCK_PAYLOAD_HASH,
    dal_attestation: $02a40dc8333f1de2$var$CODEC.ZARITH
};
const $02a40dc8333f1de2$var$SeedNonceRevelationSchema = {
    level: $02a40dc8333f1de2$var$CODEC.INT32,
    nonce: $02a40dc8333f1de2$var$CODEC.RAW
};
const $02a40dc8333f1de2$var$ProposalsSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    period: $02a40dc8333f1de2$var$CODEC.INT32,
    proposals: $02a40dc8333f1de2$var$CODEC.PROPOSAL_ARR
};
const $02a40dc8333f1de2$var$RegisterGlobalConstantSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    value: $02a40dc8333f1de2$var$CODEC.VALUE
};
const $02a40dc8333f1de2$var$TransferTicketSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    ticket_contents: $02a40dc8333f1de2$var$CODEC.VALUE,
    ticket_ty: $02a40dc8333f1de2$var$CODEC.VALUE,
    ticket_ticketer: $02a40dc8333f1de2$var$CODEC.ADDRESS,
    ticket_amount: $02a40dc8333f1de2$var$CODEC.ZARITH,
    destination: $02a40dc8333f1de2$var$CODEC.ADDRESS,
    entrypoint: $02a40dc8333f1de2$var$CODEC.ENTRYPOINT
};
const $02a40dc8333f1de2$var$IncreasePaidStorageSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    amount: $02a40dc8333f1de2$var$CODEC.ZARITH,
    destination: $02a40dc8333f1de2$var$CODEC.SMART_CONTRACT_ADDRESS
};
const $02a40dc8333f1de2$var$UpdateConsensusKeySchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    pk: $02a40dc8333f1de2$var$CODEC.PUBLIC_KEY
};
const $02a40dc8333f1de2$var$DrainDelegateSchema = {
    consensus_key: $02a40dc8333f1de2$var$CODEC.PKH,
    delegate: $02a40dc8333f1de2$var$CODEC.PKH,
    destination: $02a40dc8333f1de2$var$CODEC.PKH
};
const $02a40dc8333f1de2$var$SetDepositsLimitSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    limit: $02a40dc8333f1de2$var$CODEC.DEPOSITS_LIMIT
};
const $02a40dc8333f1de2$var$SmartRollupOriginateSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    pvm_kind: $02a40dc8333f1de2$var$CODEC.PVM_KIND,
    kernel: $02a40dc8333f1de2$var$CODEC.PADDED_BYTES,
    parameters_ty: $02a40dc8333f1de2$var$CODEC.VALUE,
    whitelist: $02a40dc8333f1de2$var$CODEC.PKH_ARR
};
const $02a40dc8333f1de2$var$SmartRollupAddMessagesSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    message: $02a40dc8333f1de2$var$CODEC.SMART_ROLLUP_MESSAGE
};
const $02a40dc8333f1de2$var$SmartRollupExecuteOutboxMessageSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    rollup: $02a40dc8333f1de2$var$CODEC.SMART_ROLLUP_ADDRESS,
    cemented_commitment: $02a40dc8333f1de2$var$CODEC.SMART_ROLLUP_COMMITMENT_HASH,
    output_proof: $02a40dc8333f1de2$var$CODEC.PADDED_BYTES
};
const $02a40dc8333f1de2$var$DalPublishCommitmentSchema = {
    source: $02a40dc8333f1de2$var$CODEC.PKH,
    fee: $02a40dc8333f1de2$var$CODEC.ZARITH,
    counter: $02a40dc8333f1de2$var$CODEC.ZARITH,
    gas_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    storage_limit: $02a40dc8333f1de2$var$CODEC.ZARITH,
    slot_header: $02a40dc8333f1de2$var$CODEC.SLOT_HEADER
};
const $02a40dc8333f1de2$var$FailingNoopSchema = {
    arbitrary: $02a40dc8333f1de2$var$CODEC.PADDED_BYTES
};
const $02a40dc8333f1de2$var$operationEncoder = (encoders)=>(operation)=>{
        if (!(operation.kind in encoders) || !(operation.kind in $02a40dc8333f1de2$var$kindMappingReverse)) throw new (0, $6cde2a3388731e1b$export$bc5be87550569b55)(operation.kind);
        return $02a40dc8333f1de2$var$kindMappingReverse[operation.kind] + encoders[operation.kind](operation);
    };
const $02a40dc8333f1de2$var$operationDecoder = (decoders)=>(value)=>{
        const op = value.consume(1);
        const operationName = $02a40dc8333f1de2$var$kindMapping[op[0]];
        if (operationName === undefined) throw new $02a40dc8333f1de2$var$UnsupportedOperationError(op[0].toString());
        const decodedObj = decoders[operationName](value);
        if (typeof decodedObj !== 'object') throw new $02a40dc8333f1de2$var$OperationDecodingError('Invalid operation, cannot be decoded.');
        return Object.assign({
            kind: operationName
        }, decodedObj);
    };
const $02a40dc8333f1de2$var$schemaEncoder = (encoders)=>(schema)=>(value)=>{
            const keys = Object.keys(schema);
            return keys.reduce((prev, key)=>{
                const valueToEncode = schema[key];
                if (value && Array.isArray(valueToEncode)) {
                    const encoder = encoders[valueToEncode[0]];
                    const values = value[key];
                    if (!Array.isArray(values)) throw new $02a40dc8333f1de2$var$OperationEncodingError(`Invalid operation value "${JSON.stringify(values)}" of key "${key}, expected value to be Array.`);
                    return prev + values.reduce((prevBytes, current)=>prevBytes + encoder(current), '');
                } else {
                    const encoder = encoders[valueToEncode];
                    return prev + encoder(value[key]);
                }
            }, '');
        };
const $02a40dc8333f1de2$var$schemaDecoder = (decoders)=>(schema)=>(value)=>{
            const keys = Object.keys(schema);
            return keys.reduce((prev, key)=>{
                const valueToEncode = schema[key];
                if (Array.isArray(valueToEncode)) {
                    const decoder = decoders[valueToEncode[0]];
                    const decoded = [];
                    const lastLength = value.length();
                    while(value.length() > 0){
                        decoded.push(decoder(value));
                        if (lastLength === value.length()) throw new $02a40dc8333f1de2$var$OperationDecodingError('Unable to decode value');
                    }
                    return Object.assign(Object.assign({}, prev), {
                        [key]: decoded
                    });
                } else {
                    const decoder = decoders[valueToEncode];
                    const result = decoder(value);
                    if (typeof result !== 'undefined') return Object.assign(Object.assign({}, prev), {
                        [key]: result
                    });
                    else return Object.assign({}, prev);
                }
            }, {});
        };
const $02a40dc8333f1de2$var$decodersProto021 = {
    [$02a40dc8333f1de2$var$CODEC.SECRET]: (val)=>$02a40dc8333f1de2$var$toHexString(val.consume(20)),
    [$02a40dc8333f1de2$var$CODEC.RAW]: (val)=>$02a40dc8333f1de2$var$toHexString(val.consume(32)),
    [$02a40dc8333f1de2$var$CODEC.TZ1]: $02a40dc8333f1de2$var$tz1Decoder,
    [$02a40dc8333f1de2$var$CODEC.BRANCH]: $02a40dc8333f1de2$var$branchDecoder,
    [$02a40dc8333f1de2$var$CODEC.ZARITH]: $02a40dc8333f1de2$var$zarithDecoder,
    [$02a40dc8333f1de2$var$CODEC.PUBLIC_KEY]: $02a40dc8333f1de2$var$publicKeyDecoder,
    [$02a40dc8333f1de2$var$CODEC.PKH]: $02a40dc8333f1de2$var$publicKeyHashDecoder,
    [$02a40dc8333f1de2$var$CODEC.PKH_ARR]: $02a40dc8333f1de2$var$publicKeyHashesDecoder,
    [$02a40dc8333f1de2$var$CODEC.DELEGATE]: $02a40dc8333f1de2$var$delegateDecoder,
    [$02a40dc8333f1de2$var$CODEC.INT32]: $02a40dc8333f1de2$var$int32Decoder,
    [$02a40dc8333f1de2$var$CODEC.SCRIPT]: $02a40dc8333f1de2$var$scriptDecoder,
    [$02a40dc8333f1de2$var$CODEC.BALLOT_STATEMENT]: $02a40dc8333f1de2$var$ballotDecoder,
    [$02a40dc8333f1de2$var$CODEC.PROPOSAL]: $02a40dc8333f1de2$var$proposalDecoder,
    [$02a40dc8333f1de2$var$CODEC.PROPOSAL_ARR]: $02a40dc8333f1de2$var$proposalsDecoder,
    [$02a40dc8333f1de2$var$CODEC.PARAMETERS]: $02a40dc8333f1de2$var$parametersDecoder,
    [$02a40dc8333f1de2$var$CODEC.ADDRESS]: $02a40dc8333f1de2$var$addressDecoder,
    [$02a40dc8333f1de2$var$CODEC.SMART_ROLLUP_ADDRESS]: $02a40dc8333f1de2$var$smartRollupAddressDecoder,
    [$02a40dc8333f1de2$var$CODEC.SMART_CONTRACT_ADDRESS]: $02a40dc8333f1de2$var$smartContractAddressDecoder,
    [$02a40dc8333f1de2$var$CODEC.SMART_ROLLUP_COMMITMENT_HASH]: $02a40dc8333f1de2$var$smartRollupCommitmentHashDecoder,
    [$02a40dc8333f1de2$var$CODEC.VALUE]: $02a40dc8333f1de2$var$valueParameterDecoder,
    [$02a40dc8333f1de2$var$CODEC.INT16]: $02a40dc8333f1de2$var$int16Decoder,
    [$02a40dc8333f1de2$var$CODEC.BLOCK_PAYLOAD_HASH]: $02a40dc8333f1de2$var$blockPayloadHashDecoder,
    [$02a40dc8333f1de2$var$CODEC.ENTRYPOINT]: $02a40dc8333f1de2$var$entrypointNameDecoder,
    [$02a40dc8333f1de2$var$CODEC.BURN_LIMIT]: $02a40dc8333f1de2$var$burnLimitDecoder,
    [$02a40dc8333f1de2$var$CODEC.DEPOSITS_LIMIT]: $02a40dc8333f1de2$var$depositsLimitDecoder,
    [$02a40dc8333f1de2$var$CODEC.PVM_KIND]: $02a40dc8333f1de2$var$pvmKindDecoder,
    [$02a40dc8333f1de2$var$CODEC.PADDED_BYTES]: $02a40dc8333f1de2$var$paddedBytesDecoder,
    [$02a40dc8333f1de2$var$CODEC.SMART_ROLLUP_MESSAGE]: $02a40dc8333f1de2$var$smartRollupMessageDecoder,
    [$02a40dc8333f1de2$var$CODEC.SLOT_HEADER]: $02a40dc8333f1de2$var$slotHeaderDecoder
};
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OPERATION] = $02a40dc8333f1de2$var$operationDecoder($02a40dc8333f1de2$var$decodersProto021);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_ACTIVATE_ACCOUNT] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$ActivationSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_FAILING_NOOP] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$FailingNoopSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_DELEGATION] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$DelegationSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_TRANSACTION] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$TransactionSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_ORIGINATION] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$OriginationSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_BALLOT] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$BallotSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_ATTESTATION] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$AttestationSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_ATTESTATION_WITH_DAL] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$AttestationWithDalSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_SEED_NONCE_REVELATION] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$SeedNonceRevelationSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_PROPOSALS] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$ProposalsSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_REVEAL] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$RevealSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_REGISTER_GLOBAL_CONSTANT] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$RegisterGlobalConstantSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_TRANSFER_TICKET] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$TransferTicketSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_INCREASE_PAID_STORAGE] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$IncreasePaidStorageSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_UPDATE_CONSENSUS_KEY] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$UpdateConsensusKeySchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_DRAIN_DELEGATE] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$DrainDelegateSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_SMART_ROLLUP_ORIGINATE] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$SmartRollupOriginateSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_SMART_ROLLUP_ADD_MESSAGES] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$SmartRollupAddMessagesSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$SmartRollupExecuteOutboxMessageSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_DAL_PUBLISH_COMMITMENT] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$DalPublishCommitmentSchema)(val);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.MANAGER] = $02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$ManagerOperationSchema);
$02a40dc8333f1de2$var$decodersProto021[$02a40dc8333f1de2$var$CODEC.OP_SET_DEPOSITS_LIMIT] = (val)=>$02a40dc8333f1de2$var$schemaDecoder($02a40dc8333f1de2$var$decodersProto021)($02a40dc8333f1de2$var$SetDepositsLimitSchema)(val);
const $02a40dc8333f1de2$export$589f0c556f2c67ce = {
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SECRET]: (val)=>val,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.RAW]: (val)=>val,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.TZ1]: $02a40dc8333f1de2$var$tz1Encoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.BRANCH]: $02a40dc8333f1de2$var$branchEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.ZARITH]: $02a40dc8333f1de2$var$zarithEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PUBLIC_KEY]: $02a40dc8333f1de2$var$publicKeyEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PKH]: $02a40dc8333f1de2$var$publicKeyHashEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PKH_ARR]: $02a40dc8333f1de2$var$publicKeyHashesEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.DELEGATE]: $02a40dc8333f1de2$var$delegateEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SCRIPT]: $02a40dc8333f1de2$var$scriptEncoder,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.BALLOT_STATEMENT]: $02a40dc8333f1de2$var$ballotEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PROPOSAL]: $02a40dc8333f1de2$var$proposalEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PROPOSAL_ARR]: $02a40dc8333f1de2$var$proposalsEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.INT32]: $02a40dc8333f1de2$var$int32Encoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PARAMETERS]: $02a40dc8333f1de2$var$parametersEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.ADDRESS]: $02a40dc8333f1de2$var$addressEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SMART_ROLLUP_ADDRESS]: $02a40dc8333f1de2$var$smartRollupAddressEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SMART_CONTRACT_ADDRESS]: $02a40dc8333f1de2$var$smartContractAddressEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SMART_ROLLUP_COMMITMENT_HASH]: $02a40dc8333f1de2$var$smartRollupCommitmentHashEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.VALUE]: $02a40dc8333f1de2$var$valueParameterEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.INT16]: $02a40dc8333f1de2$var$int16Encoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.BLOCK_PAYLOAD_HASH]: $02a40dc8333f1de2$var$blockPayloadHashEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.ENTRYPOINT]: $02a40dc8333f1de2$var$entrypointNameEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.BURN_LIMIT]: $02a40dc8333f1de2$var$burnLimitEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.DEPOSITS_LIMIT]: $02a40dc8333f1de2$var$depositsLimitEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SIGNATURE_PROOF]: $02a40dc8333f1de2$var$signatureProofEncoder,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PVM_KIND]: $02a40dc8333f1de2$var$pvmKindEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.PADDED_BYTES]: $02a40dc8333f1de2$var$paddedBytesEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SMART_ROLLUP_MESSAGE]: $02a40dc8333f1de2$var$smartRollupMessageEncoder$1,
    [$02a40dc8333f1de2$export$9a139b626817ea5b.SLOT_HEADER]: $02a40dc8333f1de2$var$slotHeaderEncoder$1
};
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OPERATION] = $02a40dc8333f1de2$var$operationEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_ACTIVATE_ACCOUNT] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$ActivationSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_DELEGATION] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$DelegationSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_TRANSACTION] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$TransactionSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_ORIGINATION] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$OriginationSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_BALLOT] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$BallotSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_ATTESTATION] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$AttestationSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_ATTESTATION_WITH_DAL] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$AttestationWithDalSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_SEED_NONCE_REVELATION] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$SeedNonceRevelationSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_PROPOSALS] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$ProposalsSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_REVEAL] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$RevealSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_REGISTER_GLOBAL_CONSTANT] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$RegisterGlobalConstantSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_TRANSFER_TICKET] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$TransferTicketSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_INCREASE_PAID_STORAGE] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$IncreasePaidStorageSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_UPDATE_CONSENSUS_KEY] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$UpdateConsensusKeySchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_DRAIN_DELEGATE] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$DrainDelegateSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_SMART_ROLLUP_ORIGINATE] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$SmartRollupOriginateSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_SMART_ROLLUP_ADD_MESSAGES] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$SmartRollupAddMessagesSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$SmartRollupExecuteOutboxMessageSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_DAL_PUBLISH_COMMITMENT] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$DalPublishCommitmentSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.MANAGER] = $02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$ManagerOperationSchema$1);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_SET_DEPOSITS_LIMIT] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$SetDepositsLimitSchema$1)(val);
$02a40dc8333f1de2$export$589f0c556f2c67ce[$02a40dc8333f1de2$export$9a139b626817ea5b.OP_FAILING_NOOP] = (val)=>$02a40dc8333f1de2$var$schemaEncoder$1($02a40dc8333f1de2$export$589f0c556f2c67ce)($02a40dc8333f1de2$var$FailingNoopSchema$1)(val);
const $02a40dc8333f1de2$var$encodersProto021 = {
    [$02a40dc8333f1de2$var$CODEC.SECRET]: (val)=>val,
    [$02a40dc8333f1de2$var$CODEC.RAW]: (val)=>val,
    [$02a40dc8333f1de2$var$CODEC.TZ1]: $02a40dc8333f1de2$var$tz1Encoder,
    [$02a40dc8333f1de2$var$CODEC.BRANCH]: $02a40dc8333f1de2$var$branchEncoder,
    [$02a40dc8333f1de2$var$CODEC.ZARITH]: $02a40dc8333f1de2$var$zarithEncoder,
    [$02a40dc8333f1de2$var$CODEC.PUBLIC_KEY]: $02a40dc8333f1de2$var$publicKeyEncoder,
    [$02a40dc8333f1de2$var$CODEC.PKH]: $02a40dc8333f1de2$var$publicKeyHashEncoder,
    [$02a40dc8333f1de2$var$CODEC.PKH_ARR]: $02a40dc8333f1de2$var$publicKeyHashesEncoder,
    [$02a40dc8333f1de2$var$CODEC.DELEGATE]: $02a40dc8333f1de2$var$delegateEncoder,
    [$02a40dc8333f1de2$var$CODEC.SCRIPT]: $02a40dc8333f1de2$var$scriptEncoder,
    [$02a40dc8333f1de2$var$CODEC.BALLOT_STATEMENT]: $02a40dc8333f1de2$var$ballotEncoder,
    [$02a40dc8333f1de2$var$CODEC.PROPOSAL]: $02a40dc8333f1de2$var$proposalEncoder,
    [$02a40dc8333f1de2$var$CODEC.PROPOSAL_ARR]: $02a40dc8333f1de2$var$proposalsEncoder,
    [$02a40dc8333f1de2$var$CODEC.INT32]: $02a40dc8333f1de2$var$int32Encoder,
    [$02a40dc8333f1de2$var$CODEC.PARAMETERS]: $02a40dc8333f1de2$var$parametersEncoder,
    [$02a40dc8333f1de2$var$CODEC.ADDRESS]: $02a40dc8333f1de2$var$addressEncoder,
    [$02a40dc8333f1de2$var$CODEC.SMART_ROLLUP_ADDRESS]: $02a40dc8333f1de2$var$smartRollupAddressEncoder,
    [$02a40dc8333f1de2$var$CODEC.SMART_CONTRACT_ADDRESS]: $02a40dc8333f1de2$var$smartContractAddressEncoder,
    [$02a40dc8333f1de2$var$CODEC.SMART_ROLLUP_COMMITMENT_HASH]: $02a40dc8333f1de2$var$smartRollupCommitmentHashEncoder,
    [$02a40dc8333f1de2$var$CODEC.VALUE]: $02a40dc8333f1de2$var$valueParameterEncoder,
    [$02a40dc8333f1de2$var$CODEC.INT16]: $02a40dc8333f1de2$var$int16Encoder,
    [$02a40dc8333f1de2$var$CODEC.BLOCK_PAYLOAD_HASH]: $02a40dc8333f1de2$var$blockPayloadHashEncoder,
    [$02a40dc8333f1de2$var$CODEC.ENTRYPOINT]: $02a40dc8333f1de2$var$entrypointNameEncoder,
    [$02a40dc8333f1de2$var$CODEC.BURN_LIMIT]: $02a40dc8333f1de2$var$burnLimitEncoder,
    [$02a40dc8333f1de2$var$CODEC.DEPOSITS_LIMIT]: $02a40dc8333f1de2$var$depositsLimitEncoder,
    [$02a40dc8333f1de2$var$CODEC.PVM_KIND]: $02a40dc8333f1de2$var$pvmKindEncoder,
    [$02a40dc8333f1de2$var$CODEC.PADDED_BYTES]: $02a40dc8333f1de2$var$paddedBytesEncoder,
    [$02a40dc8333f1de2$var$CODEC.SMART_ROLLUP_MESSAGE]: $02a40dc8333f1de2$var$smartRollupMessageEncoder,
    [$02a40dc8333f1de2$var$CODEC.SLOT_HEADER]: $02a40dc8333f1de2$var$slotHeaderEncoder
};
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OPERATION] = $02a40dc8333f1de2$var$operationEncoder($02a40dc8333f1de2$var$encodersProto021);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_ACTIVATE_ACCOUNT] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$ActivationSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_DELEGATION] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$DelegationSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_TRANSACTION] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$TransactionSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_ORIGINATION] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$OriginationSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_BALLOT] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$BallotSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_ATTESTATION] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$AttestationSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_ATTESTATION_WITH_DAL] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$AttestationWithDalSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_SEED_NONCE_REVELATION] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$SeedNonceRevelationSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_PROPOSALS] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$ProposalsSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_REVEAL] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$RevealSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_REGISTER_GLOBAL_CONSTANT] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$RegisterGlobalConstantSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_TRANSFER_TICKET] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$TransferTicketSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_INCREASE_PAID_STORAGE] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$IncreasePaidStorageSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_UPDATE_CONSENSUS_KEY] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$UpdateConsensusKeySchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_DRAIN_DELEGATE] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$DrainDelegateSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_SMART_ROLLUP_ORIGINATE] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$SmartRollupOriginateSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_SMART_ROLLUP_ADD_MESSAGES] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$SmartRollupAddMessagesSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$SmartRollupExecuteOutboxMessageSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_DAL_PUBLISH_COMMITMENT] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$DalPublishCommitmentSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.MANAGER] = $02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$ManagerOperationSchema);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_SET_DEPOSITS_LIMIT] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$SetDepositsLimitSchema)(val);
$02a40dc8333f1de2$var$encodersProto021[$02a40dc8333f1de2$var$CODEC.OP_FAILING_NOOP] = (val)=>$02a40dc8333f1de2$var$schemaEncoder($02a40dc8333f1de2$var$encodersProto021)($02a40dc8333f1de2$var$FailingNoopSchema)(val);
const $02a40dc8333f1de2$var$OperationKindMapping = {
    activate_account: $02a40dc8333f1de2$var$ActivationSchema$1,
    reveal: $02a40dc8333f1de2$var$RevealSchema$1,
    delegation: $02a40dc8333f1de2$var$DelegationSchema$1,
    transaction: $02a40dc8333f1de2$var$TransactionSchema$1,
    origination: $02a40dc8333f1de2$var$OriginationSchema$1,
    ballot: $02a40dc8333f1de2$var$BallotSchema$1,
    attestation: $02a40dc8333f1de2$var$AttestationSchema$1,
    attestation_with_dal: $02a40dc8333f1de2$var$AttestationWithDalSchema$1,
    seed_nonce_revelation: $02a40dc8333f1de2$var$SeedNonceRevelationSchema$1,
    proposals: $02a40dc8333f1de2$var$ProposalsSchema$1,
    register_global_constant: $02a40dc8333f1de2$var$RegisterGlobalConstantSchema$1,
    transfer_ticket: $02a40dc8333f1de2$var$TransferTicketSchema$1,
    increase_paid_storage: $02a40dc8333f1de2$var$IncreasePaidStorageSchema$1,
    update_consensus_key: $02a40dc8333f1de2$var$UpdateConsensusKeySchema$1,
    drain_delegate: $02a40dc8333f1de2$var$DrainDelegateSchema$1,
    set_deposits_limit: $02a40dc8333f1de2$var$SetDepositsLimitSchema$1,
    smart_rollup_originate: $02a40dc8333f1de2$var$SmartRollupOriginateSchema$1,
    smart_rollup_add_messages: $02a40dc8333f1de2$var$SmartRollupAddMessagesSchema$1,
    smart_rollup_execute_outbox_message: $02a40dc8333f1de2$var$SmartRollupExecuteOutboxMessageSchema$1,
    dal_publish_commitment: $02a40dc8333f1de2$var$DalPublishCommitmentSchema$1,
    failing_noop: $02a40dc8333f1de2$var$FailingNoopSchema$1
};
// Asymmetric difference: only account for things in arr2 that are not present in arr1, not vice versa
const $02a40dc8333f1de2$var$getArrayDifference = (arr1, arr2)=>{
    return arr2.filter((x)=>!arr1.includes(x));
};
const $02a40dc8333f1de2$var$deleteArrayElementByValue = (array, item)=>{
    return array.filter((e)=>e !== item);
};
/**
 * @returns A boolean value to indicate whether the operation kind is valid or not
 */ const $02a40dc8333f1de2$var$validateOperationKind = (opKind)=>{
    const opKindList = Object.keys($02a40dc8333f1de2$var$OperationKindMapping);
    return opKindList.includes(opKind);
};
/**
 *  returns 0 when the two array of properties are identical or the passed property
 *  does not have any missing parameters from the corresponding schema
 *
 *  @returns array element differences if there are missing required property keys
 */ const $02a40dc8333f1de2$var$validateMissingProperty = (operationContent)=>{
    const kind = operationContent.kind;
    const keys = Object.keys(operationContent);
    const cleanKeys = $02a40dc8333f1de2$var$deleteArrayElementByValue(keys, 'kind');
    const schemaKeys = Object.keys($02a40dc8333f1de2$var$OperationKindMapping[kind]);
    return $02a40dc8333f1de2$var$getArrayDifference(cleanKeys, schemaKeys);
};
var $02a40dc8333f1de2$export$cf68b74f12b4139e;
(function(ProtocolsHash) {
    ProtocolsHash["Pt24m4xi"] = "Pt24m4xiPbLDhVgVfABUjirbmda3yohdN82Sp9FeuAXJ4eV9otd";
    ProtocolsHash["PsBABY5H"] = "PsBABY5HQTSkA4297zNHfsZNKtxULfL18y95qb3m53QJiXGmrbU";
    ProtocolsHash["PsBabyM1"] = "PsBabyM1eUXZseaJdmXFApDSBqj8YBfwELoxZHHW77EMcAbbwAS";
    ProtocolsHash["PsCARTHA"] = "PsCARTHAGazKbHtnKfLzQg3kms52kSRpgnDY982a9oYsSXRLQEb";
    ProtocolsHash["PsDELPH1"] = "PsDELPH1Kxsxt8f9eWbxQeRxkjfbxoqM52jvs5Y5fBxWWh4ifpo";
    ProtocolsHash["PtEdo2Zk"] = "PtEdo2ZkT9oKpimTah6x2embF25oss54njMuPzkJTEi5RqfdZFA";
    ProtocolsHash["PsFLorena"] = "PsFLorenaUUuikDWvMDr6fGBRG8kt3e3D3fHoXK1j1BFRxeSH4i";
    ProtocolsHash["PtGRANADs"] = "PtGRANADsDU8R9daYKAgWnQYAJ64omN1o3KMGVCykShA97vQbvV";
    ProtocolsHash["PtHangz2"] = "PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx";
    ProtocolsHash["Psithaca2"] = "Psithaca2MLRFYargivpo7YvUr7wUDqyxrdhC5CQq78mRvimz6A";
    ProtocolsHash["PtJakart2"] = "PtJakart2xVj7pYXJBXrqHgd82rdkLey5ZeeGwDgPp9rhQUbSqY";
    ProtocolsHash["PtKathman"] = "PtKathmankSpLLDALzWw7CGD2j2MtyveTwboEYokqUCP4a1LxMg";
    ProtocolsHash["PtLimaPtL"] = "PtLimaPtLMwfNinJi9rCfDPWea8dFgTZ1MeJ9f1m2SRic6ayiwW";
    ProtocolsHash["PtMumbaii"] = "PtMumbaiiFFEGbew1rRjzSPyzRbA51Tm3RVZL5suHPxSZYDhCEc";
    ProtocolsHash["PtMumbai2"] = "PtMumbai2TmsJHNGRkD8v8YDbtao7BLUC3wjASn1inAKLFCjaH1";
    ProtocolsHash["PtNairobi"] = "PtNairobiyssHuh87hEhfVBGCVrK3WnS8Z2FT4ymB5tAa4r1nQf";
    ProtocolsHash["ProxfordY"] = "ProxfordYmVfjWnRcgjWH36fW6PArwqykTFzotUxRs6gmTcZDuH";
    ProtocolsHash["PtParisBx"] = "PtParisBxoLz5gzMmn3d9WBQNoPSZakgnkMC2VNuQ3KXfUtUQeZ";
    ProtocolsHash["PsParisCZ"] = "PsParisCZo7KAh1Z1smVd9ZMZ1HHn5gkzbM94V3PLCpknFWhUAi";
    ProtocolsHash["PsQuebecn"] = "PsQuebecnLByd3JwTiGadoG4nGWi3HYiLXUjkibeFV8dCFeVMUg";
    ProtocolsHash["PsRiotuma"] = "PsRiotumaAMotcRoDWW1bysEhQy2n1M5fy8JgRp8jjRfHGmfeA7";
    ProtocolsHash["ProtoALpha"] = "ProtoALphaALphaALphaALphaALphaALphaALphaALphaDdp3zK";
})($02a40dc8333f1de2$export$cf68b74f12b4139e || ($02a40dc8333f1de2$export$cf68b74f12b4139e = {}));
const $02a40dc8333f1de2$var$protoLevel = {
    Pt24m4xiPbLDhVgVfABUjirbmda3yohdN82Sp9FeuAXJ4eV9otd: 4,
    PsBABY5HQTSkA4297zNHfsZNKtxULfL18y95qb3m53QJiXGmrbU: 5,
    PsBabyM1eUXZseaJdmXFApDSBqj8YBfwELoxZHHW77EMcAbbwAS: 5,
    PsCARTHAGazKbHtnKfLzQg3kms52kSRpgnDY982a9oYsSXRLQEb: 6,
    PsDELPH1Kxsxt8f9eWbxQeRxkjfbxoqM52jvs5Y5fBxWWh4ifpo: 7,
    PtEdo2ZkT9oKpimTah6x2embF25oss54njMuPzkJTEi5RqfdZFA: 8,
    PsFLorenaUUuikDWvMDr6fGBRG8kt3e3D3fHoXK1j1BFRxeSH4i: 9,
    PtGRANADsDU8R9daYKAgWnQYAJ64omN1o3KMGVCykShA97vQbvV: 10,
    PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx: 11,
    Psithaca2MLRFYargivpo7YvUr7wUDqyxrdhC5CQq78mRvimz6A: 12,
    PtJakart2xVj7pYXJBXrqHgd82rdkLey5ZeeGwDgPp9rhQUbSqY: 13,
    PtKathmankSpLLDALzWw7CGD2j2MtyveTwboEYokqUCP4a1LxMg: 14,
    PtLimaPtLMwfNinJi9rCfDPWea8dFgTZ1MeJ9f1m2SRic6ayiwW: 15,
    PtMumbaiiFFEGbew1rRjzSPyzRbA51Tm3RVZL5suHPxSZYDhCEc: 16,
    PtMumbai2TmsJHNGRkD8v8YDbtao7BLUC3wjASn1inAKLFCjaH1: 16,
    PtNairobiyssHuh87hEhfVBGCVrK3WnS8Z2FT4ymB5tAa4r1nQf: 17,
    ProxfordYmVfjWnRcgjWH36fW6PArwqykTFzotUxRs6gmTcZDuH: 19,
    PtParisBxoLz5gzMmn3d9WBQNoPSZakgnkMC2VNuQ3KXfUtUQeZ: 20,
    PsParisCZo7KAh1Z1smVd9ZMZ1HHn5gkzbM94V3PLCpknFWhUAi: 20,
    PsQuebecnLByd3JwTiGadoG4nGWi3HYiLXUjkibeFV8dCFeVMUg: 21,
    PsRiotumaAMotcRoDWW1bysEhQy2n1M5fy8JgRp8jjRfHGmfeA7: 22,
    ProtoALphaALphaALphaALphaALphaALphaALphaALphaDdp3zK: 23
};
function $02a40dc8333f1de2$var$ProtoInferiorTo(a, b) {
    return $02a40dc8333f1de2$var$protoLevel[a] < $02a40dc8333f1de2$var$protoLevel[b];
}
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $02a40dc8333f1de2$export$a4ad2735b021c132 = {
    "commitHash": "6a2c52b9e48b299dfc856149c1fa3388e77180ad",
    "version": "22.0.0"
};
/**
 * @packageDocumentation
 * @module @taquito/local-forging
 */ const $02a40dc8333f1de2$var$PROTOCOL_CURRENT = $02a40dc8333f1de2$export$cf68b74f12b4139e.PsRiotuma;
function $02a40dc8333f1de2$export$620fe4e858113ce9(codec, _proto) {
    // use encodersProto021 & decodersProto021 if it's quebec or prior
    if (_proto === $02a40dc8333f1de2$export$cf68b74f12b4139e.PsQuebecn || $02a40dc8333f1de2$var$ProtoInferiorTo(_proto, $02a40dc8333f1de2$export$cf68b74f12b4139e.PsQuebecn)) return {
        encoder: $02a40dc8333f1de2$var$encodersProto021[codec],
        decoder: (hex)=>{
            const consumer = $02a40dc8333f1de2$export$2ea09c189c142295.fromHexString(hex);
            return $02a40dc8333f1de2$var$decodersProto021[codec](consumer);
        }
    };
    else return {
        encoder: $02a40dc8333f1de2$export$589f0c556f2c67ce[codec],
        decoder: (hex)=>{
            const consumer = $02a40dc8333f1de2$export$2ea09c189c142295.fromHexString(hex);
            return $02a40dc8333f1de2$export$1e344c6b2c4b13e7[codec](consumer);
        }
    };
// TODO: Remove above if else once mainnet migrated into rio protocol and uncommon the return block below
// return {
//   encoder: encoders[codec],
//   decoder: (hex: string) => {
//     const consumer = Uint8ArrayConsumer.fromHexString(hex);
//     return decoders[codec](consumer) as any;
//   },
// };
}
class $02a40dc8333f1de2$export$99b12ddbeed7bd69 {
    constructor(protocolHash = $02a40dc8333f1de2$var$PROTOCOL_CURRENT){
        this.protocolHash = protocolHash;
        this.codec = $02a40dc8333f1de2$export$620fe4e858113ce9($02a40dc8333f1de2$export$9a139b626817ea5b.MANAGER, this.protocolHash);
    }
    forge(params) {
        const branchValidation = (0, $6ed3c564aba0f912$export$8a53803420cdc9be)(params.branch);
        if (branchValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $6cde2a3388731e1b$export$16fabd343bcdfd7b)(params.branch, (0, $6ed3c564aba0f912$export$a2057601792df650)(branchValidation));
        for (const content of params.contents){
            if (!$02a40dc8333f1de2$var$validateOperationKind(content.kind)) throw new (0, $6cde2a3388731e1b$export$bc5be87550569b55)(content.kind);
            const diff = $02a40dc8333f1de2$var$validateMissingProperty(content);
            if (diff.length === 1) {
                if (content.kind === 'delegation' && diff[0] === 'delegate') continue;
                else if (content.kind === 'origination' && diff[0] === 'delegate') continue;
                else if (content.kind === 'transaction' && diff[0] === 'parameters') continue;
                else if (content.kind === 'set_deposits_limit' && diff[0] === 'limit') continue;
                else if (content.kind === 'smart_rollup_originate' && diff[0] === 'whitelist') continue;
                else if (content.kind === 'update_consensus_key' && diff[0] === 'proof') continue;
                else throw new $02a40dc8333f1de2$var$InvalidOperationSchemaError(content, `missing properties "${diff.join(', ')}"`);
            } else if (diff.length > 1) throw new $02a40dc8333f1de2$var$InvalidOperationSchemaError(content, `missing properties "${diff.join(', ')}"`);
        }
        const forged = this.codec.encoder(params).toLowerCase();
        return Promise.resolve(forged);
    }
    parse(hex) {
        return Promise.resolve(this.codec.decoder(hex));
    }
}
const $02a40dc8333f1de2$export$2eabd168525372f1 = new $02a40dc8333f1de2$export$99b12ddbeed7bd69();


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $2fea24c565181d86$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2fea24c565181d86$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2fea24c565181d86$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $2fea24c565181d86$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
function $2fea24c565181d86$var$formatErrorMessage(error, stringToReplace) {
    const body = JSON.parse(error.body);
    if (body[0] && body[0].kind && body[0].msg) {
        const newBody = JSON.stringify({
            kind: body[0].kind,
            id: body[0].id,
            msg: body[0].msg.replace(stringToReplace, '')
        });
        return new (0, $6cc77aa71b64d012$export$d2f2761cbe9cebf2)(`Http error response: (${error.status}) ${newBody}`, error.status, error.statusText, newBody, error.url);
    } else return error;
}
class $2fea24c565181d86$export$e81caaa38ad97a2 {
    constructor(context){
        this.context = context;
    }
    inject(signedOperationBytes) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            let hash;
            try {
                hash = yield this.context.rpc.injectOperation(signedOperationBytes);
            } catch (error) {
                const stringToStrip = '. You may want to use --replace to provide adequate fee and replace it';
                if (error instanceof (0, $6cc77aa71b64d012$export$d2f2761cbe9cebf2) && error.message.includes(stringToStrip)) throw $2fea24c565181d86$var$formatErrorMessage(error, stringToStrip);
                else throw error;
            }
            return hash;
        });
    }
}
/**
 *  @category Error
 *  @description Error that indicates no signer has been configured in the TezosToolkit instance
 */ class $2fea24c565181d86$var$UnconfiguredSignerError extends (0, $580df0c6131ecaba$export$32f4d70b2fb302b1) {
    constructor(){
        super();
        this.name = 'UnconfiguredSignerError';
        this.message = 'No signer has been configured. Please configure one by calling setProvider({signer}) on your TezosToolkit instance.';
    }
}
/**
 * @description Default signer implementation which does nothing and produce invalid signature
 * @throw {@link UnconfiguredSignerError}
 */ class $2fea24c565181d86$var$NoopSigner {
    publicKey() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            throw new $2fea24c565181d86$var$UnconfiguredSignerError();
        });
    }
    publicKeyHash() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            throw new $2fea24c565181d86$var$UnconfiguredSignerError();
        });
    }
    secretKey() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            throw new $2fea24c565181d86$var$UnconfiguredSignerError();
        });
    }
    sign(_bytes, _watermark) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            throw new $2fea24c565181d86$var$UnconfiguredSignerError();
        });
    }
}
function $2fea24c565181d86$var$createObservableFromSubscription(sub) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)((subscriber)=>{
        sub.on('data', (data)=>{
            subscriber.next(data);
        });
        sub.on('error', (error)=>{
            subscriber.error(error);
        });
        sub.on('close', ()=>{
            subscriber.complete();
        });
        return ()=>{
            sub.close();
        };
    });
}
/**
 * @deprecated default reveal gasLimit please use getRevealGasLimit(address) instead, removing hardcoded gasLimit of delegation, origination and transfer
 */ const $2fea24c565181d86$export$675c8beda367aa70 = {
    DELEGATION: 10600,
    ORIGINATION: 10600,
    TRANSFER: 10600,
    REVEAL_TZ1: 1000,
    REVEAL_TZ2: 1000,
    REVEAL_TZ3: 2000,
    REVEAL_TZ4: 2000
};
/**
 * @deprecated default reveal fee please use getRevealFee(address) instead, removing hardcoded fee of delegation, origination and transfer
 */ const $2fea24c565181d86$export$5253b4cb14a0057d = {
    DELEGATION: 1257,
    ORIGINATION: 10000,
    TRANSFER: 10000,
    REVEAL: 374
};
/**
 * @deprecated default reveal storageLimit please use REVEAL_STORAGE_LIMIT instead, removing hardcoded storageLimit of delegation, origination and transfer
 */ const $2fea24c565181d86$export$309032a94a558206 = {
    DELEGATION: 0,
    ORIGINATION: 257,
    TRANSFER: 257,
    REVEAL: 0
};
// value is based on octez-client reveal operation gasLimit of each address type in Rio Protocol
const $2fea24c565181d86$var$REVEAL_GAS_LIMIT = {
    TZ1: 169,
    TZ2: 155,
    TZ3: 445,
    TZ4: 1674
};
// value is based on octez-client reveal operation fee of each address type in Rio Protocol
const $2fea24c565181d86$var$REVEAL_FEE = {
    TZ1: 276,
    TZ2: 276,
    TZ3: 305,
    TZ4: 477
};
// value is based on octez-client reveal operation storageLimit of all address type in Rio Protocol
const $2fea24c565181d86$export$7dc909734d086289 = 0;
// protocol constants in Rio Protocol
const $2fea24c565181d86$export$c39b0b5305f5c11f = 257;
// protocol constants in Rio Protocol
const $2fea24c565181d86$export$961faea0d634ab07 = 250;
var $2fea24c565181d86$export$8b0851cfdd1d5bdc;
(function(Protocols) {
    Protocols["Pt24m4xi"] = "Pt24m4xiPbLDhVgVfABUjirbmda3yohdN82Sp9FeuAXJ4eV9otd";
    Protocols["PsBABY5H"] = "PsBABY5HQTSkA4297zNHfsZNKtxULfL18y95qb3m53QJiXGmrbU";
    Protocols["PsBabyM1"] = "PsBabyM1eUXZseaJdmXFApDSBqj8YBfwELoxZHHW77EMcAbbwAS";
    Protocols["PsCARTHA"] = "PsCARTHAGazKbHtnKfLzQg3kms52kSRpgnDY982a9oYsSXRLQEb";
    Protocols["PsDELPH1"] = "PsDELPH1Kxsxt8f9eWbxQeRxkjfbxoqM52jvs5Y5fBxWWh4ifpo";
    Protocols["PtEdo2Zk"] = "PtEdo2ZkT9oKpimTah6x2embF25oss54njMuPzkJTEi5RqfdZFA";
    Protocols["PsFLorena"] = "PsFLorenaUUuikDWvMDr6fGBRG8kt3e3D3fHoXK1j1BFRxeSH4i";
    Protocols["PtGRANADs"] = "PtGRANADsDU8R9daYKAgWnQYAJ64omN1o3KMGVCykShA97vQbvV";
    Protocols["PtHangz2"] = "PtHangz2aRngywmSRGGvrcTyMbbdpWdpFKuS4uMWxg2RaH9i1qx";
    Protocols["PsiThaCa"] = "PsiThaCaT47Zboaw71QWScM8sXeMM7bbQFncK9FLqYc6EKdpjVP";
    Protocols["Psithaca2"] = "Psithaca2MLRFYargivpo7YvUr7wUDqyxrdhC5CQq78mRvimz6A";
    Protocols["PtJakart2"] = "PtJakart2xVj7pYXJBXrqHgd82rdkLey5ZeeGwDgPp9rhQUbSqY";
    Protocols["PtKathman"] = "PtKathmankSpLLDALzWw7CGD2j2MtyveTwboEYokqUCP4a1LxMg";
    Protocols["PtLimaPtL"] = "PtLimaPtLMwfNinJi9rCfDPWea8dFgTZ1MeJ9f1m2SRic6ayiwW";
    Protocols["PtMumbaii"] = "PtMumbaiiFFEGbew1rRjzSPyzRbA51Tm3RVZL5suHPxSZYDhCEc";
    Protocols["PtMumbai2"] = "PtMumbai2TmsJHNGRkD8v8YDbtao7BLUC3wjASn1inAKLFCjaH1";
    Protocols["PtNairobi"] = "PtNairobiyssHuh87hEhfVBGCVrK3WnS8Z2FT4ymB5tAa4r1nQf";
    Protocols["ProxfordY"] = "ProxfordYmVfjWnRcgjWH36fW6PArwqykTFzotUxRs6gmTcZDuH";
    Protocols["PtParisBx"] = "PtParisBxoLz5gzMmn3d9WBQNoPSZakgnkMC2VNuQ3KXfUtUQeZ";
    Protocols["PsParisCZ"] = "PsParisCZo7KAh1Z1smVd9ZMZ1HHn5gkzbM94V3PLCpknFWhUAi";
    Protocols["PsQuebecn"] = "PsQuebecnLByd3JwTiGadoG4nGWi3HYiLXUjkibeFV8dCFeVMUg";
    Protocols["PsRiotuma"] = "PsRiotumaAMotcRoDWW1bysEhQy2n1M5fy8JgRp8jjRfHGmfeA7";
    Protocols["ProtoALpha"] = "ProtoALphaALphaALphaALphaALphaALphaALphaALphaDdp3zK";
})($2fea24c565181d86$export$8b0851cfdd1d5bdc || ($2fea24c565181d86$export$8b0851cfdd1d5bdc = {}));
const $2fea24c565181d86$export$6c805ddc3bf825c2 = {
    '004': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.Pt24m4xi
    ],
    '005': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PsBABY5H,
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PsBabyM1
    ],
    '006': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PsCARTHA
    ],
    '007': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PsDELPH1
    ],
    '008': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PtEdo2Zk
    ],
    '009': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PsFLorena
    ],
    '010': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PtGRANADs
    ],
    '011': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PtHangz2
    ],
    '012': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PsiThaCa,
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.Psithaca2
    ],
    '013': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PtJakart2
    ],
    '014': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PtKathman
    ],
    '015': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PtLimaPtL
    ],
    '016': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PtMumbai2
    ],
    '017': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PtNairobi
    ],
    '019': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.ProxfordY
    ],
    '020': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PtParisBx,
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PsParisCZ
    ],
    '021': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PsQuebecn
    ],
    '022': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.PsRiotuma
    ],
    '023': [
        $2fea24c565181d86$export$8b0851cfdd1d5bdc.ProtoALpha
    ]
};
var $2fea24c565181d86$export$89b6ee632056a8b6;
(function(ChainIds) {
    ChainIds["MAINNET"] = "NetXdQprcVkpaWU";
    ChainIds["CARTHAGENET"] = "NetXjD3HPJJjmcd";
    ChainIds["DELPHINET"] = "NetXm8tYqnMWky1";
    ChainIds["EDONET"] = "NetXSgo1ZT2DRUG";
    ChainIds["FLORENCENET"] = "NetXxkAx4woPLyu";
    ChainIds["GRANADANET"] = "NetXz969SFaFn8k";
    ChainIds["HANGZHOUNET"] = "NetXZSsxBpMQeAT";
    ChainIds["ITHACANET"] = "NetXbhmtAbMukLc";
    ChainIds["ITHACANET2"] = "NetXnHfVqm9iesp";
    ChainIds["JAKARTANET2"] = "NetXLH1uAxK7CCh";
    ChainIds["KATHMANDUNET"] = "NetXazhm4yetmff";
    ChainIds["LIMANET"] = "NetXizpkH94bocH";
    ChainIds["MUMBAINET"] = "NetXQw6nWSnrJ5t";
    ChainIds["MUMBAINET2"] = "NetXgbcrNtXD2yA";
    ChainIds["NAIROBINET"] = "NetXyuzvDo2Ugzb";
    ChainIds["OXFORDNET2"] = "NetXxWsskGahzQB";
    ChainIds["PARISBNET"] = "NetXo8SqH1c38SS";
    ChainIds["PARISCNET"] = "NetXXWAHLEvre9b";
    ChainIds["QUEBECNET"] = "NetXuTeGinLEqxp";
    ChainIds["RIONET"] = "NetXPdgaoabtBth";
})($2fea24c565181d86$export$89b6ee632056a8b6 || ($2fea24c565181d86$export$89b6ee632056a8b6 = {}));
// A fixed fee reveal operation gasLimit accepted by both simulate and injection endpoint is between 1.2-5 times of actual gas consumption (3.5 fails occasionally with gas exhausted; 4 fails occasionally with fee too low)
const $2fea24c565181d86$export$199fe2d87a4763cf = (address)=>Math.round($2fea24c565181d86$var$getRevealGasLimitInternal(address) * 37 / 10);
const $2fea24c565181d86$var$getRevealGasLimitInternal = (address)=>{
    switch(address.substring(0, 3)){
        case 'tz1':
            return $2fea24c565181d86$var$REVEAL_GAS_LIMIT.TZ1;
        case 'tz2':
            return $2fea24c565181d86$var$REVEAL_GAS_LIMIT.TZ2;
        case 'tz3':
            return $2fea24c565181d86$var$REVEAL_GAS_LIMIT.TZ3;
        case 'tz4':
            return $2fea24c565181d86$var$REVEAL_GAS_LIMIT.TZ4;
        default:
            throw new Error(`Cannot estimate reveal gas limit for ${address}`);
    }
};
const $2fea24c565181d86$export$2a009c06b05c06b7 = (address)=>Math.round($2fea24c565181d86$export$970feb211f171a98(address) * 12 / 10);
const $2fea24c565181d86$export$970feb211f171a98 = (address)=>{
    switch(address.substring(0, 3)){
        case 'tz1':
            return $2fea24c565181d86$var$REVEAL_FEE.TZ1;
        case 'tz2':
            return $2fea24c565181d86$var$REVEAL_FEE.TZ2;
        case 'tz3':
            return $2fea24c565181d86$var$REVEAL_FEE.TZ3;
        case 'tz4':
            return $2fea24c565181d86$var$REVEAL_FEE.TZ4;
        default:
            throw new Error(`Cannot estimate reveal fee for ${address}`);
    }
};
/**
 *  @category Error
 *  @description Error that indicates invalid smart contract parameters being passed or used
 */ class $2fea24c565181d86$export$e569b97a5d46005c extends (0, $580df0c6131ecaba$export$9d3f3bc8b6d48950) {
    constructor(smartContractMethodName, sigs, invalidParams){
        super();
        this.smartContractMethodName = smartContractMethodName;
        this.sigs = sigs;
        this.invalidParams = invalidParams;
        this.name = 'InvalidParameterError';
        this.message = `${smartContractMethodName} Received ${invalidParams.length} arguments while expecting one of the following signatures (${JSON.stringify(sigs)})`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid delegation source contract address being passed or used
 */ class $2fea24c565181d86$export$ccd4de17604f1cb4 extends (0, $580df0c6131ecaba$export$9d3f3bc8b6d48950) {
    constructor(source){
        super();
        this.source = source;
        this.name = `InvalidDelegationSource`;
        this.message = `Since Babylon delegation source can no longer be a contract address ${source}. Please use the smart contract abstraction to set your delegate.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid smart contract code parameter being passed or used
 */ class $2fea24c565181d86$export$6831bff83789e2ca extends (0, $580df0c6131ecaba$export$9d3f3bc8b6d48950) {
    constructor(message, data){
        super();
        this.message = message;
        this.data = data;
        this.name = 'InvalidCodeParameter';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid smart contract init parameter being passed or used
 */ class $2fea24c565181d86$export$12aaf24e6220866b extends (0, $580df0c6131ecaba$export$9d3f3bc8b6d48950) {
    constructor(message, data){
        super();
        this.message = message;
        this.data = data;
        this.name = 'InvalidInitParameter';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure when conducting a view simulation
 */ class $2fea24c565181d86$export$7a371d5bcddb4bc0 extends (0, $580df0c6131ecaba$export$5460eff990f31920) {
    constructor(message, viewName, failWith, cause){
        super();
        this.message = message;
        this.viewName = viewName;
        this.failWith = failWith;
        this.cause = cause;
        this.name = 'ViewSimulationError';
    }
}
const $2fea24c565181d86$export$6ead28c0ab00fb75 = (error)=>{
    if ($2fea24c565181d86$var$isJsonString(error.body)) {
        const parsedError = JSON.parse(error.body);
        if (Array.isArray(parsedError) && 'with' in parsedError[parsedError.length - 1]) return parsedError[parsedError.length - 1].with;
    }
};
const $2fea24c565181d86$var$isJsonString = (str)=>{
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};
/**
 *  @category Error
 *  @description Error that indicates invalid or unconfigured context when executing a view
 */ class $2fea24c565181d86$export$ff1e6a1fdce32aa4 extends (0, $580df0c6131ecaba$export$9d3f3bc8b6d48950) {
    constructor(info){
        super();
        this.info = info;
        this.name = 'InvalidViewSimulationContext';
        this.message = `${info} Please configure the context of the view execution in the executeView method.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates a mistake happening during the reveal operation
 */ class $2fea24c565181d86$export$eb140f52edb72859 extends (0, $580df0c6131ecaba$export$5460eff990f31920) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'RevealOperationError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a mistake in the parameters in the preparation of an Origination operation
 */ class $2fea24c565181d86$export$161bb6caa7045707 extends (0, $580df0c6131ecaba$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid balance being passed or used
 */ class $2fea24c565181d86$export$94f1b86f3b704c27 extends (0, $580df0c6131ecaba$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'InvalidBalanceError';
    }
}
const $2fea24c565181d86$export$eb3995ea1d48ce9e = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ pkh: pkh, secret: secret }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).ACTIVATION,
            pkh: pkh,
            secret: secret
        };
    });
const $2fea24c565181d86$export$64dd15b44cde1e0b = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ code: code, init: init, balance: balance = '0', delegate: delegate, storage: storage, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, mutez: mutez = false }) {
        if (storage !== undefined && init !== undefined) throw new $2fea24c565181d86$export$161bb6caa7045707('Storage and Init cannot be set a the same time. Please either use storage or init but not both.');
        if (!Array.isArray(code)) throw new $2fea24c565181d86$export$6831bff83789e2ca('Wrong code parameter type, expected an array', code);
        let contractStorage;
        if (storage !== undefined) {
            const storageType = code.find((p)=>'prim' in p && p.prim === 'storage');
            if ((storageType === null || storageType === void 0 ? void 0 : storageType.args) === undefined) throw new $2fea24c565181d86$export$6831bff83789e2ca('The storage section is missing from the script', code);
            const schema = new (0, $c46b7dbea18e1f8c$export$19342e026b58ebb7)(storageType.args[0]); // TODO
            contractStorage = schema.Encode(storage);
        } else if (init !== undefined && typeof init === 'object') contractStorage = init;
        else throw new $2fea24c565181d86$export$12aaf24e6220866b('Wrong init parameter type, expected JSON Michelson', init);
        const script = {
            code: code,
            storage: contractStorage
        };
        if (isNaN(Number(balance))) throw new $2fea24c565181d86$export$94f1b86f3b704c27(`Invalid Balance "${balance}", cannot be converted to a number`);
        const operation = {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            balance: mutez ? balance.toString() : (0, $6ed3c564aba0f912$export$d9468344d3651243)('tz', 'mutez', balance).toString(),
            script: script
        };
        if (delegate) operation.delegate = delegate;
        return operation;
    });
const $2fea24c565181d86$export$f3a9991068ba8db1 = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ to: to, amount: amount, parameter: parameter, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, mutez: mutez = false }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            amount: mutez ? amount.toString() : (0, $6ed3c564aba0f912$export$d9468344d3651243)('tz', 'mutez', amount).toString(),
            destination: to,
            parameters: parameter
        };
    });
const $2fea24c565181d86$export$f6ca8c66abd5d967 = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ delegate: delegate, source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit }) {
        const operation = {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            delegate: delegate
        };
        return operation;
    });
const $2fea24c565181d86$export$1823ae131c107679 = (_a, source_1)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a,
        source_1
    ], void 0, function*({ fee: fee, gasLimit: gasLimit, storageLimit: storageLimit }, source) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            delegate: source
        };
    });
const $2fea24c565181d86$export$638a1bb58510476 = (_a, source_1, publicKey_1)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a,
        source_1,
        publicKey_1
    ], void 0, function*({ fee: fee, gasLimit: gasLimit, storageLimit: storageLimit }, source, publicKey) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).REVEAL,
            fee: fee,
            public_key: publicKey,
            source: source,
            gas_limit: gasLimit !== null && gasLimit !== void 0 ? gasLimit : $2fea24c565181d86$export$199fe2d87a4763cf(source),
            storage_limit: storageLimit
        };
    });
const $2fea24c565181d86$export$36ba5bd34bec1f48 = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ value: value, source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT,
            value: value,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            source: source
        };
    });
const $2fea24c565181d86$export$c2b0bb52eb4f8f40 = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ ticketContents: ticketContents, ticketTy: ticketTy, ticketTicketer: ticketTicketer, ticketAmount: ticketAmount, destination: destination, entrypoint: entrypoint, source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSFER_TICKET,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            source: source,
            ticket_contents: ticketContents,
            ticket_ty: ticketTy,
            ticket_ticketer: ticketTicketer,
            ticket_amount: ticketAmount,
            destination: destination,
            entrypoint: entrypoint
        };
    });
const $2fea24c565181d86$export$8bbbca5738264f6e = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, amount: amount, destination: destination }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            amount: amount,
            destination: destination
        };
    });
const $2fea24c565181d86$export$3f02b23ff3ed5b1f = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ consensus_key: consensus_key, delegate: delegate, destination: destination }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).DRAIN_DELEGATE,
            consensus_key: consensus_key,
            delegate: delegate,
            destination: destination
        };
    });
const $2fea24c565181d86$export$21e0e83bb1296bf6 = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ source: source, proposal: proposal, ballot: ballot }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).BALLOT,
            source: source,
            proposal: proposal,
            ballot: ballot
        };
    });
const $2fea24c565181d86$export$a50446e8b0c2fbdd = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ source: source, proposals: proposals }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).PROPOSALS,
            source: source,
            proposals: proposals
        };
    });
const $2fea24c565181d86$export$ca68d75e3dde8c6 = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, pk: pk }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).UPDATE_CONSENSUS_KEY,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            pk: pk
        };
    });
const $2fea24c565181d86$export$e778921f9c3d1912 = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, message: message }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            message: message
        };
    });
const $2fea24c565181d86$export$7119c95759340192 = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, pvmKind: pvmKind, kernel: kernel, parametersType: parametersType }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            pvm_kind: pvmKind,
            kernel: kernel,
            parameters_ty: parametersType
        };
    });
const $2fea24c565181d86$export$4b4c6fb209c7f56d = (_a)=>$2fea24c565181d86$var$__awaiter(void 0, [
        _a
    ], void 0, function*({ source: source, fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, rollup: rollup, cementedCommitment: cementedCommitment, outputProof: outputProof }) {
        return {
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE,
            source: source,
            fee: fee,
            gas_limit: gasLimit,
            storage_limit: storageLimit,
            rollup: rollup,
            cemented_commitment: cementedCommitment,
            output_proof: outputProof
        };
    });
const $2fea24c565181d86$export$e8a70403e22ec9da = (op, kind)=>{
    return Object.assign(Object.assign({}, op), {
        kind: kind
    });
};
const $2fea24c565181d86$export$c585b8ca7df7709f = (arr, kind)=>{
    if (Array.isArray(arr)) {
        const found = arr.find((op)=>op.kind === kind);
        if (found && $2fea24c565181d86$export$427fc28e09dcdd3d(found, kind)) return found;
    }
};
const $2fea24c565181d86$export$427fc28e09dcdd3d = (op, kind)=>{
    return op.kind === kind;
};
const $2fea24c565181d86$export$5ebdc3eb4194b813 = (op)=>{
    if (op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION && op.parameters) return true;
    else return [
        'origination',
        'register_global_constant',
        'transfer_ticket',
        'update_consensus_key',
        'smart_rollup_add_messages',
        'smart_rollup_originate'
    ].indexOf(op.kind) !== -1;
};
const $2fea24c565181d86$export$7a57b5299ba95181 = (op)=>{
    return [
        'transaction',
        'delegation',
        'origination',
        'reveal',
        'register_global_constant',
        'increase_paid_storage',
        'transfer_ticket',
        'update_consensus_key',
        'smart_rollup_add_messages',
        'smart_rollup_originate',
        'smart_rollup_execute_outbox_message'
    ].indexOf(op.kind) !== -1;
};
const $2fea24c565181d86$export$6373ada671863245 = (op)=>{
    return [
        'transaction',
        'delegation',
        'origination',
        'register_global_constant',
        'increase_paid_storage',
        'transfer_ticket',
        'update_consensus_key',
        'smart_rollup_add_messages',
        'smart_rollup_originate',
        'smart_rollup_execute_outbox_message'
    ].indexOf(op.kind) !== -1;
};
const $2fea24c565181d86$export$d24863bb967c5c58 = (op)=>{
    return [
        'transaction',
        'delegation',
        'origination',
        'reveal',
        'ballot'
    ].indexOf(op.kind) !== -1;
};
const $2fea24c565181d86$export$fc04a41421709487 = (op)=>{
    return 'metadata' in op;
};
const $2fea24c565181d86$export$d3f32861fe419773 = (op)=>{
    return $2fea24c565181d86$export$fc04a41421709487(op) && 'operation_result' in op.metadata;
};
const $2fea24c565181d86$export$510616dc15a24552 = (op)=>{
    return $2fea24c565181d86$export$fc04a41421709487(op) && 'internal_operation_results' in op.metadata;
};
const $2fea24c565181d86$var$isErrorWithMessage = (error)=>{
    return 'with' in error;
};
/**
 *  @category Error
 *  @description Generic tezos error that will be thrown when a mistake occurs when doing an operation; more details here https://tezos.gitlab.io/api/errors.html
 */ class $2fea24c565181d86$export$a971cb9d7d565551 extends (0, $580df0c6131ecaba$export$5460eff990f31920) {
    constructor(errors, errorDetails, operationsWithResults){
        super();
        this.errors = errors;
        this.errorDetails = errorDetails;
        this.operationsWithResults = operationsWithResults;
        this.name = 'TezosOperationError';
        // Last error is 'often' the one with more detail
        this.lastError = errors[errors.length - 1];
        this.message = `(${this.kind}) ${this.id}`;
        if ($2fea24c565181d86$var$isErrorWithMessage(this.lastError)) {
            if (this.lastError.with.string) this.message = this.lastError.with.string;
            else if (this.lastError.with.int) this.message = this.lastError.with.int;
            else this.message = JSON.stringify(this.lastError.with);
        }
    }
    get id() {
        return this.lastError.id;
    }
    get kind() {
        return this.lastError.kind;
    }
}
/**
 *  @category Error
 *  @description Tezos error that will be thrown when a mistake happens during the preapply stage
 */ class $2fea24c565181d86$export$82778791b4c7e912 extends Error {
    constructor(result){
        super();
        this.result = result;
        this.name = 'TezosPreapplyFailureError';
        this.message = 'Preapply returned an unexpected result';
    }
}
// Flatten all operation content results and internal operation results into a single array
// Some cases where we can have multiple operation results or internal operation results are:
// - When an operation includes a reveal operation
// - When an operation is made using the batch API
// - Smart contract call can contains internal operation results when they call other smart contract internally or originate contracts
const $2fea24c565181d86$var$flattenOperationResult = (response)=>{
    const results = Array.isArray(response) ? response : [
        response
    ];
    const returnedResults = [];
    for(let i = 0; i < results.length; i++)for(let j = 0; j < results[i].contents.length; j++){
        const content = results[i].contents[j];
        if ($2fea24c565181d86$export$d3f32861fe419773(content) && 'fee' in content) {
            returnedResults.push(Object.assign({
                fee: content.fee
            }, content.metadata.operation_result));
            if (Array.isArray(content.metadata.internal_operation_results)) content.metadata.internal_operation_results.forEach((x)=>returnedResults.push(x.result));
        }
    }
    return returnedResults;
};
/***
 * @description Flatten all error from preapply response (including internal error)
 */ const $2fea24c565181d86$var$flattenErrors = (response, status = 'failed')=>{
    const results = Array.isArray(response) ? response : [
        response
    ];
    let errors = [];
    // Transaction that do not fail will be backtracked in case one failure occur
    for(let i = 0; i < results.length; i++)for(let j = 0; j < results[i].contents.length; j++){
        const content = results[i].contents[j];
        if ($2fea24c565181d86$export$fc04a41421709487(content)) {
            if ($2fea24c565181d86$export$d3f32861fe419773(content) && content.metadata.operation_result.status === status) errors = errors.concat(content.metadata.operation_result.errors || []);
            if ($2fea24c565181d86$export$510616dc15a24552(content) && Array.isArray(content.metadata.internal_operation_results)) {
                for (const internalResult of content.metadata.internal_operation_results)if ('result' in internalResult && internalResult.result.status === status) errors = errors.concat(internalResult.result.errors || []);
            }
        }
    }
    return errors;
};
/**
 *  @category Error
 *  @description Error that indicates a general failure happening during an origination operation.
 */ class $2fea24c565181d86$var$OriginationOperationError extends (0, $580df0c6131ecaba$export$e5619b407b1c8b0a) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'OriginationOperationError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid estimate value being passed
 */ class $2fea24c565181d86$export$274a49fe3e42e72c extends (0, $580df0c6131ecaba$export$9d3f3bc8b6d48950) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'InvalidEstimateValueError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid confirmation count has been passed or configured
 */ class $2fea24c565181d86$var$InvalidConfirmationCountError extends (0, $580df0c6131ecaba$export$9d3f3bc8b6d48950) {
    constructor(invalidConfirmations){
        super();
        this.invalidConfirmations = invalidConfirmations;
        this.name = 'InvalidConfirmationCountError';
        this.message = `Invalid confirmation count ${invalidConfirmations} expecting at least 1`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates that confirmation polling timed out
 */ class $2fea24c565181d86$var$ConfirmationTimeoutError extends (0, $580df0c6131ecaba$export$bae979e68e4dc802) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ConfirmationTimeoutError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an error being returned from the RPC response
 */ class $2fea24c565181d86$var$RPCResponseError extends (0, $580df0c6131ecaba$export$5460eff990f31920) {
    constructor(message, cause){
        super();
        this.message = message;
        this.cause = cause;
        this.name = 'RPCResponseError';
    }
}
/**
 * @description Utility class to interact with Tezos operations
 */ class $2fea24c565181d86$export$ab5aad00225c5662 {
    get includedInBlock() {
        return this._foundAt;
    }
    /**
     *
     * @param hash Operation hash
     * @param raw Raw operation that was injected
     * @param context Taquito context allowing access to rpc and signer
     * @throws {@link InvalidOperationHashError}
     */ constructor(hash, raw, results, context){
        this.hash = hash;
        this.raw = raw;
        this.results = results;
        this.context = context;
        this._pollingConfig$ = new (0, $4a1890c700519557$export$915d2682b0aa0991)(1);
        this.currentHead$ = this._pollingConfig$.pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((config)=>{
            return new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(config).pipe((0, $9491af11bb0ab327$export$83e74882c5df8fe1)({
                each: config.timeout * 1000,
                with: ()=>(0, $8250ab9260498953$export$8bf7aba4a9e09055)(()=>new $2fea24c565181d86$var$ConfirmationTimeoutError(`Confirmation polling timed out`))
            }));
        }), (0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)(()=>{
            return (0, $8312939aeeb1a4f7$export$260e5c0943f31606)(()=>$2fea24c565181d86$var$createObservableFromSubscription(this.context.stream.subscribeBlock('head'))).pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((newHead)=>{
                var _a, _b;
                const prevHead = (_b = (_a = this.lastHead) === null || _a === void 0 ? void 0 : _a.header.level) !== null && _b !== void 0 ? _b : newHead.header.level - 1;
                return (0, $48a6b248e7e71175$export$d02631cccf789723)(prevHead + 1, newHead.header.level - prevHead - 1).pipe((0, $9ee54e147202c320$export$c28c8388be0ab31a)((level)=>this.context.readProvider.getBlock(level)), (0, $f8cf36c2ee00b02d$export$23c7d6c8dcd743fe)(newHead));
            }), (0, $3e7edc5b22925f26$export$3f23594af5f37336)((newHead)=>this.lastHead = newHead));
        }), (0, $cd8167599454f872$export$db61d692014e534e)({
            refCount: true
        }));
        // Observable that emit once operation is seen in a block
        this.confirmed$ = this.currentHead$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((head)=>{
            for(let i = 3; i >= 0; i--)head.operations[i].forEach((op)=>{
                if (op.hash === this.hash) this._foundAt = head.header.level;
            });
            if (head.header.level - this._foundAt >= 0) return this._foundAt;
        }), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)((x)=>x !== undefined), (0, $b9a90ca4d933af63$export$43128fadae87b74a)(), (0, $cd8167599454f872$export$db61d692014e534e)());
        this._foundAt = Number.POSITIVE_INFINITY;
        if ((0, $6ed3c564aba0f912$export$a92a48117d546c9)(this.hash) !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$1a1c2023d3ec7a8a)(this.hash);
        this.confirmed$.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)(), (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>{
            return (0, $195e3b3043565ec4$export$ba255e9e49e00608)((0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58));
        })).subscribe();
    }
    get revealOperation() {
        return Array.isArray(this.results) && this.results.find((op)=>op.kind === 'reveal');
    }
    get revealStatus() {
        if (this.revealOperation) return this.revealOperation.metadata.operation_result.status;
        else return 'unknown';
    }
    get status() {
        return this.results.map((result)=>{
            if ($2fea24c565181d86$export$d3f32861fe419773(result)) return result.metadata.operation_result.status;
            else return 'unknown';
        })[0] || 'unknown';
    }
    /**
     *
     * @param confirmations [0] Number of confirmation to wait for
     * @param timeout [180] Timeout
     */ confirmation(confirmations, timeout) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof confirmations !== 'undefined' && confirmations < 1) throw new $2fea24c565181d86$var$InvalidConfirmationCountError(confirmations);
            const { defaultConfirmationCount: defaultConfirmationCount, confirmationPollingTimeoutSecond: confirmationPollingTimeoutSecond } = this.context.config;
            this._pollingConfig$.next({
                timeout: timeout || confirmationPollingTimeoutSecond
            });
            const conf = confirmations !== undefined ? confirmations : defaultConfirmationCount;
            return new Promise((resolve, reject)=>{
                this.confirmed$.pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)(()=>this.currentHead$), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)((head)=>head.header.level - this._foundAt >= conf - 1), (0, $b9a90ca4d933af63$export$43128fadae87b74a)()).subscribe({
                    error: (e)=>reject(e),
                    complete: ()=>resolve(this._foundAt + (conf - 1))
                });
            });
        });
    }
}
class $2fea24c565181d86$export$57d05bbf047997b6 extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    sumProp(arr, prop) {
        return arr.reduce((prev, current)=>{
            return prop in current ? Number(current[prop]) + prev : prev;
        }, 0);
    }
    getOriginatedContractAddresses() {
        const originationOpResults = this.results.filter((x)=>x.kind === 'origination');
        let addresses = [];
        for (const res of originationOpResults)if (res.metadata.operation_result.originated_contracts) addresses = [
            ...addresses,
            ...res.metadata.operation_result.originated_contracts
        ];
        return addresses;
    }
    get status() {
        return this.results.filter((result)=>$2fea24c565181d86$var$BATCH_KINDS.indexOf(result.kind) !== -1).map((result)=>{
            if ($2fea24c565181d86$export$d3f32861fe419773(result)) {
                const opResult = result.metadata.operation_result;
                return opResult.status;
            } else return 'unknown';
        })[0] || 'unknown';
    }
    get fee() {
        return this.sumProp(this.params, 'fee');
    }
    get gasLimit() {
        return this.sumProp(this.params, 'gas_limit');
    }
    get storageLimit() {
        return this.sumProp(this.params, 'storage_limit');
    }
    get consumedGas() {
        (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).ROUND_UP
        });
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(this.consumedMilliGas).dividedBy(1000).toString();
    }
    get consumedMilliGas() {
        return String(this.sumProp($2fea24c565181d86$var$flattenOperationResult({
            contents: this.results
        }), 'consumed_milligas'));
    }
    get storageDiff() {
        return String(this.sumProp($2fea24c565181d86$var$flattenOperationResult({
            contents: this.results
        }), 'paid_storage_size_diff'));
    }
    get errors() {
        return $2fea24c565181d86$var$flattenErrors({
            contents: this.results
        });
    }
}
class $2fea24c565181d86$var$Provider {
    get rpc() {
        return this.context.rpc;
    }
    get signer() {
        return this.context.signer;
    }
    constructor(context){
        this.context = context;
    }
    forge(_a) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*({ opOb: { branch: branch, contents: contents, protocol: protocol }, counter: counter }) {
            const forgedBytes = yield this.context.forger.forge({
                branch: branch,
                contents: contents
            });
            return {
                opbytes: forgedBytes,
                opOb: {
                    branch: branch,
                    contents: contents,
                    protocol: protocol
                },
                counter: counter
            };
        });
    }
    estimate(_a, estimator) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, gasLimit: gasLimit, storageLimit: storageLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "gasLimit",
                "storageLimit"
            ]);
            let calculatedFee = fee;
            let calculatedGas = gasLimit;
            let calculatedStorage = storageLimit;
            if (calculatedFee && calculatedFee % 1 !== 0) throw new $2fea24c565181d86$export$274a49fe3e42e72c(`Fee value must not be a decimal: ${calculatedFee}`);
            if (calculatedGas && calculatedGas % 1 !== 0) throw new $2fea24c565181d86$export$274a49fe3e42e72c(`Gas Limit value must not be a decimal: ${calculatedGas}`);
            if (calculatedStorage && calculatedStorage % 1 !== 0) throw new $2fea24c565181d86$export$274a49fe3e42e72c(`Storage Limit value must not be a decimal: ${calculatedStorage}`);
            if (fee === undefined || gasLimit === undefined || storageLimit === undefined) {
                const estimation = yield estimator(Object.assign({
                    fee: fee,
                    gasLimit: gasLimit,
                    storageLimit: storageLimit
                }, rest));
                calculatedFee !== null && calculatedFee !== void 0 ? calculatedFee : calculatedFee = estimation.suggestedFeeMutez;
                calculatedGas !== null && calculatedGas !== void 0 ? calculatedGas : calculatedGas = estimation.gasLimit;
                calculatedStorage !== null && calculatedStorage !== void 0 ? calculatedStorage : calculatedStorage = estimation.storageLimit;
            }
            return {
                fee: calculatedFee,
                gasLimit: calculatedGas,
                storageLimit: calculatedStorage
            };
        });
    }
    getRPCOp(param) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            switch(param.kind){
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION:
                    return $2fea24c565181d86$export$f3a9991068ba8db1(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION:
                    return $2fea24c565181d86$export$64dd15b44cde1e0b((yield this.context.parser.prepareCodeOrigination(Object.assign({}, param))));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION:
                    return $2fea24c565181d86$export$f6ca8c66abd5d967(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT:
                    return $2fea24c565181d86$export$36ba5bd34bec1f48(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                    return $2fea24c565181d86$export$8bbbca5738264f6e(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSFER_TICKET:
                    return $2fea24c565181d86$export$c2b0bb52eb4f8f40(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES:
                    return $2fea24c565181d86$export$e778921f9c3d1912(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE:
                    return $2fea24c565181d86$export$7119c95759340192(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE:
                    return $2fea24c565181d86$export$4b4c6fb209c7f56d(Object.assign({}, param));
                default:
                    throw new (0, $c34ebaa6f129c2ed$export$bc5be87550569b55)(param.kind);
            }
        });
    }
    runOperation(op) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return {
                opResponse: yield this.rpc.runOperation(op),
                op: op,
                context: this.context.clone()
            };
        });
    }
    simulate(op) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return {
                opResponse: yield this.rpc.simulateOperation(op),
                op: op,
                context: this.context.clone()
            };
        });
    }
    isRevealOpNeeded(op, pkh) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return !(yield this.isAccountRevealRequired(pkh)) || !this.isRevealRequiredForOpType(op) ? false : true;
        });
    }
    isAccountRevealRequired(publicKeyHash) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return !(yield this.context.readProvider.isAccountRevealed(publicKeyHash, 'head'));
        });
    }
    isRevealRequiredForOpType(op) {
        let opRequireReveal = false;
        for (const operation of op)if ($2fea24c565181d86$export$6373ada671863245(operation)) opRequireReveal = true;
        return opRequireReveal;
    }
    signAndInject(forgedBytes) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const signed = yield this.signer.sign(forgedBytes.opbytes, new Uint8Array([
                3
            ]));
            forgedBytes.opbytes = signed.sbytes;
            forgedBytes.opOb.signature = signed.prefixSig;
            const opResponse = [];
            const results = yield this.rpc.preapplyOperations([
                forgedBytes.opOb
            ]);
            if (!Array.isArray(results)) throw new $2fea24c565181d86$export$82778791b4c7e912(results);
            for(let i = 0; i < results.length; i++)for(let j = 0; j < results[i].contents.length; j++)opResponse.push(results[i].contents[j]);
            const errors = $2fea24c565181d86$var$flattenErrors(results);
            if (errors.length) throw new $2fea24c565181d86$export$a971cb9d7d565551(errors, 'Error occurred during validation simulation of operation', opResponse);
            return {
                hash: yield this.context.injector.inject(forgedBytes.opbytes),
                forgedBytes: forgedBytes,
                opResponse: opResponse,
                context: this.context.clone()
            };
        });
    }
}
class $2fea24c565181d86$export$970d9c5f24c420ee {
    constructor(walletProvider, context){
        this.walletProvider = walletProvider;
        this.context = context;
        this.operations = [];
    }
    /**
     * @description Add a transaction operation to the batch
     * @param params Transfer operation parameter
     */ withTransfer(params) {
        const toValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.to);
        if (toValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.to, (0, $6ed3c564aba0f912$export$a2057601792df650)(toValidation));
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION
        }, params));
        return this;
    }
    /**
     * @description Add a contract call to the batch
     * @param params Call a contract method
     * @param options Generic operation parameters
     */ withContractCall(params, options = {}) {
        return this.withTransfer(params.toTransferParams(options));
    }
    /**
     * @description Add a delegation operation to the batch
     * @param params Delegation operation parameter
     */ withDelegation(params) {
        var _a;
        const delegateValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_a = params.delegate) !== null && _a !== void 0 ? _a : '');
        if (params.delegate && delegateValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.delegate, (0, $6ed3c564aba0f912$export$a2057601792df650)(delegateValidation));
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION
        }, params));
        return this;
    }
    /**
     * @description Add an origination operation to the batch
     * @param params Origination operation parameter
     */ withOrigination(params) {
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION
        }, params));
        return this;
    }
    /**
     * @description Add an IncreasePaidStorage operation to the batch
     * @param param IncreasePaidStorage operation parameter
     */ withIncreasePaidStorage(params) {
        const destinationValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.destination);
        if (destinationValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.destination, (0, $6ed3c564aba0f912$export$a2057601792df650)(destinationValidation));
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE
        }, params));
        return this;
    }
    /**
     * @description Add an TransferTicket operation to the batch
     * @param param TransferTicket operation parameter
     */ withTransferTicket(params) {
        const destinationValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.destination);
        if (destinationValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.destination, (0, $6ed3c564aba0f912$export$a2057601792df650)(destinationValidation));
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSFER_TICKET
        }, params));
        return this;
    }
    mapOperation(param) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            switch(param.kind){
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION:
                    return this.walletProvider.mapTransferParamsToWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                            return param;
                        }));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION:
                    return this.walletProvider.mapOriginateParamsToWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                            return this.context.parser.prepareCodeOrigination(Object.assign({}, param));
                        }));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION:
                    return this.walletProvider.mapDelegateParamsToWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                            return param;
                        }));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                    return this.walletProvider.mapIncreasePaidStorageWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                            return param;
                        }));
                default:
                    throw new (0, $580df0c6131ecaba$export$bc5be87550569b55)(JSON.stringify(param.kind));
            }
        });
    }
    /**
     * @description Add a group operation to the batch. Operation will be applied in the order they are in the params array
     * @param params Operations parameter
     * @throws {@link InvalidOperationKindError}
     */ with(params) {
        for (const param of params)switch(param.kind){
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION:
                this.withTransfer(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION:
                this.withOrigination(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION:
                this.withDelegation(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                this.withIncreasePaidStorage(param);
                break;
            default:
                throw new (0, $580df0c6131ecaba$export$bc5be87550569b55)(JSON.stringify(param.kind));
        }
        return this;
    }
    /**
     * @description Submit batch operation to wallet
     */ send() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const ops = [];
            for (const op of this.operations)ops.push((yield this.mapOperation(op)));
            const opHash = yield this.walletProvider.sendOperations(ops);
            return this.context.operationFactory.createBatchOperation(opHash);
        });
    }
}
class $2fea24c565181d86$export$bcca3ea514774656 {
    constructor(context){
        this.context = context;
        this.walletCommand = (send)=>{
            return {
                send: send
            };
        };
    }
    get walletProvider() {
        return this.context.walletProvider;
    }
    /**
     * @description Retrieve the PKH of the account that is currently in use by the wallet
     * @param option Option to use while fetching the PKH.
     * If forceRefetch is specified the wallet provider implementation will refetch the PKH from the wallet
     */ pkh() {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*({ forceRefetch: forceRefetch } = {}) {
            if (!this._pkh || forceRefetch) this._pkh = yield this.walletProvider.getPKH();
            return this._pkh;
        });
    }
    /**
     * @description Retrieve the PK of the account that is currently in use by the wallet
     * @param option Option to use while fetching the PK.
     * If forceRefetch is specified the wallet provider implementation will refetch the PK from the wallet
     */ pk() {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*({ forceRefetch: forceRefetch } = {}) {
            if (!this._pk || forceRefetch) this._pk = yield this.walletProvider.getPK();
            return this._pk;
        });
    }
    /**
     * @description Originate a new contract according to the script in parameters.
     * @returns a OriginationWalletOperation promise object when followed by .send()
     * @param originateParams Originate operation parameter
     */ originate(params) {
        return this.walletCommand(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapOriginateParamsToWalletParams(()=>this.context.parser.prepareCodeOrigination(Object.assign({}, params)));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createOriginationOperation(opHash);
            }));
    }
    /**
     * @description Set the delegate for a contract.
     * @returns a WalletDelegateParams promise object when followed by .send()
     * @param delegateParams operation parameter
     */ setDelegate(params) {
        var _a;
        const delegateValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_a = params.delegate) !== null && _a !== void 0 ? _a : '');
        if (params.delegate && delegateValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.delegate, (0, $6ed3c564aba0f912$export$a2057601792df650)(delegateValidation));
        return this.walletCommand(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapDelegateParamsToWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                        return params;
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createDelegationOperation(opHash);
            }));
    }
    /**
     * @description failing_noop operation that is guaranteed to fail. DISCLAIMER: Not all wallets support signing failing_noop operations.
     * @returns Signature for a failing_noop
     * @param params operation parameter
     */ signFailingNoop(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const op = {
                kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).FAILING_NOOP,
                arbitrary: params.arbitrary
            };
            const hash = yield this.context.readProvider.getBlockHash(params.basedOnBlock);
            const forgedBytes = yield this.context.forger.forge({
                branch: hash,
                contents: [
                    op
                ]
            });
            const signature = yield this.walletProvider.sign(forgedBytes, Uint8Array.from([
                3
            ]));
            return {
                signature: signature,
                bytes: forgedBytes,
                signedContent: {
                    branch: hash,
                    contents: [
                        {
                            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).FAILING_NOOP,
                            arbitrary: params.arbitrary
                        }
                    ]
                }
            };
        });
    }
    /**
     * @description Register the current address as delegate.
     * @returns a DelegationWalletOperation promise object when followed by .send()
     */ registerDelegate() {
        return this.walletCommand(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapDelegateParamsToWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                        const delegate = yield this.pkh();
                        return {
                            delegate: delegate
                        };
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createDelegationOperation(opHash);
            }));
    }
    /**
     * @description Transfer tezos tokens from current address to a specific address or call a smart contract.
     * @returns a TransactionWalletOperation promise object when followed by .send()
     * @param params operation parameter
     */ transfer(params) {
        const toValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.to);
        if (toValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.to, (0, $6ed3c564aba0f912$export$a2057601792df650)(toValidation));
        return this.walletCommand(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapTransferParamsToWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                        return params;
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createTransactionOperation(opHash);
            }));
    }
    /**
     * @description Transfer tezos tickets from current address to a specific address or a smart contract
     * @returns a TransferTicketWalletOperation promise object when followed by .send()
     * @param params operation parameter
     */ transferTicket(params) {
        const toValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.destination);
        if (toValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.destination, (0, $6ed3c564aba0f912$export$a2057601792df650)(toValidation));
        return this.walletCommand(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapTransferTicketParamsToWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                        return params;
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createTransferTicketOperation(opHash);
            }));
    }
    /**
     * @description Stake a given amount for the source address
     * @returns a TransactionWalletOperation promise object when followed by .send()
     * @param Stake pseudo-operation parameter
     */ stake(params) {
        return this.walletCommand(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapStakeParamsToWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                        const source = yield this.pkh();
                        if (!params.to) params.to = source;
                        if (params.to !== source) throw new (0, $580df0c6131ecaba$export$be6cb9338b7137e0)(params.to);
                        params.parameter = {
                            entrypoint: 'stake',
                            value: {
                                prim: 'Unit'
                            }
                        };
                        return params;
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createTransactionOperation(opHash);
            }));
    }
    /**
     * @description Unstake the given amount. If "everything" is given as amount, unstakes everything from the staking balance.
     * Unstaked tez remains frozen for a set amount of cycles (the slashing period) after the operation. Once this period is over,
     * the operation "finalize unstake" must be called for the funds to appear in the liquid balance.
     * @returns a TransactionWalletOperation promise object when followed by .send()
     * @param Unstake pseudo-operation parameter
     */ unstake(params) {
        return this.walletCommand(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapUnstakeParamsToWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                        const source = yield this.pkh();
                        if (!params.to) params.to = source;
                        if (params.to !== source) throw new (0, $580df0c6131ecaba$export$be6cb9338b7137e0)(params.to);
                        params.parameter = {
                            entrypoint: 'unstake',
                            value: {
                                prim: 'Unit'
                            }
                        };
                        return params;
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return yield this.context.operationFactory.createTransactionOperation(opHash);
            }));
    }
    /**
     * @description Transfer all the finalizable unstaked funds of the source to their liquid balance
     * @returns a TransactionWalletOperation promise object when followed by .send()
     * @param Finalize_unstake pseudo-operation parameter
     */ finalizeUnstake(params) {
        return this.walletCommand(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapFinalizeUnstakeParamsToWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                        const source = yield this.pkh();
                        if (!params.to) params.to = source;
                        if (params.to !== source) throw new (0, $580df0c6131ecaba$export$be6cb9338b7137e0)(params.to);
                        if (!params.amount) params.amount = 0;
                        if (params.amount !== 0) throw new (0, $580df0c6131ecaba$export$1623a856d8b6cc2a)('Amount must be 0 to finalize unstake.');
                        params.parameter = {
                            entrypoint: 'finalize_unstake',
                            value: {
                                prim: 'Unit'
                            }
                        };
                        return params;
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return yield this.context.operationFactory.createTransactionOperation(opHash);
            }));
    }
    /**
     * @description Increase the paid storage of a smart contract.
     * @returns a IncreasePaidStorageWalletOperation promise object when followed by .send()
     * @param params operation parameter
     */ increasePaidStorage(params) {
        const destinationValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.destination);
        if (destinationValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.destination, (0, $6ed3c564aba0f912$export$a2057601792df650)(destinationValidation));
        return this.walletCommand(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                const mappedParams = yield this.walletProvider.mapIncreasePaidStorageWalletParams(()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                        return params;
                    }));
                const opHash = yield this.walletProvider.sendOperations([
                    mappedParams
                ]);
                return this.context.operationFactory.createIncreasePaidStorageOperation(opHash);
            }));
    }
    /**
     * @description Create a batch of operation
     * @returns A batch object from which we can add more operation or send a command to the wallet to execute the batch
     * @param params List of operation to initialize the batch with
     */ batch(params) {
        const batch = new $2fea24c565181d86$export$970d9c5f24c420ee(this.walletProvider, this.context);
        if (Array.isArray(params)) batch.with(params);
        return batch;
    }
    /**
     * @description Create an smart contract abstraction for the address specified. Calling entrypoints with the returned
     * smart contract abstraction will leverage the wallet provider to make smart contract calls
     * @param address Smart contract address
     * @throws {@link InvalidContractAddressError} If the contract address is not valid
     */ at(address_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(address, contractAbstractionComposer = (x)=>x) {
            const addressValidation = (0, $6ed3c564aba0f912$export$2ed905adbd9a56f2)(address);
            if (addressValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$193774326795229b)(address, (0, $6ed3c564aba0f912$export$a2057601792df650)(addressValidation));
            const rpc = this.context.withExtensions().rpc;
            const readProvider = this.context.withExtensions().readProvider;
            const script = yield readProvider.getScript(address, 'head');
            const entrypoints = yield readProvider.getEntrypoints(address);
            const abs = new $2fea24c565181d86$export$25cde19dc6218700(address, script, this, this.context.contract, entrypoints, rpc, readProvider);
            return contractAbstractionComposer(abs, this.context);
        });
    }
    /**
     * @deprecated Deprecated in favor of {@link Wallet.pk} will be removed in v19.1
     * @description Retrieve the PK of the account that is currently in use by the wallet
     */ getPK() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.pk();
        });
    }
}
const $2fea24c565181d86$var$receiptFromOperation = (op, { ALLOCATION_BURN: ALLOCATION_BURN, ORIGINATION_BURN: ORIGINATION_BURN } = {
    ALLOCATION_BURN: 257,
    ORIGINATION_BURN: 257
})=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).config({
        DECIMAL_PLACES: 0,
        ROUNDING_MODE: (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).ROUND_UP
    });
    const operationResults = $2fea24c565181d86$var$flattenOperationResult({
        contents: op
    });
    let totalMilliGas = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    let totalStorage = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    let totalFee = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    let totalOriginationBurn = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    let totalAllocationBurn = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    let totalPaidStorageDiff = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(0);
    operationResults.forEach((result)=>{
        totalFee = totalFee.plus(result.fee || 0);
        totalOriginationBurn = totalOriginationBurn.plus(Array.isArray(result.originated_contracts) ? result.originated_contracts.length * ORIGINATION_BURN : 0);
        totalAllocationBurn = totalAllocationBurn.plus('allocated_destination_contract' in result ? ALLOCATION_BURN : 0);
        totalMilliGas = totalMilliGas.plus(result.consumed_milligas || 0);
        totalPaidStorageDiff = totalPaidStorageDiff.plus('paid_storage_size_diff' in result ? Number(result.paid_storage_size_diff) || 0 : 0);
    });
    totalStorage = totalStorage.plus(totalAllocationBurn).plus(totalOriginationBurn).plus(totalPaidStorageDiff);
    return {
        totalFee: totalFee,
        totalMilliGas: totalMilliGas,
        totalGas: totalMilliGas.dividedBy(1000),
        totalStorage: totalStorage,
        totalAllocationBurn: totalAllocationBurn,
        totalOriginationBurn: totalOriginationBurn,
        totalPaidStorageDiff: totalPaidStorageDiff,
        totalStorageBurn: new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(totalStorage.multipliedBy($2fea24c565181d86$export$961faea0d634ab07))
    };
};
/**
 *  @category Error
 *  @description Error that indicates undefined confirmation has not been specified or configured
 */ class $2fea24c565181d86$var$ConfirmationUndefinedError extends (0, $580df0c6131ecaba$export$32f4d70b2fb302b1) {
    constructor(){
        super();
        this.name = 'ConfirmationUndefinedError';
        this.message = 'Default confirmation count can not be undefined';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a generic failure when trying to fetch an observable
 */ class $2fea24c565181d86$var$ObservableError extends (0, $580df0c6131ecaba$export$bae979e68e4dc802) {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ObservableError';
    }
}
const $2fea24c565181d86$var$MAX_BRANCH_ANCESTORS = 60;
/**
 * @description WalletOperation allows to monitor operation inclusion on chains and surface information related to the operation
 */ class $2fea24c565181d86$export$903c688feb2d259e {
    operationResults() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this._operationResult.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)()).toPromise();
        });
    }
    /**
     * @description Receipt expose the total amount of tezos token burn and spent on fees
     * The promise returned by receipt will resolve only once the transaction is included
     */ receipt() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const results = yield this.operationResults();
            if (!results) throw new $2fea24c565181d86$var$ObservableError('Unable to get operation results');
            return $2fea24c565181d86$var$receiptFromOperation(results);
        });
    }
    /**
     *
     * @param opHash Operation hash
     * @param raw Raw operation that was injected
     * @param context Taquito context allowing access to rpc and signer
     * @throws {InvalidOperationHashError}
     */ constructor(opHash, context, _newHead$){
        this.opHash = opHash;
        this.context = context;
        this._newHead$ = _newHead$;
        this._operationResult = new (0, $4a1890c700519557$export$915d2682b0aa0991)(1);
        this._includedInBlock = new (0, $4a1890c700519557$export$915d2682b0aa0991)(1);
        this._included = false;
        this.newHead$ = this._newHead$.pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((newHead)=>{
            var _a, _b;
            const prevHead = (_b = (_a = this.lastHead) === null || _a === void 0 ? void 0 : _a.header.level) !== null && _b !== void 0 ? _b : newHead.header.level - 1;
            return (0, $48a6b248e7e71175$export$d02631cccf789723)(prevHead + 1, newHead.header.level - prevHead - 1).pipe((0, $9ee54e147202c320$export$c28c8388be0ab31a)((level)=>this.context.readProvider.getBlock(level)), (0, $f8cf36c2ee00b02d$export$23c7d6c8dcd743fe)(newHead));
        }), (0, $3e7edc5b22925f26$export$3f23594af5f37336)((newHead)=>this.lastHead = newHead), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)({
            connector: ()=>new (0, $4a1890c700519557$export$915d2682b0aa0991)(1),
            resetOnError: false,
            resetOnComplete: false,
            resetOnRefCountZero: false
        }));
        // Observable that emit once operation is seen in a block
        this.confirmed$ = this.newHead$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((head)=>{
            for (const opGroup of head.operations){
                for (const op of opGroup)if (op.hash === this.opHash) {
                    this._included = true;
                    this._includedInBlock.next(head);
                    this._operationResult.next(op.contents);
                    // Return the block where the operation was found
                    return head;
                }
            }
        }), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)((x)=>{
            return typeof x !== 'undefined';
        }), (0, $b9a90ca4d933af63$export$43128fadae87b74a)(), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)({
            connector: ()=>new (0, $4a1890c700519557$export$915d2682b0aa0991)(1),
            resetOnError: false,
            resetOnComplete: false,
            resetOnRefCountZero: false
        }));
        if ((0, $6ed3c564aba0f912$export$a92a48117d546c9)(this.opHash) !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$1a1c2023d3ec7a8a)(this.opHash);
        this.confirmed$.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)(), (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>(0, $195e3b3043565ec4$export$ba255e9e49e00608)(undefined))).subscribe();
    }
    getCurrentConfirmation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 0;
            return (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
                this._includedInBlock,
                (0, $2fe2b696577919a5$export$6788812c4e6611e6)(this.context.readProvider.getBlock('head'))
            ]).pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)(([foundAtBlock, head])=>{
                return head.header.level - foundAtBlock.header.level + 1;
            }), (0, $b9a90ca4d933af63$export$43128fadae87b74a)()).toPromise();
        });
    }
    isInCurrentBranch() {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(tipBlockIdentifier = 'head') {
            // By default it is assumed that the operation is in the current branch
            if (!this._included) return true;
            const tipBlockHeaderLevel = yield this.context.readProvider.getBlockLevel(tipBlockIdentifier);
            const inclusionBlock = yield this._includedInBlock.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)()).toPromise();
            if (!inclusionBlock) throw new $2fea24c565181d86$var$ObservableError('Inclusion block is undefined');
            const levelDiff = tipBlockHeaderLevel - inclusionBlock.header.level;
            // Block produced before the operation is included are assumed to be part of the current branch
            if (levelDiff <= 0) return true;
            const tipBlockLevel = Math.min(inclusionBlock.header.level + levelDiff, inclusionBlock.header.level + $2fea24c565181d86$var$MAX_BRANCH_ANCESTORS);
            const blocks = new Set((yield this.context.readProvider.getLiveBlocks(tipBlockLevel)));
            return blocks.has(inclusionBlock.hash);
        });
    }
    confirmationObservable(confirmations) {
        if (typeof confirmations !== 'undefined' && confirmations < 1) throw new $2fea24c565181d86$var$InvalidConfirmationCountError(confirmations);
        const { defaultConfirmationCount: defaultConfirmationCount } = this.context.config;
        const conf = confirmations !== undefined ? confirmations : defaultConfirmationCount;
        if (conf === undefined) throw new $2fea24c565181d86$var$ConfirmationUndefinedError();
        return (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
            this._includedInBlock,
            this.newHead$
        ]).pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)(([, previousHead], [, newHead])=>{
            return previousHead.hash === newHead.hash;
        }), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([foundAtBlock, head])=>{
            return {
                block: head,
                expectedConfirmation: conf,
                currentConfirmation: head.header.level - foundAtBlock.header.level + 1,
                completed: head.header.level - foundAtBlock.header.level >= conf - 1,
                isInCurrentBranch: ()=>this.isInCurrentBranch(head.hash)
            };
        }), (0, $106fa5810fba1e6e$export$9384c7afe4015e42)(({ completed: completed })=>!completed, true));
    }
    /**
     *
     * @param confirmations [0] Number of confirmation to wait for
     */ confirmation(confirmations) {
        return this.confirmationObservable(confirmations).toPromise();
    }
}
class $2fea24c565181d86$export$8fc855f2a23d265f extends $2fea24c565181d86$export$903c688feb2d259e {
    constructor(opHash, context, newHead$){
        super(opHash, context, newHead$);
        this.opHash = opHash;
        this.context = context;
    }
    revealOperation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $2fea24c565181d86$var$ObservableError('operationResult returned undefined');
            return operationResult.find((x)=>x.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).REVEAL);
        });
    }
    transactionOperation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $2fea24c565181d86$var$ObservableError('operationResult returned undefined');
            return operationResult.find((x)=>x.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION);
        });
    }
    status() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 'pending';
            const op = yield this.transactionOperation();
            if (!op) return 'unknown';
            return op.metadata.operation_result.status;
        });
    }
}
class $2fea24c565181d86$export$fc9b2020ddc4a55c extends $2fea24c565181d86$export$903c688feb2d259e {
    constructor(opHash, context, newHead$){
        super(opHash, context, newHead$);
        this.opHash = opHash;
        this.context = context;
    }
    originationOperation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (operationResult) return $2fea24c565181d86$export$c585b8ca7df7709f(operationResult, (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION);
            else throw new $2fea24c565181d86$var$ObservableError('Unable to fetch operation result');
        });
    }
    revealOperation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (operationResult) return $2fea24c565181d86$export$c585b8ca7df7709f(operationResult, (0, $f93002942e85739a$export$b64a25b4a099ca08).REVEAL);
            else throw new $2fea24c565181d86$var$ObservableError('Unable to fetch operation result');
        });
    }
    status() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 'pending';
            const op = yield this.originationOperation();
            if (!op) return 'unknown';
            return op.metadata.operation_result.status;
        });
    }
    contract() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const op = yield this.originationOperation();
            const address = ((op === null || op === void 0 ? void 0 : op.metadata.operation_result.originated_contracts) || [])[0];
            return this.context.wallet.at(address);
        });
    }
}
class $2fea24c565181d86$export$ac7733ff4c8bbbf1 extends $2fea24c565181d86$export$903c688feb2d259e {
    constructor(opHash, context, newHead$){
        super(opHash, context, newHead$);
        this.opHash = opHash;
        this.context = context;
    }
    revealOperation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (operationResult) return operationResult.find((x)=>x.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).REVEAL);
            else throw new $2fea24c565181d86$var$ObservableError('Unable to fetch operation result');
        });
    }
    delegationOperation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (operationResult) return operationResult.find((x)=>x.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION);
            else throw new $2fea24c565181d86$var$ObservableError('Unable to fetch operation result');
        });
    }
    status() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 'pending';
            const op = yield this.delegationOperation();
            if (!op) return 'unknown';
            return op.metadata.operation_result.status;
        });
    }
}
class $2fea24c565181d86$export$5acc00b845144ee9 extends $2fea24c565181d86$export$903c688feb2d259e {
    constructor(opHash, context, newHead$){
        super(opHash, context, newHead$);
        this.opHash = opHash;
        this.context = context;
    }
    revealOperation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $2fea24c565181d86$var$ObservableError('operationResult returned undefined');
            return operationResult.find((x)=>x.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).REVEAL);
        });
    }
    transferTicketOperation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $2fea24c565181d86$var$ObservableError('operationResult returned undefined');
            return operationResult.find((x)=>x.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSFER_TICKET);
        });
    }
    status() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 'pending';
            const op = yield this.transferTicketOperation();
            if (!op) return 'unknown';
            return op.metadata.operation_result.status;
        });
    }
}
class $2fea24c565181d86$export$7e71cfc210e8a8fd {
    constructor(context){
        this.context = context;
    }
    getPKH() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.context.signer.publicKeyHash();
        });
    }
    getPK() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.context.signer.publicKey();
        });
    }
    mapTransferParamsToWalletParams(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return $2fea24c565181d86$export$e8a70403e22ec9da((yield params()), (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION);
        });
    }
    mapStakeParamsToWalletParams(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return $2fea24c565181d86$export$e8a70403e22ec9da((yield params()), (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION);
        });
    }
    mapUnstakeParamsToWalletParams(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return $2fea24c565181d86$export$e8a70403e22ec9da((yield params()), (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION);
        });
    }
    mapFinalizeUnstakeParamsToWalletParams(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return $2fea24c565181d86$export$e8a70403e22ec9da((yield params()), (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION);
        });
    }
    mapOriginateParamsToWalletParams(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return $2fea24c565181d86$export$e8a70403e22ec9da((yield params()), (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION);
        });
    }
    mapDelegateParamsToWalletParams(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return $2fea24c565181d86$export$e8a70403e22ec9da((yield params()), (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION);
        });
    }
    mapIncreasePaidStorageWalletParams(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return $2fea24c565181d86$export$e8a70403e22ec9da((yield params()), (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE);
        });
    }
    mapTransferTicketParamsToWalletParams(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return $2fea24c565181d86$export$e8a70403e22ec9da((yield params()), (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSFER_TICKET);
        });
    }
    sendOperations(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const op = yield this.context.batch.batch(params).send();
            return op.hash;
        });
    }
    sign(bytes, watermark) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { prefixSig: prefixSig } = yield this.context.signer.sign(bytes, watermark);
            return prefixSig;
        });
    }
}
/**
 * @description Utility class to send smart contract operation
 * The format for the arguments is the object representation
 */ class $2fea24c565181d86$export$c767420b65354e4c {
    constructor(provider, address, parameterSchema, name, args = 'unit', isMultipleEntrypoint = true, isAnonymous = false){
        this.provider = provider;
        this.address = address;
        this.parameterSchema = parameterSchema;
        this.name = name;
        this.args = args;
        this.isMultipleEntrypoint = isMultipleEntrypoint;
        this.isAnonymous = isAnonymous;
    }
    /**
     * @description Get the signature of the smart contract method
     */ getSignature() {
        return this.isAnonymous ? this.parameterSchema.ExtractSchema()[this.name] : this.parameterSchema.ExtractSchema();
    }
    /**
     *
     * @description Send the smart contract operation
     *
     * @param Options generic operation parameter
     */ send(params = {}) {
        if (this.provider instanceof $2fea24c565181d86$export$bcca3ea514774656) return this.provider.transfer(this.toTransferParams(params)).send();
        else return this.provider.transfer(this.toTransferParams(params));
    }
    /**
     *
     * @description Create transfer params to be used with TezosToolkit.contract.transfer methods
     *
     * @param Options generic transfer operation parameters
     */ toTransferParams({ fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, source: source, amount: amount = 0, mutez: mutez = false } = {}) {
        const fullTransferParams = {
            to: this.address,
            amount: amount,
            fee: fee,
            mutez: mutez,
            source: source,
            gasLimit: gasLimit,
            storageLimit: storageLimit,
            parameter: {
                entrypoint: this.isMultipleEntrypoint ? this.name : $2fea24c565181d86$export$a4f3c2bebc69dfa9,
                value: this.isAnonymous ? this.parameterSchema.EncodeObject({
                    [this.name]: this.args
                }) : this.parameterSchema.EncodeObject(this.args)
            }
        };
        return fullTransferParams;
    }
}
/**
 * @description Utility class to send smart contract operation
 * The format for the arguments is the flattened representation
 */ class $2fea24c565181d86$export$1fd08f6bbb20232a {
    constructor(provider, address, parameterSchema, name, args, isMultipleEntrypoint = true, isAnonymous = false){
        this.provider = provider;
        this.address = address;
        this.parameterSchema = parameterSchema;
        this.name = name;
        this.args = args;
        this.isMultipleEntrypoint = isMultipleEntrypoint;
        this.isAnonymous = isAnonymous;
    }
    validateArgs(args, schema, name) {
        const sigs = schema.ExtractSignatures();
        if (!sigs.find((x)=>x.length === args.length)) throw new $2fea24c565181d86$export$e569b97a5d46005c(name, sigs, args);
    }
    /**
     * @description Get the schema of the smart contract method
     */ get schema() {
        return this.isAnonymous ? this.parameterSchema.ExtractSchema()[this.name] : this.parameterSchema.ExtractSchema();
    }
    /**
     * @description Get the signature of the smart contract method
     */ getSignature() {
        if (this.isAnonymous) {
            const sig = this.parameterSchema.ExtractSignatures().find((x)=>x[0] === this.name);
            if (sig) {
                sig.shift();
                return sig;
            }
        } else {
            const sig = this.parameterSchema.ExtractSignatures();
            return sig.length == 1 ? sig[0] : sig;
        }
    }
    /**
     *
     * @description Send the smart contract operation
     *
     * @param Options generic operation parameter
     */ send(params = {}) {
        if (this.provider instanceof $2fea24c565181d86$export$bcca3ea514774656) return this.provider.transfer(this.toTransferParams(params)).send();
        else return this.provider.transfer(this.toTransferParams(params));
    }
    /**
     *
     * @description Create transfer params to be used with TezosToolkit.contract.transfer methods
     *
     * @param Options generic transfer operation parameters
     */ toTransferParams({ fee: fee, gasLimit: gasLimit, storageLimit: storageLimit, source: source, amount: amount = 0, mutez: mutez = false } = {}) {
        const fullTransferParams = {
            to: this.address,
            amount: amount,
            fee: fee,
            mutez: mutez,
            source: source,
            gasLimit: gasLimit,
            storageLimit: storageLimit,
            parameter: {
                entrypoint: this.isMultipleEntrypoint ? this.name : $2fea24c565181d86$export$a4f3c2bebc69dfa9,
                value: this.isAnonymous ? this.parameterSchema.Encode(this.name, ...this.args) : this.parameterSchema.Encode(...this.args)
            }
        };
        return fullTransferParams;
    }
}
class $2fea24c565181d86$var$OnChainView {
    constructor(_rpc, _readProvider, _contractAddress, _smartContractViewSchema, _contractStorageType, _args = 'Unit'){
        this._rpc = _rpc;
        this._readProvider = _readProvider;
        this._contractAddress = _contractAddress;
        this._smartContractViewSchema = _smartContractViewSchema;
        this._contractStorageType = _contractStorageType;
        this._args = _args;
    }
    /**
     * @description Get the signature of the smart contract view
     */ getSignature() {
        return {
            parameter: this._smartContractViewSchema.extractArgsSchema(),
            result: this._smartContractViewSchema.extractResultSchema()
        };
    }
    /**
     * @description Get the result of the view simulation
     * @param executionContext.source the public key hash of the account who initialized this view execution.
     * @param executionContext.viewCaller the contract address which is the caller of view.
     */ executeView(executionContext) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            this.verifyContextExecution(executionContext);
            const chainId = yield this._readProvider.getChainId();
            const viewArgs = this.transformArgsToMichelson();
            const scriptView = {
                contract: this._contractAddress,
                view: this._smartContractViewSchema.viewName,
                input: viewArgs,
                chain_id: chainId,
                source: executionContext.viewCaller
            };
            if (executionContext.source) scriptView.payer = executionContext.source;
            return this.executeViewAndDecodeResult(scriptView);
        });
    }
    verifyContextExecution(executionContext) {
        if (executionContext.source && (0, $6ed3c564aba0f912$export$f78173835dcde49f)(executionContext.source) !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new $2fea24c565181d86$export$ff1e6a1fdce32aa4(`The source account who initialized the view execution is invalid: ${executionContext.source}.`);
        if (!executionContext.viewCaller || (0, $6ed3c564aba0f912$export$f78173835dcde49f)(executionContext.viewCaller) !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new $2fea24c565181d86$export$ff1e6a1fdce32aa4(`The contract which is the caller of view is invalid: ${executionContext.viewCaller}.`);
    }
    transformArgsToMichelson() {
        try {
            return this._smartContractViewSchema.encodeViewArgs(this._args);
        } catch (error) {
            throw new (0, $580df0c6131ecaba$export$f9ce6a924724628b)(this._smartContractViewSchema.viewName, this.getSignature(), this._args, error);
        }
    }
    /**
     * @description Loops through the view's instructions and replace BALANCE, SENDER, SELF_ADDRESS and AMOUNT with Michelson expressions that match the current context, if applicable.
     *
     * Certain specific instructions have different semantics in view:
     * BALANCE represents the current amount of mutez held by the contract where view is;
     * SENDER represents the contract which is the caller of view;
     * SELF_ADDRESS represents the contract where view is;
     * AMOUNT is always 0 mutez.
     *
     */ adaptViewCodeToContext(instructions, viewCaller, contractBalance) {
        const instructionsToReplace = {
            BALANCE: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'mutez'
                        },
                        {
                            int: contractBalance
                        }
                    ]
                }
            ],
            SENDER: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'address'
                        },
                        {
                            string: viewCaller
                        }
                    ]
                }
            ],
            SELF_ADDRESS: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'address'
                        },
                        {
                            string: this._contractAddress
                        }
                    ]
                }
            ],
            AMOUNT: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'mutez'
                        },
                        {
                            int: '0'
                        }
                    ]
                }
            ]
        };
        instructions.forEach((inst, i)=>{
            if (inst.prim in instructionsToReplace) instructions[i] = Object(instructionsToReplace)[inst.prim];
            if (inst.args && inst.args.length !== 0) this.adaptViewCodeToContext(inst.args, viewCaller, contractBalance);
            else if (Array.isArray(inst)) this.adaptViewCodeToContext(inst, viewCaller, contractBalance);
        });
        return instructions;
    }
    executeViewAndDecodeResult(viewScript) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            let storage;
            try {
                storage = (yield this._rpc.runScriptView(viewScript)).data;
            } catch (error) {
                const failWith = $2fea24c565181d86$export$6ead28c0ab00fb75(error);
                throw failWith ? new $2fea24c565181d86$export$7a371d5bcddb4bc0(`The simulation of the on-chain view named ${this._smartContractViewSchema.viewName} failed with: ${JSON.stringify(failWith)}`, this._smartContractViewSchema.viewName, failWith, error) : error;
            }
            return this._smartContractViewSchema.decodeViewResult(storage);
        });
    }
}
class $2fea24c565181d86$var$ContractMethodFactory {
    constructor(provider, contractAddress){
        this.provider = provider;
        this.contractAddress = contractAddress;
    }
    createContractMethodFlatParams(smartContractMethodSchema, smartContractMethodName, args, isMultipleEntrypoint = true, isAnonymous = false) {
        return new $2fea24c565181d86$export$1fd08f6bbb20232a(this.provider, this.contractAddress, smartContractMethodSchema, smartContractMethodName, args, isMultipleEntrypoint, isAnonymous);
    }
    createContractMethodObjectParam(smartContractMethodSchema, smartContractMethodName, args, isMultipleEntrypoint = true, isAnonymous = false) {
        return new $2fea24c565181d86$export$c767420b65354e4c(this.provider, this.contractAddress, smartContractMethodSchema, smartContractMethodName, args, isMultipleEntrypoint, isAnonymous);
    }
    createContractViewObjectParam(rpc, readProvider, smartContractViewSchema, contractStorageType, viewArgs) {
        return new $2fea24c565181d86$var$OnChainView(rpc, readProvider, this.contractAddress, smartContractViewSchema, contractStorageType, viewArgs);
    }
}
const $2fea24c565181d86$export$a4f3c2bebc69dfa9 = 'default';
/**
 * @description Utility class to retrieve data from a smart contract's storage without incurring fees via a contract's view method
 */ class $2fea24c565181d86$export$63fe1d55d80baff5 {
    constructor(currentContract, name, callbackParametersSchema, parameterSchema, args, rpc, readProvider){
        this.currentContract = currentContract;
        this.name = name;
        this.callbackParametersSchema = callbackParametersSchema;
        this.parameterSchema = parameterSchema;
        this.args = args;
        this.rpc = rpc;
        this.readProvider = readProvider;
    }
    read(chainId) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const chainIdValidation = (0, $6ed3c564aba0f912$export$cb16a5d2af893df6)(chainId !== null && chainId !== void 0 ? chainId : '');
            if ((0, $6ed3c564aba0f912$export$2ed905adbd9a56f2)(chainId !== null && chainId !== void 0 ? chainId : '') == (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$11034991807c583d)(`Since version 12, the lambda view no longer depends on a lambda contract. The read method no longer accepts a contract address as a parameter.`);
            else if (chainId && chainIdValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$4836eb835ffca5b2)(chainId, (0, $6ed3c564aba0f912$export$a2057601792df650)(chainIdValidation));
            const arg = this.parameterSchema.Encode(...this.args);
            const result = yield this.rpc.runView({
                contract: this.currentContract.address,
                entrypoint: this.name,
                input: arg,
                chain_id: chainId ? chainId : yield this.readProvider.getChainId()
            });
            return this.callbackParametersSchema.Execute(result.data);
        });
    }
}
const $2fea24c565181d86$var$validateArgs = (args, schema, name)=>{
    const sigs = schema.ExtractSignatures();
    if (!sigs.find((x)=>x.length === args.length)) throw new $2fea24c565181d86$export$e569b97a5d46005c(name, sigs, args);
};
// lambda view tzip4
const $2fea24c565181d86$var$isView = (entrypoint)=>{
    let isView = false;
    if ('prim' in entrypoint && entrypoint.prim === 'pair' && entrypoint.args) {
        const lastElement = entrypoint.args[entrypoint.args.length - 1];
        if ('prim' in lastElement && lastElement.prim === 'contract') isView = true;
    }
    return isView;
};
/**
 * @description Smart contract abstraction
 */ class $2fea24c565181d86$export$25cde19dc6218700 {
    constructor(address, script, provider, storageProvider, entrypoints, rpc, readProvider){
        this.address = address;
        this.script = script;
        this.storageProvider = storageProvider;
        this.entrypoints = entrypoints;
        this.rpc = rpc;
        this.readProvider = readProvider;
        /**
         * @deprecated use methodsObject instead, flat params of methods can't sufficiently represent all Michelson values
         * @description Contains methods that are implemented by the target Tezos Smart Contract, and offers the user to call the Smart Contract methods as if they were native TS/JS methods.
         * NB: if the contract contains annotation it will include named properties; if not it will be indexed by a number.
         */ this.methods = {};
        /**
         * @description Contains methods that are implemented by the target Tezos Smart Contract, and offers the user to call the Smart Contract methods as if they were native TS/JS methods.
         * `methodsObject` serves the exact same purpose as the `methods` member. The difference is that it allows passing the parameter in an object format when calling the smart contract method (instead of the flattened representation)
         * NB: if the contract contains annotation it will include named properties; if not it will be indexed by a number.
         *
         */ this.methodsObject = {};
        /**
         * @description Contains lamda views (tzip4) that are implemented by the target Tezos Smart Contract, and offers the user to call the lambda views as if they were native TS/JS methods.
         * NB: These are the view defined in the tzip4 standard, not the views introduced by the Hangzhou protocol.
         */ this.views = {};
        /**
         * @description Contains on-chain views that are defined by the target Tezos Smart Contract, and offers the user to simulate the views execution as if they were native TS/JS methods.
         * NB: the expected format for the parameter when calling a smart contract view is the object format (same format as for the storage) and not the flattened representation.
         *
         */ this.contractViews = {};
        this.contractMethodFactory = new $2fea24c565181d86$var$ContractMethodFactory(provider, address);
        this.schema = (0, $c46b7dbea18e1f8c$export$19342e026b58ebb7).fromRPCResponse({
            script: this.script
        });
        this.parameterSchema = (0, $c46b7dbea18e1f8c$export$54a0993a9ed335cf).fromRPCResponse({
            script: this.script
        });
        this.viewSchema = (0, $c46b7dbea18e1f8c$export$d422a5b447f0dce1).fromRPCResponse({
            script: this.script
        });
        if (this.viewSchema.length !== 0) this._initializeOnChainViews(this, rpc, this.readProvider, this.viewSchema);
        this.eventSchema = (0, $c46b7dbea18e1f8c$export$769a4ec051ed522c).fromRPCResponse({
            script: this.script
        });
        this._initializeMethods(this, this.entrypoints.entrypoints, this.rpc, this.readProvider);
    }
    _initializeMethods(currentContract, entrypoints, rpc, readProvider) {
        const parameterSchema = this.parameterSchema;
        const keys = Object.keys(entrypoints);
        if (parameterSchema.isMultipleEntryPoint) {
            keys.forEach((smartContractMethodName)=>{
                const smartContractMethodSchema = new (0, $c46b7dbea18e1f8c$export$54a0993a9ed335cf)(entrypoints[smartContractMethodName]);
                this.methods[smartContractMethodName] = function(...args) {
                    return currentContract.contractMethodFactory.createContractMethodFlatParams(smartContractMethodSchema, smartContractMethodName, args);
                };
                this.methodsObject[smartContractMethodName] = function(args) {
                    return currentContract.contractMethodFactory.createContractMethodObjectParam(smartContractMethodSchema, smartContractMethodName, args);
                };
                if ($2fea24c565181d86$var$isView(entrypoints[smartContractMethodName])) {
                    const view = function(...args) {
                        const entrypointParamWithoutCallback = entrypoints[smartContractMethodName].args[0];
                        const smartContractMethodSchemaWithoutCallback = new (0, $c46b7dbea18e1f8c$export$54a0993a9ed335cf)(entrypointParamWithoutCallback);
                        const parametersCallback = entrypoints[smartContractMethodName].args[1].args[0];
                        const smartContractMethodCallbackSchema = new (0, $c46b7dbea18e1f8c$export$54a0993a9ed335cf)(parametersCallback);
                        $2fea24c565181d86$var$validateArgs(args, smartContractMethodSchemaWithoutCallback, smartContractMethodName);
                        return new $2fea24c565181d86$export$63fe1d55d80baff5(currentContract, smartContractMethodName, smartContractMethodCallbackSchema, smartContractMethodSchemaWithoutCallback, args, rpc, readProvider);
                    };
                    this.views[smartContractMethodName] = view;
                }
            });
            // Deal with methods with no annotations which were not discovered by the RPC endpoint
            // Methods with no annotations are discovered using parameter schema
            const anonymousMethods = Object.keys(parameterSchema.ExtractSchema()).filter((key)=>Object.keys(entrypoints).indexOf(key) === -1);
            anonymousMethods.forEach((smartContractMethodName)=>{
                this.methods[smartContractMethodName] = function(...args) {
                    return currentContract.contractMethodFactory.createContractMethodFlatParams(parameterSchema, smartContractMethodName, args, false, true);
                };
                this.methodsObject[smartContractMethodName] = function(args) {
                    return currentContract.contractMethodFactory.createContractMethodObjectParam(parameterSchema, smartContractMethodName, args, false, true);
                };
            });
        } else {
            const smartContractMethodSchema = this.parameterSchema;
            this.methods[$2fea24c565181d86$export$a4f3c2bebc69dfa9] = function(...args) {
                return currentContract.contractMethodFactory.createContractMethodFlatParams(smartContractMethodSchema, $2fea24c565181d86$export$a4f3c2bebc69dfa9, args, false);
            };
            this.methodsObject[$2fea24c565181d86$export$a4f3c2bebc69dfa9] = function(args) {
                return currentContract.contractMethodFactory.createContractMethodObjectParam(smartContractMethodSchema, $2fea24c565181d86$export$a4f3c2bebc69dfa9, args, false);
            };
        }
    }
    _initializeOnChainViews(currentContract, rpc, readProvider, allContractViews) {
        const storageType = this.schema.val;
        allContractViews.forEach((viewSchema)=>{
            this.contractViews[viewSchema.viewName] = function(args) {
                return currentContract.contractMethodFactory.createContractViewObjectParam(rpc, readProvider, viewSchema, storageType, args);
            };
        });
    }
    /**
     * @description Return a friendly representation of the smart contract storage
     */ storage() {
        return this.storageProvider.getStorage(this.address, this.schema);
    }
    /**
     *
     * @description Return a friendly representation of the smart contract big map value
     *
     * @param key BigMap key to fetch
     *
     * @deprecated getBigMapKey has been deprecated in favor of getBigMapKeyByID
     *
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-context-contracts-contract-id-big-map-get
     */ bigMap(key) {
        return this.storageProvider.getBigMapKey(this.address, key, this.schema);
    }
}
const $2fea24c565181d86$var$setDelegate = (key)=>{
    return [
        {
            prim: 'DROP'
        },
        {
            prim: 'NIL',
            args: [
                {
                    prim: 'operation'
                }
            ]
        },
        {
            prim: 'PUSH',
            args: [
                {
                    prim: 'key_hash'
                },
                {
                    string: key
                }
            ]
        },
        {
            prim: 'SOME'
        },
        {
            prim: 'SET_DELEGATE'
        },
        {
            prim: 'CONS'
        }
    ];
};
const $2fea24c565181d86$var$transferImplicit = (key, mutez)=>{
    return [
        {
            prim: 'DROP'
        },
        {
            prim: 'NIL',
            args: [
                {
                    prim: 'operation'
                }
            ]
        },
        {
            prim: 'PUSH',
            args: [
                {
                    prim: 'key_hash'
                },
                {
                    string: key
                }
            ]
        },
        {
            prim: 'IMPLICIT_ACCOUNT'
        },
        {
            prim: 'PUSH',
            args: [
                {
                    prim: 'mutez'
                },
                {
                    int: `${mutez}`
                }
            ]
        },
        {
            prim: 'UNIT'
        },
        {
            prim: 'TRANSFER_TOKENS'
        },
        {
            prim: 'CONS'
        }
    ];
};
const $2fea24c565181d86$var$removeDelegate = ()=>{
    return [
        {
            prim: 'DROP'
        },
        {
            prim: 'NIL',
            args: [
                {
                    prim: 'operation'
                }
            ]
        },
        {
            prim: 'NONE',
            args: [
                {
                    prim: 'key_hash'
                }
            ]
        },
        {
            prim: 'SET_DELEGATE'
        },
        {
            prim: 'CONS'
        }
    ];
};
const $2fea24c565181d86$var$transferToContract = (key, amount)=>{
    return [
        {
            prim: 'DROP'
        },
        {
            prim: 'NIL',
            args: [
                {
                    prim: 'operation'
                }
            ]
        },
        {
            prim: 'PUSH',
            args: [
                {
                    prim: 'address'
                },
                {
                    string: key
                }
            ]
        },
        {
            prim: 'CONTRACT',
            args: [
                {
                    prim: 'unit'
                }
            ]
        },
        {
            prim: 'IF_NONE',
            args: [
                [
                    {
                        prim: 'UNIT'
                    },
                    {
                        prim: 'FAILWITH'
                    }
                ],
                []
            ]
        },
        {
            prim: 'PUSH',
            args: [
                {
                    prim: 'mutez'
                },
                {
                    int: `${amount}`
                }
            ]
        },
        {
            prim: 'UNIT'
        },
        {
            prim: 'TRANSFER_TOKENS'
        },
        {
            prim: 'CONS'
        }
    ];
};
const $2fea24c565181d86$export$914bd5860575a041 = {
    setDelegate: $2fea24c565181d86$var$setDelegate,
    removeDelegate: $2fea24c565181d86$var$removeDelegate,
    transferImplicit: $2fea24c565181d86$var$transferImplicit,
    transferToContract: $2fea24c565181d86$var$transferToContract
};
const $2fea24c565181d86$var$code = [
    {
        prim: 'parameter',
        args: [
            {
                prim: 'lambda',
                args: [
                    {
                        prim: 'unit'
                    },
                    {
                        prim: 'pair',
                        args: [
                            {
                                prim: 'list',
                                args: [
                                    {
                                        prim: 'operation'
                                    }
                                ]
                            },
                            {
                                prim: 'unit'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        prim: 'storage',
        args: [
            {
                prim: 'unit'
            }
        ]
    },
    {
        prim: 'code',
        args: [
            [
                {
                    prim: 'CAR'
                },
                {
                    prim: 'UNIT'
                },
                {
                    prim: 'EXEC'
                }
            ]
        ]
    }
];
const $2fea24c565181d86$var$storage = 'Unit';
const $2fea24c565181d86$export$7f921264ee025945 = {
    code: $2fea24c565181d86$var$code,
    storage: $2fea24c565181d86$var$storage
};
function $2fea24c565181d86$export$f672e0b6f7222cd7(functioncomposer1, functioncomposer2) {
    return (contractAbstraction, context)=>functioncomposer2(functioncomposer1(contractAbstraction, context), context);
}
class $2fea24c565181d86$export$1e644e089fcc2014 {
    constructor(id, provider){
        this.id = id;
        this.provider = provider;
    }
    /**
     *
     * @description Fetch the sapling state
     *
     * @param block optional block level to fetch the values from (head will be use by default)
     * @returns Return a json object of the sapling_state
     *
     */ getSaplingDiff(block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.provider.getSaplingDiffByID(this.id.toString(), block);
        });
    }
    getId() {
        return this.id.toString();
    }
}
class $2fea24c565181d86$export$ba473e7c149ab4dc {
    constructor(id, schema, provider){
        this.id = id;
        this.schema = schema;
        this.provider = provider;
    }
    /**
     *
     * @description Fetch one value in a big map
     *
     * @param keysToEncode Key to query (will be encoded properly according to the schema)
     * @param block optional block level to fetch the values from (head will be use by default)
     * @returns Return a well formatted json object of a big map value or undefined if the key is not found in the big map
     *
     */ get(keyToEncode, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const id = yield this.provider.getBigMapKeyByID(this.id.toString(), keyToEncode, this.schema, block);
                return id;
            } catch (e) {
                if (e instanceof (0, $6cc77aa71b64d012$export$d2f2761cbe9cebf2) && e.status === (0, $6cc77aa71b64d012$export$bc3aa03eb4b395cf).NOT_FOUND) return undefined;
                else throw e;
            }
        });
    }
    /**
     *
     * @description Fetch multiple values in a big map
     * All values will be fetched on the same block level. If a block is specified in the request, the values will be fetched at it.
     * Otherwise, a first request will be done to the node to fetch the level of the head and all values will be fetched at this level.
     * If one of the keys does not exist in the big map, its value will be set to undefined.
     *
     * @param keysToEncode Array of keys to query (will be encoded properly according to the schema)
     * @param block optional block level to fetch the values from
     * @param batchSize optional batch size representing the number of requests to execute in parallel
     * @returns A MichelsonMap containing the keys queried in the big map and their value in a well-formatted JSON object format
     *
     */ getMultipleValues(keysToEncode_1, block_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(keysToEncode, block, batchSize = 5) {
            return this.provider.getBigMapKeysByID(this.id.toString(), keysToEncode, this.schema, block, batchSize);
        });
    }
    toJSON() {
        return this.id.toString();
    }
    toString() {
        return this.id.toString();
    }
}
/**
 * @description Override the default michelson encoder semantic to provide richer abstraction over storage properties
 * @param provider ContractProvider (contract API)
 */ // Override the default michelson encoder semantic to provide richer abstraction over storage properties
const $2fea24c565181d86$export$c616f2921e28f4d2 = (provider)=>({
        // Provide a specific abstraction for BigMaps
        big_map: (val, code)=>{
            if (!val || !('int' in val) || val.int === undefined) // Return an empty object in case of missing big map ID
            return {};
            else {
                const schema = new (0, $c46b7dbea18e1f8c$export$19342e026b58ebb7)(code);
                return new $2fea24c565181d86$export$ba473e7c149ab4dc(new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val.int), schema, provider);
            }
        },
        sapling_state: (val)=>{
            if (!val || !('int' in val) || val.int === undefined) // Return an empty object in case of missing sapling state ID
            return {};
            else return new $2fea24c565181d86$export$1e644e089fcc2014(new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(val.int), provider);
        }
    });
var $2fea24c565181d86$var$_PrepareProvider_counters;
const $2fea24c565181d86$var$mergeLimits = (userDefinedLimit, defaultLimits)=>{
    var _a, _b, _c;
    return {
        fee: (_a = userDefinedLimit.fee) !== null && _a !== void 0 ? _a : defaultLimits.fee,
        gasLimit: (_b = userDefinedLimit.gasLimit) !== null && _b !== void 0 ? _b : defaultLimits.gasLimit,
        storageLimit: (_c = userDefinedLimit.storageLimit) !== null && _c !== void 0 ? _c : defaultLimits.storageLimit
    };
};
/**
 * @description PrepareProvider is a utility class to output the prepared format of an operation
 */ class $2fea24c565181d86$export$c3ce3aa140a1bd8b extends $2fea24c565181d86$var$Provider {
    constructor(context){
        super(context);
        this.context = context;
        $2fea24c565181d86$var$_PrepareProvider_counters.set(this, void 0);
        $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
    }
    getBlockHash(block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.context.readProvider.getBlockHash(block !== null && block !== void 0 ? block : 'head~2');
        });
    }
    getProtocolHash() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.context.readProvider.getNextProtocol('head');
        });
    }
    getHeadCounter(pkh) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            return (_a = this.context.readProvider.getCounter(pkh, 'head')) !== null && _a !== void 0 ? _a : '0';
        });
    }
    adjustGasForBatchOperation(gasLimitBlock, gaslimitOp, numberOfOps) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).min(gaslimitOp, gasLimitBlock.div(numberOfOps + 1));
    }
    getOperationLimits(constants, numberOfOps) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { hard_gas_limit_per_operation: hard_gas_limit_per_operation, hard_gas_limit_per_block: hard_gas_limit_per_block, hard_storage_limit_per_operation: hard_storage_limit_per_operation } = constants;
            return {
                fee: 0,
                gasLimit: numberOfOps ? Math.floor(this.adjustGasForBatchOperation(hard_gas_limit_per_block, hard_gas_limit_per_operation, numberOfOps).toNumber()) : hard_gas_limit_per_operation.toNumber(),
                storageLimit: hard_storage_limit_per_operation.toNumber()
            };
        });
    }
    getFee(op, pkh, headCounter) {
        if (!$2fea24c565181d86$var$__classPrivateFieldGet(this, $2fea24c565181d86$var$_PrepareProvider_counters, "f")[pkh] || $2fea24c565181d86$var$__classPrivateFieldGet(this, $2fea24c565181d86$var$_PrepareProvider_counters, "f")[pkh] < headCounter) $2fea24c565181d86$var$__classPrivateFieldGet(this, $2fea24c565181d86$var$_PrepareProvider_counters, "f")[pkh] = headCounter;
        const opCounter = ++$2fea24c565181d86$var$__classPrivateFieldGet(this, $2fea24c565181d86$var$_PrepareProvider_counters, "f")[pkh];
        return {
            counter: `${opCounter}`,
            fee: typeof op.fee === 'undefined' ? '0' : `${op.fee}`,
            gas_limit: typeof op.gas_limit === 'undefined' ? '0' : `${op.gas_limit}`,
            storage_limit: typeof op.storage_limit === 'undefined' ? '0' : `${op.storage_limit}`
        };
    }
    getSource(op, pkh, source) {
        return {
            source: typeof op.source === 'undefined' ? source || pkh : op.source
        };
    }
    addRevealOperationIfNeeded(operation, publicKeyHash) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if ($2fea24c565181d86$export$6373ada671863245(operation)) {
                const ops = [
                    operation
                ];
                const { publicKey: publicKey, pkh: pkh } = yield this.getKeys();
                if (yield this.isAccountRevealRequired(publicKeyHash)) {
                    if (!publicKey) throw new (0, $580df0c6131ecaba$export$183b043cd3c947f9)(pkh);
                    ops.unshift((yield $2fea24c565181d86$export$638a1bb58510476({
                        fee: $2fea24c565181d86$export$2a009c06b05c06b7(pkh),
                        storageLimit: $2fea24c565181d86$export$7dc909734d086289,
                        gasLimit: $2fea24c565181d86$export$199fe2d87a4763cf(pkh)
                    }, publicKeyHash, publicKey)));
                    return ops;
                }
            }
            return operation;
        });
    }
    getKeys() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const isSignerConfigured = this.context.isAnySignerConfigured();
            return {
                pkh: isSignerConfigured ? yield this.signer.publicKeyHash() : yield this.context.walletProvider.getPKH(),
                publicKey: isSignerConfigured ? yield this.signer.publicKey() : undefined
            };
        });
    }
    convertIntoArray(op) {
        if (Array.isArray(op)) return [
            ...op
        ];
        else return [
            op
        ];
    }
    constructOpContents(ops, headCounter, pkh, source, currentVotingPeriod) {
        return ops.map((op)=>{
            switch(op.kind){
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).ACTIVATION:
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).DRAIN_DELEGATE:
                    return Object.assign({}, op);
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION:
                    return Object.assign(Object.assign(Object.assign(Object.assign({}, op), {
                        balance: typeof op.balance !== 'undefined' ? `${op.balance}` : '0'
                    }), this.getSource(op, pkh, source)), this.getFee(op, pkh, headCounter));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION:
                    {
                        const cops = Object.assign(Object.assign(Object.assign(Object.assign({}, op), {
                            amount: typeof op.amount !== 'undefined' ? `${op.amount}` : '0'
                        }), this.getSource(op, pkh, source)), this.getFee(op, pkh, headCounter));
                        if (cops.source.toLowerCase().startsWith('kt1')) throw new (0, $580df0c6131ecaba$export$11034991807c583d)(`KT1 addresses are not supported as source since ${$2fea24c565181d86$export$8b0851cfdd1d5bdc.PsBabyM1}`);
                        return cops;
                    }
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).REVEAL:
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION:
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT:
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).UPDATE_CONSENSUS_KEY:
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES:
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE:
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE:
                    return Object.assign(Object.assign(Object.assign({}, op), this.getSource(op, pkh, source)), this.getFee(op, pkh, headCounter));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSFER_TICKET:
                    return Object.assign(Object.assign(Object.assign(Object.assign({}, op), {
                        ticket_amount: `${op.ticket_amount}`
                    }), this.getSource(op, pkh, source)), this.getFee(op, pkh, headCounter));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                    return Object.assign(Object.assign(Object.assign(Object.assign({}, op), {
                        amount: `${op.amount}`
                    }), this.getSource(op, pkh, source)), this.getFee(op, pkh, headCounter));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).BALLOT:
                    if (currentVotingPeriod === undefined) throw new $2fea24c565181d86$var$RPCResponseError(`Failed to get the current voting period index`);
                    return Object.assign(Object.assign({}, op), {
                        period: currentVotingPeriod === null || currentVotingPeriod === void 0 ? void 0 : currentVotingPeriod.voting_period.index
                    });
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).PROPOSALS:
                    if (currentVotingPeriod === undefined) throw new $2fea24c565181d86$var$RPCResponseError(`Failed to get the current voting period index`);
                    return Object.assign(Object.assign({}, op), {
                        period: currentVotingPeriod === null || currentVotingPeriod === void 0 ? void 0 : currentVotingPeriod.voting_period.index
                    });
                default:
                    throw new (0, $580df0c6131ecaba$export$bc5be87550569b55)(op.kind);
            }
        });
    }
    /**
     *
     * @description Method to prepare an activation operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ activate(_a) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*({ pkh: pkh, secret: secret }) {
            const op = yield $2fea24c565181d86$export$eb3995ea1d48ce9e({
                pkh: pkh,
                secret: secret
            });
            const ops = this.convertIntoArray(op);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a reveal operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ reveal(_a) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*({ fee: fee, gasLimit: gasLimit, storageLimit: storageLimit }) {
            const { pkh: pkh, publicKey: publicKey } = yield this.getKeys();
            if (!publicKey) throw new (0, $580df0c6131ecaba$export$183b043cd3c947f9)(pkh);
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const mergedEstimates = $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS);
            const op = yield $2fea24c565181d86$export$638a1bb58510476({
                fee: mergedEstimates.fee,
                gasLimit: mergedEstimates.gasLimit,
                storageLimit: mergedEstimates.storageLimit
            }, pkh, publicKey);
            const ops = this.convertIntoArray(op);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare an origination operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ originate(_a, source) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$64dd15b44cde1e0b((yield this.context.parser.prepareCodeOrigination(Object.assign(Object.assign({}, rest), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)))));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a transaction operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ transaction(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$f3a9991068ba8db1(Object.assign(Object.assign({}, rest), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a stake pseudo-operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ stake(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$f3a9991068ba8db1(Object.assign(Object.assign(Object.assign(Object.assign({}, rest), {
                to: pkh
            }), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)), {
                parameter: {
                    entrypoint: 'stake',
                    value: {
                        prim: 'Unit'
                    }
                }
            }));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a unstake pseudo-operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ unstake(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$f3a9991068ba8db1(Object.assign(Object.assign(Object.assign(Object.assign({}, rest), {
                to: pkh
            }), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)), {
                parameter: {
                    entrypoint: 'unstake',
                    value: {
                        prim: 'Unit'
                    }
                }
            }));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a finalize_unstake pseudo-operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ finalizeUnstake(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$f3a9991068ba8db1(Object.assign(Object.assign(Object.assign(Object.assign({}, rest), {
                to: pkh,
                amount: 0
            }), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)), {
                parameter: {
                    entrypoint: 'finalize_unstake',
                    value: {
                        prim: 'Unit'
                    }
                }
            }));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a delegation operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ delegation(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$f6ca8c66abd5d967(Object.assign(Object.assign({}, rest), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a register delegate operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ registerDelegate(_a, source_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*({ fee: fee, storageLimit: storageLimit, gasLimit: gasLimit }, source) {
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const mergedEstimates = $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS);
            const op = yield $2fea24c565181d86$export$1823ae131c107679({
                fee: mergedEstimates.fee,
                storageLimit: mergedEstimates.storageLimit,
                gasLimit: mergedEstimates.gasLimit
            }, pkh);
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a register_global_constant operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ registerGlobalConstant(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$36ba5bd34bec1f48(Object.assign(Object.assign({}, rest), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare an update_consensus_key operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ updateConsensusKey(_a, source) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$ca68d75e3dde8c6(Object.assign(Object.assign({}, rest), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare an increase_paid_storage operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ increasePaidStorage(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$8bbbca5738264f6e(Object.assign(Object.assign({}, rest), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a ballot operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ ballot(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const op = yield $2fea24c565181d86$export$21e0e83bb1296bf6(Object.assign({}, params));
            const ops = this.convertIntoArray(op);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            let currentVotingPeriod;
            try {
                currentVotingPeriod = yield this.rpc.getCurrentPeriod();
            } catch (e) {
                throw new $2fea24c565181d86$var$RPCResponseError('Failed to get the current voting period index');
            }
            const contents = this.constructOpContents(ops, headCounter, pkh, undefined, currentVotingPeriod);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a proposals operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ proposals(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const op = yield $2fea24c565181d86$export$a50446e8b0c2fbdd(Object.assign({}, params));
            const ops = this.convertIntoArray(op);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            let currentVotingPeriod;
            try {
                currentVotingPeriod = yield this.rpc.getCurrentPeriod();
            } catch (e) {
                throw new $2fea24c565181d86$var$RPCResponseError('Failed to get the current voting period index');
            }
            const contents = this.constructOpContents(ops, headCounter, pkh, undefined, currentVotingPeriod);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a drain_delegate operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ drainDelegate(params, source) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh } = yield this.getKeys();
            const op = yield $2fea24c565181d86$export$3f02b23ff3ed5b1f(Object.assign({}, params));
            const ops = this.convertIntoArray(op);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a transfer_ticket operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ transferTicket(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$c2b0bb52eb4f8f40(Object.assign(Object.assign({}, rest), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a smart_rollup_add_messages operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ smartRollupAddMessages(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$e778921f9c3d1912(Object.assign(Object.assign({}, rest), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a smart_rollup_originate operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ smartRollupOriginate(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$7119c95759340192(Object.assign(Object.assign({}, $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)), rest));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a smart_rollup_execute_outbox_message operation
     * @param operation RPCOperation object or RPCOperation array
     * @param source string or undefined source pkh
     * @returns a PreparedOperation object
     */ smartRollupExecuteOutboxMessage(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const { pkh: pkh } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const op = yield $2fea24c565181d86$export$4b4c6fb209c7f56d(Object.assign(Object.assign({}, rest), $2fea24c565181d86$var$mergeLimits({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, DEFAULT_PARAMS)));
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh, rest.source);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a batch operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ batch(batchParams, estimates) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { pkh: pkh, publicKey: publicKey } = yield this.getKeys();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants, batchParams.length);
            const revealNeeded = yield this.isRevealOpNeeded(batchParams, pkh);
            const ops = [];
            if (!estimates) {
                for (const op of batchParams)if ($2fea24c565181d86$export$7a57b5299ba95181(op)) {
                    const limits = $2fea24c565181d86$var$mergeLimits(op, DEFAULT_PARAMS);
                    ops.push((yield this.getRPCOp(Object.assign(Object.assign({}, op), limits))));
                } else ops.push(Object.assign({}, op));
            } else {
                for (const op of batchParams)if ($2fea24c565181d86$export$7a57b5299ba95181(op)) {
                    const e = estimates.shift();
                    const limits = $2fea24c565181d86$var$mergeLimits(op, {
                        fee: e.suggestedFeeMutez,
                        storageLimit: e.storageLimit,
                        gasLimit: e.gasLimit
                    });
                    ops.push((yield this.getRPCOp(Object.assign(Object.assign({}, op), limits))));
                } else ops.push(Object.assign({}, op));
            }
            if (revealNeeded) {
                if (!publicKey) throw new (0, $580df0c6131ecaba$export$183b043cd3c947f9)(pkh);
                ops.unshift((yield $2fea24c565181d86$export$638a1bb58510476({
                    fee: $2fea24c565181d86$export$2a009c06b05c06b7(pkh),
                    storageLimit: $2fea24c565181d86$export$7dc909734d086289,
                    gasLimit: $2fea24c565181d86$export$199fe2d87a4763cf(pkh)
                }, pkh, publicKey)));
            }
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const contents = this.constructOpContents(ops, headCounter, pkh);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to prepare a batch operation
     * @param operation RPCOperation object or RPCOperation array
     * @returns a PreparedOperation object
     */ contractCall(contractMethod) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            const hash = yield this.getBlockHash();
            const protocol = yield this.getProtocolHash();
            const { pkh: pkh } = yield this.getKeys();
            $2fea24c565181d86$var$__classPrivateFieldSet(this, $2fea24c565181d86$var$_PrepareProvider_counters, {}, "f");
            const headCounter = parseInt((yield this.getHeadCounter(pkh)), 10);
            const params = contractMethod.toTransferParams();
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const DEFAULT_PARAMS = yield this.getOperationLimits(protocolConstants);
            const estimateLimits = $2fea24c565181d86$var$mergeLimits({
                fee: params.fee,
                storageLimit: params.storageLimit,
                gasLimit: params.gasLimit
            }, DEFAULT_PARAMS);
            const op = {
                kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION,
                fee: (_a = params.fee) !== null && _a !== void 0 ? _a : estimateLimits.fee,
                gas_limit: (_b = params.gasLimit) !== null && _b !== void 0 ? _b : estimateLimits.gasLimit,
                storage_limit: (_c = params.storageLimit) !== null && _c !== void 0 ? _c : estimateLimits.storageLimit,
                amount: String(params.amount),
                destination: params.to,
                parameters: params.parameter
            };
            const operation = yield this.addRevealOperationIfNeeded(op, pkh);
            const ops = this.convertIntoArray(operation);
            const contents = this.constructOpContents(ops, headCounter, pkh);
            return {
                opOb: {
                    branch: hash,
                    contents: contents,
                    protocol: protocol
                },
                counter: headCounter
            };
        });
    }
    /**
     *
     * @description Method to convert a PreparedOperation to the params needed for the preapplyOperation method
     * @param prepared a Prepared Operation
     * @returns a PreapplyParams object
     */ toPreapply(prepared) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { opOb: { contents: contents, branch: branch, protocol: protocol } } = prepared;
            const forgeParams = this.toForge(prepared);
            const forged = yield this.context.forger.forge(forgeParams);
            const sig = yield this.context.signer.sign(forged, new Uint8Array([
                3
            ]));
            return [
                {
                    contents: contents,
                    branch: branch,
                    protocol: protocol,
                    signature: sig.prefixSig
                }
            ];
        });
    }
    /**
     *
     * @description Method to convert a PreparedOperation to the params needed for forging
     * @param param a Prepared Operation
     * @returns a ForgeParams object
     */ toForge({ opOb: { contents: contents, branch: branch } }) {
        return {
            branch: branch,
            contents: contents
        };
    }
}
$2fea24c565181d86$var$_PrepareProvider_counters = new WeakMap();
const $2fea24c565181d86$var$BATCH_KINDS = [
    (0, $f93002942e85739a$export$b64a25b4a099ca08).ACTIVATION,
    (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION,
    (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION,
    (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION
];
class $2fea24c565181d86$export$7a235871f213c08c extends $2fea24c565181d86$var$Provider {
    constructor(context, estimator){
        super(context);
        this.estimator = estimator;
        this.operations = [];
        this.prepare = new $2fea24c565181d86$export$c3ce3aa140a1bd8b(this.context);
    }
    /**
     *
     * @description Add a transaction operation to the batch
     *
     * @param params Transfer operation parameter
     */ withTransfer(params) {
        const toValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.to);
        if (params.amount < 0) throw new (0, $580df0c6131ecaba$export$d8bf6d22cce8e288)(params.amount.toString());
        if (toValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.to, (0, $6ed3c564aba0f912$export$a2057601792df650)(toValidation));
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION
        }, params));
        return this;
    }
    /**
     *
     * @description Transfer tickets from a Tezos address (tz1,tz2 or tz3) to a smart contract address( KT1)
     *
     * @param params Transfer operation parameter
     */ withTransferTicket(params) {
        const destinationValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.destination);
        if (destinationValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.destination, (0, $6ed3c564aba0f912$export$a2057601792df650)(destinationValidation));
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSFER_TICKET
        }, params));
        return this;
    }
    /**
     *
     * @description Add a contract call to the batch
     *
     * @param params Call a contract method
     * @param options Generic operation parameters
     */ withContractCall(params, options = {}) {
        return this.withTransfer(params.toTransferParams(options));
    }
    /**
     *
     * @description Add a delegation operation to the batch
     *
     * @param params Delegation operation parameter
     */ withDelegation(params) {
        var _a;
        const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.source);
        if (params.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
        const delegateValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_a = params.delegate) !== null && _a !== void 0 ? _a : '');
        if (params.delegate && delegateValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.delegate, (0, $6ed3c564aba0f912$export$a2057601792df650)(delegateValidation));
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION
        }, params));
        return this;
    }
    /**
     *
     * @description Add an activation operation to the batch
     *
     * @param params Activation operation parameter
     * @throws {@link InvalidKeyHashError}
     */ withActivation({ pkh: pkh, secret: secret }) {
        const pkhValidation = (0, $6ed3c564aba0f912$export$dbd3afbe999d4c3d)(pkh);
        if (pkhValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$a3d7df0ca9d9410c)(pkh, (0, $6ed3c564aba0f912$export$a2057601792df650)(pkhValidation));
        this.operations.push({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).ACTIVATION,
            pkh: pkh,
            secret: secret
        });
        return this;
    }
    /**
     *
     * @description Add an origination operation to the batch
     *
     * @param params Origination operation parameter
     */ withOrigination(params) {
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION
        }, params));
        return this;
    }
    /**
     *
     * @description Add a register a global constant operation to the batch
     *
     * @param params RegisterGlobalConstant operation parameter
     */ withRegisterGlobalConstant(params) {
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT
        }, params));
        return this;
    }
    /**
     *
     * @description Add an increase paid storage operation to the batch
     *
     * @param params IncreasePaidStorage operation parameter
     */ withIncreasePaidStorage(params) {
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE
        }, params));
        return this;
    }
    /**
     *
     * @description Add a smart rollup add messages operation to the batch
     *
     * @param params Rollup origination operation parameter
     */ withSmartRollupAddMessages(params) {
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES
        }, params));
        return this;
    }
    /**
     *
     * @description Add a smart rollup originate operation to the batch
     *
     * @param params Smart Rollup Originate operation parameter
     */ withSmartRollupOriginate(params) {
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE
        }, params));
        return this;
    }
    /**
     *
     * @description Add a smart rollup execute outbox message to the batch
     *
     * @param params Smart Rollup Execute Outbox Message operation parameter
     */ withSmartRollupExecuteOutboxMessage(params) {
        this.operations.push(Object.assign({
            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE
        }, params));
        return this;
    }
    getRPCOp(param) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            switch(param.kind){
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION:
                    return $2fea24c565181d86$export$f3a9991068ba8db1(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION:
                    return $2fea24c565181d86$export$64dd15b44cde1e0b((yield this.context.parser.prepareCodeOrigination(Object.assign({}, param))));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION:
                    return $2fea24c565181d86$export$f6ca8c66abd5d967(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT:
                    return $2fea24c565181d86$export$36ba5bd34bec1f48(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                    return $2fea24c565181d86$export$8bbbca5738264f6e(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSFER_TICKET:
                    return $2fea24c565181d86$export$c2b0bb52eb4f8f40(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES:
                    return $2fea24c565181d86$export$e778921f9c3d1912(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE:
                    return $2fea24c565181d86$export$7119c95759340192(Object.assign({}, param));
                case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE:
                    return $2fea24c565181d86$export$4b4c6fb209c7f56d(Object.assign({}, param));
                default:
                    throw new (0, $580df0c6131ecaba$export$bc5be87550569b55)(JSON.stringify(param.kind));
            }
        });
    }
    /**
     *
     * @description Add a group operation to the batch. Operation will be applied in the order they are in the params array
     *
     * @param params Operations parameter
     * @throws {@link InvalidOperationKindError}
     */ with(params) {
        for (const param of params)switch(param.kind){
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION:
                this.withTransfer(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION:
                this.withOrigination(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION:
                this.withDelegation(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).ACTIVATION:
                this.withActivation(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT:
                this.withRegisterGlobalConstant(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE:
                this.withIncreasePaidStorage(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSFER_TICKET:
                this.withTransferTicket(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES:
                this.withSmartRollupAddMessages(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE:
                this.withSmartRollupOriginate(param);
                break;
            case (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE:
                this.withSmartRollupExecuteOutboxMessage(param);
                break;
            default:
                throw new (0, $580df0c6131ecaba$export$bc5be87550569b55)(JSON.stringify(param.kind));
        }
        return this;
    }
    /**
     *
     * @description Forge and Inject the operation batch
     *
     * @param params Optionally specify the source of the operation
     */ send(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const source = params && params.source || publicKeyHash;
            const estimates = yield this.estimator.batch(this.operations);
            if (estimates.length !== this.operations.length) estimates.shift();
            const preparedOp = yield this.prepare.batch(this.operations, estimates);
            const opBytes = yield this.forge(preparedOp);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$57d05bbf047997b6(hash, preparedOp.opOb.contents, source, forgedBytes, opResponse, context);
        });
    }
}
class $2fea24c565181d86$var$RPCBatchProvider {
    constructor(context, estimator){
        this.context = context;
        this.estimator = estimator;
    }
    /***
     *
     * @description Batch a group of operation together. Operations will be applied in the order in which they are added to the batch
     *
     * @param params List of operation to batch together
     */ batch(params) {
        const batch = new $2fea24c565181d86$export$7a235871f213c08c(this.context, this.estimator);
        if (Array.isArray(params)) batch.with(params);
        return batch;
    }
}
class $2fea24c565181d86$var$BatchWalletOperation extends $2fea24c565181d86$export$903c688feb2d259e {
    constructor(opHash, context, newHead$){
        super(opHash, context, newHead$);
        this.opHash = opHash;
        this.context = context;
        this.getOriginatedContractAddresses = ()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                const opResult = yield this.operationResults();
                if (!opResult) throw new $2fea24c565181d86$var$ObservableError('Unable to fetch operation results');
                else {
                    const originationOpResults = opResult.filter((x)=>x.kind === 'origination');
                    let addresses = [];
                    for (const res of originationOpResults)if (res.metadata.operation_result.originated_contracts) addresses = [
                        ...addresses,
                        ...res.metadata.operation_result.originated_contracts
                    ];
                    return addresses;
                }
            });
    }
    revealOperation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $2fea24c565181d86$var$ObservableError('Unable to fetch operation results');
            else return operationResult.find((x)=>x.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).REVEAL);
        });
    }
    status() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 'pending';
            const op = yield this.operationResults();
            if (op) return op.filter((result)=>$2fea24c565181d86$var$BATCH_KINDS.indexOf(result.kind) !== -1).map((result)=>{
                if ($2fea24c565181d86$export$d3f32861fe419773(result)) {
                    const opResult = result.metadata.operation_result;
                    return opResult.status;
                } else return 'unknown';
            })[0] || 'unknown';
            else throw new $2fea24c565181d86$var$ObservableError('Unable to fetch operation results');
        });
    }
}
class $2fea24c565181d86$var$IncreasePaidStorageWalletOperation extends $2fea24c565181d86$export$903c688feb2d259e {
    constructor(opHash, context, newHead$){
        super(opHash, context, newHead$);
        this.opHash = opHash;
        this.context = context;
    }
    revealOperation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $2fea24c565181d86$var$ObservableError('Unable to fetch operation result');
            else return operationResult.find((x)=>x.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).REVEAL);
        });
    }
    increasePaidStorageOperation() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const operationResult = yield this.operationResults();
            if (!operationResult) throw new $2fea24c565181d86$var$ObservableError('Unable to fetch operation result');
            else return operationResult.find((x)=>x.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE);
        });
    }
    status() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._included) return 'pending';
            const op = yield this.increasePaidStorageOperation();
            if (!op) return 'unknown';
            return op.metadata.operation_result.status;
        });
    }
}
function $2fea24c565181d86$var$timeoutAfter(timeoutMillisec) {
    return function inner(source) {
        return new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(null).pipe((0, $9491af11bb0ab327$export$83e74882c5df8fe1)({
            each: timeoutMillisec,
            with: ()=>(0, $8250ab9260498953$export$8bf7aba4a9e09055)(()=>new $2fea24c565181d86$var$ConfirmationTimeoutError(`Confirmation polling timed out`))
        }), (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)(()=>source));
    };
}
const $2fea24c565181d86$var$createNewPollingBasedHeadObservable = (sharedHeadOb, context, _scheduler)=>{
    return sharedHeadOb.pipe($2fea24c565181d86$var$timeoutAfter(context.config.confirmationPollingTimeoutSecond * 1000), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)({
        connector: ()=>new (0, $4a1890c700519557$export$915d2682b0aa0991)(1),
        resetOnError: false,
        resetOnComplete: false,
        resetOnRefCountZero: false
    }));
};
class $2fea24c565181d86$var$OperationFactory {
    constructor(context){
        this.context = context;
        // Cache the last block for one second across all operations
        this.sharedHeadObs = (0, $8312939aeeb1a4f7$export$260e5c0943f31606)(()=>{
            return $2fea24c565181d86$var$createObservableFromSubscription(this.context.stream.subscribeBlock('head'));
        });
    }
    createNewHeadObservable() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return $2fea24c565181d86$var$createNewPollingBasedHeadObservable(this.sharedHeadObs, this.context);
        });
    }
    createPastBlockWalker(startBlock, count = 1) {
        return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(this.context.readProvider.getBlock(startBlock)).pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((block)=>{
            if (count === 1) return (0, $195e3b3043565ec4$export$ba255e9e49e00608)(block);
            return (0, $48a6b248e7e71175$export$d02631cccf789723)(block.header.level, count - 1).pipe((0, $b52129d9072c7912$export$a4fe86229b0e9bdd)(block), (0, $9ee54e147202c320$export$c28c8388be0ab31a)((level)=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                    return this.context.readProvider.getBlock(typeof level === 'number' ? level : level.header.level);
                })));
        }));
    }
    createHeadObservableFromConfig(_a) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*({ blockIdentifier: blockIdentifier }) {
            const observableSequence = [];
            if (blockIdentifier) observableSequence.push(this.createPastBlockWalker(blockIdentifier));
            observableSequence.push((yield this.createNewHeadObservable()));
            return (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(...observableSequence);
        });
    }
    createOperation(hash_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(hash, config = {}) {
            return new $2fea24c565181d86$export$903c688feb2d259e(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
    createBatchOperation(hash_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(hash, config = {}) {
            return new $2fea24c565181d86$var$BatchWalletOperation(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
    createTransactionOperation(hash_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(hash, config = {}) {
            return new $2fea24c565181d86$export$8fc855f2a23d265f(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
    createTransferTicketOperation(hash_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(hash, config = {}) {
            return new $2fea24c565181d86$export$5acc00b845144ee9(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
    createDelegationOperation(hash_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(hash, config = {}) {
            return new $2fea24c565181d86$export$ac7733ff4c8bbbf1(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
    createOriginationOperation(hash_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(hash, config = {}) {
            return new $2fea24c565181d86$export$fc9b2020ddc4a55c(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
    createIncreasePaidStorageOperation(hash_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(hash, config = {}) {
            return new $2fea24c565181d86$var$IncreasePaidStorageWalletOperation(hash, this.context.clone(), (yield this.createHeadObservableFromConfig(config)));
        });
    }
}
class $2fea24c565181d86$var$RpcTzProvider extends $2fea24c565181d86$var$Provider {
    constructor(context){
        super(context);
        this.prepare = new $2fea24c565181d86$export$c3ce3aa140a1bd8b(this.context);
    }
    getBalance(address) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const addressValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(address);
            if (addressValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(address, (0, $6ed3c564aba0f912$export$a2057601792df650)(addressValidation));
            return this.context.readProvider.getBalance(address, 'head');
        });
    }
    getSpendable(address) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const addressValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(address);
            if (addressValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(address, (0, $6ed3c564aba0f912$export$a2057601792df650)(addressValidation));
            return this.context.readProvider.getSpendable(address, 'head');
        });
    }
    getDelegate(address) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const addressValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(address);
            if (addressValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(address, (0, $6ed3c564aba0f912$export$a2057601792df650)(addressValidation));
            return this.context.readProvider.getDelegate(address, 'head');
        });
    }
    activate(pkh, secret) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const pkhValidation = (0, $6ed3c564aba0f912$export$dbd3afbe999d4c3d)(pkh);
            if (pkhValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $c34ebaa6f129c2ed$export$a3d7df0ca9d9410c)(pkh, (0, $6ed3c564aba0f912$export$a2057601792df650)(pkhValidation));
            const prepared = yield this.prepare.activate({
                pkh: pkh,
                secret: secret
            });
            const forgedBytes = yield this.forge(prepared);
            const bytes = `${forgedBytes.opbytes}00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000`;
            return new $2fea24c565181d86$export$ab5aad00225c5662((yield this.rpc.injectOperation(bytes)), Object.assign(Object.assign({}, forgedBytes), {
                opbytes: bytes
            }), [], this.context.clone());
        });
    }
}
const $2fea24c565181d86$var$MINIMAL_FEE_MUTEZ = 100;
const $2fea24c565181d86$var$MINIMAL_FEE_PER_BYTE_MUTEZ = 1;
const $2fea24c565181d86$var$MINIMAL_FEE_PER_GAS_MUTEZ = 0.1;
/**
 * Examples of use :
 *
 *  Estimate a transfer operation :
 * ```
 * // Assuming that provider and signer are already configured...
 *
 * const amount = 2;
 * const address = 'tz1h3rQ8wBxFd8L9B3d7Jhaawu6Z568XU3xY';
 *
 * // Estimate gasLimit, storageLimit and fees for a transfer operation
 * const est = await Tezos.estimate.transfer({ to: address, amount: amount })
 * console.log(est.burnFeeMutez, est.gasLimit, est.minimalFeeMutez, est.storageLimit,
 *  est.suggestedFeeMutez, est.totalCost, est.usingBaseFeeMutez)
 *
 * ```
 *
 * Estimate a contract origination :
 * ```
 * // generic.json is referring to a Michelson Smart Contract
 *
 * const genericMultisigJSON = require('./generic.json')
 * const est = await Tezos.estimate.originate({
 *   code: genericMultisigJSON,
 *   storage: {
 *     stored_counter: 0,
 *     threshold: 1,
 *     keys: ['edpkuLxx9PQD8fZ45eUzrK3BhfDZJHhBuK4Zi49DcEGANwd2rpX82t']
 *   }
 * })
 * console.log(est.burnFeeMutez, est.gasLimit, est.minimalFeeMutez, est.storageLimit,
 *   est.suggestedFeeMutez, est.totalCost, est.usingBaseFeeMutez)
 *
 * ```
 */ class $2fea24c565181d86$export$f24de3004fef8471 {
    constructor(_milligasLimit, _storageLimit, opSize, minimalFeePerStorageByteMutez, /**
     * @description Base fee in mutez (1 mutez = 1e10−6 tez)
     */ baseFeeMutez = $2fea24c565181d86$var$MINIMAL_FEE_MUTEZ){
        this._milligasLimit = _milligasLimit;
        this._storageLimit = _storageLimit;
        this.opSize = opSize;
        this.minimalFeePerStorageByteMutez = minimalFeePerStorageByteMutez;
        this.baseFeeMutez = baseFeeMutez;
    }
    /**
     * @description The number of Mutez that will be burned for the storage of the [operation](https://tezos.gitlab.io/user/glossary.html#operations). (Storage + Allocation fees)
     */ get burnFeeMutez() {
        return this.roundUp(Number(this.storageLimit) * Number(this.minimalFeePerStorageByteMutez));
    }
    /**
     * @description  The limit on the amount of storage an [operation](https://tezos.gitlab.io/user/glossary.html#operations) can use with 20 buffer.
     */ get storageLimit() {
        return Math.max(Number(this._storageLimit), 0);
    }
    /**
     * @description The limit on the amount of [gas](https://tezos.gitlab.io/user/glossary.html#gas) a given operation can consume with 100 buffer depends on the operation.
     */ get gasLimit() {
        return this.roundUp(Number(this._milligasLimit) / 1000);
    }
    get operationFeeMutez() {
        return this.gasLimit * $2fea24c565181d86$var$MINIMAL_FEE_PER_GAS_MUTEZ + Number(this.opSize) * $2fea24c565181d86$var$MINIMAL_FEE_PER_BYTE_MUTEZ;
    }
    roundUp(nanotez) {
        return Math.ceil(Number(nanotez));
    }
    /**
     * @description Minimum fees for the [operation](https://tezos.gitlab.io/user/glossary.html#operations) according to [baker](https://tezos.gitlab.io/user/glossary.html#baker) defaults.
     */ get minimalFeeMutez() {
        return this.roundUp(this.operationFeeMutez + $2fea24c565181d86$var$MINIMAL_FEE_MUTEZ);
    }
    /**
     * @description The suggested fee for the operation which includes minimal fees and a small buffer.
     */ get suggestedFeeMutez() {
        return this.roundUp(this.operationFeeMutez + $2fea24c565181d86$var$MINIMAL_FEE_MUTEZ * 1.2);
    }
    /**
     * @description Fees according to your specified base fee will ensure that at least minimum fees are used.
     */ get usingBaseFeeMutez() {
        return Math.max(Number(this.baseFeeMutez), $2fea24c565181d86$var$MINIMAL_FEE_MUTEZ) + this.roundUp(this.operationFeeMutez);
    }
    /**
     * @description The sum of `minimalFeeMutez` + `burnFeeMutez`.
     */ get totalCost() {
        return this.minimalFeeMutez + this.burnFeeMutez;
    }
    /**
     * @description Since Delphinet, consumed gas is provided in milligas for more precision.
     * This function returns an estimation of the gas that operation will consume in milligas.
     */ get consumedMilligas() {
        return Number(this._milligasLimit);
    }
    static createEstimateInstanceFromProperties(estimateProperties) {
        let milligasLimit = 0;
        let storageLimit = 0;
        let opSize = 0;
        let minimalFeePerStorageByteMutez = 0;
        let baseFeeMutez;
        estimateProperties.forEach((estimate)=>{
            milligasLimit += estimate.milligasLimit;
            storageLimit += estimate.storageLimit;
            opSize += estimate.opSize;
            minimalFeePerStorageByteMutez = Math.max(estimate.minimalFeePerStorageByteMutez, minimalFeePerStorageByteMutez);
            if (estimate.baseFeeMutez) baseFeeMutez = baseFeeMutez ? baseFeeMutez + estimate.baseFeeMutez : estimate.baseFeeMutez;
        });
        return new $2fea24c565181d86$export$f24de3004fef8471(milligasLimit, storageLimit, opSize, minimalFeePerStorageByteMutez, baseFeeMutez);
    }
    static createArrayEstimateInstancesFromProperties(estimateProperties) {
        return estimateProperties.map((x)=>new $2fea24c565181d86$export$f24de3004fef8471(x.milligasLimit, x.storageLimit, x.opSize, x.minimalFeePerStorageByteMutez, x.baseFeeMutez));
    }
}
/**
 *  @category Error
 *  @description Error that indicates unable to get public key to estimate reveal operation in Wallet API
 */ class $2fea24c565181d86$export$921226cb1345c97b extends (0, $580df0c6131ecaba$export$e5619b407b1c8b0a) {
    constructor(){
        super();
        this.name = 'RevealEstimateError';
        this.message = 'Public key is unknown, unable to estimate the reveal operation in Wallet API.';
    }
}
// stub signature that won't be verified by tezos rpc simulate_operation
const $2fea24c565181d86$var$STUB_SIGNATURE = 'edsigtkpiSSschcaCt9pUVrpNPf7TTcgvgDEDD6NCEHMy8NNQJCGnMfLZzYoQj74yLjo9wx6MPVV29CvVzgi7qEcEUok3k7AuMg';
class $2fea24c565181d86$export$a0b53ef5867b3b16 extends $2fea24c565181d86$var$Provider {
    constructor(){
        super(...arguments);
        this.OP_SIZE_REVEAL = 324; // injecting size tz1=320, tz2=322, tz3=322, tz4=420(not supported)
        this.MILLIGAS_BUFFER = 100000; // 100 buffer depends on operation kind
        this.STORAGE_BUFFER = 20; // according to octez-client
        this.prepare = new $2fea24c565181d86$export$c3ce3aa140a1bd8b(this.context);
    }
    getKeys() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const isSignerConfigured = this.context.isAnySignerConfigured();
            return {
                publicKeyHash: isSignerConfigured ? yield this.signer.publicKeyHash() : yield this.context.walletProvider.getPKH(),
                publicKey: isSignerConfigured ? yield this.signer.publicKey() : undefined
            };
        });
    }
    getEstimationPropertiesFromOperationContent(content, size, costPerByte, originationSize) {
        const operationResults = $2fea24c565181d86$var$flattenOperationResult({
            contents: [
                content
            ]
        });
        let consumedMilligas = 0;
        let accumulatedStorage = 0;
        operationResults.forEach((result)=>{
            consumedMilligas += Number(result.consumed_milligas) || 0;
            // transfer to unrevealed implicit
            accumulatedStorage += 'allocated_destination_contract' in result ? originationSize : 0;
            // originate
            accumulatedStorage += 'originated_contracts' in result && Array.isArray(result.originated_contracts) ? result.originated_contracts.length * originationSize : 0;
            // register_global_constants
            accumulatedStorage += 'storage_size' in result && 'global_address' in result ? Number(result.storage_size) || 0 : 0;
            // transfer_ticket, originate, contract_call
            accumulatedStorage += 'paid_storage_size_diff' in result ? Number(result.paid_storage_size_diff) || 0 : 0;
            //smart_rollup_originate
            accumulatedStorage += 'genesis_commitment_hash' in result ? Number(result.size) || 0 : 0;
        });
        if ($2fea24c565181d86$export$7a57b5299ba95181(content)) return {
            milligasLimit: $2fea24c565181d86$export$5ebdc3eb4194b813(content) ? consumedMilligas + Number(this.MILLIGAS_BUFFER) : consumedMilligas,
            storageLimit: accumulatedStorage > 0 ? accumulatedStorage + this.STORAGE_BUFFER : 0,
            opSize: size,
            minimalFeePerStorageByteMutez: costPerByte.toNumber()
        };
        else return {
            milligasLimit: 0,
            storageLimit: 0,
            opSize: size,
            minimalFeePerStorageByteMutez: costPerByte.toNumber(),
            baseFeeMutez: 0
        };
    }
    calculateEstimates(op, constants) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { opbytes: opbytes, opOb: { branch: branch, contents: contents } } = yield this.forge(op);
            const operation = {
                operation: {
                    branch: branch,
                    contents: contents,
                    signature: $2fea24c565181d86$var$STUB_SIGNATURE
                },
                chain_id: yield this.context.readProvider.getChainId()
            };
            const { opResponse: opResponse } = yield this.simulate(operation);
            const { cost_per_byte: cost_per_byte, origination_size: origination_size } = constants;
            const errors = [
                ...$2fea24c565181d86$var$flattenErrors(opResponse, 'backtracked'),
                ...$2fea24c565181d86$var$flattenErrors(opResponse)
            ];
            // Fail early in case of errors
            if (errors.length) throw new $2fea24c565181d86$export$a971cb9d7d565551(errors, 'Error occurred during estimation', opResponse.contents);
            let numberOfOps = 1;
            if (Array.isArray(op.opOb.contents) && op.opOb.contents.length > 1) numberOfOps = opResponse.contents[0].kind === 'reveal' ? op.opOb.contents.length - 1 : op.opOb.contents.length;
            return opResponse.contents.map((x)=>{
                return this.getEstimationPropertiesFromOperationContent(x, // diff between estimated and injecting OP_SIZE is 124-126, we added buffer to use 130
                x.kind === 'reveal' ? this.OP_SIZE_REVEAL / 2 : (opbytes.length + 130) / 2 / numberOfOps, cost_per_byte, origination_size !== null && origination_size !== void 0 ? origination_size : 257 // protocol constants
                );
            });
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an origination operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param OriginationOperation Originate operation parameter
     */ originate(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const preparedOperation = yield this.prepare.originate(params);
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an transfer operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param TransferOperation Originate operation parameter
     */ transfer(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _b;
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const toValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(rest.to);
            if (toValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(rest.to, (0, $6ed3c564aba0f912$export$a2057601792df650)(toValidation));
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_b = rest.source) !== null && _b !== void 0 ? _b : '');
            if (rest.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(rest.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            if (rest.amount < 0) throw new (0, $580df0c6131ecaba$export$d8bf6d22cce8e288)(rest.amount.toString());
            const preparedOperation = yield this.prepare.transaction(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an stake pseudo-operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Stake pseudo-operation parameter
     */ stake(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _b;
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_b = rest.source) !== null && _b !== void 0 ? _b : '');
            if (rest.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(rest.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            if (!rest.to) rest.to = rest.source;
            if (rest.to && rest.to !== rest.source) throw new (0, $580df0c6131ecaba$export$be6cb9338b7137e0)(rest.to);
            if (rest.amount < 0) throw new (0, $580df0c6131ecaba$export$d8bf6d22cce8e288)(rest.amount.toString());
            const preparedOperation = yield this.prepare.stake(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an Unstake pseudo-operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Unstake pseudo-operation parameter
     */ unstake(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _b;
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_b = rest.source) !== null && _b !== void 0 ? _b : '');
            if (rest.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(rest.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            if (!rest.to) rest.to = rest.source;
            if (rest.to && rest.to !== rest.source) throw new (0, $580df0c6131ecaba$export$be6cb9338b7137e0)(rest.to);
            if (rest.amount < 0) throw new (0, $580df0c6131ecaba$export$d8bf6d22cce8e288)(rest.amount.toString());
            const preparedOperation = yield this.prepare.unstake(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an finalize_unstake pseudo-operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param finalize_unstake pseudo-operation parameter
     */ finalizeUnstake(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _b;
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_b = rest.source) !== null && _b !== void 0 ? _b : '');
            if (rest.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(rest.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            if (!rest.to) rest.to = rest.source;
            if (rest.to && rest.to !== rest.source) throw new (0, $580df0c6131ecaba$export$be6cb9338b7137e0)(rest.to);
            if (!rest.amount) rest.amount = 0;
            if (rest.amount !== undefined && rest.amount !== 0) throw new Error('Amount must be 0 for finalize_unstake operation');
            const preparedOperation = yield this.prepare.finalizeUnstake(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a transferTicket operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param TransferTicketParams operation parameter
     */ transferTicket(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _b;
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const destinationValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(rest.destination);
            if (destinationValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(rest.destination, (0, $6ed3c564aba0f912$export$a2057601792df650)(destinationValidation));
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_b = rest.source) !== null && _b !== void 0 ? _b : '');
            if (rest.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(rest.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.transferTicket(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a delegate operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Estimate
     */ setDelegate(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _b;
            var { fee: fee, gasLimit: gasLimit, storageLimit: storageLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "gasLimit",
                "storageLimit"
            ]);
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(rest.source);
            if (rest.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(rest.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            const delegateValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_b = rest.delegate) !== null && _b !== void 0 ? _b : '');
            if (rest.delegate && delegateValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(rest.delegate, (0, $6ed3c564aba0f912$export$a2057601792df650)(delegateValidation));
            const preparedOperation = yield this.prepare.delegation(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a each operation in the batch
     *
     * @returns An array of Estimate objects. If a reveal operation is needed, the first element of the array is the Estimate for the reveal operation.
     */ batch(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperations = yield this.prepare.batch(params);
            const estimateProperties = yield this.calculateEstimates(preparedOperations, protocolConstants);
            return $2fea24c565181d86$export$f24de3004fef8471.createArrayEstimateInstancesFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a delegate operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Estimate
     */ registerDelegate(_a, source) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const pkh = (yield this.getKeys()).publicKeyHash;
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const checkSource = source || pkh;
            const preparedOperation = yield this.prepare.registerDelegate(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest), checkSource);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees to reveal the current account
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation or undefined if the account is already revealed
     *
     * @param Estimate
     */ reveal(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { publicKeyHash: publicKeyHash, publicKey: publicKey } = yield this.getKeys();
            if (!publicKey) throw new $2fea24c565181d86$export$921226cb1345c97b();
            if (yield this.isAccountRevealRequired(publicKeyHash)) {
                const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
                const preparedOperation = params ? yield this.prepare.reveal(params) : yield this.prepare.reveal({});
                const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
                return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
            }
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an registerGlobalConstant operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param params registerGlobalConstant operation parameter
     */ registerGlobalConstant(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            const preparedOperation = yield this.prepare.registerGlobalConstant(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit, and fees for an increasePaidStorage operation
     *
     * @returns An estimation of gasLimit, storageLimit, and fees for the operation
     *
     * @param params increasePaidStorage operation parameters
     */ increasePaidStorage(_a) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var { fee: fee, storageLimit: storageLimit, gasLimit: gasLimit } = _a, rest = $2fea24c565181d86$var$__rest(_a, [
                "fee",
                "storageLimit",
                "gasLimit"
            ]);
            if (rest.amount < 0) throw new (0, $580df0c6131ecaba$export$d8bf6d22cce8e288)(rest.amount.toString());
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.increasePaidStorage(Object.assign({
                fee: fee,
                storageLimit: storageLimit,
                gasLimit: gasLimit
            }, rest));
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an Update Consensus Key operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Estimate
     */ updateConsensusKey(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.updateConsensusKey(params);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a smart_rollup_add_messages operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Estimate
     */ smartRollupAddMessages(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.smartRollupAddMessages(params);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for an Smart Rollup Originate operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param SmartRollupOriginateParams
     */ smartRollupOriginate(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.smartRollupOriginate(params);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for a smart_rollup_execute_outbox_message operation
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the operation
     *
     * @param Estimate
     */ smartRollupExecuteOutboxMessage(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.smartRollupExecuteOutboxMessage(params);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') estimateProperties.shift();
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
    /**
     *
     * @description Estimate gasLimit, storageLimit and fees for contract call
     *
     * @returns An estimation of gasLimit, storageLimit and fees for the contract call
     *
     * @param Estimate
     */ contractCall(contractMethod) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConstants = yield this.context.readProvider.getProtocolConstants('head');
            const preparedOperation = yield this.prepare.contractCall(contractMethod);
            const estimateProperties = yield this.calculateEstimates(preparedOperation, protocolConstants);
            if (preparedOperation.opOb.contents[0].kind === 'reveal') {
                estimateProperties.shift();
                estimateProperties[0].opSize -= this.OP_SIZE_REVEAL / 2;
            }
            return $2fea24c565181d86$export$f24de3004fef8471.createEstimateInstanceFromProperties(estimateProperties);
        });
    }
}
/**
 * @description Delegation operation provide utility function to fetch newly issued delegation
 *
 * @warn Currently support only one delegation per operation
 */ class $2fea24c565181d86$export$ce3dabbdbcbbc321 extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const delegationOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'delegation');
        const result = delegationOp && delegationOp.metadata && delegationOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get delegate() {
        return this.params.delegate;
    }
    get isRegisterOperation() {
        return this.delegate === this.source;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedGas() {
        (0, $42f5864281cc433e$exports.BigNumber).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, $42f5864281cc433e$exports.BigNumber).ROUND_UP
        });
        return this.consumedMilliGas ? new (0, $42f5864281cc433e$exports.BigNumber)(this.consumedMilliGas).dividedBy(1000).toString() : undefined;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
}
/**
 * @description Origination operation provide utility function to fetch newly originated contract
 *
 * @warn Currently support only one origination per operation
 */ class $2fea24c565181d86$export$ec1f5c67b17f835a extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, raw, results, context, contractProvider){
        super(hash, raw, results, context);
        this.params = params;
        this.contractProvider = contractProvider;
        const originatedContracts = this.operationResults && this.operationResults.originated_contracts;
        if (Array.isArray(originatedContracts)) this.contractAddress = originatedContracts[0];
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get operationResults() {
        const originationOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'origination');
        const result = originationOp && $2fea24c565181d86$export$d3f32861fe419773(originationOp) && originationOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedGas() {
        (0, $42f5864281cc433e$exports.BigNumber).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, $42f5864281cc433e$exports.BigNumber).ROUND_UP
        });
        return this.consumedMilliGas ? new (0, $42f5864281cc433e$exports.BigNumber)(this.consumedMilliGas).dividedBy(1000).toString() : undefined;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get storageDiff() {
        const storageDiff = this.operationResults && this.operationResults.paid_storage_size_diff;
        return storageDiff ? storageDiff : undefined;
    }
    get storageSize() {
        const storageSize = this.operationResults && this.operationResults.storage_size;
        return storageSize ? storageSize : undefined;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
    /**
     * @description Provide the contract abstract of the newly originated contract
     * @throws {@link OriginationOperationError}
     */ contract(confirmations, timeout) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.contractAddress) throw new $2fea24c565181d86$var$OriginationOperationError('No contract was originated in this operation');
            yield this.confirmation(confirmations, timeout);
            return this.contractProvider.at(this.contractAddress);
        });
    }
}
/**
 * @description RegisterGlobalConstantOperation provides utility functions to fetch a newly issued operation of kind register_global_constant
 */ class $2fea24c565181d86$export$3b8dda899a5ab452 extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
        this.globalConstantHash = this.operationResults && this.operationResults.global_address;
    }
    get operationResults() {
        const registerGlobalConstantOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'register_global_constant');
        const result = registerGlobalConstantOp && registerGlobalConstantOp.metadata && registerGlobalConstantOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get registeredExpression() {
        return this.params.value;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
    get consumedGas() {
        (0, $42f5864281cc433e$exports.BigNumber).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, $42f5864281cc433e$exports.BigNumber).ROUND_UP
        });
        return this.consumedMilliGas ? new (0, $42f5864281cc433e$exports.BigNumber)(this.consumedMilliGas).dividedBy(1000).toString() : undefined;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
}
/**
 * @description Reveal operation provides utility functions to fetch a newly issued revelation
 */ class $2fea24c565181d86$export$14d3da7f07184894 extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const revealOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'reveal');
        return revealOp ? [
            revealOp
        ] : [];
    }
    get status() {
        const operationResults = this.operationResults;
        const txResult = operationResults[0];
        if (txResult) return txResult.metadata.operation_result.status;
        else return 'unknown';
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get publicKey() {
        return this.params.public_key;
    }
    sumProp(arr, prop) {
        return arr.reduce((prev, current)=>{
            return prop in current ? Number(current[prop]) + prev : prev;
        }, 0);
    }
    get consumedGas() {
        (0, $42f5864281cc433e$exports.BigNumber).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, $42f5864281cc433e$exports.BigNumber).ROUND_UP
        });
        return new (0, $42f5864281cc433e$exports.BigNumber)(this.consumedMilliGas).dividedBy(1000).toString();
    }
    get consumedMilliGas() {
        return String(this.sumProp($2fea24c565181d86$var$flattenOperationResult({
            contents: this.operationResults
        }), 'consumed_milligas'));
    }
    get storageDiff() {
        return String(this.sumProp($2fea24c565181d86$var$flattenOperationResult({
            contents: this.operationResults
        }), 'paid_storage_size_diff'));
    }
    get storageSize() {
        return String(this.sumProp($2fea24c565181d86$var$flattenOperationResult({
            contents: this.operationResults
        }), 'storage_size'));
    }
    get errors() {
        return $2fea24c565181d86$var$flattenErrors({
            contents: this.operationResults
        });
    }
}
/**
 * @description Transaction operation provides utility functions to fetch a newly issued transaction
 *
 * @warn Currently supports one transaction per operation
 */ class $2fea24c565181d86$export$831ca37464f9fe3 extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const transactionOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'transaction');
        return transactionOp ? [
            transactionOp
        ] : [];
    }
    get status() {
        const operationResults = this.operationResults;
        const txResult = operationResults[0];
        if (txResult) return txResult.metadata.operation_result.status;
        else return 'unknown';
    }
    get amount() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(this.params.amount);
    }
    get destination() {
        return this.params.destination;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    sumProp(arr, prop) {
        return arr.reduce((prev, current)=>{
            return prop in current ? Number(current[prop]) + prev : prev;
        }, 0);
    }
    get consumedGas() {
        (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports))).ROUND_UP
        });
        return new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(this.consumedMilliGas).dividedBy(1000).toString();
    }
    get consumedMilliGas() {
        return String(this.sumProp($2fea24c565181d86$var$flattenOperationResult({
            contents: this.operationResults
        }), 'consumed_milligas'));
    }
    get storageDiff() {
        return String(this.sumProp($2fea24c565181d86$var$flattenOperationResult({
            contents: this.operationResults
        }), 'paid_storage_size_diff'));
    }
    get storageSize() {
        return String(this.sumProp($2fea24c565181d86$var$flattenOperationResult({
            contents: this.operationResults
        }), 'storage_size'));
    }
    get errors() {
        return $2fea24c565181d86$var$flattenErrors({
            contents: this.operationResults
        });
    }
}
/**
 *
 * @description IncreasePaidStorageOperation provides utility functions to fetch a new operation of kind increase_paid_storage
 *
 */ class $2fea24c565181d86$export$8d528f7d576e7bf3 extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const increasePaidStorageOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'increase_paid_storage');
        const result = increasePaidStorageOp && increasePaidStorageOp.metadata && increasePaidStorageOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get amount() {
        return this.params.amount;
    }
    get destination() {
        return this.params.destination;
    }
}
/**
 *
 * @description UpdateConsensusKeyOperation provides utility to fetch properties for Operation of kind UpdateConsensusKey
 *
 */ class $2fea24c565181d86$export$fd8ddc29035a3b9d extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const updateConsensusKeyOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'update_consensus_key');
        const result = updateConsensusKeyOp && updateConsensusKeyOp.metadata && updateConsensusKeyOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get pk() {
        return this.params.pk;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
}
/**
 * @description SmartRollupAddMessagesOperation provides utility to fetch properties of SmartRollupAddMessages
 */ class $2fea24c565181d86$export$80c7f5b8306f2de6 extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const smartRollupAddMessagesOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'smart_rollup_add_messages');
        const result = smartRollupAddMessagesOp && smartRollupAddMessagesOp.metadata && smartRollupAddMessagesOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get message() {
        return this.params.message;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
}
/**
 *
 * @description SmartRollupOriginate Operation provides utility to fetch properties for Operation of kind SmartRollupOriginate
 *
 */ class $2fea24c565181d86$export$392a36414e72aa5d extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const smartRollupOriginateOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE);
        const result = smartRollupOriginateOp && smartRollupOriginateOp.metadata && smartRollupOriginateOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get pvmKind() {
        return this.params.pvm_kind;
    }
    get kernel() {
        return this.params.kernel;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
}
/**
 *
 * @description BallotOperation provides utility functions to fetch a new operation of kind ballot
 *
 */ class $2fea24c565181d86$export$7c85c5993418b9a9 extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const ballotOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'ballot');
        const result = ballotOp;
        return result ? result : undefined;
    }
    get period() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.period;
    }
    get proposal() {
        return this.params.proposal;
    }
    get ballot() {
        return this.params.ballot;
    }
}
/**
 *
 * @description DrainDelegateOperation provides utility functions to fetch a new operation of kind drain_delegate
 *
 */ class $2fea24c565181d86$export$a70f4d895fdd289e extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
    }
    get operationResults() {
        const drainDelegateOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'drain_delegate');
        const result = drainDelegateOp && drainDelegateOp.metadata && drainDelegateOp.metadata.balance_updates;
        return result ? result : undefined;
    }
    get consensusKey() {
        return this.params.consensus_key;
    }
    get delegate() {
        return this.params.delegate;
    }
    get destination() {
        return this.params.destination;
    }
}
/**
 *
 * @description ProposalsOperation provides utility functions to fetch a new operation of kind proposals
 *
 */ class $2fea24c565181d86$export$f85d38729ebbe78f extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const proposalsOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === 'proposals');
        const result = proposalsOp;
        return result ? result : undefined;
    }
    get proposals() {
        return this.params.proposals;
    }
    get period() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.period;
    }
}
/**
 *
 * @description Transfer tickets from a Tezos address (tz1, tz2 or tz3) to a smart contract address (KT1) (everything on layer 1 at this step)
 *
 * @warn Currently only supports one L2 ticket holder transfer at once. ie. one collection of tickets owned by tz1, tz2 or tz3 to a smart contract.
 */ class $2fea24c565181d86$export$e2d2edc8d45e91bd extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const transferOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSFER_TICKET);
        const result = transferOp && transferOp.metadata && transferOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedGas() {
        (0, $42f5864281cc433e$exports.BigNumber).config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: (0, $42f5864281cc433e$exports.BigNumber).ROUND_UP
        });
        return this.consumedMilliGas ? new (0, $42f5864281cc433e$exports.BigNumber)(this.consumedMilliGas).dividedBy(1000).toString() : undefined;
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
}
/**
 *
 * @description SmartRollupExecuteOutboxMessage Operation provides utility to fetch properties for Operation of kind SmartRollupExecuteOutboxMessage
 *
 */ class $2fea24c565181d86$var$SmartRollupExecuteOutboxMessageOperation extends $2fea24c565181d86$export$ab5aad00225c5662 {
    constructor(hash, params, source, raw, results, context){
        super(hash, raw, results, context);
        this.params = params;
        this.source = source;
    }
    get operationResults() {
        const smartRollupExecuteOutboxMessageOp = Array.isArray(this.results) && this.results.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE);
        const result = smartRollupExecuteOutboxMessageOp && smartRollupExecuteOutboxMessageOp.metadata && smartRollupExecuteOutboxMessageOp.metadata.operation_result;
        return result ? result : undefined;
    }
    get status() {
        var _a, _b;
        return (_b = (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unknown';
    }
    get rollup() {
        return this.params.rollup;
    }
    get cementedCommitment() {
        return this.params.cemented_commitment;
    }
    get outputProof() {
        return this.params.output_proof;
    }
    get fee() {
        return Number(this.params.fee);
    }
    get gasLimit() {
        return Number(this.params.gas_limit);
    }
    get storageLimit() {
        return Number(this.params.storage_limit);
    }
    get consumedMilliGas() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.consumed_milligas;
    }
    get errors() {
        var _a;
        return (_a = this.operationResults) === null || _a === void 0 ? void 0 : _a.errors;
    }
}
class $2fea24c565181d86$var$RpcContractProvider extends $2fea24c565181d86$var$Provider {
    constructor(context, estimator){
        super(context);
        this.estimator = estimator;
        this.contractProviderTypeSymbol = Symbol.for('taquito-contract-provider-type-symbol');
        this.prepare = new $2fea24c565181d86$export$c3ce3aa140a1bd8b(this.context);
    }
    /**
     *
     * @description Return a well formatted json object of the contract storage
     *
     * @param contract contract address you want to get the storage from
     * @param schema optional schema can either be the contract script rpc response or a michelson-encoder schema
     * @throws {@link InvalidContractAddressError}
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-contracts-contract-id-script
     */ getStorage(contract, schema) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const contractValidation = (0, $6ed3c564aba0f912$export$2ed905adbd9a56f2)(contract);
            if (contractValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$193774326795229b)(contract, (0, $6ed3c564aba0f912$export$a2057601792df650)(contractValidation));
            const script = yield this.context.readProvider.getScript(contract, 'head');
            if (!schema) schema = script;
            let contractSchema;
            if ((0, $c46b7dbea18e1f8c$export$19342e026b58ebb7).isSchema(schema)) contractSchema = schema;
            else contractSchema = (0, $c46b7dbea18e1f8c$export$19342e026b58ebb7).fromRPCResponse({
                script: schema
            });
            return contractSchema.Execute(script.storage, $2fea24c565181d86$export$c616f2921e28f4d2(this)); // Cast into T because only the caller can know the true type of the storage
        });
    }
    /**
     *
     * @description Return a well formatted json object of the contract big map storage
     *
     * @param contract contract address you want to get the storage from
     * @param key contract big map key to fetch value from
     * @param schema optional schema can either be the contract script rpc response or a michelson-encoder schema
     * @throws {@link InvalidContractAddressError}
     * @deprecated Deprecated in favor of getBigMapKeyByID
     *
     * @see https://tezos.gitlab.io/api/rpc.html#post-block-id-context-contracts-contract-id-big-map-get
     */ getBigMapKey(contract, key, schema) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const contractValidation = (0, $6ed3c564aba0f912$export$2ed905adbd9a56f2)(contract);
            if (contractValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$193774326795229b)(contract, (0, $6ed3c564aba0f912$export$a2057601792df650)(contractValidation));
            if (!schema) schema = (yield this.rpc.getContract(contract)).script;
            let contractSchema;
            if ((0, $c46b7dbea18e1f8c$export$19342e026b58ebb7).isSchema(schema)) contractSchema = schema;
            else contractSchema = (0, $c46b7dbea18e1f8c$export$19342e026b58ebb7).fromRPCResponse({
                script: schema
            });
            const encodedKey = contractSchema.EncodeBigMapKey(key);
            const val = yield this.rpc.getBigMapKey(contract, encodedKey);
            return contractSchema.ExecuteOnBigMapValue(val); // Cast into T because only the caller can know the true type of the storage
        });
    }
    /**
     *
     * @description Return a well formatted json object of a big map value
     *
     * @param id Big Map ID
     * @param keyToEncode key to query (will be encoded properly according to the schema)
     * @param schema Big Map schema (can be determined using your contract type)
     * @param block optional block level to fetch the values from
     *
     * @see https://tezos.gitlab.io/api/rpc.html#get-block-id-context-big-maps-big-map-id-script-expr
     */ getBigMapKeyByID(id, keyToEncode, schema, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { key: key, type: type } = schema.EncodeBigMapKey(keyToEncode);
            const { packed: packed } = yield this.context.packer.packData({
                data: key,
                type: type
            });
            const encodedExpr = (0, $6ed3c564aba0f912$export$8069b2d054f1e0a)(packed);
            const bigMapValue = block ? yield this.context.readProvider.getBigMapValue({
                id: id.toString(),
                expr: encodedExpr
            }, block) : yield this.context.readProvider.getBigMapValue({
                id: id.toString(),
                expr: encodedExpr
            }, 'head');
            return schema.ExecuteOnBigMapValue(bigMapValue, $2fea24c565181d86$export$c616f2921e28f4d2(this));
        });
    }
    /**
     *
     * @description Fetch multiple values in a big map
     * All values will be fetched on the same block level. If a block is specified in the request, the values will be fetched at it.
     * Otherwise, a first request will be done to the node to fetch the level of the head and all values will be fetched at this level.
     * If one of the keys does not exist in the big map, its value will be set to undefined.
     *
     * @param id Big Map ID
     * @param keys Array of keys to query (will be encoded properly according to the schema)
     * @param schema Big Map schema (can be determined using your contract type)
     * @param block optional block level to fetch the values from
     * @param batchSize optional batch size representing the number of requests to execute in parallel
     * @returns A MichelsonMap containing the keys queried in the big map and their value in a well-formatted JSON object format
     *
     */ getBigMapKeysByID(id_1, keys_1, schema_1, block_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(id, keys, schema, block, batchSize = 5) {
            const level = yield this.getBlockForRequest(keys, block);
            const bigMapValues = new (0, $c46b7dbea18e1f8c$export$485fc446a4c98bc8)();
            // Execute batch of promises in series
            let position = 0;
            let results = [];
            while(position < keys.length){
                const keysBatch = keys.slice(position, position + batchSize);
                const batch = keysBatch.map((keyToEncode)=>this.getBigMapValueOrUndefined(keyToEncode, id, schema, level));
                results = [
                    ...results,
                    ...yield Promise.all(batch)
                ];
                position += batchSize;
            }
            for(let i = 0; i < results.length; i++)bigMapValues.set(keys[i], results[i]);
            return bigMapValues;
        });
    }
    getBlockForRequest(keys, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return keys.length === 1 || typeof block !== 'undefined' ? block : yield this.context.readProvider.getBlockLevel('head');
        });
    }
    getBigMapValueOrUndefined(keyToEncode, id, schema, level) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield this.getBigMapKeyByID(id, keyToEncode, schema, level);
            } catch (ex) {
                if (ex instanceof (0, $6cc77aa71b64d012$export$d2f2761cbe9cebf2) && ex.status === (0, $6cc77aa71b64d012$export$bc3aa03eb4b395cf).NOT_FOUND) return;
                else throw ex;
            }
        });
    }
    /**
     *
     * @description Return a well formatted json object of a sapling state
     *
     * @param id Sapling state ID
     * @param block optional block level to fetch the value from
     *
     */ getSaplingDiffByID(id, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const saplingState = block ? yield this.context.readProvider.getSaplingDiffById({
                id: id.toString()
            }, block) : yield this.context.readProvider.getSaplingDiffById({
                id: id.toString()
            }, 'head');
            return saplingState;
        });
    }
    /**
     *
     * @description Originate a new contract according to the script in parameters. Will sign and inject an operation using the current context
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @warn You cannot specify storage and init at the same time (use init to pass the raw michelson representation of storage)
     *
     * @param OriginationOperation Originate operation parameter
     */ originate(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const estimate = yield this.estimate(params, this.estimator.originate.bind(this.estimator));
            const preparedOrigination = yield this.prepare.originate(Object.assign(Object.assign({}, params), estimate));
            const content = preparedOrigination.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).ORIGINATION);
            const forgedOrigination = yield this.forge(preparedOrigination);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(forgedOrigination);
            return new $2fea24c565181d86$export$ec1f5c67b17f835a(hash, content, forgedBytes, opResponse, context, this);
        });
    }
    /**
     *
     * @description Set the delegate for a contract. Will sign and inject an operation using the current context
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param SetDelegate operation parameter
     */ setDelegate(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.source);
            if (params.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            const delegateValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_a = params.delegate) !== null && _a !== void 0 ? _a : '');
            if (params.delegate && delegateValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.delegate, (0, $6ed3c564aba0f912$export$a2057601792df650)(delegateValidation));
            // Since babylon delegation source cannot smart contract
            if (/kt1/i.test(params.source)) throw new $2fea24c565181d86$export$ccd4de17604f1cb4(params.source);
            const publicKeyHash = yield this.signer.publicKeyHash();
            const sourceOrDefault = params.source || publicKeyHash;
            const estimate = yield this.estimate(params, this.estimator.setDelegate.bind(this.estimator));
            const preparedDelegation = yield this.prepare.delegation(Object.assign(Object.assign({}, params), estimate));
            const content = preparedDelegation.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION);
            const opBytes = yield this.forge(preparedDelegation);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$ce3dabbdbcbbc321(hash, content, sourceOrDefault, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Register the current address as delegate. Will sign and inject an operation using the current context
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param RegisterDelegate operation parameter
     */ registerDelegate(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const estimate = yield this.estimate(params, this.estimator.registerDelegate.bind(this.estimator));
            const source = yield this.signer.publicKeyHash();
            const prepared = yield this.prepare.registerDelegate(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).DELEGATION);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$ce3dabbdbcbbc321(hash, content, source, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Transfer tz from current address to a specific address. Will sign and inject an operation using the current context
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param Transfer operation parameter
     */ transfer(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const toValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.to);
            if (toValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.to, (0, $6ed3c564aba0f912$export$a2057601792df650)(toValidation));
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_a = params.source) !== null && _a !== void 0 ? _a : '');
            if (params.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            if (params.amount < 0) throw new (0, $580df0c6131ecaba$export$d8bf6d22cce8e288)(params.amount.toString());
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.transfer.bind(this.estimator));
            const source = params.source || publicKeyHash;
            const prepared = yield this.prepare.transaction(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$831ca37464f9fe3(hash, content, source, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Stake a given amount for the source address
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param Stake pseudo-operation parameter
     */ stake(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_a = params.source) !== null && _a !== void 0 ? _a : '');
            if (params.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            if (!params.to) params.to = params.source;
            if (params.to && params.to !== params.source) throw new (0, $580df0c6131ecaba$export$be6cb9338b7137e0)(params.to);
            if (params.amount < 0) throw new (0, $580df0c6131ecaba$export$d8bf6d22cce8e288)(params.amount.toString());
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.stake.bind(this.estimator));
            const source = params.source || publicKeyHash;
            const prepared = yield this.prepare.stake(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$831ca37464f9fe3(hash, content, source, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Unstake the given amount. If "everything" is given as amount, unstakes everything from the staking balance.
     * Unstaked tez remains frozen for a set amount of cycles (the slashing period) after the operation. Once this period is over,
     * the operation "finalize unstake" must be called for the funds to appear in the liquid balance.
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param Unstake pseudo-operation parameter
     */ unstake(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_a = params.source) !== null && _a !== void 0 ? _a : '');
            if (params.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            if (!params.to) params.to = params.source;
            if (params.to && params.to !== params.source) throw new (0, $580df0c6131ecaba$export$be6cb9338b7137e0)(params.to);
            if (params.amount < 0) throw new (0, $580df0c6131ecaba$export$d8bf6d22cce8e288)(params.amount.toString());
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.unstake.bind(this.estimator));
            const source = params.source || publicKeyHash;
            const prepared = yield this.prepare.unstake(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$831ca37464f9fe3(hash, content, source, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Transfer all the finalizable unstaked funds of the source to their liquid balance
     * @returns An operation handle with the result from the rpc node
     *
     * @param Finalize_unstake pseudo-operation parameter
     */ finalizeUnstake(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_a = params.source) !== null && _a !== void 0 ? _a : '');
            if (params.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            if (!params.to) params.to = params.source;
            if (params.to && params.to !== params.source) throw new (0, $580df0c6131ecaba$export$be6cb9338b7137e0)(params.to);
            if (!params.amount) params.amount = 0;
            if (params.amount !== undefined && params.amount > 0) throw new (0, $580df0c6131ecaba$export$1623a856d8b6cc2a)('Amount must be 0 to finalize unstake.');
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.finalizeUnstake.bind(this.estimator));
            const source = params.source || publicKeyHash;
            const prepared = yield this.prepare.finalizeUnstake(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSACTION);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$831ca37464f9fe3(hash, content, source, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Transfer Tickets to a smart contract address
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param TransferTicketParams operation parameter
     */ transferTicket(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const destinationValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)(params.destination);
            if (destinationValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.destination, (0, $6ed3c564aba0f912$export$a2057601792df650)(destinationValidation));
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_a = params.source) !== null && _a !== void 0 ? _a : '');
            if (params.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            const publicKeyHash = yield this.signer.publicKeyHash();
            const source = (_b = params.source) !== null && _b !== void 0 ? _b : publicKeyHash;
            const estimate = yield this.estimate(params, this.estimator.transferTicket.bind(this.estimator));
            const prepared = yield this.prepare.transferTicket(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).TRANSFER_TICKET);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$e2d2edc8d45e91bd(hash, content, source, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Reveal the current address. Will throw an error if the address is already revealed.
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param RevealParams operation parameter
     */ reveal(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimateReveal = yield this.estimator.reveal(params);
            if (estimateReveal) {
                const estimated = yield this.estimate(params, ()=>$2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
                        return estimateReveal;
                    }));
                const prepared = yield this.prepare.reveal(Object.assign(Object.assign({}, params), estimated));
                const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).REVEAL);
                const opBytes = yield this.forge(prepared);
                const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
                return new $2fea24c565181d86$export$14d3da7f07184894(hash, content, publicKeyHash, forgedBytes, opResponse, context);
            } else throw new $2fea24c565181d86$export$eb140f52edb72859(`The publicKeyHash '${publicKeyHash}' has already been revealed.`);
        });
    }
    /**
     *
     * @description Register a Micheline expression in a global table of constants. Will sign and inject an operation using the current context
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param params registerGlobalConstant operation parameter
     */ registerGlobalConstant(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.registerGlobalConstant.bind(this.estimator));
            const prepared = yield this.prepare.registerGlobalConstant(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).REGISTER_GLOBAL_CONSTANT);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$3b8dda899a5ab452(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Increase the paid storage of a smart contract
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param params increasePaidStorage operation parameter
     */ increasePaidStorage(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (params.amount < 0) throw new (0, $580df0c6131ecaba$export$d8bf6d22cce8e288)(params.amount.toString());
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.increasePaidStorage.bind(this.estimator));
            const prepared = yield this.prepare.increasePaidStorage(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).INCREASE_PAID_STORAGE);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$8d528f7d576e7bf3(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Transfers the spendable balance of the delegate to destination when consensus_key is the active consensus key of delegate
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param params drainDelegate operation parameter
     */ drainDelegate(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const prepared = yield this.prepare.drainDelegate(params);
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).DRAIN_DELEGATE);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$a70f4d895fdd289e(hash, content, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Submit a ballot vote to a specified proposal
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param BallotParams Ballot operation parameter
     */ ballot(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const publicKeyHash = yield this.signer.publicKeyHash();
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_a = params.source) !== null && _a !== void 0 ? _a : '');
            if (params.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            const source = (_b = params.source) !== null && _b !== void 0 ? _b : publicKeyHash;
            const prepared = yield this.prepare.ballot(Object.assign(Object.assign({}, params), {
                source: source
            }));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).BALLOT);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$7c85c5993418b9a9(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Submit or upvote a proposal during the Proposal period
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param ProposalsParams Proposals operation parameter
     */ proposals(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const publicKeyHash = yield this.signer.publicKeyHash();
            const sourceValidation = (0, $6ed3c564aba0f912$export$f78173835dcde49f)((_a = params.source) !== null && _a !== void 0 ? _a : '');
            if (params.source && sourceValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$66c44d927ffead98)(params.source, (0, $6ed3c564aba0f912$export$a2057601792df650)(sourceValidation));
            const source = (_b = params.source) !== null && _b !== void 0 ? _b : publicKeyHash;
            const prepared = yield this.prepare.proposals(Object.assign(Object.assign({}, params), {
                source: source
            }));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).PROPOSALS);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$f85d38729ebbe78f(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description Updates the consensus key of the baker to public_key starting from the current cycle plus PRESERVED_CYCLES + 1
     *
     * @returns An operation handle with the result from the rpc node
     *
     * @param UpdateConsensusKeyParams
     */ updateConsensusKey(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.updateConsensusKey.bind(this.estimator));
            const prepared = yield this.prepare.updateConsensusKey(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).UPDATE_CONSENSUS_KEY);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$fd8ddc29035a3b9d(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     * @description Adds messages to the rollup inbox that can be executed/claimed after it gets cemented
     * @param SmartRollupAddMessagesParams
     * @returns An operation handle with results from the RPC node
     */ smartRollupAddMessages(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.smartRollupAddMessages.bind(this.estimator));
            const prepared = yield this.prepare.smartRollupAddMessages(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ADD_MESSAGES);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$80c7f5b8306f2de6(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     * @description Creates a smart rollup originate operation
     * @param SmartRollupOriginateParams
     * @returns An operation handle with results from the RPC node
     */ smartRollupOriginate(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.smartRollupOriginate.bind(this.estimator));
            const prepared = yield this.prepare.smartRollupOriginate(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_ORIGINATE);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$export$392a36414e72aa5d(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     * @description Execute a message from a smart rollup's outbox of a cemented commitment
     * @param SmartRollupExecuteOutboxMessageParams
     * @returns An operation handle with results from the RPC node
     */ smartRollupExecuteOutboxMessage(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const publicKeyHash = yield this.signer.publicKeyHash();
            const estimate = yield this.estimate(params, this.estimator.smartRollupExecuteOutboxMessage.bind(this.estimator));
            const prepared = yield this.prepare.smartRollupExecuteOutboxMessage(Object.assign(Object.assign({}, params), estimate));
            const content = prepared.opOb.contents.find((op)=>op.kind === (0, $f93002942e85739a$export$b64a25b4a099ca08).SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE);
            const opBytes = yield this.forge(prepared);
            const { hash: hash, context: context, forgedBytes: forgedBytes, opResponse: opResponse } = yield this.signAndInject(opBytes);
            return new $2fea24c565181d86$var$SmartRollupExecuteOutboxMessageOperation(hash, content, publicKeyHash, forgedBytes, opResponse, context);
        });
    }
    /**
     *
     * @description A failing_noop operation that is guaranteed to fail.
     *
     * @returns A FailingNoopOperation object representing the signed failing_noop operation
     *
     * @param params failingNoop operation parameter
     */ failingNoop(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const op = {
                kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).FAILING_NOOP,
                arbitrary: params.arbitrary
            };
            const hash = yield this.context.readProvider.getBlockHash(params.basedOnBlock);
            const forged = yield this.context.forger.forge({
                branch: hash,
                contents: [
                    op
                ]
            });
            const { prefixSig: prefixSig } = yield this.signer.sign(forged, new Uint8Array([
                3
            ]));
            return {
                signature: prefixSig,
                bytes: forged,
                signedContent: {
                    branch: hash,
                    contents: [
                        {
                            kind: (0, $f93002942e85739a$export$b64a25b4a099ca08).FAILING_NOOP,
                            arbitrary: params.arbitrary
                        }
                    ]
                }
            };
        });
    }
    /**
     *
     * @description Create an smart contract abstraction for the address specified.
     *
     * @param address Smart contract address
     * @throws {@link InvalidContractAddressError}
     */ at(address_1) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(address, contractAbstractionComposer = (x)=>x) {
            const addressValidation = (0, $6ed3c564aba0f912$export$2ed905adbd9a56f2)(address);
            if (addressValidation !== (0, $6ed3c564aba0f912$export$f9bf9a3c544b4010).VALID) throw new (0, $580df0c6131ecaba$export$193774326795229b)(address, (0, $6ed3c564aba0f912$export$a2057601792df650)(addressValidation));
            const rpc = this.context.withExtensions().rpc;
            const readProvider = this.context.withExtensions().readProvider;
            const script = yield readProvider.getScript(address, 'head');
            const entrypoints = yield readProvider.getEntrypoints(address);
            const abs = new $2fea24c565181d86$export$25cde19dc6218700(address, script, this, this, entrypoints, rpc, readProvider);
            return contractAbstractionComposer(abs, this.context);
        });
    }
    /**
     *
     * @description Batch a group of operation together. Operations will be applied in the order in which they are added to the batch
     *
     * @returns A batch object from which we can add more operation or send a command to execute the batch
     *
     * @param params List of operation to batch together
     */ batch(params) {
        const batch = new $2fea24c565181d86$export$7a235871f213c08c(this.context, this.estimator);
        if (Array.isArray(params)) batch.with(params);
        return batch;
    }
}
class $2fea24c565181d86$export$9b8795d63420af7f {
    constructor(context){
        this.context = context;
    }
    getNextProto() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.context.proto) {
                const nextProto = yield this.context.readProvider.getNextProtocol('head');
                this.context.proto = nextProto;
            }
            return this.context.proto;
        });
    }
    parseScript(src) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const parser = new (0, $a98ce94f10ce3b87$export$7acfa6ed01010e37)({
                protocol: yield this.getNextProto()
            });
            return parser.parseScript(src);
        });
    }
    parseMichelineExpression(src) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const parser = new (0, $a98ce94f10ce3b87$export$7acfa6ed01010e37)({
                protocol: yield this.getNextProto()
            });
            return parser.parseMichelineExpression(src);
        });
    }
    parseJSON(src) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const parser = new (0, $a98ce94f10ce3b87$export$7acfa6ed01010e37)({
                protocol: yield this.getNextProto()
            });
            return parser.parseJSON(src);
        });
    }
    prepareCodeOrigination(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const parsedParams = params;
            parsedParams.code = yield this.formatCodeParam(params.code);
            if (params.init) parsedParams.init = yield this.formatInitParam(params.init);
            else if (params.storage) {
                const storageType = parsedParams.code.find((p)=>'prim' in p && p.prim === 'storage');
                if (!(storageType === null || storageType === void 0 ? void 0 : storageType.args)) throw new $2fea24c565181d86$export$6831bff83789e2ca('The storage section is missing from the script', params.code);
                const schema = new (0, $c46b7dbea18e1f8c$export$19342e026b58ebb7)(storageType.args[0]);
                const globalconstantsHashAndValue = yield this.findGlobalConstantsHashAndValue(schema);
                if (Object.keys(globalconstantsHashAndValue).length !== 0) {
                    // If there are global constants in the storage part of the contract code,
                    // they need to be locally expanded in order to encode the storage arguments
                    const p = new (0, $a98ce94f10ce3b87$export$7acfa6ed01010e37)({
                        expandGlobalConstant: globalconstantsHashAndValue
                    });
                    const storageTypeNoGlobalConst = p.parseJSON(storageType.args[0]);
                    const schemaNoGlobalConst = new (0, $c46b7dbea18e1f8c$export$19342e026b58ebb7)(storageTypeNoGlobalConst);
                    parsedParams.init = schemaNoGlobalConst.Encode(params.storage);
                } else parsedParams.init = schema.Encode(params.storage);
                delete parsedParams.storage;
            }
            return parsedParams;
        });
    }
    formatCodeParam(code) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            let parsedCode;
            if (typeof code === 'string') {
                const c = yield this.parseScript(code);
                if (c === null) throw new $2fea24c565181d86$export$6831bff83789e2ca('Unable to parse', code);
                parsedCode = c;
            } else {
                const c = yield this.parseJSON(code);
                const order = [
                    'parameter',
                    'storage',
                    'code'
                ];
                // Ensure correct ordering for RPC
                parsedCode = c.sort((a, b)=>order.indexOf(a.prim) - order.indexOf(b.prim));
            }
            return parsedCode;
        });
    }
    formatInitParam(init) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            let parsedInit;
            if (typeof init === 'string') {
                const c = yield this.parseMichelineExpression(init);
                if (c === null) throw new $2fea24c565181d86$export$12aaf24e6220866b('Invalid init parameter', init);
                parsedInit = c;
            } else parsedInit = yield this.parseJSON(init);
            return parsedInit;
        });
    }
    findGlobalConstantsHashAndValue(schema) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const globalConstantTokens = schema.findToken('constant');
            const globalConstantsHashAndValue = {};
            if (globalConstantTokens.length !== 0) for (const token of globalConstantTokens){
                const tokenArgs = token.tokenVal.args;
                if (tokenArgs) {
                    const expression = tokenArgs[0];
                    if (expression.string) {
                        const hash = expression.string;
                        const michelineValue = yield this.context.globalConstantsProvider.getGlobalConstantByHash(hash);
                        Object.assign(globalConstantsHashAndValue, {
                            [hash]: michelineValue
                        });
                    }
                }
            }
            return globalConstantsHashAndValue;
        });
    }
}
class $2fea24c565181d86$export$8307dfe42d1d942a {
    constructor(context){
        this.context = context;
    }
    packData(data) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.context.rpc.packData(data);
        });
    }
}
/**
 *  @category Error
 *  @description Error that indicates that a global constant does not exist
 */ class $2fea24c565181d86$export$e37bdb7f2d71b099 extends (0, $580df0c6131ecaba$export$e5619b407b1c8b0a) {
    constructor(hash){
        super();
        this.hash = hash;
        this.name = 'GlobalConstantNotFound';
        this.message = `Please load the value associated with the constant ${hash} using the loadGlobalConstant method of the DefaultGlobalConstantsProvider.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates the global constant provider not being configured under TezosToolkit
 */ class $2fea24c565181d86$export$d5855e69e0afe7f9 extends (0, $580df0c6131ecaba$export$32f4d70b2fb302b1) {
    constructor(){
        super();
        this.name = 'UnconfiguredGlobalConstantsProviderError';
        this.message = 'No global constants provider has been configured. Please configure one by calling setGlobalConstantsProvider({globalConstantsProvider}) on your TezosToolkit instance.';
    }
}
class $2fea24c565181d86$var$NoopGlobalConstantsProvider {
    getGlobalConstantByHash(_hash) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            throw new $2fea24c565181d86$export$d5855e69e0afe7f9();
        });
    }
}
/**
 * @description Converts calls from TzReadProvider into calls to the wrapped RpcClient in a format it can understand.
 */ class $2fea24c565181d86$export$1c914715e594734e {
    constructor(rpc){
        this.rpc = rpc;
    }
    /**
     * @description The spendable balance of a contract (in mutez), also known as liquid balance. Corresponds to tez owned by the contract that are neither staked, nor in unstaked requests, nor in frozen bonds. Identical to the 'spendable' RPC.
     * @param address address from which we want to retrieve the spendable balance
     * @param block from which we want to retrieve the balance
     * @returns the balance in mutez
     */ getBalance(address, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getBalance(address, {
                block: String(block)
            });
        });
    }
    /**
     * @description The spendable balance of a contract (in mutez), also known as liquid balance. Corresponds to tez owned by the contract that are neither staked, nor in unstaked requests, nor in frozen bonds. Identical to the 'balance' RPC.
     * @param address address from which we want to retrieve the spendable balance
     * @param block from which we want to retrieve the balance
     * @returns the balance in mutez
     */ getSpendable(address, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getSpendable(address, {
                block: String(block)
            });
        });
    }
    /**
     * @description Access the delegate of a contract, if any.
     * @param address contract address from which we want to retrieve the delegate (baker)
     * @param block from which we want to retrieve the delegate
     * @returns the public key hash of the delegate or null if no delegate
     */ getDelegate(address, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getDelegate(address, {
                block: String(block)
            });
        });
    }
    /**
     * @description Access the next protocol hash
     * @param block from which we want to retrieve the next protocol hash
     */ getNextProtocol(block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const protocols = yield this.rpc.getProtocols({
                block: String(block)
            });
            return protocols.next_protocol;
        });
    }
    /**
     * @description Access protocol constants used in Taquito
     * @param block from which we want to retrieve the constants
     */ getProtocolConstants(block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { time_between_blocks: time_between_blocks, minimal_block_delay: minimal_block_delay, hard_gas_limit_per_operation: hard_gas_limit_per_operation, hard_gas_limit_per_block: hard_gas_limit_per_block, hard_storage_limit_per_operation: hard_storage_limit_per_operation, cost_per_byte: cost_per_byte, smart_rollup_origination_size: smart_rollup_origination_size } = yield this.rpc.getConstants({
                block: String(block)
            });
            return {
                time_between_blocks: time_between_blocks,
                minimal_block_delay: minimal_block_delay,
                hard_gas_limit_per_operation: hard_gas_limit_per_operation,
                hard_gas_limit_per_block: hard_gas_limit_per_block,
                hard_storage_limit_per_operation: hard_storage_limit_per_operation,
                cost_per_byte: cost_per_byte,
                smart_rollup_origination_size: smart_rollup_origination_size
            };
        });
    }
    /**
     * @description Access the script (code and storage) of a smart contract
     * @param contract contract address from which we want to retrieve the script
     * @param block from which we want to retrieve the storage value
     * @returns Note: The code must be in the JSON format and not contain global constant
     */ getScript(contract, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { script: script } = yield this.rpc.getContract(contract, {
                block: String(block)
            });
            return script;
        });
    }
    /**
     * @description Access the storage value of a contract
     * @param contract contract address from which we want to retrieve the storage
     * @param block from which we want to retrieve the storage value
     */ getStorage(contract, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getStorage(contract, {
                block: String(block)
            });
        });
    }
    /**
     * @description Access the block hash
     */ getBlockHash(block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { hash: hash } = yield this.rpc.getBlockHeader({
                block: String(block)
            });
            return hash;
        });
    }
    /**
     * @description Access the block level
     */ getBlockLevel(block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { level: level } = yield this.rpc.getBlockHeader({
                block: String(block)
            });
            return level;
        });
    }
    /**
     * @description Access the counter of an address
     * @param pkh from which we want to retrieve the counter
     * @param block from which we want to retrieve the counter
     */ getCounter(pkh, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { counter: counter } = yield this.rpc.getContract(pkh, {
                block: String(block)
            });
            return counter || '0';
        });
    }
    /**
     * @description Access the timestamp of a block
     * @param block from which we want to retrieve the timestamp
     * @returns date ISO format zero UTC offset ("2022-01-19T22:37:07Z")
     */ getBlockTimestamp(block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { timestamp: timestamp } = yield this.rpc.getBlockHeader({
                block: String(block)
            });
            return timestamp;
        });
    }
    /**
     * @description Access the value associated with a key in a big map.
     * @param bigMapQuery Big Map ID and Expression hash to query (A b58check encoded Blake2b hash of the expression)
     * @param block from which we want to retrieve the big map value
     */ getBigMapValue(bigMapQuery, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getBigMapExpr(bigMapQuery.id, bigMapQuery.expr, {
                block: String(block)
            });
        });
    }
    /**
     * @description Access the value associated with a sapling state ID.
     * @param id Sapling state ID
     * @param block from which we want to retrieve the sapling state
     */ getSaplingDiffById(saplingStateQuery, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getSaplingDiffById(saplingStateQuery.id, {
                block: String(block)
            });
        });
    }
    /**
     * @description Access the sapling state of a smart contract.
     * @param contractAddress The address of the smart contract
     * @param block The block you want to retrieve the sapling state from
     */ getSaplingDiffByContract(contractAddress, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getSaplingDiffByContract(contractAddress, {
                block: String(block)
            });
        });
    }
    /**
     * @description Return the list of entrypoints of the contract
     * @param contract address of the contract we want to get the entrypoints of
     */ getEntrypoints(contract) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getEntrypoints(contract);
        });
    }
    /**
     * @description Access the chain id
     */ getChainId() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getChainId();
        });
    }
    /**
     * @description Indicate if an account is revealed
     * @param publicKeyHash of the account
     * @param block from which we want to know if the account is revealed
     */ isAccountRevealed(publicKeyHash, block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const manager = yield this.rpc.getManagerKey(publicKeyHash, {
                block: String(block)
            });
            const haveManager = manager && typeof manager === 'object' ? !!manager.key : !!manager;
            return haveManager;
        });
    }
    /**
     * @description Return all the information about a block
     * @param block from which we want to retrieve the information
     */ getBlock(block) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return this.rpc.getBlock({
                block: String(block)
            });
        });
    }
    /**
     * @description Return a list of the ancestors of the given block which, if referred to as the branch in an operation header, are recent enough for that operation to be included in the current block.
     * @param block from which we want to retrieve the information
     */ getLiveBlocks(block) {
        return this.rpc.getLiveBlocks({
            block: String(block)
        });
    }
    /**
     * @description Returns the cycle at which the launch of the Adaptive Issuance feature is set to happen. A result of null means that the feature is not yet set to launch.
     * @param block from which we want to retrieve the information
     */ getAdaptiveIssuanceLaunchCycle(block) {
        return this.rpc.getAdaptiveIssuanceLaunchCycle({
            block: String(block)
        });
    }
}
/**
 *  @category Error
 *  @description Error that indicates an unsupported event being passed or used
 */ class $2fea24c565181d86$var$UnsupportedEventError extends (0, $580df0c6131ecaba$export$9d3f3bc8b6d48950) {
    constructor(type){
        super();
        this.type = type;
        this.name = 'UnsupportedEventError';
        this.message = `Unsupported event type "${type}" expecting one of the "data", "error", or "close".`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid filter expression being passed or used
 */ class $2fea24c565181d86$var$InvalidFilterExpressionError extends (0, $580df0c6131ecaba$export$9d3f3bc8b6d48950) {
    constructor(invalidExpression){
        super();
        this.invalidExpression = invalidExpression;
        this.name = 'InvalidFilterExpressionError';
        this.message = `Invalid filter expression expecting the object to contain either and/or property`;
    }
}
const $2fea24c565181d86$var$opHashFilter = (op, filter)=>op.hash === filter.opHash;
const $2fea24c565181d86$var$sourceFilter = (x, filter)=>{
    switch(x.kind){
        case 'attestation':
            return 'metadata' in x && x.metadata.delegate === filter.source;
        case 'activate_account':
            return 'metadata' in x && x.pkh === filter.source;
        default:
            return 'source' in x && x.source === filter.source;
    }
};
const $2fea24c565181d86$var$kindFilter = (x, filter)=>'kind' in x && x.kind === filter.kind;
const $2fea24c565181d86$var$destinationFilter = (x, filter)=>{
    switch(x.kind){
        case 'delegation':
            return x.delegate === filter.destination;
        case 'origination':
            if ('metadata' in x && 'operation_result' in x.metadata && 'originated_contracts' in x.metadata.operation_result && Array.isArray(x.metadata.operation_result.originated_contracts)) return x.metadata.operation_result.originated_contracts.some((contract)=>contract === filter.destination);
            break;
        case 'transaction':
            return x.destination === filter.destination;
        default:
            return false;
    }
};
const $2fea24c565181d86$var$eventFilter = (result, address, tag, excludeFailedOperations)=>{
    if (result.kind !== 'event') return false;
    if (tag && result.tag !== tag) return false;
    if (address && result.source !== address) return false;
    if (excludeFailedOperations && result.result.status !== 'applied') return false;
    return true;
};
const $2fea24c565181d86$var$evaluateOpFilter = (op, filter)=>{
    if ('opHash' in filter) return $2fea24c565181d86$var$opHashFilter(op, filter);
    else if ('source' in filter) return $2fea24c565181d86$var$sourceFilter(op, filter);
    else if ('kind' in filter) return $2fea24c565181d86$var$kindFilter(op, filter);
    else if ('destination' in filter) return $2fea24c565181d86$var$destinationFilter(op, filter);
    return false;
};
const $2fea24c565181d86$var$evaluateExpression = (op, exp)=>{
    if (Array.isArray(exp.and)) return exp.and.every((x)=>$2fea24c565181d86$var$evaluateFilter(op, x));
    else if (Array.isArray(exp.or)) return exp.or.some((x)=>$2fea24c565181d86$var$evaluateFilter(op, x));
    else throw new $2fea24c565181d86$var$InvalidFilterExpressionError(exp);
};
const $2fea24c565181d86$var$evaluateFilter = (op, filter)=>{
    const filters = [];
    if (!Array.isArray(filter)) filters.push(filter);
    else filters.push(...filter);
    return filters.every((filterOrExp)=>{
        if ('and' in filterOrExp || 'or' in filterOrExp) return $2fea24c565181d86$var$evaluateExpression(op, filterOrExp);
        else return $2fea24c565181d86$var$evaluateOpFilter(op, filterOrExp);
    });
};
/* eslint-disable no-dupe-class-members */ class $2fea24c565181d86$export$6e8e62b94261634 {
    constructor(obs, shouldRetry = false, operatorFunction = (0, $bd9ef8e0f52c62f6$export$9369b12211e1fce4)()){
        this.shouldRetry = shouldRetry;
        this.operatorFunction = operatorFunction;
        this.errorListeners = [];
        this.messageListeners = [];
        this.closeListeners = [];
        this.completed$ = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
        obs.pipe((0, $e890d5c5b4491f33$export$ac8dfd3a7ad06e80)(this.completed$), (0, $3e7edc5b22925f26$export$3f23594af5f37336)((data)=>{
            this.call(this.messageListeners, data);
        }, (error)=>{
            this.call(this.errorListeners, error);
        }, ()=>{
            this.call(this.closeListeners);
        }), this.shouldRetry ? operatorFunction : (0, $3e7edc5b22925f26$export$3f23594af5f37336)(), (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>(0, $29707ec27f94d999$export$96c94437c95d7862))).subscribe();
    }
    call(listeners, value) {
        for (const l of listeners)try {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            l(value);
        } catch (ex) {
            console.error(ex);
        }
    }
    remove(listeners, value) {
        const idx = listeners.indexOf(value);
        if (idx !== -1) listeners.splice(idx, 1);
    }
    on(type, cb) {
        switch(type){
            case 'data':
                this.messageListeners.push(cb);
                break;
            case 'error':
                this.errorListeners.push(cb);
                break;
            case 'close':
                this.closeListeners.push(cb);
                break;
            default:
                throw new $2fea24c565181d86$var$UnsupportedEventError(type);
        }
    }
    off(type, cb) {
        switch(type){
            case 'data':
                this.remove(this.messageListeners, cb);
                break;
            case 'error':
                this.remove(this.errorListeners, cb);
                break;
            case 'close':
                this.remove(this.closeListeners, cb);
                break;
            default:
                throw new $2fea24c565181d86$var$UnsupportedEventError(type);
        }
    }
    close() {
        this.completed$.next();
    }
}
const $2fea24c565181d86$var$defaultConfigStreamer = {
    shouldObservableSubscriptionRetry: false,
    observableSubscriptionRetryFunction: (0, $bd9ef8e0f52c62f6$export$9369b12211e1fce4)()
};
const $2fea24c565181d86$var$getLastBlock = (context)=>{
    return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(context.rpc.getBlock()).pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)());
};
const $2fea24c565181d86$var$applyFilter = (filter)=>(0, $9ee54e147202c320$export$c28c8388be0ab31a)((block)=>{
        return new (0, $4f562137a990678a$export$77cea355fa80b5f4)((sub)=>{
            for (const ops of block.operations)for (const op of ops){
                for (const content of op.contents)if ($2fea24c565181d86$var$evaluateFilter(Object.assign({
                    hash: op.hash
                }, content), filter)) sub.next(Object.assign({
                    hash: op.hash
                }, content));
            }
            sub.complete();
        });
    });
const $2fea24c565181d86$var$applyEventFilter = (filter)=>(0, $9ee54e147202c320$export$c28c8388be0ab31a)((block)=>{
        return new (0, $4f562137a990678a$export$77cea355fa80b5f4)((sub)=>{
            for (const ops of block.operations){
                for (const op of ops)for (const content of op.contents){
                    const tx = content;
                    const internalOpResults = tx.metadata.internal_operation_results;
                    if (internalOpResults) {
                        for (const event of internalOpResults)if ($2fea24c565181d86$var$eventFilter(event, filter === null || filter === void 0 ? void 0 : filter.address, filter === null || filter === void 0 ? void 0 : filter.tag, filter === null || filter === void 0 ? void 0 : filter.excludeFailedOperations)) sub.next(Object.assign({
                            opHash: op.hash,
                            blockHash: block.hash,
                            level: block.header.level
                        }, event));
                    }
                }
            }
            sub.complete();
        });
    });
class $2fea24c565181d86$export$fcbb611d52e45815 {
    constructor(context, config = {}){
        this.context = context;
        this._config$ = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(Object.assign(Object.assign({}, $2fea24c565181d86$var$defaultConfigStreamer), config));
        this.timer$ = this._config$.pipe((0, $4be1a9d761a9d3e3$export$c44985b87d605eff)('pollingIntervalMilliseconds'), (0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((pollingIntervalMilliseconds)=>{
            if (!pollingIntervalMilliseconds) return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(this.getConfirmationPollingInterval()).pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((interval)=>{
                return (0, $bce9e90ba9895d75$export$9dc4ecf953986f04)(0, interval);
            }));
            else return (0, $bce9e90ba9895d75$export$9dc4ecf953986f04)(0, pollingIntervalMilliseconds);
        }));
        this.newBlock$ = this.timer$.pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)(()=>$2fea24c565181d86$var$getLastBlock(this.context)), (0, $5b7702bd13db251d$export$571da16e28367bde)('hash'), (0, $dc522c7fdf273a70$export$89b472e03be495df)(), (0, $0a82afceb3f717e3$export$18d0766d894cba0c)());
    }
    get config() {
        return this._config$.getValue();
    }
    getConfirmationPollingInterval() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.config.pollingIntervalMilliseconds) {
                const defaultIntervalTestnetsMainnet = 5000;
                const defaultIntervalSandbox = 1000;
                try {
                    const constants = yield this.context.readProvider.getProtocolConstants('head');
                    const blockTime = constants.minimal_block_delay ? constants.minimal_block_delay.multipliedBy(1000) : new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(defaultIntervalTestnetsMainnet);
                    const confirmationPollingInterval = blockTime.dividedBy(3);
                    this.config.pollingIntervalMilliseconds = confirmationPollingInterval.toNumber() === 0 ? defaultIntervalSandbox : confirmationPollingInterval.toNumber();
                } catch (exception) {
                    return defaultIntervalTestnetsMainnet;
                }
            }
            return this.config.pollingIntervalMilliseconds;
        });
    }
    subscribeBlock(_filter) {
        return new $2fea24c565181d86$export$6e8e62b94261634(this.newBlock$, this.config.shouldObservableSubscriptionRetry, this.config.observableSubscriptionRetryFunction);
    }
    subscribe(_filter) {
        return new $2fea24c565181d86$export$6e8e62b94261634(this.newBlock$.pipe((0, $4be1a9d761a9d3e3$export$c44985b87d605eff)('hash')), this.config.shouldObservableSubscriptionRetry, this.config.observableSubscriptionRetryFunction);
    }
    subscribeOperation(filter) {
        return new $2fea24c565181d86$export$6e8e62b94261634(this.newBlock$.pipe($2fea24c565181d86$var$applyFilter(filter)), this.config.shouldObservableSubscriptionRetry, this.config.observableSubscriptionRetryFunction);
    }
    subscribeEvent(eventFilter) {
        return new $2fea24c565181d86$export$6e8e62b94261634(this.newBlock$.pipe($2fea24c565181d86$var$applyEventFilter(eventFilter)), this.config.shouldObservableSubscriptionRetry, this.config.observableSubscriptionRetryFunction);
    }
}
class $2fea24c565181d86$export$4839b713e89da7ba {
    constructor(context){
        this.context = context;
    }
    getNextProto() {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.context.proto) {
                const nextProto = yield this.context.readProvider.getNextProtocol('head');
                this.context.proto = nextProto;
            }
            return this.context.proto;
        });
    }
    forge(_a) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*({ branch: branch, contents: contents }) {
            const forger = new (0, $02a40dc8333f1de2$export$99b12ddbeed7bd69)((yield this.getNextProto()));
            return forger.forge({
                branch: branch,
                contents: contents
            });
        });
    }
}
const $2fea24c565181d86$export$a85a981d7f4618bf = {
    defaultConfirmationCount: 1,
    confirmationPollingTimeoutSecond: 180
};
/**
 * @description Encapsulate common service used throughout different part of the library
 */ class $2fea24c565181d86$export$841858b892ce1f4c {
    constructor(_rpc, _signer = new $2fea24c565181d86$var$NoopSigner(), _proto, _config = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(Object.assign({}, $2fea24c565181d86$export$a85a981d7f4618bf)), forger, injector, packer, wallet, parser, globalConstantsProvider, readProvider, stream){
        this._rpc = _rpc;
        this._signer = _signer;
        this._proto = _proto;
        this._config = _config;
        this.providerDecorator = [];
        this.tz = new $2fea24c565181d86$var$RpcTzProvider(this);
        this.estimate = new $2fea24c565181d86$export$a0b53ef5867b3b16(this);
        this.contract = new $2fea24c565181d86$var$RpcContractProvider(this, this.estimate);
        this.prepare = new $2fea24c565181d86$export$c3ce3aa140a1bd8b(this);
        this.batch = new $2fea24c565181d86$var$RPCBatchProvider(this, this.estimate);
        this.wallet = new $2fea24c565181d86$export$bcca3ea514774656(this);
        /**
         * @description Applies the decorators on a cloned instance of the context and returned this cloned instance.
         * The decorators are functions that inject logic into the context.
         * They are provided by the extensions set on the TezosToolkit by calling the registerProviderDecorator method.
         */ this.withExtensions = ()=>{
            let clonedContext = this.clone();
            this.providerDecorator.forEach((decorator)=>{
                clonedContext = decorator(clonedContext);
            });
            return clonedContext;
        };
        if (typeof this._rpc === 'string') this._rpcClient = new (0, $f93002942e85739a$export$60aeb6b70d862cfd)(this._rpc);
        else this._rpcClient = this._rpc;
        this._forger = forger ? forger : new $2fea24c565181d86$export$4839b713e89da7ba(this);
        this._injector = injector ? injector : new $2fea24c565181d86$export$e81caaa38ad97a2(this);
        this.operationFactory = new $2fea24c565181d86$var$OperationFactory(this);
        this._walletProvider = wallet ? wallet : new $2fea24c565181d86$export$7e71cfc210e8a8fd(this);
        this._parser = parser ? parser : new $2fea24c565181d86$export$9b8795d63420af7f(this);
        this._packer = packer ? packer : new $2fea24c565181d86$export$8307dfe42d1d942a(this);
        this._globalConstantsProvider = globalConstantsProvider ? globalConstantsProvider : new $2fea24c565181d86$var$NoopGlobalConstantsProvider();
        this._readProvider = readProvider ? readProvider : new $2fea24c565181d86$export$1c914715e594734e(this._rpcClient);
        this._stream = stream ? stream : new $2fea24c565181d86$export$fcbb611d52e45815(this);
    }
    get config() {
        return this._config.getValue();
    }
    set config(value) {
        this._config.next(Object.assign({}, value));
    }
    setPartialConfig(value) {
        this._config.next(Object.assign(Object.assign({}, this._config.getValue()), value));
    }
    get rpc() {
        return this._rpcClient;
    }
    set rpc(value) {
        this._rpcClient = value;
    }
    get injector() {
        return this._injector;
    }
    set injector(value) {
        this._injector = value;
    }
    get forger() {
        return this._forger;
    }
    set forger(value) {
        this._forger = value;
    }
    get signer() {
        return this._signer;
    }
    set signer(value) {
        this._signer = value;
    }
    get walletProvider() {
        return this._walletProvider;
    }
    set walletProvider(value) {
        this._walletProvider = value;
    }
    set proto(value) {
        this._proto = value;
    }
    get proto() {
        return this._proto;
    }
    get parser() {
        return this._parser;
    }
    set parser(value) {
        this._parser = value;
    }
    get packer() {
        return this._packer;
    }
    set packer(value) {
        this._packer = value;
    }
    get globalConstantsProvider() {
        return this._globalConstantsProvider;
    }
    set globalConstantsProvider(value) {
        this._globalConstantsProvider = value;
    }
    get readProvider() {
        return this._readProvider;
    }
    set readProvider(value) {
        this._readProvider = value;
    }
    get stream() {
        return this._stream;
    }
    set stream(value) {
        this._stream = value;
    }
    isAnyProtocolActive() {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*(protocol = []) {
            if (this._proto) return protocol.includes(this._proto);
            else {
                const next_protocol = yield this.readProvider.getNextProtocol('head');
                return protocol.includes(next_protocol);
            }
        });
    }
    isAnySignerConfigured() {
        return !(this.signer instanceof $2fea24c565181d86$var$NoopSigner);
    }
    /**
     * @description Create a copy of the current context. Useful when you have long running operation and you do not want a context change to affect the operation
     */ clone() {
        return new $2fea24c565181d86$export$841858b892ce1f4c(this.rpc, this.signer, this.proto, this._config, this.forger, this._injector, this.packer, this._walletProvider, this._parser, this._globalConstantsProvider, this._readProvider, this._stream);
    }
    /**
     * @description Allows extensions set on the TezosToolkit to inject logic into the context
     */ registerProviderDecorator(fx) {
        this.providerDecorator.push(fx);
    }
}
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $2fea24c565181d86$var$VERSION = {
    "commitHash": "6a2c52b9e48b299dfc856149c1fa3388e77180ad",
    "version": "22.0.0"
};
/**
 *  @category Error
 *  @description Error that indicates CompositeForger.forge() results doesn't match each other
 */ class $2fea24c565181d86$var$ForgingMismatchError extends (0, $580df0c6131ecaba$export$e5619b407b1c8b0a) {
    constructor(results){
        super();
        this.results = results;
        this.name = 'ForgingMismatchError';
        this.message = `Forging mismatch error`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates no forger has been configured for CompositeForger
 */ class $2fea24c565181d86$var$UnspecifiedForgerError extends (0, $580df0c6131ecaba$export$32f4d70b2fb302b1) {
    constructor(){
        super();
        this.name = 'UnspecifiedForgerError';
        this.message = 'No forger has been configured. Please configure new CompositeForger([rpcForger, localForger]) with your TezosToolkit instance.';
    }
}
class $2fea24c565181d86$export$b97726c11624d323 {
    constructor(forgers){
        this.forgers = forgers;
        if (forgers.length === 0) throw new $2fea24c565181d86$var$UnspecifiedForgerError();
    }
    forge(_a) {
        return $2fea24c565181d86$var$__awaiter(this, arguments, void 0, function*({ branch: branch, contents: contents }) {
            const results = yield Promise.all(this.forgers.map((forger)=>{
                return forger.forge({
                    branch: branch,
                    contents: contents
                });
            }));
            if (results.length === 0) throw new $2fea24c565181d86$var$UnspecifiedForgerError();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            let lastResult = results.pop(); // Assumed to be more than one since we
            while(results.length){
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const currentResult = results.pop();
                if (currentResult !== lastResult) throw new $2fea24c565181d86$var$ForgingMismatchError([
                    lastResult,
                    currentResult
                ]);
                lastResult = currentResult;
            }
            return lastResult;
        });
    }
}
class $2fea24c565181d86$export$376487449fdf3d19 {
    constructor(context){
        this.context = context;
    }
    forge({ branch: branch, contents: contents }) {
        return this.context.rpc.forgeOperations({
            branch: branch,
            contents: contents
        });
    }
}
class $2fea24c565181d86$export$5a9951b6b3403c22 {
    prepareCodeOrigination(params) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            return params;
        });
    }
}
class $2fea24c565181d86$export$672bcfa981578382 {
    packData(data) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const { bytes: bytes } = (0, $a98ce94f10ce3b87$export$ec5c026f9926015c)(data.data, data.type);
            return {
                packed: bytes
            };
        });
    }
}
class $2fea24c565181d86$export$5a51e32d682f4b88 {
    constructor(){
        this._globalConstantsLibrary = {};
    }
    /**
     *
     * @description Allows to load global constant hashes and their corresponding Michelson JSON values
     */ loadGlobalConstant(globalConstant) {
        for(const hash in globalConstant)Object.assign(this._globalConstantsLibrary, {
            [hash]: globalConstant[hash]
        });
    }
    /**
     *
     * @description Retrieve the Michelson value of a global constant based on its hash
     *
     * @param hash a string representing the global constant hash
     * @returns Expr, the JSON Michelson value
     */ getGlobalConstantByHash(hash) {
        return $2fea24c565181d86$var$__awaiter(this, void 0, void 0, function*() {
            const value = this._globalConstantsLibrary[hash];
            if (!value) throw new $2fea24c565181d86$export$e37bdb7f2d71b099(hash);
            return value;
        });
    }
}
/**
 * @packageDocumentation
 * @module @taquito/taquito
 */ /**
 * @description Facade class that surfaces all of the libraries capability and allow it's configuration
 *
 * @param _rpc The RPC server to use
 */ class $2fea24c565181d86$export$7e3881046cc8cfeb {
    constructor(_rpc){
        this._rpc = _rpc;
        this._options = {};
        this.format = (0, $6ed3c564aba0f912$export$d9468344d3651243);
        if (typeof this._rpc === 'string') this._rpcClient = new (0, $f93002942e85739a$export$60aeb6b70d862cfd)(this._rpc);
        else this._rpcClient = this._rpc;
        this._context = new $2fea24c565181d86$export$841858b892ce1f4c(_rpc);
        this._wallet = new $2fea24c565181d86$export$bcca3ea514774656(this._context);
        this.setProvider({
            rpc: this._rpcClient
        });
        this.batch = this._context.batch.batch.bind(this._context.batch);
    }
    /**
     * @description Sets configuration on the Tezos Taquito instance. Allows user to choose which signer, rpc client, rpc url, forger and so forth
     *
     * @param options rpc url or rpcClient to use to interact with the Tezos network
     *
     * @example Tezos.setProvider({rpc: 'https://mainnet.tezos.ecadinfra.com/', signer: new InMemorySigner.fromSecretKey(“edsk...”)})
     * @example Tezos.setProvider({ config: { confirmationPollingTimeoutSecond: 300 }})
     *
     */ setProvider({ rpc: rpc, stream: stream, signer: signer, protocol: protocol, config: config, forger: forger, wallet: wallet, packer: packer, globalConstantsProvider: globalConstantsProvider, readProvider: readProvider, parserProvider: parserProvider, injectorProvider: injectorProvider }) {
        this.setRpcProvider(rpc);
        this.setStreamProvider(stream);
        this.setSignerProvider(signer);
        this.setForgerProvider(forger);
        this.setWalletProvider(wallet);
        this.setPackerProvider(packer);
        this.setGlobalConstantsProvider(globalConstantsProvider);
        this.setReadProvider(readProvider);
        this.setParserProvider(parserProvider);
        this.setInjectorProvider(injectorProvider);
        this._context.proto = protocol;
        if (config) this._context.setPartialConfig(config);
    }
    /**
     * @description Sets signer provider on the Tezos Taquito instance.
     *
     * @param options signer to use to interact with the Tezos network
     *
     * @example Tezos.setSignerProvider(new InMemorySigner.fromSecretKey('edsk...'))
     *
     */ setSignerProvider(signer) {
        if (!this._options.signer && typeof signer === 'undefined') {
            this._context.signer = new $2fea24c565181d86$var$NoopSigner();
            this._options.signer = signer;
        } else if (typeof signer !== 'undefined') {
            this._context.signer = signer;
            this._options.signer = signer;
        }
    }
    /**
     * @description Sets rpc provider on the Tezos Taquito instance
     *
     * @param options rpc url or rpcClient to use to interact with the Tezos network
     *
     * @example Tezos.setRpcProvider('https://mainnet.tezos.ecadinfra.com/')
     *
     */ setRpcProvider(rpc) {
        if (typeof rpc === 'string') this._rpcClient = new (0, $f93002942e85739a$export$60aeb6b70d862cfd)(rpc);
        else if (rpc === undefined) ;
        else this._rpcClient = rpc;
        this._options.rpc = this._rpcClient;
        this._context.rpc = this._rpcClient;
    }
    /**
     * @description Sets forger provider on the Tezos Taquito instance
     * The `LocalForger` from `@taquito/local-forging` is set by default.
     *
     * @param options forger to use to interact with the Tezos network
     *
     * @example Tezos.setForgerProvider(this.getFactory(RpcForger)())
     *
     */ setForgerProvider(forger) {
        if (typeof forger !== 'undefined') {
            this._options.forger = forger;
            this._context.forger = forger;
        } else if (this._options.forger === undefined) {
            const f = this.getFactory($2fea24c565181d86$export$4839b713e89da7ba)();
            this._options.forger = f;
            this._context.forger = f;
        }
    }
    /**
     * @description Sets stream provider on the Tezos Taquito instance
     *
     * @param options stream to use to interact with the Tezos network
     *
     * @example Tezos.setStreamProvider(...)
     *
     */ setStreamProvider(stream) {
        if (typeof stream === 'string') {
            const s = new $2fea24c565181d86$export$fcbb611d52e45815(new $2fea24c565181d86$export$841858b892ce1f4c(new (0, $f93002942e85739a$export$60aeb6b70d862cfd)(stream)));
            this._options.stream = s;
            this._context.stream = s;
        } else if (typeof stream !== 'undefined') {
            this._options.stream = stream;
            this._context.stream = stream;
        } else if (this._options.stream === undefined) {
            const s = this.getFactory($2fea24c565181d86$export$fcbb611d52e45815)();
            this._options.stream = s;
            this._context.stream = s;
        }
    }
    /**
     * @description Sets wallet provider on the Tezos Taquito instance
     *
     * @param options wallet to use to interact with the Tezos network
     *
     * @example Tezos.setWalletProvider(...)
     *
     */ setWalletProvider(wallet) {
        if (!this._options.wallet && typeof wallet === 'undefined') {
            const w = this.getFactory($2fea24c565181d86$export$7e71cfc210e8a8fd)();
            this._options.wallet = w;
            this._context.walletProvider = w;
        } else if (typeof wallet !== 'undefined') {
            this._options.wallet = wallet;
            this._context.walletProvider = wallet;
        }
    }
    /**
     * @description Sets Packer provider on the Tezos Taquito instance
     *
     * @param options packer to use to interact with the Tezos network
     *
     * @example Tezos.setPackerProvider(new MichelCodecPacker())
     *
     */ setPackerProvider(packer) {
        if (!this._options.packer && typeof packer === 'undefined') {
            const p = this.getFactory($2fea24c565181d86$export$8307dfe42d1d942a)();
            this._context.packer = p;
            this._options.packer = p;
        } else if (typeof packer !== 'undefined') {
            this._context.packer = packer;
            this._options.packer = packer;
        }
    }
    /**
     * @description Sets global constants provider on the Tezos Taquito instance
     *
     * @param options globalConstantsProvider to use to interact with the Tezos network
     *
     * @example
     * ```
     * const globalConst = new DefaultGlobalConstantsProvider();
     * globalConst.loadGlobalConstant({
     *  "expruu5BTdW7ajqJ9XPTF3kgcV78pRiaBW3Gq31mgp3WSYjjUBYxre": { prim: "int" },
     *  // ...
     * })
     * Tezos.setGlobalConstantsProvider(globalConst);
     * ```
     *
     */ setGlobalConstantsProvider(globalConstantsProvider) {
        if (!this._options.globalConstantsProvider && typeof globalConstantsProvider === 'undefined') {
            const g = new $2fea24c565181d86$var$NoopGlobalConstantsProvider();
            this._context.globalConstantsProvider = g;
            this._options.globalConstantsProvider = g;
        } else if (typeof globalConstantsProvider !== 'undefined') {
            this._context.globalConstantsProvider = globalConstantsProvider;
            this._options.globalConstantsProvider = globalConstantsProvider;
        }
    }
    /**
     * @description Sets read provider on the Tezos Taquito instance
     * By default reads are done from the RPC usign the RpcReadAdapter class, this can be overridden to read from an indexer that implements the TzReadProvider interface
     *
     * @param options TzReadProvider to use to interact with the Tezos network
     *
     */ setReadProvider(readProvider) {
        const readP = readProvider ? readProvider : new $2fea24c565181d86$export$1c914715e594734e(this._context.rpc);
        this._options.readProvider = readP;
        this._context.readProvider = readP;
    }
    /**
     * @description Sets parser provider on the Tezos Taquito instance
     *
     * @param options parserProvider to use to interact with the Tezos network
     *
     */ setParserProvider(parserProvider) {
        if (!this._options.parserProvider && typeof parserProvider === 'undefined') {
            const p = new $2fea24c565181d86$export$9b8795d63420af7f(this._context);
            this._context.parser = p;
            this._options.parserProvider = p;
        } else if (typeof parserProvider !== 'undefined') {
            this._context.parser = parserProvider;
            this._options.parserProvider = parserProvider;
        }
    }
    /**
     * @description Sets injector provider on the Tezos Taquito instance
     *
     * @param options Injector to use to interact with the Tezos network by default RpcInjector
     *
     */ setInjectorProvider(injectorProvider) {
        if (!this._options.injectorProvider && typeof injectorProvider === 'undefined') {
            const i = new $2fea24c565181d86$export$e81caaa38ad97a2(this._context);
            this._context.injector = i;
            this._options.injectorProvider = i;
        } else if (typeof injectorProvider !== 'undefined') {
            this._context.injector = injectorProvider;
            this._options.injectorProvider = injectorProvider;
        }
    }
    /**
     * @description Sets the strategy used for field numbering in Token execute/encode/decode to convert Michelson values to/from javascript objects
     * @param strategy a value of type FieldNumberingStrategy that controls how field numbers are calculated
     */ setFieldNumberingStrategy(strategy) {
        (0, $c46b7dbea18e1f8c$export$50792b0e93539fde).fieldNumberingStrategy = strategy;
    }
    /**
     * @description Provide access to tezos account management
     */ get tz() {
        return this._context.tz;
    }
    /**
     * @description Provide access to smart contract utilities
     */ get contract() {
        return this._context.contract;
    }
    /**
     * @description Provide access to tezos operation preparation utilities
     */ get prepare() {
        return this._context.prepare;
    }
    get wallet() {
        return this._wallet;
    }
    get operation() {
        return this._context.operationFactory;
    }
    /**
     * @description Provide access to operation estimation utilities
     */ get estimate() {
        return this._context.estimate;
    }
    /**
     * @description Provide access to streaming utilities backed by an streamer implementation
     */ get stream() {
        return this._context.stream;
    }
    /**
     * @description Provide access to the currently used rpc client
     */ get rpc() {
        return this._context.rpc;
    }
    /**
     * @description Provide access to the currently used signer
     */ get signer() {
        return this._context.signer;
    }
    /**
     * @description Provide access to the currently used globalConstantsProvider
     */ get globalConstants() {
        return this._context.globalConstantsProvider;
    }
    /**
     * @description Allow to add a module to the TezosToolkit instance. This method adds the appropriate Providers(s) required by the module to the internal context.
     *
     * @param module extension to add to the TezosToolkit instance
     *
     * @example Tezos.addExtension(new Tzip16Module());
     */ addExtension(module) {
        if (Array.isArray(module)) module.forEach((extension)=>extension.configureContext(this._context));
        else module.configureContext(this._context);
    }
    getFactory(ctor) {
        return (...args)=>{
            return new ctor(this._context, ...args);
        };
    }
    /**
     * @description Gets an object containing the version of Taquito library and git sha of the commit this library is compiled from
     */ getVersionInfo() {
        return $2fea24c565181d86$var$VERSION;
    }
}


var $d27f2880068b63ad$exports = {};
$parcel$export($d27f2880068b63ad$exports, "NetworkType", () => $3ebc4504403abbff$export$4a868a35d3b57055);
$parcel$export($d27f2880068b63ad$exports, "NetworkType", () => $3ebc4504403abbff$export$4a868a35d3b57055);
$parcel$export($d27f2880068b63ad$exports, "NetworkType", () => $3ebc4504403abbff$export$4a868a35d3b57055);
const $760ae36d125def29$export$2652dcafe1aa06b5 = [];
const $760ae36d125def29$export$1b66ea3649c0f3c0 = [];
const $760ae36d125def29$export$482b29556b4c8861 = [];
const $760ae36d125def29$export$43a4877758441693 = [
    {
        "key": "airgap_ios",
        "name": "AirGap Wallet",
        "shortName": "AirGap",
        "color": "rgb(4, 235, 204)",
        "logo": "data:image/png;base64,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",
        "universalLink": "https://wallet.airgap.it",
        "deepLink": "airgap-wallet://"
    },
    {
        "key": "nova_ios",
        "name": "Nova Wallet",
        "shortName": "Nova",
        "color": "",
        "logo": "data:image/png;base64,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",
        "universalLink": "https://novawallet.io",
        "deepLink": "nova://"
    },
    {
        "key": "fearless_ios",
        "name": "Fearless Wallet",
        "shortName": "fearless",
        "color": "",
        "logo": "data:image/png;base64,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",
        "universalLink": "https://fearlesswallet.io",
        "deepLink": "fearless://"
    },
    {
        "key": "acurast-lite",
        "name": "Acurast Lite",
        "shortName": "Acurast",
        "color": "",
        "universalLink": "https://hub.acurast.com/",
        "logo": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAITElEQVR4Ae3BL88lZxnA4R83bzIjmQRG4HD1FaAQqJGIsaPATUXTL0CCI+0UDDVgO4omBL7ACWJGnYN4EOczFAESFDSbpumf7e67u+95d+e5f9f1nffee+9/H374IZLyCSSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJad2hR9P9AH7zZ/juHVX6xw6/fRcdyB16NOM78MMfUa3fvYsOJtCj6HoYJqpVNig7OphAj2KcoWmp1rqgAwp0c10Pw0S1ygZlRwcU6ObGGZqWaq0LOqhAN9X1MExUq2xQdnRQgW5qnKFpqda6oAMLdDNdD8NEtcoGZUcHFuhmxhmalmqtCzq4QDfR9TBMVKtsUHZ0cIFuYpyhaanWuqAKBHpwXQ/DRLXKBmVHFQj04MYZmpZqrQuqRKAH1fUwTFSrbFB2VIlAD2qcoWmp1rqgigR6MF0Pw0S1ygZlRxUJ9GDGGZqWaq0LqkygB9H1MExUq2xQdlSZQA9inKFpqda6oAoFemVdD8NEtcoGZUcVCvTKxhmalmqtC6pUoFfS9TBMVKtsUHZUqUCvZJyhaanWuqCKBXppXQ/DRLXKBmVHFQv00sYZmpZqrQuqXKCX0vUwTFSrbFB2VLlAL2WcoWmp1rqgBAK9sK6HYaJaZYOyowQCvbBxhqalWuuCkgj0QroeholqlQ3KjpII9ELGGZqWaq0LSiTQvXU9DBPVKhuUHSUS6N7GGZqWaq0LSibQvXQ9DBPVKhuUHSUT6F7GGZqWaq0LSijQc3U9DBPVKhuUHSUU6LnGGZqWaq0LSirQM3U9DBPVKhuUHSUV6JnGGZqWaq0LSizQt+p6GCaqVTYoO0os0LcaZ2haqrUuKLlAT9X1MExUq2xQdpRcoKcaZ2haqrUuSAT6hq6HYaJaZYOyIxHoG8YZmpZqrQvSE4G+outhmKhW2aDsSE8E+opxhqalWuuC9IU79IWuh2GiWmWDsvNMH/wV3nqbQ/rvf+CXP4F/fYruKdAXxhmalmqtC8+1LhxW08I4oxcQ6Imuh2GiWmWDsvNclxNczxzWMEHXo3sK9MQ4Q9NSrXXh3taFw2paGGd0T4HoehgmqlU2KDv3djnB9cxhDRN0PbqHQIwzNC3VWhde2LpwWE0L44zuIUiu62GYqFbZoOy8sMsJrmcOa5ig69FzBMmNMzQt1VoXXtq6cFhNC+OMniNIrOthmKhW2aDsvLTLCa5nDmuYoOvRMwSJjTM0LdVaF17ZunBYTQvjjJ4hSKrrYZioVtmg7LyyywmuZw5rmKDr0bcIkhpnaFqqtS48mHXhsJoWxhl9iyChrodholplg7LzYC4nuJ45rGGCrkdPESQ0ztC0VGtdeHDrwmE1LYwzeoogma6HYaJaZYOy8+AuJ7ieOaxhgq5HXxMkM87QtFRrXbiZdeGwmhbGGX1NkEjXwzBRrbJB2bmZywmuZw5rmKDr0ZcEiYwzNC3VWhdubl04rKaFcUZfEiTR9TBMVKtsUHZu7nKC65nDGiboevS5IIlxhqalWuvCo1kXDqtpYZzR54IEuh6GiWqVDcrOo7mc4HrmsIYJuh59JkhgnKFpqda68OjWhcNqWhhn9Jmgcl0Pw0S1ygZl59FdTnA9c1jDBF1PekHlxhmalmqtC6/NunBYTQvjTHpBxboeholqlQ3KzmtzOcH1zGENE3Q9qQUVG2doWqq1Lrx268JhNS2MM6kFlep6GCaqVTYoO6/d5QTXM4c1TND1pBVUapyhaanWuvDGWBcOq2lhnEkrqFDXwzBRrbJB2XljXE5wPXNYwwRdT0pBhcYZmpZqrQtvnHXhsJoWxpmUgsp0PQwT1SoblJ03zuUE1zOHNUzQ9aRzR2V+NsK//0m1Pv6AN9a6wK9XDqlpYZzhD78ilTsq88lH8MlH6DW4nOB6hrfe5pCGCf70e/jXp6QRSA9oXTispoVxJpVAekCXE1zPHNYwQdeTRiA9sHXhsJoWxpk0AumBXU5wPXNYwwRdTwqBdAPrwmE1LYwzKQTSDVxOcD1zWMMEXU/1AulG1oXDaloYZ6oXSDdyOcH1zGENE3Q9VQukG1oXDqtpYZypWiDd0OUE1zOHNUzQ9VQrkG5sXTispoVxplqBdGOXE1zPHNYwQddTpUB6BOvCYTUtjDNVCqRHcDnB9cxhDRN87/tU5w7pkXz8PrzzPof105/DX/5IVe6QHsnf/wa/+DF6gwSS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLQCSWkFktIKJKUVSEorkJRWICmtQFJagaS0AklpBZLSCiSlFUhKK5CUViAprUBSWoGktAJJaQWS0gokpRVISiuQlFYgKa1AUlqBpLT+D+wylfk1Cv3pAAAAAElFTkSuQmCC",
        "deepLink": "acurast://"
    }
];


class $e6fbd977d0542eab$export$82d534ce93f0d07 {
    identifier = 'substrate';
    async validateRequest(input) {
        // TODO: Validation
        if (input) return;
    }
    async handleResponse(input) {
        // TODO: Validation
        if (input) return;
    }
    async getWalletLists() {
        return {
            extensionList: (0, $760ae36d125def29$export$2652dcafe1aa06b5),
            desktopList: (0, $760ae36d125def29$export$1b66ea3649c0f3c0),
            webList: (0, $760ae36d125def29$export$482b29556b4c8861),
            iOSList: (0, $760ae36d125def29$export$43a4877758441693)
        };
    }
    async getAccountInfosFromPermissionResponse(permissionResponse) {
        return permissionResponse.blockchainData.accounts.map((account)=>({
                accountId: account.accountId,
                address: account.address,
                publicKey: account.publicKey
            }));
    }
}


var $fbae680f2d48ca5b$export$76b0f749efa1c69c;
(function(SubstrateMessageType) {
    SubstrateMessageType["transfer_request"] = "transfer_request";
    SubstrateMessageType["sign_payload_request"] = "sign_payload_request";
})($fbae680f2d48ca5b$export$76b0f749efa1c69c || ($fbae680f2d48ca5b$export$76b0f749efa1c69c = {}));


var $3184438fe16ad6a6$export$444e5b5c21dce675;
(function(SubstratePermissionScope) {
    SubstratePermissionScope["transfer"] = "transfer";
    SubstratePermissionScope["sign_payload_json"] = "sign_payload_json";
    SubstratePermissionScope["sign_payload_raw"] = "sign_payload_raw";
})($3184438fe16ad6a6$export$444e5b5c21dce675 || ($3184438fe16ad6a6$export$444e5b5c21dce675 = {}));
















const $77338d64a5d1a34a$export$2652dcafe1aa06b5 = [
    {
        "key": "spire_chrome",
        "id": "gpfndedineagiepkpinficbcbbgjoenn",
        "name": "Spire",
        "shortName": "Spire",
        "color": "",
        "logo": "data:image/png;base64,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",
        "link": "https://spirewallet.com/"
    },
    {
        "key": "temple_chrome",
        "id": "ookjlbkiijinhpmnjffcofjonbfbgaoc",
        "name": "Temple Wallet Chrome",
        "shortName": "Temple",
        "color": "",
        "logo": "data:image/png;base64,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",
        "link": "https://templewallet.com/"
    },
    {
        "key": "temple_firefox",
        "id": "{34ac229e-1cf5-4e4c-8a77-988155c4360f}",
        "name": "Temple Wallet Firefox",
        "shortName": "Temple",
        "color": "",
        "logo": "data:image/png;base64,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",
        "link": "https://templewallet.com/"
    }
];
const $77338d64a5d1a34a$export$1b66ea3649c0f3c0 = [
    {
        "key": "infinity_wallet",
        "name": "Infinity Wallet",
        "shortName": "Infinity Wallet",
        "color": "rgb(52, 147, 218)",
        "logo": "data:image/png;base64,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",
        "deepLink": "infinity://",
        "downloadLink": "https://infinitywallet.io/download"
    },
    {
        "key": "galleon_desktop",
        "name": "Galleon",
        "shortName": "Galleon",
        "color": "",
        "logo": "data:image/png;base64,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",
        "deepLink": "galleon://",
        "downloadLink": "https://cryptonomic.tech/galleon.html"
    },
    {
        "key": "umami_desktop",
        "name": "Umami",
        "shortName": "Umami",
        "color": "",
        "logo": "data:image/png;base64,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",
        "deepLink": "umami://",
        "downloadLink": "https://umamiwallet.com/#download"
    },
    {
        "key": "atomex_desktop",
        "name": "Atomex Wallet",
        "shortName": "Atomex",
        "color": "",
        "logo": "data:image/png;base64,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",
        "deepLink": "atomex://",
        "downloadLink": "https://atomex.me/"
    }
];
const $77338d64a5d1a34a$export$482b29556b4c8861 = [
    {
        "key": "metamask_tezos_web",
        "name": "MetaMask",
        "shortName": "MetaMask",
        "color": "",
        "logo": "data:image/png;base64,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",
        "links": {
            "mainnet": "https://metamask.tezos.com/",
            "ghostnet": "https://metamask.tezos.com/",
            "weeklynet": "https://metamask.tezos.com/",
            "dailynet": "https://metamask.tezos.com/",
            "delphinet": "https://metamask.tezos.com/",
            "edonet": "https://metamask.tezos.com/",
            "florencenet": "https://metamask.tezos.com/",
            "granadanet": "https://metamask.tezos.com/",
            "hangzhounet": "https://metamask.tezos.com/",
            "ithacanet": "https://metamask.tezos.com/",
            "jakartanet": "https://metamask.tezos.com/",
            "kathmandunet": "https://metamask.tezos.com/",
            "limanet": "https://metamask.tezos.com/",
            "mumbainet": "https://metamask.tezos.com/",
            "nairobinet": "https://metamask.tezos.com/",
            "oxfordnet": "https://metamask.tezos.com/",
            "parisnet": "https://metamask.tezos.com/",
            "quebecnet": "https://metamask.tezos.com/",
            "rionet": "https://metamask.tezos.com/",
            "seoulnet": "https://metamask.tezos.com/",
            "shadownet": "https://metamask.tezos.com/"
        }
    },
    {
        "key": "kukai_web",
        "name": "Kukai Wallet",
        "shortName": "Kukai",
        "color": "",
        "logo": "data:image/png;base64,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",
        "supportedInteractionStandards": [
            "wallet_connect"
        ],
        "links": {
            "mainnet": "https://wallet.kukai.app",
            "ghostnet": "https://ghostnet.kukai.app",
            "weeklynet": "https://weeklynet.kukai.app",
            "dailynet": "https://dailynet.kukai.app",
            "delphinet": "https://testnet.kukai.app",
            "edonet": "https://edonet.kukai.app",
            "florencenet": "https://florencenet.kukai.app",
            "granadanet": "https://granadanet.kukai.app",
            "hangzhounet": "https://hangzhounet.kukai.app",
            "ithacanet": "https://ithacanet.kukai.app",
            "jakartanet": "https://jakartanet.kukai.app",
            "kathmandunet": "https://kathmandunet.kukai.app",
            "limanet": "https://limanet.kukai.app",
            "mumbainet": "https://mumbainet.kukai.app",
            "nairobinet": "https://nairobinet.kukai.app",
            "oxfordnet": "https://oxfordnet.kukai.app",
            "parisnet": "https://parisnet.kukai.app",
            "quebecnet": "https://quebecnet.kukai.app",
            "rionet": "https://rionet.kukai.app",
            "seoulnet": "https://seoulnet.kukai.app",
            "shadownet": "https://shadownet.kukai.app"
        }
    },
    {
        "key": "tzsafe",
        "name": "TzSafe",
        "shortName": "TzSafe",
        "color": "rgb(235, 52, 72)",
        "logo": "data:image/svg+xml;base64,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",
        "links": {
            "mainnet": "https://tzsafe.marigold.dev",
            "ghostnet": "https://ghostnet.tzsafe.marigold.dev",
            "weeklynet": "https://ghostnet.tzsafe.marigold.dev",
            "dailynet": "https://ghostnet.tzsafe.marigold.dev",
            "delphinet": "https://ghostnet.tzsafe.marigold.dev",
            "edonet": "https://ghostnet.tzsafe.marigold.dev",
            "florencenet": "https://ghostnet.tzsafe.marigold.dev",
            "granadanet": "https://ghostnet.tzsafe.marigold.dev",
            "hangzhounet": "https://ghostnet.tzsafe.marigold.dev",
            "ithacanet": "https://ghostnet.tzsafe.marigold.dev",
            "jakartanet": "https://ghostnet.tzsafe.marigold.dev",
            "kathmandunet": "https://ghostnet.tzsafe.marigold.dev",
            "limanet": "https://ghostnet.tzsafe.marigold.dev",
            "mumbainet": "https://ghostnet.tzsafe.marigold.dev",
            "nairobinet": "https://ghostnet.tzsafe.marigold.dev",
            "oxfordnet": "https://ghostnet.tzsafe.marigold.dev",
            "parisnet": "https://ghostnet.tzsafe.marigold.dev",
            "quebecnet": "https://ghostnet.tzsafe.marigold.dev",
            "rionet": "https://ghostnet.tzsafe.marigold.dev",
            "seoulnet": "https://ghostnet.tzsafe.marigold.dev",
            "shadownet": "https://ghostnet.tzsafe.marigold.dev"
        }
    }
];
const $77338d64a5d1a34a$export$43a4877758441693 = [
    {
        "key": "airgap_ios",
        "name": "AirGap Wallet",
        "shortName": "AirGap",
        "color": "rgb(4, 235, 204)",
        "logo": "data:image/png;base64,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",
        "universalLink": "https://wallet.airgap.it",
        "deepLink": "airgap-wallet://"
    },
    {
        "key": "plenty_wallet_ios",
        "name": "Plenty Wallet - your portal to web3 ",
        "shortName": "Plenty Wallet",
        "color": "",
        "logo": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAABkfUlEQVR4AezB7Y4kaWJY53NqejT7Ta64pD5hkJBoC4YBw4B+6f4vQZANCNYfC4ZFibbJ1Yq73Nk5ijejIjMyMjIrs7q6p2emn8d/yL+Jzz777Afpic8+++wH64nPPvvsB+uJzz777Afric8+++wH6x2ffRQqWxUqaxWDyqJCZa1CZahQWasYVLYqVN5XhcprVaisVQwqiwqVis/e1hOffSsqVLZUVIaKQWVL5RYVlT0qi4qKe1SsqbxWhcqWispQMah89mE88dkHp7Klck3FoHIPlddSUbmHyltRuaZiUFlT+extPfHZJ0dlqHgfFYuKt1LxIakMFZ99WE989slSGSpeQ2Wh8j4qFiofg8pQ8dmH8Y7PULmlYlB5rQqVD6liUHlLFe+rQuV9qVxTMai8RsUPzRM/cCpDxTUqKlsV91J5LZV7qKi8pGKr4hoVla2Ke6m8lso9VFReUrFVofJD88RnByqPUnk7AbGo+FBUtlQepfKhVHwoKlsqP0RPfHZVxVAxVHw4sqY8i1kMFftiqIA4F7OAgICAgICA2KoYKiAqzgUExCzOBcRJ3EtlT8UtFZ/d74nPdlWoDCqDyluouBRDxUnMYhbKJCogICBmoawExCxeFhAQFcoklANlErM4F7OAOBcnUXFNxS0qQ8Uelc/u947vEZWhQqVCZa1C5SUqb61CReUk1pRJvEQ5U6AcFGgUKGcKlBcpN8TL4lwUKCiTANlSuYfKWoXKUKFSobJWoXKNyksqvi+e+J5QWagMKlsqQ8XHpjKLWQzFQbEhe4qD4kg5Ug6UC8pB8dEpGwFRMVTco2KoWKgsVAaVLZWh4rVUvi+e+IGpGFTuVfF+ogICopjEQjlQNmKPcqA8rDhQ7la8t+KoOKNMQpnEvlioDCqX4paKQeVeFd9XT3xPVNxD5VEq+wICAgICYhZrypHy5iruoTxMeW/KkfKCOAmIWUBAnMRQcRLXqDxK5fvqie8BFZV7VbyfgCgOio2YBcSe4r1VLFTuVfEWKoaKRxUvCIhzchIVs1AmcY+Kz2bv+A5QqVB5CyoVC5WhQuUeBcqBcpcC5UA5KlCOCpQzBcoZlddQqVioDBUq96hQGVTuUaEyKEcFylGBcqZAY025IWaypVKxUBkqVO6lckvFp+6JT5xKhcpbqVBRUVmoDBX7AmJQjoq7KLuUM8qZCuXNVKioqCxUhoqXqCwq7qGyRzmjnClQXim2KlRUVBYqQ8VLVBYVe1Q+dU98B6hcU7GnYqtiULkUEIPKSVxTHCivUnEPlWsq9lRsVQwqt6jco2JQeY2KeyhXFbuKlRgqIJSbVO5RMah8Vz3xHaeyqFiorFWoXAoIkFnMAuIktpT3ojJUVCwq7qWyqFiorFWoXIqTeITK+1AZKioWFfdSjooj5UyFshKzeC2V77p3fAdUqOypUBlUrlG5FCdxEufiQ1JZU1mrUCYCsVagHCiTOBGIQZnEvjiJ9yOPUllTWStQdhUoB8pVyo6YBciHoFLxqXrHJ0Rlq0LlGpWtCpU9Fcp3RoUKBMSWcqFAmcRWAYLMAuQkQN5HnBMIkNeoULlGuVCg7CpQPiqVRcWn5B2fOJV7VKgMKtcoH02FyjUVKkOFckGZxBA3BMhMiCvkIE7iXLyOQIDMCjRmsVWgMlSobKnco0JlUK5SroiZvJUKlTWVik/FO77jKgaV6wLkHsWRsqtCZU+FyqCyL0CUSQzKmbhTcaC8ieJI2VWgbMUkSGZyEDM5p0xiUF6lYlB5CxULlT0VKnsqVAaVT90T33EqKouKk5gJBERxUOxSUFCuUrlGZasCAgJiFnsC4gEKyqLiloqhYpeCgnKVcpWciUkcxS0BAXEvFZVFxS3FQbFLQUGZBMSWyjUqWxWfqic+QRUVWxV7KhYqEBCzgFgoB8qbqtgXWwEBAQEBAfGsoLhQ7KlYqNyiMqi8qeK6GGIWEBAQEBAnBRUQEIuKPRULlVuUA+UBAQFxTcV30RPfIpVBRWWhorKlskdlFvcqLlQ8qmJQmQUEBMSgEBAQG8UFBeWCskcFAuIkZgEBMQuICgiIWVRAQEBAQEBA7Kk4UK5SrioWATERkJWAUCYBsabyqOJC8bCKQeUalTUVFZVv2xPfEpUKlaHiLVTcQ6FiTWWoeFlAqEBAQGwVxEpxVKAcFPviUkBAQEAsKiBmcS4WCsWzGJSD4oqAgICAUCYxi62KtYqjAuWg2AqIWWwFBATEouIeChVrykFxQ6yp3FKxVrGoUFH5tjzxLVJZqKxV3C8gHqWyR+W6gDiJ4kJATOSccqQcKWsVJwEBAfFWlF3KQ4pJzAICAkKZxELlSDlSzhSLmAXELLYC4hEqe5QXxCyGimtU1lQWKt+2Jz5RKvcJkD0FxRuKRewLiJXiMQGhTOJxsaio+DYVzwLibso1MQuIPTFUVHwYAQJxElsVn7InPkEVeyoqTmIWC+WgOFCuqrhPQCxiEgTERAiI1woIiKHYVVFxi8pQMahcU/FaFQvlAQEBAbGnYldBsRUnykHFoHJNxWsVkxiUSZzEd8U7PhKVe6nsUTknEEOBcqS8SOWaCmUiQ2zIfZRz8RJll8o1FSoLlZeoXFOhco3KPZQXxJbyLECOlGsKkAMB5VmA7FG5pkC5Srki1lTuobJW8TE88RGovIWKk4AoKFCOKobi1ZRnESCPq6iYBcT7qNiqqFBZVEBUzOIkICAgIGaxpgIxi5O4V0XF68QsIIaKCwUFclQQUDwLiEco70EgKipeQ+VjeOIjqnhMQEAMKhUQa8oZlUG5S8W52IrHKc9iKN6LSsUsIAZlEhAQyoEyiVlA7KmYBQQExCxmATELCAiIa1TWKt6HSsUF5YzMhIBYBATEWsXbikE5U/GpeeIjUnlJxVrxLAbljPLeVIYKiKEgIF4rBuVIeVHFWsVJKJNYKO9NOahYFA8ICAgICAgI5UjlJRVrxbMYVM4o94itgBhUhopFxVtQjlReUvExPfEJqVCBqBiUo4riQvEmVBbKSXFNxUlUVAzFQypUICoglElAFBQXKt6CykI5qrimYq2gOCieBcRLKlSGikE5qqiAWKu4V2wFxKCyUFlUXFOcKSgOimdxjwqVoeJjeOIDUFFRUVlU3KIyE+WgOFJQKG6qeFxAFATEswJlXyiTgFgoB8qZin0xKJMYlIPiSEGh4paKk7gUEBAQJ1EBsahQuUblXCgHypkKCAiILZWFylCxUFAoJgGxp2JPzGJLFhVrFSrXKBeUA+VMxS0qCxWVQUXlQ3jHG1PZqlBRuU/copxRzqjcJ0AghpjIOeVc3KJcqFBRmcWl2BcgaypryiQWyiRO4rZYKM9iUCZxmyxUtipUlI04kXspK6FMAmRQuZ9ALFTWVB6hXChQUHkfKhVv6YmPQOU+AVEcFCjvpeJSQMxiiEsVi4pFcVS8SOUkXlIxVKjMYhYQEBAQtxTESUBAQEBAnAQEBFQsiqPiqJgEBMQsICAGlZcFBETFUKFyv4BYq9gTEEOci0XFomJRsShepDyLe1QMFSof0hMfQcVaxblYUw6Ug+LVVE4CYi0g9qlUDCoQBcqR8oKogIAYKm5RGVQgKmZxTcwCAgJiIgcBcV1AbCgVAQoBFQgBAcpGnIuKtYpblEmoDBWPiYXKa6lUDCpDhcpCeVExCRCIiltUBpWh4kN54iOqGFQqzgXIHuWoeFDMYhEQEPsqFsokIAblAbFWHKhUXBcQEINCQEBFQEBAQMzibVQcKUM8U9YCAgICAgJiKyoGhYqXBYRyVHGfgIC4JS5VLFTWVF6rYlCogLiHyofyxHtSGVRU9qgMKguVS/ES5S4VM4F4hAoExFbFVsWlWCgHypHKSUBAQAwxC4gV5R4VEBAQEBAQEBAQEBAQEBDKJCC2KrYq9gTERA6USQzKgwJC5R7FStwSECfKJCC2KrYqblEOlCPlVVRUVFTe1xNvQOURFSfxiIp7qEBADAEBMYkXxKI4o7KlchIQt1RAQECsBcQsLlVcCggICAjlquJuFRAQEMokICAglBcFxKx4FhAQ96qAeImyERBDxZ6AOFcBsVDZUnlEsRKPqFhTeR9PvAeViq2KayqUSUDcqzhQeVlALIpzckOsKbsqhgoICIih4poK5UxAQFxXAaFMAgIC4iUVa8rdlF3FQfEsIIYKiD0VCLEVEBB7igPlWdyrWAmVWwJipuyqGCq2Kq4pUDYC4paKQeUtPfGeVLZUhootlddQzlTcIyZyU8VQcS8VCOWCylBxEhDKQUBAXBMQEBDKmYp7qZwLCAiICoiKeykHykYoBxUQEBAHyiIgILYCYk05U0wC4iXKRkAsKg6KtbhOZVDZUhmKC8oVcovKWsVbeOIDqVA5FxVbxUMqVLYqIBbxrNiqWChUKLsqKhYVELdUKJOAGAIq4lzFSUDcUqFyLiogICAgICogICCG4kihQJkEBAQEREUFxFDxkgplIyouFAEBsRYQWxXKSkBU7KnYKiYBoVKBshVQUAExVLykQrlQXCgmMYuXVKi8hSc+EJVLolBQUBwoZ4pdFYPKomKhnIuZsqUCATEoV6mozOJloZyJZwoFRQWEMgmIoWJPxaACAVEBMShnKgblgnJGuUpBeRazgICAgFhT2aNQUVFxoKxVnAuIikFlURwpZyoGlS1lJVSuUVAmAnEPlT0KBQXFgfIsQCr2VAwqiwoVFRWVRzzxLVBRUC4UKBQXVCrWlElALAJiiOviMQHxslgEBMSGgqBcqFCpgJgFhEIFxEJ5UMxiFhCPiX0BAQEBsUdBQZkExFGBUhEQJwoVa8pGQDwurgmIIU4CAuJRCgrKhlSoVGypVKypvI8n3lPFULFWUbEv1ooj5UA5qFhTOYm1glhRLgXEorhDDMWBclQBUQGxqKC4FBBrFQuVQTmoWFOuqoCAgFAmAQEBMYtZFM8CAgICAgICAqJiUFlUDBVrBcUkICCuKSYBgXKgHBQBAQHKJCAg1oqVUIG4pViJW4oD5ag4qFirqLhH8SxUBpWhYk3lmopB5V5PvCeVPSoql2RLodilMlRcExATuamiOKMcVSwqZrFQLihnAmKioMwCAmKPSgUEBMRCOai4FLOAUG6qqFhTjioWFVvKJCAgIJRdCspGQEBALBSKZwFxpBwUQ1ynbMRaRcWaclRMYqi4IAQExEzZpaJyD4Vil8pQ8RKVRz3xRlReUgGxRzmq2FJZVEAMca9QUK5SGSqUSSwqzgXEEBMhtgJiUewICOWouKACAVEBMYu1OAkICIiJghIQEBAQEBMloAIlIGYVcU0ok4CYxVbFuYAYlKNiEhAQB8qiIhYBAXFdQKioXKMcVKicKbZiESovqbhGOarYUllUvJUnHqCioqLyKOUuKtdUqFxVXIqXVCyUCyonsYhrYktZCYg9yrOAgIAYKpSjgICAmBQBsRazmAUEBARExZFMAmKIQBkCAgICYk/MAgJiUNkXEAtlIyCGCpQhtqLiurimYqFM4oyyJxbxEpV7KFdVqFxT8Yh3fDSxVRwpd1EmMcQO5VxsVSxUBhWIRYGyEYu4Jq6LtWISg8pJbMUzJfbEgUziUsyieBYqgzKJRYEyiVmcCATIEOdkT5zIUDETZRIg14VyJkBOlEmA7IviSGVQWSvQALlfgNyrOFKexS0qt6g84ok7qTwuICD2KAfKQcU9Coq7FRdUVCogINaUjVjEnoDYFxBbyoEyiQqItYBYC4oKCAiIWyrOhYJKxR7lhpgFBAQExBAQEBCzWAsIlUE5KCYBAXFNRcUiILZiUbGlolKxR3kWLwmIRUDcQzlQDoq7VFS8hXe8UoXKWoXKI5QjlduiQDmIl0SBckZlobwg1uJZgQKxKFBW4roYlCOF2BOLAgW5T4UyiYUyiUGZxP1kqFBZK9A4JzGLmSxCmQSIshEgaxUqewJkLQpU1pRJgKi8LEDOFChrBcpDlCNlJUC2KlTeyhOvpLKo2FNQ3FQxVFRsVUAslIPihoAYlKsqbotFQKwoEEPxLE6ioNgIiEVxUFFxEhAVa8pBxSwgICAgICAglKuKV4hBOaqYxVpBBcRaQMyKg4qKrQqIhcpQTAJiLSBOlEnsqYCAeFmcUY6KRSyiouKW4qCg2IiKNZWh4iUqL3niDahUbCkoN6kMKipbKiAQi5jIrDgXL6mAUA4qFhVDxSK2AmKhUDELiEFBeRYQazERYqKgQEAslI2AUCZRPKxiUA4qFhVDxXUxCwiFillADArKs4CAgBhiIgcKyiQgFsqzgFgoB8UkINYCYi0ghopBOSgmMVQMFZcC4oJCATHETEHlFuVAQbmg7FIZKvaoDCoq1zzxnioGFZWT2FNcqBgqtioghoDYUE7iHspBcaCyUIFQDuK2ikFB2REQi4qAOKmAqNiqgICA2FLuEBALZRIVEMokIJRJqJzENRWDgrISEFsVs1hUBFScBETFuZjFoKwExFpcUhkqBuVZqAwqdykOFJSXVGxVDMWF4iaV9/HEgyoWFSrnAuIa5YLKoLKlEBCXKmYBcZ9YKAcVEBAQQ0DFuahYVKhA7Iu1mCizgIBQDpSVgFCuqpgFBAQEBAQExElALJSDYkdUQMwCogJiqFC5LSAgBpWTgEBmSpxTJnEuhop9sRZrsVAZil0VW8UkhgqUR6hsqQzKBWUSEBAQi4p7qex54kEqC5VzMRR3q6i4FBC7ikFlKO4Ui4qKQWUoCIhnykkMypEyia0KiEVArMWiogICAgLilgoIZRLFhTgJCAgICKioiEAIqIgICFCIc8qzUCYBAQExVOwLiLWCYhKLgIBYi0VxoEyi4lKsxVpUVAzKQTGJhcqW8ixUdsVKQFxTUTykYlAZKl5Ssecdd1B5WSyUu6lcil0FCsqacofYUpnFoBAnFcoVsS+Uo1iLLRWIe1QoKOfkIBYxxHUByrM4kGcxFCDEQhYCMZO1UCYBsi9moqzEiWxVqChnlCtiJkPMZKaypjwLkAqV62ImZ4QAeZnKvQoUVNZUXqJSsfWOK1Q+lAqVe8SKci7uEwXKkcosFnFO2RH7Yi0WsVWhAvGyWChHMcQibqtQWSgvk41YxEnIIFtxIosKFYgTORcgMRNQJjGTczGTPRUqC2USM7kUKi+TawJkESBDhcqjlFer2POOb4HKdfEhKBuxFmvxmFjEWuxRJnFdbMUiXkOZxD6BuCT3iSEGGQQCZBEzUbkUIOdiJjGTRczkXICcC+UoZvKSALktZrInZjLEoPKxqVRsvWOHyuME4h4VKosKZSK7CpRz8bK4R9wjLsVaLGJfDAXKUYVyIZ4VyA1xL5Gnpy+RL9AnBCK+6Q/U13zTHziJ62RfDDFIgKxFgcqiQgViJmsVykQuBci5mMm5ALkUM7kUIC+LmbykQmVRoXJNgfJMIEDewjseVKFyKfYUKGdUKlQGFQiItXim3FKhci6uiwKF2IpLsahQgViLRaxVKGcUKlQG5SjW4kB2xKJAOZAnvvryF/zo3R/x1Ze/4Kt3P+PLL37Kl1/8mHdPP+KLpy+5pb7h629+x+//8N/4/R/+jr//+r/yu6//lt/+/m/47e//f77+5vcok7gk54IgmYjMFCqUiaicixNRnkUMMsisQuVSgJwLEIoUuUeADBUqdytQAmSmUKEyqNyirATIWoXKLRV73vEglUcou1T2BAjESoFyEmsqewqUjRgUYisuxZoKxCLWYkvZpUxiEUPsqVCB2PrCL/npj/4RP/vqz/jJV7/iJ1/+Ev2C19Invvzix3z5xY/Z87uvf81/+/u/5je/+yv+6+/+E7/7+tecxIkcyLOImYjyLE5kT4XKVoCAMgmQtQJlnzIEyCJA9gWIym0BcqQsAmSm3K1A2QiQQWVPhcot73hAhcpbqFCZxVo8K1BQTmKrQuUkBmUl1mJWMSg7Yq1COYpFXIrrokA5iCG2KhSUSSy+evdz/ujH/wO/+PE/5Sf/4FeIfCxfvfs5X737Ob/8yZ8z/P0ffsPf/t3/zd/+9j/y69/+P0DMYiZbEQQoshYgiwoFZRIgs5hJTAoVCJCFMgmQcwFyUASozAJkT4XKWyhQbipQUHbIokJlS2WhUrH1jgeovBWVrXgWIKDcQ+UkXhInKhCXYks5ikWci32xphCLWKtQUI7ePf2If/jTv+CPf/Ln/PjLX/Kp+Adf/JRf/ewv+dXP/pKvv/kdf/N3/xf/32/+A7/5+//CLE7kSCYRg8giClRUzgXISRwoATLETE5iJicBgjIEyCJmsqbcKUD2BAgokwDZqlBRrgiQhcprvWNHhco1FSrnBOIxsYgVOahQOYnbYq1CBaIA2RGX4lIsKlAgzsW+WIshzsVCmQU/+9E/5lc/+0t+8eN/jsin7N3TV/zJT/8lf/LTf8lvf/83/PVv/j3/72/+A9/0NbM4kZOIQQSUSRSonAuQPQGyiAKVoUAD5CRAFgGyFiDnokDltgDZEyDXqQwVKpfkHhUqQ8Wed+xQ2apQGVQuxeMEIvapDBXKw1QgBoVYi31xKQqQmQJxLi7FWiziXJyTX/7kz/nTn/8rfvzlL/ku+tGXf8Q/++N/zT/+xf/KX//m3/Off/1/8PU3v+UkQM5FyCCgTKJA5SRATgJkCJCZcqRcESCLALlUoTKovJ0A2aMyFCgPU1moVGy94w4V76tC5STeTgzFgXIhXhKXYigmATKLc3EpFjEpkJXY88uf/AX/6Bf/C1+9+znfB188fcmf/fx/5lc/+x/569/8n/zV3/5bvv7md8ziRGYxxCByTcxkFgUCKbIIkJMAORczGQJkEcVGzOS2ABkqVBYBsgiQ+wXIVsWgcq933EFlT4VyF5VzAjEIxDWh3EXZiCHOVShnCpRdCiEQaxXKRqzFEMhNP//RP+Gf/tH/xo++/GO+j558x5/+7H/iT376L/irX/87/vOv/3e+6Q+cBMi5CFEmMZNzATIoRwGyiJkMFcpEFgXKUcwElIlsVajcFiAqa7Imtyg7AmRN5VHveA/KRCBeK/47e3AWrGliGOT5ff+z9DndPb3M9IxmkVoz1kiyZVvYipCtDQixY1tQlRTZuIAKRXKRXIRQmCTkgpQrF6kQX0QFCk6luEqgikpY5AQMSS6wQ6oowGaRHWNDgS3Lkmxj2ZIlzUizvTnf//d3/v0sPeeMRqN+ns0qVO5fbBbKilBWxCBGsUpZEaMYxLpYtL9zjaduvZcbh0/xjWDiLo/feDcPX3sbn/n8P+ALz3+KuZiRChWIGIgMAmRZgMwFSICsU+4JkIFyJEDOSnlVAmQQMzKqULlsu5ygQqVCpUJlWdyfOInKJhUqc7GoQjkWi2JdLItRBQoFQoUKxLoYxSDWxZw8ev2dPH7ztzFxh280+zvXePqRD/Nbz3+aX/783+PFl59nLpQVEUKh3CNzAVKhAgESIKMAWRYgcwEyVaAUaBSoLIsZ2S5AFsUqWaSySYFyT4AsqlA5qwlbVKgMVAYqc3G/KrapmItVKoMKiFUqozhNLItRBQoEMqUCsS5GMYhlATHa373Os499D0/eeg8Td/hGduPwKd75pt/D7avPMKiYC4i5QKaKDUJlLgYBMYrTRQVKgDKlciGKUYxiUHESZaq4JyBGKptUbDJhC5Xt4n5UDJStVGbiJCqLKmaimCnmYlAxE8tiiQKxLJYFxCAgBjEXEKOK21ef4Z1v+gjX9h/lgZmdyT53H34/dx/+ADuTfdbFogjlSIwqZqJiUByJRcWRWBarVEYxiu3iZFExpWyjchbKkopRxaBipKIyUFEZ7HJfZCbOQzkSo7inQKlQgThJhUKBMqUCMVCII8pMjFQgCpR7YlEMYllsE4NYFot0h7fcfi8PX3sbD2x2++rTXN1/mF/89b/NV176AssCZCpIoFCmVEbKlHJPgAQoUxUqcwEyFyDrAmSzANlGZZMChQqV0xQoFChTyjGVgcoqlUHFYMIZVKyL86gYFcQCZaACcRplStkotqsYKPfEKCAGsahiWUAExCDmAmLR7s4hzz76PTx87W08cLIruzd4+5u+j5uHbwFiWUzJkUCZi2WxLAYVA2WDWBZTRSyK8yrmiiUypRyJ0yhTygI5i4qBisqEM1B5tVSOyasQm1QMYlUsUs4plAUxFxBzsepw7zbveOz7uLr/CA+czcRdnn7kQzz20LcCsSzmImJQHIllsUaZi3WxRhnEWcQmypGYUi5axVmojCom3JcYFFPF+cWrVjETCrEqlsWgYiZGMYq5WBajOBJTFRCrHjp4nGcf+x72dq7ywHnJEze/gzffeh/rYlAxiFDuiWUxFxAVcwGxXSyKUVQMKs4upopFsSjOojimnFnFQGXCPSoDldNJgTKlnEEUxD1yrGImBsWaCohFKhDnpVJRUBEzFdvFKI4UyJSyIm4cPMUzj/xOJu7xwP175Prbufvw+wFZFiqjOAeloqI4VjETpylQplSWxSbFnHKskLliTcUq5b6oVFRMOKIyUBlUnEY5VpyJspHKImVJhcq6GMWigNimQkFBZSaUqQqITWIQyD1RLIjbV5/m6Tu/A93hgVfv9tVneObOh9EJy2IuYhTLYlEFCopyT6gMihWxKEC5JyrOQtlMCYgZZUmFykWpUFGZsIHKWRRTyn2pOAvlSKyTYqNiQUBUDJRjsU5ZEYMYxKhioNwTNw6e4i2334/IAxfnxsGbuXv7u1lVMRcxU7EsKgbKkRjEohgoR2JZLAooppRzikHFqlinsk2xUcWqioHKaMKroJxLLFMZVFSMKs4mlGMVEAPlnhhUqCyKUWwXczEXyoK4fuVxnn7kw+iEBy7eratP85bb3wXESDkSgwqIAOVIjAqUc4plsUg5QZwsVAYVFKPiSJyFcqxipLKoQmVRxa7K+cX9EIh1yhKVRQXKRhUoAxWITVRm4mQxF6OIuVgWh3u3efqRD6M7vB6J7O1cY3dyyM7kgIm7TNxlUK/wSi/yci/w0ivP8+LLz/FKL/J69PC1t/HCy1/mV3/rpwGpUIFQmYkQGQSIck+AzARIgIwCZLsAGQTIq6eySLknQCpUNilQplS2Udlkl9dEDOL8KpQVMVKJUQwKlCOxLAqQBTEXm8RJYndyyNN3fic7k31eD0QO9h7m6t6jHOze4WD3Fns7DyFyVi+98jxffekLfOWl3+C5F/8lz734a7zSi7wePH7j3Xz1pS/y+ed+EZW5ACHAAJkJkEGBBshMgATIJgGyTYBsEyDbBciqABlIhco2yoIAqVDZpEJloLLLJapQ2aZCmSpQ1ignipkKZUrZSpmKQczFshjEIOZikezw9J0Ps79zja8l3eH6/pPcuPIWru0/yY77vBq7k0N29w+5tv84jwARz7/4L/niVz/FF7/6KV585Tm+lu7e/m5eeOmLPPfC5wCpUIFAGQTIMmWDANkuQOYCZFmALCpQtipQZgqUZaFyFgXKkVC2UhlV7FaojCpGKuuiQNmoQmWgchIViIFybnGkGChnFoPYpGKkHIlVFSoQT956D9f2H+Vr5cruLW4fvJ2bB29l4j6XReTq3mNc3XuMN11/D19+4Vf5za/8M7701V8m4rWmO7z1kQ/zT3/1b/DSy19FZUbmAmSzAFkUR+JIDFQ2KVA2qlAZKCdS5pT7UUwp98hZqeyqLFLZLgbKVirLogDZIF41ZSYGFSoQy2JQgVKg3BMjFYhBrIqByuDm4V3uXH8HXwtX997EI1e/hev7T/Lak2v7j3Nt/3FefPnLfO75n+XzX/nn1Cu8lvZ3rnH34ffzC7/+44wqlCMyCJBBgFSoFChrlFMpRwJkECCDUFkWBSqbBcj9UpZUKEdkkwqVCpWdQ97yQypnI9tUqGwlZ1YxUJZUKFMxV6FMqayLQRxRIJR7YruYi0V7O4d8051/lYk7vJau7N7kyYfez2PXfhv7Ow/xtbYz2ef6/lPcPPgmXu4rfPWlL/BaurJ7g5de+SrPv/A5QJQFMiMyozJQFsiMyCJZJsvkWKAckU1UTibHChDliIwqVFYVKFPKAlmlMlAZTFRGFSeLVRUDlXUxJVsVa1SUNcpULFNZFtvFoGJVBcQgYi5W3X34A+xM9nmtTNzlTdffwzO3P8L1/Sd5vdmbXOXJhz7AW299D1d2b/FaevLmd7K/+xAQm0WMYlCxpohFsSzWFAPlnlilbFUckSUKskZlE+XcKgYTFqgMKs5K5STFkoqZKFCmKu5fjCrOQqVikcqgYrt45NqzXL/yJl4rV/ce45tu/x4ePvxmRF7Pru49yjO3v587V78NkNfCxF3u3v5uQCrmYhuViiUyVXE2gTKIzYolFaMC5UhUbBbnUZyJSsWEDVTWxTYV62KgLFGZEeWYyqLigsQg1ikrYkoWxKLdyQFP3PwOXhvy6LV389Zb/xp7O9f4eiETHr32bt5663vYm1zltXDtymM8cu1ZtosYxUBlXaCcR8WyGCn3xEBlpBxTWRKXTmXCJSvui7IiNottKooFcZo4STxx8zvZmexz2Xbc5+7N38Wdq98GyNejq3uP8vTt7+fq3qO8Fp64+R3s7lwBYlBQcbpYFaNYFstiFOsqziaWyIK4HxUV21RMOJNYVRxTWRani20qNimomItloUxVDBRik6iYi3UxF1f37/DwtWe4bHs713jr7e/l2v4TfL3bnRxw9+bv5ubB01y2nck+T9z4bQwqIJQFEaOomIu5OE3FSOVs4iwqBgExV1FxEmWqmFI5yYQtKk6inI2cm7KRAsomFYsUlAWxSmVRDGJQserJW+8B5DJd2b3BW299L1d2bvJGoTs8+dD7uXXwLJft4evPcmX3IRRUZmIuRsp2RYxiWajMxShGMVA5L5V1oaKySbFEReUkKpOKTVTunwwKiHOKdTEo1hRUqIwqBsUCmYtlsUpZEA8dPMm1/Ue5TPs7D/HWm9/L3uQqbzzyxEPv4/bh27lMIk/c/E4GFXMxijNQXq2KioshFasKCpRjxZGoOM1EpeJixUBZUjET90OBYiZGKhAjZUohRrFNQQxiJlY9fuPbuUx7O9e4e+t3szO5whvZ49ffy82DZ7hMNw/fwuHebZQtYlHFTMzFslgW28SMsqR4VVQqloWyRJlSTlQx4YjKoGJUMRMg5yPH5JjKyaJYUjGKI8oi5VUK5UgUxypm4qGDJ7m6f4fLMnGPt9z4nexNrvHGJ0889F1c23+cy/TYQ9/KuhjFKFQGxbHiSJxdjGROZaQciZNULIl7YqCySGU7Oc2EBSojlRmp2KZiUUXFoDiXAmWqYqDMFRSrKjaJUczFZqIcU4EYPHr9W7g88tSND3Bl9xbfKGTCUzc+xN7OdS7Lzat32d+5DsRZKUdioEwFVGxTsaSoGBTnUqEyVUwJMVNRsarYIk6iMmFFxaIKlW1UVilTypIKiG2UYyqDYk5BqdguigUxF8tiLgYViw72bvHQweNcljtX38X1/af4RrPjPm++8WF0wmUQuXP9HczEuoh1xbICZSaWhcqiOKIMlCXFiVSOKVNxTEWl4iTFPXKaCStUFilH4qxURnFPMVC5XzGnskhZopxLzClL7lx/B5flcO8Od669m29UB7u3eezad3BZHr72NnSHZbEuRsoyWREnURnEXMVAOUWsC1mmskhZotwTp5lwgopRcaw4VnEq5TwqBhXKBnGamCm2iEEMYl1M3OXW4dNcBt3hyYe+G5FvZA8fvpOre49yGXYm+9w6vMt2sVkMKkYVo4pRxclC5TwqpgqUuH8VJ5lwApViSmVQoBxTOU3FouJEKgNlqrhvyjnEopuHb2FnssdluHP1Xezv3OABeeKh70InXIaHr30T62IUo1ilUkypDApURsqC2KRiUcVJVKaUqbgnzkeUE00qVlWMVGZioJxJzMlMxUChYllsJccqlsV2MRdzMRerKga3rz7DZdjbucYjh+/igZn9nRs8fPhOLsP1K29ib+cqEJvFquJIDJSpmFGOxP2oGChUnJncIxVnFyAn2WUDlblYVKAsqVDZShmoQAxUThabqEBsFscKZAuBiEUxUtmZ7HP94HEuw2PXvgPd4bV25ao8+bZd7jy1y807Ew6uihN44avx5S/Eb3z2ZX7lF1/iNz77Mq+1O1e/lc8//895uRe4WHLz8C6//qWf46yUrQqUJRUq2yhTKiOVzQJkG5WzKFBOVLGrcpIC5ZiyRuVsYlCg3JcK5URxRIGYiUUVygqBmIkbB08ictGu7NzkxpW7vFb2D+Rd77/Cu96/z1Nv32My4VS/9blX+PmffIFP/MRX+PVPv8xrYeI+j1z9Fn7ty/+Yi3bz8Cl+/Us/BwRIgXImBRogA2WNyiYBsq5AuQ9RoHIaZasKFZXdCpVtVCBWVahUqCwqQDaQCuXMYqZCQVkQ28WoQLknlHtiLhbdOHwzl+HOtW8F5LLt7cv7fuCA3/79h1y5Kudx45EJv/37Dvjt33fAL/z0i/z4//ocv/ZLL3HZbh++nc899094uRe4SNf2H2PiHq/0IgPlSIAMAmQQIIuUYwEyU6FSoAEyqlDZpEIFAuSsChRUzk4GFSojlUHFrkqFSoXKWagMVJaFQhwpUBYp90UFYlShLIhtlDUxV6FQoQLy0JXHuWh7k6s8dOUul+3pb93jB/6D69x4ZMKr9cy37/H0t93k7/+N5/nbf+V5XnoxLsvEfW4dvo3PPfdPuEg64aGDx/nC859iowKlQFkQIJuoDJQjMhcqUwXKIpX7IvcESIXKyQJEZROVCUdUKlTWRUFxrGKzOBagLItiTcV5VKisKohVUawrRgoFKoPDvdvsTPa5aLcOn0UmXBaFD/++q/y7/9kNbjwy4aIovO8jh/zB/+omN+9MuEy3Dp7lMly/8iZmYlDMCRXKkVhVQDEqjsRcrClQ5mJQsariPCpUVhUbVayqqJhwj8pmoqCcWRyRjRQKKioGKosqNimmVEbFMWVJxUBZpyxS7onrVx7j4snNg2e4LE7gI//hdT7wbxyiXIrH7u7wB/7kTR598w6XZX/nIa7uPcZFu3blMRYpS1RmZJUCskJOpCyTgUpBQcVAZVHFJsURURlVjJQlxZTKKpXBhFPFOnk1FFRUVlWoFGsUiiXKfYptru7f4aId7j3C3uQal0HhB/7wdb7tQ1e4bNdvTfj9f+Imt9+0w2W5efA0F+1g7xYTd1kWozivOJ8YKSiorCpQqVilULFI5X6pTCrOqphSjlUMKkZyJKA4i4qRykCZKRYpWxX3xEDlNBVzMTjcf4SLduPKXS7Ld33kkG//8BVeK1cfkn/7jz3ElUO5DNf338xFEzncv82qipmYia2KAOVYMVUxFxUUZ1ExUo6EylSxSNmqWCAqp5mojCpGFauUNSpzMogjAspcbKNQbKYMKk6j3CObVBTEnHKsYOIeV3avc9Gu7z/JZXjybbv8jn/nKq+1hx/f4V//969xGXYnBxzuPcJFO9y7TbFEZUYqRhVrBFmmbKSCEqdTqdhImYpTKQtiVUXFoknFSGVQobKoOJEKxEA2kWIr5VjFKpVRBcSqOJmKspXCwd5NLtre5Cr7Oze4aDu78AN/+DrK18S73n+FZ759j8twde9NXLSDvVsoWwTKoEJlJgbFVGymnKpiG5VRsU6OVZxMZmKRisqoYqIyqBiprFLOLDZTzkTZIAYVKstiIEcKiM1im4rBld0bXLTDvUe5DN/+4QPuvHmHr6Xf9e9dQ7lwV/ce5aJd2b3BTKwJZEZllbJBnIfKWShbFahsUxyJGTmJyoR7VBZVzMjFiFUVFcUKWScDlW3iiHKqoqBipDK4snudi3a49wgXTeG7f+8hX2uPvWWHZ79zn4t2uPsIF21/9zqDgopiTohRVJxOXo2KioqzUk6knKqiomJSsYnKTJxNnJfKQJmqmIl1MaoozqxilYJKsWRv5xoX7crOLS7aN717n5t3JrwefOfvPuCi7UwO2J0ccJH2dq4CMlBRqNhE5XTxaqgMVAYVZ1FRcboYVKxSUZmobBcgm1Qsk+LcVEYqi2JdhYpyJgUqS+SYsmRv54CLtr97g4v2Ld+9z+vFW791j8OH5KLt79zgIons7hygHFPuS7Gm4nxCZaRymgIVldNJhcoildGkYjvZRmVUsVFRcZKKQUHFmgJipDIozkRZEnMVq3Z3DrhIOmFvcsiFEp7+tj1eLyYTePpd+1y0vZ1rXLTdyRVGFfdLOVZsVlCcpGJQUbGmGAUoUxVnobJNxYQjFaOKQcVMnEalYhALFJWTqAwUVNYoIMtCmapYFieRIzGlMqgY7bjPRdr1AJCLdOvRHa7dmPB68uSzu1y03clVLtrOZJ9iSmVQMSqmKuZiUSxTKNYpKHOxSmWgorJGGcmcyqBiM9mmYqAyUVEZqQxUZuQkFQMVBTlZxapiqmJNcRKV7WIujslUxUBlNJnscZF2Jle4aHee3OH15s5TO1y03ckVLtqOeyhTFQOVmVCmVOZkm4qBgspcjGIkFasqBhVripOobBbbqAwqJhyp2KQCYlFxrEJlJs5CZZUypbJGgdikYp1sJqtUBhUQg4k7XKSJe1y0hx6e8Hpz/faEizZxj4umO4xUBhUzsqhiTTEqUDm7UFmlMlCZiyllm4pXQ2XCEZVBxSKVVcoxlTkZxJE4s4riFLKomFIZFFvINgUVA5VBgchF0gkXbf9AXm+uHMpFE7loIoOKioHKVLFIZY0yUjYqzqyi4jwqBiqDivOqqPARPxhbVCjnEIPYJLaLZTGIRVGg3BNzMYhRzMSyiJkK5UjMhU6IAKFA7omZiFFAzMUgBjGQwQQZxCBiEKMYCETMxKoIAXdgMuGemJGZCBCIRXE+AjEjIxkJxIwQvPQSC0QWicyECMRARiIjkYh4BZCBCXJE5mRGBjISkEUiFRAFKjMyIzKSChWQOZFFMifLZCQjWSbbyZJAOSJnI9tUqOxyApWZuEgVKuelnJNADCoUBCKUjf7AH/z93Lp9i4FAxLJYF4tiEOtiu9gmYiAQMwKxSVwukblYJhCrRFYJBMg6GQnEjMg6WSbrZCDwl//yx/n0L38GldOobBIg969C5byU+1ahMlIZ7FaobBcXTeW1pgKxXQw+8nu/n2/+5nfwwBvTT/z43+bTv/wZNguQy6byWlPZZKJyMrloFYuKE1Xcn9hMtvnC57/AA29cv/mbn2ddzMirE5vISAYViyrWybFiTi7ShHMqzqVilUrFSDmRykmKc4pio1/+5U/zwBvTK6+8wmd/5VcYVMzJmRXbyZxMFatUimMqJ1LmYlXFZrFNxWDCOSnnorKJyllVnESZkmXFVsoKGfzTn/9nPPDG9Iu/+ElefOFFBir3RTkXJdYpp4hjxUlUNim2UhlMKirOorgwFdvJVDFQOUmxkbKFjAoqRj/1U/+QB96Yfuon/yGrCiqWySbFlIzkfhVH5CQVU8ogNqvYRDlRxURF5WQyUE4hZ6WyTcWUMifLZKRMxVnFSEFl9C/++S/w2c/8Cg+88fw/P/H/skpBZVlsoqyIs5B1ypHYpDgiKotkM5X7oTLhVAGxqGKzGMgmclYqU8V2cZriWMWcbFPx1//63+SBN5bf+I3f5O/8nb/LOjmvisukTFUsivOQ4ljFJhNOJSDFMZXNZLs4L5WpYp2skmUqI5XTyeAv/W9/hZdffpkH3jj+8l/6OC+/9DLrYiQjmZNBcUxlnZyfnERlqhjIeYRyTGWTCWdQcTaxTXHBYlUFxf2Lwa/+yq/xox//azzwxvDlLz/HX/jzf5GIGZmTk0XFjCyTsyouiGxTUCyQ00y4p2IbBWVNxTLZRmU7OZGyTuZkoIKynUwVczKoABn9Dx/7H/nSl77EA1//fuTP/k98/vOfR2RQsSa2EBVlSuYqzkq5f8ogTqagnKpiNOEelfNSWSfnF6uKV0HmZJXKKpVFn/vcb/DD/91HeeDr2yf+8U/zF/78X2SRyhrlvFROI9vISSpWySDOLjZRGVRMOEHFoJgqLomsUjYqTlZAzMX9+tG/+n/w1/7a3+CBr09f+MJv8Sf+iz9Jhch5FVMVU8WcbCejGMmy2E5UNilOVCyQk6hM2KJCBUKZUs5Mtiu2qjiJMlWxkbJM7kuA8F//0H/D3/t7P8kDX19e+OoL/NE/8sf5zGc+yyDiPCqUKZUp5bxkXbFVsZHMKFMVmyj3CMRpJmyhctGKKWUrlbNQWVRMyZGYqlhV3CObyUBl8MILL/DH/uh/zt/9u3+fB74+PPfc8/ynf+QH+Qf/4B8xEhkUp5CBykWrGChbKRvFMpVFxbHiSBRrKkYVO1e9+0NsFSAXRdmoQqFAOYEMKlQKlCmVY8pAZZXKVIFsEKteeOFF/q//8//mTW96jHd+8zt44PXrs5/9Ff7j/+g/4R/9o0+gMhIZqAwKlCMyIzKQZTIjAxnIMlkmIxmJyjIZVKgUKEdklcwVqFSoDJRjypTKKpVBhcrOVe/+EFvJoEB5VSqUqQLlmMpAWSADWacyUE4gczKqUFCZkzlZVfHKKy/zt/7WT/DpT3+G9773X+HKlSs88PryY3/9b/JH/8gf5zOf/gwzMhAZFagoR2RGZCTLpEBFFsmcLJORzBSoDApURioD5R5ZJSNRGaicThZVqKgMdq5694c4USjnFstURsoFkVGFciqV81IZ/dOf/2f86Mf/dw4PD3nHO9/Ozs4OD3xt/dzP/Tz/5Z/4k/wv//Nf4Ktf/SogMzIQGanMyUhkRuZkoBwRWSRzskwGMqcyUo7IdrJKBrJNgbJAQFapLPIRPxgnim0KFCpU5mIQm8SgQmUuNotYFKMKZUEMYhRzMapQiEHMxFyMIuZiJgZ37jzC7/u3/k1+z+/9CG99610eeO18+cvP8eN/68f5q3/1R/nJv/9TgMwJyEhkTgqUIzISAVkmMzKQRVKgUKAyI4tkJIsKVDaTRTKSRRUqm8k2FSoDH+YDqQwqVJbFJgXKFjGIZRXKmgoViEGFCsSoAgViWczFKEYxE3NRHIkpORIFyj0xiJiLmahQiJm7d9/Ce97zHbz9HW/nqaee5NatW+zs7LAsNrl16xZ3797lG8kXv/hFPvnJT/LKK6+wnYy+/KUv8Wu/9i/5F//iF/iZn/n/+Mef+GlefOFFBjKQGZmRkciMjIojIqAyKFCZkTkZyEgqVGZkTkaySCpUZmRUoTIqUBkJFKicj2xTMdhVGakMKlROohyrUDmNCsQqFYiRyoxAVKDMCMRmArGZQAwKlCMSgwDRGFQoJxBlSqLil37pU/zSL/0SczETMYqZmIvBu9/9bn74h3+YJ554gje6H/mRH+HP/bk/x4svvgjIMpkRGUiFyozMyEAGskzWyahAZUZGKoMCZYksU5mRCpXtZKAyI4tUFqksKlAuTIXKYMIGKjNxkmJKZRM5WcWcbKOyTbFCpopVxZTKSVRGInOyqGJKOYmskkEFyOATn/gEP/iDP8gb3Y/92I/xZ3/kR3jxxRcpVsgmKjOyqlggM1ExEBlVDJQTKWdSTKnMyHlUrJNVylYVmxRrKgYqo0nFdnIS5T7ISGVQUTGqOJmMVEAGFRADlUUVyjnIaVRAZCTrZCADmROVQUHBz/zMz/DJT36SN7KPf/zjyIzKoKCYC+QkMlKZkYoZUVlUoTIj62RO5mSZjJSt5HQqg4riWMVIRrKJyqg4phyJUYXKooqJysnk/OQ8VFRGKouKrSpGKiAjGchAZZkMZJFsIjInM3IymZM5WaWiMvjKV77CG9lXvvIVVikoc8qMDIoFMhKoGKmAjERGKpvIJrFItpHTyTJZpaIcU1lUHIlNKkbKChmpbDLhdUVWFSjIZiqrii2kWCAzspmcjczJNrJKFj3++BM8++yzvJF96EMfYkbmBGRGZCCDAhWQRTIQlTWxQkbFAtlMZuRrrUDZSmVVcU+sqhipTLg0UiCbyKA4VgGxSuUsimPKVsqCWCenkxkZySIZFAtkIAMZFEdkcHBwwJ/6U/8tOzs7vJH9oT/0h/jgBz/EoDhWbKScgRRzgsgmKvdPtpORzBQnqhgVGyn3yEmKY8o9skplVLFzyFt+SGVUMVLZpEDZqEJloJxIOaYCcnYyKI6EskBGMpA5mZOBDGRQMVKOyEBkVKGskKkCZaACMidzokwdHBzwsY/9Gd773vfyRrezs8P3fu/38LM/+7N86lOfAmSgHBEZyJzMyUhkUEypgIxEZmSZzIiMZFQckYHKQEYyKFBZJlOFykBlnYxURso9skgWyapiStlATqIyUVmkoqIyE6uUrVTWxDnIOhnIOgUVkEHFSSoGxT0ykBkVFWUrFZBVckSZkVGxROYODg742Mf+DO973/v4RnHlyhU++tGP8sEPfpA5kbORORWVY3ECKWaKGVmkoqAykJGMlO2UVRVnI9vJJgrKsWJBrKoYVAwmFSeTs6hYJ9vJNgXFmmKFDIpjKjOyTAYqA2UDmZM5GYisk0FxRE4nA4GDg0M+9rE/zfve9z6+0Vy5ss9HP/pRPvjBDwIyJxXFEZkREAIZyKLiiEwJIutkoBwRlXVyf4RiIJvIjJxJQayIik2KY8oCWaUyUBlMVEYV51VMqWwlW1WsUlHWKBsp98gmsq5YIFPFaUTmpDgiypQskoHKMjk4OORjH/vTvO997+Mb1ZUr+3z0o/89H/zgB5A5FWWdHJG5/589/InVf0Hs+67X+/rKM24WUaJ016QSlbLhj7qop2BDV/EWCRYIIQWBPJ6J6SxQnKgxAhSWlUgysa3c8Z9ILKBQGiMjkQaxYdIBpRJ/dnhszXWJ47QsMsntHTWCekb+9HzP83vOec45zzm/87t/Jgv8euVQnpHnbG7k0jaX8pycbU7Kc8qzNk8VkUupXFPe2TaH91yoHLZ5KOSa8qKNXNicbVQO27wsh7xscyHXpdg8UCHmilxT3shJcm/zRsjGF7/4Rb/4S3/dl7704/7/3Re+8KO+/vW/5id+8ieQe3ksz8mdeYuEYpt7qdyaR/KcynU5bHNpm7ONcmvzmdi8SmWb91xReRebZ5WHylm5U7m0eVYu5TVyyL2U6/JGrknuZfNIclIhZz/2Y1/0i7/0133pSz/uD5184Qs/6utf/2t+8id/wkk2b+SQQ+7lJA/lJPfyVCpXlYfmXh7b5pCnKpcqZ+VO5YG5kM9D5T3vJO9q84I8p/JUrss122xeKYc8lnt5We7l1ubsi1/8ol/8pb/uS1/6cX/ooS984Uf9ta//VT/xkz/hUG7kulyTnOSwsbmQvE4u5SV53uYV8kTeyCe1zTbP2eZH/rn+1F/2TkI2yq3yovJOtqk8ts2hPKty2NyqnOWQs41yRd5qyK3KvZzlEPHFL37RL/7S133pSz/uD133/vs/4qd+6s/4f/3mt/3e7/1DZzlkc6tykrPkUG5kc6tyltzLRrmReznkUu7lsFG5VXIpl8qNPC8PbCr3ctjmUHlOubW5VXnJj/xz/am/7IptKs8pr1I55PUq11TKrTy0Ue4UlZNcU3koh9wY8kbu5VBJ7uWpVH7si1/0i7/0dV/60o/7Qy97//0f8VM/9Wf85m/+pt/7vX8ohxyKykkeGBVyKCr3krMcyhu5l1uj3Mi9nJUbOculnJU38rw8UHIph0rlmo1yp1J5SeVHfsyf/MuVxyrPm9fY5lA+oVzapvLAZqicbRQb5cY8lHu5pvLucpLDxo/92Bf8wi993Ze+9OP+0Ou8//6P+DM/9Wf85m/+pt/7vf/Q2UblJLfmVoUcNoqNyiG5l3u5l0Mob+ReHspZznK2uVVu5Hl5LGc526ZyaXOr3NkoNiovea+yzeehcpJbc0Veq7LNWU4qlyqkvJGzPLW5kHu5l3shh+ShnOTHfuyLfuGXvu5LX/pX/KF384Uv/Kivf/2v+Imf/K84SWVzI5cql8qNVE5yL49tnpF7eShnua68kcM2T+W1Kts8Vh6okMpLtnnPjcphm7NtPguVs/KMnG1zafNAhdwp9/K8PJSzymGbk2zksVyTPJTDX/mr/6Yvfelf8Yc+mR/9wo/6+tf/5/70n/7TzipnSeUk1yVnuabciE1ONp9AHit3Km81D2xzqXKpXAh5F++7UDmrnG1TuWaj3NnmUNmm8jrZpnLYplJhDtscKoS5tVE+nZQ75VayjVyRbYpkZpvDv/wv/5f85H/1J/ww/Lv/7t/xb/1b/2sff/wf+9KXvuRnf/bP+RN/4k/4rP3Gb/zv/a2/9bd873vf86/+l/9VX/vX/3V/9I/+UZ+nH/3Cj/rv/ff/rP/Rz/9PbW5M5dJGuZCzPCdPlLPK2Ua5kDsb5WybQ2Wj8rw8MOTWRlE52+ZQubRReVeV9z2yTeVsm8pDYQ7licqhcmlDnlXuVA7blFuVwzaVQ5iHNsqNMI+FOYS5tFFuhNmozJyEOaswZ4n4F/7kv+CH4YMPvuFv/I0PVJjf/d3f9ff+3t/z7/w7/1t/5I/8EZ+VX/u1v+kXfuEXnP39v/+7/h//9/+nv/k3f9Uf+2N/zOfpX/wX/xRSTkblumxTIffyvBzCRrmzUXlO5SRnlUN5YJvKs3IrN3Ij21QOlcNGedY2ldd4zyOVS5Wn5jmVx7Y5lE8olyoPlEvlGXkql8qFlDdyLw/lkMit/+A/+H/7vH3wwTd88ME3VE5C/uE//A/97b/9t31Wfv/3f9+v/dqvOQk5fPjhh376p7/io48+8nn6zoe/41LlXiqXKg/loTyWk3IjZ+VZOctZ5V4O2xwqb5O3Kw+UByqv9Z4XbHO2zdnmzuatKmd5u82tbSoneSqHXMqlzVW5Jpe2ubMhh23OtrmUHL79m7/l//h3/k8+Lx988Ms++OCXkWt+93f/gc/Kd7/7Xf/0n/5/kcPmzoff+Y4v//RXfPTRRz4PH3/8PX/zV/8XXif3EjaP5KE8Z3Mjh80bsTnbvFXlqTxnc2ubyuvMNdu85D0vqGxzqBy2KXfKW21D7syLyq3KYZu3yaWcVR7KWc5yL2eVza3KrVEhh8pJHvuf/I//Z775zW/5rH3wwS/7xgffEEJCCDn8weazVE5GhZDKhx9+6Ge+/FUfffSRz9LHH3/PV7/yNf/gH/yes+Re7uVSTsoLcshZyFmxzaHciI1yVp6Rs20ubV5UbqRy2OaTqrzkvW0e2+ascql8YpuTMFfkmspJNo/k7fJQzvLU5k7lLDdyIQ/lkCTf//4P/MU//5d885vf8ln54INf9o0Pfhkh5BBylnzWQpQQcpbvfOdDX/7yV3300Uc+Cx9//D1f/crX/Na3f1vlkGzeyPNyL+9q80YqD5RD3t3mVrHNY7mucrb5TL3nispzNk9sXlRhKnfyiVReY/MWOctDlYdyZ27kXjZXJd//wQ/8xZ/7S/7uN7/l0/rgg1/2jQ9+2VMhJOTzkRvzRgjZ5vDhdz705S9/1UcffeTT+Pjj7/nqV77mt779286SQ7ki9xI2N/JQ7uU55Yrc2jyUbe6FXKocyp3K8/Kc8oxc2uZttnmv8pJtLlUeK68Q5ta8IC/Z5qkccq/yUM62eSrkXg6bN3Ko5KFyIZeS73//B/7Cz/28v/vNb/mkPvjgl33jg1+xeYsQ8lnKIRVyqXKSD7/zO77803/ORx995JP4+OPv+epXvua3vv3bzpKzzY3cy73kpPJQzjZ3cpaHctg8VB6rvIvNEznLSzbPmEuV52xzqLy3zUsq12xubZ7Y5rpsFHnOXLPNofKSXMph80DldVKum1ubGyFnmye+//3v+ws/95d885vf8q4++OBXfPA3fsWhQgj54cmlza3NGzn7znc+9OWf/nM++ugj7+Ljj7/nq1/5mt/69m87Sw6bW5V7uS6XNg9UHspzyo1cCpsb2eaxbZ6zUXlX2xzKM/KcbS5VDtu8V9nmsM1rlVvlicphm8cqh3lOrqncy+aRPKe8kYdy2MiNDXko90IOFVIu5FAhm1vJ4fvf/4G/+HM/7+9+81te6xsf/IpvfPArKuRs80YI+WEqN1Ih91L58MPf8TM//bM++ugjr/Hxx9/z577yNb/17d92lpxVyNnmQpJcV7mXQ8jJNofNjZDn5KRyqNzLoXLY5rHKYznLcyqXNo/McyrXVN5zo7JN5ZpttjnbvNU2lce2OYS8sXkX25QnNrdyKZsLOWzeSLFROcmljc2dza0c8lAO21TOkuT7v/99f+Hnft7f/ea3vM03PvgV3/jgV+VSNiqPbSGfh80b2dzIQyF3xnc+/NDPfPlnffTRR17y8cff89WvfM23v/3bDklyL5c2Ko9tbuSxbS6FzRupbJQrYmNztnmrbSoPZZvHNu9kozyxzTXbPLbNNu95o/KcSuWhvKRyTWVjY3NSLm2u2uZQOdvcqZzlxuZQeSjlQsqtPFUpj+SQ6yonIWeV7//+9/2FP/+XfPOb3/Kcb3zwq77xwa86SW6MUDnJ5kYO5Y2Qz1KFnOReyGNF8uF3fsfPfPlnffTRR675+OPv+epXvua3vv3bzra5ZnMjlTsjJ5VLmxupnOSs3MhZeV5R8nqVh3Ko2NiYW+VGzra5ZnOr3NncCKlc2uZQeaxyeM8/A5WiPLFNZfNEZZuTHMojuS4vy0N5KM9JyL08lbPK93/wA3/x537eN//P/57HvvHBr/rgb/yKh1LZCDmpnISQz1dOQh4LCTn78Du/42e+/D/wj//xP3Hp44+/56tf+Zrf+vZvOyRGZXMj5KyyzUmSykkeykM55CV5KGc5y3V52dwpijyxTWWbx4rNA5VPqvL+NpXX2KZSOck2xUa5s7lVXhQ25FblUGE2yp3Kc7apEKYyzwmzUZ4IE+Zso6icZJvCRmEOm1vlquQH3/+BP/8//Df8N/6b/3X/tX/tJ/3//tP/1N/+P/wd3/r3/i8qh20qzKFyljnMG0Nu5HMxROXOKDYqZ5tblcOH3/kd/+3/1p/1Z/+7/x3/0r/0n/P3//7v+l/9L/83/qP/6P/DkFuVQ+WwUW7kUHkqh41yI4fKpZzlbKPcyEM5y8lGUTnbqGxTOduGlDfyWE42yq3KoXLYpnJWnrVN5azykm3ed2ObyjaVwzaVS5XHKsxj5S3CHIoNeaLc2iiPhDmrvGRzq7yRmrONImyjEOZQOZmzCkPChKmczL2czNkf7A/8+q//hl//W79B3sjJVA4bFeZeDjmMfI4it3IWuary2D/6R9/1V//KL3issiE3cqncyDaVQ3IvZ+VGnkrY3Cp3yo0ctqmQbSq5V3msXFV5rco2lccqh41yIY9VXrLNY+95Y5vDNttULm3zvJQLuWabh3In9zYnIYdyZ5t7uS6H3KtUHspZhWxUcpbNC1I5hORezjZvhBySRO5scxJyqJxkc0UIIclnJ0ZICLlUIYQ8FLLNpSQ5lDubCzlUSLJ5Iy8LOSvKsypkm8phTjYvqjwvtzZneahyts1j5c7mM/OeKyqPVV5vrqm8SnnONpXnbHMvhzyWxzZ3Kmc5qdzL2+VeSHkkZ0mSVJ7KYaNCCLm0+VxUyFMhT4WQs8pZ8lDIodwIuZewTbmRp7J5I4eQs5B7IYfNncoh5KRyXV6WO+U1Ks/ZqDxnm3fxvmdsU/k8bXNWzHPCHCpPhTlUrglzss1ZuZGaSxvlVpjHcjL3cjI5ZOZemLNtzsqdZOZeTlLzVM7K5ywvy3OSS5s75UIeSk4q5KGclRs55LrNG1M5lBu5s1FOcl1elmtysnljKq9Rbgy5pvIu3vOMyuetcign8yob2zyU67K5lZNQKTZv5FLlUg4hD+WpnCUP5axyqJDNnSR5KhubG3nOR//kP/ZZ+e4/+i5CXpZrkuShVEjlsLmRh5JL2WbzjDy2uZFLlcrmjVyqnOS6vCzX5F7lUDls8xob27zWNttc855PaJuHsnlnlbPyghw2isprbFN5oJykXMhDIU9lcyGHzYWcJeReyKFyViHkLHlgVConIYSQw7e+9X/13X/0XZ+F/92v/4bHNjdCCDF3kiR5KOSs3KncS5JL2aZSboQ8FnKyUblU7pQbuZS3yTaPbd5Z5azyNhtF5TW2qVSu+ZEf8yf/skcqb1M526bcKnc2t8qztqlsTvLQRjlJubVRHgm5VLmUCxvloZCHcgg5KXe2qRzKnc2tIiQPZaOyuVXeCNmoJEnl1pBn5Pd///f9+//+/81/4b/4n/fP//N/wifxT/+Tf+qXfvEb/u1/+9cRQkjlzpCTSA6bW+VGyGMblS2HciM52aiQQ+WwUbkXkkupPJXDRrmRs5yFXJfK2Ua5Vd7INrlRznKWwzaVbQ6VSxvlTrm1UXmbymGba/rjfmIeqWxTea1tDuVTmMO8zZxtU3lorpvDhtzZptzaprJNeWTO5mwOmxtTnjFnc5in5rq5ZsaQF/3xP/7HfPGLX/Qu/uAP/sB3v/uP/eAHP/A2yTaHykN5WR5KLuWpnG1UDrmUp3LYKDdya6OEjco2ladyzeZWuZFrcpZPL4dtKm+zzTXvu2KbymtsU6ncm+dsU7m0TWWjPLRRnlN5KifzUJhyaxulwhwqh8rJ3AtzCHNjiHIj9+ahMBvlRuYwG8VGhTnbpnJvzhK5M3PNP/knH7lmm8q7SC5tiMq9PGej8sAQRrmQbSr3cqlyyKW8pNzapqKclRtTeSqPbRTljbxkozywTWWbyqWNcsWQyqfxnisqh20e2+Zsm8q7qDxWOZSnylM5bD6BnFVubchj2zy2ubdRyFN5KpWzkJRblZOQQ+WhELJ5IEmSJEmS5LHKrbluJEmSbO5slAsh14VUnihJ5V4OlXt5YN5BHkrl1iZnIYfNhRy2OdsoF/KcnFQeqxwqj5VnZJvXqlzznhdUHqucVa7ZvNo225zkkJdtQ8qtzTNCnsrG5qQcNg9UCDmrnFVCDiGHzRu5Lmcb5kbIU3lsm0OFbF4lSRLDklQSI0mSymPlTrkRQs42j+SpJBbzRgh5KnfmRpTcmAt5KOShbGNzqBw2D5Q3clY5KxdyZ/Na22zzLja3Kodt3maba953xTaVbSrvqnJvXlJ5KExO5sJGqZyEKZ9IuTNUTuawUd4Ic5KTeSo193IyD+VQQ84mzElOctimqFyqPDTkZK5LeaByaaPcyLsoN3Jdcq+8Rc42KiL3yo08lefkRsm9yqWN8gp5oFzKWR6rvE62qZQHKm9T2eax911ROVQ+uXnORnlBmCfKJ5Ntyp0Kc12Y8kiYezmZnMwhzEM5mY3yRk7mkEPmbM4qD811uZfDNpWz8lblHeRlyclGeSPPy6VyK4/lqVzaqNwpD+WxytvlXW1TeTdTPrFtrnnfFdtUPp0w15RXy8k8J8zblCvCHMJcCvNUmOeEOeRkHkq5MQ/lZA45mZzMU3lqrql89vJ2OeRe5Xm5LtflqTxWnshZPi95qvJucm/IZ+U9n5sh12we2OapkMNGPq1cl7M8FvJ2IWchZ3lsG3K2uZBLuTESQl4W8tnJSQgh5LoQkoSchWxzafOCmFshl/JQyFMhZyFnuS5vl5fkUs62ubTNS7a5l8/Se56xzWGbbc62eZ0wmyeKzZ3KdUPKizY3Ql6Ws82FnIU8lrPNjZCnQs5yY0PIWWUbQsojIScpt0JICCHmihBCCCFkcyOEEEIIISe5M1fkJCHkZHMj5KyyeSMVQu7lrJJLIWebG7kul3KyuZHr8pzNG7kmhJxsbuRSZZuzyksqL9nmsW22OWzznPe8YJvHKq+XyjXlFXLY3Mp1lWu2eU55JOQsj4WUCyFP5aySs5xV7uW6HDY3Qs5CyI2SEHJnnlV5d1EIIUlIcimkck25ketySMLmQh4rV20eyL3KJ1Fu5HVSbsxjldfJNi+pPGebl7znHWzzWdm81TaH8qJt7uWs8lTI2cY214Tc24Y8ladCzkIOIZtHQsjZ5lblXsgDcyuEJFEIOclJyK1hboSchJCEECOEkGtCXpbNFSGHsLlV3shT2TwSUrkuZ9tsXmXzjoaQx7Z5m82tyku2+aTe9w4qn0yYS+VZ21QqJzmZnMy9ykNhXham3Mi9MJfCUDkJ81BO5qEwZ2Go3JtLG5Wa5+Ws5ppcyknuRQw5y2N5I1fk9XJWuZezsI1SLuShnFXu5bFcyqXKvbyk3Mhz8nqV52wUldeofFLveaVtzrZ5d3mtymGb5+RtsrmzzVO5LuRZG3JdnsqlkEu5VDlsbuTtQgghZHMjZPOsvEYI2dwIebsQcl3OclI5bG6EPJTr8sDIyeYt8lrbPJZLIeSTqJBtPm/vewfbHCrbVN5dmNeoHLapvKsKc6i8u5yMISflJCfzUJiHcjJnOZlD7s2hctio3JvXqJxVHhrC3MtztqkcKtfldXKW56Tc2ihv5Lqc5Y3cqTwvb7NRblU+PzmrHLapfB7e8wls8662IZ9OyFnIhY3Nuwl5yeZWyGuFnG1zEnIp5FIeykMhhJxtbF4pJyHkOZsbeSqEkJdsboSc5ZqQp0KeCrm1MVfkeXmbzRu5JpdyzTaft222eRfv+xS2qbxGhfkkKg+FeaI8FebSNpVLG+WqyskcwtzYKORkngpTeSgnc5aTOeSs3Jjn5VAemWs2ygMb5apyIWfbVF6WQ7mV5+Q5levyQMmlXLNRbuRsm8pTKdeNciHPqbxdrqm8RuVdvedTqLybkJO8ZPMWIYe8TS5VHquQl+UsN8pDIU+FXJfHcmOEnIWQ1wshhBwq5FK5kJMQQsilylMhhOQk5JqQxzY3Qp4KuRRyKc8pN3Kp8q7KZ2zOtvlheM8/E2FeUq7a5pqQG5vr8jo529za5rANOQu5JteFPBVCyKHcCXljQwghlzZvkXshhBByks2tza3NFSGEHELISR4LIdelcs3midzb3MjL8hqbW9vc2pzlsXyWKtds85Jttnmt9/wzsM1zNi+qHLa5qjwvr5ONcqtyqJzkUq4JuWZzI9dsQwi5FCq5sbkXQion+TQ2yq1yq0IIIWc5yXNCyDbP2TwjpHJrc8hDlZflNTYqh8qtcshjeRebZ23zksphm7NtttnmXb3nh2ibQ4WQx8qrVE5y2NzKjZEbm8c2r1J5WS6FXJOzza3KScilykMhj1VCyI1N3piTuRFCiLkRchJyEkIqJyHkkJMQQk5yTchhm0PlqZDKQyGPVXJvcyOHbQ6bR7LNy0Iq1+RSyGttbpVnpPIalc/Ce36IKg/NYXNr8yrbHLY5K3eKuVEeq5DNK4Q8L+TtQspVmxvZvCDksLm1uVM5hEpulDxSbm3IvTyVnISc5G1CyKXKQyGbW9s8lKvm1uaNVM4qh/JGyKFy2OapvCRnIe+qXLW5kW1eY5vDNp/We35ItjnbhiGHyqG8SuVQOcljuW6bQ4W8xuYtQkjIU9uQw+aByqFCyPNSIRXynJyEkBubUAkhhBBCyBvzjJyEEHLN5s7mRs4qh8q9PBZCuVUhL8ulbQ6VVxu5NO9qc2fzQOVQeY3KofJpvedT2Oa1KmcVcm8+rc2NXMpTlYfyNhVC3i6HEHJSOUmFvCyEvF02N0JOck3lXZUbIYSQk7xGhZDK80Iey2O5tHkk5LHKdXlWHsm7KnfKjZzk09jm03jPp7TNNtts81rbfFrbnFWuyRWbTy5nm1ubR/JYHtqGvE5Ocmlzp3IvJyGEkMPmRgg5CSEnIYRcs7m1uSLkJI9tLoSQx0LOQshhm7NyIS/ZvJNcytk2h23e1TbkXW2zzTbbfFrv+SHa5qxyks2NnG2e2OaxylMhl/JIsdlmG3LYvFI2yq1yRcghb8ydykk2N3K2eWJzIaTy7lLZZpttyGGbk7zNRrlV3ggh93K2uVPeyDYPbELubZ6oPBTyNsXGxuZGbm0ey6WcbVM5VF5jc6dyts2lbR7b5vPwvh+iyjWVS+WBjcq7CXMW5o2h5FJqDhvlRZWT2ShvVe7MvcpJDuXGnG1UTvJQHhrCPGej8ljlsFFeVDnbpvI25UYeq1yqXNqoPC/vYqPyRLk1yiO5VDnbpvI25cKQQ+VS5dI2lc/De/4Z2uahXFOetc0125AH5iTPyKG8yjakvCCEkLPc2DwvhJRnbfNQDpsbIYRsbpUbIeSxciP3Qgghh20OlbcLeWBzFkIuhVSes7lqm8c2t8rL8kiu2eZQeXfZ5jUqn5f3fMa2ea3KYZttTrJ5tcrZNmeVkxw2irxNCHmbykkIebucVXJjY3Nn81DINZWzzZ3KpW0qhDwUQgg5CXlO5XkhhFxTyY2xubO5kbdL5Wybs8qljXIj5CW5lOdUPrmpHLbZ5mybH5b3fQ62uVR5SeVShTnbKFdtUzlUrku5MYcwr5GTeb2czPPCEKZyNlTmwkYhj21TbpVnVT4/ea08VS6kPLBRLuRsm8qh8pzKa+RSfhgqlyqX/rPy4AVLbS0BYKDEmf1vWcPFbTDGBkM+r5NUVaj8Cie+LQEpUHaprFVsk+JCQI6S98lzMpElmQjIWYCyRwUEZCLFmYCALBU/QG4EBOQIAdkjICBrBcqCLKmsFStyVeyRmYD8WnJEhcqvcuI/VDGr2KIcUjFT2RbKh+RdxZnsqZhIsUlBQF4oQAaVewICogICAgIyERAQEBAQkIlMBOSQQEDWBKQ4k6Fii3ImICB7iivli4DcUbbIz1dsEJChYlaxReVXOvEfUpmpbJNnCgpUXpOXCgqKRzIUuypmKhPZojJTAQEBAVkTkJWCAuVzclVQUNzInWJJQL4EAgLKioDMVGYqjwTkmYoC5YtM5Ci5Kaio2FOxp7hSVmRJZabySsXP9j9+gwqVzwnEFuVOhcqeApUKBZnEF+U50dijslahMonj5F4MsqAsFSh3YqFAoUB5oLyiskXO5IvMKlSOk6NUliqUfQECgbIiyksqe5QHBcq39D++oYpBZalAeVCgXKg8ozKoQMwE4iiBWCpQDpB7sVYxqCwVqNzEUKBcKA9kQblQfg6BKFDO5HMyVAwqSxUqawXKmSjPCXImK/IjCpSfomJQqfiVTvwGKnsq1lRU7onKFuVtFSAgV4EcJSDFmSi7VPYUD1RU1lTuCYgKCAgICAgIyJbiQXGATASkAkQFZIvKnuJMQGYqKmsqW1RAXpGbYkGGincVF8oOUc5kS8WaikrFr3biN6uYVagMFcfIM8UhKhUTAVEmgYC8pjKRLRVLFbMKFZDiTH5UxSMBAQEBUSjOBAREBaQ4ExAQEBCQicxUninuFF+kQGWo+IzcKZ6RiUJxJjOVoeIo5akKkFnFrEJlqPgvnPjNVGYqM5Wlin3yM6hsUa7ktYqJrKksqcxUZioTGYpfTFS2qLyj2KV8ERAVkEFlprJU8ZocJWuiskXlHcUGAVFZUpmpzFSWKn6HE79BxbtUnpNXCoo3CAgIyExAQLbJkoDMig+ICggIyHEyKyj+AwICUpzJu1QeCQgIyEsBgazJ71LxCZXf4cRvUlFRUfFMxZaKimeUi+JC2VXxnIAsyZe4UR4JyCcqHklBcSYgIDcyKBfFhbKr+FjxRVRAQEB+VLEiIBUVTykXcaHsqvhUcaUsCMiPqPhd/sc3pLJF5Z7MKpQr5SWVPRUqE4GYCSSHqEziKJUtKo9kqFCZKSuxpuwqUM5ki3KIyruUBZmp7AqQK2VBIECWVPZUqOxRNsgkQAaVd6n8Lif+IBVrFRUqs+Ki+JjKPVkSkBvZUFRMBORHVKxVVKjMKoaKGwGZCAgICAgICAiICsiPqKj4jIDcKR4UBAryJS6KLwHyDpX3yI0MFRXf2Yk/iErFmsqScqEcUnGcLAnIRFYUuakAAQEBATlKpWJNZUllUHkkaxW/ggrIrHhCQEBANikU9wS5ElDORDkTkGcqPicgW1SWKr6bE99MxVLFksqSyo18QmWomFU8EohnBGRBmalsk1lxp7ijsqTyo1SGilnFz6BcKTtkVnGnuKPMBBRkSW7kCJWhYlb8FCozlVcqhorf4cQ3UqEyVAwqs4qKtYqfQWWmMqu4EZBZcSazggI5izdIgcpQXChXBcWD4qdQmanMKvYUdwqKi2KHTARkVqFyUVwoVwGBgNwUZwIykU+ozJSrYlfFUkXFUHFURcVQ8buc+EZUZipDxUxFpWKfFB+rWKpQeSSDykRABoUA5UJAzuIplYmogBRXCgrFU8XHijsVKnuUB8qF8kVAijOZyJrKlXJRzBQUigVZq/hUcadAWZGJqKypDCpLFd/NiT+QypLKksqnVJZU9smaciETgWIiHxKQiaiAzJQ7yseUOyqvCQiICggICEjFoPI+EZAb5UxABpUllU8pd5Qvck+2qKxVDCrfzYlvqGKoUPmMDMXHKmYVs4pZxT0BWVIuBOSA4qJQuZF7AjIREBCQWfGx4qo4k6E4E5DiJZW3xCRQFmQiR1V8qriqABkqZhWvqHxXJ/4jFXtUBpWh4jOifEyluFAZKlRmKtsEBKT4IheBPKFcKBfFc/JIQFRAQEBAQEBAQEBAQEBAQFSKM1EZClRmKi8Vd4o1AQEBBQHlovgSIO9Q+ZRCcaEyFKjMVF6pWKpYqvivnPgPVVRUVOxRmVW8R0DeUVwpd1Q+IxUgCgUCciM7lKviV6uYqSypfCwmCnEhIDPZogICUvGrFVfKlxhUPlUxq6io+C+d+MOoHFFxT0Am8oyyq2Kt4hmVQWWmXAnIREAmskE5pPiUyq7iQfGUMijIREG2CMhEQJZUjqj4lHIm92SoWKt4RmVQ+W5O/GEqjlDZJhUgRxR3VNZU3lGcCcgemQgICMhZPCVflF3FYcUd5YEiICATAQGZyEIsyETuyZaKI1T2FDsEBGQixR2VNZU/1Yk/RMWg8q6KJRWIR7KmbCouKtYq9lSo3AgICMie4kJBQEC2CQjIl7ijskU2KJsCOQtkkKu4IzcFypmATOSVikHlXcUdZYNsUQFZqxgq1ir2VHwnJ76RiootKksVR6k8kllxUXGUcqGypjJUrKk8JyAgICAgKiATKS4EBATkkYCCgIBMBATkLC4KBAQEBAQEBAQEBJQLZUFAVECKMwGZiArIu1SWisOUp4qLiqNUBpU1laFiVvEdnfiGKioqtlSorFVsqVirmCkUqGwpKK6KlypU1irWKo6TChWQpWJBZsWKFFcKBCpbCoovUiwIyFqFyo0MFWsV7yhQHhSbihUprlQqVLZUVMwqXqlQqagYKr6bE3+QikFlVjFTWaoYVNZUllQgQNYUlLeobFGpqKgYVJYqtlQMKrPiTECUMwEZigvlTCYyqICAgKhAgICAgICoqIDcCMgelS0qFRUVg8pSxZbiQrkqrpQ7xYWyEipLKntUVN6h8if4H38QlQqVmcrnZBITmcgkfgWVPRUqFSpLKhUqM5UbeSQ38pz8Dip7KlQqVJYUCpQr5SB5JP+6E99cxZLKnoollVcqQLbJUnGhXBUXxZ2C4pCKmcqgMlQsqeypWFJ5peKoikFlVjFULFVUHFFcqQwqQ3FH2VXcUb7InoqjKgaVWcVQsVRR8d2d+ENUvKLyTEXFksqsYlaxpjxQNikoh6gUm1SGildUnqmoWFKZVcwq1lTWVLaoqByhUGxSLoqXlA0yq6hYUplVzCrWVNZU/mT/4w9QMVTsUXlF5RmVoUJlqUDZpSwIxFqBskm5KlDuqMwKlLepPKMyVKgsVajsUXmlQNmkXBUod5SrAuUJgQBZUnlGZahQWapQmVWsVfxpTvxlKj5RMVO5kUEFBAQE5EZuZCJryiHKrgJlV8UnKmYqayo/SjlE2VWgAgJyT4qzAHlHxUxlTeVv9D/+MiqvVMxUBpWlCpWJbBOIiTySm1grrpRDlKdUXimulAuVpQLllyqulANEWQiQJZVXKmYqg8pShcrf7sQ/oGJNRaVii8oxcoyAgExEuVAuikMKisOKBwoKxSbll1MulItiQUBAQEBmFRUgR1SsqahUbFH5F5z4S1TMKmYVayozlU9UrFUcIxNRrpSXChRUjihQ7ihXykeKB8XblCvli+ypUFE5okJlSWWmsqdiS8Xf4sRfpKJiqKiYVVQsVXxKZVaxpaLimeKioHhQ3FEuKl4TZVexQ54T5arYVFA8VVwUFGeyVLGkMlQcobKnYq2iomKoqKioqPibnPgHVQwqQ8WsYqg4SqViTUXlGRUQFZWJgAwqICAgM5WhOJOJgExkIiBLxYXKUHyR4qJYkZsAAQFRKFZERTkTEJCJzJQLFZU1lS0qQ8W7KgaVoeJfdeIfpDJUDCozlUHliIpBReWVirWKoQLkRiruCchEVCYyCZBHAgKiAlIBogICoTKogICATAQEZFYBoqICAnIjS8UXAQEpLirWKp5ReZfKUDGo/KtO/MNUhootFWsVswqVd6isqQwqayp7Kh7JUSpDxUSWKtYqZhUq71BZUxlU1lT2VPwIlaHiX3XiH1NRUVFRoTJUVMxUKoaKQaWiQmVLxVEVFe+oGFSGindVVAwqQ8WSyprKTGVLxVEVFe+oGFSGirWKWUXFUkVFhcpQ8a/5P4ZjI8kSYzLZAAAAAElFTkSuQmCC",
        "universalLink": "https://www.naan.app/",
        "deepLink": "naan://"
    },
    {
        "key": "altme_wallet",
        "name": "Altme Wallet",
        "shortName": "Altme",
        "color": "",
        "logo": "data:image/png;base64,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",
        "universalLink": "https://app.altme.io/app/download"
    },
    {
        "key": "temple_ios",
        "name": "Temple Wallet",
        "shortName": "Temple",
        "color": "",
        "logo": "data:image/png;base64,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",
        "universalLink": "https://templewallet.com",
        "deepLink": "temple://"
    },
    {
        "key": "atomex_ios",
        "name": "Atomex Wallet",
        "shortName": "Atomex",
        "color": "",
        "logo": "data:image/png;base64,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",
        "universalLink": "https://atomex.me",
        "deepLink": "atomex://"
    },
    {
        "key": "umami_ios",
        "name": "Umami Mobile",
        "shortName": "Umami Mobile",
        "color": "",
        "logo": "data:image/png;base64,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",
        "deepLink": "umami://",
        "universalLink": "https://umamiwallet.com/"
    },
    {
        "key": "trust_ios",
        "name": "Trust Wallet",
        "shortName": "Trust Wallet",
        "color": "",
        "supportedInteractionStandards": [
            "wallet_connect"
        ],
        "logo": "data:image/png;base64,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",
        "universalLink": "https://link.trustwallet.com",
        "deepLink": "trust://"
    },
    {
        "key": "exodus_mobile",
        "name": "Exodus Mobile",
        "shortName": "Exodus",
        "color": "",
        "logo": "data:image/svg+xml;base64,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",
        "supportedInteractionStandards": [
            "beacon"
        ],
        "deepLink": "exodus://wc",
        "universalLink": "https://www.exodus.com/"
    },
    {
        "key": "kukai_ios",
        "name": "Kukai Wallet",
        "shortName": "Kukai",
        "color": "",
        "logo": "data:image/png;base64,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",
        "supportedInteractionStandards": [
            "wallet_connect"
        ],
        "universalLink": "https://wallet.kukai.app",
        "deepLink": "kukai://"
    },
    {
        "key": "fireblocks_ios",
        "name": "Fireblocks Wallet",
        "shortName": "Fireblocks",
        "color": "",
        "logo": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTAwMHB4IiBoZWlnaHQ9IjEwMDBweCIgdmlld0JveD0iMCAwIDExMiAxMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+RmlyZUJsb2NrcyBOYXZ5PC90aXRsZT4KICAgIDxnIGlkPSJGaXJlQmxvY2tzLU5hdnkiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCcmFuZC9Mb2dvbWFyayIgZmlsbD0iIzAwMkU3RiI+CiAgICAgICAgICAgIDxnIGlkPSJCcmFuZC9CcmFuZG1hcmsvTmF2eSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTEyLDAgQzExMi41NTIyODUsMS40NTI4NTkxN2UtMTUgMTEzLDAuNDQ3NzE1MjUgMTEzLDEgTDExMywxIEwxMTMsMTEyIEMxMTMsMTEyLjU1MjI4NSAxMTIuNTUyMjg1LDExMyAxMTIsMTEzIEwxMTIsMTEzIEwxLDExMyBDMC40NDc3MTUyNSwxMTMgNi43NjM1Mzc1MWUtMTcsMTEyLjU1MjI4NSAwLDExMiBMMCwxMTIgTDAsMSBDMS40ODY2NzY4NmUtMTUsMC40NDc3MTUyNSAwLjQ0NzcxNTI1LDEuMDE0NTMwNjNlLTE2IDEsMCBMMSwwIFogTTU2LjQ5OTc0ODksMzEuMzg4ODg4OSBMMjUuMTEwODYsODEuNjExMTExMSBMODcuODg4NjM3OCw4MS42MTExMTExIEw1Ni40OTk3NDg5LDMxLjM4ODg4ODkgWiIgaWQ9IkJyYW5kL0JyYW5kbWFyayI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=",
        "supportedInteractionStandards": [
            "wallet_connect"
        ],
        "universalLink": ""
    }
];


class $c6d4d26512d02780$export$25b1aae6885104d {
    identifier = 'xtz';
    async validateRequest(input) {
        // TODO: Validation
        if (input) return;
    }
    async handleResponse(input) {
        // TODO: Validation
        if (input) return;
    }
    async getWalletLists() {
        return {
            extensionList: (0, $77338d64a5d1a34a$export$2652dcafe1aa06b5),
            desktopList: (0, $77338d64a5d1a34a$export$1b66ea3649c0f3c0),
            webList: (0, $77338d64a5d1a34a$export$482b29556b4c8861),
            iOSList: (0, $77338d64a5d1a34a$export$43a4877758441693)
        };
    }
    async getAccountInfosFromPermissionResponse(_permissionResponse) {
        return [
            {
                accountId: '',
                address: '',
                publicKey: ''
            }
        ];
    }
}





















class $77fa9b38024b01e5$export$645e36332148f90e extends (0, $3d81b3dc1d4c3571$export$f05ea4a0ac7b2e6c) {
    constructor(name, keyPair, storage, matrixNodes, iconUrl, appUrl){
        super(name, keyPair, storage, matrixNodes, (0, $8d1a6d1de5294bad$export$2fdc5139b636713c).TRANSPORT_P2P_PEERS_WALLET, iconUrl, appUrl);
    }
    async addPeer(newPeer, sendPairingResponse = true) {
        await super.addPeer(newPeer);
        if (sendPairingResponse) await this.client.sendPairingResponse(newPeer); // TODO: Should we have a confirmation here?
    }
}




const $53ff408192fff904$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('IncomingRequestInterceptor');
class $53ff408192fff904$export$15cdfadf33eea84e {
    /**
     * The method that is called during the interception
     *
     * @param config
     */ static async intercept(config) {
        $53ff408192fff904$var$logger.log('INTERCEPTING REQUEST', config.message);
        if (config.message.version === '2') $53ff408192fff904$export$15cdfadf33eea84e.handleV2Message(config);
        else if (config.message.version === '3') $53ff408192fff904$export$15cdfadf33eea84e.handleV3Message(config);
    }
    static async getAppMetadata(appMetadataManager, senderId) {
        const appMetadata = await appMetadataManager.getAppMetadata(senderId);
        if (!appMetadata) throw new Error('AppMetadata not found');
        return appMetadata;
    }
    static async handleV2Message(config) {
        const { message: message, connectionInfo: connectionInfo, appMetadataManager: appMetadataManager, interceptorCallback: interceptorCallback } = config;
        switch(message.type){
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest:
                {
                    $53ff408192fff904$var$logger.log('PERMISSION REQUEST V*', message);
                    // TODO: Remove v1 compatibility in later version
                    if (message.appMetadata.beaconId && !message.appMetadata.senderId) {
                        message.appMetadata.senderId = message.appMetadata.beaconId;
                        delete message.appMetadata.beaconId;
                    }
                    await appMetadataManager.addAppMetadata(message.appMetadata);
                    const request = message;
                    interceptorCallback(request, connectionInfo);
                }
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).OperationRequest:
                {
                    const appMetadata = await $53ff408192fff904$export$15cdfadf33eea84e.getAppMetadata(appMetadataManager, message.senderId);
                    const request = {
                        appMetadata: appMetadata,
                        ...message
                    };
                    interceptorCallback(request, connectionInfo);
                }
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SignPayloadRequest:
                {
                    const appMetadata = await $53ff408192fff904$export$15cdfadf33eea84e.getAppMetadata(appMetadataManager, message.senderId);
                    const request = {
                        appMetadata: appMetadata,
                        ...message
                    };
                    interceptorCallback(request, connectionInfo);
                }
                break;
            // TODO: ENCRYPTION
            // case BeaconMessageType.EncryptPayloadRequest:
            //   {
            //     const appMetadata: AppMetadata = await IncomingRequestInterceptor.getAppMetadata(
            //       appMetadataManager,
            //       message.senderId
            //     )
            //     const request: EncryptPayloadRequestOutput = {
            //       appMetadata,
            //       ...message
            //     }
            //     interceptorCallback(request, connectionInfo)
            //   }
            //   break
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BroadcastRequest:
                {
                    const appMetadata = await $53ff408192fff904$export$15cdfadf33eea84e.getAppMetadata(appMetadataManager, message.senderId);
                    const request = {
                        appMetadata: appMetadata,
                        ...message
                    };
                    interceptorCallback(request, connectionInfo);
                }
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).ProofOfEventChallengeRequest:
                {
                    const appMetadata = await $53ff408192fff904$export$15cdfadf33eea84e.getAppMetadata(appMetadataManager, message.senderId);
                    const request = {
                        appMetadata: appMetadata,
                        ...message
                    };
                    interceptorCallback(request, connectionInfo);
                }
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SimulatedProofOfEventChallengeRequest:
                {
                    const appMetadata = await $53ff408192fff904$export$15cdfadf33eea84e.getAppMetadata(appMetadataManager, message.senderId);
                    const request = {
                        appMetadata: appMetadata,
                        ...message
                    };
                    interceptorCallback(request, connectionInfo);
                }
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SimulatedProofOfEventChallengeRequest:
                {
                    const appMetadata = await $53ff408192fff904$export$15cdfadf33eea84e.getAppMetadata(appMetadataManager, message.senderId);
                    const request = {
                        appMetadata: appMetadata,
                        ...message
                    };
                    interceptorCallback(request, connectionInfo);
                }
                break;
            default:
                $53ff408192fff904$var$logger.log('intercept', 'Message not handled');
                $53ff408192fff904$var$assertNever(message);
        }
    }
    static async handleV3Message(config) {
        const { message: msg, connectionInfo: connectionInfo, appMetadataManager: appMetadataManager, interceptorCallback: interceptorCallback } = config;
        const wrappedMessage = msg; /* TODO: Remove any */ 
        const v3Message = wrappedMessage.message;
        switch(v3Message.type){
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionRequest:
                {
                    await appMetadataManager.addAppMetadata({
                        ...v3Message.blockchainData.appMetadata,
                        senderId: msg.senderId
                    }); // Make sure we use the actual senderId, not what the dApp told us
                    const request /* PermissionRequestOutput */  = wrappedMessage;
                    interceptorCallback(request, connectionInfo);
                }
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BlockchainRequest:
                {
                    // const appMetadata: AppMetadata = await IncomingRequestInterceptor.getAppMetadata(
                    //   appMetadataManager,
                    //   msg.senderId
                    // )
                    const request /* BeaconMessageWrapper<BlockchainRequestV3<string>> */  = {
                        ...wrappedMessage
                    };
                    interceptorCallback(request, connectionInfo);
                }
                break;
            default:
                $53ff408192fff904$var$logger.log('intercept', 'Message not handled');
                $53ff408192fff904$var$assertNever(v3Message);
        }
    }
}
function $53ff408192fff904$var$assertNever(_message) {
    throw new Error('Function not implemented.');
}





const $db06c54928cd0f1d$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('OutgoingResponseInterceptor');
class $db06c54928cd0f1d$export$7afb4f12c2d962e8 {
    static async intercept(config) {
        if (config.request.version === '2') $db06c54928cd0f1d$export$7afb4f12c2d962e8.handleV2Message(config);
        else if (config.request.version === '3') $db06c54928cd0f1d$export$7afb4f12c2d962e8.handleV3Message(config);
    }
    static async handleV3Message(config) {
        const { // senderId,
        // request,
        message: msg, appMetadataManager: // ownAppMetadata,
        // permissionManager,
        appMetadataManager, interceptorCallback: interceptorCallback } = config;
        const wrappedMessage = msg;
        const v3Message = wrappedMessage.message;
        $db06c54928cd0f1d$var$logger.log('LOGGING OUTGOING V3', v3Message, appMetadataManager);
        interceptorCallback(msg);
    // switch (v3Message.type) {
    //   case BeaconMessageType.PermissionResponse:
    //     {
    //       const response: PermissionResponse = {
    //         senderId,
    //         version: BEACON_VERSION,
    //         appMetadata: ownAppMetadata,
    //         ...msg
    //       }
    //       const publicKey = response.publicKey
    //       const address: string = await getAddressFromPublicKey(publicKey)
    //       const appMetadata = await appMetadataManager.getAppMetadata(request.senderId)
    //       if (!appMetadata) {
    //         throw new Error('AppMetadata not found')
    //       }
    //       const permission: PermissionInfo = {
    //         accountIdentifier: await getAccountIdentifier(address, response.network),
    //         senderId: request.senderId,
    //         appMetadata,
    //         website: '',
    //         address,
    //         publicKey,
    //         network: response.network,
    //         scopes: response.scopes,
    //         connectedAt: new Date().getTime()
    //       }
    //       permissionManager.addPermission(permission).catch(console.error)
    //       interceptorCallback(response)
    //     }
    //     break
    //   case BeaconMessageType.BlockchainResponse:
    //     {
    //       // const appMetadata: AppMetadata = await IncomingRequestInterceptor.getAppMetadata(
    //       //   appMetadataManager,
    //       //   msg.senderId
    //       // )
    //       const request: any /* BeaconMessageWrapper<BlockchainRequestV3<string>> */ = {
    //         ...wrappedMessage
    //       }
    //       interceptorCallback(request)
    //     }
    //     break
    //   default:
    //     logger.log('intercept', 'Message not handled')
    //     assertNever(v3Message)
    // }
    }
    static async handleV2Message(config) {
        const { senderId: senderId, request: request, message: message, ownAppMetadata: ownAppMetadata, permissionManager: permissionManager, appMetadataManager: appMetadataManager, interceptorCallback: interceptorCallback } = config;
        switch(message.type){
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Error:
                {
                    const response = {
                        type: message.type,
                        version: '2',
                        senderId: senderId,
                        id: message.id,
                        errorType: message.errorType
                    };
                    if (message.errorType === (0, $3402b71e229a176a$export$de39e3c3d623b630).TRANSACTION_INVALID_ERROR && message.errorData) {
                        const errorData = message.errorData;
                        // Check if error data is in correct format
                        if (Array.isArray(errorData) && errorData.every((item)=>Boolean(item.kind) && Boolean(item.id))) response.errorData = message.errorData;
                        else $db06c54928cd0f1d$var$logger.warn('ErrorData provided is not in correct format. It needs to be an array of RPC errors. It will not be included in the message sent to the dApp');
                    }
                    interceptorCallback(response);
                    break;
                }
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Acknowledge:
                {
                    const response = {
                        type: message.type,
                        version: '2',
                        senderId: senderId,
                        id: message.id
                    };
                    interceptorCallback(response);
                    break;
                }
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).PermissionResponse:
                {
                    const response = {
                        senderId: senderId,
                        version: '2',
                        appMetadata: ownAppMetadata,
                        ...message
                    };
                    if (!response.address && !response.publicKey) throw new Error('Address or PublicKey must be defined');
                    const publicKey = response.publicKey;
                    const address = response.address ?? await (0, $efd1a952be4e6fd9$export$a28ea21350b9dd16)(publicKey);
                    if (!(0, $efd1a952be4e6fd9$export$1987372119294ebb)(address)) throw new Error(`Invalid address: "${address}"`);
                    if (message.walletType === 'abstracted_account' && address.substring(0, 3) !== (0, $15a40981d98388e5$export$f3c76c19efc1480d)) throw new Error(`Invalid abstracted account address "${address}", it should be a ${(0, $15a40981d98388e5$export$f3c76c19efc1480d)} address`);
                    const appMetadata = await appMetadataManager.getAppMetadata(request.senderId);
                    if (!appMetadata) throw new Error('AppMetadata not found');
                    const permission = {
                        accountIdentifier: await (0, $707e3c5710107d55$export$f481d8b6bb80ca4a)(address, response.network),
                        senderId: request.senderId,
                        appMetadata: appMetadata,
                        website: '',
                        address: address,
                        publicKey: publicKey,
                        network: response.network,
                        scopes: response.scopes,
                        connectedAt: new Date().getTime()
                    };
                    permissionManager.addPermission(permission).catch(console.error);
                    interceptorCallback(response);
                    break;
                }
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).OperationResponse:
                {
                    const response = {
                        senderId: senderId,
                        version: '2',
                        ...message
                    };
                    interceptorCallback(response);
                }
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SignPayloadResponse:
                {
                    const response = {
                        senderId: senderId,
                        version: '2',
                        ...message
                    };
                    interceptorCallback(response);
                }
                break;
            // TODO: ENCRYPTION
            // case BeaconMessageType.EncryptPayloadResponse:
            //   {
            //     const response: EncryptPayloadResponse = {
            //       senderId,
            //       version: BEACON_VERSION,
            //       ...message
            //     }
            //     interceptorCallback(response)
            //   }
            //   break
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).BroadcastResponse:
                {
                    const response = {
                        senderId: senderId,
                        version: '2',
                        ...message
                    };
                    interceptorCallback(response);
                }
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).ProofOfEventChallengeResponse:
                {
                    const response = {
                        senderId: senderId,
                        version: '2',
                        ...message
                    };
                    interceptorCallback(response);
                }
                break;
            case (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).SimulatedProofOfEventChallengeResponse:
                {
                    const response = {
                        senderId: senderId,
                        version: '2',
                        ...message
                    };
                    interceptorCallback(response);
                }
                break;
            default:
                $db06c54928cd0f1d$var$logger.log('intercept', 'Message not handled');
                $db06c54928cd0f1d$var$assertNever(message);
        }
    }
}
function $db06c54928cd0f1d$var$assertNever(_message) {
    throw new Error('Function not implemented.');
}


const $4a5ef195806cd8a5$var$logger = new (0, $0b40dc7ca94909f1$export$efa9a398d6368992)('WalletClient');
class $4a5ef195806cd8a5$export$976775218d45df24 extends (0, $a9ae2c45e15f00d9$export$1f2bb630327ac4b6) {
    /**
     * Returns whether or not the transport is connected
     */ _isConnected = new (0, $247a3319916bcc85$export$babe85162c870d79)();
    get isConnected() {
        return this._isConnected.promise;
    }
    permissionManager;
    appMetadataManager;
    /**
     * This array stores pending requests, meaning requests we received and have not yet handled / sent a response.
     */ pendingRequests = [];
    constructor(config){
        super({
            storage: config && config.storage ? config.storage : new (0, $59e826bfd354e77a$export$19fffca37ef3e106)(),
            ...config
        });
        this.permissionManager = new (0, $6fdebab29f931b92$export$46a505c858cc753)(this.storage);
        this.appMetadataManager = new (0, $8f0d28279074bcb8$export$50a53e4bf19e8f0f)(this.storage);
    }
    async init() {
        const keyPair = await this.keyPair; // We wait for keypair here so the P2P Transport creation is not delayed and causing issues
        const p2pTransport = new (0, $77fa9b38024b01e5$export$645e36332148f90e)(this.name, keyPair, this.storage, this.matrixNodes, this.iconUrl, this.appUrl);
        return super.init(p2pTransport);
    }
    /**
     * This method initiates a connection to the P2P network and registers a callback that will be called
     * whenever a message is received.
     *
     * @param newMessageCallback The callback that will be invoked for every message the transport receives.
     */ async connect(newMessageCallback) {
        this.handleResponse = async (message, connectionContext)=>{
            if (message.version === '3') {
                const typedMessage = message;
                if (typedMessage.message.type === (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Disconnect) return this.disconnect(typedMessage.senderId);
                if (!this.pendingRequests.some((request)=>request[0].id === message.id)) {
                    this.pendingRequests.push([
                        typedMessage,
                        connectionContext
                    ]);
                    await this.sendAcknowledgeResponse(typedMessage, connectionContext);
                    await (0, $53ff408192fff904$export$15cdfadf33eea84e).intercept({
                        message: typedMessage,
                        connectionInfo: connectionContext,
                        appMetadataManager: this.appMetadataManager,
                        interceptorCallback: newMessageCallback
                    });
                }
            } else {
                const typedMessage = message;
                if (typedMessage.type === (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Disconnect) return this.disconnect(typedMessage.senderId);
                if (!this.pendingRequests.some((request)=>request[0].id === message.id)) {
                    this.pendingRequests.push([
                        typedMessage,
                        connectionContext
                    ]);
                    if (typedMessage.version !== '1') await this.sendAcknowledgeResponse(typedMessage, connectionContext);
                    await (0, $53ff408192fff904$export$15cdfadf33eea84e).intercept({
                        message: typedMessage,
                        connectionInfo: connectionContext,
                        appMetadataManager: this.appMetadataManager,
                        interceptorCallback: newMessageCallback
                    });
                }
            }
        };
        return this._connect();
    }
    async getRegisterPushChallenge(backendUrl, accountPublicKey, oracleUrl = (0, $217f751cff903b1b$export$868c67dc8134ff07)) {
        // Check if account is already registered
        const challenge = (await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${oracleUrl}/challenge`)).data;
        const constructedString = [
            'Tezos Signed Message: ',
            challenge.id,
            challenge.timestamp,
            accountPublicKey,
            backendUrl
        ].join(' ');
        const bytes = (0, $efd1a952be4e6fd9$export$7ea66e3774a60b67)(constructedString);
        const payloadBytes = "0501" + bytes.length.toString(16).padStart(8, '0') + bytes;
        return {
            challenge: challenge,
            payloadToSign: payloadBytes
        };
    }
    async registerPush(challenge, signature, backendUrl, accountPublicKey, protocolIdentifier, deviceId, oracleUrl = (0, $217f751cff903b1b$export$868c67dc8134ff07)) {
        const tokens = await this.storage.get((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).PUSH_TOKENS);
        const token = tokens.find((el)=>el.publicKey === accountPublicKey && el.backendUrl === backendUrl);
        if (token) return token;
        const register = (await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${oracleUrl}/register`, {
            name: this.name,
            challenge: challenge,
            accountPublicKey: accountPublicKey,
            signature: signature,
            backendUrl: backendUrl,
            protocolIdentifier: protocolIdentifier,
            deviceId: deviceId
        })).data;
        const newToken = {
            publicKey: accountPublicKey,
            backendUrl: backendUrl,
            accessToken: register.accessToken,
            managementToken: register.managementToken
        };
        tokens.push(newToken);
        await this.storage.set((0, $8d1a6d1de5294bad$export$2fdc5139b636713c).PUSH_TOKENS, tokens);
        return newToken;
    }
    /**
     * The method will attempt to initiate a connection using the active transport.
     */ async _connect(attempts = 3) {
        const transport = await this.transport;
        if (attempts == 0 || transport.connectionStatus !== (0, $6526b1c1da97cb73$export$da8d660a2cd6a8c0).NOT_CONNECTED) return;
        try {
            await transport.connect();
        } catch (err) {
            $4a5ef195806cd8a5$var$logger.warn('_connect', err.message);
            await transport.disconnect();
            await this._connect(--attempts);
            return;
        }
        transport.addListener(async (message, connectionInfo)=>{
            if (typeof message === 'string') {
                const deserializedMessage = await new (0, $33b837e22eef79cd$export$ef852775387a0be7)().deserialize(message);
                this.handleResponse(deserializedMessage, connectionInfo);
            }
        }).catch((error)=>$4a5ef195806cd8a5$var$logger.log('_connect', error));
        this._isConnected.resolve(true);
    }
    /**
     * This method sends a response for a specific request back to the DApp
     *
     * @param message The BeaconResponseMessage that will be sent back to the DApp
     */ async respond(message) {
        $4a5ef195806cd8a5$var$logger.log('RESPONSE', message);
        const request = this.pendingRequests.find((pendingRequest)=>pendingRequest[0].id === message.id);
        if (!request) throw new Error('No matching request found!');
        this.pendingRequests = this.pendingRequests.filter((pendingRequest)=>pendingRequest[0].id !== message.id);
        await (0, $db06c54928cd0f1d$export$7afb4f12c2d962e8).intercept({
            senderId: await (0, $1c5c036caa7dc2d6$export$c00969587a4639cc)(await this.beaconId),
            request: request[0],
            message: message,
            ownAppMetadata: await this.getOwnAppMetadata(),
            permissionManager: this.permissionManager,
            appMetadataManager: this.appMetadataManager,
            interceptorCallback: async (response)=>{
                await this.respondToMessage(response, request[1]);
            }
        });
    }
    async getAppMetadataList() {
        return this.appMetadataManager.getAppMetadataList();
    }
    async getAppMetadata(senderId) {
        return this.appMetadataManager.getAppMetadata(senderId);
    }
    async removeAppMetadata(senderId) {
        return this.appMetadataManager.removeAppMetadata(senderId);
    }
    async removeAllAppMetadata() {
        return this.appMetadataManager.removeAllAppMetadata();
    }
    async getPermissions() {
        return this.permissionManager.getPermissions();
    }
    async getPermission(accountIdentifier) {
        return this.permissionManager.getPermission(accountIdentifier);
    }
    async removePermission(accountIdentifier, senderId) {
        return this.permissionManager.removePermission(accountIdentifier, senderId);
    }
    async removeAllPermissions() {
        return this.permissionManager.removeAllPermissions();
    }
    async getPeerInfo(peer) {
        const senderId = await (0, $1c5c036caa7dc2d6$export$c00969587a4639cc)(peer.publicKey);
        if (peer instanceof (0, $ce56bdceace47856$export$556bd87f142daf0c)) return new (0, $ce56bdceace47856$export$fc9232e2a449c314)(peer.id, peer.name, peer.publicKey, peer.version, senderId);
        else if (peer instanceof (0, $7625031e92f13c50$export$5105399ce7c287dd)) return new (0, $7625031e92f13c50$export$4ed13e9517258bfc)(peer.id, peer.name, peer.publicKey, peer.version, peer.relayServer, senderId);
        else if (peer instanceof (0, $40e5f66fcc7157a8$export$6e43c36514596f83)) return new (0, $40e5f66fcc7157a8$export$6e43c36514596f83)(peer.id, peer.name, peer.publicKey, peer.version, senderId, peer.uri);
        else return {
            ...peer,
            senderId: senderId
        };
    }
    /**
     * Add a new peer to the known peers
     * @param peer The new peer to add
     */ async addPeer(peer, sendPairingResponse = true) {
        return (await this.transport).addPeer(await this.getPeerInfo(peer), sendPairingResponse);
    }
    async removePeer(peer, sendDisconnectToPeer = false) {
        const removePeerResult = (await this.transport).removePeer(peer);
        await this.removePermissionsForPeers([
            peer
        ]);
        if (sendDisconnectToPeer) await this.sendDisconnectToPeer(peer);
        return removePeerResult;
    }
    async removeAllPeers(sendDisconnectToPeers = false) {
        const peers = await (await this.transport).getPeers();
        const removePeerResult = (await this.transport).removeAllPeers();
        await this.removePermissionsForPeers(peers);
        if (sendDisconnectToPeers) {
            const disconnectPromises = peers.map((peer)=>this.sendDisconnectToPeer(peer));
            await Promise.all(disconnectPromises);
        }
        return removePeerResult;
    }
    async removePermissionsForPeers(peersToRemove) {
        const permissions = await this.permissionManager.getPermissions();
        const peerIdsToRemove = peersToRemove.map((peer)=>peer.senderId);
        // Remove all permissions with origin of the specified peer
        const permissionsToRemove = permissions.filter((permission)=>peerIdsToRemove.includes(permission.appMetadata.senderId));
        const permissionIdentifiersToRemove = permissionsToRemove.map((permissionInfo)=>permissionInfo.accountIdentifier);
        await this.permissionManager.removePermissions(permissionIdentifiersToRemove);
    }
    /**
     * Send an acknowledge message back to the sender
     *
     * @param message The message that was received
     */ async sendAcknowledgeResponse(request, connectionContext) {
        // Acknowledge the message
        const acknowledgeResponse = {
            id: request.id,
            type: (0, $8d4b62279108a12b$export$d26bbbc5c9ff3ce8).Acknowledge
        };
        await (0, $db06c54928cd0f1d$export$7afb4f12c2d962e8).intercept({
            senderId: await (0, $1c5c036caa7dc2d6$export$c00969587a4639cc)(await this.beaconId),
            request: request,
            message: acknowledgeResponse,
            ownAppMetadata: await this.getOwnAppMetadata(),
            permissionManager: this.permissionManager,
            appMetadataManager: this.appMetadataManager,
            interceptorCallback: async (response)=>{
                await this.respondToMessage(response, connectionContext);
            }
        });
    }
    /**
     * An internal method to send a BeaconMessage to the DApp
     *
     * @param response Send a message back to the DApp
     */ async respondToMessage(response, connectionContext) {
        const serializedMessage = await new (0, $33b837e22eef79cd$export$ef852775387a0be7)().serialize(response);
        if (connectionContext) {
            const peerInfos = await this.getPeers();
            const peer = peerInfos.find((peerInfo)=>peerInfo.publicKey === connectionContext.id);
            await (await this.transport).send(serializedMessage, peer);
        } else await (await this.transport).send(serializedMessage);
    }
    async disconnect(senderId) {
        const transport = await this.transport;
        const peers = await transport.getPeers();
        const peer = peers.find((peerEl)=>peerEl.senderId === senderId);
        if (peer) await this.removePeer(peer);
        await transport.disconnect();
        return;
    }
}






// networkConfig.js
const $83066fd84bd51987$var$NETWORKS = {
    mainnet: {
        name: 'mainnet',
        rpc: 'https://mainnet.smartpy.io',
        contract: 'KT1A1v3dEDRhU9sbhuXJG2n5pkpWnMhxDkjZ'
    },
    ghostnet: {
        name: 'ghostnet',
        rpc: 'https://rpc.ghostnet.teztnets.com',
        contract: 'KT1NGK65f6yQgiPpP4kjVRXr6QiGS4iiM5P1'
    }
};
var $83066fd84bd51987$export$2e2bcd8739ae039 //https://mainnet.tezos.ecadinfra.com CORS
 = $83066fd84bd51987$var$NETWORKS;


class $5bd85e37ea5234ab$var$WalletManager {
    constructor(network){
        this.network = network;
        this.rpc = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[this.network].rpc;
        this.contract = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[this.network].contract;
        this.tezos = new (0, $2fea24c565181d86$export$7e3881046cc8cfeb)(this.rpc);
        // Provide network when instantiating the wallet (via DAppClient)
        this.wallet = new (0, $16f6c354b96bd06b$export$e5d731035abe2ea9)({
            name: 'ZeroZar',
            preferredNetwork: this.network === 'mainnet' ? (0, $3ebc4504403abbff$export$4a868a35d3b57055).MAINNET : (0, $3ebc4504403abbff$export$4a868a35d3b57055).GHOSTNET
        });
        this.tezos.setWalletProvider(this.wallet);
        this.address = null;
        this.chainId = null;
    }
    async connect() {
        // Remove network param here, just request permissions directly
        await this.wallet.requestPermissions();
        this.address = await this.wallet.getPKH();
        this.chainId = await this.tezos.rpc.getChainId();
        return this.address;
    }
    async disconnect() {
        if (this.wallet && this.wallet.client) await this.wallet.client.disconnect();
        this.address = null;
        this.chainId = null;
    }
    getAddress() {
        return this.address;
    }
    getNetwork() {
        return this.network;
    }
}
var $5bd85e37ea5234ab$export$2e2bcd8739ae039 = $5bd85e37ea5234ab$var$WalletManager;







// ==========================================================================================
// parent error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Parent error class all taquito errors to extend from
 */ class $e34635f1b1edf25a$export$e5619b407b1c8b0a extends Error {
}
/**
 *  @category Error
 *  @description Error that indicates invalid user inputs
 */ class $e34635f1b1edf25a$export$9d3f3bc8b6d48950 extends $e34635f1b1edf25a$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error returned by RPC node
 */ class $e34635f1b1edf25a$export$5460eff990f31920 extends $e34635f1b1edf25a$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates TezosToolKit has not been configured appropriately
 */ class $e34635f1b1edf25a$export$32f4d70b2fb302b1 extends $e34635f1b1edf25a$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates a requested action is not supported by Taquito
 */ class $e34635f1b1edf25a$export$34bc216509d47ce6 extends $e34635f1b1edf25a$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error during a network operation
 */ class $e34635f1b1edf25a$export$bae979e68e4dc802 extends $e34635f1b1edf25a$export$e5619b407b1c8b0a {
}
/**
 *  @category Error
 *  @description Error that indicates user attempts an action without necessary permissions
 */ class $e34635f1b1edf25a$export$9c81d48c1e1840ac extends $e34635f1b1edf25a$export$e5619b407b1c8b0a {
}
// ==========================================================================================
// common error classes for Taquito
// ==========================================================================================
/**
 *  @category Error
 *  @description Error that indicates an invalid originated or implicit address being passed or used
 */ class $e34635f1b1edf25a$export$66c44d927ffead98 extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidAddressError';
        this.message = `Invalid address "${address}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
class $e34635f1b1edf25a$export$be6cb9338b7137e0 extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidStakingAddressError';
        this.message = `Invalid staking address "${address}", you can only set destination as your own address`;
    }
}
class $e34635f1b1edf25a$export$1623a856d8b6cc2a extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(address, errorDetail){
        super();
        this.address = address;
        this.errorDetail = errorDetail;
        this.name = 'InvalidFinalizeUnstakeAmountError';
        this.message = `The amount can only be 0 when finalizing an unstake`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid block hash being passed or used
 */ class $e34635f1b1edf25a$export$16fabd343bcdfd7b extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(blockHash, errorDetail){
        super();
        this.blockHash = blockHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidBlockHashError';
        this.message = `Invalid block hash "${blockHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 * @category Error
 * @description Error that indicates an invalid amount of tez being passed as a parameter
 */ class $e34635f1b1edf25a$export$d8bf6d22cce8e288 extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(amount){
        super();
        this.amount = amount;
        this.name = 'InvalidAmountError';
        this.message = `Invalid amount "${amount}"`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid derivation path being passed or used
 */ class $e34635f1b1edf25a$export$522ca3df7030c309 extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(derivationPath, errorDetail){
        super();
        this.derivationPath = derivationPath;
        this.errorDetail = errorDetail;
        this.name = 'InvalidDerivationPathError';
        this.message = `Invalid derivation path "${derivationPath}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid hex string have been passed or used
 */ class $e34635f1b1edf25a$export$1888d6928c74d5ee extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(hexString, errorDetail){
        super();
        this.hexString = hexString;
        this.errorDetail = errorDetail;
        this.name = 'InvalidHexStringError';
        this.message = `Invalid hex string "${hexString}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid message being passed or used
 */ class $e34635f1b1edf25a$export$a5124d7665e9d8ad extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(msg, errorDetail){
        super();
        this.msg = msg;
        this.errorDetail = errorDetail;
        this.name = 'InvalidMessageError';
        this.message = `Invalid message "${msg}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid view parameter of a smart contract
 */ class $e34635f1b1edf25a$export$f9ce6a924724628b extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(viewName, sigs, args, cause){
        super();
        this.viewName = viewName;
        this.sigs = sigs;
        this.args = args;
        this.cause = cause;
        this.name = 'InvalidViewParameterError';
        this.message = `Invalid view arguments ${JSON.stringify(args)} received for name "${viewName}" expecting one of the following signatures ${JSON.stringify(sigs)}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid private key being passed or used
 */ class $e34635f1b1edf25a$export$adf223add86ae0aa extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(errorDetail){
        super();
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyError';
        this.message = `Invalid private key`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an Invalid Public Key being passed or used
 */ class $e34635f1b1edf25a$export$f675822ed489f01f extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(publicKey, errorDetail){
        super();
        this.publicKey = publicKey;
        this.errorDetail = errorDetail;
        this.name = 'InvalidPublicKeyError';
        this.message = `Invalid public key "${publicKey}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid signature being passed or used
 */ class $e34635f1b1edf25a$export$ccc2f68ef106615a extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(signature, errorDetail){
        super();
        this.signature = signature;
        this.errorDetail = errorDetail;
        this.name = 'InvalidSignatureError';
        this.message = `Invalid signature "${signature}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid contract address being passed or used
 */ class $e34635f1b1edf25a$export$193774326795229b extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(contractAddress, errorDetail){
        super();
        this.contractAddress = contractAddress;
        this.errorDetail = errorDetail;
        this.name = 'InvalidContractAddressError';
        this.message = `Invalid contract address "${contractAddress}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid chain id being passed or used
 */ class $e34635f1b1edf25a$export$4836eb835ffca5b2 extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(chainId, errorDetail){
        super();
        this.chainId = chainId;
        this.errorDetail = errorDetail;
        this.name = 'InvalidChainIdError';
        this.message = `Invalid chain id "${chainId}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid public key hash being passed or used
 */ class $e34635f1b1edf25a$export$a3d7df0ca9d9410c extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(keyHash, errorDetail){
        super();
        this.keyHash = keyHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidKeyHashError';
        this.message = `Invalid public key hash "${keyHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation hash being passed or used
 */ class $e34635f1b1edf25a$export$1a1c2023d3ec7a8a extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(operationHash, errorDetail){
        super();
        this.operationHash = operationHash;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationHashError';
        this.message = `Invalid operation hash "${operationHash}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid operation kind being passed or used
 */ class $e34635f1b1edf25a$export$bc5be87550569b55 extends $e34635f1b1edf25a$export$9d3f3bc8b6d48950 {
    constructor(operationKind, errorDetail){
        super();
        this.operationKind = operationKind;
        this.errorDetail = errorDetail;
        this.name = 'InvalidOperationKindError';
        this.message = `Invalid operation kind "${operationKind}"`;
        this.message += errorDetail ? ` ${errorDetail}.` : '.';
    }
}
/**
 *  @category Error
 *  @description General error that indicates something is no longer supported and/or deprecated
 */ class $e34635f1b1edf25a$export$11034991807c583d extends $e34635f1b1edf25a$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'DeprecationError';
    }
}
/**
 *  @category Error
 *  @description General error that indicates an action is prohibited or not allowed
 */ class $e34635f1b1edf25a$export$4041d915d9096adf extends $e34635f1b1edf25a$export$34bc216509d47ce6 {
    constructor(message){
        super();
        this.message = message;
        this.name = 'ProhibitedActionError';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a failure in grabbing the public key
 */ class $e34635f1b1edf25a$export$183b043cd3c947f9 extends $e34635f1b1edf25a$export$e5619b407b1c8b0a {
    constructor(pkh, cause){
        super();
        this.pkh = pkh;
        this.cause = cause;
        this.name = 'PublicKeyNotFoundError';
        this.message = `Public key not found of this address "${pkh}" in either wallet or contract API.`;
    }
}





var $cgCz9 = parcelRequire("cgCz9");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $cbfb45a77fb8edab$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
class $cbfb45a77fb8edab$export$211e7905c74ad16d {
    constructor(){
        this.httpBackend = new (0, $6cc77aa71b64d012$export$aac4ca225fe02187)();
    }
    getMetadata(_contractAbstraction_1, _a, _context_1) {
        return $cbfb45a77fb8edab$var$__awaiter(this, arguments, void 0, function*(_contractAbstraction, { protocol: protocol, location: location }, _context) {
            return this.httpBackend.createRequest({
                url: `${protocol}:${decodeURIComponent(location)}`,
                method: 'GET',
                headers: {
                    'Content-Type': 'text/plain; charset=utf-8'
                },
                json: false
            });
        });
    }
}
/**
 *  @category Error
 *  @description Error that indicates missing big map metadata (non compliance to the TZIP-16 standard)
 */ class $cbfb45a77fb8edab$export$aa1990b8cf72cafe extends (0, $e34635f1b1edf25a$export$e5619b407b1c8b0a) {
    constructor(invalidBigMapId){
        super();
        this.invalidBigMapId = invalidBigMapId;
        this.name = 'BigMapContractMetadataNotFoundError';
        this.message = 'Non-compliance with the TZIP-016 standard. No big map named metadata was found in the contract storage.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates missing metadata in storage
 */ class $cbfb45a77fb8edab$export$2e2a1faf00493924 extends (0, $e34635f1b1edf25a$export$e5619b407b1c8b0a) {
    constructor(info){
        super();
        this.info = info;
        this.name = 'ContractMetadataNotFoundError';
        this.message = `No metadata was found in the contract storage. ${info}`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates missing URI (non compliance to the TZIP-16 standard)
 */ class $cbfb45a77fb8edab$export$8b681ac0f6b01b63 extends (0, $e34635f1b1edf25a$export$e5619b407b1c8b0a) {
    constructor(){
        super();
        this.name = 'UriNotFoundError';
        this.message = 'Non-compliance with the TZIP-016 standard. No URI found in the contract storage.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates an invalid URI (non compliance to the TZIP-16 standard)
 */ class $cbfb45a77fb8edab$export$bda1e76ab15dd48f extends (0, $e34635f1b1edf25a$export$e5619b407b1c8b0a) {
    constructor(uri){
        super();
        this.uri = uri;
        this.name = 'InvalidUriError';
        this.message = `Non-compliance with the TZIP-016 standard. The URI is invalid: ${uri}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates invalid metadata (non compliance to the TZIP-16 standard)
 */ class $cbfb45a77fb8edab$export$8c0f86d00cd7ed42 extends (0, $e34635f1b1edf25a$export$e5619b407b1c8b0a) {
    constructor(invalidMetadata){
        super();
        this.invalidMetadata = invalidMetadata;
        this.name = 'InvalidContractMetadataError';
        this.message = `The metadata found at the pointed ressource are not compliant with tzip16 standard: ${invalidMetadata}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates the uri protocol being passed or used is not supported
 */ class $cbfb45a77fb8edab$export$a2199d4a0d7fe548 extends (0, $e34635f1b1edf25a$export$9d3f3bc8b6d48950) {
    constructor(protocol){
        super();
        this.protocol = protocol;
        this.name = 'ProtocolNotSupportedError';
        this.message = `The protocol found in the URI is not supported: ${protocol}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates the metadata type is invalid (non compliance to the TZIP-16 standard)
 */ class $cbfb45a77fb8edab$export$288c4764cb8ff97b extends (0, $e34635f1b1edf25a$export$e5619b407b1c8b0a) {
    constructor(){
        super();
        this.name = 'InvalidContractMetadataTypeError';
        this.message = 'Non-compliance with the TZIP-016 standard. The type of metadata should be bytes.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates metadata provider being unconfigured in the TezosToolkit instance
 */ class $cbfb45a77fb8edab$export$3cf1cea39686bf76 extends (0, $e34635f1b1edf25a$export$32f4d70b2fb302b1) {
    constructor(){
        super();
        this.name = 'UnconfiguredContractMetadataProviderError';
        this.message = 'No metadata provider has been configured. The default one can be configured by calling addExtension(new Tzip16Module()) on your TezosToolkit instance.';
    }
}
/**
 *  @category Error
 *  @description Error that indicates a forbidden instruction being found inside the View code
 */ class $cbfb45a77fb8edab$export$20525286e89972ea extends (0, $e34635f1b1edf25a$export$e5619b407b1c8b0a) {
    constructor(instruction){
        super();
        this.instruction = instruction;
        this.name = 'ForbiddenInstructionInViewCodeError';
        this.message = `Error found in the code of the view. It contains a forbidden instruction: ${instruction}.`;
    }
}
/**
 *  @category Error
 *  @description Error that indicates parameters are being passed when it is not required
 */ class $cbfb45a77fb8edab$export$f9331a72b0e67c63 extends (0, $e34635f1b1edf25a$export$9d3f3bc8b6d48950) {
    constructor(viewName, args){
        super();
        this.viewName = viewName;
        this.args = args;
        this.name = 'NoParameterExpectedError';
        this.message = `${viewName} Received ${args.length} arguments while expecting no parameter or 'Unit'`;
    }
}
const $cbfb45a77fb8edab$var$typeOfValueToFind = {
    prim: 'big_map',
    args: [
        {
            prim: 'string'
        },
        {
            prim: 'bytes'
        }
    ],
    annots: [
        '%metadata'
    ]
};
class $cbfb45a77fb8edab$export$d59c7b6bfc398dd7 {
    constructor(){
        this.TEZOS_STORAGE_REGEX = /^(?:\/\/(KT1\w{33})(?:\.(.+))?\/)?([\w|%]+)$/;
    }
    getMetadata(contractAbstraction_1, _a, context_1) {
        return $cbfb45a77fb8edab$var$__awaiter(this, arguments, void 0, function*(contractAbstraction, { location: location }, context) {
            const parsedTezosStorageUri = this.parseTezosStorageUri(location);
            if (!parsedTezosStorageUri) throw new $cbfb45a77fb8edab$export$bda1e76ab15dd48f(`tezos-storage:${location}`);
            const script = yield context.readProvider.getScript(parsedTezosStorageUri.contractAddress || contractAbstraction.address, 'head');
            const bigMapId = (0, $c46b7dbea18e1f8c$export$19342e026b58ebb7).fromRPCResponse({
                script: script
            }).FindFirstInTopLevelPair(script.storage, $cbfb45a77fb8edab$var$typeOfValueToFind);
            if (!bigMapId || !bigMapId.int) throw new $cbfb45a77fb8edab$export$aa1990b8cf72cafe(bigMapId);
            const bytes = yield context.contract.getBigMapKeyByID(bigMapId.int.toString(), parsedTezosStorageUri.path, new (0, $c46b7dbea18e1f8c$export$19342e026b58ebb7)($cbfb45a77fb8edab$var$typeOfValueToFind));
            if (!bytes) throw new $cbfb45a77fb8edab$export$2e2a1faf00493924(`No '${parsedTezosStorageUri.path}' key found in the big map %metadata of the contract ${parsedTezosStorageUri.contractAddress || contractAbstraction.address}`);
            if (!/^[0-9a-fA-F]*$/.test(bytes)) throw new $cbfb45a77fb8edab$export$288c4764cb8ff97b();
            return (0, $6ed3c564aba0f912$export$7c746b75f47c9c7d)(bytes);
        });
    }
    /**
     * @description Extract the smart contract address, the network and the path pointing to the metadata from the uri
     * @returns an object which contains the properties allowing to find where the metadata are located or it returns undefined if the uri is not valid
     * @param tezosStorageURI URI (without the tezos-storage prefix)
     */ parseTezosStorageUri(tezosStorageURI) {
        const extractor = this.TEZOS_STORAGE_REGEX.exec(tezosStorageURI);
        if (!extractor) return;
        return {
            contractAddress: extractor[1],
            network: extractor[2],
            path: decodeURIComponent(extractor[3])
        };
    }
}
class $cbfb45a77fb8edab$export$d58bfdc3e4e890a1 {
    constructor(ipfsGatheway){
        this.httpBackend = new (0, $6cc77aa71b64d012$export$aac4ca225fe02187)();
        this._ipfsGateway = ipfsGatheway ? ipfsGatheway : 'ipfs.io';
    }
    getMetadata(_contractAbstraction_1, _a, _context_1) {
        return $cbfb45a77fb8edab$var$__awaiter(this, arguments, void 0, function*(_contractAbstraction, { location: location }, _context) {
            return this.httpBackend.createRequest({
                url: `https://${this._ipfsGateway}/ipfs/${location.substring(2)}/`,
                method: 'GET',
                headers: {
                    'Content-Type': 'text/plain; charset=utf-8'
                },
                json: false
            });
        });
    }
}
var $cbfb45a77fb8edab$export$cd85ae9c0a048fba;
(function(ViewImplementationType) {
    ViewImplementationType["MICHELSON_STORAGE"] = "michelsonStorageView";
    ViewImplementationType["REST_API_QUERY"] = "restApiQuery";
})($cbfb45a77fb8edab$export$cd85ae9c0a048fba || ($cbfb45a77fb8edab$export$cd85ae9c0a048fba = {}));
class $cbfb45a77fb8edab$export$8c817a3542ff23d3 {
    constructor(viewName, contract, rpc, readProvider, returnType, code, viewParameterType){
        this.viewName = viewName;
        this.contract = contract;
        this.rpc = rpc;
        this.readProvider = readProvider;
        this.returnType = returnType;
        this.code = code;
        this.viewParameterType = viewParameterType;
        this.validateArgs = (args, schema, viewName)=>{
            const sigs = schema.ExtractSignatures();
            if (!sigs.find((x)=>x.length === args.length)) throw new (0, $e34635f1b1edf25a$export$f9ce6a924724628b)(viewName, sigs, args);
        };
    }
    /**
     * @description According to the tzip-16 standard, the following instructions must not be used in the code of the view:
     * 'AMOUNT', 'CREATE_CONTRACT', 'SENDER', 'SET_DELEGATE', 'SOURCE', and 'TRANSFER_TOKENS'
     * The method throw an error if an illegal instruction is found
     */ findForbiddenInstructionInViewCodeError(code) {
        const illegalInstructions = [
            'AMOUNT',
            'CREATE_CONTRACT',
            'SENDER',
            'SET_DELEGATE',
            'SOURCE',
            'TRANSFER_TOKENS'
        ];
        for (const forbiddenInstruction of illegalInstructions)for (const instruction of code){
            if (instruction.prim === forbiddenInstruction) throw new $cbfb45a77fb8edab$export$20525286e89972ea(forbiddenInstruction);
            if (instruction.args && instruction.args.length !== 0) this.findForbiddenInstructionInViewCodeError(instruction.args);
        }
    }
    /**
     * @description According to the tzip-16 standard, in the first version of the specification, the instruction SELF should only be used before ADDRESS
     * The method throws an error is the instruction SELF is present, but not followed by ADDRESS
     */ illegalUseOfSelfInstruction(code) {
        for (const instruction of code){
            if (instruction.prim === 'SELF') {
                const index = code.indexOf(instruction);
                const nextInstruction = code[index + 1] ? code[index + 1].prim : undefined;
                if (nextInstruction !== 'ADDRESS') throw new $cbfb45a77fb8edab$export$20525286e89972ea('the instruction SELF should only be used before ADDRESS');
            }
            if (instruction.args && instruction.args.length !== 0) this.illegalUseOfSelfInstruction(instruction.args);
        }
    }
    /**
     * @description Loops through the view's code and replace SELF, BALANCE, NOW, and CHAIN_ID with Michelson expressions that match the current context, if applicable.
     */ adaptViewCodeToContext(code, contractBalance, blockTimeStamp, chainId) {
        const instructionsToReplace = {
            SELF: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'address'
                        },
                        {
                            string: this.contract.address
                        }
                    ]
                },
                {
                    prim: 'CONTRACT',
                    args: [
                        {
                            prim: 'unit'
                        }
                    ]
                },
                {
                    prim: 'IF_NONE',
                    args: [
                        [
                            {
                                prim: 'UNIT'
                            },
                            {
                                prim: 'FAILWITH'
                            }
                        ],
                        []
                    ]
                }
            ],
            BALANCE: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'mutez'
                        },
                        {
                            int: contractBalance
                        }
                    ]
                }
            ],
            NOW: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'timestamp'
                        },
                        {
                            string: blockTimeStamp
                        }
                    ]
                }
            ],
            CHAIN_ID: [
                {
                    prim: 'PUSH',
                    args: [
                        {
                            prim: 'string'
                        },
                        {
                            string: chainId
                        }
                    ]
                }
            ]
        };
        code.forEach((x, i)=>{
            for(const instruction in instructionsToReplace){
                if (x.prim === instruction) code[i] = Object(instructionsToReplace)[instruction];
                if (x.args && x.args.length !== 0) this.adaptViewCodeToContext(x.args, contractBalance, blockTimeStamp, chainId);
            }
        });
        return code;
    }
    formatArgsAndParameter(argView) {
        let args = argView;
        let viewParameterType = this.viewParameterType;
        if (!viewParameterType) viewParameterType = {
            args: [],
            prim: 'unit',
            annots: []
        };
        if (viewParameterType.prim === 'unit') {
            if (args.length === 0) args = [
                'Unit'
            ];
            if (args.length !== 0 && args[0] !== 'Unit') throw new $cbfb45a77fb8edab$export$f9331a72b0e67c63(this.viewName, argView);
        }
        const parameterViewSchema = new (0, $c46b7dbea18e1f8c$export$54a0993a9ed335cf)(viewParameterType);
        this.validateArgs(args, parameterViewSchema, this.viewName);
        const arg = parameterViewSchema.Encode(...args);
        return {
            arg: arg,
            viewParameterType: viewParameterType
        };
    }
    executeView(...args) {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            // validate view code against tzip-16 specifications
            this.findForbiddenInstructionInViewCodeError(this.code);
            this.illegalUseOfSelfInstruction(this.code);
            const { arg: arg, viewParameterType: viewParameterType } = this.formatArgsAndParameter(args);
            const storageType = this.contract.script.code.find((x)=>x.prim === 'storage');
            const storageArgs = storageType.args[0];
            // currentContext
            const storageValue = yield this.readProvider.getStorage(this.contract.address, 'head');
            const chainId = yield this.readProvider.getChainId();
            const contractBalance = (yield this.readProvider.getBalance(this.contract.address, 'head')).toString();
            const blockTimestamp = yield this.readProvider.getBlockTimestamp('head');
            const code = this.adaptViewCodeToContext(this.code, contractBalance, blockTimestamp, chainId);
            if (!this.viewParameterType) code.unshift({
                prim: 'CDR'
            });
            const viewScript = {
                script: [
                    {
                        prim: 'parameter',
                        args: [
                            {
                                prim: 'pair',
                                args: [
                                    viewParameterType,
                                    storageArgs
                                ]
                            }
                        ]
                    },
                    {
                        prim: 'storage',
                        args: [
                            {
                                prim: 'option',
                                args: [
                                    this.returnType
                                ]
                            }
                        ]
                    },
                    {
                        prim: 'code',
                        args: [
                            [
                                {
                                    prim: 'CAR'
                                },
                                code,
                                {
                                    prim: 'SOME'
                                },
                                {
                                    prim: 'NIL',
                                    args: [
                                        {
                                            prim: 'operation'
                                        }
                                    ]
                                },
                                {
                                    prim: 'PAIR'
                                }
                            ]
                        ]
                    }
                ],
                storage: {
                    prim: 'None'
                },
                input: {
                    prim: 'Pair',
                    args: [
                        arg,
                        storageValue
                    ]
                },
                amount: '0',
                chain_id: chainId,
                balance: '0'
            };
            let result;
            try {
                result = yield this.rpc.runCode(viewScript);
            } catch (error) {
                const failWith = (0, $2fea24c565181d86$export$6ead28c0ab00fb75)(error);
                throw failWith ? new (0, $2fea24c565181d86$export$7a371d5bcddb4bc0)(`The simulation of the Michelson view failed with: ${JSON.stringify(failWith)}`, this.viewName, failWith, error) : error;
            }
            const viewResultSchema = new (0, $c46b7dbea18e1f8c$export$54a0993a9ed335cf)(this.returnType);
            return viewResultSchema.Execute(result.storage.args[0]);
        });
    }
}
class $cbfb45a77fb8edab$export$918c359d6182b34e {
    getView(viewName, rpc, readProvider, contract, viewImplementation) {
        if (this.isMichelsonStorageView(viewImplementation)) {
            const viewValues = viewImplementation[$cbfb45a77fb8edab$export$cd85ae9c0a048fba.MICHELSON_STORAGE];
            if (!viewValues.returnType || !viewValues.code) {
                console.warn(`${viewName} is missing mandatory code or returnType property therefore it will be skipped.`);
                return;
            }
            return ()=>{
                const view = new $cbfb45a77fb8edab$export$8c817a3542ff23d3(viewName, contract, rpc, readProvider, viewValues.returnType, viewValues.code, viewValues.parameter);
                return view;
            };
        }
    }
    getImplementationType(viewImplementation) {
        return Object.keys(viewImplementation)[0];
    }
    isMichelsonStorageView(viewImplementation) {
        return this.getImplementationType(viewImplementation) === $cbfb45a77fb8edab$export$cd85ae9c0a048fba.MICHELSON_STORAGE;
    }
}
const $cbfb45a77fb8edab$var$metadataBigMapType = {
    prim: 'big_map',
    args: [
        {
            prim: 'string'
        },
        {
            prim: 'bytes'
        }
    ],
    annots: [
        '%metadata'
    ]
};
class $cbfb45a77fb8edab$export$19f2712eab36dc87 {
    constructor(constractAbstraction, context){
        this.constractAbstraction = constractAbstraction;
        this.context = context;
        this._viewFactory = new $cbfb45a77fb8edab$export$918c359d6182b34e();
        this._metadataViewsObject = {};
        this._metadataProvider = context.metadataProvider;
    }
    findMetadataBigMap() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            const metadataBigMapId = this.constractAbstraction.schema.FindFirstInTopLevelPair((yield this.context.readProvider.getStorage(this.constractAbstraction.address, 'head')), $cbfb45a77fb8edab$var$metadataBigMapType);
            if (!metadataBigMapId || !metadataBigMapId.int) throw new $cbfb45a77fb8edab$export$aa1990b8cf72cafe(metadataBigMapId);
            return new (0, $2fea24c565181d86$export$ba473e7c149ab4dc)(new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(metadataBigMapId['int']), new (0, $c46b7dbea18e1f8c$export$19342e026b58ebb7)($cbfb45a77fb8edab$var$metadataBigMapType), this.context.contract);
        });
    }
    getUriOrFail() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            const metadataBigMap = yield this.findMetadataBigMap();
            const uri = yield metadataBigMap.get('');
            if (!uri) throw new $cbfb45a77fb8edab$export$8b681ac0f6b01b63();
            return uri;
        });
    }
    /**
     * @description Return an object containing the metadata, the uri, an optional integrity check result and an optional sha256 hash
     */ getMetadata() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._metadataProvider) throw new $cbfb45a77fb8edab$export$3cf1cea39686bf76();
            if (!this._metadataEnvelope) {
                const uri = yield this.getUriOrFail();
                this._metadataEnvelope = yield this._metadataProvider.provideMetadata(this.constractAbstraction, (0, $6ed3c564aba0f912$export$7c746b75f47c9c7d)(uri), this.context);
            }
            return this._metadataEnvelope;
        });
    }
    metadataName() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._metadataEnvelope) yield this.getMetadata();
            return this._metadataEnvelope.metadata.name;
        });
    }
    metadataDescription() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._metadataEnvelope) yield this.getMetadata();
            return this._metadataEnvelope.metadata.description;
        });
    }
    metadataVersion() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._metadataEnvelope) yield this.getMetadata();
            return this._metadataEnvelope.metadata.version;
        });
    }
    metadataLicense() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._metadataEnvelope) yield this.getMetadata();
            return this._metadataEnvelope.metadata.license;
        });
    }
    metadataAuthors() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._metadataEnvelope) yield this.getMetadata();
            return this._metadataEnvelope.metadata.authors;
        });
    }
    metadataHomepage() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._metadataEnvelope) yield this.getMetadata();
            return this._metadataEnvelope.metadata.homepage;
        });
    }
    metadataSource() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._metadataEnvelope) yield this.getMetadata();
            return this._metadataEnvelope.metadata.source;
        });
    }
    metadataInterfaces() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._metadataEnvelope) yield this.getMetadata();
            return this._metadataEnvelope.metadata.interfaces;
        });
    }
    metadataErrors() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._metadataEnvelope) yield this.getMetadata();
            return this._metadataEnvelope.metadata.errors;
        });
    }
    metadataViews() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            if (Object.keys(this._metadataViewsObject).length === 0) yield this.initializeMetadataViewsList();
            return this._metadataViewsObject;
        });
    }
    initializeMetadataViewsList() {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const { metadata: metadata } = yield this.getMetadata();
            const metadataViews = {};
            (_a = metadata.views) === null || _a === void 0 || _a.forEach((view)=>this.createViewImplementations(view, metadataViews));
            this._metadataViewsObject = metadataViews;
        });
    }
    generateIndexedViewName(viewName, metadataViews) {
        let i = 1;
        if (viewName in metadataViews) {
            while(`${viewName}${i}` in metadataViews)i++;
            viewName = `${viewName}${i}`;
        }
        return viewName;
    }
    createViewImplementations(view, metadataViews) {
        var _a;
        for (const viewImplementation of (_a = view === null || view === void 0 ? void 0 : view.implementations) !== null && _a !== void 0 ? _a : [])if (view.name) {
            // when views have the same name, add an index at the end of the name
            const viewName = this.generateIndexedViewName(view.name, metadataViews);
            const metadataView = this._viewFactory.getView(viewName, this.context.rpc, this.context.readProvider, this.constractAbstraction, viewImplementation);
            if (metadataView) metadataViews[viewName] = metadataView;
            else console.warn(`Skipped generating ${viewName} because the view has an unsupported type: ${this._viewFactory.getImplementationType(viewImplementation)}`);
        }
    }
}
const $cbfb45a77fb8edab$var$ABSTRACTION_KEY = Symbol('Tzip16ContractAbstractionObjectKey');
function $cbfb45a77fb8edab$export$dcedc247e9ab031d(abs, context) {
    return Object.assign(abs, {
        // namespace tzip16
        tzip16 () {
            if (!this[$cbfb45a77fb8edab$var$ABSTRACTION_KEY]) this[$cbfb45a77fb8edab$var$ABSTRACTION_KEY] = new $cbfb45a77fb8edab$export$19f2712eab36dc87(this, context);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return this[$cbfb45a77fb8edab$var$ABSTRACTION_KEY];
        }
    });
}
function $cbfb45a77fb8edab$export$38a4e6ee456be3a0(preimage) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cgCz9))).SHA256(preimage).toString((0, (/*@__PURE__*/$parcel$interopDefault($cgCz9))).enc.Hex);
}
/**
 * @description: Metadata Provider
 */ class $cbfb45a77fb8edab$export$d2a605bb80d8e87f {
    constructor(handlers){
        this.handlers = handlers;
        this.PROTOCOL_REGEX = /(?:sha256:\/\/0x(.*)\/)?(https?|ipfs|tezos-storage):(.*)/;
    }
    /**
     * @description Fetch the metadata by using the appropriate handler based on the protcol found in the URI
     * @returns an object which contains the uri, the metadata, an optional integrity check result and an optional SHA256 hash
     * @param _contractAbstraction the contract abstraction which contains the URI in its storage
     * @param _uri the decoded uri found in the storage
     * @param context the TezosToolkit Context
     */ provideMetadata(contractAbstraction, uri, context) {
        return $cbfb45a77fb8edab$var$__awaiter(this, void 0, void 0, function*() {
            const uriInfo = this.extractProtocolInfo(uri);
            if (!uriInfo || !uriInfo.location) throw new $cbfb45a77fb8edab$export$bda1e76ab15dd48f(uri);
            const handler = this.handlers.get(uriInfo.protocol);
            if (!handler) throw new $cbfb45a77fb8edab$export$a2199d4a0d7fe548(uriInfo.protocol);
            const metadata = yield handler.getMetadata(contractAbstraction, uriInfo, context);
            const sha256Hash = $cbfb45a77fb8edab$export$38a4e6ee456be3a0(metadata);
            let metadataJSON;
            try {
                metadataJSON = JSON.parse(metadata);
            } catch (ex) {
                throw new $cbfb45a77fb8edab$export$8c0f86d00cd7ed42(metadata);
            }
            return {
                uri: uri,
                metadata: metadataJSON,
                integrityCheckResult: uriInfo.sha256hash ? uriInfo.sha256hash === sha256Hash : undefined,
                sha256Hash: uriInfo.sha256hash ? sha256Hash : undefined
            };
        });
    }
    extractProtocolInfo(_uri) {
        const extractor = this.PROTOCOL_REGEX.exec(_uri);
        if (!extractor) return;
        return {
            sha256hash: extractor[1],
            protocol: extractor[2],
            location: extractor[3]
        };
    }
}
const $cbfb45a77fb8edab$export$919ec570f8ddd5f3 = new Map([
    [
        'http',
        new $cbfb45a77fb8edab$export$211e7905c74ad16d()
    ],
    [
        'https',
        new $cbfb45a77fb8edab$export$211e7905c74ad16d()
    ],
    [
        'tezos-storage',
        new $cbfb45a77fb8edab$export$d59c7b6bfc398dd7()
    ],
    [
        'ipfs',
        new $cbfb45a77fb8edab$export$d58bfdc3e4e890a1()
    ]
]);
class $cbfb45a77fb8edab$export$5ba8cdf8fe3666fe {
    constructor(metadataProvider){
        this._metadataProvider = metadataProvider ? metadataProvider : new $cbfb45a77fb8edab$export$d2a605bb80d8e87f($cbfb45a77fb8edab$export$919ec570f8ddd5f3);
    }
    configureContext(context) {
        Object.assign(context, {
            metadataProvider: this._metadataProvider
        });
    }
}
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
const $cbfb45a77fb8edab$export$a4ad2735b021c132 = {
    "commitHash": "6a2c52b9e48b299dfc856149c1fa3388e77180ad",
    "version": "22.0.0"
};



// Decode hex string to ASCII/UTF-8
function $8f432d27490e361c$var$decodeHex(hex) {
    if (!hex) return "";
    let hexStr = hex.startsWith('0x') ? hex.slice(2) : hex;
    if (!/^[0-9a-fA-F]*$/.test(hexStr)) return "";
    // Convert hex to Uint8Array
    const bytes = new Uint8Array(hexStr.length / 2);
    for(let i = 0; i < hexStr.length; i += 2)bytes[i / 2] = parseInt(hexStr.substr(i, 2), 16);
    // Decode as UTF-8
    try {
        return new TextDecoder("utf-8").decode(bytes);
    } catch (e) {
        // Fallback: return ASCII as before
        let decoded = '';
        for(let i = 0; i < hexStr.length; i += 2)decoded += String.fromCharCode(parseInt(hexStr.substr(i, 2), 16));
        return decoded;
    }
}
async function $8f432d27490e361c$export$6369812e4fd2658f(network, contractAddress) {
    const rpc = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[network].rpc;
    const tezos = new (0, $2fea24c565181d86$export$7e3881046cc8cfeb)(rpc);
    tezos.addExtension(new (0, $cbfb45a77fb8edab$export$5ba8cdf8fe3666fe)());
    const contractInstance = await tezos.contract.at(contractAddress, (0, $cbfb45a77fb8edab$export$dcedc247e9ab031d));
    const metadataViews = await contractInstance.tzip16().metadataViews();
    const tokenIds = await metadataViews.get_active_tokens().executeView();
    if (!Array.isArray(tokenIds) || !tokenIds.length) return [];
    // Convert all tokenIds to JS numbers (safe for NFT/FA2 IDs)
    const numberTokenIds = tokenIds.map((tid)=>tid && typeof tid.toNumber === 'function' ? tid.toNumber() : Number(tid));
    numberTokenIds.sort((a, b)=>b - a);
    return numberTokenIds;
}
async function $8f432d27490e361c$export$ba96c39f7d288bbc(network, contractAddress, ownerAddress) {
    const rpc = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[network].rpc;
    const tezos = new (0, $2fea24c565181d86$export$7e3881046cc8cfeb)(rpc);
    tezos.addExtension(new (0, $cbfb45a77fb8edab$export$5ba8cdf8fe3666fe)());
    const contractInstance = await tezos.contract.at(contractAddress, (0, $cbfb45a77fb8edab$export$dcedc247e9ab031d));
    const metadataViews = await contractInstance.tzip16().metadataViews();
    const tokenIds = await metadataViews.get_active_tokens().executeView();
    const ownedTokenIds = [];
    for (const tokenId of tokenIds)try {
        // Call get_balance view: input { owner: address, token_id: number }
        const balance = await metadataViews.get_balance().executeView([
            ownerAddress,
            tokenId
        ]);
        if (balance && balance.toNumber && balance.toNumber() > 0) ownedTokenIds.push(tokenId);
    } catch (err) {
        console.warn(`Failed to get balance for tokenId ${tokenId}:`, err);
    }
    ownedTokenIds.sort((a, b)=>b - a);
    return ownedTokenIds;
}
async function $8f432d27490e361c$export$1c4c0ad9554c1ffb(tokenId, network, contractAddress) {
    const rpc = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[network].rpc;
    const tezos = new (0, $2fea24c565181d86$export$7e3881046cc8cfeb)(rpc);
    tezos.addExtension(new (0, $cbfb45a77fb8edab$export$5ba8cdf8fe3666fe)());
    const contractInstance = await tezos.contract.at(contractAddress, (0, $cbfb45a77fb8edab$export$dcedc247e9ab031d));
    const metadataViews = await contractInstance.tzip16().metadataViews();
    const meta = await metadataViews.get_token_metadata().executeView(tokenId);
    const info = meta.token_info;
    let get = (k)=>typeof info.get === 'function' ? info.get(k) : info[k];
    const nameHex = get('name');
    const artifactUriHex = get('artifactUri');
    const authorsHex = get('authors');
    const creatorsHex = get('creators');
    const royaltiesHex = get('royalties'); // New optional field
    const name = $8f432d27490e361c$var$decodeHex(nameHex);
    const img = $8f432d27490e361c$var$decodeHex(artifactUriHex);
    let authors = [];
    let creators = [];
    let royalties = '';
    try {
        authors = JSON.parse($8f432d27490e361c$var$decodeHex(authorsHex) || '[]');
    } catch  {}
    try {
        creators = JSON.parse($8f432d27490e361c$var$decodeHex(creatorsHex) || '[]');
    } catch  {}
    try {
        const decoded = $8f432d27490e361c$var$decodeHex(royaltiesHex);
        if (decoded && decoded.trim()) royalties = formatRoyaltiesFromMetadata(decoded.trim());
    } catch  {}
    return {
        tokenId: tokenId,
        name: name,
        authors: authors,
        creators: creators,
        img: img,
        royalties: royalties
    };
}
async function $8f432d27490e361c$export$4652127834519d39(address, tokenId, network, contractAddress) {
    try {
        const rpc = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[network].rpc;
        const tezos = new (0, $2fea24c565181d86$export$7e3881046cc8cfeb)(rpc);
        tezos.addExtension(new (0, $cbfb45a77fb8edab$export$5ba8cdf8fe3666fe)());
        const contractInstance = await tezos.contract.at(contractAddress, (0, $cbfb45a77fb8edab$export$dcedc247e9ab031d));
        const metadataViews = await contractInstance.tzip16().metadataViews();
        // Pass parameters separately (not as single array)
        const balance = await metadataViews.get_balance().executeView(address, Number(tokenId));
        if (balance && typeof balance.toNumber === 'function') return balance.toNumber() > 0;
        if (typeof balance === 'number') return balance > 0;
        return false;
    } catch (err) {
        console.warn('Failed to call get_balance offchain view:', err);
        return false;
    }
}




async function $3e5b4aee17d381c1$export$de07210a482e9c8a(network, tezos) {
    const marketAddr = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[network].marketbase;
    if (!marketAddr) throw new Error("No market contract for this network");
    return await tezos.wallet.at(marketAddr);
}
async function $3e5b4aee17d381c1$export$6da744084d84acdb(walletManager, ownerAddress, operatorAddress, tokenId, contractAddress) {
    const tezos = walletManager.tezos;
    const contract = await tezos.contract.at(contractAddress);
    const storage = await contract.storage();
    let operatorsBigMap;
    try {
        operatorsBigMap = storage.operators;
    } catch (err) {
        console.error('Operators big map not found:', err);
        return false;
    }
    try {
        const operatorKey = {
            owner: ownerAddress,
            operator: operatorAddress,
            token_id: tokenId
        };
        const value = await operatorsBigMap.get(operatorKey);
        return !!value;
    } catch  {
        return false;
    }
}
async function $3e5b4aee17d381c1$export$85189eae27defb41(walletManager, operatorAddress, tokenId, contractAddress, addOperator = true) {
    const contract = await walletManager.tezos.wallet.at(contractAddress);
    const update = addOperator ? {
        add_operator: {
            owner: walletManager.address,
            operator: operatorAddress,
            token_id: tokenId
        }
    } : {
        remove_operator: {
            owner: walletManager.address,
            operator: operatorAddress,
            token_id: tokenId
        }
    };
    const op = await contract.methods.update_operators([
        update
    ]).send();
    await op.confirmation();
    return op;
}
async function $3e5b4aee17d381c1$export$d10772d482bd935c(walletManager, contractAddress, tokenId, amount) {
    const contract = await walletManager.tezos.wallet.at(contractAddress);
    const op = await contract.methods.init_escrow(tokenId, amount).send();
    await op.confirmation();
    return op;
}
async function $3e5b4aee17d381c1$export$b5cfc6605ccab6a(walletManager, contractAddress, tokenId, amount) {
    const contract = await walletManager.tezos.wallet.at(contractAddress);
    const op = await contract.methods.taker_deposit(tokenId, amount).send();
    await op.confirmation();
    return op;
}
async function $3e5b4aee17d381c1$export$7832d1d1b5caa4b5(walletManager, escrowId, contractAddress) {
    const contract = await walletManager.tezos.wallet.at(contractAddress);
    const op = await contract.methods.cancel_escrow(escrowId).send();
    await op.confirmation();
    return op;
}
async function $3e5b4aee17d381c1$export$f85c19d68fed0e75(walletManager, escrowId, contractAddress) {
    const contract = await walletManager.tezos.wallet.at(contractAddress);
    const op = await contract.methods.maker_approve(escrowId).send();
    await op.confirmation();
    return op;
}
async function $3e5b4aee17d381c1$export$843a5d7f6540d3ce(walletManager, walletAddress, contractAddress) {
    const tezos = walletManager.tezos;
    const contract = await tezos.contract.at(contractAddress);
    // Call the on-chain view to get user offers (escrow_id and role)
    const userOffers = await contract.contractViews.get_user_offers(walletAddress).executeView({
        viewCaller: contractAddress
    });
    const escrows = [];
    // For each escrow record, fetch the full escrow details with get_escrow_by_id view
    for (const offer of userOffers){
        const escrowId = offer.escrow_id.toNumber ? offer.escrow_id.toNumber() : offer.escrow_id;
        const escrowInfo = await contract.contractViews.get_escrow_by_id(escrowId).executeView({
            viewCaller: contractAddress
        });
        console.log("escroInfo", escrowInfo);
        // Filter escrows based on roles and states
        const escrowStatus = escrowInfo.state;
        // IMPORTANT: Skip CANCELLED and COMPLETED escrows
        if (escrowStatus === 'CANCELLED' || escrowStatus === 'SWAPPED') continue;
        // Only include relevant escrows similar to your original logic
        const isMakerRelevant = offer.role === 'maker';
        const isTakerRelevant = offer.role === 'taker';
        if (isMakerRelevant || isTakerRelevant) escrows.push({
            escrowId: escrowId,
            maker: escrowInfo.maker,
            taker: escrowInfo.taker,
            makerApproved: escrowInfo.maker_approved,
            makerDeposited: escrowInfo.maker_deposited,
            takerApproved: escrowInfo.taker_approved,
            takerDeposited: escrowInfo.taker_deposited,
            makerToken: escrowInfo.maker_token,
            takerToken: escrowInfo.taker_token,
            status: escrowInfo.state,
            role: offer.role // from user's role in this escrow
        });
    }
    return escrows;
}


const $35da740d59af89ba$var$walletAddressDiv = document.getElementById('walletAddress');
const $35da740d59af89ba$var$connectWalletBtn = document.getElementById('connectWalletBtn');
const $35da740d59af89ba$var$disconnectWalletBtn = document.getElementById('disconnectWalletBtn');
const $35da740d59af89ba$var$networkRadios = document.querySelectorAll('input[name="network"]');
const $35da740d59af89ba$var$fetchTokensBtn = document.getElementById('fetchTokensBtn');
const $35da740d59af89ba$var$sendOfferBtn = document.getElementById('sendOfferBtn');
const $35da740d59af89ba$var$clearMakerBtn = document.getElementById('clearMakerBtn');
const $35da740d59af89ba$var$findOffersBtn = document.getElementById('findOffersBtn');
const $35da740d59af89ba$var$makerContractInput = document.getElementById('makerContractAddress');
const $35da740d59af89ba$var$artistAddressInput = document.getElementById('artistAddress');
const $35da740d59af89ba$var$quantitySelect = document.getElementById('tokenQuantity');
const $35da740d59af89ba$var$makerTokensGrid = document.getElementById('makerTokensGrid');
const $35da740d59af89ba$var$allOffersGrid = document.getElementById('allOffersGrid');
const $35da740d59af89ba$var$statusModal = document.getElementById('statusModal');
const $35da740d59af89ba$var$modalStatusText = document.getElementById('modalStatusText');
const $35da740d59af89ba$var$modalLoadingAnimation = document.getElementById('modalLoadingAnimation');
const $35da740d59af89ba$var$modalCloseBtn = document.getElementById('modalCloseBtn');
const $35da740d59af89ba$var$operatorCheckModal = document.getElementById('operatorCheckModal');
const $35da740d59af89ba$var$operatorModalMessage = document.getElementById('operatorModalMessage');
const $35da740d59af89ba$var$operatorModalError = document.getElementById('operatorModalError');
const $35da740d59af89ba$var$operatorModalRetryBtn = document.getElementById('operatorModalRetryBtn');
const $35da740d59af89ba$var$operatorModalCancelBtn = document.getElementById('operatorModalCancelBtn');
const $35da740d59af89ba$var$takerContractInput = document.getElementById('takerContractAddress');
const $35da740d59af89ba$var$takerTokensGrid = document.getElementById('takerTokensGrid');
const $35da740d59af89ba$var$fetchTakerTokensBtn = document.getElementById('fetchTakerTokensBtn');
const $35da740d59af89ba$var$takerSection = document.getElementById('takerSection');
const $35da740d59af89ba$var$depositOfferBtn = document.getElementById('depositOfferBtn');
let $35da740d59af89ba$var$walletManager = null;
let $35da740d59af89ba$var$selectedNetwork = 'mainnet';
let $35da740d59af89ba$var$connectedAddress = null;
let $35da740d59af89ba$var$makerTokens = [];
let $35da740d59af89ba$var$selectedTokenId = null;
let $35da740d59af89ba$var$selectedTokenMaxAmount = 1;
let $35da740d59af89ba$var$selectedTakerTokenId = null;
let $35da740d59af89ba$var$selectedTakerTokenMaxAmount = 1;
let $35da740d59af89ba$var$selectedEscrowId = null;
let $35da740d59af89ba$var$selectedEscrowRole = null;
let $35da740d59af89ba$var$selectedEscrowState = null;
let $35da740d59af89ba$var$lastEscrowSubmission = null;
function $35da740d59af89ba$var$getSelectedNetwork() {
    return document.getElementById('networkMainnet').checked ? 'mainnet' : 'ghostnet';
}
function $35da740d59af89ba$var$openModal(message) {
    $35da740d59af89ba$var$modalStatusText.textContent = message;
    $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'block';
    $35da740d59af89ba$var$modalCloseBtn.style.display = 'none';
    $35da740d59af89ba$var$statusModal.style.display = 'flex';
}
function $35da740d59af89ba$var$closeModal() {
    $35da740d59af89ba$var$statusModal.style.display = 'none';
    $35da740d59af89ba$var$modalCloseBtn.style.display = 'none';
    $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'block';
    $35da740d59af89ba$var$modalStatusText.textContent = '';
}
$35da740d59af89ba$var$modalCloseBtn.addEventListener('click', $35da740d59af89ba$var$closeModal);
$35da740d59af89ba$var$operatorModalRetryBtn.addEventListener('click', ()=>{
    $35da740d59af89ba$var$operatorModalError.style.display = 'none';
    $35da740d59af89ba$var$operatorCheckModal.style.display = 'none';
    if ($35da740d59af89ba$var$lastEscrowSubmission) $35da740d59af89ba$var$lastEscrowSubmission();
});
$35da740d59af89ba$var$operatorModalCancelBtn.addEventListener('click', ()=>{
    $35da740d59af89ba$var$operatorModalError.style.display = 'none';
    $35da740d59af89ba$var$operatorCheckModal.style.display = 'none';
    $35da740d59af89ba$var$lastEscrowSubmission = null;
});
$35da740d59af89ba$var$connectWalletBtn.addEventListener('click', async ()=>{
    const newlySelectedNetwork = $35da740d59af89ba$var$getSelectedNetwork();
    if ($35da740d59af89ba$var$walletManager && $35da740d59af89ba$var$walletManager.getNetwork() !== newlySelectedNetwork) {
        await $35da740d59af89ba$var$walletManager.disconnect();
        window.location.reload();
        return;
    }
    $35da740d59af89ba$var$selectedNetwork = newlySelectedNetwork;
    $35da740d59af89ba$var$walletManager = new (0, $5bd85e37ea5234ab$export$2e2bcd8739ae039)($35da740d59af89ba$var$selectedNetwork);
    try {
        $35da740d59af89ba$var$connectedAddress = await $35da740d59af89ba$var$walletManager.connect();
        $35da740d59af89ba$var$walletAddressDiv.textContent = `Connected: ${$35da740d59af89ba$var$connectedAddress}`;
        $35da740d59af89ba$var$clearMakerBtn.disabled = false;
        $35da740d59af89ba$var$findOffersBtn.disabled = false;
        $35da740d59af89ba$var$connectWalletBtn.style.display = 'none';
        $35da740d59af89ba$var$disconnectWalletBtn.style.display = 'inline-block';
        $35da740d59af89ba$var$findOffersBtn.click();
    } catch (err) {
        $35da740d59af89ba$var$walletAddressDiv.textContent = 'Wallet connection failed';
        console.error(err);
    }
});
$35da740d59af89ba$var$disconnectWalletBtn.addEventListener('click', async ()=>{
    if (!$35da740d59af89ba$var$walletManager) return;
    try {
        await $35da740d59af89ba$var$walletManager.disconnect();
        $35da740d59af89ba$var$connectedAddress = null;
        $35da740d59af89ba$var$walletManager = null;
        $35da740d59af89ba$var$walletAddressDiv.textContent = 'Disconnected';
        $35da740d59af89ba$var$clearMakerBtn.disabled = true;
        $35da740d59af89ba$var$findOffersBtn.disabled = true;
        $35da740d59af89ba$var$connectWalletBtn.style.display = 'inline-block';
        $35da740d59af89ba$var$disconnectWalletBtn.style.display = 'none';
        $35da740d59af89ba$var$resetMakerForm();
        $35da740d59af89ba$var$resetOffersGrids();
    } catch (err) {
        console.error('Disconnect error:', err);
    }
});
$35da740d59af89ba$var$fetchTokensBtn.addEventListener('click', async ()=>{
    if (!$35da740d59af89ba$var$walletManager || !$35da740d59af89ba$var$connectedAddress) {
        alert('Connect wallet first');
        return;
    }
    const contractAddr = $35da740d59af89ba$var$makerContractInput.value.trim();
    if (!contractAddr) {
        alert('Enter contract address');
        return;
    }
    $35da740d59af89ba$var$openModal("Fetching your tokens\u2026");
    try {
        $35da740d59af89ba$var$makerTokensGrid.innerHTML = '';
        $35da740d59af89ba$var$artistAddressInput.value = '';
        $35da740d59af89ba$var$quantitySelect.disabled = true;
        $35da740d59af89ba$var$sendOfferBtn.disabled = true;
        $35da740d59af89ba$var$selectedTokenId = null;
        const tokenIds = await (0, $8f432d27490e361c$export$6369812e4fd2658f)($35da740d59af89ba$var$selectedNetwork, contractAddr);
        const ownedTokenIds = [];
        const total = tokenIds.length;
        let checked = 0;
        let found = 0;
        for (const tokenId of tokenIds){
            checked++;
            $35da740d59af89ba$var$modalStatusText.textContent = `Fetching your tokens\u{2026}
Checked: ${checked} / ${total}\nFound: ${found}`;
            if (await (0, $8f432d27490e361c$export$4652127834519d39)($35da740d59af89ba$var$connectedAddress, tokenId, $35da740d59af89ba$var$selectedNetwork, contractAddr)) {
                ownedTokenIds.push(tokenId);
                found++;
            }
            $35da740d59af89ba$var$modalStatusText.textContent = `Fetching your tokens\u{2026}
Checked: ${checked} / ${total}\nFound: ${found}`;
        }
        if (!ownedTokenIds.length) {
            $35da740d59af89ba$var$closeModal();
            alert('You own no tokens in this contract');
            return;
        }
        const tokensWithMetadata = await Promise.all(ownedTokenIds.map((tokenId)=>(0, $8f432d27490e361c$export$1c4c0ad9554c1ffb)(tokenId, $35da740d59af89ba$var$selectedNetwork, contractAddr)));
        $35da740d59af89ba$var$makerTokensGrid.innerHTML = '';
        tokensWithMetadata.forEach((token)=>{
            const div = document.createElement('div');
            div.className = 'token-item';
            const label = document.createElement('label');
            label.textContent = `ID: ${token.tokenId}`;
            label.style.fontSize = '0.7em';
            label.style.fontWeight = 'bold';
            label.style.marginBottom = '5px';
            const img = document.createElement('img');
            img.src = token.img || 'placeholder.png';
            img.alt = token.name || 'Token Image';
            img.style.maxWidth = '140px';
            img.style.display = 'block';
            img.style.borderRadius = '3px';
            const nameLabel = document.createElement('label');
            nameLabel.textContent = token.name || 'Untitled';
            nameLabel.style.fontSize = '0.7em';
            nameLabel.style.marginTop = '5px';
            nameLabel.style.wordWrap = 'break-word';
            const radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = 'makerToken';
            radio.value = token.tokenId;
            radio.style.marginTop = '8px';
            radio.addEventListener('change', ()=>{
                $35da740d59af89ba$var$selectedTokenId = parseInt(radio.value);
                console.log('Token selected, selectedTokenId set to:', $35da740d59af89ba$var$selectedTokenId);
                $35da740d59af89ba$var$selectedTokenMaxAmount = 1;
                const firstCreator = Array.isArray(token.creators) && token.creators.length > 0 ? token.creators[0] : '';
                $35da740d59af89ba$var$artistAddressInput.value = firstCreator;
                $35da740d59af89ba$var$quantitySelect.disabled = false;
                $35da740d59af89ba$var$quantitySelect.innerHTML = '';
                for(let i = 1; i <= $35da740d59af89ba$var$selectedTokenMaxAmount; i++){
                    const option = document.createElement('option');
                    option.value = i;
                    option.textContent = i;
                    $35da740d59af89ba$var$quantitySelect.appendChild(option);
                }
                $35da740d59af89ba$var$sendOfferBtn.disabled = false;
            });
            div.appendChild(label);
            div.appendChild(img);
            div.appendChild(nameLabel);
            div.appendChild(radio);
            $35da740d59af89ba$var$makerTokensGrid.appendChild(div);
        });
        setTimeout(()=>$35da740d59af89ba$var$closeModal(), 500);
    } catch (err) {
        console.error(err);
        $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
        $35da740d59af89ba$var$modalStatusText.textContent = 'Failed to fetch or display owned tokens: ' + err.message;
        setTimeout(()=>$35da740d59af89ba$var$closeModal(), 2500);
    }
});
$35da740d59af89ba$var$fetchTakerTokensBtn.addEventListener('click', async ()=>{
    if (!$35da740d59af89ba$var$walletManager || !$35da740d59af89ba$var$connectedAddress) {
        alert('Connect wallet first');
        return;
    }
    const contractAddr = $35da740d59af89ba$var$takerContractInput.value.trim();
    if (!contractAddr) {
        alert('Enter contract address');
        return;
    }
    $35da740d59af89ba$var$openModal("Fetching your tokens\u2026");
    try {
        $35da740d59af89ba$var$takerTokensGrid.innerHTML = '';
        $35da740d59af89ba$var$depositOfferBtn.disabled = true;
        $35da740d59af89ba$var$selectedTakerTokenId = null;
        const tokenIds = await (0, $8f432d27490e361c$export$6369812e4fd2658f)($35da740d59af89ba$var$selectedNetwork, contractAddr);
        const ownedTokenIds = [];
        const total = tokenIds.length;
        let checked = 0;
        let found = 0;
        for (const tokenId of tokenIds){
            checked++;
            $35da740d59af89ba$var$modalStatusText.textContent = `Fetching your tokens\u{2026}
Checked: ${checked} / ${total}\nFound: ${found}`;
            if (await (0, $8f432d27490e361c$export$4652127834519d39)($35da740d59af89ba$var$connectedAddress, tokenId, $35da740d59af89ba$var$selectedNetwork, contractAddr)) {
                ownedTokenIds.push(tokenId);
                found++;
            }
            $35da740d59af89ba$var$modalStatusText.textContent = `Fetching your tokens\u{2026}
Checked: ${checked} / ${total}\nFound: ${found}`;
        }
        if (!ownedTokenIds.length) {
            $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
            $35da740d59af89ba$var$modalStatusText.textContent = 'You own no tokens in this contract.';
            setTimeout(()=>$35da740d59af89ba$var$closeModal(), 1500);
            return;
        }
        const tokensWithMetadata = await Promise.all(ownedTokenIds.map((tokenId)=>(0, $8f432d27490e361c$export$1c4c0ad9554c1ffb)(tokenId, $35da740d59af89ba$var$selectedNetwork, contractAddr)));
        $35da740d59af89ba$var$takerTokensGrid.innerHTML = '';
        tokensWithMetadata.forEach((token)=>{
            const div = document.createElement('div');
            div.className = 'token-item';
            const label = document.createElement('label');
            label.textContent = `ID: ${token.tokenId}`;
            label.style.fontSize = '0.7em';
            label.style.fontWeight = 'bold';
            label.style.marginBottom = '5px';
            const img = document.createElement('img');
            img.src = token.img || 'placeholder.png';
            img.alt = token.name || 'Token Image';
            img.style.maxWidth = '140px';
            img.style.display = 'block';
            img.style.borderRadius = '3px';
            const nameLabel = document.createElement('label');
            nameLabel.textContent = token.name || 'Untitled';
            nameLabel.style.fontSize = '0.7em';
            nameLabel.style.marginTop = '5px';
            nameLabel.style.wordWrap = 'break-word';
            const radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = 'takerToken';
            radio.value = token.tokenId;
            radio.style.marginTop = '8px';
            radio.addEventListener('change', ()=>{
                $35da740d59af89ba$var$selectedTakerTokenId = parseInt(radio.value);
                $35da740d59af89ba$var$selectedTakerTokenMaxAmount = 1;
                $35da740d59af89ba$var$depositOfferBtn.disabled = false;
            });
            div.appendChild(label);
            div.appendChild(img);
            div.appendChild(nameLabel);
            div.appendChild(radio);
            $35da740d59af89ba$var$takerTokensGrid.appendChild(div);
        });
        setTimeout(()=>$35da740d59af89ba$var$closeModal(), 500);
    } catch (err) {
        console.error(err);
        $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
        $35da740d59af89ba$var$modalStatusText.textContent = 'Failed to fetch or display your tokens: ' + err.message;
        setTimeout(()=>$35da740d59af89ba$var$closeModal(), 2500);
    }
});
$35da740d59af89ba$var$sendOfferBtn.addEventListener('click', async ()=>{
    console.log('Send offer clicked, selectedTokenId:', $35da740d59af89ba$var$selectedTokenId);
    if ($35da740d59af89ba$var$selectedTokenId == null) {
        alert('Select a token first');
        return;
    }
    if (!$35da740d59af89ba$var$walletManager || !$35da740d59af89ba$var$connectedAddress) {
        alert('Connect wallet first');
        return;
    }
    const contractAddr = $35da740d59af89ba$var$makerContractInput.value.trim();
    const takerAddress = $35da740d59af89ba$var$artistAddressInput.value.trim();
    if (!takerAddress) {
        alert('Taker address is required');
        return;
    }
    const tokenId = $35da740d59af89ba$var$selectedTokenId;
    const qty = parseInt($35da740d59af89ba$var$quantitySelect.value);
    const escrowAddress = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[$35da740d59af89ba$var$selectedNetwork].contract;
    $35da740d59af89ba$var$lastEscrowSubmission = $35da740d59af89ba$var$sendOfferBtn.onclick;
    try {
        const isOperator = await (0, $3e5b4aee17d381c1$export$6da744084d84acdb)($35da740d59af89ba$var$walletManager, $35da740d59af89ba$var$connectedAddress, escrowAddress, tokenId, contractAddr);
        const fa2Contract = await $35da740d59af89ba$var$walletManager.tezos.wallet.at(contractAddr);
        const escrowContract = await $35da740d59af89ba$var$walletManager.tezos.wallet.at(escrowAddress);
        const escrowCall = escrowContract.methods.init_escrow(takerAddress, qty, contractAddr, tokenId);
        if (!isOperator) {
            const updateOperatorsParam = {
                add_operator: {
                    owner: $35da740d59af89ba$var$connectedAddress,
                    operator: escrowAddress,
                    token_id: tokenId
                }
            };
            const batch = $35da740d59af89ba$var$walletManager.tezos.wallet.batch().withContractCall(fa2Contract.methods.update_operators([
                updateOperatorsParam
            ])).withContractCall(escrowCall);
            $35da740d59af89ba$var$openModal('Sending transaction with operator update...');
            const op = await batch.send();
            await op.confirmation();
        } else {
            $35da740d59af89ba$var$openModal('Sending transaction...');
            const op = await escrowCall.send();
            await op.confirmation();
        }
        $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
        $35da740d59af89ba$var$modalStatusText.textContent = 'Offer sent successfully!';
        $35da740d59af89ba$var$modalCloseBtn.style.display = 'inline-block';
        $35da740d59af89ba$var$resetMakerForm();
    } catch (err) {
        console.error(err);
        if (err.message && err.message.includes('update_operators')) {
            $35da740d59af89ba$var$operatorModalError.textContent = 'Operator approval failed: ' + err.message;
            $35da740d59af89ba$var$operatorModalError.style.display = 'block';
            $35da740d59af89ba$var$operatorCheckModal.style.display = 'flex';
            $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
        } else {
            $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
            $35da740d59af89ba$var$modalStatusText.textContent = 'Failed to send offer: ' + err.message;
            $35da740d59af89ba$var$modalCloseBtn.style.display = 'inline-block';
        }
    }
});
if ($35da740d59af89ba$var$depositOfferBtn) $35da740d59af89ba$var$depositOfferBtn.addEventListener('click', async ()=>{
    if (!$35da740d59af89ba$var$selectedTakerTokenId == null) {
        alert('Select a token first');
        return;
    }
    if (!$35da740d59af89ba$var$selectedEscrowId == null) {
        alert('No escrow selected');
        return;
    }
    if (!$35da740d59af89ba$var$walletManager || !$35da740d59af89ba$var$connectedAddress) {
        alert('Connect wallet first');
        return;
    }
    const contractAddr = $35da740d59af89ba$var$takerContractInput.value.trim();
    const tokenId = $35da740d59af89ba$var$selectedTakerTokenId;
    const qty = 1;
    const escrowAddress = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[$35da740d59af89ba$var$selectedNetwork].contract;
    $35da740d59af89ba$var$lastEscrowSubmission = $35da740d59af89ba$var$depositOfferBtn.onclick;
    try {
        const isOperator = await (0, $3e5b4aee17d381c1$export$6da744084d84acdb)($35da740d59af89ba$var$walletManager, $35da740d59af89ba$var$walletManager.address, escrowAddress, tokenId, contractAddr);
        const fa2Contract = await $35da740d59af89ba$var$walletManager.tezos.wallet.at(contractAddr);
        const escrowContract = await $35da740d59af89ba$var$walletManager.tezos.wallet.at(escrowAddress);
        const depositCall = escrowContract.methods.taker_deposit($35da740d59af89ba$var$selectedEscrowId, qty, contractAddr, tokenId);
        if (!isOperator) {
            const updateOperatorsParam = {
                add_operator: {
                    owner: $35da740d59af89ba$var$walletManager.address,
                    operator: escrowAddress,
                    token_id: tokenId
                }
            };
            const batch = $35da740d59af89ba$var$walletManager.tezos.wallet.batch().withContractCall(fa2Contract.methods.update_operators([
                updateOperatorsParam
            ])).withContractCall(depositCall);
            $35da740d59af89ba$var$openModal('Depositing token with operator update...');
            const op = await batch.send();
            await op.confirmation();
        } else {
            $35da740d59af89ba$var$openModal('Depositing token...');
            const op = await depositCall.send();
            await op.confirmation();
        }
        $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
        $35da740d59af89ba$var$modalStatusText.textContent = 'Token deposited successfully!';
        $35da740d59af89ba$var$modalCloseBtn.style.display = 'inline-block';
        $35da740d59af89ba$var$takerSection.style.display = 'none';
        $35da740d59af89ba$var$resetTakerForm();
    } catch (err) {
        console.error(err);
        $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
        $35da740d59af89ba$var$modalStatusText.textContent = 'Failed to deposit: ' + err.message;
        $35da740d59af89ba$var$modalCloseBtn.style.display = 'inline-block';
    }
});
$35da740d59af89ba$var$clearMakerBtn.addEventListener('click', $35da740d59af89ba$var$resetMakerForm);
function $35da740d59af89ba$var$resetMakerForm() {
    $35da740d59af89ba$var$makerContractInput.value = '';
    $35da740d59af89ba$var$artistAddressInput.value = '';
    $35da740d59af89ba$var$quantitySelect.disabled = true;
    $35da740d59af89ba$var$quantitySelect.innerHTML = '<option>1</option>';
    $35da740d59af89ba$var$sendOfferBtn.disabled = true;
    $35da740d59af89ba$var$makerTokensGrid.innerHTML = '';
    $35da740d59af89ba$var$selectedTokenId = null;
    $35da740d59af89ba$var$selectedTokenMaxAmount = 1;
    $35da740d59af89ba$var$takerSection.style.display = 'none';
    $35da740d59af89ba$var$resetTakerForm();
}
function $35da740d59af89ba$var$resetTakerForm() {
    $35da740d59af89ba$var$takerContractInput.value = '';
    $35da740d59af89ba$var$takerTokensGrid.innerHTML = '';
    $35da740d59af89ba$var$depositOfferBtn.disabled = true;
    $35da740d59af89ba$var$selectedTakerTokenId = null;
    $35da740d59af89ba$var$selectedTakerTokenMaxAmount = 1;
}
$35da740d59af89ba$var$findOffersBtn.addEventListener('click', async ()=>{
    if (!$35da740d59af89ba$var$walletManager || !$35da740d59af89ba$var$connectedAddress) {
        alert('Connect wallet first');
        return;
    }
    $35da740d59af89ba$var$openModal('Fetching open offers...');
    try {
        const escrowContractAddress = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[$35da740d59af89ba$var$selectedNetwork].contract;
        const allEscrows = await (0, $3e5b4aee17d381c1$export$843a5d7f6540d3ce)($35da740d59af89ba$var$walletManager, $35da740d59af89ba$var$connectedAddress, escrowContractAddress);
        const activeEscrows = allEscrows.filter((e)=>e.status !== 'CANCELLED' && e.status !== 'COMPLETED' && e.status !== 'SWAPPED');
        await $35da740d59af89ba$var$populateAllOffersGrid($35da740d59af89ba$var$allOffersGrid, activeEscrows);
        $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
        $35da740d59af89ba$var$modalStatusText.textContent = 'Open offers fetched';
        setTimeout(()=>{
            $35da740d59af89ba$var$closeModal();
        }, 10);
    } catch (err) {
        console.error(err);
        $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
        $35da740d59af89ba$var$modalStatusText.textContent = 'Failed to fetch offers: ' + err.message;
        $35da740d59af89ba$var$modalCloseBtn.style.display = 'inline-block';
    }
});
async function $35da740d59af89ba$var$populateAllOffersGrid(grid, offers) {
    grid.innerHTML = '';
    if (!offers.length) {
        grid.textContent = 'No offers to display';
        grid.style.display = 'block';
        return;
    }
    console.log('All offers:', offers);
    for (const offer of offers)try {
        console.log('Processing offer:', offer);
        const div = document.createElement('div');
        div.className = 'offer-item';
        div.style.position = 'relative';
        let statusText = '';
        let statusClass = '';
        let showSwap = false;
        let showApprove = false;
        let showCancel = true;
        if (offer.role === 'maker') {
            if (offer.status === 'WAITING_TAKER_DEPOSIT') {
                statusText = 'My Offer';
                statusClass = 'status-my-offer';
            } else if (offer.status === 'WAITING_MAKER_APPROVAL') {
                statusText = 'Finalize';
                statusClass = 'status-finalize';
                showSwap = true;
                showApprove = true;
            }
        } else if (offer.role === 'taker') {
            if (offer.status === 'WAITING_TAKER_DEPOSIT') {
                statusText = 'Add Deposit';
                statusClass = 'status-add-deposit';
            } else if (offer.status === 'WAITING_MAKER_APPROVAL') {
                statusText = 'Waiting for Maker';
                statusClass = 'status-add-deposit';
                showSwap = true;
            }
        }
        const statusBadge = document.createElement('div');
        statusBadge.className = `offer-status ${statusClass}`;
        statusBadge.textContent = statusText;
        div.appendChild(statusBadge);
        const tokenContainer = document.createElement('div');
        tokenContainer.style.flex = '1';
        tokenContainer.style.display = 'flex';
        tokenContainer.style.flexDirection = 'column';
        tokenContainer.style.alignItems = 'center';
        tokenContainer.style.justifyContent = 'center';
        tokenContainer.style.position = 'relative';
        let showingMakerToken = true;
        async function renderToken(isMaker) {
            const existingEnlarge = div.querySelector('.control-enlarge');
            if (existingEnlarge) existingEnlarge.remove();
            tokenContainer.innerHTML = '<div style="display: flex; align-items: center; justify-content: center; height: 100%; font-size: 2em;">\u23F3</div>';
            let token = isMaker ? offer.makerToken : offer.takerToken;
            console.log('Rendering token:', {
                isMaker: isMaker,
                token: token
            });
            if (token && token.Some) token = token.Some;
            if (!token) {
                tokenContainer.innerHTML = '<label style="font-size: 0.7em; font-style: italic;">Waiting for token...</label>';
                return;
            }
            if (!token.token_address || token.token_id === undefined) {
                console.error('Invalid token structure:', token);
                tokenContainer.innerHTML = '<label style="font-size: 0.7em; color: red;">Invalid token data</label>';
                return;
            }
            const tokenId = token.token_id.toNumber ? token.token_id.toNumber() : token.token_id;
            const tokenMeta = await (0, $8f432d27490e361c$export$1c4c0ad9554c1ffb)(tokenId, $35da740d59af89ba$var$selectedNetwork, token.token_address);
            tokenContainer.innerHTML = '';
            const label = document.createElement('label');
            label.textContent = `${isMaker ? 'Maker' : 'Taker'}: ID ${tokenMeta.tokenId}`;
            label.style.fontSize = '0.7em';
            label.style.fontWeight = 'bold';
            label.style.marginBottom = '5px';
            const img = document.createElement('img');
            img.src = tokenMeta.img || 'placeholder.png';
            img.alt = tokenMeta.name || 'Token';
            img.style.maxWidth = '140px';
            img.style.display = 'block';
            img.style.borderRadius = '3px';
            const nameLabel = document.createElement('label');
            nameLabel.textContent = tokenMeta.name || 'Untitled';
            nameLabel.style.fontSize = '0.7em';
            nameLabel.style.marginTop = '5px';
            nameLabel.style.wordWrap = 'break-word';
            tokenContainer.appendChild(label);
            tokenContainer.appendChild(img);
            tokenContainer.appendChild(nameLabel);
            const enlargeBtn = document.createElement('a');
            enlargeBtn.href = `https://zeroart.app/tezos/Zeroview/art.html?contract=${token.token_address}&tokenId=${tokenId}`;
            enlargeBtn.target = '_blank';
            enlargeBtn.className = 'offer-controls control-enlarge';
            enlargeBtn.title = 'View in Zeroview';
            enlargeBtn.innerHTML = "\u2922";
            enlargeBtn.style.textDecoration = 'none';
            div.appendChild(enlargeBtn);
        }
        await renderToken(showingMakerToken);
        div.appendChild(tokenContainer);
        if (showSwap && offer.takerToken) {
            const swapBtn = document.createElement('div');
            swapBtn.className = 'offer-controls control-swap';
            swapBtn.title = 'Swap View';
            swapBtn.innerHTML = "\uD83D\uDD04";
            swapBtn.addEventListener('click', async (e)=>{
                e.stopPropagation();
                showingMakerToken = !showingMakerToken;
                await renderToken(showingMakerToken);
            });
            div.appendChild(swapBtn);
        }
        if (showCancel) {
            const cancelBtn = document.createElement('div');
            cancelBtn.className = 'offer-controls control-cancel';
            cancelBtn.title = 'Cancel Offer';
            cancelBtn.innerHTML = "\u2715";
            cancelBtn.addEventListener('click', async (e)=>{
                e.stopPropagation();
                if (!confirm('Cancel this escrow offer?')) return;
                $35da740d59af89ba$var$openModal('Cancelling escrow...');
                try {
                    const escrowAddress = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[$35da740d59af89ba$var$selectedNetwork].contract;
                    const escrowContract = await $35da740d59af89ba$var$walletManager.tezos.wallet.at(escrowAddress);
                    const op = await escrowContract.methods.cancel_escrow(offer.escrowId).send();
                    await op.confirmation();
                    $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
                    $35da740d59af89ba$var$modalStatusText.textContent = 'Escrow cancelled';
                    $35da740d59af89ba$var$modalCloseBtn.style.display = 'inline-block';
                    $35da740d59af89ba$var$findOffersBtn.click();
                } catch (err) {
                    $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
                    $35da740d59af89ba$var$modalStatusText.textContent = 'Failed to cancel escrow: ' + err.message;
                    $35da740d59af89ba$var$modalCloseBtn.style.display = 'inline-block';
                }
            });
            div.appendChild(cancelBtn);
        }
        if (showApprove) {
            const approveBtn = document.createElement('div');
            approveBtn.className = 'offer-controls control-approve';
            approveBtn.title = 'Approve and Finalize Swap';
            approveBtn.innerHTML = "\u2713";
            approveBtn.addEventListener('click', async (e)=>{
                e.stopPropagation();
                if (!confirm('Approve this swap? This will execute the token exchange.')) return;
                $35da740d59af89ba$var$openModal('Finalizing swap...');
                try {
                    const escrowAddress = (0, $83066fd84bd51987$export$2e2bcd8739ae039)[$35da740d59af89ba$var$selectedNetwork].contract;
                    const escrowContract = await $35da740d59af89ba$var$walletManager.tezos.wallet.at(escrowAddress);
                    const op = await escrowContract.methods.maker_approve(offer.escrowId).send();
                    await op.confirmation();
                    $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
                    $35da740d59af89ba$var$modalStatusText.textContent = 'Swap completed successfully!';
                    $35da740d59af89ba$var$modalCloseBtn.style.display = 'inline-block';
                    $35da740d59af89ba$var$findOffersBtn.click();
                } catch (err) {
                    $35da740d59af89ba$var$modalLoadingAnimation.style.display = 'none';
                    $35da740d59af89ba$var$modalStatusText.textContent = 'Failed to finalize: ' + err.message;
                    $35da740d59af89ba$var$modalCloseBtn.style.display = 'inline-block';
                }
            });
            div.appendChild(approveBtn);
        }
        if (statusText === 'Add Deposit') {
            div.style.cursor = 'pointer';
            div.addEventListener('click', ()=>{
                $35da740d59af89ba$var$selectedEscrowId = offer.escrowId;
                $35da740d59af89ba$var$selectedEscrowRole = 'taker';
                $35da740d59af89ba$var$selectedEscrowState = offer.status;
                window.isMakerMode = false;
                $35da740d59af89ba$var$takerSection.style.display = 'block';
                $35da740d59af89ba$var$depositOfferBtn.disabled = false;
                $35da740d59af89ba$var$resetTakerForm();
            });
        }
        grid.appendChild(div);
    } catch (err) {
        console.error('Failed to fetch metadata or render offer:', err);
    }
}
function $35da740d59af89ba$var$resetOffersGrids() {
    $35da740d59af89ba$var$allOffersGrid.innerHTML = '';
    $35da740d59af89ba$var$selectedEscrowId = null;
    $35da740d59af89ba$var$selectedEscrowRole = null;
    $35da740d59af89ba$var$selectedEscrowState = null;
    $35da740d59af89ba$var$takerSection.style.display = 'none';
    $35da740d59af89ba$var$resetTakerForm();
}


//# sourceMappingURL=zeroswap.4d348b2f.js.map
